'use strict';
import * as $i_$0040khmyznikov$002fpwa$002dinstall from "@khmyznikov/pwa-install";
import * as $i_$0040supabase$002fauth$002djs$002fdist$002fmodule$002flib$002ferrors from "@supabase/auth-js/dist/module/lib/errors";
import * as $j_app$002ecomponents$002e$002dApp$002dIcons$0024 from "./app.components.-App-Icons$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
function $f_Lalleycats_EmptyInstances1__monoidIsEmpty__Lcats_kernel_Monoid__Lalleycats_Empty($thiz, evidence$1) {
  var a = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_package$(), evidence$1).empty__O()));
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lalleycats_Empty$$anon$1(a);
}
export { $f_Lalleycats_EmptyInstances1__monoidIsEmpty__Lcats_kernel_Monoid__Lalleycats_Empty as $f_Lalleycats_EmptyInstances1__monoidIsEmpty__Lcats_kernel_Monoid__Lalleycats_Empty };
/** @constructor */
function $c_Lalleycats_compat_IterableEmptyInstance() {
}
export { $c_Lalleycats_compat_IterableEmptyInstance as $c_Lalleycats_compat_IterableEmptyInstance };
$c_Lalleycats_compat_IterableEmptyInstance.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lalleycats_compat_IterableEmptyInstance.prototype.constructor = $c_Lalleycats_compat_IterableEmptyInstance;
/** @constructor */
function $h_Lalleycats_compat_IterableEmptyInstance() {
}
export { $h_Lalleycats_compat_IterableEmptyInstance as $h_Lalleycats_compat_IterableEmptyInstance };
$h_Lalleycats_compat_IterableEmptyInstance.prototype = $c_Lalleycats_compat_IterableEmptyInstance.prototype;
$c_Lalleycats_compat_IterableEmptyInstance.prototype.iterableIsEmpty__sc_Factory__Lalleycats_Empty = (function(factory) {
  var a = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => factory.newBuilder__scm_Builder().result__O()));
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lalleycats_Empty$$anon$1(a);
});
function $f_Lcats_ParallelArityFunctions__parMap2__O__O__F2__Lcats_NonEmptyParallel__O($thiz, m0, m1, f, p) {
  return p.monad__Lcats_Monad().map__O__F1__O($m_Lcats_Parallel$().parProduct__O__O__Lcats_NonEmptyParallel__O(m0, m1, p), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 !== null)) {
      var a0 = x$1._1__O();
      var a1 = x$1._2__O();
      return f.apply__O__O__O(a0, a1);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  })));
}
export { $f_Lcats_ParallelArityFunctions__parMap2__O__O__F2__Lcats_NonEmptyParallel__O as $f_Lcats_ParallelArityFunctions__parMap2__O__O__F2__Lcats_NonEmptyParallel__O };
function $f_Lcats_SemigroupalArityFunctions__map2__O__O__F2__Lcats_Semigroupal__Lcats_Functor__O($thiz, f0, f1, f, semigroupal, functor) {
  return functor.map__O__F1__O(semigroupal.product__O__O__O(f0, f1), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 !== null)) {
      var a0 = x$1._1__O();
      var a1 = x$1._2__O();
      return f.apply__O__O__O(a0, a1);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  })));
}
export { $f_Lcats_SemigroupalArityFunctions__map2__O__O__F2__Lcats_Semigroupal__Lcats_Functor__O as $f_Lcats_SemigroupalArityFunctions__map2__O__O__F2__Lcats_Semigroupal__Lcats_Functor__O };
/** @constructor */
function $c_Lcats_data_AndThenInstances1() {
}
export { $c_Lcats_data_AndThenInstances1 as $c_Lcats_data_AndThenInstances1 };
$c_Lcats_data_AndThenInstances1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_data_AndThenInstances1.prototype.constructor = $c_Lcats_data_AndThenInstances1;
/** @constructor */
function $h_Lcats_data_AndThenInstances1() {
}
export { $h_Lcats_data_AndThenInstances1 as $h_Lcats_data_AndThenInstances1 };
$h_Lcats_data_AndThenInstances1.prototype = $c_Lcats_data_AndThenInstances1.prototype;
function $f_Lcats_data_CommonStateTConstructors__pure__O__Lcats_Applicative__Lcats_data_IndexedStateT($thiz, a, F) {
  return $m_Lcats_data_IndexedStateT$().apply__F1__Lcats_Applicative__Lcats_data_IndexedStateT(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s) => F.pure__O__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), s, a)))), F);
}
export { $f_Lcats_data_CommonStateTConstructors__pure__O__Lcats_Applicative__Lcats_data_IndexedStateT as $f_Lcats_data_CommonStateTConstructors__pure__O__Lcats_Applicative__Lcats_data_IndexedStateT };
/** @constructor */
function $c_Lcats_data_EitherT$RightPartiallyApplied$() {
}
export { $c_Lcats_data_EitherT$RightPartiallyApplied$ as $c_Lcats_data_EitherT$RightPartiallyApplied$ };
$c_Lcats_data_EitherT$RightPartiallyApplied$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_data_EitherT$RightPartiallyApplied$.prototype.constructor = $c_Lcats_data_EitherT$RightPartiallyApplied$;
/** @constructor */
function $h_Lcats_data_EitherT$RightPartiallyApplied$() {
}
export { $h_Lcats_data_EitherT$RightPartiallyApplied$ as $h_Lcats_data_EitherT$RightPartiallyApplied$ };
$h_Lcats_data_EitherT$RightPartiallyApplied$.prototype = $c_Lcats_data_EitherT$RightPartiallyApplied$.prototype;
$c_Lcats_data_EitherT$RightPartiallyApplied$.prototype.apply$extension__Z__O__Lcats_Functor__Lcats_data_EitherT = (function(this$, fb, F) {
  var value = F.map__O__F1__O(fb, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$35) => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(_$35))));
  return new $c_Lcats_data_EitherT(value);
});
var $d_Lcats_data_EitherT$RightPartiallyApplied$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_data_EitherT$RightPartiallyApplied$, "cats.data.EitherT$RightPartiallyApplied$", ({
  Lcats_data_EitherT$RightPartiallyApplied$: 1
}));
export { $d_Lcats_data_EitherT$RightPartiallyApplied$ as $d_Lcats_data_EitherT$RightPartiallyApplied$ };
var $n_Lcats_data_EitherT$RightPartiallyApplied$;
function $m_Lcats_data_EitherT$RightPartiallyApplied$() {
  if ((!$n_Lcats_data_EitherT$RightPartiallyApplied$)) {
    $n_Lcats_data_EitherT$RightPartiallyApplied$ = new $c_Lcats_data_EitherT$RightPartiallyApplied$();
  }
  return $n_Lcats_data_EitherT$RightPartiallyApplied$;
}
export { $m_Lcats_data_EitherT$RightPartiallyApplied$ as $m_Lcats_data_EitherT$RightPartiallyApplied$ };
/** @constructor */
function $c_Lcats_data_EitherTInstances3() {
}
export { $c_Lcats_data_EitherTInstances3 as $c_Lcats_data_EitherTInstances3 };
$c_Lcats_data_EitherTInstances3.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_data_EitherTInstances3.prototype.constructor = $c_Lcats_data_EitherTInstances3;
/** @constructor */
function $h_Lcats_data_EitherTInstances3() {
}
export { $h_Lcats_data_EitherTInstances3 as $h_Lcats_data_EitherTInstances3 };
$h_Lcats_data_EitherTInstances3.prototype = $c_Lcats_data_EitherTInstances3.prototype;
/** @constructor */
function $c_Lcats_data_IndexedStateTInstances4() {
}
export { $c_Lcats_data_IndexedStateTInstances4 as $c_Lcats_data_IndexedStateTInstances4 };
$c_Lcats_data_IndexedStateTInstances4.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_data_IndexedStateTInstances4.prototype.constructor = $c_Lcats_data_IndexedStateTInstances4;
/** @constructor */
function $h_Lcats_data_IndexedStateTInstances4() {
}
export { $h_Lcats_data_IndexedStateTInstances4 as $h_Lcats_data_IndexedStateTInstances4 };
$h_Lcats_data_IndexedStateTInstances4.prototype = $c_Lcats_data_IndexedStateTInstances4.prototype;
/** @constructor */
function $c_Lcats_data_KleisliInstances9() {
}
export { $c_Lcats_data_KleisliInstances9 as $c_Lcats_data_KleisliInstances9 };
$c_Lcats_data_KleisliInstances9.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_data_KleisliInstances9.prototype.constructor = $c_Lcats_data_KleisliInstances9;
/** @constructor */
function $h_Lcats_data_KleisliInstances9() {
}
export { $h_Lcats_data_KleisliInstances9 as $h_Lcats_data_KleisliInstances9 };
$h_Lcats_data_KleisliInstances9.prototype = $c_Lcats_data_KleisliInstances9.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptyChainInstances3() {
}
export { $c_Lcats_data_NonEmptyChainInstances3 as $c_Lcats_data_NonEmptyChainInstances3 };
$c_Lcats_data_NonEmptyChainInstances3.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_data_NonEmptyChainInstances3.prototype.constructor = $c_Lcats_data_NonEmptyChainInstances3;
/** @constructor */
function $h_Lcats_data_NonEmptyChainInstances3() {
}
export { $h_Lcats_data_NonEmptyChainInstances3 as $h_Lcats_data_NonEmptyChainInstances3 };
$h_Lcats_data_NonEmptyChainInstances3.prototype = $c_Lcats_data_NonEmptyChainInstances3.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptyChainOps$() {
}
export { $c_Lcats_data_NonEmptyChainOps$ as $c_Lcats_data_NonEmptyChainOps$ };
$c_Lcats_data_NonEmptyChainOps$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_data_NonEmptyChainOps$.prototype.constructor = $c_Lcats_data_NonEmptyChainOps$;
/** @constructor */
function $h_Lcats_data_NonEmptyChainOps$() {
}
export { $h_Lcats_data_NonEmptyChainOps$ as $h_Lcats_data_NonEmptyChainOps$ };
$h_Lcats_data_NonEmptyChainOps$.prototype = $c_Lcats_data_NonEmptyChainOps$.prototype;
$c_Lcats_data_NonEmptyChainOps$.prototype.length$extension__O__J = (function(this$) {
  $m_Lcats_data_NonEmptyChainImpl$();
  return this$.length__J();
});
var $d_Lcats_data_NonEmptyChainOps$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_data_NonEmptyChainOps$, "cats.data.NonEmptyChainOps$", ({
  Lcats_data_NonEmptyChainOps$: 1
}));
export { $d_Lcats_data_NonEmptyChainOps$ as $d_Lcats_data_NonEmptyChainOps$ };
var $n_Lcats_data_NonEmptyChainOps$;
function $m_Lcats_data_NonEmptyChainOps$() {
  if ((!$n_Lcats_data_NonEmptyChainOps$)) {
    $n_Lcats_data_NonEmptyChainOps$ = new $c_Lcats_data_NonEmptyChainOps$();
  }
  return $n_Lcats_data_NonEmptyChainOps$;
}
export { $m_Lcats_data_NonEmptyChainOps$ as $m_Lcats_data_NonEmptyChainOps$ };
/** @constructor */
function $c_Lcats_data_NonEmptyMapInstances0() {
}
export { $c_Lcats_data_NonEmptyMapInstances0 as $c_Lcats_data_NonEmptyMapInstances0 };
$c_Lcats_data_NonEmptyMapInstances0.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_data_NonEmptyMapInstances0.prototype.constructor = $c_Lcats_data_NonEmptyMapInstances0;
/** @constructor */
function $h_Lcats_data_NonEmptyMapInstances0() {
}
export { $h_Lcats_data_NonEmptyMapInstances0 as $h_Lcats_data_NonEmptyMapInstances0 };
$h_Lcats_data_NonEmptyMapInstances0.prototype = $c_Lcats_data_NonEmptyMapInstances0.prototype;
function $p_Lcats_data_NonEmptyMapOps__loop$1__Lcats_Apply__F1__T2__sci_SortedMap__Lcats_Eval($thiz, G$1, f$8, h, t) {
  if (t.isEmpty__Z()) {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Eval$();
    var a = G$1.map__O__F1__O(f$8.apply__O__O(h._2__O()), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((b) => {
      var $x_1 = $m_Lcats_data_package$().Lcats_data_package$__f_NonEmptyMap;
      var self = h._1__O();
      return $x_1.apply__T2__sci_SortedMap__Lcats_kernel_Order__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self, b), $m_sci_SortedMap$().empty__s_math_Ordering__O($thiz.Lcats_data_NonEmptyMapOps__f_ordering), $thiz.Lcats_data_NonEmptyMapOps__f_order);
    })));
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Now(a);
  } else {
    var $x_2 = f$8.apply__O__O(h._2__O());
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Eval$();
    var a$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $p_Lcats_data_NonEmptyMapOps__loop$1__Lcats_Apply__F1__T2__sci_SortedMap__Lcats_Eval($thiz, G$1, f$8, t.head__T2(), t.tail__sci_TreeMap())));
    return G$1.map2Eval__O__Lcats_Eval__F2__Lcats_Eval($x_2, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Eval$$anon$5(a$1), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((b$2, acc) => {
      var $x_4 = $m_Lcats_data_package$().Lcats_data_package$__f_NonEmptyMap;
      var self$1 = h._1__O();
      var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$1, b$2);
      var this$10 = new $c_Lcats_data_NonEmptyMapOps(acc);
      var m = this$10.Lcats_data_NonEmptyMapOps__f_value;
      return $x_4.apply__T2__sci_SortedMap__Lcats_kernel_Order__O($x_3, m, $thiz.Lcats_data_NonEmptyMapOps__f_order);
    })));
  }
}
export { $p_Lcats_data_NonEmptyMapOps__loop$1__Lcats_Apply__F1__T2__sci_SortedMap__Lcats_Eval as $p_Lcats_data_NonEmptyMapOps__loop$1__Lcats_Apply__F1__T2__sci_SortedMap__Lcats_Eval };
/** @constructor */
function $c_Lcats_data_NonEmptyMapOps(value) {
  this.Lcats_data_NonEmptyMapOps__f_value = null;
  this.Lcats_data_NonEmptyMapOps__f_ordering = null;
  this.Lcats_data_NonEmptyMapOps__f_order = null;
  this.Lcats_data_NonEmptyMapOps__f_value = value;
  var m = this.Lcats_data_NonEmptyMapOps__f_value;
  this.Lcats_data_NonEmptyMapOps__f_ordering = m.sci_TreeMap__f_ordering;
  var ev = this.Lcats_data_NonEmptyMapOps__f_ordering;
  this.Lcats_data_NonEmptyMapOps__f_order = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_kernel_Order$$anon$9(ev);
}
export { $c_Lcats_data_NonEmptyMapOps as $c_Lcats_data_NonEmptyMapOps };
$c_Lcats_data_NonEmptyMapOps.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_data_NonEmptyMapOps.prototype.constructor = $c_Lcats_data_NonEmptyMapOps;
/** @constructor */
function $h_Lcats_data_NonEmptyMapOps() {
}
export { $h_Lcats_data_NonEmptyMapOps as $h_Lcats_data_NonEmptyMapOps };
$h_Lcats_data_NonEmptyMapOps.prototype = $c_Lcats_data_NonEmptyMapOps.prototype;
$c_Lcats_data_NonEmptyMapOps.prototype.concat__O__O = (function(as) {
  var m = this.Lcats_data_NonEmptyMapOps__f_value;
  var this$3 = new $c_Lcats_data_NonEmptyMapOps(as);
  var m$1 = this$3.Lcats_data_NonEmptyMapOps__f_value;
  var m$2 = m.concat__sc_IterableOnce__sci_TreeMap(m$1);
  return m$2;
});
$c_Lcats_data_NonEmptyMapOps.prototype.map__F1__O = (function(f) {
  var instance = new $c_Lcats_instances_SortedMapInstances$$anon$2();
  var m = this.Lcats_data_NonEmptyMapOps__f_value;
  var m$1 = instance.map__sci_SortedMap__F1__sci_SortedMap(m, f);
  return m$1;
});
$c_Lcats_data_NonEmptyMapOps.prototype.exists__F1__Z = (function(f) {
  var m = this.Lcats_data_NonEmptyMapOps__f_value;
  var res = false;
  var it = m.iterator__sc_Iterator();
  while (((!res) && it.hasNext__Z())) {
    var x0 = it.next__O();
    matchResult3: {
      if ((x0 !== null)) {
        var a = x0._2__O();
        res = (!(!f.apply__O__O(a)));
        break matchResult3;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x0);
    }
  }
  return res;
});
$c_Lcats_data_NonEmptyMapOps.prototype.foldLeft__O__F2__O = (function(b, f) {
  var m = this.Lcats_data_NonEmptyMapOps__f_value;
  var f$1 = ((b$2, t) => f.apply__O__O__O(b$2, t._2__O()));
  if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$is_sc_IndexedSeq(m)) {
    var at = 0;
    var end = m.length__I();
    var acc = b;
    while (true) {
      if ((at === end)) {
        return acc;
      } else {
        var temp$at = ((1 + at) | 0);
        var x0 = acc;
        var x1 = m.apply__I__O(at);
        var temp$acc = f$1(x0, x1);
        at = temp$at;
        acc = temp$acc;
      }
    }
  } else {
    var result = b;
    var it = m.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var x0$1 = result;
      var x1$1 = it.next__O();
      result = f$1(x0$1, x1$1);
    }
    return result;
  }
});
$c_Lcats_data_NonEmptyMapOps.prototype.foldRight__Lcats_Eval__F2__Lcats_Eval = (function(lb, f) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_UnorderedFoldable$();
  var m = this.Lcats_data_NonEmptyMapOps__f_value;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Foldable$().iterateRight__sc_Iterable__Lcats_Eval__F2__Lcats_Eval(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapOps$$anon$1(m), lb, f);
});
$c_Lcats_data_NonEmptyMapOps.prototype.nonEmptyTraverse__F1__Lcats_Apply__O = (function(f, G) {
  var m = this.Lcats_data_NonEmptyMapOps__f_value;
  var $x_1 = m.head__T2();
  var m$1 = this.Lcats_data_NonEmptyMapOps__f_value;
  return $p_Lcats_data_NonEmptyMapOps__loop$1__Lcats_Apply__F1__T2__sci_SortedMap__Lcats_Eval(this, G, f, $x_1, m$1.tail__sci_TreeMap()).value__O();
});
var $d_Lcats_data_NonEmptyMapOps = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_data_NonEmptyMapOps, "cats.data.NonEmptyMapOps", ({
  Lcats_data_NonEmptyMapOps: 1
}));
export { $d_Lcats_data_NonEmptyMapOps as $d_Lcats_data_NonEmptyMapOps };
/** @constructor */
function $c_Lcats_data_NonEmptySetInstances1() {
}
export { $c_Lcats_data_NonEmptySetInstances1 as $c_Lcats_data_NonEmptySetInstances1 };
$c_Lcats_data_NonEmptySetInstances1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_data_NonEmptySetInstances1.prototype.constructor = $c_Lcats_data_NonEmptySetInstances1;
/** @constructor */
function $h_Lcats_data_NonEmptySetInstances1() {
}
export { $h_Lcats_data_NonEmptySetInstances1 as $h_Lcats_data_NonEmptySetInstances1 };
$h_Lcats_data_NonEmptySetInstances1.prototype = $c_Lcats_data_NonEmptySetInstances1.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptySetOps(value) {
  this.Lcats_data_NonEmptySetOps__f_value = null;
  this.Lcats_data_NonEmptySetOps__f_ordering = null;
  this.Lcats_data_NonEmptySetOps__f_value = value;
  var s = this.Lcats_data_NonEmptySetOps__f_value;
  this.Lcats_data_NonEmptySetOps__f_ordering = s.ordering__s_math_Ordering();
}
export { $c_Lcats_data_NonEmptySetOps as $c_Lcats_data_NonEmptySetOps };
$c_Lcats_data_NonEmptySetOps.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_data_NonEmptySetOps.prototype.constructor = $c_Lcats_data_NonEmptySetOps;
/** @constructor */
function $h_Lcats_data_NonEmptySetOps() {
}
export { $h_Lcats_data_NonEmptySetOps as $h_Lcats_data_NonEmptySetOps };
$h_Lcats_data_NonEmptySetOps.prototype = $c_Lcats_data_NonEmptySetOps.prototype;
var $d_Lcats_data_NonEmptySetOps = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_data_NonEmptySetOps, "cats.data.NonEmptySetOps", ({
  Lcats_data_NonEmptySetOps: 1
}));
export { $d_Lcats_data_NonEmptySetOps as $d_Lcats_data_NonEmptySetOps };
/** @constructor */
function $c_Lcats_data_OptionTInstances3() {
}
export { $c_Lcats_data_OptionTInstances3 as $c_Lcats_data_OptionTInstances3 };
$c_Lcats_data_OptionTInstances3.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_data_OptionTInstances3.prototype.constructor = $c_Lcats_data_OptionTInstances3;
/** @constructor */
function $h_Lcats_data_OptionTInstances3() {
}
export { $h_Lcats_data_OptionTInstances3 as $h_Lcats_data_OptionTInstances3 };
$h_Lcats_data_OptionTInstances3.prototype = $c_Lcats_data_OptionTInstances3.prototype;
/** @constructor */
function $c_Lcats_data_ScalaVersionSpecificPackage() {
}
export { $c_Lcats_data_ScalaVersionSpecificPackage as $c_Lcats_data_ScalaVersionSpecificPackage };
$c_Lcats_data_ScalaVersionSpecificPackage.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_data_ScalaVersionSpecificPackage.prototype.constructor = $c_Lcats_data_ScalaVersionSpecificPackage;
/** @constructor */
function $h_Lcats_data_ScalaVersionSpecificPackage() {
}
export { $h_Lcats_data_ScalaVersionSpecificPackage as $h_Lcats_data_ScalaVersionSpecificPackage };
$h_Lcats_data_ScalaVersionSpecificPackage.prototype = $c_Lcats_data_ScalaVersionSpecificPackage.prototype;
function $p_Lcats_derived_DerivedOrder$package$DerivedOrder$__given_CoproductInstances_Order_A$lzyINIT1$1__sr_LazyRef__F0__Lshapeless3_deriving_internals_ErasedCoproductInstances($thiz, given_CoproductInstances_Order_A$lzy1$1, inst$1) {
  if ((given_CoproductInstances_Order_A$lzy1$1 === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  if (given_CoproductInstances_Order_A$lzy1$1.sr_LazyRef__f__initialized) {
    var $x_1 = given_CoproductInstances_Order_A$lzy1$1.sr_LazyRef__f__value;
  } else {
    var inst = inst$1.apply__O();
    var $x_1 = given_CoproductInstances_Order_A$lzy1$1.initialize__O__O(inst);
  }
  return $x_1;
}
export { $p_Lcats_derived_DerivedOrder$package$DerivedOrder$__given_CoproductInstances_Order_A$lzyINIT1$1__sr_LazyRef__F0__Lshapeless3_deriving_internals_ErasedCoproductInstances as $p_Lcats_derived_DerivedOrder$package$DerivedOrder$__given_CoproductInstances_Order_A$lzyINIT1$1__sr_LazyRef__F0__Lshapeless3_deriving_internals_ErasedCoproductInstances };
/** @constructor */
function $c_Lcats_derived_DerivedOrder$package$DerivedOrder$() {
}
export { $c_Lcats_derived_DerivedOrder$package$DerivedOrder$ as $c_Lcats_derived_DerivedOrder$package$DerivedOrder$ };
$c_Lcats_derived_DerivedOrder$package$DerivedOrder$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_derived_DerivedOrder$package$DerivedOrder$.prototype.constructor = $c_Lcats_derived_DerivedOrder$package$DerivedOrder$;
/** @constructor */
function $h_Lcats_derived_DerivedOrder$package$DerivedOrder$() {
}
export { $h_Lcats_derived_DerivedOrder$package$DerivedOrder$ as $h_Lcats_derived_DerivedOrder$package$DerivedOrder$ };
$h_Lcats_derived_DerivedOrder$package$DerivedOrder$.prototype = $c_Lcats_derived_DerivedOrder$package$DerivedOrder$.prototype;
$c_Lcats_derived_DerivedOrder$package$DerivedOrder$.prototype.coproduct__F0__Lcats_kernel_Order = (function(inst) {
  var given_CoproductInstances_Order_A$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_LazyRef();
  var x = new $c_Lcats_derived_DerivedOrder$package$DerivedOrder$$anon$1(given_CoproductInstances_Order_A$lzy1, inst);
  return x;
});
$c_Lcats_derived_DerivedOrder$package$DerivedOrder$.prototype.cats$derived$DerivedOrder$package$DerivedOrder$$$_$given_CoproductInstances_Order_A$1__sr_LazyRef__F0__Lshapeless3_deriving_internals_ErasedCoproductInstances = (function(given_CoproductInstances_Order_A$lzy1$2, inst$2) {
  return (given_CoproductInstances_Order_A$lzy1$2.sr_LazyRef__f__initialized ? given_CoproductInstances_Order_A$lzy1$2.sr_LazyRef__f__value : $p_Lcats_derived_DerivedOrder$package$DerivedOrder$__given_CoproductInstances_Order_A$lzyINIT1$1__sr_LazyRef__F0__Lshapeless3_deriving_internals_ErasedCoproductInstances(this, given_CoproductInstances_Order_A$lzy1$2, inst$2));
});
var $d_Lcats_derived_DerivedOrder$package$DerivedOrder$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_derived_DerivedOrder$package$DerivedOrder$, "cats.derived.DerivedOrder$package$DerivedOrder$", ({
  Lcats_derived_DerivedOrder$package$DerivedOrder$: 1
}));
export { $d_Lcats_derived_DerivedOrder$package$DerivedOrder$ as $d_Lcats_derived_DerivedOrder$package$DerivedOrder$ };
var $n_Lcats_derived_DerivedOrder$package$DerivedOrder$;
function $m_Lcats_derived_DerivedOrder$package$DerivedOrder$() {
  if ((!$n_Lcats_derived_DerivedOrder$package$DerivedOrder$)) {
    $n_Lcats_derived_DerivedOrder$package$DerivedOrder$ = new $c_Lcats_derived_DerivedOrder$package$DerivedOrder$();
  }
  return $n_Lcats_derived_DerivedOrder$package$DerivedOrder$;
}
export { $m_Lcats_derived_DerivedOrder$package$DerivedOrder$ as $m_Lcats_derived_DerivedOrder$package$DerivedOrder$ };
/** @constructor */
function $c_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$() {
}
export { $c_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$ as $c_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$ };
$c_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$.prototype.constructor = $c_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$;
/** @constructor */
function $h_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$() {
}
export { $h_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$ as $h_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$ };
$h_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$.prototype = $c_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$.prototype;
$c_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$.prototype.product__Lshapeless3_deriving_internals_ErasedProductInstances__Lcats_kernel_Order = (function(evidence$1) {
  var x = new $c_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$$anon$4(evidence$1);
  return x;
});
var $d_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$, "cats.derived.DerivedOrder$package$DerivedOrder$Strict$", ({
  Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$: 1
}));
export { $d_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$ as $d_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$ };
var $n_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$;
function $m_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$() {
  if ((!$n_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$)) {
    $n_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$ = new $c_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$();
  }
  return $n_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$;
}
export { $m_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$ as $m_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$ };
function $p_Lcats_derived_DerivedShow$package$DerivedShow$__given_ProductInstances_Show_A$lzyINIT1$1__sr_LazyRef__Lshapeless3_deriving_internals_ErasedProductInstances__Lshapeless3_deriving_internals_ErasedProductInstances($thiz, given_ProductInstances_Show_A$lzy1$1, inst$1) {
  if ((given_ProductInstances_Show_A$lzy1$1 === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  return (given_ProductInstances_Show_A$lzy1$1.sr_LazyRef__f__initialized ? given_ProductInstances_Show_A$lzy1$1.sr_LazyRef__f__value : given_ProductInstances_Show_A$lzy1$1.initialize__O__O(inst$1));
}
export { $p_Lcats_derived_DerivedShow$package$DerivedShow$__given_ProductInstances_Show_A$lzyINIT1$1__sr_LazyRef__Lshapeless3_deriving_internals_ErasedProductInstances__Lshapeless3_deriving_internals_ErasedProductInstances as $p_Lcats_derived_DerivedShow$package$DerivedShow$__given_ProductInstances_Show_A$lzyINIT1$1__sr_LazyRef__Lshapeless3_deriving_internals_ErasedProductInstances__Lshapeless3_deriving_internals_ErasedProductInstances };
function $p_Lcats_derived_DerivedShow$package$DerivedShow$__given_ProductInstances_Show_A$1__sr_LazyRef__Lshapeless3_deriving_internals_ErasedProductInstances__Lshapeless3_deriving_internals_ErasedProductInstances($thiz, given_ProductInstances_Show_A$lzy1$2, inst$2) {
  return (given_ProductInstances_Show_A$lzy1$2.sr_LazyRef__f__initialized ? given_ProductInstances_Show_A$lzy1$2.sr_LazyRef__f__value : $p_Lcats_derived_DerivedShow$package$DerivedShow$__given_ProductInstances_Show_A$lzyINIT1$1__sr_LazyRef__Lshapeless3_deriving_internals_ErasedProductInstances__Lshapeless3_deriving_internals_ErasedProductInstances($thiz, given_ProductInstances_Show_A$lzy1$2, inst$2));
}
export { $p_Lcats_derived_DerivedShow$package$DerivedShow$__given_ProductInstances_Show_A$1__sr_LazyRef__Lshapeless3_deriving_internals_ErasedProductInstances__Lshapeless3_deriving_internals_ErasedProductInstances as $p_Lcats_derived_DerivedShow$package$DerivedShow$__given_ProductInstances_Show_A$1__sr_LazyRef__Lshapeless3_deriving_internals_ErasedProductInstances__Lshapeless3_deriving_internals_ErasedProductInstances };
/** @constructor */
function $c_Lcats_derived_DerivedShow$package$DerivedShow$() {
}
export { $c_Lcats_derived_DerivedShow$package$DerivedShow$ as $c_Lcats_derived_DerivedShow$package$DerivedShow$ };
$c_Lcats_derived_DerivedShow$package$DerivedShow$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_derived_DerivedShow$package$DerivedShow$.prototype.constructor = $c_Lcats_derived_DerivedShow$package$DerivedShow$;
/** @constructor */
function $h_Lcats_derived_DerivedShow$package$DerivedShow$() {
}
export { $h_Lcats_derived_DerivedShow$package$DerivedShow$ as $h_Lcats_derived_DerivedShow$package$DerivedShow$ };
$h_Lcats_derived_DerivedShow$package$DerivedShow$.prototype = $c_Lcats_derived_DerivedShow$package$DerivedShow$.prototype;
$c_Lcats_derived_DerivedShow$package$DerivedShow$.prototype.given_DerivedShow_A__Lshapeless3_deriving_internals_ErasedProductInstances__Lshapeless3_deriving_Labelling__Lcats_Show = (function(inst, labelling) {
  var given_ProductInstances_Show_A$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_LazyRef();
  var $x_1 = $m_Lcats_derived_DerivedShow$package$DerivedShow$Strict$();
  var given_ProductInstances_Show_A$lzy1$2$1 = given_ProductInstances_Show_A$lzy1;
  return $x_1.product__Lshapeless3_deriving_Labelling__F0__Lcats_Show(labelling, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((given_ProductInstances_Show_A$lzy1$2) => (() => $p_Lcats_derived_DerivedShow$package$DerivedShow$__given_ProductInstances_Show_A$1__sr_LazyRef__Lshapeless3_deriving_internals_ErasedProductInstances__Lshapeless3_deriving_internals_ErasedProductInstances(this, given_ProductInstances_Show_A$lzy1$2, inst)))(given_ProductInstances_Show_A$lzy1$2$1)));
});
var $d_Lcats_derived_DerivedShow$package$DerivedShow$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_derived_DerivedShow$package$DerivedShow$, "cats.derived.DerivedShow$package$DerivedShow$", ({
  Lcats_derived_DerivedShow$package$DerivedShow$: 1
}));
export { $d_Lcats_derived_DerivedShow$package$DerivedShow$ as $d_Lcats_derived_DerivedShow$package$DerivedShow$ };
var $n_Lcats_derived_DerivedShow$package$DerivedShow$;
function $m_Lcats_derived_DerivedShow$package$DerivedShow$() {
  if ((!$n_Lcats_derived_DerivedShow$package$DerivedShow$)) {
    $n_Lcats_derived_DerivedShow$package$DerivedShow$ = new $c_Lcats_derived_DerivedShow$package$DerivedShow$();
  }
  return $n_Lcats_derived_DerivedShow$package$DerivedShow$;
}
export { $m_Lcats_derived_DerivedShow$package$DerivedShow$ as $m_Lcats_derived_DerivedShow$package$DerivedShow$ };
function $p_Lcats_derived_DerivedShow$package$DerivedShow$Strict$__given_CoproductInstances_Show_A$lzyINIT1$1__sr_LazyRef__F0__Lshapeless3_deriving_internals_ErasedCoproductInstances($thiz, given_CoproductInstances_Show_A$lzy1$1, inst$3) {
  if ((given_CoproductInstances_Show_A$lzy1$1 === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  if (given_CoproductInstances_Show_A$lzy1$1.sr_LazyRef__f__initialized) {
    var $x_1 = given_CoproductInstances_Show_A$lzy1$1.sr_LazyRef__f__value;
  } else {
    var inst = inst$3.apply__O();
    var $x_1 = given_CoproductInstances_Show_A$lzy1$1.initialize__O__O(inst);
  }
  return $x_1;
}
export { $p_Lcats_derived_DerivedShow$package$DerivedShow$Strict$__given_CoproductInstances_Show_A$lzyINIT1$1__sr_LazyRef__F0__Lshapeless3_deriving_internals_ErasedCoproductInstances as $p_Lcats_derived_DerivedShow$package$DerivedShow$Strict$__given_CoproductInstances_Show_A$lzyINIT1$1__sr_LazyRef__F0__Lshapeless3_deriving_internals_ErasedCoproductInstances };
/** @constructor */
function $c_Lcats_derived_DerivedShow$package$DerivedShow$Strict$() {
}
export { $c_Lcats_derived_DerivedShow$package$DerivedShow$Strict$ as $c_Lcats_derived_DerivedShow$package$DerivedShow$Strict$ };
$c_Lcats_derived_DerivedShow$package$DerivedShow$Strict$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_derived_DerivedShow$package$DerivedShow$Strict$.prototype.constructor = $c_Lcats_derived_DerivedShow$package$DerivedShow$Strict$;
/** @constructor */
function $h_Lcats_derived_DerivedShow$package$DerivedShow$Strict$() {
}
export { $h_Lcats_derived_DerivedShow$package$DerivedShow$Strict$ as $h_Lcats_derived_DerivedShow$package$DerivedShow$Strict$ };
$h_Lcats_derived_DerivedShow$package$DerivedShow$Strict$.prototype = $c_Lcats_derived_DerivedShow$package$DerivedShow$Strict$.prototype;
$c_Lcats_derived_DerivedShow$package$DerivedShow$Strict$.prototype.product__Lshapeless3_deriving_Labelling__F0__Lcats_Show = (function(evidence$1, x$1) {
  var x = new $c_Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$3(x$1, evidence$1);
  return x;
});
$c_Lcats_derived_DerivedShow$package$DerivedShow$Strict$.prototype.coproduct__F0__Lcats_Show = (function(inst) {
  var given_CoproductInstances_Show_A$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_LazyRef();
  var x = new $c_Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$4(given_CoproductInstances_Show_A$lzy1, inst);
  return x;
});
$c_Lcats_derived_DerivedShow$package$DerivedShow$Strict$.prototype.cats$derived$DerivedShow$package$DerivedShow$Strict$$$_$given_CoproductInstances_Show_A$1__sr_LazyRef__F0__Lshapeless3_deriving_internals_ErasedCoproductInstances = (function(given_CoproductInstances_Show_A$lzy1$2, inst$4) {
  return (given_CoproductInstances_Show_A$lzy1$2.sr_LazyRef__f__initialized ? given_CoproductInstances_Show_A$lzy1$2.sr_LazyRef__f__value : $p_Lcats_derived_DerivedShow$package$DerivedShow$Strict$__given_CoproductInstances_Show_A$lzyINIT1$1__sr_LazyRef__F0__Lshapeless3_deriving_internals_ErasedCoproductInstances(this, given_CoproductInstances_Show_A$lzy1$2, inst$4));
});
var $d_Lcats_derived_DerivedShow$package$DerivedShow$Strict$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_derived_DerivedShow$package$DerivedShow$Strict$, "cats.derived.DerivedShow$package$DerivedShow$Strict$", ({
  Lcats_derived_DerivedShow$package$DerivedShow$Strict$: 1
}));
export { $d_Lcats_derived_DerivedShow$package$DerivedShow$Strict$ as $d_Lcats_derived_DerivedShow$package$DerivedShow$Strict$ };
var $n_Lcats_derived_DerivedShow$package$DerivedShow$Strict$;
function $m_Lcats_derived_DerivedShow$package$DerivedShow$Strict$() {
  if ((!$n_Lcats_derived_DerivedShow$package$DerivedShow$Strict$)) {
    $n_Lcats_derived_DerivedShow$package$DerivedShow$Strict$ = new $c_Lcats_derived_DerivedShow$package$DerivedShow$Strict$();
  }
  return $n_Lcats_derived_DerivedShow$package$DerivedShow$Strict$;
}
export { $m_Lcats_derived_DerivedShow$package$DerivedShow$Strict$ as $m_Lcats_derived_DerivedShow$package$DerivedShow$Strict$ };
/** @constructor */
function $c_Lcats_effect_ContState$() {
  this.Lcats_effect_ContState$__f_cats$effect$ContState$$$waitingSentinel = null;
  $n_Lcats_effect_ContState$ = this;
  this.Lcats_effect_ContState$__f_cats$effect$ContState$$$waitingSentinel = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(null);
}
export { $c_Lcats_effect_ContState$ as $c_Lcats_effect_ContState$ };
$c_Lcats_effect_ContState$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_ContState$.prototype.constructor = $c_Lcats_effect_ContState$;
/** @constructor */
function $h_Lcats_effect_ContState$() {
}
export { $h_Lcats_effect_ContState$ as $h_Lcats_effect_ContState$ };
$h_Lcats_effect_ContState$.prototype = $c_Lcats_effect_ContState$.prototype;
var $d_Lcats_effect_ContState$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_ContState$, "cats.effect.ContState$", ({
  Lcats_effect_ContState$: 1
}));
export { $d_Lcats_effect_ContState$ as $d_Lcats_effect_ContState$ };
var $n_Lcats_effect_ContState$;
function $m_Lcats_effect_ContState$() {
  if ((!$n_Lcats_effect_ContState$)) {
    $n_Lcats_effect_ContState$ = new $c_Lcats_effect_ContState$();
  }
  return $n_Lcats_effect_ContState$;
}
export { $m_Lcats_effect_ContState$ as $m_Lcats_effect_ContState$ };
/** @constructor */
function $c_Lcats_effect_IOCompanionPlatform() {
}
export { $c_Lcats_effect_IOCompanionPlatform as $c_Lcats_effect_IOCompanionPlatform };
$c_Lcats_effect_IOCompanionPlatform.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_IOCompanionPlatform.prototype.constructor = $c_Lcats_effect_IOCompanionPlatform;
/** @constructor */
function $h_Lcats_effect_IOCompanionPlatform() {
}
export { $h_Lcats_effect_IOCompanionPlatform as $h_Lcats_effect_IOCompanionPlatform };
$h_Lcats_effect_IOCompanionPlatform.prototype = $c_Lcats_effect_IOCompanionPlatform.prototype;
$c_Lcats_effect_IOCompanionPlatform.prototype.suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_effect_IO = (function(hint, thunk) {
  return this.delay__F0__Lcats_effect_IO(thunk);
});
$c_Lcats_effect_IOCompanionPlatform.prototype.fromPromise__Lcats_effect_IO__Lcats_effect_IO = (function(iop) {
  var this$1 = this.Lcats_effect_IO$__f__asyncForIO;
  return $f_Lcats_effect_kernel_AsyncPlatform__fromPromise__O__O(this$1, iop);
});
/** @constructor */
function $c_Lcats_effect_IOFiber$() {
  this.Lcats_effect_IOFiber$__f_TypeBlocking = null;
  this.Lcats_effect_IOFiber$__f_OutcomeCanceled = null;
  this.Lcats_effect_IOFiber$__f_RightUnit = null;
  $n_Lcats_effect_IOFiber$ = this;
  this.Lcats_effect_IOFiber$__f_TypeBlocking = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_effect_kernel_Sync$Type$Blocking$();
  this.Lcats_effect_IOFiber$__f_OutcomeCanceled = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Canceled();
  this.Lcats_effect_IOFiber$__f_RightUnit = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right((void 0));
}
export { $c_Lcats_effect_IOFiber$ as $c_Lcats_effect_IOFiber$ };
$c_Lcats_effect_IOFiber$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_IOFiber$.prototype.constructor = $c_Lcats_effect_IOFiber$;
/** @constructor */
function $h_Lcats_effect_IOFiber$() {
}
export { $h_Lcats_effect_IOFiber$ as $h_Lcats_effect_IOFiber$ };
$h_Lcats_effect_IOFiber$.prototype = $c_Lcats_effect_IOFiber$.prototype;
$c_Lcats_effect_IOFiber$.prototype.onFatalFailure__jl_Throwable__E = (function(t) {
  var interrupted = $m_jl_Thread$().interrupted__Z();
  if ($m_Lcats_effect_unsafe_IORuntime$().Lcats_effect_unsafe_IORuntime$__f_globalFatalFailureHandled.compareAndSet__Z__Z__Z(false, true)) {
    if (($m_Lcats_effect_unsafe_IORuntime$().Lcats_effect_unsafe_IORuntime$__f_allRuntimes === null)) {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
    }
    var r = 0;
    var runtimes = $m_Lcats_effect_unsafe_IORuntime$().Lcats_effect_unsafe_IORuntime$__f_allRuntimes.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable;
    var length = runtimes.u.length;
    while ((r < length)) {
      var ref = runtimes.u[r];
      if ((ref instanceof $c_Lcats_effect_unsafe_IORuntime)) {
        ref.Lcats_effect_unsafe_IORuntime__f_shutdown.apply__O();
        $m_jl_Thread$().interrupted__Z();
        var idx = 0;
        var tables = ref.Lcats_effect_unsafe_IORuntime__f_fiberErrorCbs.Lcats_effect_unsafe_StripedHashtable__f_tables;
        var numTables = ref.Lcats_effect_unsafe_IORuntime__f_fiberErrorCbs.numTables__I();
        while ((idx < numTables)) {
          var table = tables.u[idx];
          if ((table === null)) {
            throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
          }
          var hashtable = table.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable;
          var len = hashtable.u.length;
          var i = 0;
          while ((i < len)) {
            var ref$2 = hashtable.u[i];
            if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$is_F1(ref$2)) {
              ref$2.apply__O__O(t);
            }
            i = ((1 + i) | 0);
          }
          idx = ((1 + idx) | 0);
        }
      }
      r = ((1 + r) | 0);
    }
  }
  if (interrupted) {
    var this$1 = $m_jl_Thread$().jl_Thread$__f_SingleThread;
    this$1.jl_Thread__f_java$lang$Thread$$interruptedState = true;
  }
  var $x_1 = t;
  throw (($x_1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? $x_1.sjs_js_JavaScriptException__f_exception : $x_1);
});
var $d_Lcats_effect_IOFiber$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IOFiber$, "cats.effect.IOFiber$", ({
  Lcats_effect_IOFiber$: 1
}));
export { $d_Lcats_effect_IOFiber$ as $d_Lcats_effect_IOFiber$ };
var $n_Lcats_effect_IOFiber$;
function $m_Lcats_effect_IOFiber$() {
  if ((!$n_Lcats_effect_IOFiber$)) {
    $n_Lcats_effect_IOFiber$ = new $c_Lcats_effect_IOFiber$();
  }
  return $n_Lcats_effect_IOFiber$;
}
export { $m_Lcats_effect_IOFiber$ as $m_Lcats_effect_IOFiber$ };
/** @constructor */
function $c_Lcats_effect_IOPlatform() {
}
export { $c_Lcats_effect_IOPlatform as $c_Lcats_effect_IOPlatform };
$c_Lcats_effect_IOPlatform.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_IOPlatform.prototype.constructor = $c_Lcats_effect_IOPlatform;
/** @constructor */
function $h_Lcats_effect_IOPlatform() {
}
export { $h_Lcats_effect_IOPlatform as $h_Lcats_effect_IOPlatform };
$h_Lcats_effect_IOPlatform.prototype = $c_Lcats_effect_IOPlatform.prototype;
function $p_Lcats_effect_Trace__renderStackTraceElement__jl_StackTraceElement__T($thiz, ste) {
  return (((((((ste.jl_StackTraceElement__f_declaringClass + ".") + ste.jl_StackTraceElement__f_methodName) + " (") + ste.jl_StackTraceElement__f_fileName) + ":") + ste.jl_StackTraceElement__f_lineNumber) + ")");
}
export { $p_Lcats_effect_Trace__renderStackTraceElement__jl_StackTraceElement__T as $p_Lcats_effect_Trace__renderStackTraceElement__jl_StackTraceElement__T };
/** @constructor */
function $c_Lcats_effect_Trace(frames) {
  this.Lcats_effect_Trace__f_frames = null;
  this.Lcats_effect_Trace__f_frames = frames;
}
export { $c_Lcats_effect_Trace as $c_Lcats_effect_Trace };
$c_Lcats_effect_Trace.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_Trace.prototype.constructor = $c_Lcats_effect_Trace;
/** @constructor */
function $h_Lcats_effect_Trace() {
}
export { $h_Lcats_effect_Trace as $h_Lcats_effect_Trace };
$h_Lcats_effect_Trace.prototype = $c_Lcats_effect_Trace.prototype;
$c_Lcats_effect_Trace.prototype.compact__T = (function() {
  var this$2 = this.Lcats_effect_Trace__f_frames;
  var f = ((ste) => $p_Lcats_effect_Trace__renderStackTraceElement__jl_StackTraceElement__T(this, ste));
  if ((this$2 === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
    var this$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  } else {
    var x0 = this$2.head__O();
    var h = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
    var t = h;
    var rest = this$2.tail__O();
    while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
      var x0$1 = rest.head__O();
      var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0$1), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      t.sci_$colon$colon__f_next = nx;
      t = nx;
      rest = rest.tail__O();
    }
    var this$3 = h;
  }
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__mkString__T__T__T__T(this$3, "", ", ", "");
});
$c_Lcats_effect_Trace.prototype.toString__T = (function() {
  return this.compact__T();
});
var $d_Lcats_effect_Trace = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_Trace, "cats.effect.Trace", ({
  Lcats_effect_Trace: 1
}));
export { $d_Lcats_effect_Trace as $d_Lcats_effect_Trace };
/** @constructor */
function $c_Lcats_effect_Trace$() {
}
export { $c_Lcats_effect_Trace$ as $c_Lcats_effect_Trace$ };
$c_Lcats_effect_Trace$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_Trace$.prototype.constructor = $c_Lcats_effect_Trace$;
/** @constructor */
function $h_Lcats_effect_Trace$() {
}
export { $h_Lcats_effect_Trace$ as $h_Lcats_effect_Trace$ };
$h_Lcats_effect_Trace$.prototype = $c_Lcats_effect_Trace$.prototype;
$c_Lcats_effect_Trace$.prototype.apply__Lcats_effect_tracing_RingBuffer__Lcats_effect_Trace = (function(events) {
  return new $c_Lcats_effect_Trace($m_Lcats_effect_tracing_Tracing$().getFrames__Lcats_effect_tracing_RingBuffer__sci_List(events));
});
var $d_Lcats_effect_Trace$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_Trace$, "cats.effect.Trace$", ({
  Lcats_effect_Trace$: 1
}));
export { $d_Lcats_effect_Trace$ as $d_Lcats_effect_Trace$ };
var $n_Lcats_effect_Trace$;
function $m_Lcats_effect_Trace$() {
  if ((!$n_Lcats_effect_Trace$)) {
    $n_Lcats_effect_Trace$ = new $c_Lcats_effect_Trace$();
  }
  return $n_Lcats_effect_Trace$;
}
export { $m_Lcats_effect_Trace$ as $m_Lcats_effect_Trace$ };
function $f_Lcats_effect_kernel_AsyncPlatform__fromPromise__O__O($thiz, iop) {
  return $f_Lcats_effect_kernel_AsyncPlatform__fromThenable__O__O($thiz, iop);
}
export { $f_Lcats_effect_kernel_AsyncPlatform__fromPromise__O__O as $f_Lcats_effect_kernel_AsyncPlatform__fromPromise__O__O };
function $f_Lcats_effect_kernel_AsyncPlatform__fromThenable__O__O($thiz, iot) {
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((t) => {
    var k = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((cb) => {
      t.then(((cb$2) => ((v) => cb$2.apply__O__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(v))))(cb), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sjs_js_defined$().apply__O__sjs_js_$bar(((cb$2$1) => ((a) => {
        var e = ((a instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? a : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(a));
        return cb$2$1.apply__O__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(e));
      }))(cb)));
    }));
    return $m_Lcats_effect_IO$().async___F1__Lcats_effect_IO(k);
  }));
  return iot.flatMap__F1__Lcats_effect_IO(f);
}
export { $f_Lcats_effect_kernel_AsyncPlatform__fromThenable__O__O as $f_Lcats_effect_kernel_AsyncPlatform__fromThenable__O__O };
/** @constructor */
function $c_Lcats_effect_kernel_ResourceFOInstances1() {
}
export { $c_Lcats_effect_kernel_ResourceFOInstances1 as $c_Lcats_effect_kernel_ResourceFOInstances1 };
$c_Lcats_effect_kernel_ResourceFOInstances1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_kernel_ResourceFOInstances1.prototype.constructor = $c_Lcats_effect_kernel_ResourceFOInstances1;
/** @constructor */
function $h_Lcats_effect_kernel_ResourceFOInstances1() {
}
export { $h_Lcats_effect_kernel_ResourceFOInstances1 as $h_Lcats_effect_kernel_ResourceFOInstances1 };
$h_Lcats_effect_kernel_ResourceFOInstances1.prototype = $c_Lcats_effect_kernel_ResourceFOInstances1.prototype;
function $f_Lcats_effect_kernel_syntax_GenSpawnSyntax__genSpawnOps__O__Lcats_effect_kernel_GenSpawn__O($thiz, wrapped, F) {
  return wrapped;
}
export { $f_Lcats_effect_kernel_syntax_GenSpawnSyntax__genSpawnOps__O__Lcats_effect_kernel_GenSpawn__O as $f_Lcats_effect_kernel_syntax_GenSpawnSyntax__genSpawnOps__O__Lcats_effect_kernel_GenSpawn__O };
/** @constructor */
function $c_Lcats_effect_package$IOLocalState$() {
  this.Lcats_effect_package$IOLocalState$__f_empty = null;
  $n_Lcats_effect_package$IOLocalState$ = this;
  this.Lcats_effect_package$IOLocalState$__f_empty = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$EmptyMap$();
}
export { $c_Lcats_effect_package$IOLocalState$ as $c_Lcats_effect_package$IOLocalState$ };
$c_Lcats_effect_package$IOLocalState$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_package$IOLocalState$.prototype.constructor = $c_Lcats_effect_package$IOLocalState$;
/** @constructor */
function $h_Lcats_effect_package$IOLocalState$() {
}
export { $h_Lcats_effect_package$IOLocalState$ as $h_Lcats_effect_package$IOLocalState$ };
$h_Lcats_effect_package$IOLocalState$.prototype = $c_Lcats_effect_package$IOLocalState$.prototype;
var $d_Lcats_effect_package$IOLocalState$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_package$IOLocalState$, "cats.effect.package$IOLocalState$", ({
  Lcats_effect_package$IOLocalState$: 1
}));
export { $d_Lcats_effect_package$IOLocalState$ as $d_Lcats_effect_package$IOLocalState$ };
var $n_Lcats_effect_package$IOLocalState$;
function $m_Lcats_effect_package$IOLocalState$() {
  if ((!$n_Lcats_effect_package$IOLocalState$)) {
    $n_Lcats_effect_package$IOLocalState$ = new $c_Lcats_effect_package$IOLocalState$();
  }
  return $n_Lcats_effect_package$IOLocalState$;
}
export { $m_Lcats_effect_package$IOLocalState$ as $m_Lcats_effect_package$IOLocalState$ };
/** @constructor */
function $c_Lcats_effect_process$() {
}
export { $c_Lcats_effect_process$ as $c_Lcats_effect_process$ };
$c_Lcats_effect_process$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_process$.prototype.constructor = $c_Lcats_effect_process$;
/** @constructor */
function $h_Lcats_effect_process$() {
}
export { $h_Lcats_effect_process$ as $h_Lcats_effect_process$ };
$h_Lcats_effect_process$.prototype = $c_Lcats_effect_process$.prototype;
$c_Lcats_effect_process$.prototype.env__T__s_Option = (function(key) {
  var this$1 = $m_Lcats_effect_std_Env$();
  var F = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_effect_SyncIO$().Lcats_effect_SyncIO$__f__syncForSyncIO;
  var env = new $c_Lcats_effect_std_EnvCompanionPlatform$SyncEnv(this$1, F);
  var value = env.get__T__O(key);
  return new $c_Lcats_data_OptionT(value).orElseF__F0__Lcats_Monad__Lcats_data_OptionT(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => env.get__T__O(("REACT_APP_" + key)))), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_effect_SyncIO$().Lcats_effect_SyncIO$__f__syncForSyncIO).Lcats_data_OptionT__f_value.unsafeRunSync__O();
});
var $d_Lcats_effect_process$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_process$, "cats.effect.process$", ({
  Lcats_effect_process$: 1
}));
export { $d_Lcats_effect_process$ as $d_Lcats_effect_process$ };
var $n_Lcats_effect_process$;
function $m_Lcats_effect_process$() {
  if ((!$n_Lcats_effect_process$)) {
    $n_Lcats_effect_process$ = new $c_Lcats_effect_process$();
  }
  return $n_Lcats_effect_process$;
}
export { $m_Lcats_effect_process$ as $m_Lcats_effect_process$ };
/** @constructor */
function $c_Lcats_effect_std_ConsoleCompanionCrossPlatform() {
}
export { $c_Lcats_effect_std_ConsoleCompanionCrossPlatform as $c_Lcats_effect_std_ConsoleCompanionCrossPlatform };
$c_Lcats_effect_std_ConsoleCompanionCrossPlatform.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_std_ConsoleCompanionCrossPlatform.prototype.constructor = $c_Lcats_effect_std_ConsoleCompanionCrossPlatform;
/** @constructor */
function $h_Lcats_effect_std_ConsoleCompanionCrossPlatform() {
}
export { $h_Lcats_effect_std_ConsoleCompanionCrossPlatform as $h_Lcats_effect_std_ConsoleCompanionCrossPlatform };
$h_Lcats_effect_std_ConsoleCompanionCrossPlatform.prototype = $c_Lcats_effect_std_ConsoleCompanionCrossPlatform.prototype;
/** @constructor */
function $c_Lcats_effect_std_EnvCompanionPlatform() {
}
export { $c_Lcats_effect_std_EnvCompanionPlatform as $c_Lcats_effect_std_EnvCompanionPlatform };
$c_Lcats_effect_std_EnvCompanionPlatform.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_std_EnvCompanionPlatform.prototype.constructor = $c_Lcats_effect_std_EnvCompanionPlatform;
/** @constructor */
function $h_Lcats_effect_std_EnvCompanionPlatform() {
}
export { $h_Lcats_effect_std_EnvCompanionPlatform as $h_Lcats_effect_std_EnvCompanionPlatform };
$h_Lcats_effect_std_EnvCompanionPlatform.prototype = $c_Lcats_effect_std_EnvCompanionPlatform.prototype;
/** @constructor */
function $c_Lcats_effect_std_Semaphore() {
}
export { $c_Lcats_effect_std_Semaphore as $c_Lcats_effect_std_Semaphore };
$c_Lcats_effect_std_Semaphore.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_std_Semaphore.prototype.constructor = $c_Lcats_effect_std_Semaphore;
/** @constructor */
function $h_Lcats_effect_std_Semaphore() {
}
export { $h_Lcats_effect_std_Semaphore as $h_Lcats_effect_std_Semaphore };
$h_Lcats_effect_std_Semaphore.prototype = $c_Lcats_effect_std_Semaphore.prototype;
function $s_Lcats_effect_std_Semaphore$__cats$effect$std$Semaphore$impl$$anon$1$$_$fulfil$1__J__sci_Queue__sci_Queue__T3(n, requests, wakeup) {
  var wakeup$tailLocal1 = wakeup;
  var requests$tailLocal1 = requests;
  var lo = n.RTLong__f_lo;
  var hi = n.RTLong__f_hi;
  var n$tailLocal1__lo = lo;
  var n$tailLocal1__hi = hi;
  while (true) {
    matchResult15: {
      var \u03b42$___1;
      var \u03b42$___2;
      var x25 = requests$tailLocal1.dequeue__T2();
      if ((x25 !== null)) {
        var req = x25._1__O();
        var tail = x25._2__O();
        var \u03b42$___1 = req;
        var \u03b42$___2 = tail;
        break matchResult15;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x25);
    }
    var req$2 = \u03b42$___1;
    var tail$2 = \u03b42$___2;
    var a__lo = n$tailLocal1__lo;
    var a__hi = n$tailLocal1__hi;
    var b = req$2.Lcats_effect_std_Semaphore$impl$Request__f_n;
    var ahi = a__hi;
    var bhi = b.RTLong__f_hi;
    if (((ahi === bhi) ? ((a__lo >>> 0) < (b.RTLong__f_lo >>> 0)) : (ahi < bhi))) {
      var a$1 = req$2.Lcats_effect_std_Semaphore$impl$Request__f_n;
      var b$1__lo = n$tailLocal1__lo;
      var b$1__hi = n$tailLocal1__hi;
      var alo = a$1.RTLong__f_lo;
      var blo = b$1__lo;
      var lo$1 = ((alo - blo) | 0);
      var hi$1 = ((((a$1.RTLong__f_hi - b$1__hi) | 0) + ((((~alo) & blo) | ((~(alo ^ blo)) & lo$1)) >> 31)) | 0);
      var elem$1 = req$2.of__J__Lcats_effect_std_Semaphore$impl$Request(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$1, hi$1));
      var _2 = tail$2.prepended__O__sci_Queue(elem$1);
      var _3 = wakeup$tailLocal1;
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T3($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0, _2, _3);
    } else {
      var a$2__lo = n$tailLocal1__lo;
      var a$2__hi = n$tailLocal1__hi;
      var b$2 = req$2.Lcats_effect_std_Semaphore$impl$Request__f_n;
      var alo$1 = a$2__lo;
      var blo$1 = b$2.RTLong__f_lo;
      var lo$2 = ((alo$1 - blo$1) | 0);
      var hi$2 = ((((a$2__hi - b$2.RTLong__f_hi) | 0) + ((((~alo$1) & blo$1) | ((~(alo$1 ^ blo$1)) & lo$2)) >> 31)) | 0);
      var newWakeup = wakeup$tailLocal1.enqueue__O__sci_Queue(req$2);
      if ((tail$2.isEmpty__Z() || ((lo$2 === 0) && (hi$2 === 0)))) {
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T3(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$2, hi$2), tail$2, newWakeup);
      } else {
        var $x_1__lo = lo$2;
        var $x_1__hi = hi$2;
        n$tailLocal1__lo = $x_1__lo;
        n$tailLocal1__hi = $x_1__hi;
        requests$tailLocal1 = tail$2;
        wakeup$tailLocal1 = newWakeup;
      }
    }
  }
}
export { $s_Lcats_effect_std_Semaphore$__cats$effect$std$Semaphore$impl$$anon$1$$_$fulfil$1__J__sci_Queue__sci_Queue__T3 as $s_Lcats_effect_std_Semaphore$__cats$effect$std$Semaphore$impl$$anon$1$$_$fulfil$1__J__sci_Queue__sci_Queue__T3 };
/** @constructor */
function $c_Lcats_effect_std_Semaphore$() {
}
export { $c_Lcats_effect_std_Semaphore$ as $c_Lcats_effect_std_Semaphore$ };
$c_Lcats_effect_std_Semaphore$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_std_Semaphore$.prototype.constructor = $c_Lcats_effect_std_Semaphore$;
/** @constructor */
function $h_Lcats_effect_std_Semaphore$() {
}
export { $h_Lcats_effect_std_Semaphore$ as $h_Lcats_effect_std_Semaphore$ };
$h_Lcats_effect_std_Semaphore$.prototype = $c_Lcats_effect_std_Semaphore$.prototype;
$c_Lcats_effect_std_Semaphore$.prototype.apply__J__Lcats_effect_kernel_GenConcurrent__O = (function(n, F) {
  var impl = new $c_Lcats_effect_std_Semaphore$impl(n, F);
  var a = impl.initialState__Lcats_effect_std_Semaphore$impl$State();
  var target = $m_Lcats_effect_IO$().ref__O__Lcats_effect_IO(a);
  var this$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target, F);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((state) => new $c_Lcats_effect_std_Semaphore$impl$$anon$1(state, impl)));
  return this$2.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.map__O__F1__O(this$2.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
});
var $d_Lcats_effect_std_Semaphore$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_std_Semaphore$, "cats.effect.std.Semaphore$", ({
  Lcats_effect_std_Semaphore$: 1
}));
export { $d_Lcats_effect_std_Semaphore$ as $d_Lcats_effect_std_Semaphore$ };
var $n_Lcats_effect_std_Semaphore$;
function $m_Lcats_effect_std_Semaphore$() {
  if ((!$n_Lcats_effect_std_Semaphore$)) {
    $n_Lcats_effect_std_Semaphore$ = new $c_Lcats_effect_std_Semaphore$();
  }
  return $n_Lcats_effect_std_Semaphore$;
}
export { $m_Lcats_effect_std_Semaphore$ as $m_Lcats_effect_std_Semaphore$ };
/** @constructor */
function $c_Lcats_effect_std_Semaphore$impl(n, F) {
  this.Lcats_effect_std_Semaphore$impl__f_n = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0;
  this.Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F = null;
  this.Lcats_effect_std_Semaphore$impl__f_Request$lzy1 = null;
  this.Lcats_effect_std_Semaphore$impl__f_State$lzy1 = null;
  this.Lcats_effect_std_Semaphore$impl__f_Wait$lzy1 = null;
  this.Lcats_effect_std_Semaphore$impl__f_Waitbitmap$1 = false;
  this.Lcats_effect_std_Semaphore$impl__f_Done$lzy1 = null;
  this.Lcats_effect_std_Semaphore$impl__f_Donebitmap$1 = false;
  this.Lcats_effect_std_Semaphore$impl__f_n = n;
  this.Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F = F;
  this.Lcats_effect_std_Semaphore$impl__f_Request$lzy1 = new $c_Lcats_effect_std_Semaphore$impl$Request$(this);
  this.Lcats_effect_std_Semaphore$impl__f_State$lzy1 = new $c_Lcats_effect_std_Semaphore$impl$State$(this);
  this.requireNonNegative__J__V(n);
}
export { $c_Lcats_effect_std_Semaphore$impl as $c_Lcats_effect_std_Semaphore$impl };
$c_Lcats_effect_std_Semaphore$impl.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_std_Semaphore$impl.prototype.constructor = $c_Lcats_effect_std_Semaphore$impl;
/** @constructor */
function $h_Lcats_effect_std_Semaphore$impl() {
}
export { $h_Lcats_effect_std_Semaphore$impl as $h_Lcats_effect_std_Semaphore$impl };
$h_Lcats_effect_std_Semaphore$impl.prototype = $c_Lcats_effect_std_Semaphore$impl.prototype;
$c_Lcats_effect_std_Semaphore$impl.prototype.requireNonNegative__J__V = (function(n) {
  var ahi = n.RTLong__f_hi;
  var requirement = (ahi >= 0);
  if ((!requirement)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), (("requirement failed: " + "n must be nonnegative, was: ") + n));
  }
});
$c_Lcats_effect_std_Semaphore$impl.prototype.newRequest__O = (function() {
  var target = $m_Lcats_effect_IO$().deferred__Lcats_effect_IO();
  var tc = this.Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F;
  var this$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$7) => this.Lcats_effect_std_Semaphore$impl__f_Request$lzy1.apply__J__Lcats_effect_kernel_Deferred__Lcats_effect_std_Semaphore$impl$Request($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0, _$7)));
  return this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
});
$c_Lcats_effect_std_Semaphore$impl.prototype.initialState__Lcats_effect_std_Semaphore$impl$State = (function() {
  var $x_2 = this.Lcats_effect_std_Semaphore$impl__f_State$lzy1;
  var $x_1 = this.Lcats_effect_std_Semaphore$impl__f_n;
  var xs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_sr_Nothing$.getArrayOf().constr)([]));
  return $x_2.apply__J__sci_Queue__Lcats_effect_std_Semaphore$impl$State($x_1, $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(xs)));
});
$c_Lcats_effect_std_Semaphore$impl.prototype.Wait__Lcats_effect_std_Semaphore$impl$Wait$ = (function() {
  if ((!this.Lcats_effect_std_Semaphore$impl__f_Waitbitmap$1)) {
    this.Lcats_effect_std_Semaphore$impl__f_Wait$lzy1 = new $c_Lcats_effect_std_Semaphore$impl$Wait$();
    this.Lcats_effect_std_Semaphore$impl__f_Waitbitmap$1 = true;
  }
  return this.Lcats_effect_std_Semaphore$impl__f_Wait$lzy1;
});
$c_Lcats_effect_std_Semaphore$impl.prototype.Done__Lcats_effect_std_Semaphore$impl$Done$ = (function() {
  if ((!this.Lcats_effect_std_Semaphore$impl__f_Donebitmap$1)) {
    this.Lcats_effect_std_Semaphore$impl__f_Done$lzy1 = new $c_Lcats_effect_std_Semaphore$impl$Done$();
    this.Lcats_effect_std_Semaphore$impl__f_Donebitmap$1 = true;
  }
  return this.Lcats_effect_std_Semaphore$impl__f_Done$lzy1;
});
var $d_Lcats_effect_std_Semaphore$impl = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_std_Semaphore$impl, "cats.effect.std.Semaphore$impl", ({
  Lcats_effect_std_Semaphore$impl: 1
}));
export { $d_Lcats_effect_std_Semaphore$impl as $d_Lcats_effect_std_Semaphore$impl };
/** @constructor */
function $c_Lcats_effect_tracing_RingBuffer(logSize) {
  this.Lcats_effect_tracing_RingBuffer__f_length = 0;
  this.Lcats_effect_tracing_RingBuffer__f_mask = 0;
  this.Lcats_effect_tracing_RingBuffer__f_buffer = null;
  this.Lcats_effect_tracing_RingBuffer__f_index = 0;
  this.Lcats_effect_tracing_RingBuffer__f_length = (1 << logSize);
  this.Lcats_effect_tracing_RingBuffer__f_mask = (((-1) + this.Lcats_effect_tracing_RingBuffer__f_length) | 0);
  var dimensions = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I(new Int32Array([this.Lcats_effect_tracing_RingBuffer__f_length]));
  this.Lcats_effect_tracing_RingBuffer__f_buffer = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Lcats_effect_tracing_TracingEvent.getClassOf(), dimensions);
  this.Lcats_effect_tracing_RingBuffer__f_index = 0;
}
export { $c_Lcats_effect_tracing_RingBuffer as $c_Lcats_effect_tracing_RingBuffer };
$c_Lcats_effect_tracing_RingBuffer.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_tracing_RingBuffer.prototype.constructor = $c_Lcats_effect_tracing_RingBuffer;
/** @constructor */
function $h_Lcats_effect_tracing_RingBuffer() {
}
export { $h_Lcats_effect_tracing_RingBuffer as $h_Lcats_effect_tracing_RingBuffer };
$h_Lcats_effect_tracing_RingBuffer.prototype = $c_Lcats_effect_tracing_RingBuffer.prototype;
$c_Lcats_effect_tracing_RingBuffer.prototype.push__Lcats_effect_tracing_TracingEvent__V = (function(te) {
  var idx = (this.Lcats_effect_tracing_RingBuffer__f_index & this.Lcats_effect_tracing_RingBuffer__f_mask);
  this.Lcats_effect_tracing_RingBuffer__f_buffer.u[idx] = te;
  this.Lcats_effect_tracing_RingBuffer__f_index = ((1 + this.Lcats_effect_tracing_RingBuffer__f_index) | 0);
});
$c_Lcats_effect_tracing_RingBuffer.prototype.toList__sci_List = (function() {
  var result = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var buf = this.Lcats_effect_tracing_RingBuffer__f_buffer;
  if ((buf !== null)) {
    var msk = this.Lcats_effect_tracing_RingBuffer__f_mask;
    var idx = this.Lcats_effect_tracing_RingBuffer__f_index;
    var x = ((idx - this.Lcats_effect_tracing_RingBuffer__f_length) | 0);
    var start = ((x > 0) ? x : 0);
    var i = start;
    while ((i < idx)) {
      var this$4 = result;
      var elem = buf.u[(i & msk)];
      result = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem, this$4);
      i = ((1 + i) | 0);
    }
  }
  return result;
});
$c_Lcats_effect_tracing_RingBuffer.prototype.invalidate__V = (function() {
  this.Lcats_effect_tracing_RingBuffer__f_index = 0;
  this.Lcats_effect_tracing_RingBuffer__f_buffer = null;
});
var $d_Lcats_effect_tracing_RingBuffer = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_tracing_RingBuffer, "cats.effect.tracing.RingBuffer", ({
  Lcats_effect_tracing_RingBuffer: 1
}));
export { $d_Lcats_effect_tracing_RingBuffer as $d_Lcats_effect_tracing_RingBuffer };
/** @constructor */
function $c_Lcats_effect_tracing_TracingConstants$() {
  this.Lcats_effect_tracing_TracingConstants$__f_isCachedStackTracing = false;
  this.Lcats_effect_tracing_TracingConstants$__f_isFullStackTracing = false;
  this.Lcats_effect_tracing_TracingConstants$__f_isStackTracing = false;
  $n_Lcats_effect_tracing_TracingConstants$ = this;
  var this$1 = $m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_TRACING_MODE");
  if (this$1.isEmpty__Z()) {
    var $x_1 = true;
  } else {
    var x0 = this$1.get__O();
    var $x_1 = (!(x0 === ""));
  }
  if ($x_1) {
    var this$2 = this$1;
  } else {
    var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
  if (this$2.isEmpty__Z()) {
    if ((((typeof process) !== "undefined") && ((typeof process.release) !== "undefined"))) {
      var x = process.release.name;
      var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, "node");
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var $x_2 = "cached";
    } else {
      var $x_2 = "none";
    }
  } else {
    var $x_2 = this$2.get__O();
  }
  var stackTracingMode = $x_2;
  _return: {
    var len = stackTracingMode.length;
    if ((len === 6)) {
      var i = 0;
      while ((i !== len)) {
        var index = i;
        var c = stackTracingMode.charCodeAt(index);
        var $x_5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toLowerCase__C__C($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toUpperCase__C__C(c));
        var index$1 = i;
        var c$1 = "cached".charCodeAt(index$1);
        if (($x_5 !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toLowerCase__C__C($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toUpperCase__C__C(c$1)))) {
          var $x_4 = false;
          break _return;
        }
        i = ((1 + i) | 0);
      }
      var $x_4 = true;
    } else {
      var $x_4 = false;
    }
  }
  this.Lcats_effect_tracing_TracingConstants$__f_isCachedStackTracing = $x_4;
  _return$1: {
    var len$1 = stackTracingMode.length;
    if ((len$1 === 4)) {
      var i$1 = 0;
      while ((i$1 !== len$1)) {
        var index$2 = i$1;
        var c$2 = stackTracingMode.charCodeAt(index$2);
        var $x_7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toLowerCase__C__C($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toUpperCase__C__C(c$2));
        var index$3 = i$1;
        var c$3 = "full".charCodeAt(index$3);
        if (($x_7 !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toLowerCase__C__C($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toUpperCase__C__C(c$3)))) {
          var $x_6 = false;
          break _return$1;
        }
        i$1 = ((1 + i$1) | 0);
      }
      var $x_6 = true;
    } else {
      var $x_6 = false;
    }
  }
  this.Lcats_effect_tracing_TracingConstants$__f_isFullStackTracing = $x_6;
  this.Lcats_effect_tracing_TracingConstants$__f_isStackTracing = (this.Lcats_effect_tracing_TracingConstants$__f_isFullStackTracing || this.Lcats_effect_tracing_TracingConstants$__f_isCachedStackTracing);
}
export { $c_Lcats_effect_tracing_TracingConstants$ as $c_Lcats_effect_tracing_TracingConstants$ };
$c_Lcats_effect_tracing_TracingConstants$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_tracing_TracingConstants$.prototype.constructor = $c_Lcats_effect_tracing_TracingConstants$;
/** @constructor */
function $h_Lcats_effect_tracing_TracingConstants$() {
}
export { $h_Lcats_effect_tracing_TracingConstants$ as $h_Lcats_effect_tracing_TracingConstants$ };
$h_Lcats_effect_tracing_TracingConstants$.prototype = $c_Lcats_effect_tracing_TracingConstants$.prototype;
var $d_Lcats_effect_tracing_TracingConstants$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_tracing_TracingConstants$, "cats.effect.tracing.TracingConstants$", ({
  Lcats_effect_tracing_TracingConstants$: 1
}));
export { $d_Lcats_effect_tracing_TracingConstants$ as $d_Lcats_effect_tracing_TracingConstants$ };
var $n_Lcats_effect_tracing_TracingConstants$;
function $m_Lcats_effect_tracing_TracingConstants$() {
  if ((!$n_Lcats_effect_tracing_TracingConstants$)) {
    $n_Lcats_effect_tracing_TracingConstants$ = new $c_Lcats_effect_tracing_TracingConstants$();
  }
  return $n_Lcats_effect_tracing_TracingConstants$;
}
export { $m_Lcats_effect_tracing_TracingConstants$ as $m_Lcats_effect_tracing_TracingConstants$ };
function $ct_Lcats_effect_tracing_TracingPlatform__($thiz) {
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_scm_Map$().empty__O();
  $thiz.Lcats_effect_tracing_TracingPlatform__f_cache = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_scm_Map__withDefaultValue__O__scm_Map(this$1, null);
  $thiz.Lcats_effect_tracing_TracingPlatform__f_function0Property = Object.getOwnPropertyNames(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => (void 0))))[0];
  $thiz.Lcats_effect_tracing_TracingPlatform__f_function1Property = Object.getOwnPropertyNames(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => (void 0))))[0];
  $thiz.Lcats_effect_tracing_TracingPlatform__f_calculateTracingEvent = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$5) => null));
  $thiz.Lcats_effect_tracing_TracingPlatform__f_stackTraceFileNameFilter = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["githubusercontent.com/typelevel/cats-effect/", "githubusercontent.com/typelevel/cats/", "githubusercontent.com/scala-js/", "githubusercontent.com/scala/"]);
  $thiz.Lcats_effect_tracing_TracingPlatform__f_stackTraceMethodNameFilter = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["_Lcats_effect_", "_jl_", "_Lorg_scalajs_"]);
  return $thiz;
}
export { $ct_Lcats_effect_tracing_TracingPlatform__ as $ct_Lcats_effect_tracing_TracingPlatform__ };
function $p_Lcats_effect_tracing_TracingPlatform__isInternalFile__T__Z($thiz, fileName) {
  var i = 0;
  var len = $thiz.Lcats_effect_tracing_TracingPlatform__f_stackTraceFileNameFilter.u.length;
  while ((i < len)) {
    var s = $thiz.Lcats_effect_tracing_TracingPlatform__f_stackTraceFileNameFilter.u[i];
    if (((fileName.indexOf(s) | 0) !== (-1))) {
      return true;
    }
    i = ((1 + i) | 0);
  }
  return false;
}
export { $p_Lcats_effect_tracing_TracingPlatform__isInternalFile__T__Z as $p_Lcats_effect_tracing_TracingPlatform__isInternalFile__T__Z };
function $p_Lcats_effect_tracing_TracingPlatform__isInternalMethod__T__Z($thiz, methodName) {
  var i = 0;
  var len = $thiz.Lcats_effect_tracing_TracingPlatform__f_stackTraceMethodNameFilter.u.length;
  while ((i < len)) {
    var s = $thiz.Lcats_effect_tracing_TracingPlatform__f_stackTraceMethodNameFilter.u[i];
    if (((methodName.indexOf(s) | 0) !== (-1))) {
      return true;
    }
    i = ((1 + i) | 0);
  }
  return false;
}
export { $p_Lcats_effect_tracing_TracingPlatform__isInternalMethod__T__Z as $p_Lcats_effect_tracing_TracingPlatform__isInternalMethod__T__Z };
function $p_Lcats_effect_tracing_TracingPlatform__isInternalScalaFile$1__T__Z($thiz, callSiteFileName$1) {
  return (((callSiteFileName$1 !== null) && (!(!(!callSiteFileName$1.endsWith(".js"))))) && $p_Lcats_effect_tracing_TracingPlatform__isInternalFile__T__Z($thiz, callSiteFileName$1));
}
export { $p_Lcats_effect_tracing_TracingPlatform__isInternalScalaFile$1__T__Z as $p_Lcats_effect_tracing_TracingPlatform__isInternalScalaFile$1__T__Z };
function $p_Lcats_effect_tracing_TracingPlatform__isInternalJSCode$1__T__T__T__Z($thiz, callSiteClassName$1, callSiteMethodName$1, callSiteFileName$2) {
  return ((callSiteClassName$1 === "<jscode>") && ($p_Lcats_effect_tracing_TracingPlatform__isInternalScalaFile$1__T__Z($thiz, callSiteFileName$2) || $p_Lcats_effect_tracing_TracingPlatform__isInternalMethod__T__Z($thiz, callSiteMethodName$1)));
}
export { $p_Lcats_effect_tracing_TracingPlatform__isInternalJSCode$1__T__T__T__Z as $p_Lcats_effect_tracing_TracingPlatform__isInternalJSCode$1__T__T__T__Z };
/** @constructor */
function $c_Lcats_effect_tracing_TracingPlatform() {
  this.Lcats_effect_tracing_TracingPlatform__f_cache = null;
  this.Lcats_effect_tracing_TracingPlatform__f_function0Property = null;
  this.Lcats_effect_tracing_TracingPlatform__f_function1Property = null;
  this.Lcats_effect_tracing_TracingPlatform__f_calculateTracingEvent = null;
  this.Lcats_effect_tracing_TracingPlatform__f_stackTraceFileNameFilter = null;
  this.Lcats_effect_tracing_TracingPlatform__f_stackTraceMethodNameFilter = null;
}
export { $c_Lcats_effect_tracing_TracingPlatform as $c_Lcats_effect_tracing_TracingPlatform };
$c_Lcats_effect_tracing_TracingPlatform.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_tracing_TracingPlatform.prototype.constructor = $c_Lcats_effect_tracing_TracingPlatform;
/** @constructor */
function $h_Lcats_effect_tracing_TracingPlatform() {
}
export { $h_Lcats_effect_tracing_TracingPlatform as $h_Lcats_effect_tracing_TracingPlatform };
$h_Lcats_effect_tracing_TracingPlatform.prototype = $c_Lcats_effect_tracing_TracingPlatform.prototype;
$c_Lcats_effect_tracing_TracingPlatform.prototype.calculateTracingEvent__F0__Lcats_effect_tracing_TracingEvent = (function(f) {
  return this.Lcats_effect_tracing_TracingPlatform__f_calculateTracingEvent.apply__O__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$dp_toString__T(f[this.Lcats_effect_tracing_TracingPlatform__f_function0Property]));
});
$c_Lcats_effect_tracing_TracingPlatform.prototype.calculateTracingEvent__F1__Lcats_effect_tracing_TracingEvent = (function(f) {
  return this.Lcats_effect_tracing_TracingPlatform__f_calculateTracingEvent.apply__O__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$dp_toString__T(f[this.Lcats_effect_tracing_TracingPlatform__f_function1Property]));
});
$c_Lcats_effect_tracing_TracingPlatform.prototype.applyStackTraceFilter__T__T__T__Z = (function(callSiteClassName, callSiteMethodName, callSiteFileName) {
  return ($p_Lcats_effect_tracing_TracingPlatform__isInternalJSCode$1__T__T__T__Z(this, callSiteClassName, callSiteMethodName, callSiteFileName) || this.isInternalClass__T__Z(callSiteClassName));
});
$c_Lcats_effect_tracing_TracingPlatform.prototype.decodeMethodName__T__T = (function(name) {
  var junk = (name.indexOf("__") | 0);
  return $m_s_reflect_NameTransformer$().decode__T__T(((junk === (-1)) ? name : name.substring(0, junk)));
});
/** @constructor */
function $c_Lcats_effect_unsafe_FiberMonitor$() {
}
export { $c_Lcats_effect_unsafe_FiberMonitor$ as $c_Lcats_effect_unsafe_FiberMonitor$ };
$c_Lcats_effect_unsafe_FiberMonitor$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_unsafe_FiberMonitor$.prototype.constructor = $c_Lcats_effect_unsafe_FiberMonitor$;
/** @constructor */
function $h_Lcats_effect_unsafe_FiberMonitor$() {
}
export { $h_Lcats_effect_unsafe_FiberMonitor$ as $h_Lcats_effect_unsafe_FiberMonitor$ };
$h_Lcats_effect_unsafe_FiberMonitor$.prototype = $c_Lcats_effect_unsafe_FiberMonitor$.prototype;
$c_Lcats_effect_unsafe_FiberMonitor$.prototype.apply__s_concurrent_ExecutionContext__Lcats_effect_unsafe_FiberMonitor = (function(compute) {
  return new $c_Lcats_effect_unsafe_NoOpFiberMonitor();
});
var $d_Lcats_effect_unsafe_FiberMonitor$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_unsafe_FiberMonitor$, "cats.effect.unsafe.FiberMonitor$", ({
  Lcats_effect_unsafe_FiberMonitor$: 1
}));
export { $d_Lcats_effect_unsafe_FiberMonitor$ as $d_Lcats_effect_unsafe_FiberMonitor$ };
var $n_Lcats_effect_unsafe_FiberMonitor$;
function $m_Lcats_effect_unsafe_FiberMonitor$() {
  if ((!$n_Lcats_effect_unsafe_FiberMonitor$)) {
    $n_Lcats_effect_unsafe_FiberMonitor$ = new $c_Lcats_effect_unsafe_FiberMonitor$();
  }
  return $n_Lcats_effect_unsafe_FiberMonitor$;
}
export { $m_Lcats_effect_unsafe_FiberMonitor$ as $m_Lcats_effect_unsafe_FiberMonitor$ };
function $ct_Lcats_effect_unsafe_FiberMonitorShared__($thiz) {
  $thiz.Lcats_effect_unsafe_FiberMonitorShared__f_newline = "\n";
  return $thiz;
}
export { $ct_Lcats_effect_unsafe_FiberMonitorShared__ as $ct_Lcats_effect_unsafe_FiberMonitorShared__ };
/** @constructor */
function $c_Lcats_effect_unsafe_FiberMonitorShared() {
  this.Lcats_effect_unsafe_FiberMonitorShared__f_newline = null;
}
export { $c_Lcats_effect_unsafe_FiberMonitorShared as $c_Lcats_effect_unsafe_FiberMonitorShared };
$c_Lcats_effect_unsafe_FiberMonitorShared.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_unsafe_FiberMonitorShared.prototype.constructor = $c_Lcats_effect_unsafe_FiberMonitorShared;
/** @constructor */
function $h_Lcats_effect_unsafe_FiberMonitorShared() {
}
export { $h_Lcats_effect_unsafe_FiberMonitorShared as $h_Lcats_effect_unsafe_FiberMonitorShared };
$h_Lcats_effect_unsafe_FiberMonitorShared.prototype = $c_Lcats_effect_unsafe_FiberMonitorShared.prototype;
/** @constructor */
function $c_Lcats_effect_unsafe_IORuntime(compute, blocking, scheduler, pollers, fiberMonitor, shutdown, config, metrics) {
  this.Lcats_effect_unsafe_IORuntime__f_compute = null;
  this.Lcats_effect_unsafe_IORuntime__f_blocking = null;
  this.Lcats_effect_unsafe_IORuntime__f_scheduler = null;
  this.Lcats_effect_unsafe_IORuntime__f_fiberMonitor = null;
  this.Lcats_effect_unsafe_IORuntime__f_shutdown = null;
  this.Lcats_effect_unsafe_IORuntime__f_config = null;
  this.Lcats_effect_unsafe_IORuntime__f_fiberErrorCbs = null;
  this.Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold = 0;
  this.Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold = 0;
  this.Lcats_effect_unsafe_IORuntime__f_enhancedExceptions = false;
  this.Lcats_effect_unsafe_IORuntime__f_traceBufferLogSize = 0;
  this.Lcats_effect_unsafe_IORuntime__f_compute = compute;
  this.Lcats_effect_unsafe_IORuntime__f_blocking = blocking;
  this.Lcats_effect_unsafe_IORuntime__f_scheduler = scheduler;
  this.Lcats_effect_unsafe_IORuntime__f_fiberMonitor = fiberMonitor;
  this.Lcats_effect_unsafe_IORuntime__f_shutdown = shutdown;
  this.Lcats_effect_unsafe_IORuntime__f_config = config;
  this.Lcats_effect_unsafe_IORuntime__f_fiberErrorCbs = new $c_Lcats_effect_unsafe_StripedHashtable();
  this.Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold = config.Lcats_effect_unsafe_IORuntimeConfig__f_cancelationCheckThreshold;
  this.Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold = config.Lcats_effect_unsafe_IORuntimeConfig__f_autoYieldThreshold;
  this.Lcats_effect_unsafe_IORuntime__f_enhancedExceptions = config.Lcats_effect_unsafe_IORuntimeConfig__f_enhancedExceptions;
  this.Lcats_effect_unsafe_IORuntime__f_traceBufferLogSize = config.Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferLogSize;
}
export { $c_Lcats_effect_unsafe_IORuntime as $c_Lcats_effect_unsafe_IORuntime };
$c_Lcats_effect_unsafe_IORuntime.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_unsafe_IORuntime.prototype.constructor = $c_Lcats_effect_unsafe_IORuntime;
/** @constructor */
function $h_Lcats_effect_unsafe_IORuntime() {
}
export { $h_Lcats_effect_unsafe_IORuntime as $h_Lcats_effect_unsafe_IORuntime };
$h_Lcats_effect_unsafe_IORuntime.prototype = $c_Lcats_effect_unsafe_IORuntime.prototype;
$c_Lcats_effect_unsafe_IORuntime.prototype.toString__T = (function() {
  return (((((("IORuntime(" + this.Lcats_effect_unsafe_IORuntime__f_compute) + ", ") + this.Lcats_effect_unsafe_IORuntime__f_scheduler) + ", ") + this.Lcats_effect_unsafe_IORuntime__f_config) + ")");
});
function $isArrayOf_Lcats_effect_unsafe_IORuntime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_unsafe_IORuntime)));
}
export { $isArrayOf_Lcats_effect_unsafe_IORuntime as $isArrayOf_Lcats_effect_unsafe_IORuntime };
var $d_Lcats_effect_unsafe_IORuntime = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_unsafe_IORuntime, "cats.effect.unsafe.IORuntime", ({
  Lcats_effect_unsafe_IORuntime: 1
}));
export { $d_Lcats_effect_unsafe_IORuntime as $d_Lcats_effect_unsafe_IORuntime };
function $ct_Lcats_effect_unsafe_IORuntimeCompanionPlatform__($thiz) {
  $thiz.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global = null;
  return $thiz;
}
export { $ct_Lcats_effect_unsafe_IORuntimeCompanionPlatform__ as $ct_Lcats_effect_unsafe_IORuntimeCompanionPlatform__ };
/** @constructor */
function $c_Lcats_effect_unsafe_IORuntimeCompanionPlatform() {
  this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global = null;
}
export { $c_Lcats_effect_unsafe_IORuntimeCompanionPlatform as $c_Lcats_effect_unsafe_IORuntimeCompanionPlatform };
$c_Lcats_effect_unsafe_IORuntimeCompanionPlatform.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_unsafe_IORuntimeCompanionPlatform.prototype.constructor = $c_Lcats_effect_unsafe_IORuntimeCompanionPlatform;
/** @constructor */
function $h_Lcats_effect_unsafe_IORuntimeCompanionPlatform() {
}
export { $h_Lcats_effect_unsafe_IORuntimeCompanionPlatform as $h_Lcats_effect_unsafe_IORuntimeCompanionPlatform };
$h_Lcats_effect_unsafe_IORuntimeCompanionPlatform.prototype = $c_Lcats_effect_unsafe_IORuntimeCompanionPlatform.prototype;
$c_Lcats_effect_unsafe_IORuntimeCompanionPlatform.prototype.createBatchingMacrotaskExecutor$default$2__F1 = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => {
    _$1.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err);
  }));
});
$c_Lcats_effect_unsafe_IORuntimeCompanionPlatform.prototype.resetGlobal__V = (function() {
  this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global = null;
});
$c_Lcats_effect_unsafe_IORuntimeCompanionPlatform.prototype.global__Lcats_effect_unsafe_IORuntime = (function() {
  if ((this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global === null)) {
    if ((this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global === null)) {
      var this$3 = $m_Lcats_effect_unsafe_IORuntime$();
      var reportFailure = this.createBatchingMacrotaskExecutor$default$2__F1();
      var compute = new $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor(64, reportFailure);
      var reportFailure$1 = this.createBatchingMacrotaskExecutor$default$2__F1();
      var blocking = new $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor(64, reportFailure$1);
      var scheduler = $m_Lcats_effect_unsafe_Scheduler$().createDefaultScheduler__T2()._1__O();
      var shutdown = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
        this.resetGlobal__V();
      }));
      var this$2 = $m_Lcats_effect_unsafe_IORuntimeConfig$();
      var config = this$2.Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform__f_Default;
      this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global = this$3.apply__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__sci_List__F0__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_IORuntime(compute, blocking, scheduler, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$(), shutdown, config);
    }
  }
  return this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global;
});
$c_Lcats_effect_unsafe_IORuntimeCompanionPlatform.prototype.registerFiberMonitorMBean__Lcats_effect_unsafe_FiberMonitor__F0 = (function(fiberMonitor) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => (void 0)));
});
function $ct_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform__($thiz) {
  var this$1 = $m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_CANCELATION_CHECK_THRESHOLD");
  if (this$1.isEmpty__Z()) {
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0 = this$1.get__O();
    try {
      var this$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Integer$();
      var r1 = this$5.java$lang$Integer$$parseIntImpl__T__I__I__I(x0, 10, 214748364);
      var $x_2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(r1);
    } catch (e) {
      var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
      matchEnd8: {
        var $x_2;
        if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
          var $x_2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(e$2);
          break matchEnd8;
        }
        throw ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
      }
    }
    var $x_1 = $x_2.toOption__s_Option();
  }
  var this$6 = $x_1;
  var cancelationCheckThreshold = ((this$6.isEmpty__Z() ? 512 : this$6.get__O()) | 0);
  var this$7 = $m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_AUTO_YIELD_THRESHOLD_MULTIPLIER");
  if (this$7.isEmpty__Z()) {
    var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0$1 = this$7.get__O();
    try {
      var this$11 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Integer$();
      var r1$1 = this$11.java$lang$Integer$$parseIntImpl__T__I__I__I(x0$1, 10, 214748364);
      var $x_4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(r1$1);
    } catch (e$1) {
      var e$2$1 = ((e$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e$1 : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e$1));
      matchEnd8$1: {
        var $x_4;
        if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2$1)) {
          var $x_4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(e$2$1);
          break matchEnd8$1;
        }
        throw ((e$2$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2$1.sjs_js_JavaScriptException__f_exception : e$2$1);
      }
    }
    var $x_3 = $x_4.toOption__s_Option();
  }
  var this$12 = $x_3;
  var autoYieldThreshold = Math.imul(((this$12.isEmpty__Z() ? 2 : this$12.get__O()) | 0), cancelationCheckThreshold);
  var this$13 = $m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_TRACING_EXCEPTIONS_ENHANCED");
  if (this$13.isEmpty__Z()) {
    var $x_5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0$2 = this$13.get__O();
    try {
      var r1$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_StringOps$().toBooleanImpl$extension__T__T__Z(x0$2, x0$2);
      var $x_6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(r1$2);
    } catch (e$3) {
      var e$2$2 = ((e$3 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e$3 : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e$3));
      matchEnd8$2: {
        var $x_6;
        if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2$2)) {
          var $x_6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(e$2$2);
          break matchEnd8$2;
        }
        throw ((e$2$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2$2.sjs_js_JavaScriptException__f_exception : e$2$2);
      }
    }
    var $x_5 = $x_6.toOption__s_Option();
  }
  var this$17 = $x_5;
  var enhancedExceptions = (!(!(this$17.isEmpty__Z() || this$17.get__O())));
  var this$18 = $m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_TRACING_BUFFER_SIZE");
  if (this$18.isEmpty__Z()) {
    var $x_7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0$3 = this$18.get__O();
    try {
      var this$22 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Integer$();
      var r1$3 = this$22.java$lang$Integer$$parseIntImpl__T__I__I__I(x0$3, 10, 214748364);
      var $x_8 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(r1$3);
    } catch (e$4) {
      var e$2$3 = ((e$4 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e$4 : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e$4));
      matchEnd8$3: {
        var $x_8;
        if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2$3)) {
          var $x_8 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(e$2$3);
          break matchEnd8$3;
        }
        throw ((e$2$3 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2$3.sjs_js_JavaScriptException__f_exception : e$2$3);
      }
    }
    var $x_7 = $x_8.toOption__s_Option();
  }
  var this$23 = $x_7;
  var traceBufferSize = ((this$23.isEmpty__Z() ? 16 : this$23.get__O()) | 0);
  var this$24 = $m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_SHUTDOWN_HOOK_TIMEOUT");
  if (this$24.isEmpty__Z()) {
    var $x_9 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0$4 = this$24.get__O();
    try {
      var r1$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$().apply__T__s_concurrent_duration_Duration(x0$4);
      var $x_10 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(r1$4);
    } catch (e$5) {
      var e$2$4 = ((e$5 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e$5 : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e$5));
      matchEnd8$4: {
        var $x_10;
        if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2$4)) {
          var $x_10 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(e$2$4);
          break matchEnd8$4;
        }
        throw ((e$2$4 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2$4.sjs_js_JavaScriptException__f_exception : e$2$4);
      }
    }
    var $x_9 = $x_10.toOption__s_Option();
  }
  var this$26 = $x_9;
  var shutdownHookTimeout = (this$26.isEmpty__Z() ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Inf : this$26.get__O());
  var this$27 = $m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_REPORT_UNHANDLED_FIBER_ERRORS");
  if (this$27.isEmpty__Z()) {
    var $x_11 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0$5 = this$27.get__O();
    try {
      var r1$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_StringOps$().toBooleanImpl$extension__T__T__Z(x0$5, x0$5);
      var $x_12 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(r1$5);
    } catch (e$6) {
      var e$2$5 = ((e$6 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e$6 : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e$6));
      matchEnd8$5: {
        var $x_12;
        if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2$5)) {
          var $x_12 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(e$2$5);
          break matchEnd8$5;
        }
        throw ((e$2$5 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2$5.sjs_js_JavaScriptException__f_exception : e$2$5);
      }
    }
    var $x_11 = $x_12.toOption__s_Option();
  }
  var this$31 = $x_11;
  var reportUnhandledFiberErrors = (!(!(this$31.isEmpty__Z() || this$31.get__O())));
  var this$32 = $m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_CPU_STARVATION_CHECK_INTERVAL");
  if (this$32.isEmpty__Z()) {
    var this$33 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0$6 = this$32.get__O();
    var this$33 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$().apply__T__s_concurrent_duration_Duration(x0$6));
  }
  if (this$33.isEmpty__Z()) {
    var $x_13 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0$7 = this$33.get__O();
    try {
      var $x_14 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(x0$7);
    } catch (e$7) {
      var e$2$6 = ((e$7 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e$7 : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e$7));
      matchEnd8$6: {
        var $x_14;
        if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2$6)) {
          var $x_14 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(e$2$6);
          break matchEnd8$6;
        }
        throw ((e$2$6 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2$6.sjs_js_JavaScriptException__f_exception : e$2$6);
      }
    }
    var $x_13 = $x_14.toOption__s_Option();
  }
  var this$35 = $x_13;
  var cpuStarvationCheckInterval = (this$35.isEmpty__Z() ? $thiz.DefaultCpuStarvationCheckInterval__s_concurrent_duration_FiniteDuration() : this$35.get__O());
  var this$36 = $m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_CPU_STARVATION_CHECK_INITIAL_DELAY");
  if (this$36.isEmpty__Z()) {
    var this$37 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0$8 = this$36.get__O();
    var this$37 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$().apply__T__s_concurrent_duration_Duration(x0$8));
  }
  var cpuStarvationCheckInitialDelay = (this$37.isEmpty__Z() ? $thiz.DefaultCpuStarvationCheckInitialDelay__s_concurrent_duration_FiniteDuration() : this$37.get__O());
  var this$38 = $m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_CPU_STARVATION_CHECK_THRESHOLD");
  if (this$38.isEmpty__Z()) {
    var $x_15 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0$9 = this$38.get__O();
    try {
      var r1$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Double$().parseDouble__T__D(x0$9);
      var $x_16 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(r1$6);
    } catch (e$8) {
      var e$2$7 = ((e$8 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e$8 : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e$8));
      matchEnd8$7: {
        var $x_16;
        if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2$7)) {
          var $x_16 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(e$2$7);
          break matchEnd8$7;
        }
        throw ((e$2$7 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2$7.sjs_js_JavaScriptException__f_exception : e$2$7);
      }
    }
    var $x_15 = $x_16.toOption__s_Option();
  }
  var this$42 = $x_15;
  var cpuStarvationCheckThreshold = (+(this$42.isEmpty__Z() ? 0.1 : this$42.get__O()));
  $thiz.Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform__f_Default = $thiz.apply__I__I__Z__I__s_concurrent_duration_Duration__Z__s_concurrent_duration_FiniteDuration__s_concurrent_duration_Duration__D__Lcats_effect_unsafe_IORuntimeConfig(cancelationCheckThreshold, autoYieldThreshold, enhancedExceptions, traceBufferSize, shutdownHookTimeout, reportUnhandledFiberErrors, cpuStarvationCheckInterval, cpuStarvationCheckInitialDelay, cpuStarvationCheckThreshold);
  return $thiz;
}
export { $ct_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform__ as $ct_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform__ };
/** @constructor */
function $c_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform() {
  this.Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform__f_Default = null;
}
export { $c_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform as $c_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform };
$c_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform.prototype.constructor = $c_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform;
/** @constructor */
function $h_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform() {
}
export { $h_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform as $h_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform };
$h_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform.prototype = $c_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform.prototype;
/** @constructor */
function $c_Lcats_effect_unsafe_JSArrayQueue() {
  this.Lcats_effect_unsafe_JSArrayQueue__f_buffer = null;
  this.Lcats_effect_unsafe_JSArrayQueue__f_startIndex = 0;
  this.Lcats_effect_unsafe_JSArrayQueue__f_endIndex = 0;
  this.Lcats_effect_unsafe_JSArrayQueue__f_empty = false;
  this.Lcats_effect_unsafe_JSArrayQueue__f_buffer = [null];
  this.Lcats_effect_unsafe_JSArrayQueue__f_startIndex = 0;
  this.Lcats_effect_unsafe_JSArrayQueue__f_endIndex = 1;
  this.Lcats_effect_unsafe_JSArrayQueue__f_empty = true;
}
export { $c_Lcats_effect_unsafe_JSArrayQueue as $c_Lcats_effect_unsafe_JSArrayQueue };
$c_Lcats_effect_unsafe_JSArrayQueue.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_unsafe_JSArrayQueue.prototype.constructor = $c_Lcats_effect_unsafe_JSArrayQueue;
/** @constructor */
function $h_Lcats_effect_unsafe_JSArrayQueue() {
}
export { $h_Lcats_effect_unsafe_JSArrayQueue as $h_Lcats_effect_unsafe_JSArrayQueue };
$h_Lcats_effect_unsafe_JSArrayQueue.prototype = $c_Lcats_effect_unsafe_JSArrayQueue.prototype;
var $d_Lcats_effect_unsafe_JSArrayQueue = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_unsafe_JSArrayQueue, "cats.effect.unsafe.JSArrayQueue", ({
  Lcats_effect_unsafe_JSArrayQueue: 1
}));
export { $d_Lcats_effect_unsafe_JSArrayQueue as $d_Lcats_effect_unsafe_JSArrayQueue };
function $ct_Lcats_effect_unsafe_SchedulerCompanionPlatform__($thiz) {
  var this$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_package$DurationInt(2147483647);
  var unit = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
  var this$ = this$2.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$();
  var hi = (this$ >> 31);
  $thiz.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$maxTimeout = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_FiniteDuration(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(this$, hi), unit);
  if (((typeof clearTimeout) === "function")) {
    var $x_1 = ((handle) => new $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1(handle, $thiz));
  } else {
    var noop = new $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2($thiz);
    var $x_1 = ((_$1) => noop);
  }
  $thiz.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$mkCancelRunnable = $x_1;
  var this$7 = $ps_Lcats_effect_unsafe_SchedulerCompanionPlatform__browsers$1__s_Option();
  var this$8 = (this$7.isEmpty__Z() ? $ps_Lcats_effect_unsafe_SchedulerCompanionPlatform__nodeJS$1__s_Option() : this$7);
  if (this$8.isEmpty__Z()) {
    var this$10 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0 = this$8.get__O();
    var this$10 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some((() => {
      var value = (1000.0 * ((+x0.timeOrigin) + (+x0.now())));
      var this$9 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_RTLong$();
      var lo = this$9.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
      var hi$1 = this$9.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi$1);
    }));
  }
  $thiz.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$nowMicrosImpl = (this$10.isEmpty__Z() ? (() => {
    var value$1 = (+Date.now());
    var this$12 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_RTLong$();
    var lo$1 = this$12.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value$1);
    var hi$2 = this$12.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var b0 = (65535 & lo$1);
    var b1 = ((lo$1 >>> 16) | 0);
    var a0b0 = Math.imul(1000, b0);
    var a0b1 = Math.imul(1000, b1);
    var lo$2 = ((a0b0 + (a0b1 << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$3 = ((Math.imul(1000, hi$2) + ((c1part >>> 16) | 0)) | 0);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$2, hi$3);
  }) : this$10.get__O());
  return $thiz;
}
export { $ct_Lcats_effect_unsafe_SchedulerCompanionPlatform__ as $ct_Lcats_effect_unsafe_SchedulerCompanionPlatform__ };
function $ps_Lcats_effect_unsafe_SchedulerCompanionPlatform__test$1__Lcats_effect_unsafe_Performance__Z(performance) {
  var x = ((+performance.timeOrigin) + (+performance.now()));
  return (!(x !== x));
}
export { $ps_Lcats_effect_unsafe_SchedulerCompanionPlatform__test$1__Lcats_effect_unsafe_Performance__Z as $ps_Lcats_effect_unsafe_SchedulerCompanionPlatform__test$1__Lcats_effect_unsafe_Performance__Z };
function $ps_Lcats_effect_unsafe_SchedulerCompanionPlatform__browsers$1__s_Option() {
  try {
    var x = performance;
    var r1 = (((x === (void 0)) || $ps_Lcats_effect_unsafe_SchedulerCompanionPlatform__test$1__Lcats_effect_unsafe_Performance__Z(x)) ? x : (void 0));
    var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(r1);
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
    matchEnd8: {
      var $x_1;
      if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(e$2);
        break matchEnd8;
      }
      throw ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  }
  var this$7 = $x_1.toOption__s_Option();
  if (this$7.isEmpty__Z()) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0 = this$7.get__O();
    return ((x0 === (void 0)) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$() : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(x0));
  }
}
export { $ps_Lcats_effect_unsafe_SchedulerCompanionPlatform__browsers$1__s_Option as $ps_Lcats_effect_unsafe_SchedulerCompanionPlatform__browsers$1__s_Option };
function $ps_Lcats_effect_unsafe_SchedulerCompanionPlatform__nodeJS$1__s_Option() {
  try {
    var x = require("perf_hooks").performance;
    var r1 = (((x === (void 0)) || $ps_Lcats_effect_unsafe_SchedulerCompanionPlatform__test$1__Lcats_effect_unsafe_Performance__Z(x)) ? x : (void 0));
    var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(r1);
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
    matchEnd8: {
      var $x_1;
      if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(e$2);
        break matchEnd8;
      }
      throw ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  }
  var this$8 = $x_1.toOption__s_Option();
  if (this$8.isEmpty__Z()) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0 = this$8.get__O();
    return ((x0 === (void 0)) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$() : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(x0));
  }
}
export { $ps_Lcats_effect_unsafe_SchedulerCompanionPlatform__nodeJS$1__s_Option as $ps_Lcats_effect_unsafe_SchedulerCompanionPlatform__nodeJS$1__s_Option };
/** @constructor */
function $c_Lcats_effect_unsafe_SchedulerCompanionPlatform() {
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$maxTimeout = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$mkCancelRunnable = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$nowMicrosImpl = null;
}
export { $c_Lcats_effect_unsafe_SchedulerCompanionPlatform as $c_Lcats_effect_unsafe_SchedulerCompanionPlatform };
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform.prototype.constructor = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform;
/** @constructor */
function $h_Lcats_effect_unsafe_SchedulerCompanionPlatform() {
}
export { $h_Lcats_effect_unsafe_SchedulerCompanionPlatform as $h_Lcats_effect_unsafe_SchedulerCompanionPlatform };
$h_Lcats_effect_unsafe_SchedulerCompanionPlatform.prototype = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform.prototype;
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform.prototype.createDefaultScheduler__T2 = (function() {
  var _1 = new $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3(this);
  var _2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => (void 0)));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, _2);
});
/** @constructor */
function $c_Lcats_effect_unsafe_StripedHashtable() {
  this.Lcats_effect_unsafe_StripedHashtable__f_log2NumTables = 0;
  this.Lcats_effect_unsafe_StripedHashtable__f_mask = 0;
  this.Lcats_effect_unsafe_StripedHashtable__f_tables = null;
  this.Lcats_effect_unsafe_StripedHashtable__f_log2NumTables = $m_Lcats_effect_unsafe_StripedHashtable$().Lcats_effect_unsafe_StripedHashtable$__f_log2NumTables;
  this.Lcats_effect_unsafe_StripedHashtable__f_mask = (((-1) + this.numTables__I()) | 0);
  var dimensions = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I(new Int32Array([this.numTables__I()]));
  var array = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Lcats_effect_unsafe_ThreadSafeHashtable.getClassOf(), dimensions);
  var i = 0;
  while ((i < this.numTables__I())) {
    array.u[i] = new $c_Lcats_effect_unsafe_ThreadSafeHashtable(8);
    i = ((1 + i) | 0);
  }
  this.Lcats_effect_unsafe_StripedHashtable__f_tables = array;
}
export { $c_Lcats_effect_unsafe_StripedHashtable as $c_Lcats_effect_unsafe_StripedHashtable };
$c_Lcats_effect_unsafe_StripedHashtable.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_unsafe_StripedHashtable.prototype.constructor = $c_Lcats_effect_unsafe_StripedHashtable;
/** @constructor */
function $h_Lcats_effect_unsafe_StripedHashtable() {
}
export { $h_Lcats_effect_unsafe_StripedHashtable as $h_Lcats_effect_unsafe_StripedHashtable };
$h_Lcats_effect_unsafe_StripedHashtable.prototype = $c_Lcats_effect_unsafe_StripedHashtable.prototype;
$c_Lcats_effect_unsafe_StripedHashtable.prototype.numTables__I = (function() {
  return (1 << this.Lcats_effect_unsafe_StripedHashtable__f_log2NumTables);
});
$c_Lcats_effect_unsafe_StripedHashtable.prototype.put__F1__V = (function(cb) {
  var hash = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$systemIdentityHashCode(cb);
  var idx = (hash & this.Lcats_effect_unsafe_StripedHashtable__f_mask);
  this.Lcats_effect_unsafe_StripedHashtable__f_tables.u[idx].put__O__I__V(cb, (hash >> this.Lcats_effect_unsafe_StripedHashtable__f_log2NumTables));
});
$c_Lcats_effect_unsafe_StripedHashtable.prototype.remove__F1__V = (function(cb) {
  var hash = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$systemIdentityHashCode(cb);
  var idx = (hash & this.Lcats_effect_unsafe_StripedHashtable__f_mask);
  this.Lcats_effect_unsafe_StripedHashtable__f_tables.u[idx].remove__O__I__V(cb, (hash >> this.Lcats_effect_unsafe_StripedHashtable__f_log2NumTables));
});
var $d_Lcats_effect_unsafe_StripedHashtable = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_unsafe_StripedHashtable, "cats.effect.unsafe.StripedHashtable", ({
  Lcats_effect_unsafe_StripedHashtable: 1
}));
export { $d_Lcats_effect_unsafe_StripedHashtable as $d_Lcats_effect_unsafe_StripedHashtable };
function $p_Lcats_effect_unsafe_StripedHashtable$__minNumTables__I($thiz) {
  return 4;
}
export { $p_Lcats_effect_unsafe_StripedHashtable$__minNumTables__I as $p_Lcats_effect_unsafe_StripedHashtable$__minNumTables__I };
/** @constructor */
function $c_Lcats_effect_unsafe_StripedHashtable$() {
  this.Lcats_effect_unsafe_StripedHashtable$__f_log2NumTables = 0;
  $n_Lcats_effect_unsafe_StripedHashtable$ = this;
  var result = 0;
  var x = $p_Lcats_effect_unsafe_StripedHashtable$__minNumTables__I(this);
  while ((x !== 0)) {
    result = ((1 + result) | 0);
    x = (x >> 1);
  }
  this.Lcats_effect_unsafe_StripedHashtable$__f_log2NumTables = result;
}
export { $c_Lcats_effect_unsafe_StripedHashtable$ as $c_Lcats_effect_unsafe_StripedHashtable$ };
$c_Lcats_effect_unsafe_StripedHashtable$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_unsafe_StripedHashtable$.prototype.constructor = $c_Lcats_effect_unsafe_StripedHashtable$;
/** @constructor */
function $h_Lcats_effect_unsafe_StripedHashtable$() {
}
export { $h_Lcats_effect_unsafe_StripedHashtable$ as $h_Lcats_effect_unsafe_StripedHashtable$ };
$h_Lcats_effect_unsafe_StripedHashtable$.prototype = $c_Lcats_effect_unsafe_StripedHashtable$.prototype;
var $d_Lcats_effect_unsafe_StripedHashtable$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_unsafe_StripedHashtable$, "cats.effect.unsafe.StripedHashtable$", ({
  Lcats_effect_unsafe_StripedHashtable$: 1
}));
export { $d_Lcats_effect_unsafe_StripedHashtable$ as $d_Lcats_effect_unsafe_StripedHashtable$ };
var $n_Lcats_effect_unsafe_StripedHashtable$;
function $m_Lcats_effect_unsafe_StripedHashtable$() {
  if ((!$n_Lcats_effect_unsafe_StripedHashtable$)) {
    $n_Lcats_effect_unsafe_StripedHashtable$ = new $c_Lcats_effect_unsafe_StripedHashtable$();
  }
  return $n_Lcats_effect_unsafe_StripedHashtable$;
}
export { $m_Lcats_effect_unsafe_StripedHashtable$ as $m_Lcats_effect_unsafe_StripedHashtable$ };
function $p_Lcats_effect_unsafe_ThreadSafeHashtable__insert__AO__I__O__I__V($thiz, table, mask, a, hash) {
  var idx = (hash & mask);
  var remaining = mask;
  while ((remaining >= 0)) {
    var cur = table.u[idx];
    if (((cur === null) || Object.is(cur, $thiz.Lcats_effect_unsafe_ThreadSafeHashtable__f_Tombstone))) {
      table.u[idx] = a;
      return (void 0);
    } else {
      idx = (((1 + idx) | 0) & mask);
    }
    remaining = (((-1) + remaining) | 0);
  }
}
export { $p_Lcats_effect_unsafe_ThreadSafeHashtable__insert__AO__I__O__I__V as $p_Lcats_effect_unsafe_ThreadSafeHashtable__insert__AO__I__O__I__V };
/** @constructor */
function $c_Lcats_effect_unsafe_ThreadSafeHashtable(initialCapacity) {
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_initialCapacity = 0;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable = null;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_size = 0;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_mask = 0;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_capacity = 0;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_log2NumTables = 0;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_Tombstone = null;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_initialCapacity = initialCapacity;
  var dimensions = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I(new Int32Array([initialCapacity]));
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_reflect_Array$().newInstance__jl_Class__AI__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_O.getClassOf(), dimensions);
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_size = 0;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_mask = (((-1) + initialCapacity) | 0);
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_capacity = initialCapacity;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_log2NumTables = $m_Lcats_effect_unsafe_StripedHashtable$().Lcats_effect_unsafe_StripedHashtable$__f_log2NumTables;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_Tombstone = $m_Lcats_effect_unsafe_ThreadSafeHashtable$().Lcats_effect_unsafe_ThreadSafeHashtable$__f_Tombstone;
}
export { $c_Lcats_effect_unsafe_ThreadSafeHashtable as $c_Lcats_effect_unsafe_ThreadSafeHashtable };
$c_Lcats_effect_unsafe_ThreadSafeHashtable.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_unsafe_ThreadSafeHashtable.prototype.constructor = $c_Lcats_effect_unsafe_ThreadSafeHashtable;
/** @constructor */
function $h_Lcats_effect_unsafe_ThreadSafeHashtable() {
}
export { $h_Lcats_effect_unsafe_ThreadSafeHashtable as $h_Lcats_effect_unsafe_ThreadSafeHashtable };
$h_Lcats_effect_unsafe_ThreadSafeHashtable.prototype = $c_Lcats_effect_unsafe_ThreadSafeHashtable.prototype;
$c_Lcats_effect_unsafe_ThreadSafeHashtable.prototype.put__O__I__V = (function(a, hash) {
  var sz = this.Lcats_effect_unsafe_ThreadSafeHashtable__f_size;
  var cap = this.Lcats_effect_unsafe_ThreadSafeHashtable__f_capacity;
  if (((sz << 1) >= cap)) {
    var newCap = (cap << 1);
    var newMask = (((-1) + newCap) | 0);
    var dimensions = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I(new Int32Array([newCap]));
    var newHashtable = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_reflect_Array$().newInstance__jl_Class__AI__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_O.getClassOf(), dimensions);
    var table = this.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable;
    var i = 0;
    while ((i < cap)) {
      var cur = table.u[i];
      if (((cur !== null) && (!Object.is(cur, this.Lcats_effect_unsafe_ThreadSafeHashtable__f_Tombstone)))) {
        $p_Lcats_effect_unsafe_ThreadSafeHashtable__insert__AO__I__O__I__V(this, newHashtable, newMask, cur, ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$systemIdentityHashCode(cur) >> this.Lcats_effect_unsafe_ThreadSafeHashtable__f_log2NumTables));
      }
      i = ((1 + i) | 0);
    }
    this.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable = newHashtable;
    this.Lcats_effect_unsafe_ThreadSafeHashtable__f_mask = newMask;
    this.Lcats_effect_unsafe_ThreadSafeHashtable__f_capacity = newCap;
  }
  $p_Lcats_effect_unsafe_ThreadSafeHashtable__insert__AO__I__O__I__V(this, this.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable, this.Lcats_effect_unsafe_ThreadSafeHashtable__f_mask, a, hash);
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_size = ((1 + sz) | 0);
});
$c_Lcats_effect_unsafe_ThreadSafeHashtable.prototype.remove__O__I__V = (function(a, hash) {
  var msk = this.Lcats_effect_unsafe_ThreadSafeHashtable__f_mask;
  var init = (hash & msk);
  var idx = init;
  var table = this.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable;
  var remaining = msk;
  while ((remaining >= 0)) {
    var cur = table.u[idx];
    if (Object.is(a, cur)) {
      table.u[idx] = this.Lcats_effect_unsafe_ThreadSafeHashtable__f_Tombstone;
      this.Lcats_effect_unsafe_ThreadSafeHashtable__f_size = (((-1) + this.Lcats_effect_unsafe_ThreadSafeHashtable__f_size) | 0);
      var sz = this.Lcats_effect_unsafe_ThreadSafeHashtable__f_size;
      var cap = this.Lcats_effect_unsafe_ThreadSafeHashtable__f_capacity;
      if (((cap > this.Lcats_effect_unsafe_ThreadSafeHashtable__f_initialCapacity) && ((sz << 2) < cap))) {
        var newCap = ((cap >>> 1) | 0);
        var newMask = (((-1) + newCap) | 0);
        var dimensions = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I(new Int32Array([newCap]));
        var newHashtable = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_reflect_Array$().newInstance__jl_Class__AI__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_O.getClassOf(), dimensions);
        var table$2 = this.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable;
        var i = 0;
        while ((i < cap)) {
          var cur$2 = table$2.u[i];
          if (((cur$2 !== null) && (!Object.is(cur$2, this.Lcats_effect_unsafe_ThreadSafeHashtable__f_Tombstone)))) {
            $p_Lcats_effect_unsafe_ThreadSafeHashtable__insert__AO__I__O__I__V(this, newHashtable, newMask, cur$2, ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$systemIdentityHashCode(cur$2) >> this.Lcats_effect_unsafe_ThreadSafeHashtable__f_log2NumTables));
          }
          i = ((1 + i) | 0);
        }
        this.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable = newHashtable;
        this.Lcats_effect_unsafe_ThreadSafeHashtable__f_mask = newMask;
        this.Lcats_effect_unsafe_ThreadSafeHashtable__f_capacity = newCap;
      }
      return (void 0);
    } else if ((cur !== null)) {
      idx = (((1 + idx) | 0) & msk);
    } else {
      return (void 0);
    }
    remaining = (((-1) + remaining) | 0);
  }
});
var $d_Lcats_effect_unsafe_ThreadSafeHashtable = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_unsafe_ThreadSafeHashtable, "cats.effect.unsafe.ThreadSafeHashtable", ({
  Lcats_effect_unsafe_ThreadSafeHashtable: 1
}));
export { $d_Lcats_effect_unsafe_ThreadSafeHashtable as $d_Lcats_effect_unsafe_ThreadSafeHashtable };
/** @constructor */
function $c_Lcats_effect_unsafe_ThreadSafeHashtable$() {
  this.Lcats_effect_unsafe_ThreadSafeHashtable$__f_Tombstone = null;
  $n_Lcats_effect_unsafe_ThreadSafeHashtable$ = this;
  this.Lcats_effect_unsafe_ThreadSafeHashtable$__f_Tombstone = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_O());
}
export { $c_Lcats_effect_unsafe_ThreadSafeHashtable$ as $c_Lcats_effect_unsafe_ThreadSafeHashtable$ };
$c_Lcats_effect_unsafe_ThreadSafeHashtable$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_unsafe_ThreadSafeHashtable$.prototype.constructor = $c_Lcats_effect_unsafe_ThreadSafeHashtable$;
/** @constructor */
function $h_Lcats_effect_unsafe_ThreadSafeHashtable$() {
}
export { $h_Lcats_effect_unsafe_ThreadSafeHashtable$ as $h_Lcats_effect_unsafe_ThreadSafeHashtable$ };
$h_Lcats_effect_unsafe_ThreadSafeHashtable$.prototype = $c_Lcats_effect_unsafe_ThreadSafeHashtable$.prototype;
var $d_Lcats_effect_unsafe_ThreadSafeHashtable$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_unsafe_ThreadSafeHashtable$, "cats.effect.unsafe.ThreadSafeHashtable$", ({
  Lcats_effect_unsafe_ThreadSafeHashtable$: 1
}));
export { $d_Lcats_effect_unsafe_ThreadSafeHashtable$ as $d_Lcats_effect_unsafe_ThreadSafeHashtable$ };
var $n_Lcats_effect_unsafe_ThreadSafeHashtable$;
function $m_Lcats_effect_unsafe_ThreadSafeHashtable$() {
  if ((!$n_Lcats_effect_unsafe_ThreadSafeHashtable$)) {
    $n_Lcats_effect_unsafe_ThreadSafeHashtable$ = new $c_Lcats_effect_unsafe_ThreadSafeHashtable$();
  }
  return $n_Lcats_effect_unsafe_ThreadSafeHashtable$;
}
export { $m_Lcats_effect_unsafe_ThreadSafeHashtable$ as $m_Lcats_effect_unsafe_ThreadSafeHashtable$ };
/** @constructor */
function $c_Lcats_effect_unsafe_metrics_CpuStarvationSampler(counter, clockDriftCurrent, clockDriftMax) {
}
export { $c_Lcats_effect_unsafe_metrics_CpuStarvationSampler as $c_Lcats_effect_unsafe_metrics_CpuStarvationSampler };
$c_Lcats_effect_unsafe_metrics_CpuStarvationSampler.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_unsafe_metrics_CpuStarvationSampler.prototype.constructor = $c_Lcats_effect_unsafe_metrics_CpuStarvationSampler;
/** @constructor */
function $h_Lcats_effect_unsafe_metrics_CpuStarvationSampler() {
}
export { $h_Lcats_effect_unsafe_metrics_CpuStarvationSampler as $h_Lcats_effect_unsafe_metrics_CpuStarvationSampler };
$h_Lcats_effect_unsafe_metrics_CpuStarvationSampler.prototype = $c_Lcats_effect_unsafe_metrics_CpuStarvationSampler.prototype;
var $d_Lcats_effect_unsafe_metrics_CpuStarvationSampler = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_unsafe_metrics_CpuStarvationSampler, "cats.effect.unsafe.metrics.CpuStarvationSampler", ({
  Lcats_effect_unsafe_metrics_CpuStarvationSampler: 1
}));
export { $d_Lcats_effect_unsafe_metrics_CpuStarvationSampler as $d_Lcats_effect_unsafe_metrics_CpuStarvationSampler };
/** @constructor */
function $c_Lcats_effect_unsafe_metrics_CpuStarvationSampler$() {
}
export { $c_Lcats_effect_unsafe_metrics_CpuStarvationSampler$ as $c_Lcats_effect_unsafe_metrics_CpuStarvationSampler$ };
$c_Lcats_effect_unsafe_metrics_CpuStarvationSampler$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_unsafe_metrics_CpuStarvationSampler$.prototype.constructor = $c_Lcats_effect_unsafe_metrics_CpuStarvationSampler$;
/** @constructor */
function $h_Lcats_effect_unsafe_metrics_CpuStarvationSampler$() {
}
export { $h_Lcats_effect_unsafe_metrics_CpuStarvationSampler$ as $h_Lcats_effect_unsafe_metrics_CpuStarvationSampler$ };
$h_Lcats_effect_unsafe_metrics_CpuStarvationSampler$.prototype = $c_Lcats_effect_unsafe_metrics_CpuStarvationSampler$.prototype;
$c_Lcats_effect_unsafe_metrics_CpuStarvationSampler$.prototype.apply__Lcats_effect_unsafe_metrics_CpuStarvationSampler = (function() {
  return new $c_Lcats_effect_unsafe_metrics_CpuStarvationSampler(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_ju_concurrent_atomic_AtomicLong($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_ju_concurrent_atomic_AtomicLong($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_ju_concurrent_atomic_AtomicLong($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0));
});
var $d_Lcats_effect_unsafe_metrics_CpuStarvationSampler$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_unsafe_metrics_CpuStarvationSampler$, "cats.effect.unsafe.metrics.CpuStarvationSampler$", ({
  Lcats_effect_unsafe_metrics_CpuStarvationSampler$: 1
}));
export { $d_Lcats_effect_unsafe_metrics_CpuStarvationSampler$ as $d_Lcats_effect_unsafe_metrics_CpuStarvationSampler$ };
var $n_Lcats_effect_unsafe_metrics_CpuStarvationSampler$;
function $m_Lcats_effect_unsafe_metrics_CpuStarvationSampler$() {
  if ((!$n_Lcats_effect_unsafe_metrics_CpuStarvationSampler$)) {
    $n_Lcats_effect_unsafe_metrics_CpuStarvationSampler$ = new $c_Lcats_effect_unsafe_metrics_CpuStarvationSampler$();
  }
  return $n_Lcats_effect_unsafe_metrics_CpuStarvationSampler$;
}
export { $m_Lcats_effect_unsafe_metrics_CpuStarvationSampler$ as $m_Lcats_effect_unsafe_metrics_CpuStarvationSampler$ };
/** @constructor */
function $c_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform() {
}
export { $c_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform as $c_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform };
$c_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform.prototype.constructor = $c_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform;
/** @constructor */
function $h_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform() {
}
export { $h_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform as $h_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform };
$h_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform.prototype = $c_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform.prototype;
$c_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform.prototype.apply__s_concurrent_ExecutionContext__Lcats_effect_unsafe_metrics_IORuntimeMetrics = (function(ec) {
  return new $c_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform$$anon$1();
});
function $f_Lcats_instances_InvariantInstances__$init$__V($thiz) {
  $thiz.cats$instances$InvariantInstances$_setter_$catsInvariantForNumeric_$eq__Lcats_Invariant__V(new $c_Lcats_instances_InvariantInstances$$anon$10());
  $thiz.cats$instances$InvariantInstances$_setter_$catsInvariantForIntegral_$eq__Lcats_Invariant__V(new $c_Lcats_instances_InvariantInstances$$anon$12());
}
export { $f_Lcats_instances_InvariantInstances__$init$__V as $f_Lcats_instances_InvariantInstances__$init$__V };
function $f_Lcats_instances_InvariantMonoidalInstances__$init$__V($thiz) {
  $thiz.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalSemigroup_$eq__Lcats_InvariantMonoidal__V(new $c_Lcats_instances_InvariantMonoidalInstances$$anon$1());
  $thiz.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalCommutativeSemigroup_$eq__Lcats_InvariantMonoidal__V(new $c_Lcats_instances_InvariantMonoidalInstances$$anon$4());
}
export { $f_Lcats_instances_InvariantMonoidalInstances__$init$__V as $f_Lcats_instances_InvariantMonoidalInstances__$init$__V };
function $f_Lcats_kernel_instances_BigDecimalInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$BigDecimalInstances$_setter_$catsKernelStdOrderForBigDecimal_$eq__Lcats_kernel_Hash__V(new $c_Lcats_kernel_instances_BigDecimalOrder());
  $thiz.cats$kernel$instances$BigDecimalInstances$_setter_$catsKernelStdGroupForBigDecimal_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_BigDecimalGroup());
}
export { $f_Lcats_kernel_instances_BigDecimalInstances__$init$__V as $f_Lcats_kernel_instances_BigDecimalInstances__$init$__V };
function $f_Lcats_kernel_instances_BigIntInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$BigIntInstances$_setter_$catsKernelStdOrderForBigInt_$eq__Lcats_kernel_Hash__V(new $c_Lcats_kernel_instances_BigIntOrder());
  $thiz.cats$kernel$instances$BigIntInstances$_setter_$catsKernelStdGroupForBigInt_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_BigIntGroup());
}
export { $f_Lcats_kernel_instances_BigIntInstances__$init$__V as $f_Lcats_kernel_instances_BigIntInstances__$init$__V };
function $f_Lcats_kernel_instances_BitSetInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$BitSetInstances$_setter_$catsKernelStdOrderForBitSet_$eq__Lcats_kernel_Hash__V(new $c_Lcats_kernel_instances_BitSetPartialOrder());
  $thiz.cats$kernel$instances$BitSetInstances$_setter_$catsKernelStdSemilatticeForBitSet_$eq__Lcats_kernel_BoundedSemilattice__V(new $c_Lcats_kernel_instances_BitSetSemilattice());
}
export { $f_Lcats_kernel_instances_BitSetInstances__$init$__V as $f_Lcats_kernel_instances_BitSetInstances__$init$__V };
function $f_Lcats_kernel_instances_ByteInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$ByteInstances$_setter_$catsKernelStdOrderForByte_$eq__Lcats_kernel_BoundedEnumerable__V(new $c_Lcats_kernel_instances_ByteOrder());
  $thiz.cats$kernel$instances$ByteInstances$_setter_$catsKernelStdGroupForByte_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_ByteGroup());
}
export { $f_Lcats_kernel_instances_ByteInstances__$init$__V as $f_Lcats_kernel_instances_ByteInstances__$init$__V };
function $f_Lcats_kernel_instances_DoubleInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$DoubleInstances$_setter_$catsKernelStdOrderForDouble_$eq__Lcats_kernel_Hash__V(new $c_Lcats_kernel_instances_DoubleOrder());
  $thiz.cats$kernel$instances$DoubleInstances$_setter_$catsKernelStdGroupForDouble_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_DoubleGroup());
}
export { $f_Lcats_kernel_instances_DoubleInstances__$init$__V as $f_Lcats_kernel_instances_DoubleInstances__$init$__V };
function $f_Lcats_kernel_instances_DurationInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$DurationInstances$_setter_$catsKernelStdOrderForDuration_$eq__Lcats_kernel_Hash__V(new $c_Lcats_kernel_instances_DurationOrder());
  $thiz.cats$kernel$instances$DurationInstances$_setter_$catsKernelStdGroupForDuration_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_DurationGroup());
}
export { $f_Lcats_kernel_instances_DurationInstances__$init$__V as $f_Lcats_kernel_instances_DurationInstances__$init$__V };
function $f_Lcats_kernel_instances_FiniteDurationInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$FiniteDurationInstances$_setter_$catsKernelStdOrderForFiniteDuration_$eq__Lcats_kernel_Hash__V(new $c_Lcats_kernel_instances_FiniteDurationOrder());
  $thiz.cats$kernel$instances$FiniteDurationInstances$_setter_$catsKernelStdGroupForFiniteDuration_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_FiniteDurationGroup());
}
export { $f_Lcats_kernel_instances_FiniteDurationInstances__$init$__V as $f_Lcats_kernel_instances_FiniteDurationInstances__$init$__V };
function $f_Lcats_kernel_instances_FloatInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$FloatInstances$_setter_$catsKernelStdOrderForFloat_$eq__Lcats_kernel_Hash__V(new $c_Lcats_kernel_instances_FloatOrder());
  $thiz.cats$kernel$instances$FloatInstances$_setter_$catsKernelStdGroupForFloat_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_FloatGroup());
}
export { $f_Lcats_kernel_instances_FloatInstances__$init$__V as $f_Lcats_kernel_instances_FloatInstances__$init$__V };
/** @constructor */
function $c_Lcats_kernel_instances_LazyListMonoid$() {
  this.Lcats_kernel_instances_LazyListMonoid$__f_singleton = null;
  $n_Lcats_kernel_instances_LazyListMonoid$ = this;
  this.Lcats_kernel_instances_LazyListMonoid$__f_singleton = new $c_Lcats_kernel_instances_LazyListMonoid();
}
export { $c_Lcats_kernel_instances_LazyListMonoid$ as $c_Lcats_kernel_instances_LazyListMonoid$ };
$c_Lcats_kernel_instances_LazyListMonoid$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_kernel_instances_LazyListMonoid$.prototype.constructor = $c_Lcats_kernel_instances_LazyListMonoid$;
/** @constructor */
function $h_Lcats_kernel_instances_LazyListMonoid$() {
}
export { $h_Lcats_kernel_instances_LazyListMonoid$ as $h_Lcats_kernel_instances_LazyListMonoid$ };
$h_Lcats_kernel_instances_LazyListMonoid$.prototype = $c_Lcats_kernel_instances_LazyListMonoid$.prototype;
var $d_Lcats_kernel_instances_LazyListMonoid$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_kernel_instances_LazyListMonoid$, "cats.kernel.instances.LazyListMonoid$", ({
  Lcats_kernel_instances_LazyListMonoid$: 1
}));
export { $d_Lcats_kernel_instances_LazyListMonoid$ as $d_Lcats_kernel_instances_LazyListMonoid$ };
var $n_Lcats_kernel_instances_LazyListMonoid$;
function $m_Lcats_kernel_instances_LazyListMonoid$() {
  if ((!$n_Lcats_kernel_instances_LazyListMonoid$)) {
    $n_Lcats_kernel_instances_LazyListMonoid$ = new $c_Lcats_kernel_instances_LazyListMonoid$();
  }
  return $n_Lcats_kernel_instances_LazyListMonoid$;
}
export { $m_Lcats_kernel_instances_LazyListMonoid$ as $m_Lcats_kernel_instances_LazyListMonoid$ };
/** @constructor */
function $c_Lcats_kernel_instances_QueueMonoid$() {
  this.Lcats_kernel_instances_QueueMonoid$__f_singleton = null;
  $n_Lcats_kernel_instances_QueueMonoid$ = this;
  this.Lcats_kernel_instances_QueueMonoid$__f_singleton = new $c_Lcats_kernel_instances_QueueMonoid();
}
export { $c_Lcats_kernel_instances_QueueMonoid$ as $c_Lcats_kernel_instances_QueueMonoid$ };
$c_Lcats_kernel_instances_QueueMonoid$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_kernel_instances_QueueMonoid$.prototype.constructor = $c_Lcats_kernel_instances_QueueMonoid$;
/** @constructor */
function $h_Lcats_kernel_instances_QueueMonoid$() {
}
export { $h_Lcats_kernel_instances_QueueMonoid$ as $h_Lcats_kernel_instances_QueueMonoid$ };
$h_Lcats_kernel_instances_QueueMonoid$.prototype = $c_Lcats_kernel_instances_QueueMonoid$.prototype;
var $d_Lcats_kernel_instances_QueueMonoid$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_kernel_instances_QueueMonoid$, "cats.kernel.instances.QueueMonoid$", ({
  Lcats_kernel_instances_QueueMonoid$: 1
}));
export { $d_Lcats_kernel_instances_QueueMonoid$ as $d_Lcats_kernel_instances_QueueMonoid$ };
var $n_Lcats_kernel_instances_QueueMonoid$;
function $m_Lcats_kernel_instances_QueueMonoid$() {
  if ((!$n_Lcats_kernel_instances_QueueMonoid$)) {
    $n_Lcats_kernel_instances_QueueMonoid$ = new $c_Lcats_kernel_instances_QueueMonoid$();
  }
  return $n_Lcats_kernel_instances_QueueMonoid$;
}
export { $m_Lcats_kernel_instances_QueueMonoid$ as $m_Lcats_kernel_instances_QueueMonoid$ };
function $f_Lcats_kernel_instances_ShortInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$ShortInstances$_setter_$catsKernelStdOrderForShort_$eq__Lcats_kernel_BoundedEnumerable__V(new $c_Lcats_kernel_instances_ShortOrder());
  $thiz.cats$kernel$instances$ShortInstances$_setter_$catsKernelStdGroupForShort_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_ShortGroup());
}
export { $f_Lcats_kernel_instances_ShortInstances__$init$__V as $f_Lcats_kernel_instances_ShortInstances__$init$__V };
function $f_Lcats_kernel_instances_UnitInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$UnitInstances$_setter_$catsKernelStdOrderForUnit_$eq__Lcats_kernel_BoundedEnumerable__V(new $c_Lcats_kernel_instances_UnitOrder());
  $thiz.cats$kernel$instances$UnitInstances$_setter_$catsKernelStdAlgebraForUnit_$eq__Lcats_kernel_BoundedSemilattice__V(new $c_Lcats_kernel_instances_UnitAlgebra());
}
export { $f_Lcats_kernel_instances_UnitInstances__$init$__V as $f_Lcats_kernel_instances_UnitInstances__$init$__V };
/** @constructor */
function $c_Lcats_syntax_ApplicativeErrorOps$() {
}
export { $c_Lcats_syntax_ApplicativeErrorOps$ as $c_Lcats_syntax_ApplicativeErrorOps$ };
$c_Lcats_syntax_ApplicativeErrorOps$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_syntax_ApplicativeErrorOps$.prototype.constructor = $c_Lcats_syntax_ApplicativeErrorOps$;
/** @constructor */
function $h_Lcats_syntax_ApplicativeErrorOps$() {
}
export { $h_Lcats_syntax_ApplicativeErrorOps$ as $h_Lcats_syntax_ApplicativeErrorOps$ };
$h_Lcats_syntax_ApplicativeErrorOps$.prototype = $c_Lcats_syntax_ApplicativeErrorOps$.prototype;
$c_Lcats_syntax_ApplicativeErrorOps$.prototype.orElse$extension__O__F0__Lcats_ApplicativeError__O = (function(this$, other, F) {
  return F.handleErrorWith__O__F1__O(this$, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$7) => other.apply__O())));
});
var $d_Lcats_syntax_ApplicativeErrorOps$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_syntax_ApplicativeErrorOps$, "cats.syntax.ApplicativeErrorOps$", ({
  Lcats_syntax_ApplicativeErrorOps$: 1
}));
export { $d_Lcats_syntax_ApplicativeErrorOps$ as $d_Lcats_syntax_ApplicativeErrorOps$ };
var $n_Lcats_syntax_ApplicativeErrorOps$;
function $m_Lcats_syntax_ApplicativeErrorOps$() {
  if ((!$n_Lcats_syntax_ApplicativeErrorOps$)) {
    $n_Lcats_syntax_ApplicativeErrorOps$ = new $c_Lcats_syntax_ApplicativeErrorOps$();
  }
  return $n_Lcats_syntax_ApplicativeErrorOps$;
}
export { $m_Lcats_syntax_ApplicativeErrorOps$ as $m_Lcats_syntax_ApplicativeErrorOps$ };
/** @constructor */
function $c_Lcats_syntax_MonadErrorRethrowOps$() {
}
export { $c_Lcats_syntax_MonadErrorRethrowOps$ as $c_Lcats_syntax_MonadErrorRethrowOps$ };
$c_Lcats_syntax_MonadErrorRethrowOps$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_syntax_MonadErrorRethrowOps$.prototype.constructor = $c_Lcats_syntax_MonadErrorRethrowOps$;
/** @constructor */
function $h_Lcats_syntax_MonadErrorRethrowOps$() {
}
export { $h_Lcats_syntax_MonadErrorRethrowOps$ as $h_Lcats_syntax_MonadErrorRethrowOps$ };
$h_Lcats_syntax_MonadErrorRethrowOps$.prototype = $c_Lcats_syntax_MonadErrorRethrowOps$.prototype;
$c_Lcats_syntax_MonadErrorRethrowOps$.prototype.rethrow$extension__O__Lcats_MonadError__O = (function(this$, F) {
  return F.flatMap__O__F1__O(this$, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$5) => {
    if ((_$5 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
      var b = _$5.s_util_Right__f_value;
      return F.pure__O__O(b);
    } else if ((_$5 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
      var a = _$5.s_util_Left__f_value;
      return F.raiseError__O__O(a);
    } else {
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(_$5);
    }
  })));
});
var $d_Lcats_syntax_MonadErrorRethrowOps$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_syntax_MonadErrorRethrowOps$, "cats.syntax.MonadErrorRethrowOps$", ({
  Lcats_syntax_MonadErrorRethrowOps$: 1
}));
export { $d_Lcats_syntax_MonadErrorRethrowOps$ as $d_Lcats_syntax_MonadErrorRethrowOps$ };
var $n_Lcats_syntax_MonadErrorRethrowOps$;
function $m_Lcats_syntax_MonadErrorRethrowOps$() {
  if ((!$n_Lcats_syntax_MonadErrorRethrowOps$)) {
    $n_Lcats_syntax_MonadErrorRethrowOps$ = new $c_Lcats_syntax_MonadErrorRethrowOps$();
  }
  return $n_Lcats_syntax_MonadErrorRethrowOps$;
}
export { $m_Lcats_syntax_MonadErrorRethrowOps$ as $m_Lcats_syntax_MonadErrorRethrowOps$ };
/** @constructor */
function $c_Lcats_syntax_PartialOrderOps(lhs, A) {
  this.Lcats_syntax_PartialOrderOps__f_lhs = null;
  this.Lcats_syntax_PartialOrderOps__f_A = null;
  this.Lcats_syntax_PartialOrderOps__f_lhs = lhs;
  this.Lcats_syntax_PartialOrderOps__f_A = A;
}
export { $c_Lcats_syntax_PartialOrderOps as $c_Lcats_syntax_PartialOrderOps };
$c_Lcats_syntax_PartialOrderOps.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_syntax_PartialOrderOps.prototype.constructor = $c_Lcats_syntax_PartialOrderOps;
/** @constructor */
function $h_Lcats_syntax_PartialOrderOps() {
}
export { $h_Lcats_syntax_PartialOrderOps as $h_Lcats_syntax_PartialOrderOps };
$h_Lcats_syntax_PartialOrderOps.prototype = $c_Lcats_syntax_PartialOrderOps.prototype;
$c_Lcats_syntax_PartialOrderOps.prototype.$greater__O__Z = (function(rhs) {
  return this.Lcats_syntax_PartialOrderOps__f_A.gt__O__O__Z(this.Lcats_syntax_PartialOrderOps__f_lhs, rhs);
});
$c_Lcats_syntax_PartialOrderOps.prototype.$less__O__Z = (function(rhs) {
  return this.Lcats_syntax_PartialOrderOps__f_A.lt__O__O__Z(this.Lcats_syntax_PartialOrderOps__f_lhs, rhs);
});
var $d_Lcats_syntax_PartialOrderOps = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_syntax_PartialOrderOps, "cats.syntax.PartialOrderOps", ({
  Lcats_syntax_PartialOrderOps: 1
}));
export { $d_Lcats_syntax_PartialOrderOps as $d_Lcats_syntax_PartialOrderOps };
/** @constructor */
function $c_Lcom_raquo_airstream_combine_CombineObservable$() {
}
export { $c_Lcom_raquo_airstream_combine_CombineObservable$ as $c_Lcom_raquo_airstream_combine_CombineObservable$ };
$c_Lcom_raquo_airstream_combine_CombineObservable$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_combine_CombineObservable$.prototype.constructor = $c_Lcom_raquo_airstream_combine_CombineObservable$;
/** @constructor */
function $h_Lcom_raquo_airstream_combine_CombineObservable$() {
}
export { $h_Lcom_raquo_airstream_combine_CombineObservable$ as $h_Lcom_raquo_airstream_combine_CombineObservable$ };
$h_Lcom_raquo_airstream_combine_CombineObservable$.prototype = $c_Lcom_raquo_airstream_combine_CombineObservable$.prototype;
$c_Lcom_raquo_airstream_combine_CombineObservable$.prototype.jsArrayCombinator__Lcom_raquo_ew_JsArray__F1__s_util_Try = (function(trys, combinator) {
  var elem = false;
  elem = true;
  var i = 0;
  var len = (trys.length | 0);
  while ((i < len)) {
    var t = trys[i];
    if (t.isFailure__Z()) {
      elem = false;
    }
    i = ((1 + i) | 0);
  }
  if (elem) {
    var values = trys.map(((_$3) => _$3.get__O()));
    var value = combinator.apply__O__O(values);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(value);
  } else {
    var arr = trys.map(((x$1) => {
      if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure)) {
        var err = x$1.s_util_Failure__f_exception;
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(err);
      } else {
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      }
    }));
    var errors = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_IndexedSeq$().from__sc_IterableOnce__sci_IndexedSeq($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_sjs_js_WrappedArray__sjs_js_Array__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_WrappedArray(), arr));
    var exception = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_core_AirstreamError$CombinedError(errors);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(exception);
  }
});
var $d_Lcom_raquo_airstream_combine_CombineObservable$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_combine_CombineObservable$, "com.raquo.airstream.combine.CombineObservable$", ({
  Lcom_raquo_airstream_combine_CombineObservable$: 1
}));
export { $d_Lcom_raquo_airstream_combine_CombineObservable$ as $d_Lcom_raquo_airstream_combine_CombineObservable$ };
var $n_Lcom_raquo_airstream_combine_CombineObservable$;
function $m_Lcom_raquo_airstream_combine_CombineObservable$() {
  if ((!$n_Lcom_raquo_airstream_combine_CombineObservable$)) {
    $n_Lcom_raquo_airstream_combine_CombineObservable$ = new $c_Lcom_raquo_airstream_combine_CombineObservable$();
  }
  return $n_Lcom_raquo_airstream_combine_CombineObservable$;
}
export { $m_Lcom_raquo_airstream_combine_CombineObservable$ as $m_Lcom_raquo_airstream_combine_CombineObservable$ };
/** @constructor */
function $c_Lcom_raquo_airstream_combine_generated_CombinableSignal$() {
}
export { $c_Lcom_raquo_airstream_combine_generated_CombinableSignal$ as $c_Lcom_raquo_airstream_combine_generated_CombinableSignal$ };
$c_Lcom_raquo_airstream_combine_generated_CombinableSignal$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_combine_generated_CombinableSignal$.prototype.constructor = $c_Lcom_raquo_airstream_combine_generated_CombinableSignal$;
/** @constructor */
function $h_Lcom_raquo_airstream_combine_generated_CombinableSignal$() {
}
export { $h_Lcom_raquo_airstream_combine_generated_CombinableSignal$ as $h_Lcom_raquo_airstream_combine_generated_CombinableSignal$ };
$h_Lcom_raquo_airstream_combine_generated_CombinableSignal$.prototype = $c_Lcom_raquo_airstream_combine_generated_CombinableSignal$.prototype;
$c_Lcom_raquo_airstream_combine_generated_CombinableSignal$.prototype.combineWith$extension__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_Source$SignalSource__Lapp_tulz_tuplez_Composition__Lcom_raquo_airstream_core_Signal = (function(this$, s1, s2, s3, c) {
  var combinator = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction4_$$Lambda$06f9c6daa9fb22f000f9d0ee75fdbad9d7687b0b(((a, v1, v2, v3) => c.compose__O__O__O(a, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T3(v1, v2, v3))));
  return $m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().combineWithFn__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_Source$SignalSource__F4__Lcom_raquo_airstream_core_Signal(this$, s1, s2, s3, combinator);
});
var $d_Lcom_raquo_airstream_combine_generated_CombinableSignal$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_combine_generated_CombinableSignal$, "com.raquo.airstream.combine.generated.CombinableSignal$", ({
  Lcom_raquo_airstream_combine_generated_CombinableSignal$: 1
}));
export { $d_Lcom_raquo_airstream_combine_generated_CombinableSignal$ as $d_Lcom_raquo_airstream_combine_generated_CombinableSignal$ };
var $n_Lcom_raquo_airstream_combine_generated_CombinableSignal$;
function $m_Lcom_raquo_airstream_combine_generated_CombinableSignal$() {
  if ((!$n_Lcom_raquo_airstream_combine_generated_CombinableSignal$)) {
    $n_Lcom_raquo_airstream_combine_generated_CombinableSignal$ = new $c_Lcom_raquo_airstream_combine_generated_CombinableSignal$();
  }
  return $n_Lcom_raquo_airstream_combine_generated_CombinableSignal$;
}
export { $m_Lcom_raquo_airstream_combine_generated_CombinableSignal$ as $m_Lcom_raquo_airstream_combine_generated_CombinableSignal$ };
/** @constructor */
function $c_Lcom_raquo_airstream_combine_generated_CombinableStream$() {
}
export { $c_Lcom_raquo_airstream_combine_generated_CombinableStream$ as $c_Lcom_raquo_airstream_combine_generated_CombinableStream$ };
$c_Lcom_raquo_airstream_combine_generated_CombinableStream$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_combine_generated_CombinableStream$.prototype.constructor = $c_Lcom_raquo_airstream_combine_generated_CombinableStream$;
/** @constructor */
function $h_Lcom_raquo_airstream_combine_generated_CombinableStream$() {
}
export { $h_Lcom_raquo_airstream_combine_generated_CombinableStream$ as $h_Lcom_raquo_airstream_combine_generated_CombinableStream$ };
$h_Lcom_raquo_airstream_combine_generated_CombinableStream$.prototype = $c_Lcom_raquo_airstream_combine_generated_CombinableStream$.prototype;
$c_Lcom_raquo_airstream_combine_generated_CombinableStream$.prototype.withCurrentValueOf$extension__Lcom_raquo_airstream_core_EventStream__Lcom_raquo_airstream_core_Source$SignalSource__Lapp_tulz_tuplez_Composition__Lcom_raquo_airstream_core_EventStream = (function(this$, s1, c) {
  var combinator = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((arr) => c.compose__O__O__O(arr[0], arr[1])));
  var sampledSignals = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcom_raquo_airstream_core_Signal.getArrayOf().constr)([s1.toObservable__Lcom_raquo_airstream_core_Signal()])));
  return new $c_Lcom_raquo_airstream_combine_SampleCombineStreamN(this$, sampledSignals, combinator);
});
$c_Lcom_raquo_airstream_combine_generated_CombinableStream$.prototype.sample$extension__Lcom_raquo_airstream_core_EventStream__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_EventStream = (function(this$, s1) {
  var combinator = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((arr) => arr[1]));
  var sampledSignals = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcom_raquo_airstream_core_Signal.getArrayOf().constr)([s1.toObservable__Lcom_raquo_airstream_core_Signal()])));
  return new $c_Lcom_raquo_airstream_combine_SampleCombineStreamN(this$, sampledSignals, combinator);
});
$c_Lcom_raquo_airstream_combine_generated_CombinableStream$.prototype.withCurrentValueOf$extension__Lcom_raquo_airstream_core_EventStream__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_Source$SignalSource__Lapp_tulz_tuplez_Composition__Lcom_raquo_airstream_core_EventStream = (function(this$, s1, s2, c) {
  var combinator = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((arr) => {
    var $x_1 = arr[0];
    var _1 = arr[1];
    var _2 = arr[2];
    return c.compose__O__O__O($x_1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, _2));
  }));
  var sampledSignals = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcom_raquo_airstream_core_Signal.getArrayOf().constr)([s1.toObservable__Lcom_raquo_airstream_core_Signal(), s2.toObservable__Lcom_raquo_airstream_core_Signal()])));
  return new $c_Lcom_raquo_airstream_combine_SampleCombineStreamN(this$, sampledSignals, combinator);
});
$c_Lcom_raquo_airstream_combine_generated_CombinableStream$.prototype.sample$extension__Lcom_raquo_airstream_core_EventStream__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_EventStream = (function(this$, s1, s2) {
  var combinator = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((arr) => {
    var _1 = arr[1];
    var _2 = arr[2];
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, _2);
  }));
  var sampledSignals = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcom_raquo_airstream_core_Signal.getArrayOf().constr)([s1.toObservable__Lcom_raquo_airstream_core_Signal(), s2.toObservable__Lcom_raquo_airstream_core_Signal()])));
  return new $c_Lcom_raquo_airstream_combine_SampleCombineStreamN(this$, sampledSignals, combinator);
});
$c_Lcom_raquo_airstream_combine_generated_CombinableStream$.prototype.sample$extension__Lcom_raquo_airstream_core_EventStream__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_EventStream = (function(this$, s1, s2, s3) {
  var combinator = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((arr) => {
    var _1 = arr[1];
    var _2 = arr[2];
    var _3 = arr[3];
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T3(_1, _2, _3);
  }));
  var sampledSignals = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcom_raquo_airstream_core_Signal.getArrayOf().constr)([s1.toObservable__Lcom_raquo_airstream_core_Signal(), s2.toObservable__Lcom_raquo_airstream_core_Signal(), s3.toObservable__Lcom_raquo_airstream_core_Signal()])));
  return new $c_Lcom_raquo_airstream_combine_SampleCombineStreamN(this$, sampledSignals, combinator);
});
var $d_Lcom_raquo_airstream_combine_generated_CombinableStream$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_combine_generated_CombinableStream$, "com.raquo.airstream.combine.generated.CombinableStream$", ({
  Lcom_raquo_airstream_combine_generated_CombinableStream$: 1
}));
export { $d_Lcom_raquo_airstream_combine_generated_CombinableStream$ as $d_Lcom_raquo_airstream_combine_generated_CombinableStream$ };
var $n_Lcom_raquo_airstream_combine_generated_CombinableStream$;
function $m_Lcom_raquo_airstream_combine_generated_CombinableStream$() {
  if ((!$n_Lcom_raquo_airstream_combine_generated_CombinableStream$)) {
    $n_Lcom_raquo_airstream_combine_generated_CombinableStream$ = new $c_Lcom_raquo_airstream_combine_generated_CombinableStream$();
  }
  return $n_Lcom_raquo_airstream_combine_generated_CombinableStream$;
}
export { $m_Lcom_raquo_airstream_combine_generated_CombinableStream$ as $m_Lcom_raquo_airstream_combine_generated_CombinableStream$ };
/** @constructor */
function $c_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$() {
}
export { $c_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$ as $c_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$ };
$c_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$.prototype.constructor = $c_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$;
/** @constructor */
function $h_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$() {
}
export { $h_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$ as $h_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$ };
$h_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$.prototype = $c_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$.prototype;
$c_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$.prototype.combineWithFn__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_Source$SignalSource__F2__Lcom_raquo_airstream_core_Signal = (function(s1, s2, combinator) {
  return new $c_Lcom_raquo_airstream_combine_CombineSignalN($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcom_raquo_airstream_core_Signal.getArrayOf().constr)([s1.toObservable__Lcom_raquo_airstream_core_Signal(), s2.toObservable__Lcom_raquo_airstream_core_Signal()]))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((arr) => combinator.apply__O__O__O(arr[0], arr[1]))));
});
$c_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$.prototype.combineWithFn__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_Source$SignalSource__F3__Lcom_raquo_airstream_core_Signal = (function(s1, s2, s3, combinator) {
  return new $c_Lcom_raquo_airstream_combine_CombineSignalN($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcom_raquo_airstream_core_Signal.getArrayOf().constr)([s1.toObservable__Lcom_raquo_airstream_core_Signal(), s2.toObservable__Lcom_raquo_airstream_core_Signal(), s3.toObservable__Lcom_raquo_airstream_core_Signal()]))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((arr) => combinator.apply__O__O__O__O(arr[0], arr[1], arr[2]))));
});
$c_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$.prototype.combineWithFn__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_Source$SignalSource__F4__Lcom_raquo_airstream_core_Signal = (function(s1, s2, s3, s4, combinator) {
  return new $c_Lcom_raquo_airstream_combine_CombineSignalN($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcom_raquo_airstream_core_Signal.getArrayOf().constr)([s1.toObservable__Lcom_raquo_airstream_core_Signal(), s2.toObservable__Lcom_raquo_airstream_core_Signal(), s3.toObservable__Lcom_raquo_airstream_core_Signal(), s4.toObservable__Lcom_raquo_airstream_core_Signal()]))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((arr) => combinator.apply__O__O__O__O__O(arr[0], arr[1], arr[2], arr[3]))));
});
$c_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$.prototype.combineWithFn__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_Source$SignalSource__F6__Lcom_raquo_airstream_core_Signal = (function(s1, s2, s3, s4, s5, s6, combinator) {
  return new $c_Lcom_raquo_airstream_combine_CombineSignalN($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcom_raquo_airstream_core_Signal.getArrayOf().constr)([s1.toObservable__Lcom_raquo_airstream_core_Signal(), s2.toObservable__Lcom_raquo_airstream_core_Signal(), s3.toObservable__Lcom_raquo_airstream_core_Signal(), s4.toObservable__Lcom_raquo_airstream_core_Signal(), s5.toObservable__Lcom_raquo_airstream_core_Signal(), s6.toObservable__Lcom_raquo_airstream_core_Signal()]))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((arr) => combinator.apply__O__O__O__O__O__O__O(arr[0], arr[1], arr[2], arr[3], arr[4], arr[5]))));
});
var $d_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$, "com.raquo.airstream.combine.generated.StaticSignalCombineOps$", ({
  Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$: 1
}));
export { $d_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$ as $d_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$ };
var $n_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$;
function $m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$() {
  if ((!$n_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$)) {
    $n_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$ = new $c_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$();
  }
  return $n_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$;
}
export { $m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$ as $m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$ };
/** @constructor */
function $c_Lcom_raquo_airstream_core_InternalObserver$() {
  this.Lcom_raquo_airstream_core_InternalObserver$__f_empty = null;
  $n_Lcom_raquo_airstream_core_InternalObserver$ = this;
  this.Lcom_raquo_airstream_core_InternalObserver$__f_empty = new $c_Lcom_raquo_airstream_core_InternalObserver$$anon$1();
}
export { $c_Lcom_raquo_airstream_core_InternalObserver$ as $c_Lcom_raquo_airstream_core_InternalObserver$ };
$c_Lcom_raquo_airstream_core_InternalObserver$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_core_InternalObserver$.prototype.constructor = $c_Lcom_raquo_airstream_core_InternalObserver$;
/** @constructor */
function $h_Lcom_raquo_airstream_core_InternalObserver$() {
}
export { $h_Lcom_raquo_airstream_core_InternalObserver$ as $h_Lcom_raquo_airstream_core_InternalObserver$ };
$h_Lcom_raquo_airstream_core_InternalObserver$.prototype = $c_Lcom_raquo_airstream_core_InternalObserver$.prototype;
$c_Lcom_raquo_airstream_core_InternalObserver$.prototype.apply__F2__F2__Lcom_raquo_airstream_core_InternalObserver = (function(onNext, onError) {
  return new $c_Lcom_raquo_airstream_core_InternalObserver$$anon$2(onNext, onError);
});
$c_Lcom_raquo_airstream_core_InternalObserver$.prototype.fromTry__F2__Lcom_raquo_airstream_core_InternalObserver = (function(onTry) {
  return new $c_Lcom_raquo_airstream_core_InternalObserver$$anon$3(onTry);
});
var $d_Lcom_raquo_airstream_core_InternalObserver$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_core_InternalObserver$, "com.raquo.airstream.core.InternalObserver$", ({
  Lcom_raquo_airstream_core_InternalObserver$: 1
}));
export { $d_Lcom_raquo_airstream_core_InternalObserver$ as $d_Lcom_raquo_airstream_core_InternalObserver$ };
var $n_Lcom_raquo_airstream_core_InternalObserver$;
function $m_Lcom_raquo_airstream_core_InternalObserver$() {
  if ((!$n_Lcom_raquo_airstream_core_InternalObserver$)) {
    $n_Lcom_raquo_airstream_core_InternalObserver$ = new $c_Lcom_raquo_airstream_core_InternalObserver$();
  }
  return $n_Lcom_raquo_airstream_core_InternalObserver$;
}
export { $m_Lcom_raquo_airstream_core_InternalObserver$ as $m_Lcom_raquo_airstream_core_InternalObserver$ };
/** @constructor */
function $c_Lcom_raquo_airstream_extensions_BooleanSignal$() {
}
export { $c_Lcom_raquo_airstream_extensions_BooleanSignal$ as $c_Lcom_raquo_airstream_extensions_BooleanSignal$ };
$c_Lcom_raquo_airstream_extensions_BooleanSignal$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_extensions_BooleanSignal$.prototype.constructor = $c_Lcom_raquo_airstream_extensions_BooleanSignal$;
/** @constructor */
function $h_Lcom_raquo_airstream_extensions_BooleanSignal$() {
}
export { $h_Lcom_raquo_airstream_extensions_BooleanSignal$ as $h_Lcom_raquo_airstream_extensions_BooleanSignal$ };
$h_Lcom_raquo_airstream_extensions_BooleanSignal$.prototype = $c_Lcom_raquo_airstream_extensions_BooleanSignal$.prototype;
$c_Lcom_raquo_airstream_extensions_BooleanSignal$.prototype.splitBoolean$extension__Lcom_raquo_airstream_core_Signal__F1__F1__Lcom_raquo_airstream_core_Signal = (function(this$, whenTrue, whenFalse) {
  return $m_Lcom_raquo_airstream_split_SplittableOneSignal$().splitOne$extension__Lcom_raquo_airstream_core_Signal__F1__F3__Lcom_raquo_airstream_core_Signal(this$, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x) => {
    var x$1 = (!(!x));
    return x$1;
  })), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction3_$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491(((_$1, initial, signal) => {
    var initial$1 = (!(!initial));
    return (initial$1 ? whenTrue.apply__O__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__mapToUnit__Lcom_raquo_airstream_core_Observable(signal)) : whenFalse.apply__O__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__mapToUnit__Lcom_raquo_airstream_core_Observable(signal)));
  })));
});
var $d_Lcom_raquo_airstream_extensions_BooleanSignal$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_extensions_BooleanSignal$, "com.raquo.airstream.extensions.BooleanSignal$", ({
  Lcom_raquo_airstream_extensions_BooleanSignal$: 1
}));
export { $d_Lcom_raquo_airstream_extensions_BooleanSignal$ as $d_Lcom_raquo_airstream_extensions_BooleanSignal$ };
var $n_Lcom_raquo_airstream_extensions_BooleanSignal$;
function $m_Lcom_raquo_airstream_extensions_BooleanSignal$() {
  if ((!$n_Lcom_raquo_airstream_extensions_BooleanSignal$)) {
    $n_Lcom_raquo_airstream_extensions_BooleanSignal$ = new $c_Lcom_raquo_airstream_extensions_BooleanSignal$();
  }
  return $n_Lcom_raquo_airstream_extensions_BooleanSignal$;
}
export { $m_Lcom_raquo_airstream_extensions_BooleanSignal$ as $m_Lcom_raquo_airstream_extensions_BooleanSignal$ };
/** @constructor */
function $c_Lcom_raquo_airstream_extensions_OptionObservable$() {
}
export { $c_Lcom_raquo_airstream_extensions_OptionObservable$ as $c_Lcom_raquo_airstream_extensions_OptionObservable$ };
$c_Lcom_raquo_airstream_extensions_OptionObservable$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_extensions_OptionObservable$.prototype.constructor = $c_Lcom_raquo_airstream_extensions_OptionObservable$;
/** @constructor */
function $h_Lcom_raquo_airstream_extensions_OptionObservable$() {
}
export { $h_Lcom_raquo_airstream_extensions_OptionObservable$ as $h_Lcom_raquo_airstream_extensions_OptionObservable$ };
$h_Lcom_raquo_airstream_extensions_OptionObservable$.prototype = $c_Lcom_raquo_airstream_extensions_OptionObservable$.prototype;
$c_Lcom_raquo_airstream_extensions_OptionObservable$.prototype.mapSome$extension__Lcom_raquo_airstream_core_BaseObservable__F1__Lcom_raquo_airstream_core_Observable = (function(this$, project) {
  return this$.map__F1__Lcom_raquo_airstream_core_Observable(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => (_$2.isEmpty__Z() ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$() : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(project.apply__O__O(_$2.get__O()))))));
});
var $d_Lcom_raquo_airstream_extensions_OptionObservable$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_extensions_OptionObservable$, "com.raquo.airstream.extensions.OptionObservable$", ({
  Lcom_raquo_airstream_extensions_OptionObservable$: 1
}));
export { $d_Lcom_raquo_airstream_extensions_OptionObservable$ as $d_Lcom_raquo_airstream_extensions_OptionObservable$ };
var $n_Lcom_raquo_airstream_extensions_OptionObservable$;
function $m_Lcom_raquo_airstream_extensions_OptionObservable$() {
  if ((!$n_Lcom_raquo_airstream_extensions_OptionObservable$)) {
    $n_Lcom_raquo_airstream_extensions_OptionObservable$ = new $c_Lcom_raquo_airstream_extensions_OptionObservable$();
  }
  return $n_Lcom_raquo_airstream_extensions_OptionObservable$;
}
export { $m_Lcom_raquo_airstream_extensions_OptionObservable$ as $m_Lcom_raquo_airstream_extensions_OptionObservable$ };
/** @constructor */
function $c_Lcom_raquo_airstream_extensions_OptionSignal$() {
}
export { $c_Lcom_raquo_airstream_extensions_OptionSignal$ as $c_Lcom_raquo_airstream_extensions_OptionSignal$ };
$c_Lcom_raquo_airstream_extensions_OptionSignal$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_extensions_OptionSignal$.prototype.constructor = $c_Lcom_raquo_airstream_extensions_OptionSignal$;
/** @constructor */
function $h_Lcom_raquo_airstream_extensions_OptionSignal$() {
}
export { $h_Lcom_raquo_airstream_extensions_OptionSignal$ as $h_Lcom_raquo_airstream_extensions_OptionSignal$ };
$h_Lcom_raquo_airstream_extensions_OptionSignal$.prototype = $c_Lcom_raquo_airstream_extensions_OptionSignal$.prototype;
$c_Lcom_raquo_airstream_extensions_OptionSignal$.prototype.splitOption$extension__Lcom_raquo_airstream_core_Signal__F2__F0__Lcom_raquo_airstream_core_Signal = (function(this$, project, ifEmpty) {
  $m_Lcom_raquo_airstream_core_Observable$();
  var observable = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__distinctByFn__F2__Lcom_raquo_airstream_core_Observable(this$, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((prev, next) => (prev.isEmpty__Z() && next.isEmpty__Z()))));
  var key$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => (void 0)));
  var duplicateKeys$1 = $m_Lcom_raquo_airstream_split_DuplicateKeysConfig$().Lcom_raquo_airstream_split_DuplicateKeysConfig$__f_noWarnings;
  var distinctCompose$1 = $m_Lcom_raquo_airstream_split_SplittableObservable$().split$default$2$extension__Lcom_raquo_airstream_core_Observable__F1(observable);
  var this$2 = $m_Lcom_raquo_airstream_split_SplittableObservable$().split$extension__Lcom_raquo_airstream_core_Observable__F1__F1__Lcom_raquo_airstream_split_DuplicateKeysConfig__F3__Lcom_raquo_airstream_split_Splittable__Lcom_raquo_airstream_core_Signal(observable, key$1, distinctCompose$1, duplicateKeys$1, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction3_$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491(((_$2, initial, signal) => project.apply__O__O__O(initial, signal))), $m_Lcom_raquo_airstream_split_Splittable$OptionSplittable$());
  var project$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$3) => (_$3.isEmpty__Z() ? ifEmpty.apply__O() : _$3.get__O())));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), this$2, project$1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lcom_raquo_airstream_extensions_OptionSignal$.prototype.splitOption$extension__Lcom_raquo_airstream_core_Signal__F2__Lcom_raquo_airstream_core_Signal = (function(this$, project) {
  return this.splitOption$extension__Lcom_raquo_airstream_core_Signal__F2__F0__Lcom_raquo_airstream_core_Signal(this$, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((initial, someSignal) => {
    var value = project.apply__O__O__O(initial, someSignal);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
  })), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$())));
});
var $d_Lcom_raquo_airstream_extensions_OptionSignal$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_extensions_OptionSignal$, "com.raquo.airstream.extensions.OptionSignal$", ({
  Lcom_raquo_airstream_extensions_OptionSignal$: 1
}));
export { $d_Lcom_raquo_airstream_extensions_OptionSignal$ as $d_Lcom_raquo_airstream_extensions_OptionSignal$ };
var $n_Lcom_raquo_airstream_extensions_OptionSignal$;
function $m_Lcom_raquo_airstream_extensions_OptionSignal$() {
  if ((!$n_Lcom_raquo_airstream_extensions_OptionSignal$)) {
    $n_Lcom_raquo_airstream_extensions_OptionSignal$ = new $c_Lcom_raquo_airstream_extensions_OptionSignal$();
  }
  return $n_Lcom_raquo_airstream_extensions_OptionSignal$;
}
export { $m_Lcom_raquo_airstream_extensions_OptionSignal$ as $m_Lcom_raquo_airstream_extensions_OptionSignal$ };
/** @constructor */
function $c_Lcom_raquo_airstream_extensions_StatusSignal$() {
}
export { $c_Lcom_raquo_airstream_extensions_StatusSignal$ as $c_Lcom_raquo_airstream_extensions_StatusSignal$ };
$c_Lcom_raquo_airstream_extensions_StatusSignal$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_extensions_StatusSignal$.prototype.constructor = $c_Lcom_raquo_airstream_extensions_StatusSignal$;
/** @constructor */
function $h_Lcom_raquo_airstream_extensions_StatusSignal$() {
}
export { $h_Lcom_raquo_airstream_extensions_StatusSignal$ as $h_Lcom_raquo_airstream_extensions_StatusSignal$ };
$h_Lcom_raquo_airstream_extensions_StatusSignal$.prototype = $c_Lcom_raquo_airstream_extensions_StatusSignal$.prototype;
$c_Lcom_raquo_airstream_extensions_StatusSignal$.prototype.splitStatus$extension__Lcom_raquo_airstream_core_Signal__F2__F2__Lcom_raquo_airstream_core_Signal = (function(this$, resolved, pending) {
  return $m_Lcom_raquo_airstream_split_SplittableOneSignal$().splitOne$extension__Lcom_raquo_airstream_core_Signal__F1__F3__Lcom_raquo_airstream_core_Signal(this$, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => _$1.isResolved__Z())), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction3_$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491(((_$2, initial, signal) => initial.fold__F1__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((signal$2) => ((_$3) => resolved.apply__O__O__O(_$3, signal$2)))(signal)), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((signal$3) => ((_$4) => pending.apply__O__O__O(_$4, signal$3)))(signal))))));
});
var $d_Lcom_raquo_airstream_extensions_StatusSignal$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_extensions_StatusSignal$, "com.raquo.airstream.extensions.StatusSignal$", ({
  Lcom_raquo_airstream_extensions_StatusSignal$: 1
}));
export { $d_Lcom_raquo_airstream_extensions_StatusSignal$ as $d_Lcom_raquo_airstream_extensions_StatusSignal$ };
var $n_Lcom_raquo_airstream_extensions_StatusSignal$;
function $m_Lcom_raquo_airstream_extensions_StatusSignal$() {
  if ((!$n_Lcom_raquo_airstream_extensions_StatusSignal$)) {
    $n_Lcom_raquo_airstream_extensions_StatusSignal$ = new $c_Lcom_raquo_airstream_extensions_StatusSignal$();
  }
  return $n_Lcom_raquo_airstream_extensions_StatusSignal$;
}
export { $m_Lcom_raquo_airstream_extensions_StatusSignal$ as $m_Lcom_raquo_airstream_extensions_StatusSignal$ };
/** @constructor */
function $c_Lcom_raquo_airstream_split_DuplicateKeysConfig(_shouldWarn) {
  this.Lcom_raquo_airstream_split_DuplicateKeysConfig__f__shouldWarn = false;
  this.Lcom_raquo_airstream_split_DuplicateKeysConfig__f__shouldWarn = _shouldWarn;
}
export { $c_Lcom_raquo_airstream_split_DuplicateKeysConfig as $c_Lcom_raquo_airstream_split_DuplicateKeysConfig };
$c_Lcom_raquo_airstream_split_DuplicateKeysConfig.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_split_DuplicateKeysConfig.prototype.constructor = $c_Lcom_raquo_airstream_split_DuplicateKeysConfig;
/** @constructor */
function $h_Lcom_raquo_airstream_split_DuplicateKeysConfig() {
}
export { $h_Lcom_raquo_airstream_split_DuplicateKeysConfig as $h_Lcom_raquo_airstream_split_DuplicateKeysConfig };
$h_Lcom_raquo_airstream_split_DuplicateKeysConfig.prototype = $c_Lcom_raquo_airstream_split_DuplicateKeysConfig.prototype;
var $d_Lcom_raquo_airstream_split_DuplicateKeysConfig = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_split_DuplicateKeysConfig, "com.raquo.airstream.split.DuplicateKeysConfig", ({
  Lcom_raquo_airstream_split_DuplicateKeysConfig: 1
}));
export { $d_Lcom_raquo_airstream_split_DuplicateKeysConfig as $d_Lcom_raquo_airstream_split_DuplicateKeysConfig };
/** @constructor */
function $c_Lcom_raquo_airstream_split_DuplicateKeysConfig$() {
  this.Lcom_raquo_airstream_split_DuplicateKeysConfig$__f_default = null;
  this.Lcom_raquo_airstream_split_DuplicateKeysConfig$__f_noWarnings = null;
  $n_Lcom_raquo_airstream_split_DuplicateKeysConfig$ = this;
  this.Lcom_raquo_airstream_split_DuplicateKeysConfig$__f_default = new $c_Lcom_raquo_airstream_split_DuplicateKeysConfig(true);
  this.Lcom_raquo_airstream_split_DuplicateKeysConfig$__f_noWarnings = new $c_Lcom_raquo_airstream_split_DuplicateKeysConfig(false);
}
export { $c_Lcom_raquo_airstream_split_DuplicateKeysConfig$ as $c_Lcom_raquo_airstream_split_DuplicateKeysConfig$ };
$c_Lcom_raquo_airstream_split_DuplicateKeysConfig$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_split_DuplicateKeysConfig$.prototype.constructor = $c_Lcom_raquo_airstream_split_DuplicateKeysConfig$;
/** @constructor */
function $h_Lcom_raquo_airstream_split_DuplicateKeysConfig$() {
}
export { $h_Lcom_raquo_airstream_split_DuplicateKeysConfig$ as $h_Lcom_raquo_airstream_split_DuplicateKeysConfig$ };
$h_Lcom_raquo_airstream_split_DuplicateKeysConfig$.prototype = $c_Lcom_raquo_airstream_split_DuplicateKeysConfig$.prototype;
var $d_Lcom_raquo_airstream_split_DuplicateKeysConfig$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_split_DuplicateKeysConfig$, "com.raquo.airstream.split.DuplicateKeysConfig$", ({
  Lcom_raquo_airstream_split_DuplicateKeysConfig$: 1
}));
export { $d_Lcom_raquo_airstream_split_DuplicateKeysConfig$ as $d_Lcom_raquo_airstream_split_DuplicateKeysConfig$ };
var $n_Lcom_raquo_airstream_split_DuplicateKeysConfig$;
function $m_Lcom_raquo_airstream_split_DuplicateKeysConfig$() {
  if ((!$n_Lcom_raquo_airstream_split_DuplicateKeysConfig$)) {
    $n_Lcom_raquo_airstream_split_DuplicateKeysConfig$ = new $c_Lcom_raquo_airstream_split_DuplicateKeysConfig$();
  }
  return $n_Lcom_raquo_airstream_split_DuplicateKeysConfig$;
}
export { $m_Lcom_raquo_airstream_split_DuplicateKeysConfig$ as $m_Lcom_raquo_airstream_split_DuplicateKeysConfig$ };
function $p_Lcom_raquo_airstream_split_SplitMatchOneMacros$__toSplittableOneObservable__Lcom_raquo_airstream_core_BaseObservable__sci_Seq__Lcom_raquo_airstream_core_Observable($thiz, parentObservable, handlers) {
  matchResult3: {
    var $x_1;
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$is_Lcom_raquo_airstream_core_EventStream(parentObservable)) {
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_EventStream$();
      var $x_1 = $m_Lcom_raquo_airstream_split_SplittableOneStream$().splitOne$extension__Lcom_raquo_airstream_core_EventStream__F1__F3__Lcom_raquo_airstream_core_EventStream(parentObservable, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$14) => (_$14._1__O() | 0))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction3_$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491(((x$1, x$2, x$3) => {
        var x$1$1 = (x$1 | 0);
        var x64 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T3(x$1$1, x$2, x$3);
        var x66 = x64.T3__f__2;
        var idx = (x64.T3__f__1 | 0);
        if ((x66 !== null)) {
          var b = x66._2__O();
          var dataSignal = x64.T3__f__3;
          var project = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$15) => _$15._2__O()));
          var bSignal = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), dataSignal, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
          var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOps__zipWithIndex__O(handlers.view__sc_SeqView()).map__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$16) => _$16.swap__T2())));
          var this$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_$less$colon$less$();
          return $x_2.toMap__s_$less$colon$less__sci_Map(this$3.s_$less$colon$less$__f_singleton).getOrElse__O__F0__O(idx, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalStateException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalStateException(), "Illegal SplitMatchOne state. This is a bug in Airstream.")))).apply__O__O__O(b, bSignal);
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x64);
      })));
      break matchResult3;
    }
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$is_Lcom_raquo_airstream_core_Signal(parentObservable)) {
      var $x_1 = $m_Lcom_raquo_airstream_split_SplittableOneSignal$().splitOne$extension__Lcom_raquo_airstream_core_Signal__F1__F3__Lcom_raquo_airstream_core_Signal(parentObservable, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$18) => (_$18._1__O() | 0))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction3_$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491(((x$1$2, x$2$1, x$3$1) => {
        var x$1$3 = (x$1$2 | 0);
        var x70 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T3(x$1$3, x$2$1, x$3$1);
        var x72 = x70.T3__f__2;
        var idx$1 = (x70.T3__f__1 | 0);
        if ((x72 !== null)) {
          var b$1 = x72._2__O();
          var dataSignal$1 = x70.T3__f__3;
          var project$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$19) => _$19._2__O()));
          var bSignal$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), dataSignal$1, project$1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
          var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOps__zipWithIndex__O(handlers.view__sc_SeqView()).map__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$20) => _$20.swap__T2())));
          var this$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_$less$colon$less$();
          return $x_3.toMap__s_$less$colon$less__sci_Map(this$6.s_$less$colon$less$__f_singleton).getOrElse__O__F0__O(idx$1, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalStateException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalStateException(), "Illegal SplitMatchOne state. This is a bug in Airstream.")))).apply__O__O__O(b$1, bSignal$1);
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x70);
      })));
      break matchResult3;
    }
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Exception__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Exception(), "All Observables must extend EventStream or Signal");
  }
  return $x_1;
}
export { $p_Lcom_raquo_airstream_split_SplitMatchOneMacros$__toSplittableOneObservable__Lcom_raquo_airstream_core_BaseObservable__sci_Seq__Lcom_raquo_airstream_core_Observable as $p_Lcom_raquo_airstream_split_SplitMatchOneMacros$__toSplittableOneObservable__Lcom_raquo_airstream_core_BaseObservable__sci_Seq__Lcom_raquo_airstream_core_Observable };
/** @constructor */
function $c_Lcom_raquo_airstream_split_SplitMatchOneMacros$() {
}
export { $c_Lcom_raquo_airstream_split_SplitMatchOneMacros$ as $c_Lcom_raquo_airstream_split_SplitMatchOneMacros$ };
$c_Lcom_raquo_airstream_split_SplitMatchOneMacros$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_split_SplitMatchOneMacros$.prototype.constructor = $c_Lcom_raquo_airstream_split_SplitMatchOneMacros$;
/** @constructor */
function $h_Lcom_raquo_airstream_split_SplitMatchOneMacros$() {
}
export { $h_Lcom_raquo_airstream_split_SplitMatchOneMacros$ as $h_Lcom_raquo_airstream_split_SplitMatchOneMacros$ };
$h_Lcom_raquo_airstream_split_SplitMatchOneMacros$.prototype = $c_Lcom_raquo_airstream_split_SplitMatchOneMacros$.prototype;
var $d_Lcom_raquo_airstream_split_SplitMatchOneMacros$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_split_SplitMatchOneMacros$, "com.raquo.airstream.split.SplitMatchOneMacros$", ({
  Lcom_raquo_airstream_split_SplitMatchOneMacros$: 1
}));
export { $d_Lcom_raquo_airstream_split_SplitMatchOneMacros$ as $d_Lcom_raquo_airstream_split_SplitMatchOneMacros$ };
var $n_Lcom_raquo_airstream_split_SplitMatchOneMacros$;
function $m_Lcom_raquo_airstream_split_SplitMatchOneMacros$() {
  if ((!$n_Lcom_raquo_airstream_split_SplitMatchOneMacros$)) {
    $n_Lcom_raquo_airstream_split_SplitMatchOneMacros$ = new $c_Lcom_raquo_airstream_split_SplitMatchOneMacros$();
  }
  return $n_Lcom_raquo_airstream_split_SplitMatchOneMacros$;
}
export { $m_Lcom_raquo_airstream_split_SplitMatchOneMacros$ as $m_Lcom_raquo_airstream_split_SplitMatchOneMacros$ };
function $f_Lcom_raquo_airstream_split_Splittable__findUpdate__O__F1__O__O($thiz, inputs, predicate, newItem) {
  var found = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_BooleanRef(false);
  return $thiz.map__O__F1__O(inputs, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((item) => {
    if (((!found.sr_BooleanRef__f_elem) && (!(!predicate.apply__O__O(item))))) {
      found.sr_BooleanRef__f_elem = true;
      return newItem;
    } else {
      return item;
    }
  })));
}
export { $f_Lcom_raquo_airstream_split_Splittable__findUpdate__O__F1__O__O as $f_Lcom_raquo_airstream_split_Splittable__findUpdate__O__F1__O__O };
function $f_Lcom_raquo_airstream_split_Splittable__zipWithIndex__O__O($thiz, inputs) {
  var ix = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_IntRef((-1));
  return $thiz.map__O__F1__O(inputs, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((input) => {
    ix.sr_IntRef__f_elem = ((1 + ix.sr_IntRef__f_elem) | 0);
    var _2 = ix.sr_IntRef__f_elem;
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), input, _2);
  })));
}
export { $f_Lcom_raquo_airstream_split_Splittable__zipWithIndex__O__O as $f_Lcom_raquo_airstream_split_Splittable__zipWithIndex__O__O };
/** @constructor */
function $c_Lcom_raquo_airstream_split_SplittableObservable$() {
}
export { $c_Lcom_raquo_airstream_split_SplittableObservable$ as $c_Lcom_raquo_airstream_split_SplittableObservable$ };
$c_Lcom_raquo_airstream_split_SplittableObservable$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_split_SplittableObservable$.prototype.constructor = $c_Lcom_raquo_airstream_split_SplittableObservable$;
/** @constructor */
function $h_Lcom_raquo_airstream_split_SplittableObservable$() {
}
export { $h_Lcom_raquo_airstream_split_SplittableObservable$ as $h_Lcom_raquo_airstream_split_SplittableObservable$ };
$h_Lcom_raquo_airstream_split_SplittableObservable$.prototype = $c_Lcom_raquo_airstream_split_SplittableObservable$.prototype;
$c_Lcom_raquo_airstream_split_SplittableObservable$.prototype.split$extension__Lcom_raquo_airstream_core_Observable__F1__F1__Lcom_raquo_airstream_split_DuplicateKeysConfig__F3__Lcom_raquo_airstream_split_Splittable__Lcom_raquo_airstream_core_Signal = (function(this$, key, distinctCompose, duplicateKeys, project, splittable) {
  matchResult3: {
    var parentSignal;
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$is_Lcom_raquo_airstream_core_EventStream(this$)) {
      var initial = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => splittable.empty__O()));
      var parentSignal = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_EventStream__toSignal__F0__Z__Lcom_raquo_airstream_core_Signal(this$, initial, true);
      break matchResult3;
    }
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$is_Lcom_raquo_airstream_core_Signal(this$)) {
      var parentSignal = this$;
      break matchResult3;
    }
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Exception__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Exception(), "All Observables must extend EventStream or Signal");
  }
  return new $c_Lcom_raquo_airstream_split_SplitSignal(parentSignal, key, distinctCompose, project, splittable, duplicateKeys, false);
});
$c_Lcom_raquo_airstream_split_SplittableObservable$.prototype.split$default$2$extension__Lcom_raquo_airstream_core_Observable__F1 = (function(this$) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable(_$2)));
});
$c_Lcom_raquo_airstream_split_SplittableObservable$.prototype.splitByIndex$extension__Lcom_raquo_airstream_core_Observable__F3__Lcom_raquo_airstream_split_Splittable__Lcom_raquo_airstream_core_Signal = (function(this$, project, splittable) {
  matchResult3: {
    var $x_1;
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$is_Lcom_raquo_airstream_core_EventStream(this$)) {
      var initial = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => splittable.empty__O()));
      var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_EventStream__toSignal__F0__Z__Lcom_raquo_airstream_core_Signal(this$, initial, true);
      break matchResult3;
    }
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$is_Lcom_raquo_airstream_core_Signal(this$)) {
      var $x_1 = this$;
      break matchResult3;
    }
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Exception__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Exception(), "All Observables must extend EventStream or Signal");
  }
  var this$2 = $x_1;
  var project$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((inputs) => $f_Lcom_raquo_airstream_split_Splittable__zipWithIndex__O__O(splittable, inputs)));
  var parentSignal = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), this$2, project$1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  return new $c_Lcom_raquo_airstream_split_SplitSignal(parentSignal, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$5) => (_$5._2__O() | 0))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$6) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__distinctBy__F1__Lcom_raquo_airstream_core_Observable(_$6, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$7) => _$7._1__O()))))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction3_$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491(((index, initialTuple, tupleSignal) => {
    var index$1 = (index | 0);
    var $x_2 = initialTuple._1__O();
    var project$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$8) => _$8._1__O()));
    return project.apply__O__O__O__O(index$1, $x_2, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), tupleSignal, project$2, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()));
  })), splittable, $m_Lcom_raquo_airstream_split_DuplicateKeysConfig$().Lcom_raquo_airstream_split_DuplicateKeysConfig$__f_noWarnings, false);
});
var $d_Lcom_raquo_airstream_split_SplittableObservable$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_split_SplittableObservable$, "com.raquo.airstream.split.SplittableObservable$", ({
  Lcom_raquo_airstream_split_SplittableObservable$: 1
}));
export { $d_Lcom_raquo_airstream_split_SplittableObservable$ as $d_Lcom_raquo_airstream_split_SplittableObservable$ };
var $n_Lcom_raquo_airstream_split_SplittableObservable$;
function $m_Lcom_raquo_airstream_split_SplittableObservable$() {
  if ((!$n_Lcom_raquo_airstream_split_SplittableObservable$)) {
    $n_Lcom_raquo_airstream_split_SplittableObservable$ = new $c_Lcom_raquo_airstream_split_SplittableObservable$();
  }
  return $n_Lcom_raquo_airstream_split_SplittableObservable$;
}
export { $m_Lcom_raquo_airstream_split_SplittableObservable$ as $m_Lcom_raquo_airstream_split_SplittableObservable$ };
/** @constructor */
function $c_Lcom_raquo_airstream_split_SplittableOneSignal$() {
}
export { $c_Lcom_raquo_airstream_split_SplittableOneSignal$ as $c_Lcom_raquo_airstream_split_SplittableOneSignal$ };
$c_Lcom_raquo_airstream_split_SplittableOneSignal$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_split_SplittableOneSignal$.prototype.constructor = $c_Lcom_raquo_airstream_split_SplittableOneSignal$;
/** @constructor */
function $h_Lcom_raquo_airstream_split_SplittableOneSignal$() {
}
export { $h_Lcom_raquo_airstream_split_SplittableOneSignal$ as $h_Lcom_raquo_airstream_split_SplittableOneSignal$ };
$h_Lcom_raquo_airstream_split_SplittableOneSignal$.prototype = $c_Lcom_raquo_airstream_split_SplittableOneSignal$.prototype;
$c_Lcom_raquo_airstream_split_SplittableOneSignal$.prototype.splitOne$extension__Lcom_raquo_airstream_core_Signal__F1__F3__Lcom_raquo_airstream_core_Signal = (function(this$, key, project) {
  $m_Lcom_raquo_airstream_core_Observable$();
  var project$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(_$1)));
  var observable = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), this$, project$1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var this$4 = $m_Lcom_raquo_airstream_split_SplittableObservable$().split$extension__Lcom_raquo_airstream_core_Observable__F1__F1__Lcom_raquo_airstream_split_DuplicateKeysConfig__F3__Lcom_raquo_airstream_split_Splittable__Lcom_raquo_airstream_core_Signal(observable, key, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x) => x)), $m_Lcom_raquo_airstream_split_DuplicateKeysConfig$().Lcom_raquo_airstream_split_DuplicateKeysConfig$__f_noWarnings, project, $m_Lcom_raquo_airstream_split_Splittable$OptionSplittable$());
  var project$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => _$2.get__O()));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), this$4, project$2, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
var $d_Lcom_raquo_airstream_split_SplittableOneSignal$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_split_SplittableOneSignal$, "com.raquo.airstream.split.SplittableOneSignal$", ({
  Lcom_raquo_airstream_split_SplittableOneSignal$: 1
}));
export { $d_Lcom_raquo_airstream_split_SplittableOneSignal$ as $d_Lcom_raquo_airstream_split_SplittableOneSignal$ };
var $n_Lcom_raquo_airstream_split_SplittableOneSignal$;
function $m_Lcom_raquo_airstream_split_SplittableOneSignal$() {
  if ((!$n_Lcom_raquo_airstream_split_SplittableOneSignal$)) {
    $n_Lcom_raquo_airstream_split_SplittableOneSignal$ = new $c_Lcom_raquo_airstream_split_SplittableOneSignal$();
  }
  return $n_Lcom_raquo_airstream_split_SplittableOneSignal$;
}
export { $m_Lcom_raquo_airstream_split_SplittableOneSignal$ as $m_Lcom_raquo_airstream_split_SplittableOneSignal$ };
/** @constructor */
function $c_Lcom_raquo_airstream_split_SplittableOneStream$() {
}
export { $c_Lcom_raquo_airstream_split_SplittableOneStream$ as $c_Lcom_raquo_airstream_split_SplittableOneStream$ };
$c_Lcom_raquo_airstream_split_SplittableOneStream$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_split_SplittableOneStream$.prototype.constructor = $c_Lcom_raquo_airstream_split_SplittableOneStream$;
/** @constructor */
function $h_Lcom_raquo_airstream_split_SplittableOneStream$() {
}
export { $h_Lcom_raquo_airstream_split_SplittableOneStream$ as $h_Lcom_raquo_airstream_split_SplittableOneStream$ };
$h_Lcom_raquo_airstream_split_SplittableOneStream$.prototype = $c_Lcom_raquo_airstream_split_SplittableOneStream$.prototype;
$c_Lcom_raquo_airstream_split_SplittableOneStream$.prototype.splitOne$extension__Lcom_raquo_airstream_core_EventStream__F1__F3__Lcom_raquo_airstream_core_EventStream = (function(this$, key, project) {
  $m_Lcom_raquo_airstream_core_Observable$();
  var observable = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__toWeakSignal__Lcom_raquo_airstream_core_Signal(this$);
  var this$3 = $m_Lcom_raquo_airstream_split_SplittableObservable$().split$extension__Lcom_raquo_airstream_core_Observable__F1__F1__Lcom_raquo_airstream_split_DuplicateKeysConfig__F3__Lcom_raquo_airstream_split_Splittable__Lcom_raquo_airstream_core_Signal(observable, key, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x) => x)), $m_Lcom_raquo_airstream_split_DuplicateKeysConfig$().Lcom_raquo_airstream_split_DuplicateKeysConfig$__f_noWarnings, project, $m_Lcom_raquo_airstream_split_Splittable$OptionSplittable$());
  var this$4 = new $c_Lcom_raquo_airstream_misc_StreamFromSignal(this$3, true);
  var project$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => _$1.get__O()));
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapStream(this$4, project$1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
var $d_Lcom_raquo_airstream_split_SplittableOneStream$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_split_SplittableOneStream$, "com.raquo.airstream.split.SplittableOneStream$", ({
  Lcom_raquo_airstream_split_SplittableOneStream$: 1
}));
export { $d_Lcom_raquo_airstream_split_SplittableOneStream$ as $d_Lcom_raquo_airstream_split_SplittableOneStream$ };
var $n_Lcom_raquo_airstream_split_SplittableOneStream$;
function $m_Lcom_raquo_airstream_split_SplittableOneStream$() {
  if ((!$n_Lcom_raquo_airstream_split_SplittableOneStream$)) {
    $n_Lcom_raquo_airstream_split_SplittableOneStream$ = new $c_Lcom_raquo_airstream_split_SplittableOneStream$();
  }
  return $n_Lcom_raquo_airstream_split_SplittableOneStream$;
}
export { $m_Lcom_raquo_airstream_split_SplittableOneStream$ as $m_Lcom_raquo_airstream_split_SplittableOneStream$ };
function $f_Lcom_raquo_airstream_state_FrameworkVarExts__maybeUpdate__Lcom_raquo_airstream_state_Var__F1__V($thiz, rxVar, mod) {
  var code = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((trx) => {
    matchResult2: {
      var x10 = rxVar.signal__Lcom_raquo_airstream_state_StrictSignal().tryNow__s_util_Try();
      if ((x10 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success)) {
        var currentValue = x10.s_util_Success__f_value;
        try {
          var r1 = mod.apply__O__O(currentValue);
          var nextValue = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(r1);
        } catch (e) {
          var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
          matchEnd8: {
            var nextValue;
            if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
              var nextValue = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(e$2);
              break matchEnd8;
            }
            throw ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
          }
        }
        if ((nextValue instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success)) {
          var x9 = nextValue.s_util_Success__f_value;
          var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
          if ((x === x9)) {
            break matchResult2;
          }
          if ((x9 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
            var nextValue$2 = x9.s_Some__f_value;
            rxVar.setCurrentValue__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(nextValue$2), trx);
            break matchResult2;
          }
        }
        if ((nextValue instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure)) {
          var err = nextValue.s_util_Failure__f_exception;
          rxVar.setCurrentValue__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(err), trx);
          break matchResult2;
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(nextValue);
      }
      if ((x10 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure)) {
        var err$2 = x10.s_util_Failure__f_exception;
        var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_AirstreamError$();
        var cause = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(err$2);
        $x_1.sendUnhandledError__jl_Throwable__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_core_AirstreamError$VarError("Unable to update a failed Var. Consider Var#tryUpdate instead.", cause));
        break matchResult2;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x10);
    }
  }));
  new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_core_Transaction(code);
}
export { $f_Lcom_raquo_airstream_state_FrameworkVarExts__maybeUpdate__Lcom_raquo_airstream_state_Var__F1__V as $f_Lcom_raquo_airstream_state_FrameworkVarExts__maybeUpdate__Lcom_raquo_airstream_state_Var__F1__V };
/** @constructor */
function $c_Lcom_raquo_airstream_state_Val$() {
}
export { $c_Lcom_raquo_airstream_state_Val$ as $c_Lcom_raquo_airstream_state_Val$ };
$c_Lcom_raquo_airstream_state_Val$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_state_Val$.prototype.constructor = $c_Lcom_raquo_airstream_state_Val$;
/** @constructor */
function $h_Lcom_raquo_airstream_state_Val$() {
}
export { $h_Lcom_raquo_airstream_state_Val$ as $h_Lcom_raquo_airstream_state_Val$ };
$h_Lcom_raquo_airstream_state_Val$.prototype = $c_Lcom_raquo_airstream_state_Val$.prototype;
$c_Lcom_raquo_airstream_state_Val$.prototype.apply__O__Lcom_raquo_airstream_state_Val = (function(value) {
  var value$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(value);
  return new $c_Lcom_raquo_airstream_state_Val(value$1);
});
var $d_Lcom_raquo_airstream_state_Val$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_state_Val$, "com.raquo.airstream.state.Val$", ({
  Lcom_raquo_airstream_state_Val$: 1
}));
export { $d_Lcom_raquo_airstream_state_Val$ as $d_Lcom_raquo_airstream_state_Val$ };
var $n_Lcom_raquo_airstream_state_Val$;
function $m_Lcom_raquo_airstream_state_Val$() {
  if ((!$n_Lcom_raquo_airstream_state_Val$)) {
    $n_Lcom_raquo_airstream_state_Val$ = new $c_Lcom_raquo_airstream_state_Val$();
  }
  return $n_Lcom_raquo_airstream_state_Val$;
}
export { $m_Lcom_raquo_airstream_state_Val$ as $m_Lcom_raquo_airstream_state_Val$ };
/** @constructor */
function $c_Lcom_raquo_airstream_state_VarExts$package$() {
  this.Lcom_raquo_airstream_state_VarExts$package$__f_frameworkVarExts$lzy1 = null;
  this.Lcom_raquo_airstream_state_VarExts$package$__f_frameworkVarExtsbitmap$1 = false;
}
export { $c_Lcom_raquo_airstream_state_VarExts$package$ as $c_Lcom_raquo_airstream_state_VarExts$package$ };
$c_Lcom_raquo_airstream_state_VarExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_state_VarExts$package$.prototype.constructor = $c_Lcom_raquo_airstream_state_VarExts$package$;
/** @constructor */
function $h_Lcom_raquo_airstream_state_VarExts$package$() {
}
export { $h_Lcom_raquo_airstream_state_VarExts$package$ as $h_Lcom_raquo_airstream_state_VarExts$package$ };
$h_Lcom_raquo_airstream_state_VarExts$package$.prototype = $c_Lcom_raquo_airstream_state_VarExts$package$.prototype;
$c_Lcom_raquo_airstream_state_VarExts$package$.prototype.frameworkVarExts__Lcom_raquo_airstream_state_FrameworkVarExts = (function() {
  if ((!this.Lcom_raquo_airstream_state_VarExts$package$__f_frameworkVarExtsbitmap$1)) {
    this.Lcom_raquo_airstream_state_VarExts$package$__f_frameworkVarExts$lzy1 = new $c_Lcom_raquo_airstream_state_VarExts$package$$anon$1();
    this.Lcom_raquo_airstream_state_VarExts$package$__f_frameworkVarExtsbitmap$1 = true;
  }
  return this.Lcom_raquo_airstream_state_VarExts$package$__f_frameworkVarExts$lzy1;
});
var $d_Lcom_raquo_airstream_state_VarExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_state_VarExts$package$, "com.raquo.airstream.state.VarExts$package$", ({
  Lcom_raquo_airstream_state_VarExts$package$: 1
}));
export { $d_Lcom_raquo_airstream_state_VarExts$package$ as $d_Lcom_raquo_airstream_state_VarExts$package$ };
var $n_Lcom_raquo_airstream_state_VarExts$package$;
function $m_Lcom_raquo_airstream_state_VarExts$package$() {
  if ((!$n_Lcom_raquo_airstream_state_VarExts$package$)) {
    $n_Lcom_raquo_airstream_state_VarExts$package$ = new $c_Lcom_raquo_airstream_state_VarExts$package$();
  }
  return $n_Lcom_raquo_airstream_state_VarExts$package$;
}
export { $m_Lcom_raquo_airstream_state_VarExts$package$ as $m_Lcom_raquo_airstream_state_VarExts$package$ };
/** @constructor */
function $c_Lcom_raquo_airstream_web_DomEventStream$() {
}
export { $c_Lcom_raquo_airstream_web_DomEventStream$ as $c_Lcom_raquo_airstream_web_DomEventStream$ };
$c_Lcom_raquo_airstream_web_DomEventStream$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_web_DomEventStream$.prototype.constructor = $c_Lcom_raquo_airstream_web_DomEventStream$;
/** @constructor */
function $h_Lcom_raquo_airstream_web_DomEventStream$() {
}
export { $h_Lcom_raquo_airstream_web_DomEventStream$ as $h_Lcom_raquo_airstream_web_DomEventStream$ };
$h_Lcom_raquo_airstream_web_DomEventStream$.prototype = $c_Lcom_raquo_airstream_web_DomEventStream$.prototype;
$c_Lcom_raquo_airstream_web_DomEventStream$.prototype.apply__Lorg_scalajs_dom_EventTarget__T__Z__Lcom_raquo_airstream_core_EventStream = (function(eventTarget, eventKey, useCapture) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_custom_CustomStreamSource(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction4_$$Lambda$06f9c6daa9fb22f000f9d0ee75fdbad9d7687b0b(((fireValue, _$1, _$2, _$3) => {
    var eventHandler = $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(fireValue);
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_custom_CustomSource$Config$().apply__F0__F0__Lcom_raquo_airstream_custom_CustomSource$Config(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
      eventTarget.addEventListener(eventKey, eventHandler, useCapture);
    })), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
      eventTarget.removeEventListener(eventKey, eventHandler, useCapture);
    })));
  })));
});
var $d_Lcom_raquo_airstream_web_DomEventStream$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_web_DomEventStream$, "com.raquo.airstream.web.DomEventStream$", ({
  Lcom_raquo_airstream_web_DomEventStream$: 1
}));
export { $d_Lcom_raquo_airstream_web_DomEventStream$ as $d_Lcom_raquo_airstream_web_DomEventStream$ };
var $n_Lcom_raquo_airstream_web_DomEventStream$;
function $m_Lcom_raquo_airstream_web_DomEventStream$() {
  if ((!$n_Lcom_raquo_airstream_web_DomEventStream$)) {
    $n_Lcom_raquo_airstream_web_DomEventStream$ = new $c_Lcom_raquo_airstream_web_DomEventStream$();
  }
  return $n_Lcom_raquo_airstream_web_DomEventStream$;
}
export { $m_Lcom_raquo_airstream_web_DomEventStream$ as $m_Lcom_raquo_airstream_web_DomEventStream$ };
/** @constructor */
function $c_Lcom_raquo_laminar_Seq(seq, scalaArray, jsArray) {
  this.Lcom_raquo_laminar_Seq__f_seq = null;
  this.Lcom_raquo_laminar_Seq__f_scalaArray = null;
  this.Lcom_raquo_laminar_Seq__f_jsArray = null;
  this.Lcom_raquo_laminar_Seq__f_seq = seq;
  this.Lcom_raquo_laminar_Seq__f_scalaArray = scalaArray;
  this.Lcom_raquo_laminar_Seq__f_jsArray = jsArray;
}
export { $c_Lcom_raquo_laminar_Seq as $c_Lcom_raquo_laminar_Seq };
$c_Lcom_raquo_laminar_Seq.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_laminar_Seq.prototype.constructor = $c_Lcom_raquo_laminar_Seq;
/** @constructor */
function $h_Lcom_raquo_laminar_Seq() {
}
export { $h_Lcom_raquo_laminar_Seq as $h_Lcom_raquo_laminar_Seq };
$h_Lcom_raquo_laminar_Seq.prototype = $c_Lcom_raquo_laminar_Seq.prototype;
$c_Lcom_raquo_laminar_Seq.prototype.map__F1__Lcom_raquo_laminar_Seq = (function(project) {
  if ((this.Lcom_raquo_laminar_Seq__f_seq !== null)) {
    var jsArr = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([])));
    this.Lcom_raquo_laminar_Seq__f_seq.foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((v) => (jsArr.push(project.apply__O__O(v)) | 0))));
    $m_Lcom_raquo_laminar_Seq$();
    return new $c_Lcom_raquo_laminar_Seq(null, null, jsArr);
  } else if ((this.Lcom_raquo_laminar_Seq__f_jsArray !== null)) {
    $m_Lcom_raquo_laminar_Seq$();
    var jsArray = this.Lcom_raquo_laminar_Seq__f_jsArray.map($m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(project));
    return new $c_Lcom_raquo_laminar_Seq(null, null, jsArray);
  } else {
    var jsArr$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([])));
    var xs = this.Lcom_raquo_laminar_Seq__f_scalaArray;
    var f = ((v$2) => (jsArr$3.push(project.apply__O__O(v$2)) | 0));
    var len = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_reflect_Array$().getLength__O__I(xs);
    var i = 0;
    if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O)) {
      while ((i < len)) {
        var x0 = xs.u[i];
        f(x0);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I)) {
      while ((i < len)) {
        var x0$1 = xs.u[i];
        f(x0$1);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_D)) {
      while ((i < len)) {
        var x0$2 = xs.u[i];
        f(x0$2);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_J)) {
      while ((i < len)) {
        var t = xs.u[i];
        var lo = t.RTLong__f_lo;
        var hi = t.RTLong__f_hi;
        f(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_F)) {
      while ((i < len)) {
        var x0$3 = xs.u[i];
        f(x0$3);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_C)) {
      while ((i < len)) {
        var x0$4 = xs.u[i];
        f($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bC(x0$4));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_B)) {
      while ((i < len)) {
        var x0$5 = xs.u[i];
        f(x0$5);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_S)) {
      while ((i < len)) {
        var x0$6 = xs.u[i];
        f(x0$6);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_Z)) {
      while ((i < len)) {
        var x0$7 = xs.u[i];
        f(x0$7);
        i = ((1 + i) | 0);
      }
    } else {
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(xs);
    }
    $m_Lcom_raquo_laminar_Seq$();
    return new $c_Lcom_raquo_laminar_Seq(null, null, jsArr$3);
  }
});
$c_Lcom_raquo_laminar_Seq.prototype.foreach__F1__V = (function(f) {
  if ((this.Lcom_raquo_laminar_Seq__f_seq !== null)) {
    this.Lcom_raquo_laminar_Seq__f_seq.foreach__F1__V(f);
  } else if ((this.Lcom_raquo_laminar_Seq__f_jsArray !== null)) {
    var arr = this.Lcom_raquo_laminar_Seq__f_jsArray;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_ew_JsArray$RichJsArray$().forEach$extension__Lcom_raquo_ew_JsArray__sjs_js_Function1__V(arr, $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(f));
  } else {
    var xs = this.Lcom_raquo_laminar_Seq__f_scalaArray;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_ArrayOps$().foreach$extension__O__F1__V(xs, f);
  }
});
var $d_Lcom_raquo_laminar_Seq = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_laminar_Seq, "com.raquo.laminar.Seq", ({
  Lcom_raquo_laminar_Seq: 1
}));
export { $d_Lcom_raquo_laminar_Seq as $d_Lcom_raquo_laminar_Seq };
/** @constructor */
function $c_Lcom_raquo_laminar_Seq$() {
}
export { $c_Lcom_raquo_laminar_Seq$ as $c_Lcom_raquo_laminar_Seq$ };
$c_Lcom_raquo_laminar_Seq$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_laminar_Seq$.prototype.constructor = $c_Lcom_raquo_laminar_Seq$;
/** @constructor */
function $h_Lcom_raquo_laminar_Seq$() {
}
export { $h_Lcom_raquo_laminar_Seq$ as $h_Lcom_raquo_laminar_Seq$ };
$h_Lcom_raquo_laminar_Seq$.prototype = $c_Lcom_raquo_laminar_Seq$.prototype;
var $d_Lcom_raquo_laminar_Seq$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_laminar_Seq$, "com.raquo.laminar.Seq$", ({
  Lcom_raquo_laminar_Seq$: 1
}));
export { $d_Lcom_raquo_laminar_Seq$ as $d_Lcom_raquo_laminar_Seq$ };
var $n_Lcom_raquo_laminar_Seq$;
function $m_Lcom_raquo_laminar_Seq$() {
  if ((!$n_Lcom_raquo_laminar_Seq$)) {
    $n_Lcom_raquo_laminar_Seq$ = new $c_Lcom_raquo_laminar_Seq$();
  }
  return $n_Lcom_raquo_laminar_Seq$;
}
export { $m_Lcom_raquo_laminar_Seq$ as $m_Lcom_raquo_laminar_Seq$ };
/** @constructor */
function $c_Lcom_raquo_laminar_api_Implicits$SourceArrowSyntax$() {
}
export { $c_Lcom_raquo_laminar_api_Implicits$SourceArrowSyntax$ as $c_Lcom_raquo_laminar_api_Implicits$SourceArrowSyntax$ };
$c_Lcom_raquo_laminar_api_Implicits$SourceArrowSyntax$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_laminar_api_Implicits$SourceArrowSyntax$.prototype.constructor = $c_Lcom_raquo_laminar_api_Implicits$SourceArrowSyntax$;
/** @constructor */
function $h_Lcom_raquo_laminar_api_Implicits$SourceArrowSyntax$() {
}
export { $h_Lcom_raquo_laminar_api_Implicits$SourceArrowSyntax$ as $h_Lcom_raquo_laminar_api_Implicits$SourceArrowSyntax$ };
$h_Lcom_raquo_laminar_api_Implicits$SourceArrowSyntax$.prototype = $c_Lcom_raquo_laminar_api_Implicits$SourceArrowSyntax$.prototype;
$c_Lcom_raquo_laminar_api_Implicits$SourceArrowSyntax$.prototype.$minus$minus$greater$extension__Lcom_raquo_airstream_core_Source__Lcom_raquo_airstream_core_Sink__Lcom_raquo_laminar_modifiers_Binder = (function(this$, sink) {
  var fn = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$5) => {
    var observable = this$.toObservable__Lcom_raquo_airstream_core_Observable();
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_ownership_DynamicSubscription$().subscribeSink__Lcom_raquo_airstream_ownership_DynamicOwner__Lcom_raquo_airstream_core_Observable__Lcom_raquo_airstream_core_Sink__Lcom_raquo_airstream_ownership_DynamicSubscription(_$5.dynamicOwner__Lcom_raquo_airstream_ownership_DynamicOwner(), observable, sink);
  }));
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_laminar_modifiers_Binder$$anon$1(fn);
});
$c_Lcom_raquo_laminar_api_Implicits$SourceArrowSyntax$.prototype.$minus$minus$greater$extension__Lcom_raquo_airstream_core_Source__F1__Lcom_raquo_laminar_modifiers_Binder = (function(this$, onNext) {
  var fn = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$6) => {
    var observable = this$.toObservable__Lcom_raquo_airstream_core_Observable();
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_ownership_DynamicSubscription$().subscribeFn__Lcom_raquo_airstream_ownership_DynamicOwner__Lcom_raquo_airstream_core_Observable__F1__Lcom_raquo_airstream_ownership_DynamicSubscription(_$6.dynamicOwner__Lcom_raquo_airstream_ownership_DynamicOwner(), observable, onNext);
  }));
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_laminar_modifiers_Binder$$anon$1(fn);
});
var $d_Lcom_raquo_laminar_api_Implicits$SourceArrowSyntax$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_laminar_api_Implicits$SourceArrowSyntax$, "com.raquo.laminar.api.Implicits$SourceArrowSyntax$", ({
  Lcom_raquo_laminar_api_Implicits$SourceArrowSyntax$: 1
}));
export { $d_Lcom_raquo_laminar_api_Implicits$SourceArrowSyntax$ as $d_Lcom_raquo_laminar_api_Implicits$SourceArrowSyntax$ };
var $n_Lcom_raquo_laminar_api_Implicits$SourceArrowSyntax$;
function $m_Lcom_raquo_laminar_api_Implicits$SourceArrowSyntax$() {
  if ((!$n_Lcom_raquo_laminar_api_Implicits$SourceArrowSyntax$)) {
    $n_Lcom_raquo_laminar_api_Implicits$SourceArrowSyntax$ = new $c_Lcom_raquo_laminar_api_Implicits$SourceArrowSyntax$();
  }
  return $n_Lcom_raquo_laminar_api_Implicits$SourceArrowSyntax$;
}
export { $m_Lcom_raquo_laminar_api_Implicits$SourceArrowSyntax$ as $m_Lcom_raquo_laminar_api_Implicits$SourceArrowSyntax$ };
function $p_Lcom_raquo_laminar_inserters_ChildrenInserter$__updateChildren__Lcom_raquo_ew_JsMap__Lcom_raquo_laminar_Seq__Lcom_raquo_ew_JsMap__Lcom_raquo_laminar_nodes_ReactiveElement__Lcom_raquo_laminar_nodes_ChildNode__I__O__I($thiz, prevChildren, nextChildren, nextChildrenMap, parentNode, sentinelNode, prevChildrenCount, hooks) {
  var index = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_IntRef(0);
  var currentChildrenCount = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_IntRef(prevChildrenCount);
  var elem = sentinelNode.ref__Lorg_scalajs_dom_Node().nextSibling;
  var prevChildRef = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_ObjectRef(elem);
  var lastIndexChild = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_ObjectRef(sentinelNode);
  nextChildren.foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((nextChild) => {
    if ((currentChildrenCount.sr_IntRef__f_elem <= index.sr_IntRef__f_elem)) {
      var this$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_domapi_DomApi$();
      var referenceChild = lastIndexChild.sr_ObjectRef__f_elem;
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_laminar_domapi_DomTree__insertChildAfter__Lcom_raquo_laminar_nodes_ParentNode__Lcom_raquo_laminar_nodes_ChildNode__Lcom_raquo_laminar_nodes_ChildNode__O__Z(this$5, parentNode, nextChild, referenceChild, hooks);
      prevChildRef.sr_ObjectRef__f_elem = nextChild.ref__Lorg_scalajs_dom_Node();
      currentChildrenCount.sr_IntRef__f_elem = ((1 + currentChildrenCount.sr_IntRef__f_elem) | 0);
    } else {
      var x = nextChild.ref__Lorg_scalajs_dom_Node();
      var y = prevChildRef.sr_ObjectRef__f_elem;
      if ((!$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y))) {
        if ((!(!(!prevChildren.has(nextChild.ref__Lorg_scalajs_dom_Node()))))) {
          var this$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_domapi_DomApi$();
          var referenceChild$1 = lastIndexChild.sr_ObjectRef__f_elem;
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_laminar_domapi_DomTree__insertChildAfter__Lcom_raquo_laminar_nodes_ParentNode__Lcom_raquo_laminar_nodes_ChildNode__Lcom_raquo_laminar_nodes_ChildNode__O__Z(this$6, parentNode, nextChild, referenceChild$1, hooks);
          prevChildRef.sr_ObjectRef__f_elem = nextChild.ref__Lorg_scalajs_dom_Node();
          currentChildrenCount.sr_IntRef__f_elem = ((1 + currentChildrenCount.sr_IntRef__f_elem) | 0);
        } else {
          while (true) {
            var x$1 = nextChild.ref__Lorg_scalajs_dom_Node();
            var y$1 = prevChildRef.sr_ObjectRef__f_elem;
            if (((!$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y$1)) && (!$p_Lcom_raquo_laminar_inserters_ChildrenInserter$__containsRef__Lcom_raquo_ew_JsMap__Lorg_scalajs_dom_Node__Z($m_Lcom_raquo_laminar_inserters_ChildrenInserter$(), nextChildrenMap, prevChildRef.sr_ObjectRef__f_elem)))) {
              var nextPrevChildRef = prevChildRef.sr_ObjectRef__f_elem.nextSibling;
              var prevChild = $p_Lcom_raquo_laminar_inserters_ChildrenInserter$__prevChildFromRef__Lcom_raquo_ew_JsMap__Lorg_scalajs_dom_Node__Lcom_raquo_laminar_nodes_ChildNode($m_Lcom_raquo_laminar_inserters_ChildrenInserter$(), prevChildren, prevChildRef.sr_ObjectRef__f_elem);
              var this$7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_domapi_DomApi$();
              $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_laminar_domapi_DomTree__removeChild__Lcom_raquo_laminar_nodes_ParentNode__Lcom_raquo_laminar_nodes_ChildNode__Z(this$7, parentNode, prevChild);
              prevChildRef.sr_ObjectRef__f_elem = nextPrevChildRef;
              currentChildrenCount.sr_IntRef__f_elem = (((-1) + currentChildrenCount.sr_IntRef__f_elem) | 0);
            } else {
              break;
            }
          }
          var x$2 = nextChild.ref__Lorg_scalajs_dom_Node();
          var y$2 = prevChildRef.sr_ObjectRef__f_elem;
          if ((!$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x$2, y$2))) {
            var this$8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_domapi_DomApi$();
            var referenceChild$2 = lastIndexChild.sr_ObjectRef__f_elem;
            $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_laminar_domapi_DomTree__insertChildAfter__Lcom_raquo_laminar_nodes_ParentNode__Lcom_raquo_laminar_nodes_ChildNode__Lcom_raquo_laminar_nodes_ChildNode__O__Z(this$8, parentNode, nextChild, referenceChild$2, hooks);
            prevChildRef.sr_ObjectRef__f_elem = nextChild.ref__Lorg_scalajs_dom_Node();
          }
        }
      }
    }
    if ((prevChildRef.sr_ObjectRef__f_elem.nextSibling === null)) {
      currentChildrenCount.sr_IntRef__f_elem = ((1 + index.sr_IntRef__f_elem) | 0);
    } else {
      prevChildRef.sr_ObjectRef__f_elem = prevChildRef.sr_ObjectRef__f_elem.nextSibling;
    }
    lastIndexChild.sr_ObjectRef__f_elem = nextChild;
    index.sr_IntRef__f_elem = ((1 + index.sr_IntRef__f_elem) | 0);
  })));
  while ((index.sr_IntRef__f_elem < currentChildrenCount.sr_IntRef__f_elem)) {
    var nextPrevChildRef$1 = prevChildRef.sr_ObjectRef__f_elem.nextSibling;
    var prevChild$1 = $p_Lcom_raquo_laminar_inserters_ChildrenInserter$__prevChildFromRef__Lcom_raquo_ew_JsMap__Lorg_scalajs_dom_Node__Lcom_raquo_laminar_nodes_ChildNode($thiz, prevChildren, prevChildRef.sr_ObjectRef__f_elem);
    var this$9 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_domapi_DomApi$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_laminar_domapi_DomTree__removeChild__Lcom_raquo_laminar_nodes_ParentNode__Lcom_raquo_laminar_nodes_ChildNode__Z(this$9, parentNode, prevChild$1);
    prevChildRef.sr_ObjectRef__f_elem = nextPrevChildRef$1;
    currentChildrenCount.sr_IntRef__f_elem = (((-1) + currentChildrenCount.sr_IntRef__f_elem) | 0);
  }
  return currentChildrenCount.sr_IntRef__f_elem;
}
export { $p_Lcom_raquo_laminar_inserters_ChildrenInserter$__updateChildren__Lcom_raquo_ew_JsMap__Lcom_raquo_laminar_Seq__Lcom_raquo_ew_JsMap__Lcom_raquo_laminar_nodes_ReactiveElement__Lcom_raquo_laminar_nodes_ChildNode__I__O__I as $p_Lcom_raquo_laminar_inserters_ChildrenInserter$__updateChildren__Lcom_raquo_ew_JsMap__Lcom_raquo_laminar_Seq__Lcom_raquo_ew_JsMap__Lcom_raquo_laminar_nodes_ReactiveElement__Lcom_raquo_laminar_nodes_ChildNode__I__O__I };
function $p_Lcom_raquo_laminar_inserters_ChildrenInserter$__containsRef__Lcom_raquo_ew_JsMap__Lorg_scalajs_dom_Node__Z($thiz, nextChildrenMap, ref) {
  return (!(!nextChildrenMap.has(ref)));
}
export { $p_Lcom_raquo_laminar_inserters_ChildrenInserter$__containsRef__Lcom_raquo_ew_JsMap__Lorg_scalajs_dom_Node__Z as $p_Lcom_raquo_laminar_inserters_ChildrenInserter$__containsRef__Lcom_raquo_ew_JsMap__Lorg_scalajs_dom_Node__Z };
function $p_Lcom_raquo_laminar_inserters_ChildrenInserter$__prevChildFromRef__Lcom_raquo_ew_JsMap__Lorg_scalajs_dom_Node__Lcom_raquo_laminar_nodes_ChildNode($thiz, prevChildren, ref) {
  var x = prevChildren.get(ref);
  if ((x === (void 0))) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Exception__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Exception(), ("prevChildFromRef[children]: not found for " + ref));
  }
  return x;
}
export { $p_Lcom_raquo_laminar_inserters_ChildrenInserter$__prevChildFromRef__Lcom_raquo_ew_JsMap__Lorg_scalajs_dom_Node__Lcom_raquo_laminar_nodes_ChildNode as $p_Lcom_raquo_laminar_inserters_ChildrenInserter$__prevChildFromRef__Lcom_raquo_ew_JsMap__Lorg_scalajs_dom_Node__Lcom_raquo_laminar_nodes_ChildNode };
/** @constructor */
function $c_Lcom_raquo_laminar_inserters_ChildrenInserter$() {
}
export { $c_Lcom_raquo_laminar_inserters_ChildrenInserter$ as $c_Lcom_raquo_laminar_inserters_ChildrenInserter$ };
$c_Lcom_raquo_laminar_inserters_ChildrenInserter$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_laminar_inserters_ChildrenInserter$.prototype.constructor = $c_Lcom_raquo_laminar_inserters_ChildrenInserter$;
/** @constructor */
function $h_Lcom_raquo_laminar_inserters_ChildrenInserter$() {
}
export { $h_Lcom_raquo_laminar_inserters_ChildrenInserter$ as $h_Lcom_raquo_laminar_inserters_ChildrenInserter$ };
$h_Lcom_raquo_laminar_inserters_ChildrenInserter$.prototype = $c_Lcom_raquo_laminar_inserters_ChildrenInserter$.prototype;
$c_Lcom_raquo_laminar_inserters_ChildrenInserter$.prototype.apply__Lcom_raquo_airstream_core_Observable__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_RenderableNode__O__Lcom_raquo_laminar_inserters_DynamicInserter = (function(childrenSource, renderableSeq, renderableNode, initialHooks) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_laminar_inserters_DynamicInserter($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$(), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction3_$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491(((ctx, owner, hooks) => {
    ctx.ensureStrictMode__V();
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(childrenSource, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((ctx$2) => ((components) => {
      var newChildren = renderableNode.asNodeSeq__Lcom_raquo_laminar_Seq__Lcom_raquo_laminar_Seq(renderableSeq.toSeq__O__Lcom_raquo_laminar_Seq(components));
      $m_Lcom_raquo_laminar_inserters_ChildrenInserter$().switchToChildren__Lcom_raquo_laminar_Seq__Lcom_raquo_laminar_inserters_InsertContext__O__V(newChildren, ctx$2, hooks);
    }))(ctx)), owner);
  })), initialHooks);
});
$c_Lcom_raquo_laminar_inserters_ChildrenInserter$.prototype.switchToChildren__Lcom_raquo_laminar_Seq__Lcom_raquo_laminar_inserters_InsertContext__O__V = (function(newChildren, ctx, hooks) {
  ctx.ensureStrictMode__V();
  var newChildrenMap = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_inserters_InsertContext$().nodesToMap__Lcom_raquo_laminar_Seq__Lcom_raquo_ew_JsMap(newChildren);
  ctx.Lcom_raquo_laminar_inserters_InsertContext__f_extraNodeCount = $p_Lcom_raquo_laminar_inserters_ChildrenInserter$__updateChildren__Lcom_raquo_ew_JsMap__Lcom_raquo_laminar_Seq__Lcom_raquo_ew_JsMap__Lcom_raquo_laminar_nodes_ReactiveElement__Lcom_raquo_laminar_nodes_ChildNode__I__O__I(this, ctx.Lcom_raquo_laminar_inserters_InsertContext__f_extraNodesMap, newChildren, newChildrenMap, ctx.Lcom_raquo_laminar_inserters_InsertContext__f_parentNode, ctx.Lcom_raquo_laminar_inserters_InsertContext__f_sentinelNode, ctx.Lcom_raquo_laminar_inserters_InsertContext__f_extraNodeCount, hooks);
  ctx.Lcom_raquo_laminar_inserters_InsertContext__f_extraNodesMap = newChildrenMap;
});
var $d_Lcom_raquo_laminar_inserters_ChildrenInserter$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_laminar_inserters_ChildrenInserter$, "com.raquo.laminar.inserters.ChildrenInserter$", ({
  Lcom_raquo_laminar_inserters_ChildrenInserter$: 1
}));
export { $d_Lcom_raquo_laminar_inserters_ChildrenInserter$ as $d_Lcom_raquo_laminar_inserters_ChildrenInserter$ };
var $n_Lcom_raquo_laminar_inserters_ChildrenInserter$;
function $m_Lcom_raquo_laminar_inserters_ChildrenInserter$() {
  if ((!$n_Lcom_raquo_laminar_inserters_ChildrenInserter$)) {
    $n_Lcom_raquo_laminar_inserters_ChildrenInserter$ = new $c_Lcom_raquo_laminar_inserters_ChildrenInserter$();
  }
  return $n_Lcom_raquo_laminar_inserters_ChildrenInserter$;
}
export { $m_Lcom_raquo_laminar_inserters_ChildrenInserter$ as $m_Lcom_raquo_laminar_inserters_ChildrenInserter$ };
/** @constructor */
function $c_Lcom_raquo_laminar_inserters_StaticChildInserter$() {
}
export { $c_Lcom_raquo_laminar_inserters_StaticChildInserter$ as $c_Lcom_raquo_laminar_inserters_StaticChildInserter$ };
$c_Lcom_raquo_laminar_inserters_StaticChildInserter$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_laminar_inserters_StaticChildInserter$.prototype.constructor = $c_Lcom_raquo_laminar_inserters_StaticChildInserter$;
/** @constructor */
function $h_Lcom_raquo_laminar_inserters_StaticChildInserter$() {
}
export { $h_Lcom_raquo_laminar_inserters_StaticChildInserter$ as $h_Lcom_raquo_laminar_inserters_StaticChildInserter$ };
$h_Lcom_raquo_laminar_inserters_StaticChildInserter$.prototype = $c_Lcom_raquo_laminar_inserters_StaticChildInserter$.prototype;
$c_Lcom_raquo_laminar_inserters_StaticChildInserter$.prototype.noHooksC__O__Lcom_raquo_laminar_modifiers_RenderableNode__Lcom_raquo_laminar_inserters_StaticChildInserter = (function(component, renderable) {
  return new $c_Lcom_raquo_laminar_inserters_StaticChildInserter(renderable.asNode__O__Lcom_raquo_laminar_nodes_ChildNode(component), (void 0));
});
var $d_Lcom_raquo_laminar_inserters_StaticChildInserter$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_laminar_inserters_StaticChildInserter$, "com.raquo.laminar.inserters.StaticChildInserter$", ({
  Lcom_raquo_laminar_inserters_StaticChildInserter$: 1
}));
export { $d_Lcom_raquo_laminar_inserters_StaticChildInserter$ as $d_Lcom_raquo_laminar_inserters_StaticChildInserter$ };
var $n_Lcom_raquo_laminar_inserters_StaticChildInserter$;
function $m_Lcom_raquo_laminar_inserters_StaticChildInserter$() {
  if ((!$n_Lcom_raquo_laminar_inserters_StaticChildInserter$)) {
    $n_Lcom_raquo_laminar_inserters_StaticChildInserter$ = new $c_Lcom_raquo_laminar_inserters_StaticChildInserter$();
  }
  return $n_Lcom_raquo_laminar_inserters_StaticChildInserter$;
}
export { $m_Lcom_raquo_laminar_inserters_StaticChildInserter$ as $m_Lcom_raquo_laminar_inserters_StaticChildInserter$ };
/** @constructor */
function $c_Lcom_raquo_laminar_keys_EventProcessor(eventProp, shouldUseCapture, shouldBePassive, processor) {
  this.Lcom_raquo_laminar_keys_EventProcessor__f_eventProp = null;
  this.Lcom_raquo_laminar_keys_EventProcessor__f_shouldUseCapture = false;
  this.Lcom_raquo_laminar_keys_EventProcessor__f_shouldBePassive = false;
  this.Lcom_raquo_laminar_keys_EventProcessor__f_processor = null;
  this.Lcom_raquo_laminar_keys_EventProcessor__f_eventProp = eventProp;
  this.Lcom_raquo_laminar_keys_EventProcessor__f_shouldUseCapture = shouldUseCapture;
  this.Lcom_raquo_laminar_keys_EventProcessor__f_shouldBePassive = shouldBePassive;
  this.Lcom_raquo_laminar_keys_EventProcessor__f_processor = processor;
}
export { $c_Lcom_raquo_laminar_keys_EventProcessor as $c_Lcom_raquo_laminar_keys_EventProcessor };
$c_Lcom_raquo_laminar_keys_EventProcessor.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_laminar_keys_EventProcessor.prototype.constructor = $c_Lcom_raquo_laminar_keys_EventProcessor;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_EventProcessor() {
}
export { $h_Lcom_raquo_laminar_keys_EventProcessor as $h_Lcom_raquo_laminar_keys_EventProcessor };
$h_Lcom_raquo_laminar_keys_EventProcessor.prototype = $c_Lcom_raquo_laminar_keys_EventProcessor.prototype;
$c_Lcom_raquo_laminar_keys_EventProcessor.prototype.preventDefault__Lcom_raquo_laminar_keys_EventProcessor = (function() {
  var newProcessor = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((ev) => {
    var this$2 = this.Lcom_raquo_laminar_keys_EventProcessor__f_processor.apply__O__O(ev);
    if (this$2.isEmpty__Z()) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    } else {
      var x0 = this$2.get__O();
      ev.preventDefault();
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(x0);
    }
  }));
  return new $c_Lcom_raquo_laminar_keys_EventProcessor(this.Lcom_raquo_laminar_keys_EventProcessor__f_eventProp, this.Lcom_raquo_laminar_keys_EventProcessor__f_shouldUseCapture, this.Lcom_raquo_laminar_keys_EventProcessor__f_shouldBePassive, newProcessor);
});
$c_Lcom_raquo_laminar_keys_EventProcessor.prototype.filter__F1__Lcom_raquo_laminar_keys_EventProcessor = (function(passes) {
  var newProcessor = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((ev) => {
    var this$2 = this.Lcom_raquo_laminar_keys_EventProcessor__f_processor.apply__O__O(ev);
    return ((this$2.isEmpty__Z() || (!(!passes.apply__O__O(this$2.get__O())))) ? this$2 : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  }));
  return new $c_Lcom_raquo_laminar_keys_EventProcessor(this.Lcom_raquo_laminar_keys_EventProcessor__f_eventProp, this.Lcom_raquo_laminar_keys_EventProcessor__f_shouldUseCapture, this.Lcom_raquo_laminar_keys_EventProcessor__f_shouldBePassive, newProcessor);
});
$c_Lcom_raquo_laminar_keys_EventProcessor.prototype.collect__s_PartialFunction__Lcom_raquo_laminar_keys_EventProcessor = (function(pf) {
  var newProcessor = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((ev) => {
    var this$2 = this.Lcom_raquo_laminar_keys_EventProcessor__f_processor.apply__O__O(ev);
    return ((!this$2.isEmpty__Z()) ? pf.lift__F1().apply__O__O(this$2.get__O()) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  }));
  return new $c_Lcom_raquo_laminar_keys_EventProcessor(this.Lcom_raquo_laminar_keys_EventProcessor__f_eventProp, this.Lcom_raquo_laminar_keys_EventProcessor__f_shouldUseCapture, this.Lcom_raquo_laminar_keys_EventProcessor__f_shouldBePassive, newProcessor);
});
$c_Lcom_raquo_laminar_keys_EventProcessor.prototype.map__F1__Lcom_raquo_laminar_keys_EventProcessor = (function(project) {
  var newProcessor = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((ev) => {
    var this$2 = this.Lcom_raquo_laminar_keys_EventProcessor__f_processor.apply__O__O(ev);
    return (this$2.isEmpty__Z() ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$() : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(project.apply__O__O(this$2.get__O())));
  }));
  return new $c_Lcom_raquo_laminar_keys_EventProcessor(this.Lcom_raquo_laminar_keys_EventProcessor__f_eventProp, this.Lcom_raquo_laminar_keys_EventProcessor__f_shouldUseCapture, this.Lcom_raquo_laminar_keys_EventProcessor__f_shouldBePassive, newProcessor);
});
$c_Lcom_raquo_laminar_keys_EventProcessor.prototype.mapToValue__Lcom_raquo_laminar_keys_EventProcessor = (function() {
  var newProcessor = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((ev) => {
    var this$2 = this.Lcom_raquo_laminar_keys_EventProcessor__f_processor.apply__O__O(ev);
    if (this$2.isEmpty__Z()) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    } else {
      this$2.get__O();
      var this$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_domapi_DomApi$();
      var element = ev.target;
      var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_laminar_domapi_DomInputs__getValue__Lorg_scalajs_dom_Element__O(this$3, element);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(((x === (void 0)) ? "" : x));
    }
  }));
  return new $c_Lcom_raquo_laminar_keys_EventProcessor(this.Lcom_raquo_laminar_keys_EventProcessor__f_eventProp, this.Lcom_raquo_laminar_keys_EventProcessor__f_shouldUseCapture, this.Lcom_raquo_laminar_keys_EventProcessor__f_shouldBePassive, newProcessor);
});
$c_Lcom_raquo_laminar_keys_EventProcessor.prototype.mapToChecked__Lcom_raquo_laminar_keys_EventProcessor = (function() {
  var newProcessor = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((ev) => {
    var this$2 = this.Lcom_raquo_laminar_keys_EventProcessor__f_processor.apply__O__O(ev);
    if (this$2.isEmpty__Z()) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    } else {
      this$2.get__O();
      var this$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_domapi_DomApi$();
      var element = ev.target;
      var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_laminar_domapi_DomInputs__getChecked__Lorg_scalajs_dom_Element__O(this$3, element);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some((!(!((x === (void 0)) ? false : x))));
    }
  }));
  return new $c_Lcom_raquo_laminar_keys_EventProcessor(this.Lcom_raquo_laminar_keys_EventProcessor__f_eventProp, this.Lcom_raquo_laminar_keys_EventProcessor__f_shouldUseCapture, this.Lcom_raquo_laminar_keys_EventProcessor__f_shouldBePassive, newProcessor);
});
$c_Lcom_raquo_laminar_keys_EventProcessor.prototype.orElseEval__F1__Lcom_raquo_laminar_keys_EventProcessor = (function(f) {
  var newProcessor = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((ev) => {
    var result = this.Lcom_raquo_laminar_keys_EventProcessor__f_processor.apply__O__O(ev);
    if (result.isEmpty__Z()) {
      f.apply__O__O(ev);
    }
    return result;
  }));
  return new $c_Lcom_raquo_laminar_keys_EventProcessor(this.Lcom_raquo_laminar_keys_EventProcessor__f_eventProp, this.Lcom_raquo_laminar_keys_EventProcessor__f_shouldUseCapture, this.Lcom_raquo_laminar_keys_EventProcessor__f_shouldBePassive, newProcessor);
});
var $d_Lcom_raquo_laminar_keys_EventProcessor = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_laminar_keys_EventProcessor, "com.raquo.laminar.keys.EventProcessor", ({
  Lcom_raquo_laminar_keys_EventProcessor: 1
}));
export { $d_Lcom_raquo_laminar_keys_EventProcessor as $d_Lcom_raquo_laminar_keys_EventProcessor };
/** @constructor */
function $c_Lcom_raquo_laminar_keys_EventProcessor$() {
}
export { $c_Lcom_raquo_laminar_keys_EventProcessor$ as $c_Lcom_raquo_laminar_keys_EventProcessor$ };
$c_Lcom_raquo_laminar_keys_EventProcessor$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_laminar_keys_EventProcessor$.prototype.constructor = $c_Lcom_raquo_laminar_keys_EventProcessor$;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_EventProcessor$() {
}
export { $h_Lcom_raquo_laminar_keys_EventProcessor$ as $h_Lcom_raquo_laminar_keys_EventProcessor$ };
$h_Lcom_raquo_laminar_keys_EventProcessor$.prototype = $c_Lcom_raquo_laminar_keys_EventProcessor$.prototype;
$c_Lcom_raquo_laminar_keys_EventProcessor$.prototype.empty__Lcom_raquo_laminar_keys_EventProp__Z__Z__Lcom_raquo_laminar_keys_EventProcessor = (function(eventProp, shouldUseCapture, shouldBePassive) {
  return new $c_Lcom_raquo_laminar_keys_EventProcessor(eventProp, shouldUseCapture, shouldBePassive, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$14) => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(_$14))));
});
var $d_Lcom_raquo_laminar_keys_EventProcessor$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_laminar_keys_EventProcessor$, "com.raquo.laminar.keys.EventProcessor$", ({
  Lcom_raquo_laminar_keys_EventProcessor$: 1
}));
export { $d_Lcom_raquo_laminar_keys_EventProcessor$ as $d_Lcom_raquo_laminar_keys_EventProcessor$ };
var $n_Lcom_raquo_laminar_keys_EventProcessor$;
function $m_Lcom_raquo_laminar_keys_EventProcessor$() {
  if ((!$n_Lcom_raquo_laminar_keys_EventProcessor$)) {
    $n_Lcom_raquo_laminar_keys_EventProcessor$ = new $c_Lcom_raquo_laminar_keys_EventProcessor$();
  }
  return $n_Lcom_raquo_laminar_keys_EventProcessor$;
}
export { $m_Lcom_raquo_laminar_keys_EventProcessor$ as $m_Lcom_raquo_laminar_keys_EventProcessor$ };
/** @constructor */
function $c_Lcom_raquo_laminar_keys_LockedEventKey(eventProcessor, composer) {
  this.Lcom_raquo_laminar_keys_LockedEventKey__f_eventProcessor = null;
  this.Lcom_raquo_laminar_keys_LockedEventKey__f_composer = null;
  this.Lcom_raquo_laminar_keys_LockedEventKey__f_eventProcessor = eventProcessor;
  this.Lcom_raquo_laminar_keys_LockedEventKey__f_composer = composer;
}
export { $c_Lcom_raquo_laminar_keys_LockedEventKey as $c_Lcom_raquo_laminar_keys_LockedEventKey };
$c_Lcom_raquo_laminar_keys_LockedEventKey.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_laminar_keys_LockedEventKey.prototype.constructor = $c_Lcom_raquo_laminar_keys_LockedEventKey;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_LockedEventKey() {
}
export { $h_Lcom_raquo_laminar_keys_LockedEventKey as $h_Lcom_raquo_laminar_keys_LockedEventKey };
$h_Lcom_raquo_laminar_keys_LockedEventKey.prototype = $c_Lcom_raquo_laminar_keys_LockedEventKey.prototype;
$c_Lcom_raquo_laminar_keys_LockedEventKey.prototype.$minus$minus$greater__Lcom_raquo_airstream_core_Sink__Lcom_raquo_laminar_modifiers_Binder = (function(sink) {
  var fn = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((el) => {
    var observable = this.Lcom_raquo_laminar_keys_LockedEventKey__f_composer.apply__O__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_laminar_nodes_ReactiveElement__events__Lcom_raquo_laminar_keys_EventProcessor__Lcom_raquo_airstream_core_EventStream(el, this.Lcom_raquo_laminar_keys_LockedEventKey__f_eventProcessor));
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_ownership_DynamicSubscription$().subscribeSink__Lcom_raquo_airstream_ownership_DynamicOwner__Lcom_raquo_airstream_core_Observable__Lcom_raquo_airstream_core_Sink__Lcom_raquo_airstream_ownership_DynamicSubscription(el.dynamicOwner__Lcom_raquo_airstream_ownership_DynamicOwner(), observable, sink);
  }));
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_laminar_modifiers_Binder$$anon$1(fn);
});
var $d_Lcom_raquo_laminar_keys_LockedEventKey = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_laminar_keys_LockedEventKey, "com.raquo.laminar.keys.LockedEventKey", ({
  Lcom_raquo_laminar_keys_LockedEventKey: 1
}));
export { $d_Lcom_raquo_laminar_keys_LockedEventKey as $d_Lcom_raquo_laminar_keys_LockedEventKey };
var $d_Lcom_raquo_laminar_modifiers_Modifier = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass(1, "com.raquo.laminar.modifiers.Modifier", ({
  Lcom_raquo_laminar_modifiers_Modifier: 1
}));
export { $d_Lcom_raquo_laminar_modifiers_Modifier as $d_Lcom_raquo_laminar_modifiers_Modifier };
/** @constructor */
function $c_Lcom_raquo_laminar_nodes_TextNode$() {
}
export { $c_Lcom_raquo_laminar_nodes_TextNode$ as $c_Lcom_raquo_laminar_nodes_TextNode$ };
$c_Lcom_raquo_laminar_nodes_TextNode$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_laminar_nodes_TextNode$.prototype.constructor = $c_Lcom_raquo_laminar_nodes_TextNode$;
/** @constructor */
function $h_Lcom_raquo_laminar_nodes_TextNode$() {
}
export { $h_Lcom_raquo_laminar_nodes_TextNode$ as $h_Lcom_raquo_laminar_nodes_TextNode$ };
$h_Lcom_raquo_laminar_nodes_TextNode$.prototype = $c_Lcom_raquo_laminar_nodes_TextNode$.prototype;
$c_Lcom_raquo_laminar_nodes_TextNode$.prototype.apply__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode = (function(initialContent, r) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_laminar_nodes_TextNode(r.asString__O__T(initialContent));
});
var $d_Lcom_raquo_laminar_nodes_TextNode$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_laminar_nodes_TextNode$, "com.raquo.laminar.nodes.TextNode$", ({
  Lcom_raquo_laminar_nodes_TextNode$: 1
}));
export { $d_Lcom_raquo_laminar_nodes_TextNode$ as $d_Lcom_raquo_laminar_nodes_TextNode$ };
var $n_Lcom_raquo_laminar_nodes_TextNode$;
function $m_Lcom_raquo_laminar_nodes_TextNode$() {
  if ((!$n_Lcom_raquo_laminar_nodes_TextNode$)) {
    $n_Lcom_raquo_laminar_nodes_TextNode$ = new $c_Lcom_raquo_laminar_nodes_TextNode$();
  }
  return $n_Lcom_raquo_laminar_nodes_TextNode$;
}
export { $m_Lcom_raquo_laminar_nodes_TextNode$ as $m_Lcom_raquo_laminar_nodes_TextNode$ };
function $ct_Lcom_raquo_waypoint_Route__T__($thiz, basePath) {
  $thiz.Lcom_raquo_waypoint_Route__f_basePath = basePath;
  if (((basePath !== "") && (!(!(!basePath.startsWith("/")))))) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Exception__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Exception(), (("Route's basePath, when not empty, must start with `/`. basePath is `" + basePath) + "` for this route."));
  }
  return $thiz;
}
export { $ct_Lcom_raquo_waypoint_Route__T__ as $ct_Lcom_raquo_waypoint_Route__T__ };
function $p_Lcom_raquo_waypoint_Route__encodeOpt__O__s_Option($thiz, page) {
  return $thiz.Lcom_raquo_waypoint_Route$Total__f_matchEncodePF.andThen__F1__s_PartialFunction(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(_$1)))).applyOrElse__O__F1__O(page, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$())));
}
export { $p_Lcom_raquo_waypoint_Route__encodeOpt__O__s_Option as $p_Lcom_raquo_waypoint_Route__encodeOpt__O__s_Option };
function $p_Lcom_raquo_waypoint_Route__decodeOpt__O__s_Option($thiz, args) {
  return $thiz.Lcom_raquo_waypoint_Route$Total__f_decodePF.andThen__F1__s_PartialFunction(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$3) => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(_$3)))).applyOrElse__O__F1__O(args, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$4) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$())));
}
export { $p_Lcom_raquo_waypoint_Route__decodeOpt__O__s_Option as $p_Lcom_raquo_waypoint_Route__decodeOpt__O__s_Option };
/** @constructor */
function $c_Lcom_raquo_waypoint_Route() {
  this.Lcom_raquo_waypoint_Route__f_basePath = null;
}
export { $c_Lcom_raquo_waypoint_Route as $c_Lcom_raquo_waypoint_Route };
$c_Lcom_raquo_waypoint_Route.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_waypoint_Route.prototype.constructor = $c_Lcom_raquo_waypoint_Route;
/** @constructor */
function $h_Lcom_raquo_waypoint_Route() {
}
export { $h_Lcom_raquo_waypoint_Route as $h_Lcom_raquo_waypoint_Route };
$h_Lcom_raquo_waypoint_Route.prototype = $c_Lcom_raquo_waypoint_Route.prototype;
$c_Lcom_raquo_waypoint_Route.prototype.relativeUrlForPage__O__s_Option = (function(page) {
  var this$1 = $p_Lcom_raquo_waypoint_Route__encodeOpt__O__s_Option(this, page);
  if (this$1.isEmpty__Z()) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0 = this$1.get__O();
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(this.relativeUrlForArgs__O__T(x0));
  }
});
$c_Lcom_raquo_waypoint_Route.prototype.relativeUrlForArgs__O__T = (function(args) {
  return (("" + this.Lcom_raquo_waypoint_Route__f_basePath) + this.Lcom_raquo_waypoint_Route$Total__f_createRelativeUrl.apply__O__O(args));
});
$c_Lcom_raquo_waypoint_Route.prototype.pageForRelativeUrl__T__T__s_Option = (function(origin, url) {
  if ((origin === "null")) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Exception__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Exception(), "pageForRelativeUrl was provided with a \"null\" origin. See https://github.com/raquo/Waypoint#firefox-and-file-urls");
  }
  if ((!((!(!url.startsWith("/"))) && (!(!(!url.startsWith("//"))))))) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Exception__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Exception(), (("Relative URL must be relative to the origin, i.e. it must start with /, whereas `" + url) + "` was given."));
  }
  var prefix = this.Lcom_raquo_waypoint_Route__f_basePath;
  if ((!(!url.startsWith(prefix)))) {
    var this$2 = this.Lcom_raquo_waypoint_Route__f_basePath;
    var beginIndex = this$2.length;
    var urlWithoutBasePath = url.substring(beginIndex);
    var this$3 = this.Lcom_raquo_waypoint_Route$Total__f_matchRelativeUrl.apply__O__O((("" + origin) + urlWithoutBasePath));
    if (this$3.isEmpty__Z()) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    } else {
      var x0 = this$3.get__O();
      return $p_Lcom_raquo_waypoint_Route__decodeOpt__O__s_Option(this, x0);
    }
  } else if (($m_Lcom_raquo_waypoint_Utils$().basePathHasEmptyFragment__T__Z(this.Lcom_raquo_waypoint_Route__f_basePath) && (url === $m_Lcom_raquo_waypoint_Utils$().basePathWithoutFragment__T__T(this.Lcom_raquo_waypoint_Route__f_basePath)))) {
    var this$4 = this.Lcom_raquo_waypoint_Route$Total__f_matchRelativeUrl.apply__O__O(origin);
    if (this$4.isEmpty__Z()) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    } else {
      var x0$1 = this$4.get__O();
      return $p_Lcom_raquo_waypoint_Route__decodeOpt__O__s_Option(this, x0$1);
    }
  } else {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
});
/** @constructor */
function $c_Lcom_raquo_waypoint_Route$() {
}
export { $c_Lcom_raquo_waypoint_Route$ as $c_Lcom_raquo_waypoint_Route$ };
$c_Lcom_raquo_waypoint_Route$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_waypoint_Route$.prototype.constructor = $c_Lcom_raquo_waypoint_Route$;
/** @constructor */
function $h_Lcom_raquo_waypoint_Route$() {
}
export { $h_Lcom_raquo_waypoint_Route$ as $h_Lcom_raquo_waypoint_Route$ };
$h_Lcom_raquo_waypoint_Route$.prototype = $c_Lcom_raquo_waypoint_Route$.prototype;
$c_Lcom_raquo_waypoint_Route$.prototype.apply__F1__F1__Lurldsl_language_PathSegment__T__s_reflect_ClassTag__Lcom_raquo_waypoint_Route$Total = (function(encode, decode, pattern, basePath, evidence$2) {
  return new $c_Lcom_raquo_waypoint_Route$Total(encode, decode, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((args) => {
    var encoder = $m_Lurldsl_url_UrlStringGenerator$().Lurldsl_url_UrlStringGenerator$__f_default;
    return ("/" + $f_Lurldsl_language_PathSegment__createPath__O__Lurldsl_url_UrlStringGenerator__T(pattern, args, encoder));
  })), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((relativeUrl) => {
    var urlStringParserGenerator = $m_Lurldsl_url_UrlStringParserGenerator$().Lurldsl_url_UrlStringParserGenerator$__f_defaultUrlStringParserGenerator;
    return $f_Lurldsl_language_PathSegment__matchRawUrl__T__Lurldsl_url_UrlStringParserGenerator__s_util_Either(pattern, relativeUrl, urlStringParserGenerator).toOption__s_Option();
  })), basePath, evidence$2);
});
$c_Lcom_raquo_waypoint_Route$.prototype.onlyQuery__F1__F1__Lurldsl_language_PathSegmentWithQueryParams__T__s_reflect_ClassTag__Lcom_raquo_waypoint_Route$Total = (function(encode, decode, pattern, basePath, evidence$3) {
  return new $c_Lcom_raquo_waypoint_Route$Total(encode, decode, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((args) => ("/" + pattern.createUrlString__O__O__Lurldsl_url_UrlStringGenerator__T((void 0), args, $m_Lurldsl_url_UrlStringGenerator$().Lurldsl_url_UrlStringGenerator$__f_default)))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((relativeUrl) => {
    var this$3 = pattern.matchRawUrl__T__Lurldsl_url_UrlStringParserGenerator__s_util_Either(relativeUrl, $m_Lurldsl_url_UrlStringParserGenerator$().Lurldsl_url_UrlStringParserGenerator$__f_defaultUrlStringParserGenerator).toOption__s_Option();
    if (this$3.isEmpty__Z()) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    } else {
      var x0 = this$3.get__O();
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(x0.Lurldsl_vocabulary_UrlMatching__f_params);
    }
  })), basePath, evidence$3);
});
$c_Lcom_raquo_waypoint_Route$.prototype.static__O__Lurldsl_language_PathSegment__T__O__s_reflect_ClassTag__Lcom_raquo_waypoint_Route$Total = (function(staticPage, pattern, basePath, evidence$9, evidence$10) {
  return new $c_Lcom_raquo_waypoint_Route$Total(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$9) => (void 0))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$10) => staticPage)), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((args) => {
    var encoder = $m_Lurldsl_url_UrlStringGenerator$().Lurldsl_url_UrlStringGenerator$__f_default;
    return ("/" + $f_Lurldsl_language_PathSegment__createPath__O__Lurldsl_url_UrlStringGenerator__T(pattern, args, encoder));
  })), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((relativeUrl) => {
    var urlStringParserGenerator = $m_Lurldsl_url_UrlStringParserGenerator$().Lurldsl_url_UrlStringParserGenerator$__f_defaultUrlStringParserGenerator;
    return $f_Lurldsl_language_PathSegment__matchRawUrl__T__Lurldsl_url_UrlStringParserGenerator__s_util_Either(pattern, relativeUrl, urlStringParserGenerator).toOption__s_Option();
  })), basePath, evidence$10);
});
var $d_Lcom_raquo_waypoint_Route$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_waypoint_Route$, "com.raquo.waypoint.Route$", ({
  Lcom_raquo_waypoint_Route$: 1
}));
export { $d_Lcom_raquo_waypoint_Route$ as $d_Lcom_raquo_waypoint_Route$ };
var $n_Lcom_raquo_waypoint_Route$;
function $m_Lcom_raquo_waypoint_Route$() {
  if ((!$n_Lcom_raquo_waypoint_Route$)) {
    $n_Lcom_raquo_waypoint_Route$ = new $c_Lcom_raquo_waypoint_Route$();
  }
  return $n_Lcom_raquo_waypoint_Route$;
}
export { $m_Lcom_raquo_waypoint_Route$ as $m_Lcom_raquo_waypoint_Route$ };
/** @constructor */
function $c_Lcom_raquo_waypoint_RouteEvent(page, stateData, pageTitle, url, replace, fromPopState) {
  this.Lcom_raquo_waypoint_RouteEvent__f_page = null;
  this.Lcom_raquo_waypoint_RouteEvent__f_stateData = null;
  this.Lcom_raquo_waypoint_RouteEvent__f_pageTitle = null;
  this.Lcom_raquo_waypoint_RouteEvent__f_url = null;
  this.Lcom_raquo_waypoint_RouteEvent__f_replace = false;
  this.Lcom_raquo_waypoint_RouteEvent__f_fromPopState = false;
  this.Lcom_raquo_waypoint_RouteEvent__f_page = page;
  this.Lcom_raquo_waypoint_RouteEvent__f_stateData = stateData;
  this.Lcom_raquo_waypoint_RouteEvent__f_pageTitle = pageTitle;
  this.Lcom_raquo_waypoint_RouteEvent__f_url = url;
  this.Lcom_raquo_waypoint_RouteEvent__f_replace = replace;
  this.Lcom_raquo_waypoint_RouteEvent__f_fromPopState = fromPopState;
}
export { $c_Lcom_raquo_waypoint_RouteEvent as $c_Lcom_raquo_waypoint_RouteEvent };
$c_Lcom_raquo_waypoint_RouteEvent.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_waypoint_RouteEvent.prototype.constructor = $c_Lcom_raquo_waypoint_RouteEvent;
/** @constructor */
function $h_Lcom_raquo_waypoint_RouteEvent() {
}
export { $h_Lcom_raquo_waypoint_RouteEvent as $h_Lcom_raquo_waypoint_RouteEvent };
$h_Lcom_raquo_waypoint_RouteEvent.prototype = $c_Lcom_raquo_waypoint_RouteEvent.prototype;
var $d_Lcom_raquo_waypoint_RouteEvent = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_waypoint_RouteEvent, "com.raquo.waypoint.RouteEvent", ({
  Lcom_raquo_waypoint_RouteEvent: 1
}));
export { $d_Lcom_raquo_waypoint_RouteEvent as $d_Lcom_raquo_waypoint_RouteEvent };
function $p_Lcom_raquo_waypoint_Router__pageToRouteEvent__O__Z__Z__T__Lcom_raquo_waypoint_RouteEvent($thiz, page, replace, fromPopState, forceUrl) {
  return new $c_Lcom_raquo_waypoint_RouteEvent(page, $thiz.Lcom_raquo_waypoint_Router__f_serializePage.apply__O__O(page), $thiz.Lcom_raquo_waypoint_Router__f_getPageTitle.apply__O__O(page), ((forceUrl !== "") ? forceUrl : $thiz.relativeUrlForPage__O__T(page)), replace, fromPopState);
}
export { $p_Lcom_raquo_waypoint_Router__pageToRouteEvent__O__Z__Z__T__Lcom_raquo_waypoint_RouteEvent as $p_Lcom_raquo_waypoint_Router__pageToRouteEvent__O__Z__Z__T__Lcom_raquo_waypoint_RouteEvent };
function $p_Lcom_raquo_waypoint_Router__handleRouteEvent__Lcom_raquo_waypoint_RouteEvent__V($thiz, ev) {
  if ((!ev.Lcom_raquo_waypoint_RouteEvent__f_fromPopState)) {
    if (ev.Lcom_raquo_waypoint_RouteEvent__f_replace) {
      var $x_1 = window.history;
      var s = ev.Lcom_raquo_waypoint_RouteEvent__f_stateData;
      $x_1.replaceState(s, ev.Lcom_raquo_waypoint_RouteEvent__f_pageTitle, ev.Lcom_raquo_waypoint_RouteEvent__f_url);
    } else {
      var $x_2 = window.history;
      var s$1 = ev.Lcom_raquo_waypoint_RouteEvent__f_stateData;
      $x_2.pushState(s$1, ev.Lcom_raquo_waypoint_RouteEvent__f_pageTitle, ev.Lcom_raquo_waypoint_RouteEvent__f_url);
    }
  }
  $thiz.replacePageTitle__T__V(ev.Lcom_raquo_waypoint_RouteEvent__f_pageTitle);
}
export { $p_Lcom_raquo_waypoint_Router__handleRouteEvent__Lcom_raquo_waypoint_RouteEvent__V as $p_Lcom_raquo_waypoint_Router__handleRouteEvent__Lcom_raquo_waypoint_RouteEvent__V };
function $p_Lcom_raquo_waypoint_Router__handlePopState__Lorg_scalajs_dom_PopStateEvent__V($thiz, ev) {
  matchResult2: {
    var routeEvent;
    var x6 = ev.state;
    if (((typeof x6) === "string")) {
      try {
        var r1 = $thiz.Lcom_raquo_waypoint_Router__f_deserializePage.apply__O__O(x6);
        var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(r1);
      } catch (e) {
        var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
        matchEnd8: {
          var $x_1;
          if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
            var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(e$2);
            break matchEnd8;
          }
          throw ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
        }
      }
      var page = $x_1.getOrElse__F0__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $thiz.Lcom_raquo_waypoint_Router__f_deserializeFallback.apply__O__O(ev.state))));
      var routeEvent = $p_Lcom_raquo_waypoint_Router__pageToRouteEvent__O__Z__Z__T__Lcom_raquo_waypoint_RouteEvent($thiz, page, false, true, "");
      break matchResult2;
    }
    if ((x6 === null)) {
      var absoluteUrl = window.location.href;
      var relativeUrl = $m_Lcom_raquo_waypoint_Utils$().makeRelativeUrl__T__T__T($thiz.Lcom_raquo_waypoint_Router__f_origin, absoluteUrl);
      var this$3 = $thiz.pageForAbsoluteUrl__T__s_Option(absoluteUrl);
      var page$2 = (this$3.isEmpty__Z() ? $thiz.Lcom_raquo_waypoint_Router__f_routeFallback.apply__O__O(absoluteUrl) : this$3.get__O());
      var routeEvent = $p_Lcom_raquo_waypoint_Router__pageToRouteEvent__O__Z__Z__T__Lcom_raquo_waypoint_RouteEvent($thiz, page$2, false, true, relativeUrl);
      break matchResult2;
    }
    var fallbackPage = $thiz.Lcom_raquo_waypoint_Router__f_deserializeFallback.apply__O__O(ev.state);
    var routeEvent = $p_Lcom_raquo_waypoint_Router__pageToRouteEvent__O__Z__Z__T__Lcom_raquo_waypoint_RouteEvent($thiz, fallbackPage, false, true, "");
  }
  var this$4 = $thiz.Lcom_raquo_waypoint_Router__f_routeEventBus;
  this$4.Lcom_raquo_airstream_eventbus_EventBus__f_writer.onNext__O__V(routeEvent);
}
export { $p_Lcom_raquo_waypoint_Router__handlePopState__Lorg_scalajs_dom_PopStateEvent__V as $p_Lcom_raquo_waypoint_Router__handlePopState__Lorg_scalajs_dom_PopStateEvent__V };
function $p_Lcom_raquo_waypoint_Router__initialPage$lzyINIT1$1__F1__T__T__sr_LazyRef__s_util_Try($thiz, routeFallback$1, origin$1, initialUrl$1, initialPage$lzy1$1) {
  if ((initialPage$lzy1$1 === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  if (initialPage$lzy1$1.sr_LazyRef__f__initialized) {
    var $x_1 = initialPage$lzy1$1.sr_LazyRef__f__value;
  } else {
    var prefix = (origin$1 + "/");
    if ((!(!(!initialUrl$1.startsWith(prefix))))) {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Exception__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Exception(), (((("Initial URL does not belong to origin: " + initialUrl$1) + " vs ") + origin$1) + "/ - Use the full absolute URL for initialUrl, and don't include the trailing slash in origin"));
    }
    var maybeInitialRoutePage = $thiz.pageForAbsoluteUrl__T__s_Option(initialUrl$1);
    if ((!maybeInitialRoutePage.isEmpty__Z())) {
      var x0 = maybeInitialRoutePage.get__O();
      var routeEvent = $p_Lcom_raquo_waypoint_Router__pageToRouteEvent__O__Z__Z__T__Lcom_raquo_waypoint_RouteEvent($thiz, x0, true, false, $m_Lcom_raquo_waypoint_Utils$().makeRelativeUrl__T__T__T(origin$1, initialUrl$1));
      $p_Lcom_raquo_waypoint_Router__handleRouteEvent__Lcom_raquo_waypoint_RouteEvent__V($thiz, routeEvent);
    }
    try {
      var r1 = (maybeInitialRoutePage.isEmpty__Z() ? routeFallback$1.apply__O__O(initialUrl$1) : maybeInitialRoutePage.get__O());
      var $x_2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(r1);
    } catch (e) {
      var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
      matchEnd8: {
        var $x_2;
        if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
          var $x_2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(e$2);
          break matchEnd8;
        }
        throw ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
      }
    }
    var $x_1 = initialPage$lzy1$1.initialize__O__O($x_2);
  }
  return $x_1;
}
export { $p_Lcom_raquo_waypoint_Router__initialPage$lzyINIT1$1__F1__T__T__sr_LazyRef__s_util_Try as $p_Lcom_raquo_waypoint_Router__initialPage$lzyINIT1$1__F1__T__T__sr_LazyRef__s_util_Try };
function $p_Lcom_raquo_waypoint_Router__initialPage$1__F1__T__T__sr_LazyRef__s_util_Try($thiz, routeFallback$4, origin$3, initialUrl$5, initialPage$lzy1$2) {
  return (initialPage$lzy1$2.sr_LazyRef__f__initialized ? initialPage$lzy1$2.sr_LazyRef__f__value : $p_Lcom_raquo_waypoint_Router__initialPage$lzyINIT1$1__F1__T__T__sr_LazyRef__s_util_Try($thiz, routeFallback$4, origin$3, initialUrl$5, initialPage$lzy1$2));
}
export { $p_Lcom_raquo_waypoint_Router__initialPage$1__F1__T__T__sr_LazyRef__s_util_Try as $p_Lcom_raquo_waypoint_Router__initialPage$1__F1__T__T__sr_LazyRef__s_util_Try };
/** @constructor */
function $c_Lcom_raquo_waypoint_Router(routes, serializePage, deserializePage, getPageTitle, routeFallback, deserializeFallback, popStateEvents, owner, origin, initialUrl) {
  this.Lcom_raquo_waypoint_Router__f_routes = null;
  this.Lcom_raquo_waypoint_Router__f_serializePage = null;
  this.Lcom_raquo_waypoint_Router__f_deserializePage = null;
  this.Lcom_raquo_waypoint_Router__f_getPageTitle = null;
  this.Lcom_raquo_waypoint_Router__f_routeFallback = null;
  this.Lcom_raquo_waypoint_Router__f_deserializeFallback = null;
  this.Lcom_raquo_waypoint_Router__f_origin = null;
  this.Lcom_raquo_waypoint_Router__f_routeEventBus = null;
  this.Lcom_raquo_waypoint_Router__f_forcePageBus = null;
  this.Lcom_raquo_waypoint_Router__f_currentPageSignal = null;
  this.Lcom_raquo_waypoint_Router__f_routes = routes;
  this.Lcom_raquo_waypoint_Router__f_serializePage = serializePage;
  this.Lcom_raquo_waypoint_Router__f_deserializePage = deserializePage;
  this.Lcom_raquo_waypoint_Router__f_getPageTitle = getPageTitle;
  this.Lcom_raquo_waypoint_Router__f_routeFallback = routeFallback;
  this.Lcom_raquo_waypoint_Router__f_deserializeFallback = deserializeFallback;
  this.Lcom_raquo_waypoint_Router__f_origin = origin;
  this.Lcom_raquo_waypoint_Router__f_routeEventBus = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_eventbus_EventBus();
  this.Lcom_raquo_waypoint_Router__f_forcePageBus = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_eventbus_EventBus();
  var initialPage$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_LazyRef();
  var this$1 = this.Lcom_raquo_waypoint_Router__f_routeEventBus.Lcom_raquo_airstream_eventbus_EventBus__f_events;
  var project = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => _$2.Lcom_raquo_waypoint_RouteEvent__f_page));
  var pageFromRoute = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapStream(this$1, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var this$5 = this.Lcom_raquo_waypoint_Router__f_forcePageBus.Lcom_raquo_airstream_eventbus_EventBus__f_events;
  var project$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((page) => {
    var pageTitle = getPageTitle.apply__O__O(page);
    if ((pageTitle !== "")) {
      this.replacePageTitle__T__V(pageTitle);
    }
    return page;
  }));
  var forcedPage = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapStream(this$5, project$1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var \u03b41$ = ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_EventStream$()).merge__sci_Seq__Lcom_raquo_airstream_core_EventStream($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcom_raquo_airstream_core_EventStream.getArrayOf().constr)([pageFromRoute, forcedPage])));
  var initialPage$lzy1$2$1 = initialPage$lzy1;
  var initial = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((initialPage$lzy1$2) => (() => $p_Lcom_raquo_waypoint_Router__initialPage$1__F1__T__T__sr_LazyRef__s_util_Try(this, routeFallback, origin, initialUrl, initialPage$lzy1$2)))(initialPage$lzy1$2$1));
  var this$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_SignalFromStream(\u03b41$, initial, false);
  this.Lcom_raquo_waypoint_Router__f_currentPageSignal = new $c_Lcom_raquo_airstream_state_ObservedSignal(this$7, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_Observer$().Lcom_raquo_airstream_core_Observer$__f__empty, owner);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(this.Lcom_raquo_waypoint_Router__f_routeEventBus.Lcom_raquo_airstream_eventbus_EventBus__f_events, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((ev) => {
    $p_Lcom_raquo_waypoint_Router__handleRouteEvent__Lcom_raquo_waypoint_RouteEvent__V(this, ev);
  })), owner);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(popStateEvents, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((ev$2) => {
    $p_Lcom_raquo_waypoint_Router__handlePopState__Lorg_scalajs_dom_PopStateEvent__V(this, ev$2);
  })), owner);
}
export { $c_Lcom_raquo_waypoint_Router as $c_Lcom_raquo_waypoint_Router };
$c_Lcom_raquo_waypoint_Router.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_waypoint_Router.prototype.constructor = $c_Lcom_raquo_waypoint_Router;
/** @constructor */
function $h_Lcom_raquo_waypoint_Router() {
}
export { $h_Lcom_raquo_waypoint_Router as $h_Lcom_raquo_waypoint_Router };
$h_Lcom_raquo_waypoint_Router.prototype = $c_Lcom_raquo_waypoint_Router.prototype;
$c_Lcom_raquo_waypoint_Router.prototype.pageForAbsoluteUrl__T__s_Option = (function(url) {
  var origin = this.Lcom_raquo_waypoint_Router__f_origin;
  var prefix = (origin + "/");
  if ((!(!url.startsWith(prefix)))) {
    var this$2 = this.Lcom_raquo_waypoint_Router__f_origin;
    var beginIndex = this$2.length;
    var relativeUrl = url.substring(beginIndex);
    return this.pageForRelativeUrl__T__s_Option(relativeUrl);
  } else {
    return ((url === this.Lcom_raquo_waypoint_Router__f_origin) ? this.pageForRelativeUrl__T__s_Option("/") : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  }
});
$c_Lcom_raquo_waypoint_Router.prototype.pageForRelativeUrl__T__s_Option = (function(url) {
  if ((!((!(!url.startsWith("/"))) && (!(!(!url.startsWith("//"))))))) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Exception__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Exception(), "Relative URL must be relative to the origin, i.e. it must start with /, whereas `$url` was given.");
  }
  var elem = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var elem$1 = null;
  elem$1 = elem;
  var this$3 = this.Lcom_raquo_waypoint_Router__f_routes;
  var these = this$3;
  while ((!these.isEmpty__Z())) {
    var x0 = these.head__O();
    var ev$1 = x0.pageForRelativeUrl__T__T__s_Option(this.Lcom_raquo_waypoint_Router__f_origin, url);
    elem$1 = ev$1;
    ev$1 = null;
    var this$4 = elem$1;
    if ((!this$4.isEmpty__Z())) {
      break;
    }
    these = these.tail__O();
  }
  return elem$1;
});
$c_Lcom_raquo_waypoint_Router.prototype.absoluteUrlForPage__O__T = (function(page) {
  return (("" + this.Lcom_raquo_waypoint_Router__f_origin) + this.relativeUrlForPage__O__T(page));
});
$c_Lcom_raquo_waypoint_Router.prototype.relativeUrlForPage__O__T = (function(page) {
  var elem = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var elem$1 = null;
  elem$1 = elem;
  var this$2 = this.Lcom_raquo_waypoint_Router__f_routes;
  var these = this$2;
  while ((!these.isEmpty__Z())) {
    var x0 = these.head__O();
    var ev$2 = x0.relativeUrlForPage__O__s_Option(page);
    elem$1 = ev$2;
    ev$2 = null;
    var this$3 = elem$1;
    if ((!this$3.isEmpty__Z())) {
      break;
    }
    these = these.tail__O();
  }
  var this$4 = elem$1;
  if (this$4.isEmpty__Z()) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Exception__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Exception(), ("Router has no route for this page: " + page));
  }
  return this$4.get__O();
});
$c_Lcom_raquo_waypoint_Router.prototype.pushState__O__V = (function(page) {
  var $x_2 = this.Lcom_raquo_waypoint_Router__f_routeEventBus.Lcom_raquo_airstream_eventbus_EventBus__f_writer;
  try {
    var r1 = $p_Lcom_raquo_waypoint_Router__pageToRouteEvent__O__Z__Z__T__Lcom_raquo_waypoint_RouteEvent(this, page, false, false, "");
    var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(r1);
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
    matchEnd8: {
      var $x_1;
      if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(e$2);
        break matchEnd8;
      }
      throw ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  }
  $x_2.onTry__s_util_Try__V($x_1);
});
$c_Lcom_raquo_waypoint_Router.prototype.replaceState__O__V = (function(page) {
  var $x_2 = this.Lcom_raquo_waypoint_Router__f_routeEventBus.Lcom_raquo_airstream_eventbus_EventBus__f_writer;
  try {
    var r1 = $p_Lcom_raquo_waypoint_Router__pageToRouteEvent__O__Z__Z__T__Lcom_raquo_waypoint_RouteEvent(this, page, true, false, "");
    var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(r1);
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
    matchEnd8: {
      var $x_1;
      if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(e$2);
        break matchEnd8;
      }
      throw ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  }
  $x_2.onTry__s_util_Try__V($x_1);
});
$c_Lcom_raquo_waypoint_Router.prototype.replacePageTitle__T__V = (function(title) {
  document.title = title;
});
var $d_Lcom_raquo_waypoint_Router = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_waypoint_Router, "com.raquo.waypoint.Router", ({
  Lcom_raquo_waypoint_Router: 1
}));
export { $d_Lcom_raquo_waypoint_Router as $d_Lcom_raquo_waypoint_Router };
/** @constructor */
function $c_Lcom_raquo_waypoint_Router$() {
  this.Lcom_raquo_waypoint_Router$__f_throwOnInvalidState = null;
  this.Lcom_raquo_waypoint_Router$__f_canonicalDocumentOrigin = null;
  $n_Lcom_raquo_waypoint_Router$ = this;
  this.Lcom_raquo_waypoint_Router$__f_throwOnInvalidState = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((state) => {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Exception__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Exception(), ("Unable to deserialize history state: " + JSON.stringify(state, null)));
  }));
  this.Lcom_raquo_waypoint_Router$__f_canonicalDocumentOrigin = ((document.location.protocol === "file:") ? "file://" : document.location.origin);
}
export { $c_Lcom_raquo_waypoint_Router$ as $c_Lcom_raquo_waypoint_Router$ };
$c_Lcom_raquo_waypoint_Router$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_waypoint_Router$.prototype.constructor = $c_Lcom_raquo_waypoint_Router$;
/** @constructor */
function $h_Lcom_raquo_waypoint_Router$() {
}
export { $h_Lcom_raquo_waypoint_Router$ as $h_Lcom_raquo_waypoint_Router$ };
$h_Lcom_raquo_waypoint_Router$.prototype = $c_Lcom_raquo_waypoint_Router$.prototype;
$c_Lcom_raquo_waypoint_Router$.prototype.$lessinit$greater$default$7__Lcom_raquo_airstream_core_EventStream = (function() {
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L;
  var x0 = this$1.Lcom_raquo_laminar_api_package$$anon$1__f_windowEventProps;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$();
  var eventProp = x0.onPopState__Lcom_raquo_laminar_keys_EventProp();
  var p = $m_Lcom_raquo_laminar_keys_EventProcessor$().empty__Lcom_raquo_laminar_keys_EventProp__Z__Z__Lcom_raquo_laminar_keys_EventProcessor(eventProp, false, false);
  var this$6 = $m_Lcom_raquo_airstream_web_DomEventStream$().apply__Lorg_scalajs_dom_EventTarget__T__Z__Lcom_raquo_airstream_core_EventStream(window, p.Lcom_raquo_laminar_keys_EventProcessor__f_eventProp.Lcom_raquo_laminar_keys_EventProp__f_name, p.Lcom_raquo_laminar_keys_EventProcessor__f_shouldUseCapture);
  var fn = p.Lcom_raquo_laminar_keys_EventProcessor__f_processor;
  return new $c_Lcom_raquo_airstream_misc_CollectStream(this$6, fn);
});
$c_Lcom_raquo_waypoint_Router$.prototype.$lessinit$greater$default$10__T = (function() {
  return window.location.href;
});
var $d_Lcom_raquo_waypoint_Router$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_waypoint_Router$, "com.raquo.waypoint.Router$", ({
  Lcom_raquo_waypoint_Router$: 1
}));
export { $d_Lcom_raquo_waypoint_Router$ as $d_Lcom_raquo_waypoint_Router$ };
var $n_Lcom_raquo_waypoint_Router$;
function $m_Lcom_raquo_waypoint_Router$() {
  if ((!$n_Lcom_raquo_waypoint_Router$)) {
    $n_Lcom_raquo_waypoint_Router$ = new $c_Lcom_raquo_waypoint_Router$();
  }
  return $n_Lcom_raquo_waypoint_Router$;
}
export { $m_Lcom_raquo_waypoint_Router$ as $m_Lcom_raquo_waypoint_Router$ };
/** @constructor */
function $c_Lcom_raquo_waypoint_Utils$() {
}
export { $c_Lcom_raquo_waypoint_Utils$ as $c_Lcom_raquo_waypoint_Utils$ };
$c_Lcom_raquo_waypoint_Utils$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_waypoint_Utils$.prototype.constructor = $c_Lcom_raquo_waypoint_Utils$;
/** @constructor */
function $h_Lcom_raquo_waypoint_Utils$() {
}
export { $h_Lcom_raquo_waypoint_Utils$ as $h_Lcom_raquo_waypoint_Utils$ };
$h_Lcom_raquo_waypoint_Utils$.prototype = $c_Lcom_raquo_waypoint_Utils$.prototype;
$c_Lcom_raquo_waypoint_Utils$.prototype.makeRelativeUrl__T__T__T = (function(origin, absoluteUrl) {
  var prefix = (origin + "/");
  if ((!(!absoluteUrl.startsWith(prefix)))) {
    var beginIndex = origin.length;
    return absoluteUrl.substring(beginIndex);
  } else {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Exception__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Exception(), (((("Can not make `" + absoluteUrl) + "` into relative URL, origin does not match `") + origin) + "`."));
  }
});
$c_Lcom_raquo_waypoint_Utils$.prototype.basePathHasEmptyFragment__T__Z = (function(basePath) {
  if ((basePath !== "")) {
    var hashIndex = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__indexOf__I__I(basePath, 35);
    return (hashIndex === (((-1) + basePath.length) | 0));
  } else {
    return false;
  }
});
$c_Lcom_raquo_waypoint_Utils$.prototype.basePathWithoutFragment__T__T = (function(basePath) {
  if ((basePath === "")) {
    return basePath;
  } else {
    var hashIndex = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__indexOf__I__I(basePath, 35);
    return basePath.substring(0, hashIndex);
  }
});
var $d_Lcom_raquo_waypoint_Utils$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_waypoint_Utils$, "com.raquo.waypoint.Utils$", ({
  Lcom_raquo_waypoint_Utils$: 1
}));
export { $d_Lcom_raquo_waypoint_Utils$ as $d_Lcom_raquo_waypoint_Utils$ };
var $n_Lcom_raquo_waypoint_Utils$;
function $m_Lcom_raquo_waypoint_Utils$() {
  if ((!$n_Lcom_raquo_waypoint_Utils$)) {
    $n_Lcom_raquo_waypoint_Utils$ = new $c_Lcom_raquo_waypoint_Utils$();
  }
  return $n_Lcom_raquo_waypoint_Utils$;
}
export { $m_Lcom_raquo_waypoint_Utils$ as $m_Lcom_raquo_waypoint_Utils$ };
/** @constructor */
function $c_Lfansi_Attr$() {
  this.Lfansi_Attr$__f_Reset = null;
  this.Lfansi_Attr$__f_categories = null;
  $n_Lfansi_Attr$ = this;
  this.Lfansi_Attr$__f_Reset = new $c_Lfansi_EscapeAttr("\u001b[0m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(2147483647, 0), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Reset")));
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
  var elems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lfansi_Category.getArrayOf().constr)([$m_Lfansi_Color$(), $m_Lfansi_Back$(), $m_Lfansi_Bold$(), $m_Lfansi_Underlined$(), $m_Lfansi_Reversed$()]));
  this.Lfansi_Attr$__f_categories = this$2.from__sc_IterableOnce__sci_Vector(elems);
}
export { $c_Lfansi_Attr$ as $c_Lfansi_Attr$ };
$c_Lfansi_Attr$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfansi_Attr$.prototype.constructor = $c_Lfansi_Attr$;
/** @constructor */
function $h_Lfansi_Attr$() {
}
export { $h_Lfansi_Attr$ as $h_Lfansi_Attr$ };
$h_Lfansi_Attr$.prototype = $c_Lfansi_Attr$.prototype;
var $d_Lfansi_Attr$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfansi_Attr$, "fansi.Attr$", ({
  Lfansi_Attr$: 1
}));
export { $d_Lfansi_Attr$ as $d_Lfansi_Attr$ };
var $n_Lfansi_Attr$;
function $m_Lfansi_Attr$() {
  if ((!$n_Lfansi_Attr$)) {
    $n_Lfansi_Attr$ = new $c_Lfansi_Attr$();
  }
  return $n_Lfansi_Attr$;
}
export { $m_Lfansi_Attr$ as $m_Lfansi_Attr$ };
function $f_Lfansi_Attrs__transform__J__J($thiz, state) {
  var b = $thiz.resetMask__J();
  var lo = (~b.RTLong__f_lo);
  var hi = (~b.RTLong__f_hi);
  var lo$1 = (state.RTLong__f_lo & lo);
  var hi$1 = (state.RTLong__f_hi & hi);
  var b$1 = $thiz.applyMask__J();
  var lo$2 = (lo$1 | b$1.RTLong__f_lo);
  var hi$2 = (hi$1 | b$1.RTLong__f_hi);
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$2, hi$2);
}
export { $f_Lfansi_Attrs__transform__J__J as $f_Lfansi_Attrs__transform__J__J };
/** @constructor */
function $c_Lfansi_Attrs$() {
  $n_Lfansi_Attrs$ = this;
  $m_Lfansi_Attrs$().apply__sci_Seq__Lfansi_Attrs($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lfansi_Attr.getArrayOf().constr)([])));
}
export { $c_Lfansi_Attrs$ as $c_Lfansi_Attrs$ };
$c_Lfansi_Attrs$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfansi_Attrs$.prototype.constructor = $c_Lfansi_Attrs$;
/** @constructor */
function $h_Lfansi_Attrs$() {
}
export { $h_Lfansi_Attrs$ as $h_Lfansi_Attrs$ };
$h_Lfansi_Attrs$.prototype = $c_Lfansi_Attrs$.prototype;
$c_Lfansi_Attrs$.prototype.emitAnsiCodes0__J__J__scm_StringBuilder__ALfansi_Category__V = (function(currentState, nextState, output, categoryArray) {
  if ((!((currentState.RTLong__f_lo === nextState.RTLong__f_lo) && (currentState.RTLong__f_hi === nextState.RTLong__f_hi)))) {
    var hardOffMask = $m_Lfansi_Bold$().mask__I();
    var lo = (~nextState.RTLong__f_lo);
    var hi = (~nextState.RTLong__f_hi);
    var lo$1 = (currentState.RTLong__f_lo & lo);
    var hi$1 = (currentState.RTLong__f_hi & hi);
    var hi$2 = (hardOffMask >> 31);
    var lo$2 = (lo$1 & hardOffMask);
    var hi$3 = (hi$1 & hi$2);
    if ((!((lo$2 === 0) && (hi$3 === 0)))) {
      output.append__T__scm_StringBuilder("\u001b[0m");
      var t = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0;
    } else {
      var t = currentState;
    }
    var lo$3 = t.RTLong__f_lo;
    var hi$4 = t.RTLong__f_hi;
    var categoryIndex = 0;
    while ((categoryIndex < categoryArray.u.length)) {
      var cat = categoryArray.u[categoryIndex];
      var value = cat.mask__I();
      var hi$5 = (value >> 31);
      var lo$4 = (value & lo$3);
      var hi$6 = (hi$5 & hi$4);
      var value$1 = cat.mask__I();
      var hi$7 = (value$1 >> 31);
      var lo$5 = (value$1 & nextState.RTLong__f_lo);
      var hi$8 = (hi$7 & nextState.RTLong__f_hi);
      if ((!((lo$4 === lo$5) && (hi$6 === hi$8)))) {
        var value$2 = cat.mask__I();
        var hi$9 = (value$2 >> 31);
        var lo$6 = (nextState.RTLong__f_lo & value$2);
        var hi$10 = (nextState.RTLong__f_hi & hi$9);
        var escape = cat.lookupEscape__J__T(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$6, hi$10));
        output.append__T__scm_StringBuilder(escape);
      }
      categoryIndex = ((1 + categoryIndex) | 0);
    }
  }
});
$c_Lfansi_Attrs$.prototype.apply__sci_Seq__Lfansi_Attrs = (function(attrs) {
  var elem = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var elem$1 = null;
  elem$1 = elem;
  var elem$2__lo = 0;
  var elem$2__hi = 0;
  var $x_1__lo = 0;
  var $x_1__hi = 0;
  elem$2__lo = $x_1__lo;
  elem$2__hi = $x_1__hi;
  var elem$3__lo = 0;
  var elem$3__hi = 0;
  var $x_2__lo = 0;
  var $x_2__hi = 0;
  elem$3__lo = $x_2__lo;
  elem$3__hi = $x_2__hi;
  var this$5 = attrs.reverseIterator__sc_Iterator();
  while (this$5.hasNext__Z()) {
    var x0 = this$5.next__O();
    var a = x0.resetMask__J();
    var b__lo = elem$2__lo;
    var b__hi = elem$2__hi;
    var lo = (~b__lo);
    var hi = (~b__hi);
    var lo$1 = (a.RTLong__f_lo & lo);
    var hi$1 = (a.RTLong__f_hi & hi);
    if ((!((lo$1 === 0) && (hi$1 === 0)))) {
      var a$1 = x0.applyMask__J();
      var b$1__lo = elem$2__lo;
      var b$1__hi = elem$2__hi;
      var lo$2 = (a$1.RTLong__f_lo & b$1__lo);
      var hi$2 = (a$1.RTLong__f_hi & b$1__hi);
      if (((lo$2 === 0) && (hi$2 === 0))) {
        var a$2__lo = elem$3__lo;
        var a$2__hi = elem$3__hi;
        var b$2 = x0.applyMask__J();
        var lo$3 = (a$2__lo | b$2.RTLong__f_lo);
        var hi$3 = (a$2__hi | b$2.RTLong__f_hi);
        var $x_3__lo = lo$3;
        var $x_3__hi = hi$3;
        elem$3__lo = $x_3__lo;
        elem$3__hi = $x_3__hi;
      }
      var a$3__lo = elem$2__lo;
      var a$3__hi = elem$2__hi;
      var b$3 = x0.resetMask__J();
      var lo$4 = (a$3__lo | b$3.RTLong__f_lo);
      var hi$4 = (a$3__hi | b$3.RTLong__f_hi);
      var $x_4__lo = lo$4;
      var $x_4__hi = hi$4;
      elem$2__lo = $x_4__lo;
      elem$2__hi = $x_4__hi;
      var this$13 = elem$1;
      elem$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(x0, this$13);
    }
  }
  if ((elem$1.length__I() === 1)) {
    return elem$1.head__O();
  } else {
    var $x_8 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(elem$2__lo, elem$2__hi);
    var $x_7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(elem$3__lo, elem$3__hi);
    var $x_6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
    var this$15 = elem$1;
    if ((this$15.knownSize__I() >= 0)) {
      var len = this$15.knownSize__I();
      var destination = new ($d_Lfansi_Attr.getArrayOf().constr)(len);
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$15, destination, 0, 2147483647);
      var xs = destination;
    } else {
      var capacity = 0;
      var size = 0;
      var jsElems = null;
      capacity = 0;
      size = 0;
      jsElems = [];
      var it = this$15.iterator__sc_Iterator();
      while (it.hasNext__Z()) {
        var elem$4 = it.next__O();
        var unboxedElem = ((elem$4 === null) ? null : elem$4);
        jsElems.push(unboxedElem);
      }
      var xs = new ($d_Lfansi_Attr.getArrayOf().constr)(jsElems);
    }
    var len$1 = xs.u.length;
    var $x_5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_reflect_ClassTag$();
    var this$22 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$objectGetClass(xs);
    var res = $x_5.apply__jl_Class__s_reflect_ClassTag(this$22.data.getComponentType()).newArray__I__O(len$1);
    var i = 0;
    while ((i < len$1)) {
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().array_update__O__I__O__V(res, (((-1) + ((len$1 - i) | 0)) | 0), xs.u[i]);
      i = ((1 + i) | 0);
    }
    return new $c_Lfansi_Attrs$Multiple($x_8, $x_7, $x_6.wrapRefArray__AO__sci_ArraySeq(res));
  }
});
var $d_Lfansi_Attrs$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfansi_Attrs$, "fansi.Attrs$", ({
  Lfansi_Attrs$: 1
}));
export { $d_Lfansi_Attrs$ as $d_Lfansi_Attrs$ };
var $n_Lfansi_Attrs$;
function $m_Lfansi_Attrs$() {
  if ((!$n_Lfansi_Attrs$)) {
    $n_Lfansi_Attrs$ = new $c_Lfansi_Attrs$();
  }
  return $n_Lfansi_Attrs$;
}
export { $m_Lfansi_Attrs$ as $m_Lfansi_Attrs$ };
function $ct_Lfansi_Category__I__I__Lsourcecode_Name__($thiz, offset, width, catName) {
  $thiz.Lfansi_Category__f_offset = offset;
  $thiz.Lfansi_Category__f_width = width;
  $thiz.Lfansi_Category__f_catName = catName;
  return $thiz;
}
export { $ct_Lfansi_Category__I__I__Lsourcecode_Name__ as $ct_Lfansi_Category__I__I__Lsourcecode_Name__ };
/** @constructor */
function $c_Lfansi_Category() {
  this.Lfansi_Category__f_offset = 0;
  this.Lfansi_Category__f_width = 0;
  this.Lfansi_Category__f_catName = null;
  this.Lfansi_Category__f_lookupAttrTable$lzy1 = null;
  this.Lfansi_Category__f_lookupAttrTablebitmap$1 = false;
}
export { $c_Lfansi_Category as $c_Lfansi_Category };
$c_Lfansi_Category.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfansi_Category.prototype.constructor = $c_Lfansi_Category;
/** @constructor */
function $h_Lfansi_Category() {
}
export { $h_Lfansi_Category as $h_Lfansi_Category };
$h_Lfansi_Category.prototype = $c_Lfansi_Category.prototype;
$c_Lfansi_Category.prototype.mask__I = (function() {
  return ((((-1) + (1 << this.Lfansi_Category__f_width)) | 0) << this.Lfansi_Category__f_offset);
});
$c_Lfansi_Category.prototype.lookupEscape__J__T = (function(applyState) {
  var escapeOpt = this.lookupAttr__J__Lfansi_Attr(applyState).escapeOpt__s_Option();
  return ((!escapeOpt.isEmpty__Z()) ? escapeOpt.get__O() : "");
});
$c_Lfansi_Category.prototype.lookupAttr__J__Lfansi_Attr = (function(applyState) {
  var $x_1 = this.lookupAttrTable__ALfansi_Attr();
  var n = this.Lfansi_Category__f_offset;
  var hi = applyState.RTLong__f_hi;
  var lo = (((32 & n) === 0) ? (((applyState.RTLong__f_lo >>> n) | 0) | ((hi << 1) << ((31 - n) | 0))) : (hi >> n));
  return $x_1.u[lo];
});
$c_Lfansi_Category.prototype.lookupTableWidth__I = (function() {
  return (1 << this.Lfansi_Category__f_width);
});
$c_Lfansi_Category.prototype.lookupAttrTable__ALfansi_Attr = (function() {
  if ((!this.Lfansi_Category__f_lookupAttrTablebitmap$1)) {
    var dimensions = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I(new Int32Array([this.lookupTableWidth__I()]));
    var arr = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Lfansi_Attr.getClassOf(), dimensions);
    this.all__sci_Vector().foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((attr) => {
      var a = attr.applyMask__J();
      var n = this.Lfansi_Category__f_offset;
      var hi = a.RTLong__f_hi;
      var lo = (((32 & n) === 0) ? (((a.RTLong__f_lo >>> n) | 0) | ((hi << 1) << ((31 - n) | 0))) : (hi >> n));
      arr.u[lo] = attr;
    })));
    this.Lfansi_Category__f_lookupAttrTable$lzy1 = arr;
    this.Lfansi_Category__f_lookupAttrTablebitmap$1 = true;
  }
  return this.Lfansi_Category__f_lookupAttrTable$lzy1;
});
$c_Lfansi_Category.prototype.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr = (function(s, applyValue, name) {
  var x = this.mask__I();
  var hi = (x >> 31);
  var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(x, hi);
  var n = this.Lfansi_Category__f_offset;
  var lo = applyValue.RTLong__f_lo;
  var lo$1 = (((32 & n) === 0) ? (lo << n) : 0);
  var hi$1 = (((32 & n) === 0) ? (((((lo >>> 1) | 0) >>> ((31 - n) | 0)) | 0) | (applyValue.RTLong__f_hi << n)) : (lo << n));
  return new $c_Lfansi_EscapeAttr(s, $x_1, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$1, hi$1), $m_Lsourcecode_Name$().wrap__O__Lsourcecode_SourceValue(((this.Lfansi_Category__f_catName.Lsourcecode_Name__f_value + ".") + name.Lsourcecode_Name__f_value)));
});
$c_Lfansi_Category.prototype.makeNoneAttr__J__Lsourcecode_Name__Lfansi_ResetAttr = (function(applyValue, name) {
  var x = this.mask__I();
  var hi = (x >> 31);
  var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(x, hi);
  var n = this.Lfansi_Category__f_offset;
  var lo = applyValue.RTLong__f_lo;
  var lo$1 = (((32 & n) === 0) ? (lo << n) : 0);
  var hi$1 = (((32 & n) === 0) ? (((((lo >>> 1) | 0) >>> ((31 - n) | 0)) | 0) | (applyValue.RTLong__f_hi << n)) : (lo << n));
  return new $c_Lfansi_ResetAttr($x_1, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$1, hi$1), $m_Lsourcecode_Name$().wrap__O__Lsourcecode_SourceValue(((this.Lfansi_Category__f_catName.Lsourcecode_Name__f_value + ".") + name.Lsourcecode_Name__f_value)));
});
var $d_Lfansi_Category = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass(0, "fansi.Category", ({
  Lfansi_Category: 1
}));
export { $d_Lfansi_Category as $d_Lfansi_Category };
/** @constructor */
function $c_Lfansi_Str(chars, colors) {
  this.Lfansi_Str__f_chars = null;
  this.Lfansi_Str__f_colors = null;
  this.Lfansi_Str__f_plainText$lzy1 = null;
  this.Lfansi_Str__f_plainTextbitmap$1 = false;
  this.Lfansi_Str__f_chars = chars;
  this.Lfansi_Str__f_colors = colors;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Predef$().require__Z__V((chars.u.length === colors.u.length));
}
export { $c_Lfansi_Str as $c_Lfansi_Str };
$c_Lfansi_Str.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfansi_Str.prototype.constructor = $c_Lfansi_Str;
/** @constructor */
function $h_Lfansi_Str() {
}
export { $h_Lfansi_Str as $h_Lfansi_Str };
$h_Lfansi_Str.prototype = $c_Lfansi_Str.prototype;
$c_Lfansi_Str.prototype.hashCode__I = (function() {
  var a = this.Lfansi_Str__f_chars;
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_Arrays$().hashCode__AC__I(a);
  var a$1 = this.Lfansi_Str__f_colors;
  return (($x_1 + $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_Arrays$().hashCode__AJ__I(a$1)) | 0);
});
$c_Lfansi_Str.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_Lfansi_Str)) {
    var a = this.Lfansi_Str__f_chars;
    var b = other.Lfansi_Str__f_chars;
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_Arrays$().equals__AC__AC__Z(a, b)) {
      var a$1 = this.Lfansi_Str__f_colors;
      var b$1 = other.Lfansi_Str__f_colors;
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_Arrays$().equals__AJ__AJ__Z(a$1, b$1);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lfansi_Str.prototype.substring__I__I__Lfansi_Str = (function(start, end) {
  var requirement = ((start >= 0) && (start <= this.Lfansi_Str__f_chars.u.length));
  if ((!requirement)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), (("requirement failed: " + (("substring start parameter [" + start) + "] must be between 0 and length:")) + this.Lfansi_Str__f_chars.u.length));
  }
  var requirement$1 = ((end >= start) && (end <= this.Lfansi_Str__f_chars.u.length));
  if ((!requirement$1)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), (("requirement failed: " + (((("substring end parameter [" + end) + "] must be between start ") + start) + " and length:")) + this.Lfansi_Str__f_chars.u.length));
  }
  var original = this.Lfansi_Str__f_chars;
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_Arrays$().copyOfRange__AC__I__I__AC(original, start, end);
  var original$1 = this.Lfansi_Str__f_colors;
  return new $c_Lfansi_Str($x_1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_Arrays$().copyOfRange__AJ__I__I__AJ(original$1, start, end));
});
$c_Lfansi_Str.prototype.toString__T = (function() {
  return this.render__T();
});
$c_Lfansi_Str.prototype.plainText__T = (function() {
  if ((!this.Lfansi_Str__f_plainTextbitmap$1)) {
    var value = this.Lfansi_Str__f_chars;
    var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_String$();
    this.Lfansi_Str__f_plainText$lzy1 = this$1.new__AC__I__I__T(value, 0, value.u.length);
    this.Lfansi_Str__f_plainTextbitmap$1 = true;
  }
  return this.Lfansi_Str__f_plainText$lzy1;
});
$c_Lfansi_Str.prototype.getColor__I__J = (function(i) {
  return this.Lfansi_Str__f_colors.u[i];
});
$c_Lfansi_Str.prototype.getChar__I__C = (function(i) {
  return this.Lfansi_Str__f_chars.u[i];
});
$c_Lfansi_Str.prototype.render__T = (function() {
  var output = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_scm_StringBuilder__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_StringBuilder(), ((this.Lfansi_Str__f_chars.u.length + Math.imul(5, this.Lfansi_Str__f_colors.u.length)) | 0));
  var currentState__lo = 0;
  var currentState__hi = 0;
  var this$2 = $m_Lfansi_Attr$().Lfansi_Attr$__f_categories;
  if ((this$2.length__I() >= 0)) {
    var len = this$2.length__I();
    var destination = new ($d_Lfansi_Category.getArrayOf().constr)(len);
    this$2.iterator__sc_Iterator().copyToArray__O__I__I__I(destination, 0, 2147483647);
    var categoryArray = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = this$2.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var elem = it.next__O();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem);
    }
    var categoryArray = new ($d_Lfansi_Category.getArrayOf().constr)(jsElems);
  }
  var i = 0;
  while ((i < this.Lfansi_Str__f_colors.u.length)) {
    var a = this.Lfansi_Str__f_colors.u[i];
    var b__lo = currentState__lo;
    var b__hi = currentState__hi;
    if ((!((a.RTLong__f_lo === b__lo) && (a.RTLong__f_hi === b__hi)))) {
      $m_Lfansi_Attrs$().emitAnsiCodes0__J__J__scm_StringBuilder__ALfansi_Category__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(currentState__lo, currentState__hi), this.Lfansi_Str__f_colors.u[i], output, categoryArray);
      var t = this.Lfansi_Str__f_colors.u[i];
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var $x_1__lo = lo;
      var $x_1__hi = hi;
      currentState__lo = $x_1__lo;
      currentState__hi = $x_1__hi;
    }
    output.append__C__scm_StringBuilder(this.Lfansi_Str__f_chars.u[i]);
    i = ((1 + i) | 0);
  }
  $m_Lfansi_Attrs$().emitAnsiCodes0__J__J__scm_StringBuilder__ALfansi_Category__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(currentState__lo, currentState__hi), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0, output, categoryArray);
  return output.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_Lfansi_Str.prototype.overlay__Lfansi_Attrs__I__I__Lfansi_Str = (function(attrs, start, end) {
  return this.overlayAll__sci_Seq__Lfansi_Str(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T3(attrs, start, end), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$()));
});
$c_Lfansi_Str.prototype.overlayAll__sci_Seq__Lfansi_Str = (function(overlays) {
  var this$1 = this.Lfansi_Str__f_colors;
  var colorsOut = this$1.clone__O();
  overlays.withFilter__F1__sc_WithFilter(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => ((x$1 !== null) && true)))).foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1$2) => {
    matchResult3: {
      if ((x$1$2 !== null)) {
        var attrs$1 = x$1$2.T3__f__1;
        var start$1 = (x$1$2.T3__f__2 | 0);
        var end$1 = (x$1$2.T3__f__3 | 0);
        var requirement = (end$1 >= start$1);
        if ((!requirement)) {
          throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), (("requirement failed: " + ((("end:" + end$1) + " must be greater than start:") + end$1)) + " in fansiStr#overlay call"));
        }
        var requirement$1 = (start$1 >= 0);
        if ((!requirement$1)) {
          throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), (("requirement failed: " + ("start:" + start$1)) + " must be greater than or equal to 0"));
        }
        var requirement$2 = (end$1 <= this.Lfansi_Str__f_colors.u.length);
        if ((!requirement$2)) {
          throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), (("requirement failed: " + (("end:" + end$1) + " must be less than or equal to length:")) + this.Lfansi_Str__f_colors.u.length));
        }
        var i = start$1;
        while ((i < end$1)) {
          colorsOut.u[i] = $f_Lfansi_Attrs__transform__J__J(attrs$1, colorsOut.u[i]);
          i = ((1 + i) | 0);
        }
        break matchResult3;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1$2);
    }
  })));
  return new $c_Lfansi_Str(this.Lfansi_Str__f_chars, colorsOut);
});
function $isArrayOf_Lfansi_Str(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfansi_Str)));
}
export { $isArrayOf_Lfansi_Str as $isArrayOf_Lfansi_Str };
var $d_Lfansi_Str = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfansi_Str, "fansi.Str", ({
  Lfansi_Str: 1
}));
export { $d_Lfansi_Str as $d_Lfansi_Str };
function $p_Lfansi_Str$__isDigit$1__jl_CharSequence__I__Z($thiz, raw$1, index) {
  return (((index < $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$dp_length__I(raw$1)) && ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$dp_charAt__I__C(raw$1, index) >= 48)) && ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$dp_charAt__I__C(raw$1, index) <= 57));
}
export { $p_Lfansi_Str$__isDigit$1__jl_CharSequence__I__Z as $p_Lfansi_Str$__isDigit$1__jl_CharSequence__I__Z };
function $p_Lfansi_Str$__checkChar$1__jl_CharSequence__I__C__Z($thiz, raw$2, index, char) {
  return ((index < $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$dp_length__I(raw$2)) && ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$dp_charAt__I__C(raw$2, index) === char));
}
export { $p_Lfansi_Str$__checkChar$1__jl_CharSequence__I__C__Z as $p_Lfansi_Str$__checkChar$1__jl_CharSequence__I__C__Z };
/** @constructor */
function $c_Lfansi_Str$() {
  this.Lfansi_Str$__f_ParseMap = null;
  $n_Lfansi_Str$ = this;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_s_util_matching_Regex__T__sci_Seq__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_matching_Regex(), "(\u009b|\u001b\\[)[0-?]*[ -\\/]*[@-~]", $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
  var this$3 = $m_Lfansi_Attr$().Lfansi_Attr$__f_categories;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
  var b = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_VectorBuilder();
  var it = this$3.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var x0 = it.next__O();
    var this$5 = x0.all__sci_Vector();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
    var b$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_VectorBuilder();
    var it$1 = this$5.iterator__sc_Iterator();
    while (it$1.hasNext__Z()) {
      var x0$1 = it$1.next__O();
      var this$7 = x0$1.escapeOpt__s_Option();
      if (this$7.isEmpty__Z()) {
        var elems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      } else {
        var x0$2 = this$7.get__O();
        var _2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(x0$1);
        var elems = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), x0$2, _2));
      }
      b$1.addAll__sc_IterableOnce__sci_VectorBuilder(elems);
    }
    var elems$1 = b$1.result__sci_Vector();
    b.addAll__sc_IterableOnce__sci_VectorBuilder(elems$1);
  }
  var pairs = b.result__sci_Vector();
  var value = $m_Lfansi_Attr$().Lfansi_Attr$__f_Reset;
  var y = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value);
  var reset = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), "\u001b[0m", y), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
  var value$1 = $m_Lfansi_Color$();
  var y$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value$1);
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), "\u001b[38;2;", y$1);
  var value$2 = $m_Lfansi_Back$();
  var y$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value$2);
  var trueColors = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon($x_1, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), "\u001b[48;2;", y$2), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$()));
  var this$19 = pairs.appendedAll__sc_IterableOnce__sci_Vector(reset);
  this.Lfansi_Str$__f_ParseMap = new $c_Lfansi_Trie(this$19.appendedAll__sc_IterableOnce__sci_Vector(trueColors));
}
export { $c_Lfansi_Str$ as $c_Lfansi_Str$ };
$c_Lfansi_Str$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfansi_Str$.prototype.constructor = $c_Lfansi_Str$;
/** @constructor */
function $h_Lfansi_Str$() {
}
export { $h_Lfansi_Str$ as $h_Lfansi_Str$ };
$h_Lfansi_Str$.prototype = $c_Lfansi_Str$.prototype;
$c_Lfansi_Str$.prototype.apply__jl_CharSequence__Lfansi_ErrorMode__Lfansi_Str = (function(raw, errorMode) {
  var dimensions = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I(new Int32Array([$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$dp_length__I(raw)]));
  var chars = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_reflect_Array$().newInstance__jl_Class__AI__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_C.getClassOf(), dimensions);
  var dimensions$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I(new Int32Array([$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$dp_length__I(raw)]));
  var colors = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_reflect_Array$().newInstance__jl_Class__AI__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_J.getClassOf(), dimensions$1);
  var currentColor__lo = 0;
  var currentColor__hi = 0;
  var elem = 0;
  elem = 0;
  var destIndex = 0;
  var length = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$dp_length__I(raw);
  while ((elem < length)) {
    var char = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$dp_charAt__I__C(raw, elem);
    if (((char === 27) || (char === 155))) {
      var escapeStartSourceIndex = elem;
      matchResult5: {
        var this$4 = this.Lfansi_Str$__f_ParseMap;
        var x20 = $ps_Lfansi_Trie__rec$1__I__jl_CharSequence__I__Lfansi_Trie__s_Option(escapeStartSourceIndex, raw, escapeStartSourceIndex, this$4);
        var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        if ((x === x20)) {
          elem = errorMode.handle__I__jl_CharSequence__I(elem, raw);
          break matchResult5;
        }
        if ((x20 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
          var tuple = x20.s_Some__f_value;
          if ((tuple !== null)) {
            var x16 = (tuple._1__O() | 0);
            var x17 = tuple._2__O();
            if ((x17 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
              var color = x17.s_util_Left__f_value;
              var t = $f_Lfansi_Attrs__transform__J__J(color, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(currentColor__lo, currentColor__hi));
              var lo = t.RTLong__f_lo;
              var hi = t.RTLong__f_hi;
              var $x_1__lo = lo;
              var $x_1__hi = hi;
              currentColor__lo = $x_1__lo;
              currentColor__hi = $x_1__hi;
              elem = ((elem + x16) | 0);
              break matchResult5;
            }
            if ((x17 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
              var category = x17.s_util_Right__f_value;
              elem = ((elem + x16) | 0);
              if ((!$p_Lfansi_Str$__isDigit$1__jl_CharSequence__I__Z(this, raw, elem))) {
                elem = errorMode.handle__I__jl_CharSequence__I(escapeStartSourceIndex, raw);
                break matchResult5;
              } else {
                var value = 0;
                var count = 0;
                while (($p_Lfansi_Str$__isDigit$1__jl_CharSequence__I__Z(this, raw, elem) && (count < 3))) {
                  value = ((Math.imul(10, value) + (((-48) + $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$dp_charAt__I__C(raw, elem)) | 0)) | 0);
                  elem = ((1 + elem) | 0);
                  count = ((1 + count) | 0);
                }
                var r = value;
                if (((!$p_Lfansi_Str$__checkChar$1__jl_CharSequence__I__C__Z(this, raw, elem, 59)) || (!$p_Lfansi_Str$__isDigit$1__jl_CharSequence__I__Z(this, raw, ((1 + elem) | 0))))) {
                  elem = errorMode.handle__I__jl_CharSequence__I(escapeStartSourceIndex, raw);
                  break matchResult5;
                } else {
                  elem = ((1 + elem) | 0);
                  var value$1 = 0;
                  var count$1 = 0;
                  while (($p_Lfansi_Str$__isDigit$1__jl_CharSequence__I__Z(this, raw, elem) && (count$1 < 3))) {
                    value$1 = ((Math.imul(10, value$1) + (((-48) + $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$dp_charAt__I__C(raw, elem)) | 0)) | 0);
                    elem = ((1 + elem) | 0);
                    count$1 = ((1 + count$1) | 0);
                  }
                  var g = value$1;
                  if (((!$p_Lfansi_Str$__checkChar$1__jl_CharSequence__I__C__Z(this, raw, elem, 59)) || (!$p_Lfansi_Str$__isDigit$1__jl_CharSequence__I__Z(this, raw, ((1 + elem) | 0))))) {
                    elem = errorMode.handle__I__jl_CharSequence__I(escapeStartSourceIndex, raw);
                    break matchResult5;
                  } else {
                    elem = ((1 + elem) | 0);
                    var value$2 = 0;
                    var count$2 = 0;
                    while (($p_Lfansi_Str$__isDigit$1__jl_CharSequence__I__Z(this, raw, elem) && (count$2 < 3))) {
                      value$2 = ((Math.imul(10, value$2) + (((-48) + $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$dp_charAt__I__C(raw, elem)) | 0)) | 0);
                      elem = ((1 + elem) | 0);
                      count$2 = ((1 + count$2) | 0);
                    }
                    var b = value$2;
                    if ((!$p_Lfansi_Str$__checkChar$1__jl_CharSequence__I__C__Z(this, raw, elem, 109))) {
                      elem = errorMode.handle__I__jl_CharSequence__I(escapeStartSourceIndex, raw);
                      break matchResult5;
                    } else {
                      elem = ((1 + elem) | 0);
                      if ((!((((((r >= 0) && (r < 256)) && (g >= 0)) && (g < 256)) && (b >= 0)) && (b < 256)))) {
                        elem = errorMode.handle__I__jl_CharSequence__I(escapeStartSourceIndex, raw);
                        break matchResult5;
                      } else {
                        var a__lo = currentColor__lo;
                        var a__hi = currentColor__hi;
                        var value$3 = (~category.mask__I());
                        var hi$1 = (value$3 >> 31);
                        var lo$1 = (a__lo & value$3);
                        var hi$2 = (a__hi & hi$1);
                        var value$4 = (((273 + category.trueIndex__I__I__I__I(r, g, b)) | 0) << category.Lfansi_Category__f_offset);
                        var hi$3 = (value$4 >> 31);
                        var lo$2 = (lo$1 | value$4);
                        var hi$4 = (hi$2 | hi$3);
                        var $x_2__lo = lo$2;
                        var $x_2__hi = hi$4;
                        currentColor__lo = $x_2__lo;
                        currentColor__hi = $x_2__hi;
                        break matchResult5;
                      }
                    }
                  }
                }
              }
            }
          }
          throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(tuple);
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x20);
      }
    } else {
      colors.u[destIndex] = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(currentColor__lo, currentColor__hi);
      chars.u[destIndex] = char;
      elem = ((1 + elem) | 0);
      destIndex = ((1 + destIndex) | 0);
    }
  }
  var end = destIndex;
  var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_Arrays$().copyOfRange__AC__I__I__AC(chars, 0, end);
  var end$1 = destIndex;
  return new $c_Lfansi_Str($x_3, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_Arrays$().copyOfRange__AJ__I__I__AJ(colors, 0, end$1));
});
$c_Lfansi_Str$.prototype.join__sc_Iterable__Lfansi_Str__Lfansi_Str = (function(args, sep) {
  var this$1 = args.iterator__sc_Iterator();
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => ((_$1.Lfansi_Str__f_chars.u.length + sep.Lfansi_Str__f_chars.u.length) | 0)));
  var this$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(this$1, f);
  var num = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_math_Numeric$IntIsIntegral$();
  var y = ((($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__sum__s_math_Numeric__O(this$2, num) | 0) - sep.Lfansi_Str__f_chars.u.length) | 0);
  var length = ((y < 0) ? 0 : y);
  var dimensions = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I(new Int32Array([length]));
  var chars = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_reflect_Array$().newInstance__jl_Class__AI__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_C.getClassOf(), dimensions);
  var dimensions$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I(new Int32Array([length]));
  var colors = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_reflect_Array$().newInstance__jl_Class__AI__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_J.getClassOf(), dimensions$1);
  var j = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_IntRef(0);
  args.foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((arg) => {
    if ((j.sr_IntRef__f_elem !== 0)) {
      var k = 0;
      while ((k < sep.Lfansi_Str__f_chars.u.length)) {
        chars.u[j.sr_IntRef__f_elem] = sep.getChar__I__C(k);
        var $x_1 = j.sr_IntRef__f_elem;
        var this$8 = sep.Lfansi_Str__f_colors;
        colors.u[$x_1] = this$8.clone__O().u[k];
        j.sr_IntRef__f_elem = ((1 + j.sr_IntRef__f_elem) | 0);
        k = ((1 + k) | 0);
      }
    }
    var i = 0;
    while ((i < arg.Lfansi_Str__f_chars.u.length)) {
      chars.u[j.sr_IntRef__f_elem] = arg.getChar__I__C(i);
      colors.u[j.sr_IntRef__f_elem] = arg.getColor__I__J(i);
      i = ((1 + i) | 0);
      j.sr_IntRef__f_elem = ((1 + j.sr_IntRef__f_elem) | 0);
    }
  })));
  return new $c_Lfansi_Str(chars.clone__O(), colors.clone__O());
});
var $d_Lfansi_Str$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfansi_Str$, "fansi.Str$", ({
  Lfansi_Str$: 1
}));
export { $d_Lfansi_Str$ as $d_Lfansi_Str$ };
var $n_Lfansi_Str$;
function $m_Lfansi_Str$() {
  if ((!$n_Lfansi_Str$)) {
    $n_Lfansi_Str$ = new $c_Lfansi_Str$();
  }
  return $n_Lfansi_Str$;
}
export { $m_Lfansi_Str$ as $m_Lfansi_Str$ };
function $ps_Lfansi_Trie__rec$1__I__jl_CharSequence__I__Lfansi_Trie__s_Option(index$2, input$1, offset, currentNode) {
  var currentNode$tailLocal1 = currentNode;
  var offset$tailLocal1 = offset;
  while (true) {
    var this$1 = currentNode$tailLocal1.Lfansi_Trie__f_value;
    if ((!this$1.isEmpty__Z())) {
      var this$2 = currentNode$tailLocal1.Lfansi_Trie__f_value;
      var offset$tailLocal1$2 = offset$tailLocal1;
      if (this$2.isEmpty__Z()) {
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      } else {
        var x0 = this$2.get__O();
        var self = ((offset$tailLocal1$2 - index$2) | 0);
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self, x0));
      }
    } else if ((offset$tailLocal1 >= $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$dp_length__I(input$1))) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    } else {
      var char = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$dp_charAt__I__C(input$1, offset$tailLocal1);
      var next = currentNode$tailLocal1.apply__C__Lfansi_Trie(char);
      if ((next === null)) {
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      } else {
        var offset$tailLocal1$tmp1 = ((1 + offset$tailLocal1) | 0);
        offset$tailLocal1 = offset$tailLocal1$tmp1;
        currentNode$tailLocal1 = next;
      }
    }
  }
}
export { $ps_Lfansi_Trie__rec$1__I__jl_CharSequence__I__Lfansi_Trie__s_Option as $ps_Lfansi_Trie__rec$1__I__jl_CharSequence__I__Lfansi_Trie__s_Option };
/** @constructor */
function $c_Lfansi_Trie(strings) {
  this.Lfansi_Trie__f_min = 0;
  this.Lfansi_Trie__f_max = 0;
  this.Lfansi_Trie__f_arr = null;
  this.Lfansi_Trie__f_value = null;
  matchResult24: {
    var x79___1;
    var x79___2;
    var x79___3;
    var x79___4;
    var x70 = strings.partition__F1__T2(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => {
      var this$1 = _$2._1__O();
      return (this$1 === "");
    })));
    if ((x70 !== null)) {
      var x77 = x70._1__O();
      var x78 = x70._2__O();
      var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      if (x.equals__O__Z(x77)) {
        var allChildChars = x78.map__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$3) => {
          var x$1 = _$3._1__O();
          return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bC(x$1.charCodeAt(0));
        })));
        var min = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uC(allChildChars.min__s_math_Ordering__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_math_Ordering$Char$()));
        var max = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uC(allChildChars.max__s_math_Ordering__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_math_Ordering$Char$()));
        var dimensions = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I(new Int32Array([((1 + ((max - min) | 0)) | 0)]));
        var arr = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Lfansi_Trie.getClassOf(), dimensions);
        var m = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_scm_Map$().empty__O();
        var it = x78.iterator__sc_Iterator();
        while (it.hasNext__Z()) {
          var elem = it.next__O();
          var x$2 = elem._1__O();
          var key = x$2.charCodeAt(0);
          var bldr = m.getOrElseUpdate__O__F0__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bC(key), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855(((this$7) => (() => this$7.newSpecificBuilder__scm_Builder()))(x78)));
          bldr.addOne__O__scm_Growable(elem);
        }
        var this$8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_HashMap$();
        var result = this$8.sci_HashMap$__f_EmptyMap;
        var mapIt = m.iterator__sc_Iterator();
        while (mapIt.hasNext__Z()) {
          var x1 = mapIt.next__O();
          if ((x1 === null)) {
            throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1);
          }
          var k = x1._1__O();
          var v = x1._2__O();
          result = result.updated__O__O__sci_HashMap(k, v.result__O());
        }
        var this$9 = result;
        var p = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1$1) => ((x$1$1 !== null) && ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uC(x$1$1._1__O()), x$1$1._2__O(), true))));
        var this$12 = new $c_sc_MapOps$WithFilter(this$9, p);
        var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1$2) => {
          matchResult23: {
            if ((x$1$2 !== null)) {
              var char$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uC(x$1$2._1__O());
              var ss$1 = x$1$2._2__O();
              arr.u[((char$1 - min) | 0)] = new $c_Lfansi_Trie(ss$1.map__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1$2$1) => {
                if ((x$1$2$1 !== null)) {
                  var k$1 = x$1$2$1._1__O();
                  var v$1 = x$1$2$1._2__O();
                  var _1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_StringOps$().tail$extension__T__T(k$1);
                  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, v$1);
                }
                throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1$2$1);
              }))));
              break matchResult23;
            }
            throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1$2);
          }
        }));
        this$12.filtered__sc_Iterable().foreach__F1__V(f);
        var _4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        var x79___1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bC(min);
        var x79___2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bC(max);
        var x79___3 = arr;
        var x79___4 = _4;
        break matchResult24;
      }
      if ((x77 !== null)) {
        if ((x77.lengthCompare__I__I(1) === 0)) {
          var x74 = x77.apply__I__O(0);
          if ((x74 !== null)) {
            var terminalValue = x74._2__O();
            var x$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
            if (x$3.equals__O__Z(x78)) {
              var dimensions$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I(new Int32Array([0]));
              var _3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Lfansi_Trie.getClassOf(), dimensions$1);
              var _4$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(terminalValue);
              var x79___1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bC(0);
              var x79___2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bC(0);
              var x79___3 = _3;
              var x79___4 = _4$1;
              break matchResult24;
            }
          }
        }
      }
    }
    throw new $c_s_NotImplementedError();
  }
  var min$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uC(x79___1);
  var max$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uC(x79___2);
  var arr$3 = x79___3;
  var value = x79___4;
  var \u03b41$___1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bC(min$3);
  var \u03b41$___2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bC(max$2);
  var \u03b41$___3 = arr$3;
  var \u03b41$___4 = value;
  this.Lfansi_Trie__f_min = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uC(\u03b41$___1);
  this.Lfansi_Trie__f_max = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uC(\u03b41$___2);
  this.Lfansi_Trie__f_arr = \u03b41$___3;
  this.Lfansi_Trie__f_value = \u03b41$___4;
}
export { $c_Lfansi_Trie as $c_Lfansi_Trie };
$c_Lfansi_Trie.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfansi_Trie.prototype.constructor = $c_Lfansi_Trie;
/** @constructor */
function $h_Lfansi_Trie() {
}
export { $h_Lfansi_Trie as $h_Lfansi_Trie };
$h_Lfansi_Trie.prototype = $c_Lfansi_Trie.prototype;
$c_Lfansi_Trie.prototype.apply__C__Lfansi_Trie = (function(c) {
  return (((c > this.Lfansi_Trie__f_max) || (c < this.Lfansi_Trie__f_min)) ? null : this.Lfansi_Trie__f_arr.u[((c - this.Lfansi_Trie__f_min) | 0)]);
});
var $d_Lfansi_Trie = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfansi_Trie, "fansi.Trie", ({
  Lfansi_Trie: 1
}));
export { $d_Lfansi_Trie as $d_Lfansi_Trie };
/** @constructor */
function $c_Lframework_api_FrameworkHeaders$X$minusRequest$minusStarted$minusAt$() {
}
export { $c_Lframework_api_FrameworkHeaders$X$minusRequest$minusStarted$minusAt$ as $c_Lframework_api_FrameworkHeaders$X$minusRequest$minusStarted$minusAt$ };
$c_Lframework_api_FrameworkHeaders$X$minusRequest$minusStarted$minusAt$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_api_FrameworkHeaders$X$minusRequest$minusStarted$minusAt$.prototype.constructor = $c_Lframework_api_FrameworkHeaders$X$minusRequest$minusStarted$minusAt$;
/** @constructor */
function $h_Lframework_api_FrameworkHeaders$X$minusRequest$minusStarted$minusAt$() {
}
export { $h_Lframework_api_FrameworkHeaders$X$minusRequest$minusStarted$minusAt$ as $h_Lframework_api_FrameworkHeaders$X$minusRequest$minusStarted$minusAt$ };
$h_Lframework_api_FrameworkHeaders$X$minusRequest$minusStarted$minusAt$.prototype = $c_Lframework_api_FrameworkHeaders$X$minusRequest$minusStarted$minusAt$.prototype;
$c_Lframework_api_FrameworkHeaders$X$minusRequest$minusStarted$minusAt$.prototype.apply__Ljava_time_LocalDateTime__T2 = (function(now) {
  var t = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_data_FrameworkDateTime$().toUnixMillis$extension__Ljava_time_LocalDateTime__J(now);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var tc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$long$().Lcats_instances_package$long$__f_catsStdShowForLong;
  var this$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$ToShowOps$$anon$3(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi), tc);
  var _2 = this$3.Lcats_Show$ToShowOps$$anon$3__f_typeClassInstance.show__O__T(this$3.Lcats_Show$ToShowOps$$anon$3__f_self);
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), "X-Request-Started-At", _2);
});
var $d_Lframework_api_FrameworkHeaders$X$minusRequest$minusStarted$minusAt$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_api_FrameworkHeaders$X$minusRequest$minusStarted$minusAt$, "framework.api.FrameworkHeaders$X$minusRequest$minusStarted$minusAt$", ({
  Lframework_api_FrameworkHeaders$X$minusRequest$minusStarted$minusAt$: 1
}));
export { $d_Lframework_api_FrameworkHeaders$X$minusRequest$minusStarted$minusAt$ as $d_Lframework_api_FrameworkHeaders$X$minusRequest$minusStarted$minusAt$ };
var $n_Lframework_api_FrameworkHeaders$X$minusRequest$minusStarted$minusAt$;
function $m_Lframework_api_FrameworkHeaders$X$minusRequest$minusStarted$minusAt$() {
  if ((!$n_Lframework_api_FrameworkHeaders$X$minusRequest$minusStarted$minusAt$)) {
    $n_Lframework_api_FrameworkHeaders$X$minusRequest$minusStarted$minusAt$ = new $c_Lframework_api_FrameworkHeaders$X$minusRequest$minusStarted$minusAt$();
  }
  return $n_Lframework_api_FrameworkHeaders$X$minusRequest$minusStarted$minusAt$;
}
export { $m_Lframework_api_FrameworkHeaders$X$minusRequest$minusStarted$minusAt$ as $m_Lframework_api_FrameworkHeaders$X$minusRequest$minusStarted$minusAt$ };
function $p_Lframework_auth_SupabaseAuthClient__doTry$1__T__Lframework_utils_JSLogger__Lframework_sourcecode_DefinedAt__I__Lcats_effect_IO($thiz, email$1, log$3, x$2$1, tryIndex) {
  var this$8 = $m_Lcats_effect_IO$();
  var thunk = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
    var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
    var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["Sending OTP code to '", "' (try index: ", ")"]));
    var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
    var msg$1 = $x_2.genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([$x_1.show$extension__s_StringContext__sci_Seq__T(sc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(email$1, $m_Lframework_data_Email$package$Email$().given_Show_Type__Lcats_Show())), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(tryIndex, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$int$().Lcats_instances_package$int$__f_catsStdShowForInt))])))]));
    var this$7 = $m_Lframework_prelude_client\uff3flogging$package$JSAppName$();
    var appName = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Newtype$WithoutValidation__apply__O__O(this$7, "app");
    var level = $s_Lframework_utils_LogLevel$__Default__Lframework_utils_LogLevel();
    log$3.atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V(level, log$3.scope__s_Option(), msg$1, x$2$1, appName);
  }));
  var this$22 = this$8.delay__F0__Lcats_effect_IO(thunk);
  var $x_4 = $m_Lcats_effect_IO$();
  var this$14 = $m_Lcats_effect_IO$();
  var thunk$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
    var $x_3 = $thiz.Lframework_auth_SupabaseAuthClient__f_client;
    $m_Lframework_data_Email$package$Email$();
    var fields = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T2.getArrayOf().constr)([$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), "email", email$1)]));
    var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
    return $x_3.signInWithOtp(_\uff3fobj);
  }));
  var that = $x_4.fromPromise__Lcats_effect_IO__Lcats_effect_IO(this$14.delay__F0__Lcats_effect_IO(thunk$1)).flatTap__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((response) => {
    var this$21 = $m_Lcats_effect_IO$();
    var thunk$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
      var $x_6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
      var $x_5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
      var parts$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["OTP code-send response: "]));
      var sc$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts$1);
      var msg$2 = $x_6.genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([$x_5.show$extension__s_StringContext__sci_Seq__T(sc$1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([]))), response]));
      var this$20 = $m_Lframework_prelude_client\uff3flogging$package$JSAppName$();
      var appName$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Newtype$WithoutValidation__apply__O__O(this$20, "app");
      var level$1 = $s_Lframework_utils_LogLevel$__Default__Lframework_utils_LogLevel();
      log$3.atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V(level$1, log$3.scope__s_Option(), msg$2, x$2$1, appName$1);
    }));
    return this$21.delay__F0__Lcats_effect_IO(thunk$2);
  }))).map__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((value) => $m_Lframework_auth_SupabaseAuthClient$().requestResultSafeDestructureAsEither__Ltypings_supabaseAuthJs_distModuleLibTypesMod_RequestResultSafeDestructure__s_util_Either(value))));
  return this$22.productR__Lcats_effect_IO__Lcats_effect_IO(that);
}
export { $p_Lframework_auth_SupabaseAuthClient__doTry$1__T__Lframework_utils_JSLogger__Lframework_sourcecode_DefinedAt__I__Lcats_effect_IO as $p_Lframework_auth_SupabaseAuthClient__doTry$1__T__Lframework_utils_JSLogger__Lframework_sourcecode_DefinedAt__I__Lcats_effect_IO };
function $p_Lframework_auth_SupabaseAuthClient__doTry$2__T__T__Lframework_utils_JSLogger__Lframework_sourcecode_DefinedAt__I__Lcats_effect_IO($thiz, otp$1, email$6, log$11, x$3$1, tryIndex) {
  var this$9 = $m_Lcats_effect_IO$();
  var thunk = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
    var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
    var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["Verifying OTP code '", "' for '", "' (try index: ", ")"]));
    var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
    var msg$3 = $x_2.genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([$x_1.show$extension__s_StringContext__sci_Seq__T(sc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(otp$1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString)), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(email$6, $m_Lframework_data_Email$package$Email$().given_Show_Type__Lcats_Show())), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(tryIndex, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$int$().Lcats_instances_package$int$__f_catsStdShowForInt))])))]));
    var this$8 = $m_Lframework_prelude_client\uff3flogging$package$JSAppName$();
    var appName = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Newtype$WithoutValidation__apply__O__O(this$8, "app");
    var level = $s_Lframework_utils_LogLevel$__Default__Lframework_utils_LogLevel();
    log$11.atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V(level, log$11.scope__s_Option(), msg$3, x$3$1, appName);
  }));
  var this$20 = this$9.delay__F0__Lcats_effect_IO(thunk);
  var $x_4 = $m_Lcats_effect_IO$();
  var this$16 = $m_Lcats_effect_IO$();
  var thunk$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
    var $x_3 = $thiz.Lframework_auth_SupabaseAuthClient__f_client;
    $m_Lframework_data_Email$package$Email$();
    var fields = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T2.getArrayOf().constr)([$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), "email", email$6), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), "token", otp$1)]));
    var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
    _\uff3fobj.type = "email";
    return $x_3.verifyOtp(_\uff3fobj);
  }));
  var that = $x_4.fromPromise__Lcats_effect_IO__Lcats_effect_IO(this$16.delay__F0__Lcats_effect_IO(thunk$1)).flatTap__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((response) => {
    var this$19 = $m_Lcats_effect_IO$();
    var thunk$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
      var msg$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(["OTP code-verify response: ", response]));
      var this$18 = $m_Lframework_prelude_client\uff3flogging$package$JSAppName$();
      var appName$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Newtype$WithoutValidation__apply__O__O(this$18, "app");
      var level$1 = $s_Lframework_utils_LogLevel$__Default__Lframework_utils_LogLevel();
      log$11.atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V(level$1, log$11.scope__s_Option(), msg$4, x$3$1, appName$1);
    }));
    return this$19.delay__F0__Lcats_effect_IO(thunk$2);
  }))).map__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((value) => $m_Lframework_auth_SupabaseAuthClient$().requestResultSafeDestructureAsEither__Ltypings_supabaseAuthJs_distModuleLibTypesMod_RequestResultSafeDestructure__s_util_Either(value))));
  return this$20.productR__Lcats_effect_IO__Lcats_effect_IO(that);
}
export { $p_Lframework_auth_SupabaseAuthClient__doTry$2__T__T__Lframework_utils_JSLogger__Lframework_sourcecode_DefinedAt__I__Lcats_effect_IO as $p_Lframework_auth_SupabaseAuthClient__doTry$2__T__T__Lframework_utils_JSLogger__Lframework_sourcecode_DefinedAt__I__Lcats_effect_IO };
/** @constructor */
function $c_Lframework_auth_SupabaseAuthClient(client, log) {
  this.Lframework_auth_SupabaseAuthClient__f_client = null;
  this.Lframework_auth_SupabaseAuthClient__f_log = null;
  this.Lframework_auth_SupabaseAuthClient__f_onAuthStateChange$lzy1 = null;
  this.Lframework_auth_SupabaseAuthClient__f_onAuthStateChangebitmap$1 = false;
  this.Lframework_auth_SupabaseAuthClient__f_retryPolicy = null;
  this.Lframework_auth_SupabaseAuthClient__f_client = client;
  this.Lframework_auth_SupabaseAuthClient__f_log = log;
  var $x_5 = $m_Lretry_RetryPolicies$();
  var this$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_package$DurationInt(50);
  var unit = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
  var this$ = this$2.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$();
  var hi = (this$ >> 31);
  var $x_4 = $x_5.constantDelay__s_concurrent_duration_FiniteDuration__Lcats_Applicative__Lretry_RetryPolicy(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_FiniteDuration(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(this$, hi), unit), $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO).join__Lretry_RetryPolicy__Lcats_Apply__Lretry_RetryPolicy($m_Lretry_RetryPolicies$().limitRetries__I__Lcats_Applicative__Lretry_RetryPolicy(10, $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO), $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO);
  var $x_3 = $m_Lretry_RetryPolicies$();
  var this$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_package$DurationInt(200);
  var unit$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
  var this$$1 = this$7.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$();
  var hi$1 = (this$$1 >> 31);
  var $x_2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_FiniteDuration(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(this$$1, hi$1), unit$1);
  var $x_1 = $m_Lretry_RetryPolicies$();
  var this$12 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_package$DurationInt(10);
  var unit$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
  var this$$2 = this$12.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$();
  var hi$2 = (this$$2 >> 31);
  this.Lframework_auth_SupabaseAuthClient__f_retryPolicy = $x_4.followedBy__Lretry_RetryPolicy__Lcats_Apply__Lretry_RetryPolicy($x_3.limitRetriesByDelay__s_concurrent_duration_FiniteDuration__Lretry_RetryPolicy__Lcats_Applicative__Lretry_RetryPolicy($x_2, $x_1.exponentialBackoff__s_concurrent_duration_FiniteDuration__Lcats_Applicative__Lretry_RetryPolicy(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_FiniteDuration(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(this$$2, hi$2), unit$2), $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO), $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO), $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO);
}
export { $c_Lframework_auth_SupabaseAuthClient as $c_Lframework_auth_SupabaseAuthClient };
$c_Lframework_auth_SupabaseAuthClient.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_auth_SupabaseAuthClient.prototype.constructor = $c_Lframework_auth_SupabaseAuthClient;
/** @constructor */
function $h_Lframework_auth_SupabaseAuthClient() {
}
export { $h_Lframework_auth_SupabaseAuthClient as $h_Lframework_auth_SupabaseAuthClient };
$h_Lframework_auth_SupabaseAuthClient.prototype = $c_Lframework_auth_SupabaseAuthClient.prototype;
$c_Lframework_auth_SupabaseAuthClient.prototype.autoRefreshToken__Z = (function() {
  return (!(!this.Lframework_auth_SupabaseAuthClient__f_client.autoRefreshToken));
});
$c_Lframework_auth_SupabaseAuthClient.prototype.onAuthStateChange__Lcom_raquo_airstream_core_EventStream = (function() {
  if ((!this.Lframework_auth_SupabaseAuthClient__f_onAuthStateChangebitmap$1)) {
    var log = $f_Lframework_utils_JSLogger__scoped__T__Lframework_utils_JSLogger(this.Lframework_auth_SupabaseAuthClient__f_log, "onAuthStateChange");
    var $x_5 = $m_Lframework_exts_EventStreamExts$package$();
    var $x_4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_EventStream$();
    var $x_3 = $m_Lframework_exts_EventStreamExts$package$().fromCustomSourceWithSubscription$default$2__Lcom_raquo_airstream_core_EventStream$__F1($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_EventStream$());
    var $x_2 = new $c_sr_AbstractFunction4_$$Lambda$44dd8b4a36ad9db1c12297bcc97fced51ec30e4c(((fireValue, fireError, getStartIndex, getIsStarted) => this.Lframework_auth_SupabaseAuthClient__f_client.onAuthStateChange(((fireValue$2) => ((jsEvt, jsSession) => {
      matchResult1: {
        var x1 = $m_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$().from__Lorg_scalablytyped_runtime_StObject__s_Option(jsEvt);
        var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        if ((x === x1)) {
          var err$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(["unknown event: ", jsEvt]));
          var file = new $c_Lsourcecode_File("/home/arturaz/work/rapix/framework/clientSupabase/src/framework/auth/SupabaseAuthClient.scala");
          var line = new $c_Lsourcecode_Line(44);
          var name = new $c_Lsourcecode_FullName("framework.auth.SupabaseAuthClient.onAuthStateChange");
          var definedAt = new $c_Lframework_sourcecode_DefinedAt(file, line, name);
          var this$5 = $m_Lframework_prelude_client\uff3flogging$package$JSAppName$();
          var appName = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Newtype$WithoutValidation__apply__O__O(this$5, "app");
          var level = $s_Lframework_utils_LogLevel$__Error__Lframework_utils_LogLevel();
          log.atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V(level, log.scope__s_Option(), err$1, definedAt, appName);
          break matchResult1;
        }
        if ((x1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
          var evt = x1.s_Some__f_value;
          var maybeSession = $m_Lframework_exts_AOrNullExts$package$().jsValueOrNullToOption__O__s_Option(jsSession);
          fireValue$2.apply__O__O(new $c_Lframework_auth_SupabaseAuthClient$AuthStateChange(evt, maybeSession));
          break matchResult1;
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1);
      }
    }))(fireValue))));
    var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((v1, v2) => {
      v2.data.subscription.unsubscribe();
    }));
    var file$1 = new $c_Lsourcecode_File("/home/arturaz/work/rapix/framework/clientSupabase/src/framework/auth/SupabaseAuthClient.scala");
    var line$1 = new $c_Lsourcecode_Line(54);
    var name$1 = new $c_Lsourcecode_FullName("framework.auth.SupabaseAuthClient.onAuthStateChange");
    this.Lframework_auth_SupabaseAuthClient__f_onAuthStateChange$lzy1 = $x_5.fromCustomSourceWithSubscription__Lcom_raquo_airstream_core_EventStream$__F1__F4__F2__Lframework_sourcecode_DefinedAt__Lcom_raquo_airstream_core_EventStream($x_4, $x_3, $x_2, $x_1, new $c_Lframework_sourcecode_DefinedAt(file$1, line$1, name$1));
    this.Lframework_auth_SupabaseAuthClient__f_onAuthStateChangebitmap$1 = true;
  }
  return this.Lframework_auth_SupabaseAuthClient__f_onAuthStateChange$lzy1;
});
$c_Lframework_auth_SupabaseAuthClient.prototype.signInWithOtp__T__Lframework_sourcecode_DefinedAt__Lcats_effect_IO = (function(email, x$2) {
  var log = $f_Lframework_utils_JSLogger__scoped__T__Lframework_utils_JSLogger(this.Lframework_auth_SupabaseAuthClient__f_log, "signInWithOtp");
  var policy = this.Lframework_auth_SupabaseAuthClient__f_retryPolicy;
  var valueHandler = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((x$1, x$2$4) => {
    var x4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), x$1, x$2$4);
    var x13 = x4.T2__f__1;
    var x14 = x4.T2__f__2;
    if ((x13 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
      var x16 = x13.s_util_Left__f_value;
      if ((!(!$i_$0040supabase$002fauth$002djs$002fdist$002fmodule$002flib$002ferrors.isAuthRetryableFetchError(x16)))) {
        var this$16 = $m_Lcats_effect_IO$();
        var thunk = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
          var $x_9 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
          var $x_8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
          var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["failed, retrying (", ")"]));
          var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
          var $x_7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
          var $x_6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$();
          var $x_5 = $m_Lpprint_package$();
          var this$8 = $m_Lpprint_package$();
          var $x_4 = this$8.Lpprint_PPrinter__f_defaultWidth;
          var this$9 = $m_Lpprint_package$();
          var $x_3 = this$9.Lpprint_PPrinter__f_defaultHeight;
          var this$10 = $m_Lpprint_package$();
          var $x_2 = this$10.Lpprint_PPrinter__f_defaultIndent;
          $m_Lpprint_package$();
          var this$11 = $m_Lpprint_package$();
          var $x_1 = this$11.Lpprint_PPrinter__f_defaultEscapeUnicode;
          var this$12 = $m_Lpprint_package$();
          var info$1 = $x_9.genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([$x_8.show$extension__s_StringContext__sci_Seq__T(sc, $x_7.genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($x_6.mat__O__Lcats_Show$ContravariantShow__T($x_5.apply__O__I__I__I__I__Z__Z__Lfansi_Str(x14, $x_4, $x_3, $x_2, 0, $x_1, this$12.Lpprint_PPrinter__f_defaultShowFieldNames).plainText__T(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))]))), x16]));
          var this$14 = $m_Lframework_prelude_client\uff3flogging$package$JSAppName$();
          var appName = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Newtype$WithoutValidation__apply__O__O(this$14, "app");
          var level = $s_Lframework_utils_LogLevel$__Info__Lframework_utils_LogLevel();
          log.atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V(level, log.scope__s_Option(), info$1, x$2, appName);
          var newAction = $p_Lframework_auth_SupabaseAuthClient__doTry$1__T__Lframework_utils_JSLogger__Lframework_sourcecode_DefinedAt__I__Lcats_effect_IO(this, email, log, x$2, ((1 + x14.Lretry_RetryDetails__f_retriesSoFar) | 0));
          return new $c_Lretry_HandlerDecision$Adapt(newAction);
        }));
        return this$16.delay__F0__Lcats_effect_IO(thunk);
      }
      var this$29 = $m_Lcats_effect_IO$();
      var thunk$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
        var $x_18 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
        var $x_17 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
        var parts$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["failed (", "):"]));
        var sc$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts$1);
        var $x_16 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
        var $x_15 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$();
        var $x_14 = $m_Lpprint_package$();
        var this$22 = $m_Lpprint_package$();
        var $x_13 = this$22.Lpprint_PPrinter__f_defaultWidth;
        var this$23 = $m_Lpprint_package$();
        var $x_12 = this$23.Lpprint_PPrinter__f_defaultHeight;
        var this$24 = $m_Lpprint_package$();
        var $x_11 = this$24.Lpprint_PPrinter__f_defaultIndent;
        $m_Lpprint_package$();
        var this$25 = $m_Lpprint_package$();
        var $x_10 = this$25.Lpprint_PPrinter__f_defaultEscapeUnicode;
        var this$26 = $m_Lpprint_package$();
        var err$2 = $x_18.genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([$x_17.show$extension__s_StringContext__sci_Seq__T(sc$1, $x_16.genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($x_15.mat__O__Lcats_Show$ContravariantShow__T($x_14.apply__O__I__I__I__I__Z__Z__Lfansi_Str(x14, $x_13, $x_12, $x_11, 0, $x_10, this$26.Lpprint_PPrinter__f_defaultShowFieldNames).plainText__T(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))]))), x16]));
        var this$28 = $m_Lframework_prelude_client\uff3flogging$package$JSAppName$();
        var appName$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Newtype$WithoutValidation__apply__O__O(this$28, "app");
        var level$1 = $s_Lframework_utils_LogLevel$__Error__Lframework_utils_LogLevel();
        log.atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V(level$1, log.scope__s_Option(), err$2, x$2, appName$1);
        return $s_Lretry_HandlerDecision$__Stop__Lretry_HandlerDecision();
      }));
      return this$29.delay__F0__Lcats_effect_IO(thunk$1);
    }
    if ((x13 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
      var messageId = x13.s_util_Right__f_value;
      var this$42 = $m_Lcats_effect_IO$();
      var thunk$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
        var $x_27 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
        var $x_26 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
        var parts$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["succeeded (", ")"]));
        var sc$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts$2);
        var $x_25 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
        var $x_24 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$();
        var $x_23 = $m_Lpprint_package$();
        var this$35 = $m_Lpprint_package$();
        var $x_22 = this$35.Lpprint_PPrinter__f_defaultWidth;
        var this$36 = $m_Lpprint_package$();
        var $x_21 = this$36.Lpprint_PPrinter__f_defaultHeight;
        var this$37 = $m_Lpprint_package$();
        var $x_20 = this$37.Lpprint_PPrinter__f_defaultIndent;
        $m_Lpprint_package$();
        var this$38 = $m_Lpprint_package$();
        var $x_19 = this$38.Lpprint_PPrinter__f_defaultEscapeUnicode;
        var this$39 = $m_Lpprint_package$();
        var info$2 = $x_27.genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([$x_26.show$extension__s_StringContext__sci_Seq__T(sc$2, $x_25.genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($x_24.mat__O__Lcats_Show$ContravariantShow__T($x_23.apply__O__I__I__I__I__Z__Z__Lfansi_Str(x14, $x_22, $x_21, $x_20, 0, $x_19, this$39.Lpprint_PPrinter__f_defaultShowFieldNames).plainText__T(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))]))), messageId]));
        var this$41 = $m_Lframework_prelude_client\uff3flogging$package$JSAppName$();
        var appName$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Newtype$WithoutValidation__apply__O__O(this$41, "app");
        var level$2 = $s_Lframework_utils_LogLevel$__Info__Lframework_utils_LogLevel();
        log.atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V(level$2, log.scope__s_Option(), info$2, x$2, appName$2);
        return $s_Lretry_HandlerDecision$__Stop__Lretry_HandlerDecision();
      }));
      return this$42.delay__F0__Lcats_effect_IO(thunk$2);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x4);
  }));
  var T = $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO;
  return $m_Lretry_package$package$().retryingOnFailures__O__Lretry_RetryPolicy__F2__Lcats_effect_kernel_GenTemporal__O($p_Lframework_auth_SupabaseAuthClient__doTry$1__T__Lframework_utils_JSLogger__Lframework_sourcecode_DefinedAt__I__Lcats_effect_IO(this, email, log, x$2, 0), policy, valueHandler, T).map__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$2) => $m_s_util_Either$MergeableEither$().merge$extension__s_util_Either__O(_$2))));
});
$c_Lframework_auth_SupabaseAuthClient.prototype.verifyOtp__T__T__Lframework_sourcecode_DefinedAt__Lcats_effect_IO = (function(email, otp, x$3) {
  var log = $f_Lframework_utils_JSLogger__scoped__T__Lframework_utils_JSLogger(this.Lframework_auth_SupabaseAuthClient__f_log, "verifyOtp");
  var policy = this.Lframework_auth_SupabaseAuthClient__f_retryPolicy;
  var valueHandler = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((x$1, x$2) => {
    if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
      var err = x$1.s_util_Left__f_value;
      if ((!(!$i_$0040supabase$002fauth$002djs$002fdist$002fmodule$002flib$002ferrors.isAuthRetryableFetchError(err)))) {
        $m_Lcats_effect_IO$();
        var newAction = $p_Lframework_auth_SupabaseAuthClient__doTry$2__T__T__Lframework_utils_JSLogger__Lframework_sourcecode_DefinedAt__I__Lcats_effect_IO(this, otp, email, log, x$3, ((1 + x$2.Lretry_RetryDetails__f_retriesSoFar) | 0));
        var value = new $c_Lretry_HandlerDecision$Adapt(newAction);
        return new $c_Lcats_effect_IO$Pure(value);
      }
    }
    $m_Lcats_effect_IO$();
    var value$1 = $s_Lretry_HandlerDecision$__Stop__Lretry_HandlerDecision();
    return new $c_Lcats_effect_IO$Pure(value$1);
  }));
  var T = $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO;
  return $m_Lretry_package$package$().retryingOnFailures__O__Lretry_RetryPolicy__F2__Lcats_effect_kernel_GenTemporal__O($p_Lframework_auth_SupabaseAuthClient__doTry$2__T__T__Lframework_utils_JSLogger__Lframework_sourcecode_DefinedAt__I__Lcats_effect_IO(this, otp, email, log, x$3, 0), policy, valueHandler, T).map__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$3) => $m_s_util_Either$MergeableEither$().merge$extension__s_util_Either__O(_$3))));
});
$c_Lframework_auth_SupabaseAuthClient.prototype.signOut__Lcats_effect_IO = (function() {
  var $x_1 = $m_Lcats_effect_IO$();
  var this$4 = $m_Lcats_effect_IO$();
  var thunk = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => this.Lframework_auth_SupabaseAuthClient__f_client.signOut()));
  return $x_1.fromPromise__Lcats_effect_IO__Lcats_effect_IO(this$4.delay__F0__Lcats_effect_IO(thunk)).map__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$4) => {
    var this$5 = $m_Lframework_exts_AOrNullExts$package$().jsValueOrNullToOption__O__s_Option(_$4.error);
    return (this$5.isEmpty__Z() ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right((void 0)) : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(this$5.get__O()));
  })));
});
var $d_Lframework_auth_SupabaseAuthClient = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_auth_SupabaseAuthClient, "framework.auth.SupabaseAuthClient", ({
  Lframework_auth_SupabaseAuthClient: 1
}));
export { $d_Lframework_auth_SupabaseAuthClient as $d_Lframework_auth_SupabaseAuthClient };
/** @constructor */
function $c_Lframework_auth_SupabaseAuthClient$() {
}
export { $c_Lframework_auth_SupabaseAuthClient$ as $c_Lframework_auth_SupabaseAuthClient$ };
$c_Lframework_auth_SupabaseAuthClient$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_auth_SupabaseAuthClient$.prototype.constructor = $c_Lframework_auth_SupabaseAuthClient$;
/** @constructor */
function $h_Lframework_auth_SupabaseAuthClient$() {
}
export { $h_Lframework_auth_SupabaseAuthClient$ as $h_Lframework_auth_SupabaseAuthClient$ };
$h_Lframework_auth_SupabaseAuthClient$.prototype = $c_Lframework_auth_SupabaseAuthClient$.prototype;
$c_Lframework_auth_SupabaseAuthClient$.prototype.requestResultSafeDestructureAsEither__Ltypings_supabaseAuthJs_distModuleLibTypesMod_RequestResultSafeDestructure__s_util_Either = (function(value) {
  var property = value.error;
  var cases = new ($d_Lframework_prelude_MatchDynamicBuilder$Case.getArrayOf().constr)(0);
  var this$8 = new $c_Lframework_prelude_MatchDynamicBuilder(value, property, cases).on__sjs_js_Any__F1__Lframework_prelude_MatchDynamicBuilder(null, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((v) => {
    var value$1 = v.data;
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value$1);
  })));
  matchResult5: {
    var $x_1;
    var x8 = this$8.performOrNone__s_Option();
    if ((x8 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var value$2 = x8.s_Some__f_value;
      var $x_1 = value$2;
      break matchResult5;
    }
    var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    if ((x === x8)) {
      var x0 = this$8.Lframework_prelude_MatchDynamicBuilder__f_obj;
      var value$3 = x0.error;
      var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value$3);
      break matchResult5;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x8);
  }
  return $x_1;
});
var $d_Lframework_auth_SupabaseAuthClient$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_auth_SupabaseAuthClient$, "framework.auth.SupabaseAuthClient$", ({
  Lframework_auth_SupabaseAuthClient$: 1
}));
export { $d_Lframework_auth_SupabaseAuthClient$ as $d_Lframework_auth_SupabaseAuthClient$ };
var $n_Lframework_auth_SupabaseAuthClient$;
function $m_Lframework_auth_SupabaseAuthClient$() {
  if ((!$n_Lframework_auth_SupabaseAuthClient$)) {
    $n_Lframework_auth_SupabaseAuthClient$ = new $c_Lframework_auth_SupabaseAuthClient$();
  }
  return $n_Lframework_auth_SupabaseAuthClient$;
}
export { $m_Lframework_auth_SupabaseAuthClient$ as $m_Lframework_auth_SupabaseAuthClient$ };
function $p_Lframework_components_AppToasts__renderToast__I__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_core_Signal__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, id, message, toastType, showCloseButton) {
  var $x_4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.div__Lcom_raquo_laminar_tags_HtmlTag();
  var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
  var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.Lcom_raquo_laminar_api_package$$anon$1__f_cls.$colon$eq__T__Lcom_raquo_laminar_modifiers_CompositeKeySetter("alert shadow-lg mb-2");
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.Lcom_raquo_laminar_api_package$$anon$1__f_cls;
  var project = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1) => {
    var x = $s_Lframework_components_ToastType$__Info__Lframework_components_ToastType();
    if (((x === null) ? (x$1 === null) : (x === x$1))) {
      return "alert-info";
    }
    var x$3 = $s_Lframework_components_ToastType$__Success__Lframework_components_ToastType();
    if (((x$3 === null) ? (x$1 === null) : (x$3 === x$1))) {
      return "alert-success";
    }
    var x$5 = $s_Lframework_components_ToastType$__Warning__Lframework_components_ToastType();
    if (((x$5 === null) ? (x$1 === null) : (x$5 === x$1))) {
      return "alert-warning";
    }
    var x$7 = $s_Lframework_components_ToastType$__Error__Lframework_components_ToastType();
    if (((x$7 === null) ? (x$1 === null) : (x$7 === x$1))) {
      return "alert-error";
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  }));
  var items = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), toastType, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var valueMapper = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.StringValueMapper__Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringValueMapper$();
  var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_laminar_modifiers_CompositeKeyUpdater(this$1, items, valueMapper);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$();
  var project$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1$2) => {
    var x$2 = $s_Lframework_components_ToastType$__Info__Lframework_components_ToastType();
    if (((x$2 === null) ? (x$1$2 === null) : (x$2 === x$1$2))) {
      return $j_app$002ecomponents$002e$002dApp$002dIcons$0024.$m_Lapp_components_AppIcons$().Info__Lcom_raquo_laminar_nodes_ReactiveSvgElement();
    }
    var x$3$1 = $s_Lframework_components_ToastType$__Success__Lframework_components_ToastType();
    if (((x$3$1 === null) ? (x$1$2 === null) : (x$3$1 === x$1$2))) {
      return $j_app$002ecomponents$002e$002dApp$002dIcons$0024.$m_Lapp_components_AppIcons$().Success__Lcom_raquo_laminar_nodes_ReactiveSvgElement();
    }
    var x$5$1 = $s_Lframework_components_ToastType$__Warning__Lframework_components_ToastType();
    if (((x$5$1 === null) ? (x$1$2 === null) : (x$5$1 === x$1$2))) {
      return $j_app$002ecomponents$002e$002dApp$002dIcons$0024.$m_Lapp_components_AppIcons$().Warning__Lcom_raquo_laminar_nodes_ReactiveSvgElement();
    }
    var x$7$1 = $s_Lframework_components_ToastType$__Error__Lframework_components_ToastType();
    if (((x$7$1 === null) ? (x$1$2 === null) : (x$7$1 === x$1$2))) {
      return $j_app$002ecomponents$002e$002dApp$002dIcons$0024.$m_Lapp_components_AppIcons$().Error__Lcom_raquo_laminar_nodes_ReactiveSvgElement();
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1$2);
  }));
  var childSource = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), toastType, project$1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  return $x_4.apply__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($x_3.wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_laminar_modifiers_Modifier.getArrayOf().constr)([$x_2, $x_1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_inserters_ChildInserter$().apply__Lcom_raquo_airstream_core_Observable__Lcom_raquo_laminar_modifiers_RenderableNode__O__Lcom_raquo_laminar_inserters_DynamicInserter(childSource, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_modifiers_RenderableNode$().Lcom_raquo_laminar_modifiers_RenderableNode$__f_nodeRenderable, (void 0)), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.span__Lcom_raquo_laminar_tags_HtmlTag().apply__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_laminar_modifiers_Modifier.getArrayOf().constr)([($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_inserters_ChildTextInserter$().apply__Lcom_raquo_airstream_core_Observable__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_inserters_DynamicInserter(message, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_modifiers_RenderableText$().Lcom_raquo_laminar_modifiers_RenderableText$__f_stringRenderable))]))), ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_receivers_ChildOptionReceiver$()).$less$minus$minus__Lcom_raquo_airstream_core_Source__Lcom_raquo_laminar_inserters_DynamicInserter($m_Lframework_exts_SignalOfBooleanExts$package$().splitBooleanAsOption__Lcom_raquo_airstream_core_Signal__F1__Lcom_raquo_airstream_core_Signal(showCloseButton, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$4) => {
    var $x_8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.button__Lcom_raquo_laminar_tags_HtmlTag();
    var $x_7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
    var $x_6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.Lcom_raquo_laminar_api_package$$anon$1__f_cls.$colon$eq__T__Lcom_raquo_laminar_modifiers_CompositeKeySetter("btn btn-ghost btn-xs");
    var this$10 = $j_app$002ecomponents$002e$002dApp$002dIcons$0024.$m_Lapp_components_AppIcons$();
    var $x_5 = this$10.Cancel__Lcom_raquo_laminar_nodes_ReactiveSvgElement();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$();
    var eventProp = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.onClick__Lcom_raquo_laminar_keys_EventProp();
    var this$12 = $m_Lcom_raquo_laminar_keys_EventProcessor$().empty__Lcom_raquo_laminar_keys_EventProp__Z__Z__Lcom_raquo_laminar_keys_EventProcessor(eventProp, false, false);
    var onNext = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$5) => {
      $thiz.close__I__V(id);
    }));
    return $x_8.apply__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($x_7.wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_laminar_modifiers_Modifier.getArrayOf().constr)([$x_6, $x_5, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_laminar_modifiers_EventListener(this$12, onNext)])));
  }))))])));
}
export { $p_Lframework_components_AppToasts__renderToast__I__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_core_Signal__Lcom_raquo_laminar_nodes_ReactiveHtmlElement as $p_Lframework_components_AppToasts__renderToast__I__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_core_Signal__Lcom_raquo_laminar_nodes_ReactiveHtmlElement };
/** @constructor */
function $c_Lframework_components_AppToasts(icons) {
  this.Lframework_components_AppToasts__f_icons = null;
  this.Lframework_components_AppToasts__f_toastsVar = null;
  this.Lframework_components_AppToasts__f_tag = null;
  this.Lframework_components_AppToasts__f_icons = icons;
  this.Lframework_components_AppToasts__f_toastsVar = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.Lcom_raquo_laminar_api_package$$anon$1__f_Var.apply__O__Lcom_raquo_airstream_state_Var($m_sci_SortedMap$().empty__s_math_Ordering__O($m_Lframework_components_AppToasts$package$ToastId$().given_Ordering_Type__s_math_Ordering()));
  var $x_6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.div__Lcom_raquo_laminar_tags_HtmlTag();
  var $x_5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
  var $x_4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.Lcom_raquo_laminar_api_package$$anon$1__f_cls.$colon$eq__T__Lcom_raquo_laminar_modifiers_CompositeKeySetter("toast");
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.zIndex__Lcom_raquo_laminar_keys_StyleProp();
  var $x_3 = new $c_Lcom_raquo_laminar_modifiers_SimpleKeySetter$StyleSetter(this$1, 1000);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$();
  $m_Lcom_raquo_airstream_core_Observable$();
  var this$10 = this.Lframework_components_AppToasts__f_toastsVar.signal__Lcom_raquo_airstream_state_StrictSignal();
  var project = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$6) => {
    var tree = _$6.sci_TreeMap__f_tree;
    var start = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    var evidence$16 = _$6.sci_TreeMap__f_ordering;
    var this$8 = new $c_sci_RedBlackTree$EntriesIterator(tree, start, evidence$16);
    var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1) => {
      if ((x$1 !== null)) {
        var id = (x$1._1__O() | 0);
        var ref = x$1._2__O();
        var y = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), id, ref);
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), id, y);
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    }));
    var this$9 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(this$8, f);
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$9);
  }));
  var observable = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), this$10, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var childrenSource = $m_Lcom_raquo_airstream_split_SplittableObservable$().split$extension__Lcom_raquo_airstream_core_Observable__F1__F1__Lcom_raquo_airstream_split_DuplicateKeysConfig__F3__Lcom_raquo_airstream_split_Splittable__Lcom_raquo_airstream_core_Signal(observable, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$7) => (_$7._1__O() | 0))), $m_Lcom_raquo_airstream_split_SplittableObservable$().split$default$2$extension__Lcom_raquo_airstream_core_Observable__F1(observable), $m_Lcom_raquo_airstream_split_DuplicateKeysConfig$().Lcom_raquo_airstream_split_DuplicateKeysConfig$__f_default, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction3_$$Lambda$26e0a25d9b29f6b82ea50ab7badf4fb70c5c74e1(((x$1$1, x$2, x$3) => {
    var x$1$2 = (x$1$1 | 0);
    var project$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$8) => _$8._2__O()._2__O()));
    var data = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), x$3, project$1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
    var project$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$9) => {
      var x11 = _$9.Lframework_components_ToastData__f_message;
      if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$is_Lcom_raquo_airstream_core_Signal(x11)) {
        return x11;
      }
      return $m_Lcom_raquo_airstream_state_Val$().apply__O__Lcom_raquo_airstream_state_Val(x11);
    }));
    var strategy = $m_Lcom_raquo_airstream_core_Observable$().Lcom_raquo_airstream_core_Observable$__f_switchSignalStrategy;
    var $x_2 = strategy.flatten__Lcom_raquo_airstream_core_Observable__Lcom_raquo_airstream_core_Observable($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), data, project$2, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()));
    var project$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$10) => _$10.Lframework_components_ToastData__f_toastType));
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), data, project$3, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
    var project$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$11) => _$11.Lframework_components_ToastData__f_showCloseButton));
    return $p_Lframework_components_AppToasts__renderToast__I__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_core_Signal__Lcom_raquo_laminar_nodes_ReactiveHtmlElement(this, x$1$2, $x_2, $x_1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), data, project$4, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()));
  })), $m_Lcom_raquo_airstream_split_Splittable$VectorSplittable$());
  this.Lframework_components_AppToasts__f_tag = $x_6.apply__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($x_5.wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_laminar_modifiers_Modifier.getArrayOf().constr)([$x_4, $x_3, $m_Lcom_raquo_laminar_inserters_ChildrenInserter$().apply__Lcom_raquo_airstream_core_Observable__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_RenderableNode__O__Lcom_raquo_laminar_inserters_DynamicInserter(childrenSource, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_modifiers_RenderableNode$().Lcom_raquo_laminar_modifiers_RenderableNode$__f_nodeRenderable, (void 0))])));
}
export { $c_Lframework_components_AppToasts as $c_Lframework_components_AppToasts };
$c_Lframework_components_AppToasts.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_components_AppToasts.prototype.constructor = $c_Lframework_components_AppToasts;
/** @constructor */
function $h_Lframework_components_AppToasts() {
}
export { $h_Lframework_components_AppToasts as $h_Lframework_components_AppToasts };
$h_Lframework_components_AppToasts.prototype = $c_Lframework_components_AppToasts.prototype;
$c_Lframework_components_AppToasts.prototype.show__O__Lframework_components_ToastType__s_concurrent_duration_FiniteDuration__Z__I = (function(message, toastType, duration, showCloseButton) {
  var id = $m_Lframework_components_AppToasts$().framework$components$AppToasts$$$generateId__I();
  this.show__I__Lframework_components_ToastData__V(id, new $c_Lframework_components_ToastData(message, toastType, showCloseButton, duration));
  return id;
});
$c_Lframework_components_AppToasts.prototype.show$default$3__s_concurrent_duration_FiniteDuration = (function() {
  var this$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_package$DurationInt(5);
  var unit = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
  var this$ = this$2.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$();
  var hi = (this$ >> 31);
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_FiniteDuration(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(this$, hi), unit);
});
$c_Lframework_components_AppToasts.prototype.show__I__Lframework_components_ToastData__V = (function(id, data) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_state_Var__update__F1__V(this.Lframework_components_AppToasts__f_toastsVar, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$1) => _$1.updated__O__O__sci_TreeMap(id, data))));
  $m_Lframework_exts_FutureCompanionExts$package$().delay__s_concurrent_Future$__s_concurrent_duration_FiniteDuration__s_concurrent_Future($m_s_concurrent_Future$(), data.Lframework_components_ToastData__f_duration).foreach__F1__s_concurrent_ExecutionContext__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$2) => {
    this.close__I__V(id);
  })), $m_Lframework_prelude_prelude\uff3fclient$package$().executionContext__s_concurrent_ExecutionContext());
});
$c_Lframework_components_AppToasts.prototype.close__I__V = (function(toastId) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_state_Var__update__F1__V(this.Lframework_components_AppToasts__f_toastsVar, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$3) => _$3.removed__O__sci_MapOps(toastId))));
});
var $d_Lframework_components_AppToasts = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_components_AppToasts, "framework.components.AppToasts", ({
  Lframework_components_AppToasts: 1
}));
export { $d_Lframework_components_AppToasts as $d_Lframework_components_AppToasts };
/** @constructor */
function $c_Lframework_components_AppToasts$() {
  this.Lframework_components_AppToasts$__f_nextId = 0;
  this.Lframework_components_AppToasts$__f_nextId = 0;
}
export { $c_Lframework_components_AppToasts$ as $c_Lframework_components_AppToasts$ };
$c_Lframework_components_AppToasts$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_components_AppToasts$.prototype.constructor = $c_Lframework_components_AppToasts$;
/** @constructor */
function $h_Lframework_components_AppToasts$() {
}
export { $h_Lframework_components_AppToasts$ as $h_Lframework_components_AppToasts$ };
$h_Lframework_components_AppToasts$.prototype = $c_Lframework_components_AppToasts$.prototype;
$c_Lframework_components_AppToasts$.prototype.framework$components$AppToasts$$$generateId__I = (function() {
  var id = this.Lframework_components_AppToasts$__f_nextId;
  this.Lframework_components_AppToasts$__f_nextId = ((1 + this.Lframework_components_AppToasts$__f_nextId) | 0);
  var this$1 = $m_Lframework_components_AppToasts$package$ToastId$();
  return ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Newtype$WithoutValidation__apply__O__O(this$1, id) | 0);
});
var $d_Lframework_components_AppToasts$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_components_AppToasts$, "framework.components.AppToasts$", ({
  Lframework_components_AppToasts$: 1
}));
export { $d_Lframework_components_AppToasts$ as $d_Lframework_components_AppToasts$ };
var $n_Lframework_components_AppToasts$;
function $m_Lframework_components_AppToasts$() {
  if ((!$n_Lframework_components_AppToasts$)) {
    $n_Lframework_components_AppToasts$ = new $c_Lframework_components_AppToasts$();
  }
  return $n_Lframework_components_AppToasts$;
}
export { $m_Lframework_components_AppToasts$ as $m_Lframework_components_AppToasts$ };
/** @constructor */
function $c_Lframework_components_MultilineText$package$() {
}
export { $c_Lframework_components_MultilineText$package$ as $c_Lframework_components_MultilineText$package$ };
$c_Lframework_components_MultilineText$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_components_MultilineText$package$.prototype.constructor = $c_Lframework_components_MultilineText$package$;
/** @constructor */
function $h_Lframework_components_MultilineText$package$() {
}
export { $h_Lframework_components_MultilineText$package$ as $h_Lframework_components_MultilineText$package$ };
$h_Lframework_components_MultilineText$package$.prototype = $c_Lframework_components_MultilineText$package$.prototype;
$c_Lframework_components_MultilineText$package$.prototype.MultilineText__T__sci_Vector = (function(str) {
  var xs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__split__T__I__AT(str, "\n", 0);
  var this$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_ArrayOps$().iterator$extension__O__sc_Iterator(xs);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$1) => {
    var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.p__Lcom_raquo_laminar_tags_HtmlTag();
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$();
    var r = $m_Lframework_prelude_laminar$package$().renderableTextForShow__Lcats_Show__Lcom_raquo_laminar_modifiers_RenderableText($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString);
    return $x_2.apply__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($x_1.wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_laminar_modifiers_Modifier.getArrayOf().constr)([$m_Lcom_raquo_laminar_nodes_TextNode$().apply__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode(_$1, r)])));
  }));
  var this$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(this$6, f);
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$7);
});
$c_Lframework_components_MultilineText$package$.prototype.MultilineText__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_core_Signal = (function(str) {
  $m_Lcom_raquo_airstream_core_Observable$();
  var project = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$2) => {
    var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__split__T__I__AT(_$2, "\n", 0));
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$1);
  }));
  var observable = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), str, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  return $m_Lcom_raquo_airstream_split_SplittableObservable$().splitByIndex$extension__Lcom_raquo_airstream_core_Observable__F3__Lcom_raquo_airstream_split_Splittable__Lcom_raquo_airstream_core_Signal(observable, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction3_$$Lambda$26e0a25d9b29f6b82ea50ab7badf4fb70c5c74e1(((_$3, _$4, signal) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.p__Lcom_raquo_laminar_tags_HtmlTag().apply__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_laminar_modifiers_Modifier.getArrayOf().constr)([($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_inserters_ChildTextInserter$().apply__Lcom_raquo_airstream_core_Observable__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_inserters_DynamicInserter(signal, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_modifiers_RenderableText$().Lcom_raquo_laminar_modifiers_RenderableText$__f_stringRenderable))]))))), $m_Lcom_raquo_airstream_split_Splittable$VectorSplittable$());
});
var $d_Lframework_components_MultilineText$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_components_MultilineText$package$, "framework.components.MultilineText$package$", ({
  Lframework_components_MultilineText$package$: 1
}));
export { $d_Lframework_components_MultilineText$package$ as $d_Lframework_components_MultilineText$package$ };
var $n_Lframework_components_MultilineText$package$;
function $m_Lframework_components_MultilineText$package$() {
  if ((!$n_Lframework_components_MultilineText$package$)) {
    $n_Lframework_components_MultilineText$package$ = new $c_Lframework_components_MultilineText$package$();
  }
  return $n_Lframework_components_MultilineText$package$;
}
export { $m_Lframework_components_MultilineText$package$ as $m_Lframework_components_MultilineText$package$ };
/** @constructor */
function $c_Lframework_components_Spinner$package$() {
}
export { $c_Lframework_components_Spinner$package$ as $c_Lframework_components_Spinner$package$ };
$c_Lframework_components_Spinner$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_components_Spinner$package$.prototype.constructor = $c_Lframework_components_Spinner$package$;
/** @constructor */
function $h_Lframework_components_Spinner$package$() {
}
export { $h_Lframework_components_Spinner$package$ as $h_Lframework_components_Spinner$package$ };
$h_Lframework_components_Spinner$package$.prototype = $c_Lframework_components_Spinner$package$.prototype;
$c_Lframework_components_Spinner$package$.prototype.Spinner__Lcom_raquo_laminar_nodes_ReactiveHtmlElement = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.span__Lcom_raquo_laminar_tags_HtmlTag().apply__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_laminar_modifiers_Modifier.getArrayOf().constr)([$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.Lcom_raquo_laminar_api_package$$anon$1__f_cls.$colon$eq__T__Lcom_raquo_laminar_modifiers_CompositeKeySetter("loading loading-spinner")])));
});
var $d_Lframework_components_Spinner$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_components_Spinner$package$, "framework.components.Spinner$package$", ({
  Lframework_components_Spinner$package$: 1
}));
export { $d_Lframework_components_Spinner$package$ as $d_Lframework_components_Spinner$package$ };
var $n_Lframework_components_Spinner$package$;
function $m_Lframework_components_Spinner$package$() {
  if ((!$n_Lframework_components_Spinner$package$)) {
    $n_Lframework_components_Spinner$package$ = new $c_Lframework_components_Spinner$package$();
  }
  return $n_Lframework_components_Spinner$package$;
}
export { $m_Lframework_components_Spinner$package$ as $m_Lframework_components_Spinner$package$ };
/** @constructor */
function $c_Lframework_components_Tooltip$package$() {
}
export { $c_Lframework_components_Tooltip$package$ as $c_Lframework_components_Tooltip$package$ };
$c_Lframework_components_Tooltip$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_components_Tooltip$package$.prototype.constructor = $c_Lframework_components_Tooltip$package$;
/** @constructor */
function $h_Lframework_components_Tooltip$package$() {
}
export { $h_Lframework_components_Tooltip$package$ as $h_Lframework_components_Tooltip$package$ };
$h_Lframework_components_Tooltip$package$.prototype = $c_Lframework_components_Tooltip$package$.prototype;
$c_Lframework_components_Tooltip$package$.prototype.Tooltip__Lcom_raquo_airstream_core_Signal__sci_Seq__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveHtmlElement = (function(tooltip, modifiers, content) {
  var $x_5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.div__Lcom_raquo_laminar_tags_HtmlTag();
  var $x_4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
  var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.Lcom_raquo_laminar_api_package$$anon$1__f_cls.$colon$eq__T__Lcom_raquo_laminar_modifiers_CompositeKeySetter("tooltip");
  var this$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L;
  var this$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_$less$colon$less$();
  var asModifier = this$5.s_$less$colon$less$__f_singleton;
  var renderableSeq = $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$();
  var $x_2 = $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier(this$6, modifiers, asModifier, renderableSeq);
  var this$8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L;
  var this$11 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_laminar_defs_complex_ComplexGlobalKeys__dataAttr__T__Lcom_raquo_laminar_keys_HtmlAttr(this$8, "tip");
  var this$10 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_$less$colon$less$();
  var ev = this$10.s_$less$colon$less$__f_singleton;
  var $x_1 = $f_Lcom_raquo_laminar_keys_SimpleAttr__$less$minus$minus__Lcom_raquo_airstream_core_Source__F1__Lcom_raquo_laminar_modifiers_SimpleKeyUpdater(this$11, tooltip, ev);
  var this$15 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L;
  var this$14 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_$less$colon$less$();
  var asModifier$1 = this$14.s_$less$colon$less$__f_singleton;
  var renderableSeq$1 = $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$();
  return $x_5.apply__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($x_4.wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_laminar_modifiers_Modifier.getArrayOf().constr)([$x_3, $x_2, $x_1, $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier(this$15, content, asModifier$1, renderableSeq$1)])));
});
$c_Lframework_components_Tooltip$package$.prototype.tooltipMaybeSignal__Lcom_raquo_airstream_core_Signal__sci_Seq__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveHtmlElement = (function(tooltip, modifiers, content) {
  var $x_6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.div__Lcom_raquo_laminar_tags_HtmlTag();
  var $x_5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
  var this$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.Lcom_raquo_laminar_api_package$$anon$1__f_cls;
  var $x_4 = this$3.$colon$eq__T__Lcom_raquo_laminar_modifiers_CompositeKeySetter("tooltip");
  var project = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$1) => (!_$1.isEmpty__Z())));
  var $x_3 = $x_4.$less$minus$minus__Lcom_raquo_airstream_core_Source__Lcom_raquo_laminar_modifiers_CompositeKeyUpdater($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), tooltip, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()));
  var this$7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L;
  var this$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_$less$colon$less$();
  var asModifier = this$6.s_$less$colon$less$__f_singleton;
  var renderableSeq = $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$();
  var $x_2 = $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier(this$7, modifiers, asModifier, renderableSeq);
  var this$9 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L;
  var this$12 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_laminar_defs_complex_ComplexGlobalKeys__dataAttr__T__Lcom_raquo_laminar_keys_HtmlAttr(this$9, "tip");
  var project$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$2) => (_$2.isEmpty__Z() ? "" : _$2.get__O())));
  var values = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), tooltip, project$1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var this$11 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_$less$colon$less$();
  var ev = this$11.s_$less$colon$less$__f_singleton;
  var $x_1 = $f_Lcom_raquo_laminar_keys_SimpleAttr__$less$minus$minus__Lcom_raquo_airstream_core_Source__F1__Lcom_raquo_laminar_modifiers_SimpleKeyUpdater(this$12, values, ev);
  var this$16 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L;
  var this$15 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_$less$colon$less$();
  var asModifier$1 = this$15.s_$less$colon$less$__f_singleton;
  var renderableSeq$1 = $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$();
  return $x_6.apply__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($x_5.wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_laminar_modifiers_Modifier.getArrayOf().constr)([$x_3, $x_2, $x_1, $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier(this$16, content, asModifier$1, renderableSeq$1)])));
});
var $d_Lframework_components_Tooltip$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_components_Tooltip$package$, "framework.components.Tooltip$package$", ({
  Lframework_components_Tooltip$package$: 1
}));
export { $d_Lframework_components_Tooltip$package$ as $d_Lframework_components_Tooltip$package$ };
var $n_Lframework_components_Tooltip$package$;
function $m_Lframework_components_Tooltip$package$() {
  if ((!$n_Lframework_components_Tooltip$package$)) {
    $n_Lframework_components_Tooltip$package$ = new $c_Lframework_components_Tooltip$package$();
  }
  return $n_Lframework_components_Tooltip$package$;
}
export { $m_Lframework_components_Tooltip$package$ as $m_Lframework_components_Tooltip$package$ };
function $f_Lframework_data_AppBaseUri__isDevelopment__Z($thiz) {
  return (!(!(!$m_Lframework_data_IsProductionMode$package$IsProductionMode$().given_Conversion_Type_Boolean__s_Conversion().apply__O__O($thiz.isProduction__Z()))));
}
export { $f_Lframework_data_AppBaseUri__isDevelopment__Z as $f_Lframework_data_AppBaseUri__isDevelopment__Z };
function $f_Lframework_data_AppBaseUri__toString__T($thiz) {
  var envStr = ((!(!$m_Lframework_data_IsProductionMode$package$IsProductionMode$().given_Conversion_Type_Boolean__s_Conversion().apply__O__O($thiz.isProduction__Z()))) ? "production" : "development");
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
  var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["AppBaseUri(", ", ", ")"]));
  var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
  return $x_1.show$extension__s_StringContext__sci_Seq__T(sc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(envStr, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString)), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T($thiz.Lframework_data_AppBaseUri$$anon$3__f_uri, $m_Lframework_prelude_sttp$package$().given_Show_Uri__Lcats_Show()))])));
}
export { $f_Lframework_data_AppBaseUri__toString__T as $f_Lframework_data_AppBaseUri__toString__T };
/** @constructor */
function $c_Lframework_data_AppBaseUri$() {
  this.Lframework_data_AppBaseUri$__f_given_Show_AppBaseUri$lzy1 = null;
  this.Lframework_data_AppBaseUri$__f_given_Show_AppBaseUribitmap$1 = false;
}
export { $c_Lframework_data_AppBaseUri$ as $c_Lframework_data_AppBaseUri$ };
$c_Lframework_data_AppBaseUri$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_AppBaseUri$.prototype.constructor = $c_Lframework_data_AppBaseUri$;
/** @constructor */
function $h_Lframework_data_AppBaseUri$() {
}
export { $h_Lframework_data_AppBaseUri$ as $h_Lframework_data_AppBaseUri$ };
$h_Lframework_data_AppBaseUri$.prototype = $c_Lframework_data_AppBaseUri$.prototype;
$c_Lframework_data_AppBaseUri$.prototype.given_Show_AppBaseUri__Lcats_Show = (function() {
  if ((!this.Lframework_data_AppBaseUri$__f_given_Show_AppBaseUribitmap$1)) {
    this.Lframework_data_AppBaseUri$__f_given_Show_AppBaseUri$lzy1 = new $c_Lframework_data_AppBaseUri$$anon$1();
    this.Lframework_data_AppBaseUri$__f_given_Show_AppBaseUribitmap$1 = true;
  }
  return this.Lframework_data_AppBaseUri$__f_given_Show_AppBaseUri$lzy1;
});
$c_Lframework_data_AppBaseUri$.prototype.scheme__Lorg_scalajs_dom_Location__T = (function(location) {
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_StringOps$();
  var x = location.protocol;
  return $x_1.stripSuffix$extension__T__T__T(x, ":");
});
$c_Lframework_data_AppBaseUri$.prototype.locationPort__Lorg_scalajs_dom_Location__s_util_Either = (function(location) {
  var _1 = location.port;
  var _2 = this.scheme__Lorg_scalajs_dom_Location__T(location);
  if ((_1 === "")) {
    if ((_2 === "http")) {
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(80);
    }
    if ((_2 === "https")) {
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(443);
    }
  }
  var this$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_StringParsers$().parseShort__T__s_Option(_1);
  if (this$6.isEmpty__Z()) {
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
    var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["Cannot parse port '", "' for scheme '", "'"]));
    var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left($x_1.show$extension__s_StringContext__sci_Seq__T(sc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(_1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString)), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(_2, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))]))));
  } else {
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(this$6.get__O());
  }
});
$c_Lframework_data_AppBaseUri$.prototype.determineFromMetaTag__Lorg_scalajs_dom_HTMLDocument__T__sci_Set__S__Lframework_data_AppBaseUri = (function(document, metaTag, metaTagContentForProduction, portForDevelopmentServer) {
  var this$1 = $m_Lframework_exts_DocumentExts$package$().getMetaContent__Lorg_scalajs_dom_Document__T__s_Option(document, metaTag);
  if ((!this$1.isEmpty__Z())) {
    var x0 = this$1.get__O();
    var isProd = metaTagContentForProduction.contains__O__Z(x0);
  } else {
    var isProd = false;
  }
  var location = document.location;
  var scheme = $m_Lframework_data_AppBaseUri$().scheme__Lorg_scalajs_dom_Location__T(location);
  var e = this.locationPort__Lorg_scalajs_dom_Location__s_util_Either(location);
  matchResult3: {
    var port;
    if ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
      var value = e.s_util_Left__f_value;
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalStateException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalStateException(), (("Expected Right, got Left(" + value) + ")"));
    }
    if ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
      var value$2 = (e.s_util_Right__f_value | 0);
      var port = value$2;
      break matchResult3;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(e);
  }
  var serverPort = (isProd ? port : portForDevelopmentServer);
  return new $c_Lframework_data_AppBaseUri$$anon$3(scheme, location, serverPort, isProd);
});
$c_Lframework_data_AppBaseUri$.prototype.determineFromMetaTag$default$1__Lorg_scalajs_dom_HTMLDocument = (function() {
  return document;
});
$c_Lframework_data_AppBaseUri$.prototype.determineFromMetaTag$default$3__sci_Set = (function() {
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Set$();
  var elems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["production", "staging"]));
  return this$1.from__sc_IterableOnce__sci_Set(elems);
});
var $d_Lframework_data_AppBaseUri$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_AppBaseUri$, "framework.data.AppBaseUri$", ({
  Lframework_data_AppBaseUri$: 1
}));
export { $d_Lframework_data_AppBaseUri$ as $d_Lframework_data_AppBaseUri$ };
var $n_Lframework_data_AppBaseUri$;
function $m_Lframework_data_AppBaseUri$() {
  if ((!$n_Lframework_data_AppBaseUri$)) {
    $n_Lframework_data_AppBaseUri$ = new $c_Lframework_data_AppBaseUri$();
  }
  return $n_Lframework_data_AppBaseUri$;
}
export { $m_Lframework_data_AppBaseUri$ as $m_Lframework_data_AppBaseUri$ };
function $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasRespondedState__maybeClientData__s_Option($thiz) {
  if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasRespondedState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
  if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasRespondedState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
    var value = $thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_clientData;
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
  }
  if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasRespondedState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
    var value$1 = $thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_clientData;
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value$1);
  }
  if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasRespondedState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
    var value$2 = $thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_clientData;
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value$2);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError($thiz);
}
export { $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasRespondedState__maybeClientData__s_Option as $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasRespondedState__maybeClientData__s_Option };
function $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__toString__T($thiz) {
  if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
    $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$();
    var x39 = $thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading__f_maybeRedirectToAfterRegistration;
    return (("Loading(redirect=" + x39) + ")");
  }
  if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
    $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$();
    var x35 = $thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated__f_failure;
    var x36 = $thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated__f_maybeRedirectToAfterRegistration;
    return (((("NotAuthenticated(failure=" + x35) + ", redirect=") + x36) + ")");
  }
  if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
    $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$();
    var x31 = $thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_clientData;
    var x32 = $thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_maybeRedirectToAfterRegistration;
    return (((("AuthenticatedInClientSide(clientData=" + x31) + ", redirect=") + x32) + ")");
  }
  if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
    $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$();
    var x26 = $thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_clientData;
    var x27 = $thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_serverData;
    var x28 = $thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_maybeRedirectToAfterRegistration;
    return (((((("AuthenticatedInClientSideButNotServerSide(clientData=" + x26) + ", serverData=") + x27) + ", redirect=") + x28) + ")");
  }
  if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
    $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$();
    var x21 = $thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_clientData;
    var x22 = $thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_serverData;
    var x23 = $thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_maybeRedirectToAfterRegistration;
    return (((((("Authenticated(clientData=" + x21) + ", serverData=") + x22) + ", redirect=") + x23) + ")");
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError($thiz);
}
export { $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__toString__T as $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__toString__T };
function $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__isLoading__Z($thiz) {
  matchAlts3: {
    matchAlts4: {
      if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
        break matchAlts4;
      }
      if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
        break matchAlts4;
      }
      break matchAlts3;
    }
    return true;
  }
  matchAlts1: {
    matchAlts2: {
      if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
        break matchAlts2;
      }
      if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
        break matchAlts2;
      }
      if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
        break matchAlts2;
      }
      break matchAlts1;
    }
    return false;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError($thiz);
}
export { $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__isLoading__Z as $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__isLoading__Z };
function $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__asClientSideHasRespondedState__s_Option($thiz) {
  if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
  if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($thiz);
  }
  if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($thiz);
  }
  if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($thiz);
  }
  if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($thiz);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError($thiz);
}
export { $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__asClientSideHasRespondedState__s_Option as $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__asClientSideHasRespondedState__s_Option };
function $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__asClientSideHasSucceededState__s_Option($thiz) {
  matchAlts5: {
    matchAlts6: {
      if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
        break matchAlts6;
      }
      if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
        break matchAlts6;
      }
      break matchAlts5;
    }
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
  if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($thiz);
  }
  if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($thiz);
  }
  if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($thiz);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError($thiz);
}
export { $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__asClientSideHasSucceededState__s_Option as $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__asClientSideHasSucceededState__s_Option };
function $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__asNotAuthenticated__s_Option($thiz) {
  matchAlts11: {
    matchAlts12: {
      if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
        break matchAlts12;
      }
      if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
        break matchAlts12;
      }
      if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
        break matchAlts12;
      }
      if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
        break matchAlts12;
      }
      break matchAlts11;
    }
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
  if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($thiz);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError($thiz);
}
export { $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__asNotAuthenticated__s_Option as $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__asNotAuthenticated__s_Option };
function $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__asClientSideAuthFailure__s_Option($thiz) {
  var this$1 = $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__asNotAuthenticated__s_Option($thiz);
  if (this$1.isEmpty__Z()) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0 = this$1.get__O();
    return x0.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated__f_failure;
  }
}
export { $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__asClientSideAuthFailure__s_Option as $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__asClientSideAuthFailure__s_Option };
function $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__asAuthenticated__s_Option($thiz) {
  matchAlts13: {
    matchAlts14: {
      if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
        break matchAlts14;
      }
      if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
        break matchAlts14;
      }
      if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
        break matchAlts14;
      }
      if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
        break matchAlts14;
      }
      break matchAlts13;
    }
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
  if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($thiz);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError($thiz);
}
export { $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__asAuthenticated__s_Option as $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__asAuthenticated__s_Option };
function $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__withRedirectToAfterAuthentication__O__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState($thiz, page) {
  matchResult15: {
    var $x_1;
    if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
      var $x_1 = $thiz.copy__s_Option__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(page));
      break matchResult15;
    }
    if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
      var $x_1 = $thiz.copy__s_Option__s_Option__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated__f_failure, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(page));
      break matchResult15;
    }
    if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
      var $x_1 = $thiz.copy__O__s_Option__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_clientData, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(page));
      break matchResult15;
    }
    if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
      var $x_1 = $thiz.copy__O__O__s_Option__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_clientData, $thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_serverData, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(page));
      break matchResult15;
    }
    if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
      var $x_1 = $thiz;
      break matchResult15;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError($thiz);
  }
  return $x_1;
}
export { $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__withRedirectToAfterAuthentication__O__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState as $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__withRedirectToAfterAuthentication__O__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState };
function $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__redirectToAfterRegistration__Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage__O($thiz, root) {
  var this$1 = $thiz.maybeRedirectToAfterRegistration__s_Option();
  return (this$1.isEmpty__Z() ? root.Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage__f_page : this$1.get__O());
}
export { $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__redirectToAfterRegistration__Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage__O as $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__redirectToAfterRegistration__Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage__O };
function $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__toNotAuthenticated__s_Option__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated($thiz, failure) {
  return $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$().Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$__f_NotAuthenticated$lzy1.apply__s_Option__s_Option__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated(failure, $thiz.maybeRedirectToAfterRegistration__s_Option());
}
export { $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__toNotAuthenticated__s_Option__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated as $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__toNotAuthenticated__s_Option__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated };
function $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__toAuthenticatedInClientSide__O__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide($thiz, clientData) {
  return $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$().Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$__f_AuthenticatedInClientSide$lzy1.apply__O__s_Option__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide(clientData, $thiz.maybeRedirectToAfterRegistration__s_Option());
}
export { $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__toAuthenticatedInClientSide__O__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide as $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__toAuthenticatedInClientSide__O__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide };
/** @constructor */
function $c_Lframework_data_FrameworkDate$() {
  this.Lframework_data_FrameworkDate$__f_utc = null;
  this.Lframework_data_FrameworkDate$__f_formatter = null;
  this.Lframework_data_FrameworkDate$__f_circeCodec$lzy1 = null;
  this.Lframework_data_FrameworkDate$__f_circeCodecbitmap$1 = false;
  this.Lframework_data_FrameworkDate$__f_schema$lzy1 = null;
  this.Lframework_data_FrameworkDate$__f_schemabitmap$1 = false;
  $n_Lframework_data_FrameworkDate$ = this;
  this.Lframework_data_FrameworkDate$__f_utc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_time_ZoneId$().of__T__Ljava_time_ZoneId("UTC");
  this.Lframework_data_FrameworkDate$__f_formatter = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_time_format_DateTimeFormatter$().ofPattern__T__Ljava_time_format_DateTimeFormatter("yyyy-MM-dd");
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_time_LocalDate$().MIN__Ljava_time_LocalDate();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_time_LocalDate$().MAX__Ljava_time_LocalDate();
}
export { $c_Lframework_data_FrameworkDate$ as $c_Lframework_data_FrameworkDate$ };
$c_Lframework_data_FrameworkDate$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_FrameworkDate$.prototype.constructor = $c_Lframework_data_FrameworkDate$;
/** @constructor */
function $h_Lframework_data_FrameworkDate$() {
}
export { $h_Lframework_data_FrameworkDate$ as $h_Lframework_data_FrameworkDate$ };
$h_Lframework_data_FrameworkDate$.prototype = $c_Lframework_data_FrameworkDate$.prototype;
$c_Lframework_data_FrameworkDate$.prototype.nowUTC__Ljava_time_LocalDate = (function() {
  var zone = this.Lframework_data_FrameworkDate$__f_utc;
  var ld = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_time_LocalDate$().now__Ljava_time_ZoneId__Ljava_time_LocalDate(zone);
  return ld;
});
$c_Lframework_data_FrameworkDate$.prototype.fromString__T__s_util_Either = (function(str) {
  try {
    var ld = this.Lframework_data_FrameworkDate$__f_formatter.parse__jl_CharSequence__Ljava_time_temporal_TemporalQuery__O(str, new $c_Lframework_data_FrameworkDate$$anon$1());
    var r1 = new $c_Lframework_data_FrameworkDate(ld);
    var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(r1);
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
    matchEnd8: {
      var $x_1;
      if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(e$2);
        break matchEnd8;
      }
      throw ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  }
  var eab = $x_1.toEither__s_util_Either();
  if ((eab instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
    var a = eab.s_util_Left__f_value;
    var tc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString;
    var this$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$ToShowOps$$anon$3(str, tc);
    var $x_2 = this$7.Lcats_Show$ToShowOps$$anon$3__f_typeClassInstance.show__O__T(this$7.Lcats_Show$ToShowOps$$anon$3__f_self);
    var target = a.getMessage__T();
    var tc$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString;
    var this$11 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$ToShowOps$$anon$3(target, tc$1);
    var value = ((("Invalid date string \"" + $x_2) + "\": ") + this$11.Lcats_Show$ToShowOps$$anon$3__f_typeClassInstance.show__O__T(this$11.Lcats_Show$ToShowOps$$anon$3__f_self));
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value);
  }
  if ((eab instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_syntax_EitherUtil$();
    return eab;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(eab);
});
$c_Lframework_data_FrameworkDate$.prototype.circeCodec__Lio_circe_Codec = (function() {
  if ((!this.Lframework_data_FrameworkDate$__f_circeCodecbitmap$1)) {
    var dec = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$().Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$__f_intC3C;
    var enc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$().Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$__f_intC3C;
    var target = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lio_circe_Codec$$anon$4(dec, enc);
    var tc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_Codec$().Lio_circe_Codec$__f_codecInvariant;
    var this$11 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Invariant$ToInvariantOps$$anon$19(target, tc);
    var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((v1) => {
      var date = (v1 | 0);
      $m_Lframework_data_FrameworkDate$();
      var year = ((date / 10000) | 0);
      var month = ((((date / 100) | 0) % 100) | 0);
      var month$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_time_Month$().of__I__Ljava_time_Month(month);
      var dayOfMonth = ((date % 100) | 0);
      var ld = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_time_LocalDate$().of__I__Ljava_time_Month__I__Ljava_time_LocalDate(year, month$1, dayOfMonth);
      return new $c_Lframework_data_FrameworkDate(ld);
    }));
    var g = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((v) => {
      var v$1 = ((v === null) ? null : v.Lframework_data_FrameworkDate__f_ld);
      var _1 = v$1.Ljava_time_LocalDate__f_year;
      var _2 = v$1.Ljava_time_LocalDate__f_month;
      var _3 = v$1.Ljava_time_LocalDate__f_day;
      return ((((Math.imul(10000, _1) + Math.imul(100, _2)) | 0) + _3) | 0);
    }));
    this.Lframework_data_FrameworkDate$__f_circeCodec$lzy1 = this$11.Lcats_Invariant$ToInvariantOps$$anon$19__f_typeClassInstance.imap__O__F1__F1__O(this$11.Lcats_Invariant$ToInvariantOps$$anon$19__f_self, f, g);
    this.Lframework_data_FrameworkDate$__f_circeCodecbitmap$1 = true;
  }
  return this.Lframework_data_FrameworkDate$__f_circeCodec$lzy1;
});
$c_Lframework_data_FrameworkDate$.prototype.schema__Lsttp_tapir_Schema = (function() {
  if ((!this.Lframework_data_FrameworkDate$__f_schemabitmap$1)) {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var schemaType = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_SchemaType$SInteger();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var name = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var isOptional = false;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var description = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var default$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var format = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var encodedExample = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var deprecated = false;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var hidden = false;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var validator = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var attributes = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
    this.Lframework_data_FrameworkDate$__f_schema$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema(schemaType, name, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes).description__T__Lsttp_tapir_Schema("A date in YYYYmmdd format").encodedExample__O__Lsttp_tapir_Schema("20241231");
    this.Lframework_data_FrameworkDate$__f_schemabitmap$1 = true;
  }
  return this.Lframework_data_FrameworkDate$__f_schema$lzy1;
});
$c_Lframework_data_FrameworkDate$.prototype.equals$extension__Ljava_time_LocalDate__O__Z = (function(this$, x$0) {
  if ((x$0 instanceof $c_Lframework_data_FrameworkDate)) {
    var x2 = ((x$0 === null) ? null : x$0.Lframework_data_FrameworkDate__f_ld);
    return ((this$ === null) ? (x2 === null) : this$.equals__O__Z(x2));
  } else {
    return false;
  }
});
$c_Lframework_data_FrameworkDate$.prototype.toString$extension__Ljava_time_LocalDate__T = (function(this$) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(new $c_Lframework_data_FrameworkDate(this$));
});
$c_Lframework_data_FrameworkDate$.prototype.productElement$extension__Ljava_time_LocalDate__I__O = (function(this$, n) {
  if ((n === 0)) {
    return this$;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_FrameworkDate$.prototype.productElementName$extension__Ljava_time_LocalDate__I__T = (function(this$, n) {
  if ((n === 0)) {
    return "ld";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_FrameworkDate$.prototype.asString$extension__Ljava_time_LocalDate__T = (function(this$) {
  var formatter = $m_Lframework_data_FrameworkDate$().Lframework_data_FrameworkDate$__f_formatter;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Ljava_time_chrono_ChronoLocalDate__format__Ljava_time_format_DateTimeFormatter__T(this$, formatter);
});
var $d_Lframework_data_FrameworkDate$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_FrameworkDate$, "framework.data.FrameworkDate$", ({
  Lframework_data_FrameworkDate$: 1
}));
export { $d_Lframework_data_FrameworkDate$ as $d_Lframework_data_FrameworkDate$ };
var $n_Lframework_data_FrameworkDate$;
function $m_Lframework_data_FrameworkDate$() {
  if ((!$n_Lframework_data_FrameworkDate$)) {
    $n_Lframework_data_FrameworkDate$ = new $c_Lframework_data_FrameworkDate$();
  }
  return $n_Lframework_data_FrameworkDate$;
}
export { $m_Lframework_data_FrameworkDate$ as $m_Lframework_data_FrameworkDate$ };
/** @constructor */
function $c_Lframework_data_IndicatorStates$() {
}
export { $c_Lframework_data_IndicatorStates$ as $c_Lframework_data_IndicatorStates$ };
$c_Lframework_data_IndicatorStates$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_IndicatorStates$.prototype.constructor = $c_Lframework_data_IndicatorStates$;
/** @constructor */
function $h_Lframework_data_IndicatorStates$() {
}
export { $h_Lframework_data_IndicatorStates$ as $h_Lframework_data_IndicatorStates$ };
$h_Lframework_data_IndicatorStates$.prototype = $c_Lframework_data_IndicatorStates$.prototype;
$c_Lframework_data_IndicatorStates$.prototype.matches__F1__O__Z = (function(matcher, page) {
  if ($is_sci_Set(matcher)) {
    return matcher.contains__O__Z(page);
  }
  if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$is_s_PartialFunction(matcher)) {
    return matcher.isDefinedAt__O__Z(page);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(matcher);
});
var $d_Lframework_data_IndicatorStates$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_IndicatorStates$, "framework.data.IndicatorStates$", ({
  Lframework_data_IndicatorStates$: 1
}));
export { $d_Lframework_data_IndicatorStates$ as $d_Lframework_data_IndicatorStates$ };
var $n_Lframework_data_IndicatorStates$;
function $m_Lframework_data_IndicatorStates$() {
  if ((!$n_Lframework_data_IndicatorStates$)) {
    $n_Lframework_data_IndicatorStates$ = new $c_Lframework_data_IndicatorStates$();
  }
  return $n_Lframework_data_IndicatorStates$;
}
export { $m_Lframework_data_IndicatorStates$ as $m_Lframework_data_IndicatorStates$ };
/** @constructor */
function $c_Lframework_data_JWT$package$JWT$() {
}
export { $c_Lframework_data_JWT$package$JWT$ as $c_Lframework_data_JWT$package$JWT$ };
$c_Lframework_data_JWT$package$JWT$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_JWT$package$JWT$.prototype.constructor = $c_Lframework_data_JWT$package$JWT$;
/** @constructor */
function $h_Lframework_data_JWT$package$JWT$() {
}
export { $h_Lframework_data_JWT$package$JWT$ as $h_Lframework_data_JWT$package$JWT$ };
$h_Lframework_data_JWT$package$JWT$.prototype = $c_Lframework_data_JWT$package$JWT$.prototype;
$c_Lframework_data_JWT$package$JWT$.prototype.apply__T__s_util_Either = (function(input) {
  var i = 0;
  var res = 0;
  var len = input.length;
  while ((i < len)) {
    var index = i;
    var x0 = input.charCodeAt(index);
    if ((x0 === 46)) {
      res = ((1 + res) | 0);
    }
    i = ((1 + i) | 0);
  }
  if ((res !== 2)) {
    var value = ("Invalid JWT, expected to have 3 parts separated by '.': " + input);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value);
  } else {
    _return: {
      var i$1 = 0;
      var len$1 = input.length;
      while ((i$1 < len$1)) {
        var index$1 = i$1;
        var x0$1 = input.charCodeAt(index$1);
        var this$8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$();
        if ((!(((this$8.isLetterOrDigit__I__Z(x0$1) || (x0$1 === 45)) || (x0$1 === 95)) || (x0$1 === 46)))) {
          var $x_1 = false;
          break _return;
        }
        i$1 = ((1 + i$1) | 0);
      }
      var $x_1 = true;
    }
    if ((!$x_1)) {
      var value$1 = ("Invalid JWT, expected base64url: " + input);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value$1);
    } else {
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(input);
    }
  }
});
var $d_Lframework_data_JWT$package$JWT$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_JWT$package$JWT$, "framework.data.JWT$package$JWT$", ({
  Lframework_data_JWT$package$JWT$: 1
}));
export { $d_Lframework_data_JWT$package$JWT$ as $d_Lframework_data_JWT$package$JWT$ };
var $n_Lframework_data_JWT$package$JWT$;
function $m_Lframework_data_JWT$package$JWT$() {
  if ((!$n_Lframework_data_JWT$package$JWT$)) {
    $n_Lframework_data_JWT$package$JWT$ = new $c_Lframework_data_JWT$package$JWT$();
  }
  return $n_Lframework_data_JWT$package$JWT$;
}
export { $m_Lframework_data_JWT$package$JWT$ as $m_Lframework_data_JWT$package$JWT$ };
/** @constructor */
function $c_Lframework_exts_AOrNullExts$package$() {
}
export { $c_Lframework_exts_AOrNullExts$package$ as $c_Lframework_exts_AOrNullExts$package$ };
$c_Lframework_exts_AOrNullExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_AOrNullExts$package$.prototype.constructor = $c_Lframework_exts_AOrNullExts$package$;
/** @constructor */
function $h_Lframework_exts_AOrNullExts$package$() {
}
export { $h_Lframework_exts_AOrNullExts$package$ as $h_Lframework_exts_AOrNullExts$package$ };
$h_Lframework_exts_AOrNullExts$package$.prototype = $c_Lframework_exts_AOrNullExts$package$.prototype;
$c_Lframework_exts_AOrNullExts$package$.prototype.jsValueOrNullToOption__O__s_Option = (function(a) {
  return ((a === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$() : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(a));
});
var $d_Lframework_exts_AOrNullExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_AOrNullExts$package$, "framework.exts.AOrNullExts$package$", ({
  Lframework_exts_AOrNullExts$package$: 1
}));
export { $d_Lframework_exts_AOrNullExts$package$ as $d_Lframework_exts_AOrNullExts$package$ };
var $n_Lframework_exts_AOrNullExts$package$;
function $m_Lframework_exts_AOrNullExts$package$() {
  if ((!$n_Lframework_exts_AOrNullExts$package$)) {
    $n_Lframework_exts_AOrNullExts$package$ = new $c_Lframework_exts_AOrNullExts$package$();
  }
  return $n_Lframework_exts_AOrNullExts$package$;
}
export { $m_Lframework_exts_AOrNullExts$package$ as $m_Lframework_exts_AOrNullExts$package$ };
/** @constructor */
function $c_Lframework_exts_AirstreamErrorExts$package$() {
}
export { $c_Lframework_exts_AirstreamErrorExts$package$ as $c_Lframework_exts_AirstreamErrorExts$package$ };
$c_Lframework_exts_AirstreamErrorExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_AirstreamErrorExts$package$.prototype.constructor = $c_Lframework_exts_AirstreamErrorExts$package$;
/** @constructor */
function $h_Lframework_exts_AirstreamErrorExts$package$() {
}
export { $h_Lframework_exts_AirstreamErrorExts$package$ as $h_Lframework_exts_AirstreamErrorExts$package$ };
$h_Lframework_exts_AirstreamErrorExts$package$.prototype = $c_Lframework_exts_AirstreamErrorExts$package$.prototype;
$c_Lframework_exts_AirstreamErrorExts$package$.prototype.registerUnhandledErrorCallbackSafe__Lcom_raquo_airstream_core_AirstreamError$__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription = (function(obj, callback, owner) {
  obj.registerUnhandledErrorCallback__F1__V(callback);
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_ownership_Subscription(owner, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
    obj.unregisterUnhandledErrorCallback__F1__V(callback);
  })));
});
var $d_Lframework_exts_AirstreamErrorExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_AirstreamErrorExts$package$, "framework.exts.AirstreamErrorExts$package$", ({
  Lframework_exts_AirstreamErrorExts$package$: 1
}));
export { $d_Lframework_exts_AirstreamErrorExts$package$ as $d_Lframework_exts_AirstreamErrorExts$package$ };
var $n_Lframework_exts_AirstreamErrorExts$package$;
function $m_Lframework_exts_AirstreamErrorExts$package$() {
  if ((!$n_Lframework_exts_AirstreamErrorExts$package$)) {
    $n_Lframework_exts_AirstreamErrorExts$package$ = new $c_Lframework_exts_AirstreamErrorExts$package$();
  }
  return $n_Lframework_exts_AirstreamErrorExts$package$;
}
export { $m_Lframework_exts_AirstreamErrorExts$package$ as $m_Lframework_exts_AirstreamErrorExts$package$ };
/** @constructor */
function $c_Lframework_exts_AnyExts$package$() {
}
export { $c_Lframework_exts_AnyExts$package$ as $c_Lframework_exts_AnyExts$package$ };
$c_Lframework_exts_AnyExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_AnyExts$package$.prototype.constructor = $c_Lframework_exts_AnyExts$package$;
/** @constructor */
function $h_Lframework_exts_AnyExts$package$() {
}
export { $h_Lframework_exts_AnyExts$package$ as $h_Lframework_exts_AnyExts$package$ };
$h_Lframework_exts_AnyExts$package$.prototype = $c_Lframework_exts_AnyExts$package$.prototype;
$c_Lframework_exts_AnyExts$package$.prototype.headOrEmpty__O__Lframework_utils_MaybeGetHead__Lalleycats_Empty__O = (function(a, x$2, x$3) {
  if (a.hasNext__Z()) {
    var value = a.next__O();
    var opt$proxy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
  } else {
    var opt$proxy1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
  var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  if ((x === opt$proxy1)) {
    return x$3.empty__O();
  }
  if ((opt$proxy1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
    var value$1 = opt$proxy1.s_Some__f_value;
    return value$1;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(opt$proxy1);
});
var $d_Lframework_exts_AnyExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_AnyExts$package$, "framework.exts.AnyExts$package$", ({
  Lframework_exts_AnyExts$package$: 1
}));
export { $d_Lframework_exts_AnyExts$package$ as $d_Lframework_exts_AnyExts$package$ };
var $n_Lframework_exts_AnyExts$package$;
function $m_Lframework_exts_AnyExts$package$() {
  if ((!$n_Lframework_exts_AnyExts$package$)) {
    $n_Lframework_exts_AnyExts$package$ = new $c_Lframework_exts_AnyExts$package$();
  }
  return $n_Lframework_exts_AnyExts$package$;
}
export { $m_Lframework_exts_AnyExts$package$ as $m_Lframework_exts_AnyExts$package$ };
/** @constructor */
function $c_Lframework_exts_AsyncExts$package$() {
}
export { $c_Lframework_exts_AsyncExts$package$ as $c_Lframework_exts_AsyncExts$package$ };
$c_Lframework_exts_AsyncExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_AsyncExts$package$.prototype.constructor = $c_Lframework_exts_AsyncExts$package$;
/** @constructor */
function $h_Lframework_exts_AsyncExts$package$() {
}
export { $h_Lframework_exts_AsyncExts$package$ as $h_Lframework_exts_AsyncExts$package$ };
$h_Lframework_exts_AsyncExts$package$.prototype = $c_Lframework_exts_AsyncExts$package$.prototype;
$c_Lframework_exts_AsyncExts$package$.prototype.takeAtLeast__O__s_concurrent_duration_FiniteDuration__Lcats_effect_kernel_Async__Lcats_NonEmptyParallel__O = (function(fa, duration, evidence$1, x$3) {
  var _1 = $f_Lcats_effect_kernel_GenTemporal__sleep__s_concurrent_duration_Duration__O(evidence$1, duration);
  var _2 = new $c_Lcats_effect_IO$Attempt(fa);
  var t = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, _2);
  var fea = new $c_Lcats_syntax_Tuple2ParallelOps(t).parMapN__F2__Lcats_NonEmptyParallel__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((_$2, a) => a)), x$3);
  return $m_Lcats_syntax_MonadErrorRethrowOps$().rethrow$extension__O__Lcats_MonadError__O(fea, evidence$1);
});
var $d_Lframework_exts_AsyncExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_AsyncExts$package$, "framework.exts.AsyncExts$package$", ({
  Lframework_exts_AsyncExts$package$: 1
}));
export { $d_Lframework_exts_AsyncExts$package$ as $d_Lframework_exts_AsyncExts$package$ };
var $n_Lframework_exts_AsyncExts$package$;
function $m_Lframework_exts_AsyncExts$package$() {
  if ((!$n_Lframework_exts_AsyncExts$package$)) {
    $n_Lframework_exts_AsyncExts$package$ = new $c_Lframework_exts_AsyncExts$package$();
  }
  return $n_Lframework_exts_AsyncExts$package$;
}
export { $m_Lframework_exts_AsyncExts$package$ as $m_Lframework_exts_AsyncExts$package$ };
/** @constructor */
function $c_Lframework_exts_CacheStorageExts$package$() {
}
export { $c_Lframework_exts_CacheStorageExts$package$ as $c_Lframework_exts_CacheStorageExts$package$ };
$c_Lframework_exts_CacheStorageExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_CacheStorageExts$package$.prototype.constructor = $c_Lframework_exts_CacheStorageExts$package$;
/** @constructor */
function $h_Lframework_exts_CacheStorageExts$package$() {
}
export { $h_Lframework_exts_CacheStorageExts$package$ as $h_Lframework_exts_CacheStorageExts$package$ };
$h_Lframework_exts_CacheStorageExts$package$.prototype = $c_Lframework_exts_CacheStorageExts$package$.prototype;
$c_Lframework_exts_CacheStorageExts$package$.prototype.deleteAll__Lorg_scalajs_dom_CacheStorage__F1__Lframework_utils_JSLogger__s_concurrent_Future = (function(storage, predicate, log) {
  var p = storage.keys();
  return $m_sjs_js_Thenable$ThenableOps$().toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$2) => {
    var this$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_sjs_js_WrappedArray__sjs_js_Array__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_WrappedArray(), _$2);
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$3);
  })), $m_Lframework_prelude_prelude\uff3fclient$package$().executionContext__s_concurrent_ExecutionContext()).flatMap__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((cacheKeys) => {
    var clearedCaches = cacheKeys.filterImpl__F1__Z__sci_Vector(predicate, false);
    var msg$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([((("Clearing caches: " + clearedCaches) + ", all available caches: ") + cacheKeys)]));
    var file = new $c_Lsourcecode_File("/home/arturaz/work/rapix/framework/client/src/framework/exts/CacheStorageExts.scala");
    var line = new $c_Lsourcecode_Line(13);
    var name = new $c_Lsourcecode_FullName("framework.exts.CacheStorageExts$package.$1");
    var definedAt = new $c_Lframework_sourcecode_DefinedAt(file, line, name);
    var this$5 = $m_Lframework_prelude_client\uff3flogging$package$JSAppName$();
    var appName = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Newtype$WithoutValidation__apply__O__O(this$5, "app");
    var level = $s_Lframework_utils_LogLevel$__Debug__Lframework_utils_LogLevel();
    log.atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V(level, log.scope__s_Option(), msg$1, definedAt, appName);
    var $x_2 = $m_s_concurrent_Future$();
    var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((cache) => {
      var msg$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([("Clearing cache: " + cache)]));
      var file$1 = new $c_Lsourcecode_File("/home/arturaz/work/rapix/framework/client/src/framework/exts/CacheStorageExts.scala");
      var line$1 = new $c_Lsourcecode_Line(15);
      var name$1 = new $c_Lsourcecode_FullName("framework.exts.CacheStorageExts$package.deleteAll");
      var definedAt$1 = new $c_Lframework_sourcecode_DefinedAt(file$1, line$1, name$1);
      var this$7 = $m_Lframework_prelude_client\uff3flogging$package$JSAppName$();
      var appName$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Newtype$WithoutValidation__apply__O__O(this$7, "app");
      var level$1 = $s_Lframework_utils_LogLevel$__Debug__Lframework_utils_LogLevel();
      log.atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V(level$1, log.scope__s_Option(), msg$2, definedAt$1, appName$1);
      var p$1 = storage.delete(cache);
      return $m_sjs_js_Thenable$ThenableOps$().toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p$1);
    }));
    var this$9 = $m_sc_BuildFrom$();
    return $x_2.traverse__sc_IterableOnce__F1__sc_BuildFrom__s_concurrent_ExecutionContext__s_concurrent_Future(clearedCaches, $x_1, new $c_sc_BuildFromLowPriority2$$anon$11(this$9), $m_Lframework_prelude_prelude\uff3fclient$package$().executionContext__s_concurrent_ExecutionContext()).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1) => (void 0))), $m_Lframework_prelude_prelude\uff3fclient$package$().executionContext__s_concurrent_ExecutionContext());
  })), $m_Lframework_prelude_prelude\uff3fclient$package$().executionContext__s_concurrent_ExecutionContext());
});
$c_Lframework_exts_CacheStorageExts$package$.prototype.deleteAll$default$2__Lorg_scalajs_dom_CacheStorage__F1 = (function(storage) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$1) => true));
});
var $d_Lframework_exts_CacheStorageExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_CacheStorageExts$package$, "framework.exts.CacheStorageExts$package$", ({
  Lframework_exts_CacheStorageExts$package$: 1
}));
export { $d_Lframework_exts_CacheStorageExts$package$ as $d_Lframework_exts_CacheStorageExts$package$ };
var $n_Lframework_exts_CacheStorageExts$package$;
function $m_Lframework_exts_CacheStorageExts$package$() {
  if ((!$n_Lframework_exts_CacheStorageExts$package$)) {
    $n_Lframework_exts_CacheStorageExts$package$ = new $c_Lframework_exts_CacheStorageExts$package$();
  }
  return $n_Lframework_exts_CacheStorageExts$package$;
}
export { $m_Lframework_exts_CacheStorageExts$package$ as $m_Lframework_exts_CacheStorageExts$package$ };
/** @constructor */
function $c_Lframework_exts_CirceDecoderExts$package$() {
}
export { $c_Lframework_exts_CirceDecoderExts$package$ as $c_Lframework_exts_CirceDecoderExts$package$ };
$c_Lframework_exts_CirceDecoderExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_CirceDecoderExts$package$.prototype.constructor = $c_Lframework_exts_CirceDecoderExts$package$;
/** @constructor */
function $h_Lframework_exts_CirceDecoderExts$package$() {
}
export { $h_Lframework_exts_CirceDecoderExts$package$ as $h_Lframework_exts_CirceDecoderExts$package$ };
$h_Lframework_exts_CirceDecoderExts$package$.prototype = $c_Lframework_exts_CirceDecoderExts$package$.prototype;
$c_Lframework_exts_CirceDecoderExts$package$.prototype.parseAndDecode__Lio_circe_Decoder__T__s_util_Either = (function(decoder, str) {
  var this$1 = $m_Lio_circe_parser_package$().parse__T__s_util_Either(str);
  if ((this$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
    var b = this$1.s_util_Right__f_value;
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lio_circe_Decoder__decodeJson__Lio_circe_Json__s_util_Either(decoder, b);
  } else {
    return this$1;
  }
});
var $d_Lframework_exts_CirceDecoderExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_CirceDecoderExts$package$, "framework.exts.CirceDecoderExts$package$", ({
  Lframework_exts_CirceDecoderExts$package$: 1
}));
export { $d_Lframework_exts_CirceDecoderExts$package$ as $d_Lframework_exts_CirceDecoderExts$package$ };
var $n_Lframework_exts_CirceDecoderExts$package$;
function $m_Lframework_exts_CirceDecoderExts$package$() {
  if ((!$n_Lframework_exts_CirceDecoderExts$package$)) {
    $n_Lframework_exts_CirceDecoderExts$package$ = new $c_Lframework_exts_CirceDecoderExts$package$();
  }
  return $n_Lframework_exts_CirceDecoderExts$package$;
}
export { $m_Lframework_exts_CirceDecoderExts$package$ as $m_Lframework_exts_CirceDecoderExts$package$ };
/** @constructor */
function $c_Lframework_exts_ClientAExts$package$() {
}
export { $c_Lframework_exts_ClientAExts$package$ as $c_Lframework_exts_ClientAExts$package$ };
$c_Lframework_exts_ClientAExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_ClientAExts$package$.prototype.constructor = $c_Lframework_exts_ClientAExts$package$;
/** @constructor */
function $h_Lframework_exts_ClientAExts$package$() {
}
export { $h_Lframework_exts_ClientAExts$package$ as $h_Lframework_exts_ClientAExts$package$ };
$h_Lframework_exts_ClientAExts$package$.prototype = $c_Lframework_exts_ClientAExts$package$.prototype;
$c_Lframework_exts_ClientAExts$package$.prototype.setAsCookie__O__Lsttp_tapir_Codec__Lframework_data_CookieNameFor__s_util_Either = (function(a, codec, name) {
  var encoded = codec.encode__O__O(a);
  var onHttps = (window.location.protocol === "https:");
  var secureFlag = (onHttps ? "; Secure" : "");
  var $x_2 = document;
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
  var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["", "=", "; Path=/; SameSite=Strict; ", ""]));
  var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
  $x_2.cookie = $x_1.show$extension__s_StringContext__sci_Seq__T(sc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(name, $m_Lframework_data_CookieNameFor$().given_Show_CookieNameFor__Lcats_Show())), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(encoded, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString)), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(secureFlag, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))])));
  var x1 = $m_Lframework_exts_HTMLDocumentExts$package$().cookieMap__Lorg_scalajs_dom_HTMLDocument__sci_Map(document).get__O__s_Option(name.Lframework_data_CookieNameFor__f_name);
  var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  if ((x === x1)) {
    var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
    var parts$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["Failed to set cookie: ", ""]));
    var sc$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts$1);
    var value = $x_3.show$extension__s_StringContext__sci_Seq__T(sc$1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(name, $m_Lframework_data_CookieNameFor$().given_Show_CookieNameFor__Lcats_Show()))])));
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value);
  }
  if ((x1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
    var x5 = x1.s_Some__f_value;
    if ((encoded === x5)) {
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right((void 0));
    }
    var $x_4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
    var parts$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["Failed to set cookie: ", ", got '", "', expected '", "'"]));
    var sc$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts$2);
    var value$1 = $x_4.show$extension__s_StringContext__sci_Seq__T(sc$2, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(name, $m_Lframework_data_CookieNameFor$().given_Show_CookieNameFor__Lcats_Show())), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(x5, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString)), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(encoded, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))])));
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value$1);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1);
});
var $d_Lframework_exts_ClientAExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_ClientAExts$package$, "framework.exts.ClientAExts$package$", ({
  Lframework_exts_ClientAExts$package$: 1
}));
export { $d_Lframework_exts_ClientAExts$package$ as $d_Lframework_exts_ClientAExts$package$ };
var $n_Lframework_exts_ClientAExts$package$;
function $m_Lframework_exts_ClientAExts$package$() {
  if ((!$n_Lframework_exts_ClientAExts$package$)) {
    $n_Lframework_exts_ClientAExts$package$ = new $c_Lframework_exts_ClientAExts$package$();
  }
  return $n_Lframework_exts_ClientAExts$package$;
}
export { $m_Lframework_exts_ClientAExts$package$ as $m_Lframework_exts_ClientAExts$package$ };
function $ps_Lframework_exts_ClientEndpointExts$package$__createEventSource$1__Lorg_scalajs_dom_EventSourceInit__Lframework_sourcecode_DefinedAt__Lsttp_model_Uri__Lorg_scalajs_dom_EventSource(options$1, definedAt$1, uri) {
  var uriStr = uri.toStringSafe__sci_Set__T($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Set$EmptySet$());
  var msg$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([(("Creating SSE stream for " + uri) + ", options="), options$1]));
  var this$4 = $m_Lframework_prelude_log$();
  var this$3 = $m_Lframework_prelude_client\uff3flogging$package$JSAppName$();
  var appName = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Newtype$WithoutValidation__apply__O__O(this$3, "app");
  var level = $s_Lframework_utils_LogLevel$__Debug__Lframework_utils_LogLevel();
  var scope = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $f_Lframework_utils_JSLogger$DefaultJavascriptLogging__atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V(this$4, level, scope, msg$1, definedAt$1, appName);
  return new EventSource(uriStr, options$1);
}
export { $ps_Lframework_exts_ClientEndpointExts$package$__createEventSource$1__Lorg_scalajs_dom_EventSourceInit__Lframework_sourcecode_DefinedAt__Lsttp_model_Uri__Lorg_scalajs_dom_EventSource as $ps_Lframework_exts_ClientEndpointExts$package$__createEventSource$1__Lorg_scalajs_dom_EventSourceInit__Lframework_sourcecode_DefinedAt__Lsttp_model_Uri__Lorg_scalajs_dom_EventSource };
function $ps_Lframework_exts_ClientEndpointExts$package$__createWebSocket$1__Lframework_sourcecode_DefinedAt__Lsttp_model_Uri__Lorg_scalajs_dom_WebSocket(definedAt$4, uri) {
  var uriStr = uri.toStringSafe__sci_Set__T($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Set$EmptySet$());
  var msg$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([("Creating WS stream for " + uri)]));
  var this$4 = $m_Lframework_prelude_log$();
  var this$3 = $m_Lframework_prelude_client\uff3flogging$package$JSAppName$();
  var appName = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Newtype$WithoutValidation__apply__O__O(this$3, "app");
  var level = $s_Lframework_utils_LogLevel$__Debug__Lframework_utils_LogLevel();
  var scope = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $f_Lframework_utils_JSLogger$DefaultJavascriptLogging__atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V(this$4, level, scope, msg$2, definedAt$4, appName);
  return new WebSocket(uriStr);
}
export { $ps_Lframework_exts_ClientEndpointExts$package$__createWebSocket$1__Lframework_sourcecode_DefinedAt__Lsttp_model_Uri__Lorg_scalajs_dom_WebSocket as $ps_Lframework_exts_ClientEndpointExts$package$__createWebSocket$1__Lframework_sourcecode_DefinedAt__Lsttp_model_Uri__Lorg_scalajs_dom_WebSocket };
/** @constructor */
function $c_Lframework_exts_ClientEndpointExts$package$() {
}
export { $c_Lframework_exts_ClientEndpointExts$package$ as $c_Lframework_exts_ClientEndpointExts$package$ };
$c_Lframework_exts_ClientEndpointExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_ClientEndpointExts$package$.prototype.constructor = $c_Lframework_exts_ClientEndpointExts$package$;
/** @constructor */
function $h_Lframework_exts_ClientEndpointExts$package$() {
}
export { $h_Lframework_exts_ClientEndpointExts$package$ as $h_Lframework_exts_ClientEndpointExts$package$ };
$h_Lframework_exts_ClientEndpointExts$package$.prototype = $c_Lframework_exts_ClientEndpointExts$package$.prototype;
$c_Lframework_exts_ClientEndpointExts$package$.prototype.toReq__Lsttp_tapir_Endpoint__O__Ljava_time_LocalDateTime__Lframework_data_AppBaseUri__Lsttp_client3_RequestT = (function(e, params, now, baseUri) {
  var $x_1 = $m_Lframework_exts_RequestExts$package$();
  var this$3 = $m_Lframework_prelude_prelude\uff3fclient$package$().sttpClientInterpreter__Lsttp_tapir_client_sttp_SttpClientInterpreter();
  var value = baseUri.Lframework_data_AppBaseUri$$anon$3__f_uri;
  var baseUri$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
  var wsToPipe = new $c_Lsttp_tapir_client_sttp_WebSocketToPipe$$anon$1();
  return $x_1.withClientRequestTracing__Lsttp_client3_RequestT__Ljava_time_LocalDateTime__Lsttp_client3_RequestT($f_Lsttp_tapir_client_sttp_SttpClientInterpreter__toRequest__Lsttp_tapir_Endpoint__s_Option__Lsttp_tapir_client_sttp_WebSocketToPipe__F1(this$3, e, baseUri$1, wsToPipe).apply__O__O(params), now).mapResponse__F1__Lsttp_client3_RequestT(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1) => {
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$is_Lsttp_tapir_DecodeResult$Failure(x$1)) {
      var error = new $c_Lframework_utils_NetworkError$DecodeError(x$1);
      var value$1 = new $c_Lframework_utils_NetworkOrEndpointError$NetworkError(error);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value$1);
    }
    if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_DecodeResult$Value)) {
      var x18 = x$1.Lsttp_tapir_DecodeResult$Value__f_v;
      if ((x18 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
        var error$1 = x18.s_util_Left__f_value;
        var value$2 = new $c_Lframework_utils_NetworkOrEndpointError$EndpointError(error$1);
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value$2);
      }
    }
    if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_DecodeResult$Value)) {
      var x13 = x$1.Lsttp_tapir_DecodeResult$Value__f_v;
      if ((x13 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
        var output = x13.s_util_Right__f_value;
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(output);
      }
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  })));
});
$c_Lframework_exts_ClientEndpointExts$package$.prototype.toReq__Lsttp_tapir_Endpoint__O__O__Ljava_time_LocalDateTime__Lframework_data_AppBaseUri__Lsttp_client3_RequestT = (function(e, securityParams, params, now, baseUri) {
  var $x_1 = $m_Lframework_exts_RequestExts$package$();
  var this$3 = $m_Lframework_prelude_prelude\uff3fclient$package$().sttpClientInterpreter__Lsttp_tapir_client_sttp_SttpClientInterpreter();
  var value = baseUri.Lframework_data_AppBaseUri$$anon$3__f_uri;
  var baseUri$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
  var wsToPipe = new $c_Lsttp_tapir_client_sttp_WebSocketToPipe$$anon$1();
  return $x_1.withClientRequestTracing__Lsttp_client3_RequestT__Ljava_time_LocalDateTime__Lsttp_client3_RequestT($f_Lsttp_tapir_client_sttp_SttpClientInterpreter__toSecureRequest__Lsttp_tapir_Endpoint__s_Option__Lsttp_tapir_client_sttp_WebSocketToPipe__F1(this$3, e, baseUri$1, wsToPipe).apply__O__O(securityParams).apply__O__O(params), now).mapResponse__F1__Lsttp_client3_RequestT(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1) => {
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$is_Lsttp_tapir_DecodeResult$Failure(x$1)) {
      var error = new $c_Lframework_utils_NetworkError$DecodeError(x$1);
      var value$1 = new $c_Lframework_utils_NetworkOrEndpointError$NetworkError(error);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value$1);
    }
    if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_DecodeResult$Value)) {
      var x35 = x$1.Lsttp_tapir_DecodeResult$Value__f_v;
      if ((x35 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
        var error$1 = x35.s_util_Left__f_value;
        var value$2 = new $c_Lframework_utils_NetworkOrEndpointError$EndpointError(error$1);
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value$2);
      }
    }
    if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_DecodeResult$Value)) {
      var x30 = x$1.Lsttp_tapir_DecodeResult$Value__f_v;
      if ((x30 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
        var output = x30.s_util_Right__f_value;
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(output);
      }
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  })));
});
$c_Lframework_exts_ClientEndpointExts$package$.prototype.toReqNow__Lsttp_tapir_Endpoint__O__O__Lframework_data_AppBaseUri__Lcats_effect_SyncIO = (function(e, securityParams, params, x$4) {
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_data_FrameworkDateTime$().Lframework_data_FrameworkDateTime$__f_nowIO;
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$1) => {
    var _$1$1 = ((_$1 === null) ? null : _$1.Lframework_data_FrameworkDateTime__f_ldt);
    return $m_Lframework_exts_ClientEndpointExts$package$().toReq__Lsttp_tapir_Endpoint__O__O__Ljava_time_LocalDateTime__Lframework_data_AppBaseUri__Lsttp_client3_RequestT(e, securityParams, params, _$1$1, x$4);
  }));
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_SyncIO$Map(this$1, f);
});
$c_Lframework_exts_ClientEndpointExts$package$.prototype.toSSEStream__Lframework_data_EndpointSSEWithWS__Lframework_data_EndpointSSEWithWS$ClientConnectionMode__Lframework_utils_SSEFallbackCallbacks__Lframework_api_FrameworkEndpoints$SseConnectionTryout__Lframework_utils_ToSSEStreamBuilder = (function(e, mode, callbacks, connectionTryout) {
  var x = $s_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__ServerSentEvents__Lframework_data_EndpointSSEWithWS$ClientConnectionMode();
  if (((x === null) ? (mode === null) : x.equals__O__Z(mode))) {
    var e$1 = e.Lframework_data_EndpointSSEWithWS__f_sse;
    return new $c_Lframework_exts_ClientEndpointExts$package$$anon$5(e$1);
  }
  var x$3 = $s_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__WebSocket__Lframework_data_EndpointSSEWithWS$ClientConnectionMode();
  if (((x$3 === null) ? (mode === null) : x$3.equals__O__Z(mode))) {
    var e$2 = e.Lframework_data_EndpointSSEWithWS__f_webSocketAsSSE;
    return new $c_Lframework_exts_ClientEndpointExts$package$$anon$6(e$2);
  }
  matchAlts1: {
    matchAlts2: {
      if ((mode instanceof $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback)) {
        var x53 = mode.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback__f_trySSEAgainAt;
        var x$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        if ((x$5 === x53)) {
          break matchAlts2;
        }
        if ((x53 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
          break matchAlts2;
        }
      }
      break matchAlts1;
    }
    var waitFor = $m_Lframework_utils_ToSSEStreamBuilder$().sseWithWebSocketFallback$default$4__F1();
    var minTimeWSProbeTakes = $m_Lframework_utils_ToSSEStreamBuilder$().sseWithWebSocketFallback$default$5__s_concurrent_duration_FiniteDuration();
    var probeTimeout = $m_Lframework_utils_ToSSEStreamBuilder$().sseWithWebSocketFallback$default$6__s_concurrent_duration_FiniteDuration();
    var value = $s_Lframework_utils_LogLevel$__Debug__Lframework_utils_LogLevel();
    var logLevel = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
    return new $c_Lframework_utils_ToSSEStreamBuilder$$anon$4(connectionTryout, minTimeWSProbeTakes, logLevel, e, probeTimeout, callbacks, waitFor, 3);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(mode);
});
var $d_Lframework_exts_ClientEndpointExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_ClientEndpointExts$package$, "framework.exts.ClientEndpointExts$package$", ({
  Lframework_exts_ClientEndpointExts$package$: 1
}));
export { $d_Lframework_exts_ClientEndpointExts$package$ as $d_Lframework_exts_ClientEndpointExts$package$ };
var $n_Lframework_exts_ClientEndpointExts$package$;
function $m_Lframework_exts_ClientEndpointExts$package$() {
  if ((!$n_Lframework_exts_ClientEndpointExts$package$)) {
    $n_Lframework_exts_ClientEndpointExts$package$ = new $c_Lframework_exts_ClientEndpointExts$package$();
  }
  return $n_Lframework_exts_ClientEndpointExts$package$;
}
export { $m_Lframework_exts_ClientEndpointExts$package$ as $m_Lframework_exts_ClientEndpointExts$package$ };
/** @constructor */
function $c_Lframework_exts_ClientFrameworkDateExts$package$() {
  this.Lframework_exts_ClientFrameworkDateExts$package$__f__nowUTCSignal$lzy1 = null;
  this.Lframework_exts_ClientFrameworkDateExts$package$__f__nowUTCSignalbitmap$1 = false;
}
export { $c_Lframework_exts_ClientFrameworkDateExts$package$ as $c_Lframework_exts_ClientFrameworkDateExts$package$ };
$c_Lframework_exts_ClientFrameworkDateExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_ClientFrameworkDateExts$package$.prototype.constructor = $c_Lframework_exts_ClientFrameworkDateExts$package$;
/** @constructor */
function $h_Lframework_exts_ClientFrameworkDateExts$package$() {
}
export { $h_Lframework_exts_ClientFrameworkDateExts$package$ as $h_Lframework_exts_ClientFrameworkDateExts$package$ };
$h_Lframework_exts_ClientFrameworkDateExts$package$.prototype = $c_Lframework_exts_ClientFrameworkDateExts$package$.prototype;
$c_Lframework_exts_ClientFrameworkDateExts$package$.prototype._nowUTCSignal__Lcom_raquo_airstream_core_Signal = (function() {
  if ((!this.Lframework_exts_ClientFrameworkDateExts$package$__f__nowUTCSignalbitmap$1)) {
    var $x_2 = $m_Lframework_exts_SignalCompanionExts$package$();
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_Signal$();
    var this$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_package$DurationInt(1);
    var unit = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
    var this$ = this$3.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$();
    var hi = (this$ >> 31);
    this.Lframework_exts_ClientFrameworkDateExts$package$__f__nowUTCSignal$lzy1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable($x_2.fromPolling__Lcom_raquo_airstream_core_Signal$__s_concurrent_duration_FiniteDuration__F0__Lcom_raquo_airstream_core_Signal($x_1, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_FiniteDuration(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(this$, hi), unit), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => new $c_Lframework_data_FrameworkDate($m_Lframework_data_FrameworkDate$().nowUTC__Ljava_time_LocalDate())))));
    this.Lframework_exts_ClientFrameworkDateExts$package$__f__nowUTCSignalbitmap$1 = true;
  }
  return this.Lframework_exts_ClientFrameworkDateExts$package$__f__nowUTCSignal$lzy1;
});
var $d_Lframework_exts_ClientFrameworkDateExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_ClientFrameworkDateExts$package$, "framework.exts.ClientFrameworkDateExts$package$", ({
  Lframework_exts_ClientFrameworkDateExts$package$: 1
}));
export { $d_Lframework_exts_ClientFrameworkDateExts$package$ as $d_Lframework_exts_ClientFrameworkDateExts$package$ };
var $n_Lframework_exts_ClientFrameworkDateExts$package$;
function $m_Lframework_exts_ClientFrameworkDateExts$package$() {
  if ((!$n_Lframework_exts_ClientFrameworkDateExts$package$)) {
    $n_Lframework_exts_ClientFrameworkDateExts$package$ = new $c_Lframework_exts_ClientFrameworkDateExts$package$();
  }
  return $n_Lframework_exts_ClientFrameworkDateExts$package$;
}
export { $m_Lframework_exts_ClientFrameworkDateExts$package$ as $m_Lframework_exts_ClientFrameworkDateExts$package$ };
/** @constructor */
function $c_Lframework_exts_ClientIteratorExts$package$() {
}
export { $c_Lframework_exts_ClientIteratorExts$package$ as $c_Lframework_exts_ClientIteratorExts$package$ };
$c_Lframework_exts_ClientIteratorExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_ClientIteratorExts$package$.prototype.constructor = $c_Lframework_exts_ClientIteratorExts$package$;
/** @constructor */
function $h_Lframework_exts_ClientIteratorExts$package$() {
}
export { $h_Lframework_exts_ClientIteratorExts$package$ as $h_Lframework_exts_ClientIteratorExts$package$ };
$h_Lframework_exts_ClientIteratorExts$package$.prototype = $c_Lframework_exts_ClientIteratorExts$package$.prototype;
$c_Lframework_exts_ClientIteratorExts$package$.prototype.toJsArray__sc_Iterator__sjs_js_Array = (function(iterator) {
  var arr = [];
  while (iterator.hasNext__Z()) {
    var x0 = iterator.next__O();
    (arr.push(x0) | 0);
  }
  return arr;
});
var $d_Lframework_exts_ClientIteratorExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_ClientIteratorExts$package$, "framework.exts.ClientIteratorExts$package$", ({
  Lframework_exts_ClientIteratorExts$package$: 1
}));
export { $d_Lframework_exts_ClientIteratorExts$package$ as $d_Lframework_exts_ClientIteratorExts$package$ };
var $n_Lframework_exts_ClientIteratorExts$package$;
function $m_Lframework_exts_ClientIteratorExts$package$() {
  if ((!$n_Lframework_exts_ClientIteratorExts$package$)) {
    $n_Lframework_exts_ClientIteratorExts$package$ = new $c_Lframework_exts_ClientIteratorExts$package$();
  }
  return $n_Lframework_exts_ClientIteratorExts$package$;
}
export { $m_Lframework_exts_ClientIteratorExts$package$ as $m_Lframework_exts_ClientIteratorExts$package$ };
/** @constructor */
function $c_Lframework_exts_DocumentExts$package$() {
}
export { $c_Lframework_exts_DocumentExts$package$ as $c_Lframework_exts_DocumentExts$package$ };
$c_Lframework_exts_DocumentExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_DocumentExts$package$.prototype.constructor = $c_Lframework_exts_DocumentExts$package$;
/** @constructor */
function $h_Lframework_exts_DocumentExts$package$() {
}
export { $h_Lframework_exts_DocumentExts$package$ as $h_Lframework_exts_DocumentExts$package$ };
$h_Lframework_exts_DocumentExts$package$.prototype = $c_Lframework_exts_DocumentExts$package$.prototype;
$c_Lframework_exts_DocumentExts$package$.prototype.getMetaContent__Lorg_scalajs_dom_Document__T__s_Option = (function(document, name) {
  var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Option$();
  var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
  var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["meta[name=\"", "\"]"]));
  var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
  var $x_1 = document.querySelector($x_2.show$extension__s_StringContext__sci_Seq__T(sc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(name, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))]))));
  var this$6 = $x_3.apply__O__s_Option($x_1);
  if (this$6.isEmpty__Z()) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0 = this$6.get__O();
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(x0.getAttribute("content"));
  }
});
var $d_Lframework_exts_DocumentExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_DocumentExts$package$, "framework.exts.DocumentExts$package$", ({
  Lframework_exts_DocumentExts$package$: 1
}));
export { $d_Lframework_exts_DocumentExts$package$ as $d_Lframework_exts_DocumentExts$package$ };
var $n_Lframework_exts_DocumentExts$package$;
function $m_Lframework_exts_DocumentExts$package$() {
  if ((!$n_Lframework_exts_DocumentExts$package$)) {
    $n_Lframework_exts_DocumentExts$package$ = new $c_Lframework_exts_DocumentExts$package$();
  }
  return $n_Lframework_exts_DocumentExts$package$;
}
export { $m_Lframework_exts_DocumentExts$package$ as $m_Lframework_exts_DocumentExts$package$ };
/** @constructor */
function $c_Lframework_exts_EmptyExts$package$() {
}
export { $c_Lframework_exts_EmptyExts$package$ as $c_Lframework_exts_EmptyExts$package$ };
$c_Lframework_exts_EmptyExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_EmptyExts$package$.prototype.constructor = $c_Lframework_exts_EmptyExts$package$;
/** @constructor */
function $h_Lframework_exts_EmptyExts$package$() {
}
export { $h_Lframework_exts_EmptyExts$package$ as $h_Lframework_exts_EmptyExts$package$ };
$h_Lframework_exts_EmptyExts$package$.prototype = $c_Lframework_exts_EmptyExts$package$.prototype;
$c_Lframework_exts_EmptyExts$package$.prototype.nonEmptyOption__O__Lalleycats_Empty__s_CanEqual__s_Option = (function(a, e, eq) {
  var y = e.empty__O();
  if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(a, y)) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(a);
  }
});
var $d_Lframework_exts_EmptyExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_EmptyExts$package$, "framework.exts.EmptyExts$package$", ({
  Lframework_exts_EmptyExts$package$: 1
}));
export { $d_Lframework_exts_EmptyExts$package$ as $d_Lframework_exts_EmptyExts$package$ };
var $n_Lframework_exts_EmptyExts$package$;
function $m_Lframework_exts_EmptyExts$package$() {
  if ((!$n_Lframework_exts_EmptyExts$package$)) {
    $n_Lframework_exts_EmptyExts$package$ = new $c_Lframework_exts_EmptyExts$package$();
  }
  return $n_Lframework_exts_EmptyExts$package$;
}
export { $m_Lframework_exts_EmptyExts$package$ as $m_Lframework_exts_EmptyExts$package$ };
/** @constructor */
function $c_Lframework_exts_EndpointExts$package$() {
}
export { $c_Lframework_exts_EndpointExts$package$ as $c_Lframework_exts_EndpointExts$package$ };
$c_Lframework_exts_EndpointExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_EndpointExts$package$.prototype.constructor = $c_Lframework_exts_EndpointExts$package$;
/** @constructor */
function $h_Lframework_exts_EndpointExts$package$() {
}
export { $h_Lframework_exts_EndpointExts$package$ as $h_Lframework_exts_EndpointExts$package$ };
$h_Lframework_exts_EndpointExts$package$.prototype = $c_Lframework_exts_EndpointExts$package$.prototype;
$c_Lframework_exts_EndpointExts$package$.prototype.securityViaCookie__Lsttp_tapir_Endpoint__Lframework_data_CookieNameFor__Lsttp_tapir_Codec__Lsttp_tapir_Endpoint = (function(e, name, codec) {
  var this$1 = $m_Lsttp_tapir_package$();
  var name$1 = name.Lframework_data_CookieNameFor__f_name;
  var evidence$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Codec$().optionHead__Lsttp_tapir_Codec__Lsttp_tapir_Codec(codec);
  var input = $f_Lsttp_tapir_Tapir__cookie__T__Lsttp_tapir_Codec__Lsttp_tapir_EndpointInput$Cookie(this$1, name$1, evidence$1);
  var input$1 = e.Lsttp_tapir_Endpoint__f_input;
  var errorOutput = e.Lsttp_tapir_Endpoint__f_errorOutput;
  var output = e.Lsttp_tapir_Endpoint__f_output;
  var info = e.Lsttp_tapir_Endpoint__f_info;
  return new $c_Lsttp_tapir_Endpoint(input, input$1, errorOutput, output, info);
});
$c_Lframework_exts_EndpointExts$package$.prototype.serverSentEvents__Lsttp_tapir_Endpoint__Lsttp_tapir_Codec__Lsttp_tapir_Endpoint = (function(e, codec) {
  var charset = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_nio_charset_UTF\uff3f8$();
  var bodyType = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_RawBodyType$StringBody(charset);
  var description = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var examples = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var attributes = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  var info = new $c_Lsttp_tapir_EndpointIO$Info(description, examples, false, attributes);
  var output = new $c_Lsttp_tapir_EndpointIO$Body(bodyType, codec, info);
  var securityInput = e.Lsttp_tapir_Endpoint__f_securityInput;
  var input = e.Lsttp_tapir_Endpoint__f_input;
  var errorOutput = e.Lsttp_tapir_Endpoint__f_errorOutput;
  var info$1 = e.Lsttp_tapir_Endpoint__f_info;
  return new $c_Lsttp_tapir_Endpoint(securityInput, input, errorOutput, output, info$1);
});
$c_Lframework_exts_EndpointExts$package$.prototype.serverSentEventsAndWebSocket__Lsttp_tapir_Endpoint__Lsttp_tapir_EndpointInput__Lsttp_tapir_Codec__Lframework_data_EndpointSSEWithWS = (function(e, wsDiscriminatedBy, codec) {
  var sse = $m_Lframework_exts_EndpointExts$package$().serverSentEvents__Lsttp_tapir_Endpoint__Lsttp_tapir_Codec__Lsttp_tapir_Endpoint(e, codec);
  var ta = new $c_Lsttp_tapir_typelevel_LowPriorityTupleArity$$anon$21();
  var concat = new $c_Lsttp_tapir_typelevel_LowPriorityTupleConcat3$$anon$7(ta);
  var e$1 = $f_Lsttp_tapir_EndpointInputsOps__in__Lsttp_tapir_EndpointInput__Lsttp_tapir_typelevel_ParamConcat__O(e, wsDiscriminatedBy, concat);
  var this$3 = $m_Lsttp_tapir_package$();
  var i = new $c_Lsttp_tapir_Tapir$WebSocketBodyBuilder(this$3).apply__Lsttp_capabilities_package$Streams__Lsttp_tapir_Codec__Lsttp_tapir_Codec__Lsttp_tapir_WebSocketBodyOutput(new $c_Lsttp_capabilities_fs2_Fs2Streams$$anon$1(), new $c_Lframework_prelude_tapir$package$tapirCodecForNothing(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Codec$().textWebSocketFrame__Lsttp_tapir_Codec__Lsttp_tapir_Codec(codec));
  var output = new $c_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper(i);
  var securityInput = e$1.Lsttp_tapir_Endpoint__f_securityInput;
  var input = e$1.Lsttp_tapir_Endpoint__f_input;
  var errorOutput = e$1.Lsttp_tapir_Endpoint__f_errorOutput;
  var info = e$1.Lsttp_tapir_Endpoint__f_info;
  var webSocket = new $c_Lsttp_tapir_Endpoint(securityInput, input, errorOutput, output, info);
  var evidence$1 = $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO;
  return new $c_Lframework_data_EndpointSSEWithWS(sse, webSocket, evidence$1);
});
$c_Lframework_exts_EndpointExts$package$.prototype.defaultTo__Lsttp_tapir_EndpointInput$Query__O__s_CanEqual__Lsttp_tapir_EndpointInput$Query = (function(query, value, x$3) {
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$2) => (_$2.isEmpty__Z() ? value : _$2.get__O())));
  var g = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1) => ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(value, x$1) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$() : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(x$1))));
  return $f_Lsttp_tapir_EndpointTransput__map__F1__F1__Lsttp_tapir_EndpointTransput(query, f, g);
});
var $d_Lframework_exts_EndpointExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_EndpointExts$package$, "framework.exts.EndpointExts$package$", ({
  Lframework_exts_EndpointExts$package$: 1
}));
export { $d_Lframework_exts_EndpointExts$package$ as $d_Lframework_exts_EndpointExts$package$ };
var $n_Lframework_exts_EndpointExts$package$;
function $m_Lframework_exts_EndpointExts$package$() {
  if ((!$n_Lframework_exts_EndpointExts$package$)) {
    $n_Lframework_exts_EndpointExts$package$ = new $c_Lframework_exts_EndpointExts$package$();
  }
  return $n_Lframework_exts_EndpointExts$package$;
}
export { $m_Lframework_exts_EndpointExts$package$ as $m_Lframework_exts_EndpointExts$package$ };
function $f_Lframework_exts_EventStreamExts__mapToSignal__Lcom_raquo_airstream_core_EventStream__F0__Lcom_raquo_airstream_core_Signal($thiz, stream, compute) {
  var \u03b41$ = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__mapTo__F0__Lcom_raquo_airstream_core_Observable(stream, compute);
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_EventStream__toSignal__F0__Z__Lcom_raquo_airstream_core_Signal(\u03b41$, compute, false);
}
export { $f_Lframework_exts_EventStreamExts__mapToSignal__Lcom_raquo_airstream_core_EventStream__F0__Lcom_raquo_airstream_core_Signal as $f_Lframework_exts_EventStreamExts__mapToSignal__Lcom_raquo_airstream_core_EventStream__F0__Lcom_raquo_airstream_core_Signal };
function $f_Lframework_exts_EventStreamExts__mapToSignal__Lcom_raquo_airstream_core_EventStream__F1__Lcom_raquo_airstream_core_Signal($thiz, stream, compute) {
  var project = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((a) => compute.apply__O__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(a))));
  var \u03b42$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapStream(stream, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var initial = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => compute.apply__O__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$())));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_EventStream__toSignal__F0__Z__Lcom_raquo_airstream_core_Signal(\u03b42$, initial, false);
}
export { $f_Lframework_exts_EventStreamExts__mapToSignal__Lcom_raquo_airstream_core_EventStream__F1__Lcom_raquo_airstream_core_Signal as $f_Lframework_exts_EventStreamExts__mapToSignal__Lcom_raquo_airstream_core_EventStream__F1__Lcom_raquo_airstream_core_Signal };
/** @constructor */
function $c_Lframework_exts_EventStreamExts$package$() {
  this.Lframework_exts_EventStreamExts$package$__f_frameworkEventStreamBooleanExts$lzy1 = null;
  this.Lframework_exts_EventStreamExts$package$__f_frameworkEventStreamBooleanExtsbitmap$1 = false;
  this.Lframework_exts_EventStreamExts$package$__f_frameworkEventStreamExts$lzy1 = null;
  this.Lframework_exts_EventStreamExts$package$__f_frameworkEventStreamExtsbitmap$1 = false;
}
export { $c_Lframework_exts_EventStreamExts$package$ as $c_Lframework_exts_EventStreamExts$package$ };
$c_Lframework_exts_EventStreamExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_EventStreamExts$package$.prototype.constructor = $c_Lframework_exts_EventStreamExts$package$;
/** @constructor */
function $h_Lframework_exts_EventStreamExts$package$() {
}
export { $h_Lframework_exts_EventStreamExts$package$ as $h_Lframework_exts_EventStreamExts$package$ };
$h_Lframework_exts_EventStreamExts$package$.prototype = $c_Lframework_exts_EventStreamExts$package$.prototype;
$c_Lframework_exts_EventStreamExts$package$.prototype.frameworkEventStreamBooleanExts__Lframework_exts_EventStreamBooleanExts = (function() {
  if ((!this.Lframework_exts_EventStreamExts$package$__f_frameworkEventStreamBooleanExtsbitmap$1)) {
    this.Lframework_exts_EventStreamExts$package$__f_frameworkEventStreamBooleanExts$lzy1 = new $c_Lframework_exts_EventStreamExts$package$$anon$3();
    this.Lframework_exts_EventStreamExts$package$__f_frameworkEventStreamBooleanExtsbitmap$1 = true;
  }
  return this.Lframework_exts_EventStreamExts$package$__f_frameworkEventStreamBooleanExts$lzy1;
});
$c_Lframework_exts_EventStreamExts$package$.prototype.frameworkEventStreamExts__Lframework_exts_EventStreamExts = (function() {
  if ((!this.Lframework_exts_EventStreamExts$package$__f_frameworkEventStreamExtsbitmap$1)) {
    this.Lframework_exts_EventStreamExts$package$__f_frameworkEventStreamExts$lzy1 = new $c_Lframework_exts_EventStreamExts$package$$anon$4();
    this.Lframework_exts_EventStreamExts$package$__f_frameworkEventStreamExtsbitmap$1 = true;
  }
  return this.Lframework_exts_EventStreamExts$package$__f_frameworkEventStreamExts$lzy1;
});
$c_Lframework_exts_EventStreamExts$package$.prototype.fromCustomSourceWithSubscription__Lcom_raquo_airstream_core_EventStream$__F1__F4__F2__Lframework_sourcecode_DefinedAt__Lcom_raquo_airstream_core_EventStream = (function(obj, shouldStart, start, stop, x$5) {
  var elem = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var maybeSubscription = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_ObjectRef(elem);
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_EventStream$().fromCustomSource__F1__F4__F1__Lcom_raquo_airstream_core_EventStream(shouldStart, new $c_sr_AbstractFunction4_$$Lambda$44dd8b4a36ad9db1c12297bcc97fced51ec30e4c(((fireValue, fireError, getStartIndex, getIsStarted) => {
    var subscription = start.apply__O__O__O__O__O(fireValue, fireError, getStartIndex, getIsStarted);
    maybeSubscription.sr_ObjectRef__f_elem = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(subscription);
  })), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((v1) => {
    var startIndex = (v1 | 0);
    matchResult14: {
      var x17 = maybeSubscription.sr_ObjectRef__f_elem;
      var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      if ((x === x17)) {
        var warning$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(["No subscription to stop"]));
        var this$7 = $m_Lframework_prelude_log$();
        var this$6 = $m_Lframework_prelude_client\uff3flogging$package$JSAppName$();
        var appName = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Newtype$WithoutValidation__apply__O__O(this$6, "app");
        var level = $s_Lframework_utils_LogLevel$__Warning__Lframework_utils_LogLevel();
        var scope = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $f_Lframework_utils_JSLogger$DefaultJavascriptLogging__atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V(this$7, level, scope, warning$1, x$5, appName);
        break matchResult14;
      }
      if ((x17 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
        var subscription$1 = x17.s_Some__f_value;
        stop.apply__O__O__O(startIndex, subscription$1);
        maybeSubscription.sr_ObjectRef__f_elem = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        break matchResult14;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x17);
    }
  })));
});
$c_Lframework_exts_EventStreamExts$package$.prototype.fromCustomSourceWithSubscription$default$2__Lcom_raquo_airstream_core_EventStream$__F1 = (function(obj) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$1) => true));
});
$c_Lframework_exts_EventStreamExts$package$.prototype.fromDomEventSource__Lcom_raquo_airstream_core_EventStream$__F0__F1__Lcom_raquo_airstream_core_EventStream = (function(obj, create, convertError) {
  var $x_4 = $m_Lframework_exts_EventStreamExts$package$();
  var $x_3 = $m_Lframework_exts_EventStreamExts$package$().fromCustomSourceWithSubscription$default$2__Lcom_raquo_airstream_core_EventStream$__F1(obj);
  var $x_2 = new $c_sr_AbstractFunction4_$$Lambda$44dd8b4a36ad9db1c12297bcc97fced51ec30e4c(((fireValue, fireError, getStartIndex, getIsStarted) => {
    var evtSource = create.apply__O();
    evtSource.onmessage = ((fireValue$2) => ((evt) => fireValue$2.apply__O__O(evt)))(fireValue);
    evtSource.onerror = ((fireError$2) => ((evt$2) => {
      fireError$2.apply__O__O(convertError.apply__O__O(evt$2));
      evtSource.close();
    }))(fireError);
    return evtSource;
  }));
  var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((v1, v2) => {
    v2.close();
  }));
  var file = new $c_Lsourcecode_File("/home/arturaz/work/rapix/framework/client/src/framework/exts/EventStreamExts.scala");
  var line = new $c_Lsourcecode_Line(119);
  var name = new $c_Lsourcecode_FullName("framework.exts.EventStreamExts$package.fromDomEventSource");
  return $x_4.fromCustomSourceWithSubscription__Lcom_raquo_airstream_core_EventStream$__F1__F4__F2__Lframework_sourcecode_DefinedAt__Lcom_raquo_airstream_core_EventStream(obj, $x_3, $x_2, $x_1, new $c_Lframework_sourcecode_DefinedAt(file, line, name));
});
$c_Lframework_exts_EventStreamExts$package$.prototype.fromDomEventSource$default$3__Lcom_raquo_airstream_core_EventStream$__F1 = (function(obj) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((evt) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Exception__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Exception(), ("An error occurred while getting events from EventSource: " + JSON.stringify(evt, (void 0), 2)))));
});
$c_Lframework_exts_EventStreamExts$package$.prototype.fromDomEventSourceEither__Lcom_raquo_airstream_core_EventStream$__F0__Lcom_raquo_airstream_core_EventStream = (function(obj, create) {
  var $x_4 = $m_Lframework_exts_EventStreamExts$package$();
  var $x_3 = $m_Lframework_exts_EventStreamExts$package$().fromCustomSourceWithSubscription$default$2__Lcom_raquo_airstream_core_EventStream$__F1(obj);
  var $x_2 = new $c_sr_AbstractFunction4_$$Lambda$44dd8b4a36ad9db1c12297bcc97fced51ec30e4c(((fireValue, fireError, getStartIndex, getIsStarted) => {
    var evtSource = create.apply__O();
    evtSource.onmessage = ((fireValue$2) => ((evt) => fireValue$2.apply__O__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(evt))))(fireValue);
    evtSource.onerror = ((fireValue$3) => ((evt$2) => {
      fireValue$3.apply__O__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(evt$2));
      evtSource.close();
    }))(fireValue);
    return evtSource;
  }));
  var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((v1, v2) => {
    v2.close();
  }));
  var file = new $c_Lsourcecode_File("/home/arturaz/work/rapix/framework/client/src/framework/exts/EventStreamExts.scala");
  var line = new $c_Lsourcecode_Line(147);
  var name = new $c_Lsourcecode_FullName("framework.exts.EventStreamExts$package.fromDomEventSourceEither");
  return $x_4.fromCustomSourceWithSubscription__Lcom_raquo_airstream_core_EventStream$__F1__F4__F2__Lframework_sourcecode_DefinedAt__Lcom_raquo_airstream_core_EventStream(obj, $x_3, $x_2, $x_1, new $c_Lframework_sourcecode_DefinedAt(file, line, name));
});
$c_Lframework_exts_EventStreamExts$package$.prototype.fromWebSocket__Lcom_raquo_airstream_core_EventStream$__F0__F1__Lcom_raquo_airstream_core_EventStream = (function(obj, create, convertError) {
  var $x_4 = $m_Lframework_exts_EventStreamExts$package$();
  var $x_3 = $m_Lframework_exts_EventStreamExts$package$().fromCustomSourceWithSubscription$default$2__Lcom_raquo_airstream_core_EventStream$__F1(obj);
  var $x_2 = new $c_sr_AbstractFunction4_$$Lambda$44dd8b4a36ad9db1c12297bcc97fced51ec30e4c(((fireValue, fireError, getStartIndex, getIsStarted) => {
    var evtSource = create.apply__O();
    evtSource.onmessage = ((fireValue$2) => ((evt) => fireValue$2.apply__O__O(evt)))(fireValue);
    evtSource.onerror = ((fireError$2) => ((evt$2) => {
      fireError$2.apply__O__O(convertError.apply__O__O(evt$2));
      evtSource.close();
    }))(fireError);
    return evtSource;
  }));
  var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((v1, v2) => {
    v2.close();
  }));
  var file = new $c_Lsourcecode_File("/home/arturaz/work/rapix/framework/client/src/framework/exts/EventStreamExts.scala");
  var line = new $c_Lsourcecode_Line(171);
  var name = new $c_Lsourcecode_FullName("framework.exts.EventStreamExts$package.fromWebSocket");
  return $x_4.fromCustomSourceWithSubscription__Lcom_raquo_airstream_core_EventStream$__F1__F4__F2__Lframework_sourcecode_DefinedAt__Lcom_raquo_airstream_core_EventStream(obj, $x_3, $x_2, $x_1, new $c_Lframework_sourcecode_DefinedAt(file, line, name));
});
$c_Lframework_exts_EventStreamExts$package$.prototype.fromWebSocket$default$3__Lcom_raquo_airstream_core_EventStream$__F1 = (function(obj) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((evt) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Exception__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Exception(), ("An error occurred while getting events from WebSocket: " + JSON.stringify(evt, (void 0), 2)))));
});
$c_Lframework_exts_EventStreamExts$package$.prototype.fromWebSocketEither__Lcom_raquo_airstream_core_EventStream$__F0__Lcom_raquo_airstream_core_EventStream = (function(obj, create) {
  var $x_4 = $m_Lframework_exts_EventStreamExts$package$();
  var $x_3 = $m_Lframework_exts_EventStreamExts$package$().fromCustomSourceWithSubscription$default$2__Lcom_raquo_airstream_core_EventStream$__F1(obj);
  var $x_2 = new $c_sr_AbstractFunction4_$$Lambda$44dd8b4a36ad9db1c12297bcc97fced51ec30e4c(((fireValue, fireError, getStartIndex, getIsStarted) => {
    var webSocket = create.apply__O();
    webSocket.onmessage = ((fireValue$2) => ((evt) => fireValue$2.apply__O__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(evt))))(fireValue);
    webSocket.onerror = ((fireValue$3) => ((evt$2) => {
      fireValue$3.apply__O__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(evt$2));
      webSocket.close();
    }))(fireValue);
    return webSocket;
  }));
  var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((v1, v2) => {
    v2.close();
  }));
  var file = new $c_Lsourcecode_File("/home/arturaz/work/rapix/framework/client/src/framework/exts/EventStreamExts.scala");
  var line = new $c_Lsourcecode_Line(199);
  var name = new $c_Lsourcecode_FullName("framework.exts.EventStreamExts$package.fromWebSocketEither");
  return $x_4.fromCustomSourceWithSubscription__Lcom_raquo_airstream_core_EventStream$__F1__F4__F2__Lframework_sourcecode_DefinedAt__Lcom_raquo_airstream_core_EventStream(obj, $x_3, $x_2, $x_1, new $c_Lframework_sourcecode_DefinedAt(file, line, name));
});
var $d_Lframework_exts_EventStreamExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_EventStreamExts$package$, "framework.exts.EventStreamExts$package$", ({
  Lframework_exts_EventStreamExts$package$: 1
}));
export { $d_Lframework_exts_EventStreamExts$package$ as $d_Lframework_exts_EventStreamExts$package$ };
var $n_Lframework_exts_EventStreamExts$package$;
function $m_Lframework_exts_EventStreamExts$package$() {
  if ((!$n_Lframework_exts_EventStreamExts$package$)) {
    $n_Lframework_exts_EventStreamExts$package$ = new $c_Lframework_exts_EventStreamExts$package$();
  }
  return $n_Lframework_exts_EventStreamExts$package$;
}
export { $m_Lframework_exts_EventStreamExts$package$ as $m_Lframework_exts_EventStreamExts$package$ };
/** @constructor */
function $c_Lframework_exts_FutureCompanionExts$package$() {
}
export { $c_Lframework_exts_FutureCompanionExts$package$ as $c_Lframework_exts_FutureCompanionExts$package$ };
$c_Lframework_exts_FutureCompanionExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_FutureCompanionExts$package$.prototype.constructor = $c_Lframework_exts_FutureCompanionExts$package$;
/** @constructor */
function $h_Lframework_exts_FutureCompanionExts$package$() {
}
export { $h_Lframework_exts_FutureCompanionExts$package$ as $h_Lframework_exts_FutureCompanionExts$package$ };
$h_Lframework_exts_FutureCompanionExts$package$.prototype = $c_Lframework_exts_FutureCompanionExts$package$.prototype;
$c_Lframework_exts_FutureCompanionExts$package$.prototype.delay__s_concurrent_Future$__s_concurrent_duration_FiniteDuration__s_concurrent_Future = (function(obj, duration) {
  var promise = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sjs_js_timers_package$().setTimeout__s_concurrent_duration_FiniteDuration__F0__sjs_js_timers_SetTimeoutHandle(duration, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
    $f_s_concurrent_Promise__success__O__s_concurrent_Promise(promise, (void 0));
  })));
  return promise;
});
var $d_Lframework_exts_FutureCompanionExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_FutureCompanionExts$package$, "framework.exts.FutureCompanionExts$package$", ({
  Lframework_exts_FutureCompanionExts$package$: 1
}));
export { $d_Lframework_exts_FutureCompanionExts$package$ as $d_Lframework_exts_FutureCompanionExts$package$ };
var $n_Lframework_exts_FutureCompanionExts$package$;
function $m_Lframework_exts_FutureCompanionExts$package$() {
  if ((!$n_Lframework_exts_FutureCompanionExts$package$)) {
    $n_Lframework_exts_FutureCompanionExts$package$ = new $c_Lframework_exts_FutureCompanionExts$package$();
  }
  return $n_Lframework_exts_FutureCompanionExts$package$;
}
export { $m_Lframework_exts_FutureCompanionExts$package$ as $m_Lframework_exts_FutureCompanionExts$package$ };
/** @constructor */
function $c_Lframework_exts_FutureExts$package$() {
}
export { $c_Lframework_exts_FutureExts$package$ as $c_Lframework_exts_FutureExts$package$ };
$c_Lframework_exts_FutureExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_FutureExts$package$.prototype.constructor = $c_Lframework_exts_FutureExts$package$;
/** @constructor */
function $h_Lframework_exts_FutureExts$package$() {
}
export { $h_Lframework_exts_FutureExts$package$ as $h_Lframework_exts_FutureExts$package$ };
$h_Lframework_exts_FutureExts$package$.prototype = $c_Lframework_exts_FutureExts$package$.prototype;
$c_Lframework_exts_FutureExts$package$.prototype.attempt__s_concurrent_Future__s_concurrent_Future = (function(future) {
  return future.transformWith__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1) => {
    if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success)) {
      var value = x$1.s_util_Success__f_value;
      return $m_s_concurrent_Future$().successful__O__s_concurrent_Future(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value));
    }
    if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure)) {
      var cause = x$1.s_util_Failure__f_exception;
      return $m_s_concurrent_Future$().successful__O__s_concurrent_Future(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(cause));
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  })), $m_s_concurrent_ExecutionContext$parasitic$());
});
$c_Lframework_exts_FutureExts$package$.prototype.orNever__s_concurrent_Future__s_concurrent_Future = (function(future) {
  return future.flatMap__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1) => {
    var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    if ((x === x$1)) {
      return $m_s_concurrent_Future$never$();
    }
    if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var value = x$1.s_Some__f_value;
      return $m_s_concurrent_Future$().successful__O__s_concurrent_Future(value);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  })), $m_s_concurrent_ExecutionContext$parasitic$());
});
var $d_Lframework_exts_FutureExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_FutureExts$package$, "framework.exts.FutureExts$package$", ({
  Lframework_exts_FutureExts$package$: 1
}));
export { $d_Lframework_exts_FutureExts$package$ as $d_Lframework_exts_FutureExts$package$ };
var $n_Lframework_exts_FutureExts$package$;
function $m_Lframework_exts_FutureExts$package$() {
  if ((!$n_Lframework_exts_FutureExts$package$)) {
    $n_Lframework_exts_FutureExts$package$ = new $c_Lframework_exts_FutureExts$package$();
  }
  return $n_Lframework_exts_FutureExts$package$;
}
export { $m_Lframework_exts_FutureExts$package$ as $m_Lframework_exts_FutureExts$package$ };
/** @constructor */
function $c_Lframework_exts_HTMLDocumentExts$package$() {
}
export { $c_Lframework_exts_HTMLDocumentExts$package$ as $c_Lframework_exts_HTMLDocumentExts$package$ };
$c_Lframework_exts_HTMLDocumentExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_HTMLDocumentExts$package$.prototype.constructor = $c_Lframework_exts_HTMLDocumentExts$package$;
/** @constructor */
function $h_Lframework_exts_HTMLDocumentExts$package$() {
}
export { $h_Lframework_exts_HTMLDocumentExts$package$ as $h_Lframework_exts_HTMLDocumentExts$package$ };
$h_Lframework_exts_HTMLDocumentExts$package$.prototype = $c_Lframework_exts_HTMLDocumentExts$package$.prototype;
$c_Lframework_exts_HTMLDocumentExts$package$.prototype.cookieMap__Lorg_scalajs_dom_HTMLDocument__sci_Map = (function(doc) {
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_StringOps$();
  var x = doc.cookie;
  var xs = $x_1.split$extension__T__C__AT(x, 59);
  var this$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_ArrayOps$().iterator$extension__O__sc_Iterator(xs);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$1) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__trim__T(_$1)));
  var this$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(this$3, f);
  var p = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$2) => (_$2 !== "")));
  var this$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$6(this$6, p, false);
  var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$3) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__split__T__I__AT(_$3, "=", 2)));
  var this$12 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(this$7, f$1);
  var f$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1) => {
    if ((x$1 !== null)) {
      if (($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Array$UnapplySeqWrapper$().lengthCompare$extension__O__I__I(x$1, 2) === 0)) {
        var x3 = x$1.u[0];
        var x4 = x$1.u[1];
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), x3, x4);
      }
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  }));
  var this$14 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(this$12, f$2);
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$().from__sc_IterableOnce__sci_Map(this$14);
});
var $d_Lframework_exts_HTMLDocumentExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_HTMLDocumentExts$package$, "framework.exts.HTMLDocumentExts$package$", ({
  Lframework_exts_HTMLDocumentExts$package$: 1
}));
export { $d_Lframework_exts_HTMLDocumentExts$package$ as $d_Lframework_exts_HTMLDocumentExts$package$ };
var $n_Lframework_exts_HTMLDocumentExts$package$;
function $m_Lframework_exts_HTMLDocumentExts$package$() {
  if ((!$n_Lframework_exts_HTMLDocumentExts$package$)) {
    $n_Lframework_exts_HTMLDocumentExts$package$ = new $c_Lframework_exts_HTMLDocumentExts$package$();
  }
  return $n_Lframework_exts_HTMLDocumentExts$package$;
}
export { $m_Lframework_exts_HTMLDocumentExts$package$ as $m_Lframework_exts_HTMLDocumentExts$package$ };
function $p_Lframework_exts_IOExts$package$__resolveCompleted$1__Lcats_effect_kernel_Outcome__Lcats_effect_IO($thiz, outcome) {
  if ((outcome instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Succeeded)) {
    var x8 = outcome.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
    return x8;
  }
  if ((outcome instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Errored)) {
    var x5 = outcome.Lcats_effect_kernel_Outcome$Errored__f_e;
    $m_Lcats_effect_IO$();
    return new $c_Lcats_effect_IO$Error(x5);
  }
  if ((outcome instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Canceled)) {
    $m_Lcats_effect_IO$();
    var value = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    return new $c_Lcats_effect_IO$Pure(value);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(outcome);
}
export { $p_Lframework_exts_IOExts$package$__resolveCompleted$1__Lcats_effect_kernel_Outcome__Lcats_effect_IO as $p_Lframework_exts_IOExts$package$__resolveCompleted$1__Lcats_effect_kernel_Outcome__Lcats_effect_IO };
function $p_Lframework_exts_IOExts$package$__resolveFirst$1__Lcats_effect_kernel_Outcome__Lcats_effect_kernel_Fiber__Lcats_effect_IO($thiz, first, other) {
  if ((first instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Succeeded)) {
    var x19 = first.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
    return x19.flatMap__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1) => {
      if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
        return other.cancel__O().as__O__Lcats_effect_IO(x$1);
      }
      var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      if ((x === x$1)) {
        return other.join__O().flatMap__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((outcome) => $p_Lframework_exts_IOExts$package$__resolveCompleted$1__Lcats_effect_kernel_Outcome__Lcats_effect_IO($thiz, outcome))));
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })));
  }
  if ((first instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Errored)) {
    var x16 = first.Lcats_effect_kernel_Outcome$Errored__f_e;
    var this$6 = other.cancel__O();
    $m_Lcats_effect_IO$();
    var that = new $c_Lcats_effect_IO$Error(x16);
    return this$6.productR__Lcats_effect_IO__Lcats_effect_IO(that);
  }
  if ((first instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Canceled)) {
    return other.join__O().flatMap__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((outcome$1) => $p_Lframework_exts_IOExts$package$__resolveCompleted$1__Lcats_effect_kernel_Outcome__Lcats_effect_IO($thiz, outcome$1))));
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(first);
}
export { $p_Lframework_exts_IOExts$package$__resolveFirst$1__Lcats_effect_kernel_Outcome__Lcats_effect_kernel_Fiber__Lcats_effect_IO as $p_Lframework_exts_IOExts$package$__resolveFirst$1__Lcats_effect_kernel_Outcome__Lcats_effect_kernel_Fiber__Lcats_effect_IO };
/** @constructor */
function $c_Lframework_exts_IOExts$package$() {
}
export { $c_Lframework_exts_IOExts$package$ as $c_Lframework_exts_IOExts$package$ };
$c_Lframework_exts_IOExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_IOExts$package$.prototype.constructor = $c_Lframework_exts_IOExts$package$;
/** @constructor */
function $h_Lframework_exts_IOExts$package$() {
}
export { $h_Lframework_exts_IOExts$package$ as $h_Lframework_exts_IOExts$package$ };
$h_Lframework_exts_IOExts$package$.prototype = $c_Lframework_exts_IOExts$package$.prototype;
$c_Lframework_exts_IOExts$package$.prototype.raceSome__Lcats_effect_IO$__Lcats_effect_IO__Lcats_effect_IO__Lcats_effect_IO = (function(obj, ioa, iob) {
  return ($m_Lcats_effect_IO$(), new $c_Lcats_effect_IO$RacePair(ioa, iob)).flatMap__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1) => {
    if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
      var x26 = x$1.s_util_Left__f_value;
      if ((x26 !== null)) {
        var outcomeA = x26._1__O();
        var fiberB = x26._2__O();
        return $p_Lframework_exts_IOExts$package$__resolveFirst$1__Lcats_effect_kernel_Outcome__Lcats_effect_kernel_Fiber__Lcats_effect_IO(this, outcomeA, fiberB);
      }
    }
    if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
      var x22 = x$1.s_util_Right__f_value;
      if ((x22 !== null)) {
        var fiberA = x22._1__O();
        var outcomeB = x22._2__O();
        return $p_Lframework_exts_IOExts$package$__resolveFirst$1__Lcats_effect_kernel_Outcome__Lcats_effect_kernel_Fiber__Lcats_effect_IO(this, outcomeB, fiberA);
      }
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  })));
});
var $d_Lframework_exts_IOExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_IOExts$package$, "framework.exts.IOExts$package$", ({
  Lframework_exts_IOExts$package$: 1
}));
export { $d_Lframework_exts_IOExts$package$ as $d_Lframework_exts_IOExts$package$ };
var $n_Lframework_exts_IOExts$package$;
function $m_Lframework_exts_IOExts$package$() {
  if ((!$n_Lframework_exts_IOExts$package$)) {
    $n_Lframework_exts_IOExts$package$ = new $c_Lframework_exts_IOExts$package$();
  }
  return $n_Lframework_exts_IOExts$package$;
}
export { $m_Lframework_exts_IOExts$package$ as $m_Lframework_exts_IOExts$package$ };
function $f_Lframework_exts_IterableOnceExts__findMap__sc_IterableOnce__F1__s_Option($thiz, iter, f) {
  var this$1 = iter.iterator__sc_Iterator();
  var this$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(this$1, f);
  _return: {
    while (this$2.hasNext__Z()) {
      var a = this$2.next__O();
      if ((!a.isEmpty__Z())) {
        var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(a);
        break _return;
      }
    }
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
  var this$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_$less$colon$less$();
  return $x_1.flatten__s_$less$colon$less__s_Option(this$3.s_$less$colon$less$__f_singleton);
}
export { $f_Lframework_exts_IterableOnceExts__findMap__sc_IterableOnce__F1__s_Option as $f_Lframework_exts_IterableOnceExts__findMap__sc_IterableOnce__F1__s_Option };
function $f_Lframework_exts_IterableOnceExts__mapFilter__sc_IterableOnce__F1__sc_Iterator($thiz, iter, f) {
  var this$1 = iter.iterator__sc_Iterator();
  var this$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(this$1, f);
  var pf = new $c_Lframework_exts_IterableOnceExts$$anon$1();
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$7(this$2, pf);
}
export { $f_Lframework_exts_IterableOnceExts__mapFilter__sc_IterableOnce__F1__sc_Iterator as $f_Lframework_exts_IterableOnceExts__mapFilter__sc_IterableOnce__F1__sc_Iterator };
/** @constructor */
function $c_Lframework_exts_IterableOnceExts$package$() {
  this.Lframework_exts_IterableOnceExts$package$__f_frameworkIterableOnceExts$lzy1 = null;
  this.Lframework_exts_IterableOnceExts$package$__f_frameworkIterableOnceExtsbitmap$1 = false;
}
export { $c_Lframework_exts_IterableOnceExts$package$ as $c_Lframework_exts_IterableOnceExts$package$ };
$c_Lframework_exts_IterableOnceExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_IterableOnceExts$package$.prototype.constructor = $c_Lframework_exts_IterableOnceExts$package$;
/** @constructor */
function $h_Lframework_exts_IterableOnceExts$package$() {
}
export { $h_Lframework_exts_IterableOnceExts$package$ as $h_Lframework_exts_IterableOnceExts$package$ };
$h_Lframework_exts_IterableOnceExts$package$.prototype = $c_Lframework_exts_IterableOnceExts$package$.prototype;
$c_Lframework_exts_IterableOnceExts$package$.prototype.frameworkIterableOnceExts__Lframework_exts_IterableOnceExts = (function() {
  if ((!this.Lframework_exts_IterableOnceExts$package$__f_frameworkIterableOnceExtsbitmap$1)) {
    this.Lframework_exts_IterableOnceExts$package$__f_frameworkIterableOnceExts$lzy1 = new $c_Lframework_exts_IterableOnceExts$package$$anon$2();
    this.Lframework_exts_IterableOnceExts$package$__f_frameworkIterableOnceExtsbitmap$1 = true;
  }
  return this.Lframework_exts_IterableOnceExts$package$__f_frameworkIterableOnceExts$lzy1;
});
var $d_Lframework_exts_IterableOnceExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_IterableOnceExts$package$, "framework.exts.IterableOnceExts$package$", ({
  Lframework_exts_IterableOnceExts$package$: 1
}));
export { $d_Lframework_exts_IterableOnceExts$package$ as $d_Lframework_exts_IterableOnceExts$package$ };
var $n_Lframework_exts_IterableOnceExts$package$;
function $m_Lframework_exts_IterableOnceExts$package$() {
  if ((!$n_Lframework_exts_IterableOnceExts$package$)) {
    $n_Lframework_exts_IterableOnceExts$package$ = new $c_Lframework_exts_IterableOnceExts$package$();
  }
  return $n_Lframework_exts_IterableOnceExts$package$;
}
export { $m_Lframework_exts_IterableOnceExts$package$ as $m_Lframework_exts_IterableOnceExts$package$ };
function $p_Lframework_exts_JWTExts$package$__given_Strings$lzyINIT1$1__sr_LazyRef__Lframework_utils_PrettyPrintDuration$Strings($thiz, given_Strings$lzy1$1) {
  return (given_Strings$lzy1$1.sr_LazyRef__f__initialized ? given_Strings$lzy1$1.sr_LazyRef__f__value : given_Strings$lzy1$1.initialize__O__O($m_Lframework_utils_PrettyPrintDuration$Strings$EnglishShortNoSpaces$()));
}
export { $p_Lframework_exts_JWTExts$package$__given_Strings$lzyINIT1$1__sr_LazyRef__Lframework_utils_PrettyPrintDuration$Strings as $p_Lframework_exts_JWTExts$package$__given_Strings$lzyINIT1$1__sr_LazyRef__Lframework_utils_PrettyPrintDuration$Strings };
function $p_Lframework_exts_JWTExts$package$__given_Strings$1__sr_LazyRef__Lframework_utils_PrettyPrintDuration$Strings($thiz, given_Strings$lzy1$2) {
  return (given_Strings$lzy1$2.sr_LazyRef__f__initialized ? given_Strings$lzy1$2.sr_LazyRef__f__value : $p_Lframework_exts_JWTExts$package$__given_Strings$lzyINIT1$1__sr_LazyRef__Lframework_utils_PrettyPrintDuration$Strings($thiz, given_Strings$lzy1$2));
}
export { $p_Lframework_exts_JWTExts$package$__given_Strings$1__sr_LazyRef__Lframework_utils_PrettyPrintDuration$Strings as $p_Lframework_exts_JWTExts$package$__given_Strings$1__sr_LazyRef__Lframework_utils_PrettyPrintDuration$Strings };
/** @constructor */
function $c_Lframework_exts_JWTExts$package$() {
}
export { $c_Lframework_exts_JWTExts$package$ as $c_Lframework_exts_JWTExts$package$ };
$c_Lframework_exts_JWTExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_JWTExts$package$.prototype.constructor = $c_Lframework_exts_JWTExts$package$;
/** @constructor */
function $h_Lframework_exts_JWTExts$package$() {
}
export { $h_Lframework_exts_JWTExts$package$ as $h_Lframework_exts_JWTExts$package$ };
$h_Lframework_exts_JWTExts$package$.prototype = $c_Lframework_exts_JWTExts$package$.prototype;
$c_Lframework_exts_JWTExts$package$.prototype.toOptionSignal$default$3__Lframework_data_JWT$package$JWT$Expiring__F0 = (function(jwt) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lframework_data_FrameworkDateTime($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_data_FrameworkDateTime$().now__Ljava_time_LocalDateTime())));
});
var $d_Lframework_exts_JWTExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_JWTExts$package$, "framework.exts.JWTExts$package$", ({
  Lframework_exts_JWTExts$package$: 1
}));
export { $d_Lframework_exts_JWTExts$package$ as $d_Lframework_exts_JWTExts$package$ };
var $n_Lframework_exts_JWTExts$package$;
function $m_Lframework_exts_JWTExts$package$() {
  if ((!$n_Lframework_exts_JWTExts$package$)) {
    $n_Lframework_exts_JWTExts$package$ = new $c_Lframework_exts_JWTExts$package$();
  }
  return $n_Lframework_exts_JWTExts$package$;
}
export { $m_Lframework_exts_JWTExts$package$ as $m_Lframework_exts_JWTExts$package$ };
/** @constructor */
function $c_Lframework_exts_LocalizedTextExts$package$() {
}
export { $c_Lframework_exts_LocalizedTextExts$package$ as $c_Lframework_exts_LocalizedTextExts$package$ };
$c_Lframework_exts_LocalizedTextExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_LocalizedTextExts$package$.prototype.constructor = $c_Lframework_exts_LocalizedTextExts$package$;
/** @constructor */
function $h_Lframework_exts_LocalizedTextExts$package$() {
}
export { $h_Lframework_exts_LocalizedTextExts$package$ as $h_Lframework_exts_LocalizedTextExts$package$ };
$h_Lframework_exts_LocalizedTextExts$package$.prototype = $c_Lframework_exts_LocalizedTextExts$package$.prototype;
$c_Lframework_exts_LocalizedTextExts$package$.prototype.textSignal__Lframework_localization_LocalizationSupport__Lframework_localization_LocalizationSupport$LocalizedText__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_core_Signal = (function(l18n, text, locale) {
  var project = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((l) => text.text__O__T(l)));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), locale, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lframework_exts_LocalizedTextExts$package$.prototype.textRx__Lframework_localization_LocalizationSupport__Lframework_localization_LocalizationSupport$LocalizedText__Lcom_raquo_airstream_core_Source__Lcom_raquo_laminar_inserters_DynamicInserter = (function(l18n, text, locale) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$();
  var textSource = locale.toObservable__Lcom_raquo_airstream_core_Observable().map__F1__Lcom_raquo_airstream_core_Observable(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((l) => text.text__O__T(l))));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_inserters_ChildTextInserter$().apply__Lcom_raquo_airstream_core_Observable__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_inserters_DynamicInserter(textSource.toObservable__Lcom_raquo_airstream_core_Observable(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_modifiers_RenderableText$().Lcom_raquo_laminar_modifiers_RenderableText$__f_stringRenderable);
});
$c_Lframework_exts_LocalizedTextExts$package$.prototype.textRx__Lcom_raquo_airstream_core_Signal__Lframework_localization_LocalizationSupport__F1__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_laminar_inserters_DynamicInserter = (function(signal, l18n, f, locale) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$();
  var s1 = locale.toObservable__Lcom_raquo_airstream_core_Signal();
  var combinator = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((a, locale$2) => f.apply__O__O(a).text__O__T(locale$2)));
  var textSource = $m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().combineWithFn__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_Source$SignalSource__F2__Lcom_raquo_airstream_core_Signal(signal, s1, combinator);
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_inserters_ChildTextInserter$().apply__Lcom_raquo_airstream_core_Observable__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_inserters_DynamicInserter(textSource, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_modifiers_RenderableText$().Lcom_raquo_laminar_modifiers_RenderableText$__f_stringRenderable);
});
var $d_Lframework_exts_LocalizedTextExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_LocalizedTextExts$package$, "framework.exts.LocalizedTextExts$package$", ({
  Lframework_exts_LocalizedTextExts$package$: 1
}));
export { $d_Lframework_exts_LocalizedTextExts$package$ as $d_Lframework_exts_LocalizedTextExts$package$ };
var $n_Lframework_exts_LocalizedTextExts$package$;
function $m_Lframework_exts_LocalizedTextExts$package$() {
  if ((!$n_Lframework_exts_LocalizedTextExts$package$)) {
    $n_Lframework_exts_LocalizedTextExts$package$ = new $c_Lframework_exts_LocalizedTextExts$package$();
  }
  return $n_Lframework_exts_LocalizedTextExts$package$;
}
export { $m_Lframework_exts_LocalizedTextExts$package$ as $m_Lframework_exts_LocalizedTextExts$package$ };
/** @constructor */
function $c_Lframework_exts_LongExts$package$() {
}
export { $c_Lframework_exts_LongExts$package$ as $c_Lframework_exts_LongExts$package$ };
$c_Lframework_exts_LongExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_LongExts$package$.prototype.constructor = $c_Lframework_exts_LongExts$package$;
/** @constructor */
function $h_Lframework_exts_LongExts$package$() {
}
export { $h_Lframework_exts_LongExts$package$ as $h_Lframework_exts_LongExts$package$ };
$h_Lframework_exts_LongExts$package$.prototype = $c_Lframework_exts_LongExts$package$.prototype;
$c_Lframework_exts_LongExts$package$.prototype.toIntClamped__J__I = (function(value) {
  var ahi = value.RTLong__f_hi;
  if (((ahi === (-1)) ? ((value.RTLong__f_lo >>> 0) > 2147483648) : (ahi > (-1)))) {
    var t = value;
  } else {
    var t = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong((-2147483648), (-1));
  }
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var a = (((hi === 0) ? ((lo >>> 0) < 2147483647) : (hi < 0)) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi) : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(2147483647, 0));
  return a.RTLong__f_lo;
});
var $d_Lframework_exts_LongExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_LongExts$package$, "framework.exts.LongExts$package$", ({
  Lframework_exts_LongExts$package$: 1
}));
export { $d_Lframework_exts_LongExts$package$ as $d_Lframework_exts_LongExts$package$ };
var $n_Lframework_exts_LongExts$package$;
function $m_Lframework_exts_LongExts$package$() {
  if ((!$n_Lframework_exts_LongExts$package$)) {
    $n_Lframework_exts_LongExts$package$ = new $c_Lframework_exts_LongExts$package$();
  }
  return $n_Lframework_exts_LongExts$package$;
}
export { $m_Lframework_exts_LongExts$package$ as $m_Lframework_exts_LongExts$package$ };
/** @constructor */
function $c_Lframework_exts_MapExts$package$() {
}
export { $c_Lframework_exts_MapExts$package$ as $c_Lframework_exts_MapExts$package$ };
$c_Lframework_exts_MapExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_MapExts$package$.prototype.constructor = $c_Lframework_exts_MapExts$package$;
/** @constructor */
function $h_Lframework_exts_MapExts$package$() {
}
export { $h_Lframework_exts_MapExts$package$ as $h_Lframework_exts_MapExts$package$ };
$h_Lframework_exts_MapExts$package$.prototype = $c_Lframework_exts_MapExts$package$.prototype;
$c_Lframework_exts_MapExts$package$.prototype.toNonEmptyMap__sci_Map__s_math_Ordering__s_Option = (function(map, x$2) {
  return $m_Lcats_data_package$().Lcats_data_package$__f_NonEmptyMap.fromMap__sci_SortedMap__s_Option($m_sci_SortedMap$().from__sc_IterableOnce__s_math_Ordering__sci_SortedMap(map, x$2));
});
var $d_Lframework_exts_MapExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_MapExts$package$, "framework.exts.MapExts$package$", ({
  Lframework_exts_MapExts$package$: 1
}));
export { $d_Lframework_exts_MapExts$package$ as $d_Lframework_exts_MapExts$package$ };
var $n_Lframework_exts_MapExts$package$;
function $m_Lframework_exts_MapExts$package$() {
  if ((!$n_Lframework_exts_MapExts$package$)) {
    $n_Lframework_exts_MapExts$package$ = new $c_Lframework_exts_MapExts$package$();
  }
  return $n_Lframework_exts_MapExts$package$;
}
export { $m_Lframework_exts_MapExts$package$ as $m_Lframework_exts_MapExts$package$ };
/** @constructor */
function $c_Lframework_exts_NavigatorExts$package$() {
}
export { $c_Lframework_exts_NavigatorExts$package$ as $c_Lframework_exts_NavigatorExts$package$ };
$c_Lframework_exts_NavigatorExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_NavigatorExts$package$.prototype.constructor = $c_Lframework_exts_NavigatorExts$package$;
/** @constructor */
function $h_Lframework_exts_NavigatorExts$package$() {
}
export { $h_Lframework_exts_NavigatorExts$package$ as $h_Lframework_exts_NavigatorExts$package$ };
$h_Lframework_exts_NavigatorExts$package$.prototype = $c_Lframework_exts_NavigatorExts$package$.prototype;
$c_Lframework_exts_NavigatorExts$package$.prototype.serviceWorkerOption__Lorg_scalajs_dom_Navigator__s_Option = (function(navigator) {
  var v = navigator.serviceWorker;
  if ((v === (void 0))) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Option$().apply__O__s_Option(navigator.serviceWorker);
  }
});
var $d_Lframework_exts_NavigatorExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_NavigatorExts$package$, "framework.exts.NavigatorExts$package$", ({
  Lframework_exts_NavigatorExts$package$: 1
}));
export { $d_Lframework_exts_NavigatorExts$package$ as $d_Lframework_exts_NavigatorExts$package$ };
var $n_Lframework_exts_NavigatorExts$package$;
function $m_Lframework_exts_NavigatorExts$package$() {
  if ((!$n_Lframework_exts_NavigatorExts$package$)) {
    $n_Lframework_exts_NavigatorExts$package$ = new $c_Lframework_exts_NavigatorExts$package$();
  }
  return $n_Lframework_exts_NavigatorExts$package$;
}
export { $m_Lframework_exts_NavigatorExts$package$ as $m_Lframework_exts_NavigatorExts$package$ };
function $f_Lframework_exts_ObservableExts__toIO__Lcom_raquo_airstream_core_Observable__Lcats_effect_IO($thiz, observable) {
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$1) => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(_$1)));
  return $f_Lframework_exts_ObservableExts__toIOMapFilter__Lcom_raquo_airstream_core_Observable__F1__Lcats_effect_IO($thiz, observable, f);
}
export { $f_Lframework_exts_ObservableExts__toIO__Lcom_raquo_airstream_core_Observable__Lcats_effect_IO as $f_Lframework_exts_ObservableExts__toIO__Lcom_raquo_airstream_core_Observable__Lcats_effect_IO };
function $f_Lframework_exts_ObservableExts__toIOMapFilter__Lcom_raquo_airstream_core_Observable__F1__Lcats_effect_IO($thiz, observable, f) {
  return $m_Lcats_effect_IO$().async__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((callback) => {
    var this$8 = $m_Lcats_effect_IO$();
    var thunk$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855(((callback$2) => (() => {
      var owner = new $c_Lcom_raquo_airstream_ownership_ManualOwner();
      var this$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_Observer$();
      var onNext = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((a) => {
        matchResult1: {
          var x1 = f.apply__O__O(a);
          var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
          if ((x === x1)) {
            break matchResult1;
          }
          if ((x1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
            var b = x1.s_Some__f_value;
            $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_ownership_Owner__killSubscriptions__V(owner);
            callback$2.apply__O__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(b));
            break matchResult1;
          }
          throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1);
        }
      }));
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__addObserver__Lcom_raquo_airstream_core_Observer__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(observable, this$4.withRecover__F1__s_PartialFunction__Z__Lcom_raquo_airstream_core_Observer(onNext, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_PartialFunction$().s_PartialFunction$__f_empty_pf, true), owner);
      var this$6 = $m_Lcats_effect_IO$();
      var thunk = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_ownership_Owner__killSubscriptions__V(owner);
      }));
      var value = this$6.delay__F0__Lcats_effect_IO(thunk);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
    }))(callback));
    return this$8.delay__F0__Lcats_effect_IO(thunk$1);
  })));
}
export { $f_Lframework_exts_ObservableExts__toIOMapFilter__Lcom_raquo_airstream_core_Observable__F1__Lcats_effect_IO as $f_Lframework_exts_ObservableExts__toIOMapFilter__Lcom_raquo_airstream_core_Observable__F1__Lcats_effect_IO };
/** @constructor */
function $c_Lframework_exts_ObservableExts$package$() {
  this.Lframework_exts_ObservableExts$package$__f_frameworkObservableExts$lzy1 = null;
  this.Lframework_exts_ObservableExts$package$__f_frameworkObservableExtsbitmap$1 = false;
}
export { $c_Lframework_exts_ObservableExts$package$ as $c_Lframework_exts_ObservableExts$package$ };
$c_Lframework_exts_ObservableExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_ObservableExts$package$.prototype.constructor = $c_Lframework_exts_ObservableExts$package$;
/** @constructor */
function $h_Lframework_exts_ObservableExts$package$() {
}
export { $h_Lframework_exts_ObservableExts$package$ as $h_Lframework_exts_ObservableExts$package$ };
$h_Lframework_exts_ObservableExts$package$.prototype = $c_Lframework_exts_ObservableExts$package$.prototype;
$c_Lframework_exts_ObservableExts$package$.prototype.frameworkObservableExts__Lframework_exts_ObservableExts = (function() {
  if ((!this.Lframework_exts_ObservableExts$package$__f_frameworkObservableExtsbitmap$1)) {
    this.Lframework_exts_ObservableExts$package$__f_frameworkObservableExts$lzy1 = new $c_Lframework_exts_ObservableExts$package$$anon$1();
    this.Lframework_exts_ObservableExts$package$__f_frameworkObservableExtsbitmap$1 = true;
  }
  return this.Lframework_exts_ObservableExts$package$__f_frameworkObservableExts$lzy1;
});
var $d_Lframework_exts_ObservableExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_ObservableExts$package$, "framework.exts.ObservableExts$package$", ({
  Lframework_exts_ObservableExts$package$: 1
}));
export { $d_Lframework_exts_ObservableExts$package$ as $d_Lframework_exts_ObservableExts$package$ };
var $n_Lframework_exts_ObservableExts$package$;
function $m_Lframework_exts_ObservableExts$package$() {
  if ((!$n_Lframework_exts_ObservableExts$package$)) {
    $n_Lframework_exts_ObservableExts$package$ = new $c_Lframework_exts_ObservableExts$package$();
  }
  return $n_Lframework_exts_ObservableExts$package$;
}
export { $m_Lframework_exts_ObservableExts$package$ as $m_Lframework_exts_ObservableExts$package$ };
function $p_Lframework_exts_OnSSEStreamError$__given_Strings$lzyINIT1$1__sr_LazyRef__Lframework_utils_PrettyPrintDuration$Strings($thiz, given_Strings$lzy1$1) {
  return (given_Strings$lzy1$1.sr_LazyRef__f__initialized ? given_Strings$lzy1$1.sr_LazyRef__f__value : given_Strings$lzy1$1.initialize__O__O($m_Lframework_utils_PrettyPrintDuration$Strings$EnglishShortNoSpaces$()));
}
export { $p_Lframework_exts_OnSSEStreamError$__given_Strings$lzyINIT1$1__sr_LazyRef__Lframework_utils_PrettyPrintDuration$Strings as $p_Lframework_exts_OnSSEStreamError$__given_Strings$lzyINIT1$1__sr_LazyRef__Lframework_utils_PrettyPrintDuration$Strings };
function $p_Lframework_exts_OnSSEStreamError$__given_Strings$1__sr_LazyRef__Lframework_utils_PrettyPrintDuration$Strings($thiz, given_Strings$lzy1$2) {
  return (given_Strings$lzy1$2.sr_LazyRef__f__initialized ? given_Strings$lzy1$2.sr_LazyRef__f__value : $p_Lframework_exts_OnSSEStreamError$__given_Strings$lzyINIT1$1__sr_LazyRef__Lframework_utils_PrettyPrintDuration$Strings($thiz, given_Strings$lzy1$2));
}
export { $p_Lframework_exts_OnSSEStreamError$__given_Strings$1__sr_LazyRef__Lframework_utils_PrettyPrintDuration$Strings as $p_Lframework_exts_OnSSEStreamError$__given_Strings$1__sr_LazyRef__Lframework_utils_PrettyPrintDuration$Strings };
/** @constructor */
function $c_Lframework_exts_OnSSEStreamError$() {
}
export { $c_Lframework_exts_OnSSEStreamError$ as $c_Lframework_exts_OnSSEStreamError$ };
$c_Lframework_exts_OnSSEStreamError$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_OnSSEStreamError$.prototype.constructor = $c_Lframework_exts_OnSSEStreamError$;
/** @constructor */
function $h_Lframework_exts_OnSSEStreamError$() {
}
export { $h_Lframework_exts_OnSSEStreamError$ as $h_Lframework_exts_OnSSEStreamError$ };
$h_Lframework_exts_OnSSEStreamError$.prototype = $c_Lframework_exts_OnSSEStreamError$.prototype;
$c_Lframework_exts_OnSSEStreamError$.prototype.keepingLastMessage__F2__F6__Z__Lframework_exts_OnSSEStreamError = (function(onMessage, onError, clearContentsOnError) {
  return new $c_Lframework_exts_OnSSEStreamError$$anon$4(onMessage, onError, clearContentsOnError);
});
$c_Lframework_exts_OnSSEStreamError$.prototype.defaultWaitFor__I__s_concurrent_duration_FiniteDuration = (function(index) {
  var this$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_package$DurationInt(500);
  var unit = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
  var this$ = this$2.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$();
  var hi = (this$ >> 31);
  var this$11 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_FiniteDuration(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(this$, hi), unit);
  var this$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_package$DurationInt(index);
  var unit$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
  var this$$1 = this$7.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$();
  var hi$1 = (this$$1 >> 31);
  var other = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_FiniteDuration(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(this$$1, hi$1), unit$1);
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$p_s_concurrent_duration_FiniteDuration__add__J__ju_concurrent_TimeUnit__s_concurrent_duration_FiniteDuration(this$11, other.s_concurrent_duration_FiniteDuration__f_length, other.s_concurrent_duration_FiniteDuration__f_unit);
});
$c_Lframework_exts_OnSSEStreamError$.prototype.defaultOnError__Lsttp_model_Uri__Lorg_scalajs_dom_Event__I__O__O__Lframework_sourcecode_DefinedAt__Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter = (function(uri, error, connectionIndex, securityInput, input, definedAt) {
  var given_Strings$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_LazyRef();
  var waitingFor = this.defaultWaitFor__I__s_concurrent_duration_FiniteDuration(connectionIndex);
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
  var strings = $p_Lframework_exts_OnSSEStreamError$__given_Strings$1__sr_LazyRef__Lframework_utils_PrettyPrintDuration$Strings(this, given_Strings$lzy1);
  var err$1 = $x_1.genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([(((((("Error in SSE stream (url=" + uri) + ", index=") + connectionIndex) + "), waiting for ") + $m_Lframework_utils_PrettyPrintDuration$().prettyPrint__s_concurrent_duration_Duration__I__ju_concurrent_TimeUnit__Lframework_utils_PrettyPrintDuration$Strings__T(waitingFor, ($m_Lframework_utils_PrettyPrintDuration$(), 2147483647), ($m_Lframework_utils_PrettyPrintDuration$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS), strings)) + " before reconnecting."), (("[securityInput=" + securityInput) + "]"), (("[input=" + input) + "]"), "error=", error]));
  var this$5 = $m_Lframework_prelude_log$();
  var this$4 = $m_Lframework_prelude_client\uff3flogging$package$JSAppName$();
  var appName = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Newtype$WithoutValidation__apply__O__O(this$4, "app");
  var level = $s_Lframework_utils_LogLevel$__Error__Lframework_utils_LogLevel();
  var scope = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $f_Lframework_utils_JSLogger$DefaultJavascriptLogging__atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V(this$5, level, scope, err$1, definedAt, appName);
  return new $c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter(securityInput, input, waitingFor);
});
var $d_Lframework_exts_OnSSEStreamError$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_OnSSEStreamError$, "framework.exts.OnSSEStreamError$", ({
  Lframework_exts_OnSSEStreamError$: 1
}));
export { $d_Lframework_exts_OnSSEStreamError$ as $d_Lframework_exts_OnSSEStreamError$ };
var $n_Lframework_exts_OnSSEStreamError$;
function $m_Lframework_exts_OnSSEStreamError$() {
  if ((!$n_Lframework_exts_OnSSEStreamError$)) {
    $n_Lframework_exts_OnSSEStreamError$ = new $c_Lframework_exts_OnSSEStreamError$();
  }
  return $n_Lframework_exts_OnSSEStreamError$;
}
export { $m_Lframework_exts_OnSSEStreamError$ as $m_Lframework_exts_OnSSEStreamError$ };
/** @constructor */
function $c_Lframework_exts_PartialTransformerExts$package$() {
}
export { $c_Lframework_exts_PartialTransformerExts$package$ as $c_Lframework_exts_PartialTransformerExts$package$ };
$c_Lframework_exts_PartialTransformerExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_PartialTransformerExts$package$.prototype.constructor = $c_Lframework_exts_PartialTransformerExts$package$;
/** @constructor */
function $h_Lframework_exts_PartialTransformerExts$package$() {
}
export { $h_Lframework_exts_PartialTransformerExts$package$ as $h_Lframework_exts_PartialTransformerExts$package$ };
$h_Lframework_exts_PartialTransformerExts$package$.prototype = $c_Lframework_exts_PartialTransformerExts$package$.prototype;
$c_Lframework_exts_PartialTransformerExts$package$.prototype.fromEitherString__Lio_scalaland_chimney_PartialTransformer$__F1__Lio_scalaland_chimney_PartialTransformer = (function(obj, f) {
  var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((from) => $m_Lio_scalaland_chimney_partial_Result$().fromEitherString__s_util_Either__Lio_scalaland_chimney_partial_Result(f.apply__O__O(from))));
  return new $c_Lio_scalaland_chimney_PartialTransformer$$anon$1(f$1);
});
$c_Lframework_exts_PartialTransformerExts$package$.prototype.fromEitherStrings__Lio_scalaland_chimney_PartialTransformer$__F1__Lio_scalaland_chimney_PartialTransformer = (function(obj, f) {
  var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((from) => {
    var $x_2 = $m_Lio_scalaland_chimney_partial_Result$();
    var this$1 = f.apply__O__O(from);
    var this$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Either$LeftProjection(this$1);
    var x1 = this$2.s_util_Either$LeftProjection__f_e;
    if ((x1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
      var a = x1.s_util_Left__f_value;
      var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left($m_Lio_scalaland_chimney_partial_Result$Errors$().fromStrings__T__sci_Seq__Lio_scalaland_chimney_partial_Result$Errors(a.head__O(), a.tail__O()));
    } else {
      var $x_1 = this$2.s_util_Either$LeftProjection__f_e;
    }
    return $x_2.fromEither__s_util_Either__Lio_scalaland_chimney_partial_Result($x_1);
  }));
  return new $c_Lio_scalaland_chimney_PartialTransformer$$anon$1(f$1);
});
var $d_Lframework_exts_PartialTransformerExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_PartialTransformerExts$package$, "framework.exts.PartialTransformerExts$package$", ({
  Lframework_exts_PartialTransformerExts$package$: 1
}));
export { $d_Lframework_exts_PartialTransformerExts$package$ as $d_Lframework_exts_PartialTransformerExts$package$ };
var $n_Lframework_exts_PartialTransformerExts$package$;
function $m_Lframework_exts_PartialTransformerExts$package$() {
  if ((!$n_Lframework_exts_PartialTransformerExts$package$)) {
    $n_Lframework_exts_PartialTransformerExts$package$ = new $c_Lframework_exts_PartialTransformerExts$package$();
  }
  return $n_Lframework_exts_PartialTransformerExts$package$;
}
export { $m_Lframework_exts_PartialTransformerExts$package$ as $m_Lframework_exts_PartialTransformerExts$package$ };
/** @constructor */
function $c_Lframework_exts_PartialTransformerExts$package$PartialTransformerExts$() {
}
export { $c_Lframework_exts_PartialTransformerExts$package$PartialTransformerExts$ as $c_Lframework_exts_PartialTransformerExts$package$PartialTransformerExts$ };
$c_Lframework_exts_PartialTransformerExts$package$PartialTransformerExts$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_PartialTransformerExts$package$PartialTransformerExts$.prototype.constructor = $c_Lframework_exts_PartialTransformerExts$package$PartialTransformerExts$;
/** @constructor */
function $h_Lframework_exts_PartialTransformerExts$package$PartialTransformerExts$() {
}
export { $h_Lframework_exts_PartialTransformerExts$package$PartialTransformerExts$ as $h_Lframework_exts_PartialTransformerExts$package$PartialTransformerExts$ };
$h_Lframework_exts_PartialTransformerExts$package$PartialTransformerExts$.prototype = $c_Lframework_exts_PartialTransformerExts$package$PartialTransformerExts$.prototype;
$c_Lframework_exts_PartialTransformerExts$package$PartialTransformerExts$.prototype.andThen$extension__Lio_scalaland_chimney_PartialTransformer__Lio_scalaland_chimney_PartialTransformer__Lio_scalaland_chimney_PartialTransformer = (function(this$, t2) {
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((from) => {
    var this$1 = this$.transform__O__Z__Lio_scalaland_chimney_partial_Result(from, false);
    if ((this$1 instanceof $c_Lio_scalaland_chimney_partial_Result$Value)) {
      var x40 = this$1.Lio_scalaland_chimney_partial_Result$Value__f_value;
      return t2.transform__O__Z__Lio_scalaland_chimney_partial_Result(x40, false);
    }
    if ((this$1 instanceof $c_Lio_scalaland_chimney_partial_Result$Errors)) {
      return this$1;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this$1);
  }));
  return new $c_Lio_scalaland_chimney_PartialTransformer$$anon$1(f);
});
$c_Lframework_exts_PartialTransformerExts$package$PartialTransformerExts$.prototype.andThen$extension__Lio_scalaland_chimney_PartialTransformer__Lio_scalaland_chimney_Transformer__Lio_scalaland_chimney_PartialTransformer = (function(this$, t2) {
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((from) => {
    var this$1 = this$.transform__O__Z__Lio_scalaland_chimney_partial_Result(from, false);
    if ((this$1 instanceof $c_Lio_scalaland_chimney_partial_Result$Value)) {
      var x35 = this$1.Lio_scalaland_chimney_partial_Result$Value__f_value;
      var value = t2.transform__O__O(x35);
      return new $c_Lio_scalaland_chimney_partial_Result$Value(value);
    }
    if ((this$1 instanceof $c_Lio_scalaland_chimney_partial_Result$Errors)) {
      return this$1;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this$1);
  }));
  return new $c_Lio_scalaland_chimney_PartialTransformer$$anon$1(f);
});
var $d_Lframework_exts_PartialTransformerExts$package$PartialTransformerExts$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_PartialTransformerExts$package$PartialTransformerExts$, "framework.exts.PartialTransformerExts$package$PartialTransformerExts$", ({
  Lframework_exts_PartialTransformerExts$package$PartialTransformerExts$: 1
}));
export { $d_Lframework_exts_PartialTransformerExts$package$PartialTransformerExts$ as $d_Lframework_exts_PartialTransformerExts$package$PartialTransformerExts$ };
var $n_Lframework_exts_PartialTransformerExts$package$PartialTransformerExts$;
function $m_Lframework_exts_PartialTransformerExts$package$PartialTransformerExts$() {
  if ((!$n_Lframework_exts_PartialTransformerExts$package$PartialTransformerExts$)) {
    $n_Lframework_exts_PartialTransformerExts$package$PartialTransformerExts$ = new $c_Lframework_exts_PartialTransformerExts$package$PartialTransformerExts$();
  }
  return $n_Lframework_exts_PartialTransformerExts$package$PartialTransformerExts$;
}
export { $m_Lframework_exts_PartialTransformerExts$package$PartialTransformerExts$ as $m_Lframework_exts_PartialTransformerExts$package$PartialTransformerExts$ };
/** @constructor */
function $c_Lframework_exts_PushSubscriptionExts$package$() {
}
export { $c_Lframework_exts_PushSubscriptionExts$package$ as $c_Lframework_exts_PushSubscriptionExts$package$ };
$c_Lframework_exts_PushSubscriptionExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_PushSubscriptionExts$package$.prototype.constructor = $c_Lframework_exts_PushSubscriptionExts$package$;
/** @constructor */
function $h_Lframework_exts_PushSubscriptionExts$package$() {
}
export { $h_Lframework_exts_PushSubscriptionExts$package$ as $h_Lframework_exts_PushSubscriptionExts$package$ };
$h_Lframework_exts_PushSubscriptionExts$package$.prototype = $c_Lframework_exts_PushSubscriptionExts$package$.prototype;
$c_Lframework_exts_PushSubscriptionExts$package$.prototype.asScala__Lorg_scalajs_dom_PushSubscription__s_util_Either = (function(jsSubscription) {
  return $m_Lframework_exts_PushSubscriptionExts$package$().asScala__Lorg_scalajs_dom_PushSubscriptionJSON__s_util_Either(jsSubscription.toJSON());
});
$c_Lframework_exts_PushSubscriptionExts$package$.prototype.asScala__Lorg_scalajs_dom_PushSubscriptionJSON__s_util_Either = (function(json) {
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_Uri$().parse__T__s_util_Either(json.endpoint);
  if ((this$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
    var b = this$1.s_util_Right__f_value;
    var dict = json.keys;
    var this$4 = ((!(!$m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, "auth"))) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(dict.auth) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
    var this$5 = (this$4.isEmpty__Z() ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left("Cannot find 'auth' key") : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(this$4.get__O()));
    if ((this$5 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
      var b$1 = this$5.s_util_Right__f_value;
      var dict$1 = json.keys;
      var this$8 = ((!(!$m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict$1, "p256dh"))) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(dict$1.p256dh) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
      var this$9 = (this$8.isEmpty__Z() ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left("Cannot find 'p256dh' key") : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(this$8.get__O()));
      if ((this$9 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
        var b$2 = this$9.s_util_Right__f_value;
        var keys = new $c_Lframework_data_WebPushSubscription$Keys(b$1, b$2);
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(new $c_Lframework_data_WebPushSubscription(b, keys));
      } else {
        return this$9;
      }
    } else {
      return this$5;
    }
  } else {
    return this$1;
  }
});
var $d_Lframework_exts_PushSubscriptionExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_PushSubscriptionExts$package$, "framework.exts.PushSubscriptionExts$package$", ({
  Lframework_exts_PushSubscriptionExts$package$: 1
}));
export { $d_Lframework_exts_PushSubscriptionExts$package$ as $d_Lframework_exts_PushSubscriptionExts$package$ };
var $n_Lframework_exts_PushSubscriptionExts$package$;
function $m_Lframework_exts_PushSubscriptionExts$package$() {
  if ((!$n_Lframework_exts_PushSubscriptionExts$package$)) {
    $n_Lframework_exts_PushSubscriptionExts$package$ = new $c_Lframework_exts_PushSubscriptionExts$package$();
  }
  return $n_Lframework_exts_PushSubscriptionExts$package$;
}
export { $m_Lframework_exts_PushSubscriptionExts$package$ as $m_Lframework_exts_PushSubscriptionExts$package$ };
/** @constructor */
function $c_Lframework_exts_PushSubscriptionOptions$package$() {
}
export { $c_Lframework_exts_PushSubscriptionOptions$package$ as $c_Lframework_exts_PushSubscriptionOptions$package$ };
$c_Lframework_exts_PushSubscriptionOptions$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_PushSubscriptionOptions$package$.prototype.constructor = $c_Lframework_exts_PushSubscriptionOptions$package$;
/** @constructor */
function $h_Lframework_exts_PushSubscriptionOptions$package$() {
}
export { $h_Lframework_exts_PushSubscriptionOptions$package$ as $h_Lframework_exts_PushSubscriptionOptions$package$ };
$h_Lframework_exts_PushSubscriptionOptions$package$.prototype = $c_Lframework_exts_PushSubscriptionOptions$package$.prototype;
$c_Lframework_exts_PushSubscriptionOptions$package$.prototype.asString__Lorg_scalajs_dom_PushSubscriptionOptions__T = (function(opts) {
  var $x_9 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
  var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["userVisibleOnly=", ", "]));
  var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
  var $x_8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
  var $x_7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$();
  var x = opts.userVisibleOnly;
  var $x_6 = ((x === (void 0)) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$() : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(x));
  var evidence$1 = $m_Lcats_instances_package$boolean$().Lcats_instances_package$boolean$__f_catsStdShowForBoolean;
  var this$12 = $m_Lcats_instances_package$option$();
  var $x_5 = $x_9.show$extension__s_StringContext__sci_Seq__T(sc, $x_8.genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($x_7.mat__O__Lcats_Show$ContravariantShow__T($x_6, new $c_Lcats_instances_OptionInstances$$anon$2(evidence$1, this$12)))])));
  var $x_4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
  var parts$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["key=", ""]));
  var sc$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts$1);
  var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
  var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$();
  var x$1 = opts.applicationServerKey;
  var this$22 = ((x$1 === (void 0)) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$() : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(x$1));
  if (this$22.isEmpty__Z()) {
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0 = this$22.get__O();
    var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($m_Lframework_utils_PushNotifications$PublicKey$().fromJs__sjs_js_typedarray_Uint8Array__Lframework_utils_PushNotifications$PublicKey(x0));
  }
  var evidence$1$1 = $m_Lframework_utils_PushNotifications$PublicKey$().given_Show_PublicKey__Lcats_Show();
  var this$24 = $m_Lcats_instances_package$option$();
  return (("" + $x_5) + $x_4.show$extension__s_StringContext__sci_Seq__T(sc$1, $x_3.genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($x_2.mat__O__Lcats_Show$ContravariantShow__T($x_1, new $c_Lcats_instances_OptionInstances$$anon$2(evidence$1$1, this$24)))]))));
});
var $d_Lframework_exts_PushSubscriptionOptions$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_PushSubscriptionOptions$package$, "framework.exts.PushSubscriptionOptions$package$", ({
  Lframework_exts_PushSubscriptionOptions$package$: 1
}));
export { $d_Lframework_exts_PushSubscriptionOptions$package$ as $d_Lframework_exts_PushSubscriptionOptions$package$ };
var $n_Lframework_exts_PushSubscriptionOptions$package$;
function $m_Lframework_exts_PushSubscriptionOptions$package$() {
  if ((!$n_Lframework_exts_PushSubscriptionOptions$package$)) {
    $n_Lframework_exts_PushSubscriptionOptions$package$ = new $c_Lframework_exts_PushSubscriptionOptions$package$();
  }
  return $n_Lframework_exts_PushSubscriptionOptions$package$;
}
export { $m_Lframework_exts_PushSubscriptionOptions$package$ as $m_Lframework_exts_PushSubscriptionOptions$package$ };
/** @constructor */
function $c_Lframework_exts_RequestDebugCounter$() {
  this.Lframework_exts_RequestDebugCounter$__f_counter = 0;
  this.Lframework_exts_RequestDebugCounter$__f_counter = 0;
}
export { $c_Lframework_exts_RequestDebugCounter$ as $c_Lframework_exts_RequestDebugCounter$ };
$c_Lframework_exts_RequestDebugCounter$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_RequestDebugCounter$.prototype.constructor = $c_Lframework_exts_RequestDebugCounter$;
/** @constructor */
function $h_Lframework_exts_RequestDebugCounter$() {
}
export { $h_Lframework_exts_RequestDebugCounter$ as $h_Lframework_exts_RequestDebugCounter$ };
$h_Lframework_exts_RequestDebugCounter$.prototype = $c_Lframework_exts_RequestDebugCounter$.prototype;
var $d_Lframework_exts_RequestDebugCounter$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_RequestDebugCounter$, "framework.exts.RequestDebugCounter$", ({
  Lframework_exts_RequestDebugCounter$: 1
}));
export { $d_Lframework_exts_RequestDebugCounter$ as $d_Lframework_exts_RequestDebugCounter$ };
var $n_Lframework_exts_RequestDebugCounter$;
function $m_Lframework_exts_RequestDebugCounter$() {
  if ((!$n_Lframework_exts_RequestDebugCounter$)) {
    $n_Lframework_exts_RequestDebugCounter$ = new $c_Lframework_exts_RequestDebugCounter$();
  }
  return $n_Lframework_exts_RequestDebugCounter$;
}
export { $m_Lframework_exts_RequestDebugCounter$ as $m_Lframework_exts_RequestDebugCounter$ };
/** @constructor */
function $c_Lframework_exts_RequestExts$package$() {
}
export { $c_Lframework_exts_RequestExts$package$ as $c_Lframework_exts_RequestExts$package$ };
$c_Lframework_exts_RequestExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_RequestExts$package$.prototype.constructor = $c_Lframework_exts_RequestExts$package$;
/** @constructor */
function $h_Lframework_exts_RequestExts$package$() {
}
export { $h_Lframework_exts_RequestExts$package$ as $h_Lframework_exts_RequestExts$package$ };
$h_Lframework_exts_RequestExts$package$.prototype = $c_Lframework_exts_RequestExts$package$.prototype;
$c_Lframework_exts_RequestExts$package$.prototype.withClientRequestTracing__Lsttp_client3_RequestT__Ljava_time_LocalDateTime__Lsttp_client3_RequestT = (function(req, now) {
  matchResult1: {
    var \u03b42$;
    var x1 = $m_Lframework_api_FrameworkHeaders$X$minusRequest$minusStarted$minusAt$().apply__Ljava_time_LocalDateTime__T2(now);
    if ((x1 !== null)) {
      var \u03b42$ = x1;
      break matchResult1;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1);
  }
  var name = \u03b42$._1__O();
  var value = \u03b42$._2__O();
  return req.header__T__T__Lsttp_client3_RequestT(name, value);
});
$c_Lframework_exts_RequestExts$package$.prototype.ioWithEndpointError__Lsttp_client3_RequestT__Lframework_sourcecode_DefinedAt__Lcats_data_EitherT = (function(req, x$2) {
  var id = $m_Lframework_exts_RequestDebugCounter$().Lframework_exts_RequestDebugCounter$__f_counter;
  var \u03b43$ = $m_Lframework_exts_RequestDebugCounter$();
  \u03b43$.Lframework_exts_RequestDebugCounter$__f_counter = ((1 + \u03b43$.Lframework_exts_RequestDebugCounter$__f_counter) | 0);
  var this$6 = $m_Lframework_prelude_log$();
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
  var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["req #", ""]));
  var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
  var scope = $x_1.show$extension__s_StringContext__sci_Seq__T(sc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(id, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$int$().Lcats_instances_package$int$__f_catsStdShowForInt))])));
  var reqLog = $f_Lframework_utils_JSLogger__scoped__T__Lframework_utils_JSLogger(this$6, scope);
  var this$8 = $m_Lcats_effect_IO$();
  var thunk = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
    var msg$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([("Sending request: " + req)]));
    var this$7 = $m_Lframework_prelude_client\uff3flogging$package$JSAppName$();
    var appName = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Newtype$WithoutValidation__apply__O__O(this$7, "app");
    var level = $s_Lframework_utils_LogLevel$__Default__Lframework_utils_LogLevel();
    reqLog.atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V(level, reqLog.scope__s_Option(), msg$1, x$2, appName);
  }));
  var this$20 = this$8.delay__F0__Lcats_effect_IO(thunk);
  var that = $m_Lframework_prelude_prelude\uff3fclient$package$().sttpBackend__Lsttp_client3_SttpBackend().send__Lsttp_client3_RequestT__O(req).map__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((response) => {
    var level$1 = (response.Lsttp_client3_Response__f_body.isLeft__Z() ? $s_Lframework_utils_LogLevel$__Error__Lframework_utils_LogLevel() : $s_Lframework_utils_LogLevel$__Info__Lframework_utils_LogLevel());
    var msg$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([("Received response: " + response)]));
    var this$9 = $m_Lframework_prelude_client\uff3flogging$package$JSAppName$();
    var appName$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Newtype$WithoutValidation__apply__O__O(this$9, "app");
    reqLog.atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V(level$1, reqLog.scope__s_Option(), msg$2, x$2, appName$1);
    matchResult4: {
      var normalizedBody;
      var x18 = response.Lsttp_client3_Response__f_body;
      if ((x18 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
        var x20 = x18.s_util_Left__f_value;
        if ((x20 instanceof $c_Lframework_utils_NetworkOrEndpointError$NetworkError)) {
          var x23 = x20.Lframework_utils_NetworkOrEndpointError$NetworkError__f_error;
          if ((x23 instanceof $c_Lframework_utils_NetworkError$DecodeError)) {
            var x26 = x23.Lframework_utils_NetworkError$DecodeError__f_failure;
            if ((!$m_Lsttp_model_StatusCode$().isSuccess$extension__I__Z(response.Lsttp_client3_Response__f_code))) {
              matchResult3: {
                var error;
                var x17 = response.Lsttp_client3_Response__f_code;
                if (($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_TooManyRequests === x17)) {
                  var error = new $c_Lframework_utils_NetworkError$RateLimited(x26);
                  break matchResult3;
                }
                var error = new $c_Lframework_utils_NetworkError$UnexpectedResponse(x17, x26);
              }
              var value = new $c_Lframework_utils_NetworkOrEndpointError$NetworkError(error);
              var normalizedBody = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value);
              break matchResult4;
            }
          }
        }
      }
      var normalizedBody = x18;
    }
    if ((normalizedBody instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
      var error$2 = normalizedBody.s_util_Left__f_value;
      var value$1 = new $c_Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError(error$2);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value$1);
    }
    if ((normalizedBody instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
      var value$2 = normalizedBody.s_util_Right__f_value;
      var code = response.Lsttp_client3_Response__f_code;
      var statusText = response.Lsttp_client3_Response__f_statusText;
      var headers = response.Lsttp_client3_Response__f_headers;
      var history = response.Lsttp_client3_Response__f_history;
      var request = response.Lsttp_client3_Response__f_request;
      var value$3 = new $c_Lsttp_client3_Response(value$2, code, statusText, headers, history, request);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value$3);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(normalizedBody);
  }))).recover__s_PartialFunction__Lcats_effect_IO(new $c_Lframework_exts_RequestExts$package$$anon$1(reqLog, x$2));
  var value$4 = this$20.productR__Lcats_effect_IO__Lcats_effect_IO(that);
  return new $c_Lcats_data_EitherT(value$4);
});
var $d_Lframework_exts_RequestExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_RequestExts$package$, "framework.exts.RequestExts$package$", ({
  Lframework_exts_RequestExts$package$: 1
}));
export { $d_Lframework_exts_RequestExts$package$ as $d_Lframework_exts_RequestExts$package$ };
var $n_Lframework_exts_RequestExts$package$;
function $m_Lframework_exts_RequestExts$package$() {
  if ((!$n_Lframework_exts_RequestExts$package$)) {
    $n_Lframework_exts_RequestExts$package$ = new $c_Lframework_exts_RequestExts$package$();
  }
  return $n_Lframework_exts_RequestExts$package$;
}
export { $m_Lframework_exts_RequestExts$package$ as $m_Lframework_exts_RequestExts$package$ };
/** @constructor */
function $c_Lframework_exts_RetryDetailsExts$package$RetryDetailsExts$() {
}
export { $c_Lframework_exts_RetryDetailsExts$package$RetryDetailsExts$ as $c_Lframework_exts_RetryDetailsExts$package$RetryDetailsExts$ };
$c_Lframework_exts_RetryDetailsExts$package$RetryDetailsExts$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_RetryDetailsExts$package$RetryDetailsExts$.prototype.constructor = $c_Lframework_exts_RetryDetailsExts$package$RetryDetailsExts$;
/** @constructor */
function $h_Lframework_exts_RetryDetailsExts$package$RetryDetailsExts$() {
}
export { $h_Lframework_exts_RetryDetailsExts$package$RetryDetailsExts$ as $h_Lframework_exts_RetryDetailsExts$package$RetryDetailsExts$ };
$h_Lframework_exts_RetryDetailsExts$package$RetryDetailsExts$.prototype = $c_Lframework_exts_RetryDetailsExts$package$RetryDetailsExts$.prototype;
$c_Lframework_exts_RetryDetailsExts$package$RetryDetailsExts$.prototype.asString$extension__Lretry_RetryDetails__T = (function(this$) {
  matchResult4: {
    var \u03b41$___1;
    var \u03b41$___2;
    var \u03b41$___3;
    if ((this$ !== null)) {
      var x11 = this$.Lretry_RetryDetails__f_retriesSoFar;
      var x12 = this$.Lretry_RetryDetails__f_cumulativeDelay;
      var x13 = this$.Lretry_RetryDetails__f_nextStepIfUnsuccessful;
      var \u03b41$___1 = x11;
      var \u03b41$___2 = x12;
      var \u03b41$___3 = x13;
      break matchResult4;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this$);
  }
  var retriesSoFar$2 = (\u03b41$___1 | 0);
  var cumulativeDelay$2 = \u03b41$___2;
  var nextStepIfUnsuccessful$2 = \u03b41$___3;
  var $x_7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
  var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["RetryDetails(retriesSoFar=", ", "]));
  var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
  var $x_6 = $x_7.show$extension__s_StringContext__sci_Seq__T(sc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(retriesSoFar$2, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$int$().Lcats_instances_package$int$__f_catsStdShowForInt))])));
  var $x_5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
  var parts$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["cumulativeDelay=", ", "]));
  var sc$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts$1);
  var $x_4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
  var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$();
  var strings = $m_Lframework_utils_PrettyPrintDuration$Strings$EnglishShortNoSpaces$();
  var $x_2 = $x_5.show$extension__s_StringContext__sci_Seq__T(sc$1, $x_4.genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($x_3.mat__O__Lcats_Show$ContravariantShow__T($m_Lframework_utils_PrettyPrintDuration$().prettyPrint__s_concurrent_duration_Duration__I__ju_concurrent_TimeUnit__Lframework_utils_PrettyPrintDuration$Strings__T(cumulativeDelay$2, ($m_Lframework_utils_PrettyPrintDuration$(), 2147483647), ($m_Lframework_utils_PrettyPrintDuration$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS), strings), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))])));
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
  var parts$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["nextStepIfUnsuccessful=", ")"]));
  var sc$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts$2);
  return ((("" + $x_6) + $x_2) + $x_1.show$extension__s_StringContext__sci_Seq__T(sc$2, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T($m_Lframework_exts_RetryDetailsExts$package$RetryDetailsNextStepExts$().asString$extension__Lretry_RetryDetails$NextStep__T(nextStepIfUnsuccessful$2), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))]))));
});
var $d_Lframework_exts_RetryDetailsExts$package$RetryDetailsExts$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_RetryDetailsExts$package$RetryDetailsExts$, "framework.exts.RetryDetailsExts$package$RetryDetailsExts$", ({
  Lframework_exts_RetryDetailsExts$package$RetryDetailsExts$: 1
}));
export { $d_Lframework_exts_RetryDetailsExts$package$RetryDetailsExts$ as $d_Lframework_exts_RetryDetailsExts$package$RetryDetailsExts$ };
var $n_Lframework_exts_RetryDetailsExts$package$RetryDetailsExts$;
function $m_Lframework_exts_RetryDetailsExts$package$RetryDetailsExts$() {
  if ((!$n_Lframework_exts_RetryDetailsExts$package$RetryDetailsExts$)) {
    $n_Lframework_exts_RetryDetailsExts$package$RetryDetailsExts$ = new $c_Lframework_exts_RetryDetailsExts$package$RetryDetailsExts$();
  }
  return $n_Lframework_exts_RetryDetailsExts$package$RetryDetailsExts$;
}
export { $m_Lframework_exts_RetryDetailsExts$package$RetryDetailsExts$ as $m_Lframework_exts_RetryDetailsExts$package$RetryDetailsExts$ };
/** @constructor */
function $c_Lframework_exts_RetryDetailsExts$package$RetryDetailsNextStepExts$() {
}
export { $c_Lframework_exts_RetryDetailsExts$package$RetryDetailsNextStepExts$ as $c_Lframework_exts_RetryDetailsExts$package$RetryDetailsNextStepExts$ };
$c_Lframework_exts_RetryDetailsExts$package$RetryDetailsNextStepExts$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_RetryDetailsExts$package$RetryDetailsNextStepExts$.prototype.constructor = $c_Lframework_exts_RetryDetailsExts$package$RetryDetailsNextStepExts$;
/** @constructor */
function $h_Lframework_exts_RetryDetailsExts$package$RetryDetailsNextStepExts$() {
}
export { $h_Lframework_exts_RetryDetailsExts$package$RetryDetailsNextStepExts$ as $h_Lframework_exts_RetryDetailsExts$package$RetryDetailsNextStepExts$ };
$h_Lframework_exts_RetryDetailsExts$package$RetryDetailsNextStepExts$.prototype = $c_Lframework_exts_RetryDetailsExts$package$RetryDetailsNextStepExts$.prototype;
$c_Lframework_exts_RetryDetailsExts$package$RetryDetailsNextStepExts$.prototype.asString$extension__Lretry_RetryDetails$NextStep__T = (function(this$) {
  var x = $s_Lretry_RetryDetails$NextStep$__GiveUp__Lretry_RetryDetails$NextStep();
  if (((x === null) ? (this$ === null) : x.equals__O__Z(this$))) {
    return "GiveUp";
  }
  if ((this$ instanceof $c_Lretry_RetryDetails$NextStep$DelayAndRetry)) {
    var x6 = this$.Lretry_RetryDetails$NextStep$DelayAndRetry__f_nextDelay;
    var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
    var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["DelayAndRetry(nextDelay=", ")"]));
    var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
    var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$();
    var strings = $m_Lframework_utils_PrettyPrintDuration$Strings$EnglishShortNoSpaces$();
    return $x_3.show$extension__s_StringContext__sci_Seq__T(sc, $x_2.genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($x_1.mat__O__Lcats_Show$ContravariantShow__T($m_Lframework_utils_PrettyPrintDuration$().prettyPrint__s_concurrent_duration_Duration__I__ju_concurrent_TimeUnit__Lframework_utils_PrettyPrintDuration$Strings__T(x6, ($m_Lframework_utils_PrettyPrintDuration$(), 2147483647), ($m_Lframework_utils_PrettyPrintDuration$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS), strings), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))])));
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this$);
});
var $d_Lframework_exts_RetryDetailsExts$package$RetryDetailsNextStepExts$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_RetryDetailsExts$package$RetryDetailsNextStepExts$, "framework.exts.RetryDetailsExts$package$RetryDetailsNextStepExts$", ({
  Lframework_exts_RetryDetailsExts$package$RetryDetailsNextStepExts$: 1
}));
export { $d_Lframework_exts_RetryDetailsExts$package$RetryDetailsNextStepExts$ as $d_Lframework_exts_RetryDetailsExts$package$RetryDetailsNextStepExts$ };
var $n_Lframework_exts_RetryDetailsExts$package$RetryDetailsNextStepExts$;
function $m_Lframework_exts_RetryDetailsExts$package$RetryDetailsNextStepExts$() {
  if ((!$n_Lframework_exts_RetryDetailsExts$package$RetryDetailsNextStepExts$)) {
    $n_Lframework_exts_RetryDetailsExts$package$RetryDetailsNextStepExts$ = new $c_Lframework_exts_RetryDetailsExts$package$RetryDetailsNextStepExts$();
  }
  return $n_Lframework_exts_RetryDetailsExts$package$RetryDetailsNextStepExts$;
}
export { $m_Lframework_exts_RetryDetailsExts$package$RetryDetailsNextStepExts$ as $m_Lframework_exts_RetryDetailsExts$package$RetryDetailsNextStepExts$ };
/** @constructor */
function $c_Lframework_exts_SignalCompanionExts$package$() {
}
export { $c_Lframework_exts_SignalCompanionExts$package$ as $c_Lframework_exts_SignalCompanionExts$package$ };
$c_Lframework_exts_SignalCompanionExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_SignalCompanionExts$package$.prototype.constructor = $c_Lframework_exts_SignalCompanionExts$package$;
/** @constructor */
function $h_Lframework_exts_SignalCompanionExts$package$() {
}
export { $h_Lframework_exts_SignalCompanionExts$package$ as $h_Lframework_exts_SignalCompanionExts$package$ };
$h_Lframework_exts_SignalCompanionExts$package$.prototype = $c_Lframework_exts_SignalCompanionExts$package$.prototype;
$c_Lframework_exts_SignalCompanionExts$package$.prototype.fromAuthRequestIO__Lcom_raquo_airstream_core_Signal$__Lcats_data_EitherT__Lcom_raquo_airstream_core_Signal = (function(obj, io) {
  return $m_Lframework_exts_SignalCompanionExts$package$().fromAuthRequestReturningOptionIO__Lcom_raquo_airstream_core_Signal$__Lcats_data_EitherT__Lcom_raquo_airstream_core_Signal(obj, io.map__F1__Lcats_Functor__Lcats_data_EitherT(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$4) => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(_$4))), $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO));
});
$c_Lframework_exts_SignalCompanionExts$package$.prototype.fromAuthRequestFutureReturningOption__Lcom_raquo_airstream_core_Signal$__F0__Lcom_raquo_airstream_core_Signal = (function(obj, future) {
  var this$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_Signal$().fromFuture__F0__s_concurrent_ExecutionContext__Lcom_raquo_airstream_core_Signal(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => future.apply__O().Lcats_data_EitherT__f_value)), $m_Lframework_prelude_prelude\uff3fclient$package$().executionContext__s_concurrent_ExecutionContext());
  var project = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1) => {
    matchResult2: {
      var $x_1;
      matchAlts3: {
        matchAlts4: {
          var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
          if ((x === x$1)) {
            break matchAlts4;
          }
          if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
            var x55 = x$1.s_Some__f_value;
            if ((x55 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
              var x$3 = $s_Lframework_utils_AuthenticatedNetworkRequestFailure$__Aborted__Lframework_utils_AuthenticatedNetworkRequestFailure();
              var x$4 = x55.s_util_Left__f_value;
              if (((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))) {
                break matchAlts4;
              }
            }
          }
          break matchAlts3;
        }
        var $x_1 = $m_Lframework_data_AuthLoadingStatus$Loading$();
        break matchResult2;
      }
      if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
        var x45 = x$1.s_Some__f_value;
        if ((x45 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
          var x47 = x45.s_util_Left__f_value;
          if ((x47 instanceof $c_Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError)) {
            var x50 = x47.Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError__f_err;
            if ((x50 instanceof $c_Lframework_utils_NetworkOrEndpointError$NetworkError)) {
              var $x_1 = $m_Lframework_data_AuthLoadingStatus$NetworkError$();
              break matchResult2;
            }
            if ((x50 instanceof $c_Lframework_utils_NetworkOrEndpointError$EndpointError)) {
              var $x_1 = $m_Lframework_data_AuthLoadingStatus$Unauthenticated$();
              break matchResult2;
            }
          }
        }
        if ((x45 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
          var x33 = x45.s_util_Right__f_value;
          var x$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
          if ((x$5 === x33)) {
            var $x_1 = $m_Lframework_data_AuthLoadingStatus$NotFound$();
            break matchResult2;
          }
          if ((x33 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
            var value = x33.s_Some__f_value;
            var $x_1 = new $c_Lframework_data_AuthLoadingStatus$Loaded(value);
            break matchResult2;
          }
        }
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    }
    return $x_1;
  }));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), this$5, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lframework_exts_SignalCompanionExts$package$.prototype.fromAuthRequestReturningOptionIO__Lcom_raquo_airstream_core_Signal$__Lcats_data_EitherT__Lcom_raquo_airstream_core_Signal = (function(obj, io) {
  return $m_Lframework_exts_SignalCompanionExts$package$().fromAuthRequestFutureReturningOption__Lcom_raquo_airstream_core_Signal$__F0__Lcom_raquo_airstream_core_Signal(obj, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => io.mapK__Lcats_arrow_FunctionK__Lcats_data_EitherT($m_Lframework_prelude_prelude\uff3fclient$package$().ioToFutureFunctionK__Lcats_arrow_FunctionK()))));
});
$c_Lframework_exts_SignalCompanionExts$package$.prototype.fromPolling__Lcom_raquo_airstream_core_Signal$__s_concurrent_duration_FiniteDuration__F0__Lcom_raquo_airstream_core_Signal = (function(obj, period, f) {
  var this$4 = $m_Lframework_exts_EventStreamExts$package$().frameworkEventStreamExts__Lframework_exts_EventStreamExts();
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_EventStream$();
  var a = period.s_concurrent_duration_FiniteDuration__f_unit.toMillis__J__J(period.s_concurrent_duration_FiniteDuration__f_length);
  var stream = $x_1.periodic__I__Z__Lcom_raquo_airstream_timing_PeriodicStream(a.RTLong__f_lo, ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_EventStream$(), false));
  return $f_Lframework_exts_EventStreamExts__mapToSignal__Lcom_raquo_airstream_core_EventStream__F0__Lcom_raquo_airstream_core_Signal(this$4, stream, f);
});
$c_Lframework_exts_SignalCompanionExts$package$.prototype.fromPollingFuture__Lcom_raquo_airstream_core_Signal$__s_concurrent_duration_FiniteDuration__F0__F0__Lcom_raquo_airstream_core_Signal = (function(obj, period, initial, f) {
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_EventStream$();
  var a = period.s_concurrent_duration_FiniteDuration__f_unit.toMillis__J__J(period.s_concurrent_duration_FiniteDuration__f_length);
  var this$6 = $x_1.periodic__I__Z__Lcom_raquo_airstream_timing_PeriodicStream(a.RTLong__f_lo, ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_EventStream$(), false));
  var project = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$5) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_EventStream$().fromFuture__F0__Z__s_concurrent_ExecutionContext__Lcom_raquo_airstream_core_EventStream(f, ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_EventStream$(), false), $m_Lframework_prelude_prelude\uff3fclient$package$().executionContext__s_concurrent_ExecutionContext())));
  var strategy = $m_Lcom_raquo_airstream_core_Observable$().Lcom_raquo_airstream_core_Observable$__f_switchStreamStrategy;
  var \u03b41$ = strategy.flatten__Lcom_raquo_airstream_core_Observable__Lcom_raquo_airstream_core_Observable(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapStream(this$6, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_EventStream__toSignal__F0__Z__Lcom_raquo_airstream_core_Signal(\u03b41$, initial, false);
});
$c_Lframework_exts_SignalCompanionExts$package$.prototype.fromPollingFuture__Lcom_raquo_airstream_core_Signal$__s_concurrent_duration_FiniteDuration__F0__Lcom_raquo_airstream_core_Signal = (function(obj, period, f) {
  return $m_Lframework_exts_SignalCompanionExts$package$().fromPollingFuture__Lcom_raquo_airstream_core_Signal$__s_concurrent_duration_FiniteDuration__F0__F0__Lcom_raquo_airstream_core_Signal(obj, period, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$())), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => f.apply__O().map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$6) => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(_$6))), $m_Lframework_prelude_prelude\uff3fclient$package$().executionContext__s_concurrent_ExecutionContext()))));
});
var $d_Lframework_exts_SignalCompanionExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_SignalCompanionExts$package$, "framework.exts.SignalCompanionExts$package$", ({
  Lframework_exts_SignalCompanionExts$package$: 1
}));
export { $d_Lframework_exts_SignalCompanionExts$package$ as $d_Lframework_exts_SignalCompanionExts$package$ };
var $n_Lframework_exts_SignalCompanionExts$package$;
function $m_Lframework_exts_SignalCompanionExts$package$() {
  if ((!$n_Lframework_exts_SignalCompanionExts$package$)) {
    $n_Lframework_exts_SignalCompanionExts$package$ = new $c_Lframework_exts_SignalCompanionExts$package$();
  }
  return $n_Lframework_exts_SignalCompanionExts$package$;
}
export { $m_Lframework_exts_SignalCompanionExts$package$ as $m_Lframework_exts_SignalCompanionExts$package$ };
function $f_Lframework_exts_SignalExts__toEventStream__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_core_EventStream($thiz, signal) {
  var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_EventStream$();
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_EventStream$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_EventStream$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_EventStream$();
  var emitOnce = false;
  var stream = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_EventStream$().fromValue__O__Z__Lcom_raquo_airstream_core_EventStream((void 0), emitOnce);
  return $x_2.merge__sci_Seq__Lcom_raquo_airstream_core_EventStream($x_1.wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcom_raquo_airstream_core_EventStream.getArrayOf().constr)([$m_Lcom_raquo_airstream_combine_generated_CombinableStream$().sample$extension__Lcom_raquo_airstream_core_EventStream__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_EventStream(stream, signal), new $c_Lcom_raquo_airstream_misc_StreamFromSignal(signal, true)])));
}
export { $f_Lframework_exts_SignalExts__toEventStream__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_core_EventStream as $f_Lframework_exts_SignalExts__toEventStream__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_core_EventStream };
function $f_Lframework_exts_SignalExts__changedValues__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_core_Signal($thiz, signal) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_Signal__scanLeft__F1__F2__Lcom_raquo_airstream_core_Signal(signal, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((a) => {
    var _1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, a);
  })), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((x$1, x$2) => {
    var x1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), x$1, x$2);
    var x2 = x1.T2__f__1;
    if ((x2 !== null)) {
      var previous = x2._2__O();
      var current = x1.T2__f__2;
      var _1$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(previous);
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1$1, current);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1);
  })));
}
export { $f_Lframework_exts_SignalExts__changedValues__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_core_Signal as $f_Lframework_exts_SignalExts__changedValues__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_core_Signal };
function $f_Lframework_exts_SignalExts__sequentially__Lcom_raquo_airstream_core_Signal__F1__Lcom_raquo_airstream_core_Signal($thiz, signal, f) {
  var Idle$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_LazyRef();
  var Running$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_LazyRef();
  var lastEvt = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_state_Var$().apply__O__Lcom_raquo_airstream_state_Var($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var elem = $ps_Lframework_exts_SignalExts__Idle$1__sr_LazyRef__Lframework_exts_SignalExts$Idle$2$(Idle$lzy1);
  var current = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_ObjectRef(elem);
  var Idle$lzy1$2$1 = Idle$lzy1;
  var Running$lzy1$2$1 = Running$lzy1;
  var project = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((Idle$lzy1$2, Running$lzy1$2) => ((a) => {
    $p_Lframework_exts_SignalExts__onSourceValue$1__sr_ObjectRef__sr_LazyRef__F1__Lcom_raquo_airstream_state_Var__sr_LazyRef__O__V($thiz, current, Idle$lzy1$2, f, lastEvt, Running$lzy1$2, a);
    return lastEvt.signal__Lcom_raquo_airstream_state_StrictSignal();
  }))(Idle$lzy1$2$1, Running$lzy1$2$1));
  var strategy = $m_Lcom_raquo_airstream_core_Observable$().Lcom_raquo_airstream_core_Observable$__f_switchSignalStrategy;
  return strategy.flatten__Lcom_raquo_airstream_core_Observable__Lcom_raquo_airstream_core_Observable($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), signal, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()));
}
export { $f_Lframework_exts_SignalExts__sequentially__Lcom_raquo_airstream_core_Signal__F1__Lcom_raquo_airstream_core_Signal as $f_Lframework_exts_SignalExts__sequentially__Lcom_raquo_airstream_core_Signal__F1__Lcom_raquo_airstream_core_Signal };
function $ps_Lframework_exts_SignalExts__Idle$lzyINIT1$1__sr_LazyRef__Lframework_exts_SignalExts$Idle$2$(Idle$lzy1$1) {
  return (Idle$lzy1$1.sr_LazyRef__f__initialized ? Idle$lzy1$1.sr_LazyRef__f__value : Idle$lzy1$1.initialize__O__O(new $c_Lframework_exts_SignalExts$Idle$2$()));
}
export { $ps_Lframework_exts_SignalExts__Idle$lzyINIT1$1__sr_LazyRef__Lframework_exts_SignalExts$Idle$2$ as $ps_Lframework_exts_SignalExts__Idle$lzyINIT1$1__sr_LazyRef__Lframework_exts_SignalExts$Idle$2$ };
function $ps_Lframework_exts_SignalExts__Idle$1__sr_LazyRef__Lframework_exts_SignalExts$Idle$2$(Idle$lzy1$2) {
  return (Idle$lzy1$2.sr_LazyRef__f__initialized ? Idle$lzy1$2.sr_LazyRef__f__value : $ps_Lframework_exts_SignalExts__Idle$lzyINIT1$1__sr_LazyRef__Lframework_exts_SignalExts$Idle$2$(Idle$lzy1$2));
}
export { $ps_Lframework_exts_SignalExts__Idle$1__sr_LazyRef__Lframework_exts_SignalExts$Idle$2$ as $ps_Lframework_exts_SignalExts__Idle$1__sr_LazyRef__Lframework_exts_SignalExts$Idle$2$ };
function $p_Lframework_exts_SignalExts__Running$lzyINIT1$1__sr_LazyRef__Lframework_exts_SignalExts$Running$3$($thiz, Running$lzy1$1) {
  return (Running$lzy1$1.sr_LazyRef__f__initialized ? Running$lzy1$1.sr_LazyRef__f__value : Running$lzy1$1.initialize__O__O(new $c_Lframework_exts_SignalExts$Running$3$($thiz)));
}
export { $p_Lframework_exts_SignalExts__Running$lzyINIT1$1__sr_LazyRef__Lframework_exts_SignalExts$Running$3$ as $p_Lframework_exts_SignalExts__Running$lzyINIT1$1__sr_LazyRef__Lframework_exts_SignalExts$Running$3$ };
function $p_Lframework_exts_SignalExts__Running$2__sr_LazyRef__Lframework_exts_SignalExts$Running$3$($thiz, Running$lzy1$2) {
  return (Running$lzy1$2.sr_LazyRef__f__initialized ? Running$lzy1$2.sr_LazyRef__f__value : $p_Lframework_exts_SignalExts__Running$lzyINIT1$1__sr_LazyRef__Lframework_exts_SignalExts$Running$3$($thiz, Running$lzy1$2));
}
export { $p_Lframework_exts_SignalExts__Running$2__sr_LazyRef__Lframework_exts_SignalExts$Running$3$ as $p_Lframework_exts_SignalExts__Running$2__sr_LazyRef__Lframework_exts_SignalExts$Running$3$ };
function $ps_Lframework_exts_SignalExts__pullNextFromQueue$1__sr_ObjectRef__sr_LazyRef__F1__Lcom_raquo_airstream_state_Var__V(current$1, Idle$lzy1$3, f$1, lastEvt$1) {
  var x20 = current$1.sr_ObjectRef__f_elem;
  if ((x20 instanceof $c_Lframework_exts_SignalExts$Running$1)) {
    var x15 = x20.tryDequeue__s_Option();
    var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    if ((x === x15)) {
      current$1.sr_ObjectRef__f_elem = $ps_Lframework_exts_SignalExts__Idle$1__sr_LazyRef__Lframework_exts_SignalExts$Idle$2$(Idle$lzy1$3);
      return (void 0);
    }
    if ((x15 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var x17 = x15.s_Some__f_value;
      if ((x17 !== null)) {
        var a = x17._1__O();
        var next = x17._2__O();
        current$1.sr_ObjectRef__f_elem = next;
        $ps_Lframework_exts_SignalExts__launch$1__F1__Lcom_raquo_airstream_state_Var__sr_ObjectRef__sr_LazyRef__O__V(f$1, lastEvt$1, current$1, Idle$lzy1$3, a);
        return (void 0);
      }
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x15);
  }
  var x$3 = $ps_Lframework_exts_SignalExts__Idle$1__sr_LazyRef__Lframework_exts_SignalExts$Idle$2$(Idle$lzy1$3);
  if ((x$3 === x20)) {
    return (void 0);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x20);
}
export { $ps_Lframework_exts_SignalExts__pullNextFromQueue$1__sr_ObjectRef__sr_LazyRef__F1__Lcom_raquo_airstream_state_Var__V as $ps_Lframework_exts_SignalExts__pullNextFromQueue$1__sr_ObjectRef__sr_LazyRef__F1__Lcom_raquo_airstream_state_Var__V };
function $ps_Lframework_exts_SignalExts__launch$1__F1__Lcom_raquo_airstream_state_Var__sr_ObjectRef__sr_LazyRef__O__V(f$2, lastEvt$2, current$2, Idle$lzy1$4, a) {
  var future = f$2.apply__O__O(a);
  future.onComplete__F1__s_concurrent_ExecutionContext__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1) => {
    matchResult10: {
      if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure)) {
        var err = x$1.s_util_Failure__f_exception;
        lastEvt$2.writer__Lcom_raquo_airstream_core_Observer().onError__jl_Throwable__V(err);
        $ps_Lframework_exts_SignalExts__pullNextFromQueue$1__sr_ObjectRef__sr_LazyRef__F1__Lcom_raquo_airstream_state_Var__V(current$2, Idle$lzy1$4, f$2, lastEvt$2);
        break matchResult10;
      }
      if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success)) {
        var b = x$1.s_util_Success__f_value;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_state_Var__set__O__V(lastEvt$2, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(b));
        $ps_Lframework_exts_SignalExts__pullNextFromQueue$1__sr_ObjectRef__sr_LazyRef__F1__Lcom_raquo_airstream_state_Var__V(current$2, Idle$lzy1$4, f$2, lastEvt$2);
        break matchResult10;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    }
  })), $m_Lframework_prelude_prelude\uff3fclient$package$().executionContext__s_concurrent_ExecutionContext());
}
export { $ps_Lframework_exts_SignalExts__launch$1__F1__Lcom_raquo_airstream_state_Var__sr_ObjectRef__sr_LazyRef__O__V as $ps_Lframework_exts_SignalExts__launch$1__F1__Lcom_raquo_airstream_state_Var__sr_ObjectRef__sr_LazyRef__O__V };
function $p_Lframework_exts_SignalExts__onSourceValue$1__sr_ObjectRef__sr_LazyRef__F1__Lcom_raquo_airstream_state_Var__sr_LazyRef__O__V($thiz, current$4, Idle$lzy1$6, f$4, lastEvt$4, Running$lzy1$3, a) {
  matchResult11: {
    var $x_1;
    var x27 = current$4.sr_ObjectRef__f_elem;
    if ((x27 === $ps_Lframework_exts_SignalExts__Idle$1__sr_LazyRef__Lframework_exts_SignalExts$Idle$2$(Idle$lzy1$6))) {
      $ps_Lframework_exts_SignalExts__launch$1__F1__Lcom_raquo_airstream_state_Var__sr_ObjectRef__sr_LazyRef__O__V(f$4, lastEvt$4, current$4, Idle$lzy1$6, a);
      var $x_1 = $p_Lframework_exts_SignalExts__Running$2__sr_LazyRef__Lframework_exts_SignalExts$Running$3$($thiz, Running$lzy1$3).apply__sci_Queue__Lframework_exts_SignalExts$Running$1($m_sci_Queue$EmptyQueue$());
      break matchResult11;
    }
    if ((x27 instanceof $c_Lframework_exts_SignalExts$Running$1)) {
      var $x_1 = x27.enqueue__O__Lframework_exts_SignalExts$Running$1(a);
      break matchResult11;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x27);
  }
  current$4.sr_ObjectRef__f_elem = $x_1;
}
export { $p_Lframework_exts_SignalExts__onSourceValue$1__sr_ObjectRef__sr_LazyRef__F1__Lcom_raquo_airstream_state_Var__sr_LazyRef__O__V as $p_Lframework_exts_SignalExts__onSourceValue$1__sr_ObjectRef__sr_LazyRef__F1__Lcom_raquo_airstream_state_Var__sr_LazyRef__O__V };
/** @constructor */
function $c_Lframework_exts_SignalExts$package$() {
  this.Lframework_exts_SignalExts$package$__f_frameworkSignalExts$lzy1 = null;
  this.Lframework_exts_SignalExts$package$__f_frameworkSignalExtsbitmap$1 = false;
  this.Lframework_exts_SignalExts$package$__f_frameworkSignalOptionExts$lzy1 = null;
  this.Lframework_exts_SignalExts$package$__f_frameworkSignalOptionExtsbitmap$1 = false;
}
export { $c_Lframework_exts_SignalExts$package$ as $c_Lframework_exts_SignalExts$package$ };
$c_Lframework_exts_SignalExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_SignalExts$package$.prototype.constructor = $c_Lframework_exts_SignalExts$package$;
/** @constructor */
function $h_Lframework_exts_SignalExts$package$() {
}
export { $h_Lframework_exts_SignalExts$package$ as $h_Lframework_exts_SignalExts$package$ };
$h_Lframework_exts_SignalExts$package$.prototype = $c_Lframework_exts_SignalExts$package$.prototype;
$c_Lframework_exts_SignalExts$package$.prototype.frameworkSignalExts__Lframework_exts_SignalExts = (function() {
  if ((!this.Lframework_exts_SignalExts$package$__f_frameworkSignalExtsbitmap$1)) {
    this.Lframework_exts_SignalExts$package$__f_frameworkSignalExts$lzy1 = new $c_Lframework_exts_SignalExts$package$$anon$1();
    this.Lframework_exts_SignalExts$package$__f_frameworkSignalExtsbitmap$1 = true;
  }
  return this.Lframework_exts_SignalExts$package$__f_frameworkSignalExts$lzy1;
});
$c_Lframework_exts_SignalExts$package$.prototype.frameworkSignalOptionExts__Lframework_exts_SignalOptionExts = (function() {
  if ((!this.Lframework_exts_SignalExts$package$__f_frameworkSignalOptionExtsbitmap$1)) {
    this.Lframework_exts_SignalExts$package$__f_frameworkSignalOptionExts$lzy1 = new $c_Lframework_exts_SignalExts$package$$anon$2();
    this.Lframework_exts_SignalExts$package$__f_frameworkSignalOptionExtsbitmap$1 = true;
  }
  return this.Lframework_exts_SignalExts$package$__f_frameworkSignalOptionExts$lzy1;
});
var $d_Lframework_exts_SignalExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_SignalExts$package$, "framework.exts.SignalExts$package$", ({
  Lframework_exts_SignalExts$package$: 1
}));
export { $d_Lframework_exts_SignalExts$package$ as $d_Lframework_exts_SignalExts$package$ };
var $n_Lframework_exts_SignalExts$package$;
function $m_Lframework_exts_SignalExts$package$() {
  if ((!$n_Lframework_exts_SignalExts$package$)) {
    $n_Lframework_exts_SignalExts$package$ = new $c_Lframework_exts_SignalExts$package$();
  }
  return $n_Lframework_exts_SignalExts$package$;
}
export { $m_Lframework_exts_SignalExts$package$ as $m_Lframework_exts_SignalExts$package$ };
/** @constructor */
function $c_Lframework_exts_SignalOfBooleanExts$package$() {
}
export { $c_Lframework_exts_SignalOfBooleanExts$package$ as $c_Lframework_exts_SignalOfBooleanExts$package$ };
$c_Lframework_exts_SignalOfBooleanExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_SignalOfBooleanExts$package$.prototype.constructor = $c_Lframework_exts_SignalOfBooleanExts$package$;
/** @constructor */
function $h_Lframework_exts_SignalOfBooleanExts$package$() {
}
export { $h_Lframework_exts_SignalOfBooleanExts$package$ as $h_Lframework_exts_SignalOfBooleanExts$package$ };
$h_Lframework_exts_SignalOfBooleanExts$package$.prototype = $c_Lframework_exts_SignalOfBooleanExts$package$.prototype;
$c_Lframework_exts_SignalOfBooleanExts$package$.prototype.splitBooleanAsOption__Lcom_raquo_airstream_core_Signal__F1__Lcom_raquo_airstream_core_Signal = (function(signal, whenTrue) {
  var project = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$1) => {
    var _$1$1 = (!(!_$1));
    return (_$1$1 ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some((void 0)) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  }));
  var signal$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), signal, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  return $m_Lcom_raquo_airstream_extensions_OptionSignal$().splitOption$extension__Lcom_raquo_airstream_core_Signal__F2__Lcom_raquo_airstream_core_Signal(signal$1, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((_$2, signal$2) => whenTrue.apply__O__O(signal$2))));
});
$c_Lframework_exts_SignalOfBooleanExts$package$.prototype.splitBooleanOrEmpty__Lcom_raquo_airstream_core_Signal__F1__Lalleycats_Empty__Lcom_raquo_airstream_core_Signal = (function(signal, whenTrue, empty) {
  return $m_Lcom_raquo_airstream_extensions_BooleanSignal$().splitBoolean$extension__Lcom_raquo_airstream_core_Signal__F1__F1__Lcom_raquo_airstream_core_Signal(signal, whenTrue, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$3) => empty.empty__O())));
});
var $d_Lframework_exts_SignalOfBooleanExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_SignalOfBooleanExts$package$, "framework.exts.SignalOfBooleanExts$package$", ({
  Lframework_exts_SignalOfBooleanExts$package$: 1
}));
export { $d_Lframework_exts_SignalOfBooleanExts$package$ as $d_Lframework_exts_SignalOfBooleanExts$package$ };
var $n_Lframework_exts_SignalOfBooleanExts$package$;
function $m_Lframework_exts_SignalOfBooleanExts$package$() {
  if ((!$n_Lframework_exts_SignalOfBooleanExts$package$)) {
    $n_Lframework_exts_SignalOfBooleanExts$package$ = new $c_Lframework_exts_SignalOfBooleanExts$package$();
  }
  return $n_Lframework_exts_SignalOfBooleanExts$package$;
}
export { $m_Lframework_exts_SignalOfBooleanExts$package$ as $m_Lframework_exts_SignalOfBooleanExts$package$ };
function $f_Lframework_exts_SignalOptionExts__mapSomeOpt__Lcom_raquo_airstream_core_Signal__F1__Lcom_raquo_airstream_core_Signal($thiz, signal, f) {
  var project = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$2) => (_$2.isEmpty__Z() ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$() : f.apply__O__O(_$2.get__O()))));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), signal, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
}
export { $f_Lframework_exts_SignalOptionExts__mapSomeOpt__Lcom_raquo_airstream_core_Signal__F1__Lcom_raquo_airstream_core_Signal as $f_Lframework_exts_SignalOptionExts__mapSomeOpt__Lcom_raquo_airstream_core_Signal__F1__Lcom_raquo_airstream_core_Signal };
function $f_Lframework_exts_SignalOptionExts__toIOOnSome__Lcom_raquo_airstream_core_Signal__Lcats_effect_IO($thiz, signal) {
  var this$2 = $m_Lframework_exts_ObservableExts$package$().frameworkObservableExts__Lframework_exts_ObservableExts();
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x) => x));
  return $f_Lframework_exts_ObservableExts__toIOMapFilter__Lcom_raquo_airstream_core_Observable__F1__Lcats_effect_IO(this$2, signal, f);
}
export { $f_Lframework_exts_SignalOptionExts__toIOOnSome__Lcom_raquo_airstream_core_Signal__Lcats_effect_IO as $f_Lframework_exts_SignalOptionExts__toIOOnSome__Lcom_raquo_airstream_core_Signal__Lcats_effect_IO };
function $f_Lframework_exts_SignalOptionExts__splitOptionOrEmpty__Lcom_raquo_airstream_core_Signal__F2__Lalleycats_Empty__Lcom_raquo_airstream_core_Signal($thiz, signal, f, empty) {
  return $m_Lcom_raquo_airstream_extensions_OptionSignal$().splitOption$extension__Lcom_raquo_airstream_core_Signal__F2__F0__Lcom_raquo_airstream_core_Signal(signal, f, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => empty.empty__O())));
}
export { $f_Lframework_exts_SignalOptionExts__splitOptionOrEmpty__Lcom_raquo_airstream_core_Signal__F2__Lalleycats_Empty__Lcom_raquo_airstream_core_Signal as $f_Lframework_exts_SignalOptionExts__splitOptionOrEmpty__Lcom_raquo_airstream_core_Signal__F2__Lalleycats_Empty__Lcom_raquo_airstream_core_Signal };
/** @constructor */
function $c_Lframework_exts_ThrowableExts$package$() {
}
export { $c_Lframework_exts_ThrowableExts$package$ as $c_Lframework_exts_ThrowableExts$package$ };
$c_Lframework_exts_ThrowableExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_ThrowableExts$package$.prototype.constructor = $c_Lframework_exts_ThrowableExts$package$;
/** @constructor */
function $h_Lframework_exts_ThrowableExts$package$() {
}
export { $h_Lframework_exts_ThrowableExts$package$ as $h_Lframework_exts_ThrowableExts$package$ };
$h_Lframework_exts_ThrowableExts$package$.prototype = $c_Lframework_exts_ThrowableExts$package$.prototype;
$c_Lframework_exts_ThrowableExts$package$.prototype.causes__jl_Throwable__sci_List = (function(t) {
  var elems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_jl_Throwable.getArrayOf().constr)([t]));
  var causes = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_ListBuffer().scala$collection$mutable$ListBuffer$$freshFrom__sc_IterableOnce__scm_ListBuffer(elems);
  var current = t;
  while (true) {
    var this$2 = current;
    if ((this$2.jl_Throwable__f_e !== null)) {
      var this$3 = current;
      current = this$3.jl_Throwable__f_e;
      var elem = current;
      causes.addOne__O__scm_ListBuffer(elem);
    } else {
      break;
    }
  }
  return causes.toList__sci_List();
});
$c_Lframework_exts_ThrowableExts$package$.prototype.errorWithCausesAndStacktracesString__jl_Throwable__T = (function(t) {
  var this$1 = $m_Lframework_exts_ThrowableExts$package$().causes__jl_Throwable__sci_List(t);
  var errors = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(t, this$1);
  var this$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_StrictOptimizedLinearSeqOps$$anon$1(errors);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((err) => {
    var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef(err.getStackTrace__Ajl_StackTraceElement());
    var x = (((("|" + err) + "\n            |  ### Stacktrace ###\n            |  # ") + $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__mkString__T__T__T__T(this$2, "", "\n  # ", "")) + "\n            |");
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_StringOps$().stripMargin$extension__T__C__T(x, 124);
  }));
  var this$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(this$5, f);
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__mkString__T__T__T__T(this$6, "", "\n  caused by\n", "");
});
var $d_Lframework_exts_ThrowableExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_ThrowableExts$package$, "framework.exts.ThrowableExts$package$", ({
  Lframework_exts_ThrowableExts$package$: 1
}));
export { $d_Lframework_exts_ThrowableExts$package$ as $d_Lframework_exts_ThrowableExts$package$ };
var $n_Lframework_exts_ThrowableExts$package$;
function $m_Lframework_exts_ThrowableExts$package$() {
  if ((!$n_Lframework_exts_ThrowableExts$package$)) {
    $n_Lframework_exts_ThrowableExts$package$ = new $c_Lframework_exts_ThrowableExts$package$();
  }
  return $n_Lframework_exts_ThrowableExts$package$;
}
export { $m_Lframework_exts_ThrowableExts$package$ as $m_Lframework_exts_ThrowableExts$package$ };
/** @constructor */
function $c_Lframework_facades_PWAInstallElement$() {
}
export { $c_Lframework_facades_PWAInstallElement$ as $c_Lframework_facades_PWAInstallElement$ };
$c_Lframework_facades_PWAInstallElement$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_facades_PWAInstallElement$.prototype.constructor = $c_Lframework_facades_PWAInstallElement$;
/** @constructor */
function $h_Lframework_facades_PWAInstallElement$() {
}
export { $h_Lframework_facades_PWAInstallElement$ as $h_Lframework_facades_PWAInstallElement$ };
$h_Lframework_facades_PWAInstallElement$.prototype = $c_Lframework_facades_PWAInstallElement$.prototype;
$c_Lframework_facades_PWAInstallElement$.prototype.isMobile__Lframework_facades_PWAInstallElement__Z = (function(pwa) {
  return (((!(!pwa.isAndroid)) || (!(!pwa.isAndroidFallback))) || (!(!pwa.isAppleMobilePlatform)));
});
$c_Lframework_facades_PWAInstallElement$.prototype.create__T__T__T__Z__s_Option__Z__Z__s_Option__Z__Lframework_facades_PWAInstallElement = (function(manifestUrl, name, icon, useLocalStorage, installDescription, disableInstallDescription, disableScreenshots, description, disableClose) {
  this.makeSureIsInitialized__V();
  var elem = document.createElement("pwa-install");
  if (useLocalStorage) {
    elem.setAttribute("use-local-storage", "true");
  }
  if ((!installDescription.isEmpty__Z())) {
    var x0 = installDescription.get__O();
    elem.setAttribute("install-description", x0);
  }
  if (disableInstallDescription) {
    elem.setAttribute("disable-install-description", "true");
  }
  if (disableScreenshots) {
    elem.setAttribute("disable-screenshots", "true");
  }
  elem.setAttribute("manifest-url", manifestUrl);
  elem.setAttribute("name", name);
  elem.setAttribute("icon", icon);
  if ((!description.isEmpty__Z())) {
    var x0$1 = description.get__O();
    elem.setAttribute("description", x0$1);
  }
  if (disableClose) {
    elem.setAttribute("disable-close", "true");
  }
  return elem;
});
$c_Lframework_facades_PWAInstallElement$.prototype.makeSureIsInitialized__V = (function() {
  $i_$0040khmyznikov$002fpwa$002dinstall;
});
var $d_Lframework_facades_PWAInstallElement$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_facades_PWAInstallElement$, "framework.facades.PWAInstallElement$", ({
  Lframework_facades_PWAInstallElement$: 1
}));
export { $d_Lframework_facades_PWAInstallElement$ as $d_Lframework_facades_PWAInstallElement$ };
var $n_Lframework_facades_PWAInstallElement$;
function $m_Lframework_facades_PWAInstallElement$() {
  if ((!$n_Lframework_facades_PWAInstallElement$)) {
    $n_Lframework_facades_PWAInstallElement$ = new $c_Lframework_facades_PWAInstallElement$();
  }
  return $n_Lframework_facades_PWAInstallElement$;
}
export { $m_Lframework_facades_PWAInstallElement$ as $m_Lframework_facades_PWAInstallElement$ };
/** @constructor */
function $c_Lframework_prelude_alleycats$package$() {
}
export { $c_Lframework_prelude_alleycats$package$ as $c_Lframework_prelude_alleycats$package$ };
$c_Lframework_prelude_alleycats$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_prelude_alleycats$package$.prototype.constructor = $c_Lframework_prelude_alleycats$package$;
/** @constructor */
function $h_Lframework_prelude_alleycats$package$() {
}
export { $h_Lframework_prelude_alleycats$package$ as $h_Lframework_prelude_alleycats$package$ };
$h_Lframework_prelude_alleycats$package$.prototype = $c_Lframework_prelude_alleycats$package$.prototype;
$c_Lframework_prelude_alleycats$package$.prototype.emptyOption__Lalleycats_Empty = (function() {
  var a = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()));
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lalleycats_Empty$$anon$1(a);
});
var $d_Lframework_prelude_alleycats$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_prelude_alleycats$package$, "framework.prelude.alleycats$package$", ({
  Lframework_prelude_alleycats$package$: 1
}));
export { $d_Lframework_prelude_alleycats$package$ as $d_Lframework_prelude_alleycats$package$ };
var $n_Lframework_prelude_alleycats$package$;
function $m_Lframework_prelude_alleycats$package$() {
  if ((!$n_Lframework_prelude_alleycats$package$)) {
    $n_Lframework_prelude_alleycats$package$ = new $c_Lframework_prelude_alleycats$package$();
  }
  return $n_Lframework_prelude_alleycats$package$;
}
export { $m_Lframework_prelude_alleycats$package$ as $m_Lframework_prelude_alleycats$package$ };
/** @constructor */
function $c_Lframework_prelude_circe$package$() {
  this.Lframework_prelude_circe$package$__f_given_CirceKeyEncoder_Uri$lzy1 = null;
  this.Lframework_prelude_circe$package$__f_given_CirceKeyEncoder_Uribitmap$1 = false;
  this.Lframework_prelude_circe$package$__f_given_CirceKeyDecoder_Uri$lzy1 = null;
  this.Lframework_prelude_circe$package$__f_given_CirceKeyDecoder_Uribitmap$1 = false;
  this.Lframework_prelude_circe$package$__f_given_CirceCodec_Uri$lzy1 = null;
  this.Lframework_prelude_circe$package$__f_given_CirceCodec_Uribitmap$1 = false;
  this.Lframework_prelude_circe$package$__f_given_CirceCodec_FiniteDuration$lzy1 = null;
  this.Lframework_prelude_circe$package$__f_given_CirceCodec_FiniteDurationbitmap$1 = false;
}
export { $c_Lframework_prelude_circe$package$ as $c_Lframework_prelude_circe$package$ };
$c_Lframework_prelude_circe$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_prelude_circe$package$.prototype.constructor = $c_Lframework_prelude_circe$package$;
/** @constructor */
function $h_Lframework_prelude_circe$package$() {
}
export { $h_Lframework_prelude_circe$package$ as $h_Lframework_prelude_circe$package$ };
$h_Lframework_prelude_circe$package$.prototype = $c_Lframework_prelude_circe$package$.prototype;
$c_Lframework_prelude_circe$package$.prototype.given_CirceKeyEncoder_Uri__Lio_circe_KeyEncoder = (function() {
  if ((!this.Lframework_prelude_circe$package$__f_given_CirceKeyEncoder_Uribitmap$1)) {
    var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$1) => _$1.toStringSafe__sci_Set__T($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Set$EmptySet$())));
    this.Lframework_prelude_circe$package$__f_given_CirceKeyEncoder_Uri$lzy1 = new $c_Lio_circe_KeyEncoder$$anon$12(f);
    this.Lframework_prelude_circe$package$__f_given_CirceKeyEncoder_Uribitmap$1 = true;
  }
  return this.Lframework_prelude_circe$package$__f_given_CirceKeyEncoder_Uri$lzy1;
});
$c_Lframework_prelude_circe$package$.prototype.given_CirceKeyDecoder_Uri__Lio_circe_KeyDecoder = (function() {
  if ((!this.Lframework_prelude_circe$package$__f_given_CirceKeyDecoder_Uribitmap$1)) {
    $m_Lio_circe_KeyDecoder$();
    var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$2) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_Uri$().parse__T__s_util_Either(_$2).toOption__s_Option()));
    this.Lframework_prelude_circe$package$__f_given_CirceKeyDecoder_Uri$lzy1 = new $c_Lio_circe_KeyDecoder$$anon$12(f);
    this.Lframework_prelude_circe$package$__f_given_CirceKeyDecoder_Uribitmap$1 = true;
  }
  return this.Lframework_prelude_circe$package$__f_given_CirceKeyDecoder_Uri$lzy1;
});
$c_Lframework_prelude_circe$package$.prototype.given_CirceCodec_Uri__Lio_circe_Codec = (function() {
  if ((!this.Lframework_prelude_circe$package$__f_given_CirceCodec_Uribitmap$1)) {
    this.Lframework_prelude_circe$package$__f_given_CirceCodec_Uri$lzy1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_exts_CirceCodecExts$package$().fromKeyCodecs__Lio_circe_Codec$__Lio_circe_KeyDecoder__Lio_circe_KeyEncoder__Lio_circe_Codec($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_Codec$(), this.given_CirceKeyDecoder_Uri__Lio_circe_KeyDecoder(), this.given_CirceKeyEncoder_Uri__Lio_circe_KeyEncoder());
    this.Lframework_prelude_circe$package$__f_given_CirceCodec_Uribitmap$1 = true;
  }
  return this.Lframework_prelude_circe$package$__f_given_CirceCodec_Uri$lzy1;
});
$c_Lframework_prelude_circe$package$.prototype.given_CirceCodec_FiniteDuration__Lio_circe_Codec = (function() {
  if ((!this.Lframework_prelude_circe$package$__f_given_CirceCodec_FiniteDurationbitmap$1)) {
    var target = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$().Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$__f_longC3C;
    var tc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_Codec$().Lio_circe_Codec$__f_codecInvariant;
    var this$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Invariant$ToInvariantOps$$anon$19(target, tc);
    var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$4) => {
      var t = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(_$4);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var unit = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_FiniteDuration(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi), unit);
    }));
    var g = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$5) => _$5.s_concurrent_duration_FiniteDuration__f_unit.toNanos__J__J(_$5.s_concurrent_duration_FiniteDuration__f_length)));
    this.Lframework_prelude_circe$package$__f_given_CirceCodec_FiniteDuration$lzy1 = this$4.Lcats_Invariant$ToInvariantOps$$anon$19__f_typeClassInstance.imap__O__F1__F1__O(this$4.Lcats_Invariant$ToInvariantOps$$anon$19__f_self, f, g);
    this.Lframework_prelude_circe$package$__f_given_CirceCodec_FiniteDurationbitmap$1 = true;
  }
  return this.Lframework_prelude_circe$package$__f_given_CirceCodec_FiniteDuration$lzy1;
});
var $d_Lframework_prelude_circe$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_prelude_circe$package$, "framework.prelude.circe$package$", ({
  Lframework_prelude_circe$package$: 1
}));
export { $d_Lframework_prelude_circe$package$ as $d_Lframework_prelude_circe$package$ };
var $n_Lframework_prelude_circe$package$;
function $m_Lframework_prelude_circe$package$() {
  if ((!$n_Lframework_prelude_circe$package$)) {
    $n_Lframework_prelude_circe$package$ = new $c_Lframework_prelude_circe$package$();
  }
  return $n_Lframework_prelude_circe$package$;
}
export { $m_Lframework_prelude_circe$package$ as $m_Lframework_prelude_circe$package$ };
/** @constructor */
function $c_Lframework_prelude_client\uff3flogging$package$() {
}
export { $c_Lframework_prelude_client\uff3flogging$package$ as $c_Lframework_prelude_client\uff3flogging$package$ };
$c_Lframework_prelude_client\uff3flogging$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_prelude_client\uff3flogging$package$.prototype.constructor = $c_Lframework_prelude_client\uff3flogging$package$;
/** @constructor */
function $h_Lframework_prelude_client\uff3flogging$package$() {
}
export { $h_Lframework_prelude_client\uff3flogging$package$ as $h_Lframework_prelude_client\uff3flogging$package$ };
$h_Lframework_prelude_client\uff3flogging$package$.prototype = $c_Lframework_prelude_client\uff3flogging$package$.prototype;
$c_Lframework_prelude_client\uff3flogging$package$.prototype.getOrLogAndEmpty__s_util_Either__Lframework_utils_LogLevel__Lframework_sourcecode_DefinedAt__Lalleycats_Empty__T__O = (function(either, level, definedAt, empty, appName) {
  if ((either instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
    var value = either.s_util_Right__f_value;
    return value;
  }
  if ((either instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
    var error = either.s_util_Left__f_value;
    var this$1 = $m_Lframework_prelude_log$();
    var msg = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([error]));
    var scope = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $f_Lframework_utils_JSLogger$DefaultJavascriptLogging__atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V(this$1, level, scope, msg, definedAt, appName);
    return empty.empty__O();
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(either);
});
var $d_Lframework_prelude_client\uff3flogging$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_prelude_client\uff3flogging$package$, "framework.prelude.client_logging$package$", ({
  Lframework_prelude_client\uff3flogging$package$: 1
}));
export { $d_Lframework_prelude_client\uff3flogging$package$ as $d_Lframework_prelude_client\uff3flogging$package$ };
var $n_Lframework_prelude_client\uff3flogging$package$;
function $m_Lframework_prelude_client\uff3flogging$package$() {
  if ((!$n_Lframework_prelude_client\uff3flogging$package$)) {
    $n_Lframework_prelude_client\uff3flogging$package$ = new $c_Lframework_prelude_client\uff3flogging$package$();
  }
  return $n_Lframework_prelude_client\uff3flogging$package$;
}
export { $m_Lframework_prelude_client\uff3flogging$package$ as $m_Lframework_prelude_client\uff3flogging$package$ };
/** @constructor */
function $c_Lframework_prelude_js$() {
  this.Lframework_prelude_js$__f_Dynamic = null;
  $n_Lframework_prelude_js$ = this;
  Object;
  this.Lframework_prelude_js$__f_Dynamic = $m_sjs_js_Dynamic$();
}
export { $c_Lframework_prelude_js$ as $c_Lframework_prelude_js$ };
$c_Lframework_prelude_js$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_prelude_js$.prototype.constructor = $c_Lframework_prelude_js$;
/** @constructor */
function $h_Lframework_prelude_js$() {
}
export { $h_Lframework_prelude_js$ as $h_Lframework_prelude_js$ };
$h_Lframework_prelude_js$.prototype = $c_Lframework_prelude_js$.prototype;
$c_Lframework_prelude_js$.prototype.obj__F1__sjs_js_Object = (function(setup) {
  $m_Lframework_prelude_js$();
  var fields = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T2.getArrayOf().constr)([]));
  var a$proxy1 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  setup.apply__O__O(a$proxy1);
  return a$proxy1;
});
var $d_Lframework_prelude_js$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_prelude_js$, "framework.prelude.js$", ({
  Lframework_prelude_js$: 1
}));
export { $d_Lframework_prelude_js$ as $d_Lframework_prelude_js$ };
var $n_Lframework_prelude_js$;
function $m_Lframework_prelude_js$() {
  if ((!$n_Lframework_prelude_js$)) {
    $n_Lframework_prelude_js$ = new $c_Lframework_prelude_js$();
  }
  return $n_Lframework_prelude_js$;
}
export { $m_Lframework_prelude_js$ as $m_Lframework_prelude_js$ };
/** @constructor */
function $c_Lframework_prelude_laminar$package$() {
}
export { $c_Lframework_prelude_laminar$package$ as $c_Lframework_prelude_laminar$package$ };
$c_Lframework_prelude_laminar$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_prelude_laminar$package$.prototype.constructor = $c_Lframework_prelude_laminar$package$;
/** @constructor */
function $h_Lframework_prelude_laminar$package$() {
}
export { $h_Lframework_prelude_laminar$package$ as $h_Lframework_prelude_laminar$package$ };
$h_Lframework_prelude_laminar$package$.prototype = $c_Lframework_prelude_laminar$package$.prototype;
$c_Lframework_prelude_laminar$package$.prototype.renderableTextForLocalizedText__Lframework_localization_LocalizationSupport__O__Lcom_raquo_laminar_modifiers_RenderableText = (function(l18n, x$2) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_modifiers_RenderableText$();
  var render = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$8) => _$8.text__O__T(x$2)));
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(render);
});
$c_Lframework_prelude_laminar$package$.prototype.renderableTextForShow__Lcats_Show__Lcom_raquo_laminar_modifiers_RenderableText = (function(evidence$1) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_modifiers_RenderableText$();
  var render = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$9) => {
    var this$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$ToShowOps$$anon$3(_$9, evidence$1);
    return this$3.Lcats_Show$ToShowOps$$anon$3__f_typeClassInstance.show__O__T(this$3.Lcats_Show$ToShowOps$$anon$3__f_self);
  }));
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(render);
});
var $d_Lframework_prelude_laminar$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_prelude_laminar$package$, "framework.prelude.laminar$package$", ({
  Lframework_prelude_laminar$package$: 1
}));
export { $d_Lframework_prelude_laminar$package$ as $d_Lframework_prelude_laminar$package$ };
var $n_Lframework_prelude_laminar$package$;
function $m_Lframework_prelude_laminar$package$() {
  if ((!$n_Lframework_prelude_laminar$package$)) {
    $n_Lframework_prelude_laminar$package$ = new $c_Lframework_prelude_laminar$package$();
  }
  return $n_Lframework_prelude_laminar$package$;
}
export { $m_Lframework_prelude_laminar$package$ as $m_Lframework_prelude_laminar$package$ };
/** @constructor */
function $c_Lframework_prelude_navigateTo$package$() {
}
export { $c_Lframework_prelude_navigateTo$package$ as $c_Lframework_prelude_navigateTo$package$ };
$c_Lframework_prelude_navigateTo$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_prelude_navigateTo$package$.prototype.constructor = $c_Lframework_prelude_navigateTo$package$;
/** @constructor */
function $h_Lframework_prelude_navigateTo$package$() {
}
export { $h_Lframework_prelude_navigateTo$package$ as $h_Lframework_prelude_navigateTo$package$ };
$h_Lframework_prelude_navigateTo$package$.prototype = $c_Lframework_prelude_navigateTo$package$.prototype;
$c_Lframework_prelude_navigateTo$package$.prototype.navigateTo__Lcom_raquo_airstream_core_Signal__Lframework_utils_RouterOps$In__Lcom_raquo_laminar_modifiers_Binder = (function(signal, router) {
  var $x_1 = $m_Lframework_prelude_navigateTo$package$();
  var project = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((value) => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value)));
  return $x_1.navigateToOption__Lcom_raquo_airstream_core_Signal__Lframework_utils_RouterOps$In__Lcom_raquo_laminar_modifiers_Binder($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), signal, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()), router);
});
$c_Lframework_prelude_navigateTo$package$.prototype.navigateToOption__Lcom_raquo_airstream_core_Signal__Lframework_utils_RouterOps$In__Lcom_raquo_laminar_modifiers_Binder = (function(signal, router) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$();
  var fn = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((el) => {
    var isLinkElement = (!(!(el.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_ref instanceof HTMLAnchorElement)));
    if (isLinkElement) {
      try {
        var project = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$1) => {
          if (_$1.isEmpty__Z()) {
            var $x_1 = "";
          } else {
            var x0 = _$1.get__O();
            var $x_1 = router.Lapp_pages_AppPageInit__f_router.absoluteUrlForPage__O__T(x0);
          }
          return $x_1;
        }));
        var urlSignal = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), signal, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
        var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
        var this$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.href__Lcom_raquo_laminar_keys_HtmlAttr();
        var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_$less$colon$less$();
        var ev = this$2.s_$less$colon$less$__f_singleton;
        var mods = $x_2.wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_laminar_modifiers_Modifier.getArrayOf().constr)([$f_Lcom_raquo_laminar_keys_SimpleAttr__$less$minus$minus__Lcom_raquo_airstream_core_Source__F1__Lcom_raquo_laminar_modifiers_SimpleKeyUpdater(this$3, urlSignal, ev)]));
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement(el, mods);
      } catch (e) {
        var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
        matchResult1: {
          var x2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
          if ((!x2.isEmpty__Z())) {
            var x3 = x2.get__O();
            var err$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([("navigateTo: " + x3)]));
            var this$7 = $m_Lframework_prelude_log$();
            var file = new $c_Lsourcecode_File("/home/arturaz/work/rapix/framework/client/src/framework/prelude/navigateTo.scala");
            var line = new $c_Lsourcecode_Line(36);
            var name = new $c_Lsourcecode_FullName("framework.prelude.navigateTo$package.navigateTo");
            var definedAt = new $c_Lframework_sourcecode_DefinedAt(file, line, name);
            var this$6 = $m_Lframework_prelude_client\uff3flogging$package$JSAppName$();
            var appName = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Newtype$WithoutValidation__apply__O__O(this$6, "app");
            var level = $s_Lframework_utils_LogLevel$__Error__Lframework_utils_LogLevel();
            var scope = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
            $f_Lframework_utils_JSLogger$DefaultJavascriptLogging__atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V(this$7, level, scope, err$1, definedAt, appName);
            break matchResult1;
          }
          throw ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
        }
      }
    }
    var this$9 = $m_Lframework_prelude_navigateTo$package$().navigateToEventProcessor__Z__Lcom_raquo_laminar_keys_EventProcessor(isLinkElement);
    var operator = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$2) => {
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_EventStream$();
      return $m_Lcom_raquo_airstream_combine_generated_CombinableStream$().sample$extension__Lcom_raquo_airstream_core_EventStream__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_EventStream(_$2, signal);
    }));
    var this$10 = new $c_Lcom_raquo_laminar_keys_LockedEventKey(this$9, operator);
    var onNext = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1) => {
      matchResult2: {
        var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        if ((x === x$1)) {
          break matchResult2;
        }
        if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
          var page = x$1.s_Some__f_value;
          router.Lapp_pages_AppPageInit__f_router.pushState__O__V(page);
          break matchResult2;
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
      }
    }));
    var this$11 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_Observer$();
    var binder = this$10.$minus$minus$greater__Lcom_raquo_airstream_core_Sink__Lcom_raquo_laminar_modifiers_Binder(this$11.withRecover__F1__s_PartialFunction__Z__Lcom_raquo_airstream_core_Observer(onNext, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_PartialFunction$().s_PartialFunction$__f_empty_pf, true));
    return binder.bind__Lcom_raquo_laminar_nodes_ReactiveElement__Lcom_raquo_airstream_ownership_DynamicSubscription(el);
  }));
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_laminar_modifiers_Binder$$anon$1(fn);
});
$c_Lframework_prelude_navigateTo$package$.prototype.navigateTo__O__Lframework_utils_RouterOps$In__Lcom_raquo_laminar_modifiers_Binder = (function(page, router) {
  return $m_Lframework_prelude_navigateTo$package$().navigateTo__Lcom_raquo_airstream_core_Signal__Lframework_utils_RouterOps$In__Lcom_raquo_laminar_modifiers_Binder(($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_airstream_state_Val$().apply__O__Lcom_raquo_airstream_state_Val(page)), router);
});
$c_Lframework_prelude_navigateTo$package$.prototype.navigateToEventProcessor__Z__Lcom_raquo_laminar_keys_EventProcessor = (function(isLinkElement) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$();
  var eventProp = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.onClick__Lcom_raquo_laminar_keys_EventProp();
  return $m_Lcom_raquo_laminar_keys_EventProcessor$().empty__Lcom_raquo_laminar_keys_EventProp__Z__Z__Lcom_raquo_laminar_keys_EventProcessor(eventProp, false, false).filter__F1__Lcom_raquo_laminar_keys_EventProcessor(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((ev) => (!(isLinkElement && ((((!(!ev.ctrlKey)) || (!(!ev.metaKey))) || (!(!ev.shiftKey))) || (!(!ev.altKey)))))))).preventDefault__Lcom_raquo_laminar_keys_EventProcessor();
});
var $d_Lframework_prelude_navigateTo$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_prelude_navigateTo$package$, "framework.prelude.navigateTo$package$", ({
  Lframework_prelude_navigateTo$package$: 1
}));
export { $d_Lframework_prelude_navigateTo$package$ as $d_Lframework_prelude_navigateTo$package$ };
var $n_Lframework_prelude_navigateTo$package$;
function $m_Lframework_prelude_navigateTo$package$() {
  if ((!$n_Lframework_prelude_navigateTo$package$)) {
    $n_Lframework_prelude_navigateTo$package$ = new $c_Lframework_prelude_navigateTo$package$();
  }
  return $n_Lframework_prelude_navigateTo$package$;
}
export { $m_Lframework_prelude_navigateTo$package$ as $m_Lframework_prelude_navigateTo$package$ };
/** @constructor */
function $c_Lframework_prelude_newtype\uff3fcirce$package$() {
}
export { $c_Lframework_prelude_newtype\uff3fcirce$package$ as $c_Lframework_prelude_newtype\uff3fcirce$package$ };
$c_Lframework_prelude_newtype\uff3fcirce$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_prelude_newtype\uff3fcirce$package$.prototype.constructor = $c_Lframework_prelude_newtype\uff3fcirce$package$;
/** @constructor */
function $h_Lframework_prelude_newtype\uff3fcirce$package$() {
}
export { $h_Lframework_prelude_newtype\uff3fcirce$package$ as $h_Lframework_prelude_newtype\uff3fcirce$package$ };
$h_Lframework_prelude_newtype\uff3fcirce$package$.prototype = $c_Lframework_prelude_newtype\uff3fcirce$package$.prototype;
$c_Lframework_prelude_newtype\uff3fcirce$package$.prototype.newTypeCirceCodec__Lyantl_INewtype__Lio_circe_Encoder__Lio_circe_Decoder__Lio_circe_Codec = (function(newType, encoder, decoder) {
  var this$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lio_circe_Codec$$anon$4(decoder, encoder);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((input) => {
    var this$3 = newType.make__Lyantl_INewtype$make$();
    var x$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_prelude_newtype$package$().given_AsString_Any__Lyantl_AsString();
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Make__asString__O__Lyantl_AsString__s_util_Either(this$3, input, x$2);
  }));
  var g = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((v) => newType.protected_unwrap__O__O(v)));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lio_circe_Codec__iemap__F1__F1__Lio_circe_Codec(this$4, f, g);
});
var $d_Lframework_prelude_newtype\uff3fcirce$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_prelude_newtype\uff3fcirce$package$, "framework.prelude.newtype_circe$package$", ({
  Lframework_prelude_newtype\uff3fcirce$package$: 1
}));
export { $d_Lframework_prelude_newtype\uff3fcirce$package$ as $d_Lframework_prelude_newtype\uff3fcirce$package$ };
var $n_Lframework_prelude_newtype\uff3fcirce$package$;
function $m_Lframework_prelude_newtype\uff3fcirce$package$() {
  if ((!$n_Lframework_prelude_newtype\uff3fcirce$package$)) {
    $n_Lframework_prelude_newtype\uff3fcirce$package$ = new $c_Lframework_prelude_newtype\uff3fcirce$package$();
  }
  return $n_Lframework_prelude_newtype\uff3fcirce$package$;
}
export { $m_Lframework_prelude_newtype\uff3fcirce$package$ as $m_Lframework_prelude_newtype\uff3fcirce$package$ };
/** @constructor */
function $c_Lframework_prelude_prelude\uff3fclient$package$() {
  this.Lframework_prelude_prelude\uff3fclient$package$__f_executionContext$lzy1 = null;
  this.Lframework_prelude_prelude\uff3fclient$package$__f_executionContextbitmap$1 = false;
  this.Lframework_prelude_prelude\uff3fclient$package$__f_ioRuntime$lzy1 = null;
  this.Lframework_prelude_prelude\uff3fclient$package$__f_ioRuntimebitmap$1 = false;
  this.Lframework_prelude_prelude\uff3fclient$package$__f_sttpClientInterpreter$lzy1 = null;
  this.Lframework_prelude_prelude\uff3fclient$package$__f_sttpClientInterpreterbitmap$1 = false;
  this.Lframework_prelude_prelude\uff3fclient$package$__f_sttpBackend$lzy1 = null;
  this.Lframework_prelude_prelude\uff3fclient$package$__f_sttpBackendbitmap$1 = false;
  this.Lframework_prelude_prelude\uff3fclient$package$__f_ioToFutureFunctionK$lzy1 = null;
  this.Lframework_prelude_prelude\uff3fclient$package$__f_ioToFutureFunctionKbitmap$1 = false;
}
export { $c_Lframework_prelude_prelude\uff3fclient$package$ as $c_Lframework_prelude_prelude\uff3fclient$package$ };
$c_Lframework_prelude_prelude\uff3fclient$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_prelude_prelude\uff3fclient$package$.prototype.constructor = $c_Lframework_prelude_prelude\uff3fclient$package$;
/** @constructor */
function $h_Lframework_prelude_prelude\uff3fclient$package$() {
}
export { $h_Lframework_prelude_prelude\uff3fclient$package$ as $h_Lframework_prelude_prelude\uff3fclient$package$ };
$h_Lframework_prelude_prelude\uff3fclient$package$.prototype = $c_Lframework_prelude_prelude\uff3fclient$package$.prototype;
$c_Lframework_prelude_prelude\uff3fclient$package$.prototype.executionContext__s_concurrent_ExecutionContext = (function() {
  if ((!this.Lframework_prelude_prelude\uff3fclient$package$__f_executionContextbitmap$1)) {
    this.Lframework_prelude_prelude\uff3fclient$package$__f_executionContext$lzy1 = $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue;
    this.Lframework_prelude_prelude\uff3fclient$package$__f_executionContextbitmap$1 = true;
  }
  return this.Lframework_prelude_prelude\uff3fclient$package$__f_executionContext$lzy1;
});
$c_Lframework_prelude_prelude\uff3fclient$package$.prototype.ioRuntime__Lcats_effect_unsafe_IORuntime = (function() {
  if ((!this.Lframework_prelude_prelude\uff3fclient$package$__f_ioRuntimebitmap$1)) {
    this.Lframework_prelude_prelude\uff3fclient$package$__f_ioRuntime$lzy1 = $m_Lcats_effect_unsafe_IORuntime$().global__Lcats_effect_unsafe_IORuntime();
    this.Lframework_prelude_prelude\uff3fclient$package$__f_ioRuntimebitmap$1 = true;
  }
  return this.Lframework_prelude_prelude\uff3fclient$package$__f_ioRuntime$lzy1;
});
$c_Lframework_prelude_prelude\uff3fclient$package$.prototype.sttpClientInterpreter__Lsttp_tapir_client_sttp_SttpClientInterpreter = (function() {
  if ((!this.Lframework_prelude_prelude\uff3fclient$package$__f_sttpClientInterpreterbitmap$1)) {
    var clientOptions = $m_Lsttp_tapir_client_sttp_SttpClientOptions$().Lsttp_tapir_client_sttp_SttpClientOptions$__f_default;
    this.Lframework_prelude_prelude\uff3fclient$package$__f_sttpClientInterpreter$lzy1 = new $c_Lsttp_tapir_client_sttp_SttpClientInterpreter$$anon$1(clientOptions);
    this.Lframework_prelude_prelude\uff3fclient$package$__f_sttpClientInterpreterbitmap$1 = true;
  }
  return this.Lframework_prelude_prelude\uff3fclient$package$__f_sttpClientInterpreter$lzy1;
});
$c_Lframework_prelude_prelude\uff3fclient$package$.prototype.sttpBackend__Lsttp_client3_SttpBackend = (function() {
  if ((!this.Lframework_prelude_prelude\uff3fclient$package$__f_sttpBackendbitmap$1)) {
    $m_Lsttp_client3_FetchOptions$();
    var credentials = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some("include");
    var this$2 = $m_Lsttp_client3_FetchOptions$().Lsttp_client3_FetchOptions$__f_Default;
    var mode = this$2.Lsttp_client3_FetchOptions__f_mode;
    var fetchOptions = new $c_Lsttp_client3_FetchOptions(credentials, mode);
    var customizeRequest = $m_Lsttp_client3_impl_cats_FetchCatsBackend$().apply$default$2__F1();
    var evidence$1 = $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO;
    this.Lframework_prelude_prelude\uff3fclient$package$__f_sttpBackend$lzy1 = new $c_Lsttp_client3_impl_cats_FetchCatsBackend(fetchOptions, customizeRequest, evidence$1);
    this.Lframework_prelude_prelude\uff3fclient$package$__f_sttpBackendbitmap$1 = true;
  }
  return this.Lframework_prelude_prelude\uff3fclient$package$__f_sttpBackend$lzy1;
});
$c_Lframework_prelude_prelude\uff3fclient$package$.prototype.ioToFutureFunctionK__Lcats_arrow_FunctionK = (function() {
  if ((!this.Lframework_prelude_prelude\uff3fclient$package$__f_ioToFutureFunctionKbitmap$1)) {
    this.Lframework_prelude_prelude\uff3fclient$package$__f_ioToFutureFunctionK$lzy1 = new $c_Lframework_prelude_prelude\uff3fclient$package$$anon$1();
    this.Lframework_prelude_prelude\uff3fclient$package$__f_ioToFutureFunctionKbitmap$1 = true;
  }
  return this.Lframework_prelude_prelude\uff3fclient$package$__f_ioToFutureFunctionK$lzy1;
});
$c_Lframework_prelude_prelude\uff3fclient$package$.prototype.console__Lorg_scalajs_dom_Console = (function() {
  return console;
});
$c_Lframework_prelude_prelude\uff3fclient$package$.prototype.window__Lorg_scalajs_dom_Window = (function() {
  return window;
});
var $d_Lframework_prelude_prelude\uff3fclient$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_prelude_prelude\uff3fclient$package$, "framework.prelude.prelude_client$package$", ({
  Lframework_prelude_prelude\uff3fclient$package$: 1
}));
export { $d_Lframework_prelude_prelude\uff3fclient$package$ as $d_Lframework_prelude_prelude\uff3fclient$package$ };
var $n_Lframework_prelude_prelude\uff3fclient$package$;
function $m_Lframework_prelude_prelude\uff3fclient$package$() {
  if ((!$n_Lframework_prelude_prelude\uff3fclient$package$)) {
    $n_Lframework_prelude_prelude\uff3fclient$package$ = new $c_Lframework_prelude_prelude\uff3fclient$package$();
  }
  return $n_Lframework_prelude_prelude\uff3fclient$package$;
}
export { $m_Lframework_prelude_prelude\uff3fclient$package$ as $m_Lframework_prelude_prelude\uff3fclient$package$ };
/** @constructor */
function $c_Lframework_prelude_sttp$package$() {
  this.Lframework_prelude_sttp$package$__f_given_Show_Uri$lzy1 = null;
  this.Lframework_prelude_sttp$package$__f_given_Show_Uribitmap$1 = false;
  this.Lframework_prelude_sttp$package$__f_given_Show_StatusCode$lzy1 = null;
  this.Lframework_prelude_sttp$package$__f_given_Show_StatusCodebitmap$1 = false;
}
export { $c_Lframework_prelude_sttp$package$ as $c_Lframework_prelude_sttp$package$ };
$c_Lframework_prelude_sttp$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_prelude_sttp$package$.prototype.constructor = $c_Lframework_prelude_sttp$package$;
/** @constructor */
function $h_Lframework_prelude_sttp$package$() {
}
export { $h_Lframework_prelude_sttp$package$ as $h_Lframework_prelude_sttp$package$ };
$h_Lframework_prelude_sttp$package$.prototype = $c_Lframework_prelude_sttp$package$.prototype;
$c_Lframework_prelude_sttp$package$.prototype.given_Show_Uri__Lcats_Show = (function() {
  if ((!this.Lframework_prelude_sttp$package$__f_given_Show_Uribitmap$1)) {
    this.Lframework_prelude_sttp$package$__f_given_Show_Uri$lzy1 = new $c_Lframework_prelude_sttp$package$$anon$1();
    this.Lframework_prelude_sttp$package$__f_given_Show_Uribitmap$1 = true;
  }
  return this.Lframework_prelude_sttp$package$__f_given_Show_Uri$lzy1;
});
$c_Lframework_prelude_sttp$package$.prototype.given_Show_StatusCode__Lcats_Show = (function() {
  if ((!this.Lframework_prelude_sttp$package$__f_given_Show_StatusCodebitmap$1)) {
    this.Lframework_prelude_sttp$package$__f_given_Show_StatusCode$lzy1 = new $c_Lframework_prelude_sttp$package$$anon$2();
    this.Lframework_prelude_sttp$package$__f_given_Show_StatusCodebitmap$1 = true;
  }
  return this.Lframework_prelude_sttp$package$__f_given_Show_StatusCode$lzy1;
});
var $d_Lframework_prelude_sttp$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_prelude_sttp$package$, "framework.prelude.sttp$package$", ({
  Lframework_prelude_sttp$package$: 1
}));
export { $d_Lframework_prelude_sttp$package$ as $d_Lframework_prelude_sttp$package$ };
var $n_Lframework_prelude_sttp$package$;
function $m_Lframework_prelude_sttp$package$() {
  if ((!$n_Lframework_prelude_sttp$package$)) {
    $n_Lframework_prelude_sttp$package$ = new $c_Lframework_prelude_sttp$package$();
  }
  return $n_Lframework_prelude_sttp$package$;
}
export { $m_Lframework_prelude_sttp$package$ as $m_Lframework_prelude_sttp$package$ };
/** @constructor */
function $c_Lframework_prelude_tapir$package$() {
  this.Lframework_prelude_tapir$package$__f_schemaForNothing$lzy1 = null;
  this.Lframework_prelude_tapir$package$__f_schemaForNothingbitmap$1 = false;
  this.Lframework_prelude_tapir$package$__f_schemaForFiniteDuration$lzy1 = null;
  this.Lframework_prelude_tapir$package$__f_schemaForFiniteDurationbitmap$1 = false;
}
export { $c_Lframework_prelude_tapir$package$ as $c_Lframework_prelude_tapir$package$ };
$c_Lframework_prelude_tapir$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_prelude_tapir$package$.prototype.constructor = $c_Lframework_prelude_tapir$package$;
/** @constructor */
function $h_Lframework_prelude_tapir$package$() {
}
export { $h_Lframework_prelude_tapir$package$ as $h_Lframework_prelude_tapir$package$ };
$h_Lframework_prelude_tapir$package$.prototype = $c_Lframework_prelude_tapir$package$.prototype;
$c_Lframework_prelude_tapir$package$.prototype.given_Schema_NonEmptySet__Lsttp_tapir_Schema__Lsttp_tapir_Schema = (function(evidence$1) {
  var x$proxy3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$().schemaForSet__Lsttp_tapir_Schema__Lsttp_tapir_Schema(evidence$1);
  var g = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$3) => {
    var this$2 = new $c_Lcats_data_NonEmptySetOps(_$3);
    var s = this$2.Lcats_data_NonEmptySetOps__f_value;
    return s;
  }));
  var schemaType$1 = x$proxy3.Lsttp_tapir_Schema__f_schemaType.contramap__F1__Lsttp_tapir_SchemaType(g);
  var this$4 = x$proxy3.Lsttp_tapir_Schema__f_default;
  if (this$4.isEmpty__Z()) {
    var default$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0 = this$4.get__O();
    matchResult4: {
      var default$1;
      if ((x0 !== null)) {
        var t = x0._1__O();
        var raw = x0._2__O();
        var this$6 = $m_Lcats_data_package$().Lcats_data_package$__f_NonEmptySet.fromSet__sci_SortedSet__s_Option(t);
        if (this$6.isEmpty__Z()) {
          var default$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
          break matchResult4;
        } else {
          var x0$1 = this$6.get__O();
          var default$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), x0$1, raw));
          break matchResult4;
        }
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x0);
    }
  }
  var validator$1 = x$proxy3.Lsttp_tapir_Schema__f_validator.contramap__F1__Lsttp_tapir_Validator(g);
  var name$1 = x$proxy3.Lsttp_tapir_Schema__f_name;
  var isOptional$1 = x$proxy3.Lsttp_tapir_Schema__f_isOptional;
  var description$1 = x$proxy3.Lsttp_tapir_Schema__f_description;
  var format$1 = x$proxy3.Lsttp_tapir_Schema__f_format;
  var encodedExample$1 = x$proxy3.Lsttp_tapir_Schema__f_encodedExample;
  var deprecated$1 = x$proxy3.Lsttp_tapir_Schema__f_deprecated;
  var hidden$1 = x$proxy3.Lsttp_tapir_Schema__f_hidden;
  var attributes$1 = x$proxy3.Lsttp_tapir_Schema__f_attributes;
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema(schemaType$1, name$1, isOptional$1, description$1, default$1, format$1, encodedExample$1, deprecated$1, hidden$1, validator$1, attributes$1);
});
$c_Lframework_prelude_tapir$package$.prototype.schemaForNothing__Lsttp_tapir_Schema = (function() {
  if ((!this.Lframework_prelude_tapir$package$__f_schemaForNothingbitmap$1)) {
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$().any__Lsttp_tapir_Schema();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$SName$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$SName$();
    var typeParameterShortNames = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    this.Lframework_prelude_tapir$package$__f_schemaForNothing$lzy1 = $x_1.name__Lsttp_tapir_Schema$SName__Lsttp_tapir_Schema(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema$SName("Nothing", typeParameterShortNames)).description__T__Lsttp_tapir_Schema("Nothing - no values will be accepted or produced.");
    this.Lframework_prelude_tapir$package$__f_schemaForNothingbitmap$1 = true;
  }
  return this.Lframework_prelude_tapir$package$__f_schemaForNothing$lzy1;
});
$c_Lframework_prelude_tapir$package$.prototype.schemaForFiniteDuration__Lsttp_tapir_Schema = (function() {
  if ((!this.Lframework_prelude_tapir$package$__f_schemaForFiniteDurationbitmap$1)) {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var schemaType = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_SchemaType$SInteger();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var name = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var isOptional = false;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var description = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var default$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var format = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var encodedExample = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var deprecated = false;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var hidden = false;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var validator = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var attributes = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
    var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema(schemaType, name, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes).format__T__Lsttp_tapir_Schema("int64");
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$SName$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$SName$();
    var typeParameterShortNames = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    this.Lframework_prelude_tapir$package$__f_schemaForFiniteDuration$lzy1 = $x_1.name__Lsttp_tapir_Schema$SName__Lsttp_tapir_Schema(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema$SName("FiniteDuration", typeParameterShortNames)).description__T__Lsttp_tapir_Schema("A finite duration in nanoseconds");
    this.Lframework_prelude_tapir$package$__f_schemaForFiniteDurationbitmap$1 = true;
  }
  return this.Lframework_prelude_tapir$package$__f_schemaForFiniteDuration$lzy1;
});
var $d_Lframework_prelude_tapir$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_prelude_tapir$package$, "framework.prelude.tapir$package$", ({
  Lframework_prelude_tapir$package$: 1
}));
export { $d_Lframework_prelude_tapir$package$ as $d_Lframework_prelude_tapir$package$ };
var $n_Lframework_prelude_tapir$package$;
function $m_Lframework_prelude_tapir$package$() {
  if ((!$n_Lframework_prelude_tapir$package$)) {
    $n_Lframework_prelude_tapir$package$ = new $c_Lframework_prelude_tapir$package$();
  }
  return $n_Lframework_prelude_tapir$package$;
}
export { $m_Lframework_prelude_tapir$package$ as $m_Lframework_prelude_tapir$package$ };
/** @constructor */
function $c_Lframework_utils_IsRenderableNode$() {
}
export { $c_Lframework_utils_IsRenderableNode$ as $c_Lframework_utils_IsRenderableNode$ };
$c_Lframework_utils_IsRenderableNode$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_IsRenderableNode$.prototype.constructor = $c_Lframework_utils_IsRenderableNode$;
/** @constructor */
function $h_Lframework_utils_IsRenderableNode$() {
}
export { $h_Lframework_utils_IsRenderableNode$ as $h_Lframework_utils_IsRenderableNode$ };
$h_Lframework_utils_IsRenderableNode$.prototype = $c_Lframework_utils_IsRenderableNode$.prototype;
$c_Lframework_utils_IsRenderableNode$.prototype.renderableNode__Lcom_raquo_laminar_modifiers_RenderableNode = (function() {
  var renderNode = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$1) => _$1.render__Lcom_raquo_laminar_nodes_ChildNode()));
  return new $c_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$2(renderNode);
});
var $d_Lframework_utils_IsRenderableNode$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_IsRenderableNode$, "framework.utils.IsRenderableNode$", ({
  Lframework_utils_IsRenderableNode$: 1
}));
export { $d_Lframework_utils_IsRenderableNode$ as $d_Lframework_utils_IsRenderableNode$ };
var $n_Lframework_utils_IsRenderableNode$;
function $m_Lframework_utils_IsRenderableNode$() {
  if ((!$n_Lframework_utils_IsRenderableNode$)) {
    $n_Lframework_utils_IsRenderableNode$ = new $c_Lframework_utils_IsRenderableNode$();
  }
  return $n_Lframework_utils_IsRenderableNode$;
}
export { $m_Lframework_utils_IsRenderableNode$ as $m_Lframework_utils_IsRenderableNode$ };
function $f_Lframework_utils_JSLogger__scoped__T__Lframework_utils_JSLogger($thiz, scope) {
  return new $c_Lframework_utils_JSLogger$$anon$1(scope, $thiz);
}
export { $f_Lframework_utils_JSLogger__scoped__T__Lframework_utils_JSLogger as $f_Lframework_utils_JSLogger__scoped__T__Lframework_utils_JSLogger };
/** @constructor */
function $c_Lframework_utils_JSLogger$() {
  this.Lframework_utils_JSLogger$__f_noOp = null;
  $n_Lframework_utils_JSLogger$ = this;
  this.Lframework_utils_JSLogger$__f_noOp = new $c_Lframework_utils_JSLogger$$anon$2();
}
export { $c_Lframework_utils_JSLogger$ as $c_Lframework_utils_JSLogger$ };
$c_Lframework_utils_JSLogger$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_JSLogger$.prototype.constructor = $c_Lframework_utils_JSLogger$;
/** @constructor */
function $h_Lframework_utils_JSLogger$() {
}
export { $h_Lframework_utils_JSLogger$ as $h_Lframework_utils_JSLogger$ };
$h_Lframework_utils_JSLogger$.prototype = $c_Lframework_utils_JSLogger$.prototype;
var $d_Lframework_utils_JSLogger$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_JSLogger$, "framework.utils.JSLogger$", ({
  Lframework_utils_JSLogger$: 1
}));
export { $d_Lframework_utils_JSLogger$ as $d_Lframework_utils_JSLogger$ };
var $n_Lframework_utils_JSLogger$;
function $m_Lframework_utils_JSLogger$() {
  if ((!$n_Lframework_utils_JSLogger$)) {
    $n_Lframework_utils_JSLogger$ = new $c_Lframework_utils_JSLogger$();
  }
  return $n_Lframework_utils_JSLogger$;
}
export { $m_Lframework_utils_JSLogger$ as $m_Lframework_utils_JSLogger$ };
/** @constructor */
function $c_Lframework_utils_NewtypeNonEmptyString$() {
  this.Lframework_utils_NewtypeNonEmptyString$__f_validators = null;
  $n_Lframework_utils_NewtypeNonEmptyString$ = this;
  this.Lframework_utils_NewtypeNonEmptyString$__f_validators = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lyantl_ValidatorRule.getArrayOf().constr)([new $c_Lyantl_ValidatorRule$$anon$12(), new $c_Lyantl_ValidatorRule$$anon$13()]);
}
export { $c_Lframework_utils_NewtypeNonEmptyString$ as $c_Lframework_utils_NewtypeNonEmptyString$ };
$c_Lframework_utils_NewtypeNonEmptyString$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_NewtypeNonEmptyString$.prototype.constructor = $c_Lframework_utils_NewtypeNonEmptyString$;
/** @constructor */
function $h_Lframework_utils_NewtypeNonEmptyString$() {
}
export { $h_Lframework_utils_NewtypeNonEmptyString$ as $h_Lframework_utils_NewtypeNonEmptyString$ };
$h_Lframework_utils_NewtypeNonEmptyString$.prototype = $c_Lframework_utils_NewtypeNonEmptyString$.prototype;
var $d_Lframework_utils_NewtypeNonEmptyString$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_NewtypeNonEmptyString$, "framework.utils.NewtypeNonEmptyString$", ({
  Lframework_utils_NewtypeNonEmptyString$: 1
}));
export { $d_Lframework_utils_NewtypeNonEmptyString$ as $d_Lframework_utils_NewtypeNonEmptyString$ };
var $n_Lframework_utils_NewtypeNonEmptyString$;
function $m_Lframework_utils_NewtypeNonEmptyString$() {
  if ((!$n_Lframework_utils_NewtypeNonEmptyString$)) {
    $n_Lframework_utils_NewtypeNonEmptyString$ = new $c_Lframework_utils_NewtypeNonEmptyString$();
  }
  return $n_Lframework_utils_NewtypeNonEmptyString$;
}
export { $m_Lframework_utils_NewtypeNonEmptyString$ as $m_Lframework_utils_NewtypeNonEmptyString$ };
/** @constructor */
function $c_Lframework_utils_PageFocus$() {
  this.Lframework_utils_PageFocus$__f_rxVar = null;
  $n_Lframework_utils_PageFocus$ = this;
  this.Lframework_utils_PageFocus$__f_rxVar = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_state_Var$().apply__O__Lcom_raquo_airstream_state_Var((!(!$m_Lframework_prelude_prelude\uff3fclient$package$().window__Lorg_scalajs_dom_Window().document.hasFocus())));
  $m_Lframework_prelude_prelude\uff3fclient$package$().window__Lorg_scalajs_dom_Window().addEventListener("focus", ((_$1) => {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_state_Var__set__O__V(this.Lframework_utils_PageFocus$__f_rxVar, true);
  }));
  $m_Lframework_prelude_prelude\uff3fclient$package$().window__Lorg_scalajs_dom_Window().addEventListener("blur", ((_$2) => {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_state_Var__set__O__V(this.Lframework_utils_PageFocus$__f_rxVar, false);
  }));
}
export { $c_Lframework_utils_PageFocus$ as $c_Lframework_utils_PageFocus$ };
$c_Lframework_utils_PageFocus$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_PageFocus$.prototype.constructor = $c_Lframework_utils_PageFocus$;
/** @constructor */
function $h_Lframework_utils_PageFocus$() {
}
export { $h_Lframework_utils_PageFocus$ as $h_Lframework_utils_PageFocus$ };
$h_Lframework_utils_PageFocus$.prototype = $c_Lframework_utils_PageFocus$.prototype;
$c_Lframework_utils_PageFocus$.prototype.signal__Lcom_raquo_airstream_state_StrictSignal = (function() {
  return this.Lframework_utils_PageFocus$__f_rxVar.signal__Lcom_raquo_airstream_state_StrictSignal();
});
var $d_Lframework_utils_PageFocus$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_PageFocus$, "framework.utils.PageFocus$", ({
  Lframework_utils_PageFocus$: 1
}));
export { $d_Lframework_utils_PageFocus$ as $d_Lframework_utils_PageFocus$ };
var $n_Lframework_utils_PageFocus$;
function $m_Lframework_utils_PageFocus$() {
  if ((!$n_Lframework_utils_PageFocus$)) {
    $n_Lframework_utils_PageFocus$ = new $c_Lframework_utils_PageFocus$();
  }
  return $n_Lframework_utils_PageFocus$;
}
export { $m_Lframework_utils_PageFocus$ as $m_Lframework_utils_PageFocus$ };
/** @constructor */
function $c_Lframework_utils_PersistedVar(underlying, persistenceKey, storage, defaultValueVar, x$5, x$6, x$7) {
  this.Lframework_utils_PersistedVar__f_underlying = null;
  this.Lframework_utils_PersistedVar__f_persistenceKey = null;
  this.Lframework_utils_PersistedVar__f_storage = null;
  this.Lframework_utils_PersistedVar__f_defaultValueVar = null;
  this.Lframework_utils_PersistedVar__f_x$6 = null;
  this.Lframework_utils_PersistedVar__f_underlying = underlying;
  this.Lframework_utils_PersistedVar__f_persistenceKey = persistenceKey;
  this.Lframework_utils_PersistedVar__f_storage = storage;
  this.Lframework_utils_PersistedVar__f_defaultValueVar = defaultValueVar;
  this.Lframework_utils_PersistedVar__f_x$6 = x$6;
}
export { $c_Lframework_utils_PersistedVar as $c_Lframework_utils_PersistedVar };
$c_Lframework_utils_PersistedVar.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_PersistedVar.prototype.constructor = $c_Lframework_utils_PersistedVar;
/** @constructor */
function $h_Lframework_utils_PersistedVar() {
}
export { $h_Lframework_utils_PersistedVar as $h_Lframework_utils_PersistedVar };
$h_Lframework_utils_PersistedVar.prototype = $c_Lframework_utils_PersistedVar.prototype;
$c_Lframework_utils_PersistedVar.prototype.persistEvent__Lcom_raquo_airstream_core_EventStream__I__Lcom_raquo_airstream_core_EventStream = (function(submitting, underlyingDebounceMs) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_EventStream$();
  var $x_2 = $m_Lcom_raquo_airstream_combine_generated_CombinableStream$().sample$extension__Lcom_raquo_airstream_core_EventStream__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_EventStream(submitting, this.Lframework_utils_PersistedVar__f_underlying.signal__Lcom_raquo_airstream_state_StrictSignal());
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
  var this$2 = this.Lframework_utils_PersistedVar__f_underlying.signal__Lcom_raquo_airstream_state_StrictSignal();
  var this$3 = new $c_Lcom_raquo_airstream_misc_StreamFromSignal(this$2, true);
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_EventStream__mergeWith__sci_Seq__Lcom_raquo_airstream_core_EventStream($x_2, $x_1.wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcom_raquo_airstream_core_EventStream.getArrayOf().constr)([new $c_Lcom_raquo_airstream_timing_DebounceStream(this$3, underlyingDebounceMs)]))));
});
$c_Lframework_utils_PersistedVar.prototype.setAndPersist__O__V = (function(value) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_state_Var__set__O__V(this.Lframework_utils_PersistedVar__f_underlying, value);
  this.persist__O__V(value);
});
$c_Lframework_utils_PersistedVar.prototype.persist__O__V = (function(value) {
  var encoder = this.Lframework_utils_PersistedVar__f_x$6;
  var this$4 = encoder.apply__O__Lio_circe_Json(value);
  var serialized = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_Printer$().Lio_circe_Printer$__f_noSpaces.print__Lio_circe_Json__T(this$4);
  this.Lframework_utils_PersistedVar__f_storage.setItem(this.Lframework_utils_PersistedVar__f_persistenceKey, serialized);
});
$c_Lframework_utils_PersistedVar.prototype.persistEventFromSignal__Lcom_raquo_airstream_core_Signal__I__Lcom_raquo_airstream_core_EventStream = (function(submitting, underlyingDebounceMs) {
  $m_Lframework_exts_EventStreamExts$package$().frameworkEventStreamBooleanExts__Lframework_exts_EventStreamBooleanExts();
  var stream = new $c_Lcom_raquo_airstream_misc_StreamFromSignal(submitting, true);
  var pf = new $c_Lframework_exts_EventStreamBooleanExts$$anon$1();
  var fn = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_PartialFunction$Lifted(pf);
  return this.persistEvent__Lcom_raquo_airstream_core_EventStream__I__Lcom_raquo_airstream_core_EventStream(new $c_Lcom_raquo_airstream_misc_CollectStream(stream, fn), underlyingDebounceMs);
});
$c_Lframework_utils_PersistedVar.prototype.resetToDefault__V = (function() {
  var $x_1 = this.Lframework_utils_PersistedVar__f_underlying;
  var this$1 = this.Lframework_utils_PersistedVar__f_defaultValueVar;
  var this$2 = this$1.signal__Lcom_raquo_airstream_state_StrictSignal();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_state_Var__set__O__V($x_1, this$2.tryNow__s_util_Try().get__O());
  this.Lframework_utils_PersistedVar__f_storage.removeItem(this.Lframework_utils_PersistedVar__f_persistenceKey);
});
$c_Lframework_utils_PersistedVar.prototype.changeDefaultTo__O__V = (function(a) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_state_Var__set__O__V(this.Lframework_utils_PersistedVar__f_defaultValueVar, a);
});
var $d_Lframework_utils_PersistedVar = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_PersistedVar, "framework.utils.PersistedVar", ({
  Lframework_utils_PersistedVar: 1
}));
export { $d_Lframework_utils_PersistedVar as $d_Lframework_utils_PersistedVar };
function $p_Lframework_utils_PrettyPrintDuration$__prettyRec__sci_List__sci_List__s_concurrent_duration_FiniteDuration__Z__s_Option__Lframework_utils_PrettyPrintDuration$Strings__T($thiz, accumulator, remainingUnits, remainingDuration, isPast, maxParts, strs) {
  var remainingDuration$tailLocal1 = remainingDuration;
  var remainingUnits$tailLocal1 = remainingUnits;
  var accumulator$tailLocal1 = accumulator;
  while (true) {
    var x1 = remainingUnits$tailLocal1;
    if ((x1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon)) {
      var x4 = x1.sci_$colon$colon__f_next;
      var timeUnit = x1.sci_$colon$colon__f_head;
      if (maxParts.isEmpty__Z()) {
        var $x_1 = true;
      } else {
        var accumulator$tailLocal1$2 = accumulator$tailLocal1;
        if ((!maxParts.isEmpty__Z())) {
          var x0 = maxParts.get__O();
          var _$1 = (x0 | 0);
          var $x_1 = (accumulator$tailLocal1$2.length__I() < _$1);
        } else {
          var $x_1 = false;
        }
      }
      if ($x_1) {
        var this$2 = remainingDuration$tailLocal1;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$();
        var that = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_FiniteDuration(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(1, 0), timeUnit);
        if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_math_Ordered__$greater__O__Z(this$2, that)) {
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$();
          var value = remainingDuration$tailLocal1.toUnit__ju_concurrent_TimeUnit__D(timeUnit);
          var this$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_RTLong$();
          var lo = this$3.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
          var hi = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          var x = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_FiniteDuration(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi), timeUnit);
          var this$5 = accumulator$tailLocal1;
          var accumulator$tailLocal1$tmp1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(x, this$5);
          var remainingDuration$tailLocal1$tmp1 = remainingDuration$tailLocal1.$minus__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration(x);
          accumulator$tailLocal1 = accumulator$tailLocal1$tmp1;
          remainingUnits$tailLocal1 = x4;
          remainingDuration$tailLocal1 = remainingDuration$tailLocal1$tmp1;
          continue;
        } else {
          remainingUnits$tailLocal1 = x4;
          continue;
        }
      }
    }
    var this$6 = accumulator$tailLocal1;
    var this$7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__reversed__sc_Iterable(this$6).iterator__sc_Iterator();
    var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((strs) => ((duration) => $f_Lframework_utils_PrettyPrintDuration$Strings$EnglishShort__format__s_concurrent_duration_FiniteDuration__T(strs, duration)))(strs));
    var this$8 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(this$7, f);
    var result = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__mkString__T__T__T__T(this$8, "", " ", "");
    return (isPast ? $f_Lframework_utils_PrettyPrintDuration$Strings$EnglishShort__formatNegativeDuration__T__T(strs, result) : result);
  }
}
export { $p_Lframework_utils_PrettyPrintDuration$__prettyRec__sci_List__sci_List__s_concurrent_duration_FiniteDuration__Z__s_Option__Lframework_utils_PrettyPrintDuration$Strings__T as $p_Lframework_utils_PrettyPrintDuration$__prettyRec__sci_List__sci_List__s_concurrent_duration_FiniteDuration__Z__s_Option__Lframework_utils_PrettyPrintDuration$Strings__T };
function $p_Lframework_utils_PrettyPrintDuration$__maxPartsAsOption$1__I__s_Option($thiz, maxParts$1) {
  return ((maxParts$1 === 2147483647) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$() : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(maxParts$1));
}
export { $p_Lframework_utils_PrettyPrintDuration$__maxPartsAsOption$1__I__s_Option as $p_Lframework_utils_PrettyPrintDuration$__maxPartsAsOption$1__I__s_Option };
/** @constructor */
function $c_Lframework_utils_PrettyPrintDuration$() {
  this.Lframework_utils_PrettyPrintDuration$__f_timeUnitList = null;
  $n_Lframework_utils_PrettyPrintDuration$ = this;
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var elem = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
  var this$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem, this$2);
  var elem$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
  var this$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem$1, this$4);
  var elem$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
  var this$8 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem$2, this$6);
  var elem$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
  var this$10 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem$3, this$8);
  var elem$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MINUTES;
  var this$12 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem$4, this$10);
  var elem$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_HOURS;
  var this$14 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem$5, this$12);
  var elem$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS;
  this.Lframework_utils_PrettyPrintDuration$__f_timeUnitList = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem$6, this$14);
}
export { $c_Lframework_utils_PrettyPrintDuration$ as $c_Lframework_utils_PrettyPrintDuration$ };
$c_Lframework_utils_PrettyPrintDuration$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_PrettyPrintDuration$.prototype.constructor = $c_Lframework_utils_PrettyPrintDuration$;
/** @constructor */
function $h_Lframework_utils_PrettyPrintDuration$() {
}
export { $h_Lframework_utils_PrettyPrintDuration$ as $h_Lframework_utils_PrettyPrintDuration$ };
$h_Lframework_utils_PrettyPrintDuration$.prototype = $c_Lframework_utils_PrettyPrintDuration$.prototype;
$c_Lframework_utils_PrettyPrintDuration$.prototype.prettyPrint__s_concurrent_duration_Duration__I__ju_concurrent_TimeUnit__Lframework_utils_PrettyPrintDuration$Strings__T = (function(duration, maxParts, maxGranularity, strs) {
  var x$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
  if ((maxGranularity === x$2)) {
    var timeUnitList = this.Lframework_utils_PrettyPrintDuration$__f_timeUnitList;
  } else {
    var this$1 = this.Lframework_utils_PrettyPrintDuration$__f_timeUnitList;
    var b = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_ListBuffer();
    var these = this$1;
    while (true) {
      if ((!these.isEmpty__Z())) {
        var x0 = these.head__O();
        var $x_1 = (!((x0 === null) ? (maxGranularity === null) : (x0 === maxGranularity)));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var elem = these.head__O();
        b.addOne__O__scm_ListBuffer(elem);
        these = these.tail__O();
      } else {
        break;
      }
    }
    var prefix$1 = b.toList__sci_List();
    var timeUnitList = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(maxGranularity, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$()).$colon$colon$colon__sci_List__sci_List(prefix$1);
  }
  var x$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Zero;
  if (((x$3 === null) ? (duration === null) : x$3.equals__O__Z(duration))) {
    return "now";
  }
  if ((duration instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_FiniteDuration)) {
    var that = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Zero;
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_math_Ordered__$less__O__Z(duration, that)) {
      return $p_Lframework_utils_PrettyPrintDuration$__prettyRec__sci_List__sci_List__s_concurrent_duration_FiniteDuration__Z__s_Option__Lframework_utils_PrettyPrintDuration$Strings__T(this, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$(), timeUnitList, duration.$times__J__s_concurrent_duration_FiniteDuration(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong((-1), (-1))), true, $p_Lframework_utils_PrettyPrintDuration$__maxPartsAsOption$1__I__s_Option(this, maxParts), strs);
    }
    return $p_Lframework_utils_PrettyPrintDuration$__prettyRec__sci_List__sci_List__s_concurrent_duration_FiniteDuration__Z__s_Option__Lframework_utils_PrettyPrintDuration$Strings__T(this, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$(), timeUnitList, duration, false, $p_Lframework_utils_PrettyPrintDuration$__maxPartsAsOption$1__I__s_Option(this, maxParts), strs);
  }
  var x$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Inf;
  if (((x$5 === null) ? (duration === null) : x$5.equals__O__Z(duration))) {
    return "\u221e";
  }
  var x$7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_MinusInf;
  if (((x$7 === null) ? (duration === null) : x$7.equals__O__Z(duration))) {
    return "-\u221e";
  }
  return "undefined";
});
var $d_Lframework_utils_PrettyPrintDuration$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_PrettyPrintDuration$, "framework.utils.PrettyPrintDuration$", ({
  Lframework_utils_PrettyPrintDuration$: 1
}));
export { $d_Lframework_utils_PrettyPrintDuration$ as $d_Lframework_utils_PrettyPrintDuration$ };
var $n_Lframework_utils_PrettyPrintDuration$;
function $m_Lframework_utils_PrettyPrintDuration$() {
  if ((!$n_Lframework_utils_PrettyPrintDuration$)) {
    $n_Lframework_utils_PrettyPrintDuration$ = new $c_Lframework_utils_PrettyPrintDuration$();
  }
  return $n_Lframework_utils_PrettyPrintDuration$;
}
export { $m_Lframework_utils_PrettyPrintDuration$ as $m_Lframework_utils_PrettyPrintDuration$ };
/** @constructor */
function $c_Lframework_utils_PushNotifications$() {
}
export { $c_Lframework_utils_PushNotifications$ as $c_Lframework_utils_PushNotifications$ };
$c_Lframework_utils_PushNotifications$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_PushNotifications$.prototype.constructor = $c_Lframework_utils_PushNotifications$;
/** @constructor */
function $h_Lframework_utils_PushNotifications$() {
}
export { $h_Lframework_utils_PushNotifications$ as $h_Lframework_utils_PushNotifications$ };
$h_Lframework_utils_PushNotifications$.prototype = $c_Lframework_utils_PushNotifications$.prototype;
$c_Lframework_utils_PushNotifications$.prototype.getState__Lorg_scalajs_dom_PushSubscriptionOptions__Lframework_utils_JSLogger__Lcom_raquo_airstream_state_StrictSignal = (function(options, log) {
  var rx = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_state_Var$().apply__O__Lcom_raquo_airstream_state_Var($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var this$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_$less$colon$less$();
  var evidence = this$3.s_$less$colon$less$__f_singleton;
  var sink = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_Observer__contramapSome__s_$less$colon$less__Lcom_raquo_airstream_core_Observer(rx.writer__Lcom_raquo_airstream_core_Observer(), evidence);
  var future = $m_Lframework_exts_FutureExts$package$().orNever__s_concurrent_Future__s_concurrent_Future($m_Lframework_utils_ServiceWorkerRegistration$().get__s_concurrent_Future()).flatMap__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((serviceWorkerRegistration) => {
    var pushManager = serviceWorkerRegistration.pushManager;
    var p = pushManager.permissionState(options);
    return $m_sjs_js_Thenable$ThenableOps$().toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p).flatMap__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((jsState) => {
      if ((jsState === "granted")) {
        var p$1 = pushManager.getSubscription();
        var $x_1 = $m_sjs_js_Thenable$ThenableOps$().toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p$1).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$6) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Option$().apply__O__s_Option(_$6))), $m_Lframework_prelude_prelude\uff3fclient$package$().executionContext__s_concurrent_ExecutionContext()).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$7) => new $c_Lframework_utils_PushNotifications$State$Granted(pushManager, options, _$7, sink))), $m_Lframework_prelude_prelude\uff3fclient$package$().executionContext__s_concurrent_ExecutionContext());
      } else if ((jsState === "denied")) {
        var $x_1 = $m_s_concurrent_Future$().successful__O__s_concurrent_Future($m_Lframework_utils_PushNotifications$State$Denied$());
      } else if ((jsState === "prompt")) {
        var $x_1 = $m_s_concurrent_Future$().successful__O__s_concurrent_Future(new $c_Lframework_utils_PushNotifications$State$Prompt(pushManager, options, sink));
      } else {
        var err$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(["Unknown push permission state", jsState]));
        var file = new $c_Lsourcecode_File("/home/arturaz/work/rapix/framework/client/src/framework/utils/PushNotifications.scala");
        var line = new $c_Lsourcecode_Line(119);
        var name = new $c_Lsourcecode_FullName("framework.utils.PushNotifications.future");
        var definedAt = new $c_Lframework_sourcecode_DefinedAt(file, line, name);
        var this$9 = $m_Lframework_prelude_client\uff3flogging$package$JSAppName$();
        var appName = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Newtype$WithoutValidation__apply__O__O(this$9, "app");
        var level = $s_Lframework_utils_LogLevel$__Error__Lframework_utils_LogLevel();
        log.atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V(level, log.scope__s_Option(), err$1, definedAt, appName);
        var $x_1 = $m_s_concurrent_Future$().successful__O__s_concurrent_Future($m_Lframework_utils_PushNotifications$State$Denied$());
      }
      return $x_1.map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((state) => state)), $m_Lframework_prelude_prelude\uff3fclient$package$().executionContext__s_concurrent_ExecutionContext());
    })), $m_Lframework_prelude_prelude\uff3fclient$package$().executionContext__s_concurrent_ExecutionContext());
  })), $m_Lframework_prelude_prelude\uff3fclient$package$().executionContext__s_concurrent_ExecutionContext());
  future.foreach__F1__s_concurrent_ExecutionContext__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((nextValue) => {
    sink.onNext__O__V(nextValue);
  })), $m_Lframework_prelude_prelude\uff3fclient$package$().executionContext__s_concurrent_ExecutionContext());
  return rx.signal__Lcom_raquo_airstream_state_StrictSignal();
});
var $d_Lframework_utils_PushNotifications$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_PushNotifications$, "framework.utils.PushNotifications$", ({
  Lframework_utils_PushNotifications$: 1
}));
export { $d_Lframework_utils_PushNotifications$ as $d_Lframework_utils_PushNotifications$ };
var $n_Lframework_utils_PushNotifications$;
function $m_Lframework_utils_PushNotifications$() {
  if ((!$n_Lframework_utils_PushNotifications$)) {
    $n_Lframework_utils_PushNotifications$ = new $c_Lframework_utils_PushNotifications$();
  }
  return $n_Lframework_utils_PushNotifications$;
}
export { $m_Lframework_utils_PushNotifications$ as $m_Lframework_utils_PushNotifications$ };
/** @constructor */
function $c_Lframework_utils_ServiceWorkerRegistration$() {
}
export { $c_Lframework_utils_ServiceWorkerRegistration$ as $c_Lframework_utils_ServiceWorkerRegistration$ };
$c_Lframework_utils_ServiceWorkerRegistration$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_ServiceWorkerRegistration$.prototype.constructor = $c_Lframework_utils_ServiceWorkerRegistration$;
/** @constructor */
function $h_Lframework_utils_ServiceWorkerRegistration$() {
}
export { $h_Lframework_utils_ServiceWorkerRegistration$ as $h_Lframework_utils_ServiceWorkerRegistration$ };
$h_Lframework_utils_ServiceWorkerRegistration$.prototype = $c_Lframework_utils_ServiceWorkerRegistration$.prototype;
$c_Lframework_utils_ServiceWorkerRegistration$.prototype.get__s_concurrent_Future = (function() {
  var this$1 = $m_Lframework_exts_NavigatorExts$package$().serviceWorkerOption__Lorg_scalajs_dom_Navigator__s_Option($m_Lframework_prelude_prelude\uff3fclient$package$().window__Lorg_scalajs_dom_Window().navigator);
  if (this$1.isEmpty__Z()) {
    var target = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0 = this$1.get__O();
    var p = x0.ready;
    var target = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($m_sjs_js_Thenable$ThenableOps$().toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p));
  }
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_UnorderedFoldable$();
  var tc = $m_Lcats_instances_package$option$().Lcats_instances_package$option$__f_catsStdInstancesForOption;
  var this$8 = new $c_Lcats_Traverse$ToTraverseOps$$anon$3(target, tc);
  var ec = $m_Lframework_prelude_prelude\uff3fclient$package$().executionContext__s_concurrent_ExecutionContext();
  var ev$2 = new $c_Lcats_instances_FutureInstances$$anon$1(ec);
  return $f_Lcats_Traverse__sequence__O__Lcats_Applicative__O(this$8.Lcats_Traverse$ToTraverseOps$$anon$3__f_typeClassInstance, this$8.Lcats_Traverse$ToTraverseOps$$anon$3__f_self, ev$2);
});
var $d_Lframework_utils_ServiceWorkerRegistration$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_ServiceWorkerRegistration$, "framework.utils.ServiceWorkerRegistration$", ({
  Lframework_utils_ServiceWorkerRegistration$: 1
}));
export { $d_Lframework_utils_ServiceWorkerRegistration$ as $d_Lframework_utils_ServiceWorkerRegistration$ };
var $n_Lframework_utils_ServiceWorkerRegistration$;
function $m_Lframework_utils_ServiceWorkerRegistration$() {
  if ((!$n_Lframework_utils_ServiceWorkerRegistration$)) {
    $n_Lframework_utils_ServiceWorkerRegistration$ = new $c_Lframework_utils_ServiceWorkerRegistration$();
  }
  return $n_Lframework_utils_ServiceWorkerRegistration$;
}
export { $m_Lframework_utils_ServiceWorkerRegistration$ as $m_Lframework_utils_ServiceWorkerRegistration$ };
function $f_Lframework_utils_ToSSEStreamBuilder__rawImpl__O__O__s_Option__F2__F1__F1__Lframework_data_AppBaseUri__Lframework_sourcecode_DefinedAt__Lcom_raquo_airstream_core_EventStream($thiz, securityParams, params, reconnectOnError, createUri, createEventStream, createEithersEventStream, baseUri, definedAt) {
  var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  if ((x === reconnectOnError)) {
    var uri = createUri.apply__O__O__O(securityParams, params);
    return createEventStream.apply__O__O(uri);
  }
  if ((reconnectOnError instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
    var onError = reconnectOnError.s_Some__f_value;
    return $ps_Lframework_utils_ToSSEStreamBuilder__stream$1__F2__F1__Lframework_exts_OnSSEStreamError__Lframework_sourcecode_DefinedAt__O__O__I__Lcom_raquo_airstream_core_EventStream(createUri, createEithersEventStream, onError, definedAt, securityParams, params, 0);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(reconnectOnError);
}
export { $f_Lframework_utils_ToSSEStreamBuilder__rawImpl__O__O__s_Option__F2__F1__F1__Lframework_data_AppBaseUri__Lframework_sourcecode_DefinedAt__Lcom_raquo_airstream_core_EventStream as $f_Lframework_utils_ToSSEStreamBuilder__rawImpl__O__O__s_Option__F2__F1__F1__Lframework_data_AppBaseUri__Lframework_sourcecode_DefinedAt__Lcom_raquo_airstream_core_EventStream };
function $f_Lframework_utils_ToSSEStreamBuilder__apply__O__O__F1__F0__s_Option__Z__Lframework_data_AppBaseUri__Lframework_sourcecode_DefinedAt__Lcom_raquo_airstream_core_EventStream($thiz, securityParams, params, decode, now, reconnectOnError, withCredentials, baseUri, definedAt) {
  if (reconnectOnError.isEmpty__Z()) {
    var modifiedReconnectOnError = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0 = reconnectOnError.get__O();
    var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$2) => (void 0)));
    var modifiedReconnectOnError = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(new $c_Lframework_exts_OnSSEStreamError$$anon$1(f, x0));
  }
  var evtStream = $thiz.raw__O__O__F0__s_Option__Z__Lframework_data_AppBaseUri__Lframework_sourcecode_DefinedAt__Lcom_raquo_airstream_core_EventStream(securityParams, params, now, modifiedReconnectOnError, withCredentials, baseUri, definedAt);
  var project = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((evt) => {
    matchResult4: {
      var this$3;
      var x18 = evt.data;
      if (((typeof x18) === "string")) {
        var this$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(x18);
        break matchResult4;
      }
      var value = ("Event data is not a string: " + x18);
      var this$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value);
    }
    if ((this$3 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
      var b = this$3.s_util_Right__f_value;
      var this$4 = decode.apply__O__O(b);
      var this$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Either$LeftProjection(this$4);
      var x1 = this$5.s_util_Either$LeftProjection__f_e;
      if ((x1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
        var a = x1.s_util_Left__f_value;
        var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(((("Failed to decode event data '" + b) + "': ") + a));
      } else {
        var $x_1 = this$5.s_util_Either$LeftProjection__f_e;
      }
      var this$6 = $x_1;
      if ((this$6 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
        var b$1 = this$6.s_util_Right__f_value;
        var either = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), evt, b$1));
      } else {
        var either = this$6;
      }
    } else {
      var either = this$3;
    }
    if ((either instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
      var err = either.s_util_Left__f_value;
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Exception__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Exception(), err);
    }
    if ((either instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
      var value$1 = either.s_util_Right__f_value;
      matchResult5: {
        var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        if ((x === reconnectOnError)) {
          break matchResult5;
        }
        if ((reconnectOnError instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
          var handler = reconnectOnError.s_Some__f_value;
          handler.onMessage__O__V(value$1);
          break matchResult5;
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(reconnectOnError);
      }
      return value$1;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(either);
  }));
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapStream(evtStream, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
}
export { $f_Lframework_utils_ToSSEStreamBuilder__apply__O__O__F1__F0__s_Option__Z__Lframework_data_AppBaseUri__Lframework_sourcecode_DefinedAt__Lcom_raquo_airstream_core_EventStream as $f_Lframework_utils_ToSSEStreamBuilder__apply__O__O__F1__F0__s_Option__Z__Lframework_data_AppBaseUri__Lframework_sourcecode_DefinedAt__Lcom_raquo_airstream_core_EventStream };
function $f_Lframework_utils_ToSSEStreamBuilder__json__O__O__F0__s_Option__Z__Lframework_data_AppBaseUri__Lio_circe_Decoder__Lframework_sourcecode_DefinedAt__Lcom_raquo_airstream_core_EventStream($thiz, securityParams, params, now, reconnectOnError, withCredentials, baseUri, codec, definedAt) {
  return $f_Lframework_utils_ToSSEStreamBuilder__apply__O__O__F1__F0__s_Option__Z__Lframework_data_AppBaseUri__Lframework_sourcecode_DefinedAt__Lcom_raquo_airstream_core_EventStream($thiz, securityParams, params, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$3) => {
    var this$1 = $m_Lframework_exts_CirceDecoderExts$package$().parseAndDecode__Lio_circe_Decoder__T__s_util_Either(codec, _$3);
    var this$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Either$LeftProjection(this$1);
    var x1 = this$2.s_util_Either$LeftProjection__f_e;
    if ((x1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
      var a = x1.s_util_Left__f_value;
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(("Failed to decode event data: " + a));
    } else {
      return this$2.s_util_Either$LeftProjection__f_e;
    }
  })), now, reconnectOnError, withCredentials, baseUri, definedAt);
}
export { $f_Lframework_utils_ToSSEStreamBuilder__json__O__O__F0__s_Option__Z__Lframework_data_AppBaseUri__Lio_circe_Decoder__Lframework_sourcecode_DefinedAt__Lcom_raquo_airstream_core_EventStream as $f_Lframework_utils_ToSSEStreamBuilder__json__O__O__F0__s_Option__Z__Lframework_data_AppBaseUri__Lio_circe_Decoder__Lframework_sourcecode_DefinedAt__Lcom_raquo_airstream_core_EventStream };
function $f_Lframework_utils_ToSSEStreamBuilder__json$default$3__F0($thiz) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lframework_data_FrameworkDateTime($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_data_FrameworkDateTime$().now__Ljava_time_LocalDateTime())));
}
export { $f_Lframework_utils_ToSSEStreamBuilder__json$default$3__F0 as $f_Lframework_utils_ToSSEStreamBuilder__json$default$3__F0 };
function $ps_Lframework_utils_ToSSEStreamBuilder__stream$1__F2__F1__Lframework_exts_OnSSEStreamError__Lframework_sourcecode_DefinedAt__O__O__I__Lcom_raquo_airstream_core_EventStream(createUri$1, createEithersEventStream$1, onError$1, definedAt$1, securityParams, params, index) {
  var uri = createUri$1.apply__O__O__O(securityParams, params);
  var this$10 = createEithersEventStream$1.apply__O__O(uri);
  var project$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1) => {
    if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
      var value = x$1.s_util_Right__f_value;
      onError$1.onMessage__O__V(value);
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_EventStream$().fromValue__O__Z__Lcom_raquo_airstream_core_EventStream(value, ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_EventStream$(), false));
    }
    if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
      var error = x$1.s_util_Left__f_value;
      var x1 = onError$1.onError__Lsttp_model_Uri__Lorg_scalajs_dom_Event__I__O__O__Lframework_sourcecode_DefinedAt__Lframework_exts_OnSSEStreamError$OnErrorAction(uri, error, index, securityParams, params, definedAt$1);
      if ((x1 instanceof $c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter)) {
        var x7 = x1.Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter__f_securityInput;
        var x8 = x1.Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter__f_input;
        var x9 = x1.Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter__f_after;
        var this$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_EventStream$();
        var a = x9.s_concurrent_duration_FiniteDuration__f_unit.toMillis__J__J(x9.s_concurrent_duration_FiniteDuration__f_length);
        var ms = a.RTLong__f_lo;
        var this$7 = this$6.delay__I__O__Z__Lcom_raquo_airstream_core_EventStream(ms, (void 0), false);
        var project = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$1) => $ps_Lframework_utils_ToSSEStreamBuilder__stream$1__F2__F1__Lframework_exts_OnSSEStreamError__Lframework_sourcecode_DefinedAt__O__O__I__Lcom_raquo_airstream_core_EventStream(createUri$1, createEithersEventStream$1, onError$1, definedAt$1, x7, x8, ((1 + index) | 0))));
        var strategy = $m_Lcom_raquo_airstream_core_Observable$().Lcom_raquo_airstream_core_Observable$__f_switchStreamStrategy;
        return strategy.flatten__Lcom_raquo_airstream_core_Observable__Lcom_raquo_airstream_core_Observable(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapStream(this$7, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()));
      }
      if ((x1 instanceof $c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith)) {
        var x4 = x1.Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith__f_stream;
        return x4;
      }
      var x = $s_Lframework_exts_OnSSEStreamError$OnErrorAction$__Stop__Lframework_exts_OnSSEStreamError$OnErrorAction();
      if (((x === null) ? (x1 === null) : x.equals__O__Z(x1))) {
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_EventStream$().Lcom_raquo_airstream_core_EventStream$__f_empty;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  }));
  var strategy$1 = $m_Lcom_raquo_airstream_core_Observable$().Lcom_raquo_airstream_core_Observable$__f_switchStreamStrategy;
  return strategy$1.flatten__Lcom_raquo_airstream_core_Observable__Lcom_raquo_airstream_core_Observable(this$10.map__F1__Lcom_raquo_airstream_core_Observable(project$1));
}
export { $ps_Lframework_utils_ToSSEStreamBuilder__stream$1__F2__F1__Lframework_exts_OnSSEStreamError__Lframework_sourcecode_DefinedAt__O__O__I__Lcom_raquo_airstream_core_EventStream as $ps_Lframework_utils_ToSSEStreamBuilder__stream$1__F2__F1__Lframework_exts_OnSSEStreamError__Lframework_sourcecode_DefinedAt__O__O__I__Lcom_raquo_airstream_core_EventStream };
/** @constructor */
function $c_Lframework_utils_ToSSEStreamBuilder$() {
}
export { $c_Lframework_utils_ToSSEStreamBuilder$ as $c_Lframework_utils_ToSSEStreamBuilder$ };
$c_Lframework_utils_ToSSEStreamBuilder$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_ToSSEStreamBuilder$.prototype.constructor = $c_Lframework_utils_ToSSEStreamBuilder$;
/** @constructor */
function $h_Lframework_utils_ToSSEStreamBuilder$() {
}
export { $h_Lframework_utils_ToSSEStreamBuilder$ as $h_Lframework_utils_ToSSEStreamBuilder$ };
$h_Lframework_utils_ToSSEStreamBuilder$.prototype = $c_Lframework_utils_ToSSEStreamBuilder$.prototype;
$c_Lframework_utils_ToSSEStreamBuilder$.prototype.sseWithWebSocketFallback$default$4__F1 = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((index) => {
    var index$1 = (index | 0);
    return $m_Lframework_exts_OnSSEStreamError$().defaultWaitFor__I__s_concurrent_duration_FiniteDuration(index$1);
  }));
});
$c_Lframework_utils_ToSSEStreamBuilder$.prototype.sseWithWebSocketFallback$default$5__s_concurrent_duration_FiniteDuration = (function() {
  var this$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_package$DurationInt(1);
  var unit = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
  var this$ = this$2.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$();
  var hi = (this$ >> 31);
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_FiniteDuration(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(this$, hi), unit);
});
$c_Lframework_utils_ToSSEStreamBuilder$.prototype.sseWithWebSocketFallback$default$6__s_concurrent_duration_FiniteDuration = (function() {
  var this$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_package$DurationInt(8);
  var unit = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
  var this$ = this$2.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$();
  var hi = (this$ >> 31);
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_FiniteDuration(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(this$, hi), unit);
});
var $d_Lframework_utils_ToSSEStreamBuilder$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_ToSSEStreamBuilder$, "framework.utils.ToSSEStreamBuilder$", ({
  Lframework_utils_ToSSEStreamBuilder$: 1
}));
export { $d_Lframework_utils_ToSSEStreamBuilder$ as $d_Lframework_utils_ToSSEStreamBuilder$ };
var $n_Lframework_utils_ToSSEStreamBuilder$;
function $m_Lframework_utils_ToSSEStreamBuilder$() {
  if ((!$n_Lframework_utils_ToSSEStreamBuilder$)) {
    $n_Lframework_utils_ToSSEStreamBuilder$ = new $c_Lframework_utils_ToSSEStreamBuilder$();
  }
  return $n_Lframework_utils_ToSSEStreamBuilder$;
}
export { $m_Lframework_utils_ToSSEStreamBuilder$ as $m_Lframework_utils_ToSSEStreamBuilder$ };
function $f_Lframework_utils_UnvalidatedNewtypeOf__empty__Lalleycats_Empty__Lalleycats_Empty($thiz, empty) {
  var a = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
    var underlying = empty.empty__O();
    return underlying;
  }));
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lalleycats_Empty$$anon$1(a);
}
export { $f_Lframework_utils_UnvalidatedNewtypeOf__empty__Lalleycats_Empty__Lalleycats_Empty as $f_Lframework_utils_UnvalidatedNewtypeOf__empty__Lalleycats_Empty__Lalleycats_Empty };
function $f_Lframework_utils_UnvalidatedNewtypeOf__circeCodec__Lio_circe_Decoder__Lio_circe_Encoder__Lio_circe_Codec($thiz, decoder, encoder) {
  var target = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lio_circe_Codec$$anon$4(decoder, encoder);
  var tc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_Codec$().Lio_circe_Codec$__f_codecInvariant;
  var this$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Invariant$ToInvariantOps$$anon$19(target, tc);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((underlying) => underlying));
  var g = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((unvalidated) => unvalidated));
  return this$6.Lcats_Invariant$ToInvariantOps$$anon$19__f_typeClassInstance.imap__O__F1__F1__O(this$6.Lcats_Invariant$ToInvariantOps$$anon$19__f_self, f, g);
}
export { $f_Lframework_utils_UnvalidatedNewtypeOf__circeCodec__Lio_circe_Decoder__Lio_circe_Encoder__Lio_circe_Codec as $f_Lframework_utils_UnvalidatedNewtypeOf__circeCodec__Lio_circe_Decoder__Lio_circe_Encoder__Lio_circe_Codec };
function $f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer($thiz) {
  return $m_Lframework_exts_PartialTransformerExts$package$().fromEitherStrings__Lio_scalaland_chimney_PartialTransformer$__F1__Lio_scalaland_chimney_PartialTransformer($m_Lio_scalaland_chimney_PartialTransformer$(), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((unvalidated) => {
    var this$2 = $thiz.companionOfValidated__Lyantl_INewtype().make__Lyantl_INewtype$make$();
    var asString = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_prelude_newtype$package$().given_AsString_Any__Lyantl_AsString();
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Make__asStrings__O__Lyantl_AsString__s_util_Either(this$2, unvalidated, asString);
  })));
}
export { $f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer as $f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer };
function $f_Lframework_utils_UnvalidatedNewtypeOf__validateAsOption__O__s_Option($thiz, unvalidated) {
  return $thiz.companionOfValidated__Lyantl_INewtype().make__Lyantl_INewtype$make$().apply__O__s_util_Either(unvalidated).toOption__s_Option();
}
export { $f_Lframework_utils_UnvalidatedNewtypeOf__validateAsOption__O__s_Option as $f_Lframework_utils_UnvalidatedNewtypeOf__validateAsOption__O__s_Option };
function $f_Lframework_utils_UnvalidatedNewtypeOf__isValid__O__Z($thiz, unvalidated) {
  return $thiz.companionOfValidated__Lyantl_INewtype().make__Lyantl_INewtype$make$().apply__O__s_util_Either(unvalidated).isRight__Z();
}
export { $f_Lframework_utils_UnvalidatedNewtypeOf__isValid__O__Z as $f_Lframework_utils_UnvalidatedNewtypeOf__isValid__O__Z };
function $f_Lframework_utils_UnvalidatedNewtypeOf__isInvalid__O__Z($thiz, unvalidated) {
  return $thiz.companionOfValidated__Lyantl_INewtype().make__Lyantl_INewtype$make$().apply__O__s_util_Either(unvalidated).isLeft__Z();
}
export { $f_Lframework_utils_UnvalidatedNewtypeOf__isInvalid__O__Z as $f_Lframework_utils_UnvalidatedNewtypeOf__isInvalid__O__Z };
function $f_Lframework_utils_WithLogger__log__Lframework_utils_JSLogger($thiz) {
  var this$2 = $m_Lframework_prelude_log$();
  var this$1 = $thiz.enclosingForLogger__Lsourcecode_Enclosing().Lsourcecode_Enclosing__f_value;
  var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__split__T__I__AT(this$1, "\\.", 0);
  var scope = ((parts.u.length < 2) ? "<unknown>" : parts.u[(((-2) + parts.u.length) | 0)]);
  return $f_Lframework_utils_JSLogger__scoped__T__Lframework_utils_JSLogger(this$2, scope);
}
export { $f_Lframework_utils_WithLogger__log__Lframework_utils_JSLogger as $f_Lframework_utils_WithLogger__log__Lframework_utils_JSLogger };
function $f_Lfs2_Compiler$TargetLowPriority__forSync__Lcats_effect_kernel_Sync__Lfs2_Compiler$Target($thiz, F) {
  return ($is_Lcats_effect_kernel_Async(F) ? new $c_Lfs2_Compiler$Target$ConcurrentTarget(F) : new $c_Lfs2_Compiler$TargetLowPriority$SyncTarget(F));
}
export { $f_Lfs2_Compiler$TargetLowPriority__forSync__Lcats_effect_kernel_Sync__Lfs2_Compiler$Target as $f_Lfs2_Compiler$TargetLowPriority__forSync__Lcats_effect_kernel_Sync__Lfs2_Compiler$Target };
/** @constructor */
function $c_Lfs2_Pull() {
}
export { $c_Lfs2_Pull as $c_Lfs2_Pull };
$c_Lfs2_Pull.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_Pull.prototype.constructor = $c_Lfs2_Pull;
/** @constructor */
function $h_Lfs2_Pull() {
}
export { $h_Lfs2_Pull as $h_Lfs2_Pull };
$h_Lfs2_Pull.prototype = $c_Lfs2_Pull.prototype;
$c_Lfs2_Pull.prototype.map__F1__Lfs2_Pull = (function(f) {
  return new $c_Lfs2_Pull$$anon$4(f, this);
});
$c_Lfs2_Pull.prototype.as__O__Lfs2_Pull = (function(s) {
  return this.map__F1__Lfs2_Pull(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => s)));
});
/** @constructor */
function $c_Lfs2_Pull$IdOps$() {
}
export { $c_Lfs2_Pull$IdOps$ as $c_Lfs2_Pull$IdOps$ };
$c_Lfs2_Pull$IdOps$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_Pull$IdOps$.prototype.constructor = $c_Lfs2_Pull$IdOps$;
/** @constructor */
function $h_Lfs2_Pull$IdOps$() {
}
export { $h_Lfs2_Pull$IdOps$ as $h_Lfs2_Pull$IdOps$ };
$h_Lfs2_Pull$IdOps$.prototype = $c_Lfs2_Pull$IdOps$.prototype;
$c_Lfs2_Pull$IdOps$.prototype.covaryId$extension__Lfs2_Pull__Lcats_Applicative__Lfs2_Pull = (function(this$, evidence$1) {
  return $m_Lfs2_Pull$().translate__Lfs2_Pull__Lcats_arrow_FunctionK__Lfs2_Pull(this$, new $c_Lfs2_Pull$IdOps$$anon$10(evidence$1));
});
var $d_Lfs2_Pull$IdOps$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$IdOps$, "fs2.Pull$IdOps$", ({
  Lfs2_Pull$IdOps$: 1
}));
export { $d_Lfs2_Pull$IdOps$ as $d_Lfs2_Pull$IdOps$ };
var $n_Lfs2_Pull$IdOps$;
function $m_Lfs2_Pull$IdOps$() {
  if ((!$n_Lfs2_Pull$IdOps$)) {
    $n_Lfs2_Pull$IdOps$ = new $c_Lfs2_Pull$IdOps$();
  }
  return $n_Lfs2_Pull$IdOps$;
}
export { $m_Lfs2_Pull$IdOps$ as $m_Lfs2_Pull$IdOps$ };
/** @constructor */
function $c_Lfs2_Pull$StreamPullOps$() {
}
export { $c_Lfs2_Pull$StreamPullOps$ as $c_Lfs2_Pull$StreamPullOps$ };
$c_Lfs2_Pull$StreamPullOps$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_Pull$StreamPullOps$.prototype.constructor = $c_Lfs2_Pull$StreamPullOps$;
/** @constructor */
function $h_Lfs2_Pull$StreamPullOps$() {
}
export { $h_Lfs2_Pull$StreamPullOps$ as $h_Lfs2_Pull$StreamPullOps$ };
$h_Lfs2_Pull$StreamPullOps$.prototype = $c_Lfs2_Pull$StreamPullOps$.prototype;
$c_Lfs2_Pull$StreamPullOps$.prototype.stream$extension__Lfs2_Pull__Lfs2_Stream = (function(this$) {
  return new $c_Lfs2_Stream(($m_Lfs2_Pull$(), new $c_Lfs2_Pull$InScope(this$, false)));
});
$c_Lfs2_Pull$StreamPullOps$.prototype.flatMapOutput$extension__Lfs2_Pull__F1__Lfs2_Pull = (function(this$, f) {
  return ((this$ instanceof $c_Lfs2_Pull$AlgEffect) ? this$ : ((this$ instanceof $c_Lfs2_Pull$Terminal) ? this$ : new $c_Lfs2_Pull$FlatMapOutput(this$, f)));
});
$c_Lfs2_Pull$StreamPullOps$.prototype.unconsFlatMap$extension__Lfs2_Pull__F1__Lfs2_Pull = (function(this$, f) {
  var this$3 = this.uncons$extension__Lfs2_Pull__Lfs2_Pull(this$);
  var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    if ((x === x$1)) {
      return $m_Lfs2_Pull$().Lfs2_Pull$__f_done;
    }
    if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var x35 = x$1.s_Some__f_value;
      if ((x35 !== null)) {
        var hd = x35._1__O();
        var tl = x35._2__O();
        var this$2 = f.apply__O__O(hd);
        var post = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $m_Lfs2_Pull$StreamPullOps$().unconsFlatMap$extension__Lfs2_Pull__F1__Lfs2_Pull(($m_Lfs2_Pull$(), tl), f)));
        return new $c_Lfs2_Pull$$anon$2(post, this$2);
      }
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  }));
  return new $c_Lfs2_Pull$$anon$1(f$1, this$3);
});
$c_Lfs2_Pull$StreamPullOps$.prototype.uncons$extension__Lfs2_Pull__Lfs2_Pull = (function(this$) {
  if ((this$ instanceof $c_Lfs2_Pull$Succeeded)) {
    var r = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    var $x_1 = new $c_Lfs2_Pull$Succeeded(r);
  } else if ((this$ instanceof $c_Lfs2_Pull$Output)) {
    var x43 = this$.Lfs2_Pull$Output__f_values;
    var y = $m_Lfs2_Pull$().Lfs2_Pull$__f_fs2$Pull$$$unit;
    var value = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), x43, y);
    var r$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
    var $x_1 = new $c_Lfs2_Pull$Succeeded(r$1);
  } else {
    var $x_1 = ((this$ instanceof $c_Lfs2_Pull$Fail) ? this$ : ((this$ instanceof $c_Lfs2_Pull$Interrupted) ? this$ : new $c_Lfs2_Pull$Uncons(this$)));
  }
  return $x_1;
});
var $d_Lfs2_Pull$StreamPullOps$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$StreamPullOps$, "fs2.Pull$StreamPullOps$", ({
  Lfs2_Pull$StreamPullOps$: 1
}));
export { $d_Lfs2_Pull$StreamPullOps$ as $d_Lfs2_Pull$StreamPullOps$ };
var $n_Lfs2_Pull$StreamPullOps$;
function $m_Lfs2_Pull$StreamPullOps$() {
  if ((!$n_Lfs2_Pull$StreamPullOps$)) {
    $n_Lfs2_Pull$StreamPullOps$ = new $c_Lfs2_Pull$StreamPullOps$();
  }
  return $n_Lfs2_Pull$StreamPullOps$;
}
export { $m_Lfs2_Pull$StreamPullOps$ as $m_Lfs2_Pull$StreamPullOps$ };
/** @constructor */
function $c_Lfs2_RaiseThrowable$() {
}
export { $c_Lfs2_RaiseThrowable$ as $c_Lfs2_RaiseThrowable$ };
$c_Lfs2_RaiseThrowable$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_RaiseThrowable$.prototype.constructor = $c_Lfs2_RaiseThrowable$;
/** @constructor */
function $h_Lfs2_RaiseThrowable$() {
}
export { $h_Lfs2_RaiseThrowable$ as $h_Lfs2_RaiseThrowable$ };
$h_Lfs2_RaiseThrowable$.prototype = $c_Lfs2_RaiseThrowable$.prototype;
$c_Lfs2_RaiseThrowable$.prototype.fromApplicativeError__Lcats_ApplicativeError__Lfs2_RaiseThrowable = (function(F) {
  return new $c_Lfs2_RaiseThrowable$$anon$1();
});
var $d_Lfs2_RaiseThrowable$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_RaiseThrowable$, "fs2.RaiseThrowable$", ({
  Lfs2_RaiseThrowable$: 1
}));
export { $d_Lfs2_RaiseThrowable$ as $d_Lfs2_RaiseThrowable$ };
var $n_Lfs2_RaiseThrowable$;
function $m_Lfs2_RaiseThrowable$() {
  if ((!$n_Lfs2_RaiseThrowable$)) {
    $n_Lfs2_RaiseThrowable$ = new $c_Lfs2_RaiseThrowable$();
  }
  return $n_Lfs2_RaiseThrowable$;
}
export { $m_Lfs2_RaiseThrowable$ as $m_Lfs2_RaiseThrowable$ };
function $p_Lfs2_Stream__merge___Lfs2_Stream__F2__Lcats_effect_kernel_GenConcurrent__Lfs2_Stream($thiz, that, f, F) {
  var $x_3 = $m_Lfs2_Stream$();
  var $x_1 = $m_Lfs2_concurrent_SignallingRef$();
  var _1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var _2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var target = $x_1.of__O__Lcats_effect_kernel_GenConcurrent__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, _2), F);
  var this$39 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F);
  var f$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((bothStates) => {
    var this$4 = $m_Lfs2_concurrent_Channel$();
    var target$1 = this$4.bounded__I__Lcats_effect_kernel_GenConcurrent__O(0, F);
    var this$38 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, F);
    var f$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((bothStates$2) => ((output) => {
      var target$2 = $m_Lcats_effect_IO$().deferred__Lcats_effect_IO();
      var this$37 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, F);
      var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((output$2) => ((stopDef) => {
        var target$3 = stopDef.complete__O__Lcats_effect_IO((void 0));
        var this$9 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target$3, F);
        var signalStop = this$9.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.void__O__O(this$9.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
        var target$4 = stopDef.get__Lcats_effect_IO();
        var this$12 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target$4, F);
        var b = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right((void 0));
        var stop = this$12.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.as__O__O__O(this$12.Lcats_Functor$ToFunctorOps$$anon$5__f_self, b);
        var bothStopped = new $c_Lfs2_Stream$$anon$2();
        var this$13 = bothStates$2.discrete__Lfs2_Stream().collect__s_PartialFunction__Lfs2_Stream(bothStopped);
        var $x_2 = this$13.take__J__Lfs2_Stream(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(1, 0));
        var this$14 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_$less$colon$less$();
        var this$17 = $x_2.rethrow__s_$less$colon$less__Lfs2_RaiseThrowable__Lfs2_Stream(this$14.s_$less$colon$less$__f_singleton, $m_Lfs2_RaiseThrowable$().fromApplicativeError__Lcats_ApplicativeError__Lfs2_RaiseThrowable(F));
        $m_Lfs2_Compiler$();
        var F$1 = new $c_Lfs2_Compiler$Target$ConcurrentTarget(F);
        var compiler = new $c_Lfs2_CompilerLowPriority1$$anon$2(F$1);
        var wrapped = new $c_Lfs2_Stream$CompileOps(this$17.Lfs2_Stream__f_underlying, compiler).drain__O();
        var target$5 = output$2.close__O();
        var this$20 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target$5, F);
        var fin = this$20.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.void__O__O(this$20.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
        var waitForBoth = wrapped.guarantee__Lcats_effect_IO__Lcats_effect_IO(fin);
        var this$22 = $m_Lcats_effect_kernel_implicits$();
        var wrapped$1 = $ps_Lfs2_Stream__run$1__Lcats_effect_kernel_GenConcurrent__Lfs2_concurrent_Channel__F2__O__O__Lfs2_concurrent_SignallingRef__Lfs2_Stream__O(F, output$2, f, stop, signalStop, bothStates$2, $thiz);
        var ev$164 = $f_Lcats_effect_kernel_syntax_GenSpawnSyntax__genSpawnOps__O__Lcats_effect_kernel_GenSpawn__O(this$22, wrapped$1, F);
        var fa = new $c_Lcats_effect_IO$Start(ev$164);
        var fa$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
          var this$26 = $m_Lcats_effect_kernel_implicits$();
          var wrapped$2 = $ps_Lfs2_Stream__run$1__Lcats_effect_kernel_GenConcurrent__Lfs2_concurrent_Channel__F2__O__O__Lfs2_concurrent_SignallingRef__Lfs2_Stream__O(F, output$2, f, stop, signalStop, bothStates$2, that);
          var ev$165 = $f_Lcats_effect_kernel_syntax_GenSpawnSyntax__genSpawnOps__O__Lcats_effect_kernel_GenSpawn__O(this$26, wrapped$2, F);
          return new $c_Lcats_effect_IO$Start(ev$165);
        })), F);
        var setup = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa$1, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
          var this$30 = $m_Lcats_effect_kernel_implicits$();
          var ev$167 = $f_Lcats_effect_kernel_syntax_GenSpawnSyntax__genSpawnOps__O__Lcats_effect_kernel_GenSpawn__O(this$30, waitForBoth, F);
          return new $c_Lcats_effect_IO$Start(ev$167);
        })), F);
        return $m_Lfs2_Stream$().bracket__O__F1__Lfs2_Stream(setup, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((wfb) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(signalStop, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((wfb$2) => (() => {
          var this$34 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_$less$colon$less$();
          return $f_Lcats_effect_kernel_Fiber__joinWithUnit__Lcats_effect_kernel_MonadCancel__s_$less$colon$less__O(wfb$2, F, this$34.s_$less$colon$less$__f_singleton);
        }))(wfb)), F)))).$greater$greater__F0__s_util_NotGiven__Lfs2_Stream(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
          var this$36 = output$2.stream__Lfs2_Stream();
          var this$35 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_$less$colon$less$();
          var ev = this$35.s_$less$colon$less$__f_singleton;
          return this$36.flatMap__F1__s_util_NotGiven__Lfs2_Stream(ev, $m_s_util_NotGiven$().s_util_NotGiven$__f_cachedValue).interruptWhen__O__Lfs2_Stream(stop);
        })), $m_s_util_NotGiven$().s_util_NotGiven$__f_cachedValue);
      }))(output));
      return this$37.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.map__O__F1__O(this$37.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$1);
    }))(bothStates));
    return this$38.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$38.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
  }));
  return $x_3.force__O__Lfs2_Stream(this$39.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$39.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3));
}
export { $p_Lfs2_Stream__merge___Lfs2_Stream__F2__Lcats_effect_kernel_GenConcurrent__Lfs2_Stream as $p_Lfs2_Stream__merge___Lfs2_Stream__F2__Lcats_effect_kernel_GenConcurrent__Lfs2_Stream };
function $ps_Lfs2_Stream__complete$1__Lfs2_concurrent_SignallingRef__s_util_Either__O(bothStates$3, result) {
  return bothStates$3.update__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 !== null)) {
      var x256 = x$1._1__O();
      var x257 = x$1._2__O();
      var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      if ((x === x256)) {
        var x$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        var $x_1 = (x$3 === x257);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var _1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(result);
        var _2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, _2);
      }
      var x$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      if ((x$5 === x257)) {
        var _2$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(result);
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), x256, _2$1);
      }
    }
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_sys_package$().error__T__E("impossible");
  })));
}
export { $ps_Lfs2_Stream__complete$1__Lfs2_concurrent_SignallingRef__s_util_Either__O as $ps_Lfs2_Stream__complete$1__Lfs2_concurrent_SignallingRef__s_util_Either__O };
function $ps_Lfs2_Stream__sendChunk$1__Lfs2_concurrent_Channel__F2__Lcats_effect_std_Semaphore__Lcats_effect_kernel_GenConcurrent__Lfs2_Chunk__O(output$4, f$62, guard$9, F$55, chk) {
  var a = f$62.apply__O__O__O($m_Lfs2_Stream$().chunk__Lfs2_Chunk__Lfs2_Stream(chk), guard$9.releaseN__J__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(1, 0)));
  var fa = output$4.sendImpl__O__Z__O(a, false);
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => guard$9.acquireN__J__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(1, 0)))), F$55);
}
export { $ps_Lfs2_Stream__sendChunk$1__Lfs2_concurrent_Channel__F2__Lcats_effect_std_Semaphore__Lcats_effect_kernel_GenConcurrent__Lfs2_Chunk__O as $ps_Lfs2_Stream__sendChunk$1__Lfs2_concurrent_Channel__F2__Lcats_effect_std_Semaphore__Lcats_effect_kernel_GenConcurrent__Lfs2_Chunk__O };
function $ps_Lfs2_Stream__run$1__Lcats_effect_kernel_GenConcurrent__Lfs2_concurrent_Channel__F2__O__O__Lfs2_concurrent_SignallingRef__Lfs2_Stream__O(F$53, output$2, f$60, stop$1, signalStop$1, bothStates$4, s) {
  var target = $m_Lcats_effect_std_Semaphore$().apply__J__Lcats_effect_kernel_GenConcurrent__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(1, 0), F$53);
  var this$11 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F$53);
  var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((guard) => {
    var this$4 = $m_Lfs2_Stream$().exec__O__Lfs2_Stream(guard.acquireN__J__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(1, 0))).$plus$plus__F0__Lfs2_Stream(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((guard$2) => (() => s.chunks__Lfs2_Stream().foreach__F1__Lfs2_Stream(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((chk) => $ps_Lfs2_Stream__sendChunk$1__Lfs2_concurrent_Channel__F2__Lcats_effect_std_Semaphore__Lcats_effect_kernel_GenConcurrent__Lfs2_Chunk__O(output$2, f$60, guard$2, F$53, chk))))))(guard))).interruptWhen__O__Lfs2_Stream(stop$1);
    $m_Lfs2_Compiler$();
    var F = new $c_Lfs2_Compiler$Target$ConcurrentTarget(F$53);
    var compiler = new $c_Lfs2_CompilerLowPriority1$$anon$2(F);
    var fa = new $c_Lfs2_Stream$CompileOps(this$4.Lfs2_Stream__f_underlying, compiler).drain__O();
    var target$1 = new $c_Lcats_effect_IO$Attempt(fa);
    var this$10 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, F$53);
    var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
      if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
        var fa$1 = $ps_Lfs2_Stream__complete$1__Lfs2_concurrent_SignallingRef__s_util_Either__O(bothStates$4, x$1);
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa$1, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => signalStop$1)), F$53);
      }
      if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
        var x$2 = x$1.s_util_Right__f_value;
        if ((x$2 === (void 0))) {
          return $ps_Lfs2_Stream__complete$1__Lfs2_concurrent_SignallingRef__s_util_Either__O(bothStates$4, x$1);
        }
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    }));
    return this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  }));
  return this$11.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$11.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
}
export { $ps_Lfs2_Stream__run$1__Lcats_effect_kernel_GenConcurrent__Lfs2_concurrent_Channel__F2__O__O__Lfs2_concurrent_SignallingRef__Lfs2_Stream__O as $ps_Lfs2_Stream__run$1__Lcats_effect_kernel_GenConcurrent__Lfs2_concurrent_Channel__F2__O__O__Lfs2_concurrent_SignallingRef__Lfs2_Stream__O };
/** @constructor */
function $c_Lfs2_Stream(underlying) {
  this.Lfs2_Stream__f_underlying = null;
  this.Lfs2_Stream__f_underlying = underlying;
}
export { $c_Lfs2_Stream as $c_Lfs2_Stream };
$c_Lfs2_Stream.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_Stream.prototype.constructor = $c_Lfs2_Stream;
/** @constructor */
function $h_Lfs2_Stream() {
}
export { $h_Lfs2_Stream as $h_Lfs2_Stream };
$h_Lfs2_Stream.prototype = $c_Lfs2_Stream.prototype;
$c_Lfs2_Stream.prototype.$plus$plus__F0__Lfs2_Stream = (function(s2) {
  $m_Lfs2_Pull$();
  var this$1 = this.Lfs2_Stream__f_underlying;
  var post = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => s2.apply__O().Lfs2_Stream__f_underlying));
  var self = new $c_Lfs2_Pull$$anon$2(post, this$1);
  return new $c_Lfs2_Stream(self);
});
$c_Lfs2_Stream.prototype.chunks__Lfs2_Stream = (function() {
  $m_Lfs2_Pull$();
  $m_Lfs2_Pull$();
  var self = this.Lfs2_Stream__f_underlying;
  var self$1 = $m_Lfs2_Pull$StreamPullOps$().unconsFlatMap$extension__Lfs2_Pull__F1__Lfs2_Pull(self, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((o) => $m_Lfs2_Pull$().output1__O__Lfs2_Pull(o))));
  return $m_Lfs2_Pull$StreamPullOps$().stream$extension__Lfs2_Pull__Lfs2_Stream(self$1);
});
$c_Lfs2_Stream.prototype.collect__s_PartialFunction__Lfs2_Stream = (function(pf) {
  return this.mapChunks__F1__Lfs2_Stream(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$8) => _$8.collect__s_PartialFunction__Lfs2_Chunk(pf))));
});
$c_Lfs2_Stream.prototype.cons__Lfs2_Chunk__Lfs2_Stream = (function(c) {
  return (c.isEmpty__Z() ? this : $m_Lfs2_Stream$().chunk__Lfs2_Chunk__Lfs2_Stream(c).$plus$plus__F0__Lfs2_Stream(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => this))));
});
$c_Lfs2_Stream.prototype.flatMap__F1__s_util_NotGiven__Lfs2_Stream = (function(f, ev) {
  $m_Lfs2_Pull$();
  $m_Lfs2_Pull$();
  var self = this.Lfs2_Stream__f_underlying;
  var self$1 = $m_Lfs2_Pull$StreamPullOps$().flatMapOutput$extension__Lfs2_Pull__F1__Lfs2_Pull(self, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((o) => f.apply__O__O(o).Lfs2_Stream__f_underlying)));
  return new $c_Lfs2_Stream(self$1);
});
$c_Lfs2_Stream.prototype.$greater$greater__F0__s_util_NotGiven__Lfs2_Stream = (function(s2, ev) {
  return this.flatMap__F1__s_util_NotGiven__Lfs2_Stream(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$35) => s2.apply__O())), $m_s_util_NotGiven$().s_util_NotGiven$__f_cachedValue);
});
$c_Lfs2_Stream.prototype.foreach__F1__Lfs2_Stream = (function(f) {
  $m_Lfs2_Pull$();
  $m_Lfs2_Pull$();
  var self = this.Lfs2_Stream__f_underlying;
  var self$1 = $m_Lfs2_Pull$StreamPullOps$().flatMapOutput$extension__Lfs2_Pull__F1__Lfs2_Pull(self, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((o) => {
    $m_Lfs2_Pull$();
    var fr = f.apply__O__O(o);
    return new $c_Lfs2_Pull$Eval(fr);
  })));
  return new $c_Lfs2_Stream(self$1);
});
$c_Lfs2_Stream.prototype.interruptWhen__O__Lfs2_Stream = (function(haltOnSignal) {
  $m_Lfs2_Pull$();
  $m_Lfs2_Pull$();
  var this$7 = new $c_Lfs2_Pull$InterruptWhen(haltOnSignal);
  var post = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    var ev$134 = ($m_Lfs2_Stream$(), new $c_Lfs2_Stream$ToPull(this)).Lfs2_Stream$ToPull__f_self;
    return ev$134.Lfs2_Stream__f_underlying;
  }));
  var self = new $c_Lfs2_Pull$$anon$2(post, this$7);
  return $m_Lfs2_Pull$StreamPullOps$().stream$extension__Lfs2_Pull__Lfs2_Stream(self).interruptScope__Lfs2_Stream();
});
$c_Lfs2_Stream.prototype.interruptScope__Lfs2_Stream = (function() {
  $m_Lfs2_Pull$();
  $m_Lfs2_Pull$();
  var s = this.Lfs2_Stream__f_underlying;
  var self = new $c_Lfs2_Pull$InScope(s, true);
  return new $c_Lfs2_Stream(self);
});
$c_Lfs2_Stream.prototype.map__F1__Lfs2_Stream = (function(f) {
  $m_Lfs2_Pull$();
  var self = $m_Lfs2_Pull$().mapOutput__Lfs2_Stream__F1__Lfs2_Pull(this, f);
  return new $c_Lfs2_Stream(self);
});
$c_Lfs2_Stream.prototype.fs2$Stream$$mapNoScope__F1__Lfs2_Stream = (function(f) {
  $m_Lfs2_Pull$();
  var self = $m_Lfs2_Pull$().mapOutputNoScope__Lfs2_Stream__F1__Lfs2_Pull(this, f);
  return new $c_Lfs2_Stream(self);
});
$c_Lfs2_Stream.prototype.mapChunks__F1__Lfs2_Stream = (function(f) {
  $m_Lfs2_Pull$();
  $m_Lfs2_Pull$();
  var self = this.Lfs2_Stream__f_underlying;
  var self$1 = $m_Lfs2_Pull$StreamPullOps$().unconsFlatMap$extension__Lfs2_Pull__F1__Lfs2_Pull(self, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((hd) => $m_Lfs2_Pull$().output__Lfs2_Chunk__Lfs2_Pull(f.apply__O__O(hd)))));
  return $m_Lfs2_Pull$StreamPullOps$().stream$extension__Lfs2_Pull__Lfs2_Stream(self$1);
});
$c_Lfs2_Stream.prototype.merge__Lfs2_Stream__Lcats_effect_kernel_GenConcurrent__Lfs2_Stream = (function(that, F) {
  return $p_Lfs2_Stream__merge___Lfs2_Stream__F2__Lcats_effect_kernel_GenConcurrent__Lfs2_Stream(this, that, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((x$1, x$2) => $m_Lfs2_Stream$().exec__O__Lfs2_Stream(x$2).$plus$plus__F0__Lfs2_Stream(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((s$2) => (() => s$2))(x$1))))), F);
});
$c_Lfs2_Stream.prototype.mergeHaltBoth__Lfs2_Stream__Lcats_effect_kernel_GenConcurrent__Lfs2_Stream = (function(that, evidence$1) {
  $m_Lfs2_Stream$();
  var self = this.noneTerminate__Lfs2_Stream().merge__Lfs2_Stream__Lcats_effect_kernel_GenConcurrent__Lfs2_Stream(that.noneTerminate__Lfs2_Stream(), evidence$1);
  return $m_Lfs2_Stream$OptionStreamOps$().unNoneTerminate$extension__Lfs2_Stream__Lfs2_Stream(self);
});
$c_Lfs2_Stream.prototype.noneTerminate__Lfs2_Stream = (function() {
  return this.map__F1__Lfs2_Stream(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$52) => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(_$52)))).$plus$plus__F0__Lfs2_Stream(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $m_Lfs2_Stream$().emit__O__Lfs2_Stream($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()))));
});
$c_Lfs2_Stream.prototype.rethrow__s_$less$colon$less__Lfs2_RaiseThrowable__Lfs2_Stream = (function(ev, rt) {
  return this.chunks__Lfs2_Stream().flatMap__F1__s_util_NotGiven__Lfs2_Stream(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((c) => {
    var size = c.size__I();
    var capacity = 0;
    var size$1 = 0;
    var jsElems = null;
    capacity = 0;
    size$1 = 0;
    jsElems = [];
    var i = 0;
    var elem = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    var exOpt = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_ObjectRef(elem);
    while (((i < size) && exOpt.sr_ObjectRef__f_elem.isEmpty__Z())) {
      var x337 = c.apply__I__O(i);
      if ((x337 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
        var ex = x337.s_util_Left__f_value;
        exOpt.sr_ObjectRef__f_elem = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(ex);
        continue;
      }
      if ((x337 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
        var o = x337.s_util_Right__f_value;
        var unboxedElem = ((o === null) ? null : o);
        jsElems.push(unboxedElem);
        i = ((1 + i) | 0);
        continue;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x337);
    }
    var this$8 = $m_Lfs2_Chunk$();
    var values = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(jsElems);
    var evidence$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_reflect_ManifestFactory$AnyManifest$();
    var length = values.u.length;
    if ((length === 0)) {
      var chunk = this$8.Lfs2_Chunk$__f_empty_;
    } else if ((length === 1)) {
      var o$1 = values.u[0];
      var chunk = new $c_Lfs2_Chunk$Singleton(o$1);
    } else {
      var chunk = new $c_Lfs2_Chunk$ArraySlice(values, 0, length, evidence$1);
    }
    return $m_Lfs2_Stream$().chunk__Lfs2_Chunk__Lfs2_Stream(chunk).$plus$plus__F0__Lfs2_Stream(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
      var this$10 = exOpt.sr_ObjectRef__f_elem;
      if (this$10.isEmpty__Z()) {
        var this$11 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      } else {
        var x0 = this$10.get__O();
        var this$11 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($m_Lfs2_Stream$().raiseError__jl_Throwable__Lfs2_RaiseThrowable__Lfs2_Stream(x0, rt));
      }
      return (this$11.isEmpty__Z() ? $m_Lfs2_Stream$().Lfs2_Stream$__f_empty : this$11.get__O());
    })));
  })), $m_s_util_NotGiven$().s_util_NotGiven$__f_cachedValue);
});
$c_Lfs2_Stream.prototype.scope__Lfs2_Stream = (function() {
  $m_Lfs2_Pull$();
  $m_Lfs2_Pull$();
  var s = this.Lfs2_Stream__f_underlying;
  var self = new $c_Lfs2_Pull$InScope(s, false);
  return new $c_Lfs2_Stream(self);
});
$c_Lfs2_Stream.prototype.take__J__Lfs2_Stream = (function(n) {
  $m_Lfs2_Pull$();
  var ev$225 = ($m_Lfs2_Stream$(), new $c_Lfs2_Stream$ToPull(this)).Lfs2_Stream$ToPull__f_self;
  var this$3 = $m_Lfs2_Stream$ToPull$().take$extension__Lfs2_Stream__J__Lfs2_Pull(ev$225, n);
  var self = this$3.as__O__Lfs2_Pull((void 0));
  return $m_Lfs2_Pull$StreamPullOps$().stream$extension__Lfs2_Pull__Lfs2_Stream(self);
});
$c_Lfs2_Stream.prototype.toString__T = (function() {
  return "Stream(..)";
});
var $d_Lfs2_Stream = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Stream, "fs2.Stream", ({
  Lfs2_Stream: 1
}));
export { $d_Lfs2_Stream as $d_Lfs2_Stream };
/** @constructor */
function $c_Lfs2_Stream$CompileOps(underlying, compiler) {
  this.Lfs2_Stream$CompileOps__f_underlying = null;
  this.Lfs2_Stream$CompileOps__f_compiler = null;
  this.Lfs2_Stream$CompileOps__f_underlying = underlying;
  this.Lfs2_Stream$CompileOps__f_compiler = compiler;
}
export { $c_Lfs2_Stream$CompileOps as $c_Lfs2_Stream$CompileOps };
$c_Lfs2_Stream$CompileOps.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_Stream$CompileOps.prototype.constructor = $c_Lfs2_Stream$CompileOps;
/** @constructor */
function $h_Lfs2_Stream$CompileOps() {
}
export { $h_Lfs2_Stream$CompileOps as $h_Lfs2_Stream$CompileOps };
$h_Lfs2_Stream$CompileOps.prototype = $c_Lfs2_Stream$CompileOps.prototype;
$c_Lfs2_Stream$CompileOps.prototype.drain__O = (function() {
  return this.foldChunks__O__F2__O((void 0), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((_$216, _$217) => (void 0))));
});
$c_Lfs2_Stream$CompileOps.prototype.foldChunks__O__F2__O = (function(init, f) {
  return this.Lfs2_Stream$CompileOps__f_compiler.apply__Lfs2_Pull__O__F2__O(this.Lfs2_Stream$CompileOps__f_underlying, init, f);
});
var $d_Lfs2_Stream$CompileOps = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Stream$CompileOps, "fs2.Stream$CompileOps", ({
  Lfs2_Stream$CompileOps: 1
}));
export { $d_Lfs2_Stream$CompileOps as $d_Lfs2_Stream$CompileOps };
function $p_Lfs2_Stream$OptionStreamOps$__loop$2__Lfs2_Pull__Lfs2_Pull($thiz, p) {
  var this$7 = ($m_Lfs2_Pull$(), $m_Lfs2_Pull$StreamPullOps$().uncons$extension__Lfs2_Pull__Lfs2_Pull(p));
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    if ((x === x$1)) {
      return $m_Lfs2_Pull$().Lfs2_Pull$__f_done;
    }
    if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var x586 = x$1.s_Some__f_value;
      if ((x586 !== null)) {
        var hd = x586._1__O();
        var tl = x586._2__O();
        var \u03b41$ = hd.iterator__sc_Iterator();
        _return: {
          var i = 0;
          var dropped = \u03b41$.drop__I__sc_Iterator(0);
          while (dropped.hasNext__Z()) {
            var x0 = dropped.next__O();
            if (x0.isEmpty__Z()) {
              var idx = i;
              break _return;
            }
            i = ((1 + i) | 0);
          }
          var idx = (-1);
        }
        var x579 = ((idx < 0) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$() : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(idx));
        if ((x579 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
          var x583 = (x579.s_Some__f_value | 0);
          if ((x583 === 0)) {
            return $m_Lfs2_Pull$().Lfs2_Pull$__f_done;
          }
          return $m_Lfs2_Pull$().output__Lfs2_Chunk__Lfs2_Pull(hd.take__I__Lfs2_Chunk(x583).map__F1__Lfs2_Chunk(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$183) => _$183.get__O()))));
        }
        var x$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        if ((x$3 === x579)) {
          var this$6 = $m_Lfs2_Pull$().output__Lfs2_Chunk__Lfs2_Pull(hd.map__F1__Lfs2_Chunk(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$184) => _$184.get__O()))));
          var post = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $p_Lfs2_Stream$OptionStreamOps$__loop$2__Lfs2_Pull__Lfs2_Pull($thiz, tl)));
          return new $c_Lfs2_Pull$$anon$2(post, this$6);
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x579);
      }
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  }));
  return new $c_Lfs2_Pull$$anon$1(f, this$7);
}
export { $p_Lfs2_Stream$OptionStreamOps$__loop$2__Lfs2_Pull__Lfs2_Pull as $p_Lfs2_Stream$OptionStreamOps$__loop$2__Lfs2_Pull__Lfs2_Pull };
/** @constructor */
function $c_Lfs2_Stream$OptionStreamOps$() {
}
export { $c_Lfs2_Stream$OptionStreamOps$ as $c_Lfs2_Stream$OptionStreamOps$ };
$c_Lfs2_Stream$OptionStreamOps$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_Stream$OptionStreamOps$.prototype.constructor = $c_Lfs2_Stream$OptionStreamOps$;
/** @constructor */
function $h_Lfs2_Stream$OptionStreamOps$() {
}
export { $h_Lfs2_Stream$OptionStreamOps$ as $h_Lfs2_Stream$OptionStreamOps$ };
$h_Lfs2_Stream$OptionStreamOps$.prototype = $c_Lfs2_Stream$OptionStreamOps$.prototype;
$c_Lfs2_Stream$OptionStreamOps$.prototype.unNoneTerminate$extension__Lfs2_Stream__Lfs2_Stream = (function(this$) {
  $m_Lfs2_Pull$();
  var self = $p_Lfs2_Stream$OptionStreamOps$__loop$2__Lfs2_Pull__Lfs2_Pull(this, this$.Lfs2_Stream__f_underlying);
  return $m_Lfs2_Pull$StreamPullOps$().stream$extension__Lfs2_Pull__Lfs2_Stream(self);
});
var $d_Lfs2_Stream$OptionStreamOps$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Stream$OptionStreamOps$, "fs2.Stream$OptionStreamOps$", ({
  Lfs2_Stream$OptionStreamOps$: 1
}));
export { $d_Lfs2_Stream$OptionStreamOps$ as $d_Lfs2_Stream$OptionStreamOps$ };
var $n_Lfs2_Stream$OptionStreamOps$;
function $m_Lfs2_Stream$OptionStreamOps$() {
  if ((!$n_Lfs2_Stream$OptionStreamOps$)) {
    $n_Lfs2_Stream$OptionStreamOps$ = new $c_Lfs2_Stream$OptionStreamOps$();
  }
  return $n_Lfs2_Stream$OptionStreamOps$;
}
export { $m_Lfs2_Stream$OptionStreamOps$ as $m_Lfs2_Stream$OptionStreamOps$ };
/** @constructor */
function $c_Lfs2_Stream$StepLeg(head, scopeId, next) {
}
export { $c_Lfs2_Stream$StepLeg as $c_Lfs2_Stream$StepLeg };
$c_Lfs2_Stream$StepLeg.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_Stream$StepLeg.prototype.constructor = $c_Lfs2_Stream$StepLeg;
/** @constructor */
function $h_Lfs2_Stream$StepLeg() {
}
export { $h_Lfs2_Stream$StepLeg as $h_Lfs2_Stream$StepLeg };
$h_Lfs2_Stream$StepLeg.prototype = $c_Lfs2_Stream$StepLeg.prototype;
var $d_Lfs2_Stream$StepLeg = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Stream$StepLeg, "fs2.Stream$StepLeg", ({
  Lfs2_Stream$StepLeg: 1
}));
export { $d_Lfs2_Stream$StepLeg as $d_Lfs2_Stream$StepLeg };
/** @constructor */
function $c_Lfs2_Stream$ToPull(self) {
  this.Lfs2_Stream$ToPull__f_self = null;
  this.Lfs2_Stream$ToPull__f_self = self;
}
export { $c_Lfs2_Stream$ToPull as $c_Lfs2_Stream$ToPull };
$c_Lfs2_Stream$ToPull.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_Stream$ToPull.prototype.constructor = $c_Lfs2_Stream$ToPull;
/** @constructor */
function $h_Lfs2_Stream$ToPull() {
}
export { $h_Lfs2_Stream$ToPull as $h_Lfs2_Stream$ToPull };
$h_Lfs2_Stream$ToPull.prototype = $c_Lfs2_Stream$ToPull.prototype;
$c_Lfs2_Stream$ToPull.prototype.hashCode__I = (function() {
  var this$ = this.Lfs2_Stream$ToPull__f_self;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$systemIdentityHashCode(this$);
});
$c_Lfs2_Stream$ToPull.prototype.equals__O__Z = (function(x$0) {
  return $m_Lfs2_Stream$ToPull$().equals$extension__Lfs2_Stream__O__Z(this.Lfs2_Stream$ToPull__f_self, x$0);
});
function $isArrayOf_Lfs2_Stream$ToPull(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Stream$ToPull)));
}
export { $isArrayOf_Lfs2_Stream$ToPull as $isArrayOf_Lfs2_Stream$ToPull };
var $d_Lfs2_Stream$ToPull = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Stream$ToPull, "fs2.Stream$ToPull", ({
  Lfs2_Stream$ToPull: 1
}));
export { $d_Lfs2_Stream$ToPull as $d_Lfs2_Stream$ToPull };
/** @constructor */
function $c_Lfs2_Stream$ToPull$() {
}
export { $c_Lfs2_Stream$ToPull$ as $c_Lfs2_Stream$ToPull$ };
$c_Lfs2_Stream$ToPull$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_Stream$ToPull$.prototype.constructor = $c_Lfs2_Stream$ToPull$;
/** @constructor */
function $h_Lfs2_Stream$ToPull$() {
}
export { $h_Lfs2_Stream$ToPull$ as $h_Lfs2_Stream$ToPull$ };
$h_Lfs2_Stream$ToPull$.prototype = $c_Lfs2_Stream$ToPull$.prototype;
$c_Lfs2_Stream$ToPull$.prototype.equals$extension__Lfs2_Stream__O__Z = (function(this$, x$0) {
  if ((x$0 instanceof $c_Lfs2_Stream$ToPull)) {
    var x$0$2 = ((x$0 === null) ? null : x$0.Lfs2_Stream$ToPull__f_self);
    return (this$ === x$0$2);
  } else {
    return false;
  }
});
$c_Lfs2_Stream$ToPull$.prototype.uncons$extension__Lfs2_Stream__Lfs2_Pull = (function(this$) {
  $m_Lfs2_Pull$();
  var self = this$.Lfs2_Stream__f_underlying;
  return $m_Lfs2_Pull$StreamPullOps$().uncons$extension__Lfs2_Pull__Lfs2_Pull(self).map__F1__Lfs2_Pull(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$207) => {
    if (_$207.isEmpty__Z()) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    } else {
      var x0 = _$207.get__O();
      matchResult160: {
        var $x_1;
        if ((x0 !== null)) {
          var hd = x0._1__O();
          var tl = x0._2__O();
          $m_Lfs2_Pull$();
          var _2 = new $c_Lfs2_Stream(tl);
          var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), hd, _2);
          break matchResult160;
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x0);
      }
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($x_1);
    }
  })));
});
$c_Lfs2_Stream$ToPull$.prototype.take$extension__Lfs2_Stream__J__Lfs2_Pull = (function(this$, n) {
  var ahi = n.RTLong__f_hi;
  if (((ahi === 0) ? (n.RTLong__f_lo === 0) : (ahi < 0))) {
    $m_Lfs2_Pull$();
    var r = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    return new $c_Lfs2_Pull$Succeeded(r);
  } else {
    var this$18 = this.uncons$extension__Lfs2_Stream__Lfs2_Pull(this$);
    var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(($m_Lfs2_Stream$(), ((x$1) => {
      var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      if ((x === x$1)) {
        $m_Lfs2_Pull$();
        var r$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        return new $c_Lfs2_Pull$Succeeded(r$1);
      }
      if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
        var x757 = x$1.s_Some__f_value;
        if ((x757 !== null)) {
          var hd = x757._1__O();
          var tl = x757._2__O();
          var value = hd.size__I();
          var hi = (value >> 31);
          var bhi = n.RTLong__f_hi;
          if (((hi === bhi) ? ((value >>> 0) < (n.RTLong__f_lo >>> 0)) : (hi < bhi))) {
            var this$11 = $m_Lfs2_Pull$().output__Lfs2_Chunk__Lfs2_Pull(hd);
            var post = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((m$2) => (() => {
              var $x_2 = $m_Lfs2_Stream$ToPull$();
              var $x_1 = new $c_Lfs2_Stream$ToPull(tl).Lfs2_Stream$ToPull__f_self;
              var alo = n.RTLong__f_lo;
              var blo = m$2.RTLong__f_lo;
              var lo = ((alo - blo) | 0);
              var hi$1 = ((((n.RTLong__f_hi - m$2.RTLong__f_hi) | 0) + ((((~alo) & blo) | ((~(alo ^ blo)) & lo)) >> 31)) | 0);
              return $x_2.take$extension__Lfs2_Stream__J__Lfs2_Pull($x_1, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi$1));
            }))(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(value, hi)));
            return new $c_Lfs2_Pull$$anon$2(post, this$11);
          }
          if (((value === n.RTLong__f_lo) && (hi === n.RTLong__f_hi))) {
            return $m_Lfs2_Pull$().output__Lfs2_Chunk__Lfs2_Pull(hd).as__O__Lfs2_Pull(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(tl));
          }
          matchResult189: {
            var \u03b427$___1;
            var \u03b427$___2;
            var x751 = hd.splitAt__I__T2(n.RTLong__f_lo);
            if ((x751 !== null)) {
              var pfx = x751._1__O();
              var sfx = x751._2__O();
              var \u03b427$___1 = pfx;
              var \u03b427$___2 = sfx;
              break matchResult189;
            }
            throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x751);
          }
          var pfx$2 = \u03b427$___1;
          var sfx$2 = \u03b427$___2;
          var $x_3 = $m_Lfs2_Pull$().output__Lfs2_Chunk__Lfs2_Pull(pfx$2);
          var value$1 = tl.cons__Lfs2_Chunk__Lfs2_Stream(sfx$2);
          return $x_3.as__O__Lfs2_Pull(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value$1));
        }
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })));
    return new $c_Lfs2_Pull$$anon$1(f, this$18);
  }
});
var $d_Lfs2_Stream$ToPull$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Stream$ToPull$, "fs2.Stream$ToPull$", ({
  Lfs2_Stream$ToPull$: 1
}));
export { $d_Lfs2_Stream$ToPull$ as $d_Lfs2_Stream$ToPull$ };
var $n_Lfs2_Stream$ToPull$;
function $m_Lfs2_Stream$ToPull$() {
  if ((!$n_Lfs2_Stream$ToPull$)) {
    $n_Lfs2_Stream$ToPull$ = new $c_Lfs2_Stream$ToPull$();
  }
  return $n_Lfs2_Stream$ToPull$;
}
export { $m_Lfs2_Stream$ToPull$ as $m_Lfs2_Stream$ToPull$ };
function $p_Lfs2_concurrent_Channel$__State$lzyINIT1$1__sr_LazyRef__Lfs2_concurrent_Channel$State$3$($thiz, State$lzy1$1) {
  if ((State$lzy1$1 === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  return (State$lzy1$1.sr_LazyRef__f__initialized ? State$lzy1$1.sr_LazyRef__f__value : State$lzy1$1.initialize__O__O(new $c_Lfs2_concurrent_Channel$State$3$()));
}
export { $p_Lfs2_concurrent_Channel$__State$lzyINIT1$1__sr_LazyRef__Lfs2_concurrent_Channel$State$3$ as $p_Lfs2_concurrent_Channel$__State$lzyINIT1$1__sr_LazyRef__Lfs2_concurrent_Channel$State$3$ };
/** @constructor */
function $c_Lfs2_concurrent_Channel$() {
  this.Lfs2_concurrent_Channel$__f__closed = null;
  this.Lfs2_concurrent_Channel$__f_fs2$concurrent$Channel$$$rightUnit = null;
  $n_Lfs2_concurrent_Channel$ = this;
  var value = $m_Lfs2_concurrent_Channel$Closed$();
  this.Lfs2_concurrent_Channel$__f__closed = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value);
  this.Lfs2_concurrent_Channel$__f_fs2$concurrent$Channel$$$rightUnit = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right((void 0));
}
export { $c_Lfs2_concurrent_Channel$ as $c_Lfs2_concurrent_Channel$ };
$c_Lfs2_concurrent_Channel$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_concurrent_Channel$.prototype.constructor = $c_Lfs2_concurrent_Channel$;
/** @constructor */
function $h_Lfs2_concurrent_Channel$() {
}
export { $h_Lfs2_concurrent_Channel$ as $h_Lfs2_concurrent_Channel$ };
$h_Lfs2_concurrent_Channel$.prototype = $c_Lfs2_concurrent_Channel$.prototype;
$c_Lfs2_concurrent_Channel$.prototype.bounded__I__Lcats_effect_kernel_GenConcurrent__O = (function(capacity, F) {
  var State$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_LazyRef();
  this.fs2$concurrent$Channel$$$_$State$2__sr_LazyRef__Lfs2_concurrent_Channel$State$3$(State$lzy1);
  var values = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var waiting = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var producers = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var open = new $c_Lfs2_concurrent_Channel$State$1(values, 0, waiting, producers, false);
  var _1 = $m_Lcats_effect_IO$().ref__O__Lcats_effect_IO(open);
  var _2 = $m_Lcats_effect_IO$().deferred__Lcats_effect_IO();
  var t = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, _2);
  var $x_1 = new $c_Lcats_syntax_Tuple2SemigroupalOps(t);
  var State$lzy1$2$1 = State$lzy1;
  return $x_1.mapN__F2__Lcats_Functor__Lcats_Semigroupal__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((State$lzy1$2) => ((state, closedGate) => new $c_Lfs2_concurrent_Channel$$anon$1(F, state, capacity, closedGate, State$lzy1$2, open)))(State$lzy1$2$1)), F, F);
});
$c_Lfs2_concurrent_Channel$.prototype.fs2$concurrent$Channel$$$_$State$2__sr_LazyRef__Lfs2_concurrent_Channel$State$3$ = (function(State$lzy1$2) {
  return (State$lzy1$2.sr_LazyRef__f__initialized ? State$lzy1$2.sr_LazyRef__f__value : $p_Lfs2_concurrent_Channel$__State$lzyINIT1$1__sr_LazyRef__Lfs2_concurrent_Channel$State$3$(this, State$lzy1$2));
});
$c_Lfs2_concurrent_Channel$.prototype.fs2$concurrent$Channel$$$_$empty$1__Lfs2_concurrent_Channel$State$1__sr_LazyRef__Z__Lfs2_concurrent_Channel$State$1 = (function(open$1, State$lzy1$3, isClosed) {
  if (isClosed) {
    this.fs2$concurrent$Channel$$$_$State$2__sr_LazyRef__Lfs2_concurrent_Channel$State$3$(State$lzy1$3);
    var values = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var waiting = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    var producers = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    return new $c_Lfs2_concurrent_Channel$State$1(values, 0, waiting, producers, true);
  } else {
    return open$1;
  }
});
var $d_Lfs2_concurrent_Channel$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_concurrent_Channel$, "fs2.concurrent.Channel$", ({
  Lfs2_concurrent_Channel$: 1
}));
export { $d_Lfs2_concurrent_Channel$ as $d_Lfs2_concurrent_Channel$ };
var $n_Lfs2_concurrent_Channel$;
function $m_Lfs2_concurrent_Channel$() {
  if ((!$n_Lfs2_concurrent_Channel$)) {
    $n_Lfs2_concurrent_Channel$ = new $c_Lfs2_concurrent_Channel$();
  }
  return $n_Lfs2_concurrent_Channel$;
}
export { $m_Lfs2_concurrent_Channel$ as $m_Lfs2_concurrent_Channel$ };
/** @constructor */
function $c_Lfs2_concurrent_Channel$Closed$() {
}
export { $c_Lfs2_concurrent_Channel$Closed$ as $c_Lfs2_concurrent_Channel$Closed$ };
$c_Lfs2_concurrent_Channel$Closed$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_concurrent_Channel$Closed$.prototype.constructor = $c_Lfs2_concurrent_Channel$Closed$;
/** @constructor */
function $h_Lfs2_concurrent_Channel$Closed$() {
}
export { $h_Lfs2_concurrent_Channel$Closed$ as $h_Lfs2_concurrent_Channel$Closed$ };
$h_Lfs2_concurrent_Channel$Closed$.prototype = $c_Lfs2_concurrent_Channel$Closed$.prototype;
var $d_Lfs2_concurrent_Channel$Closed$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_concurrent_Channel$Closed$, "fs2.concurrent.Channel$Closed$", ({
  Lfs2_concurrent_Channel$Closed$: 1
}));
export { $d_Lfs2_concurrent_Channel$Closed$ as $d_Lfs2_concurrent_Channel$Closed$ };
var $n_Lfs2_concurrent_Channel$Closed$;
function $m_Lfs2_concurrent_Channel$Closed$() {
  if ((!$n_Lfs2_concurrent_Channel$Closed$)) {
    $n_Lfs2_concurrent_Channel$Closed$ = new $c_Lfs2_concurrent_Channel$Closed$();
  }
  return $n_Lfs2_concurrent_Channel$Closed$;
}
export { $m_Lfs2_concurrent_Channel$Closed$ as $m_Lfs2_concurrent_Channel$Closed$ };
function $p_Lfs2_concurrent_SignallingRef$__State$lzyINIT1$1__sr_LazyRef__Lfs2_concurrent_SignallingRef$State$3$($thiz, State$lzy1$1) {
  if ((State$lzy1$1 === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  return (State$lzy1$1.sr_LazyRef__f__initialized ? State$lzy1$1.sr_LazyRef__f__value : State$lzy1$1.initialize__O__O(new $c_Lfs2_concurrent_SignallingRef$State$3$()));
}
export { $p_Lfs2_concurrent_SignallingRef$__State$lzyINIT1$1__sr_LazyRef__Lfs2_concurrent_SignallingRef$State$3$ as $p_Lfs2_concurrent_SignallingRef$__State$lzyINIT1$1__sr_LazyRef__Lfs2_concurrent_SignallingRef$State$3$ };
/** @constructor */
function $c_Lfs2_concurrent_SignallingRef$() {
}
export { $c_Lfs2_concurrent_SignallingRef$ as $c_Lfs2_concurrent_SignallingRef$ };
$c_Lfs2_concurrent_SignallingRef$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_concurrent_SignallingRef$.prototype.constructor = $c_Lfs2_concurrent_SignallingRef$;
/** @constructor */
function $h_Lfs2_concurrent_SignallingRef$() {
}
export { $h_Lfs2_concurrent_SignallingRef$ as $h_Lfs2_concurrent_SignallingRef$ };
$h_Lfs2_concurrent_SignallingRef$.prototype = $c_Lfs2_concurrent_SignallingRef$.prototype;
$c_Lfs2_concurrent_SignallingRef$.prototype.of__O__Lcats_effect_kernel_GenConcurrent__O = (function(initial, F) {
  var State$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_LazyRef();
  this.fs2$concurrent$SignallingRef$$$_$State$2__sr_LazyRef__Lfs2_concurrent_SignallingRef$State$3$(State$lzy1);
  var listeners = $m_sci_LongMap$Nil$();
  var a = new $c_Lfs2_concurrent_SignallingRef$State$1(initial, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0, listeners);
  var fa = $m_Lcats_effect_IO$().ref__O__Lcats_effect_IO(a);
  var fb = $m_Lcats_effect_IO$().ref__O__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(1, 0));
  var target = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__product__O__O__O(F, fa, fb);
  var this$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target, F);
  var State$lzy1$2$1 = State$lzy1;
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((State$lzy1$2) => ((x$1) => {
    if ((x$1 !== null)) {
      var state = x$1._1__O();
      var ids = x$1._2__O();
      return new $c_Lfs2_concurrent_SignallingRef$$anon$4(state, F, State$lzy1$2, ids);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  }))(State$lzy1$2$1));
  return this$7.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.map__O__F1__O(this$7.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
});
$c_Lfs2_concurrent_SignallingRef$.prototype.fs2$concurrent$SignallingRef$$$_$State$2__sr_LazyRef__Lfs2_concurrent_SignallingRef$State$3$ = (function(State$lzy1$2) {
  return (State$lzy1$2.sr_LazyRef__f__initialized ? State$lzy1$2.sr_LazyRef__f__value : $p_Lfs2_concurrent_SignallingRef$__State$lzyINIT1$1__sr_LazyRef__Lfs2_concurrent_SignallingRef$State$3$(this, State$lzy1$2));
});
$c_Lfs2_concurrent_SignallingRef$.prototype.fs2$concurrent$SignallingRef$$$_$newId$1__Lcats_effect_kernel_Ref__O = (function(ids$1) {
  return ids$1.getAndUpdate__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$17) => {
    var t = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(_$17);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var lo$1 = ((1 + lo) | 0);
    var hi$1 = ((hi + (((lo & (~lo$1)) >>> 31) | 0)) | 0);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$1, hi$1);
  })));
});
$c_Lfs2_concurrent_SignallingRef$.prototype.fs2$concurrent$SignallingRef$$$_$updateAndNotify$1__Lcats_effect_kernel_GenConcurrent__sr_LazyRef__Lfs2_concurrent_SignallingRef$State$1__F1__T2 = (function(F$4, State$lzy1$4, state, f) {
  matchResult9: {
    var \u03b42$___1;
    var \u03b42$___2;
    var x17 = f.apply__O__O(state.Lfs2_concurrent_SignallingRef$State$1__f_value);
    if ((x17 !== null)) {
      var newValue = x17._1__O();
      var result = x17._2__O();
      var \u03b42$___1 = newValue;
      var \u03b42$___2 = result;
      break matchResult9;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x17);
  }
  var newValue$2 = \u03b42$___1;
  var result$2 = \u03b42$___2;
  var b = state.Lfs2_concurrent_SignallingRef$State$1__f_lastUpdate;
  var blo = b.RTLong__f_lo;
  var lo = ((1 + blo) | 0);
  var hi = ((b.RTLong__f_hi + (((blo & (~lo)) >>> 31) | 0)) | 0);
  this.fs2$concurrent$SignallingRef$$$_$State$2__sr_LazyRef__Lfs2_concurrent_SignallingRef$State$3$(State$lzy1$4);
  var listeners = $m_sci_LongMap$Nil$();
  var newState = new $c_Lfs2_concurrent_SignallingRef$State$1(newValue$2, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi), listeners);
  var this$5 = state.Lfs2_concurrent_SignallingRef$State$1__f_listeners;
  var this$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapOps$$anon$1(this$5);
  var target = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$6);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_UnorderedFoldable$();
  var tc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$vector$().Lcats_instances_package$vector$__f_catsStdInstancesForVector;
  var this$11 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Foldable$ToFoldableOps$$anon$6(target, tc);
  var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((lastUpdate$2) => ((listener) => {
    var a = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), newValue$2, lastUpdate$2);
    return listener.complete__O__Lcats_effect_IO(a);
  }))(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi)));
  var notifyListeners = this$11.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance.traverseVoid__O__F1__Lcats_Applicative__O(this$11.Lcats_Foldable$ToFoldableOps$$anon$6__f_self, f$1, F$4);
  var this$14 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(notifyListeners, F$4);
  var y = this$14.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.as__O__O__O(this$14.Lcats_Functor$ToFunctorOps$$anon$5__f_self, result$2);
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), newState, y);
});
var $d_Lfs2_concurrent_SignallingRef$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_concurrent_SignallingRef$, "fs2.concurrent.SignallingRef$", ({
  Lfs2_concurrent_SignallingRef$: 1
}));
export { $d_Lfs2_concurrent_SignallingRef$ as $d_Lfs2_concurrent_SignallingRef$ };
var $n_Lfs2_concurrent_SignallingRef$;
function $m_Lfs2_concurrent_SignallingRef$() {
  if ((!$n_Lfs2_concurrent_SignallingRef$)) {
    $n_Lfs2_concurrent_SignallingRef$ = new $c_Lfs2_concurrent_SignallingRef$();
  }
  return $n_Lfs2_concurrent_SignallingRef$;
}
export { $m_Lfs2_concurrent_SignallingRef$ as $m_Lfs2_concurrent_SignallingRef$ };
/** @constructor */
function $c_Lfs2_internal_InterruptContext$() {
}
export { $c_Lfs2_internal_InterruptContext$ as $c_Lfs2_internal_InterruptContext$ };
$c_Lfs2_internal_InterruptContext$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_internal_InterruptContext$.prototype.constructor = $c_Lfs2_internal_InterruptContext$;
/** @constructor */
function $h_Lfs2_internal_InterruptContext$() {
}
export { $h_Lfs2_internal_InterruptContext$ as $h_Lfs2_internal_InterruptContext$ };
$h_Lfs2_internal_InterruptContext$.prototype = $c_Lfs2_internal_InterruptContext$.prototype;
$c_Lfs2_internal_InterruptContext$.prototype.apply__Lcats_effect_kernel_Unique$Token__O__Lcats_effect_kernel_GenConcurrent__O = (function(newScopeId, cancelParent, F) {
  var a = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var target = $m_Lcats_effect_IO$().ref__O__Lcats_effect_IO(a);
  var this$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F);
  var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((ref) => {
    var target$1 = $m_Lcats_effect_IO$().deferred__Lcats_effect_IO();
    var this$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, F);
    var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((ref$2) => ((deferred) => new $c_Lfs2_internal_InterruptContext(deferred, ref$2, newScopeId, cancelParent, F)))(ref));
    return this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  }));
  return this$5.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$5.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
});
var $d_Lfs2_internal_InterruptContext$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_internal_InterruptContext$, "fs2.internal.InterruptContext$", ({
  Lfs2_internal_InterruptContext$: 1
}));
export { $d_Lfs2_internal_InterruptContext$ as $d_Lfs2_internal_InterruptContext$ };
var $n_Lfs2_internal_InterruptContext$;
function $m_Lfs2_internal_InterruptContext$() {
  if ((!$n_Lfs2_internal_InterruptContext$)) {
    $n_Lfs2_internal_InterruptContext$ = new $c_Lfs2_internal_InterruptContext$();
  }
  return $n_Lfs2_internal_InterruptContext$;
}
export { $m_Lfs2_internal_InterruptContext$ as $m_Lfs2_internal_InterruptContext$ };
function $p_Lfs2_internal_Scope__register__Lfs2_internal_ScopedResource__O($thiz, resource) {
  return $thiz.Lfs2_internal_Scope__f_state.modify__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 instanceof $c_Lfs2_internal_Scope$State$Open)) {
      var this$1 = x$1.Lfs2_internal_Scope$State$Open__f_resources;
      var resources = this$1.prepend__O__Lcats_data_Chain(resource);
      var children = x$1.Lfs2_internal_Scope$State$Open__f_children;
      var _1 = new $c_Lfs2_internal_Scope$State$Open(resources, children);
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, true);
    }
    if ((x$1 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), x$1, false);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  })));
}
export { $p_Lfs2_internal_Scope__register__Lfs2_internal_ScopedResource__O as $p_Lfs2_internal_Scope__register__Lfs2_internal_ScopedResource__O };
function $p_Lfs2_internal_Scope__releaseChildScope__Lcats_effect_kernel_Unique$Token__O($thiz, id) {
  return $thiz.Lfs2_internal_Scope__f_state.update__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 instanceof $c_Lfs2_internal_Scope$State$Open)) {
      return x$1.unregisterChild__Lcats_effect_kernel_Unique$Token__Lfs2_internal_Scope$State(id);
    }
    if ((x$1 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
      return x$1;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  })));
}
export { $p_Lfs2_internal_Scope__releaseChildScope__Lcats_effect_kernel_Unique$Token__O as $p_Lfs2_internal_Scope__releaseChildScope__Lcats_effect_kernel_Unique$Token__O };
function $p_Lfs2_internal_Scope__close___Lcats_effect_kernel_Resource$ExitCase__O($thiz, ec) {
  var target = $thiz.Lfs2_internal_Scope__f_state.modify__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s) => {
    var self = $m_Lfs2_internal_Scope$State$().Lfs2_internal_Scope$State$__f_closed_;
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self, s);
  })));
  var tc = $thiz.Lfs2_internal_Scope__f_F;
  var this$20 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 instanceof $c_Lfs2_internal_Scope$State$Open)) {
      var target$1 = $thiz.fs2$internal$Scope$$traverseError__Lcats_data_Chain__F1__O(x$1.Lfs2_internal_Scope$State$Open__f_children, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$5) => $p_Lfs2_internal_Scope__close___Lcats_effect_kernel_Resource$ExitCase__O(_$5, ec))));
      var tc$1 = $thiz.Lfs2_internal_Scope__f_F;
      var this$17 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$1);
      var f$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((previous$2) => ((resultChildren) => {
        var target$2 = $thiz.fs2$internal$Scope$$traverseError__Lcats_data_Chain__F1__O(previous$2.Lfs2_internal_Scope$State$Open__f_resources, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$6) => _$6.release__Lcats_effect_kernel_Resource$ExitCase__O(ec))));
        var tc$2 = $thiz.Lfs2_internal_Scope__f_F;
        var this$16 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, tc$2);
        var f$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((resultChildren$2) => ((resultResources) => {
          var this$7 = $thiz.Lfs2_internal_Scope__f_interruptible;
          if (this$7.isEmpty__Z()) {
            var this$8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
          } else {
            var x0 = this$7.get__O();
            var this$8 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(x0.Lfs2_internal_InterruptContext__f_cancelParent);
          }
          if (this$8.isEmpty__Z()) {
            var this$9 = $thiz.Lfs2_internal_Scope__f_F;
            var target$3 = this$9.F__Lcats_effect_kernel_MonadCancel().pure__O__O((void 0));
          } else {
            var target$3 = this$8.get__O();
          }
          var tc$3 = $thiz.Lfs2_internal_Scope__f_F;
          var this$15 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$3, tc$3);
          var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((resultResources$2) => ((x$1$1) => {
            var this$11 = $thiz.Lfs2_internal_Scope__f_parent;
            if (this$11.isEmpty__Z()) {
              var this$12 = $thiz.Lfs2_internal_Scope__f_F;
              var target$4 = this$12.F__Lcats_effect_kernel_MonadCancel().pure__O__O((void 0));
            } else {
              var x0$1 = this$11.get__O();
              var target$4 = $p_Lfs2_internal_Scope__releaseChildScope__Lcats_effect_kernel_Unique$Token__O(x0$1, $thiz.Lfs2_internal_Scope__f_id);
            }
            var tc$4 = $thiz.Lfs2_internal_Scope__f_F;
            var this$14 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target$4, tc$4);
            var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1$2) => $m_Lfs2_CompositeFailure$().fromResults__s_util_Either__s_util_Either__s_util_Either(resultChildren$2, resultResources$2)));
            return this$14.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.map__O__F1__O(this$14.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
          }))(resultResources));
          return this$15.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$15.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
        }))(resultChildren));
        return this$16.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$16.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
      }))(x$1));
      return this$17.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$17.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
    }
    if ((x$1 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
      var this$19 = $thiz.Lfs2_internal_Scope__f_F;
      var a = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right((void 0));
      return this$19.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  }));
  return this$20.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$20.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$4);
}
export { $p_Lfs2_internal_Scope__close___Lcats_effect_kernel_Resource$ExitCase__O as $p_Lfs2_internal_Scope__close___Lcats_effect_kernel_Resource$ExitCase__O };
function $p_Lfs2_internal_Scope__openScope__O($thiz) {
  var target = $thiz.Lfs2_internal_Scope__f_state.get__O();
  var tc = $thiz.Lfs2_internal_Scope__f_F;
  var this$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 instanceof $c_Lfs2_internal_Scope$State$Open)) {
      var this$3 = $thiz.Lfs2_internal_Scope__f_F;
      return this$3.F__Lcats_effect_kernel_MonadCancel().pure__O__O($thiz);
    }
    if ((x$1 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
      return $thiz.openAncestor__O();
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  }));
  return this$4.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$4.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
}
export { $p_Lfs2_internal_Scope__openScope__O as $p_Lfs2_internal_Scope__openScope__O };
function $p_Lfs2_internal_Scope__findSelfOrChild__Lcats_effect_kernel_Unique$Token__O($thiz, scopeId) {
  var x = $thiz.Lfs2_internal_Scope__f_id;
  if ((x === scopeId)) {
    var this$2 = $thiz.Lfs2_internal_Scope__f_F;
    var a = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($thiz);
    return this$2.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a);
  } else {
    var target = $thiz.Lfs2_internal_Scope__f_state.get__O();
    var tc = $thiz.Lfs2_internal_Scope__f_F;
    var this$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
    var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
      if ((x$1 instanceof $c_Lfs2_internal_Scope$State$Open)) {
        return $p_Lfs2_internal_Scope__go$4__Lcats_effect_kernel_Unique$Token__Lcats_data_Chain__O($thiz, scopeId, x$1.Lfs2_internal_Scope$State$Open__f_children);
      }
      if ((x$1 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
        var this$5 = $thiz.Lfs2_internal_Scope__f_F;
        var a$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        return this$5.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a$1);
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    }));
    return this$6.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$6.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  }
}
export { $p_Lfs2_internal_Scope__findSelfOrChild__Lcats_effect_kernel_Unique$Token__O as $p_Lfs2_internal_Scope__findSelfOrChild__Lcats_effect_kernel_Unique$Token__O };
function $ps_Lfs2_internal_Scope__go$1__Lfs2_internal_Scope__I__I(scope, acc) {
  var acc$tailLocal1 = acc;
  var scope$tailLocal1 = scope;
  while (true) {
    var x1 = scope$tailLocal1.Lfs2_internal_Scope__f_parent;
    var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    if ((x === x1)) {
      return acc$tailLocal1;
    }
    if ((x1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var s = x1.s_Some__f_value;
      var acc$tailLocal1$tmp1 = ((1 + acc$tailLocal1) | 0);
      scope$tailLocal1 = s;
      acc$tailLocal1 = acc$tailLocal1$tmp1;
      continue;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1);
  }
}
export { $ps_Lfs2_internal_Scope__go$1__Lfs2_internal_Scope__I__I as $ps_Lfs2_internal_Scope__go$1__Lfs2_internal_Scope__I__I };
function $ps_Lfs2_internal_Scope__go$3__Lcats_effect_kernel_Unique$Token__Lfs2_internal_Scope__s_Option(scopeId$1, curr) {
  var curr$tailLocal2 = curr;
  while (true) {
    var x = curr$tailLocal2.Lfs2_internal_Scope__f_id;
    if ((x === scopeId$1)) {
      var value = curr$tailLocal2;
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
    } else {
      var x68 = curr$tailLocal2.Lfs2_internal_Scope__f_parent;
      if ((x68 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
        var scope = x68.s_Some__f_value;
        curr$tailLocal2 = scope;
        continue;
      }
      var x$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      if ((x$3 === x68)) {
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x68);
    }
  }
}
export { $ps_Lfs2_internal_Scope__go$3__Lcats_effect_kernel_Unique$Token__Lfs2_internal_Scope__s_Option as $ps_Lfs2_internal_Scope__go$3__Lcats_effect_kernel_Unique$Token__Lfs2_internal_Scope__s_Option };
function $p_Lfs2_internal_Scope__go$4__Lcats_effect_kernel_Unique$Token__Lcats_data_Chain__O($thiz, scopeId$3, scopes) {
  var x77 = scopes.uncons__s_Option();
  var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  if ((x === x77)) {
    var this$1 = $thiz.Lfs2_internal_Scope__f_F;
    var a = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    return this$1.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a);
  }
  if ((x77 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
    var x79 = x77.s_Some__f_value;
    if ((x79 !== null)) {
      var scope = x79._1__O();
      var tail = x79._2__O();
      var x$3 = scope.Lfs2_internal_Scope__f_id;
      if ((x$3 === scopeId$3)) {
        var this$3 = $thiz.Lfs2_internal_Scope__f_F;
        var a$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(scope);
        return this$3.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a$1);
      } else {
        var target = scope.Lfs2_internal_Scope__f_state.get__O();
        var tc = $thiz.Lfs2_internal_Scope__f_F;
        var this$10 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
        var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
          if ((x$1 instanceof $c_Lfs2_internal_Scope$State$Open)) {
            if (x$1.Lfs2_internal_Scope$State$Open__f_children.isEmpty__Z()) {
              return $p_Lfs2_internal_Scope__go$4__Lcats_effect_kernel_Unique$Token__Lcats_data_Chain__O($thiz, scopeId$3, tail);
            } else {
              var target$1 = $p_Lfs2_internal_Scope__go$4__Lcats_effect_kernel_Unique$Token__Lcats_data_Chain__O($thiz, scopeId$3, x$1.Lfs2_internal_Scope$State$Open__f_children);
              var tc$1 = $thiz.Lfs2_internal_Scope__f_F;
              var this$9 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$1);
              var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1$2) => {
                var x$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
                if ((x$2 === x$1$2)) {
                  return $p_Lfs2_internal_Scope__go$4__Lcats_effect_kernel_Unique$Token__Lcats_data_Chain__O($thiz, scopeId$3, tail);
                }
                if ((x$1$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
                  var scope$1 = x$1$2.s_Some__f_value;
                  var this$8 = $thiz.Lfs2_internal_Scope__f_F;
                  var a$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(scope$1);
                  return this$8.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a$2);
                }
                throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1$2);
              }));
              return this$9.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$9.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
            }
          }
          if ((x$1 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
            return $p_Lfs2_internal_Scope__go$4__Lcats_effect_kernel_Unique$Token__Lcats_data_Chain__O($thiz, scopeId$3, tail);
          }
          throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
        }));
        return this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
      }
    }
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x77);
}
export { $p_Lfs2_internal_Scope__go$4__Lcats_effect_kernel_Unique$Token__Lcats_data_Chain__O as $p_Lfs2_internal_Scope__go$4__Lcats_effect_kernel_Unique$Token__Lcats_data_Chain__O };
function $ps_Lfs2_internal_Scope__go$5__Lfs2_internal_Scope__Lfs2_internal_Scope(scope) {
  var scope$tailLocal2 = scope;
  while (true) {
    var x88 = scope$tailLocal2.Lfs2_internal_Scope__f_parent;
    var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    if ((x === x88)) {
      return scope$tailLocal2;
    }
    if ((x88 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var parent = x88.s_Some__f_value;
      scope$tailLocal2 = parent;
      continue;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x88);
  }
}
export { $ps_Lfs2_internal_Scope__go$5__Lfs2_internal_Scope__Lfs2_internal_Scope as $ps_Lfs2_internal_Scope__go$5__Lfs2_internal_Scope__Lfs2_internal_Scope };
/** @constructor */
function $c_Lfs2_internal_Scope(id, parent, interruptible, state, F) {
  this.Lfs2_internal_Scope__f_id = null;
  this.Lfs2_internal_Scope__f_parent = null;
  this.Lfs2_internal_Scope__f_interruptible = null;
  this.Lfs2_internal_Scope__f_state = null;
  this.Lfs2_internal_Scope__f_F = null;
  this.Lfs2_internal_Scope__f_id = id;
  this.Lfs2_internal_Scope__f_parent = parent;
  this.Lfs2_internal_Scope__f_interruptible = interruptible;
  this.Lfs2_internal_Scope__f_state = state;
  this.Lfs2_internal_Scope__f_F = F;
}
export { $c_Lfs2_internal_Scope as $c_Lfs2_internal_Scope };
$c_Lfs2_internal_Scope.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_internal_Scope.prototype.constructor = $c_Lfs2_internal_Scope;
/** @constructor */
function $h_Lfs2_internal_Scope() {
}
export { $h_Lfs2_internal_Scope as $h_Lfs2_internal_Scope };
$h_Lfs2_internal_Scope.prototype = $c_Lfs2_internal_Scope.prototype;
$c_Lfs2_internal_Scope.prototype.open__Z__O = (function(interruptible) {
  var target = this.Lfs2_internal_Scope__f_F.unique__O();
  var tc = this.Lfs2_internal_Scope__f_F;
  var this$14 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((newScopeId) => {
    var x7 = this.Lfs2_internal_Scope__f_interruptible;
    var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    if ((x === x7)) {
      var optFCtx = (interruptible ? this.Lfs2_internal_Scope__f_F.interruptContext__Lcats_effect_kernel_Unique$Token__s_Option(newScopeId) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_UnorderedFoldable$();
      var tc$1 = $m_Lcats_instances_package$option$().Lcats_instances_package$option$__f_catsStdInstancesForOption;
      var this$6 = new $c_Lcats_Traverse$ToTraverseOps$$anon$3(optFCtx, tc$1);
      var ev$2 = this.Lfs2_internal_Scope__f_F;
      var target$1 = $f_Lcats_Traverse__sequence__O__Lcats_Applicative__O(this$6.Lcats_Traverse$ToTraverseOps$$anon$3__f_typeClassInstance, this$6.Lcats_Traverse$ToTraverseOps$$anon$3__f_self, ev$2);
      var tc$2 = this.Lfs2_internal_Scope__f_F;
      var this$9 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$2);
      var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((newScopeId$2) => ((iCtx) => $m_Lfs2_internal_Scope$().fs2$internal$Scope$$$apply__Lcats_effect_kernel_Unique$Token__s_Option__s_Option__Lfs2_Compiler$Target__O(newScopeId$2, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(this), iCtx, this.Lfs2_internal_Scope__f_F)))(newScopeId));
      return this$9.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$9.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
    }
    if ((x7 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var parentICtx = x7.s_Some__f_value;
      var target$2 = parentICtx.childContext__Z__Lcats_effect_kernel_Unique$Token__O(interruptible, newScopeId);
      var tc$3 = this.Lfs2_internal_Scope__f_F;
      var this$13 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, tc$3);
      var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((newScopeId$3) => ((iCtx$2) => $m_Lfs2_internal_Scope$().fs2$internal$Scope$$$apply__Lcats_effect_kernel_Unique$Token__s_Option__s_Option__Lfs2_Compiler$Target__O(newScopeId$3, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(this), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(iCtx$2), this.Lfs2_internal_Scope__f_F)))(newScopeId));
      return this$13.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$13.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x7);
  }));
  var createScope = this$14.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$14.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
  var tc$4 = this.Lfs2_internal_Scope__f_F;
  var this$30 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(createScope, tc$4);
  var f$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((scope) => {
    var target$3 = this.Lfs2_internal_Scope__f_state.modify__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((scope$2) => ((x$1) => {
      if ((x$1 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
        var _2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), x$1, _2);
      }
      if ((x$1 instanceof $c_Lfs2_internal_Scope$State$Open)) {
        var this$17 = x$1.Lfs2_internal_Scope$State$Open__f_children;
        var children$1 = this$17.prepend__O__Lcats_data_Chain(scope$2);
        var resources$1 = x$1.Lfs2_internal_Scope$State$Open__f_resources;
        var _1 = new $c_Lfs2_internal_Scope$State$Open(resources$1, children$1);
        var _2$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(scope$2);
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, _2$1);
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    }))(scope)));
    var tc$5 = this.Lfs2_internal_Scope__f_F;
    var this$29 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$3, tc$5);
    var f$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1$2) => {
      if ((x$1$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
        var s = x$1$2.s_Some__f_value;
        var this$22 = this.Lfs2_internal_Scope__f_F;
        var a = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(s);
        return this$22.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a);
      }
      var x$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      if ((x$2 === x$1$2)) {
        var x13 = this.Lfs2_internal_Scope__f_parent;
        if ((x13 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
          var parent = x13.s_Some__f_value;
          var this$23 = this.Lfs2_internal_Scope__f_interruptible;
          if (this$23.isEmpty__Z()) {
            var this$24 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
          } else {
            var x0 = this$23.get__O();
            var this$24 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(x0.Lfs2_internal_InterruptContext__f_cancelParent);
          }
          if (this$24.isEmpty__Z()) {
            var this$25 = this.Lfs2_internal_Scope__f_F;
            var fa = this$25.F__Lcats_effect_kernel_MonadCancel().pure__O__O((void 0));
          } else {
            var fa = this$24.get__O();
          }
          return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => parent.open__Z__O(interruptible))), this.Lfs2_internal_Scope__f_F);
        }
        var x$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        if ((x$3 === x13)) {
          var this$28 = this.Lfs2_internal_Scope__f_F;
          var value = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalStateException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalStateException(), "cannot re-open root scope");
          var a$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value);
          return this$28.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a$1);
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x13);
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1$2);
    }));
    return this$29.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$29.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
  }));
  return this$30.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$30.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$4);
});
$c_Lfs2_internal_Scope.prototype.acquireResource__F1__F2__O = (function(acquire, release) {
  var target = $m_Lfs2_internal_ScopedResource$().create__Lfs2_Compiler$Target__O(this.Lfs2_internal_Scope__f_F);
  var tc = this.Lfs2_internal_Scope__f_F;
  var this$23 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((resource) => {
    var this$22 = this.Lfs2_internal_Scope__f_F;
    var f$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((resource$2) => ((poll) => {
      var fa = acquire.apply__O__O(poll);
      var recover = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((t) => {
        var this$5 = this.Lfs2_internal_Scope__f_F;
        var a = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(t);
        return this$5.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a);
      }));
      var bind = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((r) => {
        var finalizer = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((ec) => {
          var this$6 = this.Lfs2_internal_Scope__f_F;
          var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((ec$2) => ((_$3) => release.apply__O__O__O(r, ec$2)))(ec));
          return this$6.F__Lcats_effect_kernel_MonadCancel().uncancelable__F1__O(f);
        }));
        var target$1 = resource$2.acquired__F1__O(finalizer);
        var tc$1 = this.Lfs2_internal_Scope__f_F;
        var this$20 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$1);
        var f$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((result) => {
          if ((result instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
            var b = result.s_util_Right__f_value;
            var x = (!(!b));
            var $x_1 = x;
          } else {
            var $x_1 = false;
          }
          if ($x_1) {
            var target$2 = $p_Lfs2_internal_Scope__register__Lfs2_internal_ScopedResource__O(this, resource$2);
            var tc$2 = this.Lfs2_internal_Scope__f_F;
            var this$15 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, tc$2);
            var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
              var x$1$1 = (!(!x$1));
              if ((x$1$1 === false)) {
                var target$3 = finalizer.apply__O__O($m_Lcats_effect_kernel_Resource$ExitCase$Canceled$());
                var tc$3 = this.Lfs2_internal_Scope__f_F;
                var this$12 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target$3, tc$3);
                var value = $m_Lfs2_internal_AcquireAfterScopeClosed$();
                var b$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value);
                return this$12.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.as__O__O__O(this$12.Lcats_Functor$ToFunctorOps$$anon$5__f_self, b$1);
              }
              if ((x$1$1 === true)) {
                var this$14 = this.Lfs2_internal_Scope__f_F;
                var a$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(r);
                return this$14.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a$1);
              }
              throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1$1);
            }));
            return this$15.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$15.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
          } else {
            var target$4 = finalizer.apply__O__O($m_Lcats_effect_kernel_Resource$ExitCase$Canceled$());
            var tc$4 = this.Lfs2_internal_Scope__f_F;
            var this$19 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target$4, tc$4);
            var this$17 = result.swap__s_util_Either();
            if ((this$17 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
              var b$2 = this$17.s_util_Right__f_value;
              var value$1 = b$2;
            } else {
              var value$1 = $m_Lfs2_internal_AcquireAfterScopeClosed$();
            }
            var b$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value$1);
            return this$19.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.as__O__O__O(this$19.Lcats_Functor$ToFunctorOps$$anon$5__f_self, b$3);
          }
        }));
        return this$20.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$20.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
      }));
      var F$1 = this.Lfs2_internal_Scope__f_F;
      return $f_Lcats_MonadError__redeemWith__O__F1__F1__O(F$1, fa, recover, bind);
    }))(resource));
    return this$22.F__Lcats_effect_kernel_MonadCancel().uncancelable__F1__O(f$3);
  }));
  var target$5 = this.interruptibleEval__O__O(this$23.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$23.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$4));
  var tc$5 = this.Lfs2_internal_Scope__f_F;
  var this$34 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target$5, tc$5);
  var f$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1$2) => {
    if ((x$1$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
      var x38 = x$1$2.s_util_Left__f_value;
      if ((x38 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Errored)) {
        var x41 = x38.Lcats_effect_kernel_Outcome$Errored__f_e;
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Errored(x41);
      }
      if ((x38 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Canceled)) {
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Canceled();
      }
      if ((x38 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Succeeded)) {
        var x33 = x38.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
        var fa$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(x33);
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Succeeded(fa$1);
      }
    }
    if ((x$1$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
      var x26 = x$1$2.s_util_Right__f_value;
      if ((x26 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
        var t$2 = x26.s_util_Left__f_value;
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Errored(t$2);
      }
      if ((x26 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
        var r$1 = x26.s_util_Right__f_value;
        var fa$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(r$1);
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Succeeded(fa$2);
      }
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1$2);
  }));
  return this$34.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.map__O__F1__O(this$34.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$5);
});
$c_Lfs2_internal_Scope.prototype.fs2$internal$Scope$$traverseError__Lcats_data_Chain__F1__O = (function(ca, f) {
  var instance = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_Chain$().Lcats_data_ChainInstances__f_catsDataInstancesForChain;
  var target = instance.traverse__O__F1__Lcats_Applicative__O(ca, f, this.Lfs2_internal_Scope__f_F);
  var tc = this.Lfs2_internal_Scope__f_F;
  var this$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
  var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((results) => {
    var this$3 = $m_Lfs2_CompositeFailure$().fromList__sci_List__s_Option(results.collect__s_PartialFunction__Lcats_data_Chain(new $c_Lfs2_internal_Scope$$anon$1()).toList__sci_List());
    return (this$3.isEmpty__Z() ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right((void 0)) : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(this$3.get__O()));
  }));
  return this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$1);
});
$c_Lfs2_internal_Scope.prototype.close__Lcats_effect_kernel_Resource$ExitCase__O = (function(ec) {
  var this$2 = this.Lfs2_internal_Scope__f_F;
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$4) => $p_Lfs2_internal_Scope__close___Lcats_effect_kernel_Resource$ExitCase__O(this, ec)));
  return this$2.F__Lcats_effect_kernel_MonadCancel().uncancelable__F1__O(f);
});
$c_Lfs2_internal_Scope.prototype.openAncestor__O = (function() {
  var this$1 = this.Lfs2_internal_Scope__f_parent;
  if (this$1.isEmpty__Z()) {
    var this$2 = this.Lfs2_internal_Scope__f_F;
    return this$2.F__Lcats_effect_kernel_MonadCancel().pure__O__O(this);
  } else {
    var x0 = this$1.get__O();
    var target = x0.Lfs2_internal_Scope__f_state.get__O();
    var tc = this.Lfs2_internal_Scope__f_F;
    var this$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
    var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((parent$2) => ((x$1) => {
      if ((x$1 instanceof $c_Lfs2_internal_Scope$State$Open)) {
        var this$5 = this.Lfs2_internal_Scope__f_F;
        return this$5.F__Lcats_effect_kernel_MonadCancel().pure__O__O(parent$2);
      }
      if ((x$1 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
        return parent$2.openAncestor__O();
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    }))(x0));
    return this$6.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$6.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  }
});
$c_Lfs2_internal_Scope.prototype.descendsFrom__Lcats_effect_kernel_Unique$Token__Z = (function(scopeId) {
  var this$1 = $ps_Lfs2_internal_Scope__go$3__Lcats_effect_kernel_Unique$Token__Lfs2_internal_Scope__s_Option(scopeId, this);
  return (!this$1.isEmpty__Z());
});
$c_Lfs2_internal_Scope.prototype.findInLineage__Lcats_effect_kernel_Unique$Token__O = (function(scopeId) {
  var a = $ps_Lfs2_internal_Scope__go$3__Lcats_effect_kernel_Unique$Token__Lfs2_internal_Scope__s_Option(scopeId, this);
  var F = this.Lfs2_internal_Scope__f_F;
  var fa = F.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a);
  return $m_Lcats_syntax_ApplicativeErrorOps$().orElse$extension__O__F0__Lcats_ApplicativeError__O(fa, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $p_Lfs2_internal_Scope__findSelfOrChild__Lcats_effect_kernel_Unique$Token__O(this, scopeId))), this.Lfs2_internal_Scope__f_F);
});
$c_Lfs2_internal_Scope.prototype.shiftScope__Lcats_effect_kernel_Unique$Token__F0__O = (function(scopeId, context) {
  var target = this.findStepScope__Lcats_effect_kernel_Unique$Token__O(scopeId);
  var tc = this.Lfs2_internal_Scope__f_F;
  var this$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var scope = x$1.s_Some__f_value;
      var this$3 = this.Lfs2_internal_Scope__f_F;
      return this$3.F__Lcats_effect_kernel_MonadCancel().pure__O__O(scope);
    }
    var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    if ((x === x$1)) {
      var x$2 = ((("|Scope lookup failure!\n              |\n              |This is typically caused by uncons-ing from two or more streams in the same Pull.\n              |To do this safely, use `s.pull.stepLeg` instead of `s.pull.uncons` or a variant\n              |thereof. See the implementation of `Stream#zipWith_` for an example.\n              |\n              |Scope id: " + this.Lfs2_internal_Scope__f_id) + "\n              |Step: ") + context.apply__O());
      var msg = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_StringOps$().stripMargin$extension__T__C__T(x$2, 124);
      var this$6 = this.Lfs2_internal_Scope__f_F;
      var e = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_RuntimeException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_RuntimeException(), msg);
      return this$6.F__Lcats_effect_kernel_MonadCancel().raiseError__O__O(e);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  }));
  return this$7.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$7.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
});
$c_Lfs2_internal_Scope.prototype.findStepScope__Lcats_effect_kernel_Unique$Token__O = (function(scopeId) {
  var x$2 = this.Lfs2_internal_Scope__f_id;
  if ((scopeId === x$2)) {
    var this$2 = this.Lfs2_internal_Scope__f_F;
    var a = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(this);
    return this$2.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a);
  } else {
    var x94 = this.Lfs2_internal_Scope__f_parent;
    var x$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    if ((x$3 === x94)) {
      return $p_Lfs2_internal_Scope__findSelfOrChild__Lcats_effect_kernel_Unique$Token__O(this, scopeId);
    }
    if ((x94 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var parent = x94.s_Some__f_value;
      var target = $p_Lfs2_internal_Scope__findSelfOrChild__Lcats_effect_kernel_Unique$Token__O(parent, scopeId);
      var tc = this.Lfs2_internal_Scope__f_F;
      var this$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
      var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
        if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
          var scope = x$1.s_Some__f_value;
          var this$6 = this.Lfs2_internal_Scope__f_F;
          var a$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(scope);
          return this$6.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a$1);
        }
        var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        if ((x === x$1)) {
          return $p_Lfs2_internal_Scope__findSelfOrChild__Lcats_effect_kernel_Unique$Token__O($ps_Lfs2_internal_Scope__go$5__Lfs2_internal_Scope__Lfs2_internal_Scope(this), scopeId);
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
      }));
      return this$7.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$7.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x94);
  }
});
$c_Lfs2_internal_Scope.prototype.interruptWhen__O__O = (function(haltWhen) {
  var x97 = this.Lfs2_internal_Scope__f_interruptible;
  var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  if ((x === x97)) {
    var this$1 = this.Lfs2_internal_Scope__f_F;
    var a = new $c_Lfs2_internal_Scope$$anon$2(this);
    return this$1.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a);
  }
  if ((x97 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
    var iCtx = x97.s_Some__f_value;
    var tc = this.Lfs2_internal_Scope__f_F;
    var this$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(haltWhen, tc);
    var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$9) => {
      if ((_$9 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
        var fa = iCtx.Lfs2_internal_InterruptContext__f_interruptRoot;
        var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Succeeded(fa);
      } else {
        if ((!(_$9 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left))) {
          throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(_$9);
        }
        var a$1 = _$9.s_util_Left__f_value;
        var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Errored(a$1);
      }
      return $x_1;
    }));
    var outcome = this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.map__O__F1__O(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
    return iCtx.completeWhen__O__O(outcome);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x97);
});
$c_Lfs2_internal_Scope.prototype.isInterrupted__O = (function() {
  var target = $p_Lfs2_internal_Scope__openScope__O(this);
  var tc = this.Lfs2_internal_Scope__f_F;
  var this$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((scope) => {
    var x100 = scope.Lfs2_internal_Scope__f_interruptible;
    var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    if ((x === x100)) {
      var this$3 = this.Lfs2_internal_Scope__f_F;
      var a = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      return this$3.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a);
    }
    if ((x100 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var iCtx = x100.s_Some__f_value;
      return iCtx.Lfs2_internal_InterruptContext__f_ref.get__O();
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x100);
  }));
  return this$4.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$4.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
});
$c_Lfs2_internal_Scope.prototype.interruptibleEval__O__O = (function(f) {
  var target = $p_Lfs2_internal_Scope__openScope__O(this);
  var tc = this.Lfs2_internal_Scope__f_F;
  var this$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
  var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$11) => _$11.Lfs2_internal_Scope__f_interruptible));
  var target$1 = this$2.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.map__O__F1__O(this$2.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$1);
  var tc$1 = this.Lfs2_internal_Scope__f_F;
  var this$14 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$1);
  var f$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    if ((x === x$1)) {
      var F$1 = this.Lfs2_internal_Scope__f_F;
      var target$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_ApplicativeError__attempt__O__O(F$1, f);
      var tc$2 = this.Lfs2_internal_Scope__f_F;
      var this$13 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, tc$2);
      var f$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$12) => {
        if ((_$12 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
          var a = _$12.s_util_Left__f_value;
          var value = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Errored(a);
          return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value);
        }
        if ((_$12 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_syntax_EitherUtil$();
          return _$12;
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(_$12);
      }));
      return this$13.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.map__O__F1__O(this$13.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$2);
    }
    if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var iCtx = x$1.s_Some__f_value;
      return iCtx.eval__O__O(f);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  }));
  return this$14.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$14.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
});
$c_Lfs2_internal_Scope.prototype.toString__T = (function() {
  var $x_1 = this.Lfs2_internal_Scope__f_id;
  var this$1 = this.Lfs2_internal_Scope__f_interruptible;
  return (((("Scope(id=" + $x_1) + ",interruptible=") + (!this$1.isEmpty__Z())) + ")");
});
var $d_Lfs2_internal_Scope = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_internal_Scope, "fs2.internal.Scope", ({
  Lfs2_internal_Scope: 1
}));
export { $d_Lfs2_internal_Scope as $d_Lfs2_internal_Scope };
/** @constructor */
function $c_Lfs2_internal_Scope$() {
}
export { $c_Lfs2_internal_Scope$ as $c_Lfs2_internal_Scope$ };
$c_Lfs2_internal_Scope$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_internal_Scope$.prototype.constructor = $c_Lfs2_internal_Scope$;
/** @constructor */
function $h_Lfs2_internal_Scope$() {
}
export { $h_Lfs2_internal_Scope$ as $h_Lfs2_internal_Scope$ };
$h_Lfs2_internal_Scope$.prototype = $c_Lfs2_internal_Scope$.prototype;
$c_Lfs2_internal_Scope$.prototype.fs2$internal$Scope$$$apply__Lcats_effect_kernel_Unique$Token__s_Option__s_Option__Lfs2_Compiler$Target__O = (function(id, parent, interruptible, F) {
  var target = F.ref__O__O($m_Lfs2_internal_Scope$State$().Lfs2_internal_Scope$State$__f_initial_);
  var this$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target, F);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((state) => new $c_Lfs2_internal_Scope(id, parent, interruptible, state, F)));
  return this$2.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.map__O__F1__O(this$2.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
});
$c_Lfs2_internal_Scope$.prototype.newRoot__Lfs2_Compiler$Target__O = (function(F) {
  var target = F.unique__O();
  var this$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$18) => $m_Lfs2_internal_Scope$().fs2$internal$Scope$$$apply__Lcats_effect_kernel_Unique$Token__s_Option__s_Option__Lfs2_Compiler$Target__O(_$18, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$(), F)));
  return this$2.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$2.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
});
var $d_Lfs2_internal_Scope$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_internal_Scope$, "fs2.internal.Scope$", ({
  Lfs2_internal_Scope$: 1
}));
export { $d_Lfs2_internal_Scope$ as $d_Lfs2_internal_Scope$ };
var $n_Lfs2_internal_Scope$;
function $m_Lfs2_internal_Scope$() {
  if ((!$n_Lfs2_internal_Scope$)) {
    $n_Lfs2_internal_Scope$ = new $c_Lfs2_internal_Scope$();
  }
  return $n_Lfs2_internal_Scope$;
}
export { $m_Lfs2_internal_Scope$ as $m_Lfs2_internal_Scope$ };
/** @constructor */
function $c_Lfs2_internal_ScopedResource() {
}
export { $c_Lfs2_internal_ScopedResource as $c_Lfs2_internal_ScopedResource };
$c_Lfs2_internal_ScopedResource.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_internal_ScopedResource.prototype.constructor = $c_Lfs2_internal_ScopedResource;
/** @constructor */
function $h_Lfs2_internal_ScopedResource() {
}
export { $h_Lfs2_internal_ScopedResource as $h_Lfs2_internal_ScopedResource };
$h_Lfs2_internal_ScopedResource.prototype = $c_Lfs2_internal_ScopedResource.prototype;
/** @constructor */
function $c_Lfs2_internal_ScopedResource$() {
  this.Lfs2_internal_ScopedResource$__f_initial = null;
  $n_Lfs2_internal_ScopedResource$ = this;
  var finalizer = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  this.Lfs2_internal_ScopedResource$__f_initial = new $c_Lfs2_internal_ScopedResource$State(true, finalizer, 0);
}
export { $c_Lfs2_internal_ScopedResource$ as $c_Lfs2_internal_ScopedResource$ };
$c_Lfs2_internal_ScopedResource$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_internal_ScopedResource$.prototype.constructor = $c_Lfs2_internal_ScopedResource$;
/** @constructor */
function $h_Lfs2_internal_ScopedResource$() {
}
export { $h_Lfs2_internal_ScopedResource$ as $h_Lfs2_internal_ScopedResource$ };
$h_Lfs2_internal_ScopedResource$.prototype = $c_Lfs2_internal_ScopedResource$.prototype;
$c_Lfs2_internal_ScopedResource$.prototype.create__Lfs2_Compiler$Target__O = (function(F) {
  $m_Lcats_implicits$();
  var target = F.ref__O__O(this.Lfs2_internal_ScopedResource$__f_initial);
  var this$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F);
  var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((state) => {
    $m_Lcats_implicits$();
    var target$1 = F.unique__O();
    var this$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, F);
    var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((state$2) => ((token) => new $c_Lfs2_internal_ScopedResource$$anon$1(token, F, state$2)))(state));
    return this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  }));
  return this$5.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$5.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
});
var $d_Lfs2_internal_ScopedResource$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_internal_ScopedResource$, "fs2.internal.ScopedResource$", ({
  Lfs2_internal_ScopedResource$: 1
}));
export { $d_Lfs2_internal_ScopedResource$ as $d_Lfs2_internal_ScopedResource$ };
var $n_Lfs2_internal_ScopedResource$;
function $m_Lfs2_internal_ScopedResource$() {
  if ((!$n_Lfs2_internal_ScopedResource$)) {
    $n_Lfs2_internal_ScopedResource$ = new $c_Lfs2_internal_ScopedResource$();
  }
  return $n_Lfs2_internal_ScopedResource$;
}
export { $m_Lfs2_internal_ScopedResource$ as $m_Lfs2_internal_ScopedResource$ };
/** @constructor */
function $c_Lio_circe_Error$() {
  this.Lio_circe_Error$__f_showError = null;
  $n_Lio_circe_Error$ = this;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_package$();
  var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1$2) => {
    if ((x$1$2 instanceof $c_Lio_circe_ParsingFailure)) {
      return $m_Lio_circe_ParsingFailure$().Lio_circe_ParsingFailure$__f_showParsingFailure.show__O__T(x$1$2);
    }
    if ((x$1$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lio_circe_DecodingFailure)) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_DecodingFailure$().Lio_circe_DecodingFailure$__f_showDecodingFailure.show__O__T(x$1$2);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1$2);
  }));
  this.Lio_circe_Error$__f_showError = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$$anon$4(f$1);
}
export { $c_Lio_circe_Error$ as $c_Lio_circe_Error$ };
$c_Lio_circe_Error$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_circe_Error$.prototype.constructor = $c_Lio_circe_Error$;
/** @constructor */
function $h_Lio_circe_Error$() {
}
export { $h_Lio_circe_Error$ as $h_Lio_circe_Error$ };
$h_Lio_circe_Error$.prototype = $c_Lio_circe_Error$.prototype;
var $d_Lio_circe_Error$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_circe_Error$, "io.circe.Error$", ({
  Lio_circe_Error$: 1
}));
export { $d_Lio_circe_Error$ as $d_Lio_circe_Error$ };
var $n_Lio_circe_Error$;
function $m_Lio_circe_Error$() {
  if ((!$n_Lio_circe_Error$)) {
    $n_Lio_circe_Error$ = new $c_Lio_circe_Error$();
  }
  return $n_Lio_circe_Error$;
}
export { $m_Lio_circe_Error$ as $m_Lio_circe_Error$ };
/** @constructor */
function $c_Lio_circe_KeyDecoder$() {
}
export { $c_Lio_circe_KeyDecoder$ as $c_Lio_circe_KeyDecoder$ };
$c_Lio_circe_KeyDecoder$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_circe_KeyDecoder$.prototype.constructor = $c_Lio_circe_KeyDecoder$;
/** @constructor */
function $h_Lio_circe_KeyDecoder$() {
}
export { $h_Lio_circe_KeyDecoder$ as $h_Lio_circe_KeyDecoder$ };
$h_Lio_circe_KeyDecoder$.prototype = $c_Lio_circe_KeyDecoder$.prototype;
var $d_Lio_circe_KeyDecoder$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_circe_KeyDecoder$, "io.circe.KeyDecoder$", ({
  Lio_circe_KeyDecoder$: 1
}));
export { $d_Lio_circe_KeyDecoder$ as $d_Lio_circe_KeyDecoder$ };
var $n_Lio_circe_KeyDecoder$;
function $m_Lio_circe_KeyDecoder$() {
  if ((!$n_Lio_circe_KeyDecoder$)) {
    $n_Lio_circe_KeyDecoder$ = new $c_Lio_circe_KeyDecoder$();
  }
  return $n_Lio_circe_KeyDecoder$;
}
export { $m_Lio_circe_KeyDecoder$ as $m_Lio_circe_KeyDecoder$ };
/** @constructor */
function $c_Lio_circe_MapDecoder$() {
}
export { $c_Lio_circe_MapDecoder$ as $c_Lio_circe_MapDecoder$ };
$c_Lio_circe_MapDecoder$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_circe_MapDecoder$.prototype.constructor = $c_Lio_circe_MapDecoder$;
/** @constructor */
function $h_Lio_circe_MapDecoder$() {
}
export { $h_Lio_circe_MapDecoder$ as $h_Lio_circe_MapDecoder$ };
$h_Lio_circe_MapDecoder$.prototype = $c_Lio_circe_MapDecoder$.prototype;
$c_Lio_circe_MapDecoder$.prototype.invalidKeyfailure__Lio_circe_HCursor__Lio_circe_DecodingFailure = (function(c) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_DecodingFailure$().apply__T__F0__Lio_circe_DecodingFailure("Couldn't decode key.", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => c.history__sci_List())));
});
$c_Lio_circe_MapDecoder$.prototype.notJsObjectFailure__Lio_circe_HCursor__Lio_circe_Json__Lio_circe_DecodingFailure = (function(c, value) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_DecodingFailure$().apply__Lio_circe_DecodingFailure$Reason__F0__Lio_circe_DecodingFailure(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation("object", value), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => c.history__sci_List())));
});
$c_Lio_circe_MapDecoder$.prototype.notJsObjectFailureResult__Lio_circe_HCursor__Lio_circe_Json__s_util_Either = (function(c, value) {
  var value$1 = this.notJsObjectFailure__Lio_circe_HCursor__Lio_circe_Json__Lio_circe_DecodingFailure(c, value);
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value$1);
});
$c_Lio_circe_MapDecoder$.prototype.notJsObjectfailureAccumulatingResult__Lio_circe_HCursor__Lio_circe_Json__Lcats_data_Validated = (function(c, value) {
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_Validated$();
  var e = this.notJsObjectFailure__Lio_circe_HCursor__Lio_circe_Json__Lio_circe_DecodingFailure(c, value);
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_data_ValidatedFunctions__invalidNel__O__Lcats_data_Validated(this$1, e);
});
var $d_Lio_circe_MapDecoder$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_circe_MapDecoder$, "io.circe.MapDecoder$", ({
  Lio_circe_MapDecoder$: 1
}));
export { $d_Lio_circe_MapDecoder$ as $d_Lio_circe_MapDecoder$ };
var $n_Lio_circe_MapDecoder$;
function $m_Lio_circe_MapDecoder$() {
  if ((!$n_Lio_circe_MapDecoder$)) {
    $n_Lio_circe_MapDecoder$ = new $c_Lio_circe_MapDecoder$();
  }
  return $n_Lio_circe_MapDecoder$;
}
export { $m_Lio_circe_MapDecoder$ as $m_Lio_circe_MapDecoder$ };
function $is_Lio_circe_derivation_SumOrProduct(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lio_circe_derivation_SumOrProduct)));
}
export { $is_Lio_circe_derivation_SumOrProduct as $is_Lio_circe_derivation_SumOrProduct };
function $isArrayOf_Lio_circe_derivation_SumOrProduct(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_derivation_SumOrProduct)));
}
export { $isArrayOf_Lio_circe_derivation_SumOrProduct as $isArrayOf_Lio_circe_derivation_SumOrProduct };
/** @constructor */
function $c_Lio_circe_scalajs_package$() {
}
export { $c_Lio_circe_scalajs_package$ as $c_Lio_circe_scalajs_package$ };
$c_Lio_circe_scalajs_package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_circe_scalajs_package$.prototype.constructor = $c_Lio_circe_scalajs_package$;
/** @constructor */
function $h_Lio_circe_scalajs_package$() {
}
export { $h_Lio_circe_scalajs_package$ as $h_Lio_circe_scalajs_package$ };
$h_Lio_circe_scalajs_package$.prototype = $c_Lio_circe_scalajs_package$.prototype;
$c_Lio_circe_scalajs_package$.prototype.convertAnyToJsonUnsafe__O__Lio_circe_Json = (function(input) {
  if (((typeof input) === "string")) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_Json$().fromString__T__Lio_circe_Json(input);
  }
  if (((typeof input) === "number")) {
    var n = (+input);
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_Json$().fromDoubleOrNull__D__Lio_circe_Json(n);
  }
  if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(true, input)) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_Json$().Lio_circe_Json$__f_True;
  }
  if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(false, input)) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_Json$().Lio_circe_Json$__f_False;
  }
  if ((input === null)) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_Json$().Lio_circe_Json$__f_Null;
  }
  if ((!(!(input instanceof Array)))) {
    var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_Json$();
    var len = (input.length | 0);
    var res = new Array(len);
    var i = 0;
    while ((i < len)) {
      var $x_1 = i;
      var x0 = input[i];
      res[$x_1] = $m_Lio_circe_scalajs_package$().convertAnyToJsonUnsafe__O__Lio_circe_Json(x0);
      i = ((1 + i) | 0);
    }
    return $x_2.fromValues__sc_Iterable__Lio_circe_Json($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_sjs_js_WrappedArray__sjs_js_Array__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_WrappedArray(), res));
  }
  if ((!(!(input instanceof Object)))) {
    var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_Json$();
    var this$5 = new $c_sjs_js_WrappedDictionary(input);
    var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((input$2) => $m_Lio_circe_scalajs_package$().convertAnyToJsonUnsafe__O__Lio_circe_Json(input$2)));
    var this$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapView$MapValues(this$5, f);
    return $x_3.fromFields__sc_Iterable__Lio_circe_Json($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$6));
  }
  if ((input === (void 0))) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_Json$().Lio_circe_Json$__f_Null;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(input);
});
$c_Lio_circe_scalajs_package$.prototype.convertJsToJson__sjs_js_Any__s_util_Either = (function(input) {
  try {
    var value = $m_Lio_circe_scalajs_package$().convertAnyToJsonUnsafe__O__Lio_circe_Json(input);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value);
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
    var x7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
    if ((!x7.isEmpty__Z())) {
      var x8 = x7.get__O();
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(x8);
    }
    throw ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
  }
});
var $d_Lio_circe_scalajs_package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_circe_scalajs_package$, "io.circe.scalajs.package$", ({
  Lio_circe_scalajs_package$: 1
}));
export { $d_Lio_circe_scalajs_package$ as $d_Lio_circe_scalajs_package$ };
var $n_Lio_circe_scalajs_package$;
function $m_Lio_circe_scalajs_package$() {
  if ((!$n_Lio_circe_scalajs_package$)) {
    $n_Lio_circe_scalajs_package$ = new $c_Lio_circe_scalajs_package$();
  }
  return $n_Lio_circe_scalajs_package$;
}
export { $m_Lio_circe_scalajs_package$ as $m_Lio_circe_scalajs_package$ };
/** @constructor */
function $c_Lio_scalaland_chimney_partial_Path$() {
  this.Lio_scalaland_chimney_partial_Path$__f_Empty = null;
  $n_Lio_scalaland_chimney_partial_Path$ = this;
  $m_Lio_scalaland_chimney_partial_Path$();
  var elements = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  this.Lio_scalaland_chimney_partial_Path$__f_Empty = elements;
}
export { $c_Lio_scalaland_chimney_partial_Path$ as $c_Lio_scalaland_chimney_partial_Path$ };
$c_Lio_scalaland_chimney_partial_Path$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_scalaland_chimney_partial_Path$.prototype.constructor = $c_Lio_scalaland_chimney_partial_Path$;
/** @constructor */
function $h_Lio_scalaland_chimney_partial_Path$() {
}
export { $h_Lio_scalaland_chimney_partial_Path$ as $h_Lio_scalaland_chimney_partial_Path$ };
$h_Lio_scalaland_chimney_partial_Path$.prototype = $c_Lio_scalaland_chimney_partial_Path$.prototype;
$c_Lio_scalaland_chimney_partial_Path$.prototype.equals$extension__sci_List__O__Z = (function(this$, x$0) {
  if ((x$0 instanceof $c_Lio_scalaland_chimney_partial_Path)) {
    var x$0$2 = ((x$0 === null) ? null : x$0.Lio_scalaland_chimney_partial_Path__f_elements);
    return ((this$ === null) ? (x$0$2 === null) : this$.equals__O__Z(x$0$2));
  } else {
    return false;
  }
});
$c_Lio_scalaland_chimney_partial_Path$.prototype.toString$extension__sci_List__T = (function(this$) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(new $c_Lio_scalaland_chimney_partial_Path(this$));
});
$c_Lio_scalaland_chimney_partial_Path$.prototype.productElement$extension__sci_List__I__O = (function(this$, n) {
  if ((n === 0)) {
    return this$;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_scalaland_chimney_partial_Path$.prototype.productElementName$extension__sci_List__I__T = (function(this$, n) {
  if ((n === 0)) {
    return "elements";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_scalaland_chimney_partial_Path$.prototype.prepend$extension__sci_List__Lio_scalaland_chimney_partial_PathElement__sci_List = (function(this$, pathElement) {
  if ((this$ instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon)) {
    var x11 = this$.sci_$colon$colon__f_head;
    var x12 = this$.sci_$colon$colon__f_next;
    if (false) {
      return this$;
    }
    if (false) {
      if ((x11.sealPath__Z() || false)) {
        return this$;
      } else if (false) {
        x11.sealPath_$eq__Z__V(true);
        return this$;
      } else {
        $m_Lio_scalaland_chimney_partial_Path$();
        var this$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(pathElement, x12);
        var elements = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(x11, this$1);
        return elements;
      }
    }
  }
  if (false) {
    $m_Lio_scalaland_chimney_partial_Path$();
    var this$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var elements$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(pathElement, this$3);
    return elements$1;
  } else {
    $m_Lio_scalaland_chimney_partial_Path$();
    var elements$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(pathElement, this$);
    return elements$2;
  }
});
$c_Lio_scalaland_chimney_partial_Path$.prototype.unsealPath$extension__sci_List__V = (function(this$) {
  if ((this$ instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon)) {
    var x16 = this$.sci_$colon$colon__f_head;
    if (false) {
      x16.sealPath_$eq__Z__V(false);
      return (void 0);
    }
  }
});
$c_Lio_scalaland_chimney_partial_Path$.prototype.asString$extension__sci_List__T = (function(this$) {
  if (this$.isEmpty__Z()) {
    return "";
  } else {
    var sb = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_scm_StringBuilder__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_StringBuilder());
    var it = this$.iterator__sc_Iterator();
    var computedSuffix = null;
    while (it.hasNext__Z()) {
      var curr = it.next__O();
      if (((computedSuffix === null) && false)) {
        computedSuffix = curr.asString__T();
      } else {
        if (((!sb.isEmpty__Z()) && $m_Lio_scalaland_chimney_partial_PathElement$().shouldPrependWithDot__Lio_scalaland_chimney_partial_PathElement__Z(curr))) {
          sb.addOne__C__scm_StringBuilder(46);
        }
        var s = curr.asString__T();
        sb.addAll__T__scm_StringBuilder(s);
      }
    }
    if ((computedSuffix !== null)) {
      if ((!sb.isEmpty__Z())) {
        sb.addAll__T__scm_StringBuilder(" => ");
      }
      var s$1 = computedSuffix;
      sb.addAll__T__scm_StringBuilder(s$1);
    }
    return sb.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  }
});
var $d_Lio_scalaland_chimney_partial_Path$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_scalaland_chimney_partial_Path$, "io.scalaland.chimney.partial.Path$", ({
  Lio_scalaland_chimney_partial_Path$: 1
}));
export { $d_Lio_scalaland_chimney_partial_Path$ as $d_Lio_scalaland_chimney_partial_Path$ };
var $n_Lio_scalaland_chimney_partial_Path$;
function $m_Lio_scalaland_chimney_partial_Path$() {
  if ((!$n_Lio_scalaland_chimney_partial_Path$)) {
    $n_Lio_scalaland_chimney_partial_Path$ = new $c_Lio_scalaland_chimney_partial_Path$();
  }
  return $n_Lio_scalaland_chimney_partial_Path$;
}
export { $m_Lio_scalaland_chimney_partial_Path$ as $m_Lio_scalaland_chimney_partial_Path$ };
var $d_jl_Runnable = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass(1, "java.lang.Runnable", ({
  jl_Runnable: 1
}));
export { $d_jl_Runnable as $d_jl_Runnable };
/** @constructor */
function $c_jl_System$Streams$() {
  this.jl_System$Streams$__f_err = null;
  $n_jl_System$Streams$ = this;
  this.jl_System$Streams$__f_err = new $c_jl_JSConsoleBasedPrintStream(true);
}
export { $c_jl_System$Streams$ as $c_jl_System$Streams$ };
$c_jl_System$Streams$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_jl_System$Streams$.prototype.constructor = $c_jl_System$Streams$;
/** @constructor */
function $h_jl_System$Streams$() {
}
export { $h_jl_System$Streams$ as $h_jl_System$Streams$ };
$h_jl_System$Streams$.prototype = $c_jl_System$Streams$.prototype;
var $d_jl_System$Streams$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_jl_System$Streams$, "java.lang.System$Streams$", ({
  jl_System$Streams$: 1
}));
export { $d_jl_System$Streams$ as $d_jl_System$Streams$ };
var $n_jl_System$Streams$;
function $m_jl_System$Streams$() {
  if ((!$n_jl_System$Streams$)) {
    $n_jl_System$Streams$ = new $c_jl_System$Streams$();
  }
  return $n_jl_System$Streams$;
}
export { $m_jl_System$Streams$ as $m_jl_System$Streams$ };
/** @constructor */
function $c_jl_Thread$() {
  this.jl_Thread$__f_SingleThread = null;
  $n_jl_Thread$ = this;
  this.jl_Thread$__f_SingleThread = new $c_jl_Thread((void 0));
}
export { $c_jl_Thread$ as $c_jl_Thread$ };
$c_jl_Thread$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_jl_Thread$.prototype.constructor = $c_jl_Thread$;
/** @constructor */
function $h_jl_Thread$() {
}
export { $h_jl_Thread$ as $h_jl_Thread$ };
$h_jl_Thread$.prototype = $c_jl_Thread$.prototype;
$c_jl_Thread$.prototype.interrupted__Z = (function() {
  var this$1 = this.jl_Thread$__f_SingleThread;
  var ret = this$1.jl_Thread__f_java$lang$Thread$$interruptedState;
  this.jl_Thread$__f_SingleThread.jl_Thread__f_java$lang$Thread$$interruptedState = false;
  return ret;
});
var $d_jl_Thread$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_jl_Thread$, "java.lang.Thread$", ({
  jl_Thread$: 1
}));
export { $d_jl_Thread$ as $d_jl_Thread$ };
var $n_jl_Thread$;
function $m_jl_Thread$() {
  if ((!$n_jl_Thread$)) {
    $n_jl_Thread$ = new $c_jl_Thread$();
  }
  return $n_jl_Thread$;
}
export { $m_jl_Thread$ as $m_jl_Thread$ };
/** @constructor */
function $c_Lmagnolia1_SealedTrait$SubtypeValue(subtype, v) {
  this.Lmagnolia1_SealedTrait$SubtypeValue__f_subtype = null;
  this.Lmagnolia1_SealedTrait$SubtypeValue__f_v = null;
  this.Lmagnolia1_SealedTrait$SubtypeValue__f_subtype = subtype;
  this.Lmagnolia1_SealedTrait$SubtypeValue__f_v = v;
}
export { $c_Lmagnolia1_SealedTrait$SubtypeValue as $c_Lmagnolia1_SealedTrait$SubtypeValue };
$c_Lmagnolia1_SealedTrait$SubtypeValue.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lmagnolia1_SealedTrait$SubtypeValue.prototype.constructor = $c_Lmagnolia1_SealedTrait$SubtypeValue;
/** @constructor */
function $h_Lmagnolia1_SealedTrait$SubtypeValue() {
}
export { $h_Lmagnolia1_SealedTrait$SubtypeValue as $h_Lmagnolia1_SealedTrait$SubtypeValue };
$h_Lmagnolia1_SealedTrait$SubtypeValue.prototype = $c_Lmagnolia1_SealedTrait$SubtypeValue.prototype;
$c_Lmagnolia1_SealedTrait$SubtypeValue.prototype.value__O = (function() {
  return this.Lmagnolia1_SealedTrait$SubtypeValue__f_subtype.apply__O__O(this.Lmagnolia1_SealedTrait$SubtypeValue__f_v);
});
var $d_Lmagnolia1_SealedTrait$SubtypeValue = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lmagnolia1_SealedTrait$SubtypeValue, "magnolia1.SealedTrait$SubtypeValue", ({
  Lmagnolia1_SealedTrait$SubtypeValue: 1
}));
export { $d_Lmagnolia1_SealedTrait$SubtypeValue as $d_Lmagnolia1_SealedTrait$SubtypeValue };
function $ct_Lmonocle_IsoInstances__($thiz) {
  return $thiz;
}
export { $ct_Lmonocle_IsoInstances__ as $ct_Lmonocle_IsoInstances__ };
/** @constructor */
function $c_Lmonocle_IsoInstances() {
}
export { $c_Lmonocle_IsoInstances as $c_Lmonocle_IsoInstances };
$c_Lmonocle_IsoInstances.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lmonocle_IsoInstances.prototype.constructor = $c_Lmonocle_IsoInstances;
/** @constructor */
function $h_Lmonocle_IsoInstances() {
}
export { $h_Lmonocle_IsoInstances as $h_Lmonocle_IsoInstances };
$h_Lmonocle_IsoInstances.prototype = $c_Lmonocle_IsoInstances.prototype;
function $ct_Lmonocle_LensInstances__($thiz) {
  return $thiz;
}
export { $ct_Lmonocle_LensInstances__ as $ct_Lmonocle_LensInstances__ };
/** @constructor */
function $c_Lmonocle_LensInstances() {
}
export { $c_Lmonocle_LensInstances as $c_Lmonocle_LensInstances };
$c_Lmonocle_LensInstances.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lmonocle_LensInstances.prototype.constructor = $c_Lmonocle_LensInstances;
/** @constructor */
function $h_Lmonocle_LensInstances() {
}
export { $h_Lmonocle_LensInstances as $h_Lmonocle_LensInstances };
$h_Lmonocle_LensInstances.prototype = $c_Lmonocle_LensInstances.prototype;
/** @constructor */
function $c_Lmonocle_Optional$() {
}
export { $c_Lmonocle_Optional$ as $c_Lmonocle_Optional$ };
$c_Lmonocle_Optional$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lmonocle_Optional$.prototype.constructor = $c_Lmonocle_Optional$;
/** @constructor */
function $h_Lmonocle_Optional$() {
}
export { $h_Lmonocle_Optional$ as $h_Lmonocle_Optional$ };
$h_Lmonocle_Optional$.prototype = $c_Lmonocle_Optional$.prototype;
$c_Lmonocle_Optional$.prototype.void__Lmonocle_POptional = (function() {
  var this$4 = $m_Lmonocle_Optional$();
  var _getOption = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$19) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()));
  var _set = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$20) => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x) => x))));
  return new $c_Lmonocle_Optional$$anon$3(_getOption, _set, this$4);
});
var $d_Lmonocle_Optional$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lmonocle_Optional$, "monocle.Optional$", ({
  Lmonocle_Optional$: 1
}));
export { $d_Lmonocle_Optional$ as $d_Lmonocle_Optional$ };
var $n_Lmonocle_Optional$;
function $m_Lmonocle_Optional$() {
  if ((!$n_Lmonocle_Optional$)) {
    $n_Lmonocle_Optional$ = new $c_Lmonocle_Optional$();
  }
  return $n_Lmonocle_Optional$;
}
export { $m_Lmonocle_Optional$ as $m_Lmonocle_Optional$ };
/** @constructor */
function $c_Lmonocle_Prism$() {
}
export { $c_Lmonocle_Prism$ as $c_Lmonocle_Prism$ };
$c_Lmonocle_Prism$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lmonocle_Prism$.prototype.constructor = $c_Lmonocle_Prism$;
/** @constructor */
function $h_Lmonocle_Prism$() {
}
export { $h_Lmonocle_Prism$ as $h_Lmonocle_Prism$ };
$h_Lmonocle_Prism$.prototype = $c_Lmonocle_Prism$.prototype;
var $d_Lmonocle_Prism$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lmonocle_Prism$, "monocle.Prism$", ({
  Lmonocle_Prism$: 1
}));
export { $d_Lmonocle_Prism$ as $d_Lmonocle_Prism$ };
var $n_Lmonocle_Prism$;
function $m_Lmonocle_Prism$() {
  if ((!$n_Lmonocle_Prism$)) {
    $n_Lmonocle_Prism$ = new $c_Lmonocle_Prism$();
  }
  return $n_Lmonocle_Prism$;
}
export { $m_Lmonocle_Prism$ as $m_Lmonocle_Prism$ };
function $ct_Lmonocle_PrismInstances__($thiz) {
  return $thiz;
}
export { $ct_Lmonocle_PrismInstances__ as $ct_Lmonocle_PrismInstances__ };
/** @constructor */
function $c_Lmonocle_PrismInstances() {
}
export { $c_Lmonocle_PrismInstances as $c_Lmonocle_PrismInstances };
$c_Lmonocle_PrismInstances.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lmonocle_PrismInstances.prototype.constructor = $c_Lmonocle_PrismInstances;
/** @constructor */
function $h_Lmonocle_PrismInstances() {
}
export { $h_Lmonocle_PrismInstances as $h_Lmonocle_PrismInstances };
$h_Lmonocle_PrismInstances.prototype = $c_Lmonocle_PrismInstances.prototype;
function $f_Lmonocle_internal_BoundedInstances__$init$__V($thiz) {
  $thiz.Lmonocle_internal_Bounded$__f_booleanBounded = new $c_Lmonocle_internal_BoundedInstances$$anon$1();
  $thiz.Lmonocle_internal_Bounded$__f_byteBounded = new $c_Lmonocle_internal_BoundedInstances$$anon$2();
  $thiz.Lmonocle_internal_Bounded$__f_charBounded = new $c_Lmonocle_internal_BoundedInstances$$anon$3();
  $thiz.Lmonocle_internal_Bounded$__f_intBounded = new $c_Lmonocle_internal_BoundedInstances$$anon$4();
}
export { $f_Lmonocle_internal_BoundedInstances__$init$__V as $f_Lmonocle_internal_BoundedInstances__$init$__V };
function $f_Lmonocle_std_ByteOptics__$init$__V($thiz) {
  $thiz.Lmonocle_std_byte$__f_byteToBoolean = $m_Lmonocle_internal_Bounded$().orderingBoundedSafeCast__F1__F1__Lcats_kernel_Order__Lmonocle_internal_Bounded__Lmonocle_PPrism(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    var x$1$1 = (x$1 | 0);
    if ((x$1$1 === 0)) {
      return false;
    }
    if ((x$1$1 === 1)) {
      return true;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1$1);
  })), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => {
    var _$1$1 = (!(!_$1));
    return (_$1$1 ? 1 : 0);
  })), $m_Lcats_instances_package$byte$().Lcats_instances_package$byte$__f_catsKernelStdOrderForByte, $m_Lmonocle_internal_Bounded$().Lmonocle_internal_Bounded$__f_booleanBounded);
}
export { $f_Lmonocle_std_ByteOptics__$init$__V as $f_Lmonocle_std_ByteOptics__$init$__V };
function $f_Lmonocle_std_LongOptics__$init$__V($thiz) {
  $thiz.Lmonocle_std_long$__f_longToInt = $m_Lmonocle_internal_Bounded$().orderingBoundedSafeCast__F1__F1__Lcats_kernel_Order__Lmonocle_internal_Bounded__Lmonocle_PPrism(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => {
    var t = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(_$1);
    var lo = t.RTLong__f_lo;
    return lo;
  })), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => {
    var _$2$1 = (_$2 | 0);
    var hi$1 = (_$2$1 >> 31);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(_$2$1, hi$1);
  })), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$long$().Lcats_instances_package$long$__f_catsKernelStdOrderForLong, $m_Lmonocle_internal_Bounded$().Lmonocle_internal_Bounded$__f_intBounded);
  $m_Lmonocle_internal_Bounded$().orderingBoundedSafeCast__F1__F1__Lcats_kernel_Order__Lmonocle_internal_Bounded__Lmonocle_PPrism(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$3) => {
    var t$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(_$3);
    var lo$1 = t$1.RTLong__f_lo;
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bC((65535 & lo$1));
  })), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$4) => {
    var _$4$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uC(_$4);
    var value = _$4$1;
    var hi$3 = (value >> 31);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(value, hi$3);
  })), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$long$().Lcats_instances_package$long$__f_catsKernelStdOrderForLong, $m_Lmonocle_internal_Bounded$().Lmonocle_internal_Bounded$__f_charBounded);
  $thiz.Lmonocle_std_long$__f_longToByte = $m_Lmonocle_internal_Bounded$().orderingBoundedSafeCast__F1__F1__Lcats_kernel_Order__Lmonocle_internal_Bounded__Lmonocle_PPrism(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$5) => {
    var t$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(_$5);
    var lo$2 = t$2.RTLong__f_lo;
    return ((lo$2 << 24) >> 24);
  })), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$6) => {
    var _$6$1 = (_$6 | 0);
    var value$1 = _$6$1;
    var hi$5 = (value$1 >> 31);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(value$1, hi$5);
  })), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$long$().Lcats_instances_package$long$__f_catsKernelStdOrderForLong, $m_Lmonocle_internal_Bounded$().Lmonocle_internal_Bounded$__f_byteBounded);
  $thiz.Lmonocle_std_long$__f_longToByte.andThen__Lmonocle_PPrism__Lmonocle_PPrism($m_Lmonocle_std_byte$().Lmonocle_std_byte$__f_byteToBoolean);
}
export { $f_Lmonocle_std_LongOptics__$init$__V as $f_Lmonocle_std_LongOptics__$init$__V };
function $f_Lmonocle_std_OptionOptics__pSome__Lmonocle_PPrism($thiz) {
  var this$5 = $m_Lmonocle_PPrism$();
  var _getOrModify = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => {
    if (_$1.isEmpty__Z()) {
      var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    } else {
      var x0 = _$1.get__O();
      var this$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(x0));
    }
    if (this$2.isEmpty__Z()) {
      var value = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value);
    } else {
      var $x_1 = this$2.get__O();
    }
    return $x_1;
  }));
  var _reverseGet = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((value$1) => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value$1)));
  return new $c_Lmonocle_PPrism$$anon$2(_getOrModify, _reverseGet, this$5);
}
export { $f_Lmonocle_std_OptionOptics__pSome__Lmonocle_PPrism as $f_Lmonocle_std_OptionOptics__pSome__Lmonocle_PPrism };
/** @constructor */
function $c_Lmonocle_syntax_AppliedPLens$() {
}
export { $c_Lmonocle_syntax_AppliedPLens$ as $c_Lmonocle_syntax_AppliedPLens$ };
$c_Lmonocle_syntax_AppliedPLens$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lmonocle_syntax_AppliedPLens$.prototype.constructor = $c_Lmonocle_syntax_AppliedPLens$;
/** @constructor */
function $h_Lmonocle_syntax_AppliedPLens$() {
}
export { $h_Lmonocle_syntax_AppliedPLens$ as $h_Lmonocle_syntax_AppliedPLens$ };
$h_Lmonocle_syntax_AppliedPLens$.prototype = $c_Lmonocle_syntax_AppliedPLens$.prototype;
var $d_Lmonocle_syntax_AppliedPLens$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lmonocle_syntax_AppliedPLens$, "monocle.syntax.AppliedPLens$", ({
  Lmonocle_syntax_AppliedPLens$: 1
}));
export { $d_Lmonocle_syntax_AppliedPLens$ as $d_Lmonocle_syntax_AppliedPLens$ };
var $n_Lmonocle_syntax_AppliedPLens$;
function $m_Lmonocle_syntax_AppliedPLens$() {
  if ((!$n_Lmonocle_syntax_AppliedPLens$)) {
    $n_Lmonocle_syntax_AppliedPLens$ = new $c_Lmonocle_syntax_AppliedPLens$();
  }
  return $n_Lmonocle_syntax_AppliedPLens$;
}
export { $m_Lmonocle_syntax_AppliedPLens$ as $m_Lmonocle_syntax_AppliedPLens$ };
/** @constructor */
function $c_Lmonocle_syntax_AppliedPOptional$() {
}
export { $c_Lmonocle_syntax_AppliedPOptional$ as $c_Lmonocle_syntax_AppliedPOptional$ };
$c_Lmonocle_syntax_AppliedPOptional$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lmonocle_syntax_AppliedPOptional$.prototype.constructor = $c_Lmonocle_syntax_AppliedPOptional$;
/** @constructor */
function $h_Lmonocle_syntax_AppliedPOptional$() {
}
export { $h_Lmonocle_syntax_AppliedPOptional$ as $h_Lmonocle_syntax_AppliedPOptional$ };
$h_Lmonocle_syntax_AppliedPOptional$.prototype = $c_Lmonocle_syntax_AppliedPOptional$.prototype;
var $d_Lmonocle_syntax_AppliedPOptional$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lmonocle_syntax_AppliedPOptional$, "monocle.syntax.AppliedPOptional$", ({
  Lmonocle_syntax_AppliedPOptional$: 1
}));
export { $d_Lmonocle_syntax_AppliedPOptional$ as $d_Lmonocle_syntax_AppliedPOptional$ };
var $n_Lmonocle_syntax_AppliedPOptional$;
function $m_Lmonocle_syntax_AppliedPOptional$() {
  if ((!$n_Lmonocle_syntax_AppliedPOptional$)) {
    $n_Lmonocle_syntax_AppliedPOptional$ = new $c_Lmonocle_syntax_AppliedPOptional$();
  }
  return $n_Lmonocle_syntax_AppliedPOptional$;
}
export { $m_Lmonocle_syntax_AppliedPOptional$ as $m_Lmonocle_syntax_AppliedPOptional$ };
function $f_Lmonocle_syntax_AppliedPSetter__replace__O__O($thiz, b) {
  return $thiz.optic__Lmonocle_PSetter().replace__O__F1(b).apply__O__O($thiz.value__O());
}
export { $f_Lmonocle_syntax_AppliedPSetter__replace__O__O as $f_Lmonocle_syntax_AppliedPSetter__replace__O__O };
function $f_Lmonocle_syntax_AppliedPSetter__modify__F1__O($thiz, f) {
  return $thiz.optic__Lmonocle_PSetter().modify__F1__F1(f).apply__O__O($thiz.value__O());
}
export { $f_Lmonocle_syntax_AppliedPSetter__modify__F1__O as $f_Lmonocle_syntax_AppliedPSetter__modify__F1__O };
/** @constructor */
function $c_Lorg_scalajs_dom_RequestRedirect$package$RequestRedirect$() {
  this.Lorg_scalajs_dom_RequestRedirect$package$RequestRedirect$__f_follow = null;
  this.Lorg_scalajs_dom_RequestRedirect$package$RequestRedirect$__f_manual = null;
  this.Lorg_scalajs_dom_RequestRedirect$package$RequestRedirect$__f_follow = "follow";
  this.Lorg_scalajs_dom_RequestRedirect$package$RequestRedirect$__f_manual = "manual";
}
export { $c_Lorg_scalajs_dom_RequestRedirect$package$RequestRedirect$ as $c_Lorg_scalajs_dom_RequestRedirect$package$RequestRedirect$ };
$c_Lorg_scalajs_dom_RequestRedirect$package$RequestRedirect$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lorg_scalajs_dom_RequestRedirect$package$RequestRedirect$.prototype.constructor = $c_Lorg_scalajs_dom_RequestRedirect$package$RequestRedirect$;
/** @constructor */
function $h_Lorg_scalajs_dom_RequestRedirect$package$RequestRedirect$() {
}
export { $h_Lorg_scalajs_dom_RequestRedirect$package$RequestRedirect$ as $h_Lorg_scalajs_dom_RequestRedirect$package$RequestRedirect$ };
$h_Lorg_scalajs_dom_RequestRedirect$package$RequestRedirect$.prototype = $c_Lorg_scalajs_dom_RequestRedirect$package$RequestRedirect$.prototype;
var $d_Lorg_scalajs_dom_RequestRedirect$package$RequestRedirect$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lorg_scalajs_dom_RequestRedirect$package$RequestRedirect$, "org.scalajs.dom.RequestRedirect$package$RequestRedirect$", ({
  Lorg_scalajs_dom_RequestRedirect$package$RequestRedirect$: 1
}));
export { $d_Lorg_scalajs_dom_RequestRedirect$package$RequestRedirect$ as $d_Lorg_scalajs_dom_RequestRedirect$package$RequestRedirect$ };
var $n_Lorg_scalajs_dom_RequestRedirect$package$RequestRedirect$;
function $m_Lorg_scalajs_dom_RequestRedirect$package$RequestRedirect$() {
  if ((!$n_Lorg_scalajs_dom_RequestRedirect$package$RequestRedirect$)) {
    $n_Lorg_scalajs_dom_RequestRedirect$package$RequestRedirect$ = new $c_Lorg_scalajs_dom_RequestRedirect$package$RequestRedirect$();
  }
  return $n_Lorg_scalajs_dom_RequestRedirect$package$RequestRedirect$;
}
export { $m_Lorg_scalajs_dom_RequestRedirect$package$RequestRedirect$ as $m_Lorg_scalajs_dom_RequestRedirect$package$RequestRedirect$ };
/** @constructor */
function $c_Lorg_scalajs_dom_ResponseType$package$ResponseType$() {
  this.Lorg_scalajs_dom_ResponseType$package$ResponseType$__f_opaqueredirect = null;
  this.Lorg_scalajs_dom_ResponseType$package$ResponseType$__f_opaqueredirect = "opaqueredirect";
}
export { $c_Lorg_scalajs_dom_ResponseType$package$ResponseType$ as $c_Lorg_scalajs_dom_ResponseType$package$ResponseType$ };
$c_Lorg_scalajs_dom_ResponseType$package$ResponseType$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lorg_scalajs_dom_ResponseType$package$ResponseType$.prototype.constructor = $c_Lorg_scalajs_dom_ResponseType$package$ResponseType$;
/** @constructor */
function $h_Lorg_scalajs_dom_ResponseType$package$ResponseType$() {
}
export { $h_Lorg_scalajs_dom_ResponseType$package$ResponseType$ as $h_Lorg_scalajs_dom_ResponseType$package$ResponseType$ };
$h_Lorg_scalajs_dom_ResponseType$package$ResponseType$.prototype = $c_Lorg_scalajs_dom_ResponseType$package$ResponseType$.prototype;
var $d_Lorg_scalajs_dom_ResponseType$package$ResponseType$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lorg_scalajs_dom_ResponseType$package$ResponseType$, "org.scalajs.dom.ResponseType$package$ResponseType$", ({
  Lorg_scalajs_dom_ResponseType$package$ResponseType$: 1
}));
export { $d_Lorg_scalajs_dom_ResponseType$package$ResponseType$ as $d_Lorg_scalajs_dom_ResponseType$package$ResponseType$ };
var $n_Lorg_scalajs_dom_ResponseType$package$ResponseType$;
function $m_Lorg_scalajs_dom_ResponseType$package$ResponseType$() {
  if ((!$n_Lorg_scalajs_dom_ResponseType$package$ResponseType$)) {
    $n_Lorg_scalajs_dom_ResponseType$package$ResponseType$ = new $c_Lorg_scalajs_dom_ResponseType$package$ResponseType$();
  }
  return $n_Lorg_scalajs_dom_ResponseType$package$ResponseType$;
}
export { $m_Lorg_scalajs_dom_ResponseType$package$ResponseType$ as $m_Lorg_scalajs_dom_ResponseType$package$ResponseType$ };
/** @constructor */
function $c_Lorg_scalajs_dom_experimental_package$() {
  this.Lorg_scalajs_dom_experimental_package$__f_RequestRedirect$lzy1 = null;
  this.Lorg_scalajs_dom_experimental_package$__f_RequestRedirectbitmap$1 = false;
  this.Lorg_scalajs_dom_experimental_package$__f_ResponseType$lzy1 = null;
  this.Lorg_scalajs_dom_experimental_package$__f_ResponseTypebitmap$1 = false;
}
export { $c_Lorg_scalajs_dom_experimental_package$ as $c_Lorg_scalajs_dom_experimental_package$ };
$c_Lorg_scalajs_dom_experimental_package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lorg_scalajs_dom_experimental_package$.prototype.constructor = $c_Lorg_scalajs_dom_experimental_package$;
/** @constructor */
function $h_Lorg_scalajs_dom_experimental_package$() {
}
export { $h_Lorg_scalajs_dom_experimental_package$ as $h_Lorg_scalajs_dom_experimental_package$ };
$h_Lorg_scalajs_dom_experimental_package$.prototype = $c_Lorg_scalajs_dom_experimental_package$.prototype;
$c_Lorg_scalajs_dom_experimental_package$.prototype.RequestRedirect__Lorg_scalajs_dom_RequestRedirect$package$RequestRedirect$ = (function() {
  if ((!this.Lorg_scalajs_dom_experimental_package$__f_RequestRedirectbitmap$1)) {
    this.Lorg_scalajs_dom_experimental_package$__f_RequestRedirect$lzy1 = $m_Lorg_scalajs_dom_RequestRedirect$package$RequestRedirect$();
    this.Lorg_scalajs_dom_experimental_package$__f_RequestRedirectbitmap$1 = true;
  }
  return this.Lorg_scalajs_dom_experimental_package$__f_RequestRedirect$lzy1;
});
$c_Lorg_scalajs_dom_experimental_package$.prototype.ResponseType__Lorg_scalajs_dom_ResponseType$package$ResponseType$ = (function() {
  if ((!this.Lorg_scalajs_dom_experimental_package$__f_ResponseTypebitmap$1)) {
    this.Lorg_scalajs_dom_experimental_package$__f_ResponseType$lzy1 = $m_Lorg_scalajs_dom_ResponseType$package$ResponseType$();
    this.Lorg_scalajs_dom_experimental_package$__f_ResponseTypebitmap$1 = true;
  }
  return this.Lorg_scalajs_dom_experimental_package$__f_ResponseType$lzy1;
});
var $d_Lorg_scalajs_dom_experimental_package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lorg_scalajs_dom_experimental_package$, "org.scalajs.dom.experimental.package$", ({
  Lorg_scalajs_dom_experimental_package$: 1
}));
export { $d_Lorg_scalajs_dom_experimental_package$ as $d_Lorg_scalajs_dom_experimental_package$ };
var $n_Lorg_scalajs_dom_experimental_package$;
function $m_Lorg_scalajs_dom_experimental_package$() {
  if ((!$n_Lorg_scalajs_dom_experimental_package$)) {
    $n_Lorg_scalajs_dom_experimental_package$ = new $c_Lorg_scalajs_dom_experimental_package$();
  }
  return $n_Lorg_scalajs_dom_experimental_package$;
}
export { $m_Lorg_scalajs_dom_experimental_package$ as $m_Lorg_scalajs_dom_experimental_package$ };
function $p_Lpprint_ProductSupport$__isIdentifier__T__Z($thiz, name) {
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Predef$().wrapString__T__sci_WrappedString(name);
  var x1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$1);
  if ((x1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon)) {
    var x4 = x1.sci_$colon$colon__f_next;
    var first = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uC(x1.sci_$colon$colon__f_head);
    if ($p_Lpprint_ProductSupport$__isStart$1__C__Z($thiz, first)) {
      var these = x4;
      while ((!these.isEmpty__Z())) {
        var x0 = these.head__O();
        var c = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uC(x0);
        if ((!$p_Lpprint_ProductSupport$__isPart$1__C__Z($thiz, c))) {
          return false;
        }
        these = these.tail__O();
      }
      return true;
    }
  }
  return false;
}
export { $p_Lpprint_ProductSupport$__isIdentifier__T__Z as $p_Lpprint_ProductSupport$__isIdentifier__T__Z };
function $p_Lpprint_ProductSupport$__isStart$1__C__Z($thiz, c) {
  if (((c === 95) || (c === 36))) {
    return true;
  } else {
    var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$();
    return this$1.isUnicodeIdentifierStart__I__Z(c);
  }
}
export { $p_Lpprint_ProductSupport$__isStart$1__C__Z as $p_Lpprint_ProductSupport$__isStart$1__C__Z };
function $p_Lpprint_ProductSupport$__isPart$1__C__Z($thiz, c) {
  if ((c === 36)) {
    return true;
  } else {
    var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$();
    return this$1.isUnicodeIdentifierPart__I__Z(c);
  }
}
export { $p_Lpprint_ProductSupport$__isPart$1__C__Z as $p_Lpprint_ProductSupport$__isPart$1__C__Z };
/** @constructor */
function $c_Lpprint_ProductSupport$() {
}
export { $c_Lpprint_ProductSupport$ as $c_Lpprint_ProductSupport$ };
$c_Lpprint_ProductSupport$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lpprint_ProductSupport$.prototype.constructor = $c_Lpprint_ProductSupport$;
/** @constructor */
function $h_Lpprint_ProductSupport$() {
}
export { $h_Lpprint_ProductSupport$ as $h_Lpprint_ProductSupport$ };
$h_Lpprint_ProductSupport$.prototype = $c_Lpprint_ProductSupport$.prototype;
$c_Lpprint_ProductSupport$.prototype.treeifyProductElements__s_Product__Lpprint_Walker__Z__Z__sc_Iterator = (function(x, walker, escapeUnicode, showFieldNames) {
  if (((!showFieldNames) || (x.productArity__I() < 2))) {
    var this$1 = x.productIterator__sc_Iterator();
    var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$2) => walker.treeify__O__Z__Z__Lpprint_Tree(x$2, escapeUnicode, showFieldNames)));
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(this$1, f);
  } else {
    var this$2 = new $c_s_Product$$anon$2(x);
    var this$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$16(this$2);
    var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
      if ((x$1 !== null)) {
        var name = x$1._1__O();
        var i = (x$1._2__O() | 0);
        var key = ((!$p_Lpprint_ProductSupport$__isIdentifier__T__Z($m_Lpprint_ProductSupport$(), name)) ? (("`" + name) + "`") : name);
        var elem = x.productElement__I__O(i);
        var value = walker.treeify__O__Z__Z__Lpprint_Tree(elem, escapeUnicode, showFieldNames);
        return new $c_Lpprint_Tree$KeyValue(key, value);
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    }));
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(this$4, f$1);
  }
});
var $d_Lpprint_ProductSupport$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lpprint_ProductSupport$, "pprint.ProductSupport$", ({
  Lpprint_ProductSupport$: 1
}));
export { $d_Lpprint_ProductSupport$ as $d_Lpprint_ProductSupport$ };
var $n_Lpprint_ProductSupport$;
function $m_Lpprint_ProductSupport$() {
  if ((!$n_Lpprint_ProductSupport$)) {
    $n_Lpprint_ProductSupport$ = new $c_Lpprint_ProductSupport$();
  }
  return $n_Lpprint_ProductSupport$;
}
export { $m_Lpprint_ProductSupport$ as $m_Lpprint_ProductSupport$ };
function $p_Lpprint_Renderer__applyHeader$1__T__sc_Iterator($thiz, prefix$1) {
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
  var this$2 = $thiz.Lpprint_Renderer__f_colorApplyPrefix;
  var this$1 = $m_Lfansi_Str$();
  var s = this$1.apply__jl_CharSequence__Lfansi_ErrorMode__Lfansi_Str(prefix$1, $m_Lfansi_ErrorMode$Sanitize$());
  var xs = $x_1.wrapRefArray__AO__sci_ArraySeq(new ($d_Lfansi_Str.getArrayOf().constr)([s.overlay__Lfansi_Attrs__I__I__Lfansi_Str(this$2, 0, s.Lfansi_Str__f_chars.u.length), $m_Lpprint_Renderer$().Lpprint_Renderer$__f_openParen]));
  return xs.iterator__sc_Iterator();
}
export { $p_Lpprint_Renderer__applyHeader$1__T__sc_Iterator as $p_Lpprint_Renderer__applyHeader$1__T__sc_Iterator };
function $ps_Lpprint_Renderer__separator$1__Lfansi_Str__sc_Iterator(indentPlusOne$1) {
  var xs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lfansi_Str.getArrayOf().constr)([$m_Lpprint_Renderer$().Lpprint_Renderer$__f_commaNewLine, indentPlusOne$1]));
  return xs.iterator__sc_Iterator();
}
export { $ps_Lpprint_Renderer__separator$1__Lfansi_Str__sc_Iterator as $ps_Lpprint_Renderer__separator$1__Lfansi_Str__sc_Iterator };
function $ps_Lpprint_Renderer__bufferedFragments$1__scm_Buffer__sr_ObjectRef__Lfansi_Str__Lpprint_Util$ConcatIterator(buffer$2, lastChildIter$1, indentPlusOne$2) {
  $m_Lpprint_Renderer$();
  var this$1 = buffer$2.iterator__sc_Iterator();
  var this$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$16(this$1);
  var p = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => ((x$1 !== null) && (x$1._1__O(), (x$1._2__O() | 0), true))));
  var this$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$6(this$2, p, false);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1$2) => {
    if ((x$1$2 !== null)) {
      var v$1 = x$1$2._1__O();
      var i$1 = (x$1$2._2__O() | 0);
      if ((i$1 < (((-1) + buffer$2.length__I()) | 0))) {
        return v$1.iterator__sc_Iterator();
      } else {
        var this$3 = v$1.iterator__sc_Iterator();
        var xs = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => lastChildIter$1.sr_ObjectRef__f_elem));
        return this$3.concat__F0__sc_Iterator(xs);
      }
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1$2);
  }));
  var it0 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(this$4, f);
  var joiner = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $ps_Lpprint_Renderer__separator$1__Lfansi_Str__sc_Iterator(indentPlusOne$2)));
  return new $c_Lpprint_Util$ConcatIterator(it0, joiner);
}
export { $ps_Lpprint_Renderer__bufferedFragments$1__scm_Buffer__sr_ObjectRef__Lfansi_Str__Lpprint_Util$ConcatIterator as $ps_Lpprint_Renderer__bufferedFragments$1__scm_Buffer__sr_ObjectRef__Lfansi_Str__Lpprint_Util$ConcatIterator };
function $p_Lpprint_Renderer__nonBufferedFragments$1__sc_Iterator__I__Lfansi_Str__Lpprint_Util$ConcatIterator($thiz, body$1, indentCount$2, indentPlusOne$3) {
  $m_Lpprint_Renderer$();
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((c) => $thiz.rec__Lpprint_Tree__I__I__Lpprint_Result(c, Math.imul(((1 + indentCount$2) | 0), $thiz.Lpprint_Renderer__f_indentStep), ((1 + indentCount$2) | 0)).Lpprint_Result__f_iter));
  var it0 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(body$1, f);
  var joiner = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $ps_Lpprint_Renderer__separator$1__Lfansi_Str__sc_Iterator(indentPlusOne$3)));
  return new $c_Lpprint_Util$ConcatIterator(it0, joiner);
}
export { $p_Lpprint_Renderer__nonBufferedFragments$1__sc_Iterator__I__Lfansi_Str__Lpprint_Util$ConcatIterator as $p_Lpprint_Renderer__nonBufferedFragments$1__sc_Iterator__I__Lfansi_Str__Lpprint_Util$ConcatIterator };
function $p_Lpprint_Renderer__allFragments$1__scm_Buffer__sc_Iterator__I__Lfansi_Str__sr_ObjectRef__Lpprint_Util$ConcatIterator($thiz, buffer$4, body$2, indentCount$4, indentPlusOne$4, lastChildIter$4) {
  if (buffer$4.isEmpty__Z()) {
    return $p_Lpprint_Renderer__nonBufferedFragments$1__sc_Iterator__I__Lfansi_Str__Lpprint_Util$ConcatIterator($thiz, body$2, indentCount$4, indentPlusOne$4);
  } else if ((!body$2.hasNext__Z())) {
    return $ps_Lpprint_Renderer__bufferedFragments$1__scm_Buffer__sr_ObjectRef__Lfansi_Str__Lpprint_Util$ConcatIterator(buffer$4, lastChildIter$4, indentPlusOne$4);
  } else {
    $m_Lpprint_Renderer$();
    var xs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lpprint_Util$ConcatIterator.getArrayOf().constr)([$ps_Lpprint_Renderer__bufferedFragments$1__scm_Buffer__sr_ObjectRef__Lfansi_Str__Lpprint_Util$ConcatIterator(buffer$4, lastChildIter$4, indentPlusOne$4), $p_Lpprint_Renderer__nonBufferedFragments$1__sc_Iterator__I__Lfansi_Str__Lpprint_Util$ConcatIterator($thiz, body$2, indentCount$4, indentPlusOne$4)]));
    var it0 = xs.iterator__sc_Iterator();
    var joiner = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $ps_Lpprint_Renderer__separator$1__Lfansi_Str__sc_Iterator(indentPlusOne$4)));
    return new $c_Lpprint_Util$ConcatIterator(it0, joiner);
  }
}
export { $p_Lpprint_Renderer__allFragments$1__scm_Buffer__sc_Iterator__I__Lfansi_Str__sr_ObjectRef__Lpprint_Util$ConcatIterator as $p_Lpprint_Renderer__allFragments$1__scm_Buffer__sc_Iterator__I__Lfansi_Str__sr_ObjectRef__Lpprint_Util$ConcatIterator };
function $p_Lpprint_Renderer__iter$1__Lfansi_Str__I__T__scm_Buffer__sc_Iterator__sr_ObjectRef__Lpprint_Util$ConcatIterator($thiz, indentPlusOne$5, indentCount$5, prefix$2, buffer$5, body$3, lastChildIter$5) {
  return $m_Lpprint_Util$().concat__sci_Seq__Lpprint_Util$ConcatIterator($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_F0.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $p_Lpprint_Renderer__applyHeader$1__T__sc_Iterator($thiz, prefix$2))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    var xs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lfansi_Str.getArrayOf().constr)([$m_Lpprint_Renderer$().Lpprint_Renderer$__f_newLine, indentPlusOne$5]));
    return xs.iterator__sc_Iterator();
  })), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $p_Lpprint_Renderer__allFragments$1__scm_Buffer__sc_Iterator__I__Lfansi_Str__sr_ObjectRef__Lpprint_Util$ConcatIterator($thiz, buffer$5, body$3, indentCount$5, indentPlusOne$5, lastChildIter$5))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    var xs$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lfansi_Str.getArrayOf().constr)([$m_Lpprint_Renderer$().Lpprint_Renderer$__f_newLine, $m_Lpprint_Renderer$().indent__I__Lfansi_Str(Math.imul(indentCount$5, $thiz.Lpprint_Renderer__f_indentStep)), $m_Lpprint_Renderer$().Lpprint_Renderer$__f_closeParen]));
    return xs$1.iterator__sc_Iterator();
  }))])));
}
export { $p_Lpprint_Renderer__iter$1__Lfansi_Str__I__T__scm_Buffer__sc_Iterator__sr_ObjectRef__Lpprint_Util$ConcatIterator as $p_Lpprint_Renderer__iter$1__Lfansi_Str__I__T__scm_Buffer__sc_Iterator__sr_ObjectRef__Lpprint_Util$ConcatIterator };
function $p_Lpprint_Renderer__str$lzyINIT1$1__sr_LazyRef__Lpprint_Tree$Lazy__I__I__sc_Iterator($thiz, str$lzy1$1, t$1, leftOffset$1, indentCount$10) {
  if ((str$lzy1$1 === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  if (str$lzy1$1.sr_LazyRef__f__initialized) {
    var $x_1 = str$lzy1$1.sr_LazyRef__f__value;
  } else {
    var $x_2 = t$1.Lpprint_Tree$Lazy__f_body0;
    var width = $thiz.Lpprint_Renderer__f_maxWidth;
    var indentStep = $thiz.Lpprint_Renderer__f_indentStep;
    var literalColor = $thiz.Lpprint_Renderer__f_colorLiteral;
    var applyPrefixColor = $thiz.Lpprint_Renderer__f_colorApplyPrefix;
    var $x_1 = str$lzy1$1.initialize__O__O($x_2.apply__O__O(new $c_Lpprint_Tree$Ctx(width, leftOffset$1, indentCount$10, indentStep, literalColor, applyPrefixColor)));
  }
  return $x_1;
}
export { $p_Lpprint_Renderer__str$lzyINIT1$1__sr_LazyRef__Lpprint_Tree$Lazy__I__I__sc_Iterator as $p_Lpprint_Renderer__str$lzyINIT1$1__sr_LazyRef__Lpprint_Tree$Lazy__I__I__sc_Iterator };
function $p_Lpprint_Renderer__str$1__sr_LazyRef__Lpprint_Tree$Lazy__I__I__sc_Iterator($thiz, str$lzy1$2, t$2, leftOffset$2, indentCount$11) {
  return (str$lzy1$2.sr_LazyRef__f__initialized ? str$lzy1$2.sr_LazyRef__f__value : $p_Lpprint_Renderer__str$lzyINIT1$1__sr_LazyRef__Lpprint_Tree$Lazy__I__I__sc_Iterator($thiz, str$lzy1$2, t$2, leftOffset$2, indentCount$11));
}
export { $p_Lpprint_Renderer__str$1__sr_LazyRef__Lpprint_Tree$Lazy__I__I__sc_Iterator as $p_Lpprint_Renderer__str$1__sr_LazyRef__Lpprint_Tree$Lazy__I__I__sc_Iterator };
/** @constructor */
function $c_Lpprint_Renderer(maxWidth, colorApplyPrefix, colorLiteral, indentStep) {
  this.Lpprint_Renderer__f_maxWidth = 0;
  this.Lpprint_Renderer__f_colorApplyPrefix = null;
  this.Lpprint_Renderer__f_colorLiteral = null;
  this.Lpprint_Renderer__f_indentStep = 0;
  this.Lpprint_Renderer__f_maxWidth = maxWidth;
  this.Lpprint_Renderer__f_colorApplyPrefix = colorApplyPrefix;
  this.Lpprint_Renderer__f_colorLiteral = colorLiteral;
  this.Lpprint_Renderer__f_indentStep = indentStep;
}
export { $c_Lpprint_Renderer as $c_Lpprint_Renderer };
$c_Lpprint_Renderer.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lpprint_Renderer.prototype.constructor = $c_Lpprint_Renderer;
/** @constructor */
function $h_Lpprint_Renderer() {
}
export { $h_Lpprint_Renderer as $h_Lpprint_Renderer };
$h_Lpprint_Renderer.prototype = $c_Lpprint_Renderer.prototype;
$c_Lpprint_Renderer.prototype.rec__Lpprint_Tree__I__I__Lpprint_Result = (function(x, leftOffset, indentCount) {
  if ((x instanceof $c_Lpprint_Tree$Apply)) {
    var x21 = x.Lpprint_Tree$Apply__f_prefix;
    var x22 = x.Lpprint_Tree$Apply__f_body;
    var nonEmpty = x22.hasNext__Z();
    var totalHorizontalWidth = ((2 + ((leftOffset + x21.length) | 0)) | 0);
    var buffer = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_scm_Buffer$().empty__sc_SeqOps();
    var xs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lfansi_Str.getArrayOf().constr)([]));
    var elem = xs.iterator__sc_Iterator();
    var lastChildIter = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_ObjectRef(elem);
    var childCompletedLineCount = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_IntRef(0);
    while (((x22.hasNext__Z() && (totalHorizontalWidth <= this.Lpprint_Renderer__f_maxWidth)) && (childCompletedLineCount.sr_IntRef__f_elem === 0))) {
      var child = x22.next__O();
      var childRes = this.rec__Lpprint_Tree__I__I__Lpprint_Result(child, Math.imul(((1 + indentCount) | 0), this.Lpprint_Renderer__f_indentStep), ((1 + indentCount) | 0));
      var childBuffer = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_scm_Buffer$().empty__sc_SeqOps();
      while ((childRes.Lpprint_Result__f_iter.hasNext__Z() && (totalHorizontalWidth < this.Lpprint_Renderer__f_maxWidth))) {
        var next = childRes.Lpprint_Result__f_iter.next__O();
        childBuffer.addOne__O__scm_Growable(next);
        totalHorizontalWidth = ((totalHorizontalWidth + next.Lfansi_Str__f_chars.u.length) | 0);
      }
      if (x22.hasNext__Z()) {
        totalHorizontalWidth = ((2 + totalHorizontalWidth) | 0);
      }
      if ((!childRes.Lpprint_Result__f_iter.hasNext__Z())) {
        childCompletedLineCount.sr_IntRef__f_elem = ((childCompletedLineCount.sr_IntRef__f_elem + childRes.completedLineCount__I()) | 0);
      } else {
        lastChildIter.sr_ObjectRef__f_elem = childRes.Lpprint_Result__f_iter;
      }
      var elem$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Seq$().from__sc_IterableOnce__sci_Seq(childBuffer);
      buffer.addOne__O__scm_Growable(elem$1);
    }
    var indentPlusOne = $m_Lpprint_Renderer$().indent__I__Lfansi_Str(Math.imul(((1 + indentCount) | 0), this.Lpprint_Renderer__f_indentStep));
    if ((((totalHorizontalWidth <= this.Lpprint_Renderer__f_maxWidth) && (childCompletedLineCount.sr_IntRef__f_elem === 0)) && (!lastChildIter.sr_ObjectRef__f_elem.hasNext__Z()))) {
      var iter = $m_Lpprint_Util$().concat__sci_Seq__Lpprint_Util$ConcatIterator($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_F0.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $p_Lpprint_Renderer__applyHeader$1__T__sc_Iterator(this, x21))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
        $m_Lpprint_Renderer$();
        var this$6 = buffer.iterator__sc_Iterator();
        var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => _$1.iterator__sc_Iterator()));
        var it0 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(this$6, f);
        var joiner = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
          var xs$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lfansi_Str.getArrayOf().constr)([$m_Lpprint_Renderer$().Lpprint_Renderer$__f_commaSpace]));
          return xs$1.iterator__sc_Iterator();
        }));
        return new $c_Lpprint_Util$ConcatIterator(it0, joiner);
      })), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
        var xs$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lfansi_Str.getArrayOf().constr)([$m_Lpprint_Renderer$().Lpprint_Renderer$__f_closeParen]));
        return xs$2.iterator__sc_Iterator();
      }))])));
      var this$12 = buffer.iterator__sc_Iterator();
      var f$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => {
        var this$10 = _$2.iterator__sc_Iterator();
        var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$3) => _$3.Lfansi_Str__f_chars.u.length));
        var this$11 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(this$10, f$1);
        var num = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_math_Numeric$IntIsIntegral$();
        return ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__sum__s_math_Numeric__O(this$11, num) | 0);
      }));
      var this$13 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(this$12, f$2);
      var num$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_math_Numeric$IntIsIntegral$();
      var length = ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__sum__s_math_Numeric__O(this$13, num$1) | 0);
      return new $c_Lpprint_Result(iter, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => 0)), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => length)));
    } else if (((!nonEmpty) && (totalHorizontalWidth > this.Lpprint_Renderer__f_maxWidth))) {
      var iter$2 = $m_Lpprint_Util$().concat__sci_Seq__Lpprint_Util$ConcatIterator($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_F0.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $p_Lpprint_Renderer__applyHeader$1__T__sc_Iterator(this, x21))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
        var xs$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lfansi_Str.getArrayOf().constr)([$m_Lpprint_Renderer$().Lpprint_Renderer$__f_newLine, $m_Lpprint_Renderer$().indent__I__Lfansi_Str(Math.imul(indentCount, this.Lpprint_Renderer__f_indentStep)), $m_Lpprint_Renderer$().Lpprint_Renderer$__f_closeParen]));
        return xs$3.iterator__sc_Iterator();
      }))])));
      var this$17 = buffer.iterator__sc_Iterator();
      var f$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$4) => {
        var this$15 = _$4.iterator__sc_Iterator();
        var f$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$5) => _$5.Lfansi_Str__f_chars.u.length));
        var this$16 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(this$15, f$3);
        var num$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_math_Numeric$IntIsIntegral$();
        return ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__sum__s_math_Numeric__O(this$16, num$2) | 0);
      }));
      var this$18 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(this$17, f$4);
      var num$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_math_Numeric$IntIsIntegral$();
      var length$3 = ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__sum__s_math_Numeric__O(this$18, num$3) | 0);
      return new $c_Lpprint_Result(iter$2, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => 0)), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => length$3)));
    } else {
      return new $c_Lpprint_Result($p_Lpprint_Renderer__iter$1__Lfansi_Str__I__T__scm_Buffer__sc_Iterator__sr_ObjectRef__Lpprint_Util$ConcatIterator(this, indentPlusOne, indentCount, x21, buffer, x22, lastChildIter), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => ((2 + childCompletedLineCount.sr_IntRef__f_elem) | 0))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => ((1 + Math.imul(indentCount, this.Lpprint_Renderer__f_indentStep)) | 0))));
    }
  }
  if ((x instanceof $c_Lpprint_Tree$Infix)) {
    var x16 = x.Lpprint_Tree$Infix__f_lhs;
    var x17 = x.Lpprint_Tree$Infix__f_op;
    var x18 = x.Lpprint_Tree$Infix__f_rhs;
    return this.rec__Lpprint_Tree__I__I__Lpprint_Result(x16, leftOffset, indentCount).flatMap__F2__Lpprint_Result(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((lhsNewline, lhsLastLineLength) => {
      var lhsLastLineLength$1 = (lhsLastLineLength | 0);
      return $m_Lpprint_Result$().fromString__F0__Lpprint_Result(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
        var this$20 = $m_Lfansi_Str$();
        var raw = ((" " + x17) + " ");
        return this$20.apply__jl_CharSequence__Lfansi_ErrorMode__Lfansi_Str(raw, $m_Lfansi_ErrorMode$Sanitize$());
      }))).flatMap__F2__Lpprint_Result(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((_$6, _$7) => this.rec__Lpprint_Tree__I__I__Lpprint_Result(x18, lhsLastLineLength$1, indentCount))));
    })));
  }
  if ((x instanceof $c_Lpprint_Tree$Lazy)) {
    var str$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_LazyRef();
    var this$22 = $p_Lpprint_Renderer__str$1__sr_LazyRef__Lpprint_Tree$Lazy__I__I__sc_Iterator(this, str$lzy1, x, leftOffset, indentCount);
    var f$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$8) => $m_Lfansi_Str$().apply__jl_CharSequence__Lfansi_ErrorMode__Lfansi_Str(_$8, ($m_Lfansi_Str$(), $m_Lfansi_ErrorMode$Sanitize$()))));
    return new $c_Lpprint_Truncated(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(this$22, f$5), this.Lpprint_Renderer__f_maxWidth, 99999999, "...").toResult__Lpprint_Result();
  }
  if ((x instanceof $c_Lpprint_Tree$Literal)) {
    return $m_Lpprint_Result$().fromString__F0__Lpprint_Result(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((t$3) => (() => {
      var this$24 = this.Lpprint_Renderer__f_colorLiteral;
      var this$23 = $m_Lfansi_Str$();
      var raw$1 = t$3.Lpprint_Tree$Literal__f_body;
      var s = this$23.apply__jl_CharSequence__Lfansi_ErrorMode__Lfansi_Str(raw$1, $m_Lfansi_ErrorMode$Sanitize$());
      return s.overlay__Lfansi_Attrs__I__I__Lfansi_Str(this$24, 0, s.Lfansi_Str__f_chars.u.length);
    }))(x)));
  }
  if ((x instanceof $c_Lpprint_Tree$KeyValue)) {
    var x10 = x.Lpprint_Tree$KeyValue__f_key;
    var x11 = x.Lpprint_Tree$KeyValue__f_value;
    var prefix$4 = (x10 + " = ");
    return $m_Lpprint_Result$().fromString__F0__Lpprint_Result(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
      var this$26 = $m_Lfansi_Str$();
      return this$26.apply__jl_CharSequence__Lfansi_ErrorMode__Lfansi_Str(prefix$4, $m_Lfansi_ErrorMode$Sanitize$());
    }))).flatMap__F2__Lpprint_Result(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((_$9, _$10) => this.rec__Lpprint_Tree__I__I__Lpprint_Result(x11, ((leftOffset + prefix$4.length) | 0), indentCount))));
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x);
});
var $d_Lpprint_Renderer = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lpprint_Renderer, "pprint.Renderer", ({
  Lpprint_Renderer: 1
}));
export { $d_Lpprint_Renderer as $d_Lpprint_Renderer };
/** @constructor */
function $c_Lpprint_Renderer$() {
  this.Lpprint_Renderer$__f_openParen = null;
  this.Lpprint_Renderer$__f_closeParen = null;
  this.Lpprint_Renderer$__f_commaSpace = null;
  this.Lpprint_Renderer$__f_newLine = null;
  this.Lpprint_Renderer$__f_commaNewLine = null;
  this.Lpprint_Renderer$__f_cachedIndents = null;
  $n_Lpprint_Renderer$ = this;
  this.Lpprint_Renderer$__f_openParen = $m_Lfansi_Str$().apply__jl_CharSequence__Lfansi_ErrorMode__Lfansi_Str("(", ($m_Lfansi_Str$(), $m_Lfansi_ErrorMode$Sanitize$()));
  this.Lpprint_Renderer$__f_closeParen = $m_Lfansi_Str$().apply__jl_CharSequence__Lfansi_ErrorMode__Lfansi_Str(")", ($m_Lfansi_Str$(), $m_Lfansi_ErrorMode$Sanitize$()));
  this.Lpprint_Renderer$__f_commaSpace = $m_Lfansi_Str$().apply__jl_CharSequence__Lfansi_ErrorMode__Lfansi_Str(", ", ($m_Lfansi_Str$(), $m_Lfansi_ErrorMode$Sanitize$()));
  this.Lpprint_Renderer$__f_newLine = $m_Lfansi_Str$().apply__jl_CharSequence__Lfansi_ErrorMode__Lfansi_Str("\n", ($m_Lfansi_Str$(), $m_Lfansi_ErrorMode$Sanitize$()));
  this.Lpprint_Renderer$__f_commaNewLine = $m_Lfansi_Str$().apply__jl_CharSequence__Lfansi_ErrorMode__Lfansi_Str(",\n", ($m_Lfansi_Str$(), $m_Lfansi_ErrorMode$Sanitize$()));
  var array = new ($d_Lfansi_Str.getArrayOf().constr)(64);
  var i = 0;
  while ((i < 64)) {
    var $x_1 = i;
    var x0 = i;
    array.u[$x_1] = $m_Lfansi_Str$().apply__jl_CharSequence__Lfansi_ErrorMode__Lfansi_Str($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_StringOps$().$times$extension__T__I__T(" ", x0), ($m_Lfansi_Str$(), $m_Lfansi_ErrorMode$Sanitize$()));
    i = ((1 + i) | 0);
  }
  this.Lpprint_Renderer$__f_cachedIndents = array;
}
export { $c_Lpprint_Renderer$ as $c_Lpprint_Renderer$ };
$c_Lpprint_Renderer$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lpprint_Renderer$.prototype.constructor = $c_Lpprint_Renderer$;
/** @constructor */
function $h_Lpprint_Renderer$() {
}
export { $h_Lpprint_Renderer$ as $h_Lpprint_Renderer$ };
$h_Lpprint_Renderer$.prototype = $c_Lpprint_Renderer$.prototype;
$c_Lpprint_Renderer$.prototype.indent__I__Lfansi_Str = (function(n) {
  return ((n < 64) ? this.Lpprint_Renderer$__f_cachedIndents.u[n] : $m_Lfansi_Str$().apply__jl_CharSequence__Lfansi_ErrorMode__Lfansi_Str($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_StringOps$().$times$extension__T__I__T(" ", n), ($m_Lfansi_Str$(), $m_Lfansi_ErrorMode$Sanitize$())));
});
var $d_Lpprint_Renderer$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lpprint_Renderer$, "pprint.Renderer$", ({
  Lpprint_Renderer$: 1
}));
export { $d_Lpprint_Renderer$ as $d_Lpprint_Renderer$ };
var $n_Lpprint_Renderer$;
function $m_Lpprint_Renderer$() {
  if ((!$n_Lpprint_Renderer$)) {
    $n_Lpprint_Renderer$ = new $c_Lpprint_Renderer$();
  }
  return $n_Lpprint_Renderer$;
}
export { $m_Lpprint_Renderer$ as $m_Lpprint_Renderer$ };
/** @constructor */
function $c_Lpprint_Result(iter, completedLineCount0, lastLineLength0) {
  this.Lpprint_Result__f_iter = null;
  this.Lpprint_Result__f_completedLineCount0 = null;
  this.Lpprint_Result__f_lastLineLength0 = null;
  this.Lpprint_Result__f_completedLineCount$lzy1 = 0;
  this.Lpprint_Result__f_completedLineCountbitmap$1 = false;
  this.Lpprint_Result__f_lastLineLength$lzy1 = 0;
  this.Lpprint_Result__f_lastLineLengthbitmap$1 = false;
  this.Lpprint_Result__f_iter = iter;
  this.Lpprint_Result__f_completedLineCount0 = completedLineCount0;
  this.Lpprint_Result__f_lastLineLength0 = lastLineLength0;
}
export { $c_Lpprint_Result as $c_Lpprint_Result };
$c_Lpprint_Result.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lpprint_Result.prototype.constructor = $c_Lpprint_Result;
/** @constructor */
function $h_Lpprint_Result() {
}
export { $h_Lpprint_Result as $h_Lpprint_Result };
$h_Lpprint_Result.prototype = $c_Lpprint_Result.prototype;
$c_Lpprint_Result.prototype.completedLineCount__I = (function() {
  if ((!this.Lpprint_Result__f_completedLineCountbitmap$1)) {
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Predef$();
    var this$1 = this.Lpprint_Result__f_iter;
    $x_1.require__Z__V((!this$1.hasNext__Z()));
    this.Lpprint_Result__f_completedLineCount$lzy1 = (this.Lpprint_Result__f_completedLineCount0.apply__O() | 0);
    this.Lpprint_Result__f_completedLineCountbitmap$1 = true;
    this.Lpprint_Result__f_completedLineCount0 = null;
  }
  return this.Lpprint_Result__f_completedLineCount$lzy1;
});
$c_Lpprint_Result.prototype.lastLineLength__I = (function() {
  if ((!this.Lpprint_Result__f_lastLineLengthbitmap$1)) {
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Predef$();
    var this$1 = this.Lpprint_Result__f_iter;
    $x_1.require__Z__V((!this$1.hasNext__Z()));
    this.Lpprint_Result__f_lastLineLength$lzy1 = (this.Lpprint_Result__f_lastLineLength0.apply__O() | 0);
    this.Lpprint_Result__f_lastLineLengthbitmap$1 = true;
  }
  return this.Lpprint_Result__f_lastLineLength$lzy1;
});
$c_Lpprint_Result.prototype.flatMap__F2__Lpprint_Result = (function(f) {
  var newCompletedLineCount = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_IntRef(0);
  var newLastLineLength = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_IntRef(0);
  var mergedIterator = $m_Lpprint_Util$().concat__sci_Seq__Lpprint_Util$ConcatIterator($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_F0.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => this.Lpprint_Result__f_iter)), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Predef$().require__Z__V((!this.Lpprint_Result__f_iter.hasNext__Z()));
    var newResult = f.apply__O__O__O(this.completedLineCount__I(), this.Lpprint_Result__f_lastLineLength0.apply__O());
    var this$4 = newResult.Lpprint_Result__f_iter;
    var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x) => {
      if ((!newResult.Lpprint_Result__f_iter.hasNext__Z())) {
        newCompletedLineCount.sr_IntRef__f_elem = newResult.completedLineCount__I();
        newLastLineLength.sr_IntRef__f_elem = newResult.lastLineLength__I();
      }
      return x;
    }));
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(this$4, f$1);
  }))])));
  return new $c_Lpprint_Result(mergedIterator, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => ((newCompletedLineCount.sr_IntRef__f_elem + this.completedLineCount__I()) | 0))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => ((newCompletedLineCount.sr_IntRef__f_elem > 0) ? newLastLineLength.sr_IntRef__f_elem : ((newLastLineLength.sr_IntRef__f_elem + this.lastLineLength__I()) | 0)))));
});
var $d_Lpprint_Result = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lpprint_Result, "pprint.Result", ({
  Lpprint_Result: 1
}));
export { $d_Lpprint_Result as $d_Lpprint_Result };
function $p_Lpprint_Result$__lines$lzyINIT1$1__sr_LazyRef__F0__AT($thiz, lines$lzy1$1, s$1) {
  if ((lines$lzy1$1 === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  if (lines$lzy1$1.sr_LazyRef__f__initialized) {
    var $x_1 = lines$lzy1$1.sr_LazyRef__f__value;
  } else {
    var x = s$1.apply__O().plainText__T();
    var this$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_StringOps$$anon$1(x, true);
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    while ((this$5.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index < this$5.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len)) {
      var elem = this$5.next__T();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem);
    }
    var $x_1 = lines$lzy1$1.initialize__O__O(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(jsElems));
  }
  return $x_1;
}
export { $p_Lpprint_Result$__lines$lzyINIT1$1__sr_LazyRef__F0__AT as $p_Lpprint_Result$__lines$lzyINIT1$1__sr_LazyRef__F0__AT };
function $p_Lpprint_Result$__lines$1__sr_LazyRef__F0__AT($thiz, lines$lzy1$2, s$2) {
  return (lines$lzy1$2.sr_LazyRef__f__initialized ? lines$lzy1$2.sr_LazyRef__f__value : $p_Lpprint_Result$__lines$lzyINIT1$1__sr_LazyRef__F0__AT($thiz, lines$lzy1$2, s$2));
}
export { $p_Lpprint_Result$__lines$1__sr_LazyRef__F0__AT as $p_Lpprint_Result$__lines$1__sr_LazyRef__F0__AT };
/** @constructor */
function $c_Lpprint_Result$() {
}
export { $c_Lpprint_Result$ as $c_Lpprint_Result$ };
$c_Lpprint_Result$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lpprint_Result$.prototype.constructor = $c_Lpprint_Result$;
/** @constructor */
function $h_Lpprint_Result$() {
}
export { $h_Lpprint_Result$ as $h_Lpprint_Result$ };
$h_Lpprint_Result$.prototype = $c_Lpprint_Result$.prototype;
$c_Lpprint_Result$.prototype.fromString__F0__Lpprint_Result = (function(s) {
  var lines$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_LazyRef();
  var xs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lfansi_Str.getArrayOf().constr)([s.apply__O()]));
  var $x_2 = xs.iterator__sc_Iterator();
  var lines$lzy1$2$1 = lines$lzy1;
  var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((lines$lzy1$2) => (() => (((-1) + $p_Lpprint_Result$__lines$1__sr_LazyRef__F0__AT(this, lines$lzy1$2, s).u.length) | 0)))(lines$lzy1$2$1));
  var lines$lzy1$3$1 = lines$lzy1;
  return new $c_Lpprint_Result($x_2, $x_1, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((lines$lzy1$3) => (() => {
    var xs$1 = $p_Lpprint_Result$__lines$1__sr_LazyRef__F0__AT(this, lines$lzy1$3, s);
    var this$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_ArrayOps$().last$extension__O__O(xs$1);
    return this$4.length;
  }))(lines$lzy1$3$1)));
});
var $d_Lpprint_Result$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lpprint_Result$, "pprint.Result$", ({
  Lpprint_Result$: 1
}));
export { $d_Lpprint_Result$ as $d_Lpprint_Result$ };
var $n_Lpprint_Result$;
function $m_Lpprint_Result$() {
  if ((!$n_Lpprint_Result$)) {
    $n_Lpprint_Result$ = new $c_Lpprint_Result$();
  }
  return $n_Lpprint_Result$;
}
export { $m_Lpprint_Result$ as $m_Lpprint_Result$ };
/** @constructor */
function $c_Lpprint_Truncated$Internal$(outer) {
  this.Lpprint_Truncated$Internal$__f_chunks = null;
  this.Lpprint_Truncated$Internal$__f_previousSlashN = false;
  this.Lpprint_Truncated$Internal$__f_previousSlashR = false;
  this.Lpprint_Truncated$Internal$__f_lastLineFinished = false;
  this.Lpprint_Truncated$Internal$__f_lastChunkLeftover = null;
  this.Lpprint_Truncated$Internal$__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lpprint_Truncated$Internal$__f_$outer = outer;
  var this$1 = outer.Lpprint_Truncated__f_pprint$Truncated$$chunks0;
  var p = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => (_$1.Lfansi_Str__f_chars.u.length > 0)));
  this.Lpprint_Truncated$Internal$__f_chunks = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$6(this$1, p, false);
  this.Lpprint_Truncated$Internal$__f_previousSlashN = false;
  this.Lpprint_Truncated$Internal$__f_previousSlashR = false;
  this.Lpprint_Truncated$Internal$__f_lastLineFinished = false;
  this.Lpprint_Truncated$Internal$__f_lastChunkLeftover = $m_Lfansi_Str$().apply__jl_CharSequence__Lfansi_ErrorMode__Lfansi_Str("", ($m_Lfansi_Str$(), $m_Lfansi_ErrorMode$Sanitize$()));
}
export { $c_Lpprint_Truncated$Internal$ as $c_Lpprint_Truncated$Internal$ };
$c_Lpprint_Truncated$Internal$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lpprint_Truncated$Internal$.prototype.constructor = $c_Lpprint_Truncated$Internal$;
/** @constructor */
function $h_Lpprint_Truncated$Internal$() {
}
export { $h_Lpprint_Truncated$Internal$ as $h_Lpprint_Truncated$Internal$ };
$h_Lpprint_Truncated$Internal$.prototype = $c_Lpprint_Truncated$Internal$.prototype;
$c_Lpprint_Truncated$Internal$.prototype.handleNormalChar__C__O = (function(char) {
  this.Lpprint_Truncated$Internal$__f_previousSlashN = false;
  this.Lpprint_Truncated$Internal$__f_previousSlashR = false;
  if ((((char === 10) && this.Lpprint_Truncated$Internal$__f_previousSlashR) || ((char === 13) && this.Lpprint_Truncated$Internal$__f_previousSlashN))) {
    return (void 0);
  } else if ((char === 10)) {
    this.Lpprint_Truncated$Internal$__f_previousSlashN = true;
    var this$1 = this.Lpprint_Truncated$Internal$__f_$outer.Lpprint_Truncated__f_lineLengths;
    return this$1.addOne__O__scm_Growable(0);
  } else if ((char === 13)) {
    this.Lpprint_Truncated$Internal$__f_previousSlashR = true;
    var this$2 = this.Lpprint_Truncated$Internal$__f_$outer.Lpprint_Truncated__f_lineLengths;
    return this$2.addOne__O__scm_Growable(0);
  } else if (((this.Lpprint_Truncated$Internal$__f_$outer.Lpprint_Truncated__f_lineLengths.last__O() | 0) === this.Lpprint_Truncated$Internal$__f_$outer.Lpprint_Truncated__f_pprint$Truncated$$width)) {
    var this$3 = this.Lpprint_Truncated$Internal$__f_$outer.Lpprint_Truncated__f_lineLengths;
    return this$3.addOne__O__scm_Growable(1);
  } else {
    var i$1 = (((-1) + this.Lpprint_Truncated$Internal$__f_$outer.Lpprint_Truncated__f_lineLengths.length__I()) | 0);
    this.Lpprint_Truncated$Internal$__f_$outer.Lpprint_Truncated__f_lineLengths.update__I__O__V(i$1, ((1 + (this.Lpprint_Truncated$Internal$__f_$outer.Lpprint_Truncated__f_lineLengths.apply__I__O(i$1) | 0)) | 0));
    return (void 0);
  }
});
$c_Lpprint_Truncated$Internal$.prototype.completedLines__I = (function() {
  return (((-1) + this.Lpprint_Truncated$Internal$__f_$outer.Lpprint_Truncated__f_lineLengths.length__I()) | 0);
});
$c_Lpprint_Truncated$Internal$.prototype.consumeChunkUntilLine__Lfansi_Str__I__s_Option = (function(chunk, lineLimit) {
  var i = 0;
  var this$1 = chunk.Lfansi_Str__f_chars;
  var chars = this$1.clone__O();
  while (((i < chars.u.length) && (this.completedLines__I() < lineLimit))) {
    var char = chars.u[i];
    this.handleNormalChar__C__O(char);
    i = ((1 + i) | 0);
  }
  if ((i === chunk.Lfansi_Str__f_chars.u.length)) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var value = i;
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
  }
});
var $d_Lpprint_Truncated$Internal$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lpprint_Truncated$Internal$, "pprint.Truncated$Internal$", ({
  Lpprint_Truncated$Internal$: 1
}));
export { $d_Lpprint_Truncated$Internal$ as $d_Lpprint_Truncated$Internal$ };
/** @constructor */
function $c_Lpprint_Util$() {
}
export { $c_Lpprint_Util$ as $c_Lpprint_Util$ };
$c_Lpprint_Util$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lpprint_Util$.prototype.constructor = $c_Lpprint_Util$;
/** @constructor */
function $h_Lpprint_Util$() {
}
export { $h_Lpprint_Util$ as $h_Lpprint_Util$ };
$h_Lpprint_Util$.prototype = $c_Lpprint_Util$.prototype;
$c_Lpprint_Util$.prototype.concat__sci_Seq__Lpprint_Util$ConcatIterator = (function(is) {
  var this$1 = is.iterator__sc_Iterator();
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => _$1.apply__O()));
  return new $c_Lpprint_Util$ConcatIterator(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(this$1, f), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty)));
});
$c_Lpprint_Util$.prototype.isOperator__T__Z = (function(ident) {
  if ((ident.length > 0)) {
    var x1 = ident.charCodeAt(0);
    switch (x1) {
      case 60:
      case 126:
      case 33:
      case 64:
      case 35:
      case 37:
      case 94:
      case 42:
      case 43:
      case 45:
      case 62:
      case 63:
      case 58:
      case 61:
      case 38:
      case 124:
      case 47:
      case 92: {
        return true;
        break;
      }
      default: {
        return false;
      }
    }
  } else {
    return false;
  }
});
$c_Lpprint_Util$.prototype.escapeChar__C__scm_StringBuilder__Z__scm_StringBuilder = (function(c, sb, unicode) {
  switch (c) {
    case 34: {
      return sb.append__T__scm_StringBuilder("\\\"");
      break;
    }
    case 92: {
      return sb.append__T__scm_StringBuilder("\\\\");
      break;
    }
    case 8: {
      return sb.append__T__scm_StringBuilder("\\b");
      break;
    }
    case 12: {
      return sb.append__T__scm_StringBuilder("\\f");
      break;
    }
    case 10: {
      return sb.append__T__scm_StringBuilder("\\n");
      break;
    }
    case 13: {
      return sb.append__T__scm_StringBuilder("\\r");
      break;
    }
    case 9: {
      return sb.append__T__scm_StringBuilder("\\t");
      break;
    }
    default: {
      return (((c < 32) || ((c > 126) && unicode)) ? sb.append__T__scm_StringBuilder($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_StringOps$().format$extension__T__sci_Seq__T("\\u%04x", $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([c])))) : sb.append__C__scm_StringBuilder(c));
    }
  }
});
$c_Lpprint_Util$.prototype.literalize__sci_IndexedSeq__Z__T = (function(s, unicode) {
  var sb = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_scm_StringBuilder__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_StringBuilder());
  sb.append__C__scm_StringBuilder(34);
  var i = 0;
  var len = s.length__I();
  while ((i < len)) {
    $m_Lpprint_Util$().escapeChar__C__scm_StringBuilder__Z__scm_StringBuilder($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uC(s.apply__I__O(i)), sb, unicode);
    i = ((1 + i) | 0);
  }
  sb.append__C__scm_StringBuilder(34);
  return sb.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
var $d_Lpprint_Util$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lpprint_Util$, "pprint.Util$", ({
  Lpprint_Util$: 1
}));
export { $d_Lpprint_Util$ as $d_Lpprint_Util$ };
var $n_Lpprint_Util$;
function $m_Lpprint_Util$() {
  if ((!$n_Lpprint_Util$)) {
    $n_Lpprint_Util$ = new $c_Lpprint_Util$();
  }
  return $n_Lpprint_Util$;
}
export { $m_Lpprint_Util$ as $m_Lpprint_Util$ };
function $ct_Lpprint_Walker__($thiz) {
  $thiz.Lpprint_Walker__f_tuplePrefix = "scala.Tuple";
  return $thiz;
}
export { $ct_Lpprint_Walker__ as $ct_Lpprint_Walker__ };
/** @constructor */
function $c_Lpprint_Walker() {
  this.Lpprint_Walker__f_tuplePrefix = null;
}
export { $c_Lpprint_Walker as $c_Lpprint_Walker };
$c_Lpprint_Walker.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lpprint_Walker.prototype.constructor = $c_Lpprint_Walker;
/** @constructor */
function $h_Lpprint_Walker() {
}
export { $h_Lpprint_Walker as $h_Lpprint_Walker };
$h_Lpprint_Walker.prototype = $c_Lpprint_Walker.prototype;
$c_Lpprint_Walker.prototype.treeify__O__Z__Z__Lpprint_Tree = (function(x, escapeUnicode, showFieldNames) {
  var this$1 = this.Lpprint_PPrinter__f_additionalHandlers.lift__F1().apply__O__O(x);
  if (this$1.isEmpty__Z()) {
    if ((x === null)) {
      var $x_2 = new $c_Lpprint_Tree$Literal("null");
    } else if (((typeof x) === "boolean")) {
      var x$1 = (!(!x));
      var body = ("" + x$1);
      var $x_2 = new $c_Lpprint_Tree$Literal(body);
    } else if ((x instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$Char)) {
      var x$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uC(x);
      var sb = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_scm_StringBuilder__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_StringBuilder());
      sb.append__C__scm_StringBuilder(39);
      $m_Lpprint_Util$().escapeChar__C__scm_StringBuilder__Z__scm_StringBuilder(x$2, sb, escapeUnicode);
      sb.append__C__scm_StringBuilder(39);
      var body$1 = sb.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content;
      var $x_2 = new $c_Lpprint_Tree$Literal(body$1);
    } else if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$isByte(x)) {
      var x$3 = (x | 0);
      var body$2 = ("" + x$3);
      var $x_2 = new $c_Lpprint_Tree$Literal(body$2);
    } else if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$isShort(x)) {
      var x$4 = (x | 0);
      var body$3 = ("" + x$4);
      var $x_2 = new $c_Lpprint_Tree$Literal(body$3);
    } else if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$isInt(x)) {
      var x$5 = (x | 0);
      var body$4 = ("" + x$5);
      var $x_2 = new $c_Lpprint_Tree$Literal(body$4);
    } else if ((x instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong)) {
      var t = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(x);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var this$12 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_RTLong$();
      var body$5 = (this$12.org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(lo, hi) + "L");
      var $x_2 = new $c_Lpprint_Tree$Literal(body$5);
    } else if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$isFloat(x)) {
      var x$7 = Math.fround(x);
      var body$6 = (x$7 + "F");
      var $x_2 = new $c_Lpprint_Tree$Literal(body$6);
    } else if (((typeof x) === "number")) {
      var x$8 = (+x);
      var body$7 = ("" + x$8);
      var $x_2 = new $c_Lpprint_Tree$Literal(body$7);
    } else if (((typeof x) === "string")) {
      _return: {
        var len = x.length;
        var i = 0;
        while ((i < len)) {
          var index = i;
          var x0 = x.charCodeAt(index);
          if (((x0 === 10) || (x0 === 13))) {
            var $x_3 = i;
            break _return;
          }
          i = ((1 + i) | 0);
        }
        var $x_3 = (-1);
      }
      if (($x_3 !== (-1))) {
        var body$8 = (("\"\"\"" + x) + "\"\"\"");
        var $x_2 = new $c_Lpprint_Tree$Literal(body$8);
      } else {
        var body$9 = $m_Lpprint_Util$().literalize__sci_IndexedSeq__Z__T($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Predef$().wrapString__T__sci_WrappedString(x), escapeUnicode);
        var $x_2 = new $c_Lpprint_Tree$Literal(body$9);
      }
    } else if (false) {
      var body$10 = ("'" + x.s_Symbol__f_name);
      var $x_2 = new $c_Lpprint_Tree$Literal(body$10);
    } else if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$is_sc_Map(x)) {
      var prefix = ((x instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_HashMap) ? "Map" : x.className__T());
      var this$28 = x.iterator__sc_Iterator();
      var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1$2) => {
        if ((x$1$2 !== null)) {
          var k = x$1$2._1__O();
          var v = x$1$2._2__O();
          var lhs = this.treeify__O__Z__Z__Lpprint_Tree(k, escapeUnicode, showFieldNames);
          var rhs = this.treeify__O__Z__Z__Lpprint_Tree(v, escapeUnicode, showFieldNames);
          return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(new $c_Lpprint_Tree$Infix(lhs, "->", rhs), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1$2);
      }));
      var body$11 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$10(this$28, f);
      var $x_2 = new $c_Lpprint_Tree$Apply(prefix, body$11);
    } else if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$is_sc_Iterable(x)) {
      var prefix$1 = ((x instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_ArraySeq) ? "Seq" : ((x instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_HashSet) ? "Set" : x.className__T()));
      var this$32 = x.iterator__sc_Iterator();
      var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$13) => this.treeify__O__Z__Z__Lpprint_Tree(x$13, escapeUnicode, showFieldNames)));
      var body$12 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(this$32, f$1);
      var $x_2 = new $c_Lpprint_Tree$Apply(prefix$1, body$12);
    } else {
      var x$14 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      if ((x$14 === x)) {
        var $x_2 = new $c_Lpprint_Tree$Literal("None");
      } else if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$is_sc_Iterator(x)) {
        var $x_2 = ((!x.hasNext__Z()) ? new $c_Lpprint_Tree$Literal("empty iterator") : new $c_Lpprint_Tree$Literal("non-empty iterator"));
      } else if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().isArray__O__I__Z(x, 1)) {
        var this$38 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_ArrayOps$().iterator$extension__O__sc_Iterator(x);
        var f$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$17) => this.treeify__O__Z__Z__Lpprint_Tree(x$17, escapeUnicode, showFieldNames)));
        var body$13 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(this$38, f$2);
        var $x_2 = new $c_Lpprint_Tree$Apply("Array", body$13);
      } else if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$is_s_Product(x)) {
        var className = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$objectClassName(x);
        if ((x.productArity__I() === 0)) {
          var body0 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$19) => ((ctx) => {
            var xs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)([x$19.toString__T()]));
            return xs.iterator__sc_Iterator();
          }))(x));
          var $x_2 = new $c_Lpprint_Tree$Lazy(body0);
        } else if (((x.productArity__I() === 2) && $m_Lpprint_Util$().isOperator__T__Z(x.productPrefix__T()))) {
          var lhs$1 = this.treeify__O__Z__Z__Lpprint_Tree(x.productElement__I__O(0), escapeUnicode, showFieldNames);
          var op = x.productPrefix__T();
          var rhs$1 = this.treeify__O__Z__Z__Lpprint_Tree(x.productElement__I__O(1), escapeUnicode, showFieldNames);
          var $x_2 = new $c_Lpprint_Tree$Infix(lhs$1, op, rhs$1);
        } else {
          matchResult23: {
            var $x_2;
            var prefix$2 = this.Lpprint_Walker__f_tuplePrefix;
            var _1 = (!(!className.startsWith(prefix$2)));
            var this$43 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Predef$().wrapString__T__sci_WrappedString(className);
            var this$45 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_PartialFunction$Lifted(this$43);
            var this$44 = this.Lpprint_Walker__f_tuplePrefix;
            var v1 = this$44.length;
            var _2 = this$45.apply__O__s_Option(v1);
            if (((_1 === true) && (_2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some))) {
              var x43 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uC(_2.s_Some__f_value);
              matchAlts1: {
                switch (x43) {
                  case 50: {
                    break;
                  }
                  case 51: {
                    break;
                  }
                  case 52: {
                    break;
                  }
                  case 53: {
                    break;
                  }
                  case 54: {
                    break;
                  }
                  case 55: {
                    break;
                  }
                  case 56: {
                    break;
                  }
                  case 57: {
                    break;
                  }
                  default: {
                    break matchAlts1;
                  }
                }
                var this$47 = x.productIterator__sc_Iterator();
                var f$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$20) => this.treeify__O__Z__Z__Lpprint_Tree(x$20, escapeUnicode, showFieldNames)));
                var body$14 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(this$47, f$3);
                var $x_2 = new $c_Lpprint_Tree$Apply("", body$14);
                break matchResult23;
              }
            }
            var prefix$3 = x.productPrefix__T();
            var body$15 = $m_Lpprint_ProductSupport$().treeifyProductElements__s_Product__Lpprint_Walker__Z__Z__sc_Iterator(x, this, escapeUnicode, showFieldNames);
            var $x_2 = new $c_Lpprint_Tree$Apply(prefix$3, body$15);
          }
        }
      } else {
        var body0$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((ctx$2) => {
          var $x_5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
          matchResult24: {
            var $x_4;
            var x44 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$dp_toString__T(x);
            if ((x44 === null)) {
              var $x_4 = "null";
              break matchResult24;
            }
            var $x_4 = x44;
          }
          var xs$1 = $x_5.wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)([$x_4]));
          return xs$1.iterator__sc_Iterator();
        }));
        var $x_2 = new $c_Lpprint_Tree$Lazy(body0$1);
      }
    }
    var $x_1 = $x_2;
  } else {
    var $x_1 = this$1.get__O();
  }
  return $x_1;
});
function $p_Lretry_RetryPolicies$__safeMultiply__s_concurrent_duration_FiniteDuration__J__s_concurrent_duration_FiniteDuration($thiz, duration, multiplier) {
  var durationNanos = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_package$().BigInt__s_math_BigInt$().apply__J__s_math_BigInt(duration.s_concurrent_duration_FiniteDuration__f_unit.toNanos__J__J(duration.s_concurrent_duration_FiniteDuration__f_length));
  var resultNanos = durationNanos.$times__s_math_BigInt__s_math_BigInt($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_package$().BigInt__s_math_BigInt$().apply__J__s_math_BigInt(multiplier));
  var safeResultNanos = resultNanos.min__s_math_BigInt__s_math_BigInt($thiz.Lretry_RetryPolicies$__f_LongMax);
  var t = safeResultNanos.longValue__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var unit = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_FiniteDuration(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi), unit);
}
export { $p_Lretry_RetryPolicies$__safeMultiply__s_concurrent_duration_FiniteDuration__J__s_concurrent_duration_FiniteDuration as $p_Lretry_RetryPolicies$__safeMultiply__s_concurrent_duration_FiniteDuration__J__s_concurrent_duration_FiniteDuration };
function $p_Lretry_RetryPolicies$__decideNextRetry$1__Lretry_RetryPolicy__Lcats_Applicative__s_concurrent_duration_FiniteDuration__O__Lretry_RetryStatus__O($thiz, policy$1, evidence$1$2, threshold$1, actionResult, status) {
  var target = policy$1.Lretry_RetryPolicy__f_decideNextRetry.apply__O__O__O(actionResult, status);
  var this$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target, evidence$1$2);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 instanceof $c_Lretry_PolicyDecision$DelayAndRetry)) {
      var x4 = x$1.Lretry_PolicyDecision$DelayAndRetry__f_delay;
      return ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_math_Ordered__$greater__O__Z(x4, threshold$1) ? $s_Lretry_PolicyDecision$__GiveUp__Lretry_PolicyDecision() : x$1);
    }
    var x = $s_Lretry_PolicyDecision$__GiveUp__Lretry_PolicyDecision();
    if (((x === null) ? (x$1 === null) : x.equals__O__Z(x$1))) {
      return $s_Lretry_PolicyDecision$__GiveUp__Lretry_PolicyDecision();
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  }));
  return this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.map__O__F1__O(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
}
export { $p_Lretry_RetryPolicies$__decideNextRetry$1__Lretry_RetryPolicy__Lcats_Applicative__s_concurrent_duration_FiniteDuration__O__Lretry_RetryStatus__O as $p_Lretry_RetryPolicies$__decideNextRetry$1__Lretry_RetryPolicy__Lcats_Applicative__s_concurrent_duration_FiniteDuration__O__Lretry_RetryStatus__O };
/** @constructor */
function $c_Lretry_RetryPolicies$() {
  this.Lretry_RetryPolicies$__f_LongMax = null;
  $n_Lretry_RetryPolicies$ = this;
  this.Lretry_RetryPolicies$__f_LongMax = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_package$().BigInt__s_math_BigInt$().apply__J__s_math_BigInt(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong((-1), 2147483647));
}
export { $c_Lretry_RetryPolicies$ as $c_Lretry_RetryPolicies$ };
$c_Lretry_RetryPolicies$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lretry_RetryPolicies$.prototype.constructor = $c_Lretry_RetryPolicies$;
/** @constructor */
function $h_Lretry_RetryPolicies$() {
}
export { $h_Lretry_RetryPolicies$ as $h_Lretry_RetryPolicies$ };
$h_Lretry_RetryPolicies$.prototype = $c_Lretry_RetryPolicies$.prototype;
$c_Lretry_RetryPolicies$.prototype.constantDelay__s_concurrent_duration_FiniteDuration__Lcats_Applicative__Lretry_RetryPolicy = (function(delay, evidence$1) {
  return $m_Lretry_RetryPolicy$().liftWithShow__F2__F0__Lcats_Applicative__Lretry_RetryPolicy(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((_$5, _$6) => new $c_Lretry_PolicyDecision$DelayAndRetry(delay))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
    var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["constantDelay(", ")"]));
    var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
    return $x_1.show$extension__s_StringContext__sci_Seq__T(sc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(delay, $m_Lcats_instances_package$duration$().Lcats_instances_package$duration$__f_catsStdShowForDurationUnambiguous))])));
  })), evidence$1);
});
$c_Lretry_RetryPolicies$.prototype.exponentialBackoff__s_concurrent_duration_FiniteDuration__Lcats_Applicative__Lretry_RetryPolicy = (function(baseDelay, evidence$1) {
  return $m_Lretry_RetryPolicy$().liftWithShow__F2__F0__Lcats_Applicative__Lretry_RetryPolicy(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((_$8, status) => {
    var $x_1 = $m_Lretry_RetryPolicies$();
    var b = status.Lretry_RetryStatus__f_retriesSoFar;
    var value = (+Math.pow(2.0, b));
    var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_RTLong$();
    var lo = this$2.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
    var hi = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var delay = $p_Lretry_RetryPolicies$__safeMultiply__s_concurrent_duration_FiniteDuration__J__s_concurrent_duration_FiniteDuration($x_1, baseDelay, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi));
    return new $c_Lretry_PolicyDecision$DelayAndRetry(delay);
  })), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
    var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["exponentialBackOff(baseDelay=", ")"]));
    var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
    return $x_2.show$extension__s_StringContext__sci_Seq__T(sc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(baseDelay, $m_Lcats_instances_package$duration$().Lcats_instances_package$duration$__f_catsStdShowForDurationUnambiguous))])));
  })), evidence$1);
});
$c_Lretry_RetryPolicies$.prototype.limitRetries__I__Lcats_Applicative__Lretry_RetryPolicy = (function(maxRetries, evidence$1) {
  return $m_Lretry_RetryPolicy$().liftWithShow__F2__F0__Lcats_Applicative__Lretry_RetryPolicy(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((_$10, status) => {
    if ((status.Lretry_RetryStatus__f_retriesSoFar >= maxRetries)) {
      return $s_Lretry_PolicyDecision$__GiveUp__Lretry_PolicyDecision();
    } else {
      var delay = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Zero;
      return new $c_Lretry_PolicyDecision$DelayAndRetry(delay);
    }
  })), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
    var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["limitRetries(maxRetries=", ")"]));
    var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
    return $x_1.show$extension__s_StringContext__sci_Seq__T(sc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(maxRetries, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$int$().Lcats_instances_package$int$__f_catsStdShowForInt))])));
  })), evidence$1);
});
$c_Lretry_RetryPolicies$.prototype.limitRetriesByDelay__s_concurrent_duration_FiniteDuration__Lretry_RetryPolicy__Lcats_Applicative__Lretry_RetryPolicy = (function(threshold, policy, evidence$1) {
  var decideNextRetry = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((actionResult, status) => $p_Lretry_RetryPolicies$__decideNextRetry$1__Lretry_RetryPolicy__Lcats_Applicative__s_concurrent_duration_FiniteDuration__O__Lretry_RetryStatus__O(this, policy, evidence$1, threshold, actionResult, status)));
  var pretty = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
    var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["limitRetriesByDelay(threshold=", ", ", ")"]));
    var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
    return $x_1.show$extension__s_StringContext__sci_Seq__T(sc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(threshold, $m_Lcats_instances_package$duration$().Lcats_instances_package$duration$__f_catsStdShowForDurationUnambiguous)), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(policy, $m_Lretry_RetryPolicy$().given_Show_RetryPolicy__Lcats_Show()))])));
  }));
  return new $c_Lretry_RetryPolicy$$anon$1(decideNextRetry, pretty);
});
var $d_Lretry_RetryPolicies$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lretry_RetryPolicies$, "retry.RetryPolicies$", ({
  Lretry_RetryPolicies$: 1
}));
export { $d_Lretry_RetryPolicies$ as $d_Lretry_RetryPolicies$ };
var $n_Lretry_RetryPolicies$;
function $m_Lretry_RetryPolicies$() {
  if ((!$n_Lretry_RetryPolicies$)) {
    $n_Lretry_RetryPolicies$ = new $c_Lretry_RetryPolicies$();
  }
  return $n_Lretry_RetryPolicies$;
}
export { $m_Lretry_RetryPolicies$ as $m_Lretry_RetryPolicies$ };
function $p_Lretry_package$package$__applyNextStep$1__Lcats_effect_kernel_GenTemporal__Lretry_NextStep__O__s_util_Either__O($thiz, T$7, nextStep, nextAction, valueToReturn) {
  if ((nextStep instanceof $c_Lretry_NextStep$RetryAfterDelay)) {
    var x16 = nextStep.Lretry_NextStep$RetryAfterDelay__f_delay;
    var x17 = nextStep.Lretry_NextStep$RetryAfterDelay__f_updatedStatus;
    var fa = $f_Lcats_effect_kernel_GenTemporal__sleep__s_concurrent_duration_Duration__O(T$7, x16);
    var value = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), nextAction, x17);
    var x = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value);
    $m_Lcats_effect_IO$();
    var fb = new $c_Lcats_effect_IO$Pure(x);
    return fa.productR__Lcats_effect_IO__Lcats_effect_IO(fb);
  }
  var x$1 = $m_Lretry_NextStep$GiveUp$();
  if ((x$1 === nextStep)) {
    var x$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(valueToReturn);
    $m_Lcats_effect_IO$();
    return new $c_Lcats_effect_IO$Pure(x$2);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(nextStep);
}
export { $p_Lretry_package$package$__applyNextStep$1__Lcats_effect_kernel_GenTemporal__Lretry_NextStep__O__s_util_Either__O as $p_Lretry_package$package$__applyNextStep$1__Lcats_effect_kernel_GenTemporal__Lretry_NextStep__O__s_util_Either__O };
function $p_Lretry_package$package$__applyHandlerDecision$1__Lcats_effect_kernel_GenTemporal__O__O__Lretry_HandlerDecision__Lretry_NextStep__O($thiz, T$8, actionResult$1, currentAction$4, handlerDecision, nextStep) {
  var x = $s_Lretry_HandlerDecision$__Stop__Lretry_HandlerDecision();
  if (((x === null) ? (handlerDecision === null) : x.equals__O__Z(handlerDecision))) {
    var value = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(actionResult$1);
    var x$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value);
    $m_Lcats_effect_IO$();
    return new $c_Lcats_effect_IO$Pure(x$1);
  }
  var x$3 = $s_Lretry_HandlerDecision$__Continue__Lretry_HandlerDecision();
  if (((x$3 === null) ? (handlerDecision === null) : x$3.equals__O__Z(handlerDecision))) {
    return $p_Lretry_package$package$__applyNextStep$1__Lcats_effect_kernel_GenTemporal__Lretry_NextStep__O__s_util_Either__O($thiz, T$8, nextStep, currentAction$4, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(actionResult$1));
  }
  if ((handlerDecision instanceof $c_Lretry_HandlerDecision$Adapt)) {
    var x21 = handlerDecision.Lretry_HandlerDecision$Adapt__f_newAction;
    return $p_Lretry_package$package$__applyNextStep$1__Lcats_effect_kernel_GenTemporal__Lretry_NextStep__O__s_util_Either__O($thiz, T$8, nextStep, x21, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(actionResult$1));
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(handlerDecision);
}
export { $p_Lretry_package$package$__applyHandlerDecision$1__Lcats_effect_kernel_GenTemporal__O__O__Lretry_HandlerDecision__Lretry_NextStep__O as $p_Lretry_package$package$__applyHandlerDecision$1__Lcats_effect_kernel_GenTemporal__O__O__Lretry_HandlerDecision__Lretry_NextStep__O };
function $p_Lretry_package$package$__applyNextStep$2__Lcats_effect_kernel_GenTemporal__jl_Throwable__Lretry_NextStep__O__O($thiz, T$11, error, nextStep, nextAction) {
  if ((nextStep instanceof $c_Lretry_NextStep$RetryAfterDelay)) {
    var x28 = nextStep.Lretry_NextStep$RetryAfterDelay__f_delay;
    var x29 = nextStep.Lretry_NextStep$RetryAfterDelay__f_updatedStatus;
    var fa = $f_Lcats_effect_kernel_GenTemporal__sleep__s_concurrent_duration_Duration__O(T$11, x28);
    var value = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), nextAction, x29);
    var x = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value);
    $m_Lcats_effect_IO$();
    var fb = new $c_Lcats_effect_IO$Pure(x);
    return fa.productR__Lcats_effect_IO__Lcats_effect_IO(fb);
  }
  var x$1 = $m_Lretry_NextStep$GiveUp$();
  if ((x$1 === nextStep)) {
    $m_Lcats_effect_IO$();
    var target = new $c_Lcats_effect_IO$Error(error);
    var this$12 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target, T$11);
    var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$10) => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(_$10)));
    return this$12.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.map__O__F1__O(this$12.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(nextStep);
}
export { $p_Lretry_package$package$__applyNextStep$2__Lcats_effect_kernel_GenTemporal__jl_Throwable__Lretry_NextStep__O__O as $p_Lretry_package$package$__applyNextStep$2__Lcats_effect_kernel_GenTemporal__jl_Throwable__Lretry_NextStep__O__O };
function $p_Lretry_package$package$__applyHandlerDecision$2__Lcats_effect_kernel_GenTemporal__O__jl_Throwable__Lretry_HandlerDecision__Lretry_NextStep__O($thiz, T$12, currentAction$7, error, handlerDecision, nextStep) {
  var x = $s_Lretry_HandlerDecision$__Stop__Lretry_HandlerDecision();
  if (((x === null) ? (handlerDecision === null) : x.equals__O__Z(handlerDecision))) {
    $m_Lcats_effect_IO$();
    var target = new $c_Lcats_effect_IO$Error(error);
    var this$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target, T$12);
    var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$11) => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(_$11)));
    return this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.map__O__F1__O(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  }
  var x$3 = $s_Lretry_HandlerDecision$__Continue__Lretry_HandlerDecision();
  if (((x$3 === null) ? (handlerDecision === null) : x$3.equals__O__Z(handlerDecision))) {
    return $p_Lretry_package$package$__applyNextStep$2__Lcats_effect_kernel_GenTemporal__jl_Throwable__Lretry_NextStep__O__O($thiz, T$12, error, nextStep, currentAction$7);
  }
  if ((handlerDecision instanceof $c_Lretry_HandlerDecision$Adapt)) {
    var x33 = handlerDecision.Lretry_HandlerDecision$Adapt__f_newAction;
    return $p_Lretry_package$package$__applyNextStep$2__Lcats_effect_kernel_GenTemporal__jl_Throwable__Lretry_NextStep__O__O($thiz, T$12, error, nextStep, x33);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(handlerDecision);
}
export { $p_Lretry_package$package$__applyHandlerDecision$2__Lcats_effect_kernel_GenTemporal__O__jl_Throwable__Lretry_HandlerDecision__Lretry_NextStep__O as $p_Lretry_package$package$__applyHandlerDecision$2__Lcats_effect_kernel_GenTemporal__O__jl_Throwable__Lretry_HandlerDecision__Lretry_NextStep__O };
/** @constructor */
function $c_Lretry_package$package$() {
}
export { $c_Lretry_package$package$ as $c_Lretry_package$package$ };
$c_Lretry_package$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lretry_package$package$.prototype.constructor = $c_Lretry_package$package$;
/** @constructor */
function $h_Lretry_package$package$() {
}
export { $h_Lretry_package$package$ as $h_Lretry_package$package$ };
$h_Lretry_package$package$.prototype = $c_Lretry_package$package$.prototype;
$c_Lretry_package$package$.prototype.retryingOnFailures__O__Lretry_RetryPolicy__F2__Lcats_effect_kernel_GenTemporal__O = (function(action, policy, valueHandler, T) {
  var _2 = $m_Lretry_RetryStatus$().Lretry_RetryStatus$__f_NoRetriesYet;
  var a = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), action, _2);
  var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    var currentAction = x$1._1__O();
    var status = x$1._2__O();
    var this$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(currentAction, T);
    var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((actionResult) => $m_Lretry_package$package$().retryingOnFailuresImpl__Lretry_RetryPolicy__F2__Lretry_RetryStatus__O__O__Lcats_effect_kernel_GenTemporal__O(policy, valueHandler, status, currentAction, actionResult, T)));
    return this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  }));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_StackSafeMonad__tailRecM__O__F1__O(T, a, f$1);
});
$c_Lretry_package$package$.prototype.retryingOnErrors__O__Lretry_RetryPolicy__F2__Lcats_effect_kernel_GenTemporal__O = (function(action, policy, errorHandler, T) {
  var _2 = $m_Lretry_RetryStatus$().Lretry_RetryStatus$__f_NoRetriesYet;
  var a = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), action, _2);
  var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    var currentAction = x$1._1__O();
    var status = x$1._2__O();
    var target = new $c_Lcats_effect_IO$Attempt(currentAction);
    var this$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, T);
    var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((attempt) => $m_Lretry_package$package$().retryingOnErrorsImpl__Lretry_RetryPolicy__F2__Lretry_RetryStatus__O__s_util_Either__Lcats_effect_kernel_GenTemporal__O(policy, errorHandler, status, currentAction, attempt, T)));
    return this$4.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$4.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  }));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_StackSafeMonad__tailRecM__O__F1__O(T, a, f$1);
});
$c_Lretry_package$package$.prototype.retryingOnFailuresImpl__Lretry_RetryPolicy__F2__Lretry_RetryStatus__O__O__Lcats_effect_kernel_GenTemporal__O = (function(policy, valueHandler, status, currentAction, actionResult, T) {
  var target = $m_Lretry_package$package$().applyPolicy__Lretry_RetryPolicy__O__Lretry_RetryStatus__Lcats_Functor__O(policy, actionResult, status, T);
  var this$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target, T);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((nextStep) => {
    var retryDetails = $m_Lretry_package$package$().buildRetryDetails__Lretry_RetryStatus__Lretry_NextStep__Lretry_RetryDetails(status, nextStep);
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), nextStep, retryDetails);
  }));
  var target$1 = this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.map__O__F1__O(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  var this$10 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, T);
  var f$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 !== null)) {
      var nextStep$1 = x$1._1__O();
      var retryDetails$1 = x$1._2__O();
      var target$2 = valueHandler.apply__O__O__O(actionResult, retryDetails$1);
      var this$9 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, T);
      var f$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((handlerDecision) => {
        var target$3 = $p_Lretry_package$package$__applyHandlerDecision$1__Lcats_effect_kernel_GenTemporal__O__O__Lretry_HandlerDecision__Lretry_NextStep__O(this, T, actionResult, currentAction, handlerDecision, nextStep$1);
        var this$8 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target$3, T);
        var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((result) => result));
        return this$8.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.map__O__F1__O(this$8.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$1);
      }));
      return this$9.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$9.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  }));
  return this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
});
$c_Lretry_package$package$.prototype.retryingOnErrorsImpl__Lretry_RetryPolicy__F2__Lretry_RetryStatus__O__s_util_Either__Lcats_effect_kernel_GenTemporal__O = (function(policy, errorHandler, status, currentAction, attempt, T) {
  if ((attempt instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
    var error = attempt.s_util_Left__f_value;
    var target = $m_Lretry_package$package$().applyPolicy__Lretry_RetryPolicy__O__Lretry_RetryStatus__Lcats_Functor__O(policy, error, status, T);
    var this$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target, T);
    var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((nextStep) => {
      var retryDetails = $m_Lretry_package$package$().buildRetryDetails__Lretry_RetryStatus__Lretry_NextStep__Lretry_RetryDetails(status, nextStep);
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), nextStep, retryDetails);
    }));
    var target$1 = this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.map__O__F1__O(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
    var this$10 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, T);
    var f$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
      if ((x$1 !== null)) {
        var nextStep$1 = x$1._1__O();
        var retryDetails$1 = x$1._2__O();
        var target$2 = errorHandler.apply__O__O__O(error, retryDetails$1);
        var this$9 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, T);
        var f$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((handlerDecision) => {
          var target$3 = $p_Lretry_package$package$__applyHandlerDecision$2__Lcats_effect_kernel_GenTemporal__O__jl_Throwable__Lretry_HandlerDecision__Lretry_NextStep__O(this, T, currentAction, error, handlerDecision, nextStep$1);
          var this$8 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target$3, T);
          var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((result) => result));
          return this$8.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.map__O__F1__O(this$8.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$1);
        }));
        return this$9.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$9.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    }));
    return this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
  }
  if ((attempt instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
    var success = attempt.s_util_Right__f_value;
    var x = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(success);
    $m_Lcats_effect_IO$();
    return new $c_Lcats_effect_IO$Pure(x);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(attempt);
});
$c_Lretry_package$package$.prototype.applyPolicy__Lretry_RetryPolicy__O__Lretry_RetryStatus__Lcats_Functor__O = (function(policy, actionResult, retryStatus, evidence$1) {
  var target = policy.Lretry_RetryPolicy__f_decideNextRetry.apply__O__O__O(actionResult, retryStatus);
  var this$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target, evidence$1);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    matchResult15: {
      var $x_1;
      if ((x$1 instanceof $c_Lretry_PolicyDecision$DelayAndRetry)) {
        var x45 = x$1.Lretry_PolicyDecision$DelayAndRetry__f_delay;
        var updatedStatus = retryStatus.addRetry__s_concurrent_duration_FiniteDuration__Lretry_RetryStatus(x45);
        var $x_1 = new $c_Lretry_NextStep$RetryAfterDelay(x45, updatedStatus);
        break matchResult15;
      }
      var x = $s_Lretry_PolicyDecision$__GiveUp__Lretry_PolicyDecision();
      if (((x === null) ? (x$1 === null) : x.equals__O__Z(x$1))) {
        var $x_1 = $m_Lretry_NextStep$GiveUp$();
        break matchResult15;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    }
    return $x_1;
  }));
  return this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
});
$c_Lretry_package$package$.prototype.buildRetryDetails__Lretry_RetryStatus__Lretry_NextStep__Lretry_RetryDetails = (function(currentStatus, nextStep) {
  if ((nextStep instanceof $c_Lretry_NextStep$RetryAfterDelay)) {
    var x49 = nextStep.Lretry_NextStep$RetryAfterDelay__f_delay;
    var retriesSoFar = currentStatus.Lretry_RetryStatus__f_retriesSoFar;
    var cumulativeDelay = currentStatus.Lretry_RetryStatus__f_cumulativeDelay;
    var nextStepIfUnsuccessful = new $c_Lretry_RetryDetails$NextStep$DelayAndRetry(x49);
    return new $c_Lretry_RetryDetails(retriesSoFar, cumulativeDelay, nextStepIfUnsuccessful);
  }
  var x = $m_Lretry_NextStep$GiveUp$();
  if ((x === nextStep)) {
    var retriesSoFar$1 = currentStatus.Lretry_RetryStatus__f_retriesSoFar;
    var cumulativeDelay$1 = currentStatus.Lretry_RetryStatus__f_cumulativeDelay;
    var nextStepIfUnsuccessful$1 = $s_Lretry_RetryDetails$NextStep$__GiveUp__Lretry_RetryDetails$NextStep();
    return new $c_Lretry_RetryDetails(retriesSoFar$1, cumulativeDelay$1, nextStepIfUnsuccessful$1);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(nextStep);
});
var $d_Lretry_package$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lretry_package$package$, "retry.package$package$", ({
  Lretry_package$package$: 1
}));
export { $d_Lretry_package$package$ as $d_Lretry_package$package$ };
var $n_Lretry_package$package$;
function $m_Lretry_package$package$() {
  if ((!$n_Lretry_package$package$)) {
    $n_Lretry_package$package$ = new $c_Lretry_package$package$();
  }
  return $n_Lretry_package$package$;
}
export { $m_Lretry_package$package$ as $m_Lretry_package$package$ };
/** @constructor */
function $c_sc_BitSetOps$() {
}
export { $c_sc_BitSetOps$ as $c_sc_BitSetOps$ };
$c_sc_BitSetOps$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_sc_BitSetOps$.prototype.constructor = $c_sc_BitSetOps$;
/** @constructor */
function $h_sc_BitSetOps$() {
}
export { $h_sc_BitSetOps$ as $h_sc_BitSetOps$ };
$h_sc_BitSetOps$.prototype = $c_sc_BitSetOps$.prototype;
$c_sc_BitSetOps$.prototype.updateArray__AJ__I__J__AJ = (function(elems, idx, w) {
  var len = elems.u.length;
  while (true) {
    if ((len > 0)) {
      var a = elems.u[(((-1) + len) | 0)];
      if (((a.RTLong__f_lo === 0) && (a.RTLong__f_hi === 0))) {
        var $x_1 = true;
      } else {
        var $x_1 = (((w.RTLong__f_lo === 0) && (w.RTLong__f_hi === 0)) && (idx === (((-1) + len) | 0)));
      }
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      len = (((-1) + len) | 0);
    } else {
      break;
    }
  }
  var newlen = len;
  if (((idx >= newlen) && (!((w.RTLong__f_lo === 0) && (w.RTLong__f_hi === 0))))) {
    newlen = ((1 + idx) | 0);
  }
  var newelems = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_J(newlen);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Array$().copy__O__I__O__I__I__V(elems, 0, newelems, 0, len);
  if ((idx < newlen)) {
    newelems.u[idx] = w;
  } else {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Predef$().assert__Z__V(((w.RTLong__f_lo === 0) && (w.RTLong__f_hi === 0)));
  }
  return newelems;
});
$c_sc_BitSetOps$.prototype.computeWordForFilter__F1__Z__J__I__J = (function(pred, isFlipped, oldWord, wordIndex) {
  if (((oldWord.RTLong__f_lo === 0) && (oldWord.RTLong__f_hi === 0))) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0;
  } else {
    var lo = oldWord.RTLong__f_lo;
    var hi = oldWord.RTLong__f_hi;
    var w__lo = lo;
    var w__hi = hi;
    var l__lo = w__lo;
    var l__hi = w__hi;
    var lo$1 = l__lo;
    if ((lo$1 !== 0)) {
      var i = ((~lo$1) & (((-1) + lo$1) | 0));
      var trailingZeroes = ((32 - Math.clz32(i)) | 0);
    } else {
      var hi$1 = l__hi;
      var i$1 = ((~hi$1) & (((-1) + hi$1) | 0));
      var trailingZeroes = ((32 + ((32 - Math.clz32(i$1)) | 0)) | 0);
    }
    var lo$2 = (((32 & trailingZeroes) === 0) ? (1 << trailingZeroes) : 0);
    var hi$2 = (((32 & trailingZeroes) === 0) ? 0 : (1 << trailingZeroes));
    var jmask__lo = lo$2;
    var jmask__hi = hi$2;
    var j = (((wordIndex << 6) + trailingZeroes) | 0);
    var l$1__lo = w__lo;
    var l$1__hi = w__hi;
    var hi$3 = l$1__hi;
    if ((hi$3 !== 0)) {
      var $x_1 = Math.clz32(hi$3);
    } else {
      var i$2 = l$1__lo;
      var $x_1 = ((32 + Math.clz32(i$2)) | 0);
    }
    var maxJ = (((((1 + wordIndex) | 0) << 6) - $x_1) | 0);
    while ((j !== maxJ)) {
      var a__lo = w__lo;
      var a__hi = w__hi;
      var b__lo = jmask__lo;
      var b__hi = jmask__hi;
      var lo$3 = (a__lo & b__lo);
      var hi$4 = (a__hi & b__hi);
      if ((!((lo$3 === 0) && (hi$4 === 0)))) {
        if ((pred.apply$mcZI$sp__I__Z(j) === isFlipped)) {
          var a$1__lo = w__lo;
          var a$1__hi = w__hi;
          var b$1__lo = jmask__lo;
          var b$1__hi = jmask__hi;
          var lo$4 = (~b$1__lo);
          var hi$5 = (~b$1__hi);
          var lo$5 = (a$1__lo & lo$4);
          var hi$6 = (a$1__hi & hi$5);
          var $x_2__lo = lo$5;
          var $x_2__hi = hi$6;
          w__lo = $x_2__lo;
          w__hi = $x_2__hi;
        }
      }
      var a$2__lo = jmask__lo;
      var a$2__hi = jmask__hi;
      var lo$6 = a$2__lo;
      var lo$7 = (lo$6 << 1);
      var hi$7 = (((lo$6 >>> 31) | 0) | (a$2__hi << 1));
      var $x_3__lo = lo$7;
      var $x_3__hi = hi$7;
      jmask__lo = $x_3__lo;
      jmask__hi = $x_3__hi;
      j = ((1 + j) | 0);
    }
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(w__lo, w__hi);
  }
});
var $d_sc_BitSetOps$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sc_BitSetOps$, "scala.collection.BitSetOps$", ({
  sc_BitSetOps$: 1
}));
export { $d_sc_BitSetOps$ as $d_sc_BitSetOps$ };
var $n_sc_BitSetOps$;
function $m_sc_BitSetOps$() {
  if ((!$n_sc_BitSetOps$)) {
    $n_sc_BitSetOps$ = new $c_sc_BitSetOps$();
  }
  return $n_sc_BitSetOps$;
}
export { $m_sc_BitSetOps$ as $m_sc_BitSetOps$ };
function $f_scg_BitOperations$Long__zero__J__J__Z($thiz, i, mask) {
  var lo = (i.RTLong__f_lo & mask.RTLong__f_lo);
  var hi = (i.RTLong__f_hi & mask.RTLong__f_hi);
  return ((lo === 0) && (hi === 0));
}
export { $f_scg_BitOperations$Long__zero__J__J__Z as $f_scg_BitOperations$Long__zero__J__J__Z };
function $f_scg_BitOperations$Long__mask__J__J__J($thiz, i, mask) {
  var blo = mask.RTLong__f_lo;
  var lo = (((-1) + blo) | 0);
  var hi = (((((-1) + mask.RTLong__f_hi) | 0) + (((blo | (~lo)) >>> 31) | 0)) | 0);
  var a = $f_scg_BitOperations$Long__complement__J__J($thiz, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi));
  var lo$1 = (a.RTLong__f_lo ^ mask.RTLong__f_lo);
  var hi$1 = (a.RTLong__f_hi ^ mask.RTLong__f_hi);
  var lo$2 = (i.RTLong__f_lo & lo$1);
  var hi$2 = (i.RTLong__f_hi & hi$1);
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$2, hi$2);
}
export { $f_scg_BitOperations$Long__mask__J__J__J as $f_scg_BitOperations$Long__mask__J__J__J };
function $f_scg_BitOperations$Long__hasMatch__J__J__J__Z($thiz, key, prefix, m) {
  var a = $f_scg_BitOperations$Long__mask__J__J__J($thiz, key, m);
  return ((a.RTLong__f_lo === prefix.RTLong__f_lo) && (a.RTLong__f_hi === prefix.RTLong__f_hi));
}
export { $f_scg_BitOperations$Long__hasMatch__J__J__J__Z as $f_scg_BitOperations$Long__hasMatch__J__J__J__Z };
function $f_scg_BitOperations$Long__complement__J__J($thiz, i) {
  var lo = (~i.RTLong__f_lo);
  var hi = (~i.RTLong__f_hi);
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi);
}
export { $f_scg_BitOperations$Long__complement__J__J as $f_scg_BitOperations$Long__complement__J__J };
/** @constructor */
function $c_sci_LazyList$Deferrer$() {
}
export { $c_sci_LazyList$Deferrer$ as $c_sci_LazyList$Deferrer$ };
$c_sci_LazyList$Deferrer$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_sci_LazyList$Deferrer$.prototype.constructor = $c_sci_LazyList$Deferrer$;
/** @constructor */
function $h_sci_LazyList$Deferrer$() {
}
export { $h_sci_LazyList$Deferrer$ as $h_sci_LazyList$Deferrer$ };
$h_sci_LazyList$Deferrer$.prototype = $c_sci_LazyList$Deferrer$.prototype;
$c_sci_LazyList$Deferrer$.prototype.$hash$colon$colon$extension__F0__F0__sci_LazyList = (function(this$, elem) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_LazyList$();
  var state = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_LazyList$();
    var hd = elem.apply__O();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_LazyList$();
    var tl = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_sci_LazyList__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_LazyList(), this$);
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_sci_LazyList__O__sci_LazyList__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_LazyList(), hd, tl);
  }));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_sci_LazyList__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_LazyList(), state);
});
var $d_sci_LazyList$Deferrer$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sci_LazyList$Deferrer$, "scala.collection.immutable.LazyList$Deferrer$", ({
  sci_LazyList$Deferrer$: 1
}));
export { $d_sci_LazyList$Deferrer$ as $d_sci_LazyList$Deferrer$ };
var $n_sci_LazyList$Deferrer$;
function $m_sci_LazyList$Deferrer$() {
  if ((!$n_sci_LazyList$Deferrer$)) {
    $n_sci_LazyList$Deferrer$ = new $c_sci_LazyList$Deferrer$();
  }
  return $n_sci_LazyList$Deferrer$;
}
export { $m_sci_LazyList$Deferrer$ as $m_sci_LazyList$Deferrer$ };
function $p_sci_RedBlackTree$___foreach__sci_RedBlackTree$Tree__F1__V($thiz, tree, f) {
  while (true) {
    var this$1 = tree;
    if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left !== null)) {
      var this$2 = tree;
      $p_sci_RedBlackTree$___foreach__sci_RedBlackTree$Tree__F1__V($thiz, this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, f);
    }
    var this$3 = tree;
    var $x_1 = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
    var this$4 = tree;
    f.apply__O__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), $x_1, this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value));
    var this$5 = tree;
    if ((this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right !== null)) {
      var this$6 = tree;
      tree = this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      continue;
    }
    return (void 0);
  }
}
export { $p_sci_RedBlackTree$___foreach__sci_RedBlackTree$Tree__F1__V as $p_sci_RedBlackTree$___foreach__sci_RedBlackTree$Tree__F1__V };
function $p_sci_RedBlackTree$___foreachKey__sci_RedBlackTree$Tree__F1__V($thiz, tree, f) {
  while (true) {
    var this$1 = tree;
    if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left !== null)) {
      var this$2 = tree;
      $p_sci_RedBlackTree$___foreachKey__sci_RedBlackTree$Tree__F1__V($thiz, this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, f);
    }
    var this$3 = tree;
    f.apply__O__O(this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
    var this$4 = tree;
    if ((this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right !== null)) {
      var this$5 = tree;
      tree = this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      continue;
    }
    return (void 0);
  }
}
export { $p_sci_RedBlackTree$___foreachKey__sci_RedBlackTree$Tree__F1__V as $p_sci_RedBlackTree$___foreachKey__sci_RedBlackTree$Tree__F1__V };
function $p_sci_RedBlackTree$___foreachEntry__sci_RedBlackTree$Tree__F2__V($thiz, tree, f) {
  while (true) {
    var this$1 = tree;
    if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left !== null)) {
      var this$2 = tree;
      $p_sci_RedBlackTree$___foreachEntry__sci_RedBlackTree$Tree__F2__V($thiz, this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, f);
    }
    var this$3 = tree;
    var $x_1 = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
    var this$4 = tree;
    f.apply__O__O__O($x_1, this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value);
    var this$5 = tree;
    if ((this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right !== null)) {
      var this$6 = tree;
      tree = this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      continue;
    }
    return (void 0);
  }
}
export { $p_sci_RedBlackTree$___foreachEntry__sci_RedBlackTree$Tree__F2__V as $p_sci_RedBlackTree$___foreachEntry__sci_RedBlackTree$Tree__F2__V };
function $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, t) {
  return ((t === null) ? null : t.black__sci_RedBlackTree$Tree());
}
export { $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree as $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree };
function $p_sci_RedBlackTree$__maybeBlacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, t) {
  if ($thiz.isBlack__sci_RedBlackTree$Tree__Z(t)) {
    return t;
  } else {
    var tree = t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    if (((tree !== null) && (tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
      var $x_1 = true;
    } else {
      var tree$1 = t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      var $x_1 = ((tree$1 !== null) && (tree$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0));
    }
    if ($x_1) {
      return t.black__sci_RedBlackTree$Tree();
    } else {
      return t;
    }
  }
}
export { $p_sci_RedBlackTree$__maybeBlacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree as $p_sci_RedBlackTree$__maybeBlacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree };
function $p_sci_RedBlackTree$__mkTree__Z__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, isBlack, key, value, left, right) {
  var sizeAndColour = (((1 + ((((left === null) ? 0 : (2147483647 & left.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) + ((right === null) ? 0 : (2147483647 & right.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0) | (isBlack ? (-2147483648) : 0));
  return new $c_sci_RedBlackTree$Tree(key, value, left, right, sizeAndColour);
}
export { $p_sci_RedBlackTree$__mkTree__Z__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree as $p_sci_RedBlackTree$__mkTree__Z__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree };
function $p_sci_RedBlackTree$__balanceLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, newLeft) {
  if ((tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left === newLeft)) {
    return tree;
  } else if ((newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) {
    var newLeft_left = newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    var newLeft_right = newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
    if (((newLeft_left !== null) && (newLeft_left.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
      var resultLeft = newLeft_left.black__sci_RedBlackTree$Tree();
      var resultRight = tree.blackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft_right);
      return newLeft.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft, resultRight);
    } else if (((newLeft_right !== null) && (newLeft_right.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
      var newLeft_right_right = newLeft_right.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      var resultLeft$2 = newLeft.blackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft_right.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
      var resultRight$2 = tree.blackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft_right_right);
      return newLeft_right.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft$2, resultRight$2);
    } else {
      return tree.withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft);
    }
  } else {
    return tree.withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft);
  }
}
export { $p_sci_RedBlackTree$__balanceLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree as $p_sci_RedBlackTree$__balanceLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree };
function $p_sci_RedBlackTree$__balanceRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, newRight) {
  if ((tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right === newRight)) {
    return tree;
  } else if ((newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) {
    var newRight_left = newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    if (((newRight_left !== null) && (newRight_left.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
      var resultLeft = tree.blackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight_left.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
      var resultRight = newRight.blackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight_left.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
      return newRight_left.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft, resultRight);
    } else {
      var newRight_right = newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      if (((newRight_right !== null) && (newRight_right.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
        var resultLeft$2 = tree.blackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight_left);
        var resultRight$2 = newRight_right.black__sci_RedBlackTree$Tree();
        return newRight.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft$2, resultRight$2);
      } else {
        return tree.withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight);
      }
    }
  } else {
    return tree.withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight);
  }
}
export { $p_sci_RedBlackTree$__balanceRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree as $p_sci_RedBlackTree$__balanceRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree };
function $p_sci_RedBlackTree$__upd__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree($thiz, tree, k, v, overwrite, ordering) {
  if ((tree === null)) {
    return $thiz.RedTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(k, v, null, null);
  } else if (Object.is(k, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key)) {
    return (overwrite ? tree.withV__O__sci_RedBlackTree$Tree(v) : tree);
  } else {
    var cmp = ordering.compare__O__O__I(k, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
    return ((cmp < 0) ? $p_sci_RedBlackTree$__balanceLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, $p_sci_RedBlackTree$__upd__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree($thiz, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, k, v, overwrite, ordering)) : ((cmp > 0) ? $p_sci_RedBlackTree$__balanceRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, $p_sci_RedBlackTree$__upd__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree($thiz, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, k, v, overwrite, ordering)) : ((overwrite && (!Object.is(v, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value))) ? tree.withV__O__sci_RedBlackTree$Tree(v) : tree)));
  }
}
export { $p_sci_RedBlackTree$__upd__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree as $p_sci_RedBlackTree$__upd__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree };
function $p_sci_RedBlackTree$__updNth__sci_RedBlackTree$Tree__I__O__O__sci_RedBlackTree$Tree($thiz, tree, idx, k, v) {
  if ((tree === null)) {
    return $thiz.RedTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(k, v, null, null);
  } else {
    var rank = ((1 + $thiz.count__sci_RedBlackTree$Tree__I(tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left)) | 0);
    return ((idx < rank) ? $p_sci_RedBlackTree$__balanceLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, $p_sci_RedBlackTree$__updNth__sci_RedBlackTree$Tree__I__O__O__sci_RedBlackTree$Tree($thiz, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, idx, k, v)) : ((idx > rank) ? $p_sci_RedBlackTree$__balanceRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, $p_sci_RedBlackTree$__updNth__sci_RedBlackTree$Tree__I__O__O__sci_RedBlackTree$Tree($thiz, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, ((idx - rank) | 0), k, v)) : tree));
  }
}
export { $p_sci_RedBlackTree$__updNth__sci_RedBlackTree$Tree__I__O__O__sci_RedBlackTree$Tree as $p_sci_RedBlackTree$__updNth__sci_RedBlackTree$Tree__I__O__O__sci_RedBlackTree$Tree };
function $p_sci_RedBlackTree$__doDrop__sci_RedBlackTree$Tree__I__sci_RedBlackTree$Tree($thiz, tree, n) {
  while (true) {
    if (((tree === null) || (n <= 0))) {
      return tree;
    } else {
      var $x_1 = n;
      var this$1 = tree;
      if (($x_1 >= (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) {
        return null;
      } else {
        var this$2 = tree;
        var l = $thiz.count__sci_RedBlackTree$Tree__I(this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
        if ((n > l)) {
          var this$3 = tree;
          var temp$tree = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
          var temp$n = (((-1) + ((n - l) | 0)) | 0);
          tree = temp$tree;
          n = temp$n;
        } else if ((n === l)) {
          var this$4 = tree;
          var $x_3 = this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
          var this$5 = tree;
          var $x_2 = this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value;
          var this$6 = tree;
          return $thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(null, $x_3, $x_2, this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
        } else {
          var this$7 = tree;
          var $x_6 = $p_sci_RedBlackTree$__doDrop__sci_RedBlackTree$Tree__I__sci_RedBlackTree$Tree($thiz, this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, n);
          var this$8 = tree;
          var $x_5 = this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
          var this$9 = tree;
          var $x_4 = this$9.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value;
          var this$10 = tree;
          return $thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($x_6, $x_5, $x_4, this$10.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
        }
      }
    }
  }
}
export { $p_sci_RedBlackTree$__doDrop__sci_RedBlackTree$Tree__I__sci_RedBlackTree$Tree as $p_sci_RedBlackTree$__doDrop__sci_RedBlackTree$Tree__I__sci_RedBlackTree$Tree };
function $p_sci_RedBlackTree$__doTake__sci_RedBlackTree$Tree__I__sci_RedBlackTree$Tree($thiz, tree, n) {
  while (true) {
    if (((tree === null) || (n <= 0))) {
      return null;
    } else {
      var this$1 = tree;
      if ((n >= (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) {
        return tree;
      } else {
        var this$2 = tree;
        var l = $thiz.count__sci_RedBlackTree$Tree__I(this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
        if ((n <= l)) {
          var this$3 = tree;
          tree = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
        } else if ((n === ((1 + l) | 0))) {
          var this$4 = tree;
          var $x_2 = this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
          var this$5 = tree;
          var $x_1 = this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
          var this$6 = tree;
          return $p_sci_RedBlackTree$__maybeBlacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, $p_sci_RedBlackTree$__updNth__sci_RedBlackTree$Tree__I__O__O__sci_RedBlackTree$Tree($thiz, $x_2, n, $x_1, this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value));
        } else {
          var this$7 = tree;
          var $x_5 = this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
          var this$8 = tree;
          var $x_4 = this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
          var this$9 = tree;
          var $x_3 = this$9.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value;
          var this$10 = tree;
          return $thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($x_5, $x_4, $x_3, $p_sci_RedBlackTree$__doTake__sci_RedBlackTree$Tree__I__sci_RedBlackTree$Tree($thiz, this$10.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, (((-1) + ((n - l) | 0)) | 0)));
        }
      }
    }
  }
}
export { $p_sci_RedBlackTree$__doTake__sci_RedBlackTree$Tree__I__sci_RedBlackTree$Tree as $p_sci_RedBlackTree$__doTake__sci_RedBlackTree$Tree__I__sci_RedBlackTree$Tree };
function $p_sci_RedBlackTree$__del__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree($thiz, tree, k, ordering) {
  if ((tree === null)) {
    return null;
  } else {
    var cmp = ordering.compare__O__O__I(k, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
    if ((cmp < 0)) {
      var newLeft = $p_sci_RedBlackTree$__del__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree($thiz, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, k, ordering);
      if ((newLeft === tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left)) {
        return tree;
      } else {
        var tree$1 = tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
        if (((tree$1 !== null) && (tree$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
          return $p_sci_RedBlackTree$__balLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, newLeft, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
        } else {
          return tree.redWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft);
        }
      }
    } else if ((cmp > 0)) {
      var newRight = $p_sci_RedBlackTree$__del__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree($thiz, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, k, ordering);
      if ((newRight === tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)) {
        return tree;
      } else {
        var tree$2 = tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
        if (((tree$2 !== null) && (tree$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
          return $p_sci_RedBlackTree$__balRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, newRight);
        } else {
          return tree.redWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight);
        }
      }
    } else {
      return $p_sci_RedBlackTree$__append__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
    }
  }
}
export { $p_sci_RedBlackTree$__del__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree as $p_sci_RedBlackTree$__del__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree };
function $p_sci_RedBlackTree$__balance__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, tl, tr) {
  if (((tl !== null) && (tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
    if (((tr !== null) && (tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
      return tree.redWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl.black__sci_RedBlackTree$Tree(), tr.black__sci_RedBlackTree$Tree());
    } else {
      var tree$1 = tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      if (((tree$1 !== null) && (tree$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
        return tl.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left.black__sci_RedBlackTree$Tree(), tree.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr));
      } else {
        var tree$2 = tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
        if (((tree$2 !== null) && (tree$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
          var $x_2 = tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
          var this$1 = tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
          var $x_1 = tl.blackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
          var this$2 = tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
          return $x_2.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($x_1, tree.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr));
        } else {
          return tree.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, tr);
        }
      }
    }
  } else if (((tr !== null) && (tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
    var tree$3 = tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
    if (((tree$3 !== null) && (tree$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
      return tr.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tree.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left), tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right.black__sci_RedBlackTree$Tree());
    } else {
      var tree$4 = tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      if (((tree$4 !== null) && (tree$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
        var $x_4 = tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
        var this$3 = tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
        var $x_3 = tree.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
        var this$4 = tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
        return $x_4.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($x_3, tr.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right));
      } else {
        return tree.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, tr);
      }
    }
  } else {
    return tree.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, tr);
  }
}
export { $p_sci_RedBlackTree$__balance__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree as $p_sci_RedBlackTree$__balance__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree };
function $p_sci_RedBlackTree$__balLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, tl, tr) {
  if (((tl !== null) && (tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
    return tree.redWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl.black__sci_RedBlackTree$Tree(), tr);
  } else if (((tr !== null) && (tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
    return $p_sci_RedBlackTree$__balance__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, tl, tr.red__sci_RedBlackTree$Tree());
  } else {
    if (((tr !== null) && (tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
      var tree$1 = tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      var $x_1 = ((tree$1 !== null) && (tree$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var $x_3 = tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      var this$1 = tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      var $x_2 = tree.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
      var this$2 = tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      return $x_3.redWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($x_2, $p_sci_RedBlackTree$__balance__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tr, this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right.red__sci_RedBlackTree$Tree()));
    } else {
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_sys_package$().error__T__E("Defect: invariance violation");
    }
  }
}
export { $p_sci_RedBlackTree$__balLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree as $p_sci_RedBlackTree$__balLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree };
function $p_sci_RedBlackTree$__balRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, tl, tr) {
  if (((tr !== null) && (tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
    return tree.redWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, tr.black__sci_RedBlackTree$Tree());
  } else if (((tl !== null) && (tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
    return $p_sci_RedBlackTree$__balance__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, tl.red__sci_RedBlackTree$Tree(), tr);
  } else {
    if (((tl !== null) && (tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
      var tree$1 = tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      var $x_1 = ((tree$1 !== null) && (tree$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var $x_4 = tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      var $x_3 = tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left.red__sci_RedBlackTree$Tree();
      var this$1 = tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      var $x_2 = $p_sci_RedBlackTree$__balance__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tl, $x_3, this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
      var this$2 = tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      return $x_4.redWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($x_2, tree.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr));
    } else {
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_sys_package$().error__T__E("Defect: invariance violation");
    }
  }
}
export { $p_sci_RedBlackTree$__balRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree as $p_sci_RedBlackTree$__balRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree };
function $p_sci_RedBlackTree$__append__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tl, tr) {
  if ((tl === null)) {
    return tr;
  } else if ((tr === null)) {
    return tl;
  } else if ((tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) {
    if ((tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) {
      var bc = $p_sci_RedBlackTree$__append__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
      return (((bc !== null) && (bc.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) ? bc.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl.withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(bc.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left), tr.withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(bc.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)) : tl.withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tr.withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(bc)));
    } else {
      return tl.withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($p_sci_RedBlackTree$__append__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr));
    }
  } else if ((tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0)) {
    var bc$2 = $p_sci_RedBlackTree$__append__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
    return (((bc$2 !== null) && (bc$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) ? bc$2.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl.withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(bc$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left), tr.withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(bc$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)) : $p_sci_RedBlackTree$__balLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tl, tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, tr.withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(bc$2)));
  } else {
    return tr.withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($p_sci_RedBlackTree$__append__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tl, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left));
  }
}
export { $p_sci_RedBlackTree$__append__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree as $p_sci_RedBlackTree$__append__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree };
function $p_sci_RedBlackTree$__joinRight__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__I__I__sci_RedBlackTree$Tree($thiz, tl, k, v, tr, bhtl, rtr) {
  var rtl = ((tl === null) ? 0 : ((tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0) ? ((((-1) + bhtl) | 0) << 1) : (((-1) + (bhtl << 1)) | 0)));
  if ((rtl === (((rtr / 2) | 0) << 1))) {
    return $thiz.RedTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(k, v, tl, tr);
  } else {
    var tlBlack = ((tl !== null) && (tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0));
    var bhtlr = (tlBlack ? (((-1) + bhtl) | 0) : bhtl);
    var ttr = $p_sci_RedBlackTree$__joinRight__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__I__I__sci_RedBlackTree$Tree($thiz, tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, k, v, tr, bhtlr, rtr);
    if ((tlBlack && ((ttr !== null) && (ttr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)))) {
      var tree = ttr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      var $x_1 = ((tree !== null) && (tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return $thiz.RedTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(ttr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, ttr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, $thiz.BlackTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, ttr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left), ttr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right.black__sci_RedBlackTree$Tree());
    } else {
      return $p_sci_RedBlackTree$__mkTree__Z__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tlBlack, tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, ttr);
    }
  }
}
export { $p_sci_RedBlackTree$__joinRight__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__I__I__sci_RedBlackTree$Tree as $p_sci_RedBlackTree$__joinRight__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__I__I__sci_RedBlackTree$Tree };
function $p_sci_RedBlackTree$__joinLeft__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__I__I__sci_RedBlackTree$Tree($thiz, tl, k, v, tr, rtl, bhtr) {
  var rtr = ((tr === null) ? 0 : ((tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0) ? ((((-1) + bhtr) | 0) << 1) : (((-1) + (bhtr << 1)) | 0)));
  if ((rtr === (((rtl / 2) | 0) << 1))) {
    return $thiz.RedTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(k, v, tl, tr);
  } else {
    var trBlack = ((tr !== null) && (tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0));
    var bhtrl = (trBlack ? (((-1) + bhtr) | 0) : bhtr);
    var ttl = $p_sci_RedBlackTree$__joinLeft__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__I__I__sci_RedBlackTree$Tree($thiz, tl, k, v, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, rtl, bhtrl);
    if ((trBlack && ((ttl !== null) && (ttl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)))) {
      var tree = ttl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      var $x_1 = ((tree !== null) && (tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return $thiz.RedTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(ttl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, ttl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, ttl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left.black__sci_RedBlackTree$Tree(), $thiz.BlackTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, ttl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right));
    } else {
      return $p_sci_RedBlackTree$__mkTree__Z__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, trBlack, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, ttl, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
    }
  }
}
export { $p_sci_RedBlackTree$__joinLeft__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__I__I__sci_RedBlackTree$Tree as $p_sci_RedBlackTree$__joinLeft__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__I__I__sci_RedBlackTree$Tree };
function $p_sci_RedBlackTree$__split__sci_RedBlackTree$Tree__O__s_math_Ordering__T4($thiz, t, k2, ordering) {
  if ((t === null)) {
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T4(null, null, null, k2);
  } else {
    var cmp = ordering.compare__O__O__I(k2, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
    if ((cmp === 0)) {
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T4(t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, t, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
    } else if ((cmp < 0)) {
      var x1 = $p_sci_RedBlackTree$__split__sci_RedBlackTree$Tree__O__s_math_Ordering__T4($thiz, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, k2, ordering);
      if ((x1 === null)) {
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1);
      }
      var ll = x1.T4__f__1;
      var b = x1.T4__f__2;
      var lr = x1.T4__f__3;
      var k1 = x1.T4__f__4;
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T4(ll, b, $thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(lr, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right), k1);
    } else {
      var x1$2 = $p_sci_RedBlackTree$__split__sci_RedBlackTree$Tree__O__s_math_Ordering__T4($thiz, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, k2, ordering);
      if ((x1$2 === null)) {
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1$2);
      }
      var rl = x1$2.T4__f__1;
      var b$3 = x1$2.T4__f__2;
      var rr = x1$2.T4__f__3;
      var k1$3 = x1$2.T4__f__4;
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T4($thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, rl), b$3, rr, k1$3);
    }
  }
}
export { $p_sci_RedBlackTree$__split__sci_RedBlackTree$Tree__O__s_math_Ordering__T4 as $p_sci_RedBlackTree$__split__sci_RedBlackTree$Tree__O__s_math_Ordering__T4 };
function $p_sci_RedBlackTree$__splitLast__sci_RedBlackTree$Tree__T3($thiz, t) {
  if ((t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right === null)) {
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T3(t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value);
  } else {
    var x1 = $p_sci_RedBlackTree$__splitLast__sci_RedBlackTree$Tree__T3($thiz, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
    if ((x1 === null)) {
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1);
    }
    var tt = x1.T3__f__1;
    var kk = x1.T3__f__2;
    var vv = x1.T3__f__3;
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T3($thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, tt), kk, vv);
  }
}
export { $p_sci_RedBlackTree$__splitLast__sci_RedBlackTree$Tree__T3 as $p_sci_RedBlackTree$__splitLast__sci_RedBlackTree$Tree__T3 };
function $p_sci_RedBlackTree$___union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree($thiz, t1, t2, ordering) {
  if (((t1 === null) || (t1 === t2))) {
    return t2;
  } else if ((t2 === null)) {
    return t1;
  } else {
    var x1 = $p_sci_RedBlackTree$__split__sci_RedBlackTree$Tree__O__s_math_Ordering__T4($thiz, t1, t2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, ordering);
    if ((x1 === null)) {
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1);
    }
    var l1 = x1.T4__f__1;
    var r1 = x1.T4__f__3;
    var k1 = x1.T4__f__4;
    var tl = $p_sci_RedBlackTree$___union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree($thiz, l1, t2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, ordering);
    var tr = $p_sci_RedBlackTree$___union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree($thiz, r1, t2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, ordering);
    return $thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, k1, t2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, tr);
  }
}
export { $p_sci_RedBlackTree$___union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree as $p_sci_RedBlackTree$___union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree };
function $p_sci_RedBlackTree$___difference__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree($thiz, t1, t2, ordering) {
  if (((t1 === null) || (t2 === null))) {
    return t1;
  } else if ((t1 === t2)) {
    return null;
  } else {
    var x1 = $p_sci_RedBlackTree$__split__sci_RedBlackTree$Tree__O__s_math_Ordering__T4($thiz, t1, t2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, ordering);
    if ((x1 === null)) {
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1);
    }
    var l1 = x1.T4__f__1;
    var r1 = x1.T4__f__3;
    var tl = $p_sci_RedBlackTree$___difference__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree($thiz, l1, t2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, ordering);
    var tr = $p_sci_RedBlackTree$___difference__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree($thiz, r1, t2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, ordering);
    return $thiz.scala$collection$immutable$RedBlackTree$$join2__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, tr);
  }
}
export { $p_sci_RedBlackTree$___difference__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree as $p_sci_RedBlackTree$___difference__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree };
function $p_sci_RedBlackTree$___tail$1__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree) {
  if ((tree === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_ju_NoSuchElementException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_ju_NoSuchElementException(), "empty tree");
  } else {
    var tl = tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    return ((tl === null) ? tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right : ((tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0) ? $p_sci_RedBlackTree$__balLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, $p_sci_RedBlackTree$___tail$1__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tl), tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right) : tree.redWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($p_sci_RedBlackTree$___tail$1__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left))));
  }
}
export { $p_sci_RedBlackTree$___tail$1__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree as $p_sci_RedBlackTree$___tail$1__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree };
function $p_sci_RedBlackTree$__f$1__I__I__I__sc_Iterator__sci_RedBlackTree$Tree($thiz, level, size, maxUsedDepth$1, xs$1) {
  switch (size) {
    case 0: {
      return null;
      break;
    }
    case 1: {
      return $p_sci_RedBlackTree$__mkTree__Z__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, ((level !== maxUsedDepth$1) || (level === 1)), xs$1.next__O(), null, null, null);
      break;
    }
    default: {
      var leftSize = (((((-1) + size) | 0) / 2) | 0);
      var left = $p_sci_RedBlackTree$__f$1__I__I__I__sc_Iterator__sci_RedBlackTree$Tree($thiz, ((1 + level) | 0), leftSize, maxUsedDepth$1, xs$1);
      var x = xs$1.next__O();
      var right = $p_sci_RedBlackTree$__f$1__I__I__I__sc_Iterator__sci_RedBlackTree$Tree($thiz, ((1 + level) | 0), (((((-1) + size) | 0) - leftSize) | 0), maxUsedDepth$1, xs$1);
      return $thiz.BlackTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(x, null, left, right);
    }
  }
}
export { $p_sci_RedBlackTree$__f$1__I__I__I__sc_Iterator__sci_RedBlackTree$Tree as $p_sci_RedBlackTree$__f$1__I__I__I__sc_Iterator__sci_RedBlackTree$Tree };
function $p_sci_RedBlackTree$__f$2__I__I__sc_Iterator__I__sci_RedBlackTree$Tree($thiz, level, size, xs$2, maxUsedDepth$2) {
  switch (size) {
    case 0: {
      return null;
      break;
    }
    case 1: {
      var x1$2 = xs$2.next__O();
      if ((x1$2 === null)) {
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1$2);
      }
      var k = x1$2._1__O();
      var v = x1$2._2__O();
      return $p_sci_RedBlackTree$__mkTree__Z__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, ((level !== maxUsedDepth$2) || (level === 1)), k, v, null, null);
      break;
    }
    default: {
      var leftSize = (((((-1) + size) | 0) / 2) | 0);
      var left = $p_sci_RedBlackTree$__f$2__I__I__sc_Iterator__I__sci_RedBlackTree$Tree($thiz, ((1 + level) | 0), leftSize, xs$2, maxUsedDepth$2);
      var x1$3 = xs$2.next__O();
      if ((x1$3 === null)) {
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1$3);
      }
      var k$3 = x1$3._1__O();
      var v$3 = x1$3._2__O();
      var right = $p_sci_RedBlackTree$__f$2__I__I__sc_Iterator__I__sci_RedBlackTree$Tree($thiz, ((1 + level) | 0), (((((-1) + size) | 0) - leftSize) | 0), xs$2, maxUsedDepth$2);
      return $thiz.BlackTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(k$3, v$3, left, right);
    }
  }
}
export { $p_sci_RedBlackTree$__f$2__I__I__sc_Iterator__I__sci_RedBlackTree$Tree as $p_sci_RedBlackTree$__f$2__I__I__sc_Iterator__I__sci_RedBlackTree$Tree };
function $p_sci_RedBlackTree$__fk$1__sci_RedBlackTree$Tree__F2__sci_RedBlackTree$Tree($thiz, t, f$3) {
  var k = t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
  var v = t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value;
  var l = t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
  var r = t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
  var l2 = ((l === null) ? null : $p_sci_RedBlackTree$__fk$1__sci_RedBlackTree$Tree__F2__sci_RedBlackTree$Tree($thiz, l, f$3));
  var keep = (!(!f$3.apply__O__O__O(k, v)));
  var r2 = ((r === null) ? null : $p_sci_RedBlackTree$__fk$1__sci_RedBlackTree$Tree__F2__sci_RedBlackTree$Tree($thiz, r, f$3));
  return ((!keep) ? $thiz.scala$collection$immutable$RedBlackTree$$join2__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(l2, r2) : (((l2 === l) && (r2 === r)) ? t : $thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(l2, k, v, r2)));
}
export { $p_sci_RedBlackTree$__fk$1__sci_RedBlackTree$Tree__F2__sci_RedBlackTree$Tree as $p_sci_RedBlackTree$__fk$1__sci_RedBlackTree$Tree__F2__sci_RedBlackTree$Tree };
function $p_sci_RedBlackTree$__h$1__sci_RedBlackTree$Tree__I__I($thiz, t, i) {
  while (true) {
    if ((t === null)) {
      return ((1 + i) | 0);
    } else {
      var this$1 = t;
      var temp$t = this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      var this$2 = t;
      if ((this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0)) {
        var temp$i = ((1 + i) | 0);
      } else {
        var temp$i = i;
      }
      t = temp$t;
      i = temp$i;
    }
  }
}
export { $p_sci_RedBlackTree$__h$1__sci_RedBlackTree$Tree__I__I as $p_sci_RedBlackTree$__h$1__sci_RedBlackTree$Tree__I__I };
/** @constructor */
function $c_sci_RedBlackTree$() {
}
export { $c_sci_RedBlackTree$ as $c_sci_RedBlackTree$ };
$c_sci_RedBlackTree$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_sci_RedBlackTree$.prototype.constructor = $c_sci_RedBlackTree$;
/** @constructor */
function $h_sci_RedBlackTree$() {
}
export { $h_sci_RedBlackTree$ as $h_sci_RedBlackTree$ };
$h_sci_RedBlackTree$.prototype = $c_sci_RedBlackTree$.prototype;
$c_sci_RedBlackTree$.prototype.contains__sci_RedBlackTree$Tree__O__s_math_Ordering__Z = (function(tree, x, evidence$1) {
  return (this.lookup__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree(tree, x, evidence$1) !== null);
});
$c_sci_RedBlackTree$.prototype.get__sci_RedBlackTree$Tree__O__s_math_Ordering__s_Option = (function(tree, x, evidence$2) {
  var x1 = this.lookup__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree(tree, x, evidence$2);
  return ((x1 === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$() : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(x1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value));
});
$c_sci_RedBlackTree$.prototype.lookup__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree = (function(tree, x, ordering) {
  while (true) {
    if ((tree === null)) {
      return null;
    } else {
      var this$1 = tree;
      var cmp = ordering.compare__O__O__I(x, this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
      if ((cmp < 0)) {
        var this$2 = tree;
        tree = this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      } else if ((cmp > 0)) {
        var this$3 = tree;
        tree = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      } else {
        return tree;
      }
    }
  }
});
$c_sci_RedBlackTree$.prototype.count__sci_RedBlackTree$Tree__I = (function(tree) {
  return ((tree === null) ? 0 : (2147483647 & tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count));
});
$c_sci_RedBlackTree$.prototype.update__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree = (function(tree, k, v, overwrite, evidence$3) {
  return $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $p_sci_RedBlackTree$__upd__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree(this, tree, k, v, overwrite, evidence$3));
});
$c_sci_RedBlackTree$.prototype.delete__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree = (function(tree, k, evidence$4) {
  return $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $p_sci_RedBlackTree$__del__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree(this, tree, k, evidence$4));
});
$c_sci_RedBlackTree$.prototype.drop__sci_RedBlackTree$Tree__I__s_math_Ordering__sci_RedBlackTree$Tree = (function(tree, n, evidence$10) {
  return $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $p_sci_RedBlackTree$__doDrop__sci_RedBlackTree$Tree__I__sci_RedBlackTree$Tree(this, tree, n));
});
$c_sci_RedBlackTree$.prototype.take__sci_RedBlackTree$Tree__I__s_math_Ordering__sci_RedBlackTree$Tree = (function(tree, n, evidence$11) {
  return $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $p_sci_RedBlackTree$__doTake__sci_RedBlackTree$Tree__I__sci_RedBlackTree$Tree(this, tree, n));
});
$c_sci_RedBlackTree$.prototype.smallest__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tree) {
  if ((tree === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_ju_NoSuchElementException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_ju_NoSuchElementException(), "empty tree");
  }
  var result = tree;
  while (true) {
    var this$1 = result;
    if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left !== null)) {
      var this$2 = result;
      result = this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    } else {
      break;
    }
  }
  return result;
});
$c_sci_RedBlackTree$.prototype.greatest__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tree) {
  if ((tree === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_ju_NoSuchElementException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_ju_NoSuchElementException(), "empty tree");
  }
  var result = tree;
  while (true) {
    var this$1 = result;
    if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right !== null)) {
      var this$2 = result;
      result = this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
    } else {
      break;
    }
  }
  return result;
});
$c_sci_RedBlackTree$.prototype.tail__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tree) {
  return $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $p_sci_RedBlackTree$___tail$1__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, tree));
});
$c_sci_RedBlackTree$.prototype.foreach__sci_RedBlackTree$Tree__F1__V = (function(tree, f) {
  if ((tree !== null)) {
    $p_sci_RedBlackTree$___foreach__sci_RedBlackTree$Tree__F1__V(this, tree, f);
  }
});
$c_sci_RedBlackTree$.prototype.keysEqual__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__Z = (function(a, b, evidence$13) {
  return ((a === b) || ((a !== null) && ((b !== null) && (((2147483647 & a.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === (2147483647 & b.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) && new $c_sci_RedBlackTree$EqualsIterator(a, evidence$13).sameKeys__sci_RedBlackTree$EqualsIterator__Z(new $c_sci_RedBlackTree$EqualsIterator(b, evidence$13))))));
});
$c_sci_RedBlackTree$.prototype.entriesEqual__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__Z = (function(a, b, evidence$15) {
  return ((a === b) || ((a !== null) && ((b !== null) && (((2147483647 & a.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === (2147483647 & b.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) && new $c_sci_RedBlackTree$EqualsIterator(a, evidence$15).sameEntries__sci_RedBlackTree$EqualsIterator__Z(new $c_sci_RedBlackTree$EqualsIterator(b, evidence$15))))));
});
$c_sci_RedBlackTree$.prototype.foreachKey__sci_RedBlackTree$Tree__F1__V = (function(tree, f) {
  if ((tree !== null)) {
    $p_sci_RedBlackTree$___foreachKey__sci_RedBlackTree$Tree__F1__V(this, tree, f);
  }
});
$c_sci_RedBlackTree$.prototype.foreachEntry__sci_RedBlackTree$Tree__F2__V = (function(tree, f) {
  if ((tree !== null)) {
    $p_sci_RedBlackTree$___foreachEntry__sci_RedBlackTree$Tree__F2__V(this, tree, f);
  }
});
$c_sci_RedBlackTree$.prototype.isBlack__sci_RedBlackTree$Tree__Z = (function(tree) {
  return ((tree === null) || (tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0));
});
$c_sci_RedBlackTree$.prototype.RedTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(key, value, left, right) {
  var size = ((1 + ((((left === null) ? 0 : (2147483647 & left.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) + ((right === null) ? 0 : (2147483647 & right.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0);
  return new $c_sci_RedBlackTree$Tree(key, value, left, right, size);
});
$c_sci_RedBlackTree$.prototype.BlackTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(key, value, left, right) {
  var size = ((1 + ((((left === null) ? 0 : (2147483647 & left.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) + ((right === null) ? 0 : (2147483647 & right.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0);
  return new $c_sci_RedBlackTree$Tree(key, value, left, right, ((-2147483648) | size));
});
$c_sci_RedBlackTree$.prototype.fromOrderedKeys__sc_Iterator__I__sci_RedBlackTree$Tree = (function(xs, size) {
  var maxUsedDepth = ((32 - Math.clz32(size)) | 0);
  return $p_sci_RedBlackTree$__f$1__I__I__I__sc_Iterator__sci_RedBlackTree$Tree(this, 1, size, maxUsedDepth, xs);
});
$c_sci_RedBlackTree$.prototype.fromOrderedEntries__sc_Iterator__I__sci_RedBlackTree$Tree = (function(xs, size) {
  var maxUsedDepth = ((32 - Math.clz32(size)) | 0);
  return $p_sci_RedBlackTree$__f$2__I__I__sc_Iterator__I__sci_RedBlackTree$Tree(this, 1, size, xs, maxUsedDepth);
});
$c_sci_RedBlackTree$.prototype.filterEntries__sci_RedBlackTree$Tree__F2__sci_RedBlackTree$Tree = (function(t, f) {
  return ((t === null) ? null : $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $p_sci_RedBlackTree$__fk$1__sci_RedBlackTree$Tree__F2__sci_RedBlackTree$Tree(this, t, f)));
});
$c_sci_RedBlackTree$.prototype.union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree = (function(t1, t2, ordering) {
  return $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $p_sci_RedBlackTree$___union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree(this, t1, t2, ordering));
});
$c_sci_RedBlackTree$.prototype.difference__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree = (function(t1, t2, ordering) {
  return $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $p_sci_RedBlackTree$___difference__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree(this, t1, t2, ordering));
});
$c_sci_RedBlackTree$.prototype.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tl, k, v, tr) {
  var bhtl = $p_sci_RedBlackTree$__h$1__sci_RedBlackTree$Tree__I__I(this, tl, 0);
  var bhtr = $p_sci_RedBlackTree$__h$1__sci_RedBlackTree$Tree__I__I(this, tr, 0);
  if ((bhtl > bhtr)) {
    var tt = $p_sci_RedBlackTree$__joinRight__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__I__I__sci_RedBlackTree$Tree(this, tl, k, v, tr, bhtl, ((tr === null) ? 0 : ((tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0) ? ((((-1) + bhtr) | 0) << 1) : (((-1) + (bhtr << 1)) | 0))));
    if (((tt !== null) && (tt.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
      var tree = tt.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      var $x_1 = ((tree !== null) && (tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return tt.black__sci_RedBlackTree$Tree();
    } else {
      return tt;
    }
  } else if ((bhtr > bhtl)) {
    var tt$2 = $p_sci_RedBlackTree$__joinLeft__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__I__I__sci_RedBlackTree$Tree(this, tl, k, v, tr, ((tl === null) ? 0 : ((tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0) ? ((((-1) + bhtl) | 0) << 1) : (((-1) + (bhtl << 1)) | 0))), bhtr);
    if (((tt$2 !== null) && (tt$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
      var tree$1 = tt$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      var $x_2 = ((tree$1 !== null) && (tree$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      return tt$2.black__sci_RedBlackTree$Tree();
    } else {
      return tt$2;
    }
  } else {
    return $p_sci_RedBlackTree$__mkTree__Z__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, (((tl !== null) && (tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) || ((tr !== null) && (tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))), k, v, tl, tr);
  }
});
$c_sci_RedBlackTree$.prototype.scala$collection$immutable$RedBlackTree$$join2__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tl, tr) {
  if ((tl === null)) {
    return tr;
  } else if ((tr === null)) {
    return tl;
  } else {
    var x1 = $p_sci_RedBlackTree$__splitLast__sci_RedBlackTree$Tree__T3(this, tl);
    if ((x1 === null)) {
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1);
    }
    var ttl = x1.T3__f__1;
    var k = x1.T3__f__2;
    var v = x1.T3__f__3;
    return this.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(ttl, k, v, tr);
  }
});
var $d_sci_RedBlackTree$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sci_RedBlackTree$, "scala.collection.immutable.RedBlackTree$", ({
  sci_RedBlackTree$: 1
}));
export { $d_sci_RedBlackTree$ as $d_sci_RedBlackTree$ };
var $n_sci_RedBlackTree$;
function $m_sci_RedBlackTree$() {
  if ((!$n_sci_RedBlackTree$)) {
    $n_sci_RedBlackTree$ = new $c_sci_RedBlackTree$();
  }
  return $n_sci_RedBlackTree$;
}
export { $m_sci_RedBlackTree$ as $m_sci_RedBlackTree$ };
function $ct_sci_RedBlackTree$Helper__s_math_Ordering__($thiz, ordering) {
  $thiz.sci_RedBlackTree$Helper__f_ordering = ordering;
  return $thiz;
}
export { $ct_sci_RedBlackTree$Helper__s_math_Ordering__ as $ct_sci_RedBlackTree$Helper__s_math_Ordering__ };
/** @constructor */
function $c_sci_RedBlackTree$Helper() {
  this.sci_RedBlackTree$Helper__f_ordering = null;
}
export { $c_sci_RedBlackTree$Helper as $c_sci_RedBlackTree$Helper };
$c_sci_RedBlackTree$Helper.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_sci_RedBlackTree$Helper.prototype.constructor = $c_sci_RedBlackTree$Helper;
/** @constructor */
function $h_sci_RedBlackTree$Helper() {
}
export { $h_sci_RedBlackTree$Helper as $h_sci_RedBlackTree$Helper };
$h_sci_RedBlackTree$Helper.prototype = $c_sci_RedBlackTree$Helper.prototype;
$c_sci_RedBlackTree$Helper.prototype.beforePublish__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tree) {
  if ((tree === null)) {
    return tree;
  } else if (((2147483647 & tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    var res = tree.mutableBlack__sci_RedBlackTree$Tree().makeImmutable__sci_RedBlackTree$Tree();
    return res;
  } else {
    return tree.black__sci_RedBlackTree$Tree();
  }
});
$c_sci_RedBlackTree$Helper.prototype.mutableBalanceLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tree, newLeft) {
  if ((newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) {
    var newLeft_left = newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    var newLeft_right = newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
    if (((newLeft_left !== null) && (newLeft_left.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
      var resultLeft = newLeft_left.mutableBlack__sci_RedBlackTree$Tree();
      var resultRight = tree.mutableBlackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft_right);
      return newLeft.mutableWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft, resultRight);
    } else if (((newLeft_right !== null) && (newLeft_right.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
      var newLeft_right_right = newLeft_right.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      var resultLeft$2 = newLeft.mutableBlackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft_right.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
      var resultRight$2 = tree.mutableBlackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft_right_right);
      return newLeft_right.mutableWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft$2, resultRight$2);
    } else {
      return tree.mutableWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft);
    }
  } else {
    return tree.mutableWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft);
  }
});
$c_sci_RedBlackTree$Helper.prototype.mutableBalanceRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tree, newRight) {
  if ((newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) {
    var newRight_left = newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    if (((newRight_left !== null) && (newRight_left.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
      var resultLeft = tree.mutableBlackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight_left.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
      var resultRight = newRight.mutableBlackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight_left.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
      return newRight_left.mutableWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft, resultRight);
    } else {
      var newRight_right = newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      if (((newRight_right !== null) && (newRight_right.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
        var resultLeft$2 = tree.mutableBlackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight_left);
        var resultRight$2 = newRight_right.mutableBlack__sci_RedBlackTree$Tree();
        return newRight.mutableWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft$2, resultRight$2);
      } else {
        return tree.mutableWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight);
      }
    }
  } else {
    return tree.mutableWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight);
  }
});
function $p_sci_RedBlackTree$Tree__makeImmutableImpl$1__V($thiz) {
  if (((2147483647 & $thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    var size = 1;
    if (($thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left !== null)) {
      $thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left.makeImmutable__sci_RedBlackTree$Tree();
      var $x_1 = size;
      var this$1 = $thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      size = (($x_1 + (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) | 0);
    }
    if (($thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right !== null)) {
      $thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right.makeImmutable__sci_RedBlackTree$Tree();
      var $x_2 = size;
      var this$2 = $thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      size = (($x_2 + (2147483647 & this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) | 0);
    }
    $thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count = ($thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count | size);
  }
}
export { $p_sci_RedBlackTree$Tree__makeImmutableImpl$1__V as $p_sci_RedBlackTree$Tree__makeImmutableImpl$1__V };
/** @constructor */
function $c_sci_RedBlackTree$Tree(_key, _value, _left, _right, _count) {
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key = null;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value = null;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left = null;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right = null;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count = 0;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key = _key;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value = _value;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left = _left;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right = _right;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count = _count;
}
export { $c_sci_RedBlackTree$Tree as $c_sci_RedBlackTree$Tree };
$c_sci_RedBlackTree$Tree.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_sci_RedBlackTree$Tree.prototype.constructor = $c_sci_RedBlackTree$Tree;
/** @constructor */
function $h_sci_RedBlackTree$Tree() {
}
export { $h_sci_RedBlackTree$Tree as $h_sci_RedBlackTree$Tree };
$h_sci_RedBlackTree$Tree.prototype = $c_sci_RedBlackTree$Tree.prototype;
$c_sci_RedBlackTree$Tree.prototype.toString__T = (function() {
  return (((((((((((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0) ? "RedTree" : "BlackTree") + "(") + this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key) + ", ") + this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value) + ", ") + this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left) + ", ") + this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right) + ")");
});
$c_sci_RedBlackTree$Tree.prototype.makeImmutable__sci_RedBlackTree$Tree = (function() {
  $p_sci_RedBlackTree$Tree__makeImmutableImpl$1__V(this);
  return this;
});
$c_sci_RedBlackTree$Tree.prototype.mutableBlack__sci_RedBlackTree$Tree = (function() {
  if ((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0)) {
    return this;
  } else if (((2147483647 & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count = (-2147483648);
    return this;
  } else {
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, (-2147483648));
  }
});
$c_sci_RedBlackTree$Tree.prototype.mutableWithV__O__sci_RedBlackTree$Tree = (function(newValue) {
  if (Object.is(newValue, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value)) {
    return this;
  } else if (((2147483647 & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value = newValue;
    return this;
  } else {
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, newValue, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, ((-2147483648) & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count));
  }
});
$c_sci_RedBlackTree$Tree.prototype.mutableWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft) {
  if ((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left === newLeft)) {
    return this;
  } else if (((2147483647 & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left = newLeft;
    return this;
  } else {
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, ((-2147483648) & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count));
  }
});
$c_sci_RedBlackTree$Tree.prototype.mutableWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newRight) {
  if ((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right === newRight)) {
    return this;
  } else if (((2147483647 & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right = newRight;
    return this;
  } else {
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, newRight, ((-2147483648) & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count));
  }
});
$c_sci_RedBlackTree$Tree.prototype.mutableWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft, newRight) {
  if (((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left === newLeft) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right === newRight))) {
    return this;
  } else if (((2147483647 & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left = newLeft;
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right = newRight;
    return this;
  } else {
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, newRight, ((-2147483648) & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count));
  }
});
$c_sci_RedBlackTree$Tree.prototype.mutableBlackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft) {
  if (((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left === newLeft) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
    return this;
  } else if (((2147483647 & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count = (-2147483648);
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left = newLeft;
    return this;
  } else {
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, (-2147483648));
  }
});
$c_sci_RedBlackTree$Tree.prototype.mutableBlackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newRight) {
  if (((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right === newRight) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
    return this;
  } else if (((2147483647 & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count = (-2147483648);
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right = newRight;
    return this;
  } else {
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, newRight, (-2147483648));
  }
});
$c_sci_RedBlackTree$Tree.prototype.black__sci_RedBlackTree$Tree = (function() {
  return ((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0) ? this : new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, ((-2147483648) ^ this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)));
});
$c_sci_RedBlackTree$Tree.prototype.red__sci_RedBlackTree$Tree = (function() {
  return ((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0) ? this : new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, ((-2147483648) ^ this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)));
});
$c_sci_RedBlackTree$Tree.prototype.withV__O__sci_RedBlackTree$Tree = (function(newValue) {
  return (Object.is(newValue, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value) ? this : new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, newValue, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count));
});
$c_sci_RedBlackTree$Tree.prototype.withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft) {
  if ((newLeft === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left)) {
    return this;
  } else {
    var $x_1 = ((newLeft === null) ? 0 : (2147483647 & newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count));
    var tree = this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
    var size = ((1 + (($x_1 + ((tree === null) ? 0 : (2147483647 & tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, (((-2147483648) & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) | size));
  }
});
$c_sci_RedBlackTree$Tree.prototype.withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newRight) {
  if ((newRight === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)) {
    return this;
  } else {
    var tree = this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    var size = ((1 + ((((tree === null) ? 0 : (2147483647 & tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) + ((newRight === null) ? 0 : (2147483647 & newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, newRight, (((-2147483648) & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) | size));
  }
});
$c_sci_RedBlackTree$Tree.prototype.blackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft) {
  if (((newLeft === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
    return this;
  } else {
    var $x_1 = ((newLeft === null) ? 0 : (2147483647 & newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count));
    var tree = this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
    var size = ((1 + (($x_1 + ((tree === null) ? 0 : (2147483647 & tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, ((-2147483648) | size));
  }
});
$c_sci_RedBlackTree$Tree.prototype.redWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft) {
  if (((newLeft === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
    return this;
  } else {
    var $x_1 = ((newLeft === null) ? 0 : (2147483647 & newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count));
    var tree = this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
    var size = ((1 + (($x_1 + ((tree === null) ? 0 : (2147483647 & tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, size);
  }
});
$c_sci_RedBlackTree$Tree.prototype.blackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newRight) {
  if (((newRight === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
    return this;
  } else {
    var tree = this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    var size = ((1 + ((((tree === null) ? 0 : (2147483647 & tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) + ((newRight === null) ? 0 : (2147483647 & newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, newRight, ((-2147483648) | size));
  }
});
$c_sci_RedBlackTree$Tree.prototype.redWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newRight) {
  if (((newRight === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
    return this;
  } else {
    var tree = this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    var size = ((1 + ((((tree === null) ? 0 : (2147483647 & tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) + ((newRight === null) ? 0 : (2147483647 & newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, newRight, size);
  }
});
$c_sci_RedBlackTree$Tree.prototype.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft, newRight) {
  if (((newLeft === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left) && (newRight === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right))) {
    return this;
  } else {
    var size = ((1 + ((((newLeft === null) ? 0 : (2147483647 & newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) + ((newRight === null) ? 0 : (2147483647 & newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, newRight, (((-2147483648) & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) | size));
  }
});
$c_sci_RedBlackTree$Tree.prototype.redWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft, newRight) {
  if ((((newLeft === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left) && (newRight === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
    return this;
  } else {
    var size = ((1 + ((((newLeft === null) ? 0 : (2147483647 & newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) + ((newRight === null) ? 0 : (2147483647 & newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, newRight, size);
  }
});
$c_sci_RedBlackTree$Tree.prototype.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft, newRight) {
  if ((((newLeft === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left) && (newRight === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
    return this;
  } else {
    var size = ((1 + ((((newLeft === null) ? 0 : (2147483647 & newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) + ((newRight === null) ? 0 : (2147483647 & newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, newRight, ((-2147483648) | size));
  }
});
var $d_sci_RedBlackTree$Tree = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sci_RedBlackTree$Tree, "scala.collection.immutable.RedBlackTree$Tree", ({
  sci_RedBlackTree$Tree: 1
}));
export { $d_sci_RedBlackTree$Tree as $d_sci_RedBlackTree$Tree };
function $p_s_concurrent_BatchingExecutor$AbstractBatch__ensureCapacity__I__Ajl_Runnable($thiz, curSize) {
  var curOther = $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_other;
  var curLen = curOther.u.length;
  if ((curSize <= curLen)) {
    return curOther;
  } else {
    var newLen = ((curLen === 0) ? 4 : (curLen << 1));
    if ((newLen <= curLen)) {
      throw new $c_jl_StackOverflowError(("Space limit of asynchronous stack reached: " + curLen));
    }
    var newOther = new ($d_jl_Runnable.getArrayOf().constr)(newLen);
    curOther.copyTo(0, newOther, 0, curLen);
    $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_other = newOther;
    return newOther;
  }
}
export { $p_s_concurrent_BatchingExecutor$AbstractBatch__ensureCapacity__I__Ajl_Runnable as $p_s_concurrent_BatchingExecutor$AbstractBatch__ensureCapacity__I__Ajl_Runnable };
function $ct_s_concurrent_BatchingExecutor$AbstractBatch__s_concurrent_BatchingExecutor__jl_Runnable__Ajl_Runnable__I__($thiz, outer, first, other, size) {
  $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_first = first;
  $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_other = other;
  $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_size = size;
  $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_$outer = outer;
  return $thiz;
}
export { $ct_s_concurrent_BatchingExecutor$AbstractBatch__s_concurrent_BatchingExecutor__jl_Runnable__Ajl_Runnable__I__ as $ct_s_concurrent_BatchingExecutor$AbstractBatch__s_concurrent_BatchingExecutor__jl_Runnable__Ajl_Runnable__I__ };
/** @constructor */
function $c_s_concurrent_BatchingExecutor$AbstractBatch() {
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_first = null;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_other = null;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_size = 0;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_$outer = null;
}
export { $c_s_concurrent_BatchingExecutor$AbstractBatch as $c_s_concurrent_BatchingExecutor$AbstractBatch };
$c_s_concurrent_BatchingExecutor$AbstractBatch.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_s_concurrent_BatchingExecutor$AbstractBatch.prototype.constructor = $c_s_concurrent_BatchingExecutor$AbstractBatch;
/** @constructor */
function $h_s_concurrent_BatchingExecutor$AbstractBatch() {
}
export { $h_s_concurrent_BatchingExecutor$AbstractBatch as $h_s_concurrent_BatchingExecutor$AbstractBatch };
$h_s_concurrent_BatchingExecutor$AbstractBatch.prototype = $c_s_concurrent_BatchingExecutor$AbstractBatch.prototype;
$c_s_concurrent_BatchingExecutor$AbstractBatch.prototype.push__jl_Runnable__V = (function(r) {
  var sz = this.s_concurrent_BatchingExecutor$AbstractBatch__f_size;
  if ((sz === 0)) {
    this.s_concurrent_BatchingExecutor$AbstractBatch__f_first = r;
  } else {
    $p_s_concurrent_BatchingExecutor$AbstractBatch__ensureCapacity__I__Ajl_Runnable(this, sz).u[(((-1) + sz) | 0)] = r;
  }
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_size = ((1 + sz) | 0);
});
$c_s_concurrent_BatchingExecutor$AbstractBatch.prototype.runN__I__V = (function(n) {
  while (true) {
    if ((n > 0)) {
      var x1 = this.s_concurrent_BatchingExecutor$AbstractBatch__f_size;
      switch (x1) {
        case 0: {
          break;
        }
        case 1: {
          var next = this.s_concurrent_BatchingExecutor$AbstractBatch__f_first;
          this.s_concurrent_BatchingExecutor$AbstractBatch__f_first = null;
          this.s_concurrent_BatchingExecutor$AbstractBatch__f_size = 0;
          next.run__V();
          n = (((-1) + n) | 0);
          continue;
          break;
        }
        default: {
          var o = this.s_concurrent_BatchingExecutor$AbstractBatch__f_other;
          var next$2 = o.u[(((-2) + x1) | 0)];
          o.u[(((-2) + x1) | 0)] = null;
          this.s_concurrent_BatchingExecutor$AbstractBatch__f_size = (((-1) + x1) | 0);
          next$2.run__V();
          n = (((-1) + n) | 0);
          continue;
        }
      }
    }
    return (void 0);
  }
});
/** @constructor */
function $c_s_concurrent_BatchingExecutorStatics$() {
  this.s_concurrent_BatchingExecutorStatics$__f_emptyBatchArray = null;
  $n_s_concurrent_BatchingExecutorStatics$ = this;
  this.s_concurrent_BatchingExecutorStatics$__f_emptyBatchArray = new ($d_jl_Runnable.getArrayOf().constr)(0);
}
export { $c_s_concurrent_BatchingExecutorStatics$ as $c_s_concurrent_BatchingExecutorStatics$ };
$c_s_concurrent_BatchingExecutorStatics$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_s_concurrent_BatchingExecutorStatics$.prototype.constructor = $c_s_concurrent_BatchingExecutorStatics$;
/** @constructor */
function $h_s_concurrent_BatchingExecutorStatics$() {
}
export { $h_s_concurrent_BatchingExecutorStatics$ as $h_s_concurrent_BatchingExecutorStatics$ };
$h_s_concurrent_BatchingExecutorStatics$.prototype = $c_s_concurrent_BatchingExecutorStatics$.prototype;
var $d_s_concurrent_BatchingExecutorStatics$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_s_concurrent_BatchingExecutorStatics$, "scala.concurrent.BatchingExecutorStatics$", ({
  s_concurrent_BatchingExecutorStatics$: 1
}));
export { $d_s_concurrent_BatchingExecutorStatics$ as $d_s_concurrent_BatchingExecutorStatics$ };
var $n_s_concurrent_BatchingExecutorStatics$;
function $m_s_concurrent_BatchingExecutorStatics$() {
  if ((!$n_s_concurrent_BatchingExecutorStatics$)) {
    $n_s_concurrent_BatchingExecutorStatics$ = new $c_s_concurrent_BatchingExecutorStatics$();
  }
  return $n_s_concurrent_BatchingExecutorStatics$;
}
export { $m_s_concurrent_BatchingExecutorStatics$ as $m_s_concurrent_BatchingExecutorStatics$ };
/** @constructor */
function $c_s_concurrent_ExecutionContext$() {
  this.s_concurrent_ExecutionContext$__f_defaultReporter = null;
  $n_s_concurrent_ExecutionContext$ = this;
  this.s_concurrent_ExecutionContext$__f_defaultReporter = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1$2$2) => {
    x$1$2$2.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err);
  }));
}
export { $c_s_concurrent_ExecutionContext$ as $c_s_concurrent_ExecutionContext$ };
$c_s_concurrent_ExecutionContext$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_s_concurrent_ExecutionContext$.prototype.constructor = $c_s_concurrent_ExecutionContext$;
/** @constructor */
function $h_s_concurrent_ExecutionContext$() {
}
export { $h_s_concurrent_ExecutionContext$ as $h_s_concurrent_ExecutionContext$ };
$h_s_concurrent_ExecutionContext$.prototype = $c_s_concurrent_ExecutionContext$.prototype;
var $d_s_concurrent_ExecutionContext$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_s_concurrent_ExecutionContext$, "scala.concurrent.ExecutionContext$", ({
  s_concurrent_ExecutionContext$: 1
}));
export { $d_s_concurrent_ExecutionContext$ as $d_s_concurrent_ExecutionContext$ };
var $n_s_concurrent_ExecutionContext$;
function $m_s_concurrent_ExecutionContext$() {
  if ((!$n_s_concurrent_ExecutionContext$)) {
    $n_s_concurrent_ExecutionContext$ = new $c_s_concurrent_ExecutionContext$();
  }
  return $n_s_concurrent_ExecutionContext$;
}
export { $m_s_concurrent_ExecutionContext$ as $m_s_concurrent_ExecutionContext$ };
/** @constructor */
function $c_s_concurrent_Future$() {
  this.s_concurrent_Future$__f_collectFailed = null;
  this.s_concurrent_Future$__f_filterFailure = null;
  this.s_concurrent_Future$__f_failedFailure = null;
  this.s_concurrent_Future$__f_recoverWithFailedMarker = null;
  this.s_concurrent_Future$__f_recoverWithFailed = null;
  this.s_concurrent_Future$__f__addToBuilderFun = null;
  this.s_concurrent_Future$__f_unit = null;
  $n_s_concurrent_Future$ = this;
  var this$22 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$();
  var x0 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Z.getClassOf(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_jl_Boolean.getClassOf());
  var x1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_B.getClassOf(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_jl_Byte.getClassOf());
  var x2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_C.getClassOf(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_jl_Character.getClassOf());
  var x3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_S.getClassOf(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_jl_Short.getClassOf());
  var x4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_I.getClassOf(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_jl_Integer.getClassOf());
  var x5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_J.getClassOf(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_jl_Long.getClassOf());
  var x6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_F.getClassOf(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_jl_Float.getClassOf());
  var x7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_D.getClassOf(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_jl_Double.getClassOf());
  var x8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_V.getClassOf(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_jl_Void.getClassOf());
  var array = [x0, x1, x2, x3, x4, x5, x6, x7, x8];
  var elems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_WrappedVarArgs(), array);
  this$22.from__sc_IterableOnce__sci_Map(elems);
  this.s_concurrent_Future$__f_collectFailed = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((t$2$2) => {
    throw new $c_s_concurrent_Future$$anon$1(t$2$2);
  }));
  this.s_concurrent_Future$__f_filterFailure = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(new $c_s_concurrent_Future$$anon$2());
  this.s_concurrent_Future$__f_failedFailure = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(new $c_s_concurrent_Future$$anon$3());
  this.fromTry__s_util_Try__s_concurrent_Future(this.s_concurrent_Future$__f_failedFailure);
  this.s_concurrent_Future$__f_recoverWithFailedMarker = this.failed__jl_Throwable__s_concurrent_Future(new $c_s_concurrent_Future$$anon$4());
  this.s_concurrent_Future$__f_recoverWithFailed = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((t$2$2$1) => $m_s_concurrent_Future$().s_concurrent_Future$__f_recoverWithFailedMarker));
  this.s_concurrent_Future$__f__addToBuilderFun = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((b$2$2, e$2$2) => b$2$2.addOne__O__scm_Growable(e$2$2)));
  this.s_concurrent_Future$__f_unit = this.fromTry__s_util_Try__s_concurrent_Future(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success((void 0)));
}
export { $c_s_concurrent_Future$ as $c_s_concurrent_Future$ };
$c_s_concurrent_Future$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_s_concurrent_Future$.prototype.constructor = $c_s_concurrent_Future$;
/** @constructor */
function $h_s_concurrent_Future$() {
}
export { $h_s_concurrent_Future$ as $h_s_concurrent_Future$ };
$h_s_concurrent_Future$.prototype = $c_s_concurrent_Future$.prototype;
$c_s_concurrent_Future$.prototype.failed__jl_Throwable__s_concurrent_Future = (function(exception) {
  return $m_s_concurrent_Promise$().failed__jl_Throwable__s_concurrent_Promise(exception);
});
$c_s_concurrent_Future$.prototype.successful__O__s_concurrent_Future = (function(result) {
  return $m_s_concurrent_Promise$().successful__O__s_concurrent_Promise(result);
});
$c_s_concurrent_Future$.prototype.fromTry__s_util_Try__s_concurrent_Future = (function(result) {
  return $ct_s_concurrent_impl_Promise$DefaultPromise__s_util_Try__(new $c_s_concurrent_impl_Promise$DefaultPromise(), result);
});
$c_s_concurrent_Future$.prototype.apply__F0__s_concurrent_ExecutionContext__s_concurrent_Future = (function(body, executor) {
  return this.s_concurrent_Future$__f_unit.map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$4$2$2) => body.apply__O())), executor);
});
$c_s_concurrent_Future$.prototype.traverse__sc_IterableOnce__F1__sc_BuildFrom__s_concurrent_ExecutionContext__s_concurrent_Future = (function(in$1, fn, bf, executor) {
  var this$1 = in$1.iterator__sc_Iterator();
  var z = this.successful__O__s_concurrent_Future(bf.newBuilder__O__scm_Builder(in$1));
  var f = ((fr$2$2, a$2$2) => fr$2$2.zipWith__s_concurrent_Future__F2__s_concurrent_ExecutionContext__s_concurrent_Future(fn.apply__O__O(a$2$2), $m_s_concurrent_Future$().s_concurrent_Future$__f__addToBuilderFun, executor));
  if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$is_sc_IndexedSeq(this$1)) {
    var at = 0;
    var end = this$1.length__I();
    var acc = z;
    var $x_1;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var x0 = acc;
        var x1 = this$1.apply__I__O(at);
        var temp$acc = f(x0, x1);
        at = temp$at;
        acc = temp$acc;
        continue;
      }
      var $x_1 = acc;
      break;
    }
  } else {
    var result = z;
    while (this$1.hasNext__Z()) {
      var x0$1 = result;
      var x1$1 = this$1.next__O();
      result = f(x0$1, x1$1);
    }
    var $x_1 = result;
  }
  return $x_1.map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$10$2$2) => x$10$2$2.result__O())), ($is_s_concurrent_BatchingExecutor(executor) ? executor : $m_s_concurrent_ExecutionContext$parasitic$()));
});
var $d_s_concurrent_Future$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_s_concurrent_Future$, "scala.concurrent.Future$", ({
  s_concurrent_Future$: 1
}));
export { $d_s_concurrent_Future$ as $d_s_concurrent_Future$ };
var $n_s_concurrent_Future$;
function $m_s_concurrent_Future$() {
  if ((!$n_s_concurrent_Future$)) {
    $n_s_concurrent_Future$ = new $c_s_concurrent_Future$();
  }
  return $n_s_concurrent_Future$;
}
export { $m_s_concurrent_Future$ as $m_s_concurrent_Future$ };
function $f_s_concurrent_Promise__complete__s_util_Try__s_concurrent_Promise($thiz, result) {
  if ($thiz.tryComplete__s_util_Try__Z(result)) {
    return $thiz;
  } else {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalStateException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalStateException(), "Promise already completed.");
  }
}
export { $f_s_concurrent_Promise__complete__s_util_Try__s_concurrent_Promise as $f_s_concurrent_Promise__complete__s_util_Try__s_concurrent_Promise };
function $f_s_concurrent_Promise__success__O__s_concurrent_Promise($thiz, value) {
  var result = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(value);
  return $f_s_concurrent_Promise__complete__s_util_Try__s_concurrent_Promise($thiz, result);
}
export { $f_s_concurrent_Promise__success__O__s_concurrent_Promise as $f_s_concurrent_Promise__success__O__s_concurrent_Promise };
function $f_s_concurrent_Promise__failure__jl_Throwable__s_concurrent_Promise($thiz, cause) {
  var result = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(cause);
  return $f_s_concurrent_Promise__complete__s_util_Try__s_concurrent_Promise($thiz, result);
}
export { $f_s_concurrent_Promise__failure__jl_Throwable__s_concurrent_Promise as $f_s_concurrent_Promise__failure__jl_Throwable__s_concurrent_Promise };
/** @constructor */
function $c_s_concurrent_Promise$() {
}
export { $c_s_concurrent_Promise$ as $c_s_concurrent_Promise$ };
$c_s_concurrent_Promise$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_s_concurrent_Promise$.prototype.constructor = $c_s_concurrent_Promise$;
/** @constructor */
function $h_s_concurrent_Promise$() {
}
export { $h_s_concurrent_Promise$ as $h_s_concurrent_Promise$ };
$h_s_concurrent_Promise$.prototype = $c_s_concurrent_Promise$.prototype;
$c_s_concurrent_Promise$.prototype.failed__jl_Throwable__s_concurrent_Promise = (function(exception) {
  var result = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(exception);
  return $ct_s_concurrent_impl_Promise$DefaultPromise__s_util_Try__(new $c_s_concurrent_impl_Promise$DefaultPromise(), result);
});
$c_s_concurrent_Promise$.prototype.successful__O__s_concurrent_Promise = (function(result) {
  var result$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(result);
  return $ct_s_concurrent_impl_Promise$DefaultPromise__s_util_Try__(new $c_s_concurrent_impl_Promise$DefaultPromise(), result$1);
});
var $d_s_concurrent_Promise$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_s_concurrent_Promise$, "scala.concurrent.Promise$", ({
  s_concurrent_Promise$: 1
}));
export { $d_s_concurrent_Promise$ as $d_s_concurrent_Promise$ };
var $n_s_concurrent_Promise$;
function $m_s_concurrent_Promise$() {
  if ((!$n_s_concurrent_Promise$)) {
    $n_s_concurrent_Promise$ = new $c_s_concurrent_Promise$();
  }
  return $n_s_concurrent_Promise$;
}
export { $m_s_concurrent_Promise$ as $m_s_concurrent_Promise$ };
/** @constructor */
function $c_s_concurrent_impl_Promise$() {
  this.s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop = null;
  $n_s_concurrent_impl_Promise$ = this;
  this.s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop = $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 0, null, $m_s_concurrent_ExecutionContext$parasitic$());
}
export { $c_s_concurrent_impl_Promise$ as $c_s_concurrent_impl_Promise$ };
$c_s_concurrent_impl_Promise$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_s_concurrent_impl_Promise$.prototype.constructor = $c_s_concurrent_impl_Promise$;
/** @constructor */
function $h_s_concurrent_impl_Promise$() {
}
export { $h_s_concurrent_impl_Promise$ as $h_s_concurrent_impl_Promise$ };
$h_s_concurrent_impl_Promise$.prototype = $c_s_concurrent_impl_Promise$.prototype;
$c_s_concurrent_impl_Promise$.prototype.scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try = (function(value) {
  if ((value === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  if ((value instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success)) {
    return value;
  } else {
    var t = value.s_util_Failure__f_exception;
    return ((((t instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_control_ControlThrowable) || false) || (t instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Error)) ? ((t instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_NonLocalReturnControl) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(t.sr_NonLocalReturnControl__f_value) : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(new $c_ju_concurrent_ExecutionException("Boxed Exception", t))) : value);
  }
});
var $d_s_concurrent_impl_Promise$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_s_concurrent_impl_Promise$, "scala.concurrent.impl.Promise$", ({
  s_concurrent_impl_Promise$: 1
}));
export { $d_s_concurrent_impl_Promise$ as $d_s_concurrent_impl_Promise$ };
var $n_s_concurrent_impl_Promise$;
function $m_s_concurrent_impl_Promise$() {
  if ((!$n_s_concurrent_impl_Promise$)) {
    $n_s_concurrent_impl_Promise$ = new $c_s_concurrent_impl_Promise$();
  }
  return $n_s_concurrent_impl_Promise$;
}
export { $m_s_concurrent_impl_Promise$ as $m_s_concurrent_impl_Promise$ };
function $is_s_concurrent_impl_Promise$Callbacks(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_concurrent_impl_Promise$Callbacks)));
}
export { $is_s_concurrent_impl_Promise$Callbacks as $is_s_concurrent_impl_Promise$Callbacks };
function $isArrayOf_s_concurrent_impl_Promise$Callbacks(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_impl_Promise$Callbacks)));
}
export { $isArrayOf_s_concurrent_impl_Promise$Callbacks as $isArrayOf_s_concurrent_impl_Promise$Callbacks };
/** @constructor */
function $c_s_package$$hash$colon$colon$() {
}
export { $c_s_package$$hash$colon$colon$ as $c_s_package$$hash$colon$colon$ };
$c_s_package$$hash$colon$colon$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_s_package$$hash$colon$colon$.prototype.constructor = $c_s_package$$hash$colon$colon$;
/** @constructor */
function $h_s_package$$hash$colon$colon$() {
}
export { $h_s_package$$hash$colon$colon$ as $h_s_package$$hash$colon$colon$ };
$h_s_package$$hash$colon$colon$.prototype = $c_s_package$$hash$colon$colon$.prototype;
$c_s_package$$hash$colon$colon$.prototype.unapply__sci_Stream__s_Option = (function(s) {
  return ((!s.isEmpty__Z()) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), s.head__O(), s.tail__O())) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
var $d_s_package$$hash$colon$colon$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_s_package$$hash$colon$colon$, "scala.package$$hash$colon$colon$", ({
  s_package$$hash$colon$colon$: 1
}));
export { $d_s_package$$hash$colon$colon$ as $d_s_package$$hash$colon$colon$ };
var $n_s_package$$hash$colon$colon$;
function $m_s_package$$hash$colon$colon$() {
  if ((!$n_s_package$$hash$colon$colon$)) {
    $n_s_package$$hash$colon$colon$ = new $c_s_package$$hash$colon$colon$();
  }
  return $n_s_package$$hash$colon$colon$;
}
export { $m_s_package$$hash$colon$colon$ as $m_s_package$$hash$colon$colon$ };
function $p_s_reflect_NameTransformer$__enterOp__C__T__V($thiz, op, code) {
  $thiz.s_reflect_NameTransformer$__f_op2code.u[op] = code;
  var c = (((-97) + ((Math.imul(26, (((-97) + code.charCodeAt(1)) | 0)) + code.charCodeAt(2)) | 0)) | 0);
  $thiz.s_reflect_NameTransformer$__f_code2op.u[c] = new $c_s_reflect_NameTransformer$OpCodes(op, code, $thiz.s_reflect_NameTransformer$__f_code2op.u[c]);
}
export { $p_s_reflect_NameTransformer$__enterOp__C__T__V as $p_s_reflect_NameTransformer$__enterOp__C__T__V };
/** @constructor */
function $c_s_reflect_NameTransformer$() {
  this.s_reflect_NameTransformer$__f_nops = 0;
  this.s_reflect_NameTransformer$__f_ncodes = 0;
  this.s_reflect_NameTransformer$__f_op2code = null;
  this.s_reflect_NameTransformer$__f_code2op = null;
  $n_s_reflect_NameTransformer$ = this;
  this.s_reflect_NameTransformer$__f_nops = 128;
  this.s_reflect_NameTransformer$__f_ncodes = 676;
  this.s_reflect_NameTransformer$__f_op2code = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(this.s_reflect_NameTransformer$__f_nops);
  this.s_reflect_NameTransformer$__f_code2op = new ($d_s_reflect_NameTransformer$OpCodes.getArrayOf().constr)(this.s_reflect_NameTransformer$__f_ncodes);
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 126, "$tilde");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 61, "$eq");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 60, "$less");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 62, "$greater");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 33, "$bang");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 35, "$hash");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 37, "$percent");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 94, "$up");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 38, "$amp");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 124, "$bar");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 42, "$times");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 47, "$div");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 43, "$plus");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 45, "$minus");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 58, "$colon");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 92, "$bslash");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 63, "$qmark");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 64, "$at");
}
export { $c_s_reflect_NameTransformer$ as $c_s_reflect_NameTransformer$ };
$c_s_reflect_NameTransformer$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_s_reflect_NameTransformer$.prototype.constructor = $c_s_reflect_NameTransformer$;
/** @constructor */
function $h_s_reflect_NameTransformer$() {
}
export { $h_s_reflect_NameTransformer$ as $h_s_reflect_NameTransformer$ };
$h_s_reflect_NameTransformer$.prototype = $c_s_reflect_NameTransformer$.prototype;
$c_s_reflect_NameTransformer$.prototype.decode__T__T = (function(name0) {
  var name = ((!(!name0.endsWith("<init>"))) ? ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_StringOps$().stripSuffix$extension__T__T__T(name0, "<init>") + "this") : name0);
  var buf = null;
  var len = name.length;
  var i = 0;
  while ((i < len)) {
    var ops = null;
    var unicode = false;
    var index = i;
    var c = name.charCodeAt(index);
    if (((c === 36) && (((2 + i) | 0) < len))) {
      var index$1 = ((1 + i) | 0);
      var ch1 = name.charCodeAt(index$1);
      if (((ch1 >= 97) && (ch1 <= 122))) {
        var index$2 = ((2 + i) | 0);
        var ch2 = name.charCodeAt(index$2);
        if (((ch2 >= 97) && (ch2 <= 122))) {
          ops = this.s_reflect_NameTransformer$__f_code2op.u[(((-97) + ((Math.imul(26, (((-97) + ch1) | 0)) + ch2) | 0)) | 0)];
          while (true) {
            if ((ops !== null)) {
              var prefix = ops.s_reflect_NameTransformer$OpCodes__f_code;
              var toffset = i;
              var $x_1 = (!(((toffset <= name.length) && (toffset >= 0)) && (!(!name.startsWith(prefix, toffset)))));
            } else {
              var $x_1 = false;
            }
            if ($x_1) {
              ops = ops.s_reflect_NameTransformer$OpCodes__f_next;
            } else {
              break;
            }
          }
          if ((ops !== null)) {
            if ((buf === null)) {
              buf = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_scm_StringBuilder__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_StringBuilder());
              var $x_2 = buf;
              var endIndex = i;
              $x_2.append__T__scm_StringBuilder(name.substring(0, endIndex));
            }
            buf.append__C__scm_StringBuilder(ops.s_reflect_NameTransformer$OpCodes__f_op);
            var $x_3 = i;
            var this$2 = ops.s_reflect_NameTransformer$OpCodes__f_code;
            i = (($x_3 + this$2.length) | 0);
          }
        } else {
          if (((((len - i) | 0) >= 6) && (ch1 === 117))) {
            var this$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$();
            if (this$3.isDigit__I__Z(ch2)) {
              var $x_4 = true;
            } else {
              var $x_4 = ((ch2 >= 65) && (ch2 <= 70));
            }
          } else {
            var $x_4 = false;
          }
          if ($x_4) {
            var beginIndex = ((2 + i) | 0);
            var endIndex$1 = ((6 + i) | 0);
            var hex = name.substring(beginIndex, endIndex$1);
            try {
              var this$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Integer$();
              var str = (65535 & this$4.java$lang$Integer$$parseIntImpl__T__I__I__I(hex, 16, 134217728));
              if ((buf === null)) {
                buf = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_scm_StringBuilder__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_StringBuilder());
                var $x_5 = buf;
                var endIndex$2 = i;
                $x_5.append__T__scm_StringBuilder(name.substring(0, endIndex$2));
              }
              buf.append__C__scm_StringBuilder(str);
              i = ((6 + i) | 0);
              unicode = true;
            } catch (e) {
              if ((!(e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NumberFormatException))) {
                throw e;
              }
            }
          }
        }
      }
    }
    if (((ops === null) && (!unicode))) {
      if ((buf !== null)) {
        buf.append__C__scm_StringBuilder(c);
      }
      i = ((1 + i) | 0);
    }
  }
  if ((buf === null)) {
    return name;
  } else {
    var this$6 = buf;
    return this$6.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  }
});
var $d_s_reflect_NameTransformer$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_s_reflect_NameTransformer$, "scala.reflect.NameTransformer$", ({
  s_reflect_NameTransformer$: 1
}));
export { $d_s_reflect_NameTransformer$ as $d_s_reflect_NameTransformer$ };
var $n_s_reflect_NameTransformer$;
function $m_s_reflect_NameTransformer$() {
  if ((!$n_s_reflect_NameTransformer$)) {
    $n_s_reflect_NameTransformer$ = new $c_s_reflect_NameTransformer$();
  }
  return $n_s_reflect_NameTransformer$;
}
export { $m_s_reflect_NameTransformer$ as $m_s_reflect_NameTransformer$ };
/** @constructor */
function $c_s_reflect_NameTransformer$OpCodes(op, code, next) {
  this.s_reflect_NameTransformer$OpCodes__f_op = 0;
  this.s_reflect_NameTransformer$OpCodes__f_code = null;
  this.s_reflect_NameTransformer$OpCodes__f_next = null;
  this.s_reflect_NameTransformer$OpCodes__f_op = op;
  this.s_reflect_NameTransformer$OpCodes__f_code = code;
  this.s_reflect_NameTransformer$OpCodes__f_next = next;
}
export { $c_s_reflect_NameTransformer$OpCodes as $c_s_reflect_NameTransformer$OpCodes };
$c_s_reflect_NameTransformer$OpCodes.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_s_reflect_NameTransformer$OpCodes.prototype.constructor = $c_s_reflect_NameTransformer$OpCodes;
/** @constructor */
function $h_s_reflect_NameTransformer$OpCodes() {
}
export { $h_s_reflect_NameTransformer$OpCodes as $h_s_reflect_NameTransformer$OpCodes };
$h_s_reflect_NameTransformer$OpCodes.prototype = $c_s_reflect_NameTransformer$OpCodes.prototype;
var $d_s_reflect_NameTransformer$OpCodes = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_s_reflect_NameTransformer$OpCodes, "scala.reflect.NameTransformer$OpCodes", ({
  s_reflect_NameTransformer$OpCodes: 1
}));
export { $d_s_reflect_NameTransformer$OpCodes as $d_s_reflect_NameTransformer$OpCodes };
/** @constructor */
function $c_sjs_concurrent_JSExecutionContext$() {
  this.sjs_concurrent_JSExecutionContext$__f_queue = null;
  $n_sjs_concurrent_JSExecutionContext$ = this;
  this.sjs_concurrent_JSExecutionContext$__f_queue = $m_sjs_concurrent_QueueExecutionContext$().apply__s_concurrent_ExecutionContextExecutor();
}
export { $c_sjs_concurrent_JSExecutionContext$ as $c_sjs_concurrent_JSExecutionContext$ };
$c_sjs_concurrent_JSExecutionContext$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_sjs_concurrent_JSExecutionContext$.prototype.constructor = $c_sjs_concurrent_JSExecutionContext$;
/** @constructor */
function $h_sjs_concurrent_JSExecutionContext$() {
}
export { $h_sjs_concurrent_JSExecutionContext$ as $h_sjs_concurrent_JSExecutionContext$ };
$h_sjs_concurrent_JSExecutionContext$.prototype = $c_sjs_concurrent_JSExecutionContext$.prototype;
var $d_sjs_concurrent_JSExecutionContext$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sjs_concurrent_JSExecutionContext$, "scala.scalajs.concurrent.JSExecutionContext$", ({
  sjs_concurrent_JSExecutionContext$: 1
}));
export { $d_sjs_concurrent_JSExecutionContext$ as $d_sjs_concurrent_JSExecutionContext$ };
var $n_sjs_concurrent_JSExecutionContext$;
function $m_sjs_concurrent_JSExecutionContext$() {
  if ((!$n_sjs_concurrent_JSExecutionContext$)) {
    $n_sjs_concurrent_JSExecutionContext$ = new $c_sjs_concurrent_JSExecutionContext$();
  }
  return $n_sjs_concurrent_JSExecutionContext$;
}
export { $m_sjs_concurrent_JSExecutionContext$ as $m_sjs_concurrent_JSExecutionContext$ };
/** @constructor */
function $c_sjs_concurrent_JSExecutionContext$Implicits$() {
  this.sjs_concurrent_JSExecutionContext$Implicits$__f_queue = null;
  $n_sjs_concurrent_JSExecutionContext$Implicits$ = this;
  this.sjs_concurrent_JSExecutionContext$Implicits$__f_queue = $m_sjs_concurrent_JSExecutionContext$().sjs_concurrent_JSExecutionContext$__f_queue;
}
export { $c_sjs_concurrent_JSExecutionContext$Implicits$ as $c_sjs_concurrent_JSExecutionContext$Implicits$ };
$c_sjs_concurrent_JSExecutionContext$Implicits$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_sjs_concurrent_JSExecutionContext$Implicits$.prototype.constructor = $c_sjs_concurrent_JSExecutionContext$Implicits$;
/** @constructor */
function $h_sjs_concurrent_JSExecutionContext$Implicits$() {
}
export { $h_sjs_concurrent_JSExecutionContext$Implicits$ as $h_sjs_concurrent_JSExecutionContext$Implicits$ };
$h_sjs_concurrent_JSExecutionContext$Implicits$.prototype = $c_sjs_concurrent_JSExecutionContext$Implicits$.prototype;
var $d_sjs_concurrent_JSExecutionContext$Implicits$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sjs_concurrent_JSExecutionContext$Implicits$, "scala.scalajs.concurrent.JSExecutionContext$Implicits$", ({
  sjs_concurrent_JSExecutionContext$Implicits$: 1
}));
export { $d_sjs_concurrent_JSExecutionContext$Implicits$ as $d_sjs_concurrent_JSExecutionContext$Implicits$ };
var $n_sjs_concurrent_JSExecutionContext$Implicits$;
function $m_sjs_concurrent_JSExecutionContext$Implicits$() {
  if ((!$n_sjs_concurrent_JSExecutionContext$Implicits$)) {
    $n_sjs_concurrent_JSExecutionContext$Implicits$ = new $c_sjs_concurrent_JSExecutionContext$Implicits$();
  }
  return $n_sjs_concurrent_JSExecutionContext$Implicits$;
}
export { $m_sjs_concurrent_JSExecutionContext$Implicits$ as $m_sjs_concurrent_JSExecutionContext$Implicits$ };
/** @constructor */
function $c_sjs_concurrent_QueueExecutionContext$() {
}
export { $c_sjs_concurrent_QueueExecutionContext$ as $c_sjs_concurrent_QueueExecutionContext$ };
$c_sjs_concurrent_QueueExecutionContext$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_sjs_concurrent_QueueExecutionContext$.prototype.constructor = $c_sjs_concurrent_QueueExecutionContext$;
/** @constructor */
function $h_sjs_concurrent_QueueExecutionContext$() {
}
export { $h_sjs_concurrent_QueueExecutionContext$ as $h_sjs_concurrent_QueueExecutionContext$ };
$h_sjs_concurrent_QueueExecutionContext$.prototype = $c_sjs_concurrent_QueueExecutionContext$.prototype;
$c_sjs_concurrent_QueueExecutionContext$.prototype.apply__s_concurrent_ExecutionContextExecutor = (function() {
  return (((typeof Promise) === "undefined") ? new $c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext() : new $c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext());
});
var $d_sjs_concurrent_QueueExecutionContext$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sjs_concurrent_QueueExecutionContext$, "scala.scalajs.concurrent.QueueExecutionContext$", ({
  sjs_concurrent_QueueExecutionContext$: 1
}));
export { $d_sjs_concurrent_QueueExecutionContext$ as $d_sjs_concurrent_QueueExecutionContext$ };
var $n_sjs_concurrent_QueueExecutionContext$;
function $m_sjs_concurrent_QueueExecutionContext$() {
  if ((!$n_sjs_concurrent_QueueExecutionContext$)) {
    $n_sjs_concurrent_QueueExecutionContext$ = new $c_sjs_concurrent_QueueExecutionContext$();
  }
  return $n_sjs_concurrent_QueueExecutionContext$;
}
export { $m_sjs_concurrent_QueueExecutionContext$ as $m_sjs_concurrent_QueueExecutionContext$ };
/** @constructor */
function $c_sjs_js_ArrayOps$() {
}
export { $c_sjs_js_ArrayOps$ as $c_sjs_js_ArrayOps$ };
$c_sjs_js_ArrayOps$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_sjs_js_ArrayOps$.prototype.constructor = $c_sjs_js_ArrayOps$;
/** @constructor */
function $h_sjs_js_ArrayOps$() {
}
export { $h_sjs_js_ArrayOps$ as $h_sjs_js_ArrayOps$ };
$h_sjs_js_ArrayOps$.prototype = $c_sjs_js_ArrayOps$.prototype;
$c_sjs_js_ArrayOps$.prototype.indexOf$extension__sjs_js_Array__O__I__I = (function(this$, elem, from) {
  var len = (this$.length | 0);
  var i = from;
  while ((i < len)) {
    var x0 = this$[i];
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(elem, x0)) {
      return i;
    }
    i = ((1 + i) | 0);
  }
  return (-1);
});
$c_sjs_js_ArrayOps$.prototype.contains$extension__sjs_js_Array__O__Z = (function(this$, elem) {
  return ($m_sjs_js_ArrayOps$().indexOf$extension__sjs_js_Array__O__I__I(this$, elem, 0) >= 0);
});
var $d_sjs_js_ArrayOps$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sjs_js_ArrayOps$, "scala.scalajs.js.ArrayOps$", ({
  sjs_js_ArrayOps$: 1
}));
export { $d_sjs_js_ArrayOps$ as $d_sjs_js_ArrayOps$ };
var $n_sjs_js_ArrayOps$;
function $m_sjs_js_ArrayOps$() {
  if ((!$n_sjs_js_ArrayOps$)) {
    $n_sjs_js_ArrayOps$ = new $c_sjs_js_ArrayOps$();
  }
  return $n_sjs_js_ArrayOps$;
}
export { $m_sjs_js_ArrayOps$ as $m_sjs_js_ArrayOps$ };
/** @constructor */
function $c_sjs_js_Dynamic$() {
}
export { $c_sjs_js_Dynamic$ as $c_sjs_js_Dynamic$ };
$c_sjs_js_Dynamic$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_sjs_js_Dynamic$.prototype.constructor = $c_sjs_js_Dynamic$;
/** @constructor */
function $h_sjs_js_Dynamic$() {
}
export { $h_sjs_js_Dynamic$ as $h_sjs_js_Dynamic$ };
$h_sjs_js_Dynamic$.prototype = $c_sjs_js_Dynamic$.prototype;
var $d_sjs_js_Dynamic$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sjs_js_Dynamic$, "scala.scalajs.js.Dynamic$", ({
  sjs_js_Dynamic$: 1
}));
export { $d_sjs_js_Dynamic$ as $d_sjs_js_Dynamic$ };
var $n_sjs_js_Dynamic$;
function $m_sjs_js_Dynamic$() {
  if ((!$n_sjs_js_Dynamic$)) {
    $n_sjs_js_Dynamic$ = new $c_sjs_js_Dynamic$();
  }
  return $n_sjs_js_Dynamic$;
}
export { $m_sjs_js_Dynamic$ as $m_sjs_js_Dynamic$ };
/** @constructor */
function $c_sjs_js_Thenable$ThenableOps$() {
}
export { $c_sjs_js_Thenable$ThenableOps$ as $c_sjs_js_Thenable$ThenableOps$ };
$c_sjs_js_Thenable$ThenableOps$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_sjs_js_Thenable$ThenableOps$.prototype.constructor = $c_sjs_js_Thenable$ThenableOps$;
/** @constructor */
function $h_sjs_js_Thenable$ThenableOps$() {
}
export { $h_sjs_js_Thenable$ThenableOps$ as $h_sjs_js_Thenable$ThenableOps$ };
$h_sjs_js_Thenable$ThenableOps$.prototype = $c_sjs_js_Thenable$ThenableOps$.prototype;
$c_sjs_js_Thenable$ThenableOps$.prototype.toFuture$extension__sjs_js_Thenable__s_concurrent_Future = (function(this$) {
  var p2 = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
  this$.then(((arg1$2) => {
    $f_s_concurrent_Promise__success__O__s_concurrent_Promise(p2, arg1$2);
  }), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sjs_js_defined$().apply__O__sjs_js_$bar(((arg1$2$1) => {
    var cause = ((arg1$2$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? arg1$2$1 : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(arg1$2$1));
    $f_s_concurrent_Promise__failure__jl_Throwable__s_concurrent_Promise(p2, cause);
  })));
  return p2;
});
var $d_sjs_js_Thenable$ThenableOps$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sjs_js_Thenable$ThenableOps$, "scala.scalajs.js.Thenable$ThenableOps$", ({
  sjs_js_Thenable$ThenableOps$: 1
}));
export { $d_sjs_js_Thenable$ThenableOps$ as $d_sjs_js_Thenable$ThenableOps$ };
var $n_sjs_js_Thenable$ThenableOps$;
function $m_sjs_js_Thenable$ThenableOps$() {
  if ((!$n_sjs_js_Thenable$ThenableOps$)) {
    $n_sjs_js_Thenable$ThenableOps$ = new $c_sjs_js_Thenable$ThenableOps$();
  }
  return $n_sjs_js_Thenable$ThenableOps$;
}
export { $m_sjs_js_Thenable$ThenableOps$ as $m_sjs_js_Thenable$ThenableOps$ };
/** @constructor */
function $c_sjs_js_WrappedDictionary$Cache$() {
  this.sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty = null;
  $n_sjs_js_WrappedDictionary$Cache$ = this;
  this.sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty = Object.prototype.hasOwnProperty;
}
export { $c_sjs_js_WrappedDictionary$Cache$ as $c_sjs_js_WrappedDictionary$Cache$ };
$c_sjs_js_WrappedDictionary$Cache$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_sjs_js_WrappedDictionary$Cache$.prototype.constructor = $c_sjs_js_WrappedDictionary$Cache$;
/** @constructor */
function $h_sjs_js_WrappedDictionary$Cache$() {
}
export { $h_sjs_js_WrappedDictionary$Cache$ as $h_sjs_js_WrappedDictionary$Cache$ };
$h_sjs_js_WrappedDictionary$Cache$.prototype = $c_sjs_js_WrappedDictionary$Cache$.prototype;
var $d_sjs_js_WrappedDictionary$Cache$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sjs_js_WrappedDictionary$Cache$, "scala.scalajs.js.WrappedDictionary$Cache$", ({
  sjs_js_WrappedDictionary$Cache$: 1
}));
export { $d_sjs_js_WrappedDictionary$Cache$ as $d_sjs_js_WrappedDictionary$Cache$ };
var $n_sjs_js_WrappedDictionary$Cache$;
function $m_sjs_js_WrappedDictionary$Cache$() {
  if ((!$n_sjs_js_WrappedDictionary$Cache$)) {
    $n_sjs_js_WrappedDictionary$Cache$ = new $c_sjs_js_WrappedDictionary$Cache$();
  }
  return $n_sjs_js_WrappedDictionary$Cache$;
}
export { $m_sjs_js_WrappedDictionary$Cache$ as $m_sjs_js_WrappedDictionary$Cache$ };
/** @constructor */
function $c_sjs_js_special_package$() {
}
export { $c_sjs_js_special_package$ as $c_sjs_js_special_package$ };
$c_sjs_js_special_package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_sjs_js_special_package$.prototype.constructor = $c_sjs_js_special_package$;
/** @constructor */
function $h_sjs_js_special_package$() {
}
export { $h_sjs_js_special_package$ as $h_sjs_js_special_package$ };
$h_sjs_js_special_package$.prototype = $c_sjs_js_special_package$.prototype;
$c_sjs_js_special_package$.prototype.objectLiteral__sci_Seq__sjs_js_Object = (function(properties) {
  var result = ({});
  properties.foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((pair$2$2) => {
    result[pair$2$2._1__O()] = pair$2$2._2__O();
  })));
  return result;
});
var $d_sjs_js_special_package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sjs_js_special_package$, "scala.scalajs.js.special.package$", ({
  sjs_js_special_package$: 1
}));
export { $d_sjs_js_special_package$ as $d_sjs_js_special_package$ };
var $n_sjs_js_special_package$;
function $m_sjs_js_special_package$() {
  if ((!$n_sjs_js_special_package$)) {
    $n_sjs_js_special_package$ = new $c_sjs_js_special_package$();
  }
  return $n_sjs_js_special_package$;
}
export { $m_sjs_js_special_package$ as $m_sjs_js_special_package$ };
/** @constructor */
function $c_s_util_Either$MergeableEither$() {
}
export { $c_s_util_Either$MergeableEither$ as $c_s_util_Either$MergeableEither$ };
$c_s_util_Either$MergeableEither$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_s_util_Either$MergeableEither$.prototype.constructor = $c_s_util_Either$MergeableEither$;
/** @constructor */
function $h_s_util_Either$MergeableEither$() {
}
export { $h_s_util_Either$MergeableEither$ as $h_s_util_Either$MergeableEither$ };
$h_s_util_Either$MergeableEither$.prototype = $c_s_util_Either$MergeableEither$.prototype;
$c_s_util_Either$MergeableEither$.prototype.merge$extension__s_util_Either__O = (function(this$) {
  if ((this$ instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
    var a = this$.s_util_Right__f_value;
    return a;
  } else if ((this$ instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
    var a$2 = this$.s_util_Left__f_value;
    return a$2;
  } else {
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this$);
  }
});
var $d_s_util_Either$MergeableEither$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_s_util_Either$MergeableEither$, "scala.util.Either$MergeableEither$", ({
  s_util_Either$MergeableEither$: 1
}));
export { $d_s_util_Either$MergeableEither$ as $d_s_util_Either$MergeableEither$ };
var $n_s_util_Either$MergeableEither$;
function $m_s_util_Either$MergeableEither$() {
  if ((!$n_s_util_Either$MergeableEither$)) {
    $n_s_util_Either$MergeableEither$ = new $c_s_util_Either$MergeableEither$();
  }
  return $n_s_util_Either$MergeableEither$;
}
export { $m_s_util_Either$MergeableEither$ as $m_s_util_Either$MergeableEither$ };
/** @constructor */
function $c_s_util_NotGiven() {
}
export { $c_s_util_NotGiven as $c_s_util_NotGiven };
$c_s_util_NotGiven.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_s_util_NotGiven.prototype.constructor = $c_s_util_NotGiven;
/** @constructor */
function $h_s_util_NotGiven() {
}
export { $h_s_util_NotGiven as $h_s_util_NotGiven };
$h_s_util_NotGiven.prototype = $c_s_util_NotGiven.prototype;
var $d_s_util_NotGiven = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_s_util_NotGiven, "scala.util.NotGiven", ({
  s_util_NotGiven: 1
}));
export { $d_s_util_NotGiven as $d_s_util_NotGiven };
function $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable($thiz) {
  var this$1 = $m_s_util_control_NoStackTrace$();
  if (this$1.s_util_control_NoStackTrace$__f__noSuppression) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable.prototype.fillInStackTrace__jl_Throwable.call($thiz);
  } else {
    return $thiz;
  }
}
export { $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable as $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable };
/** @constructor */
function $c_Lshapeless3_deriving_internals_ErasedProductInstances$() {
  this.Lshapeless3_deriving_internals_ErasedProductInstances$__f_emptyArray = null;
  $n_Lshapeless3_deriving_internals_ErasedProductInstances$ = this;
  var dimensions = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I(new Int32Array([0]));
  this.Lshapeless3_deriving_internals_ErasedProductInstances$__f_emptyArray = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_reflect_Array$().newInstance__jl_Class__AI__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_O.getClassOf(), dimensions);
}
export { $c_Lshapeless3_deriving_internals_ErasedProductInstances$ as $c_Lshapeless3_deriving_internals_ErasedProductInstances$ };
$c_Lshapeless3_deriving_internals_ErasedProductInstances$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lshapeless3_deriving_internals_ErasedProductInstances$.prototype.constructor = $c_Lshapeless3_deriving_internals_ErasedProductInstances$;
/** @constructor */
function $h_Lshapeless3_deriving_internals_ErasedProductInstances$() {
}
export { $h_Lshapeless3_deriving_internals_ErasedProductInstances$ as $h_Lshapeless3_deriving_internals_ErasedProductInstances$ };
$h_Lshapeless3_deriving_internals_ErasedProductInstances$.prototype = $c_Lshapeless3_deriving_internals_ErasedProductInstances$.prototype;
var $d_Lshapeless3_deriving_internals_ErasedProductInstances$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lshapeless3_deriving_internals_ErasedProductInstances$, "shapeless3.deriving.internals.ErasedProductInstances$", ({
  Lshapeless3_deriving_internals_ErasedProductInstances$: 1
}));
export { $d_Lshapeless3_deriving_internals_ErasedProductInstances$ as $d_Lshapeless3_deriving_internals_ErasedProductInstances$ };
var $n_Lshapeless3_deriving_internals_ErasedProductInstances$;
function $m_Lshapeless3_deriving_internals_ErasedProductInstances$() {
  if ((!$n_Lshapeless3_deriving_internals_ErasedProductInstances$)) {
    $n_Lshapeless3_deriving_internals_ErasedProductInstances$ = new $c_Lshapeless3_deriving_internals_ErasedProductInstances$();
  }
  return $n_Lshapeless3_deriving_internals_ErasedProductInstances$;
}
export { $m_Lshapeless3_deriving_internals_ErasedProductInstances$ as $m_Lshapeless3_deriving_internals_ErasedProductInstances$ };
function $ct_Lsourcecode_SourceCompanion__F1__($thiz, build) {
  $thiz.Lsourcecode_SourceCompanion__f_build = build;
  return $thiz;
}
export { $ct_Lsourcecode_SourceCompanion__F1__ as $ct_Lsourcecode_SourceCompanion__F1__ };
/** @constructor */
function $c_Lsourcecode_SourceCompanion() {
  this.Lsourcecode_SourceCompanion__f_build = null;
}
export { $c_Lsourcecode_SourceCompanion as $c_Lsourcecode_SourceCompanion };
$c_Lsourcecode_SourceCompanion.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsourcecode_SourceCompanion.prototype.constructor = $c_Lsourcecode_SourceCompanion;
/** @constructor */
function $h_Lsourcecode_SourceCompanion() {
}
export { $h_Lsourcecode_SourceCompanion as $h_Lsourcecode_SourceCompanion };
$h_Lsourcecode_SourceCompanion.prototype = $c_Lsourcecode_SourceCompanion.prototype;
$c_Lsourcecode_SourceCompanion.prototype.wrap__O__Lsourcecode_SourceValue = (function(s) {
  return this.Lsourcecode_SourceCompanion__f_build.apply__O__O(s);
});
/** @constructor */
function $c_Lsourcecode_SourceValue() {
}
export { $c_Lsourcecode_SourceValue as $c_Lsourcecode_SourceValue };
$c_Lsourcecode_SourceValue.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsourcecode_SourceValue.prototype.constructor = $c_Lsourcecode_SourceValue;
/** @constructor */
function $h_Lsourcecode_SourceValue() {
}
export { $h_Lsourcecode_SourceValue as $h_Lsourcecode_SourceValue };
$h_Lsourcecode_SourceValue.prototype = $c_Lsourcecode_SourceValue.prototype;
/** @constructor */
function $c_Lsttp_capabilities_package$Streams() {
}
export { $c_Lsttp_capabilities_package$Streams as $c_Lsttp_capabilities_package$Streams };
$c_Lsttp_capabilities_package$Streams.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_capabilities_package$Streams.prototype.constructor = $c_Lsttp_capabilities_package$Streams;
/** @constructor */
function $h_Lsttp_capabilities_package$Streams() {
}
export { $h_Lsttp_capabilities_package$Streams as $h_Lsttp_capabilities_package$Streams };
$h_Lsttp_capabilities_package$Streams.prototype = $c_Lsttp_capabilities_package$Streams.prototype;
var $d_Lsttp_capabilities_package$Streams = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass(0, "sttp.capabilities.package$Streams", ({
  Lsttp_capabilities_package$Streams: 1
}));
export { $d_Lsttp_capabilities_package$Streams as $d_Lsttp_capabilities_package$Streams };
/** @constructor */
function $c_Lsttp_client3_FollowRedirectsBackend$() {
  this.Lsttp_client3_FollowRedirectsBackend$__f_MaxRedirects = 0;
  $n_Lsttp_client3_FollowRedirectsBackend$ = this;
  this.Lsttp_client3_FollowRedirectsBackend$__f_MaxRedirects = 32;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_s_util_matching_Regex__T__sci_Seq__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_matching_Regex(), "^[a-z]+://.*", $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
}
export { $c_Lsttp_client3_FollowRedirectsBackend$ as $c_Lsttp_client3_FollowRedirectsBackend$ };
$c_Lsttp_client3_FollowRedirectsBackend$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_FollowRedirectsBackend$.prototype.constructor = $c_Lsttp_client3_FollowRedirectsBackend$;
/** @constructor */
function $h_Lsttp_client3_FollowRedirectsBackend$() {
}
export { $h_Lsttp_client3_FollowRedirectsBackend$ as $h_Lsttp_client3_FollowRedirectsBackend$ };
$h_Lsttp_client3_FollowRedirectsBackend$.prototype = $c_Lsttp_client3_FollowRedirectsBackend$.prototype;
var $d_Lsttp_client3_FollowRedirectsBackend$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_FollowRedirectsBackend$, "sttp.client3.FollowRedirectsBackend$", ({
  Lsttp_client3_FollowRedirectsBackend$: 1
}));
export { $d_Lsttp_client3_FollowRedirectsBackend$ as $d_Lsttp_client3_FollowRedirectsBackend$ };
var $n_Lsttp_client3_FollowRedirectsBackend$;
function $m_Lsttp_client3_FollowRedirectsBackend$() {
  if ((!$n_Lsttp_client3_FollowRedirectsBackend$)) {
    $n_Lsttp_client3_FollowRedirectsBackend$ = new $c_Lsttp_client3_FollowRedirectsBackend$();
  }
  return $n_Lsttp_client3_FollowRedirectsBackend$;
}
export { $m_Lsttp_client3_FollowRedirectsBackend$ as $m_Lsttp_client3_FollowRedirectsBackend$ };
function $f_Lsttp_client3_RequestTExtensions__body__Lorg_scalajs_dom_File__Lsttp_client3_RequestT($thiz, file) {
  return $thiz.body__Lsttp_client3_internal_SttpFile__Lsttp_client3_RequestT(new $c_Lsttp_client3_internal_SttpFileCompanionExtensions$$anon$1(file));
}
export { $f_Lsttp_client3_RequestTExtensions__body__Lorg_scalajs_dom_File__Lsttp_client3_RequestT as $f_Lsttp_client3_RequestTExtensions__body__Lorg_scalajs_dom_File__Lsttp_client3_RequestT };
function $f_Lsttp_client3_ResponseAs__map__F1__Lsttp_client3_ResponseAs($thiz, f) {
  return $thiz.mapWithMetadata__F2__Lsttp_client3_ResponseAs(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((x$1, x$2) => f.apply__O__O(x$1))));
}
export { $f_Lsttp_client3_ResponseAs__map__F1__Lsttp_client3_ResponseAs as $f_Lsttp_client3_ResponseAs__map__F1__Lsttp_client3_ResponseAs };
function $f_Lsttp_client3_ResponseAs__showAs__T__Lsttp_client3_ResponseAs($thiz, s) {
  var g = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((t, _$1) => t));
  var showAs = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(s);
  return new $c_Lsttp_client3_MappedResponseAs($thiz, g, showAs);
}
export { $f_Lsttp_client3_ResponseAs__showAs__T__Lsttp_client3_ResponseAs as $f_Lsttp_client3_ResponseAs__showAs__T__Lsttp_client3_ResponseAs };
function $f_Lsttp_client3_SttpClientExceptionExtensions__defaultExceptionToSttpClientException__Lsttp_client3_RequestT__jl_Exception__s_Option($thiz, request, e) {
  var e$tailLocal1 = e;
  while (true) {
    var x1 = e$tailLocal1;
    if (false) {
      var value = new $c_Lsttp_client3_SttpClientException$ConnectException(request, x1);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
    }
    if ((x1 instanceof $c_Ljava_net_URISyntaxException)) {
      var value$1 = new $c_Lsttp_client3_SttpClientException$ConnectException(request, x1);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value$1);
    }
    if (false) {
      var value$2 = new $c_Lsttp_client3_SttpClientException$TimeoutException(request, x1);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value$2);
    }
    if ((x1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Ljava_io_IOException)) {
      var value$3 = $ct_Lsttp_client3_SttpClientException$ReadException__Lsttp_client3_RequestT__jl_Exception__(new $c_Lsttp_client3_SttpClientException$ReadException(), request, x1);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value$3);
    }
    if ((x1 instanceof $c_Lsttp_client3_ws_NotAWebSocketException)) {
      var value$4 = $ct_Lsttp_client3_SttpClientException$ReadException__Lsttp_client3_RequestT__jl_Exception__(new $c_Lsttp_client3_SttpClientException$ReadException(), request, x1);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value$4);
    }
    if ((x1 instanceof $c_Lsttp_client3_ws_GotAWebSocketException)) {
      var value$5 = $ct_Lsttp_client3_SttpClientException$ReadException__Lsttp_client3_RequestT__jl_Exception__(new $c_Lsttp_client3_SttpClientException$ReadException(), request, x1);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value$5);
    }
    if (false) {
      var value$6 = $ct_Lsttp_client3_SttpClientException$ReadException__Lsttp_client3_RequestT__jl_Exception__(new $c_Lsttp_client3_SttpClientException$ReadException(), request, x1);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value$6);
    }
    if (((x1.jl_Throwable__f_e !== null) && (x1.jl_Throwable__f_e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Exception))) {
      e$tailLocal1 = x1.jl_Throwable__f_e;
      continue;
    }
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
}
export { $f_Lsttp_client3_SttpClientExceptionExtensions__defaultExceptionToSttpClientException__Lsttp_client3_RequestT__jl_Exception__s_Option as $f_Lsttp_client3_SttpClientExceptionExtensions__defaultExceptionToSttpClientException__Lsttp_client3_RequestT__jl_Exception__s_Option };
function $f_Lsttp_client3_SttpExtensions__asFileAlways__Lorg_scalajs_dom_File__Lsttp_client3_ResponseAs($thiz, file) {
  var output = new $c_Lsttp_client3_internal_SttpFileCompanionExtensions$$anon$1(file);
  var this$3 = new $c_Lsttp_client3_ResponseAsFile(output);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => _$1.Lsttp_client3_internal_SttpFile__f_underlying));
  return $f_Lsttp_client3_ResponseAs__map__F1__Lsttp_client3_ResponseAs(this$3, f);
}
export { $f_Lsttp_client3_SttpExtensions__asFileAlways__Lorg_scalajs_dom_File__Lsttp_client3_ResponseAs as $f_Lsttp_client3_SttpExtensions__asFileAlways__Lorg_scalajs_dom_File__Lsttp_client3_ResponseAs };
function $f_Lsttp_client3_SttpExtensions__multipartFile__T__Lorg_scalajs_dom_File__Lsttp_model_Part($thiz, name, file) {
  var this$2 = $m_Lsttp_client3_package$();
  var file$1 = new $c_Lsttp_client3_internal_SttpFileCompanionExtensions$$anon$1(file);
  return $f_Lsttp_client3_SttpApi__multipartSttpFile__T__Lsttp_client3_internal_SttpFile__Lsttp_model_Part(this$2, name, file$1);
}
export { $f_Lsttp_client3_SttpExtensions__multipartFile__T__Lorg_scalajs_dom_File__Lsttp_model_Part as $f_Lsttp_client3_SttpExtensions__multipartFile__T__Lorg_scalajs_dom_File__Lsttp_model_Part };
/** @constructor */
function $c_Lsttp_client3_impl_cats_FetchCatsBackend$() {
}
export { $c_Lsttp_client3_impl_cats_FetchCatsBackend$ as $c_Lsttp_client3_impl_cats_FetchCatsBackend$ };
$c_Lsttp_client3_impl_cats_FetchCatsBackend$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_impl_cats_FetchCatsBackend$.prototype.constructor = $c_Lsttp_client3_impl_cats_FetchCatsBackend$;
/** @constructor */
function $h_Lsttp_client3_impl_cats_FetchCatsBackend$() {
}
export { $h_Lsttp_client3_impl_cats_FetchCatsBackend$ as $h_Lsttp_client3_impl_cats_FetchCatsBackend$ };
$h_Lsttp_client3_impl_cats_FetchCatsBackend$.prototype = $c_Lsttp_client3_impl_cats_FetchCatsBackend$.prototype;
$c_Lsttp_client3_impl_cats_FetchCatsBackend$.prototype.apply$default$2__F1 = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x) => x));
});
var $d_Lsttp_client3_impl_cats_FetchCatsBackend$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_impl_cats_FetchCatsBackend$, "sttp.client3.impl.cats.FetchCatsBackend$", ({
  Lsttp_client3_impl_cats_FetchCatsBackend$: 1
}));
export { $d_Lsttp_client3_impl_cats_FetchCatsBackend$ as $d_Lsttp_client3_impl_cats_FetchCatsBackend$ };
var $n_Lsttp_client3_impl_cats_FetchCatsBackend$;
function $m_Lsttp_client3_impl_cats_FetchCatsBackend$() {
  if ((!$n_Lsttp_client3_impl_cats_FetchCatsBackend$)) {
    $n_Lsttp_client3_impl_cats_FetchCatsBackend$ = new $c_Lsttp_client3_impl_cats_FetchCatsBackend$();
  }
  return $n_Lsttp_client3_impl_cats_FetchCatsBackend$;
}
export { $m_Lsttp_client3_impl_cats_FetchCatsBackend$ as $m_Lsttp_client3_impl_cats_FetchCatsBackend$ };
function $ct_Lsttp_client3_internal_BodyFromResponseAs__Lsttp_monad_MonadError__($thiz, m) {
  $thiz.Lsttp_client3_internal_BodyFromResponseAs__f_m = m;
  return $thiz;
}
export { $ct_Lsttp_client3_internal_BodyFromResponseAs__Lsttp_monad_MonadError__ as $ct_Lsttp_client3_internal_BodyFromResponseAs__Lsttp_monad_MonadError__ };
function $p_Lsttp_client3_internal_BodyFromResponseAs__doApply__Lsttp_client3_ResponseAs__Lsttp_model_ResponseMetadata__s_util_Either__O($thiz, responseAs, meta, response) {
  var responseAs$tailLocal1 = responseAs;
  while (true) {
    var _1 = responseAs$tailLocal1;
    var x25 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, response);
    var x79 = x25.T2__f__1;
    var x80 = x25.T2__f__2;
    if ((x79 instanceof $c_Lsttp_client3_MappedResponseAs)) {
      var x83 = x79.Lsttp_client3_MappedResponseAs__f_raw;
      var x84 = x79.Lsttp_client3_MappedResponseAs__f_g;
      var r = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((x83, meta, response) => (() => $p_Lsttp_client3_internal_BodyFromResponseAs__doApply__Lsttp_client3_ResponseAs__Lsttp_model_ResponseMetadata__s_util_Either__O($thiz, x83, meta, response)))(x83, meta, response));
      return new $c_Lsttp_monad_syntax$MonadErrorOps(r).flatMap__F1__Lsttp_monad_MonadError__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x84, meta) => ((x$1) => {
        if ((x$1 !== null)) {
          var result = x$1._1__O();
          var replayableBody = x$1._2__O();
          var r$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $thiz.Lsttp_client3_internal_BodyFromResponseAs__f_m.eval__F0__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => x84.apply__O__O__O(result, meta))))));
          return new $c_Lsttp_monad_syntax$MonadErrorOps(r$1).map__F1__Lsttp_monad_MonadError__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$3) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _$3, replayableBody))), $thiz.Lsttp_client3_internal_BodyFromResponseAs__f_m);
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
      }))(x84, meta)), $thiz.Lsttp_client3_internal_BodyFromResponseAs__f_m);
    }
    if ((x79 instanceof $c_Lsttp_client3_ResponseAsFromMetadata)) {
      responseAs$tailLocal1 = x79.apply__Lsttp_model_ResponseMetadata__Lsttp_client3_ResponseAs(meta);
      continue;
    }
    if (false) {
      var x74 = x79.Lsttp_client3_ResponseAsBoth__f_l;
      var x75 = x79.Lsttp_client3_ResponseAsBoth__f_r;
      var r$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((x74, meta, response) => (() => $p_Lsttp_client3_internal_BodyFromResponseAs__doApply__Lsttp_client3_ResponseAs__Lsttp_model_ResponseMetadata__s_util_Either__O($thiz, x74, meta, response)))(x74, meta, response));
      return new $c_Lsttp_monad_syntax$MonadErrorOps(r$2).flatMap__F1__Lsttp_monad_MonadError__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((response, x75, meta) => ((x$1$2) => {
        if ((x$1$2 !== null)) {
          var x17 = x$1$2._1__O();
          var x18 = x$1$2._2__O();
          var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
          if ((x === x18)) {
            var _2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
            var _1$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), x17, _2);
            var _2$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
            var v = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1$1, _2$1);
            var ME = $thiz.Lsttp_client3_internal_BodyFromResponseAs__f_m;
            return ME.unit__O__O(v);
          }
          if ((x18 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
            var rb = x18.s_Some__f_value;
            var r$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
              if ((response instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
                var rr = response.s_util_Left__f_value;
                var r$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $thiz.withReplayableBody__Lorg_scalajs_dom_Response__s_util_Either__O(rr, rb)));
                return new $c_Lsttp_monad_syntax$MonadErrorOps(r$3).map__F1__Lsttp_monad_MonadError__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$4) => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(_$4))), $thiz.Lsttp_client3_internal_BodyFromResponseAs__f_m);
              }
              if ((response instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
                var ws = response.s_util_Right__f_value;
                var v$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(ws);
                var ME$1 = $thiz.Lsttp_client3_internal_BodyFromResponseAs__f_m;
                return ME$1.unit__O__O(v$1);
              }
              throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(response);
            }));
            return new $c_Lsttp_monad_syntax$MonadErrorOps(r$4).flatMap__F1__Lsttp_monad_MonadError__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((replayableResponse) => {
              var r$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((replayableResponse$2) => (() => $p_Lsttp_client3_internal_BodyFromResponseAs__doApply__Lsttp_client3_ResponseAs__Lsttp_model_ResponseMetadata__s_util_Either__O($thiz, x75, meta, replayableResponse$2)))(replayableResponse));
              return new $c_Lsttp_monad_syntax$MonadErrorOps(r$5).map__F1__Lsttp_monad_MonadError__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1$1) => {
                if ((x$1$1 !== null)) {
                  var rightResult = x$1$1._1__O();
                  var _2$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(rightResult);
                  var _1$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), x17, _2$2);
                  var _2$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(rb);
                  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1$2, _2$3);
                }
                throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1$1);
              })), $thiz.Lsttp_client3_internal_BodyFromResponseAs__f_m);
            })), $thiz.Lsttp_client3_internal_BodyFromResponseAs__f_m);
          }
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1$2);
      }))(response, x75, meta)), $thiz.Lsttp_client3_internal_BodyFromResponseAs__f_m);
    }
    var x$2 = $m_Lsttp_client3_IgnoreResponse$();
    if (((x$2 === x79) && (x80 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left))) {
      var regular = x80.s_util_Left__f_value;
      var r$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((regular) => (() => $thiz.regularIgnore__Lorg_scalajs_dom_Response__O(regular)))(regular));
      return new $c_Lsttp_monad_syntax$MonadErrorOps(r$6).map__F1__Lsttp_monad_MonadError__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$5) => {
        var _2$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), (void 0), _2$4);
      })), $thiz.Lsttp_client3_internal_BodyFromResponseAs__f_m);
    }
    var x$3 = $m_Lsttp_client3_ResponseAsByteArray$();
    if (((x$3 === x79) && (x80 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left))) {
      var regular$3 = x80.s_util_Left__f_value;
      var r$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((regular$3) => (() => $thiz.regularAsByteArray__Lorg_scalajs_dom_Response__O(regular$3)))(regular$3));
      return new $c_Lsttp_monad_syntax$MonadErrorOps(r$7).map__F1__Lsttp_monad_MonadError__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((b) => {
        var _2$5 = $m_Lsttp_client3_internal_package$().replayableBody__AB__s_Option(b);
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), b, _2$5);
      })), $thiz.Lsttp_client3_internal_BodyFromResponseAs__f_m);
    }
    if (false) {
      var x61 = x79.Lsttp_client3_ResponseAsStream__f_f;
      if ((x80 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
        var regular$5 = x80.s_util_Left__f_value;
        var r$8 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((regular$5) => (() => $thiz.regularAsStream__Lorg_scalajs_dom_Response__O(regular$5)))(regular$5));
        return new $c_Lsttp_monad_syntax$MonadErrorOps(r$8).flatMap__F1__Lsttp_monad_MonadError__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x61, meta) => ((x$1$3) => {
          if ((x$1$3 !== null)) {
            var stream = x$1$3._1__O();
            var cancel = x$1$3._2__O();
            var r$10 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
              var r$9 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
                var this$30 = $thiz.Lsttp_client3_internal_BodyFromResponseAs__f_m;
                var t = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => x61.apply__O__O__O(stream, meta)));
                return $f_Lsttp_monad_MonadError__suspend__F0__O(this$30, t);
              }));
              return new $c_Lsttp_monad_syntax$MonadErrorOps(r$9).map__F1__Lsttp_monad_MonadError__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$6) => {
                var _2$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
                return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _$6, _2$6);
              })), $thiz.Lsttp_client3_internal_BodyFromResponseAs__f_m);
            }));
            return new $c_Lsttp_monad_syntax$MonadErrorOps(r$10).ensure__F0__Lsttp_monad_MonadError__O(cancel, $thiz.Lsttp_client3_internal_BodyFromResponseAs__f_m);
          }
          throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1$3);
        }))(x61, meta)), $thiz.Lsttp_client3_internal_BodyFromResponseAs__f_m);
      }
    }
    if ((x79 instanceof $c_Lsttp_client3_ResponseAsStreamUnsafe)) {
      if ((x80 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
        var regular$7 = x80.s_util_Left__f_value;
        var r$11 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((regular$7) => (() => $thiz.regularAsStream__Lorg_scalajs_dom_Response__O(regular$7)))(regular$7));
        return new $c_Lsttp_monad_syntax$MonadErrorOps(r$11).map__F1__Lsttp_monad_MonadError__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1$4) => {
          if ((x$1$4 !== null)) {
            var stream$1 = x$1$4._1__O();
            var _2$7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
            return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), stream$1, _2$7);
          }
          throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1$4);
        })), $thiz.Lsttp_client3_internal_BodyFromResponseAs__f_m);
      }
    }
    if ((x79 instanceof $c_Lsttp_client3_ResponseAsFile)) {
      var x46 = x79.Lsttp_client3_ResponseAsFile__f_output;
      if ((x80 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
        var regular$9 = x80.s_util_Left__f_value;
        var r$12 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((regular$9, x46) => (() => $thiz.regularAsFile__Lorg_scalajs_dom_Response__Lsttp_client3_internal_SttpFile__O(regular$9, x46)))(regular$9, x46));
        return new $c_Lsttp_monad_syntax$MonadErrorOps(r$12).map__F1__Lsttp_monad_MonadError__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((f$3) => {
          var _2$8 = $m_Lsttp_client3_internal_package$().replayableBody__Lsttp_client3_internal_SttpFile__s_Option(f$3);
          return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), f$3, _2$8);
        })), $thiz.Lsttp_client3_internal_BodyFromResponseAs__f_m);
      }
    }
    if ($is_Lsttp_client3_WebSocketResponseAs(x79)) {
      if ((x80 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
        var ws$1 = x80.s_util_Right__f_value;
        var r$13 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((wsr$2, meta, ws$1) => (() => $thiz.handleWS__Lsttp_client3_WebSocketResponseAs__Lsttp_model_ResponseMetadata__Lsttp_ws_WebSocket__O(wsr$2, meta, ws$1)))(x79, meta, ws$1));
        return new $c_Lsttp_monad_syntax$MonadErrorOps(r$13).map__F1__Lsttp_monad_MonadError__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((w) => {
          var _2$9 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
          return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), w, _2$9);
        })), $thiz.Lsttp_client3_internal_BodyFromResponseAs__f_m);
      }
    }
    if (($is_Lsttp_client3_WebSocketResponseAs(x79) && (x80 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left))) {
      var regular$11 = x80.s_util_Left__f_value;
      var e = new $c_Lsttp_client3_ws_NotAWebSocketException(meta.code__I());
      var r$14 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((regular$11, e) => (() => $thiz.cleanupWhenNotAWebSocket__Lorg_scalajs_dom_Response__Lsttp_client3_ws_NotAWebSocketException__O(regular$11, e)))(regular$11, e));
      return new $c_Lsttp_monad_syntax$MonadErrorOps(r$14).flatMap__F1__Lsttp_monad_MonadError__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((e) => ((_$7) => $thiz.Lsttp_client3_internal_BodyFromResponseAs__f_m.error__jl_Throwable__O(e)))(e)), $thiz.Lsttp_client3_internal_BodyFromResponseAs__f_m);
    }
    if ((x80 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
      var ws$3 = x80.s_util_Right__f_value;
      var e$4 = new $c_Lsttp_client3_ws_GotAWebSocketException();
      var r$15 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((ws$3, e$4) => (() => $thiz.cleanupWhenGotWebSocket__Lsttp_ws_WebSocket__Lsttp_client3_ws_GotAWebSocketException__O(ws$3, e$4)))(ws$3, e$4));
      return new $c_Lsttp_monad_syntax$MonadErrorOps(r$15).flatMap__F1__Lsttp_monad_MonadError__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((e$4) => ((_$8) => $thiz.Lsttp_client3_internal_BodyFromResponseAs__f_m.error__jl_Throwable__O(e$4)))(e$4)), $thiz.Lsttp_client3_internal_BodyFromResponseAs__f_m);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x25);
  }
}
export { $p_Lsttp_client3_internal_BodyFromResponseAs__doApply__Lsttp_client3_ResponseAs__Lsttp_model_ResponseMetadata__s_util_Either__O as $p_Lsttp_client3_internal_BodyFromResponseAs__doApply__Lsttp_client3_ResponseAs__Lsttp_model_ResponseMetadata__s_util_Either__O };
/** @constructor */
function $c_Lsttp_client3_internal_BodyFromResponseAs() {
  this.Lsttp_client3_internal_BodyFromResponseAs__f_m = null;
}
export { $c_Lsttp_client3_internal_BodyFromResponseAs as $c_Lsttp_client3_internal_BodyFromResponseAs };
$c_Lsttp_client3_internal_BodyFromResponseAs.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_internal_BodyFromResponseAs.prototype.constructor = $c_Lsttp_client3_internal_BodyFromResponseAs;
/** @constructor */
function $h_Lsttp_client3_internal_BodyFromResponseAs() {
}
export { $h_Lsttp_client3_internal_BodyFromResponseAs as $h_Lsttp_client3_internal_BodyFromResponseAs };
$h_Lsttp_client3_internal_BodyFromResponseAs.prototype = $c_Lsttp_client3_internal_BodyFromResponseAs.prototype;
$c_Lsttp_client3_internal_BodyFromResponseAs.prototype.apply__Lsttp_client3_ResponseAs__Lsttp_model_ResponseMetadata__s_util_Either__O = (function(responseAs, meta, response) {
  var r = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $p_Lsttp_client3_internal_BodyFromResponseAs__doApply__Lsttp_client3_ResponseAs__Lsttp_model_ResponseMetadata__s_util_Either__O(this, responseAs, meta, response)));
  return new $c_Lsttp_monad_syntax$MonadErrorOps(r).map__F1__Lsttp_monad_MonadError__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => _$2._1__O())), this.Lsttp_client3_internal_BodyFromResponseAs__f_m);
});
/** @constructor */
function $c_Lsttp_client3_internal_package$() {
  this.Lsttp_client3_internal_package$__f_Utf8 = null;
  this.Lsttp_client3_internal_package$__f_nonReplayableBody = null;
  this.Lsttp_client3_internal_package$__f_IOBufferSize = 0;
  $n_Lsttp_client3_internal_package$ = this;
  this.Lsttp_client3_internal_package$__f_Utf8 = "utf-8";
  this.Lsttp_client3_internal_package$__f_nonReplayableBody = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  this.Lsttp_client3_internal_package$__f_IOBufferSize = 1024;
}
export { $c_Lsttp_client3_internal_package$ as $c_Lsttp_client3_internal_package$ };
$c_Lsttp_client3_internal_package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_internal_package$.prototype.constructor = $c_Lsttp_client3_internal_package$;
/** @constructor */
function $h_Lsttp_client3_internal_package$() {
}
export { $h_Lsttp_client3_internal_package$ as $h_Lsttp_client3_internal_package$ };
$h_Lsttp_client3_internal_package$.prototype = $c_Lsttp_client3_internal_package$.prototype;
$c_Lsttp_client3_internal_package$.prototype.charsetFromContentType__T__s_Option = (function(ct) {
  var xs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__split__T__I__AT(ct, ";", 0);
  var f = ((_$1) => {
    var this$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__trim__T(_$1);
    return this$3.toLowerCase();
  });
  var len = xs.u.length;
  var ys = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(len);
  if ((len > 0)) {
    var i = 0;
    if ((xs !== null)) {
      while ((i < len)) {
        var $x_1 = i;
        var x0 = xs.u[i];
        ys.u[$x_1] = f(x0);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I)) {
      while ((i < len)) {
        var $x_2 = i;
        var x0$1 = xs.u[i];
        ys.u[$x_2] = f(x0$1);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_D)) {
      while ((i < len)) {
        var $x_3 = i;
        var x0$2 = xs.u[i];
        ys.u[$x_3] = f(x0$2);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_J)) {
      while ((i < len)) {
        var $x_4 = i;
        var t = xs.u[i];
        var lo = t.RTLong__f_lo;
        var hi = t.RTLong__f_hi;
        ys.u[$x_4] = f(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_F)) {
      while ((i < len)) {
        var $x_5 = i;
        var x0$3 = xs.u[i];
        ys.u[$x_5] = f(x0$3);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_C)) {
      while ((i < len)) {
        var $x_6 = i;
        var x0$4 = xs.u[i];
        ys.u[$x_6] = f($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bC(x0$4));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_B)) {
      while ((i < len)) {
        var $x_7 = i;
        var x0$5 = xs.u[i];
        ys.u[$x_7] = f(x0$5);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_S)) {
      while ((i < len)) {
        var $x_8 = i;
        var x0$6 = xs.u[i];
        ys.u[$x_8] = f(x0$6);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_Z)) {
      while ((i < len)) {
        var $x_9 = i;
        var x0$7 = xs.u[i];
        ys.u[$x_9] = f(x0$7);
        i = ((1 + i) | 0);
      }
    } else {
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(xs);
    }
  }
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_ArrayOps$().collectFirst$extension__O__s_PartialFunction__s_Option(ys, new $c_Lsttp_client3_internal_package$$anon$1(this));
});
$c_Lsttp_client3_internal_package$.prototype.transfer__Ljava_io_InputStream__Ljava_io_OutputStream__V = (function(is, os) {
  var elem = 0;
  elem = 0;
  var dimensions = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I(new Int32Array([1024]));
  var buf = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_reflect_Array$().newInstance__jl_Class__AI__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_B.getClassOf(), dimensions);
  while (true) {
    var ev$3 = is.read__AB__I__I__I(buf, 0, buf.u.length);
    elem = ev$3;
    if ((elem !== (-1))) {
      os.write__AB__I__I__V(buf, 0, elem);
    } else {
      break;
    }
  }
});
$c_Lsttp_client3_internal_package$.prototype.toByteArray__Ljava_io_InputStream__AB = (function(is) {
  var os = $ct_Ljava_io_ByteArrayOutputStream__(new $c_Ljava_io_ByteArrayOutputStream());
  $m_Lsttp_client3_internal_package$().transfer__Ljava_io_InputStream__Ljava_io_OutputStream__V(is, os);
  return os.toByteArray__AB();
});
$c_Lsttp_client3_internal_package$.prototype.sanitizeCharset__T__T = (function(charset) {
  var c2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__trim__T(charset);
  var c3 = ((!(!c2.startsWith("\""))) ? c2.substring(1) : c2);
  if ((!(!c3.endsWith("\"")))) {
    var endIndex = (((-1) + c3.length) | 0);
    return c3.substring(0, endIndex);
  } else {
    return c3;
  }
});
$c_Lsttp_client3_internal_package$.prototype.throwNestedMultipartNotAllowed__E = (function() {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), "Nested multipart bodies are not allowed");
});
$c_Lsttp_client3_internal_package$.prototype.replayableBody__AB__s_Option = (function(a) {
  var value = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(a);
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
});
$c_Lsttp_client3_internal_package$.prototype.replayableBody__Lsttp_client3_internal_SttpFile__s_Option = (function(f) {
  var value = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(f);
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
});
var $d_Lsttp_client3_internal_package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_internal_package$, "sttp.client3.internal.package$", ({
  Lsttp_client3_internal_package$: 1
}));
export { $d_Lsttp_client3_internal_package$ as $d_Lsttp_client3_internal_package$ };
var $n_Lsttp_client3_internal_package$;
function $m_Lsttp_client3_internal_package$() {
  if ((!$n_Lsttp_client3_internal_package$)) {
    $n_Lsttp_client3_internal_package$ = new $c_Lsttp_client3_internal_package$();
  }
  return $n_Lsttp_client3_internal_package$;
}
export { $m_Lsttp_client3_internal_package$ as $m_Lsttp_client3_internal_package$ };
function $f_Lsttp_model_Methods__$init$__V($thiz) {
  $thiz.Lsttp_model_Method$__f_GET = ($m_Lsttp_model_Method$(), "GET");
  $thiz.Lsttp_model_Method$__f_HEAD = ($m_Lsttp_model_Method$(), "HEAD");
  $thiz.Lsttp_model_Method$__f_POST = ($m_Lsttp_model_Method$(), "POST");
  $thiz.Lsttp_model_Method$__f_PUT = ($m_Lsttp_model_Method$(), "PUT");
  $thiz.Lsttp_model_Method$__f_DELETE = ($m_Lsttp_model_Method$(), "DELETE");
  $thiz.Lsttp_model_Method$__f_OPTIONS = ($m_Lsttp_model_Method$(), "OPTIONS");
  $m_Lsttp_model_Method$();
  $m_Lsttp_model_Method$();
  $thiz.Lsttp_model_Method$__f_TRACE = ($m_Lsttp_model_Method$(), "TRACE");
}
export { $f_Lsttp_model_Methods__$init$__V as $f_Lsttp_model_Methods__$init$__V };
/** @constructor */
function $c_Lsttp_model_StatusCode(code) {
  this.Lsttp_model_StatusCode__f_code = 0;
  this.Lsttp_model_StatusCode__f_code = code;
}
export { $c_Lsttp_model_StatusCode as $c_Lsttp_model_StatusCode };
$c_Lsttp_model_StatusCode.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_model_StatusCode.prototype.constructor = $c_Lsttp_model_StatusCode;
/** @constructor */
function $h_Lsttp_model_StatusCode() {
}
export { $h_Lsttp_model_StatusCode as $h_Lsttp_model_StatusCode };
$h_Lsttp_model_StatusCode.prototype = $c_Lsttp_model_StatusCode.prototype;
$c_Lsttp_model_StatusCode.prototype.hashCode__I = (function() {
  $m_Lsttp_model_StatusCode$();
  var this$ = this.Lsttp_model_StatusCode__f_code;
  return this$;
});
$c_Lsttp_model_StatusCode.prototype.equals__O__Z = (function(x$0) {
  return $m_Lsttp_model_StatusCode$().equals$extension__I__O__Z(this.Lsttp_model_StatusCode__f_code, x$0);
});
$c_Lsttp_model_StatusCode.prototype.toString__T = (function() {
  $m_Lsttp_model_StatusCode$();
  var this$ = this.Lsttp_model_StatusCode__f_code;
  return ("" + this$);
});
function $isArrayOf_Lsttp_model_StatusCode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_model_StatusCode)));
}
export { $isArrayOf_Lsttp_model_StatusCode as $isArrayOf_Lsttp_model_StatusCode };
var $d_Lsttp_model_StatusCode = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_model_StatusCode, "sttp.model.StatusCode", ({
  Lsttp_model_StatusCode: 1
}));
export { $d_Lsttp_model_StatusCode as $d_Lsttp_model_StatusCode };
function $f_Lsttp_model_StatusCodes__$init$__V($thiz) {
  $thiz.Lsttp_model_StatusCode$__f_Continue = ($m_Lsttp_model_StatusCode$(), 100);
  $thiz.Lsttp_model_StatusCode$__f_SwitchingProtocols = ($m_Lsttp_model_StatusCode$(), 101);
  $thiz.Lsttp_model_StatusCode$__f_Processing = ($m_Lsttp_model_StatusCode$(), 102);
  $thiz.Lsttp_model_StatusCode$__f_EarlyHints = ($m_Lsttp_model_StatusCode$(), 103);
  $thiz.Lsttp_model_StatusCode$__f_Ok = ($m_Lsttp_model_StatusCode$(), 200);
  $thiz.Lsttp_model_StatusCode$__f_Created = ($m_Lsttp_model_StatusCode$(), 201);
  $thiz.Lsttp_model_StatusCode$__f_Accepted = ($m_Lsttp_model_StatusCode$(), 202);
  $thiz.Lsttp_model_StatusCode$__f_NonAuthoritativeInformation = ($m_Lsttp_model_StatusCode$(), 203);
  $thiz.Lsttp_model_StatusCode$__f_NoContent = ($m_Lsttp_model_StatusCode$(), 204);
  $thiz.Lsttp_model_StatusCode$__f_ResetContent = ($m_Lsttp_model_StatusCode$(), 205);
  $thiz.Lsttp_model_StatusCode$__f_PartialContent = ($m_Lsttp_model_StatusCode$(), 206);
  $thiz.Lsttp_model_StatusCode$__f_MultiStatus = ($m_Lsttp_model_StatusCode$(), 207);
  $thiz.Lsttp_model_StatusCode$__f_AlreadyReported = ($m_Lsttp_model_StatusCode$(), 208);
  $thiz.Lsttp_model_StatusCode$__f_ImUsed = ($m_Lsttp_model_StatusCode$(), 226);
  $thiz.Lsttp_model_StatusCode$__f_MultipleChoices = ($m_Lsttp_model_StatusCode$(), 300);
  $thiz.Lsttp_model_StatusCode$__f_MovedPermanently = ($m_Lsttp_model_StatusCode$(), 301);
  $thiz.Lsttp_model_StatusCode$__f_Found = ($m_Lsttp_model_StatusCode$(), 302);
  $thiz.Lsttp_model_StatusCode$__f_SeeOther = ($m_Lsttp_model_StatusCode$(), 303);
  $thiz.Lsttp_model_StatusCode$__f_NotModified = ($m_Lsttp_model_StatusCode$(), 304);
  $thiz.Lsttp_model_StatusCode$__f_UseProxy = ($m_Lsttp_model_StatusCode$(), 305);
  $thiz.Lsttp_model_StatusCode$__f_TemporaryRedirect = ($m_Lsttp_model_StatusCode$(), 307);
  $thiz.Lsttp_model_StatusCode$__f_PermanentRedirect = ($m_Lsttp_model_StatusCode$(), 308);
  $thiz.Lsttp_model_StatusCode$__f_BadRequest = ($m_Lsttp_model_StatusCode$(), 400);
  $thiz.Lsttp_model_StatusCode$__f_Unauthorized = ($m_Lsttp_model_StatusCode$(), 401);
  $thiz.Lsttp_model_StatusCode$__f_PaymentRequired = ($m_Lsttp_model_StatusCode$(), 402);
  $thiz.Lsttp_model_StatusCode$__f_Forbidden = ($m_Lsttp_model_StatusCode$(), 403);
  $thiz.Lsttp_model_StatusCode$__f_NotFound = ($m_Lsttp_model_StatusCode$(), 404);
  $thiz.Lsttp_model_StatusCode$__f_MethodNotAllowed = ($m_Lsttp_model_StatusCode$(), 405);
  $thiz.Lsttp_model_StatusCode$__f_NotAcceptable = ($m_Lsttp_model_StatusCode$(), 406);
  $thiz.Lsttp_model_StatusCode$__f_ProxyAuthenticationRequired = ($m_Lsttp_model_StatusCode$(), 407);
  $thiz.Lsttp_model_StatusCode$__f_RequestTimeout = ($m_Lsttp_model_StatusCode$(), 408);
  $thiz.Lsttp_model_StatusCode$__f_Conflict = ($m_Lsttp_model_StatusCode$(), 409);
  $thiz.Lsttp_model_StatusCode$__f_Gone = ($m_Lsttp_model_StatusCode$(), 410);
  $thiz.Lsttp_model_StatusCode$__f_LengthRequired = ($m_Lsttp_model_StatusCode$(), 411);
  $thiz.Lsttp_model_StatusCode$__f_PreconditionFailed = ($m_Lsttp_model_StatusCode$(), 412);
  $thiz.Lsttp_model_StatusCode$__f_PayloadTooLarge = ($m_Lsttp_model_StatusCode$(), 413);
  $thiz.Lsttp_model_StatusCode$__f_UriTooLong = ($m_Lsttp_model_StatusCode$(), 414);
  $thiz.Lsttp_model_StatusCode$__f_UnsupportedMediaType = ($m_Lsttp_model_StatusCode$(), 415);
  $thiz.Lsttp_model_StatusCode$__f_RangeNotSatisfiable = ($m_Lsttp_model_StatusCode$(), 416);
  $thiz.Lsttp_model_StatusCode$__f_ExpectationFailed = ($m_Lsttp_model_StatusCode$(), 417);
  $thiz.Lsttp_model_StatusCode$__f_MisdirectedRequest = ($m_Lsttp_model_StatusCode$(), 421);
  $thiz.Lsttp_model_StatusCode$__f_UnprocessableEntity = ($m_Lsttp_model_StatusCode$(), 422);
  $thiz.Lsttp_model_StatusCode$__f_Locked = ($m_Lsttp_model_StatusCode$(), 423);
  $thiz.Lsttp_model_StatusCode$__f_FailedDependency = ($m_Lsttp_model_StatusCode$(), 424);
  $thiz.Lsttp_model_StatusCode$__f_UpgradeRequired = ($m_Lsttp_model_StatusCode$(), 426);
  $thiz.Lsttp_model_StatusCode$__f_PreconditionRequired = ($m_Lsttp_model_StatusCode$(), 428);
  $thiz.Lsttp_model_StatusCode$__f_TooManyRequests = ($m_Lsttp_model_StatusCode$(), 429);
  $thiz.Lsttp_model_StatusCode$__f_RequestHeaderFieldsTooLarge = ($m_Lsttp_model_StatusCode$(), 431);
  $thiz.Lsttp_model_StatusCode$__f_UnavailableForLegalReasons = ($m_Lsttp_model_StatusCode$(), 451);
  $thiz.Lsttp_model_StatusCode$__f_InternalServerError = ($m_Lsttp_model_StatusCode$(), 500);
  $thiz.Lsttp_model_StatusCode$__f_NotImplemented = ($m_Lsttp_model_StatusCode$(), 501);
  $thiz.Lsttp_model_StatusCode$__f_BadGateway = ($m_Lsttp_model_StatusCode$(), 502);
  $thiz.Lsttp_model_StatusCode$__f_ServiceUnavailable = ($m_Lsttp_model_StatusCode$(), 503);
  $thiz.Lsttp_model_StatusCode$__f_GatewayTimeout = ($m_Lsttp_model_StatusCode$(), 504);
  $thiz.Lsttp_model_StatusCode$__f_HttpVersionNotSupported = ($m_Lsttp_model_StatusCode$(), 505);
  $thiz.Lsttp_model_StatusCode$__f_VariantAlsoNegotiates = ($m_Lsttp_model_StatusCode$(), 506);
  $thiz.Lsttp_model_StatusCode$__f_InsufficientStorage = ($m_Lsttp_model_StatusCode$(), 507);
  $thiz.Lsttp_model_StatusCode$__f_LoopDetected = ($m_Lsttp_model_StatusCode$(), 508);
  $thiz.Lsttp_model_StatusCode$__f_NotExtended = ($m_Lsttp_model_StatusCode$(), 510);
  $thiz.Lsttp_model_StatusCode$__f_NetworkAuthenticationRequired = ($m_Lsttp_model_StatusCode$(), 511);
}
export { $f_Lsttp_model_StatusCodes__$init$__V as $f_Lsttp_model_StatusCodes__$init$__V };
function $f_Lsttp_monad_MonadError__suspend__F0__O($thiz, t) {
  return $thiz.flatten__O__O($thiz.eval__F0__O(t));
}
export { $f_Lsttp_monad_MonadError__suspend__F0__O as $f_Lsttp_monad_MonadError__suspend__F0__O };
/** @constructor */
function $c_Lsttp_monad_syntax$MonadErrorOps(r) {
  this.Lsttp_monad_syntax$MonadErrorOps__f_r = null;
  this.Lsttp_monad_syntax$MonadErrorOps__f_r = r;
}
export { $c_Lsttp_monad_syntax$MonadErrorOps as $c_Lsttp_monad_syntax$MonadErrorOps };
$c_Lsttp_monad_syntax$MonadErrorOps.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_monad_syntax$MonadErrorOps.prototype.constructor = $c_Lsttp_monad_syntax$MonadErrorOps;
/** @constructor */
function $h_Lsttp_monad_syntax$MonadErrorOps() {
}
export { $h_Lsttp_monad_syntax$MonadErrorOps as $h_Lsttp_monad_syntax$MonadErrorOps };
$h_Lsttp_monad_syntax$MonadErrorOps.prototype = $c_Lsttp_monad_syntax$MonadErrorOps.prototype;
$c_Lsttp_monad_syntax$MonadErrorOps.prototype.map__F1__Lsttp_monad_MonadError__O = (function(f, ME) {
  return ME.map__O__F1__O(this.Lsttp_monad_syntax$MonadErrorOps__f_r.apply__O(), f);
});
$c_Lsttp_monad_syntax$MonadErrorOps.prototype.flatMap__F1__Lsttp_monad_MonadError__O = (function(f, ME) {
  return ME.flatMap__O__F1__O(this.Lsttp_monad_syntax$MonadErrorOps__f_r.apply__O(), f);
});
$c_Lsttp_monad_syntax$MonadErrorOps.prototype.ensure__F0__Lsttp_monad_MonadError__O = (function(e, ME) {
  var f = this.Lsttp_monad_syntax$MonadErrorOps__f_r;
  return ME.ensure__O__F0__O(f.apply__O(), e);
});
var $d_Lsttp_monad_syntax$MonadErrorOps = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_monad_syntax$MonadErrorOps, "sttp.monad.syntax$MonadErrorOps", ({
  Lsttp_monad_syntax$MonadErrorOps: 1
}));
export { $d_Lsttp_monad_syntax$MonadErrorOps as $d_Lsttp_monad_syntax$MonadErrorOps };
/** @constructor */
function $c_Lsttp_tapir_Defaults$() {
}
export { $c_Lsttp_tapir_Defaults$ as $c_Lsttp_tapir_Defaults$ };
$c_Lsttp_tapir_Defaults$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_Defaults$.prototype.constructor = $c_Lsttp_tapir_Defaults$;
/** @constructor */
function $h_Lsttp_tapir_Defaults$() {
}
export { $h_Lsttp_tapir_Defaults$ as $h_Lsttp_tapir_Defaults$ };
$h_Lsttp_tapir_Defaults$.prototype = $c_Lsttp_tapir_Defaults$.prototype;
$c_Lsttp_tapir_Defaults$.prototype.createTempFile__F0 = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    var $x_3 = File;
    var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterable$();
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
    var array = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_B(0);
    var self = $x_2.apply__sci_Seq__O($x_1.wrapRefArray__AO__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([array.u.slice()])));
    return new $x_3(new ($a_sjs_js_JSConverters$IterableAdapter())(self), "temp.txt");
  }));
});
var $d_Lsttp_tapir_Defaults$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_Defaults$, "sttp.tapir.Defaults$", ({
  Lsttp_tapir_Defaults$: 1
}));
export { $d_Lsttp_tapir_Defaults$ as $d_Lsttp_tapir_Defaults$ };
var $n_Lsttp_tapir_Defaults$;
function $m_Lsttp_tapir_Defaults$() {
  if ((!$n_Lsttp_tapir_Defaults$)) {
    $n_Lsttp_tapir_Defaults$ = new $c_Lsttp_tapir_Defaults$();
  }
  return $n_Lsttp_tapir_Defaults$;
}
export { $m_Lsttp_tapir_Defaults$ as $m_Lsttp_tapir_Defaults$ };
function $f_Lsttp_tapir_EndpointMetaOps__showShort__T($thiz) {
  var x17 = $thiz.Lsttp_tapir_Endpoint__f_info.Lsttp_tapir_EndpointInfo__f_name;
  var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  if ((x === x17)) {
    var this$1 = $thiz.method__s_Option();
    if (this$1.isEmpty__Z()) {
      var this$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    } else {
      var x0 = this$1.get__O();
      var _$6 = ((x0 === null) ? null : x0.Lsttp_model_Method__f_method);
      $m_Lsttp_model_Method$();
      var this$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(_$6);
    }
    var $x_1 = (this$3.isEmpty__Z() ? "*" : this$3.get__O());
    var showQueryParam$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    var showPathParam$1 = $f_Lsttp_tapir_EndpointMetaOps__showPathTemplate$default$1__F2($thiz);
    var showPathsAs$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some("*");
    var showQueryParamsAs$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some("*");
    return (($x_1 + " ") + $m_Lsttp_tapir_internal_ShowPathTemplate$().apply__Lsttp_tapir_EndpointMetaOps__F2__s_Option__Z__T__s_Option__s_Option__T($thiz, showPathParam$1, showQueryParam$1, true, "*", showPathsAs$1, showQueryParamsAs$1));
  }
  if ((x17 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
    var name = x17.s_Some__f_value;
    return (("[" + name) + "]");
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x17);
}
export { $f_Lsttp_tapir_EndpointMetaOps__showShort__T as $f_Lsttp_tapir_EndpointMetaOps__showShort__T };
function $f_Lsttp_tapir_EndpointMetaOps__showPathTemplate$default$1__F2($thiz) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((index, pc) => {
    var index$1 = (index | 0);
    var this$1 = pc.Lsttp_tapir_EndpointInput$PathCapture__f_name;
    if (this$1.isEmpty__Z()) {
      var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    } else {
      var x0 = this$1.get__O();
      var this$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some((("{" + x0) + "}"));
    }
    return (this$2.isEmpty__Z() ? (("{param" + index$1) + "}") : this$2.get__O());
  }));
}
export { $f_Lsttp_tapir_EndpointMetaOps__showPathTemplate$default$1__F2 as $f_Lsttp_tapir_EndpointMetaOps__showPathTemplate$default$1__F2 };
function $f_Lsttp_tapir_EndpointMetaOps__method__s_Option($thiz) {
  var input = $thiz.Lsttp_tapir_Endpoint__f_input;
  var this$2 = new $c_Lsttp_tapir_internal_package$RichEndpointInput(input).method__s_Option();
  if (this$2.isEmpty__Z()) {
    var input$1 = $thiz.Lsttp_tapir_Endpoint__f_securityInput;
    return new $c_Lsttp_tapir_internal_package$RichEndpointInput(input$1).method__s_Option();
  } else {
    return this$2;
  }
}
export { $f_Lsttp_tapir_EndpointMetaOps__method__s_Option as $f_Lsttp_tapir_EndpointMetaOps__method__s_Option };
var $d_Lsttp_tapir_RawBodyType = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass(1, "sttp.tapir.RawBodyType", ({
  Lsttp_tapir_RawBodyType: 1
}));
export { $d_Lsttp_tapir_RawBodyType as $d_Lsttp_tapir_RawBodyType };
/** @constructor */
function $c_Lsttp_tapir_Tapir$WebSocketBodyBuilder(outer) {
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lsttp_tapir_Tapir$WebSocketBodyBuilder as $c_Lsttp_tapir_Tapir$WebSocketBodyBuilder };
$c_Lsttp_tapir_Tapir$WebSocketBodyBuilder.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_Tapir$WebSocketBodyBuilder.prototype.constructor = $c_Lsttp_tapir_Tapir$WebSocketBodyBuilder;
/** @constructor */
function $h_Lsttp_tapir_Tapir$WebSocketBodyBuilder() {
}
export { $h_Lsttp_tapir_Tapir$WebSocketBodyBuilder as $h_Lsttp_tapir_Tapir$WebSocketBodyBuilder };
$h_Lsttp_tapir_Tapir$WebSocketBodyBuilder.prototype = $c_Lsttp_tapir_Tapir$WebSocketBodyBuilder.prototype;
$c_Lsttp_tapir_Tapir$WebSocketBodyBuilder.prototype.apply__Lsttp_capabilities_package$Streams__Lsttp_tapir_Codec__Lsttp_tapir_Codec__Lsttp_tapir_WebSocketBodyOutput = (function(s, requests, responses) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Codec$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Codec$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var schemaType = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_SchemaType$SString();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var name = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var isOptional = false;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var description = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var default$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var format = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var encodedExample = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var deprecated = false;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var hidden = false;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var validator = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var attributes = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  var s$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema(schemaType, name, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_CodecFormat$TextPlain();
  var codec = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Codec$$anon$4(s$1, f);
  var description$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var examples = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var attributes$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  var info = new $c_Lsttp_tapir_EndpointIO$Info(description$1, examples, false, attributes$1);
  var description$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var examples$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var attributes$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  var requestsInfo = new $c_Lsttp_tapir_EndpointIO$Info(description$2, examples$1, false, attributes$2);
  var description$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var examples$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var attributes$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  var responsesInfo = new $c_Lsttp_tapir_EndpointIO$Info(description$3, examples$2, false, attributes$3);
  var decodeCloseRequests = requests.schema__Lsttp_tapir_Schema().Lsttp_tapir_Schema__f_isOptional;
  var decodeCloseResponses = responses.schema__Lsttp_tapir_Schema().Lsttp_tapir_Schema__f_isOptional;
  var this$20 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_package$DurationInt(13);
  var unit = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
  var this$ = this$20.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$();
  var hi = (this$ >> 31);
  var _1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_FiniteDuration(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(this$, hi), unit);
  var payload = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyByteArray;
  var _2 = new $c_Lsttp_ws_WebSocketFrame$Ping(payload);
  var value = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, _2);
  var autoPing = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
  return new $c_Lsttp_tapir_WebSocketBodyOutput(s, requests, responses, codec, info, requestsInfo, responsesInfo, true, true, true, decodeCloseRequests, decodeCloseResponses, autoPing);
});
var $d_Lsttp_tapir_Tapir$WebSocketBodyBuilder = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_Tapir$WebSocketBodyBuilder, "sttp.tapir.Tapir$WebSocketBodyBuilder", ({
  Lsttp_tapir_Tapir$WebSocketBodyBuilder: 1
}));
export { $d_Lsttp_tapir_Tapir$WebSocketBodyBuilder as $d_Lsttp_tapir_Tapir$WebSocketBodyBuilder };
function $p_Lsttp_tapir_TapirAuth$__filterHeaders$1__T__sci_List__Lsttp_tapir_Codec__sci_List($thiz, authScheme$1, headers, evidence$1) {
  var f = ((_$5) => {
    var this$1 = _$5.toLowerCase();
    var prefix = authScheme$1.toLowerCase();
    return (!(!this$1.startsWith(prefix)));
  });
  var l = headers;
  block: {
    var result;
    while (true) {
      if (l.isEmpty__Z()) {
        var result = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
        break;
      } else {
        var h = l.head__O();
        var t = l.tail__O();
        if (((!(!f(h))) === false)) {
          l = t;
          continue;
        }
        var start = l;
        var remaining = t;
        while (true) {
          if (remaining.isEmpty__Z()) {
            var result = start;
            break block;
          } else {
            var x = remaining.head__O();
            if (((!(!f(x))) !== false)) {
              remaining = remaining.tail__O();
              continue;
            }
            var firstMiss = remaining;
            var newHead = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(start.head__O(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
            var toProcess = start.tail__O();
            var currentLast = newHead;
            while ((toProcess !== firstMiss)) {
              var newElem = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(toProcess.head__O(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
              currentLast.sci_$colon$colon__f_next = newElem;
              currentLast = newElem;
              toProcess = toProcess.tail__O();
            }
            var next = firstMiss.tail__O();
            var nextToCopy = next;
            while ((!next.isEmpty__Z())) {
              var head = next.head__O();
              if (((!(!f(head))) !== false)) {
                next = next.tail__O();
              } else {
                while ((nextToCopy !== next)) {
                  var newElem$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(nextToCopy.head__O(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
                  currentLast.sci_$colon$colon__f_next = newElem$2;
                  currentLast = newElem$2;
                  nextToCopy = nextToCopy.tail__O();
                }
                nextToCopy = next.tail__O();
                next = next.tail__O();
              }
            }
            if ((!nextToCopy.isEmpty__Z())) {
              currentLast.sci_$colon$colon__f_next = nextToCopy;
            }
            var result = newHead;
            break block;
          }
        }
      }
    }
  }
  return result;
}
export { $p_Lsttp_tapir_TapirAuth$__filterHeaders$1__T__sci_List__Lsttp_tapir_Codec__sci_List as $p_Lsttp_tapir_TapirAuth$__filterHeaders$1__T__sci_List__Lsttp_tapir_Codec__sci_List };
function $p_Lsttp_tapir_TapirAuth$__stringPrefixWithSpace$1__T__Lsttp_tapir_Mapping($thiz, authScheme$3) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Mapping$().stringPrefixCaseInsensitiveForList__T__Lsttp_tapir_Mapping((authScheme$3 + " "));
}
export { $p_Lsttp_tapir_TapirAuth$__stringPrefixWithSpace$1__T__Lsttp_tapir_Mapping as $p_Lsttp_tapir_TapirAuth$__stringPrefixWithSpace$1__T__Lsttp_tapir_Mapping };
/** @constructor */
function $c_Lsttp_tapir_TapirAuth$() {
}
export { $c_Lsttp_tapir_TapirAuth$ as $c_Lsttp_tapir_TapirAuth$ };
$c_Lsttp_tapir_TapirAuth$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_TapirAuth$.prototype.constructor = $c_Lsttp_tapir_TapirAuth$;
/** @constructor */
function $h_Lsttp_tapir_TapirAuth$() {
}
export { $h_Lsttp_tapir_TapirAuth$ as $h_Lsttp_tapir_TapirAuth$ };
$h_Lsttp_tapir_TapirAuth$.prototype = $c_Lsttp_tapir_TapirAuth$.prototype;
$c_Lsttp_tapir_TapirAuth$.prototype.http__T__Lsttp_model_headers_WWWAuthenticateChallenge__Lsttp_tapir_Codec__Lsttp_tapir_EndpointInput$Auth = (function(authScheme, challenge, evidence$1) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Codec$();
  var f = evidence$1.format__Lsttp_tapir_CodecFormat();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var schemaType = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_SchemaType$SBinary();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var name = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var isOptional = false;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var description = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var default$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var format = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var encodedExample = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var deprecated = false;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var hidden = false;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var validator = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var attributes = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  var s = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema(schemaType, name, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes);
  var this$15 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Codec$$anon$4(s, f);
  var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$6) => $p_Lsttp_tapir_TapirAuth$__filterHeaders$1__T__sci_List__Lsttp_tapir_Codec__sci_List(this, authScheme, _$6, evidence$1)));
  var g = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x) => x));
  var this$16 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lsttp_tapir_Codec__map__F1__F1__Lsttp_tapir_Codec(this$15, f$1, g);
  var mapping = $p_Lsttp_tapir_TapirAuth$__stringPrefixWithSpace$1__T__Lsttp_tapir_Mapping(this, authScheme);
  var this$17 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Codec$$anon$1(mapping, this$16);
  var f$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((l) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lsttp_tapir_Codec__decode__O__Lsttp_tapir_DecodeResult(evidence$1, l)));
  var g$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((h) => evidence$1.encode__O__O(h)));
  var this$18 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lsttp_tapir_Codec__mapDecode__F1__F1__Lsttp_tapir_Codec(this$17, f$2, g$1);
  var s2 = evidence$1.schema__Lsttp_tapir_Schema();
  var authCodec = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Codec$$anon$2(s2, this$18);
  var this$19 = $m_Lsttp_tapir_package$();
  var name$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_Authorization;
  var input = $f_Lsttp_tapir_Tapir__header__T__Lsttp_tapir_Codec__Lsttp_tapir_EndpointIO$Header(this$19, name$1, authCodec);
  var authType = new $c_Lsttp_tapir_EndpointInput$AuthType$Http(authScheme);
  var info = $m_Lsttp_tapir_EndpointInput$AuthInfo$().Lsttp_tapir_EndpointInput$AuthInfo$__f_Empty;
  return new $c_Lsttp_tapir_EndpointInput$Auth(input, challenge, authType, info);
});
var $d_Lsttp_tapir_TapirAuth$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_TapirAuth$, "sttp.tapir.TapirAuth$", ({
  Lsttp_tapir_TapirAuth$: 1
}));
export { $d_Lsttp_tapir_TapirAuth$ as $d_Lsttp_tapir_TapirAuth$ };
var $n_Lsttp_tapir_TapirAuth$;
function $m_Lsttp_tapir_TapirAuth$() {
  if ((!$n_Lsttp_tapir_TapirAuth$)) {
    $n_Lsttp_tapir_TapirAuth$ = new $c_Lsttp_tapir_TapirAuth$();
  }
  return $n_Lsttp_tapir_TapirAuth$;
}
export { $m_Lsttp_tapir_TapirAuth$ as $m_Lsttp_tapir_TapirAuth$ };
function $f_Lsttp_tapir_TapirComputedInputs__$init$__V($thiz) {
  var this$3 = $f_Lsttp_tapir_Tapir__extractFromRequest__F1__Lsttp_tapir_EndpointInput$ExtractFromRequest($thiz, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$22) => _$22.uri__Lsttp_model_Uri().path__sci_Seq())));
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((ps) => ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOps__lastOption__s_Option(ps).contains__O__Z("") ? new $c_Lsttp_tapir_DecodeResult$Mismatch("", "/") : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_DecodeResult$Value((void 0)))));
  var g = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$23) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$()));
  $thiz.sttp$tapir$TapirComputedInputs$_setter_$noTrailingSlash_$eq__Lsttp_tapir_EndpointInput__V($f_Lsttp_tapir_EndpointTransput$Atom__attribute__Lsttp_tapir_AttributeKey__O__Lsttp_tapir_EndpointTransput($f_Lsttp_tapir_EndpointTransput__mapDecode__F1__F1__Lsttp_tapir_EndpointTransput(this$3, f, g), $thiz.NoTrailingSlash__Lsttp_tapir_TapirComputedInputs$NoTrailingSlash$().Lsttp_tapir_TapirComputedInputs$NoTrailingSlash$__f_Attribute, true));
}
export { $f_Lsttp_tapir_TapirComputedInputs__$init$__V as $f_Lsttp_tapir_TapirComputedInputs__$init$__V };
/** @constructor */
function $c_Lsttp_tapir_TapirComputedInputs$NoTrailingSlash$(outer) {
  this.Lsttp_tapir_TapirComputedInputs$NoTrailingSlash$__f_Attribute = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lsttp_tapir_TapirComputedInputs$NoTrailingSlash$__f_Attribute = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_AttributeKey("sttp.tapir.NoTrailingSlash");
}
export { $c_Lsttp_tapir_TapirComputedInputs$NoTrailingSlash$ as $c_Lsttp_tapir_TapirComputedInputs$NoTrailingSlash$ };
$c_Lsttp_tapir_TapirComputedInputs$NoTrailingSlash$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_TapirComputedInputs$NoTrailingSlash$.prototype.constructor = $c_Lsttp_tapir_TapirComputedInputs$NoTrailingSlash$;
/** @constructor */
function $h_Lsttp_tapir_TapirComputedInputs$NoTrailingSlash$() {
}
export { $h_Lsttp_tapir_TapirComputedInputs$NoTrailingSlash$ as $h_Lsttp_tapir_TapirComputedInputs$NoTrailingSlash$ };
$h_Lsttp_tapir_TapirComputedInputs$NoTrailingSlash$.prototype = $c_Lsttp_tapir_TapirComputedInputs$NoTrailingSlash$.prototype;
var $d_Lsttp_tapir_TapirComputedInputs$NoTrailingSlash$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_TapirComputedInputs$NoTrailingSlash$, "sttp.tapir.TapirComputedInputs$NoTrailingSlash$", ({
  Lsttp_tapir_TapirComputedInputs$NoTrailingSlash$: 1
}));
export { $d_Lsttp_tapir_TapirComputedInputs$NoTrailingSlash$ as $d_Lsttp_tapir_TapirComputedInputs$NoTrailingSlash$ };
function $p_Lsttp_tapir_client_ClientOutputParams__handleOutputPair__Lsttp_tapir_EndpointOutput__Lsttp_tapir_EndpointOutput__F2__O__Lsttp_model_ResponseMetadata__Lsttp_tapir_DecodeResult($thiz, left, right, combine, body, meta) {
  var l = $thiz.apply__Lsttp_tapir_EndpointOutput__O__Lsttp_model_ResponseMetadata__Lsttp_tapir_DecodeResult(left, body, meta);
  var r = $thiz.apply__Lsttp_tapir_EndpointOutput__O__Lsttp_model_ResponseMetadata__Lsttp_tapir_DecodeResult(right, body, meta);
  return l.flatMap__F1__Lsttp_tapir_DecodeResult(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((leftParams) => r.map__F1__Lsttp_tapir_DecodeResult(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((leftParams$2) => ((rightParams) => combine.apply__O__O__O(leftParams$2, rightParams)))(leftParams))))));
}
export { $p_Lsttp_tapir_client_ClientOutputParams__handleOutputPair__Lsttp_tapir_EndpointOutput__Lsttp_tapir_EndpointOutput__F2__O__Lsttp_model_ResponseMetadata__Lsttp_tapir_DecodeResult as $p_Lsttp_tapir_client_ClientOutputParams__handleOutputPair__Lsttp_tapir_EndpointOutput__Lsttp_tapir_EndpointOutput__F2__O__Lsttp_model_ResponseMetadata__Lsttp_tapir_DecodeResult };
function $p_Lsttp_tapir_client_ClientOutputParams__tryDecodeOneOf__sci_List__O__Lsttp_model_ResponseMetadata__s_Option__s_Option($thiz, mappings, body, meta, firstFailure) {
  var firstFailure$tailLocal1 = firstFailure;
  var mappings$tailLocal1 = mappings;
  while (true) {
    var x96 = mappings$tailLocal1;
    var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    if (x.equals__O__Z(x96)) {
      var x90 = firstFailure$tailLocal1;
      var x$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      if ((x$3 === x90)) {
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      }
      if ((x90 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
        var failure = x90.s_Some__f_value;
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(failure);
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x90);
    }
    if ((x96 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon)) {
      var x99 = x96.sci_$colon$colon__f_next;
      var mapping = x96.sci_$colon$colon__f_head;
      var x93 = $thiz.apply__Lsttp_tapir_EndpointOutput__O__Lsttp_model_ResponseMetadata__Lsttp_tapir_DecodeResult(mapping.output__Lsttp_tapir_EndpointOutput(), body, meta);
      if ((x93 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_DecodeResult$Value)) {
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(x93);
      }
      if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$is_Lsttp_tapir_DecodeResult$Failure(x93)) {
        var this$3 = firstFailure$tailLocal1;
        var firstFailure$tailLocal1$tmp1 = (this$3.isEmpty__Z() ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(x93) : this$3);
        mappings$tailLocal1 = x99;
        firstFailure$tailLocal1 = firstFailure$tailLocal1$tmp1;
        continue;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x93);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x96);
  }
}
export { $p_Lsttp_tapir_client_ClientOutputParams__tryDecodeOneOf__sci_List__O__Lsttp_model_ResponseMetadata__s_Option__s_Option as $p_Lsttp_tapir_client_ClientOutputParams__tryDecodeOneOf__sci_List__O__Lsttp_model_ResponseMetadata__s_Option__s_Option };
/** @constructor */
function $c_Lsttp_tapir_client_ClientOutputParams() {
}
export { $c_Lsttp_tapir_client_ClientOutputParams as $c_Lsttp_tapir_client_ClientOutputParams };
$c_Lsttp_tapir_client_ClientOutputParams.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_client_ClientOutputParams.prototype.constructor = $c_Lsttp_tapir_client_ClientOutputParams;
/** @constructor */
function $h_Lsttp_tapir_client_ClientOutputParams() {
}
export { $h_Lsttp_tapir_client_ClientOutputParams as $h_Lsttp_tapir_client_ClientOutputParams };
$h_Lsttp_tapir_client_ClientOutputParams.prototype = $c_Lsttp_tapir_client_ClientOutputParams.prototype;
$c_Lsttp_tapir_client_ClientOutputParams.prototype.apply__Lsttp_tapir_EndpointOutput__O__Lsttp_model_ResponseMetadata__Lsttp_tapir_DecodeResult = (function(output, body, meta) {
  if ($is_Lsttp_tapir_EndpointOutput$Single(output)) {
    matchResult4: {
      var $x_1;
      if ((output instanceof $c_Lsttp_tapir_EndpointIO$Body)) {
        var x73 = output.Lsttp_tapir_EndpointIO$Body__f_codec;
        var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lsttp_tapir_Codec__decode__O__Lsttp_tapir_DecodeResult(x73, body);
        break matchResult4;
      }
      if (false) {
        var x68 = output.Lsttp_tapir_EndpointIO$OneOfBody__f_variants;
        var x69 = output.Lsttp_tapir_EndpointIO$OneOfBody__f_mapping;
        var body2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lsttp_tapir_Mapping__decode__O__Lsttp_tapir_DecodeResult(x69, body);
        var this$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lsttp_model_HasHeaders__header__T__s_Option(meta, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_ContentType);
        if (this$3.isEmpty__Z()) {
          var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        } else {
          var x0 = this$3.get__O();
          var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_MediaType$().parse__T__s_util_Either(x0).toOption__s_Option();
        }
        var this$4 = $x_2;
        if (this$4.isEmpty__Z()) {
          var this$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        } else {
          var x0$1 = this$4.get__O();
          _return: {
            var these = x68;
            while ((!these.isEmpty__Z())) {
              var x0$2 = these.head__O();
              if (x0$1.matches__Lsttp_model_ContentTypeRange__Z(x0$2.Lsttp_tapir_EndpointIO$OneOfBodyVariant__f_range)) {
                var this$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(these.head__O());
                break _return;
              }
              these = these.tail__O();
            }
            var this$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
          }
        }
        var bodyVariant = (this$5.isEmpty__Z() ? x68.head__O() : this$5.get__O());
        var $x_1 = body2.flatMap__F1__Lsttp_tapir_DecodeResult(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => {
          var codec = bodyVariant.bodyAsAtom__Lsttp_tapir_EndpointIO$Atom().codec__Lsttp_tapir_Codec();
          return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lsttp_tapir_Codec__decode__O__Lsttp_tapir_DecodeResult(codec, _$2);
        })));
        break matchResult4;
      }
      if (false) {
        var x58 = output.Lsttp_tapir_EndpointIO$StreamBodyWrapper__f_wrapped;
        if ((x58 !== null)) {
          var x62 = x58.Lsttp_tapir_StreamBodyIO__f_codec;
          var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lsttp_tapir_Codec__decode__O__Lsttp_tapir_DecodeResult(x62, body);
          break matchResult4;
        }
      }
      if ((output instanceof $c_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper)) {
        var x55 = output.Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper__f_wrapped;
        var $x_1 = this.decodeWebSocketBody__Lsttp_tapir_WebSocketBodyOutput__O__Lsttp_tapir_DecodeResult(x55, body);
        break matchResult4;
      }
      if ((output instanceof $c_Lsttp_tapir_EndpointIO$Header)) {
        var x50 = output.Lsttp_tapir_EndpointIO$Header__f_name;
        var x51 = output.Lsttp_tapir_EndpointIO$Header__f_codec;
        var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lsttp_tapir_Codec__decode__O__Lsttp_tapir_DecodeResult(x51, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lsttp_model_HasHeaders__headers__T__sci_Seq(meta, x50).toList__sci_List());
        break matchResult4;
      }
      if (false) {
        var x46 = output.Lsttp_tapir_EndpointIO$Headers__f_codec;
        var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lsttp_tapir_Codec__decode__O__Lsttp_tapir_DecodeResult(x46, meta.headers__sci_Seq().toList__sci_List());
        break matchResult4;
      }
      if (false) {
        var x42 = output.Lsttp_tapir_EndpointOutput$StatusCode__f_codec;
        var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lsttp_tapir_Codec__decode__O__Lsttp_tapir_DecodeResult(x42, new $c_Lsttp_model_StatusCode(meta.code__I()));
        break matchResult4;
      }
      if ((output instanceof $c_Lsttp_tapir_EndpointOutput$FixedStatusCode)) {
        var x36 = output.Lsttp_tapir_EndpointOutput$FixedStatusCode__f_statusCode;
        var x37 = output.Lsttp_tapir_EndpointOutput$FixedStatusCode__f_codec;
        if ((meta.code__I() === x36)) {
          var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lsttp_tapir_Codec__decode__O__Lsttp_tapir_DecodeResult(x37, (void 0));
          break matchResult4;
        } else {
          $m_Lsttp_model_StatusCode$();
          var expected = ("" + x36);
          $m_Lsttp_model_StatusCode$();
          var this$ = meta.code__I();
          var actual = ("" + this$);
          var $x_1 = new $c_Lsttp_tapir_DecodeResult$Mismatch(expected, actual);
          break matchResult4;
        }
      }
      if (false) {
        var x31 = output.Lsttp_tapir_EndpointIO$FixedHeader__f_h;
        var x32 = output.Lsttp_tapir_EndpointIO$FixedHeader__f_codec;
        var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lsttp_model_HasHeaders__header__T__s_Option(meta, x31.Lsttp_model_Header__f_name);
        var x$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Option$().apply__O__s_Option(x31.Lsttp_model_Header__f_value);
        if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
          var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lsttp_tapir_Codec__decode__O__Lsttp_tapir_DecodeResult(x32, (void 0));
          break matchResult4;
        } else {
          var this$21 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(x31);
          var expected$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this$21);
          var actual$1 = meta.headers__sci_Seq().find__F1__s_Option(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$3) => {
            var otherName = x31.Lsttp_model_Header__f_name;
            var this$22 = _$3.Lsttp_model_Header__f_name;
            var len = this$22.length;
            if ((!((otherName === null) || (otherName.length !== len)))) {
              var i = 0;
              while ((i !== len)) {
                var index = i;
                var c = this$22.charCodeAt(index);
                var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toLowerCase__C__C($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toUpperCase__C__C(c));
                var index$1 = i;
                var c$1 = otherName.charCodeAt(index$1);
                if (($x_3 !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toLowerCase__C__C($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toUpperCase__C__C(c$1)))) {
                  return false;
                }
                i = ((1 + i) | 0);
              }
              return true;
            } else {
              return false;
            }
          }))).toString__T();
          var $x_1 = new $c_Lsttp_tapir_DecodeResult$Mismatch(expected$1, actual$1);
          break matchResult4;
        }
      }
      if ((output instanceof $c_Lsttp_tapir_EndpointIO$Empty)) {
        var x27 = output.Lsttp_tapir_EndpointIO$Empty__f_codec;
        var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lsttp_tapir_Codec__decode__O__Lsttp_tapir_DecodeResult(x27, (void 0));
        break matchResult4;
      }
      if (false) {
        var x23 = output.Lsttp_tapir_EndpointOutput$OneOf__f_variants;
        var x24 = output.Lsttp_tapir_EndpointOutput$OneOf__f_mapping;
        var this$26 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lsttp_model_HasHeaders__header__T__s_Option(meta, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_ContentType);
        if (this$26.isEmpty__Z()) {
          var contentType = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        } else {
          var x0$3 = this$26.get__O();
          var contentType = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_MediaType$().parse__T__s_util_Either(x0$3));
        }
        matchResult3: {
          var mappingsFilteredByContentType;
          matchAlts1: {
            matchAlts2: {
              var x$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
              if ((x$3 === contentType)) {
                break matchAlts2;
              }
              if (((contentType instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some) && (contentType.s_Some__f_value instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left))) {
                break matchAlts2;
              }
              break matchAlts1;
            }
            var mappingsFilteredByContentType = x23;
            break matchResult3;
          }
          if ((contentType instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
            var x5 = contentType.s_Some__f_value;
            if ((x5 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
              var content = x5.s_util_Right__f_value;
              var mappingsForContentType = x23.collect__s_PartialFunction__sci_List(new $c_Lsttp_tapir_client_ClientOutputParams$$anon$1(content));
              var mappingsFilteredByContentType = (mappingsForContentType.isEmpty__Z() ? x23 : mappingsForContentType);
              break matchResult3;
            }
          }
          throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(contentType);
        }
        var this$27 = $p_Lsttp_tapir_client_ClientOutputParams__tryDecodeOneOf__sci_List__O__Lsttp_model_ResponseMetadata__s_Option__s_Option(this, mappingsFilteredByContentType, body, meta, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
        if (this$27.isEmpty__Z()) {
          var original = meta.statusText__T();
          var $x_5 = new $c_Lsttp_model_StatusCode(meta.code__I());
          var this$28 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lsttp_model_HasHeaders__header__T__s_Option(meta, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_ContentType);
          var error = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), ((((("Cannot find mapping for status code " + $x_5) + " and content type: ") + (this$28.isEmpty__Z() ? "-" : this$28.get__O())) + ", in outputs ") + x23));
          var $x_4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_DecodeResult$Error(original, error);
        } else {
          var $x_4 = this$27.get__O();
        }
        var $x_1 = $x_4.flatMap__F1__Lsttp_tapir_DecodeResult(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((p) => {
          var v = p.asAny__O();
          return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lsttp_tapir_Mapping__decode__O__Lsttp_tapir_DecodeResult(x24, v);
        })));
        break matchResult4;
      }
      if (false) {
        var x19 = output.Lsttp_tapir_EndpointIO$MappedPair__f_io;
        var x20 = output.Lsttp_tapir_EndpointIO$MappedPair__f_mapping;
        var $x_1 = this.apply__Lsttp_tapir_EndpointOutput__O__Lsttp_model_ResponseMetadata__Lsttp_tapir_DecodeResult(x19, body, meta).flatMap__F1__Lsttp_tapir_DecodeResult(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((p$2) => {
          var v$1 = p$2.asAny__O();
          return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lsttp_tapir_Mapping__decode__O__Lsttp_tapir_DecodeResult(x20, v$1);
        })));
        break matchResult4;
      }
      if ((output instanceof $c_Lsttp_tapir_EndpointOutput$MappedPair)) {
        var x15 = output.Lsttp_tapir_EndpointOutput$MappedPair__f_output;
        var x16 = output.Lsttp_tapir_EndpointOutput$MappedPair__f_mapping;
        var $x_1 = this.apply__Lsttp_tapir_EndpointOutput__O__Lsttp_model_ResponseMetadata__Lsttp_tapir_DecodeResult(x15, body, meta).flatMap__F1__Lsttp_tapir_DecodeResult(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((p$3) => {
          var v$2 = p$3.asAny__O();
          return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lsttp_tapir_Mapping__decode__O__Lsttp_tapir_DecodeResult(x16, v$2);
        })));
        break matchResult4;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(output);
    }
    return $x_1.map__F1__Lsttp_tapir_DecodeResult(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((asAny) => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_internal_package$ParamsAsAny(asAny))));
  }
  if ((output instanceof $c_Lsttp_tapir_EndpointOutput$Void)) {
    var error$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), "Cannot convert a void output to a value!");
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_DecodeResult$Error("", error$1);
  }
  if ((output instanceof $c_Lsttp_tapir_EndpointOutput$Pair)) {
    var x84 = output.Lsttp_tapir_EndpointOutput$Pair__f_left;
    var x85 = output.Lsttp_tapir_EndpointOutput$Pair__f_right;
    var x86 = output.Lsttp_tapir_EndpointOutput$Pair__f_combine;
    return $p_Lsttp_tapir_client_ClientOutputParams__handleOutputPair__Lsttp_tapir_EndpointOutput__Lsttp_tapir_EndpointOutput__F2__O__Lsttp_model_ResponseMetadata__Lsttp_tapir_DecodeResult(this, x84, x85, x86, body, meta);
  }
  if (false) {
    var x78 = output.Lsttp_tapir_EndpointIO$Pair__f_left;
    var x79 = output.Lsttp_tapir_EndpointIO$Pair__f_right;
    var x80 = output.Lsttp_tapir_EndpointIO$Pair__f_combine;
    return $p_Lsttp_tapir_client_ClientOutputParams__handleOutputPair__Lsttp_tapir_EndpointOutput__Lsttp_tapir_EndpointOutput__F2__O__Lsttp_model_ResponseMetadata__Lsttp_tapir_DecodeResult(this, x78, x79, x80, body, meta);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(output);
});
function $p_Lsttp_tapir_internal_ShowPathTemplate$__shownPathComponents__sci_Vector__F2__s_Option__T2($thiz, inputs, showPathParam, showPathsAs) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
  var _1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector0$();
  var z = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, 1);
  var at = 0;
  var end = inputs.length__I();
  var acc = z;
  var $x_1;
  while (true) {
    if ((at !== end)) {
      var temp$at = ((1 + at) | 0);
      var x0 = acc;
      var x1 = inputs.apply__I__O(at);
      matchResult3$1: {
        var temp$acc;
        var x8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), x0, x1);
        var x9 = x8.T2__f__1;
        if ((x9 !== null)) {
          var acc$1 = x9._1__O();
          var index = (x9._2__O() | 0);
          var component = x8.T2__f__2;
          if ((component instanceof $c_Lsttp_tapir_EndpointInput$PathCapture)) {
            if ((!component.Lsttp_tapir_EndpointInput$PathCapture__f_codec.schema__Lsttp_tapir_Schema().Lsttp_tapir_Schema__f_hidden)) {
              var elem = showPathParam.apply__O__O__O(index, component);
              var _1$1 = acc$1.appended__O__O(elem);
              var _2 = ((1 + index) | 0);
              var temp$acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1$1, _2);
              break matchResult3$1;
            }
          }
          if (false) {
            if ((!component.Lsttp_tapir_EndpointInput$PathsCapture__f_codec.schema__Lsttp_tapir_Schema().Lsttp_tapir_Schema__f_hidden)) {
              if (showPathsAs.isEmpty__Z()) {
                var _1$2 = acc$1;
              } else {
                var x0$1 = showPathsAs.get__O();
                var _1$2 = acc$1.appended__O__O(x0$1);
              }
              var temp$acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1$2, index);
              break matchResult3$1;
            }
          }
          if ((component instanceof $c_Lsttp_tapir_EndpointInput$FixedPath)) {
            if ((!component.Lsttp_tapir_EndpointInput$FixedPath__f_codec.schema__Lsttp_tapir_Schema().Lsttp_tapir_Schema__f_hidden)) {
              var s = component.Lsttp_tapir_EndpointInput$FixedPath__f_s;
              var this$7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_internal_Rfc3986$();
              var allowedCharacters = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_internal_Rfc3986$().Lsttp_model_internal_Rfc3986$__f_PathSegment;
              $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_internal_Rfc3986$();
              var spaceAsPlus = false;
              $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_internal_Rfc3986$();
              var encodePlus = false;
              var elem$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$p_Lsttp_model_internal_Rfc3986$__encode__T__T__sci_Set__Z__Z__T(this$7, s, "UTF-8", allowedCharacters, spaceAsPlus, encodePlus);
              var _1$3 = acc$1.appended__O__O(elem$1);
              var temp$acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1$3, index);
              break matchResult3$1;
            }
          }
          var temp$acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), acc$1, index);
          break matchResult3$1;
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x8);
      }
      at = temp$at;
      acc = temp$acc;
      continue;
    }
    var $x_1 = acc;
    break;
  }
  return $x_1;
}
export { $p_Lsttp_tapir_internal_ShowPathTemplate$__shownPathComponents__sci_Vector__F2__s_Option__T2 as $p_Lsttp_tapir_internal_ShowPathTemplate$__shownPathComponents__sci_Vector__F2__s_Option__T2 };
function $p_Lsttp_tapir_internal_ShowPathTemplate$__shownQueryComponents__sci_Vector__F2__I__s_Option__sci_Vector($thiz, inputs, showQueryParam, pathParamCount, showQueryParamsAs) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
  var _1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector0$();
  var at = 0;
  var end = inputs.length__I();
  var acc___1 = _1;
  var acc___2 = pathParamCount;
  var $x_1___1;
  var $x_1___2;
  while (true) {
    if ((at !== end)) {
      var temp$at = ((1 + at) | 0);
      var x0___1 = acc___1;
      var x0___2 = acc___2;
      var x1 = inputs.apply__I__O(at);
      var acc$1 = x0___1;
      var index = (x0___2 | 0);
      matchResult4: {
        var temp$acc___1;
        var temp$acc___2;
        if ((x1 instanceof $c_Lsttp_tapir_EndpointInput$Query)) {
          if ((!x1.Lsttp_tapir_EndpointInput$Query__f_codec.schema__Lsttp_tapir_Schema().Lsttp_tapir_Schema__f_hidden)) {
            var elem = showQueryParam.apply__O__O__O(index, x1);
            var _1$1 = acc$1.appended__O__O(elem);
            var _2 = ((1 + index) | 0);
            var temp$acc___1 = _1$1;
            var temp$acc___2 = _2;
            break matchResult4;
          }
        }
        if (false) {
          if ((!x1.Lsttp_tapir_EndpointInput$QueryParams__f_codec.schema__Lsttp_tapir_Schema().Lsttp_tapir_Schema__f_hidden)) {
            if (showQueryParamsAs.isEmpty__Z()) {
              var _1$2 = acc$1;
            } else {
              var x0$1 = showQueryParamsAs.get__O();
              var _1$2 = acc$1.appended__O__O(x0$1);
            }
            var temp$acc___1 = _1$2;
            var temp$acc___2 = index;
            break matchResult4;
          }
        }
        var temp$acc___1 = acc$1;
        var temp$acc___2 = index;
      }
      at = temp$at;
      acc___1 = temp$acc___1;
      acc___2 = temp$acc___2;
      continue;
    }
    var $x_1___1 = acc___1;
    var $x_1___2 = acc___2;
    break;
  }
  return $x_1___1;
}
export { $p_Lsttp_tapir_internal_ShowPathTemplate$__shownQueryComponents__sci_Vector__F2__I__s_Option__sci_Vector as $p_Lsttp_tapir_internal_ShowPathTemplate$__shownQueryComponents__sci_Vector__F2__I__s_Option__sci_Vector };
/** @constructor */
function $c_Lsttp_tapir_internal_ShowPathTemplate$() {
}
export { $c_Lsttp_tapir_internal_ShowPathTemplate$ as $c_Lsttp_tapir_internal_ShowPathTemplate$ };
$c_Lsttp_tapir_internal_ShowPathTemplate$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_internal_ShowPathTemplate$.prototype.constructor = $c_Lsttp_tapir_internal_ShowPathTemplate$;
/** @constructor */
function $h_Lsttp_tapir_internal_ShowPathTemplate$() {
}
export { $h_Lsttp_tapir_internal_ShowPathTemplate$ as $h_Lsttp_tapir_internal_ShowPathTemplate$ };
$h_Lsttp_tapir_internal_ShowPathTemplate$.prototype = $c_Lsttp_tapir_internal_ShowPathTemplate$.prototype;
$c_Lsttp_tapir_internal_ShowPathTemplate$.prototype.apply__Lsttp_tapir_EndpointMetaOps__F2__s_Option__Z__T__s_Option__s_Option__T = (function(e, showPathParam, showQueryParam, includeAuth, showNoPathAs, showPathsAs, showQueryParamsAs) {
  var input = $f_Lsttp_tapir_EndpointInput__and__Lsttp_tapir_EndpointInput__Lsttp_tapir_typelevel_ParamConcat__Lsttp_tapir_EndpointInput(e.Lsttp_tapir_Endpoint__f_securityInput, e.Lsttp_tapir_Endpoint__f_input, ($m_Lsttp_tapir_typelevel_TupleOps$Join$Fold$().step__Lsttp_tapir_typelevel_TupleOps$AppendOne__Lsttp_tapir_typelevel_BinaryPolyFunc$Case(new $c_Lsttp_tapir_typelevel_TupleAppendOneInstances$$anon$28()), new $c_Lsttp_tapir_typelevel_LowPriorityTupleConcat0$$anon$12()));
  var inputs = new $c_Lsttp_tapir_internal_package$RichEndpointInput(input).asVectorOfBasicInputs__Z__sci_Vector(includeAuth);
  matchResult1: {
    var \u03b41$___1;
    var \u03b41$___2;
    var x1 = $p_Lsttp_tapir_internal_ShowPathTemplate$__shownPathComponents__sci_Vector__F2__s_Option__T2(this, inputs, showPathParam, showPathsAs);
    if ((x1 !== null)) {
      var pathComponents = x1._1__O();
      var pathParamCount = (x1._2__O() | 0);
      var \u03b41$___1 = pathComponents;
      var \u03b41$___2 = pathParamCount;
      break matchResult1;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1);
  }
  var pathComponents$2 = \u03b41$___1;
  var pathParamCount$2 = (\u03b41$___2 | 0);
  if (showQueryParam.isEmpty__Z()) {
    var this$7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0 = showQueryParam.get__O();
    var this$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($p_Lsttp_tapir_internal_ShowPathTemplate$__shownQueryComponents__sci_Vector__F2__I__s_Option__sci_Vector($m_Lsttp_tapir_internal_ShowPathTemplate$(), inputs, x0, pathParamCount$2, showQueryParamsAs));
  }
  if (this$7.isEmpty__Z()) {
    var this$8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0$1 = this$7.get__O();
    var this$8 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__mkString__T__T__T__T(x0$1, "", "&", ""));
  }
  var queryComponents = (this$8.isEmpty__Z() ? "" : this$8.get__O());
  var path = ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_SeqOps__isEmpty__Z(pathComponents$2) ? showNoPathAs : ("/" + $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__mkString__T__T__T__T(pathComponents$2, "", "/", "")));
  return (path + ((queryComponents === "") ? "" : ("?" + queryComponents)));
});
var $d_Lsttp_tapir_internal_ShowPathTemplate$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_internal_ShowPathTemplate$, "sttp.tapir.internal.ShowPathTemplate$", ({
  Lsttp_tapir_internal_ShowPathTemplate$: 1
}));
export { $d_Lsttp_tapir_internal_ShowPathTemplate$ as $d_Lsttp_tapir_internal_ShowPathTemplate$ };
var $n_Lsttp_tapir_internal_ShowPathTemplate$;
function $m_Lsttp_tapir_internal_ShowPathTemplate$() {
  if ((!$n_Lsttp_tapir_internal_ShowPathTemplate$)) {
    $n_Lsttp_tapir_internal_ShowPathTemplate$ = new $c_Lsttp_tapir_internal_ShowPathTemplate$();
  }
  return $n_Lsttp_tapir_internal_ShowPathTemplate$;
}
export { $m_Lsttp_tapir_internal_ShowPathTemplate$ as $m_Lsttp_tapir_internal_ShowPathTemplate$ };
/** @constructor */
function $c_Lsttp_tapir_internal_package$RichBody(body) {
  this.Lsttp_tapir_internal_package$RichBody__f_body = null;
  this.Lsttp_tapir_internal_package$RichBody__f_body = body;
}
export { $c_Lsttp_tapir_internal_package$RichBody as $c_Lsttp_tapir_internal_package$RichBody };
$c_Lsttp_tapir_internal_package$RichBody.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_internal_package$RichBody.prototype.constructor = $c_Lsttp_tapir_internal_package$RichBody;
/** @constructor */
function $h_Lsttp_tapir_internal_package$RichBody() {
}
export { $h_Lsttp_tapir_internal_package$RichBody as $h_Lsttp_tapir_internal_package$RichBody };
$h_Lsttp_tapir_internal_package$RichBody.prototype = $c_Lsttp_tapir_internal_package$RichBody.prototype;
$c_Lsttp_tapir_internal_package$RichBody.prototype.mediaTypeWithCharset__Lsttp_model_MediaType = (function() {
  var \u03b41$ = this.Lsttp_tapir_internal_package$RichBody__f_body.Lsttp_tapir_EndpointIO$Body__f_codec.format__Lsttp_tapir_CodecFormat().mediaType__Lsttp_model_MediaType();
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_internal_package$().charset__Lsttp_tapir_RawBodyType__s_Option(this.Lsttp_tapir_internal_package$RichBody__f_body.Lsttp_tapir_EndpointIO$Body__f_bodyType);
  if (this$1.isEmpty__Z()) {
    var charset$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0 = this$1.get__O();
    var charset$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(x0.Ljava_nio_charset_Charset__f_canonicalName);
  }
  var mainType$1 = \u03b41$.Lsttp_model_MediaType__f_mainType;
  var subType$1 = \u03b41$.Lsttp_model_MediaType__f_subType;
  var otherParameters$1 = \u03b41$.Lsttp_model_MediaType__f_otherParameters;
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_model_MediaType(mainType$1, subType$1, charset$1, otherParameters$1);
});
var $d_Lsttp_tapir_internal_package$RichBody = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_internal_package$RichBody, "sttp.tapir.internal.package$RichBody", ({
  Lsttp_tapir_internal_package$RichBody: 1
}));
export { $d_Lsttp_tapir_internal_package$RichBody as $d_Lsttp_tapir_internal_package$RichBody };
/** @constructor */
function $c_Lsttp_tapir_internal_package$RichEndpointInput(input) {
  this.Lsttp_tapir_internal_package$RichEndpointInput__f_input = null;
  this.Lsttp_tapir_internal_package$RichEndpointInput__f_input = input;
}
export { $c_Lsttp_tapir_internal_package$RichEndpointInput as $c_Lsttp_tapir_internal_package$RichEndpointInput };
$c_Lsttp_tapir_internal_package$RichEndpointInput.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_internal_package$RichEndpointInput.prototype.constructor = $c_Lsttp_tapir_internal_package$RichEndpointInput;
/** @constructor */
function $h_Lsttp_tapir_internal_package$RichEndpointInput() {
}
export { $h_Lsttp_tapir_internal_package$RichEndpointInput as $h_Lsttp_tapir_internal_package$RichEndpointInput };
$h_Lsttp_tapir_internal_package$RichEndpointInput.prototype = $c_Lsttp_tapir_internal_package$RichEndpointInput.prototype;
$c_Lsttp_tapir_internal_package$RichEndpointInput.prototype.traverseInputs__s_PartialFunction__sci_Vector = (function(handle) {
  var x37 = this.Lsttp_tapir_internal_package$RichEndpointInput__f_input;
  if ((x37 !== null)) {
    if (handle.isDefinedAt__O__Z(x37)) {
      return handle.apply__O__O(x37);
    }
  }
  if ((x37 instanceof $c_Lsttp_tapir_EndpointInput$Pair)) {
    var x55 = x37.Lsttp_tapir_EndpointInput$Pair__f_left;
    var x56 = x37.Lsttp_tapir_EndpointInput$Pair__f_right;
    var this$4 = new $c_Lsttp_tapir_internal_package$RichEndpointInput(x55).traverseInputs__s_PartialFunction__sci_Vector(handle);
    var suffix = new $c_Lsttp_tapir_internal_package$RichEndpointInput(x56).traverseInputs__s_PartialFunction__sci_Vector(handle);
    return this$4.appendedAll__sc_IterableOnce__sci_Vector(suffix);
  }
  if (false) {
    var x49 = x37.Lsttp_tapir_EndpointIO$Pair__f_left;
    var x50 = x37.Lsttp_tapir_EndpointIO$Pair__f_right;
    var this$8 = new $c_Lsttp_tapir_internal_package$RichEndpointInput(x49).traverseInputs__s_PartialFunction__sci_Vector(handle);
    var suffix$1 = new $c_Lsttp_tapir_internal_package$RichEndpointInput(x50).traverseInputs__s_PartialFunction__sci_Vector(handle);
    return this$8.appendedAll__sc_IterableOnce__sci_Vector(suffix$1);
  }
  if ((x37 instanceof $c_Lsttp_tapir_EndpointInput$MappedPair)) {
    var x45 = x37.Lsttp_tapir_EndpointInput$MappedPair__f_input;
    return new $c_Lsttp_tapir_internal_package$RichEndpointInput(x45).traverseInputs__s_PartialFunction__sci_Vector(handle);
  }
  if (false) {
    var x41 = x37.Lsttp_tapir_EndpointIO$MappedPair__f_io;
    return new $c_Lsttp_tapir_internal_package$RichEndpointInput(x41).traverseInputs__s_PartialFunction__sci_Vector(handle);
  }
  if ((x37 instanceof $c_Lsttp_tapir_EndpointInput$Auth)) {
    var input = x37.Lsttp_tapir_EndpointInput$Auth__f_input;
    return new $c_Lsttp_tapir_internal_package$RichEndpointInput(input).traverseInputs__s_PartialFunction__sci_Vector(handle);
  }
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector0$();
});
$c_Lsttp_tapir_internal_package$RichEndpointInput.prototype.asVectorOfBasicInputs__Z__sci_Vector = (function(includeAuth) {
  return this.traverseInputs__s_PartialFunction__sci_Vector(new $c_Lsttp_tapir_internal_package$RichEndpointInput$$anon$2(includeAuth));
});
$c_Lsttp_tapir_internal_package$RichEndpointInput.prototype.method__s_Option = (function() {
  var this$1 = this.traverseInputs__s_PartialFunction__sci_Vector(new $c_Lsttp_tapir_internal_package$RichEndpointInput$$anon$3());
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IndexedSeqOps__headOption__s_Option(this$1);
});
var $d_Lsttp_tapir_internal_package$RichEndpointInput = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_internal_package$RichEndpointInput, "sttp.tapir.internal.package$RichEndpointInput", ({
  Lsttp_tapir_internal_package$RichEndpointInput: 1
}));
export { $d_Lsttp_tapir_internal_package$RichEndpointInput as $d_Lsttp_tapir_internal_package$RichEndpointInput };
/** @constructor */
function $c_Lsttp_tapir_internal_package$RichEndpointOutput(output) {
  this.Lsttp_tapir_internal_package$RichEndpointOutput__f_output = null;
  this.Lsttp_tapir_internal_package$RichEndpointOutput__f_output = output;
}
export { $c_Lsttp_tapir_internal_package$RichEndpointOutput as $c_Lsttp_tapir_internal_package$RichEndpointOutput };
$c_Lsttp_tapir_internal_package$RichEndpointOutput.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_internal_package$RichEndpointOutput.prototype.constructor = $c_Lsttp_tapir_internal_package$RichEndpointOutput;
/** @constructor */
function $h_Lsttp_tapir_internal_package$RichEndpointOutput() {
}
export { $h_Lsttp_tapir_internal_package$RichEndpointOutput as $h_Lsttp_tapir_internal_package$RichEndpointOutput };
$h_Lsttp_tapir_internal_package$RichEndpointOutput.prototype = $c_Lsttp_tapir_internal_package$RichEndpointOutput.prototype;
$c_Lsttp_tapir_internal_package$RichEndpointOutput.prototype.traverseOutputs__s_PartialFunction__sci_Vector = (function(handle) {
  var x143 = this.Lsttp_tapir_internal_package$RichEndpointOutput__f_output;
  if ((x143 !== null)) {
    if (handle.isDefinedAt__O__Z(x143)) {
      return handle.apply__O__O(x143);
    }
  }
  if ((x143 instanceof $c_Lsttp_tapir_EndpointOutput$Pair)) {
    var x161 = x143.Lsttp_tapir_EndpointOutput$Pair__f_left;
    var x162 = x143.Lsttp_tapir_EndpointOutput$Pair__f_right;
    var this$4 = new $c_Lsttp_tapir_internal_package$RichEndpointOutput(x161).traverseOutputs__s_PartialFunction__sci_Vector(handle);
    var suffix = new $c_Lsttp_tapir_internal_package$RichEndpointOutput(x162).traverseOutputs__s_PartialFunction__sci_Vector(handle);
    return this$4.appendedAll__sc_IterableOnce__sci_Vector(suffix);
  }
  if (false) {
    var x155 = x143.Lsttp_tapir_EndpointIO$Pair__f_left;
    var x156 = x143.Lsttp_tapir_EndpointIO$Pair__f_right;
    var this$8 = new $c_Lsttp_tapir_internal_package$RichEndpointOutput(x155).traverseOutputs__s_PartialFunction__sci_Vector(handle);
    var suffix$1 = new $c_Lsttp_tapir_internal_package$RichEndpointOutput(x156).traverseOutputs__s_PartialFunction__sci_Vector(handle);
    return this$8.appendedAll__sc_IterableOnce__sci_Vector(suffix$1);
  }
  if ((x143 instanceof $c_Lsttp_tapir_EndpointOutput$MappedPair)) {
    var x151 = x143.Lsttp_tapir_EndpointOutput$MappedPair__f_output;
    return new $c_Lsttp_tapir_internal_package$RichEndpointOutput(x151).traverseOutputs__s_PartialFunction__sci_Vector(handle);
  }
  if (false) {
    var x147 = x143.Lsttp_tapir_EndpointIO$MappedPair__f_io;
    return new $c_Lsttp_tapir_internal_package$RichEndpointOutput(x147).traverseOutputs__s_PartialFunction__sci_Vector(handle);
  }
  if (false) {
    var this$13 = x143.Lsttp_tapir_EndpointOutput$OneOf__f_variants;
    var this$14 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$13);
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
    var b = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_VectorBuilder();
    var it = this$14.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var x0 = it.next__O();
      var output = x0.output__Lsttp_tapir_EndpointOutput();
      var elems = new $c_Lsttp_tapir_internal_package$RichEndpointOutput(output).traverseOutputs__s_PartialFunction__sci_Vector(handle);
      b.addAll__sc_IterableOnce__sci_VectorBuilder(elems);
    }
    return b.result__sci_Vector();
  }
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector0$();
});
$c_Lsttp_tapir_internal_package$RichEndpointOutput.prototype.bodyType__s_Option = (function() {
  var this$1 = this.traverseOutputs__s_PartialFunction__sci_Vector(new $c_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$4());
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IndexedSeqOps__headOption__s_Option(this$1);
});
$c_Lsttp_tapir_internal_package$RichEndpointOutput.prototype.hasOptionalBodyMatchingContent__Lsttp_model_MediaType__Z = (function(content) {
  matchResult25: {
    var contentToMatch;
    if ((content !== null)) {
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_MediaType$();
      var x206 = content.Lsttp_model_MediaType__f_charset;
      var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      if ((x === x206)) {
        var this$2 = content.Lsttp_model_MediaType__f_mainType;
        _return: {
          var len = this$2.length;
          if ((len === 4)) {
            var i = 0;
            while ((i !== len)) {
              var index = i;
              var c = this$2.charCodeAt(index);
              var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toLowerCase__C__C($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toUpperCase__C__C(c));
              var index$1 = i;
              var c$1 = "text".charCodeAt(index$1);
              if (($x_2 !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toLowerCase__C__C($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toUpperCase__C__C(c$1)))) {
                var $x_1 = false;
                break _return;
              }
              i = ((1 + i) | 0);
            }
            var $x_1 = true;
          } else {
            var $x_1 = false;
          }
        }
        if ($x_1) {
          var contentToMatch = content.charset__T__Lsttp_model_MediaType($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_nio_charset_ISO\uff3f8859\uff3f1$().Ljava_nio_charset_Charset__f_canonicalName);
          break matchResult25;
        }
      }
    }
    var contentToMatch = content;
  }
  var this$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_ContentTypeRange$();
  var mainType = contentToMatch.Lsttp_model_MediaType__f_mainType;
  var subType = contentToMatch.Lsttp_model_MediaType__f_subType;
  var this$4 = contentToMatch.Lsttp_model_MediaType__f_charset;
  var charset = (this$4.isEmpty__Z() ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_ContentTypeRange$().Lsttp_model_ContentTypeRange$__f_Wildcard : this$4.get__O());
  var contentTypeRange = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_model_ContentTypeRange(mainType, subType, charset, this$5.Lsttp_model_ContentTypeRange$__f_EmptyParameters);
  var supported = this.traverseOutputs__s_PartialFunction__sci_Vector(new $c_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$5());
  if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_SeqOps__isEmpty__Z(supported)) {
    return true;
  } else {
    var res = false;
    var it = supported.iterator__sc_Iterator();
    while (((!res) && it.hasNext__Z())) {
      var x0 = it.next__O();
      res = x0.matches__Lsttp_model_ContentTypeRange__Z(contentTypeRange);
    }
    return res;
  }
});
var $d_Lsttp_tapir_internal_package$RichEndpointOutput = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_internal_package$RichEndpointOutput, "sttp.tapir.internal.package$RichEndpointOutput", ({
  Lsttp_tapir_internal_package$RichEndpointOutput: 1
}));
export { $d_Lsttp_tapir_internal_package$RichEndpointOutput as $d_Lsttp_tapir_internal_package$RichEndpointOutput };
/** @constructor */
function $c_Lsttp_tapir_internal_package$RichStreamBody(body) {
  this.Lsttp_tapir_internal_package$RichStreamBody__f_body = null;
  this.Lsttp_tapir_internal_package$RichStreamBody__f_body = body;
}
export { $c_Lsttp_tapir_internal_package$RichStreamBody as $c_Lsttp_tapir_internal_package$RichStreamBody };
$c_Lsttp_tapir_internal_package$RichStreamBody.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_internal_package$RichStreamBody.prototype.constructor = $c_Lsttp_tapir_internal_package$RichStreamBody;
/** @constructor */
function $h_Lsttp_tapir_internal_package$RichStreamBody() {
}
export { $h_Lsttp_tapir_internal_package$RichStreamBody as $h_Lsttp_tapir_internal_package$RichStreamBody };
$h_Lsttp_tapir_internal_package$RichStreamBody.prototype = $c_Lsttp_tapir_internal_package$RichStreamBody.prototype;
$c_Lsttp_tapir_internal_package$RichStreamBody.prototype.mediaTypeWithCharset__Lsttp_model_MediaType = (function() {
  var this$1 = this.Lsttp_tapir_internal_package$RichStreamBody__f_body;
  var \u03b42$ = this$1.Lsttp_tapir_EndpointIO$StreamBodyWrapper__f_wrapped.Lsttp_tapir_StreamBodyIO__f_codec.format__Lsttp_tapir_CodecFormat().mediaType__Lsttp_model_MediaType();
  var this$2 = this.Lsttp_tapir_internal_package$RichStreamBody__f_body.Lsttp_tapir_EndpointIO$StreamBodyWrapper__f_wrapped.Lsttp_tapir_StreamBodyIO__f_charset;
  if (this$2.isEmpty__Z()) {
    var charset$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0 = this$2.get__O();
    var charset$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(x0.Ljava_nio_charset_Charset__f_canonicalName);
  }
  var mainType$2 = \u03b42$.Lsttp_model_MediaType__f_mainType;
  var subType$2 = \u03b42$.Lsttp_model_MediaType__f_subType;
  var otherParameters$2 = \u03b42$.Lsttp_model_MediaType__f_otherParameters;
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_model_MediaType(mainType$2, subType$2, charset$2, otherParameters$2);
});
var $d_Lsttp_tapir_internal_package$RichStreamBody = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_internal_package$RichStreamBody, "sttp.tapir.internal.package$RichStreamBody", ({
  Lsttp_tapir_internal_package$RichStreamBody: 1
}));
export { $d_Lsttp_tapir_internal_package$RichStreamBody as $d_Lsttp_tapir_internal_package$RichStreamBody };
function $f_Lsttp_tapir_json_circe_TapirJsonCirce__$init$__V($thiz) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$().any__Lsttp_tapir_Schema();
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$().anyObject__Lsttp_tapir_Schema();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$SName$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$SName$();
  var typeParameterShortNames = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  $x_1.name__Lsttp_tapir_Schema$SName__Lsttp_tapir_Schema(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema$SName("io.circe.JsonObject", typeParameterShortNames));
}
export { $f_Lsttp_tapir_json_circe_TapirJsonCirce__$init$__V as $f_Lsttp_tapir_json_circe_TapirJsonCirce__$init$__V };
function $f_Lsttp_tapir_json_circe_TapirJsonCirce__jsonBody__Lio_circe_Encoder__Lio_circe_Decoder__Lsttp_tapir_Schema__Lsttp_tapir_EndpointIO$Body($thiz, evidence$1, evidence$2, evidence$3) {
  var this$1 = $m_Lsttp_tapir_package$();
  var codec = $f_Lsttp_tapir_json_circe_TapirJsonCirce__circeCodec__Lio_circe_Encoder__Lio_circe_Decoder__Lsttp_tapir_Schema__Lsttp_tapir_Codec($thiz, evidence$1, evidence$2, evidence$3);
  var charset = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_nio_charset_UTF\uff3f8$();
  return $f_Lsttp_tapir_Tapir__stringBodyAnyFormat__Lsttp_tapir_Codec__Ljava_nio_charset_Charset__Lsttp_tapir_EndpointIO$Body(this$1, codec, charset);
}
export { $f_Lsttp_tapir_json_circe_TapirJsonCirce__jsonBody__Lio_circe_Encoder__Lio_circe_Decoder__Lsttp_tapir_Schema__Lsttp_tapir_EndpointIO$Body as $f_Lsttp_tapir_json_circe_TapirJsonCirce__jsonBody__Lio_circe_Encoder__Lio_circe_Decoder__Lsttp_tapir_Schema__Lsttp_tapir_EndpointIO$Body };
function $f_Lsttp_tapir_json_circe_TapirJsonCirce__circeCodec__Lio_circe_Encoder__Lio_circe_Decoder__Lsttp_tapir_Schema__Lsttp_tapir_Codec($thiz, evidence$1, evidence$2, evidence$3) {
  var this$24 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Codec$();
  var _rawDecode = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s) => {
    matchResult2: {
      var $x_1;
      var this$1 = $m_Lio_circe_parser_package$();
      var x7 = $f_Lio_circe_Parser__decodeAccumulating__T__Lio_circe_Decoder__Lcats_data_Validated(this$1, s, evidence$2);
      if ((x7 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_Validated$Valid)) {
        var x13 = x7.Lcats_data_Validated$Valid__f_a;
        var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_DecodeResult$Value(x13);
        break matchResult2;
      }
      if ((x7 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_Validated$Invalid)) {
        var x10 = x7.Lcats_data_Validated$Invalid__f_e;
        var f$2 = ((x$1) => {
          if ((x$1 instanceof $c_Lio_circe_ParsingFailure)) {
            $m_Lio_circe_ParsingFailure$();
            var x5 = x$1.Lio_circe_ParsingFailure__f_message;
            var path = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
            return new $c_Lsttp_tapir_DecodeResult$Error$JsonError(x5, path);
          }
          if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lio_circe_DecodingFailure)) {
            var path$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_CursorOp$().opsToPath__sci_List__T(x$1.history__sci_List());
            var this$8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__split__T__I__AT(path$1, "\\.", 0));
            var this$12 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$8);
            var f = ((_$1) => (_$1 !== ""));
            var l = this$12;
            block: {
              var result;
              while (true) {
                if (l.isEmpty__Z()) {
                  var result = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
                  break;
                } else {
                  var h = l.head__O();
                  var t = l.tail__O();
                  if (((!(!f(h))) === false)) {
                    l = t;
                    continue;
                  }
                  var start = l;
                  var remaining = t;
                  while (true) {
                    if (remaining.isEmpty__Z()) {
                      var result = start;
                      break block;
                    } else {
                      var x = remaining.head__O();
                      if (((!(!f(x))) !== false)) {
                        remaining = remaining.tail__O();
                        continue;
                      }
                      var firstMiss = remaining;
                      var newHead = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(start.head__O(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
                      var toProcess = start.tail__O();
                      var currentLast = newHead;
                      while ((toProcess !== firstMiss)) {
                        var newElem = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(toProcess.head__O(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
                        currentLast.sci_$colon$colon__f_next = newElem;
                        currentLast = newElem;
                        toProcess = toProcess.tail__O();
                      }
                      var next = firstMiss.tail__O();
                      var nextToCopy = next;
                      while ((!next.isEmpty__Z())) {
                        var head = next.head__O();
                        if (((!(!f(head))) !== false)) {
                          next = next.tail__O();
                        } else {
                          while ((nextToCopy !== next)) {
                            var newElem$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(nextToCopy.head__O(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
                            currentLast.sci_$colon$colon__f_next = newElem$2;
                            currentLast = newElem$2;
                            nextToCopy = nextToCopy.tail__O();
                          }
                          nextToCopy = next.tail__O();
                          next = next.tail__O();
                        }
                      }
                      if ((!nextToCopy.isEmpty__Z())) {
                        currentLast.sci_$colon$colon__f_next = nextToCopy;
                      }
                      var result = newHead;
                      break block;
                    }
                  }
                }
              }
            }
            var f$1 = ((name) => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_FieldName(name, name));
            if ((result === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
              var fields = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
            } else {
              var x0 = result.head__O();
              var h$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f$1(x0), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
              var t$1 = h$1;
              var rest = result.tail__O();
              while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
                var x0$1 = rest.head__O();
                var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f$1(x0$1), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
                t$1.sci_$colon$colon__f_next = nx;
                t$1 = nx;
                rest = rest.tail__O();
              }
              var fields = h$1;
            }
            var msg = x$1.message__T();
            return new $c_Lsttp_tapir_DecodeResult$Error$JsonError(msg, fields);
          }
          throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
        });
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_NonEmptyList$();
        var x0$2 = x10.Lcats_data_NonEmptyList__f_head;
        var head$1 = f$2(x0$2);
        var this$15 = x10.Lcats_data_NonEmptyList__f_tail;
        if ((this$15 === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
          var tail = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
        } else {
          var x0$3 = this$15.head__O();
          var h$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f$2(x0$3), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
          var t$2 = h$2;
          var rest$1 = this$15.tail__O();
          while ((rest$1 !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
            var x0$4 = rest$1.head__O();
            var nx$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f$2(x0$4), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
            t$2.sci_$colon$colon__f_next = nx$1;
            t$2 = nx$1;
            rest$1 = rest$1.tail__O();
          }
          var tail = h$2;
        }
        var tapirJsonErrors = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_NonEmptyList(head$1, tail);
        var this$17 = tapirJsonErrors.Lcats_data_NonEmptyList__f_tail;
        var elem = tapirJsonErrors.Lcats_data_NonEmptyList__f_head;
        var errors = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem, this$17);
        var underlying = new $c_Lio_circe_Errors(x10);
        var error = new $c_Lsttp_tapir_DecodeResult$Error$JsonDecodeException(errors, underlying);
        var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_DecodeResult$Error(s, error);
        break matchResult2;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x7);
    }
    return $x_1;
  }));
  var _encode = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((t$3) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_Printer$().Lio_circe_Printer$__f_noSpaces.print__Lio_circe_Json__T(evidence$1.apply__O__Lio_circe_Json(t$3))));
  return this$24.anyString__Lsttp_tapir_CodecFormat__F1__F1__Lsttp_tapir_Schema__Lsttp_tapir_Codec(new $c_Lsttp_tapir_CodecFormat$Json(), _rawDecode, _encode, evidence$3);
}
export { $f_Lsttp_tapir_json_circe_TapirJsonCirce__circeCodec__Lio_circe_Encoder__Lio_circe_Decoder__Lsttp_tapir_Schema__Lsttp_tapir_Codec as $f_Lsttp_tapir_json_circe_TapirJsonCirce__circeCodec__Lio_circe_Encoder__Lio_circe_Decoder__Lsttp_tapir_Schema__Lsttp_tapir_Codec };
/** @constructor */
function $c_Lsttp_tapir_typelevel_BinaryPolyFunc$CaseBuilder(outer) {
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lsttp_tapir_typelevel_BinaryPolyFunc$CaseBuilder as $c_Lsttp_tapir_typelevel_BinaryPolyFunc$CaseBuilder };
$c_Lsttp_tapir_typelevel_BinaryPolyFunc$CaseBuilder.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_typelevel_BinaryPolyFunc$CaseBuilder.prototype.constructor = $c_Lsttp_tapir_typelevel_BinaryPolyFunc$CaseBuilder;
/** @constructor */
function $h_Lsttp_tapir_typelevel_BinaryPolyFunc$CaseBuilder() {
}
export { $h_Lsttp_tapir_typelevel_BinaryPolyFunc$CaseBuilder as $h_Lsttp_tapir_typelevel_BinaryPolyFunc$CaseBuilder };
$h_Lsttp_tapir_typelevel_BinaryPolyFunc$CaseBuilder.prototype = $c_Lsttp_tapir_typelevel_BinaryPolyFunc$CaseBuilder.prototype;
var $d_Lsttp_tapir_typelevel_BinaryPolyFunc$CaseBuilder = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_typelevel_BinaryPolyFunc$CaseBuilder, "sttp.tapir.typelevel.BinaryPolyFunc$CaseBuilder", ({
  Lsttp_tapir_typelevel_BinaryPolyFunc$CaseBuilder: 1
}));
export { $d_Lsttp_tapir_typelevel_BinaryPolyFunc$CaseBuilder as $d_Lsttp_tapir_typelevel_BinaryPolyFunc$CaseBuilder };
/** @constructor */
function $c_Lurldsl_language_PathSegment$() {
}
export { $c_Lurldsl_language_PathSegment$ as $c_Lurldsl_language_PathSegment$ };
$c_Lurldsl_language_PathSegment$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lurldsl_language_PathSegment$.prototype.constructor = $c_Lurldsl_language_PathSegment$;
/** @constructor */
function $h_Lurldsl_language_PathSegment$() {
}
export { $h_Lurldsl_language_PathSegment$ as $h_Lurldsl_language_PathSegment$ };
$h_Lurldsl_language_PathSegment$.prototype = $c_Lurldsl_language_PathSegment$.prototype;
$c_Lurldsl_language_PathSegment$.prototype.empty__Lurldsl_language_PathSegment = (function() {
  var matching = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((segments) => {
    var value = new $c_Lurldsl_vocabulary_PathMatchOutput((void 0), segments);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value);
  }));
  var creating = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$13) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$()));
  return new $c_Lurldsl_language_PathSegment$$anon$1(matching, creating, this);
});
$c_Lurldsl_language_PathSegment$.prototype.simplePathSegment__F1__F1__Lurldsl_errors_PathMatchingError__Lurldsl_language_PathSegment = (function(matching, creating, pathMatchingError) {
  var matching$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$16) => {
    var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    if (x.equals__O__Z(_$16)) {
      var value = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lurldsl_errors_DummyError$dummyError$();
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value);
    }
    if ((_$16 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon)) {
      var x42 = _$16.sci_$colon$colon__f_next;
      var first = ((_$16.sci_$colon$colon__f_head === null) ? null : _$16.sci_$colon$colon__f_head.Lurldsl_vocabulary_Segment__f_content);
      var this$3 = matching.apply__O__O(new $c_Lurldsl_vocabulary_Segment(first));
      if ((this$3 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
        var b = this$3.s_util_Right__f_value;
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(new $c_Lurldsl_vocabulary_PathMatchOutput(b, x42));
      } else {
        return this$3;
      }
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(_$16);
  }));
  var creating$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$18) => {
    var elems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([_$18]));
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems).map__F1__sci_List(creating);
  }));
  return new $c_Lurldsl_language_PathSegment$$anon$1(matching$1, creating$1, this);
});
$c_Lurldsl_language_PathSegment$.prototype.segment__Lurldsl_vocabulary_FromString__Lurldsl_vocabulary_Printer__Lurldsl_errors_PathMatchingError__Lurldsl_language_PathSegment = (function(fromString, printer, error) {
  var this$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((str) => fromString.fromString__T__s_util_Either(str)));
  var g = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$19) => {
    var _$19$1 = ((_$19 === null) ? null : _$19.Lurldsl_vocabulary_Segment__f_content);
    return _$19$1;
  }));
  return this.simplePathSegment__F1__F1__Lurldsl_errors_PathMatchingError__Lurldsl_language_PathSegment($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_F1__compose__F1__F1(this$3, g), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((t) => new $c_Lurldsl_vocabulary_Segment($m_Lurldsl_vocabulary_Segment$().simpleSegment__O__Lurldsl_vocabulary_Printer__T(printer.print__O__T(t), $m_Lurldsl_vocabulary_Printer$().stringPrinter__Lurldsl_vocabulary_Printer())))), error);
});
$c_Lurldsl_language_PathSegment$.prototype.endOfSegments__Lurldsl_errors_PathMatchingError__Lurldsl_language_PathSegment = (function(pathMatchingError) {
  var matching = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$20) => {
    var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    if (x.equals__O__Z(_$20)) {
      var unusedSegments = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      var value = new $c_Lurldsl_vocabulary_PathMatchOutput((void 0), unusedSegments);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value);
    } else {
      var value$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lurldsl_errors_DummyError$dummyError$();
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value$1);
    }
  }));
  var creating = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$21) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$()));
  return new $c_Lurldsl_language_PathSegment$$anon$1(matching, creating, this);
});
$c_Lurldsl_language_PathSegment$.prototype.remainingSegments__Lurldsl_language_PathSegment = (function() {
  var matching = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((segments) => {
    var f = ((_$22) => {
      var _$22$1 = ((_$22 === null) ? null : _$22.Lurldsl_vocabulary_Segment__f_content);
      return _$22$1;
    });
    if ((segments === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
      var output = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    } else {
      var x0 = segments.head__O();
      var h = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      var t = h;
      var rest = segments.tail__O();
      while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
        var x0$1 = rest.head__O();
        var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0$1), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
        t.sci_$colon$colon__f_next = nx;
        t = nx;
        rest = rest.tail__O();
      }
      var output = h;
    }
    var unusedSegments = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var value = new $c_Lurldsl_vocabulary_PathMatchOutput(output, unusedSegments);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value);
  }));
  var creating = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$23) => {
    var f$1 = ((content) => new $c_Lurldsl_vocabulary_Segment(content));
    if ((_$23 === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    } else {
      var x0$2 = _$23.head__O();
      var h$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f$1(x0$2), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      var t$1 = h$1;
      var rest$1 = _$23.tail__O();
      while ((rest$1 !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
        var x0$3 = rest$1.head__O();
        var nx$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f$1(x0$3), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
        t$1.sci_$colon$colon__f_next = nx$1;
        t$1 = nx$1;
        rest$1 = rest$1.tail__O();
      }
      return h$1;
    }
  }));
  return new $c_Lurldsl_language_PathSegment$$anon$1(matching, creating, this);
});
var $d_Lurldsl_language_PathSegment$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lurldsl_language_PathSegment$, "urldsl.language.PathSegment$", ({
  Lurldsl_language_PathSegment$: 1
}));
export { $d_Lurldsl_language_PathSegment$ as $d_Lurldsl_language_PathSegment$ };
var $n_Lurldsl_language_PathSegment$;
function $m_Lurldsl_language_PathSegment$() {
  if ((!$n_Lurldsl_language_PathSegment$)) {
    $n_Lurldsl_language_PathSegment$ = new $c_Lurldsl_language_PathSegment$();
  }
  return $n_Lurldsl_language_PathSegment$;
}
export { $m_Lurldsl_language_PathSegment$ as $m_Lurldsl_language_PathSegment$ };
function $f_Lurldsl_language_PathSegmentImpl__$init$__V($thiz) {
  var this$1 = $m_Lurldsl_language_PathSegment$();
  $thiz.Lcom_raquo_waypoint_Waypoint__f_root = this$1.empty__Lurldsl_language_PathSegment();
  $m_Lurldsl_language_PathSegment$().remainingSegments__Lurldsl_language_PathSegment();
}
export { $f_Lurldsl_language_PathSegmentImpl__$init$__V as $f_Lurldsl_language_PathSegmentImpl__$init$__V };
function $f_Lurldsl_language_PathSegmentImpl__unaryPathSegment__O__Lurldsl_vocabulary_FromString__Lurldsl_vocabulary_Printer__Lurldsl_language_PathSegment($thiz, t, fromString, printer) {
  return $m_Lurldsl_language_PathSegment$().simplePathSegment__F1__F1__Lurldsl_errors_PathMatchingError__Lurldsl_language_PathSegment(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s) => {
    var s$1 = ((s === null) ? null : s.Lurldsl_vocabulary_Segment__f_content);
    var this$2 = fromString.fromString__T__s_util_Either(s$1);
    matchEnd4: {
      var this$4;
      if ((this$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
        var b = this$2.s_util_Right__f_value;
        if ((!$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(b, t))) {
          var this$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lurldsl_errors_DummyError$dummyError$());
          break matchEnd4;
        }
      }
      var this$4 = this$2;
    }
    return ((this$4 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right((void 0)) : this$4);
  })), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$3) => {
    var content = printer.print__O__T(t);
    return new $c_Lurldsl_vocabulary_Segment(content);
  })), $thiz.Lcom_raquo_waypoint_Waypoint__f_pathError);
}
export { $f_Lurldsl_language_PathSegmentImpl__unaryPathSegment__O__Lurldsl_vocabulary_FromString__Lurldsl_vocabulary_Printer__Lurldsl_language_PathSegment as $f_Lurldsl_language_PathSegmentImpl__unaryPathSegment__O__Lurldsl_vocabulary_FromString__Lurldsl_vocabulary_Printer__Lurldsl_language_PathSegment };
/** @constructor */
function $c_Lurldsl_language_QueryParameters$() {
}
export { $c_Lurldsl_language_QueryParameters$ as $c_Lurldsl_language_QueryParameters$ };
$c_Lurldsl_language_QueryParameters$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lurldsl_language_QueryParameters$.prototype.constructor = $c_Lurldsl_language_QueryParameters$;
/** @constructor */
function $h_Lurldsl_language_QueryParameters$() {
}
export { $h_Lurldsl_language_QueryParameters$ as $h_Lurldsl_language_QueryParameters$ };
$h_Lurldsl_language_QueryParameters$.prototype = $c_Lurldsl_language_QueryParameters$.prototype;
$c_Lurldsl_language_QueryParameters$.prototype.empty__Lurldsl_language_QueryParameters = (function() {
  var matching = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((params) => {
    var value = new $c_Lurldsl_vocabulary_ParamMatchOutput((void 0), params);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value);
  }));
  var creating = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$8) => {
    var this$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$();
    var elems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T2.getArrayOf().constr)([]));
    return this$4.from__sc_IterableOnce__sci_Map(elems);
  }));
  return new $c_Lurldsl_language_QueryParameters$$anon$1(matching, creating, this);
});
$c_Lurldsl_language_QueryParameters$.prototype.simpleQueryParam__T__F1__F1__F1__Lurldsl_errors_ParamMatchingError__Lurldsl_language_QueryParameters = (function(paramName, matching, creating, onParameterNotFound, paramMatchingError) {
  var matching$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((params) => {
    var this$2 = params.get__O__s_Option(paramName);
    var this$3 = (this$2.isEmpty__Z() ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$() : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(matching.apply__O__O(this$2.get__O())));
    if (this$3.isEmpty__Z()) {
      var this$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    } else {
      var x0 = this$3.get__O();
      if ((x0 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
        var b = x0.s_util_Right__f_value;
        var unusedParams = params.removed__O__sci_MapOps(paramName);
        var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(new $c_Lurldsl_vocabulary_ParamMatchOutput(b, unusedParams));
      } else {
        var $x_1 = x0;
      }
      var this$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($x_1);
    }
    return (this$5.isEmpty__Z() ? onParameterNotFound.apply__O__O(params) : this$5.get__O());
  }));
  var creating$1 = creating.andThen__F1__F1(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$11) => {
    var _$11$1 = ((_$11 === null) ? null : _$11.Lurldsl_vocabulary_Param__f_content);
    var y = new $c_Lurldsl_vocabulary_Param(_$11$1);
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), paramName, y);
  }))).andThen__F1__F1(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$12) => {
    var this$8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$();
    var elems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T2.getArrayOf().constr)([_$12]));
    return this$8.from__sc_IterableOnce__sci_Map(elems);
  })));
  return new $c_Lurldsl_language_QueryParameters$$anon$1(matching$1, creating$1, this);
});
$c_Lurldsl_language_QueryParameters$.prototype.simpleQueryParam__T__F1__F1__Lurldsl_errors_ParamMatchingError__Lurldsl_language_QueryParameters = (function(paramName, matching, creating, paramMatchingError) {
  return this.simpleQueryParam__T__F1__F1__F1__Lurldsl_errors_ParamMatchingError__Lurldsl_language_QueryParameters(paramName, matching, creating, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$13) => {
    var value = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lurldsl_errors_DummyError$dummyError$();
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value);
  })), paramMatchingError);
});
$c_Lurldsl_language_QueryParameters$.prototype.param__T__Lurldsl_vocabulary_FromString__Lurldsl_vocabulary_Printer__Lurldsl_errors_ParamMatchingError__Lurldsl_language_QueryParameters = (function(paramName, fromString, printer, paramMatchingError) {
  return this.simpleQueryParam__T__F1__F1__Lurldsl_errors_ParamMatchingError__Lurldsl_language_QueryParameters(paramName, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$14) => {
    var _$14$1 = ((_$14 === null) ? null : _$14.Lurldsl_vocabulary_Param__f_content);
    var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    if (x.equals__O__Z(_$14$1)) {
      var value = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lurldsl_errors_DummyError$dummyError$();
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value);
    }
    if ((_$14$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon)) {
      var head = _$14$1.sci_$colon$colon__f_head;
      return fromString.fromString__T__s_util_Either(head);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(new $c_Lurldsl_vocabulary_Param(_$14$1));
  })), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((q) => {
    var elems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)([printer.print__O__T(q)]));
    var content = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
    return new $c_Lurldsl_vocabulary_Param(content);
  })), paramMatchingError);
});
var $d_Lurldsl_language_QueryParameters$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lurldsl_language_QueryParameters$, "urldsl.language.QueryParameters$", ({
  Lurldsl_language_QueryParameters$: 1
}));
export { $d_Lurldsl_language_QueryParameters$ as $d_Lurldsl_language_QueryParameters$ };
var $n_Lurldsl_language_QueryParameters$;
function $m_Lurldsl_language_QueryParameters$() {
  if ((!$n_Lurldsl_language_QueryParameters$)) {
    $n_Lurldsl_language_QueryParameters$ = new $c_Lurldsl_language_QueryParameters$();
  }
  return $n_Lurldsl_language_QueryParameters$;
}
export { $m_Lurldsl_language_QueryParameters$ as $m_Lurldsl_language_QueryParameters$ };
function $f_Lurldsl_language_QueryParametersImpl__$init$__V($thiz) {
  $m_Lurldsl_language_QueryParameters$().empty__Lurldsl_language_QueryParameters();
  var this$1 = $m_Lurldsl_language_QueryParameters$();
  this$1.empty__Lurldsl_language_QueryParameters();
}
export { $f_Lurldsl_language_QueryParametersImpl__$init$__V as $f_Lurldsl_language_QueryParametersImpl__$init$__V };
function $f_Lurldsl_url_DefaultUrlStringGenerator__$init$__V($thiz) {
  $thiz.Lurldsl_url_UrlStringGenerator$__f_default0 = new $c_Lurldsl_url_DefaultUrlStringGenerator$$anon$1($thiz);
}
export { $f_Lurldsl_url_DefaultUrlStringGenerator__$init$__V as $f_Lurldsl_url_DefaultUrlStringGenerator__$init$__V };
/** @constructor */
function $c_Lurldsl_url_JSUrlStringParser$() {
  this.Lurldsl_url_JSUrlStringParser$__f_jsUrlStringParserGenerator$lzy1 = null;
  this.Lurldsl_url_JSUrlStringParser$__f_jsUrlStringParserGeneratorbitmap$1 = false;
}
export { $c_Lurldsl_url_JSUrlStringParser$ as $c_Lurldsl_url_JSUrlStringParser$ };
$c_Lurldsl_url_JSUrlStringParser$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lurldsl_url_JSUrlStringParser$.prototype.constructor = $c_Lurldsl_url_JSUrlStringParser$;
/** @constructor */
function $h_Lurldsl_url_JSUrlStringParser$() {
}
export { $h_Lurldsl_url_JSUrlStringParser$ as $h_Lurldsl_url_JSUrlStringParser$ };
$h_Lurldsl_url_JSUrlStringParser$.prototype = $c_Lurldsl_url_JSUrlStringParser$.prototype;
$c_Lurldsl_url_JSUrlStringParser$.prototype.jsUrlStringParserGenerator__Lurldsl_url_UrlStringParserGenerator = (function() {
  if ((!this.Lurldsl_url_JSUrlStringParser$__f_jsUrlStringParserGeneratorbitmap$1)) {
    this.Lurldsl_url_JSUrlStringParser$__f_jsUrlStringParserGenerator$lzy1 = new $c_Lurldsl_url_JSUrlStringParser$$anon$1(this);
    this.Lurldsl_url_JSUrlStringParser$__f_jsUrlStringParserGeneratorbitmap$1 = true;
  }
  return this.Lurldsl_url_JSUrlStringParser$__f_jsUrlStringParserGenerator$lzy1;
});
var $d_Lurldsl_url_JSUrlStringParser$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lurldsl_url_JSUrlStringParser$, "urldsl.url.JSUrlStringParser$", ({
  Lurldsl_url_JSUrlStringParser$: 1
}));
export { $d_Lurldsl_url_JSUrlStringParser$ as $d_Lurldsl_url_JSUrlStringParser$ };
var $n_Lurldsl_url_JSUrlStringParser$;
function $m_Lurldsl_url_JSUrlStringParser$() {
  if ((!$n_Lurldsl_url_JSUrlStringParser$)) {
    $n_Lurldsl_url_JSUrlStringParser$ = new $c_Lurldsl_url_JSUrlStringParser$();
  }
  return $n_Lurldsl_url_JSUrlStringParser$;
}
export { $m_Lurldsl_url_JSUrlStringParser$ as $m_Lurldsl_url_JSUrlStringParser$ };
function $f_Lurldsl_url_UrlStringDecoder__decodePath__T__sci_List($thiz, path) {
  var this$4 = $m_Lurldsl_vocabulary_Segment$().fromPath__T__sci_List(path);
  var f = ((v1) => {
    var _$1 = ((v1 === null) ? null : v1.Lurldsl_vocabulary_Segment__f_content);
    var content = $thiz.decode__T__T__T(_$1, "utf-8");
    return new $c_Lurldsl_vocabulary_Segment(content);
  });
  if ((this$4 === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  } else {
    var x0 = this$4.head__O();
    var h = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
    var t = h;
    var rest = this$4.tail__O();
    while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
      var x0$1 = rest.head__O();
      var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0$1), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      t.sci_$colon$colon__f_next = nx;
      t = nx;
      rest = rest.tail__O();
    }
    return h;
  }
}
export { $f_Lurldsl_url_UrlStringDecoder__decodePath__T__sci_List as $f_Lurldsl_url_UrlStringDecoder__decodePath__T__sci_List };
function $f_Lurldsl_url_UrlStringDecoder__decodeParams__T__sci_Map($thiz, queryString) {
  return $m_Lurldsl_vocabulary_Param$().fromQueryString__T__sci_Map(queryString).map__F1__sc_IterableOps(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 !== null)) {
      var key = x$1._1__O();
      var value = ((x$1._2__O() === null) ? null : x$1._2__O().Lurldsl_vocabulary_Param__f_content);
      var f = ((_$3) => $thiz.decode__T__T__T(_$3, "utf-8"));
      if ((value === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
        var content = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      } else {
        var x0 = value.head__O();
        var h = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
        var t = h;
        var rest = value.tail__O();
        while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
          var x0$1 = rest.head__O();
          var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0$1), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
          t.sci_$colon$colon__f_next = nx;
          t = nx;
          rest = rest.tail__O();
        }
        var content = h;
      }
      var y = new $c_Lurldsl_vocabulary_Param(content);
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), key, y);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  })));
}
export { $f_Lurldsl_url_UrlStringDecoder__decodeParams__T__sci_Map as $f_Lurldsl_url_UrlStringDecoder__decodeParams__T__sci_Map };
function $f_Lurldsl_url_UrlStringGenerator__makePath__sci_List__T($thiz, segments) {
  var f = ((_$1) => {
    var _$1$1 = ((_$1 === null) ? null : _$1.Lurldsl_vocabulary_Segment__f_content);
    return _$1$1;
  });
  if ((segments === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
    var this$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  } else {
    var x0 = segments.head__O();
    var h = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
    var t = h;
    var rest = segments.tail__O();
    while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
      var x0$1 = rest.head__O();
      var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0$1), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      t.sci_$colon$colon__f_next = nx;
      t = nx;
      rest = rest.tail__O();
    }
    var this$3 = h;
  }
  var f$1 = ((_$2) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$dp_toString__T(encodeURIComponent(_$2)));
  if ((this$3 === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
    var this$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  } else {
    var x0$2 = this$3.head__O();
    var h$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f$1(x0$2), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
    var t$1 = h$1;
    var rest$1 = this$3.tail__O();
    while ((rest$1 !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
      var x0$3 = rest$1.head__O();
      var nx$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f$1(x0$3), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      t$1.sci_$colon$colon__f_next = nx$1;
      t$1 = nx$1;
      rest$1 = rest$1.tail__O();
    }
    var this$6 = h$1;
  }
  var f$2 = ((_$3) => (_$3 !== ""));
  var l = this$6;
  block: {
    var result;
    while (true) {
      if (l.isEmpty__Z()) {
        var result = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
        break;
      } else {
        var h$2 = l.head__O();
        var t$2 = l.tail__O();
        if (((!(!f$2(h$2))) === false)) {
          l = t$2;
          continue;
        }
        var start = l;
        var remaining = t$2;
        while (true) {
          if (remaining.isEmpty__Z()) {
            var result = start;
            break block;
          } else {
            var x = remaining.head__O();
            if (((!(!f$2(x))) !== false)) {
              remaining = remaining.tail__O();
              continue;
            }
            var firstMiss = remaining;
            var newHead = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(start.head__O(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
            var toProcess = start.tail__O();
            var currentLast = newHead;
            while ((toProcess !== firstMiss)) {
              var newElem = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(toProcess.head__O(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
              currentLast.sci_$colon$colon__f_next = newElem;
              currentLast = newElem;
              toProcess = toProcess.tail__O();
            }
            var next = firstMiss.tail__O();
            var nextToCopy = next;
            while ((!next.isEmpty__Z())) {
              var head = next.head__O();
              if (((!(!f$2(head))) !== false)) {
                next = next.tail__O();
              } else {
                while ((nextToCopy !== next)) {
                  var newElem$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(nextToCopy.head__O(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
                  currentLast.sci_$colon$colon__f_next = newElem$2;
                  currentLast = newElem$2;
                  nextToCopy = nextToCopy.tail__O();
                }
                nextToCopy = next.tail__O();
                next = next.tail__O();
              }
            }
            if ((!nextToCopy.isEmpty__Z())) {
              currentLast.sci_$colon$colon__f_next = nextToCopy;
            }
            var result = newHead;
            break block;
          }
        }
      }
    }
  }
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__mkString__T__T__T__T(result, "", "/", "");
}
export { $f_Lurldsl_url_UrlStringGenerator__makePath__sci_List__T as $f_Lurldsl_url_UrlStringGenerator__makePath__sci_List__T };
function $f_Lurldsl_url_UrlStringGenerator__makeParamsMap__sci_Map__sci_Map($thiz, params) {
  return params.map__F1__sc_IterableOps(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 !== null)) {
      var key = x$1._1__O();
      var value = ((x$1._2__O() === null) ? null : x$1._2__O().Lurldsl_vocabulary_Param__f_content);
      var f = ((_$4) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$dp_toString__T(encodeURIComponent(_$4)));
      if ((value === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
        var y = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      } else {
        var x0 = value.head__O();
        var h = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
        var t = h;
        var rest = value.tail__O();
        while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
          var x0$1 = rest.head__O();
          var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0$1), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
          t.sci_$colon$colon__f_next = nx;
          t = nx;
          rest = rest.tail__O();
        }
        var y = h;
      }
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), key, y);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  })));
}
export { $f_Lurldsl_url_UrlStringGenerator__makeParamsMap__sci_Map__sci_Map as $f_Lurldsl_url_UrlStringGenerator__makeParamsMap__sci_Map__sci_Map };
function $f_Lurldsl_url_UrlStringGenerator__makeParams__sci_Map__T($thiz, params) {
  var this$1 = $f_Lurldsl_url_UrlStringGenerator__makeParamsMap__sci_Map__sci_Map($thiz, params).flatMap__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 !== null)) {
      var key = x$1._1__O();
      var values = x$1._2__O();
      var f = ((value) => ((key + "=") + value));
      if ((values === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      } else {
        var x0 = values.head__O();
        var h = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
        var t = h;
        var rest = values.tail__O();
        while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
          var x0$1 = rest.head__O();
          var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0$1), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
          t.sci_$colon$colon__f_next = nx;
          t = nx;
          rest = rest.tail__O();
        }
        return h;
      }
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  })));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__mkString__T__T__T__T(this$1, "", "&", "");
}
export { $f_Lurldsl_url_UrlStringGenerator__makeParams__sci_Map__T as $f_Lurldsl_url_UrlStringGenerator__makeParams__sci_Map__T };
/** @constructor */
function $c_Lurldsl_vocabulary_Param$() {
}
export { $c_Lurldsl_vocabulary_Param$ as $c_Lurldsl_vocabulary_Param$ };
$c_Lurldsl_vocabulary_Param$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lurldsl_vocabulary_Param$.prototype.constructor = $c_Lurldsl_vocabulary_Param$;
/** @constructor */
function $h_Lurldsl_vocabulary_Param$() {
}
export { $h_Lurldsl_vocabulary_Param$ as $h_Lurldsl_vocabulary_Param$ };
$h_Lurldsl_vocabulary_Param$.prototype = $c_Lurldsl_vocabulary_Param$.prototype;
$c_Lurldsl_vocabulary_Param$.prototype.fromQueryString__T__sci_Map = (function(queryString) {
  var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Predef$();
  _return: {
    var len = queryString.length;
    var i = 0;
    while ((i < len)) {
      var index = i;
      var x0 = queryString.charCodeAt(index);
      if ((x0 !== 63)) {
        var x1 = i;
        break _return;
      }
      i = ((1 + i) | 0);
    }
    var x1 = (-1);
  }
  var this$4 = ((x1 === (-1)) ? "" : queryString.substring(x1));
  var xs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__split__T__I__AT(this$4, "&", 0);
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_reflect_ClassTag$();
  var this$8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$objectGetClass(xs);
  var evidence$1 = $x_1.apply__jl_Class__s_reflect_ClassTag(this$8.data.getComponentType());
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1.runtimeClass__jl_Class();
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_C.getClassOf());
  jsElems = [];
  var i$1 = 0;
  while ((i$1 < xs.u.length)) {
    var x1$1 = i$1;
    var x = xs.u[x1$1];
    if ((x !== "")) {
      var unboxedElem = (isCharArrayBuilder ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uC(x) : ((x === null) ? elementClass.data.zero : x));
      jsElems.push(unboxedElem);
    }
    i$1 = ((1 + i$1) | 0);
  }
  var elemRuntimeClass = ((elementClass === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_V.getClassOf()) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_jl_Void.getClassOf() : (((elementClass === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_sr_Null$.getClassOf()) || (elementClass === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_sr_Nothing$.getClassOf())) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_O.getClassOf() : elementClass));
  var xs$1 = elemRuntimeClass.data.getArrayOf().wrapArray(jsElems);
  var len$1 = xs$1.u.length;
  var ys = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_sci_List.getArrayOf().constr)(len$1);
  if ((len$1 > 0)) {
    var i$2 = 0;
    while ((i$2 < len$1)) {
      var $x_2 = i$2;
      var x0$1 = xs$1.u[i$2];
      var this$17 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__split__T__I__AT(x0$1, "=", 0));
      ys.u[$x_2] = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$17);
      i$2 = ((1 + i$2) | 0);
    }
  }
  var this$19 = $x_3.wrapRefArray__AO__scm_ArraySeq$ofRef(ys);
  var this$21 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$19).collect__s_PartialFunction__sci_List(new $c_Lurldsl_vocabulary_Param$$anon$1(this));
  var m = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_scm_Map$().empty__O();
  var it = this$21.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var elem = it.next__O();
    var key = elem._1__O();
    var bldr = m.getOrElseUpdate__O__F0__O(key, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_ListBuffer())));
    bldr.addOne__O__scm_Growable(elem);
  }
  var this$23 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_HashMap$();
  var result = this$23.sci_HashMap$__f_EmptyMap;
  var mapIt = m.iterator__sc_Iterator();
  while (mapIt.hasNext__Z()) {
    var x1$2 = mapIt.next__O();
    if ((x1$2 === null)) {
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1$2);
    }
    var k = x1$2._1__O();
    var v = x1$2._2__O();
    result = result.updated__O__O__sci_HashMap(k, v.result__O());
  }
  var this$24 = result;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_HashMap$();
  var b = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_HashMapBuilder();
  var it$1 = this$24.iterator__sc_Iterator();
  while (it$1.hasNext__Z()) {
    var x0$2 = it$1.next__O();
    matchResult6: {
      var elem$1___1;
      var elem$1___2;
      if ((x0$2 !== null)) {
        var key$1 = x0$2._1__O();
        var value = x0$2._2__O();
        var f = ((_$5) => _$5._2__O());
        if ((value === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
          var y = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
        } else {
          var x0$3 = value.head__O();
          var h = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0$3), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
          var t = h;
          var rest = value.tail__O();
          while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
            var x0$4 = rest.head__O();
            var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0$4), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
            t.sci_$colon$colon__f_next = nx;
            t = nx;
            rest = rest.tail__O();
          }
          var y = h;
        }
        var elem$1___1 = key$1;
        var elem$1___2 = y;
        break matchResult6;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x0$2);
    }
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$p_sci_HashMapBuilder__ensureUnaliased__V(b);
    var x$1 = elem$1___1;
    var h$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$1);
    var im = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Hashing$().improve__I__I(h$1);
    b.update__sci_MapNode__O__O__I__I__I__V(b.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, elem$1___1, elem$1___2, h$1, im, 0);
  }
  var this$29 = b.result__sci_HashMap();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_HashMap$();
  var b$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_HashMapBuilder();
  var it$2 = this$29.iterator__sc_Iterator();
  while (it$2.hasNext__Z()) {
    var x0$5 = it$2.next__O();
    matchResult7: {
      var elem$2___1;
      var elem$2___2;
      if ((x0$5 !== null)) {
        var key$2 = x0$5._1__O();
        var value$1 = x0$5._2__O();
        var y$1 = new $c_Lurldsl_vocabulary_Param(value$1);
        var elem$2___1 = key$2;
        var elem$2___2 = y$1;
        break matchResult7;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x0$5);
    }
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$p_sci_HashMapBuilder__ensureUnaliased__V(b$1);
    var x$2 = elem$2___1;
    var h$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$2);
    var im$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Hashing$().improve__I__I(h$2);
    b$1.update__sci_MapNode__O__O__I__I__I__V(b$1.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, elem$2___1, elem$2___2, h$2, im$1, 0);
  }
  return b$1.result__sci_HashMap();
});
$c_Lurldsl_vocabulary_Param$.prototype.equals$extension__sci_List__O__Z = (function(this$, x$0) {
  if ((x$0 instanceof $c_Lurldsl_vocabulary_Param)) {
    var x$0$2 = ((x$0 === null) ? null : x$0.Lurldsl_vocabulary_Param__f_content);
    return ((this$ === null) ? (x$0$2 === null) : this$.equals__O__Z(x$0$2));
  } else {
    return false;
  }
});
$c_Lurldsl_vocabulary_Param$.prototype.toString$extension__sci_List__T = (function(this$) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(new $c_Lurldsl_vocabulary_Param(this$));
});
$c_Lurldsl_vocabulary_Param$.prototype.productElement$extension__sci_List__I__O = (function(this$, n) {
  if ((n === 0)) {
    return this$;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lurldsl_vocabulary_Param$.prototype.productElementName$extension__sci_List__I__T = (function(this$, n) {
  if ((n === 0)) {
    return "content";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lurldsl_vocabulary_Param$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lurldsl_vocabulary_Param$, "urldsl.vocabulary.Param$", ({
  Lurldsl_vocabulary_Param$: 1
}));
export { $d_Lurldsl_vocabulary_Param$ as $d_Lurldsl_vocabulary_Param$ };
var $n_Lurldsl_vocabulary_Param$;
function $m_Lurldsl_vocabulary_Param$() {
  if ((!$n_Lurldsl_vocabulary_Param$)) {
    $n_Lurldsl_vocabulary_Param$ = new $c_Lurldsl_vocabulary_Param$();
  }
  return $n_Lurldsl_vocabulary_Param$;
}
export { $m_Lurldsl_vocabulary_Param$ as $m_Lurldsl_vocabulary_Param$ };
/** @constructor */
function $c_Lurldsl_vocabulary_Printer$() {
}
export { $c_Lurldsl_vocabulary_Printer$ as $c_Lurldsl_vocabulary_Printer$ };
$c_Lurldsl_vocabulary_Printer$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lurldsl_vocabulary_Printer$.prototype.constructor = $c_Lurldsl_vocabulary_Printer$;
/** @constructor */
function $h_Lurldsl_vocabulary_Printer$() {
}
export { $h_Lurldsl_vocabulary_Printer$ as $h_Lurldsl_vocabulary_Printer$ };
$h_Lurldsl_vocabulary_Printer$.prototype = $c_Lurldsl_vocabulary_Printer$.prototype;
$c_Lurldsl_vocabulary_Printer$.prototype.stringPrinter__Lurldsl_vocabulary_Printer = (function() {
  var printing = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x) => x));
  return new $c_Lurldsl_vocabulary_Printer$$anon$1(printing, this);
});
var $d_Lurldsl_vocabulary_Printer$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lurldsl_vocabulary_Printer$, "urldsl.vocabulary.Printer$", ({
  Lurldsl_vocabulary_Printer$: 1
}));
export { $d_Lurldsl_vocabulary_Printer$ as $d_Lurldsl_vocabulary_Printer$ };
var $n_Lurldsl_vocabulary_Printer$;
function $m_Lurldsl_vocabulary_Printer$() {
  if ((!$n_Lurldsl_vocabulary_Printer$)) {
    $n_Lurldsl_vocabulary_Printer$ = new $c_Lurldsl_vocabulary_Printer$();
  }
  return $n_Lurldsl_vocabulary_Printer$;
}
export { $m_Lurldsl_vocabulary_Printer$ as $m_Lurldsl_vocabulary_Printer$ };
/** @constructor */
function $c_Lurldsl_vocabulary_Segment$() {
}
export { $c_Lurldsl_vocabulary_Segment$ as $c_Lurldsl_vocabulary_Segment$ };
$c_Lurldsl_vocabulary_Segment$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lurldsl_vocabulary_Segment$.prototype.constructor = $c_Lurldsl_vocabulary_Segment$;
/** @constructor */
function $h_Lurldsl_vocabulary_Segment$() {
}
export { $h_Lurldsl_vocabulary_Segment$ as $h_Lurldsl_vocabulary_Segment$ };
$h_Lurldsl_vocabulary_Segment$.prototype = $c_Lurldsl_vocabulary_Segment$.prototype;
$c_Lurldsl_vocabulary_Segment$.prototype.simpleSegment__O__Lurldsl_vocabulary_Printer__T = (function(t, printer) {
  var content = printer.print__O__T(t);
  return content;
});
$c_Lurldsl_vocabulary_Segment$.prototype.fromPath__T__sci_List = (function(path) {
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Predef$();
  _return: {
    var len = path.length;
    var i = 0;
    while ((i < len)) {
      var index = i;
      var x0 = path.charCodeAt(index);
      if ((x0 !== 47)) {
        var x1 = i;
        break _return;
      }
      i = ((1 + i) | 0);
    }
    var x1 = (-1);
  }
  var this$4 = ((x1 === (-1)) ? "" : path.substring(x1));
  var this$5 = $x_1.wrapRefArray__AO__scm_ArraySeq$ofRef($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__split__T__I__AT(this$4, "/", 0));
  var this$9 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$5);
  var f = ((_$2) => (_$2 !== ""));
  var l = this$9;
  block: {
    var result;
    while (true) {
      if (l.isEmpty__Z()) {
        var result = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
        break;
      } else {
        var h = l.head__O();
        var t = l.tail__O();
        if (((!(!f(h))) === false)) {
          l = t;
          continue;
        }
        var start = l;
        var remaining = t;
        while (true) {
          if (remaining.isEmpty__Z()) {
            var result = start;
            break block;
          } else {
            var x = remaining.head__O();
            if (((!(!f(x))) !== false)) {
              remaining = remaining.tail__O();
              continue;
            }
            var firstMiss = remaining;
            var newHead = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(start.head__O(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
            var toProcess = start.tail__O();
            var currentLast = newHead;
            while ((toProcess !== firstMiss)) {
              var newElem = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(toProcess.head__O(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
              currentLast.sci_$colon$colon__f_next = newElem;
              currentLast = newElem;
              toProcess = toProcess.tail__O();
            }
            var next = firstMiss.tail__O();
            var nextToCopy = next;
            while ((!next.isEmpty__Z())) {
              var head = next.head__O();
              if (((!(!f(head))) !== false)) {
                next = next.tail__O();
              } else {
                while ((nextToCopy !== next)) {
                  var newElem$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(nextToCopy.head__O(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
                  currentLast.sci_$colon$colon__f_next = newElem$2;
                  currentLast = newElem$2;
                  nextToCopy = nextToCopy.tail__O();
                }
                nextToCopy = next.tail__O();
                next = next.tail__O();
              }
            }
            if ((!nextToCopy.isEmpty__Z())) {
              currentLast.sci_$colon$colon__f_next = nextToCopy;
            }
            var result = newHead;
            break block;
          }
        }
      }
    }
  }
  var f$1 = ((content) => new $c_Lurldsl_vocabulary_Segment(content));
  if ((result === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  } else {
    var x0$1 = result.head__O();
    var h$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f$1(x0$1), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
    var t$1 = h$1;
    var rest = result.tail__O();
    while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
      var x0$2 = rest.head__O();
      var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f$1(x0$2), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      t$1.sci_$colon$colon__f_next = nx;
      t$1 = nx;
      rest = rest.tail__O();
    }
    return h$1;
  }
});
$c_Lurldsl_vocabulary_Segment$.prototype.equals$extension__T__O__Z = (function(this$, x$0) {
  if ((x$0 instanceof $c_Lurldsl_vocabulary_Segment)) {
    var x$0$2 = ((x$0 === null) ? null : x$0.Lurldsl_vocabulary_Segment__f_content);
    return (this$ === x$0$2);
  } else {
    return false;
  }
});
$c_Lurldsl_vocabulary_Segment$.prototype.toString$extension__T__T = (function(this$) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(new $c_Lurldsl_vocabulary_Segment(this$));
});
$c_Lurldsl_vocabulary_Segment$.prototype.productElement$extension__T__I__O = (function(this$, n) {
  if ((n === 0)) {
    return this$;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lurldsl_vocabulary_Segment$.prototype.productElementName$extension__T__I__T = (function(this$, n) {
  if ((n === 0)) {
    return "content";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lurldsl_vocabulary_Segment$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lurldsl_vocabulary_Segment$, "urldsl.vocabulary.Segment$", ({
  Lurldsl_vocabulary_Segment$: 1
}));
export { $d_Lurldsl_vocabulary_Segment$ as $d_Lurldsl_vocabulary_Segment$ };
var $n_Lurldsl_vocabulary_Segment$;
function $m_Lurldsl_vocabulary_Segment$() {
  if ((!$n_Lurldsl_vocabulary_Segment$)) {
    $n_Lurldsl_vocabulary_Segment$ = new $c_Lurldsl_vocabulary_Segment$();
  }
  return $n_Lurldsl_vocabulary_Segment$;
}
export { $m_Lurldsl_vocabulary_Segment$ as $m_Lurldsl_vocabulary_Segment$ };
/** @constructor */
function $c_Lyantl_ValidatorRule$() {
}
export { $c_Lyantl_ValidatorRule$ as $c_Lyantl_ValidatorRule$ };
$c_Lyantl_ValidatorRule$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lyantl_ValidatorRule$.prototype.constructor = $c_Lyantl_ValidatorRule$;
/** @constructor */
function $h_Lyantl_ValidatorRule$() {
}
export { $h_Lyantl_ValidatorRule$ as $h_Lyantl_ValidatorRule$ };
$h_Lyantl_ValidatorRule$.prototype = $c_Lyantl_ValidatorRule$.prototype;
$c_Lyantl_ValidatorRule$.prototype.maxLength__I__Lyantl_ValidatorRule = (function(maxLength) {
  var getLength = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => _$2.length));
  return new $c_Lyantl_ValidatorRule$$anon$10(getLength, maxLength);
});
var $d_Lyantl_ValidatorRule$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lyantl_ValidatorRule$, "yantl.ValidatorRule$", ({
  Lyantl_ValidatorRule$: 1
}));
export { $d_Lyantl_ValidatorRule$ as $d_Lyantl_ValidatorRule$ };
var $n_Lyantl_ValidatorRule$;
function $m_Lyantl_ValidatorRule$() {
  if ((!$n_Lyantl_ValidatorRule$)) {
    $n_Lyantl_ValidatorRule$ = new $c_Lyantl_ValidatorRule$();
  }
  return $n_Lyantl_ValidatorRule$;
}
export { $m_Lyantl_ValidatorRule$ as $m_Lyantl_ValidatorRule$ };
/** @constructor */
function $c_Lyantl_ValidatorRule$English$() {
}
export { $c_Lyantl_ValidatorRule$English$ as $c_Lyantl_ValidatorRule$English$ };
$c_Lyantl_ValidatorRule$English$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lyantl_ValidatorRule$English$.prototype.constructor = $c_Lyantl_ValidatorRule$English$;
/** @constructor */
function $h_Lyantl_ValidatorRule$English$() {
}
export { $h_Lyantl_ValidatorRule$English$ as $h_Lyantl_ValidatorRule$English$ };
$h_Lyantl_ValidatorRule$English$.prototype = $c_Lyantl_ValidatorRule$English$.prototype;
$c_Lyantl_ValidatorRule$English$.prototype.plural__J__T__T__T = (function(count, singular, plural) {
  return (((count.RTLong__f_lo === 1) && (count.RTLong__f_hi === 0)) ? singular : plural);
});
var $d_Lyantl_ValidatorRule$English$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lyantl_ValidatorRule$English$, "yantl.ValidatorRule$English$", ({
  Lyantl_ValidatorRule$English$: 1
}));
export { $d_Lyantl_ValidatorRule$English$ as $d_Lyantl_ValidatorRule$English$ };
var $n_Lyantl_ValidatorRule$English$;
function $m_Lyantl_ValidatorRule$English$() {
  if ((!$n_Lyantl_ValidatorRule$English$)) {
    $n_Lyantl_ValidatorRule$English$ = new $c_Lyantl_ValidatorRule$English$();
  }
  return $n_Lyantl_ValidatorRule$English$;
}
export { $m_Lyantl_ValidatorRule$English$ as $m_Lyantl_ValidatorRule$English$ };
/** @constructor */
function $c_Lcats_ParallelArityFunctions2() {
}
export { $c_Lcats_ParallelArityFunctions2 as $c_Lcats_ParallelArityFunctions2 };
$c_Lcats_ParallelArityFunctions2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_ParallelArityFunctions2.prototype.constructor = $c_Lcats_ParallelArityFunctions2;
/** @constructor */
function $h_Lcats_ParallelArityFunctions2() {
}
export { $h_Lcats_ParallelArityFunctions2 as $h_Lcats_ParallelArityFunctions2 };
$h_Lcats_ParallelArityFunctions2.prototype = $c_Lcats_ParallelArityFunctions2.prototype;
function $ct_Lcats_data_AndThenInstances0__($thiz) {
  new $c_Lcats_data_AndThenInstances0$$anon$1();
  return $thiz;
}
export { $ct_Lcats_data_AndThenInstances0__ as $ct_Lcats_data_AndThenInstances0__ };
/** @constructor */
function $c_Lcats_data_AndThenInstances0() {
}
export { $c_Lcats_data_AndThenInstances0 as $c_Lcats_data_AndThenInstances0 };
$c_Lcats_data_AndThenInstances0.prototype = new $h_Lcats_data_AndThenInstances1();
$c_Lcats_data_AndThenInstances0.prototype.constructor = $c_Lcats_data_AndThenInstances0;
/** @constructor */
function $h_Lcats_data_AndThenInstances0() {
}
export { $h_Lcats_data_AndThenInstances0 as $h_Lcats_data_AndThenInstances0 };
$h_Lcats_data_AndThenInstances0.prototype = $c_Lcats_data_AndThenInstances0.prototype;
/** @constructor */
function $c_Lcats_data_EitherTInstances2() {
}
export { $c_Lcats_data_EitherTInstances2 as $c_Lcats_data_EitherTInstances2 };
$c_Lcats_data_EitherTInstances2.prototype = new $h_Lcats_data_EitherTInstances3();
$c_Lcats_data_EitherTInstances2.prototype.constructor = $c_Lcats_data_EitherTInstances2;
/** @constructor */
function $h_Lcats_data_EitherTInstances2() {
}
export { $h_Lcats_data_EitherTInstances2 as $h_Lcats_data_EitherTInstances2 };
$h_Lcats_data_EitherTInstances2.prototype = $c_Lcats_data_EitherTInstances2.prototype;
/** @constructor */
function $c_Lcats_data_IndexedStateT(runF) {
  this.Lcats_data_IndexedStateT__f_runF = null;
  this.Lcats_data_IndexedStateT__f_runF = runF;
}
export { $c_Lcats_data_IndexedStateT as $c_Lcats_data_IndexedStateT };
$c_Lcats_data_IndexedStateT.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_data_IndexedStateT.prototype.constructor = $c_Lcats_data_IndexedStateT;
/** @constructor */
function $h_Lcats_data_IndexedStateT() {
}
export { $h_Lcats_data_IndexedStateT as $h_Lcats_data_IndexedStateT };
$h_Lcats_data_IndexedStateT.prototype = $c_Lcats_data_IndexedStateT.prototype;
$c_Lcats_data_IndexedStateT.prototype.flatMap__F1__Lcats_FlatMap__Lcats_data_IndexedStateT = (function(fas, F) {
  var runF = F.map__O__F1__O(this.Lcats_data_IndexedStateT__f_runF, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((safsba) => $m_Lcats_data_AndThen$().apply__F1__Lcats_data_AndThen(safsba).andThen__F1__Lcats_data_AndThen(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((fsba) => F.flatMap__O__F1__O(fsba, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 !== null)) {
      var sb = x$1._1__O();
      var a = x$1._2__O();
      return fas.apply__O__O(a).run__O__Lcats_FlatMap__O(sb, F);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  })))))))));
  return new $c_Lcats_data_IndexedStateT(runF);
});
$c_Lcats_data_IndexedStateT.prototype.run__O__Lcats_FlatMap__O = (function(initial, F) {
  return F.flatMap__O__F1__O(this.Lcats_data_IndexedStateT__f_runF, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((f) => f.apply__O__O(initial))));
});
$c_Lcats_data_IndexedStateT.prototype.runA__O__Lcats_FlatMap__O = (function(s, F) {
  return F.map__O__F1__O(this.run__O__Lcats_FlatMap__O(s, F), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$6) => _$6._2__O())));
});
var $d_Lcats_data_IndexedStateT = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_data_IndexedStateT, "cats.data.IndexedStateT", ({
  Lcats_data_IndexedStateT: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_data_IndexedStateT as $d_Lcats_data_IndexedStateT };
/** @constructor */
function $c_Lcats_data_IndexedStateTInstances3() {
}
export { $c_Lcats_data_IndexedStateTInstances3 as $c_Lcats_data_IndexedStateTInstances3 };
$c_Lcats_data_IndexedStateTInstances3.prototype = new $h_Lcats_data_IndexedStateTInstances4();
$c_Lcats_data_IndexedStateTInstances3.prototype.constructor = $c_Lcats_data_IndexedStateTInstances3;
/** @constructor */
function $h_Lcats_data_IndexedStateTInstances3() {
}
export { $h_Lcats_data_IndexedStateTInstances3 as $h_Lcats_data_IndexedStateTInstances3 };
$h_Lcats_data_IndexedStateTInstances3.prototype = $c_Lcats_data_IndexedStateTInstances3.prototype;
/** @constructor */
function $c_Lcats_data_KleisliInstances8() {
}
export { $c_Lcats_data_KleisliInstances8 as $c_Lcats_data_KleisliInstances8 };
$c_Lcats_data_KleisliInstances8.prototype = new $h_Lcats_data_KleisliInstances9();
$c_Lcats_data_KleisliInstances8.prototype.constructor = $c_Lcats_data_KleisliInstances8;
/** @constructor */
function $h_Lcats_data_KleisliInstances8() {
}
export { $h_Lcats_data_KleisliInstances8 as $h_Lcats_data_KleisliInstances8 };
$h_Lcats_data_KleisliInstances8.prototype = $c_Lcats_data_KleisliInstances8.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptyChainInstances2() {
}
export { $c_Lcats_data_NonEmptyChainInstances2 as $c_Lcats_data_NonEmptyChainInstances2 };
$c_Lcats_data_NonEmptyChainInstances2.prototype = new $h_Lcats_data_NonEmptyChainInstances3();
$c_Lcats_data_NonEmptyChainInstances2.prototype.constructor = $c_Lcats_data_NonEmptyChainInstances2;
/** @constructor */
function $h_Lcats_data_NonEmptyChainInstances2() {
}
export { $h_Lcats_data_NonEmptyChainInstances2 as $h_Lcats_data_NonEmptyChainInstances2 };
$h_Lcats_data_NonEmptyChainInstances2.prototype = $c_Lcats_data_NonEmptyChainInstances2.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptyMapInstances() {
}
export { $c_Lcats_data_NonEmptyMapInstances as $c_Lcats_data_NonEmptyMapInstances };
$c_Lcats_data_NonEmptyMapInstances.prototype = new $h_Lcats_data_NonEmptyMapInstances0();
$c_Lcats_data_NonEmptyMapInstances.prototype.constructor = $c_Lcats_data_NonEmptyMapInstances;
/** @constructor */
function $h_Lcats_data_NonEmptyMapInstances() {
}
export { $h_Lcats_data_NonEmptyMapInstances as $h_Lcats_data_NonEmptyMapInstances };
$h_Lcats_data_NonEmptyMapInstances.prototype = $c_Lcats_data_NonEmptyMapInstances.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptySetInstances0() {
}
export { $c_Lcats_data_NonEmptySetInstances0 as $c_Lcats_data_NonEmptySetInstances0 };
$c_Lcats_data_NonEmptySetInstances0.prototype = new $h_Lcats_data_NonEmptySetInstances1();
$c_Lcats_data_NonEmptySetInstances0.prototype.constructor = $c_Lcats_data_NonEmptySetInstances0;
/** @constructor */
function $h_Lcats_data_NonEmptySetInstances0() {
}
export { $h_Lcats_data_NonEmptySetInstances0 as $h_Lcats_data_NonEmptySetInstances0 };
$h_Lcats_data_NonEmptySetInstances0.prototype = $c_Lcats_data_NonEmptySetInstances0.prototype;
/** @constructor */
function $c_Lcats_data_OptionTInstances2() {
}
export { $c_Lcats_data_OptionTInstances2 as $c_Lcats_data_OptionTInstances2 };
$c_Lcats_data_OptionTInstances2.prototype = new $h_Lcats_data_OptionTInstances3();
$c_Lcats_data_OptionTInstances2.prototype.constructor = $c_Lcats_data_OptionTInstances2;
/** @constructor */
function $h_Lcats_data_OptionTInstances2() {
}
export { $h_Lcats_data_OptionTInstances2 as $h_Lcats_data_OptionTInstances2 };
$h_Lcats_data_OptionTInstances2.prototype = $c_Lcats_data_OptionTInstances2.prototype;
/** @constructor */
function $c_Lcats_data_package$() {
  this.Lcats_data_package$__f_NonEmptyMap = null;
  this.Lcats_data_package$__f_NonEmptySet = null;
  this.Lcats_data_package$__f_NonEmptyChain = null;
  $n_Lcats_data_package$ = this;
  this.Lcats_data_package$__f_NonEmptyMap = $m_Lcats_data_NonEmptyMapImpl$();
  this.Lcats_data_package$__f_NonEmptySet = $m_Lcats_data_NonEmptySetImpl$();
  this.Lcats_data_package$__f_NonEmptyChain = $m_Lcats_data_NonEmptyChainImpl$();
  $m_Lcats_data_Kleisli$();
}
export { $c_Lcats_data_package$ as $c_Lcats_data_package$ };
$c_Lcats_data_package$.prototype = new $h_Lcats_data_ScalaVersionSpecificPackage();
$c_Lcats_data_package$.prototype.constructor = $c_Lcats_data_package$;
/** @constructor */
function $h_Lcats_data_package$() {
}
export { $h_Lcats_data_package$ as $h_Lcats_data_package$ };
$h_Lcats_data_package$.prototype = $c_Lcats_data_package$.prototype;
var $d_Lcats_data_package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_data_package$, "cats.data.package$", ({
  Lcats_data_package$: 1,
  Lcats_data_ScalaVersionSpecificPackage: 1
}));
export { $d_Lcats_data_package$ as $d_Lcats_data_package$ };
var $n_Lcats_data_package$;
function $m_Lcats_data_package$() {
  if ((!$n_Lcats_data_package$)) {
    $n_Lcats_data_package$ = new $c_Lcats_data_package$();
  }
  return $n_Lcats_data_package$;
}
export { $m_Lcats_data_package$ as $m_Lcats_data_package$ };
/** @constructor */
function $c_Lcats_derived_DerivedOrder$package$DerivedOrder$Product$$anon$2() {
}
export { $c_Lcats_derived_DerivedOrder$package$DerivedOrder$Product$$anon$2 as $c_Lcats_derived_DerivedOrder$package$DerivedOrder$Product$$anon$2 };
$c_Lcats_derived_DerivedOrder$package$DerivedOrder$Product$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_derived_DerivedOrder$package$DerivedOrder$Product$$anon$2.prototype.constructor = $c_Lcats_derived_DerivedOrder$package$DerivedOrder$Product$$anon$2;
/** @constructor */
function $h_Lcats_derived_DerivedOrder$package$DerivedOrder$Product$$anon$2() {
}
export { $h_Lcats_derived_DerivedOrder$package$DerivedOrder$Product$$anon$2 as $h_Lcats_derived_DerivedOrder$package$DerivedOrder$Product$$anon$2 };
$h_Lcats_derived_DerivedOrder$package$DerivedOrder$Product$$anon$2.prototype = $c_Lcats_derived_DerivedOrder$package$DerivedOrder$Product$$anon$2.prototype;
$c_Lcats_derived_DerivedOrder$package$DerivedOrder$Product$$anon$2.prototype.toString__T = (function() {
  return "<function4>";
});
$c_Lcats_derived_DerivedOrder$package$DerivedOrder$Product$$anon$2.prototype.apply__O__O__O__O__O = (function(acc, ord, t0, t1) {
  var cmp = ord.compare__O__O__I(t0, t1);
  var c$proxy1 = (cmp !== 0);
  return (c$proxy1 ? new $c_Lshapeless3_deriving_Complete(cmp) : acc);
});
var $d_Lcats_derived_DerivedOrder$package$DerivedOrder$Product$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_derived_DerivedOrder$package$DerivedOrder$Product$$anon$2, "cats.derived.DerivedOrder$package$DerivedOrder$Product$$anon$2", ({
  Lcats_derived_DerivedOrder$package$DerivedOrder$Product$$anon$2: 1,
  F4: 1
}));
export { $d_Lcats_derived_DerivedOrder$package$DerivedOrder$Product$$anon$2 as $d_Lcats_derived_DerivedOrder$package$DerivedOrder$Product$$anon$2 };
/** @constructor */
function $c_Lcats_derived_DerivedShow$package$DerivedShow$Coproduct$$anon$2() {
}
export { $c_Lcats_derived_DerivedShow$package$DerivedShow$Coproduct$$anon$2 as $c_Lcats_derived_DerivedShow$package$DerivedShow$Coproduct$$anon$2 };
$c_Lcats_derived_DerivedShow$package$DerivedShow$Coproduct$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_derived_DerivedShow$package$DerivedShow$Coproduct$$anon$2.prototype.constructor = $c_Lcats_derived_DerivedShow$package$DerivedShow$Coproduct$$anon$2;
/** @constructor */
function $h_Lcats_derived_DerivedShow$package$DerivedShow$Coproduct$$anon$2() {
}
export { $h_Lcats_derived_DerivedShow$package$DerivedShow$Coproduct$$anon$2 as $h_Lcats_derived_DerivedShow$package$DerivedShow$Coproduct$$anon$2 };
$h_Lcats_derived_DerivedShow$package$DerivedShow$Coproduct$$anon$2.prototype = $c_Lcats_derived_DerivedShow$package$DerivedShow$Coproduct$$anon$2.prototype;
$c_Lcats_derived_DerivedShow$package$DerivedShow$Coproduct$$anon$2.prototype.toString__T = (function() {
  return "<function2>";
});
$c_Lcats_derived_DerivedShow$package$DerivedShow$Coproduct$$anon$2.prototype.apply__O__O__O = (function(st, t) {
  return st.show__O__T(t);
});
var $d_Lcats_derived_DerivedShow$package$DerivedShow$Coproduct$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_derived_DerivedShow$package$DerivedShow$Coproduct$$anon$2, "cats.derived.DerivedShow$package$DerivedShow$Coproduct$$anon$2", ({
  Lcats_derived_DerivedShow$package$DerivedShow$Coproduct$$anon$2: 1,
  F2: 1
}));
export { $d_Lcats_derived_DerivedShow$package$DerivedShow$Coproduct$$anon$2 as $d_Lcats_derived_DerivedShow$package$DerivedShow$Coproduct$$anon$2 };
/** @constructor */
function $c_Lcats_derived_DerivedShow$package$DerivedShow$Product$$anon$1() {
}
export { $c_Lcats_derived_DerivedShow$package$DerivedShow$Product$$anon$1 as $c_Lcats_derived_DerivedShow$package$DerivedShow$Product$$anon$1 };
$c_Lcats_derived_DerivedShow$package$DerivedShow$Product$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_derived_DerivedShow$package$DerivedShow$Product$$anon$1.prototype.constructor = $c_Lcats_derived_DerivedShow$package$DerivedShow$Product$$anon$1;
/** @constructor */
function $h_Lcats_derived_DerivedShow$package$DerivedShow$Product$$anon$1() {
}
export { $h_Lcats_derived_DerivedShow$package$DerivedShow$Product$$anon$1 as $h_Lcats_derived_DerivedShow$package$DerivedShow$Product$$anon$1 };
$h_Lcats_derived_DerivedShow$package$DerivedShow$Product$$anon$1.prototype = $c_Lcats_derived_DerivedShow$package$DerivedShow$Product$$anon$1.prototype;
$c_Lcats_derived_DerivedShow$package$DerivedShow$Product$$anon$1.prototype.toString__T = (function() {
  return "<function2>";
});
$c_Lcats_derived_DerivedShow$package$DerivedShow$Product$$anon$1.prototype.apply__O__O__O = (function(show, x) {
  return show.show__O__T(x);
});
var $d_Lcats_derived_DerivedShow$package$DerivedShow$Product$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_derived_DerivedShow$package$DerivedShow$Product$$anon$1, "cats.derived.DerivedShow$package$DerivedShow$Product$$anon$1", ({
  Lcats_derived_DerivedShow$package$DerivedShow$Product$$anon$1: 1,
  F2: 1
}));
export { $d_Lcats_derived_DerivedShow$package$DerivedShow$Product$$anon$1 as $d_Lcats_derived_DerivedShow$package$DerivedShow$Product$$anon$1 };
/** @constructor */
function $c_Lcats_effect_IO() {
}
export { $c_Lcats_effect_IO as $c_Lcats_effect_IO };
$c_Lcats_effect_IO.prototype = new $h_Lcats_effect_IOPlatform();
$c_Lcats_effect_IO.prototype.constructor = $c_Lcats_effect_IO;
/** @constructor */
function $h_Lcats_effect_IO() {
}
export { $h_Lcats_effect_IO as $h_Lcats_effect_IO };
$h_Lcats_effect_IO.prototype = $c_Lcats_effect_IO.prototype;
$c_Lcats_effect_IO.prototype.as__O__Lcats_effect_IO = (function(b) {
  return this.map__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => b)));
});
$c_Lcats_effect_IO.prototype.flatMap__F1__Lcats_effect_IO = (function(f) {
  var event = $m_Lcats_effect_tracing_Tracing$().calculateTracingEvent__F1__Lcats_effect_tracing_TracingEvent(f);
  return new $c_Lcats_effect_IO$FlatMap(this, f, event);
});
$c_Lcats_effect_IO.prototype.flatTap__F1__Lcats_effect_IO = (function(f) {
  return this.flatMap__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((a) => f.apply__O__O(a).as__O__Lcats_effect_IO(a))));
});
$c_Lcats_effect_IO.prototype.guarantee__Lcats_effect_IO__Lcats_effect_IO = (function(finalizer) {
  return $m_Lcats_effect_IO$().uncancelable__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((poll) => {
    var onError = new $c_Lcats_effect_IO$$anon$1(finalizer);
    var this$2 = poll.apply__O__O(this);
    return new $c_Lcats_effect_IO$OnCancel(this$2, finalizer).onError__s_PartialFunction__Lcats_effect_IO(onError).flatTap__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$10) => finalizer)));
  })));
});
$c_Lcats_effect_IO.prototype.guaranteeCase__F1__Lcats_effect_IO = (function(finalizer) {
  return $m_Lcats_effect_IO$().uncancelable__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((poll) => {
    var this$4 = poll.apply__O__O(this);
    var fin = finalizer.apply__O__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Canceled());
    var finalized = new $c_Lcats_effect_IO$OnCancel(this$4, fin);
    var onError = new $c_Lcats_effect_IO$$anon$2(finalizer);
    return finalized.onError__s_PartialFunction__Lcats_effect_IO(onError).flatTap__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((a) => {
      $m_Lcats_effect_IO$();
      var fa = new $c_Lcats_effect_IO$Pure(a);
      return finalizer.apply__O__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Succeeded(fa));
    })));
  })));
});
$c_Lcats_effect_IO.prototype.handleError__F1__Lcats_effect_IO = (function(f) {
  return this.handleErrorWith__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((t) => {
    $m_Lcats_effect_IO$();
    var value = f.apply__O__O(t);
    return new $c_Lcats_effect_IO$Pure(value);
  })));
});
$c_Lcats_effect_IO.prototype.handleErrorWith__F1__Lcats_effect_IO = (function(f) {
  var event = $m_Lcats_effect_tracing_Tracing$().calculateTracingEvent__F1__Lcats_effect_tracing_TracingEvent(f);
  return new $c_Lcats_effect_IO$HandleErrorWith(this, f, event);
});
$c_Lcats_effect_IO.prototype.recover__s_PartialFunction__Lcats_effect_IO = (function(pf) {
  return this.handleErrorWith__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((e) => pf.andThen__F1__s_PartialFunction(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$12) => {
    $m_Lcats_effect_IO$();
    return new $c_Lcats_effect_IO$Pure(_$12);
  }))).applyOrElse__O__F1__O(e, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((t) => {
    $m_Lcats_effect_IO$();
    return new $c_Lcats_effect_IO$Error(t);
  }))))));
});
$c_Lcats_effect_IO.prototype.map__F1__Lcats_effect_IO = (function(f) {
  var event = $m_Lcats_effect_tracing_Tracing$().calculateTracingEvent__F1__Lcats_effect_tracing_TracingEvent(f);
  return new $c_Lcats_effect_IO$Map(this, f, event);
});
$c_Lcats_effect_IO.prototype.onError__s_PartialFunction__Lcats_effect_IO = (function(pf) {
  return this.handleErrorWith__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((t) => {
    var this$3 = pf.applyOrElse__O__F1__O(t, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$13) => $m_Lcats_effect_IO$().Lcats_effect_IO$__f__unit)));
    $m_Lcats_effect_IO$();
    var that = new $c_Lcats_effect_IO$Error(t);
    return this$3.productR__Lcats_effect_IO__Lcats_effect_IO(that);
  })));
});
$c_Lcats_effect_IO.prototype.timeoutTo__s_concurrent_duration_Duration__Lcats_effect_IO__Lcats_effect_IO = (function(duration, fallback) {
  if ((duration instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_FiniteDuration)) {
    return $m_Lcats_effect_IO$().uncancelable__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((finiteDuration$2) => ((poll) => {
      var this$3 = $m_Lcats_effect_IO$();
      var that = this$3.sleep__s_concurrent_duration_Duration__Lcats_effect_IO(finiteDuration$2);
      $m_Lcats_effect_IO$();
      return poll.apply__O__O(new $c_Lcats_effect_IO$RacePair(this, that)).flatMap__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((poll$2) => ((x$1) => {
        if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
          var x27 = x$1.s_util_Left__f_value;
          if ((x27 !== null)) {
            var oc = x27._1__O();
            var f = x27._2__O();
            var this$8 = f.cancel__O();
            var this$7 = poll$2.apply__O__O(($m_Lcats_effect_IO$(), $m_Lcats_effect_IO$Canceled$()));
            var that$1 = $m_Lcats_effect_IO$().Lcats_effect_IO$__f__never;
            var that$2 = $f_Lcats_effect_kernel_Outcome__embed__O__Lcats_effect_kernel_MonadCancel__O(oc, this$7.productR__Lcats_effect_IO__Lcats_effect_IO(that$1), $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO);
            return this$8.productR__Lcats_effect_IO__Lcats_effect_IO(that$2);
          }
        }
        if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
          var x23 = x$1.s_util_Right__f_value;
          if ((x23 !== null)) {
            var f$2 = x23._1__O();
            var this$14 = f$2.cancel__O();
            var that$3 = f$2.join__O().flatMap__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((oc$2) => {
              matchResult1: {
                var $x_1;
                if ((oc$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Canceled)) {
                  var $x_1 = fallback;
                  break matchResult1;
                }
                if ((oc$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Errored)) {
                  var x7 = oc$2.Lcats_effect_kernel_Outcome$Errored__f_e;
                  $m_Lcats_effect_IO$();
                  var $x_1 = new $c_Lcats_effect_IO$Error(x7);
                  break matchResult1;
                }
                if ((oc$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Succeeded)) {
                  var x4 = oc$2.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
                  var $x_1 = x4;
                  break matchResult1;
                }
                throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(oc$2);
              }
              return $x_1;
            })));
            return this$14.productR__Lcats_effect_IO__Lcats_effect_IO(that$3);
          }
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
      }))(poll)));
    }))(duration)));
  }
  var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Inf;
  if (((x === null) ? (duration === null) : x.equals__O__Z(duration))) {
    return this;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), ("Duration must be either a `FiniteDuration` or `Duration.Inf`, but got: " + duration));
});
$c_Lcats_effect_IO.prototype.productL__Lcats_effect_IO__Lcats_effect_IO = (function(that) {
  return this.flatMap__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((a) => that.as__O__Lcats_effect_IO(a))));
});
$c_Lcats_effect_IO.prototype.productR__Lcats_effect_IO__Lcats_effect_IO = (function(that) {
  return this.flatMap__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$18) => that)));
});
$c_Lcats_effect_IO.prototype.uncancelable__Lcats_effect_IO = (function() {
  return $m_Lcats_effect_IO$().uncancelable__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$19) => this)));
});
$c_Lcats_effect_IO.prototype.void__Lcats_effect_IO = (function() {
  return this.map__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$20) => (void 0))));
});
$c_Lcats_effect_IO.prototype.reportError__s_$less$colon$less__Lcats_effect_IO = (function(ev) {
  return this.handleErrorWith__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((t) => ($m_Lcats_effect_IO$(), $m_Lcats_effect_IO$ReadEC$()).flatMap__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((t$2) => ((ec) => {
    var this$2 = $m_Lcats_effect_IO$();
    var thunk = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((ec$2) => (() => {
      ec$2.reportFailure__jl_Throwable__V(t$2);
    }))(ec));
    return this$2.delay__F0__Lcats_effect_IO(thunk);
  }))(t))))));
});
$c_Lcats_effect_IO.prototype.toString__T = (function() {
  return "IO(...)";
});
$c_Lcats_effect_IO.prototype.unsafeRunAsyncImpl__F1__Lcats_effect_unsafe_IORuntime__Lcats_effect_IOFiber = (function(cb, runtime) {
  return this.unsafeRunFiber__F0__F1__F1__Z__Lcats_effect_unsafe_IORuntime__Lcats_effect_IOFiber(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    var value = new $c_ju_concurrent_CancellationException("The fiber was canceled");
    cb.apply__O__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value));
  })), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((t) => {
    if ((!$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(t))) {
      t.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err);
    }
    cb.apply__O__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(t));
  })), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((a) => {
    cb.apply__O__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(a));
  })), true, runtime);
});
$c_Lcats_effect_IO.prototype.unsafeRunAndForget__Lcats_effect_unsafe_IORuntime__V = (function(runtime) {
  this.unsafeRunFiber__F0__F1__F1__Z__Lcats_effect_unsafe_IORuntime__Lcats_effect_IOFiber(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => (void 0))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((t) => {
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(t)) {
      if (runtime.Lcats_effect_unsafe_IORuntime__f_config.Lcats_effect_unsafe_IORuntimeConfig__f_reportUnhandledFiberErrors) {
        runtime.Lcats_effect_unsafe_IORuntime__f_compute.reportFailure__jl_Throwable__V(t);
      }
    } else {
      t.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err);
    }
  })), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$23) => (void 0))), true, runtime);
});
$c_Lcats_effect_IO.prototype.unsafeToFuture__Lcats_effect_unsafe_IORuntime__s_concurrent_Future = (function(runtime) {
  return this.unsafeToFutureCancelable__Lcats_effect_unsafe_IORuntime__T2(runtime)._1__O();
});
$c_Lcats_effect_IO.prototype.unsafeToFutureCancelable__Lcats_effect_unsafe_IORuntime__T2 = (function(runtime) {
  var p = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
  var fiber = this.unsafeRunFiber__F0__F1__F1__Z__Lcats_effect_unsafe_IORuntime__Lcats_effect_IOFiber(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    var cause = new $c_ju_concurrent_CancellationException("The fiber was canceled");
    $f_s_concurrent_Promise__failure__jl_Throwable__s_concurrent_Promise(p, cause);
  })), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((cause$1) => {
    $f_s_concurrent_Promise__failure__jl_Throwable__s_concurrent_Promise(p, cause$1);
  })), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((value) => {
    $f_s_concurrent_Promise__success__O__s_concurrent_Promise(p, value);
  })), true, runtime);
  var _2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => fiber.cancel__Lcats_effect_IO().unsafeToFuture__Lcats_effect_unsafe_IORuntime__s_concurrent_Future(runtime)));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), p, _2);
});
$c_Lcats_effect_IO.prototype.unsafeRunFiber__F0__F1__F1__Z__Lcats_effect_unsafe_IORuntime__Lcats_effect_IOFiber = (function(canceled, failure, success, registerCallback, runtime) {
  var fiber = new $c_Lcats_effect_IOFiber($m_Lcats_effect_package$IOLocalState$().Lcats_effect_package$IOLocalState$__f_empty, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((oc) => {
    if (registerCallback) {
      runtime.Lcats_effect_unsafe_IORuntime__f_fiberErrorCbs.remove__F1__V(failure);
    }
    matchResult1: {
      if ((oc instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Canceled)) {
        canceled.apply__O();
        break matchResult1;
      }
      if ((oc instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Errored)) {
        var x7 = oc.Lcats_effect_kernel_Outcome$Errored__f_e;
        failure.apply__O__O(x7);
        break matchResult1;
      }
      if ((oc instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Succeeded)) {
        var x4 = oc.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
        success.apply__O__O(x4.Lcats_effect_IO$Pure__f_value);
        break matchResult1;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(oc);
    }
  })), this, runtime.Lcats_effect_unsafe_IORuntime__f_compute, runtime);
  if (registerCallback) {
    runtime.Lcats_effect_unsafe_IORuntime__f_fiberErrorCbs.put__F1__V(failure);
  }
  runtime.Lcats_effect_unsafe_IORuntime__f_compute.execute__jl_Runnable__V(fiber);
  return fiber;
});
/** @constructor */
function $c_Lcats_effect_IOFiber$$anon$2(cb$12, outer) {
  this.Lcats_effect_IOFiber$$anon$2__f_cb$11 = null;
  this.Lcats_effect_IOFiber$$anon$2__f_cb$11 = cb$12;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lcats_effect_IOFiber$$anon$2 as $c_Lcats_effect_IOFiber$$anon$2 };
$c_Lcats_effect_IOFiber$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_IOFiber$$anon$2.prototype.constructor = $c_Lcats_effect_IOFiber$$anon$2;
/** @constructor */
function $h_Lcats_effect_IOFiber$$anon$2() {
}
export { $h_Lcats_effect_IOFiber$$anon$2 as $h_Lcats_effect_IOFiber$$anon$2 };
$h_Lcats_effect_IOFiber$$anon$2.prototype = $c_Lcats_effect_IOFiber$$anon$2.prototype;
$c_Lcats_effect_IOFiber$$anon$2.prototype.run__V = (function() {
  var cb$7 = this.Lcats_effect_IOFiber$$anon$2__f_cb$11;
  cb$7.apply__O__O($m_Lcats_effect_IOFiber$().Lcats_effect_IOFiber$__f_RightUnit);
});
var $d_Lcats_effect_IOFiber$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IOFiber$$anon$2, "cats.effect.IOFiber$$anon$2", ({
  Lcats_effect_IOFiber$$anon$2: 1,
  jl_Runnable: 1
}));
export { $d_Lcats_effect_IOFiber$$anon$2 as $d_Lcats_effect_IOFiber$$anon$2 };
/** @constructor */
function $c_Lcats_effect_instances_package$spawn$() {
}
export { $c_Lcats_effect_instances_package$spawn$ as $c_Lcats_effect_instances_package$spawn$ };
$c_Lcats_effect_instances_package$spawn$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_instances_package$spawn$.prototype.constructor = $c_Lcats_effect_instances_package$spawn$;
/** @constructor */
function $h_Lcats_effect_instances_package$spawn$() {
}
export { $h_Lcats_effect_instances_package$spawn$ as $h_Lcats_effect_instances_package$spawn$ };
$h_Lcats_effect_instances_package$spawn$.prototype = $c_Lcats_effect_instances_package$spawn$.prototype;
var $d_Lcats_effect_instances_package$spawn$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_instances_package$spawn$, "cats.effect.instances.package$spawn$", ({
  Lcats_effect_instances_package$spawn$: 1,
  Lcats_effect_kernel_instances_GenSpawnInstances: 1
}));
export { $d_Lcats_effect_instances_package$spawn$ as $d_Lcats_effect_instances_package$spawn$ };
var $n_Lcats_effect_instances_package$spawn$;
function $m_Lcats_effect_instances_package$spawn$() {
  if ((!$n_Lcats_effect_instances_package$spawn$)) {
    $n_Lcats_effect_instances_package$spawn$ = new $c_Lcats_effect_instances_package$spawn$();
  }
  return $n_Lcats_effect_instances_package$spawn$;
}
export { $m_Lcats_effect_instances_package$spawn$ as $m_Lcats_effect_instances_package$spawn$ };
function $f_Lcats_effect_kernel_Fiber__joinWith__O__Lcats_effect_kernel_MonadCancel__O($thiz, onCancel, F) {
  var target = $thiz.join__O();
  var this$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => $f_Lcats_effect_kernel_Outcome__embed__O__Lcats_effect_kernel_MonadCancel__O(_$2, onCancel, F)));
  return this$2.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$2.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
}
export { $f_Lcats_effect_kernel_Fiber__joinWith__O__Lcats_effect_kernel_MonadCancel__O as $f_Lcats_effect_kernel_Fiber__joinWith__O__Lcats_effect_kernel_MonadCancel__O };
function $f_Lcats_effect_kernel_Fiber__joinWithUnit__Lcats_effect_kernel_MonadCancel__s_$less$colon$less__O($thiz, F, ev) {
  return $f_Lcats_effect_kernel_Fiber__joinWith__O__Lcats_effect_kernel_MonadCancel__O($thiz, F.unit__O(), F);
}
export { $f_Lcats_effect_kernel_Fiber__joinWithUnit__Lcats_effect_kernel_MonadCancel__s_$less$colon$less__O as $f_Lcats_effect_kernel_Fiber__joinWithUnit__Lcats_effect_kernel_MonadCancel__s_$less$colon$less__O };
/** @constructor */
function $c_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2(F$8) {
  this.Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2__f_F$6 = null;
  this.Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2__f_F$6 = F$8;
}
export { $c_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2 as $c_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2 };
$c_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2.prototype.constructor = $c_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2;
/** @constructor */
function $h_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2() {
}
export { $h_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2 as $h_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2 };
$h_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2.prototype = $c_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2.prototype;
$c_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2.prototype.refOf__O__O = (function(a) {
  return this.Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2__f_F$6.delay__F0__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    var F = this.Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2__f_F$6;
    return new $c_Lcats_effect_kernel_SyncRef(a, F);
  })));
});
var $d_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2, "cats.effect.kernel.Ref$MakeLowPriorityInstances$$anon$2", ({
  Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2: 1,
  Lcats_effect_kernel_Ref$Make: 1
}));
export { $d_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2 as $d_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2 };
function $ps_Lcats_effect_kernel_Resource__Nil$lzyINIT1$1__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$2$(Nil$lzy1$1) {
  if ((Nil$lzy1$1 === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  return (Nil$lzy1$1.sr_LazyRef__f__initialized ? Nil$lzy1$1.sr_LazyRef__f__value : Nil$lzy1$1.initialize__O__O(new $c_Lcats_effect_kernel_Resource$Nil$2$()));
}
export { $ps_Lcats_effect_kernel_Resource__Nil$lzyINIT1$1__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$2$ as $ps_Lcats_effect_kernel_Resource__Nil$lzyINIT1$1__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$2$ };
function $ps_Lcats_effect_kernel_Resource__Nil$1__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$2$(Nil$lzy1$2) {
  return (Nil$lzy1$2.sr_LazyRef__f__initialized ? Nil$lzy1$2.sr_LazyRef__f__value : $ps_Lcats_effect_kernel_Resource__Nil$lzyINIT1$1__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$2$(Nil$lzy1$2));
}
export { $ps_Lcats_effect_kernel_Resource__Nil$1__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$2$ as $ps_Lcats_effect_kernel_Resource__Nil$1__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$2$ };
function $p_Lcats_effect_kernel_Resource__Frame$lzyINIT1$1__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$3$($thiz, Frame$lzy1$1) {
  if ((Frame$lzy1$1 === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  return (Frame$lzy1$1.sr_LazyRef__f__initialized ? Frame$lzy1$1.sr_LazyRef__f__value : Frame$lzy1$1.initialize__O__O(new $c_Lcats_effect_kernel_Resource$Frame$3$($thiz)));
}
export { $p_Lcats_effect_kernel_Resource__Frame$lzyINIT1$1__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$3$ as $p_Lcats_effect_kernel_Resource__Frame$lzyINIT1$1__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$3$ };
function $p_Lcats_effect_kernel_Resource__Frame$2__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$3$($thiz, Frame$lzy1$2) {
  return (Frame$lzy1$2.sr_LazyRef__f__initialized ? Frame$lzy1$2.sr_LazyRef__f__value : $p_Lcats_effect_kernel_Resource__Frame$lzyINIT1$1__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$3$($thiz, Frame$lzy1$2));
}
export { $p_Lcats_effect_kernel_Resource__Frame$2__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$3$ as $p_Lcats_effect_kernel_Resource__Frame$2__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$3$ };
function $p_Lcats_effect_kernel_Resource__loop$1__Lcats_effect_kernel_MonadCancel__F1__F2__sr_LazyRef__sr_LazyRef__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource$Stack$1__O($thiz, F$1, onOutput$1, onRelease$1, Nil$lzy1$3, Frame$lzy1$3, current, stack) {
  var stack$tailLocal1 = stack;
  var current$tailLocal1 = current;
  while (true) {
    var x25 = current$tailLocal1;
    if ((x25 instanceof $c_Lcats_effect_kernel_Resource$Allocate)) {
      var x38 = x25.Lcats_effect_kernel_Resource$Allocate__f_resource;
      var stack$tailLocal1$2$1 = stack$tailLocal1;
      return F$1.bracketFull__F1__F1__F2__O(x38, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((stack$tailLocal1$2, onOutput$1, Nil$lzy1$3, Frame$lzy1$3, F$1, onRelease$1) => ((x$1) => {
        if ((x$1 !== null)) {
          var a = x$1._1__O();
          var x = $ps_Lcats_effect_kernel_Resource__Nil$1__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$2$(Nil$lzy1$3);
          if ((x === stack$tailLocal1$2)) {
            return onOutput$1.apply__O__O(a);
          }
          if ((stack$tailLocal1$2 instanceof $c_Lcats_effect_kernel_Resource$Frame$1)) {
            $p_Lcats_effect_kernel_Resource__Frame$2__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$3$($thiz, Frame$lzy1$3);
            var x10 = stack$tailLocal1$2.Lcats_effect_kernel_Resource$Frame$1__f_head;
            var x11 = stack$tailLocal1$2.Lcats_effect_kernel_Resource$Frame$1__f_tail;
            var current$1 = x10.apply__O__O(a);
            return $p_Lcats_effect_kernel_Resource__loop$1__Lcats_effect_kernel_MonadCancel__F1__F2__sr_LazyRef__sr_LazyRef__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource$Stack$1__O($thiz, F$1, onOutput$1, onRelease$1, Nil$lzy1$3, Frame$lzy1$3, current$1, x11);
          }
          throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(stack$tailLocal1$2);
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
      }))(stack$tailLocal1$2$1, onOutput$1, Nil$lzy1$3, Frame$lzy1$3, F$1, onRelease$1)), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((onRelease$1) => ((x$1$2, x$2) => {
        var x15 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), x$1$2, x$2);
        var x16 = x15.T2__f__1;
        if ((x16 !== null)) {
          var release = x16._2__O();
          var outcome = x15.T2__f__2;
          return onRelease$1.apply__O__O__O(release, $m_Lcats_effect_kernel_Resource$ExitCase$().fromOutcome__Lcats_effect_kernel_Outcome__Lcats_effect_kernel_Resource$ExitCase(outcome));
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x15);
      }))(onRelease$1)));
    }
    if (false) {
      var x34 = x25.Lcats_effect_kernel_Resource$Bind__f_source;
      var x35 = x25.Lcats_effect_kernel_Resource$Bind__f_fs;
      var stack$tailLocal1$tmp1 = $p_Lcats_effect_kernel_Resource__Frame$2__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$3$($thiz, Frame$lzy1$3).apply__F1__Lcats_effect_kernel_Resource$Stack$1__Lcats_effect_kernel_Resource$Frame$1(x35, stack$tailLocal1);
      current$tailLocal1 = x34;
      stack$tailLocal1 = stack$tailLocal1$tmp1;
      continue;
    }
    if ((x25 instanceof $c_Lcats_effect_kernel_Resource$Pure)) {
      var x31 = x25.Lcats_effect_kernel_Resource$Pure__f_a;
      var x20 = stack$tailLocal1;
      var x$3 = $ps_Lcats_effect_kernel_Resource__Nil$1__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$2$(Nil$lzy1$3);
      if ((x$3 === x20)) {
        return onOutput$1.apply__O__O(x31);
      }
      if ((x20 instanceof $c_Lcats_effect_kernel_Resource$Frame$1)) {
        $p_Lcats_effect_kernel_Resource__Frame$2__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$3$($thiz, Frame$lzy1$3);
        var x23 = x20.Lcats_effect_kernel_Resource$Frame$1__f_head;
        var x24 = x20.Lcats_effect_kernel_Resource$Frame$1__f_tail;
        var current$tailLocal1$tmp2 = x23.apply__O__O(x31);
        current$tailLocal1 = current$tailLocal1$tmp2;
        stack$tailLocal1 = x24;
        continue;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x20);
    }
    if ((x25 instanceof $c_Lcats_effect_kernel_Resource$Eval)) {
      var x28 = x25.Lcats_effect_kernel_Resource$Eval__f_fa;
      var this$12 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(x28, F$1);
      var stack$tailLocal1$3$1 = stack$tailLocal1;
      var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((stack$tailLocal1$3, F$1, onOutput$1, onRelease$1, Nil$lzy1$3, Frame$lzy1$3) => ((a$1) => {
        var current$2 = new $c_Lcats_effect_kernel_Resource$Pure(a$1);
        return $p_Lcats_effect_kernel_Resource__loop$1__Lcats_effect_kernel_MonadCancel__F1__F2__sr_LazyRef__sr_LazyRef__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource$Stack$1__O($thiz, F$1, onOutput$1, onRelease$1, Nil$lzy1$3, Frame$lzy1$3, current$2, stack$tailLocal1$3);
      }))(stack$tailLocal1$3$1, F$1, onOutput$1, onRelease$1, Nil$lzy1$3, Frame$lzy1$3));
      return this$12.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$12.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x25);
  }
}
export { $p_Lcats_effect_kernel_Resource__loop$1__Lcats_effect_kernel_MonadCancel__F1__F2__sr_LazyRef__sr_LazyRef__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource$Stack$1__O as $p_Lcats_effect_kernel_Resource__loop$1__Lcats_effect_kernel_MonadCancel__F1__F2__sr_LazyRef__sr_LazyRef__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource$Stack$1__O };
/** @constructor */
function $c_Lcats_effect_kernel_Resource() {
}
export { $c_Lcats_effect_kernel_Resource as $c_Lcats_effect_kernel_Resource };
$c_Lcats_effect_kernel_Resource.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_kernel_Resource.prototype.constructor = $c_Lcats_effect_kernel_Resource;
/** @constructor */
function $h_Lcats_effect_kernel_Resource() {
}
export { $h_Lcats_effect_kernel_Resource as $h_Lcats_effect_kernel_Resource };
$h_Lcats_effect_kernel_Resource.prototype = $c_Lcats_effect_kernel_Resource.prototype;
$c_Lcats_effect_kernel_Resource.prototype.fold__F1__F2__Lcats_effect_kernel_MonadCancel__O = (function(onOutput, onRelease, F) {
  var Nil$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_LazyRef();
  var Frame$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_LazyRef();
  return $p_Lcats_effect_kernel_Resource__loop$1__Lcats_effect_kernel_MonadCancel__F1__F2__sr_LazyRef__sr_LazyRef__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource$Stack$1__O(this, F, onOutput, onRelease, Nil$lzy1, Frame$lzy1, this, $ps_Lcats_effect_kernel_Resource__Nil$1__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$2$(Nil$lzy1));
});
$c_Lcats_effect_kernel_Resource.prototype.use__F1__Lcats_effect_kernel_MonadCancel__O = (function(f, F) {
  return this.fold__F1__F2__Lcats_effect_kernel_MonadCancel__O(f, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((_$2, _$3) => _$2.apply__O__O(_$3))), F);
});
/** @constructor */
function $c_Lcats_effect_kernel_ResourceFOInstances0() {
}
export { $c_Lcats_effect_kernel_ResourceFOInstances0 as $c_Lcats_effect_kernel_ResourceFOInstances0 };
$c_Lcats_effect_kernel_ResourceFOInstances0.prototype = new $h_Lcats_effect_kernel_ResourceFOInstances1();
$c_Lcats_effect_kernel_ResourceFOInstances0.prototype.constructor = $c_Lcats_effect_kernel_ResourceFOInstances0;
/** @constructor */
function $h_Lcats_effect_kernel_ResourceFOInstances0() {
}
export { $h_Lcats_effect_kernel_ResourceFOInstances0 as $h_Lcats_effect_kernel_ResourceFOInstances0 };
$h_Lcats_effect_kernel_ResourceFOInstances0.prototype = $c_Lcats_effect_kernel_ResourceFOInstances0.prototype;
/** @constructor */
function $c_Lcats_effect_std_Console$() {
}
export { $c_Lcats_effect_std_Console$ as $c_Lcats_effect_std_Console$ };
$c_Lcats_effect_std_Console$.prototype = new $h_Lcats_effect_std_ConsoleCompanionCrossPlatform();
$c_Lcats_effect_std_Console$.prototype.constructor = $c_Lcats_effect_std_Console$;
/** @constructor */
function $h_Lcats_effect_std_Console$() {
}
export { $h_Lcats_effect_std_Console$ as $h_Lcats_effect_std_Console$ };
$h_Lcats_effect_std_Console$.prototype = $c_Lcats_effect_std_Console$.prototype;
$c_Lcats_effect_std_Console$.prototype.make__Lcats_effect_kernel_Async__Lcats_effect_std_Console = (function(F) {
  try {
    var r1 = process.stdout;
    var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(r1);
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
    matchEnd8: {
      var $x_1;
      if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(e$2);
        break matchEnd8;
      }
      throw ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  }
  var this$2 = $x_1.toOption__s_Option();
  if (this$2.isEmpty__Z()) {
    var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0 = this$2.get__O();
    var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Option$().apply__O__s_Option(x0);
  }
  var this$3 = $x_2;
  if (this$3.isEmpty__Z()) {
    var $x_3 = true;
  } else {
    var x0$1 = this$3.get__O();
    var $x_3 = (!(x0$1 === (void 0)));
  }
  if ($x_3) {
    var stdout = this$3;
  } else {
    var stdout = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
  try {
    var r1$1 = process.stderr;
    var $x_4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(r1$1);
  } catch (e$1) {
    var e$2$1 = ((e$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e$1 : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e$1));
    matchEnd8$1: {
      var $x_4;
      if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2$1)) {
        var $x_4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(e$2$1);
        break matchEnd8$1;
      }
      throw ((e$2$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2$1.sjs_js_JavaScriptException__f_exception : e$2$1);
    }
  }
  var this$6 = $x_4.toOption__s_Option();
  if (this$6.isEmpty__Z()) {
    var $x_5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0$2 = this$6.get__O();
    var $x_5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Option$().apply__O__s_Option(x0$2);
  }
  var this$7 = $x_5;
  if (this$7.isEmpty__Z()) {
    var $x_6 = true;
  } else {
    var x0$3 = this$7.get__O();
    var $x_6 = (!(x0$3 === (void 0)));
  }
  if ($x_6) {
    var stderr = this$7;
  } else {
    var stderr = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((_$8, _$9) => new $c_Lcats_effect_std_Console$NodeJSConsole(_$8, _$9, F)));
  var F$1 = $m_Lcats_instances_package$option$().Lcats_instances_package$option$__f_catsStdInstancesForOption;
  var this$12 = F$1.map2__O__O__F2__O(stdout, stderr, f);
  return (this$12.isEmpty__Z() ? new $c_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole(this, F) : this$12.get__O());
});
var $d_Lcats_effect_std_Console$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_std_Console$, "cats.effect.std.Console$", ({
  Lcats_effect_std_Console$: 1,
  Lcats_effect_std_ConsoleCompanionCrossPlatform: 1
}));
export { $d_Lcats_effect_std_Console$ as $d_Lcats_effect_std_Console$ };
var $n_Lcats_effect_std_Console$;
function $m_Lcats_effect_std_Console$() {
  if ((!$n_Lcats_effect_std_Console$)) {
    $n_Lcats_effect_std_Console$ = new $c_Lcats_effect_std_Console$();
  }
  return $n_Lcats_effect_std_Console$;
}
export { $m_Lcats_effect_std_Console$ as $m_Lcats_effect_std_Console$ };
/** @constructor */
function $c_Lcats_effect_std_Env$() {
}
export { $c_Lcats_effect_std_Env$ as $c_Lcats_effect_std_Env$ };
$c_Lcats_effect_std_Env$.prototype = new $h_Lcats_effect_std_EnvCompanionPlatform();
$c_Lcats_effect_std_Env$.prototype.constructor = $c_Lcats_effect_std_Env$;
/** @constructor */
function $h_Lcats_effect_std_Env$() {
}
export { $h_Lcats_effect_std_Env$ as $h_Lcats_effect_std_Env$ };
$h_Lcats_effect_std_Env$.prototype = $c_Lcats_effect_std_Env$.prototype;
var $d_Lcats_effect_std_Env$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_std_Env$, "cats.effect.std.Env$", ({
  Lcats_effect_std_Env$: 1,
  Lcats_effect_std_EnvCompanionPlatform: 1
}));
export { $d_Lcats_effect_std_Env$ as $d_Lcats_effect_std_Env$ };
var $n_Lcats_effect_std_Env$;
function $m_Lcats_effect_std_Env$() {
  if ((!$n_Lcats_effect_std_Env$)) {
    $n_Lcats_effect_std_Env$ = new $c_Lcats_effect_std_Env$();
  }
  return $n_Lcats_effect_std_Env$;
}
export { $m_Lcats_effect_std_Env$ as $m_Lcats_effect_std_Env$ };
function $p_Lcats_effect_std_EnvCompanionPlatform$SyncEnv__processEnv__sjs_js_Dictionary($thiz) {
  try {
    var r1 = process.env;
    var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(r1);
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
    matchEnd8: {
      var $x_1;
      if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(e$2);
        break matchEnd8;
      }
      throw ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  }
  return $x_1.getOrElse__F0__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => (({})))));
}
export { $p_Lcats_effect_std_EnvCompanionPlatform$SyncEnv__processEnv__sjs_js_Dictionary as $p_Lcats_effect_std_EnvCompanionPlatform$SyncEnv__processEnv__sjs_js_Dictionary };
/** @constructor */
function $c_Lcats_effect_std_EnvCompanionPlatform$SyncEnv(outer, F) {
  this.Lcats_effect_std_EnvCompanionPlatform$SyncEnv__f_F = null;
  this.Lcats_effect_std_EnvCompanionPlatform$SyncEnv__f_F = F;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lcats_effect_std_EnvCompanionPlatform$SyncEnv as $c_Lcats_effect_std_EnvCompanionPlatform$SyncEnv };
$c_Lcats_effect_std_EnvCompanionPlatform$SyncEnv.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_std_EnvCompanionPlatform$SyncEnv.prototype.constructor = $c_Lcats_effect_std_EnvCompanionPlatform$SyncEnv;
/** @constructor */
function $h_Lcats_effect_std_EnvCompanionPlatform$SyncEnv() {
}
export { $h_Lcats_effect_std_EnvCompanionPlatform$SyncEnv as $h_Lcats_effect_std_EnvCompanionPlatform$SyncEnv };
$h_Lcats_effect_std_EnvCompanionPlatform$SyncEnv.prototype = $c_Lcats_effect_std_EnvCompanionPlatform$SyncEnv.prototype;
$c_Lcats_effect_std_EnvCompanionPlatform$SyncEnv.prototype.get__T__O = (function(name) {
  var value = this.Lcats_effect_std_EnvCompanionPlatform$SyncEnv__f_F.delay__F0__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    var dict = $p_Lcats_effect_std_EnvCompanionPlatform$SyncEnv__processEnv__sjs_js_Dictionary(this);
    return ((!(!$m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, name))) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(dict[name]) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  })));
  return new $c_Lcats_data_OptionT(value).collect__s_PartialFunction__Lcats_Functor__Lcats_data_OptionT(new $c_Lcats_effect_std_EnvCompanionPlatform$$anon$1(), this.Lcats_effect_std_EnvCompanionPlatform$SyncEnv__f_F).Lcats_data_OptionT__f_value;
});
var $d_Lcats_effect_std_EnvCompanionPlatform$SyncEnv = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_std_EnvCompanionPlatform$SyncEnv, "cats.effect.std.EnvCompanionPlatform$SyncEnv", ({
  Lcats_effect_std_EnvCompanionPlatform$SyncEnv: 1,
  Lcats_effect_std_Env: 1
}));
export { $d_Lcats_effect_std_EnvCompanionPlatform$SyncEnv as $d_Lcats_effect_std_EnvCompanionPlatform$SyncEnv };
/** @constructor */
function $c_Lcats_effect_std_Semaphore$impl$$anon$1(state$2, outer) {
  this.Lcats_effect_std_Semaphore$impl$$anon$1__f_state$1 = null;
  this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer = null;
  this.Lcats_effect_std_Semaphore$impl$$anon$1__f_state$1 = state$2;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer = outer;
}
export { $c_Lcats_effect_std_Semaphore$impl$$anon$1 as $c_Lcats_effect_std_Semaphore$impl$$anon$1 };
$c_Lcats_effect_std_Semaphore$impl$$anon$1.prototype = new $h_Lcats_effect_std_Semaphore();
$c_Lcats_effect_std_Semaphore$impl$$anon$1.prototype.constructor = $c_Lcats_effect_std_Semaphore$impl$$anon$1;
/** @constructor */
function $h_Lcats_effect_std_Semaphore$impl$$anon$1() {
}
export { $h_Lcats_effect_std_Semaphore$impl$$anon$1 as $h_Lcats_effect_std_Semaphore$impl$$anon$1 };
$h_Lcats_effect_std_Semaphore$impl$$anon$1.prototype = $c_Lcats_effect_std_Semaphore$impl$$anon$1.prototype;
$c_Lcats_effect_std_Semaphore$impl$$anon$1.prototype.acquireN__J__O = (function(n) {
  this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer.requireNonNegative__J__V(n);
  if (((n.RTLong__f_lo === 0) && (n.RTLong__f_hi === 0))) {
    return $m_Lcats_effect_IO$().Lcats_effect_IO$__f__unit;
  } else {
    var body = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((poll) => {
      var target = this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer.newRequest__O();
      var tc = this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer.Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F;
      var this$43 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
      var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((poll$2) => ((req) => {
        var ffa$1 = this.Lcats_effect_std_Semaphore$impl$$anon$1__f_state$1.modify__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((req$2) => ((x$1) => {
          if ((x$1 !== null)) {
            var t = x$1.Lcats_effect_std_Semaphore$impl$State__f_permits;
            var lo = t.RTLong__f_lo;
            var hi = t.RTLong__f_hi;
            var x24 = x$1.Lcats_effect_std_Semaphore$impl$State__f_waiting;
            if ((!x24.isEmpty__Z())) {
              var self = this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer.Lcats_effect_std_Semaphore$impl__f_State$lzy1.apply__J__sci_Queue__Lcats_effect_std_Semaphore$impl$State($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0, x24.enqueue__O__sci_Queue(req$2.of__J__Lcats_effect_std_Semaphore$impl$Request(n)));
              var y = this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer.Wait__Lcats_effect_std_Semaphore$impl$Wait$();
              var x13___1 = self;
              var x13___2 = y;
            } else {
              var blo = n.RTLong__f_lo;
              var lo$1 = ((lo - blo) | 0);
              var hi$1 = ((((hi - n.RTLong__f_hi) | 0) + ((((~lo) & blo) | ((~(lo ^ blo)) & lo$1)) >> 31)) | 0);
              if ((hi$1 >= 0)) {
                var $x_2 = this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer.Lcats_effect_std_Semaphore$impl__f_State$lzy1;
                var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$1, hi$1);
                var xs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_sr_Nothing$.getArrayOf().constr)([]));
                var self$1 = $x_2.apply__J__sci_Queue__Lcats_effect_std_Semaphore$impl$State($x_1, $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(xs)));
                var y$1 = this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer.Done__Lcats_effect_std_Semaphore$impl$Done$();
                var x13___1 = self$1;
                var x13___2 = y$1;
              } else {
                var $x_3 = this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer.Lcats_effect_std_Semaphore$impl__f_State$lzy1;
                var sign = (hi$1 >> 31);
                var xlo = (lo$1 ^ sign);
                var rlo = ((xlo - sign) | 0);
                var rhi = (((hi$1 ^ sign) + (((xlo & (~rlo)) >>> 31) | 0)) | 0);
                var a = req$2.of__J__Lcats_effect_std_Semaphore$impl$Request(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(rlo, rhi));
                var F = $m_Lcats_instances_package$queue$().Lcats_instances_package$queue$__f_catsStdInstancesForQueue;
                var self$2 = $x_3.apply__J__sci_Queue__Lcats_effect_std_Semaphore$impl$State($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0, F.pure__O__O(a));
                var y$2 = this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer.Wait__Lcats_effect_std_Semaphore$impl$Wait$();
                var x13___1 = self$2;
                var x13___2 = y$2;
              }
            }
            var newState = x13___1;
            var decision = x13___2;
            var \u03b41$___1 = newState;
            var \u03b41$___2 = decision;
            var newState$2 = \u03b41$___1;
            var decision$2 = \u03b41$___2;
            var ffa = this.Lcats_effect_std_Semaphore$impl$$anon$1__f_state$1.modify__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1$2) => {
              if ((x$1$2 !== null)) {
                var t$1 = x$1$2.Lcats_effect_std_Semaphore$impl$State__f_permits;
                var lo$2 = t$1.RTLong__f_lo;
                var hi$2 = t$1.RTLong__f_hi;
                var x19 = x$1$2.Lcats_effect_std_Semaphore$impl$State__f_waiting;
                _return: {
                  var these = x19;
                  while ((!these.isEmpty__Z())) {
                    var x0 = these.head__O();
                    if (x0.sameAs__Lcats_effect_std_Semaphore$impl$Request__Z(req$2)) {
                      var target$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(these.head__O());
                      break _return;
                    }
                    these = these.tail__O();
                  }
                  var target$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
                }
                $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_UnorderedFoldable$();
                var tc$1 = $m_Lcats_instances_package$option$().Lcats_instances_package$option$__f_catsStdInstancesForOption;
                var this$28 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Foldable$ToFoldableOps$$anon$6(target$1, tc$1);
                var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$9) => _$9.Lcats_effect_std_Semaphore$impl$Request__f_n));
                var B = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_kernel_instances_long_package$().Lcats_kernel_instances_long_package$__f_catsKernelStdGroupForLong;
                var b = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(this$28.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance.foldMap__O__F1__Lcats_kernel_Monoid__O(this$28.Lcats_Foldable$ToFoldableOps$$anon$6__f_self, f, B));
                var alo = n.RTLong__f_lo;
                var blo$1 = b.RTLong__f_lo;
                var lo$3 = ((alo - blo$1) | 0);
                var hi$3 = ((((n.RTLong__f_hi - b.RTLong__f_hi) | 0) + ((((~alo) & blo$1) | ((~(alo ^ blo$1)) & lo$3)) >> 31)) | 0);
                var b$1 = $m_sci_Queue$().newBuilder__scm_Builder();
                var it = x19.iterator__sc_Iterator();
                while (it.hasNext__Z()) {
                  var elem = it.next__O();
                  if ((elem.sameAs__Lcats_effect_std_Semaphore$impl$Request__Z(req$2) !== true)) {
                    b$1.addOne__O__scm_Growable(elem);
                  }
                }
                var waitingNow = b$1.result__O();
                var self$3 = this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer.Lcats_effect_std_Semaphore$impl__f_State$lzy1.apply__J__sci_Queue__Lcats_effect_std_Semaphore$impl$State(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$2, hi$2), waitingNow);
                var y$3 = this.releaseN__J__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$3, hi$3));
                return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$3, y$3);
              }
              throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1$2);
            })));
            var F$1 = this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer.Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F;
            var cleanup = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__flatten__O__O(F$1, ffa);
            matchResult13: {
              var action;
              var x = this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer.Done__Lcats_effect_std_Semaphore$impl$Done$();
              if ((x === decision$2)) {
                var action = $m_Lcats_effect_IO$().Lcats_effect_IO$__f__unit;
                break matchResult13;
              }
              var x$3 = this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer.Wait__Lcats_effect_std_Semaphore$impl$Wait$();
              if ((x$3 === decision$2)) {
                var this$35 = req$2.Lcats_effect_std_Semaphore$impl$Request__f_gate;
                var wrapped = poll$2.apply__O__O(this$35.get__Lcats_effect_IO());
                var action = new $c_Lcats_effect_IO$OnCancel(wrapped, cleanup);
                break matchResult13;
              }
              throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(decision$2);
            }
            return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), newState$2, action);
          }
          throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
        }))(req)));
        var F$3 = this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer.Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F;
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__flatten__O__O(F$3, ffa$1);
      }))(poll));
      return this$43.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$43.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
    }));
    return $m_Lcats_effect_IO$().uncancelable__F1__Lcats_effect_IO(body);
  }
});
$c_Lcats_effect_std_Semaphore$impl$$anon$1.prototype.releaseN__J__O = (function(n) {
  this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer.requireNonNegative__J__V(n);
  return (((n.RTLong__f_lo === 0) && (n.RTLong__f_hi === 0)) ? $m_Lcats_effect_IO$().Lcats_effect_IO$__f__unit : this.Lcats_effect_std_Semaphore$impl$$anon$1__f_state$1.flatModify__F1__Lcats_effect_kernel_MonadCancel__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 !== null)) {
      var t = x$1.Lcats_effect_std_Semaphore$impl$State__f_permits;
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var x35 = x$1.Lcats_effect_std_Semaphore$impl$State__f_waiting;
      if (x35.isEmpty__Z()) {
        var $x_1 = this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer.Lcats_effect_std_Semaphore$impl__f_State$lzy1;
        var blo = n.RTLong__f_lo;
        var lo$1 = ((lo + blo) | 0);
        var hi$1 = ((((hi + n.RTLong__f_hi) | 0) + ((((lo & blo) | ((lo | blo) & (~lo$1))) >>> 31) | 0)) | 0);
        var self = $x_1.apply__J__sci_Queue__Lcats_effect_std_Semaphore$impl$State(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$1, hi$1), x35);
        var y = $m_Lcats_effect_IO$().Lcats_effect_IO$__f__unit;
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self, y);
      } else {
        matchResult16: {
          var \u03b43$___1;
          var \u03b43$___2;
          var \u03b43$___3;
          var xs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_sr_Nothing$.getArrayOf().constr)([]));
          var x28 = $s_Lcats_effect_std_Semaphore$__cats$effect$std$Semaphore$impl$$anon$1$$_$fulfil$1__J__sci_Queue__sci_Queue__T3(n, x35, $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(xs)));
          if ((x28 !== null)) {
            var t$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(x28.T3__f__1);
            var lo$2 = t$1.RTLong__f_lo;
            var hi$2 = t$1.RTLong__f_hi;
            var waitingNow = x28.T3__f__2;
            var wakeup = x28.T3__f__3;
            var \u03b43$___1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$2, hi$2);
            var \u03b43$___2 = waitingNow;
            var \u03b43$___3 = wakeup;
            break matchResult16;
          }
          throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x28);
        }
        var t$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(\u03b43$___1);
        var lo$3 = t$2.RTLong__f_lo;
        var hi$3 = t$2.RTLong__f_hi;
        var waitingNow$2 = \u03b43$___2;
        var wakeup$2 = \u03b43$___3;
        var self$1 = this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer.Lcats_effect_std_Semaphore$impl__f_State$lzy1.apply__J__sci_Queue__Lcats_effect_std_Semaphore$impl$State(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$3, hi$3), waitingNow$2);
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_UnorderedFoldable$();
        var tc = $m_Lcats_instances_package$queue$().Lcats_instances_package$queue$__f_catsStdInstancesForQueue;
        var this$16 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Foldable$ToFoldableOps$$anon$6(wakeup$2, tc);
        var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$11) => {
          var this$15 = _$11.Lcats_effect_std_Semaphore$impl$Request__f_gate;
          return this$15.complete__O__Lcats_effect_IO((void 0));
        }));
        var G = this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer.Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F;
        var y$1 = this$16.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance.traverseVoid__O__F1__Lcats_Applicative__O(this$16.Lcats_Foldable$ToFoldableOps$$anon$6__f_self, f, G);
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$1, y$1);
      }
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  })), this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer.Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F));
});
var $d_Lcats_effect_std_Semaphore$impl$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_std_Semaphore$impl$$anon$1, "cats.effect.std.Semaphore$impl$$anon$1", ({
  Lcats_effect_std_Semaphore$impl$$anon$1: 1,
  Lcats_effect_std_Semaphore: 1
}));
export { $d_Lcats_effect_std_Semaphore$impl$$anon$1 as $d_Lcats_effect_std_Semaphore$impl$$anon$1 };
function $p_Lcats_effect_tracing_Tracing$__applyRunLoopFilter$1__jl_StackTraceElement__Z($thiz, ste) {
  var name = ste.jl_StackTraceElement__f_declaringClass;
  var i = 0;
  var len = $thiz.Lcats_effect_tracing_Tracing$__f_runLoopFilter.u.length;
  while ((i < len)) {
    var prefix = $thiz.Lcats_effect_tracing_Tracing$__f_runLoopFilter.u[i];
    if ((!(!name.startsWith(prefix)))) {
      return true;
    }
    i = ((1 + i) | 0);
  }
  return false;
}
export { $p_Lcats_effect_tracing_Tracing$__applyRunLoopFilter$1__jl_StackTraceElement__Z as $p_Lcats_effect_tracing_Tracing$__applyRunLoopFilter$1__jl_StackTraceElement__Z };
function $p_Lcats_effect_tracing_Tracing$__dropRunLoopFrames$1__Ajl_StackTraceElement__Ajl_StackTraceElement($thiz, frames) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_scm_ArrayBuffer$();
  var buffer = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_scm_ArrayBuffer__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_ArrayBuffer());
  var i = 0;
  var len = frames.u.length;
  while ((i < len)) {
    var frame = frames.u[i];
    if ((!$p_Lcats_effect_tracing_Tracing$__applyRunLoopFilter$1__jl_StackTraceElement__Z($thiz, frame))) {
      buffer.addOne__O__scm_ArrayBuffer(frame);
    } else if ((buffer.scm_ArrayBuffer__f_size0 >= 0)) {
      var len$1 = buffer.scm_ArrayBuffer__f_size0;
      var destination = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_jl_StackTraceElement.getArrayOf().constr)(len$1);
      buffer.copyToArray__O__I__I__I(destination, 0, 2147483647);
      return destination;
    } else {
      var capacity = 0;
      var size = 0;
      var jsElems = null;
      capacity = 0;
      size = 0;
      jsElems = [];
      var it = buffer.view__scm_ArrayBufferView().iterator__sc_Iterator();
      while (it.hasNext__Z()) {
        var elem = it.next__O();
        var unboxedElem = ((elem === null) ? null : elem);
        jsElems.push(unboxedElem);
      }
      return new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_jl_StackTraceElement.getArrayOf().constr)(jsElems);
    }
    i = ((1 + i) | 0);
  }
  if ((buffer.scm_ArrayBuffer__f_size0 >= 0)) {
    var len$2 = buffer.scm_ArrayBuffer__f_size0;
    var destination$1 = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_jl_StackTraceElement.getArrayOf().constr)(len$2);
    buffer.copyToArray__O__I__I__I(destination$1, 0, 2147483647);
    return destination$1;
  } else {
    var capacity$1 = 0;
    var size$1 = 0;
    var jsElems$1 = null;
    capacity$1 = 0;
    size$1 = 0;
    jsElems$1 = [];
    var it$1 = buffer.view__scm_ArrayBufferView().iterator__sc_Iterator();
    while (it$1.hasNext__Z()) {
      var elem$1 = it$1.next__O();
      var unboxedElem$1 = ((elem$1 === null) ? null : elem$1);
      jsElems$1.push(unboxedElem$1);
    }
    return new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_jl_StackTraceElement.getArrayOf().constr)(jsElems$1);
  }
}
export { $p_Lcats_effect_tracing_Tracing$__dropRunLoopFrames$1__Ajl_StackTraceElement__Ajl_StackTraceElement as $p_Lcats_effect_tracing_Tracing$__dropRunLoopFrames$1__Ajl_StackTraceElement__Ajl_StackTraceElement };
/** @constructor */
function $c_Lcats_effect_tracing_Tracing$() {
  this.Lcats_effect_tracing_TracingPlatform__f_cache = null;
  this.Lcats_effect_tracing_TracingPlatform__f_function0Property = null;
  this.Lcats_effect_tracing_TracingPlatform__f_function1Property = null;
  this.Lcats_effect_tracing_TracingPlatform__f_calculateTracingEvent = null;
  this.Lcats_effect_tracing_TracingPlatform__f_stackTraceFileNameFilter = null;
  this.Lcats_effect_tracing_TracingPlatform__f_stackTraceMethodNameFilter = null;
  this.Lcats_effect_tracing_Tracing$__f_runLoopFilter = null;
  this.Lcats_effect_tracing_Tracing$__f_stackTraceClassNameFilter = null;
  $ct_Lcats_effect_tracing_TracingPlatform__(this);
  $n_Lcats_effect_tracing_Tracing$ = this;
  this.Lcats_effect_tracing_Tracing$__f_runLoopFilter = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["cats.effect.", "scala.runtime.", "scala.scalajs.runtime.", "scala.scalanative.runtime."]);
  this.Lcats_effect_tracing_Tracing$__f_stackTraceClassNameFilter = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["cats.", "sbt.", "java.", "jdk.", "sun.", "scala.", "org.scalajs."]);
}
export { $c_Lcats_effect_tracing_Tracing$ as $c_Lcats_effect_tracing_Tracing$ };
$c_Lcats_effect_tracing_Tracing$.prototype = new $h_Lcats_effect_tracing_TracingPlatform();
$c_Lcats_effect_tracing_Tracing$.prototype.constructor = $c_Lcats_effect_tracing_Tracing$;
/** @constructor */
function $h_Lcats_effect_tracing_Tracing$() {
}
export { $h_Lcats_effect_tracing_Tracing$ as $h_Lcats_effect_tracing_Tracing$ };
$h_Lcats_effect_tracing_Tracing$.prototype = $c_Lcats_effect_tracing_Tracing$.prototype;
$c_Lcats_effect_tracing_Tracing$.prototype.combineOpAndCallSite__jl_StackTraceElement__jl_StackTraceElement__jl_StackTraceElement = (function(methodSite, callSite) {
  var methodSiteMethodName = methodSite.jl_StackTraceElement__f_methodName;
  var op = this.decodeMethodName__T__T(methodSiteMethodName);
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_StackTraceElement__T__T__T__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_StackTraceElement(), ((op + " @ ") + callSite.jl_StackTraceElement__f_declaringClass), callSite.jl_StackTraceElement__f_methodName, callSite.jl_StackTraceElement__f_fileName, callSite.jl_StackTraceElement__f_lineNumber);
});
$c_Lcats_effect_tracing_Tracing$.prototype.isInternalClass__T__Z = (function(className) {
  var i = 0;
  var len = this.Lcats_effect_tracing_Tracing$__f_stackTraceClassNameFilter.u.length;
  while ((i < len)) {
    var prefix = this.Lcats_effect_tracing_Tracing$__f_stackTraceClassNameFilter.u[i];
    if ((!(!className.startsWith(prefix)))) {
      return true;
    }
    i = ((1 + i) | 0);
  }
  return false;
});
$c_Lcats_effect_tracing_Tracing$.prototype.cats$effect$tracing$Tracing$$$getOpAndCallSite__Ajl_StackTraceElement__jl_StackTraceElement = (function(stackTrace) {
  var len = stackTrace.u.length;
  var idx = 1;
  while ((idx < len)) {
    var methodSite = stackTrace.u[(((-1) + idx) | 0)];
    var callSite = stackTrace.u[idx];
    var callSiteClassName = callSite.jl_StackTraceElement__f_declaringClass;
    var callSiteMethodName = callSite.jl_StackTraceElement__f_methodName;
    var callSiteFileName = callSite.jl_StackTraceElement__f_fileName;
    if (((callSiteClassName === "cats.effect.IOFiber") && (callSiteMethodName === "run"))) {
      return null;
    }
    if ((!this.applyStackTraceFilter__T__T__T__Z(callSiteClassName, callSiteMethodName, callSiteFileName))) {
      return this.combineOpAndCallSite__jl_StackTraceElement__jl_StackTraceElement__jl_StackTraceElement(methodSite, callSite);
    }
    idx = ((1 + idx) | 0);
  }
  return null;
});
$c_Lcats_effect_tracing_Tracing$.prototype.augmentThrowable__Z__jl_Throwable__Lcats_effect_tracing_RingBuffer__V = (function(enhancedExceptions, t, events) {
  if (($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing && enhancedExceptions)) {
    var stackTrace = t.getStackTrace__Ajl_StackTraceElement();
    if ((stackTrace.u.length !== 0)) {
      var augmented = ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__indexOf__I__I($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_ArrayOps$().last$extension__O__O(stackTrace).jl_StackTraceElement__f_declaringClass, 64) !== (-1));
      if ((!augmented)) {
        var prefix = $p_Lcats_effect_tracing_Tracing$__dropRunLoopFrames$1__Ajl_StackTraceElement__Ajl_StackTraceElement(this, stackTrace);
        var this$5 = this.getFrames__Lcats_effect_tracing_RingBuffer__sci_List(events);
        if ((this$5.knownSize__I() >= 0)) {
          var len = this$5.knownSize__I();
          var destination = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_jl_StackTraceElement.getArrayOf().constr)(len);
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$5, destination, 0, 2147483647);
          var suffix = destination;
        } else {
          var capacity = 0;
          var size = 0;
          var jsElems = null;
          capacity = 0;
          size = 0;
          jsElems = [];
          var it = this$5.iterator__sc_Iterator();
          while (it.hasNext__Z()) {
            var elem = it.next__O();
            var unboxedElem = ((elem === null) ? null : elem);
            jsElems.push(unboxedElem);
          }
          var suffix = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_jl_StackTraceElement.getArrayOf().constr)(jsElems);
        }
        var newLength = ((prefix.u.length + suffix.u.length) | 0);
        var this$14 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$objectGetClass(prefix);
        var that = this$14.data.getComponentType();
        if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_jl_StackTraceElement.isAssignableFrom(that.data)) {
          var dest$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(prefix, newLength, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_jl_StackTraceElement.getArrayOf().getClassOf());
        } else {
          var dest = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_jl_StackTraceElement.getArrayOf().constr)(newLength);
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Array$().copy__O__I__O__I__I__V(prefix, 0, dest, 0, prefix.u.length);
          var dest$1 = dest;
        }
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Array$().copy__O__I__O__I__I__V(suffix, 0, dest$1, prefix.u.length, suffix.u.length);
        t.setStackTrace__Ajl_StackTraceElement__V(dest$1);
      }
    }
  }
});
$c_Lcats_effect_tracing_Tracing$.prototype.getFrames__Lcats_effect_tracing_RingBuffer__sci_List = (function(events) {
  var this$1 = events.toList__sci_List().collect__s_PartialFunction__sci_List(new $c_Lcats_effect_tracing_Tracing$$anon$1());
  var f = ((_$1) => (_$1 !== null));
  var l = this$1;
  block: {
    var result;
    while (true) {
      if (l.isEmpty__Z()) {
        var result = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
        break;
      } else {
        var h = l.head__O();
        var t = l.tail__O();
        if (((!(!f(h))) === false)) {
          l = t;
          continue;
        }
        var start = l;
        var remaining = t;
        while (true) {
          if (remaining.isEmpty__Z()) {
            var result = start;
            break block;
          } else {
            var x = remaining.head__O();
            if (((!(!f(x))) !== false)) {
              remaining = remaining.tail__O();
              continue;
            }
            var firstMiss = remaining;
            var newHead = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(start.head__O(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
            var toProcess = start.tail__O();
            var currentLast = newHead;
            while ((toProcess !== firstMiss)) {
              var newElem = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(toProcess.head__O(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
              currentLast.sci_$colon$colon__f_next = newElem;
              currentLast = newElem;
              toProcess = toProcess.tail__O();
            }
            var next = firstMiss.tail__O();
            var nextToCopy = next;
            while ((!next.isEmpty__Z())) {
              var head = next.head__O();
              if (((!(!f(head))) !== false)) {
                next = next.tail__O();
              } else {
                while ((nextToCopy !== next)) {
                  var newElem$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(nextToCopy.head__O(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
                  currentLast.sci_$colon$colon__f_next = newElem$2;
                  currentLast = newElem$2;
                  nextToCopy = nextToCopy.tail__O();
                }
                nextToCopy = next.tail__O();
                next = next.tail__O();
              }
            }
            if ((!nextToCopy.isEmpty__Z())) {
              currentLast.sci_$colon$colon__f_next = nextToCopy;
            }
            var result = newHead;
            break block;
          }
        }
      }
    }
  }
  return result;
});
var $d_Lcats_effect_tracing_Tracing$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_tracing_Tracing$, "cats.effect.tracing.Tracing$", ({
  Lcats_effect_tracing_Tracing$: 1,
  Lcats_effect_tracing_TracingPlatform: 1
}));
export { $d_Lcats_effect_tracing_Tracing$ as $d_Lcats_effect_tracing_Tracing$ };
var $n_Lcats_effect_tracing_Tracing$;
function $m_Lcats_effect_tracing_Tracing$() {
  if ((!$n_Lcats_effect_tracing_Tracing$)) {
    $n_Lcats_effect_tracing_Tracing$ = new $c_Lcats_effect_tracing_Tracing$();
  }
  return $n_Lcats_effect_tracing_Tracing$;
}
export { $m_Lcats_effect_tracing_Tracing$ as $m_Lcats_effect_tracing_Tracing$ };
var $d_Lcats_effect_tracing_TracingEvent = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass(1, "cats.effect.tracing.TracingEvent", ({
  Lcats_effect_tracing_TracingEvent: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_effect_tracing_TracingEvent as $d_Lcats_effect_tracing_TracingEvent };
/** @constructor */
function $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1(outer) {
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1__f_$outer = outer;
}
export { $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1 as $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1 };
$c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1.prototype.constructor = $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1;
/** @constructor */
function $h_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1() {
}
export { $h_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1 as $h_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1 };
$h_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1.prototype = $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1.prototype;
$c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1.prototype.run__V = (function() {
  var i = 0;
  while (((i < this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1__f_$outer.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$batchSize) && (!this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1__f_$outer.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$fibers.Lcats_effect_unsafe_JSArrayQueue__f_empty))) {
    var this$1 = this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1__f_$outer.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$fibers;
    var a = this$1.Lcats_effect_unsafe_JSArrayQueue__f_buffer[this$1.Lcats_effect_unsafe_JSArrayQueue__f_startIndex];
    this$1.Lcats_effect_unsafe_JSArrayQueue__f_buffer[this$1.Lcats_effect_unsafe_JSArrayQueue__f_startIndex] = null;
    this$1.Lcats_effect_unsafe_JSArrayQueue__f_startIndex = ((1 + this$1.Lcats_effect_unsafe_JSArrayQueue__f_startIndex) | 0);
    if ((this$1.Lcats_effect_unsafe_JSArrayQueue__f_startIndex === this$1.Lcats_effect_unsafe_JSArrayQueue__f_endIndex)) {
      this$1.Lcats_effect_unsafe_JSArrayQueue__f_empty = true;
    }
    if ((this$1.Lcats_effect_unsafe_JSArrayQueue__f_startIndex >= (this$1.Lcats_effect_unsafe_JSArrayQueue__f_buffer.length | 0))) {
      this$1.Lcats_effect_unsafe_JSArrayQueue__f_startIndex = 0;
    }
    try {
      a.run__V();
    } catch (e) {
      var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
      matchResult1: {
        if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$2)) {
          this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1__f_$outer.reportFailure__jl_Throwable__V(e$2);
          break matchResult1;
        }
        $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(e$2);
      }
    }
    i = ((1 + i) | 0);
  }
  if ((!this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1__f_$outer.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$fibers.Lcats_effect_unsafe_JSArrayQueue__f_empty)) {
    $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$().execute__jl_Runnable__V(this);
  } else {
    this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1__f_$outer.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$needsReschedule = true;
  }
});
var $d_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1, "cats.effect.unsafe.BatchingMacrotaskExecutor$$anon$1", ({
  Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1: 1,
  jl_Runnable: 1
}));
export { $d_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1 as $d_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1 };
/** @constructor */
function $c_Lcats_effect_unsafe_FiberMonitor() {
  this.Lcats_effect_unsafe_FiberMonitorShared__f_newline = null;
}
export { $c_Lcats_effect_unsafe_FiberMonitor as $c_Lcats_effect_unsafe_FiberMonitor };
$c_Lcats_effect_unsafe_FiberMonitor.prototype = new $h_Lcats_effect_unsafe_FiberMonitorShared();
$c_Lcats_effect_unsafe_FiberMonitor.prototype.constructor = $c_Lcats_effect_unsafe_FiberMonitor;
/** @constructor */
function $h_Lcats_effect_unsafe_FiberMonitor() {
}
export { $h_Lcats_effect_unsafe_FiberMonitor as $h_Lcats_effect_unsafe_FiberMonitor };
$h_Lcats_effect_unsafe_FiberMonitor.prototype = $c_Lcats_effect_unsafe_FiberMonitor.prototype;
function $p_Lcats_effect_unsafe_IORuntime$__unregisterAndShutdown$1__F0__F0__sr_LazyRef__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__sci_List__Lcats_effect_unsafe_FiberMonitor__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_metrics_IORuntimeMetrics__F0($thiz, unregister$1, shutdown$1, runtime$lzy1$1, compute$1, blocking$1, scheduler$1, pollers$1, fiberMonitor$1, config$1, metrics$1) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    unregister$1.apply__O();
    shutdown$1.apply__O();
    var $x_2 = $thiz.Lcats_effect_unsafe_IORuntime$__f_allRuntimes;
    var $x_1 = $p_Lcats_effect_unsafe_IORuntime$__runtime$1__sr_LazyRef__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__sci_List__Lcats_effect_unsafe_FiberMonitor__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_metrics_IORuntimeMetrics__F0__F0__Lcats_effect_unsafe_IORuntime($thiz, runtime$lzy1$1, compute$1, blocking$1, scheduler$1, pollers$1, fiberMonitor$1, config$1, metrics$1, unregister$1, shutdown$1);
    var this$2 = $p_Lcats_effect_unsafe_IORuntime$__runtime$1__sr_LazyRef__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__sci_List__Lcats_effect_unsafe_FiberMonitor__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_metrics_IORuntimeMetrics__F0__F0__Lcats_effect_unsafe_IORuntime($thiz, runtime$lzy1$1, compute$1, blocking$1, scheduler$1, pollers$1, fiberMonitor$1, config$1, metrics$1, unregister$1, shutdown$1);
    $x_2.remove__O__I__V($x_1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$systemIdentityHashCode(this$2));
  }));
}
export { $p_Lcats_effect_unsafe_IORuntime$__unregisterAndShutdown$1__F0__F0__sr_LazyRef__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__sci_List__Lcats_effect_unsafe_FiberMonitor__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_metrics_IORuntimeMetrics__F0 as $p_Lcats_effect_unsafe_IORuntime$__unregisterAndShutdown$1__F0__F0__sr_LazyRef__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__sci_List__Lcats_effect_unsafe_FiberMonitor__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_metrics_IORuntimeMetrics__F0 };
function $p_Lcats_effect_unsafe_IORuntime$__runtime$lzyINIT1$1__sr_LazyRef__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__sci_List__Lcats_effect_unsafe_FiberMonitor__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_metrics_IORuntimeMetrics__F0__F0__Lcats_effect_unsafe_IORuntime($thiz, runtime$lzy1$3, compute$3, blocking$3, scheduler$3, pollers$3, fiberMonitor$3, config$3, metrics$3, unregister$3, shutdown$3) {
  if ((runtime$lzy1$3 === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  return (runtime$lzy1$3.sr_LazyRef__f__initialized ? runtime$lzy1$3.sr_LazyRef__f__value : runtime$lzy1$3.initialize__O__O(new $c_Lcats_effect_unsafe_IORuntime(compute$3, blocking$3, scheduler$3, pollers$3, fiberMonitor$3, $p_Lcats_effect_unsafe_IORuntime$__unregisterAndShutdown$1__F0__F0__sr_LazyRef__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__sci_List__Lcats_effect_unsafe_FiberMonitor__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_metrics_IORuntimeMetrics__F0($thiz, unregister$3, shutdown$3, runtime$lzy1$3, compute$3, blocking$3, scheduler$3, pollers$3, fiberMonitor$3, config$3, metrics$3), config$3, metrics$3)));
}
export { $p_Lcats_effect_unsafe_IORuntime$__runtime$lzyINIT1$1__sr_LazyRef__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__sci_List__Lcats_effect_unsafe_FiberMonitor__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_metrics_IORuntimeMetrics__F0__F0__Lcats_effect_unsafe_IORuntime as $p_Lcats_effect_unsafe_IORuntime$__runtime$lzyINIT1$1__sr_LazyRef__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__sci_List__Lcats_effect_unsafe_FiberMonitor__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_metrics_IORuntimeMetrics__F0__F0__Lcats_effect_unsafe_IORuntime };
function $p_Lcats_effect_unsafe_IORuntime$__runtime$1__sr_LazyRef__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__sci_List__Lcats_effect_unsafe_FiberMonitor__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_metrics_IORuntimeMetrics__F0__F0__Lcats_effect_unsafe_IORuntime($thiz, runtime$lzy1$4, compute$4, blocking$4, scheduler$4, pollers$4, fiberMonitor$4, config$4, metrics$4, unregister$4, shutdown$4) {
  return (runtime$lzy1$4.sr_LazyRef__f__initialized ? runtime$lzy1$4.sr_LazyRef__f__value : $p_Lcats_effect_unsafe_IORuntime$__runtime$lzyINIT1$1__sr_LazyRef__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__sci_List__Lcats_effect_unsafe_FiberMonitor__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_metrics_IORuntimeMetrics__F0__F0__Lcats_effect_unsafe_IORuntime($thiz, runtime$lzy1$4, compute$4, blocking$4, scheduler$4, pollers$4, fiberMonitor$4, config$4, metrics$4, unregister$4, shutdown$4));
}
export { $p_Lcats_effect_unsafe_IORuntime$__runtime$1__sr_LazyRef__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__sci_List__Lcats_effect_unsafe_FiberMonitor__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_metrics_IORuntimeMetrics__F0__F0__Lcats_effect_unsafe_IORuntime as $p_Lcats_effect_unsafe_IORuntime$__runtime$1__sr_LazyRef__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__sci_List__Lcats_effect_unsafe_FiberMonitor__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_metrics_IORuntimeMetrics__F0__F0__Lcats_effect_unsafe_IORuntime };
/** @constructor */
function $c_Lcats_effect_unsafe_IORuntime$() {
  this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global = null;
  this.Lcats_effect_unsafe_IORuntime$__f_allRuntimes = null;
  this.Lcats_effect_unsafe_IORuntime$__f_globalFatalFailureHandled = null;
  $ct_Lcats_effect_unsafe_IORuntimeCompanionPlatform__(this);
  $n_Lcats_effect_unsafe_IORuntime$ = this;
  this.Lcats_effect_unsafe_IORuntime$__f_allRuntimes = new $c_Lcats_effect_unsafe_ThreadSafeHashtable(4);
  this.Lcats_effect_unsafe_IORuntime$__f_globalFatalFailureHandled = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_ju_concurrent_atomic_AtomicBoolean__Z__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_ju_concurrent_atomic_AtomicBoolean(), false);
}
export { $c_Lcats_effect_unsafe_IORuntime$ as $c_Lcats_effect_unsafe_IORuntime$ };
$c_Lcats_effect_unsafe_IORuntime$.prototype = new $h_Lcats_effect_unsafe_IORuntimeCompanionPlatform();
$c_Lcats_effect_unsafe_IORuntime$.prototype.constructor = $c_Lcats_effect_unsafe_IORuntime$;
/** @constructor */
function $h_Lcats_effect_unsafe_IORuntime$() {
}
export { $h_Lcats_effect_unsafe_IORuntime$ as $h_Lcats_effect_unsafe_IORuntime$ };
$h_Lcats_effect_unsafe_IORuntime$.prototype = $c_Lcats_effect_unsafe_IORuntime$.prototype;
$c_Lcats_effect_unsafe_IORuntime$.prototype.apply__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__sci_List__F0__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_IORuntime = (function(compute, blocking, scheduler, pollers, shutdown, config) {
  var runtime$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_LazyRef();
  var fiberMonitor = $m_Lcats_effect_unsafe_FiberMonitor$().apply__s_concurrent_ExecutionContext__Lcats_effect_unsafe_FiberMonitor(compute);
  var unregister = this.registerFiberMonitorMBean__Lcats_effect_unsafe_FiberMonitor__F0(fiberMonitor);
  var metrics = $m_Lcats_effect_unsafe_metrics_IORuntimeMetrics$().apply__s_concurrent_ExecutionContext__Lcats_effect_unsafe_metrics_IORuntimeMetrics(compute);
  var $x_2 = this.Lcats_effect_unsafe_IORuntime$__f_allRuntimes;
  var $x_1 = $p_Lcats_effect_unsafe_IORuntime$__runtime$1__sr_LazyRef__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__sci_List__Lcats_effect_unsafe_FiberMonitor__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_metrics_IORuntimeMetrics__F0__F0__Lcats_effect_unsafe_IORuntime(this, runtime$lzy1, compute, blocking, scheduler, pollers, fiberMonitor, config, metrics, unregister, shutdown);
  var this$1 = $p_Lcats_effect_unsafe_IORuntime$__runtime$1__sr_LazyRef__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__sci_List__Lcats_effect_unsafe_FiberMonitor__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_metrics_IORuntimeMetrics__F0__F0__Lcats_effect_unsafe_IORuntime(this, runtime$lzy1, compute, blocking, scheduler, pollers, fiberMonitor, config, metrics, unregister, shutdown);
  $x_2.put__O__I__V($x_1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$systemIdentityHashCode(this$1));
  return $p_Lcats_effect_unsafe_IORuntime$__runtime$1__sr_LazyRef__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__sci_List__Lcats_effect_unsafe_FiberMonitor__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_metrics_IORuntimeMetrics__F0__F0__Lcats_effect_unsafe_IORuntime(this, runtime$lzy1, compute, blocking, scheduler, pollers, fiberMonitor, config, metrics, unregister, shutdown);
});
var $d_Lcats_effect_unsafe_IORuntime$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_unsafe_IORuntime$, "cats.effect.unsafe.IORuntime$", ({
  Lcats_effect_unsafe_IORuntime$: 1,
  Lcats_effect_unsafe_IORuntimeCompanionPlatform: 1
}));
export { $d_Lcats_effect_unsafe_IORuntime$ as $d_Lcats_effect_unsafe_IORuntime$ };
var $n_Lcats_effect_unsafe_IORuntime$;
function $m_Lcats_effect_unsafe_IORuntime$() {
  if ((!$n_Lcats_effect_unsafe_IORuntime$)) {
    $n_Lcats_effect_unsafe_IORuntime$ = new $c_Lcats_effect_unsafe_IORuntime$();
  }
  return $n_Lcats_effect_unsafe_IORuntime$;
}
export { $m_Lcats_effect_unsafe_IORuntime$ as $m_Lcats_effect_unsafe_IORuntime$ };
/** @constructor */
function $c_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1(outer) {
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1 as $c_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1 };
$c_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1.prototype.constructor = $c_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1;
/** @constructor */
function $h_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1() {
}
export { $h_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1 as $h_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1 };
$h_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1.prototype = $c_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1.prototype;
$c_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1.prototype.deregister__V = (function() {
});
var $d_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1, "cats.effect.unsafe.NoOpFiberMonitor$$anon$1", ({
  Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1: 1,
  Lcats_effect_unsafe_WeakBag$Handle: 1
}));
export { $d_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1 as $d_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1 };
/** @constructor */
function $c_Lcats_effect_unsafe_Scheduler$() {
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$maxTimeout = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$mkCancelRunnable = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$nowMicrosImpl = null;
  $ct_Lcats_effect_unsafe_SchedulerCompanionPlatform__(this);
}
export { $c_Lcats_effect_unsafe_Scheduler$ as $c_Lcats_effect_unsafe_Scheduler$ };
$c_Lcats_effect_unsafe_Scheduler$.prototype = new $h_Lcats_effect_unsafe_SchedulerCompanionPlatform();
$c_Lcats_effect_unsafe_Scheduler$.prototype.constructor = $c_Lcats_effect_unsafe_Scheduler$;
/** @constructor */
function $h_Lcats_effect_unsafe_Scheduler$() {
}
export { $h_Lcats_effect_unsafe_Scheduler$ as $h_Lcats_effect_unsafe_Scheduler$ };
$h_Lcats_effect_unsafe_Scheduler$.prototype = $c_Lcats_effect_unsafe_Scheduler$.prototype;
var $d_Lcats_effect_unsafe_Scheduler$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_unsafe_Scheduler$, "cats.effect.unsafe.Scheduler$", ({
  Lcats_effect_unsafe_Scheduler$: 1,
  Lcats_effect_unsafe_SchedulerCompanionPlatform: 1
}));
export { $d_Lcats_effect_unsafe_Scheduler$ as $d_Lcats_effect_unsafe_Scheduler$ };
var $n_Lcats_effect_unsafe_Scheduler$;
function $m_Lcats_effect_unsafe_Scheduler$() {
  if ((!$n_Lcats_effect_unsafe_Scheduler$)) {
    $n_Lcats_effect_unsafe_Scheduler$ = new $c_Lcats_effect_unsafe_Scheduler$();
  }
  return $n_Lcats_effect_unsafe_Scheduler$;
}
export { $m_Lcats_effect_unsafe_Scheduler$ as $m_Lcats_effect_unsafe_Scheduler$ };
/** @constructor */
function $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1(handle$3, outer) {
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1__f_handle$2 = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1__f_handle$2 = handle$3;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1 as $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1 };
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1.prototype.constructor = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1;
/** @constructor */
function $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1() {
}
export { $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1 as $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1 };
$h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1.prototype = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1.prototype;
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1.prototype.run__V = (function() {
  var handle$1 = this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1__f_handle$2;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sjs_js_timers_package$().clearTimeout__sjs_js_timers_SetTimeoutHandle__V(handle$1);
});
var $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1, "cats.effect.unsafe.SchedulerCompanionPlatform$$anon$1", ({
  Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1: 1,
  jl_Runnable: 1
}));
export { $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1 as $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1 };
/** @constructor */
function $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2(outer) {
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2 as $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2 };
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2.prototype.constructor = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2;
/** @constructor */
function $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2() {
}
export { $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2 as $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2 };
$h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2.prototype = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2.prototype;
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2.prototype.run__V = (function() {
});
var $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2, "cats.effect.unsafe.SchedulerCompanionPlatform$$anon$2", ({
  Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2: 1,
  jl_Runnable: 1
}));
export { $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2 as $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2 };
/** @constructor */
function $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3(outer) {
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3__f_$outer = outer;
}
export { $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3 as $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3 };
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3.prototype.constructor = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3;
/** @constructor */
function $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3() {
}
export { $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3 as $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3 };
$h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3.prototype = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3.prototype;
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3.prototype.sleep__s_concurrent_duration_FiniteDuration__jl_Runnable__jl_Runnable = (function(delay, task) {
  var that = this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3__f_$outer.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$maxTimeout;
  if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_math_Ordered__$less$eq__O__Z(delay, that)) {
    var handle = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sjs_js_timers_package$().setTimeout__s_concurrent_duration_FiniteDuration__F0__sjs_js_timers_SetTimeoutHandle(delay, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
      task.run__V();
    })));
    return (0, this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3__f_$outer.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$mkCancelRunnable)(handle);
  } else {
    var elem = new $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4(this);
    var cancel = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_ObjectRef(elem);
    cancel.sr_ObjectRef__f_elem = this.sleep__s_concurrent_duration_FiniteDuration__jl_Runnable__jl_Runnable(this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3__f_$outer.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$maxTimeout, new $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5(cancel, delay, task, this));
    return new $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6(cancel, this);
  }
});
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3.prototype.nowMicros__J = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ((0, this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3__f_$outer.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$nowMicrosImpl)());
});
var $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3, "cats.effect.unsafe.SchedulerCompanionPlatform$$anon$3", ({
  Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3: 1,
  Lcats_effect_unsafe_Scheduler: 1
}));
export { $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3 as $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3 };
/** @constructor */
function $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4(outer) {
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4 as $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4 };
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4.prototype.constructor = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4;
/** @constructor */
function $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4() {
}
export { $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4 as $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4 };
$h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4.prototype = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4.prototype;
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4.prototype.run__V = (function() {
});
var $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4, "cats.effect.unsafe.SchedulerCompanionPlatform$$anon$4", ({
  Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4: 1,
  jl_Runnable: 1
}));
export { $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4 as $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4 };
/** @constructor */
function $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5(cancel$5, delay$3, task$5, outer) {
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_cancel$3 = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_delay$2 = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_task$4 = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_$outer = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_cancel$3 = cancel$5;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_delay$2 = delay$3;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_task$4 = task$5;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_$outer = outer;
}
export { $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5 as $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5 };
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5.prototype.constructor = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5;
/** @constructor */
function $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5() {
}
export { $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5 as $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5 };
$h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5.prototype = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5.prototype;
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5.prototype.run__V = (function() {
  var this$1 = this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_$outer;
  var cancel$1 = this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_cancel$3;
  var delay$1 = this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_delay$2;
  var task$2 = this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_task$4;
  cancel$1.sr_ObjectRef__f_elem = this$1.sleep__s_concurrent_duration_FiniteDuration__jl_Runnable__jl_Runnable(delay$1.$minus__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration(this$1.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3__f_$outer.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$maxTimeout), task$2);
});
var $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5, "cats.effect.unsafe.SchedulerCompanionPlatform$$anon$5", ({
  Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5: 1,
  jl_Runnable: 1
}));
export { $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5 as $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5 };
/** @constructor */
function $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6(cancel$6, outer) {
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6__f_cancel$4 = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6__f_cancel$4 = cancel$6;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6 as $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6 };
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6.prototype.constructor = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6;
/** @constructor */
function $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6() {
}
export { $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6 as $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6 };
$h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6.prototype = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6.prototype;
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6.prototype.run__V = (function() {
  var cancel$2 = this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6__f_cancel$4;
  cancel$2.sr_ObjectRef__f_elem.run__V();
});
var $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6, "cats.effect.unsafe.SchedulerCompanionPlatform$$anon$6", ({
  Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6: 1,
  jl_Runnable: 1
}));
export { $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6 as $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6 };
function $isArrayOf_Lcats_effect_unsafe_WorkStealingThreadPool(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_unsafe_WorkStealingThreadPool)));
}
export { $isArrayOf_Lcats_effect_unsafe_WorkStealingThreadPool as $isArrayOf_Lcats_effect_unsafe_WorkStealingThreadPool };
/** @constructor */
function $c_Lcats_effect_unsafe_metrics_IORuntimeMetrics$() {
}
export { $c_Lcats_effect_unsafe_metrics_IORuntimeMetrics$ as $c_Lcats_effect_unsafe_metrics_IORuntimeMetrics$ };
$c_Lcats_effect_unsafe_metrics_IORuntimeMetrics$.prototype = new $h_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform();
$c_Lcats_effect_unsafe_metrics_IORuntimeMetrics$.prototype.constructor = $c_Lcats_effect_unsafe_metrics_IORuntimeMetrics$;
/** @constructor */
function $h_Lcats_effect_unsafe_metrics_IORuntimeMetrics$() {
}
export { $h_Lcats_effect_unsafe_metrics_IORuntimeMetrics$ as $h_Lcats_effect_unsafe_metrics_IORuntimeMetrics$ };
$h_Lcats_effect_unsafe_metrics_IORuntimeMetrics$.prototype = $c_Lcats_effect_unsafe_metrics_IORuntimeMetrics$.prototype;
var $d_Lcats_effect_unsafe_metrics_IORuntimeMetrics$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_unsafe_metrics_IORuntimeMetrics$, "cats.effect.unsafe.metrics.IORuntimeMetrics$", ({
  Lcats_effect_unsafe_metrics_IORuntimeMetrics$: 1,
  Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform: 1
}));
export { $d_Lcats_effect_unsafe_metrics_IORuntimeMetrics$ as $d_Lcats_effect_unsafe_metrics_IORuntimeMetrics$ };
var $n_Lcats_effect_unsafe_metrics_IORuntimeMetrics$;
function $m_Lcats_effect_unsafe_metrics_IORuntimeMetrics$() {
  if ((!$n_Lcats_effect_unsafe_metrics_IORuntimeMetrics$)) {
    $n_Lcats_effect_unsafe_metrics_IORuntimeMetrics$ = new $c_Lcats_effect_unsafe_metrics_IORuntimeMetrics$();
  }
  return $n_Lcats_effect_unsafe_metrics_IORuntimeMetrics$;
}
export { $m_Lcats_effect_unsafe_metrics_IORuntimeMetrics$ as $m_Lcats_effect_unsafe_metrics_IORuntimeMetrics$ };
function $f_Lcats_instances_Function1Instances__$init$__V($thiz) {
  $thiz.cats$instances$Function1Instances$_setter_$catsStdInstancesForFunction1_$eq__Lcats_arrow_ArrowChoice__V(new $c_Lcats_instances_Function1Instances$$anon$6());
  $thiz.cats$instances$Function1Instances$_setter_$catsStdMonoidKForFunction1_$eq__Lcats_MonoidK__V(new $c_Lcats_instances_Function1Instances$$anon$7($thiz));
}
export { $f_Lcats_instances_Function1Instances__$init$__V as $f_Lcats_instances_Function1Instances__$init$__V };
/** @constructor */
function $c_Lcats_instances_package$equiv$() {
  this.Lcats_instances_package$equiv$__f_catsContravariantMonoidalForEquiv = null;
  $n_Lcats_instances_package$equiv$ = this;
  this.Lcats_instances_package$equiv$__f_catsContravariantMonoidalForEquiv = new $c_Lcats_instances_EquivInstances$$anon$1();
}
export { $c_Lcats_instances_package$equiv$ as $c_Lcats_instances_package$equiv$ };
$c_Lcats_instances_package$equiv$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_package$equiv$.prototype.constructor = $c_Lcats_instances_package$equiv$;
/** @constructor */
function $h_Lcats_instances_package$equiv$() {
}
export { $h_Lcats_instances_package$equiv$ as $h_Lcats_instances_package$equiv$ };
$h_Lcats_instances_package$equiv$.prototype = $c_Lcats_instances_package$equiv$.prototype;
var $d_Lcats_instances_package$equiv$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_package$equiv$, "cats.instances.package$equiv$", ({
  Lcats_instances_package$equiv$: 1,
  Lcats_instances_EquivInstances: 1
}));
export { $d_Lcats_instances_package$equiv$ as $d_Lcats_instances_package$equiv$ };
var $n_Lcats_instances_package$equiv$;
function $m_Lcats_instances_package$equiv$() {
  if ((!$n_Lcats_instances_package$equiv$)) {
    $n_Lcats_instances_package$equiv$ = new $c_Lcats_instances_package$equiv$();
  }
  return $n_Lcats_instances_package$equiv$;
}
export { $m_Lcats_instances_package$equiv$ as $m_Lcats_instances_package$equiv$ };
/** @constructor */
function $c_Lcats_instances_package$ordering$() {
  this.Lcats_instances_package$ordering$__f_catsContravariantMonoidalForOrdering = null;
  $n_Lcats_instances_package$ordering$ = this;
  this.Lcats_instances_package$ordering$__f_catsContravariantMonoidalForOrdering = new $c_Lcats_instances_OrderingInstances$$anon$1();
}
export { $c_Lcats_instances_package$ordering$ as $c_Lcats_instances_package$ordering$ };
$c_Lcats_instances_package$ordering$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_package$ordering$.prototype.constructor = $c_Lcats_instances_package$ordering$;
/** @constructor */
function $h_Lcats_instances_package$ordering$() {
}
export { $h_Lcats_instances_package$ordering$ as $h_Lcats_instances_package$ordering$ };
$h_Lcats_instances_package$ordering$.prototype = $c_Lcats_instances_package$ordering$.prototype;
var $d_Lcats_instances_package$ordering$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_package$ordering$, "cats.instances.package$ordering$", ({
  Lcats_instances_package$ordering$: 1,
  Lcats_instances_OrderingInstances: 1
}));
export { $d_Lcats_instances_package$ordering$ as $d_Lcats_instances_package$ordering$ };
var $n_Lcats_instances_package$ordering$;
function $m_Lcats_instances_package$ordering$() {
  if ((!$n_Lcats_instances_package$ordering$)) {
    $n_Lcats_instances_package$ordering$ = new $c_Lcats_instances_package$ordering$();
  }
  return $n_Lcats_instances_package$ordering$;
}
export { $m_Lcats_instances_package$ordering$ as $m_Lcats_instances_package$ordering$ };
/** @constructor */
function $c_Lcats_instances_package$partialOrdering$() {
  this.Lcats_instances_package$partialOrdering$__f_catsContravariantMonoidalForPartialOrdering = null;
  $n_Lcats_instances_package$partialOrdering$ = this;
  this.Lcats_instances_package$partialOrdering$__f_catsContravariantMonoidalForPartialOrdering = new $c_Lcats_instances_PartialOrderingInstances$$anon$1();
}
export { $c_Lcats_instances_package$partialOrdering$ as $c_Lcats_instances_package$partialOrdering$ };
$c_Lcats_instances_package$partialOrdering$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_package$partialOrdering$.prototype.constructor = $c_Lcats_instances_package$partialOrdering$;
/** @constructor */
function $h_Lcats_instances_package$partialOrdering$() {
}
export { $h_Lcats_instances_package$partialOrdering$ as $h_Lcats_instances_package$partialOrdering$ };
$h_Lcats_instances_package$partialOrdering$.prototype = $c_Lcats_instances_package$partialOrdering$.prototype;
var $d_Lcats_instances_package$partialOrdering$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_package$partialOrdering$, "cats.instances.package$partialOrdering$", ({
  Lcats_instances_package$partialOrdering$: 1,
  Lcats_instances_PartialOrderingInstances: 1
}));
export { $d_Lcats_instances_package$partialOrdering$ as $d_Lcats_instances_package$partialOrdering$ };
var $n_Lcats_instances_package$partialOrdering$;
function $m_Lcats_instances_package$partialOrdering$() {
  if ((!$n_Lcats_instances_package$partialOrdering$)) {
    $n_Lcats_instances_package$partialOrdering$ = new $c_Lcats_instances_package$partialOrdering$();
  }
  return $n_Lcats_instances_package$partialOrdering$;
}
export { $m_Lcats_instances_package$partialOrdering$ as $m_Lcats_instances_package$partialOrdering$ };
/** @constructor */
function $c_Lcats_kernel_instances_string_package$() {
  this.Lcats_kernel_instances_string_package$__f_catsKernelStdMonoidForString = null;
  $n_Lcats_kernel_instances_string_package$ = this;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_instances_StringInstances__$init$__V(this);
}
export { $c_Lcats_kernel_instances_string_package$ as $c_Lcats_kernel_instances_string_package$ };
$c_Lcats_kernel_instances_string_package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_kernel_instances_string_package$.prototype.constructor = $c_Lcats_kernel_instances_string_package$;
/** @constructor */
function $h_Lcats_kernel_instances_string_package$() {
}
export { $h_Lcats_kernel_instances_string_package$ as $h_Lcats_kernel_instances_string_package$ };
$h_Lcats_kernel_instances_string_package$.prototype = $c_Lcats_kernel_instances_string_package$.prototype;
$c_Lcats_kernel_instances_string_package$.prototype.cats$kernel$instances$StringInstances$_setter_$catsKernelStdOrderForString_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_kernel_instances_string_package$.prototype.cats$kernel$instances$StringInstances$_setter_$catsKernelStdMonoidForString_$eq__Lcats_kernel_Monoid__V = (function(x$0) {
  this.Lcats_kernel_instances_string_package$__f_catsKernelStdMonoidForString = x$0;
});
var $d_Lcats_kernel_instances_string_package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_kernel_instances_string_package$, "cats.kernel.instances.string.package$", ({
  Lcats_kernel_instances_string_package$: 1,
  Lcats_kernel_instances_StringInstances: 1
}));
export { $d_Lcats_kernel_instances_string_package$ as $d_Lcats_kernel_instances_string_package$ };
var $n_Lcats_kernel_instances_string_package$;
function $m_Lcats_kernel_instances_string_package$() {
  if ((!$n_Lcats_kernel_instances_string_package$)) {
    $n_Lcats_kernel_instances_string_package$ = new $c_Lcats_kernel_instances_string_package$();
  }
  return $n_Lcats_kernel_instances_string_package$;
}
export { $m_Lcats_kernel_instances_string_package$ as $m_Lcats_kernel_instances_string_package$ };
/** @constructor */
function $c_Lcats_syntax_Tuple2ParallelOps(t) {
  this.Lcats_syntax_Tuple2ParallelOps__f_t = null;
  this.Lcats_syntax_Tuple2ParallelOps__f_t = t;
}
export { $c_Lcats_syntax_Tuple2ParallelOps as $c_Lcats_syntax_Tuple2ParallelOps };
$c_Lcats_syntax_Tuple2ParallelOps.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_syntax_Tuple2ParallelOps.prototype.constructor = $c_Lcats_syntax_Tuple2ParallelOps;
/** @constructor */
function $h_Lcats_syntax_Tuple2ParallelOps() {
}
export { $h_Lcats_syntax_Tuple2ParallelOps as $h_Lcats_syntax_Tuple2ParallelOps };
$h_Lcats_syntax_Tuple2ParallelOps.prototype = $c_Lcats_syntax_Tuple2ParallelOps.prototype;
$c_Lcats_syntax_Tuple2ParallelOps.prototype.parMapN__F2__Lcats_NonEmptyParallel__O = (function(f, p) {
  var this$1 = $m_Lcats_Parallel$();
  var m0 = this.Lcats_syntax_Tuple2ParallelOps__f_t._1__O();
  var m1 = this.Lcats_syntax_Tuple2ParallelOps__f_t._2__O();
  return $f_Lcats_ParallelArityFunctions__parMap2__O__O__F2__Lcats_NonEmptyParallel__O(this$1, m0, m1, f, p);
});
var $d_Lcats_syntax_Tuple2ParallelOps = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_syntax_Tuple2ParallelOps, "cats.syntax.Tuple2ParallelOps", ({
  Lcats_syntax_Tuple2ParallelOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_syntax_Tuple2ParallelOps as $d_Lcats_syntax_Tuple2ParallelOps };
/** @constructor */
function $c_Lcats_syntax_Tuple2SemigroupalOps(t) {
  this.Lcats_syntax_Tuple2SemigroupalOps__f_t = null;
  this.Lcats_syntax_Tuple2SemigroupalOps__f_t = t;
}
export { $c_Lcats_syntax_Tuple2SemigroupalOps as $c_Lcats_syntax_Tuple2SemigroupalOps };
$c_Lcats_syntax_Tuple2SemigroupalOps.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_syntax_Tuple2SemigroupalOps.prototype.constructor = $c_Lcats_syntax_Tuple2SemigroupalOps;
/** @constructor */
function $h_Lcats_syntax_Tuple2SemigroupalOps() {
}
export { $h_Lcats_syntax_Tuple2SemigroupalOps as $h_Lcats_syntax_Tuple2SemigroupalOps };
$h_Lcats_syntax_Tuple2SemigroupalOps.prototype = $c_Lcats_syntax_Tuple2SemigroupalOps.prototype;
$c_Lcats_syntax_Tuple2SemigroupalOps.prototype.mapN__F2__Lcats_Functor__Lcats_Semigroupal__O = (function(f, functor, semigroupal) {
  var this$1 = $m_Lcats_Semigroupal$();
  var f0 = this.Lcats_syntax_Tuple2SemigroupalOps__f_t._1__O();
  var f1 = this.Lcats_syntax_Tuple2SemigroupalOps__f_t._2__O();
  return $f_Lcats_SemigroupalArityFunctions__map2__O__O__F2__Lcats_Semigroupal__Lcats_Functor__O(this$1, f0, f1, f, semigroupal, functor);
});
var $d_Lcats_syntax_Tuple2SemigroupalOps = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_syntax_Tuple2SemigroupalOps, "cats.syntax.Tuple2SemigroupalOps", ({
  Lcats_syntax_Tuple2SemigroupalOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_syntax_Tuple2SemigroupalOps as $d_Lcats_syntax_Tuple2SemigroupalOps };
/** @constructor */
function $c_Lcom_raquo_airstream_core_InternalObserver$$anon$1() {
}
export { $c_Lcom_raquo_airstream_core_InternalObserver$$anon$1 as $c_Lcom_raquo_airstream_core_InternalObserver$$anon$1 };
$c_Lcom_raquo_airstream_core_InternalObserver$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_core_InternalObserver$$anon$1.prototype.constructor = $c_Lcom_raquo_airstream_core_InternalObserver$$anon$1;
/** @constructor */
function $h_Lcom_raquo_airstream_core_InternalObserver$$anon$1() {
}
export { $h_Lcom_raquo_airstream_core_InternalObserver$$anon$1 as $h_Lcom_raquo_airstream_core_InternalObserver$$anon$1 };
$h_Lcom_raquo_airstream_core_InternalObserver$$anon$1.prototype = $c_Lcom_raquo_airstream_core_InternalObserver$$anon$1.prototype;
$c_Lcom_raquo_airstream_core_InternalObserver$$anon$1.prototype.onNext__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
});
$c_Lcom_raquo_airstream_core_InternalObserver$$anon$1.prototype.onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
});
$c_Lcom_raquo_airstream_core_InternalObserver$$anon$1.prototype.onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
});
var $d_Lcom_raquo_airstream_core_InternalObserver$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_core_InternalObserver$$anon$1, "com.raquo.airstream.core.InternalObserver$$anon$1", ({
  Lcom_raquo_airstream_core_InternalObserver$$anon$1: 1,
  Lcom_raquo_airstream_core_InternalObserver: 1
}));
export { $d_Lcom_raquo_airstream_core_InternalObserver$$anon$1 as $d_Lcom_raquo_airstream_core_InternalObserver$$anon$1 };
/** @constructor */
function $c_Lcom_raquo_airstream_core_InternalObserver$$anon$2(onNextParam$2, onErrorParam$2) {
  this.Lcom_raquo_airstream_core_InternalObserver$$anon$2__f_onNextParam$1 = null;
  this.Lcom_raquo_airstream_core_InternalObserver$$anon$2__f_onErrorParam$1 = null;
  this.Lcom_raquo_airstream_core_InternalObserver$$anon$2__f_onNextParam$1 = onNextParam$2;
  this.Lcom_raquo_airstream_core_InternalObserver$$anon$2__f_onErrorParam$1 = onErrorParam$2;
}
export { $c_Lcom_raquo_airstream_core_InternalObserver$$anon$2 as $c_Lcom_raquo_airstream_core_InternalObserver$$anon$2 };
$c_Lcom_raquo_airstream_core_InternalObserver$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_core_InternalObserver$$anon$2.prototype.constructor = $c_Lcom_raquo_airstream_core_InternalObserver$$anon$2;
/** @constructor */
function $h_Lcom_raquo_airstream_core_InternalObserver$$anon$2() {
}
export { $h_Lcom_raquo_airstream_core_InternalObserver$$anon$2 as $h_Lcom_raquo_airstream_core_InternalObserver$$anon$2 };
$h_Lcom_raquo_airstream_core_InternalObserver$$anon$2.prototype = $c_Lcom_raquo_airstream_core_InternalObserver$$anon$2.prototype;
$c_Lcom_raquo_airstream_core_InternalObserver$$anon$2.prototype.onNext__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  this.Lcom_raquo_airstream_core_InternalObserver$$anon$2__f_onNextParam$1.apply__O__O__O(nextValue, transaction);
});
$c_Lcom_raquo_airstream_core_InternalObserver$$anon$2.prototype.onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  this.Lcom_raquo_airstream_core_InternalObserver$$anon$2__f_onErrorParam$1.apply__O__O__O(nextError, transaction);
});
$c_Lcom_raquo_airstream_core_InternalObserver$$anon$2.prototype.onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  nextValue.fold__F1__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => {
    this.onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(_$1, transaction);
  })), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => {
    this.onNext__O__Lcom_raquo_airstream_core_Transaction__V(_$2, transaction);
  })));
});
var $d_Lcom_raquo_airstream_core_InternalObserver$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_core_InternalObserver$$anon$2, "com.raquo.airstream.core.InternalObserver$$anon$2", ({
  Lcom_raquo_airstream_core_InternalObserver$$anon$2: 1,
  Lcom_raquo_airstream_core_InternalObserver: 1
}));
export { $d_Lcom_raquo_airstream_core_InternalObserver$$anon$2 as $d_Lcom_raquo_airstream_core_InternalObserver$$anon$2 };
/** @constructor */
function $c_Lcom_raquo_airstream_core_InternalObserver$$anon$3(onTryParam$2) {
  this.Lcom_raquo_airstream_core_InternalObserver$$anon$3__f_onTryParam$1 = null;
  this.Lcom_raquo_airstream_core_InternalObserver$$anon$3__f_onTryParam$1 = onTryParam$2;
}
export { $c_Lcom_raquo_airstream_core_InternalObserver$$anon$3 as $c_Lcom_raquo_airstream_core_InternalObserver$$anon$3 };
$c_Lcom_raquo_airstream_core_InternalObserver$$anon$3.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_core_InternalObserver$$anon$3.prototype.constructor = $c_Lcom_raquo_airstream_core_InternalObserver$$anon$3;
/** @constructor */
function $h_Lcom_raquo_airstream_core_InternalObserver$$anon$3() {
}
export { $h_Lcom_raquo_airstream_core_InternalObserver$$anon$3 as $h_Lcom_raquo_airstream_core_InternalObserver$$anon$3 };
$h_Lcom_raquo_airstream_core_InternalObserver$$anon$3.prototype = $c_Lcom_raquo_airstream_core_InternalObserver$$anon$3.prototype;
$c_Lcom_raquo_airstream_core_InternalObserver$$anon$3.prototype.onNext__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  this.onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(nextValue), transaction);
});
$c_Lcom_raquo_airstream_core_InternalObserver$$anon$3.prototype.onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  this.onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(nextError), transaction);
});
$c_Lcom_raquo_airstream_core_InternalObserver$$anon$3.prototype.onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  this.Lcom_raquo_airstream_core_InternalObserver$$anon$3__f_onTryParam$1.apply__O__O__O(nextValue, transaction);
});
var $d_Lcom_raquo_airstream_core_InternalObserver$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_core_InternalObserver$$anon$3, "com.raquo.airstream.core.InternalObserver$$anon$3", ({
  Lcom_raquo_airstream_core_InternalObserver$$anon$3: 1,
  Lcom_raquo_airstream_core_InternalObserver: 1
}));
export { $d_Lcom_raquo_airstream_core_InternalObserver$$anon$3 as $d_Lcom_raquo_airstream_core_InternalObserver$$anon$3 };
/** @constructor */
function $c_Lcom_raquo_airstream_split_Splittable$OptionSplittable$() {
}
export { $c_Lcom_raquo_airstream_split_Splittable$OptionSplittable$ as $c_Lcom_raquo_airstream_split_Splittable$OptionSplittable$ };
$c_Lcom_raquo_airstream_split_Splittable$OptionSplittable$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_split_Splittable$OptionSplittable$.prototype.constructor = $c_Lcom_raquo_airstream_split_Splittable$OptionSplittable$;
/** @constructor */
function $h_Lcom_raquo_airstream_split_Splittable$OptionSplittable$() {
}
export { $h_Lcom_raquo_airstream_split_Splittable$OptionSplittable$ as $h_Lcom_raquo_airstream_split_Splittable$OptionSplittable$ };
$h_Lcom_raquo_airstream_split_Splittable$OptionSplittable$.prototype = $c_Lcom_raquo_airstream_split_Splittable$OptionSplittable$.prototype;
$c_Lcom_raquo_airstream_split_Splittable$OptionSplittable$.prototype.map__O__F1__O = (function(inputs, project) {
  return (inputs.isEmpty__Z() ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$() : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(project.apply__O__O(inputs.get__O())));
});
$c_Lcom_raquo_airstream_split_Splittable$OptionSplittable$.prototype.foreach__O__F1__V = (function(inputs, f) {
  if ((!inputs.isEmpty__Z())) {
    f.apply__O__O(inputs.get__O());
  }
});
$c_Lcom_raquo_airstream_split_Splittable$OptionSplittable$.prototype.empty__O = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
});
var $d_Lcom_raquo_airstream_split_Splittable$OptionSplittable$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_split_Splittable$OptionSplittable$, "com.raquo.airstream.split.Splittable$OptionSplittable$", ({
  Lcom_raquo_airstream_split_Splittable$OptionSplittable$: 1,
  Lcom_raquo_airstream_split_Splittable: 1
}));
export { $d_Lcom_raquo_airstream_split_Splittable$OptionSplittable$ as $d_Lcom_raquo_airstream_split_Splittable$OptionSplittable$ };
var $n_Lcom_raquo_airstream_split_Splittable$OptionSplittable$;
function $m_Lcom_raquo_airstream_split_Splittable$OptionSplittable$() {
  if ((!$n_Lcom_raquo_airstream_split_Splittable$OptionSplittable$)) {
    $n_Lcom_raquo_airstream_split_Splittable$OptionSplittable$ = new $c_Lcom_raquo_airstream_split_Splittable$OptionSplittable$();
  }
  return $n_Lcom_raquo_airstream_split_Splittable$OptionSplittable$;
}
export { $m_Lcom_raquo_airstream_split_Splittable$OptionSplittable$ as $m_Lcom_raquo_airstream_split_Splittable$OptionSplittable$ };
/** @constructor */
function $c_Lcom_raquo_airstream_split_Splittable$VectorSplittable$() {
}
export { $c_Lcom_raquo_airstream_split_Splittable$VectorSplittable$ as $c_Lcom_raquo_airstream_split_Splittable$VectorSplittable$ };
$c_Lcom_raquo_airstream_split_Splittable$VectorSplittable$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_split_Splittable$VectorSplittable$.prototype.constructor = $c_Lcom_raquo_airstream_split_Splittable$VectorSplittable$;
/** @constructor */
function $h_Lcom_raquo_airstream_split_Splittable$VectorSplittable$() {
}
export { $h_Lcom_raquo_airstream_split_Splittable$VectorSplittable$ as $h_Lcom_raquo_airstream_split_Splittable$VectorSplittable$ };
$h_Lcom_raquo_airstream_split_Splittable$VectorSplittable$.prototype = $c_Lcom_raquo_airstream_split_Splittable$VectorSplittable$.prototype;
$c_Lcom_raquo_airstream_split_Splittable$VectorSplittable$.prototype.map__O__F1__O = (function(inputs, project) {
  return inputs.map__F1__O(project);
});
$c_Lcom_raquo_airstream_split_Splittable$VectorSplittable$.prototype.foreach__O__F1__V = (function(inputs, f) {
  inputs.foreach__F1__V(f);
});
$c_Lcom_raquo_airstream_split_Splittable$VectorSplittable$.prototype.empty__O = (function() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector0$();
});
var $d_Lcom_raquo_airstream_split_Splittable$VectorSplittable$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_split_Splittable$VectorSplittable$, "com.raquo.airstream.split.Splittable$VectorSplittable$", ({
  Lcom_raquo_airstream_split_Splittable$VectorSplittable$: 1,
  Lcom_raquo_airstream_split_Splittable: 1
}));
export { $d_Lcom_raquo_airstream_split_Splittable$VectorSplittable$ as $d_Lcom_raquo_airstream_split_Splittable$VectorSplittable$ };
var $n_Lcom_raquo_airstream_split_Splittable$VectorSplittable$;
function $m_Lcom_raquo_airstream_split_Splittable$VectorSplittable$() {
  if ((!$n_Lcom_raquo_airstream_split_Splittable$VectorSplittable$)) {
    $n_Lcom_raquo_airstream_split_Splittable$VectorSplittable$ = new $c_Lcom_raquo_airstream_split_Splittable$VectorSplittable$();
  }
  return $n_Lcom_raquo_airstream_split_Splittable$VectorSplittable$;
}
export { $m_Lcom_raquo_airstream_split_Splittable$VectorSplittable$ as $m_Lcom_raquo_airstream_split_Splittable$VectorSplittable$ };
/** @constructor */
function $c_Lcom_raquo_airstream_state_VarExts$package$$anon$1() {
}
export { $c_Lcom_raquo_airstream_state_VarExts$package$$anon$1 as $c_Lcom_raquo_airstream_state_VarExts$package$$anon$1 };
$c_Lcom_raquo_airstream_state_VarExts$package$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_state_VarExts$package$$anon$1.prototype.constructor = $c_Lcom_raquo_airstream_state_VarExts$package$$anon$1;
/** @constructor */
function $h_Lcom_raquo_airstream_state_VarExts$package$$anon$1() {
}
export { $h_Lcom_raquo_airstream_state_VarExts$package$$anon$1 as $h_Lcom_raquo_airstream_state_VarExts$package$$anon$1 };
$h_Lcom_raquo_airstream_state_VarExts$package$$anon$1.prototype = $c_Lcom_raquo_airstream_state_VarExts$package$$anon$1.prototype;
var $d_Lcom_raquo_airstream_state_VarExts$package$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_state_VarExts$package$$anon$1, "com.raquo.airstream.state.VarExts$package$$anon$1", ({
  Lcom_raquo_airstream_state_VarExts$package$$anon$1: 1,
  Lcom_raquo_airstream_state_FrameworkVarExts: 1
}));
export { $d_Lcom_raquo_airstream_state_VarExts$package$$anon$1 as $d_Lcom_raquo_airstream_state_VarExts$package$$anon$1 };
function $f_Lcom_raquo_laminar_keys_SimpleAttr__$colon$eq__O__Lcom_raquo_laminar_modifiers_SimpleKeySetter($thiz, value) {
  var setOrRemoveF = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction3_$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491(((element, attr, value$2) => {
    var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_domapi_DomApi$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_laminar_domapi_DomKeys__setAttribute__Lcom_raquo_laminar_nodes_ReactiveElement__Lcom_raquo_laminar_keys_SimpleAttr__O__V(this$1, element, attr, value$2);
  }));
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_laminar_modifiers_SimpleKeySetter$$anon$1($thiz, value, setOrRemoveF);
}
export { $f_Lcom_raquo_laminar_keys_SimpleAttr__$colon$eq__O__Lcom_raquo_laminar_modifiers_SimpleKeySetter as $f_Lcom_raquo_laminar_keys_SimpleAttr__$colon$eq__O__Lcom_raquo_laminar_modifiers_SimpleKeySetter };
function $f_Lcom_raquo_laminar_keys_SimpleAttr__$less$minus$minus__Lcom_raquo_airstream_core_Source__F1__Lcom_raquo_laminar_modifiers_SimpleKeyUpdater($thiz, values, ev) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_laminar_modifiers_SimpleKeyUpdater($thiz, values.toObservable__Lcom_raquo_airstream_core_Observable(), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((el, value) => {
    var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_domapi_DomApi$();
    var value$1 = ev.apply__O__O(value);
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_laminar_domapi_DomKeys__setAttribute__Lcom_raquo_laminar_nodes_ReactiveElement__Lcom_raquo_laminar_keys_SimpleAttr__O__V(this$2, el, $thiz, value$1);
  })));
}
export { $f_Lcom_raquo_laminar_keys_SimpleAttr__$less$minus$minus__Lcom_raquo_airstream_core_Source__F1__Lcom_raquo_laminar_modifiers_SimpleKeyUpdater as $f_Lcom_raquo_laminar_keys_SimpleAttr__$less$minus$minus__Lcom_raquo_airstream_core_Source__F1__Lcom_raquo_laminar_modifiers_SimpleKeyUpdater };
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$2(renderNode$2) {
  this.Lcom_raquo_laminar_modifiers_RenderableNode$$anon$2__f_renderNode$1 = null;
  this.Lcom_raquo_laminar_modifiers_RenderableNode$$anon$2__f_renderNode$1 = renderNode$2;
}
export { $c_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$2 as $c_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$2 };
$c_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$2.prototype.constructor = $c_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$2;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$2() {
}
export { $h_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$2 as $h_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$2 };
$h_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$2.prototype = $c_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$2.prototype;
$c_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$2.prototype.asNode__O__Lcom_raquo_laminar_nodes_ChildNode = (function(value) {
  return this.Lcom_raquo_laminar_modifiers_RenderableNode$$anon$2__f_renderNode$1.apply__O__O(value);
});
$c_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$2.prototype.asNodeSeq__Lcom_raquo_laminar_Seq__Lcom_raquo_laminar_Seq = (function(values) {
  return values.map__F1__Lcom_raquo_laminar_Seq(this.Lcom_raquo_laminar_modifiers_RenderableNode$$anon$2__f_renderNode$1);
});
var $d_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$2, "com.raquo.laminar.modifiers.RenderableNode$$anon$2", ({
  Lcom_raquo_laminar_modifiers_RenderableNode$$anon$2: 1,
  Lcom_raquo_laminar_modifiers_RenderableNode: 1
}));
export { $d_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$2 as $d_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$2 };
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$() {
}
export { $c_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$ as $c_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$ };
$c_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$.prototype.constructor = $c_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$() {
}
export { $h_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$ as $h_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$ };
$h_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$.prototype = $c_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$.prototype;
$c_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$.prototype.toSeq__O__Lcom_raquo_laminar_Seq = (function(values) {
  $m_Lcom_raquo_laminar_Seq$();
  return new $c_Lcom_raquo_laminar_Seq(values, null, null);
});
$c_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$.prototype.foreach__O__F1__V = (function(values, f) {
  values.foreach__F1__V(f);
});
var $d_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$, "com.raquo.laminar.modifiers.RenderableSeq$collectionSeqRenderable$", ({
  Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$: 1,
  Lcom_raquo_laminar_modifiers_RenderableSeq: 1
}));
export { $d_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$ as $d_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$ };
var $n_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$;
function $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$() {
  if ((!$n_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$)) {
    $n_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$ = new $c_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$();
  }
  return $n_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$;
}
export { $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$ as $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$ };
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_RenderableSeq$optionRenderable$() {
}
export { $c_Lcom_raquo_laminar_modifiers_RenderableSeq$optionRenderable$ as $c_Lcom_raquo_laminar_modifiers_RenderableSeq$optionRenderable$ };
$c_Lcom_raquo_laminar_modifiers_RenderableSeq$optionRenderable$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_laminar_modifiers_RenderableSeq$optionRenderable$.prototype.constructor = $c_Lcom_raquo_laminar_modifiers_RenderableSeq$optionRenderable$;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_RenderableSeq$optionRenderable$() {
}
export { $h_Lcom_raquo_laminar_modifiers_RenderableSeq$optionRenderable$ as $h_Lcom_raquo_laminar_modifiers_RenderableSeq$optionRenderable$ };
$h_Lcom_raquo_laminar_modifiers_RenderableSeq$optionRenderable$.prototype = $c_Lcom_raquo_laminar_modifiers_RenderableSeq$optionRenderable$.prototype;
$c_Lcom_raquo_laminar_modifiers_RenderableSeq$optionRenderable$.prototype.toSeq__O__Lcom_raquo_laminar_Seq = (function(values) {
  $m_Lcom_raquo_laminar_Seq$();
  var seq = values.toList__sci_List();
  return new $c_Lcom_raquo_laminar_Seq(seq, null, null);
});
$c_Lcom_raquo_laminar_modifiers_RenderableSeq$optionRenderable$.prototype.foreach__O__F1__V = (function(values, f) {
  if ((!values.isEmpty__Z())) {
    f.apply__O__O(values.get__O());
  }
});
var $d_Lcom_raquo_laminar_modifiers_RenderableSeq$optionRenderable$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_laminar_modifiers_RenderableSeq$optionRenderable$, "com.raquo.laminar.modifiers.RenderableSeq$optionRenderable$", ({
  Lcom_raquo_laminar_modifiers_RenderableSeq$optionRenderable$: 1,
  Lcom_raquo_laminar_modifiers_RenderableSeq: 1
}));
export { $d_Lcom_raquo_laminar_modifiers_RenderableSeq$optionRenderable$ as $d_Lcom_raquo_laminar_modifiers_RenderableSeq$optionRenderable$ };
var $n_Lcom_raquo_laminar_modifiers_RenderableSeq$optionRenderable$;
function $m_Lcom_raquo_laminar_modifiers_RenderableSeq$optionRenderable$() {
  if ((!$n_Lcom_raquo_laminar_modifiers_RenderableSeq$optionRenderable$)) {
    $n_Lcom_raquo_laminar_modifiers_RenderableSeq$optionRenderable$ = new $c_Lcom_raquo_laminar_modifiers_RenderableSeq$optionRenderable$();
  }
  return $n_Lcom_raquo_laminar_modifiers_RenderableSeq$optionRenderable$;
}
export { $m_Lcom_raquo_laminar_modifiers_RenderableSeq$optionRenderable$ as $m_Lcom_raquo_laminar_modifiers_RenderableSeq$optionRenderable$ };
/** @constructor */
function $c_Lcom_raquo_waypoint_Route$Total(encode, decode, createRelativeUrl, matchRelativeUrl, basePath, evidence$1) {
  this.Lcom_raquo_waypoint_Route__f_basePath = null;
  this.Lcom_raquo_waypoint_Route$Total__f_com$raquo$waypoint$Route$Total$$encode = null;
  this.Lcom_raquo_waypoint_Route$Total__f_com$raquo$waypoint$Route$Total$$decode = null;
  this.Lcom_raquo_waypoint_Route$Total__f_createRelativeUrl = null;
  this.Lcom_raquo_waypoint_Route$Total__f_matchRelativeUrl = null;
  this.Lcom_raquo_waypoint_Route$Total__f_com$raquo$waypoint$Route$Total$$evidence$1 = null;
  this.Lcom_raquo_waypoint_Route$Total__f_matchEncodePF = null;
  this.Lcom_raquo_waypoint_Route$Total__f_decodePF = null;
  this.Lcom_raquo_waypoint_Route$Total__f_com$raquo$waypoint$Route$Total$$encode = encode;
  this.Lcom_raquo_waypoint_Route$Total__f_com$raquo$waypoint$Route$Total$$decode = decode;
  this.Lcom_raquo_waypoint_Route$Total__f_createRelativeUrl = createRelativeUrl;
  this.Lcom_raquo_waypoint_Route$Total__f_matchRelativeUrl = matchRelativeUrl;
  this.Lcom_raquo_waypoint_Route$Total__f_com$raquo$waypoint$Route$Total$$evidence$1 = evidence$1;
  $ct_Lcom_raquo_waypoint_Route__T__(this, basePath);
  this.Lcom_raquo_waypoint_Route$Total__f_matchEncodePF = new $c_Lcom_raquo_waypoint_Route$Total$$anon$1(this);
  this.Lcom_raquo_waypoint_Route$Total__f_decodePF = new $c_Lcom_raquo_waypoint_Route$Total$$anon$2(this);
}
export { $c_Lcom_raquo_waypoint_Route$Total as $c_Lcom_raquo_waypoint_Route$Total };
$c_Lcom_raquo_waypoint_Route$Total.prototype = new $h_Lcom_raquo_waypoint_Route();
$c_Lcom_raquo_waypoint_Route$Total.prototype.constructor = $c_Lcom_raquo_waypoint_Route$Total;
/** @constructor */
function $h_Lcom_raquo_waypoint_Route$Total() {
}
export { $h_Lcom_raquo_waypoint_Route$Total as $h_Lcom_raquo_waypoint_Route$Total };
$h_Lcom_raquo_waypoint_Route$Total.prototype = $c_Lcom_raquo_waypoint_Route$Total.prototype;
var $d_Lcom_raquo_waypoint_Route$Total = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_waypoint_Route$Total, "com.raquo.waypoint.Route$Total", ({
  Lcom_raquo_waypoint_Route$Total: 1,
  Lcom_raquo_waypoint_Route: 1
}));
export { $d_Lcom_raquo_waypoint_Route$Total as $d_Lcom_raquo_waypoint_Route$Total };
function $is_Lfansi_Attr(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lfansi_Attr)));
}
export { $is_Lfansi_Attr as $is_Lfansi_Attr };
function $isArrayOf_Lfansi_Attr(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfansi_Attr)));
}
export { $isArrayOf_Lfansi_Attr as $isArrayOf_Lfansi_Attr };
var $d_Lfansi_Attr = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass(1, "fansi.Attr", ({
  Lfansi_Attr: 1,
  Lfansi_Attrs: 1
}));
export { $d_Lfansi_Attr as $d_Lfansi_Attr };
/** @constructor */
function $c_Lfansi_Attrs$Multiple(resetMask, applyMask, attrs) {
  this.Lfansi_Attrs$Multiple__f_resetMask = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0;
  this.Lfansi_Attrs$Multiple__f_applyMask = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0;
  this.Lfansi_Attrs$Multiple__f_attrs = null;
  this.Lfansi_Attrs$Multiple__f_resetMask = resetMask;
  this.Lfansi_Attrs$Multiple__f_applyMask = applyMask;
  this.Lfansi_Attrs$Multiple__f_attrs = attrs;
  if ((attrs.length__I() === 1)) {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Scala3RunTime$().assertFailed__E();
  }
}
export { $c_Lfansi_Attrs$Multiple as $c_Lfansi_Attrs$Multiple };
$c_Lfansi_Attrs$Multiple.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfansi_Attrs$Multiple.prototype.constructor = $c_Lfansi_Attrs$Multiple;
/** @constructor */
function $h_Lfansi_Attrs$Multiple() {
}
export { $h_Lfansi_Attrs$Multiple as $h_Lfansi_Attrs$Multiple };
$h_Lfansi_Attrs$Multiple.prototype = $c_Lfansi_Attrs$Multiple.prototype;
$c_Lfansi_Attrs$Multiple.prototype.resetMask__J = (function() {
  return this.Lfansi_Attrs$Multiple__f_resetMask;
});
$c_Lfansi_Attrs$Multiple.prototype.applyMask__J = (function() {
  return this.Lfansi_Attrs$Multiple__f_applyMask;
});
$c_Lfansi_Attrs$Multiple.prototype.hashCode__I = (function() {
  return this.Lfansi_Attrs$Multiple__f_attrs.hashCode__I();
});
$c_Lfansi_Attrs$Multiple.prototype.equals__O__Z = (function(other) {
  if ($is_Lfansi_Attr(this)) {
    if ($is_Lfansi_Attr(other)) {
      return (this === other);
    }
    if ((other instanceof $c_Lfansi_Attrs$Multiple)) {
      if ((other.Lfansi_Attrs$Multiple__f_attrs.length__I() === 1)) {
        return (this === other.Lfansi_Attrs$Multiple__f_attrs.apply__I__O(0));
      }
    }
  }
  if ($is_Lfansi_Attr(other)) {
    if ((this.Lfansi_Attrs$Multiple__f_attrs.length__I() === 1)) {
      return (this.Lfansi_Attrs$Multiple__f_attrs.apply__I__O(0) === other);
    }
  }
  if ((other instanceof $c_Lfansi_Attrs$Multiple)) {
    return (this.Lfansi_Attrs$Multiple__f_attrs === other.Lfansi_Attrs$Multiple__f_attrs);
  }
  return false;
});
$c_Lfansi_Attrs$Multiple.prototype.toString__T = (function() {
  var this$1 = this.Lfansi_Attrs$Multiple__f_attrs;
  return (("Attrs(" + $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__mkString__T__T__T__T(this$1, "", ",", "")) + ")");
});
function $isArrayOf_Lfansi_Attrs$Multiple(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfansi_Attrs$Multiple)));
}
export { $isArrayOf_Lfansi_Attrs$Multiple as $isArrayOf_Lfansi_Attrs$Multiple };
var $d_Lfansi_Attrs$Multiple = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfansi_Attrs$Multiple, "fansi.Attrs$Multiple", ({
  Lfansi_Attrs$Multiple: 1,
  Lfansi_Attrs: 1
}));
export { $d_Lfansi_Attrs$Multiple as $d_Lfansi_Attrs$Multiple };
/** @constructor */
function $c_Lfansi_Bold$() {
  this.Lfansi_Category__f_offset = 0;
  this.Lfansi_Category__f_width = 0;
  this.Lfansi_Category__f_catName = null;
  this.Lfansi_Category__f_lookupAttrTable$lzy1 = null;
  this.Lfansi_Category__f_lookupAttrTablebitmap$1 = false;
  this.Lfansi_Bold$__f_Faint = null;
  this.Lfansi_Bold$__f_On = null;
  this.Lfansi_Bold$__f_Off = null;
  this.Lfansi_Bold$__f_all = null;
  $ct_Lfansi_Category__I__I__Lsourcecode_Name__(this, 0, 2, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Bold")));
  $n_Lfansi_Bold$ = this;
  this.Lfansi_Bold$__f_Faint = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[2m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(2, 0), $m_Lsourcecode_Name$().wrap__O__Lsourcecode_SourceValue("Faint"));
  this.Lfansi_Bold$__f_On = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[1m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(1, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("On")));
  this.Lfansi_Bold$__f_Off = this.makeNoneAttr__J__Lsourcecode_Name__Lfansi_ResetAttr($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Off")));
  var this$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
  var elems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lfansi_Attr.getArrayOf().constr)([this.Lfansi_Bold$__f_On, this.Lfansi_Bold$__f_Off, this.Lfansi_Bold$__f_Faint]));
  this.Lfansi_Bold$__f_all = this$4.from__sc_IterableOnce__sci_Vector(elems);
}
export { $c_Lfansi_Bold$ as $c_Lfansi_Bold$ };
$c_Lfansi_Bold$.prototype = new $h_Lfansi_Category();
$c_Lfansi_Bold$.prototype.constructor = $c_Lfansi_Bold$;
/** @constructor */
function $h_Lfansi_Bold$() {
}
export { $h_Lfansi_Bold$ as $h_Lfansi_Bold$ };
$h_Lfansi_Bold$.prototype = $c_Lfansi_Bold$.prototype;
$c_Lfansi_Bold$.prototype.all__sci_Vector = (function() {
  return this.Lfansi_Bold$__f_all;
});
var $d_Lfansi_Bold$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfansi_Bold$, "fansi.Bold$", ({
  Lfansi_Bold$: 1,
  Lfansi_Category: 1
}));
export { $d_Lfansi_Bold$ as $d_Lfansi_Bold$ };
var $n_Lfansi_Bold$;
function $m_Lfansi_Bold$() {
  if ((!$n_Lfansi_Bold$)) {
    $n_Lfansi_Bold$ = new $c_Lfansi_Bold$();
  }
  return $n_Lfansi_Bold$;
}
export { $m_Lfansi_Bold$ as $m_Lfansi_Bold$ };
function $ct_Lfansi_ColorCategory__I__I__I__Lsourcecode_Name__($thiz, offset, width, colorCode, catName) {
  $thiz.Lfansi_ColorCategory__f_offset = offset;
  $thiz.Lfansi_ColorCategory__f_colorCode = colorCode;
  $ct_Lfansi_Category__I__I__Lsourcecode_Name__($thiz, offset, width, catName);
  var b = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_IndexedSeq$().newBuilder__scm_Builder();
  var it = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_RangeIterator(0, 1, 255, false);
  while (it.sci_RangeIterator__f__hasNext) {
    var x0 = it.next__I();
    var x = ((17 + x0) | 0);
    var hi = (x >> 31);
    var elem = $thiz.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr((((("\u001b[" + colorCode) + ";5;") + x0) + "m"), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(x, hi), $m_Lsourcecode_Name$().wrap__O__Lsourcecode_SourceValue((("Full(" + x0) + ")")));
    b.addOne__O__scm_Growable(elem);
  }
  $thiz.Lfansi_ColorCategory__f_Full = b.result__O();
  return $thiz;
}
export { $ct_Lfansi_ColorCategory__I__I__I__Lsourcecode_Name__ as $ct_Lfansi_ColorCategory__I__I__I__Lsourcecode_Name__ };
function $p_Lfansi_ColorCategory__True0__I__I__I__I__Lfansi_EscapeAttr($thiz, r, g, b, index) {
  var $x_1 = $thiz.trueRgbEscape__I__I__I__T(r, g, b);
  var x = ((273 + index) | 0);
  var hi = (x >> 31);
  return $thiz.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr($x_1, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(x, hi), $m_Lsourcecode_Name$().wrap__O__Lsourcecode_SourceValue((((((("True(" + r) + ",") + g) + ",") + b) + ")")));
}
export { $p_Lfansi_ColorCategory__True0__I__I__I__I__Lfansi_EscapeAttr as $p_Lfansi_ColorCategory__True0__I__I__I__I__Lfansi_EscapeAttr };
/** @constructor */
function $c_Lfansi_ColorCategory() {
  this.Lfansi_Category__f_offset = 0;
  this.Lfansi_Category__f_width = 0;
  this.Lfansi_Category__f_catName = null;
  this.Lfansi_Category__f_lookupAttrTable$lzy1 = null;
  this.Lfansi_Category__f_lookupAttrTablebitmap$1 = false;
  this.Lfansi_ColorCategory__f_offset = 0;
  this.Lfansi_ColorCategory__f_colorCode = 0;
  this.Lfansi_ColorCategory__f_Full = null;
}
export { $c_Lfansi_ColorCategory as $c_Lfansi_ColorCategory };
$c_Lfansi_ColorCategory.prototype = new $h_Lfansi_Category();
$c_Lfansi_ColorCategory.prototype.constructor = $c_Lfansi_ColorCategory;
/** @constructor */
function $h_Lfansi_ColorCategory() {
}
export { $h_Lfansi_ColorCategory as $h_Lfansi_ColorCategory };
$h_Lfansi_ColorCategory.prototype = $c_Lfansi_ColorCategory.prototype;
$c_Lfansi_ColorCategory.prototype.trueRgbEscape__I__I__I__T = (function(r, g, b) {
  return (((((((("\u001b[" + this.Lfansi_ColorCategory__f_colorCode) + ";2;") + r) + ";") + g) + ";") + b) + "m");
});
$c_Lfansi_ColorCategory.prototype.True__I__Lfansi_EscapeAttr = (function(index) {
  var requirement = ((index >= 0) && (index <= 16777216));
  if ((!requirement)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), (("requirement failed: " + "True parameter `index` must be 273 <= index <= 16777488, not ") + index));
  }
  var r = (index >> 16);
  var g = (255 & (index >> 8));
  var b = (255 & index);
  return $p_Lfansi_ColorCategory__True0__I__I__I__I__Lfansi_EscapeAttr(this, r, g, b, index);
});
$c_Lfansi_ColorCategory.prototype.trueIndex__I__I__I__I = (function(r, g, b) {
  var requirement = ((r >= 0) && (r < 256));
  if ((!requirement)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), (("requirement failed: " + "True parameter `r` must be 0 <= r < 256, not ") + r));
  }
  var requirement$1 = ((g >= 0) && (g < 256));
  if ((!requirement$1)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), (("requirement failed: " + "True parameter `g` must be 0 <= r < 256, not ") + g));
  }
  var requirement$2 = ((b >= 0) && (b < 256));
  if ((!requirement$2)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), (("requirement failed: " + "True parameter `b` must be 0 <= r < 256, not ") + b));
  }
  return (((r << 16) | (g << 8)) | b);
});
$c_Lfansi_ColorCategory.prototype.lookupEscape__J__T = (function(applyState) {
  var n = this.Lfansi_ColorCategory__f_offset;
  var hi = applyState.RTLong__f_hi;
  var lo = (((32 & n) === 0) ? (((applyState.RTLong__f_lo >>> n) | 0) | ((hi << 1) << ((31 - n) | 0))) : (hi >> n));
  if ((lo < 273)) {
    return $c_Lfansi_Category.prototype.lookupEscape__J__T.call(this, applyState);
  } else {
    var index = (((-273) + lo) | 0);
    return this.trueRgbEscape__I__I__I__T((index >> 16), (255 & (index >> 8)), (255 & index));
  }
});
$c_Lfansi_ColorCategory.prototype.lookupAttr__J__Lfansi_Attr = (function(applyState) {
  var n = this.Lfansi_ColorCategory__f_offset;
  var hi = applyState.RTLong__f_hi;
  var lo = (((32 & n) === 0) ? (((applyState.RTLong__f_lo >>> n) | 0) | ((hi << 1) << ((31 - n) | 0))) : (hi >> n));
  return ((lo < 273) ? this.lookupAttrTable__ALfansi_Attr().u[lo] : this.True__I__Lfansi_EscapeAttr((((-273) + lo) | 0)));
});
$c_Lfansi_ColorCategory.prototype.lookupTableWidth__I = (function() {
  return 273;
});
/** @constructor */
function $c_Lfansi_Reversed$() {
  this.Lfansi_Category__f_offset = 0;
  this.Lfansi_Category__f_width = 0;
  this.Lfansi_Category__f_catName = null;
  this.Lfansi_Category__f_lookupAttrTable$lzy1 = null;
  this.Lfansi_Category__f_lookupAttrTablebitmap$1 = false;
  this.Lfansi_Reversed$__f_On = null;
  this.Lfansi_Reversed$__f_Off = null;
  this.Lfansi_Reversed$__f_all = null;
  $ct_Lfansi_Category__I__I__Lsourcecode_Name__(this, 2, 1, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Reversed")));
  $n_Lfansi_Reversed$ = this;
  this.Lfansi_Reversed$__f_On = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[7m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(1, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("On")));
  this.Lfansi_Reversed$__f_Off = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[27m", $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Off")));
  var this$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
  var elems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lfansi_EscapeAttr.getArrayOf().constr)([this.Lfansi_Reversed$__f_On, this.Lfansi_Reversed$__f_Off]));
  this.Lfansi_Reversed$__f_all = this$4.from__sc_IterableOnce__sci_Vector(elems);
}
export { $c_Lfansi_Reversed$ as $c_Lfansi_Reversed$ };
$c_Lfansi_Reversed$.prototype = new $h_Lfansi_Category();
$c_Lfansi_Reversed$.prototype.constructor = $c_Lfansi_Reversed$;
/** @constructor */
function $h_Lfansi_Reversed$() {
}
export { $h_Lfansi_Reversed$ as $h_Lfansi_Reversed$ };
$h_Lfansi_Reversed$.prototype = $c_Lfansi_Reversed$.prototype;
$c_Lfansi_Reversed$.prototype.all__sci_Vector = (function() {
  return this.Lfansi_Reversed$__f_all;
});
var $d_Lfansi_Reversed$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfansi_Reversed$, "fansi.Reversed$", ({
  Lfansi_Reversed$: 1,
  Lfansi_Category: 1
}));
export { $d_Lfansi_Reversed$ as $d_Lfansi_Reversed$ };
var $n_Lfansi_Reversed$;
function $m_Lfansi_Reversed$() {
  if ((!$n_Lfansi_Reversed$)) {
    $n_Lfansi_Reversed$ = new $c_Lfansi_Reversed$();
  }
  return $n_Lfansi_Reversed$;
}
export { $m_Lfansi_Reversed$ as $m_Lfansi_Reversed$ };
/** @constructor */
function $c_Lfansi_Underlined$() {
  this.Lfansi_Category__f_offset = 0;
  this.Lfansi_Category__f_width = 0;
  this.Lfansi_Category__f_catName = null;
  this.Lfansi_Category__f_lookupAttrTable$lzy1 = null;
  this.Lfansi_Category__f_lookupAttrTablebitmap$1 = false;
  this.Lfansi_Underlined$__f_On = null;
  this.Lfansi_Underlined$__f_Off = null;
  this.Lfansi_Underlined$__f_all = null;
  $ct_Lfansi_Category__I__I__Lsourcecode_Name__(this, 3, 1, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Underlined")));
  $n_Lfansi_Underlined$ = this;
  this.Lfansi_Underlined$__f_On = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[4m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(1, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("On")));
  this.Lfansi_Underlined$__f_Off = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[24m", $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Off")));
  var this$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
  var elems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lfansi_EscapeAttr.getArrayOf().constr)([this.Lfansi_Underlined$__f_On, this.Lfansi_Underlined$__f_Off]));
  this.Lfansi_Underlined$__f_all = this$4.from__sc_IterableOnce__sci_Vector(elems);
}
export { $c_Lfansi_Underlined$ as $c_Lfansi_Underlined$ };
$c_Lfansi_Underlined$.prototype = new $h_Lfansi_Category();
$c_Lfansi_Underlined$.prototype.constructor = $c_Lfansi_Underlined$;
/** @constructor */
function $h_Lfansi_Underlined$() {
}
export { $h_Lfansi_Underlined$ as $h_Lfansi_Underlined$ };
$h_Lfansi_Underlined$.prototype = $c_Lfansi_Underlined$.prototype;
$c_Lfansi_Underlined$.prototype.all__sci_Vector = (function() {
  return this.Lfansi_Underlined$__f_all;
});
var $d_Lfansi_Underlined$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfansi_Underlined$, "fansi.Underlined$", ({
  Lfansi_Underlined$: 1,
  Lfansi_Category: 1
}));
export { $d_Lfansi_Underlined$ as $d_Lfansi_Underlined$ };
var $n_Lfansi_Underlined$;
function $m_Lfansi_Underlined$() {
  if ((!$n_Lfansi_Underlined$)) {
    $n_Lfansi_Underlined$ = new $c_Lfansi_Underlined$();
  }
  return $n_Lfansi_Underlined$;
}
export { $m_Lfansi_Underlined$ as $m_Lfansi_Underlined$ };
function $ct_Lframework_api_FrameworkEndpoints__Lsttp_tapir_EndpointInput$FixedPath__($thiz, RootPath) {
  $thiz.Lframework_api_FrameworkEndpoints__f_RootPath = RootPath;
  var this$1 = $m_Lsttp_tapir_package$().Lsttp_tapir_package$__f_endpoint;
  var m = $m_Lsttp_model_Method$().Lsttp_model_Method$__f_GET;
  var this$8 = $f_Lsttp_tapir_EndpointInputsOps__method__T__O(this$1, m);
  var this$2 = $m_Lsttp_tapir_package$();
  var other = $f_Lsttp_tapir_Tapir__stringToPath__T__Lsttp_tapir_EndpointInput$FixedPath(this$2, "framework");
  var concat = new $c_Lsttp_tapir_typelevel_ParamConcat$$anon$1();
  var this$6 = $f_Lsttp_tapir_EndpointInput__and__Lsttp_tapir_EndpointInput__Lsttp_tapir_typelevel_ParamConcat__Lsttp_tapir_EndpointInput(RootPath, other, concat);
  var this$4 = $m_Lsttp_tapir_package$();
  var other$1 = $f_Lsttp_tapir_Tapir__stringToPath__T__Lsttp_tapir_EndpointInput$FixedPath(this$4, "sse-connection-tryout");
  var concat$1 = new $c_Lsttp_tapir_typelevel_ParamConcat$$anon$1();
  var i = $f_Lsttp_tapir_EndpointInput__and__Lsttp_tapir_EndpointInput__Lsttp_tapir_typelevel_ParamConcat__Lsttp_tapir_EndpointInput(this$6, other$1, concat$1);
  var concat$2 = new $c_Lsttp_tapir_typelevel_ParamConcat$$anon$1();
  var e$1 = $f_Lsttp_tapir_EndpointInputsOps__in__Lsttp_tapir_EndpointInput__Lsttp_tapir_typelevel_ParamConcat__O(this$8, i, concat$2);
  var $x_2 = $m_Lframework_exts_EndpointExts$package$();
  var this$10 = $m_Lsttp_tapir_package$();
  var $x_1 = $f_Lsttp_tapir_Tapir__stringToPath__T__Lsttp_tapir_EndpointInput$FixedPath(this$10, "ws");
  var this$11 = $m_Lframework_tapir_FrameworkTapir$();
  var evidence$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_data_FrameworkDateTime$().circeCodec__Lio_circe_Codec();
  var evidence$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_data_FrameworkDateTime$().circeCodec__Lio_circe_Codec();
  var evidence$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_data_FrameworkDateTime$().schema__Lsttp_tapir_Schema();
  $thiz.Lframework_api_FrameworkEndpoints__f_sseConnectionTryout = $x_2.serverSentEventsAndWebSocket__Lsttp_tapir_Endpoint__Lsttp_tapir_EndpointInput__Lsttp_tapir_Codec__Lframework_data_EndpointSSEWithWS(e$1, $x_1, $f_Lsttp_tapir_json_circe_TapirJsonCirce__circeCodec__Lio_circe_Encoder__Lio_circe_Decoder__Lsttp_tapir_Schema__Lsttp_tapir_Codec(this$11, evidence$1, evidence$2, evidence$3));
  return $thiz;
}
export { $ct_Lframework_api_FrameworkEndpoints__Lsttp_tapir_EndpointInput$FixedPath__ as $ct_Lframework_api_FrameworkEndpoints__Lsttp_tapir_EndpointInput$FixedPath__ };
/** @constructor */
function $c_Lframework_api_FrameworkEndpoints() {
  this.Lframework_api_FrameworkEndpoints__f_RootPath = null;
  this.Lframework_api_FrameworkEndpoints__f_sseConnectionTryout = null;
}
export { $c_Lframework_api_FrameworkEndpoints as $c_Lframework_api_FrameworkEndpoints };
$c_Lframework_api_FrameworkEndpoints.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_api_FrameworkEndpoints.prototype.constructor = $c_Lframework_api_FrameworkEndpoints;
/** @constructor */
function $h_Lframework_api_FrameworkEndpoints() {
}
export { $h_Lframework_api_FrameworkEndpoints as $h_Lframework_api_FrameworkEndpoints };
$h_Lframework_api_FrameworkEndpoints.prototype = $c_Lframework_api_FrameworkEndpoints.prototype;
$c_Lframework_api_FrameworkEndpoints.prototype.sseConnectionTryout__Lframework_data_EndpointSSEWithWS = (function() {
  return this.Lframework_api_FrameworkEndpoints__f_sseConnectionTryout;
});
function $ct_Lframework_components_FrameworkMainModal__($thiz) {
  $thiz.Lframework_components_FrameworkMainModal__f_DataBox$lzy1 = new $c_Lframework_components_FrameworkMainModal$DataBox$($thiz);
  $thiz.Lframework_components_FrameworkMainModal__f_dataVar = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_Named__setDisplayName__T__Lcom_raquo_airstream_core_Named($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.Lcom_raquo_laminar_api_package$$anon$1__f_Var.apply__O__Lcom_raquo_airstream_state_Var($m_sci_Queue$EmptyQueue$()), "AppMainModal");
  var this$3 = $thiz.Lframework_components_FrameworkMainModal__f_dataVar.signal__Lcom_raquo_airstream_state_StrictSignal();
  var project = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$1) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_LinearSeqOps__headOption__s_Option(_$1)));
  var this$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), this$3, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  $thiz.Lframework_components_FrameworkMainModal__f_currentDataSignal = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable(this$4);
  var $x_25 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.dialogTag__Lcom_raquo_laminar_tags_HtmlTag();
  var $x_24 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
  var $x_23 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.Lcom_raquo_laminar_api_package$$anon$1__f_cls.$colon$eq__T__Lcom_raquo_laminar_modifiers_CompositeKeySetter("modal");
  var $x_22 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.div__Lcom_raquo_laminar_tags_HtmlTag();
  var $x_21 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
  var $x_20 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.Lcom_raquo_laminar_api_package$$anon$1__f_cls.$colon$eq__T__Lcom_raquo_laminar_modifiers_CompositeKeySetter("modal-box");
  var $x_19 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.h3__Lcom_raquo_laminar_tags_HtmlTag();
  var $x_18 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
  var $x_17 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.Lcom_raquo_laminar_api_package$$anon$1__f_cls.$colon$eq__T__Lcom_raquo_laminar_modifiers_CompositeKeySetter("font-bold text-lg flex items-center gap-2");
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$();
  var this$14 = $thiz.Lframework_components_FrameworkMainModal__f_currentDataSignal;
  var project$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1) => {
    if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var box = x$1.s_Some__f_value;
      var data = box.Lframework_components_FrameworkMainModal$DataBox__f_data;
      return $thiz.renderDataAsTitle__Lapp_components_AppMainModal$Data__sci_Seq(data);
    }
    var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    if ((x === x$1)) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  }));
  var childrenSource = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), this$14, project$1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var $x_16 = $x_19.apply__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($x_18.wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_laminar_modifiers_Modifier.getArrayOf().constr)([$x_17, $m_Lcom_raquo_laminar_inserters_ChildrenInserter$().apply__Lcom_raquo_airstream_core_Observable__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_RenderableNode__O__Lcom_raquo_laminar_inserters_DynamicInserter(childrenSource, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_modifiers_RenderableNode$().Lcom_raquo_laminar_modifiers_RenderableNode$__f_nodeRenderable, (void 0))])));
  var $x_15 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.div__Lcom_raquo_laminar_tags_HtmlTag();
  var $x_14 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
  var $x_13 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.Lcom_raquo_laminar_api_package$$anon$1__f_cls.$colon$eq__T__Lcom_raquo_laminar_modifiers_CompositeKeySetter("py-4 prose");
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$();
  var this$20 = $thiz.Lframework_components_FrameworkMainModal__f_currentDataSignal;
  var project$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1$2) => {
    if ((x$1$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var box$1 = x$1$2.s_Some__f_value;
      var data$1 = box$1.Lframework_components_FrameworkMainModal$DataBox__f_data;
      return $thiz.renderDataAsContent__Lapp_components_AppMainModal$Data__sci_Seq(data$1);
    }
    var x$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    if ((x$2 === x$1$2)) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1$2);
  }));
  var childrenSource$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), this$20, project$2, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var $x_12 = $x_15.apply__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($x_14.wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_laminar_modifiers_Modifier.getArrayOf().constr)([$x_13, $m_Lcom_raquo_laminar_inserters_ChildrenInserter$().apply__Lcom_raquo_airstream_core_Observable__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_RenderableNode__O__Lcom_raquo_laminar_inserters_DynamicInserter(childrenSource$1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_modifiers_RenderableNode$().Lcom_raquo_laminar_modifiers_RenderableNode$__f_nodeRenderable, (void 0))])));
  var $x_11 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.div__Lcom_raquo_laminar_tags_HtmlTag();
  var $x_10 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
  var $x_9 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.Lcom_raquo_laminar_api_package$$anon$1__f_cls.$colon$eq__T__Lcom_raquo_laminar_modifiers_CompositeKeySetter("modal-action");
  var $x_8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.form__Lcom_raquo_laminar_tags_HtmlTag();
  var $x_7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
  var $x_6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.method__Lcom_raquo_laminar_keys_HtmlProp().$colon$eq__O__Lcom_raquo_laminar_modifiers_SimpleKeySetter("dialog");
  var $x_5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.button__Lcom_raquo_laminar_tags_HtmlTag();
  var $x_4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
  var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.Lcom_raquo_laminar_api_package$$anon$1__f_cls.$colon$eq__T__Lcom_raquo_laminar_modifiers_CompositeKeySetter("btn btn-primary");
  var this$31 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L;
  var modifiers = $thiz.closeButtonModifiers__sci_Seq();
  var this$30 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_$less$colon$less$();
  var asModifier = this$30.s_$less$colon$less$__f_singleton;
  var renderableSeq = $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$();
  var $x_2 = $x_22.apply__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($x_21.wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_laminar_modifiers_Modifier.getArrayOf().constr)([$x_20, $x_16, $x_12, $x_11.apply__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($x_10.wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_laminar_modifiers_Modifier.getArrayOf().constr)([$x_9, $x_8.apply__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($x_7.wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_laminar_modifiers_Modifier.getArrayOf().constr)([$x_6, $x_5.apply__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($x_4.wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_laminar_modifiers_Modifier.getArrayOf().constr)([$x_3, $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier(this$31, modifiers, asModifier, renderableSeq)])))])))])))])));
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$();
  var this$33 = $m_Lframework_exts_SignalExts$package$().frameworkSignalExts__Lframework_exts_SignalExts();
  var signal = $thiz.Lframework_components_FrameworkMainModal__f_currentDataSignal;
  var source = $f_Lframework_exts_SignalExts__changedValues__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_core_Signal(this$33, signal);
  var $x_1 = $m_Lcom_raquo_laminar_api_Implicits$SourceArrowSyntax$().$minus$minus$greater$extension__Lcom_raquo_airstream_core_Source__F1__Lcom_raquo_laminar_modifiers_Binder(source, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1$3) => {
    matchResult8: {
      if ((x$1$3 !== null)) {
        var previousDataOpt = x$1$3._1__O();
        var dataOpt = x$1$3._2__O();
        var this$35 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_$less$colon$less$();
        var this$36 = previousDataOpt.flatten__s_$less$colon$less__s_Option(this$35.s_$less$colon$less$__f_singleton);
        if ((!this$36.isEmpty__Z())) {
          var x0 = this$36.get__O();
          var msg$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([("modal for data closed: " + x0.Lframework_components_FrameworkMainModal$DataBox__f_data)]));
          var this$39 = $thiz.log__Lframework_utils_JSLogger();
          var definedAt = x0.Lframework_components_FrameworkMainModal$DataBox__f_data.definedAt__Lframework_sourcecode_DefinedAt();
          $thiz.log__Lframework_utils_JSLogger();
          var this$38 = $m_Lframework_prelude_client\uff3flogging$package$JSAppName$();
          var appName = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Newtype$WithoutValidation__apply__O__O(this$38, "app");
          var level = $s_Lframework_utils_LogLevel$__Debug__Lframework_utils_LogLevel();
          this$39.atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V(level, this$39.scope__s_Option(), msg$1, definedAt, appName);
          var this$40 = x0.Lframework_components_FrameworkMainModal$DataBox__f_closed;
          $f_s_concurrent_Promise__success__O__s_concurrent_Promise(this$40, (void 0));
        }
        var x$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        if ((x$3 === dataOpt)) {
          var msg$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(["closing modal."]));
          var this$44 = $thiz.log__Lframework_utils_JSLogger();
          var file = new $c_Lsourcecode_File("/home/arturaz/work/rapix/framework/clientDaisyUI/src/framework/components/FrameworkMainModal.scala");
          var line = new $c_Lsourcecode_Line(99);
          var name = new $c_Lsourcecode_FullName("framework.components.FrameworkMainModal.tag");
          var definedAt$1 = new $c_Lframework_sourcecode_DefinedAt(file, line, name);
          $thiz.log__Lframework_utils_JSLogger();
          var this$43 = $m_Lframework_prelude_client\uff3flogging$package$JSAppName$();
          var appName$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Newtype$WithoutValidation__apply__O__O(this$43, "app");
          var level$1 = $s_Lframework_utils_LogLevel$__Debug__Lframework_utils_LogLevel();
          this$44.atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V(level$1, this$44.scope__s_Option(), msg$2, definedAt$1, appName$1);
          $thiz.Lframework_components_FrameworkMainModal__f_tag.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_ref.close();
          break matchResult8;
        }
        if ((dataOpt instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
          var x14 = dataOpt.s_Some__f_value;
          if ((x14 !== null)) {
            var x16 = x14.Lframework_components_FrameworkMainModal$DataBox__f_data;
            var msg$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([(("opening modal with data: " + x16) + ".")]));
            var this$48 = $thiz.log__Lframework_utils_JSLogger();
            var definedAt$2 = x16.definedAt__Lframework_sourcecode_DefinedAt();
            $thiz.log__Lframework_utils_JSLogger();
            var this$47 = $m_Lframework_prelude_client\uff3flogging$package$JSAppName$();
            var appName$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Newtype$WithoutValidation__apply__O__O(this$47, "app");
            var level$2 = $s_Lframework_utils_LogLevel$__Debug__Lframework_utils_LogLevel();
            this$48.atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V(level$2, this$48.scope__s_Option(), msg$3, definedAt$2, appName$2);
            $thiz.Lframework_components_FrameworkMainModal__f_tag.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_ref.showModal();
            break matchResult8;
          }
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(dataOpt);
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1$3);
    }
  })));
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$();
  var eventProp = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_laminar_keys_EventProp("close");
  var this$57 = $m_Lcom_raquo_laminar_keys_EventProcessor$().empty__Lcom_raquo_laminar_keys_EventProp__Z__Z__Lcom_raquo_laminar_keys_EventProcessor(eventProp, false, false);
  var onNext = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$3) => {
    var msg$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(["modal closed."]));
    var this$56 = $thiz.log__Lframework_utils_JSLogger();
    var file$1 = new $c_Lsourcecode_File("/home/arturaz/work/rapix/framework/clientDaisyUI/src/framework/components/FrameworkMainModal.scala");
    var line$1 = new $c_Lsourcecode_Line(108);
    var name$1 = new $c_Lsourcecode_FullName("framework.components.FrameworkMainModal.tag");
    var definedAt$3 = new $c_Lframework_sourcecode_DefinedAt(file$1, line$1, name$1);
    $thiz.log__Lframework_utils_JSLogger();
    var this$55 = $m_Lframework_prelude_client\uff3flogging$package$JSAppName$();
    var appName$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Newtype$WithoutValidation__apply__O__O(this$55, "app");
    var level$3 = $s_Lframework_utils_LogLevel$__Debug__Lframework_utils_LogLevel();
    this$56.atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V(level$3, this$56.scope__s_Option(), msg$4, definedAt$3, appName$3);
    $thiz.close__V();
  }));
  $thiz.Lframework_components_FrameworkMainModal__f_tag = $x_25.apply__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($x_24.wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_laminar_modifiers_Modifier.getArrayOf().constr)([$x_23, $x_2, $x_1, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_laminar_modifiers_EventListener(this$57, onNext)])));
  return $thiz;
}
export { $ct_Lframework_components_FrameworkMainModal__ as $ct_Lframework_components_FrameworkMainModal__ };
/** @constructor */
function $c_Lframework_components_FrameworkMainModal() {
  this.Lframework_components_FrameworkMainModal__f_log$lzy1 = null;
  this.Lframework_components_FrameworkMainModal__f_logbitmap$1 = false;
  this.Lframework_components_FrameworkMainModal__f_DataBox$lzy1 = null;
  this.Lframework_components_FrameworkMainModal__f_dataVar = null;
  this.Lframework_components_FrameworkMainModal__f_currentDataSignal = null;
  this.Lframework_components_FrameworkMainModal__f_tag = null;
  this.Lframework_components_FrameworkMainModal__f_enclosingForLogger$lzy1 = null;
  this.Lframework_components_FrameworkMainModal__f_enclosingForLoggerbitmap$1 = false;
}
export { $c_Lframework_components_FrameworkMainModal as $c_Lframework_components_FrameworkMainModal };
$c_Lframework_components_FrameworkMainModal.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_components_FrameworkMainModal.prototype.constructor = $c_Lframework_components_FrameworkMainModal;
/** @constructor */
function $h_Lframework_components_FrameworkMainModal() {
}
export { $h_Lframework_components_FrameworkMainModal as $h_Lframework_components_FrameworkMainModal };
$h_Lframework_components_FrameworkMainModal.prototype = $c_Lframework_components_FrameworkMainModal.prototype;
$c_Lframework_components_FrameworkMainModal.prototype.log__Lframework_utils_JSLogger = (function() {
  if ((!this.Lframework_components_FrameworkMainModal__f_logbitmap$1)) {
    this.Lframework_components_FrameworkMainModal__f_log$lzy1 = $f_Lframework_utils_WithLogger__log__Lframework_utils_JSLogger(this);
    this.Lframework_components_FrameworkMainModal__f_logbitmap$1 = true;
  }
  return this.Lframework_components_FrameworkMainModal__f_log$lzy1;
});
$c_Lframework_components_FrameworkMainModal.prototype.showFuture__Lframework_components_FrameworkMainModal$Data__s_concurrent_Future = (function(data) {
  var promise = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
  var box = this.Lframework_components_FrameworkMainModal__f_DataBox$lzy1.apply__Lframework_components_FrameworkMainModal$Data__s_concurrent_Promise__Lframework_components_FrameworkMainModal$DataBox(data, promise);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_state_Var__update__F1__V(this.Lframework_components_FrameworkMainModal__f_dataVar, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((q) => q.enqueue__O__sci_Queue(box))));
  return promise;
});
$c_Lframework_components_FrameworkMainModal.prototype.show__Lframework_components_FrameworkMainModal$Data__V = (function(data) {
  this.showFuture__Lframework_components_FrameworkMainModal$Data__s_concurrent_Future(data);
});
$c_Lframework_components_FrameworkMainModal.prototype.close__V = (function() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_state_Var__update__F1__V(this.Lframework_components_FrameworkMainModal__f_dataVar, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$2) => _$2.tail__sci_Queue())));
});
$c_Lframework_components_FrameworkMainModal.prototype.detailsDiv__T__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveHtmlElement = (function(details, title) {
  var $x_18 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.div__Lcom_raquo_laminar_tags_HtmlTag();
  var $x_17 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
  var $x_16 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.Lcom_raquo_laminar_api_package$$anon$1__f_cls.$colon$eq__T__Lcom_raquo_laminar_modifiers_CompositeKeySetter("collapse collapse-arrow bg-base-200");
  var $x_15 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.input__Lcom_raquo_laminar_tags_HtmlTag();
  var $x_14 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
  var this$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.type__Lcom_raquo_laminar_keys_HtmlAttr();
  var $x_13 = $x_15.apply__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($x_14.wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_laminar_modifiers_Modifier.getArrayOf().constr)([$f_Lcom_raquo_laminar_keys_SimpleAttr__$colon$eq__O__Lcom_raquo_laminar_modifiers_SimpleKeySetter(this$5, "checkbox")])));
  var $x_12 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.div__Lcom_raquo_laminar_tags_HtmlTag();
  var $x_11 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
  var $x_10 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.Lcom_raquo_laminar_api_package$$anon$1__f_cls.$colon$eq__T__Lcom_raquo_laminar_modifiers_CompositeKeySetter("collapse-title font-bold");
  var this$11 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L;
  var this$10 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_$less$colon$less$();
  var asModifier = this$10.s_$less$colon$less$__f_singleton;
  var renderableSeq = $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$();
  var $x_9 = $x_12.apply__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($x_11.wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_laminar_modifiers_Modifier.getArrayOf().constr)([$x_10, $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier(this$11, title, asModifier, renderableSeq)])));
  var $x_8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.div__Lcom_raquo_laminar_tags_HtmlTag();
  var $x_7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
  var $x_6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.Lcom_raquo_laminar_api_package$$anon$1__f_cls.$colon$eq__T__Lcom_raquo_laminar_modifiers_CompositeKeySetter("collapse-content");
  var $x_5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.pre__Lcom_raquo_laminar_tags_HtmlTag();
  var $x_4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
  var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.Lcom_raquo_laminar_api_package$$anon$1__f_cls.$colon$eq__T__Lcom_raquo_laminar_modifiers_CompositeKeySetter("my-0");
  var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.code__Lcom_raquo_laminar_tags_HtmlTag();
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$();
  var r = $m_Lframework_prelude_laminar$package$().renderableTextForShow__Lcats_Show__Lcom_raquo_laminar_modifiers_RenderableText($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString);
  return $x_18.apply__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($x_17.wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_laminar_modifiers_Modifier.getArrayOf().constr)([$x_16, $x_13, $x_9, $x_8.apply__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($x_7.wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_laminar_modifiers_Modifier.getArrayOf().constr)([$x_6, $x_5.apply__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($x_4.wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_laminar_modifiers_Modifier.getArrayOf().constr)([$x_3, $x_2.apply__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($x_1.wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_laminar_modifiers_Modifier.getArrayOf().constr)([$m_Lcom_raquo_laminar_nodes_TextNode$().apply__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode(details, r)])))])))])))])));
});
$c_Lframework_components_FrameworkMainModal.prototype.enclosingForLogger__Lsourcecode_Enclosing = (function() {
  if ((!this.Lframework_components_FrameworkMainModal__f_enclosingForLoggerbitmap$1)) {
    this.Lframework_components_FrameworkMainModal__f_enclosingForLogger$lzy1 = new $c_Lsourcecode_Enclosing("framework.components.FrameworkMainModal#enclosingForLogger");
    this.Lframework_components_FrameworkMainModal__f_enclosingForLoggerbitmap$1 = true;
  }
  return this.Lframework_components_FrameworkMainModal__f_enclosingForLogger$lzy1;
});
/** @constructor */
function $c_Lframework_data_AppBaseUri$$anon$3(scheme$3, location$2, serverPort$2, isProd$3) {
  this.Lframework_data_AppBaseUri$$anon$3__f_isProd$4 = false;
  this.Lframework_data_AppBaseUri$$anon$3__f_uri = null;
  this.Lframework_data_AppBaseUri$$anon$3__f_isProd$4 = isProd$3;
  this.Lframework_data_AppBaseUri$$anon$3__f_uri = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_Uri$().apply__T__T__I__Lsttp_model_Uri(scheme$3, location$2.hostname, serverPort$2);
}
export { $c_Lframework_data_AppBaseUri$$anon$3 as $c_Lframework_data_AppBaseUri$$anon$3 };
$c_Lframework_data_AppBaseUri$$anon$3.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_AppBaseUri$$anon$3.prototype.constructor = $c_Lframework_data_AppBaseUri$$anon$3;
/** @constructor */
function $h_Lframework_data_AppBaseUri$$anon$3() {
}
export { $h_Lframework_data_AppBaseUri$$anon$3 as $h_Lframework_data_AppBaseUri$$anon$3 };
$h_Lframework_data_AppBaseUri$$anon$3.prototype = $c_Lframework_data_AppBaseUri$$anon$3.prototype;
$c_Lframework_data_AppBaseUri$$anon$3.prototype.toString__T = (function() {
  return $f_Lframework_data_AppBaseUri__toString__T(this);
});
$c_Lframework_data_AppBaseUri$$anon$3.prototype.isProduction__Z = (function() {
  var this$1 = $m_Lframework_data_IsProductionMode$package$IsProductionMode$();
  var input = this.Lframework_data_AppBaseUri$$anon$3__f_isProd$4;
  return (!(!$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Newtype$WithoutValidation__apply__O__O(this$1, input)));
});
var $d_Lframework_data_AppBaseUri$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_AppBaseUri$$anon$3, "framework.data.AppBaseUri$$anon$3", ({
  Lframework_data_AppBaseUri$$anon$3: 1,
  Lframework_data_AppBaseUri: 1
}));
export { $d_Lframework_data_AppBaseUri$$anon$3 as $d_Lframework_data_AppBaseUri$$anon$3 };
function $f_Lframework_data_AuthLoadingStatus__map__F1__Lframework_data_AuthLoadingStatus($thiz, f) {
  matchResult1: {
    var $x_1;
    var x = $m_Lframework_data_AuthLoadingStatus$Loading$();
    if ((x === $thiz)) {
      var $x_1 = $m_Lframework_data_AuthLoadingStatus$Loading$();
      break matchResult1;
    }
    var x$3 = $m_Lframework_data_AuthLoadingStatus$NotFound$();
    if ((x$3 === $thiz)) {
      var $x_1 = $m_Lframework_data_AuthLoadingStatus$NotFound$();
      break matchResult1;
    }
    var x$5 = $m_Lframework_data_AuthLoadingStatus$NetworkError$();
    if ((x$5 === $thiz)) {
      var $x_1 = $m_Lframework_data_AuthLoadingStatus$NetworkError$();
      break matchResult1;
    }
    var x$7 = $m_Lframework_data_AuthLoadingStatus$Unauthenticated$();
    if ((x$7 === $thiz)) {
      var $x_1 = $m_Lframework_data_AuthLoadingStatus$Unauthenticated$();
      break matchResult1;
    }
    if (($thiz instanceof $c_Lframework_data_AuthLoadingStatus$Loaded)) {
      var x4 = $thiz.Lframework_data_AuthLoadingStatus$Loaded__f_value;
      var value = f.apply__O__O(x4);
      var $x_1 = new $c_Lframework_data_AuthLoadingStatus$Loaded(value);
      break matchResult1;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError($thiz);
  }
  return $x_1;
}
export { $f_Lframework_data_AuthLoadingStatus__map__F1__Lframework_data_AuthLoadingStatus as $f_Lframework_data_AuthLoadingStatus__map__F1__Lframework_data_AuthLoadingStatus };
function $f_Lframework_data_AuthLoadingStatus__isLoading__Z($thiz) {
  var x = $m_Lframework_data_AuthLoadingStatus$Loading$();
  if ((x === $thiz)) {
    return true;
  }
  var x$3 = $m_Lframework_data_AuthLoadingStatus$NotFound$();
  if ((x$3 === $thiz)) {
    return false;
  }
  var x$5 = $m_Lframework_data_AuthLoadingStatus$NetworkError$();
  if ((x$5 === $thiz)) {
    return false;
  }
  var x$7 = $m_Lframework_data_AuthLoadingStatus$Unauthenticated$();
  if ((x$7 === $thiz)) {
    return false;
  }
  if (($thiz instanceof $c_Lframework_data_AuthLoadingStatus$Loaded)) {
    return false;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError($thiz);
}
export { $f_Lframework_data_AuthLoadingStatus__isLoading__Z as $f_Lframework_data_AuthLoadingStatus__isLoading__Z };
function $f_Lframework_data_AuthLoadingStatus__toLoadedOption__s_Option($thiz) {
  var x = $m_Lframework_data_AuthLoadingStatus$Loading$();
  if ((x === $thiz)) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
  var x$3 = $m_Lframework_data_AuthLoadingStatus$NotFound$();
  if ((x$3 === $thiz)) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
  var x$5 = $m_Lframework_data_AuthLoadingStatus$NetworkError$();
  if ((x$5 === $thiz)) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
  var x$7 = $m_Lframework_data_AuthLoadingStatus$Unauthenticated$();
  if ((x$7 === $thiz)) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
  if (($thiz instanceof $c_Lframework_data_AuthLoadingStatus$Loaded)) {
    var x12 = $thiz.Lframework_data_AuthLoadingStatus$Loaded__f_value;
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(x12);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError($thiz);
}
export { $f_Lframework_data_AuthLoadingStatus__toLoadedOption__s_Option as $f_Lframework_data_AuthLoadingStatus__toLoadedOption__s_Option };
function $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasSucceededState__withAuthenticationFailedOnServerSide__O__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide($thiz, data) {
  if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasSucceededState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
    return $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasSucceededState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$().Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$__f_AuthenticatedInClientSideButNotServerSide$lzy1.apply__O__O__s_Option__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_clientData, data, $thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_maybeRedirectToAfterRegistration);
  }
  if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasSucceededState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
    return $thiz.copy__O__O__s_Option__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_clientData, data, $thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_maybeRedirectToAfterRegistration);
  }
  if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasSucceededState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
    return $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasSucceededState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$().Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$__f_AuthenticatedInClientSideButNotServerSide$lzy1.apply__O__O__s_Option__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_clientData, data, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError($thiz);
}
export { $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasSucceededState__withAuthenticationFailedOnServerSide__O__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide as $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasSucceededState__withAuthenticationFailedOnServerSide__O__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide };
function $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasSucceededState__withAuthenticationSucceededOnServerSide__O__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated($thiz, data) {
  if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasSucceededState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
    return $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasSucceededState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$().Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$__f_Authenticated$lzy1.apply__O__O__s_Option__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_clientData, data, $thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_maybeRedirectToAfterRegistration);
  }
  if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasSucceededState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
    return $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasSucceededState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$().Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$__f_Authenticated$lzy1.apply__O__O__s_Option__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_clientData, data, $thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_maybeRedirectToAfterRegistration);
  }
  if ((($thiz instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated) && ($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_$outer === $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasSucceededState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$()))) {
    return $thiz.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasSucceededState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth().ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$().Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$__f_Authenticated$lzy1.apply__O__O__s_Option__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated($thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_clientData, data, $thiz.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_maybeRedirectToAfterRegistration);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError($thiz);
}
export { $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasSucceededState__withAuthenticationSucceededOnServerSide__O__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated as $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasSucceededState__withAuthenticationSucceededOnServerSide__O__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated };
/** @constructor */
function $c_Lframework_data_Email$package$Email$$anon$1() {
}
export { $c_Lframework_data_Email$package$Email$$anon$1 as $c_Lframework_data_Email$package$Email$$anon$1 };
$c_Lframework_data_Email$package$Email$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_Email$package$Email$$anon$1.prototype.constructor = $c_Lframework_data_Email$package$Email$$anon$1;
/** @constructor */
function $h_Lframework_data_Email$package$Email$$anon$1() {
}
export { $h_Lframework_data_Email$package$Email$$anon$1 as $h_Lframework_data_Email$package$Email$$anon$1 };
$h_Lframework_data_Email$package$Email$$anon$1.prototype = $c_Lframework_data_Email$package$Email$$anon$1.prototype;
$c_Lframework_data_Email$package$Email$$anon$1.prototype.validate__O__s_Option = (function(input) {
  var x2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__indexOf__I__I(input, 64);
  if ((x2 === (-1))) {
    var value = new $c_Lframework_data_Email$package$Email$NotAnEmail(input);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
  }
  var x1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__lastIndexOf__I__I(input, 46);
  if ((x1 === (-1))) {
    var value$1 = new $c_Lframework_data_Email$package$Email$NotAnEmail(input);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value$1);
  }
  if ((x1 <= x2)) {
    var value$2 = new $c_Lframework_data_Email$package$Email$NotAnEmail(input);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value$2);
  } else {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
});
var $d_Lframework_data_Email$package$Email$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_Email$package$Email$$anon$1, "framework.data.Email$package$Email$$anon$1", ({
  Lframework_data_Email$package$Email$$anon$1: 1,
  Lyantl_ValidatorRule: 1
}));
export { $d_Lframework_data_Email$package$Email$$anon$1 as $d_Lframework_data_Email$package$Email$$anon$1 };
/** @constructor */
function $c_Lframework_data_FrameworkDate$$anon$1() {
}
export { $c_Lframework_data_FrameworkDate$$anon$1 as $c_Lframework_data_FrameworkDate$$anon$1 };
$c_Lframework_data_FrameworkDate$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_FrameworkDate$$anon$1.prototype.constructor = $c_Lframework_data_FrameworkDate$$anon$1;
/** @constructor */
function $h_Lframework_data_FrameworkDate$$anon$1() {
}
export { $h_Lframework_data_FrameworkDate$$anon$1 as $h_Lframework_data_FrameworkDate$$anon$1 };
$h_Lframework_data_FrameworkDate$$anon$1.prototype = $c_Lframework_data_FrameworkDate$$anon$1.prototype;
$c_Lframework_data_FrameworkDate$$anon$1.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(x$0) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_time_LocalDate$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(x$0);
});
var $d_Lframework_data_FrameworkDate$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_FrameworkDate$$anon$1, "framework.data.FrameworkDate$$anon$1", ({
  Lframework_data_FrameworkDate$$anon$1: 1,
  Ljava_time_temporal_TemporalQuery: 1
}));
export { $d_Lframework_data_FrameworkDate$$anon$1 as $d_Lframework_data_FrameworkDate$$anon$1 };
/** @constructor */
function $c_Lframework_data_LastVersionFor$ForBuilder$$anon$1(version$2) {
  this.Lframework_data_LastVersionFor$ForBuilder$$anon$1__f_version$1 = null;
  this.Lframework_data_LastVersionFor$ForBuilder$$anon$1__f_version$1 = version$2;
}
export { $c_Lframework_data_LastVersionFor$ForBuilder$$anon$1 as $c_Lframework_data_LastVersionFor$ForBuilder$$anon$1 };
$c_Lframework_data_LastVersionFor$ForBuilder$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_LastVersionFor$ForBuilder$$anon$1.prototype.constructor = $c_Lframework_data_LastVersionFor$ForBuilder$$anon$1;
/** @constructor */
function $h_Lframework_data_LastVersionFor$ForBuilder$$anon$1() {
}
export { $h_Lframework_data_LastVersionFor$ForBuilder$$anon$1 as $h_Lframework_data_LastVersionFor$ForBuilder$$anon$1 };
$h_Lframework_data_LastVersionFor$ForBuilder$$anon$1.prototype = $c_Lframework_data_LastVersionFor$ForBuilder$$anon$1.prototype;
var $d_Lframework_data_LastVersionFor$ForBuilder$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_LastVersionFor$ForBuilder$$anon$1, "framework.data.LastVersionFor$ForBuilder$$anon$1", ({
  Lframework_data_LastVersionFor$ForBuilder$$anon$1: 1,
  Lframework_data_LastVersionFor: 1
}));
export { $d_Lframework_data_LastVersionFor$ForBuilder$$anon$1 as $d_Lframework_data_LastVersionFor$ForBuilder$$anon$1 };
function $f_Lframework_data_LocalLoadingStatus__isLoading__Z($thiz) {
  var x = $m_Lframework_data_LocalLoadingStatus$Loading$();
  if ((x === $thiz)) {
    return true;
  }
  if (($thiz instanceof $c_Lframework_data_LocalLoadingStatus$Loaded)) {
    return false;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError($thiz);
}
export { $f_Lframework_data_LocalLoadingStatus__isLoading__Z as $f_Lframework_data_LocalLoadingStatus__isLoading__Z };
function $f_Lframework_data_LocalLoadingStatus__toLoadedOption__s_Option($thiz) {
  var x = $m_Lframework_data_LocalLoadingStatus$Loading$();
  if ((x === $thiz)) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
  if (($thiz instanceof $c_Lframework_data_LocalLoadingStatus$Loaded)) {
    var x20 = $thiz.Lframework_data_LocalLoadingStatus$Loaded__f_value;
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(x20);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError($thiz);
}
export { $f_Lframework_data_LocalLoadingStatus__toLoadedOption__s_Option as $f_Lframework_data_LocalLoadingStatus__toLoadedOption__s_Option };
function $f_Lframework_data_LocalLoadingStatus__toAirstream__I__Lcom_raquo_airstream_status_Status($thiz, ix) {
  matchResult6: {
    var $x_1;
    var x = $m_Lframework_data_LocalLoadingStatus$Loading$();
    if ((x === $thiz)) {
      var $x_1 = new $c_Lcom_raquo_airstream_status_Pending((void 0));
      break matchResult6;
    }
    if (($thiz instanceof $c_Lframework_data_LocalLoadingStatus$Loaded)) {
      var x24 = $thiz.Lframework_data_LocalLoadingStatus$Loaded__f_value;
      var $x_1 = new $c_Lcom_raquo_airstream_status_Resolved((void 0), x24, ix);
      break matchResult6;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError($thiz);
  }
  return $x_1;
}
export { $f_Lframework_data_LocalLoadingStatus__toAirstream__I__Lcom_raquo_airstream_status_Status as $f_Lframework_data_LocalLoadingStatus__toAirstream__I__Lcom_raquo_airstream_status_Status };
function $p_Lframework_exts_ClientEndpointExts$package$$anon$5__createUri$1__F0__Lframework_data_AppBaseUri__O__O__Lsttp_model_Uri($thiz, now$1, baseUri$1, securityParams, params) {
  var ev$1 = now$1.apply__O();
  var timestamp = ((ev$1 === null) ? null : ev$1.Lframework_data_FrameworkDateTime__f_ldt);
  matchResult11: {
    var \u03b42$;
    var x39 = $m_Lframework_api_FrameworkHeaders$X$minusRequest$minusStarted$minusAt$().apply__Ljava_time_LocalDateTime__T2(timestamp);
    if ((x39 !== null)) {
      var \u03b42$ = x39;
      break matchResult11;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x39);
  }
  var name = \u03b42$._1__O();
  var value = \u03b42$._2__O();
  return $m_Lframework_exts_ClientEndpointExts$package$().toReq__Lsttp_tapir_Endpoint__O__O__Ljava_time_LocalDateTime__Lframework_data_AppBaseUri__Lsttp_client3_RequestT($thiz.Lframework_exts_ClientEndpointExts$package$$anon$5__f_e$2, securityParams, params, timestamp, baseUri$1).Lsttp_client3_RequestT__f_uri.addParam__T__T__Lsttp_model_Uri(name, value);
}
export { $p_Lframework_exts_ClientEndpointExts$package$$anon$5__createUri$1__F0__Lframework_data_AppBaseUri__O__O__Lsttp_model_Uri as $p_Lframework_exts_ClientEndpointExts$package$$anon$5__createUri$1__F0__Lframework_data_AppBaseUri__O__O__Lsttp_model_Uri };
/** @constructor */
function $c_Lframework_exts_ClientEndpointExts$package$$anon$5(e$5) {
  this.Lframework_exts_ClientEndpointExts$package$$anon$5__f_e$2 = null;
  this.Lframework_exts_ClientEndpointExts$package$$anon$5__f_e$2 = e$5;
}
export { $c_Lframework_exts_ClientEndpointExts$package$$anon$5 as $c_Lframework_exts_ClientEndpointExts$package$$anon$5 };
$c_Lframework_exts_ClientEndpointExts$package$$anon$5.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_ClientEndpointExts$package$$anon$5.prototype.constructor = $c_Lframework_exts_ClientEndpointExts$package$$anon$5;
/** @constructor */
function $h_Lframework_exts_ClientEndpointExts$package$$anon$5() {
}
export { $h_Lframework_exts_ClientEndpointExts$package$$anon$5 as $h_Lframework_exts_ClientEndpointExts$package$$anon$5 };
$h_Lframework_exts_ClientEndpointExts$package$$anon$5.prototype = $c_Lframework_exts_ClientEndpointExts$package$$anon$5.prototype;
$c_Lframework_exts_ClientEndpointExts$package$$anon$5.prototype.raw__O__O__F0__s_Option__Z__Lframework_data_AppBaseUri__Lframework_sourcecode_DefinedAt__Lcom_raquo_airstream_core_EventStream = (function(securityParams, params, now, reconnectOnError, withCredentials, baseUri, definedAt) {
  $m_Lframework_prelude_js$();
  var fields = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T2.getArrayOf().constr)([$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), "withCredentials", withCredentials)]));
  var options = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var createUri = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((securityParams$2, params$2) => $p_Lframework_exts_ClientEndpointExts$package$$anon$5__createUri$1__F0__Lframework_data_AppBaseUri__O__O__Lsttp_model_Uri(this, now, baseUri, securityParams$2, params$2)));
  var createEventStream = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((uri) => $m_Lframework_exts_EventStreamExts$package$().fromDomEventSource__Lcom_raquo_airstream_core_EventStream$__F0__F1__Lcom_raquo_airstream_core_EventStream($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_EventStream$(), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855(((uri$2) => (() => $ps_Lframework_exts_ClientEndpointExts$package$__createEventSource$1__Lorg_scalajs_dom_EventSourceInit__Lframework_sourcecode_DefinedAt__Lsttp_model_Uri__Lorg_scalajs_dom_EventSource(options, definedAt, uri$2)))(uri)), $m_Lframework_exts_EventStreamExts$package$().fromDomEventSource$default$3__Lcom_raquo_airstream_core_EventStream$__F1($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_EventStream$()))));
  var createEithersEventStream = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((uri$2$1) => $m_Lframework_exts_EventStreamExts$package$().fromDomEventSourceEither__Lcom_raquo_airstream_core_EventStream$__F0__Lcom_raquo_airstream_core_EventStream($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_EventStream$(), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855(((uri$2$2) => (() => $ps_Lframework_exts_ClientEndpointExts$package$__createEventSource$1__Lorg_scalajs_dom_EventSourceInit__Lframework_sourcecode_DefinedAt__Lsttp_model_Uri__Lorg_scalajs_dom_EventSource(options, definedAt, uri$2$2)))(uri$2$1)))));
  return $f_Lframework_utils_ToSSEStreamBuilder__rawImpl__O__O__s_Option__F2__F1__F1__Lframework_data_AppBaseUri__Lframework_sourcecode_DefinedAt__Lcom_raquo_airstream_core_EventStream(this, securityParams, params, reconnectOnError, createUri, createEventStream, createEithersEventStream, baseUri, definedAt);
});
var $d_Lframework_exts_ClientEndpointExts$package$$anon$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_ClientEndpointExts$package$$anon$5, "framework.exts.ClientEndpointExts$package$$anon$5", ({
  Lframework_exts_ClientEndpointExts$package$$anon$5: 1,
  Lframework_utils_ToSSEStreamBuilder: 1
}));
export { $d_Lframework_exts_ClientEndpointExts$package$$anon$5 as $d_Lframework_exts_ClientEndpointExts$package$$anon$5 };
function $p_Lframework_exts_ClientEndpointExts$package$$anon$6__createUri$2__F0__Lframework_data_AppBaseUri__O__O__Lsttp_model_Uri($thiz, now$2, baseUri$2, securityParams, params) {
  var ev$2 = now$2.apply__O();
  var timestamp = ((ev$2 === null) ? null : ev$2.Lframework_data_FrameworkDateTime__f_ldt);
  matchResult12: {
    var \u03b44$;
    var x42 = $m_Lframework_api_FrameworkHeaders$X$minusRequest$minusStarted$minusAt$().apply__Ljava_time_LocalDateTime__T2(timestamp);
    if ((x42 !== null)) {
      var \u03b44$ = x42;
      break matchResult12;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x42);
  }
  var name = \u03b44$._1__O();
  var value = \u03b44$._2__O();
  return $m_Lframework_exts_ClientEndpointExts$package$().toReq__Lsttp_tapir_Endpoint__O__O__Ljava_time_LocalDateTime__Lframework_data_AppBaseUri__Lsttp_client3_RequestT($thiz.Lframework_exts_ClientEndpointExts$package$$anon$6__f_e$3, securityParams, params, timestamp, baseUri$2).Lsttp_client3_RequestT__f_uri.addParam__T__T__Lsttp_model_Uri(name, value);
}
export { $p_Lframework_exts_ClientEndpointExts$package$$anon$6__createUri$2__F0__Lframework_data_AppBaseUri__O__O__Lsttp_model_Uri as $p_Lframework_exts_ClientEndpointExts$package$$anon$6__createUri$2__F0__Lframework_data_AppBaseUri__O__O__Lsttp_model_Uri };
/** @constructor */
function $c_Lframework_exts_ClientEndpointExts$package$$anon$6(e$6) {
  this.Lframework_exts_ClientEndpointExts$package$$anon$6__f_e$3 = null;
  this.Lframework_exts_ClientEndpointExts$package$$anon$6__f_e$3 = e$6;
}
export { $c_Lframework_exts_ClientEndpointExts$package$$anon$6 as $c_Lframework_exts_ClientEndpointExts$package$$anon$6 };
$c_Lframework_exts_ClientEndpointExts$package$$anon$6.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_ClientEndpointExts$package$$anon$6.prototype.constructor = $c_Lframework_exts_ClientEndpointExts$package$$anon$6;
/** @constructor */
function $h_Lframework_exts_ClientEndpointExts$package$$anon$6() {
}
export { $h_Lframework_exts_ClientEndpointExts$package$$anon$6 as $h_Lframework_exts_ClientEndpointExts$package$$anon$6 };
$h_Lframework_exts_ClientEndpointExts$package$$anon$6.prototype = $c_Lframework_exts_ClientEndpointExts$package$$anon$6.prototype;
$c_Lframework_exts_ClientEndpointExts$package$$anon$6.prototype.raw__O__O__F0__s_Option__Z__Lframework_data_AppBaseUri__Lframework_sourcecode_DefinedAt__Lcom_raquo_airstream_core_EventStream = (function(securityParams, params, now, reconnectOnError, withCredentials, baseUri, definedAt) {
  var createUri = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((securityParams$2, params$2) => $p_Lframework_exts_ClientEndpointExts$package$$anon$6__createUri$2__F0__Lframework_data_AppBaseUri__O__O__Lsttp_model_Uri(this, now, baseUri, securityParams$2, params$2)));
  var createEventStream = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((uri) => $m_Lframework_exts_EventStreamExts$package$().fromWebSocket__Lcom_raquo_airstream_core_EventStream$__F0__F1__Lcom_raquo_airstream_core_EventStream($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_EventStream$(), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855(((uri$2) => (() => $ps_Lframework_exts_ClientEndpointExts$package$__createWebSocket$1__Lframework_sourcecode_DefinedAt__Lsttp_model_Uri__Lorg_scalajs_dom_WebSocket(definedAt, uri$2)))(uri)), $m_Lframework_exts_EventStreamExts$package$().fromWebSocket$default$3__Lcom_raquo_airstream_core_EventStream$__F1($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_EventStream$()))));
  var createEithersEventStream = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((uri$2$1) => $m_Lframework_exts_EventStreamExts$package$().fromWebSocketEither__Lcom_raquo_airstream_core_EventStream$__F0__Lcom_raquo_airstream_core_EventStream($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_EventStream$(), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855(((uri$2$2) => (() => $ps_Lframework_exts_ClientEndpointExts$package$__createWebSocket$1__Lframework_sourcecode_DefinedAt__Lsttp_model_Uri__Lorg_scalajs_dom_WebSocket(definedAt, uri$2$2)))(uri$2$1)))));
  return $f_Lframework_utils_ToSSEStreamBuilder__rawImpl__O__O__s_Option__F2__F1__F1__Lframework_data_AppBaseUri__Lframework_sourcecode_DefinedAt__Lcom_raquo_airstream_core_EventStream(this, securityParams, params, reconnectOnError, createUri, createEventStream, createEithersEventStream, baseUri, definedAt);
});
var $d_Lframework_exts_ClientEndpointExts$package$$anon$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_ClientEndpointExts$package$$anon$6, "framework.exts.ClientEndpointExts$package$$anon$6", ({
  Lframework_exts_ClientEndpointExts$package$$anon$6: 1,
  Lframework_utils_ToSSEStreamBuilder: 1
}));
export { $d_Lframework_exts_ClientEndpointExts$package$$anon$6 as $d_Lframework_exts_ClientEndpointExts$package$$anon$6 };
/** @constructor */
function $c_Lframework_exts_EventStreamExts$package$$anon$3() {
}
export { $c_Lframework_exts_EventStreamExts$package$$anon$3 as $c_Lframework_exts_EventStreamExts$package$$anon$3 };
$c_Lframework_exts_EventStreamExts$package$$anon$3.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_EventStreamExts$package$$anon$3.prototype.constructor = $c_Lframework_exts_EventStreamExts$package$$anon$3;
/** @constructor */
function $h_Lframework_exts_EventStreamExts$package$$anon$3() {
}
export { $h_Lframework_exts_EventStreamExts$package$$anon$3 as $h_Lframework_exts_EventStreamExts$package$$anon$3 };
$h_Lframework_exts_EventStreamExts$package$$anon$3.prototype = $c_Lframework_exts_EventStreamExts$package$$anon$3.prototype;
var $d_Lframework_exts_EventStreamExts$package$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_EventStreamExts$package$$anon$3, "framework.exts.EventStreamExts$package$$anon$3", ({
  Lframework_exts_EventStreamExts$package$$anon$3: 1,
  Lframework_exts_EventStreamBooleanExts: 1
}));
export { $d_Lframework_exts_EventStreamExts$package$$anon$3 as $d_Lframework_exts_EventStreamExts$package$$anon$3 };
/** @constructor */
function $c_Lframework_exts_EventStreamExts$package$$anon$4() {
}
export { $c_Lframework_exts_EventStreamExts$package$$anon$4 as $c_Lframework_exts_EventStreamExts$package$$anon$4 };
$c_Lframework_exts_EventStreamExts$package$$anon$4.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_EventStreamExts$package$$anon$4.prototype.constructor = $c_Lframework_exts_EventStreamExts$package$$anon$4;
/** @constructor */
function $h_Lframework_exts_EventStreamExts$package$$anon$4() {
}
export { $h_Lframework_exts_EventStreamExts$package$$anon$4 as $h_Lframework_exts_EventStreamExts$package$$anon$4 };
$h_Lframework_exts_EventStreamExts$package$$anon$4.prototype = $c_Lframework_exts_EventStreamExts$package$$anon$4.prototype;
var $d_Lframework_exts_EventStreamExts$package$$anon$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_EventStreamExts$package$$anon$4, "framework.exts.EventStreamExts$package$$anon$4", ({
  Lframework_exts_EventStreamExts$package$$anon$4: 1,
  Lframework_exts_EventStreamExts: 1
}));
export { $d_Lframework_exts_EventStreamExts$package$$anon$4 as $d_Lframework_exts_EventStreamExts$package$$anon$4 };
/** @constructor */
function $c_Lframework_exts_IterableOnceExts$package$$anon$2() {
}
export { $c_Lframework_exts_IterableOnceExts$package$$anon$2 as $c_Lframework_exts_IterableOnceExts$package$$anon$2 };
$c_Lframework_exts_IterableOnceExts$package$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_IterableOnceExts$package$$anon$2.prototype.constructor = $c_Lframework_exts_IterableOnceExts$package$$anon$2;
/** @constructor */
function $h_Lframework_exts_IterableOnceExts$package$$anon$2() {
}
export { $h_Lframework_exts_IterableOnceExts$package$$anon$2 as $h_Lframework_exts_IterableOnceExts$package$$anon$2 };
$h_Lframework_exts_IterableOnceExts$package$$anon$2.prototype = $c_Lframework_exts_IterableOnceExts$package$$anon$2.prototype;
var $d_Lframework_exts_IterableOnceExts$package$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_IterableOnceExts$package$$anon$2, "framework.exts.IterableOnceExts$package$$anon$2", ({
  Lframework_exts_IterableOnceExts$package$$anon$2: 1,
  Lframework_exts_IterableOnceExts: 1
}));
export { $d_Lframework_exts_IterableOnceExts$package$$anon$2 as $d_Lframework_exts_IterableOnceExts$package$$anon$2 };
/** @constructor */
function $c_Lframework_exts_ObservableExts$package$$anon$1() {
}
export { $c_Lframework_exts_ObservableExts$package$$anon$1 as $c_Lframework_exts_ObservableExts$package$$anon$1 };
$c_Lframework_exts_ObservableExts$package$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_ObservableExts$package$$anon$1.prototype.constructor = $c_Lframework_exts_ObservableExts$package$$anon$1;
/** @constructor */
function $h_Lframework_exts_ObservableExts$package$$anon$1() {
}
export { $h_Lframework_exts_ObservableExts$package$$anon$1 as $h_Lframework_exts_ObservableExts$package$$anon$1 };
$h_Lframework_exts_ObservableExts$package$$anon$1.prototype = $c_Lframework_exts_ObservableExts$package$$anon$1.prototype;
var $d_Lframework_exts_ObservableExts$package$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_ObservableExts$package$$anon$1, "framework.exts.ObservableExts$package$$anon$1", ({
  Lframework_exts_ObservableExts$package$$anon$1: 1,
  Lframework_exts_ObservableExts: 1
}));
export { $d_Lframework_exts_ObservableExts$package$$anon$1 as $d_Lframework_exts_ObservableExts$package$$anon$1 };
/** @constructor */
function $c_Lframework_exts_OnSSEStreamError$$anon$1(f$2, outer) {
  this.Lframework_exts_OnSSEStreamError$$anon$1__f_f$1 = null;
  this.Lframework_exts_OnSSEStreamError$$anon$1__f_$outer = null;
  this.Lframework_exts_OnSSEStreamError$$anon$1__f_f$1 = f$2;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lframework_exts_OnSSEStreamError$$anon$1__f_$outer = outer;
}
export { $c_Lframework_exts_OnSSEStreamError$$anon$1 as $c_Lframework_exts_OnSSEStreamError$$anon$1 };
$c_Lframework_exts_OnSSEStreamError$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_OnSSEStreamError$$anon$1.prototype.constructor = $c_Lframework_exts_OnSSEStreamError$$anon$1;
/** @constructor */
function $h_Lframework_exts_OnSSEStreamError$$anon$1() {
}
export { $h_Lframework_exts_OnSSEStreamError$$anon$1 as $h_Lframework_exts_OnSSEStreamError$$anon$1 };
$h_Lframework_exts_OnSSEStreamError$$anon$1.prototype = $c_Lframework_exts_OnSSEStreamError$$anon$1.prototype;
$c_Lframework_exts_OnSSEStreamError$$anon$1.prototype.onMessage__O__V = (function(msg) {
  this.Lframework_exts_OnSSEStreamError$$anon$1__f_f$1.apply__O__O(msg);
});
$c_Lframework_exts_OnSSEStreamError$$anon$1.prototype.onError__Lsttp_model_Uri__Lorg_scalajs_dom_Event__I__O__O__Lframework_sourcecode_DefinedAt__Lframework_exts_OnSSEStreamError$OnErrorAction = (function(uri, error, connectionIndex, securityInput, input, x$6) {
  return this.Lframework_exts_OnSSEStreamError$$anon$1__f_$outer.onError__Lsttp_model_Uri__Lorg_scalajs_dom_Event__I__O__O__Lframework_sourcecode_DefinedAt__Lframework_exts_OnSSEStreamError$OnErrorAction(uri, error, connectionIndex, securityInput, input, x$6);
});
var $d_Lframework_exts_OnSSEStreamError$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_OnSSEStreamError$$anon$1, "framework.exts.OnSSEStreamError$$anon$1", ({
  Lframework_exts_OnSSEStreamError$$anon$1: 1,
  Lframework_exts_OnSSEStreamError: 1
}));
export { $d_Lframework_exts_OnSSEStreamError$$anon$1 as $d_Lframework_exts_OnSSEStreamError$$anon$1 };
/** @constructor */
function $c_Lframework_exts_OnSSEStreamError$$anon$3() {
}
export { $c_Lframework_exts_OnSSEStreamError$$anon$3 as $c_Lframework_exts_OnSSEStreamError$$anon$3 };
$c_Lframework_exts_OnSSEStreamError$$anon$3.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_OnSSEStreamError$$anon$3.prototype.constructor = $c_Lframework_exts_OnSSEStreamError$$anon$3;
/** @constructor */
function $h_Lframework_exts_OnSSEStreamError$$anon$3() {
}
export { $h_Lframework_exts_OnSSEStreamError$$anon$3 as $h_Lframework_exts_OnSSEStreamError$$anon$3 };
$h_Lframework_exts_OnSSEStreamError$$anon$3.prototype = $c_Lframework_exts_OnSSEStreamError$$anon$3.prototype;
$c_Lframework_exts_OnSSEStreamError$$anon$3.prototype.onMessage__O__V = (function(msg) {
});
$c_Lframework_exts_OnSSEStreamError$$anon$3.prototype.onError__Lsttp_model_Uri__Lorg_scalajs_dom_Event__I__O__O__Lframework_sourcecode_DefinedAt__Lframework_exts_OnSSEStreamError$OnErrorAction = (function(uri, error, connectionIndex, securityInput, input, x$6) {
  return $m_Lframework_exts_OnSSEStreamError$().defaultOnError__Lsttp_model_Uri__Lorg_scalajs_dom_Event__I__O__O__Lframework_sourcecode_DefinedAt__Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter(uri, error, connectionIndex, securityInput, input, x$6);
});
var $d_Lframework_exts_OnSSEStreamError$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_OnSSEStreamError$$anon$3, "framework.exts.OnSSEStreamError$$anon$3", ({
  Lframework_exts_OnSSEStreamError$$anon$3: 1,
  Lframework_exts_OnSSEStreamError: 1
}));
export { $d_Lframework_exts_OnSSEStreamError$$anon$3 as $d_Lframework_exts_OnSSEStreamError$$anon$3 };
/** @constructor */
function $c_Lframework_exts_OnSSEStreamError$$anon$4(_onMessage$2, _onError$2, clearContentsOnError$2) {
  this.Lframework_exts_OnSSEStreamError$$anon$4__f__onMessage$1 = null;
  this.Lframework_exts_OnSSEStreamError$$anon$4__f__onError$1 = null;
  this.Lframework_exts_OnSSEStreamError$$anon$4__f_clearContentsOnError$1 = false;
  this.Lframework_exts_OnSSEStreamError$$anon$4__f__contents = null;
  this.Lframework_exts_OnSSEStreamError$$anon$4__f__onMessage$1 = _onMessage$2;
  this.Lframework_exts_OnSSEStreamError$$anon$4__f__onError$1 = _onError$2;
  this.Lframework_exts_OnSSEStreamError$$anon$4__f_clearContentsOnError$1 = clearContentsOnError$2;
  this.Lframework_exts_OnSSEStreamError$$anon$4__f__contents = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
}
export { $c_Lframework_exts_OnSSEStreamError$$anon$4 as $c_Lframework_exts_OnSSEStreamError$$anon$4 };
$c_Lframework_exts_OnSSEStreamError$$anon$4.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_OnSSEStreamError$$anon$4.prototype.constructor = $c_Lframework_exts_OnSSEStreamError$$anon$4;
/** @constructor */
function $h_Lframework_exts_OnSSEStreamError$$anon$4() {
}
export { $h_Lframework_exts_OnSSEStreamError$$anon$4 as $h_Lframework_exts_OnSSEStreamError$$anon$4 };
$h_Lframework_exts_OnSSEStreamError$$anon$4.prototype = $c_Lframework_exts_OnSSEStreamError$$anon$4.prototype;
$c_Lframework_exts_OnSSEStreamError$$anon$4.prototype.onMessage__O__V = (function(msg) {
  this.Lframework_exts_OnSSEStreamError$$anon$4__f__contents = this.Lframework_exts_OnSSEStreamError$$anon$4__f__onMessage$1.apply__O__O__O(this.Lframework_exts_OnSSEStreamError$$anon$4__f__contents, msg);
});
$c_Lframework_exts_OnSSEStreamError$$anon$4.prototype.onError__Lsttp_model_Uri__Lorg_scalajs_dom_Event__I__O__O__Lframework_sourcecode_DefinedAt__Lframework_exts_OnSSEStreamError$OnErrorAction = (function(uri, error, connectionIndex, securityInput, input, x$6) {
  var result = this.Lframework_exts_OnSSEStreamError$$anon$4__f__onError$1.apply__O__O__O__O__O__O__O(uri, error, connectionIndex, securityInput, input, this.Lframework_exts_OnSSEStreamError$$anon$4__f__contents).apply__O__O(x$6);
  if (this.Lframework_exts_OnSSEStreamError$$anon$4__f_clearContentsOnError$1) {
    this.Lframework_exts_OnSSEStreamError$$anon$4__f__contents = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
  return result;
});
var $d_Lframework_exts_OnSSEStreamError$$anon$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_OnSSEStreamError$$anon$4, "framework.exts.OnSSEStreamError$$anon$4", ({
  Lframework_exts_OnSSEStreamError$$anon$4: 1,
  Lframework_exts_OnSSEStreamError: 1
}));
export { $d_Lframework_exts_OnSSEStreamError$$anon$4 as $d_Lframework_exts_OnSSEStreamError$$anon$4 };
/** @constructor */
function $c_Lframework_exts_SignalExts$package$$anon$1() {
}
export { $c_Lframework_exts_SignalExts$package$$anon$1 as $c_Lframework_exts_SignalExts$package$$anon$1 };
$c_Lframework_exts_SignalExts$package$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_SignalExts$package$$anon$1.prototype.constructor = $c_Lframework_exts_SignalExts$package$$anon$1;
/** @constructor */
function $h_Lframework_exts_SignalExts$package$$anon$1() {
}
export { $h_Lframework_exts_SignalExts$package$$anon$1 as $h_Lframework_exts_SignalExts$package$$anon$1 };
$h_Lframework_exts_SignalExts$package$$anon$1.prototype = $c_Lframework_exts_SignalExts$package$$anon$1.prototype;
var $d_Lframework_exts_SignalExts$package$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_SignalExts$package$$anon$1, "framework.exts.SignalExts$package$$anon$1", ({
  Lframework_exts_SignalExts$package$$anon$1: 1,
  Lframework_exts_SignalExts: 1
}));
export { $d_Lframework_exts_SignalExts$package$$anon$1 as $d_Lframework_exts_SignalExts$package$$anon$1 };
/** @constructor */
function $c_Lframework_exts_SignalExts$package$$anon$2() {
}
export { $c_Lframework_exts_SignalExts$package$$anon$2 as $c_Lframework_exts_SignalExts$package$$anon$2 };
$c_Lframework_exts_SignalExts$package$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_SignalExts$package$$anon$2.prototype.constructor = $c_Lframework_exts_SignalExts$package$$anon$2;
/** @constructor */
function $h_Lframework_exts_SignalExts$package$$anon$2() {
}
export { $h_Lframework_exts_SignalExts$package$$anon$2 as $h_Lframework_exts_SignalExts$package$$anon$2 };
$h_Lframework_exts_SignalExts$package$$anon$2.prototype = $c_Lframework_exts_SignalExts$package$$anon$2.prototype;
var $d_Lframework_exts_SignalExts$package$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_SignalExts$package$$anon$2, "framework.exts.SignalExts$package$$anon$2", ({
  Lframework_exts_SignalExts$package$$anon$2: 1,
  Lframework_exts_SignalOptionExts: 1
}));
export { $d_Lframework_exts_SignalExts$package$$anon$2 as $d_Lframework_exts_SignalExts$package$$anon$2 };
/** @constructor */
function $c_Lframework_prelude_tapir$package$tapirCodecForNothing() {
}
export { $c_Lframework_prelude_tapir$package$tapirCodecForNothing as $c_Lframework_prelude_tapir$package$tapirCodecForNothing };
$c_Lframework_prelude_tapir$package$tapirCodecForNothing.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_prelude_tapir$package$tapirCodecForNothing.prototype.constructor = $c_Lframework_prelude_tapir$package$tapirCodecForNothing;
/** @constructor */
function $h_Lframework_prelude_tapir$package$tapirCodecForNothing() {
}
export { $h_Lframework_prelude_tapir$package$tapirCodecForNothing as $h_Lframework_prelude_tapir$package$tapirCodecForNothing };
$h_Lframework_prelude_tapir$package$tapirCodecForNothing.prototype = $c_Lframework_prelude_tapir$package$tapirCodecForNothing.prototype;
$c_Lframework_prelude_tapir$package$tapirCodecForNothing.prototype.format__Lsttp_tapir_CodecFormat = (function() {
  throw new $c_s_NotImplementedError();
});
$c_Lframework_prelude_tapir$package$tapirCodecForNothing.prototype.rawDecode__O__Lsttp_tapir_DecodeResult = (function(l) {
  throw new $c_s_NotImplementedError();
});
$c_Lframework_prelude_tapir$package$tapirCodecForNothing.prototype.schema__Lsttp_tapir_Schema = (function() {
  return $m_Lframework_prelude_tapir$package$().schemaForNothing__Lsttp_tapir_Schema();
});
$c_Lframework_prelude_tapir$package$tapirCodecForNothing.prototype.encode__O__O = (function(h) {
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_ClassCastException();
});
var $d_Lframework_prelude_tapir$package$tapirCodecForNothing = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_prelude_tapir$package$tapirCodecForNothing, "framework.prelude.tapir$package$tapirCodecForNothing", ({
  Lframework_prelude_tapir$package$tapirCodecForNothing: 1,
  Lsttp_tapir_Codec: 1
}));
export { $d_Lframework_prelude_tapir$package$tapirCodecForNothing as $d_Lframework_prelude_tapir$package$tapirCodecForNothing };
/** @constructor */
function $c_Lframework_utils_JSLogger$$anon$1(s$1, outer) {
  this.Lframework_utils_JSLogger$$anon$1__f_scope = null;
  this.Lframework_utils_JSLogger$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lframework_utils_JSLogger$$anon$1__f_$outer = outer;
  var opt$proxy1 = outer.scope__s_Option();
  matchResult1: {
    var value$1;
    var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    if ((x === opt$proxy1)) {
      var value$1 = s$1;
      break matchResult1;
    }
    if ((opt$proxy1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var value = opt$proxy1.s_Some__f_value;
      var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
      var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["", "/", ""]));
      var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
      var value$1 = $x_1.show$extension__s_StringContext__sci_Seq__T(sc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(value, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString)), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(s$1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))])));
      break matchResult1;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(opt$proxy1);
  }
  this.Lframework_utils_JSLogger$$anon$1__f_scope = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value$1);
}
export { $c_Lframework_utils_JSLogger$$anon$1 as $c_Lframework_utils_JSLogger$$anon$1 };
$c_Lframework_utils_JSLogger$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_JSLogger$$anon$1.prototype.constructor = $c_Lframework_utils_JSLogger$$anon$1;
/** @constructor */
function $h_Lframework_utils_JSLogger$$anon$1() {
}
export { $h_Lframework_utils_JSLogger$$anon$1 as $h_Lframework_utils_JSLogger$$anon$1 };
$h_Lframework_utils_JSLogger$$anon$1.prototype = $c_Lframework_utils_JSLogger$$anon$1.prototype;
$c_Lframework_utils_JSLogger$$anon$1.prototype.scope__s_Option = (function() {
  return this.Lframework_utils_JSLogger$$anon$1__f_scope;
});
$c_Lframework_utils_JSLogger$$anon$1.prototype.atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V = (function(level, scope, msg, definedAt, appName) {
  this.Lframework_utils_JSLogger$$anon$1__f_$outer.atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V(level, scope, msg, definedAt, appName);
});
var $d_Lframework_utils_JSLogger$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_JSLogger$$anon$1, "framework.utils.JSLogger$$anon$1", ({
  Lframework_utils_JSLogger$$anon$1: 1,
  Lframework_utils_JSLogger: 1
}));
export { $d_Lframework_utils_JSLogger$$anon$1 as $d_Lframework_utils_JSLogger$$anon$1 };
/** @constructor */
function $c_Lframework_utils_JSLogger$$anon$2() {
}
export { $c_Lframework_utils_JSLogger$$anon$2 as $c_Lframework_utils_JSLogger$$anon$2 };
$c_Lframework_utils_JSLogger$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_JSLogger$$anon$2.prototype.constructor = $c_Lframework_utils_JSLogger$$anon$2;
/** @constructor */
function $h_Lframework_utils_JSLogger$$anon$2() {
}
export { $h_Lframework_utils_JSLogger$$anon$2 as $h_Lframework_utils_JSLogger$$anon$2 };
$h_Lframework_utils_JSLogger$$anon$2.prototype = $c_Lframework_utils_JSLogger$$anon$2.prototype;
$c_Lframework_utils_JSLogger$$anon$2.prototype.atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V = (function(level, scope, msg, definedAt, appName) {
});
$c_Lframework_utils_JSLogger$$anon$2.prototype.scope__s_Option = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
});
var $d_Lframework_utils_JSLogger$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_JSLogger$$anon$2, "framework.utils.JSLogger$$anon$2", ({
  Lframework_utils_JSLogger$$anon$2: 1,
  Lframework_utils_JSLogger: 1
}));
export { $d_Lframework_utils_JSLogger$$anon$2 as $d_Lframework_utils_JSLogger$$anon$2 };
function $f_Lframework_utils_JSLogger$DefaultJavascriptLogging__atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V($thiz, level, scope, msg, definedAt, appName) {
  matchResult2: {
    var prefix;
    var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    if ((x === scope)) {
      var prefix = appName;
      break matchResult2;
    }
    if ((scope instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var value = scope.s_Some__f_value;
      var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
      var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["", "/", ""]));
      var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
      var prefix = $x_1.show$extension__s_StringContext__sci_Seq__T(sc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(appName, $m_Lframework_prelude_client\uff3flogging$package$JSAppName$().given_Show_Type__Lcats_Show())), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(value, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))])));
      break matchResult2;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(scope);
  }
  matchResult3: {
    var x$3 = $s_Lframework_utils_LogLevel$__Default__Lframework_utils_LogLevel();
    if ((x$3 === level)) {
      var $x_3 = $m_Lframework_prelude_prelude\uff3fclient$package$().console__Lorg_scalajs_dom_Console();
      var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
      var parts$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["[", "] "]));
      var sc$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts$1);
      $x_3.log($x_2.show$extension__s_StringContext__sci_Seq__T(sc$1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(prefix, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))]))), ...$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sjsr_Compat$().toJSVarArgsImpl__sci_Seq__sjs_js_Array(msg));
      var $x_5 = $m_Lframework_prelude_prelude\uff3fclient$package$().console__Lorg_scalajs_dom_Console();
      var $x_4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
      var parts$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["[", "]   @ ", ""]));
      var sc$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts$2);
      $x_5.log($x_4.show$extension__s_StringContext__sci_Seq__T(sc$2, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(prefix, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString)), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(definedAt, $m_Lframework_sourcecode_DefinedAt$().show__Lcats_Show()))]))));
      break matchResult3;
    }
    var x$5 = $s_Lframework_utils_LogLevel$__Debug__Lframework_utils_LogLevel();
    if ((x$5 === level)) {
      var $x_7 = $m_Lframework_prelude_prelude\uff3fclient$package$().console__Lorg_scalajs_dom_Console();
      var $x_6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
      var parts$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["[", "] "]));
      var sc$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts$3);
      $x_7.debug($x_6.show$extension__s_StringContext__sci_Seq__T(sc$3, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(prefix, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))]))), ...$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sjsr_Compat$().toJSVarArgsImpl__sci_Seq__sjs_js_Array(msg));
      var $x_9 = $m_Lframework_prelude_prelude\uff3fclient$package$().console__Lorg_scalajs_dom_Console();
      var $x_8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
      var parts$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["[", "]   @ ", ""]));
      var sc$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts$4);
      $x_9.debug($x_8.show$extension__s_StringContext__sci_Seq__T(sc$4, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(prefix, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString)), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(definedAt, $m_Lframework_sourcecode_DefinedAt$().show__Lcats_Show()))]))));
      break matchResult3;
    }
    var x$7 = $s_Lframework_utils_LogLevel$__Info__Lframework_utils_LogLevel();
    if ((x$7 === level)) {
      var $x_11 = $m_Lframework_prelude_prelude\uff3fclient$package$().console__Lorg_scalajs_dom_Console();
      var $x_10 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
      var parts$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["[", "] "]));
      var sc$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts$5);
      $x_11.info($x_10.show$extension__s_StringContext__sci_Seq__T(sc$5, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(prefix, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))]))), ...$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sjsr_Compat$().toJSVarArgsImpl__sci_Seq__sjs_js_Array(msg));
      var $x_13 = $m_Lframework_prelude_prelude\uff3fclient$package$().console__Lorg_scalajs_dom_Console();
      var $x_12 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
      var parts$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["[", "]   @ ", ""]));
      var sc$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts$6);
      $x_13.info($x_12.show$extension__s_StringContext__sci_Seq__T(sc$6, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(prefix, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString)), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(definedAt, $m_Lframework_sourcecode_DefinedAt$().show__Lcats_Show()))]))));
      break matchResult3;
    }
    var x$9 = $s_Lframework_utils_LogLevel$__Warning__Lframework_utils_LogLevel();
    if ((x$9 === level)) {
      var $x_15 = $m_Lframework_prelude_prelude\uff3fclient$package$().console__Lorg_scalajs_dom_Console();
      var $x_14 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
      var parts$7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["[", "] "]));
      var sc$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts$7);
      $x_15.warn($x_14.show$extension__s_StringContext__sci_Seq__T(sc$7, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(prefix, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))]))), ...$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sjsr_Compat$().toJSVarArgsImpl__sci_Seq__sjs_js_Array(msg));
      var $x_17 = $m_Lframework_prelude_prelude\uff3fclient$package$().console__Lorg_scalajs_dom_Console();
      var $x_16 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
      var parts$8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["[", "]   @ ", ""]));
      var sc$8 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts$8);
      $x_17.warn($x_16.show$extension__s_StringContext__sci_Seq__T(sc$8, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(prefix, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString)), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(definedAt, $m_Lframework_sourcecode_DefinedAt$().show__Lcats_Show()))]))));
      break matchResult3;
    }
    var x$11 = $s_Lframework_utils_LogLevel$__Error__Lframework_utils_LogLevel();
    if ((x$11 === level)) {
      var $x_19 = $m_Lframework_prelude_prelude\uff3fclient$package$().console__Lorg_scalajs_dom_Console();
      var $x_18 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
      var parts$9 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["[", "] "]));
      var sc$9 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts$9);
      $x_19.error($x_18.show$extension__s_StringContext__sci_Seq__T(sc$9, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(prefix, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))]))), ...$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sjsr_Compat$().toJSVarArgsImpl__sci_Seq__sjs_js_Array(msg));
      var $x_21 = $m_Lframework_prelude_prelude\uff3fclient$package$().console__Lorg_scalajs_dom_Console();
      var $x_20 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
      var parts$10 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["[", "]   @ ", ""]));
      var sc$10 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts$10);
      $x_21.error($x_20.show$extension__s_StringContext__sci_Seq__T(sc$10, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(prefix, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString)), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(definedAt, $m_Lframework_sourcecode_DefinedAt$().show__Lcats_Show()))]))));
      break matchResult3;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(level);
  }
}
export { $f_Lframework_utils_JSLogger$DefaultJavascriptLogging__atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V as $f_Lframework_utils_JSLogger$DefaultJavascriptLogging__atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V };
/** @constructor */
function $c_Lframework_utils_MaybeGetHead$$anon$6() {
}
export { $c_Lframework_utils_MaybeGetHead$$anon$6 as $c_Lframework_utils_MaybeGetHead$$anon$6 };
$c_Lframework_utils_MaybeGetHead$$anon$6.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_MaybeGetHead$$anon$6.prototype.constructor = $c_Lframework_utils_MaybeGetHead$$anon$6;
/** @constructor */
function $h_Lframework_utils_MaybeGetHead$$anon$6() {
}
export { $h_Lframework_utils_MaybeGetHead$$anon$6 as $h_Lframework_utils_MaybeGetHead$$anon$6 };
$h_Lframework_utils_MaybeGetHead$$anon$6.prototype = $c_Lframework_utils_MaybeGetHead$$anon$6.prototype;
var $d_Lframework_utils_MaybeGetHead$$anon$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_MaybeGetHead$$anon$6, "framework.utils.MaybeGetHead$$anon$6", ({
  Lframework_utils_MaybeGetHead$$anon$6: 1,
  Lframework_utils_MaybeGetHead: 1
}));
export { $d_Lframework_utils_MaybeGetHead$$anon$6 as $d_Lframework_utils_MaybeGetHead$$anon$6 };
function $f_Lframework_utils_PrettyPrintDuration$Strings$EnglishShort__formatNegativeDuration__T__T($thiz, prettyPrinted) {
  return (prettyPrinted + " ago");
}
export { $f_Lframework_utils_PrettyPrintDuration$Strings$EnglishShort__formatNegativeDuration__T__T as $f_Lframework_utils_PrettyPrintDuration$Strings$EnglishShort__formatNegativeDuration__T__T };
function $f_Lframework_utils_PrettyPrintDuration$Strings$EnglishShort__format__s_concurrent_duration_FiniteDuration__T($thiz, duration) {
  var t = duration.s_concurrent_duration_FiniteDuration__f_length;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var s = ($thiz.Lframework_utils_PrettyPrintDuration$Strings$EnglishShortNoSpaces$__f_framework$utils$PrettyPrintDuration$Strings$EnglishShort$$useSpaces ? " " : "");
  var x8 = duration.s_concurrent_duration_FiniteDuration__f_unit;
  var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
  if ((x === x8)) {
    return ((new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi) + s) + "ns");
  }
  var x$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
  if ((x$3 === x8)) {
    return ((new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi) + s) + "\u03bcs");
  }
  var x$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
  if ((x$5 === x8)) {
    return ((new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi) + s) + "ms");
  }
  var x$7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
  if ((x$7 === x8)) {
    return ((new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi) + s) + "s");
  }
  var x$9 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MINUTES;
  if ((x$9 === x8)) {
    return ((new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi) + s) + "m");
  }
  var x$11 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_HOURS;
  if ((x$11 === x8)) {
    return ((new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi) + s) + "h");
  }
  var x$13 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS;
  if ((x$13 === x8)) {
    return ((new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi) + s) + "d");
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x8);
}
export { $f_Lframework_utils_PrettyPrintDuration$Strings$EnglishShort__format__s_concurrent_duration_FiniteDuration__T as $f_Lframework_utils_PrettyPrintDuration$Strings$EnglishShort__format__s_concurrent_duration_FiniteDuration__T };
function $f_Lframework_utils_PushNotifications$State$Askable__subscribe__s_concurrent_Future($thiz) {
  var $x_1 = $m_Lframework_exts_FutureExts$package$();
  var p = $thiz.Lframework_utils_PushNotifications$State$Prompt__f_pushManager.subscribe($thiz.Lframework_utils_PushNotifications$State$Prompt__f_options);
  var a$proxy1 = $x_1.attempt__s_concurrent_Future__s_concurrent_Future($m_sjs_js_Thenable$ThenableOps$().toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p));
  a$proxy1.foreach__F1__s_concurrent_ExecutionContext__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1) => {
    matchResult4: {
      if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
        var subscription = x$1.s_util_Right__f_value;
        var $x_2 = $thiz.Lframework_utils_PushNotifications$State$Prompt__f_sink;
        var pushManager = $thiz.Lframework_utils_PushNotifications$State$Prompt__f_pushManager;
        var options = $thiz.Lframework_utils_PushNotifications$State$Prompt__f_options;
        var subscription$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(subscription);
        var sink = $thiz.Lframework_utils_PushNotifications$State$Prompt__f_sink;
        $x_2.onNext__O__V(new $c_Lframework_utils_PushNotifications$State$Granted(pushManager, options, subscription$1, sink));
        break matchResult4;
      }
      if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
        $thiz.Lframework_utils_PushNotifications$State$Prompt__f_sink.onNext__O__V($m_Lframework_utils_PushNotifications$State$Denied$());
        break matchResult4;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    }
  })), $m_Lframework_prelude_prelude\uff3fclient$package$().executionContext__s_concurrent_ExecutionContext());
  return a$proxy1;
}
export { $f_Lframework_utils_PushNotifications$State$Askable__subscribe__s_concurrent_Future as $f_Lframework_utils_PushNotifications$State$Askable__subscribe__s_concurrent_Future };
/** @constructor */
function $c_Lframework_utils_SSEFallbackCallbacks$$anon$2(persistedVar$2, recoveryTimeout$2, logger$2) {
  this.Lframework_utils_SSEFallbackCallbacks$$anon$2__f_persistedVar$1 = null;
  this.Lframework_utils_SSEFallbackCallbacks$$anon$2__f_recoveryTimeout$1 = null;
  this.Lframework_utils_SSEFallbackCallbacks$$anon$2__f_logger$1 = null;
  this.Lframework_utils_SSEFallbackCallbacks$$anon$2__f_persistedVar$1 = persistedVar$2;
  this.Lframework_utils_SSEFallbackCallbacks$$anon$2__f_recoveryTimeout$1 = recoveryTimeout$2;
  this.Lframework_utils_SSEFallbackCallbacks$$anon$2__f_logger$1 = logger$2;
}
export { $c_Lframework_utils_SSEFallbackCallbacks$$anon$2 as $c_Lframework_utils_SSEFallbackCallbacks$$anon$2 };
$c_Lframework_utils_SSEFallbackCallbacks$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_SSEFallbackCallbacks$$anon$2.prototype.constructor = $c_Lframework_utils_SSEFallbackCallbacks$$anon$2;
/** @constructor */
function $h_Lframework_utils_SSEFallbackCallbacks$$anon$2() {
}
export { $h_Lframework_utils_SSEFallbackCallbacks$$anon$2 as $h_Lframework_utils_SSEFallbackCallbacks$$anon$2 };
$h_Lframework_utils_SSEFallbackCallbacks$$anon$2.prototype = $c_Lframework_utils_SSEFallbackCallbacks$$anon$2.prototype;
$c_Lframework_utils_SSEFallbackCallbacks$$anon$2.prototype.onFallbackToWebSocket__V = (function() {
  var this$1 = this.Lframework_utils_SSEFallbackCallbacks$$anon$2__f_persistedVar$1.Lframework_utils_PersistedVar__f_underlying;
  var this$2 = this$1.signal__Lcom_raquo_airstream_state_StrictSignal();
  var x28 = this$2.tryNow__s_util_Try().get__O();
  if ((x28 instanceof $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback)) {
    var tryAgainAt = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_data_FrameworkDateTime$().$plus$extension__Ljava_time_LocalDateTime__s_concurrent_duration_FiniteDuration__Ljava_time_LocalDateTime($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_data_FrameworkDateTime$().now__Ljava_time_LocalDateTime(), this.Lframework_utils_SSEFallbackCallbacks$$anon$2__f_recoveryTimeout$1);
    var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
    var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["SSE failed, falling back to WebSocket. Will try SSE again at ", ""]));
    var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
    var info$1 = $x_2.genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([$x_1.show$extension__s_StringContext__sci_Seq__T(sc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lframework_data_FrameworkDateTime(tryAgainAt), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_data_FrameworkDateTime$().show__Lcats_Show()))])))]));
    var this$11 = this.Lframework_utils_SSEFallbackCallbacks$$anon$2__f_logger$1;
    var file = new $c_Lsourcecode_File("/home/arturaz/work/rapix/framework/client/src/framework/utils/ToSSEStreamBuilder.scala");
    var line = new $c_Lsourcecode_Line(195);
    var name = new $c_Lsourcecode_FullName("framework.utils.SSEFallbackCallbacks.$anon.onFallbackToWebSocket");
    var definedAt = new $c_Lframework_sourcecode_DefinedAt(file, line, name);
    var this$10 = $m_Lframework_prelude_client\uff3flogging$package$JSAppName$();
    var appName = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Newtype$WithoutValidation__apply__O__O(this$10, "app");
    var level = $s_Lframework_utils_LogLevel$__Info__Lframework_utils_LogLevel();
    this$11.atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V(level, this$11.scope__s_Option(), info$1, definedAt, appName);
    var $x_3 = this.Lframework_utils_SSEFallbackCallbacks$$anon$2__f_persistedVar$1;
    var value = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lframework_data_FrameworkDateTime(tryAgainAt);
    var trySSEAgainAt = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
    $x_3.setAndPersist__O__V(new $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback(trySSEAgainAt));
    return (void 0);
  }
  matchAlts1: {
    matchAlts2: {
      var x = $s_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__ServerSentEvents__Lframework_data_EndpointSSEWithWS$ClientConnectionMode();
      if (((x === null) ? (x28 === null) : x.equals__O__Z(x28))) {
        break matchAlts2;
      }
      var x$3 = $s_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__WebSocket__Lframework_data_EndpointSSEWithWS$ClientConnectionMode();
      if (((x$3 === null) ? (x28 === null) : x$3.equals__O__Z(x28))) {
        break matchAlts2;
      }
      break matchAlts1;
    }
    return (void 0);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x28);
});
$c_Lframework_utils_SSEFallbackCallbacks$$anon$2.prototype.onSSESuccess__V = (function() {
  var this$1 = this.Lframework_utils_SSEFallbackCallbacks$$anon$2__f_persistedVar$1.Lframework_utils_PersistedVar__f_underlying;
  var this$2 = this$1.signal__Lcom_raquo_airstream_state_StrictSignal();
  var x32 = this$2.tryNow__s_util_Try().get__O();
  if ((x32 instanceof $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback)) {
    var x38 = x32.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback__f_trySSEAgainAt;
    if ((x38 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var info$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(["SSE connection succeeded, clearing forced WebSocket mode"]));
      var this$7 = this.Lframework_utils_SSEFallbackCallbacks$$anon$2__f_logger$1;
      var file = new $c_Lsourcecode_File("/home/arturaz/work/rapix/framework/client/src/framework/utils/ToSSEStreamBuilder.scala");
      var line = new $c_Lsourcecode_Line(210);
      var name = new $c_Lsourcecode_FullName("framework.utils.SSEFallbackCallbacks.$anon.onSSESuccess");
      var definedAt = new $c_Lframework_sourcecode_DefinedAt(file, line, name);
      var this$6 = $m_Lframework_prelude_client\uff3flogging$package$JSAppName$();
      var appName = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Newtype$WithoutValidation__apply__O__O(this$6, "app");
      var level = $s_Lframework_utils_LogLevel$__Info__Lframework_utils_LogLevel();
      this$7.atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V(level, this$7.scope__s_Option(), info$2, definedAt, appName);
      var $x_1 = this.Lframework_utils_SSEFallbackCallbacks$$anon$2__f_persistedVar$1;
      var trySSEAgainAt = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      $x_1.setAndPersist__O__V(new $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback(trySSEAgainAt));
      return (void 0);
    }
  }
  matchAlts3: {
    matchAlts4: {
      if ((x32 instanceof $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback)) {
        var x35 = x32.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback__f_trySSEAgainAt;
        var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        if ((x === x35)) {
          break matchAlts4;
        }
      }
      var x$3 = $s_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__ServerSentEvents__Lframework_data_EndpointSSEWithWS$ClientConnectionMode();
      if (((x$3 === null) ? (x32 === null) : x$3.equals__O__Z(x32))) {
        break matchAlts4;
      }
      var x$5 = $s_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__WebSocket__Lframework_data_EndpointSSEWithWS$ClientConnectionMode();
      if (((x$5 === null) ? (x32 === null) : x$5.equals__O__Z(x32))) {
        break matchAlts4;
      }
      break matchAlts3;
    }
    return (void 0);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x32);
});
var $d_Lframework_utils_SSEFallbackCallbacks$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_SSEFallbackCallbacks$$anon$2, "framework.utils.SSEFallbackCallbacks$$anon$2", ({
  Lframework_utils_SSEFallbackCallbacks$$anon$2: 1,
  Lframework_utils_SSEFallbackCallbacks: 1
}));
export { $d_Lframework_utils_SSEFallbackCallbacks$$anon$2 as $d_Lframework_utils_SSEFallbackCallbacks$$anon$2 };
function $p_Lframework_utils_ToSSEStreamBuilder$$anon$4__probeConnectionMode__F0__Z__Lframework_data_AppBaseUri__Lcats_effect_IO($thiz, now, withCredentials, baseUri) {
  var ev$1 = now.apply__O();
  var timestamp = ((ev$1 === null) ? null : ev$1.Lframework_data_FrameworkDateTime__f_ldt);
  matchResult10: {
    var \u03b42$;
    var x42 = $m_Lframework_api_FrameworkHeaders$X$minusRequest$minusStarted$minusAt$().apply__Ljava_time_LocalDateTime__T2(timestamp);
    if ((x42 !== null)) {
      var \u03b42$ = x42;
      break matchResult10;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x42);
  }
  var tracingName = \u03b42$._1__O();
  var tracingValue = \u03b42$._2__O();
  var this$1 = $m_Lframework_exts_ClientEndpointExts$package$().toReq__Lsttp_tapir_Endpoint__O__Ljava_time_LocalDateTime__Lframework_data_AppBaseUri__Lsttp_client3_RequestT($thiz.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_connectionTryout$1.sseConnectionTryout__Lframework_data_EndpointSSEWithWS().Lframework_data_EndpointSSEWithWS__f_sse, (void 0), timestamp, baseUri).Lsttp_client3_RequestT__f_uri.addParam__T__T__Lsttp_model_Uri(tracingName, tracingValue);
  var sseUri = this$1.toStringSafe__sci_Set__T($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Set$EmptySet$());
  var this$3 = $m_Lframework_exts_ClientEndpointExts$package$().toReq__Lsttp_tapir_Endpoint__O__Ljava_time_LocalDateTime__Lframework_data_AppBaseUri__Lsttp_client3_RequestT($thiz.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_connectionTryout$1.sseConnectionTryout__Lframework_data_EndpointSSEWithWS().Lframework_data_EndpointSSEWithWS__f_webSocketAsSSE, (void 0), timestamp, baseUri).Lsttp_client3_RequestT__f_uri.addParam__T__T__Lsttp_model_Uri(tracingName, tracingValue);
  var wsUri = this$3.toStringSafe__sci_Set__T($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Set$EmptySet$());
  var fields = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T2.getArrayOf().constr)([$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), "withCredentials", withCredentials)]));
  var sseOptions = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var this$14 = $m_Lframework_exts_ObservableExts$package$().frameworkObservableExts__Lframework_exts_ObservableExts();
  var this$13 = $m_Lframework_exts_EventStreamExts$package$().fromDomEventSourceEither__Lcom_raquo_airstream_core_EventStream$__F0__Lcom_raquo_airstream_core_EventStream($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_EventStream$(), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => new EventSource(sseUri, sseOptions))));
  var project = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$5) => {
    var target = _$5.toOption__s_Option();
    var tc = $m_Lcats_instances_package$option$().Lcats_instances_package$option$__f_catsStdInstancesForOption;
    var this$12 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
    var b = $s_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__ServerSentEvents__Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode();
    return this$12.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.as__O__O__O(this$12.Lcats_Functor$ToFunctorOps$$anon$5__f_self, b);
  }));
  var observable = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapStream(this$13, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var sseOutcomeIO = $f_Lframework_exts_ObservableExts__toIO__Lcom_raquo_airstream_core_Observable__Lcats_effect_IO(this$14, observable);
  var this$21 = $m_Lframework_exts_ObservableExts$package$().frameworkObservableExts__Lframework_exts_ObservableExts();
  var this$20 = $m_Lframework_exts_EventStreamExts$package$().fromWebSocketEither__Lcom_raquo_airstream_core_EventStream$__F0__Lcom_raquo_airstream_core_EventStream($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_EventStream$(), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => new WebSocket(wsUri))));
  var project$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$6) => {
    var target$1 = _$6.toOption__s_Option();
    var tc$1 = $m_Lcats_instances_package$option$().Lcats_instances_package$option$__f_catsStdInstancesForOption;
    var this$19 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, tc$1);
    var b$1 = $s_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__WebSocket__Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode();
    return this$19.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.as__O__O__O(this$19.Lcats_Functor$ToFunctorOps$$anon$5__f_self, b$1);
  }));
  var observable$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapStream(this$20, project$1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var wsOutcomeIO = $f_Lframework_exts_ObservableExts__toIO__Lcom_raquo_airstream_core_Observable__Lcats_effect_IO(this$21, observable$1).flatMap__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1) => {
    if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      return $m_Lframework_exts_AsyncExts$package$().takeAtLeast__O__s_concurrent_duration_FiniteDuration__Lcats_effect_kernel_Async__Lcats_NonEmptyParallel__O(($m_Lcats_effect_IO$(), new $c_Lcats_effect_IO$Pure(x$1)), $thiz.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_minTimeWSProbeTakes$1, $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO, $m_Lcats_effect_IO$().Lcats_effect_IO$__f__parallelForIO);
    }
    var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    if ((x === x$1)) {
      $m_Lcats_effect_IO$();
      var value = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      return new $c_Lcats_effect_IO$Pure(value);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  })));
  var $x_6 = $m_Lframework_exts_IOExts$package$().raceSome__Lcats_effect_IO$__Lcats_effect_IO__Lcats_effect_IO__Lcats_effect_IO($m_Lcats_effect_IO$(), sseOutcomeIO, wsOutcomeIO).flatTap__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1$2) => {
    if ((x$1$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var mode = x$1$2.s_Some__f_value;
      var x48 = $thiz.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_logLevel$1;
      var x$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      if ((x$2 === x48)) {
        return $m_Lcats_effect_IO$().Lcats_effect_IO$__f__unit;
      }
      if ((x48 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
        var level = x48.s_Some__f_value;
        var this$42 = $m_Lcats_effect_IO$();
        var thunk = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
          var $x_10 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
          var $x_9 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
          var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["SSE/WS tryout succeeded for ", " for ", ""]));
          var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
          var msg$1 = $x_10.genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([$x_9.show$extension__s_StringContext__sci_Seq__T(sc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(mode, $m_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$().derived$Show__Lcats_Show())), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T($thiz.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_framework$utils$ToSSEStreamBuilder$$anon$4$$e$1.showShort__T(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))])))]));
          var this$41 = $m_Lframework_prelude_log$();
          var file = new $c_Lsourcecode_File("/home/arturaz/work/rapix/framework/client/src/framework/utils/ToSSEStreamBuilder.scala");
          var line = new $c_Lsourcecode_Line(289);
          var name = new $c_Lsourcecode_FullName("framework.utils.ToSSEStreamBuilder.$anon.io");
          var definedAt = new $c_Lframework_sourcecode_DefinedAt(file, line, name);
          var this$40 = $m_Lframework_prelude_client\uff3flogging$package$JSAppName$();
          var appName = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Newtype$WithoutValidation__apply__O__O(this$40, "app");
          var scope = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
          $f_Lframework_utils_JSLogger$DefaultJavascriptLogging__atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V(this$41, level, scope, msg$1, definedAt, appName);
        }));
        return this$42.delay__F0__Lcats_effect_IO(thunk);
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x48);
    }
    var x$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    if ((x$3 === x$1$2)) {
      return $m_Lcats_effect_IO$().Lcats_effect_IO$__f__unit;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1$2);
  }))).flatMap__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1$3) => {
    var x$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    if ((x$4 === x$1$3)) {
      var this$54 = $m_Lcats_effect_IO$();
      var thunk$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
        var $x_8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
        var $x_7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
        var parts$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["SSE/WS tryout failed for both transports, defaulting to SSE for ", ""]));
        var sc$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts$1);
        var warning$1 = $x_8.genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([$x_7.show$extension__s_StringContext__sci_Seq__T(sc$1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T($thiz.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_framework$utils$ToSSEStreamBuilder$$anon$4$$e$1.showShort__T(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))])))]));
        var this$53 = $m_Lframework_prelude_log$();
        var file$1 = new $c_Lsourcecode_File("/home/arturaz/work/rapix/framework/client/src/framework/utils/ToSSEStreamBuilder.scala");
        var line$1 = new $c_Lsourcecode_Line(296);
        var name$1 = new $c_Lsourcecode_FullName("framework.utils.ToSSEStreamBuilder.$anon.io");
        var definedAt$1 = new $c_Lframework_sourcecode_DefinedAt(file$1, line$1, name$1);
        var this$52 = $m_Lframework_prelude_client\uff3flogging$package$JSAppName$();
        var appName$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Newtype$WithoutValidation__apply__O__O(this$52, "app");
        var level$1 = $s_Lframework_utils_LogLevel$__Warning__Lframework_utils_LogLevel();
        var scope$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $f_Lframework_utils_JSLogger$DefaultJavascriptLogging__atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V(this$53, level$1, scope$1, warning$1, definedAt$1, appName$1);
        return $s_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__ServerSentEvents__Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode();
      }));
      return this$54.delay__F0__Lcats_effect_IO(thunk$1);
    }
    if ((x$1$3 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var mode$1 = x$1$3.s_Some__f_value;
      $m_Lcats_effect_IO$();
      return new $c_Lcats_effect_IO$Pure(mode$1);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1$3);
  })));
  var $x_5 = $thiz.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_probeTimeout$1;
  var this$72 = $m_Lcats_effect_IO$();
  var thunk$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
    var $x_4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
    var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
    var parts$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["SSE/WS tryout timed out in ", ", defaulting to SSE for ", ""]));
    var sc$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts$2);
    var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$();
    var duration$1 = $thiz.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_probeTimeout$1;
    var strings = $m_Lframework_utils_PrettyPrintDuration$Strings$EnglishShortNoSpaces$();
    var warning$2 = $x_4.genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([$x_3.show$extension__s_StringContext__sci_Seq__T(sc$2, $x_2.genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($x_1.mat__O__Lcats_Show$ContravariantShow__T($m_Lframework_utils_PrettyPrintDuration$().prettyPrint__s_concurrent_duration_Duration__I__ju_concurrent_TimeUnit__Lframework_utils_PrettyPrintDuration$Strings__T(duration$1, ($m_Lframework_utils_PrettyPrintDuration$(), 2147483647), ($m_Lframework_utils_PrettyPrintDuration$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS), strings), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString)), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T($thiz.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_framework$utils$ToSSEStreamBuilder$$anon$4$$e$1.showShort__T(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))])))]));
    var this$71 = $m_Lframework_prelude_log$();
    var file$2 = new $c_Lsourcecode_File("/home/arturaz/work/rapix/framework/client/src/framework/utils/ToSSEStreamBuilder.scala");
    var line$2 = new $c_Lsourcecode_Line(307);
    var name$2 = new $c_Lsourcecode_FullName("framework.utils.ToSSEStreamBuilder.$anon.io");
    var definedAt$2 = new $c_Lframework_sourcecode_DefinedAt(file$2, line$2, name$2);
    var this$70 = $m_Lframework_prelude_client\uff3flogging$package$JSAppName$();
    var appName$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Newtype$WithoutValidation__apply__O__O(this$70, "app");
    var level$2 = $s_Lframework_utils_LogLevel$__Warning__Lframework_utils_LogLevel();
    var scope$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $f_Lframework_utils_JSLogger$DefaultJavascriptLogging__atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V(this$71, level$2, scope$2, warning$2, definedAt$2, appName$2);
    return $s_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__ServerSentEvents__Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode();
  }));
  var io = $x_6.timeoutTo__s_concurrent_duration_Duration__Lcats_effect_IO__Lcats_effect_IO($x_5, this$72.delay__F0__Lcats_effect_IO(thunk$2));
  return io;
}
export { $p_Lframework_utils_ToSSEStreamBuilder$$anon$4__probeConnectionMode__F0__Z__Lframework_data_AppBaseUri__Lcats_effect_IO as $p_Lframework_utils_ToSSEStreamBuilder$$anon$4__probeConnectionMode__F0__Z__Lframework_data_AppBaseUri__Lcats_effect_IO };
function $p_Lframework_utils_ToSSEStreamBuilder$$anon$4__sseStreamWithFallback__O__O__F0__s_Option__Z__Lframework_data_AppBaseUri__Lframework_sourcecode_DefinedAt__Lcom_raquo_airstream_core_EventStream($thiz, securityParams, params, now, reconnectOnError, withCredentials, baseUri, definedAt) {
  var sseReconnectOnError = new $c_Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5(reconnectOnError, now, withCredentials, baseUri, $thiz);
  var e = $thiz.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_framework$utils$ToSSEStreamBuilder$$anon$4$$e$1.Lframework_data_EndpointSSEWithWS__f_sse;
  return new $c_Lframework_exts_ClientEndpointExts$package$$anon$5(e).raw__O__O__F0__s_Option__Z__Lframework_data_AppBaseUri__Lframework_sourcecode_DefinedAt__Lcom_raquo_airstream_core_EventStream(securityParams, params, now, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(sseReconnectOnError), withCredentials, baseUri, definedAt);
}
export { $p_Lframework_utils_ToSSEStreamBuilder$$anon$4__sseStreamWithFallback__O__O__F0__s_Option__Z__Lframework_data_AppBaseUri__Lframework_sourcecode_DefinedAt__Lcom_raquo_airstream_core_EventStream as $p_Lframework_utils_ToSSEStreamBuilder$$anon$4__sseStreamWithFallback__O__O__F0__s_Option__Z__Lframework_data_AppBaseUri__Lframework_sourcecode_DefinedAt__Lcom_raquo_airstream_core_EventStream };
/** @constructor */
function $c_Lframework_utils_ToSSEStreamBuilder$$anon$4(connectionTryout$2, minTimeWSProbeTakes$2, logLevel$2, e$2, probeTimeout$2, callbacks$2, waitFor$2, maxSseFailuresBeforeFallback$2) {
  this.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_connectionTryout$1 = null;
  this.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_minTimeWSProbeTakes$1 = null;
  this.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_logLevel$1 = null;
  this.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_framework$utils$ToSSEStreamBuilder$$anon$4$$e$1 = null;
  this.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_probeTimeout$1 = null;
  this.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_framework$utils$ToSSEStreamBuilder$$anon$4$$callbacks$1 = null;
  this.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_framework$utils$ToSSEStreamBuilder$$anon$4$$waitFor$1 = null;
  this.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_framework$utils$ToSSEStreamBuilder$$anon$4$$maxSseFailuresBeforeFallback$1 = 0;
  this.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_framework$utils$ToSSEStreamBuilder$$anon$4$$sseSuccessNotified = false;
  this.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_connectionTryout$1 = connectionTryout$2;
  this.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_minTimeWSProbeTakes$1 = minTimeWSProbeTakes$2;
  this.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_logLevel$1 = logLevel$2;
  this.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_framework$utils$ToSSEStreamBuilder$$anon$4$$e$1 = e$2;
  this.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_probeTimeout$1 = probeTimeout$2;
  this.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_framework$utils$ToSSEStreamBuilder$$anon$4$$callbacks$1 = callbacks$2;
  this.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_framework$utils$ToSSEStreamBuilder$$anon$4$$waitFor$1 = waitFor$2;
  this.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_framework$utils$ToSSEStreamBuilder$$anon$4$$maxSseFailuresBeforeFallback$1 = maxSseFailuresBeforeFallback$2;
  this.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_framework$utils$ToSSEStreamBuilder$$anon$4$$sseSuccessNotified = false;
}
export { $c_Lframework_utils_ToSSEStreamBuilder$$anon$4 as $c_Lframework_utils_ToSSEStreamBuilder$$anon$4 };
$c_Lframework_utils_ToSSEStreamBuilder$$anon$4.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_ToSSEStreamBuilder$$anon$4.prototype.constructor = $c_Lframework_utils_ToSSEStreamBuilder$$anon$4;
/** @constructor */
function $h_Lframework_utils_ToSSEStreamBuilder$$anon$4() {
}
export { $h_Lframework_utils_ToSSEStreamBuilder$$anon$4 as $h_Lframework_utils_ToSSEStreamBuilder$$anon$4 };
$h_Lframework_utils_ToSSEStreamBuilder$$anon$4.prototype = $c_Lframework_utils_ToSSEStreamBuilder$$anon$4.prototype;
$c_Lframework_utils_ToSSEStreamBuilder$$anon$4.prototype.raw__O__O__F0__s_Option__Z__Lframework_data_AppBaseUri__Lframework_sourcecode_DefinedAt__Lcom_raquo_airstream_core_EventStream = (function(securityParams, params, now, reconnectOnError, withCredentials, baseUri, definedAt) {
  this.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_framework$utils$ToSSEStreamBuilder$$anon$4$$sseSuccessNotified = false;
  var this$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_EventStream$().fromFuture__F0__Z__s_concurrent_ExecutionContext__Lcom_raquo_airstream_core_EventStream(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => $p_Lframework_utils_ToSSEStreamBuilder$$anon$4__probeConnectionMode__F0__Z__Lframework_data_AppBaseUri__Lcats_effect_IO(this, now, withCredentials, baseUri).unsafeToFuture__Lcats_effect_unsafe_IORuntime__s_concurrent_Future($m_Lframework_prelude_prelude\uff3fclient$package$().ioRuntime__Lcats_effect_unsafe_IORuntime()))), ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_EventStream$(), false), $m_Lframework_prelude_prelude\uff3fclient$package$().executionContext__s_concurrent_ExecutionContext());
  var project = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1) => {
    var x = $s_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__ServerSentEvents__Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode();
    if (((x === null) ? (x$1 === null) : (x === x$1))) {
      this.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_framework$utils$ToSSEStreamBuilder$$anon$4$$callbacks$1.onSSESuccess__V();
      return $p_Lframework_utils_ToSSEStreamBuilder$$anon$4__sseStreamWithFallback__O__O__F0__s_Option__Z__Lframework_data_AppBaseUri__Lframework_sourcecode_DefinedAt__Lcom_raquo_airstream_core_EventStream(this, securityParams, params, now, reconnectOnError, withCredentials, baseUri, definedAt);
    }
    var x$3 = $s_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__WebSocket__Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode();
    if (((x$3 === null) ? (x$1 === null) : (x$3 === x$1))) {
      this.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_framework$utils$ToSSEStreamBuilder$$anon$4$$callbacks$1.onFallbackToWebSocket__V();
      var e = this.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_framework$utils$ToSSEStreamBuilder$$anon$4$$e$1.Lframework_data_EndpointSSEWithWS__f_webSocketAsSSE;
      return new $c_Lframework_exts_ClientEndpointExts$package$$anon$6(e).raw__O__O__F0__s_Option__Z__Lframework_data_AppBaseUri__Lframework_sourcecode_DefinedAt__Lcom_raquo_airstream_core_EventStream(securityParams, params, now, reconnectOnError, withCredentials, baseUri, definedAt);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  }));
  var strategy = $m_Lcom_raquo_airstream_core_Observable$().Lcom_raquo_airstream_core_Observable$__f_switchStreamStrategy;
  return strategy.flatten__Lcom_raquo_airstream_core_Observable__Lcom_raquo_airstream_core_Observable(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapStream(this$5, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()));
});
var $d_Lframework_utils_ToSSEStreamBuilder$$anon$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_ToSSEStreamBuilder$$anon$4, "framework.utils.ToSSEStreamBuilder$$anon$4", ({
  Lframework_utils_ToSSEStreamBuilder$$anon$4: 1,
  Lframework_utils_ToSSEStreamBuilder: 1
}));
export { $d_Lframework_utils_ToSSEStreamBuilder$$anon$4 as $d_Lframework_utils_ToSSEStreamBuilder$$anon$4 };
function $p_Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5__delayedWsStream$1__s_concurrent_duration_FiniteDuration__O__O__Lframework_sourcecode_DefinedAt__Lcom_raquo_airstream_core_EventStream($thiz, delay$1, securityParams$2, params$2, x$6$1) {
  $thiz.Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5__f_$outer.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_framework$utils$ToSSEStreamBuilder$$anon$4$$callbacks$1.onFallbackToWebSocket__V();
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_EventStream$();
  var ms = $m_Lframework_exts_LongExts$package$().toIntClamped__J__I(delay$1.s_concurrent_duration_FiniteDuration__f_unit.toMillis__J__J(delay$1.s_concurrent_duration_FiniteDuration__f_length));
  var this$5 = this$2.delay__I__O__Z__Lcom_raquo_airstream_core_EventStream(ms, (void 0), false);
  var project = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$8) => {
    var e = $thiz.Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5__f_$outer.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_framework$utils$ToSSEStreamBuilder$$anon$4$$e$1.Lframework_data_EndpointSSEWithWS__f_webSocketAsSSE;
    return new $c_Lframework_exts_ClientEndpointExts$package$$anon$6(e).raw__O__O__F0__s_Option__Z__Lframework_data_AppBaseUri__Lframework_sourcecode_DefinedAt__Lcom_raquo_airstream_core_EventStream(securityParams$2, params$2, $thiz.Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5__f_now$1, $thiz.Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5__f_reconnectOnError$2, $thiz.Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5__f_withCredentials$1, $thiz.Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5__f_baseUri$1, x$6$1);
  }));
  var strategy = $m_Lcom_raquo_airstream_core_Observable$().Lcom_raquo_airstream_core_Observable$__f_switchStreamStrategy;
  return strategy.flatten__Lcom_raquo_airstream_core_Observable__Lcom_raquo_airstream_core_Observable(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapStream(this$5, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()));
}
export { $p_Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5__delayedWsStream$1__s_concurrent_duration_FiniteDuration__O__O__Lframework_sourcecode_DefinedAt__Lcom_raquo_airstream_core_EventStream as $p_Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5__delayedWsStream$1__s_concurrent_duration_FiniteDuration__O__O__Lframework_sourcecode_DefinedAt__Lcom_raquo_airstream_core_EventStream };
/** @constructor */
function $c_Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5(reconnectOnError$4, now$4, withCredentials$4, baseUri$4, outer) {
  this.Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5__f_reconnectOnError$2 = null;
  this.Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5__f_now$1 = null;
  this.Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5__f_withCredentials$1 = false;
  this.Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5__f_baseUri$1 = null;
  this.Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5__f_$outer = null;
  this.Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5__f_reconnectOnError$2 = reconnectOnError$4;
  this.Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5__f_now$1 = now$4;
  this.Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5__f_withCredentials$1 = withCredentials$4;
  this.Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5__f_baseUri$1 = baseUri$4;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5__f_$outer = outer;
}
export { $c_Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5 as $c_Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5 };
$c_Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5.prototype.constructor = $c_Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5;
/** @constructor */
function $h_Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5() {
}
export { $h_Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5 as $h_Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5 };
$h_Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5.prototype = $c_Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5.prototype;
$c_Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5.prototype.onMessage__Lorg_scalajs_dom_MessageEvent__V = (function(msg) {
  if ((!this.Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5__f_$outer.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_framework$utils$ToSSEStreamBuilder$$anon$4$$sseSuccessNotified)) {
    this.Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5__f_$outer.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_framework$utils$ToSSEStreamBuilder$$anon$4$$sseSuccessNotified = true;
    this.Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5__f_$outer.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_framework$utils$ToSSEStreamBuilder$$anon$4$$callbacks$1.onSSESuccess__V();
  }
  var this$1 = this.Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5__f_reconnectOnError$2;
  if ((!this$1.isEmpty__Z())) {
    var x0 = this$1.get__O();
    x0.onMessage__O__V(msg);
  }
});
$c_Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5.prototype.onError__Lsttp_model_Uri__Lorg_scalajs_dom_Event__I__O__O__Lframework_sourcecode_DefinedAt__Lframework_exts_OnSSEStreamError$OnErrorAction = (function(uri, error, connectionIndex, securityParams, params, x$6) {
  var failuresSoFar = ((1 + connectionIndex) | 0);
  var delay = this.Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5__f_$outer.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_framework$utils$ToSSEStreamBuilder$$anon$4$$waitFor$1.apply__O__O(connectionIndex);
  var x57 = this.Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5__f_reconnectOnError$2;
  var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  if ((x === x57)) {
    var $x_4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
    var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
    var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["sseWithWebSocketFallback: reconnectOnError is None, reconnecting with WS in ", ""]));
    var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
    var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$();
    var strings = $m_Lframework_utils_PrettyPrintDuration$Strings$EnglishShortNoSpaces$();
    var info$3 = $x_4.genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([$x_3.show$extension__s_StringContext__sci_Seq__T(sc, $x_2.genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($x_1.mat__O__Lcats_Show$ContravariantShow__T($m_Lframework_utils_PrettyPrintDuration$().prettyPrint__s_concurrent_duration_Duration__I__ju_concurrent_TimeUnit__Lframework_utils_PrettyPrintDuration$Strings__T(delay, ($m_Lframework_utils_PrettyPrintDuration$(), 2147483647), ($m_Lframework_utils_PrettyPrintDuration$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS), strings), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))])))]));
    var this$11 = $m_Lframework_prelude_log$();
    var this$10 = $m_Lframework_prelude_client\uff3flogging$package$JSAppName$();
    var appName = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Newtype$WithoutValidation__apply__O__O(this$10, "app");
    var level = $s_Lframework_utils_LogLevel$__Info__Lframework_utils_LogLevel();
    var scope = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $f_Lframework_utils_JSLogger$DefaultJavascriptLogging__atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V(this$11, level, scope, info$3, x$6, appName);
    var stream = $p_Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5__delayedWsStream$1__s_concurrent_duration_FiniteDuration__O__O__Lframework_sourcecode_DefinedAt__Lcom_raquo_airstream_core_EventStream(this, delay, securityParams, params, x$6);
    return new $c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith(stream);
  }
  if ((x57 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
    if ((failuresSoFar >= this.Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5__f_$outer.Lframework_utils_ToSSEStreamBuilder$$anon$4__f_framework$utils$ToSSEStreamBuilder$$anon$4$$maxSseFailuresBeforeFallback$1)) {
      var $x_10 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
      var $x_9 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
      var parts$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["sseWithWebSocketFallback: failure at connection index ", ", "]));
      var sc$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts$1);
      var $x_8 = $x_9.show$extension__s_StringContext__sci_Seq__T(sc$1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(connectionIndex, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$int$().Lcats_instances_package$int$__f_catsStdShowForInt))])));
      var $x_7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
      var parts$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["reconnecting with WS in ", ""]));
      var sc$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts$2);
      var $x_6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
      var $x_5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$();
      var strings$1 = $m_Lframework_utils_PrettyPrintDuration$Strings$EnglishShortNoSpaces$();
      var info$4 = $x_10.genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([(("" + $x_8) + $x_7.show$extension__s_StringContext__sci_Seq__T(sc$2, $x_6.genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($x_5.mat__O__Lcats_Show$ContravariantShow__T($m_Lframework_utils_PrettyPrintDuration$().prettyPrint__s_concurrent_duration_Duration__I__ju_concurrent_TimeUnit__Lframework_utils_PrettyPrintDuration$Strings__T(delay, ($m_Lframework_utils_PrettyPrintDuration$(), 2147483647), ($m_Lframework_utils_PrettyPrintDuration$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS), strings$1), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))]))))]));
      var this$28 = $m_Lframework_prelude_log$();
      var this$27 = $m_Lframework_prelude_client\uff3flogging$package$JSAppName$();
      var appName$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Newtype$WithoutValidation__apply__O__O(this$27, "app");
      var level$1 = $s_Lframework_utils_LogLevel$__Info__Lframework_utils_LogLevel();
      var scope$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      $f_Lframework_utils_JSLogger$DefaultJavascriptLogging__atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V(this$28, level$1, scope$1, info$4, x$6, appName$1);
      var stream$1 = $p_Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5__delayedWsStream$1__s_concurrent_duration_FiniteDuration__O__O__Lframework_sourcecode_DefinedAt__Lcom_raquo_airstream_core_EventStream(this, delay, securityParams, params, x$6);
      return new $c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith(stream$1);
    }
    var reconnectOnError = x57.s_Some__f_value;
    return reconnectOnError.onError__Lsttp_model_Uri__Lorg_scalajs_dom_Event__I__O__O__Lframework_sourcecode_DefinedAt__Lframework_exts_OnSSEStreamError$OnErrorAction(uri, error, connectionIndex, securityParams, params, x$6);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x57);
});
$c_Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5.prototype.onMessage__O__V = (function(msg) {
  this.onMessage__Lorg_scalajs_dom_MessageEvent__V(msg);
});
var $d_Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5, "framework.utils.ToSSEStreamBuilder$$anon$4$$anon$5", ({
  Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5: 1,
  Lframework_exts_OnSSEStreamError: 1
}));
export { $d_Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5 as $d_Lframework_utils_ToSSEStreamBuilder$$anon$4$$anon$5 };
/** @constructor */
function $c_Lfs2_Compiler$$anon$5() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_package$();
}
export { $c_Lfs2_Compiler$$anon$5 as $c_Lfs2_Compiler$$anon$5 };
$c_Lfs2_Compiler$$anon$5.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_Compiler$$anon$5.prototype.constructor = $c_Lfs2_Compiler$$anon$5;
/** @constructor */
function $h_Lfs2_Compiler$$anon$5() {
}
export { $h_Lfs2_Compiler$$anon$5 as $h_Lfs2_Compiler$$anon$5 };
$h_Lfs2_Compiler$$anon$5.prototype = $c_Lfs2_Compiler$$anon$5.prototype;
$c_Lfs2_Compiler$$anon$5.prototype.apply__Lfs2_Pull__O__F2__O = (function(stream, init, foldChunk) {
  $m_Lfs2_Compiler$();
  var this$1 = $m_Lfs2_Compiler$Target$();
  var F = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_effect_SyncIO$().Lcats_effect_SyncIO$__f__syncForSyncIO;
  var F$1 = $f_Lfs2_Compiler$TargetLowPriority__forSync__Lcats_effect_kernel_Sync__Lfs2_Compiler$Target(this$1, F);
  return new $c_Lfs2_CompilerLowPriority1$$anon$2(F$1).apply__Lfs2_Pull__O__F2__O(stream, init, foldChunk).unsafeRunSync__O();
});
var $d_Lfs2_Compiler$$anon$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Compiler$$anon$5, "fs2.Compiler$$anon$5", ({
  Lfs2_Compiler$$anon$5: 1,
  Lfs2_Compiler: 1
}));
export { $d_Lfs2_Compiler$$anon$5 as $d_Lfs2_Compiler$$anon$5 };
/** @constructor */
function $c_Lfs2_Compiler$Target$() {
}
export { $c_Lfs2_Compiler$Target$ as $c_Lfs2_Compiler$Target$ };
$c_Lfs2_Compiler$Target$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_Compiler$Target$.prototype.constructor = $c_Lfs2_Compiler$Target$;
/** @constructor */
function $h_Lfs2_Compiler$Target$() {
}
export { $h_Lfs2_Compiler$Target$ as $h_Lfs2_Compiler$Target$ };
$h_Lfs2_Compiler$Target$.prototype = $c_Lfs2_Compiler$Target$.prototype;
var $d_Lfs2_Compiler$Target$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Compiler$Target$, "fs2.Compiler$Target$", ({
  Lfs2_Compiler$Target$: 1,
  Lfs2_Compiler$TargetLowPriority: 1
}));
export { $d_Lfs2_Compiler$Target$ as $d_Lfs2_Compiler$Target$ };
var $n_Lfs2_Compiler$Target$;
function $m_Lfs2_Compiler$Target$() {
  if ((!$n_Lfs2_Compiler$Target$)) {
    $n_Lfs2_Compiler$Target$ = new $c_Lfs2_Compiler$Target$();
  }
  return $n_Lfs2_Compiler$Target$;
}
export { $m_Lfs2_Compiler$Target$ as $m_Lfs2_Compiler$Target$ };
/** @constructor */
function $c_Lfs2_CompilerLowPriority$$anon$4() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$either$();
}
export { $c_Lfs2_CompilerLowPriority$$anon$4 as $c_Lfs2_CompilerLowPriority$$anon$4 };
$c_Lfs2_CompilerLowPriority$$anon$4.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_CompilerLowPriority$$anon$4.prototype.constructor = $c_Lfs2_CompilerLowPriority$$anon$4;
/** @constructor */
function $h_Lfs2_CompilerLowPriority$$anon$4() {
}
export { $h_Lfs2_CompilerLowPriority$$anon$4 as $h_Lfs2_CompilerLowPriority$$anon$4 };
$h_Lfs2_CompilerLowPriority$$anon$4.prototype = $c_Lfs2_CompilerLowPriority$$anon$4.prototype;
$c_Lfs2_CompilerLowPriority$$anon$4.prototype.apply__Lfs2_Pull__O__F2__s_util_Either = (function(stream, init, foldChunk) {
  $m_Lfs2_Compiler$();
  var this$1 = $m_Lfs2_Compiler$Target$();
  var F = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_effect_SyncIO$().Lcats_effect_SyncIO$__f__syncForSyncIO;
  var F$1 = $f_Lfs2_Compiler$TargetLowPriority__forSync__Lcats_effect_kernel_Sync__Lfs2_Compiler$Target(this$1, F);
  var this$3 = new $c_Lfs2_CompilerLowPriority1$$anon$2(F$1).apply__Lfs2_Pull__O__F2__O(stream, init, foldChunk);
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_SyncIO$Attempt(this$3).unsafeRunSync__O();
});
$c_Lfs2_CompilerLowPriority$$anon$4.prototype.apply__Lfs2_Pull__O__F2__O = (function(stream, init, fold) {
  return this.apply__Lfs2_Pull__O__F2__s_util_Either(stream, init, fold);
});
var $d_Lfs2_CompilerLowPriority$$anon$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_CompilerLowPriority$$anon$4, "fs2.CompilerLowPriority$$anon$4", ({
  Lfs2_CompilerLowPriority$$anon$4: 1,
  Lfs2_Compiler: 1
}));
export { $d_Lfs2_CompilerLowPriority$$anon$4 as $d_Lfs2_CompilerLowPriority$$anon$4 };
/** @constructor */
function $c_Lfs2_CompilerLowPriority0$$anon$3() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_package$();
}
export { $c_Lfs2_CompilerLowPriority0$$anon$3 as $c_Lfs2_CompilerLowPriority0$$anon$3 };
$c_Lfs2_CompilerLowPriority0$$anon$3.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_CompilerLowPriority0$$anon$3.prototype.constructor = $c_Lfs2_CompilerLowPriority0$$anon$3;
/** @constructor */
function $h_Lfs2_CompilerLowPriority0$$anon$3() {
}
export { $h_Lfs2_CompilerLowPriority0$$anon$3 as $h_Lfs2_CompilerLowPriority0$$anon$3 };
$h_Lfs2_CompilerLowPriority0$$anon$3.prototype = $c_Lfs2_CompilerLowPriority0$$anon$3.prototype;
$c_Lfs2_CompilerLowPriority0$$anon$3.prototype.apply__Lfs2_Pull__O__F2__O = (function(stream, init, foldChunk) {
  $m_Lfs2_Compiler$();
  var this$1 = $m_Lfs2_Compiler$Target$();
  var F = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_effect_SyncIO$().Lcats_effect_SyncIO$__f__syncForSyncIO;
  var F$1 = $f_Lfs2_Compiler$TargetLowPriority__forSync__Lcats_effect_kernel_Sync__Lfs2_Compiler$Target(this$1, F);
  return new $c_Lfs2_CompilerLowPriority1$$anon$2(F$1).apply__Lfs2_Pull__O__F2__O(($m_Lfs2_Pull$(), $m_Lfs2_Pull$IdOps$().covaryId$extension__Lfs2_Pull__Lcats_Applicative__Lfs2_Pull(stream, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_effect_SyncIO$().Lcats_effect_SyncIO$__f__syncForSyncIO)), init, foldChunk).unsafeRunSync__O();
});
var $d_Lfs2_CompilerLowPriority0$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_CompilerLowPriority0$$anon$3, "fs2.CompilerLowPriority0$$anon$3", ({
  Lfs2_CompilerLowPriority0$$anon$3: 1,
  Lfs2_Compiler: 1
}));
export { $d_Lfs2_CompilerLowPriority0$$anon$3 as $d_Lfs2_CompilerLowPriority0$$anon$3 };
/** @constructor */
function $c_Lfs2_CompilerLowPriority1$$anon$2(F$1) {
  this.Lfs2_CompilerLowPriority1$$anon$2__f_F$2 = null;
  this.Lfs2_CompilerLowPriority1$$anon$2__f_F$2 = F$1;
}
export { $c_Lfs2_CompilerLowPriority1$$anon$2 as $c_Lfs2_CompilerLowPriority1$$anon$2 };
$c_Lfs2_CompilerLowPriority1$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_CompilerLowPriority1$$anon$2.prototype.constructor = $c_Lfs2_CompilerLowPriority1$$anon$2;
/** @constructor */
function $h_Lfs2_CompilerLowPriority1$$anon$2() {
}
export { $h_Lfs2_CompilerLowPriority1$$anon$2 as $h_Lfs2_CompilerLowPriority1$$anon$2 };
$h_Lfs2_CompilerLowPriority1$$anon$2.prototype = $c_Lfs2_CompilerLowPriority1$$anon$2.prototype;
$c_Lfs2_CompilerLowPriority1$$anon$2.prototype.apply__Lfs2_Pull__O__F2__O = (function(stream, init, foldChunk) {
  return $f_Lfs2_Compiler$Target__compile__Lfs2_Pull__O__F2__O(this.Lfs2_CompilerLowPriority1$$anon$2__f_F$2, stream, init, foldChunk);
});
var $d_Lfs2_CompilerLowPriority1$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_CompilerLowPriority1$$anon$2, "fs2.CompilerLowPriority1$$anon$2", ({
  Lfs2_CompilerLowPriority1$$anon$2: 1,
  Lfs2_Compiler: 1
}));
export { $d_Lfs2_CompilerLowPriority1$$anon$2 as $d_Lfs2_CompilerLowPriority1$$anon$2 };
function $p_Lfs2_Pull$__TheBuildR$lzyINIT1$1__sr_LazyRef__Lcats_MonadError__Lfs2_Pull$TheBuildR$2$($thiz, TheBuildR$lzy1$1, F$7) {
  if ((TheBuildR$lzy1$1 === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  return (TheBuildR$lzy1$1.sr_LazyRef__f__initialized ? TheBuildR$lzy1$1.sr_LazyRef__f__value : TheBuildR$lzy1$1.initialize__O__O(new $c_Lfs2_Pull$TheBuildR$2$(F$7)));
}
export { $p_Lfs2_Pull$__TheBuildR$lzyINIT1$1__sr_LazyRef__Lcats_MonadError__Lfs2_Pull$TheBuildR$2$ as $p_Lfs2_Pull$__TheBuildR$lzyINIT1$1__sr_LazyRef__Lcats_MonadError__Lfs2_Pull$TheBuildR$2$ };
function $p_Lfs2_Pull$__TheBuildR$1__sr_LazyRef__Lcats_MonadError__Lfs2_Pull$TheBuildR$2$($thiz, TheBuildR$lzy1$2, F$8) {
  return (TheBuildR$lzy1$2.sr_LazyRef__f__initialized ? TheBuildR$lzy1$2.sr_LazyRef__f__value : $p_Lfs2_Pull$__TheBuildR$lzyINIT1$1__sr_LazyRef__Lcats_MonadError__Lfs2_Pull$TheBuildR$2$($thiz, TheBuildR$lzy1$2, F$8));
}
export { $p_Lfs2_Pull$__TheBuildR$1__sr_LazyRef__Lcats_MonadError__Lfs2_Pull$TheBuildR$2$ as $p_Lfs2_Pull$__TheBuildR$1__sr_LazyRef__Lcats_MonadError__Lfs2_Pull$TheBuildR$2$ };
function $s_Lfs2_Pull$__fs2$Pull$ViewRunner$1$$_$outLoop$1__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__Lfs2_Pull$Run$1__O(head$2, scope$7, acc, pred) {
  var pred$tailLocal1 = pred;
  var acc$tailLocal1 = acc;
  while (true) {
    var x187 = pred$tailLocal1;
    if ((x187 instanceof $c_Lfs2_Pull$ViewRunner$1)) {
      var acc$tailLocal1$tmp1 = $m_Lfs2_Pull$().fs2$Pull$$$bindView__Lfs2_Pull__F1__Lfs2_Pull(acc$tailLocal1, x187.Lfs2_Pull$ViewRunner$1__f_view);
      var pred$tailLocal1$tmp1 = x187.Lfs2_Pull$ViewRunner$1__f_prevRunner;
      acc$tailLocal1 = acc$tailLocal1$tmp1;
      pred$tailLocal1 = pred$tailLocal1$tmp1;
      continue;
    }
    return pred$tailLocal1.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O(head$2, scope$7, acc$tailLocal1);
  }
}
export { $s_Lfs2_Pull$__fs2$Pull$ViewRunner$1$$_$outLoop$1__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__Lfs2_Pull$Run$1__O as $s_Lfs2_Pull$__fs2$Pull$ViewRunner$1$$_$outLoop$1__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__Lfs2_Pull$Run$1__O };
function $p_Lfs2_Pull$__goEval$1__Lfs2_internal_Scope__Lcats_arrow_FunctionK__Lcats_MonadError__s_Option__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_Pull$Eval__F1__O($thiz, scope$14, translation$tailLocal1$11, F$21, extendedTopLevelScope$11, runner$tailLocal1$11, extendLastTopLevelScope$12, contP$14, TheBuildR$lzy1$14, eval$1, view) {
  var target = scope$14.interruptibleEval__O__O(translation$tailLocal1$11.apply__O__O(eval$1.Lfs2_Pull$Eval__f_value));
  var this$9 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F$21);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((eitherOutcome) => {
    matchResult81: {
      var $x_1;
      if ((eitherOutcome instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
        var r = eitherOutcome.s_util_Right__f_value;
        var $x_1 = new $c_Lfs2_Pull$Succeeded(r);
        break matchResult81;
      }
      if ((eitherOutcome instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
        var x222 = eitherOutcome.s_util_Left__f_value;
        if ((x222 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Errored)) {
          var x225 = x222.Lcats_effect_kernel_Outcome$Errored__f_e;
          var $x_1 = new $c_Lfs2_Pull$Fail(x225);
          break matchResult81;
        }
        if ((x222 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Canceled)) {
          var context = scope$14.Lfs2_internal_Scope__f_id;
          var deferredError = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
          var $x_1 = new $c_Lfs2_Pull$Interrupted(context, deferredError);
          break matchResult81;
        }
        if ((x222 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Succeeded)) {
          var x217 = x222.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
          var deferredError$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
          var $x_1 = new $c_Lfs2_Pull$Interrupted(x217, deferredError$1);
          break matchResult81;
        }
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(eitherOutcome);
    }
    var result = $x_1;
    return $thiz.fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(F$21, extendLastTopLevelScope$12, contP$14, TheBuildR$lzy1$14, scope$14, extendedTopLevelScope$11, translation$tailLocal1$11, runner$tailLocal1$11, view.apply__O__O(result));
  }));
  return this$9.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$9.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
}
export { $p_Lfs2_Pull$__goEval$1__Lfs2_internal_Scope__Lcats_arrow_FunctionK__Lcats_MonadError__s_Option__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_Pull$Eval__F1__O as $p_Lfs2_Pull$__goEval$1__Lfs2_internal_Scope__Lcats_arrow_FunctionK__Lcats_MonadError__s_Option__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_Pull$Eval__F1__O };
function $p_Lfs2_Pull$__goAcquire$1__Lfs2_internal_Scope__Lcats_arrow_FunctionK__Lcats_MonadError__s_Option__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_Pull$Acquire__F1__O($thiz, scope$16, translation$tailLocal1$13, F$23, extendedTopLevelScope$13, runner$tailLocal1$13, extendLastTopLevelScope$14, contP$16, TheBuildR$lzy1$16, acquire, view) {
  var onScope = scope$16.acquireResource__F1__F2__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((poll) => (acquire.Lfs2_Pull$Acquire__f_cancelable ? poll.apply__O__O(translation$tailLocal1$13.apply__O__O(acquire.Lfs2_Pull$Acquire__f_resource)) : translation$tailLocal1$13.apply__O__O(acquire.Lfs2_Pull$Acquire__f_resource)))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((resource, exit) => translation$tailLocal1$13.apply__O__O(acquire.Lfs2_Pull$Acquire__f_release.apply__O__O__O(resource, exit)))));
  var this$9 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(onScope, F$23);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((outcome) => {
    matchResult82: {
      var $x_1;
      if ((outcome instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Succeeded)) {
        var x240 = outcome.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
        if ((x240 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
          var r = x240.s_util_Right__f_value;
          var $x_1 = new $c_Lfs2_Pull$Succeeded(r);
          break matchResult82;
        }
        if ((x240 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
          var scopeId = x240.s_util_Left__f_value;
          var deferredError = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
          var $x_1 = new $c_Lfs2_Pull$Interrupted(scopeId, deferredError);
          break matchResult82;
        }
      }
      if ((outcome instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Canceled)) {
        var context = scope$16.Lfs2_internal_Scope__f_id;
        var deferredError$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        var $x_1 = new $c_Lfs2_Pull$Interrupted(context, deferredError$1);
        break matchResult82;
      }
      if ((outcome instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Errored)) {
        var x231 = outcome.Lcats_effect_kernel_Outcome$Errored__f_e;
        var $x_1 = new $c_Lfs2_Pull$Fail(x231);
        break matchResult82;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(outcome);
    }
    var result = $x_1;
    return $thiz.fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(F$23, extendLastTopLevelScope$14, contP$16, TheBuildR$lzy1$16, scope$16, extendedTopLevelScope$13, translation$tailLocal1$13, runner$tailLocal1$13, view.apply__O__O(result));
  }));
  var cont = this$9.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$9.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  return $thiz.fs2$Pull$$$_$interruptGuard$1__Lcats_MonadError__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__F1__F0__O(F$23, extendedTopLevelScope$13, translation$tailLocal1$13, runner$tailLocal1$13, extendLastTopLevelScope$14, contP$16, TheBuildR$lzy1$16, scope$16, view, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => cont)));
}
export { $p_Lfs2_Pull$__goAcquire$1__Lfs2_internal_Scope__Lcats_arrow_FunctionK__Lcats_MonadError__s_Option__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_Pull$Acquire__F1__O as $p_Lfs2_Pull$__goAcquire$1__Lfs2_internal_Scope__Lcats_arrow_FunctionK__Lcats_MonadError__s_Option__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_Pull$Acquire__F1__O };
function $p_Lfs2_Pull$__goInterruptWhen$1__Lfs2_internal_Scope__Lcats_MonadError__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__O__F1__O($thiz, scope$18, F$25, extendedTopLevelScope$15, translation$tailLocal1$17, runner$tailLocal1$15, extendLastTopLevelScope$16, contP$18, TheBuildR$lzy1$18, haltOnSignal, view) {
  var onScope = scope$18.acquireResource__F1__F2__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$68) => scope$18.interruptWhen__O__O(haltOnSignal))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((f, _$69) => f.cancel__O())));
  var this$8 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(onScope, F$25);
  var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((outcome) => {
    matchResult83: {
      var result;
      if ((outcome instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Succeeded)) {
        var x255 = outcome.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
        if ((x255 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
          var result = $thiz.Lfs2_Pull$__f_fs2$Pull$$$unit;
          break matchResult83;
        }
        if ((x255 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
          var scopeId = x255.s_util_Left__f_value;
          var deferredError = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
          var result = new $c_Lfs2_Pull$Interrupted(scopeId, deferredError);
          break matchResult83;
        }
      }
      if ((outcome instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Canceled)) {
        var context = scope$18.Lfs2_internal_Scope__f_id;
        var deferredError$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        var result = new $c_Lfs2_Pull$Interrupted(context, deferredError$1);
        break matchResult83;
      }
      if ((outcome instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Errored)) {
        var x246 = outcome.Lcats_effect_kernel_Outcome$Errored__f_e;
        var result = new $c_Lfs2_Pull$Fail(x246);
        break matchResult83;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(outcome);
    }
    return $thiz.fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(F$25, extendLastTopLevelScope$16, contP$18, TheBuildR$lzy1$18, scope$18, extendedTopLevelScope$15, translation$tailLocal1$17, runner$tailLocal1$15, view.apply__O__O(result));
  }));
  var cont = this$8.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$8.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
  return $thiz.fs2$Pull$$$_$interruptGuard$1__Lcats_MonadError__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__F1__F0__O(F$25, extendedTopLevelScope$15, translation$tailLocal1$17, runner$tailLocal1$15, extendLastTopLevelScope$16, contP$18, TheBuildR$lzy1$18, scope$18, view, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => cont)));
}
export { $p_Lfs2_Pull$__goInterruptWhen$1__Lfs2_internal_Scope__Lcats_MonadError__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__O__F1__O as $p_Lfs2_Pull$__goInterruptWhen$1__Lfs2_internal_Scope__Lcats_MonadError__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__O__F1__O };
function $p_Lfs2_Pull$__goInScope$1__Lfs2_internal_Scope__s_Option__Lcats_MonadError__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_Pull__Z__F1__O($thiz, scope$21, extendedTopLevelScope$17, F$27, translation$tailLocal1$19, runner$tailLocal1$17, extendLastTopLevelScope$18, contP$20, TheBuildR$lzy1$20, stream, useInterruption, view) {
  if ((scope$21.Lfs2_internal_Scope__f_parent.isEmpty__Z() && (!extendedTopLevelScope$17.isEmpty__Z()))) {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_UnorderedFoldable$();
    var tc = $m_Lcats_instances_package$option$().Lcats_instances_package$option$__f_catsStdInstancesForOption;
    var this$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Foldable$ToFoldableOps$$anon$6(extendedTopLevelScope$17, tc);
    var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$70) => {
      var fea = _$70.close__Lcats_effect_kernel_Resource$ExitCase__O($m_Lcats_effect_kernel_Resource$ExitCase$Succeeded$());
      return $m_Lcats_syntax_MonadErrorRethrowOps$().rethrow$extension__O__Lcats_MonadError__O(fea, F$27);
    }));
    var target = this$4.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance.traverseVoid__O__F1__Lcats_Applicative__O(this$4.Lcats_Foldable$ToFoldableOps$$anon$6__f_self, f, F$27);
    var this$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target, F$27);
    var b = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    var maybeCloseExtendedScope = this$6.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.as__O__O__O(this$6.Lcats_Functor$ToFunctorOps$$anon$5__f_self, b);
  } else {
    var maybeCloseExtendedScope = F$27.pure__O__O(extendedTopLevelScope$17);
  }
  var this$12 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(maybeCloseExtendedScope, F$27);
  var f$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((newExtendedScope) => {
    var fea$1 = scope$21.open__Z__O(useInterruption);
    var target$1 = $m_Lcats_syntax_MonadErrorRethrowOps$().rethrow$extension__O__Lcats_MonadError__O(fea$1, F$27);
    var this$11 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, F$27);
    var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((newExtendedScope$2) => ((childScope) => {
      var bb = new $c_Lfs2_Pull$$anon$8(stream, childScope);
      return $thiz.fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(F$27, extendLastTopLevelScope$18, contP$20, TheBuildR$lzy1$20, childScope, newExtendedScope$2, translation$tailLocal1$19, new $c_Lfs2_Pull$ViewRunner$1(runner$tailLocal1$17, extendedTopLevelScope$17, translation$tailLocal1$19, scope$21, F$27, extendLastTopLevelScope$18, contP$20, TheBuildR$lzy1$20, view), bb);
    }))(newExtendedScope));
    return this$11.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$11.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
  }));
  var tail = this$12.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$12.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
  return $thiz.fs2$Pull$$$_$interruptGuard$1__Lcats_MonadError__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__F1__F0__O(F$27, extendedTopLevelScope$17, translation$tailLocal1$19, runner$tailLocal1$17, extendLastTopLevelScope$18, contP$20, TheBuildR$lzy1$20, scope$21, view, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => tail)));
}
export { $p_Lfs2_Pull$__goInScope$1__Lfs2_internal_Scope__s_Option__Lcats_MonadError__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_Pull__Z__F1__O as $p_Lfs2_Pull$__goInScope$1__Lfs2_internal_Scope__s_Option__Lcats_MonadError__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_Pull__Z__F1__O };
function $p_Lfs2_Pull$__addError$1__jl_Throwable__Lfs2_Pull$Terminal__Lfs2_Pull$Terminal($thiz, err, res) {
  if ((res instanceof $c_Lfs2_Pull$Succeeded)) {
    return new $c_Lfs2_Pull$Fail(err);
  }
  if ((res instanceof $c_Lfs2_Pull$Fail)) {
    var x276 = res.Lfs2_Pull$Fail__f_error;
    var error = $m_Lfs2_CompositeFailure$().apply__jl_Throwable__jl_Throwable__sci_List__Lfs2_CompositeFailure(err, x276, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
    return new $c_Lfs2_Pull$Fail(error);
  }
  if ((res instanceof $c_Lfs2_Pull$Interrupted)) {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_sys_package$().error__T__E("Impossible, cannot interrupt here");
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(res);
}
export { $p_Lfs2_Pull$__addError$1__jl_Throwable__Lfs2_Pull$Terminal__Lfs2_Pull$Terminal as $p_Lfs2_Pull$__addError$1__jl_Throwable__Lfs2_Pull$Terminal__Lfs2_Pull$Terminal };
function $p_Lfs2_Pull$__viewCont$1__Lfs2_Pull$CloseScope__F1__Lfs2_Pull$Terminal__Lfs2_Pull($thiz, close$1, view$9, res) {
  var x280 = close$1.exitCase__Lcats_effect_kernel_Resource$ExitCase();
  if ((x280 instanceof $c_Lcats_effect_kernel_Resource$ExitCase$Errored)) {
    var x283 = x280.Lcats_effect_kernel_Resource$ExitCase$Errored__f_e;
    return view$9.apply__O__O($p_Lfs2_Pull$__addError$1__jl_Throwable__Lfs2_Pull$Terminal__Lfs2_Pull$Terminal($thiz, x283, res));
  }
  return view$9.apply__O__O(res);
}
export { $p_Lfs2_Pull$__viewCont$1__Lfs2_Pull$CloseScope__F1__Lfs2_Pull$Terminal__Lfs2_Pull as $p_Lfs2_Pull$__viewCont$1__Lfs2_Pull$CloseScope__F1__Lfs2_Pull$Terminal__Lfs2_Pull };
function $p_Lfs2_Pull$__err1$1__s_util_Either__s_Option__s_Option($thiz, r$1, err$1) {
  var $x_1 = $m_Lfs2_CompositeFailure$();
  var this$1 = r$1.swap__s_util_Either().toOption__s_Option().toList__sci_List();
  var suffix = err$1.toList__sci_List();
  return $x_1.fromList__sci_List__s_Option(this$1.appendedAll__sc_IterableOnce__sci_List(suffix));
}
export { $p_Lfs2_Pull$__err1$1__s_util_Either__s_Option__s_Option as $p_Lfs2_Pull$__err1$1__s_util_Either__s_Option__s_Option };
function $p_Lfs2_Pull$__closeTerminal$1__Lfs2_Pull$CloseScope__s_util_Either__Lfs2_internal_Scope__Lfs2_Pull$Terminal($thiz, close$2, r, ancestor) {
  var x287 = close$2.interruption__s_Option();
  var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  if ((x === x287)) {
    if ((r instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
      var b = r.s_util_Right__f_value;
      var $x_1 = new $c_Lfs2_Pull$Succeeded(b);
    } else {
      if ((!(r instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left))) {
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(r);
      }
      var a = r.s_util_Left__f_value;
      var $x_1 = new $c_Lfs2_Pull$Fail(a);
    }
    return $x_1;
  }
  if ((x287 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
    var x289 = x287.s_Some__f_value;
    if ((x289 !== null)) {
      var x291 = x289.Lfs2_Pull$Interrupted__f_context;
      var x292 = x289.Lfs2_Pull$Interrupted__f_deferredError;
      if (ancestor.descendsFrom__Lcats_effect_kernel_Unique$Token__Z(x291)) {
        var deferredError = $p_Lfs2_Pull$__err1$1__s_util_Either__s_Option__s_Option($thiz, r, x292);
        return new $c_Lfs2_Pull$Interrupted(x291, deferredError);
      } else {
        var x284 = $p_Lfs2_Pull$__err1$1__s_util_Either__s_Option__s_Option($thiz, r, x292);
        var x$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        if ((x$3 === x284)) {
          return $thiz.Lfs2_Pull$__f_fs2$Pull$$$unit;
        }
        if ((x284 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
          var e2 = x284.s_Some__f_value;
          return new $c_Lfs2_Pull$Fail(e2);
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x284);
      }
    }
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x287);
}
export { $p_Lfs2_Pull$__closeTerminal$1__Lfs2_Pull$CloseScope__s_util_Either__Lfs2_internal_Scope__Lfs2_Pull$Terminal as $p_Lfs2_Pull$__closeTerminal$1__Lfs2_Pull$CloseScope__s_util_Either__Lfs2_internal_Scope__Lfs2_Pull$Terminal };
function $p_Lfs2_Pull$__goCloseScope$1__Lfs2_internal_Scope__Lcats_MonadError__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_Pull$CloseScope__F1__O($thiz, scope$24, F$31, extendedTopLevelScope$20, translation$tailLocal1$22, runner$tailLocal1$20, extendLastTopLevelScope$21, contP$23, TheBuildR$lzy1$23, close, view) {
  var target = scope$24.findInLineage__Lcats_effect_kernel_Unique$Token__O(close.scopeId__Lcats_effect_kernel_Unique$Token());
  var this$17 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F$31);
  var f$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var x299 = x$1.s_Some__f_value;
      if (x299.Lfs2_internal_Scope__f_parent.isEmpty__Z()) {
        return $thiz.fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(F$31, extendLastTopLevelScope$21, contP$23, TheBuildR$lzy1$23, scope$24, extendedTopLevelScope$20, translation$tailLocal1$22, runner$tailLocal1$20, $p_Lfs2_Pull$__viewCont$1__Lfs2_Pull$CloseScope__F1__Lfs2_Pull$Terminal__Lfs2_Pull($thiz, close, view, $thiz.Lfs2_Pull$__f_fs2$Pull$$$unit));
      }
      if ((extendLastTopLevelScope$21 && ($ps_Lfs2_internal_Scope__go$1__Lfs2_internal_Scope__I__I(x299, 0) === 1))) {
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_UnorderedFoldable$();
        var tc = $m_Lcats_instances_package$option$().Lcats_instances_package$option$__f_catsStdInstancesForOption;
        var this$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Foldable$ToFoldableOps$$anon$6(extendedTopLevelScope$20, tc);
        var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$73) => {
          var fea = _$73.close__Lcats_effect_kernel_Resource$ExitCase__O($m_Lcats_effect_kernel_Resource$ExitCase$Succeeded$());
          return $m_Lcats_syntax_MonadErrorRethrowOps$().rethrow$extension__O__Lcats_MonadError__O(fea, F$31);
        }));
        var fa = this$6.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance.traverseVoid__O__F1__Lcats_Applicative__O(this$6.Lcats_Foldable$ToFoldableOps$$anon$6__f_self, f, F$31);
        var target$1 = x299.openAncestor__O();
        var this$10 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, F$31);
        var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((ancestor) => $thiz.fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(F$31, extendLastTopLevelScope$21, contP$23, TheBuildR$lzy1$23, ancestor, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(x299), translation$tailLocal1$22, runner$tailLocal1$20, $p_Lfs2_Pull$__viewCont$1__Lfs2_Pull$CloseScope__F1__Lfs2_Pull$Terminal__Lfs2_Pull($thiz, close, view, $thiz.Lfs2_Pull$__f_fs2$Pull$$$unit))));
        var fb = this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
        return F$31.productR__O__O__O(fa, fb);
      }
      var target$2 = x299.close__Lcats_effect_kernel_Resource$ExitCase__O(close.exitCase__Lcats_effect_kernel_Resource$ExitCase());
      var this$15 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, F$31);
      var f$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((r) => {
        var target$3 = x299.openAncestor__O();
        var this$14 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$3, F$31);
        var f$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((r$2) => ((ancestor$1) => {
          var res = $p_Lfs2_Pull$__closeTerminal$1__Lfs2_Pull$CloseScope__s_util_Either__Lfs2_internal_Scope__Lfs2_Pull$Terminal($thiz, close, r$2, ancestor$1);
          return $thiz.fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(F$31, extendLastTopLevelScope$21, contP$23, TheBuildR$lzy1$23, ancestor$1, extendedTopLevelScope$20, translation$tailLocal1$22, runner$tailLocal1$20, $p_Lfs2_Pull$__viewCont$1__Lfs2_Pull$CloseScope__F1__Lfs2_Pull$Terminal__Lfs2_Pull($thiz, close, view, res));
        }))(r));
        return this$14.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$14.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
      }));
      return this$15.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$15.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
    }
    var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    if ((x === x$1)) {
      var this$16 = close.interruption__s_Option();
      var result = (this$16.isEmpty__Z() ? $m_Lfs2_Pull$().Lfs2_Pull$__f_fs2$Pull$$$unit : this$16.get__O());
      return $thiz.fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(F$31, extendLastTopLevelScope$21, contP$23, TheBuildR$lzy1$23, scope$24, extendedTopLevelScope$20, translation$tailLocal1$22, runner$tailLocal1$20, $p_Lfs2_Pull$__viewCont$1__Lfs2_Pull$CloseScope__F1__Lfs2_Pull$Terminal__Lfs2_Pull($thiz, close, view, result));
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  }));
  return this$17.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$17.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$4);
}
export { $p_Lfs2_Pull$__goCloseScope$1__Lfs2_internal_Scope__Lcats_MonadError__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_Pull$CloseScope__F1__O as $p_Lfs2_Pull$__goCloseScope$1__Lfs2_internal_Scope__Lcats_MonadError__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_Pull$CloseScope__F1__O };
/** @constructor */
function $c_Lfs2_Pull$() {
  this.Lfs2_Pull$__f_fs2$Pull$$$unit = null;
  this.Lfs2_Pull$__f_outUnit = null;
  this.Lfs2_Pull$__f_done = null;
  $n_Lfs2_Pull$ = this;
  this.Lfs2_Pull$__f_fs2$Pull$$$unit = new $c_Lfs2_Pull$Succeeded((void 0));
  var values = $m_Lfs2_Chunk$().Lfs2_Chunk$__f_unit;
  this.Lfs2_Pull$__f_outUnit = new $c_Lfs2_Pull$Output(values);
  this.Lfs2_Pull$__f_done = this.Lfs2_Pull$__f_fs2$Pull$$$unit;
}
export { $c_Lfs2_Pull$ as $c_Lfs2_Pull$ };
$c_Lfs2_Pull$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_Pull$.prototype.constructor = $c_Lfs2_Pull$;
/** @constructor */
function $h_Lfs2_Pull$() {
}
export { $h_Lfs2_Pull$ as $h_Lfs2_Pull$ };
$h_Lfs2_Pull$.prototype = $c_Lfs2_Pull$.prototype;
$c_Lfs2_Pull$.prototype.output1__O__Lfs2_Pull = (function(o) {
  $m_Lfs2_Chunk$();
  var values = new $c_Lfs2_Chunk$Singleton(o);
  return new $c_Lfs2_Pull$Output(values);
});
$c_Lfs2_Pull$.prototype.output__Lfs2_Chunk__Lfs2_Pull = (function(os) {
  return (os.isEmpty__Z() ? $m_Lfs2_Pull$().Lfs2_Pull$__f_done : new $c_Lfs2_Pull$Output(os));
});
$c_Lfs2_Pull$.prototype.acquireCancelable__F1__F2__Lcats_effect_kernel_MonadCancel__Lfs2_Pull = (function(resource, release, F) {
  var resource$1 = F.uncancelable__F1__O(resource);
  return new $c_Lfs2_Pull$Acquire(resource$1, release, true);
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$bindView__Lfs2_Pull__F1__Lfs2_Pull = (function(fmoc, view) {
  var x = $m_Lfs2_Pull$IdContP$();
  if ((x === view)) {
    return fmoc;
  } else if ((view instanceof $c_Lfs2_Pull$Bind)) {
    if ((fmoc instanceof $c_Lfs2_Pull$Terminal)) {
      try {
        return view.cont__Lfs2_Pull$Terminal__Lfs2_Pull(fmoc);
      } catch (e) {
        var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
        var x95 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
        if ((!x95.isEmpty__Z())) {
          var x96 = x95.get__O();
          return new $c_Lfs2_Pull$Fail(x96);
        }
        throw ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
      }
    } else {
      return new $c_Lfs2_Pull$DelegateBind(fmoc, view.delegate__Lfs2_Pull$Bind());
    }
  } else {
    return new $c_Lfs2_Pull$$anon$7(fmoc, view);
  }
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$bindBindAux__Lfs2_Pull__Lfs2_Pull$Bind__Lfs2_Pull = (function(py, del) {
  var del$tailLocal1 = del;
  var py$tailLocal1 = py;
  while (true) {
    var x108 = py$tailLocal1;
    if ((x108 instanceof $c_Lfs2_Pull$Terminal)) {
      var x106 = del$tailLocal1;
      if ((x106 instanceof $c_Lfs2_Pull$BindBind)) {
        var py$tailLocal1$tmp1 = x106.Lfs2_Pull$BindBind__f_bb.cont__Lfs2_Pull$Terminal__Lfs2_Pull(x108);
        var del$tailLocal1$tmp1 = x106.Lfs2_Pull$BindBind__f_del;
        py$tailLocal1 = py$tailLocal1$tmp1;
        del$tailLocal1 = del$tailLocal1$tmp1;
        continue;
      }
      return del$tailLocal1.cont__Lfs2_Pull$Terminal__Lfs2_Pull(x108);
    }
    return new $c_Lfs2_Pull$DelegateBind(x108, del$tailLocal1);
  }
});
$c_Lfs2_Pull$.prototype.compile__Lfs2_Pull__Lfs2_internal_Scope__Z__O__F2__Lcats_MonadError__O = (function(stream, initScope, extendLastTopLevelScope, init, foldChunk, F) {
  var TheBuildR$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_LazyRef();
  var contP = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_ObjectRef(null);
  var initFk = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_arrow_FunctionK$$anon$4();
  return this.fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(F, extendLastTopLevelScope, contP, TheBuildR$lzy1, initScope, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$(), initFk, new $c_Lfs2_Pull$OuterRun$1(F, foldChunk, initFk, extendLastTopLevelScope, contP, TheBuildR$lzy1, init), stream);
});
$c_Lfs2_Pull$.prototype.translate__Lfs2_Pull__Lcats_arrow_FunctionK__Lfs2_Pull = (function(stream, fK) {
  var fK$tailLocal1 = fK;
  var stream$tailLocal2 = stream;
  while (true) {
    var x331 = stream$tailLocal2;
    if ((x331 instanceof $c_Lfs2_Pull$Translate)) {
      var stream$tailLocal2$tmp1 = x331.Lfs2_Pull$Translate__f_stream;
      var this$1 = x331.Lfs2_Pull$Translate__f_fk;
      var f = fK$tailLocal1;
      var fK$tailLocal1$tmp1 = new $c_Lcats_arrow_FunctionK$$anon$1(this$1, f);
      stream$tailLocal2 = stream$tailLocal2$tmp1;
      fK$tailLocal1 = fK$tailLocal1$tmp1;
      continue;
    }
    if ((x331 instanceof $c_Lfs2_Pull$Output)) {
      return x331;
    }
    if ((x331 instanceof $c_Lfs2_Pull$Terminal)) {
      return x331;
    }
    var stream$1 = stream$tailLocal2;
    var fk = fK$tailLocal1;
    return new $c_Lfs2_Pull$Translate(stream$1, fk);
  }
});
$c_Lfs2_Pull$.prototype.mapOutput__Lfs2_Stream__F1__Lfs2_Pull = (function(s, f) {
  var s$1 = this.mapOutputNoScope__Lfs2_Stream__F1__Lfs2_Pull(s, f);
  return new $c_Lfs2_Pull$InScope(s$1, true);
});
$c_Lfs2_Pull$.prototype.mapOutputNoScope__Lfs2_Stream__F1__Lfs2_Pull = (function(s, f) {
  var ev$16 = ($m_Lfs2_Stream$(), new $c_Lfs2_Stream$ToPull(s)).Lfs2_Stream$ToPull__f_self;
  var self = ev$16.Lfs2_Stream__f_underlying;
  return $m_Lfs2_Pull$StreamPullOps$().unconsFlatMap$extension__Lfs2_Pull__F1__Lfs2_Pull(self, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((hd) => $m_Lfs2_Pull$().output__Lfs2_Chunk__Lfs2_Pull(hd.map__F1__Lfs2_Chunk(f)))));
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$transformWith__Lfs2_Pull__F1__Lfs2_Pull = (function(p, f) {
  if ((p instanceof $c_Lfs2_Pull$Terminal)) {
    try {
      return f.apply__O__O(p);
    } catch (e) {
      var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
      var x336 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
      if ((!x336.isEmpty__Z())) {
        var x337 = x336.get__O();
        return new $c_Lfs2_Pull$Fail(x337);
      }
      throw ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  } else {
    return new $c_Lfs2_Pull$$anon$9(p, f);
  }
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$_$viewL$1__sr_ObjectRef__Lfs2_Pull__Lfs2_Pull$ViewL = (function(contP$2, free) {
  var free$tailLocal1 = free;
  while (true) {
    var x166 = free$tailLocal1;
    if ((x166 instanceof $c_Lfs2_Pull$Action)) {
      contP$2.sr_ObjectRef__f_elem = $m_Lfs2_Pull$IdContP$();
      return x166;
    }
    if ((x166 instanceof $c_Lfs2_Pull$Bind)) {
      var x162 = x166.Lfs2_Pull$Bind__f_step;
      if ((x162 instanceof $c_Lfs2_Pull$Bind)) {
        free$tailLocal1 = new $c_Lfs2_Pull$BindBind(x162.Lfs2_Pull$Bind__f_step, x162.delegate__Lfs2_Pull$Bind(), x166.delegate__Lfs2_Pull$Bind());
        continue;
      }
      if ((x162 instanceof $c_Lfs2_Pull$Action)) {
        contP$2.sr_ObjectRef__f_elem = x166.delegate__Lfs2_Pull$Bind();
        return x162;
      }
      if ((x162 instanceof $c_Lfs2_Pull$Terminal)) {
        free$tailLocal1 = x166.cont__Lfs2_Pull$Terminal__Lfs2_Pull(x162);
        continue;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x162);
    }
    if ((x166 instanceof $c_Lfs2_Pull$Terminal)) {
      return x166;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x166);
  }
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$_$interruptBoundary$1__sr_ObjectRef__Lfs2_Pull__Lfs2_Pull$Interrupted__Lfs2_Pull = (function(contP$38, stream, interruption) {
  var x170 = this.fs2$Pull$$$_$viewL$1__sr_ObjectRef__Lfs2_Pull__Lfs2_Pull$ViewL(contP$38, stream);
  if ((x170 instanceof $c_Lfs2_Pull$CloseScope)) {
    var scopeId = x170.scopeId__Lcats_effect_kernel_Unique$Token();
    var cl = new $c_Lfs2_Pull$CanceledScope(scopeId, interruption);
    return this.fs2$Pull$$$transformWith__Lfs2_Pull__F1__Lfs2_Pull(cl, contP$38.sr_ObjectRef__f_elem);
  }
  if ((x170 instanceof $c_Lfs2_Pull$Action)) {
    var this$2 = contP$38.sr_ObjectRef__f_elem;
    return this$2.cont__Lfs2_Pull$Terminal__Lfs2_Pull(interruption);
  }
  if ((x170 instanceof $c_Lfs2_Pull$Interrupted)) {
    return x170;
  }
  if ((x170 instanceof $c_Lfs2_Pull$Succeeded)) {
    return interruption;
  }
  if ((x170 instanceof $c_Lfs2_Pull$Fail)) {
    var this$3 = interruption.Lfs2_Pull$Interrupted__f_deferredError.toList__sci_List();
    var elem = x170.Lfs2_Pull$Fail__f_error;
    var errs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedSeqOps__appended__O__O(this$3, elem);
    var this$4 = $m_Lfs2_CompositeFailure$().fromList__sci_List__s_Option(errs);
    var error = (this$4.isEmpty__Z() ? x170.Lfs2_Pull$Fail__f_error : this$4.get__O());
    return new $c_Lfs2_Pull$Fail(error);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x170);
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$_$interruptGuard$1__Lcats_MonadError__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__F1__F0__O = (function(F$11, extendedTopLevelScope$1, translation$tailLocal1$1, runner$tailLocal1$1, extendLastTopLevelScope$2, contP$4, TheBuildR$lzy1$4, scope, view, next) {
  var target = scope.isInterrupted__O();
  var this$8 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F$11);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    if ((x === x$1)) {
      return next.apply__O();
    }
    if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var outcome = x$1.s_Some__f_value;
      matchResult74: {
        var $x_1;
        if ((outcome instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Errored)) {
          var x183 = outcome.Lcats_effect_kernel_Outcome$Errored__f_e;
          var $x_1 = new $c_Lfs2_Pull$Fail(x183);
          break matchResult74;
        }
        if ((outcome instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Canceled)) {
          var context = scope.Lfs2_internal_Scope__f_id;
          var deferredError = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
          var $x_1 = new $c_Lfs2_Pull$Interrupted(context, deferredError);
          break matchResult74;
        }
        if ((outcome instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Succeeded)) {
          var x179 = outcome.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
          var deferredError$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
          var $x_1 = new $c_Lfs2_Pull$Interrupted(x179, deferredError$1);
          break matchResult74;
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(outcome);
      }
      var result = $x_1;
      return this.fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(F$11, extendLastTopLevelScope$2, contP$4, TheBuildR$lzy1$4, scope, extendedTopLevelScope$1, translation$tailLocal1$1, runner$tailLocal1$1, view.apply__O__O(result));
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  }));
  return this$8.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$8.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$_$goErr$1__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__jl_Throwable__F1__O = (function(scope$4, extendedTopLevelScope$3, translation$tailLocal1$3, runner$tailLocal1$3, F$13, extendLastTopLevelScope$4, contP$6, TheBuildR$lzy1$6, err, view) {
  return this.fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(F$13, extendLastTopLevelScope$4, contP$6, TheBuildR$lzy1$6, scope$4, extendedTopLevelScope$3, translation$tailLocal1$3, runner$tailLocal1$3, view.apply__O__O(new $c_Lfs2_Pull$Fail(err)));
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$_$endScope$1__Lcats_effect_kernel_Unique$Token__Lfs2_Pull$Terminal__Lfs2_Pull = (function(scopeId, result) {
  matchResult84: {
    var $x_1;
    if ((result instanceof $c_Lfs2_Pull$Succeeded)) {
      var $x_1 = new $c_Lfs2_Pull$SucceedScope(scopeId);
      break matchResult84;
    }
    if ((result instanceof $c_Lfs2_Pull$Interrupted)) {
      var $x_1 = new $c_Lfs2_Pull$CanceledScope(scopeId, result);
      break matchResult84;
    }
    if ((result instanceof $c_Lfs2_Pull$Fail)) {
      var x261 = result.Lfs2_Pull$Fail__f_error;
      var $x_1 = new $c_Lfs2_Pull$FailedScope(scopeId, x261);
      break matchResult84;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(result);
  }
  return $x_1;
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O = (function(F$10, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3, scope, extendedTopLevelScope, translation, runner, stream) {
  var stream$tailLocal1 = stream;
  var runner$tailLocal1 = runner;
  var translation$tailLocal1 = translation;
  while (true) {
    var x300 = this.fs2$Pull$$$_$viewL$1__sr_ObjectRef__Lfs2_Pull__Lfs2_Pull$ViewL(contP$3, stream$tailLocal1);
    if ((x300 instanceof $c_Lfs2_Pull$Translate)) {
      var translateRunner = new $c_Lfs2_Pull$TranslateRunner$1(extendedTopLevelScope, translation$tailLocal1, runner$tailLocal1, scope, F$10, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3, x300.Lfs2_Pull$Translate__f_fk, contP$3.sr_ObjectRef__f_elem);
      var this$1 = translation$tailLocal1;
      var f = x300.Lfs2_Pull$Translate__f_fk;
      var composed = new $c_Lcats_arrow_FunctionK$$anon$1(f, this$1);
      var stream$tailLocal1$tmp1 = x300.Lfs2_Pull$Translate__f_stream;
      translation$tailLocal1 = composed;
      runner$tailLocal1 = translateRunner;
      stream$tailLocal1 = stream$tailLocal1$tmp1;
      continue;
    }
    if ((x300 instanceof $c_Lfs2_Pull$Output)) {
      var view = contP$3.sr_ObjectRef__f_elem;
      var $x_2 = translation$tailLocal1;
      var $x_1 = runner$tailLocal1;
      var runner$tailLocal1$2$1 = runner$tailLocal1;
      return this.fs2$Pull$$$_$interruptGuard$1__Lcats_MonadError__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__F1__F0__O(F$10, extendedTopLevelScope, $x_2, $x_1, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3, scope, view, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((runner$tailLocal1$2, output$2, scope, view) => (() => {
        var $x_3 = output$2.Lfs2_Pull$Output__f_values;
        var x0 = $m_Lfs2_Pull$().Lfs2_Pull$__f_fs2$Pull$$$unit;
        return runner$tailLocal1$2.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O($x_3, scope, view.cont__Lfs2_Pull$Terminal__Lfs2_Pull(x0));
      }))(runner$tailLocal1$2$1, x300, scope, view)));
    }
    if ((x300 instanceof $c_Lfs2_Pull$FlatMapOutput)) {
      var fmrunr = new $c_Lfs2_Pull$FlatMapR$1(extendedTopLevelScope, translation$tailLocal1, runner$tailLocal1, scope, contP$3, F$10, extendLastTopLevelScope$1, TheBuildR$lzy1$3, contP$3.sr_ObjectRef__f_elem, x300.Lfs2_Pull$FlatMapOutput__f_fun);
      var fa = F$10.unit__O();
      var $x_4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_syntax_FlatMapOps$();
      var translation$tailLocal1$2$1 = translation$tailLocal1;
      return $x_4.$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((scope, extendedTopLevelScope, translation$tailLocal1$2, fmrunr, fmout$2, F$10, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3) => (() => this.fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(F$10, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3, scope, extendedTopLevelScope, translation$tailLocal1$2, fmrunr, fmout$2.Lfs2_Pull$FlatMapOutput__f_stream)))(scope, extendedTopLevelScope, translation$tailLocal1$2$1, fmrunr, x300, F$10, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3)), F$10);
    }
    if ((x300 instanceof $c_Lfs2_Pull$Uncons)) {
      var v = contP$3.sr_ObjectRef__f_elem;
      var runr = $p_Lfs2_Pull$__TheBuildR$1__sr_LazyRef__Lcats_MonadError__Lfs2_Pull$TheBuildR$2$(this, TheBuildR$lzy1$3, F$10);
      var fa$1 = F$10.unit__O();
      var $x_5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_syntax_FlatMapOps$();
      var translation$tailLocal1$3$1 = translation$tailLocal1;
      var runner$tailLocal1$3$1 = runner$tailLocal1;
      return $x_5.$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa$1, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((scope, extendedTopLevelScope, translation$tailLocal1$3, runr, u$2, F$10, v, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3, runner$tailLocal1$3) => (() => {
        var fa$2 = this.fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(F$10, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3, scope, extendedTopLevelScope, translation$tailLocal1$3, runr, u$2.Lfs2_Pull$Uncons__f_stream);
        var target = F$10.attempt__O__O(fa$2);
        var this$8 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F$10);
        var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$74) => {
          if ((_$74 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
            var b = _$74.s_util_Right__f_value;
            return b.apply__O__O(new $c_Lfs2_Pull$UnconsRunR$1(extendedTopLevelScope, translation$tailLocal1$3, runner$tailLocal1$3, scope, F$10, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3, this, v));
          } else if ((_$74 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
            var a = _$74.s_util_Left__f_value;
            return this.fs2$Pull$$$_$goErr$1__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__jl_Throwable__F1__O(scope, extendedTopLevelScope, translation$tailLocal1$3, runner$tailLocal1$3, F$10, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3, a, v);
          } else {
            throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(_$74);
          }
        }));
        return this$8.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$8.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
      }))(scope, extendedTopLevelScope, translation$tailLocal1$3$1, runr, x300, F$10, v, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3, runner$tailLocal1$3$1)), F$10);
    }
    if (false) {
      var v$3 = contP$3.sr_ObjectRef__f_elem;
      var runr$3 = $p_Lfs2_Pull$__TheBuildR$1__sr_LazyRef__Lcats_MonadError__Lfs2_Pull$TheBuildR$2$(this, TheBuildR$lzy1$3, F$10);
      var target$1 = scope.shiftScope__Lcats_effect_kernel_Unique$Token__F0__O(x300.scope__Lcats_effect_kernel_Unique$Token(), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((s$2) => (() => s$2.toString__T()))(x300)));
      var this$12 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, F$10);
      var translation$tailLocal1$4$1 = translation$tailLocal1;
      var f$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((extendedTopLevelScope, translation$tailLocal1$4, runr$3, s$3, F$10, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3) => ((_$77) => {
        var fa$3 = this.fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(F$10, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3, _$77, extendedTopLevelScope, translation$tailLocal1$4, runr$3, s$3.stream__Lfs2_Pull());
        return F$10.attempt__O__O(fa$3);
      }))(extendedTopLevelScope, translation$tailLocal1$4$1, runr$3, x300, F$10, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3));
      var target$2 = this$12.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$12.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
      var this$14 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, F$10);
      var translation$tailLocal1$5$1 = translation$tailLocal1;
      var runner$tailLocal1$4$1 = runner$tailLocal1;
      var f$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((v$3, scope, extendedTopLevelScope, translation$tailLocal1$5, runner$tailLocal1$4, F$10, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3) => ((_$78) => {
        if ((_$78 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
          var b$1 = _$78.s_util_Right__f_value;
          return b$1.apply__O__O(new $c_Lfs2_Pull$StepLegRunR$1(scope, extendedTopLevelScope, translation$tailLocal1$5, runner$tailLocal1$4, F$10, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3, this, v$3));
        } else if ((_$78 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
          var a$1 = _$78.s_util_Left__f_value;
          return this.fs2$Pull$$$_$goErr$1__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__jl_Throwable__F1__O(scope, extendedTopLevelScope, translation$tailLocal1$5, runner$tailLocal1$4, F$10, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3, a$1, v$3);
        } else {
          throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(_$78);
        }
      }))(v$3, scope, extendedTopLevelScope, translation$tailLocal1$5$1, runner$tailLocal1$4$1, F$10, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3));
      return this$14.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$14.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
    }
    if (false) {
      var this$16 = contP$3.sr_ObjectRef__f_elem;
      var x0$1 = new $c_Lfs2_Pull$Succeeded(scope);
      stream$tailLocal1 = this$16.cont__Lfs2_Pull$Terminal__Lfs2_Pull(x0$1);
      continue;
    }
    if ((x300 instanceof $c_Lfs2_Pull$Eval)) {
      return $p_Lfs2_Pull$__goEval$1__Lfs2_internal_Scope__Lcats_arrow_FunctionK__Lcats_MonadError__s_Option__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_Pull$Eval__F1__O(this, scope, translation$tailLocal1, F$10, extendedTopLevelScope, runner$tailLocal1, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3, x300, contP$3.sr_ObjectRef__f_elem);
    }
    if ((x300 instanceof $c_Lfs2_Pull$Acquire)) {
      return $p_Lfs2_Pull$__goAcquire$1__Lfs2_internal_Scope__Lcats_arrow_FunctionK__Lcats_MonadError__s_Option__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_Pull$Acquire__F1__O(this, scope, translation$tailLocal1, F$10, extendedTopLevelScope, runner$tailLocal1, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3, x300, contP$3.sr_ObjectRef__f_elem);
    }
    if ((x300 instanceof $c_Lfs2_Pull$InScope)) {
      return $p_Lfs2_Pull$__goInScope$1__Lfs2_internal_Scope__s_Option__Lcats_MonadError__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_Pull__Z__F1__O(this, scope, extendedTopLevelScope, F$10, translation$tailLocal1, runner$tailLocal1, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3, x300.Lfs2_Pull$InScope__f_stream, x300.Lfs2_Pull$InScope__f_useInterruption, contP$3.sr_ObjectRef__f_elem);
    }
    if ((x300 instanceof $c_Lfs2_Pull$InterruptWhen)) {
      return $p_Lfs2_Pull$__goInterruptWhen$1__Lfs2_internal_Scope__Lcats_MonadError__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__O__F1__O(this, scope, F$10, extendedTopLevelScope, translation$tailLocal1, runner$tailLocal1, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3, translation$tailLocal1.apply__O__O(x300.Lfs2_Pull$InterruptWhen__f_haltOnSignal), contP$3.sr_ObjectRef__f_elem);
    }
    if ((x300 instanceof $c_Lfs2_Pull$CloseScope)) {
      return $p_Lfs2_Pull$__goCloseScope$1__Lfs2_internal_Scope__Lcats_MonadError__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_Pull$CloseScope__F1__O(this, scope, F$10, extendedTopLevelScope, translation$tailLocal1, runner$tailLocal1, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3, x300, contP$3.sr_ObjectRef__f_elem);
    }
    if ((x300 instanceof $c_Lfs2_Pull$Succeeded)) {
      return runner$tailLocal1.done__Lfs2_internal_Scope__O(scope);
    }
    if ((x300 instanceof $c_Lfs2_Pull$Fail)) {
      return runner$tailLocal1.fail__jl_Throwable__O(x300.Lfs2_Pull$Fail__f_error);
    }
    if ((x300 instanceof $c_Lfs2_Pull$Interrupted)) {
      return runner$tailLocal1.interrupted__Lfs2_Pull$Interrupted__O(x300);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x300);
  }
});
var $d_Lfs2_Pull$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$, "fs2.Pull$", ({
  Lfs2_Pull$: 1,
  Lfs2_PullLowPriority: 1
}));
export { $d_Lfs2_Pull$ as $d_Lfs2_Pull$ };
var $n_Lfs2_Pull$;
function $m_Lfs2_Pull$() {
  if ((!$n_Lfs2_Pull$)) {
    $n_Lfs2_Pull$ = new $c_Lfs2_Pull$();
  }
  return $n_Lfs2_Pull$;
}
export { $m_Lfs2_Pull$ as $m_Lfs2_Pull$ };
function $p_Lfs2_Pull$FlatMapR$1__unconsed__Lfs2_Chunk__Lfs2_Pull__Lfs2_Pull($thiz, chunk, tail) {
  if (((chunk.size__I() === 1) && (tail instanceof $c_Lfs2_Pull$Succeeded))) {
    try {
      return $thiz.Lfs2_Pull$FlatMapR$1__f_fun.apply__O__O(chunk.apply__I__O(0));
    } catch (e) {
      var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
      var x190 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
      if ((!x190.isEmpty__Z())) {
        var x191 = x190.get__O();
        return new $c_Lfs2_Pull$Fail(x191);
      }
      throw ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  } else {
    return $p_Lfs2_Pull$FlatMapR$1__go$2__Lfs2_Chunk__Lfs2_Pull__I__Lfs2_Pull($thiz, chunk, tail, 0);
  }
}
export { $p_Lfs2_Pull$FlatMapR$1__unconsed__Lfs2_Chunk__Lfs2_Pull__Lfs2_Pull as $p_Lfs2_Pull$FlatMapR$1__unconsed__Lfs2_Chunk__Lfs2_Pull__Lfs2_Pull };
function $p_Lfs2_Pull$FlatMapR$1__loop$1__Lfs2_Chunk__sr_IntRef__Lfs2_Pull($thiz, chunk$2, j$1) {
  while (true) {
    var x193 = $thiz.Lfs2_Pull$FlatMapR$1__f_fun.apply__O__O(chunk$2.apply__I__O(j$1.sr_IntRef__f_elem));
    if ((x193 instanceof $c_Lfs2_Pull$Succeeded)) {
      if ((j$1.sr_IntRef__f_elem < (((-1) + chunk$2.size__I()) | 0))) {
        j$1.sr_IntRef__f_elem = ((1 + j$1.sr_IntRef__f_elem) | 0);
        continue;
      }
    }
    return x193;
  }
}
export { $p_Lfs2_Pull$FlatMapR$1__loop$1__Lfs2_Chunk__sr_IntRef__Lfs2_Pull as $p_Lfs2_Pull$FlatMapR$1__loop$1__Lfs2_Chunk__sr_IntRef__Lfs2_Pull };
function $p_Lfs2_Pull$FlatMapR$1__go$2__Lfs2_Chunk__Lfs2_Pull__I__Lfs2_Pull($thiz, chunk$1, tail$4, idx) {
  if ((idx === chunk$1.size__I())) {
    $m_Lfs2_Pull$();
    return $m_Lfs2_Pull$StreamPullOps$().flatMapOutput$extension__Lfs2_Pull__F1__Lfs2_Pull(tail$4, $thiz.Lfs2_Pull$FlatMapR$1__f_fun);
  } else {
    try {
      var j = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_IntRef(idx);
      var next = $p_Lfs2_Pull$FlatMapR$1__loop$1__Lfs2_Chunk__sr_IntRef__Lfs2_Pull($thiz, chunk$1, j);
      return $m_Lfs2_Pull$().fs2$Pull$$$transformWith__Lfs2_Pull__F1__Lfs2_Pull(next, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
        if ((x$1 instanceof $c_Lfs2_Pull$Succeeded)) {
          return $p_Lfs2_Pull$FlatMapR$1__go$2__Lfs2_Chunk__Lfs2_Pull__I__Lfs2_Pull($thiz, chunk$1, tail$4, ((1 + j.sr_IntRef__f_elem) | 0));
        }
        if ((x$1 instanceof $c_Lfs2_Pull$Fail)) {
          var x204 = x$1.Lfs2_Pull$Fail__f_error;
          return new $c_Lfs2_Pull$Fail(x204);
        }
        if ((x$1 instanceof $c_Lfs2_Pull$Interrupted)) {
          $m_Lfs2_Pull$();
          var self = $m_Lfs2_Pull$().fs2$Pull$$$_$interruptBoundary$1__sr_ObjectRef__Lfs2_Pull__Lfs2_Pull$Interrupted__Lfs2_Pull($thiz.Lfs2_Pull$FlatMapR$1__f_contP$13, tail$4, x$1);
          return $m_Lfs2_Pull$StreamPullOps$().flatMapOutput$extension__Lfs2_Pull__F1__Lfs2_Pull(self, $thiz.Lfs2_Pull$FlatMapR$1__f_fun);
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
      })));
    } catch (e) {
      var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
      var x209 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
      if ((!x209.isEmpty__Z())) {
        var x210 = x209.get__O();
        return new $c_Lfs2_Pull$Fail(x210);
      }
      throw ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  }
}
export { $p_Lfs2_Pull$FlatMapR$1__go$2__Lfs2_Chunk__Lfs2_Pull__I__Lfs2_Pull as $p_Lfs2_Pull$FlatMapR$1__go$2__Lfs2_Chunk__Lfs2_Pull__I__Lfs2_Pull };
/** @constructor */
function $c_Lfs2_Pull$FlatMapR$1(extendedTopLevelScope$37, translation$tailLocal1$40, runner$tailLocal1$37, scope$39, contP$43, F$53, extendLastTopLevelScope$40, TheBuildR$lzy1$43, view, fun) {
  this.Lfs2_Pull$FlatMapR$1__f_extendedTopLevelScope$10 = null;
  this.Lfs2_Pull$FlatMapR$1__f_translation$tailLocal1$10 = null;
  this.Lfs2_Pull$FlatMapR$1__f_runner$tailLocal1$10 = null;
  this.Lfs2_Pull$FlatMapR$1__f_scope$13 = null;
  this.Lfs2_Pull$FlatMapR$1__f_contP$13 = null;
  this.Lfs2_Pull$FlatMapR$1__f_F$20 = null;
  this.Lfs2_Pull$FlatMapR$1__f_extendLastTopLevelScope$11 = false;
  this.Lfs2_Pull$FlatMapR$1__f_TheBuildR$lzy1$13 = null;
  this.Lfs2_Pull$FlatMapR$1__f_view = null;
  this.Lfs2_Pull$FlatMapR$1__f_fun = null;
  this.Lfs2_Pull$FlatMapR$1__f_extendedTopLevelScope$10 = extendedTopLevelScope$37;
  this.Lfs2_Pull$FlatMapR$1__f_translation$tailLocal1$10 = translation$tailLocal1$40;
  this.Lfs2_Pull$FlatMapR$1__f_runner$tailLocal1$10 = runner$tailLocal1$37;
  this.Lfs2_Pull$FlatMapR$1__f_scope$13 = scope$39;
  this.Lfs2_Pull$FlatMapR$1__f_contP$13 = contP$43;
  this.Lfs2_Pull$FlatMapR$1__f_F$20 = F$53;
  this.Lfs2_Pull$FlatMapR$1__f_extendLastTopLevelScope$11 = extendLastTopLevelScope$40;
  this.Lfs2_Pull$FlatMapR$1__f_TheBuildR$lzy1$13 = TheBuildR$lzy1$43;
  this.Lfs2_Pull$FlatMapR$1__f_view = view;
  this.Lfs2_Pull$FlatMapR$1__f_fun = fun;
}
export { $c_Lfs2_Pull$FlatMapR$1 as $c_Lfs2_Pull$FlatMapR$1 };
$c_Lfs2_Pull$FlatMapR$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_Pull$FlatMapR$1.prototype.constructor = $c_Lfs2_Pull$FlatMapR$1;
/** @constructor */
function $h_Lfs2_Pull$FlatMapR$1() {
}
export { $h_Lfs2_Pull$FlatMapR$1 as $h_Lfs2_Pull$FlatMapR$1 };
$h_Lfs2_Pull$FlatMapR$1.prototype = $c_Lfs2_Pull$FlatMapR$1.prototype;
$c_Lfs2_Pull$FlatMapR$1.prototype.done__Lfs2_internal_Scope__O = (function(scope) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$interruptGuard$1__Lcats_MonadError__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__F1__F0__O(this.Lfs2_Pull$FlatMapR$1__f_F$20, this.Lfs2_Pull$FlatMapR$1__f_extendedTopLevelScope$10, this.Lfs2_Pull$FlatMapR$1__f_translation$tailLocal1$10, this.Lfs2_Pull$FlatMapR$1__f_runner$tailLocal1$10, this.Lfs2_Pull$FlatMapR$1__f_extendLastTopLevelScope$11, this.Lfs2_Pull$FlatMapR$1__f_contP$13, this.Lfs2_Pull$FlatMapR$1__f_TheBuildR$lzy1$13, scope, this.Lfs2_Pull$FlatMapR$1__f_view, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$FlatMapR$1__f_F$20, this.Lfs2_Pull$FlatMapR$1__f_extendLastTopLevelScope$11, this.Lfs2_Pull$FlatMapR$1__f_contP$13, this.Lfs2_Pull$FlatMapR$1__f_TheBuildR$lzy1$13, scope, this.Lfs2_Pull$FlatMapR$1__f_extendedTopLevelScope$10, this.Lfs2_Pull$FlatMapR$1__f_translation$tailLocal1$10, this.Lfs2_Pull$FlatMapR$1__f_runner$tailLocal1$10, this.Lfs2_Pull$FlatMapR$1__f_view.apply__O__O($m_Lfs2_Pull$().Lfs2_Pull$__f_fs2$Pull$$$unit)))));
});
$c_Lfs2_Pull$FlatMapR$1.prototype.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O = (function(head, outScope, tail) {
  var next = $m_Lfs2_Pull$().fs2$Pull$$$bindView__Lfs2_Pull__F1__Lfs2_Pull($p_Lfs2_Pull$FlatMapR$1__unconsed__Lfs2_Chunk__Lfs2_Pull__Lfs2_Pull(this, head, tail), this.Lfs2_Pull$FlatMapR$1__f_view);
  return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$FlatMapR$1__f_F$20, this.Lfs2_Pull$FlatMapR$1__f_extendLastTopLevelScope$11, this.Lfs2_Pull$FlatMapR$1__f_contP$13, this.Lfs2_Pull$FlatMapR$1__f_TheBuildR$lzy1$13, outScope, this.Lfs2_Pull$FlatMapR$1__f_extendedTopLevelScope$10, this.Lfs2_Pull$FlatMapR$1__f_translation$tailLocal1$10, this.Lfs2_Pull$FlatMapR$1__f_runner$tailLocal1$10, next);
});
$c_Lfs2_Pull$FlatMapR$1.prototype.interrupted__Lfs2_Pull$Interrupted__O = (function(inter) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$FlatMapR$1__f_F$20, this.Lfs2_Pull$FlatMapR$1__f_extendLastTopLevelScope$11, this.Lfs2_Pull$FlatMapR$1__f_contP$13, this.Lfs2_Pull$FlatMapR$1__f_TheBuildR$lzy1$13, this.Lfs2_Pull$FlatMapR$1__f_scope$13, this.Lfs2_Pull$FlatMapR$1__f_extendedTopLevelScope$10, this.Lfs2_Pull$FlatMapR$1__f_translation$tailLocal1$10, this.Lfs2_Pull$FlatMapR$1__f_runner$tailLocal1$10, this.Lfs2_Pull$FlatMapR$1__f_view.apply__O__O(inter));
});
$c_Lfs2_Pull$FlatMapR$1.prototype.fail__jl_Throwable__O = (function(e) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$goErr$1__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__jl_Throwable__F1__O(this.Lfs2_Pull$FlatMapR$1__f_scope$13, this.Lfs2_Pull$FlatMapR$1__f_extendedTopLevelScope$10, this.Lfs2_Pull$FlatMapR$1__f_translation$tailLocal1$10, this.Lfs2_Pull$FlatMapR$1__f_runner$tailLocal1$10, this.Lfs2_Pull$FlatMapR$1__f_F$20, this.Lfs2_Pull$FlatMapR$1__f_extendLastTopLevelScope$11, this.Lfs2_Pull$FlatMapR$1__f_contP$13, this.Lfs2_Pull$FlatMapR$1__f_TheBuildR$lzy1$13, e, this.Lfs2_Pull$FlatMapR$1__f_view);
});
var $d_Lfs2_Pull$FlatMapR$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$FlatMapR$1, "fs2.Pull$FlatMapR$1", ({
  Lfs2_Pull$FlatMapR$1: 1,
  Lfs2_Pull$Run$1: 1
}));
export { $d_Lfs2_Pull$FlatMapR$1 as $d_Lfs2_Pull$FlatMapR$1 };
/** @constructor */
function $c_Lfs2_Pull$OuterRun$1(F$54, foldChunk$2, initFk$2, extendLastTopLevelScope$41, contP$44, TheBuildR$lzy1$44, initB) {
  this.Lfs2_Pull$OuterRun$1__f_F$46 = null;
  this.Lfs2_Pull$OuterRun$1__f_foldChunk$1 = null;
  this.Lfs2_Pull$OuterRun$1__f_initFk$1 = null;
  this.Lfs2_Pull$OuterRun$1__f_extendLastTopLevelScope$35 = false;
  this.Lfs2_Pull$OuterRun$1__f_contP$37 = null;
  this.Lfs2_Pull$OuterRun$1__f_TheBuildR$lzy1$37 = null;
  this.Lfs2_Pull$OuterRun$1__f_accB = null;
  this.Lfs2_Pull$OuterRun$1__f_F$46 = F$54;
  this.Lfs2_Pull$OuterRun$1__f_foldChunk$1 = foldChunk$2;
  this.Lfs2_Pull$OuterRun$1__f_initFk$1 = initFk$2;
  this.Lfs2_Pull$OuterRun$1__f_extendLastTopLevelScope$35 = extendLastTopLevelScope$41;
  this.Lfs2_Pull$OuterRun$1__f_contP$37 = contP$44;
  this.Lfs2_Pull$OuterRun$1__f_TheBuildR$lzy1$37 = TheBuildR$lzy1$44;
  this.Lfs2_Pull$OuterRun$1__f_accB = initB;
}
export { $c_Lfs2_Pull$OuterRun$1 as $c_Lfs2_Pull$OuterRun$1 };
$c_Lfs2_Pull$OuterRun$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_Pull$OuterRun$1.prototype.constructor = $c_Lfs2_Pull$OuterRun$1;
/** @constructor */
function $h_Lfs2_Pull$OuterRun$1() {
}
export { $h_Lfs2_Pull$OuterRun$1 as $h_Lfs2_Pull$OuterRun$1 };
$h_Lfs2_Pull$OuterRun$1.prototype = $c_Lfs2_Pull$OuterRun$1.prototype;
$c_Lfs2_Pull$OuterRun$1.prototype.done__Lfs2_internal_Scope__O = (function(scope) {
  return this.Lfs2_Pull$OuterRun$1__f_F$46.pure__O__O(this.Lfs2_Pull$OuterRun$1__f_accB);
});
$c_Lfs2_Pull$OuterRun$1.prototype.fail__jl_Throwable__O = (function(e) {
  return this.Lfs2_Pull$OuterRun$1__f_F$46.raiseError__O__O(e);
});
$c_Lfs2_Pull$OuterRun$1.prototype.interrupted__Lfs2_Pull$Interrupted__O = (function(inter) {
  var this$1 = inter.Lfs2_Pull$Interrupted__f_deferredError;
  if (this$1.isEmpty__Z()) {
    return this.Lfs2_Pull$OuterRun$1__f_F$46.pure__O__O(this.Lfs2_Pull$OuterRun$1__f_accB);
  } else {
    var x0 = this$1.get__O();
    return this.Lfs2_Pull$OuterRun$1__f_F$46.raiseError__O__O(x0);
  }
});
$c_Lfs2_Pull$OuterRun$1.prototype.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O = (function(head, scope, tail) {
  try {
    this.Lfs2_Pull$OuterRun$1__f_accB = this.Lfs2_Pull$OuterRun$1__f_foldChunk$1.apply__O__O__O(this.Lfs2_Pull$OuterRun$1__f_accB, head);
    return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$OuterRun$1__f_F$46, this.Lfs2_Pull$OuterRun$1__f_extendLastTopLevelScope$35, this.Lfs2_Pull$OuterRun$1__f_contP$37, this.Lfs2_Pull$OuterRun$1__f_TheBuildR$lzy1$37, scope, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$(), this.Lfs2_Pull$OuterRun$1__f_initFk$1, this, tail);
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
    var x328 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
    if ((!x328.isEmpty__Z())) {
      var x329 = x328.get__O();
      var x315 = $m_Lfs2_Pull$().fs2$Pull$$$_$viewL$1__sr_ObjectRef__Lfs2_Pull__Lfs2_Pull$ViewL(this.Lfs2_Pull$OuterRun$1__f_contP$37, tail);
      if ((x315 instanceof $c_Lfs2_Pull$Action)) {
        var $x_7 = $m_Lfs2_Pull$();
        var $x_6 = this.Lfs2_Pull$OuterRun$1__f_F$46;
        var $x_5 = this.Lfs2_Pull$OuterRun$1__f_extendLastTopLevelScope$35;
        var $x_4 = this.Lfs2_Pull$OuterRun$1__f_contP$37;
        var $x_3 = this.Lfs2_Pull$OuterRun$1__f_TheBuildR$lzy1$37;
        var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        var $x_1 = this.Lfs2_Pull$OuterRun$1__f_initFk$1;
        $m_Lfs2_Pull$();
        var contP$1 = this.Lfs2_Pull$OuterRun$1__f_contP$37;
        var this$3 = contP$1.sr_ObjectRef__f_elem;
        var x0 = new $c_Lfs2_Pull$Fail(x329);
        return $x_7.fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O($x_6, $x_5, $x_4, $x_3, scope, $x_2, $x_1, this, this$3.cont__Lfs2_Pull$Terminal__Lfs2_Pull(x0));
      }
      if ((x315 instanceof $c_Lfs2_Pull$Succeeded)) {
        return this.Lfs2_Pull$OuterRun$1__f_F$46.raiseError__O__O(x329);
      }
      if ((x315 instanceof $c_Lfs2_Pull$Fail)) {
        var x322 = x315.Lfs2_Pull$Fail__f_error;
        return this.Lfs2_Pull$OuterRun$1__f_F$46.raiseError__O__O($m_Lfs2_CompositeFailure$().apply__jl_Throwable__jl_Throwable__sci_List__Lfs2_CompositeFailure(x322, x329, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$()));
      }
      if ((x315 instanceof $c_Lfs2_Pull$Interrupted)) {
        var x319 = x315.Lfs2_Pull$Interrupted__f_deferredError;
        var $x_9 = this.Lfs2_Pull$OuterRun$1__f_F$46;
        if (x319.isEmpty__Z()) {
          var $x_8 = x329;
        } else {
          var x0$1 = x319.get__O();
          var $x_8 = $m_Lfs2_CompositeFailure$().apply__jl_Throwable__jl_Throwable__sci_List__Lfs2_CompositeFailure(x329, x0$1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
        }
        return $x_9.raiseError__O__O($x_8);
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x315);
    }
    throw ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
  }
});
var $d_Lfs2_Pull$OuterRun$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$OuterRun$1, "fs2.Pull$OuterRun$1", ({
  Lfs2_Pull$OuterRun$1: 1,
  Lfs2_Pull$Run$1: 1
}));
export { $d_Lfs2_Pull$OuterRun$1 as $d_Lfs2_Pull$OuterRun$1 };
function $ct_Lfs2_Pull$StepRunR$1__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_internal_Scope__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__F1__($thiz, extendedTopLevelScope$34, translation$tailLocal1$37, runner$tailLocal1$34, scope$36, F$50, extendLastTopLevelScope$37, contP$40, TheBuildR$lzy1$40, view) {
  $thiz.Lfs2_Pull$StepRunR$1__f_extendedTopLevelScope$7 = extendedTopLevelScope$34;
  $thiz.Lfs2_Pull$StepRunR$1__f_translation$tailLocal1$7 = translation$tailLocal1$37;
  $thiz.Lfs2_Pull$StepRunR$1__f_runner$tailLocal1$7 = runner$tailLocal1$34;
  $thiz.Lfs2_Pull$StepRunR$1__f_scope$10 = scope$36;
  $thiz.Lfs2_Pull$StepRunR$1__f_F$17 = F$50;
  $thiz.Lfs2_Pull$StepRunR$1__f_extendLastTopLevelScope$8 = extendLastTopLevelScope$37;
  $thiz.Lfs2_Pull$StepRunR$1__f_contP$10 = contP$40;
  $thiz.Lfs2_Pull$StepRunR$1__f_TheBuildR$lzy1$10 = TheBuildR$lzy1$40;
  $thiz.Lfs2_Pull$StepRunR$1__f_view = view;
  return $thiz;
}
export { $ct_Lfs2_Pull$StepRunR$1__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_internal_Scope__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__F1__ as $ct_Lfs2_Pull$StepRunR$1__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_internal_Scope__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__F1__ };
/** @constructor */
function $c_Lfs2_Pull$StepRunR$1() {
  this.Lfs2_Pull$StepRunR$1__f_extendedTopLevelScope$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_translation$tailLocal1$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_runner$tailLocal1$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_scope$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_F$17 = null;
  this.Lfs2_Pull$StepRunR$1__f_extendLastTopLevelScope$8 = false;
  this.Lfs2_Pull$StepRunR$1__f_contP$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_TheBuildR$lzy1$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_view = null;
}
export { $c_Lfs2_Pull$StepRunR$1 as $c_Lfs2_Pull$StepRunR$1 };
$c_Lfs2_Pull$StepRunR$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_Pull$StepRunR$1.prototype.constructor = $c_Lfs2_Pull$StepRunR$1;
/** @constructor */
function $h_Lfs2_Pull$StepRunR$1() {
}
export { $h_Lfs2_Pull$StepRunR$1 as $h_Lfs2_Pull$StepRunR$1 };
$h_Lfs2_Pull$StepRunR$1.prototype = $c_Lfs2_Pull$StepRunR$1.prototype;
$c_Lfs2_Pull$StepRunR$1.prototype.done__Lfs2_internal_Scope__O = (function(scope) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$interruptGuard$1__Lcats_MonadError__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__F1__F0__O(this.Lfs2_Pull$StepRunR$1__f_F$17, this.Lfs2_Pull$StepRunR$1__f_extendedTopLevelScope$7, this.Lfs2_Pull$StepRunR$1__f_translation$tailLocal1$7, this.Lfs2_Pull$StepRunR$1__f_runner$tailLocal1$7, this.Lfs2_Pull$StepRunR$1__f_extendLastTopLevelScope$8, this.Lfs2_Pull$StepRunR$1__f_contP$10, this.Lfs2_Pull$StepRunR$1__f_TheBuildR$lzy1$10, scope, this.Lfs2_Pull$StepRunR$1__f_view, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    var $x_9 = $m_Lfs2_Pull$();
    var $x_8 = this.Lfs2_Pull$StepRunR$1__f_F$17;
    var $x_7 = this.Lfs2_Pull$StepRunR$1__f_extendLastTopLevelScope$8;
    var $x_6 = this.Lfs2_Pull$StepRunR$1__f_contP$10;
    var $x_5 = this.Lfs2_Pull$StepRunR$1__f_TheBuildR$lzy1$10;
    var $x_4 = this.Lfs2_Pull$StepRunR$1__f_extendedTopLevelScope$7;
    var $x_3 = this.Lfs2_Pull$StepRunR$1__f_translation$tailLocal1$7;
    var $x_2 = this.Lfs2_Pull$StepRunR$1__f_runner$tailLocal1$7;
    var $x_1 = this.Lfs2_Pull$StepRunR$1__f_view;
    var r = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    return $x_9.fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O($x_8, $x_7, $x_6, $x_5, scope, $x_4, $x_3, $x_2, $x_1.apply__O__O(new $c_Lfs2_Pull$Succeeded(r)));
  })));
});
$c_Lfs2_Pull$StepRunR$1.prototype.interrupted__Lfs2_Pull$Interrupted__O = (function(inter) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$StepRunR$1__f_F$17, this.Lfs2_Pull$StepRunR$1__f_extendLastTopLevelScope$8, this.Lfs2_Pull$StepRunR$1__f_contP$10, this.Lfs2_Pull$StepRunR$1__f_TheBuildR$lzy1$10, this.Lfs2_Pull$StepRunR$1__f_scope$10, this.Lfs2_Pull$StepRunR$1__f_extendedTopLevelScope$7, this.Lfs2_Pull$StepRunR$1__f_translation$tailLocal1$7, this.Lfs2_Pull$StepRunR$1__f_runner$tailLocal1$7, this.Lfs2_Pull$StepRunR$1__f_view.apply__O__O(inter));
});
$c_Lfs2_Pull$StepRunR$1.prototype.fail__jl_Throwable__O = (function(e) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$goErr$1__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__jl_Throwable__F1__O(this.Lfs2_Pull$StepRunR$1__f_scope$10, this.Lfs2_Pull$StepRunR$1__f_extendedTopLevelScope$7, this.Lfs2_Pull$StepRunR$1__f_translation$tailLocal1$7, this.Lfs2_Pull$StepRunR$1__f_runner$tailLocal1$7, this.Lfs2_Pull$StepRunR$1__f_F$17, this.Lfs2_Pull$StepRunR$1__f_extendLastTopLevelScope$8, this.Lfs2_Pull$StepRunR$1__f_contP$10, this.Lfs2_Pull$StepRunR$1__f_TheBuildR$lzy1$10, e, this.Lfs2_Pull$StepRunR$1__f_view);
});
/** @constructor */
function $c_Lfs2_Pull$TheBuildR$2$(F$47) {
  this.Lfs2_Pull$TheBuildR$2$__f_F$9 = null;
  this.Lfs2_Pull$TheBuildR$2$__f_F$9 = F$47;
}
export { $c_Lfs2_Pull$TheBuildR$2$ as $c_Lfs2_Pull$TheBuildR$2$ };
$c_Lfs2_Pull$TheBuildR$2$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_Pull$TheBuildR$2$.prototype.constructor = $c_Lfs2_Pull$TheBuildR$2$;
/** @constructor */
function $h_Lfs2_Pull$TheBuildR$2$() {
}
export { $h_Lfs2_Pull$TheBuildR$2$ as $h_Lfs2_Pull$TheBuildR$2$ };
$h_Lfs2_Pull$TheBuildR$2$.prototype = $c_Lfs2_Pull$TheBuildR$2$.prototype;
$c_Lfs2_Pull$TheBuildR$2$.prototype.fail__jl_Throwable__O = (function(e) {
  return this.Lfs2_Pull$TheBuildR$2$__f_F$9.raiseError__O__O(e);
});
$c_Lfs2_Pull$TheBuildR$2$.prototype.done__Lfs2_internal_Scope__O = (function(scope) {
  return this.Lfs2_Pull$TheBuildR$2$__f_F$9.pure__O__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$62) => _$62.done__Lfs2_internal_Scope__O(scope))));
});
$c_Lfs2_Pull$TheBuildR$2$.prototype.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O = (function(head, scope, tail) {
  return this.Lfs2_Pull$TheBuildR$2$__f_F$9.pure__O__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$63) => _$63.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O(head, scope, tail))));
});
$c_Lfs2_Pull$TheBuildR$2$.prototype.interrupted__Lfs2_Pull$Interrupted__O = (function(i) {
  return this.Lfs2_Pull$TheBuildR$2$__f_F$9.pure__O__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$64) => _$64.interrupted__Lfs2_Pull$Interrupted__O(i))));
});
var $d_Lfs2_Pull$TheBuildR$2$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$TheBuildR$2$, "fs2.Pull$TheBuildR$2$", ({
  Lfs2_Pull$TheBuildR$2$: 1,
  Lfs2_Pull$Run$1: 1
}));
export { $d_Lfs2_Pull$TheBuildR$2$ as $d_Lfs2_Pull$TheBuildR$2$ };
/** @constructor */
function $c_Lfs2_Pull$TranslateRunner$1(extendedTopLevelScope$33, translation$tailLocal1$36, runner$tailLocal1$33, scope$35, F$49, extendLastTopLevelScope$36, contP$39, TheBuildR$lzy1$39, fk, view) {
  this.Lfs2_Pull$TranslateRunner$1__f_extendedTopLevelScope$6 = null;
  this.Lfs2_Pull$TranslateRunner$1__f_translation$tailLocal1$6 = null;
  this.Lfs2_Pull$TranslateRunner$1__f_runner$tailLocal1$6 = null;
  this.Lfs2_Pull$TranslateRunner$1__f_scope$8 = null;
  this.Lfs2_Pull$TranslateRunner$1__f_F$16 = null;
  this.Lfs2_Pull$TranslateRunner$1__f_extendLastTopLevelScope$7 = false;
  this.Lfs2_Pull$TranslateRunner$1__f_contP$9 = null;
  this.Lfs2_Pull$TranslateRunner$1__f_TheBuildR$lzy1$9 = null;
  this.Lfs2_Pull$TranslateRunner$1__f_fk = null;
  this.Lfs2_Pull$TranslateRunner$1__f_view = null;
  this.Lfs2_Pull$TranslateRunner$1__f_extendedTopLevelScope$6 = extendedTopLevelScope$33;
  this.Lfs2_Pull$TranslateRunner$1__f_translation$tailLocal1$6 = translation$tailLocal1$36;
  this.Lfs2_Pull$TranslateRunner$1__f_runner$tailLocal1$6 = runner$tailLocal1$33;
  this.Lfs2_Pull$TranslateRunner$1__f_scope$8 = scope$35;
  this.Lfs2_Pull$TranslateRunner$1__f_F$16 = F$49;
  this.Lfs2_Pull$TranslateRunner$1__f_extendLastTopLevelScope$7 = extendLastTopLevelScope$36;
  this.Lfs2_Pull$TranslateRunner$1__f_contP$9 = contP$39;
  this.Lfs2_Pull$TranslateRunner$1__f_TheBuildR$lzy1$9 = TheBuildR$lzy1$39;
  this.Lfs2_Pull$TranslateRunner$1__f_fk = fk;
  this.Lfs2_Pull$TranslateRunner$1__f_view = view;
}
export { $c_Lfs2_Pull$TranslateRunner$1 as $c_Lfs2_Pull$TranslateRunner$1 };
$c_Lfs2_Pull$TranslateRunner$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_Pull$TranslateRunner$1.prototype.constructor = $c_Lfs2_Pull$TranslateRunner$1;
/** @constructor */
function $h_Lfs2_Pull$TranslateRunner$1() {
}
export { $h_Lfs2_Pull$TranslateRunner$1 as $h_Lfs2_Pull$TranslateRunner$1 };
$h_Lfs2_Pull$TranslateRunner$1.prototype = $c_Lfs2_Pull$TranslateRunner$1.prototype;
$c_Lfs2_Pull$TranslateRunner$1.prototype.done__Lfs2_internal_Scope__O = (function(doneScope) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$TranslateRunner$1__f_F$16, this.Lfs2_Pull$TranslateRunner$1__f_extendLastTopLevelScope$7, this.Lfs2_Pull$TranslateRunner$1__f_contP$9, this.Lfs2_Pull$TranslateRunner$1__f_TheBuildR$lzy1$9, doneScope, this.Lfs2_Pull$TranslateRunner$1__f_extendedTopLevelScope$6, this.Lfs2_Pull$TranslateRunner$1__f_translation$tailLocal1$6, this.Lfs2_Pull$TranslateRunner$1__f_runner$tailLocal1$6, this.Lfs2_Pull$TranslateRunner$1__f_view.apply__O__O($m_Lfs2_Pull$().Lfs2_Pull$__f_fs2$Pull$$$unit));
});
$c_Lfs2_Pull$TranslateRunner$1.prototype.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O = (function(head, scope, tail) {
  var $x_1 = $m_Lfs2_Pull$();
  var fk = this.Lfs2_Pull$TranslateRunner$1__f_fk;
  var next = $x_1.fs2$Pull$$$bindView__Lfs2_Pull__F1__Lfs2_Pull(new $c_Lfs2_Pull$Translate(tail, fk), this.Lfs2_Pull$TranslateRunner$1__f_view);
  return this.Lfs2_Pull$TranslateRunner$1__f_runner$tailLocal1$6.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O(head, scope, next);
});
$c_Lfs2_Pull$TranslateRunner$1.prototype.interrupted__Lfs2_Pull$Interrupted__O = (function(inter) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$TranslateRunner$1__f_F$16, this.Lfs2_Pull$TranslateRunner$1__f_extendLastTopLevelScope$7, this.Lfs2_Pull$TranslateRunner$1__f_contP$9, this.Lfs2_Pull$TranslateRunner$1__f_TheBuildR$lzy1$9, this.Lfs2_Pull$TranslateRunner$1__f_scope$8, this.Lfs2_Pull$TranslateRunner$1__f_extendedTopLevelScope$6, this.Lfs2_Pull$TranslateRunner$1__f_translation$tailLocal1$6, this.Lfs2_Pull$TranslateRunner$1__f_runner$tailLocal1$6, this.Lfs2_Pull$TranslateRunner$1__f_view.apply__O__O(inter));
});
$c_Lfs2_Pull$TranslateRunner$1.prototype.fail__jl_Throwable__O = (function(e) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$goErr$1__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__jl_Throwable__F1__O(this.Lfs2_Pull$TranslateRunner$1__f_scope$8, this.Lfs2_Pull$TranslateRunner$1__f_extendedTopLevelScope$6, this.Lfs2_Pull$TranslateRunner$1__f_translation$tailLocal1$6, this.Lfs2_Pull$TranslateRunner$1__f_runner$tailLocal1$6, this.Lfs2_Pull$TranslateRunner$1__f_F$16, this.Lfs2_Pull$TranslateRunner$1__f_extendLastTopLevelScope$7, this.Lfs2_Pull$TranslateRunner$1__f_contP$9, this.Lfs2_Pull$TranslateRunner$1__f_TheBuildR$lzy1$9, e, this.Lfs2_Pull$TranslateRunner$1__f_view);
});
var $d_Lfs2_Pull$TranslateRunner$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$TranslateRunner$1, "fs2.Pull$TranslateRunner$1", ({
  Lfs2_Pull$TranslateRunner$1: 1,
  Lfs2_Pull$Run$1: 1
}));
export { $d_Lfs2_Pull$TranslateRunner$1 as $d_Lfs2_Pull$TranslateRunner$1 };
/** @constructor */
function $c_Lfs2_Pull$ViewRunner$1(runner$tailLocal1$4, extendedTopLevelScope$4, translation$tailLocal1$4, scope$5, F$14, extendLastTopLevelScope$5, contP$7, TheBuildR$lzy1$7, view) {
  this.Lfs2_Pull$ViewRunner$1__f_extendedTopLevelScope$5 = null;
  this.Lfs2_Pull$ViewRunner$1__f_translation$tailLocal1$5 = null;
  this.Lfs2_Pull$ViewRunner$1__f_scope$6 = null;
  this.Lfs2_Pull$ViewRunner$1__f_F$15 = null;
  this.Lfs2_Pull$ViewRunner$1__f_extendLastTopLevelScope$6 = false;
  this.Lfs2_Pull$ViewRunner$1__f_runner$tailLocal1$5 = null;
  this.Lfs2_Pull$ViewRunner$1__f_contP$8 = null;
  this.Lfs2_Pull$ViewRunner$1__f_TheBuildR$lzy1$8 = null;
  this.Lfs2_Pull$ViewRunner$1__f_view = null;
  this.Lfs2_Pull$ViewRunner$1__f_prevRunner = null;
  this.Lfs2_Pull$ViewRunner$1__f_extendedTopLevelScope$5 = extendedTopLevelScope$4;
  this.Lfs2_Pull$ViewRunner$1__f_translation$tailLocal1$5 = translation$tailLocal1$4;
  this.Lfs2_Pull$ViewRunner$1__f_scope$6 = scope$5;
  this.Lfs2_Pull$ViewRunner$1__f_F$15 = F$14;
  this.Lfs2_Pull$ViewRunner$1__f_extendLastTopLevelScope$6 = extendLastTopLevelScope$5;
  this.Lfs2_Pull$ViewRunner$1__f_runner$tailLocal1$5 = runner$tailLocal1$4;
  this.Lfs2_Pull$ViewRunner$1__f_contP$8 = contP$7;
  this.Lfs2_Pull$ViewRunner$1__f_TheBuildR$lzy1$8 = TheBuildR$lzy1$7;
  this.Lfs2_Pull$ViewRunner$1__f_view = view;
  this.Lfs2_Pull$ViewRunner$1__f_prevRunner = runner$tailLocal1$4;
}
export { $c_Lfs2_Pull$ViewRunner$1 as $c_Lfs2_Pull$ViewRunner$1 };
$c_Lfs2_Pull$ViewRunner$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_Pull$ViewRunner$1.prototype.constructor = $c_Lfs2_Pull$ViewRunner$1;
/** @constructor */
function $h_Lfs2_Pull$ViewRunner$1() {
}
export { $h_Lfs2_Pull$ViewRunner$1 as $h_Lfs2_Pull$ViewRunner$1 };
$h_Lfs2_Pull$ViewRunner$1.prototype = $c_Lfs2_Pull$ViewRunner$1.prototype;
$c_Lfs2_Pull$ViewRunner$1.prototype.done__Lfs2_internal_Scope__O = (function(doneScope) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$ViewRunner$1__f_F$15, this.Lfs2_Pull$ViewRunner$1__f_extendLastTopLevelScope$6, this.Lfs2_Pull$ViewRunner$1__f_contP$8, this.Lfs2_Pull$ViewRunner$1__f_TheBuildR$lzy1$8, doneScope, this.Lfs2_Pull$ViewRunner$1__f_extendedTopLevelScope$5, this.Lfs2_Pull$ViewRunner$1__f_translation$tailLocal1$5, this.Lfs2_Pull$ViewRunner$1__f_prevRunner, this.Lfs2_Pull$ViewRunner$1__f_view.apply__O__O($m_Lfs2_Pull$().Lfs2_Pull$__f_fs2$Pull$$$unit));
});
$c_Lfs2_Pull$ViewRunner$1.prototype.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O = (function(head, scope, tail) {
  return $s_Lfs2_Pull$__fs2$Pull$ViewRunner$1$$_$outLoop$1__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__Lfs2_Pull$Run$1__O(head, scope, tail, this);
});
$c_Lfs2_Pull$ViewRunner$1.prototype.interrupted__Lfs2_Pull$Interrupted__O = (function(inter) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$ViewRunner$1__f_F$15, this.Lfs2_Pull$ViewRunner$1__f_extendLastTopLevelScope$6, this.Lfs2_Pull$ViewRunner$1__f_contP$8, this.Lfs2_Pull$ViewRunner$1__f_TheBuildR$lzy1$8, this.Lfs2_Pull$ViewRunner$1__f_scope$6, this.Lfs2_Pull$ViewRunner$1__f_extendedTopLevelScope$5, this.Lfs2_Pull$ViewRunner$1__f_translation$tailLocal1$5, this.Lfs2_Pull$ViewRunner$1__f_prevRunner, this.Lfs2_Pull$ViewRunner$1__f_view.apply__O__O(inter));
});
$c_Lfs2_Pull$ViewRunner$1.prototype.fail__jl_Throwable__O = (function(e) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$goErr$1__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__jl_Throwable__F1__O(this.Lfs2_Pull$ViewRunner$1__f_scope$6, this.Lfs2_Pull$ViewRunner$1__f_extendedTopLevelScope$5, this.Lfs2_Pull$ViewRunner$1__f_translation$tailLocal1$5, this.Lfs2_Pull$ViewRunner$1__f_runner$tailLocal1$5, this.Lfs2_Pull$ViewRunner$1__f_F$15, this.Lfs2_Pull$ViewRunner$1__f_extendLastTopLevelScope$6, this.Lfs2_Pull$ViewRunner$1__f_contP$8, this.Lfs2_Pull$ViewRunner$1__f_TheBuildR$lzy1$8, e, this.Lfs2_Pull$ViewRunner$1__f_view);
});
function $isArrayOf_Lfs2_Pull$ViewRunner$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$ViewRunner$1)));
}
export { $isArrayOf_Lfs2_Pull$ViewRunner$1 as $isArrayOf_Lfs2_Pull$ViewRunner$1 };
var $d_Lfs2_Pull$ViewRunner$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$ViewRunner$1, "fs2.Pull$ViewRunner$1", ({
  Lfs2_Pull$ViewRunner$1: 1,
  Lfs2_Pull$Run$1: 1
}));
export { $d_Lfs2_Pull$ViewRunner$1 as $d_Lfs2_Pull$ViewRunner$1 };
/** @constructor */
function $c_Lfs2_RaiseThrowable$$anon$1() {
}
export { $c_Lfs2_RaiseThrowable$$anon$1 as $c_Lfs2_RaiseThrowable$$anon$1 };
$c_Lfs2_RaiseThrowable$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_RaiseThrowable$$anon$1.prototype.constructor = $c_Lfs2_RaiseThrowable$$anon$1;
/** @constructor */
function $h_Lfs2_RaiseThrowable$$anon$1() {
}
export { $h_Lfs2_RaiseThrowable$$anon$1 as $h_Lfs2_RaiseThrowable$$anon$1 };
$h_Lfs2_RaiseThrowable$$anon$1.prototype = $c_Lfs2_RaiseThrowable$$anon$1.prototype;
var $d_Lfs2_RaiseThrowable$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_RaiseThrowable$$anon$1, "fs2.RaiseThrowable$$anon$1", ({
  Lfs2_RaiseThrowable$$anon$1: 1,
  Lfs2_RaiseThrowable: 1
}));
export { $d_Lfs2_RaiseThrowable$$anon$1 as $d_Lfs2_RaiseThrowable$$anon$1 };
/** @constructor */
function $c_Lfs2_Stream$() {
  this.Lfs2_Stream$__f_empty = null;
  $n_Lfs2_Stream$ = this;
  $m_Lfs2_Pull$();
  $m_Lfs2_Pull$();
  $m_Lfs2_Pull$();
  var self$1 = $m_Lfs2_Pull$().Lfs2_Pull$__f_done;
  this.Lfs2_Stream$__f_empty = new $c_Lfs2_Stream(self$1);
}
export { $c_Lfs2_Stream$ as $c_Lfs2_Stream$ };
$c_Lfs2_Stream$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_Stream$.prototype.constructor = $c_Lfs2_Stream$;
/** @constructor */
function $h_Lfs2_Stream$() {
}
export { $h_Lfs2_Stream$ as $h_Lfs2_Stream$ };
$h_Lfs2_Stream$.prototype = $c_Lfs2_Stream$.prototype;
$c_Lfs2_Stream$.prototype.bracket__O__F1__Lfs2_Stream = (function(acquire, release) {
  return this.bracketCase__O__F2__Lfs2_Stream(acquire, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((r, _$90) => release.apply__O__O(r))));
});
$c_Lfs2_Stream$.prototype.bracketCase__O__F2__Lfs2_Stream = (function(acquire, release) {
  return this.bracketCaseWeak__O__F2__Lfs2_Stream(acquire, release).scope__Lfs2_Stream();
});
$c_Lfs2_Stream$.prototype.bracketCaseWeak__O__F2__Lfs2_Stream = (function(acquire, release) {
  $m_Lfs2_Pull$();
  $m_Lfs2_Pull$();
  var this$3 = new $c_Lfs2_Pull$Acquire(acquire, release, false);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$95) => $m_Lfs2_Pull$().output1__O__Lfs2_Pull(_$95)));
  var self = new $c_Lfs2_Pull$$anon$1(f, this$3);
  return new $c_Lfs2_Stream(self);
});
$c_Lfs2_Stream$.prototype.bracketFullWeak__F1__F2__Lcats_effect_kernel_MonadCancel__Lfs2_Stream = (function(acquire, release, F) {
  $m_Lfs2_Pull$();
  var this$1 = $m_Lfs2_Pull$().acquireCancelable__F1__F2__Lcats_effect_kernel_MonadCancel__Lfs2_Pull(acquire, release, F);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((o) => $m_Lfs2_Pull$().output1__O__Lfs2_Pull(o)));
  var self = new $c_Lfs2_Pull$$anon$1(f, this$1);
  return new $c_Lfs2_Stream(self);
});
$c_Lfs2_Stream$.prototype.chunk__Lfs2_Chunk__Lfs2_Stream = (function(os) {
  $m_Lfs2_Pull$();
  var self = $m_Lfs2_Pull$().output__Lfs2_Chunk__Lfs2_Pull(os);
  return new $c_Lfs2_Stream(self);
});
$c_Lfs2_Stream$.prototype.emit__O__Lfs2_Stream = (function(o) {
  $m_Lfs2_Pull$();
  var self = $m_Lfs2_Pull$().output1__O__Lfs2_Pull(o);
  return new $c_Lfs2_Stream(self);
});
$c_Lfs2_Stream$.prototype.eval__O__Lfs2_Stream = (function(fo) {
  $m_Lfs2_Pull$();
  $m_Lfs2_Pull$();
  var this$3 = new $c_Lfs2_Pull$Eval(fo);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((o) => $m_Lfs2_Pull$().output1__O__Lfs2_Pull(o)));
  var self = new $c_Lfs2_Pull$$anon$1(f, this$3);
  return new $c_Lfs2_Stream(self);
});
$c_Lfs2_Stream$.prototype.exec__O__Lfs2_Stream = (function(action) {
  $m_Lfs2_Pull$();
  $m_Lfs2_Pull$();
  var self = new $c_Lfs2_Pull$Eval(action);
  return new $c_Lfs2_Stream(self);
});
$c_Lfs2_Stream$.prototype.force__O__Lfs2_Stream = (function(f) {
  return this.eval__O__Lfs2_Stream(f).flatMap__F1__s_util_NotGiven__Lfs2_Stream(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s) => s)), $m_s_util_NotGiven$().s_util_NotGiven$__f_cachedValue);
});
$c_Lfs2_Stream$.prototype.raiseError__jl_Throwable__Lfs2_RaiseThrowable__Lfs2_Stream = (function(e, evidence$1) {
  $m_Lfs2_Pull$();
  $m_Lfs2_Pull$();
  var self = new $c_Lfs2_Pull$Fail(e);
  return new $c_Lfs2_Stream(self);
});
$c_Lfs2_Stream$.prototype.resource__Lcats_effect_kernel_Resource__Lcats_effect_kernel_MonadCancel__Lfs2_Stream = (function(r, F) {
  return this.resourceWeak__Lcats_effect_kernel_Resource__Lcats_effect_kernel_MonadCancel__Lfs2_Stream(r, F).scope__Lfs2_Stream();
});
$c_Lfs2_Stream$.prototype.resourceWeak__Lcats_effect_kernel_Resource__Lcats_effect_kernel_MonadCancel__Lfs2_Stream = (function(r, F) {
  if ((r instanceof $c_Lcats_effect_kernel_Resource$Allocate)) {
    var x498 = r.Lcats_effect_kernel_Resource$Allocate__f_resource;
    return $m_Lfs2_Stream$().bracketFullWeak__F1__F2__Lcats_effect_kernel_MonadCancel__Lfs2_Stream(x498, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((x$1, x$2) => {
      var x480 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), x$1, x$2);
      var x481 = x480.T2__f__1;
      if ((x481 !== null)) {
        var release = x481._2__O();
        var exit = x480.T2__f__2;
        return release.apply__O__O(exit);
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x480);
    })), F).fs2$Stream$$mapNoScope__F1__Lfs2_Stream(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$156) => _$156._1__O())));
  }
  if (false) {
    var x494 = r.Lcats_effect_kernel_Resource$Bind__f_source;
    var x495 = r.Lcats_effect_kernel_Resource$Bind__f_fs;
    return this.resourceWeak__Lcats_effect_kernel_Resource__Lcats_effect_kernel_MonadCancel__Lfs2_Stream(x494, F).flatMap__F1__s_util_NotGiven__Lfs2_Stream(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((o) => $m_Lfs2_Stream$().resourceWeak__Lcats_effect_kernel_Resource__Lcats_effect_kernel_MonadCancel__Lfs2_Stream(x495.apply__O__O(o), F))), $m_s_util_NotGiven$().s_util_NotGiven$__f_cachedValue);
  }
  if ((r instanceof $c_Lcats_effect_kernel_Resource$Eval)) {
    var x491 = r.Lcats_effect_kernel_Resource$Eval__f_fa;
    return $m_Lfs2_Stream$().eval__O__Lfs2_Stream(x491);
  }
  if ((r instanceof $c_Lcats_effect_kernel_Resource$Pure)) {
    var x488 = r.Lcats_effect_kernel_Resource$Pure__f_a;
    return $m_Lfs2_Stream$().emit__O__Lfs2_Stream(x488);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(r);
});
var $d_Lfs2_Stream$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Stream$, "fs2.Stream$", ({
  Lfs2_Stream$: 1,
  Lfs2_StreamLowPriority: 1
}));
export { $d_Lfs2_Stream$ as $d_Lfs2_Stream$ };
var $n_Lfs2_Stream$;
function $m_Lfs2_Stream$() {
  if ((!$n_Lfs2_Stream$)) {
    $n_Lfs2_Stream$ = new $c_Lfs2_Stream$();
  }
  return $n_Lfs2_Stream$;
}
export { $m_Lfs2_Stream$ as $m_Lfs2_Stream$ };
function $p_Lfs2_concurrent_Channel$$anon$1__makeChunk__sci_List__sci_List__I__Lfs2_Chunk($thiz, init, tail, size) {
  var arr = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(size);
  var i = (((-1) + size) | 0);
  var values = tail;
  while ((i >= 0)) {
    if (values.isEmpty__Z()) {
      values = init;
    }
    arr.u[i] = values.head__O();
    values = values.tail__O();
    i = (((-1) + i) | 0);
  }
  var this$1 = $m_Lfs2_Chunk$();
  var evidence$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_reflect_ManifestFactory$AnyManifest$();
  var length = arr.u.length;
  if ((length === 0)) {
    return this$1.Lfs2_Chunk$__f_empty_;
  } else if ((length === 1)) {
    var o = arr.u[0];
    return new $c_Lfs2_Chunk$Singleton(o);
  } else {
    return new $c_Lfs2_Chunk$ArraySlice(arr, 0, length, evidence$1);
  }
}
export { $p_Lfs2_concurrent_Channel$$anon$1__makeChunk__sci_List__sci_List__I__Lfs2_Chunk as $p_Lfs2_concurrent_Channel$$anon$1__makeChunk__sci_List__sci_List__I__Lfs2_Chunk };
/** @constructor */
function $c_Lfs2_concurrent_Channel$$anon$1(F$3, state$2, capacity$3, closedGate$2, State$lzy1$6, open$4) {
  this.Lfs2_concurrent_Channel$$anon$1__f_F$2 = null;
  this.Lfs2_concurrent_Channel$$anon$1__f_state$1 = null;
  this.Lfs2_concurrent_Channel$$anon$1__f_capacity$2 = 0;
  this.Lfs2_concurrent_Channel$$anon$1__f_closedGate$1 = null;
  this.Lfs2_concurrent_Channel$$anon$1__f_State$lzy1$5 = null;
  this.Lfs2_concurrent_Channel$$anon$1__f_open$3 = null;
  this.Lfs2_concurrent_Channel$$anon$1__f_F$2 = F$3;
  this.Lfs2_concurrent_Channel$$anon$1__f_state$1 = state$2;
  this.Lfs2_concurrent_Channel$$anon$1__f_capacity$2 = capacity$3;
  this.Lfs2_concurrent_Channel$$anon$1__f_closedGate$1 = closedGate$2;
  this.Lfs2_concurrent_Channel$$anon$1__f_State$lzy1$5 = State$lzy1$6;
  this.Lfs2_concurrent_Channel$$anon$1__f_open$3 = open$4;
}
export { $c_Lfs2_concurrent_Channel$$anon$1 as $c_Lfs2_concurrent_Channel$$anon$1 };
$c_Lfs2_concurrent_Channel$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_concurrent_Channel$$anon$1.prototype.constructor = $c_Lfs2_concurrent_Channel$$anon$1;
/** @constructor */
function $h_Lfs2_concurrent_Channel$$anon$1() {
}
export { $h_Lfs2_concurrent_Channel$$anon$1 as $h_Lfs2_concurrent_Channel$$anon$1 };
$h_Lfs2_concurrent_Channel$$anon$1.prototype = $c_Lfs2_concurrent_Channel$$anon$1.prototype;
$c_Lfs2_concurrent_Channel$$anon$1.prototype.sendImpl__O__Z__O = (function(a, close) {
  var target = $m_Lcats_effect_IO$().deferred__Lcats_effect_IO();
  var tc = this.Lfs2_concurrent_Channel$$anon$1__f_F$2;
  var this$32 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((producer) => this.Lfs2_concurrent_Channel$$anon$1__f_state$1.flatModifyFull__F2__Lcats_effect_kernel_MonadCancel__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((producer$2) => ((x$1, x$2) => {
    if ((x$2 !== null)) {
      $m_Lfs2_concurrent_Channel$().fs2$concurrent$Channel$$$_$State$2__sr_LazyRef__Lfs2_concurrent_Channel$State$3$(this.Lfs2_concurrent_Channel$$anon$1__f_State$lzy1$5);
      var x13 = x$2.Lfs2_concurrent_Channel$State$1__f_values;
      var x14 = x$2.Lfs2_concurrent_Channel$State$1__f_size;
      var x15 = x$2.Lfs2_concurrent_Channel$State$1__f_waiting;
      var x16 = x$2.Lfs2_concurrent_Channel$State$1__f_producers;
      var x17 = x$2.Lfs2_concurrent_Channel$State$1__f_closed;
      if ((x17 === true)) {
        var a$1 = $m_Lfs2_concurrent_Channel$().Lfs2_concurrent_Channel$__f__closed;
        $m_Lcats_effect_IO$();
        var _2 = new $c_Lcats_effect_IO$Pure(a$1);
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), x$2, _2);
      }
      if ((x17 === false)) {
        if ((x14 < this.Lfs2_concurrent_Channel$$anon$1__f_capacity$2)) {
          $m_Lfs2_concurrent_Channel$().fs2$concurrent$Channel$$$_$State$2__sr_LazyRef__Lfs2_concurrent_Channel$State$3$(this.Lfs2_concurrent_Channel$$anon$1__f_State$lzy1$5);
          var values = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(a, x13);
          var size = ((1 + x14) | 0);
          var waiting = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
          var _1 = new $c_Lfs2_concurrent_Channel$State$1(values, size, waiting, x16, close);
          if (close) {
            var fa = this.signalClosure__O();
            var fa$1 = fa.void__Lcats_effect_IO();
          } else {
            var fa$1 = $m_Lcats_effect_IO$().Lcats_effect_IO$__f__unit;
          }
          var target$1 = this.notifyStream__s_Option__O(x15);
          var tc$1 = this.Lfs2_concurrent_Channel$$anon$1__f_F$2;
          var this$16 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, tc$1);
          var b = $m_Lfs2_concurrent_Channel$().Lfs2_concurrent_Channel$__f_fs2$concurrent$Channel$$$rightUnit;
          var fb = this$16.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.as__O__O__O(this$16.Lcats_Functor$ToFunctorOps$$anon$5__f_self, b);
          var _2$1 = fa$1.productR__Lcats_effect_IO__Lcats_effect_IO(fb);
          return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, _2$1);
        } else {
          $m_Lfs2_concurrent_Channel$().fs2$concurrent$Channel$$$_$State$2__sr_LazyRef__Lfs2_concurrent_Channel$State$3$(this.Lfs2_concurrent_Channel$$anon$1__f_State$lzy1$5);
          var waiting$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
          var elem$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), a, producer$2);
          var producers = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem$1, x16);
          var _1$1 = new $c_Lfs2_concurrent_Channel$State$1(x13, x14, waiting$1, producers, close);
          if (close) {
            var fa$2 = this.signalClosure__O();
            var fa$3 = fa$2.void__Lcats_effect_IO();
          } else {
            var fa$3 = $m_Lcats_effect_IO$().Lcats_effect_IO$__f__unit;
          }
          var target$2 = this.notifyStream__s_Option__O(x15);
          var tc$2 = this.Lfs2_concurrent_Channel$$anon$1__f_F$2;
          var this$25 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, tc$2);
          var b$1 = $m_Lfs2_concurrent_Channel$().Lfs2_concurrent_Channel$__f_fs2$concurrent$Channel$$$rightUnit;
          var fb$1 = this$25.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.as__O__O__O(this$25.Lcats_Functor$ToFunctorOps$$anon$5__f_self, b$1);
          var fa$4 = fa$3.productR__Lcats_effect_IO__Lcats_effect_IO(fb$1);
          if (close) {
            var fb$2 = $m_Lcats_effect_IO$().Lcats_effect_IO$__f__unit;
          } else {
            var fa$5 = this.waitOnBound__Lcats_effect_kernel_Deferred__Lcats_effect_kernel_Poll__O(producer$2, x$1);
            var fb$2 = fa$5.void__Lcats_effect_IO();
          }
          var _2$2 = fa$4.productL__Lcats_effect_IO__Lcats_effect_IO(fb$2);
          return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1$1, _2$2);
        }
      }
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$2);
  }))(producer)), this.Lfs2_concurrent_Channel$$anon$1__f_F$2)));
  return this$32.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$32.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
});
$c_Lfs2_concurrent_Channel$$anon$1.prototype.close__O = (function() {
  return this.Lfs2_concurrent_Channel$$anon$1__f_state$1.flatModify__F1__Lcats_effect_kernel_MonadCancel__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 !== null)) {
      $m_Lfs2_concurrent_Channel$().fs2$concurrent$Channel$$$_$State$2__sr_LazyRef__Lfs2_concurrent_Channel$State$3$(this.Lfs2_concurrent_Channel$$anon$1__f_State$lzy1$5);
      var x42 = x$1.Lfs2_concurrent_Channel$State$1__f_values;
      var x43 = x$1.Lfs2_concurrent_Channel$State$1__f_size;
      var x44 = x$1.Lfs2_concurrent_Channel$State$1__f_waiting;
      var x45 = x$1.Lfs2_concurrent_Channel$State$1__f_producers;
      var x46 = x$1.Lfs2_concurrent_Channel$State$1__f_closed;
      if ((x46 === true)) {
        var a = $m_Lfs2_concurrent_Channel$().Lfs2_concurrent_Channel$__f__closed;
        $m_Lcats_effect_IO$();
        var _2 = new $c_Lcats_effect_IO$Pure(a);
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), x$1, _2);
      }
      if ((x46 === false)) {
        $m_Lfs2_concurrent_Channel$().fs2$concurrent$Channel$$$_$State$2__sr_LazyRef__Lfs2_concurrent_Channel$State$3$(this.Lfs2_concurrent_Channel$$anon$1__f_State$lzy1$5);
        var waiting = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        var _1 = new $c_Lfs2_concurrent_Channel$State$1(x42, x43, waiting, x45, true);
        var target = this.notifyStream__s_Option__O(x44);
        var tc = this.Lfs2_concurrent_Channel$$anon$1__f_F$2;
        var this$10 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
        var b = $m_Lfs2_concurrent_Channel$().Lfs2_concurrent_Channel$__f_fs2$concurrent$Channel$$$rightUnit;
        var fa = this$10.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.as__O__O__O(this$10.Lcats_Functor$ToFunctorOps$$anon$5__f_self, b);
        var fb = this.signalClosure__O();
        var _2$1 = fa.productL__Lcats_effect_IO__Lcats_effect_IO(fb);
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, _2$1);
      }
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  })), this.Lfs2_concurrent_Channel$$anon$1__f_F$2);
});
$c_Lfs2_concurrent_Channel$$anon$1.prototype.stream__Lfs2_Stream = (function() {
  $m_Lfs2_Pull$();
  var self = this.consumeLoop__Lfs2_Pull();
  return $m_Lfs2_Pull$StreamPullOps$().stream$extension__Lfs2_Pull__Lfs2_Stream(self);
});
$c_Lfs2_concurrent_Channel$$anon$1.prototype.consumeLoop__Lfs2_Pull = (function() {
  $m_Lfs2_Pull$();
  var target = $m_Lcats_effect_IO$().deferred__Lcats_effect_IO();
  var tc = this.Lfs2_concurrent_Channel$$anon$1__f_F$2;
  var this$32 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((waiting) => {
    var target$1 = this.Lfs2_concurrent_Channel$$anon$1__f_state$1.modify__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((waiting$2) => ((state) => {
      var this$4 = state.Lfs2_concurrent_Channel$State$1__f_values;
      if ((!this$4.isEmpty__Z())) {
        var $x_1 = true;
      } else {
        var this$5 = state.Lfs2_concurrent_Channel$State$1__f_producers;
        var $x_1 = (!this$5.isEmpty__Z());
      }
      if ($x_1) {
        var _1 = $m_Lfs2_concurrent_Channel$().fs2$concurrent$Channel$$$_$empty$1__Lfs2_concurrent_Channel$State$1__sr_LazyRef__Z__Lfs2_concurrent_Channel$State$1(this.Lfs2_concurrent_Channel$$anon$1__f_open$3, this.Lfs2_concurrent_Channel$$anon$1__f_State$lzy1$5, state.Lfs2_concurrent_Channel$State$1__f_closed);
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, state);
      } else {
        var waiting$2$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(waiting$2);
        var values$2 = state.Lfs2_concurrent_Channel$State$1__f_values;
        var size$2 = state.Lfs2_concurrent_Channel$State$1__f_size;
        var producers$2 = state.Lfs2_concurrent_Channel$State$1__f_producers;
        var closed$2 = state.Lfs2_concurrent_Channel$State$1__f_closed;
        var _1$1 = new $c_Lfs2_concurrent_Channel$State$1(values$2, size$2, waiting$2$1, producers$2, closed$2);
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1$1, state);
      }
    }))(waiting)));
    var tc$1 = this.Lfs2_concurrent_Channel$$anon$1__f_F$2;
    var this$30 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$1);
    var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((waiting$3) => ((x$1) => {
      if ((x$1 !== null)) {
        $m_Lfs2_concurrent_Channel$().fs2$concurrent$Channel$$$_$State$2__sr_LazyRef__Lfs2_concurrent_Channel$State$3$(this.Lfs2_concurrent_Channel$$anon$1__f_State$lzy1$5);
        var x52 = x$1.Lfs2_concurrent_Channel$State$1__f_values;
        var x53 = x$1.Lfs2_concurrent_Channel$State$1__f_size;
        var x55 = x$1.Lfs2_concurrent_Channel$State$1__f_producers;
        var x56 = x$1.Lfs2_concurrent_Channel$State$1__f_closed;
        var this$13 = x$1.Lfs2_concurrent_Channel$State$1__f_values;
        if ((!this$13.isEmpty__Z())) {
          var $x_2 = true;
        } else {
          var this$14 = x$1.Lfs2_concurrent_Channel$State$1__f_producers;
          var $x_2 = (!this$14.isEmpty__Z());
        }
        if ($x_2) {
          var elem = 0;
          elem = x53;
          var tailValues = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_ListBuffer();
          var elem$1 = $m_Lcats_effect_IO$().Lcats_effect_IO$__f__unit;
          var elem$2 = null;
          elem$2 = elem$1;
          var these = x55;
          while ((!these.isEmpty__Z())) {
            var x0 = these.head__O();
            matchResult8: {
              if ((x0 !== null)) {
                var value = x0._1__O();
                var producer = x0._2__O();
                elem = ((1 + elem) | 0);
                tailValues.addOne__O__scm_ListBuffer(value);
                var fa = elem$2;
                var fb = producer.complete__O__Lcats_effect_IO((void 0));
                elem$2 = fa.productL__Lcats_effect_IO__Lcats_effect_IO(fb);
                break matchResult8;
              }
              throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x0);
            }
            these = these.tail__O();
          }
          var toEmit = $p_Lfs2_concurrent_Channel$$anon$1__makeChunk__sci_List__sci_List__I__Lfs2_Chunk(this, x52, tailValues.toList__sci_List(), elem);
          var target$2 = elem$2;
          var tc$2 = this.Lfs2_concurrent_Channel$$anon$1__f_F$2;
          var this$23 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, tc$2);
          var this$22 = $m_Lfs2_Pull$().output__Lfs2_Chunk__Lfs2_Pull(toEmit);
          var post = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => this.consumeLoop__Lfs2_Pull()));
          var b = new $c_Lfs2_Pull$$anon$2(post, this$22);
          return this$23.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.as__O__O__O(this$23.Lcats_Functor$ToFunctorOps$$anon$5__f_self, b);
        } else {
          if (x56) {
            var x = $m_Lfs2_Pull$().Lfs2_Pull$__f_done;
          } else {
            $m_Lfs2_Pull$();
            var fr = waiting$3.get__Lcats_effect_IO();
            var this$26 = new $c_Lfs2_Pull$Eval(fr);
            var post$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => this.consumeLoop__Lfs2_Pull()));
            var x = new $c_Lfs2_Pull$$anon$2(post$1, this$26);
          }
          $m_Lcats_effect_IO$();
          return new $c_Lcats_effect_IO$Pure(x);
        }
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    }))(waiting));
    var wrapped = this$30.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$30.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$().uncancelable$extension__O__Lcats_effect_kernel_MonadCancel__O(wrapped, this.Lfs2_concurrent_Channel$$anon$1__f_F$2);
  }));
  var fr$1 = this$32.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$32.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
  var ffa = new $c_Lfs2_Pull$Eval(fr$1);
  $m_Lfs2_Pull$();
  $m_Lfs2_Pull$();
  var F$1 = new $c_Lfs2_PullMonadErrorInstance();
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__flatten__O__O(F$1, ffa);
});
$c_Lfs2_concurrent_Channel$$anon$1.prototype.notifyStream__s_Option__O = (function(waitForChanges) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_UnorderedFoldable$();
  var tc = $m_Lcats_instances_package$option$().Lcats_instances_package$option$__f_catsStdInstancesForOption;
  var this$3 = new $c_Lcats_Traverse$ToTraverseOps$$anon$3(waitForChanges, tc);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$7) => _$7.complete__O__Lcats_effect_IO((void 0))));
  var ev$1 = this.Lfs2_concurrent_Channel$$anon$1__f_F$2;
  return this$3.Lcats_Traverse$ToTraverseOps$$anon$3__f_typeClassInstance.traverse__O__F1__Lcats_Applicative__O(this$3.Lcats_Traverse$ToTraverseOps$$anon$3__f_self, f, ev$1);
});
$c_Lfs2_concurrent_Channel$$anon$1.prototype.waitOnBound__Lcats_effect_kernel_Deferred__Lcats_effect_kernel_Poll__O = (function(producer, poll) {
  var wrapped = poll.apply__O__O(producer.get__Lcats_effect_IO());
  var fin = this.Lfs2_concurrent_Channel$$anon$1__f_state$1.update__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s) => {
    var this$2 = s.Lfs2_concurrent_Channel$State$1__f_producers;
    var f = ((_$8) => (_$8._2__O() !== producer));
    var l = this$2;
    block: {
      var result;
      while (true) {
        if (l.isEmpty__Z()) {
          var result = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
          break;
        } else {
          var h = l.head__O();
          var t = l.tail__O();
          if (((!(!f(h))) === false)) {
            l = t;
            continue;
          }
          var start = l;
          var remaining = t;
          while (true) {
            if (remaining.isEmpty__Z()) {
              var result = start;
              break block;
            } else {
              var x = remaining.head__O();
              if (((!(!f(x))) !== false)) {
                remaining = remaining.tail__O();
                continue;
              }
              var firstMiss = remaining;
              var newHead = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(start.head__O(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
              var toProcess = start.tail__O();
              var currentLast = newHead;
              while ((toProcess !== firstMiss)) {
                var newElem = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(toProcess.head__O(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
                currentLast.sci_$colon$colon__f_next = newElem;
                currentLast = newElem;
                toProcess = toProcess.tail__O();
              }
              var next = firstMiss.tail__O();
              var nextToCopy = next;
              while ((!next.isEmpty__Z())) {
                var head = next.head__O();
                if (((!(!f(head))) !== false)) {
                  next = next.tail__O();
                } else {
                  while ((nextToCopy !== next)) {
                    var newElem$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(nextToCopy.head__O(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
                    currentLast.sci_$colon$colon__f_next = newElem$2;
                    currentLast = newElem$2;
                    nextToCopy = nextToCopy.tail__O();
                  }
                  nextToCopy = next.tail__O();
                  next = next.tail__O();
                }
              }
              if ((!nextToCopy.isEmpty__Z())) {
                currentLast.sci_$colon$colon__f_next = nextToCopy;
              }
              var result = newHead;
              break block;
            }
          }
        }
      }
    }
    var values$1 = s.Lfs2_concurrent_Channel$State$1__f_values;
    var size$1 = s.Lfs2_concurrent_Channel$State$1__f_size;
    var waiting$1 = s.Lfs2_concurrent_Channel$State$1__f_waiting;
    var closed$1 = s.Lfs2_concurrent_Channel$State$1__f_closed;
    return new $c_Lfs2_concurrent_Channel$State$1(values$1, size$1, waiting$1, result, closed$1);
  })));
  return new $c_Lcats_effect_IO$OnCancel(wrapped, fin);
});
$c_Lfs2_concurrent_Channel$$anon$1.prototype.signalClosure__O = (function() {
  var this$1 = this.Lfs2_concurrent_Channel$$anon$1__f_closedGate$1;
  return this$1.complete__O__Lcats_effect_IO((void 0));
});
var $d_Lfs2_concurrent_Channel$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_concurrent_Channel$$anon$1, "fs2.concurrent.Channel$$anon$1", ({
  Lfs2_concurrent_Channel$$anon$1: 1,
  Lfs2_concurrent_Channel: 1
}));
export { $d_Lfs2_concurrent_Channel$$anon$1 as $d_Lfs2_concurrent_Channel$$anon$1 };
/** @constructor */
function $c_Lfs2_internal_ScopedResource$$anon$1(token$1, F$2, state$1) {
  this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$state$3 = null;
  this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$F$4 = null;
  this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$pru = null;
  this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$state$3 = state$1;
  this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$F$4 = F$2;
  $m_Lcats_implicits$();
  var a = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right((void 0));
  this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$pru = F$2.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a);
}
export { $c_Lfs2_internal_ScopedResource$$anon$1 as $c_Lfs2_internal_ScopedResource$$anon$1 };
$c_Lfs2_internal_ScopedResource$$anon$1.prototype = new $h_Lfs2_internal_ScopedResource();
$c_Lfs2_internal_ScopedResource$$anon$1.prototype.constructor = $c_Lfs2_internal_ScopedResource$$anon$1;
/** @constructor */
function $h_Lfs2_internal_ScopedResource$$anon$1() {
}
export { $h_Lfs2_internal_ScopedResource$$anon$1 as $h_Lfs2_internal_ScopedResource$$anon$1 };
$h_Lfs2_internal_ScopedResource$$anon$1.prototype = $c_Lfs2_internal_ScopedResource$$anon$1.prototype;
$c_Lfs2_internal_ScopedResource$$anon$1.prototype.release__Lcats_effect_kernel_Resource$ExitCase__O = (function(ec) {
  $m_Lcats_implicits$();
  var target = this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$state$3.modify__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s) => {
    if ((s.Lfs2_internal_ScopedResource$State__f_leases !== 0)) {
      var finalizer = s.Lfs2_internal_ScopedResource$State__f_finalizer;
      var leases = s.Lfs2_internal_ScopedResource$State__f_leases;
      var _1 = new $c_Lfs2_internal_ScopedResource$State(false, finalizer, leases);
      var _2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, _2);
    } else {
      var finalizer$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      var leases$1 = s.Lfs2_internal_ScopedResource$State__f_leases;
      var _1$1 = new $c_Lfs2_internal_ScopedResource$State(false, finalizer$1, leases$1);
      var _2$1 = s.Lfs2_internal_ScopedResource$State__f_finalizer;
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1$1, _2$1);
    }
  })));
  var tc = this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$F$4;
  var this$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((finalizer$2) => {
    if (finalizer$2.isEmpty__Z()) {
      var this$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    } else {
      var x0 = finalizer$2.get__O();
      var this$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(x0.apply__O__O(ec));
    }
    return (this$5.isEmpty__Z() ? this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$pru : this$5.get__O());
  }));
  return this$6.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$6.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
});
$c_Lfs2_internal_ScopedResource$$anon$1.prototype.acquired__F1__O = (function(finalizer) {
  return this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$state$3.flatModify__F1__Lcats_effect_kernel_MonadCancel__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s) => {
    if (((!s.Lfs2_internal_ScopedResource$State__f_open) && (s.Lfs2_internal_ScopedResource$State__f_leases === 0))) {
      $m_Lcats_implicits$();
      $m_Lcats_implicits$();
      var target = finalizer.apply__O__O($m_Lcats_effect_kernel_Resource$ExitCase$Succeeded$());
      var tc = this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$F$4;
      var this$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
      var fa = this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.as__O__O__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, false);
      var F$1 = this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$F$4;
      var y = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_ApplicativeError__attempt__O__O(F$1, fa);
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), s, y);
    } else {
      var attemptFinalizer = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((ec) => {
        $m_Lcats_implicits$();
        var fa$1 = finalizer.apply__O__O(ec);
        var F$3 = this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$F$4;
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_ApplicativeError__attempt__O__O(F$3, fa$1);
      }));
      var finalizer$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(attemptFinalizer);
      var open$1 = s.Lfs2_internal_ScopedResource$State__f_open;
      var leases$1 = s.Lfs2_internal_ScopedResource$State__f_leases;
      var self = new $c_Lfs2_internal_ScopedResource$State(open$1, finalizer$1, leases$1);
      $m_Lcats_implicits$();
      var a = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(true);
      var F$4 = this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$F$4;
      var y$1 = F$4.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a);
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self, y$1);
    }
  })), this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$F$4);
});
var $d_Lfs2_internal_ScopedResource$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_internal_ScopedResource$$anon$1, "fs2.internal.ScopedResource$$anon$1", ({
  Lfs2_internal_ScopedResource$$anon$1: 1,
  Lfs2_internal_ScopedResource: 1
}));
export { $d_Lfs2_internal_ScopedResource$$anon$1 as $d_Lfs2_internal_ScopedResource$$anon$1 };
function $f_Lio_circe_Parser__finishDecode__s_util_Either__Lio_circe_Decoder__s_util_Either($thiz, input, decoder) {
  if ((input instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
    var json = input.s_util_Right__f_value;
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lio_circe_Decoder__decodeJson__Lio_circe_Json__s_util_Either(decoder, json);
  }
  if ((input instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
    return input;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(input);
}
export { $f_Lio_circe_Parser__finishDecode__s_util_Either__Lio_circe_Decoder__s_util_Either as $f_Lio_circe_Parser__finishDecode__s_util_Either__Lio_circe_Decoder__s_util_Either };
function $f_Lio_circe_Parser__finishDecodeAccumulating__s_util_Either__Lio_circe_Decoder__Lcats_data_Validated($thiz, input, decoder) {
  if ((input instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
    var json = input.s_util_Right__f_value;
    var this$2 = decoder.decodeAccumulating__Lio_circe_HCursor__Lcats_data_Validated(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lio_circe_cursor_TopCursor(json, null, null));
    if ((this$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_Validated$Valid)) {
      return this$2;
    }
    if ((this$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_Validated$Invalid)) {
      var x235 = this$2.Lcats_data_Validated$Invalid__f_e;
      matchResult2: {
        var e;
        if ((x235 !== null)) {
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_NonEmptyList$();
          var x8 = x235.Lcats_data_NonEmptyList__f_head;
          var x9 = x235.Lcats_data_NonEmptyList__f_tail;
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_NonEmptyList$();
          var e = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_NonEmptyList(x8, x9);
          break matchResult2;
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x235);
      }
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_Validated$Invalid(e);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this$2);
  }
  if ((input instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
    var error = input.s_util_Left__f_value;
    var this$8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_Validated$();
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_data_ValidatedFunctions__invalidNel__O__Lcats_data_Validated(this$8, error);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(input);
}
export { $f_Lio_circe_Parser__finishDecodeAccumulating__s_util_Either__Lio_circe_Decoder__Lcats_data_Validated as $f_Lio_circe_Parser__finishDecodeAccumulating__s_util_Either__Lio_circe_Decoder__Lcats_data_Validated };
function $f_Lio_circe_Parser__decode__T__Lio_circe_Decoder__s_util_Either($thiz, input, evidence$1) {
  var input$1 = $thiz.parse__T__s_util_Either(input);
  return $f_Lio_circe_Parser__finishDecode__s_util_Either__Lio_circe_Decoder__s_util_Either($thiz, input$1, evidence$1);
}
export { $f_Lio_circe_Parser__decode__T__Lio_circe_Decoder__s_util_Either as $f_Lio_circe_Parser__decode__T__Lio_circe_Decoder__s_util_Either };
function $f_Lio_circe_Parser__decodeAccumulating__T__Lio_circe_Decoder__Lcats_data_Validated($thiz, input, evidence$1) {
  var input$1 = $thiz.parse__T__s_util_Either(input);
  return $f_Lio_circe_Parser__finishDecodeAccumulating__s_util_Either__Lio_circe_Decoder__Lcats_data_Validated($thiz, input$1, evidence$1);
}
export { $f_Lio_circe_Parser__decodeAccumulating__T__Lio_circe_Decoder__Lcats_data_Validated as $f_Lio_circe_Parser__decodeAccumulating__T__Lio_circe_Decoder__Lcats_data_Validated };
/** @constructor */
function $c_Lio_circe_derivation_DecoderDeriveSum(x$1) {
  this.Lio_circe_derivation_DecoderDeriveSum__f_x$1 = null;
  this.Lio_circe_derivation_DecoderDeriveSum__f_x$1 = x$1;
}
export { $c_Lio_circe_derivation_DecoderDeriveSum as $c_Lio_circe_derivation_DecoderDeriveSum };
$c_Lio_circe_derivation_DecoderDeriveSum.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_circe_derivation_DecoderDeriveSum.prototype.constructor = $c_Lio_circe_derivation_DecoderDeriveSum;
/** @constructor */
function $h_Lio_circe_derivation_DecoderDeriveSum() {
}
export { $h_Lio_circe_derivation_DecoderDeriveSum as $h_Lio_circe_derivation_DecoderDeriveSum };
$h_Lio_circe_derivation_DecoderDeriveSum.prototype = $c_Lio_circe_derivation_DecoderDeriveSum.prototype;
var $d_Lio_circe_derivation_DecoderDeriveSum = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_circe_derivation_DecoderDeriveSum, "io.circe.derivation.DecoderDeriveSum", ({
  Lio_circe_derivation_DecoderDeriveSum: 1,
  Lio_circe_derivation_Inliner: 1
}));
export { $d_Lio_circe_derivation_DecoderDeriveSum as $d_Lio_circe_derivation_DecoderDeriveSum };
/** @constructor */
function $c_Lio_circe_derivation_DecoderNotDeriveSum(x$1) {
  this.Lio_circe_derivation_DecoderNotDeriveSum__f_x$1 = null;
  this.Lio_circe_derivation_DecoderNotDeriveSum__f_x$1 = x$1;
}
export { $c_Lio_circe_derivation_DecoderNotDeriveSum as $c_Lio_circe_derivation_DecoderNotDeriveSum };
$c_Lio_circe_derivation_DecoderNotDeriveSum.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_circe_derivation_DecoderNotDeriveSum.prototype.constructor = $c_Lio_circe_derivation_DecoderNotDeriveSum;
/** @constructor */
function $h_Lio_circe_derivation_DecoderNotDeriveSum() {
}
export { $h_Lio_circe_derivation_DecoderNotDeriveSum as $h_Lio_circe_derivation_DecoderNotDeriveSum };
$h_Lio_circe_derivation_DecoderNotDeriveSum.prototype = $c_Lio_circe_derivation_DecoderNotDeriveSum.prototype;
var $d_Lio_circe_derivation_DecoderNotDeriveSum = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_circe_derivation_DecoderNotDeriveSum, "io.circe.derivation.DecoderNotDeriveSum", ({
  Lio_circe_derivation_DecoderNotDeriveSum: 1,
  Lio_circe_derivation_Inliner: 1
}));
export { $d_Lio_circe_derivation_DecoderNotDeriveSum as $d_Lio_circe_derivation_DecoderNotDeriveSum };
function $f_Lio_circe_derivation_Default__defaultAt__I__s_Option($thiz, index) {
  var x1 = $thiz.defaults__s_Product();
  if ((x1 === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_T$package$EmptyTuple$())) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
  if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Tuples$().isInstanceOfNonEmptyTuple__O__Z(x1)) {
    return x1.productElement__I__O(index);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1);
}
export { $f_Lio_circe_derivation_Default__defaultAt__I__s_Option as $f_Lio_circe_derivation_Default__defaultAt__I__s_Option };
/** @constructor */
function $c_Lio_circe_derivation_EncoderDeriveSum(config) {
  this.Lio_circe_derivation_EncoderDeriveSum__f_config = null;
  this.Lio_circe_derivation_EncoderDeriveSum__f_config = config;
}
export { $c_Lio_circe_derivation_EncoderDeriveSum as $c_Lio_circe_derivation_EncoderDeriveSum };
$c_Lio_circe_derivation_EncoderDeriveSum.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_circe_derivation_EncoderDeriveSum.prototype.constructor = $c_Lio_circe_derivation_EncoderDeriveSum;
/** @constructor */
function $h_Lio_circe_derivation_EncoderDeriveSum() {
}
export { $h_Lio_circe_derivation_EncoderDeriveSum as $h_Lio_circe_derivation_EncoderDeriveSum };
$h_Lio_circe_derivation_EncoderDeriveSum.prototype = $c_Lio_circe_derivation_EncoderDeriveSum.prototype;
var $d_Lio_circe_derivation_EncoderDeriveSum = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_circe_derivation_EncoderDeriveSum, "io.circe.derivation.EncoderDeriveSum", ({
  Lio_circe_derivation_EncoderDeriveSum: 1,
  Lio_circe_derivation_Inliner: 1
}));
export { $d_Lio_circe_derivation_EncoderDeriveSum as $d_Lio_circe_derivation_EncoderDeriveSum };
/** @constructor */
function $c_Lio_circe_derivation_EncoderNotDeriveSum(config) {
  this.Lio_circe_derivation_EncoderNotDeriveSum__f_config = null;
  this.Lio_circe_derivation_EncoderNotDeriveSum__f_config = config;
}
export { $c_Lio_circe_derivation_EncoderNotDeriveSum as $c_Lio_circe_derivation_EncoderNotDeriveSum };
$c_Lio_circe_derivation_EncoderNotDeriveSum.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_circe_derivation_EncoderNotDeriveSum.prototype.constructor = $c_Lio_circe_derivation_EncoderNotDeriveSum;
/** @constructor */
function $h_Lio_circe_derivation_EncoderNotDeriveSum() {
}
export { $h_Lio_circe_derivation_EncoderNotDeriveSum as $h_Lio_circe_derivation_EncoderNotDeriveSum };
$h_Lio_circe_derivation_EncoderNotDeriveSum.prototype = $c_Lio_circe_derivation_EncoderNotDeriveSum.prototype;
var $d_Lio_circe_derivation_EncoderNotDeriveSum = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_circe_derivation_EncoderNotDeriveSum, "io.circe.derivation.EncoderNotDeriveSum", ({
  Lio_circe_derivation_EncoderNotDeriveSum: 1,
  Lio_circe_derivation_Inliner: 1
}));
export { $d_Lio_circe_derivation_EncoderNotDeriveSum as $d_Lio_circe_derivation_EncoderNotDeriveSum };
/** @constructor */
function $c_jl_Thread(dummy) {
  this.jl_Thread__f_java$lang$Thread$$interruptedState = false;
  this.jl_Thread__f_java$lang$Thread$$interruptedState = false;
}
export { $c_jl_Thread as $c_jl_Thread };
$c_jl_Thread.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_jl_Thread.prototype.constructor = $c_jl_Thread;
/** @constructor */
function $h_jl_Thread() {
}
export { $h_jl_Thread as $h_jl_Thread };
$h_jl_Thread.prototype = $c_jl_Thread.prototype;
$c_jl_Thread.prototype.run__V = (function() {
});
var $d_jl_Thread = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_jl_Thread, "java.lang.Thread", ({
  jl_Thread: 1,
  jl_Runnable: 1
}));
export { $d_jl_Thread as $d_jl_Thread };
function $p_Ljava_net_URI$__loop$1__I__T__T__I($thiz, i, x$1, y$1) {
  while (true) {
    if (((i >= x$1.length) || (i >= y$1.length))) {
      return ((x$1.length - y$1.length) | 0);
    } else {
      var index = i;
      var index$1 = i;
      var diff = ((x$1.charCodeAt(index) - y$1.charCodeAt(index$1)) | 0);
      if ((diff !== 0)) {
        return diff;
      } else {
        var index$2 = i;
        if ((x$1.charCodeAt(index$2) === 37)) {
          if (((((2 + i) | 0) >= x$1.length) || (((2 + i) | 0) >= y$1.length))) {
            throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_AssertionError__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_AssertionError(), "Invalid escape in URI");
          }
          var beginIndex = ((1 + i) | 0);
          var endIndex = ((3 + i) | 0);
          var $x_1 = x$1.substring(beginIndex, endIndex);
          var beginIndex$1 = ((1 + i) | 0);
          var endIndex$1 = ((3 + i) | 0);
          var cmp = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__compareToIgnoreCase__T__I($x_1, y$1.substring(beginIndex$1, endIndex$1));
          if ((cmp !== 0)) {
            return cmp;
          } else {
            i = ((3 + i) | 0);
          }
        } else {
          i = ((1 + i) | 0);
        }
      }
    }
  }
}
export { $p_Ljava_net_URI$__loop$1__I__T__T__I as $p_Ljava_net_URI$__loop$1__I__T__T__I };
/** @constructor */
function $c_Ljava_net_URI$() {
  this.Ljava_net_URI$__f_ipv4address = null;
  this.Ljava_net_URI$__f_ipv6address = null;
  this.Ljava_net_URI$__f_java$net$URI$$uriRe = null;
  $n_Ljava_net_URI$ = this;
  this.Ljava_net_URI$__f_ipv4address = "(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)";
  var ipv4 = this.Ljava_net_URI$__f_ipv4address;
  this.Ljava_net_URI$__f_ipv6address = (((((((((((((("(?:(?:[0-9a-f]{1,4}:){7}[0-9a-f]{1,4}|(?:[0-9a-f]{1,4}:){1,7}:|(?:[0-9a-f]{1,4}:){1,6}(?::[0-9a-f]{1,4})|(?:[0-9a-f]{1,4}:){1,5}(?::[0-9a-f]{1,4}){1,2}|(?:[0-9a-f]{1,4}:){1,4}(?::[0-9a-f]{1,4}){1,3}|(?:[0-9a-f]{1,4}:){1,3}(?::[0-9a-f]{1,4}){1,4}|(?:[0-9a-f]{1,4}:){1,2}(?::[0-9a-f]{1,4}){1,5}|(?:[0-9a-f]{1,4}:)(?::[0-9a-f]{1,4}){1,6}|:(?:(?::[0-9a-f]{1,4}){1,7}|:)|(?:[0-9a-f]{1,4}:){6}" + ipv4) + "|(?:[0-9a-f]{1,4}:){1,5}:") + ipv4) + "|(?:[0-9a-f]{1,4}:){1,4}(?::[0-9a-f]{1,4}):") + ipv4) + "|(?:[0-9a-f]{1,4}:){1,3}(?::[0-9a-f]{1,4}){1,2}:") + ipv4) + "|(?:[0-9a-f]{1,4}:){1,2}(?::[0-9a-f]{1,4}){1,3}:") + ipv4) + "|(?:[0-9a-f]{1,4}:)(?::[0-9a-f]{1,4}){1,4}:") + ipv4) + "|::(?:[0-9a-f]{1,4}:){1,5}") + ipv4) + ")(?:%[0-9a-z]+)?");
  new RegExp((("^" + this.Ljava_net_URI$__f_ipv6address) + "$"), "i");
  var ipv6reference = (("\\[(?:" + this.Ljava_net_URI$__f_ipv6address) + ")\\]");
  var host = (((("((?:(?:[a-z0-9]|[a-z0-9][a-z0-9-]*[a-z0-9])\\.)*(?:[a-z]|[a-z][a-z0-9-]*[a-z0-9])\\.?|" + this.Ljava_net_URI$__f_ipv4address) + "|") + ipv6reference) + ")");
  var hostport = (host + "(?::([0-9]*))?");
  var server = (("(?:(?:((?:[a-z0-9-_.!~*'();:&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)@)?" + hostport) + ")?");
  var authority = (server + "|(?:[a-z0-9-_.!~*'()$,;:@&=+]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])+");
  var net_path = (("//(" + authority) + ")(/(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*(?:;(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)*(?:/(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*(?:;(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)*)*)?");
  var hier_part = (("(?:" + net_path) + "|(/(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*(?:;(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)*(?:/(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*(?:;(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)*)*))(?:\\?((?:[;/?:@&=+$,\\[\\]a-z0-9-_.!~*'()]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*))?");
  var absoluteURI = (("([a-z][a-z0-9+-.]*):(?:(" + hier_part) + ")|((?:[a-z0-9-_.!~*'();?:@&=+$,]|%[a-f0-9]{2})(?:[;/?:@&=+$,\\[\\]a-z0-9-_.!~*'()]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*))");
  var relativeURI = (("((?:" + net_path) + "|(/(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*(?:;(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)*(?:/(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*(?:;(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)*)*)|((?:[a-z0-9-_.!~*'();@&=+$,]|%[a-f0-9]{2})*(?:/(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*(?:;(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)*(?:/(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*(?:;(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)*)*)?))(?:\\?((?:[;/?:@&=+$,\\[\\]a-z0-9-_.!~*'()]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*))?)");
  var uriRef = (((("^(?:" + absoluteURI) + "|") + relativeURI) + ")(?:#((?:[;/?:@&=+$,\\[\\]a-z0-9-_.!~*'()]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*))?$");
  this.Ljava_net_URI$__f_java$net$URI$$uriRe = new RegExp(uriRef, "i");
  new RegExp("[\u0000- \"#/<>?@\\[-\\^`{-}\u007f-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029]|%(?![0-9a-f]{2})", "ig");
  new RegExp("[\u0000- \"#<>?\\[-\\^`{-}\u007f-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029]|%(?![0-9a-f]{2})", "ig");
  new RegExp("[\u0000- \"#/<>?\\^`{-}\u007f-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029]|%(?![0-9a-f]{2})", "ig");
  new RegExp("[\u0000- \"#<>@\\^`{-}\u007f-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029]|%(?![0-9a-f]{2})", "ig");
  new RegExp("[^\u0000-\u007f]+", "g");
}
export { $c_Ljava_net_URI$ as $c_Ljava_net_URI$ };
$c_Ljava_net_URI$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Ljava_net_URI$.prototype.constructor = $c_Ljava_net_URI$;
/** @constructor */
function $h_Ljava_net_URI$() {
}
export { $h_Ljava_net_URI$ as $h_Ljava_net_URI$ };
$h_Ljava_net_URI$.prototype = $c_Ljava_net_URI$.prototype;
$c_Ljava_net_URI$.prototype.java$net$URI$$caseInsensitiveCompare__T__T__I = (function(x, y) {
  return ((x === null) ? ((y === null) ? 0 : (-1)) : ((y === null) ? 1 : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__compareToIgnoreCase__T__I(x, y)));
});
$c_Ljava_net_URI$.prototype.java$net$URI$$escapeAwareCompare__T__T__I = (function(x, y) {
  return ((x === null) ? ((y === null) ? 0 : (-1)) : ((y === null) ? 1 : $p_Ljava_net_URI$__loop$1__I__T__T__I(this, 0, x, y)));
});
$c_Ljava_net_URI$.prototype.java$net$URI$$normalizeEscapes__T__T = (function(str) {
  if ((str === null)) {
    return null;
  } else {
    var i = 0;
    var res = "";
    while ((i < str.length)) {
      var index = i;
      if ((str.charCodeAt(index) === 37)) {
        if ((((2 + i) | 0) >= str.length)) {
          throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_AssertionError__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_AssertionError(), "Invalid escape in URI");
        }
        var $x_1 = res;
        var beginIndex = i;
        var endIndex = ((3 + i) | 0);
        var this$1 = str.substring(beginIndex, endIndex);
        res = (("" + $x_1) + this$1.toUpperCase());
        i = ((3 + i) | 0);
      } else {
        var $x_2 = res;
        var beginIndex$1 = i;
        var endIndex$1 = ((1 + i) | 0);
        res = (("" + $x_2) + str.substring(beginIndex$1, endIndex$1));
        i = ((1 + i) | 0);
      }
    }
    return res;
  }
});
var $d_Ljava_net_URI$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Ljava_net_URI$, "java.net.URI$", ({
  Ljava_net_URI$: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_net_URI$ as $d_Ljava_net_URI$ };
var $n_Ljava_net_URI$;
function $m_Ljava_net_URI$() {
  if ((!$n_Ljava_net_URI$)) {
    $n_Ljava_net_URI$ = new $c_Ljava_net_URI$();
  }
  return $n_Ljava_net_URI$;
}
export { $m_Ljava_net_URI$ as $m_Ljava_net_URI$ };
function $p_ju_Random$__randomInt__I($thiz) {
  var a = (4.294967296E9 * (+Math.random()));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$doubleToInt(((+Math.floor(a)) - 2.147483648E9));
}
export { $p_ju_Random$__randomInt__I as $p_ju_Random$__randomInt__I };
/** @constructor */
function $c_ju_Random$() {
}
export { $c_ju_Random$ as $c_ju_Random$ };
$c_ju_Random$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_ju_Random$.prototype.constructor = $c_ju_Random$;
/** @constructor */
function $h_ju_Random$() {
}
export { $h_ju_Random$ as $h_ju_Random$ };
$h_ju_Random$.prototype = $c_ju_Random$.prototype;
$c_ju_Random$.prototype.java$util$Random$$randomSeed__J = (function() {
  var value = $p_ju_Random$__randomInt__I(this);
  var value$1 = $p_ju_Random$__randomInt__I(this);
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(value$1, value);
});
var $d_ju_Random$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_ju_Random$, "java.util.Random$", ({
  ju_Random$: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_Random$ as $d_ju_Random$ };
var $n_ju_Random$;
function $m_ju_Random$() {
  if ((!$n_ju_Random$)) {
    $n_ju_Random$ = new $c_ju_Random$();
  }
  return $n_ju_Random$;
}
export { $m_ju_Random$ as $m_ju_Random$ };
/** @constructor */
function $c_Lmonocle_PIso$() {
  $ct_Lmonocle_IsoInstances__(this);
}
export { $c_Lmonocle_PIso$ as $c_Lmonocle_PIso$ };
$c_Lmonocle_PIso$.prototype = new $h_Lmonocle_IsoInstances();
$c_Lmonocle_PIso$.prototype.constructor = $c_Lmonocle_PIso$;
/** @constructor */
function $h_Lmonocle_PIso$() {
}
export { $h_Lmonocle_PIso$ as $h_Lmonocle_PIso$ };
$h_Lmonocle_PIso$.prototype = $c_Lmonocle_PIso$.prototype;
var $d_Lmonocle_PIso$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lmonocle_PIso$, "monocle.PIso$", ({
  Lmonocle_PIso$: 1,
  Lmonocle_IsoInstances: 1
}));
export { $d_Lmonocle_PIso$ as $d_Lmonocle_PIso$ };
var $n_Lmonocle_PIso$;
function $m_Lmonocle_PIso$() {
  if ((!$n_Lmonocle_PIso$)) {
    $n_Lmonocle_PIso$ = new $c_Lmonocle_PIso$();
  }
  return $n_Lmonocle_PIso$;
}
export { $m_Lmonocle_PIso$ as $m_Lmonocle_PIso$ };
/** @constructor */
function $c_Lmonocle_PLens$() {
  $ct_Lmonocle_LensInstances__(this);
}
export { $c_Lmonocle_PLens$ as $c_Lmonocle_PLens$ };
$c_Lmonocle_PLens$.prototype = new $h_Lmonocle_LensInstances();
$c_Lmonocle_PLens$.prototype.constructor = $c_Lmonocle_PLens$;
/** @constructor */
function $h_Lmonocle_PLens$() {
}
export { $h_Lmonocle_PLens$ as $h_Lmonocle_PLens$ };
$h_Lmonocle_PLens$.prototype = $c_Lmonocle_PLens$.prototype;
var $d_Lmonocle_PLens$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lmonocle_PLens$, "monocle.PLens$", ({
  Lmonocle_PLens$: 1,
  Lmonocle_LensInstances: 1
}));
export { $d_Lmonocle_PLens$ as $d_Lmonocle_PLens$ };
var $n_Lmonocle_PLens$;
function $m_Lmonocle_PLens$() {
  if ((!$n_Lmonocle_PLens$)) {
    $n_Lmonocle_PLens$ = new $c_Lmonocle_PLens$();
  }
  return $n_Lmonocle_PLens$;
}
export { $m_Lmonocle_PLens$ as $m_Lmonocle_PLens$ };
/** @constructor */
function $c_Lmonocle_PPrism$() {
  $ct_Lmonocle_PrismInstances__(this);
}
export { $c_Lmonocle_PPrism$ as $c_Lmonocle_PPrism$ };
$c_Lmonocle_PPrism$.prototype = new $h_Lmonocle_PrismInstances();
$c_Lmonocle_PPrism$.prototype.constructor = $c_Lmonocle_PPrism$;
/** @constructor */
function $h_Lmonocle_PPrism$() {
}
export { $h_Lmonocle_PPrism$ as $h_Lmonocle_PPrism$ };
$h_Lmonocle_PPrism$.prototype = $c_Lmonocle_PPrism$.prototype;
var $d_Lmonocle_PPrism$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lmonocle_PPrism$, "monocle.PPrism$", ({
  Lmonocle_PPrism$: 1,
  Lmonocle_PrismInstances: 1
}));
export { $d_Lmonocle_PPrism$ as $d_Lmonocle_PPrism$ };
var $n_Lmonocle_PPrism$;
function $m_Lmonocle_PPrism$() {
  if ((!$n_Lmonocle_PPrism$)) {
    $n_Lmonocle_PPrism$ = new $c_Lmonocle_PPrism$();
  }
  return $n_Lmonocle_PPrism$;
}
export { $m_Lmonocle_PPrism$ as $m_Lmonocle_PPrism$ };
/** @constructor */
function $c_Lmonocle_function_At() {
}
export { $c_Lmonocle_function_At as $c_Lmonocle_function_At };
$c_Lmonocle_function_At.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lmonocle_function_At.prototype.constructor = $c_Lmonocle_function_At;
/** @constructor */
function $h_Lmonocle_function_At() {
}
export { $h_Lmonocle_function_At as $h_Lmonocle_function_At };
$h_Lmonocle_function_At.prototype = $c_Lmonocle_function_At.prototype;
/** @constructor */
function $c_Lmonocle_function_At$() {
}
export { $c_Lmonocle_function_At$ as $c_Lmonocle_function_At$ };
$c_Lmonocle_function_At$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lmonocle_function_At$.prototype.constructor = $c_Lmonocle_function_At$;
/** @constructor */
function $h_Lmonocle_function_At$() {
}
export { $h_Lmonocle_function_At$ as $h_Lmonocle_function_At$ };
$h_Lmonocle_function_At$.prototype = $c_Lmonocle_function_At$.prototype;
$c_Lmonocle_function_At$.prototype.atMap__Lmonocle_function_At = (function() {
  var this$6 = $m_Lmonocle_function_At$();
  var lens = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((i) => {
    var get = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$3) => _$3.get__O__s_Option(i)));
    var replace = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((optV) => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((optV$2) => ((map) => {
      if (optV$2.isEmpty__Z()) {
        return map.removed__O__sci_MapOps(i);
      } else {
        var x0 = optV$2.get__O();
        return map.$plus__T2__sci_MapOps($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), i, x0));
      }
    }))(optV))));
    var this$5 = $m_Lmonocle_PLens$();
    return new $c_Lmonocle_PLens$$anon$2(get, replace, this$5);
  }));
  return new $c_Lmonocle_function_At$$anon$1(lens, this$6);
});
var $d_Lmonocle_function_At$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lmonocle_function_At$, "monocle.function.At$", ({
  Lmonocle_function_At$: 1,
  Lmonocle_function_AtFunctions: 1
}));
export { $d_Lmonocle_function_At$ as $d_Lmonocle_function_At$ };
var $n_Lmonocle_function_At$;
function $m_Lmonocle_function_At$() {
  if ((!$n_Lmonocle_function_At$)) {
    $n_Lmonocle_function_At$ = new $c_Lmonocle_function_At$();
  }
  return $n_Lmonocle_function_At$;
}
export { $m_Lmonocle_function_At$ as $m_Lmonocle_function_At$ };
/** @constructor */
function $c_Lmonocle_function_Index() {
}
export { $c_Lmonocle_function_Index as $c_Lmonocle_function_Index };
$c_Lmonocle_function_Index.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lmonocle_function_Index.prototype.constructor = $c_Lmonocle_function_Index;
/** @constructor */
function $h_Lmonocle_function_Index() {
}
export { $h_Lmonocle_function_Index as $h_Lmonocle_function_Index };
$h_Lmonocle_function_Index.prototype = $c_Lmonocle_function_Index.prototype;
/** @constructor */
function $c_Lmonocle_function_Index$() {
  $n_Lmonocle_function_Index$ = this;
  var this$3 = $m_Lmonocle_function_Index$();
  var optional = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((key) => {
    var key$1 = (key | 0);
    var $x_1 = $m_Lmonocle_std_string$().Lmonocle_std_string$__f_stringToList;
    $m_Lmonocle_function_Index$();
    var ev = this.listIndex__Lmonocle_function_Index();
    return $x_1.andThen__Lmonocle_POptional__Lmonocle_POptional(ev.index__O__Lmonocle_POptional(key$1));
  }));
  new $c_Lmonocle_function_Index$$anon$1(optional, this$3);
}
export { $c_Lmonocle_function_Index$ as $c_Lmonocle_function_Index$ };
$c_Lmonocle_function_Index$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lmonocle_function_Index$.prototype.constructor = $c_Lmonocle_function_Index$;
/** @constructor */
function $h_Lmonocle_function_Index$() {
}
export { $h_Lmonocle_function_Index$ as $h_Lmonocle_function_Index$ };
$h_Lmonocle_function_Index$.prototype = $c_Lmonocle_function_Index$.prototype;
$c_Lmonocle_function_Index$.prototype.fromAt__Lmonocle_function_At__Lmonocle_function_Index = (function(ev) {
  var this$3 = $m_Lmonocle_function_Index$();
  var optional = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => {
    var $x_1 = ev.at__O__Lmonocle_PLens(_$1);
    var this$2 = $m_Lmonocle_std_option$();
    return $x_1.andThen__Lmonocle_POptional__Lmonocle_POptional($f_Lmonocle_std_OptionOptics__pSome__Lmonocle_PPrism(this$2));
  }));
  return new $c_Lmonocle_function_Index$$anon$1(optional, this$3);
});
$c_Lmonocle_function_Index$.prototype.seqIndex__Lmonocle_function_Index = (function() {
  var this$4 = $m_Lmonocle_function_Index$();
  var optional = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((i) => {
    var i$1 = (i | 0);
    if ((i$1 < 0)) {
      return $m_Lmonocle_Optional$().void__Lmonocle_POptional();
    } else {
      var this$3 = $m_Lmonocle_Optional$();
      var _getOption = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s) => {
        if (s.isDefinedAt__I__Z(i$1)) {
          var value = s.apply__I__O(i$1);
          return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
        } else {
          return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        }
      }));
      var _set = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((a) => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s$1) => (s$1.isDefinedAt__I__Z(i$1) ? s$1.updated__I__O__O(i$1, a) : s$1)))));
      return new $c_Lmonocle_Optional$$anon$3(_getOption, _set, this$3);
    }
  }));
  return new $c_Lmonocle_function_Index$$anon$1(optional, this$4);
});
$c_Lmonocle_function_Index$.prototype.listIndex__Lmonocle_function_Index = (function() {
  var this$4 = $m_Lmonocle_function_Index$();
  var optional = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((i) => {
    var i$1 = (i | 0);
    if ((i$1 < 0)) {
      return $m_Lmonocle_Optional$().void__Lmonocle_POptional();
    } else {
      var this$3 = $m_Lmonocle_Optional$();
      var _getOption = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(_$2, i$1, _$2).headOption__s_Option()));
      var _set = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((a) => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s) => {
        try {
          var r1 = s.updated__I__O__sci_List(i$1, a);
          var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(r1);
        } catch (e) {
          var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
          matchEnd8: {
            var $x_1;
            if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
              var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(e$2);
              break matchEnd8;
            }
            throw ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
          }
        }
        return $x_1.getOrElse__F0__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((s$3) => (() => s$3))(s)));
      }))));
      return new $c_Lmonocle_Optional$$anon$3(_getOption, _set, this$3);
    }
  }));
  return new $c_Lmonocle_function_Index$$anon$1(optional, this$4);
});
var $d_Lmonocle_function_Index$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lmonocle_function_Index$, "monocle.function.Index$", ({
  Lmonocle_function_Index$: 1,
  Lmonocle_function_IndexFunctions: 1
}));
export { $d_Lmonocle_function_Index$ as $d_Lmonocle_function_Index$ };
var $n_Lmonocle_function_Index$;
function $m_Lmonocle_function_Index$() {
  if ((!$n_Lmonocle_function_Index$)) {
    $n_Lmonocle_function_Index$ = new $c_Lmonocle_function_Index$();
  }
  return $n_Lmonocle_function_Index$;
}
export { $m_Lmonocle_function_Index$ as $m_Lmonocle_function_Index$ };
/** @constructor */
function $c_Lmonocle_internal_Bounded$() {
  this.Lmonocle_internal_Bounded$__f_booleanBounded = null;
  this.Lmonocle_internal_Bounded$__f_byteBounded = null;
  this.Lmonocle_internal_Bounded$__f_charBounded = null;
  this.Lmonocle_internal_Bounded$__f_intBounded = null;
  $n_Lmonocle_internal_Bounded$ = this;
  $f_Lmonocle_internal_BoundedInstances__$init$__V(this);
}
export { $c_Lmonocle_internal_Bounded$ as $c_Lmonocle_internal_Bounded$ };
$c_Lmonocle_internal_Bounded$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lmonocle_internal_Bounded$.prototype.constructor = $c_Lmonocle_internal_Bounded$;
/** @constructor */
function $h_Lmonocle_internal_Bounded$() {
}
export { $h_Lmonocle_internal_Bounded$ as $h_Lmonocle_internal_Bounded$ };
$h_Lmonocle_internal_Bounded$.prototype = $c_Lmonocle_internal_Bounded$.prototype;
$c_Lmonocle_internal_Bounded$.prototype.orderingBoundedSafeCast__F1__F1__Lcats_kernel_Order__Lmonocle_internal_Bounded__Lmonocle_PPrism = (function(unsafeCast, reverseCast, evidence$1, evidence$2) {
  var this$7 = $m_Lmonocle_Prism$();
  var _getOption = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((from) => {
    if ((new $c_Lcats_syntax_PartialOrderOps(from, evidence$1).$greater__O__Z(reverseCast.apply__O__O(($m_Lmonocle_internal_Bounded$(), evidence$2).MaxValue__O())) || new $c_Lcats_syntax_PartialOrderOps(from, evidence$1).$less__O__Z(reverseCast.apply__O__O(($m_Lmonocle_internal_Bounded$(), evidence$2).MinValue__O())))) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    } else {
      var value = unsafeCast.apply__O__O(from);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
    }
  }));
  return new $c_Lmonocle_Prism$$anon$3(_getOption, reverseCast, this$7);
});
var $d_Lmonocle_internal_Bounded$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lmonocle_internal_Bounded$, "monocle.internal.Bounded$", ({
  Lmonocle_internal_Bounded$: 1,
  Lmonocle_internal_BoundedInstances: 1
}));
export { $d_Lmonocle_internal_Bounded$ as $d_Lmonocle_internal_Bounded$ };
var $n_Lmonocle_internal_Bounded$;
function $m_Lmonocle_internal_Bounded$() {
  if ((!$n_Lmonocle_internal_Bounded$)) {
    $n_Lmonocle_internal_Bounded$ = new $c_Lmonocle_internal_Bounded$();
  }
  return $n_Lmonocle_internal_Bounded$;
}
export { $m_Lmonocle_internal_Bounded$ as $m_Lmonocle_internal_Bounded$ };
/** @constructor */
function $c_Lmonocle_internal_BoundedInstances$$anon$1() {
  this.Lmonocle_internal_BoundedInstances$$anon$1__f_MaxValue = false;
  this.Lmonocle_internal_BoundedInstances$$anon$1__f_MinValue = false;
  this.Lmonocle_internal_BoundedInstances$$anon$1__f_MaxValue = true;
  this.Lmonocle_internal_BoundedInstances$$anon$1__f_MinValue = false;
}
export { $c_Lmonocle_internal_BoundedInstances$$anon$1 as $c_Lmonocle_internal_BoundedInstances$$anon$1 };
$c_Lmonocle_internal_BoundedInstances$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lmonocle_internal_BoundedInstances$$anon$1.prototype.constructor = $c_Lmonocle_internal_BoundedInstances$$anon$1;
/** @constructor */
function $h_Lmonocle_internal_BoundedInstances$$anon$1() {
}
export { $h_Lmonocle_internal_BoundedInstances$$anon$1 as $h_Lmonocle_internal_BoundedInstances$$anon$1 };
$h_Lmonocle_internal_BoundedInstances$$anon$1.prototype = $c_Lmonocle_internal_BoundedInstances$$anon$1.prototype;
$c_Lmonocle_internal_BoundedInstances$$anon$1.prototype.MaxValue__O = (function() {
  return this.Lmonocle_internal_BoundedInstances$$anon$1__f_MaxValue;
});
$c_Lmonocle_internal_BoundedInstances$$anon$1.prototype.MinValue__O = (function() {
  return this.Lmonocle_internal_BoundedInstances$$anon$1__f_MinValue;
});
var $d_Lmonocle_internal_BoundedInstances$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lmonocle_internal_BoundedInstances$$anon$1, "monocle.internal.BoundedInstances$$anon$1", ({
  Lmonocle_internal_BoundedInstances$$anon$1: 1,
  Lmonocle_internal_Bounded: 1
}));
export { $d_Lmonocle_internal_BoundedInstances$$anon$1 as $d_Lmonocle_internal_BoundedInstances$$anon$1 };
/** @constructor */
function $c_Lmonocle_internal_BoundedInstances$$anon$2() {
  this.Lmonocle_internal_BoundedInstances$$anon$2__f_MaxValue = 0;
  this.Lmonocle_internal_BoundedInstances$$anon$2__f_MinValue = 0;
  this.Lmonocle_internal_BoundedInstances$$anon$2__f_MaxValue = 127;
  this.Lmonocle_internal_BoundedInstances$$anon$2__f_MinValue = (-128);
}
export { $c_Lmonocle_internal_BoundedInstances$$anon$2 as $c_Lmonocle_internal_BoundedInstances$$anon$2 };
$c_Lmonocle_internal_BoundedInstances$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lmonocle_internal_BoundedInstances$$anon$2.prototype.constructor = $c_Lmonocle_internal_BoundedInstances$$anon$2;
/** @constructor */
function $h_Lmonocle_internal_BoundedInstances$$anon$2() {
}
export { $h_Lmonocle_internal_BoundedInstances$$anon$2 as $h_Lmonocle_internal_BoundedInstances$$anon$2 };
$h_Lmonocle_internal_BoundedInstances$$anon$2.prototype = $c_Lmonocle_internal_BoundedInstances$$anon$2.prototype;
$c_Lmonocle_internal_BoundedInstances$$anon$2.prototype.MaxValue__O = (function() {
  return this.Lmonocle_internal_BoundedInstances$$anon$2__f_MaxValue;
});
$c_Lmonocle_internal_BoundedInstances$$anon$2.prototype.MinValue__O = (function() {
  return this.Lmonocle_internal_BoundedInstances$$anon$2__f_MinValue;
});
var $d_Lmonocle_internal_BoundedInstances$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lmonocle_internal_BoundedInstances$$anon$2, "monocle.internal.BoundedInstances$$anon$2", ({
  Lmonocle_internal_BoundedInstances$$anon$2: 1,
  Lmonocle_internal_Bounded: 1
}));
export { $d_Lmonocle_internal_BoundedInstances$$anon$2 as $d_Lmonocle_internal_BoundedInstances$$anon$2 };
/** @constructor */
function $c_Lmonocle_internal_BoundedInstances$$anon$3() {
  this.Lmonocle_internal_BoundedInstances$$anon$3__f_MaxValue = 0;
  this.Lmonocle_internal_BoundedInstances$$anon$3__f_MinValue = 0;
  this.Lmonocle_internal_BoundedInstances$$anon$3__f_MaxValue = 65535;
  this.Lmonocle_internal_BoundedInstances$$anon$3__f_MinValue = 0;
}
export { $c_Lmonocle_internal_BoundedInstances$$anon$3 as $c_Lmonocle_internal_BoundedInstances$$anon$3 };
$c_Lmonocle_internal_BoundedInstances$$anon$3.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lmonocle_internal_BoundedInstances$$anon$3.prototype.constructor = $c_Lmonocle_internal_BoundedInstances$$anon$3;
/** @constructor */
function $h_Lmonocle_internal_BoundedInstances$$anon$3() {
}
export { $h_Lmonocle_internal_BoundedInstances$$anon$3 as $h_Lmonocle_internal_BoundedInstances$$anon$3 };
$h_Lmonocle_internal_BoundedInstances$$anon$3.prototype = $c_Lmonocle_internal_BoundedInstances$$anon$3.prototype;
$c_Lmonocle_internal_BoundedInstances$$anon$3.prototype.MaxValue__O = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bC(this.Lmonocle_internal_BoundedInstances$$anon$3__f_MaxValue);
});
$c_Lmonocle_internal_BoundedInstances$$anon$3.prototype.MinValue__O = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bC(this.Lmonocle_internal_BoundedInstances$$anon$3__f_MinValue);
});
var $d_Lmonocle_internal_BoundedInstances$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lmonocle_internal_BoundedInstances$$anon$3, "monocle.internal.BoundedInstances$$anon$3", ({
  Lmonocle_internal_BoundedInstances$$anon$3: 1,
  Lmonocle_internal_Bounded: 1
}));
export { $d_Lmonocle_internal_BoundedInstances$$anon$3 as $d_Lmonocle_internal_BoundedInstances$$anon$3 };
/** @constructor */
function $c_Lmonocle_internal_BoundedInstances$$anon$4() {
  this.Lmonocle_internal_BoundedInstances$$anon$4__f_MaxValue = 0;
  this.Lmonocle_internal_BoundedInstances$$anon$4__f_MinValue = 0;
  this.Lmonocle_internal_BoundedInstances$$anon$4__f_MaxValue = 2147483647;
  this.Lmonocle_internal_BoundedInstances$$anon$4__f_MinValue = (-2147483648);
}
export { $c_Lmonocle_internal_BoundedInstances$$anon$4 as $c_Lmonocle_internal_BoundedInstances$$anon$4 };
$c_Lmonocle_internal_BoundedInstances$$anon$4.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lmonocle_internal_BoundedInstances$$anon$4.prototype.constructor = $c_Lmonocle_internal_BoundedInstances$$anon$4;
/** @constructor */
function $h_Lmonocle_internal_BoundedInstances$$anon$4() {
}
export { $h_Lmonocle_internal_BoundedInstances$$anon$4 as $h_Lmonocle_internal_BoundedInstances$$anon$4 };
$h_Lmonocle_internal_BoundedInstances$$anon$4.prototype = $c_Lmonocle_internal_BoundedInstances$$anon$4.prototype;
$c_Lmonocle_internal_BoundedInstances$$anon$4.prototype.MaxValue__O = (function() {
  return this.Lmonocle_internal_BoundedInstances$$anon$4__f_MaxValue;
});
$c_Lmonocle_internal_BoundedInstances$$anon$4.prototype.MinValue__O = (function() {
  return this.Lmonocle_internal_BoundedInstances$$anon$4__f_MinValue;
});
var $d_Lmonocle_internal_BoundedInstances$$anon$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lmonocle_internal_BoundedInstances$$anon$4, "monocle.internal.BoundedInstances$$anon$4", ({
  Lmonocle_internal_BoundedInstances$$anon$4: 1,
  Lmonocle_internal_Bounded: 1
}));
export { $d_Lmonocle_internal_BoundedInstances$$anon$4 as $d_Lmonocle_internal_BoundedInstances$$anon$4 };
function $f_Lmonocle_std_StringOptics__$init$__V($thiz) {
  var get = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => {
    var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Predef$().wrapString__T__sci_WrappedString(_$1);
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$1);
  }));
  var reverseGet = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__mkString__T__T__T__T(_$2, "", "", "")));
  var this$4 = $m_Lmonocle_PIso$();
  $thiz.Lmonocle_std_string$__f_stringToList = new $c_Lmonocle_PIso$$anon$3(get, reverseGet, this$4);
  var this$7 = $m_Lmonocle_Prism$();
  var _getOption = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s) => $p_Lmonocle_std_StringOptics__parseCaseSensitiveBoolean__T__s_Option($thiz, s)));
  var _reverseGet = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$3) => {
    var _$3$1 = (!(!_$3));
    return ("" + _$3$1);
  }));
  new $c_Lmonocle_Prism$$anon$3(_getOption, _reverseGet, this$7);
  var this$9 = $m_Lmonocle_Prism$();
  var _getOption$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s$2) => $p_Lmonocle_std_StringOptics__parseLong__T__s_Option($thiz, s$2)));
  var _reverseGet$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$4) => {
    var t = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(_$4);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var this$8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_RTLong$();
    return this$8.org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(lo, hi);
  }));
  $thiz.Lmonocle_std_string$__f_stringToLong = new $c_Lmonocle_Prism$$anon$3(_getOption$1, _reverseGet$1, this$9);
  $thiz.Lmonocle_std_string$__f_stringToLong.andThen__Lmonocle_PPrism__Lmonocle_PPrism($m_Lmonocle_std_long$().Lmonocle_std_long$__f_longToInt);
  $thiz.Lmonocle_std_string$__f_stringToLong.andThen__Lmonocle_PPrism__Lmonocle_PPrism($m_Lmonocle_std_long$().Lmonocle_std_long$__f_longToByte);
  var this$11 = $m_Lmonocle_Prism$();
  var _getOption$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s$3) => {
    try {
      var r1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_UUID$().fromString__T__ju_UUID(s$3);
      var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(r1);
    } catch (e) {
      var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
      matchEnd8: {
        var $x_1;
        if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
          var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(e$2);
          break matchEnd8;
        }
        throw ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
      }
    }
    return $x_1.toOption__s_Option();
  }));
  var _reverseGet$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$5) => _$5.toString__T()));
  new $c_Lmonocle_Prism$$anon$3(_getOption$2, _reverseGet$2, this$11);
  var this$13 = $m_Lmonocle_Prism$();
  var _getOption$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s$4) => {
    try {
      var r1$1 = new $c_Ljava_net_URI(s$4);
      var $x_2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(r1$1);
    } catch (e$1) {
      var e$2$1 = ((e$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e$1 : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e$1));
      matchEnd8$1: {
        var $x_2;
        if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2$1)) {
          var $x_2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(e$2$1);
          break matchEnd8$1;
        }
        throw ((e$2$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2$1.sjs_js_JavaScriptException__f_exception : e$2$1);
      }
    }
    return $x_2.toOption__s_Option();
  }));
  var _reverseGet$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$6) => _$6.Ljava_net_URI__f_origStr));
  new $c_Lmonocle_Prism$$anon$3(_getOption$3, _reverseGet$3, this$13);
}
export { $f_Lmonocle_std_StringOptics__$init$__V as $f_Lmonocle_std_StringOptics__$init$__V };
function $p_Lmonocle_std_StringOptics__parseLong__T__s_Option($thiz, s) {
  if ($ps_Lmonocle_std_StringOptics__inputBreaksPrismLaws$1__T__T__Z(s, s)) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Predef$().wrapString__T__sci_WrappedString(s);
    var x1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$1);
    if ((x1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon)) {
      var x4 = x1.sci_$colon$colon__f_next;
      if (($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uC(x1.sci_$colon$colon__f_head) === 45)) {
        var this$3 = $p_Lmonocle_std_StringOptics__parseLongUnsigned__sci_List__s_Option($thiz, x4);
        if (this$3.isEmpty__Z()) {
          return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        } else {
          var x0 = this$3.get__O();
          var t = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(x0);
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          var lo$1 = ((-lo) | 0);
          var hi$1 = ((((-hi) | 0) + ((lo | lo$1) >> 31)) | 0);
          return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$1, hi$1));
        }
      }
    }
    return $p_Lmonocle_std_StringOptics__parseLongUnsigned__sci_List__s_Option($thiz, x1);
  }
}
export { $p_Lmonocle_std_StringOptics__parseLong__T__s_Option as $p_Lmonocle_std_StringOptics__parseLong__T__s_Option };
function $p_Lmonocle_std_StringOptics__parseLongUnsigned__sci_List__s_Option($thiz, s) {
  if (s.isEmpty__Z()) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var tc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList;
    var this$3 = new $c_Lcats_Traverse$ToTraverseOps$$anon$3(s, tc);
    var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((c) => {
      var c$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uC(c);
      return $p_Lmonocle_std_StringOptics__charToDigit__C__s_Option($thiz, c$1);
    }));
    var ev$1 = $m_Lcats_instances_package$option$().Lcats_instances_package$option$__f_catsStdInstancesForOption;
    var this$4 = this$3.Lcats_Traverse$ToTraverseOps$$anon$3__f_typeClassInstance.traverse__O__F1__Lcats_Applicative__O(this$3.Lcats_Traverse$ToTraverseOps$$anon$3__f_self, f, ev$1);
    if (this$4.isEmpty__Z()) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    } else {
      var x0 = this$4.get__O();
      var acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0;
      var these = x0;
      while ((!these.isEmpty__Z())) {
        var x0$1 = acc;
        var x1 = these.head__O();
        var t = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(x0$1);
        var lo = t.RTLong__f_lo;
        var hi = t.RTLong__f_hi;
        var d = (x1 | 0);
        var b0 = (65535 & lo);
        var b1 = ((lo >>> 16) | 0);
        var a0b0 = Math.imul(10, b0);
        var a0b1 = Math.imul(10, b1);
        var lo$1 = ((a0b0 + (a0b1 << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$1 = ((Math.imul(10, hi) + ((c1part >>> 16) | 0)) | 0);
        var hi$2 = (d >> 31);
        var lo$2 = ((lo$1 + d) | 0);
        var hi$3 = ((((hi$1 + hi$2) | 0) + ((((lo$1 & d) | ((lo$1 | d) & (~lo$2))) >>> 31) | 0)) | 0);
        acc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$2, hi$3);
        these = these.tail__O();
      }
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(acc));
    }
  }
}
export { $p_Lmonocle_std_StringOptics__parseLongUnsigned__sci_List__s_Option as $p_Lmonocle_std_StringOptics__parseLongUnsigned__sci_List__s_Option };
function $p_Lmonocle_std_StringOptics__charToDigit__C__s_Option($thiz, c) {
  if (((c >= 48) && (c <= 57))) {
    var value = (((-48) + c) | 0);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
  } else {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
}
export { $p_Lmonocle_std_StringOptics__charToDigit__C__s_Option as $p_Lmonocle_std_StringOptics__charToDigit__C__s_Option };
function $p_Lmonocle_std_StringOptics__parseCaseSensitiveBoolean__T__s_Option($thiz, stringBoolean) {
  return ((stringBoolean === "true") ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(true) : ((stringBoolean === "false") ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(false) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()));
}
export { $p_Lmonocle_std_StringOptics__parseCaseSensitiveBoolean__T__s_Option as $p_Lmonocle_std_StringOptics__parseCaseSensitiveBoolean__T__s_Option };
function $ps_Lmonocle_std_StringOptics__inputBreaksPrismLaws$1__T__T__Z(s$3, input) {
  return (((s$3 === "") || (!(!s$3.startsWith("+")))) || ((!(!s$3.startsWith("0"))) && (s$3.length > 1)));
}
export { $ps_Lmonocle_std_StringOptics__inputBreaksPrismLaws$1__T__T__Z as $ps_Lmonocle_std_StringOptics__inputBreaksPrismLaws$1__T__T__Z };
/** @constructor */
function $c_Lmonocle_std_byte$() {
  this.Lmonocle_std_byte$__f_byteToBoolean = null;
  $n_Lmonocle_std_byte$ = this;
  $f_Lmonocle_std_ByteOptics__$init$__V(this);
}
export { $c_Lmonocle_std_byte$ as $c_Lmonocle_std_byte$ };
$c_Lmonocle_std_byte$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lmonocle_std_byte$.prototype.constructor = $c_Lmonocle_std_byte$;
/** @constructor */
function $h_Lmonocle_std_byte$() {
}
export { $h_Lmonocle_std_byte$ as $h_Lmonocle_std_byte$ };
$h_Lmonocle_std_byte$.prototype = $c_Lmonocle_std_byte$.prototype;
var $d_Lmonocle_std_byte$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lmonocle_std_byte$, "monocle.std.byte$", ({
  Lmonocle_std_byte$: 1,
  Lmonocle_std_ByteOptics: 1
}));
export { $d_Lmonocle_std_byte$ as $d_Lmonocle_std_byte$ };
var $n_Lmonocle_std_byte$;
function $m_Lmonocle_std_byte$() {
  if ((!$n_Lmonocle_std_byte$)) {
    $n_Lmonocle_std_byte$ = new $c_Lmonocle_std_byte$();
  }
  return $n_Lmonocle_std_byte$;
}
export { $m_Lmonocle_std_byte$ as $m_Lmonocle_std_byte$ };
/** @constructor */
function $c_Lmonocle_std_long$() {
  this.Lmonocle_std_long$__f_longToInt = null;
  this.Lmonocle_std_long$__f_longToByte = null;
  $n_Lmonocle_std_long$ = this;
  $f_Lmonocle_std_LongOptics__$init$__V(this);
}
export { $c_Lmonocle_std_long$ as $c_Lmonocle_std_long$ };
$c_Lmonocle_std_long$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lmonocle_std_long$.prototype.constructor = $c_Lmonocle_std_long$;
/** @constructor */
function $h_Lmonocle_std_long$() {
}
export { $h_Lmonocle_std_long$ as $h_Lmonocle_std_long$ };
$h_Lmonocle_std_long$.prototype = $c_Lmonocle_std_long$.prototype;
var $d_Lmonocle_std_long$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lmonocle_std_long$, "monocle.std.long$", ({
  Lmonocle_std_long$: 1,
  Lmonocle_std_LongOptics: 1
}));
export { $d_Lmonocle_std_long$ as $d_Lmonocle_std_long$ };
var $n_Lmonocle_std_long$;
function $m_Lmonocle_std_long$() {
  if ((!$n_Lmonocle_std_long$)) {
    $n_Lmonocle_std_long$ = new $c_Lmonocle_std_long$();
  }
  return $n_Lmonocle_std_long$;
}
export { $m_Lmonocle_std_long$ as $m_Lmonocle_std_long$ };
/** @constructor */
function $c_Lmonocle_std_option$() {
}
export { $c_Lmonocle_std_option$ as $c_Lmonocle_std_option$ };
$c_Lmonocle_std_option$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lmonocle_std_option$.prototype.constructor = $c_Lmonocle_std_option$;
/** @constructor */
function $h_Lmonocle_std_option$() {
}
export { $h_Lmonocle_std_option$ as $h_Lmonocle_std_option$ };
$h_Lmonocle_std_option$.prototype = $c_Lmonocle_std_option$.prototype;
var $d_Lmonocle_std_option$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lmonocle_std_option$, "monocle.std.option$", ({
  Lmonocle_std_option$: 1,
  Lmonocle_std_OptionOptics: 1
}));
export { $d_Lmonocle_std_option$ as $d_Lmonocle_std_option$ };
var $n_Lmonocle_std_option$;
function $m_Lmonocle_std_option$() {
  if ((!$n_Lmonocle_std_option$)) {
    $n_Lmonocle_std_option$ = new $c_Lmonocle_std_option$();
  }
  return $n_Lmonocle_std_option$;
}
export { $m_Lmonocle_std_option$ as $m_Lmonocle_std_option$ };
function $isArrayOf_s_Symbol(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_Symbol)));
}
export { $isArrayOf_s_Symbol as $isArrayOf_s_Symbol };
/** @constructor */
function $c_sc_BuildFromLowPriority2$$anon$11(outer) {
}
export { $c_sc_BuildFromLowPriority2$$anon$11 as $c_sc_BuildFromLowPriority2$$anon$11 };
$c_sc_BuildFromLowPriority2$$anon$11.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_sc_BuildFromLowPriority2$$anon$11.prototype.constructor = $c_sc_BuildFromLowPriority2$$anon$11;
/** @constructor */
function $h_sc_BuildFromLowPriority2$$anon$11() {
}
export { $h_sc_BuildFromLowPriority2$$anon$11 as $h_sc_BuildFromLowPriority2$$anon$11 };
$h_sc_BuildFromLowPriority2$$anon$11.prototype = $c_sc_BuildFromLowPriority2$$anon$11.prototype;
$c_sc_BuildFromLowPriority2$$anon$11.prototype.newBuilder__O__scm_Builder = (function(from) {
  return from.iterableFactory__sc_IterableFactory().newBuilder__scm_Builder();
});
var $d_sc_BuildFromLowPriority2$$anon$11 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sc_BuildFromLowPriority2$$anon$11, "scala.collection.BuildFromLowPriority2$$anon$11", ({
  sc_BuildFromLowPriority2$$anon$11: 1,
  sc_BuildFrom: 1
}));
export { $d_sc_BuildFromLowPriority2$$anon$11 as $d_sc_BuildFromLowPriority2$$anon$11 };
function $f_sc_IterableFactory__tabulate__I__F1__O($thiz, n, f) {
  return $thiz.from__sc_IterableOnce__O(new $c_sc_View$Tabulate(n, f));
}
export { $f_sc_IterableFactory__tabulate__I__F1__O as $f_sc_IterableFactory__tabulate__I__F1__O };
/** @constructor */
function $c_sci_LongMapUtils$() {
}
export { $c_sci_LongMapUtils$ as $c_sci_LongMapUtils$ };
$c_sci_LongMapUtils$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_sci_LongMapUtils$.prototype.constructor = $c_sci_LongMapUtils$;
/** @constructor */
function $h_sci_LongMapUtils$() {
}
export { $h_sci_LongMapUtils$ as $h_sci_LongMapUtils$ };
$h_sci_LongMapUtils$.prototype = $c_sci_LongMapUtils$.prototype;
$c_sci_LongMapUtils$.prototype.branchMask__J__J__J = (function(i, j) {
  var lo = (i.RTLong__f_lo ^ j.RTLong__f_lo);
  var hi = (i.RTLong__f_hi ^ j.RTLong__f_hi);
  var lo$1 = ((hi !== 0) ? 0 : (((-2147483648) >> Math.clz32(lo)) & lo));
  var hi$1 = (((-2147483648) >> Math.clz32(hi)) & hi);
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$1, hi$1);
});
$c_sci_LongMapUtils$.prototype.join__J__sci_LongMap__J__sci_LongMap__sci_LongMap = (function(p1, t1, p2, t2) {
  var t = this.branchMask__J__J__J(p1, p2);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $f_scg_BitOperations$Long__mask__J__J__J(this, p1, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi));
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return ($f_scg_BitOperations$Long__zero__J__J__Z(this, p1, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi)) ? new $c_sci_LongMap$Bin(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$1, hi$1), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi), t1, t2) : new $c_sci_LongMap$Bin(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$1, hi$1), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi), t2, t1));
});
$c_sci_LongMapUtils$.prototype.bin__J__J__sci_LongMap__sci_LongMap__sci_LongMap = (function(prefix, mask, left, right) {
  var x = $m_sci_LongMap$Nil$();
  if (x.equals__O__Z(right)) {
    return left;
  } else {
    var x$3 = $m_sci_LongMap$Nil$();
    if (x$3.equals__O__Z(left)) {
      return right;
    } else {
      return new $c_sci_LongMap$Bin(prefix, mask, left, right);
    }
  }
});
var $d_sci_LongMapUtils$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sci_LongMapUtils$, "scala.collection.immutable.LongMapUtils$", ({
  sci_LongMapUtils$: 1,
  scg_BitOperations$Long: 1
}));
export { $d_sci_LongMapUtils$ as $d_sci_LongMapUtils$ };
var $n_sci_LongMapUtils$;
function $m_sci_LongMapUtils$() {
  if ((!$n_sci_LongMapUtils$)) {
    $n_sci_LongMapUtils$ = new $c_sci_LongMapUtils$();
  }
  return $n_sci_LongMapUtils$;
}
export { $m_sci_LongMapUtils$ as $m_sci_LongMapUtils$ };
/** @constructor */
function $c_sci_RedBlackTree$MapHelper() {
  this.sci_RedBlackTree$Helper__f_ordering = null;
}
export { $c_sci_RedBlackTree$MapHelper as $c_sci_RedBlackTree$MapHelper };
$c_sci_RedBlackTree$MapHelper.prototype = new $h_sci_RedBlackTree$Helper();
$c_sci_RedBlackTree$MapHelper.prototype.constructor = $c_sci_RedBlackTree$MapHelper;
/** @constructor */
function $h_sci_RedBlackTree$MapHelper() {
}
export { $h_sci_RedBlackTree$MapHelper as $h_sci_RedBlackTree$MapHelper };
$h_sci_RedBlackTree$MapHelper.prototype = $c_sci_RedBlackTree$MapHelper.prototype;
$c_sci_RedBlackTree$MapHelper.prototype.mutableUpd__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree = (function(tree, k, v) {
  if ((tree === null)) {
    return new $c_sci_RedBlackTree$Tree(k, v, null, null, 0);
  } else if (Object.is(k, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key)) {
    return tree.mutableWithV__O__sci_RedBlackTree$Tree(v);
  } else {
    var cmp = this.sci_RedBlackTree$Helper__f_ordering.compare__O__O__I(k, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
    return ((cmp < 0) ? this.mutableBalanceLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tree, this.mutableUpd__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree(tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, k, v)) : ((cmp > 0) ? this.mutableBalanceRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tree, this.mutableUpd__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree(tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, k, v)) : tree.mutableWithV__O__sci_RedBlackTree$Tree(v)));
  }
});
/** @constructor */
function $c_sci_RedBlackTree$SetHelper() {
  this.sci_RedBlackTree$Helper__f_ordering = null;
}
export { $c_sci_RedBlackTree$SetHelper as $c_sci_RedBlackTree$SetHelper };
$c_sci_RedBlackTree$SetHelper.prototype = new $h_sci_RedBlackTree$Helper();
$c_sci_RedBlackTree$SetHelper.prototype.constructor = $c_sci_RedBlackTree$SetHelper;
/** @constructor */
function $h_sci_RedBlackTree$SetHelper() {
}
export { $h_sci_RedBlackTree$SetHelper as $h_sci_RedBlackTree$SetHelper };
$h_sci_RedBlackTree$SetHelper.prototype = $c_sci_RedBlackTree$SetHelper.prototype;
$c_sci_RedBlackTree$SetHelper.prototype.mutableUpd__sci_RedBlackTree$Tree__O__sci_RedBlackTree$Tree = (function(tree, k) {
  if ((tree === null)) {
    return new $c_sci_RedBlackTree$Tree(k, (void 0), null, null, 0);
  } else if (Object.is(k, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key)) {
    return tree;
  } else {
    var cmp = this.sci_RedBlackTree$Helper__f_ordering.compare__O__O__I(k, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
    return ((cmp < 0) ? this.mutableBalanceLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tree, this.mutableUpd__sci_RedBlackTree$Tree__O__sci_RedBlackTree$Tree(tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, k)) : ((cmp > 0) ? this.mutableBalanceRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tree, this.mutableUpd__sci_RedBlackTree$Tree__O__sci_RedBlackTree$Tree(tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, k)) : tree));
  }
});
function $f_s_concurrent_BatchingExecutor__submitSyncBatched__jl_Runnable__V($thiz, runnable) {
  if ((runnable === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException(), "runnable is null");
  }
  var tl = $thiz.s_concurrent_ExecutionContext$parasitic$__f_scala$concurrent$BatchingExecutor$$_tasksLocal;
  var b = tl.get__O();
  if ((b instanceof $c_s_concurrent_BatchingExecutor$SyncBatch)) {
    b.push__jl_Runnable__V(runnable);
  } else {
    var i = ((b !== null) ? b : 0);
    if ((i < 16)) {
      var i$1 = ((1 + i) | 0);
      tl.set__O__V(i$1);
      try {
        runnable.run__V();
      } catch (e) {
        var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
        if (false) {
          $m_s_concurrent_ExecutionContext$().s_concurrent_ExecutionContext$__f_defaultReporter.apply__O__O(e$2);
        } else if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
          $m_s_concurrent_ExecutionContext$().s_concurrent_ExecutionContext$__f_defaultReporter.apply__O__O(e$2);
        } else {
          throw ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
        }
      } finally {
        tl.set__O__V(b);
      }
    } else {
      var batch = new $c_s_concurrent_BatchingExecutor$SyncBatch($thiz, runnable);
      tl.set__O__V(batch);
      batch.run__V();
      tl.set__O__V(b);
    }
  }
}
export { $f_s_concurrent_BatchingExecutor__submitSyncBatched__jl_Runnable__V as $f_s_concurrent_BatchingExecutor__submitSyncBatched__jl_Runnable__V };
function $is_s_concurrent_BatchingExecutor(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_concurrent_BatchingExecutor)));
}
export { $is_s_concurrent_BatchingExecutor as $is_s_concurrent_BatchingExecutor };
function $isArrayOf_s_concurrent_BatchingExecutor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_BatchingExecutor)));
}
export { $isArrayOf_s_concurrent_BatchingExecutor as $isArrayOf_s_concurrent_BatchingExecutor };
/** @constructor */
function $c_s_concurrent_impl_Promise$ManyCallbacks(first, rest) {
  this.s_concurrent_impl_Promise$ManyCallbacks__f_first = null;
  this.s_concurrent_impl_Promise$ManyCallbacks__f_rest = null;
  this.s_concurrent_impl_Promise$ManyCallbacks__f_first = first;
  this.s_concurrent_impl_Promise$ManyCallbacks__f_rest = rest;
}
export { $c_s_concurrent_impl_Promise$ManyCallbacks as $c_s_concurrent_impl_Promise$ManyCallbacks };
$c_s_concurrent_impl_Promise$ManyCallbacks.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_s_concurrent_impl_Promise$ManyCallbacks.prototype.constructor = $c_s_concurrent_impl_Promise$ManyCallbacks;
/** @constructor */
function $h_s_concurrent_impl_Promise$ManyCallbacks() {
}
export { $h_s_concurrent_impl_Promise$ManyCallbacks as $h_s_concurrent_impl_Promise$ManyCallbacks };
$h_s_concurrent_impl_Promise$ManyCallbacks.prototype = $c_s_concurrent_impl_Promise$ManyCallbacks.prototype;
$c_s_concurrent_impl_Promise$ManyCallbacks.prototype.toString__T = (function() {
  return "ManyCallbacks";
});
function $isArrayOf_s_concurrent_impl_Promise$ManyCallbacks(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_impl_Promise$ManyCallbacks)));
}
export { $isArrayOf_s_concurrent_impl_Promise$ManyCallbacks as $isArrayOf_s_concurrent_impl_Promise$ManyCallbacks };
var $d_s_concurrent_impl_Promise$ManyCallbacks = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_s_concurrent_impl_Promise$ManyCallbacks, "scala.concurrent.impl.Promise$ManyCallbacks", ({
  s_concurrent_impl_Promise$ManyCallbacks: 1,
  s_concurrent_impl_Promise$Callbacks: 1
}));
export { $d_s_concurrent_impl_Promise$ManyCallbacks as $d_s_concurrent_impl_Promise$ManyCallbacks };
/** @constructor */
function $c_sr_AbstractFunction6() {
}
export { $c_sr_AbstractFunction6 as $c_sr_AbstractFunction6 };
$c_sr_AbstractFunction6.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_sr_AbstractFunction6.prototype.constructor = $c_sr_AbstractFunction6;
/** @constructor */
function $h_sr_AbstractFunction6() {
}
export { $h_sr_AbstractFunction6 as $h_sr_AbstractFunction6 };
$h_sr_AbstractFunction6.prototype = $c_sr_AbstractFunction6.prototype;
$c_sr_AbstractFunction6.prototype.toString__T = (function() {
  return "<function6>";
});
/** @constructor */
function $c_sr_LongRef(elem) {
  this.sr_LongRef__f_elem = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0;
  this.sr_LongRef__f_elem = elem;
}
export { $c_sr_LongRef as $c_sr_LongRef };
$c_sr_LongRef.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_sr_LongRef.prototype.constructor = $c_sr_LongRef;
/** @constructor */
function $h_sr_LongRef() {
}
export { $h_sr_LongRef as $h_sr_LongRef };
$h_sr_LongRef.prototype = $c_sr_LongRef.prototype;
$c_sr_LongRef.prototype.toString__T = (function() {
  var t = this.sr_LongRef__f_elem;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_RTLong$();
  return this$2.org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(lo, hi);
});
var $d_sr_LongRef = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sr_LongRef, "scala.runtime.LongRef", ({
  sr_LongRef: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sr_LongRef as $d_sr_LongRef };
/** @constructor */
function $c_s_util_NotGiven$() {
  this.s_util_NotGiven$__f_cachedValue = null;
  $n_s_util_NotGiven$ = this;
  this.s_util_NotGiven$__f_cachedValue = new $c_s_util_NotGiven();
}
export { $c_s_util_NotGiven$ as $c_s_util_NotGiven$ };
$c_s_util_NotGiven$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_s_util_NotGiven$.prototype.constructor = $c_s_util_NotGiven$;
/** @constructor */
function $h_s_util_NotGiven$() {
}
export { $h_s_util_NotGiven$ as $h_s_util_NotGiven$ };
$h_s_util_NotGiven$.prototype = $c_s_util_NotGiven$.prototype;
var $d_s_util_NotGiven$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_s_util_NotGiven$, "scala.util.NotGiven$", ({
  s_util_NotGiven$: 1,
  s_util_LowPriorityNotGiven: 1
}));
export { $d_s_util_NotGiven$ as $d_s_util_NotGiven$ };
var $n_s_util_NotGiven$;
function $m_s_util_NotGiven$() {
  if ((!$n_s_util_NotGiven$)) {
    $n_s_util_NotGiven$ = new $c_s_util_NotGiven$();
  }
  return $n_s_util_NotGiven$;
}
export { $m_s_util_NotGiven$ as $m_s_util_NotGiven$ };
function $ct_s_util_Random__ju_Random__($thiz, self) {
  $thiz.s_util_Random__f_self = self;
  return $thiz;
}
export { $ct_s_util_Random__ju_Random__ as $ct_s_util_Random__ju_Random__ };
/** @constructor */
function $c_s_util_Random() {
  this.s_util_Random__f_self = null;
}
export { $c_s_util_Random as $c_s_util_Random };
$c_s_util_Random.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_s_util_Random.prototype.constructor = $c_s_util_Random;
/** @constructor */
function $h_s_util_Random() {
}
export { $h_s_util_Random as $h_s_util_Random };
$h_s_util_Random.prototype = $c_s_util_Random.prototype;
/** @constructor */
function $c_s_util_control_NoStackTrace$() {
  this.s_util_control_NoStackTrace$__f__noSuppression = false;
  this.s_util_control_NoStackTrace$__f__noSuppression = false;
}
export { $c_s_util_control_NoStackTrace$ as $c_s_util_control_NoStackTrace$ };
$c_s_util_control_NoStackTrace$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_s_util_control_NoStackTrace$.prototype.constructor = $c_s_util_control_NoStackTrace$;
/** @constructor */
function $h_s_util_control_NoStackTrace$() {
}
export { $h_s_util_control_NoStackTrace$ as $h_s_util_control_NoStackTrace$ };
$h_s_util_control_NoStackTrace$.prototype = $c_s_util_control_NoStackTrace$.prototype;
var $d_s_util_control_NoStackTrace$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_s_util_control_NoStackTrace$, "scala.util.control.NoStackTrace$", ({
  s_util_control_NoStackTrace$: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_util_control_NoStackTrace$ as $d_s_util_control_NoStackTrace$ };
var $n_s_util_control_NoStackTrace$;
function $m_s_util_control_NoStackTrace$() {
  if ((!$n_s_util_control_NoStackTrace$)) {
    $n_s_util_control_NoStackTrace$ = new $c_s_util_control_NoStackTrace$();
  }
  return $n_s_util_control_NoStackTrace$;
}
export { $m_s_util_control_NoStackTrace$ as $m_s_util_control_NoStackTrace$ };
/** @constructor */
function $c_Lshapeless3_deriving_internals_ErasedInstances() {
}
export { $c_Lshapeless3_deriving_internals_ErasedInstances as $c_Lshapeless3_deriving_internals_ErasedInstances };
$c_Lshapeless3_deriving_internals_ErasedInstances.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lshapeless3_deriving_internals_ErasedInstances.prototype.constructor = $c_Lshapeless3_deriving_internals_ErasedInstances;
/** @constructor */
function $h_Lshapeless3_deriving_internals_ErasedInstances() {
}
export { $h_Lshapeless3_deriving_internals_ErasedInstances as $h_Lshapeless3_deriving_internals_ErasedInstances };
$h_Lshapeless3_deriving_internals_ErasedInstances.prototype = $c_Lshapeless3_deriving_internals_ErasedInstances.prototype;
function $ct_Lsttp_client3_AbstractFetchBackend__Lsttp_client3_FetchOptions__F1__Lsttp_monad_MonadError__($thiz, options, customizeRequest, monad) {
  $thiz.Lsttp_client3_AbstractFetchBackend__f_sttp$client3$AbstractFetchBackend$$options = options;
  $thiz.Lsttp_client3_AbstractFetchBackend__f_customizeRequest = customizeRequest;
  $thiz.Lsttp_client3_AbstractFetchBackend__f_sttp$client3$AbstractFetchBackend$$monad = monad;
  return $thiz;
}
export { $ct_Lsttp_client3_AbstractFetchBackend__Lsttp_client3_FetchOptions__F1__Lsttp_monad_MonadError__ as $ct_Lsttp_client3_AbstractFetchBackend__Lsttp_client3_FetchOptions__F1__Lsttp_monad_MonadError__ };
function $p_Lsttp_client3_AbstractFetchBackend__sendRegular__Lsttp_client3_RequestT__O($thiz, request) {
  var readTimeout = request.Lsttp_client3_RequestT__f_options.Lsttp_client3_RequestOptions__f_readTimeout;
  var controller = new AbortController();
  var signal = controller.signal;
  if ((readTimeout instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_FiniteDuration)) {
    var timeoutHandle = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sjs_js_timers_package$().setTimeout__s_concurrent_duration_FiniteDuration__F0__sjs_js_timers_SetTimeoutHandle(readTimeout, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
      controller.abort();
    })));
    var cancelTimeout = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sjs_js_timers_package$().clearTimeout__sjs_js_timers_SetTimeoutHandle__V(timeoutHandle);
    }));
  } else {
    var cancelTimeout = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => (void 0)));
  }
  var cancel = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    controller.abort();
  }));
  var rheaders = new Headers();
  request.Lsttp_client3_RequestT__f_headers.foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((header) => {
    var otherName = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_ContentType;
    var this$1 = header.Lsttp_model_Header__f_name;
    _return: {
      var len = this$1.length;
      if ((!((otherName === null) || (otherName.length !== len)))) {
        var i = 0;
        while ((i !== len)) {
          var index = i;
          var c = this$1.charCodeAt(index);
          var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toLowerCase__C__C($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toUpperCase__C__C(c));
          var index$1 = i;
          var c$1 = otherName.charCodeAt(index$1);
          if (($x_3 !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toLowerCase__C__C($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toUpperCase__C__C(c$1)))) {
            var $x_2 = false;
            break _return;
          }
          i = ((1 + i) | 0);
        }
        var $x_2 = true;
      } else {
        var $x_2 = false;
      }
    }
    if ($x_2) {
      var this$2 = header.Lsttp_model_Header__f_value;
      var this$3 = this$2.toLowerCase();
      var $x_1 = (!(!this$3.startsWith("multipart/")));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var this$4 = header.Lsttp_model_Header__f_value;
      var this$6 = this$4.toLowerCase();
      var this$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_MediaType$().Lsttp_model_MediaType$__f_MultipartFormData;
      var prefix = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$p_Lsttp_model_MediaType__toStringCache__T(this$5);
      if ((!(!(!this$6.startsWith(prefix))))) {
        throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), "Multipart bodies other than multipart/form-data are not supported");
      }
    } else {
      rheaders.set(header.Lsttp_model_Header__f_name, header.Lsttp_model_Header__f_value);
    }
  })));
  var r = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $p_Lsttp_client3_AbstractFetchBackend__createBody__Lsttp_client3_RequestBody__O($thiz, request.Lsttp_client3_RequestT__f_body)));
  var req = new $c_Lsttp_monad_syntax$MonadErrorOps(r).map__F1__Lsttp_monad_MonadError__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((rbody) => {
    var rredirect = (request.Lsttp_client3_RequestT__f_options.Lsttp_client3_RequestOptions__f_followRedirects ? ($m_Lorg_scalajs_dom_experimental_package$().RequestRedirect__Lorg_scalajs_dom_RequestRedirect$package$RequestRedirect$(), "follow") : ($m_Lorg_scalajs_dom_experimental_package$().RequestRedirect__Lorg_scalajs_dom_RequestRedirect$package$RequestRedirect$(), "manual"));
    var requestInitStatic = (() => {
      var request$6 = null;
      var rheaders$3 = null;
      var rbody$1 = null;
      var rredirect$1 = null;
      var rsignal$1 = null;
      var outer = null;
      request$6 = request;
      rheaders$3 = rheaders;
      rbody$1 = rbody;
      rredirect$1 = rredirect;
      rsignal$1 = signal;
      outer = $thiz;
      var this$9 = ({});
      if ((outer === null)) {
        throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
      }
      this$9.method = request$6.Lsttp_client3_RequestT__f_method.Lsttp_model_Method__f_method;
      this$9.headers = rheaders$3;
      this$9.body = rbody$1;
      this$9.referrer = (void 0);
      this$9.referrerPolicy = (void 0);
      var opt = outer.Lsttp_client3_AbstractFetchBackend__f_sttp$client3$AbstractFetchBackend$$options.Lsttp_client3_FetchOptions__f_mode;
      if (opt.isEmpty__Z()) {
        var $x_4 = (void 0);
      } else {
        var x0 = opt.get__O();
        var $x_4 = x0;
      }
      this$9.mode = $x_4;
      var opt$1 = outer.Lsttp_client3_AbstractFetchBackend__f_sttp$client3$AbstractFetchBackend$$options.Lsttp_client3_FetchOptions__f_credentials;
      if (opt$1.isEmpty__Z()) {
        var $x_5 = (void 0);
      } else {
        var x0$1 = opt$1.get__O();
        var $x_5 = x0$1;
      }
      this$9.credentials = $x_5;
      this$9.cache = (void 0);
      this$9.redirect = rredirect$1;
      this$9.integrity = (void 0);
      this$9.keepalive = (void 0);
      this$9.signal = rsignal$1;
      this$9.window = (void 0);
      return this$9;
    })();
    requestInitStatic.signal = signal;
    requestInitStatic.redirect = rredirect;
    var $x_6 = Request;
    var this$21 = request.Lsttp_client3_RequestT__f_uri;
    return new $x_6(this$21.toStringSafe__sci_Set__T($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Set$EmptySet$()), requestInitStatic);
  })), $thiz.Lsttp_client3_AbstractFetchBackend__f_sttp$client3$AbstractFetchBackend$$monad);
  var r$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    var r$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
      var r$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => req));
      return new $c_Lsttp_monad_syntax$MonadErrorOps(r$1).flatMap__F1__Lsttp_monad_MonadError__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((r$2) => {
        var $x_7 = new $c_Lsttp_client3_impl_cats_FetchCatsBackend$$anon$1($thiz);
        var p = fetch($thiz.Lsttp_client3_AbstractFetchBackend__f_customizeRequest.apply__O__O(r$2));
        return $x_7.apply__s_concurrent_Future__O($m_sjs_js_Thenable$ThenableOps$().toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p));
      })), $thiz.Lsttp_client3_AbstractFetchBackend__f_sttp$client3$AbstractFetchBackend$$monad);
    }));
    return new $c_Lsttp_monad_syntax$MonadErrorOps(r$3).flatMap__F1__Lsttp_monad_MonadError__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((resp) => ((resp.type === ($m_Lorg_scalajs_dom_experimental_package$().ResponseType__Lorg_scalajs_dom_ResponseType$package$ResponseType$(), "opaqueredirect")) ? $thiz.Lsttp_client3_AbstractFetchBackend__f_sttp$client3$AbstractFetchBackend$$monad.error__jl_Throwable__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_RuntimeException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_RuntimeException(), "Unexpected redirect")) : $thiz.Lsttp_client3_AbstractFetchBackend__f_sttp$client3$AbstractFetchBackend$$monad.unit__O__O(resp)))), $thiz.Lsttp_client3_AbstractFetchBackend__f_sttp$client3$AbstractFetchBackend$$monad);
  }));
  var result = new $c_Lsttp_monad_syntax$MonadErrorOps(r$4).flatMap__F1__Lsttp_monad_MonadError__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((resp$1) => {
    var headers = $p_Lsttp_client3_AbstractFetchBackend__convertResponseHeaders__Lorg_scalajs_dom_Headers__sci_Seq($thiz, resp$1.headers);
    $m_Lsttp_model_StatusCode$();
    var code = (resp$1.status | 0);
    var _statusText = resp$1.statusText;
    var metadata = new $c_Lsttp_model_ResponseMetadata$$anon$1(code, _statusText, headers);
    var body = $p_Lsttp_client3_AbstractFetchBackend__bodyFromResponseAs__Lsttp_client3_internal_BodyFromResponseAs($thiz).apply__Lsttp_client3_ResponseAs__Lsttp_model_ResponseMetadata__s_util_Either__O(request.Lsttp_client3_RequestT__f_response, metadata, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(resp$1));
    var r$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => body));
    return new $c_Lsttp_monad_syntax$MonadErrorOps(r$5).map__F1__Lsttp_monad_MonadError__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((b) => {
      $m_Lsttp_model_StatusCode$();
      var code$1 = (resp$1.status | 0);
      var statusText = resp$1.statusText;
      var history = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      var this$32 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_$less$colon$less$();
      var request$1 = request.onlyMetadata__s_$eq$colon$eq__Lsttp_model_RequestMetadata(this$32.s_$less$colon$less$__f_singleton);
      return new $c_Lsttp_client3_Response(b, code$1, statusText, headers, history, request$1);
    })), $thiz.Lsttp_client3_AbstractFetchBackend__f_sttp$client3$AbstractFetchBackend$$monad);
  })), $thiz.Lsttp_client3_AbstractFetchBackend__f_sttp$client3$AbstractFetchBackend$$monad);
  return $thiz.addCancelTimeoutHook__O__F0__F0__O(result, cancel, cancelTimeout);
}
export { $p_Lsttp_client3_AbstractFetchBackend__sendRegular__Lsttp_client3_RequestT__O as $p_Lsttp_client3_AbstractFetchBackend__sendRegular__Lsttp_client3_RequestT__O };
function $p_Lsttp_client3_AbstractFetchBackend__convertResponseHeaders__Lorg_scalajs_dom_Headers__sci_Seq($thiz, headers) {
  var self = headers[Symbol.iterator]();
  var this$9 = new $c_sjs_js_Iterator$WrappedIterator(self);
  var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((hs) => {
    if (((hs.length | 0) >= 2)) {
      var name = hs[0];
      var this$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_sjs_js_WrappedArray__sjs_js_Array__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_WrappedArray(), hs);
      var this$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$4);
      var this$8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this$6, 1, this$6);
      var f = ((v) => {
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_Header$();
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_model_Header(name, v);
      });
      if ((this$8 === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      } else {
        var x0 = this$8.head__O();
        var h = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
        var t = h;
        var rest = this$8.tail__O();
        while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
          var x0$1 = rest.head__O();
          var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0$1), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
          t.sci_$colon$colon__f_next = nx;
          t = nx;
          rest = rest.tail__O();
        }
        return h;
      }
    } else {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Seq$().empty__sc_SeqOps();
    }
  }));
  var this$10 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$10(this$9, f$1);
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$10);
}
export { $p_Lsttp_client3_AbstractFetchBackend__convertResponseHeaders__Lorg_scalajs_dom_Headers__sci_Seq as $p_Lsttp_client3_AbstractFetchBackend__convertResponseHeaders__Lorg_scalajs_dom_Headers__sci_Seq };
function $p_Lsttp_client3_AbstractFetchBackend__createBody__Lsttp_client3_RequestBody__O($thiz, body) {
  var x = $m_Lsttp_client3_NoBody$();
  if ((x === body)) {
    return $thiz.Lsttp_client3_AbstractFetchBackend__f_sttp$client3$AbstractFetchBackend$$monad.unit__O__O((void 0));
  }
  if ($is_Lsttp_client3_BasicRequestBody(body)) {
    return $thiz.Lsttp_client3_AbstractFetchBackend__f_sttp$client3$AbstractFetchBackend$$monad.unit__O__O($p_Lsttp_client3_AbstractFetchBackend__writeBasicBody__Lsttp_client3_BasicRequestBody__O($thiz, body));
  }
  if ((body instanceof $c_Lsttp_client3_StreamBody)) {
    var x24 = body.Lsttp_client3_StreamBody__f_b;
    return $thiz.handleStreamBody__O__O(x24);
  }
  if ((body instanceof $c_Lsttp_client3_MultipartBody)) {
    var formData = new FormData();
    body.Lsttp_client3_MultipartBody__f_parts.foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((part) => {
      matchResult5: {
        var value;
        var x7 = part.Lsttp_model_Part__f_body;
        var x$1 = $m_Lsttp_client3_NoBody$();
        if ((x$1 === x7)) {
          var array = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_B(new Int8Array([]));
          var value = array.u.slice();
          break matchResult5;
        }
        if ($is_Lsttp_client3_BasicRequestBody(x7)) {
          var value = $p_Lsttp_client3_AbstractFetchBackend__writeBasicBody__Lsttp_client3_BasicRequestBody__O($thiz, x7);
          break matchResult5;
        }
        if ((x7 instanceof $c_Lsttp_client3_StreamBody)) {
          throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), "Streaming multipart bodies are not supported");
        }
        if ((x7 instanceof $c_Lsttp_client3_MultipartBody)) {
          $m_Lsttp_client3_internal_package$().throwNestedMultipartNotAllowed__E();
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x7);
      }
      if ((!(!(value instanceof Blob)))) {
        var blob = value;
      } else {
        var $x_2 = Blob;
        var self = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterable$().apply__sci_Seq__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([value])));
        var $x_1 = new ($a_sjs_js_JSConverters$IterableAdapter())(self);
        var h = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_ContentType;
        var opt = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lsttp_model_HasHeaders__header__T__s_Option(part, h);
        if (opt.isEmpty__Z()) {
          var type = (void 0);
        } else {
          var x0 = opt.get__O();
          var type = x0;
        }
        var fields = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T2.getArrayOf().constr)([]));
        var result = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
        if ((type !== (void 0))) {
          result.type = type;
        }
        var blob = new $x_2($x_1, result);
      }
      matchResult7: {
        var x17 = part.fileName__s_Option();
        var x$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        if ((x$3 === x17)) {
          formData.append(part.Lsttp_model_Part__f_name, blob);
          break matchResult7;
        }
        if ((x17 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
          var fileName = x17.s_Some__f_value;
          formData.append(part.Lsttp_model_Part__f_name, blob, fileName);
          break matchResult7;
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x17);
      }
    })));
    return $thiz.Lsttp_client3_AbstractFetchBackend__f_sttp$client3$AbstractFetchBackend$$monad.unit__O__O(formData);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(body);
}
export { $p_Lsttp_client3_AbstractFetchBackend__createBody__Lsttp_client3_RequestBody__O as $p_Lsttp_client3_AbstractFetchBackend__createBody__Lsttp_client3_RequestBody__O };
function $p_Lsttp_client3_AbstractFetchBackend__writeBasicBody__Lsttp_client3_BasicRequestBody__O($thiz, body) {
  if ((body instanceof $c_Lsttp_client3_StringBody)) {
    var x45 = body.Lsttp_client3_StringBody__f_s;
    var x46 = body.Lsttp_client3_StringBody__f_encoding;
    if (($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__compareToIgnoreCase__T__I(x46, "utf-8") === 0)) {
      return x45;
    } else {
      var array = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__getBytes__T__AB(x45, x46);
      return array.u.slice();
    }
  }
  if ((body instanceof $c_Lsttp_client3_ByteArrayBody)) {
    var x41 = body.Lsttp_client3_ByteArrayBody__f_b;
    return x41.u.slice();
  }
  if ((body instanceof $c_Lsttp_client3_ByteBufferBody)) {
    var x37 = body.Lsttp_client3_ByteBufferBody__f_b;
    var array$1 = $p_Lsttp_client3_AbstractFetchBackend__byteBufferToArray__Ljava_nio_ByteBuffer__AB($thiz, x37);
    return array$1.u.slice();
  }
  if ((body instanceof $c_Lsttp_client3_InputStreamBody)) {
    var x33 = body.Lsttp_client3_InputStreamBody__f_b;
    var array$2 = $m_Lsttp_client3_internal_package$().toByteArray__Ljava_io_InputStream__AB(x33);
    return array$2.u.slice();
  }
  if ((body instanceof $c_Lsttp_client3_FileBody)) {
    var x29 = body.Lsttp_client3_FileBody__f_f;
    return x29.Lsttp_client3_internal_SttpFile__f_underlying;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(body);
}
export { $p_Lsttp_client3_AbstractFetchBackend__writeBasicBody__Lsttp_client3_BasicRequestBody__O as $p_Lsttp_client3_AbstractFetchBackend__writeBasicBody__Lsttp_client3_BasicRequestBody__O };
function $p_Lsttp_client3_AbstractFetchBackend__byteBufferToArray__Ljava_nio_ByteBuffer__AB($thiz, bb) {
  var dimensions = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I(new Int32Array([((bb.Ljava_nio_Buffer__f__limit - bb.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0)]));
  var b = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_reflect_Array$().newInstance__jl_Class__AI__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_B.getClassOf(), dimensions);
  bb.get__AB__I__I__Ljava_nio_ByteBuffer(b, 0, b.u.length);
  return b;
}
export { $p_Lsttp_client3_AbstractFetchBackend__byteBufferToArray__Ljava_nio_ByteBuffer__AB as $p_Lsttp_client3_AbstractFetchBackend__byteBufferToArray__Ljava_nio_ByteBuffer__AB };
function $p_Lsttp_client3_AbstractFetchBackend__sendWebSocket__Lsttp_client3_RequestT__O($thiz, request) {
  var queue = new $c_Lsttp_client3_JSSimpleQueue(new $c_Lsttp_client3_impl_cats_FetchCatsBackend$$anon$1($thiz));
  var $x_1 = WebSocket;
  var this$1 = request.Lsttp_client3_RequestT__f_uri;
  var ws = new $x_1(this$1.toStringSafe__sci_Set__T($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Set$EmptySet$()));
  ws.binaryType = "arraybuffer";
  var isOpen = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
  ws.onopen = ((_$3) => {
    $f_s_concurrent_Promise__success__O__s_concurrent_Promise(isOpen, (void 0));
    queue.offer__O__V(new $c_Lsttp_client3_internal_ws_WebSocketEvent$Open());
  });
  ws.onmessage = ((event) => {
    queue.offer__O__V($p_Lsttp_client3_AbstractFetchBackend__toWebSocketEvent__Lorg_scalajs_dom_MessageEvent__Lsttp_client3_internal_ws_WebSocketEvent($thiz, event));
  });
  ws.onerror = ((_$4) => {
    if ((!isOpen.isCompleted__Z())) {
      var cause = $ct_Lsttp_client3_SttpClientException$ReadException__Lsttp_client3_RequestT__jl_Exception__(new $c_Lsttp_client3_SttpClientException$ReadException(), request, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_RuntimeException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_RuntimeException(), "Something went wrong in web socket or it could not be opened"));
      return $f_s_concurrent_Promise__failure__jl_Throwable__s_concurrent_Promise(isOpen, cause);
    } else {
      var t = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_RuntimeException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_RuntimeException(), "Something went wrong in web socket or it could not be opened");
      queue.offer__O__V(new $c_Lsttp_client3_internal_ws_WebSocketEvent$Error(t));
      return (void 0);
    }
  });
  ws.onclose = ((event$2) => {
    queue.offer__O__V($p_Lsttp_client3_AbstractFetchBackend__toWebSocketEvent__Lorg_scalajs_dom_CloseEvent__Lsttp_client3_internal_ws_WebSocketEvent($thiz, event$2));
  });
  var r = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => new $c_Lsttp_client3_impl_cats_FetchCatsBackend$$anon$1($thiz).apply__s_concurrent_Future__O(isOpen)));
  return new $c_Lsttp_monad_syntax$MonadErrorOps(r).flatMap__F1__Lsttp_monad_MonadError__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$5) => {
    var monad = $thiz.Lsttp_client3_AbstractFetchBackend__f_sttp$client3$AbstractFetchBackend$$monad;
    var webSocket = new $c_Lsttp_client3_WebSocketImpl(ws, queue, monad);
    var r$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
      var r$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
        var $x_3 = $p_Lsttp_client3_AbstractFetchBackend__bodyFromResponseAs__Lsttp_client3_internal_BodyFromResponseAs($thiz);
        var $x_2 = request.Lsttp_client3_RequestT__f_response;
        var statusCode = $m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_Ok;
        var _headers = request.Lsttp_client3_RequestT__f_headers;
        return $x_3.apply__Lsttp_client3_ResponseAs__Lsttp_model_ResponseMetadata__s_util_Either__O($x_2, new $c_Lsttp_model_ResponseMetadata$$anon$1(statusCode, "", _headers), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(webSocket));
      }));
      return new $c_Lsttp_monad_syntax$MonadErrorOps(r$1).map__F1__Lsttp_monad_MonadError__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((body) => {
        var this$12 = $m_Lsttp_client3_Response$();
        return this$12.apply__O__I__Lsttp_client3_Response(body, $m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_Ok);
      })), $thiz.Lsttp_client3_AbstractFetchBackend__f_sttp$client3$AbstractFetchBackend$$monad);
    }));
    return new $c_Lsttp_monad_syntax$MonadErrorOps(r$2).map__F1__Lsttp_monad_MonadError__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$6) => {
      var this$14 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_$less$colon$less$();
      var request$1 = request.onlyMetadata__s_$eq$colon$eq__Lsttp_model_RequestMetadata(this$14.s_$less$colon$less$__f_singleton);
      var body$1 = _$6.Lsttp_client3_Response__f_body;
      var code$1 = _$6.Lsttp_client3_Response__f_code;
      var statusText$1 = _$6.Lsttp_client3_Response__f_statusText;
      var headers$1 = _$6.Lsttp_client3_Response__f_headers;
      var history$1 = _$6.Lsttp_client3_Response__f_history;
      return new $c_Lsttp_client3_Response(body$1, code$1, statusText$1, headers$1, history$1, request$1);
    })), $thiz.Lsttp_client3_AbstractFetchBackend__f_sttp$client3$AbstractFetchBackend$$monad);
  })), $thiz.Lsttp_client3_AbstractFetchBackend__f_sttp$client3$AbstractFetchBackend$$monad);
}
export { $p_Lsttp_client3_AbstractFetchBackend__sendWebSocket__Lsttp_client3_RequestT__O as $p_Lsttp_client3_AbstractFetchBackend__sendWebSocket__Lsttp_client3_RequestT__O };
function $p_Lsttp_client3_AbstractFetchBackend__toWebSocketEvent__Lorg_scalajs_dom_MessageEvent__Lsttp_client3_internal_ws_WebSocketEvent($thiz, msg) {
  var x48 = msg.data;
  if ((!(!(x48 instanceof ArrayBuffer)))) {
    var dv = new DataView(x48);
    var dimensions = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I(new Int32Array([(dv.byteLength | 0)]));
    var bytes = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_reflect_Array$().newInstance__jl_Class__AI__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_B.getClassOf(), dimensions);
    var end = (dv.byteLength | 0);
    var isEmpty = (end <= 0);
    var scala$collection$immutable$Range$$lastElement = (((-1) + end) | 0);
    if ((!isEmpty)) {
      var i = 0;
      while (true) {
        var x0 = i;
        bytes.u[x0] = (dv.getInt8(x0) | 0);
        if ((i === scala$collection$immutable$Range$$lastElement)) {
          break;
        }
        i = ((1 + i) | 0);
      }
    }
    var rsv = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    var f = new $c_Lsttp_ws_WebSocketFrame$Binary(bytes, true, rsv);
    return new $c_Lsttp_client3_internal_ws_WebSocketEvent$Frame(f);
  }
  if (((typeof x48) === "string")) {
    var rsv$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_ws_WebSocketFrame$Text(x48, true, rsv$1);
    return new $c_Lsttp_client3_internal_ws_WebSocketEvent$Frame(f$1);
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_RuntimeException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_RuntimeException(), ("Unknown format of event.data " + msg.data));
}
export { $p_Lsttp_client3_AbstractFetchBackend__toWebSocketEvent__Lorg_scalajs_dom_MessageEvent__Lsttp_client3_internal_ws_WebSocketEvent as $p_Lsttp_client3_AbstractFetchBackend__toWebSocketEvent__Lorg_scalajs_dom_MessageEvent__Lsttp_client3_internal_ws_WebSocketEvent };
function $p_Lsttp_client3_AbstractFetchBackend__toWebSocketEvent__Lorg_scalajs_dom_CloseEvent__Lsttp_client3_internal_ws_WebSocketEvent($thiz, close) {
  var statusCode = (close.code | 0);
  var reasonText = close.reason;
  var f = new $c_Lsttp_ws_WebSocketFrame$Close(statusCode, reasonText);
  return new $c_Lsttp_client3_internal_ws_WebSocketEvent$Frame(f);
}
export { $p_Lsttp_client3_AbstractFetchBackend__toWebSocketEvent__Lorg_scalajs_dom_CloseEvent__Lsttp_client3_internal_ws_WebSocketEvent as $p_Lsttp_client3_AbstractFetchBackend__toWebSocketEvent__Lorg_scalajs_dom_CloseEvent__Lsttp_client3_internal_ws_WebSocketEvent };
function $p_Lsttp_client3_AbstractFetchBackend__bodyFromResponseAs__Lsttp_client3_internal_BodyFromResponseAs($thiz) {
  if ((!$thiz.Lsttp_client3_AbstractFetchBackend__f_bodyFromResponseAsbitmap$1)) {
    $thiz.Lsttp_client3_AbstractFetchBackend__f_bodyFromResponseAs$lzy1 = new $c_Lsttp_client3_AbstractFetchBackend$$anon$2($thiz);
    $thiz.Lsttp_client3_AbstractFetchBackend__f_bodyFromResponseAsbitmap$1 = true;
  }
  return $thiz.Lsttp_client3_AbstractFetchBackend__f_bodyFromResponseAs$lzy1;
}
export { $p_Lsttp_client3_AbstractFetchBackend__bodyFromResponseAs__Lsttp_client3_internal_BodyFromResponseAs as $p_Lsttp_client3_AbstractFetchBackend__bodyFromResponseAs__Lsttp_client3_internal_BodyFromResponseAs };
/** @constructor */
function $c_Lsttp_client3_AbstractFetchBackend() {
  this.Lsttp_client3_AbstractFetchBackend__f_sttp$client3$AbstractFetchBackend$$options = null;
  this.Lsttp_client3_AbstractFetchBackend__f_customizeRequest = null;
  this.Lsttp_client3_AbstractFetchBackend__f_sttp$client3$AbstractFetchBackend$$monad = null;
  this.Lsttp_client3_AbstractFetchBackend__f_bodyFromResponseAs$lzy1 = null;
  this.Lsttp_client3_AbstractFetchBackend__f_bodyFromResponseAsbitmap$1 = false;
}
export { $c_Lsttp_client3_AbstractFetchBackend as $c_Lsttp_client3_AbstractFetchBackend };
$c_Lsttp_client3_AbstractFetchBackend.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_AbstractFetchBackend.prototype.constructor = $c_Lsttp_client3_AbstractFetchBackend;
/** @constructor */
function $h_Lsttp_client3_AbstractFetchBackend() {
}
export { $h_Lsttp_client3_AbstractFetchBackend as $h_Lsttp_client3_AbstractFetchBackend };
$h_Lsttp_client3_AbstractFetchBackend.prototype = $c_Lsttp_client3_AbstractFetchBackend.prototype;
$c_Lsttp_client3_AbstractFetchBackend.prototype.send__Lsttp_client3_RequestT__O = (function(request) {
  var this$2 = $m_Lsttp_client3_SttpClientException$();
  var monadError = this.Lsttp_client3_AbstractFetchBackend__f_sttp$client3$AbstractFetchBackend$$monad;
  var usingFn = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => {
    var this$1 = $m_Lsttp_client3_SttpClientException$();
    return $f_Lsttp_client3_SttpClientExceptionExtensions__defaultExceptionToSttpClientException__Lsttp_client3_RequestT__jl_Exception__s_Option(this$1, request, _$2);
  }));
  var h = new $c_Lsttp_client3_SttpClientException$$anon$1(monadError, usingFn, this$2);
  try {
    return monadError.handleWrappedError__O__s_PartialFunction__O(($m_Lsttp_client3_ResponseAs$().isWebSocket__Lsttp_client3_ResponseAs__Z(request.Lsttp_client3_RequestT__f_response) ? $p_Lsttp_client3_AbstractFetchBackend__sendWebSocket__Lsttp_client3_RequestT__O(this, request) : $p_Lsttp_client3_AbstractFetchBackend__sendRegular__Lsttp_client3_RequestT__O(this, request)), h);
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
    if (h.isDefinedAt__jl_Throwable__Z(e$2)) {
      var default$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_PartialFunction$().s_PartialFunction$__f_empty_pf;
      return h.applyOrElse__jl_Throwable__F1__O(e$2, default$1);
    } else {
      return monadError.error__jl_Throwable__O(e$2);
    }
  }
});
/** @constructor */
function $c_Lsttp_client3_AbstractFetchBackend$$anon$2(outer) {
  this.Lsttp_client3_internal_BodyFromResponseAs__f_m = null;
  this.Lsttp_client3_AbstractFetchBackend$$anon$2__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lsttp_client3_AbstractFetchBackend$$anon$2__f_$outer = outer;
  $ct_Lsttp_client3_internal_BodyFromResponseAs__Lsttp_monad_MonadError__(this, outer.Lsttp_client3_AbstractFetchBackend__f_sttp$client3$AbstractFetchBackend$$monad);
}
export { $c_Lsttp_client3_AbstractFetchBackend$$anon$2 as $c_Lsttp_client3_AbstractFetchBackend$$anon$2 };
$c_Lsttp_client3_AbstractFetchBackend$$anon$2.prototype = new $h_Lsttp_client3_internal_BodyFromResponseAs();
$c_Lsttp_client3_AbstractFetchBackend$$anon$2.prototype.constructor = $c_Lsttp_client3_AbstractFetchBackend$$anon$2;
/** @constructor */
function $h_Lsttp_client3_AbstractFetchBackend$$anon$2() {
}
export { $h_Lsttp_client3_AbstractFetchBackend$$anon$2 as $h_Lsttp_client3_AbstractFetchBackend$$anon$2 };
$h_Lsttp_client3_AbstractFetchBackend$$anon$2.prototype = $c_Lsttp_client3_AbstractFetchBackend$$anon$2.prototype;
$c_Lsttp_client3_AbstractFetchBackend$$anon$2.prototype.withReplayableBody__Lorg_scalajs_dom_Response__s_util_Either__O = (function(response, replayableBody) {
  matchResult11: {
    var bytes;
    if ((replayableBody instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
      var byteArray = replayableBody.s_util_Left__f_value;
      var bytes = byteArray;
      break matchResult11;
    }
    if ((replayableBody instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), "Replayable file bodies are not supported");
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(replayableBody);
  }
  var v = new Response(bytes.u.slice(), response);
  var ME = this.Lsttp_client3_AbstractFetchBackend$$anon$2__f_$outer.Lsttp_client3_AbstractFetchBackend__f_sttp$client3$AbstractFetchBackend$$monad;
  return ME.unit__O__O(v);
});
$c_Lsttp_client3_AbstractFetchBackend$$anon$2.prototype.regularIgnore__Lorg_scalajs_dom_Response__O = (function(response) {
  var r = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    var this$2 = this.Lsttp_client3_AbstractFetchBackend$$anon$2__f_$outer;
    var $x_1 = new $c_Lsttp_client3_impl_cats_FetchCatsBackend$$anon$1(this$2);
    var p = response.arrayBuffer();
    return $x_1.apply__s_concurrent_Future__O($m_sjs_js_Thenable$ThenableOps$().toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p));
  }));
  return new $c_Lsttp_monad_syntax$MonadErrorOps(r).map__F1__Lsttp_monad_MonadError__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$7) => (void 0))), this.Lsttp_client3_AbstractFetchBackend$$anon$2__f_$outer.Lsttp_client3_AbstractFetchBackend__f_sttp$client3$AbstractFetchBackend$$monad);
});
$c_Lsttp_client3_AbstractFetchBackend$$anon$2.prototype.regularAsByteArray__Lorg_scalajs_dom_Response__O = (function(response) {
  var r = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    var this$2 = this.Lsttp_client3_AbstractFetchBackend$$anon$2__f_$outer;
    var $x_1 = new $c_Lsttp_client3_impl_cats_FetchCatsBackend$$anon$1(this$2);
    var p = response.arrayBuffer();
    return $x_1.apply__s_concurrent_Future__O($m_sjs_js_Thenable$ThenableOps$().toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p));
  }));
  return new $c_Lsttp_monad_syntax$MonadErrorOps(r).map__F1__Lsttp_monad_MonadError__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((ab) => {
    var array = new Int8Array(ab);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_B(array.slice());
  })), this.Lsttp_client3_AbstractFetchBackend$$anon$2__f_$outer.Lsttp_client3_AbstractFetchBackend__f_sttp$client3$AbstractFetchBackend$$monad);
});
$c_Lsttp_client3_AbstractFetchBackend$$anon$2.prototype.regularAsFile__Lorg_scalajs_dom_Response__Lsttp_client3_internal_SttpFile__O = (function(response, file) {
  var r = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    var this$2 = this.Lsttp_client3_AbstractFetchBackend$$anon$2__f_$outer;
    var $x_1 = new $c_Lsttp_client3_impl_cats_FetchCatsBackend$$anon$1(this$2);
    var p = response.arrayBuffer();
    return $x_1.apply__s_concurrent_Future__O($m_sjs_js_Thenable$ThenableOps$().toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p));
  }));
  return new $c_Lsttp_monad_syntax$MonadErrorOps(r).map__F1__Lsttp_monad_MonadError__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((ab) => {
    var $x_4 = File;
    var self = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterable$().apply__sci_Seq__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([ab])));
    var $x_3 = new ($a_sjs_js_JSConverters$IterableAdapter())(self);
    var $x_2 = file.Lsttp_client3_internal_SttpFileCompanionExtensions$$anon$1__f_name;
    var type = file.Lsttp_client3_internal_SttpFile__f_underlying.type;
    var fields = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T2.getArrayOf().constr)([]));
    var result = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
    if ((type !== (void 0))) {
      result.type = type;
    }
    var file$1 = new $x_4($x_3, $x_2, result);
    return new $c_Lsttp_client3_internal_SttpFileCompanionExtensions$$anon$1(file$1);
  })), this.Lsttp_client3_AbstractFetchBackend$$anon$2__f_$outer.Lsttp_client3_AbstractFetchBackend__f_sttp$client3$AbstractFetchBackend$$monad);
});
$c_Lsttp_client3_AbstractFetchBackend$$anon$2.prototype.regularAsStream__Lorg_scalajs_dom_Response__O = (function(response) {
  return this.Lsttp_client3_AbstractFetchBackend$$anon$2__f_$outer.handleResponseAsStream__Lorg_scalajs_dom_Response__O(response);
});
$c_Lsttp_client3_AbstractFetchBackend$$anon$2.prototype.handleWS__Lsttp_client3_WebSocketResponseAs__Lsttp_model_ResponseMetadata__Lsttp_ws_WebSocket__O = (function(responseAs, meta, ws) {
  if (false) {
    var x64 = responseAs.Lsttp_client3_ResponseAsWebSocket__f_f;
    return x64.apply__O__O__O(ws, meta);
  }
  if ((responseAs instanceof $c_Lsttp_client3_ResponseAsWebSocketUnsafe)) {
    var ME = this.Lsttp_client3_AbstractFetchBackend$$anon$2__f_$outer.Lsttp_client3_AbstractFetchBackend__f_sttp$client3$AbstractFetchBackend$$monad;
    return ME.unit__O__O(ws);
  }
  if (false) {
    var x60 = responseAs.Lsttp_client3_ResponseAsWebSocketStream__f_p;
    return this.Lsttp_client3_AbstractFetchBackend$$anon$2__f_$outer.compileWebSocketPipe__Lsttp_ws_WebSocket__O__O(ws, x60);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(responseAs);
});
$c_Lsttp_client3_AbstractFetchBackend$$anon$2.prototype.cleanupWhenNotAWebSocket__Lorg_scalajs_dom_Response__Lsttp_client3_ws_NotAWebSocketException__O = (function(response, e) {
  return this.Lsttp_client3_AbstractFetchBackend$$anon$2__f_$outer.Lsttp_client3_AbstractFetchBackend__f_sttp$client3$AbstractFetchBackend$$monad.unit__O__O((void 0));
});
$c_Lsttp_client3_AbstractFetchBackend$$anon$2.prototype.cleanupWhenGotWebSocket__Lsttp_ws_WebSocket__Lsttp_client3_ws_GotAWebSocketException__O = (function(response, e) {
  return this.Lsttp_client3_AbstractFetchBackend$$anon$2__f_$outer.Lsttp_client3_AbstractFetchBackend__f_sttp$client3$AbstractFetchBackend$$monad.unit__O__O((response.send__Lsttp_ws_WebSocketFrame__Z__O(new $c_Lsttp_ws_WebSocketFrame$Close(1000, "normal closure"), false), (void 0)));
});
var $d_Lsttp_client3_AbstractFetchBackend$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_AbstractFetchBackend$$anon$2, "sttp.client3.AbstractFetchBackend$$anon$2", ({
  Lsttp_client3_AbstractFetchBackend$$anon$2: 1,
  Lsttp_client3_internal_BodyFromResponseAs: 1
}));
export { $d_Lsttp_client3_AbstractFetchBackend$$anon$2 as $d_Lsttp_client3_AbstractFetchBackend$$anon$2 };
function $is_Lsttp_client3_BasicRequestBody(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsttp_client3_BasicRequestBody)));
}
export { $is_Lsttp_client3_BasicRequestBody as $is_Lsttp_client3_BasicRequestBody };
function $isArrayOf_Lsttp_client3_BasicRequestBody(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_client3_BasicRequestBody)));
}
export { $isArrayOf_Lsttp_client3_BasicRequestBody as $isArrayOf_Lsttp_client3_BasicRequestBody };
/** @constructor */
function $c_Lsttp_client3_JSSimpleQueue(fromFuture) {
  this.Lsttp_client3_JSSimpleQueue__f_state = null;
  var elems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_sr_Nothing$.getArrayOf().constr)([]));
  var value = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  this.Lsttp_client3_JSSimpleQueue__f_state = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value);
}
export { $c_Lsttp_client3_JSSimpleQueue as $c_Lsttp_client3_JSSimpleQueue };
$c_Lsttp_client3_JSSimpleQueue.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_JSSimpleQueue.prototype.constructor = $c_Lsttp_client3_JSSimpleQueue;
/** @constructor */
function $h_Lsttp_client3_JSSimpleQueue() {
}
export { $h_Lsttp_client3_JSSimpleQueue as $h_Lsttp_client3_JSSimpleQueue };
$h_Lsttp_client3_JSSimpleQueue.prototype = $c_Lsttp_client3_JSSimpleQueue.prototype;
$c_Lsttp_client3_JSSimpleQueue.prototype.offer__O__V = (function(t) {
  var x1 = this.Lsttp_client3_JSSimpleQueue__f_state;
  if ((x1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
    var x7 = x1.s_util_Left__f_value;
    if ((x7 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon)) {
      var x10 = x7.sci_$colon$colon__f_next;
      var p = x7.sci_$colon$colon__f_head;
      $f_s_concurrent_Promise__success__O__s_concurrent_Promise(p, t);
      this.Lsttp_client3_JSSimpleQueue__f_state = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(x10);
      return (void 0);
    }
    var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    if (x.equals__O__Z(x7)) {
      var elems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([t]));
      var value = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
      this.Lsttp_client3_JSSimpleQueue__f_state = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value);
      return (void 0);
    }
  }
  if ((x1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
    var elems$1 = x1.s_util_Right__f_value;
    var value$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedSeqOps__appended__O__O(elems$1, t);
    this.Lsttp_client3_JSSimpleQueue__f_state = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value$1);
    return (void 0);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1);
});
var $d_Lsttp_client3_JSSimpleQueue = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_JSSimpleQueue, "sttp.client3.JSSimpleQueue", ({
  Lsttp_client3_JSSimpleQueue: 1,
  Lsttp_client3_internal_ws_SimpleQueue: 1
}));
export { $d_Lsttp_client3_JSSimpleQueue as $d_Lsttp_client3_JSSimpleQueue };
/** @constructor */
function $c_Lsttp_client3_SttpClientException$() {
}
export { $c_Lsttp_client3_SttpClientException$ as $c_Lsttp_client3_SttpClientException$ };
$c_Lsttp_client3_SttpClientException$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_SttpClientException$.prototype.constructor = $c_Lsttp_client3_SttpClientException$;
/** @constructor */
function $h_Lsttp_client3_SttpClientException$() {
}
export { $h_Lsttp_client3_SttpClientException$ as $h_Lsttp_client3_SttpClientException$ };
$h_Lsttp_client3_SttpClientException$.prototype = $c_Lsttp_client3_SttpClientException$.prototype;
var $d_Lsttp_client3_SttpClientException$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_SttpClientException$, "sttp.client3.SttpClientException$", ({
  Lsttp_client3_SttpClientException$: 1,
  Lsttp_client3_SttpClientExceptionExtensions: 1
}));
export { $d_Lsttp_client3_SttpClientException$ as $d_Lsttp_client3_SttpClientException$ };
var $n_Lsttp_client3_SttpClientException$;
function $m_Lsttp_client3_SttpClientException$() {
  if ((!$n_Lsttp_client3_SttpClientException$)) {
    $n_Lsttp_client3_SttpClientException$ = new $c_Lsttp_client3_SttpClientException$();
  }
  return $n_Lsttp_client3_SttpClientException$;
}
export { $m_Lsttp_client3_SttpClientException$ as $m_Lsttp_client3_SttpClientException$ };
/** @constructor */
function $c_Lsttp_client3_WebSocketImpl(ws, queue, monad) {
  this.Lsttp_client3_WebSocketImpl__f_ws = null;
  this.Lsttp_client3_WebSocketImpl__f_monad = null;
  this.Lsttp_client3_WebSocketImpl__f_ws = ws;
  this.Lsttp_client3_WebSocketImpl__f_monad = monad;
}
export { $c_Lsttp_client3_WebSocketImpl as $c_Lsttp_client3_WebSocketImpl };
$c_Lsttp_client3_WebSocketImpl.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_WebSocketImpl.prototype.constructor = $c_Lsttp_client3_WebSocketImpl;
/** @constructor */
function $h_Lsttp_client3_WebSocketImpl() {
}
export { $h_Lsttp_client3_WebSocketImpl as $h_Lsttp_client3_WebSocketImpl };
$h_Lsttp_client3_WebSocketImpl.prototype = $c_Lsttp_client3_WebSocketImpl.prototype;
$c_Lsttp_client3_WebSocketImpl.prototype.send__Lsttp_ws_WebSocketFrame__Z__O = (function(f, isContinuation) {
  if ((f instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_ws_WebSocketFrame$Text)) {
    var x32 = f.Lsttp_ws_WebSocketFrame$Text__f_payload;
    return this.Lsttp_client3_WebSocketImpl__f_monad.unit__O__O((this.Lsttp_client3_WebSocketImpl__f_ws.send(x32), (void 0)));
  }
  if ((f instanceof $c_Lsttp_ws_WebSocketFrame$Binary)) {
    var x27 = f.Lsttp_ws_WebSocketFrame$Binary__f_payload;
    var ab = x27.u.slice().buffer;
    return this.Lsttp_client3_WebSocketImpl__f_monad.unit__O__O((this.Lsttp_client3_WebSocketImpl__f_ws.send(ab), (void 0)));
  }
  if ((f instanceof $c_Lsttp_ws_WebSocketFrame$Close)) {
    var x23 = f.Lsttp_ws_WebSocketFrame$Close__f_statusCode;
    var x24 = f.Lsttp_ws_WebSocketFrame$Close__f_reasonText;
    var r = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => this.isOpen__O()));
    return new $c_Lsttp_monad_syntax$MonadErrorOps(r).flatMap__F1__Lsttp_monad_MonadError__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((open) => {
      var open$1 = (!(!open));
      if (open$1) {
        return this.Lsttp_client3_WebSocketImpl__f_monad.unit__O__O((this.Lsttp_client3_WebSocketImpl__f_ws.close(x23, x24), (void 0)));
      } else {
        var ME = this.Lsttp_client3_WebSocketImpl__f_monad;
        return ME.unit__O__O((void 0));
      }
    })), this.Lsttp_client3_WebSocketImpl__f_monad);
  }
  if ((f instanceof $c_Lsttp_ws_WebSocketFrame$Ping)) {
    return this.Lsttp_client3_WebSocketImpl__f_monad.error__jl_Throwable__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_UnsupportedOperationException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_UnsupportedOperationException(), "Ping is not supported in browsers"));
  }
  if (false) {
    return this.Lsttp_client3_WebSocketImpl__f_monad.error__jl_Throwable__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_UnsupportedOperationException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_UnsupportedOperationException(), "Pong is not supported in browsers"));
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(f);
});
$c_Lsttp_client3_WebSocketImpl.prototype.isOpen__O = (function() {
  return this.Lsttp_client3_WebSocketImpl__f_monad.eval__F0__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => ((this.Lsttp_client3_WebSocketImpl__f_ws.readyState | 0) === 1))));
});
var $d_Lsttp_client3_WebSocketImpl = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_WebSocketImpl, "sttp.client3.WebSocketImpl", ({
  Lsttp_client3_WebSocketImpl: 1,
  Lsttp_ws_WebSocket: 1
}));
export { $d_Lsttp_client3_WebSocketImpl as $d_Lsttp_client3_WebSocketImpl };
function $is_Lsttp_client3_WebSocketResponseAs(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsttp_client3_WebSocketResponseAs)));
}
export { $is_Lsttp_client3_WebSocketResponseAs as $is_Lsttp_client3_WebSocketResponseAs };
function $isArrayOf_Lsttp_client3_WebSocketResponseAs(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_client3_WebSocketResponseAs)));
}
export { $isArrayOf_Lsttp_client3_WebSocketResponseAs as $isArrayOf_Lsttp_client3_WebSocketResponseAs };
function $ct_Lsttp_client3_impl_cats_CatsMonadError__Lcats_effect_kernel_Sync__($thiz, F) {
  $thiz.Lsttp_client3_impl_cats_CatsMonadError__f_F = F;
  return $thiz;
}
export { $ct_Lsttp_client3_impl_cats_CatsMonadError__Lcats_effect_kernel_Sync__ as $ct_Lsttp_client3_impl_cats_CatsMonadError__Lcats_effect_kernel_Sync__ };
/** @constructor */
function $c_Lsttp_client3_impl_cats_CatsMonadError() {
  this.Lsttp_client3_impl_cats_CatsMonadError__f_F = null;
}
export { $c_Lsttp_client3_impl_cats_CatsMonadError as $c_Lsttp_client3_impl_cats_CatsMonadError };
$c_Lsttp_client3_impl_cats_CatsMonadError.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_impl_cats_CatsMonadError.prototype.constructor = $c_Lsttp_client3_impl_cats_CatsMonadError;
/** @constructor */
function $h_Lsttp_client3_impl_cats_CatsMonadError() {
}
export { $h_Lsttp_client3_impl_cats_CatsMonadError as $h_Lsttp_client3_impl_cats_CatsMonadError };
$h_Lsttp_client3_impl_cats_CatsMonadError.prototype = $c_Lsttp_client3_impl_cats_CatsMonadError.prototype;
$c_Lsttp_client3_impl_cats_CatsMonadError.prototype.unit__O__O = (function(t) {
  return this.Lsttp_client3_impl_cats_CatsMonadError__f_F.pure__O__O(t);
});
$c_Lsttp_client3_impl_cats_CatsMonadError.prototype.map__O__F1__O = (function(fa, f) {
  return this.Lsttp_client3_impl_cats_CatsMonadError__f_F.map__O__F1__O(fa, f);
});
$c_Lsttp_client3_impl_cats_CatsMonadError.prototype.flatMap__O__F1__O = (function(fa, f) {
  return this.Lsttp_client3_impl_cats_CatsMonadError__f_F.flatMap__O__F1__O(fa, f);
});
$c_Lsttp_client3_impl_cats_CatsMonadError.prototype.error__jl_Throwable__O = (function(t) {
  return this.Lsttp_client3_impl_cats_CatsMonadError__f_F.raiseError__O__O(t);
});
$c_Lsttp_client3_impl_cats_CatsMonadError.prototype.handleWrappedError__O__s_PartialFunction__O = (function(rt, h) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_ApplicativeError__recoverWith__O__s_PartialFunction__O(this.Lsttp_client3_impl_cats_CatsMonadError__f_F, rt, h);
});
$c_Lsttp_client3_impl_cats_CatsMonadError.prototype.eval__F0__O = (function(t) {
  return this.Lsttp_client3_impl_cats_CatsMonadError__f_F.delay__F0__O(t);
});
$c_Lsttp_client3_impl_cats_CatsMonadError.prototype.flatten__O__O = (function(ffa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__flatten__O__O(this.Lsttp_client3_impl_cats_CatsMonadError__f_F, ffa);
});
$c_Lsttp_client3_impl_cats_CatsMonadError.prototype.ensure__O__F0__O = (function(f, e) {
  return this.Lsttp_client3_impl_cats_CatsMonadError__f_F.guaranteeCase__O__F1__O(f, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => e.apply__O())));
});
/** @constructor */
function $c_Lsttp_client3_impl_cats_FetchCatsBackend$$anon$1(outer) {
  this.Lsttp_client3_impl_cats_FetchCatsBackend$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lsttp_client3_impl_cats_FetchCatsBackend$$anon$1__f_$outer = outer;
}
export { $c_Lsttp_client3_impl_cats_FetchCatsBackend$$anon$1 as $c_Lsttp_client3_impl_cats_FetchCatsBackend$$anon$1 };
$c_Lsttp_client3_impl_cats_FetchCatsBackend$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_impl_cats_FetchCatsBackend$$anon$1.prototype.constructor = $c_Lsttp_client3_impl_cats_FetchCatsBackend$$anon$1;
/** @constructor */
function $h_Lsttp_client3_impl_cats_FetchCatsBackend$$anon$1() {
}
export { $h_Lsttp_client3_impl_cats_FetchCatsBackend$$anon$1 as $h_Lsttp_client3_impl_cats_FetchCatsBackend$$anon$1 };
$h_Lsttp_client3_impl_cats_FetchCatsBackend$$anon$1.prototype = $c_Lsttp_client3_impl_cats_FetchCatsBackend$$anon$1.prototype;
$c_Lsttp_client3_impl_cats_FetchCatsBackend$$anon$1.prototype.apply__s_concurrent_Future__O = (function(f) {
  var F = this.Lsttp_client3_impl_cats_FetchCatsBackend$$anon$1__f_$outer.Lsttp_client3_impl_cats_FetchCatsBackend__f_sttp$client3$impl$cats$FetchCatsBackend$$evidence$1;
  var fut = this.Lsttp_client3_impl_cats_FetchCatsBackend$$anon$1__f_$outer.Lsttp_client3_AbstractFetchBackend__f_sttp$client3$AbstractFetchBackend$$monad.unit__O__O(f);
  return $f_Lcats_effect_kernel_Async__fromFuture__O__O(F, fut);
});
var $d_Lsttp_client3_impl_cats_FetchCatsBackend$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_impl_cats_FetchCatsBackend$$anon$1, "sttp.client3.impl.cats.FetchCatsBackend$$anon$1", ({
  Lsttp_client3_impl_cats_FetchCatsBackend$$anon$1: 1,
  Lsttp_client3_internal_ConvertFromFuture: 1
}));
export { $d_Lsttp_client3_impl_cats_FetchCatsBackend$$anon$1 as $d_Lsttp_client3_impl_cats_FetchCatsBackend$$anon$1 };
function $ct_Lsttp_client3_internal_SttpFile__O__($thiz, underlying) {
  $thiz.Lsttp_client3_internal_SttpFile__f_underlying = underlying;
  return $thiz;
}
export { $ct_Lsttp_client3_internal_SttpFile__O__ as $ct_Lsttp_client3_internal_SttpFile__O__ };
/** @constructor */
function $c_Lsttp_client3_internal_SttpFile() {
  this.Lsttp_client3_internal_SttpFile__f_underlying = null;
}
export { $c_Lsttp_client3_internal_SttpFile as $c_Lsttp_client3_internal_SttpFile };
$c_Lsttp_client3_internal_SttpFile.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_internal_SttpFile.prototype.constructor = $c_Lsttp_client3_internal_SttpFile;
/** @constructor */
function $h_Lsttp_client3_internal_SttpFile() {
}
export { $h_Lsttp_client3_internal_SttpFile as $h_Lsttp_client3_internal_SttpFile };
$h_Lsttp_client3_internal_SttpFile.prototype = $c_Lsttp_client3_internal_SttpFile.prototype;
/** @constructor */
function $c_Lsttp_model_Method$() {
  this.Lsttp_model_Method$__f_GET = null;
  this.Lsttp_model_Method$__f_HEAD = null;
  this.Lsttp_model_Method$__f_POST = null;
  this.Lsttp_model_Method$__f_PUT = null;
  this.Lsttp_model_Method$__f_DELETE = null;
  this.Lsttp_model_Method$__f_OPTIONS = null;
  this.Lsttp_model_Method$__f_TRACE = null;
  $n_Lsttp_model_Method$ = this;
  $f_Lsttp_model_Methods__$init$__V(this);
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Set$();
  var elems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_Lsttp_model_Method.getArrayOf().constr)([new $c_Lsttp_model_Method($m_Lsttp_model_Method$().Lsttp_model_Method$__f_HEAD), new $c_Lsttp_model_Method($m_Lsttp_model_Method$().Lsttp_model_Method$__f_TRACE), new $c_Lsttp_model_Method($m_Lsttp_model_Method$().Lsttp_model_Method$__f_GET), new $c_Lsttp_model_Method($m_Lsttp_model_Method$().Lsttp_model_Method$__f_PUT), new $c_Lsttp_model_Method($m_Lsttp_model_Method$().Lsttp_model_Method$__f_OPTIONS), new $c_Lsttp_model_Method($m_Lsttp_model_Method$().Lsttp_model_Method$__f_DELETE)]));
  this$1.from__sc_IterableOnce__sci_Set(elems);
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Set$();
  var elems$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_Lsttp_model_Method.getArrayOf().constr)([new $c_Lsttp_model_Method($m_Lsttp_model_Method$().Lsttp_model_Method$__f_HEAD), new $c_Lsttp_model_Method($m_Lsttp_model_Method$().Lsttp_model_Method$__f_GET), new $c_Lsttp_model_Method($m_Lsttp_model_Method$().Lsttp_model_Method$__f_OPTIONS)]));
  this$2.from__sc_IterableOnce__sci_Set(elems$1);
}
export { $c_Lsttp_model_Method$ as $c_Lsttp_model_Method$ };
$c_Lsttp_model_Method$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_model_Method$.prototype.constructor = $c_Lsttp_model_Method$;
/** @constructor */
function $h_Lsttp_model_Method$() {
}
export { $h_Lsttp_model_Method$ as $h_Lsttp_model_Method$ };
$h_Lsttp_model_Method$.prototype = $c_Lsttp_model_Method$.prototype;
$c_Lsttp_model_Method$.prototype.equals$extension__T__O__Z = (function(this$, x$0) {
  if ((x$0 instanceof $c_Lsttp_model_Method)) {
    var x$0$2 = ((x$0 === null) ? null : x$0.Lsttp_model_Method__f_method);
    return (this$ === x$0$2);
  } else {
    return false;
  }
});
$c_Lsttp_model_Method$.prototype.productElement$extension__T__I__O = (function(this$, n) {
  if ((n === 0)) {
    return this$;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_Method$.prototype.productElementName$extension__T__I__T = (function(this$, n) {
  if ((n === 0)) {
    return "method";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lsttp_model_Method$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_model_Method$, "sttp.model.Method$", ({
  Lsttp_model_Method$: 1,
  Lsttp_model_Methods: 1
}));
export { $d_Lsttp_model_Method$ as $d_Lsttp_model_Method$ };
var $n_Lsttp_model_Method$;
function $m_Lsttp_model_Method$() {
  if ((!$n_Lsttp_model_Method$)) {
    $n_Lsttp_model_Method$ = new $c_Lsttp_model_Method$();
  }
  return $n_Lsttp_model_Method$;
}
export { $m_Lsttp_model_Method$ as $m_Lsttp_model_Method$ };
function $f_Lsttp_model_RequestMetadata__toString__T($thiz) {
  return (((((("RequestMetadata(" + new $c_Lsttp_model_Method($thiz.method__T())) + ",") + $thiz.uri__Lsttp_model_Uri()) + ",") + $m_Lsttp_model_Headers$().toStringSafe__sci_Seq__sci_Set__sci_Seq($thiz.headers__sci_Seq(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_SensitiveHeaders)) + ")");
}
export { $f_Lsttp_model_RequestMetadata__toString__T as $f_Lsttp_model_RequestMetadata__toString__T };
function $f_Lsttp_model_ResponseMetadata__toString__T($thiz) {
  return (((((("ResponseMetadata(" + new $c_Lsttp_model_StatusCode($thiz.code__I())) + ",") + $thiz.statusText__T()) + ",") + $m_Lsttp_model_Headers$().toStringSafe__sci_Seq__sci_Set__sci_Seq($thiz.headers__sci_Seq(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_SensitiveHeaders)) + ")");
}
export { $f_Lsttp_model_ResponseMetadata__toString__T as $f_Lsttp_model_ResponseMetadata__toString__T };
/** @constructor */
function $c_Lsttp_model_StatusCode$() {
  this.Lsttp_model_StatusCode$__f_Continue = 0;
  this.Lsttp_model_StatusCode$__f_SwitchingProtocols = 0;
  this.Lsttp_model_StatusCode$__f_Processing = 0;
  this.Lsttp_model_StatusCode$__f_EarlyHints = 0;
  this.Lsttp_model_StatusCode$__f_Ok = 0;
  this.Lsttp_model_StatusCode$__f_Created = 0;
  this.Lsttp_model_StatusCode$__f_Accepted = 0;
  this.Lsttp_model_StatusCode$__f_NonAuthoritativeInformation = 0;
  this.Lsttp_model_StatusCode$__f_NoContent = 0;
  this.Lsttp_model_StatusCode$__f_ResetContent = 0;
  this.Lsttp_model_StatusCode$__f_PartialContent = 0;
  this.Lsttp_model_StatusCode$__f_MultiStatus = 0;
  this.Lsttp_model_StatusCode$__f_AlreadyReported = 0;
  this.Lsttp_model_StatusCode$__f_ImUsed = 0;
  this.Lsttp_model_StatusCode$__f_MultipleChoices = 0;
  this.Lsttp_model_StatusCode$__f_MovedPermanently = 0;
  this.Lsttp_model_StatusCode$__f_Found = 0;
  this.Lsttp_model_StatusCode$__f_SeeOther = 0;
  this.Lsttp_model_StatusCode$__f_NotModified = 0;
  this.Lsttp_model_StatusCode$__f_UseProxy = 0;
  this.Lsttp_model_StatusCode$__f_TemporaryRedirect = 0;
  this.Lsttp_model_StatusCode$__f_PermanentRedirect = 0;
  this.Lsttp_model_StatusCode$__f_BadRequest = 0;
  this.Lsttp_model_StatusCode$__f_Unauthorized = 0;
  this.Lsttp_model_StatusCode$__f_PaymentRequired = 0;
  this.Lsttp_model_StatusCode$__f_Forbidden = 0;
  this.Lsttp_model_StatusCode$__f_NotFound = 0;
  this.Lsttp_model_StatusCode$__f_MethodNotAllowed = 0;
  this.Lsttp_model_StatusCode$__f_NotAcceptable = 0;
  this.Lsttp_model_StatusCode$__f_ProxyAuthenticationRequired = 0;
  this.Lsttp_model_StatusCode$__f_RequestTimeout = 0;
  this.Lsttp_model_StatusCode$__f_Conflict = 0;
  this.Lsttp_model_StatusCode$__f_Gone = 0;
  this.Lsttp_model_StatusCode$__f_LengthRequired = 0;
  this.Lsttp_model_StatusCode$__f_PreconditionFailed = 0;
  this.Lsttp_model_StatusCode$__f_PayloadTooLarge = 0;
  this.Lsttp_model_StatusCode$__f_UriTooLong = 0;
  this.Lsttp_model_StatusCode$__f_UnsupportedMediaType = 0;
  this.Lsttp_model_StatusCode$__f_RangeNotSatisfiable = 0;
  this.Lsttp_model_StatusCode$__f_ExpectationFailed = 0;
  this.Lsttp_model_StatusCode$__f_MisdirectedRequest = 0;
  this.Lsttp_model_StatusCode$__f_UnprocessableEntity = 0;
  this.Lsttp_model_StatusCode$__f_Locked = 0;
  this.Lsttp_model_StatusCode$__f_FailedDependency = 0;
  this.Lsttp_model_StatusCode$__f_UpgradeRequired = 0;
  this.Lsttp_model_StatusCode$__f_PreconditionRequired = 0;
  this.Lsttp_model_StatusCode$__f_TooManyRequests = 0;
  this.Lsttp_model_StatusCode$__f_RequestHeaderFieldsTooLarge = 0;
  this.Lsttp_model_StatusCode$__f_UnavailableForLegalReasons = 0;
  this.Lsttp_model_StatusCode$__f_InternalServerError = 0;
  this.Lsttp_model_StatusCode$__f_NotImplemented = 0;
  this.Lsttp_model_StatusCode$__f_BadGateway = 0;
  this.Lsttp_model_StatusCode$__f_ServiceUnavailable = 0;
  this.Lsttp_model_StatusCode$__f_GatewayTimeout = 0;
  this.Lsttp_model_StatusCode$__f_HttpVersionNotSupported = 0;
  this.Lsttp_model_StatusCode$__f_VariantAlsoNegotiates = 0;
  this.Lsttp_model_StatusCode$__f_InsufficientStorage = 0;
  this.Lsttp_model_StatusCode$__f_LoopDetected = 0;
  this.Lsttp_model_StatusCode$__f_NotExtended = 0;
  this.Lsttp_model_StatusCode$__f_NetworkAuthenticationRequired = 0;
  $n_Lsttp_model_StatusCode$ = this;
  $f_Lsttp_model_StatusCodes__$init$__V(this);
}
export { $c_Lsttp_model_StatusCode$ as $c_Lsttp_model_StatusCode$ };
$c_Lsttp_model_StatusCode$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_model_StatusCode$.prototype.constructor = $c_Lsttp_model_StatusCode$;
/** @constructor */
function $h_Lsttp_model_StatusCode$() {
}
export { $h_Lsttp_model_StatusCode$ as $h_Lsttp_model_StatusCode$ };
$h_Lsttp_model_StatusCode$.prototype = $c_Lsttp_model_StatusCode$.prototype;
$c_Lsttp_model_StatusCode$.prototype.equals$extension__I__O__Z = (function(this$, x$0) {
  if ((x$0 instanceof $c_Lsttp_model_StatusCode)) {
    var x$0$2 = ((x$0 === null) ? (null | 0) : x$0.Lsttp_model_StatusCode__f_code);
    return (this$ === x$0$2);
  } else {
    return false;
  }
});
$c_Lsttp_model_StatusCode$.prototype.isSuccess$extension__I__Z = (function(this$) {
  return (((this$ / 100) | 0) === 2);
});
var $d_Lsttp_model_StatusCode$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_model_StatusCode$, "sttp.model.StatusCode$", ({
  Lsttp_model_StatusCode$: 1,
  Lsttp_model_StatusCodes: 1
}));
export { $d_Lsttp_model_StatusCode$ as $d_Lsttp_model_StatusCode$ };
var $n_Lsttp_model_StatusCode$;
function $m_Lsttp_model_StatusCode$() {
  if ((!$n_Lsttp_model_StatusCode$)) {
    $n_Lsttp_model_StatusCode$ = new $c_Lsttp_model_StatusCode$();
  }
  return $n_Lsttp_model_StatusCode$;
}
export { $m_Lsttp_model_StatusCode$ as $m_Lsttp_model_StatusCode$ };
/** @constructor */
function $c_Lsttp_model_headers_AuthenticationScheme$Digest$() {
  this.Lsttp_model_headers_AuthenticationScheme$Digest$__f_name = null;
  $n_Lsttp_model_headers_AuthenticationScheme$Digest$ = this;
  this.Lsttp_model_headers_AuthenticationScheme$Digest$__f_name = "Digest";
  new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon("auth", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon("auth-int", $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$()));
}
export { $c_Lsttp_model_headers_AuthenticationScheme$Digest$ as $c_Lsttp_model_headers_AuthenticationScheme$Digest$ };
$c_Lsttp_model_headers_AuthenticationScheme$Digest$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_model_headers_AuthenticationScheme$Digest$.prototype.constructor = $c_Lsttp_model_headers_AuthenticationScheme$Digest$;
/** @constructor */
function $h_Lsttp_model_headers_AuthenticationScheme$Digest$() {
}
export { $h_Lsttp_model_headers_AuthenticationScheme$Digest$ as $h_Lsttp_model_headers_AuthenticationScheme$Digest$ };
$h_Lsttp_model_headers_AuthenticationScheme$Digest$.prototype = $c_Lsttp_model_headers_AuthenticationScheme$Digest$.prototype;
var $d_Lsttp_model_headers_AuthenticationScheme$Digest$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_model_headers_AuthenticationScheme$Digest$, "sttp.model.headers.AuthenticationScheme$Digest$", ({
  Lsttp_model_headers_AuthenticationScheme$Digest$: 1,
  Lsttp_model_headers_AuthenticationScheme: 1
}));
export { $d_Lsttp_model_headers_AuthenticationScheme$Digest$ as $d_Lsttp_model_headers_AuthenticationScheme$Digest$ };
var $n_Lsttp_model_headers_AuthenticationScheme$Digest$;
function $m_Lsttp_model_headers_AuthenticationScheme$Digest$() {
  if ((!$n_Lsttp_model_headers_AuthenticationScheme$Digest$)) {
    $n_Lsttp_model_headers_AuthenticationScheme$Digest$ = new $c_Lsttp_model_headers_AuthenticationScheme$Digest$();
  }
  return $n_Lsttp_model_headers_AuthenticationScheme$Digest$;
}
export { $m_Lsttp_model_headers_AuthenticationScheme$Digest$ as $m_Lsttp_model_headers_AuthenticationScheme$Digest$ };
function $f_Lsttp_tapir_EndpointErrorOutputsOps__errorOut__Lsttp_tapir_EndpointOutput__Lsttp_tapir_typelevel_ParamConcat__O($thiz, o, ts) {
  var output = $thiz.Lsttp_tapir_Endpoint__f_errorOutput.and__Lsttp_tapir_EndpointOutput__Lsttp_tapir_typelevel_ParamConcat__Lsttp_tapir_EndpointOutput(o, ts);
  var securityInput = $thiz.Lsttp_tapir_Endpoint__f_securityInput;
  var input = $thiz.Lsttp_tapir_Endpoint__f_input;
  var output$1 = $thiz.Lsttp_tapir_Endpoint__f_output;
  var info = $thiz.Lsttp_tapir_Endpoint__f_info;
  return new $c_Lsttp_tapir_Endpoint(securityInput, input, output, output$1, info);
}
export { $f_Lsttp_tapir_EndpointErrorOutputsOps__errorOut__Lsttp_tapir_EndpointOutput__Lsttp_tapir_typelevel_ParamConcat__O as $f_Lsttp_tapir_EndpointErrorOutputsOps__errorOut__Lsttp_tapir_EndpointOutput__Lsttp_tapir_typelevel_ParamConcat__O };
function $f_Lsttp_tapir_EndpointInputsOps__method__T__O($thiz, m) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Codec$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Codec$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var schemaType = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_SchemaType$SString();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var name = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var isOptional = false;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var description = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var default$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var format = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var encodedExample = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var deprecated = false;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var hidden = false;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var validator = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var attributes = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  var s = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema(schemaType, name, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_CodecFormat$TextPlain();
  var codec = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Codec$$anon$4(s, f);
  var description$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var examples = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var attributes$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  var info = new $c_Lsttp_tapir_EndpointIO$Info(description$1, examples, false, attributes$1);
  var i = new $c_Lsttp_tapir_EndpointInput$FixedMethod(m, codec, info);
  var ta = new $c_Lsttp_tapir_typelevel_LowPriorityTupleArity$$anon$21();
  var concat = new $c_Lsttp_tapir_typelevel_LowPriorityTupleConcat3$$anon$7(ta);
  return $f_Lsttp_tapir_EndpointInputsOps__in__Lsttp_tapir_EndpointInput__Lsttp_tapir_typelevel_ParamConcat__O($thiz, i, concat);
}
export { $f_Lsttp_tapir_EndpointInputsOps__method__T__O as $f_Lsttp_tapir_EndpointInputsOps__method__T__O };
function $f_Lsttp_tapir_EndpointInputsOps__in__Lsttp_tapir_EndpointInput__Lsttp_tapir_typelevel_ParamConcat__O($thiz, i, concat) {
  var input = $f_Lsttp_tapir_EndpointInput__and__Lsttp_tapir_EndpointInput__Lsttp_tapir_typelevel_ParamConcat__Lsttp_tapir_EndpointInput($thiz.Lsttp_tapir_Endpoint__f_input, i, concat);
  var securityInput = $thiz.Lsttp_tapir_Endpoint__f_securityInput;
  var errorOutput = $thiz.Lsttp_tapir_Endpoint__f_errorOutput;
  var output = $thiz.Lsttp_tapir_Endpoint__f_output;
  var info = $thiz.Lsttp_tapir_Endpoint__f_info;
  return new $c_Lsttp_tapir_Endpoint(securityInput, input, errorOutput, output, info);
}
export { $f_Lsttp_tapir_EndpointInputsOps__in__Lsttp_tapir_EndpointInput__Lsttp_tapir_typelevel_ParamConcat__O as $f_Lsttp_tapir_EndpointInputsOps__in__Lsttp_tapir_EndpointInput__Lsttp_tapir_typelevel_ParamConcat__O };
function $f_Lsttp_tapir_EndpointInputsOps__mapIn__F1__F1__O($thiz, f, g) {
  var input = $f_Lsttp_tapir_EndpointTransput__map__F1__F1__Lsttp_tapir_EndpointTransput($thiz.Lsttp_tapir_Endpoint__f_input, f, g);
  var securityInput = $thiz.Lsttp_tapir_Endpoint__f_securityInput;
  var errorOutput = $thiz.Lsttp_tapir_Endpoint__f_errorOutput;
  var output = $thiz.Lsttp_tapir_Endpoint__f_output;
  var info = $thiz.Lsttp_tapir_Endpoint__f_info;
  return new $c_Lsttp_tapir_Endpoint(securityInput, input, errorOutput, output, info);
}
export { $f_Lsttp_tapir_EndpointInputsOps__mapIn__F1__F1__O as $f_Lsttp_tapir_EndpointInputsOps__mapIn__F1__F1__O };
function $f_Lsttp_tapir_EndpointInputsOps__mapInDecode__F1__F1__O($thiz, f, g) {
  var input = $f_Lsttp_tapir_EndpointTransput__mapDecode__F1__F1__Lsttp_tapir_EndpointTransput($thiz.Lsttp_tapir_Endpoint__f_input, f, g);
  var securityInput = $thiz.Lsttp_tapir_Endpoint__f_securityInput;
  var errorOutput = $thiz.Lsttp_tapir_Endpoint__f_errorOutput;
  var output = $thiz.Lsttp_tapir_Endpoint__f_output;
  var info = $thiz.Lsttp_tapir_Endpoint__f_info;
  return new $c_Lsttp_tapir_Endpoint(securityInput, input, errorOutput, output, info);
}
export { $f_Lsttp_tapir_EndpointInputsOps__mapInDecode__F1__F1__O as $f_Lsttp_tapir_EndpointInputsOps__mapInDecode__F1__F1__O };
function $f_Lsttp_tapir_EndpointOutputsOps__out__Lsttp_tapir_EndpointOutput__Lsttp_tapir_typelevel_ParamConcat__O($thiz, i, ts) {
  var input = $thiz.Lsttp_tapir_Endpoint__f_output.and__Lsttp_tapir_EndpointOutput__Lsttp_tapir_typelevel_ParamConcat__Lsttp_tapir_EndpointOutput(i, ts);
  var securityInput = $thiz.Lsttp_tapir_Endpoint__f_securityInput;
  var input$1 = $thiz.Lsttp_tapir_Endpoint__f_input;
  var errorOutput = $thiz.Lsttp_tapir_Endpoint__f_errorOutput;
  var info = $thiz.Lsttp_tapir_Endpoint__f_info;
  return new $c_Lsttp_tapir_Endpoint(securityInput, input$1, errorOutput, input, info);
}
export { $f_Lsttp_tapir_EndpointOutputsOps__out__Lsttp_tapir_EndpointOutput__Lsttp_tapir_typelevel_ParamConcat__O as $f_Lsttp_tapir_EndpointOutputsOps__out__Lsttp_tapir_EndpointOutput__Lsttp_tapir_typelevel_ParamConcat__O };
function $f_Lsttp_tapir_EndpointOutputsOps__mapOut__F1__F1__O($thiz, f, g) {
  var input = $f_Lsttp_tapir_EndpointTransput__map__F1__F1__Lsttp_tapir_EndpointTransput($thiz.Lsttp_tapir_Endpoint__f_output, f, g);
  var securityInput = $thiz.Lsttp_tapir_Endpoint__f_securityInput;
  var input$1 = $thiz.Lsttp_tapir_Endpoint__f_input;
  var errorOutput = $thiz.Lsttp_tapir_Endpoint__f_errorOutput;
  var info = $thiz.Lsttp_tapir_Endpoint__f_info;
  return new $c_Lsttp_tapir_Endpoint(securityInput, input$1, errorOutput, input, info);
}
export { $f_Lsttp_tapir_EndpointOutputsOps__mapOut__F1__F1__O as $f_Lsttp_tapir_EndpointOutputsOps__mapOut__F1__F1__O };
function $f_Lsttp_tapir_EndpointSecurityInputsOps__securityIn__Lsttp_tapir_EndpointInput__Lsttp_tapir_typelevel_ParamConcat__O($thiz, i, concat) {
  var securityInput = $f_Lsttp_tapir_EndpointInput__and__Lsttp_tapir_EndpointInput__Lsttp_tapir_typelevel_ParamConcat__Lsttp_tapir_EndpointInput($thiz.Lsttp_tapir_Endpoint__f_securityInput, i, concat);
  var input = $thiz.Lsttp_tapir_Endpoint__f_input;
  var errorOutput = $thiz.Lsttp_tapir_Endpoint__f_errorOutput;
  var output = $thiz.Lsttp_tapir_Endpoint__f_output;
  var info = $thiz.Lsttp_tapir_Endpoint__f_info;
  return new $c_Lsttp_tapir_Endpoint(securityInput, input, errorOutput, output, info);
}
export { $f_Lsttp_tapir_EndpointSecurityInputsOps__securityIn__Lsttp_tapir_EndpointInput__Lsttp_tapir_typelevel_ParamConcat__O as $f_Lsttp_tapir_EndpointSecurityInputsOps__securityIn__Lsttp_tapir_EndpointInput__Lsttp_tapir_typelevel_ParamConcat__O };
function $f_Lsttp_tapir_EndpointTransput__map__F1__F1__Lsttp_tapir_EndpointTransput($thiz, f, g) {
  return $thiz.map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Mapping$().from__F1__F1__Lsttp_tapir_Mapping(f, g));
}
export { $f_Lsttp_tapir_EndpointTransput__map__F1__F1__Lsttp_tapir_EndpointTransput as $f_Lsttp_tapir_EndpointTransput__map__F1__F1__Lsttp_tapir_EndpointTransput };
function $f_Lsttp_tapir_EndpointTransput__mapDecode__F1__F1__Lsttp_tapir_EndpointTransput($thiz, f, g) {
  return $thiz.map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Mapping$$anon$4(f, g));
}
export { $f_Lsttp_tapir_EndpointTransput__mapDecode__F1__F1__Lsttp_tapir_EndpointTransput as $f_Lsttp_tapir_EndpointTransput__mapDecode__F1__F1__Lsttp_tapir_EndpointTransput };
/** @constructor */
function $c_Lsttp_tapir_Mapping$$anon$1(codec$2, outer) {
  this.Lsttp_tapir_Mapping$$anon$1__f_codec$1 = null;
  this.Lsttp_tapir_Mapping$$anon$1__f_$outer = null;
  this.Lsttp_tapir_Mapping$$anon$1__f_codec$1 = codec$2;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lsttp_tapir_Mapping$$anon$1__f_$outer = outer;
}
export { $c_Lsttp_tapir_Mapping$$anon$1 as $c_Lsttp_tapir_Mapping$$anon$1 };
$c_Lsttp_tapir_Mapping$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_Mapping$$anon$1.prototype.constructor = $c_Lsttp_tapir_Mapping$$anon$1;
/** @constructor */
function $h_Lsttp_tapir_Mapping$$anon$1() {
}
export { $h_Lsttp_tapir_Mapping$$anon$1 as $h_Lsttp_tapir_Mapping$$anon$1 };
$h_Lsttp_tapir_Mapping$$anon$1.prototype = $c_Lsttp_tapir_Mapping$$anon$1.prototype;
$c_Lsttp_tapir_Mapping$$anon$1.prototype.rawDecode__O__Lsttp_tapir_DecodeResult = (function(l) {
  return this.Lsttp_tapir_Mapping$$anon$1__f_$outer.rawDecode__O__Lsttp_tapir_DecodeResult(l).flatMap__F1__Lsttp_tapir_DecodeResult(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((l$2) => this.Lsttp_tapir_Mapping$$anon$1__f_codec$1.rawDecode__O__Lsttp_tapir_DecodeResult(l$2))));
});
$c_Lsttp_tapir_Mapping$$anon$1.prototype.encode__O__O = (function(hh) {
  return this.Lsttp_tapir_Mapping$$anon$1__f_$outer.encode__O__O(this.Lsttp_tapir_Mapping$$anon$1__f_codec$1.encode__O__O(hh));
});
$c_Lsttp_tapir_Mapping$$anon$1.prototype.validator__Lsttp_tapir_Validator = (function() {
  return this.Lsttp_tapir_Mapping$$anon$1__f_$outer.validator__Lsttp_tapir_Validator().contramap__F1__Lsttp_tapir_Validator(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((h) => this.Lsttp_tapir_Mapping$$anon$1__f_codec$1.encode__O__O(h)))).and__Lsttp_tapir_Validator__Lsttp_tapir_Validator(this.Lsttp_tapir_Mapping$$anon$1__f_codec$1.validator__Lsttp_tapir_Validator());
});
var $d_Lsttp_tapir_Mapping$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_Mapping$$anon$1, "sttp.tapir.Mapping$$anon$1", ({
  Lsttp_tapir_Mapping$$anon$1: 1,
  Lsttp_tapir_Mapping: 1
}));
export { $d_Lsttp_tapir_Mapping$$anon$1 as $d_Lsttp_tapir_Mapping$$anon$1 };
function $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__setInputParams__Lsttp_tapir_EndpointInput__Lsttp_tapir_internal_package$Params__Lsttp_model_Uri__Lsttp_client3_RequestT__T2($thiz, input, params, uri, req) {
  var input$tailLocal1 = input;
  while (true) {
    var x24 = input$tailLocal1;
    if ((x24 instanceof $c_Lsttp_tapir_EndpointInput$FixedMethod)) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), uri, req);
    }
    if ((x24 instanceof $c_Lsttp_tapir_EndpointInput$FixedPath)) {
      var x155 = x24.Lsttp_tapir_EndpointInput$FixedPath__f_s;
      var _1 = uri.addPath__T__sci_Seq__Lsttp_model_Uri(x155, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)([])));
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, req);
    }
    if ((x24 instanceof $c_Lsttp_tapir_EndpointInput$PathCapture)) {
      var x151 = x24.Lsttp_tapir_EndpointInput$PathCapture__f_codec;
      var v = x151.encode__O__O(params.asAny__O());
      var _1$1 = uri.addPath__T__sci_Seq__Lsttp_model_Uri(v, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)([])));
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1$1, req);
    }
    if (false) {
      var x146 = x24.Lsttp_tapir_EndpointInput$PathsCapture__f_codec;
      var ps = x146.encode__O__O(params.asAny__O());
      var _1$2 = uri.addPath__sc_Seq__Lsttp_model_Uri(ps);
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1$2, req);
    }
    if ((x24 instanceof $c_Lsttp_tapir_EndpointInput$Query)) {
      var x138 = x24.Lsttp_tapir_EndpointInput$Query__f_name;
      var x139 = x24.Lsttp_tapir_EndpointInput$Query__f_flagValue;
      var x140 = x24.Lsttp_tapir_EndpointInput$Query__f_codec;
      if ((x139 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
        var flagValue = x139.s_Some__f_value;
        var x = params.asAny__O();
        if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, flagValue)) {
          var _1$3 = uri.withParams__Lsttp_model_QueryParams__Lsttp_model_Uri(uri.params__Lsttp_model_QueryParams().param__T__sci_Seq__Lsttp_model_QueryParams(x138, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$()));
          return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1$3, req);
        }
      }
      var uri2 = x140.encode__O__O(params.asAny__O()).foldLeft__O__F2__O(uri, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((x138) => ((x$1, x$2) => x$1.addParam__T__T__Lsttp_model_Uri(x138, x$2)))(x138)));
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), uri2, req);
    }
    if ((x24 instanceof $c_Lsttp_tapir_EndpointInput$Cookie)) {
      var x127 = x24.Lsttp_tapir_EndpointInput$Cookie__f_name;
      var x128 = x24.Lsttp_tapir_EndpointInput$Cookie__f_codec;
      var req2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Option$().option2Iterable__s_Option__sc_Iterable(x128.encode__O__O(params.asAny__O())).foldLeft__O__F2__O(req, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((x127) => ((x$1$2, x$2$2) => x$1$2.cookie__T__T__Lsttp_client3_RequestT(x127, x$2$2)))(x127)));
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), uri, req2);
    }
    if (false) {
      var x123 = x24.Lsttp_tapir_EndpointInput$QueryParams__f_codec;
      var mqp = x123.encode__O__O(params.asAny__O());
      var uri2$2 = uri.addParams__sci_Seq__Lsttp_model_Uri(mqp.toSeq__sci_Seq());
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), uri2$2, req);
    }
    if ((x24 instanceof $c_Lsttp_tapir_EndpointIO$Empty)) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), uri, req);
    }
    if ((x24 instanceof $c_Lsttp_tapir_EndpointIO$Body)) {
      var x114 = x24.Lsttp_tapir_EndpointIO$Body__f_bodyType;
      var x115 = x24.Lsttp_tapir_EndpointIO$Body__f_codec;
      var req2$2 = $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__setBody__O__Lsttp_tapir_RawBodyType__Lsttp_tapir_Codec__Lsttp_client3_RequestT__Lsttp_client3_RequestT($thiz, params.asAny__O(), x114, x115, req);
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), uri, req2$2);
    }
    if (false) {
      var x102 = x24.Lsttp_tapir_EndpointIO$OneOfBody__f_variants;
      if ((x102 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon)) {
        var x105 = x102.sci_$colon$colon__f_head;
        if ((x105 !== null)) {
          var x109 = x105.Lsttp_tapir_EndpointIO$OneOfBodyVariant__f_body;
          if ((x109 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
            var body = x109.s_util_Left__f_value;
            input$tailLocal1 = body;
            continue;
          }
        }
      }
    }
    if (false) {
      var x80 = x24.Lsttp_tapir_EndpointIO$OneOfBody__f_variants;
      if ((x80 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon)) {
        var x83 = x80.sci_$colon$colon__f_head;
        if ((x83 !== null)) {
          var x87 = x83.Lsttp_tapir_EndpointIO$OneOfBodyVariant__f_body;
          if ((x87 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
            var x89 = x87.s_util_Right__f_value;
            if ((x89 !== null)) {
              var x92 = x89.Lsttp_tapir_EndpointIO$StreamBodyWrapper__f_wrapped;
              if ((x92 !== null)) {
                var x95 = x92.Lsttp_tapir_StreamBodyIO__f_streams;
                var req2$3 = req.streamBody__Lsttp_capabilities_package$Streams__O__Lsttp_client3_RequestT(x95, params.asAny__O());
                return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), uri, req2$3);
              }
            }
          }
        }
      }
    }
    if (false) {
      var x76 = x24.Lsttp_tapir_EndpointIO$OneOfBody__f_variants;
      var x$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      if (x$3.equals__O__Z(x76)) {
        throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_RuntimeException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_RuntimeException(), "One of body without variants");
      }
    }
    if (false) {
      var x66 = x24.Lsttp_tapir_EndpointIO$StreamBodyWrapper__f_wrapped;
      if ((x66 !== null)) {
        var x69 = x66.Lsttp_tapir_StreamBodyIO__f_streams;
        var req2$4 = req.streamBody__Lsttp_capabilities_package$Streams__O__Lsttp_client3_RequestT(x69, params.asAny__O());
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), uri, req2$4);
      }
    }
    if ((x24 instanceof $c_Lsttp_tapir_EndpointIO$Header)) {
      var x61 = x24.Lsttp_tapir_EndpointIO$Header__f_name;
      var x62 = x24.Lsttp_tapir_EndpointIO$Header__f_codec;
      var req2$5 = x62.encode__O__O(params.asAny__O()).foldLeft__O__F2__O(req, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((x61) => ((x$1$3, x$2$3) => x$1$3.header__T__T__Lsttp_client3_RequestT(x61, x$2$3)))(x61)));
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), uri, req2$5);
    }
    if (false) {
      var x57 = x24.Lsttp_tapir_EndpointIO$Headers__f_codec;
      var headers = x57.encode__O__O(params.asAny__O());
      var acc = req;
      var these = headers;
      while ((!these.isEmpty__Z())) {
        var x0 = acc;
        var x1 = these.head__O();
        var this$38 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_ContentType;
        var anotherString = x1.Lsttp_model_Header__f_name;
        _return$1: {
          var len = this$38.length;
          if ((!((anotherString === null) || (anotherString.length !== len)))) {
            var i = 0;
            while ((i !== len)) {
              var index = i;
              var c = this$38.charCodeAt(index);
              var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toLowerCase__C__C($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toUpperCase__C__C(c));
              var index$1 = i;
              var c$1 = anotherString.charCodeAt(index$1);
              if (($x_2 !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toLowerCase__C__C($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toUpperCase__C__C(c$1)))) {
                var $x_1 = false;
                break _return$1;
              }
              i = ((1 + i) | 0);
            }
            var $x_1 = true;
          } else {
            var $x_1 = false;
          }
        }
        if ($x_1) {
          var replaceExisting = true;
        } else {
          var this$39 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_ContentLength;
          var anotherString$1 = x1.Lsttp_model_Header__f_name;
          _return$2: {
            var len$1 = this$39.length;
            if ((!((anotherString$1 === null) || (anotherString$1.length !== len$1)))) {
              var i$1 = 0;
              while ((i$1 !== len$1)) {
                var index$2 = i$1;
                var c$2 = this$39.charCodeAt(index$2);
                var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toLowerCase__C__C($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toUpperCase__C__C(c$2));
                var index$3 = i$1;
                var c$3 = anotherString$1.charCodeAt(index$3);
                if (($x_3 !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toLowerCase__C__C($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toUpperCase__C__C(c$3)))) {
                  var replaceExisting = false;
                  break _return$2;
                }
                i$1 = ((1 + i$1) | 0);
              }
              var replaceExisting = true;
            } else {
              var replaceExisting = false;
            }
          }
        }
        acc = x0.header__Lsttp_model_Header__Z__Lsttp_client3_RequestT(x1, replaceExisting);
        these = these.tail__O();
      }
      var req2$6 = acc;
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), uri, req2$6);
    }
    if (false) {
      var x52 = x24.Lsttp_tapir_EndpointIO$FixedHeader__f_h;
      var req2$7 = req.header__Lsttp_model_Header__Z__Lsttp_client3_RequestT(x52, false);
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), uri, req2$7);
    }
    if ((x24 instanceof $c_Lsttp_tapir_EndpointInput$ExtractFromRequest)) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), uri, req);
    }
    if ((x24 instanceof $c_Lsttp_tapir_EndpointInput$Auth)) {
      input$tailLocal1 = x24.Lsttp_tapir_EndpointInput$Auth__f_input;
      continue;
    }
    if ((x24 instanceof $c_Lsttp_tapir_EndpointInput$Pair)) {
      var x41 = x24.Lsttp_tapir_EndpointInput$Pair__f_left;
      var x42 = x24.Lsttp_tapir_EndpointInput$Pair__f_right;
      var x44 = x24.Lsttp_tapir_EndpointInput$Pair__f_split;
      return $thiz.handleInputPair__Lsttp_tapir_EndpointInput__Lsttp_tapir_EndpointInput__Lsttp_tapir_internal_package$Params__F1__Lsttp_model_Uri__Lsttp_client3_RequestT__T2(x41, x42, params, x44, uri, req);
    }
    if (false) {
      var x35 = x24.Lsttp_tapir_EndpointIO$Pair__f_left;
      var x36 = x24.Lsttp_tapir_EndpointIO$Pair__f_right;
      var x38 = x24.Lsttp_tapir_EndpointIO$Pair__f_split;
      return $thiz.handleInputPair__Lsttp_tapir_EndpointInput__Lsttp_tapir_EndpointInput__Lsttp_tapir_internal_package$Params__F1__Lsttp_model_Uri__Lsttp_client3_RequestT__T2(x35, x36, params, x38, uri, req);
    }
    if ((x24 instanceof $c_Lsttp_tapir_EndpointInput$MappedPair)) {
      var x31 = x24.Lsttp_tapir_EndpointInput$MappedPair__f_input;
      var x32 = x24.Lsttp_tapir_EndpointInput$MappedPair__f_mapping;
      return $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__handleMapped__Lsttp_tapir_EndpointInput__Lsttp_tapir_Mapping__Lsttp_tapir_internal_package$Params__Lsttp_model_Uri__Lsttp_client3_RequestT__T2($thiz, x31, x32, params, uri, req);
    }
    if (false) {
      var x27 = x24.Lsttp_tapir_EndpointIO$MappedPair__f_io;
      var x28 = x24.Lsttp_tapir_EndpointIO$MappedPair__f_mapping;
      return $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__handleMapped__Lsttp_tapir_EndpointInput__Lsttp_tapir_Mapping__Lsttp_tapir_internal_package$Params__Lsttp_model_Uri__Lsttp_client3_RequestT__T2($thiz, x27, x28, params, uri, req);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x24);
  }
}
export { $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__setInputParams__Lsttp_tapir_EndpointInput__Lsttp_tapir_internal_package$Params__Lsttp_model_Uri__Lsttp_client3_RequestT__T2 as $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__setInputParams__Lsttp_tapir_EndpointInput__Lsttp_tapir_internal_package$Params__Lsttp_model_Uri__Lsttp_client3_RequestT__T2 };
function $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__handleMapped__Lsttp_tapir_EndpointInput__Lsttp_tapir_Mapping__Lsttp_tapir_internal_package$Params__Lsttp_model_Uri__Lsttp_client3_RequestT__T2($thiz, tuple, codec, params, uri, req) {
  var asAny = codec.encode__O__O(params.asAny__O());
  return $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__setInputParams__Lsttp_tapir_EndpointInput__Lsttp_tapir_internal_package$Params__Lsttp_model_Uri__Lsttp_client3_RequestT__T2($thiz, tuple, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_internal_package$ParamsAsAny(asAny), uri, req);
}
export { $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__handleMapped__Lsttp_tapir_EndpointInput__Lsttp_tapir_Mapping__Lsttp_tapir_internal_package$Params__Lsttp_model_Uri__Lsttp_client3_RequestT__T2 as $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__handleMapped__Lsttp_tapir_EndpointInput__Lsttp_tapir_Mapping__Lsttp_tapir_internal_package$Params__Lsttp_model_Uri__Lsttp_client3_RequestT__T2 };
function $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__setBody__O__Lsttp_tapir_RawBodyType__Lsttp_tapir_Codec__Lsttp_client3_RequestT__Lsttp_client3_RequestT($thiz, v, bodyType, codec, req) {
  var h = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_ContentType;
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lsttp_model_HasHeaders__header__T__s_Option(req, h);
  var wasContentTypeAlreadySet = (!this$1.isEmpty__Z());
  var encoded = codec.encode__O__O(v);
  matchResult12: {
    var req2;
    if ((bodyType instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_RawBodyType$StringBody)) {
      var x178 = bodyType.Lsttp_tapir_RawBodyType$StringBody__f_charset;
      var req2 = req.body__T__T__Lsttp_client3_RequestT(encoded, x178.Ljava_nio_charset_Charset__f_canonicalName);
      break matchResult12;
    }
    var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_RawBodyType$ByteArrayBody$();
    if ((x === bodyType)) {
      var req2 = req.body__AB__Lsttp_client3_RequestT(encoded);
      break matchResult12;
    }
    var x$3 = $m_Lsttp_tapir_RawBodyType$ByteBufferBody$();
    if ((x$3 === bodyType)) {
      var req2 = req.body__Ljava_nio_ByteBuffer__Lsttp_client3_RequestT(encoded);
      break matchResult12;
    }
    var x$5 = $m_Lsttp_tapir_RawBodyType$InputStreamBody$();
    if ((x$5 === bodyType)) {
      var req2 = req.body__Ljava_io_InputStream__Lsttp_client3_RequestT(encoded);
      break matchResult12;
    }
    var x$7 = $m_Lsttp_tapir_RawBodyType$FileBody$();
    if ((x$7 === bodyType)) {
      var file = encoded.Lsttp_tapir_FileRange__f_file;
      var req2 = $f_Lsttp_client3_RequestTExtensions__body__Lorg_scalajs_dom_File__Lsttp_client3_RequestT(req, file);
      break matchResult12;
    }
    var x$9 = $m_Lsttp_tapir_RawBodyType$InputStreamRangeBody$();
    if ((x$9 === bodyType)) {
      var req2 = req.body__Ljava_io_InputStream__Lsttp_client3_RequestT(encoded.Lsttp_tapir_InputStreamRange__f_inputStream.apply__O());
      break matchResult12;
    }
    if ((bodyType instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_RawBodyType$MultipartBody)) {
      var parts = encoded.flatMap__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((m$2) => ((p) => {
        var this$4 = m$2.partType__T__s_Option(p.Lsttp_model_Part__f_name);
        if (this$4.isEmpty__Z()) {
          return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        } else {
          var x0 = this$4.get__O();
          var sttpPart1 = $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__partToSttpPart__Lsttp_model_Part__Lsttp_tapir_RawBodyType__Lsttp_model_Part($thiz, p, x0);
          var sttpPart2 = p.Lsttp_model_Part__f_headers.foldLeft__O__F2__O(sttpPart1, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((part, header) => {
            var otherName = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_ContentType;
            var this$5 = header.Lsttp_model_Header__f_name;
            _return: {
              var len = this$5.length;
              if ((!((otherName === null) || (otherName.length !== len)))) {
                var i = 0;
                while ((i !== len)) {
                  var index = i;
                  var c = this$5.charCodeAt(index);
                  var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toLowerCase__C__C($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toUpperCase__C__C(c));
                  var index$1 = i;
                  var c$1 = otherName.charCodeAt(index$1);
                  if (($x_2 !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toLowerCase__C__C($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toUpperCase__C__C(c$1)))) {
                    var $x_1 = false;
                    break _return;
                  }
                  i = ((1 + i) | 0);
                }
                var $x_1 = true;
              } else {
                var $x_1 = false;
              }
            }
            return part.header__Lsttp_model_Header__Z__Lsttp_model_Part(header, $x_1);
          })));
          var this$7 = p.Lsttp_model_Part__f_otherDispositionParams;
          var f = ((x$1, x$2) => {
            var x169 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), x$1, x$2);
            var x171 = x169.T2__f__2;
            var part$1 = x169.T2__f__1;
            if ((x171 !== null)) {
              var k = x171._1__O();
              var v$1 = x171._2__O();
              return part$1.dispositionParam__T__T__Lsttp_model_Part(k, v$1);
            }
            throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x169);
          });
          if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$is_sc_IndexedSeq(this$7)) {
            var at = 0;
            var end = this$7.length__I();
            var acc = sttpPart2;
            var $x_3;
            while (true) {
              if ((at !== end)) {
                var temp$at = ((1 + at) | 0);
                var x0$1 = acc;
                var x1 = this$7.apply__I__O(at);
                var temp$acc = f(x0$1, x1);
                at = temp$at;
                acc = temp$acc;
                continue;
              }
              var $x_3 = acc;
              break;
            }
          } else {
            var result = sttpPart2;
            var it = this$7.iterator__sc_Iterator();
            while (it.hasNext__Z()) {
              var x0$2 = result;
              var x1$1 = it.next__O();
              result = f(x0$2, x1$1);
            }
            var $x_3 = result;
          }
          return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($x_3);
        }
      }))(bodyType)));
      var req2 = req.multipartBody__sci_Seq__Lsttp_client3_RequestT(parts.toList__sci_List());
      break matchResult12;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(bodyType);
  }
  if (wasContentTypeAlreadySet) {
    return req2;
  } else {
    var mt = codec.format__Lsttp_tapir_CodecFormat().mediaType__Lsttp_model_MediaType();
    return req2.header__T__T__Z__Lsttp_client3_RequestT($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_ContentType, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$p_Lsttp_model_MediaType__toStringCache__T(mt), true);
  }
}
export { $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__setBody__O__Lsttp_tapir_RawBodyType__Lsttp_tapir_Codec__Lsttp_client3_RequestT__Lsttp_client3_RequestT as $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__setBody__O__Lsttp_tapir_RawBodyType__Lsttp_tapir_Codec__Lsttp_client3_RequestT__Lsttp_client3_RequestT };
function $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__partToSttpPart__Lsttp_model_Part__Lsttp_tapir_RawBodyType__Lsttp_model_Part($thiz, p, bodyType) {
  if ((bodyType instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_RawBodyType$StringBody)) {
    var x186 = bodyType.Lsttp_tapir_RawBodyType$StringBody__f_charset;
    var this$2 = $m_Lsttp_client3_package$();
    var name = p.Lsttp_model_Part__f_name;
    var data = p.Lsttp_model_Part__f_body;
    var encoding = x186.Ljava_nio_charset_Charset__f_canonicalName;
    return $f_Lsttp_client3_SttpApi__multipart__T__T__T__Lsttp_model_Part(this$2, name, data, encoding);
  }
  var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_RawBodyType$ByteArrayBody$();
  if ((x === bodyType)) {
    var this$3 = $m_Lsttp_client3_package$();
    var name$1 = p.Lsttp_model_Part__f_name;
    var data$1 = p.Lsttp_model_Part__f_body;
    return $f_Lsttp_client3_SttpApi__multipart__T__AB__Lsttp_model_Part(this$3, name$1, data$1);
  }
  var x$3 = $m_Lsttp_tapir_RawBodyType$ByteBufferBody$();
  if ((x$3 === bodyType)) {
    var this$4 = $m_Lsttp_client3_package$();
    var name$2 = p.Lsttp_model_Part__f_name;
    var data$2 = p.Lsttp_model_Part__f_body;
    return $f_Lsttp_client3_SttpApi__multipart__T__Ljava_nio_ByteBuffer__Lsttp_model_Part(this$4, name$2, data$2);
  }
  var x$5 = $m_Lsttp_tapir_RawBodyType$InputStreamBody$();
  if ((x$5 === bodyType)) {
    var this$5 = $m_Lsttp_client3_package$();
    var name$3 = p.Lsttp_model_Part__f_name;
    var data$3 = p.Lsttp_model_Part__f_body;
    return $f_Lsttp_client3_SttpApi__multipart__T__Ljava_io_InputStream__Lsttp_model_Part(this$5, name$3, data$3);
  }
  var x$7 = $m_Lsttp_tapir_RawBodyType$FileBody$();
  if ((x$7 === bodyType)) {
    var this$6 = $m_Lsttp_client3_package$();
    var name$4 = p.Lsttp_model_Part__f_name;
    var file = p.Lsttp_model_Part__f_body.Lsttp_tapir_FileRange__f_file;
    return $f_Lsttp_client3_SttpExtensions__multipartFile__T__Lorg_scalajs_dom_File__Lsttp_model_Part(this$6, name$4, file);
  }
  var x$9 = $m_Lsttp_tapir_RawBodyType$InputStreamRangeBody$();
  if ((x$9 === bodyType)) {
    var this$7 = $m_Lsttp_client3_package$();
    var name$5 = p.Lsttp_model_Part__f_name;
    var data$4 = p.Lsttp_model_Part__f_body.Lsttp_tapir_InputStreamRange__f_inputStream.apply__O();
    return $f_Lsttp_client3_SttpApi__multipart__T__Ljava_io_InputStream__Lsttp_model_Part(this$7, name$5, data$4);
  }
  if ((bodyType instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_RawBodyType$MultipartBody)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), "Nested multipart bodies aren't supported");
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(bodyType);
}
export { $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__partToSttpPart__Lsttp_model_Part__Lsttp_tapir_RawBodyType__Lsttp_model_Part as $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__partToSttpPart__Lsttp_model_Part__Lsttp_tapir_RawBodyType__Lsttp_model_Part };
function $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__responseAsFromOutputs__Lsttp_tapir_EndpointOutput__Z__Lsttp_client3_ResponseAs($thiz, out, isWebSocket) {
  var _1 = $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__bodyIsStream__Lsttp_tapir_EndpointOutput__s_Option($thiz, out);
  var x195 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, isWebSocket);
  var x200 = x195.T2__f__1;
  var x201 = (!(!x195.T2__f__2));
  if ((x200 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
    var streams = x200.s_Some__f_value;
    $m_Lsttp_client3_package$();
    return new $c_Lsttp_client3_ResponseAsStreamUnsafe(streams);
  }
  if ((x201 === true)) {
    $m_Lsttp_client3_package$();
    return new $c_Lsttp_client3_ResponseAsWebSocketUnsafe();
  }
  var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  if (((x === x200) && (x201 === false))) {
    var this$7 = new $c_Lsttp_tapir_internal_package$RichEndpointOutput(out).bodyType__s_Option();
    if (this$7.isEmpty__Z()) {
      var this$24 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    } else {
      var x0 = this$7.get__O();
      matchResult14: {
        var $x_1;
        if ((x0 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_RawBodyType$StringBody)) {
          var x194 = x0.Lsttp_tapir_RawBodyType$StringBody__f_charset;
          var this$9 = $m_Lsttp_client3_package$();
          var charset = x194.Ljava_nio_charset_Charset__f_canonicalName;
          var $x_1 = $f_Lsttp_client3_SttpApi__asStringAlways__T__Lsttp_client3_ResponseAs(this$9, charset);
          break matchResult14;
        }
        var x$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_RawBodyType$ByteArrayBody$();
        if ((x$1 === x0)) {
          $m_Lsttp_client3_package$();
          var $x_1 = $m_Lsttp_client3_ResponseAsByteArray$();
          break matchResult14;
        }
        var x$3 = $m_Lsttp_tapir_RawBodyType$ByteBufferBody$();
        if ((x$3 === x0)) {
          $m_Lsttp_client3_package$();
          var this$13 = $m_Lsttp_client3_ResponseAsByteArray$();
          var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$0) => {
            var length = x$0.u.length;
            return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_nio_HeapByteBuffer$().wrap__AB__I__I__I__I__Z__Ljava_nio_ByteBuffer(x$0, 0, x$0.u.length, 0, length, false);
          }));
          var $x_1 = $f_Lsttp_client3_ResponseAs__map__F1__Lsttp_client3_ResponseAs(this$13, f);
          break matchResult14;
        }
        var x$5 = $m_Lsttp_tapir_RawBodyType$InputStreamBody$();
        if ((x$5 === x0)) {
          $m_Lsttp_client3_package$();
          var this$15 = $m_Lsttp_client3_ResponseAsByteArray$();
          var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => $ct_Ljava_io_ByteArrayInputStream__AB__(new $c_Ljava_io_ByteArrayInputStream(), _$2)));
          var $x_1 = $f_Lsttp_client3_ResponseAs__map__F1__Lsttp_client3_ResponseAs(this$15, f$1);
          break matchResult14;
        }
        var x$7 = $m_Lsttp_tapir_RawBodyType$FileBody$();
        if ((x$7 === x0)) {
          var this$16 = $m_Lsttp_client3_package$();
          var file = $thiz.Lsttp_tapir_client_sttp_EndpointToSttpClient__f_clientOptions.Lsttp_tapir_client_sttp_SttpClientOptions__f_createFile.apply__O();
          var $x_1 = $f_Lsttp_client3_ResponseAs__map__F1__Lsttp_client3_ResponseAs($f_Lsttp_client3_SttpExtensions__asFileAlways__Lorg_scalajs_dom_File__Lsttp_client3_ResponseAs(this$16, file), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((d) => {
            var range = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
            return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_FileRange(d, range);
          })));
          break matchResult14;
        }
        var x$9 = $m_Lsttp_tapir_RawBodyType$InputStreamRangeBody$();
        if ((x$9 === x0)) {
          $m_Lsttp_client3_package$();
          var this$22 = $m_Lsttp_client3_ResponseAsByteArray$();
          var f$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((b) => {
            var inputStream = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((b$2) => (() => $ct_Ljava_io_ByteArrayInputStream__AB__(new $c_Ljava_io_ByteArrayInputStream(), b$2)))(b));
            var range$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
            return new $c_Lsttp_tapir_InputStreamRange(inputStream, range$1);
          }));
          var $x_1 = $f_Lsttp_client3_ResponseAs__map__F1__Lsttp_client3_ResponseAs(this$22, f$2);
          break matchResult14;
        }
        if ((x0 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_RawBodyType$MultipartBody)) {
          throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), "Multipart bodies aren't supported in responses");
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x0);
      }
      var this$24 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($x_1);
    }
    return (this$24.isEmpty__Z() ? ($m_Lsttp_client3_package$(), $m_Lsttp_client3_IgnoreResponse$()) : this$24.get__O());
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x195);
}
export { $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__responseAsFromOutputs__Lsttp_tapir_EndpointOutput__Z__Lsttp_client3_ResponseAs as $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__responseAsFromOutputs__Lsttp_tapir_EndpointOutput__Z__Lsttp_client3_ResponseAs };
function $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__bodyIsStream__Lsttp_tapir_EndpointOutput__s_Option($thiz, out) {
  var this$2 = new $c_Lsttp_tapir_internal_package$RichEndpointOutput(out).traverseOutputs__s_PartialFunction__sci_Vector(new $c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$2());
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IndexedSeqOps__headOption__s_Option(this$2);
}
export { $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__bodyIsStream__Lsttp_tapir_EndpointOutput__s_Option as $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__bodyIsStream__Lsttp_tapir_EndpointOutput__s_Option };
function $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__bodyIsWebSocket__Lsttp_tapir_EndpointOutput__Z($thiz, out) {
  var this$2 = new $c_Lsttp_tapir_internal_package$RichEndpointOutput(out).traverseOutputs__s_PartialFunction__sci_Vector(new $c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$3());
  return (!$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_SeqOps__isEmpty__Z(this$2));
}
export { $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__bodyIsWebSocket__Lsttp_tapir_EndpointOutput__Z as $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__bodyIsWebSocket__Lsttp_tapir_EndpointOutput__Z };
function $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__isSuccess$1__Z__Lsttp_model_ResponseMetadata__Z($thiz, isWebSocket$1, meta) {
  return (isWebSocket$1 ? (meta.code__I() === $thiz.Lsttp_tapir_client_sttp_EndpointToSttpClient__f_webSocketSuccessStatusCode) : $m_Lsttp_model_StatusCode$().isSuccess$extension__I__Z(meta.code__I()));
}
export { $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__isSuccess$1__Z__Lsttp_model_ResponseMetadata__Z as $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__isSuccess$1__Z__Lsttp_model_ResponseMetadata__Z };
/** @constructor */
function $c_Lsttp_tapir_client_sttp_EndpointToSttpClient(clientOptions, wsToPipe) {
  this.Lsttp_tapir_client_sttp_EndpointToSttpClient__f_webSocketSuccessStatusCode = 0;
  this.Lsttp_tapir_client_sttp_EndpointToSttpClient__f_clientOptions = null;
  this.Lsttp_tapir_client_sttp_EndpointToSttpClient__f_sttp$tapir$client$sttp$EndpointToSttpClient$$wsToPipe = null;
  this.Lsttp_tapir_client_sttp_EndpointToSttpClient__f_clientOutputParams = null;
  this.Lsttp_tapir_client_sttp_EndpointToSttpClient__f_clientOptions = clientOptions;
  this.Lsttp_tapir_client_sttp_EndpointToSttpClient__f_sttp$tapir$client$sttp$EndpointToSttpClient$$wsToPipe = wsToPipe;
  this.Lsttp_tapir_client_sttp_EndpointToSttpClient__f_webSocketSuccessStatusCode = $m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_Ok;
  this.Lsttp_tapir_client_sttp_EndpointToSttpClient__f_clientOutputParams = new $c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$1(this);
}
export { $c_Lsttp_tapir_client_sttp_EndpointToSttpClient as $c_Lsttp_tapir_client_sttp_EndpointToSttpClient };
$c_Lsttp_tapir_client_sttp_EndpointToSttpClient.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_client_sttp_EndpointToSttpClient.prototype.constructor = $c_Lsttp_tapir_client_sttp_EndpointToSttpClient;
/** @constructor */
function $h_Lsttp_tapir_client_sttp_EndpointToSttpClient() {
}
export { $h_Lsttp_tapir_client_sttp_EndpointToSttpClient as $h_Lsttp_tapir_client_sttp_EndpointToSttpClient };
$h_Lsttp_tapir_client_sttp_EndpointToSttpClient.prototype = $c_Lsttp_tapir_client_sttp_EndpointToSttpClient.prototype;
$c_Lsttp_tapir_client_sttp_EndpointToSttpClient.prototype.toSttpRequest__Lsttp_tapir_Endpoint__s_Option__F1 = (function(e, baseUri) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((aParams) => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((iParams) => {
    matchResult1: {
      var \u03b41$___1;
      var \u03b41$___2;
      var $x_3 = e.Lsttp_tapir_Endpoint__f_securityInput;
      var $x_2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_internal_package$ParamsAsAny(aParams);
      if (baseUri.isEmpty__Z()) {
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_Uri$();
        var scheme = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        var authority = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        var pathSegments = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_Uri$EmptyPath$();
        var querySegments = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
        var fragmentSegment = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_model_Uri(scheme, authority, pathSegments, querySegments, fragmentSegment);
      } else {
        var $x_1 = baseUri.get__O();
      }
      var x1 = $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__setInputParams__Lsttp_tapir_EndpointInput__Lsttp_tapir_internal_package$Params__Lsttp_model_Uri__Lsttp_client3_RequestT__T2(this, $x_3, $x_2, $x_1, $m_Lsttp_client3_package$().Lsttp_client3_package$__f_basicRequest);
      if ((x1 !== null)) {
        var uri1 = x1._1__O();
        var req1 = x1._2__O();
        var \u03b41$___1 = uri1;
        var \u03b41$___2 = req1;
        break matchResult1;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1);
    }
    var uri1$2 = \u03b41$___1;
    var req1$2 = \u03b41$___2;
    matchResult2: {
      var \u03b42$___1;
      var \u03b42$___2;
      var x4 = $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__setInputParams__Lsttp_tapir_EndpointInput__Lsttp_tapir_internal_package$Params__Lsttp_model_Uri__Lsttp_client3_RequestT__T2(this, e.Lsttp_tapir_Endpoint__f_input, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_internal_package$ParamsAsAny(iParams), uri1$2, req1$2);
      if ((x4 !== null)) {
        var uri2 = x4._1__O();
        var req2 = x4._2__O();
        var \u03b42$___1 = uri2;
        var \u03b42$___2 = req2;
        break matchResult2;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x4);
    }
    var uri2$2 = \u03b42$___1;
    var req2$2 = \u03b42$___2;
    $m_Lsttp_model_Method$();
    var this$7 = e.method__s_Option();
    var method = (this$7.isEmpty__Z() ? new $c_Lsttp_model_Method($m_Lsttp_model_Method$().Lsttp_model_Method$__f_GET) : this$7.get__O()).Lsttp_model_Method__f_method;
    var method$1 = new $c_Lsttp_model_Method(method);
    var body = req2$2.Lsttp_client3_RequestT__f_body;
    var headers = req2$2.Lsttp_client3_RequestT__f_headers;
    var response = req2$2.Lsttp_client3_RequestT__f_response;
    var options = req2$2.Lsttp_client3_RequestT__f_options;
    var tags = req2$2.Lsttp_client3_RequestT__f_tags;
    var req3 = new $c_Lsttp_client3_RequestT(method$1, uri2$2, body, headers, response, options, tags);
    var isWebSocket = $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__bodyIsWebSocket__Lsttp_tapir_EndpointOutput__Z(this, e.Lsttp_tapir_Endpoint__f_output);
    $m_Lsttp_client3_package$();
    var default$1 = $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__responseAsFromOutputs__Lsttp_tapir_EndpointOutput__Z__Lsttp_client3_ResponseAs(this, e.Lsttp_tapir_Endpoint__f_errorOutput, false);
    var $x_4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
    var condition = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((meta) => $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__isSuccess$1__Z__Lsttp_model_ResponseMetadata__Z(this, isWebSocket, meta)));
    var responseAs = $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__responseAsFromOutputs__Lsttp_tapir_EndpointOutput__Z__Lsttp_client3_ResponseAs(this, e.Lsttp_tapir_Endpoint__f_output, isWebSocket);
    var conditions = $x_4.wrapRefArray__AO__sci_ArraySeq(new ($d_Lsttp_client3_ConditionalResponseAs.getArrayOf().constr)([new $c_Lsttp_client3_ConditionalResponseAs(condition, responseAs)]));
    var conditions$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(conditions);
    var this$15 = new $c_Lsttp_client3_ResponseAsFromMetadata(conditions$1, default$1);
    var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((body$1, meta$2) => {
      var output = ($p_Lsttp_tapir_client_sttp_EndpointToSttpClient__isSuccess$1__Z__Lsttp_model_ResponseMetadata__Z(this, isWebSocket, meta$2) ? e.Lsttp_tapir_Endpoint__f_output : e.Lsttp_tapir_Endpoint__f_errorOutput);
      var params = this.Lsttp_tapir_client_sttp_EndpointToSttpClient__f_clientOutputParams.apply__Lsttp_tapir_EndpointOutput__O__Lsttp_model_ResponseMetadata__Lsttp_tapir_DecodeResult(output, body$1, meta$2);
      return params.map__F1__Lsttp_tapir_DecodeResult(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => _$1.asAny__O()))).map__F1__Lsttp_tapir_DecodeResult(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((meta$2$1) => ((p) => ($p_Lsttp_tapir_client_sttp_EndpointToSttpClient__isSuccess$1__Z__Lsttp_model_ResponseMetadata__Z(this, isWebSocket, meta$2$1) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(p) : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(p))))(meta$2)));
    }));
    var showAs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    var this$19 = new $c_Lsttp_client3_MappedResponseAs(this$15, f, showAs);
    var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
      if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_DecodeResult$Error)) {
        var x10 = x$1.Lsttp_tapir_DecodeResult$Error__f_original;
        var x11 = x$1.Lsttp_tapir_DecodeResult$Error__f_error;
        var error = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__jl_Throwable__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), ((((("Cannot decode from: " + x10) + ", request: ") + req3.Lsttp_client3_RequestT__f_method) + " ") + req3.Lsttp_client3_RequestT__f_uri), x11);
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_DecodeResult$Error(x10, error);
      } else {
        return x$1;
      }
    }));
    var responseAs$1 = $f_Lsttp_client3_ResponseAs__map__F1__Lsttp_client3_ResponseAs(this$19, f$1);
    var method$2 = req3.Lsttp_client3_RequestT__f_method;
    var uri = req3.Lsttp_client3_RequestT__f_uri;
    var body$2 = req3.Lsttp_client3_RequestT__f_body;
    var headers$1 = req3.Lsttp_client3_RequestT__f_headers;
    var options$1 = req3.Lsttp_client3_RequestT__f_options;
    var tags$1 = req3.Lsttp_client3_RequestT__f_tags;
    return new $c_Lsttp_client3_RequestT(method$2, uri, body$2, headers$1, responseAs$1, options$1, tags$1);
  }))));
});
$c_Lsttp_tapir_client_sttp_EndpointToSttpClient.prototype.handleInputPair__Lsttp_tapir_EndpointInput__Lsttp_tapir_EndpointInput__Lsttp_tapir_internal_package$Params__F1__Lsttp_model_Uri__Lsttp_client3_RequestT__T2 = (function(left, right, params, split, uri, req) {
  matchResult9: {
    var \u03b43$___1;
    var \u03b43$___2;
    var x163 = split.apply__O__O(params);
    if ((x163 !== null)) {
      var leftParams = x163._1__O();
      var rightParams = x163._2__O();
      var \u03b43$___1 = leftParams;
      var \u03b43$___2 = rightParams;
      break matchResult9;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x163);
  }
  var leftParams$2 = \u03b43$___1;
  var rightParams$2 = \u03b43$___2;
  matchResult10: {
    var \u03b44$___1;
    var \u03b44$___2;
    var x166 = $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__setInputParams__Lsttp_tapir_EndpointInput__Lsttp_tapir_internal_package$Params__Lsttp_model_Uri__Lsttp_client3_RequestT__T2(this, left, leftParams$2, uri, req);
    if ((x166 !== null)) {
      var uri2 = x166._1__O();
      var req2 = x166._2__O();
      var \u03b44$___1 = uri2;
      var \u03b44$___2 = req2;
      break matchResult10;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x166);
  }
  var uri2$2 = \u03b44$___1;
  var req2$2 = \u03b44$___2;
  return $p_Lsttp_tapir_client_sttp_EndpointToSttpClient__setInputParams__Lsttp_tapir_EndpointInput__Lsttp_tapir_internal_package$Params__Lsttp_model_Uri__Lsttp_client3_RequestT__T2(this, right, rightParams$2, uri2$2, req2$2);
});
var $d_Lsttp_tapir_client_sttp_EndpointToSttpClient = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_client_sttp_EndpointToSttpClient, "sttp.tapir.client.sttp.EndpointToSttpClient", ({
  Lsttp_tapir_client_sttp_EndpointToSttpClient: 1,
  Lsttp_tapir_client_sttp_EndpointToSttpClientExtensions: 1
}));
export { $d_Lsttp_tapir_client_sttp_EndpointToSttpClient as $d_Lsttp_tapir_client_sttp_EndpointToSttpClient };
/** @constructor */
function $c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$1(outer) {
  this.Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$1__f_$outer = outer;
}
export { $c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$1 as $c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$1 };
$c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$1.prototype = new $h_Lsttp_tapir_client_ClientOutputParams();
$c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$1.prototype.constructor = $c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$1;
/** @constructor */
function $h_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$1() {
}
export { $h_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$1 as $h_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$1 };
$h_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$1.prototype = $c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$1.prototype;
$c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$1.prototype.decodeWebSocketBody__Lsttp_tapir_WebSocketBodyOutput__O__Lsttp_tapir_DecodeResult = (function(o, body) {
  var streams = o.Lsttp_tapir_WebSocketBodyOutput__f_streams;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lsttp_tapir_Codec__decode__O__Lsttp_tapir_DecodeResult(o.Lsttp_tapir_WebSocketBodyOutput__f_codec, this.Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$1__f_$outer.Lsttp_tapir_client_sttp_EndpointToSttpClient__f_sttp$tapir$client$sttp$EndpointToSttpClient$$wsToPipe.apply__O__Lsttp_ws_WebSocket__Lsttp_tapir_WebSocketBodyOutput__O(streams, body, o));
});
var $d_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$1, "sttp.tapir.client.sttp.EndpointToSttpClient$$anon$1", ({
  Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$1: 1,
  Lsttp_tapir_client_ClientOutputParams: 1
}));
export { $d_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$1 as $d_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$1 };
function $f_Lsttp_tapir_client_sttp_SttpClientInterpreter__toRequest__Lsttp_tapir_Endpoint__s_Option__Lsttp_tapir_client_sttp_WebSocketToPipe__F1($thiz, e, baseUri, wsToPipe) {
  return new $c_Lsttp_tapir_client_sttp_EndpointToSttpClient($thiz.Lsttp_tapir_client_sttp_SttpClientInterpreter$$anon$1__f_clientOptions$1, wsToPipe).toSttpRequest__Lsttp_tapir_Endpoint__s_Option__F1(e, baseUri).apply__O__O((void 0));
}
export { $f_Lsttp_tapir_client_sttp_SttpClientInterpreter__toRequest__Lsttp_tapir_Endpoint__s_Option__Lsttp_tapir_client_sttp_WebSocketToPipe__F1 as $f_Lsttp_tapir_client_sttp_SttpClientInterpreter__toRequest__Lsttp_tapir_Endpoint__s_Option__Lsttp_tapir_client_sttp_WebSocketToPipe__F1 };
function $f_Lsttp_tapir_client_sttp_SttpClientInterpreter__toSecureRequest__Lsttp_tapir_Endpoint__s_Option__Lsttp_tapir_client_sttp_WebSocketToPipe__F1($thiz, e, baseUri, wsToPipe) {
  return new $c_Lsttp_tapir_client_sttp_EndpointToSttpClient($thiz.Lsttp_tapir_client_sttp_SttpClientInterpreter$$anon$1__f_clientOptions$1, wsToPipe).toSttpRequest__Lsttp_tapir_Endpoint__s_Option__F1(e, baseUri);
}
export { $f_Lsttp_tapir_client_sttp_SttpClientInterpreter__toSecureRequest__Lsttp_tapir_Endpoint__s_Option__Lsttp_tapir_client_sttp_WebSocketToPipe__F1 as $f_Lsttp_tapir_client_sttp_SttpClientInterpreter__toSecureRequest__Lsttp_tapir_Endpoint__s_Option__Lsttp_tapir_client_sttp_WebSocketToPipe__F1 };
/** @constructor */
function $c_Lsttp_tapir_client_sttp_WebSocketToPipe$$anon$1() {
}
export { $c_Lsttp_tapir_client_sttp_WebSocketToPipe$$anon$1 as $c_Lsttp_tapir_client_sttp_WebSocketToPipe$$anon$1 };
$c_Lsttp_tapir_client_sttp_WebSocketToPipe$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_client_sttp_WebSocketToPipe$$anon$1.prototype.constructor = $c_Lsttp_tapir_client_sttp_WebSocketToPipe$$anon$1;
/** @constructor */
function $h_Lsttp_tapir_client_sttp_WebSocketToPipe$$anon$1() {
}
export { $h_Lsttp_tapir_client_sttp_WebSocketToPipe$$anon$1 as $h_Lsttp_tapir_client_sttp_WebSocketToPipe$$anon$1 };
$h_Lsttp_tapir_client_sttp_WebSocketToPipe$$anon$1.prototype = $c_Lsttp_tapir_client_sttp_WebSocketToPipe$$anon$1.prototype;
$c_Lsttp_tapir_client_sttp_WebSocketToPipe$$anon$1.prototype.apply__O__Lsttp_ws_WebSocket__Lsttp_tapir_WebSocketBodyOutput__O = (function(s, ws, o) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_RuntimeException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_RuntimeException(), "WebSockets are not supported");
});
var $d_Lsttp_tapir_client_sttp_WebSocketToPipe$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_client_sttp_WebSocketToPipe$$anon$1, "sttp.tapir.client.sttp.WebSocketToPipe$$anon$1", ({
  Lsttp_tapir_client_sttp_WebSocketToPipe$$anon$1: 1,
  Lsttp_tapir_client_sttp_WebSocketToPipe: 1
}));
export { $d_Lsttp_tapir_client_sttp_WebSocketToPipe$$anon$1 as $d_Lsttp_tapir_client_sttp_WebSocketToPipe$$anon$1 };
/** @constructor */
function $c_Lsttp_tapir_typelevel_BinaryPolyFunc$$anon$3(f$24) {
}
export { $c_Lsttp_tapir_typelevel_BinaryPolyFunc$$anon$3 as $c_Lsttp_tapir_typelevel_BinaryPolyFunc$$anon$3 };
$c_Lsttp_tapir_typelevel_BinaryPolyFunc$$anon$3.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_typelevel_BinaryPolyFunc$$anon$3.prototype.constructor = $c_Lsttp_tapir_typelevel_BinaryPolyFunc$$anon$3;
/** @constructor */
function $h_Lsttp_tapir_typelevel_BinaryPolyFunc$$anon$3() {
}
export { $h_Lsttp_tapir_typelevel_BinaryPolyFunc$$anon$3 as $h_Lsttp_tapir_typelevel_BinaryPolyFunc$$anon$3 };
$h_Lsttp_tapir_typelevel_BinaryPolyFunc$$anon$3.prototype = $c_Lsttp_tapir_typelevel_BinaryPolyFunc$$anon$3.prototype;
var $d_Lsttp_tapir_typelevel_BinaryPolyFunc$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_typelevel_BinaryPolyFunc$$anon$3, "sttp.tapir.typelevel.BinaryPolyFunc$$anon$3", ({
  Lsttp_tapir_typelevel_BinaryPolyFunc$$anon$3: 1,
  Lsttp_tapir_typelevel_BinaryPolyFunc$Case: 1
}));
export { $d_Lsttp_tapir_typelevel_BinaryPolyFunc$$anon$3 as $d_Lsttp_tapir_typelevel_BinaryPolyFunc$$anon$3 };
/** @constructor */
function $c_Lsttp_tapir_typelevel_LowPriorityTupleArity$$anon$21() {
}
export { $c_Lsttp_tapir_typelevel_LowPriorityTupleArity$$anon$21 as $c_Lsttp_tapir_typelevel_LowPriorityTupleArity$$anon$21 };
$c_Lsttp_tapir_typelevel_LowPriorityTupleArity$$anon$21.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_typelevel_LowPriorityTupleArity$$anon$21.prototype.constructor = $c_Lsttp_tapir_typelevel_LowPriorityTupleArity$$anon$21;
/** @constructor */
function $h_Lsttp_tapir_typelevel_LowPriorityTupleArity$$anon$21() {
}
export { $h_Lsttp_tapir_typelevel_LowPriorityTupleArity$$anon$21 as $h_Lsttp_tapir_typelevel_LowPriorityTupleArity$$anon$21 };
$h_Lsttp_tapir_typelevel_LowPriorityTupleArity$$anon$21.prototype = $c_Lsttp_tapir_typelevel_LowPriorityTupleArity$$anon$21.prototype;
$c_Lsttp_tapir_typelevel_LowPriorityTupleArity$$anon$21.prototype.arity__I = (function() {
  return 1;
});
var $d_Lsttp_tapir_typelevel_LowPriorityTupleArity$$anon$21 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_typelevel_LowPriorityTupleArity$$anon$21, "sttp.tapir.typelevel.LowPriorityTupleArity$$anon$21", ({
  Lsttp_tapir_typelevel_LowPriorityTupleArity$$anon$21: 1,
  Lsttp_tapir_typelevel_TupleArity: 1
}));
export { $d_Lsttp_tapir_typelevel_LowPriorityTupleArity$$anon$21 as $d_Lsttp_tapir_typelevel_LowPriorityTupleArity$$anon$21 };
/** @constructor */
function $c_Lsttp_tapir_typelevel_TupleAppendOneInstances$$anon$28() {
}
export { $c_Lsttp_tapir_typelevel_TupleAppendOneInstances$$anon$28 as $c_Lsttp_tapir_typelevel_TupleAppendOneInstances$$anon$28 };
$c_Lsttp_tapir_typelevel_TupleAppendOneInstances$$anon$28.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_typelevel_TupleAppendOneInstances$$anon$28.prototype.constructor = $c_Lsttp_tapir_typelevel_TupleAppendOneInstances$$anon$28;
/** @constructor */
function $h_Lsttp_tapir_typelevel_TupleAppendOneInstances$$anon$28() {
}
export { $h_Lsttp_tapir_typelevel_TupleAppendOneInstances$$anon$28 as $h_Lsttp_tapir_typelevel_TupleAppendOneInstances$$anon$28 };
$h_Lsttp_tapir_typelevel_TupleAppendOneInstances$$anon$28.prototype = $c_Lsttp_tapir_typelevel_TupleAppendOneInstances$$anon$28.prototype;
$c_Lsttp_tapir_typelevel_TupleAppendOneInstances$$anon$28.prototype.apply__O__O__O = (function(prefix, last) {
  var _1 = prefix.T1__f__1;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, last);
});
var $d_Lsttp_tapir_typelevel_TupleAppendOneInstances$$anon$28 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_typelevel_TupleAppendOneInstances$$anon$28, "sttp.tapir.typelevel.TupleAppendOneInstances$$anon$28", ({
  Lsttp_tapir_typelevel_TupleAppendOneInstances$$anon$28: 1,
  Lsttp_tapir_typelevel_TupleOps$AppendOne: 1
}));
export { $d_Lsttp_tapir_typelevel_TupleAppendOneInstances$$anon$28 as $d_Lsttp_tapir_typelevel_TupleAppendOneInstances$$anon$28 };
/** @constructor */
function $c_Lsttp_tapir_typelevel_TupleOps$Join$Fold$() {
}
export { $c_Lsttp_tapir_typelevel_TupleOps$Join$Fold$ as $c_Lsttp_tapir_typelevel_TupleOps$Join$Fold$ };
$c_Lsttp_tapir_typelevel_TupleOps$Join$Fold$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_typelevel_TupleOps$Join$Fold$.prototype.constructor = $c_Lsttp_tapir_typelevel_TupleOps$Join$Fold$;
/** @constructor */
function $h_Lsttp_tapir_typelevel_TupleOps$Join$Fold$() {
}
export { $h_Lsttp_tapir_typelevel_TupleOps$Join$Fold$ as $h_Lsttp_tapir_typelevel_TupleOps$Join$Fold$ };
$h_Lsttp_tapir_typelevel_TupleOps$Join$Fold$.prototype = $c_Lsttp_tapir_typelevel_TupleOps$Join$Fold$.prototype;
$c_Lsttp_tapir_typelevel_TupleOps$Join$Fold$.prototype.step__Lsttp_tapir_typelevel_TupleOps$AppendOne__Lsttp_tapir_typelevel_BinaryPolyFunc$Case = (function(append) {
  new $c_Lsttp_tapir_typelevel_BinaryPolyFunc$CaseBuilder(this);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((_$1, _$2) => append.apply__O__O__O(_$1, _$2)));
  return new $c_Lsttp_tapir_typelevel_BinaryPolyFunc$$anon$3(f);
});
var $d_Lsttp_tapir_typelevel_TupleOps$Join$Fold$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_typelevel_TupleOps$Join$Fold$, "sttp.tapir.typelevel.TupleOps$Join$Fold$", ({
  Lsttp_tapir_typelevel_TupleOps$Join$Fold$: 1,
  Lsttp_tapir_typelevel_BinaryPolyFunc: 1
}));
export { $d_Lsttp_tapir_typelevel_TupleOps$Join$Fold$ as $d_Lsttp_tapir_typelevel_TupleOps$Join$Fold$ };
var $n_Lsttp_tapir_typelevel_TupleOps$Join$Fold$;
function $m_Lsttp_tapir_typelevel_TupleOps$Join$Fold$() {
  if ((!$n_Lsttp_tapir_typelevel_TupleOps$Join$Fold$)) {
    $n_Lsttp_tapir_typelevel_TupleOps$Join$Fold$ = new $c_Lsttp_tapir_typelevel_TupleOps$Join$Fold$();
  }
  return $n_Lsttp_tapir_typelevel_TupleOps$Join$Fold$;
}
export { $m_Lsttp_tapir_typelevel_TupleOps$Join$Fold$ as $m_Lsttp_tapir_typelevel_TupleOps$Join$Fold$ };
function $f_Lurldsl_language_PathSegment__matchRawUrl__T__Lurldsl_url_UrlStringParserGenerator__s_util_Either($thiz, url, urlStringParserGenerator) {
  var this$1 = new $c_Lurldsl_url_JSUrlStringParser(url);
  var path = this$1.path__T();
  var this$2 = $thiz.matchSegments__sci_List__s_util_Either($f_Lurldsl_url_UrlStringDecoder__decodePath__T__sci_List(this$1, path));
  if ((this$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
    var b = this$2.s_util_Right__f_value;
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(b.Lurldsl_vocabulary_PathMatchOutput__f_output);
  } else {
    return this$2;
  }
}
export { $f_Lurldsl_language_PathSegment__matchRawUrl__T__Lurldsl_url_UrlStringParserGenerator__s_util_Either as $f_Lurldsl_language_PathSegment__matchRawUrl__T__Lurldsl_url_UrlStringParserGenerator__s_util_Either };
function $f_Lurldsl_language_PathSegment__createPath__O__Lurldsl_url_UrlStringGenerator__T($thiz, t, encoder) {
  var segments = $thiz.createSegments__O__sci_List(t);
  return $f_Lurldsl_url_UrlStringGenerator__makePath__sci_List__T(encoder, segments);
}
export { $f_Lurldsl_language_PathSegment__createPath__O__Lurldsl_url_UrlStringGenerator__T as $f_Lurldsl_language_PathSegment__createPath__O__Lurldsl_url_UrlStringGenerator__T };
function $f_Lurldsl_language_PathSegment__$div__Lurldsl_language_PathSegment__Lapp_tulz_tuplez_Composition__Lurldsl_language_PathSegment($thiz, that, c) {
  var this$17 = $m_Lurldsl_language_PathSegment$();
  var matching = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((segments) => {
    var this$2 = $thiz.matchSegments__sci_List__s_util_Either(segments);
    if ((this$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
      var b = this$2.s_util_Right__f_value;
      matchResult1: {
        var \u03b42$___1;
        var \u03b42$___2;
        var \u03b42$___3;
        if ((b !== null)) {
          var x3 = b.Lurldsl_vocabulary_PathMatchOutput__f_output;
          var x4 = b.Lurldsl_vocabulary_PathMatchOutput__f_unusedSegments;
          var \u03b42$___1 = b;
          var \u03b42$___2 = x3;
          var \u03b42$___3 = x4;
          break matchResult1;
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(b);
      }
      var \u03b41$$2 = \u03b42$___1;
      var this$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), b, \u03b41$$2));
    } else {
      var this$6 = this$2;
    }
    if ((this$6 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
      var b$1 = this$6.s_util_Right__f_value;
      if ((b$1 !== null)) {
        var x17 = b$1._2__O();
        b$1._1__O();
        if ((x17 !== null)) {
          var x19 = x17.Lurldsl_vocabulary_PathMatchOutput__f_output;
          var x20 = x17.Lurldsl_vocabulary_PathMatchOutput__f_unusedSegments;
          var this$8 = that.matchSegments__sci_List__s_util_Either(x20);
          if ((this$8 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
            var b$2 = this$8.s_util_Right__f_value;
            matchResult2: {
              var \u03b44$___1;
              var \u03b44$___2;
              var \u03b44$___3;
              if ((b$2 !== null)) {
                var x7 = b$2.Lurldsl_vocabulary_PathMatchOutput__f_output;
                var x8 = b$2.Lurldsl_vocabulary_PathMatchOutput__f_unusedSegments;
                var \u03b44$___1 = b$2;
                var \u03b44$___2 = x7;
                var \u03b44$___3 = x8;
                break matchResult2;
              }
              throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(b$2);
            }
            var \u03b43$$2 = \u03b44$___1;
            var this$12 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), b$2, \u03b43$$2));
          } else {
            var this$12 = this$8;
          }
          if ((this$12 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
            var b$3 = this$12.s_util_Right__f_value;
            matchResult3: {
              var $x_1;
              if ((b$3 !== null)) {
                var x11 = b$3._2__O();
                b$3._1__O();
                if ((x11 !== null)) {
                  var x13 = x11.Lurldsl_vocabulary_PathMatchOutput__f_output;
                  var x14 = x11.Lurldsl_vocabulary_PathMatchOutput__f_unusedSegments;
                  var output = c.compose__O__O__O(x19, x13);
                  var $x_1 = new $c_Lurldsl_vocabulary_PathMatchOutput(output, x14);
                  break matchResult3;
                }
              }
              throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(b$3);
            }
            return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right($x_1);
          } else {
            return this$12;
          }
        }
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(b$1);
    } else {
      return this$6;
    }
  }));
  var creating = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((out) => {
    matchResult5: {
      var \u03b45$___1;
      var \u03b45$___2;
      var x21 = c.decompose__O__T2(out);
      if ((x21 !== null)) {
        var t = x21._1__O();
        var u = x21._2__O();
        var \u03b45$___1 = t;
        var \u03b45$___2 = u;
        break matchResult5;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x21);
    }
    var t$2$1 = \u03b45$___1;
    var u$2$1 = \u03b45$___2;
    var this$16 = $thiz.createSegments__O__sci_List(t$2$1);
    var suffix = that.createSegments__O__sci_List(u$2$1);
    return this$16.appendedAll__sc_IterableOnce__sci_List(suffix);
  }));
  return new $c_Lurldsl_language_PathSegment$$anon$1(matching, creating, this$17);
}
export { $f_Lurldsl_language_PathSegment__$div__Lurldsl_language_PathSegment__Lapp_tulz_tuplez_Composition__Lurldsl_language_PathSegment as $f_Lurldsl_language_PathSegment__$div__Lurldsl_language_PathSegment__Lapp_tulz_tuplez_Composition__Lurldsl_language_PathSegment };
/** @constructor */
function $c_Lurldsl_language_PathSegmentWithQueryParams(pathSegment, queryParams) {
  this.Lurldsl_language_PathSegmentWithQueryParams__f_pathSegment = null;
  this.Lurldsl_language_PathSegmentWithQueryParams__f_queryParams = null;
  this.Lurldsl_language_PathSegmentWithQueryParams__f_pathSegment = pathSegment;
  this.Lurldsl_language_PathSegmentWithQueryParams__f_queryParams = queryParams;
}
export { $c_Lurldsl_language_PathSegmentWithQueryParams as $c_Lurldsl_language_PathSegmentWithQueryParams };
$c_Lurldsl_language_PathSegmentWithQueryParams.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lurldsl_language_PathSegmentWithQueryParams.prototype.constructor = $c_Lurldsl_language_PathSegmentWithQueryParams;
/** @constructor */
function $h_Lurldsl_language_PathSegmentWithQueryParams() {
}
export { $h_Lurldsl_language_PathSegmentWithQueryParams as $h_Lurldsl_language_PathSegmentWithQueryParams };
$h_Lurldsl_language_PathSegmentWithQueryParams.prototype = $c_Lurldsl_language_PathSegmentWithQueryParams.prototype;
$c_Lurldsl_language_PathSegmentWithQueryParams.prototype.matchRawUrl__T__Lurldsl_url_UrlStringParserGenerator__s_util_Either = (function(url, parserGenerator) {
  var this$1 = this.Lurldsl_language_PathSegmentWithQueryParams__f_pathSegment;
  var x22 = $f_Lurldsl_language_PathSegment__matchRawUrl__T__Lurldsl_url_UrlStringParserGenerator__s_util_Either(this$1, url, parserGenerator);
  if ((x22 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
    var error = x22.s_util_Left__f_value;
    var value = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(error);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value);
  }
  if ((x22 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
    var pathOutput = x22.s_util_Right__f_value;
    var this$4 = this.Lurldsl_language_PathSegmentWithQueryParams__f_queryParams;
    var x17 = $f_Lurldsl_language_QueryParameters__matchRawUrl__T__Lurldsl_url_UrlStringParserGenerator__s_util_Either(this$4, url, parserGenerator);
    if ((x17 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
      var error$2 = x17.s_util_Left__f_value;
      var value$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(error$2);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value$1);
    }
    if ((x17 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
      var paramsOutput = x17.s_util_Right__f_value;
      var value$2 = new $c_Lurldsl_vocabulary_UrlMatching(pathOutput, paramsOutput);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value$2);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x17);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x22);
});
$c_Lurldsl_language_PathSegmentWithQueryParams.prototype.createUrlString__O__O__Lurldsl_url_UrlStringGenerator__T = (function(path, params, generator) {
  var this$1 = this.Lurldsl_language_PathSegmentWithQueryParams__f_pathSegment;
  var x = $f_Lurldsl_language_PathSegment__createPath__O__Lurldsl_url_UrlStringGenerator__T(this$1, path, generator);
  var x$1 = (x + "?");
  var this$6 = this.Lurldsl_language_PathSegmentWithQueryParams__f_queryParams;
  var xs = $f_Lurldsl_language_QueryParameters__createParamsString__O__Lurldsl_url_UrlStringGenerator__T(this$6, params, generator);
  return (x$1 + xs);
});
var $d_Lurldsl_language_PathSegmentWithQueryParams = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lurldsl_language_PathSegmentWithQueryParams, "urldsl.language.PathSegmentWithQueryParams", ({
  Lurldsl_language_PathSegmentWithQueryParams: 1,
  Lurldsl_language_UrlPart: 1
}));
export { $d_Lurldsl_language_PathSegmentWithQueryParams as $d_Lurldsl_language_PathSegmentWithQueryParams };
function $f_Lurldsl_language_QueryParameters__matchRawUrl__T__Lurldsl_url_UrlStringParserGenerator__s_util_Either($thiz, url, urlStringParserGenerator) {
  var this$1 = new $c_Lurldsl_url_JSUrlStringParser(url);
  var queryString = this$1.queryParametersString__T();
  var this$2 = $thiz.matchParams__sci_Map__s_util_Either($f_Lurldsl_url_UrlStringDecoder__decodeParams__T__sci_Map(this$1, queryString));
  if ((this$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
    var b = this$2.s_util_Right__f_value;
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(b.Lurldsl_vocabulary_ParamMatchOutput__f_output);
  } else {
    return this$2;
  }
}
export { $f_Lurldsl_language_QueryParameters__matchRawUrl__T__Lurldsl_url_UrlStringParserGenerator__s_util_Either as $f_Lurldsl_language_QueryParameters__matchRawUrl__T__Lurldsl_url_UrlStringParserGenerator__s_util_Either };
function $f_Lurldsl_language_QueryParameters__createParamsString__O__Lurldsl_url_UrlStringGenerator__T($thiz, q, encoder) {
  var params = $thiz.createParams__O__sci_Map(q);
  return $f_Lurldsl_url_UrlStringGenerator__makeParams__sci_Map__T(encoder, params);
}
export { $f_Lurldsl_language_QueryParameters__createParamsString__O__Lurldsl_url_UrlStringGenerator__T as $f_Lurldsl_language_QueryParameters__createParamsString__O__Lurldsl_url_UrlStringGenerator__T };
function $f_Lurldsl_language_QueryParameters__$amp__Lurldsl_language_QueryParameters__Lapp_tulz_tuplez_Composition__Lurldsl_language_QueryParameters($thiz, that, c) {
  var this$16 = $m_Lurldsl_language_QueryParameters$();
  var matching = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((params) => {
    var this$2 = $thiz.matchParams__sci_Map__s_util_Either(params);
    if ((this$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
      var b = this$2.s_util_Right__f_value;
      matchResult1: {
        var \u03b42$___1;
        var \u03b42$___2;
        var \u03b42$___3;
        if ((b !== null)) {
          var x3 = b.Lurldsl_vocabulary_ParamMatchOutput__f_output;
          var x4 = b.Lurldsl_vocabulary_ParamMatchOutput__f_unusedParams;
          var \u03b42$___1 = b;
          var \u03b42$___2 = x3;
          var \u03b42$___3 = x4;
          break matchResult1;
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(b);
      }
      var \u03b41$$2 = \u03b42$___1;
      var this$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), b, \u03b41$$2));
    } else {
      var this$6 = this$2;
    }
    if ((this$6 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
      var b$1 = this$6.s_util_Right__f_value;
      if ((b$1 !== null)) {
        var x17 = b$1._2__O();
        b$1._1__O();
        if ((x17 !== null)) {
          var x19 = x17.Lurldsl_vocabulary_ParamMatchOutput__f_output;
          var x20 = x17.Lurldsl_vocabulary_ParamMatchOutput__f_unusedParams;
          var this$8 = that.matchParams__sci_Map__s_util_Either(x20);
          if ((this$8 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
            var b$2 = this$8.s_util_Right__f_value;
            matchResult2: {
              var \u03b44$___1;
              var \u03b44$___2;
              var \u03b44$___3;
              if ((b$2 !== null)) {
                var x7 = b$2.Lurldsl_vocabulary_ParamMatchOutput__f_output;
                var x8 = b$2.Lurldsl_vocabulary_ParamMatchOutput__f_unusedParams;
                var \u03b44$___1 = b$2;
                var \u03b44$___2 = x7;
                var \u03b44$___3 = x8;
                break matchResult2;
              }
              throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(b$2);
            }
            var \u03b43$$2 = \u03b44$___1;
            var this$12 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), b$2, \u03b43$$2));
          } else {
            var this$12 = this$8;
          }
          if ((this$12 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
            var b$3 = this$12.s_util_Right__f_value;
            matchResult3: {
              var $x_1;
              if ((b$3 !== null)) {
                var x11 = b$3._2__O();
                b$3._1__O();
                if ((x11 !== null)) {
                  var x13 = x11.Lurldsl_vocabulary_ParamMatchOutput__f_output;
                  var x14 = x11.Lurldsl_vocabulary_ParamMatchOutput__f_unusedParams;
                  var output = c.compose__O__O__O(x19, x13);
                  var $x_1 = new $c_Lurldsl_vocabulary_ParamMatchOutput(output, x14);
                  break matchResult3;
                }
              }
              throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(b$3);
            }
            return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right($x_1);
          } else {
            return this$12;
          }
        }
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(b$1);
    } else {
      return this$6;
    }
  }));
  var creating = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((out) => {
    matchResult5: {
      var \u03b45$___1;
      var \u03b45$___2;
      var x21 = c.decompose__O__T2(out);
      if ((x21 !== null)) {
        var q = x21._1__O();
        var r = x21._2__O();
        var \u03b45$___1 = q;
        var \u03b45$___2 = r;
        break matchResult5;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x21);
    }
    var q$2$1 = \u03b45$___1;
    var r$2$1 = \u03b45$___2;
    return $thiz.createParams__O__sci_Map(q$2$1).$plus$plus__sc_IterableOnce__sc_IterableOps(that.createParams__O__sci_Map(r$2$1));
  }));
  return new $c_Lurldsl_language_QueryParameters$$anon$1(matching, creating, this$16);
}
export { $f_Lurldsl_language_QueryParameters__$amp__Lurldsl_language_QueryParameters__Lapp_tulz_tuplez_Composition__Lurldsl_language_QueryParameters as $f_Lurldsl_language_QueryParameters__$amp__Lurldsl_language_QueryParameters__Lapp_tulz_tuplez_Composition__Lurldsl_language_QueryParameters };
function $f_Lurldsl_language_QueryParameters__$qmark__Lurldsl_language_QueryParameters($thiz) {
  var this$10 = $m_Lurldsl_language_QueryParameters$();
  var matching = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((params) => {
    var x24 = $thiz.matchParams__sci_Map__s_util_Either(params);
    if ((x24 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
      var x28 = x24.s_util_Right__f_value;
      if ((x28 !== null)) {
        var x30 = x28.Lurldsl_vocabulary_ParamMatchOutput__f_output;
        var x31 = x28.Lurldsl_vocabulary_ParamMatchOutput__f_unusedParams;
        var output = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(x30);
        var value = new $c_Lurldsl_vocabulary_ParamMatchOutput(output, x31);
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value);
      }
    }
    if ((x24 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
      var output$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      var value$1 = new $c_Lurldsl_vocabulary_ParamMatchOutput(output$1, params);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value$1);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x24);
  }));
  var creating = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$3) => {
    if (_$3.isEmpty__Z()) {
      var this$8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    } else {
      var x0 = _$3.get__O();
      var this$8 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($thiz.createParams__O__sci_Map(x0));
    }
    if (this$8.isEmpty__Z()) {
      var this$9 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$();
      var elems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T2.getArrayOf().constr)([]));
      var $x_1 = this$9.from__sc_IterableOnce__sci_Map(elems);
    } else {
      var $x_1 = this$8.get__O();
    }
    return $x_1;
  }));
  return new $c_Lurldsl_language_QueryParameters$$anon$1(matching, creating, this$10);
}
export { $f_Lurldsl_language_QueryParameters__$qmark__Lurldsl_language_QueryParameters as $f_Lurldsl_language_QueryParameters__$qmark__Lurldsl_language_QueryParameters };
/** @constructor */
function $c_Lurldsl_url_DefaultUrlStringGenerator$$anon$1(outer) {
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lurldsl_url_DefaultUrlStringGenerator$$anon$1 as $c_Lurldsl_url_DefaultUrlStringGenerator$$anon$1 };
$c_Lurldsl_url_DefaultUrlStringGenerator$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lurldsl_url_DefaultUrlStringGenerator$$anon$1.prototype.constructor = $c_Lurldsl_url_DefaultUrlStringGenerator$$anon$1;
/** @constructor */
function $h_Lurldsl_url_DefaultUrlStringGenerator$$anon$1() {
}
export { $h_Lurldsl_url_DefaultUrlStringGenerator$$anon$1 as $h_Lurldsl_url_DefaultUrlStringGenerator$$anon$1 };
$h_Lurldsl_url_DefaultUrlStringGenerator$$anon$1.prototype = $c_Lurldsl_url_DefaultUrlStringGenerator$$anon$1.prototype;
var $d_Lurldsl_url_DefaultUrlStringGenerator$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lurldsl_url_DefaultUrlStringGenerator$$anon$1, "urldsl.url.DefaultUrlStringGenerator$$anon$1", ({
  Lurldsl_url_DefaultUrlStringGenerator$$anon$1: 1,
  Lurldsl_url_UrlStringGenerator: 1
}));
export { $d_Lurldsl_url_DefaultUrlStringGenerator$$anon$1 as $d_Lurldsl_url_DefaultUrlStringGenerator$$anon$1 };
/** @constructor */
function $c_Lurldsl_url_JSUrlStringParser$$anon$1(outer) {
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lurldsl_url_JSUrlStringParser$$anon$1 as $c_Lurldsl_url_JSUrlStringParser$$anon$1 };
$c_Lurldsl_url_JSUrlStringParser$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lurldsl_url_JSUrlStringParser$$anon$1.prototype.constructor = $c_Lurldsl_url_JSUrlStringParser$$anon$1;
/** @constructor */
function $h_Lurldsl_url_JSUrlStringParser$$anon$1() {
}
export { $h_Lurldsl_url_JSUrlStringParser$$anon$1 as $h_Lurldsl_url_JSUrlStringParser$$anon$1 };
$h_Lurldsl_url_JSUrlStringParser$$anon$1.prototype = $c_Lurldsl_url_JSUrlStringParser$$anon$1.prototype;
var $d_Lurldsl_url_JSUrlStringParser$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lurldsl_url_JSUrlStringParser$$anon$1, "urldsl.url.JSUrlStringParser$$anon$1", ({
  Lurldsl_url_JSUrlStringParser$$anon$1: 1,
  Lurldsl_url_UrlStringParserGenerator: 1
}));
export { $d_Lurldsl_url_JSUrlStringParser$$anon$1 as $d_Lurldsl_url_JSUrlStringParser$$anon$1 };
/** @constructor */
function $c_Lurldsl_url_UrlStringGenerator$() {
  this.Lurldsl_url_UrlStringGenerator$__f_default0 = null;
  this.Lurldsl_url_UrlStringGenerator$__f_default = null;
  $n_Lurldsl_url_UrlStringGenerator$ = this;
  $f_Lurldsl_url_DefaultUrlStringGenerator__$init$__V(this);
  this.Lurldsl_url_UrlStringGenerator$__f_default = this.Lurldsl_url_UrlStringGenerator$__f_default0;
}
export { $c_Lurldsl_url_UrlStringGenerator$ as $c_Lurldsl_url_UrlStringGenerator$ };
$c_Lurldsl_url_UrlStringGenerator$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lurldsl_url_UrlStringGenerator$.prototype.constructor = $c_Lurldsl_url_UrlStringGenerator$;
/** @constructor */
function $h_Lurldsl_url_UrlStringGenerator$() {
}
export { $h_Lurldsl_url_UrlStringGenerator$ as $h_Lurldsl_url_UrlStringGenerator$ };
$h_Lurldsl_url_UrlStringGenerator$.prototype = $c_Lurldsl_url_UrlStringGenerator$.prototype;
var $d_Lurldsl_url_UrlStringGenerator$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lurldsl_url_UrlStringGenerator$, "urldsl.url.UrlStringGenerator$", ({
  Lurldsl_url_UrlStringGenerator$: 1,
  Lurldsl_url_DefaultUrlStringGenerator: 1
}));
export { $d_Lurldsl_url_UrlStringGenerator$ as $d_Lurldsl_url_UrlStringGenerator$ };
var $n_Lurldsl_url_UrlStringGenerator$;
function $m_Lurldsl_url_UrlStringGenerator$() {
  if ((!$n_Lurldsl_url_UrlStringGenerator$)) {
    $n_Lurldsl_url_UrlStringGenerator$ = new $c_Lurldsl_url_UrlStringGenerator$();
  }
  return $n_Lurldsl_url_UrlStringGenerator$;
}
export { $m_Lurldsl_url_UrlStringGenerator$ as $m_Lurldsl_url_UrlStringGenerator$ };
/** @constructor */
function $c_Lurldsl_url_UrlStringParserGenerator$() {
  this.Lurldsl_url_UrlStringParserGenerator$__f_defaultUrlStringParserGenerator0 = null;
  this.Lurldsl_url_UrlStringParserGenerator$__f_defaultUrlStringParserGenerator = null;
  $n_Lurldsl_url_UrlStringParserGenerator$ = this;
  this.Lurldsl_url_UrlStringParserGenerator$__f_defaultUrlStringParserGenerator0 = $m_Lurldsl_url_JSUrlStringParser$().jsUrlStringParserGenerator__Lurldsl_url_UrlStringParserGenerator();
  this.Lurldsl_url_UrlStringParserGenerator$__f_defaultUrlStringParserGenerator = this.Lurldsl_url_UrlStringParserGenerator$__f_defaultUrlStringParserGenerator0;
}
export { $c_Lurldsl_url_UrlStringParserGenerator$ as $c_Lurldsl_url_UrlStringParserGenerator$ };
$c_Lurldsl_url_UrlStringParserGenerator$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lurldsl_url_UrlStringParserGenerator$.prototype.constructor = $c_Lurldsl_url_UrlStringParserGenerator$;
/** @constructor */
function $h_Lurldsl_url_UrlStringParserGenerator$() {
}
export { $h_Lurldsl_url_UrlStringParserGenerator$ as $h_Lurldsl_url_UrlStringParserGenerator$ };
$h_Lurldsl_url_UrlStringParserGenerator$.prototype = $c_Lurldsl_url_UrlStringParserGenerator$.prototype;
var $d_Lurldsl_url_UrlStringParserGenerator$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lurldsl_url_UrlStringParserGenerator$, "urldsl.url.UrlStringParserGenerator$", ({
  Lurldsl_url_UrlStringParserGenerator$: 1,
  Lurldsl_url_DefaultUrlParserGenerator: 1
}));
export { $d_Lurldsl_url_UrlStringParserGenerator$ as $d_Lurldsl_url_UrlStringParserGenerator$ };
var $n_Lurldsl_url_UrlStringParserGenerator$;
function $m_Lurldsl_url_UrlStringParserGenerator$() {
  if ((!$n_Lurldsl_url_UrlStringParserGenerator$)) {
    $n_Lurldsl_url_UrlStringParserGenerator$ = new $c_Lurldsl_url_UrlStringParserGenerator$();
  }
  return $n_Lurldsl_url_UrlStringParserGenerator$;
}
export { $m_Lurldsl_url_UrlStringParserGenerator$ as $m_Lurldsl_url_UrlStringParserGenerator$ };
/** @constructor */
function $c_Lurldsl_vocabulary_FromString$() {
}
export { $c_Lurldsl_vocabulary_FromString$ as $c_Lurldsl_vocabulary_FromString$ };
$c_Lurldsl_vocabulary_FromString$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lurldsl_vocabulary_FromString$.prototype.constructor = $c_Lurldsl_vocabulary_FromString$;
/** @constructor */
function $h_Lurldsl_vocabulary_FromString$() {
}
export { $h_Lurldsl_vocabulary_FromString$ as $h_Lurldsl_vocabulary_FromString$ };
$h_Lurldsl_vocabulary_FromString$.prototype = $c_Lurldsl_vocabulary_FromString$.prototype;
$c_Lurldsl_vocabulary_FromString$.prototype.stringFromString__Lurldsl_vocabulary_FromString = (function() {
  var read = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(_$1)));
  return new $c_Lurldsl_vocabulary_FromString$$anon$1(read, this);
});
var $d_Lurldsl_vocabulary_FromString$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lurldsl_vocabulary_FromString$, "urldsl.vocabulary.FromString$", ({
  Lurldsl_vocabulary_FromString$: 1,
  Lurldsl_vocabulary_FromStringWithNumeric: 1
}));
export { $d_Lurldsl_vocabulary_FromString$ as $d_Lurldsl_vocabulary_FromString$ };
var $n_Lurldsl_vocabulary_FromString$;
function $m_Lurldsl_vocabulary_FromString$() {
  if ((!$n_Lurldsl_vocabulary_FromString$)) {
    $n_Lurldsl_vocabulary_FromString$ = new $c_Lurldsl_vocabulary_FromString$();
  }
  return $n_Lurldsl_vocabulary_FromString$;
}
export { $m_Lurldsl_vocabulary_FromString$ as $m_Lurldsl_vocabulary_FromString$ };
/** @constructor */
function $c_Lurldsl_vocabulary_FromString$$anon$1(read$3, outer) {
  this.Lurldsl_vocabulary_FromString$$anon$1__f_read$2 = null;
  this.Lurldsl_vocabulary_FromString$$anon$1__f_read$2 = read$3;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lurldsl_vocabulary_FromString$$anon$1 as $c_Lurldsl_vocabulary_FromString$$anon$1 };
$c_Lurldsl_vocabulary_FromString$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lurldsl_vocabulary_FromString$$anon$1.prototype.constructor = $c_Lurldsl_vocabulary_FromString$$anon$1;
/** @constructor */
function $h_Lurldsl_vocabulary_FromString$$anon$1() {
}
export { $h_Lurldsl_vocabulary_FromString$$anon$1 as $h_Lurldsl_vocabulary_FromString$$anon$1 };
$h_Lurldsl_vocabulary_FromString$$anon$1.prototype = $c_Lurldsl_vocabulary_FromString$$anon$1.prototype;
$c_Lurldsl_vocabulary_FromString$$anon$1.prototype.fromString__T__s_util_Either = (function(str) {
  var read$1 = this.Lurldsl_vocabulary_FromString$$anon$1__f_read$2;
  return read$1.apply__O__O(str);
});
var $d_Lurldsl_vocabulary_FromString$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lurldsl_vocabulary_FromString$$anon$1, "urldsl.vocabulary.FromString$$anon$1", ({
  Lurldsl_vocabulary_FromString$$anon$1: 1,
  Lurldsl_vocabulary_FromString: 1
}));
export { $d_Lurldsl_vocabulary_FromString$$anon$1 as $d_Lurldsl_vocabulary_FromString$$anon$1 };
/** @constructor */
function $c_Lurldsl_vocabulary_Printer$$anon$1(printing$3, outer) {
  this.Lurldsl_vocabulary_Printer$$anon$1__f_printing$2 = null;
  this.Lurldsl_vocabulary_Printer$$anon$1__f_printing$2 = printing$3;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lurldsl_vocabulary_Printer$$anon$1 as $c_Lurldsl_vocabulary_Printer$$anon$1 };
$c_Lurldsl_vocabulary_Printer$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lurldsl_vocabulary_Printer$$anon$1.prototype.constructor = $c_Lurldsl_vocabulary_Printer$$anon$1;
/** @constructor */
function $h_Lurldsl_vocabulary_Printer$$anon$1() {
}
export { $h_Lurldsl_vocabulary_Printer$$anon$1 as $h_Lurldsl_vocabulary_Printer$$anon$1 };
$h_Lurldsl_vocabulary_Printer$$anon$1.prototype = $c_Lurldsl_vocabulary_Printer$$anon$1.prototype;
$c_Lurldsl_vocabulary_Printer$$anon$1.prototype.print__O__T = (function(t) {
  var printing$1 = this.Lurldsl_vocabulary_Printer$$anon$1__f_printing$2;
  return printing$1.apply__O__O(t);
});
var $d_Lurldsl_vocabulary_Printer$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lurldsl_vocabulary_Printer$$anon$1, "urldsl.vocabulary.Printer$$anon$1", ({
  Lurldsl_vocabulary_Printer$$anon$1: 1,
  Lurldsl_vocabulary_Printer: 1
}));
export { $d_Lurldsl_vocabulary_Printer$$anon$1 as $d_Lurldsl_vocabulary_Printer$$anon$1 };
/** @constructor */
function $c_Lyantl_ValidatorRule$$anon$10(getLength$6, maxLength$3) {
  this.Lyantl_ValidatorRule$$anon$10__f_getLength$4 = null;
  this.Lyantl_ValidatorRule$$anon$10__f_maxLength$2 = 0;
  this.Lyantl_ValidatorRule$$anon$10__f_getLength$4 = getLength$6;
  this.Lyantl_ValidatorRule$$anon$10__f_maxLength$2 = maxLength$3;
}
export { $c_Lyantl_ValidatorRule$$anon$10 as $c_Lyantl_ValidatorRule$$anon$10 };
$c_Lyantl_ValidatorRule$$anon$10.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lyantl_ValidatorRule$$anon$10.prototype.constructor = $c_Lyantl_ValidatorRule$$anon$10;
/** @constructor */
function $h_Lyantl_ValidatorRule$$anon$10() {
}
export { $h_Lyantl_ValidatorRule$$anon$10 as $h_Lyantl_ValidatorRule$$anon$10 };
$h_Lyantl_ValidatorRule$$anon$10.prototype = $c_Lyantl_ValidatorRule$$anon$10.prototype;
$c_Lyantl_ValidatorRule$$anon$10.prototype.validate__O__s_Option = (function(a) {
  var getLength$2 = this.Lyantl_ValidatorRule$$anon$10__f_getLength$4;
  var maxLength$1 = this.Lyantl_ValidatorRule$$anon$10__f_maxLength$2;
  var length = (getLength$2.apply__O__O(a) | 0);
  if ((length > maxLength$1)) {
    var value = new $c_Lyantl_ValidatorRule$MaxLengthExceeded(maxLength$1, length, a);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
  } else {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
});
var $d_Lyantl_ValidatorRule$$anon$10 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lyantl_ValidatorRule$$anon$10, "yantl.ValidatorRule$$anon$10", ({
  Lyantl_ValidatorRule$$anon$10: 1,
  Lyantl_ValidatorRule: 1
}));
export { $d_Lyantl_ValidatorRule$$anon$10 as $d_Lyantl_ValidatorRule$$anon$10 };
/** @constructor */
function $c_Lyantl_ValidatorRule$$anon$12() {
}
export { $c_Lyantl_ValidatorRule$$anon$12 as $c_Lyantl_ValidatorRule$$anon$12 };
$c_Lyantl_ValidatorRule$$anon$12.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lyantl_ValidatorRule$$anon$12.prototype.constructor = $c_Lyantl_ValidatorRule$$anon$12;
/** @constructor */
function $h_Lyantl_ValidatorRule$$anon$12() {
}
export { $h_Lyantl_ValidatorRule$$anon$12 as $h_Lyantl_ValidatorRule$$anon$12 };
$h_Lyantl_ValidatorRule$$anon$12.prototype = $c_Lyantl_ValidatorRule$$anon$12.prototype;
$c_Lyantl_ValidatorRule$$anon$12.prototype.validate__O__s_Option = (function(input) {
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__trim__T(input);
  if ((this$1 === "")) {
    var value = new $c_Lyantl_ValidatorRule$WasBlank(input);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
  } else {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
});
var $d_Lyantl_ValidatorRule$$anon$12 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lyantl_ValidatorRule$$anon$12, "yantl.ValidatorRule$$anon$12", ({
  Lyantl_ValidatorRule$$anon$12: 1,
  Lyantl_ValidatorRule: 1
}));
export { $d_Lyantl_ValidatorRule$$anon$12 as $d_Lyantl_ValidatorRule$$anon$12 };
/** @constructor */
function $c_Lyantl_ValidatorRule$$anon$13() {
}
export { $c_Lyantl_ValidatorRule$$anon$13 as $c_Lyantl_ValidatorRule$$anon$13 };
$c_Lyantl_ValidatorRule$$anon$13.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lyantl_ValidatorRule$$anon$13.prototype.constructor = $c_Lyantl_ValidatorRule$$anon$13;
/** @constructor */
function $h_Lyantl_ValidatorRule$$anon$13() {
}
export { $h_Lyantl_ValidatorRule$$anon$13 as $h_Lyantl_ValidatorRule$$anon$13 };
$h_Lyantl_ValidatorRule$$anon$13.prototype = $c_Lyantl_ValidatorRule$$anon$13.prototype;
$c_Lyantl_ValidatorRule$$anon$13.prototype.validate__O__s_Option = (function(input) {
  if ((input !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__trim__T(input))) {
    var value = new $c_Lyantl_ValidatorRule$HadSurroundingWhitespace(input);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
  } else {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
});
var $d_Lyantl_ValidatorRule$$anon$13 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lyantl_ValidatorRule$$anon$13, "yantl.ValidatorRule$$anon$13", ({
  Lyantl_ValidatorRule$$anon$13: 1,
  Lyantl_ValidatorRule: 1
}));
export { $d_Lyantl_ValidatorRule$$anon$13 as $d_Lyantl_ValidatorRule$$anon$13 };
/** @constructor */
function $c_Lyantl_ValidatorRule$$anon$2(f$10, outer) {
  this.Lyantl_ValidatorRule$$anon$2__f_f$6 = null;
  this.Lyantl_ValidatorRule$$anon$2__f_$outer = null;
  this.Lyantl_ValidatorRule$$anon$2__f_f$6 = f$10;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lyantl_ValidatorRule$$anon$2__f_$outer = outer;
}
export { $c_Lyantl_ValidatorRule$$anon$2 as $c_Lyantl_ValidatorRule$$anon$2 };
$c_Lyantl_ValidatorRule$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lyantl_ValidatorRule$$anon$2.prototype.constructor = $c_Lyantl_ValidatorRule$$anon$2;
/** @constructor */
function $h_Lyantl_ValidatorRule$$anon$2() {
}
export { $h_Lyantl_ValidatorRule$$anon$2 as $h_Lyantl_ValidatorRule$$anon$2 };
$h_Lyantl_ValidatorRule$$anon$2.prototype = $c_Lyantl_ValidatorRule$$anon$2.prototype;
$c_Lyantl_ValidatorRule$$anon$2.prototype.validate__O__s_Option = (function(input) {
  var this$1 = this.Lyantl_ValidatorRule$$anon$2__f_$outer;
  var f$2 = this.Lyantl_ValidatorRule$$anon$2__f_f$6;
  return this$1.validate__O__s_Option(f$2.apply__O__O(input));
});
var $d_Lyantl_ValidatorRule$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lyantl_ValidatorRule$$anon$2, "yantl.ValidatorRule$$anon$2", ({
  Lyantl_ValidatorRule$$anon$2: 1,
  Lyantl_ValidatorRule: 1
}));
export { $d_Lyantl_ValidatorRule$$anon$2 as $d_Lyantl_ValidatorRule$$anon$2 };
/** @constructor */
function $c_Lyantl_ValidatorRule$$anon$5(f$12) {
  this.Lyantl_ValidatorRule$$anon$5__f_f$8 = null;
  this.Lyantl_ValidatorRule$$anon$5__f_f$8 = f$12;
}
export { $c_Lyantl_ValidatorRule$$anon$5 as $c_Lyantl_ValidatorRule$$anon$5 };
$c_Lyantl_ValidatorRule$$anon$5.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lyantl_ValidatorRule$$anon$5.prototype.constructor = $c_Lyantl_ValidatorRule$$anon$5;
/** @constructor */
function $h_Lyantl_ValidatorRule$$anon$5() {
}
export { $h_Lyantl_ValidatorRule$$anon$5 as $h_Lyantl_ValidatorRule$$anon$5 };
$h_Lyantl_ValidatorRule$$anon$5.prototype = $c_Lyantl_ValidatorRule$$anon$5.prototype;
$c_Lyantl_ValidatorRule$$anon$5.prototype.validate__O__s_Option = (function(input) {
  var f$4 = this.Lyantl_ValidatorRule$$anon$5__f_f$8;
  return f$4.apply__O__O(input);
});
var $d_Lyantl_ValidatorRule$$anon$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lyantl_ValidatorRule$$anon$5, "yantl.ValidatorRule$$anon$5", ({
  Lyantl_ValidatorRule$$anon$5: 1,
  Lyantl_ValidatorRule: 1
}));
export { $d_Lyantl_ValidatorRule$$anon$5 as $d_Lyantl_ValidatorRule$$anon$5 };
/** @constructor */
function $c_Lyantl_ValidatorRule$$anon$9(getLength$5, minLength$3) {
  this.Lyantl_ValidatorRule$$anon$9__f_getLength$3 = null;
  this.Lyantl_ValidatorRule$$anon$9__f_minLength$2 = 0;
  this.Lyantl_ValidatorRule$$anon$9__f_getLength$3 = getLength$5;
  this.Lyantl_ValidatorRule$$anon$9__f_minLength$2 = minLength$3;
}
export { $c_Lyantl_ValidatorRule$$anon$9 as $c_Lyantl_ValidatorRule$$anon$9 };
$c_Lyantl_ValidatorRule$$anon$9.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lyantl_ValidatorRule$$anon$9.prototype.constructor = $c_Lyantl_ValidatorRule$$anon$9;
/** @constructor */
function $h_Lyantl_ValidatorRule$$anon$9() {
}
export { $h_Lyantl_ValidatorRule$$anon$9 as $h_Lyantl_ValidatorRule$$anon$9 };
$h_Lyantl_ValidatorRule$$anon$9.prototype = $c_Lyantl_ValidatorRule$$anon$9.prototype;
$c_Lyantl_ValidatorRule$$anon$9.prototype.validate__O__s_Option = (function(a) {
  var getLength$1 = this.Lyantl_ValidatorRule$$anon$9__f_getLength$3;
  var minLength$1 = this.Lyantl_ValidatorRule$$anon$9__f_minLength$2;
  var length = (getLength$1.apply__O__O(a) | 0);
  if ((length < minLength$1)) {
    var value = new $c_Lyantl_ValidatorRule$UnderMinLength(minLength$1, length, a);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
  } else {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
});
var $d_Lyantl_ValidatorRule$$anon$9 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lyantl_ValidatorRule$$anon$9, "yantl.ValidatorRule$$anon$9", ({
  Lyantl_ValidatorRule$$anon$9: 1,
  Lyantl_ValidatorRule: 1
}));
export { $d_Lyantl_ValidatorRule$$anon$9 as $d_Lyantl_ValidatorRule$$anon$9 };
/** @constructor */
function $c_Lcats_Parallel$() {
}
export { $c_Lcats_Parallel$ as $c_Lcats_Parallel$ };
$c_Lcats_Parallel$.prototype = new $h_Lcats_ParallelArityFunctions2();
$c_Lcats_Parallel$.prototype.constructor = $c_Lcats_Parallel$;
/** @constructor */
function $h_Lcats_Parallel$() {
}
export { $h_Lcats_Parallel$ as $h_Lcats_Parallel$ };
$h_Lcats_Parallel$.prototype = $c_Lcats_Parallel$.prototype;
$c_Lcats_Parallel$.prototype.parProduct__O__O__Lcats_NonEmptyParallel__O = (function(ma, mb, P) {
  return P.sequential__Lcats_arrow_FunctionK().apply__O__O(P.applicative__Lcats_Applicative().product__O__O__O(P.parallel__Lcats_arrow_FunctionK().apply__O__O(ma), P.parallel__Lcats_arrow_FunctionK().apply__O__O(mb)));
});
var $d_Lcats_Parallel$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_Parallel$, "cats.Parallel$", ({
  Lcats_Parallel$: 1,
  Lcats_ParallelArityFunctions2: 1,
  Lcats_ParallelArityFunctions: 1
}));
export { $d_Lcats_Parallel$ as $d_Lcats_Parallel$ };
var $n_Lcats_Parallel$;
function $m_Lcats_Parallel$() {
  if ((!$n_Lcats_Parallel$)) {
    $n_Lcats_Parallel$ = new $c_Lcats_Parallel$();
  }
  return $n_Lcats_Parallel$;
}
export { $m_Lcats_Parallel$ as $m_Lcats_Parallel$ };
/** @constructor */
function $c_Lcats_Semigroupal$() {
  $n_Lcats_Semigroupal$ = this;
  $m_Lcats_instances_package$order$();
  $m_Lcats_instances_package$partialOrder$();
  $m_Lcats_instances_package$ordering$();
  $m_Lcats_instances_package$partialOrdering$();
  $m_Lcats_instances_package$eq$();
  $m_Lcats_instances_package$equiv$();
  $m_Lcats_instances_package$invariant$();
  $m_Lcats_instances_package$invariant$();
  $m_Lcats_instances_package$invariant$();
}
export { $c_Lcats_Semigroupal$ as $c_Lcats_Semigroupal$ };
$c_Lcats_Semigroupal$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_Semigroupal$.prototype.constructor = $c_Lcats_Semigroupal$;
/** @constructor */
function $h_Lcats_Semigroupal$() {
}
export { $h_Lcats_Semigroupal$ as $h_Lcats_Semigroupal$ };
$h_Lcats_Semigroupal$.prototype = $c_Lcats_Semigroupal$.prototype;
var $d_Lcats_Semigroupal$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_Semigroupal$, "cats.Semigroupal$", ({
  Lcats_Semigroupal$: 1,
  Lcats_ScalaVersionSpecificSemigroupalInstances: 1,
  Lcats_SemigroupalArityFunctions: 1
}));
export { $d_Lcats_Semigroupal$ as $d_Lcats_Semigroupal$ };
var $n_Lcats_Semigroupal$;
function $m_Lcats_Semigroupal$() {
  if ((!$n_Lcats_Semigroupal$)) {
    $n_Lcats_Semigroupal$ = new $c_Lcats_Semigroupal$();
  }
  return $n_Lcats_Semigroupal$;
}
export { $m_Lcats_Semigroupal$ as $m_Lcats_Semigroupal$ };
/** @constructor */
function $c_Lcats_Traverse$ToTraverseOps$$anon$3(target$2, tc$2) {
  this.Lcats_Traverse$ToTraverseOps$$anon$3__f_self = null;
  this.Lcats_Traverse$ToTraverseOps$$anon$3__f_typeClassInstance = null;
  this.Lcats_Traverse$ToTraverseOps$$anon$3__f_self = target$2;
  this.Lcats_Traverse$ToTraverseOps$$anon$3__f_typeClassInstance = tc$2;
}
export { $c_Lcats_Traverse$ToTraverseOps$$anon$3 as $c_Lcats_Traverse$ToTraverseOps$$anon$3 };
$c_Lcats_Traverse$ToTraverseOps$$anon$3.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_Traverse$ToTraverseOps$$anon$3.prototype.constructor = $c_Lcats_Traverse$ToTraverseOps$$anon$3;
/** @constructor */
function $h_Lcats_Traverse$ToTraverseOps$$anon$3() {
}
export { $h_Lcats_Traverse$ToTraverseOps$$anon$3 as $h_Lcats_Traverse$ToTraverseOps$$anon$3 };
$h_Lcats_Traverse$ToTraverseOps$$anon$3.prototype = $c_Lcats_Traverse$ToTraverseOps$$anon$3.prototype;
var $d_Lcats_Traverse$ToTraverseOps$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_Traverse$ToTraverseOps$$anon$3, "cats.Traverse$ToTraverseOps$$anon$3", ({
  Lcats_Traverse$ToTraverseOps$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lcats_Traverse$Ops: 1
}));
export { $d_Lcats_Traverse$ToTraverseOps$$anon$3 as $d_Lcats_Traverse$ToTraverseOps$$anon$3 };
/** @constructor */
function $c_Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4(target$2, tc$2) {
  this.Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4__f_self = null;
  this.Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4__f_typeClassInstance = null;
  this.Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4__f_self = target$2;
  this.Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4__f_typeClassInstance = tc$2;
}
export { $c_Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4 as $c_Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4 };
$c_Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4.prototype.constructor = $c_Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4;
/** @constructor */
function $h_Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4() {
}
export { $h_Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4 as $h_Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4 };
$h_Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4.prototype = $c_Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4.prototype;
var $d_Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4, "cats.UnorderedFoldable$ToUnorderedFoldableOps$$anon$4", ({
  Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4: 1,
  Ljava_io_Serializable: 1,
  Lcats_UnorderedFoldable$Ops: 1
}));
export { $d_Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4 as $d_Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4 };
/** @constructor */
function $c_Lcats_arrow_FunctionK$$anon$1(f$2, outer) {
  this.Lcats_arrow_FunctionK$$anon$1__f_f$1 = null;
  this.Lcats_arrow_FunctionK$$anon$1__f_$outer = null;
  this.Lcats_arrow_FunctionK$$anon$1__f_f$1 = f$2;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lcats_arrow_FunctionK$$anon$1__f_$outer = outer;
}
export { $c_Lcats_arrow_FunctionK$$anon$1 as $c_Lcats_arrow_FunctionK$$anon$1 };
$c_Lcats_arrow_FunctionK$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_arrow_FunctionK$$anon$1.prototype.constructor = $c_Lcats_arrow_FunctionK$$anon$1;
/** @constructor */
function $h_Lcats_arrow_FunctionK$$anon$1() {
}
export { $h_Lcats_arrow_FunctionK$$anon$1 as $h_Lcats_arrow_FunctionK$$anon$1 };
$h_Lcats_arrow_FunctionK$$anon$1.prototype = $c_Lcats_arrow_FunctionK$$anon$1.prototype;
$c_Lcats_arrow_FunctionK$$anon$1.prototype.apply__O__O = (function(fa) {
  return this.Lcats_arrow_FunctionK$$anon$1__f_$outer.apply__O__O(this.Lcats_arrow_FunctionK$$anon$1__f_f$1.apply__O__O(fa));
});
var $d_Lcats_arrow_FunctionK$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_arrow_FunctionK$$anon$1, "cats.arrow.FunctionK$$anon$1", ({
  Lcats_arrow_FunctionK$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
}));
export { $d_Lcats_arrow_FunctionK$$anon$1 as $d_Lcats_arrow_FunctionK$$anon$1 };
/** @constructor */
function $c_Lcats_data_EitherTInstances1() {
}
export { $c_Lcats_data_EitherTInstances1 as $c_Lcats_data_EitherTInstances1 };
$c_Lcats_data_EitherTInstances1.prototype = new $h_Lcats_data_EitherTInstances2();
$c_Lcats_data_EitherTInstances1.prototype.constructor = $c_Lcats_data_EitherTInstances1;
/** @constructor */
function $h_Lcats_data_EitherTInstances1() {
}
export { $h_Lcats_data_EitherTInstances1 as $h_Lcats_data_EitherTInstances1 };
$h_Lcats_data_EitherTInstances1.prototype = $c_Lcats_data_EitherTInstances1.prototype;
/** @constructor */
function $c_Lcats_data_IndexedStateTInstances2() {
}
export { $c_Lcats_data_IndexedStateTInstances2 as $c_Lcats_data_IndexedStateTInstances2 };
$c_Lcats_data_IndexedStateTInstances2.prototype = new $h_Lcats_data_IndexedStateTInstances3();
$c_Lcats_data_IndexedStateTInstances2.prototype.constructor = $c_Lcats_data_IndexedStateTInstances2;
/** @constructor */
function $h_Lcats_data_IndexedStateTInstances2() {
}
export { $h_Lcats_data_IndexedStateTInstances2 as $h_Lcats_data_IndexedStateTInstances2 };
$h_Lcats_data_IndexedStateTInstances2.prototype = $c_Lcats_data_IndexedStateTInstances2.prototype;
/** @constructor */
function $c_Lcats_data_KleisliInstances7() {
}
export { $c_Lcats_data_KleisliInstances7 as $c_Lcats_data_KleisliInstances7 };
$c_Lcats_data_KleisliInstances7.prototype = new $h_Lcats_data_KleisliInstances8();
$c_Lcats_data_KleisliInstances7.prototype.constructor = $c_Lcats_data_KleisliInstances7;
/** @constructor */
function $h_Lcats_data_KleisliInstances7() {
}
export { $h_Lcats_data_KleisliInstances7 as $h_Lcats_data_KleisliInstances7 };
$h_Lcats_data_KleisliInstances7.prototype = $c_Lcats_data_KleisliInstances7.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptyChainInstances1() {
}
export { $c_Lcats_data_NonEmptyChainInstances1 as $c_Lcats_data_NonEmptyChainInstances1 };
$c_Lcats_data_NonEmptyChainInstances1.prototype = new $h_Lcats_data_NonEmptyChainInstances2();
$c_Lcats_data_NonEmptyChainInstances1.prototype.constructor = $c_Lcats_data_NonEmptyChainInstances1;
/** @constructor */
function $h_Lcats_data_NonEmptyChainInstances1() {
}
export { $h_Lcats_data_NonEmptyChainInstances1 as $h_Lcats_data_NonEmptyChainInstances1 };
$h_Lcats_data_NonEmptyChainInstances1.prototype = $c_Lcats_data_NonEmptyChainInstances1.prototype;
function $ct_Lcats_data_NonEmptySetInstances__($thiz) {
  return $thiz;
}
export { $ct_Lcats_data_NonEmptySetInstances__ as $ct_Lcats_data_NonEmptySetInstances__ };
/** @constructor */
function $c_Lcats_data_NonEmptySetInstances() {
}
export { $c_Lcats_data_NonEmptySetInstances as $c_Lcats_data_NonEmptySetInstances };
$c_Lcats_data_NonEmptySetInstances.prototype = new $h_Lcats_data_NonEmptySetInstances0();
$c_Lcats_data_NonEmptySetInstances.prototype.constructor = $c_Lcats_data_NonEmptySetInstances;
/** @constructor */
function $h_Lcats_data_NonEmptySetInstances() {
}
export { $h_Lcats_data_NonEmptySetInstances as $h_Lcats_data_NonEmptySetInstances };
$h_Lcats_data_NonEmptySetInstances.prototype = $c_Lcats_data_NonEmptySetInstances.prototype;
/** @constructor */
function $c_Lcats_data_OptionTInstances1() {
}
export { $c_Lcats_data_OptionTInstances1 as $c_Lcats_data_OptionTInstances1 };
$c_Lcats_data_OptionTInstances1.prototype = new $h_Lcats_data_OptionTInstances2();
$c_Lcats_data_OptionTInstances1.prototype.constructor = $c_Lcats_data_OptionTInstances1;
/** @constructor */
function $h_Lcats_data_OptionTInstances1() {
}
export { $h_Lcats_data_OptionTInstances1 as $h_Lcats_data_OptionTInstances1 };
$h_Lcats_data_OptionTInstances1.prototype = $c_Lcats_data_OptionTInstances1.prototype;
/** @constructor */
function $c_Lcats_effect_ContState(wasFinalizing) {
  this.ju_concurrent_atomic_AtomicReference__f_value = null;
  this.Lcats_effect_ContState__f_wasFinalizing = false;
  this.Lcats_effect_ContState__f_waiting = null;
  this.Lcats_effect_ContState__f_handle = null;
  this.Lcats_effect_ContState__f_wasFinalizing = wasFinalizing;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_ju_concurrent_atomic_AtomicReference__O__(this, null);
  this.Lcats_effect_ContState__f_waiting = $m_Lcats_effect_ContState$().Lcats_effect_ContState$__f_cats$effect$ContState$$$waitingSentinel;
}
export { $c_Lcats_effect_ContState as $c_Lcats_effect_ContState };
$c_Lcats_effect_ContState.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_ju_concurrent_atomic_AtomicReference();
$c_Lcats_effect_ContState.prototype.constructor = $c_Lcats_effect_ContState;
/** @constructor */
function $h_Lcats_effect_ContState() {
}
export { $h_Lcats_effect_ContState as $h_Lcats_effect_ContState };
$h_Lcats_effect_ContState.prototype = $c_Lcats_effect_ContState.prototype;
var $d_Lcats_effect_ContState = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_ContState, "cats.effect.ContState", ({
  Lcats_effect_ContState: 1,
  ju_concurrent_atomic_AtomicReference: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_effect_ContState as $d_Lcats_effect_ContState };
/** @constructor */
function $c_Lcats_effect_IO$$anon$4(k$4) {
  this.Lcats_effect_IO$$anon$4__f_k$1 = null;
  this.Lcats_effect_IO$$anon$4__f_k$1 = k$4;
}
export { $c_Lcats_effect_IO$$anon$4 as $c_Lcats_effect_IO$$anon$4 };
$c_Lcats_effect_IO$$anon$4.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_IO$$anon$4.prototype.constructor = $c_Lcats_effect_IO$$anon$4;
/** @constructor */
function $h_Lcats_effect_IO$$anon$4() {
}
export { $h_Lcats_effect_IO$$anon$4 as $h_Lcats_effect_IO$$anon$4 };
$h_Lcats_effect_IO$$anon$4.prototype = $c_Lcats_effect_IO$$anon$4.prototype;
$c_Lcats_effect_IO$$anon$4.prototype.apply__Lcats_effect_kernel_MonadCancel__F3 = (function(G) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction3_$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491(((resume, get, lift) => G.uncancelable__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((lift$2, resume$2) => ((poll) => {
    var target = lift$2.apply__O__O(this.Lcats_effect_IO$$anon$4__f_k$1.apply__O__O(resume$2));
    var this$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, G);
    var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((poll$2) => ((x$1) => {
      if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
        var a = x$1.s_util_Right__f_value;
        return G.pure__O__O(a);
      }
      if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
        var x38 = x$1.s_util_Left__f_value;
        if ((x38 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
          var fin = x38.s_Some__f_value;
          return G.onCancel__O__O__O(poll$2.apply__O__O(get), lift$2.apply__O__O(fin));
        }
        var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        if ((x === x38)) {
          return get;
        }
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    }))(poll));
    return this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  }))(lift, resume)))));
});
var $d_Lcats_effect_IO$$anon$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IO$$anon$4, "cats.effect.IO$$anon$4", ({
  Lcats_effect_IO$$anon$4: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Cont: 1
}));
export { $d_Lcats_effect_IO$$anon$4 as $d_Lcats_effect_IO$$anon$4 };
/** @constructor */
function $c_Lcats_effect_IO$$anon$5(k$5) {
  this.Lcats_effect_IO$$anon$5__f_k$2 = null;
  this.Lcats_effect_IO$$anon$5__f_k$2 = k$5;
}
export { $c_Lcats_effect_IO$$anon$5 as $c_Lcats_effect_IO$$anon$5 };
$c_Lcats_effect_IO$$anon$5.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_IO$$anon$5.prototype.constructor = $c_Lcats_effect_IO$$anon$5;
/** @constructor */
function $h_Lcats_effect_IO$$anon$5() {
}
export { $h_Lcats_effect_IO$$anon$5 as $h_Lcats_effect_IO$$anon$5 };
$h_Lcats_effect_IO$$anon$5.prototype = $c_Lcats_effect_IO$$anon$5.prototype;
$c_Lcats_effect_IO$$anon$5.prototype.apply__Lcats_effect_kernel_MonadCancel__F3 = (function(G) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction3_$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491(((resume, get, lift) => G.uncancelable__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((lift$2, resume$2) => ((poll) => {
    var target = lift$2.apply__O__O(this.Lcats_effect_IO$$anon$5__f_k$2.apply__O__O(resume$2));
    var this$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, G);
    var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((poll$2) => ((x$1) => {
      if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
        var fin = x$1.s_Some__f_value;
        return G.onCancel__O__O__O(poll$2.apply__O__O(get), lift$2.apply__O__O(fin));
      }
      var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      if ((x === x$1)) {
        return get;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    }))(poll));
    return this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  }))(lift, resume)))));
});
var $d_Lcats_effect_IO$$anon$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IO$$anon$5, "cats.effect.IO$$anon$5", ({
  Lcats_effect_IO$$anon$5: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Cont: 1
}));
export { $d_Lcats_effect_IO$$anon$5 as $d_Lcats_effect_IO$$anon$5 };
/** @constructor */
function $c_Lcats_effect_IO$$anon$6(k$6) {
  this.Lcats_effect_IO$$anon$6__f_k$3 = null;
  this.Lcats_effect_IO$$anon$6__f_k$3 = k$6;
}
export { $c_Lcats_effect_IO$$anon$6 as $c_Lcats_effect_IO$$anon$6 };
$c_Lcats_effect_IO$$anon$6.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_IO$$anon$6.prototype.constructor = $c_Lcats_effect_IO$$anon$6;
/** @constructor */
function $h_Lcats_effect_IO$$anon$6() {
}
export { $h_Lcats_effect_IO$$anon$6 as $h_Lcats_effect_IO$$anon$6 };
$h_Lcats_effect_IO$$anon$6.prototype = $c_Lcats_effect_IO$$anon$6.prototype;
$c_Lcats_effect_IO$$anon$6.prototype.apply__Lcats_effect_kernel_MonadCancel__F3 = (function(G) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction3_$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491(((resume, get, lift) => G.uncancelable__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((lift$2, resume$2) => ((_$40) => {
    var target = lift$2.apply__O__O($m_Lcats_effect_IO$().delay__F0__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
      this.Lcats_effect_IO$$anon$6__f_k$3.apply__O__O(resume$2);
    }))));
    var this$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, G);
    var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$41) => get));
    return this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  }))(lift, resume)))));
});
var $d_Lcats_effect_IO$$anon$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IO$$anon$6, "cats.effect.IO$$anon$6", ({
  Lcats_effect_IO$$anon$6: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Cont: 1
}));
export { $d_Lcats_effect_IO$$anon$6 as $d_Lcats_effect_IO$$anon$6 };
/** @constructor */
function $c_Lcats_effect_IOFiberPlatform() {
  this.ju_concurrent_atomic_AtomicBoolean__f_value = false;
}
export { $c_Lcats_effect_IOFiberPlatform as $c_Lcats_effect_IOFiberPlatform };
$c_Lcats_effect_IOFiberPlatform.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_ju_concurrent_atomic_AtomicBoolean();
$c_Lcats_effect_IOFiberPlatform.prototype.constructor = $c_Lcats_effect_IOFiberPlatform;
/** @constructor */
function $h_Lcats_effect_IOFiberPlatform() {
}
export { $h_Lcats_effect_IOFiberPlatform as $h_Lcats_effect_IOFiberPlatform };
$h_Lcats_effect_IOFiberPlatform.prototype = $c_Lcats_effect_IOFiberPlatform.prototype;
$c_Lcats_effect_IOFiberPlatform.prototype.interruptibleImpl__Lcats_effect_IO$Blocking__Lcats_effect_IO = (function(cur) {
  var this$1 = $m_Lcats_effect_IO$();
  var thunk = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => cur.thunk__F0().apply__O()));
  return this$1.delay__F0__Lcats_effect_IO(thunk);
});
/** @constructor */
function $c_Lcats_effect_kernel_Resource$ExitCase$() {
}
export { $c_Lcats_effect_kernel_Resource$ExitCase$ as $c_Lcats_effect_kernel_Resource$ExitCase$ };
$c_Lcats_effect_kernel_Resource$ExitCase$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_kernel_Resource$ExitCase$.prototype.constructor = $c_Lcats_effect_kernel_Resource$ExitCase$;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$ExitCase$() {
}
export { $h_Lcats_effect_kernel_Resource$ExitCase$ as $h_Lcats_effect_kernel_Resource$ExitCase$ };
$h_Lcats_effect_kernel_Resource$ExitCase$.prototype = $c_Lcats_effect_kernel_Resource$ExitCase$.prototype;
$c_Lcats_effect_kernel_Resource$ExitCase$.prototype.fromOutcome__Lcats_effect_kernel_Outcome__Lcats_effect_kernel_Resource$ExitCase = (function(outcome) {
  if ((outcome instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Succeeded)) {
    return $m_Lcats_effect_kernel_Resource$ExitCase$Succeeded$();
  }
  if ((outcome instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Errored)) {
    var x260 = outcome.Lcats_effect_kernel_Outcome$Errored__f_e;
    return new $c_Lcats_effect_kernel_Resource$ExitCase$Errored(x260);
  }
  if ((outcome instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Canceled)) {
    return $m_Lcats_effect_kernel_Resource$ExitCase$Canceled$();
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(outcome);
});
$c_Lcats_effect_kernel_Resource$ExitCase$.prototype.ordinal__Lcats_effect_kernel_Resource$ExitCase__I = (function(x$0) {
  if ((x$0 === $m_Lcats_effect_kernel_Resource$ExitCase$Succeeded$())) {
    return 0;
  }
  if ((x$0 instanceof $c_Lcats_effect_kernel_Resource$ExitCase$Errored)) {
    return 1;
  }
  if ((x$0 === $m_Lcats_effect_kernel_Resource$ExitCase$Canceled$())) {
    return 2;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$0);
});
$c_Lcats_effect_kernel_Resource$ExitCase$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Lcats_effect_kernel_Resource$ExitCase__I(x);
});
var $d_Lcats_effect_kernel_Resource$ExitCase$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_kernel_Resource$ExitCase$, "cats.effect.kernel.Resource$ExitCase$", ({
  Lcats_effect_kernel_Resource$ExitCase$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lcats_effect_kernel_Resource$ExitCase$ as $d_Lcats_effect_kernel_Resource$ExitCase$ };
var $n_Lcats_effect_kernel_Resource$ExitCase$;
function $m_Lcats_effect_kernel_Resource$ExitCase$() {
  if ((!$n_Lcats_effect_kernel_Resource$ExitCase$)) {
    $n_Lcats_effect_kernel_Resource$ExitCase$ = new $c_Lcats_effect_kernel_Resource$ExitCase$();
  }
  return $n_Lcats_effect_kernel_Resource$ExitCase$;
}
export { $m_Lcats_effect_kernel_Resource$ExitCase$ as $m_Lcats_effect_kernel_Resource$ExitCase$ };
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Frame$3$(outer) {
  this.Lcats_effect_kernel_Resource$Frame$3$__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lcats_effect_kernel_Resource$Frame$3$__f_$outer = outer;
}
export { $c_Lcats_effect_kernel_Resource$Frame$3$ as $c_Lcats_effect_kernel_Resource$Frame$3$ };
$c_Lcats_effect_kernel_Resource$Frame$3$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_kernel_Resource$Frame$3$.prototype.constructor = $c_Lcats_effect_kernel_Resource$Frame$3$;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Frame$3$() {
}
export { $h_Lcats_effect_kernel_Resource$Frame$3$ as $h_Lcats_effect_kernel_Resource$Frame$3$ };
$h_Lcats_effect_kernel_Resource$Frame$3$.prototype = $c_Lcats_effect_kernel_Resource$Frame$3$.prototype;
$c_Lcats_effect_kernel_Resource$Frame$3$.prototype.apply__F1__Lcats_effect_kernel_Resource$Stack$1__Lcats_effect_kernel_Resource$Frame$1 = (function(head, tail) {
  return new $c_Lcats_effect_kernel_Resource$Frame$1(this.Lcats_effect_kernel_Resource$Frame$3$__f_$outer, head, tail);
});
$c_Lcats_effect_kernel_Resource$Frame$3$.prototype.toString__T = (function() {
  return "Frame";
});
$c_Lcats_effect_kernel_Resource$Frame$3$.prototype.fromProduct__s_Product__Lcats_effect_kernel_Resource$Frame$1 = (function(x$0) {
  return new $c_Lcats_effect_kernel_Resource$Frame$1(this.Lcats_effect_kernel_Resource$Frame$3$__f_$outer, x$0.productElement__I__O(0), x$0.productElement__I__O(1));
});
$c_Lcats_effect_kernel_Resource$Frame$3$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lcats_effect_kernel_Resource$Frame$1(p);
});
var $d_Lcats_effect_kernel_Resource$Frame$3$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_kernel_Resource$Frame$3$, "cats.effect.kernel.Resource$Frame$3$", ({
  Lcats_effect_kernel_Resource$Frame$3$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lcats_effect_kernel_Resource$Frame$3$ as $d_Lcats_effect_kernel_Resource$Frame$3$ };
/** @constructor */
function $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2() {
}
export { $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2 as $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2 };
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2.prototype.constructor = $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2;
/** @constructor */
function $h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2() {
}
export { $h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2 as $h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2 };
$h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2.prototype = $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2.prototype;
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2.prototype.apply__O__O = (function(fa) {
  return fa;
});
var $d_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2, "cats.effect.kernel.instances.GenSpawnInstances$$anon$2", ({
  Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
}));
export { $d_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2 as $d_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2 };
/** @constructor */
function $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3() {
}
export { $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3 as $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3 };
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3.prototype.constructor = $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3;
/** @constructor */
function $h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3() {
}
export { $h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3 as $h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3 };
$h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3.prototype = $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3.prototype;
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3.prototype.apply__O__O = (function(ma) {
  return ma;
});
var $d_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3, "cats.effect.kernel.instances.GenSpawnInstances$$anon$3", ({
  Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
}));
export { $d_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3 as $d_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3 };
/** @constructor */
function $c_Lcats_effect_std_Console$NodeJSConsole(stdout, stderr, F) {
}
export { $c_Lcats_effect_std_Console$NodeJSConsole as $c_Lcats_effect_std_Console$NodeJSConsole };
$c_Lcats_effect_std_Console$NodeJSConsole.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_std_Console$NodeJSConsole.prototype.constructor = $c_Lcats_effect_std_Console$NodeJSConsole;
/** @constructor */
function $h_Lcats_effect_std_Console$NodeJSConsole() {
}
export { $h_Lcats_effect_std_Console$NodeJSConsole as $h_Lcats_effect_std_Console$NodeJSConsole };
$h_Lcats_effect_std_Console$NodeJSConsole.prototype = $c_Lcats_effect_std_Console$NodeJSConsole.prototype;
var $d_Lcats_effect_std_Console$NodeJSConsole = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_std_Console$NodeJSConsole, "cats.effect.std.Console$NodeJSConsole", ({
  Lcats_effect_std_Console$NodeJSConsole: 1,
  Lcats_effect_std_ConsoleCrossPlatform: 1,
  Lcats_effect_std_Console: 1
}));
export { $d_Lcats_effect_std_Console$NodeJSConsole as $d_Lcats_effect_std_Console$NodeJSConsole };
/** @constructor */
function $c_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole(outer, F) {
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole as $c_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole };
$c_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole.prototype.constructor = $c_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole;
/** @constructor */
function $h_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole() {
}
export { $h_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole as $h_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole };
$h_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole.prototype = $c_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole.prototype;
var $d_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole, "cats.effect.std.ConsoleCompanionCrossPlatform$SyncConsole", ({
  Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole: 1,
  Lcats_effect_std_ConsoleCrossPlatform: 1,
  Lcats_effect_std_Console: 1
}));
export { $d_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole as $d_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole };
/** @constructor */
function $c_Lcats_effect_std_Semaphore$impl$Request$(outer) {
  this.Lcats_effect_std_Semaphore$impl$Request$__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lcats_effect_std_Semaphore$impl$Request$__f_$outer = outer;
}
export { $c_Lcats_effect_std_Semaphore$impl$Request$ as $c_Lcats_effect_std_Semaphore$impl$Request$ };
$c_Lcats_effect_std_Semaphore$impl$Request$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_std_Semaphore$impl$Request$.prototype.constructor = $c_Lcats_effect_std_Semaphore$impl$Request$;
/** @constructor */
function $h_Lcats_effect_std_Semaphore$impl$Request$() {
}
export { $h_Lcats_effect_std_Semaphore$impl$Request$ as $h_Lcats_effect_std_Semaphore$impl$Request$ };
$h_Lcats_effect_std_Semaphore$impl$Request$.prototype = $c_Lcats_effect_std_Semaphore$impl$Request$.prototype;
$c_Lcats_effect_std_Semaphore$impl$Request$.prototype.apply__J__Lcats_effect_kernel_Deferred__Lcats_effect_std_Semaphore$impl$Request = (function(n, gate) {
  return new $c_Lcats_effect_std_Semaphore$impl$Request(this.Lcats_effect_std_Semaphore$impl$Request$__f_$outer, n, gate);
});
$c_Lcats_effect_std_Semaphore$impl$Request$.prototype.toString__T = (function() {
  return "Request";
});
$c_Lcats_effect_std_Semaphore$impl$Request$.prototype.fromProduct__s_Product__Lcats_effect_std_Semaphore$impl$Request = (function(x$0) {
  return new $c_Lcats_effect_std_Semaphore$impl$Request(this.Lcats_effect_std_Semaphore$impl$Request$__f_$outer, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(x$0.productElement__I__O(0)), x$0.productElement__I__O(1));
});
$c_Lcats_effect_std_Semaphore$impl$Request$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lcats_effect_std_Semaphore$impl$Request(p);
});
var $d_Lcats_effect_std_Semaphore$impl$Request$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_std_Semaphore$impl$Request$, "cats.effect.std.Semaphore$impl$Request$", ({
  Lcats_effect_std_Semaphore$impl$Request$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lcats_effect_std_Semaphore$impl$Request$ as $d_Lcats_effect_std_Semaphore$impl$Request$ };
/** @constructor */
function $c_Lcats_effect_std_Semaphore$impl$State$(outer) {
  this.Lcats_effect_std_Semaphore$impl$State$__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lcats_effect_std_Semaphore$impl$State$__f_$outer = outer;
}
export { $c_Lcats_effect_std_Semaphore$impl$State$ as $c_Lcats_effect_std_Semaphore$impl$State$ };
$c_Lcats_effect_std_Semaphore$impl$State$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_std_Semaphore$impl$State$.prototype.constructor = $c_Lcats_effect_std_Semaphore$impl$State$;
/** @constructor */
function $h_Lcats_effect_std_Semaphore$impl$State$() {
}
export { $h_Lcats_effect_std_Semaphore$impl$State$ as $h_Lcats_effect_std_Semaphore$impl$State$ };
$h_Lcats_effect_std_Semaphore$impl$State$.prototype = $c_Lcats_effect_std_Semaphore$impl$State$.prototype;
$c_Lcats_effect_std_Semaphore$impl$State$.prototype.apply__J__sci_Queue__Lcats_effect_std_Semaphore$impl$State = (function(permits, waiting) {
  return new $c_Lcats_effect_std_Semaphore$impl$State(this.Lcats_effect_std_Semaphore$impl$State$__f_$outer, permits, waiting);
});
$c_Lcats_effect_std_Semaphore$impl$State$.prototype.toString__T = (function() {
  return "State";
});
$c_Lcats_effect_std_Semaphore$impl$State$.prototype.fromProduct__s_Product__Lcats_effect_std_Semaphore$impl$State = (function(x$0) {
  return new $c_Lcats_effect_std_Semaphore$impl$State(this.Lcats_effect_std_Semaphore$impl$State$__f_$outer, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(x$0.productElement__I__O(0)), x$0.productElement__I__O(1));
});
$c_Lcats_effect_std_Semaphore$impl$State$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lcats_effect_std_Semaphore$impl$State(p);
});
var $d_Lcats_effect_std_Semaphore$impl$State$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_std_Semaphore$impl$State$, "cats.effect.std.Semaphore$impl$State$", ({
  Lcats_effect_std_Semaphore$impl$State$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lcats_effect_std_Semaphore$impl$State$ as $d_Lcats_effect_std_Semaphore$impl$State$ };
/** @constructor */
function $c_Lcats_effect_unsafe_NoOpFiberMonitor() {
  this.Lcats_effect_unsafe_FiberMonitorShared__f_newline = null;
  $ct_Lcats_effect_unsafe_FiberMonitorShared__(this);
}
export { $c_Lcats_effect_unsafe_NoOpFiberMonitor as $c_Lcats_effect_unsafe_NoOpFiberMonitor };
$c_Lcats_effect_unsafe_NoOpFiberMonitor.prototype = new $h_Lcats_effect_unsafe_FiberMonitor();
$c_Lcats_effect_unsafe_NoOpFiberMonitor.prototype.constructor = $c_Lcats_effect_unsafe_NoOpFiberMonitor;
/** @constructor */
function $h_Lcats_effect_unsafe_NoOpFiberMonitor() {
}
export { $h_Lcats_effect_unsafe_NoOpFiberMonitor as $h_Lcats_effect_unsafe_NoOpFiberMonitor };
$h_Lcats_effect_unsafe_NoOpFiberMonitor.prototype = $c_Lcats_effect_unsafe_NoOpFiberMonitor.prototype;
$c_Lcats_effect_unsafe_NoOpFiberMonitor.prototype.monitorSuspended__Lcats_effect_IOFiber__Lcats_effect_unsafe_WeakBag$Handle = (function(fiber) {
  return new $c_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1(this);
});
var $d_Lcats_effect_unsafe_NoOpFiberMonitor = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_unsafe_NoOpFiberMonitor, "cats.effect.unsafe.NoOpFiberMonitor", ({
  Lcats_effect_unsafe_NoOpFiberMonitor: 1,
  Lcats_effect_unsafe_FiberMonitor: 1,
  Lcats_effect_unsafe_FiberMonitorShared: 1
}));
export { $d_Lcats_effect_unsafe_NoOpFiberMonitor as $d_Lcats_effect_unsafe_NoOpFiberMonitor };
/** @constructor */
function $c_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform$$anon$1() {
  this.Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform$$anon$1__f_cpuStarvationSampler = null;
  this.Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform$$anon$1__f_cpuStarvationSampler = $m_Lcats_effect_unsafe_metrics_CpuStarvationSampler$().apply__Lcats_effect_unsafe_metrics_CpuStarvationSampler();
}
export { $c_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform$$anon$1 as $c_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform$$anon$1 };
$c_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform$$anon$1.prototype.constructor = $c_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform$$anon$1;
/** @constructor */
function $h_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform$$anon$1() {
}
export { $h_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform$$anon$1 as $h_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform$$anon$1 };
$h_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform$$anon$1.prototype = $c_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform$$anon$1.prototype;
var $d_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform$$anon$1, "cats.effect.unsafe.metrics.IORuntimeMetricsCompanionPlatform$$anon$1", ({
  Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform$$anon$1: 1,
  Lcats_effect_unsafe_metrics_IORuntimeMetricsPlatform: 1,
  Lcats_effect_unsafe_metrics_IORuntimeMetrics: 1
}));
export { $d_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform$$anon$1 as $d_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform$$anon$1 };
/** @constructor */
function $c_Lcats_instances_EqInstances$$anon$2(fa$6, fb$3, outer) {
  this.Lcats_instances_EqInstances$$anon$2__f_fa$4 = null;
  this.Lcats_instances_EqInstances$$anon$2__f_fb$2 = null;
  this.Lcats_instances_EqInstances$$anon$2__f_fa$4 = fa$6;
  this.Lcats_instances_EqInstances$$anon$2__f_fb$2 = fb$3;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lcats_instances_EqInstances$$anon$2 as $c_Lcats_instances_EqInstances$$anon$2 };
$c_Lcats_instances_EqInstances$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_EqInstances$$anon$2.prototype.constructor = $c_Lcats_instances_EqInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_EqInstances$$anon$2() {
}
export { $h_Lcats_instances_EqInstances$$anon$2 as $h_Lcats_instances_EqInstances$$anon$2 };
$h_Lcats_instances_EqInstances$$anon$2.prototype = $c_Lcats_instances_EqInstances$$anon$2.prototype;
$c_Lcats_instances_EqInstances$$anon$2.prototype.neqv__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Eq__neqv__O__O__Z(this, x, y);
});
$c_Lcats_instances_EqInstances$$anon$2.prototype.eqv__T2__T2__Z = (function(left, right) {
  var fa$1 = this.Lcats_instances_EqInstances$$anon$2__f_fa$4;
  var fb$1 = this.Lcats_instances_EqInstances$$anon$2__f_fb$2;
  return (fa$1.eqv__O__O__Z(left._1__O(), right._1__O()) && fb$1.eqv__O__O__Z(left._2__O(), right._2__O()));
});
$c_Lcats_instances_EqInstances$$anon$2.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__T2__T2__Z(x, y);
});
var $d_Lcats_instances_EqInstances$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_EqInstances$$anon$2, "cats.instances.EqInstances$$anon$2", ({
  Lcats_instances_EqInstances$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1
}));
export { $d_Lcats_instances_EqInstances$$anon$2 as $d_Lcats_instances_EqInstances$$anon$2 };
/** @constructor */
function $c_Lcats_instances_EquivInstances$$anon$3(fa$5, f$2) {
}
export { $c_Lcats_instances_EquivInstances$$anon$3 as $c_Lcats_instances_EquivInstances$$anon$3 };
$c_Lcats_instances_EquivInstances$$anon$3.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_EquivInstances$$anon$3.prototype.constructor = $c_Lcats_instances_EquivInstances$$anon$3;
/** @constructor */
function $h_Lcats_instances_EquivInstances$$anon$3() {
}
export { $h_Lcats_instances_EquivInstances$$anon$3 as $h_Lcats_instances_EquivInstances$$anon$3 };
$h_Lcats_instances_EquivInstances$$anon$3.prototype = $c_Lcats_instances_EquivInstances$$anon$3.prototype;
var $d_Lcats_instances_EquivInstances$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_EquivInstances$$anon$3, "cats.instances.EquivInstances$$anon$3", ({
  Lcats_instances_EquivInstances$$anon$3: 1,
  Ljava_io_Serializable: 1,
  s_math_Equiv: 1
}));
export { $d_Lcats_instances_EquivInstances$$anon$3 as $d_Lcats_instances_EquivInstances$$anon$3 };
/** @constructor */
function $c_Lcats_instances_EquivInstances$$anon$4(fa$6, fb$2) {
}
export { $c_Lcats_instances_EquivInstances$$anon$4 as $c_Lcats_instances_EquivInstances$$anon$4 };
$c_Lcats_instances_EquivInstances$$anon$4.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_EquivInstances$$anon$4.prototype.constructor = $c_Lcats_instances_EquivInstances$$anon$4;
/** @constructor */
function $h_Lcats_instances_EquivInstances$$anon$4() {
}
export { $h_Lcats_instances_EquivInstances$$anon$4 as $h_Lcats_instances_EquivInstances$$anon$4 };
$h_Lcats_instances_EquivInstances$$anon$4.prototype = $c_Lcats_instances_EquivInstances$$anon$4.prototype;
var $d_Lcats_instances_EquivInstances$$anon$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_EquivInstances$$anon$4, "cats.instances.EquivInstances$$anon$4", ({
  Lcats_instances_EquivInstances$$anon$4: 1,
  Ljava_io_Serializable: 1,
  s_math_Equiv: 1
}));
export { $d_Lcats_instances_EquivInstances$$anon$4 as $d_Lcats_instances_EquivInstances$$anon$4 };
/** @constructor */
function $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1() {
  this.Lcats_instances_FunctionInstancesBinCompat0$$anon$1__f_Deferred$lzy1 = null;
  this.Lcats_instances_FunctionInstancesBinCompat0$$anon$1__f_Deferred$lzy1 = new $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$(this);
}
export { $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1 as $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1 };
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1.prototype.constructor = $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1;
/** @constructor */
function $h_Lcats_instances_FunctionInstancesBinCompat0$$anon$1() {
}
export { $h_Lcats_instances_FunctionInstancesBinCompat0$$anon$1 as $h_Lcats_instances_FunctionInstancesBinCompat0$$anon$1 };
$h_Lcats_instances_FunctionInstancesBinCompat0$$anon$1.prototype = $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1.prototype;
var $d_Lcats_instances_FunctionInstancesBinCompat0$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1, "cats.instances.FunctionInstancesBinCompat0$$anon$1", ({
  Lcats_instances_FunctionInstancesBinCompat0$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Defer: 1
}));
export { $d_Lcats_instances_FunctionInstancesBinCompat0$$anon$1 as $d_Lcats_instances_FunctionInstancesBinCompat0$$anon$1 };
/** @constructor */
function $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$(outer) {
  this.Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$__f_$outer = outer;
}
export { $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$ as $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$ };
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$.prototype.constructor = $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$;
/** @constructor */
function $h_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$() {
}
export { $h_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$ as $h_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$ };
$h_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$.prototype = $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$.prototype;
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$.prototype.toString__T = (function() {
  return "Deferred";
});
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$.prototype.fromProduct__s_Product__Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred = (function(x$0) {
  return new $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred(this.Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$__f_$outer, x$0.productElement__I__O(0));
});
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred(p);
});
var $d_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$, "cats.instances.FunctionInstancesBinCompat0$$anon$1$Deferred$", ({
  Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$ as $d_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$ };
/** @constructor */
function $c_Lcats_instances_InvariantInstances$$anon$10() {
}
export { $c_Lcats_instances_InvariantInstances$$anon$10 as $c_Lcats_instances_InvariantInstances$$anon$10 };
$c_Lcats_instances_InvariantInstances$$anon$10.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_InvariantInstances$$anon$10.prototype.constructor = $c_Lcats_instances_InvariantInstances$$anon$10;
/** @constructor */
function $h_Lcats_instances_InvariantInstances$$anon$10() {
}
export { $h_Lcats_instances_InvariantInstances$$anon$10 as $h_Lcats_instances_InvariantInstances$$anon$10 };
$h_Lcats_instances_InvariantInstances$$anon$10.prototype = $c_Lcats_instances_InvariantInstances$$anon$10.prototype;
$c_Lcats_instances_InvariantInstances$$anon$10.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return new $c_Lcats_instances_InvariantInstances$$anon$11(fa, f, g);
});
var $d_Lcats_instances_InvariantInstances$$anon$10 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_InvariantInstances$$anon$10, "cats.instances.InvariantInstances$$anon$10", ({
  Lcats_instances_InvariantInstances$$anon$10: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1
}));
export { $d_Lcats_instances_InvariantInstances$$anon$10 as $d_Lcats_instances_InvariantInstances$$anon$10 };
/** @constructor */
function $c_Lcats_instances_InvariantInstances$$anon$12() {
}
export { $c_Lcats_instances_InvariantInstances$$anon$12 as $c_Lcats_instances_InvariantInstances$$anon$12 };
$c_Lcats_instances_InvariantInstances$$anon$12.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_InvariantInstances$$anon$12.prototype.constructor = $c_Lcats_instances_InvariantInstances$$anon$12;
/** @constructor */
function $h_Lcats_instances_InvariantInstances$$anon$12() {
}
export { $h_Lcats_instances_InvariantInstances$$anon$12 as $h_Lcats_instances_InvariantInstances$$anon$12 };
$h_Lcats_instances_InvariantInstances$$anon$12.prototype = $c_Lcats_instances_InvariantInstances$$anon$12.prototype;
$c_Lcats_instances_InvariantInstances$$anon$12.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return new $c_Lcats_instances_InvariantInstances$$anon$13(fa, f, g);
});
var $d_Lcats_instances_InvariantInstances$$anon$12 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_InvariantInstances$$anon$12, "cats.instances.InvariantInstances$$anon$12", ({
  Lcats_instances_InvariantInstances$$anon$12: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1
}));
export { $d_Lcats_instances_InvariantInstances$$anon$12 as $d_Lcats_instances_InvariantInstances$$anon$12 };
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$2(fa$18, fb$7, outer) {
  this.Lcats_instances_InvariantMonoidalInstances$$anon$2__f_fa$13 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$2__f_fb$5 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$2__f_fa$13 = fa$18;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$2__f_fb$5 = fb$7;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lcats_instances_InvariantMonoidalInstances$$anon$2 as $c_Lcats_instances_InvariantMonoidalInstances$$anon$2 };
$c_Lcats_instances_InvariantMonoidalInstances$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$2.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$2() {
}
export { $h_Lcats_instances_InvariantMonoidalInstances$$anon$2 as $h_Lcats_instances_InvariantMonoidalInstances$$anon$2 };
$h_Lcats_instances_InvariantMonoidalInstances$$anon$2.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$2.prototype;
$c_Lcats_instances_InvariantMonoidalInstances$$anon$2.prototype.combine__T2__T2__T2 = (function(x, y) {
  var fa$1 = this.Lcats_instances_InvariantMonoidalInstances$$anon$2__f_fa$13;
  var fb$1 = this.Lcats_instances_InvariantMonoidalInstances$$anon$2__f_fb$5;
  var self = fa$1.combine__O__O__O(x._1__O(), y._1__O());
  var y$1 = fb$1.combine__O__O__O(x._2__O(), y._2__O());
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self, y$1);
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$2.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__T2__T2__T2(x, y);
});
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_InvariantMonoidalInstances$$anon$2, "cats.instances.InvariantMonoidalInstances$$anon$2", ({
  Lcats_instances_InvariantMonoidalInstances$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1
}));
export { $d_Lcats_instances_InvariantMonoidalInstances$$anon$2 as $d_Lcats_instances_InvariantMonoidalInstances$$anon$2 };
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$3(f$12, fa$19, g$12, outer) {
  this.Lcats_instances_InvariantMonoidalInstances$$anon$3__f_f$9 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$3__f_fa$14 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$3__f_g$9 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$3__f_f$9 = f$12;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$3__f_fa$14 = fa$19;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$3__f_g$9 = g$12;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lcats_instances_InvariantMonoidalInstances$$anon$3 as $c_Lcats_instances_InvariantMonoidalInstances$$anon$3 };
$c_Lcats_instances_InvariantMonoidalInstances$$anon$3.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$3.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$3;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$3() {
}
export { $h_Lcats_instances_InvariantMonoidalInstances$$anon$3 as $h_Lcats_instances_InvariantMonoidalInstances$$anon$3 };
$h_Lcats_instances_InvariantMonoidalInstances$$anon$3.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$3.prototype;
$c_Lcats_instances_InvariantMonoidalInstances$$anon$3.prototype.combine__O__O__O = (function(x, y) {
  var f$1 = this.Lcats_instances_InvariantMonoidalInstances$$anon$3__f_f$9;
  var fa$2 = this.Lcats_instances_InvariantMonoidalInstances$$anon$3__f_fa$14;
  var g$1 = this.Lcats_instances_InvariantMonoidalInstances$$anon$3__f_g$9;
  return f$1.apply__O__O(fa$2.combine__O__O__O(g$1.apply__O__O(x), g$1.apply__O__O(y)));
});
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_InvariantMonoidalInstances$$anon$3, "cats.instances.InvariantMonoidalInstances$$anon$3", ({
  Lcats_instances_InvariantMonoidalInstances$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1
}));
export { $d_Lcats_instances_InvariantMonoidalInstances$$anon$3 as $d_Lcats_instances_InvariantMonoidalInstances$$anon$3 };
/** @constructor */
function $c_Lcats_instances_package$boolean$() {
  this.Lcats_instances_package$boolean$__f_catsStdShowForBoolean = null;
  $n_Lcats_instances_package$boolean$ = this;
  this.Lcats_instances_package$boolean$__f_catsStdShowForBoolean = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$$anon$5();
}
export { $c_Lcats_instances_package$boolean$ as $c_Lcats_instances_package$boolean$ };
$c_Lcats_instances_package$boolean$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_package$boolean$.prototype.constructor = $c_Lcats_instances_package$boolean$;
/** @constructor */
function $h_Lcats_instances_package$boolean$() {
}
export { $h_Lcats_instances_package$boolean$ as $h_Lcats_instances_package$boolean$ };
$h_Lcats_instances_package$boolean$.prototype = $c_Lcats_instances_package$boolean$.prototype;
var $d_Lcats_instances_package$boolean$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_package$boolean$, "cats.instances.package$boolean$", ({
  Lcats_instances_package$boolean$: 1,
  Lcats_kernel_instances_BooleanInstances: 1,
  Lcats_instances_BooleanInstances: 1
}));
export { $d_Lcats_instances_package$boolean$ as $d_Lcats_instances_package$boolean$ };
var $n_Lcats_instances_package$boolean$;
function $m_Lcats_instances_package$boolean$() {
  if ((!$n_Lcats_instances_package$boolean$)) {
    $n_Lcats_instances_package$boolean$ = new $c_Lcats_instances_package$boolean$();
  }
  return $n_Lcats_instances_package$boolean$;
}
export { $m_Lcats_instances_package$boolean$ as $m_Lcats_instances_package$boolean$ };
/** @constructor */
function $c_Lcats_instances_package$byte$() {
  this.Lcats_instances_package$byte$__f_catsKernelStdOrderForByte = null;
  $n_Lcats_instances_package$byte$ = this;
  $f_Lcats_kernel_instances_ByteInstances__$init$__V(this);
}
export { $c_Lcats_instances_package$byte$ as $c_Lcats_instances_package$byte$ };
$c_Lcats_instances_package$byte$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_package$byte$.prototype.constructor = $c_Lcats_instances_package$byte$;
/** @constructor */
function $h_Lcats_instances_package$byte$() {
}
export { $h_Lcats_instances_package$byte$ as $h_Lcats_instances_package$byte$ };
$h_Lcats_instances_package$byte$.prototype = $c_Lcats_instances_package$byte$.prototype;
$c_Lcats_instances_package$byte$.prototype.cats$kernel$instances$ByteInstances$_setter_$catsKernelStdOrderForByte_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
  this.Lcats_instances_package$byte$__f_catsKernelStdOrderForByte = x$0;
});
$c_Lcats_instances_package$byte$.prototype.cats$kernel$instances$ByteInstances$_setter_$catsKernelStdGroupForByte_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
var $d_Lcats_instances_package$byte$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_package$byte$, "cats.instances.package$byte$", ({
  Lcats_instances_package$byte$: 1,
  Lcats_kernel_instances_ByteInstances: 1,
  Lcats_instances_ByteInstances: 1
}));
export { $d_Lcats_instances_package$byte$ as $d_Lcats_instances_package$byte$ };
var $n_Lcats_instances_package$byte$;
function $m_Lcats_instances_package$byte$() {
  if ((!$n_Lcats_instances_package$byte$)) {
    $n_Lcats_instances_package$byte$ = new $c_Lcats_instances_package$byte$();
  }
  return $n_Lcats_instances_package$byte$;
}
export { $m_Lcats_instances_package$byte$ as $m_Lcats_instances_package$byte$ };
/** @constructor */
function $c_Lcats_kernel_Eq$$anon$2(ev$6, f$5) {
  this.Lcats_kernel_Eq$$anon$2__f_ev$4 = null;
  this.Lcats_kernel_Eq$$anon$2__f_f$3 = null;
  this.Lcats_kernel_Eq$$anon$2__f_ev$4 = ev$6;
  this.Lcats_kernel_Eq$$anon$2__f_f$3 = f$5;
}
export { $c_Lcats_kernel_Eq$$anon$2 as $c_Lcats_kernel_Eq$$anon$2 };
$c_Lcats_kernel_Eq$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_kernel_Eq$$anon$2.prototype.constructor = $c_Lcats_kernel_Eq$$anon$2;
/** @constructor */
function $h_Lcats_kernel_Eq$$anon$2() {
}
export { $h_Lcats_kernel_Eq$$anon$2 as $h_Lcats_kernel_Eq$$anon$2 };
$h_Lcats_kernel_Eq$$anon$2.prototype = $c_Lcats_kernel_Eq$$anon$2.prototype;
$c_Lcats_kernel_Eq$$anon$2.prototype.neqv__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Eq__neqv__O__O__Z(this, x, y);
});
$c_Lcats_kernel_Eq$$anon$2.prototype.eqv__O__O__Z = (function(x, y) {
  var ev$2 = this.Lcats_kernel_Eq$$anon$2__f_ev$4;
  var f$1 = this.Lcats_kernel_Eq$$anon$2__f_f$3;
  return ev$2.eqv__O__O__Z(f$1.apply__O__O(x), f$1.apply__O__O(y));
});
var $d_Lcats_kernel_Eq$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_kernel_Eq$$anon$2, "cats.kernel.Eq$$anon$2", ({
  Lcats_kernel_Eq$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1
}));
export { $d_Lcats_kernel_Eq$$anon$2 as $d_Lcats_kernel_Eq$$anon$2 };
function $f_Lcats_kernel_PartialOrder__eqv__O__O__Z($thiz, x, y) {
  return ($thiz.partialCompare__O__O__D(x, y) === 0.0);
}
export { $f_Lcats_kernel_PartialOrder__eqv__O__O__Z as $f_Lcats_kernel_PartialOrder__eqv__O__O__Z };
function $f_Lcats_kernel_PartialOrder__lt__O__O__Z($thiz, x, y) {
  return ($thiz.partialCompare__O__O__D(x, y) < 0.0);
}
export { $f_Lcats_kernel_PartialOrder__lt__O__O__Z as $f_Lcats_kernel_PartialOrder__lt__O__O__Z };
function $f_Lcats_kernel_PartialOrder__gt__O__O__Z($thiz, x, y) {
  return ($thiz.partialCompare__O__O__D(x, y) > 0.0);
}
export { $f_Lcats_kernel_PartialOrder__gt__O__O__Z as $f_Lcats_kernel_PartialOrder__gt__O__O__Z };
/** @constructor */
function $c_Lcom_raquo_airstream_core_Observable$() {
  this.Lcom_raquo_airstream_core_Observable$__f_switchStreamStrategy = null;
  this.Lcom_raquo_airstream_core_Observable$__f_switchSignalStreamStrategy = null;
  this.Lcom_raquo_airstream_core_Observable$__f_switchSignalStrategy = null;
  $n_Lcom_raquo_airstream_core_Observable$ = this;
  this.Lcom_raquo_airstream_core_Observable$__f_switchStreamStrategy = $m_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$();
  this.Lcom_raquo_airstream_core_Observable$__f_switchSignalStreamStrategy = $m_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$();
  this.Lcom_raquo_airstream_core_Observable$__f_switchSignalStrategy = $m_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$();
}
export { $c_Lcom_raquo_airstream_core_Observable$ as $c_Lcom_raquo_airstream_core_Observable$ };
$c_Lcom_raquo_airstream_core_Observable$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_core_Observable$.prototype.constructor = $c_Lcom_raquo_airstream_core_Observable$;
/** @constructor */
function $h_Lcom_raquo_airstream_core_Observable$() {
}
export { $h_Lcom_raquo_airstream_core_Observable$ as $h_Lcom_raquo_airstream_core_Observable$ };
$h_Lcom_raquo_airstream_core_Observable$.prototype = $c_Lcom_raquo_airstream_core_Observable$.prototype;
var $d_Lcom_raquo_airstream_core_Observable$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_core_Observable$, "com.raquo.airstream.core.Observable$", ({
  Lcom_raquo_airstream_core_Observable$: 1,
  Lcom_raquo_airstream_core_ObservableMacroImplicits: 1,
  Lcom_raquo_airstream_core_ObservableLowPriorityImplicits: 1
}));
export { $d_Lcom_raquo_airstream_core_Observable$ as $d_Lcom_raquo_airstream_core_Observable$ };
var $n_Lcom_raquo_airstream_core_Observable$;
function $m_Lcom_raquo_airstream_core_Observable$() {
  if ((!$n_Lcom_raquo_airstream_core_Observable$)) {
    $n_Lcom_raquo_airstream_core_Observable$ = new $c_Lcom_raquo_airstream_core_Observable$();
  }
  return $n_Lcom_raquo_airstream_core_Observable$;
}
export { $m_Lcom_raquo_airstream_core_Observable$ as $m_Lcom_raquo_airstream_core_Observable$ };
/** @constructor */
function $c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$() {
}
export { $c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$ as $c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$ };
$c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$.prototype.constructor = $c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$;
/** @constructor */
function $h_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$() {
}
export { $h_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$ as $h_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$ };
$h_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$.prototype = $c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$.prototype;
$c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$.prototype.flatten__Lcom_raquo_airstream_core_Observable__Lcom_raquo_airstream_core_Observable = (function(parent) {
  return new $c_Lcom_raquo_airstream_flatten_SwitchSignal(parent);
});
var $d_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$, "com.raquo.airstream.flatten.FlattenStrategy$SwitchSignalStrategy$", ({
  Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$: 1,
  Lcom_raquo_airstream_flatten_FlattenStrategy: 1,
  Lcom_raquo_airstream_flatten_SwitchingStrategy: 1
}));
export { $d_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$ as $d_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$ };
var $n_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$;
function $m_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$() {
  if ((!$n_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$)) {
    $n_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$ = new $c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$();
  }
  return $n_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$;
}
export { $m_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$ as $m_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$ };
/** @constructor */
function $c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$() {
}
export { $c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$ as $c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$ };
$c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$.prototype.constructor = $c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$;
/** @constructor */
function $h_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$() {
}
export { $h_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$ as $h_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$ };
$h_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$.prototype = $c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$.prototype;
$c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$.prototype.flatten__Lcom_raquo_airstream_core_Observable__Lcom_raquo_airstream_core_Observable = (function(parent) {
  return new $c_Lcom_raquo_airstream_flatten_SwitchSignalStream(parent);
});
var $d_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$, "com.raquo.airstream.flatten.FlattenStrategy$SwitchSignalStreamStrategy$", ({
  Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$: 1,
  Lcom_raquo_airstream_flatten_FlattenStrategy: 1,
  Lcom_raquo_airstream_flatten_SwitchingStrategy: 1
}));
export { $d_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$ as $d_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$ };
var $n_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$;
function $m_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$() {
  if ((!$n_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$)) {
    $n_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$ = new $c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$();
  }
  return $n_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$;
}
export { $m_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$ as $m_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$ };
/** @constructor */
function $c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$() {
}
export { $c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$ as $c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$ };
$c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$.prototype.constructor = $c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$;
/** @constructor */
function $h_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$() {
}
export { $h_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$ as $h_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$ };
$h_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$.prototype = $c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$.prototype;
$c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$.prototype.flatten__Lcom_raquo_airstream_core_Observable__Lcom_raquo_airstream_core_EventStream = (function(parent) {
  return new $c_Lcom_raquo_airstream_flatten_SwitchStream(parent, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x) => x)));
});
$c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$.prototype.flatten__Lcom_raquo_airstream_core_Observable__Lcom_raquo_airstream_core_Observable = (function(parent) {
  return this.flatten__Lcom_raquo_airstream_core_Observable__Lcom_raquo_airstream_core_EventStream(parent);
});
var $d_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$, "com.raquo.airstream.flatten.FlattenStrategy$SwitchStreamStrategy$", ({
  Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$: 1,
  Lcom_raquo_airstream_flatten_FlattenStrategy: 1,
  Lcom_raquo_airstream_flatten_SwitchingStrategy: 1
}));
export { $d_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$ as $d_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$ };
var $n_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$;
function $m_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$() {
  if ((!$n_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$)) {
    $n_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$ = new $c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$();
  }
  return $n_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$;
}
export { $m_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$ as $m_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$ };
/** @constructor */
function $c_Lcom_raquo_airstream_ownership_ManualOwner() {
  this.Lcom_raquo_airstream_ownership_ManualOwner__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_ownership_ManualOwner__f_subscriptions = null;
  this.Lcom_raquo_airstream_ownership_ManualOwner__f_maybeDisplayName = (void 0);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_ownership_Owner__$init$__V(this);
}
export { $c_Lcom_raquo_airstream_ownership_ManualOwner as $c_Lcom_raquo_airstream_ownership_ManualOwner };
$c_Lcom_raquo_airstream_ownership_ManualOwner.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_ownership_ManualOwner.prototype.constructor = $c_Lcom_raquo_airstream_ownership_ManualOwner;
/** @constructor */
function $h_Lcom_raquo_airstream_ownership_ManualOwner() {
}
export { $h_Lcom_raquo_airstream_ownership_ManualOwner as $h_Lcom_raquo_airstream_ownership_ManualOwner };
$h_Lcom_raquo_airstream_ownership_ManualOwner.prototype = $c_Lcom_raquo_airstream_ownership_ManualOwner.prototype;
$c_Lcom_raquo_airstream_ownership_ManualOwner.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_ownership_ManualOwner__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_ownership_ManualOwner.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_ownership_ManualOwner__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_ownership_ManualOwner.prototype.defaultDisplayName__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_airstream_ownership_ManualOwner.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_ownership_ManualOwner.prototype.subscriptions__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_ownership_ManualOwner__f_subscriptions;
});
$c_Lcom_raquo_airstream_ownership_ManualOwner.prototype.com$raquo$airstream$ownership$Owner$_setter_$subscriptions_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_ownership_ManualOwner__f_subscriptions = x$0;
});
$c_Lcom_raquo_airstream_ownership_ManualOwner.prototype.own__Lcom_raquo_airstream_ownership_Subscription__V = (function(subscription) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_ownership_Owner__own__Lcom_raquo_airstream_ownership_Subscription__V(this, subscription);
});
$c_Lcom_raquo_airstream_ownership_ManualOwner.prototype.killSubscriptions__V = (function() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_ownership_Owner__killSubscriptions__V(this);
});
var $d_Lcom_raquo_airstream_ownership_ManualOwner = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_ownership_ManualOwner, "com.raquo.airstream.ownership.ManualOwner", ({
  Lcom_raquo_airstream_ownership_ManualOwner: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_ownership_Owner: 1
}));
export { $d_Lcom_raquo_airstream_ownership_ManualOwner as $d_Lcom_raquo_airstream_ownership_ManualOwner };
/** @constructor */
function $c_Lcom_raquo_airstream_split_SplitSignal$$anon$1() {
}
export { $c_Lcom_raquo_airstream_split_SplitSignal$$anon$1 as $c_Lcom_raquo_airstream_split_SplitSignal$$anon$1 };
$c_Lcom_raquo_airstream_split_SplitSignal$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_split_SplitSignal$$anon$1.prototype.constructor = $c_Lcom_raquo_airstream_split_SplitSignal$$anon$1;
/** @constructor */
function $h_Lcom_raquo_airstream_split_SplitSignal$$anon$1() {
}
export { $h_Lcom_raquo_airstream_split_SplitSignal$$anon$1 as $h_Lcom_raquo_airstream_split_SplitSignal$$anon$1 };
$h_Lcom_raquo_airstream_split_SplitSignal$$anon$1.prototype = $c_Lcom_raquo_airstream_split_SplitSignal$$anon$1.prototype;
$c_Lcom_raquo_airstream_split_SplitSignal$$anon$1.prototype.onNext__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_split_SplitSignal$$anon$1.prototype.onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$c_Lcom_raquo_airstream_split_SplitSignal$$anon$1.prototype.onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
});
var $d_Lcom_raquo_airstream_split_SplitSignal$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_split_SplitSignal$$anon$1, "com.raquo.airstream.split.SplitSignal$$anon$1", ({
  Lcom_raquo_airstream_split_SplitSignal$$anon$1: 1,
  Lcom_raquo_airstream_core_InternalObserver: 1,
  Lcom_raquo_airstream_common_InternalTryObserver: 1
}));
export { $d_Lcom_raquo_airstream_split_SplitSignal$$anon$1 as $d_Lcom_raquo_airstream_split_SplitSignal$$anon$1 };
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_Setter$$anon$2(fn$2) {
  this.Lcom_raquo_laminar_modifiers_Setter$$anon$2__f_fn$1 = null;
  this.Lcom_raquo_laminar_modifiers_Setter$$anon$2__f_fn$1 = fn$2;
}
export { $c_Lcom_raquo_laminar_modifiers_Setter$$anon$2 as $c_Lcom_raquo_laminar_modifiers_Setter$$anon$2 };
$c_Lcom_raquo_laminar_modifiers_Setter$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_laminar_modifiers_Setter$$anon$2.prototype.constructor = $c_Lcom_raquo_laminar_modifiers_Setter$$anon$2;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_Setter$$anon$2() {
}
export { $h_Lcom_raquo_laminar_modifiers_Setter$$anon$2 as $h_Lcom_raquo_laminar_modifiers_Setter$$anon$2 };
$h_Lcom_raquo_laminar_modifiers_Setter$$anon$2.prototype = $c_Lcom_raquo_laminar_modifiers_Setter$$anon$2.prototype;
$c_Lcom_raquo_laminar_modifiers_Setter$$anon$2.prototype.apply__Lcom_raquo_laminar_nodes_ReactiveElement__V = (function(element) {
  this.Lcom_raquo_laminar_modifiers_Setter$$anon$2__f_fn$1.apply__O__O(element);
});
var $d_Lcom_raquo_laminar_modifiers_Setter$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_laminar_modifiers_Setter$$anon$2, "com.raquo.laminar.modifiers.Setter$$anon$2", ({
  Lcom_raquo_laminar_modifiers_Setter$$anon$2: 1,
  Lcom_raquo_laminar_modifiers_Modifier: 1,
  Lcom_raquo_laminar_modifiers_Setter: 1
}));
export { $d_Lcom_raquo_laminar_modifiers_Setter$$anon$2 as $d_Lcom_raquo_laminar_modifiers_Setter$$anon$2 };
var $d_Lcom_raquo_laminar_nodes_ChildNode = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass(1, "com.raquo.laminar.nodes.ChildNode", ({
  Lcom_raquo_laminar_nodes_ChildNode: 1,
  Lcom_raquo_laminar_nodes_ReactiveNode: 1,
  Lcom_raquo_laminar_modifiers_Modifier: 1
}));
export { $d_Lcom_raquo_laminar_nodes_ChildNode as $d_Lcom_raquo_laminar_nodes_ChildNode };
/** @constructor */
function $c_Lcom_raquo_laminar_nodes_RootNode(container, child) {
  this.Lcom_raquo_laminar_nodes_RootNode__f_dynamicOwner = null;
  this.Lcom_raquo_laminar_nodes_RootNode__f_child = null;
  this.Lcom_raquo_laminar_nodes_RootNode__f_ref = null;
  this.Lcom_raquo_laminar_nodes_RootNode__f_child = child;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_laminar_nodes_ParentNode__$init$__V(this);
  if ((container === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Exception__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Exception(), "Unable to mount Laminar RootNode into a null container. See https://laminar.dev/documentation#waiting-for-the-dom-to-load");
  }
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_domapi_DomApi$raw$();
  var ancestor = document;
  if ((!$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_laminar_domapi_DomTreeRaw__isDescendantOf__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Z(this$1, container, ancestor))) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Exception__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Exception(), "Unable to mount Laminar RootNode into an unmounted container. See https://laminar.dev/documentation#rendering");
  }
  this.Lcom_raquo_laminar_nodes_RootNode__f_ref = container;
  this.mount__Z();
}
export { $c_Lcom_raquo_laminar_nodes_RootNode as $c_Lcom_raquo_laminar_nodes_RootNode };
$c_Lcom_raquo_laminar_nodes_RootNode.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_laminar_nodes_RootNode.prototype.constructor = $c_Lcom_raquo_laminar_nodes_RootNode;
/** @constructor */
function $h_Lcom_raquo_laminar_nodes_RootNode() {
}
export { $h_Lcom_raquo_laminar_nodes_RootNode as $h_Lcom_raquo_laminar_nodes_RootNode };
$h_Lcom_raquo_laminar_nodes_RootNode.prototype = $c_Lcom_raquo_laminar_nodes_RootNode.prototype;
$c_Lcom_raquo_laminar_nodes_RootNode.prototype.dynamicOwner__Lcom_raquo_airstream_ownership_DynamicOwner = (function() {
  return this.Lcom_raquo_laminar_nodes_RootNode__f_dynamicOwner;
});
$c_Lcom_raquo_laminar_nodes_RootNode.prototype.com$raquo$laminar$nodes$ParentNode$_setter_$dynamicOwner_$eq__Lcom_raquo_airstream_ownership_DynamicOwner__V = (function(x$0) {
  this.Lcom_raquo_laminar_nodes_RootNode__f_dynamicOwner = x$0;
});
$c_Lcom_raquo_laminar_nodes_RootNode.prototype.mount__Z = (function() {
  this.Lcom_raquo_laminar_nodes_RootNode__f_dynamicOwner.activate__V();
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_domapi_DomApi$();
  var child = this.Lcom_raquo_laminar_nodes_RootNode__f_child;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_laminar_domapi_DomTree__appendChild__Lcom_raquo_laminar_nodes_ParentNode__Lcom_raquo_laminar_nodes_ChildNode__O__Z(this$1, this, child, (void 0));
});
$c_Lcom_raquo_laminar_nodes_RootNode.prototype.ref__Lorg_scalajs_dom_Node = (function() {
  return this.Lcom_raquo_laminar_nodes_RootNode__f_ref;
});
var $d_Lcom_raquo_laminar_nodes_RootNode = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_laminar_nodes_RootNode, "com.raquo.laminar.nodes.RootNode", ({
  Lcom_raquo_laminar_nodes_RootNode: 1,
  Lcom_raquo_laminar_nodes_ReactiveNode: 1,
  Lcom_raquo_laminar_nodes_ParentNode: 1
}));
export { $d_Lcom_raquo_laminar_nodes_RootNode as $d_Lcom_raquo_laminar_nodes_RootNode };
/** @constructor */
function $c_Lfansi_Back$() {
  this.Lfansi_Category__f_offset = 0;
  this.Lfansi_Category__f_width = 0;
  this.Lfansi_Category__f_catName = null;
  this.Lfansi_Category__f_lookupAttrTable$lzy1 = null;
  this.Lfansi_Category__f_lookupAttrTablebitmap$1 = false;
  this.Lfansi_ColorCategory__f_offset = 0;
  this.Lfansi_ColorCategory__f_colorCode = 0;
  this.Lfansi_ColorCategory__f_Full = null;
  this.Lfansi_Back$__f_Reset = null;
  this.Lfansi_Back$__f_Black = null;
  this.Lfansi_Back$__f_Red = null;
  this.Lfansi_Back$__f_Green = null;
  this.Lfansi_Back$__f_Yellow = null;
  this.Lfansi_Back$__f_Blue = null;
  this.Lfansi_Back$__f_Magenta = null;
  this.Lfansi_Back$__f_Cyan = null;
  this.Lfansi_Back$__f_LightGray = null;
  this.Lfansi_Back$__f_DarkGray = null;
  this.Lfansi_Back$__f_LightRed = null;
  this.Lfansi_Back$__f_LightGreen = null;
  this.Lfansi_Back$__f_LightYellow = null;
  this.Lfansi_Back$__f_LightBlue = null;
  this.Lfansi_Back$__f_LightMagenta = null;
  this.Lfansi_Back$__f_LightCyan = null;
  this.Lfansi_Back$__f_White = null;
  this.Lfansi_Back$__f_all = null;
  $ct_Lfansi_ColorCategory__I__I__I__Lsourcecode_Name__(this, 29, 25, 48, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Back")));
  $n_Lfansi_Back$ = this;
  this.Lfansi_Back$__f_Reset = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[49m", $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Reset")));
  this.Lfansi_Back$__f_Black = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[40m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(1, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Black")));
  this.Lfansi_Back$__f_Red = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[41m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(2, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Red")));
  this.Lfansi_Back$__f_Green = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[42m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(3, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Green")));
  this.Lfansi_Back$__f_Yellow = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[43m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(4, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Yellow")));
  this.Lfansi_Back$__f_Blue = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[44m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(5, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Blue")));
  this.Lfansi_Back$__f_Magenta = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[45m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(6, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Magenta")));
  this.Lfansi_Back$__f_Cyan = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[46m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(7, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Cyan")));
  this.Lfansi_Back$__f_LightGray = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[47m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(8, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("LightGray")));
  this.Lfansi_Back$__f_DarkGray = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[100m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(9, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("DarkGray")));
  this.Lfansi_Back$__f_LightRed = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[101m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(10, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("LightRed")));
  this.Lfansi_Back$__f_LightGreen = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[102m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(11, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("LightGreen")));
  this.Lfansi_Back$__f_LightYellow = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[103m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(12, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("LightYellow")));
  this.Lfansi_Back$__f_LightBlue = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[104m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(13, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("LightBlue")));
  this.Lfansi_Back$__f_LightMagenta = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[105m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(14, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("LightMagenta")));
  this.Lfansi_Back$__f_LightCyan = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[106m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(15, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("LightCyan")));
  this.Lfansi_Back$__f_White = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[107m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(16, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("White")));
  var this$19 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
  var elems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lfansi_EscapeAttr.getArrayOf().constr)([this.Lfansi_Back$__f_Reset, this.Lfansi_Back$__f_Black, this.Lfansi_Back$__f_Red, this.Lfansi_Back$__f_Green, this.Lfansi_Back$__f_Yellow, this.Lfansi_Back$__f_Blue, this.Lfansi_Back$__f_Magenta, this.Lfansi_Back$__f_Cyan, this.Lfansi_Back$__f_LightGray, this.Lfansi_Back$__f_DarkGray, this.Lfansi_Back$__f_LightRed, this.Lfansi_Back$__f_LightGreen, this.Lfansi_Back$__f_LightYellow, this.Lfansi_Back$__f_LightBlue, this.Lfansi_Back$__f_LightMagenta, this.Lfansi_Back$__f_LightCyan, this.Lfansi_Back$__f_White]));
  var this$20 = this$19.from__sc_IterableOnce__sci_Vector(elems);
  var suffix = this.Lfansi_ColorCategory__f_Full;
  this.Lfansi_Back$__f_all = this$20.appendedAll__sc_IterableOnce__sci_Vector(suffix);
}
export { $c_Lfansi_Back$ as $c_Lfansi_Back$ };
$c_Lfansi_Back$.prototype = new $h_Lfansi_ColorCategory();
$c_Lfansi_Back$.prototype.constructor = $c_Lfansi_Back$;
/** @constructor */
function $h_Lfansi_Back$() {
}
export { $h_Lfansi_Back$ as $h_Lfansi_Back$ };
$h_Lfansi_Back$.prototype = $c_Lfansi_Back$.prototype;
$c_Lfansi_Back$.prototype.all__sci_Vector = (function() {
  return this.Lfansi_Back$__f_all;
});
var $d_Lfansi_Back$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfansi_Back$, "fansi.Back$", ({
  Lfansi_Back$: 1,
  Lfansi_ColorCategory: 1,
  Lfansi_Category: 1
}));
export { $d_Lfansi_Back$ as $d_Lfansi_Back$ };
var $n_Lfansi_Back$;
function $m_Lfansi_Back$() {
  if ((!$n_Lfansi_Back$)) {
    $n_Lfansi_Back$ = new $c_Lfansi_Back$();
  }
  return $n_Lfansi_Back$;
}
export { $m_Lfansi_Back$ as $m_Lfansi_Back$ };
/** @constructor */
function $c_Lfansi_Color$() {
  this.Lfansi_Category__f_offset = 0;
  this.Lfansi_Category__f_width = 0;
  this.Lfansi_Category__f_catName = null;
  this.Lfansi_Category__f_lookupAttrTable$lzy1 = null;
  this.Lfansi_Category__f_lookupAttrTablebitmap$1 = false;
  this.Lfansi_ColorCategory__f_offset = 0;
  this.Lfansi_ColorCategory__f_colorCode = 0;
  this.Lfansi_ColorCategory__f_Full = null;
  this.Lfansi_Color$__f_Reset = null;
  this.Lfansi_Color$__f_Black = null;
  this.Lfansi_Color$__f_Red = null;
  this.Lfansi_Color$__f_Green = null;
  this.Lfansi_Color$__f_Yellow = null;
  this.Lfansi_Color$__f_Blue = null;
  this.Lfansi_Color$__f_Magenta = null;
  this.Lfansi_Color$__f_Cyan = null;
  this.Lfansi_Color$__f_LightGray = null;
  this.Lfansi_Color$__f_DarkGray = null;
  this.Lfansi_Color$__f_LightRed = null;
  this.Lfansi_Color$__f_LightGreen = null;
  this.Lfansi_Color$__f_LightYellow = null;
  this.Lfansi_Color$__f_LightBlue = null;
  this.Lfansi_Color$__f_LightMagenta = null;
  this.Lfansi_Color$__f_LightCyan = null;
  this.Lfansi_Color$__f_White = null;
  this.Lfansi_Color$__f_all = null;
  $ct_Lfansi_ColorCategory__I__I__I__Lsourcecode_Name__(this, 4, 25, 38, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Color")));
  $n_Lfansi_Color$ = this;
  this.Lfansi_Color$__f_Reset = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[39m", $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Reset")));
  this.Lfansi_Color$__f_Black = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[30m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(1, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Black")));
  this.Lfansi_Color$__f_Red = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[31m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(2, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Red")));
  this.Lfansi_Color$__f_Green = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[32m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(3, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Green")));
  this.Lfansi_Color$__f_Yellow = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[33m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(4, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Yellow")));
  this.Lfansi_Color$__f_Blue = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[34m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(5, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Blue")));
  this.Lfansi_Color$__f_Magenta = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[35m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(6, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Magenta")));
  this.Lfansi_Color$__f_Cyan = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[36m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(7, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Cyan")));
  this.Lfansi_Color$__f_LightGray = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[37m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(8, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("LightGray")));
  this.Lfansi_Color$__f_DarkGray = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[90m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(9, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("DarkGray")));
  this.Lfansi_Color$__f_LightRed = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[91m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(10, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("LightRed")));
  this.Lfansi_Color$__f_LightGreen = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[92m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(11, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("LightGreen")));
  this.Lfansi_Color$__f_LightYellow = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[93m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(12, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("LightYellow")));
  this.Lfansi_Color$__f_LightBlue = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[94m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(13, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("LightBlue")));
  this.Lfansi_Color$__f_LightMagenta = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[95m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(14, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("LightMagenta")));
  this.Lfansi_Color$__f_LightCyan = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[96m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(15, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("LightCyan")));
  this.Lfansi_Color$__f_White = this.makeAttr__T__J__Lsourcecode_Name__Lfansi_EscapeAttr("\u001b[97m", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(16, 0), ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("White")));
  var this$19 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
  var elems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lfansi_EscapeAttr.getArrayOf().constr)([this.Lfansi_Color$__f_Reset, this.Lfansi_Color$__f_Black, this.Lfansi_Color$__f_Red, this.Lfansi_Color$__f_Green, this.Lfansi_Color$__f_Yellow, this.Lfansi_Color$__f_Blue, this.Lfansi_Color$__f_Magenta, this.Lfansi_Color$__f_Cyan, this.Lfansi_Color$__f_LightGray, this.Lfansi_Color$__f_DarkGray, this.Lfansi_Color$__f_LightRed, this.Lfansi_Color$__f_LightGreen, this.Lfansi_Color$__f_LightYellow, this.Lfansi_Color$__f_LightBlue, this.Lfansi_Color$__f_LightMagenta, this.Lfansi_Color$__f_LightCyan, this.Lfansi_Color$__f_White]));
  var this$20 = this$19.from__sc_IterableOnce__sci_Vector(elems);
  var suffix = this.Lfansi_ColorCategory__f_Full;
  this.Lfansi_Color$__f_all = this$20.appendedAll__sc_IterableOnce__sci_Vector(suffix);
}
export { $c_Lfansi_Color$ as $c_Lfansi_Color$ };
$c_Lfansi_Color$.prototype = new $h_Lfansi_ColorCategory();
$c_Lfansi_Color$.prototype.constructor = $c_Lfansi_Color$;
/** @constructor */
function $h_Lfansi_Color$() {
}
export { $h_Lfansi_Color$ as $h_Lfansi_Color$ };
$h_Lfansi_Color$.prototype = $c_Lfansi_Color$.prototype;
$c_Lfansi_Color$.prototype.all__sci_Vector = (function() {
  return this.Lfansi_Color$__f_all;
});
var $d_Lfansi_Color$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfansi_Color$, "fansi.Color$", ({
  Lfansi_Color$: 1,
  Lfansi_ColorCategory: 1,
  Lfansi_Category: 1
}));
export { $d_Lfansi_Color$ as $d_Lfansi_Color$ };
var $n_Lfansi_Color$;
function $m_Lfansi_Color$() {
  if ((!$n_Lfansi_Color$)) {
    $n_Lfansi_Color$ = new $c_Lfansi_Color$();
  }
  return $n_Lfansi_Color$;
}
export { $m_Lfansi_Color$ as $m_Lfansi_Color$ };
function $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__INITIAL_SESSION__Lframework_auth_SupabaseAuthClient$AuthChangeEvent() {
  $m_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$();
  return $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__INITIAL_SESSION;
}
export { $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__INITIAL_SESSION__Lframework_auth_SupabaseAuthClient$AuthChangeEvent as $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__INITIAL_SESSION__Lframework_auth_SupabaseAuthClient$AuthChangeEvent };
function $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__PASSWORD_RECOVERY__Lframework_auth_SupabaseAuthClient$AuthChangeEvent() {
  $m_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$();
  return $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__PASSWORD_RECOVERY;
}
export { $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__PASSWORD_RECOVERY__Lframework_auth_SupabaseAuthClient$AuthChangeEvent as $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__PASSWORD_RECOVERY__Lframework_auth_SupabaseAuthClient$AuthChangeEvent };
function $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__SIGNED_IN__Lframework_auth_SupabaseAuthClient$AuthChangeEvent() {
  $m_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$();
  return $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__SIGNED_IN;
}
export { $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__SIGNED_IN__Lframework_auth_SupabaseAuthClient$AuthChangeEvent as $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__SIGNED_IN__Lframework_auth_SupabaseAuthClient$AuthChangeEvent };
function $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__SIGNED_OUT__Lframework_auth_SupabaseAuthClient$AuthChangeEvent() {
  $m_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$();
  return $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__SIGNED_OUT;
}
export { $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__SIGNED_OUT__Lframework_auth_SupabaseAuthClient$AuthChangeEvent as $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__SIGNED_OUT__Lframework_auth_SupabaseAuthClient$AuthChangeEvent };
function $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__TOKEN_REFRESHED__Lframework_auth_SupabaseAuthClient$AuthChangeEvent() {
  $m_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$();
  return $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__TOKEN_REFRESHED;
}
export { $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__TOKEN_REFRESHED__Lframework_auth_SupabaseAuthClient$AuthChangeEvent as $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__TOKEN_REFRESHED__Lframework_auth_SupabaseAuthClient$AuthChangeEvent };
function $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__USER_UPDATED__Lframework_auth_SupabaseAuthClient$AuthChangeEvent() {
  $m_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$();
  return $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__USER_UPDATED;
}
export { $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__USER_UPDATED__Lframework_auth_SupabaseAuthClient$AuthChangeEvent as $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__USER_UPDATED__Lframework_auth_SupabaseAuthClient$AuthChangeEvent };
function $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__AuthChangeEventMFA__Lframework_auth_SupabaseAuthClient$AuthChangeEvent() {
  $m_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$();
  return $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__AuthChangeEventMFA;
}
export { $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__AuthChangeEventMFA__Lframework_auth_SupabaseAuthClient$AuthChangeEvent as $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__AuthChangeEventMFA__Lframework_auth_SupabaseAuthClient$AuthChangeEvent };
/** @constructor */
function $c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$() {
  this.Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__f_show$lzy1 = null;
  this.Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__f_showbitmap$1 = false;
  $n_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$ = this;
  $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__INITIAL_SESSION = new $c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1("INITIAL_SESSION", 0);
  $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__PASSWORD_RECOVERY = new $c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1("PASSWORD_RECOVERY", 1);
  $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__SIGNED_IN = new $c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1("SIGNED_IN", 2);
  $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__SIGNED_OUT = new $c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1("SIGNED_OUT", 3);
  $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__TOKEN_REFRESHED = new $c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1("TOKEN_REFRESHED", 4);
  $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__USER_UPDATED = new $c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1("USER_UPDATED", 5);
  $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__AuthChangeEventMFA = new $c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1("AuthChangeEventMFA", 6);
  $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__INITIAL_SESSION__Lframework_auth_SupabaseAuthClient$AuthChangeEvent();
  $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__PASSWORD_RECOVERY__Lframework_auth_SupabaseAuthClient$AuthChangeEvent();
  $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__SIGNED_IN__Lframework_auth_SupabaseAuthClient$AuthChangeEvent();
  $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__SIGNED_OUT__Lframework_auth_SupabaseAuthClient$AuthChangeEvent();
  $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__TOKEN_REFRESHED__Lframework_auth_SupabaseAuthClient$AuthChangeEvent();
  $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__USER_UPDATED__Lframework_auth_SupabaseAuthClient$AuthChangeEvent();
  $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__AuthChangeEventMFA__Lframework_auth_SupabaseAuthClient$AuthChangeEvent();
}
export { $c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$ as $c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$ };
$c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$.prototype.constructor = $c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$;
/** @constructor */
function $h_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$() {
}
export { $h_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$ as $h_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$ };
$h_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$.prototype = $c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$.prototype;
$c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$.prototype.show__Lcats_Show = (function() {
  if ((!this.Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__f_showbitmap$1)) {
    this.Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__f_show$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$$anon$5();
    this.Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__f_showbitmap$1 = true;
  }
  return this.Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__f_show$lzy1;
});
$c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$.prototype.from__Lorg_scalablytyped_runtime_StObject__s_Option = (function(jsEvent) {
  if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(jsEvent, "MFA_CHALLENGE_VERIFIED")) {
    var value = $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__AuthChangeEventMFA__Lframework_auth_SupabaseAuthClient$AuthChangeEvent();
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
  } else if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(jsEvent, "INITIAL_SESSION")) {
    var value$1 = $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__INITIAL_SESSION__Lframework_auth_SupabaseAuthClient$AuthChangeEvent();
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value$1);
  } else if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(jsEvent, "PASSWORD_RECOVERY")) {
    var value$2 = $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__PASSWORD_RECOVERY__Lframework_auth_SupabaseAuthClient$AuthChangeEvent();
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value$2);
  } else if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(jsEvent, "SIGNED_IN")) {
    var value$3 = $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__SIGNED_IN__Lframework_auth_SupabaseAuthClient$AuthChangeEvent();
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value$3);
  } else if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(jsEvent, "SIGNED_OUT")) {
    var value$4 = $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__SIGNED_OUT__Lframework_auth_SupabaseAuthClient$AuthChangeEvent();
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value$4);
  } else if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(jsEvent, "TOKEN_REFRESHED")) {
    var value$5 = $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__TOKEN_REFRESHED__Lframework_auth_SupabaseAuthClient$AuthChangeEvent();
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value$5);
  } else if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(jsEvent, "USER_UPDATED")) {
    var value$6 = $s_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__USER_UPDATED__Lframework_auth_SupabaseAuthClient$AuthChangeEvent();
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value$6);
  } else {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
});
$c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$.prototype.ordinal__O__I = (function(x) {
  return x.Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1__f__$ordinal$1;
});
var $d_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$, "framework.auth.SupabaseAuthClient$AuthChangeEvent$", ({
  Lframework_auth_SupabaseAuthClient$AuthChangeEvent$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$ as $d_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$ };
var $n_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$;
function $m_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$() {
  if ((!$n_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$)) {
    $n_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$ = new $c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$();
  }
  return $n_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$;
}
export { $m_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$ as $m_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$ };
/** @constructor */
function $c_Lframework_components_FrameworkMainModal$DataBox$(outer) {
  this.Lframework_components_FrameworkMainModal$DataBox$__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lframework_components_FrameworkMainModal$DataBox$__f_$outer = outer;
}
export { $c_Lframework_components_FrameworkMainModal$DataBox$ as $c_Lframework_components_FrameworkMainModal$DataBox$ };
$c_Lframework_components_FrameworkMainModal$DataBox$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_components_FrameworkMainModal$DataBox$.prototype.constructor = $c_Lframework_components_FrameworkMainModal$DataBox$;
/** @constructor */
function $h_Lframework_components_FrameworkMainModal$DataBox$() {
}
export { $h_Lframework_components_FrameworkMainModal$DataBox$ as $h_Lframework_components_FrameworkMainModal$DataBox$ };
$h_Lframework_components_FrameworkMainModal$DataBox$.prototype = $c_Lframework_components_FrameworkMainModal$DataBox$.prototype;
$c_Lframework_components_FrameworkMainModal$DataBox$.prototype.apply__Lframework_components_FrameworkMainModal$Data__s_concurrent_Promise__Lframework_components_FrameworkMainModal$DataBox = (function(data, closed) {
  return new $c_Lframework_components_FrameworkMainModal$DataBox(this.Lframework_components_FrameworkMainModal$DataBox$__f_$outer, data, closed);
});
$c_Lframework_components_FrameworkMainModal$DataBox$.prototype.toString__T = (function() {
  return "DataBox";
});
$c_Lframework_components_FrameworkMainModal$DataBox$.prototype.fromProduct__s_Product__Lframework_components_FrameworkMainModal$DataBox = (function(x$0) {
  var data$1 = x$0.productElement__I__O(0);
  var closed$1 = x$0.productElement__I__O(1);
  return new $c_Lframework_components_FrameworkMainModal$DataBox(this.Lframework_components_FrameworkMainModal$DataBox$__f_$outer, data$1, closed$1);
});
$c_Lframework_components_FrameworkMainModal$DataBox$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lframework_components_FrameworkMainModal$DataBox(p);
});
var $d_Lframework_components_FrameworkMainModal$DataBox$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_components_FrameworkMainModal$DataBox$, "framework.components.FrameworkMainModal$DataBox$", ({
  Lframework_components_FrameworkMainModal$DataBox$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lframework_components_FrameworkMainModal$DataBox$ as $d_Lframework_components_FrameworkMainModal$DataBox$ };
function $s_Lframework_components_ToastType$__Info__Lframework_components_ToastType() {
  $m_Lframework_components_ToastType$();
  return $t_Lframework_components_ToastType$__Info;
}
export { $s_Lframework_components_ToastType$__Info__Lframework_components_ToastType as $s_Lframework_components_ToastType$__Info__Lframework_components_ToastType };
function $s_Lframework_components_ToastType$__Success__Lframework_components_ToastType() {
  $m_Lframework_components_ToastType$();
  return $t_Lframework_components_ToastType$__Success;
}
export { $s_Lframework_components_ToastType$__Success__Lframework_components_ToastType as $s_Lframework_components_ToastType$__Success__Lframework_components_ToastType };
function $s_Lframework_components_ToastType$__Warning__Lframework_components_ToastType() {
  $m_Lframework_components_ToastType$();
  return $t_Lframework_components_ToastType$__Warning;
}
export { $s_Lframework_components_ToastType$__Warning__Lframework_components_ToastType as $s_Lframework_components_ToastType$__Warning__Lframework_components_ToastType };
function $s_Lframework_components_ToastType$__Error__Lframework_components_ToastType() {
  $m_Lframework_components_ToastType$();
  return $t_Lframework_components_ToastType$__Error;
}
export { $s_Lframework_components_ToastType$__Error__Lframework_components_ToastType as $s_Lframework_components_ToastType$__Error__Lframework_components_ToastType };
/** @constructor */
function $c_Lframework_components_ToastType$() {
  $n_Lframework_components_ToastType$ = this;
  $t_Lframework_components_ToastType$__Info = new $c_Lframework_components_ToastType$$anon$1("Info", 0);
  $t_Lframework_components_ToastType$__Success = new $c_Lframework_components_ToastType$$anon$1("Success", 1);
  $t_Lframework_components_ToastType$__Warning = new $c_Lframework_components_ToastType$$anon$1("Warning", 2);
  $t_Lframework_components_ToastType$__Error = new $c_Lframework_components_ToastType$$anon$1("Error", 3);
  $s_Lframework_components_ToastType$__Info__Lframework_components_ToastType();
  $s_Lframework_components_ToastType$__Success__Lframework_components_ToastType();
  $s_Lframework_components_ToastType$__Warning__Lframework_components_ToastType();
  $s_Lframework_components_ToastType$__Error__Lframework_components_ToastType();
}
export { $c_Lframework_components_ToastType$ as $c_Lframework_components_ToastType$ };
$c_Lframework_components_ToastType$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_components_ToastType$.prototype.constructor = $c_Lframework_components_ToastType$;
/** @constructor */
function $h_Lframework_components_ToastType$() {
}
export { $h_Lframework_components_ToastType$ as $h_Lframework_components_ToastType$ };
$h_Lframework_components_ToastType$.prototype = $c_Lframework_components_ToastType$.prototype;
$c_Lframework_components_ToastType$.prototype.ordinal__O__I = (function(x) {
  return x.Lframework_components_ToastType$$anon$1__f__$ordinal$1;
});
var $d_Lframework_components_ToastType$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_components_ToastType$, "framework.components.ToastType$", ({
  Lframework_components_ToastType$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lframework_components_ToastType$ as $d_Lframework_components_ToastType$ };
var $n_Lframework_components_ToastType$;
function $m_Lframework_components_ToastType$() {
  if ((!$n_Lframework_components_ToastType$)) {
    $n_Lframework_components_ToastType$ = new $c_Lframework_components_ToastType$();
  }
  return $n_Lframework_components_ToastType$;
}
export { $m_Lframework_components_ToastType$ as $m_Lframework_components_ToastType$ };
/** @constructor */
function $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$(outer) {
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$__f_Loading$lzy1 = null;
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$__f_NotAuthenticated$lzy1 = null;
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$__f_AuthenticatedInClientSide$lzy1 = null;
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$__f_AuthenticatedInClientSideButNotServerSide$lzy1 = null;
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$__f_Authenticated$lzy1 = null;
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$__f_$outer = outer;
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$__f_Loading$lzy1 = new $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading$(this);
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$__f_NotAuthenticated$lzy1 = new $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated$(this);
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$__f_AuthenticatedInClientSide$lzy1 = new $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide$(this);
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$__f_AuthenticatedInClientSideButNotServerSide$lzy1 = new $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide$(this);
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$__f_Authenticated$lzy1 = new $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated$(this);
}
export { $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$ as $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$ };
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$.prototype.constructor = $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$;
/** @constructor */
function $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$() {
}
export { $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$ as $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$ };
$h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$.prototype = $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$.prototype;
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$.prototype.splitByClientAuthState__Lcom_raquo_airstream_core_Signal__F2__F2__F2__F2__F2__Lcom_raquo_airstream_core_Signal = (function(signal, whenLoading, whenNotAuthenticated, whenAuthenticatedInClientSide, whenAuthenticatedInClientSideButNotServerSide, whenAuthenticated) {
  var this$7 = $m_Lcom_raquo_airstream_split_SplitMatchOneMacros$();
  var project = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((i) => {
    if (((i instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading) && (i.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading__f_$outer === this))) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), 0, i);
    }
    if (((i instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated) && (i.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated__f_$outer === this))) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), 1, i);
    }
    if (((i instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide) && (i.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_$outer === this))) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), 2, i);
    }
    if (((i instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide) && (i.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_$outer === this))) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), 3, i);
    }
    if (((i instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated) && (i.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_$outer === this))) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), 4, i);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(i);
  }));
  var parentObservable = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), signal, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var handlers = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([whenLoading, whenNotAuthenticated, whenAuthenticatedInClientSide, whenAuthenticatedInClientSideButNotServerSide, whenAuthenticated]));
  return $p_Lcom_raquo_airstream_split_SplitMatchOneMacros$__toSplittableOneObservable__Lcom_raquo_airstream_core_BaseObservable__sci_Seq__Lcom_raquo_airstream_core_Observable(this$7, parentObservable, handlers);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$.prototype.ordinal__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__I = (function(x$0) {
  if (((x$0 instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading) && (x$0.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading__f_$outer === this))) {
    return 0;
  }
  if (((x$0 instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated) && (x$0.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated__f_$outer === this))) {
    return 1;
  }
  if (((x$0 instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide) && (x$0.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_$outer === this))) {
    return 2;
  }
  if (((x$0 instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide) && (x$0.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_$outer === this))) {
    return 3;
  }
  if (((x$0 instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated) && (x$0.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_$outer === this))) {
    return 4;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$0);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__I(x);
});
var $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$, "framework.data.AuthPlatformForClientAndServerSideAuth$ClientAuthState$", ({
  Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$ as $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$ };
/** @constructor */
function $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated$(outer) {
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated$__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated$__f_$outer = outer;
}
export { $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated$ as $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated$ };
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated$.prototype.constructor = $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated$;
/** @constructor */
function $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated$() {
}
export { $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated$ as $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated$ };
$h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated$.prototype = $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated$.prototype;
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated$.prototype.apply__O__O__s_Option__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated = (function(clientData, serverData, maybeRedirectToAfterRegistration) {
  return new $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated(this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated$__f_$outer, clientData, serverData, maybeRedirectToAfterRegistration);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated$.prototype.toString__T = (function() {
  return "Authenticated";
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated$.prototype.fromProduct__s_Product__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated = (function(x$0) {
  var clientData$3 = x$0.productElement__I__O(0);
  var serverData$2 = x$0.productElement__I__O(1);
  var maybeRedirectToAfterRegistration$5 = x$0.productElement__I__O(2);
  return new $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated(this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated$__f_$outer, clientData$3, serverData$2, maybeRedirectToAfterRegistration$5);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated(p);
});
var $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated$, "framework.data.AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated$", ({
  Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated$ as $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated$ };
/** @constructor */
function $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide$(outer) {
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide$__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide$__f_$outer = outer;
}
export { $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide$ as $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide$ };
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide$.prototype.constructor = $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide$;
/** @constructor */
function $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide$() {
}
export { $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide$ as $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide$ };
$h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide$.prototype = $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide$.prototype;
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide$.prototype.apply__O__s_Option__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide = (function(clientData, maybeRedirectToAfterRegistration) {
  return new $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide(this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide$__f_$outer, clientData, maybeRedirectToAfterRegistration);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide$.prototype.toString__T = (function() {
  return "AuthenticatedInClientSide";
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide$.prototype.fromProduct__s_Product__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide = (function(x$0) {
  var clientData$1 = x$0.productElement__I__O(0);
  var maybeRedirectToAfterRegistration$3 = x$0.productElement__I__O(1);
  return new $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide(this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide$__f_$outer, clientData$1, maybeRedirectToAfterRegistration$3);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide(p);
});
var $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide$, "framework.data.AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide$", ({
  Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide$ as $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide$ };
/** @constructor */
function $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide$(outer) {
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide$__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide$__f_$outer = outer;
}
export { $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide$ as $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide$ };
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide$.prototype.constructor = $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide$;
/** @constructor */
function $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide$() {
}
export { $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide$ as $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide$ };
$h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide$.prototype = $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide$.prototype;
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide$.prototype.apply__O__O__s_Option__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide = (function(clientData, serverData, maybeRedirectToAfterRegistration) {
  return new $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide(this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide$__f_$outer, clientData, serverData, maybeRedirectToAfterRegistration);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide$.prototype.toString__T = (function() {
  return "AuthenticatedInClientSideButNotServerSide";
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide$.prototype.fromProduct__s_Product__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide = (function(x$0) {
  var clientData$2 = x$0.productElement__I__O(0);
  var serverData$1 = x$0.productElement__I__O(1);
  var maybeRedirectToAfterRegistration$4 = x$0.productElement__I__O(2);
  return new $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide(this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide$__f_$outer, clientData$2, serverData$1, maybeRedirectToAfterRegistration$4);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide(p);
});
var $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide$, "framework.data.AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide$", ({
  Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide$ as $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide$ };
/** @constructor */
function $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading$(outer) {
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading$__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading$__f_$outer = outer;
}
export { $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading$ as $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading$ };
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading$.prototype.constructor = $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading$;
/** @constructor */
function $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading$() {
}
export { $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading$ as $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading$ };
$h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading$.prototype = $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading$.prototype;
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading$.prototype.apply__s_Option__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading = (function(maybeRedirectToAfterRegistration) {
  return new $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading(this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading$__f_$outer, maybeRedirectToAfterRegistration);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading$.prototype.toString__T = (function() {
  return "Loading";
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading$.prototype.fromProduct__s_Product__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading = (function(x$0) {
  var maybeRedirectToAfterRegistration$1 = x$0.productElement__I__O(0);
  return new $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading(this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading$__f_$outer, maybeRedirectToAfterRegistration$1);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading(p);
});
var $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading$, "framework.data.AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading$", ({
  Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading$ as $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading$ };
/** @constructor */
function $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated$(outer) {
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated$__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated$__f_$outer = outer;
}
export { $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated$ as $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated$ };
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated$.prototype.constructor = $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated$;
/** @constructor */
function $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated$() {
}
export { $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated$ as $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated$ };
$h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated$.prototype = $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated$.prototype;
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated$.prototype.apply__s_Option__s_Option__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated = (function(failure, maybeRedirectToAfterRegistration) {
  return new $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated(this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated$__f_$outer, failure, maybeRedirectToAfterRegistration);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated$.prototype.toString__T = (function() {
  return "NotAuthenticated";
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated$.prototype.fromProduct__s_Product__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated = (function(x$0) {
  var failure$1 = x$0.productElement__I__O(0);
  var maybeRedirectToAfterRegistration$2 = x$0.productElement__I__O(1);
  return new $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated(this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated$__f_$outer, failure$1, maybeRedirectToAfterRegistration$2);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated(p);
});
var $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated$, "framework.data.AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated$", ({
  Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated$ as $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated$ };
/** @constructor */
function $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage$(outer) {
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage$__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage$__f_$outer = outer;
}
export { $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage$ as $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage$ };
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage$.prototype.constructor = $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage$;
/** @constructor */
function $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage$() {
}
export { $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage$ as $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage$ };
$h_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage$.prototype = $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage$.prototype;
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage$.prototype.apply__O__Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage = (function(page) {
  return new $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage(this.Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage$__f_$outer, page);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage$.prototype.toString__T = (function() {
  return "RootPage";
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage$.prototype.fromProduct__s_Product__Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage = (function(x$0) {
  var page$1 = x$0.productElement__I__O(0);
  return new $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage(this.Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage$__f_$outer, page$1);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage(p);
});
var $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage$, "framework.data.AuthPlatformForClientAndServerSideAuth$RootPage$", ({
  Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage$ as $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage$ };
function $p_Lframework_data_AuthToken$__decodeDevTokenString__T__Lio_circe_Decoder__s_util_Either($thiz, value, x$2) {
  var raw = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_StringOps$().stripPrefix$extension__T__T__T(value, $thiz.Lframework_data_AuthToken$__f_DevTokenPrefix);
  try {
    var bytes = $thiz.Lframework_data_AuthToken$__f_base64Decoder.decode__T__AB(raw);
    var charset = $thiz.Lframework_data_AuthToken$__f_charset;
    var value$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_String$().new__AB__Ljava_nio_charset_Charset__T(bytes, charset);
    var decodedJsonEither = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value$1);
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
    matchResult8: {
      var decodedJsonEither;
      var x17 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
      if ((!x17.isEmpty__Z())) {
        var x18 = x17.get__O();
        var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
        var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["Failed to decode dev token base64: ", ""]));
        var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
        var value$2 = $x_1.show$extension__s_StringContext__sci_Seq__T(sc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(x18.getMessage__T(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))])));
        var decodedJsonEither = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value$2);
        break matchResult8;
      }
      throw ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  }
  if ((decodedJsonEither instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
    var b = decodedJsonEither.s_util_Right__f_value;
    var this$10 = $m_Lio_circe_parser_package$();
    var x20 = $f_Lio_circe_Parser__decode__T__Lio_circe_Decoder__s_util_Either(this$10, b, x$2);
    if ((x20 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
      var err = x20.s_util_Left__f_value;
      var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
      var parts$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["Failed to decode dev token json: ", ""]));
      var sc$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts$1);
      var value$3 = $x_2.show$extension__s_StringContext__sci_Seq__T(sc$1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(err, $m_Lio_circe_Error$().Lio_circe_Error$__f_showError))])));
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value$3);
    }
    if ((x20 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
      var devToken = x20.s_util_Right__f_value;
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(devToken);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x20);
  } else {
    return decodedJsonEither;
  }
}
export { $p_Lframework_data_AuthToken$__decodeDevTokenString__T__Lio_circe_Decoder__s_util_Either as $p_Lframework_data_AuthToken$__decodeDevTokenString__T__Lio_circe_Decoder__s_util_Either };
/** @constructor */
function $c_Lframework_data_AuthToken$() {
  this.Lframework_data_AuthToken$__f_DevTokenPrefix = null;
  this.Lframework_data_AuthToken$__f_base64Encoder = null;
  this.Lframework_data_AuthToken$__f_base64Decoder = null;
  this.Lframework_data_AuthToken$__f_charset = null;
  $n_Lframework_data_AuthToken$ = this;
  this.Lframework_data_AuthToken$__f_DevTokenPrefix = "dev-token:";
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_Base64$();
  this.Lframework_data_AuthToken$__f_base64Encoder = this$1.ju_Base64$__f_urlSafeEncoder.withoutPadding__ju_Base64$Encoder();
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_Base64$();
  this.Lframework_data_AuthToken$__f_base64Decoder = this$2.ju_Base64$__f_urlSafeDecoder;
  this.Lframework_data_AuthToken$__f_charset = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_nio_charset_UTF\uff3f8$();
}
export { $c_Lframework_data_AuthToken$ as $c_Lframework_data_AuthToken$ };
$c_Lframework_data_AuthToken$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_AuthToken$.prototype.constructor = $c_Lframework_data_AuthToken$;
/** @constructor */
function $h_Lframework_data_AuthToken$() {
}
export { $h_Lframework_data_AuthToken$ as $h_Lframework_data_AuthToken$ };
$h_Lframework_data_AuthToken$.prototype = $c_Lframework_data_AuthToken$.prototype;
$c_Lframework_data_AuthToken$.prototype.encodeDevToken__O__Lio_circe_Encoder__T = (function(token, x$2) {
  var this$4 = x$2.apply__O__Lio_circe_Json(token);
  var json = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_Printer$().Lio_circe_Printer$__f_noSpaces.print__Lio_circe_Json__T(this$4);
  var encoded = this.Lframework_data_AuthToken$__f_base64Encoder.encodeToString__AB__T($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__getBytes__Ljava_nio_charset_Charset__AB(json, this.Lframework_data_AuthToken$__f_charset));
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
  var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["", "", ""]));
  var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
  return $x_1.show$extension__s_StringContext__sci_Seq__T(sc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(this.Lframework_data_AuthToken$__f_DevTokenPrefix, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString)), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(encoded, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))])));
});
$c_Lframework_data_AuthToken$.prototype.decodeString__T__Lio_circe_Decoder__s_util_Either = (function(value, x$2) {
  var prefix = this.Lframework_data_AuthToken$__f_DevTokenPrefix;
  if ((!(!value.startsWith(prefix)))) {
    var this$1 = $p_Lframework_data_AuthToken$__decodeDevTokenString__T__Lio_circe_Decoder__s_util_Either(this, value, x$2);
    if ((this$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
      var b = this$1.s_util_Right__f_value;
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(new $c_Lframework_data_AuthToken$Dev(b));
    } else {
      return this$1;
    }
  } else {
    var this$3 = $m_Lframework_data_JWT$package$JWT$().apply__T__s_util_Either(value);
    if ((this$3 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
      var b$1 = this$3.s_util_Right__f_value;
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(new $c_Lframework_data_AuthToken$Jwt(b$1));
    } else {
      return this$3;
    }
  }
});
$c_Lframework_data_AuthToken$.prototype.ordinal__O__I = (function(x) {
  return x.ordinal__I();
});
var $d_Lframework_data_AuthToken$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_AuthToken$, "framework.data.AuthToken$", ({
  Lframework_data_AuthToken$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lframework_data_AuthToken$ as $d_Lframework_data_AuthToken$ };
var $n_Lframework_data_AuthToken$;
function $m_Lframework_data_AuthToken$() {
  if ((!$n_Lframework_data_AuthToken$)) {
    $n_Lframework_data_AuthToken$ = new $c_Lframework_data_AuthToken$();
  }
  return $n_Lframework_data_AuthToken$;
}
export { $m_Lframework_data_AuthToken$ as $m_Lframework_data_AuthToken$ };
/** @constructor */
function $c_Lframework_data_CookieNameFor$() {
  this.Lframework_data_CookieNameFor$__f_given_Show_CookieNameFor$lzy1 = null;
  this.Lframework_data_CookieNameFor$__f_given_Show_CookieNameForbitmap$1 = false;
}
export { $c_Lframework_data_CookieNameFor$ as $c_Lframework_data_CookieNameFor$ };
$c_Lframework_data_CookieNameFor$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_CookieNameFor$.prototype.constructor = $c_Lframework_data_CookieNameFor$;
/** @constructor */
function $h_Lframework_data_CookieNameFor$() {
}
export { $h_Lframework_data_CookieNameFor$ as $h_Lframework_data_CookieNameFor$ };
$h_Lframework_data_CookieNameFor$.prototype = $c_Lframework_data_CookieNameFor$.prototype;
$c_Lframework_data_CookieNameFor$.prototype.given_Show_CookieNameFor__Lcats_Show = (function() {
  if ((!this.Lframework_data_CookieNameFor$__f_given_Show_CookieNameForbitmap$1)) {
    this.Lframework_data_CookieNameFor$__f_given_Show_CookieNameFor$lzy1 = new $c_Lframework_data_CookieNameFor$$anon$1();
    this.Lframework_data_CookieNameFor$__f_given_Show_CookieNameForbitmap$1 = true;
  }
  return this.Lframework_data_CookieNameFor$__f_given_Show_CookieNameFor$lzy1;
});
$c_Lframework_data_CookieNameFor$.prototype.fromProduct__s_Product__Lframework_data_CookieNameFor = (function(x$0) {
  var name$1 = x$0.productElement__I__O(0);
  return new $c_Lframework_data_CookieNameFor(name$1);
});
$c_Lframework_data_CookieNameFor$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lframework_data_CookieNameFor(p);
});
var $d_Lframework_data_CookieNameFor$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_CookieNameFor$, "framework.data.CookieNameFor$", ({
  Lframework_data_CookieNameFor$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lframework_data_CookieNameFor$ as $d_Lframework_data_CookieNameFor$ };
var $n_Lframework_data_CookieNameFor$;
function $m_Lframework_data_CookieNameFor$() {
  if ((!$n_Lframework_data_CookieNameFor$)) {
    $n_Lframework_data_CookieNameFor$ = new $c_Lframework_data_CookieNameFor$();
  }
  return $n_Lframework_data_CookieNameFor$;
}
export { $m_Lframework_data_CookieNameFor$ as $m_Lframework_data_CookieNameFor$ };
function $ct_Lframework_data_Email$package$Email$Validated__($thiz) {
  $thiz.Lframework_data_Email$package$Email$Validated__f_ValidationError$lzy1 = new $c_Lframework_data_Email$package$Email$Validated$ValidationError$($thiz);
  return $thiz;
}
export { $ct_Lframework_data_Email$package$Email$Validated__ as $ct_Lframework_data_Email$package$Email$Validated__ };
/** @constructor */
function $c_Lframework_data_Email$package$Email$Validated() {
  this.Lframework_data_Email$package$Email$Validated__f_defaultMake$lzy1 = null;
  this.Lframework_data_Email$package$Email$Validated__f_defaultMakebitmap$1 = false;
  this.Lframework_data_Email$package$Email$Validated__f_make$lzy1 = null;
  this.Lframework_data_Email$package$Email$Validated__f_makebitmap$1 = false;
  this.Lframework_data_Email$package$Email$Validated__f_validator$lzy1 = null;
  this.Lframework_data_Email$package$Email$Validated__f_validatorbitmap$1 = false;
  this.Lframework_data_Email$package$Email$Validated__f_given_Show_Type$lzy1 = null;
  this.Lframework_data_Email$package$Email$Validated__f_given_Show_Typebitmap$1 = false;
  this.Lframework_data_Email$package$Email$Validated__f_given_CanEqual1_Type$lzy1 = null;
  this.Lframework_data_Email$package$Email$Validated__f_given_CanEqual1_Typebitmap$1 = false;
  this.Lframework_data_Email$package$Email$Validated__f_RegexValidator$lzy1 = null;
  this.Lframework_data_Email$package$Email$Validated__f_RegexValidatorbitmap$1 = false;
  this.Lframework_data_Email$package$Email$Validated__f_ValidationError$lzy1 = null;
}
export { $c_Lframework_data_Email$package$Email$Validated as $c_Lframework_data_Email$package$Email$Validated };
$c_Lframework_data_Email$package$Email$Validated.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_Email$package$Email$Validated.prototype.constructor = $c_Lframework_data_Email$package$Email$Validated;
/** @constructor */
function $h_Lframework_data_Email$package$Email$Validated() {
}
export { $h_Lframework_data_Email$package$Email$Validated as $h_Lframework_data_Email$package$Email$Validated };
$h_Lframework_data_Email$package$Email$Validated.prototype = $c_Lframework_data_Email$package$Email$Validated.prototype;
$c_Lframework_data_Email$package$Email$Validated.prototype.defaultMake__Lyantl_INewtype$defaultMake$ = (function() {
  if ((!this.Lframework_data_Email$package$Email$Validated__f_defaultMakebitmap$1)) {
    this.Lframework_data_Email$package$Email$Validated__f_defaultMake$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$defaultMake$(this);
    this.Lframework_data_Email$package$Email$Validated__f_defaultMakebitmap$1 = true;
  }
  return this.Lframework_data_Email$package$Email$Validated__f_defaultMake$lzy1;
});
$c_Lframework_data_Email$package$Email$Validated.prototype.make__Lyantl_INewtype$make$ = (function() {
  if ((!this.Lframework_data_Email$package$Email$Validated__f_makebitmap$1)) {
    this.Lframework_data_Email$package$Email$Validated__f_make$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$make$(this);
    this.Lframework_data_Email$package$Email$Validated__f_makebitmap$1 = true;
  }
  return this.Lframework_data_Email$package$Email$Validated__f_make$lzy1;
});
$c_Lframework_data_Email$package$Email$Validated.prototype.resolveMake__Lyantl_Make = (function() {
  return this.defaultMake__Lyantl_INewtype$defaultMake$();
});
$c_Lframework_data_Email$package$Email$Validated.prototype.protected_unwrap__O__O = (function(wrapped) {
  return wrapped;
});
$c_Lframework_data_Email$package$Email$Validated.prototype.wrap__O__O = (function(underlying) {
  return underlying;
});
$c_Lframework_data_Email$package$Email$Validated.prototype.validator__Lyantl_Validator = (function() {
  if ((!this.Lframework_data_Email$package$Email$Validated__f_validatorbitmap$1)) {
    var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lyantl_Validator$();
    var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
    var $x_1 = this.RegexValidator__Lframework_data_Email$package$Email$Validated$RegexValidator$();
    var this$1 = this.validEmails__sci_Set();
    this.Lframework_data_Email$package$Email$Validated__f_validator$lzy1 = $x_3.of__sci_Seq__Lyantl_Validator($x_2.wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lyantl_ValidatorRule.getArrayOf().constr)([$x_1.anyOf__sci_Seq__Lyantl_ValidatorRule($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$1))])));
    this.Lframework_data_Email$package$Email$Validated__f_validatorbitmap$1 = true;
  }
  return this.Lframework_data_Email$package$Email$Validated__f_validator$lzy1;
});
$c_Lframework_data_Email$package$Email$Validated.prototype.validate__Lyantl_Validate = (function() {
  return this.validator__Lyantl_Validator();
});
$c_Lframework_data_Email$package$Email$Validated.prototype.given_Show_Type__Lcats_Show = (function() {
  if ((!this.Lframework_data_Email$package$Email$Validated__f_given_Show_Typebitmap$1)) {
    this.Lframework_data_Email$package$Email$Validated__f_given_Show_Type$lzy1 = new $c_Lframework_data_Email$package$Email$Validated$$anon$2(this);
    this.Lframework_data_Email$package$Email$Validated__f_given_Show_Typebitmap$1 = true;
  }
  return this.Lframework_data_Email$package$Email$Validated__f_given_Show_Type$lzy1;
});
$c_Lframework_data_Email$package$Email$Validated.prototype.given_CanEqual1_Type__s_CanEqual = (function() {
  if ((!this.Lframework_data_Email$package$Email$Validated__f_given_CanEqual1_Typebitmap$1)) {
    this.Lframework_data_Email$package$Email$Validated__f_given_CanEqual1_Type$lzy1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_CanEqual$derived$();
    this.Lframework_data_Email$package$Email$Validated__f_given_CanEqual1_Typebitmap$1 = true;
  }
  return this.Lframework_data_Email$package$Email$Validated__f_given_CanEqual1_Type$lzy1;
});
$c_Lframework_data_Email$package$Email$Validated.prototype.RegexValidator__Lframework_data_Email$package$Email$Validated$RegexValidator$ = (function() {
  if ((!this.Lframework_data_Email$package$Email$Validated__f_RegexValidatorbitmap$1)) {
    this.Lframework_data_Email$package$Email$Validated__f_RegexValidator$lzy1 = new $c_Lframework_data_Email$package$Email$Validated$RegexValidator$(this);
    this.Lframework_data_Email$package$Email$Validated__f_RegexValidatorbitmap$1 = true;
  }
  return this.Lframework_data_Email$package$Email$Validated__f_RegexValidator$lzy1;
});
/** @constructor */
function $c_Lframework_data_Email$package$Email$Validated$RegexValidator$(outer) {
  this.Lframework_data_Email$package$Email$Validated$RegexValidator$__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lframework_data_Email$package$Email$Validated$RegexValidator$__f_$outer = outer;
}
export { $c_Lframework_data_Email$package$Email$Validated$RegexValidator$ as $c_Lframework_data_Email$package$Email$Validated$RegexValidator$ };
$c_Lframework_data_Email$package$Email$Validated$RegexValidator$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_Email$package$Email$Validated$RegexValidator$.prototype.constructor = $c_Lframework_data_Email$package$Email$Validated$RegexValidator$;
/** @constructor */
function $h_Lframework_data_Email$package$Email$Validated$RegexValidator$() {
}
export { $h_Lframework_data_Email$package$Email$Validated$RegexValidator$ as $h_Lframework_data_Email$package$Email$Validated$RegexValidator$ };
$h_Lframework_data_Email$package$Email$Validated$RegexValidator$.prototype = $c_Lframework_data_Email$package$Email$Validated$RegexValidator$.prototype;
$c_Lframework_data_Email$package$Email$Validated$RegexValidator$.prototype.apply__s_util_matching_Regex__Lframework_data_Email$package$Email$Validated$RegexValidator = (function(regex) {
  return new $c_Lframework_data_Email$package$Email$Validated$RegexValidator(this.Lframework_data_Email$package$Email$Validated$RegexValidator$__f_$outer, regex);
});
$c_Lframework_data_Email$package$Email$Validated$RegexValidator$.prototype.anyOf__sci_Seq__Lyantl_ValidatorRule = (function(validEmails) {
  var f$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((email) => {
    var passes = validEmails.exists__F1__Z(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((email$2) => ((_$9) => _$9.isValid__T__Z(email$2)))(email)));
    if (passes) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    } else {
      var this$2 = validEmails.iterator__sc_Iterator();
      var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((email$3) => ((_$10) => _$10.validate__T__s_Option(email$3)))(email));
      var this$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$10(this$2, f);
      var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$11) => _$11.Lframework_data_Email$package$Email$Validated$ValidationError__f_failed));
      var this$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$10(this$3, f$1);
      var errors = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$4);
      var this$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_NonEmptyVector$().fromVector__sci_Vector__s_Option(errors);
      if (this$6.isEmpty__Z()) {
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      } else {
        var x0 = this$6.get__O();
        var failed = ((x0 === null) ? null : x0.Lcats_data_NonEmptyVector__f_toVector);
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(this.Lframework_data_Email$package$Email$Validated$RegexValidator$__f_$outer.Lframework_data_Email$package$Email$Validated__f_ValidationError$lzy1.apply__T__sci_Vector__Lframework_data_Email$package$Email$Validated$ValidationError(email, failed));
      }
    }
  }));
  return new $c_Lyantl_ValidatorRule$$anon$5(f$2);
});
$c_Lframework_data_Email$package$Email$Validated$RegexValidator$.prototype.fromProduct__s_Product__Lframework_data_Email$package$Email$Validated$RegexValidator = (function(x$0) {
  var regex$1 = x$0.productElement__I__O(0);
  return new $c_Lframework_data_Email$package$Email$Validated$RegexValidator(this.Lframework_data_Email$package$Email$Validated$RegexValidator$__f_$outer, regex$1);
});
$c_Lframework_data_Email$package$Email$Validated$RegexValidator$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lframework_data_Email$package$Email$Validated$RegexValidator(p);
});
var $d_Lframework_data_Email$package$Email$Validated$RegexValidator$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_Email$package$Email$Validated$RegexValidator$, "framework.data.Email$package$Email$Validated$RegexValidator$", ({
  Lframework_data_Email$package$Email$Validated$RegexValidator$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lframework_data_Email$package$Email$Validated$RegexValidator$ as $d_Lframework_data_Email$package$Email$Validated$RegexValidator$ };
/** @constructor */
function $c_Lframework_data_Email$package$Email$Validated$ValidationError$(outer) {
  this.Lframework_data_Email$package$Email$Validated$ValidationError$__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lframework_data_Email$package$Email$Validated$ValidationError$__f_$outer = outer;
}
export { $c_Lframework_data_Email$package$Email$Validated$ValidationError$ as $c_Lframework_data_Email$package$Email$Validated$ValidationError$ };
$c_Lframework_data_Email$package$Email$Validated$ValidationError$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_Email$package$Email$Validated$ValidationError$.prototype.constructor = $c_Lframework_data_Email$package$Email$Validated$ValidationError$;
/** @constructor */
function $h_Lframework_data_Email$package$Email$Validated$ValidationError$() {
}
export { $h_Lframework_data_Email$package$Email$Validated$ValidationError$ as $h_Lframework_data_Email$package$Email$Validated$ValidationError$ };
$h_Lframework_data_Email$package$Email$Validated$ValidationError$.prototype = $c_Lframework_data_Email$package$Email$Validated$ValidationError$.prototype;
$c_Lframework_data_Email$package$Email$Validated$ValidationError$.prototype.apply__T__sci_Vector__Lframework_data_Email$package$Email$Validated$ValidationError = (function(email, failed) {
  return new $c_Lframework_data_Email$package$Email$Validated$ValidationError(this.Lframework_data_Email$package$Email$Validated$ValidationError$__f_$outer, email, failed);
});
$c_Lframework_data_Email$package$Email$Validated$ValidationError$.prototype.toString__T = (function() {
  return "ValidationError";
});
$c_Lframework_data_Email$package$Email$Validated$ValidationError$.prototype.fromProduct__s_Product__Lframework_data_Email$package$Email$Validated$ValidationError = (function(x$0) {
  var email$2 = x$0.productElement__I__O(0);
  var ev$1 = x$0.productElement__I__O(1);
  var failed$1 = ((ev$1 === null) ? null : ev$1.Lcats_data_NonEmptyVector__f_toVector);
  return new $c_Lframework_data_Email$package$Email$Validated$ValidationError(this.Lframework_data_Email$package$Email$Validated$ValidationError$__f_$outer, email$2, failed$1);
});
$c_Lframework_data_Email$package$Email$Validated$ValidationError$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lframework_data_Email$package$Email$Validated$ValidationError(p);
});
var $d_Lframework_data_Email$package$Email$Validated$ValidationError$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_Email$package$Email$Validated$ValidationError$, "framework.data.Email$package$Email$Validated$ValidationError$", ({
  Lframework_data_Email$package$Email$Validated$ValidationError$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lframework_data_Email$package$Email$Validated$ValidationError$ as $d_Lframework_data_Email$package$Email$Validated$ValidationError$ };
function $s_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__ServerSentEvents__Lframework_data_EndpointSSEWithWS$ClientConnectionMode() {
  $m_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$();
  return $t_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__ServerSentEvents;
}
export { $s_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__ServerSentEvents__Lframework_data_EndpointSSEWithWS$ClientConnectionMode as $s_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__ServerSentEvents__Lframework_data_EndpointSSEWithWS$ClientConnectionMode };
function $s_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__WebSocket__Lframework_data_EndpointSSEWithWS$ClientConnectionMode() {
  $m_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$();
  return $t_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__WebSocket;
}
export { $s_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__WebSocket__Lframework_data_EndpointSSEWithWS$ClientConnectionMode as $s_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__WebSocket__Lframework_data_EndpointSSEWithWS$ClientConnectionMode };
/** @constructor */
function $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$() {
  this.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__f_given_Show_ClientConnectionMode$lzy1 = null;
  this.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__f_given_Show_ClientConnectionModebitmap$1 = false;
  this.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__f_defaultRecoveryTimeout = null;
  this.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__f_derived$CanEqual$lzy1 = null;
  this.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__f_derived$CanEqualbitmap$1 = false;
  this.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__f_derived$CirceCodec$lzy1 = null;
  this.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__f_derived$CirceCodecbitmap$1 = false;
  $n_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$ = this;
  $t_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__ServerSentEvents = new $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$$anon$1("ServerSentEvents", 0);
  $t_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__WebSocket = new $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$$anon$1("WebSocket", 1);
  var this$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_package$DurationInt(1);
  var unit = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_HOURS;
  var this$ = this$2.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$();
  var hi = (this$ >> 31);
  this.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__f_defaultRecoveryTimeout = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_FiniteDuration(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(this$, hi), unit);
}
export { $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$ as $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$ };
$c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$.prototype.constructor = $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$;
/** @constructor */
function $h_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$() {
}
export { $h_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$ as $h_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$ };
$h_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$.prototype = $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$.prototype;
$c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$.prototype.given_Show_ClientConnectionMode__Lcats_Show = (function() {
  if ((!this.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__f_given_Show_ClientConnectionModebitmap$1)) {
    this.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__f_given_Show_ClientConnectionMode$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$$anon$5();
    this.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__f_given_Show_ClientConnectionModebitmap$1 = true;
  }
  return this.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__f_given_Show_ClientConnectionMode$lzy1;
});
$c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$.prototype.derived$CanEqual__s_CanEqual = (function() {
  if ((!this.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__f_derived$CanEqualbitmap$1)) {
    this.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__f_derived$CanEqual$lzy1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_CanEqual$derived$();
    this.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__f_derived$CanEqualbitmap$1 = true;
  }
  return this.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__f_derived$CanEqual$lzy1;
});
$c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$.prototype.derived$CirceCodec__Lio_circe_Codec = (function() {
  if ((!this.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__f_derived$CirceCodecbitmap$1)) {
    var configuration$proxy1 = $m_Lio_circe_derivation_Configuration$().Lio_circe_derivation_Configuration$__f_default;
    var decoders$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
      var f$proxy1 = new $c_Lio_circe_derivation_DecoderDeriveSum(configuration$proxy1);
      var x$2$proxy1 = f$proxy1.Lio_circe_derivation_DecoderDeriveSum__f_x$1;
      var m = $s_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__ServerSentEvents__Lframework_data_EndpointSSEWithWS$ClientConnectionMode();
      var decoders = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$()));
      var labels = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      var fromProduct = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((p) => m))));
      var values = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_T$package$EmptyTuple$()));
      var defaults = new $c_Lio_circe_derivation_Default$$anon$1(values);
      var elem$21 = new $c_Lio_circe_derivation_ConfiguredDecoder$$anon$3(x$2$proxy1, "ServerSentEvents", fromProduct, decoders, labels, defaults);
      var x$2$proxy2 = f$proxy1.Lio_circe_derivation_DecoderDeriveSum__f_x$1;
      var m$3 = $s_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__WebSocket__Lframework_data_EndpointSSEWithWS$ClientConnectionMode();
      var decoders$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$()));
      var labels$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      var fromProduct$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((p$1) => m$3))));
      var values$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_T$package$EmptyTuple$()));
      var defaults$1 = new $c_Lio_circe_derivation_Default$$anon$1(values$1);
      var elem$21$2 = new $c_Lio_circe_derivation_ConfiguredDecoder$$anon$3(x$2$proxy2, "WebSocket", fromProduct$1, decoders$1, labels$1, defaults$1);
      var x$2$proxy3 = f$proxy1.Lio_circe_derivation_DecoderDeriveSum__f_x$1;
      var m$5 = $m_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback$();
      var decoders$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
        var f$proxy4 = new $c_Lio_circe_derivation_DecoderNotDeriveSum(x$2$proxy3);
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_Decoder$();
        var d = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_data_FrameworkDateTime$().circeCodec__Lio_circe_Codec();
        var decodeA = new $c_Lio_circe_Decoder$OptionDecoder(d);
        var this$9 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(decodeA, this$9);
      }));
      var this$10 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      var labels$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon("trySSEAgainAt", this$10);
      var fromProduct$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((p$2) => m$5.fromProduct__s_Product__Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback(p$2)))));
      var values$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
        var value = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        var _1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T1(_1);
      }));
      var defaults$2 = new $c_Lio_circe_derivation_Default$$anon$1(values$2);
      var elem$21$4 = new $c_Lio_circe_derivation_ConfiguredDecoder$$anon$3(x$2$proxy3, "SSEWithWebSocketFallback", fromProduct$2, decoders$2, labels$2, defaults$2);
      var this$16 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      var this$17 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem$21$4, this$16);
      var this$18 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem$21$2, this$17);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem$21, this$18);
    }));
    var encoders$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
      var f$proxy5 = new $c_Lio_circe_derivation_EncoderDeriveSum(configuration$proxy1);
      var x$2$proxy5 = f$proxy5.Lio_circe_derivation_EncoderDeriveSum__f_config;
      $s_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__ServerSentEvents__Lframework_data_EndpointSSEWithWS$ClientConnectionMode();
      var encoders = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$()));
      var labels$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      var elem$21$1 = new $c_Lio_circe_derivation_ConfiguredEncoder$$anon$3(x$2$proxy5, encoders, labels$3);
      var x$2$proxy6 = f$proxy5.Lio_circe_derivation_EncoderDeriveSum__f_config;
      $s_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__WebSocket__Lframework_data_EndpointSSEWithWS$ClientConnectionMode();
      var encoders$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$()));
      var labels$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      var elem$21$2$1 = new $c_Lio_circe_derivation_ConfiguredEncoder$$anon$3(x$2$proxy6, encoders$1, labels$4);
      var x$2$proxy7 = f$proxy5.Lio_circe_derivation_EncoderDeriveSum__f_config;
      var encoders$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
        var f$proxy8 = new $c_Lio_circe_derivation_EncoderNotDeriveSum(x$2$proxy7);
        var e = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_data_FrameworkDateTime$().circeCodec__Lio_circe_Codec();
        var encodeA = new $c_Lio_circe_Encoder$$anon$25(e);
        var this$22 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(encodeA, this$22);
      }));
      var this$23 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      var labels$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon("trySSEAgainAt", this$23);
      var elem$21$4$1 = new $c_Lio_circe_derivation_ConfiguredEncoder$$anon$3(x$2$proxy7, encoders$2, labels$5);
      var this$25 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      var this$26 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem$21$4$1, this$25);
      var this$27 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem$21$2$1, this$26);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem$21$1, this$27);
    }));
    var this$28 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var this$29 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon("SSEWithWebSocketFallback", this$28);
    var this$30 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon("WebSocket", this$29);
    var labels$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon("ServerSentEvents", this$30);
    var ordinal = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
      $m_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$();
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x) => x.ordinal__I()));
    }));
    var values$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
      var _1$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      var _2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      var _3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T3(_1$1, _2, _3);
    }));
    var defaults$3 = new $c_Lio_circe_derivation_Default$$anon$1(values$3);
    this.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__f_derived$CirceCodec$lzy1 = new $c_Lio_circe_derivation_ConfiguredCodec$$anon$4(configuration$proxy1, "ClientConnectionMode", ordinal, decoders$3, encoders$3, labels$6, defaults$3);
    this.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__f_derived$CirceCodecbitmap$1 = true;
  }
  return this.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__f_derived$CirceCodec$lzy1;
});
$c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$.prototype.ordinal__O__I = (function(x) {
  return x.ordinal__I();
});
var $d_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$, "framework.data.EndpointSSEWithWS$ClientConnectionMode$", ({
  Lframework_data_EndpointSSEWithWS$ClientConnectionMode$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$ as $d_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$ };
var $n_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$;
function $m_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$() {
  if ((!$n_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$)) {
    $n_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$ = new $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$();
  }
  return $n_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$;
}
export { $m_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$ as $m_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$ };
/** @constructor */
function $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback$() {
}
export { $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback$ as $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback$ };
$c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback$.prototype.constructor = $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback$;
/** @constructor */
function $h_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback$() {
}
export { $h_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback$ as $h_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback$ };
$h_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback$.prototype = $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback$.prototype;
$c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback$.prototype.toString__T = (function() {
  return "SSEWithWebSocketFallback";
});
$c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback$.prototype.fromProduct__s_Product__Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback = (function(x$0) {
  var trySSEAgainAt$1 = x$0.productElement__I__O(0);
  return new $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback(trySSEAgainAt$1);
});
$c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback(p);
});
var $d_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback$, "framework.data.EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback$", ({
  Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback$ as $d_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback$ };
var $n_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback$;
function $m_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback$() {
  if ((!$n_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback$)) {
    $n_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback$ = new $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback$();
  }
  return $n_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback$;
}
export { $m_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback$ as $m_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback$ };
/** @constructor */
function $c_Lframework_data_FrameworkDateTime$Newtype$$anon$4(outer) {
  this.Lframework_data_FrameworkDateTime$Newtype$$anon$4__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lframework_data_FrameworkDateTime$Newtype$$anon$4__f_$outer = outer;
}
export { $c_Lframework_data_FrameworkDateTime$Newtype$$anon$4 as $c_Lframework_data_FrameworkDateTime$Newtype$$anon$4 };
$c_Lframework_data_FrameworkDateTime$Newtype$$anon$4.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_s_Conversion();
$c_Lframework_data_FrameworkDateTime$Newtype$$anon$4.prototype.constructor = $c_Lframework_data_FrameworkDateTime$Newtype$$anon$4;
/** @constructor */
function $h_Lframework_data_FrameworkDateTime$Newtype$$anon$4() {
}
export { $h_Lframework_data_FrameworkDateTime$Newtype$$anon$4 as $h_Lframework_data_FrameworkDateTime$Newtype$$anon$4 };
$h_Lframework_data_FrameworkDateTime$Newtype$$anon$4.prototype = $c_Lframework_data_FrameworkDateTime$Newtype$$anon$4.prototype;
$c_Lframework_data_FrameworkDateTime$Newtype$$anon$4.prototype.apply__Ljava_time_LocalDateTime__Ljava_time_LocalDateTime = (function(v) {
  var v$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lframework_data_FrameworkDateTime(v);
  return v$1.Lframework_data_FrameworkDateTime__f_ldt;
});
$c_Lframework_data_FrameworkDateTime$Newtype$$anon$4.prototype.apply__O__O = (function(x) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lframework_data_FrameworkDateTime(this.apply__Ljava_time_LocalDateTime__Ljava_time_LocalDateTime(((x === null) ? null : x.Lframework_data_FrameworkDateTime__f_ldt)));
});
var $d_Lframework_data_FrameworkDateTime$Newtype$$anon$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_FrameworkDateTime$Newtype$$anon$4, "framework.data.FrameworkDateTime$Newtype$$anon$4", ({
  Lframework_data_FrameworkDateTime$Newtype$$anon$4: 1,
  s_Conversion: 1,
  F1: 1
}));
export { $d_Lframework_data_FrameworkDateTime$Newtype$$anon$4 as $d_Lframework_data_FrameworkDateTime$Newtype$$anon$4 };
/** @constructor */
function $c_Lframework_data_IndicatorStates$ListIndicatorState$() {
}
export { $c_Lframework_data_IndicatorStates$ListIndicatorState$ as $c_Lframework_data_IndicatorStates$ListIndicatorState$ };
$c_Lframework_data_IndicatorStates$ListIndicatorState$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_IndicatorStates$ListIndicatorState$.prototype.constructor = $c_Lframework_data_IndicatorStates$ListIndicatorState$;
/** @constructor */
function $h_Lframework_data_IndicatorStates$ListIndicatorState$() {
}
export { $h_Lframework_data_IndicatorStates$ListIndicatorState$ as $h_Lframework_data_IndicatorStates$ListIndicatorState$ };
$h_Lframework_data_IndicatorStates$ListIndicatorState$.prototype = $c_Lframework_data_IndicatorStates$ListIndicatorState$.prototype;
$c_Lframework_data_IndicatorStates$ListIndicatorState$.prototype.empty__Lframework_data_IndicatorStates$ListIndicatorState = (function() {
  var unreadItems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Set$EmptySet$();
  var currentlyIn = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  return new $c_Lframework_data_IndicatorStates$ListIndicatorState(unreadItems, currentlyIn);
});
$c_Lframework_data_IndicatorStates$ListIndicatorState$.prototype.given_Empty_ListIndicatorState__Lalleycats_Empty = (function() {
  var a = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => $m_Lframework_data_IndicatorStates$ListIndicatorState$().empty__Lframework_data_IndicatorStates$ListIndicatorState()));
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lalleycats_Empty$$anon$1(a);
});
$c_Lframework_data_IndicatorStates$ListIndicatorState$.prototype.fromProduct__s_Product__Lframework_data_IndicatorStates$ListIndicatorState = (function(x$0) {
  var unreadItems$8 = x$0.productElement__I__O(0);
  var currentlyIn$2 = x$0.productElement__I__O(1);
  return new $c_Lframework_data_IndicatorStates$ListIndicatorState(unreadItems$8, currentlyIn$2);
});
$c_Lframework_data_IndicatorStates$ListIndicatorState$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lframework_data_IndicatorStates$ListIndicatorState(p);
});
var $d_Lframework_data_IndicatorStates$ListIndicatorState$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_IndicatorStates$ListIndicatorState$, "framework.data.IndicatorStates$ListIndicatorState$", ({
  Lframework_data_IndicatorStates$ListIndicatorState$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lframework_data_IndicatorStates$ListIndicatorState$ as $d_Lframework_data_IndicatorStates$ListIndicatorState$ };
var $n_Lframework_data_IndicatorStates$ListIndicatorState$;
function $m_Lframework_data_IndicatorStates$ListIndicatorState$() {
  if ((!$n_Lframework_data_IndicatorStates$ListIndicatorState$)) {
    $n_Lframework_data_IndicatorStates$ListIndicatorState$ = new $c_Lframework_data_IndicatorStates$ListIndicatorState$();
  }
  return $n_Lframework_data_IndicatorStates$ListIndicatorState$;
}
export { $m_Lframework_data_IndicatorStates$ListIndicatorState$ as $m_Lframework_data_IndicatorStates$ListIndicatorState$ };
function $s_Lframework_data_WebPushSubscription$__framework$data$WebPushSubscription$Keys$$anon$1$$_$allTypeArguments$1__Lmagnolia1_TypeInfo__sci_Seq(tn) {
  var this$1 = tn.Lmagnolia1_TypeInfo__f_typeParams.toList__sci_List();
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
    var x0 = rest.head__O();
    var this$2 = $s_Lframework_data_WebPushSubscription$__framework$data$WebPushSubscription$Keys$$anon$1$$_$allTypeArguments$1__Lmagnolia1_TypeInfo__sci_Seq(x0);
    var it = this$2.prepended__O__O(x0).iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(it.next__O(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.sci_$colon$colon__f_next = nx;
      }
      t = nx;
    }
    rest = rest.tail__O();
  }
  return ((h === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$() : h);
}
export { $s_Lframework_data_WebPushSubscription$__framework$data$WebPushSubscription$Keys$$anon$1$$_$allTypeArguments$1__Lmagnolia1_TypeInfo__sci_Seq as $s_Lframework_data_WebPushSubscription$__framework$data$WebPushSubscription$Keys$$anon$1$$_$allTypeArguments$1__Lmagnolia1_TypeInfo__sci_Seq };
function $s_Lframework_data_WebPushSubscription$__framework$data$WebPushSubscription$$anon$8$$_$allTypeArguments$2__Lmagnolia1_TypeInfo__sci_Seq(tn) {
  var this$1 = tn.Lmagnolia1_TypeInfo__f_typeParams.toList__sci_List();
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
    var x0 = rest.head__O();
    var this$2 = $s_Lframework_data_WebPushSubscription$__framework$data$WebPushSubscription$$anon$8$$_$allTypeArguments$2__Lmagnolia1_TypeInfo__sci_Seq(x0);
    var it = this$2.prepended__O__O(x0).iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(it.next__O(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.sci_$colon$colon__f_next = nx;
      }
      t = nx;
    }
    rest = rest.tail__O();
  }
  return ((h === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$() : h);
}
export { $s_Lframework_data_WebPushSubscription$__framework$data$WebPushSubscription$$anon$8$$_$allTypeArguments$2__Lmagnolia1_TypeInfo__sci_Seq as $s_Lframework_data_WebPushSubscription$__framework$data$WebPushSubscription$$anon$8$$_$allTypeArguments$2__Lmagnolia1_TypeInfo__sci_Seq };
/** @constructor */
function $c_Lframework_data_WebPushSubscription$() {
  this.Lframework_data_WebPushSubscription$__f_derived$Schema$lzy2 = null;
  this.Lframework_data_WebPushSubscription$__f_derived$Schemabitmap$2 = false;
  this.Lframework_data_WebPushSubscription$__f_derived$CirceCodec$lzy2 = null;
  this.Lframework_data_WebPushSubscription$__f_derived$CirceCodecbitmap$2 = false;
}
export { $c_Lframework_data_WebPushSubscription$ as $c_Lframework_data_WebPushSubscription$ };
$c_Lframework_data_WebPushSubscription$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_WebPushSubscription$.prototype.constructor = $c_Lframework_data_WebPushSubscription$;
/** @constructor */
function $h_Lframework_data_WebPushSubscription$() {
}
export { $h_Lframework_data_WebPushSubscription$ as $h_Lframework_data_WebPushSubscription$ };
$h_Lframework_data_WebPushSubscription$.prototype = $c_Lframework_data_WebPushSubscription$.prototype;
$c_Lframework_data_WebPushSubscription$.prototype.derived$Schema__Lsttp_tapir_Schema = (function() {
  if ((!this.Lframework_data_WebPushSubscription$__f_derived$Schemabitmap$2)) {
    var SchemaMagnoliaDerivation_this = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var m$proxy2 = $m_Lframework_data_WebPushSubscription$();
    var derivation = new $c_Lframework_data_WebPushSubscription$$anon$8(SchemaMagnoliaDerivation_this);
    var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var factory = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$();
    var factory$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapFactory$ToFactory(factory);
    var annotations$proxy2 = factory$1.fromSpecific__sc_IterableOnce__O(this$2);
    var _2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), "endpoint", _2);
    var _2$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var this$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon($x_1, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), "keys", _2$1), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$()));
    var factory$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$();
    var factory$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapFactory$ToFactory(factory$2);
    var inheritedAnnotations$proxy2 = factory$3.fromSpecific__sc_IterableOnce__O(this$6);
    var this$8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var factory$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$();
    var factory$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapFactory$ToFactory(factory$4);
    var typeAnnotations$proxy2 = factory$5.fromSpecific__sc_IterableOnce__O(this$8);
    var this$12 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), "endpoint", false), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), "keys", false), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$()));
    var factory$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$();
    var factory$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapFactory$ToFactory(factory$6);
    var repeated$proxy2 = factory$7.fromSpecific__sc_IterableOnce__O(this$12);
    var _2$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), "endpoint", _2$2);
    var _2$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    var this$16 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon($x_2, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), "keys", _2$3), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$()));
    var factory$8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$();
    var factory$9 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapFactory$ToFactory(factory$8);
    var defaults$proxy2 = factory$9.fromSpecific__sc_IterableOnce__O(this$16);
    var tc = new $c_Lframework_data_WebPushSubscription$$anon$11();
    matchResult25: {
      var d;
      var $x_3 = defaults$proxy2.get__O__s_Option("endpoint");
      var this$17 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_$less$colon$less$();
      var x105 = $x_3.flatten__s_$less$colon$less__s_Option(this$17.s_$less$colon$less$__f_singleton);
      if ((x105 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
        var evaluator = x105.s_Some__f_value;
        var d = new $c_Lframework_data_WebPushSubscription$$anon$12(evaluator);
        break matchResult25;
      }
      var d = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lmagnolia1_CaseClassDerivation$().Lmagnolia1_CaseClassDerivation$__f_returningNone;
    }
    var this$18 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lmagnolia1_CaseClassDerivation$();
    var tc$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lmagnolia1_CallByNeed$().createLazy__F0__Lmagnolia1_CallByNeed(tc);
    var d$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lmagnolia1_CallByNeed$().createValueEvaluator__F0__Lmagnolia1_CallByNeed(d);
    var elem$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$p_Lmagnolia1_CaseClassDerivation$__paramFromMaps__T__Lmagnolia1_CallByNeed__Lmagnolia1_CallByNeed__sci_Map__sci_Map__sci_Map__sci_Map__I__Lmagnolia1_CaseClass$Param(this$18, "endpoint", tc$1, d$1, repeated$proxy2, annotations$proxy2, inheritedAnnotations$proxy2, typeAnnotations$proxy2, 0);
    var tc$2 = new $c_Lframework_data_WebPushSubscription$$anon$13();
    matchResult26: {
      var d$2;
      var $x_4 = defaults$proxy2.get__O__s_Option("keys");
      var this$19 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_$less$colon$less$();
      var x108 = $x_4.flatten__s_$less$colon$less__s_Option(this$19.s_$less$colon$less$__f_singleton);
      if ((x108 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
        var evaluator$2 = x108.s_Some__f_value;
        var d$2 = new $c_Lframework_data_WebPushSubscription$$anon$14(evaluator$2);
        break matchResult26;
      }
      var d$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lmagnolia1_CaseClassDerivation$().Lmagnolia1_CaseClassDerivation$__f_returningNone;
    }
    var this$20 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lmagnolia1_CaseClassDerivation$();
    var tc$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lmagnolia1_CallByNeed$().createLazy__F0__Lmagnolia1_CallByNeed(tc$2);
    var d$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lmagnolia1_CallByNeed$().createValueEvaluator__F0__Lmagnolia1_CallByNeed(d$2);
    var elem$1$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$p_Lmagnolia1_CaseClassDerivation$__paramFromMaps__T__Lmagnolia1_CallByNeed__Lmagnolia1_CallByNeed__sci_Map__sci_Map__sci_Map__sci_Map__I__Lmagnolia1_CaseClass$Param(this$20, "keys", tc$3, d$3, repeated$proxy2, annotations$proxy2, inheritedAnnotations$proxy2, typeAnnotations$proxy2, 1);
    var this$21 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var this$22 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem$1$2, this$21);
    var xs = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem$1, this$22);
    var len = xs.length__I();
    var array = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lmagnolia1_CaseClass$Param.getArrayOf().constr)(len);
    var iterator = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_StrictOptimizedLinearSeqOps$$anon$1(xs);
    var i = 0;
    while (iterator.hasNext__Z()) {
      array.u[i] = iterator.next__O();
      i = ((1 + i) | 0);
    }
    var typeParams = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var $x_5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lmagnolia1_TypeInfo("framework.data", "WebPushSubscription", typeParams);
    var xs$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var len$1 = xs$1.length__I();
    var array$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(len$1);
    var iterator$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
    var i$1 = 0;
    while (iterator$1.hasNext__Z()) {
      array$1.u[i$1] = iterator$1.next__O();
      i$1 = ((1 + i$1) | 0);
    }
    var xs$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var len$2 = xs$2.length__I();
    var array$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(len$2);
    var iterator$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
    var i$2 = 0;
    while (iterator$2.hasNext__Z()) {
      array$2.u[i$2] = iterator$2.next__O();
      i$2 = ((1 + i$2) | 0);
    }
    var xs$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var len$3 = xs$3.length__I();
    var array$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(len$3);
    var iterator$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
    var i$3 = 0;
    while (iterator$3.hasNext__Z()) {
      array$3.u[i$3] = iterator$3.next__O();
      i$3 = ((1 + i$3) | 0);
    }
    var caseClass = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lmagnolia1_CaseClassDerivation$ProductCaseClass($x_5, false, false, array, array$1, array$2, array$3, m$proxy2);
    this.Lframework_data_WebPushSubscription$__f_derived$Schema$lzy2 = derivation.join__Lmagnolia1_CaseClass__Lsttp_tapir_Schema(caseClass);
    this.Lframework_data_WebPushSubscription$__f_derived$Schemabitmap$2 = true;
  }
  return this.Lframework_data_WebPushSubscription$__f_derived$Schema$lzy2;
});
$c_Lframework_data_WebPushSubscription$.prototype.derived$CirceCodec__Lio_circe_Codec = (function() {
  if ((!this.Lframework_data_WebPushSubscription$__f_derived$CirceCodecbitmap$2)) {
    var configuration$proxy2 = $m_Lio_circe_derivation_Configuration$().Lio_circe_derivation_Configuration$__f_default;
    var decoders = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
      var f$proxy3 = new $c_Lio_circe_derivation_DecoderNotDeriveSum(configuration$proxy2);
      var decodeA = $m_Lframework_prelude_circe$package$().given_CirceCodec_Uri__Lio_circe_Codec();
      var decodeA$2 = $m_Lframework_data_WebPushSubscription$Keys$().derived$CirceCodec__Lio_circe_Codec();
      var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      var this$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(decodeA$2, this$2);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(decodeA, this$3);
    }));
    var encoders = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
      var f$proxy4 = new $c_Lio_circe_derivation_EncoderNotDeriveSum(configuration$proxy2);
      var encodeA = $m_Lframework_prelude_circe$package$().given_CirceCodec_Uri__Lio_circe_Codec();
      var encodeA$2 = $m_Lframework_data_WebPushSubscription$Keys$().derived$CirceCodec__Lio_circe_Codec();
      var this$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      var this$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(encodeA$2, this$4);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(encodeA, this$5);
    }));
    var this$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var this$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon("keys", this$6);
    var labels = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon("endpoint", this$7);
    var fromProduct = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
      var \u03b41$ = $m_Lframework_data_WebPushSubscription$();
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((p) => \u03b41$.fromProduct__s_Product__Lframework_data_WebPushSubscription(p)));
    }));
    var values = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
      var _1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      var _2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, _2);
    }));
    var defaults = new $c_Lio_circe_derivation_Default$$anon$1(values);
    this.Lframework_data_WebPushSubscription$__f_derived$CirceCodec$lzy2 = new $c_Lio_circe_derivation_ConfiguredCodec$$anon$3(configuration$proxy2, "WebPushSubscription", fromProduct, decoders, encoders, labels, defaults);
    this.Lframework_data_WebPushSubscription$__f_derived$CirceCodecbitmap$2 = true;
  }
  return this.Lframework_data_WebPushSubscription$__f_derived$CirceCodec$lzy2;
});
$c_Lframework_data_WebPushSubscription$.prototype.fromProduct__s_Product__Lframework_data_WebPushSubscription = (function(x$0) {
  var endpoint$1 = x$0.productElement__I__O(0);
  var keys$1 = x$0.productElement__I__O(1);
  return new $c_Lframework_data_WebPushSubscription(endpoint$1, keys$1);
});
$c_Lframework_data_WebPushSubscription$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lframework_data_WebPushSubscription(p);
});
var $d_Lframework_data_WebPushSubscription$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_WebPushSubscription$, "framework.data.WebPushSubscription$", ({
  Lframework_data_WebPushSubscription$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lframework_data_WebPushSubscription$ as $d_Lframework_data_WebPushSubscription$ };
var $n_Lframework_data_WebPushSubscription$;
function $m_Lframework_data_WebPushSubscription$() {
  if ((!$n_Lframework_data_WebPushSubscription$)) {
    $n_Lframework_data_WebPushSubscription$ = new $c_Lframework_data_WebPushSubscription$();
  }
  return $n_Lframework_data_WebPushSubscription$;
}
export { $m_Lframework_data_WebPushSubscription$ as $m_Lframework_data_WebPushSubscription$ };
/** @constructor */
function $c_Lframework_data_WebPushSubscription$Keys$() {
  this.Lframework_data_WebPushSubscription$Keys$__f_derived$Schema$lzy1 = null;
  this.Lframework_data_WebPushSubscription$Keys$__f_derived$Schemabitmap$1 = false;
  this.Lframework_data_WebPushSubscription$Keys$__f_derived$CirceCodec$lzy1 = null;
  this.Lframework_data_WebPushSubscription$Keys$__f_derived$CirceCodecbitmap$1 = false;
}
export { $c_Lframework_data_WebPushSubscription$Keys$ as $c_Lframework_data_WebPushSubscription$Keys$ };
$c_Lframework_data_WebPushSubscription$Keys$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_WebPushSubscription$Keys$.prototype.constructor = $c_Lframework_data_WebPushSubscription$Keys$;
/** @constructor */
function $h_Lframework_data_WebPushSubscription$Keys$() {
}
export { $h_Lframework_data_WebPushSubscription$Keys$ as $h_Lframework_data_WebPushSubscription$Keys$ };
$h_Lframework_data_WebPushSubscription$Keys$.prototype = $c_Lframework_data_WebPushSubscription$Keys$.prototype;
$c_Lframework_data_WebPushSubscription$Keys$.prototype.toString__T = (function() {
  return "Keys";
});
$c_Lframework_data_WebPushSubscription$Keys$.prototype.derived$Schema__Lsttp_tapir_Schema = (function() {
  if ((!this.Lframework_data_WebPushSubscription$Keys$__f_derived$Schemabitmap$1)) {
    var SchemaMagnoliaDerivation_this = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var m$proxy1 = $m_Lframework_data_WebPushSubscription$Keys$();
    var derivation = new $c_Lframework_data_WebPushSubscription$Keys$$anon$1(SchemaMagnoliaDerivation_this);
    var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var factory = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$();
    var factory$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapFactory$ToFactory(factory);
    var annotations$proxy1 = factory$1.fromSpecific__sc_IterableOnce__O(this$2);
    var _2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), "auth", _2);
    var _2$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var this$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon($x_1, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), "p256dh", _2$1), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$()));
    var factory$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$();
    var factory$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapFactory$ToFactory(factory$2);
    var inheritedAnnotations$proxy1 = factory$3.fromSpecific__sc_IterableOnce__O(this$6);
    var this$8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var factory$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$();
    var factory$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapFactory$ToFactory(factory$4);
    var typeAnnotations$proxy1 = factory$5.fromSpecific__sc_IterableOnce__O(this$8);
    var this$12 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), "auth", false), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), "p256dh", false), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$()));
    var factory$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$();
    var factory$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapFactory$ToFactory(factory$6);
    var repeated$proxy1 = factory$7.fromSpecific__sc_IterableOnce__O(this$12);
    var _2$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), "auth", _2$2);
    var _2$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    var this$16 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon($x_2, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), "p256dh", _2$3), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$()));
    var factory$8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$();
    var factory$9 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapFactory$ToFactory(factory$8);
    var defaults$proxy1 = factory$9.fromSpecific__sc_IterableOnce__O(this$16);
    var tc = new $c_Lframework_data_WebPushSubscription$Keys$$anon$4();
    matchResult15: {
      var d;
      var $x_3 = defaults$proxy1.get__O__s_Option("auth");
      var this$17 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_$less$colon$less$();
      var x54 = $x_3.flatten__s_$less$colon$less__s_Option(this$17.s_$less$colon$less$__f_singleton);
      if ((x54 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
        var evaluator = x54.s_Some__f_value;
        var d = new $c_Lframework_data_WebPushSubscription$Keys$$anon$5(evaluator);
        break matchResult15;
      }
      var d = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lmagnolia1_CaseClassDerivation$().Lmagnolia1_CaseClassDerivation$__f_returningNone;
    }
    var this$18 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lmagnolia1_CaseClassDerivation$();
    var tc$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lmagnolia1_CallByNeed$().createLazy__F0__Lmagnolia1_CallByNeed(tc);
    var d$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lmagnolia1_CallByNeed$().createValueEvaluator__F0__Lmagnolia1_CallByNeed(d);
    var elem$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$p_Lmagnolia1_CaseClassDerivation$__paramFromMaps__T__Lmagnolia1_CallByNeed__Lmagnolia1_CallByNeed__sci_Map__sci_Map__sci_Map__sci_Map__I__Lmagnolia1_CaseClass$Param(this$18, "auth", tc$1, d$1, repeated$proxy1, annotations$proxy1, inheritedAnnotations$proxy1, typeAnnotations$proxy1, 0);
    var tc$2 = new $c_Lframework_data_WebPushSubscription$Keys$$anon$6();
    matchResult16: {
      var d$2;
      var $x_4 = defaults$proxy1.get__O__s_Option("p256dh");
      var this$19 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_$less$colon$less$();
      var x57 = $x_4.flatten__s_$less$colon$less__s_Option(this$19.s_$less$colon$less$__f_singleton);
      if ((x57 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
        var evaluator$2 = x57.s_Some__f_value;
        var d$2 = new $c_Lframework_data_WebPushSubscription$Keys$$anon$7(evaluator$2);
        break matchResult16;
      }
      var d$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lmagnolia1_CaseClassDerivation$().Lmagnolia1_CaseClassDerivation$__f_returningNone;
    }
    var this$20 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lmagnolia1_CaseClassDerivation$();
    var tc$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lmagnolia1_CallByNeed$().createLazy__F0__Lmagnolia1_CallByNeed(tc$2);
    var d$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lmagnolia1_CallByNeed$().createValueEvaluator__F0__Lmagnolia1_CallByNeed(d$2);
    var elem$1$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$p_Lmagnolia1_CaseClassDerivation$__paramFromMaps__T__Lmagnolia1_CallByNeed__Lmagnolia1_CallByNeed__sci_Map__sci_Map__sci_Map__sci_Map__I__Lmagnolia1_CaseClass$Param(this$20, "p256dh", tc$3, d$3, repeated$proxy1, annotations$proxy1, inheritedAnnotations$proxy1, typeAnnotations$proxy1, 1);
    var this$21 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var this$22 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem$1$2, this$21);
    var xs = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem$1, this$22);
    var len = xs.length__I();
    var array = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lmagnolia1_CaseClass$Param.getArrayOf().constr)(len);
    var iterator = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_StrictOptimizedLinearSeqOps$$anon$1(xs);
    var i = 0;
    while (iterator.hasNext__Z()) {
      array.u[i] = iterator.next__O();
      i = ((1 + i) | 0);
    }
    var typeParams = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var $x_5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lmagnolia1_TypeInfo("framework.data.WebPushSubscription", "Keys", typeParams);
    var xs$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var len$1 = xs$1.length__I();
    var array$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(len$1);
    var iterator$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
    var i$1 = 0;
    while (iterator$1.hasNext__Z()) {
      array$1.u[i$1] = iterator$1.next__O();
      i$1 = ((1 + i$1) | 0);
    }
    var xs$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var len$2 = xs$2.length__I();
    var array$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(len$2);
    var iterator$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
    var i$2 = 0;
    while (iterator$2.hasNext__Z()) {
      array$2.u[i$2] = iterator$2.next__O();
      i$2 = ((1 + i$2) | 0);
    }
    var xs$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var len$3 = xs$3.length__I();
    var array$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(len$3);
    var iterator$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
    var i$3 = 0;
    while (iterator$3.hasNext__Z()) {
      array$3.u[i$3] = iterator$3.next__O();
      i$3 = ((1 + i$3) | 0);
    }
    var caseClass = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lmagnolia1_CaseClassDerivation$ProductCaseClass($x_5, false, false, array, array$1, array$2, array$3, m$proxy1);
    this.Lframework_data_WebPushSubscription$Keys$__f_derived$Schema$lzy1 = derivation.join__Lmagnolia1_CaseClass__Lsttp_tapir_Schema(caseClass);
    this.Lframework_data_WebPushSubscription$Keys$__f_derived$Schemabitmap$1 = true;
  }
  return this.Lframework_data_WebPushSubscription$Keys$__f_derived$Schema$lzy1;
});
$c_Lframework_data_WebPushSubscription$Keys$.prototype.derived$CirceCodec__Lio_circe_Codec = (function() {
  if ((!this.Lframework_data_WebPushSubscription$Keys$__f_derived$CirceCodecbitmap$1)) {
    var configuration$proxy1 = $m_Lio_circe_derivation_Configuration$().Lio_circe_derivation_Configuration$__f_default;
    var decoders = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
      var f$proxy1 = new $c_Lio_circe_derivation_DecoderNotDeriveSum(configuration$proxy1);
      var decodeA = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
      var decodeA$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
      var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      var this$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(decodeA$2, this$2);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(decodeA, this$3);
    }));
    var encoders = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
      var f$proxy2 = new $c_Lio_circe_derivation_EncoderNotDeriveSum(configuration$proxy1);
      var encodeA = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
      var encodeA$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
      var this$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      var this$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(encodeA$2, this$4);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(encodeA, this$5);
    }));
    var this$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var this$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon("p256dh", this$6);
    var labels = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon("auth", this$7);
    var fromProduct = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
      var \u03b41$ = $m_Lframework_data_WebPushSubscription$Keys$();
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((p) => \u03b41$.fromProduct__s_Product__Lframework_data_WebPushSubscription$Keys(p)));
    }));
    var values = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
      var _1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      var _2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, _2);
    }));
    var defaults = new $c_Lio_circe_derivation_Default$$anon$1(values);
    this.Lframework_data_WebPushSubscription$Keys$__f_derived$CirceCodec$lzy1 = new $c_Lio_circe_derivation_ConfiguredCodec$$anon$3(configuration$proxy1, "Keys", fromProduct, decoders, encoders, labels, defaults);
    this.Lframework_data_WebPushSubscription$Keys$__f_derived$CirceCodecbitmap$1 = true;
  }
  return this.Lframework_data_WebPushSubscription$Keys$__f_derived$CirceCodec$lzy1;
});
$c_Lframework_data_WebPushSubscription$Keys$.prototype.fromProduct__s_Product__Lframework_data_WebPushSubscription$Keys = (function(x$0) {
  var auth$1 = x$0.productElement__I__O(0);
  var p256dh$1 = x$0.productElement__I__O(1);
  return new $c_Lframework_data_WebPushSubscription$Keys(auth$1, p256dh$1);
});
$c_Lframework_data_WebPushSubscription$Keys$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lframework_data_WebPushSubscription$Keys(p);
});
var $d_Lframework_data_WebPushSubscription$Keys$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_WebPushSubscription$Keys$, "framework.data.WebPushSubscription$Keys$", ({
  Lframework_data_WebPushSubscription$Keys$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lframework_data_WebPushSubscription$Keys$ as $d_Lframework_data_WebPushSubscription$Keys$ };
var $n_Lframework_data_WebPushSubscription$Keys$;
function $m_Lframework_data_WebPushSubscription$Keys$() {
  if ((!$n_Lframework_data_WebPushSubscription$Keys$)) {
    $n_Lframework_data_WebPushSubscription$Keys$ = new $c_Lframework_data_WebPushSubscription$Keys$();
  }
  return $n_Lframework_data_WebPushSubscription$Keys$;
}
export { $m_Lframework_data_WebPushSubscription$Keys$ as $m_Lframework_data_WebPushSubscription$Keys$ };
function $s_Lframework_exts_OnSSEStreamError$OnErrorAction$__Stop__Lframework_exts_OnSSEStreamError$OnErrorAction() {
  $m_Lframework_exts_OnSSEStreamError$OnErrorAction$();
  return $t_Lframework_exts_OnSSEStreamError$OnErrorAction$__Stop;
}
export { $s_Lframework_exts_OnSSEStreamError$OnErrorAction$__Stop__Lframework_exts_OnSSEStreamError$OnErrorAction as $s_Lframework_exts_OnSSEStreamError$OnErrorAction$__Stop__Lframework_exts_OnSSEStreamError$OnErrorAction };
/** @constructor */
function $c_Lframework_exts_OnSSEStreamError$OnErrorAction$() {
  $n_Lframework_exts_OnSSEStreamError$OnErrorAction$ = this;
  $t_Lframework_exts_OnSSEStreamError$OnErrorAction$__Stop = new $c_Lframework_exts_OnSSEStreamError$OnErrorAction$$anon$2();
}
export { $c_Lframework_exts_OnSSEStreamError$OnErrorAction$ as $c_Lframework_exts_OnSSEStreamError$OnErrorAction$ };
$c_Lframework_exts_OnSSEStreamError$OnErrorAction$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_OnSSEStreamError$OnErrorAction$.prototype.constructor = $c_Lframework_exts_OnSSEStreamError$OnErrorAction$;
/** @constructor */
function $h_Lframework_exts_OnSSEStreamError$OnErrorAction$() {
}
export { $h_Lframework_exts_OnSSEStreamError$OnErrorAction$ as $h_Lframework_exts_OnSSEStreamError$OnErrorAction$ };
$h_Lframework_exts_OnSSEStreamError$OnErrorAction$.prototype = $c_Lframework_exts_OnSSEStreamError$OnErrorAction$.prototype;
$c_Lframework_exts_OnSSEStreamError$OnErrorAction$.prototype.ordinal__O__I = (function(x) {
  return x.ordinal__I();
});
var $d_Lframework_exts_OnSSEStreamError$OnErrorAction$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_OnSSEStreamError$OnErrorAction$, "framework.exts.OnSSEStreamError$OnErrorAction$", ({
  Lframework_exts_OnSSEStreamError$OnErrorAction$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lframework_exts_OnSSEStreamError$OnErrorAction$ as $d_Lframework_exts_OnSSEStreamError$OnErrorAction$ };
var $n_Lframework_exts_OnSSEStreamError$OnErrorAction$;
function $m_Lframework_exts_OnSSEStreamError$OnErrorAction$() {
  if ((!$n_Lframework_exts_OnSSEStreamError$OnErrorAction$)) {
    $n_Lframework_exts_OnSSEStreamError$OnErrorAction$ = new $c_Lframework_exts_OnSSEStreamError$OnErrorAction$();
  }
  return $n_Lframework_exts_OnSSEStreamError$OnErrorAction$;
}
export { $m_Lframework_exts_OnSSEStreamError$OnErrorAction$ as $m_Lframework_exts_OnSSEStreamError$OnErrorAction$ };
/** @constructor */
function $c_Lframework_exts_SignalExts$Running$3$(outer) {
  this.Lframework_exts_SignalExts$Running$3$__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lframework_exts_SignalExts$Running$3$__f_$outer = outer;
}
export { $c_Lframework_exts_SignalExts$Running$3$ as $c_Lframework_exts_SignalExts$Running$3$ };
$c_Lframework_exts_SignalExts$Running$3$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_SignalExts$Running$3$.prototype.constructor = $c_Lframework_exts_SignalExts$Running$3$;
/** @constructor */
function $h_Lframework_exts_SignalExts$Running$3$() {
}
export { $h_Lframework_exts_SignalExts$Running$3$ as $h_Lframework_exts_SignalExts$Running$3$ };
$h_Lframework_exts_SignalExts$Running$3$.prototype = $c_Lframework_exts_SignalExts$Running$3$.prototype;
$c_Lframework_exts_SignalExts$Running$3$.prototype.apply__sci_Queue__Lframework_exts_SignalExts$Running$1 = (function(queue) {
  return new $c_Lframework_exts_SignalExts$Running$1(this.Lframework_exts_SignalExts$Running$3$__f_$outer, queue);
});
$c_Lframework_exts_SignalExts$Running$3$.prototype.toString__T = (function() {
  return "Running";
});
$c_Lframework_exts_SignalExts$Running$3$.prototype.fromProduct__s_Product__Lframework_exts_SignalExts$Running$1 = (function(x$0) {
  var queue$1 = x$0.productElement__I__O(0);
  return new $c_Lframework_exts_SignalExts$Running$1(this.Lframework_exts_SignalExts$Running$3$__f_$outer, queue$1);
});
$c_Lframework_exts_SignalExts$Running$3$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lframework_exts_SignalExts$Running$1(p);
});
var $d_Lframework_exts_SignalExts$Running$3$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_SignalExts$Running$3$, "framework.exts.SignalExts$Running$3$", ({
  Lframework_exts_SignalExts$Running$3$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lframework_exts_SignalExts$Running$3$ as $d_Lframework_exts_SignalExts$Running$3$ };
/** @constructor */
function $c_Lframework_exts_TransformerExts$package$TransformerExts$$anon$1(t2$4, \u03b4this$9) {
  this.Lframework_exts_TransformerExts$package$TransformerExts$$anon$1__f_t2$3 = null;
  this.Lframework_exts_TransformerExts$package$TransformerExts$$anon$1__f_$this$6 = null;
  this.Lframework_exts_TransformerExts$package$TransformerExts$$anon$1__f_t2$3 = t2$4;
  this.Lframework_exts_TransformerExts$package$TransformerExts$$anon$1__f_$this$6 = \u03b4this$9;
}
export { $c_Lframework_exts_TransformerExts$package$TransformerExts$$anon$1 as $c_Lframework_exts_TransformerExts$package$TransformerExts$$anon$1 };
$c_Lframework_exts_TransformerExts$package$TransformerExts$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_TransformerExts$package$TransformerExts$$anon$1.prototype.constructor = $c_Lframework_exts_TransformerExts$package$TransformerExts$$anon$1;
/** @constructor */
function $h_Lframework_exts_TransformerExts$package$TransformerExts$$anon$1() {
}
export { $h_Lframework_exts_TransformerExts$package$TransformerExts$$anon$1 as $h_Lframework_exts_TransformerExts$package$TransformerExts$$anon$1 };
$h_Lframework_exts_TransformerExts$package$TransformerExts$$anon$1.prototype = $c_Lframework_exts_TransformerExts$package$TransformerExts$$anon$1.prototype;
$c_Lframework_exts_TransformerExts$package$TransformerExts$$anon$1.prototype.transform__O__O = (function(from) {
  var t2$2 = this.Lframework_exts_TransformerExts$package$TransformerExts$$anon$1__f_t2$3;
  var \u03b4this$2 = this.Lframework_exts_TransformerExts$package$TransformerExts$$anon$1__f_$this$6;
  return t2$2.transform__O__O(\u03b4this$2.transform__O__O(from));
});
var $d_Lframework_exts_TransformerExts$package$TransformerExts$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_TransformerExts$package$TransformerExts$$anon$1, "framework.exts.TransformerExts$package$TransformerExts$$anon$1", ({
  Lframework_exts_TransformerExts$package$TransformerExts$$anon$1: 1,
  Lio_scalaland_chimney_Transformer$AutoDerived: 1,
  Lio_scalaland_chimney_Transformer: 1
}));
export { $d_Lframework_exts_TransformerExts$package$TransformerExts$$anon$1 as $d_Lframework_exts_TransformerExts$package$TransformerExts$$anon$1 };
/** @constructor */
function $c_Lframework_prelude_log$() {
}
export { $c_Lframework_prelude_log$ as $c_Lframework_prelude_log$ };
$c_Lframework_prelude_log$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_prelude_log$.prototype.constructor = $c_Lframework_prelude_log$;
/** @constructor */
function $h_Lframework_prelude_log$() {
}
export { $h_Lframework_prelude_log$ as $h_Lframework_prelude_log$ };
$h_Lframework_prelude_log$.prototype = $c_Lframework_prelude_log$.prototype;
$c_Lframework_prelude_log$.prototype.atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V = (function(level, scope, msg, definedAt, appName) {
  $f_Lframework_utils_JSLogger$DefaultJavascriptLogging__atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V(this, level, scope, msg, definedAt, appName);
});
$c_Lframework_prelude_log$.prototype.scope__s_Option = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
});
var $d_Lframework_prelude_log$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_prelude_log$, "framework.prelude.log$", ({
  Lframework_prelude_log$: 1,
  Lframework_utils_JSLogger: 1,
  Lframework_utils_JSLogger$DefaultJavascriptLogging: 1
}));
export { $d_Lframework_prelude_log$ as $d_Lframework_prelude_log$ };
var $n_Lframework_prelude_log$;
function $m_Lframework_prelude_log$() {
  if ((!$n_Lframework_prelude_log$)) {
    $n_Lframework_prelude_log$ = new $c_Lframework_prelude_log$();
  }
  return $n_Lframework_prelude_log$;
}
export { $m_Lframework_prelude_log$ as $m_Lframework_prelude_log$ };
/** @constructor */
function $c_Lframework_prelude_prelude\uff3fclient$package$$anon$1() {
}
export { $c_Lframework_prelude_prelude\uff3fclient$package$$anon$1 as $c_Lframework_prelude_prelude\uff3fclient$package$$anon$1 };
$c_Lframework_prelude_prelude\uff3fclient$package$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_prelude_prelude\uff3fclient$package$$anon$1.prototype.constructor = $c_Lframework_prelude_prelude\uff3fclient$package$$anon$1;
/** @constructor */
function $h_Lframework_prelude_prelude\uff3fclient$package$$anon$1() {
}
export { $h_Lframework_prelude_prelude\uff3fclient$package$$anon$1 as $h_Lframework_prelude_prelude\uff3fclient$package$$anon$1 };
$h_Lframework_prelude_prelude\uff3fclient$package$$anon$1.prototype = $c_Lframework_prelude_prelude\uff3fclient$package$$anon$1.prototype;
$c_Lframework_prelude_prelude\uff3fclient$package$$anon$1.prototype.apply__O__O = (function(fa) {
  return fa.unsafeToFuture__Lcats_effect_unsafe_IORuntime__s_concurrent_Future($m_Lframework_prelude_prelude\uff3fclient$package$().ioRuntime__Lcats_effect_unsafe_IORuntime());
});
var $d_Lframework_prelude_prelude\uff3fclient$package$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_prelude_prelude\uff3fclient$package$$anon$1, "framework.prelude.prelude_client$package$$anon$1", ({
  Lframework_prelude_prelude\uff3fclient$package$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
}));
export { $d_Lframework_prelude_prelude\uff3fclient$package$$anon$1 as $d_Lframework_prelude_prelude\uff3fclient$package$$anon$1 };
/** @constructor */
function $c_Lframework_sourcecode_DefinedAt$() {
  this.Lframework_sourcecode_DefinedAt$__f_show$lzy1 = null;
  this.Lframework_sourcecode_DefinedAt$__f_showbitmap$1 = false;
}
export { $c_Lframework_sourcecode_DefinedAt$ as $c_Lframework_sourcecode_DefinedAt$ };
$c_Lframework_sourcecode_DefinedAt$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_sourcecode_DefinedAt$.prototype.constructor = $c_Lframework_sourcecode_DefinedAt$;
/** @constructor */
function $h_Lframework_sourcecode_DefinedAt$() {
}
export { $h_Lframework_sourcecode_DefinedAt$ as $h_Lframework_sourcecode_DefinedAt$ };
$h_Lframework_sourcecode_DefinedAt$.prototype = $c_Lframework_sourcecode_DefinedAt$.prototype;
$c_Lframework_sourcecode_DefinedAt$.prototype.show__Lcats_Show = (function() {
  if ((!this.Lframework_sourcecode_DefinedAt$__f_showbitmap$1)) {
    this.Lframework_sourcecode_DefinedAt$__f_show$lzy1 = new $c_Lframework_sourcecode_DefinedAt$$anon$1();
    this.Lframework_sourcecode_DefinedAt$__f_showbitmap$1 = true;
  }
  return this.Lframework_sourcecode_DefinedAt$__f_show$lzy1;
});
$c_Lframework_sourcecode_DefinedAt$.prototype.fromProduct__s_Product__Lframework_sourcecode_DefinedAt = (function(x$0) {
  var file$1 = x$0.productElement__I__O(0);
  var line$1 = x$0.productElement__I__O(1);
  var name$1 = x$0.productElement__I__O(2);
  return new $c_Lframework_sourcecode_DefinedAt(file$1, line$1, name$1);
});
$c_Lframework_sourcecode_DefinedAt$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lframework_sourcecode_DefinedAt(p);
});
var $d_Lframework_sourcecode_DefinedAt$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_sourcecode_DefinedAt$, "framework.sourcecode.DefinedAt$", ({
  Lframework_sourcecode_DefinedAt$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lframework_sourcecode_DefinedAt$ as $d_Lframework_sourcecode_DefinedAt$ };
var $n_Lframework_sourcecode_DefinedAt$;
function $m_Lframework_sourcecode_DefinedAt$() {
  if ((!$n_Lframework_sourcecode_DefinedAt$)) {
    $n_Lframework_sourcecode_DefinedAt$ = new $c_Lframework_sourcecode_DefinedAt$();
  }
  return $n_Lframework_sourcecode_DefinedAt$;
}
export { $m_Lframework_sourcecode_DefinedAt$ as $m_Lframework_sourcecode_DefinedAt$ };
function $s_Lframework_utils_AuthenticatedNetworkRequestFailure$__Aborted__Lframework_utils_AuthenticatedNetworkRequestFailure() {
  $m_Lframework_utils_AuthenticatedNetworkRequestFailure$();
  return $t_Lframework_utils_AuthenticatedNetworkRequestFailure$__Aborted;
}
export { $s_Lframework_utils_AuthenticatedNetworkRequestFailure$__Aborted__Lframework_utils_AuthenticatedNetworkRequestFailure as $s_Lframework_utils_AuthenticatedNetworkRequestFailure$__Aborted__Lframework_utils_AuthenticatedNetworkRequestFailure };
/** @constructor */
function $c_Lframework_utils_AuthenticatedNetworkRequestFailure$() {
  $n_Lframework_utils_AuthenticatedNetworkRequestFailure$ = this;
  $t_Lframework_utils_AuthenticatedNetworkRequestFailure$__Aborted = new $c_Lframework_utils_AuthenticatedNetworkRequestFailure$$anon$1();
}
export { $c_Lframework_utils_AuthenticatedNetworkRequestFailure$ as $c_Lframework_utils_AuthenticatedNetworkRequestFailure$ };
$c_Lframework_utils_AuthenticatedNetworkRequestFailure$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_AuthenticatedNetworkRequestFailure$.prototype.constructor = $c_Lframework_utils_AuthenticatedNetworkRequestFailure$;
/** @constructor */
function $h_Lframework_utils_AuthenticatedNetworkRequestFailure$() {
}
export { $h_Lframework_utils_AuthenticatedNetworkRequestFailure$ as $h_Lframework_utils_AuthenticatedNetworkRequestFailure$ };
$h_Lframework_utils_AuthenticatedNetworkRequestFailure$.prototype = $c_Lframework_utils_AuthenticatedNetworkRequestFailure$.prototype;
$c_Lframework_utils_AuthenticatedNetworkRequestFailure$.prototype.ordinal__O__I = (function(x) {
  return x.ordinal__I();
});
var $d_Lframework_utils_AuthenticatedNetworkRequestFailure$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_AuthenticatedNetworkRequestFailure$, "framework.utils.AuthenticatedNetworkRequestFailure$", ({
  Lframework_utils_AuthenticatedNetworkRequestFailure$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lframework_utils_AuthenticatedNetworkRequestFailure$ as $d_Lframework_utils_AuthenticatedNetworkRequestFailure$ };
var $n_Lframework_utils_AuthenticatedNetworkRequestFailure$;
function $m_Lframework_utils_AuthenticatedNetworkRequestFailure$() {
  if ((!$n_Lframework_utils_AuthenticatedNetworkRequestFailure$)) {
    $n_Lframework_utils_AuthenticatedNetworkRequestFailure$ = new $c_Lframework_utils_AuthenticatedNetworkRequestFailure$();
  }
  return $n_Lframework_utils_AuthenticatedNetworkRequestFailure$;
}
export { $m_Lframework_utils_AuthenticatedNetworkRequestFailure$ as $m_Lframework_utils_AuthenticatedNetworkRequestFailure$ };
function $s_Lframework_utils_BrowserDetection$__MicrosoftEdge__Lframework_utils_BrowserDetection() {
  $m_Lframework_utils_BrowserDetection$();
  return $t_Lframework_utils_BrowserDetection$__MicrosoftEdge;
}
export { $s_Lframework_utils_BrowserDetection$__MicrosoftEdge__Lframework_utils_BrowserDetection as $s_Lframework_utils_BrowserDetection$__MicrosoftEdge__Lframework_utils_BrowserDetection };
/** @constructor */
function $c_Lframework_utils_BrowserDetection$() {
  this.Lframework_utils_BrowserDetection$__f_browser$lzy1 = null;
  this.Lframework_utils_BrowserDetection$__f_browserbitmap$1 = false;
  $n_Lframework_utils_BrowserDetection$ = this;
  $t_Lframework_utils_BrowserDetection$__MicrosoftEdge = new $c_Lframework_utils_BrowserDetection$$anon$1("MicrosoftEdge", 0);
}
export { $c_Lframework_utils_BrowserDetection$ as $c_Lframework_utils_BrowserDetection$ };
$c_Lframework_utils_BrowserDetection$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_BrowserDetection$.prototype.constructor = $c_Lframework_utils_BrowserDetection$;
/** @constructor */
function $h_Lframework_utils_BrowserDetection$() {
}
export { $h_Lframework_utils_BrowserDetection$ as $h_Lframework_utils_BrowserDetection$ };
$h_Lframework_utils_BrowserDetection$.prototype = $c_Lframework_utils_BrowserDetection$.prototype;
$c_Lframework_utils_BrowserDetection$.prototype.browser__Lframework_utils_BrowserDetection = (function() {
  if ((!this.Lframework_utils_BrowserDetection$__f_browserbitmap$1)) {
    this.Lframework_utils_BrowserDetection$__f_browser$lzy1 = this.detect__Lframework_utils_BrowserDetection();
    this.Lframework_utils_BrowserDetection$__f_browserbitmap$1 = true;
  }
  return this.Lframework_utils_BrowserDetection$__f_browser$lzy1;
});
$c_Lframework_utils_BrowserDetection$.prototype.detect__Lframework_utils_BrowserDetection = (function() {
  var userAgent = $m_Lframework_prelude_prelude\uff3fclient$package$().window__Lorg_scalajs_dom_Window().navigator.userAgent;
  var a = $m_Lframework_prelude_prelude\uff3fclient$package$().window__Lorg_scalajs_dom_Window().navigator;
  var selected = a.userAgentData;
  var maybeUserAgentData = ((selected === (void 0)) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$() : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(selected));
  if ((maybeUserAgentData instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
    var uaData = maybeUserAgentData.s_Some__f_value;
    var array = uaData.brands;
    _return: {
      var len = (array.length | 0);
      var i = 0;
      while ((i < len)) {
        var x0 = array[i];
        if ((x0.brand === "Microsoft Edge")) {
          var $x_1 = i;
          break _return;
        }
        i = ((1 + i) | 0);
      }
      var $x_1 = (-1);
    }
    if ((($x_1 >= 0) || ((userAgent.indexOf("Edg/") | 0) !== (-1)))) {
      return $s_Lframework_utils_BrowserDetection$__MicrosoftEdge__Lframework_utils_BrowserDetection();
    } else {
      return new $c_Lframework_utils_BrowserDetection$Other(userAgent, maybeUserAgentData);
    }
  }
  var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  if ((x === maybeUserAgentData)) {
    var userAgentData = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    return new $c_Lframework_utils_BrowserDetection$Other(userAgent, userAgentData);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(maybeUserAgentData);
});
$c_Lframework_utils_BrowserDetection$.prototype.ordinal__O__I = (function(x) {
  return x.ordinal__I();
});
var $d_Lframework_utils_BrowserDetection$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_BrowserDetection$, "framework.utils.BrowserDetection$", ({
  Lframework_utils_BrowserDetection$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lframework_utils_BrowserDetection$ as $d_Lframework_utils_BrowserDetection$ };
var $n_Lframework_utils_BrowserDetection$;
function $m_Lframework_utils_BrowserDetection$() {
  if ((!$n_Lframework_utils_BrowserDetection$)) {
    $n_Lframework_utils_BrowserDetection$ = new $c_Lframework_utils_BrowserDetection$();
  }
  return $n_Lframework_utils_BrowserDetection$;
}
export { $m_Lframework_utils_BrowserDetection$ as $m_Lframework_utils_BrowserDetection$ };
function $s_Lframework_utils_LogLevel$__Default__Lframework_utils_LogLevel() {
  $m_Lframework_utils_LogLevel$();
  return $t_Lframework_utils_LogLevel$__Default;
}
export { $s_Lframework_utils_LogLevel$__Default__Lframework_utils_LogLevel as $s_Lframework_utils_LogLevel$__Default__Lframework_utils_LogLevel };
function $s_Lframework_utils_LogLevel$__Debug__Lframework_utils_LogLevel() {
  $m_Lframework_utils_LogLevel$();
  return $t_Lframework_utils_LogLevel$__Debug;
}
export { $s_Lframework_utils_LogLevel$__Debug__Lframework_utils_LogLevel as $s_Lframework_utils_LogLevel$__Debug__Lframework_utils_LogLevel };
function $s_Lframework_utils_LogLevel$__Info__Lframework_utils_LogLevel() {
  $m_Lframework_utils_LogLevel$();
  return $t_Lframework_utils_LogLevel$__Info;
}
export { $s_Lframework_utils_LogLevel$__Info__Lframework_utils_LogLevel as $s_Lframework_utils_LogLevel$__Info__Lframework_utils_LogLevel };
function $s_Lframework_utils_LogLevel$__Warning__Lframework_utils_LogLevel() {
  $m_Lframework_utils_LogLevel$();
  return $t_Lframework_utils_LogLevel$__Warning;
}
export { $s_Lframework_utils_LogLevel$__Warning__Lframework_utils_LogLevel as $s_Lframework_utils_LogLevel$__Warning__Lframework_utils_LogLevel };
function $s_Lframework_utils_LogLevel$__Error__Lframework_utils_LogLevel() {
  $m_Lframework_utils_LogLevel$();
  return $t_Lframework_utils_LogLevel$__Error;
}
export { $s_Lframework_utils_LogLevel$__Error__Lframework_utils_LogLevel as $s_Lframework_utils_LogLevel$__Error__Lframework_utils_LogLevel };
/** @constructor */
function $c_Lframework_utils_LogLevel$() {
  $n_Lframework_utils_LogLevel$ = this;
  $t_Lframework_utils_LogLevel$__Default = new $c_Lframework_utils_LogLevel$$anon$1("Default", 0);
  $t_Lframework_utils_LogLevel$__Debug = new $c_Lframework_utils_LogLevel$$anon$1("Debug", 1);
  $t_Lframework_utils_LogLevel$__Info = new $c_Lframework_utils_LogLevel$$anon$1("Info", 2);
  $t_Lframework_utils_LogLevel$__Warning = new $c_Lframework_utils_LogLevel$$anon$1("Warning", 3);
  $t_Lframework_utils_LogLevel$__Error = new $c_Lframework_utils_LogLevel$$anon$1("Error", 4);
  $s_Lframework_utils_LogLevel$__Default__Lframework_utils_LogLevel();
  $s_Lframework_utils_LogLevel$__Debug__Lframework_utils_LogLevel();
  $s_Lframework_utils_LogLevel$__Info__Lframework_utils_LogLevel();
  $s_Lframework_utils_LogLevel$__Warning__Lframework_utils_LogLevel();
  $s_Lframework_utils_LogLevel$__Error__Lframework_utils_LogLevel();
}
export { $c_Lframework_utils_LogLevel$ as $c_Lframework_utils_LogLevel$ };
$c_Lframework_utils_LogLevel$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_LogLevel$.prototype.constructor = $c_Lframework_utils_LogLevel$;
/** @constructor */
function $h_Lframework_utils_LogLevel$() {
}
export { $h_Lframework_utils_LogLevel$ as $h_Lframework_utils_LogLevel$ };
$h_Lframework_utils_LogLevel$.prototype = $c_Lframework_utils_LogLevel$.prototype;
$c_Lframework_utils_LogLevel$.prototype.ordinal__O__I = (function(x) {
  return x.Lframework_utils_LogLevel$$anon$1__f__$ordinal$1;
});
var $d_Lframework_utils_LogLevel$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_LogLevel$, "framework.utils.LogLevel$", ({
  Lframework_utils_LogLevel$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lframework_utils_LogLevel$ as $d_Lframework_utils_LogLevel$ };
var $n_Lframework_utils_LogLevel$;
function $m_Lframework_utils_LogLevel$() {
  if ((!$n_Lframework_utils_LogLevel$)) {
    $n_Lframework_utils_LogLevel$ = new $c_Lframework_utils_LogLevel$();
  }
  return $n_Lframework_utils_LogLevel$;
}
export { $m_Lframework_utils_LogLevel$ as $m_Lframework_utils_LogLevel$ };
/** @constructor */
function $c_Lframework_utils_NewtypeBoolean$$anon$2(outer) {
  this.Lframework_utils_NewtypeBoolean$$anon$2__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lframework_utils_NewtypeBoolean$$anon$2__f_$outer = outer;
}
export { $c_Lframework_utils_NewtypeBoolean$$anon$2 as $c_Lframework_utils_NewtypeBoolean$$anon$2 };
$c_Lframework_utils_NewtypeBoolean$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_s_Conversion();
$c_Lframework_utils_NewtypeBoolean$$anon$2.prototype.constructor = $c_Lframework_utils_NewtypeBoolean$$anon$2;
/** @constructor */
function $h_Lframework_utils_NewtypeBoolean$$anon$2() {
}
export { $h_Lframework_utils_NewtypeBoolean$$anon$2 as $h_Lframework_utils_NewtypeBoolean$$anon$2 };
$h_Lframework_utils_NewtypeBoolean$$anon$2.prototype = $c_Lframework_utils_NewtypeBoolean$$anon$2.prototype;
$c_Lframework_utils_NewtypeBoolean$$anon$2.prototype.apply__Z__Z = (function(v) {
  return v;
});
$c_Lframework_utils_NewtypeBoolean$$anon$2.prototype.apply__O__O = (function(x) {
  return this.apply__Z__Z((!(!x)));
});
var $d_Lframework_utils_NewtypeBoolean$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_NewtypeBoolean$$anon$2, "framework.utils.NewtypeBoolean$$anon$2", ({
  Lframework_utils_NewtypeBoolean$$anon$2: 1,
  s_Conversion: 1,
  F1: 1
}));
export { $d_Lframework_utils_NewtypeBoolean$$anon$2 as $d_Lframework_utils_NewtypeBoolean$$anon$2 };
/** @constructor */
function $c_Lframework_utils_PageRenderResult$() {
  this.Lframework_utils_PageRenderResult$__f_given_Conversion_Element_PageRenderResult$lzy1 = null;
  this.Lframework_utils_PageRenderResult$__f_given_Conversion_Element_PageRenderResultbitmap$1 = false;
}
export { $c_Lframework_utils_PageRenderResult$ as $c_Lframework_utils_PageRenderResult$ };
$c_Lframework_utils_PageRenderResult$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_PageRenderResult$.prototype.constructor = $c_Lframework_utils_PageRenderResult$;
/** @constructor */
function $h_Lframework_utils_PageRenderResult$() {
}
export { $h_Lframework_utils_PageRenderResult$ as $h_Lframework_utils_PageRenderResult$ };
$h_Lframework_utils_PageRenderResult$.prototype = $c_Lframework_utils_PageRenderResult$.prototype;
$c_Lframework_utils_PageRenderResult$.prototype.given_Conversion_Element_PageRenderResult__s_Conversion = (function() {
  if ((!this.Lframework_utils_PageRenderResult$__f_given_Conversion_Element_PageRenderResultbitmap$1)) {
    this.Lframework_utils_PageRenderResult$__f_given_Conversion_Element_PageRenderResult$lzy1 = new $c_Lframework_utils_PageRenderResult$$anon$1();
    this.Lframework_utils_PageRenderResult$__f_given_Conversion_Element_PageRenderResultbitmap$1 = true;
  }
  return this.Lframework_utils_PageRenderResult$__f_given_Conversion_Element_PageRenderResult$lzy1;
});
$c_Lframework_utils_PageRenderResult$.prototype.unsignal__Lcom_raquo_airstream_core_Signal__Lframework_utils_PageRenderResult = (function(signal) {
  var project = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$3) => {
    var x13 = _$3.Lframework_utils_PageRenderResult__f_content;
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$is_Lcom_raquo_airstream_core_Signal(x13)) {
      return x13;
    }
    return $m_Lcom_raquo_airstream_state_Val$().apply__O__Lcom_raquo_airstream_state_Val(x13);
  }));
  var strategy = $m_Lcom_raquo_airstream_core_Observable$().Lcom_raquo_airstream_core_Observable$__f_switchSignalStrategy;
  var content = strategy.flatten__Lcom_raquo_airstream_core_Observable__Lcom_raquo_airstream_core_Observable($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), signal, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()));
  var project$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$4) => {
    var x15 = _$4.Lframework_utils_PageRenderResult__f_pageTitle;
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$is_Lcom_raquo_airstream_core_Signal(x15)) {
      return x15;
    }
    return $m_Lcom_raquo_airstream_state_Val$().apply__O__Lcom_raquo_airstream_state_Val(x15);
  }));
  var strategy$1 = $m_Lcom_raquo_airstream_core_Observable$().Lcom_raquo_airstream_core_Observable$__f_switchSignalStrategy;
  var pageTitle = strategy$1.flatten__Lcom_raquo_airstream_core_Observable__Lcom_raquo_airstream_core_Observable($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), signal, project$1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()));
  var project$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$5) => {
    var x17 = _$5.Lframework_utils_PageRenderResult__f_externalModifiers;
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$is_Lcom_raquo_airstream_core_Signal(x17)) {
      return x17;
    }
    return $m_Lcom_raquo_airstream_state_Val$().apply__O__Lcom_raquo_airstream_state_Val(x17);
  }));
  var strategy$2 = $m_Lcom_raquo_airstream_core_Observable$().Lcom_raquo_airstream_core_Observable$__f_switchSignalStrategy;
  var externalModifiers = strategy$2.flatten__Lcom_raquo_airstream_core_Observable__Lcom_raquo_airstream_core_Observable($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), signal, project$2, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()));
  return new $c_Lframework_utils_PageRenderResult(content, pageTitle, externalModifiers);
});
$c_Lframework_utils_PageRenderResult$.prototype.fromProduct__s_Product__Lframework_utils_PageRenderResult = (function(x$0) {
  var content$2 = x$0.productElement__I__O(0);
  var pageTitle$2 = x$0.productElement__I__O(1);
  var externalModifiers$2 = x$0.productElement__I__O(2);
  return new $c_Lframework_utils_PageRenderResult(content$2, pageTitle$2, externalModifiers$2);
});
$c_Lframework_utils_PageRenderResult$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lframework_utils_PageRenderResult(p);
});
var $d_Lframework_utils_PageRenderResult$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_PageRenderResult$, "framework.utils.PageRenderResult$", ({
  Lframework_utils_PageRenderResult$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lframework_utils_PageRenderResult$ as $d_Lframework_utils_PageRenderResult$ };
var $n_Lframework_utils_PageRenderResult$;
function $m_Lframework_utils_PageRenderResult$() {
  if ((!$n_Lframework_utils_PageRenderResult$)) {
    $n_Lframework_utils_PageRenderResult$ = new $c_Lframework_utils_PageRenderResult$();
  }
  return $n_Lframework_utils_PageRenderResult$;
}
export { $m_Lframework_utils_PageRenderResult$ as $m_Lframework_utils_PageRenderResult$ };
/** @constructor */
function $c_Lframework_utils_PageRenderResult$$anon$1() {
}
export { $c_Lframework_utils_PageRenderResult$$anon$1 as $c_Lframework_utils_PageRenderResult$$anon$1 };
$c_Lframework_utils_PageRenderResult$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_s_Conversion();
$c_Lframework_utils_PageRenderResult$$anon$1.prototype.constructor = $c_Lframework_utils_PageRenderResult$$anon$1;
/** @constructor */
function $h_Lframework_utils_PageRenderResult$$anon$1() {
}
export { $h_Lframework_utils_PageRenderResult$$anon$1 as $h_Lframework_utils_PageRenderResult$$anon$1 };
$h_Lframework_utils_PageRenderResult$$anon$1.prototype = $c_Lframework_utils_PageRenderResult$$anon$1.prototype;
$c_Lframework_utils_PageRenderResult$$anon$1.prototype.apply__O__O = (function(x) {
  var pageTitle = $m_Lframework_utils_PageTitleResult$().Lframework_utils_PageTitleResult$__f_default;
  var externalModifiers = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Seq$().empty__sc_SeqOps();
  return new $c_Lframework_utils_PageRenderResult(x, pageTitle, externalModifiers);
});
var $d_Lframework_utils_PageRenderResult$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_PageRenderResult$$anon$1, "framework.utils.PageRenderResult$$anon$1", ({
  Lframework_utils_PageRenderResult$$anon$1: 1,
  s_Conversion: 1,
  F1: 1
}));
export { $d_Lframework_utils_PageRenderResult$$anon$1 as $d_Lframework_utils_PageRenderResult$$anon$1 };
/** @constructor */
function $c_Lframework_utils_PageTitleResult$() {
  this.Lframework_utils_PageTitleResult$__f_default = null;
  $n_Lframework_utils_PageTitleResult$ = this;
  this.Lframework_utils_PageTitleResult$__f_default = new $c_Lframework_utils_PageTitleResult$Default(true);
}
export { $c_Lframework_utils_PageTitleResult$ as $c_Lframework_utils_PageTitleResult$ };
$c_Lframework_utils_PageTitleResult$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_PageTitleResult$.prototype.constructor = $c_Lframework_utils_PageTitleResult$;
/** @constructor */
function $h_Lframework_utils_PageTitleResult$() {
}
export { $h_Lframework_utils_PageTitleResult$ as $h_Lframework_utils_PageTitleResult$ };
$h_Lframework_utils_PageTitleResult$.prototype = $c_Lframework_utils_PageTitleResult$.prototype;
$c_Lframework_utils_PageTitleResult$.prototype.pageTitleSignal__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_core_Signal = (function(signal, defaultPageTitleSignal) {
  var project$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1) => {
    if ((x$1 instanceof $c_Lframework_utils_PageTitleResult$Default)) {
      var x25 = x$1.Lframework_utils_PageTitleResult$Default__f_renderInDocument;
      var project = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$1) => new $c_Lframework_utils_PageTitleResult$Result(_$1, x25)));
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), defaultPageTitleSignal, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
    }
    if ((x$1 instanceof $c_Lframework_utils_PageTitleResult$Custom)) {
      var x21 = x$1.Lframework_utils_PageTitleResult$Custom__f_title;
      var x22 = x$1.Lframework_utils_PageTitleResult$Custom__f_renderInDocument;
      var this$7 = ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$is_Lcom_raquo_airstream_core_Signal(x21) ? x21 : $m_Lcom_raquo_airstream_state_Val$().apply__O__Lcom_raquo_airstream_state_Val(x21));
      var project$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$2) => new $c_Lframework_utils_PageTitleResult$Result(_$2, x22)));
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), this$7, project$1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  }));
  var strategy = $m_Lcom_raquo_airstream_core_Observable$().Lcom_raquo_airstream_core_Observable$__f_switchSignalStrategy;
  return strategy.flatten__Lcom_raquo_airstream_core_Observable__Lcom_raquo_airstream_core_Observable($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), signal, project$2, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()));
});
$c_Lframework_utils_PageTitleResult$.prototype.ordinal__O__I = (function(x) {
  return x.ordinal__I();
});
var $d_Lframework_utils_PageTitleResult$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_PageTitleResult$, "framework.utils.PageTitleResult$", ({
  Lframework_utils_PageTitleResult$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lframework_utils_PageTitleResult$ as $d_Lframework_utils_PageTitleResult$ };
var $n_Lframework_utils_PageTitleResult$;
function $m_Lframework_utils_PageTitleResult$() {
  if ((!$n_Lframework_utils_PageTitleResult$)) {
    $n_Lframework_utils_PageTitleResult$ = new $c_Lframework_utils_PageTitleResult$();
  }
  return $n_Lframework_utils_PageTitleResult$;
}
export { $m_Lframework_utils_PageTitleResult$ as $m_Lframework_utils_PageTitleResult$ };
/** @constructor */
function $c_Lframework_utils_PrettyPrintDuration$Strings$EnglishShortNoSpaces$() {
  this.Lframework_utils_PrettyPrintDuration$Strings$EnglishShortNoSpaces$__f_framework$utils$PrettyPrintDuration$Strings$EnglishShort$$useSpaces = false;
  this.Lframework_utils_PrettyPrintDuration$Strings$EnglishShortNoSpaces$__f_framework$utils$PrettyPrintDuration$Strings$EnglishShort$$useSpaces = false;
}
export { $c_Lframework_utils_PrettyPrintDuration$Strings$EnglishShortNoSpaces$ as $c_Lframework_utils_PrettyPrintDuration$Strings$EnglishShortNoSpaces$ };
$c_Lframework_utils_PrettyPrintDuration$Strings$EnglishShortNoSpaces$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_PrettyPrintDuration$Strings$EnglishShortNoSpaces$.prototype.constructor = $c_Lframework_utils_PrettyPrintDuration$Strings$EnglishShortNoSpaces$;
/** @constructor */
function $h_Lframework_utils_PrettyPrintDuration$Strings$EnglishShortNoSpaces$() {
}
export { $h_Lframework_utils_PrettyPrintDuration$Strings$EnglishShortNoSpaces$ as $h_Lframework_utils_PrettyPrintDuration$Strings$EnglishShortNoSpaces$ };
$h_Lframework_utils_PrettyPrintDuration$Strings$EnglishShortNoSpaces$.prototype = $c_Lframework_utils_PrettyPrintDuration$Strings$EnglishShortNoSpaces$.prototype;
var $d_Lframework_utils_PrettyPrintDuration$Strings$EnglishShortNoSpaces$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_PrettyPrintDuration$Strings$EnglishShortNoSpaces$, "framework.utils.PrettyPrintDuration$Strings$EnglishShortNoSpaces$", ({
  Lframework_utils_PrettyPrintDuration$Strings$EnglishShortNoSpaces$: 1,
  Lframework_utils_PrettyPrintDuration$Strings: 1,
  Lframework_utils_PrettyPrintDuration$Strings$EnglishShort: 1
}));
export { $d_Lframework_utils_PrettyPrintDuration$Strings$EnglishShortNoSpaces$ as $d_Lframework_utils_PrettyPrintDuration$Strings$EnglishShortNoSpaces$ };
var $n_Lframework_utils_PrettyPrintDuration$Strings$EnglishShortNoSpaces$;
function $m_Lframework_utils_PrettyPrintDuration$Strings$EnglishShortNoSpaces$() {
  if ((!$n_Lframework_utils_PrettyPrintDuration$Strings$EnglishShortNoSpaces$)) {
    $n_Lframework_utils_PrettyPrintDuration$Strings$EnglishShortNoSpaces$ = new $c_Lframework_utils_PrettyPrintDuration$Strings$EnglishShortNoSpaces$();
  }
  return $n_Lframework_utils_PrettyPrintDuration$Strings$EnglishShortNoSpaces$;
}
export { $m_Lframework_utils_PrettyPrintDuration$Strings$EnglishShortNoSpaces$ as $m_Lframework_utils_PrettyPrintDuration$Strings$EnglishShortNoSpaces$ };
/** @constructor */
function $c_Lframework_utils_PushNotifications$PublicKey$() {
  this.Lframework_utils_PushNotifications$PublicKey$__f_given_Show_PublicKey$lzy1 = null;
  this.Lframework_utils_PushNotifications$PublicKey$__f_given_Show_PublicKeybitmap$1 = false;
}
export { $c_Lframework_utils_PushNotifications$PublicKey$ as $c_Lframework_utils_PushNotifications$PublicKey$ };
$c_Lframework_utils_PushNotifications$PublicKey$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_PushNotifications$PublicKey$.prototype.constructor = $c_Lframework_utils_PushNotifications$PublicKey$;
/** @constructor */
function $h_Lframework_utils_PushNotifications$PublicKey$() {
}
export { $h_Lframework_utils_PushNotifications$PublicKey$ as $h_Lframework_utils_PushNotifications$PublicKey$ };
$h_Lframework_utils_PushNotifications$PublicKey$.prototype = $c_Lframework_utils_PushNotifications$PublicKey$.prototype;
$c_Lframework_utils_PushNotifications$PublicKey$.prototype.given_Show_PublicKey__Lcats_Show = (function() {
  if ((!this.Lframework_utils_PushNotifications$PublicKey$__f_given_Show_PublicKeybitmap$1)) {
    this.Lframework_utils_PushNotifications$PublicKey$__f_given_Show_PublicKey$lzy1 = new $c_Lframework_utils_PushNotifications$PublicKey$$anon$1();
    this.Lframework_utils_PushNotifications$PublicKey$__f_given_Show_PublicKeybitmap$1 = true;
  }
  return this.Lframework_utils_PushNotifications$PublicKey$__f_given_Show_PublicKey$lzy1;
});
$c_Lframework_utils_PushNotifications$PublicKey$.prototype.fromString__T__s_util_Either = (function(str) {
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__replaceAll__T__T__T(str, "\\s+", "");
  var trimmed = this$1.toUpperCase();
  var regex = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_s_util_matching_Regex__T__sci_Seq__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_matching_Regex(), "^[0-9A-F]{1,2}(:[0-9A-F]{1,2})+$", $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
  if (regex.matches__jl_CharSequence__Z(trimmed)) {
    var xs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__split__T__I__AT(trimmed, ":", 0);
    var this$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_ArrayOps$().iterator$extension__O__sc_Iterator(xs);
    var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((hex) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Short$().parseShort__T__I__S(hex, 16)));
    var this$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(this$5, f);
    var bytes = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$6);
    var value = new $c_Lframework_utils_PushNotifications$PublicKey(bytes);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value);
  } else {
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
    var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["Invalid public key format, expected '04:c3:cb:06:...': '", "'"]));
    var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
    var value$1 = $x_1.show$extension__s_StringContext__sci_Seq__T(sc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(trimmed, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))])));
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value$1);
  }
});
$c_Lframework_utils_PushNotifications$PublicKey$.prototype.fromJs__sjs_js_typedarray_Uint8Array__Lframework_utils_PushNotifications$PublicKey = (function(key) {
  var this$2 = new $c_sjs_js_IterableOps(key);
  var bytes = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$2);
  return new $c_Lframework_utils_PushNotifications$PublicKey(bytes);
});
$c_Lframework_utils_PushNotifications$PublicKey$.prototype.fromProduct__s_Product__Lframework_utils_PushNotifications$PublicKey = (function(x$0) {
  var bytes$1 = x$0.productElement__I__O(0);
  return new $c_Lframework_utils_PushNotifications$PublicKey(bytes$1);
});
$c_Lframework_utils_PushNotifications$PublicKey$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lframework_utils_PushNotifications$PublicKey(p);
});
var $d_Lframework_utils_PushNotifications$PublicKey$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_PushNotifications$PublicKey$, "framework.utils.PushNotifications$PublicKey$", ({
  Lframework_utils_PushNotifications$PublicKey$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lframework_utils_PushNotifications$PublicKey$ as $d_Lframework_utils_PushNotifications$PublicKey$ };
var $n_Lframework_utils_PushNotifications$PublicKey$;
function $m_Lframework_utils_PushNotifications$PublicKey$() {
  if ((!$n_Lframework_utils_PushNotifications$PublicKey$)) {
    $n_Lframework_utils_PushNotifications$PublicKey$ = new $c_Lframework_utils_PushNotifications$PublicKey$();
  }
  return $n_Lframework_utils_PushNotifications$PublicKey$;
}
export { $m_Lframework_utils_PushNotifications$PublicKey$ as $m_Lframework_utils_PushNotifications$PublicKey$ };
function $s_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__ServerSentEvents__Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode() {
  $m_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$();
  return $t_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__ServerSentEvents;
}
export { $s_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__ServerSentEvents__Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode as $s_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__ServerSentEvents__Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode };
function $s_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__WebSocket__Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode() {
  $m_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$();
  return $t_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__WebSocket;
}
export { $s_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__WebSocket__Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode as $s_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__WebSocket__Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode };
/** @constructor */
function $c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$() {
  this.Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__f_derived$Show$lzy1 = null;
  this.Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__f_derived$Showbitmap$1 = false;
  $n_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$ = this;
  $t_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__ServerSentEvents = new $c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$$anon$3("ServerSentEvents", 0);
  $t_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__WebSocket = new $c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$$anon$3("WebSocket", 1);
  $s_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__ServerSentEvents__Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode();
  $s_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__WebSocket__Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode();
}
export { $c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$ as $c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$ };
$c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$.prototype.constructor = $c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$;
/** @constructor */
function $h_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$() {
}
export { $h_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$ as $h_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$ };
$h_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$.prototype = $c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$.prototype;
$c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$.prototype.derived$Show__Lcats_Show = (function() {
  if ((!this.Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__f_derived$Showbitmap$1)) {
    var x$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
      var gen$proxy1 = $m_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$();
      return new $c_Lshapeless3_deriving_internals_ErasedCoproductInstances(gen$proxy1, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
        var arr$proxy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(2);
        var $x_3 = $m_Lcats_derived_DerivedShow$package$DerivedShow$();
        var gen$proxy2 = $s_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__ServerSentEvents__Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode();
        var is = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => $m_Lshapeless3_deriving_internals_ErasedProductInstances$().Lshapeless3_deriving_internals_ErasedProductInstances$__f_emptyArray));
        var $x_2 = new $c_Lshapeless3_deriving_internals_ErasedProductInstancesN(gen$proxy2, is);
        var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_ArraySeq$();
        var arr$proxy2 = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(0);
        var elemLabels = $x_1.unsafeWrapArray__O__sci_ArraySeq(arr$proxy2);
        var instance = $x_3.given_DerivedShow_A__Lshapeless3_deriving_internals_ErasedProductInstances__Lshapeless3_deriving_Labelling__Lcats_Show($x_2, new $c_Lshapeless3_deriving_Labelling("ServerSentEvents", elemLabels));
        arr$proxy1.u[0] = instance;
        var $x_6 = $m_Lcats_derived_DerivedShow$package$DerivedShow$();
        var gen$proxy3 = $s_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__WebSocket__Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode();
        var is$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => $m_Lshapeless3_deriving_internals_ErasedProductInstances$().Lshapeless3_deriving_internals_ErasedProductInstances$__f_emptyArray));
        var $x_5 = new $c_Lshapeless3_deriving_internals_ErasedProductInstancesN(gen$proxy3, is$1);
        var $x_4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_ArraySeq$();
        var arr$proxy3 = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(0);
        var elemLabels$1 = $x_4.unsafeWrapArray__O__sci_ArraySeq(arr$proxy3);
        var instance$2 = $x_6.given_DerivedShow_A__Lshapeless3_deriving_internals_ErasedProductInstances__Lshapeless3_deriving_Labelling__Lcats_Show($x_5, new $c_Lshapeless3_deriving_Labelling("WebSocket", elemLabels$1));
        arr$proxy1.u[1] = instance$2;
        return arr$proxy1;
      })));
    }));
    var derived = $m_Lcats_derived_DerivedShow$package$DerivedShow$Strict$().coproduct__F0__Lcats_Show(x$1);
    this.Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__f_derived$Show$lzy1 = derived;
    this.Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__f_derived$Showbitmap$1 = true;
  }
  return this.Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__f_derived$Show$lzy1;
});
$c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$.prototype.ordinal__O__I = (function(x) {
  return x.Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$$anon$3__f__$ordinal$1;
});
var $d_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$, "framework.utils.ToSSEStreamBuilder$PreferredConnectionMode$", ({
  Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$ as $d_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$ };
var $n_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$;
function $m_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$() {
  if ((!$n_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$)) {
    $n_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$ = new $c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$();
  }
  return $n_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$;
}
export { $m_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$ as $m_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$ };
/** @constructor */
function $c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(outer) {
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1 as $c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1 };
$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1.prototype.constructor = $c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1;
/** @constructor */
function $h_Lframework_utils_UnvalidatedNewtypeOf$$anon$1() {
}
export { $h_Lframework_utils_UnvalidatedNewtypeOf$$anon$1 as $h_Lframework_utils_UnvalidatedNewtypeOf$$anon$1 };
$h_Lframework_utils_UnvalidatedNewtypeOf$$anon$1.prototype = $c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1.prototype;
$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1.prototype.transform__O__O = (function(a) {
  return a;
});
var $d_Lframework_utils_UnvalidatedNewtypeOf$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1, "framework.utils.UnvalidatedNewtypeOf$$anon$1", ({
  Lframework_utils_UnvalidatedNewtypeOf$$anon$1: 1,
  Lio_scalaland_chimney_Transformer$AutoDerived: 1,
  Lio_scalaland_chimney_Transformer: 1
}));
export { $d_Lframework_utils_UnvalidatedNewtypeOf$$anon$1 as $d_Lframework_utils_UnvalidatedNewtypeOf$$anon$1 };
/** @constructor */
function $c_Lframework_utils_UnvalidatedNewtypeOf$$anon$4(outer) {
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lframework_utils_UnvalidatedNewtypeOf$$anon$4 as $c_Lframework_utils_UnvalidatedNewtypeOf$$anon$4 };
$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$4.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_s_Conversion();
$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$4.prototype.constructor = $c_Lframework_utils_UnvalidatedNewtypeOf$$anon$4;
/** @constructor */
function $h_Lframework_utils_UnvalidatedNewtypeOf$$anon$4() {
}
export { $h_Lframework_utils_UnvalidatedNewtypeOf$$anon$4 as $h_Lframework_utils_UnvalidatedNewtypeOf$$anon$4 };
$h_Lframework_utils_UnvalidatedNewtypeOf$$anon$4.prototype = $c_Lframework_utils_UnvalidatedNewtypeOf$$anon$4.prototype;
$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$4.prototype.apply__O__O = (function(a) {
  return a;
});
var $d_Lframework_utils_UnvalidatedNewtypeOf$$anon$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_UnvalidatedNewtypeOf$$anon$4, "framework.utils.UnvalidatedNewtypeOf$$anon$4", ({
  Lframework_utils_UnvalidatedNewtypeOf$$anon$4: 1,
  s_Conversion: 1,
  F1: 1
}));
export { $d_Lframework_utils_UnvalidatedNewtypeOf$$anon$4 as $d_Lframework_utils_UnvalidatedNewtypeOf$$anon$4 };
/** @constructor */
function $c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(outer) {
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5 as $c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5 };
$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5.prototype.constructor = $c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5;
/** @constructor */
function $h_Lframework_utils_UnvalidatedNewtypeOf$$anon$5() {
}
export { $h_Lframework_utils_UnvalidatedNewtypeOf$$anon$5 as $h_Lframework_utils_UnvalidatedNewtypeOf$$anon$5 };
$h_Lframework_utils_UnvalidatedNewtypeOf$$anon$5.prototype = $c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5.prototype;
$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5.prototype.transform__O__O = (function(a) {
  return a;
});
var $d_Lframework_utils_UnvalidatedNewtypeOf$$anon$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5, "framework.utils.UnvalidatedNewtypeOf$$anon$5", ({
  Lframework_utils_UnvalidatedNewtypeOf$$anon$5: 1,
  Lio_scalaland_chimney_Transformer$AutoDerived: 1,
  Lio_scalaland_chimney_Transformer: 1
}));
export { $d_Lframework_utils_UnvalidatedNewtypeOf$$anon$5 as $d_Lframework_utils_UnvalidatedNewtypeOf$$anon$5 };
/** @constructor */
function $c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(outer) {
  this.Lframework_utils_UnvalidatedNewtypeOf$$anon$6__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lframework_utils_UnvalidatedNewtypeOf$$anon$6__f_$outer = outer;
}
export { $c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6 as $c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6 };
$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6.prototype.constructor = $c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6;
/** @constructor */
function $h_Lframework_utils_UnvalidatedNewtypeOf$$anon$6() {
}
export { $h_Lframework_utils_UnvalidatedNewtypeOf$$anon$6 as $h_Lframework_utils_UnvalidatedNewtypeOf$$anon$6 };
$h_Lframework_utils_UnvalidatedNewtypeOf$$anon$6.prototype = $c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6.prototype;
$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6.prototype.transform__O__O = (function(validated) {
  var this$1 = this.Lframework_utils_UnvalidatedNewtypeOf$$anon$6__f_$outer;
  var this$2 = this$1.companionOfValidated__Lyantl_INewtype();
  return this$2.protected_unwrap__O__O(validated);
});
var $d_Lframework_utils_UnvalidatedNewtypeOf$$anon$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6, "framework.utils.UnvalidatedNewtypeOf$$anon$6", ({
  Lframework_utils_UnvalidatedNewtypeOf$$anon$6: 1,
  Lio_scalaland_chimney_Transformer$AutoDerived: 1,
  Lio_scalaland_chimney_Transformer: 1
}));
export { $d_Lframework_utils_UnvalidatedNewtypeOf$$anon$6 as $d_Lframework_utils_UnvalidatedNewtypeOf$$anon$6 };
function $p_Lfs2_CompositeFailure$__flattenExceptions$1__jl_Throwable__Lcats_data_NonEmptyList($thiz, throwable) {
  if ((throwable instanceof $c_Lfs2_CompositeFailure)) {
    var this$1 = throwable.Lfs2_CompositeFailure__f_tail;
    var a = throwable.Lfs2_CompositeFailure__f_head;
    return this$1.prepend__O__Lcats_data_NonEmptyList(a);
  } else {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_NonEmptyList$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_NonEmptyList$();
    var tail = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_NonEmptyList(throwable, tail);
  }
}
export { $p_Lfs2_CompositeFailure$__flattenExceptions$1__jl_Throwable__Lcats_data_NonEmptyList as $p_Lfs2_CompositeFailure$__flattenExceptions$1__jl_Throwable__Lcats_data_NonEmptyList };
/** @constructor */
function $c_Lfs2_CompositeFailure$() {
}
export { $c_Lfs2_CompositeFailure$ as $c_Lfs2_CompositeFailure$ };
$c_Lfs2_CompositeFailure$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_CompositeFailure$.prototype.constructor = $c_Lfs2_CompositeFailure$;
/** @constructor */
function $h_Lfs2_CompositeFailure$() {
}
export { $h_Lfs2_CompositeFailure$ as $h_Lfs2_CompositeFailure$ };
$h_Lfs2_CompositeFailure$.prototype = $c_Lfs2_CompositeFailure$.prototype;
$c_Lfs2_CompositeFailure$.prototype.apply__jl_Throwable__jl_Throwable__sci_List__Lfs2_CompositeFailure = (function(first, second, rest) {
  return this.apply__jl_Throwable__Lcats_data_NonEmptyList__Lfs2_CompositeFailure(first, ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_NonEmptyList$(), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_NonEmptyList(second, rest)));
});
$c_Lfs2_CompositeFailure$.prototype.apply__jl_Throwable__Lcats_data_NonEmptyList__Lfs2_CompositeFailure = (function(first, rest) {
  if ((first instanceof $c_Lfs2_CompositeFailure)) {
    var f = ((throwable) => $p_Lfs2_CompositeFailure$__flattenExceptions$1__jl_Throwable__Lcats_data_NonEmptyList(this, throwable));
    var x0 = rest.Lcats_data_NonEmptyList__f_head;
    var this$6 = f(x0);
    var this$2 = rest.Lcats_data_NonEmptyList__f_tail;
    var rest$1 = this$2;
    var h = null;
    var t = null;
    while ((rest$1 !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
      var x0$1 = rest$1.head__O();
      var this$3 = f(x0$1);
      var this$4 = this$3.Lcats_data_NonEmptyList__f_tail;
      var elem = this$3.Lcats_data_NonEmptyList__f_head;
      var this$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem, this$4);
      var it = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$5);
      while (it.hasNext__Z()) {
        var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(it.next__O(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
        if ((t === null)) {
          h = nx;
        } else {
          t.sci_$colon$colon__f_next = nx;
        }
        t = nx;
      }
      rest$1 = rest$1.tail__O();
    }
    var l = ((h === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$() : h);
    var this$7 = this$6.concat__sci_List__Lcats_data_NonEmptyList(l);
    var other = first.Lfs2_CompositeFailure__f_tail;
    var tail = other.concatNel__Lcats_data_NonEmptyList__Lcats_data_NonEmptyList(this$7);
    return new $c_Lfs2_CompositeFailure(first.Lfs2_CompositeFailure__f_head, tail);
  } else {
    var f$1 = ((throwable$2) => $p_Lfs2_CompositeFailure$__flattenExceptions$1__jl_Throwable__Lcats_data_NonEmptyList(this, throwable$2));
    var x0$2 = rest.Lcats_data_NonEmptyList__f_head;
    var this$12 = f$1(x0$2);
    var this$8 = rest.Lcats_data_NonEmptyList__f_tail;
    var rest$2 = this$8;
    var h$1 = null;
    var t$1 = null;
    while ((rest$2 !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
      var x0$3 = rest$2.head__O();
      var this$9 = f$1(x0$3);
      var this$10 = this$9.Lcats_data_NonEmptyList__f_tail;
      var elem$1 = this$9.Lcats_data_NonEmptyList__f_head;
      var this$11 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem$1, this$10);
      var it$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$11);
      while (it$1.hasNext__Z()) {
        var nx$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(it$1.next__O(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
        if ((t$1 === null)) {
          h$1 = nx$1;
        } else {
          t$1.sci_$colon$colon__f_next = nx$1;
        }
        t$1 = nx$1;
      }
      rest$2 = rest$2.tail__O();
    }
    var l$1 = ((h$1 === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$() : h$1);
    return new $c_Lfs2_CompositeFailure(first, this$12.concat__sci_List__Lcats_data_NonEmptyList(l$1));
  }
});
$c_Lfs2_CompositeFailure$.prototype.fromList__sci_List__s_Option = (function(errors) {
  var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  if (x.equals__O__Z(errors)) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
  if ((errors instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon)) {
    var x27 = errors.sci_$colon$colon__f_head;
    var x28 = errors.sci_$colon$colon__f_next;
    var x$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    if (x$3.equals__O__Z(x28)) {
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(x27);
    }
    if ((x28 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon)) {
      var x25 = x28.sci_$colon$colon__f_next;
      var second = x28.sci_$colon$colon__f_head;
      var value = this.apply__jl_Throwable__jl_Throwable__sci_List__Lfs2_CompositeFailure(x27, second, x25);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
    }
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(errors);
});
$c_Lfs2_CompositeFailure$.prototype.fromResults__s_util_Either__s_util_Either__s_util_Either = (function(first, second) {
  if ((first instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
    return second;
  }
  if ((first instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
    var err = first.s_util_Left__f_value;
    if ((second instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
      var value = err;
    } else {
      if ((!(second instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left))) {
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(second);
      }
      var a = second.s_util_Left__f_value;
      var value = $m_Lfs2_CompositeFailure$().apply__jl_Throwable__jl_Throwable__sci_List__Lfs2_CompositeFailure(err, a, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
    }
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(first);
});
$c_Lfs2_CompositeFailure$.prototype.fromProduct__s_Product__Lfs2_CompositeFailure = (function(x$0) {
  return new $c_Lfs2_CompositeFailure(x$0.productElement__I__O(0), x$0.productElement__I__O(1));
});
$c_Lfs2_CompositeFailure$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lfs2_CompositeFailure(p);
});
var $d_Lfs2_CompositeFailure$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_CompositeFailure$, "fs2.CompositeFailure$", ({
  Lfs2_CompositeFailure$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lfs2_CompositeFailure$ as $d_Lfs2_CompositeFailure$ };
var $n_Lfs2_CompositeFailure$;
function $m_Lfs2_CompositeFailure$() {
  if ((!$n_Lfs2_CompositeFailure$)) {
    $n_Lfs2_CompositeFailure$ = new $c_Lfs2_CompositeFailure$();
  }
  return $n_Lfs2_CompositeFailure$;
}
export { $m_Lfs2_CompositeFailure$ as $m_Lfs2_CompositeFailure$ };
/** @constructor */
function $c_Lfs2_Pull$Action() {
}
export { $c_Lfs2_Pull$Action as $c_Lfs2_Pull$Action };
$c_Lfs2_Pull$Action.prototype = new $h_Lfs2_Pull();
$c_Lfs2_Pull$Action.prototype.constructor = $c_Lfs2_Pull$Action;
/** @constructor */
function $h_Lfs2_Pull$Action() {
}
export { $h_Lfs2_Pull$Action as $h_Lfs2_Pull$Action };
$h_Lfs2_Pull$Action.prototype = $c_Lfs2_Pull$Action.prototype;
function $isArrayOf_Lfs2_Pull$Action(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Action)));
}
export { $isArrayOf_Lfs2_Pull$Action as $isArrayOf_Lfs2_Pull$Action };
/** @constructor */
function $c_Lfs2_Pull$IdContP$() {
}
export { $c_Lfs2_Pull$IdContP$ as $c_Lfs2_Pull$IdContP$ };
$c_Lfs2_Pull$IdContP$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_Pull$IdContP$.prototype.constructor = $c_Lfs2_Pull$IdContP$;
/** @constructor */
function $h_Lfs2_Pull$IdContP$() {
}
export { $h_Lfs2_Pull$IdContP$ as $h_Lfs2_Pull$IdContP$ };
$h_Lfs2_Pull$IdContP$.prototype = $c_Lfs2_Pull$IdContP$.prototype;
$c_Lfs2_Pull$IdContP$.prototype.compose__F1__F1 = (function(g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_F1__compose__F1__F1(this, g);
});
$c_Lfs2_Pull$IdContP$.prototype.andThen__F1__F1 = (function(g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_F1__andThen__F1__F1(this, g);
});
$c_Lfs2_Pull$IdContP$.prototype.toString__T = (function() {
  return "<function1>";
});
$c_Lfs2_Pull$IdContP$.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(r) {
  return r;
});
$c_Lfs2_Pull$IdContP$.prototype.apply__O__O = (function(v1) {
  return v1;
});
$c_Lfs2_Pull$IdContP$.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return v1;
});
var $d_Lfs2_Pull$IdContP$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$IdContP$, "fs2.Pull$IdContP$", ({
  Lfs2_Pull$IdContP$: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
}));
export { $d_Lfs2_Pull$IdContP$ as $d_Lfs2_Pull$IdContP$ };
var $n_Lfs2_Pull$IdContP$;
function $m_Lfs2_Pull$IdContP$() {
  if ((!$n_Lfs2_Pull$IdContP$)) {
    $n_Lfs2_Pull$IdContP$ = new $c_Lfs2_Pull$IdContP$();
  }
  return $n_Lfs2_Pull$IdContP$;
}
export { $m_Lfs2_Pull$IdContP$ as $m_Lfs2_Pull$IdContP$ };
/** @constructor */
function $c_Lfs2_Pull$IdOps$$anon$10(evidence$1$2) {
  this.Lfs2_Pull$IdOps$$anon$10__f_evidence$1$1 = null;
  this.Lfs2_Pull$IdOps$$anon$10__f_evidence$1$1 = evidence$1$2;
}
export { $c_Lfs2_Pull$IdOps$$anon$10 as $c_Lfs2_Pull$IdOps$$anon$10 };
$c_Lfs2_Pull$IdOps$$anon$10.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_Pull$IdOps$$anon$10.prototype.constructor = $c_Lfs2_Pull$IdOps$$anon$10;
/** @constructor */
function $h_Lfs2_Pull$IdOps$$anon$10() {
}
export { $h_Lfs2_Pull$IdOps$$anon$10 as $h_Lfs2_Pull$IdOps$$anon$10 };
$h_Lfs2_Pull$IdOps$$anon$10.prototype = $c_Lfs2_Pull$IdOps$$anon$10.prototype;
$c_Lfs2_Pull$IdOps$$anon$10.prototype.apply__O__O = (function(a) {
  var F = this.Lfs2_Pull$IdOps$$anon$10__f_evidence$1$1;
  return F.pure__O__O(a);
});
var $d_Lfs2_Pull$IdOps$$anon$10 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$IdOps$$anon$10, "fs2.Pull$IdOps$$anon$10", ({
  Lfs2_Pull$IdOps$$anon$10: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
}));
export { $d_Lfs2_Pull$IdOps$$anon$10 as $d_Lfs2_Pull$IdOps$$anon$10 };
/** @constructor */
function $c_Lfs2_Pull$StepLegRunR$1(scope$38, extendedTopLevelScope$36, translation$tailLocal1$39, runner$tailLocal1$36, F$52, extendLastTopLevelScope$39, contP$42, TheBuildR$lzy1$42, outer, view) {
  this.Lfs2_Pull$StepRunR$1__f_extendedTopLevelScope$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_translation$tailLocal1$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_runner$tailLocal1$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_scope$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_F$17 = null;
  this.Lfs2_Pull$StepRunR$1__f_extendLastTopLevelScope$8 = false;
  this.Lfs2_Pull$StepRunR$1__f_contP$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_TheBuildR$lzy1$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_view = null;
  this.Lfs2_Pull$StepLegRunR$1__f_scope$11 = null;
  this.Lfs2_Pull$StepLegRunR$1__f_extendedTopLevelScope$9 = null;
  this.Lfs2_Pull$StepLegRunR$1__f_translation$tailLocal1$9 = null;
  this.Lfs2_Pull$StepLegRunR$1__f_runner$tailLocal1$9 = null;
  this.Lfs2_Pull$StepLegRunR$1__f_F$19 = null;
  this.Lfs2_Pull$StepLegRunR$1__f_extendLastTopLevelScope$10 = false;
  this.Lfs2_Pull$StepLegRunR$1__f_contP$12 = null;
  this.Lfs2_Pull$StepLegRunR$1__f_TheBuildR$lzy1$12 = null;
  this.Lfs2_Pull$StepLegRunR$1__f_view = null;
  this.Lfs2_Pull$StepLegRunR$1__f_scope$11 = scope$38;
  this.Lfs2_Pull$StepLegRunR$1__f_extendedTopLevelScope$9 = extendedTopLevelScope$36;
  this.Lfs2_Pull$StepLegRunR$1__f_translation$tailLocal1$9 = translation$tailLocal1$39;
  this.Lfs2_Pull$StepLegRunR$1__f_runner$tailLocal1$9 = runner$tailLocal1$36;
  this.Lfs2_Pull$StepLegRunR$1__f_F$19 = F$52;
  this.Lfs2_Pull$StepLegRunR$1__f_extendLastTopLevelScope$10 = extendLastTopLevelScope$39;
  this.Lfs2_Pull$StepLegRunR$1__f_contP$12 = contP$42;
  this.Lfs2_Pull$StepLegRunR$1__f_TheBuildR$lzy1$12 = TheBuildR$lzy1$42;
  this.Lfs2_Pull$StepLegRunR$1__f_view = view;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  $ct_Lfs2_Pull$StepRunR$1__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_internal_Scope__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__F1__(this, extendedTopLevelScope$36, translation$tailLocal1$39, runner$tailLocal1$36, scope$38, F$52, extendLastTopLevelScope$39, contP$42, TheBuildR$lzy1$42, view);
}
export { $c_Lfs2_Pull$StepLegRunR$1 as $c_Lfs2_Pull$StepLegRunR$1 };
$c_Lfs2_Pull$StepLegRunR$1.prototype = new $h_Lfs2_Pull$StepRunR$1();
$c_Lfs2_Pull$StepLegRunR$1.prototype.constructor = $c_Lfs2_Pull$StepLegRunR$1;
/** @constructor */
function $h_Lfs2_Pull$StepLegRunR$1() {
}
export { $h_Lfs2_Pull$StepLegRunR$1 as $h_Lfs2_Pull$StepLegRunR$1 };
$h_Lfs2_Pull$StepLegRunR$1.prototype = $c_Lfs2_Pull$StepLegRunR$1.prototype;
$c_Lfs2_Pull$StepLegRunR$1.prototype.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O = (function(head, outScope, tail) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$interruptGuard$1__Lcats_MonadError__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__F1__F0__O(this.Lfs2_Pull$StepLegRunR$1__f_F$19, this.Lfs2_Pull$StepLegRunR$1__f_extendedTopLevelScope$9, this.Lfs2_Pull$StepLegRunR$1__f_translation$tailLocal1$9, this.Lfs2_Pull$StepLegRunR$1__f_runner$tailLocal1$9, this.Lfs2_Pull$StepLegRunR$1__f_extendLastTopLevelScope$10, this.Lfs2_Pull$StepLegRunR$1__f_contP$12, this.Lfs2_Pull$StepLegRunR$1__f_TheBuildR$lzy1$12, this.Lfs2_Pull$StepLegRunR$1__f_scope$11, this.Lfs2_Pull$StepLegRunR$1__f_view, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    var value = new $c_Lfs2_Stream$StepLeg(head, outScope.Lfs2_internal_Scope__f_id, tail);
    var r = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
    var result = new $c_Lfs2_Pull$Succeeded(r);
    return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$StepLegRunR$1__f_F$19, this.Lfs2_Pull$StepLegRunR$1__f_extendLastTopLevelScope$10, this.Lfs2_Pull$StepLegRunR$1__f_contP$12, this.Lfs2_Pull$StepLegRunR$1__f_TheBuildR$lzy1$12, this.Lfs2_Pull$StepLegRunR$1__f_scope$11, this.Lfs2_Pull$StepLegRunR$1__f_extendedTopLevelScope$9, this.Lfs2_Pull$StepLegRunR$1__f_translation$tailLocal1$9, this.Lfs2_Pull$StepLegRunR$1__f_runner$tailLocal1$9, this.Lfs2_Pull$StepLegRunR$1__f_view.apply__O__O(result));
  })));
});
var $d_Lfs2_Pull$StepLegRunR$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$StepLegRunR$1, "fs2.Pull$StepLegRunR$1", ({
  Lfs2_Pull$StepLegRunR$1: 1,
  Lfs2_Pull$StepRunR$1: 1,
  Lfs2_Pull$Run$1: 1
}));
export { $d_Lfs2_Pull$StepLegRunR$1 as $d_Lfs2_Pull$StepLegRunR$1 };
/** @constructor */
function $c_Lfs2_Pull$Terminal() {
}
export { $c_Lfs2_Pull$Terminal as $c_Lfs2_Pull$Terminal };
$c_Lfs2_Pull$Terminal.prototype = new $h_Lfs2_Pull();
$c_Lfs2_Pull$Terminal.prototype.constructor = $c_Lfs2_Pull$Terminal;
/** @constructor */
function $h_Lfs2_Pull$Terminal() {
}
export { $h_Lfs2_Pull$Terminal as $h_Lfs2_Pull$Terminal };
$h_Lfs2_Pull$Terminal.prototype = $c_Lfs2_Pull$Terminal.prototype;
function $isArrayOf_Lfs2_Pull$Terminal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Terminal)));
}
export { $isArrayOf_Lfs2_Pull$Terminal as $isArrayOf_Lfs2_Pull$Terminal };
/** @constructor */
function $c_Lfs2_Pull$UnconsRunR$1(extendedTopLevelScope$35, translation$tailLocal1$38, runner$tailLocal1$35, scope$37, F$51, extendLastTopLevelScope$38, contP$41, TheBuildR$lzy1$41, outer, view) {
  this.Lfs2_Pull$StepRunR$1__f_extendedTopLevelScope$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_translation$tailLocal1$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_runner$tailLocal1$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_scope$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_F$17 = null;
  this.Lfs2_Pull$StepRunR$1__f_extendLastTopLevelScope$8 = false;
  this.Lfs2_Pull$StepRunR$1__f_contP$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_TheBuildR$lzy1$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_view = null;
  this.Lfs2_Pull$UnconsRunR$1__f_extendedTopLevelScope$8 = null;
  this.Lfs2_Pull$UnconsRunR$1__f_translation$tailLocal1$8 = null;
  this.Lfs2_Pull$UnconsRunR$1__f_runner$tailLocal1$8 = null;
  this.Lfs2_Pull$UnconsRunR$1__f_F$18 = null;
  this.Lfs2_Pull$UnconsRunR$1__f_extendLastTopLevelScope$9 = false;
  this.Lfs2_Pull$UnconsRunR$1__f_contP$11 = null;
  this.Lfs2_Pull$UnconsRunR$1__f_TheBuildR$lzy1$11 = null;
  this.Lfs2_Pull$UnconsRunR$1__f_view = null;
  this.Lfs2_Pull$UnconsRunR$1__f_extendedTopLevelScope$8 = extendedTopLevelScope$35;
  this.Lfs2_Pull$UnconsRunR$1__f_translation$tailLocal1$8 = translation$tailLocal1$38;
  this.Lfs2_Pull$UnconsRunR$1__f_runner$tailLocal1$8 = runner$tailLocal1$35;
  this.Lfs2_Pull$UnconsRunR$1__f_F$18 = F$51;
  this.Lfs2_Pull$UnconsRunR$1__f_extendLastTopLevelScope$9 = extendLastTopLevelScope$38;
  this.Lfs2_Pull$UnconsRunR$1__f_contP$11 = contP$41;
  this.Lfs2_Pull$UnconsRunR$1__f_TheBuildR$lzy1$11 = TheBuildR$lzy1$41;
  this.Lfs2_Pull$UnconsRunR$1__f_view = view;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  $ct_Lfs2_Pull$StepRunR$1__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_internal_Scope__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__F1__(this, extendedTopLevelScope$35, translation$tailLocal1$38, runner$tailLocal1$35, scope$37, F$51, extendLastTopLevelScope$38, contP$41, TheBuildR$lzy1$41, view);
}
export { $c_Lfs2_Pull$UnconsRunR$1 as $c_Lfs2_Pull$UnconsRunR$1 };
$c_Lfs2_Pull$UnconsRunR$1.prototype = new $h_Lfs2_Pull$StepRunR$1();
$c_Lfs2_Pull$UnconsRunR$1.prototype.constructor = $c_Lfs2_Pull$UnconsRunR$1;
/** @constructor */
function $h_Lfs2_Pull$UnconsRunR$1() {
}
export { $h_Lfs2_Pull$UnconsRunR$1 as $h_Lfs2_Pull$UnconsRunR$1 };
$h_Lfs2_Pull$UnconsRunR$1.prototype = $c_Lfs2_Pull$UnconsRunR$1.prototype;
$c_Lfs2_Pull$UnconsRunR$1.prototype.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O = (function(head, outScope, tail) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$interruptGuard$1__Lcats_MonadError__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__F1__F0__O(this.Lfs2_Pull$UnconsRunR$1__f_F$18, this.Lfs2_Pull$UnconsRunR$1__f_extendedTopLevelScope$8, this.Lfs2_Pull$UnconsRunR$1__f_translation$tailLocal1$8, this.Lfs2_Pull$UnconsRunR$1__f_runner$tailLocal1$8, this.Lfs2_Pull$UnconsRunR$1__f_extendLastTopLevelScope$9, this.Lfs2_Pull$UnconsRunR$1__f_contP$11, this.Lfs2_Pull$UnconsRunR$1__f_TheBuildR$lzy1$11, outScope, this.Lfs2_Pull$UnconsRunR$1__f_view, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    var value = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), head, tail);
    var r = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
    var result = new $c_Lfs2_Pull$Succeeded(r);
    return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$UnconsRunR$1__f_F$18, this.Lfs2_Pull$UnconsRunR$1__f_extendLastTopLevelScope$9, this.Lfs2_Pull$UnconsRunR$1__f_contP$11, this.Lfs2_Pull$UnconsRunR$1__f_TheBuildR$lzy1$11, outScope, this.Lfs2_Pull$UnconsRunR$1__f_extendedTopLevelScope$8, this.Lfs2_Pull$UnconsRunR$1__f_translation$tailLocal1$8, this.Lfs2_Pull$UnconsRunR$1__f_runner$tailLocal1$8, this.Lfs2_Pull$UnconsRunR$1__f_view.apply__O__O(result));
  })));
});
var $d_Lfs2_Pull$UnconsRunR$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$UnconsRunR$1, "fs2.Pull$UnconsRunR$1", ({
  Lfs2_Pull$UnconsRunR$1: 1,
  Lfs2_Pull$StepRunR$1: 1,
  Lfs2_Pull$Run$1: 1
}));
export { $d_Lfs2_Pull$UnconsRunR$1 as $d_Lfs2_Pull$UnconsRunR$1 };
/** @constructor */
function $c_Lfs2_concurrent_Channel$State$3$() {
}
export { $c_Lfs2_concurrent_Channel$State$3$ as $c_Lfs2_concurrent_Channel$State$3$ };
$c_Lfs2_concurrent_Channel$State$3$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_concurrent_Channel$State$3$.prototype.constructor = $c_Lfs2_concurrent_Channel$State$3$;
/** @constructor */
function $h_Lfs2_concurrent_Channel$State$3$() {
}
export { $h_Lfs2_concurrent_Channel$State$3$ as $h_Lfs2_concurrent_Channel$State$3$ };
$h_Lfs2_concurrent_Channel$State$3$.prototype = $c_Lfs2_concurrent_Channel$State$3$.prototype;
$c_Lfs2_concurrent_Channel$State$3$.prototype.toString__T = (function() {
  return "State";
});
$c_Lfs2_concurrent_Channel$State$3$.prototype.fromProduct__s_Product__Lfs2_concurrent_Channel$State$1 = (function(x$0) {
  return new $c_Lfs2_concurrent_Channel$State$1(x$0.productElement__I__O(0), (x$0.productElement__I__O(1) | 0), x$0.productElement__I__O(2), x$0.productElement__I__O(3), (!(!x$0.productElement__I__O(4))));
});
$c_Lfs2_concurrent_Channel$State$3$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lfs2_concurrent_Channel$State$1(p);
});
var $d_Lfs2_concurrent_Channel$State$3$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_concurrent_Channel$State$3$, "fs2.concurrent.Channel$State$3$", ({
  Lfs2_concurrent_Channel$State$3$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lfs2_concurrent_Channel$State$3$ as $d_Lfs2_concurrent_Channel$State$3$ };
/** @constructor */
function $c_Lfs2_concurrent_SignallingRef$State$3$() {
}
export { $c_Lfs2_concurrent_SignallingRef$State$3$ as $c_Lfs2_concurrent_SignallingRef$State$3$ };
$c_Lfs2_concurrent_SignallingRef$State$3$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_concurrent_SignallingRef$State$3$.prototype.constructor = $c_Lfs2_concurrent_SignallingRef$State$3$;
/** @constructor */
function $h_Lfs2_concurrent_SignallingRef$State$3$() {
}
export { $h_Lfs2_concurrent_SignallingRef$State$3$ as $h_Lfs2_concurrent_SignallingRef$State$3$ };
$h_Lfs2_concurrent_SignallingRef$State$3$.prototype = $c_Lfs2_concurrent_SignallingRef$State$3$.prototype;
$c_Lfs2_concurrent_SignallingRef$State$3$.prototype.toString__T = (function() {
  return "State";
});
$c_Lfs2_concurrent_SignallingRef$State$3$.prototype.fromProduct__s_Product__Lfs2_concurrent_SignallingRef$State$1 = (function(x$0) {
  return new $c_Lfs2_concurrent_SignallingRef$State$1(x$0.productElement__I__O(0), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(x$0.productElement__I__O(1)), x$0.productElement__I__O(2));
});
$c_Lfs2_concurrent_SignallingRef$State$3$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lfs2_concurrent_SignallingRef$State$1(p);
});
var $d_Lfs2_concurrent_SignallingRef$State$3$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_concurrent_SignallingRef$State$3$, "fs2.concurrent.SignallingRef$State$3$", ({
  Lfs2_concurrent_SignallingRef$State$3$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lfs2_concurrent_SignallingRef$State$3$ as $d_Lfs2_concurrent_SignallingRef$State$3$ };
/** @constructor */
function $c_Lfs2_internal_Scope$$anon$2(outer) {
  this.Lfs2_internal_Scope$$anon$2__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lfs2_internal_Scope$$anon$2__f_$outer = outer;
}
export { $c_Lfs2_internal_Scope$$anon$2 as $c_Lfs2_internal_Scope$$anon$2 };
$c_Lfs2_internal_Scope$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_internal_Scope$$anon$2.prototype.constructor = $c_Lfs2_internal_Scope$$anon$2;
/** @constructor */
function $h_Lfs2_internal_Scope$$anon$2() {
}
export { $h_Lfs2_internal_Scope$$anon$2 as $h_Lfs2_internal_Scope$$anon$2 };
$h_Lfs2_internal_Scope$$anon$2.prototype = $c_Lfs2_internal_Scope$$anon$2.prototype;
$c_Lfs2_internal_Scope$$anon$2.prototype.cancel__O = (function() {
  var this$1 = this.Lfs2_internal_Scope$$anon$2__f_$outer.Lfs2_internal_Scope__f_F;
  return this$1.F__Lcats_effect_kernel_MonadCancel().pure__O__O((void 0));
});
$c_Lfs2_internal_Scope$$anon$2.prototype.join__O = (function() {
  var this$3 = this.Lfs2_internal_Scope$$anon$2__f_$outer.Lfs2_internal_Scope__f_F;
  var this$1 = this.Lfs2_internal_Scope$$anon$2__f_$outer.Lfs2_internal_Scope__f_F;
  var fa = this$1.F__Lcats_effect_kernel_MonadCancel().pure__O__O((void 0));
  var a = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Succeeded(fa);
  return this$3.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a);
});
var $d_Lfs2_internal_Scope$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_internal_Scope$$anon$2, "fs2.internal.Scope$$anon$2", ({
  Lfs2_internal_Scope$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Fiber: 1
}));
export { $d_Lfs2_internal_Scope$$anon$2 as $d_Lfs2_internal_Scope$$anon$2 };
/** @constructor */
function $c_Lfs2_internal_Scope$State$() {
  this.Lfs2_internal_Scope$State$__f_initial_ = null;
  this.Lfs2_internal_Scope$State$__f_closed_ = null;
  $n_Lfs2_internal_Scope$State$ = this;
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_Chain$();
  var resources = this$1.Lcats_data_Chain$__f_nil;
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_Chain$();
  var children = this$2.Lcats_data_Chain$__f_nil;
  this.Lfs2_internal_Scope$State$__f_initial_ = new $c_Lfs2_internal_Scope$State$Open(resources, children);
  this.Lfs2_internal_Scope$State$__f_closed_ = new $c_Lfs2_internal_Scope$State$Closed();
}
export { $c_Lfs2_internal_Scope$State$ as $c_Lfs2_internal_Scope$State$ };
$c_Lfs2_internal_Scope$State$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_internal_Scope$State$.prototype.constructor = $c_Lfs2_internal_Scope$State$;
/** @constructor */
function $h_Lfs2_internal_Scope$State$() {
}
export { $h_Lfs2_internal_Scope$State$ as $h_Lfs2_internal_Scope$State$ };
$h_Lfs2_internal_Scope$State$.prototype = $c_Lfs2_internal_Scope$State$.prototype;
$c_Lfs2_internal_Scope$State$.prototype.ordinal__Lfs2_internal_Scope$State__I = (function(x$0) {
  if ((x$0 instanceof $c_Lfs2_internal_Scope$State$Open)) {
    return 0;
  }
  if ((x$0 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
    return 1;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$0);
});
$c_Lfs2_internal_Scope$State$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Lfs2_internal_Scope$State__I(x);
});
var $d_Lfs2_internal_Scope$State$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_internal_Scope$State$, "fs2.internal.Scope$State$", ({
  Lfs2_internal_Scope$State$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lfs2_internal_Scope$State$ as $d_Lfs2_internal_Scope$State$ };
var $n_Lfs2_internal_Scope$State$;
function $m_Lfs2_internal_Scope$State$() {
  if ((!$n_Lfs2_internal_Scope$State$)) {
    $n_Lfs2_internal_Scope$State$ = new $c_Lfs2_internal_Scope$State$();
  }
  return $n_Lfs2_internal_Scope$State$;
}
export { $m_Lfs2_internal_Scope$State$ as $m_Lfs2_internal_Scope$State$ };
/** @constructor */
function $c_Lio_circe_Decoder$$anon$36(f$21) {
  this.Lio_circe_Decoder$$anon$36__f_f$10 = null;
  this.Lio_circe_Decoder$$anon$36__f_f$10 = f$21;
}
export { $c_Lio_circe_Decoder$$anon$36 as $c_Lio_circe_Decoder$$anon$36 };
$c_Lio_circe_Decoder$$anon$36.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_circe_Decoder$$anon$36.prototype.constructor = $c_Lio_circe_Decoder$$anon$36;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$36() {
}
export { $h_Lio_circe_Decoder$$anon$36 as $h_Lio_circe_Decoder$$anon$36 };
$h_Lio_circe_Decoder$$anon$36.prototype = $c_Lio_circe_Decoder$$anon$36.prototype;
$c_Lio_circe_Decoder$$anon$36.prototype.decodeAccumulating__Lio_circe_HCursor__Lcats_data_Validated = (function(c) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lio_circe_Decoder__decodeAccumulating__Lio_circe_HCursor__Lcats_data_Validated(this, c);
});
$c_Lio_circe_Decoder$$anon$36.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$c_Lio_circe_Decoder$$anon$36.prototype.tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated = (function(c) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lio_circe_Decoder__tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated(this, c);
});
$c_Lio_circe_Decoder$$anon$36.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  return this.Lio_circe_Decoder$$anon$36__f_f$10.apply__O__O(c);
});
var $d_Lio_circe_Decoder$$anon$36 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_circe_Decoder$$anon$36, "io.circe.Decoder$$anon$36", ({
  Lio_circe_Decoder$$anon$36: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
}));
export { $d_Lio_circe_Decoder$$anon$36 as $d_Lio_circe_Decoder$$anon$36 };
/** @constructor */
function $c_Lio_circe_Decoder$OptionDecoder(A) {
  this.Lio_circe_Decoder$OptionDecoder__f_A = null;
  this.Lio_circe_Decoder$OptionDecoder__f_A = A;
}
export { $c_Lio_circe_Decoder$OptionDecoder as $c_Lio_circe_Decoder$OptionDecoder };
$c_Lio_circe_Decoder$OptionDecoder.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_circe_Decoder$OptionDecoder.prototype.constructor = $c_Lio_circe_Decoder$OptionDecoder;
/** @constructor */
function $h_Lio_circe_Decoder$OptionDecoder() {
}
export { $h_Lio_circe_Decoder$OptionDecoder as $h_Lio_circe_Decoder$OptionDecoder };
$h_Lio_circe_Decoder$OptionDecoder.prototype = $c_Lio_circe_Decoder$OptionDecoder.prototype;
$c_Lio_circe_Decoder$OptionDecoder.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  return this.tryDecode__Lio_circe_ACursor__s_util_Either(c);
});
$c_Lio_circe_Decoder$OptionDecoder.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  if ((c instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lio_circe_HCursor)) {
    if (c.value__Lio_circe_Json().isNull__Z()) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_io$circe$Decoder$$$rightNone;
    } else {
      var x289 = this.Lio_circe_Decoder$OptionDecoder__f_A.apply__Lio_circe_HCursor__s_util_Either(c);
      if ((x289 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
        var a = x289.s_util_Right__f_value;
        var value = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(a);
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value);
      }
      if ((x289 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
        var df = x289.s_util_Left__f_value;
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(df);
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x289);
    }
  }
  if ((c instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lio_circe_FailedCursor)) {
    if ((!c.incorrectFocus__Z())) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_keyMissingNone;
    } else {
      var value$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_DecodingFailure$().apply__Lio_circe_DecodingFailure$Reason__F0__Lio_circe_DecodingFailure($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_DecodingFailure$Reason$MissingField$(), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((c$4) => (() => c$4.history__sci_List()))(c)));
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value$1);
    }
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(c);
});
$c_Lio_circe_Decoder$OptionDecoder.prototype.decodeAccumulating__Lio_circe_HCursor__Lcats_data_Validated = (function(c) {
  return this.tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated(c);
});
$c_Lio_circe_Decoder$OptionDecoder.prototype.tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated = (function(c) {
  if ((c instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lio_circe_HCursor)) {
    if (c.value__Lio_circe_Json().isNull__Z()) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_io$circe$Decoder$$$validNone;
    } else {
      var x297 = this.Lio_circe_Decoder$OptionDecoder__f_A.decodeAccumulating__Lio_circe_HCursor__Lcats_data_Validated(c);
      if ((x297 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_Validated$Valid)) {
        var x303 = x297.Lcats_data_Validated$Valid__f_a;
        var a = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(x303);
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_Validated$Valid(a);
      }
      if ((x297 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_Validated$Invalid)) {
        return x297;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x297);
    }
  }
  if ((c instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lio_circe_FailedCursor)) {
    if ((!c.incorrectFocus__Z())) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_keyMissingNoneAccumulating;
    } else {
      var this$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_Validated$();
      var e = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_DecodingFailure$().apply__Lio_circe_DecodingFailure$Reason__F0__Lio_circe_DecodingFailure($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_DecodingFailure$Reason$MissingField$(), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((c$4) => (() => c$4.history__sci_List()))(c)));
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_data_ValidatedFunctions__invalidNel__O__Lcats_data_Validated(this$5, e);
    }
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(c);
});
var $d_Lio_circe_Decoder$OptionDecoder = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_circe_Decoder$OptionDecoder, "io.circe.Decoder$OptionDecoder", ({
  Lio_circe_Decoder$OptionDecoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
}));
export { $d_Lio_circe_Decoder$OptionDecoder as $d_Lio_circe_Decoder$OptionDecoder };
/** @constructor */
function $c_Lio_circe_Encoder$$anon$25(e$4) {
  this.Lio_circe_Encoder$$anon$25__f_e$2 = null;
  this.Lio_circe_Encoder$$anon$25__f_e$2 = e$4;
}
export { $c_Lio_circe_Encoder$$anon$25 as $c_Lio_circe_Encoder$$anon$25 };
$c_Lio_circe_Encoder$$anon$25.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_circe_Encoder$$anon$25.prototype.constructor = $c_Lio_circe_Encoder$$anon$25;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$25() {
}
export { $h_Lio_circe_Encoder$$anon$25 as $h_Lio_circe_Encoder$$anon$25 };
$h_Lio_circe_Encoder$$anon$25.prototype = $c_Lio_circe_Encoder$$anon$25.prototype;
$c_Lio_circe_Encoder$$anon$25.prototype.apply__s_Option__Lio_circe_Json = (function(a) {
  if ((a instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
    var v = a.s_Some__f_value;
    return this.Lio_circe_Encoder$$anon$25__f_e$2.apply__O__Lio_circe_Json(v);
  }
  var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  if ((x === a)) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_Json$().Lio_circe_Json$__f_Null;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(a);
});
$c_Lio_circe_Encoder$$anon$25.prototype.apply__O__Lio_circe_Json = (function(a) {
  return this.apply__s_Option__Lio_circe_Json(a);
});
var $d_Lio_circe_Encoder$$anon$25 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_circe_Encoder$$anon$25, "io.circe.Encoder$$anon$25", ({
  Lio_circe_Encoder$$anon$25: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1
}));
export { $d_Lio_circe_Encoder$$anon$25 as $d_Lio_circe_Encoder$$anon$25 };
/** @constructor */
function $c_Lio_circe_KeyDecoder$$anon$12(f$11) {
  this.Lio_circe_KeyDecoder$$anon$12__f_f$5 = null;
  this.Lio_circe_KeyDecoder$$anon$12__f_f$5 = f$11;
}
export { $c_Lio_circe_KeyDecoder$$anon$12 as $c_Lio_circe_KeyDecoder$$anon$12 };
$c_Lio_circe_KeyDecoder$$anon$12.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_circe_KeyDecoder$$anon$12.prototype.constructor = $c_Lio_circe_KeyDecoder$$anon$12;
/** @constructor */
function $h_Lio_circe_KeyDecoder$$anon$12() {
}
export { $h_Lio_circe_KeyDecoder$$anon$12 as $h_Lio_circe_KeyDecoder$$anon$12 };
$h_Lio_circe_KeyDecoder$$anon$12.prototype = $c_Lio_circe_KeyDecoder$$anon$12.prototype;
$c_Lio_circe_KeyDecoder$$anon$12.prototype.apply__T__s_Option = (function(key) {
  return this.Lio_circe_KeyDecoder$$anon$12__f_f$5.apply__O__O(key);
});
var $d_Lio_circe_KeyDecoder$$anon$12 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_circe_KeyDecoder$$anon$12, "io.circe.KeyDecoder$$anon$12", ({
  Lio_circe_KeyDecoder$$anon$12: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_KeyDecoder: 1
}));
export { $d_Lio_circe_KeyDecoder$$anon$12 as $d_Lio_circe_KeyDecoder$$anon$12 };
function $isArrayOf_Lio_circe_KeyDecoder$AlwaysKeyDecoder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_KeyDecoder$AlwaysKeyDecoder)));
}
export { $isArrayOf_Lio_circe_KeyDecoder$AlwaysKeyDecoder as $isArrayOf_Lio_circe_KeyDecoder$AlwaysKeyDecoder };
/** @constructor */
function $c_Lio_circe_KeyEncoder$$anon$12(f$4) {
  this.Lio_circe_KeyEncoder$$anon$12__f_f$2 = null;
  this.Lio_circe_KeyEncoder$$anon$12__f_f$2 = f$4;
}
export { $c_Lio_circe_KeyEncoder$$anon$12 as $c_Lio_circe_KeyEncoder$$anon$12 };
$c_Lio_circe_KeyEncoder$$anon$12.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_circe_KeyEncoder$$anon$12.prototype.constructor = $c_Lio_circe_KeyEncoder$$anon$12;
/** @constructor */
function $h_Lio_circe_KeyEncoder$$anon$12() {
}
export { $h_Lio_circe_KeyEncoder$$anon$12 as $h_Lio_circe_KeyEncoder$$anon$12 };
$h_Lio_circe_KeyEncoder$$anon$12.prototype = $c_Lio_circe_KeyEncoder$$anon$12.prototype;
$c_Lio_circe_KeyEncoder$$anon$12.prototype.apply__O__T = (function(key) {
  return this.Lio_circe_KeyEncoder$$anon$12__f_f$2.apply__O__O(key);
});
var $d_Lio_circe_KeyEncoder$$anon$12 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_circe_KeyEncoder$$anon$12, "io.circe.KeyEncoder$$anon$12", ({
  Lio_circe_KeyEncoder$$anon$12: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_KeyEncoder: 1
}));
export { $d_Lio_circe_KeyEncoder$$anon$12 as $d_Lio_circe_KeyEncoder$$anon$12 };
function $ct_Lio_circe_MapDecoder__Lio_circe_KeyDecoder__Lio_circe_Decoder__($thiz, decodeK, decodeV) {
  $thiz.Lio_circe_MapDecoder__f_decodeK = decodeK;
  $thiz.Lio_circe_MapDecoder__f_decodeV = decodeV;
  $thiz.Lio_circe_MapDecoder__f_alwaysDecodeK = (false ? decodeK : null);
  return $thiz;
}
export { $ct_Lio_circe_MapDecoder__Lio_circe_KeyDecoder__Lio_circe_Decoder__ as $ct_Lio_circe_MapDecoder__Lio_circe_KeyDecoder__Lio_circe_Decoder__ };
function $p_Lio_circe_MapDecoder__createObjectCursor__Lio_circe_HCursor__Lio_circe_JsonObject__T__Lio_circe_HCursor($thiz, c, obj, key) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lio_circe_cursor_ObjectCursor(obj, key, c, false, c, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lio_circe_CursorOp$DownField(key));
}
export { $p_Lio_circe_MapDecoder__createObjectCursor__Lio_circe_HCursor__Lio_circe_JsonObject__T__Lio_circe_HCursor as $p_Lio_circe_MapDecoder__createObjectCursor__Lio_circe_HCursor__Lio_circe_JsonObject__T__Lio_circe_HCursor };
function $p_Lio_circe_MapDecoder__handleResult__O__Lio_circe_HCursor__scm_Builder__Lio_circe_DecodingFailure($thiz, key, c, builder) {
  var x7 = $thiz.Lio_circe_MapDecoder__f_decodeV.apply__Lio_circe_HCursor__s_util_Either(c);
  if ((x7 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
    var value = x7.s_util_Right__f_value;
    var elem = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), key, value);
    builder.addOne__O__scm_Growable(elem);
    return null;
  }
  if ((x7 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
    var error = x7.s_util_Left__f_value;
    return error;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x7);
}
export { $p_Lio_circe_MapDecoder__handleResult__O__Lio_circe_HCursor__scm_Builder__Lio_circe_DecodingFailure as $p_Lio_circe_MapDecoder__handleResult__O__Lio_circe_HCursor__scm_Builder__Lio_circe_DecodingFailure };
function $p_Lio_circe_MapDecoder__decodeJsonObject__Lio_circe_HCursor__Lio_circe_JsonObject__s_util_Either($thiz, c, obj) {
  var it = obj.keys__sc_Iterable().iterator__sc_Iterator();
  var builder = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_MapBuilderImpl();
  var failed = null;
  while (((failed === null) && it.hasNext__Z())) {
    var key = it.next__O();
    var atH = $p_Lio_circe_MapDecoder__createObjectCursor__Lio_circe_HCursor__Lio_circe_JsonObject__T__Lio_circe_HCursor($thiz, c, obj, key);
    if (($thiz.Lio_circe_MapDecoder__f_alwaysDecodeK !== null)) {
      failed = $p_Lio_circe_MapDecoder__handleResult__O__Lio_circe_HCursor__scm_Builder__Lio_circe_DecodingFailure($thiz, $thiz.Lio_circe_MapDecoder__f_alwaysDecodeK.decodeSafe__T__O(key), atH, builder);
    } else {
      matchResult4: {
        var x12 = $thiz.Lio_circe_MapDecoder__f_decodeK.apply__T__s_Option(key);
        var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        if ((x === x12)) {
          failed = $m_Lio_circe_MapDecoder$().invalidKeyfailure__Lio_circe_HCursor__Lio_circe_DecodingFailure(atH);
          break matchResult4;
        }
        if ((x12 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
          var k = x12.s_Some__f_value;
          failed = $p_Lio_circe_MapDecoder__handleResult__O__Lio_circe_HCursor__scm_Builder__Lio_circe_DecodingFailure($thiz, k, atH, builder);
          break matchResult4;
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x12);
      }
    }
  }
  if ((failed === null)) {
    var value = builder.result__sci_Map();
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value);
  } else {
    var value$1 = failed;
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value$1);
  }
}
export { $p_Lio_circe_MapDecoder__decodeJsonObject__Lio_circe_HCursor__Lio_circe_JsonObject__s_util_Either as $p_Lio_circe_MapDecoder__decodeJsonObject__Lio_circe_HCursor__Lio_circe_JsonObject__s_util_Either };
/** @constructor */
function $c_Lio_circe_MapDecoder() {
  this.Lio_circe_MapDecoder__f_decodeK = null;
  this.Lio_circe_MapDecoder__f_decodeV = null;
  this.Lio_circe_MapDecoder__f_alwaysDecodeK = null;
}
export { $c_Lio_circe_MapDecoder as $c_Lio_circe_MapDecoder };
$c_Lio_circe_MapDecoder.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_circe_MapDecoder.prototype.constructor = $c_Lio_circe_MapDecoder;
/** @constructor */
function $h_Lio_circe_MapDecoder() {
}
export { $h_Lio_circe_MapDecoder as $h_Lio_circe_MapDecoder };
$h_Lio_circe_MapDecoder.prototype = $c_Lio_circe_MapDecoder.prototype;
$c_Lio_circe_MapDecoder.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$c_Lio_circe_MapDecoder.prototype.tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated = (function(c) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lio_circe_Decoder__tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated(this, c);
});
$c_Lio_circe_MapDecoder.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x3 = c.value__Lio_circe_Json();
  if ((x3 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lio_circe_Json$JObject)) {
    var x6 = x3.Lio_circe_Json$JObject__f_value;
    return $p_Lio_circe_MapDecoder__decodeJsonObject__Lio_circe_HCursor__Lio_circe_JsonObject__s_util_Either(this, c, x6);
  }
  return $m_Lio_circe_MapDecoder$().notJsObjectFailureResult__Lio_circe_HCursor__Lio_circe_Json__s_util_Either(c, x3);
});
$c_Lio_circe_MapDecoder.prototype.decodeAccumulating__Lio_circe_HCursor__Lcats_data_Validated = (function(c) {
  var x36 = c.value__Lio_circe_Json();
  if ((x36 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lio_circe_Json$JObject)) {
    var x39 = x36.Lio_circe_Json$JObject__f_value;
    var it = x39.keys__sc_Iterable().iterator__sc_Iterator();
    var builder = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_MapBuilderImpl();
    var failed = false;
    var failures = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_ListBuffer();
    while (it.hasNext__Z()) {
      var key = it.next__O();
      var atH = $p_Lio_circe_MapDecoder__createObjectCursor__Lio_circe_HCursor__Lio_circe_JsonObject__T__Lio_circe_HCursor(this, c, x39, key);
      if ((this.Lio_circe_MapDecoder__f_alwaysDecodeK !== null)) {
        matchResult5: {
          var x15 = this.Lio_circe_MapDecoder__f_decodeV.decodeAccumulating__Lio_circe_HCursor__Lcats_data_Validated(atH);
          if ((x15 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_Validated$Valid)) {
            var x21 = x15.Lcats_data_Validated$Valid__f_a;
            if ((!failed)) {
              var _1 = this.Lio_circe_MapDecoder__f_alwaysDecodeK.decodeSafe__T__O(key);
              builder.addOne__O__O__sci_MapBuilderImpl(_1, x21);
              break matchResult5;
            } else {
              break matchResult5;
            }
          }
          if ((x15 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_Validated$Invalid)) {
            var x18 = x15.Lcats_data_Validated$Invalid__f_e;
            failed = true;
            var elem = x18.Lcats_data_NonEmptyList__f_head;
            failures.addOne__O__scm_ListBuffer(elem);
            var elems = x18.Lcats_data_NonEmptyList__f_tail;
            failures.addAll__sc_IterableOnce__scm_ListBuffer(elems);
            break matchResult5;
          }
          throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x15);
        }
      } else {
        matchResult7: {
          var x29 = this.Lio_circe_MapDecoder__f_decodeK.apply__T__s_Option(key);
          if ((x29 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
            var k = x29.s_Some__f_value;
            var x22 = this.Lio_circe_MapDecoder__f_decodeV.decodeAccumulating__Lio_circe_HCursor__Lcats_data_Validated(atH);
            if ((x22 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_Validated$Valid)) {
              var x28 = x22.Lcats_data_Validated$Valid__f_a;
              if ((!failed)) {
                builder.addOne__O__O__sci_MapBuilderImpl(k, x28);
                break matchResult7;
              } else {
                break matchResult7;
              }
            }
            if ((x22 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_Validated$Invalid)) {
              var x25 = x22.Lcats_data_Validated$Invalid__f_e;
              failed = true;
              var elem$1 = x25.Lcats_data_NonEmptyList__f_head;
              failures.addOne__O__scm_ListBuffer(elem$1);
              var elems$1 = x25.Lcats_data_NonEmptyList__f_tail;
              failures.addAll__sc_IterableOnce__scm_ListBuffer(elems$1);
              break matchResult7;
            }
            throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x22);
          }
          var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
          if ((x === x29)) {
            failed = true;
            var elem$2 = $m_Lio_circe_MapDecoder$().invalidKeyfailure__Lio_circe_HCursor__Lio_circe_DecodingFailure(atH);
            failures.addOne__O__scm_ListBuffer(elem$2);
            break matchResult7;
          }
          throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x29);
        }
      }
    }
    if ((!failed)) {
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_Validated$();
      var a = builder.result__sci_Map();
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_Validated$Valid(a);
    } else {
      var x32 = failures.toList__sci_List();
      if ((x32 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon)) {
        var x35 = x32.sci_$colon$colon__f_next;
        var h = x32.sci_$colon$colon__f_head;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_Validated$();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_NonEmptyList$();
        var e = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_NonEmptyList(h, x35);
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_Validated$Invalid(e);
      }
      var x$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      if (x$3.equals__O__Z(x32)) {
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_Validated$();
        var a$1 = builder.result__sci_Map();
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_Validated$Valid(a$1);
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x32);
    }
  }
  return $m_Lio_circe_MapDecoder$().notJsObjectfailureAccumulatingResult__Lio_circe_HCursor__Lio_circe_Json__Lcats_data_Validated(c, x36);
});
function $ct_Lio_circe_NonEmptySeqDecoder__Lio_circe_Decoder__($thiz, decodeA) {
  $thiz.Lio_circe_NonEmptySeqDecoder__f_io$circe$NonEmptySeqDecoder$$decodeA = decodeA;
  $thiz.Lio_circe_NonEmptySeqDecoder__f_decodeCA = new $c_Lio_circe_NonEmptySeqDecoder$$anon$1($thiz);
  return $thiz;
}
export { $ct_Lio_circe_NonEmptySeqDecoder__Lio_circe_Decoder__ as $ct_Lio_circe_NonEmptySeqDecoder__Lio_circe_Decoder__ };
/** @constructor */
function $c_Lio_circe_NonEmptySeqDecoder() {
  this.Lio_circe_NonEmptySeqDecoder__f_io$circe$NonEmptySeqDecoder$$decodeA = null;
  this.Lio_circe_NonEmptySeqDecoder__f_decodeCA = null;
}
export { $c_Lio_circe_NonEmptySeqDecoder as $c_Lio_circe_NonEmptySeqDecoder };
$c_Lio_circe_NonEmptySeqDecoder.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_circe_NonEmptySeqDecoder.prototype.constructor = $c_Lio_circe_NonEmptySeqDecoder;
/** @constructor */
function $h_Lio_circe_NonEmptySeqDecoder() {
}
export { $h_Lio_circe_NonEmptySeqDecoder as $h_Lio_circe_NonEmptySeqDecoder };
$h_Lio_circe_NonEmptySeqDecoder.prototype = $c_Lio_circe_NonEmptySeqDecoder.prototype;
$c_Lio_circe_NonEmptySeqDecoder.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$c_Lio_circe_NonEmptySeqDecoder.prototype.tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated = (function(c) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lio_circe_Decoder__tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated(this, c);
});
$c_Lio_circe_NonEmptySeqDecoder.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var arr = c.downArray__Lio_circe_ACursor();
  var x6 = this.Lio_circe_NonEmptySeqDecoder__f_io$circe$NonEmptySeqDecoder$$decodeA.tryDecode__Lio_circe_ACursor__s_util_Either(arr);
  if ((x6 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
    var head = x6.s_util_Right__f_value;
    var x1 = this.Lio_circe_NonEmptySeqDecoder__f_decodeCA.tryDecode__Lio_circe_ACursor__s_util_Either(arr.delete__Lio_circe_ACursor());
    if ((x1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
      var tail = x1.s_util_Right__f_value;
      var value = this.Lio_circe_Decoder$$anon$54__f_create.apply__O__O__O(head, tail);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value);
    }
    if ((x1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
      return x1;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1);
  }
  if ((x6 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
    return x6;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x6);
});
$c_Lio_circe_NonEmptySeqDecoder.prototype.decodeAccumulating__Lio_circe_HCursor__Lcats_data_Validated = (function(c) {
  var arr = c.downArray__Lio_circe_ACursor();
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_accumulatingResultInstance.map2__O__O__F2__O(this.Lio_circe_NonEmptySeqDecoder__f_io$circe$NonEmptySeqDecoder$$decodeA.tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated(arr), this.Lio_circe_NonEmptySeqDecoder__f_decodeCA.tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated(arr.delete__Lio_circe_ACursor()), this.Lio_circe_Decoder$$anon$54__f_create);
});
/** @constructor */
function $c_Lio_circe_ParsingFailure$() {
  this.Lio_circe_ParsingFailure$__f_eqParsingFailure = null;
  this.Lio_circe_ParsingFailure$__f_showParsingFailure = null;
  $n_Lio_circe_ParsingFailure$ = this;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_package$();
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((x$1, x$2) => {
    var x9 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), x$1, x$2);
    var x10 = x9.T2__f__1;
    var x11 = x9.T2__f__2;
    if ((x10 !== null)) {
      $m_Lio_circe_ParsingFailure$();
      var x16 = x10.Lio_circe_ParsingFailure__f_message;
      var x17 = x10.Lio_circe_ParsingFailure__f_underlying;
      if ((x11 !== null)) {
        $m_Lio_circe_ParsingFailure$();
        var x13 = x11.Lio_circe_ParsingFailure__f_message;
        var x14 = x11.Lio_circe_ParsingFailure__f_underlying;
        return ((x16 === x13) && ((x17 === null) ? (x14 === null) : x17.equals__O__Z(x14)));
      }
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x9);
  }));
  this.Lio_circe_ParsingFailure$__f_eqParsingFailure = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_kernel_Eq$$anon$5(f);
  this.Lio_circe_ParsingFailure$__f_showParsingFailure = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$$anon$5();
}
export { $c_Lio_circe_ParsingFailure$ as $c_Lio_circe_ParsingFailure$ };
$c_Lio_circe_ParsingFailure$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_circe_ParsingFailure$.prototype.constructor = $c_Lio_circe_ParsingFailure$;
/** @constructor */
function $h_Lio_circe_ParsingFailure$() {
}
export { $h_Lio_circe_ParsingFailure$ as $h_Lio_circe_ParsingFailure$ };
$h_Lio_circe_ParsingFailure$.prototype = $c_Lio_circe_ParsingFailure$.prototype;
$c_Lio_circe_ParsingFailure$.prototype.fromProduct__s_Product__Lio_circe_ParsingFailure = (function(x$0) {
  return new $c_Lio_circe_ParsingFailure(x$0.productElement__I__O(0), x$0.productElement__I__O(1));
});
$c_Lio_circe_ParsingFailure$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lio_circe_ParsingFailure(p);
});
var $d_Lio_circe_ParsingFailure$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_circe_ParsingFailure$, "io.circe.ParsingFailure$", ({
  Lio_circe_ParsingFailure$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lio_circe_ParsingFailure$ as $d_Lio_circe_ParsingFailure$ };
var $n_Lio_circe_ParsingFailure$;
function $m_Lio_circe_ParsingFailure$() {
  if ((!$n_Lio_circe_ParsingFailure$)) {
    $n_Lio_circe_ParsingFailure$ = new $c_Lio_circe_ParsingFailure$();
  }
  return $n_Lio_circe_ParsingFailure$;
}
export { $m_Lio_circe_ParsingFailure$ as $m_Lio_circe_ParsingFailure$ };
function $ct_Lio_circe_SeqDecoder__Lio_circe_Decoder__($thiz, decodeA) {
  $thiz.Lio_circe_SeqDecoder__f_decodeA = decodeA;
  return $thiz;
}
export { $ct_Lio_circe_SeqDecoder__Lio_circe_Decoder__ as $ct_Lio_circe_SeqDecoder__Lio_circe_Decoder__ };
/** @constructor */
function $c_Lio_circe_SeqDecoder() {
  this.Lio_circe_SeqDecoder__f_decodeA = null;
}
export { $c_Lio_circe_SeqDecoder as $c_Lio_circe_SeqDecoder };
$c_Lio_circe_SeqDecoder.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_circe_SeqDecoder.prototype.constructor = $c_Lio_circe_SeqDecoder;
/** @constructor */
function $h_Lio_circe_SeqDecoder() {
}
export { $h_Lio_circe_SeqDecoder as $h_Lio_circe_SeqDecoder };
$h_Lio_circe_SeqDecoder.prototype = $c_Lio_circe_SeqDecoder.prototype;
$c_Lio_circe_SeqDecoder.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$c_Lio_circe_SeqDecoder.prototype.tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated = (function(c) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lio_circe_Decoder__tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated(this, c);
});
$c_Lio_circe_SeqDecoder.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var values = c.value__Lio_circe_Json().asArray__s_Option();
  if ((!values.isEmpty__Z())) {
    var jsonValues = values.get__O();
    var builder = this.createBuilder__scm_Builder();
    builder.sizeHint__I__V(jsonValues.length__I());
    var failed = null;
    var index = 0;
    var cursor = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lio_circe_cursor_ArrayCursor(jsonValues, index, c, false, c, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_CursorOp$DownArray$());
    while (((failed === null) && (index < jsonValues.length__I()))) {
      matchResult1: {
        var this$1 = cursor;
        var d = this.Lio_circe_SeqDecoder__f_decodeA;
        var x1 = d.tryDecode__Lio_circe_ACursor__s_util_Either(this$1);
        if ((x1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
          var e = x1.s_util_Left__f_value;
          var message$1 = e.message__T();
          failed = e.copy__T__F0__Lio_circe_DecodingFailure(message$1, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((e) => (() => e.history__sci_List()))(e))).withReason__Lio_circe_DecodingFailure$Reason__Lio_circe_DecodingFailure(e.Lio_circe_DecodingFailure__f_lazyReason.value__O());
          break matchResult1;
        }
        if ((x1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
          var a = x1.s_util_Right__f_value;
          builder.addOne__O__scm_Growable(a);
          cursor = cursor.right__Lio_circe_ACursor();
          break matchResult1;
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1);
      }
      index = ((1 + index) | 0);
    }
    if ((failed === null)) {
      var value = builder.result__O();
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value);
    } else {
      var value$1 = failed;
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value$1);
    }
  } else if (c.value__Lio_circe_Json().isArray__Z()) {
    var value$2 = this.createBuilder__scm_Builder().result__O();
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value$2);
  } else {
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_DecodingFailure$();
    var jsonValue = c.value__Lio_circe_Json();
    var value$3 = $x_1.apply__Lio_circe_DecodingFailure$Reason__F0__Lio_circe_DecodingFailure(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation("array", jsonValue), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => c.history__sci_List())));
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value$3);
  }
});
$c_Lio_circe_SeqDecoder.prototype.decodeAccumulating__Lio_circe_HCursor__Lcats_data_Validated = (function(c) {
  var values = c.value__Lio_circe_Json().asArray__s_Option();
  if ((!values.isEmpty__Z())) {
    var jsonValues = values.get__O();
    var builder = this.createBuilder__scm_Builder();
    builder.sizeHint__I__V(jsonValues.length__I());
    var failed = false;
    var failures = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_ListBuffer();
    var index = 0;
    var cursor = c.downArray__Lio_circe_ACursor();
    while ((index < jsonValues.length__I())) {
      matchResult2: {
        var x6 = this.Lio_circe_SeqDecoder__f_decodeA.decodeAccumulating__Lio_circe_HCursor__Lcats_data_Validated(cursor);
        if ((x6 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_Validated$Invalid)) {
          var x12 = x6.Lcats_data_Validated$Invalid__f_e;
          failed = true;
          var f = ((e) => {
            var message$2 = e.message__T();
            return e.copy__T__F0__Lio_circe_DecodingFailure(message$2, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((e$2) => (() => e$2.history__sci_List()))(e))).withReason__Lio_circe_DecodingFailure$Reason__Lio_circe_DecodingFailure(e.Lio_circe_DecodingFailure__f_lazyReason.value__O());
          });
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_NonEmptyList$();
          var x0 = x12.Lcats_data_NonEmptyList__f_head;
          var head = f(x0);
          var this$3 = x12.Lcats_data_NonEmptyList__f_tail;
          if ((this$3 === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
            var tail = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
          } else {
            var x0$1 = this$3.head__O();
            var h = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0$1), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
            var t = h;
            var rest = this$3.tail__O();
            while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
              var x0$2 = rest.head__O();
              var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0$2), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
              t.sci_$colon$colon__f_next = nx;
              t = nx;
              rest = rest.tail__O();
            }
            var tail = h;
          }
          var fixedErrors = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_NonEmptyList(head, tail);
          var elem = fixedErrors.Lcats_data_NonEmptyList__f_head;
          failures.addOne__O__scm_ListBuffer(elem);
          var elems = fixedErrors.Lcats_data_NonEmptyList__f_tail;
          failures.addAll__sc_IterableOnce__scm_ListBuffer(elems);
          break matchResult2;
        }
        if ((x6 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_Validated$Valid)) {
          var x9 = x6.Lcats_data_Validated$Valid__f_a;
          if ((!failed)) {
            builder.addOne__O__scm_Growable(x9);
            break matchResult2;
          } else {
            break matchResult2;
          }
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x6);
      }
      index = ((1 + index) | 0);
      cursor = cursor.right__Lio_circe_ACursor();
    }
    if ((!failed)) {
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_Validated$();
      var a = builder.result__O();
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_Validated$Valid(a);
    } else {
      var x13 = failures.toList__sci_List();
      if ((x13 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon)) {
        var x16 = x13.sci_$colon$colon__f_next;
        var h$1 = x13.sci_$colon$colon__f_head;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_Validated$();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_NonEmptyList$();
        var e$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_NonEmptyList(h$1, x16);
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_Validated$Invalid(e$1);
      }
      var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      if (x.equals__O__Z(x13)) {
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_Validated$();
        var a$1 = builder.result__O();
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_Validated$Valid(a$1);
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x13);
    }
  } else if (c.value__Lio_circe_Json().isArray__Z()) {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_Validated$();
    var a$2 = this.createBuilder__scm_Builder().result__O();
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_Validated$Valid(a$2);
  } else {
    var this$16 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_Validated$();
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_DecodingFailure$();
    var jsonValue = c.value__Lio_circe_Json();
    var e$3 = $x_1.apply__Lio_circe_DecodingFailure$Reason__F0__Lio_circe_DecodingFailure(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation("array", jsonValue), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => c.history__sci_List())));
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_data_ValidatedFunctions__invalidNel__O__Lcats_data_Validated(this$16, e$3);
  }
});
/** @constructor */
function $c_Lio_circe_derivation_Configuration$() {
  this.Lio_circe_derivation_Configuration$__f_default = null;
  $n_Lio_circe_derivation_Configuration$ = this;
  $m_Lio_circe_derivation_Configuration$();
  var transformMemberNames = $m_Lio_circe_derivation_Configuration$().$lessinit$greater$default$1__F1();
  var transformConstructorNames = $m_Lio_circe_derivation_Configuration$().$lessinit$greater$default$2__F1();
  $m_Lio_circe_derivation_Configuration$();
  var useDefaults = false;
  $m_Lio_circe_derivation_Configuration$();
  var discriminator = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $m_Lio_circe_derivation_Configuration$();
  var strictDecoding = false;
  this.Lio_circe_derivation_Configuration$__f_default = new $c_Lio_circe_derivation_Configuration(transformMemberNames, transformConstructorNames, useDefaults, discriminator, strictDecoding);
}
export { $c_Lio_circe_derivation_Configuration$ as $c_Lio_circe_derivation_Configuration$ };
$c_Lio_circe_derivation_Configuration$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_circe_derivation_Configuration$.prototype.constructor = $c_Lio_circe_derivation_Configuration$;
/** @constructor */
function $h_Lio_circe_derivation_Configuration$() {
}
export { $h_Lio_circe_derivation_Configuration$ as $h_Lio_circe_derivation_Configuration$ };
$h_Lio_circe_derivation_Configuration$.prototype = $c_Lio_circe_derivation_Configuration$.prototype;
$c_Lio_circe_derivation_Configuration$.prototype.$lessinit$greater$default$1__F1 = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x) => x));
});
$c_Lio_circe_derivation_Configuration$.prototype.$lessinit$greater$default$2__F1 = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x) => x));
});
$c_Lio_circe_derivation_Configuration$.prototype.fromProduct__s_Product__Lio_circe_derivation_Configuration = (function(x$0) {
  return new $c_Lio_circe_derivation_Configuration(x$0.productElement__I__O(0), x$0.productElement__I__O(1), (!(!x$0.productElement__I__O(2))), x$0.productElement__I__O(3), (!(!x$0.productElement__I__O(4))));
});
$c_Lio_circe_derivation_Configuration$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lio_circe_derivation_Configuration(p);
});
var $d_Lio_circe_derivation_Configuration$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_circe_derivation_Configuration$, "io.circe.derivation.Configuration$", ({
  Lio_circe_derivation_Configuration$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lio_circe_derivation_Configuration$ as $d_Lio_circe_derivation_Configuration$ };
var $n_Lio_circe_derivation_Configuration$;
function $m_Lio_circe_derivation_Configuration$() {
  if ((!$n_Lio_circe_derivation_Configuration$)) {
    $n_Lio_circe_derivation_Configuration$ = new $c_Lio_circe_derivation_Configuration$();
  }
  return $n_Lio_circe_derivation_Configuration$;
}
export { $m_Lio_circe_derivation_Configuration$ as $m_Lio_circe_derivation_Configuration$ };
function $f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List($thiz) {
  return $thiz.elemLabels__sci_List().map__F1__sci_List($thiz.io$circe$derivation$ConfiguredDecoder$$conf__Lio_circe_derivation_Configuration().Lio_circe_derivation_Configuration__f_transformConstructorNames);
}
export { $f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List as $f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List };
function $f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map($thiz) {
  var this$1 = $thiz.constructorNames__sci_List();
  var that = $thiz.elemDecoders__sci_List();
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this$1, that);
  var rest = this$2;
  var h = null;
  var t = null;
  while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
    var x0 = rest.head__O();
    var it = $ps_Lio_circe_derivation_ConfiguredDecoder__findDecoderDict$1__T2__sci_List(x0).iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(it.next__O(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.sci_$colon$colon__f_next = nx;
      }
      t = nx;
    }
    rest = rest.tail__O();
  }
  var this$4 = ((h === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$() : h);
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$().from__sc_IterableOnce__sci_Map(this$4);
}
export { $f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map as $f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map };
function $p_Lio_circe_derivation_ConfiguredDecoder__strictDecodingFailure__Lio_circe_HCursor__T__Lio_circe_DecodingFailure($thiz, c, message) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_DecodingFailure$().apply__T__F0__Lio_circe_DecodingFailure(((("Strict decoding " + $thiz.name__T()) + " - ") + message), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => c.history__sci_List())));
}
export { $p_Lio_circe_derivation_ConfiguredDecoder__strictDecodingFailure__Lio_circe_HCursor__T__Lio_circe_DecodingFailure as $p_Lio_circe_derivation_ConfiguredDecoder__strictDecodingFailure__Lio_circe_HCursor__T__Lio_circe_DecodingFailure };
function $f_Lio_circe_derivation_ConfiguredDecoder__decodeSum__Lio_circe_HCursor__s_util_Either($thiz, c) {
  var f = ((value) => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value));
  var f$1 = ((_$1) => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1$2) => ((c$1) => _$1$2.tryDecode__Lio_circe_ACursor__s_util_Either(c$1)))(_$1)));
  matchResult6: {
    var $x_1;
    var x21 = $thiz.io$circe$derivation$ConfiguredDecoder$$conf__Lio_circe_derivation_Configuration().Lio_circe_derivation_Configuration__f_discriminator;
    if ((x21 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var discriminator = x21.s_Some__f_value;
      var cursor = c.downField__T__Lio_circe_ACursor(discriminator);
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_Decoder$();
      var d = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
      var d$1 = new $c_Lio_circe_Decoder$OptionDecoder(d);
      var x9 = d$1.tryDecode__Lio_circe_ACursor__s_util_Either(cursor);
      if ((x9 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
        var failure = x9.s_util_Left__f_value;
        var $x_1 = f(failure);
        break matchResult6;
      }
      if ((x9 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
        var x15 = x9.s_util_Right__f_value;
        var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        if ((x === x15)) {
          var x0 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_DecodingFailure$().apply__T__F0__Lio_circe_DecodingFailure(((($thiz.name__T() + ": could not find discriminator field '") + discriminator) + "' or its null."), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => cursor.history__sci_List())));
          var $x_1 = f(x0);
          break matchResult6;
        }
        if ((x15 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
          var sumTypeName = x15.s_Some__f_value;
          var fallBacks = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
          var cursor$tailLocal1 = c;
          var sumTypeName$tailLocal1 = sumTypeName;
          while (true) {
            var x6 = $thiz.io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map().get__O__s_Option(sumTypeName$tailLocal1);
            if ((x6 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
              var decoder = x6.s_Some__f_value;
              var $x_1 = f$1(decoder).apply__O__O(cursor$tailLocal1);
              break matchResult6;
            }
            if (fallBacks.hasNext__Z()) {
              matchResult2: {
                var \u03b41$___1;
                var \u03b41$___2;
                var x3 = fallBacks.next__O();
                if ((x3 !== null)) {
                  var sumTypeName$2 = x3._1__O();
                  var cursor$2 = x3._2__O();
                  var \u03b41$___1 = sumTypeName$2;
                  var \u03b41$___2 = cursor$2;
                  break matchResult2;
                }
                throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x3);
              }
              var sumTypeName$3 = \u03b41$___1;
              var cursor$3 = \u03b41$___2;
              sumTypeName$tailLocal1 = sumTypeName$3;
              cursor$tailLocal1 = cursor$3;
              continue;
            }
            var $x_4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_DecodingFailure$();
            var $x_3 = $thiz.name__T();
            var $x_2 = sumTypeName$tailLocal1;
            var cursor$tailLocal1$2$1 = cursor$tailLocal1;
            var x0$1 = $x_4.apply__T__F0__Lio_circe_DecodingFailure((((("type " + $x_3) + " has no class/object/case named '") + $x_2) + "'."), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((cursor$tailLocal1$2) => (() => cursor$tailLocal1$2.history__sci_List()))(cursor$tailLocal1$2$1)));
            var $x_1 = f(x0$1);
            break matchResult6;
          }
        }
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x9);
    }
    var x18 = c.keys__s_Option();
    var x$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    if ((x$3 === x18)) {
      var $x_5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_DecodingFailure$();
      var jsonValue = c.value__Lio_circe_Json();
      var x0$2 = $x_5.apply__Lio_circe_DecodingFailure$Reason__F0__Lio_circe_DecodingFailure(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation("object", jsonValue), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => c.history__sci_List())));
      var $x_1 = f(x0$2);
      break matchResult6;
    }
    if ((x18 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var keys = x18.s_Some__f_value;
      var iter = keys.iterator__sc_Iterator();
      if ((!iter.hasNext__Z())) {
        var $x_6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_DecodingFailure$();
        var jsonValue$1 = c.value__Lio_circe_Json();
        var x0$3 = $x_6.apply__Lio_circe_DecodingFailure$Reason__F0__Lio_circe_DecodingFailure(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation("non-empty json object", jsonValue$1), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => c.history__sci_List())));
        var $x_1 = f(x0$3);
        break matchResult6;
      } else {
        var sumTypeName$2$1 = iter.next__O();
        if ((iter.hasNext__Z() && $thiz.io$circe$derivation$ConfiguredDecoder$$conf__Lio_circe_derivation_Configuration().Lio_circe_derivation_Configuration__f_strictDecoding)) {
          var this$6 = $thiz.constructorNames__sci_List().iterator__sc_Iterator();
          var x0$4 = $p_Lio_circe_derivation_ConfiguredDecoder__strictDecodingFailure__Lio_circe_HCursor__T__Lio_circe_DecodingFailure($thiz, c, (("expected a single key json object with one of: " + $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__mkString__T__T__T__T(this$6, "", ", ", "")) + "."));
          var $x_1 = f(x0$4);
          break matchResult6;
        } else {
          var cursor$1 = c.downField__T__Lio_circe_ACursor(sumTypeName$2$1);
          var f$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((key) => {
            var _2 = c.downField__T__Lio_circe_ACursor(key);
            return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), key, _2);
          }));
          var fallBacks$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(iter, f$2);
          var cursor$tailLocal1$1 = cursor$1;
          var sumTypeName$tailLocal1$1 = sumTypeName$2$1;
          while (true) {
            var x6$1 = $thiz.io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map().get__O__s_Option(sumTypeName$tailLocal1$1);
            if ((x6$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
              var decoder$1 = x6$1.s_Some__f_value;
              var $x_1 = f$1(decoder$1).apply__O__O(cursor$tailLocal1$1);
              break matchResult6;
            }
            if (fallBacks$1.hasNext__Z()) {
              matchResult2$1: {
                var \u03b41$$1___1;
                var \u03b41$$1___2;
                var x3$1 = fallBacks$1.next__O();
                if ((x3$1 !== null)) {
                  var sumTypeName$2$2 = x3$1._1__O();
                  var cursor$2$1 = x3$1._2__O();
                  var \u03b41$$1___1 = sumTypeName$2$2;
                  var \u03b41$$1___2 = cursor$2$1;
                  break matchResult2$1;
                }
                throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x3$1);
              }
              var sumTypeName$3$1 = \u03b41$$1___1;
              var cursor$3$1 = \u03b41$$1___2;
              sumTypeName$tailLocal1$1 = sumTypeName$3$1;
              cursor$tailLocal1$1 = cursor$3$1;
              continue;
            }
            var $x_9 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_DecodingFailure$();
            var $x_8 = $thiz.name__T();
            var $x_7 = sumTypeName$tailLocal1$1;
            var cursor$tailLocal1$2$3 = cursor$tailLocal1$1;
            var x0$5 = $x_9.apply__T__F0__Lio_circe_DecodingFailure((((("type " + $x_8) + " has no class/object/case named '") + $x_7) + "'."), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((cursor$tailLocal1$2$2) => (() => cursor$tailLocal1$2$2.history__sci_List()))(cursor$tailLocal1$2$3)));
            var $x_1 = f(x0$5);
            break matchResult6;
          }
        }
      }
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x18);
  }
  return $x_1;
}
export { $f_Lio_circe_derivation_ConfiguredDecoder__decodeSum__Lio_circe_HCursor__s_util_Either as $f_Lio_circe_derivation_ConfiguredDecoder__decodeSum__Lio_circe_HCursor__s_util_Either };
function $f_Lio_circe_derivation_ConfiguredDecoder__decodeSumAccumulating__Lio_circe_HCursor__Lcats_data_Validated($thiz, c) {
  var f = ((e) => {
    var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_Validated$();
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_data_ValidatedFunctions__invalidNel__O__Lcats_data_Validated(this$1, e);
  });
  var f$1 = ((_$2) => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2$2) => ((c$1) => _$2$2.tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated(c$1)))(_$2)));
  matchResult6: {
    var $x_1;
    var x21 = $thiz.io$circe$derivation$ConfiguredDecoder$$conf__Lio_circe_derivation_Configuration().Lio_circe_derivation_Configuration__f_discriminator;
    if ((x21 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var discriminator = x21.s_Some__f_value;
      var cursor = c.downField__T__Lio_circe_ACursor(discriminator);
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_Decoder$();
      var d = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
      var d$1 = new $c_Lio_circe_Decoder$OptionDecoder(d);
      var x9 = d$1.tryDecode__Lio_circe_ACursor__s_util_Either(cursor);
      if ((x9 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
        var failure = x9.s_util_Left__f_value;
        var $x_1 = f(failure);
        break matchResult6;
      }
      if ((x9 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
        var x15 = x9.s_util_Right__f_value;
        var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        if ((x === x15)) {
          var x0 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_DecodingFailure$().apply__T__F0__Lio_circe_DecodingFailure(((($thiz.name__T() + ": could not find discriminator field '") + discriminator) + "' or its null."), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => cursor.history__sci_List())));
          var $x_1 = f(x0);
          break matchResult6;
        }
        if ((x15 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
          var sumTypeName = x15.s_Some__f_value;
          var fallBacks = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
          var cursor$tailLocal1 = c;
          var sumTypeName$tailLocal1 = sumTypeName;
          while (true) {
            var x6 = $thiz.io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map().get__O__s_Option(sumTypeName$tailLocal1);
            if ((x6 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
              var decoder = x6.s_Some__f_value;
              var $x_1 = f$1(decoder).apply__O__O(cursor$tailLocal1);
              break matchResult6;
            }
            if (fallBacks.hasNext__Z()) {
              matchResult2: {
                var \u03b41$___1;
                var \u03b41$___2;
                var x3 = fallBacks.next__O();
                if ((x3 !== null)) {
                  var sumTypeName$2 = x3._1__O();
                  var cursor$2 = x3._2__O();
                  var \u03b41$___1 = sumTypeName$2;
                  var \u03b41$___2 = cursor$2;
                  break matchResult2;
                }
                throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x3);
              }
              var sumTypeName$3 = \u03b41$___1;
              var cursor$3 = \u03b41$___2;
              sumTypeName$tailLocal1 = sumTypeName$3;
              cursor$tailLocal1 = cursor$3;
              continue;
            }
            var $x_4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_DecodingFailure$();
            var $x_3 = $thiz.name__T();
            var $x_2 = sumTypeName$tailLocal1;
            var cursor$tailLocal1$2$1 = cursor$tailLocal1;
            var x0$1 = $x_4.apply__T__F0__Lio_circe_DecodingFailure((((("type " + $x_3) + " has no class/object/case named '") + $x_2) + "'."), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((cursor$tailLocal1$2) => (() => cursor$tailLocal1$2.history__sci_List()))(cursor$tailLocal1$2$1)));
            var $x_1 = f(x0$1);
            break matchResult6;
          }
        }
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x9);
    }
    var x18 = c.keys__s_Option();
    var x$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    if ((x$3 === x18)) {
      var $x_5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_DecodingFailure$();
      var jsonValue = c.value__Lio_circe_Json();
      var x0$2 = $x_5.apply__Lio_circe_DecodingFailure$Reason__F0__Lio_circe_DecodingFailure(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation("object", jsonValue), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => c.history__sci_List())));
      var $x_1 = f(x0$2);
      break matchResult6;
    }
    if ((x18 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var keys = x18.s_Some__f_value;
      var iter = keys.iterator__sc_Iterator();
      if ((!iter.hasNext__Z())) {
        var $x_6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_DecodingFailure$();
        var jsonValue$1 = c.value__Lio_circe_Json();
        var x0$3 = $x_6.apply__Lio_circe_DecodingFailure$Reason__F0__Lio_circe_DecodingFailure(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation("non-empty json object", jsonValue$1), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => c.history__sci_List())));
        var $x_1 = f(x0$3);
        break matchResult6;
      } else {
        var sumTypeName$2$1 = iter.next__O();
        if ((iter.hasNext__Z() && $thiz.io$circe$derivation$ConfiguredDecoder$$conf__Lio_circe_derivation_Configuration().Lio_circe_derivation_Configuration__f_strictDecoding)) {
          var this$6 = $thiz.constructorNames__sci_List().iterator__sc_Iterator();
          var x0$4 = $p_Lio_circe_derivation_ConfiguredDecoder__strictDecodingFailure__Lio_circe_HCursor__T__Lio_circe_DecodingFailure($thiz, c, (("expected a single key json object with one of: " + $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__mkString__T__T__T__T(this$6, "", ", ", "")) + "."));
          var $x_1 = f(x0$4);
          break matchResult6;
        } else {
          var cursor$1 = c.downField__T__Lio_circe_ACursor(sumTypeName$2$1);
          var f$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((key) => {
            var _2 = c.downField__T__Lio_circe_ACursor(key);
            return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), key, _2);
          }));
          var fallBacks$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(iter, f$2);
          var cursor$tailLocal1$1 = cursor$1;
          var sumTypeName$tailLocal1$1 = sumTypeName$2$1;
          while (true) {
            var x6$1 = $thiz.io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map().get__O__s_Option(sumTypeName$tailLocal1$1);
            if ((x6$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
              var decoder$1 = x6$1.s_Some__f_value;
              var $x_1 = f$1(decoder$1).apply__O__O(cursor$tailLocal1$1);
              break matchResult6;
            }
            if (fallBacks$1.hasNext__Z()) {
              matchResult2$1: {
                var \u03b41$$1___1;
                var \u03b41$$1___2;
                var x3$1 = fallBacks$1.next__O();
                if ((x3$1 !== null)) {
                  var sumTypeName$2$2 = x3$1._1__O();
                  var cursor$2$1 = x3$1._2__O();
                  var \u03b41$$1___1 = sumTypeName$2$2;
                  var \u03b41$$1___2 = cursor$2$1;
                  break matchResult2$1;
                }
                throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x3$1);
              }
              var sumTypeName$3$1 = \u03b41$$1___1;
              var cursor$3$1 = \u03b41$$1___2;
              sumTypeName$tailLocal1$1 = sumTypeName$3$1;
              cursor$tailLocal1$1 = cursor$3$1;
              continue;
            }
            var $x_9 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_DecodingFailure$();
            var $x_8 = $thiz.name__T();
            var $x_7 = sumTypeName$tailLocal1$1;
            var cursor$tailLocal1$2$3 = cursor$tailLocal1$1;
            var x0$5 = $x_9.apply__T__F0__Lio_circe_DecodingFailure((((("type " + $x_8) + " has no class/object/case named '") + $x_7) + "'."), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((cursor$tailLocal1$2$2) => (() => cursor$tailLocal1$2$2.history__sci_List()))(cursor$tailLocal1$2$3)));
            var $x_1 = f(x0$5);
            break matchResult6;
          }
        }
      }
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x18);
  }
  return $x_1;
}
export { $f_Lio_circe_derivation_ConfiguredDecoder__decodeSumAccumulating__Lio_circe_HCursor__Lcats_data_Validated as $f_Lio_circe_derivation_ConfiguredDecoder__decodeSumAccumulating__Lio_circe_HCursor__Lcats_data_Validated };
function $f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either($thiz, c, fromProduct) {
  var f = ((x$1) => {
    if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var strictFailure = x$1.s_Some__f_value;
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(strictFailure);
    }
    var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    if ((x === x$1)) {
      var dimensions = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I(new Int32Array([$thiz.elemLabels__sci_List().length__I()]));
      var res = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_reflect_Array$().newInstance__jl_Class__AI__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_O.getClassOf(), dimensions);
      var failed = null;
      var index = 0;
      while (((index < $thiz.elemLabels__sci_List().length__I()) && (failed === null))) {
        matchResult10: {
          var index$1 = index;
          var this$4 = $thiz.elemDecoders__sci_List();
          var decoder = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_LinearSeqOps__apply__I__O(this$4, index$1);
          var $x_1 = $thiz.io$circe$derivation$ConfiguredDecoder$$conf__Lio_circe_derivation_Configuration().Lio_circe_derivation_Configuration__f_transformMemberNames;
          var this$5 = $thiz.elemLabels__sci_List();
          var cursor = c.downField__T__Lio_circe_ACursor($x_1.apply__O__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_LinearSeqOps__apply__I__O(this$5, index$1)));
          var result = decoder.tryDecode__Lio_circe_ACursor__s_util_Either(cursor);
          if ($thiz.io$circe$derivation$ConfiguredDecoder$$conf__Lio_circe_derivation_Configuration().Lio_circe_derivation_Configuration__f_useDefaults) {
            matchResult7: {
              var x33;
              var this$6 = $thiz.elemDefaults__Lio_circe_derivation_Default();
              var x24 = $f_Lio_circe_derivation_Default__defaultAt__I__s_Option(this$6, index$1);
              var x$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
              if ((x$2 === x24)) {
                var x33 = result;
                break matchResult7;
              }
              if ((x24 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
                var default$1 = x24.s_Some__f_value;
                var x33 = $ps_Lio_circe_derivation_ConfiguredDecoder__withDefault$1__s_util_Either__Lio_circe_ACursor__O__s_util_Either(result, cursor, default$1);
                break matchResult7;
              }
              throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x24);
            }
          } else {
            var x33 = result;
          }
          if ((x33 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
            var value = x33.s_util_Right__f_value;
            res.u[index] = value;
            break matchResult10;
          }
          if ((x33 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
            failed = x33;
            break matchResult10;
          }
          throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x33);
        }
        index = ((1 + index) | 0);
      }
      if ((failed === null)) {
        var value$1 = fromProduct.apply__O__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_T$().fromArray__O__s_Product(res));
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value$1);
      } else {
        return failed;
      }
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  });
  matchResult8: {
    var $x_2;
    var x27 = c.value__Lio_circe_Json().isObject__Z();
    if ((x27 === false)) {
      var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_DecodingFailure$();
      var jsonValue = c.value__Lio_circe_Json();
      var x0 = $x_3.apply__Lio_circe_DecodingFailure$Reason__F0__Lio_circe_DecodingFailure(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation("object", jsonValue), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => c.history__sci_List())));
      var $x_2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(x0);
      break matchResult8;
    }
    if ((x27 === true)) {
      if ((!$thiz.io$circe$derivation$ConfiguredDecoder$$conf__Lio_circe_derivation_Configuration().Lio_circe_derivation_Configuration__f_strictDecoding)) {
        var x0$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        var $x_2 = f(x0$1);
        break matchResult8;
      }
      var this$10 = $thiz.elemLabels__sci_List();
      var this$11 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_IndexedSeq$().from__sc_IterableOnce__sci_IndexedSeq(this$10).map__F1__O($thiz.io$circe$derivation$ConfiguredDecoder$$conf__Lio_circe_derivation_Configuration().Lio_circe_derivation_Configuration__f_transformMemberNames);
      var suffix = $thiz.io$circe$derivation$ConfiguredDecoder$$conf__Lio_circe_derivation_Configuration().Lio_circe_derivation_Configuration__f_discriminator;
      var expectedFields = this$11.concat__sc_IterableOnce__O(suffix);
      var expectedFieldsSet = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Set$().from__sc_IterableOnce__sci_Set(expectedFields);
      var this$12 = c.keys__s_Option();
      if (this$12.isEmpty__Z()) {
        var this$14 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      } else {
        var x0$2 = this$12.get__O();
        var this$13 = x0$2.toList__sci_List();
        var this$14 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$p_sci_List__filterCommon__F1__Z__sci_List(this$13, expectedFieldsSet, true));
      }
      var unexpectedFields = (this$14.isEmpty__Z() ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$() : this$14.get__O());
      if (unexpectedFields.isEmpty__Z()) {
        var strictFailure$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      } else {
        var value$2 = $p_Lio_circe_derivation_ConfiguredDecoder__strictDecodingFailure__Lio_circe_HCursor__T__Lio_circe_DecodingFailure($thiz, c, (((("unexpected fields: " + $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__mkString__T__T__T__T(unexpectedFields, "", ", ", "")) + "; valid fields: ") + $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__mkString__T__T__T__T(expectedFields, "", ", ", "")) + "."));
        var strictFailure$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value$2);
      }
      var $x_2 = f(strictFailure$1);
      break matchResult8;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x27);
  }
  return $x_2;
}
export { $f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either as $f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either };
function $f_Lio_circe_derivation_ConfiguredDecoder__decodeProductAccumulating__Lio_circe_HCursor__F1__Lcats_data_Validated($thiz, c, fromProduct) {
  var f = ((strictFailure) => {
    var dimensions = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I(new Int32Array([$thiz.elemLabels__sci_List().length__I()]));
    var res = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_reflect_Array$().newInstance__jl_Class__AI__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_O.getClassOf(), dimensions);
    var failed = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_ListBuffer();
    var index = 0;
    while ((index < $thiz.elemLabels__sci_List().length__I())) {
      matchResult13: {
        var index$1 = index;
        var this$4 = $thiz.elemDecoders__sci_List();
        var decoder = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_LinearSeqOps__apply__I__O(this$4, index$1);
        var $x_1 = $thiz.io$circe$derivation$ConfiguredDecoder$$conf__Lio_circe_derivation_Configuration().Lio_circe_derivation_Configuration__f_transformMemberNames;
        var this$5 = $thiz.elemLabels__sci_List();
        var cursor = c.downField__T__Lio_circe_ACursor($x_1.apply__O__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_LinearSeqOps__apply__I__O(this$5, index$1)));
        var result = decoder.tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated(cursor);
        if ($thiz.io$circe$derivation$ConfiguredDecoder$$conf__Lio_circe_derivation_Configuration().Lio_circe_derivation_Configuration__f_useDefaults) {
          matchResult7: {
            var x48;
            var this$6 = $thiz.elemDefaults__Lio_circe_derivation_Default();
            var x24 = $f_Lio_circe_derivation_Default__defaultAt__I__s_Option(this$6, index$1);
            var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
            if ((x === x24)) {
              var x48 = result;
              break matchResult7;
            }
            if ((x24 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
              var default$1 = x24.s_Some__f_value;
              var x48 = $ps_Lio_circe_derivation_ConfiguredDecoder__withDefault$2__Lcats_data_Validated__Lio_circe_ACursor__O__Lcats_data_Validated(result, cursor, default$1);
              break matchResult7;
            }
            throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x24);
          }
        } else {
          var x48 = result;
        }
        if ((x48 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_Validated$Valid)) {
          var x54 = x48.Lcats_data_Validated$Valid__f_a;
          res.u[index] = x54;
          break matchResult13;
        }
        if ((x48 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_Validated$Invalid)) {
          var x51 = x48.Lcats_data_Validated$Invalid__f_e;
          var this$9 = x51.Lcats_data_NonEmptyList__f_tail;
          var elem = x51.Lcats_data_NonEmptyList__f_head;
          var elems = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem, this$9);
          failed.addAll__sc_IterableOnce__scm_ListBuffer(elems);
          break matchResult13;
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x48);
      }
      index = ((1 + index) | 0);
    }
    var this$10 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(strictFailure, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
    var b = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_ListBuffer();
    var it = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$10);
    while (it.hasNext__Z()) {
      var x0 = it.next__O();
      var elems$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Option$().option2Iterable__s_Option__sc_Iterable(x0);
      b.addAll__sc_IterableOnce__scm_ListBuffer(elems$1);
    }
    var this$12 = b.toList__sci_List();
    var suffix = failed.toList__sci_List();
    var failures$2 = this$12.appendedAll__sc_IterableOnce__sci_List(suffix);
    if (failures$2.isEmpty__Z()) {
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_Validated$();
      var a = fromProduct.apply__O__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_T$().fromArray__O__s_Product(res));
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_Validated$Valid(a);
    } else {
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_Validated$();
      var e = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_NonEmptyList$().fromListUnsafe__sci_List__Lcats_data_NonEmptyList(failures$2);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_Validated$Invalid(e);
    }
  });
  matchResult8: {
    var $x_2;
    var x27 = c.value__Lio_circe_Json().isObject__Z();
    if ((x27 === false)) {
      var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_DecodingFailure$();
      var jsonValue = c.value__Lio_circe_Json();
      var x0$1 = $x_3.apply__Lio_circe_DecodingFailure$Reason__F0__Lio_circe_DecodingFailure(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation("object", jsonValue), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => c.history__sci_List())));
      var this$18 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_Validated$();
      var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_data_ValidatedFunctions__invalidNel__O__Lcats_data_Validated(this$18, x0$1);
      break matchResult8;
    }
    if ((x27 === true)) {
      if ((!$thiz.io$circe$derivation$ConfiguredDecoder$$conf__Lio_circe_derivation_Configuration().Lio_circe_derivation_Configuration__f_strictDecoding)) {
        var x0$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        var $x_2 = f(x0$2);
        break matchResult8;
      }
      var this$19 = $thiz.elemLabels__sci_List();
      var this$20 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_IndexedSeq$().from__sc_IterableOnce__sci_IndexedSeq(this$19).map__F1__O($thiz.io$circe$derivation$ConfiguredDecoder$$conf__Lio_circe_derivation_Configuration().Lio_circe_derivation_Configuration__f_transformMemberNames);
      var suffix$1 = $thiz.io$circe$derivation$ConfiguredDecoder$$conf__Lio_circe_derivation_Configuration().Lio_circe_derivation_Configuration__f_discriminator;
      var expectedFields = this$20.concat__sc_IterableOnce__O(suffix$1);
      var expectedFieldsSet = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Set$().from__sc_IterableOnce__sci_Set(expectedFields);
      var this$21 = c.keys__s_Option();
      if (this$21.isEmpty__Z()) {
        var this$23 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      } else {
        var x0$3 = this$21.get__O();
        var this$22 = x0$3.toList__sci_List();
        var this$23 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$p_sci_List__filterCommon__F1__Z__sci_List(this$22, expectedFieldsSet, true));
      }
      var unexpectedFields = (this$23.isEmpty__Z() ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$() : this$23.get__O());
      if (unexpectedFields.isEmpty__Z()) {
        var strictFailure$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      } else {
        var value = $p_Lio_circe_derivation_ConfiguredDecoder__strictDecodingFailure__Lio_circe_HCursor__T__Lio_circe_DecodingFailure($thiz, c, (((("unexpected fields: " + $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__mkString__T__T__T__T(unexpectedFields, "", ", ", "")) + "; valid fields: ") + $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__mkString__T__T__T__T(expectedFields, "", ", ", "")) + "."));
        var strictFailure$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
      }
      var $x_2 = f(strictFailure$1);
      break matchResult8;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x27);
  }
  return $x_2;
}
export { $f_Lio_circe_derivation_ConfiguredDecoder__decodeProductAccumulating__Lio_circe_HCursor__F1__Lcats_data_Validated as $f_Lio_circe_derivation_ConfiguredDecoder__decodeProductAccumulating__Lio_circe_HCursor__F1__Lcats_data_Validated };
function $ps_Lio_circe_derivation_ConfiguredDecoder__findDecoderDict$1__T2__sci_List(p) {
  var x1 = p._2__O();
  if (($is_Lio_circe_derivation_ConfiguredDecoder(x1) && $is_Lio_circe_derivation_SumOrProduct(x1))) {
    if (x1.isSum__Z()) {
      var this$1 = x1.constructorNames__sci_List();
      var that = x1.elemDecoders__sci_List();
      var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this$1, that);
      var rest = this$2;
      var h = null;
      var t = null;
      while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
        var x0 = rest.head__O();
        var it = $ps_Lio_circe_derivation_ConfiguredDecoder__findDecoderDict$1__T2__sci_List(x0).iterator__sc_Iterator();
        while (it.hasNext__Z()) {
          var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(it.next__O(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
          if ((t === null)) {
            h = nx;
          } else {
            t.sci_$colon$colon__f_next = nx;
          }
          t = nx;
        }
        rest = rest.tail__O();
      }
      return ((h === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$() : h);
    }
  }
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(p, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
}
export { $ps_Lio_circe_derivation_ConfiguredDecoder__findDecoderDict$1__T2__sci_List as $ps_Lio_circe_derivation_ConfiguredDecoder__findDecoderDict$1__T2__sci_List };
function $ps_Lio_circe_derivation_ConfiguredDecoder__withDefault$1__s_util_Either__Lio_circe_ACursor__O__s_util_Either(result, cursor, default$1) {
  if ((result instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
    if ((result !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_keyMissingNone)) {
      return result;
    }
  }
  if ((result instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
    if (cursor.succeeded__Z()) {
      var this$1 = cursor.focus__s_Option();
      if ((!this$1.isEmpty__Z())) {
        var x0 = this$1.get__O();
        var $x_2 = x0.isNull__Z();
      } else {
        var $x_2 = false;
      }
      var $x_1 = (!$x_2);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return result;
    }
  }
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(default$1);
}
export { $ps_Lio_circe_derivation_ConfiguredDecoder__withDefault$1__s_util_Either__Lio_circe_ACursor__O__s_util_Either as $ps_Lio_circe_derivation_ConfiguredDecoder__withDefault$1__s_util_Either__Lio_circe_ACursor__O__s_util_Either };
function $ps_Lio_circe_derivation_ConfiguredDecoder__withDefault$2__Lcats_data_Validated__Lio_circe_ACursor__O__Lcats_data_Validated(result, cursor, default$1) {
  if ((result instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_Validated$Valid)) {
    if ((result !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_keyMissingNoneAccumulating)) {
      return result;
    }
  }
  if ((result instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_Validated$Invalid)) {
    if (cursor.succeeded__Z()) {
      var this$3 = cursor.focus__s_Option();
      if ((!this$3.isEmpty__Z())) {
        var x0 = this$3.get__O();
        var $x_2 = x0.isNull__Z();
      } else {
        var $x_2 = false;
      }
      var $x_1 = (!$x_2);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return result;
    }
  }
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_Validated$Valid(default$1);
}
export { $ps_Lio_circe_derivation_ConfiguredDecoder__withDefault$2__Lcats_data_Validated__Lio_circe_ACursor__O__Lcats_data_Validated as $ps_Lio_circe_derivation_ConfiguredDecoder__withDefault$2__Lcats_data_Validated__Lio_circe_ACursor__O__Lcats_data_Validated };
function $is_Lio_circe_derivation_ConfiguredDecoder(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lio_circe_derivation_ConfiguredDecoder)));
}
export { $is_Lio_circe_derivation_ConfiguredDecoder as $is_Lio_circe_derivation_ConfiguredDecoder };
function $isArrayOf_Lio_circe_derivation_ConfiguredDecoder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_derivation_ConfiguredDecoder)));
}
export { $isArrayOf_Lio_circe_derivation_ConfiguredDecoder as $isArrayOf_Lio_circe_derivation_ConfiguredDecoder };
/** @constructor */
function $c_Lio_circe_derivation_Default$$anon$1(values$2) {
  this.Lio_circe_derivation_Default$$anon$1__f_values$1 = null;
  this.Lio_circe_derivation_Default$$anon$1__f_defaults$lzy1 = null;
  this.Lio_circe_derivation_Default$$anon$1__f_defaultsbitmap$1 = false;
  this.Lio_circe_derivation_Default$$anon$1__f_values$1 = values$2;
}
export { $c_Lio_circe_derivation_Default$$anon$1 as $c_Lio_circe_derivation_Default$$anon$1 };
$c_Lio_circe_derivation_Default$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_circe_derivation_Default$$anon$1.prototype.constructor = $c_Lio_circe_derivation_Default$$anon$1;
/** @constructor */
function $h_Lio_circe_derivation_Default$$anon$1() {
}
export { $h_Lio_circe_derivation_Default$$anon$1 as $h_Lio_circe_derivation_Default$$anon$1 };
$h_Lio_circe_derivation_Default$$anon$1.prototype = $c_Lio_circe_derivation_Default$$anon$1.prototype;
$c_Lio_circe_derivation_Default$$anon$1.prototype.defaults__s_Product = (function() {
  if ((!this.Lio_circe_derivation_Default$$anon$1__f_defaultsbitmap$1)) {
    this.Lio_circe_derivation_Default$$anon$1__f_defaults$lzy1 = this.Lio_circe_derivation_Default$$anon$1__f_values$1.apply__O();
    this.Lio_circe_derivation_Default$$anon$1__f_defaultsbitmap$1 = true;
  }
  return this.Lio_circe_derivation_Default$$anon$1__f_defaults$lzy1;
});
var $d_Lio_circe_derivation_Default$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_circe_derivation_Default$$anon$1, "io.circe.derivation.Default$$anon$1", ({
  Lio_circe_derivation_Default$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_derivation_Default: 1
}));
export { $d_Lio_circe_derivation_Default$$anon$1 as $d_Lio_circe_derivation_Default$$anon$1 };
/** @constructor */
function $c_Lio_circe_parser_package$() {
}
export { $c_Lio_circe_parser_package$ as $c_Lio_circe_parser_package$ };
$c_Lio_circe_parser_package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_circe_parser_package$.prototype.constructor = $c_Lio_circe_parser_package$;
/** @constructor */
function $h_Lio_circe_parser_package$() {
}
export { $h_Lio_circe_parser_package$ as $h_Lio_circe_parser_package$ };
$h_Lio_circe_parser_package$.prototype = $c_Lio_circe_parser_package$.prototype;
$c_Lio_circe_parser_package$.prototype.parse__T__s_util_Either = (function(input) {
  try {
    var x5 = $m_Lio_circe_scalajs_package$().convertJsToJson__sjs_js_Any__s_util_Either(JSON.parse(input));
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
    matchResult1: {
      var x5;
      var x2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
      if ((!x2.isEmpty__Z())) {
        var x3 = x2.get__O();
        $m_Lio_circe_ParsingFailure$();
        var message = x3.getMessage__T();
        var value = new $c_Lio_circe_ParsingFailure(message, x3);
        var x5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value);
        break matchResult1;
      }
      throw ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  }
  if ((x5 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
    return x5;
  }
  if ((x5 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
    var exception$2 = x5.s_util_Left__f_value;
    $m_Lio_circe_ParsingFailure$();
    var message$1 = exception$2.getMessage__T();
    var value$1 = new $c_Lio_circe_ParsingFailure(message$1, exception$2);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value$1);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x5);
});
var $d_Lio_circe_parser_package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_circe_parser_package$, "io.circe.parser.package$", ({
  Lio_circe_parser_package$: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Parser: 1
}));
export { $d_Lio_circe_parser_package$ as $d_Lio_circe_parser_package$ };
var $n_Lio_circe_parser_package$;
function $m_Lio_circe_parser_package$() {
  if ((!$n_Lio_circe_parser_package$)) {
    $n_Lio_circe_parser_package$ = new $c_Lio_circe_parser_package$();
  }
  return $n_Lio_circe_parser_package$;
}
export { $m_Lio_circe_parser_package$ as $m_Lio_circe_parser_package$ };
/** @constructor */
function $c_Lio_scalaland_chimney_PartialTransformer$() {
}
export { $c_Lio_scalaland_chimney_PartialTransformer$ as $c_Lio_scalaland_chimney_PartialTransformer$ };
$c_Lio_scalaland_chimney_PartialTransformer$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_scalaland_chimney_PartialTransformer$.prototype.constructor = $c_Lio_scalaland_chimney_PartialTransformer$;
/** @constructor */
function $h_Lio_scalaland_chimney_PartialTransformer$() {
}
export { $h_Lio_scalaland_chimney_PartialTransformer$ as $h_Lio_scalaland_chimney_PartialTransformer$ };
$h_Lio_scalaland_chimney_PartialTransformer$.prototype = $c_Lio_scalaland_chimney_PartialTransformer$.prototype;
var $d_Lio_scalaland_chimney_PartialTransformer$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_scalaland_chimney_PartialTransformer$, "io.scalaland.chimney.PartialTransformer$", ({
  Lio_scalaland_chimney_PartialTransformer$: 1,
  Lio_scalaland_chimney_PartialTransformerLowPriorityImplicits1: 1,
  Lio_scalaland_chimney_PartialTransformerCompanionPlatform: 1
}));
export { $d_Lio_scalaland_chimney_PartialTransformer$ as $d_Lio_scalaland_chimney_PartialTransformer$ };
var $n_Lio_scalaland_chimney_PartialTransformer$;
function $m_Lio_scalaland_chimney_PartialTransformer$() {
  if ((!$n_Lio_scalaland_chimney_PartialTransformer$)) {
    $n_Lio_scalaland_chimney_PartialTransformer$ = new $c_Lio_scalaland_chimney_PartialTransformer$();
  }
  return $n_Lio_scalaland_chimney_PartialTransformer$;
}
export { $m_Lio_scalaland_chimney_PartialTransformer$ as $m_Lio_scalaland_chimney_PartialTransformer$ };
/** @constructor */
function $c_Lio_scalaland_chimney_PartialTransformer$$anon$1(f$5) {
  this.Lio_scalaland_chimney_PartialTransformer$$anon$1__f_f$3 = null;
  this.Lio_scalaland_chimney_PartialTransformer$$anon$1__f_f$3 = f$5;
}
export { $c_Lio_scalaland_chimney_PartialTransformer$$anon$1 as $c_Lio_scalaland_chimney_PartialTransformer$$anon$1 };
$c_Lio_scalaland_chimney_PartialTransformer$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_scalaland_chimney_PartialTransformer$$anon$1.prototype.constructor = $c_Lio_scalaland_chimney_PartialTransformer$$anon$1;
/** @constructor */
function $h_Lio_scalaland_chimney_PartialTransformer$$anon$1() {
}
export { $h_Lio_scalaland_chimney_PartialTransformer$$anon$1 as $h_Lio_scalaland_chimney_PartialTransformer$$anon$1 };
$h_Lio_scalaland_chimney_PartialTransformer$$anon$1.prototype = $c_Lio_scalaland_chimney_PartialTransformer$$anon$1.prototype;
$c_Lio_scalaland_chimney_PartialTransformer$$anon$1.prototype.transform__O__Z__Lio_scalaland_chimney_partial_Result = (function(src, _$1) {
  var f$1 = this.Lio_scalaland_chimney_PartialTransformer$$anon$1__f_f$3;
  try {
    return f$1.apply__O__O(src);
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
    return $m_Lio_scalaland_chimney_partial_Result$().fromErrorThrowable__jl_Throwable__Lio_scalaland_chimney_partial_Result(e$2);
  }
});
var $d_Lio_scalaland_chimney_PartialTransformer$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_scalaland_chimney_PartialTransformer$$anon$1, "io.scalaland.chimney.PartialTransformer$$anon$1", ({
  Lio_scalaland_chimney_PartialTransformer$$anon$1: 1,
  Lio_scalaland_chimney_PartialTransformer$AutoDerived: 1,
  Lio_scalaland_chimney_PartialTransformer: 1
}));
export { $d_Lio_scalaland_chimney_PartialTransformer$$anon$1 as $d_Lio_scalaland_chimney_PartialTransformer$$anon$1 };
/** @constructor */
function $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$() {
}
export { $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$ as $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$ };
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$.prototype.constructor = $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$;
/** @constructor */
function $h_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$() {
}
export { $h_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$ as $h_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$ };
$h_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$.prototype = $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$.prototype;
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$.prototype.from__Lio_scalaland_chimney_partial_Error__sci_Seq__Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain = (function(head, tail) {
  if (tail.isEmpty__Z()) {
    var $x_1 = new $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single(head);
  } else if ((tail.lengthCompare__I__I(1) === 0)) {
    var errors1 = new $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single(head);
    var error = tail.head__O();
    var errors2 = new $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single(error);
    var $x_1 = new $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge(errors1, errors2);
  } else {
    var errors1$1 = new $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single(head);
    var errors2$1 = new $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Wrap(tail);
    var $x_1 = new $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge(errors1$1, errors2$1);
  }
  return $x_1;
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$.prototype.ordinal__Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain__I = (function(x$0) {
  if ((x$0 instanceof $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single)) {
    return 0;
  }
  if ((x$0 instanceof $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Wrap)) {
    return 1;
  }
  if ((x$0 instanceof $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge)) {
    return 2;
  }
  if ((x$0 instanceof $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath)) {
    return 3;
  }
  if ((x$0 instanceof $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$UnsealPath)) {
    return 4;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$0);
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain__I(x);
});
var $d_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$, "io.scalaland.chimney.internal.runtime.NonEmptyErrorsChain$", ({
  Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$ as $d_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$ };
var $n_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$;
function $m_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$() {
  if ((!$n_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$)) {
    $n_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$ = new $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$();
  }
  return $n_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$;
}
export { $m_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$ as $m_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$ };
/** @constructor */
function $c_Lio_scalaland_chimney_partial_Error$() {
}
export { $c_Lio_scalaland_chimney_partial_Error$ as $c_Lio_scalaland_chimney_partial_Error$ };
$c_Lio_scalaland_chimney_partial_Error$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_scalaland_chimney_partial_Error$.prototype.constructor = $c_Lio_scalaland_chimney_partial_Error$;
/** @constructor */
function $h_Lio_scalaland_chimney_partial_Error$() {
}
export { $h_Lio_scalaland_chimney_partial_Error$ as $h_Lio_scalaland_chimney_partial_Error$ };
$h_Lio_scalaland_chimney_partial_Error$.prototype = $c_Lio_scalaland_chimney_partial_Error$.prototype;
$c_Lio_scalaland_chimney_partial_Error$.prototype.fromString__T__Lio_scalaland_chimney_partial_Error = (function(message) {
  var message$1 = new $c_Lio_scalaland_chimney_partial_ErrorMessage$StringMessage(message);
  var path = $m_Lio_scalaland_chimney_partial_Path$().Lio_scalaland_chimney_partial_Path$__f_Empty;
  return new $c_Lio_scalaland_chimney_partial_Error(message$1, path);
});
$c_Lio_scalaland_chimney_partial_Error$.prototype.fromThrowable__jl_Throwable__Lio_scalaland_chimney_partial_Error = (function(throwable) {
  var message = new $c_Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage(throwable);
  var path = $m_Lio_scalaland_chimney_partial_Path$().Lio_scalaland_chimney_partial_Path$__f_Empty;
  return new $c_Lio_scalaland_chimney_partial_Error(message, path);
});
$c_Lio_scalaland_chimney_partial_Error$.prototype.fromProduct__s_Product__Lio_scalaland_chimney_partial_Error = (function(x$0) {
  var $x_1 = x$0.productElement__I__O(0);
  var ev$1 = x$0.productElement__I__O(1);
  return new $c_Lio_scalaland_chimney_partial_Error($x_1, ((ev$1 === null) ? null : ev$1.Lio_scalaland_chimney_partial_Path__f_elements));
});
$c_Lio_scalaland_chimney_partial_Error$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lio_scalaland_chimney_partial_Error(p);
});
var $d_Lio_scalaland_chimney_partial_Error$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_scalaland_chimney_partial_Error$, "io.scalaland.chimney.partial.Error$", ({
  Lio_scalaland_chimney_partial_Error$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lio_scalaland_chimney_partial_Error$ as $d_Lio_scalaland_chimney_partial_Error$ };
var $n_Lio_scalaland_chimney_partial_Error$;
function $m_Lio_scalaland_chimney_partial_Error$() {
  if ((!$n_Lio_scalaland_chimney_partial_Error$)) {
    $n_Lio_scalaland_chimney_partial_Error$ = new $c_Lio_scalaland_chimney_partial_Error$();
  }
  return $n_Lio_scalaland_chimney_partial_Error$;
}
export { $m_Lio_scalaland_chimney_partial_Error$ as $m_Lio_scalaland_chimney_partial_Error$ };
/** @constructor */
function $c_Lio_scalaland_chimney_partial_PathElement$() {
}
export { $c_Lio_scalaland_chimney_partial_PathElement$ as $c_Lio_scalaland_chimney_partial_PathElement$ };
$c_Lio_scalaland_chimney_partial_PathElement$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_scalaland_chimney_partial_PathElement$.prototype.constructor = $c_Lio_scalaland_chimney_partial_PathElement$;
/** @constructor */
function $h_Lio_scalaland_chimney_partial_PathElement$() {
}
export { $h_Lio_scalaland_chimney_partial_PathElement$ as $h_Lio_scalaland_chimney_partial_PathElement$ };
$h_Lio_scalaland_chimney_partial_PathElement$.prototype = $c_Lio_scalaland_chimney_partial_PathElement$.prototype;
$c_Lio_scalaland_chimney_partial_PathElement$.prototype.shouldPrependWithDot__Lio_scalaland_chimney_partial_PathElement__Z = (function(pathElement) {
  if ((pathElement instanceof $c_Lio_scalaland_chimney_partial_PathElement$Accessor)) {
    return true;
  }
  if ((pathElement instanceof $c_Lio_scalaland_chimney_partial_PathElement$Index)) {
    return false;
  }
  if (false) {
    return false;
  }
  if (false) {
    return true;
  }
  if (false) {
    return false;
  }
  if (false) {
    return false;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(pathElement);
});
$c_Lio_scalaland_chimney_partial_PathElement$.prototype.ordinal__Lio_scalaland_chimney_partial_PathElement__I = (function(x$0) {
  if ((x$0 instanceof $c_Lio_scalaland_chimney_partial_PathElement$Accessor)) {
    return 0;
  }
  if ((x$0 instanceof $c_Lio_scalaland_chimney_partial_PathElement$Index)) {
    return 1;
  }
  if (false) {
    return 2;
  }
  if (false) {
    return 3;
  }
  if (false) {
    return 4;
  }
  if (false) {
    return 5;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$0);
});
$c_Lio_scalaland_chimney_partial_PathElement$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Lio_scalaland_chimney_partial_PathElement__I(x);
});
var $d_Lio_scalaland_chimney_partial_PathElement$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_scalaland_chimney_partial_PathElement$, "io.scalaland.chimney.partial.PathElement$", ({
  Lio_scalaland_chimney_partial_PathElement$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lio_scalaland_chimney_partial_PathElement$ as $d_Lio_scalaland_chimney_partial_PathElement$ };
var $n_Lio_scalaland_chimney_partial_PathElement$;
function $m_Lio_scalaland_chimney_partial_PathElement$() {
  if ((!$n_Lio_scalaland_chimney_partial_PathElement$)) {
    $n_Lio_scalaland_chimney_partial_PathElement$ = new $c_Lio_scalaland_chimney_partial_PathElement$();
  }
  return $n_Lio_scalaland_chimney_partial_PathElement$;
}
export { $m_Lio_scalaland_chimney_partial_PathElement$ as $m_Lio_scalaland_chimney_partial_PathElement$ };
/** @constructor */
function $c_Lio_scalaland_chimney_partial_Result$() {
}
export { $c_Lio_scalaland_chimney_partial_Result$ as $c_Lio_scalaland_chimney_partial_Result$ };
$c_Lio_scalaland_chimney_partial_Result$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_scalaland_chimney_partial_Result$.prototype.constructor = $c_Lio_scalaland_chimney_partial_Result$;
/** @constructor */
function $h_Lio_scalaland_chimney_partial_Result$() {
}
export { $h_Lio_scalaland_chimney_partial_Result$ as $h_Lio_scalaland_chimney_partial_Result$ };
$h_Lio_scalaland_chimney_partial_Result$.prototype = $c_Lio_scalaland_chimney_partial_Result$.prototype;
$c_Lio_scalaland_chimney_partial_Result$.prototype.fromErrorThrowable__jl_Throwable__Lio_scalaland_chimney_partial_Result = (function(throwable) {
  return $m_Lio_scalaland_chimney_partial_Result$Errors$().single__Lio_scalaland_chimney_partial_Error__Lio_scalaland_chimney_partial_Result$Errors($m_Lio_scalaland_chimney_partial_Error$().fromThrowable__jl_Throwable__Lio_scalaland_chimney_partial_Error(throwable));
});
$c_Lio_scalaland_chimney_partial_Result$.prototype.fromEither__s_util_Either__Lio_scalaland_chimney_partial_Result = (function(value) {
  if ((value instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
    var value$2 = value.s_util_Right__f_value;
    return new $c_Lio_scalaland_chimney_partial_Result$Value(value$2);
  }
  if ((value instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
    var x83 = value.s_util_Left__f_value;
    if ((x83 !== null)) {
      return x83;
    }
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(value);
});
$c_Lio_scalaland_chimney_partial_Result$.prototype.fromEitherString__s_util_Either__Lio_scalaland_chimney_partial_Result = (function(value) {
  var this$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Either$LeftProjection(value);
  var x1 = this$1.s_util_Either$LeftProjection__f_e;
  if ((x1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
    var a = x1.s_util_Left__f_value;
    var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left($m_Lio_scalaland_chimney_partial_Result$Errors$().fromString__T__Lio_scalaland_chimney_partial_Result$Errors(a));
  } else {
    var $x_1 = this$1.s_util_Either$LeftProjection__f_e;
  }
  return this.fromEither__s_util_Either__Lio_scalaland_chimney_partial_Result($x_1);
});
$c_Lio_scalaland_chimney_partial_Result$.prototype.ordinal__Lio_scalaland_chimney_partial_Result__I = (function(x$0) {
  if ((x$0 instanceof $c_Lio_scalaland_chimney_partial_Result$Value)) {
    return 0;
  }
  if ((x$0 instanceof $c_Lio_scalaland_chimney_partial_Result$Errors)) {
    return 1;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$0);
});
$c_Lio_scalaland_chimney_partial_Result$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Lio_scalaland_chimney_partial_Result__I(x);
});
var $d_Lio_scalaland_chimney_partial_Result$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_scalaland_chimney_partial_Result$, "io.scalaland.chimney.partial.Result$", ({
  Lio_scalaland_chimney_partial_Result$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lio_scalaland_chimney_partial_Result$ as $d_Lio_scalaland_chimney_partial_Result$ };
var $n_Lio_scalaland_chimney_partial_Result$;
function $m_Lio_scalaland_chimney_partial_Result$() {
  if ((!$n_Lio_scalaland_chimney_partial_Result$)) {
    $n_Lio_scalaland_chimney_partial_Result$ = new $c_Lio_scalaland_chimney_partial_Result$();
  }
  return $n_Lio_scalaland_chimney_partial_Result$;
}
export { $m_Lio_scalaland_chimney_partial_Result$ as $m_Lio_scalaland_chimney_partial_Result$ };
/** @constructor */
function $c_Lio_scalaland_chimney_partial_Result$Errors$() {
}
export { $c_Lio_scalaland_chimney_partial_Result$Errors$ as $c_Lio_scalaland_chimney_partial_Result$Errors$ };
$c_Lio_scalaland_chimney_partial_Result$Errors$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_scalaland_chimney_partial_Result$Errors$.prototype.constructor = $c_Lio_scalaland_chimney_partial_Result$Errors$;
/** @constructor */
function $h_Lio_scalaland_chimney_partial_Result$Errors$() {
}
export { $h_Lio_scalaland_chimney_partial_Result$Errors$ as $h_Lio_scalaland_chimney_partial_Result$Errors$ };
$h_Lio_scalaland_chimney_partial_Result$Errors$.prototype = $c_Lio_scalaland_chimney_partial_Result$Errors$.prototype;
$c_Lio_scalaland_chimney_partial_Result$Errors$.prototype.apply__Lio_scalaland_chimney_partial_Error__sci_Seq__Lio_scalaland_chimney_partial_Result$Errors = (function(error, errors) {
  var errors$1 = $m_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$().from__Lio_scalaland_chimney_partial_Error__sci_Seq__Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain(error, errors);
  return new $c_Lio_scalaland_chimney_partial_Result$Errors(errors$1);
});
$c_Lio_scalaland_chimney_partial_Result$Errors$.prototype.single__Lio_scalaland_chimney_partial_Error__Lio_scalaland_chimney_partial_Result$Errors = (function(error) {
  var errors = new $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single(error);
  return new $c_Lio_scalaland_chimney_partial_Result$Errors(errors);
});
$c_Lio_scalaland_chimney_partial_Result$Errors$.prototype.fromString__T__Lio_scalaland_chimney_partial_Result$Errors = (function(message) {
  return this.single__Lio_scalaland_chimney_partial_Error__Lio_scalaland_chimney_partial_Result$Errors($m_Lio_scalaland_chimney_partial_Error$().fromString__T__Lio_scalaland_chimney_partial_Error(message));
});
$c_Lio_scalaland_chimney_partial_Result$Errors$.prototype.fromStrings__T__sci_Seq__Lio_scalaland_chimney_partial_Result$Errors = (function(message, messages) {
  return this.apply__Lio_scalaland_chimney_partial_Error__sci_Seq__Lio_scalaland_chimney_partial_Result$Errors($m_Lio_scalaland_chimney_partial_Error$().fromString__T__Lio_scalaland_chimney_partial_Error(message), messages.map__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((message$2) => $m_Lio_scalaland_chimney_partial_Error$().fromString__T__Lio_scalaland_chimney_partial_Error(message$2)))));
});
$c_Lio_scalaland_chimney_partial_Result$Errors$.prototype.merge__Lio_scalaland_chimney_partial_Result$Errors__Lio_scalaland_chimney_partial_Result$Errors__Lio_scalaland_chimney_partial_Result$Errors = (function(errors1, errors2) {
  var this$1 = errors1.Lio_scalaland_chimney_partial_Result$Errors__f_errors;
  var other = errors2.Lio_scalaland_chimney_partial_Result$Errors__f_errors;
  var errors = new $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge(this$1, other);
  return new $c_Lio_scalaland_chimney_partial_Result$Errors(errors);
});
$c_Lio_scalaland_chimney_partial_Result$Errors$.prototype._\uff3fmergeResultNullable__Lio_scalaland_chimney_partial_Result$Errors__Lio_scalaland_chimney_partial_Result__Lio_scalaland_chimney_partial_Result$Errors = (function(errorsNullable, result) {
  if ((result instanceof $c_Lio_scalaland_chimney_partial_Result$Value)) {
    return errorsNullable;
  }
  if ((result instanceof $c_Lio_scalaland_chimney_partial_Result$Errors)) {
    return ((errorsNullable === null) ? result : this.merge__Lio_scalaland_chimney_partial_Result$Errors__Lio_scalaland_chimney_partial_Result$Errors__Lio_scalaland_chimney_partial_Result$Errors(errorsNullable, result));
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(result);
});
$c_Lio_scalaland_chimney_partial_Result$Errors$.prototype.fromProduct__s_Product__Lio_scalaland_chimney_partial_Result$Errors = (function(x$0) {
  return new $c_Lio_scalaland_chimney_partial_Result$Errors(x$0.productElement__I__O(0));
});
$c_Lio_scalaland_chimney_partial_Result$Errors$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lio_scalaland_chimney_partial_Result$Errors(p);
});
var $d_Lio_scalaland_chimney_partial_Result$Errors$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_scalaland_chimney_partial_Result$Errors$, "io.scalaland.chimney.partial.Result$Errors$", ({
  Lio_scalaland_chimney_partial_Result$Errors$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lio_scalaland_chimney_partial_Result$Errors$ as $d_Lio_scalaland_chimney_partial_Result$Errors$ };
var $n_Lio_scalaland_chimney_partial_Result$Errors$;
function $m_Lio_scalaland_chimney_partial_Result$Errors$() {
  if ((!$n_Lio_scalaland_chimney_partial_Result$Errors$)) {
    $n_Lio_scalaland_chimney_partial_Result$Errors$ = new $c_Lio_scalaland_chimney_partial_Result$Errors$();
  }
  return $n_Lio_scalaland_chimney_partial_Result$Errors$;
}
export { $m_Lio_scalaland_chimney_partial_Result$Errors$ as $m_Lio_scalaland_chimney_partial_Result$Errors$ };
/** @constructor */
function $c_Ljava_io_InputStream() {
}
export { $c_Ljava_io_InputStream as $c_Ljava_io_InputStream };
$c_Ljava_io_InputStream.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Ljava_io_InputStream.prototype.constructor = $c_Ljava_io_InputStream;
/** @constructor */
function $h_Ljava_io_InputStream() {
}
export { $h_Ljava_io_InputStream as $h_Ljava_io_InputStream };
$h_Ljava_io_InputStream.prototype = $c_Ljava_io_InputStream.prototype;
function $p_Ljava_net_URI__comparePathQueryFragement$1__Ljava_net_URI__I($thiz, that$1) {
  var cmpPath = $m_Ljava_net_URI$().java$net$URI$$escapeAwareCompare__T__T__I($thiz.Ljava_net_URI__f__path, that$1.Ljava_net_URI__f__path);
  if ((cmpPath !== 0)) {
    return cmpPath;
  } else {
    var cmpQuery = $m_Ljava_net_URI$().java$net$URI$$escapeAwareCompare__T__T__I($thiz.Ljava_net_URI__f__query, that$1.Ljava_net_URI__f__query);
    return ((cmpQuery !== 0) ? cmpQuery : $m_Ljava_net_URI$().java$net$URI$$escapeAwareCompare__T__T__I($thiz.Ljava_net_URI__f__fragment, that$1.Ljava_net_URI__f__fragment));
  }
}
export { $p_Ljava_net_URI__comparePathQueryFragement$1__Ljava_net_URI__I as $p_Ljava_net_URI__comparePathQueryFragement$1__Ljava_net_URI__I };
function $ps_Ljava_net_URI__normalizeEscapesHash$1__T__I(str) {
  return ((str === null) ? 0 : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I($m_Ljava_net_URI$().java$net$URI$$normalizeEscapes__T__T(str)));
}
export { $ps_Ljava_net_URI__normalizeEscapesHash$1__T__I as $ps_Ljava_net_URI__normalizeEscapesHash$1__T__I };
/** @constructor */
function $c_Ljava_net_URI(origStr) {
  this.Ljava_net_URI__f_origStr = null;
  this.Ljava_net_URI__f_java$net$URI$$_fld = null;
  this.Ljava_net_URI__f_java$net$URI$$_isAbsolute = false;
  this.Ljava_net_URI__f__isOpaque = false;
  this.Ljava_net_URI__f__scheme = null;
  this.Ljava_net_URI__f__schemeSpecificPart = null;
  this.Ljava_net_URI__f__authority = null;
  this.Ljava_net_URI__f__userInfo = null;
  this.Ljava_net_URI__f__host = null;
  this.Ljava_net_URI__f__port = 0;
  this.Ljava_net_URI__f__path = null;
  this.Ljava_net_URI__f__query = null;
  this.Ljava_net_URI__f__fragment = null;
  this.Ljava_net_URI__f_origStr = origStr;
  this.Ljava_net_URI__f_java$net$URI$$_fld = $m_Ljava_net_URI$().Ljava_net_URI$__f_java$net$URI$$uriRe.exec(origStr);
  if ((this.Ljava_net_URI__f_java$net$URI$$_fld === null)) {
    throw $ct_Ljava_net_URISyntaxException__T__T__(new $c_Ljava_net_URISyntaxException(), origStr, "Malformed URI");
  }
  var x = this.Ljava_net_URI__f_java$net$URI$$_fld[1];
  this.Ljava_net_URI__f_java$net$URI$$_isAbsolute = (x !== (void 0));
  var x$1 = this.Ljava_net_URI__f_java$net$URI$$_fld[10];
  this.Ljava_net_URI__f__isOpaque = (x$1 !== (void 0));
  var x$2 = this.Ljava_net_URI__f_java$net$URI$$_fld[1];
  this.Ljava_net_URI__f__scheme = ((x$2 !== (void 0)) ? x$2 : null);
  if ((!this.Ljava_net_URI__f_java$net$URI$$_isAbsolute)) {
    var x$3 = this.Ljava_net_URI__f_java$net$URI$$_fld[11];
    var $x_1 = ((x$3 !== (void 0)) ? x$3 : null);
  } else if (this.Ljava_net_URI__f__isOpaque) {
    var x$4 = this.Ljava_net_URI__f_java$net$URI$$_fld[10];
    var $x_1 = ((x$4 !== (void 0)) ? x$4 : null);
  } else {
    var x$5 = this.Ljava_net_URI__f_java$net$URI$$_fld[2];
    var $x_1 = ((x$5 !== (void 0)) ? x$5 : null);
  }
  this.Ljava_net_URI__f__schemeSpecificPart = $x_1;
  if (this.Ljava_net_URI__f_java$net$URI$$_isAbsolute) {
    var x$6 = this.Ljava_net_URI__f_java$net$URI$$_fld[3];
    var authPart = ((x$6 !== (void 0)) ? x$6 : null);
  } else {
    var x$7 = this.Ljava_net_URI__f_java$net$URI$$_fld[12];
    var authPart = ((x$7 !== (void 0)) ? x$7 : null);
  }
  this.Ljava_net_URI__f__authority = ((authPart === "") ? null : authPart);
  if (this.Ljava_net_URI__f_java$net$URI$$_isAbsolute) {
    var x$8 = this.Ljava_net_URI__f_java$net$URI$$_fld[4];
    var $x_2 = ((x$8 !== (void 0)) ? x$8 : null);
  } else {
    var x$9 = this.Ljava_net_URI__f_java$net$URI$$_fld[13];
    var $x_2 = ((x$9 !== (void 0)) ? x$9 : null);
  }
  this.Ljava_net_URI__f__userInfo = $x_2;
  if (this.Ljava_net_URI__f_java$net$URI$$_isAbsolute) {
    var x$10 = this.Ljava_net_URI__f_java$net$URI$$_fld[5];
    var $x_3 = ((x$10 !== (void 0)) ? x$10 : null);
  } else {
    var x$11 = this.Ljava_net_URI__f_java$net$URI$$_fld[14];
    var $x_3 = ((x$11 !== (void 0)) ? x$11 : null);
  }
  this.Ljava_net_URI__f__host = $x_3;
  if (this.Ljava_net_URI__f_java$net$URI$$_isAbsolute) {
    var x$12 = this.Ljava_net_URI__f_java$net$URI$$_fld[6];
    var portPart = ((x$12 !== (void 0)) ? x$12 : null);
  } else {
    var x$13 = this.Ljava_net_URI__f_java$net$URI$$_fld[15];
    var portPart = ((x$13 !== (void 0)) ? x$13 : null);
  }
  if ((portPart === null)) {
    var $x_4 = (-1);
  } else {
    var this$15 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Integer$();
    var $x_4 = this$15.java$lang$Integer$$parseIntImpl__T__I__I__I(portPart, 10, 214748364);
  }
  this.Ljava_net_URI__f__port = $x_4;
  if (this.Ljava_net_URI__f_java$net$URI$$_isAbsolute) {
    var x$14 = this.Ljava_net_URI__f_java$net$URI$$_fld[3];
    var $x_5 = ((x$14 !== (void 0)) ? x$14 : null);
  } else {
    var x$15 = this.Ljava_net_URI__f_java$net$URI$$_fld[12];
    var $x_5 = ((x$15 !== (void 0)) ? x$15 : null);
  }
  var useNetPath = ($x_5 !== null);
  if (useNetPath) {
    if (this.Ljava_net_URI__f_java$net$URI$$_isAbsolute) {
      var x$16 = this.Ljava_net_URI__f_java$net$URI$$_fld[7];
      var netPath = ((x$16 !== (void 0)) ? x$16 : null);
    } else {
      var x$17 = this.Ljava_net_URI__f_java$net$URI$$_fld[16];
      var netPath = ((x$17 !== (void 0)) ? x$17 : null);
    }
    var $x_6 = ((netPath === null) ? "" : netPath);
  } else if (this.Ljava_net_URI__f_java$net$URI$$_isAbsolute) {
    var x$18 = this.Ljava_net_URI__f_java$net$URI$$_fld[8];
    var $x_6 = ((x$18 !== (void 0)) ? x$18 : null);
  } else {
    var x$19 = this.Ljava_net_URI__f_java$net$URI$$_fld[17];
    var relAbsPath = ((x$19 !== (void 0)) ? x$19 : null);
    if ((relAbsPath !== null)) {
      var $x_6 = relAbsPath;
    } else {
      var x$20 = this.Ljava_net_URI__f_java$net$URI$$_fld[18];
      var $x_6 = ((x$20 !== (void 0)) ? x$20 : null);
    }
  }
  this.Ljava_net_URI__f__path = $x_6;
  if (this.Ljava_net_URI__f_java$net$URI$$_isAbsolute) {
    var x$21 = this.Ljava_net_URI__f_java$net$URI$$_fld[9];
    var $x_7 = ((x$21 !== (void 0)) ? x$21 : null);
  } else {
    var x$22 = this.Ljava_net_URI__f_java$net$URI$$_fld[19];
    var $x_7 = ((x$22 !== (void 0)) ? x$22 : null);
  }
  this.Ljava_net_URI__f__query = $x_7;
  var x$23 = this.Ljava_net_URI__f_java$net$URI$$_fld[20];
  this.Ljava_net_URI__f__fragment = ((x$23 !== (void 0)) ? x$23 : null);
  this.Ljava_net_URI__f_java$net$URI$$_fld = null;
}
export { $c_Ljava_net_URI as $c_Ljava_net_URI };
$c_Ljava_net_URI.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Ljava_net_URI.prototype.constructor = $c_Ljava_net_URI;
/** @constructor */
function $h_Ljava_net_URI() {
}
export { $h_Ljava_net_URI as $h_Ljava_net_URI };
$h_Ljava_net_URI.prototype = $c_Ljava_net_URI.prototype;
$c_Ljava_net_URI.prototype.compareTo__Ljava_net_URI__I = (function(that) {
  var cmpScheme = $m_Ljava_net_URI$().java$net$URI$$caseInsensitiveCompare__T__T__I(this.Ljava_net_URI__f__scheme, that.Ljava_net_URI__f__scheme);
  if ((cmpScheme !== 0)) {
    return cmpScheme;
  } else {
    var x = this.Ljava_net_URI__f__isOpaque;
    var y = that.Ljava_net_URI__f__isOpaque;
    var cmpIsOpaque = ((x === y) ? 0 : (x ? 1 : (-1)));
    if ((cmpIsOpaque !== 0)) {
      return cmpIsOpaque;
    } else if (this.Ljava_net_URI__f__isOpaque) {
      var cmpSchemeSpecificPart = $m_Ljava_net_URI$().java$net$URI$$escapeAwareCompare__T__T__I(this.Ljava_net_URI__f__schemeSpecificPart, that.Ljava_net_URI__f__schemeSpecificPart);
      return ((cmpSchemeSpecificPart !== 0) ? cmpSchemeSpecificPart : $p_Ljava_net_URI__comparePathQueryFragement$1__Ljava_net_URI__I(this, that));
    } else if (((this.Ljava_net_URI__f__host !== null) && (that.Ljava_net_URI__f__host !== null))) {
      var cmpUserInfo = $m_Ljava_net_URI$().java$net$URI$$escapeAwareCompare__T__T__I(this.Ljava_net_URI__f__userInfo, that.Ljava_net_URI__f__userInfo);
      if ((cmpUserInfo !== 0)) {
        return cmpUserInfo;
      } else {
        var cmpHost = $m_Ljava_net_URI$().java$net$URI$$caseInsensitiveCompare__T__T__I(this.Ljava_net_URI__f__host, that.Ljava_net_URI__f__host);
        if ((cmpHost !== 0)) {
          return cmpHost;
        } else {
          var cmpPort = ((this.Ljava_net_URI__f__port - that.Ljava_net_URI__f__port) | 0);
          return ((cmpPort !== 0) ? cmpPort : $p_Ljava_net_URI__comparePathQueryFragement$1__Ljava_net_URI__I(this, that));
        }
      }
    } else {
      var cmpAuthority = $m_Ljava_net_URI$().java$net$URI$$escapeAwareCompare__T__T__I(this.Ljava_net_URI__f__authority, that.Ljava_net_URI__f__authority);
      return ((cmpAuthority !== 0) ? cmpAuthority : $p_Ljava_net_URI__comparePathQueryFragement$1__Ljava_net_URI__I(this, that));
    }
  }
});
$c_Ljava_net_URI.prototype.equals__O__Z = (function(that) {
  return ((that instanceof $c_Ljava_net_URI) && (this.compareTo__Ljava_net_URI__I(that) === 0));
});
$c_Ljava_net_URI.prototype.hashCode__I = (function() {
  var acc = 53722356;
  var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_internal_MurmurHash3$();
  var $x_2 = acc;
  if ((this.Ljava_net_URI__f__scheme === null)) {
    var $x_1 = 0;
  } else {
    var this$1 = this.Ljava_net_URI__f__scheme;
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I(this$1.toLowerCase());
  }
  acc = $x_3.mix__I__I__I($x_2, $x_1);
  if (this.Ljava_net_URI__f__isOpaque) {
    acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_internal_MurmurHash3$().mix__I__I__I(acc, $ps_Ljava_net_URI__normalizeEscapesHash$1__T__I(this.Ljava_net_URI__f__schemeSpecificPart));
  } else if ((this.Ljava_net_URI__f__host !== null)) {
    acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_internal_MurmurHash3$().mix__I__I__I(acc, $ps_Ljava_net_URI__normalizeEscapesHash$1__T__I(this.Ljava_net_URI__f__userInfo));
    var $x_5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_internal_MurmurHash3$();
    var $x_4 = acc;
    var this$2 = this.Ljava_net_URI__f__host;
    acc = $x_5.mix__I__I__I($x_4, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I(this$2.toLowerCase()));
    var $x_7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_internal_MurmurHash3$();
    var $x_6 = acc;
    var this$3 = this.Ljava_net_URI__f__port;
    acc = $x_7.mix__I__I__I($x_6, this$3);
  } else {
    acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_internal_MurmurHash3$().mix__I__I__I(acc, $ps_Ljava_net_URI__normalizeEscapesHash$1__T__I(this.Ljava_net_URI__f__authority));
  }
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_internal_MurmurHash3$().mix__I__I__I(acc, $ps_Ljava_net_URI__normalizeEscapesHash$1__T__I(this.Ljava_net_URI__f__path));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_internal_MurmurHash3$().mix__I__I__I(acc, $ps_Ljava_net_URI__normalizeEscapesHash$1__T__I(this.Ljava_net_URI__f__query));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_internal_MurmurHash3$().mixLast__I__I__I(acc, $ps_Ljava_net_URI__normalizeEscapesHash$1__T__I(this.Ljava_net_URI__f__fragment));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_internal_MurmurHash3$().finalizeHash__I__I__I(acc, 3);
});
$c_Ljava_net_URI.prototype.toString__T = (function() {
  return this.Ljava_net_URI__f_origStr;
});
$c_Ljava_net_URI.prototype.compareTo__O__I = (function(o) {
  return this.compareTo__Ljava_net_URI__I(o);
});
function $isArrayOf_Ljava_net_URI(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_net_URI)));
}
export { $isArrayOf_Ljava_net_URI as $isArrayOf_Ljava_net_URI };
var $d_Ljava_net_URI = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Ljava_net_URI, "java.net.URI", ({
  Ljava_net_URI: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1
}));
export { $d_Ljava_net_URI as $d_Ljava_net_URI };
function $ct_ju_Random__J__($thiz, seed_in) {
  $thiz.setSeed__J__V(seed_in);
  return $thiz;
}
export { $ct_ju_Random__J__ as $ct_ju_Random__J__ };
function $ct_ju_Random__($thiz) {
  $ct_ju_Random__J__($thiz, $m_ju_Random$().java$util$Random$$randomSeed__J());
  return $thiz;
}
export { $ct_ju_Random__ as $ct_ju_Random__ };
/** @constructor */
function $c_ju_Random() {
  this.ju_Random__f_java$util$Random$$seed = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0;
}
export { $c_ju_Random as $c_ju_Random };
$c_ju_Random.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_ju_Random.prototype.constructor = $c_ju_Random;
/** @constructor */
function $h_ju_Random() {
}
export { $h_ju_Random as $h_ju_Random };
$h_ju_Random.prototype = $c_ju_Random.prototype;
$c_ju_Random.prototype.setSeed__J__V = (function(seed_in) {
  var lo = ((-554899859) ^ seed_in.RTLong__f_lo);
  var hi = (5 ^ seed_in.RTLong__f_hi);
  var hi$1 = (65535 & hi);
  this.ju_Random__f_java$util$Random$$seed = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi$1);
});
$c_ju_Random.prototype.next__I__I = (function(bits) {
  var b = this.ju_Random__f_java$util$Random$$seed;
  var blo = b.RTLong__f_lo;
  var b0 = (65535 & blo);
  var b1 = ((blo >>> 16) | 0);
  var a1b0 = Math.imul(58989, b0);
  var lo = (a1b0 << 16);
  var hi = ((((((Math.imul((-429064192), b.RTLong__f_hi) + Math.imul(384748, blo)) | 0) + Math.imul(58989, b1)) | 0) + ((a1b0 >>> 16) | 0)) | 0);
  var lo$1 = ((720896 + lo) | 0);
  var hi$1 = ((hi + (((lo & (~lo$1)) >>> 31) | 0)) | 0);
  var lo$2 = (((lo$1 >>> 16) | 0) | (hi$1 << 16));
  var hi$2 = ((hi$1 >>> 16) | 0);
  this.ju_Random__f_java$util$Random$$seed = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$2, hi$2);
  return ((hi$1 >>> ((32 - bits) | 0)) | 0);
});
var $d_ju_Random = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_ju_Random, "java.util.Random", ({
  ju_Random: 1,
  ju_random_RandomGenerator: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_Random as $d_ju_Random };
function $ct_ju_concurrent_atomic_AtomicInteger__I__($thiz, value) {
  $thiz.ju_concurrent_atomic_AtomicInteger__f_java$util$concurrent$atomic$AtomicInteger$$value = value;
  return $thiz;
}
export { $ct_ju_concurrent_atomic_AtomicInteger__I__ as $ct_ju_concurrent_atomic_AtomicInteger__I__ };
function $ct_ju_concurrent_atomic_AtomicInteger__($thiz) {
  $ct_ju_concurrent_atomic_AtomicInteger__I__($thiz, 0);
  return $thiz;
}
export { $ct_ju_concurrent_atomic_AtomicInteger__ as $ct_ju_concurrent_atomic_AtomicInteger__ };
/** @constructor */
function $c_ju_concurrent_atomic_AtomicInteger() {
  this.ju_concurrent_atomic_AtomicInteger__f_java$util$concurrent$atomic$AtomicInteger$$value = 0;
}
export { $c_ju_concurrent_atomic_AtomicInteger as $c_ju_concurrent_atomic_AtomicInteger };
$c_ju_concurrent_atomic_AtomicInteger.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_jl_Number();
$c_ju_concurrent_atomic_AtomicInteger.prototype.constructor = $c_ju_concurrent_atomic_AtomicInteger;
/** @constructor */
function $h_ju_concurrent_atomic_AtomicInteger() {
}
export { $h_ju_concurrent_atomic_AtomicInteger as $h_ju_concurrent_atomic_AtomicInteger };
$h_ju_concurrent_atomic_AtomicInteger.prototype = $c_ju_concurrent_atomic_AtomicInteger.prototype;
$c_ju_concurrent_atomic_AtomicInteger.prototype.toString__T = (function() {
  var this$1 = this.ju_concurrent_atomic_AtomicInteger__f_java$util$concurrent$atomic$AtomicInteger$$value;
  return ("" + this$1);
});
var $d_ju_concurrent_atomic_AtomicInteger = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_ju_concurrent_atomic_AtomicInteger, "java.util.concurrent.atomic.AtomicInteger", ({
  ju_concurrent_atomic_AtomicInteger: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_concurrent_atomic_AtomicInteger as $d_ju_concurrent_atomic_AtomicInteger };
/** @constructor */
function $c_Lmonocle_function_At$$anon$1(lens$3, outer) {
  this.Lmonocle_function_At$$anon$1__f_lens$2 = null;
  this.Lmonocle_function_At$$anon$1__f_lens$2 = lens$3;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lmonocle_function_At$$anon$1 as $c_Lmonocle_function_At$$anon$1 };
$c_Lmonocle_function_At$$anon$1.prototype = new $h_Lmonocle_function_At();
$c_Lmonocle_function_At$$anon$1.prototype.constructor = $c_Lmonocle_function_At$$anon$1;
/** @constructor */
function $h_Lmonocle_function_At$$anon$1() {
}
export { $h_Lmonocle_function_At$$anon$1 as $h_Lmonocle_function_At$$anon$1 };
$h_Lmonocle_function_At$$anon$1.prototype = $c_Lmonocle_function_At$$anon$1.prototype;
$c_Lmonocle_function_At$$anon$1.prototype.at__O__Lmonocle_PLens = (function(i) {
  var lens$1 = this.Lmonocle_function_At$$anon$1__f_lens$2;
  return lens$1.apply__O__O(i);
});
var $d_Lmonocle_function_At$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lmonocle_function_At$$anon$1, "monocle.function.At$$anon$1", ({
  Lmonocle_function_At$$anon$1: 1,
  Lmonocle_function_At: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lmonocle_function_At$$anon$1 as $d_Lmonocle_function_At$$anon$1 };
/** @constructor */
function $c_Lmonocle_function_Index$$anon$1(optional$3, outer) {
  this.Lmonocle_function_Index$$anon$1__f_optional$2 = null;
  this.Lmonocle_function_Index$$anon$1__f_optional$2 = optional$3;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lmonocle_function_Index$$anon$1 as $c_Lmonocle_function_Index$$anon$1 };
$c_Lmonocle_function_Index$$anon$1.prototype = new $h_Lmonocle_function_Index();
$c_Lmonocle_function_Index$$anon$1.prototype.constructor = $c_Lmonocle_function_Index$$anon$1;
/** @constructor */
function $h_Lmonocle_function_Index$$anon$1() {
}
export { $h_Lmonocle_function_Index$$anon$1 as $h_Lmonocle_function_Index$$anon$1 };
$h_Lmonocle_function_Index$$anon$1.prototype = $c_Lmonocle_function_Index$$anon$1.prototype;
$c_Lmonocle_function_Index$$anon$1.prototype.index__O__Lmonocle_POptional = (function(i) {
  $m_Lmonocle_function_Index$();
  var optional$1 = this.Lmonocle_function_Index$$anon$1__f_optional$2;
  return optional$1.apply__O__O(i);
});
var $d_Lmonocle_function_Index$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lmonocle_function_Index$$anon$1, "monocle.function.Index$$anon$1", ({
  Lmonocle_function_Index$$anon$1: 1,
  Lmonocle_function_Index: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lmonocle_function_Index$$anon$1 as $d_Lmonocle_function_Index$$anon$1 };
/** @constructor */
function $c_Lmonocle_std_string$() {
  this.Lmonocle_std_string$__f_stringToList = null;
  this.Lmonocle_std_string$__f_stringToLong = null;
  $n_Lmonocle_std_string$ = this;
  $f_Lmonocle_std_StringOptics__$init$__V(this);
}
export { $c_Lmonocle_std_string$ as $c_Lmonocle_std_string$ };
$c_Lmonocle_std_string$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lmonocle_std_string$.prototype.constructor = $c_Lmonocle_std_string$;
/** @constructor */
function $h_Lmonocle_std_string$() {
}
export { $h_Lmonocle_std_string$ as $h_Lmonocle_std_string$ };
$h_Lmonocle_std_string$.prototype = $c_Lmonocle_std_string$.prototype;
var $d_Lmonocle_std_string$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lmonocle_std_string$, "monocle.std.string$", ({
  Lmonocle_std_string$: 1,
  Lmonocle_std_PlatformSpecificStringOptics: 1,
  Lmonocle_std_StringOptics: 1
}));
export { $d_Lmonocle_std_string$ as $d_Lmonocle_std_string$ };
var $n_Lmonocle_std_string$;
function $m_Lmonocle_std_string$() {
  if ((!$n_Lmonocle_std_string$)) {
    $n_Lmonocle_std_string$ = new $c_Lmonocle_std_string$();
  }
  return $n_Lmonocle_std_string$;
}
export { $m_Lmonocle_std_string$ as $m_Lmonocle_std_string$ };
function $s_Lretry_HandlerDecision$__Stop__Lretry_HandlerDecision() {
  $m_Lretry_HandlerDecision$();
  return $t_Lretry_HandlerDecision$__Stop;
}
export { $s_Lretry_HandlerDecision$__Stop__Lretry_HandlerDecision as $s_Lretry_HandlerDecision$__Stop__Lretry_HandlerDecision };
function $s_Lretry_HandlerDecision$__Continue__Lretry_HandlerDecision() {
  $m_Lretry_HandlerDecision$();
  return $t_Lretry_HandlerDecision$__Continue;
}
export { $s_Lretry_HandlerDecision$__Continue__Lretry_HandlerDecision as $s_Lretry_HandlerDecision$__Continue__Lretry_HandlerDecision };
/** @constructor */
function $c_Lretry_HandlerDecision$() {
  $n_Lretry_HandlerDecision$ = this;
  $t_Lretry_HandlerDecision$__Stop = new $c_Lretry_HandlerDecision$$anon$1();
  $t_Lretry_HandlerDecision$__Continue = new $c_Lretry_HandlerDecision$$anon$2();
}
export { $c_Lretry_HandlerDecision$ as $c_Lretry_HandlerDecision$ };
$c_Lretry_HandlerDecision$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lretry_HandlerDecision$.prototype.constructor = $c_Lretry_HandlerDecision$;
/** @constructor */
function $h_Lretry_HandlerDecision$() {
}
export { $h_Lretry_HandlerDecision$ as $h_Lretry_HandlerDecision$ };
$h_Lretry_HandlerDecision$.prototype = $c_Lretry_HandlerDecision$.prototype;
$c_Lretry_HandlerDecision$.prototype.ordinal__O__I = (function(x) {
  return x.ordinal__I();
});
var $d_Lretry_HandlerDecision$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lretry_HandlerDecision$, "retry.HandlerDecision$", ({
  Lretry_HandlerDecision$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lretry_HandlerDecision$ as $d_Lretry_HandlerDecision$ };
var $n_Lretry_HandlerDecision$;
function $m_Lretry_HandlerDecision$() {
  if ((!$n_Lretry_HandlerDecision$)) {
    $n_Lretry_HandlerDecision$ = new $c_Lretry_HandlerDecision$();
  }
  return $n_Lretry_HandlerDecision$;
}
export { $m_Lretry_HandlerDecision$ as $m_Lretry_HandlerDecision$ };
function $s_Lretry_PolicyDecision$__GiveUp__Lretry_PolicyDecision() {
  $m_Lretry_PolicyDecision$();
  return $t_Lretry_PolicyDecision$__GiveUp;
}
export { $s_Lretry_PolicyDecision$__GiveUp__Lretry_PolicyDecision as $s_Lretry_PolicyDecision$__GiveUp__Lretry_PolicyDecision };
/** @constructor */
function $c_Lretry_PolicyDecision$() {
  $n_Lretry_PolicyDecision$ = this;
  $t_Lretry_PolicyDecision$__GiveUp = new $c_Lretry_PolicyDecision$$anon$1("GiveUp", 0);
}
export { $c_Lretry_PolicyDecision$ as $c_Lretry_PolicyDecision$ };
$c_Lretry_PolicyDecision$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lretry_PolicyDecision$.prototype.constructor = $c_Lretry_PolicyDecision$;
/** @constructor */
function $h_Lretry_PolicyDecision$() {
}
export { $h_Lretry_PolicyDecision$ as $h_Lretry_PolicyDecision$ };
$h_Lretry_PolicyDecision$.prototype = $c_Lretry_PolicyDecision$.prototype;
$c_Lretry_PolicyDecision$.prototype.ordinal__O__I = (function(x) {
  return x.ordinal__I();
});
var $d_Lretry_PolicyDecision$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lretry_PolicyDecision$, "retry.PolicyDecision$", ({
  Lretry_PolicyDecision$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lretry_PolicyDecision$ as $d_Lretry_PolicyDecision$ };
var $n_Lretry_PolicyDecision$;
function $m_Lretry_PolicyDecision$() {
  if ((!$n_Lretry_PolicyDecision$)) {
    $n_Lretry_PolicyDecision$ = new $c_Lretry_PolicyDecision$();
  }
  return $n_Lretry_PolicyDecision$;
}
export { $m_Lretry_PolicyDecision$ as $m_Lretry_PolicyDecision$ };
function $s_Lretry_RetryDetails$NextStep$__GiveUp__Lretry_RetryDetails$NextStep() {
  $m_Lretry_RetryDetails$NextStep$();
  return $t_Lretry_RetryDetails$NextStep$__GiveUp;
}
export { $s_Lretry_RetryDetails$NextStep$__GiveUp__Lretry_RetryDetails$NextStep as $s_Lretry_RetryDetails$NextStep$__GiveUp__Lretry_RetryDetails$NextStep };
/** @constructor */
function $c_Lretry_RetryDetails$NextStep$() {
  $n_Lretry_RetryDetails$NextStep$ = this;
  $t_Lretry_RetryDetails$NextStep$__GiveUp = new $c_Lretry_RetryDetails$NextStep$$anon$1("GiveUp", 0);
}
export { $c_Lretry_RetryDetails$NextStep$ as $c_Lretry_RetryDetails$NextStep$ };
$c_Lretry_RetryDetails$NextStep$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lretry_RetryDetails$NextStep$.prototype.constructor = $c_Lretry_RetryDetails$NextStep$;
/** @constructor */
function $h_Lretry_RetryDetails$NextStep$() {
}
export { $h_Lretry_RetryDetails$NextStep$ as $h_Lretry_RetryDetails$NextStep$ };
$h_Lretry_RetryDetails$NextStep$.prototype = $c_Lretry_RetryDetails$NextStep$.prototype;
$c_Lretry_RetryDetails$NextStep$.prototype.ordinal__O__I = (function(x) {
  return x.ordinal__I();
});
var $d_Lretry_RetryDetails$NextStep$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lretry_RetryDetails$NextStep$, "retry.RetryDetails$NextStep$", ({
  Lretry_RetryDetails$NextStep$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lretry_RetryDetails$NextStep$ as $d_Lretry_RetryDetails$NextStep$ };
var $n_Lretry_RetryDetails$NextStep$;
function $m_Lretry_RetryDetails$NextStep$() {
  if ((!$n_Lretry_RetryDetails$NextStep$)) {
    $n_Lretry_RetryDetails$NextStep$ = new $c_Lretry_RetryDetails$NextStep$();
  }
  return $n_Lretry_RetryDetails$NextStep$;
}
export { $m_Lretry_RetryDetails$NextStep$ as $m_Lretry_RetryDetails$NextStep$ };
/** @constructor */
function $c_Lretry_RetryPolicy$() {
}
export { $c_Lretry_RetryPolicy$ as $c_Lretry_RetryPolicy$ };
$c_Lretry_RetryPolicy$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lretry_RetryPolicy$.prototype.constructor = $c_Lretry_RetryPolicy$;
/** @constructor */
function $h_Lretry_RetryPolicy$() {
}
export { $h_Lretry_RetryPolicy$ as $h_Lretry_RetryPolicy$ };
$h_Lretry_RetryPolicy$.prototype = $c_Lretry_RetryPolicy$.prototype;
$c_Lretry_RetryPolicy$.prototype.liftWithShow__F2__F0__Lcats_Applicative__Lretry_RetryPolicy = (function(decideNextRetry, pretty, F) {
  var decideNextRetry$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((actionResult, retryStatus) => F.pure__O__O(decideNextRetry.apply__O__O__O(actionResult, retryStatus))));
  return new $c_Lretry_RetryPolicy$$anon$1(decideNextRetry$1, pretty);
});
$c_Lretry_RetryPolicy$.prototype.given_Show_RetryPolicy__Lcats_Show = (function() {
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$9) => _$9.show__T()));
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$$anon$4(f);
});
$c_Lretry_RetryPolicy$.prototype.fromProduct__s_Product__Lretry_RetryPolicy = (function(x$0) {
  return $ct_Lretry_RetryPolicy__F2__(new $c_Lretry_RetryPolicy(), x$0.productElement__I__O(0));
});
$c_Lretry_RetryPolicy$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lretry_RetryPolicy(p);
});
var $d_Lretry_RetryPolicy$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lretry_RetryPolicy$, "retry.RetryPolicy$", ({
  Lretry_RetryPolicy$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lretry_RetryPolicy$ as $d_Lretry_RetryPolicy$ };
var $n_Lretry_RetryPolicy$;
function $m_Lretry_RetryPolicy$() {
  if ((!$n_Lretry_RetryPolicy$)) {
    $n_Lretry_RetryPolicy$ = new $c_Lretry_RetryPolicy$();
  }
  return $n_Lretry_RetryPolicy$;
}
export { $m_Lretry_RetryPolicy$ as $m_Lretry_RetryPolicy$ };
/** @constructor */
function $c_Lretry_RetryStatus$() {
  this.Lretry_RetryStatus$__f_NoRetriesYet = null;
  $n_Lretry_RetryStatus$ = this;
  $m_Lretry_RetryStatus$();
  var cumulativeDelay = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Zero;
  var previousDelay = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  this.Lretry_RetryStatus$__f_NoRetriesYet = new $c_Lretry_RetryStatus(0, cumulativeDelay, previousDelay);
}
export { $c_Lretry_RetryStatus$ as $c_Lretry_RetryStatus$ };
$c_Lretry_RetryStatus$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lretry_RetryStatus$.prototype.constructor = $c_Lretry_RetryStatus$;
/** @constructor */
function $h_Lretry_RetryStatus$() {
}
export { $h_Lretry_RetryStatus$ as $h_Lretry_RetryStatus$ };
$h_Lretry_RetryStatus$.prototype = $c_Lretry_RetryStatus$.prototype;
$c_Lretry_RetryStatus$.prototype.fromProduct__s_Product__Lretry_RetryStatus = (function(x$0) {
  return new $c_Lretry_RetryStatus((x$0.productElement__I__O(0) | 0), x$0.productElement__I__O(1), x$0.productElement__I__O(2));
});
$c_Lretry_RetryStatus$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lretry_RetryStatus(p);
});
var $d_Lretry_RetryStatus$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lretry_RetryStatus$, "retry.RetryStatus$", ({
  Lretry_RetryStatus$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lretry_RetryStatus$ as $d_Lretry_RetryStatus$ };
var $n_Lretry_RetryStatus$;
function $m_Lretry_RetryStatus$() {
  if ((!$n_Lretry_RetryStatus$)) {
    $n_Lretry_RetryStatus$ = new $c_Lretry_RetryStatus$();
  }
  return $n_Lretry_RetryStatus$;
}
export { $m_Lretry_RetryStatus$ as $m_Lretry_RetryStatus$ };
/** @constructor */
function $c_sc_BuildFrom$() {
}
export { $c_sc_BuildFrom$ as $c_sc_BuildFrom$ };
$c_sc_BuildFrom$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_sc_BuildFrom$.prototype.constructor = $c_sc_BuildFrom$;
/** @constructor */
function $h_sc_BuildFrom$() {
}
export { $h_sc_BuildFrom$ as $h_sc_BuildFrom$ };
$h_sc_BuildFrom$.prototype = $c_sc_BuildFrom$.prototype;
var $d_sc_BuildFrom$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sc_BuildFrom$, "scala.collection.BuildFrom$", ({
  sc_BuildFrom$: 1,
  sc_BuildFromLowPriority1: 1,
  sc_BuildFromLowPriority2: 1
}));
export { $d_sc_BuildFrom$ as $d_sc_BuildFrom$ };
var $n_sc_BuildFrom$;
function $m_sc_BuildFrom$() {
  if ((!$n_sc_BuildFrom$)) {
    $n_sc_BuildFrom$ = new $c_sc_BuildFrom$();
  }
  return $n_sc_BuildFrom$;
}
export { $m_sc_BuildFrom$ as $m_sc_BuildFrom$ };
function $ct_sc_EvidenceIterableFactory$Delegate__sc_EvidenceIterableFactory__($thiz, delegate) {
  $thiz.sc_EvidenceIterableFactory$Delegate__f_delegate = delegate;
  return $thiz;
}
export { $ct_sc_EvidenceIterableFactory$Delegate__sc_EvidenceIterableFactory__ as $ct_sc_EvidenceIterableFactory$Delegate__sc_EvidenceIterableFactory__ };
/** @constructor */
function $c_sc_EvidenceIterableFactory$Delegate() {
  this.sc_EvidenceIterableFactory$Delegate__f_delegate = null;
}
export { $c_sc_EvidenceIterableFactory$Delegate as $c_sc_EvidenceIterableFactory$Delegate };
$c_sc_EvidenceIterableFactory$Delegate.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_sc_EvidenceIterableFactory$Delegate.prototype.constructor = $c_sc_EvidenceIterableFactory$Delegate;
/** @constructor */
function $h_sc_EvidenceIterableFactory$Delegate() {
}
export { $h_sc_EvidenceIterableFactory$Delegate as $h_sc_EvidenceIterableFactory$Delegate };
$h_sc_EvidenceIterableFactory$Delegate.prototype = $c_sc_EvidenceIterableFactory$Delegate.prototype;
$c_sc_EvidenceIterableFactory$Delegate.prototype.apply__sci_Seq__O__O = (function(xs, evidence$18) {
  return this.sc_EvidenceIterableFactory$Delegate__f_delegate.apply__sci_Seq__O__O(xs, evidence$18);
});
$c_sc_EvidenceIterableFactory$Delegate.prototype.from__sc_IterableOnce__O__O = (function(it, evidence$20) {
  return this.sc_EvidenceIterableFactory$Delegate__f_delegate.from__sc_IterableOnce__O__O(it, evidence$20);
});
$c_sc_EvidenceIterableFactory$Delegate.prototype.newBuilder__O__scm_Builder = (function(evidence$21) {
  return this.sc_EvidenceIterableFactory$Delegate__f_delegate.newBuilder__O__scm_Builder(evidence$21);
});
/** @constructor */
function $c_sc_IterableFactory$ToFactory(factory) {
  this.sc_IterableFactory$ToFactory__f_factory = null;
  this.sc_IterableFactory$ToFactory__f_factory = factory;
}
export { $c_sc_IterableFactory$ToFactory as $c_sc_IterableFactory$ToFactory };
$c_sc_IterableFactory$ToFactory.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_sc_IterableFactory$ToFactory.prototype.constructor = $c_sc_IterableFactory$ToFactory;
/** @constructor */
function $h_sc_IterableFactory$ToFactory() {
}
export { $h_sc_IterableFactory$ToFactory as $h_sc_IterableFactory$ToFactory };
$h_sc_IterableFactory$ToFactory.prototype = $c_sc_IterableFactory$ToFactory.prototype;
$c_sc_IterableFactory$ToFactory.prototype.fromSpecific__sc_IterableOnce__O = (function(it) {
  return this.sc_IterableFactory$ToFactory__f_factory.from__sc_IterableOnce__O(it);
});
$c_sc_IterableFactory$ToFactory.prototype.newBuilder__scm_Builder = (function() {
  return this.sc_IterableFactory$ToFactory__f_factory.newBuilder__scm_Builder();
});
var $d_sc_IterableFactory$ToFactory = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sc_IterableFactory$ToFactory, "scala.collection.IterableFactory$ToFactory", ({
  sc_IterableFactory$ToFactory: 1,
  sc_Factory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_IterableFactory$ToFactory as $d_sc_IterableFactory$ToFactory };
function $ct_sc_SortedMapFactory$Delegate__sc_SortedMapFactory__($thiz, delegate) {
  $thiz.sc_SortedMapFactory$Delegate__f_delegate = delegate;
  return $thiz;
}
export { $ct_sc_SortedMapFactory$Delegate__sc_SortedMapFactory__ as $ct_sc_SortedMapFactory$Delegate__sc_SortedMapFactory__ };
/** @constructor */
function $c_sc_SortedMapFactory$Delegate() {
  this.sc_SortedMapFactory$Delegate__f_delegate = null;
}
export { $c_sc_SortedMapFactory$Delegate as $c_sc_SortedMapFactory$Delegate };
$c_sc_SortedMapFactory$Delegate.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_sc_SortedMapFactory$Delegate.prototype.constructor = $c_sc_SortedMapFactory$Delegate;
/** @constructor */
function $h_sc_SortedMapFactory$Delegate() {
}
export { $h_sc_SortedMapFactory$Delegate as $h_sc_SortedMapFactory$Delegate };
$h_sc_SortedMapFactory$Delegate.prototype = $c_sc_SortedMapFactory$Delegate.prototype;
$c_sc_SortedMapFactory$Delegate.prototype.apply__sci_Seq__s_math_Ordering__O = (function(elems, evidence$45) {
  return this.sc_SortedMapFactory$Delegate__f_delegate.apply__sci_Seq__s_math_Ordering__O(elems, evidence$45);
});
$c_sc_SortedMapFactory$Delegate.prototype.from__sc_IterableOnce__s_math_Ordering__O = (function(it, evidence$46) {
  return this.sc_SortedMapFactory$Delegate__f_delegate.from__sc_IterableOnce__s_math_Ordering__O(it, evidence$46);
});
$c_sc_SortedMapFactory$Delegate.prototype.empty__s_math_Ordering__O = (function(evidence$47) {
  return this.sc_SortedMapFactory$Delegate__f_delegate.empty__s_math_Ordering__O(evidence$47);
});
/** @constructor */
function $c_sci_TreeMap$() {
}
export { $c_sci_TreeMap$ as $c_sci_TreeMap$ };
$c_sci_TreeMap$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_sci_TreeMap$.prototype.constructor = $c_sci_TreeMap$;
/** @constructor */
function $h_sci_TreeMap$() {
}
export { $h_sci_TreeMap$ as $h_sci_TreeMap$ };
$h_sci_TreeMap$.prototype = $c_sci_TreeMap$.prototype;
$c_sci_TreeMap$.prototype.apply__sci_Seq__s_math_Ordering__O = (function(elems, evidence$38) {
  return this.from__sc_IterableOnce__s_math_Ordering__sci_TreeMap(elems, evidence$38);
});
$c_sci_TreeMap$.prototype.from__sc_IterableOnce__s_math_Ordering__sci_TreeMap = (function(it, ordering) {
  if ((it instanceof $c_sci_TreeMap)) {
    var x$2 = it.sci_TreeMap__f_ordering;
    if (((ordering === null) ? (x$2 === null) : ordering.equals__O__Z(x$2))) {
      return it;
    }
  }
  if ($is_sc_SortedMap(it)) {
    var x$4 = it.sci_TreeMap__f_ordering;
    if (((ordering === null) ? (x$4 === null) : ordering.equals__O__Z(x$4))) {
      var $x_1 = $m_sci_RedBlackTree$();
      var tree = it.sci_TreeMap__f_tree;
      var start = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      var evidence$16 = it.sci_TreeMap__f_ordering;
      return $ct_sci_TreeMap__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeMap(), $x_1.fromOrderedEntries__sc_Iterator__I__sci_RedBlackTree$Tree(new $c_sci_RedBlackTree$EntriesIterator(tree, start, evidence$16), $m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(it.sci_TreeMap__f_tree)), ordering);
    }
  }
  var t = null;
  var i = it.iterator__sc_Iterator();
  while (i.hasNext__Z()) {
    var x1$2 = i.next__O();
    if ((x1$2 === null)) {
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1$2);
    }
    var k = x1$2._1__O();
    var v = x1$2._2__O();
    t = $m_sci_RedBlackTree$().update__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree(t, k, v, true, ordering);
  }
  return $ct_sci_TreeMap__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeMap(), t, ordering);
});
$c_sci_TreeMap$.prototype.from__sc_IterableOnce__s_math_Ordering__O = (function(it, evidence$37) {
  return this.from__sc_IterableOnce__s_math_Ordering__sci_TreeMap(it, evidence$37);
});
$c_sci_TreeMap$.prototype.empty__s_math_Ordering__O = (function(evidence$36) {
  return $ct_sci_TreeMap__s_math_Ordering__(new $c_sci_TreeMap(), evidence$36);
});
var $d_sci_TreeMap$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sci_TreeMap$, "scala.collection.immutable.TreeMap$", ({
  sci_TreeMap$: 1,
  sc_SortedMapFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_TreeMap$ as $d_sci_TreeMap$ };
var $n_sci_TreeMap$;
function $m_sci_TreeMap$() {
  if ((!$n_sci_TreeMap$)) {
    $n_sci_TreeMap$ = new $c_sci_TreeMap$();
  }
  return $n_sci_TreeMap$;
}
export { $m_sci_TreeMap$ as $m_sci_TreeMap$ };
/** @constructor */
function $c_sci_TreeMap$TreeMapBuilder$adder$(outer) {
  this.sci_TreeMap$TreeMapBuilder$adder$__f_accumulator = null;
  this.sci_TreeMap$TreeMapBuilder$adder$__f_$outer = null;
  this.sci_TreeMap$TreeMapBuilder$adder$__f_$outer = outer;
  this.sci_TreeMap$TreeMapBuilder$adder$__f_accumulator = null;
}
export { $c_sci_TreeMap$TreeMapBuilder$adder$ as $c_sci_TreeMap$TreeMapBuilder$adder$ };
$c_sci_TreeMap$TreeMapBuilder$adder$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractFunction2();
$c_sci_TreeMap$TreeMapBuilder$adder$.prototype.constructor = $c_sci_TreeMap$TreeMapBuilder$adder$;
/** @constructor */
function $h_sci_TreeMap$TreeMapBuilder$adder$() {
}
export { $h_sci_TreeMap$TreeMapBuilder$adder$ as $h_sci_TreeMap$TreeMapBuilder$adder$ };
$h_sci_TreeMap$TreeMapBuilder$adder$.prototype = $c_sci_TreeMap$TreeMapBuilder$adder$.prototype;
$c_sci_TreeMap$TreeMapBuilder$adder$.prototype.addForEach__sc_Map__V = (function(hasForEach) {
  this.sci_TreeMap$TreeMapBuilder$adder$__f_accumulator = this.sci_TreeMap$TreeMapBuilder$adder$__f_$outer.sci_TreeMap$TreeMapBuilder__f_scala$collection$immutable$TreeMap$TreeMapBuilder$$tree;
  hasForEach.foreachEntry__F2__V(this);
  this.sci_TreeMap$TreeMapBuilder$adder$__f_$outer.sci_TreeMap$TreeMapBuilder__f_scala$collection$immutable$TreeMap$TreeMapBuilder$$tree = this.sci_TreeMap$TreeMapBuilder$adder$__f_accumulator;
  this.sci_TreeMap$TreeMapBuilder$adder$__f_accumulator = null;
});
$c_sci_TreeMap$TreeMapBuilder$adder$.prototype.apply__O__O__V = (function(key, value) {
  this.sci_TreeMap$TreeMapBuilder$adder$__f_accumulator = this.sci_TreeMap$TreeMapBuilder$adder$__f_$outer.mutableUpd__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree(this.sci_TreeMap$TreeMapBuilder$adder$__f_accumulator, key, value);
});
$c_sci_TreeMap$TreeMapBuilder$adder$.prototype.apply__O__O__O = (function(v1, v2) {
  this.apply__O__O__V(v1, v2);
});
var $d_sci_TreeMap$TreeMapBuilder$adder$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sci_TreeMap$TreeMapBuilder$adder$, "scala.collection.immutable.TreeMap$TreeMapBuilder$adder$", ({
  sci_TreeMap$TreeMapBuilder$adder$: 1,
  sr_AbstractFunction2: 1,
  F2: 1
}));
export { $d_sci_TreeMap$TreeMapBuilder$adder$ as $d_sci_TreeMap$TreeMapBuilder$adder$ };
/** @constructor */
function $c_sci_TreeSet$sub$1$(outer) {
  this.sci_TreeSet$sub$1$__f_currentTree = null;
  this.sci_TreeSet$sub$1$__f_$outer = null;
  this.sci_TreeSet$sub$1$__f_$outer = outer;
  this.sci_TreeSet$sub$1$__f_currentTree = outer.sci_TreeSet__f_tree;
}
export { $c_sci_TreeSet$sub$1$ as $c_sci_TreeSet$sub$1$ };
$c_sci_TreeSet$sub$1$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractFunction1();
$c_sci_TreeSet$sub$1$.prototype.constructor = $c_sci_TreeSet$sub$1$;
/** @constructor */
function $h_sci_TreeSet$sub$1$() {
}
export { $h_sci_TreeSet$sub$1$ as $h_sci_TreeSet$sub$1$ };
$h_sci_TreeSet$sub$1$.prototype = $c_sci_TreeSet$sub$1$.prototype;
$c_sci_TreeSet$sub$1$.prototype.apply__O__V = (function(k) {
  this.sci_TreeSet$sub$1$__f_currentTree = $m_sci_RedBlackTree$().delete__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeSet$sub$1$__f_currentTree, k, this.sci_TreeSet$sub$1$__f_$outer.sci_TreeSet__f_ordering);
});
$c_sci_TreeSet$sub$1$.prototype.apply__O__O = (function(v1) {
  this.apply__O__V(v1);
});
var $d_sci_TreeSet$sub$1$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sci_TreeSet$sub$1$, "scala.collection.immutable.TreeSet$sub$1$", ({
  sci_TreeSet$sub$1$: 1,
  sr_AbstractFunction1: 1,
  F1: 1
}));
export { $d_sci_TreeSet$sub$1$ as $d_sci_TreeSet$sub$1$ };
/** @constructor */
function $c_s_concurrent_BatchingExecutor$SyncBatch(outer, runnable) {
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_first = null;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_other = null;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_size = 0;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_$outer = null;
  $ct_s_concurrent_BatchingExecutor$AbstractBatch__s_concurrent_BatchingExecutor__jl_Runnable__Ajl_Runnable__I__(this, outer, runnable, $m_s_concurrent_BatchingExecutorStatics$().s_concurrent_BatchingExecutorStatics$__f_emptyBatchArray, 1);
}
export { $c_s_concurrent_BatchingExecutor$SyncBatch as $c_s_concurrent_BatchingExecutor$SyncBatch };
$c_s_concurrent_BatchingExecutor$SyncBatch.prototype = new $h_s_concurrent_BatchingExecutor$AbstractBatch();
$c_s_concurrent_BatchingExecutor$SyncBatch.prototype.constructor = $c_s_concurrent_BatchingExecutor$SyncBatch;
/** @constructor */
function $h_s_concurrent_BatchingExecutor$SyncBatch() {
}
export { $h_s_concurrent_BatchingExecutor$SyncBatch as $h_s_concurrent_BatchingExecutor$SyncBatch };
$h_s_concurrent_BatchingExecutor$SyncBatch.prototype = $c_s_concurrent_BatchingExecutor$SyncBatch.prototype;
$c_s_concurrent_BatchingExecutor$SyncBatch.prototype.run__V = (function() {
  while (true) {
    try {
      this.runN__I__V(1024);
    } catch (e) {
      var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
      if (false) {
        $m_s_concurrent_ExecutionContext$().s_concurrent_ExecutionContext$__f_defaultReporter.apply__O__O(e$2);
      } else if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        $m_s_concurrent_ExecutionContext$().s_concurrent_ExecutionContext$__f_defaultReporter.apply__O__O(e$2);
      } else {
        throw ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
      }
    }
    if ((this.s_concurrent_BatchingExecutor$AbstractBatch__f_size > 0)) {
      continue;
    }
    return (void 0);
  }
});
function $isArrayOf_s_concurrent_BatchingExecutor$SyncBatch(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_BatchingExecutor$SyncBatch)));
}
export { $isArrayOf_s_concurrent_BatchingExecutor$SyncBatch as $isArrayOf_s_concurrent_BatchingExecutor$SyncBatch };
var $d_s_concurrent_BatchingExecutor$SyncBatch = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_s_concurrent_BatchingExecutor$SyncBatch, "scala.concurrent.BatchingExecutor$SyncBatch", ({
  s_concurrent_BatchingExecutor$SyncBatch: 1,
  s_concurrent_BatchingExecutor$AbstractBatch: 1,
  jl_Runnable: 1
}));
export { $d_s_concurrent_BatchingExecutor$SyncBatch as $d_s_concurrent_BatchingExecutor$SyncBatch };
/** @constructor */
function $c_s_concurrent_Future$never$() {
}
export { $c_s_concurrent_Future$never$ as $c_s_concurrent_Future$never$ };
$c_s_concurrent_Future$never$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_s_concurrent_Future$never$.prototype.constructor = $c_s_concurrent_Future$never$;
/** @constructor */
function $h_s_concurrent_Future$never$() {
}
export { $h_s_concurrent_Future$never$ as $h_s_concurrent_Future$never$ };
$h_s_concurrent_Future$never$.prototype = $c_s_concurrent_Future$never$.prototype;
$c_s_concurrent_Future$never$.prototype.onComplete__F1__s_concurrent_ExecutionContext__V = (function(f, executor) {
});
$c_s_concurrent_Future$never$.prototype.value__s_Option = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
});
$c_s_concurrent_Future$never$.prototype.foreach__F1__s_concurrent_ExecutionContext__V = (function(f, executor) {
});
$c_s_concurrent_Future$never$.prototype.transformWith__F1__s_concurrent_ExecutionContext__s_concurrent_Future = (function(f, executor) {
  return this;
});
$c_s_concurrent_Future$never$.prototype.map__F1__s_concurrent_ExecutionContext__s_concurrent_Future = (function(f, executor) {
  return this;
});
$c_s_concurrent_Future$never$.prototype.flatMap__F1__s_concurrent_ExecutionContext__s_concurrent_Future = (function(f, executor) {
  return this;
});
$c_s_concurrent_Future$never$.prototype.recoverWith__s_PartialFunction__s_concurrent_ExecutionContext__s_concurrent_Future = (function(pf, executor) {
  return this;
});
$c_s_concurrent_Future$never$.prototype.zipWith__s_concurrent_Future__F2__s_concurrent_ExecutionContext__s_concurrent_Future = (function(that, f, executor) {
  return this;
});
$c_s_concurrent_Future$never$.prototype.toString__T = (function() {
  return "Future(<never>)";
});
var $d_s_concurrent_Future$never$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_s_concurrent_Future$never$, "scala.concurrent.Future$never$", ({
  s_concurrent_Future$never$: 1,
  s_concurrent_Future: 1,
  s_concurrent_Awaitable: 1
}));
export { $d_s_concurrent_Future$never$ as $d_s_concurrent_Future$never$ };
var $n_s_concurrent_Future$never$;
function $m_s_concurrent_Future$never$() {
  if ((!$n_s_concurrent_Future$never$)) {
    $n_s_concurrent_Future$never$ = new $c_s_concurrent_Future$never$();
  }
  return $n_s_concurrent_Future$never$;
}
export { $m_s_concurrent_Future$never$ as $m_s_concurrent_Future$never$ };
/** @constructor */
function $c_s_concurrent_impl_Promise$Link(to) {
  this.ju_concurrent_atomic_AtomicReference__f_value = null;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_ju_concurrent_atomic_AtomicReference__O__(this, to);
}
export { $c_s_concurrent_impl_Promise$Link as $c_s_concurrent_impl_Promise$Link };
$c_s_concurrent_impl_Promise$Link.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_ju_concurrent_atomic_AtomicReference();
$c_s_concurrent_impl_Promise$Link.prototype.constructor = $c_s_concurrent_impl_Promise$Link;
/** @constructor */
function $h_s_concurrent_impl_Promise$Link() {
}
export { $h_s_concurrent_impl_Promise$Link as $h_s_concurrent_impl_Promise$Link };
$h_s_concurrent_impl_Promise$Link.prototype = $c_s_concurrent_impl_Promise$Link.prototype;
$c_s_concurrent_impl_Promise$Link.prototype.promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise = (function(owner) {
  var c = this.ju_concurrent_atomic_AtomicReference__f_value;
  var current = c;
  var target = c;
  while (true) {
    var value = target.ju_concurrent_atomic_AtomicReference__f_value;
    if ($is_s_concurrent_impl_Promise$Callbacks(value)) {
      if (this.compareAndSet__O__O__Z(current, target)) {
        return target;
      } else {
        current = this.ju_concurrent_atomic_AtomicReference__f_value;
      }
    } else if ((value instanceof $c_s_concurrent_impl_Promise$Link)) {
      target = value.ju_concurrent_atomic_AtomicReference__f_value;
    } else {
      owner.unlink__s_util_Try__V(value);
      return owner;
    }
  }
});
function $isArrayOf_s_concurrent_impl_Promise$Link(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_impl_Promise$Link)));
}
export { $isArrayOf_s_concurrent_impl_Promise$Link as $isArrayOf_s_concurrent_impl_Promise$Link };
var $d_s_concurrent_impl_Promise$Link = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_s_concurrent_impl_Promise$Link, "scala.concurrent.impl.Promise$Link", ({
  s_concurrent_impl_Promise$Link: 1,
  ju_concurrent_atomic_AtomicReference: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_concurrent_impl_Promise$Link as $d_s_concurrent_impl_Promise$Link };
/** @constructor */
function $c_sr_AbstractFunction4_$$Lambda$44dd8b4a36ad9db1c12297bcc97fced51ec30e4c(f) {
  this.sr_AbstractFunction4_$$Lambda$44dd8b4a36ad9db1c12297bcc97fced51ec30e4c__f_f = null;
  this.sr_AbstractFunction4_$$Lambda$44dd8b4a36ad9db1c12297bcc97fced51ec30e4c__f_f = f;
}
export { $c_sr_AbstractFunction4_$$Lambda$44dd8b4a36ad9db1c12297bcc97fced51ec30e4c as $c_sr_AbstractFunction4_$$Lambda$44dd8b4a36ad9db1c12297bcc97fced51ec30e4c };
$c_sr_AbstractFunction4_$$Lambda$44dd8b4a36ad9db1c12297bcc97fced51ec30e4c.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractFunction4();
$c_sr_AbstractFunction4_$$Lambda$44dd8b4a36ad9db1c12297bcc97fced51ec30e4c.prototype.constructor = $c_sr_AbstractFunction4_$$Lambda$44dd8b4a36ad9db1c12297bcc97fced51ec30e4c;
/** @constructor */
function $h_sr_AbstractFunction4_$$Lambda$44dd8b4a36ad9db1c12297bcc97fced51ec30e4c() {
}
export { $h_sr_AbstractFunction4_$$Lambda$44dd8b4a36ad9db1c12297bcc97fced51ec30e4c as $h_sr_AbstractFunction4_$$Lambda$44dd8b4a36ad9db1c12297bcc97fced51ec30e4c };
$h_sr_AbstractFunction4_$$Lambda$44dd8b4a36ad9db1c12297bcc97fced51ec30e4c.prototype = $c_sr_AbstractFunction4_$$Lambda$44dd8b4a36ad9db1c12297bcc97fced51ec30e4c.prototype;
$c_sr_AbstractFunction4_$$Lambda$44dd8b4a36ad9db1c12297bcc97fced51ec30e4c.prototype.apply__O__O__O__O__O = (function(x0, x1, x2, x3) {
  return (0, this.sr_AbstractFunction4_$$Lambda$44dd8b4a36ad9db1c12297bcc97fced51ec30e4c__f_f)(x0, x1, x2, x3);
});
var $d_sr_AbstractFunction4_$$Lambda$44dd8b4a36ad9db1c12297bcc97fced51ec30e4c = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sr_AbstractFunction4_$$Lambda$44dd8b4a36ad9db1c12297bcc97fced51ec30e4c, "scala.runtime.AbstractFunction4.$$Lambda$44dd8b4a36ad9db1c12297bcc97fced51ec30e4c", ({
  sr_AbstractFunction4_$$Lambda$44dd8b4a36ad9db1c12297bcc97fced51ec30e4c: 1,
  sr_AbstractFunction4: 1,
  F4: 1
}));
export { $d_sr_AbstractFunction4_$$Lambda$44dd8b4a36ad9db1c12297bcc97fced51ec30e4c as $d_sr_AbstractFunction4_$$Lambda$44dd8b4a36ad9db1c12297bcc97fced51ec30e4c };
/** @constructor */
function $c_sr_AbstractFunction6_$$Lambda$a99c8f90daf3b5626ca3b2aaf61c97e045a5237f(f) {
  this.sr_AbstractFunction6_$$Lambda$a99c8f90daf3b5626ca3b2aaf61c97e045a5237f__f_f = null;
  this.sr_AbstractFunction6_$$Lambda$a99c8f90daf3b5626ca3b2aaf61c97e045a5237f__f_f = f;
}
export { $c_sr_AbstractFunction6_$$Lambda$a99c8f90daf3b5626ca3b2aaf61c97e045a5237f as $c_sr_AbstractFunction6_$$Lambda$a99c8f90daf3b5626ca3b2aaf61c97e045a5237f };
$c_sr_AbstractFunction6_$$Lambda$a99c8f90daf3b5626ca3b2aaf61c97e045a5237f.prototype = new $h_sr_AbstractFunction6();
$c_sr_AbstractFunction6_$$Lambda$a99c8f90daf3b5626ca3b2aaf61c97e045a5237f.prototype.constructor = $c_sr_AbstractFunction6_$$Lambda$a99c8f90daf3b5626ca3b2aaf61c97e045a5237f;
/** @constructor */
function $h_sr_AbstractFunction6_$$Lambda$a99c8f90daf3b5626ca3b2aaf61c97e045a5237f() {
}
export { $h_sr_AbstractFunction6_$$Lambda$a99c8f90daf3b5626ca3b2aaf61c97e045a5237f as $h_sr_AbstractFunction6_$$Lambda$a99c8f90daf3b5626ca3b2aaf61c97e045a5237f };
$h_sr_AbstractFunction6_$$Lambda$a99c8f90daf3b5626ca3b2aaf61c97e045a5237f.prototype = $c_sr_AbstractFunction6_$$Lambda$a99c8f90daf3b5626ca3b2aaf61c97e045a5237f.prototype;
$c_sr_AbstractFunction6_$$Lambda$a99c8f90daf3b5626ca3b2aaf61c97e045a5237f.prototype.apply__O__O__O__O__O__O__O = (function(x0, x1, x2, x3, x4, x5) {
  return (0, this.sr_AbstractFunction6_$$Lambda$a99c8f90daf3b5626ca3b2aaf61c97e045a5237f__f_f)(x0, x1, x2, x3, x4, x5);
});
var $d_sr_AbstractFunction6_$$Lambda$a99c8f90daf3b5626ca3b2aaf61c97e045a5237f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sr_AbstractFunction6_$$Lambda$a99c8f90daf3b5626ca3b2aaf61c97e045a5237f, "scala.runtime.AbstractFunction6.$$Lambda$a99c8f90daf3b5626ca3b2aaf61c97e045a5237f", ({
  sr_AbstractFunction6_$$Lambda$a99c8f90daf3b5626ca3b2aaf61c97e045a5237f: 1,
  sr_AbstractFunction6: 1,
  F6: 1
}));
export { $d_sr_AbstractFunction6_$$Lambda$a99c8f90daf3b5626ca3b2aaf61c97e045a5237f as $d_sr_AbstractFunction6_$$Lambda$a99c8f90daf3b5626ca3b2aaf61c97e045a5237f };
/** @constructor */
function $c_sjs_js_Any$() {
}
export { $c_sjs_js_Any$ as $c_sjs_js_Any$ };
$c_sjs_js_Any$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_sjs_js_Any$.prototype.constructor = $c_sjs_js_Any$;
/** @constructor */
function $h_sjs_js_Any$() {
}
export { $h_sjs_js_Any$ as $h_sjs_js_Any$ };
$h_sjs_js_Any$.prototype = $c_sjs_js_Any$.prototype;
$c_sjs_js_Any$.prototype.fromFunction0__F0__sjs_js_Function0 = (function(f) {
  return (() => f.apply__O());
});
$c_sjs_js_Any$.prototype.fromFunction1__F1__sjs_js_Function1 = (function(f) {
  return ((arg1$2) => f.apply__O__O(arg1$2));
});
$c_sjs_js_Any$.prototype.fromFunction2__F2__sjs_js_Function2 = (function(f) {
  return ((arg1$2, arg2$2) => f.apply__O__O__O(arg1$2, arg2$2));
});
var $d_sjs_js_Any$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sjs_js_Any$, "scala.scalajs.js.Any$", ({
  sjs_js_Any$: 1,
  sjs_js_LowPrioAnyImplicits: 1,
  sjs_js_LowestPrioAnyImplicits: 1
}));
export { $d_sjs_js_Any$ as $d_sjs_js_Any$ };
var $n_sjs_js_Any$;
function $m_sjs_js_Any$() {
  if ((!$n_sjs_js_Any$)) {
    $n_sjs_js_Any$ = new $c_sjs_js_Any$();
  }
  return $n_sjs_js_Any$;
}
export { $m_sjs_js_Any$ as $m_sjs_js_Any$ };
/** @constructor */
function $c_s_util_Random$() {
  this.s_util_Random__f_self = null;
  $ct_s_util_Random__ju_Random__(this, $ct_ju_Random__(new $c_ju_Random()));
}
export { $c_s_util_Random$ as $c_s_util_Random$ };
$c_s_util_Random$.prototype = new $h_s_util_Random();
$c_s_util_Random$.prototype.constructor = $c_s_util_Random$;
/** @constructor */
function $h_s_util_Random$() {
}
export { $h_s_util_Random$ as $h_s_util_Random$ };
$h_s_util_Random$.prototype = $c_s_util_Random$.prototype;
var $d_s_util_Random$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_s_util_Random$, "scala.util.Random$", ({
  s_util_Random$: 1,
  s_util_Random: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_util_Random$ as $d_s_util_Random$ };
var $n_s_util_Random$;
function $m_s_util_Random$() {
  if ((!$n_s_util_Random$)) {
    $n_s_util_Random$ = new $c_s_util_Random$();
  }
  return $n_s_util_Random$;
}
export { $m_s_util_Random$ as $m_s_util_Random$ };
function $p_Lshapeless3_deriving_internals_ErasedCoproductInstances__is__AO($thiz) {
  if ((!$thiz.Lshapeless3_deriving_internals_ErasedCoproductInstances__f_isbitmap$2)) {
    $thiz.Lshapeless3_deriving_internals_ErasedCoproductInstances__f_is$lzy2 = $thiz.Lshapeless3_deriving_internals_ErasedCoproductInstances__f_is0.apply__O();
    $thiz.Lshapeless3_deriving_internals_ErasedCoproductInstances__f_isbitmap$2 = true;
    $thiz.Lshapeless3_deriving_internals_ErasedCoproductInstances__f_is0 = null;
  }
  return $thiz.Lshapeless3_deriving_internals_ErasedCoproductInstances__f_is$lzy2;
}
export { $p_Lshapeless3_deriving_internals_ErasedCoproductInstances__is__AO as $p_Lshapeless3_deriving_internals_ErasedCoproductInstances__is__AO };
function $p_Lshapeless3_deriving_internals_ErasedCoproductInstances__ordinal__O__O($thiz, x) {
  return $p_Lshapeless3_deriving_internals_ErasedCoproductInstances__is__AO($thiz).u[$thiz.Lshapeless3_deriving_internals_ErasedCoproductInstances__f_mirror.ordinal__O__I(x)];
}
export { $p_Lshapeless3_deriving_internals_ErasedCoproductInstances__ordinal__O__O as $p_Lshapeless3_deriving_internals_ErasedCoproductInstances__ordinal__O__O };
/** @constructor */
function $c_Lshapeless3_deriving_internals_ErasedCoproductInstances(mirror, is0) {
  this.Lshapeless3_deriving_internals_ErasedCoproductInstances__f_mirror = null;
  this.Lshapeless3_deriving_internals_ErasedCoproductInstances__f_is0 = null;
  this.Lshapeless3_deriving_internals_ErasedCoproductInstances__f_is$lzy2 = null;
  this.Lshapeless3_deriving_internals_ErasedCoproductInstances__f_isbitmap$2 = false;
  this.Lshapeless3_deriving_internals_ErasedCoproductInstances__f_mirror = mirror;
  this.Lshapeless3_deriving_internals_ErasedCoproductInstances__f_is0 = is0;
}
export { $c_Lshapeless3_deriving_internals_ErasedCoproductInstances as $c_Lshapeless3_deriving_internals_ErasedCoproductInstances };
$c_Lshapeless3_deriving_internals_ErasedCoproductInstances.prototype = new $h_Lshapeless3_deriving_internals_ErasedInstances();
$c_Lshapeless3_deriving_internals_ErasedCoproductInstances.prototype.constructor = $c_Lshapeless3_deriving_internals_ErasedCoproductInstances;
/** @constructor */
function $h_Lshapeless3_deriving_internals_ErasedCoproductInstances() {
}
export { $h_Lshapeless3_deriving_internals_ErasedCoproductInstances as $h_Lshapeless3_deriving_internals_ErasedCoproductInstances };
$h_Lshapeless3_deriving_internals_ErasedCoproductInstances.prototype = $c_Lshapeless3_deriving_internals_ErasedCoproductInstances.prototype;
$c_Lshapeless3_deriving_internals_ErasedCoproductInstances.prototype.erasedFold__O__F2__O = (function(x, f) {
  var i = $p_Lshapeless3_deriving_internals_ErasedCoproductInstances__ordinal__O__O(this, x);
  return f.apply__O__O__O(i, x);
});
var $d_Lshapeless3_deriving_internals_ErasedCoproductInstances = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lshapeless3_deriving_internals_ErasedCoproductInstances, "shapeless3.deriving.internals.ErasedCoproductInstances", ({
  Lshapeless3_deriving_internals_ErasedCoproductInstances: 1,
  Lshapeless3_deriving_internals_ErasedInstances: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lshapeless3_deriving_internals_ErasedCoproductInstances as $d_Lshapeless3_deriving_internals_ErasedCoproductInstances };
/** @constructor */
function $c_Lshapeless3_deriving_internals_ErasedProductInstances() {
}
export { $c_Lshapeless3_deriving_internals_ErasedProductInstances as $c_Lshapeless3_deriving_internals_ErasedProductInstances };
$c_Lshapeless3_deriving_internals_ErasedProductInstances.prototype = new $h_Lshapeless3_deriving_internals_ErasedInstances();
$c_Lshapeless3_deriving_internals_ErasedProductInstances.prototype.constructor = $c_Lshapeless3_deriving_internals_ErasedProductInstances;
/** @constructor */
function $h_Lshapeless3_deriving_internals_ErasedProductInstances() {
}
export { $h_Lshapeless3_deriving_internals_ErasedProductInstances as $h_Lshapeless3_deriving_internals_ErasedProductInstances };
$h_Lshapeless3_deriving_internals_ErasedProductInstances.prototype = $c_Lshapeless3_deriving_internals_ErasedProductInstances.prototype;
/** @constructor */
function $c_Lshapeless3_deriving_internals_ErasedProductInstances$ArrayProduct(elems) {
  this.Lshapeless3_deriving_internals_ErasedProductInstances$ArrayProduct__f_elems = null;
  this.Lshapeless3_deriving_internals_ErasedProductInstances$ArrayProduct__f_elems = elems;
}
export { $c_Lshapeless3_deriving_internals_ErasedProductInstances$ArrayProduct as $c_Lshapeless3_deriving_internals_ErasedProductInstances$ArrayProduct };
$c_Lshapeless3_deriving_internals_ErasedProductInstances$ArrayProduct.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lshapeless3_deriving_internals_ErasedProductInstances$ArrayProduct.prototype.constructor = $c_Lshapeless3_deriving_internals_ErasedProductInstances$ArrayProduct;
/** @constructor */
function $h_Lshapeless3_deriving_internals_ErasedProductInstances$ArrayProduct() {
}
export { $h_Lshapeless3_deriving_internals_ErasedProductInstances$ArrayProduct as $h_Lshapeless3_deriving_internals_ErasedProductInstances$ArrayProduct };
$h_Lshapeless3_deriving_internals_ErasedProductInstances$ArrayProduct.prototype = $c_Lshapeless3_deriving_internals_ErasedProductInstances$ArrayProduct.prototype;
$c_Lshapeless3_deriving_internals_ErasedProductInstances$ArrayProduct.prototype.productPrefix__T = (function() {
  return "";
});
$c_Lshapeless3_deriving_internals_ErasedProductInstances$ArrayProduct.prototype.productElementName__I__T = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_Product__productElementName__I__T(this, n);
});
$c_Lshapeless3_deriving_internals_ErasedProductInstances$ArrayProduct.prototype.productElement__I__O = (function(n) {
  return this.Lshapeless3_deriving_internals_ErasedProductInstances$ArrayProduct__f_elems.u[n];
});
$c_Lshapeless3_deriving_internals_ErasedProductInstances$ArrayProduct.prototype.productArity__I = (function() {
  return this.Lshapeless3_deriving_internals_ErasedProductInstances$ArrayProduct__f_elems.u.length;
});
$c_Lshapeless3_deriving_internals_ErasedProductInstances$ArrayProduct.prototype.productIterator__sc_Iterator = (function() {
  var xs = this.Lshapeless3_deriving_internals_ErasedProductInstances$ArrayProduct__f_elems;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_ArrayOps$().iterator$extension__O__sc_Iterator(xs);
});
var $d_Lshapeless3_deriving_internals_ErasedProductInstances$ArrayProduct = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lshapeless3_deriving_internals_ErasedProductInstances$ArrayProduct, "shapeless3.deriving.internals.ErasedProductInstances$ArrayProduct", ({
  Lshapeless3_deriving_internals_ErasedProductInstances$ArrayProduct: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lshapeless3_deriving_internals_ErasedProductInstances$ArrayProduct as $d_Lshapeless3_deriving_internals_ErasedProductInstances$ArrayProduct };
/** @constructor */
function $c_Lsttp_capabilities_fs2_Fs2Streams$$anon$1() {
}
export { $c_Lsttp_capabilities_fs2_Fs2Streams$$anon$1 as $c_Lsttp_capabilities_fs2_Fs2Streams$$anon$1 };
$c_Lsttp_capabilities_fs2_Fs2Streams$$anon$1.prototype = new $h_Lsttp_capabilities_package$Streams();
$c_Lsttp_capabilities_fs2_Fs2Streams$$anon$1.prototype.constructor = $c_Lsttp_capabilities_fs2_Fs2Streams$$anon$1;
/** @constructor */
function $h_Lsttp_capabilities_fs2_Fs2Streams$$anon$1() {
}
export { $h_Lsttp_capabilities_fs2_Fs2Streams$$anon$1 as $h_Lsttp_capabilities_fs2_Fs2Streams$$anon$1 };
$h_Lsttp_capabilities_fs2_Fs2Streams$$anon$1.prototype = $c_Lsttp_capabilities_fs2_Fs2Streams$$anon$1.prototype;
var $d_Lsttp_capabilities_fs2_Fs2Streams$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_capabilities_fs2_Fs2Streams$$anon$1, "sttp.capabilities.fs2.Fs2Streams$$anon$1", ({
  Lsttp_capabilities_fs2_Fs2Streams$$anon$1: 1,
  Lsttp_capabilities_package$Streams: 1,
  Lsttp_capabilities_fs2_Fs2Streams: 1
}));
export { $d_Lsttp_capabilities_fs2_Fs2Streams$$anon$1 as $d_Lsttp_capabilities_fs2_Fs2Streams$$anon$1 };
/** @constructor */
function $c_Lsttp_client3_FetchOptions$() {
  this.Lsttp_client3_FetchOptions$__f_Default = null;
  $n_Lsttp_client3_FetchOptions$ = this;
  $m_Lsttp_client3_FetchOptions$();
  var credentials = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var mode = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  this.Lsttp_client3_FetchOptions$__f_Default = new $c_Lsttp_client3_FetchOptions(credentials, mode);
}
export { $c_Lsttp_client3_FetchOptions$ as $c_Lsttp_client3_FetchOptions$ };
$c_Lsttp_client3_FetchOptions$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_FetchOptions$.prototype.constructor = $c_Lsttp_client3_FetchOptions$;
/** @constructor */
function $h_Lsttp_client3_FetchOptions$() {
}
export { $h_Lsttp_client3_FetchOptions$ as $h_Lsttp_client3_FetchOptions$ };
$h_Lsttp_client3_FetchOptions$.prototype = $c_Lsttp_client3_FetchOptions$.prototype;
$c_Lsttp_client3_FetchOptions$.prototype.fromProduct__s_Product__Lsttp_client3_FetchOptions = (function(x$0) {
  return new $c_Lsttp_client3_FetchOptions(x$0.productElement__I__O(0), x$0.productElement__I__O(1));
});
$c_Lsttp_client3_FetchOptions$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lsttp_client3_FetchOptions(p);
});
var $d_Lsttp_client3_FetchOptions$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_FetchOptions$, "sttp.client3.FetchOptions$", ({
  Lsttp_client3_FetchOptions$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lsttp_client3_FetchOptions$ as $d_Lsttp_client3_FetchOptions$ };
var $n_Lsttp_client3_FetchOptions$;
function $m_Lsttp_client3_FetchOptions$() {
  if ((!$n_Lsttp_client3_FetchOptions$)) {
    $n_Lsttp_client3_FetchOptions$ = new $c_Lsttp_client3_FetchOptions$();
  }
  return $n_Lsttp_client3_FetchOptions$;
}
export { $m_Lsttp_client3_FetchOptions$ as $m_Lsttp_client3_FetchOptions$ };
/** @constructor */
function $c_Lsttp_client3_RequestT$$anon$2(m$1, u$1, h$2) {
  this.Lsttp_client3_RequestT$$anon$2__f_method = null;
  this.Lsttp_client3_RequestT$$anon$2__f_uri = null;
  this.Lsttp_client3_RequestT$$anon$2__f_headers = null;
  this.Lsttp_client3_RequestT$$anon$2__f_method = m$1;
  this.Lsttp_client3_RequestT$$anon$2__f_uri = u$1;
  this.Lsttp_client3_RequestT$$anon$2__f_headers = h$2;
}
export { $c_Lsttp_client3_RequestT$$anon$2 as $c_Lsttp_client3_RequestT$$anon$2 };
$c_Lsttp_client3_RequestT$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_RequestT$$anon$2.prototype.constructor = $c_Lsttp_client3_RequestT$$anon$2;
/** @constructor */
function $h_Lsttp_client3_RequestT$$anon$2() {
}
export { $h_Lsttp_client3_RequestT$$anon$2 as $h_Lsttp_client3_RequestT$$anon$2 };
$h_Lsttp_client3_RequestT$$anon$2.prototype = $c_Lsttp_client3_RequestT$$anon$2.prototype;
$c_Lsttp_client3_RequestT$$anon$2.prototype.toString__T = (function() {
  return $f_Lsttp_model_RequestMetadata__toString__T(this);
});
$c_Lsttp_client3_RequestT$$anon$2.prototype.method__T = (function() {
  return this.Lsttp_client3_RequestT$$anon$2__f_method;
});
$c_Lsttp_client3_RequestT$$anon$2.prototype.uri__Lsttp_model_Uri = (function() {
  return this.Lsttp_client3_RequestT$$anon$2__f_uri;
});
$c_Lsttp_client3_RequestT$$anon$2.prototype.headers__sci_Seq = (function() {
  return this.Lsttp_client3_RequestT$$anon$2__f_headers;
});
var $d_Lsttp_client3_RequestT$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_RequestT$$anon$2, "sttp.client3.RequestT$$anon$2", ({
  Lsttp_client3_RequestT$$anon$2: 1,
  Lsttp_model_HasHeaders: 1,
  Lsttp_model_RequestMetadata: 1
}));
export { $d_Lsttp_client3_RequestT$$anon$2 as $d_Lsttp_client3_RequestT$$anon$2 };
function $p_Lsttp_client3_Response$__resolveStatusText__I__T__T($thiz, statusCode, provided) {
  if ((provided === "")) {
    var this$1 = $m_Lsttp_model_StatusText$().default__I__s_Option(statusCode);
    return (this$1.isEmpty__Z() ? provided : this$1.get__O());
  } else {
    return provided;
  }
}
export { $p_Lsttp_client3_Response$__resolveStatusText__I__T__T as $p_Lsttp_client3_Response$__resolveStatusText__I__T__T };
/** @constructor */
function $c_Lsttp_client3_Response$() {
  this.Lsttp_client3_Response$__f_ExampleGet = null;
  $n_Lsttp_client3_Response$ = this;
  this.Lsttp_client3_Response$__f_ExampleGet = new $c_Lsttp_client3_Response$$anon$1();
}
export { $c_Lsttp_client3_Response$ as $c_Lsttp_client3_Response$ };
$c_Lsttp_client3_Response$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_Response$.prototype.constructor = $c_Lsttp_client3_Response$;
/** @constructor */
function $h_Lsttp_client3_Response$() {
}
export { $h_Lsttp_client3_Response$ as $h_Lsttp_client3_Response$ };
$h_Lsttp_client3_Response$.prototype = $c_Lsttp_client3_Response$.prototype;
$c_Lsttp_client3_Response$.prototype.apply__O__I__Lsttp_client3_Response = (function(body, code) {
  var statusText = $p_Lsttp_client3_Response$__resolveStatusText__I__T__T(this, code, "");
  var headers = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var history = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var request = this.Lsttp_client3_Response$__f_ExampleGet;
  return new $c_Lsttp_client3_Response(body, code, statusText, headers, history, request);
});
$c_Lsttp_client3_Response$.prototype.fromProduct__s_Product__Lsttp_client3_Response = (function(x$0) {
  var $x_1 = x$0.productElement__I__O(0);
  var ev$1 = x$0.productElement__I__O(1);
  return new $c_Lsttp_client3_Response($x_1, ((ev$1 === null) ? (null | 0) : ev$1.Lsttp_model_StatusCode__f_code), x$0.productElement__I__O(2), x$0.productElement__I__O(3), x$0.productElement__I__O(4), x$0.productElement__I__O(5));
});
$c_Lsttp_client3_Response$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lsttp_client3_Response(p);
});
var $d_Lsttp_client3_Response$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_Response$, "sttp.client3.Response$", ({
  Lsttp_client3_Response$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lsttp_client3_Response$ as $d_Lsttp_client3_Response$ };
var $n_Lsttp_client3_Response$;
function $m_Lsttp_client3_Response$() {
  if ((!$n_Lsttp_client3_Response$)) {
    $n_Lsttp_client3_Response$ = new $c_Lsttp_client3_Response$();
  }
  return $n_Lsttp_client3_Response$;
}
export { $m_Lsttp_client3_Response$ as $m_Lsttp_client3_Response$ };
/** @constructor */
function $c_Lsttp_client3_Response$$anon$1() {
}
export { $c_Lsttp_client3_Response$$anon$1 as $c_Lsttp_client3_Response$$anon$1 };
$c_Lsttp_client3_Response$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_Response$$anon$1.prototype.constructor = $c_Lsttp_client3_Response$$anon$1;
/** @constructor */
function $h_Lsttp_client3_Response$$anon$1() {
}
export { $h_Lsttp_client3_Response$$anon$1 as $h_Lsttp_client3_Response$$anon$1 };
$h_Lsttp_client3_Response$$anon$1.prototype = $c_Lsttp_client3_Response$$anon$1.prototype;
$c_Lsttp_client3_Response$$anon$1.prototype.toString__T = (function() {
  return $f_Lsttp_model_RequestMetadata__toString__T(this);
});
$c_Lsttp_client3_Response$$anon$1.prototype.method__T = (function() {
  return $m_Lsttp_model_Method$().Lsttp_model_Method$__f_GET;
});
$c_Lsttp_client3_Response$$anon$1.prototype.uri__Lsttp_model_Uri = (function() {
  var this$2 = $m_Lsttp_client3_package$();
  var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["http://example.com"]));
  var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
  var this$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_model_UriInterpolator$UriContext(this$2, sc);
  var args = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([]));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_UriInterpolator$().interpolate__s_StringContext__sci_Seq__Lsttp_model_Uri(this$3.Lsttp_model_UriInterpolator$UriContext__f_sc, args);
});
$c_Lsttp_client3_Response$$anon$1.prototype.headers__sci_Seq = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
});
var $d_Lsttp_client3_Response$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_Response$$anon$1, "sttp.client3.Response$$anon$1", ({
  Lsttp_client3_Response$$anon$1: 1,
  Lsttp_model_HasHeaders: 1,
  Lsttp_model_RequestMetadata: 1
}));
export { $d_Lsttp_client3_Response$$anon$1 as $d_Lsttp_client3_Response$$anon$1 };
/** @constructor */
function $c_Lsttp_client3_ResponseAs$() {
}
export { $c_Lsttp_client3_ResponseAs$ as $c_Lsttp_client3_ResponseAs$ };
$c_Lsttp_client3_ResponseAs$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_ResponseAs$.prototype.constructor = $c_Lsttp_client3_ResponseAs$;
/** @constructor */
function $h_Lsttp_client3_ResponseAs$() {
}
export { $h_Lsttp_client3_ResponseAs$ as $h_Lsttp_client3_ResponseAs$ };
$h_Lsttp_client3_ResponseAs$.prototype = $c_Lsttp_client3_ResponseAs$.prototype;
$c_Lsttp_client3_ResponseAs$.prototype.isWebSocket__Lsttp_client3_ResponseAs__Z = (function(ra) {
  var ra$tailLocal1 = ra;
  while (true) {
    var x117 = ra$tailLocal1;
    if ($is_Lsttp_client3_WebSocketResponseAs(x117)) {
      return true;
    }
    if ((x117 instanceof $c_Lsttp_client3_ResponseAsFromMetadata)) {
      var x129 = x117.Lsttp_client3_ResponseAsFromMetadata__f_conditions;
      var x130 = x117.Lsttp_client3_ResponseAsFromMetadata__f_default;
      _return$1: {
        var these = x129;
        while ((!these.isEmpty__Z())) {
          var x0 = these.head__O();
          if (this.isWebSocket__Lsttp_client3_ResponseAs__Z(x0.Lsttp_client3_ConditionalResponseAs__f_responseAs)) {
            var $x_1 = true;
            break _return$1;
          }
          these = these.tail__O();
        }
        var $x_1 = false;
      }
      if ($x_1) {
        return true;
      } else {
        ra$tailLocal1 = x130;
        continue;
      }
    }
    if ((x117 instanceof $c_Lsttp_client3_MappedResponseAs)) {
      var x124 = x117.Lsttp_client3_MappedResponseAs__f_raw;
      ra$tailLocal1 = x124;
      continue;
    }
    if (false) {
      var x120 = x117.Lsttp_client3_ResponseAsBoth__f_l;
      var x121 = x117.Lsttp_client3_ResponseAsBoth__f_r;
      if (this.isWebSocket__Lsttp_client3_ResponseAs__Z(x120)) {
        return true;
      } else {
        ra$tailLocal1 = x121;
        continue;
      }
    }
    return false;
  }
});
$c_Lsttp_client3_ResponseAs$.prototype.ordinal__Lsttp_client3_ResponseAs__I = (function(x$0) {
  if ((x$0 === $m_Lsttp_client3_IgnoreResponse$())) {
    return 0;
  }
  if ((x$0 === $m_Lsttp_client3_ResponseAsByteArray$())) {
    return 1;
  }
  if (false) {
    return 2;
  }
  if ((x$0 instanceof $c_Lsttp_client3_ResponseAsStreamUnsafe)) {
    return 3;
  }
  if ((x$0 instanceof $c_Lsttp_client3_ResponseAsFile)) {
    return 4;
  }
  if ($is_Lsttp_client3_WebSocketResponseAs(x$0)) {
    return 5;
  }
  if ((x$0 instanceof $c_Lsttp_client3_ResponseAsFromMetadata)) {
    return 6;
  }
  if ((x$0 instanceof $c_Lsttp_client3_MappedResponseAs)) {
    return 7;
  }
  if (false) {
    return 8;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$0);
});
$c_Lsttp_client3_ResponseAs$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Lsttp_client3_ResponseAs__I(x);
});
var $d_Lsttp_client3_ResponseAs$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_ResponseAs$, "sttp.client3.ResponseAs$", ({
  Lsttp_client3_ResponseAs$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lsttp_client3_ResponseAs$ as $d_Lsttp_client3_ResponseAs$ };
var $n_Lsttp_client3_ResponseAs$;
function $m_Lsttp_client3_ResponseAs$() {
  if ((!$n_Lsttp_client3_ResponseAs$)) {
    $n_Lsttp_client3_ResponseAs$ = new $c_Lsttp_client3_ResponseAs$();
  }
  return $n_Lsttp_client3_ResponseAs$;
}
export { $m_Lsttp_client3_ResponseAs$ as $m_Lsttp_client3_ResponseAs$ };
function $f_Lsttp_client3_SttpApi__$init$__V($thiz) {
  var this$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_package$DurationInt(1);
  var unit = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MINUTES;
  var this$ = this$2.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$();
  var hi = (this$ >> 31);
  $thiz.Lsttp_client3_package$__f_DefaultReadTimeout = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_FiniteDuration(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(this$, hi), unit);
  var method = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var uri = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var body = $m_Lsttp_client3_NoBody$();
  var this$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
  var elems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_sr_Nothing$.getArrayOf().constr)([]));
  var headers = this$6.from__sc_IterableOnce__sci_Vector(elems);
  var response = $f_Lsttp_client3_SttpApi__asString__T__Lsttp_client3_ResponseAs($thiz, "utf-8");
  var readTimeout = $thiz.Lsttp_client3_package$__f_DefaultReadTimeout;
  var maxRedirects = $m_Lsttp_client3_FollowRedirectsBackend$().Lsttp_client3_FollowRedirectsBackend$__f_MaxRedirects;
  var options = new $c_Lsttp_client3_RequestOptions(true, readTimeout, maxRedirects, false);
  var this$8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$();
  var elems$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T2.getArrayOf().constr)([]));
  var tags = this$8.from__sc_IterableOnce__sci_Map(elems$1);
  $thiz.Lsttp_client3_package$__f_emptyRequest = new $c_Lsttp_client3_RequestT(method, uri, body, headers, response, options, tags);
  var this$10 = $thiz.Lsttp_client3_package$__f_emptyRequest;
  $thiz.Lsttp_client3_package$__f_basicRequest = this$10.header__T__T__Z__Lsttp_client3_RequestT($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_AcceptEncoding, "gzip, deflate", true);
  var this$11 = $thiz.Lsttp_client3_package$__f_basicRequest;
  $f_Lsttp_client3_SttpApi__asStringAlways__T__Lsttp_client3_ResponseAs($thiz, "utf-8");
}
export { $f_Lsttp_client3_SttpApi__$init$__V as $f_Lsttp_client3_SttpApi__$init$__V };
function $f_Lsttp_client3_SttpApi__asString__T__Lsttp_client3_ResponseAs($thiz, charset) {
  return $f_Lsttp_client3_SttpApi__asStringAlways__T__Lsttp_client3_ResponseAs($thiz, charset).mapWithMetadata__F2__Lsttp_client3_ResponseAs(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((s, m) => ($m_Lsttp_model_StatusCode$().isSuccess$extension__I__Z(m.code__I()) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(s) : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(s))))).showAs__T__Lsttp_client3_ResponseAs("either(as string, as string)");
}
export { $f_Lsttp_client3_SttpApi__asString__T__Lsttp_client3_ResponseAs as $f_Lsttp_client3_SttpApi__asString__T__Lsttp_client3_ResponseAs };
function $f_Lsttp_client3_SttpApi__asStringAlways__T__Lsttp_client3_ResponseAs($thiz, charset) {
  var this$3 = $m_Lsttp_client3_ResponseAsByteArray$();
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((bytes, metadata) => {
    var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lsttp_model_HasHeaders__header__T__s_Option(metadata, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_ContentType);
    if (this$1.isEmpty__Z()) {
      var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    } else {
      var x0 = this$1.get__O();
      var $x_1 = $m_Lsttp_client3_internal_package$().charsetFromContentType__T__s_Option(x0);
    }
    var this$2 = $x_1;
    var charset2 = (this$2.isEmpty__Z() ? charset : this$2.get__O());
    var charset3 = $m_Lsttp_client3_internal_package$().sanitizeCharset__T__T(charset2);
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_String$().new__AB__T__T(bytes, charset3);
  }));
  var showAs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  return new $c_Lsttp_client3_MappedResponseAs(this$3, f, showAs).showAs__T__Lsttp_client3_ResponseAs("as string");
}
export { $f_Lsttp_client3_SttpApi__asStringAlways__T__Lsttp_client3_ResponseAs as $f_Lsttp_client3_SttpApi__asStringAlways__T__Lsttp_client3_ResponseAs };
function $f_Lsttp_client3_SttpApi__multipart__T__T__T__Lsttp_model_Part($thiz, name, data, encoding) {
  var $x_2 = $m_Lsttp_model_Part$();
  var defaultContentType = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_MediaType$().Lsttp_model_MediaType$__f_TextPlain;
  var $x_1 = new $c_Lsttp_client3_StringBody(data, encoding, defaultContentType);
  var value = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_MediaType$().Lsttp_model_MediaType$__f_TextPlain.charset__T__Lsttp_model_MediaType(encoding);
  return $x_2.apply__T__O__s_Option__s_Option__sci_Map__sci_Seq__Lsttp_model_Part(name, $x_1, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$EmptyMap$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
}
export { $f_Lsttp_client3_SttpApi__multipart__T__T__T__Lsttp_model_Part as $f_Lsttp_client3_SttpApi__multipart__T__T__T__Lsttp_model_Part };
function $f_Lsttp_client3_SttpApi__multipart__T__AB__Lsttp_model_Part($thiz, name, data) {
  var $x_2 = $m_Lsttp_model_Part$();
  var defaultContentType = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_MediaType$().Lsttp_model_MediaType$__f_ApplicationOctetStream;
  var $x_1 = new $c_Lsttp_client3_ByteArrayBody(data, defaultContentType);
  var value = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_MediaType$().Lsttp_model_MediaType$__f_ApplicationOctetStream;
  return $x_2.apply__T__O__s_Option__s_Option__sci_Map__sci_Seq__Lsttp_model_Part(name, $x_1, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$EmptyMap$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
}
export { $f_Lsttp_client3_SttpApi__multipart__T__AB__Lsttp_model_Part as $f_Lsttp_client3_SttpApi__multipart__T__AB__Lsttp_model_Part };
function $f_Lsttp_client3_SttpApi__multipart__T__Ljava_nio_ByteBuffer__Lsttp_model_Part($thiz, name, data) {
  var $x_2 = $m_Lsttp_model_Part$();
  var defaultContentType = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_MediaType$().Lsttp_model_MediaType$__f_ApplicationOctetStream;
  var $x_1 = new $c_Lsttp_client3_ByteBufferBody(data, defaultContentType);
  var value = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_MediaType$().Lsttp_model_MediaType$__f_ApplicationOctetStream;
  return $x_2.apply__T__O__s_Option__s_Option__sci_Map__sci_Seq__Lsttp_model_Part(name, $x_1, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$EmptyMap$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
}
export { $f_Lsttp_client3_SttpApi__multipart__T__Ljava_nio_ByteBuffer__Lsttp_model_Part as $f_Lsttp_client3_SttpApi__multipart__T__Ljava_nio_ByteBuffer__Lsttp_model_Part };
function $f_Lsttp_client3_SttpApi__multipart__T__Ljava_io_InputStream__Lsttp_model_Part($thiz, name, data) {
  var $x_2 = $m_Lsttp_model_Part$();
  var defaultContentType = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_MediaType$().Lsttp_model_MediaType$__f_ApplicationOctetStream;
  var $x_1 = new $c_Lsttp_client3_InputStreamBody(data, defaultContentType);
  var value = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_MediaType$().Lsttp_model_MediaType$__f_ApplicationOctetStream;
  return $x_2.apply__T__O__s_Option__s_Option__sci_Map__sci_Seq__Lsttp_model_Part(name, $x_1, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$EmptyMap$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
}
export { $f_Lsttp_client3_SttpApi__multipart__T__Ljava_io_InputStream__Lsttp_model_Part as $f_Lsttp_client3_SttpApi__multipart__T__Ljava_io_InputStream__Lsttp_model_Part };
function $f_Lsttp_client3_SttpApi__multipartSttpFile__T__Lsttp_client3_internal_SttpFile__Lsttp_model_Part($thiz, name, file) {
  var defaultContentType = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_MediaType$().Lsttp_model_MediaType$__f_ApplicationOctetStream;
  var body$1 = new $c_Lsttp_client3_FileBody(file, defaultContentType);
  var value = file.Lsttp_client3_internal_SttpFileCompanionExtensions$$anon$1__f_name;
  var fileName$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
  var value$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_MediaType$().Lsttp_model_MediaType$__f_ApplicationOctetStream;
  var contentType$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value$1);
  var otherDispositionParams$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$EmptyMap$();
  var otherHeaders$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  return $m_Lsttp_model_Part$().apply__T__O__s_Option__s_Option__sci_Map__sci_Seq__Lsttp_model_Part(name, body$1, contentType$1, fileName$1, otherDispositionParams$1, otherHeaders$1);
}
export { $f_Lsttp_client3_SttpApi__multipartSttpFile__T__Lsttp_client3_internal_SttpFile__Lsttp_model_Part as $f_Lsttp_client3_SttpApi__multipartSttpFile__T__Lsttp_client3_internal_SttpFile__Lsttp_model_Part };
/** @constructor */
function $c_Lsttp_client3_impl_cats_FetchCatsBackend(fetchOptions, customizeRequest, evidence$1) {
  this.Lsttp_client3_AbstractFetchBackend__f_sttp$client3$AbstractFetchBackend$$options = null;
  this.Lsttp_client3_AbstractFetchBackend__f_customizeRequest = null;
  this.Lsttp_client3_AbstractFetchBackend__f_sttp$client3$AbstractFetchBackend$$monad = null;
  this.Lsttp_client3_AbstractFetchBackend__f_bodyFromResponseAs$lzy1 = null;
  this.Lsttp_client3_AbstractFetchBackend__f_bodyFromResponseAsbitmap$1 = false;
  this.Lsttp_client3_impl_cats_FetchCatsBackend__f_sttp$client3$impl$cats$FetchCatsBackend$$evidence$1 = null;
  this.Lsttp_client3_impl_cats_FetchCatsBackend__f_sttp$client3$impl$cats$FetchCatsBackend$$evidence$1 = evidence$1;
  $ct_Lsttp_client3_AbstractFetchBackend__Lsttp_client3_FetchOptions__F1__Lsttp_monad_MonadError__(this, fetchOptions, customizeRequest, new $c_Lsttp_client3_impl_cats_CatsMonadAsyncError(evidence$1));
}
export { $c_Lsttp_client3_impl_cats_FetchCatsBackend as $c_Lsttp_client3_impl_cats_FetchCatsBackend };
$c_Lsttp_client3_impl_cats_FetchCatsBackend.prototype = new $h_Lsttp_client3_AbstractFetchBackend();
$c_Lsttp_client3_impl_cats_FetchCatsBackend.prototype.constructor = $c_Lsttp_client3_impl_cats_FetchCatsBackend;
/** @constructor */
function $h_Lsttp_client3_impl_cats_FetchCatsBackend() {
}
export { $h_Lsttp_client3_impl_cats_FetchCatsBackend as $h_Lsttp_client3_impl_cats_FetchCatsBackend };
$h_Lsttp_client3_impl_cats_FetchCatsBackend.prototype = $c_Lsttp_client3_impl_cats_FetchCatsBackend.prototype;
$c_Lsttp_client3_impl_cats_FetchCatsBackend.prototype.addCancelTimeoutHook__O__F0__F0__O = (function(result, cancel, cleanup) {
  var this$2 = $m_Lcats_effect_IO$();
  var doCancel = this$2.delay__F0__Lcats_effect_IO(cancel);
  var this$4 = $m_Lcats_effect_IO$();
  var doCleanup = this$4.delay__F0__Lcats_effect_IO(cleanup);
  var wrapped = new $c_Lcats_effect_IO$OnCancel(result, doCancel);
  return wrapped.guarantee__Lcats_effect_IO__Lcats_effect_IO(doCleanup);
});
$c_Lsttp_client3_impl_cats_FetchCatsBackend.prototype.handleResponseAsStream__Lorg_scalajs_dom_Response__O = (function(response) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalStateException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalStateException(), "FetchCatsBackend does not support streaming responses");
});
$c_Lsttp_client3_impl_cats_FetchCatsBackend.prototype.compileWebSocketPipe__Lsttp_ws_WebSocket__E__O = (function(ws, pipe) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalStateException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalStateException(), "FetchCatsBackend does not support streaming responses");
});
$c_Lsttp_client3_impl_cats_FetchCatsBackend.prototype.handleStreamBody__O__O = (function(s) {
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_ClassCastException();
});
$c_Lsttp_client3_impl_cats_FetchCatsBackend.prototype.compileWebSocketPipe__Lsttp_ws_WebSocket__O__O = (function(ws, pipe) {
  var $x_1;
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_ClassCastException();
  return this.compileWebSocketPipe__Lsttp_ws_WebSocket__E__O(ws, $x_1);
});
var $d_Lsttp_client3_impl_cats_FetchCatsBackend = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_impl_cats_FetchCatsBackend, "sttp.client3.impl.cats.FetchCatsBackend", ({
  Lsttp_client3_impl_cats_FetchCatsBackend: 1,
  Lsttp_client3_AbstractFetchBackend: 1,
  Lsttp_client3_SttpBackend: 1
}));
export { $d_Lsttp_client3_impl_cats_FetchCatsBackend as $d_Lsttp_client3_impl_cats_FetchCatsBackend };
/** @constructor */
function $c_Lsttp_client3_internal_SttpFileCompanionExtensions$$anon$1(file$1) {
  this.Lsttp_client3_internal_SttpFile__f_underlying = null;
  this.Lsttp_client3_internal_SttpFileCompanionExtensions$$anon$1__f_name = null;
  this.Lsttp_client3_internal_SttpFileCompanionExtensions$$anon$1__f_size = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0;
  $ct_Lsttp_client3_internal_SttpFile__O__(this, file$1);
  this.Lsttp_client3_internal_SttpFileCompanionExtensions$$anon$1__f_name = file$1.name;
  var value = (+file$1.size);
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_RTLong$();
  var lo = this$1.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  this.Lsttp_client3_internal_SttpFileCompanionExtensions$$anon$1__f_size = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi);
}
export { $c_Lsttp_client3_internal_SttpFileCompanionExtensions$$anon$1 as $c_Lsttp_client3_internal_SttpFileCompanionExtensions$$anon$1 };
$c_Lsttp_client3_internal_SttpFileCompanionExtensions$$anon$1.prototype = new $h_Lsttp_client3_internal_SttpFile();
$c_Lsttp_client3_internal_SttpFileCompanionExtensions$$anon$1.prototype.constructor = $c_Lsttp_client3_internal_SttpFileCompanionExtensions$$anon$1;
/** @constructor */
function $h_Lsttp_client3_internal_SttpFileCompanionExtensions$$anon$1() {
}
export { $h_Lsttp_client3_internal_SttpFileCompanionExtensions$$anon$1 as $h_Lsttp_client3_internal_SttpFileCompanionExtensions$$anon$1 };
$h_Lsttp_client3_internal_SttpFileCompanionExtensions$$anon$1.prototype = $c_Lsttp_client3_internal_SttpFileCompanionExtensions$$anon$1.prototype;
var $d_Lsttp_client3_internal_SttpFileCompanionExtensions$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_internal_SttpFileCompanionExtensions$$anon$1, "sttp.client3.internal.SttpFileCompanionExtensions$$anon$1", ({
  Lsttp_client3_internal_SttpFileCompanionExtensions$$anon$1: 1,
  Lsttp_client3_internal_SttpFile: 1,
  Lsttp_client3_internal_SttpFileExtensions: 1
}));
export { $d_Lsttp_client3_internal_SttpFileCompanionExtensions$$anon$1 as $d_Lsttp_client3_internal_SttpFileCompanionExtensions$$anon$1 };
/** @constructor */
function $c_Lsttp_model_Headers$() {
}
export { $c_Lsttp_model_Headers$ as $c_Lsttp_model_Headers$ };
$c_Lsttp_model_Headers$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_model_Headers$.prototype.constructor = $c_Lsttp_model_Headers$;
/** @constructor */
function $h_Lsttp_model_Headers$() {
}
export { $h_Lsttp_model_Headers$ as $h_Lsttp_model_Headers$ };
$h_Lsttp_model_Headers$.prototype = $c_Lsttp_model_Headers$.prototype;
$c_Lsttp_model_Headers$.prototype.toStringSafe__sci_Seq__sci_Set__sci_Seq = (function(headers, sensitiveHeaders) {
  return headers.map__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => _$1.toStringSafe__sci_Set__T(sensitiveHeaders))));
});
$c_Lsttp_model_Headers$.prototype.fromProduct__s_Product__Lsttp_model_Headers = (function(x$0) {
  return new $c_Lsttp_model_Headers(x$0.productElement__I__O(0));
});
$c_Lsttp_model_Headers$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lsttp_model_Headers(p);
});
var $d_Lsttp_model_Headers$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_model_Headers$, "sttp.model.Headers$", ({
  Lsttp_model_Headers$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lsttp_model_Headers$ as $d_Lsttp_model_Headers$ };
var $n_Lsttp_model_Headers$;
function $m_Lsttp_model_Headers$() {
  if ((!$n_Lsttp_model_Headers$)) {
    $n_Lsttp_model_Headers$ = new $c_Lsttp_model_Headers$();
  }
  return $n_Lsttp_model_Headers$;
}
export { $m_Lsttp_model_Headers$ as $m_Lsttp_model_Headers$ };
/** @constructor */
function $c_Lsttp_model_Part$() {
  this.Lsttp_model_Part$__f_FileNameDispositionParam = null;
  this.Lsttp_model_Part$__f_NonAsciiFileNameDispositionParam = null;
  this.Lsttp_model_Part$__f_FileNameDispositionParam = "filename";
  this.Lsttp_model_Part$__f_NonAsciiFileNameDispositionParam = "filename*";
}
export { $c_Lsttp_model_Part$ as $c_Lsttp_model_Part$ };
$c_Lsttp_model_Part$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_model_Part$.prototype.constructor = $c_Lsttp_model_Part$;
/** @constructor */
function $h_Lsttp_model_Part$() {
}
export { $h_Lsttp_model_Part$ as $h_Lsttp_model_Part$ };
$h_Lsttp_model_Part$.prototype = $c_Lsttp_model_Part$.prototype;
$c_Lsttp_model_Part$.prototype.apply__T__O__s_Option__s_Option__sci_Map__sci_Seq__Lsttp_model_Part = (function(name, body, contentType, fileName, otherDispositionParams, otherHeaders) {
  var p1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_model_Part(name, body, otherDispositionParams, otherHeaders);
  if (contentType.isEmpty__Z()) {
    var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0 = contentType.get__O();
    var this$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(p1.contentType__Lsttp_model_MediaType__Lsttp_model_Part(x0));
  }
  var p2 = (this$2.isEmpty__Z() ? p1 : this$2.get__O());
  if (fileName.isEmpty__Z()) {
    var this$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0$1 = fileName.get__O();
    var this$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(p2.dispositionParam__T__T__Lsttp_model_Part("filename", x0$1));
  }
  return (this$3.isEmpty__Z() ? p2 : this$3.get__O());
});
$c_Lsttp_model_Part$.prototype.fromProduct__s_Product__Lsttp_model_Part = (function(x$0) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_model_Part(x$0.productElement__I__O(0), x$0.productElement__I__O(1), x$0.productElement__I__O(2), x$0.productElement__I__O(3));
});
$c_Lsttp_model_Part$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lsttp_model_Part(p);
});
var $d_Lsttp_model_Part$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_model_Part$, "sttp.model.Part$", ({
  Lsttp_model_Part$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lsttp_model_Part$ as $d_Lsttp_model_Part$ };
var $n_Lsttp_model_Part$;
function $m_Lsttp_model_Part$() {
  if ((!$n_Lsttp_model_Part$)) {
    $n_Lsttp_model_Part$ = new $c_Lsttp_model_Part$();
  }
  return $n_Lsttp_model_Part$;
}
export { $m_Lsttp_model_Part$ as $m_Lsttp_model_Part$ };
/** @constructor */
function $c_Lsttp_model_ResponseMetadata$$anon$1(statusCode$2, _statusText$2, _headers$2) {
  this.Lsttp_model_ResponseMetadata$$anon$1__f_statusCode$1 = 0;
  this.Lsttp_model_ResponseMetadata$$anon$1__f__statusText$1 = null;
  this.Lsttp_model_ResponseMetadata$$anon$1__f__headers$1 = null;
  this.Lsttp_model_ResponseMetadata$$anon$1__f_statusCode$1 = statusCode$2;
  this.Lsttp_model_ResponseMetadata$$anon$1__f__statusText$1 = _statusText$2;
  this.Lsttp_model_ResponseMetadata$$anon$1__f__headers$1 = _headers$2;
}
export { $c_Lsttp_model_ResponseMetadata$$anon$1 as $c_Lsttp_model_ResponseMetadata$$anon$1 };
$c_Lsttp_model_ResponseMetadata$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_model_ResponseMetadata$$anon$1.prototype.constructor = $c_Lsttp_model_ResponseMetadata$$anon$1;
/** @constructor */
function $h_Lsttp_model_ResponseMetadata$$anon$1() {
}
export { $h_Lsttp_model_ResponseMetadata$$anon$1 as $h_Lsttp_model_ResponseMetadata$$anon$1 };
$h_Lsttp_model_ResponseMetadata$$anon$1.prototype = $c_Lsttp_model_ResponseMetadata$$anon$1.prototype;
$c_Lsttp_model_ResponseMetadata$$anon$1.prototype.toString__T = (function() {
  return $f_Lsttp_model_ResponseMetadata__toString__T(this);
});
$c_Lsttp_model_ResponseMetadata$$anon$1.prototype.code__I = (function() {
  return this.Lsttp_model_ResponseMetadata$$anon$1__f_statusCode$1;
});
$c_Lsttp_model_ResponseMetadata$$anon$1.prototype.statusText__T = (function() {
  return this.Lsttp_model_ResponseMetadata$$anon$1__f__statusText$1;
});
$c_Lsttp_model_ResponseMetadata$$anon$1.prototype.headers__sci_Seq = (function() {
  return this.Lsttp_model_ResponseMetadata$$anon$1__f__headers$1;
});
var $d_Lsttp_model_ResponseMetadata$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_model_ResponseMetadata$$anon$1, "sttp.model.ResponseMetadata$$anon$1", ({
  Lsttp_model_ResponseMetadata$$anon$1: 1,
  Lsttp_model_HasHeaders: 1,
  Lsttp_model_ResponseMetadata: 1
}));
export { $d_Lsttp_model_ResponseMetadata$$anon$1 as $d_Lsttp_model_ResponseMetadata$$anon$1 };
/** @constructor */
function $c_Lsttp_model_StatusText$() {
  this.Lsttp_model_StatusText$__f_statusTexts = null;
  $n_Lsttp_model_StatusText$ = this;
  var this$121 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$();
  var $x_60 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
  var self = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_Continue);
  var $x_59 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self, "Continue");
  var self$1 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_SwitchingProtocols);
  var $x_58 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$1, "Switching Protocols");
  var self$2 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_Processing);
  var $x_57 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$2, "Processing");
  var self$3 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_EarlyHints);
  var $x_56 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$3, "Early Hints");
  var self$4 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_Ok);
  var $x_55 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$4, "Ok");
  var self$5 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_Created);
  var $x_54 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$5, "Created");
  var self$6 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_Accepted);
  var $x_53 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$6, "Accepted");
  var self$7 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_NonAuthoritativeInformation);
  var $x_52 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$7, "Non Authoritative Information");
  var self$8 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_NoContent);
  var $x_51 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$8, "No Content");
  var self$9 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_ResetContent);
  var $x_50 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$9, "Reset Content");
  var self$10 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_PartialContent);
  var $x_49 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$10, "Partial Content");
  var self$11 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_MultiStatus);
  var $x_48 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$11, "Multi Status");
  var self$12 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_AlreadyReported);
  var $x_47 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$12, "Already Reported");
  var self$13 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_ImUsed);
  var $x_46 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$13, "Im Used");
  var self$14 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_MultipleChoices);
  var $x_45 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$14, "Multiple Choices");
  var self$15 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_MovedPermanently);
  var $x_44 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$15, "Moved Permanently");
  var self$16 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_Found);
  var $x_43 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$16, "Found");
  var self$17 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_SeeOther);
  var $x_42 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$17, "See Other");
  var self$18 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_NotModified);
  var $x_41 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$18, "Not Modified");
  var self$19 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_UseProxy);
  var $x_40 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$19, "Use Proxy");
  var self$20 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_TemporaryRedirect);
  var $x_39 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$20, "Temporary Redirect");
  var self$21 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_PermanentRedirect);
  var $x_38 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$21, "Permanent Redirect");
  var self$22 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_BadRequest);
  var $x_37 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$22, "Bad Request");
  var self$23 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_Unauthorized);
  var $x_36 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$23, "Unauthorized");
  var self$24 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_PaymentRequired);
  var $x_35 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$24, "Payment Required");
  var self$25 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_Forbidden);
  var $x_34 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$25, "Forbidden");
  var self$26 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_NotFound);
  var $x_33 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$26, "Not Found");
  var self$27 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_MethodNotAllowed);
  var $x_32 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$27, "Method Not Allowed");
  var self$28 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_NotAcceptable);
  var $x_31 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$28, "Not Acceptable");
  var self$29 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_ProxyAuthenticationRequired);
  var $x_30 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$29, "Proxy Authentication Required");
  var self$30 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_RequestTimeout);
  var $x_29 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$30, "Request Timeout");
  var self$31 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_Conflict);
  var $x_28 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$31, "Conflict");
  var self$32 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_Gone);
  var $x_27 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$32, "Gone");
  var self$33 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_LengthRequired);
  var $x_26 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$33, "Length Required");
  var self$34 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_PreconditionFailed);
  var $x_25 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$34, "Precondition Failed");
  var self$35 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_PayloadTooLarge);
  var $x_24 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$35, "Payload Too Large");
  var self$36 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_UriTooLong);
  var $x_23 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$36, "Uri Too Long");
  var self$37 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_UnsupportedMediaType);
  var $x_22 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$37, "Unsupported MediaType");
  var self$38 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_RangeNotSatisfiable);
  var $x_21 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$38, "Range Not Satisfiable");
  var self$39 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_ExpectationFailed);
  var $x_20 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$39, "Expectation Failed");
  var self$40 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_MisdirectedRequest);
  var $x_19 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$40, "Misdirected Request");
  var self$41 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_UnprocessableEntity);
  var $x_18 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$41, "Unprocessable Entity");
  var self$42 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_Locked);
  var $x_17 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$42, "Locked");
  var self$43 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_FailedDependency);
  var $x_16 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$43, "Failed Dependency");
  var self$44 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_UpgradeRequired);
  var $x_15 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$44, "Upgrade Required");
  var self$45 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_PreconditionRequired);
  var $x_14 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$45, "Precondition Required");
  var self$46 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_TooManyRequests);
  var $x_13 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$46, "Too Many Requests");
  var self$47 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_RequestHeaderFieldsTooLarge);
  var $x_12 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$47, "RequestHeader Fields Too Large");
  var self$48 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_UnavailableForLegalReasons);
  var $x_11 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$48, "Unavailable For Legal Reasons");
  var self$49 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_InternalServerError);
  var $x_10 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$49, "Internal Server Error");
  var self$50 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_NotImplemented);
  var $x_9 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$50, "Not Implemented");
  var self$51 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_BadGateway);
  var $x_8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$51, "Bad Gateway");
  var self$52 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_ServiceUnavailable);
  var $x_7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$52, "Service Unavailable");
  var self$53 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_GatewayTimeout);
  var $x_6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$53, "Gateway Timeout");
  var self$54 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_HttpVersionNotSupported);
  var $x_5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$54, "Http Version Not Supported");
  var self$55 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_VariantAlsoNegotiates);
  var $x_4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$55, "Variant Also Negotiates");
  var self$56 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_InsufficientStorage);
  var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$56, "Insufficient Storage");
  var self$57 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_LoopDetected);
  var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$57, "Loop Detected");
  var self$58 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_NotExtended);
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$58, "Not Extended");
  var self$59 = new $c_Lsttp_model_StatusCode($m_Lsttp_model_StatusCode$().Lsttp_model_StatusCode$__f_NetworkAuthenticationRequired);
  var elems = $x_60.wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T2.getArrayOf().constr)([$x_59, $x_58, $x_57, $x_56, $x_55, $x_54, $x_53, $x_52, $x_51, $x_50, $x_49, $x_48, $x_47, $x_46, $x_45, $x_44, $x_43, $x_42, $x_41, $x_40, $x_39, $x_38, $x_37, $x_36, $x_35, $x_34, $x_33, $x_32, $x_31, $x_30, $x_29, $x_28, $x_27, $x_26, $x_25, $x_24, $x_23, $x_22, $x_21, $x_20, $x_19, $x_18, $x_17, $x_16, $x_15, $x_14, $x_13, $x_12, $x_11, $x_10, $x_9, $x_8, $x_7, $x_6, $x_5, $x_4, $x_3, $x_2, $x_1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$59, "Network Authentication Required")]));
  this.Lsttp_model_StatusText$__f_statusTexts = this$121.from__sc_IterableOnce__sci_Map(elems);
}
export { $c_Lsttp_model_StatusText$ as $c_Lsttp_model_StatusText$ };
$c_Lsttp_model_StatusText$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_model_StatusText$.prototype.constructor = $c_Lsttp_model_StatusText$;
/** @constructor */
function $h_Lsttp_model_StatusText$() {
}
export { $h_Lsttp_model_StatusText$ as $h_Lsttp_model_StatusText$ };
$h_Lsttp_model_StatusText$.prototype = $c_Lsttp_model_StatusText$.prototype;
$c_Lsttp_model_StatusText$.prototype.default__I__s_Option = (function(statusCode) {
  return this.Lsttp_model_StatusText$__f_statusTexts.get__O__s_Option(new $c_Lsttp_model_StatusCode(statusCode));
});
$c_Lsttp_model_StatusText$.prototype.fromProduct__s_Product__Lsttp_model_StatusText = (function(x$0) {
  return new $c_Lsttp_model_StatusText(x$0.productElement__I__O(0));
});
$c_Lsttp_model_StatusText$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lsttp_model_StatusText(p);
});
var $d_Lsttp_model_StatusText$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_model_StatusText$, "sttp.model.StatusText$", ({
  Lsttp_model_StatusText$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lsttp_model_StatusText$ as $d_Lsttp_model_StatusText$ };
var $n_Lsttp_model_StatusText$;
function $m_Lsttp_model_StatusText$() {
  if ((!$n_Lsttp_model_StatusText$)) {
    $n_Lsttp_model_StatusText$ = new $c_Lsttp_model_StatusText$();
  }
  return $n_Lsttp_model_StatusText$;
}
export { $m_Lsttp_model_StatusText$ as $m_Lsttp_model_StatusText$ };
/** @constructor */
function $c_Lsttp_model_headers_WWWAuthenticateChallenge$() {
  $n_Lsttp_model_headers_WWWAuthenticateChallenge$ = this;
  $m_Lsttp_model_headers_AuthenticationScheme$Digest$();
}
export { $c_Lsttp_model_headers_WWWAuthenticateChallenge$ as $c_Lsttp_model_headers_WWWAuthenticateChallenge$ };
$c_Lsttp_model_headers_WWWAuthenticateChallenge$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_model_headers_WWWAuthenticateChallenge$.prototype.constructor = $c_Lsttp_model_headers_WWWAuthenticateChallenge$;
/** @constructor */
function $h_Lsttp_model_headers_WWWAuthenticateChallenge$() {
}
export { $h_Lsttp_model_headers_WWWAuthenticateChallenge$ as $h_Lsttp_model_headers_WWWAuthenticateChallenge$ };
$h_Lsttp_model_headers_WWWAuthenticateChallenge$.prototype = $c_Lsttp_model_headers_WWWAuthenticateChallenge$.prototype;
$c_Lsttp_model_headers_WWWAuthenticateChallenge$.prototype.fromProduct__s_Product__Lsttp_model_headers_WWWAuthenticateChallenge = (function(x$0) {
  return new $c_Lsttp_model_headers_WWWAuthenticateChallenge(x$0.productElement__I__O(0), x$0.productElement__I__O(1));
});
$c_Lsttp_model_headers_WWWAuthenticateChallenge$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lsttp_model_headers_WWWAuthenticateChallenge(p);
});
var $d_Lsttp_model_headers_WWWAuthenticateChallenge$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_model_headers_WWWAuthenticateChallenge$, "sttp.model.headers.WWWAuthenticateChallenge$", ({
  Lsttp_model_headers_WWWAuthenticateChallenge$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lsttp_model_headers_WWWAuthenticateChallenge$ as $d_Lsttp_model_headers_WWWAuthenticateChallenge$ };
var $n_Lsttp_model_headers_WWWAuthenticateChallenge$;
function $m_Lsttp_model_headers_WWWAuthenticateChallenge$() {
  if ((!$n_Lsttp_model_headers_WWWAuthenticateChallenge$)) {
    $n_Lsttp_model_headers_WWWAuthenticateChallenge$ = new $c_Lsttp_model_headers_WWWAuthenticateChallenge$();
  }
  return $n_Lsttp_model_headers_WWWAuthenticateChallenge$;
}
export { $m_Lsttp_model_headers_WWWAuthenticateChallenge$ as $m_Lsttp_model_headers_WWWAuthenticateChallenge$ };
function $f_Lsttp_tapir_EndpointInput__and__Lsttp_tapir_EndpointInput__Lsttp_tapir_typelevel_ParamConcat__Lsttp_tapir_EndpointInput($thiz, other, concat) {
  var combine = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_internal_package$().mkCombine__Lsttp_tapir_typelevel_BinaryTupleOp__F2(concat);
  var split = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_internal_package$().mkSplit__Lsttp_tapir_typelevel_BinaryTupleOp__F1(concat);
  return new $c_Lsttp_tapir_EndpointInput$Pair($thiz, other, combine, split);
}
export { $f_Lsttp_tapir_EndpointInput__and__Lsttp_tapir_EndpointInput__Lsttp_tapir_typelevel_ParamConcat__Lsttp_tapir_EndpointInput as $f_Lsttp_tapir_EndpointInput__and__Lsttp_tapir_EndpointInput__Lsttp_tapir_typelevel_ParamConcat__Lsttp_tapir_EndpointInput };
/** @constructor */
function $c_Lsttp_tapir_EndpointInput$AuthInfo$() {
  this.Lsttp_tapir_EndpointInput$AuthInfo$__f_Empty = null;
  $n_Lsttp_tapir_EndpointInput$AuthInfo$ = this;
  $m_Lsttp_tapir_EndpointInput$AuthInfo$();
  var securitySchemeName = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var description = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var attributes = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  var group = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var bearerFormat = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  this.Lsttp_tapir_EndpointInput$AuthInfo$__f_Empty = new $c_Lsttp_tapir_EndpointInput$AuthInfo(securitySchemeName, description, attributes, group, bearerFormat);
}
export { $c_Lsttp_tapir_EndpointInput$AuthInfo$ as $c_Lsttp_tapir_EndpointInput$AuthInfo$ };
$c_Lsttp_tapir_EndpointInput$AuthInfo$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_EndpointInput$AuthInfo$.prototype.constructor = $c_Lsttp_tapir_EndpointInput$AuthInfo$;
/** @constructor */
function $h_Lsttp_tapir_EndpointInput$AuthInfo$() {
}
export { $h_Lsttp_tapir_EndpointInput$AuthInfo$ as $h_Lsttp_tapir_EndpointInput$AuthInfo$ };
$h_Lsttp_tapir_EndpointInput$AuthInfo$.prototype = $c_Lsttp_tapir_EndpointInput$AuthInfo$.prototype;
$c_Lsttp_tapir_EndpointInput$AuthInfo$.prototype.fromProduct__s_Product__Lsttp_tapir_EndpointInput$AuthInfo = (function(x$0) {
  return new $c_Lsttp_tapir_EndpointInput$AuthInfo(x$0.productElement__I__O(0), x$0.productElement__I__O(1), x$0.productElement__I__O(2), x$0.productElement__I__O(3), x$0.productElement__I__O(4));
});
$c_Lsttp_tapir_EndpointInput$AuthInfo$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lsttp_tapir_EndpointInput$AuthInfo(p);
});
var $d_Lsttp_tapir_EndpointInput$AuthInfo$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_EndpointInput$AuthInfo$, "sttp.tapir.EndpointInput$AuthInfo$", ({
  Lsttp_tapir_EndpointInput$AuthInfo$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lsttp_tapir_EndpointInput$AuthInfo$ as $d_Lsttp_tapir_EndpointInput$AuthInfo$ };
var $n_Lsttp_tapir_EndpointInput$AuthInfo$;
function $m_Lsttp_tapir_EndpointInput$AuthInfo$() {
  if ((!$n_Lsttp_tapir_EndpointInput$AuthInfo$)) {
    $n_Lsttp_tapir_EndpointInput$AuthInfo$ = new $c_Lsttp_tapir_EndpointInput$AuthInfo$();
  }
  return $n_Lsttp_tapir_EndpointInput$AuthInfo$;
}
export { $m_Lsttp_tapir_EndpointInput$AuthInfo$ as $m_Lsttp_tapir_EndpointInput$AuthInfo$ };
function $f_Lsttp_tapir_EndpointOutput__and__Lsttp_tapir_EndpointOutput__Lsttp_tapir_typelevel_ParamConcat__Lsttp_tapir_EndpointOutput($thiz, other, concat) {
  var combine = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_internal_package$().mkCombine__Lsttp_tapir_typelevel_BinaryTupleOp__F2(concat);
  var split = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_internal_package$().mkSplit__Lsttp_tapir_typelevel_BinaryTupleOp__F1(concat);
  return new $c_Lsttp_tapir_EndpointOutput$Pair($thiz, other, combine, split);
}
export { $f_Lsttp_tapir_EndpointOutput__and__Lsttp_tapir_EndpointOutput__Lsttp_tapir_typelevel_ParamConcat__Lsttp_tapir_EndpointOutput as $f_Lsttp_tapir_EndpointOutput__and__Lsttp_tapir_EndpointOutput__Lsttp_tapir_typelevel_ParamConcat__Lsttp_tapir_EndpointOutput };
/** @constructor */
function $c_Lsttp_tapir_client_sttp_SttpClientInterpreter$$anon$1(clientOptions$2) {
  this.Lsttp_tapir_client_sttp_SttpClientInterpreter$$anon$1__f_clientOptions$1 = null;
  this.Lsttp_tapir_client_sttp_SttpClientInterpreter$$anon$1__f_clientOptions$1 = clientOptions$2;
}
export { $c_Lsttp_tapir_client_sttp_SttpClientInterpreter$$anon$1 as $c_Lsttp_tapir_client_sttp_SttpClientInterpreter$$anon$1 };
$c_Lsttp_tapir_client_sttp_SttpClientInterpreter$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_client_sttp_SttpClientInterpreter$$anon$1.prototype.constructor = $c_Lsttp_tapir_client_sttp_SttpClientInterpreter$$anon$1;
/** @constructor */
function $h_Lsttp_tapir_client_sttp_SttpClientInterpreter$$anon$1() {
}
export { $h_Lsttp_tapir_client_sttp_SttpClientInterpreter$$anon$1 as $h_Lsttp_tapir_client_sttp_SttpClientInterpreter$$anon$1 };
$h_Lsttp_tapir_client_sttp_SttpClientInterpreter$$anon$1.prototype = $c_Lsttp_tapir_client_sttp_SttpClientInterpreter$$anon$1.prototype;
var $d_Lsttp_tapir_client_sttp_SttpClientInterpreter$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_client_sttp_SttpClientInterpreter$$anon$1, "sttp.tapir.client.sttp.SttpClientInterpreter$$anon$1", ({
  Lsttp_tapir_client_sttp_SttpClientInterpreter$$anon$1: 1,
  Lsttp_tapir_client_sttp_SttpClientInterpreterExtensions: 1,
  Lsttp_tapir_client_sttp_SttpClientInterpreter: 1
}));
export { $d_Lsttp_tapir_client_sttp_SttpClientInterpreter$$anon$1 as $d_Lsttp_tapir_client_sttp_SttpClientInterpreter$$anon$1 };
/** @constructor */
function $c_Lsttp_tapir_client_sttp_SttpClientOptions$() {
  this.Lsttp_tapir_client_sttp_SttpClientOptions$__f_default = null;
  $n_Lsttp_tapir_client_sttp_SttpClientOptions$ = this;
  $m_Lsttp_tapir_client_sttp_SttpClientOptions$();
  var createFile = $m_Lsttp_tapir_Defaults$().createTempFile__F0();
  this.Lsttp_tapir_client_sttp_SttpClientOptions$__f_default = new $c_Lsttp_tapir_client_sttp_SttpClientOptions(createFile);
}
export { $c_Lsttp_tapir_client_sttp_SttpClientOptions$ as $c_Lsttp_tapir_client_sttp_SttpClientOptions$ };
$c_Lsttp_tapir_client_sttp_SttpClientOptions$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_client_sttp_SttpClientOptions$.prototype.constructor = $c_Lsttp_tapir_client_sttp_SttpClientOptions$;
/** @constructor */
function $h_Lsttp_tapir_client_sttp_SttpClientOptions$() {
}
export { $h_Lsttp_tapir_client_sttp_SttpClientOptions$ as $h_Lsttp_tapir_client_sttp_SttpClientOptions$ };
$h_Lsttp_tapir_client_sttp_SttpClientOptions$.prototype = $c_Lsttp_tapir_client_sttp_SttpClientOptions$.prototype;
$c_Lsttp_tapir_client_sttp_SttpClientOptions$.prototype.fromProduct__s_Product__Lsttp_tapir_client_sttp_SttpClientOptions = (function(x$0) {
  return new $c_Lsttp_tapir_client_sttp_SttpClientOptions(x$0.productElement__I__O(0));
});
$c_Lsttp_tapir_client_sttp_SttpClientOptions$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lsttp_tapir_client_sttp_SttpClientOptions(p);
});
var $d_Lsttp_tapir_client_sttp_SttpClientOptions$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_client_sttp_SttpClientOptions$, "sttp.tapir.client.sttp.SttpClientOptions$", ({
  Lsttp_tapir_client_sttp_SttpClientOptions$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lsttp_tapir_client_sttp_SttpClientOptions$ as $d_Lsttp_tapir_client_sttp_SttpClientOptions$ };
var $n_Lsttp_tapir_client_sttp_SttpClientOptions$;
function $m_Lsttp_tapir_client_sttp_SttpClientOptions$() {
  if ((!$n_Lsttp_tapir_client_sttp_SttpClientOptions$)) {
    $n_Lsttp_tapir_client_sttp_SttpClientOptions$ = new $c_Lsttp_tapir_client_sttp_SttpClientOptions$();
  }
  return $n_Lsttp_tapir_client_sttp_SttpClientOptions$;
}
export { $m_Lsttp_tapir_client_sttp_SttpClientOptions$ as $m_Lsttp_tapir_client_sttp_SttpClientOptions$ };
/** @constructor */
function $c_Lsttp_tapir_typelevel_LowPriorityTupleConcat0$$anon$12() {
}
export { $c_Lsttp_tapir_typelevel_LowPriorityTupleConcat0$$anon$12 as $c_Lsttp_tapir_typelevel_LowPriorityTupleConcat0$$anon$12 };
$c_Lsttp_tapir_typelevel_LowPriorityTupleConcat0$$anon$12.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_typelevel_LowPriorityTupleConcat0$$anon$12.prototype.constructor = $c_Lsttp_tapir_typelevel_LowPriorityTupleConcat0$$anon$12;
/** @constructor */
function $h_Lsttp_tapir_typelevel_LowPriorityTupleConcat0$$anon$12() {
}
export { $h_Lsttp_tapir_typelevel_LowPriorityTupleConcat0$$anon$12 as $h_Lsttp_tapir_typelevel_LowPriorityTupleConcat0$$anon$12 };
$h_Lsttp_tapir_typelevel_LowPriorityTupleConcat0$$anon$12.prototype = $c_Lsttp_tapir_typelevel_LowPriorityTupleConcat0$$anon$12.prototype;
$c_Lsttp_tapir_typelevel_LowPriorityTupleConcat0$$anon$12.prototype.leftArity__I = (function() {
  return 1;
});
$c_Lsttp_tapir_typelevel_LowPriorityTupleConcat0$$anon$12.prototype.rightArity__I = (function() {
  return 1;
});
var $d_Lsttp_tapir_typelevel_LowPriorityTupleConcat0$$anon$12 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_typelevel_LowPriorityTupleConcat0$$anon$12, "sttp.tapir.typelevel.LowPriorityTupleConcat0$$anon$12", ({
  Lsttp_tapir_typelevel_LowPriorityTupleConcat0$$anon$12: 1,
  Lsttp_tapir_typelevel_BinaryTupleOp: 1,
  Lsttp_tapir_typelevel_ParamConcat: 1
}));
export { $d_Lsttp_tapir_typelevel_LowPriorityTupleConcat0$$anon$12 as $d_Lsttp_tapir_typelevel_LowPriorityTupleConcat0$$anon$12 };
/** @constructor */
function $c_Lsttp_tapir_typelevel_LowPriorityTupleConcat3$$anon$7(ta$5) {
  this.Lsttp_tapir_typelevel_LowPriorityTupleConcat3$$anon$7__f_ta$1 = null;
  this.Lsttp_tapir_typelevel_LowPriorityTupleConcat3$$anon$7__f_ta$1 = ta$5;
}
export { $c_Lsttp_tapir_typelevel_LowPriorityTupleConcat3$$anon$7 as $c_Lsttp_tapir_typelevel_LowPriorityTupleConcat3$$anon$7 };
$c_Lsttp_tapir_typelevel_LowPriorityTupleConcat3$$anon$7.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_typelevel_LowPriorityTupleConcat3$$anon$7.prototype.constructor = $c_Lsttp_tapir_typelevel_LowPriorityTupleConcat3$$anon$7;
/** @constructor */
function $h_Lsttp_tapir_typelevel_LowPriorityTupleConcat3$$anon$7() {
}
export { $h_Lsttp_tapir_typelevel_LowPriorityTupleConcat3$$anon$7 as $h_Lsttp_tapir_typelevel_LowPriorityTupleConcat3$$anon$7 };
$h_Lsttp_tapir_typelevel_LowPriorityTupleConcat3$$anon$7.prototype = $c_Lsttp_tapir_typelevel_LowPriorityTupleConcat3$$anon$7.prototype;
$c_Lsttp_tapir_typelevel_LowPriorityTupleConcat3$$anon$7.prototype.leftArity__I = (function() {
  return this.Lsttp_tapir_typelevel_LowPriorityTupleConcat3$$anon$7__f_ta$1.arity__I();
});
$c_Lsttp_tapir_typelevel_LowPriorityTupleConcat3$$anon$7.prototype.rightArity__I = (function() {
  return 0;
});
var $d_Lsttp_tapir_typelevel_LowPriorityTupleConcat3$$anon$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_typelevel_LowPriorityTupleConcat3$$anon$7, "sttp.tapir.typelevel.LowPriorityTupleConcat3$$anon$7", ({
  Lsttp_tapir_typelevel_LowPriorityTupleConcat3$$anon$7: 1,
  Lsttp_tapir_typelevel_BinaryTupleOp: 1,
  Lsttp_tapir_typelevel_ParamConcat: 1
}));
export { $d_Lsttp_tapir_typelevel_LowPriorityTupleConcat3$$anon$7 as $d_Lsttp_tapir_typelevel_LowPriorityTupleConcat3$$anon$7 };
/** @constructor */
function $c_Lsttp_tapir_typelevel_LowPriorityTupleConcat4$$anon$5(ua$5) {
  this.Lsttp_tapir_typelevel_LowPriorityTupleConcat4$$anon$5__f_ua$1 = null;
  this.Lsttp_tapir_typelevel_LowPriorityTupleConcat4$$anon$5__f_ua$1 = ua$5;
}
export { $c_Lsttp_tapir_typelevel_LowPriorityTupleConcat4$$anon$5 as $c_Lsttp_tapir_typelevel_LowPriorityTupleConcat4$$anon$5 };
$c_Lsttp_tapir_typelevel_LowPriorityTupleConcat4$$anon$5.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_typelevel_LowPriorityTupleConcat4$$anon$5.prototype.constructor = $c_Lsttp_tapir_typelevel_LowPriorityTupleConcat4$$anon$5;
/** @constructor */
function $h_Lsttp_tapir_typelevel_LowPriorityTupleConcat4$$anon$5() {
}
export { $h_Lsttp_tapir_typelevel_LowPriorityTupleConcat4$$anon$5 as $h_Lsttp_tapir_typelevel_LowPriorityTupleConcat4$$anon$5 };
$h_Lsttp_tapir_typelevel_LowPriorityTupleConcat4$$anon$5.prototype = $c_Lsttp_tapir_typelevel_LowPriorityTupleConcat4$$anon$5.prototype;
$c_Lsttp_tapir_typelevel_LowPriorityTupleConcat4$$anon$5.prototype.leftArity__I = (function() {
  return 0;
});
$c_Lsttp_tapir_typelevel_LowPriorityTupleConcat4$$anon$5.prototype.rightArity__I = (function() {
  return this.Lsttp_tapir_typelevel_LowPriorityTupleConcat4$$anon$5__f_ua$1.arity__I();
});
var $d_Lsttp_tapir_typelevel_LowPriorityTupleConcat4$$anon$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_typelevel_LowPriorityTupleConcat4$$anon$5, "sttp.tapir.typelevel.LowPriorityTupleConcat4$$anon$5", ({
  Lsttp_tapir_typelevel_LowPriorityTupleConcat4$$anon$5: 1,
  Lsttp_tapir_typelevel_BinaryTupleOp: 1,
  Lsttp_tapir_typelevel_ParamConcat: 1
}));
export { $d_Lsttp_tapir_typelevel_LowPriorityTupleConcat4$$anon$5 as $d_Lsttp_tapir_typelevel_LowPriorityTupleConcat4$$anon$5 };
/** @constructor */
function $c_Lsttp_tapir_typelevel_ParamConcat$$anon$1() {
}
export { $c_Lsttp_tapir_typelevel_ParamConcat$$anon$1 as $c_Lsttp_tapir_typelevel_ParamConcat$$anon$1 };
$c_Lsttp_tapir_typelevel_ParamConcat$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_typelevel_ParamConcat$$anon$1.prototype.constructor = $c_Lsttp_tapir_typelevel_ParamConcat$$anon$1;
/** @constructor */
function $h_Lsttp_tapir_typelevel_ParamConcat$$anon$1() {
}
export { $h_Lsttp_tapir_typelevel_ParamConcat$$anon$1 as $h_Lsttp_tapir_typelevel_ParamConcat$$anon$1 };
$h_Lsttp_tapir_typelevel_ParamConcat$$anon$1.prototype = $c_Lsttp_tapir_typelevel_ParamConcat$$anon$1.prototype;
$c_Lsttp_tapir_typelevel_ParamConcat$$anon$1.prototype.leftArity__I = (function() {
  return 0;
});
$c_Lsttp_tapir_typelevel_ParamConcat$$anon$1.prototype.rightArity__I = (function() {
  return 0;
});
var $d_Lsttp_tapir_typelevel_ParamConcat$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_typelevel_ParamConcat$$anon$1, "sttp.tapir.typelevel.ParamConcat$$anon$1", ({
  Lsttp_tapir_typelevel_ParamConcat$$anon$1: 1,
  Lsttp_tapir_typelevel_BinaryTupleOp: 1,
  Lsttp_tapir_typelevel_ParamConcat: 1
}));
export { $d_Lsttp_tapir_typelevel_ParamConcat$$anon$1 as $d_Lsttp_tapir_typelevel_ParamConcat$$anon$1 };
/** @constructor */
function $c_Lurldsl_language_PathSegment$$anon$1(matching$3, creating$3, outer) {
  this.Lurldsl_language_PathSegment$$anon$1__f_matching$1 = null;
  this.Lurldsl_language_PathSegment$$anon$1__f_creating$1 = null;
  this.Lurldsl_language_PathSegment$$anon$1__f_matching$1 = matching$3;
  this.Lurldsl_language_PathSegment$$anon$1__f_creating$1 = creating$3;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lurldsl_language_PathSegment$$anon$1 as $c_Lurldsl_language_PathSegment$$anon$1 };
$c_Lurldsl_language_PathSegment$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lurldsl_language_PathSegment$$anon$1.prototype.constructor = $c_Lurldsl_language_PathSegment$$anon$1;
/** @constructor */
function $h_Lurldsl_language_PathSegment$$anon$1() {
}
export { $h_Lurldsl_language_PathSegment$$anon$1 as $h_Lurldsl_language_PathSegment$$anon$1 };
$h_Lurldsl_language_PathSegment$$anon$1.prototype = $c_Lurldsl_language_PathSegment$$anon$1.prototype;
$c_Lurldsl_language_PathSegment$$anon$1.prototype.matchSegments__sci_List__s_util_Either = (function(segments) {
  return this.Lurldsl_language_PathSegment$$anon$1__f_matching$1.apply__O__O(segments);
});
$c_Lurldsl_language_PathSegment$$anon$1.prototype.createSegments__O__sci_List = (function(t) {
  return this.Lurldsl_language_PathSegment$$anon$1__f_creating$1.apply__O__O(t);
});
var $d_Lurldsl_language_PathSegment$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lurldsl_language_PathSegment$$anon$1, "urldsl.language.PathSegment$$anon$1", ({
  Lurldsl_language_PathSegment$$anon$1: 1,
  Lurldsl_language_UrlPart: 1,
  Lurldsl_language_PathSegment: 1
}));
export { $d_Lurldsl_language_PathSegment$$anon$1 as $d_Lurldsl_language_PathSegment$$anon$1 };
/** @constructor */
function $c_Lurldsl_language_QueryParameters$$anon$1(matching$3, creating$2, outer) {
  this.Lurldsl_language_QueryParameters$$anon$1__f_matching$1 = null;
  this.Lurldsl_language_QueryParameters$$anon$1__f_creating$1 = null;
  this.Lurldsl_language_QueryParameters$$anon$1__f_matching$1 = matching$3;
  this.Lurldsl_language_QueryParameters$$anon$1__f_creating$1 = creating$2;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lurldsl_language_QueryParameters$$anon$1 as $c_Lurldsl_language_QueryParameters$$anon$1 };
$c_Lurldsl_language_QueryParameters$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lurldsl_language_QueryParameters$$anon$1.prototype.constructor = $c_Lurldsl_language_QueryParameters$$anon$1;
/** @constructor */
function $h_Lurldsl_language_QueryParameters$$anon$1() {
}
export { $h_Lurldsl_language_QueryParameters$$anon$1 as $h_Lurldsl_language_QueryParameters$$anon$1 };
$h_Lurldsl_language_QueryParameters$$anon$1.prototype = $c_Lurldsl_language_QueryParameters$$anon$1.prototype;
$c_Lurldsl_language_QueryParameters$$anon$1.prototype.matchParams__sci_Map__s_util_Either = (function(params) {
  return this.Lurldsl_language_QueryParameters$$anon$1__f_matching$1.apply__O__O(params);
});
$c_Lurldsl_language_QueryParameters$$anon$1.prototype.createParams__O__sci_Map = (function(q) {
  return this.Lurldsl_language_QueryParameters$$anon$1__f_creating$1.apply__O__O(q);
});
var $d_Lurldsl_language_QueryParameters$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lurldsl_language_QueryParameters$$anon$1, "urldsl.language.QueryParameters$$anon$1", ({
  Lurldsl_language_QueryParameters$$anon$1: 1,
  Lurldsl_language_UrlPart: 1,
  Lurldsl_language_QueryParameters: 1
}));
export { $d_Lurldsl_language_QueryParameters$$anon$1 as $d_Lurldsl_language_QueryParameters$$anon$1 };
/** @constructor */
function $c_Lurldsl_url_JSUrlStringParser(rawUrl) {
  this.Lurldsl_url_JSUrlStringParser__f_urlParser = null;
  this.Lurldsl_url_JSUrlStringParser__f_urlParser = new URL(rawUrl);
}
export { $c_Lurldsl_url_JSUrlStringParser as $c_Lurldsl_url_JSUrlStringParser };
$c_Lurldsl_url_JSUrlStringParser.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lurldsl_url_JSUrlStringParser.prototype.constructor = $c_Lurldsl_url_JSUrlStringParser;
/** @constructor */
function $h_Lurldsl_url_JSUrlStringParser() {
}
export { $h_Lurldsl_url_JSUrlStringParser as $h_Lurldsl_url_JSUrlStringParser };
$h_Lurldsl_url_JSUrlStringParser.prototype = $c_Lurldsl_url_JSUrlStringParser.prototype;
$c_Lurldsl_url_JSUrlStringParser.prototype.queryParametersString__T = (function() {
  var x = this.Lurldsl_url_JSUrlStringParser__f_urlParser.search;
  _return: {
    var len = x.length;
    var i = 0;
    while ((i < len)) {
      var index = i;
      var x0 = x.charCodeAt(index);
      if ((x0 !== 63)) {
        var x1 = i;
        break _return;
      }
      i = ((1 + i) | 0);
    }
    var x1 = (-1);
  }
  return ((x1 === (-1)) ? "" : x.substring(x1));
});
$c_Lurldsl_url_JSUrlStringParser.prototype.path__T = (function() {
  return this.Lurldsl_url_JSUrlStringParser__f_urlParser.pathname;
});
$c_Lurldsl_url_JSUrlStringParser.prototype.decode__T__T__T = (function(str, encoding) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$dp_toString__T(decodeURIComponent(str));
});
var $d_Lurldsl_url_JSUrlStringParser = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lurldsl_url_JSUrlStringParser, "urldsl.url.JSUrlStringParser", ({
  Lurldsl_url_JSUrlStringParser: 1,
  Lurldsl_url_UrlStringDecoder: 1,
  Lurldsl_url_UrlStringParser: 1
}));
export { $d_Lurldsl_url_JSUrlStringParser as $d_Lurldsl_url_JSUrlStringParser };
/** @constructor */
function $c_Lyantl_Make$$anon$1(f$4, outer) {
  this.Lyantl_Make$$anon$1__f_f$1 = null;
  this.Lyantl_Make$$anon$1__f_$outer = null;
  this.Lyantl_Make$$anon$1__f_f$1 = f$4;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lyantl_Make$$anon$1__f_$outer = outer;
}
export { $c_Lyantl_Make$$anon$1 as $c_Lyantl_Make$$anon$1 };
$c_Lyantl_Make$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lyantl_Make$$anon$1.prototype.constructor = $c_Lyantl_Make$$anon$1;
/** @constructor */
function $h_Lyantl_Make$$anon$1() {
}
export { $h_Lyantl_Make$$anon$1 as $h_Lyantl_Make$$anon$1 };
$h_Lyantl_Make$$anon$1.prototype = $c_Lyantl_Make$$anon$1.prototype;
$c_Lyantl_Make$$anon$1.prototype.validate__O__sci_Vector = (function(input) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Make__validate__O__sci_Vector(this, input);
});
$c_Lyantl_Make$$anon$1.prototype.apply__O__s_util_Either = (function(input) {
  return this.Lyantl_Make$$anon$1__f_$outer.apply__O__s_util_Either(this.Lyantl_Make$$anon$1__f_f$1.apply__O__O(input));
});
var $d_Lyantl_Make$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lyantl_Make$$anon$1, "yantl.Make$$anon$1", ({
  Lyantl_Make$$anon$1: 1,
  Lyantl_Validate: 1,
  Lyantl_Make: 1
}));
export { $d_Lyantl_Make$$anon$1 as $d_Lyantl_Make$$anon$1 };
/** @constructor */
function $c_Lalleycats_Empty$() {
}
export { $c_Lalleycats_Empty$ as $c_Lalleycats_Empty$ };
$c_Lalleycats_Empty$.prototype = new $h_Lalleycats_compat_IterableEmptyInstance();
$c_Lalleycats_Empty$.prototype.constructor = $c_Lalleycats_Empty$;
/** @constructor */
function $h_Lalleycats_Empty$() {
}
export { $h_Lalleycats_Empty$ as $h_Lalleycats_Empty$ };
$h_Lalleycats_Empty$.prototype = $c_Lalleycats_Empty$.prototype;
var $d_Lalleycats_Empty$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lalleycats_Empty$, "alleycats.Empty$", ({
  Lalleycats_Empty$: 1,
  Lalleycats_compat_IterableEmptyInstance: 1,
  Lalleycats_EmptyInstances1: 1,
  Lalleycats_EmptyInstances0: 1
}));
export { $d_Lalleycats_Empty$ as $d_Lalleycats_Empty$ };
var $n_Lalleycats_Empty$;
function $m_Lalleycats_Empty$() {
  if ((!$n_Lalleycats_Empty$)) {
    $n_Lalleycats_Empty$ = new $c_Lalleycats_Empty$();
  }
  return $n_Lalleycats_Empty$;
}
export { $m_Lalleycats_Empty$ as $m_Lalleycats_Empty$ };
/** @constructor */
function $c_Lcats_data_EitherT(value) {
  this.Lcats_data_EitherT__f_value = null;
  this.Lcats_data_EitherT__f_value = value;
}
export { $c_Lcats_data_EitherT as $c_Lcats_data_EitherT };
$c_Lcats_data_EitherT.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_data_EitherT.prototype.constructor = $c_Lcats_data_EitherT;
/** @constructor */
function $h_Lcats_data_EitherT() {
}
export { $h_Lcats_data_EitherT as $h_Lcats_data_EitherT };
$h_Lcats_data_EitherT.prototype = $c_Lcats_data_EitherT.prototype;
$c_Lcats_data_EitherT.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_data_EitherT.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_data_EitherT.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_data_EitherT)) {
    var x = this.Lcats_data_EitherT__f_value;
    var y = x$0.Lcats_data_EitherT__f_value;
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_data_EitherT.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_data_EitherT.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_data_EitherT.prototype.productPrefix__T = (function() {
  return "EitherT";
});
$c_Lcats_data_EitherT.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_EitherT__f_value;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_data_EitherT.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_data_EitherT.prototype.valueOrF__F1__Lcats_Monad__O = (function(f, F) {
  return F.flatMap__O__F1__O(this.Lcats_data_EitherT__f_value, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
      var a = x$1.s_util_Left__f_value;
      return f.apply__O__O(a);
    }
    if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
      var b = x$1.s_util_Right__f_value;
      return F.pure__O__O(b);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  })));
});
$c_Lcats_data_EitherT.prototype.bimap__F1__F1__Lcats_Functor__Lcats_data_EitherT = (function(fa, fb, F) {
  var value$2 = F.map__O__F1__O(this.Lcats_data_EitherT__f_value, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
      var b = x$1.s_util_Right__f_value;
      var value = fb.apply__O__O(b);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value);
    }
    if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
      var a = x$1.s_util_Left__f_value;
      var value$1 = fa.apply__O__O(a);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value$1);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  })));
  return new $c_Lcats_data_EitherT(value$2);
});
$c_Lcats_data_EitherT.prototype.flatMap__F1__Lcats_Monad__Lcats_data_EitherT = (function(f, F) {
  var value = F.flatMap__O__F1__O(this.Lcats_data_EitherT__f_value, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
      return F.pure__O__O(($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_syntax_EitherUtil$(), x$1));
    }
    if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
      var b = x$1.s_util_Right__f_value;
      return f.apply__O__O(b).Lcats_data_EitherT__f_value;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  })));
  return new $c_Lcats_data_EitherT(value);
});
$c_Lcats_data_EitherT.prototype.map__F1__Lcats_Functor__Lcats_data_EitherT = (function(f, F) {
  return this.bimap__F1__F1__Lcats_Functor__Lcats_data_EitherT(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x) => x)), f, F);
});
$c_Lcats_data_EitherT.prototype.mapK__Lcats_arrow_FunctionK__Lcats_data_EitherT = (function(f) {
  var value = f.apply__O__O(this.Lcats_data_EitherT__f_value);
  return new $c_Lcats_data_EitherT(value);
});
$c_Lcats_data_EitherT.prototype.semiflatMap__F1__Lcats_Monad__Lcats_data_EitherT = (function(f, F) {
  return this.flatMap__F1__Lcats_Monad__Lcats_data_EitherT(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((b) => $m_Lcats_data_EitherT$RightPartiallyApplied$().apply$extension__Z__O__Lcats_Functor__Lcats_data_EitherT(true, f.apply__O__O(b), F))), F);
});
$c_Lcats_data_EitherT.prototype.leftMap__F1__Lcats_Functor__Lcats_data_EitherT = (function(f, F) {
  return this.bimap__F1__F1__Lcats_Functor__Lcats_data_EitherT(f, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x) => x)), F);
});
$c_Lcats_data_EitherT.prototype.leftFlatMap__F1__Lcats_Monad__Lcats_data_EitherT = (function(f, F) {
  var value = F.flatMap__O__F1__O(this.Lcats_data_EitherT__f_value, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
      var a = x$1.s_util_Left__f_value;
      return f.apply__O__O(a).Lcats_data_EitherT__f_value;
    }
    if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
      return F.pure__O__O(($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_syntax_EitherUtil$(), x$1));
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  })));
  return new $c_Lcats_data_EitherT(value);
});
function $isArrayOf_Lcats_data_EitherT(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_EitherT)));
}
export { $isArrayOf_Lcats_data_EitherT as $isArrayOf_Lcats_data_EitherT };
var $d_Lcats_data_EitherT = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_data_EitherT, "cats.data.EitherT", ({
  Lcats_data_EitherT: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_data_EitherT as $d_Lcats_data_EitherT };
/** @constructor */
function $c_Lcats_data_EitherTInstances() {
}
export { $c_Lcats_data_EitherTInstances as $c_Lcats_data_EitherTInstances };
$c_Lcats_data_EitherTInstances.prototype = new $h_Lcats_data_EitherTInstances1();
$c_Lcats_data_EitherTInstances.prototype.constructor = $c_Lcats_data_EitherTInstances;
/** @constructor */
function $h_Lcats_data_EitherTInstances() {
}
export { $h_Lcats_data_EitherTInstances as $h_Lcats_data_EitherTInstances };
$h_Lcats_data_EitherTInstances.prototype = $c_Lcats_data_EitherTInstances.prototype;
/** @constructor */
function $c_Lcats_data_IndexedStateTFunctor() {
}
export { $c_Lcats_data_IndexedStateTFunctor as $c_Lcats_data_IndexedStateTFunctor };
$c_Lcats_data_IndexedStateTFunctor.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_data_IndexedStateTFunctor.prototype.constructor = $c_Lcats_data_IndexedStateTFunctor;
/** @constructor */
function $h_Lcats_data_IndexedStateTFunctor() {
}
export { $h_Lcats_data_IndexedStateTFunctor as $h_Lcats_data_IndexedStateTFunctor };
$h_Lcats_data_IndexedStateTFunctor.prototype = $c_Lcats_data_IndexedStateTFunctor.prototype;
$c_Lcats_data_IndexedStateTFunctor.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_data_IndexedStateTFunctor.prototype.void__O__O = (function(fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_data_IndexedStateTFunctor.prototype.as__O__O__O = (function(fa, b) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Functor__as__O__O__O(this, fa, b);
});
/** @constructor */
function $c_Lcats_data_IndexedStateTInstances1() {
}
export { $c_Lcats_data_IndexedStateTInstances1 as $c_Lcats_data_IndexedStateTInstances1 };
$c_Lcats_data_IndexedStateTInstances1.prototype = new $h_Lcats_data_IndexedStateTInstances2();
$c_Lcats_data_IndexedStateTInstances1.prototype.constructor = $c_Lcats_data_IndexedStateTInstances1;
/** @constructor */
function $h_Lcats_data_IndexedStateTInstances1() {
}
export { $h_Lcats_data_IndexedStateTInstances1 as $h_Lcats_data_IndexedStateTInstances1 };
$h_Lcats_data_IndexedStateTInstances1.prototype = $c_Lcats_data_IndexedStateTInstances1.prototype;
/** @constructor */
function $c_Lcats_data_Kleisli(run) {
  this.Lcats_data_Kleisli__f_run = null;
  this.Lcats_data_Kleisli__f_run = run;
}
export { $c_Lcats_data_Kleisli as $c_Lcats_data_Kleisli };
$c_Lcats_data_Kleisli.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_data_Kleisli.prototype.constructor = $c_Lcats_data_Kleisli;
/** @constructor */
function $h_Lcats_data_Kleisli() {
}
export { $h_Lcats_data_Kleisli as $h_Lcats_data_Kleisli };
$h_Lcats_data_Kleisli.prototype = $c_Lcats_data_Kleisli.prototype;
$c_Lcats_data_Kleisli.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_data_Kleisli.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_data_Kleisli.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_data_Kleisli)) {
    var x = this.Lcats_data_Kleisli__f_run;
    var x$2 = x$0.Lcats_data_Kleisli__f_run;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lcats_data_Kleisli.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_data_Kleisli.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_data_Kleisli.prototype.productPrefix__T = (function() {
  return "Kleisli";
});
$c_Lcats_data_Kleisli.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_Kleisli__f_run;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_data_Kleisli.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "run";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcats_data_Kleisli(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Kleisli)));
}
export { $isArrayOf_Lcats_data_Kleisli as $isArrayOf_Lcats_data_Kleisli };
var $d_Lcats_data_Kleisli = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_data_Kleisli, "cats.data.Kleisli", ({
  Lcats_data_Kleisli: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_data_Kleisli as $d_Lcats_data_Kleisli };
/** @constructor */
function $c_Lcats_data_KleisliInstances6() {
}
export { $c_Lcats_data_KleisliInstances6 as $c_Lcats_data_KleisliInstances6 };
$c_Lcats_data_KleisliInstances6.prototype = new $h_Lcats_data_KleisliInstances7();
$c_Lcats_data_KleisliInstances6.prototype.constructor = $c_Lcats_data_KleisliInstances6;
/** @constructor */
function $h_Lcats_data_KleisliInstances6() {
}
export { $h_Lcats_data_KleisliInstances6 as $h_Lcats_data_KleisliInstances6 };
$h_Lcats_data_KleisliInstances6.prototype = $c_Lcats_data_KleisliInstances6.prototype;
function $ct_Lcats_data_NonEmptyChainInstances__($thiz) {
  new $c_Lcats_data_NonEmptyChainInstances$$anon$1();
  return $thiz;
}
export { $ct_Lcats_data_NonEmptyChainInstances__ as $ct_Lcats_data_NonEmptyChainInstances__ };
/** @constructor */
function $c_Lcats_data_NonEmptyChainInstances() {
}
export { $c_Lcats_data_NonEmptyChainInstances as $c_Lcats_data_NonEmptyChainInstances };
$c_Lcats_data_NonEmptyChainInstances.prototype = new $h_Lcats_data_NonEmptyChainInstances1();
$c_Lcats_data_NonEmptyChainInstances.prototype.constructor = $c_Lcats_data_NonEmptyChainInstances;
/** @constructor */
function $h_Lcats_data_NonEmptyChainInstances() {
}
export { $h_Lcats_data_NonEmptyChainInstances as $h_Lcats_data_NonEmptyChainInstances };
$h_Lcats_data_NonEmptyChainInstances.prototype = $c_Lcats_data_NonEmptyChainInstances.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptyMapImpl$() {
}
export { $c_Lcats_data_NonEmptyMapImpl$ as $c_Lcats_data_NonEmptyMapImpl$ };
$c_Lcats_data_NonEmptyMapImpl$.prototype = new $h_Lcats_data_NonEmptyMapInstances();
$c_Lcats_data_NonEmptyMapImpl$.prototype.constructor = $c_Lcats_data_NonEmptyMapImpl$;
/** @constructor */
function $h_Lcats_data_NonEmptyMapImpl$() {
}
export { $h_Lcats_data_NonEmptyMapImpl$ as $h_Lcats_data_NonEmptyMapImpl$ };
$h_Lcats_data_NonEmptyMapImpl$.prototype = $c_Lcats_data_NonEmptyMapImpl$.prototype;
$c_Lcats_data_NonEmptyMapImpl$.prototype.fromMap__sci_SortedMap__s_Option = (function(as) {
  return ((!as.isEmpty__Z()) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Option$().apply__O__s_Option(as) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lcats_data_NonEmptyMapImpl$.prototype.apply__T2__sci_SortedMap__Lcats_kernel_Order__O = (function(head, tail, K) {
  var this$1 = $m_sci_SortedMap$().apply__sci_Seq__s_math_Ordering__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T2.getArrayOf().constr)([head])), K.toOrdering__s_math_Ordering());
  var m = this$1.concat__sc_IterableOnce__sci_TreeMap(tail);
  return m;
});
var $d_Lcats_data_NonEmptyMapImpl$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_data_NonEmptyMapImpl$, "cats.data.NonEmptyMapImpl$", ({
  Lcats_data_NonEmptyMapImpl$: 1,
  Lcats_data_NonEmptyMapInstances: 1,
  Lcats_data_NonEmptyMapInstances0: 1,
  Lcats_data_Newtype2: 1
}));
export { $d_Lcats_data_NonEmptyMapImpl$ as $d_Lcats_data_NonEmptyMapImpl$ };
var $n_Lcats_data_NonEmptyMapImpl$;
function $m_Lcats_data_NonEmptyMapImpl$() {
  if ((!$n_Lcats_data_NonEmptyMapImpl$)) {
    $n_Lcats_data_NonEmptyMapImpl$ = new $c_Lcats_data_NonEmptyMapImpl$();
  }
  return $n_Lcats_data_NonEmptyMapImpl$;
}
export { $m_Lcats_data_NonEmptyMapImpl$ as $m_Lcats_data_NonEmptyMapImpl$ };
/** @constructor */
function $c_Lcats_data_OptionT(value) {
  this.Lcats_data_OptionT__f_value = null;
  this.Lcats_data_OptionT__f_value = value;
}
export { $c_Lcats_data_OptionT as $c_Lcats_data_OptionT };
$c_Lcats_data_OptionT.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_data_OptionT.prototype.constructor = $c_Lcats_data_OptionT;
/** @constructor */
function $h_Lcats_data_OptionT() {
}
export { $h_Lcats_data_OptionT as $h_Lcats_data_OptionT };
$h_Lcats_data_OptionT.prototype = $c_Lcats_data_OptionT.prototype;
$c_Lcats_data_OptionT.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_data_OptionT.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_data_OptionT.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_data_OptionT)) {
    var x = this.Lcats_data_OptionT__f_value;
    var y = x$0.Lcats_data_OptionT__f_value;
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_data_OptionT.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_data_OptionT.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_data_OptionT.prototype.productPrefix__T = (function() {
  return "OptionT";
});
$c_Lcats_data_OptionT.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_OptionT__f_value;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_data_OptionT.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_data_OptionT.prototype.semiflatMap__F1__Lcats_Monad__Lcats_data_OptionT = (function(f, F) {
  return this.flatMap__F1__Lcats_Monad__Lcats_data_OptionT(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((a) => $m_Lcats_data_OptionT$().liftF__O__Lcats_Functor__Lcats_data_OptionT(f.apply__O__O(a), F))), F);
});
$c_Lcats_data_OptionT.prototype.flatMap__F1__Lcats_Monad__Lcats_data_OptionT = (function(f, F) {
  return this.flatMapF__F1__Lcats_Monad__Lcats_data_OptionT(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((a) => f.apply__O__O(a).Lcats_data_OptionT__f_value)), F);
});
$c_Lcats_data_OptionT.prototype.flatMapF__F1__Lcats_Monad__Lcats_data_OptionT = (function(f, F) {
  var value = F.flatMap__O__F1__O(this.Lcats_data_OptionT__f_value, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$9) => (_$9.isEmpty__Z() ? F.pure__O__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()) : f.apply__O__O(_$9.get__O())))));
  return new $c_Lcats_data_OptionT(value);
});
$c_Lcats_data_OptionT.prototype.collect__s_PartialFunction__Lcats_Functor__Lcats_data_OptionT = (function(f, F) {
  var value = F.map__O__F1__O(this.Lcats_data_OptionT__f_value, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$15) => ((!_$15.isEmpty__Z()) ? f.lift__F1().apply__O__O(_$15.get__O()) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()))));
  return new $c_Lcats_data_OptionT(value);
});
$c_Lcats_data_OptionT.prototype.orElseF__F0__Lcats_Monad__Lcats_data_OptionT = (function(default$1, F) {
  var value = F.flatMap__O__F1__O(this.Lcats_data_OptionT__f_value, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      return F.pure__O__O(x$1);
    }
    var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    if ((x === x$1)) {
      return default$1.apply__O();
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  })));
  return new $c_Lcats_data_OptionT(value);
});
function $isArrayOf_Lcats_data_OptionT(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_OptionT)));
}
export { $isArrayOf_Lcats_data_OptionT as $isArrayOf_Lcats_data_OptionT };
var $d_Lcats_data_OptionT = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_data_OptionT, "cats.data.OptionT", ({
  Lcats_data_OptionT: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_data_OptionT as $d_Lcats_data_OptionT };
/** @constructor */
function $c_Lcats_data_OptionTInstances0() {
}
export { $c_Lcats_data_OptionTInstances0 as $c_Lcats_data_OptionTInstances0 };
$c_Lcats_data_OptionTInstances0.prototype = new $h_Lcats_data_OptionTInstances1();
$c_Lcats_data_OptionTInstances0.prototype.constructor = $c_Lcats_data_OptionTInstances0;
/** @constructor */
function $h_Lcats_data_OptionTInstances0() {
}
export { $h_Lcats_data_OptionTInstances0 as $h_Lcats_data_OptionTInstances0 };
$h_Lcats_data_OptionTInstances0.prototype = $c_Lcats_data_OptionTInstances0.prototype;
function $f_Lcats_derived_DerivedShow$package$DerivedShow$Coproduct__show__O__T($thiz, a) {
  var f$proxy2 = new $c_Lcats_derived_DerivedShow$package$DerivedShow$Coproduct$$anon$2();
  return $thiz.Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$4__f_cats$derived$DerivedShow$package$DerivedShow$Coproduct$$inst.erasedFold__O__F2__O(a, f$proxy2);
}
export { $f_Lcats_derived_DerivedShow$package$DerivedShow$Coproduct__show__O__T as $f_Lcats_derived_DerivedShow$package$DerivedShow$Coproduct__show__O__T };
function $f_Lcats_derived_DerivedShow$package$DerivedShow$Product__show__O__T($thiz, a) {
  var prefix = $thiz.Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$3__f_cats$derived$DerivedShow$package$DerivedShow$Product$$labelling.Lshapeless3_deriving_Labelling__f_label;
  var labels = $thiz.Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$3__f_cats$derived$DerivedShow$package$DerivedShow$Product$$labelling.Lshapeless3_deriving_Labelling__f_elemLabels;
  var n = labels.length__I();
  if ((n <= 0)) {
    return prefix;
  } else {
    var sb = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_scm_StringBuilder__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_StringBuilder(), prefix);
    sb.append__C__scm_StringBuilder(40);
    var i = 0;
    while ((i < n)) {
      sb.append__T__scm_StringBuilder(labels.apply__I__O(i));
      sb.append__T__scm_StringBuilder(" = ");
      var p$proxy1 = i;
      var f$proxy1 = new $c_Lcats_derived_DerivedShow$package$DerivedShow$Product$$anon$1();
      sb.append__T__scm_StringBuilder($thiz.Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$3__f_cats$derived$DerivedShow$package$DerivedShow$Product$$inst.erasedProject__O__I__F2__O(a, p$proxy1, f$proxy1));
      sb.append__T__scm_StringBuilder(", ");
      i = ((1 + i) | 0);
    }
    var l = sb.scm_StringBuilder__f_underlying.length__I();
    sb.delete__I__I__scm_StringBuilder((((-2) + l) | 0), l);
    sb.append__C__scm_StringBuilder(41);
    return sb.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  }
}
export { $f_Lcats_derived_DerivedShow$package$DerivedShow$Product__show__O__T as $f_Lcats_derived_DerivedShow$package$DerivedShow$Product__show__O__T };
/** @constructor */
function $c_Lcats_effect_IOFiber$$anon$1(id$2, outer) {
  this.Lcats_effect_IOFiber$$anon$1__f_id$1 = 0;
  this.Lcats_effect_IOFiber$$anon$1__f_$outer = null;
  this.Lcats_effect_IOFiber$$anon$1__f_id$1 = id$2;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lcats_effect_IOFiber$$anon$1__f_$outer = outer;
}
export { $c_Lcats_effect_IOFiber$$anon$1 as $c_Lcats_effect_IOFiber$$anon$1 };
$c_Lcats_effect_IOFiber$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_IOFiber$$anon$1.prototype.constructor = $c_Lcats_effect_IOFiber$$anon$1;
/** @constructor */
function $h_Lcats_effect_IOFiber$$anon$1() {
}
export { $h_Lcats_effect_IOFiber$$anon$1 as $h_Lcats_effect_IOFiber$$anon$1 };
$h_Lcats_effect_IOFiber$$anon$1.prototype = $c_Lcats_effect_IOFiber$$anon$1.prototype;
$c_Lcats_effect_IOFiber$$anon$1.prototype.apply__Lcats_effect_IO__Lcats_effect_IO = (function(ioa) {
  var id = this.Lcats_effect_IOFiber$$anon$1__f_id$1;
  var self = this.Lcats_effect_IOFiber$$anon$1__f_$outer;
  return new $c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop(ioa, id, self);
});
$c_Lcats_effect_IOFiber$$anon$1.prototype.apply__O__O = (function(fa) {
  return this.apply__Lcats_effect_IO__Lcats_effect_IO(fa);
});
var $d_Lcats_effect_IOFiber$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IOFiber$$anon$1, "cats.effect.IOFiber$$anon$1", ({
  Lcats_effect_IOFiber$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1,
  Lcats_effect_kernel_Poll: 1
}));
export { $d_Lcats_effect_IOFiber$$anon$1 as $d_Lcats_effect_IOFiber$$anon$1 };
/** @constructor */
function $c_Lcats_effect_kernel_Deferred() {
}
export { $c_Lcats_effect_kernel_Deferred as $c_Lcats_effect_kernel_Deferred };
$c_Lcats_effect_kernel_Deferred.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_kernel_Deferred.prototype.constructor = $c_Lcats_effect_kernel_Deferred;
/** @constructor */
function $h_Lcats_effect_kernel_Deferred() {
}
export { $h_Lcats_effect_kernel_Deferred as $h_Lcats_effect_kernel_Deferred };
$h_Lcats_effect_kernel_Deferred.prototype = $c_Lcats_effect_kernel_Deferred.prototype;
function $f_Lcats_effect_kernel_Outcome__embed__O__Lcats_effect_kernel_MonadCancel__O($thiz, onCancel, F) {
  if (($thiz instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Canceled)) {
    return onCancel;
  }
  if (($thiz instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Errored)) {
    var x7 = $thiz.Lcats_effect_kernel_Outcome$Errored__f_e;
    return F.raiseError__O__O(x7);
  }
  if (($thiz instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Succeeded)) {
    var x4 = $thiz.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
    return x4;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError($thiz);
}
export { $f_Lcats_effect_kernel_Outcome__embed__O__Lcats_effect_kernel_MonadCancel__O as $f_Lcats_effect_kernel_Outcome__embed__O__Lcats_effect_kernel_MonadCancel__O };
/** @constructor */
function $c_Lcats_effect_kernel_Ref() {
}
export { $c_Lcats_effect_kernel_Ref as $c_Lcats_effect_kernel_Ref };
$c_Lcats_effect_kernel_Ref.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_kernel_Ref.prototype.constructor = $c_Lcats_effect_kernel_Ref;
/** @constructor */
function $h_Lcats_effect_kernel_Ref() {
}
export { $h_Lcats_effect_kernel_Ref as $h_Lcats_effect_kernel_Ref };
$h_Lcats_effect_kernel_Ref.prototype = $c_Lcats_effect_kernel_Ref.prototype;
$c_Lcats_effect_kernel_Ref.prototype.getAndUpdate__F1__O = (function(f) {
  return this.modify__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((a) => {
    var _1 = f.apply__O__O(a);
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, a);
  })));
});
$c_Lcats_effect_kernel_Ref.prototype.flatModify__F1__Lcats_effect_kernel_MonadCancel__O = (function(f, F) {
  return F.uncancelable__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$3) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__flatten__O__O(F, this.modify__F1__O(f)))));
});
$c_Lcats_effect_kernel_Ref.prototype.flatModifyFull__F2__Lcats_effect_kernel_MonadCancel__O = (function(f, F) {
  return F.uncancelable__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((poll) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__flatten__O__O(F, this.modify__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((poll$2) => ((_$4) => f.apply__O__O__O(poll$2, _$4)))(poll)))))));
});
/** @constructor */
function $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1(M$2, outer) {
  this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1__f_M$1 = null;
  this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1__f_$outer = null;
  this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1__f_M$1 = M$2;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1__f_$outer = outer;
}
export { $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1 as $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1 };
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1.prototype.constructor = $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1;
/** @constructor */
function $h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1() {
}
export { $h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1 as $h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1 };
$h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1.prototype = $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1.prototype;
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1.prototype.applicative__Lcats_Applicative = (function() {
  var F = this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1__f_M$1;
  return new $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4(F);
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1.prototype.monad__Lcats_Monad = (function() {
  return this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1__f_M$1;
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1.prototype.sequential__Lcats_arrow_FunctionK = (function() {
  return new $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2();
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1.prototype.parallel__Lcats_arrow_FunctionK = (function() {
  return new $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3();
});
var $d_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1, "cats.effect.kernel.instances.GenSpawnInstances$$anon$1", ({
  Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_NonEmptyParallel: 1,
  Lcats_Parallel: 1
}));
export { $d_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1 as $d_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1 };
/** @constructor */
function $c_Lcats_effect_std_Semaphore$impl$Request(outer, n, gate) {
  this.Lcats_effect_std_Semaphore$impl$Request__f_n = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0;
  this.Lcats_effect_std_Semaphore$impl$Request__f_gate = null;
  this.Lcats_effect_std_Semaphore$impl$Request__f_$outer = null;
  this.Lcats_effect_std_Semaphore$impl$Request__f_n = n;
  this.Lcats_effect_std_Semaphore$impl$Request__f_gate = gate;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lcats_effect_std_Semaphore$impl$Request__f_$outer = outer;
}
export { $c_Lcats_effect_std_Semaphore$impl$Request as $c_Lcats_effect_std_Semaphore$impl$Request };
$c_Lcats_effect_std_Semaphore$impl$Request.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_std_Semaphore$impl$Request.prototype.constructor = $c_Lcats_effect_std_Semaphore$impl$Request;
/** @constructor */
function $h_Lcats_effect_std_Semaphore$impl$Request() {
}
export { $h_Lcats_effect_std_Semaphore$impl$Request as $h_Lcats_effect_std_Semaphore$impl$Request };
$h_Lcats_effect_std_Semaphore$impl$Request.prototype = $c_Lcats_effect_std_Semaphore$impl$Request.prototype;
$c_Lcats_effect_std_Semaphore$impl$Request.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_std_Semaphore$impl$Request.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I("Request");
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var t = this.Lcats_effect_std_Semaphore$impl$Request__f_n;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var data$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().longHash__J__I(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lcats_effect_std_Semaphore$impl$Request__f_gate;
  var data$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2);
});
$c_Lcats_effect_std_Semaphore$impl$Request.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Lcats_effect_std_Semaphore$impl$Request) && (x$0.Lcats_effect_std_Semaphore$impl$Request__f_$outer === this.Lcats_effect_std_Semaphore$impl$Request__f_$outer))) {
    var a = this.Lcats_effect_std_Semaphore$impl$Request__f_n;
    var b = x$0.Lcats_effect_std_Semaphore$impl$Request__f_n;
    if (((a.RTLong__f_lo === b.RTLong__f_lo) && (a.RTLong__f_hi === b.RTLong__f_hi))) {
      var x = this.Lcats_effect_std_Semaphore$impl$Request__f_gate;
      var x$2 = x$0.Lcats_effect_std_Semaphore$impl$Request__f_gate;
      return (x === x$2);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_std_Semaphore$impl$Request.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_std_Semaphore$impl$Request.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_std_Semaphore$impl$Request.prototype.productPrefix__T = (function() {
  return "Request";
});
$c_Lcats_effect_std_Semaphore$impl$Request.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_std_Semaphore$impl$Request__f_n;
  }
  if ((n === 1)) {
    return this.Lcats_effect_std_Semaphore$impl$Request__f_gate;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_std_Semaphore$impl$Request.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "n";
  }
  if ((n === 1)) {
    return "gate";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_std_Semaphore$impl$Request.prototype.sameAs__Lcats_effect_std_Semaphore$impl$Request__Z = (function(r) {
  return (r.Lcats_effect_std_Semaphore$impl$Request__f_gate === this.Lcats_effect_std_Semaphore$impl$Request__f_gate);
});
$c_Lcats_effect_std_Semaphore$impl$Request.prototype.of__J__Lcats_effect_std_Semaphore$impl$Request = (function(newN) {
  return this.Lcats_effect_std_Semaphore$impl$Request__f_$outer.Lcats_effect_std_Semaphore$impl__f_Request$lzy1.apply__J__Lcats_effect_kernel_Deferred__Lcats_effect_std_Semaphore$impl$Request(newN, this.Lcats_effect_std_Semaphore$impl$Request__f_gate);
});
function $isArrayOf_Lcats_effect_std_Semaphore$impl$Request(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Semaphore$impl$Request)));
}
export { $isArrayOf_Lcats_effect_std_Semaphore$impl$Request as $isArrayOf_Lcats_effect_std_Semaphore$impl$Request };
var $d_Lcats_effect_std_Semaphore$impl$Request = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_std_Semaphore$impl$Request, "cats.effect.std.Semaphore$impl$Request", ({
  Lcats_effect_std_Semaphore$impl$Request: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_effect_std_Semaphore$impl$Request as $d_Lcats_effect_std_Semaphore$impl$Request };
/** @constructor */
function $c_Lcats_effect_std_Semaphore$impl$State(outer, permits, waiting) {
  this.Lcats_effect_std_Semaphore$impl$State__f_permits = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0;
  this.Lcats_effect_std_Semaphore$impl$State__f_waiting = null;
  this.Lcats_effect_std_Semaphore$impl$State__f_$outer = null;
  this.Lcats_effect_std_Semaphore$impl$State__f_permits = permits;
  this.Lcats_effect_std_Semaphore$impl$State__f_waiting = waiting;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lcats_effect_std_Semaphore$impl$State__f_$outer = outer;
}
export { $c_Lcats_effect_std_Semaphore$impl$State as $c_Lcats_effect_std_Semaphore$impl$State };
$c_Lcats_effect_std_Semaphore$impl$State.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_std_Semaphore$impl$State.prototype.constructor = $c_Lcats_effect_std_Semaphore$impl$State;
/** @constructor */
function $h_Lcats_effect_std_Semaphore$impl$State() {
}
export { $h_Lcats_effect_std_Semaphore$impl$State as $h_Lcats_effect_std_Semaphore$impl$State };
$h_Lcats_effect_std_Semaphore$impl$State.prototype = $c_Lcats_effect_std_Semaphore$impl$State.prototype;
$c_Lcats_effect_std_Semaphore$impl$State.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_std_Semaphore$impl$State.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I("State");
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var t = this.Lcats_effect_std_Semaphore$impl$State__f_permits;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var data$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().longHash__J__I(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lcats_effect_std_Semaphore$impl$State__f_waiting;
  var data$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2);
});
$c_Lcats_effect_std_Semaphore$impl$State.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Lcats_effect_std_Semaphore$impl$State) && (x$0.Lcats_effect_std_Semaphore$impl$State__f_$outer === this.Lcats_effect_std_Semaphore$impl$State__f_$outer))) {
    var a = this.Lcats_effect_std_Semaphore$impl$State__f_permits;
    var b = x$0.Lcats_effect_std_Semaphore$impl$State__f_permits;
    if (((a.RTLong__f_lo === b.RTLong__f_lo) && (a.RTLong__f_hi === b.RTLong__f_hi))) {
      var x = this.Lcats_effect_std_Semaphore$impl$State__f_waiting;
      var x$2 = x$0.Lcats_effect_std_Semaphore$impl$State__f_waiting;
      return ((x === null) ? (x$2 === null) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_Seq__equals__O__Z(x, x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_std_Semaphore$impl$State.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_std_Semaphore$impl$State.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_std_Semaphore$impl$State.prototype.productPrefix__T = (function() {
  return "State";
});
$c_Lcats_effect_std_Semaphore$impl$State.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_std_Semaphore$impl$State__f_permits;
  }
  if ((n === 1)) {
    return this.Lcats_effect_std_Semaphore$impl$State__f_waiting;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_std_Semaphore$impl$State.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "permits";
  }
  if ((n === 1)) {
    return "waiting";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcats_effect_std_Semaphore$impl$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Semaphore$impl$State)));
}
export { $isArrayOf_Lcats_effect_std_Semaphore$impl$State as $isArrayOf_Lcats_effect_std_Semaphore$impl$State };
var $d_Lcats_effect_std_Semaphore$impl$State = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_std_Semaphore$impl$State, "cats.effect.std.Semaphore$impl$State", ({
  Lcats_effect_std_Semaphore$impl$State: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_effect_std_Semaphore$impl$State as $d_Lcats_effect_std_Semaphore$impl$State };
function $isArrayOf_Lcats_effect_tracing_TracingEvent$StackTrace(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_tracing_TracingEvent$StackTrace)));
}
export { $isArrayOf_Lcats_effect_tracing_TracingEvent$StackTrace as $isArrayOf_Lcats_effect_tracing_TracingEvent$StackTrace };
/** @constructor */
function $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor(batchSize, reportFailure0) {
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$batchSize = 0;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_reportFailure0 = null;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_queueMicrotask = null;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$needsReschedule = false;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$fibers = null;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_executeBatchTaskRunnable = null;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_executeBatchTaskJSFunction = null;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_fiberBag = null;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$batchSize = batchSize;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_reportFailure0 = reportFailure0;
  if (((typeof queueMicrotask) === "function")) {
    var $x_1 = queueMicrotask;
  } else {
    var resolved = Promise.resolve((void 0));
    var $x_1 = ((task) => resolved.then(task));
  }
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_queueMicrotask = $x_1;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$needsReschedule = true;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$fibers = new $c_Lcats_effect_unsafe_JSArrayQueue();
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_executeBatchTaskRunnable = new $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1(this);
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_executeBatchTaskJSFunction = (() => {
    this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_executeBatchTaskRunnable.run__V();
  });
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_fiberBag = null;
}
export { $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor as $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor };
$c_Lcats_effect_unsafe_BatchingMacrotaskExecutor.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_unsafe_BatchingMacrotaskExecutor.prototype.constructor = $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor;
/** @constructor */
function $h_Lcats_effect_unsafe_BatchingMacrotaskExecutor() {
}
export { $h_Lcats_effect_unsafe_BatchingMacrotaskExecutor as $h_Lcats_effect_unsafe_BatchingMacrotaskExecutor };
$h_Lcats_effect_unsafe_BatchingMacrotaskExecutor.prototype = $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor.prototype;
$c_Lcats_effect_unsafe_BatchingMacrotaskExecutor.prototype.execute__jl_Runnable__V = (function(runnable) {
  $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$().execute__jl_Runnable__V(runnable);
});
$c_Lcats_effect_unsafe_BatchingMacrotaskExecutor.prototype.schedule__Lcats_effect_IOFiber__V = (function(fiber) {
  var this$1 = this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$fibers;
  if ((!this$1.Lcats_effect_unsafe_JSArrayQueue__f_empty)) {
    if (((this$1.Lcats_effect_unsafe_JSArrayQueue__f_startIndex === 0) && (this$1.Lcats_effect_unsafe_JSArrayQueue__f_endIndex === (this$1.Lcats_effect_unsafe_JSArrayQueue__f_buffer.length | 0)))) {
      this$1.Lcats_effect_unsafe_JSArrayQueue__f_buffer.push(null);
    } else if ((this$1.Lcats_effect_unsafe_JSArrayQueue__f_startIndex === this$1.Lcats_effect_unsafe_JSArrayQueue__f_endIndex)) {
      var i = 0;
      while ((i < this$1.Lcats_effect_unsafe_JSArrayQueue__f_endIndex)) {
        this$1.Lcats_effect_unsafe_JSArrayQueue__f_buffer.push(this$1.Lcats_effect_unsafe_JSArrayQueue__f_buffer[i]);
        this$1.Lcats_effect_unsafe_JSArrayQueue__f_buffer[i] = null;
        i = ((1 + i) | 0);
      }
      this$1.Lcats_effect_unsafe_JSArrayQueue__f_endIndex = (this$1.Lcats_effect_unsafe_JSArrayQueue__f_buffer.length | 0);
    }
  }
  this$1.Lcats_effect_unsafe_JSArrayQueue__f_endIndex = ((1 + this$1.Lcats_effect_unsafe_JSArrayQueue__f_endIndex) | 0);
  if ((this$1.Lcats_effect_unsafe_JSArrayQueue__f_endIndex > (this$1.Lcats_effect_unsafe_JSArrayQueue__f_buffer.length | 0))) {
    this$1.Lcats_effect_unsafe_JSArrayQueue__f_endIndex = 1;
  }
  this$1.Lcats_effect_unsafe_JSArrayQueue__f_buffer[(((-1) + this$1.Lcats_effect_unsafe_JSArrayQueue__f_endIndex) | 0)] = fiber;
  this$1.Lcats_effect_unsafe_JSArrayQueue__f_empty = false;
  if (this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$needsReschedule) {
    this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$needsReschedule = false;
    (0, this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_queueMicrotask)(this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_executeBatchTaskJSFunction);
  }
});
$c_Lcats_effect_unsafe_BatchingMacrotaskExecutor.prototype.reportFailure__jl_Throwable__V = (function(t) {
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_reportFailure0.apply__O__O(t);
});
function $isArrayOf_Lcats_effect_unsafe_BatchingMacrotaskExecutor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_unsafe_BatchingMacrotaskExecutor)));
}
export { $isArrayOf_Lcats_effect_unsafe_BatchingMacrotaskExecutor as $isArrayOf_Lcats_effect_unsafe_BatchingMacrotaskExecutor };
var $d_Lcats_effect_unsafe_BatchingMacrotaskExecutor = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_unsafe_BatchingMacrotaskExecutor, "cats.effect.unsafe.BatchingMacrotaskExecutor", ({
  Lcats_effect_unsafe_BatchingMacrotaskExecutor: 1,
  s_concurrent_ExecutionContext: 1,
  ju_concurrent_Executor: 1,
  s_concurrent_ExecutionContextExecutor: 1
}));
export { $d_Lcats_effect_unsafe_BatchingMacrotaskExecutor as $d_Lcats_effect_unsafe_BatchingMacrotaskExecutor };
/** @constructor */
function $c_Lcats_effect_unsafe_IORuntimeConfig(cancelationCheckThreshold, autoYieldThreshold, enhancedExceptions, traceBufferSize, shutdownHookTimeout, reportUnhandledFiberErrors, cpuStarvationCheckInterval, cpuStarvationCheckInitialDelay, cpuStarvationCheckThreshold) {
  this.Lcats_effect_unsafe_IORuntimeConfig__f_cancelationCheckThreshold = 0;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_autoYieldThreshold = 0;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_enhancedExceptions = false;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferSize = 0;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_shutdownHookTimeout = null;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_reportUnhandledFiberErrors = false;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInterval = null;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInitialDelay = null;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckThreshold = 0.0;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferLogSize = 0;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_cancelationCheckThreshold = cancelationCheckThreshold;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_autoYieldThreshold = autoYieldThreshold;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_enhancedExceptions = enhancedExceptions;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferSize = traceBufferSize;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_shutdownHookTimeout = shutdownHookTimeout;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_reportUnhandledFiberErrors = reportUnhandledFiberErrors;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInterval = cpuStarvationCheckInterval;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInitialDelay = cpuStarvationCheckInitialDelay;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckThreshold = cpuStarvationCheckThreshold;
  var requirement = (autoYieldThreshold > 1);
  if ((!requirement)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), (("requirement failed: " + ("Auto yield threshold " + autoYieldThreshold)) + " must be > 1"));
  }
  var requirement$1 = (cancelationCheckThreshold > 0);
  if ((!requirement$1)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), (("requirement failed: " + ("Cancelation check threshold " + cancelationCheckThreshold)) + " must be > 0"));
  }
  var requirement$2 = (((autoYieldThreshold % $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$checkIntDivisor(cancelationCheckThreshold)) | 0) === 0);
  if ((!requirement$2)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), (("requirement failed: " + (("Auto yield threshold " + autoYieldThreshold) + " must be a multiple of cancelation check threshold ")) + cancelationCheckThreshold));
  }
  var requirement$3 = (cpuStarvationCheckThreshold > 0.0);
  if ((!requirement$3)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), (("requirement failed: " + ("CPU starvation check threshold " + cpuStarvationCheckThreshold)) + " must be > 0"));
  }
  var a = traceBufferSize;
  var a$1 = ((+Math.log(a)) / (+Math.log(2.0)));
  var value = (+Math.round(a$1));
  var this$8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_RTLong$();
  var lo = this$8.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
  this.Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferLogSize = lo;
}
export { $c_Lcats_effect_unsafe_IORuntimeConfig as $c_Lcats_effect_unsafe_IORuntimeConfig };
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype.constructor = $c_Lcats_effect_unsafe_IORuntimeConfig;
/** @constructor */
function $h_Lcats_effect_unsafe_IORuntimeConfig() {
}
export { $h_Lcats_effect_unsafe_IORuntimeConfig as $h_Lcats_effect_unsafe_IORuntimeConfig };
$h_Lcats_effect_unsafe_IORuntimeConfig.prototype = $c_Lcats_effect_unsafe_IORuntimeConfig.prototype;
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I("IORuntimeConfig");
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lcats_effect_unsafe_IORuntimeConfig__f_cancelationCheckThreshold;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Lcats_effect_unsafe_IORuntimeConfig__f_autoYieldThreshold;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = (this.Lcats_effect_unsafe_IORuntimeConfig__f_enhancedExceptions ? 1231 : 1237);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var data$4 = this.Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferSize;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x = this.Lcats_effect_unsafe_IORuntimeConfig__f_shutdownHookTimeout;
  var data$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var data$6 = (this.Lcats_effect_unsafe_IORuntimeConfig__f_reportUnhandledFiberErrors ? 1231 : 1237);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var x$1 = this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInterval;
  var data$7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$1);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  var x$2 = this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInitialDelay;
  var data$8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$2);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$8, data$8);
  var hash$9 = acc;
  var dv = this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckThreshold;
  var data$9 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().doubleHash__D__I(dv);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$9, data$9);
  var hash$10 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$10, 9);
});
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_unsafe_IORuntimeConfig)) {
    if (((((((this.Lcats_effect_unsafe_IORuntimeConfig__f_cancelationCheckThreshold === x$0.Lcats_effect_unsafe_IORuntimeConfig__f_cancelationCheckThreshold) && (this.Lcats_effect_unsafe_IORuntimeConfig__f_autoYieldThreshold === x$0.Lcats_effect_unsafe_IORuntimeConfig__f_autoYieldThreshold)) && (this.Lcats_effect_unsafe_IORuntimeConfig__f_enhancedExceptions === x$0.Lcats_effect_unsafe_IORuntimeConfig__f_enhancedExceptions)) && (this.Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferSize === x$0.Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferSize)) && (this.Lcats_effect_unsafe_IORuntimeConfig__f_reportUnhandledFiberErrors === x$0.Lcats_effect_unsafe_IORuntimeConfig__f_reportUnhandledFiberErrors)) && (this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckThreshold === x$0.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckThreshold))) {
      var x = this.Lcats_effect_unsafe_IORuntimeConfig__f_shutdownHookTimeout;
      var x$2 = x$0.Lcats_effect_unsafe_IORuntimeConfig__f_shutdownHookTimeout;
      var $x_2 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInterval;
      var x$4 = x$0.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInterval;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInitialDelay;
      var x$6 = x$0.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInitialDelay;
      return ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype.productArity__I = (function() {
  return 9;
});
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype.productPrefix__T = (function() {
  return "IORuntimeConfig";
});
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lcats_effect_unsafe_IORuntimeConfig__f_cancelationCheckThreshold;
      break;
    }
    case 1: {
      return this.Lcats_effect_unsafe_IORuntimeConfig__f_autoYieldThreshold;
      break;
    }
    case 2: {
      return this.Lcats_effect_unsafe_IORuntimeConfig__f_enhancedExceptions;
      break;
    }
    case 3: {
      return this.Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferSize;
      break;
    }
    case 4: {
      return this.Lcats_effect_unsafe_IORuntimeConfig__f_shutdownHookTimeout;
      break;
    }
    case 5: {
      return this.Lcats_effect_unsafe_IORuntimeConfig__f_reportUnhandledFiberErrors;
      break;
    }
    case 6: {
      return this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInterval;
      break;
    }
    case 7: {
      return this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInitialDelay;
      break;
    }
    case 8: {
      return this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckThreshold;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "cancelationCheckThreshold";
      break;
    }
    case 1: {
      return "autoYieldThreshold";
      break;
    }
    case 2: {
      return "enhancedExceptions";
      break;
    }
    case 3: {
      return "traceBufferSize";
      break;
    }
    case 4: {
      return "shutdownHookTimeout";
      break;
    }
    case 5: {
      return "reportUnhandledFiberErrors";
      break;
    }
    case 6: {
      return "cpuStarvationCheckInterval";
      break;
    }
    case 7: {
      return "cpuStarvationCheckInitialDelay";
      break;
    }
    case 8: {
      return "cpuStarvationCheckThreshold";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcats_effect_unsafe_IORuntimeConfig(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_unsafe_IORuntimeConfig)));
}
export { $isArrayOf_Lcats_effect_unsafe_IORuntimeConfig as $isArrayOf_Lcats_effect_unsafe_IORuntimeConfig };
var $d_Lcats_effect_unsafe_IORuntimeConfig = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_unsafe_IORuntimeConfig, "cats.effect.unsafe.IORuntimeConfig", ({
  Lcats_effect_unsafe_IORuntimeConfig: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_effect_unsafe_IORuntimeConfig as $d_Lcats_effect_unsafe_IORuntimeConfig };
/** @constructor */
function $c_Lcats_effect_unsafe_IORuntimeConfig$() {
  this.Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform__f_Default = null;
  $ct_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform__(this);
}
export { $c_Lcats_effect_unsafe_IORuntimeConfig$ as $c_Lcats_effect_unsafe_IORuntimeConfig$ };
$c_Lcats_effect_unsafe_IORuntimeConfig$.prototype = new $h_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform();
$c_Lcats_effect_unsafe_IORuntimeConfig$.prototype.constructor = $c_Lcats_effect_unsafe_IORuntimeConfig$;
/** @constructor */
function $h_Lcats_effect_unsafe_IORuntimeConfig$() {
}
export { $h_Lcats_effect_unsafe_IORuntimeConfig$ as $h_Lcats_effect_unsafe_IORuntimeConfig$ };
$h_Lcats_effect_unsafe_IORuntimeConfig$.prototype = $c_Lcats_effect_unsafe_IORuntimeConfig$.prototype;
$c_Lcats_effect_unsafe_IORuntimeConfig$.prototype.DefaultCpuStarvationCheckInterval__s_concurrent_duration_FiniteDuration = (function() {
  var this$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_package$DurationInt(1);
  var unit = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
  var this$ = this$2.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$();
  var hi = (this$ >> 31);
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_FiniteDuration(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(this$, hi), unit);
});
$c_Lcats_effect_unsafe_IORuntimeConfig$.prototype.DefaultCpuStarvationCheckInitialDelay__s_concurrent_duration_FiniteDuration = (function() {
  var this$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_package$DurationInt(10);
  var unit = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
  var this$ = this$2.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$();
  var hi = (this$ >> 31);
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_FiniteDuration(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(this$, hi), unit);
});
$c_Lcats_effect_unsafe_IORuntimeConfig$.prototype.apply__I__I__Z__I__s_concurrent_duration_Duration__Z__s_concurrent_duration_FiniteDuration__s_concurrent_duration_Duration__D__Lcats_effect_unsafe_IORuntimeConfig = (function(cancelationCheckThreshold, autoYieldThreshold, enhancedExceptions, traceBufferSize, shutdownHookTimeout, reportUnhandledFiberErrors, cpuStarvationCheckInterval, cpuStarvationCheckInitialDelay, cpuStarvationCheckThreshold) {
  var a = traceBufferSize;
  var a$1 = ((+Math.log(a)) / (+Math.log(2.0)));
  var value = (+Math.round(a$1));
  var this$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_RTLong$();
  var lo = this$4.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
  return new $c_Lcats_effect_unsafe_IORuntimeConfig(cancelationCheckThreshold, autoYieldThreshold, enhancedExceptions, (1 << lo), shutdownHookTimeout, reportUnhandledFiberErrors, cpuStarvationCheckInterval, cpuStarvationCheckInitialDelay, cpuStarvationCheckThreshold);
});
$c_Lcats_effect_unsafe_IORuntimeConfig$.prototype.fromProduct__s_Product__Lcats_effect_unsafe_IORuntimeConfig = (function(x$0) {
  return new $c_Lcats_effect_unsafe_IORuntimeConfig((x$0.productElement__I__O(0) | 0), (x$0.productElement__I__O(1) | 0), (!(!x$0.productElement__I__O(2))), (x$0.productElement__I__O(3) | 0), x$0.productElement__I__O(4), (!(!x$0.productElement__I__O(5))), x$0.productElement__I__O(6), x$0.productElement__I__O(7), (+x$0.productElement__I__O(8)));
});
$c_Lcats_effect_unsafe_IORuntimeConfig$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lcats_effect_unsafe_IORuntimeConfig(p);
});
var $d_Lcats_effect_unsafe_IORuntimeConfig$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_unsafe_IORuntimeConfig$, "cats.effect.unsafe.IORuntimeConfig$", ({
  Lcats_effect_unsafe_IORuntimeConfig$: 1,
  Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lcats_effect_unsafe_IORuntimeConfig$ as $d_Lcats_effect_unsafe_IORuntimeConfig$ };
var $n_Lcats_effect_unsafe_IORuntimeConfig$;
function $m_Lcats_effect_unsafe_IORuntimeConfig$() {
  if ((!$n_Lcats_effect_unsafe_IORuntimeConfig$)) {
    $n_Lcats_effect_unsafe_IORuntimeConfig$ = new $c_Lcats_effect_unsafe_IORuntimeConfig$();
  }
  return $n_Lcats_effect_unsafe_IORuntimeConfig$;
}
export { $m_Lcats_effect_unsafe_IORuntimeConfig$ as $m_Lcats_effect_unsafe_IORuntimeConfig$ };
/** @constructor */
function $c_Lcats_instances_Function1Instances$$anon$7(outer) {
  this.Lcats_instances_Function1Instances$$anon$7__f_category = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  var instance = outer.catsStdInstancesForFunction1__Lcats_arrow_ArrowChoice();
  this.Lcats_instances_Function1Instances$$anon$7__f_category = instance;
}
export { $c_Lcats_instances_Function1Instances$$anon$7 as $c_Lcats_instances_Function1Instances$$anon$7 };
$c_Lcats_instances_Function1Instances$$anon$7.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_Function1Instances$$anon$7.prototype.constructor = $c_Lcats_instances_Function1Instances$$anon$7;
/** @constructor */
function $h_Lcats_instances_Function1Instances$$anon$7() {
}
export { $h_Lcats_instances_Function1Instances$$anon$7 as $h_Lcats_instances_Function1Instances$$anon$7 };
$h_Lcats_instances_Function1Instances$$anon$7.prototype = $c_Lcats_instances_Function1Instances$$anon$7.prototype;
$c_Lcats_instances_Function1Instances$$anon$7.prototype.combineK__F1__F1__F1 = (function(x, y) {
  return $m_Lcats_data_AndThen$().apply__F1__Lcats_data_AndThen(this.Lcats_instances_Function1Instances$$anon$7__f_category.compose__O__O__O(x, y));
});
$c_Lcats_instances_Function1Instances$$anon$7.prototype.empty__O = (function() {
  return this.Lcats_instances_Function1Instances$$anon$7__f_category.id__O();
});
$c_Lcats_instances_Function1Instances$$anon$7.prototype.combineK__O__O__O = (function(x, y) {
  return this.combineK__F1__F1__F1(x, y);
});
$c_Lcats_instances_Function1Instances$$anon$7.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_MonoidK$$anon$1(this);
});
var $d_Lcats_instances_Function1Instances$$anon$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_Function1Instances$$anon$7, "cats.instances.Function1Instances$$anon$7", ({
  Lcats_instances_Function1Instances$$anon$7: 1,
  Ljava_io_Serializable: 1,
  Lcats_SemigroupK: 1,
  Lcats_MonoidK: 1
}));
export { $d_Lcats_instances_Function1Instances$$anon$7 as $d_Lcats_instances_Function1Instances$$anon$7 };
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$5(fa$20, fb$8, outer) {
  this.Lcats_instances_InvariantMonoidalInstances$$anon$5__f_fa$15 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$5__f_fb$6 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$5__f_fa$15 = fa$20;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$5__f_fb$6 = fb$8;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lcats_instances_InvariantMonoidalInstances$$anon$5 as $c_Lcats_instances_InvariantMonoidalInstances$$anon$5 };
$c_Lcats_instances_InvariantMonoidalInstances$$anon$5.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$5.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$5;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$5() {
}
export { $h_Lcats_instances_InvariantMonoidalInstances$$anon$5 as $h_Lcats_instances_InvariantMonoidalInstances$$anon$5 };
$h_Lcats_instances_InvariantMonoidalInstances$$anon$5.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$5.prototype;
$c_Lcats_instances_InvariantMonoidalInstances$$anon$5.prototype.combine__T2__T2__T2 = (function(x, y) {
  var fa$3 = this.Lcats_instances_InvariantMonoidalInstances$$anon$5__f_fa$15;
  var fb$2 = this.Lcats_instances_InvariantMonoidalInstances$$anon$5__f_fb$6;
  var self = fa$3.combine__O__O__O(x._1__O(), y._1__O());
  var y$1 = fb$2.combine__O__O__O(x._2__O(), y._2__O());
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self, y$1);
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$5.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__T2__T2__T2(x, y);
});
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_InvariantMonoidalInstances$$anon$5, "cats.instances.InvariantMonoidalInstances$$anon$5", ({
  Lcats_instances_InvariantMonoidalInstances$$anon$5: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_CommutativeSemigroup: 1
}));
export { $d_Lcats_instances_InvariantMonoidalInstances$$anon$5 as $d_Lcats_instances_InvariantMonoidalInstances$$anon$5 };
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$6(f$13, fa$21, g$13, outer) {
  this.Lcats_instances_InvariantMonoidalInstances$$anon$6__f_f$10 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$6__f_fa$16 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$6__f_g$10 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$6__f_f$10 = f$13;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$6__f_fa$16 = fa$21;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$6__f_g$10 = g$13;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lcats_instances_InvariantMonoidalInstances$$anon$6 as $c_Lcats_instances_InvariantMonoidalInstances$$anon$6 };
$c_Lcats_instances_InvariantMonoidalInstances$$anon$6.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$6.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$6;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$6() {
}
export { $h_Lcats_instances_InvariantMonoidalInstances$$anon$6 as $h_Lcats_instances_InvariantMonoidalInstances$$anon$6 };
$h_Lcats_instances_InvariantMonoidalInstances$$anon$6.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$6.prototype;
$c_Lcats_instances_InvariantMonoidalInstances$$anon$6.prototype.combine__O__O__O = (function(x, y) {
  var f$2 = this.Lcats_instances_InvariantMonoidalInstances$$anon$6__f_f$10;
  var fa$4 = this.Lcats_instances_InvariantMonoidalInstances$$anon$6__f_fa$16;
  var g$2 = this.Lcats_instances_InvariantMonoidalInstances$$anon$6__f_g$10;
  return f$2.apply__O__O(fa$4.combine__O__O__O(g$2.apply__O__O(x), g$2.apply__O__O(y)));
});
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_InvariantMonoidalInstances$$anon$6, "cats.instances.InvariantMonoidalInstances$$anon$6", ({
  Lcats_instances_InvariantMonoidalInstances$$anon$6: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_CommutativeSemigroup: 1
}));
export { $d_Lcats_instances_InvariantMonoidalInstances$$anon$6 as $d_Lcats_instances_InvariantMonoidalInstances$$anon$6 };
function $f_Lcats_instances_LazyListInstances__$init$__V($thiz) {
  $thiz.cats$instances$LazyListInstances$_setter_$catsStdInstancesForLazyList_$eq__Lcats_Align__V(new $c_Lcats_instances_LazyListInstances$$anon$1());
  $thiz.cats$instances$LazyListInstances$_setter_$catsStdTraverseFilterForLazyList_$eq__Lcats_TraverseFilter__V(new $c_Lcats_instances_LazyListInstances$$anon$3($thiz));
}
export { $f_Lcats_instances_LazyListInstances__$init$__V as $f_Lcats_instances_LazyListInstances__$init$__V };
function $ps_Lcats_instances_LazyListInstances__step$1__Lcats_Monad__F2__T2__O(G$3, f$8, in$1) {
  matchResult5: {
    var \u03b41$___1;
    var \u03b41$___2;
    if ((in$1 !== null)) {
      var s = in$1._1__O();
      var b = in$1._2__O();
      var \u03b41$___1 = s;
      var \u03b41$___2 = b;
      break matchResult5;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(in$1);
  }
  var s$2 = \u03b41$___1;
  var b$2 = \u03b41$___2;
  return ((s$2.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty) ? G$3.pure__O__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(b$2)) : G$3.map__O__F1__O(f$8.apply__O__O__O(b$2, s$2.head__O()), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((bnext) => {
    var _1 = s$2.tail__sci_LazyList();
    var value = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, bnext);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value);
  }))));
}
export { $ps_Lcats_instances_LazyListInstances__step$1__Lcats_Monad__F2__T2__O as $ps_Lcats_instances_LazyListInstances__step$1__Lcats_Monad__F2__T2__O };
/** @constructor */
function $c_Lcats_instances_LazyListInstances$$anon$3(outer) {
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  outer.catsStdInstancesForLazyList__Lcats_Align();
}
export { $c_Lcats_instances_LazyListInstances$$anon$3 as $c_Lcats_instances_LazyListInstances$$anon$3 };
$c_Lcats_instances_LazyListInstances$$anon$3.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_LazyListInstances$$anon$3.prototype.constructor = $c_Lcats_instances_LazyListInstances$$anon$3;
/** @constructor */
function $h_Lcats_instances_LazyListInstances$$anon$3() {
}
export { $h_Lcats_instances_LazyListInstances$$anon$3 as $h_Lcats_instances_LazyListInstances$$anon$3 };
$h_Lcats_instances_LazyListInstances$$anon$3.prototype = $c_Lcats_instances_LazyListInstances$$anon$3.prototype;
var $d_Lcats_instances_LazyListInstances$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_LazyListInstances$$anon$3, "cats.instances.LazyListInstances$$anon$3", ({
  Lcats_instances_LazyListInstances$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lcats_FunctorFilter: 1,
  Lcats_TraverseFilter: 1
}));
export { $d_Lcats_instances_LazyListInstances$$anon$3 as $d_Lcats_instances_LazyListInstances$$anon$3 };
/** @constructor */
function $c_Lcats_instances_OptionInstances$$anon$2(A$3, outer) {
  this.Lcats_instances_OptionInstances$$anon$2__f_A$2 = null;
  this.Lcats_instances_OptionInstances$$anon$2__f_A$2 = A$3;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lcats_instances_OptionInstances$$anon$2 as $c_Lcats_instances_OptionInstances$$anon$2 };
$c_Lcats_instances_OptionInstances$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_OptionInstances$$anon$2.prototype.constructor = $c_Lcats_instances_OptionInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_OptionInstances$$anon$2() {
}
export { $h_Lcats_instances_OptionInstances$$anon$2 as $h_Lcats_instances_OptionInstances$$anon$2 };
$h_Lcats_instances_OptionInstances$$anon$2.prototype = $c_Lcats_instances_OptionInstances$$anon$2.prototype;
$c_Lcats_instances_OptionInstances$$anon$2.prototype.show__s_Option__T = (function(x$1) {
  var A$1 = this.Lcats_instances_OptionInstances$$anon$2__f_A$2;
  if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
    var a = x$1.s_Some__f_value;
    return (("Some(" + A$1.show__O__T(a)) + ")");
  }
  var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  if ((x === x$1)) {
    return "None";
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
});
$c_Lcats_instances_OptionInstances$$anon$2.prototype.show__O__T = (function(t) {
  return this.show__s_Option__T(t);
});
var $d_Lcats_instances_OptionInstances$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_OptionInstances$$anon$2, "cats.instances.OptionInstances$$anon$2", ({
  Lcats_instances_OptionInstances$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_Show$ContravariantShow: 1,
  Lcats_Show: 1
}));
export { $d_Lcats_instances_OptionInstances$$anon$2 as $d_Lcats_instances_OptionInstances$$anon$2 };
/** @constructor */
function $c_Lcats_instances_OptionInstancesBinCompat0$$anon$3() {
  $m_Lcats_instances_package$option$();
}
export { $c_Lcats_instances_OptionInstancesBinCompat0$$anon$3 as $c_Lcats_instances_OptionInstancesBinCompat0$$anon$3 };
$c_Lcats_instances_OptionInstancesBinCompat0$$anon$3.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_OptionInstancesBinCompat0$$anon$3.prototype.constructor = $c_Lcats_instances_OptionInstancesBinCompat0$$anon$3;
/** @constructor */
function $h_Lcats_instances_OptionInstancesBinCompat0$$anon$3() {
}
export { $h_Lcats_instances_OptionInstancesBinCompat0$$anon$3 as $h_Lcats_instances_OptionInstancesBinCompat0$$anon$3 };
$h_Lcats_instances_OptionInstancesBinCompat0$$anon$3.prototype = $c_Lcats_instances_OptionInstancesBinCompat0$$anon$3.prototype;
var $d_Lcats_instances_OptionInstancesBinCompat0$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_OptionInstancesBinCompat0$$anon$3, "cats.instances.OptionInstancesBinCompat0$$anon$3", ({
  Lcats_instances_OptionInstancesBinCompat0$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lcats_FunctorFilter: 1,
  Lcats_TraverseFilter: 1
}));
export { $d_Lcats_instances_OptionInstancesBinCompat0$$anon$3 as $d_Lcats_instances_OptionInstancesBinCompat0$$anon$3 };
/** @constructor */
function $c_Lcats_instances_PartialOrderInstances$$anon$2(fa$6, fb$3, outer) {
  this.Lcats_instances_PartialOrderInstances$$anon$2__f_fa$4 = null;
  this.Lcats_instances_PartialOrderInstances$$anon$2__f_fb$2 = null;
  this.Lcats_instances_PartialOrderInstances$$anon$2__f_fa$4 = fa$6;
  this.Lcats_instances_PartialOrderInstances$$anon$2__f_fb$2 = fb$3;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lcats_instances_PartialOrderInstances$$anon$2 as $c_Lcats_instances_PartialOrderInstances$$anon$2 };
$c_Lcats_instances_PartialOrderInstances$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_PartialOrderInstances$$anon$2.prototype.constructor = $c_Lcats_instances_PartialOrderInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_PartialOrderInstances$$anon$2() {
}
export { $h_Lcats_instances_PartialOrderInstances$$anon$2 as $h_Lcats_instances_PartialOrderInstances$$anon$2 };
$h_Lcats_instances_PartialOrderInstances$$anon$2.prototype = $c_Lcats_instances_PartialOrderInstances$$anon$2.prototype;
$c_Lcats_instances_PartialOrderInstances$$anon$2.prototype.neqv__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Eq__neqv__O__O__Z(this, x, y);
});
$c_Lcats_instances_PartialOrderInstances$$anon$2.prototype.eqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_PartialOrder__eqv__O__O__Z(this, x, y);
});
$c_Lcats_instances_PartialOrderInstances$$anon$2.prototype.lt__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_PartialOrder__lt__O__O__Z(this, x, y);
});
$c_Lcats_instances_PartialOrderInstances$$anon$2.prototype.gt__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_PartialOrder__gt__O__O__Z(this, x, y);
});
$c_Lcats_instances_PartialOrderInstances$$anon$2.prototype.partialCompare__T2__T2__D = (function(x, y) {
  var fa$1 = this.Lcats_instances_PartialOrderInstances$$anon$2__f_fa$4;
  var fb$1 = this.Lcats_instances_PartialOrderInstances$$anon$2__f_fb$2;
  var z = fa$1.partialCompare__O__O__D(x._1__O(), y._1__O());
  return ((z === 0.0) ? fb$1.partialCompare__O__O__D(x._2__O(), y._2__O()) : z);
});
$c_Lcats_instances_PartialOrderInstances$$anon$2.prototype.partialCompare__O__O__D = (function(x, y) {
  return this.partialCompare__T2__T2__D(x, y);
});
var $d_Lcats_instances_PartialOrderInstances$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_PartialOrderInstances$$anon$2, "cats.instances.PartialOrderInstances$$anon$2", ({
  Lcats_instances_PartialOrderInstances$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1
}));
export { $d_Lcats_instances_PartialOrderInstances$$anon$2 as $d_Lcats_instances_PartialOrderInstances$$anon$2 };
/** @constructor */
function $c_Lcats_instances_PartialOrderingInstances$$anon$2(fa$5, f$2) {
}
export { $c_Lcats_instances_PartialOrderingInstances$$anon$2 as $c_Lcats_instances_PartialOrderingInstances$$anon$2 };
$c_Lcats_instances_PartialOrderingInstances$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_PartialOrderingInstances$$anon$2.prototype.constructor = $c_Lcats_instances_PartialOrderingInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_PartialOrderingInstances$$anon$2() {
}
export { $h_Lcats_instances_PartialOrderingInstances$$anon$2 as $h_Lcats_instances_PartialOrderingInstances$$anon$2 };
$h_Lcats_instances_PartialOrderingInstances$$anon$2.prototype = $c_Lcats_instances_PartialOrderingInstances$$anon$2.prototype;
var $d_Lcats_instances_PartialOrderingInstances$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_PartialOrderingInstances$$anon$2, "cats.instances.PartialOrderingInstances$$anon$2", ({
  Lcats_instances_PartialOrderingInstances$$anon$2: 1,
  Ljava_io_Serializable: 1,
  s_math_Equiv: 1,
  s_math_PartialOrdering: 1
}));
export { $d_Lcats_instances_PartialOrderingInstances$$anon$2 as $d_Lcats_instances_PartialOrderingInstances$$anon$2 };
/** @constructor */
function $c_Lcats_instances_PartialOrderingInstances$$anon$3(fa$6, fb$2) {
}
export { $c_Lcats_instances_PartialOrderingInstances$$anon$3 as $c_Lcats_instances_PartialOrderingInstances$$anon$3 };
$c_Lcats_instances_PartialOrderingInstances$$anon$3.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_PartialOrderingInstances$$anon$3.prototype.constructor = $c_Lcats_instances_PartialOrderingInstances$$anon$3;
/** @constructor */
function $h_Lcats_instances_PartialOrderingInstances$$anon$3() {
}
export { $h_Lcats_instances_PartialOrderingInstances$$anon$3 as $h_Lcats_instances_PartialOrderingInstances$$anon$3 };
$h_Lcats_instances_PartialOrderingInstances$$anon$3.prototype = $c_Lcats_instances_PartialOrderingInstances$$anon$3.prototype;
var $d_Lcats_instances_PartialOrderingInstances$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_PartialOrderingInstances$$anon$3, "cats.instances.PartialOrderingInstances$$anon$3", ({
  Lcats_instances_PartialOrderingInstances$$anon$3: 1,
  Ljava_io_Serializable: 1,
  s_math_Equiv: 1,
  s_math_PartialOrdering: 1
}));
export { $d_Lcats_instances_PartialOrderingInstances$$anon$3 as $d_Lcats_instances_PartialOrderingInstances$$anon$3 };
function $s_Lcats_instances_QueueInstances__cats$instances$QueueInstances$$anon$1$$_$go$1__scm_Builder__F1__sci_List__sci_Queue(bldr$1, f$4, lists) {
  var lists$tailLocal1 = lists;
  while (true) {
    var x9 = lists$tailLocal1;
    if ((x9 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon)) {
      var x12 = x9.sci_$colon$colon__f_next;
      var q = x9.sci_$colon$colon__f_head;
      if (q.isEmpty__Z()) {
        lists$tailLocal1 = x12;
        continue;
      } else {
        matchResult1: {
          var \u03b41$___1;
          var \u03b41$___2;
          var x1 = q.dequeue__T2();
          if ((x1 !== null)) {
            var e = x1._1__O();
            var es = x1._2__O();
            var \u03b41$___1 = e;
            var \u03b41$___2 = es;
            break matchResult1;
          }
          throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1);
        }
        var e$2 = \u03b41$___1;
        var es$2 = \u03b41$___2;
        if ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
          var b = e$2.s_util_Right__f_value;
          bldr$1.addOne__O__scm_Growable(b);
          lists$tailLocal1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(es$2, x12);
          continue;
        }
        if ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
          var a = e$2.s_util_Left__f_value;
          var elem$1 = f$4.apply__O__O(a);
          var this$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(es$2, x12);
          lists$tailLocal1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem$1, this$2);
          continue;
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(e$2);
      }
    }
    var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    if (x.equals__O__Z(x9)) {
      return bldr$1.result__O();
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x9);
  }
}
export { $s_Lcats_instances_QueueInstances__cats$instances$QueueInstances$$anon$1$$_$go$1__scm_Builder__F1__sci_List__sci_Queue as $s_Lcats_instances_QueueInstances__cats$instances$QueueInstances$$anon$1$$_$go$1__scm_Builder__F1__sci_List__sci_Queue };
function $ps_Lcats_instances_QueueInstances__loop$2__Lcats_Eval__F2__sci_Queue__Lcats_Eval(lb$1, f$6, as) {
  if (as.isEmpty__Z()) {
    return lb$1;
  } else {
    matchResult5: {
      var \u03b42$___1;
      var \u03b42$___2;
      var x16 = as.dequeue__T2();
      if ((x16 !== null)) {
        var h = x16._1__O();
        var t = x16._2__O();
        var \u03b42$___1 = h;
        var \u03b42$___2 = t;
        break matchResult5;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x16);
    }
    var h$2 = \u03b42$___1;
    var t$2 = \u03b42$___2;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Eval$();
    var a = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $ps_Lcats_instances_QueueInstances__loop$2__Lcats_Eval__F2__sci_Queue__Lcats_Eval(lb$1, f$6, t$2)));
    return f$6.apply__O__O__O(h$2, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Eval$$anon$5(a));
  }
}
export { $ps_Lcats_instances_QueueInstances__loop$2__Lcats_Eval__F2__sci_Queue__Lcats_Eval as $ps_Lcats_instances_QueueInstances__loop$2__Lcats_Eval__F2__sci_Queue__Lcats_Eval };
function $ps_Lcats_instances_QueueInstances__step$1__Lcats_Monad__F2__T2__O(G$2, f$10, in$1) {
  matchResult8: {
    var \u03b43$___1;
    var \u03b43$___2;
    if ((in$1 !== null)) {
      var xs = in$1._1__O();
      var b = in$1._2__O();
      var \u03b43$___1 = xs;
      var \u03b43$___2 = b;
      break matchResult8;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(in$1);
  }
  var xs$2 = \u03b43$___1;
  var b$2 = \u03b43$___2;
  if (xs$2.isEmpty__Z()) {
    return G$2.pure__O__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(b$2));
  } else {
    matchResult9: {
      var \u03b44$___1;
      var \u03b44$___2;
      var x26 = xs$2.dequeue__T2();
      if ((x26 !== null)) {
        var a = x26._1__O();
        var tail = x26._2__O();
        var \u03b44$___1 = a;
        var \u03b44$___2 = tail;
        break matchResult9;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x26);
    }
    var a$2 = \u03b44$___1;
    var tail$2 = \u03b44$___2;
    return G$2.map__O__F1__O(f$10.apply__O__O__O(b$2, a$2), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((bnext) => {
      var value = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), tail$2, bnext);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value);
    })));
  }
}
export { $ps_Lcats_instances_QueueInstances__step$1__Lcats_Monad__F2__T2__O as $ps_Lcats_instances_QueueInstances__step$1__Lcats_Monad__F2__T2__O };
function $ps_Lcats_instances_StreamInstances__step$1__Lcats_Monad__F2__T2__O(G$3, f$8, in$1) {
  matchResult5: {
    var \u03b41$___1;
    var \u03b41$___2;
    if ((in$1 !== null)) {
      var s = in$1._1__O();
      var b = in$1._2__O();
      var \u03b41$___1 = s;
      var \u03b41$___2 = b;
      break matchResult5;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(in$1);
  }
  var s$2 = \u03b41$___1;
  var b$2 = \u03b41$___2;
  return (s$2.isEmpty__Z() ? G$3.pure__O__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(b$2)) : G$3.map__O__F1__O(f$8.apply__O__O__O(b$2, s$2.head__O()), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((bnext) => {
    var _1 = s$2.tail__sci_Stream();
    var value = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, bnext);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value);
  }))));
}
export { $ps_Lcats_instances_StreamInstances__step$1__Lcats_Monad__F2__T2__O as $ps_Lcats_instances_StreamInstances__step$1__Lcats_Monad__F2__T2__O };
/** @constructor */
function $c_Lcats_instances_StreamInstances$$anon$2(fn$1, a$2) {
  this.Lcats_instances_StreamInstances$$anon$2__f_fn$2 = null;
  this.Lcats_instances_StreamInstances$$anon$2__f_stack = null;
  this.Lcats_instances_StreamInstances$$anon$2__f_state = null;
  this.Lcats_instances_StreamInstances$$anon$2__f_fn$2 = fn$1;
  this.Lcats_instances_StreamInstances$$anon$2__f_stack = fn$1.apply__O__O(a$2);
  this.Lcats_instances_StreamInstances$$anon$2__f_state = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left((void 0));
}
export { $c_Lcats_instances_StreamInstances$$anon$2 as $c_Lcats_instances_StreamInstances$$anon$2 };
$c_Lcats_instances_StreamInstances$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_StreamInstances$$anon$2.prototype.constructor = $c_Lcats_instances_StreamInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_StreamInstances$$anon$2() {
}
export { $h_Lcats_instances_StreamInstances$$anon$2 as $h_Lcats_instances_StreamInstances$$anon$2 };
$h_Lcats_instances_StreamInstances$$anon$2.prototype = $c_Lcats_instances_StreamInstances$$anon$2.prototype;
$c_Lcats_instances_StreamInstances$$anon$2.prototype.knownSize__I = (function() {
  return (-1);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.forall__F1__Z = (function(p) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.find__F1__s_Option = (function(p) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.reduceLeft__F2__O = (function(op) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.toList__sci_List = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.toVector__sci_Vector = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.reversed__sc_Iterable = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__reversed__sc_Iterable(this);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.iterator__sc_Iterator = (function() {
  return this;
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.take__I__sc_Iterator = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.drop__I__sc_Iterator = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1));
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.toString__T = (function() {
  return "<iterator>";
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.advance__V = (function() {
  while (true) {
    var x1 = this.Lcats_instances_StreamInstances$$anon$2__f_stack;
    if ((x1 !== null)) {
      var x8 = $m_s_package$$hash$colon$colon$().unapply__sci_Stream__s_Option(x1);
      if ((!x8.isEmpty__Z())) {
        var x9 = x8.get__O();
        var x10 = x9._1__O();
        var x11 = x9._2__O();
        if ((x10 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
          var b = x10.s_util_Right__f_value;
          this.Lcats_instances_StreamInstances$$anon$2__f_stack = x11;
          var value = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(b);
          this.Lcats_instances_StreamInstances$$anon$2__f_state = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value);
          return (void 0);
        }
        if ((x10 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
          var a = x10.s_util_Left__f_value;
          var prefix$1 = this.Lcats_instances_StreamInstances$$anon$2__f_fn$2.apply__O__O(a);
          var l = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((x11) => (() => x11))(x11));
          this.Lcats_instances_StreamInstances$$anon$2__f_stack = prefix$1.lazyAppendedAll__F0__sci_Stream(l);
          continue;
        }
      }
    }
    var value$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    this.Lcats_instances_StreamInstances$$anon$2__f_state = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value$1);
    return (void 0);
  }
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.hasNext__Z = (function() {
  while (true) {
    var x14 = this.Lcats_instances_StreamInstances$$anon$2__f_state;
    if ((x14 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
      var x$2 = x14.s_util_Left__f_value;
      var $x_1 = (x$2 === (void 0));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      this.advance__V();
      continue;
    }
    if ((x14 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
      var o = x14.s_util_Right__f_value;
      return (!o.isEmpty__Z());
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x14);
  }
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.next__O = (function() {
  while (true) {
    var x19 = this.Lcats_instances_StreamInstances$$anon$2__f_state;
    if ((x19 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
      var x$2 = x19.s_util_Left__f_value;
      var $x_1 = (x$2 === (void 0));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      this.advance__V();
      continue;
    }
    if ((x19 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
      var o = x19.s_util_Right__f_value;
      var b = o.get__O();
      this.advance__V();
      return b;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x19);
  }
});
var $d_Lcats_instances_StreamInstances$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_StreamInstances$$anon$2, "cats.instances.StreamInstances$$anon$2", ({
  Lcats_instances_StreamInstances$$anon$2: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_Iterator: 1
}));
export { $d_Lcats_instances_StreamInstances$$anon$2 as $d_Lcats_instances_StreamInstances$$anon$2 };
/** @constructor */
function $c_Lcats_instances_StreamInstancesBinCompat0$$anon$7() {
  $m_Lcats_instances_package$stream$();
}
export { $c_Lcats_instances_StreamInstancesBinCompat0$$anon$7 as $c_Lcats_instances_StreamInstancesBinCompat0$$anon$7 };
$c_Lcats_instances_StreamInstancesBinCompat0$$anon$7.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_StreamInstancesBinCompat0$$anon$7.prototype.constructor = $c_Lcats_instances_StreamInstancesBinCompat0$$anon$7;
/** @constructor */
function $h_Lcats_instances_StreamInstancesBinCompat0$$anon$7() {
}
export { $h_Lcats_instances_StreamInstancesBinCompat0$$anon$7 as $h_Lcats_instances_StreamInstancesBinCompat0$$anon$7 };
$h_Lcats_instances_StreamInstancesBinCompat0$$anon$7.prototype = $c_Lcats_instances_StreamInstancesBinCompat0$$anon$7.prototype;
var $d_Lcats_instances_StreamInstancesBinCompat0$$anon$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_StreamInstancesBinCompat0$$anon$7, "cats.instances.StreamInstancesBinCompat0$$anon$7", ({
  Lcats_instances_StreamInstancesBinCompat0$$anon$7: 1,
  Ljava_io_Serializable: 1,
  Lcats_FunctorFilter: 1,
  Lcats_TraverseFilter: 1
}));
export { $d_Lcats_instances_StreamInstancesBinCompat0$$anon$7 as $d_Lcats_instances_StreamInstancesBinCompat0$$anon$7 };
/** @constructor */
function $c_Lcats_instances_package$duration$() {
  this.Lcats_instances_package$duration$__f_catsStdShowForDurationUnambiguous = null;
  $n_Lcats_instances_package$duration$ = this;
  this.Lcats_instances_package$duration$__f_catsStdShowForDurationUnambiguous = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$$anon$5();
  $f_Lcats_kernel_instances_DurationInstances__$init$__V(this);
}
export { $c_Lcats_instances_package$duration$ as $c_Lcats_instances_package$duration$ };
$c_Lcats_instances_package$duration$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_package$duration$.prototype.constructor = $c_Lcats_instances_package$duration$;
/** @constructor */
function $h_Lcats_instances_package$duration$() {
}
export { $h_Lcats_instances_package$duration$ as $h_Lcats_instances_package$duration$ };
$h_Lcats_instances_package$duration$.prototype = $c_Lcats_instances_package$duration$.prototype;
$c_Lcats_instances_package$duration$.prototype.cats$kernel$instances$DurationInstances$_setter_$catsKernelStdOrderForDuration_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_instances_package$duration$.prototype.cats$kernel$instances$DurationInstances$_setter_$catsKernelStdGroupForDuration_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
var $d_Lcats_instances_package$duration$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_package$duration$, "cats.instances.package$duration$", ({
  Lcats_instances_package$duration$: 1,
  Lcats_instances_CoreDurationInstances: 1,
  Lcats_kernel_instances_DurationInstances: 1,
  Lcats_instances_DurationInstances: 1
}));
export { $d_Lcats_instances_package$duration$ as $d_Lcats_instances_package$duration$ };
var $n_Lcats_instances_package$duration$;
function $m_Lcats_instances_package$duration$() {
  if ((!$n_Lcats_instances_package$duration$)) {
    $n_Lcats_instances_package$duration$ = new $c_Lcats_instances_package$duration$();
  }
  return $n_Lcats_instances_package$duration$;
}
export { $m_Lcats_instances_package$duration$ as $m_Lcats_instances_package$duration$ };
/** @constructor */
function $c_Lcats_instances_package$eq$() {
  this.Lcats_instances_package$eq$__f_catsContravariantMonoidalForEq = null;
  $n_Lcats_instances_package$eq$ = this;
  this.Lcats_instances_package$eq$__f_catsContravariantMonoidalForEq = new $c_Lcats_instances_EqInstances$$anon$1();
}
export { $c_Lcats_instances_package$eq$ as $c_Lcats_instances_package$eq$ };
$c_Lcats_instances_package$eq$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_package$eq$.prototype.constructor = $c_Lcats_instances_package$eq$;
/** @constructor */
function $h_Lcats_instances_package$eq$() {
}
export { $h_Lcats_instances_package$eq$ as $h_Lcats_instances_package$eq$ };
$h_Lcats_instances_package$eq$.prototype = $c_Lcats_instances_package$eq$.prototype;
var $d_Lcats_instances_package$eq$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_package$eq$, "cats.instances.package$eq$", ({
  Lcats_instances_package$eq$: 1,
  Lcats_kernel_EqToEquivConversion: 1,
  Lcats_kernel_instances_EqInstances: 1,
  Lcats_instances_EqInstances: 1
}));
export { $d_Lcats_instances_package$eq$ as $d_Lcats_instances_package$eq$ };
var $n_Lcats_instances_package$eq$;
function $m_Lcats_instances_package$eq$() {
  if ((!$n_Lcats_instances_package$eq$)) {
    $n_Lcats_instances_package$eq$ = new $c_Lcats_instances_package$eq$();
  }
  return $n_Lcats_instances_package$eq$;
}
export { $m_Lcats_instances_package$eq$ as $m_Lcats_instances_package$eq$ };
/** @constructor */
function $c_Lcats_instances_package$invariant$() {
  this.Lcats_instances_package$invariant$__f_catsInvariantMonoidalSemigroup = null;
  this.Lcats_instances_package$invariant$__f_catsInvariantMonoidalCommutativeSemigroup = null;
  $n_Lcats_instances_package$invariant$ = this;
  $f_Lcats_instances_InvariantMonoidalInstances__$init$__V(this);
  $f_Lcats_instances_InvariantInstances__$init$__V(this);
}
export { $c_Lcats_instances_package$invariant$ as $c_Lcats_instances_package$invariant$ };
$c_Lcats_instances_package$invariant$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_package$invariant$.prototype.constructor = $c_Lcats_instances_package$invariant$;
/** @constructor */
function $h_Lcats_instances_package$invariant$() {
}
export { $h_Lcats_instances_package$invariant$ as $h_Lcats_instances_package$invariant$ };
$h_Lcats_instances_package$invariant$.prototype = $c_Lcats_instances_package$invariant$.prototype;
$c_Lcats_instances_package$invariant$.prototype.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalSemigroup_$eq__Lcats_InvariantMonoidal__V = (function(x$0) {
  this.Lcats_instances_package$invariant$__f_catsInvariantMonoidalSemigroup = x$0;
});
$c_Lcats_instances_package$invariant$.prototype.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalCommutativeSemigroup_$eq__Lcats_InvariantMonoidal__V = (function(x$0) {
  this.Lcats_instances_package$invariant$__f_catsInvariantMonoidalCommutativeSemigroup = x$0;
});
$c_Lcats_instances_package$invariant$.prototype.cats$instances$InvariantInstances$_setter_$catsInvariantForNumeric_$eq__Lcats_Invariant__V = (function(x$0) {
});
$c_Lcats_instances_package$invariant$.prototype.cats$instances$InvariantInstances$_setter_$catsInvariantForIntegral_$eq__Lcats_Invariant__V = (function(x$0) {
});
var $d_Lcats_instances_package$invariant$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_package$invariant$, "cats.instances.package$invariant$", ({
  Lcats_instances_package$invariant$: 1,
  Lcats_instances_InvariantMonoidalInstances: 1,
  Lcats_instances_InvariantInstances: 1,
  Lcats_instances_InvariantInstancesBinCompat0: 1
}));
export { $d_Lcats_instances_package$invariant$ as $d_Lcats_instances_package$invariant$ };
var $n_Lcats_instances_package$invariant$;
function $m_Lcats_instances_package$invariant$() {
  if ((!$n_Lcats_instances_package$invariant$)) {
    $n_Lcats_instances_package$invariant$ = new $c_Lcats_instances_package$invariant$();
  }
  return $n_Lcats_instances_package$invariant$;
}
export { $m_Lcats_instances_package$invariant$ as $m_Lcats_instances_package$invariant$ };
/** @constructor */
function $c_Lcats_instances_package$order$() {
  this.Lcats_instances_package$order$__f_catsContravariantMonoidalForOrder = null;
  $n_Lcats_instances_package$order$ = this;
  this.Lcats_instances_package$order$__f_catsContravariantMonoidalForOrder = new $c_Lcats_instances_OrderInstances$$anon$1();
}
export { $c_Lcats_instances_package$order$ as $c_Lcats_instances_package$order$ };
$c_Lcats_instances_package$order$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_package$order$.prototype.constructor = $c_Lcats_instances_package$order$;
/** @constructor */
function $h_Lcats_instances_package$order$() {
}
export { $h_Lcats_instances_package$order$ as $h_Lcats_instances_package$order$ };
$h_Lcats_instances_package$order$.prototype = $c_Lcats_instances_package$order$.prototype;
var $d_Lcats_instances_package$order$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_package$order$, "cats.instances.package$order$", ({
  Lcats_instances_package$order$: 1,
  Lcats_kernel_OrderToOrderingConversion: 1,
  Lcats_kernel_instances_OrderInstances: 1,
  Lcats_instances_OrderInstances: 1
}));
export { $d_Lcats_instances_package$order$ as $d_Lcats_instances_package$order$ };
var $n_Lcats_instances_package$order$;
function $m_Lcats_instances_package$order$() {
  if ((!$n_Lcats_instances_package$order$)) {
    $n_Lcats_instances_package$order$ = new $c_Lcats_instances_package$order$();
  }
  return $n_Lcats_instances_package$order$;
}
export { $m_Lcats_instances_package$order$ as $m_Lcats_instances_package$order$ };
/** @constructor */
function $c_Lcats_instances_package$partialOrder$() {
  this.Lcats_instances_package$partialOrder$__f_catsContravariantMonoidalForPartialOrder = null;
  $n_Lcats_instances_package$partialOrder$ = this;
  this.Lcats_instances_package$partialOrder$__f_catsContravariantMonoidalForPartialOrder = new $c_Lcats_instances_PartialOrderInstances$$anon$1();
}
export { $c_Lcats_instances_package$partialOrder$ as $c_Lcats_instances_package$partialOrder$ };
$c_Lcats_instances_package$partialOrder$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_package$partialOrder$.prototype.constructor = $c_Lcats_instances_package$partialOrder$;
/** @constructor */
function $h_Lcats_instances_package$partialOrder$() {
}
export { $h_Lcats_instances_package$partialOrder$ as $h_Lcats_instances_package$partialOrder$ };
$h_Lcats_instances_package$partialOrder$.prototype = $c_Lcats_instances_package$partialOrder$.prototype;
var $d_Lcats_instances_package$partialOrder$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_package$partialOrder$, "cats.instances.package$partialOrder$", ({
  Lcats_instances_package$partialOrder$: 1,
  Lcats_kernel_PartialOrderToPartialOrderingConversion: 1,
  Lcats_kernel_instances_PartialOrderInstances: 1,
  Lcats_instances_PartialOrderInstances: 1
}));
export { $d_Lcats_instances_package$partialOrder$ as $d_Lcats_instances_package$partialOrder$ };
var $n_Lcats_instances_package$partialOrder$;
function $m_Lcats_instances_package$partialOrder$() {
  if ((!$n_Lcats_instances_package$partialOrder$)) {
    $n_Lcats_instances_package$partialOrder$ = new $c_Lcats_instances_package$partialOrder$();
  }
  return $n_Lcats_instances_package$partialOrder$;
}
export { $m_Lcats_instances_package$partialOrder$ as $m_Lcats_instances_package$partialOrder$ };
/** @constructor */
function $c_Lcats_kernel_PartialOrder$$anon$1(ev$7, f$5) {
  this.Lcats_kernel_PartialOrder$$anon$1__f_ev$4 = null;
  this.Lcats_kernel_PartialOrder$$anon$1__f_f$3 = null;
  this.Lcats_kernel_PartialOrder$$anon$1__f_ev$4 = ev$7;
  this.Lcats_kernel_PartialOrder$$anon$1__f_f$3 = f$5;
}
export { $c_Lcats_kernel_PartialOrder$$anon$1 as $c_Lcats_kernel_PartialOrder$$anon$1 };
$c_Lcats_kernel_PartialOrder$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_kernel_PartialOrder$$anon$1.prototype.constructor = $c_Lcats_kernel_PartialOrder$$anon$1;
/** @constructor */
function $h_Lcats_kernel_PartialOrder$$anon$1() {
}
export { $h_Lcats_kernel_PartialOrder$$anon$1 as $h_Lcats_kernel_PartialOrder$$anon$1 };
$h_Lcats_kernel_PartialOrder$$anon$1.prototype = $c_Lcats_kernel_PartialOrder$$anon$1.prototype;
$c_Lcats_kernel_PartialOrder$$anon$1.prototype.neqv__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Eq__neqv__O__O__Z(this, x, y);
});
$c_Lcats_kernel_PartialOrder$$anon$1.prototype.eqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_PartialOrder__eqv__O__O__Z(this, x, y);
});
$c_Lcats_kernel_PartialOrder$$anon$1.prototype.lt__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_PartialOrder__lt__O__O__Z(this, x, y);
});
$c_Lcats_kernel_PartialOrder$$anon$1.prototype.gt__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_PartialOrder__gt__O__O__Z(this, x, y);
});
$c_Lcats_kernel_PartialOrder$$anon$1.prototype.partialCompare__O__O__D = (function(x, y) {
  var ev$1 = this.Lcats_kernel_PartialOrder$$anon$1__f_ev$4;
  var f$1 = this.Lcats_kernel_PartialOrder$$anon$1__f_f$3;
  return ev$1.partialCompare__O__O__D(f$1.apply__O__O(x), f$1.apply__O__O(y));
});
var $d_Lcats_kernel_PartialOrder$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_kernel_PartialOrder$$anon$1, "cats.kernel.PartialOrder$$anon$1", ({
  Lcats_kernel_PartialOrder$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1
}));
export { $d_Lcats_kernel_PartialOrder$$anon$1 as $d_Lcats_kernel_PartialOrder$$anon$1 };
/** @constructor */
function $c_Lcats_kernel_instances_LazyListMonoid() {
}
export { $c_Lcats_kernel_instances_LazyListMonoid as $c_Lcats_kernel_instances_LazyListMonoid };
$c_Lcats_kernel_instances_LazyListMonoid.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_kernel_instances_LazyListMonoid.prototype.constructor = $c_Lcats_kernel_instances_LazyListMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_LazyListMonoid() {
}
export { $h_Lcats_kernel_instances_LazyListMonoid as $h_Lcats_kernel_instances_LazyListMonoid };
$h_Lcats_kernel_instances_LazyListMonoid.prototype = $c_Lcats_kernel_instances_LazyListMonoid.prototype;
$c_Lcats_kernel_instances_LazyListMonoid.prototype.combineAll__sc_IterableOnce__sci_LazyList = (function(xs) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_kernel_instances_StaticMethods$().combineAllIterable__scm_Builder__sc_IterableOnce__O(($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_LazyList$(), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_LazyList$LazyBuilder()), xs);
});
$c_Lcats_kernel_instances_LazyListMonoid.prototype.empty__O = (function() {
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_LazyList$();
  return this$1.sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty;
});
$c_Lcats_kernel_instances_LazyListMonoid.prototype.combine__O__O__O = (function(x, y) {
  return x.appendedAll__sc_IterableOnce__sci_LazyList(y);
});
$c_Lcats_kernel_instances_LazyListMonoid.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return this.combineAll__sc_IterableOnce__sci_LazyList(as);
});
var $d_Lcats_kernel_instances_LazyListMonoid = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_kernel_instances_LazyListMonoid, "cats.kernel.instances.LazyListMonoid", ({
  Lcats_kernel_instances_LazyListMonoid: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
}));
export { $d_Lcats_kernel_instances_LazyListMonoid as $d_Lcats_kernel_instances_LazyListMonoid };
/** @constructor */
function $c_Lcats_kernel_instances_QueueMonoid() {
}
export { $c_Lcats_kernel_instances_QueueMonoid as $c_Lcats_kernel_instances_QueueMonoid };
$c_Lcats_kernel_instances_QueueMonoid.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_kernel_instances_QueueMonoid.prototype.constructor = $c_Lcats_kernel_instances_QueueMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_QueueMonoid() {
}
export { $h_Lcats_kernel_instances_QueueMonoid as $h_Lcats_kernel_instances_QueueMonoid };
$h_Lcats_kernel_instances_QueueMonoid.prototype = $c_Lcats_kernel_instances_QueueMonoid.prototype;
$c_Lcats_kernel_instances_QueueMonoid.prototype.empty__O = (function() {
  return $m_sci_Queue$EmptyQueue$();
});
$c_Lcats_kernel_instances_QueueMonoid.prototype.combine__O__O__O = (function(x, y) {
  return x.appendedAll__sc_IterableOnce__sci_Queue(y);
});
$c_Lcats_kernel_instances_QueueMonoid.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_kernel_instances_StaticMethods$().combineAllIterable__scm_Builder__sc_IterableOnce__O($m_sci_Queue$().newBuilder__scm_Builder(), as);
});
var $d_Lcats_kernel_instances_QueueMonoid = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_kernel_instances_QueueMonoid, "cats.kernel.instances.QueueMonoid", ({
  Lcats_kernel_instances_QueueMonoid: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
}));
export { $d_Lcats_kernel_instances_QueueMonoid as $d_Lcats_kernel_instances_QueueMonoid };
/** @constructor */
function $c_Lcats_kernel_instances_StreamMonoid() {
}
export { $c_Lcats_kernel_instances_StreamMonoid as $c_Lcats_kernel_instances_StreamMonoid };
$c_Lcats_kernel_instances_StreamMonoid.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_kernel_instances_StreamMonoid.prototype.constructor = $c_Lcats_kernel_instances_StreamMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_StreamMonoid() {
}
export { $h_Lcats_kernel_instances_StreamMonoid as $h_Lcats_kernel_instances_StreamMonoid };
$h_Lcats_kernel_instances_StreamMonoid.prototype = $c_Lcats_kernel_instances_StreamMonoid.prototype;
$c_Lcats_kernel_instances_StreamMonoid.prototype.combineAll__sc_IterableOnce__sci_Stream = (function(xs) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_kernel_instances_StaticMethods$().combineAllIterable__scm_Builder__sc_IterableOnce__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Stream$().newBuilder__scm_Builder(), xs);
});
$c_Lcats_kernel_instances_StreamMonoid.prototype.empty__O = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Stream$Empty$();
});
$c_Lcats_kernel_instances_StreamMonoid.prototype.combine__O__O__O = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOps__concat__sc_IterableOnce__O(x, y);
});
$c_Lcats_kernel_instances_StreamMonoid.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return this.combineAll__sc_IterableOnce__sci_Stream(as);
});
var $d_Lcats_kernel_instances_StreamMonoid = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_kernel_instances_StreamMonoid, "cats.kernel.instances.StreamMonoid", ({
  Lcats_kernel_instances_StreamMonoid: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
}));
export { $d_Lcats_kernel_instances_StreamMonoid as $d_Lcats_kernel_instances_StreamMonoid };
var $d_Lcom_raquo_airstream_core_Observable = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass(1, "com.raquo.airstream.core.Observable", ({
  Lcom_raquo_airstream_core_Observable: 1,
  Lcom_raquo_airstream_core_Source: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_BaseObservable: 1
}));
export { $d_Lcom_raquo_airstream_core_Observable as $d_Lcom_raquo_airstream_core_Observable };
function $f_Lcom_raquo_laminar_api_Implicits__seqToSetter__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Setter($thiz, setters, renderableSeq) {
  var fn = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((element) => {
    renderableSeq.foreach__O__F1__V(setters, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((element$2) => ((_$2) => {
      _$2.apply__Lcom_raquo_laminar_nodes_ReactiveElement__V(element$2);
    }))(element)));
  }));
  return new $c_Lcom_raquo_laminar_modifiers_Setter$$anon$2(fn);
}
export { $f_Lcom_raquo_laminar_api_Implicits__seqToSetter__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Setter as $f_Lcom_raquo_laminar_api_Implicits__seqToSetter__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Setter };
function $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($thiz, modifiers, asModifier, renderableSeq) {
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((element) => {
    renderableSeq.foreach__O__F1__V(modifiers, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((element$2) => ((_$4) => {
      asModifier.apply__O__O(_$4).apply__Lcom_raquo_laminar_nodes_ReactiveElement__V(element$2);
    }))(element)));
  }));
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_laminar_modifiers_Modifier$$anon$2(f);
}
export { $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier as $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier };
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_SimpleKeySetter$StyleSetter(key, value) {
  this.Lcom_raquo_laminar_modifiers_SimpleKeySetter__f_set = null;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_laminar_modifiers_SimpleKeySetter__Lcom_raquo_laminar_keys_SimpleKey__O__F1__F1__(this, key, value, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_modifiers_SimpleKeySetter$().com$raquo$laminar$modifiers$SimpleKeySetter$$$StyleSetter$superArg$1__Lcom_raquo_laminar_keys_StyleProp__O__F1(key, value), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_modifiers_SimpleKeySetter$().com$raquo$laminar$modifiers$SimpleKeySetter$$$StyleSetter$superArg$2__Lcom_raquo_laminar_keys_StyleProp__O__F1(key, value));
}
export { $c_Lcom_raquo_laminar_modifiers_SimpleKeySetter$StyleSetter as $c_Lcom_raquo_laminar_modifiers_SimpleKeySetter$StyleSetter };
$c_Lcom_raquo_laminar_modifiers_SimpleKeySetter$StyleSetter.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_Lcom_raquo_laminar_modifiers_SimpleKeySetter();
$c_Lcom_raquo_laminar_modifiers_SimpleKeySetter$StyleSetter.prototype.constructor = $c_Lcom_raquo_laminar_modifiers_SimpleKeySetter$StyleSetter;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_SimpleKeySetter$StyleSetter() {
}
export { $h_Lcom_raquo_laminar_modifiers_SimpleKeySetter$StyleSetter as $h_Lcom_raquo_laminar_modifiers_SimpleKeySetter$StyleSetter };
$h_Lcom_raquo_laminar_modifiers_SimpleKeySetter$StyleSetter.prototype = $c_Lcom_raquo_laminar_modifiers_SimpleKeySetter$StyleSetter.prototype;
var $d_Lcom_raquo_laminar_modifiers_SimpleKeySetter$StyleSetter = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_laminar_modifiers_SimpleKeySetter$StyleSetter, "com.raquo.laminar.modifiers.SimpleKeySetter$StyleSetter", ({
  Lcom_raquo_laminar_modifiers_SimpleKeySetter$StyleSetter: 1,
  Lcom_raquo_laminar_modifiers_SimpleKeySetter: 1,
  Lcom_raquo_laminar_modifiers_Modifier: 1,
  Lcom_raquo_laminar_modifiers_Setter: 1
}));
export { $d_Lcom_raquo_laminar_modifiers_SimpleKeySetter$StyleSetter as $d_Lcom_raquo_laminar_modifiers_SimpleKeySetter$StyleSetter };
function $ct_Lcom_raquo_waypoint_Waypoint__Lurldsl_errors_PathMatchingError__Lurldsl_errors_ParamMatchingError__Lurldsl_errors_FragmentMatchingError__($thiz, pathError, queryError, fragmentError) {
  $thiz.Lcom_raquo_waypoint_Waypoint__f_pathError = pathError;
  $thiz.Lcom_raquo_waypoint_Waypoint__f_queryError = queryError;
  $f_Lurldsl_language_PathSegmentImpl__$init$__V($thiz);
  $f_Lurldsl_language_QueryParametersImpl__$init$__V($thiz);
  return $thiz;
}
export { $ct_Lcom_raquo_waypoint_Waypoint__Lurldsl_errors_PathMatchingError__Lurldsl_errors_ParamMatchingError__Lurldsl_errors_FragmentMatchingError__ as $ct_Lcom_raquo_waypoint_Waypoint__Lurldsl_errors_PathMatchingError__Lurldsl_errors_ParamMatchingError__Lurldsl_errors_FragmentMatchingError__ };
/** @constructor */
function $c_Lcom_raquo_waypoint_Waypoint() {
  this.Lcom_raquo_waypoint_Waypoint__f_root = null;
  this.Lcom_raquo_waypoint_Waypoint__f_endOfSegments$lzy1 = null;
  this.Lcom_raquo_waypoint_Waypoint__f_endOfSegmentsbitmap$1 = false;
  this.Lcom_raquo_waypoint_Waypoint__f_pathError = null;
  this.Lcom_raquo_waypoint_Waypoint__f_queryError = null;
}
export { $c_Lcom_raquo_waypoint_Waypoint as $c_Lcom_raquo_waypoint_Waypoint };
$c_Lcom_raquo_waypoint_Waypoint.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_waypoint_Waypoint.prototype.constructor = $c_Lcom_raquo_waypoint_Waypoint;
/** @constructor */
function $h_Lcom_raquo_waypoint_Waypoint() {
}
export { $h_Lcom_raquo_waypoint_Waypoint as $h_Lcom_raquo_waypoint_Waypoint };
$h_Lcom_raquo_waypoint_Waypoint.prototype = $c_Lcom_raquo_waypoint_Waypoint.prototype;
$c_Lcom_raquo_waypoint_Waypoint.prototype.endOfSegments__Lurldsl_language_PathSegment = (function() {
  if ((!this.Lcom_raquo_waypoint_Waypoint__f_endOfSegmentsbitmap$1)) {
    this.Lcom_raquo_waypoint_Waypoint__f_endOfSegments$lzy1 = $m_Lurldsl_language_PathSegment$().endOfSegments__Lurldsl_errors_PathMatchingError__Lurldsl_language_PathSegment(this.Lcom_raquo_waypoint_Waypoint__f_pathError);
    this.Lcom_raquo_waypoint_Waypoint__f_endOfSegmentsbitmap$1 = true;
  }
  return this.Lcom_raquo_waypoint_Waypoint__f_endOfSegments$lzy1;
});
/** @constructor */
function $c_Lframework_auth_SupabaseAuthClient$AuthStateChange(event, maybeSession) {
  this.Lframework_auth_SupabaseAuthClient$AuthStateChange__f_event = null;
  this.Lframework_auth_SupabaseAuthClient$AuthStateChange__f_maybeSession = null;
  this.Lframework_auth_SupabaseAuthClient$AuthStateChange__f_event = event;
  this.Lframework_auth_SupabaseAuthClient$AuthStateChange__f_maybeSession = maybeSession;
}
export { $c_Lframework_auth_SupabaseAuthClient$AuthStateChange as $c_Lframework_auth_SupabaseAuthClient$AuthStateChange };
$c_Lframework_auth_SupabaseAuthClient$AuthStateChange.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_auth_SupabaseAuthClient$AuthStateChange.prototype.constructor = $c_Lframework_auth_SupabaseAuthClient$AuthStateChange;
/** @constructor */
function $h_Lframework_auth_SupabaseAuthClient$AuthStateChange() {
}
export { $h_Lframework_auth_SupabaseAuthClient$AuthStateChange as $h_Lframework_auth_SupabaseAuthClient$AuthStateChange };
$h_Lframework_auth_SupabaseAuthClient$AuthStateChange.prototype = $c_Lframework_auth_SupabaseAuthClient$AuthStateChange.prototype;
$c_Lframework_auth_SupabaseAuthClient$AuthStateChange.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_auth_SupabaseAuthClient$AuthStateChange.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 20098906, true);
});
$c_Lframework_auth_SupabaseAuthClient$AuthStateChange.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lframework_auth_SupabaseAuthClient$AuthStateChange)) {
    var x = this.Lframework_auth_SupabaseAuthClient$AuthStateChange__f_event;
    var x$2 = x$0.Lframework_auth_SupabaseAuthClient$AuthStateChange__f_event;
    if ((x === x$2)) {
      var x$3 = this.Lframework_auth_SupabaseAuthClient$AuthStateChange__f_maybeSession;
      var x$4 = x$0.Lframework_auth_SupabaseAuthClient$AuthStateChange__f_maybeSession;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lframework_auth_SupabaseAuthClient$AuthStateChange.prototype.productArity__I = (function() {
  return 2;
});
$c_Lframework_auth_SupabaseAuthClient$AuthStateChange.prototype.productPrefix__T = (function() {
  return "AuthStateChange";
});
$c_Lframework_auth_SupabaseAuthClient$AuthStateChange.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_auth_SupabaseAuthClient$AuthStateChange__f_event;
  }
  if ((n === 1)) {
    return this.Lframework_auth_SupabaseAuthClient$AuthStateChange__f_maybeSession;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_auth_SupabaseAuthClient$AuthStateChange.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "event";
  }
  if ((n === 1)) {
    return "maybeSession";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_auth_SupabaseAuthClient$AuthStateChange.prototype.toString__T = (function() {
  var $x_5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
  var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["AuthStateChange(event=", ", session=", ")"]));
  var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
  var $x_4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
  var $x_3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(this.Lframework_auth_SupabaseAuthClient$AuthStateChange__f_event, $m_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$().show__Lcats_Show()));
  var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$();
  var this$5 = this.Lframework_auth_SupabaseAuthClient$AuthStateChange__f_maybeSession;
  if (this$5.isEmpty__Z()) {
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0 = this$5.get__O();
    var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(JSON.stringify(x0, (void 0), 2));
  }
  var evidence$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString;
  var this$8 = $m_Lcats_instances_package$option$();
  return $x_5.show$extension__s_StringContext__sci_Seq__T(sc, $x_4.genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([$x_3, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($x_2.mat__O__Lcats_Show$ContravariantShow__T($x_1, new $c_Lcats_instances_OptionInstances$$anon$2(evidence$1, this$8)))])));
});
function $isArrayOf_Lframework_auth_SupabaseAuthClient$AuthStateChange(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_auth_SupabaseAuthClient$AuthStateChange)));
}
export { $isArrayOf_Lframework_auth_SupabaseAuthClient$AuthStateChange as $isArrayOf_Lframework_auth_SupabaseAuthClient$AuthStateChange };
var $d_Lframework_auth_SupabaseAuthClient$AuthStateChange = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_auth_SupabaseAuthClient$AuthStateChange, "framework.auth.SupabaseAuthClient$AuthStateChange", ({
  Lframework_auth_SupabaseAuthClient$AuthStateChange: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_auth_SupabaseAuthClient$AuthStateChange as $d_Lframework_auth_SupabaseAuthClient$AuthStateChange };
/** @constructor */
function $c_Lframework_components_FrameworkMainModal$DataBox(outer, data, closed) {
  this.Lframework_components_FrameworkMainModal$DataBox__f_data = null;
  this.Lframework_components_FrameworkMainModal$DataBox__f_closed = null;
  this.Lframework_components_FrameworkMainModal$DataBox__f_$outer = null;
  this.Lframework_components_FrameworkMainModal$DataBox__f_data = data;
  this.Lframework_components_FrameworkMainModal$DataBox__f_closed = closed;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lframework_components_FrameworkMainModal$DataBox__f_$outer = outer;
}
export { $c_Lframework_components_FrameworkMainModal$DataBox as $c_Lframework_components_FrameworkMainModal$DataBox };
$c_Lframework_components_FrameworkMainModal$DataBox.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_components_FrameworkMainModal$DataBox.prototype.constructor = $c_Lframework_components_FrameworkMainModal$DataBox;
/** @constructor */
function $h_Lframework_components_FrameworkMainModal$DataBox() {
}
export { $h_Lframework_components_FrameworkMainModal$DataBox as $h_Lframework_components_FrameworkMainModal$DataBox };
$h_Lframework_components_FrameworkMainModal$DataBox.prototype = $c_Lframework_components_FrameworkMainModal$DataBox.prototype;
$c_Lframework_components_FrameworkMainModal$DataBox.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_components_FrameworkMainModal$DataBox.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1002125438, true);
});
$c_Lframework_components_FrameworkMainModal$DataBox.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Lframework_components_FrameworkMainModal$DataBox) && (x$0.Lframework_components_FrameworkMainModal$DataBox__f_$outer === this.Lframework_components_FrameworkMainModal$DataBox__f_$outer))) {
    var x = this.Lframework_components_FrameworkMainModal$DataBox__f_data;
    var x$2 = x$0.Lframework_components_FrameworkMainModal$DataBox__f_data;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lframework_components_FrameworkMainModal$DataBox__f_closed;
      var x$4 = x$0.Lframework_components_FrameworkMainModal$DataBox__f_closed;
      return (x$3 === x$4);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lframework_components_FrameworkMainModal$DataBox.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lframework_components_FrameworkMainModal$DataBox.prototype.productArity__I = (function() {
  return 2;
});
$c_Lframework_components_FrameworkMainModal$DataBox.prototype.productPrefix__T = (function() {
  return "DataBox";
});
$c_Lframework_components_FrameworkMainModal$DataBox.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_components_FrameworkMainModal$DataBox__f_data;
  }
  if ((n === 1)) {
    return this.Lframework_components_FrameworkMainModal$DataBox__f_closed;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_components_FrameworkMainModal$DataBox.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "data";
  }
  if ((n === 1)) {
    return "closed";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lframework_components_FrameworkMainModal$DataBox(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_components_FrameworkMainModal$DataBox)));
}
export { $isArrayOf_Lframework_components_FrameworkMainModal$DataBox as $isArrayOf_Lframework_components_FrameworkMainModal$DataBox };
var $d_Lframework_components_FrameworkMainModal$DataBox = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_components_FrameworkMainModal$DataBox, "framework.components.FrameworkMainModal$DataBox", ({
  Lframework_components_FrameworkMainModal$DataBox: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_components_FrameworkMainModal$DataBox as $d_Lframework_components_FrameworkMainModal$DataBox };
/** @constructor */
function $c_Lframework_components_ToastData(message, toastType, showCloseButton, duration) {
  this.Lframework_components_ToastData__f_message = null;
  this.Lframework_components_ToastData__f_toastType = null;
  this.Lframework_components_ToastData__f_showCloseButton = false;
  this.Lframework_components_ToastData__f_duration = null;
  this.Lframework_components_ToastData__f_message = message;
  this.Lframework_components_ToastData__f_toastType = toastType;
  this.Lframework_components_ToastData__f_showCloseButton = showCloseButton;
  this.Lframework_components_ToastData__f_duration = duration;
}
export { $c_Lframework_components_ToastData as $c_Lframework_components_ToastData };
$c_Lframework_components_ToastData.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_components_ToastData.prototype.constructor = $c_Lframework_components_ToastData;
/** @constructor */
function $h_Lframework_components_ToastData() {
}
export { $h_Lframework_components_ToastData as $h_Lframework_components_ToastData };
$h_Lframework_components_ToastData.prototype = $c_Lframework_components_ToastData.prototype;
$c_Lframework_components_ToastData.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_components_ToastData.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, (-2028753327));
  var hash$1 = acc;
  var x = this.Lframework_components_ToastData__f_message;
  var data = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data);
  var hash$2 = acc;
  var x$1 = this.Lframework_components_ToastData__f_toastType;
  var data$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$1);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$2, data$1);
  var hash$3 = acc;
  var data$2 = (this.Lframework_components_ToastData__f_showCloseButton ? 1231 : 1237);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$3, data$2);
  var hash$4 = acc;
  var x$2 = this.Lframework_components_ToastData__f_duration;
  var data$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$2);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$4, data$3);
  var hash$5 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$5, 4);
});
$c_Lframework_components_ToastData.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lframework_components_ToastData)) {
    if ((this.Lframework_components_ToastData__f_showCloseButton === x$0.Lframework_components_ToastData__f_showCloseButton)) {
      var x = this.Lframework_components_ToastData__f_message;
      var y = x$0.Lframework_components_ToastData__f_message;
      var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$1 = this.Lframework_components_ToastData__f_toastType;
      var x$2 = x$0.Lframework_components_ToastData__f_toastType;
      var $x_1 = (x$1 === x$2);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.Lframework_components_ToastData__f_duration;
      var x$4 = x$0.Lframework_components_ToastData__f_duration;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lframework_components_ToastData.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lframework_components_ToastData.prototype.productArity__I = (function() {
  return 4;
});
$c_Lframework_components_ToastData.prototype.productPrefix__T = (function() {
  return "ToastData";
});
$c_Lframework_components_ToastData.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lframework_components_ToastData__f_message;
      break;
    }
    case 1: {
      return this.Lframework_components_ToastData__f_toastType;
      break;
    }
    case 2: {
      return this.Lframework_components_ToastData__f_showCloseButton;
      break;
    }
    case 3: {
      return this.Lframework_components_ToastData__f_duration;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lframework_components_ToastData.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "message";
      break;
    }
    case 1: {
      return "toastType";
      break;
    }
    case 2: {
      return "showCloseButton";
      break;
    }
    case 3: {
      return "duration";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lframework_components_ToastData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_components_ToastData)));
}
export { $isArrayOf_Lframework_components_ToastData as $isArrayOf_Lframework_components_ToastData };
var $d_Lframework_components_ToastData = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_components_ToastData, "framework.components.ToastData", ({
  Lframework_components_ToastData: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_components_ToastData as $d_Lframework_components_ToastData };
/** @constructor */
function $c_Lframework_data_AppBaseUri$$anon$1() {
}
export { $c_Lframework_data_AppBaseUri$$anon$1 as $c_Lframework_data_AppBaseUri$$anon$1 };
$c_Lframework_data_AppBaseUri$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_AppBaseUri$$anon$1.prototype.constructor = $c_Lframework_data_AppBaseUri$$anon$1;
/** @constructor */
function $h_Lframework_data_AppBaseUri$$anon$1() {
}
export { $h_Lframework_data_AppBaseUri$$anon$1 as $h_Lframework_data_AppBaseUri$$anon$1 };
$h_Lframework_data_AppBaseUri$$anon$1.prototype = $c_Lframework_data_AppBaseUri$$anon$1.prototype;
$c_Lframework_data_AppBaseUri$$anon$1.prototype.show__O__T = (function(t) {
  return $f_Lframework_data_AppBaseUri__toString__T(t);
});
var $d_Lframework_data_AppBaseUri$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_AppBaseUri$$anon$1, "framework.data.AppBaseUri$$anon$1", ({
  Lframework_data_AppBaseUri$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Show$ContravariantShow: 1,
  Lcats_Show: 1
}));
export { $d_Lframework_data_AppBaseUri$$anon$1 as $d_Lframework_data_AppBaseUri$$anon$1 };
/** @constructor */
function $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage(outer, page) {
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage__f_page = null;
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage__f_$outer = null;
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage__f_page = page;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage__f_$outer = outer;
}
export { $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage as $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage };
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage.prototype.constructor = $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage;
/** @constructor */
function $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage() {
}
export { $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage as $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage };
$h_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage.prototype = $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage.prototype;
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1321456163), true);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage) && (x$0.Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage__f_$outer === this.Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage__f_$outer))) {
    var x = this.Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage__f_page;
    var y = x$0.Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage__f_page;
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage.prototype.productArity__I = (function() {
  return 1;
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage.prototype.productPrefix__T = (function() {
  return "RootPage";
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage__f_page;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "page";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage)));
}
export { $isArrayOf_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage as $isArrayOf_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage };
var $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage, "framework.data.AuthPlatformForClientAndServerSideAuth$RootPage", ({
  Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage as $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage };
/** @constructor */
function $c_Lframework_data_AuthToken$$anon$1(evidence$1$5) {
  this.Lframework_data_AuthToken$$anon$1__f_evidence$1$4 = null;
  this.Lframework_data_AuthToken$$anon$1__f_evidence$1$4 = evidence$1$5;
}
export { $c_Lframework_data_AuthToken$$anon$1 as $c_Lframework_data_AuthToken$$anon$1 };
$c_Lframework_data_AuthToken$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_AuthToken$$anon$1.prototype.constructor = $c_Lframework_data_AuthToken$$anon$1;
/** @constructor */
function $h_Lframework_data_AuthToken$$anon$1() {
}
export { $h_Lframework_data_AuthToken$$anon$1 as $h_Lframework_data_AuthToken$$anon$1 };
$h_Lframework_data_AuthToken$$anon$1.prototype = $c_Lframework_data_AuthToken$$anon$1.prototype;
$c_Lframework_data_AuthToken$$anon$1.prototype.show__Lframework_data_AuthToken__T = (function(_$5) {
  var evidence$1$3 = this.Lframework_data_AuthToken$$anon$1__f_evidence$1$4;
  return _$5.asString__Lio_circe_Encoder__T(evidence$1$3);
});
$c_Lframework_data_AuthToken$$anon$1.prototype.show__O__T = (function(t) {
  return this.show__Lframework_data_AuthToken__T(t);
});
var $d_Lframework_data_AuthToken$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_AuthToken$$anon$1, "framework.data.AuthToken$$anon$1", ({
  Lframework_data_AuthToken$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Show$ContravariantShow: 1,
  Lcats_Show: 1
}));
export { $d_Lframework_data_AuthToken$$anon$1 as $d_Lframework_data_AuthToken$$anon$1 };
/** @constructor */
function $c_Lframework_data_CookieNameFor(name) {
  this.Lframework_data_CookieNameFor__f_name = null;
  this.Lframework_data_CookieNameFor__f_name = name;
}
export { $c_Lframework_data_CookieNameFor as $c_Lframework_data_CookieNameFor };
$c_Lframework_data_CookieNameFor.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_CookieNameFor.prototype.constructor = $c_Lframework_data_CookieNameFor;
/** @constructor */
function $h_Lframework_data_CookieNameFor() {
}
export { $h_Lframework_data_CookieNameFor as $h_Lframework_data_CookieNameFor };
$h_Lframework_data_CookieNameFor.prototype = $c_Lframework_data_CookieNameFor.prototype;
$c_Lframework_data_CookieNameFor.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_data_CookieNameFor.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1006610397), true);
});
$c_Lframework_data_CookieNameFor.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lframework_data_CookieNameFor) && (this.Lframework_data_CookieNameFor__f_name === x$0.Lframework_data_CookieNameFor__f_name)));
});
$c_Lframework_data_CookieNameFor.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lframework_data_CookieNameFor.prototype.productArity__I = (function() {
  return 1;
});
$c_Lframework_data_CookieNameFor.prototype.productPrefix__T = (function() {
  return "CookieNameFor";
});
$c_Lframework_data_CookieNameFor.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_data_CookieNameFor__f_name;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_CookieNameFor.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "name";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lframework_data_CookieNameFor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_data_CookieNameFor)));
}
export { $isArrayOf_Lframework_data_CookieNameFor as $isArrayOf_Lframework_data_CookieNameFor };
var $d_Lframework_data_CookieNameFor = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_CookieNameFor, "framework.data.CookieNameFor", ({
  Lframework_data_CookieNameFor: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_data_CookieNameFor as $d_Lframework_data_CookieNameFor };
/** @constructor */
function $c_Lframework_data_CookieNameFor$$anon$1() {
}
export { $c_Lframework_data_CookieNameFor$$anon$1 as $c_Lframework_data_CookieNameFor$$anon$1 };
$c_Lframework_data_CookieNameFor$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_CookieNameFor$$anon$1.prototype.constructor = $c_Lframework_data_CookieNameFor$$anon$1;
/** @constructor */
function $h_Lframework_data_CookieNameFor$$anon$1() {
}
export { $h_Lframework_data_CookieNameFor$$anon$1 as $h_Lframework_data_CookieNameFor$$anon$1 };
$h_Lframework_data_CookieNameFor$$anon$1.prototype = $c_Lframework_data_CookieNameFor$$anon$1.prototype;
$c_Lframework_data_CookieNameFor$$anon$1.prototype.show__O__T = (function(t) {
  return t.Lframework_data_CookieNameFor__f_name;
});
var $d_Lframework_data_CookieNameFor$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_CookieNameFor$$anon$1, "framework.data.CookieNameFor$$anon$1", ({
  Lframework_data_CookieNameFor$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Show$ContravariantShow: 1,
  Lcats_Show: 1
}));
export { $d_Lframework_data_CookieNameFor$$anon$1 as $d_Lframework_data_CookieNameFor$$anon$1 };
/** @constructor */
function $c_Lframework_data_Email$package$Email$NotAnEmail(email) {
  this.Lframework_data_Email$package$Email$NotAnEmail__f_email = null;
  this.Lframework_data_Email$package$Email$NotAnEmail__f_email = email;
}
export { $c_Lframework_data_Email$package$Email$NotAnEmail as $c_Lframework_data_Email$package$Email$NotAnEmail };
$c_Lframework_data_Email$package$Email$NotAnEmail.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_Email$package$Email$NotAnEmail.prototype.constructor = $c_Lframework_data_Email$package$Email$NotAnEmail;
/** @constructor */
function $h_Lframework_data_Email$package$Email$NotAnEmail() {
}
export { $h_Lframework_data_Email$package$Email$NotAnEmail as $h_Lframework_data_Email$package$Email$NotAnEmail };
$h_Lframework_data_Email$package$Email$NotAnEmail.prototype = $c_Lframework_data_Email$package$Email$NotAnEmail.prototype;
$c_Lframework_data_Email$package$Email$NotAnEmail.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_data_Email$package$Email$NotAnEmail.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 2144141719, true);
});
$c_Lframework_data_Email$package$Email$NotAnEmail.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lframework_data_Email$package$Email$NotAnEmail) && (this.Lframework_data_Email$package$Email$NotAnEmail__f_email === x$0.Lframework_data_Email$package$Email$NotAnEmail__f_email)));
});
$c_Lframework_data_Email$package$Email$NotAnEmail.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lframework_data_Email$package$Email$NotAnEmail.prototype.productArity__I = (function() {
  return 1;
});
$c_Lframework_data_Email$package$Email$NotAnEmail.prototype.productPrefix__T = (function() {
  return "NotAnEmail";
});
$c_Lframework_data_Email$package$Email$NotAnEmail.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_data_Email$package$Email$NotAnEmail__f_email;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_Email$package$Email$NotAnEmail.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "email";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lframework_data_Email$package$Email$NotAnEmail(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_data_Email$package$Email$NotAnEmail)));
}
export { $isArrayOf_Lframework_data_Email$package$Email$NotAnEmail as $isArrayOf_Lframework_data_Email$package$Email$NotAnEmail };
var $d_Lframework_data_Email$package$Email$NotAnEmail = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_Email$package$Email$NotAnEmail, "framework.data.Email$package$Email$NotAnEmail", ({
  Lframework_data_Email$package$Email$NotAnEmail: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_data_Email$package$Email$NotAnEmail as $d_Lframework_data_Email$package$Email$NotAnEmail };
/** @constructor */
function $c_Lframework_data_Email$package$Email$Validated$$anon$2(outer) {
  this.Lframework_data_Email$package$Email$Validated$$anon$2__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lframework_data_Email$package$Email$Validated$$anon$2__f_$outer = outer;
}
export { $c_Lframework_data_Email$package$Email$Validated$$anon$2 as $c_Lframework_data_Email$package$Email$Validated$$anon$2 };
$c_Lframework_data_Email$package$Email$Validated$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_Email$package$Email$Validated$$anon$2.prototype.constructor = $c_Lframework_data_Email$package$Email$Validated$$anon$2;
/** @constructor */
function $h_Lframework_data_Email$package$Email$Validated$$anon$2() {
}
export { $h_Lframework_data_Email$package$Email$Validated$$anon$2 as $h_Lframework_data_Email$package$Email$Validated$$anon$2 };
$h_Lframework_data_Email$package$Email$Validated$$anon$2.prototype = $c_Lframework_data_Email$package$Email$Validated$$anon$2.prototype;
$c_Lframework_data_Email$package$Email$Validated$$anon$2.prototype.show__T__T = (function(v) {
  $m_Lframework_data_Email$package$Email$();
  return v;
});
$c_Lframework_data_Email$package$Email$Validated$$anon$2.prototype.show__O__T = (function(t) {
  return this.show__T__T(t);
});
var $d_Lframework_data_Email$package$Email$Validated$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_Email$package$Email$Validated$$anon$2, "framework.data.Email$package$Email$Validated$$anon$2", ({
  Lframework_data_Email$package$Email$Validated$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_Show$ContravariantShow: 1,
  Lcats_Show: 1
}));
export { $d_Lframework_data_Email$package$Email$Validated$$anon$2 as $d_Lframework_data_Email$package$Email$Validated$$anon$2 };
/** @constructor */
function $c_Lframework_data_Email$package$Email$Validated$ValidationError(outer, email, failed) {
  this.Lframework_data_Email$package$Email$Validated$ValidationError__f_email = null;
  this.Lframework_data_Email$package$Email$Validated$ValidationError__f_failed = null;
  this.Lframework_data_Email$package$Email$Validated$ValidationError__f_$outer = null;
  this.Lframework_data_Email$package$Email$Validated$ValidationError__f_email = email;
  this.Lframework_data_Email$package$Email$Validated$ValidationError__f_failed = failed;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lframework_data_Email$package$Email$Validated$ValidationError__f_$outer = outer;
}
export { $c_Lframework_data_Email$package$Email$Validated$ValidationError as $c_Lframework_data_Email$package$Email$Validated$ValidationError };
$c_Lframework_data_Email$package$Email$Validated$ValidationError.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_Email$package$Email$Validated$ValidationError.prototype.constructor = $c_Lframework_data_Email$package$Email$Validated$ValidationError;
/** @constructor */
function $h_Lframework_data_Email$package$Email$Validated$ValidationError() {
}
export { $h_Lframework_data_Email$package$Email$Validated$ValidationError as $h_Lframework_data_Email$package$Email$Validated$ValidationError };
$h_Lframework_data_Email$package$Email$Validated$ValidationError.prototype = $c_Lframework_data_Email$package$Email$Validated$ValidationError.prototype;
$c_Lframework_data_Email$package$Email$Validated$ValidationError.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_data_Email$package$Email$Validated$ValidationError.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1262516101), true);
});
$c_Lframework_data_Email$package$Email$Validated$ValidationError.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Lframework_data_Email$package$Email$Validated$ValidationError) && (x$0.Lframework_data_Email$package$Email$Validated$ValidationError__f_$outer === this.Lframework_data_Email$package$Email$Validated$ValidationError__f_$outer))) {
    if ((this.Lframework_data_Email$package$Email$Validated$ValidationError__f_email === x$0.Lframework_data_Email$package$Email$Validated$ValidationError__f_email)) {
      var x = this.Lframework_data_Email$package$Email$Validated$ValidationError__f_failed;
      var x$2 = x$0.Lframework_data_Email$package$Email$Validated$ValidationError__f_failed;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lframework_data_Email$package$Email$Validated$ValidationError.prototype.productArity__I = (function() {
  return 2;
});
$c_Lframework_data_Email$package$Email$Validated$ValidationError.prototype.productPrefix__T = (function() {
  return "ValidationError";
});
$c_Lframework_data_Email$package$Email$Validated$ValidationError.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_data_Email$package$Email$Validated$ValidationError__f_email;
  }
  if ((n === 1)) {
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_data_NonEmptyVector(this.Lframework_data_Email$package$Email$Validated$ValidationError__f_failed);
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_Email$package$Email$Validated$ValidationError.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "email";
  }
  if ((n === 1)) {
    return "failed";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_Email$package$Email$Validated$ValidationError.prototype.toString__T = (function() {
  return "Invalid email format.";
});
function $isArrayOf_Lframework_data_Email$package$Email$Validated$ValidationError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_data_Email$package$Email$Validated$ValidationError)));
}
export { $isArrayOf_Lframework_data_Email$package$Email$Validated$ValidationError as $isArrayOf_Lframework_data_Email$package$Email$Validated$ValidationError };
var $d_Lframework_data_Email$package$Email$Validated$ValidationError = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_Email$package$Email$Validated$ValidationError, "framework.data.Email$package$Email$Validated$ValidationError", ({
  Lframework_data_Email$package$Email$Validated$ValidationError: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_data_Email$package$Email$Validated$ValidationError as $d_Lframework_data_Email$package$Email$Validated$ValidationError };
/** @constructor */
function $c_Lframework_data_EndpointSSEWithWS(sse, webSocket, evidence$1) {
  this.Lframework_data_EndpointSSEWithWS__f_sse = null;
  this.Lframework_data_EndpointSSEWithWS__f_webSocket = null;
  this.Lframework_data_EndpointSSEWithWS__f_webSocketAsSSE = null;
  this.Lframework_data_EndpointSSEWithWS__f_sse = sse;
  this.Lframework_data_EndpointSSEWithWS__f_webSocket = webSocket;
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((pipe) => pipe.apply__O__O($m_Lfs2_Stream$().Lfs2_Stream$__f_empty)));
  var g = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((outputStream) => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((outputStream$2) => ((inputStream) => inputStream.mergeHaltBoth__Lfs2_Stream__Lcats_effect_kernel_GenConcurrent__Lfs2_Stream(outputStream$2, evidence$1)))(outputStream))));
  this.Lframework_data_EndpointSSEWithWS__f_webSocketAsSSE = $f_Lsttp_tapir_EndpointOutputsOps__mapOut__F1__F1__O(webSocket, f, g);
}
export { $c_Lframework_data_EndpointSSEWithWS as $c_Lframework_data_EndpointSSEWithWS };
$c_Lframework_data_EndpointSSEWithWS.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_EndpointSSEWithWS.prototype.constructor = $c_Lframework_data_EndpointSSEWithWS;
/** @constructor */
function $h_Lframework_data_EndpointSSEWithWS() {
}
export { $h_Lframework_data_EndpointSSEWithWS as $h_Lframework_data_EndpointSSEWithWS };
$h_Lframework_data_EndpointSSEWithWS.prototype = $c_Lframework_data_EndpointSSEWithWS.prototype;
$c_Lframework_data_EndpointSSEWithWS.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_data_EndpointSSEWithWS.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1519679071, true);
});
$c_Lframework_data_EndpointSSEWithWS.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lframework_data_EndpointSSEWithWS)) {
    var x = this.Lframework_data_EndpointSSEWithWS__f_sse;
    var x$2 = x$0.Lframework_data_EndpointSSEWithWS__f_sse;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lframework_data_EndpointSSEWithWS__f_webSocket;
      var x$4 = x$0.Lframework_data_EndpointSSEWithWS__f_webSocket;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lframework_data_EndpointSSEWithWS.prototype.productArity__I = (function() {
  return 2;
});
$c_Lframework_data_EndpointSSEWithWS.prototype.productPrefix__T = (function() {
  return "EndpointSSEWithWS";
});
$c_Lframework_data_EndpointSSEWithWS.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_data_EndpointSSEWithWS__f_sse;
  }
  if ((n === 1)) {
    return this.Lframework_data_EndpointSSEWithWS__f_webSocket;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_EndpointSSEWithWS.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "sse";
  }
  if ((n === 1)) {
    return "webSocket";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_EndpointSSEWithWS.prototype.showShort__T = (function() {
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
  var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["EndpointSSEWithWS(", ", ", ")"]));
  var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
  return $x_1.show$extension__s_StringContext__sci_Seq__T(sc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(this.Lframework_data_EndpointSSEWithWS__f_sse.showShort__T(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString)), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(this.Lframework_data_EndpointSSEWithWS__f_webSocket.showShort__T(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))])));
});
$c_Lframework_data_EndpointSSEWithWS.prototype.toString__T = (function() {
  return this.showShort__T();
});
function $isArrayOf_Lframework_data_EndpointSSEWithWS(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_data_EndpointSSEWithWS)));
}
export { $isArrayOf_Lframework_data_EndpointSSEWithWS as $isArrayOf_Lframework_data_EndpointSSEWithWS };
var $d_Lframework_data_EndpointSSEWithWS = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_EndpointSSEWithWS, "framework.data.EndpointSSEWithWS", ({
  Lframework_data_EndpointSSEWithWS: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_data_EndpointSSEWithWS as $d_Lframework_data_EndpointSSEWithWS };
function $f_Lframework_data_FrameworkDateTime$Newtype__given_Ordering_Type__s_math_Ordering($thiz) {
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((v1) => {
    var v = ((v1 === null) ? null : v1.Lframework_data_FrameworkDateTime__f_ldt);
    var v$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lframework_data_FrameworkDateTime(v);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lframework_data_FrameworkDateTime(v$1.Lframework_data_FrameworkDateTime__f_ldt);
  }));
  var ord = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_data_FrameworkDateTime$().given_Ordering_FrameworkDateTime__s_math_Ordering();
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_math_Ordering$$anon$5(ord, f);
}
export { $f_Lframework_data_FrameworkDateTime$Newtype__given_Ordering_Type__s_math_Ordering as $f_Lframework_data_FrameworkDateTime$Newtype__given_Ordering_Type__s_math_Ordering };
function $f_Lframework_data_FrameworkDateTime$Newtype__fromString__T__Ljava_time_format_DateTimeFormatter__s_util_Either($thiz, str, formatter) {
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_data_FrameworkDateTime$().fromString__T__Ljava_time_format_DateTimeFormatter__s_util_Either(str, formatter);
  var this$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Either$LeftProjection(this$1);
  var x1 = this$2.s_util_Either$LeftProjection__f_e;
  if ((x1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
    var a = x1.s_util_Left__f_value;
    var this$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
    var elems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lframework_data_FrameworkDateTime$Newtype$CannotParseError.getArrayOf().constr)([$thiz.CannotParseError__Lframework_data_FrameworkDateTime$Newtype$CannotParseError$().apply__T__T__Ljava_time_format_DateTimeFormatter__Lframework_data_FrameworkDateTime$Newtype$CannotParseError(str, a, formatter)]));
    var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(this$3.from__sc_IterableOnce__sci_Vector(elems));
  } else {
    var $x_1 = this$2.s_util_Either$LeftProjection__f_e;
  }
  var this$4 = $x_1;
  if ((this$4 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
    var b = this$4.s_util_Right__f_value;
    var _$9 = ((b === null) ? null : b.Lframework_data_FrameworkDateTime__f_ldt);
    return $thiz.make__Lyantl_INewtype$make$().apply__O__s_util_Either(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lframework_data_FrameworkDateTime(_$9));
  } else {
    return this$4;
  }
}
export { $f_Lframework_data_FrameworkDateTime$Newtype__fromString__T__Ljava_time_format_DateTimeFormatter__s_util_Either as $f_Lframework_data_FrameworkDateTime$Newtype__fromString__T__Ljava_time_format_DateTimeFormatter__s_util_Either };
function $f_Lframework_data_FrameworkDateTime$Newtype__asString__Ljava_time_LocalDateTime__T($thiz, value) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_data_FrameworkDateTime$();
  var v = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lframework_data_FrameworkDateTime(value);
  var this$ = v.Lframework_data_FrameworkDateTime__f_ldt;
  var formatter = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_data_FrameworkDateTime$().Lframework_data_FrameworkDateTime$__f_FromToStringFormatter;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Ljava_time_chrono_ChronoLocalDateTime.prototype.format__Ljava_time_format_DateTimeFormatter__T.call(this$, formatter);
}
export { $f_Lframework_data_FrameworkDateTime$Newtype__asString__Ljava_time_LocalDateTime__T as $f_Lframework_data_FrameworkDateTime$Newtype__asString__Ljava_time_LocalDateTime__T };
/** @constructor */
function $c_Lframework_data_JWT$package$JWT$Expiring(jwt, expiresAt) {
  this.Lframework_data_JWT$package$JWT$Expiring__f_jwt = null;
  this.Lframework_data_JWT$package$JWT$Expiring__f_expiresAt = null;
  this.Lframework_data_JWT$package$JWT$Expiring__f_jwt = jwt;
  this.Lframework_data_JWT$package$JWT$Expiring__f_expiresAt = expiresAt;
}
export { $c_Lframework_data_JWT$package$JWT$Expiring as $c_Lframework_data_JWT$package$JWT$Expiring };
$c_Lframework_data_JWT$package$JWT$Expiring.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_JWT$package$JWT$Expiring.prototype.constructor = $c_Lframework_data_JWT$package$JWT$Expiring;
/** @constructor */
function $h_Lframework_data_JWT$package$JWT$Expiring() {
}
export { $h_Lframework_data_JWT$package$JWT$Expiring as $h_Lframework_data_JWT$package$JWT$Expiring };
$h_Lframework_data_JWT$package$JWT$Expiring.prototype = $c_Lframework_data_JWT$package$JWT$Expiring.prototype;
$c_Lframework_data_JWT$package$JWT$Expiring.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_data_JWT$package$JWT$Expiring.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 705694992, true);
});
$c_Lframework_data_JWT$package$JWT$Expiring.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lframework_data_JWT$package$JWT$Expiring)) {
    if ((this.Lframework_data_JWT$package$JWT$Expiring__f_jwt === x$0.Lframework_data_JWT$package$JWT$Expiring__f_jwt)) {
      var x = this.Lframework_data_JWT$package$JWT$Expiring__f_expiresAt;
      var x$2 = x$0.Lframework_data_JWT$package$JWT$Expiring__f_expiresAt;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lframework_data_JWT$package$JWT$Expiring.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lframework_data_JWT$package$JWT$Expiring.prototype.productArity__I = (function() {
  return 2;
});
$c_Lframework_data_JWT$package$JWT$Expiring.prototype.productPrefix__T = (function() {
  return "Expiring";
});
$c_Lframework_data_JWT$package$JWT$Expiring.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_data_JWT$package$JWT$Expiring__f_jwt;
  }
  if ((n === 1)) {
    return this.Lframework_data_JWT$package$JWT$Expiring__f_expiresAt;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_JWT$package$JWT$Expiring.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "jwt";
  }
  if ((n === 1)) {
    return "expiresAt";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lframework_data_JWT$package$JWT$Expiring(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_data_JWT$package$JWT$Expiring)));
}
export { $isArrayOf_Lframework_data_JWT$package$JWT$Expiring as $isArrayOf_Lframework_data_JWT$package$JWT$Expiring };
var $d_Lframework_data_JWT$package$JWT$Expiring = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_JWT$package$JWT$Expiring, "framework.data.JWT$package$JWT$Expiring", ({
  Lframework_data_JWT$package$JWT$Expiring: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_data_JWT$package$JWT$Expiring as $d_Lframework_data_JWT$package$JWT$Expiring };
/** @constructor */
function $c_Lframework_data_WebPushSubscription(endpoint, keys) {
  this.Lframework_data_WebPushSubscription__f_endpoint = null;
  this.Lframework_data_WebPushSubscription__f_keys = null;
  this.Lframework_data_WebPushSubscription__f_endpoint = endpoint;
  this.Lframework_data_WebPushSubscription__f_keys = keys;
}
export { $c_Lframework_data_WebPushSubscription as $c_Lframework_data_WebPushSubscription };
$c_Lframework_data_WebPushSubscription.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_WebPushSubscription.prototype.constructor = $c_Lframework_data_WebPushSubscription;
/** @constructor */
function $h_Lframework_data_WebPushSubscription() {
}
export { $h_Lframework_data_WebPushSubscription as $h_Lframework_data_WebPushSubscription };
$h_Lframework_data_WebPushSubscription.prototype = $c_Lframework_data_WebPushSubscription.prototype;
$c_Lframework_data_WebPushSubscription.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_data_WebPushSubscription.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 694599552, true);
});
$c_Lframework_data_WebPushSubscription.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lframework_data_WebPushSubscription)) {
    var x = this.Lframework_data_WebPushSubscription__f_endpoint;
    var x$2 = x$0.Lframework_data_WebPushSubscription__f_endpoint;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lframework_data_WebPushSubscription__f_keys;
      var x$4 = x$0.Lframework_data_WebPushSubscription__f_keys;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lframework_data_WebPushSubscription.prototype.productArity__I = (function() {
  return 2;
});
$c_Lframework_data_WebPushSubscription.prototype.productPrefix__T = (function() {
  return "WebPushSubscription";
});
$c_Lframework_data_WebPushSubscription.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_data_WebPushSubscription__f_endpoint;
  }
  if ((n === 1)) {
    return this.Lframework_data_WebPushSubscription__f_keys;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_WebPushSubscription.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "endpoint";
  }
  if ((n === 1)) {
    return "keys";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_WebPushSubscription.prototype.toString__T = (function() {
  return (((("WebPushSubscription(endpoint=" + this.Lframework_data_WebPushSubscription__f_endpoint) + ", ") + this.Lframework_data_WebPushSubscription__f_keys) + ")");
});
function $isArrayOf_Lframework_data_WebPushSubscription(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_data_WebPushSubscription)));
}
export { $isArrayOf_Lframework_data_WebPushSubscription as $isArrayOf_Lframework_data_WebPushSubscription };
var $d_Lframework_data_WebPushSubscription = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_WebPushSubscription, "framework.data.WebPushSubscription", ({
  Lframework_data_WebPushSubscription: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_data_WebPushSubscription as $d_Lframework_data_WebPushSubscription };
/** @constructor */
function $c_Lframework_data_WebPushSubscription$$anon$11() {
}
export { $c_Lframework_data_WebPushSubscription$$anon$11 as $c_Lframework_data_WebPushSubscription$$anon$11 };
$c_Lframework_data_WebPushSubscription$$anon$11.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_WebPushSubscription$$anon$11.prototype.constructor = $c_Lframework_data_WebPushSubscription$$anon$11;
/** @constructor */
function $h_Lframework_data_WebPushSubscription$$anon$11() {
}
export { $h_Lframework_data_WebPushSubscription$$anon$11 as $h_Lframework_data_WebPushSubscription$$anon$11 };
$h_Lframework_data_WebPushSubscription$$anon$11.prototype = $c_Lframework_data_WebPushSubscription$$anon$11.prototype;
$c_Lframework_data_WebPushSubscription$$anon$11.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lframework_data_WebPushSubscription$$anon$11.prototype.apply__O = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForUri;
});
var $d_Lframework_data_WebPushSubscription$$anon$11 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_WebPushSubscription$$anon$11, "framework.data.WebPushSubscription$$anon$11", ({
  Lframework_data_WebPushSubscription$$anon$11: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lframework_data_WebPushSubscription$$anon$11 as $d_Lframework_data_WebPushSubscription$$anon$11 };
/** @constructor */
function $c_Lframework_data_WebPushSubscription$$anon$12(evaluator$7) {
  this.Lframework_data_WebPushSubscription$$anon$12__f_evaluator$3 = null;
  this.Lframework_data_WebPushSubscription$$anon$12__f_evaluator$3 = evaluator$7;
}
export { $c_Lframework_data_WebPushSubscription$$anon$12 as $c_Lframework_data_WebPushSubscription$$anon$12 };
$c_Lframework_data_WebPushSubscription$$anon$12.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_WebPushSubscription$$anon$12.prototype.constructor = $c_Lframework_data_WebPushSubscription$$anon$12;
/** @constructor */
function $h_Lframework_data_WebPushSubscription$$anon$12() {
}
export { $h_Lframework_data_WebPushSubscription$$anon$12 as $h_Lframework_data_WebPushSubscription$$anon$12 };
$h_Lframework_data_WebPushSubscription$$anon$12.prototype = $c_Lframework_data_WebPushSubscription$$anon$12.prototype;
$c_Lframework_data_WebPushSubscription$$anon$12.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lframework_data_WebPushSubscription$$anon$12.prototype.apply__s_Option = (function() {
  var v = this.Lframework_data_WebPushSubscription$$anon$12__f_evaluator$3.apply__O();
  return ((v instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_model_Uri) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lframework_data_WebPushSubscription$$anon$12.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lframework_data_WebPushSubscription$$anon$12 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_WebPushSubscription$$anon$12, "framework.data.WebPushSubscription$$anon$12", ({
  Lframework_data_WebPushSubscription$$anon$12: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lframework_data_WebPushSubscription$$anon$12 as $d_Lframework_data_WebPushSubscription$$anon$12 };
/** @constructor */
function $c_Lframework_data_WebPushSubscription$$anon$13() {
}
export { $c_Lframework_data_WebPushSubscription$$anon$13 as $c_Lframework_data_WebPushSubscription$$anon$13 };
$c_Lframework_data_WebPushSubscription$$anon$13.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_WebPushSubscription$$anon$13.prototype.constructor = $c_Lframework_data_WebPushSubscription$$anon$13;
/** @constructor */
function $h_Lframework_data_WebPushSubscription$$anon$13() {
}
export { $h_Lframework_data_WebPushSubscription$$anon$13 as $h_Lframework_data_WebPushSubscription$$anon$13 };
$h_Lframework_data_WebPushSubscription$$anon$13.prototype = $c_Lframework_data_WebPushSubscription$$anon$13.prototype;
$c_Lframework_data_WebPushSubscription$$anon$13.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lframework_data_WebPushSubscription$$anon$13.prototype.apply__O = (function() {
  return $m_Lframework_data_WebPushSubscription$Keys$().derived$Schema__Lsttp_tapir_Schema();
});
var $d_Lframework_data_WebPushSubscription$$anon$13 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_WebPushSubscription$$anon$13, "framework.data.WebPushSubscription$$anon$13", ({
  Lframework_data_WebPushSubscription$$anon$13: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lframework_data_WebPushSubscription$$anon$13 as $d_Lframework_data_WebPushSubscription$$anon$13 };
/** @constructor */
function $c_Lframework_data_WebPushSubscription$$anon$14(evaluator$8) {
  this.Lframework_data_WebPushSubscription$$anon$14__f_evaluator$4 = null;
  this.Lframework_data_WebPushSubscription$$anon$14__f_evaluator$4 = evaluator$8;
}
export { $c_Lframework_data_WebPushSubscription$$anon$14 as $c_Lframework_data_WebPushSubscription$$anon$14 };
$c_Lframework_data_WebPushSubscription$$anon$14.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_WebPushSubscription$$anon$14.prototype.constructor = $c_Lframework_data_WebPushSubscription$$anon$14;
/** @constructor */
function $h_Lframework_data_WebPushSubscription$$anon$14() {
}
export { $h_Lframework_data_WebPushSubscription$$anon$14 as $h_Lframework_data_WebPushSubscription$$anon$14 };
$h_Lframework_data_WebPushSubscription$$anon$14.prototype = $c_Lframework_data_WebPushSubscription$$anon$14.prototype;
$c_Lframework_data_WebPushSubscription$$anon$14.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lframework_data_WebPushSubscription$$anon$14.prototype.apply__s_Option = (function() {
  var v = this.Lframework_data_WebPushSubscription$$anon$14__f_evaluator$4.apply__O();
  return ((v instanceof $c_Lframework_data_WebPushSubscription$Keys) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lframework_data_WebPushSubscription$$anon$14.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lframework_data_WebPushSubscription$$anon$14 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_WebPushSubscription$$anon$14, "framework.data.WebPushSubscription$$anon$14", ({
  Lframework_data_WebPushSubscription$$anon$14: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lframework_data_WebPushSubscription$$anon$14 as $d_Lframework_data_WebPushSubscription$$anon$14 };
function $p_Lframework_data_WebPushSubscription$$anon$8__productSchemaType__Lmagnolia1_CaseClass__Lsttp_tapir_SchemaType$SProduct($thiz, ctx) {
  var $x_10 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$();
  var arr = ctx.Lmagnolia1_CaseClass__f_parameters;
  var f = ((p) => {
    var annotations = $p_Lframework_data_WebPushSubscription$$anon$8__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq($thiz, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(p.Lmagnolia1_CaseClass$Param$$anon$2__f_annotations), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(p.Lmagnolia1_CaseClass$Param$$anon$2__f_inheritedAnns$4));
    var pSchema = $p_Lframework_data_WebPushSubscription$$anon$8__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema($thiz, p.typeclass__O(), annotations);
    var this$2 = annotations.collectFirst__s_PartialFunction__s_Option(new $c_Lframework_data_WebPushSubscription$$anon$10());
    var encodedName = (this$2.isEmpty__Z() ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_generic_Configuration$().Lsttp_tapir_generic_Configuration$__f_default.Lsttp_tapir_generic_Configuration__f_toEncodedName.apply__O__O(p.Lmagnolia1_CaseClass$Param$$anon$2__f_label) : this$2.get__O());
    var name = p.Lmagnolia1_CaseClass$Param$$anon$2__f_label;
    var _name = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_FieldName(name, encodedName);
    var _get = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((p$3) => ((t) => {
      var value = p$3.deref__O__O(t);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
    }))(p));
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_SchemaType$SProductField$$anon$1(_name, pSchema, _get);
  });
  var len = arr.u.length;
  var ys = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lsttp_tapir_SchemaType$SProductField.getArrayOf().constr)(len);
  if ((len > 0)) {
    var i = 0;
    if ((arr !== null)) {
      while ((i < len)) {
        var $x_1 = i;
        var x0 = arr.u[i];
        ys.u[$x_1] = f(x0);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I)) {
      while ((i < len)) {
        var $x_2 = i;
        var x0$1 = arr.u[i];
        ys.u[$x_2] = f(x0$1);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_D)) {
      while ((i < len)) {
        var $x_3 = i;
        var x0$2 = arr.u[i];
        ys.u[$x_3] = f(x0$2);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_J)) {
      while ((i < len)) {
        var $x_4 = i;
        var t$1 = arr.u[i];
        var lo = t$1.RTLong__f_lo;
        var hi = t$1.RTLong__f_hi;
        ys.u[$x_4] = f(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi));
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_F)) {
      while ((i < len)) {
        var $x_5 = i;
        var x0$3 = arr.u[i];
        ys.u[$x_5] = f(x0$3);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_C)) {
      while ((i < len)) {
        var $x_6 = i;
        var x0$4 = arr.u[i];
        ys.u[$x_6] = f($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bC(x0$4));
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_B)) {
      while ((i < len)) {
        var $x_7 = i;
        var x0$5 = arr.u[i];
        ys.u[$x_7] = f(x0$5);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_S)) {
      while ((i < len)) {
        var $x_8 = i;
        var x0$6 = arr.u[i];
        ys.u[$x_8] = f(x0$6);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_Z)) {
      while ((i < len)) {
        var $x_9 = i;
        var x0$7 = arr.u[i];
        ys.u[$x_9] = f(x0$7);
        i = ((1 + i) | 0);
      }
    } else {
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(arr);
    }
  }
  var this$11 = $x_10.wrapRefArray__AO__sci_ArraySeq$ofRef(ys);
  var fields = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$11);
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_SchemaType$SProduct(fields);
}
export { $p_Lframework_data_WebPushSubscription$$anon$8__productSchemaType__Lmagnolia1_CaseClass__Lsttp_tapir_SchemaType$SProduct as $p_Lframework_data_WebPushSubscription$$anon$8__productSchemaType__Lmagnolia1_CaseClass__Lsttp_tapir_SchemaType$SProduct };
function $p_Lframework_data_WebPushSubscription$$anon$8__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName($thiz, typeName, annotations) {
  var x64 = annotations.collectFirst__s_PartialFunction__s_Option(new $c_Lframework_data_WebPushSubscription$$anon$9());
  if ((x64 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
    var altName = x64.s_Some__f_value;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$SName$();
    var typeParameterShortNames = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema$SName(altName, typeParameterShortNames);
  }
  var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  if ((x === x64)) {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$SName$();
    var fullName = typeName.full__T();
    var typeParameterShortNames$1 = $s_Lframework_data_WebPushSubscription$__framework$data$WebPushSubscription$$anon$8$$_$allTypeArguments$2__Lmagnolia1_TypeInfo__sci_Seq(typeName).map__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$1) => _$1.full__T()))).toList__sci_List();
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema$SName(fullName, typeParameterShortNames$1);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x64);
}
export { $p_Lframework_data_WebPushSubscription$$anon$8__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName as $p_Lframework_data_WebPushSubscription$$anon$8__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName };
function $p_Lframework_data_WebPushSubscription$$anon$8__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema($thiz, schema, annotations) {
  return annotations.foldLeft__O__F2__O(schema, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((x$1, x$2) => {
    if (false) {
      return x$1.description__T__Lsttp_tapir_Schema(x$2.text__T());
    } else if (false) {
      return x$1.encodedExample__O__Lsttp_tapir_Schema(x$2.example__O());
    } else if (false) {
      return x$1.default__O__s_Option__Lsttp_tapir_Schema(x$2.default__O(), x$2.encoded__s_Option());
    } else if (false) {
      return x$1.validate__Lsttp_tapir_Validator__Lsttp_tapir_Schema(x$2.v__Lsttp_tapir_Validator());
    } else if (false) {
      var fields = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)([$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_ModifyCollectionElements]));
      var modify = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((ann$6) => ((_$2) => _$2.validate__Lsttp_tapir_Validator__Lsttp_tapir_Schema(ann$6.v__Lsttp_tapir_Validator())))(x$2));
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$p_Lsttp_tapir_Schema__modifyAtPath__sci_List__F1__Lsttp_tapir_Schema(x$1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(fields), modify);
    } else if (false) {
      return x$1.format__T__Lsttp_tapir_Schema(x$2.format__T());
    } else if (false) {
      return x$1.title__T__Lsttp_tapir_Schema(x$2.name__T());
    } else if (false) {
      var schemaType = x$1.Lsttp_tapir_Schema__f_schemaType;
      var name = x$1.Lsttp_tapir_Schema__f_name;
      var isOptional = x$1.Lsttp_tapir_Schema__f_isOptional;
      var description = x$1.Lsttp_tapir_Schema__f_description;
      var default$1 = x$1.Lsttp_tapir_Schema__f_default;
      var format = x$1.Lsttp_tapir_Schema__f_format;
      var encodedExample = x$1.Lsttp_tapir_Schema__f_encodedExample;
      var hidden = x$1.Lsttp_tapir_Schema__f_hidden;
      var validator = x$1.Lsttp_tapir_Schema__f_validator;
      var attributes = x$1.Lsttp_tapir_Schema__f_attributes;
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema(schemaType, name, isOptional, description, default$1, format, encodedExample, true, hidden, validator, attributes);
    } else {
      return (false ? x$2.f__F1().apply__O__O(x$1) : x$1);
    }
  })));
}
export { $p_Lframework_data_WebPushSubscription$$anon$8__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema as $p_Lframework_data_WebPushSubscription$$anon$8__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema };
function $p_Lframework_data_WebPushSubscription$$anon$8__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq($thiz, primary, inherited) {
  var suffix = inherited.distinct__O().filter__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1) => (!primary.exists__F1__Z(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$3) => {
    var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$objectGetClass(_$3);
    var that = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$objectGetClass(x$1);
    return (this$1 === that);
  })))))));
  return primary.appendedAll__sc_IterableOnce__O(suffix);
}
export { $p_Lframework_data_WebPushSubscription$$anon$8__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq as $p_Lframework_data_WebPushSubscription$$anon$8__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq };
/** @constructor */
function $c_Lframework_data_WebPushSubscription$$anon$8(SchemaMagnoliaDerivation_this$4) {
  this.Lframework_data_WebPushSubscription$$anon$8__f_SchemaMagnoliaDerivation_this$2 = null;
  this.Lframework_data_WebPushSubscription$$anon$8__f_SchemaMagnoliaDerivation_this$2 = SchemaMagnoliaDerivation_this$4;
}
export { $c_Lframework_data_WebPushSubscription$$anon$8 as $c_Lframework_data_WebPushSubscription$$anon$8 };
$c_Lframework_data_WebPushSubscription$$anon$8.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_WebPushSubscription$$anon$8.prototype.constructor = $c_Lframework_data_WebPushSubscription$$anon$8;
/** @constructor */
function $h_Lframework_data_WebPushSubscription$$anon$8() {
}
export { $h_Lframework_data_WebPushSubscription$$anon$8 as $h_Lframework_data_WebPushSubscription$$anon$8 };
$h_Lframework_data_WebPushSubscription$$anon$8.prototype = $c_Lframework_data_WebPushSubscription$$anon$8.prototype;
$c_Lframework_data_WebPushSubscription$$anon$8.prototype.join__Lmagnolia1_CaseClass__Lsttp_tapir_Schema = (function(ctx) {
  var typeName = ctx.Lmagnolia1_CaseClass__f_typeInfo;
  var annotations = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(ctx.Lmagnolia1_CaseClass__f_annotations);
  var cacheKey = typeName.full__T();
  var inProgressOrNull = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$().Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$__f_deriveCache.get__O();
  var newCache = (inProgressOrNull === null);
  if (newCache) {
    var newInProgress = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_scm_Set$().apply__sci_Seq__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)([])));
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$().Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$__f_deriveCache.set__O__V(newInProgress);
    var inProgress = newInProgress;
  } else {
    if ((inProgressOrNull === null)) {
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Scala3RunTime$().nnFail__E();
    }
    var inProgress = inProgressOrNull;
  }
  if (inProgress.contains__O__Z(cacheKey)) {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var name = $p_Lframework_data_WebPushSubscription$$anon$8__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName(this, typeName, annotations);
    var schemaType = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_SchemaType$SRef(name);
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var name$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var isOptional = false;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var description = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var default$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var format = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var encodedExample = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var deprecated = false;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var hidden = false;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var validator = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var attributes = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema(schemaType, name$1, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes);
  } else {
    try {
      inProgress.add__O__Z(cacheKey);
      if (ctx.Lmagnolia1_CaseClass__f_isValueClass) {
        var requirement = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().nonEmpty__O__Z(ctx.Lmagnolia1_CaseClass__f_parameters);
        if ((!requirement)) {
          throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), (("requirement failed: " + "Cannot derive schema for generic value class: ") + ctx.Lmagnolia1_CaseClass__f_typeInfo.Lmagnolia1_TypeInfo__f_owner));
        }
        var valueSchema = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().head__O__O(ctx.Lmagnolia1_CaseClass__f_parameters).typeclass__O();
        var schemaType$1 = valueSchema.Lsttp_tapir_Schema__f_schemaType;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var name$1$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var isOptional$1 = false;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var description$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var default$1$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var encodedExample$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var deprecated$1 = false;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var hidden$1 = false;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var validator$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var attributes$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var format$1 = valueSchema.Lsttp_tapir_Schema__f_format;
        var result = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema(schemaType$1, name$1$1, isOptional$1, description$1, default$1$1, format$1, encodedExample$1, deprecated$1, hidden$1, validator$1, attributes$1);
      } else {
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var schemaType$2 = $p_Lframework_data_WebPushSubscription$$anon$8__productSchemaType__Lmagnolia1_CaseClass__Lsttp_tapir_SchemaType$SProduct(this, ctx);
        var value = $p_Lframework_data_WebPushSubscription$$anon$8__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName(this, ctx.Lmagnolia1_CaseClass__f_typeInfo, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(ctx.Lmagnolia1_CaseClass__f_annotations));
        var name$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var isOptional$2 = false;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var description$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var default$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var format$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var encodedExample$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var deprecated$2 = false;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var hidden$2 = false;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var validator$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var attributes$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
        var result = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema(schemaType$2, name$2, isOptional$2, description$2, default$2, format$2, encodedExample$2, deprecated$2, hidden$2, validator$2, attributes$2);
      }
      var this$28 = ctx.Lmagnolia1_CaseClass__f_typeInfo.full__T();
      if ((!(!this$28.startsWith("scala.Tuple")))) {
        result = result.tuple__Lsttp_tapir_Schema();
      }
      var schema = $p_Lframework_data_WebPushSubscription$$anon$8__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema(this, result, $p_Lframework_data_WebPushSubscription$$anon$8__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq(this, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(ctx.Lmagnolia1_CaseClass__f_annotations), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(ctx.Lmagnolia1_CaseClass__f_inheritedAnnotations)));
      return schema;
    } finally {
      inProgress.remove__O__Z(cacheKey);
      if (newCache) {
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$().Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$__f_deriveCache.remove__V();
      }
    }
  }
});
var $d_Lframework_data_WebPushSubscription$$anon$8 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_WebPushSubscription$$anon$8, "framework.data.WebPushSubscription$$anon$8", ({
  Lframework_data_WebPushSubscription$$anon$8: 1,
  Lmagnolia1_CommonDerivation: 1,
  Lmagnolia1_SealedTraitDerivation: 1,
  Lmagnolia1_Derivation: 1
}));
export { $d_Lframework_data_WebPushSubscription$$anon$8 as $d_Lframework_data_WebPushSubscription$$anon$8 };
/** @constructor */
function $c_Lframework_data_WebPushSubscription$Keys(auth, p256dh) {
  this.Lframework_data_WebPushSubscription$Keys__f_auth = null;
  this.Lframework_data_WebPushSubscription$Keys__f_p256dh = null;
  this.Lframework_data_WebPushSubscription$Keys__f_auth = auth;
  this.Lframework_data_WebPushSubscription$Keys__f_p256dh = p256dh;
}
export { $c_Lframework_data_WebPushSubscription$Keys as $c_Lframework_data_WebPushSubscription$Keys };
$c_Lframework_data_WebPushSubscription$Keys.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_WebPushSubscription$Keys.prototype.constructor = $c_Lframework_data_WebPushSubscription$Keys;
/** @constructor */
function $h_Lframework_data_WebPushSubscription$Keys() {
}
export { $h_Lframework_data_WebPushSubscription$Keys as $h_Lframework_data_WebPushSubscription$Keys };
$h_Lframework_data_WebPushSubscription$Keys.prototype = $c_Lframework_data_WebPushSubscription$Keys.prototype;
$c_Lframework_data_WebPushSubscription$Keys.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_data_WebPushSubscription$Keys.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1518484046, true);
});
$c_Lframework_data_WebPushSubscription$Keys.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lframework_data_WebPushSubscription$Keys) && ((this.Lframework_data_WebPushSubscription$Keys__f_auth === x$0.Lframework_data_WebPushSubscription$Keys__f_auth) && (this.Lframework_data_WebPushSubscription$Keys__f_p256dh === x$0.Lframework_data_WebPushSubscription$Keys__f_p256dh))));
});
$c_Lframework_data_WebPushSubscription$Keys.prototype.productArity__I = (function() {
  return 2;
});
$c_Lframework_data_WebPushSubscription$Keys.prototype.productPrefix__T = (function() {
  return "Keys";
});
$c_Lframework_data_WebPushSubscription$Keys.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_data_WebPushSubscription$Keys__f_auth;
  }
  if ((n === 1)) {
    return this.Lframework_data_WebPushSubscription$Keys__f_p256dh;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_WebPushSubscription$Keys.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "auth";
  }
  if ((n === 1)) {
    return "p256dh";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_WebPushSubscription$Keys.prototype.toString__T = (function() {
  return (((("Keys(auth=\"" + this.Lframework_data_WebPushSubscription$Keys__f_auth) + "\", p256dh=\"") + this.Lframework_data_WebPushSubscription$Keys__f_p256dh) + "\")");
});
function $isArrayOf_Lframework_data_WebPushSubscription$Keys(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_data_WebPushSubscription$Keys)));
}
export { $isArrayOf_Lframework_data_WebPushSubscription$Keys as $isArrayOf_Lframework_data_WebPushSubscription$Keys };
var $d_Lframework_data_WebPushSubscription$Keys = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_WebPushSubscription$Keys, "framework.data.WebPushSubscription$Keys", ({
  Lframework_data_WebPushSubscription$Keys: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_data_WebPushSubscription$Keys as $d_Lframework_data_WebPushSubscription$Keys };
function $p_Lframework_data_WebPushSubscription$Keys$$anon$1__productSchemaType__Lmagnolia1_CaseClass__Lsttp_tapir_SchemaType$SProduct($thiz, ctx) {
  var $x_10 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$();
  var arr = ctx.Lmagnolia1_CaseClass__f_parameters;
  var f = ((p) => {
    var annotations = $p_Lframework_data_WebPushSubscription$Keys$$anon$1__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq($thiz, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(p.Lmagnolia1_CaseClass$Param$$anon$2__f_annotations), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(p.Lmagnolia1_CaseClass$Param$$anon$2__f_inheritedAnns$4));
    var pSchema = $p_Lframework_data_WebPushSubscription$Keys$$anon$1__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema($thiz, p.typeclass__O(), annotations);
    var this$2 = annotations.collectFirst__s_PartialFunction__s_Option(new $c_Lframework_data_WebPushSubscription$$anon$3());
    var encodedName = (this$2.isEmpty__Z() ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_generic_Configuration$().Lsttp_tapir_generic_Configuration$__f_default.Lsttp_tapir_generic_Configuration__f_toEncodedName.apply__O__O(p.Lmagnolia1_CaseClass$Param$$anon$2__f_label) : this$2.get__O());
    var name = p.Lmagnolia1_CaseClass$Param$$anon$2__f_label;
    var _name = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_FieldName(name, encodedName);
    var _get = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((p$3) => ((t) => {
      var value = p$3.deref__O__O(t);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
    }))(p));
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_SchemaType$SProductField$$anon$1(_name, pSchema, _get);
  });
  var len = arr.u.length;
  var ys = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lsttp_tapir_SchemaType$SProductField.getArrayOf().constr)(len);
  if ((len > 0)) {
    var i = 0;
    if ((arr !== null)) {
      while ((i < len)) {
        var $x_1 = i;
        var x0 = arr.u[i];
        ys.u[$x_1] = f(x0);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I)) {
      while ((i < len)) {
        var $x_2 = i;
        var x0$1 = arr.u[i];
        ys.u[$x_2] = f(x0$1);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_D)) {
      while ((i < len)) {
        var $x_3 = i;
        var x0$2 = arr.u[i];
        ys.u[$x_3] = f(x0$2);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_J)) {
      while ((i < len)) {
        var $x_4 = i;
        var t$1 = arr.u[i];
        var lo = t$1.RTLong__f_lo;
        var hi = t$1.RTLong__f_hi;
        ys.u[$x_4] = f(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi));
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_F)) {
      while ((i < len)) {
        var $x_5 = i;
        var x0$3 = arr.u[i];
        ys.u[$x_5] = f(x0$3);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_C)) {
      while ((i < len)) {
        var $x_6 = i;
        var x0$4 = arr.u[i];
        ys.u[$x_6] = f($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bC(x0$4));
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_B)) {
      while ((i < len)) {
        var $x_7 = i;
        var x0$5 = arr.u[i];
        ys.u[$x_7] = f(x0$5);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_S)) {
      while ((i < len)) {
        var $x_8 = i;
        var x0$6 = arr.u[i];
        ys.u[$x_8] = f(x0$6);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_Z)) {
      while ((i < len)) {
        var $x_9 = i;
        var x0$7 = arr.u[i];
        ys.u[$x_9] = f(x0$7);
        i = ((1 + i) | 0);
      }
    } else {
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(arr);
    }
  }
  var this$11 = $x_10.wrapRefArray__AO__sci_ArraySeq$ofRef(ys);
  var fields = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$11);
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_SchemaType$SProduct(fields);
}
export { $p_Lframework_data_WebPushSubscription$Keys$$anon$1__productSchemaType__Lmagnolia1_CaseClass__Lsttp_tapir_SchemaType$SProduct as $p_Lframework_data_WebPushSubscription$Keys$$anon$1__productSchemaType__Lmagnolia1_CaseClass__Lsttp_tapir_SchemaType$SProduct };
function $p_Lframework_data_WebPushSubscription$Keys$$anon$1__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName($thiz, typeName, annotations) {
  var x13 = annotations.collectFirst__s_PartialFunction__s_Option(new $c_Lframework_data_WebPushSubscription$$anon$2());
  if ((x13 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
    var altName = x13.s_Some__f_value;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$SName$();
    var typeParameterShortNames = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema$SName(altName, typeParameterShortNames);
  }
  var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  if ((x === x13)) {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$SName$();
    var fullName = typeName.full__T();
    var typeParameterShortNames$1 = $s_Lframework_data_WebPushSubscription$__framework$data$WebPushSubscription$Keys$$anon$1$$_$allTypeArguments$1__Lmagnolia1_TypeInfo__sci_Seq(typeName).map__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$1) => _$1.full__T()))).toList__sci_List();
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema$SName(fullName, typeParameterShortNames$1);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x13);
}
export { $p_Lframework_data_WebPushSubscription$Keys$$anon$1__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName as $p_Lframework_data_WebPushSubscription$Keys$$anon$1__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName };
function $p_Lframework_data_WebPushSubscription$Keys$$anon$1__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema($thiz, schema, annotations) {
  return annotations.foldLeft__O__F2__O(schema, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((x$1, x$2) => {
    if (false) {
      return x$1.description__T__Lsttp_tapir_Schema(x$2.text__T());
    } else if (false) {
      return x$1.encodedExample__O__Lsttp_tapir_Schema(x$2.example__O());
    } else if (false) {
      return x$1.default__O__s_Option__Lsttp_tapir_Schema(x$2.default__O(), x$2.encoded__s_Option());
    } else if (false) {
      return x$1.validate__Lsttp_tapir_Validator__Lsttp_tapir_Schema(x$2.v__Lsttp_tapir_Validator());
    } else if (false) {
      var fields = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)([$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_ModifyCollectionElements]));
      var modify = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((ann$6) => ((_$2) => _$2.validate__Lsttp_tapir_Validator__Lsttp_tapir_Schema(ann$6.v__Lsttp_tapir_Validator())))(x$2));
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$p_Lsttp_tapir_Schema__modifyAtPath__sci_List__F1__Lsttp_tapir_Schema(x$1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(fields), modify);
    } else if (false) {
      return x$1.format__T__Lsttp_tapir_Schema(x$2.format__T());
    } else if (false) {
      return x$1.title__T__Lsttp_tapir_Schema(x$2.name__T());
    } else if (false) {
      var schemaType = x$1.Lsttp_tapir_Schema__f_schemaType;
      var name = x$1.Lsttp_tapir_Schema__f_name;
      var isOptional = x$1.Lsttp_tapir_Schema__f_isOptional;
      var description = x$1.Lsttp_tapir_Schema__f_description;
      var default$1 = x$1.Lsttp_tapir_Schema__f_default;
      var format = x$1.Lsttp_tapir_Schema__f_format;
      var encodedExample = x$1.Lsttp_tapir_Schema__f_encodedExample;
      var hidden = x$1.Lsttp_tapir_Schema__f_hidden;
      var validator = x$1.Lsttp_tapir_Schema__f_validator;
      var attributes = x$1.Lsttp_tapir_Schema__f_attributes;
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema(schemaType, name, isOptional, description, default$1, format, encodedExample, true, hidden, validator, attributes);
    } else {
      return (false ? x$2.f__F1().apply__O__O(x$1) : x$1);
    }
  })));
}
export { $p_Lframework_data_WebPushSubscription$Keys$$anon$1__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema as $p_Lframework_data_WebPushSubscription$Keys$$anon$1__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema };
function $p_Lframework_data_WebPushSubscription$Keys$$anon$1__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq($thiz, primary, inherited) {
  var suffix = inherited.distinct__O().filter__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1) => (!primary.exists__F1__Z(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$3) => {
    var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$objectGetClass(_$3);
    var that = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$objectGetClass(x$1);
    return (this$1 === that);
  })))))));
  return primary.appendedAll__sc_IterableOnce__O(suffix);
}
export { $p_Lframework_data_WebPushSubscription$Keys$$anon$1__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq as $p_Lframework_data_WebPushSubscription$Keys$$anon$1__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq };
/** @constructor */
function $c_Lframework_data_WebPushSubscription$Keys$$anon$1(SchemaMagnoliaDerivation_this$3) {
  this.Lframework_data_WebPushSubscription$Keys$$anon$1__f_SchemaMagnoliaDerivation_this$1 = null;
  this.Lframework_data_WebPushSubscription$Keys$$anon$1__f_SchemaMagnoliaDerivation_this$1 = SchemaMagnoliaDerivation_this$3;
}
export { $c_Lframework_data_WebPushSubscription$Keys$$anon$1 as $c_Lframework_data_WebPushSubscription$Keys$$anon$1 };
$c_Lframework_data_WebPushSubscription$Keys$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_WebPushSubscription$Keys$$anon$1.prototype.constructor = $c_Lframework_data_WebPushSubscription$Keys$$anon$1;
/** @constructor */
function $h_Lframework_data_WebPushSubscription$Keys$$anon$1() {
}
export { $h_Lframework_data_WebPushSubscription$Keys$$anon$1 as $h_Lframework_data_WebPushSubscription$Keys$$anon$1 };
$h_Lframework_data_WebPushSubscription$Keys$$anon$1.prototype = $c_Lframework_data_WebPushSubscription$Keys$$anon$1.prototype;
$c_Lframework_data_WebPushSubscription$Keys$$anon$1.prototype.join__Lmagnolia1_CaseClass__Lsttp_tapir_Schema = (function(ctx) {
  var typeName = ctx.Lmagnolia1_CaseClass__f_typeInfo;
  var annotations = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(ctx.Lmagnolia1_CaseClass__f_annotations);
  var cacheKey = typeName.full__T();
  var inProgressOrNull = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$().Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$__f_deriveCache.get__O();
  var newCache = (inProgressOrNull === null);
  if (newCache) {
    var newInProgress = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_scm_Set$().apply__sci_Seq__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)([])));
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$().Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$__f_deriveCache.set__O__V(newInProgress);
    var inProgress = newInProgress;
  } else {
    if ((inProgressOrNull === null)) {
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Scala3RunTime$().nnFail__E();
    }
    var inProgress = inProgressOrNull;
  }
  if (inProgress.contains__O__Z(cacheKey)) {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var name = $p_Lframework_data_WebPushSubscription$Keys$$anon$1__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName(this, typeName, annotations);
    var schemaType = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_SchemaType$SRef(name);
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var name$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var isOptional = false;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var description = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var default$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var format = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var encodedExample = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var deprecated = false;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var hidden = false;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var validator = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var attributes = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema(schemaType, name$1, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes);
  } else {
    try {
      inProgress.add__O__Z(cacheKey);
      if (ctx.Lmagnolia1_CaseClass__f_isValueClass) {
        var requirement = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().nonEmpty__O__Z(ctx.Lmagnolia1_CaseClass__f_parameters);
        if ((!requirement)) {
          throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), (("requirement failed: " + "Cannot derive schema for generic value class: ") + ctx.Lmagnolia1_CaseClass__f_typeInfo.Lmagnolia1_TypeInfo__f_owner));
        }
        var valueSchema = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().head__O__O(ctx.Lmagnolia1_CaseClass__f_parameters).typeclass__O();
        var schemaType$1 = valueSchema.Lsttp_tapir_Schema__f_schemaType;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var name$1$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var isOptional$1 = false;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var description$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var default$1$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var encodedExample$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var deprecated$1 = false;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var hidden$1 = false;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var validator$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var attributes$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var format$1 = valueSchema.Lsttp_tapir_Schema__f_format;
        var result = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema(schemaType$1, name$1$1, isOptional$1, description$1, default$1$1, format$1, encodedExample$1, deprecated$1, hidden$1, validator$1, attributes$1);
      } else {
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var schemaType$2 = $p_Lframework_data_WebPushSubscription$Keys$$anon$1__productSchemaType__Lmagnolia1_CaseClass__Lsttp_tapir_SchemaType$SProduct(this, ctx);
        var value = $p_Lframework_data_WebPushSubscription$Keys$$anon$1__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName(this, ctx.Lmagnolia1_CaseClass__f_typeInfo, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(ctx.Lmagnolia1_CaseClass__f_annotations));
        var name$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var isOptional$2 = false;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var description$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var default$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var format$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var encodedExample$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var deprecated$2 = false;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var hidden$2 = false;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var validator$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var attributes$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
        var result = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema(schemaType$2, name$2, isOptional$2, description$2, default$2, format$2, encodedExample$2, deprecated$2, hidden$2, validator$2, attributes$2);
      }
      var this$28 = ctx.Lmagnolia1_CaseClass__f_typeInfo.full__T();
      if ((!(!this$28.startsWith("scala.Tuple")))) {
        result = result.tuple__Lsttp_tapir_Schema();
      }
      var schema = $p_Lframework_data_WebPushSubscription$Keys$$anon$1__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema(this, result, $p_Lframework_data_WebPushSubscription$Keys$$anon$1__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq(this, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(ctx.Lmagnolia1_CaseClass__f_annotations), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(ctx.Lmagnolia1_CaseClass__f_inheritedAnnotations)));
      return schema;
    } finally {
      inProgress.remove__O__Z(cacheKey);
      if (newCache) {
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$().Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$__f_deriveCache.remove__V();
      }
    }
  }
});
var $d_Lframework_data_WebPushSubscription$Keys$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_WebPushSubscription$Keys$$anon$1, "framework.data.WebPushSubscription$Keys$$anon$1", ({
  Lframework_data_WebPushSubscription$Keys$$anon$1: 1,
  Lmagnolia1_CommonDerivation: 1,
  Lmagnolia1_SealedTraitDerivation: 1,
  Lmagnolia1_Derivation: 1
}));
export { $d_Lframework_data_WebPushSubscription$Keys$$anon$1 as $d_Lframework_data_WebPushSubscription$Keys$$anon$1 };
/** @constructor */
function $c_Lframework_data_WebPushSubscription$Keys$$anon$4() {
}
export { $c_Lframework_data_WebPushSubscription$Keys$$anon$4 as $c_Lframework_data_WebPushSubscription$Keys$$anon$4 };
$c_Lframework_data_WebPushSubscription$Keys$$anon$4.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_WebPushSubscription$Keys$$anon$4.prototype.constructor = $c_Lframework_data_WebPushSubscription$Keys$$anon$4;
/** @constructor */
function $h_Lframework_data_WebPushSubscription$Keys$$anon$4() {
}
export { $h_Lframework_data_WebPushSubscription$Keys$$anon$4 as $h_Lframework_data_WebPushSubscription$Keys$$anon$4 };
$h_Lframework_data_WebPushSubscription$Keys$$anon$4.prototype = $c_Lframework_data_WebPushSubscription$Keys$$anon$4.prototype;
$c_Lframework_data_WebPushSubscription$Keys$$anon$4.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lframework_data_WebPushSubscription$Keys$$anon$4.prototype.apply__O = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForString;
});
var $d_Lframework_data_WebPushSubscription$Keys$$anon$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_WebPushSubscription$Keys$$anon$4, "framework.data.WebPushSubscription$Keys$$anon$4", ({
  Lframework_data_WebPushSubscription$Keys$$anon$4: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lframework_data_WebPushSubscription$Keys$$anon$4 as $d_Lframework_data_WebPushSubscription$Keys$$anon$4 };
/** @constructor */
function $c_Lframework_data_WebPushSubscription$Keys$$anon$5(evaluator$5) {
  this.Lframework_data_WebPushSubscription$Keys$$anon$5__f_evaluator$1 = null;
  this.Lframework_data_WebPushSubscription$Keys$$anon$5__f_evaluator$1 = evaluator$5;
}
export { $c_Lframework_data_WebPushSubscription$Keys$$anon$5 as $c_Lframework_data_WebPushSubscription$Keys$$anon$5 };
$c_Lframework_data_WebPushSubscription$Keys$$anon$5.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_WebPushSubscription$Keys$$anon$5.prototype.constructor = $c_Lframework_data_WebPushSubscription$Keys$$anon$5;
/** @constructor */
function $h_Lframework_data_WebPushSubscription$Keys$$anon$5() {
}
export { $h_Lframework_data_WebPushSubscription$Keys$$anon$5 as $h_Lframework_data_WebPushSubscription$Keys$$anon$5 };
$h_Lframework_data_WebPushSubscription$Keys$$anon$5.prototype = $c_Lframework_data_WebPushSubscription$Keys$$anon$5.prototype;
$c_Lframework_data_WebPushSubscription$Keys$$anon$5.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lframework_data_WebPushSubscription$Keys$$anon$5.prototype.apply__s_Option = (function() {
  var v = this.Lframework_data_WebPushSubscription$Keys$$anon$5__f_evaluator$1.apply__O();
  return (((typeof v) === "string") ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lframework_data_WebPushSubscription$Keys$$anon$5.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lframework_data_WebPushSubscription$Keys$$anon$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_WebPushSubscription$Keys$$anon$5, "framework.data.WebPushSubscription$Keys$$anon$5", ({
  Lframework_data_WebPushSubscription$Keys$$anon$5: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lframework_data_WebPushSubscription$Keys$$anon$5 as $d_Lframework_data_WebPushSubscription$Keys$$anon$5 };
/** @constructor */
function $c_Lframework_data_WebPushSubscription$Keys$$anon$6() {
}
export { $c_Lframework_data_WebPushSubscription$Keys$$anon$6 as $c_Lframework_data_WebPushSubscription$Keys$$anon$6 };
$c_Lframework_data_WebPushSubscription$Keys$$anon$6.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_WebPushSubscription$Keys$$anon$6.prototype.constructor = $c_Lframework_data_WebPushSubscription$Keys$$anon$6;
/** @constructor */
function $h_Lframework_data_WebPushSubscription$Keys$$anon$6() {
}
export { $h_Lframework_data_WebPushSubscription$Keys$$anon$6 as $h_Lframework_data_WebPushSubscription$Keys$$anon$6 };
$h_Lframework_data_WebPushSubscription$Keys$$anon$6.prototype = $c_Lframework_data_WebPushSubscription$Keys$$anon$6.prototype;
$c_Lframework_data_WebPushSubscription$Keys$$anon$6.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lframework_data_WebPushSubscription$Keys$$anon$6.prototype.apply__O = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForString;
});
var $d_Lframework_data_WebPushSubscription$Keys$$anon$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_WebPushSubscription$Keys$$anon$6, "framework.data.WebPushSubscription$Keys$$anon$6", ({
  Lframework_data_WebPushSubscription$Keys$$anon$6: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lframework_data_WebPushSubscription$Keys$$anon$6 as $d_Lframework_data_WebPushSubscription$Keys$$anon$6 };
/** @constructor */
function $c_Lframework_data_WebPushSubscription$Keys$$anon$7(evaluator$6) {
  this.Lframework_data_WebPushSubscription$Keys$$anon$7__f_evaluator$2 = null;
  this.Lframework_data_WebPushSubscription$Keys$$anon$7__f_evaluator$2 = evaluator$6;
}
export { $c_Lframework_data_WebPushSubscription$Keys$$anon$7 as $c_Lframework_data_WebPushSubscription$Keys$$anon$7 };
$c_Lframework_data_WebPushSubscription$Keys$$anon$7.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_WebPushSubscription$Keys$$anon$7.prototype.constructor = $c_Lframework_data_WebPushSubscription$Keys$$anon$7;
/** @constructor */
function $h_Lframework_data_WebPushSubscription$Keys$$anon$7() {
}
export { $h_Lframework_data_WebPushSubscription$Keys$$anon$7 as $h_Lframework_data_WebPushSubscription$Keys$$anon$7 };
$h_Lframework_data_WebPushSubscription$Keys$$anon$7.prototype = $c_Lframework_data_WebPushSubscription$Keys$$anon$7.prototype;
$c_Lframework_data_WebPushSubscription$Keys$$anon$7.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lframework_data_WebPushSubscription$Keys$$anon$7.prototype.apply__s_Option = (function() {
  var v = this.Lframework_data_WebPushSubscription$Keys$$anon$7__f_evaluator$2.apply__O();
  return (((typeof v) === "string") ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lframework_data_WebPushSubscription$Keys$$anon$7.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lframework_data_WebPushSubscription$Keys$$anon$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_WebPushSubscription$Keys$$anon$7, "framework.data.WebPushSubscription$Keys$$anon$7", ({
  Lframework_data_WebPushSubscription$Keys$$anon$7: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lframework_data_WebPushSubscription$Keys$$anon$7 as $d_Lframework_data_WebPushSubscription$Keys$$anon$7 };
/** @constructor */
function $c_Lframework_prelude_MatchDynamicBuilder(obj, property, cases) {
  this.Lframework_prelude_MatchDynamicBuilder__f_obj = null;
  this.Lframework_prelude_MatchDynamicBuilder__f_property = null;
  this.Lframework_prelude_MatchDynamicBuilder__f_cases = null;
  this.Lframework_prelude_MatchDynamicBuilder__f_obj = obj;
  this.Lframework_prelude_MatchDynamicBuilder__f_property = property;
  this.Lframework_prelude_MatchDynamicBuilder__f_cases = cases;
}
export { $c_Lframework_prelude_MatchDynamicBuilder as $c_Lframework_prelude_MatchDynamicBuilder };
$c_Lframework_prelude_MatchDynamicBuilder.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_prelude_MatchDynamicBuilder.prototype.constructor = $c_Lframework_prelude_MatchDynamicBuilder;
/** @constructor */
function $h_Lframework_prelude_MatchDynamicBuilder() {
}
export { $h_Lframework_prelude_MatchDynamicBuilder as $h_Lframework_prelude_MatchDynamicBuilder };
$h_Lframework_prelude_MatchDynamicBuilder.prototype = $c_Lframework_prelude_MatchDynamicBuilder.prototype;
$c_Lframework_prelude_MatchDynamicBuilder.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_prelude_MatchDynamicBuilder.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-982017955), true);
});
$c_Lframework_prelude_MatchDynamicBuilder.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lframework_prelude_MatchDynamicBuilder)) {
    var x = this.Lframework_prelude_MatchDynamicBuilder__f_obj;
    var y = x$0.Lframework_prelude_MatchDynamicBuilder__f_obj;
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Lframework_prelude_MatchDynamicBuilder__f_property;
      var y$1 = x$0.Lframework_prelude_MatchDynamicBuilder__f_property;
      var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y$1);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$2 = this.Lframework_prelude_MatchDynamicBuilder__f_cases;
      var x$2$1 = x$0.Lframework_prelude_MatchDynamicBuilder__f_cases;
      return (x$2 === x$2$1);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lframework_prelude_MatchDynamicBuilder.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lframework_prelude_MatchDynamicBuilder.prototype.productArity__I = (function() {
  return 3;
});
$c_Lframework_prelude_MatchDynamicBuilder.prototype.productPrefix__T = (function() {
  return "MatchDynamicBuilder";
});
$c_Lframework_prelude_MatchDynamicBuilder.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lframework_prelude_MatchDynamicBuilder__f_obj;
      break;
    }
    case 1: {
      return this.Lframework_prelude_MatchDynamicBuilder__f_property;
      break;
    }
    case 2: {
      return this.Lframework_prelude_MatchDynamicBuilder__f_cases;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lframework_prelude_MatchDynamicBuilder.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "obj";
      break;
    }
    case 1: {
      return "property";
      break;
    }
    case 2: {
      return "cases";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lframework_prelude_MatchDynamicBuilder.prototype.on__sjs_js_Any__F1__Lframework_prelude_MatchDynamicBuilder = (function(property, onMatch) {
  var onMatch$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((input) => onMatch.apply__O__O(input)));
  var thisCase = new $c_Lframework_prelude_MatchDynamicBuilder$Case(property, onMatch$1);
  var arr = this.Lframework_prelude_MatchDynamicBuilder__f_cases;
  var newLength = ((1 + arr.u.length) | 0);
  var this$8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$objectGetClass(arr);
  var that = this$8.data.getComponentType();
  if ($d_Lframework_prelude_MatchDynamicBuilder$Case.isAssignableFrom(that.data)) {
    var dest$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(arr, newLength, $d_Lframework_prelude_MatchDynamicBuilder$Case.getArrayOf().getClassOf());
  } else {
    var dest = new ($d_Lframework_prelude_MatchDynamicBuilder$Case.getArrayOf().constr)(newLength);
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Array$().copy__O__I__O__I__I__V(arr, 0, dest, 0, arr.u.length);
    var dest$1 = dest;
  }
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().array_update__O__I__O__V(dest$1, arr.u.length, thisCase);
  var obj$1 = this.Lframework_prelude_MatchDynamicBuilder__f_obj;
  var property$1 = this.Lframework_prelude_MatchDynamicBuilder__f_property;
  return new $c_Lframework_prelude_MatchDynamicBuilder(obj$1, property$1, dest$1);
});
$c_Lframework_prelude_MatchDynamicBuilder.prototype.performOrNone__s_Option = (function() {
  var idx = 0;
  while (true) {
    var $x_1 = idx;
    var arr = this.Lframework_prelude_MatchDynamicBuilder__f_cases;
    if (($x_1 < arr.u.length)) {
      var arr$1 = this.Lframework_prelude_MatchDynamicBuilder__f_cases;
      var n = idx;
      var case$1 = arr$1.u[n];
      var x = this.Lframework_prelude_MatchDynamicBuilder__f_property;
      var y = case$1.Lframework_prelude_MatchDynamicBuilder$Case__f_property;
      if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
        var value = case$1.Lframework_prelude_MatchDynamicBuilder$Case__f_onMatch.apply__O__O(this.Lframework_prelude_MatchDynamicBuilder__f_obj);
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
      }
      idx = ((1 + idx) | 0);
    } else {
      break;
    }
  }
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
});
$c_Lframework_prelude_MatchDynamicBuilder.prototype.performOrThrow__O = (function() {
  var x5 = this.performOrNone__s_Option();
  if ((x5 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
    var value = x5.s_Some__f_value;
    return value;
  }
  var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  if ((x === x5)) {
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(((("No case found for property '" + this.Lframework_prelude_MatchDynamicBuilder__f_property) + "' in object ") + this.Lframework_prelude_MatchDynamicBuilder__f_obj));
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x5);
});
function $isArrayOf_Lframework_prelude_MatchDynamicBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_prelude_MatchDynamicBuilder)));
}
export { $isArrayOf_Lframework_prelude_MatchDynamicBuilder as $isArrayOf_Lframework_prelude_MatchDynamicBuilder };
var $d_Lframework_prelude_MatchDynamicBuilder = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_prelude_MatchDynamicBuilder, "framework.prelude.MatchDynamicBuilder", ({
  Lframework_prelude_MatchDynamicBuilder: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_prelude_MatchDynamicBuilder as $d_Lframework_prelude_MatchDynamicBuilder };
/** @constructor */
function $c_Lframework_prelude_MatchDynamicBuilder$Case(property, onMatch) {
  this.Lframework_prelude_MatchDynamicBuilder$Case__f_property = null;
  this.Lframework_prelude_MatchDynamicBuilder$Case__f_onMatch = null;
  this.Lframework_prelude_MatchDynamicBuilder$Case__f_property = property;
  this.Lframework_prelude_MatchDynamicBuilder$Case__f_onMatch = onMatch;
}
export { $c_Lframework_prelude_MatchDynamicBuilder$Case as $c_Lframework_prelude_MatchDynamicBuilder$Case };
$c_Lframework_prelude_MatchDynamicBuilder$Case.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_prelude_MatchDynamicBuilder$Case.prototype.constructor = $c_Lframework_prelude_MatchDynamicBuilder$Case;
/** @constructor */
function $h_Lframework_prelude_MatchDynamicBuilder$Case() {
}
export { $h_Lframework_prelude_MatchDynamicBuilder$Case as $h_Lframework_prelude_MatchDynamicBuilder$Case };
$h_Lframework_prelude_MatchDynamicBuilder$Case.prototype = $c_Lframework_prelude_MatchDynamicBuilder$Case.prototype;
$c_Lframework_prelude_MatchDynamicBuilder$Case.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_prelude_MatchDynamicBuilder$Case.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-2138487125), true);
});
$c_Lframework_prelude_MatchDynamicBuilder$Case.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lframework_prelude_MatchDynamicBuilder$Case)) {
    var x = this.Lframework_prelude_MatchDynamicBuilder$Case__f_property;
    var y = x$0.Lframework_prelude_MatchDynamicBuilder$Case__f_property;
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Lframework_prelude_MatchDynamicBuilder$Case__f_onMatch;
      var x$2 = x$0.Lframework_prelude_MatchDynamicBuilder$Case__f_onMatch;
      return ((x$1 === null) ? (x$2 === null) : x$1.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lframework_prelude_MatchDynamicBuilder$Case.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lframework_prelude_MatchDynamicBuilder$Case.prototype.productArity__I = (function() {
  return 2;
});
$c_Lframework_prelude_MatchDynamicBuilder$Case.prototype.productPrefix__T = (function() {
  return "Case";
});
$c_Lframework_prelude_MatchDynamicBuilder$Case.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_prelude_MatchDynamicBuilder$Case__f_property;
  }
  if ((n === 1)) {
    return this.Lframework_prelude_MatchDynamicBuilder$Case__f_onMatch;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_prelude_MatchDynamicBuilder$Case.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "property";
  }
  if ((n === 1)) {
    return "onMatch";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lframework_prelude_MatchDynamicBuilder$Case(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_prelude_MatchDynamicBuilder$Case)));
}
export { $isArrayOf_Lframework_prelude_MatchDynamicBuilder$Case as $isArrayOf_Lframework_prelude_MatchDynamicBuilder$Case };
var $d_Lframework_prelude_MatchDynamicBuilder$Case = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_prelude_MatchDynamicBuilder$Case, "framework.prelude.MatchDynamicBuilder$Case", ({
  Lframework_prelude_MatchDynamicBuilder$Case: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_prelude_MatchDynamicBuilder$Case as $d_Lframework_prelude_MatchDynamicBuilder$Case };
/** @constructor */
function $c_Lframework_prelude_sttp$package$$anon$1() {
}
export { $c_Lframework_prelude_sttp$package$$anon$1 as $c_Lframework_prelude_sttp$package$$anon$1 };
$c_Lframework_prelude_sttp$package$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_prelude_sttp$package$$anon$1.prototype.constructor = $c_Lframework_prelude_sttp$package$$anon$1;
/** @constructor */
function $h_Lframework_prelude_sttp$package$$anon$1() {
}
export { $h_Lframework_prelude_sttp$package$$anon$1 as $h_Lframework_prelude_sttp$package$$anon$1 };
$h_Lframework_prelude_sttp$package$$anon$1.prototype = $c_Lframework_prelude_sttp$package$$anon$1.prototype;
$c_Lframework_prelude_sttp$package$$anon$1.prototype.show__O__T = (function(t) {
  return t.toStringSafe__sci_Set__T($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Set$EmptySet$());
});
var $d_Lframework_prelude_sttp$package$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_prelude_sttp$package$$anon$1, "framework.prelude.sttp$package$$anon$1", ({
  Lframework_prelude_sttp$package$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Show$ContravariantShow: 1,
  Lcats_Show: 1
}));
export { $d_Lframework_prelude_sttp$package$$anon$1 as $d_Lframework_prelude_sttp$package$$anon$1 };
/** @constructor */
function $c_Lframework_prelude_sttp$package$$anon$2() {
}
export { $c_Lframework_prelude_sttp$package$$anon$2 as $c_Lframework_prelude_sttp$package$$anon$2 };
$c_Lframework_prelude_sttp$package$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_prelude_sttp$package$$anon$2.prototype.constructor = $c_Lframework_prelude_sttp$package$$anon$2;
/** @constructor */
function $h_Lframework_prelude_sttp$package$$anon$2() {
}
export { $h_Lframework_prelude_sttp$package$$anon$2 as $h_Lframework_prelude_sttp$package$$anon$2 };
$h_Lframework_prelude_sttp$package$$anon$2.prototype = $c_Lframework_prelude_sttp$package$$anon$2.prototype;
$c_Lframework_prelude_sttp$package$$anon$2.prototype.show__O__T = (function(t) {
  var _$2 = ((t === null) ? (null | 0) : t.Lsttp_model_StatusCode__f_code);
  $m_Lsttp_model_StatusCode$();
  return ("" + _$2);
});
var $d_Lframework_prelude_sttp$package$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_prelude_sttp$package$$anon$2, "framework.prelude.sttp$package$$anon$2", ({
  Lframework_prelude_sttp$package$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_Show$ContravariantShow: 1,
  Lcats_Show: 1
}));
export { $d_Lframework_prelude_sttp$package$$anon$2 as $d_Lframework_prelude_sttp$package$$anon$2 };
/** @constructor */
function $c_Lframework_sourcecode_DefinedAt(file, line, name) {
  this.Lframework_sourcecode_DefinedAt__f_file = null;
  this.Lframework_sourcecode_DefinedAt__f_line = null;
  this.Lframework_sourcecode_DefinedAt__f_name = null;
  this.Lframework_sourcecode_DefinedAt__f_file = file;
  this.Lframework_sourcecode_DefinedAt__f_line = line;
  this.Lframework_sourcecode_DefinedAt__f_name = name;
}
export { $c_Lframework_sourcecode_DefinedAt as $c_Lframework_sourcecode_DefinedAt };
$c_Lframework_sourcecode_DefinedAt.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_sourcecode_DefinedAt.prototype.constructor = $c_Lframework_sourcecode_DefinedAt;
/** @constructor */
function $h_Lframework_sourcecode_DefinedAt() {
}
export { $h_Lframework_sourcecode_DefinedAt as $h_Lframework_sourcecode_DefinedAt };
$h_Lframework_sourcecode_DefinedAt.prototype = $c_Lframework_sourcecode_DefinedAt.prototype;
$c_Lframework_sourcecode_DefinedAt.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_sourcecode_DefinedAt.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 387043802, true);
});
$c_Lframework_sourcecode_DefinedAt.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lframework_sourcecode_DefinedAt)) {
    var x = this.Lframework_sourcecode_DefinedAt__f_file;
    var x$2 = x$0.Lframework_sourcecode_DefinedAt__f_file;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lframework_sourcecode_DefinedAt__f_line;
      var x$4 = x$0.Lframework_sourcecode_DefinedAt__f_line;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Lframework_sourcecode_DefinedAt__f_name;
      var x$6 = x$0.Lframework_sourcecode_DefinedAt__f_name;
      return ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lframework_sourcecode_DefinedAt.prototype.productArity__I = (function() {
  return 3;
});
$c_Lframework_sourcecode_DefinedAt.prototype.productPrefix__T = (function() {
  return "DefinedAt";
});
$c_Lframework_sourcecode_DefinedAt.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lframework_sourcecode_DefinedAt__f_file;
      break;
    }
    case 1: {
      return this.Lframework_sourcecode_DefinedAt__f_line;
      break;
    }
    case 2: {
      return this.Lframework_sourcecode_DefinedAt__f_name;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lframework_sourcecode_DefinedAt.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "file";
      break;
    }
    case 1: {
      return "line";
      break;
    }
    case 2: {
      return "name";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lframework_sourcecode_DefinedAt.prototype.toString__T = (function() {
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
  var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["[", " @ ", ":", "]"]));
  var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
  return $x_1.show$extension__s_StringContext__sci_Seq__T(sc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(this.Lframework_sourcecode_DefinedAt__f_name.Lsourcecode_FullName__f_value, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString)), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(this.Lframework_sourcecode_DefinedAt__f_file.Lsourcecode_File__f_value, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString)), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(this.Lframework_sourcecode_DefinedAt__f_line.Lsourcecode_Line__f_value, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$int$().Lcats_instances_package$int$__f_catsStdShowForInt))])));
});
function $isArrayOf_Lframework_sourcecode_DefinedAt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_sourcecode_DefinedAt)));
}
export { $isArrayOf_Lframework_sourcecode_DefinedAt as $isArrayOf_Lframework_sourcecode_DefinedAt };
var $d_Lframework_sourcecode_DefinedAt = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_sourcecode_DefinedAt, "framework.sourcecode.DefinedAt", ({
  Lframework_sourcecode_DefinedAt: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_sourcecode_DefinedAt as $d_Lframework_sourcecode_DefinedAt };
/** @constructor */
function $c_Lframework_sourcecode_DefinedAt$$anon$1() {
}
export { $c_Lframework_sourcecode_DefinedAt$$anon$1 as $c_Lframework_sourcecode_DefinedAt$$anon$1 };
$c_Lframework_sourcecode_DefinedAt$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_sourcecode_DefinedAt$$anon$1.prototype.constructor = $c_Lframework_sourcecode_DefinedAt$$anon$1;
/** @constructor */
function $h_Lframework_sourcecode_DefinedAt$$anon$1() {
}
export { $h_Lframework_sourcecode_DefinedAt$$anon$1 as $h_Lframework_sourcecode_DefinedAt$$anon$1 };
$h_Lframework_sourcecode_DefinedAt$$anon$1.prototype = $c_Lframework_sourcecode_DefinedAt$$anon$1.prototype;
$c_Lframework_sourcecode_DefinedAt$$anon$1.prototype.show__O__T = (function(t) {
  return t.toString__T();
});
var $d_Lframework_sourcecode_DefinedAt$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_sourcecode_DefinedAt$$anon$1, "framework.sourcecode.DefinedAt$$anon$1", ({
  Lframework_sourcecode_DefinedAt$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Show$ContravariantShow: 1,
  Lcats_Show: 1
}));
export { $d_Lframework_sourcecode_DefinedAt$$anon$1 as $d_Lframework_sourcecode_DefinedAt$$anon$1 };
/** @constructor */
function $c_Lframework_utils_NewtypeInt$$anon$1(outer) {
  this.Lframework_utils_NewtypeInt$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lframework_utils_NewtypeInt$$anon$1__f_$outer = outer;
}
export { $c_Lframework_utils_NewtypeInt$$anon$1 as $c_Lframework_utils_NewtypeInt$$anon$1 };
$c_Lframework_utils_NewtypeInt$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_NewtypeInt$$anon$1.prototype.constructor = $c_Lframework_utils_NewtypeInt$$anon$1;
/** @constructor */
function $h_Lframework_utils_NewtypeInt$$anon$1() {
}
export { $h_Lframework_utils_NewtypeInt$$anon$1 as $h_Lframework_utils_NewtypeInt$$anon$1 };
$h_Lframework_utils_NewtypeInt$$anon$1.prototype = $c_Lframework_utils_NewtypeInt$$anon$1.prototype;
$c_Lframework_utils_NewtypeInt$$anon$1.prototype.show__I__T = (function(_$1) {
  var tc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$int$().Lcats_instances_package$int$__f_catsStdShowForInt;
  var this$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$ToShowOps$$anon$3(_$1, tc);
  return this$4.Lcats_Show$ToShowOps$$anon$3__f_typeClassInstance.show__O__T(this$4.Lcats_Show$ToShowOps$$anon$3__f_self);
});
$c_Lframework_utils_NewtypeInt$$anon$1.prototype.show__O__T = (function(t) {
  return this.show__I__T((t | 0));
});
var $d_Lframework_utils_NewtypeInt$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_NewtypeInt$$anon$1, "framework.utils.NewtypeInt$$anon$1", ({
  Lframework_utils_NewtypeInt$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Show$ContravariantShow: 1,
  Lcats_Show: 1
}));
export { $d_Lframework_utils_NewtypeInt$$anon$1 as $d_Lframework_utils_NewtypeInt$$anon$1 };
function $f_Lframework_utils_NewtypeString__given_Ordering_Type__s_math_Ordering($thiz) {
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((v) => v));
  var ord = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_math_Ordering$String$();
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_math_Ordering$$anon$5(ord, f);
}
export { $f_Lframework_utils_NewtypeString__given_Ordering_Type__s_math_Ordering as $f_Lframework_utils_NewtypeString__given_Ordering_Type__s_math_Ordering };
function $f_Lframework_utils_NewtypeString__tapirCodec__Lsttp_tapir_Codec($thiz) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lsttp_tapir_Codec__mapEither__F1__F1__Lsttp_tapir_Codec($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Codec$().Lsttp_tapir_Codec$__f_string, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((input) => {
    var this$3 = $thiz.make__Lyantl_INewtype$make$();
    var x$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_prelude_newtype$package$().given_AsString_Any__Lyantl_AsString();
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Make__asString__O__Lyantl_AsString__s_util_Either(this$3, input, x$2);
  })), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((v) => v)));
}
export { $f_Lframework_utils_NewtypeString__tapirCodec__Lsttp_tapir_Codec as $f_Lframework_utils_NewtypeString__tapirCodec__Lsttp_tapir_Codec };
/** @constructor */
function $c_Lframework_utils_NewtypeString$$anon$1(outer) {
  this.Lframework_utils_NewtypeString$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lframework_utils_NewtypeString$$anon$1__f_$outer = outer;
}
export { $c_Lframework_utils_NewtypeString$$anon$1 as $c_Lframework_utils_NewtypeString$$anon$1 };
$c_Lframework_utils_NewtypeString$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_NewtypeString$$anon$1.prototype.constructor = $c_Lframework_utils_NewtypeString$$anon$1;
/** @constructor */
function $h_Lframework_utils_NewtypeString$$anon$1() {
}
export { $h_Lframework_utils_NewtypeString$$anon$1 as $h_Lframework_utils_NewtypeString$$anon$1 };
$h_Lframework_utils_NewtypeString$$anon$1.prototype = $c_Lframework_utils_NewtypeString$$anon$1.prototype;
$c_Lframework_utils_NewtypeString$$anon$1.prototype.show__T__T = (function(_$1) {
  return _$1;
});
$c_Lframework_utils_NewtypeString$$anon$1.prototype.show__O__T = (function(t) {
  return this.show__T__T(t);
});
var $d_Lframework_utils_NewtypeString$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_NewtypeString$$anon$1, "framework.utils.NewtypeString$$anon$1", ({
  Lframework_utils_NewtypeString$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Show$ContravariantShow: 1,
  Lcats_Show: 1
}));
export { $d_Lframework_utils_NewtypeString$$anon$1 as $d_Lframework_utils_NewtypeString$$anon$1 };
/** @constructor */
function $c_Lframework_utils_NewtypeUUID$$anon$1(outer) {
  this.Lframework_utils_NewtypeUUID$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lframework_utils_NewtypeUUID$$anon$1__f_$outer = outer;
}
export { $c_Lframework_utils_NewtypeUUID$$anon$1 as $c_Lframework_utils_NewtypeUUID$$anon$1 };
$c_Lframework_utils_NewtypeUUID$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_NewtypeUUID$$anon$1.prototype.constructor = $c_Lframework_utils_NewtypeUUID$$anon$1;
/** @constructor */
function $h_Lframework_utils_NewtypeUUID$$anon$1() {
}
export { $h_Lframework_utils_NewtypeUUID$$anon$1 as $h_Lframework_utils_NewtypeUUID$$anon$1 };
$h_Lframework_utils_NewtypeUUID$$anon$1.prototype = $c_Lframework_utils_NewtypeUUID$$anon$1.prototype;
$c_Lframework_utils_NewtypeUUID$$anon$1.prototype.show__ju_UUID__T = (function(_$1) {
  var this$1 = this.Lframework_utils_NewtypeUUID$$anon$1__f_$outer;
  return $f_Lframework_utils_NewtypeUUID__toBase64__ju_UUID__Lframework_data_Base64Id(this$1, _$1).asString__T();
});
$c_Lframework_utils_NewtypeUUID$$anon$1.prototype.show__O__T = (function(t) {
  return this.show__ju_UUID__T(t);
});
var $d_Lframework_utils_NewtypeUUID$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_NewtypeUUID$$anon$1, "framework.utils.NewtypeUUID$$anon$1", ({
  Lframework_utils_NewtypeUUID$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Show$ContravariantShow: 1,
  Lcats_Show: 1
}));
export { $d_Lframework_utils_NewtypeUUID$$anon$1 as $d_Lframework_utils_NewtypeUUID$$anon$1 };
/** @constructor */
function $c_Lframework_utils_PageRenderResult(content, pageTitle, externalModifiers) {
  this.Lframework_utils_PageRenderResult__f_content = null;
  this.Lframework_utils_PageRenderResult__f_pageTitle = null;
  this.Lframework_utils_PageRenderResult__f_externalModifiers = null;
  this.Lframework_utils_PageRenderResult__f_content = content;
  this.Lframework_utils_PageRenderResult__f_pageTitle = pageTitle;
  this.Lframework_utils_PageRenderResult__f_externalModifiers = externalModifiers;
}
export { $c_Lframework_utils_PageRenderResult as $c_Lframework_utils_PageRenderResult };
$c_Lframework_utils_PageRenderResult.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_PageRenderResult.prototype.constructor = $c_Lframework_utils_PageRenderResult;
/** @constructor */
function $h_Lframework_utils_PageRenderResult() {
}
export { $h_Lframework_utils_PageRenderResult as $h_Lframework_utils_PageRenderResult };
$h_Lframework_utils_PageRenderResult.prototype = $c_Lframework_utils_PageRenderResult.prototype;
$c_Lframework_utils_PageRenderResult.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_utils_PageRenderResult.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-2088939444), true);
});
$c_Lframework_utils_PageRenderResult.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lframework_utils_PageRenderResult)) {
    var x = this.Lframework_utils_PageRenderResult__f_content;
    var y = x$0.Lframework_utils_PageRenderResult__f_content;
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Lframework_utils_PageRenderResult__f_pageTitle;
      var y$1 = x$0.Lframework_utils_PageRenderResult__f_pageTitle;
      var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y$1);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$2 = this.Lframework_utils_PageRenderResult__f_externalModifiers;
      var y$2 = x$0.Lframework_utils_PageRenderResult__f_externalModifiers;
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x$2, y$2);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lframework_utils_PageRenderResult.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lframework_utils_PageRenderResult.prototype.productArity__I = (function() {
  return 3;
});
$c_Lframework_utils_PageRenderResult.prototype.productPrefix__T = (function() {
  return "PageRenderResult";
});
$c_Lframework_utils_PageRenderResult.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lframework_utils_PageRenderResult__f_content;
      break;
    }
    case 1: {
      return this.Lframework_utils_PageRenderResult__f_pageTitle;
      break;
    }
    case 2: {
      return this.Lframework_utils_PageRenderResult__f_externalModifiers;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lframework_utils_PageRenderResult.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "content";
      break;
    }
    case 1: {
      return "pageTitle";
      break;
    }
    case 2: {
      return "externalModifiers";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lframework_utils_PageRenderResult.prototype.pageTitleSignal__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_core_Signal = (function(defaultPageTitleSignal) {
  var $x_2 = $m_Lframework_utils_PageTitleResult$();
  matchResult4: {
    var $x_1;
    var x5 = this.Lframework_utils_PageRenderResult__f_pageTitle;
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$is_Lcom_raquo_airstream_core_Signal(x5)) {
      var $x_1 = x5;
      break matchResult4;
    }
    var $x_1 = $m_Lcom_raquo_airstream_state_Val$().apply__O__Lcom_raquo_airstream_state_Val(x5);
  }
  return $x_2.pageTitleSignal__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_core_Signal($x_1, defaultPageTitleSignal);
});
$c_Lframework_utils_PageRenderResult.prototype.withExternalModifiers__F1__Lframework_utils_PageRenderResult = (function(f) {
  matchResult5: {
    var $x_1;
    var x7 = this.Lframework_utils_PageRenderResult__f_externalModifiers;
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$is_Lcom_raquo_airstream_core_Signal(x7)) {
      var $x_1 = x7;
      break matchResult5;
    }
    var $x_1 = $m_Lcom_raquo_airstream_state_Val$().apply__O__Lcom_raquo_airstream_state_Val(x7);
  }
  var this$3 = $x_1;
  var externalModifiers$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), this$3, f, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var content$1 = this.Lframework_utils_PageRenderResult__f_content;
  var pageTitle$1 = this.Lframework_utils_PageRenderResult__f_pageTitle;
  return new $c_Lframework_utils_PageRenderResult(content$1, pageTitle$1, externalModifiers$1);
});
$c_Lframework_utils_PageRenderResult.prototype.mapContent__F1__Lframework_utils_PageRenderResult = (function(f) {
  matchResult6: {
    var $x_1;
    var x9 = this.Lframework_utils_PageRenderResult__f_content;
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$is_Lcom_raquo_airstream_core_Signal(x9)) {
      var $x_1 = x9;
      break matchResult6;
    }
    var $x_1 = $m_Lcom_raquo_airstream_state_Val$().apply__O__Lcom_raquo_airstream_state_Val(x9);
  }
  var this$5 = $x_1;
  var project = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$1) => {
    var value$proxy1 = f.apply__O__O(_$1);
    return ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$is_Lcom_raquo_airstream_core_Signal(value$proxy1) ? value$proxy1 : $m_Lcom_raquo_airstream_state_Val$().apply__O__Lcom_raquo_airstream_state_Val(value$proxy1));
  }));
  var strategy = $m_Lcom_raquo_airstream_core_Observable$().Lcom_raquo_airstream_core_Observable$__f_switchSignalStrategy;
  var content = strategy.flatten__Lcom_raquo_airstream_core_Observable__Lcom_raquo_airstream_core_Observable($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), this$5, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()));
  var pageTitle = this.Lframework_utils_PageRenderResult__f_pageTitle;
  var externalModifiers = this.Lframework_utils_PageRenderResult__f_externalModifiers;
  return new $c_Lframework_utils_PageRenderResult(content, pageTitle, externalModifiers);
});
function $isArrayOf_Lframework_utils_PageRenderResult(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_utils_PageRenderResult)));
}
export { $isArrayOf_Lframework_utils_PageRenderResult as $isArrayOf_Lframework_utils_PageRenderResult };
var $d_Lframework_utils_PageRenderResult = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_PageRenderResult, "framework.utils.PageRenderResult", ({
  Lframework_utils_PageRenderResult: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_utils_PageRenderResult as $d_Lframework_utils_PageRenderResult };
function $p_Lframework_utils_PageTitleResult$Result__withPrefix$1__s_Option__T__T($thiz, prefix$1, str) {
  var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  if ((x === prefix$1)) {
    return str;
  }
  if ((prefix$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
    var prefix = prefix$1.s_Some__f_value;
    return (("" + prefix) + str);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(prefix$1);
}
export { $p_Lframework_utils_PageTitleResult$Result__withPrefix$1__s_Option__T__T as $p_Lframework_utils_PageTitleResult$Result__withPrefix$1__s_Option__T__T };
/** @constructor */
function $c_Lframework_utils_PageTitleResult$Result(pageTitle, renderInDocument) {
  this.Lframework_utils_PageTitleResult$Result__f_pageTitle = null;
  this.Lframework_utils_PageTitleResult$Result__f_renderInDocument = false;
  this.Lframework_utils_PageTitleResult$Result__f_pageTitle = pageTitle;
  this.Lframework_utils_PageTitleResult$Result__f_renderInDocument = renderInDocument;
}
export { $c_Lframework_utils_PageTitleResult$Result as $c_Lframework_utils_PageTitleResult$Result };
$c_Lframework_utils_PageTitleResult$Result.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_PageTitleResult$Result.prototype.constructor = $c_Lframework_utils_PageTitleResult$Result;
/** @constructor */
function $h_Lframework_utils_PageTitleResult$Result() {
}
export { $h_Lframework_utils_PageTitleResult$Result as $h_Lframework_utils_PageTitleResult$Result };
$h_Lframework_utils_PageTitleResult$Result.prototype = $c_Lframework_utils_PageTitleResult$Result.prototype;
$c_Lframework_utils_PageTitleResult$Result.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_utils_PageTitleResult$Result.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, (-1850559427));
  var hash$1 = acc;
  var x = this.Lframework_utils_PageTitleResult$Result__f_pageTitle;
  var data = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data);
  var hash$2 = acc;
  var data$1 = (this.Lframework_utils_PageTitleResult$Result__f_renderInDocument ? 1231 : 1237);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$2, data$1);
  var hash$3 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2);
});
$c_Lframework_utils_PageTitleResult$Result.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lframework_utils_PageTitleResult$Result) && ((this.Lframework_utils_PageTitleResult$Result__f_renderInDocument === x$0.Lframework_utils_PageTitleResult$Result__f_renderInDocument) && (this.Lframework_utils_PageTitleResult$Result__f_pageTitle === x$0.Lframework_utils_PageTitleResult$Result__f_pageTitle))));
});
$c_Lframework_utils_PageTitleResult$Result.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lframework_utils_PageTitleResult$Result.prototype.productArity__I = (function() {
  return 2;
});
$c_Lframework_utils_PageTitleResult$Result.prototype.productPrefix__T = (function() {
  return "Result";
});
$c_Lframework_utils_PageTitleResult$Result.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_utils_PageTitleResult$Result__f_pageTitle;
  }
  if ((n === 1)) {
    return this.Lframework_utils_PageTitleResult$Result__f_renderInDocument;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_utils_PageTitleResult$Result.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "pageTitle";
  }
  if ((n === 1)) {
    return "renderInDocument";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_utils_PageTitleResult$Result.prototype.pageTitleForDocument__s_Option = (function() {
  if (this.Lframework_utils_PageTitleResult$Result__f_renderInDocument) {
    var value = this.Lframework_utils_PageTitleResult$Result__f_pageTitle;
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
  } else {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
});
$c_Lframework_utils_PageTitleResult$Result.prototype.pageTitleNodeForDocument__s_Option = (function() {
  var this$1 = this.pageTitleForDocument__s_Option();
  if (this$1.isEmpty__Z()) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0 = this$1.get__O();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$();
    var r = $m_Lframework_prelude_laminar$package$().renderableTextForShow__Lcats_Show__Lcom_raquo_laminar_modifiers_RenderableText($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($m_Lcom_raquo_laminar_nodes_TextNode$().apply__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode(x0, r));
  }
});
$c_Lframework_utils_PageTitleResult$Result.prototype.windowTitle__T__s_Option__T = (function(appName, prefix) {
  if ((this.Lframework_utils_PageTitleResult$Result__f_pageTitle === appName)) {
    var $x_1 = appName;
  } else {
    var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
    var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["", " - ", ""]));
    var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
    var $x_1 = $x_2.show$extension__s_StringContext__sci_Seq__T(sc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(this.Lframework_utils_PageTitleResult$Result__f_pageTitle, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString)), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(appName, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))])));
  }
  return $p_Lframework_utils_PageTitleResult$Result__withPrefix$1__s_Option__T__T(this, prefix, $x_1);
});
$c_Lframework_utils_PageTitleResult$Result.prototype.applyWindowTitle__T__s_Option__V = (function(appName, prefix) {
  document.title = this.windowTitle__T__s_Option__T(appName, prefix);
});
function $isArrayOf_Lframework_utils_PageTitleResult$Result(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_utils_PageTitleResult$Result)));
}
export { $isArrayOf_Lframework_utils_PageTitleResult$Result as $isArrayOf_Lframework_utils_PageTitleResult$Result };
var $d_Lframework_utils_PageTitleResult$Result = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_PageTitleResult$Result, "framework.utils.PageTitleResult$Result", ({
  Lframework_utils_PageTitleResult$Result: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_utils_PageTitleResult$Result as $d_Lframework_utils_PageTitleResult$Result };
/** @constructor */
function $c_Lframework_utils_PushNotifications$PublicKey(bytes) {
  this.Lframework_utils_PushNotifications$PublicKey__f_bytes = null;
  this.Lframework_utils_PushNotifications$PublicKey__f_bytes = bytes;
}
export { $c_Lframework_utils_PushNotifications$PublicKey as $c_Lframework_utils_PushNotifications$PublicKey };
$c_Lframework_utils_PushNotifications$PublicKey.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_PushNotifications$PublicKey.prototype.constructor = $c_Lframework_utils_PushNotifications$PublicKey;
/** @constructor */
function $h_Lframework_utils_PushNotifications$PublicKey() {
}
export { $h_Lframework_utils_PushNotifications$PublicKey as $h_Lframework_utils_PushNotifications$PublicKey };
$h_Lframework_utils_PushNotifications$PublicKey.prototype = $c_Lframework_utils_PushNotifications$PublicKey.prototype;
$c_Lframework_utils_PushNotifications$PublicKey.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_utils_PushNotifications$PublicKey.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-643337887), true);
});
$c_Lframework_utils_PushNotifications$PublicKey.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lframework_utils_PushNotifications$PublicKey)) {
    var x = this.Lframework_utils_PushNotifications$PublicKey__f_bytes;
    var x$2 = x$0.Lframework_utils_PushNotifications$PublicKey__f_bytes;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lframework_utils_PushNotifications$PublicKey.prototype.productArity__I = (function() {
  return 1;
});
$c_Lframework_utils_PushNotifications$PublicKey.prototype.productPrefix__T = (function() {
  return "PublicKey";
});
$c_Lframework_utils_PushNotifications$PublicKey.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_utils_PushNotifications$PublicKey__f_bytes;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_utils_PushNotifications$PublicKey.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "bytes";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_utils_PushNotifications$PublicKey.prototype.toJS__sjs_js_typedarray_Uint8Array = (function() {
  var $x_2 = Uint8Array;
  var $x_1 = $m_Lframework_exts_ClientIteratorExts$package$();
  var this$1 = this.Lframework_utils_PushNotifications$PublicKey__f_bytes.iterator__sc_Iterator();
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$1) => {
    var _$1$1 = (_$1 | 0);
    return _$1$1;
  }));
  return new $x_2($x_1.toJsArray__sc_Iterator__sjs_js_Array(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(this$1, f)));
});
$c_Lframework_utils_PushNotifications$PublicKey.prototype.toString__T = (function() {
  var this$1 = this.Lframework_utils_PushNotifications$PublicKey__f_bytes.iterator__sc_Iterator();
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((b) => {
    var b$1 = (b | 0);
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_StringOps$().format$extension__T__sci_Seq__T("%02x", $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([b$1])));
  }));
  var this$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(this$1, f);
  return (("PublicKey(" + $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__mkString__T__T__T__T(this$2, "", ":", "")) + ")");
});
function $isArrayOf_Lframework_utils_PushNotifications$PublicKey(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_utils_PushNotifications$PublicKey)));
}
export { $isArrayOf_Lframework_utils_PushNotifications$PublicKey as $isArrayOf_Lframework_utils_PushNotifications$PublicKey };
var $d_Lframework_utils_PushNotifications$PublicKey = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_PushNotifications$PublicKey, "framework.utils.PushNotifications$PublicKey", ({
  Lframework_utils_PushNotifications$PublicKey: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_utils_PushNotifications$PublicKey as $d_Lframework_utils_PushNotifications$PublicKey };
/** @constructor */
function $c_Lframework_utils_PushNotifications$PublicKey$$anon$1() {
}
export { $c_Lframework_utils_PushNotifications$PublicKey$$anon$1 as $c_Lframework_utils_PushNotifications$PublicKey$$anon$1 };
$c_Lframework_utils_PushNotifications$PublicKey$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_PushNotifications$PublicKey$$anon$1.prototype.constructor = $c_Lframework_utils_PushNotifications$PublicKey$$anon$1;
/** @constructor */
function $h_Lframework_utils_PushNotifications$PublicKey$$anon$1() {
}
export { $h_Lframework_utils_PushNotifications$PublicKey$$anon$1 as $h_Lframework_utils_PushNotifications$PublicKey$$anon$1 };
$h_Lframework_utils_PushNotifications$PublicKey$$anon$1.prototype = $c_Lframework_utils_PushNotifications$PublicKey$$anon$1.prototype;
$c_Lframework_utils_PushNotifications$PublicKey$$anon$1.prototype.show__O__T = (function(t) {
  return t.toString__T();
});
var $d_Lframework_utils_PushNotifications$PublicKey$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_PushNotifications$PublicKey$$anon$1, "framework.utils.PushNotifications$PublicKey$$anon$1", ({
  Lframework_utils_PushNotifications$PublicKey$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Show$ContravariantShow: 1,
  Lcats_Show: 1
}));
export { $d_Lframework_utils_PushNotifications$PublicKey$$anon$1 as $d_Lframework_utils_PushNotifications$PublicKey$$anon$1 };
/** @constructor */
function $c_Lframework_utils_extractors_StartsWithE(prefix) {
  this.Lframework_utils_extractors_StartsWithE__f_prefix = null;
  this.Lframework_utils_extractors_StartsWithE__f_prefix = prefix;
}
export { $c_Lframework_utils_extractors_StartsWithE as $c_Lframework_utils_extractors_StartsWithE };
$c_Lframework_utils_extractors_StartsWithE.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_extractors_StartsWithE.prototype.constructor = $c_Lframework_utils_extractors_StartsWithE;
/** @constructor */
function $h_Lframework_utils_extractors_StartsWithE() {
}
export { $h_Lframework_utils_extractors_StartsWithE as $h_Lframework_utils_extractors_StartsWithE };
$h_Lframework_utils_extractors_StartsWithE.prototype = $c_Lframework_utils_extractors_StartsWithE.prototype;
$c_Lframework_utils_extractors_StartsWithE.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_utils_extractors_StartsWithE.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1052434888, true);
});
$c_Lframework_utils_extractors_StartsWithE.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lframework_utils_extractors_StartsWithE) && (this.Lframework_utils_extractors_StartsWithE__f_prefix === x$0.Lframework_utils_extractors_StartsWithE__f_prefix)));
});
$c_Lframework_utils_extractors_StartsWithE.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lframework_utils_extractors_StartsWithE.prototype.productArity__I = (function() {
  return 1;
});
$c_Lframework_utils_extractors_StartsWithE.prototype.productPrefix__T = (function() {
  return "StartsWithE";
});
$c_Lframework_utils_extractors_StartsWithE.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_utils_extractors_StartsWithE__f_prefix;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_utils_extractors_StartsWithE.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "prefix";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_utils_extractors_StartsWithE.prototype.unapply__T__s_Option = (function(s) {
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Option$().apply__O__s_Option(s);
  if (this$1.isEmpty__Z()) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0 = this$1.get__O();
    var prefix = this.Lframework_utils_extractors_StartsWithE__f_prefix;
    if ((!(!x0.startsWith(prefix)))) {
      var this$2 = this.Lframework_utils_extractors_StartsWithE__f_prefix;
      var beginIndex = this$2.length;
      var value = x0.substring(beginIndex);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
    } else {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    }
  }
});
function $isArrayOf_Lframework_utils_extractors_StartsWithE(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_utils_extractors_StartsWithE)));
}
export { $isArrayOf_Lframework_utils_extractors_StartsWithE as $isArrayOf_Lframework_utils_extractors_StartsWithE };
var $d_Lframework_utils_extractors_StartsWithE = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_extractors_StartsWithE, "framework.utils.extractors.StartsWithE", ({
  Lframework_utils_extractors_StartsWithE: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_utils_extractors_StartsWithE as $d_Lframework_utils_extractors_StartsWithE };
/** @constructor */
function $c_Lfs2_Chunk$$anon$1(outer) {
  this.Lfs2_Chunk$$anon$1__f_i = 0;
  this.Lfs2_Chunk$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lfs2_Chunk$$anon$1__f_$outer = outer;
  this.Lfs2_Chunk$$anon$1__f_i = 0;
}
export { $c_Lfs2_Chunk$$anon$1 as $c_Lfs2_Chunk$$anon$1 };
$c_Lfs2_Chunk$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_Chunk$$anon$1.prototype.constructor = $c_Lfs2_Chunk$$anon$1;
/** @constructor */
function $h_Lfs2_Chunk$$anon$1() {
}
export { $h_Lfs2_Chunk$$anon$1 as $h_Lfs2_Chunk$$anon$1 };
$h_Lfs2_Chunk$$anon$1.prototype = $c_Lfs2_Chunk$$anon$1.prototype;
$c_Lfs2_Chunk$$anon$1.prototype.knownSize__I = (function() {
  return (-1);
});
$c_Lfs2_Chunk$$anon$1.prototype.forall__F1__Z = (function(p) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_Lfs2_Chunk$$anon$1.prototype.find__F1__s_Option = (function(p) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$c_Lfs2_Chunk$$anon$1.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_Lfs2_Chunk$$anon$1.prototype.reduceLeft__F2__O = (function(op) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$c_Lfs2_Chunk$$anon$1.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$c_Lfs2_Chunk$$anon$1.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_Lfs2_Chunk$$anon$1.prototype.toList__sci_List = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_Lfs2_Chunk$$anon$1.prototype.toVector__sci_Vector = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this);
});
$c_Lfs2_Chunk$$anon$1.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_Lfs2_Chunk$$anon$1.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_Lfs2_Chunk$$anon$1.prototype.reversed__sc_Iterable = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__reversed__sc_Iterable(this);
});
$c_Lfs2_Chunk$$anon$1.prototype.iterator__sc_Iterator = (function() {
  return this;
});
$c_Lfs2_Chunk$$anon$1.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$c_Lfs2_Chunk$$anon$1.prototype.take__I__sc_Iterator = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$c_Lfs2_Chunk$$anon$1.prototype.drop__I__sc_Iterator = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1));
});
$c_Lfs2_Chunk$$anon$1.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$c_Lfs2_Chunk$$anon$1.prototype.toString__T = (function() {
  return "<iterator>";
});
$c_Lfs2_Chunk$$anon$1.prototype.hasNext__Z = (function() {
  return (this.Lfs2_Chunk$$anon$1__f_i < this.Lfs2_Chunk$$anon$1__f_$outer.size__I());
});
$c_Lfs2_Chunk$$anon$1.prototype.next__O = (function() {
  var result = this.Lfs2_Chunk$$anon$1__f_$outer.apply__I__O(this.Lfs2_Chunk$$anon$1__f_i);
  this.Lfs2_Chunk$$anon$1__f_i = ((1 + this.Lfs2_Chunk$$anon$1__f_i) | 0);
  return result;
});
var $d_Lfs2_Chunk$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Chunk$$anon$1, "fs2.Chunk$$anon$1", ({
  Lfs2_Chunk$$anon$1: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_Iterator: 1
}));
export { $d_Lfs2_Chunk$$anon$1 as $d_Lfs2_Chunk$$anon$1 };
/** @constructor */
function $c_Lfs2_Pull$AlgEffect() {
}
export { $c_Lfs2_Pull$AlgEffect as $c_Lfs2_Pull$AlgEffect };
$c_Lfs2_Pull$AlgEffect.prototype = new $h_Lfs2_Pull$Action();
$c_Lfs2_Pull$AlgEffect.prototype.constructor = $c_Lfs2_Pull$AlgEffect;
/** @constructor */
function $h_Lfs2_Pull$AlgEffect() {
}
export { $h_Lfs2_Pull$AlgEffect as $h_Lfs2_Pull$AlgEffect };
$h_Lfs2_Pull$AlgEffect.prototype = $c_Lfs2_Pull$AlgEffect.prototype;
function $isArrayOf_Lfs2_Pull$AlgEffect(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$AlgEffect)));
}
export { $isArrayOf_Lfs2_Pull$AlgEffect as $isArrayOf_Lfs2_Pull$AlgEffect };
function $ct_Lfs2_Pull$Bind__Lfs2_Pull__($thiz, step) {
  $thiz.Lfs2_Pull$Bind__f_step = step;
  return $thiz;
}
export { $ct_Lfs2_Pull$Bind__Lfs2_Pull__ as $ct_Lfs2_Pull$Bind__Lfs2_Pull__ };
/** @constructor */
function $c_Lfs2_Pull$Bind() {
  this.Lfs2_Pull$Bind__f_step = null;
}
export { $c_Lfs2_Pull$Bind as $c_Lfs2_Pull$Bind };
$c_Lfs2_Pull$Bind.prototype = new $h_Lfs2_Pull();
$c_Lfs2_Pull$Bind.prototype.constructor = $c_Lfs2_Pull$Bind;
/** @constructor */
function $h_Lfs2_Pull$Bind() {
}
export { $h_Lfs2_Pull$Bind as $h_Lfs2_Pull$Bind };
$h_Lfs2_Pull$Bind.prototype = $c_Lfs2_Pull$Bind.prototype;
$c_Lfs2_Pull$Bind.prototype.compose__F1__F1 = (function(g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_F1__compose__F1__F1(this, g);
});
$c_Lfs2_Pull$Bind.prototype.andThen__F1__F1 = (function(g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_F1__andThen__F1__F1(this, g);
});
$c_Lfs2_Pull$Bind.prototype.toString__T = (function() {
  return "<function1>";
});
$c_Lfs2_Pull$Bind.prototype.delegate__Lfs2_Pull$Bind = (function() {
  return this;
});
$c_Lfs2_Pull$Bind.prototype.apply__O__O = (function(v1) {
  return this.cont__Lfs2_Pull$Terminal__Lfs2_Pull(v1);
});
$c_Lfs2_Pull$Bind.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return (!(!this.cont__Lfs2_Pull$Terminal__Lfs2_Pull(v1)));
});
function $isArrayOf_Lfs2_Pull$Bind(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Bind)));
}
export { $isArrayOf_Lfs2_Pull$Bind as $isArrayOf_Lfs2_Pull$Bind };
/** @constructor */
function $c_Lfs2_concurrent_Channel$State$1(values, size, waiting, producers, closed) {
  this.Lfs2_concurrent_Channel$State$1__f_values = null;
  this.Lfs2_concurrent_Channel$State$1__f_size = 0;
  this.Lfs2_concurrent_Channel$State$1__f_waiting = null;
  this.Lfs2_concurrent_Channel$State$1__f_producers = null;
  this.Lfs2_concurrent_Channel$State$1__f_closed = false;
  this.Lfs2_concurrent_Channel$State$1__f_values = values;
  this.Lfs2_concurrent_Channel$State$1__f_size = size;
  this.Lfs2_concurrent_Channel$State$1__f_waiting = waiting;
  this.Lfs2_concurrent_Channel$State$1__f_producers = producers;
  this.Lfs2_concurrent_Channel$State$1__f_closed = closed;
}
export { $c_Lfs2_concurrent_Channel$State$1 as $c_Lfs2_concurrent_Channel$State$1 };
$c_Lfs2_concurrent_Channel$State$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_concurrent_Channel$State$1.prototype.constructor = $c_Lfs2_concurrent_Channel$State$1;
/** @constructor */
function $h_Lfs2_concurrent_Channel$State$1() {
}
export { $h_Lfs2_concurrent_Channel$State$1 as $h_Lfs2_concurrent_Channel$State$1 };
$h_Lfs2_concurrent_Channel$State$1.prototype = $c_Lfs2_concurrent_Channel$State$1.prototype;
$c_Lfs2_concurrent_Channel$State$1.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lfs2_concurrent_Channel$State$1.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, 80204913);
  var hash$1 = acc;
  var x = this.Lfs2_concurrent_Channel$State$1__f_values;
  var data = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data);
  var hash$2 = acc;
  var data$1 = this.Lfs2_concurrent_Channel$State$1__f_size;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$2, data$1);
  var hash$3 = acc;
  var x$1 = this.Lfs2_concurrent_Channel$State$1__f_waiting;
  var data$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$1);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$3, data$2);
  var hash$4 = acc;
  var x$2 = this.Lfs2_concurrent_Channel$State$1__f_producers;
  var data$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$2);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$4, data$3);
  var hash$5 = acc;
  var data$4 = (this.Lfs2_concurrent_Channel$State$1__f_closed ? 1231 : 1237);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$5, data$4);
  var hash$6 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$6, 5);
});
$c_Lfs2_concurrent_Channel$State$1.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_concurrent_Channel$State$1)) {
    if (((this.Lfs2_concurrent_Channel$State$1__f_size === x$0.Lfs2_concurrent_Channel$State$1__f_size) && (this.Lfs2_concurrent_Channel$State$1__f_closed === x$0.Lfs2_concurrent_Channel$State$1__f_closed))) {
      var x = this.Lfs2_concurrent_Channel$State$1__f_values;
      var x$2 = x$0.Lfs2_concurrent_Channel$State$1__f_values;
      var $x_2 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Lfs2_concurrent_Channel$State$1__f_waiting;
      var x$4 = x$0.Lfs2_concurrent_Channel$State$1__f_waiting;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Lfs2_concurrent_Channel$State$1__f_producers;
      var x$6 = x$0.Lfs2_concurrent_Channel$State$1__f_producers;
      return ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lfs2_concurrent_Channel$State$1.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_concurrent_Channel$State$1.prototype.productArity__I = (function() {
  return 5;
});
$c_Lfs2_concurrent_Channel$State$1.prototype.productPrefix__T = (function() {
  return "State";
});
$c_Lfs2_concurrent_Channel$State$1.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lfs2_concurrent_Channel$State$1__f_values;
      break;
    }
    case 1: {
      return this.Lfs2_concurrent_Channel$State$1__f_size;
      break;
    }
    case 2: {
      return this.Lfs2_concurrent_Channel$State$1__f_waiting;
      break;
    }
    case 3: {
      return this.Lfs2_concurrent_Channel$State$1__f_producers;
      break;
    }
    case 4: {
      return this.Lfs2_concurrent_Channel$State$1__f_closed;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lfs2_concurrent_Channel$State$1.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "values";
      break;
    }
    case 1: {
      return "size";
      break;
    }
    case 2: {
      return "waiting";
      break;
    }
    case 3: {
      return "producers";
      break;
    }
    case 4: {
      return "closed";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lfs2_concurrent_Channel$State$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_concurrent_Channel$State$1)));
}
export { $isArrayOf_Lfs2_concurrent_Channel$State$1 as $isArrayOf_Lfs2_concurrent_Channel$State$1 };
var $d_Lfs2_concurrent_Channel$State$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_concurrent_Channel$State$1, "fs2.concurrent.Channel$State$1", ({
  Lfs2_concurrent_Channel$State$1: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lfs2_concurrent_Channel$State$1 as $d_Lfs2_concurrent_Channel$State$1 };
/** @constructor */
function $c_Lfs2_concurrent_SignallingRef$State$1(value, lastUpdate, listeners) {
  this.Lfs2_concurrent_SignallingRef$State$1__f_value = null;
  this.Lfs2_concurrent_SignallingRef$State$1__f_lastUpdate = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0;
  this.Lfs2_concurrent_SignallingRef$State$1__f_listeners = null;
  this.Lfs2_concurrent_SignallingRef$State$1__f_value = value;
  this.Lfs2_concurrent_SignallingRef$State$1__f_lastUpdate = lastUpdate;
  this.Lfs2_concurrent_SignallingRef$State$1__f_listeners = listeners;
}
export { $c_Lfs2_concurrent_SignallingRef$State$1 as $c_Lfs2_concurrent_SignallingRef$State$1 };
$c_Lfs2_concurrent_SignallingRef$State$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_concurrent_SignallingRef$State$1.prototype.constructor = $c_Lfs2_concurrent_SignallingRef$State$1;
/** @constructor */
function $h_Lfs2_concurrent_SignallingRef$State$1() {
}
export { $h_Lfs2_concurrent_SignallingRef$State$1 as $h_Lfs2_concurrent_SignallingRef$State$1 };
$h_Lfs2_concurrent_SignallingRef$State$1.prototype = $c_Lfs2_concurrent_SignallingRef$State$1.prototype;
$c_Lfs2_concurrent_SignallingRef$State$1.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lfs2_concurrent_SignallingRef$State$1.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, 80204913);
  var hash$1 = acc;
  var x = this.Lfs2_concurrent_SignallingRef$State$1__f_value;
  var data = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data);
  var hash$2 = acc;
  var t = this.Lfs2_concurrent_SignallingRef$State$1__f_lastUpdate;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var data$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().longHash__J__I(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$2, data$1);
  var hash$3 = acc;
  var x$1 = this.Lfs2_concurrent_SignallingRef$State$1__f_listeners;
  var data$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$1);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$3, data$2);
  var hash$4 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3);
});
$c_Lfs2_concurrent_SignallingRef$State$1.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_concurrent_SignallingRef$State$1)) {
    var a = this.Lfs2_concurrent_SignallingRef$State$1__f_lastUpdate;
    var b = x$0.Lfs2_concurrent_SignallingRef$State$1__f_lastUpdate;
    if (((a.RTLong__f_lo === b.RTLong__f_lo) && (a.RTLong__f_hi === b.RTLong__f_hi))) {
      var x = this.Lfs2_concurrent_SignallingRef$State$1__f_value;
      var y = x$0.Lfs2_concurrent_SignallingRef$State$1__f_value;
      var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$1 = this.Lfs2_concurrent_SignallingRef$State$1__f_listeners;
      var x$2 = x$0.Lfs2_concurrent_SignallingRef$State$1__f_listeners;
      return ((x$1 === null) ? (x$2 === null) : x$1.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lfs2_concurrent_SignallingRef$State$1.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_concurrent_SignallingRef$State$1.prototype.productArity__I = (function() {
  return 3;
});
$c_Lfs2_concurrent_SignallingRef$State$1.prototype.productPrefix__T = (function() {
  return "State";
});
$c_Lfs2_concurrent_SignallingRef$State$1.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lfs2_concurrent_SignallingRef$State$1__f_value;
      break;
    }
    case 1: {
      return this.Lfs2_concurrent_SignallingRef$State$1__f_lastUpdate;
      break;
    }
    case 2: {
      return this.Lfs2_concurrent_SignallingRef$State$1__f_listeners;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lfs2_concurrent_SignallingRef$State$1.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "value";
      break;
    }
    case 1: {
      return "lastUpdate";
      break;
    }
    case 2: {
      return "listeners";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lfs2_concurrent_SignallingRef$State$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_concurrent_SignallingRef$State$1)));
}
export { $isArrayOf_Lfs2_concurrent_SignallingRef$State$1 as $isArrayOf_Lfs2_concurrent_SignallingRef$State$1 };
var $d_Lfs2_concurrent_SignallingRef$State$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_concurrent_SignallingRef$State$1, "fs2.concurrent.SignallingRef$State$1", ({
  Lfs2_concurrent_SignallingRef$State$1: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lfs2_concurrent_SignallingRef$State$1 as $d_Lfs2_concurrent_SignallingRef$State$1 };
function $p_Lfs2_internal_InterruptContext__complete__Lcats_effect_kernel_Outcome__O($thiz, outcome) {
  var wrapped = $thiz.Lfs2_internal_InterruptContext__f_ref.update__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => (_$2.isEmpty__Z() ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(outcome) : _$2))));
  var this$3 = $thiz.Lfs2_internal_InterruptContext__f_deferred;
  var target = this$3.complete__O__Lcats_effect_IO(outcome);
  var tc = $thiz.Lfs2_internal_InterruptContext__f_F;
  var this$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
  var fin = this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.void__O__O(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
  return wrapped.guarantee__Lcats_effect_IO__Lcats_effect_IO(fin);
}
export { $p_Lfs2_internal_InterruptContext__complete__Lcats_effect_kernel_Outcome__O as $p_Lfs2_internal_InterruptContext__complete__Lcats_effect_kernel_Outcome__O };
/** @constructor */
function $c_Lfs2_internal_InterruptContext(deferred, ref, interruptRoot, cancelParent, F) {
  this.Lfs2_internal_InterruptContext__f_deferred = null;
  this.Lfs2_internal_InterruptContext__f_ref = null;
  this.Lfs2_internal_InterruptContext__f_interruptRoot = null;
  this.Lfs2_internal_InterruptContext__f_cancelParent = null;
  this.Lfs2_internal_InterruptContext__f_F = null;
  this.Lfs2_internal_InterruptContext__f_deferred = deferred;
  this.Lfs2_internal_InterruptContext__f_ref = ref;
  this.Lfs2_internal_InterruptContext__f_interruptRoot = interruptRoot;
  this.Lfs2_internal_InterruptContext__f_cancelParent = cancelParent;
  this.Lfs2_internal_InterruptContext__f_F = F;
}
export { $c_Lfs2_internal_InterruptContext as $c_Lfs2_internal_InterruptContext };
$c_Lfs2_internal_InterruptContext.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_internal_InterruptContext.prototype.constructor = $c_Lfs2_internal_InterruptContext;
/** @constructor */
function $h_Lfs2_internal_InterruptContext() {
}
export { $h_Lfs2_internal_InterruptContext as $h_Lfs2_internal_InterruptContext };
$h_Lfs2_internal_InterruptContext.prototype = $c_Lfs2_internal_InterruptContext.prototype;
$c_Lfs2_internal_InterruptContext.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lfs2_internal_InterruptContext.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 260103398, true);
});
$c_Lfs2_internal_InterruptContext.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_internal_InterruptContext)) {
    var x = this.Lfs2_internal_InterruptContext__f_deferred;
    var x$2 = x$0.Lfs2_internal_InterruptContext__f_deferred;
    if ((x === x$2)) {
      var x$3 = this.Lfs2_internal_InterruptContext__f_ref;
      var x$4 = x$0.Lfs2_internal_InterruptContext__f_ref;
      var $x_2 = (x$3 === x$4);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Lfs2_internal_InterruptContext__f_interruptRoot;
      var x$6 = x$0.Lfs2_internal_InterruptContext__f_interruptRoot;
      var $x_1 = (x$5 === x$6);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$1 = this.Lfs2_internal_InterruptContext__f_cancelParent;
      var y = x$0.Lfs2_internal_InterruptContext__f_cancelParent;
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lfs2_internal_InterruptContext.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_internal_InterruptContext.prototype.productArity__I = (function() {
  return 4;
});
$c_Lfs2_internal_InterruptContext.prototype.productPrefix__T = (function() {
  return "InterruptContext";
});
$c_Lfs2_internal_InterruptContext.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lfs2_internal_InterruptContext__f_deferred;
      break;
    }
    case 1: {
      return this.Lfs2_internal_InterruptContext__f_ref;
      break;
    }
    case 2: {
      return this.Lfs2_internal_InterruptContext__f_interruptRoot;
      break;
    }
    case 3: {
      return this.Lfs2_internal_InterruptContext__f_cancelParent;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lfs2_internal_InterruptContext.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "deferred";
      break;
    }
    case 1: {
      return "ref";
      break;
    }
    case 2: {
      return "interruptRoot";
      break;
    }
    case 3: {
      return "cancelParent";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lfs2_internal_InterruptContext.prototype.completeWhen__O__O = (function(outcome) {
  var tc = this.Lfs2_internal_InterruptContext__f_F;
  var this$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(outcome, tc);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((outcome$2) => $p_Lfs2_internal_InterruptContext__complete__Lcats_effect_kernel_Outcome__O(this, outcome$2)));
  var fa = this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  return new $c_Lcats_effect_IO$Start(fa);
});
$c_Lfs2_internal_InterruptContext.prototype.childContext__Z__Lcats_effect_kernel_Unique$Token__O = (function(interruptible, newScopeId) {
  if (interruptible) {
    var this$2 = $m_Lcats_effect_kernel_implicits$();
    var this$1 = this.Lfs2_internal_InterruptContext__f_deferred;
    var wrapped = this$1.get__Lcats_effect_IO();
    var F = this.Lfs2_internal_InterruptContext__f_F;
    var ev$2 = $f_Lcats_effect_kernel_syntax_GenSpawnSyntax__genSpawnOps__O__Lcats_effect_kernel_GenSpawn__O(this$2, wrapped, F);
    var target = new $c_Lcats_effect_IO$Start(ev$2);
    var tc = this.Lfs2_internal_InterruptContext__f_F;
    var this$22 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
    var f$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((fiber) => {
      var target$1 = $m_Lfs2_internal_InterruptContext$().apply__Lcats_effect_kernel_Unique$Token__O__Lcats_effect_kernel_GenConcurrent__O(newScopeId, fiber.cancel__O(), this.Lfs2_internal_InterruptContext__f_F);
      var tc$1 = this.Lfs2_internal_InterruptContext__f_F;
      var this$21 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$1);
      var f$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((fiber$2) => ((context) => {
        var this$16 = $m_Lcats_effect_kernel_implicits$();
        var target$2 = fiber$2.join__O();
        var tc$2 = this.Lfs2_internal_InterruptContext__f_F;
        var this$15 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, tc$2);
        var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((context$2) => ((x$1) => {
          if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Succeeded)) {
            var x12 = x$1.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
            var tc$3 = this.Lfs2_internal_InterruptContext__f_F;
            var this$11 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(x12, tc$3);
            var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((i) => $p_Lfs2_internal_InterruptContext__complete__Lcats_effect_kernel_Outcome__O(context$2, i)));
            return this$11.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$11.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
          }
          if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Errored)) {
            var x9 = x$1.Lcats_effect_kernel_Outcome$Errored__f_e;
            return $p_Lfs2_internal_InterruptContext__complete__Lcats_effect_kernel_Outcome__O(context$2, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Errored(x9));
          }
          if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Canceled)) {
            return $p_Lfs2_internal_InterruptContext__complete__Lcats_effect_kernel_Outcome__O(context$2, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Canceled());
          }
          throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
        }))(context));
        var wrapped$1 = this$15.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$15.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
        var F$2 = this.Lfs2_internal_InterruptContext__f_F;
        var ev$3 = $f_Lcats_effect_kernel_syntax_GenSpawnSyntax__genSpawnOps__O__Lcats_effect_kernel_GenSpawn__O(this$16, wrapped$1, F$2);
        var target$3 = new $c_Lcats_effect_IO$Start(ev$3);
        var tc$4 = this.Lfs2_internal_InterruptContext__f_F;
        var this$20 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target$3, tc$4);
        return this$20.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.as__O__O__O(this$20.Lcats_Functor$ToFunctorOps$$anon$5__f_self, context);
      }))(fiber));
      return this$21.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$21.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
    }));
    return this$22.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$22.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
  } else {
    var cancelParent$1 = $m_Lcats_effect_IO$().Lcats_effect_IO$__f__unit;
    var deferred$1 = this.Lfs2_internal_InterruptContext__f_deferred;
    var ref$1 = this.Lfs2_internal_InterruptContext__f_ref;
    var interruptRoot$1 = this.Lfs2_internal_InterruptContext__f_interruptRoot;
    var F$4 = this.Lfs2_internal_InterruptContext__f_F;
    var a = new $c_Lfs2_internal_InterruptContext(deferred$1, ref$1, interruptRoot$1, cancelParent$1, F$4);
    $m_Lcats_effect_IO$();
    return new $c_Lcats_effect_IO$Pure(a);
  }
});
$c_Lfs2_internal_InterruptContext.prototype.eval__O__O = (function(fa) {
  var target = this.Lfs2_internal_InterruptContext__f_ref.get__O();
  var tc = this.Lfs2_internal_InterruptContext__f_F;
  var this$35 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var outcome = x$1.s_Some__f_value;
      var x = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(outcome);
      $m_Lcats_effect_IO$();
      return new $c_Lcats_effect_IO$Pure(x);
    }
    var x$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    if ((x$2 === x$1)) {
      var this$11 = this.Lfs2_internal_InterruptContext__f_F;
      var this$7 = this.Lfs2_internal_InterruptContext__f_deferred;
      var fa$1 = this$7.get__Lcats_effect_IO();
      var fb = new $c_Lcats_effect_IO$Attempt(fa);
      var target$1 = $f_Lcats_effect_kernel_GenSpawn__raceOutcome__O__O__O(this$11, fa$1, fb);
      var tc$1 = this.Lfs2_internal_InterruptContext__f_F;
      var this$34 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$1);
      var f$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1$2) => {
        if ((x$1$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
          var oc = x$1$2.s_util_Right__f_value;
          if ((oc instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Canceled)) {
            $m_Lcats_effect_IO$();
            var target$2 = $m_Lcats_effect_IO$Canceled$();
            var tc$2 = this.Lfs2_internal_InterruptContext__f_F;
            var this$18 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, tc$2);
            var value = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Canceled();
            var b = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value);
            return this$18.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.as__O__O__O(this$18.Lcats_Functor$ToFunctorOps$$anon$5__f_self, b);
          }
          if ((oc instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Errored)) {
            var x7 = oc.Lcats_effect_kernel_Outcome$Errored__f_e;
            $m_Lcats_effect_IO$();
            return new $c_Lcats_effect_IO$Error(x7);
          }
          if ((oc instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Succeeded)) {
            var x4 = oc.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
            var tc$3 = this.Lfs2_internal_InterruptContext__f_F;
            var this$30 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(x4, tc$3);
            var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$3) => {
              if ((_$3 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
                var a = _$3.s_util_Left__f_value;
                var value$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Errored(a);
                return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value$1);
              }
              if ((_$3 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
                $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_syntax_EitherUtil$();
                return _$3;
              }
              throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(_$3);
            }));
            return this$30.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.map__O__F1__O(this$30.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
          }
          throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(oc);
        }
        if ((x$1$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
          var oc$2 = x$1$2.s_util_Left__f_value;
          var F$2 = this.Lfs2_internal_InterruptContext__f_F;
          var target$3 = $f_Lcats_effect_kernel_Outcome__embed__O__Lcats_effect_kernel_MonadCancel__O(oc$2, $f_Lcats_effect_kernel_Async__never__O(F$2), F$2);
          var tc$4 = this.Lfs2_internal_InterruptContext__f_F;
          var this$33 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target$3, tc$4);
          var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$5) => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(_$5)));
          return this$33.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.map__O__F1__O(this$33.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$1);
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1$2);
      }));
      return this$34.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$34.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  }));
  return this$35.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$35.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
});
function $isArrayOf_Lfs2_internal_InterruptContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_internal_InterruptContext)));
}
export { $isArrayOf_Lfs2_internal_InterruptContext as $isArrayOf_Lfs2_internal_InterruptContext };
var $d_Lfs2_internal_InterruptContext = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_internal_InterruptContext, "fs2.internal.InterruptContext", ({
  Lfs2_internal_InterruptContext: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lfs2_internal_InterruptContext as $d_Lfs2_internal_InterruptContext };
/** @constructor */
function $c_Lfs2_internal_ScopedResource$State(open, finalizer, leases) {
  this.Lfs2_internal_ScopedResource$State__f_open = false;
  this.Lfs2_internal_ScopedResource$State__f_finalizer = null;
  this.Lfs2_internal_ScopedResource$State__f_leases = 0;
  this.Lfs2_internal_ScopedResource$State__f_open = open;
  this.Lfs2_internal_ScopedResource$State__f_finalizer = finalizer;
  this.Lfs2_internal_ScopedResource$State__f_leases = leases;
}
export { $c_Lfs2_internal_ScopedResource$State as $c_Lfs2_internal_ScopedResource$State };
$c_Lfs2_internal_ScopedResource$State.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_internal_ScopedResource$State.prototype.constructor = $c_Lfs2_internal_ScopedResource$State;
/** @constructor */
function $h_Lfs2_internal_ScopedResource$State() {
}
export { $h_Lfs2_internal_ScopedResource$State as $h_Lfs2_internal_ScopedResource$State };
$h_Lfs2_internal_ScopedResource$State.prototype = $c_Lfs2_internal_ScopedResource$State.prototype;
$c_Lfs2_internal_ScopedResource$State.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lfs2_internal_ScopedResource$State.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, 80204913);
  var hash$1 = acc;
  var data = (this.Lfs2_internal_ScopedResource$State__f_open ? 1231 : 1237);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data);
  var hash$2 = acc;
  var x = this.Lfs2_internal_ScopedResource$State__f_finalizer;
  var data$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$2, data$1);
  var hash$3 = acc;
  var data$2 = this.Lfs2_internal_ScopedResource$State__f_leases;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$3, data$2);
  var hash$4 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3);
});
$c_Lfs2_internal_ScopedResource$State.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_internal_ScopedResource$State)) {
    if (((this.Lfs2_internal_ScopedResource$State__f_open === x$0.Lfs2_internal_ScopedResource$State__f_open) && (this.Lfs2_internal_ScopedResource$State__f_leases === x$0.Lfs2_internal_ScopedResource$State__f_leases))) {
      var x = this.Lfs2_internal_ScopedResource$State__f_finalizer;
      var x$2 = x$0.Lfs2_internal_ScopedResource$State__f_finalizer;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lfs2_internal_ScopedResource$State.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_internal_ScopedResource$State.prototype.productArity__I = (function() {
  return 3;
});
$c_Lfs2_internal_ScopedResource$State.prototype.productPrefix__T = (function() {
  return "State";
});
$c_Lfs2_internal_ScopedResource$State.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lfs2_internal_ScopedResource$State__f_open;
      break;
    }
    case 1: {
      return this.Lfs2_internal_ScopedResource$State__f_finalizer;
      break;
    }
    case 2: {
      return this.Lfs2_internal_ScopedResource$State__f_leases;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lfs2_internal_ScopedResource$State.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "open";
      break;
    }
    case 1: {
      return "finalizer";
      break;
    }
    case 2: {
      return "leases";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lfs2_internal_ScopedResource$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_internal_ScopedResource$State)));
}
export { $isArrayOf_Lfs2_internal_ScopedResource$State as $isArrayOf_Lfs2_internal_ScopedResource$State };
var $d_Lfs2_internal_ScopedResource$State = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_internal_ScopedResource$State, "fs2.internal.ScopedResource$State", ({
  Lfs2_internal_ScopedResource$State: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lfs2_internal_ScopedResource$State as $d_Lfs2_internal_ScopedResource$State };
/** @constructor */
function $c_Lio_circe_Decoder$$anon$45(decodeK$1, decodeV$1) {
  this.Lio_circe_MapDecoder__f_decodeK = null;
  this.Lio_circe_MapDecoder__f_decodeV = null;
  this.Lio_circe_MapDecoder__f_alwaysDecodeK = null;
  $ct_Lio_circe_MapDecoder__Lio_circe_KeyDecoder__Lio_circe_Decoder__(this, decodeK$1, decodeV$1);
}
export { $c_Lio_circe_Decoder$$anon$45 as $c_Lio_circe_Decoder$$anon$45 };
$c_Lio_circe_Decoder$$anon$45.prototype = new $h_Lio_circe_MapDecoder();
$c_Lio_circe_Decoder$$anon$45.prototype.constructor = $c_Lio_circe_Decoder$$anon$45;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$45() {
}
export { $h_Lio_circe_Decoder$$anon$45 as $h_Lio_circe_Decoder$$anon$45 };
$h_Lio_circe_Decoder$$anon$45.prototype = $c_Lio_circe_Decoder$$anon$45.prototype;
var $d_Lio_circe_Decoder$$anon$45 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_circe_Decoder$$anon$45, "io.circe.Decoder$$anon$45", ({
  Lio_circe_Decoder$$anon$45: 1,
  Lio_circe_MapDecoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
}));
export { $d_Lio_circe_Decoder$$anon$45 as $d_Lio_circe_Decoder$$anon$45 };
/** @constructor */
function $c_Lio_circe_Decoder$$anon$54(decodeA$9, orderA$1) {
  this.Lio_circe_NonEmptySeqDecoder__f_io$circe$NonEmptySeqDecoder$$decodeA = null;
  this.Lio_circe_NonEmptySeqDecoder__f_decodeCA = null;
  this.Lio_circe_Decoder$$anon$54__f_orderA$3 = null;
  this.Lio_circe_Decoder$$anon$54__f_create = null;
  this.Lio_circe_Decoder$$anon$54__f_orderA$3 = orderA$1;
  $ct_Lio_circe_NonEmptySeqDecoder__Lio_circe_Decoder__(this, decodeA$9);
  this.Lio_circe_Decoder$$anon$54__f_create = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((h, t) => $m_Lcats_data_package$().Lcats_data_package$__f_NonEmptySet.apply__O__sci_SortedSet__Lcats_kernel_Order__O(h, t, orderA$1)));
}
export { $c_Lio_circe_Decoder$$anon$54 as $c_Lio_circe_Decoder$$anon$54 };
$c_Lio_circe_Decoder$$anon$54.prototype = new $h_Lio_circe_NonEmptySeqDecoder();
$c_Lio_circe_Decoder$$anon$54.prototype.constructor = $c_Lio_circe_Decoder$$anon$54;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$54() {
}
export { $h_Lio_circe_Decoder$$anon$54 as $h_Lio_circe_Decoder$$anon$54 };
$h_Lio_circe_Decoder$$anon$54.prototype = $c_Lio_circe_Decoder$$anon$54.prototype;
$c_Lio_circe_Decoder$$anon$54.prototype.createBuilder__scm_Builder = (function() {
  var $x_1 = $m_sci_SortedSet$();
  var ev = this.Lio_circe_Decoder$$anon$54__f_orderA$3;
  return $x_1.newBuilder__O__scm_Builder(ev.toOrdering__s_math_Ordering());
});
var $d_Lio_circe_Decoder$$anon$54 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_circe_Decoder$$anon$54, "io.circe.Decoder$$anon$54", ({
  Lio_circe_Decoder$$anon$54: 1,
  Lio_circe_NonEmptySeqDecoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
}));
export { $d_Lio_circe_Decoder$$anon$54 as $d_Lio_circe_Decoder$$anon$54 };
function $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json($thiz, a) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_Json$().fromValues__sc_Iterable__Lio_circe_Json($thiz.encodeArray__O__sci_Vector(a));
}
export { $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json as $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json };
/** @constructor */
function $c_Lio_circe_NonEmptySeqDecoder$$anon$1(outer) {
  this.Lio_circe_SeqDecoder__f_decodeA = null;
  this.Lio_circe_NonEmptySeqDecoder$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lio_circe_NonEmptySeqDecoder$$anon$1__f_$outer = outer;
  $ct_Lio_circe_SeqDecoder__Lio_circe_Decoder__(this, outer.Lio_circe_NonEmptySeqDecoder__f_io$circe$NonEmptySeqDecoder$$decodeA);
}
export { $c_Lio_circe_NonEmptySeqDecoder$$anon$1 as $c_Lio_circe_NonEmptySeqDecoder$$anon$1 };
$c_Lio_circe_NonEmptySeqDecoder$$anon$1.prototype = new $h_Lio_circe_SeqDecoder();
$c_Lio_circe_NonEmptySeqDecoder$$anon$1.prototype.constructor = $c_Lio_circe_NonEmptySeqDecoder$$anon$1;
/** @constructor */
function $h_Lio_circe_NonEmptySeqDecoder$$anon$1() {
}
export { $h_Lio_circe_NonEmptySeqDecoder$$anon$1 as $h_Lio_circe_NonEmptySeqDecoder$$anon$1 };
$h_Lio_circe_NonEmptySeqDecoder$$anon$1.prototype = $c_Lio_circe_NonEmptySeqDecoder$$anon$1.prototype;
$c_Lio_circe_NonEmptySeqDecoder$$anon$1.prototype.createBuilder__scm_Builder = (function() {
  return this.Lio_circe_NonEmptySeqDecoder$$anon$1__f_$outer.createBuilder__scm_Builder();
});
var $d_Lio_circe_NonEmptySeqDecoder$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_circe_NonEmptySeqDecoder$$anon$1, "io.circe.NonEmptySeqDecoder$$anon$1", ({
  Lio_circe_NonEmptySeqDecoder$$anon$1: 1,
  Lio_circe_SeqDecoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
}));
export { $d_Lio_circe_NonEmptySeqDecoder$$anon$1 as $d_Lio_circe_NonEmptySeqDecoder$$anon$1 };
/** @constructor */
function $c_Lio_circe_derivation_Configuration(transformMemberNames, transformConstructorNames, useDefaults, discriminator, strictDecoding) {
  this.Lio_circe_derivation_Configuration__f_transformMemberNames = null;
  this.Lio_circe_derivation_Configuration__f_transformConstructorNames = null;
  this.Lio_circe_derivation_Configuration__f_useDefaults = false;
  this.Lio_circe_derivation_Configuration__f_discriminator = null;
  this.Lio_circe_derivation_Configuration__f_strictDecoding = false;
  this.Lio_circe_derivation_Configuration__f_transformMemberNames = transformMemberNames;
  this.Lio_circe_derivation_Configuration__f_transformConstructorNames = transformConstructorNames;
  this.Lio_circe_derivation_Configuration__f_useDefaults = useDefaults;
  this.Lio_circe_derivation_Configuration__f_discriminator = discriminator;
  this.Lio_circe_derivation_Configuration__f_strictDecoding = strictDecoding;
}
export { $c_Lio_circe_derivation_Configuration as $c_Lio_circe_derivation_Configuration };
$c_Lio_circe_derivation_Configuration.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_circe_derivation_Configuration.prototype.constructor = $c_Lio_circe_derivation_Configuration;
/** @constructor */
function $h_Lio_circe_derivation_Configuration() {
}
export { $h_Lio_circe_derivation_Configuration as $h_Lio_circe_derivation_Configuration };
$h_Lio_circe_derivation_Configuration.prototype = $c_Lio_circe_derivation_Configuration.prototype;
$c_Lio_circe_derivation_Configuration.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lio_circe_derivation_Configuration.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I("Configuration");
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lio_circe_derivation_Configuration__f_transformMemberNames;
  var data$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lio_circe_derivation_Configuration__f_transformConstructorNames;
  var data$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$1);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = (this.Lio_circe_derivation_Configuration__f_useDefaults ? 1231 : 1237);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$2 = this.Lio_circe_derivation_Configuration__f_discriminator;
  var data$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$2);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var data$5 = (this.Lio_circe_derivation_Configuration__f_strictDecoding ? 1231 : 1237);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$6, 5);
});
$c_Lio_circe_derivation_Configuration.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_circe_derivation_Configuration)) {
    if (((this.Lio_circe_derivation_Configuration__f_useDefaults === x$0.Lio_circe_derivation_Configuration__f_useDefaults) && (this.Lio_circe_derivation_Configuration__f_strictDecoding === x$0.Lio_circe_derivation_Configuration__f_strictDecoding))) {
      var x = this.Lio_circe_derivation_Configuration__f_transformMemberNames;
      var x$2 = x$0.Lio_circe_derivation_Configuration__f_transformMemberNames;
      var $x_2 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Lio_circe_derivation_Configuration__f_transformConstructorNames;
      var x$4 = x$0.Lio_circe_derivation_Configuration__f_transformConstructorNames;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Lio_circe_derivation_Configuration__f_discriminator;
      var x$6 = x$0.Lio_circe_derivation_Configuration__f_discriminator;
      return ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lio_circe_derivation_Configuration.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lio_circe_derivation_Configuration.prototype.productArity__I = (function() {
  return 5;
});
$c_Lio_circe_derivation_Configuration.prototype.productPrefix__T = (function() {
  return "Configuration";
});
$c_Lio_circe_derivation_Configuration.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lio_circe_derivation_Configuration__f_transformMemberNames;
      break;
    }
    case 1: {
      return this.Lio_circe_derivation_Configuration__f_transformConstructorNames;
      break;
    }
    case 2: {
      return this.Lio_circe_derivation_Configuration__f_useDefaults;
      break;
    }
    case 3: {
      return this.Lio_circe_derivation_Configuration__f_discriminator;
      break;
    }
    case 4: {
      return this.Lio_circe_derivation_Configuration__f_strictDecoding;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lio_circe_derivation_Configuration.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "transformMemberNames";
      break;
    }
    case 1: {
      return "transformConstructorNames";
      break;
    }
    case 2: {
      return "useDefaults";
      break;
    }
    case 3: {
      return "discriminator";
      break;
    }
    case 4: {
      return "strictDecoding";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_circe_derivation_Configuration(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_derivation_Configuration)));
}
export { $isArrayOf_Lio_circe_derivation_Configuration as $isArrayOf_Lio_circe_derivation_Configuration };
var $d_Lio_circe_derivation_Configuration = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_circe_derivation_Configuration, "io.circe.derivation.Configuration", ({
  Lio_circe_derivation_Configuration: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_circe_derivation_Configuration as $d_Lio_circe_derivation_Configuration };
/** @constructor */
function $c_Lio_scalaland_chimney_partial_Error(message, path) {
  this.Lio_scalaland_chimney_partial_Error__f_message = null;
  this.Lio_scalaland_chimney_partial_Error__f_path = null;
  this.Lio_scalaland_chimney_partial_Error__f_message = message;
  this.Lio_scalaland_chimney_partial_Error__f_path = path;
}
export { $c_Lio_scalaland_chimney_partial_Error as $c_Lio_scalaland_chimney_partial_Error };
$c_Lio_scalaland_chimney_partial_Error.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_scalaland_chimney_partial_Error.prototype.constructor = $c_Lio_scalaland_chimney_partial_Error;
/** @constructor */
function $h_Lio_scalaland_chimney_partial_Error() {
}
export { $h_Lio_scalaland_chimney_partial_Error as $h_Lio_scalaland_chimney_partial_Error };
$h_Lio_scalaland_chimney_partial_Error.prototype = $c_Lio_scalaland_chimney_partial_Error.prototype;
$c_Lio_scalaland_chimney_partial_Error.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lio_scalaland_chimney_partial_Error.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lio_scalaland_chimney_partial_Error.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_scalaland_chimney_partial_Error)) {
    var x = this.Lio_scalaland_chimney_partial_Error__f_message;
    var x$2 = x$0.Lio_scalaland_chimney_partial_Error__f_message;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lio_scalaland_chimney_partial_Error__f_path;
      var x$4 = x$0.Lio_scalaland_chimney_partial_Error__f_path;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lio_scalaland_chimney_partial_Error.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lio_scalaland_chimney_partial_Error.prototype.productArity__I = (function() {
  return 2;
});
$c_Lio_scalaland_chimney_partial_Error.prototype.productPrefix__T = (function() {
  return "Error";
});
$c_Lio_scalaland_chimney_partial_Error.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_scalaland_chimney_partial_Error__f_message;
  }
  if ((n === 1)) {
    return new $c_Lio_scalaland_chimney_partial_Path(this.Lio_scalaland_chimney_partial_Error__f_path);
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_scalaland_chimney_partial_Error.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "message";
  }
  if ((n === 1)) {
    return "path";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_scalaland_chimney_partial_Error.prototype.asErrorPathMessage__T2 = (function() {
  var _1 = $m_Lio_scalaland_chimney_partial_Path$().asString$extension__sci_List__T(this.Lio_scalaland_chimney_partial_Error__f_path);
  var _2 = this.Lio_scalaland_chimney_partial_Error__f_message;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, _2);
});
$c_Lio_scalaland_chimney_partial_Error.prototype.prependErrorPath__Lio_scalaland_chimney_partial_PathElement__Lio_scalaland_chimney_partial_Error = (function(pathElement) {
  var message = this.Lio_scalaland_chimney_partial_Error__f_message;
  var path = $m_Lio_scalaland_chimney_partial_Path$().prepend$extension__sci_List__Lio_scalaland_chimney_partial_PathElement__sci_List(this.Lio_scalaland_chimney_partial_Error__f_path, pathElement);
  return new $c_Lio_scalaland_chimney_partial_Error(message, path);
});
$c_Lio_scalaland_chimney_partial_Error.prototype.unsealErrorPath__Lio_scalaland_chimney_partial_Error = (function() {
  $m_Lio_scalaland_chimney_partial_Path$().unsealPath$extension__sci_List__V(this.Lio_scalaland_chimney_partial_Error__f_path);
  return this;
});
function $isArrayOf_Lio_scalaland_chimney_partial_Error(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_scalaland_chimney_partial_Error)));
}
export { $isArrayOf_Lio_scalaland_chimney_partial_Error as $isArrayOf_Lio_scalaland_chimney_partial_Error };
var $d_Lio_scalaland_chimney_partial_Error = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_scalaland_chimney_partial_Error, "io.scalaland.chimney.partial.Error", ({
  Lio_scalaland_chimney_partial_Error: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_scalaland_chimney_partial_Error as $d_Lio_scalaland_chimney_partial_Error };
/** @constructor */
function $c_Lio_scalaland_chimney_partial_Path(elements) {
  this.Lio_scalaland_chimney_partial_Path__f_elements = null;
  this.Lio_scalaland_chimney_partial_Path__f_elements = elements;
}
export { $c_Lio_scalaland_chimney_partial_Path as $c_Lio_scalaland_chimney_partial_Path };
$c_Lio_scalaland_chimney_partial_Path.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_scalaland_chimney_partial_Path.prototype.constructor = $c_Lio_scalaland_chimney_partial_Path;
/** @constructor */
function $h_Lio_scalaland_chimney_partial_Path() {
}
export { $h_Lio_scalaland_chimney_partial_Path as $h_Lio_scalaland_chimney_partial_Path };
$h_Lio_scalaland_chimney_partial_Path.prototype = $c_Lio_scalaland_chimney_partial_Path.prototype;
$c_Lio_scalaland_chimney_partial_Path.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lio_scalaland_chimney_partial_Path.prototype.hashCode__I = (function() {
  $m_Lio_scalaland_chimney_partial_Path$();
  var this$ = this.Lio_scalaland_chimney_partial_Path__f_elements;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().seqHash__sc_Seq__I(this$);
});
$c_Lio_scalaland_chimney_partial_Path.prototype.equals__O__Z = (function(x$0) {
  return $m_Lio_scalaland_chimney_partial_Path$().equals$extension__sci_List__O__Z(this.Lio_scalaland_chimney_partial_Path__f_elements, x$0);
});
$c_Lio_scalaland_chimney_partial_Path.prototype.toString__T = (function() {
  return $m_Lio_scalaland_chimney_partial_Path$().toString$extension__sci_List__T(this.Lio_scalaland_chimney_partial_Path__f_elements);
});
$c_Lio_scalaland_chimney_partial_Path.prototype.productArity__I = (function() {
  $m_Lio_scalaland_chimney_partial_Path$();
  return 1;
});
$c_Lio_scalaland_chimney_partial_Path.prototype.productPrefix__T = (function() {
  $m_Lio_scalaland_chimney_partial_Path$();
  return "Path";
});
$c_Lio_scalaland_chimney_partial_Path.prototype.productElement__I__O = (function(n) {
  return $m_Lio_scalaland_chimney_partial_Path$().productElement$extension__sci_List__I__O(this.Lio_scalaland_chimney_partial_Path__f_elements, n);
});
$c_Lio_scalaland_chimney_partial_Path.prototype.productElementName__I__T = (function(n) {
  return $m_Lio_scalaland_chimney_partial_Path$().productElementName$extension__sci_List__I__T(this.Lio_scalaland_chimney_partial_Path__f_elements, n);
});
function $isArrayOf_Lio_scalaland_chimney_partial_Path(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_scalaland_chimney_partial_Path)));
}
export { $isArrayOf_Lio_scalaland_chimney_partial_Path as $isArrayOf_Lio_scalaland_chimney_partial_Path };
var $d_Lio_scalaland_chimney_partial_Path = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_scalaland_chimney_partial_Path, "io.scalaland.chimney.partial.Path", ({
  Lio_scalaland_chimney_partial_Path: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_scalaland_chimney_partial_Path as $d_Lio_scalaland_chimney_partial_Path };
function $ct_Ljava_io_ByteArrayInputStream__AB__I__I__($thiz, buf, offset, length) {
  $thiz.Ljava_io_ByteArrayInputStream__f_buf = buf;
  $thiz.Ljava_io_ByteArrayInputStream__f_count = ((offset + length) | 0);
  $thiz.Ljava_io_ByteArrayInputStream__f_pos = offset;
  return $thiz;
}
export { $ct_Ljava_io_ByteArrayInputStream__AB__I__I__ as $ct_Ljava_io_ByteArrayInputStream__AB__I__I__ };
function $ct_Ljava_io_ByteArrayInputStream__AB__($thiz, buf) {
  $ct_Ljava_io_ByteArrayInputStream__AB__I__I__($thiz, buf, 0, buf.u.length);
  return $thiz;
}
export { $ct_Ljava_io_ByteArrayInputStream__AB__ as $ct_Ljava_io_ByteArrayInputStream__AB__ };
/** @constructor */
function $c_Ljava_io_ByteArrayInputStream() {
  this.Ljava_io_ByteArrayInputStream__f_buf = null;
  this.Ljava_io_ByteArrayInputStream__f_count = 0;
  this.Ljava_io_ByteArrayInputStream__f_pos = 0;
}
export { $c_Ljava_io_ByteArrayInputStream as $c_Ljava_io_ByteArrayInputStream };
$c_Ljava_io_ByteArrayInputStream.prototype = new $h_Ljava_io_InputStream();
$c_Ljava_io_ByteArrayInputStream.prototype.constructor = $c_Ljava_io_ByteArrayInputStream;
/** @constructor */
function $h_Ljava_io_ByteArrayInputStream() {
}
export { $h_Ljava_io_ByteArrayInputStream as $h_Ljava_io_ByteArrayInputStream };
$h_Ljava_io_ByteArrayInputStream.prototype = $c_Ljava_io_ByteArrayInputStream.prototype;
$c_Ljava_io_ByteArrayInputStream.prototype.read__AB__I__I__I = (function(b, off, reqLen) {
  if ((((off < 0) || (reqLen < 0)) || (reqLen > ((b.u.length - off) | 0)))) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException());
  }
  if ((this.Ljava_io_ByteArrayInputStream__f_pos === this.Ljava_io_ByteArrayInputStream__f_count)) {
    return (-1);
  } else {
    var b$1 = ((this.Ljava_io_ByteArrayInputStream__f_count - this.Ljava_io_ByteArrayInputStream__f_pos) | 0);
    var len = ((reqLen < b$1) ? reqLen : b$1);
    var x0 = this.Ljava_io_ByteArrayInputStream__f_buf;
    var x1 = this.Ljava_io_ByteArrayInputStream__f_pos;
    x0.copyTo(x1, b, off, len);
    this.Ljava_io_ByteArrayInputStream__f_pos = ((this.Ljava_io_ByteArrayInputStream__f_pos + len) | 0);
    return len;
  }
});
var $d_Ljava_io_ByteArrayInputStream = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Ljava_io_ByteArrayInputStream, "java.io.ByteArrayInputStream", ({
  Ljava_io_ByteArrayInputStream: 1,
  Ljava_io_InputStream: 1,
  Ljava_io_Closeable: 1,
  jl_AutoCloseable: 1
}));
export { $d_Ljava_io_ByteArrayInputStream as $d_Ljava_io_ByteArrayInputStream };
/** @constructor */
function $c_Ljava_io_OutputStream() {
}
export { $c_Ljava_io_OutputStream as $c_Ljava_io_OutputStream };
$c_Ljava_io_OutputStream.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Ljava_io_OutputStream.prototype.constructor = $c_Ljava_io_OutputStream;
/** @constructor */
function $h_Ljava_io_OutputStream() {
}
export { $h_Ljava_io_OutputStream as $h_Ljava_io_OutputStream };
$h_Ljava_io_OutputStream.prototype = $c_Ljava_io_OutputStream.prototype;
$c_Ljava_io_OutputStream.prototype.write__AB__I__I__V = (function(b, off, len) {
  if ((((off < 0) || (len < 0)) || (len > ((b.u.length - off) | 0)))) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException());
  }
  var n = off;
  var stop = ((off + len) | 0);
  while ((n < stop)) {
    this.write__I__V(b.u[n]);
    n = ((1 + n) | 0);
  }
});
function $ct_Ljava_net_URISyntaxException__T__T__I__($thiz, input, reason, index) {
  var s = ((((reason + " in ") + input) + " at ") + index);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
export { $ct_Ljava_net_URISyntaxException__T__T__I__ as $ct_Ljava_net_URISyntaxException__T__T__I__ };
function $ct_Ljava_net_URISyntaxException__T__T__($thiz, input, reason) {
  $ct_Ljava_net_URISyntaxException__T__T__I__($thiz, input, reason, (-1));
  return $thiz;
}
export { $ct_Ljava_net_URISyntaxException__T__T__ as $ct_Ljava_net_URISyntaxException__T__T__ };
class $c_Ljava_net_URISyntaxException extends $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Exception {
}
export { $c_Ljava_net_URISyntaxException as $c_Ljava_net_URISyntaxException };
function $isArrayOf_Ljava_net_URISyntaxException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_net_URISyntaxException)));
}
export { $isArrayOf_Ljava_net_URISyntaxException as $isArrayOf_Ljava_net_URISyntaxException };
var $d_Ljava_net_URISyntaxException = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Ljava_net_URISyntaxException, "java.net.URISyntaxException", ({
  Ljava_net_URISyntaxException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_net_URISyntaxException as $d_Ljava_net_URISyntaxException };
class $c_ju_concurrent_ExecutionException extends $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Exception {
  constructor(message, cause) {
    super();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, cause, true, true);
  }
}
export { $c_ju_concurrent_ExecutionException as $c_ju_concurrent_ExecutionException };
var $d_ju_concurrent_ExecutionException = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_ju_concurrent_ExecutionException, "java.util.concurrent.ExecutionException", ({
  ju_concurrent_ExecutionException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_concurrent_ExecutionException as $d_ju_concurrent_ExecutionException };
function $isArrayOf_ju_concurrent_TimeoutException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_concurrent_TimeoutException)));
}
export { $isArrayOf_ju_concurrent_TimeoutException as $isArrayOf_ju_concurrent_TimeoutException };
/** @constructor */
function $c_Lmagnolia1_SealedTrait(typeInfo, subtypes, annotations, typeAnnotations, isEnum, inheritedAnnotations) {
  this.Lmagnolia1_SealedTrait__f_typeInfo = null;
  this.Lmagnolia1_SealedTrait__f_subtypes = null;
  this.Lmagnolia1_SealedTrait__f_annotations = null;
  this.Lmagnolia1_SealedTrait__f_typeAnnotations = null;
  this.Lmagnolia1_SealedTrait__f_isEnum = false;
  this.Lmagnolia1_SealedTrait__f_inheritedAnnotations = null;
  this.Lmagnolia1_SealedTrait__f_typeInfo = typeInfo;
  this.Lmagnolia1_SealedTrait__f_subtypes = subtypes;
  this.Lmagnolia1_SealedTrait__f_annotations = annotations;
  this.Lmagnolia1_SealedTrait__f_typeAnnotations = typeAnnotations;
  this.Lmagnolia1_SealedTrait__f_isEnum = isEnum;
  this.Lmagnolia1_SealedTrait__f_inheritedAnnotations = inheritedAnnotations;
}
export { $c_Lmagnolia1_SealedTrait as $c_Lmagnolia1_SealedTrait };
$c_Lmagnolia1_SealedTrait.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lmagnolia1_SealedTrait.prototype.constructor = $c_Lmagnolia1_SealedTrait;
/** @constructor */
function $h_Lmagnolia1_SealedTrait() {
}
export { $h_Lmagnolia1_SealedTrait as $h_Lmagnolia1_SealedTrait };
$h_Lmagnolia1_SealedTrait.prototype = $c_Lmagnolia1_SealedTrait.prototype;
$c_Lmagnolia1_SealedTrait.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lmagnolia1_SealedTrait.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I("SealedTrait");
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lmagnolia1_SealedTrait__f_typeInfo;
  var data$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lmagnolia1_SealedTrait__f_subtypes;
  var data$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$1);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$2 = this.Lmagnolia1_SealedTrait__f_annotations;
  var data$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$2);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$3 = this.Lmagnolia1_SealedTrait__f_typeAnnotations;
  var data$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$3);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var data$5 = (this.Lmagnolia1_SealedTrait__f_isEnum ? 1231 : 1237);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var x$4 = this.Lmagnolia1_SealedTrait__f_inheritedAnnotations;
  var data$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$4);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$7, 6);
});
$c_Lmagnolia1_SealedTrait.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmagnolia1_SealedTrait)) {
    if ((this.Lmagnolia1_SealedTrait__f_isEnum === x$0.Lmagnolia1_SealedTrait__f_isEnum)) {
      var x = this.Lmagnolia1_SealedTrait__f_typeInfo;
      var x$2 = x$0.Lmagnolia1_SealedTrait__f_typeInfo;
      var $x_4 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$3 = this.Lmagnolia1_SealedTrait__f_subtypes;
      var x$4 = x$0.Lmagnolia1_SealedTrait__f_subtypes;
      var $x_3 = (x$3 === x$4);
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$1 = this.Lmagnolia1_SealedTrait__f_annotations;
      var y = x$0.Lmagnolia1_SealedTrait__f_annotations;
      var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Lmagnolia1_SealedTrait__f_typeAnnotations;
      var y$1 = x$0.Lmagnolia1_SealedTrait__f_typeAnnotations;
      var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x$5, y$1);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$6 = this.Lmagnolia1_SealedTrait__f_inheritedAnnotations;
      var y$2 = x$0.Lmagnolia1_SealedTrait__f_inheritedAnnotations;
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x$6, y$2);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lmagnolia1_SealedTrait.prototype.productArity__I = (function() {
  return 6;
});
$c_Lmagnolia1_SealedTrait.prototype.productPrefix__T = (function() {
  return "SealedTrait";
});
$c_Lmagnolia1_SealedTrait.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lmagnolia1_SealedTrait__f_typeInfo;
      break;
    }
    case 1: {
      return this.Lmagnolia1_SealedTrait__f_subtypes;
      break;
    }
    case 2: {
      return this.Lmagnolia1_SealedTrait__f_annotations;
      break;
    }
    case 3: {
      return this.Lmagnolia1_SealedTrait__f_typeAnnotations;
      break;
    }
    case 4: {
      return this.Lmagnolia1_SealedTrait__f_isEnum;
      break;
    }
    case 5: {
      return this.Lmagnolia1_SealedTrait__f_inheritedAnnotations;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lmagnolia1_SealedTrait.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "typeInfo";
      break;
    }
    case 1: {
      return "subtypes";
      break;
    }
    case 2: {
      return "annotations";
      break;
    }
    case 3: {
      return "typeAnnotations";
      break;
    }
    case 4: {
      return "isEnum";
      break;
    }
    case 5: {
      return "inheritedAnnotations";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lmagnolia1_SealedTrait.prototype.toString__T = (function() {
  var $x_1 = this.Lmagnolia1_SealedTrait__f_typeInfo;
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().wrapRefArray__AO__sci_ArraySeq$ofRef(this.Lmagnolia1_SealedTrait__f_subtypes);
  return (((("SealedTrait(" + $x_1) + ", IArray[") + $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__mkString__T__T__T__T(this$1, "", ",", "")) + "])");
});
function $isArrayOf_Lmagnolia1_SealedTrait(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lmagnolia1_SealedTrait)));
}
export { $isArrayOf_Lmagnolia1_SealedTrait as $isArrayOf_Lmagnolia1_SealedTrait };
var $d_Lmagnolia1_SealedTrait = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lmagnolia1_SealedTrait, "magnolia1.SealedTrait", ({
  Lmagnolia1_SealedTrait: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lmagnolia1_SealedTrait as $d_Lmagnolia1_SealedTrait };
/** @constructor */
function $c_Lmagnolia1_SealedTrait$Subtype(typeInfo, annotations, inheritedAnnotations, typeAnnotations, isObject, index, callByNeed, isType, asType) {
  this.Lmagnolia1_SealedTrait$Subtype__f_typeInfo = null;
  this.Lmagnolia1_SealedTrait$Subtype__f_annotations = null;
  this.Lmagnolia1_SealedTrait$Subtype__f_callByNeed = null;
  this.Lmagnolia1_SealedTrait$Subtype__f_isType = null;
  this.Lmagnolia1_SealedTrait$Subtype__f_asType = null;
  this.Lmagnolia1_SealedTrait$Subtype__f_typeInfo = typeInfo;
  this.Lmagnolia1_SealedTrait$Subtype__f_annotations = annotations;
  this.Lmagnolia1_SealedTrait$Subtype__f_callByNeed = callByNeed;
  this.Lmagnolia1_SealedTrait$Subtype__f_isType = isType;
  this.Lmagnolia1_SealedTrait$Subtype__f_asType = asType;
}
export { $c_Lmagnolia1_SealedTrait$Subtype as $c_Lmagnolia1_SealedTrait$Subtype };
$c_Lmagnolia1_SealedTrait$Subtype.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lmagnolia1_SealedTrait$Subtype.prototype.constructor = $c_Lmagnolia1_SealedTrait$Subtype;
/** @constructor */
function $h_Lmagnolia1_SealedTrait$Subtype() {
}
export { $h_Lmagnolia1_SealedTrait$Subtype as $h_Lmagnolia1_SealedTrait$Subtype };
$h_Lmagnolia1_SealedTrait$Subtype.prototype = $c_Lmagnolia1_SealedTrait$Subtype.prototype;
$c_Lmagnolia1_SealedTrait$Subtype.prototype.compose__F1__F1 = (function(g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_F1__compose__F1__F1(this, g);
});
$c_Lmagnolia1_SealedTrait$Subtype.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k);
});
$c_Lmagnolia1_SealedTrait$Subtype.prototype.lift__F1 = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_PartialFunction$Lifted(this);
});
$c_Lmagnolia1_SealedTrait$Subtype.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1);
});
$c_Lmagnolia1_SealedTrait$Subtype.prototype.runWith__F1__F1 = (function(action) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_PartialFunction__runWith__F1__F1(this, action);
});
$c_Lmagnolia1_SealedTrait$Subtype.prototype.typeclass__O = (function() {
  return this.Lmagnolia1_SealedTrait$Subtype__f_callByNeed.value__O();
});
$c_Lmagnolia1_SealedTrait$Subtype.prototype.isDefinedAt__O__Z = (function(t) {
  return (!(!this.Lmagnolia1_SealedTrait$Subtype__f_isType.apply__O__O(t)));
});
$c_Lmagnolia1_SealedTrait$Subtype.prototype.apply__O__O = (function(t) {
  return this.Lmagnolia1_SealedTrait$Subtype__f_asType.apply__O__O(t);
});
$c_Lmagnolia1_SealedTrait$Subtype.prototype.toString__T = (function() {
  return (("Subtype(" + this.Lmagnolia1_SealedTrait$Subtype__f_typeInfo.full__T()) + ")");
});
$c_Lmagnolia1_SealedTrait$Subtype.prototype.andThen__F1__F1 = (function(g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g);
});
$c_Lmagnolia1_SealedTrait$Subtype.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return (!(!this.apply__O__O(v1)));
});
var $d_Lmagnolia1_SealedTrait$Subtype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lmagnolia1_SealedTrait$Subtype, "magnolia1.SealedTrait$Subtype", ({
  Lmagnolia1_SealedTrait$Subtype: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lmagnolia1_SealedTrait$Subtype as $d_Lmagnolia1_SealedTrait$Subtype };
function $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__canUsePostMessage$1__Z($thiz) {
  if ((((typeof postMessage) !== "undefined") && ((typeof importScripts) === "undefined"))) {
    var postMessageIsAsynchronous = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_BooleanRef(true);
    var oldOnMessage = onmessage;
    try {
      onmessage = $m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
        var ev$4 = false;
        postMessageIsAsynchronous.sr_BooleanRef__f_elem = ev$4;
      })));
      postMessage("", "*");
      onmessage = oldOnMessage;
      return postMessageIsAsynchronous.sr_BooleanRef__f_elem;
    } catch (e) {
      var e$1 = e;
      var e$2 = ((e$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e$1 : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e$1));
      var x2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
      if ((!x2.isEmpty__Z())) {
        x2.get__O();
        return false;
      }
      throw e$2;
    }
  } else {
    return false;
  }
}
export { $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__canUsePostMessage$1__Z as $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__canUsePostMessage$1__Z };
function $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__runIfPresent$1__scm_Map__sr_BooleanRef__I__V($thiz, tasksByHandle$1, currentlyRunningATask$1, handle) {
  if (currentlyRunningATask$1.sr_BooleanRef__f_elem) {
    setTimeout($m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
      $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__runIfPresent$1__scm_Map__sr_BooleanRef__I__V($thiz, tasksByHandle$1, currentlyRunningATask$1, handle);
    }))), 0);
  } else {
    matchResult2: {
      var x5 = tasksByHandle$1.get__O__s_Option(handle);
      if ((x5 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
        var task = x5.s_Some__f_value;
        var ev$5 = true;
        currentlyRunningATask$1.sr_BooleanRef__f_elem = ev$5;
        try {
          task.apply__O();
          break matchResult2;
        } finally {
          tasksByHandle$1.subtractOne__O__scm_Shrinkable(handle);
          var ev$6 = false;
          currentlyRunningATask$1.sr_BooleanRef__f_elem = ev$6;
        }
      }
      var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      if ((x === x5)) {
        break matchResult2;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x5);
    }
  }
}
export { $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__runIfPresent$1__scm_Map__sr_BooleanRef__I__V as $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__runIfPresent$1__scm_Map__sr_BooleanRef__I__V };
function $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__onGlobalMessage$1__scm_Map__sr_BooleanRef__T__sjs_js_Dynamic__V($thiz, tasksByHandle$3, currentlyRunningATask$3, messagePrefix$1, event) {
  if ((((typeof event.data) === "string") && ((event.data.indexOf(messagePrefix$1) | 0) === 0))) {
    var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$dp_toString__T(event.data);
    var beginIndex = messagePrefix$1.length;
    var x = this$2.substring(beginIndex);
    var this$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Integer$();
    $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__runIfPresent$1__scm_Map__sr_BooleanRef__I__V($thiz, tasksByHandle$3, currentlyRunningATask$3, this$5.java$lang$Integer$$parseIntImpl__T__I__I__I(x, 10, 214748364));
  }
}
export { $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__onGlobalMessage$1__scm_Map__sr_BooleanRef__T__sjs_js_Dynamic__V as $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__onGlobalMessage$1__scm_Map__sr_BooleanRef__T__sjs_js_Dynamic__V };
/** @constructor */
function $c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$() {
  this.Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__f_setImmediate = null;
  $n_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$ = this;
  if (((typeof setImmediate) === "undefined")) {
    var nextHandle = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_IntRef(1);
    var tasksByHandle = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_scm_Map$().apply__sci_Seq__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T2.getArrayOf().constr)([])));
    var currentlyRunningATask = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_BooleanRef(false);
    if (((typeof navigator) !== "undefined")) {
      var x = navigator.userAgent;
      var $x_5 = ((x !== (void 0)) && ((x.indexOf("jsdom") | 0) !== (-1)));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var setImmediate$1 = Node.constructor("return setImmediate")();
      var $x_4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((k) => {
        setImmediate$1($m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(k));
      }));
    } else if ($p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__canUsePostMessage$1__Z(this)) {
      var this$9 = $m_s_util_Random$();
      var this$10 = this$9.s_util_Random__f_self;
      var messagePrefix = (("setImmediate$" + this$10.next__I__I(32)) + "$");
      if (((typeof addEventListener) !== "undefined")) {
        addEventListener("message", $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((event) => {
          $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__onGlobalMessage$1__scm_Map__sr_BooleanRef__T__sjs_js_Dynamic__V(this, tasksByHandle, currentlyRunningATask, messagePrefix, event);
        }))), false);
      } else {
        attachEvent("onmessage", $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((event$2) => {
          $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__onGlobalMessage$1__scm_Map__sr_BooleanRef__T__sjs_js_Dynamic__V(this, tasksByHandle, currentlyRunningATask, messagePrefix, event$2);
        }))));
      }
      var $x_4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((k$2) => {
        var handle = nextHandle.sr_IntRef__f_elem;
        var ev$7 = ((1 + nextHandle.sr_IntRef__f_elem) | 0);
        nextHandle.sr_IntRef__f_elem = ev$7;
        var elem = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), handle, k$2);
        tasksByHandle.addOne__O__scm_Growable(elem);
        var $x_6 = postMessage;
        var s = (messagePrefix + handle);
        $x_6(s, "*");
      }));
    } else if (((typeof MessageChannel) !== "undefined")) {
      var channel = new MessageChannel();
      channel.port1.onmessage = $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((event$3) => {
        $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__runIfPresent$1__scm_Map__sr_BooleanRef__I__V(this, tasksByHandle, currentlyRunningATask, (event$3.data | 0));
      })));
      var $x_4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((k$3) => {
        var handle$1 = nextHandle.sr_IntRef__f_elem;
        var ev$8 = ((1 + nextHandle.sr_IntRef__f_elem) | 0);
        nextHandle.sr_IntRef__f_elem = ev$8;
        var elem$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), handle$1, k$3);
        tasksByHandle.addOne__O__scm_Growable(elem$1);
        channel.port2.postMessage(handle$1);
      }));
    } else {
      var $x_4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((k$4) => {
        setTimeout($m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(k$4), 0);
      }));
    }
  } else {
    var $x_4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((k$5) => {
      setImmediate($m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(k$5));
    }));
  }
  this.Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__f_setImmediate = $x_4;
}
export { $c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$ as $c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$ };
$c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$.prototype.constructor = $c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$;
/** @constructor */
function $h_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$() {
}
export { $h_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$ as $h_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$ };
$h_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$.prototype = $c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$.prototype;
$c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$.prototype.execute__jl_Runnable__V = (function(runnable) {
  this.Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__f_setImmediate.apply__O__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    runnable.run__V();
  })));
});
$c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$.prototype.reportFailure__jl_Throwable__V = (function(cause) {
  cause.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err);
});
var $d_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$, "org.scalajs.macrotaskexecutor.MacrotaskExecutor$", ({
  Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$: 1,
  s_concurrent_ExecutionContext: 1,
  ju_concurrent_Executor: 1,
  s_concurrent_ExecutionContextExecutor: 1
}));
export { $d_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$ as $d_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$ };
var $n_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$;
function $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$() {
  if ((!$n_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$)) {
    $n_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$ = new $c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$();
  }
  return $n_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$;
}
export { $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$ as $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$ };
/** @constructor */
function $c_Lpprint_Tree$Ctx(width, leftOffset, indentCount, indentStep, literalColor, applyPrefixColor) {
  this.Lpprint_Tree$Ctx__f_width = 0;
  this.Lpprint_Tree$Ctx__f_leftOffset = 0;
  this.Lpprint_Tree$Ctx__f_indentCount = 0;
  this.Lpprint_Tree$Ctx__f_indentStep = 0;
  this.Lpprint_Tree$Ctx__f_literalColor = null;
  this.Lpprint_Tree$Ctx__f_applyPrefixColor = null;
  this.Lpprint_Tree$Ctx__f_width = width;
  this.Lpprint_Tree$Ctx__f_leftOffset = leftOffset;
  this.Lpprint_Tree$Ctx__f_indentCount = indentCount;
  this.Lpprint_Tree$Ctx__f_indentStep = indentStep;
  this.Lpprint_Tree$Ctx__f_literalColor = literalColor;
  this.Lpprint_Tree$Ctx__f_applyPrefixColor = applyPrefixColor;
}
export { $c_Lpprint_Tree$Ctx as $c_Lpprint_Tree$Ctx };
$c_Lpprint_Tree$Ctx.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lpprint_Tree$Ctx.prototype.constructor = $c_Lpprint_Tree$Ctx;
/** @constructor */
function $h_Lpprint_Tree$Ctx() {
}
export { $h_Lpprint_Tree$Ctx as $h_Lpprint_Tree$Ctx };
$h_Lpprint_Tree$Ctx.prototype = $c_Lpprint_Tree$Ctx.prototype;
$c_Lpprint_Tree$Ctx.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lpprint_Tree$Ctx.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I("Ctx");
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lpprint_Tree$Ctx__f_width;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Lpprint_Tree$Ctx__f_leftOffset;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = this.Lpprint_Tree$Ctx__f_indentCount;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var data$4 = this.Lpprint_Tree$Ctx__f_indentStep;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x = this.Lpprint_Tree$Ctx__f_literalColor;
  var data$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var x$1 = this.Lpprint_Tree$Ctx__f_applyPrefixColor;
  var data$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$1);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$7, 6);
});
$c_Lpprint_Tree$Ctx.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpprint_Tree$Ctx)) {
    if (((((this.Lpprint_Tree$Ctx__f_width === x$0.Lpprint_Tree$Ctx__f_width) && (this.Lpprint_Tree$Ctx__f_leftOffset === x$0.Lpprint_Tree$Ctx__f_leftOffset)) && (this.Lpprint_Tree$Ctx__f_indentCount === x$0.Lpprint_Tree$Ctx__f_indentCount)) && (this.Lpprint_Tree$Ctx__f_indentStep === x$0.Lpprint_Tree$Ctx__f_indentStep))) {
      var x = this.Lpprint_Tree$Ctx__f_literalColor;
      var x$2 = x$0.Lpprint_Tree$Ctx__f_literalColor;
      var $x_1 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.Lpprint_Tree$Ctx__f_applyPrefixColor;
      var x$4 = x$0.Lpprint_Tree$Ctx__f_applyPrefixColor;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lpprint_Tree$Ctx.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lpprint_Tree$Ctx.prototype.productArity__I = (function() {
  return 6;
});
$c_Lpprint_Tree$Ctx.prototype.productPrefix__T = (function() {
  return "Ctx";
});
$c_Lpprint_Tree$Ctx.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lpprint_Tree$Ctx__f_width;
      break;
    }
    case 1: {
      return this.Lpprint_Tree$Ctx__f_leftOffset;
      break;
    }
    case 2: {
      return this.Lpprint_Tree$Ctx__f_indentCount;
      break;
    }
    case 3: {
      return this.Lpprint_Tree$Ctx__f_indentStep;
      break;
    }
    case 4: {
      return this.Lpprint_Tree$Ctx__f_literalColor;
      break;
    }
    case 5: {
      return this.Lpprint_Tree$Ctx__f_applyPrefixColor;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lpprint_Tree$Ctx.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "width";
      break;
    }
    case 1: {
      return "leftOffset";
      break;
    }
    case 2: {
      return "indentCount";
      break;
    }
    case 3: {
      return "indentStep";
      break;
    }
    case 4: {
      return "literalColor";
      break;
    }
    case 5: {
      return "applyPrefixColor";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpprint_Tree$Ctx(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lpprint_Tree$Ctx)));
}
export { $isArrayOf_Lpprint_Tree$Ctx as $isArrayOf_Lpprint_Tree$Ctx };
var $d_Lpprint_Tree$Ctx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lpprint_Tree$Ctx, "pprint.Tree$Ctx", ({
  Lpprint_Tree$Ctx: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lpprint_Tree$Ctx as $d_Lpprint_Tree$Ctx };
function $p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$($thiz) {
  if ((!$thiz.Lpprint_Truncated__f_Internalbitmap$1)) {
    $thiz.Lpprint_Truncated__f_Internal$lzy1 = new $c_Lpprint_Truncated$Internal$($thiz);
    $thiz.Lpprint_Truncated__f_Internalbitmap$1 = true;
  }
  return $thiz.Lpprint_Truncated__f_Internal$lzy1;
}
export { $p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$ as $p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$ };
/** @constructor */
function $c_Lpprint_Truncated(chunks0, width, height, truncationMarker) {
  this.Lpprint_Truncated__f_pprint$Truncated$$chunks0 = null;
  this.Lpprint_Truncated__f_pprint$Truncated$$width = 0;
  this.Lpprint_Truncated__f_height = 0;
  this.Lpprint_Truncated__f_truncationMarker = null;
  this.Lpprint_Truncated__f_lineLengths = null;
  this.Lpprint_Truncated__f_Internal$lzy1 = null;
  this.Lpprint_Truncated__f_Internalbitmap$1 = false;
  this.Lpprint_Truncated__f_pprint$Truncated$$chunks0 = chunks0;
  this.Lpprint_Truncated__f_pprint$Truncated$$width = width;
  this.Lpprint_Truncated__f_height = height;
  this.Lpprint_Truncated__f_truncationMarker = truncationMarker;
  this.Lpprint_Truncated__f_lineLengths = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_scm_Buffer$().apply__sci_Seq__sc_SeqOps($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapIntArray__AI__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I(new Int32Array([0]))));
}
export { $c_Lpprint_Truncated as $c_Lpprint_Truncated };
$c_Lpprint_Truncated.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lpprint_Truncated.prototype.constructor = $c_Lpprint_Truncated;
/** @constructor */
function $h_Lpprint_Truncated() {
}
export { $h_Lpprint_Truncated as $h_Lpprint_Truncated };
$h_Lpprint_Truncated.prototype = $c_Lpprint_Truncated.prototype;
$c_Lpprint_Truncated.prototype.knownSize__I = (function() {
  return (-1);
});
$c_Lpprint_Truncated.prototype.forall__F1__Z = (function(p) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_Lpprint_Truncated.prototype.find__F1__s_Option = (function(p) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$c_Lpprint_Truncated.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_Lpprint_Truncated.prototype.reduceLeft__F2__O = (function(op) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$c_Lpprint_Truncated.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$c_Lpprint_Truncated.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_Lpprint_Truncated.prototype.toList__sci_List = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_Lpprint_Truncated.prototype.toVector__sci_Vector = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this);
});
$c_Lpprint_Truncated.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_Lpprint_Truncated.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_Lpprint_Truncated.prototype.reversed__sc_Iterable = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__reversed__sc_Iterable(this);
});
$c_Lpprint_Truncated.prototype.iterator__sc_Iterator = (function() {
  return this;
});
$c_Lpprint_Truncated.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$c_Lpprint_Truncated.prototype.take__I__sc_Iterator = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$c_Lpprint_Truncated.prototype.drop__I__sc_Iterator = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1));
});
$c_Lpprint_Truncated.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$c_Lpprint_Truncated.prototype.toString__T = (function() {
  return "<iterator>";
});
$c_Lpprint_Truncated.prototype.completedLineCount__I = (function() {
  if (this.hasNext__Z()) {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Scala3RunTime$().assertFailed__E();
  }
  return (((-1) + this.Lpprint_Truncated__f_lineLengths.length__I()) | 0);
});
$c_Lpprint_Truncated.prototype.lastLineLength__I = (function() {
  if (this.hasNext__Z()) {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Scala3RunTime$().assertFailed__E();
  }
  return (this.Lpprint_Truncated__f_lineLengths.apply__I__O((((-1) + this.Lpprint_Truncated__f_lineLengths.length__I()) | 0)) | 0);
});
$c_Lpprint_Truncated.prototype.toResult__Lpprint_Result = (function() {
  return new $c_Lpprint_Result(this, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => this.completedLineCount__I())), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => this.lastLineLength__I())));
});
$c_Lpprint_Truncated.prototype.hasNext__Z = (function() {
  return (($p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).Lpprint_Truncated$Internal$__f_chunks.hasNext__Z() && ($p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).completedLines__I() < (((-1) + this.Lpprint_Truncated__f_height) | 0))) || (!$p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).Lpprint_Truncated$Internal$__f_lastLineFinished));
});
$c_Lpprint_Truncated.prototype.next__Lfansi_Str = (function() {
  if (($p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).Lpprint_Truncated$Internal$__f_chunks.hasNext__Z() && ($p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).completedLines__I() < (((-1) + this.Lpprint_Truncated__f_height) | 0)))) {
    var chunk = $p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).Lpprint_Truncated$Internal$__f_chunks.next__O();
    var x1 = $p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).consumeChunkUntilLine__Lfansi_Str__I__s_Option(chunk, (((-1) + this.Lpprint_Truncated__f_height) | 0));
    var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    if ((x === x1)) {
      if ((!$p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).Lpprint_Truncated$Internal$__f_chunks.hasNext__Z())) {
        $p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).Lpprint_Truncated$Internal$__f_lastLineFinished = true;
      }
      return chunk;
    }
    if ((x1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var i = (x1.s_Some__f_value | 0);
      var splitPoint = (((this.Lpprint_Truncated__f_lineLengths.last__O() | 0) !== 0) ? (((-1) + i) | 0) : i);
      $p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).Lpprint_Truncated$Internal$__f_lastChunkLeftover = chunk.substring__I__I__Lfansi_Str(splitPoint, chunk.Lfansi_Str__f_chars.u.length);
      return chunk.substring__I__I__Lfansi_Str(0, splitPoint);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1);
  } else if ((!$p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).Lpprint_Truncated$Internal$__f_lastLineFinished)) {
    var buffer = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_scm_Buffer$().empty__sc_SeqOps();
    var charsLeftOver = false;
    matchResult2: {
      var x4 = $p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).consumeChunkUntilLine__Lfansi_Str__I__s_Option($p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).Lpprint_Truncated$Internal$__f_lastChunkLeftover, this.Lpprint_Truncated__f_height);
      var x$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      if ((x$3 === x4)) {
        var elem = $p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).Lpprint_Truncated$Internal$__f_lastChunkLeftover;
        buffer.addOne__O__scm_Growable(elem);
        break matchResult2;
      }
      if ((x4 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
        var i$2 = (x4.s_Some__f_value | 0);
        charsLeftOver = true;
        var elem$1 = $p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).Lpprint_Truncated$Internal$__f_lastChunkLeftover.substring__I__I__Lfansi_Str(0, (((-1) + i$2) | 0));
        buffer.addOne__O__scm_Growable(elem$1);
        break matchResult2;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x4);
    }
    while (($p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).Lpprint_Truncated$Internal$__f_chunks.hasNext__Z() && ($p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).completedLines__I() < this.Lpprint_Truncated__f_height))) {
      var chunk$2 = $p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).Lpprint_Truncated$Internal$__f_chunks.next__O();
      matchResult3: {
        var x7 = $p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).consumeChunkUntilLine__Lfansi_Str__I__s_Option(chunk$2, this.Lpprint_Truncated__f_height);
        var x$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        if ((x$5 === x7)) {
          buffer.addOne__O__scm_Growable(chunk$2);
          break matchResult3;
        }
        if ((x7 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
          var i$3 = (x7.s_Some__f_value | 0);
          charsLeftOver = true;
          var elem$2 = chunk$2.substring__I__I__Lfansi_Str(0, i$3);
          buffer.addOne__O__scm_Growable(elem$2);
          break matchResult3;
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x7);
      }
    }
    $p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).Lpprint_Truncated$Internal$__f_lastLineFinished = true;
    if ((charsLeftOver || $p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).Lpprint_Truncated$Internal$__f_chunks.hasNext__Z())) {
      $p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this);
      return $m_Lfansi_Str$().apply__jl_CharSequence__Lfansi_ErrorMode__Lfansi_Str(this.Lpprint_Truncated__f_truncationMarker, ($m_Lfansi_Str$(), $m_Lfansi_ErrorMode$Sanitize$()));
    } else {
      var this$3 = $m_Lfansi_Str$();
      var this$2 = buffer.map__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => _$2.render__T())));
      var raw = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__mkString__T__T__T__T(this$2, "", "", "");
      return this$3.apply__jl_CharSequence__Lfansi_ErrorMode__Lfansi_Str(raw, $m_Lfansi_ErrorMode$Sanitize$());
    }
  } else {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_ju_NoSuchElementException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_ju_NoSuchElementException(), "next on empty iterator");
  }
});
$c_Lpprint_Truncated.prototype.next__O = (function() {
  return this.next__Lfansi_Str();
});
var $d_Lpprint_Truncated = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lpprint_Truncated, "pprint.Truncated", ({
  Lpprint_Truncated: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_Iterator: 1
}));
export { $d_Lpprint_Truncated as $d_Lpprint_Truncated };
function $p_Lpprint_Util$ConcatIterator__check__Z($thiz) {
  while (true) {
    if ((($thiz.Lpprint_Util$ConcatIterator__f_head !== null) && $thiz.Lpprint_Util$ConcatIterator__f_head.hasNext__Z())) {
      return true;
    } else if ((!$thiz.Lpprint_Util$ConcatIterator__f_it0.hasNext__Z())) {
      return false;
    } else {
      if (((($thiz.Lpprint_Util$ConcatIterator__f_count % 2) | 0) === 0)) {
        $thiz.Lpprint_Util$ConcatIterator__f_head = $thiz.Lpprint_Util$ConcatIterator__f_it0.next__O();
      } else {
        $thiz.Lpprint_Util$ConcatIterator__f_head = $thiz.Lpprint_Util$ConcatIterator__f_joiner.apply__O();
      }
      $thiz.Lpprint_Util$ConcatIterator__f_count = ((1 + $thiz.Lpprint_Util$ConcatIterator__f_count) | 0);
    }
  }
}
export { $p_Lpprint_Util$ConcatIterator__check__Z as $p_Lpprint_Util$ConcatIterator__check__Z };
/** @constructor */
function $c_Lpprint_Util$ConcatIterator(it0, joiner) {
  this.Lpprint_Util$ConcatIterator__f_it0 = null;
  this.Lpprint_Util$ConcatIterator__f_joiner = null;
  this.Lpprint_Util$ConcatIterator__f_head = null;
  this.Lpprint_Util$ConcatIterator__f_count = 0;
  this.Lpprint_Util$ConcatIterator__f_it0 = it0;
  this.Lpprint_Util$ConcatIterator__f_joiner = joiner;
  this.Lpprint_Util$ConcatIterator__f_head = null;
  this.Lpprint_Util$ConcatIterator__f_count = 0;
}
export { $c_Lpprint_Util$ConcatIterator as $c_Lpprint_Util$ConcatIterator };
$c_Lpprint_Util$ConcatIterator.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lpprint_Util$ConcatIterator.prototype.constructor = $c_Lpprint_Util$ConcatIterator;
/** @constructor */
function $h_Lpprint_Util$ConcatIterator() {
}
export { $h_Lpprint_Util$ConcatIterator as $h_Lpprint_Util$ConcatIterator };
$h_Lpprint_Util$ConcatIterator.prototype = $c_Lpprint_Util$ConcatIterator.prototype;
$c_Lpprint_Util$ConcatIterator.prototype.knownSize__I = (function() {
  return (-1);
});
$c_Lpprint_Util$ConcatIterator.prototype.forall__F1__Z = (function(p) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_Lpprint_Util$ConcatIterator.prototype.find__F1__s_Option = (function(p) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$c_Lpprint_Util$ConcatIterator.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_Lpprint_Util$ConcatIterator.prototype.reduceLeft__F2__O = (function(op) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$c_Lpprint_Util$ConcatIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$c_Lpprint_Util$ConcatIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_Lpprint_Util$ConcatIterator.prototype.toList__sci_List = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_Lpprint_Util$ConcatIterator.prototype.toVector__sci_Vector = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this);
});
$c_Lpprint_Util$ConcatIterator.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_Lpprint_Util$ConcatIterator.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_Lpprint_Util$ConcatIterator.prototype.reversed__sc_Iterable = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__reversed__sc_Iterable(this);
});
$c_Lpprint_Util$ConcatIterator.prototype.iterator__sc_Iterator = (function() {
  return this;
});
$c_Lpprint_Util$ConcatIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$c_Lpprint_Util$ConcatIterator.prototype.take__I__sc_Iterator = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$c_Lpprint_Util$ConcatIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1));
});
$c_Lpprint_Util$ConcatIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$c_Lpprint_Util$ConcatIterator.prototype.toString__T = (function() {
  return "<iterator>";
});
$c_Lpprint_Util$ConcatIterator.prototype.hasNext__Z = (function() {
  return $p_Lpprint_Util$ConcatIterator__check__Z(this);
});
$c_Lpprint_Util$ConcatIterator.prototype.next__O = (function() {
  $p_Lpprint_Util$ConcatIterator__check__Z(this);
  return this.Lpprint_Util$ConcatIterator__f_head.next__O();
});
var $d_Lpprint_Util$ConcatIterator = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lpprint_Util$ConcatIterator, "pprint.Util$ConcatIterator", ({
  Lpprint_Util$ConcatIterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_Iterator: 1
}));
export { $d_Lpprint_Util$ConcatIterator as $d_Lpprint_Util$ConcatIterator };
/** @constructor */
function $c_Lretry_RetryDetails(retriesSoFar, cumulativeDelay, nextStepIfUnsuccessful) {
  this.Lretry_RetryDetails__f_retriesSoFar = 0;
  this.Lretry_RetryDetails__f_cumulativeDelay = null;
  this.Lretry_RetryDetails__f_nextStepIfUnsuccessful = null;
  this.Lretry_RetryDetails__f_retriesSoFar = retriesSoFar;
  this.Lretry_RetryDetails__f_cumulativeDelay = cumulativeDelay;
  this.Lretry_RetryDetails__f_nextStepIfUnsuccessful = nextStepIfUnsuccessful;
}
export { $c_Lretry_RetryDetails as $c_Lretry_RetryDetails };
$c_Lretry_RetryDetails.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lretry_RetryDetails.prototype.constructor = $c_Lretry_RetryDetails;
/** @constructor */
function $h_Lretry_RetryDetails() {
}
export { $h_Lretry_RetryDetails as $h_Lretry_RetryDetails };
$h_Lretry_RetryDetails.prototype = $c_Lretry_RetryDetails.prototype;
$c_Lretry_RetryDetails.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lretry_RetryDetails.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I("RetryDetails");
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lretry_RetryDetails__f_retriesSoFar;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lretry_RetryDetails__f_cumulativeDelay;
  var data$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lretry_RetryDetails__f_nextStepIfUnsuccessful;
  var data$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$1);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3);
});
$c_Lretry_RetryDetails.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lretry_RetryDetails)) {
    if ((this.Lretry_RetryDetails__f_retriesSoFar === x$0.Lretry_RetryDetails__f_retriesSoFar)) {
      var x = this.Lretry_RetryDetails__f_cumulativeDelay;
      var x$2 = x$0.Lretry_RetryDetails__f_cumulativeDelay;
      var $x_1 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.Lretry_RetryDetails__f_nextStepIfUnsuccessful;
      var x$4 = x$0.Lretry_RetryDetails__f_nextStepIfUnsuccessful;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lretry_RetryDetails.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lretry_RetryDetails.prototype.productArity__I = (function() {
  return 3;
});
$c_Lretry_RetryDetails.prototype.productPrefix__T = (function() {
  return "RetryDetails";
});
$c_Lretry_RetryDetails.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lretry_RetryDetails__f_retriesSoFar;
      break;
    }
    case 1: {
      return this.Lretry_RetryDetails__f_cumulativeDelay;
      break;
    }
    case 2: {
      return this.Lretry_RetryDetails__f_nextStepIfUnsuccessful;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lretry_RetryDetails.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "retriesSoFar";
      break;
    }
    case 1: {
      return "cumulativeDelay";
      break;
    }
    case 2: {
      return "nextStepIfUnsuccessful";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lretry_RetryDetails(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lretry_RetryDetails)));
}
export { $isArrayOf_Lretry_RetryDetails as $isArrayOf_Lretry_RetryDetails };
var $d_Lretry_RetryDetails = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lretry_RetryDetails, "retry.RetryDetails", ({
  Lretry_RetryDetails: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lretry_RetryDetails as $d_Lretry_RetryDetails };
function $ct_Lretry_RetryPolicy__F2__($thiz, decideNextRetry) {
  $thiz.Lretry_RetryPolicy__f_decideNextRetry = decideNextRetry;
  return $thiz;
}
export { $ct_Lretry_RetryPolicy__F2__ as $ct_Lretry_RetryPolicy__F2__ };
/** @constructor */
function $c_Lretry_RetryPolicy() {
  this.Lretry_RetryPolicy__f_decideNextRetry = null;
}
export { $c_Lretry_RetryPolicy as $c_Lretry_RetryPolicy };
$c_Lretry_RetryPolicy.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lretry_RetryPolicy.prototype.constructor = $c_Lretry_RetryPolicy;
/** @constructor */
function $h_Lretry_RetryPolicy() {
}
export { $h_Lretry_RetryPolicy as $h_Lretry_RetryPolicy };
$h_Lretry_RetryPolicy.prototype = $c_Lretry_RetryPolicy.prototype;
$c_Lretry_RetryPolicy.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lretry_RetryPolicy.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lretry_RetryPolicy.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lretry_RetryPolicy)) {
    var x = this.Lretry_RetryPolicy__f_decideNextRetry;
    var x$2 = x$0.Lretry_RetryPolicy__f_decideNextRetry;
    return (x === x$2);
  } else {
    return false;
  }
});
$c_Lretry_RetryPolicy.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lretry_RetryPolicy.prototype.productArity__I = (function() {
  return 1;
});
$c_Lretry_RetryPolicy.prototype.productPrefix__T = (function() {
  return "RetryPolicy";
});
$c_Lretry_RetryPolicy.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lretry_RetryPolicy__f_decideNextRetry;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lretry_RetryPolicy.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "decideNextRetry";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lretry_RetryPolicy.prototype.show__T = (function() {
  return this.toString__T();
});
$c_Lretry_RetryPolicy.prototype.followedBy__Lretry_RetryPolicy__Lcats_Apply__Lretry_RetryPolicy = (function(rp, F) {
  var decideNextRetry = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((actionResult, status) => F.map2__O__O__F2__O(this.Lretry_RetryPolicy__f_decideNextRetry.apply__O__O__O(actionResult, status), rp.Lretry_RetryPolicy__f_decideNextRetry.apply__O__O__O(actionResult, status), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((x$1, x$2) => {
    var x = $s_Lretry_PolicyDecision$__GiveUp__Lretry_PolicyDecision();
    if (((x === null) ? (x$1 === null) : x.equals__O__Z(x$1))) {
      return x$2;
    } else {
      return x$1;
    }
  })))));
  var pretty = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
    $m_Lcats_implicits$();
    var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["", ".followedBy(", ")"]));
    var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
    return $x_1.show$extension__s_StringContext__sci_Seq__T(sc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(this.show__T(), $m_Lcats_implicits$().Lcats_implicits$__f_catsStdShowForString)), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(rp, $m_Lretry_RetryPolicy$().given_Show_RetryPolicy__Lcats_Show()))])));
  }));
  return new $c_Lretry_RetryPolicy$$anon$1(decideNextRetry, pretty);
});
$c_Lretry_RetryPolicy.prototype.join__Lretry_RetryPolicy__Lcats_Apply__Lretry_RetryPolicy = (function(rp, F) {
  var decideNextRetry = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((actionResult, status) => F.map2__O__O__F2__O(this.Lretry_RetryPolicy__f_decideNextRetry.apply__O__O__O(actionResult, status), rp.Lretry_RetryPolicy__f_decideNextRetry.apply__O__O__O(actionResult, status), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((x$1, x$2) => {
    if ((x$1 instanceof $c_Lretry_PolicyDecision$DelayAndRetry)) {
      var x18 = x$1.Lretry_PolicyDecision$DelayAndRetry__f_delay;
      if ((x$2 instanceof $c_Lretry_PolicyDecision$DelayAndRetry)) {
        var x15 = x$2.Lretry_PolicyDecision$DelayAndRetry__f_delay;
        var delay = x18.max__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration(x15);
        return new $c_Lretry_PolicyDecision$DelayAndRetry(delay);
      }
    }
    return $s_Lretry_PolicyDecision$__GiveUp__Lretry_PolicyDecision();
  })))));
  var pretty = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
    $m_Lcats_implicits$();
    var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["", ".join(", ")"]));
    var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
    return $x_1.show$extension__s_StringContext__sci_Seq__T(sc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(this.show__T(), $m_Lcats_implicits$().Lcats_implicits$__f_catsStdShowForString)), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(rp, $m_Lretry_RetryPolicy$().given_Show_RetryPolicy__Lcats_Show()))])));
  }));
  return new $c_Lretry_RetryPolicy$$anon$1(decideNextRetry, pretty);
});
function $isArrayOf_Lretry_RetryPolicy(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lretry_RetryPolicy)));
}
export { $isArrayOf_Lretry_RetryPolicy as $isArrayOf_Lretry_RetryPolicy };
var $d_Lretry_RetryPolicy = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lretry_RetryPolicy, "retry.RetryPolicy", ({
  Lretry_RetryPolicy: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lretry_RetryPolicy as $d_Lretry_RetryPolicy };
/** @constructor */
function $c_Lretry_RetryStatus(retriesSoFar, cumulativeDelay, previousDelay) {
  this.Lretry_RetryStatus__f_retriesSoFar = 0;
  this.Lretry_RetryStatus__f_cumulativeDelay = null;
  this.Lretry_RetryStatus__f_previousDelay = null;
  this.Lretry_RetryStatus__f_retriesSoFar = retriesSoFar;
  this.Lretry_RetryStatus__f_cumulativeDelay = cumulativeDelay;
  this.Lretry_RetryStatus__f_previousDelay = previousDelay;
}
export { $c_Lretry_RetryStatus as $c_Lretry_RetryStatus };
$c_Lretry_RetryStatus.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lretry_RetryStatus.prototype.constructor = $c_Lretry_RetryStatus;
/** @constructor */
function $h_Lretry_RetryStatus() {
}
export { $h_Lretry_RetryStatus as $h_Lretry_RetryStatus };
$h_Lretry_RetryStatus.prototype = $c_Lretry_RetryStatus.prototype;
$c_Lretry_RetryStatus.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lretry_RetryStatus.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I("RetryStatus");
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lretry_RetryStatus__f_retriesSoFar;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lretry_RetryStatus__f_cumulativeDelay;
  var data$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lretry_RetryStatus__f_previousDelay;
  var data$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$1);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3);
});
$c_Lretry_RetryStatus.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lretry_RetryStatus)) {
    if ((this.Lretry_RetryStatus__f_retriesSoFar === x$0.Lretry_RetryStatus__f_retriesSoFar)) {
      var x = this.Lretry_RetryStatus__f_cumulativeDelay;
      var x$2 = x$0.Lretry_RetryStatus__f_cumulativeDelay;
      var $x_1 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.Lretry_RetryStatus__f_previousDelay;
      var x$4 = x$0.Lretry_RetryStatus__f_previousDelay;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lretry_RetryStatus.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lretry_RetryStatus.prototype.productArity__I = (function() {
  return 3;
});
$c_Lretry_RetryStatus.prototype.productPrefix__T = (function() {
  return "RetryStatus";
});
$c_Lretry_RetryStatus.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lretry_RetryStatus__f_retriesSoFar;
      break;
    }
    case 1: {
      return this.Lretry_RetryStatus__f_cumulativeDelay;
      break;
    }
    case 2: {
      return this.Lretry_RetryStatus__f_previousDelay;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lretry_RetryStatus.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "retriesSoFar";
      break;
    }
    case 1: {
      return "cumulativeDelay";
      break;
    }
    case 2: {
      return "previousDelay";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lretry_RetryStatus.prototype.addRetry__s_concurrent_duration_FiniteDuration__Lretry_RetryStatus = (function(delay) {
  $m_Lretry_RetryStatus$();
  var retriesSoFar = ((1 + this.Lretry_RetryStatus__f_retriesSoFar) | 0);
  var this$1 = this.Lretry_RetryStatus__f_cumulativeDelay;
  var cumulativeDelay = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$p_s_concurrent_duration_FiniteDuration__add__J__ju_concurrent_TimeUnit__s_concurrent_duration_FiniteDuration(this$1, delay.s_concurrent_duration_FiniteDuration__f_length, delay.s_concurrent_duration_FiniteDuration__f_unit);
  var previousDelay = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(delay);
  return new $c_Lretry_RetryStatus(retriesSoFar, cumulativeDelay, previousDelay);
});
function $isArrayOf_Lretry_RetryStatus(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lretry_RetryStatus)));
}
export { $isArrayOf_Lretry_RetryStatus as $isArrayOf_Lretry_RetryStatus };
var $d_Lretry_RetryStatus = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lretry_RetryStatus, "retry.RetryStatus", ({
  Lretry_RetryStatus: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lretry_RetryStatus as $d_Lretry_RetryStatus };
class $c_s_NotImplementedError extends $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Error {
  constructor() {
    super();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, "an implementation is missing", null, true, true);
  }
}
export { $c_s_NotImplementedError as $c_s_NotImplementedError };
var $d_s_NotImplementedError = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_s_NotImplementedError, "scala.NotImplementedError", ({
  s_NotImplementedError: 1,
  jl_Error: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_NotImplementedError as $d_s_NotImplementedError };
/** @constructor */
function $c_sc_MapOps$WithFilter(self, p) {
  this.sc_IterableOps$WithFilter__f_self = null;
  this.sc_IterableOps$WithFilter__f_p = null;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(this, self, p);
}
export { $c_sc_MapOps$WithFilter as $c_sc_MapOps$WithFilter };
$c_sc_MapOps$WithFilter.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sc_IterableOps$WithFilter();
$c_sc_MapOps$WithFilter.prototype.constructor = $c_sc_MapOps$WithFilter;
/** @constructor */
function $h_sc_MapOps$WithFilter() {
}
export { $h_sc_MapOps$WithFilter as $h_sc_MapOps$WithFilter };
$h_sc_MapOps$WithFilter.prototype = $c_sc_MapOps$WithFilter.prototype;
var $d_sc_MapOps$WithFilter = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sc_MapOps$WithFilter, "scala.collection.MapOps$WithFilter", ({
  sc_MapOps$WithFilter: 1,
  sc_IterableOps$WithFilter: 1,
  sc_WithFilter: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_MapOps$WithFilter as $d_sc_MapOps$WithFilter };
/** @constructor */
function $c_sci_BitSet$() {
  this.sci_BitSet$__f_empty = null;
  $n_sci_BitSet$ = this;
  this.sci_BitSet$__f_empty = new $c_sci_BitSet$BitSet1($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0);
}
export { $c_sci_BitSet$ as $c_sci_BitSet$ };
$c_sci_BitSet$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_sci_BitSet$.prototype.constructor = $c_sci_BitSet$;
/** @constructor */
function $h_sci_BitSet$() {
}
export { $h_sci_BitSet$ as $h_sci_BitSet$ };
$h_sci_BitSet$.prototype = $c_sci_BitSet$.prototype;
$c_sci_BitSet$.prototype.fromSpecific__sc_IterableOnce__sci_BitSet = (function(it) {
  if ((it instanceof $c_sci_BitSet)) {
    return it;
  } else {
    var this$1 = this.newBuilder__scm_Builder();
    return this$1.addAll__sc_IterableOnce__scm_Growable(it).result__O();
  }
});
$c_sci_BitSet$.prototype.newBuilder__scm_Builder = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_scm_GrowableBuilder__scm_Growable__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_GrowableBuilder(), $ct_scm_BitSet__(new $c_scm_BitSet()));
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((bs$2$2) => $m_sci_BitSet$().fromBitMaskNoCopy__AJ__sci_BitSet(bs$2$2.scm_BitSet__f_elems)));
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_Builder$$anon$1(this$2, f);
});
$c_sci_BitSet$.prototype.scala$collection$immutable$BitSet$$createSmall__J__J__sci_BitSet = (function(a, b) {
  return (((b.RTLong__f_lo === 0) && (b.RTLong__f_hi === 0)) ? new $c_sci_BitSet$BitSet1(a) : new $c_sci_BitSet$BitSet2(a, b));
});
$c_sci_BitSet$.prototype.fromBitMaskNoCopy__AJ__sci_BitSet = (function(elems) {
  var len = elems.u.length;
  return ((len === 0) ? this.sci_BitSet$__f_empty : ((len === 1) ? new $c_sci_BitSet$BitSet1(elems.u[0]) : ((len === 2) ? this.scala$collection$immutable$BitSet$$createSmall__J__J__sci_BitSet(elems.u[0], elems.u[1]) : new $c_sci_BitSet$BitSetN(elems))));
});
var $d_sci_BitSet$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sci_BitSet$, "scala.collection.immutable.BitSet$", ({
  sci_BitSet$: 1,
  sc_SpecificIterableFactory: 1,
  sc_Factory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_BitSet$ as $d_sci_BitSet$ };
var $n_sci_BitSet$;
function $m_sci_BitSet$() {
  if ((!$n_sci_BitSet$)) {
    $n_sci_BitSet$ = new $c_sci_BitSet$();
  }
  return $n_sci_BitSet$;
}
export { $m_sci_BitSet$ as $m_sci_BitSet$ };
/** @constructor */
function $c_sci_SortedMap$() {
  this.sc_SortedMapFactory$Delegate__f_delegate = null;
  $ct_sc_SortedMapFactory$Delegate__sc_SortedMapFactory__(this, $m_sci_TreeMap$());
}
export { $c_sci_SortedMap$ as $c_sci_SortedMap$ };
$c_sci_SortedMap$.prototype = new $h_sc_SortedMapFactory$Delegate();
$c_sci_SortedMap$.prototype.constructor = $c_sci_SortedMap$;
/** @constructor */
function $h_sci_SortedMap$() {
}
export { $h_sci_SortedMap$ as $h_sci_SortedMap$ };
$h_sci_SortedMap$.prototype = $c_sci_SortedMap$.prototype;
$c_sci_SortedMap$.prototype.from__sc_IterableOnce__s_math_Ordering__sci_SortedMap = (function(it, evidence$1) {
  if ($is_sci_SortedMap(it)) {
    var x$2 = it.sci_TreeMap__f_ordering;
    if (((evidence$1 === null) ? (x$2 === null) : evidence$1.equals__O__Z(x$2))) {
      return it;
    }
  }
  return $c_sc_SortedMapFactory$Delegate.prototype.from__sc_IterableOnce__s_math_Ordering__O.call(this, it, evidence$1);
});
$c_sci_SortedMap$.prototype.from__sc_IterableOnce__s_math_Ordering__O = (function(it, evidence$46) {
  return this.from__sc_IterableOnce__s_math_Ordering__sci_SortedMap(it, evidence$46);
});
var $d_sci_SortedMap$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sci_SortedMap$, "scala.collection.immutable.SortedMap$", ({
  sci_SortedMap$: 1,
  sc_SortedMapFactory$Delegate: 1,
  sc_SortedMapFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_SortedMap$ as $d_sci_SortedMap$ };
var $n_sci_SortedMap$;
function $m_sci_SortedMap$() {
  if ((!$n_sci_SortedMap$)) {
    $n_sci_SortedMap$ = new $c_sci_SortedMap$();
  }
  return $n_sci_SortedMap$;
}
export { $m_sci_SortedMap$ as $m_sci_SortedMap$ };
/** @constructor */
function $c_sci_TreeMap$Adder(outer) {
  this.sci_RedBlackTree$Helper__f_ordering = null;
  this.sci_TreeMap$Adder__f_currentMutableTree = null;
  var ordering = outer.sci_TreeMap__f_ordering;
  $ct_sci_RedBlackTree$Helper__s_math_Ordering__(this, ordering);
  this.sci_TreeMap$Adder__f_currentMutableTree = outer.sci_TreeMap__f_tree;
}
export { $c_sci_TreeMap$Adder as $c_sci_TreeMap$Adder };
$c_sci_TreeMap$Adder.prototype = new $h_sci_RedBlackTree$MapHelper();
$c_sci_TreeMap$Adder.prototype.constructor = $c_sci_TreeMap$Adder;
/** @constructor */
function $h_sci_TreeMap$Adder() {
}
export { $h_sci_TreeMap$Adder as $h_sci_TreeMap$Adder };
$h_sci_TreeMap$Adder.prototype = $c_sci_TreeMap$Adder.prototype;
$c_sci_TreeMap$Adder.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return (this.apply__T2__V(v1), (void 0));
});
$c_sci_TreeMap$Adder.prototype.compose__F1__F1 = (function(g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_F1__compose__F1__F1(this, g);
});
$c_sci_TreeMap$Adder.prototype.andThen__F1__F1 = (function(g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_F1__andThen__F1__F1(this, g);
});
$c_sci_TreeMap$Adder.prototype.toString__T = (function() {
  return "<function1>";
});
$c_sci_TreeMap$Adder.prototype.apply__T2__V = (function(kv) {
  this.sci_TreeMap$Adder__f_currentMutableTree = this.mutableUpd__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree(this.sci_TreeMap$Adder__f_currentMutableTree, kv._1__O(), kv._2__O());
});
$c_sci_TreeMap$Adder.prototype.addAll__sci_LinearSeq__V = (function(ls) {
  while (true) {
    if ((!ls.isEmpty__Z())) {
      var kv = ls.head__O();
      this.sci_TreeMap$Adder__f_currentMutableTree = this.mutableUpd__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree(this.sci_TreeMap$Adder__f_currentMutableTree, kv._1__O(), kv._2__O());
      ls = ls.tail__O();
      continue;
    }
    return (void 0);
  }
});
$c_sci_TreeMap$Adder.prototype.apply__O__O = (function(v1) {
  this.apply__T2__V(v1);
});
var $d_sci_TreeMap$Adder = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sci_TreeMap$Adder, "scala.collection.immutable.TreeMap$Adder", ({
  sci_TreeMap$Adder: 1,
  sci_RedBlackTree$MapHelper: 1,
  sci_RedBlackTree$Helper: 1,
  F1: 1
}));
export { $d_sci_TreeMap$Adder as $d_sci_TreeMap$Adder };
/** @constructor */
function $c_sci_TreeSet$() {
}
export { $c_sci_TreeSet$ as $c_sci_TreeSet$ };
$c_sci_TreeSet$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_sci_TreeSet$.prototype.constructor = $c_sci_TreeSet$;
/** @constructor */
function $h_sci_TreeSet$() {
}
export { $h_sci_TreeSet$ as $h_sci_TreeSet$ };
$h_sci_TreeSet$.prototype = $c_sci_TreeSet$.prototype;
$c_sci_TreeSet$.prototype.apply__sci_Seq__O__O = (function(xs, evidence$7) {
  return this.from__sc_IterableOnce__s_math_Ordering__sci_TreeSet(xs, evidence$7);
});
$c_sci_TreeSet$.prototype.from__sc_IterableOnce__s_math_Ordering__sci_TreeSet = (function(it, ordering) {
  if ((it instanceof $c_sci_TreeSet)) {
    var x$2 = it.sci_TreeSet__f_ordering;
    if (((ordering === null) ? (x$2 === null) : ordering.equals__O__Z(x$2))) {
      return it;
    }
  }
  if ($is_sc_SortedSet(it)) {
    var x$4 = it.ordering__s_math_Ordering();
    if (((ordering === null) ? (x$4 === null) : ordering.equals__O__Z(x$4))) {
      return $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), $m_sci_RedBlackTree$().fromOrderedKeys__sc_Iterator__I__sci_RedBlackTree$Tree(it.iterator__sc_Iterator(), it.size__I()), ordering);
    }
  }
  if ((it instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_Range)) {
    if ((ordering === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_math_Ordering$Int$())) {
      var $x_1 = true;
    } else {
      var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_math_Ordering$Int$();
      var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z(this$1, ordering);
    }
    if ($x_1) {
      if (((ordering === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_math_Ordering$Int$()) === (it.sci_Range__f_step > 0))) {
        var it$2 = it.iterator__sc_Iterator();
      } else {
        var this$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_IndexedSeqView$Id(it);
        var it$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$2);
      }
      var tree = $m_sci_RedBlackTree$().fromOrderedKeys__sc_Iterator__I__sci_RedBlackTree$Tree(it$2, it.length__I());
      return $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), tree, ordering);
    }
  }
  var t = null;
  var i = it.iterator__sc_Iterator();
  while (i.hasNext__Z()) {
    t = $m_sci_RedBlackTree$().update__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree(t, i.next__O(), null, false, ordering);
  }
  return $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), t, ordering);
});
$c_sci_TreeSet$.prototype.newBuilder__O__scm_Builder = (function(evidence$12) {
  return new $c_sci_TreeSet$TreeSetBuilder(evidence$12);
});
$c_sci_TreeSet$.prototype.from__sc_IterableOnce__O__O = (function(it, evidence$5) {
  return this.from__sc_IterableOnce__s_math_Ordering__sci_TreeSet(it, evidence$5);
});
var $d_sci_TreeSet$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sci_TreeSet$, "scala.collection.immutable.TreeSet$", ({
  sci_TreeSet$: 1,
  sc_SortedIterableFactory: 1,
  sc_EvidenceIterableFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_TreeSet$ as $d_sci_TreeSet$ };
var $n_sci_TreeSet$;
function $m_sci_TreeSet$() {
  if ((!$n_sci_TreeSet$)) {
    $n_sci_TreeSet$ = new $c_sci_TreeSet$();
  }
  return $n_sci_TreeSet$;
}
export { $m_sci_TreeSet$ as $m_sci_TreeSet$ };
class $c_s_concurrent_Future$$anon$4 extends $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable {
  constructor() {
    super();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  fillInStackTrace__jl_Throwable() {
    return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this);
  }
}
export { $c_s_concurrent_Future$$anon$4 as $c_s_concurrent_Future$$anon$4 };
var $d_s_concurrent_Future$$anon$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_s_concurrent_Future$$anon$4, "scala.concurrent.Future$$anon$4", ({
  s_concurrent_Future$$anon$4: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_util_control_NoStackTrace: 1
}));
export { $d_s_concurrent_Future$$anon$4 as $d_s_concurrent_Future$$anon$4 };
/** @constructor */
function $c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext() {
  this.sjs_concurrent_QueueExecutionContext$PromisesExecutionContext__f_resolvedUnitPromise = null;
  this.sjs_concurrent_QueueExecutionContext$PromisesExecutionContext__f_resolvedUnitPromise = Promise.resolve((void 0));
}
export { $c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext as $c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext };
$c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext.prototype.constructor = $c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext;
/** @constructor */
function $h_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext() {
}
export { $h_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext as $h_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext };
$h_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext.prototype = $c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext.prototype;
$c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext.prototype.execute__jl_Runnable__V = (function(runnable) {
  this.sjs_concurrent_QueueExecutionContext$PromisesExecutionContext__f_resolvedUnitPromise.then(((arg1$2) => {
    try {
      runnable.run__V();
    } catch (e) {
      var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
      e$2.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err);
    }
  }));
});
$c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext.prototype.reportFailure__jl_Throwable__V = (function(t) {
  t.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err);
});
var $d_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext, "scala.scalajs.concurrent.QueueExecutionContext$PromisesExecutionContext", ({
  sjs_concurrent_QueueExecutionContext$PromisesExecutionContext: 1,
  s_concurrent_ExecutionContextExecutor: 1,
  s_concurrent_ExecutionContext: 1,
  ju_concurrent_Executor: 1
}));
export { $d_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext as $d_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext };
/** @constructor */
function $c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext() {
}
export { $c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext as $c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext };
$c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext.prototype.constructor = $c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext;
/** @constructor */
function $h_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext() {
}
export { $h_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext as $h_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext };
$h_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext.prototype = $c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext.prototype;
$c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext.prototype.execute__jl_Runnable__V = (function(runnable) {
  setTimeout($m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
    try {
      runnable.run__V();
    } catch (e) {
      var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
      e$2.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err);
    }
  }))), 0);
});
$c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext.prototype.reportFailure__jl_Throwable__V = (function(t) {
  t.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err);
});
var $d_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext, "scala.scalajs.concurrent.QueueExecutionContext$TimeoutsExecutionContext", ({
  sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext: 1,
  s_concurrent_ExecutionContextExecutor: 1,
  s_concurrent_ExecutionContext: 1,
  ju_concurrent_Executor: 1
}));
export { $d_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext as $d_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext };
/** @constructor */
function $c_sjs_js_Iterator$WrappedIterator(self) {
  this.sjs_js_Iterator$WrappedIterator__f_scala$scalajs$js$Iterator$WrappedIterator$$self = null;
  this.sjs_js_Iterator$WrappedIterator__f_scala$scalajs$js$Iterator$WrappedIterator$$lastEntry = null;
  this.sjs_js_Iterator$WrappedIterator__f_scala$scalajs$js$Iterator$WrappedIterator$$self = self;
  this.sjs_js_Iterator$WrappedIterator__f_scala$scalajs$js$Iterator$WrappedIterator$$lastEntry = self.next();
}
export { $c_sjs_js_Iterator$WrappedIterator as $c_sjs_js_Iterator$WrappedIterator };
$c_sjs_js_Iterator$WrappedIterator.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_sjs_js_Iterator$WrappedIterator.prototype.constructor = $c_sjs_js_Iterator$WrappedIterator;
/** @constructor */
function $h_sjs_js_Iterator$WrappedIterator() {
}
export { $h_sjs_js_Iterator$WrappedIterator as $h_sjs_js_Iterator$WrappedIterator };
$h_sjs_js_Iterator$WrappedIterator.prototype = $c_sjs_js_Iterator$WrappedIterator.prototype;
$c_sjs_js_Iterator$WrappedIterator.prototype.iterator__sc_Iterator = (function() {
  return this;
});
$c_sjs_js_Iterator$WrappedIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$c_sjs_js_Iterator$WrappedIterator.prototype.take__I__sc_Iterator = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$c_sjs_js_Iterator$WrappedIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1));
});
$c_sjs_js_Iterator$WrappedIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$c_sjs_js_Iterator$WrappedIterator.prototype.toString__T = (function() {
  return "<iterator>";
});
$c_sjs_js_Iterator$WrappedIterator.prototype.forall__F1__Z = (function(p) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_sjs_js_Iterator$WrappedIterator.prototype.find__F1__s_Option = (function(p) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$c_sjs_js_Iterator$WrappedIterator.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_sjs_js_Iterator$WrappedIterator.prototype.reduceLeft__F2__O = (function(op) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$c_sjs_js_Iterator$WrappedIterator.prototype.copyToArray__O__I__I__I = (function(dest, start, n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, dest, start, n);
});
$c_sjs_js_Iterator$WrappedIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_sjs_js_Iterator$WrappedIterator.prototype.toList__sci_List = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_sjs_js_Iterator$WrappedIterator.prototype.toVector__sci_Vector = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this);
});
$c_sjs_js_Iterator$WrappedIterator.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_sjs_js_Iterator$WrappedIterator.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_sjs_js_Iterator$WrappedIterator.prototype.reversed__sc_Iterable = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__reversed__sc_Iterable(this);
});
$c_sjs_js_Iterator$WrappedIterator.prototype.knownSize__I = (function() {
  return (-1);
});
$c_sjs_js_Iterator$WrappedIterator.prototype.hasNext__Z = (function() {
  return (!(!(!this.sjs_js_Iterator$WrappedIterator__f_scala$scalajs$js$Iterator$WrappedIterator$$lastEntry.done)));
});
$c_sjs_js_Iterator$WrappedIterator.prototype.next__O = (function() {
  var value = this.sjs_js_Iterator$WrappedIterator__f_scala$scalajs$js$Iterator$WrappedIterator$$lastEntry.value;
  this.sjs_js_Iterator$WrappedIterator__f_scala$scalajs$js$Iterator$WrappedIterator$$lastEntry = this.sjs_js_Iterator$WrappedIterator__f_scala$scalajs$js$Iterator$WrappedIterator$$self.next();
  return value;
});
var $d_sjs_js_Iterator$WrappedIterator = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sjs_js_Iterator$WrappedIterator, "scala.scalajs.js.Iterator$WrappedIterator", ({
  sjs_js_Iterator$WrappedIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sjs_js_Iterator$WrappedIterator as $d_sjs_js_Iterator$WrappedIterator };
var $r_sjs_js_JSConverters$IterableAdapter__col = Symbol();
export { $r_sjs_js_JSConverters$IterableAdapter__col as $r_sjs_js_JSConverters$IterableAdapter__col };
var $b_sjs_js_JSConverters$IterableAdapter;
function $a_sjs_js_JSConverters$IterableAdapter() {
  if ((!$b_sjs_js_JSConverters$IterableAdapter)) {
    $b_sjs_js_JSConverters$IterableAdapter = class $b_sjs_js_JSConverters$IterableAdapter extends Object {
    constructor(arg) {
      var col = null;
      col = arg;
      super();
      this[$r_sjs_js_JSConverters$IterableAdapter__col] = null;
      this[$r_sjs_js_JSConverters$IterableAdapter__col] = col;
    }
    [Symbol.iterator]() {
      var self = this[$r_sjs_js_JSConverters$IterableAdapter__col].iterator__sc_Iterator();
      return new ($a_sjs_js_JSConverters$IteratorAdapter())(self);
    }
    };
  }
  return $b_sjs_js_JSConverters$IterableAdapter;
}
export { $a_sjs_js_JSConverters$IterableAdapter as $a_sjs_js_JSConverters$IterableAdapter };
var $r_sjs_js_JSConverters$IteratorAdapter__scala$scalajs$js$JSConverters$IteratorAdapter$$it = Symbol();
export { $r_sjs_js_JSConverters$IteratorAdapter__scala$scalajs$js$JSConverters$IteratorAdapter$$it as $r_sjs_js_JSConverters$IteratorAdapter__scala$scalajs$js$JSConverters$IteratorAdapter$$it };
var $b_sjs_js_JSConverters$IteratorAdapter;
function $a_sjs_js_JSConverters$IteratorAdapter() {
  if ((!$b_sjs_js_JSConverters$IteratorAdapter)) {
    $b_sjs_js_JSConverters$IteratorAdapter = class $b_sjs_js_JSConverters$IteratorAdapter extends Object {
    constructor(arg) {
      var it = null;
      it = arg;
      super();
      this[$r_sjs_js_JSConverters$IteratorAdapter__scala$scalajs$js$JSConverters$IteratorAdapter$$it] = null;
      this[$r_sjs_js_JSConverters$IteratorAdapter__scala$scalajs$js$JSConverters$IteratorAdapter$$it] = it;
    }
    "next"() {
      return (this[$r_sjs_js_JSConverters$IteratorAdapter__scala$scalajs$js$JSConverters$IteratorAdapter$$it].hasNext__Z() ? (() => {
        var outer = null;
        outer = this;
        var this$2 = ({});
        this$2.done = false;
        this$2.value = null;
        this$2.done = false;
        this$2.value = outer[$r_sjs_js_JSConverters$IteratorAdapter__scala$scalajs$js$JSConverters$IteratorAdapter$$it].next__O();
        return this$2;
      })() : (() => {
        var outer$1 = null;
        outer$1 = this;
        var this$3 = ({});
        this$3.done = false;
        this$3.value = null;
        this$3.done = true;
        this$3.value = (void 0);
        return this$3;
      })());
    }
    };
  }
  return $b_sjs_js_JSConverters$IteratorAdapter;
}
export { $a_sjs_js_JSConverters$IteratorAdapter as $a_sjs_js_JSConverters$IteratorAdapter };
/** @constructor */
function $c_sjs_js_WrappedDictionary$DictionaryIterator(dict) {
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_dict = null;
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_keys = null;
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_index = 0;
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_dict = dict;
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_keys = Object.keys(dict);
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_index = 0;
}
export { $c_sjs_js_WrappedDictionary$DictionaryIterator as $c_sjs_js_WrappedDictionary$DictionaryIterator };
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.constructor = $c_sjs_js_WrappedDictionary$DictionaryIterator;
/** @constructor */
function $h_sjs_js_WrappedDictionary$DictionaryIterator() {
}
export { $h_sjs_js_WrappedDictionary$DictionaryIterator as $h_sjs_js_WrappedDictionary$DictionaryIterator };
$h_sjs_js_WrappedDictionary$DictionaryIterator.prototype = $c_sjs_js_WrappedDictionary$DictionaryIterator.prototype;
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.iterator__sc_Iterator = (function() {
  return this;
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.take__I__sc_Iterator = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1));
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.toString__T = (function() {
  return "<iterator>";
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.forall__F1__Z = (function(p) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.find__F1__s_Option = (function(p) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.reduceLeft__F2__O = (function(op) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.copyToArray__O__I__I__I = (function(dest, start, n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, dest, start, n);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.toList__sci_List = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.toVector__sci_Vector = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.reversed__sc_Iterable = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__reversed__sc_Iterable(this);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.knownSize__I = (function() {
  return (-1);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.hasNext__Z = (function() {
  return (this.sjs_js_WrappedDictionary$DictionaryIterator__f_index < (this.sjs_js_WrappedDictionary$DictionaryIterator__f_keys.length | 0));
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.next__T2 = (function() {
  var key = this.sjs_js_WrappedDictionary$DictionaryIterator__f_keys[this.sjs_js_WrappedDictionary$DictionaryIterator__f_index];
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_index = ((1 + this.sjs_js_WrappedDictionary$DictionaryIterator__f_index) | 0);
  var dict = this.sjs_js_WrappedDictionary$DictionaryIterator__f_dict;
  if ((!(!$m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key)))) {
    var $x_1 = dict[key];
  } else {
    var $x_1;
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_ju_NoSuchElementException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_ju_NoSuchElementException(), ("key not found: " + key));
  }
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), key, $x_1);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.next__O = (function() {
  return this.next__T2();
});
var $d_sjs_js_WrappedDictionary$DictionaryIterator = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sjs_js_WrappedDictionary$DictionaryIterator, "scala.scalajs.js.WrappedDictionary$DictionaryIterator", ({
  sjs_js_WrappedDictionary$DictionaryIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sjs_js_WrappedDictionary$DictionaryIterator as $d_sjs_js_WrappedDictionary$DictionaryIterator };
/** @constructor */
function $c_Lshapeless3_deriving_Complete(t) {
  this.Lshapeless3_deriving_Complete__f_t = null;
  this.Lshapeless3_deriving_Complete__f_t = t;
}
export { $c_Lshapeless3_deriving_Complete as $c_Lshapeless3_deriving_Complete };
$c_Lshapeless3_deriving_Complete.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lshapeless3_deriving_Complete.prototype.constructor = $c_Lshapeless3_deriving_Complete;
/** @constructor */
function $h_Lshapeless3_deriving_Complete() {
}
export { $h_Lshapeless3_deriving_Complete as $h_Lshapeless3_deriving_Complete };
$h_Lshapeless3_deriving_Complete.prototype = $c_Lshapeless3_deriving_Complete.prototype;
$c_Lshapeless3_deriving_Complete.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lshapeless3_deriving_Complete.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lshapeless3_deriving_Complete.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lshapeless3_deriving_Complete)) {
    var x = this.Lshapeless3_deriving_Complete__f_t;
    var y = x$0.Lshapeless3_deriving_Complete__f_t;
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lshapeless3_deriving_Complete.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lshapeless3_deriving_Complete.prototype.productArity__I = (function() {
  return 1;
});
$c_Lshapeless3_deriving_Complete.prototype.productPrefix__T = (function() {
  return "Complete";
});
$c_Lshapeless3_deriving_Complete.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lshapeless3_deriving_Complete__f_t;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lshapeless3_deriving_Complete.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "t";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lshapeless3_deriving_Complete(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lshapeless3_deriving_Complete)));
}
export { $isArrayOf_Lshapeless3_deriving_Complete as $isArrayOf_Lshapeless3_deriving_Complete };
var $d_Lshapeless3_deriving_Complete = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lshapeless3_deriving_Complete, "shapeless3.deriving.Complete", ({
  Lshapeless3_deriving_Complete: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lshapeless3_deriving_Complete as $d_Lshapeless3_deriving_Complete };
/** @constructor */
function $c_Lshapeless3_deriving_Labelling(label, elemLabels) {
  this.Lshapeless3_deriving_Labelling__f_label = null;
  this.Lshapeless3_deriving_Labelling__f_elemLabels = null;
  this.Lshapeless3_deriving_Labelling__f_label = label;
  this.Lshapeless3_deriving_Labelling__f_elemLabels = elemLabels;
}
export { $c_Lshapeless3_deriving_Labelling as $c_Lshapeless3_deriving_Labelling };
$c_Lshapeless3_deriving_Labelling.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lshapeless3_deriving_Labelling.prototype.constructor = $c_Lshapeless3_deriving_Labelling;
/** @constructor */
function $h_Lshapeless3_deriving_Labelling() {
}
export { $h_Lshapeless3_deriving_Labelling as $h_Lshapeless3_deriving_Labelling };
$h_Lshapeless3_deriving_Labelling.prototype = $c_Lshapeless3_deriving_Labelling.prototype;
$c_Lshapeless3_deriving_Labelling.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lshapeless3_deriving_Labelling.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lshapeless3_deriving_Labelling.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lshapeless3_deriving_Labelling)) {
    if ((this.Lshapeless3_deriving_Labelling__f_label === x$0.Lshapeless3_deriving_Labelling__f_label)) {
      var x = this.Lshapeless3_deriving_Labelling__f_elemLabels;
      var x$2 = x$0.Lshapeless3_deriving_Labelling__f_elemLabels;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lshapeless3_deriving_Labelling.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lshapeless3_deriving_Labelling.prototype.productArity__I = (function() {
  return 2;
});
$c_Lshapeless3_deriving_Labelling.prototype.productPrefix__T = (function() {
  return "Labelling";
});
$c_Lshapeless3_deriving_Labelling.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lshapeless3_deriving_Labelling__f_label;
  }
  if ((n === 1)) {
    return this.Lshapeless3_deriving_Labelling__f_elemLabels;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lshapeless3_deriving_Labelling.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "label";
  }
  if ((n === 1)) {
    return "elemLabels";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lshapeless3_deriving_Labelling(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lshapeless3_deriving_Labelling)));
}
export { $isArrayOf_Lshapeless3_deriving_Labelling as $isArrayOf_Lshapeless3_deriving_Labelling };
var $d_Lshapeless3_deriving_Labelling = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lshapeless3_deriving_Labelling, "shapeless3.deriving.Labelling", ({
  Lshapeless3_deriving_Labelling: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lshapeless3_deriving_Labelling as $d_Lshapeless3_deriving_Labelling };
function $p_Lshapeless3_deriving_internals_ErasedProductInstances1__i__O($thiz) {
  if ((!$thiz.Lshapeless3_deriving_internals_ErasedProductInstances1__f_ibitmap$1)) {
    $thiz.Lshapeless3_deriving_internals_ErasedProductInstances1__f_i$lzy1 = $thiz.Lshapeless3_deriving_internals_ErasedProductInstances1__f_i0.apply__O();
    $thiz.Lshapeless3_deriving_internals_ErasedProductInstances1__f_ibitmap$1 = true;
    $thiz.Lshapeless3_deriving_internals_ErasedProductInstances1__f_i0 = null;
  }
  return $thiz.Lshapeless3_deriving_internals_ErasedProductInstances1__f_i$lzy1;
}
export { $p_Lshapeless3_deriving_internals_ErasedProductInstances1__i__O as $p_Lshapeless3_deriving_internals_ErasedProductInstances1__i__O };
function $p_Lshapeless3_deriving_internals_ErasedProductInstances1__fromElement__O__O($thiz, x) {
  return $thiz.Lshapeless3_deriving_internals_ErasedProductInstances1__f_mirror.fromProduct__s_Product__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T1(x));
}
export { $p_Lshapeless3_deriving_internals_ErasedProductInstances1__fromElement__O__O as $p_Lshapeless3_deriving_internals_ErasedProductInstances1__fromElement__O__O };
/** @constructor */
function $c_Lshapeless3_deriving_internals_ErasedProductInstances1(mirror, i0) {
  this.Lshapeless3_deriving_internals_ErasedProductInstances1__f_mirror = null;
  this.Lshapeless3_deriving_internals_ErasedProductInstances1__f_i0 = null;
  this.Lshapeless3_deriving_internals_ErasedProductInstances1__f_i$lzy1 = null;
  this.Lshapeless3_deriving_internals_ErasedProductInstances1__f_ibitmap$1 = false;
  this.Lshapeless3_deriving_internals_ErasedProductInstances1__f_mirror = mirror;
  this.Lshapeless3_deriving_internals_ErasedProductInstances1__f_i0 = i0;
}
export { $c_Lshapeless3_deriving_internals_ErasedProductInstances1 as $c_Lshapeless3_deriving_internals_ErasedProductInstances1 };
$c_Lshapeless3_deriving_internals_ErasedProductInstances1.prototype = new $h_Lshapeless3_deriving_internals_ErasedProductInstances();
$c_Lshapeless3_deriving_internals_ErasedProductInstances1.prototype.constructor = $c_Lshapeless3_deriving_internals_ErasedProductInstances1;
/** @constructor */
function $h_Lshapeless3_deriving_internals_ErasedProductInstances1() {
}
export { $h_Lshapeless3_deriving_internals_ErasedProductInstances1 as $h_Lshapeless3_deriving_internals_ErasedProductInstances1 };
$h_Lshapeless3_deriving_internals_ErasedProductInstances1.prototype = $c_Lshapeless3_deriving_internals_ErasedProductInstances1.prototype;
$c_Lshapeless3_deriving_internals_ErasedProductInstances1.prototype.erasedConstruct__F1__O = (function(f) {
  return $p_Lshapeless3_deriving_internals_ErasedProductInstances1__fromElement__O__O(this, f.apply__O__O($p_Lshapeless3_deriving_internals_ErasedProductInstances1__i__O(this)));
});
$c_Lshapeless3_deriving_internals_ErasedProductInstances1.prototype.erasedFoldLeft2__O__O__O__F4__O = (function(x, y, a, f) {
  var x15 = f.apply__O__O__O__O__O(a, $p_Lshapeless3_deriving_internals_ErasedProductInstances1__i__O(this), x.productElement__I__O(0), y.productElement__I__O(0));
  if ((x15 instanceof $c_Lshapeless3_deriving_Complete)) {
    var x18 = x15.Lshapeless3_deriving_Complete__f_t;
    return x18;
  }
  return x15;
});
$c_Lshapeless3_deriving_internals_ErasedProductInstances1.prototype.erasedProject__O__I__F2__O = (function(x, p, f) {
  return f.apply__O__O__O($p_Lshapeless3_deriving_internals_ErasedProductInstances1__i__O(this), x.productElement__I__O(0));
});
var $d_Lshapeless3_deriving_internals_ErasedProductInstances1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lshapeless3_deriving_internals_ErasedProductInstances1, "shapeless3.deriving.internals.ErasedProductInstances1", ({
  Lshapeless3_deriving_internals_ErasedProductInstances1: 1,
  Lshapeless3_deriving_internals_ErasedProductInstances: 1,
  Lshapeless3_deriving_internals_ErasedInstances: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lshapeless3_deriving_internals_ErasedProductInstances1 as $d_Lshapeless3_deriving_internals_ErasedProductInstances1 };
function $p_Lshapeless3_deriving_internals_ErasedProductInstancesN__is__AO($thiz) {
  if ((!$thiz.Lshapeless3_deriving_internals_ErasedProductInstancesN__f_isbitmap$1)) {
    $thiz.Lshapeless3_deriving_internals_ErasedProductInstancesN__f_is$lzy1 = $thiz.Lshapeless3_deriving_internals_ErasedProductInstancesN__f_is0.apply__O();
    $thiz.Lshapeless3_deriving_internals_ErasedProductInstancesN__f_isbitmap$1 = true;
    $thiz.Lshapeless3_deriving_internals_ErasedProductInstancesN__f_is0 = null;
  }
  return $thiz.Lshapeless3_deriving_internals_ErasedProductInstancesN__f_is$lzy1;
}
export { $p_Lshapeless3_deriving_internals_ErasedProductInstancesN__is__AO as $p_Lshapeless3_deriving_internals_ErasedProductInstancesN__is__AO };
function $p_Lshapeless3_deriving_internals_ErasedProductInstancesN__fromArray__AO__O($thiz, xs) {
  return $thiz.Lshapeless3_deriving_internals_ErasedProductInstancesN__f_mirror.fromProduct__s_Product__O(new $c_Lshapeless3_deriving_internals_ErasedProductInstances$ArrayProduct(xs));
}
export { $p_Lshapeless3_deriving_internals_ErasedProductInstancesN__fromArray__AO__O as $p_Lshapeless3_deriving_internals_ErasedProductInstancesN__fromArray__AO__O };
function $p_Lshapeless3_deriving_internals_ErasedProductInstancesN__fromEmptyProduct__O($thiz) {
  return $thiz.Lshapeless3_deriving_internals_ErasedProductInstancesN__f_mirror.fromProduct__s_Product__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
}
export { $p_Lshapeless3_deriving_internals_ErasedProductInstancesN__fromEmptyProduct__O as $p_Lshapeless3_deriving_internals_ErasedProductInstancesN__fromEmptyProduct__O };
function $p_Lshapeless3_deriving_internals_ErasedProductInstancesN__loop$4__I__F4__s_Product__s_Product__I__O__O($thiz, n$4, f$10, x$5, y$1, i, acc) {
  var acc$tailLocal4 = acc;
  var i$tailLocal4 = i;
  while (true) {
    if ((i$tailLocal4 >= n$4)) {
      return acc$tailLocal4;
    } else {
      var x45 = f$10.apply__O__O__O__O__O(acc$tailLocal4, $p_Lshapeless3_deriving_internals_ErasedProductInstancesN__is__AO($thiz).u[i$tailLocal4], x$5.productElement__I__O(i$tailLocal4), y$1.productElement__I__O(i$tailLocal4));
      if ((x45 instanceof $c_Lshapeless3_deriving_Complete)) {
        var x48 = x45.Lshapeless3_deriving_Complete__f_t;
        return x48;
      }
      var i$tailLocal4$tmp1 = ((1 + i$tailLocal4) | 0);
      i$tailLocal4 = i$tailLocal4$tmp1;
      acc$tailLocal4 = x45;
    }
  }
}
export { $p_Lshapeless3_deriving_internals_ErasedProductInstancesN__loop$4__I__F4__s_Product__s_Product__I__O__O as $p_Lshapeless3_deriving_internals_ErasedProductInstancesN__loop$4__I__F4__s_Product__s_Product__I__O__O };
/** @constructor */
function $c_Lshapeless3_deriving_internals_ErasedProductInstancesN(mirror, is0) {
  this.Lshapeless3_deriving_internals_ErasedProductInstancesN__f_mirror = null;
  this.Lshapeless3_deriving_internals_ErasedProductInstancesN__f_is0 = null;
  this.Lshapeless3_deriving_internals_ErasedProductInstancesN__f_is$lzy1 = null;
  this.Lshapeless3_deriving_internals_ErasedProductInstancesN__f_isbitmap$1 = false;
  this.Lshapeless3_deriving_internals_ErasedProductInstancesN__f_mirror = mirror;
  this.Lshapeless3_deriving_internals_ErasedProductInstancesN__f_is0 = is0;
}
export { $c_Lshapeless3_deriving_internals_ErasedProductInstancesN as $c_Lshapeless3_deriving_internals_ErasedProductInstancesN };
$c_Lshapeless3_deriving_internals_ErasedProductInstancesN.prototype = new $h_Lshapeless3_deriving_internals_ErasedProductInstances();
$c_Lshapeless3_deriving_internals_ErasedProductInstancesN.prototype.constructor = $c_Lshapeless3_deriving_internals_ErasedProductInstancesN;
/** @constructor */
function $h_Lshapeless3_deriving_internals_ErasedProductInstancesN() {
}
export { $h_Lshapeless3_deriving_internals_ErasedProductInstancesN as $h_Lshapeless3_deriving_internals_ErasedProductInstancesN };
$h_Lshapeless3_deriving_internals_ErasedProductInstancesN.prototype = $c_Lshapeless3_deriving_internals_ErasedProductInstancesN.prototype;
$c_Lshapeless3_deriving_internals_ErasedProductInstancesN.prototype.erasedConstruct__F1__O = (function(f) {
  var n = $p_Lshapeless3_deriving_internals_ErasedProductInstancesN__is__AO(this).u.length;
  if ((n === 0)) {
    return $p_Lshapeless3_deriving_internals_ErasedProductInstancesN__fromEmptyProduct__O(this);
  } else {
    var dimensions = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I(new Int32Array([n]));
    var arr = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_reflect_Array$().newInstance__jl_Class__AI__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_O.getClassOf(), dimensions);
    var i = 0;
    while ((i < n)) {
      arr.u[i] = f.apply__O__O($p_Lshapeless3_deriving_internals_ErasedProductInstancesN__is__AO(this).u[i]);
      i = ((1 + i) | 0);
    }
    return $p_Lshapeless3_deriving_internals_ErasedProductInstancesN__fromArray__AO__O(this, arr);
  }
});
$c_Lshapeless3_deriving_internals_ErasedProductInstancesN.prototype.erasedFoldLeft2__O__O__O__F4__O = (function(x0, y0, i, f) {
  var n = $p_Lshapeless3_deriving_internals_ErasedProductInstancesN__is__AO(this).u.length;
  return ((n === 0) ? i : $p_Lshapeless3_deriving_internals_ErasedProductInstancesN__loop$4__I__F4__s_Product__s_Product__I__O__O(this, n, f, x0, y0, 0, i));
});
$c_Lshapeless3_deriving_internals_ErasedProductInstancesN.prototype.erasedProject__O__I__F2__O = (function(x0, p, f) {
  return f.apply__O__O__O($p_Lshapeless3_deriving_internals_ErasedProductInstancesN__is__AO(this).u[p], x0.productElement__I__O(p));
});
var $d_Lshapeless3_deriving_internals_ErasedProductInstancesN = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lshapeless3_deriving_internals_ErasedProductInstancesN, "shapeless3.deriving.internals.ErasedProductInstancesN", ({
  Lshapeless3_deriving_internals_ErasedProductInstancesN: 1,
  Lshapeless3_deriving_internals_ErasedProductInstances: 1,
  Lshapeless3_deriving_internals_ErasedInstances: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lshapeless3_deriving_internals_ErasedProductInstancesN as $d_Lshapeless3_deriving_internals_ErasedProductInstancesN };
/** @constructor */
function $c_Lsttp_client3_ConditionalResponseAs(condition, responseAs) {
  this.Lsttp_client3_ConditionalResponseAs__f_condition = null;
  this.Lsttp_client3_ConditionalResponseAs__f_responseAs = null;
  this.Lsttp_client3_ConditionalResponseAs__f_condition = condition;
  this.Lsttp_client3_ConditionalResponseAs__f_responseAs = responseAs;
}
export { $c_Lsttp_client3_ConditionalResponseAs as $c_Lsttp_client3_ConditionalResponseAs };
$c_Lsttp_client3_ConditionalResponseAs.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_ConditionalResponseAs.prototype.constructor = $c_Lsttp_client3_ConditionalResponseAs;
/** @constructor */
function $h_Lsttp_client3_ConditionalResponseAs() {
}
export { $h_Lsttp_client3_ConditionalResponseAs as $h_Lsttp_client3_ConditionalResponseAs };
$h_Lsttp_client3_ConditionalResponseAs.prototype = $c_Lsttp_client3_ConditionalResponseAs.prototype;
$c_Lsttp_client3_ConditionalResponseAs.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_client3_ConditionalResponseAs.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lsttp_client3_ConditionalResponseAs.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_client3_ConditionalResponseAs)) {
    var x = this.Lsttp_client3_ConditionalResponseAs__f_condition;
    var x$2 = x$0.Lsttp_client3_ConditionalResponseAs__f_condition;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lsttp_client3_ConditionalResponseAs__f_responseAs;
      var x$4 = x$0.Lsttp_client3_ConditionalResponseAs__f_responseAs;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_client3_ConditionalResponseAs.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_client3_ConditionalResponseAs.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsttp_client3_ConditionalResponseAs.prototype.productPrefix__T = (function() {
  return "ConditionalResponseAs";
});
$c_Lsttp_client3_ConditionalResponseAs.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_client3_ConditionalResponseAs__f_condition;
  }
  if ((n === 1)) {
    return this.Lsttp_client3_ConditionalResponseAs__f_responseAs;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_client3_ConditionalResponseAs.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "condition";
  }
  if ((n === 1)) {
    return "responseAs";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_client3_ConditionalResponseAs(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_client3_ConditionalResponseAs)));
}
export { $isArrayOf_Lsttp_client3_ConditionalResponseAs as $isArrayOf_Lsttp_client3_ConditionalResponseAs };
var $d_Lsttp_client3_ConditionalResponseAs = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_ConditionalResponseAs, "sttp.client3.ConditionalResponseAs", ({
  Lsttp_client3_ConditionalResponseAs: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_client3_ConditionalResponseAs as $d_Lsttp_client3_ConditionalResponseAs };
/** @constructor */
function $c_Lsttp_client3_FetchOptions(credentials, mode) {
  this.Lsttp_client3_FetchOptions__f_credentials = null;
  this.Lsttp_client3_FetchOptions__f_mode = null;
  this.Lsttp_client3_FetchOptions__f_credentials = credentials;
  this.Lsttp_client3_FetchOptions__f_mode = mode;
}
export { $c_Lsttp_client3_FetchOptions as $c_Lsttp_client3_FetchOptions };
$c_Lsttp_client3_FetchOptions.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_FetchOptions.prototype.constructor = $c_Lsttp_client3_FetchOptions;
/** @constructor */
function $h_Lsttp_client3_FetchOptions() {
}
export { $h_Lsttp_client3_FetchOptions as $h_Lsttp_client3_FetchOptions };
$h_Lsttp_client3_FetchOptions.prototype = $c_Lsttp_client3_FetchOptions.prototype;
$c_Lsttp_client3_FetchOptions.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_client3_FetchOptions.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lsttp_client3_FetchOptions.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_client3_FetchOptions)) {
    var x = this.Lsttp_client3_FetchOptions__f_credentials;
    var x$2 = x$0.Lsttp_client3_FetchOptions__f_credentials;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lsttp_client3_FetchOptions__f_mode;
      var x$4 = x$0.Lsttp_client3_FetchOptions__f_mode;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_client3_FetchOptions.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_client3_FetchOptions.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsttp_client3_FetchOptions.prototype.productPrefix__T = (function() {
  return "FetchOptions";
});
$c_Lsttp_client3_FetchOptions.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_client3_FetchOptions__f_credentials;
  }
  if ((n === 1)) {
    return this.Lsttp_client3_FetchOptions__f_mode;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_client3_FetchOptions.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "credentials";
  }
  if ((n === 1)) {
    return "mode";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_client3_FetchOptions(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_client3_FetchOptions)));
}
export { $isArrayOf_Lsttp_client3_FetchOptions as $isArrayOf_Lsttp_client3_FetchOptions };
var $d_Lsttp_client3_FetchOptions = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_FetchOptions, "sttp.client3.FetchOptions", ({
  Lsttp_client3_FetchOptions: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_client3_FetchOptions as $d_Lsttp_client3_FetchOptions };
/** @constructor */
function $c_Lsttp_client3_RequestOptions(followRedirects, readTimeout, maxRedirects, redirectToGet) {
  this.Lsttp_client3_RequestOptions__f_followRedirects = false;
  this.Lsttp_client3_RequestOptions__f_readTimeout = null;
  this.Lsttp_client3_RequestOptions__f_maxRedirects = 0;
  this.Lsttp_client3_RequestOptions__f_redirectToGet = false;
  this.Lsttp_client3_RequestOptions__f_followRedirects = followRedirects;
  this.Lsttp_client3_RequestOptions__f_readTimeout = readTimeout;
  this.Lsttp_client3_RequestOptions__f_maxRedirects = maxRedirects;
  this.Lsttp_client3_RequestOptions__f_redirectToGet = redirectToGet;
}
export { $c_Lsttp_client3_RequestOptions as $c_Lsttp_client3_RequestOptions };
$c_Lsttp_client3_RequestOptions.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_RequestOptions.prototype.constructor = $c_Lsttp_client3_RequestOptions;
/** @constructor */
function $h_Lsttp_client3_RequestOptions() {
}
export { $h_Lsttp_client3_RequestOptions as $h_Lsttp_client3_RequestOptions };
$h_Lsttp_client3_RequestOptions.prototype = $c_Lsttp_client3_RequestOptions.prototype;
$c_Lsttp_client3_RequestOptions.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_client3_RequestOptions.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I("RequestOptions");
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lsttp_client3_RequestOptions__f_followRedirects ? 1231 : 1237);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lsttp_client3_RequestOptions__f_readTimeout;
  var data$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = this.Lsttp_client3_RequestOptions__f_maxRedirects;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var data$4 = (this.Lsttp_client3_RequestOptions__f_redirectToGet ? 1231 : 1237);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$5, 4);
});
$c_Lsttp_client3_RequestOptions.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_client3_RequestOptions)) {
    if ((((this.Lsttp_client3_RequestOptions__f_followRedirects === x$0.Lsttp_client3_RequestOptions__f_followRedirects) && (this.Lsttp_client3_RequestOptions__f_maxRedirects === x$0.Lsttp_client3_RequestOptions__f_maxRedirects)) && (this.Lsttp_client3_RequestOptions__f_redirectToGet === x$0.Lsttp_client3_RequestOptions__f_redirectToGet))) {
      var x = this.Lsttp_client3_RequestOptions__f_readTimeout;
      var x$2 = x$0.Lsttp_client3_RequestOptions__f_readTimeout;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_client3_RequestOptions.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_client3_RequestOptions.prototype.productArity__I = (function() {
  return 4;
});
$c_Lsttp_client3_RequestOptions.prototype.productPrefix__T = (function() {
  return "RequestOptions";
});
$c_Lsttp_client3_RequestOptions.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsttp_client3_RequestOptions__f_followRedirects;
      break;
    }
    case 1: {
      return this.Lsttp_client3_RequestOptions__f_readTimeout;
      break;
    }
    case 2: {
      return this.Lsttp_client3_RequestOptions__f_maxRedirects;
      break;
    }
    case 3: {
      return this.Lsttp_client3_RequestOptions__f_redirectToGet;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_client3_RequestOptions.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "followRedirects";
      break;
    }
    case 1: {
      return "readTimeout";
      break;
    }
    case 2: {
      return "maxRedirects";
      break;
    }
    case 3: {
      return "redirectToGet";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lsttp_client3_RequestOptions(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_client3_RequestOptions)));
}
export { $isArrayOf_Lsttp_client3_RequestOptions as $isArrayOf_Lsttp_client3_RequestOptions };
var $d_Lsttp_client3_RequestOptions = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_RequestOptions, "sttp.client3.RequestOptions", ({
  Lsttp_client3_RequestOptions: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_client3_RequestOptions as $d_Lsttp_client3_RequestOptions };
function $isArrayOf_Lsttp_client3_ResponseException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_client3_ResponseException)));
}
export { $isArrayOf_Lsttp_client3_ResponseException as $isArrayOf_Lsttp_client3_ResponseException };
function $ct_Lsttp_client3_SttpClientException__Lsttp_client3_RequestT__jl_Exception__($thiz, request, cause) {
  var message = ((("Exception when sending request: " + request.Lsttp_client3_RequestT__f_method) + " ") + request.Lsttp_client3_RequestT__f_uri);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, message, cause, true, true);
  return $thiz;
}
export { $ct_Lsttp_client3_SttpClientException__Lsttp_client3_RequestT__jl_Exception__ as $ct_Lsttp_client3_SttpClientException__Lsttp_client3_RequestT__jl_Exception__ };
class $c_Lsttp_client3_SttpClientException extends $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Exception {
}
export { $c_Lsttp_client3_SttpClientException as $c_Lsttp_client3_SttpClientException };
/** @constructor */
function $c_Lsttp_client3_impl_cats_CatsMonadAsyncError(F) {
  this.Lsttp_client3_impl_cats_CatsMonadError__f_F = null;
  $ct_Lsttp_client3_impl_cats_CatsMonadError__Lcats_effect_kernel_Sync__(this, F);
}
export { $c_Lsttp_client3_impl_cats_CatsMonadAsyncError as $c_Lsttp_client3_impl_cats_CatsMonadAsyncError };
$c_Lsttp_client3_impl_cats_CatsMonadAsyncError.prototype = new $h_Lsttp_client3_impl_cats_CatsMonadError();
$c_Lsttp_client3_impl_cats_CatsMonadAsyncError.prototype.constructor = $c_Lsttp_client3_impl_cats_CatsMonadAsyncError;
/** @constructor */
function $h_Lsttp_client3_impl_cats_CatsMonadAsyncError() {
}
export { $h_Lsttp_client3_impl_cats_CatsMonadAsyncError as $h_Lsttp_client3_impl_cats_CatsMonadAsyncError };
$h_Lsttp_client3_impl_cats_CatsMonadAsyncError.prototype = $c_Lsttp_client3_impl_cats_CatsMonadAsyncError.prototype;
var $d_Lsttp_client3_impl_cats_CatsMonadAsyncError = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_impl_cats_CatsMonadAsyncError, "sttp.client3.impl.cats.CatsMonadAsyncError", ({
  Lsttp_client3_impl_cats_CatsMonadAsyncError: 1,
  Lsttp_client3_impl_cats_CatsMonadError: 1,
  Lsttp_monad_MonadError: 1,
  Lsttp_monad_MonadAsyncError: 1
}));
export { $d_Lsttp_client3_impl_cats_CatsMonadAsyncError as $d_Lsttp_client3_impl_cats_CatsMonadAsyncError };
/** @constructor */
function $c_Lsttp_client3_package$() {
  this.Lsttp_client3_package$__f_DefaultReadTimeout = null;
  this.Lsttp_client3_package$__f_emptyRequest = null;
  this.Lsttp_client3_package$__f_basicRequest = null;
  $n_Lsttp_client3_package$ = this;
  $f_Lsttp_client3_SttpApi__$init$__V(this);
}
export { $c_Lsttp_client3_package$ as $c_Lsttp_client3_package$ };
$c_Lsttp_client3_package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_package$.prototype.constructor = $c_Lsttp_client3_package$;
/** @constructor */
function $h_Lsttp_client3_package$() {
}
export { $h_Lsttp_client3_package$ as $h_Lsttp_client3_package$ };
$h_Lsttp_client3_package$.prototype = $c_Lsttp_client3_package$.prototype;
var $d_Lsttp_client3_package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_package$, "sttp.client3.package$", ({
  Lsttp_client3_package$: 1,
  Lsttp_client3_SttpExtensions: 1,
  Lsttp_model_UriInterpolator: 1,
  Lsttp_client3_SttpApi: 1
}));
export { $d_Lsttp_client3_package$ as $d_Lsttp_client3_package$ };
var $n_Lsttp_client3_package$;
function $m_Lsttp_client3_package$() {
  if ((!$n_Lsttp_client3_package$)) {
    $n_Lsttp_client3_package$ = new $c_Lsttp_client3_package$();
  }
  return $n_Lsttp_client3_package$;
}
export { $m_Lsttp_client3_package$ as $m_Lsttp_client3_package$ };
class $c_Lsttp_client3_ws_GotAWebSocketException extends $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Exception {
  constructor() {
    super();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, "Got a web socket, but expected normal content", null, true, true);
  }
}
export { $c_Lsttp_client3_ws_GotAWebSocketException as $c_Lsttp_client3_ws_GotAWebSocketException };
function $isArrayOf_Lsttp_client3_ws_GotAWebSocketException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_client3_ws_GotAWebSocketException)));
}
export { $isArrayOf_Lsttp_client3_ws_GotAWebSocketException as $isArrayOf_Lsttp_client3_ws_GotAWebSocketException };
var $d_Lsttp_client3_ws_GotAWebSocketException = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_ws_GotAWebSocketException, "sttp.client3.ws.GotAWebSocketException", ({
  Lsttp_client3_ws_GotAWebSocketException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_client3_ws_GotAWebSocketException as $d_Lsttp_client3_ws_GotAWebSocketException };
class $c_Lsttp_client3_ws_NotAWebSocketException extends $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Exception {
  constructor(statusCode) {
    super();
    var s = ("Not a web socket; got response code: " + new $c_Lsttp_model_StatusCode(statusCode));
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true);
  }
}
export { $c_Lsttp_client3_ws_NotAWebSocketException as $c_Lsttp_client3_ws_NotAWebSocketException };
function $isArrayOf_Lsttp_client3_ws_NotAWebSocketException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_client3_ws_NotAWebSocketException)));
}
export { $isArrayOf_Lsttp_client3_ws_NotAWebSocketException as $isArrayOf_Lsttp_client3_ws_NotAWebSocketException };
var $d_Lsttp_client3_ws_NotAWebSocketException = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_ws_NotAWebSocketException, "sttp.client3.ws.NotAWebSocketException", ({
  Lsttp_client3_ws_NotAWebSocketException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_client3_ws_NotAWebSocketException as $d_Lsttp_client3_ws_NotAWebSocketException };
/** @constructor */
function $c_Lsttp_model_Method(method) {
  this.Lsttp_model_Method__f_method = null;
  this.Lsttp_model_Method__f_method = method;
}
export { $c_Lsttp_model_Method as $c_Lsttp_model_Method };
$c_Lsttp_model_Method.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_model_Method.prototype.constructor = $c_Lsttp_model_Method;
/** @constructor */
function $h_Lsttp_model_Method() {
}
export { $h_Lsttp_model_Method as $h_Lsttp_model_Method };
$h_Lsttp_model_Method.prototype = $c_Lsttp_model_Method.prototype;
$c_Lsttp_model_Method.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_model_Method.prototype.hashCode__I = (function() {
  $m_Lsttp_model_Method$();
  var this$ = this.Lsttp_model_Method__f_method;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I(this$);
});
$c_Lsttp_model_Method.prototype.equals__O__Z = (function(x$0) {
  return $m_Lsttp_model_Method$().equals$extension__T__O__Z(this.Lsttp_model_Method__f_method, x$0);
});
$c_Lsttp_model_Method.prototype.productArity__I = (function() {
  $m_Lsttp_model_Method$();
  return 1;
});
$c_Lsttp_model_Method.prototype.productPrefix__T = (function() {
  $m_Lsttp_model_Method$();
  return "Method";
});
$c_Lsttp_model_Method.prototype.productElement__I__O = (function(n) {
  return $m_Lsttp_model_Method$().productElement$extension__T__I__O(this.Lsttp_model_Method__f_method, n);
});
$c_Lsttp_model_Method.prototype.productElementName__I__T = (function(n) {
  return $m_Lsttp_model_Method$().productElementName$extension__T__I__T(this.Lsttp_model_Method__f_method, n);
});
$c_Lsttp_model_Method.prototype.toString__T = (function() {
  $m_Lsttp_model_Method$();
  var this$ = this.Lsttp_model_Method__f_method;
  return this$;
});
function $isArrayOf_Lsttp_model_Method(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_model_Method)));
}
export { $isArrayOf_Lsttp_model_Method as $isArrayOf_Lsttp_model_Method };
var $d_Lsttp_model_Method = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_model_Method, "sttp.model.Method", ({
  Lsttp_model_Method: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_model_Method as $d_Lsttp_model_Method };
/** @constructor */
function $c_Lsttp_model_StatusText(text) {
  this.Lsttp_model_StatusText__f_text = null;
  this.Lsttp_model_StatusText__f_text = text;
}
export { $c_Lsttp_model_StatusText as $c_Lsttp_model_StatusText };
$c_Lsttp_model_StatusText.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_model_StatusText.prototype.constructor = $c_Lsttp_model_StatusText;
/** @constructor */
function $h_Lsttp_model_StatusText() {
}
export { $h_Lsttp_model_StatusText as $h_Lsttp_model_StatusText };
$h_Lsttp_model_StatusText.prototype = $c_Lsttp_model_StatusText.prototype;
$c_Lsttp_model_StatusText.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_model_StatusText.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 50447082, true);
});
$c_Lsttp_model_StatusText.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lsttp_model_StatusText) && (this.Lsttp_model_StatusText__f_text === x$0.Lsttp_model_StatusText__f_text)));
});
$c_Lsttp_model_StatusText.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_model_StatusText.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_model_StatusText.prototype.productPrefix__T = (function() {
  return "StatusText";
});
$c_Lsttp_model_StatusText.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_model_StatusText__f_text;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_StatusText.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "text";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_model_StatusText(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_model_StatusText)));
}
export { $isArrayOf_Lsttp_model_StatusText as $isArrayOf_Lsttp_model_StatusText };
var $d_Lsttp_model_StatusText = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_model_StatusText, "sttp.model.StatusText", ({
  Lsttp_model_StatusText: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_model_StatusText as $d_Lsttp_model_StatusText };
/** @constructor */
function $c_Lsttp_model_headers_WWWAuthenticateChallenge(scheme, params) {
  this.Lsttp_model_headers_WWWAuthenticateChallenge__f_scheme = null;
  this.Lsttp_model_headers_WWWAuthenticateChallenge__f_params = null;
  this.Lsttp_model_headers_WWWAuthenticateChallenge__f_scheme = scheme;
  this.Lsttp_model_headers_WWWAuthenticateChallenge__f_params = params;
}
export { $c_Lsttp_model_headers_WWWAuthenticateChallenge as $c_Lsttp_model_headers_WWWAuthenticateChallenge };
$c_Lsttp_model_headers_WWWAuthenticateChallenge.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_model_headers_WWWAuthenticateChallenge.prototype.constructor = $c_Lsttp_model_headers_WWWAuthenticateChallenge;
/** @constructor */
function $h_Lsttp_model_headers_WWWAuthenticateChallenge() {
}
export { $h_Lsttp_model_headers_WWWAuthenticateChallenge as $h_Lsttp_model_headers_WWWAuthenticateChallenge };
$h_Lsttp_model_headers_WWWAuthenticateChallenge.prototype = $c_Lsttp_model_headers_WWWAuthenticateChallenge.prototype;
$c_Lsttp_model_headers_WWWAuthenticateChallenge.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_model_headers_WWWAuthenticateChallenge.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1126892270, true);
});
$c_Lsttp_model_headers_WWWAuthenticateChallenge.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_model_headers_WWWAuthenticateChallenge)) {
    if ((this.Lsttp_model_headers_WWWAuthenticateChallenge__f_scheme === x$0.Lsttp_model_headers_WWWAuthenticateChallenge__f_scheme)) {
      var x = this.Lsttp_model_headers_WWWAuthenticateChallenge__f_params;
      var x$2 = x$0.Lsttp_model_headers_WWWAuthenticateChallenge__f_params;
      return ((x === null) ? (x$2 === null) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_Map__equals__O__Z(x, x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_model_headers_WWWAuthenticateChallenge.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsttp_model_headers_WWWAuthenticateChallenge.prototype.productPrefix__T = (function() {
  return "WWWAuthenticateChallenge";
});
$c_Lsttp_model_headers_WWWAuthenticateChallenge.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_model_headers_WWWAuthenticateChallenge__f_scheme;
  }
  if ((n === 1)) {
    return this.Lsttp_model_headers_WWWAuthenticateChallenge__f_params;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_WWWAuthenticateChallenge.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "scheme";
  }
  if ((n === 1)) {
    return "params";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_WWWAuthenticateChallenge.prototype.toString__T = (function() {
  var this$1 = this.Lsttp_model_headers_WWWAuthenticateChallenge__f_params;
  if ((!this$1.isEmpty__Z())) {
    var sb = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_StringBuilder__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_StringBuilder());
    var str = this.Lsttp_model_headers_WWWAuthenticateChallenge__f_scheme;
    sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
    sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + " ");
    var elem = false;
    elem = false;
    var this$4 = this.Lsttp_model_headers_WWWAuthenticateChallenge__f_params;
    var it = this$4.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var x0 = it.next__O();
      matchResult4: {
        if ((x0 !== null)) {
          var k = x0._1__O();
          var v = x0._2__O();
          if (elem) {
            sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + ", ");
          }
          sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + k);
          sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + "=\"");
          sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + v);
          sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + "\"");
          elem = true;
          break matchResult4;
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x0);
      }
    }
    return sb.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  } else {
    return this.Lsttp_model_headers_WWWAuthenticateChallenge__f_scheme;
  }
});
function $isArrayOf_Lsttp_model_headers_WWWAuthenticateChallenge(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_model_headers_WWWAuthenticateChallenge)));
}
export { $isArrayOf_Lsttp_model_headers_WWWAuthenticateChallenge as $isArrayOf_Lsttp_model_headers_WWWAuthenticateChallenge };
var $d_Lsttp_model_headers_WWWAuthenticateChallenge = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_model_headers_WWWAuthenticateChallenge, "sttp.model.headers.WWWAuthenticateChallenge", ({
  Lsttp_model_headers_WWWAuthenticateChallenge: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_model_headers_WWWAuthenticateChallenge as $d_Lsttp_model_headers_WWWAuthenticateChallenge };
/** @constructor */
function $c_Lsttp_tapir_DecodeResult$Error$JsonError(msg, path) {
  this.Lsttp_tapir_DecodeResult$Error$JsonError__f_msg = null;
  this.Lsttp_tapir_DecodeResult$Error$JsonError__f_path = null;
  this.Lsttp_tapir_DecodeResult$Error$JsonError__f_msg = msg;
  this.Lsttp_tapir_DecodeResult$Error$JsonError__f_path = path;
}
export { $c_Lsttp_tapir_DecodeResult$Error$JsonError as $c_Lsttp_tapir_DecodeResult$Error$JsonError };
$c_Lsttp_tapir_DecodeResult$Error$JsonError.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_DecodeResult$Error$JsonError.prototype.constructor = $c_Lsttp_tapir_DecodeResult$Error$JsonError;
/** @constructor */
function $h_Lsttp_tapir_DecodeResult$Error$JsonError() {
}
export { $h_Lsttp_tapir_DecodeResult$Error$JsonError as $h_Lsttp_tapir_DecodeResult$Error$JsonError };
$h_Lsttp_tapir_DecodeResult$Error$JsonError.prototype = $c_Lsttp_tapir_DecodeResult$Error$JsonError.prototype;
$c_Lsttp_tapir_DecodeResult$Error$JsonError.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_DecodeResult$Error$JsonError.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 869570884, true);
});
$c_Lsttp_tapir_DecodeResult$Error$JsonError.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_DecodeResult$Error$JsonError)) {
    if ((this.Lsttp_tapir_DecodeResult$Error$JsonError__f_msg === x$0.Lsttp_tapir_DecodeResult$Error$JsonError__f_msg)) {
      var x = this.Lsttp_tapir_DecodeResult$Error$JsonError__f_path;
      var x$2 = x$0.Lsttp_tapir_DecodeResult$Error$JsonError__f_path;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_DecodeResult$Error$JsonError.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_DecodeResult$Error$JsonError.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsttp_tapir_DecodeResult$Error$JsonError.prototype.productPrefix__T = (function() {
  return "JsonError";
});
$c_Lsttp_tapir_DecodeResult$Error$JsonError.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_DecodeResult$Error$JsonError__f_msg;
  }
  if ((n === 1)) {
    return this.Lsttp_tapir_DecodeResult$Error$JsonError__f_path;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_DecodeResult$Error$JsonError.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "msg";
  }
  if ((n === 1)) {
    return "path";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_tapir_DecodeResult$Error$JsonError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_DecodeResult$Error$JsonError)));
}
export { $isArrayOf_Lsttp_tapir_DecodeResult$Error$JsonError as $isArrayOf_Lsttp_tapir_DecodeResult$Error$JsonError };
var $d_Lsttp_tapir_DecodeResult$Error$JsonError = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_DecodeResult$Error$JsonError, "sttp.tapir.DecodeResult$Error$JsonError", ({
  Lsttp_tapir_DecodeResult$Error$JsonError: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_DecodeResult$Error$JsonError as $d_Lsttp_tapir_DecodeResult$Error$JsonError };
/** @constructor */
function $c_Lsttp_tapir_EndpointIO$Example(value, name, summary, description) {
  this.Lsttp_tapir_EndpointIO$Example__f_value = null;
  this.Lsttp_tapir_EndpointIO$Example__f_name = null;
  this.Lsttp_tapir_EndpointIO$Example__f_summary = null;
  this.Lsttp_tapir_EndpointIO$Example__f_description = null;
  this.Lsttp_tapir_EndpointIO$Example__f_value = value;
  this.Lsttp_tapir_EndpointIO$Example__f_name = name;
  this.Lsttp_tapir_EndpointIO$Example__f_summary = summary;
  this.Lsttp_tapir_EndpointIO$Example__f_description = description;
}
export { $c_Lsttp_tapir_EndpointIO$Example as $c_Lsttp_tapir_EndpointIO$Example };
$c_Lsttp_tapir_EndpointIO$Example.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_EndpointIO$Example.prototype.constructor = $c_Lsttp_tapir_EndpointIO$Example;
/** @constructor */
function $h_Lsttp_tapir_EndpointIO$Example() {
}
export { $h_Lsttp_tapir_EndpointIO$Example as $h_Lsttp_tapir_EndpointIO$Example };
$h_Lsttp_tapir_EndpointIO$Example.prototype = $c_Lsttp_tapir_EndpointIO$Example.prototype;
$c_Lsttp_tapir_EndpointIO$Example.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_EndpointIO$Example.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1309886510), true);
});
$c_Lsttp_tapir_EndpointIO$Example.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_EndpointIO$Example)) {
    var x = this.Lsttp_tapir_EndpointIO$Example__f_value;
    var y = x$0.Lsttp_tapir_EndpointIO$Example__f_value;
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Lsttp_tapir_EndpointIO$Example__f_name;
      var x$2 = x$0.Lsttp_tapir_EndpointIO$Example__f_name;
      var $x_2 = ((x$1 === null) ? (x$2 === null) : x$1.equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Lsttp_tapir_EndpointIO$Example__f_summary;
      var x$4 = x$0.Lsttp_tapir_EndpointIO$Example__f_summary;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Lsttp_tapir_EndpointIO$Example__f_description;
      var x$6 = x$0.Lsttp_tapir_EndpointIO$Example__f_description;
      return ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_EndpointIO$Example.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_EndpointIO$Example.prototype.productArity__I = (function() {
  return 4;
});
$c_Lsttp_tapir_EndpointIO$Example.prototype.productPrefix__T = (function() {
  return "Example";
});
$c_Lsttp_tapir_EndpointIO$Example.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsttp_tapir_EndpointIO$Example__f_value;
      break;
    }
    case 1: {
      return this.Lsttp_tapir_EndpointIO$Example__f_name;
      break;
    }
    case 2: {
      return this.Lsttp_tapir_EndpointIO$Example__f_summary;
      break;
    }
    case 3: {
      return this.Lsttp_tapir_EndpointIO$Example__f_description;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_EndpointIO$Example.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "value";
      break;
    }
    case 1: {
      return "name";
      break;
    }
    case 2: {
      return "summary";
      break;
    }
    case 3: {
      return "description";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lsttp_tapir_EndpointIO$Example(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointIO$Example)));
}
export { $isArrayOf_Lsttp_tapir_EndpointIO$Example as $isArrayOf_Lsttp_tapir_EndpointIO$Example };
var $d_Lsttp_tapir_EndpointIO$Example = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_EndpointIO$Example, "sttp.tapir.EndpointIO$Example", ({
  Lsttp_tapir_EndpointIO$Example: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_EndpointIO$Example as $d_Lsttp_tapir_EndpointIO$Example };
/** @constructor */
function $c_Lsttp_tapir_EndpointIO$Info(description, examples, deprecated, attributes) {
  this.Lsttp_tapir_EndpointIO$Info__f_description = null;
  this.Lsttp_tapir_EndpointIO$Info__f_examples = null;
  this.Lsttp_tapir_EndpointIO$Info__f_deprecated = false;
  this.Lsttp_tapir_EndpointIO$Info__f_attributes = null;
  this.Lsttp_tapir_EndpointIO$Info__f_description = description;
  this.Lsttp_tapir_EndpointIO$Info__f_examples = examples;
  this.Lsttp_tapir_EndpointIO$Info__f_deprecated = deprecated;
  this.Lsttp_tapir_EndpointIO$Info__f_attributes = attributes;
}
export { $c_Lsttp_tapir_EndpointIO$Info as $c_Lsttp_tapir_EndpointIO$Info };
$c_Lsttp_tapir_EndpointIO$Info.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_EndpointIO$Info.prototype.constructor = $c_Lsttp_tapir_EndpointIO$Info;
/** @constructor */
function $h_Lsttp_tapir_EndpointIO$Info() {
}
export { $h_Lsttp_tapir_EndpointIO$Info as $h_Lsttp_tapir_EndpointIO$Info };
$h_Lsttp_tapir_EndpointIO$Info.prototype = $c_Lsttp_tapir_EndpointIO$Info.prototype;
$c_Lsttp_tapir_EndpointIO$Info.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_EndpointIO$Info.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, 2283726);
  var hash$1 = acc;
  var x = this.Lsttp_tapir_EndpointIO$Info__f_description;
  var data = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data);
  var hash$2 = acc;
  var x$1 = this.Lsttp_tapir_EndpointIO$Info__f_examples;
  var data$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$1);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$2, data$1);
  var hash$3 = acc;
  var data$2 = (this.Lsttp_tapir_EndpointIO$Info__f_deprecated ? 1231 : 1237);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$3, data$2);
  var hash$4 = acc;
  var x$2 = this.Lsttp_tapir_EndpointIO$Info__f_attributes;
  var data$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$2);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$4, data$3);
  var hash$5 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$5, 4);
});
$c_Lsttp_tapir_EndpointIO$Info.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_EndpointIO$Info)) {
    if ((this.Lsttp_tapir_EndpointIO$Info__f_deprecated === x$0.Lsttp_tapir_EndpointIO$Info__f_deprecated)) {
      var x = this.Lsttp_tapir_EndpointIO$Info__f_description;
      var x$2 = x$0.Lsttp_tapir_EndpointIO$Info__f_description;
      var $x_2 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Lsttp_tapir_EndpointIO$Info__f_examples;
      var x$4 = x$0.Lsttp_tapir_EndpointIO$Info__f_examples;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Lsttp_tapir_EndpointIO$Info__f_attributes;
      var x$6 = x$0.Lsttp_tapir_EndpointIO$Info__f_attributes;
      return ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_EndpointIO$Info.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_EndpointIO$Info.prototype.productArity__I = (function() {
  return 4;
});
$c_Lsttp_tapir_EndpointIO$Info.prototype.productPrefix__T = (function() {
  return "Info";
});
$c_Lsttp_tapir_EndpointIO$Info.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsttp_tapir_EndpointIO$Info__f_description;
      break;
    }
    case 1: {
      return this.Lsttp_tapir_EndpointIO$Info__f_examples;
      break;
    }
    case 2: {
      return this.Lsttp_tapir_EndpointIO$Info__f_deprecated;
      break;
    }
    case 3: {
      return this.Lsttp_tapir_EndpointIO$Info__f_attributes;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_EndpointIO$Info.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "description";
      break;
    }
    case 1: {
      return "examples";
      break;
    }
    case 2: {
      return "deprecated";
      break;
    }
    case 3: {
      return "attributes";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_EndpointIO$Info.prototype.attribute__Lsttp_tapir_AttributeKey__O__Lsttp_tapir_EndpointIO$Info = (function(k, v) {
  var attributes$6 = this.Lsttp_tapir_EndpointIO$Info__f_attributes.put__Lsttp_tapir_AttributeKey__O__Lsttp_tapir_AttributeMap(k, v);
  var description$9 = this.Lsttp_tapir_EndpointIO$Info__f_description;
  var examples$2 = this.Lsttp_tapir_EndpointIO$Info__f_examples;
  var deprecated$2 = this.Lsttp_tapir_EndpointIO$Info__f_deprecated;
  return new $c_Lsttp_tapir_EndpointIO$Info(description$9, examples$2, deprecated$2, attributes$6);
});
$c_Lsttp_tapir_EndpointIO$Info.prototype.map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointIO$Info = (function(codec) {
  var description$1 = this.Lsttp_tapir_EndpointIO$Info__f_description;
  var this$2 = this.Lsttp_tapir_EndpointIO$Info__f_examples;
  var f = ((e) => {
    var value = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lsttp_tapir_Mapping__decode__O__Lsttp_tapir_DecodeResult(codec, e.Lsttp_tapir_EndpointIO$Example__f_value);
    var name = e.Lsttp_tapir_EndpointIO$Example__f_name;
    var summary = e.Lsttp_tapir_EndpointIO$Example__f_summary;
    var description = e.Lsttp_tapir_EndpointIO$Example__f_description;
    return new $c_Lsttp_tapir_EndpointIO$Example(value, name, summary, description);
  });
  if ((this$2 === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  } else {
    var x0 = this$2.head__O();
    var h = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
    var t = h;
    var rest = this$2.tail__O();
    while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
      var x0$1 = rest.head__O();
      var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0$1), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      t.sci_$colon$colon__f_next = nx;
      t = nx;
      rest = rest.tail__O();
    }
    var $x_1 = h;
  }
  var examples = $x_1.collect__s_PartialFunction__sci_List(new $c_Lsttp_tapir_EndpointIO$Info$$anon$2());
  var deprecated = this.Lsttp_tapir_EndpointIO$Info__f_deprecated;
  var attributes = this.Lsttp_tapir_EndpointIO$Info__f_attributes;
  return new $c_Lsttp_tapir_EndpointIO$Info(description$1, examples, deprecated, attributes);
});
function $isArrayOf_Lsttp_tapir_EndpointIO$Info(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointIO$Info)));
}
export { $isArrayOf_Lsttp_tapir_EndpointIO$Info as $isArrayOf_Lsttp_tapir_EndpointIO$Info };
var $d_Lsttp_tapir_EndpointIO$Info = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_EndpointIO$Info, "sttp.tapir.EndpointIO$Info", ({
  Lsttp_tapir_EndpointIO$Info: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_EndpointIO$Info as $d_Lsttp_tapir_EndpointIO$Info };
/** @constructor */
function $c_Lsttp_tapir_EndpointInfo(name, summary, description, tags, deprecated, attributes) {
  this.Lsttp_tapir_EndpointInfo__f_name = null;
  this.Lsttp_tapir_EndpointInfo__f_summary = null;
  this.Lsttp_tapir_EndpointInfo__f_description = null;
  this.Lsttp_tapir_EndpointInfo__f_tags = null;
  this.Lsttp_tapir_EndpointInfo__f_deprecated = false;
  this.Lsttp_tapir_EndpointInfo__f_attributes = null;
  this.Lsttp_tapir_EndpointInfo__f_name = name;
  this.Lsttp_tapir_EndpointInfo__f_summary = summary;
  this.Lsttp_tapir_EndpointInfo__f_description = description;
  this.Lsttp_tapir_EndpointInfo__f_tags = tags;
  this.Lsttp_tapir_EndpointInfo__f_deprecated = deprecated;
  this.Lsttp_tapir_EndpointInfo__f_attributes = attributes;
}
export { $c_Lsttp_tapir_EndpointInfo as $c_Lsttp_tapir_EndpointInfo };
$c_Lsttp_tapir_EndpointInfo.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_EndpointInfo.prototype.constructor = $c_Lsttp_tapir_EndpointInfo;
/** @constructor */
function $h_Lsttp_tapir_EndpointInfo() {
}
export { $h_Lsttp_tapir_EndpointInfo as $h_Lsttp_tapir_EndpointInfo };
$h_Lsttp_tapir_EndpointInfo.prototype = $c_Lsttp_tapir_EndpointInfo.prototype;
$c_Lsttp_tapir_EndpointInfo.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_EndpointInfo.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, (-686655485));
  var hash$1 = acc;
  var x = this.Lsttp_tapir_EndpointInfo__f_name;
  var data = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data);
  var hash$2 = acc;
  var x$1 = this.Lsttp_tapir_EndpointInfo__f_summary;
  var data$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$1);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$2, data$1);
  var hash$3 = acc;
  var x$2 = this.Lsttp_tapir_EndpointInfo__f_description;
  var data$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$2);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$3, data$2);
  var hash$4 = acc;
  var x$3 = this.Lsttp_tapir_EndpointInfo__f_tags;
  var data$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$3);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$4, data$3);
  var hash$5 = acc;
  var data$4 = (this.Lsttp_tapir_EndpointInfo__f_deprecated ? 1231 : 1237);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$5, data$4);
  var hash$6 = acc;
  var x$4 = this.Lsttp_tapir_EndpointInfo__f_attributes;
  var data$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$4);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$6, data$5);
  var hash$7 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$7, 6);
});
$c_Lsttp_tapir_EndpointInfo.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_EndpointInfo)) {
    if ((this.Lsttp_tapir_EndpointInfo__f_deprecated === x$0.Lsttp_tapir_EndpointInfo__f_deprecated)) {
      var x = this.Lsttp_tapir_EndpointInfo__f_name;
      var x$2 = x$0.Lsttp_tapir_EndpointInfo__f_name;
      var $x_4 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$3 = this.Lsttp_tapir_EndpointInfo__f_summary;
      var x$4 = x$0.Lsttp_tapir_EndpointInfo__f_summary;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.Lsttp_tapir_EndpointInfo__f_description;
      var x$6 = x$0.Lsttp_tapir_EndpointInfo__f_description;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.Lsttp_tapir_EndpointInfo__f_tags;
      var x$8 = x$0.Lsttp_tapir_EndpointInfo__f_tags;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : x$7.equals__O__Z(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$9 = this.Lsttp_tapir_EndpointInfo__f_attributes;
      var x$10 = x$0.Lsttp_tapir_EndpointInfo__f_attributes;
      return ((x$9 === null) ? (x$10 === null) : x$9.equals__O__Z(x$10));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_EndpointInfo.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_EndpointInfo.prototype.productArity__I = (function() {
  return 6;
});
$c_Lsttp_tapir_EndpointInfo.prototype.productPrefix__T = (function() {
  return "EndpointInfo";
});
$c_Lsttp_tapir_EndpointInfo.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsttp_tapir_EndpointInfo__f_name;
      break;
    }
    case 1: {
      return this.Lsttp_tapir_EndpointInfo__f_summary;
      break;
    }
    case 2: {
      return this.Lsttp_tapir_EndpointInfo__f_description;
      break;
    }
    case 3: {
      return this.Lsttp_tapir_EndpointInfo__f_tags;
      break;
    }
    case 4: {
      return this.Lsttp_tapir_EndpointInfo__f_deprecated;
      break;
    }
    case 5: {
      return this.Lsttp_tapir_EndpointInfo__f_attributes;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_EndpointInfo.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "name";
      break;
    }
    case 1: {
      return "summary";
      break;
    }
    case 2: {
      return "description";
      break;
    }
    case 3: {
      return "tags";
      break;
    }
    case 4: {
      return "deprecated";
      break;
    }
    case 5: {
      return "attributes";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lsttp_tapir_EndpointInfo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointInfo)));
}
export { $isArrayOf_Lsttp_tapir_EndpointInfo as $isArrayOf_Lsttp_tapir_EndpointInfo };
var $d_Lsttp_tapir_EndpointInfo = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_EndpointInfo, "sttp.tapir.EndpointInfo", ({
  Lsttp_tapir_EndpointInfo: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_EndpointInfo as $d_Lsttp_tapir_EndpointInfo };
/** @constructor */
function $c_Lsttp_tapir_EndpointInput$AuthInfo(securitySchemeName, description, attributes, group, bearerFormat) {
  this.Lsttp_tapir_EndpointInput$AuthInfo__f_securitySchemeName = null;
  this.Lsttp_tapir_EndpointInput$AuthInfo__f_description = null;
  this.Lsttp_tapir_EndpointInput$AuthInfo__f_attributes = null;
  this.Lsttp_tapir_EndpointInput$AuthInfo__f_group = null;
  this.Lsttp_tapir_EndpointInput$AuthInfo__f_bearerFormat = null;
  this.Lsttp_tapir_EndpointInput$AuthInfo__f_securitySchemeName = securitySchemeName;
  this.Lsttp_tapir_EndpointInput$AuthInfo__f_description = description;
  this.Lsttp_tapir_EndpointInput$AuthInfo__f_attributes = attributes;
  this.Lsttp_tapir_EndpointInput$AuthInfo__f_group = group;
  this.Lsttp_tapir_EndpointInput$AuthInfo__f_bearerFormat = bearerFormat;
}
export { $c_Lsttp_tapir_EndpointInput$AuthInfo as $c_Lsttp_tapir_EndpointInput$AuthInfo };
$c_Lsttp_tapir_EndpointInput$AuthInfo.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_EndpointInput$AuthInfo.prototype.constructor = $c_Lsttp_tapir_EndpointInput$AuthInfo;
/** @constructor */
function $h_Lsttp_tapir_EndpointInput$AuthInfo() {
}
export { $h_Lsttp_tapir_EndpointInput$AuthInfo as $h_Lsttp_tapir_EndpointInput$AuthInfo };
$h_Lsttp_tapir_EndpointInput$AuthInfo.prototype = $c_Lsttp_tapir_EndpointInput$AuthInfo.prototype;
$c_Lsttp_tapir_EndpointInput$AuthInfo.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_EndpointInput$AuthInfo.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-638327922), true);
});
$c_Lsttp_tapir_EndpointInput$AuthInfo.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_EndpointInput$AuthInfo)) {
    var x = this.Lsttp_tapir_EndpointInput$AuthInfo__f_securitySchemeName;
    var x$2 = x$0.Lsttp_tapir_EndpointInput$AuthInfo__f_securitySchemeName;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lsttp_tapir_EndpointInput$AuthInfo__f_description;
      var x$4 = x$0.Lsttp_tapir_EndpointInput$AuthInfo__f_description;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.Lsttp_tapir_EndpointInput$AuthInfo__f_attributes;
      var x$6 = x$0.Lsttp_tapir_EndpointInput$AuthInfo__f_attributes;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.Lsttp_tapir_EndpointInput$AuthInfo__f_group;
      var x$8 = x$0.Lsttp_tapir_EndpointInput$AuthInfo__f_group;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : x$7.equals__O__Z(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$9 = this.Lsttp_tapir_EndpointInput$AuthInfo__f_bearerFormat;
      var x$10 = x$0.Lsttp_tapir_EndpointInput$AuthInfo__f_bearerFormat;
      return ((x$9 === null) ? (x$10 === null) : x$9.equals__O__Z(x$10));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_EndpointInput$AuthInfo.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_EndpointInput$AuthInfo.prototype.productArity__I = (function() {
  return 5;
});
$c_Lsttp_tapir_EndpointInput$AuthInfo.prototype.productPrefix__T = (function() {
  return "AuthInfo";
});
$c_Lsttp_tapir_EndpointInput$AuthInfo.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsttp_tapir_EndpointInput$AuthInfo__f_securitySchemeName;
      break;
    }
    case 1: {
      return this.Lsttp_tapir_EndpointInput$AuthInfo__f_description;
      break;
    }
    case 2: {
      return this.Lsttp_tapir_EndpointInput$AuthInfo__f_attributes;
      break;
    }
    case 3: {
      return this.Lsttp_tapir_EndpointInput$AuthInfo__f_group;
      break;
    }
    case 4: {
      return this.Lsttp_tapir_EndpointInput$AuthInfo__f_bearerFormat;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_EndpointInput$AuthInfo.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "securitySchemeName";
      break;
    }
    case 1: {
      return "description";
      break;
    }
    case 2: {
      return "attributes";
      break;
    }
    case 3: {
      return "group";
      break;
    }
    case 4: {
      return "bearerFormat";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lsttp_tapir_EndpointInput$AuthInfo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointInput$AuthInfo)));
}
export { $isArrayOf_Lsttp_tapir_EndpointInput$AuthInfo as $isArrayOf_Lsttp_tapir_EndpointInput$AuthInfo };
var $d_Lsttp_tapir_EndpointInput$AuthInfo = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_EndpointInput$AuthInfo, "sttp.tapir.EndpointInput$AuthInfo", ({
  Lsttp_tapir_EndpointInput$AuthInfo: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_EndpointInput$AuthInfo as $d_Lsttp_tapir_EndpointInput$AuthInfo };
function $is_Lsttp_tapir_EndpointOutput$Single(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsttp_tapir_EndpointOutput$Single)));
}
export { $is_Lsttp_tapir_EndpointOutput$Single as $is_Lsttp_tapir_EndpointOutput$Single };
function $isArrayOf_Lsttp_tapir_EndpointOutput$Single(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointOutput$Single)));
}
export { $isArrayOf_Lsttp_tapir_EndpointOutput$Single as $isArrayOf_Lsttp_tapir_EndpointOutput$Single };
function $f_Lsttp_tapir_EndpointTransput$Atom__map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput($thiz, mapping) {
  var this$1 = $thiz.codec__Lsttp_tapir_Codec();
  return $thiz.copyWith__Lsttp_tapir_Codec__Lsttp_tapir_EndpointIO$Info__Lsttp_tapir_EndpointTransput(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Codec$$anon$1(mapping, this$1), $thiz.info__Lsttp_tapir_EndpointIO$Info().map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointIO$Info(mapping));
}
export { $f_Lsttp_tapir_EndpointTransput$Atom__map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput as $f_Lsttp_tapir_EndpointTransput$Atom__map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput };
function $f_Lsttp_tapir_EndpointTransput$Atom__attribute__Lsttp_tapir_AttributeKey__O__Lsttp_tapir_EndpointTransput($thiz, k, v) {
  return $thiz.copyWith__Lsttp_tapir_Codec__Lsttp_tapir_EndpointIO$Info__Lsttp_tapir_EndpointTransput($thiz.codec__Lsttp_tapir_Codec(), $thiz.info__Lsttp_tapir_EndpointIO$Info().attribute__Lsttp_tapir_AttributeKey__O__Lsttp_tapir_EndpointIO$Info(k, v));
}
export { $f_Lsttp_tapir_EndpointTransput$Atom__attribute__Lsttp_tapir_AttributeKey__O__Lsttp_tapir_EndpointTransput as $f_Lsttp_tapir_EndpointTransput$Atom__attribute__Lsttp_tapir_AttributeKey__O__Lsttp_tapir_EndpointTransput };
/** @constructor */
function $c_Lsttp_tapir_InputStreamRange(inputStream, range) {
  this.Lsttp_tapir_InputStreamRange__f_inputStream = null;
  this.Lsttp_tapir_InputStreamRange__f_range = null;
  this.Lsttp_tapir_InputStreamRange__f_inputStream = inputStream;
  this.Lsttp_tapir_InputStreamRange__f_range = range;
}
export { $c_Lsttp_tapir_InputStreamRange as $c_Lsttp_tapir_InputStreamRange };
$c_Lsttp_tapir_InputStreamRange.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_InputStreamRange.prototype.constructor = $c_Lsttp_tapir_InputStreamRange;
/** @constructor */
function $h_Lsttp_tapir_InputStreamRange() {
}
export { $h_Lsttp_tapir_InputStreamRange as $h_Lsttp_tapir_InputStreamRange };
$h_Lsttp_tapir_InputStreamRange.prototype = $c_Lsttp_tapir_InputStreamRange.prototype;
$c_Lsttp_tapir_InputStreamRange.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_InputStreamRange.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-2112688409), true);
});
$c_Lsttp_tapir_InputStreamRange.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_InputStreamRange)) {
    var x = this.Lsttp_tapir_InputStreamRange__f_inputStream;
    var x$2 = x$0.Lsttp_tapir_InputStreamRange__f_inputStream;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lsttp_tapir_InputStreamRange__f_range;
      var x$4 = x$0.Lsttp_tapir_InputStreamRange__f_range;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_InputStreamRange.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_InputStreamRange.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsttp_tapir_InputStreamRange.prototype.productPrefix__T = (function() {
  return "InputStreamRange";
});
$c_Lsttp_tapir_InputStreamRange.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_InputStreamRange__f_inputStream;
  }
  if ((n === 1)) {
    return this.Lsttp_tapir_InputStreamRange__f_range;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_InputStreamRange.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "inputStream";
  }
  if ((n === 1)) {
    return "range";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_tapir_InputStreamRange(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_InputStreamRange)));
}
export { $isArrayOf_Lsttp_tapir_InputStreamRange as $isArrayOf_Lsttp_tapir_InputStreamRange };
var $d_Lsttp_tapir_InputStreamRange = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_InputStreamRange, "sttp.tapir.InputStreamRange", ({
  Lsttp_tapir_InputStreamRange: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_InputStreamRange as $d_Lsttp_tapir_InputStreamRange };
/** @constructor */
function $c_Lsttp_tapir_SchemaType$SchemaWithValue(schema, value) {
  this.Lsttp_tapir_SchemaType$SchemaWithValue__f_schema = null;
  this.Lsttp_tapir_SchemaType$SchemaWithValue__f_value = null;
  this.Lsttp_tapir_SchemaType$SchemaWithValue__f_schema = schema;
  this.Lsttp_tapir_SchemaType$SchemaWithValue__f_value = value;
}
export { $c_Lsttp_tapir_SchemaType$SchemaWithValue as $c_Lsttp_tapir_SchemaType$SchemaWithValue };
$c_Lsttp_tapir_SchemaType$SchemaWithValue.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_SchemaType$SchemaWithValue.prototype.constructor = $c_Lsttp_tapir_SchemaType$SchemaWithValue;
/** @constructor */
function $h_Lsttp_tapir_SchemaType$SchemaWithValue() {
}
export { $h_Lsttp_tapir_SchemaType$SchemaWithValue as $h_Lsttp_tapir_SchemaType$SchemaWithValue };
$h_Lsttp_tapir_SchemaType$SchemaWithValue.prototype = $c_Lsttp_tapir_SchemaType$SchemaWithValue.prototype;
$c_Lsttp_tapir_SchemaType$SchemaWithValue.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_SchemaType$SchemaWithValue.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1149516573, true);
});
$c_Lsttp_tapir_SchemaType$SchemaWithValue.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_SchemaType$SchemaWithValue)) {
    var x = this.Lsttp_tapir_SchemaType$SchemaWithValue__f_schema;
    var x$2 = x$0.Lsttp_tapir_SchemaType$SchemaWithValue__f_schema;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$1 = this.Lsttp_tapir_SchemaType$SchemaWithValue__f_value;
      var y = x$0.Lsttp_tapir_SchemaType$SchemaWithValue__f_value;
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_SchemaType$SchemaWithValue.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_SchemaType$SchemaWithValue.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsttp_tapir_SchemaType$SchemaWithValue.prototype.productPrefix__T = (function() {
  return "SchemaWithValue";
});
$c_Lsttp_tapir_SchemaType$SchemaWithValue.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_SchemaType$SchemaWithValue__f_schema;
  }
  if ((n === 1)) {
    return this.Lsttp_tapir_SchemaType$SchemaWithValue__f_value;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_SchemaType$SchemaWithValue.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "schema";
  }
  if ((n === 1)) {
    return "value";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_tapir_SchemaType$SchemaWithValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_SchemaType$SchemaWithValue)));
}
export { $isArrayOf_Lsttp_tapir_SchemaType$SchemaWithValue as $isArrayOf_Lsttp_tapir_SchemaType$SchemaWithValue };
var $d_Lsttp_tapir_SchemaType$SchemaWithValue = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_SchemaType$SchemaWithValue, "sttp.tapir.SchemaType$SchemaWithValue", ({
  Lsttp_tapir_SchemaType$SchemaWithValue: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_SchemaType$SchemaWithValue as $d_Lsttp_tapir_SchemaType$SchemaWithValue };
/** @constructor */
function $c_Lsttp_tapir_client_sttp_SttpClientOptions(createFile) {
  this.Lsttp_tapir_client_sttp_SttpClientOptions__f_createFile = null;
  this.Lsttp_tapir_client_sttp_SttpClientOptions__f_createFile = createFile;
}
export { $c_Lsttp_tapir_client_sttp_SttpClientOptions as $c_Lsttp_tapir_client_sttp_SttpClientOptions };
$c_Lsttp_tapir_client_sttp_SttpClientOptions.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_client_sttp_SttpClientOptions.prototype.constructor = $c_Lsttp_tapir_client_sttp_SttpClientOptions;
/** @constructor */
function $h_Lsttp_tapir_client_sttp_SttpClientOptions() {
}
export { $h_Lsttp_tapir_client_sttp_SttpClientOptions as $h_Lsttp_tapir_client_sttp_SttpClientOptions };
$h_Lsttp_tapir_client_sttp_SttpClientOptions.prototype = $c_Lsttp_tapir_client_sttp_SttpClientOptions.prototype;
$c_Lsttp_tapir_client_sttp_SttpClientOptions.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_client_sttp_SttpClientOptions.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 502581614, true);
});
$c_Lsttp_tapir_client_sttp_SttpClientOptions.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_client_sttp_SttpClientOptions)) {
    var x = this.Lsttp_tapir_client_sttp_SttpClientOptions__f_createFile;
    var x$2 = x$0.Lsttp_tapir_client_sttp_SttpClientOptions__f_createFile;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lsttp_tapir_client_sttp_SttpClientOptions.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_client_sttp_SttpClientOptions.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_tapir_client_sttp_SttpClientOptions.prototype.productPrefix__T = (function() {
  return "SttpClientOptions";
});
$c_Lsttp_tapir_client_sttp_SttpClientOptions.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_client_sttp_SttpClientOptions__f_createFile;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_client_sttp_SttpClientOptions.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "createFile";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_tapir_client_sttp_SttpClientOptions(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_client_sttp_SttpClientOptions)));
}
export { $isArrayOf_Lsttp_tapir_client_sttp_SttpClientOptions as $isArrayOf_Lsttp_tapir_client_sttp_SttpClientOptions };
var $d_Lsttp_tapir_client_sttp_SttpClientOptions = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_client_sttp_SttpClientOptions, "sttp.tapir.client.sttp.SttpClientOptions", ({
  Lsttp_tapir_client_sttp_SttpClientOptions: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_client_sttp_SttpClientOptions as $d_Lsttp_tapir_client_sttp_SttpClientOptions };
/** @constructor */
function $c_Lurldsl_vocabulary_Param(content) {
  this.Lurldsl_vocabulary_Param__f_content = null;
  this.Lurldsl_vocabulary_Param__f_content = content;
}
export { $c_Lurldsl_vocabulary_Param as $c_Lurldsl_vocabulary_Param };
$c_Lurldsl_vocabulary_Param.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lurldsl_vocabulary_Param.prototype.constructor = $c_Lurldsl_vocabulary_Param;
/** @constructor */
function $h_Lurldsl_vocabulary_Param() {
}
export { $h_Lurldsl_vocabulary_Param as $h_Lurldsl_vocabulary_Param };
$h_Lurldsl_vocabulary_Param.prototype = $c_Lurldsl_vocabulary_Param.prototype;
$c_Lurldsl_vocabulary_Param.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lurldsl_vocabulary_Param.prototype.hashCode__I = (function() {
  var this$ = this.Lurldsl_vocabulary_Param__f_content;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().seqHash__sc_Seq__I(this$);
});
$c_Lurldsl_vocabulary_Param.prototype.equals__O__Z = (function(x$0) {
  return $m_Lurldsl_vocabulary_Param$().equals$extension__sci_List__O__Z(this.Lurldsl_vocabulary_Param__f_content, x$0);
});
$c_Lurldsl_vocabulary_Param.prototype.toString__T = (function() {
  return $m_Lurldsl_vocabulary_Param$().toString$extension__sci_List__T(this.Lurldsl_vocabulary_Param__f_content);
});
$c_Lurldsl_vocabulary_Param.prototype.productArity__I = (function() {
  return 1;
});
$c_Lurldsl_vocabulary_Param.prototype.productPrefix__T = (function() {
  return "Param";
});
$c_Lurldsl_vocabulary_Param.prototype.productElement__I__O = (function(n) {
  return $m_Lurldsl_vocabulary_Param$().productElement$extension__sci_List__I__O(this.Lurldsl_vocabulary_Param__f_content, n);
});
$c_Lurldsl_vocabulary_Param.prototype.productElementName__I__T = (function(n) {
  return $m_Lurldsl_vocabulary_Param$().productElementName$extension__sci_List__I__T(this.Lurldsl_vocabulary_Param__f_content, n);
});
function $isArrayOf_Lurldsl_vocabulary_Param(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lurldsl_vocabulary_Param)));
}
export { $isArrayOf_Lurldsl_vocabulary_Param as $isArrayOf_Lurldsl_vocabulary_Param };
var $d_Lurldsl_vocabulary_Param = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lurldsl_vocabulary_Param, "urldsl.vocabulary.Param", ({
  Lurldsl_vocabulary_Param: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lurldsl_vocabulary_Param as $d_Lurldsl_vocabulary_Param };
/** @constructor */
function $c_Lurldsl_vocabulary_ParamMatchOutput(output, unusedParams) {
  this.Lurldsl_vocabulary_ParamMatchOutput__f_output = null;
  this.Lurldsl_vocabulary_ParamMatchOutput__f_unusedParams = null;
  this.Lurldsl_vocabulary_ParamMatchOutput__f_output = output;
  this.Lurldsl_vocabulary_ParamMatchOutput__f_unusedParams = unusedParams;
}
export { $c_Lurldsl_vocabulary_ParamMatchOutput as $c_Lurldsl_vocabulary_ParamMatchOutput };
$c_Lurldsl_vocabulary_ParamMatchOutput.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lurldsl_vocabulary_ParamMatchOutput.prototype.constructor = $c_Lurldsl_vocabulary_ParamMatchOutput;
/** @constructor */
function $h_Lurldsl_vocabulary_ParamMatchOutput() {
}
export { $h_Lurldsl_vocabulary_ParamMatchOutput as $h_Lurldsl_vocabulary_ParamMatchOutput };
$h_Lurldsl_vocabulary_ParamMatchOutput.prototype = $c_Lurldsl_vocabulary_ParamMatchOutput.prototype;
$c_Lurldsl_vocabulary_ParamMatchOutput.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lurldsl_vocabulary_ParamMatchOutput.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lurldsl_vocabulary_ParamMatchOutput.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lurldsl_vocabulary_ParamMatchOutput)) {
    var x = this.Lurldsl_vocabulary_ParamMatchOutput__f_output;
    var y = x$0.Lurldsl_vocabulary_ParamMatchOutput__f_output;
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Lurldsl_vocabulary_ParamMatchOutput__f_unusedParams;
      var x$2 = x$0.Lurldsl_vocabulary_ParamMatchOutput__f_unusedParams;
      return ((x$1 === null) ? (x$2 === null) : x$1.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lurldsl_vocabulary_ParamMatchOutput.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lurldsl_vocabulary_ParamMatchOutput.prototype.productArity__I = (function() {
  return 2;
});
$c_Lurldsl_vocabulary_ParamMatchOutput.prototype.productPrefix__T = (function() {
  return "ParamMatchOutput";
});
$c_Lurldsl_vocabulary_ParamMatchOutput.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lurldsl_vocabulary_ParamMatchOutput__f_output;
  }
  if ((n === 1)) {
    return this.Lurldsl_vocabulary_ParamMatchOutput__f_unusedParams;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lurldsl_vocabulary_ParamMatchOutput.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "output";
  }
  if ((n === 1)) {
    return "unusedParams";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lurldsl_vocabulary_ParamMatchOutput(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lurldsl_vocabulary_ParamMatchOutput)));
}
export { $isArrayOf_Lurldsl_vocabulary_ParamMatchOutput as $isArrayOf_Lurldsl_vocabulary_ParamMatchOutput };
var $d_Lurldsl_vocabulary_ParamMatchOutput = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lurldsl_vocabulary_ParamMatchOutput, "urldsl.vocabulary.ParamMatchOutput", ({
  Lurldsl_vocabulary_ParamMatchOutput: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lurldsl_vocabulary_ParamMatchOutput as $d_Lurldsl_vocabulary_ParamMatchOutput };
/** @constructor */
function $c_Lurldsl_vocabulary_PathMatchOutput(output, unusedSegments) {
  this.Lurldsl_vocabulary_PathMatchOutput__f_output = null;
  this.Lurldsl_vocabulary_PathMatchOutput__f_unusedSegments = null;
  this.Lurldsl_vocabulary_PathMatchOutput__f_output = output;
  this.Lurldsl_vocabulary_PathMatchOutput__f_unusedSegments = unusedSegments;
}
export { $c_Lurldsl_vocabulary_PathMatchOutput as $c_Lurldsl_vocabulary_PathMatchOutput };
$c_Lurldsl_vocabulary_PathMatchOutput.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lurldsl_vocabulary_PathMatchOutput.prototype.constructor = $c_Lurldsl_vocabulary_PathMatchOutput;
/** @constructor */
function $h_Lurldsl_vocabulary_PathMatchOutput() {
}
export { $h_Lurldsl_vocabulary_PathMatchOutput as $h_Lurldsl_vocabulary_PathMatchOutput };
$h_Lurldsl_vocabulary_PathMatchOutput.prototype = $c_Lurldsl_vocabulary_PathMatchOutput.prototype;
$c_Lurldsl_vocabulary_PathMatchOutput.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lurldsl_vocabulary_PathMatchOutput.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lurldsl_vocabulary_PathMatchOutput.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lurldsl_vocabulary_PathMatchOutput)) {
    var x = this.Lurldsl_vocabulary_PathMatchOutput__f_output;
    var y = x$0.Lurldsl_vocabulary_PathMatchOutput__f_output;
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Lurldsl_vocabulary_PathMatchOutput__f_unusedSegments;
      var x$2 = x$0.Lurldsl_vocabulary_PathMatchOutput__f_unusedSegments;
      return ((x$1 === null) ? (x$2 === null) : x$1.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lurldsl_vocabulary_PathMatchOutput.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lurldsl_vocabulary_PathMatchOutput.prototype.productArity__I = (function() {
  return 2;
});
$c_Lurldsl_vocabulary_PathMatchOutput.prototype.productPrefix__T = (function() {
  return "PathMatchOutput";
});
$c_Lurldsl_vocabulary_PathMatchOutput.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lurldsl_vocabulary_PathMatchOutput__f_output;
  }
  if ((n === 1)) {
    return this.Lurldsl_vocabulary_PathMatchOutput__f_unusedSegments;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lurldsl_vocabulary_PathMatchOutput.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "output";
  }
  if ((n === 1)) {
    return "unusedSegments";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lurldsl_vocabulary_PathMatchOutput(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lurldsl_vocabulary_PathMatchOutput)));
}
export { $isArrayOf_Lurldsl_vocabulary_PathMatchOutput as $isArrayOf_Lurldsl_vocabulary_PathMatchOutput };
var $d_Lurldsl_vocabulary_PathMatchOutput = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lurldsl_vocabulary_PathMatchOutput, "urldsl.vocabulary.PathMatchOutput", ({
  Lurldsl_vocabulary_PathMatchOutput: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lurldsl_vocabulary_PathMatchOutput as $d_Lurldsl_vocabulary_PathMatchOutput };
/** @constructor */
function $c_Lurldsl_vocabulary_Segment(content) {
  this.Lurldsl_vocabulary_Segment__f_content = null;
  this.Lurldsl_vocabulary_Segment__f_content = content;
}
export { $c_Lurldsl_vocabulary_Segment as $c_Lurldsl_vocabulary_Segment };
$c_Lurldsl_vocabulary_Segment.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lurldsl_vocabulary_Segment.prototype.constructor = $c_Lurldsl_vocabulary_Segment;
/** @constructor */
function $h_Lurldsl_vocabulary_Segment() {
}
export { $h_Lurldsl_vocabulary_Segment as $h_Lurldsl_vocabulary_Segment };
$h_Lurldsl_vocabulary_Segment.prototype = $c_Lurldsl_vocabulary_Segment.prototype;
$c_Lurldsl_vocabulary_Segment.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lurldsl_vocabulary_Segment.prototype.hashCode__I = (function() {
  var this$ = this.Lurldsl_vocabulary_Segment__f_content;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I(this$);
});
$c_Lurldsl_vocabulary_Segment.prototype.equals__O__Z = (function(x$0) {
  return $m_Lurldsl_vocabulary_Segment$().equals$extension__T__O__Z(this.Lurldsl_vocabulary_Segment__f_content, x$0);
});
$c_Lurldsl_vocabulary_Segment.prototype.toString__T = (function() {
  return $m_Lurldsl_vocabulary_Segment$().toString$extension__T__T(this.Lurldsl_vocabulary_Segment__f_content);
});
$c_Lurldsl_vocabulary_Segment.prototype.productArity__I = (function() {
  return 1;
});
$c_Lurldsl_vocabulary_Segment.prototype.productPrefix__T = (function() {
  return "Segment";
});
$c_Lurldsl_vocabulary_Segment.prototype.productElement__I__O = (function(n) {
  return $m_Lurldsl_vocabulary_Segment$().productElement$extension__T__I__O(this.Lurldsl_vocabulary_Segment__f_content, n);
});
$c_Lurldsl_vocabulary_Segment.prototype.productElementName__I__T = (function(n) {
  return $m_Lurldsl_vocabulary_Segment$().productElementName$extension__T__I__T(this.Lurldsl_vocabulary_Segment__f_content, n);
});
function $isArrayOf_Lurldsl_vocabulary_Segment(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lurldsl_vocabulary_Segment)));
}
export { $isArrayOf_Lurldsl_vocabulary_Segment as $isArrayOf_Lurldsl_vocabulary_Segment };
var $d_Lurldsl_vocabulary_Segment = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lurldsl_vocabulary_Segment, "urldsl.vocabulary.Segment", ({
  Lurldsl_vocabulary_Segment: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lurldsl_vocabulary_Segment as $d_Lurldsl_vocabulary_Segment };
/** @constructor */
function $c_Lurldsl_vocabulary_UrlMatching(path, params) {
  this.Lurldsl_vocabulary_UrlMatching__f_path = null;
  this.Lurldsl_vocabulary_UrlMatching__f_params = null;
  this.Lurldsl_vocabulary_UrlMatching__f_path = path;
  this.Lurldsl_vocabulary_UrlMatching__f_params = params;
}
export { $c_Lurldsl_vocabulary_UrlMatching as $c_Lurldsl_vocabulary_UrlMatching };
$c_Lurldsl_vocabulary_UrlMatching.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lurldsl_vocabulary_UrlMatching.prototype.constructor = $c_Lurldsl_vocabulary_UrlMatching;
/** @constructor */
function $h_Lurldsl_vocabulary_UrlMatching() {
}
export { $h_Lurldsl_vocabulary_UrlMatching as $h_Lurldsl_vocabulary_UrlMatching };
$h_Lurldsl_vocabulary_UrlMatching.prototype = $c_Lurldsl_vocabulary_UrlMatching.prototype;
$c_Lurldsl_vocabulary_UrlMatching.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lurldsl_vocabulary_UrlMatching.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lurldsl_vocabulary_UrlMatching.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lurldsl_vocabulary_UrlMatching)) {
    var x = this.Lurldsl_vocabulary_UrlMatching__f_path;
    var y = x$0.Lurldsl_vocabulary_UrlMatching__f_path;
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Lurldsl_vocabulary_UrlMatching__f_params;
      var y$1 = x$0.Lurldsl_vocabulary_UrlMatching__f_params;
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y$1);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lurldsl_vocabulary_UrlMatching.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lurldsl_vocabulary_UrlMatching.prototype.productArity__I = (function() {
  return 2;
});
$c_Lurldsl_vocabulary_UrlMatching.prototype.productPrefix__T = (function() {
  return "UrlMatching";
});
$c_Lurldsl_vocabulary_UrlMatching.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lurldsl_vocabulary_UrlMatching__f_path;
  }
  if ((n === 1)) {
    return this.Lurldsl_vocabulary_UrlMatching__f_params;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lurldsl_vocabulary_UrlMatching.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "path";
  }
  if ((n === 1)) {
    return "params";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lurldsl_vocabulary_UrlMatching(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lurldsl_vocabulary_UrlMatching)));
}
export { $isArrayOf_Lurldsl_vocabulary_UrlMatching as $isArrayOf_Lurldsl_vocabulary_UrlMatching };
var $d_Lurldsl_vocabulary_UrlMatching = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lurldsl_vocabulary_UrlMatching, "urldsl.vocabulary.UrlMatching", ({
  Lurldsl_vocabulary_UrlMatching: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lurldsl_vocabulary_UrlMatching as $d_Lurldsl_vocabulary_UrlMatching };
/** @constructor */
function $c_Lyantl_ValidatorRule$HadSurroundingWhitespace(value) {
  this.Lyantl_ValidatorRule$HadSurroundingWhitespace__f_value = null;
  this.Lyantl_ValidatorRule$HadSurroundingWhitespace__f_value = value;
}
export { $c_Lyantl_ValidatorRule$HadSurroundingWhitespace as $c_Lyantl_ValidatorRule$HadSurroundingWhitespace };
$c_Lyantl_ValidatorRule$HadSurroundingWhitespace.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lyantl_ValidatorRule$HadSurroundingWhitespace.prototype.constructor = $c_Lyantl_ValidatorRule$HadSurroundingWhitespace;
/** @constructor */
function $h_Lyantl_ValidatorRule$HadSurroundingWhitespace() {
}
export { $h_Lyantl_ValidatorRule$HadSurroundingWhitespace as $h_Lyantl_ValidatorRule$HadSurroundingWhitespace };
$h_Lyantl_ValidatorRule$HadSurroundingWhitespace.prototype = $c_Lyantl_ValidatorRule$HadSurroundingWhitespace.prototype;
$c_Lyantl_ValidatorRule$HadSurroundingWhitespace.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lyantl_ValidatorRule$HadSurroundingWhitespace.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lyantl_ValidatorRule$HadSurroundingWhitespace.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lyantl_ValidatorRule$HadSurroundingWhitespace) && (this.Lyantl_ValidatorRule$HadSurroundingWhitespace__f_value === x$0.Lyantl_ValidatorRule$HadSurroundingWhitespace__f_value)));
});
$c_Lyantl_ValidatorRule$HadSurroundingWhitespace.prototype.productArity__I = (function() {
  return 1;
});
$c_Lyantl_ValidatorRule$HadSurroundingWhitespace.prototype.productPrefix__T = (function() {
  return "HadSurroundingWhitespace";
});
$c_Lyantl_ValidatorRule$HadSurroundingWhitespace.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lyantl_ValidatorRule$HadSurroundingWhitespace__f_value;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lyantl_ValidatorRule$HadSurroundingWhitespace.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lyantl_ValidatorRule$HadSurroundingWhitespace.prototype.toString__T = (function() {
  return "Cannot have leading or trailing whitespace.";
});
function $isArrayOf_Lyantl_ValidatorRule$HadSurroundingWhitespace(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lyantl_ValidatorRule$HadSurroundingWhitespace)));
}
export { $isArrayOf_Lyantl_ValidatorRule$HadSurroundingWhitespace as $isArrayOf_Lyantl_ValidatorRule$HadSurroundingWhitespace };
var $d_Lyantl_ValidatorRule$HadSurroundingWhitespace = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lyantl_ValidatorRule$HadSurroundingWhitespace, "yantl.ValidatorRule$HadSurroundingWhitespace", ({
  Lyantl_ValidatorRule$HadSurroundingWhitespace: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lyantl_ValidatorRule$HadSurroundingWhitespace as $d_Lyantl_ValidatorRule$HadSurroundingWhitespace };
/** @constructor */
function $c_Lyantl_ValidatorRule$MaxLengthExceeded(maxLength, actualLength, actual) {
  this.Lyantl_ValidatorRule$MaxLengthExceeded__f_maxLength = 0;
  this.Lyantl_ValidatorRule$MaxLengthExceeded__f_actualLength = 0;
  this.Lyantl_ValidatorRule$MaxLengthExceeded__f_actual = null;
  this.Lyantl_ValidatorRule$MaxLengthExceeded__f_maxLength = maxLength;
  this.Lyantl_ValidatorRule$MaxLengthExceeded__f_actualLength = actualLength;
  this.Lyantl_ValidatorRule$MaxLengthExceeded__f_actual = actual;
}
export { $c_Lyantl_ValidatorRule$MaxLengthExceeded as $c_Lyantl_ValidatorRule$MaxLengthExceeded };
$c_Lyantl_ValidatorRule$MaxLengthExceeded.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lyantl_ValidatorRule$MaxLengthExceeded.prototype.constructor = $c_Lyantl_ValidatorRule$MaxLengthExceeded;
/** @constructor */
function $h_Lyantl_ValidatorRule$MaxLengthExceeded() {
}
export { $h_Lyantl_ValidatorRule$MaxLengthExceeded as $h_Lyantl_ValidatorRule$MaxLengthExceeded };
$h_Lyantl_ValidatorRule$MaxLengthExceeded.prototype = $c_Lyantl_ValidatorRule$MaxLengthExceeded.prototype;
$c_Lyantl_ValidatorRule$MaxLengthExceeded.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lyantl_ValidatorRule$MaxLengthExceeded.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I("MaxLengthExceeded");
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lyantl_ValidatorRule$MaxLengthExceeded__f_maxLength;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Lyantl_ValidatorRule$MaxLengthExceeded__f_actualLength;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x = this.Lyantl_ValidatorRule$MaxLengthExceeded__f_actual;
  var data$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3);
});
$c_Lyantl_ValidatorRule$MaxLengthExceeded.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lyantl_ValidatorRule$MaxLengthExceeded)) {
    if (((this.Lyantl_ValidatorRule$MaxLengthExceeded__f_maxLength === x$0.Lyantl_ValidatorRule$MaxLengthExceeded__f_maxLength) && (this.Lyantl_ValidatorRule$MaxLengthExceeded__f_actualLength === x$0.Lyantl_ValidatorRule$MaxLengthExceeded__f_actualLength))) {
      var x = this.Lyantl_ValidatorRule$MaxLengthExceeded__f_actual;
      var y = x$0.Lyantl_ValidatorRule$MaxLengthExceeded__f_actual;
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lyantl_ValidatorRule$MaxLengthExceeded.prototype.productArity__I = (function() {
  return 3;
});
$c_Lyantl_ValidatorRule$MaxLengthExceeded.prototype.productPrefix__T = (function() {
  return "MaxLengthExceeded";
});
$c_Lyantl_ValidatorRule$MaxLengthExceeded.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lyantl_ValidatorRule$MaxLengthExceeded__f_maxLength;
      break;
    }
    case 1: {
      return this.Lyantl_ValidatorRule$MaxLengthExceeded__f_actualLength;
      break;
    }
    case 2: {
      return this.Lyantl_ValidatorRule$MaxLengthExceeded__f_actual;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lyantl_ValidatorRule$MaxLengthExceeded.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "maxLength";
      break;
    }
    case 1: {
      return "actualLength";
      break;
    }
    case 2: {
      return "actual";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lyantl_ValidatorRule$MaxLengthExceeded.prototype.toString__T = (function() {
  var $x_3 = this.Lyantl_ValidatorRule$MaxLengthExceeded__f_maxLength;
  var this$3 = $m_Lyantl_ValidatorRule$English$();
  var x = this.Lyantl_ValidatorRule$MaxLengthExceeded__f_maxLength;
  var hi = (x >> 31);
  var $x_2 = this$3.plural__J__T__T__T(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(x, hi), "character", "characters");
  var $x_1 = this.Lyantl_ValidatorRule$MaxLengthExceeded__f_actualLength;
  var this$6 = $m_Lyantl_ValidatorRule$English$();
  var x$1 = this.Lyantl_ValidatorRule$MaxLengthExceeded__f_actualLength;
  var hi$1 = (x$1 >> 31);
  return (((((("Cannot be longer than " + $x_3) + " ") + $x_2) + ", ") + ((("was " + $x_1) + " ") + this$6.plural__J__T__T__T(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(x$1, hi$1), "character", "characters"))) + ".");
});
function $isArrayOf_Lyantl_ValidatorRule$MaxLengthExceeded(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lyantl_ValidatorRule$MaxLengthExceeded)));
}
export { $isArrayOf_Lyantl_ValidatorRule$MaxLengthExceeded as $isArrayOf_Lyantl_ValidatorRule$MaxLengthExceeded };
var $d_Lyantl_ValidatorRule$MaxLengthExceeded = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lyantl_ValidatorRule$MaxLengthExceeded, "yantl.ValidatorRule$MaxLengthExceeded", ({
  Lyantl_ValidatorRule$MaxLengthExceeded: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lyantl_ValidatorRule$MaxLengthExceeded as $d_Lyantl_ValidatorRule$MaxLengthExceeded };
/** @constructor */
function $c_Lyantl_ValidatorRule$UnderMinLength(minLength, actualLength, actual) {
  this.Lyantl_ValidatorRule$UnderMinLength__f_minLength = 0;
  this.Lyantl_ValidatorRule$UnderMinLength__f_actualLength = 0;
  this.Lyantl_ValidatorRule$UnderMinLength__f_actual = null;
  this.Lyantl_ValidatorRule$UnderMinLength__f_minLength = minLength;
  this.Lyantl_ValidatorRule$UnderMinLength__f_actualLength = actualLength;
  this.Lyantl_ValidatorRule$UnderMinLength__f_actual = actual;
}
export { $c_Lyantl_ValidatorRule$UnderMinLength as $c_Lyantl_ValidatorRule$UnderMinLength };
$c_Lyantl_ValidatorRule$UnderMinLength.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lyantl_ValidatorRule$UnderMinLength.prototype.constructor = $c_Lyantl_ValidatorRule$UnderMinLength;
/** @constructor */
function $h_Lyantl_ValidatorRule$UnderMinLength() {
}
export { $h_Lyantl_ValidatorRule$UnderMinLength as $h_Lyantl_ValidatorRule$UnderMinLength };
$h_Lyantl_ValidatorRule$UnderMinLength.prototype = $c_Lyantl_ValidatorRule$UnderMinLength.prototype;
$c_Lyantl_ValidatorRule$UnderMinLength.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lyantl_ValidatorRule$UnderMinLength.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I("UnderMinLength");
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lyantl_ValidatorRule$UnderMinLength__f_minLength;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Lyantl_ValidatorRule$UnderMinLength__f_actualLength;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x = this.Lyantl_ValidatorRule$UnderMinLength__f_actual;
  var data$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3);
});
$c_Lyantl_ValidatorRule$UnderMinLength.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lyantl_ValidatorRule$UnderMinLength)) {
    if (((this.Lyantl_ValidatorRule$UnderMinLength__f_minLength === x$0.Lyantl_ValidatorRule$UnderMinLength__f_minLength) && (this.Lyantl_ValidatorRule$UnderMinLength__f_actualLength === x$0.Lyantl_ValidatorRule$UnderMinLength__f_actualLength))) {
      var x = this.Lyantl_ValidatorRule$UnderMinLength__f_actual;
      var y = x$0.Lyantl_ValidatorRule$UnderMinLength__f_actual;
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lyantl_ValidatorRule$UnderMinLength.prototype.productArity__I = (function() {
  return 3;
});
$c_Lyantl_ValidatorRule$UnderMinLength.prototype.productPrefix__T = (function() {
  return "UnderMinLength";
});
$c_Lyantl_ValidatorRule$UnderMinLength.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lyantl_ValidatorRule$UnderMinLength__f_minLength;
      break;
    }
    case 1: {
      return this.Lyantl_ValidatorRule$UnderMinLength__f_actualLength;
      break;
    }
    case 2: {
      return this.Lyantl_ValidatorRule$UnderMinLength__f_actual;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lyantl_ValidatorRule$UnderMinLength.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "minLength";
      break;
    }
    case 1: {
      return "actualLength";
      break;
    }
    case 2: {
      return "actual";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lyantl_ValidatorRule$UnderMinLength.prototype.toString__T = (function() {
  var $x_3 = this.Lyantl_ValidatorRule$UnderMinLength__f_minLength;
  var this$3 = $m_Lyantl_ValidatorRule$English$();
  var x = this.Lyantl_ValidatorRule$UnderMinLength__f_minLength;
  var hi = (x >> 31);
  var $x_2 = this$3.plural__J__T__T__T(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(x, hi), "character", "characters");
  var $x_1 = this.Lyantl_ValidatorRule$UnderMinLength__f_actualLength;
  var this$6 = $m_Lyantl_ValidatorRule$English$();
  var x$1 = this.Lyantl_ValidatorRule$UnderMinLength__f_actualLength;
  var hi$1 = (x$1 >> 31);
  return (((((("Cannot be shorter than " + $x_3) + " ") + $x_2) + ", ") + ((("was " + $x_1) + " ") + this$6.plural__J__T__T__T(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(x$1, hi$1), "character", "characters"))) + ".");
});
function $isArrayOf_Lyantl_ValidatorRule$UnderMinLength(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lyantl_ValidatorRule$UnderMinLength)));
}
export { $isArrayOf_Lyantl_ValidatorRule$UnderMinLength as $isArrayOf_Lyantl_ValidatorRule$UnderMinLength };
var $d_Lyantl_ValidatorRule$UnderMinLength = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lyantl_ValidatorRule$UnderMinLength, "yantl.ValidatorRule$UnderMinLength", ({
  Lyantl_ValidatorRule$UnderMinLength: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lyantl_ValidatorRule$UnderMinLength as $d_Lyantl_ValidatorRule$UnderMinLength };
/** @constructor */
function $c_Lyantl_ValidatorRule$WasBlank(value) {
  this.Lyantl_ValidatorRule$WasBlank__f_value = null;
  this.Lyantl_ValidatorRule$WasBlank__f_value = value;
}
export { $c_Lyantl_ValidatorRule$WasBlank as $c_Lyantl_ValidatorRule$WasBlank };
$c_Lyantl_ValidatorRule$WasBlank.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lyantl_ValidatorRule$WasBlank.prototype.constructor = $c_Lyantl_ValidatorRule$WasBlank;
/** @constructor */
function $h_Lyantl_ValidatorRule$WasBlank() {
}
export { $h_Lyantl_ValidatorRule$WasBlank as $h_Lyantl_ValidatorRule$WasBlank };
$h_Lyantl_ValidatorRule$WasBlank.prototype = $c_Lyantl_ValidatorRule$WasBlank.prototype;
$c_Lyantl_ValidatorRule$WasBlank.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lyantl_ValidatorRule$WasBlank.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lyantl_ValidatorRule$WasBlank.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lyantl_ValidatorRule$WasBlank) && (this.Lyantl_ValidatorRule$WasBlank__f_value === x$0.Lyantl_ValidatorRule$WasBlank__f_value)));
});
$c_Lyantl_ValidatorRule$WasBlank.prototype.productArity__I = (function() {
  return 1;
});
$c_Lyantl_ValidatorRule$WasBlank.prototype.productPrefix__T = (function() {
  return "WasBlank";
});
$c_Lyantl_ValidatorRule$WasBlank.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lyantl_ValidatorRule$WasBlank__f_value;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lyantl_ValidatorRule$WasBlank.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lyantl_ValidatorRule$WasBlank.prototype.toString__T = (function() {
  return "Cannot be blank.";
});
function $isArrayOf_Lyantl_ValidatorRule$WasBlank(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lyantl_ValidatorRule$WasBlank)));
}
export { $isArrayOf_Lyantl_ValidatorRule$WasBlank as $isArrayOf_Lyantl_ValidatorRule$WasBlank };
var $d_Lyantl_ValidatorRule$WasBlank = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lyantl_ValidatorRule$WasBlank, "yantl.ValidatorRule$WasBlank", ({
  Lyantl_ValidatorRule$WasBlank: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lyantl_ValidatorRule$WasBlank as $d_Lyantl_ValidatorRule$WasBlank };
function $ps_Lcats_data_AndThen__loop$1__Lcats_data_AndThen__O__O(self, current) {
  var current$tailLocal1 = current;
  var self$tailLocal1 = self;
  while (true) {
    var x31 = self$tailLocal1;
    if ((x31 instanceof $c_Lcats_data_AndThen$Single)) {
      var x50 = x31.Lcats_data_AndThen$Single__f_f;
      return x50.apply__O__O(current$tailLocal1);
    }
    if ((x31 instanceof $c_Lcats_data_AndThen$Concat)) {
      var x42 = x31.Lcats_data_AndThen$Concat__f_left;
      var x43 = x31.Lcats_data_AndThen$Concat__f_right;
      if ((x42 instanceof $c_Lcats_data_AndThen$Single)) {
        var x46 = x42.Lcats_data_AndThen$Single__f_f;
        var current$tailLocal1$tmp1 = x46.apply__O__O(current$tailLocal1);
        self$tailLocal1 = x43;
        current$tailLocal1 = current$tailLocal1$tmp1;
        continue;
      }
    }
    if ((x31 instanceof $c_Lcats_data_AndThen$Concat)) {
      var x34 = x31.Lcats_data_AndThen$Concat__f_left;
      var x35 = x31.Lcats_data_AndThen$Concat__f_right;
      if ((x34 instanceof $c_Lcats_data_AndThen$Concat)) {
        self$tailLocal1 = $ps_Lcats_data_AndThen__loop$2__Lcats_data_AndThen__Lcats_data_AndThen__Lcats_data_AndThen(x34, x35);
        continue;
      }
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x31);
  }
}
export { $ps_Lcats_data_AndThen__loop$1__Lcats_data_AndThen__O__O as $ps_Lcats_data_AndThen__loop$1__Lcats_data_AndThen__O__O };
function $ps_Lcats_data_AndThen__loop$2__Lcats_data_AndThen__Lcats_data_AndThen__Lcats_data_AndThen(left, right) {
  var right$tailLocal1 = right;
  var left$tailLocal1 = left;
  while (true) {
    var x52 = left$tailLocal1;
    if ((x52 instanceof $c_Lcats_data_AndThen$Concat)) {
      var x55 = x52.Lcats_data_AndThen$Concat__f_left;
      var x56 = x52.Lcats_data_AndThen$Concat__f_right;
      var right$1 = right$tailLocal1;
      var right$tailLocal1$tmp1 = new $c_Lcats_data_AndThen$Concat(x56, right$1);
      left$tailLocal1 = x55;
      right$tailLocal1 = right$tailLocal1$tmp1;
      continue;
    }
    var right$2 = right$tailLocal1;
    return new $c_Lcats_data_AndThen$Concat(x52, right$2);
  }
}
export { $ps_Lcats_data_AndThen__loop$2__Lcats_data_AndThen__Lcats_data_AndThen__Lcats_data_AndThen as $ps_Lcats_data_AndThen__loop$2__Lcats_data_AndThen__Lcats_data_AndThen__Lcats_data_AndThen };
/** @constructor */
function $c_Lcats_data_AndThen() {
}
export { $c_Lcats_data_AndThen as $c_Lcats_data_AndThen };
$c_Lcats_data_AndThen.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_data_AndThen.prototype.constructor = $c_Lcats_data_AndThen;
/** @constructor */
function $h_Lcats_data_AndThen() {
}
export { $h_Lcats_data_AndThen as $h_Lcats_data_AndThen };
$h_Lcats_data_AndThen.prototype = $c_Lcats_data_AndThen.prototype;
$c_Lcats_data_AndThen.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_data_AndThen.prototype.apply__O__O = (function(a) {
  return $ps_Lcats_data_AndThen__loop$1__Lcats_data_AndThen__O__O(this, a);
});
$c_Lcats_data_AndThen.prototype.andThen__F1__Lcats_data_AndThen = (function(g) {
  if ((g instanceof $c_Lcats_data_AndThen)) {
    return $m_Lcats_data_AndThen$().andThen__Lcats_data_AndThen__Lcats_data_AndThen__Lcats_data_AndThen(this, g);
  } else {
    if ((this instanceof $c_Lcats_data_AndThen$Single)) {
      var x12 = this.Lcats_data_AndThen$Single__f_f;
      var x13 = this.Lcats_data_AndThen$Single__f_index;
      if ((x13 < 128)) {
        var f = x12.andThen__F1__F1(g);
        var index = ((1 + x13) | 0);
        return new $c_Lcats_data_AndThen$Single(f, index);
      }
    }
    if ((this instanceof $c_Lcats_data_AndThen$Concat)) {
      var x4 = this.Lcats_data_AndThen$Concat__f_left;
      var x5 = this.Lcats_data_AndThen$Concat__f_right;
      if ((x5 instanceof $c_Lcats_data_AndThen$Single)) {
        var x8 = x5.Lcats_data_AndThen$Single__f_f;
        var x9 = x5.Lcats_data_AndThen$Single__f_index;
        if ((x9 < 128)) {
          var f$1 = x8.andThen__F1__F1(g);
          var index$1 = ((1 + x9) | 0);
          var right = new $c_Lcats_data_AndThen$Single(f$1, index$1);
          return new $c_Lcats_data_AndThen$Concat(x4, right);
        }
      }
    }
    var right$1 = new $c_Lcats_data_AndThen$Single(g, 0);
    return new $c_Lcats_data_AndThen$Concat(this, right$1);
  }
});
$c_Lcats_data_AndThen.prototype.compose__F1__Lcats_data_AndThen = (function(g) {
  if ((g instanceof $c_Lcats_data_AndThen)) {
    return $m_Lcats_data_AndThen$().andThen__Lcats_data_AndThen__Lcats_data_AndThen__Lcats_data_AndThen(g, this);
  } else {
    if ((this instanceof $c_Lcats_data_AndThen$Single)) {
      var x27 = this.Lcats_data_AndThen$Single__f_f;
      var x28 = this.Lcats_data_AndThen$Single__f_index;
      if ((x28 < 128)) {
        var f = x27.compose__F1__F1(g);
        var index = ((1 + x28) | 0);
        return new $c_Lcats_data_AndThen$Single(f, index);
      }
    }
    if ((this instanceof $c_Lcats_data_AndThen$Concat)) {
      var x19 = this.Lcats_data_AndThen$Concat__f_left;
      var x20 = this.Lcats_data_AndThen$Concat__f_right;
      if ((x19 instanceof $c_Lcats_data_AndThen$Single)) {
        var x23 = x19.Lcats_data_AndThen$Single__f_f;
        var x24 = x19.Lcats_data_AndThen$Single__f_index;
        if ((x24 < 128)) {
          var f$1 = x23.compose__F1__F1(g);
          var index$1 = ((1 + x24) | 0);
          var left = new $c_Lcats_data_AndThen$Single(f$1, index$1);
          return new $c_Lcats_data_AndThen$Concat(left, x20);
        }
      }
    }
    var left$1 = new $c_Lcats_data_AndThen$Single(g, 0);
    return new $c_Lcats_data_AndThen$Concat(left$1, this);
  }
});
$c_Lcats_data_AndThen.prototype.toString__T = (function() {
  return ("AndThen$" + $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$systemIdentityHashCode(this));
});
$c_Lcats_data_AndThen.prototype.andThen__F1__F1 = (function(g) {
  return this.andThen__F1__Lcats_data_AndThen(g);
});
$c_Lcats_data_AndThen.prototype.compose__F1__F1 = (function(g) {
  return this.compose__F1__Lcats_data_AndThen(g);
});
$c_Lcats_data_AndThen.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return (!(!$ps_Lcats_data_AndThen__loop$1__Lcats_data_AndThen__O__O(this, v1)));
});
function $isArrayOf_Lcats_data_AndThen(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_AndThen)));
}
export { $isArrayOf_Lcats_data_AndThen as $isArrayOf_Lcats_data_AndThen };
/** @constructor */
function $c_Lcats_data_AndThen$() {
  $ct_Lcats_data_AndThenInstances0__(this);
}
export { $c_Lcats_data_AndThen$ as $c_Lcats_data_AndThen$ };
$c_Lcats_data_AndThen$.prototype = new $h_Lcats_data_AndThenInstances0();
$c_Lcats_data_AndThen$.prototype.constructor = $c_Lcats_data_AndThen$;
/** @constructor */
function $h_Lcats_data_AndThen$() {
}
export { $h_Lcats_data_AndThen$ as $h_Lcats_data_AndThen$ };
$h_Lcats_data_AndThen$.prototype = $c_Lcats_data_AndThen$.prototype;
$c_Lcats_data_AndThen$.prototype.apply__F1__Lcats_data_AndThen = (function(f) {
  return ((f instanceof $c_Lcats_data_AndThen) ? f : new $c_Lcats_data_AndThen$Single(f, 0));
});
$c_Lcats_data_AndThen$.prototype.andThen__Lcats_data_AndThen__Lcats_data_AndThen__Lcats_data_AndThen = (function(ab, bc) {
  if ((ab instanceof $c_Lcats_data_AndThen$Single)) {
    var x177 = ab.Lcats_data_AndThen$Single__f_f;
    var x178 = ab.Lcats_data_AndThen$Single__f_index;
    if ((bc instanceof $c_Lcats_data_AndThen$Single)) {
      var x151 = bc.Lcats_data_AndThen$Single__f_f;
      var x152 = bc.Lcats_data_AndThen$Single__f_index;
      if ((((x178 + x152) | 0) < 128)) {
        var f = x177.andThen__F1__F1(x151);
        var index = ((1 + ((x178 + x152) | 0)) | 0);
        return new $c_Lcats_data_AndThen$Single(f, index);
      } else {
        return new $c_Lcats_data_AndThen$Concat(ab, bc);
      }
    }
    if ((bc instanceof $c_Lcats_data_AndThen$Concat)) {
      var x143 = bc.Lcats_data_AndThen$Concat__f_left;
      var x144 = bc.Lcats_data_AndThen$Concat__f_right;
      if ((x143 instanceof $c_Lcats_data_AndThen$Single)) {
        var x147 = x143.Lcats_data_AndThen$Single__f_f;
        var x148 = x143.Lcats_data_AndThen$Single__f_index;
        if ((((x178 + x148) | 0) < 128)) {
          var f$1 = x177.andThen__F1__F1(x147);
          var index$1 = ((1 + ((x178 + x148) | 0)) | 0);
          var left = new $c_Lcats_data_AndThen$Single(f$1, index$1);
          return new $c_Lcats_data_AndThen$Concat(left, x144);
        }
      }
    }
    return new $c_Lcats_data_AndThen$Concat(ab, bc);
  }
  if ((ab instanceof $c_Lcats_data_AndThen$Concat)) {
    var x169 = ab.Lcats_data_AndThen$Concat__f_left;
    var x170 = ab.Lcats_data_AndThen$Concat__f_right;
    if ((x170 instanceof $c_Lcats_data_AndThen$Single)) {
      var x173 = x170.Lcats_data_AndThen$Single__f_f;
      var x174 = x170.Lcats_data_AndThen$Single__f_index;
      if ((bc instanceof $c_Lcats_data_AndThen$Single)) {
        var x164 = bc.Lcats_data_AndThen$Single__f_f;
        var x165 = bc.Lcats_data_AndThen$Single__f_index;
        if ((((x174 + x165) | 0) < 128)) {
          var f$2 = x173.andThen__F1__F1(x164);
          var index$2 = ((1 + ((x174 + x165) | 0)) | 0);
          var right = new $c_Lcats_data_AndThen$Single(f$2, index$2);
          return new $c_Lcats_data_AndThen$Concat(x169, right);
        } else {
          return new $c_Lcats_data_AndThen$Concat(ab, bc);
        }
      }
      if ((bc instanceof $c_Lcats_data_AndThen$Concat)) {
        var x156 = bc.Lcats_data_AndThen$Concat__f_left;
        var x157 = bc.Lcats_data_AndThen$Concat__f_right;
        if ((x156 instanceof $c_Lcats_data_AndThen$Single)) {
          var x160 = x156.Lcats_data_AndThen$Single__f_f;
          var x161 = x156.Lcats_data_AndThen$Single__f_index;
          if ((((x174 + x161) | 0) < 128)) {
            var f$3 = x173.andThen__F1__F1(x160);
            var index$3 = ((1 + ((x174 + x161) | 0)) | 0);
            var left$1 = new $c_Lcats_data_AndThen$Single(f$3, index$3);
            var right$1 = new $c_Lcats_data_AndThen$Concat(left$1, x157);
            return new $c_Lcats_data_AndThen$Concat(x169, right$1);
          }
        }
      }
      return new $c_Lcats_data_AndThen$Concat(ab, bc);
    }
  }
  return new $c_Lcats_data_AndThen$Concat(ab, bc);
});
$c_Lcats_data_AndThen$.prototype.ordinal__Lcats_data_AndThen__I = (function(x$0) {
  if ((x$0 instanceof $c_Lcats_data_AndThen$Single)) {
    return 0;
  }
  if ((x$0 instanceof $c_Lcats_data_AndThen$Concat)) {
    return 1;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$0);
});
$c_Lcats_data_AndThen$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Lcats_data_AndThen__I(x);
});
var $d_Lcats_data_AndThen$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_data_AndThen$, "cats.data.AndThen$", ({
  Lcats_data_AndThen$: 1,
  Lcats_data_AndThenInstances0: 1,
  Lcats_data_AndThenInstances1: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lcats_data_AndThen$ as $d_Lcats_data_AndThen$ };
var $n_Lcats_data_AndThen$;
function $m_Lcats_data_AndThen$() {
  if ((!$n_Lcats_data_AndThen$)) {
    $n_Lcats_data_AndThen$ = new $c_Lcats_data_AndThen$();
  }
  return $n_Lcats_data_AndThen$;
}
export { $m_Lcats_data_AndThen$ as $m_Lcats_data_AndThen$ };
/** @constructor */
function $c_Lcats_data_IndexedStateTInstances() {
}
export { $c_Lcats_data_IndexedStateTInstances as $c_Lcats_data_IndexedStateTInstances };
$c_Lcats_data_IndexedStateTInstances.prototype = new $h_Lcats_data_IndexedStateTInstances1();
$c_Lcats_data_IndexedStateTInstances.prototype.constructor = $c_Lcats_data_IndexedStateTInstances;
/** @constructor */
function $h_Lcats_data_IndexedStateTInstances() {
}
export { $h_Lcats_data_IndexedStateTInstances as $h_Lcats_data_IndexedStateTInstances };
$h_Lcats_data_IndexedStateTInstances.prototype = $c_Lcats_data_IndexedStateTInstances.prototype;
/** @constructor */
function $c_Lcats_data_KleisliInstances5() {
}
export { $c_Lcats_data_KleisliInstances5 as $c_Lcats_data_KleisliInstances5 };
$c_Lcats_data_KleisliInstances5.prototype = new $h_Lcats_data_KleisliInstances6();
$c_Lcats_data_KleisliInstances5.prototype.constructor = $c_Lcats_data_KleisliInstances5;
/** @constructor */
function $h_Lcats_data_KleisliInstances5() {
}
export { $h_Lcats_data_KleisliInstances5 as $h_Lcats_data_KleisliInstances5 };
$h_Lcats_data_KleisliInstances5.prototype = $c_Lcats_data_KleisliInstances5.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptySetImpl$() {
  $ct_Lcats_data_NonEmptySetInstances__(this);
}
export { $c_Lcats_data_NonEmptySetImpl$ as $c_Lcats_data_NonEmptySetImpl$ };
$c_Lcats_data_NonEmptySetImpl$.prototype = new $h_Lcats_data_NonEmptySetInstances();
$c_Lcats_data_NonEmptySetImpl$.prototype.constructor = $c_Lcats_data_NonEmptySetImpl$;
/** @constructor */
function $h_Lcats_data_NonEmptySetImpl$() {
}
export { $h_Lcats_data_NonEmptySetImpl$ as $h_Lcats_data_NonEmptySetImpl$ };
$h_Lcats_data_NonEmptySetImpl$.prototype = $c_Lcats_data_NonEmptySetImpl$.prototype;
$c_Lcats_data_NonEmptySetImpl$.prototype.fromSet__sci_SortedSet__s_Option = (function(as) {
  return ((!as.isEmpty__Z()) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Option$().apply__O__s_Option(as) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lcats_data_NonEmptySetImpl$.prototype.apply__O__sci_SortedSet__Lcats_kernel_Order__O = (function(head, tail, A) {
  var this$1 = $m_sci_SortedSet$().apply__sci_Seq__O__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([head])), A.toOrdering__s_math_Ordering());
  var s = this$1.concat__sc_IterableOnce__sc_SetOps(tail);
  return s;
});
var $d_Lcats_data_NonEmptySetImpl$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_data_NonEmptySetImpl$, "cats.data.NonEmptySetImpl$", ({
  Lcats_data_NonEmptySetImpl$: 1,
  Lcats_data_NonEmptySetInstances: 1,
  Lcats_data_NonEmptySetInstances0: 1,
  Lcats_data_NonEmptySetInstances1: 1,
  Lcats_data_Newtype: 1
}));
export { $d_Lcats_data_NonEmptySetImpl$ as $d_Lcats_data_NonEmptySetImpl$ };
var $n_Lcats_data_NonEmptySetImpl$;
function $m_Lcats_data_NonEmptySetImpl$() {
  if ((!$n_Lcats_data_NonEmptySetImpl$)) {
    $n_Lcats_data_NonEmptySetImpl$ = new $c_Lcats_data_NonEmptySetImpl$();
  }
  return $n_Lcats_data_NonEmptySetImpl$;
}
export { $m_Lcats_data_NonEmptySetImpl$ as $m_Lcats_data_NonEmptySetImpl$ };
/** @constructor */
function $c_Lcats_data_OptionTInstances() {
}
export { $c_Lcats_data_OptionTInstances as $c_Lcats_data_OptionTInstances };
$c_Lcats_data_OptionTInstances.prototype = new $h_Lcats_data_OptionTInstances0();
$c_Lcats_data_OptionTInstances.prototype.constructor = $c_Lcats_data_OptionTInstances;
/** @constructor */
function $h_Lcats_data_OptionTInstances() {
}
export { $h_Lcats_data_OptionTInstances as $h_Lcats_data_OptionTInstances };
$h_Lcats_data_OptionTInstances.prototype = $c_Lcats_data_OptionTInstances.prototype;
function $f_Lcats_derived_DerivedOrder$package$DerivedOrder$Coproduct__compare__O__O__I($thiz, x, y) {
  var this$1 = $thiz.Lcats_derived_DerivedOrder$package$DerivedOrder$$anon$1__f_cats$derived$DerivedOrder$package$DerivedOrder$Coproduct$$inst;
  var i = this$1.Lshapeless3_deriving_internals_ErasedCoproductInstances__f_mirror.ordinal__O__I(x);
  var j = this$1.Lshapeless3_deriving_internals_ErasedCoproductInstances__f_mirror.ordinal__O__I(y);
  if ((i === j)) {
    var ord = $p_Lshapeless3_deriving_internals_ErasedCoproductInstances__is__AO(this$1).u[i];
    return ord.compare__O__O__I(x, y);
  } else {
    return ((i - j) | 0);
  }
}
export { $f_Lcats_derived_DerivedOrder$package$DerivedOrder$Coproduct__compare__O__O__I as $f_Lcats_derived_DerivedOrder$package$DerivedOrder$Coproduct__compare__O__O__I };
function $f_Lcats_derived_DerivedOrder$package$DerivedOrder$Product__compare__O__O__I($thiz, x, y) {
  var f$proxy1 = new $c_Lcats_derived_DerivedOrder$package$DerivedOrder$Product$$anon$2();
  return ($thiz.Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$$anon$4__f_cats$derived$DerivedOrder$package$DerivedOrder$Product$$inst.erasedFoldLeft2__O__O__O__F4__O(x, y, 0, f$proxy1) | 0);
}
export { $f_Lcats_derived_DerivedOrder$package$DerivedOrder$Product__compare__O__O__I as $f_Lcats_derived_DerivedOrder$package$DerivedOrder$Product__compare__O__O__I };
/** @constructor */
function $c_Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$3(x$1$1, evidence$1$1) {
  this.Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$3__f_cats$derived$DerivedShow$package$DerivedShow$Product$$inst = null;
  this.Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$3__f_cats$derived$DerivedShow$package$DerivedShow$Product$$labelling = null;
  this.Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$3__f_cats$derived$DerivedShow$package$DerivedShow$Product$$inst = x$1$1.apply__O();
  this.Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$3__f_cats$derived$DerivedShow$package$DerivedShow$Product$$labelling = evidence$1$1;
}
export { $c_Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$3 as $c_Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$3 };
$c_Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$3.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$3.prototype.constructor = $c_Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$3;
/** @constructor */
function $h_Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$3() {
}
export { $h_Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$3 as $h_Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$3 };
$h_Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$3.prototype = $c_Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$3.prototype;
$c_Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$3.prototype.show__O__T = (function(a) {
  return $f_Lcats_derived_DerivedShow$package$DerivedShow$Product__show__O__T(this, a);
});
var $d_Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$3, "cats.derived.DerivedShow$package$DerivedShow$Strict$$anon$3", ({
  Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lcats_Show$ContravariantShow: 1,
  Lcats_Show: 1,
  Lcats_derived_DerivedShow$package$DerivedShow$Product: 1
}));
export { $d_Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$3 as $d_Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$3 };
/** @constructor */
function $c_Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$4(given_CoproductInstances_Show_A$lzy1$3, inst$6) {
  this.Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$4__f_cats$derived$DerivedShow$package$DerivedShow$Coproduct$$inst = null;
  this.Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$4__f_cats$derived$DerivedShow$package$DerivedShow$Coproduct$$inst = $m_Lcats_derived_DerivedShow$package$DerivedShow$Strict$().cats$derived$DerivedShow$package$DerivedShow$Strict$$$_$given_CoproductInstances_Show_A$1__sr_LazyRef__F0__Lshapeless3_deriving_internals_ErasedCoproductInstances(given_CoproductInstances_Show_A$lzy1$3, inst$6);
}
export { $c_Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$4 as $c_Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$4 };
$c_Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$4.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$4.prototype.constructor = $c_Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$4;
/** @constructor */
function $h_Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$4() {
}
export { $h_Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$4 as $h_Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$4 };
$h_Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$4.prototype = $c_Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$4.prototype;
$c_Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$4.prototype.show__O__T = (function(a) {
  return $f_Lcats_derived_DerivedShow$package$DerivedShow$Coproduct__show__O__T(this, a);
});
var $d_Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$4, "cats.derived.DerivedShow$package$DerivedShow$Strict$$anon$4", ({
  Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$4: 1,
  Ljava_io_Serializable: 1,
  Lcats_Show$ContravariantShow: 1,
  Lcats_Show: 1,
  Lcats_derived_DerivedShow$package$DerivedShow$Coproduct: 1
}));
export { $d_Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$4 as $d_Lcats_derived_DerivedShow$package$DerivedShow$Strict$$anon$4 };
/** @constructor */
function $c_Lcats_effect_IO$$anon$1(finalizer$7) {
  this.Lcats_effect_IO$$anon$1__f_finalizer$2 = null;
  this.Lcats_effect_IO$$anon$1__f_finalizer$2 = finalizer$7;
}
export { $c_Lcats_effect_IO$$anon$1 as $c_Lcats_effect_IO$$anon$1 };
$c_Lcats_effect_IO$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$c_Lcats_effect_IO$$anon$1.prototype.constructor = $c_Lcats_effect_IO$$anon$1;
/** @constructor */
function $h_Lcats_effect_IO$$anon$1() {
}
export { $h_Lcats_effect_IO$$anon$1 as $h_Lcats_effect_IO$$anon$1 };
$h_Lcats_effect_IO$$anon$1.prototype = $c_Lcats_effect_IO$$anon$1.prototype;
$c_Lcats_effect_IO$$anon$1.prototype.isDefinedAt__jl_Throwable__Z = (function(x) {
  return true;
});
$c_Lcats_effect_IO$$anon$1.prototype.applyOrElse__jl_Throwable__F1__O = (function(x, default$1) {
  var $x_1 = this.Lcats_effect_IO$$anon$1__f_finalizer$2;
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_$less$colon$less$();
  return $x_1.reportError__s_$less$colon$less__Lcats_effect_IO(this$1.s_$less$colon$less$__f_singleton);
});
$c_Lcats_effect_IO$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z(x);
});
$c_Lcats_effect_IO$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__jl_Throwable__F1__O(x, default$1);
});
var $d_Lcats_effect_IO$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IO$$anon$1, "cats.effect.IO$$anon$1", ({
  Lcats_effect_IO$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_effect_IO$$anon$1 as $d_Lcats_effect_IO$$anon$1 };
/** @constructor */
function $c_Lcats_effect_IO$$anon$2(finalizer$8) {
  this.Lcats_effect_IO$$anon$2__f_finalizer$5 = null;
  this.Lcats_effect_IO$$anon$2__f_finalizer$5 = finalizer$8;
}
export { $c_Lcats_effect_IO$$anon$2 as $c_Lcats_effect_IO$$anon$2 };
$c_Lcats_effect_IO$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$c_Lcats_effect_IO$$anon$2.prototype.constructor = $c_Lcats_effect_IO$$anon$2;
/** @constructor */
function $h_Lcats_effect_IO$$anon$2() {
}
export { $h_Lcats_effect_IO$$anon$2 as $h_Lcats_effect_IO$$anon$2 };
$h_Lcats_effect_IO$$anon$2.prototype = $c_Lcats_effect_IO$$anon$2.prototype;
$c_Lcats_effect_IO$$anon$2.prototype.isDefinedAt__jl_Throwable__Z = (function(x) {
  return true;
});
$c_Lcats_effect_IO$$anon$2.prototype.applyOrElse__jl_Throwable__F1__O = (function(x, default$1) {
  var $x_1 = this.Lcats_effect_IO$$anon$2__f_finalizer$5.apply__O__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Errored(x));
  var this$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_$less$colon$less$();
  return $x_1.reportError__s_$less$colon$less__Lcats_effect_IO(this$3.s_$less$colon$less$__f_singleton);
});
$c_Lcats_effect_IO$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z(x);
});
$c_Lcats_effect_IO$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__jl_Throwable__F1__O(x, default$1);
});
var $d_Lcats_effect_IO$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IO$$anon$2, "cats.effect.IO$$anon$2", ({
  Lcats_effect_IO$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_effect_IO$$anon$2 as $d_Lcats_effect_IO$$anon$2 };
function $p_Lcats_effect_IODeferred__clear$1__I__V($thiz, handle$1) {
  var stack = $thiz.Lcats_effect_IODeferred__f_callbacks;
  delete stack[handle$1];
  var removed = true;
  if ((!removed)) {
    var this$3 = $thiz.Lcats_effect_IODeferred__f_clearCounter;
    var newValue = ((1 + this$3.ju_concurrent_atomic_AtomicInteger__f_java$util$concurrent$atomic$AtomicInteger$$value) | 0);
    this$3.ju_concurrent_atomic_AtomicInteger__f_java$util$concurrent$atomic$AtomicInteger$$value = newValue;
    if (((newValue & (((-1) + newValue) | 0)) === 0)) {
      var this$6 = $thiz.Lcats_effect_IODeferred__f_clearCounter;
      var delta = ((-((newValue - newValue) | 0)) | 0);
      var newValue$1 = ((this$6.ju_concurrent_atomic_AtomicInteger__f_java$util$concurrent$atomic$AtomicInteger$$value + delta) | 0);
      this$6.ju_concurrent_atomic_AtomicInteger__f_java$util$concurrent$atomic$AtomicInteger$$value = newValue$1;
    }
  }
}
export { $p_Lcats_effect_IODeferred__clear$1__I__V as $p_Lcats_effect_IODeferred__clear$1__I__V };
/** @constructor */
function $c_Lcats_effect_IODeferred() {
  this.Lcats_effect_IODeferred__f_initial = null;
  this.Lcats_effect_IODeferred__f_cell = null;
  this.Lcats_effect_IODeferred__f_callbacks = null;
  this.Lcats_effect_IODeferred__f_clearCounter = null;
  var await$1 = $m_Lcats_effect_IO$().asyncCheckAttempt__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((cb) => {
    var this$8 = $m_Lcats_effect_IO$();
    var thunk$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((cb$2) => (() => {
      var stack = this.Lcats_effect_IODeferred__f_callbacks;
      stack.push(cb$2);
      var handle = (((-1) + (stack.length | 0)) | 0);
      var back = this.Lcats_effect_IODeferred__f_cell.ju_concurrent_atomic_AtomicReference__f_value;
      if ((back === this.Lcats_effect_IODeferred__f_initial)) {
        var this$4 = $m_Lcats_effect_IO$();
        var thunk = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
          $p_Lcats_effect_IODeferred__clear$1__I__V(this, handle);
        }));
        var value = this$4.delay__F0__Lcats_effect_IO(thunk);
        var value$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value$1);
      } else {
        $p_Lcats_effect_IODeferred__clear$1__I__V(this, handle);
        var value$2 = back.Lcats_effect_IO$Pure__f_value;
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value$2);
      }
    }))(cb));
    return this$8.delay__F0__Lcats_effect_IO(thunk$1);
  })));
  this.Lcats_effect_IODeferred__f_initial = $m_Lcats_effect_IO$().defer__F0__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    var back$1 = this.Lcats_effect_IODeferred__f_cell.ju_concurrent_atomic_AtomicReference__f_value;
    return ((back$1 === this.Lcats_effect_IODeferred__f_initial) ? await$1 : back$1);
  })));
  this.Lcats_effect_IODeferred__f_cell = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_ju_concurrent_atomic_AtomicReference__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_ju_concurrent_atomic_AtomicReference(), this.Lcats_effect_IODeferred__f_initial);
  this.Lcats_effect_IODeferred__f_callbacks = [null];
  this.Lcats_effect_IODeferred__f_clearCounter = $ct_ju_concurrent_atomic_AtomicInteger__(new $c_ju_concurrent_atomic_AtomicInteger());
}
export { $c_Lcats_effect_IODeferred as $c_Lcats_effect_IODeferred };
$c_Lcats_effect_IODeferred.prototype = new $h_Lcats_effect_kernel_Deferred();
$c_Lcats_effect_IODeferred.prototype.constructor = $c_Lcats_effect_IODeferred;
/** @constructor */
function $h_Lcats_effect_IODeferred() {
}
export { $h_Lcats_effect_IODeferred as $h_Lcats_effect_IODeferred };
$h_Lcats_effect_IODeferred.prototype = $c_Lcats_effect_IODeferred.prototype;
$c_Lcats_effect_IODeferred.prototype.complete__O__Lcats_effect_IO = (function(a) {
  var this$8 = $m_Lcats_effect_IO$();
  var thunk = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    if (this.Lcats_effect_IODeferred__f_cell.compareAndSet__O__O__Z(this.Lcats_effect_IODeferred__f_initial, ($m_Lcats_effect_IO$(), new $c_Lcats_effect_IO$Pure(a)))) {
      var stack = this.Lcats_effect_IODeferred__f_callbacks;
      var oc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(a);
      (!(!stack.reduceRight($m_sjs_js_Any$().fromFunction2__F2__sjs_js_Function2(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((acc, cb) => {
        var acc$1 = (!(!acc));
        return ((cb !== null) ? (cb.apply__O__O(oc), true) : acc$1);
      }))), false)));
      return true;
    } else {
      return false;
    }
  }));
  return this$8.delay__F0__Lcats_effect_IO(thunk);
});
$c_Lcats_effect_IODeferred.prototype.get__Lcats_effect_IO = (function() {
  return this.Lcats_effect_IODeferred__f_cell.ju_concurrent_atomic_AtomicReference__f_value;
});
var $d_Lcats_effect_IODeferred = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IODeferred, "cats.effect.IODeferred", ({
  Lcats_effect_IODeferred: 1,
  Lcats_effect_kernel_Deferred: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_DeferredSource: 1,
  Lcats_effect_kernel_DeferredSink: 1
}));
export { $d_Lcats_effect_IODeferred as $d_Lcats_effect_IODeferred };
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Allocate(resource) {
  this.Lcats_effect_kernel_Resource$Allocate__f_resource = null;
  this.Lcats_effect_kernel_Resource$Allocate__f_resource = resource;
}
export { $c_Lcats_effect_kernel_Resource$Allocate as $c_Lcats_effect_kernel_Resource$Allocate };
$c_Lcats_effect_kernel_Resource$Allocate.prototype = new $h_Lcats_effect_kernel_Resource();
$c_Lcats_effect_kernel_Resource$Allocate.prototype.constructor = $c_Lcats_effect_kernel_Resource$Allocate;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Allocate() {
}
export { $h_Lcats_effect_kernel_Resource$Allocate as $h_Lcats_effect_kernel_Resource$Allocate };
$h_Lcats_effect_kernel_Resource$Allocate.prototype = $c_Lcats_effect_kernel_Resource$Allocate.prototype;
$c_Lcats_effect_kernel_Resource$Allocate.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Resource$Allocate.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_kernel_Resource$Allocate.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Resource$Allocate)) {
    var x = this.Lcats_effect_kernel_Resource$Allocate__f_resource;
    var x$2 = x$0.Lcats_effect_kernel_Resource$Allocate__f_resource;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lcats_effect_kernel_Resource$Allocate.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_kernel_Resource$Allocate.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_kernel_Resource$Allocate.prototype.productPrefix__T = (function() {
  return "Allocate";
});
$c_Lcats_effect_kernel_Resource$Allocate.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Resource$Allocate__f_resource;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_kernel_Resource$Allocate.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "resource";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcats_effect_kernel_Resource$Allocate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Allocate)));
}
export { $isArrayOf_Lcats_effect_kernel_Resource$Allocate as $isArrayOf_Lcats_effect_kernel_Resource$Allocate };
var $d_Lcats_effect_kernel_Resource$Allocate = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_kernel_Resource$Allocate, "cats.effect.kernel.Resource$Allocate", ({
  Lcats_effect_kernel_Resource$Allocate: 1,
  Lcats_effect_kernel_Resource: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lcats_effect_kernel_Resource$Allocate as $d_Lcats_effect_kernel_Resource$Allocate };
function $isArrayOf_Lcats_effect_kernel_Resource$Bind(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Bind)));
}
export { $isArrayOf_Lcats_effect_kernel_Resource$Bind as $isArrayOf_Lcats_effect_kernel_Resource$Bind };
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Eval(fa) {
  this.Lcats_effect_kernel_Resource$Eval__f_fa = null;
  this.Lcats_effect_kernel_Resource$Eval__f_fa = fa;
}
export { $c_Lcats_effect_kernel_Resource$Eval as $c_Lcats_effect_kernel_Resource$Eval };
$c_Lcats_effect_kernel_Resource$Eval.prototype = new $h_Lcats_effect_kernel_Resource();
$c_Lcats_effect_kernel_Resource$Eval.prototype.constructor = $c_Lcats_effect_kernel_Resource$Eval;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Eval() {
}
export { $h_Lcats_effect_kernel_Resource$Eval as $h_Lcats_effect_kernel_Resource$Eval };
$h_Lcats_effect_kernel_Resource$Eval.prototype = $c_Lcats_effect_kernel_Resource$Eval.prototype;
$c_Lcats_effect_kernel_Resource$Eval.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Resource$Eval.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_kernel_Resource$Eval.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Resource$Eval)) {
    var x = this.Lcats_effect_kernel_Resource$Eval__f_fa;
    var y = x$0.Lcats_effect_kernel_Resource$Eval__f_fa;
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_effect_kernel_Resource$Eval.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_kernel_Resource$Eval.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_kernel_Resource$Eval.prototype.productPrefix__T = (function() {
  return "Eval";
});
$c_Lcats_effect_kernel_Resource$Eval.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Resource$Eval__f_fa;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_kernel_Resource$Eval.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "fa";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcats_effect_kernel_Resource$Eval(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Eval)));
}
export { $isArrayOf_Lcats_effect_kernel_Resource$Eval as $isArrayOf_Lcats_effect_kernel_Resource$Eval };
var $d_Lcats_effect_kernel_Resource$Eval = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_kernel_Resource$Eval, "cats.effect.kernel.Resource$Eval", ({
  Lcats_effect_kernel_Resource$Eval: 1,
  Lcats_effect_kernel_Resource: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lcats_effect_kernel_Resource$Eval as $d_Lcats_effect_kernel_Resource$Eval };
/** @constructor */
function $c_Lcats_effect_kernel_Resource$ExitCase$Errored(e) {
  this.Lcats_effect_kernel_Resource$ExitCase$Errored__f_e = null;
  this.Lcats_effect_kernel_Resource$ExitCase$Errored__f_e = e;
}
export { $c_Lcats_effect_kernel_Resource$ExitCase$Errored as $c_Lcats_effect_kernel_Resource$ExitCase$Errored };
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype.constructor = $c_Lcats_effect_kernel_Resource$ExitCase$Errored;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$ExitCase$Errored() {
}
export { $h_Lcats_effect_kernel_Resource$ExitCase$Errored as $h_Lcats_effect_kernel_Resource$ExitCase$Errored };
$h_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype = $c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype;
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Resource$ExitCase$Errored)) {
    var x = this.Lcats_effect_kernel_Resource$ExitCase$Errored__f_e;
    var x$2 = x$0.Lcats_effect_kernel_Resource$ExitCase$Errored__f_e;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype.productPrefix__T = (function() {
  return "Errored";
});
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Resource$ExitCase$Errored__f_e;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "e";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcats_effect_kernel_Resource$ExitCase$Errored(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$ExitCase$Errored)));
}
export { $isArrayOf_Lcats_effect_kernel_Resource$ExitCase$Errored as $isArrayOf_Lcats_effect_kernel_Resource$ExitCase$Errored };
var $d_Lcats_effect_kernel_Resource$ExitCase$Errored = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_kernel_Resource$ExitCase$Errored, "cats.effect.kernel.Resource$ExitCase$Errored", ({
  Lcats_effect_kernel_Resource$ExitCase$Errored: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Resource$ExitCase: 1
}));
export { $d_Lcats_effect_kernel_Resource$ExitCase$Errored as $d_Lcats_effect_kernel_Resource$ExitCase$Errored };
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Frame$1(outer, head, tail) {
  this.Lcats_effect_kernel_Resource$Frame$1__f_head = null;
  this.Lcats_effect_kernel_Resource$Frame$1__f_tail = null;
  this.Lcats_effect_kernel_Resource$Frame$1__f_head = head;
  this.Lcats_effect_kernel_Resource$Frame$1__f_tail = tail;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lcats_effect_kernel_Resource$Frame$1 as $c_Lcats_effect_kernel_Resource$Frame$1 };
$c_Lcats_effect_kernel_Resource$Frame$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_kernel_Resource$Frame$1.prototype.constructor = $c_Lcats_effect_kernel_Resource$Frame$1;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Frame$1() {
}
export { $h_Lcats_effect_kernel_Resource$Frame$1 as $h_Lcats_effect_kernel_Resource$Frame$1 };
$h_Lcats_effect_kernel_Resource$Frame$1.prototype = $c_Lcats_effect_kernel_Resource$Frame$1.prototype;
$c_Lcats_effect_kernel_Resource$Frame$1.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Resource$Frame$1.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_kernel_Resource$Frame$1.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Resource$Frame$1)) {
    var x = this.Lcats_effect_kernel_Resource$Frame$1__f_head;
    var x$2 = x$0.Lcats_effect_kernel_Resource$Frame$1__f_head;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_kernel_Resource$Frame$1__f_tail;
      var x$4 = x$0.Lcats_effect_kernel_Resource$Frame$1__f_tail;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_kernel_Resource$Frame$1.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_kernel_Resource$Frame$1.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_kernel_Resource$Frame$1.prototype.productPrefix__T = (function() {
  return "Frame";
});
$c_Lcats_effect_kernel_Resource$Frame$1.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Resource$Frame$1__f_head;
  }
  if ((n === 1)) {
    return this.Lcats_effect_kernel_Resource$Frame$1__f_tail;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_kernel_Resource$Frame$1.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "head";
  }
  if ((n === 1)) {
    return "tail";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcats_effect_kernel_Resource$Frame$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Frame$1)));
}
export { $isArrayOf_Lcats_effect_kernel_Resource$Frame$1 as $isArrayOf_Lcats_effect_kernel_Resource$Frame$1 };
var $d_Lcats_effect_kernel_Resource$Frame$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_kernel_Resource$Frame$1, "cats.effect.kernel.Resource$Frame$1", ({
  Lcats_effect_kernel_Resource$Frame$1: 1,
  Lcats_effect_kernel_Resource$Stack$1: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_effect_kernel_Resource$Frame$1 as $d_Lcats_effect_kernel_Resource$Frame$1 };
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Pure(a) {
  this.Lcats_effect_kernel_Resource$Pure__f_a = null;
  this.Lcats_effect_kernel_Resource$Pure__f_a = a;
}
export { $c_Lcats_effect_kernel_Resource$Pure as $c_Lcats_effect_kernel_Resource$Pure };
$c_Lcats_effect_kernel_Resource$Pure.prototype = new $h_Lcats_effect_kernel_Resource();
$c_Lcats_effect_kernel_Resource$Pure.prototype.constructor = $c_Lcats_effect_kernel_Resource$Pure;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Pure() {
}
export { $h_Lcats_effect_kernel_Resource$Pure as $h_Lcats_effect_kernel_Resource$Pure };
$h_Lcats_effect_kernel_Resource$Pure.prototype = $c_Lcats_effect_kernel_Resource$Pure.prototype;
$c_Lcats_effect_kernel_Resource$Pure.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Resource$Pure.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_kernel_Resource$Pure.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Resource$Pure)) {
    var x = this.Lcats_effect_kernel_Resource$Pure__f_a;
    var y = x$0.Lcats_effect_kernel_Resource$Pure__f_a;
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_effect_kernel_Resource$Pure.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_kernel_Resource$Pure.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_kernel_Resource$Pure.prototype.productPrefix__T = (function() {
  return "Pure";
});
$c_Lcats_effect_kernel_Resource$Pure.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Resource$Pure__f_a;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_kernel_Resource$Pure.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "a";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcats_effect_kernel_Resource$Pure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Pure)));
}
export { $isArrayOf_Lcats_effect_kernel_Resource$Pure as $isArrayOf_Lcats_effect_kernel_Resource$Pure };
var $d_Lcats_effect_kernel_Resource$Pure = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_kernel_Resource$Pure, "cats.effect.kernel.Resource$Pure", ({
  Lcats_effect_kernel_Resource$Pure: 1,
  Lcats_effect_kernel_Resource: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lcats_effect_kernel_Resource$Pure as $d_Lcats_effect_kernel_Resource$Pure };
/** @constructor */
function $c_Lcats_effect_kernel_SyncRef(value, F) {
  this.Lcats_effect_kernel_SyncRef__f_value = null;
  this.Lcats_effect_kernel_SyncRef__f_F = null;
  this.Lcats_effect_kernel_SyncRef__f_value = value;
  this.Lcats_effect_kernel_SyncRef__f_F = F;
}
export { $c_Lcats_effect_kernel_SyncRef as $c_Lcats_effect_kernel_SyncRef };
$c_Lcats_effect_kernel_SyncRef.prototype = new $h_Lcats_effect_kernel_Ref();
$c_Lcats_effect_kernel_SyncRef.prototype.constructor = $c_Lcats_effect_kernel_SyncRef;
/** @constructor */
function $h_Lcats_effect_kernel_SyncRef() {
}
export { $h_Lcats_effect_kernel_SyncRef as $h_Lcats_effect_kernel_SyncRef };
$h_Lcats_effect_kernel_SyncRef.prototype = $c_Lcats_effect_kernel_SyncRef.prototype;
$c_Lcats_effect_kernel_SyncRef.prototype.get__O = (function() {
  return this.Lcats_effect_kernel_SyncRef__f_F.delay__F0__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => this.Lcats_effect_kernel_SyncRef__f_value)));
});
$c_Lcats_effect_kernel_SyncRef.prototype.getAndUpdate__F1__O = (function(f) {
  return this.Lcats_effect_kernel_SyncRef__f_F.delay__F0__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    var current = this.Lcats_effect_kernel_SyncRef__f_value;
    this.Lcats_effect_kernel_SyncRef__f_value = f.apply__O__O(current);
    return current;
  })));
});
$c_Lcats_effect_kernel_SyncRef.prototype.update__F1__O = (function(f) {
  return this.Lcats_effect_kernel_SyncRef__f_F.delay__F0__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    this.Lcats_effect_kernel_SyncRef__f_value = f.apply__O__O(this.Lcats_effect_kernel_SyncRef__f_value);
  })));
});
$c_Lcats_effect_kernel_SyncRef.prototype.modify__F1__O = (function(f) {
  return this.Lcats_effect_kernel_SyncRef__f_F.delay__F0__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    matchResult2: {
      var \u03b42$___1;
      var \u03b42$___2;
      var x4 = f.apply__O__O(this.Lcats_effect_kernel_SyncRef__f_value);
      if ((x4 !== null)) {
        var u = x4._1__O();
        var b = x4._2__O();
        var \u03b42$___1 = u;
        var \u03b42$___2 = b;
        break matchResult2;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x4);
    }
    var u$2 = \u03b42$___1;
    var b$2 = \u03b42$___2;
    this.Lcats_effect_kernel_SyncRef__f_value = u$2;
    return b$2;
  })));
});
var $d_Lcats_effect_kernel_SyncRef = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_kernel_SyncRef, "cats.effect.kernel.SyncRef", ({
  Lcats_effect_kernel_SyncRef: 1,
  Lcats_effect_kernel_Ref: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_RefSource: 1,
  Lcats_effect_kernel_RefSink: 1
}));
export { $d_Lcats_effect_kernel_SyncRef as $d_Lcats_effect_kernel_SyncRef };
/** @constructor */
function $c_Lcats_effect_std_EnvCompanionPlatform$$anon$1() {
}
export { $c_Lcats_effect_std_EnvCompanionPlatform$$anon$1 as $c_Lcats_effect_std_EnvCompanionPlatform$$anon$1 };
$c_Lcats_effect_std_EnvCompanionPlatform$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$c_Lcats_effect_std_EnvCompanionPlatform$$anon$1.prototype.constructor = $c_Lcats_effect_std_EnvCompanionPlatform$$anon$1;
/** @constructor */
function $h_Lcats_effect_std_EnvCompanionPlatform$$anon$1() {
}
export { $h_Lcats_effect_std_EnvCompanionPlatform$$anon$1 as $h_Lcats_effect_std_EnvCompanionPlatform$$anon$1 };
$h_Lcats_effect_std_EnvCompanionPlatform$$anon$1.prototype = $c_Lcats_effect_std_EnvCompanionPlatform$$anon$1.prototype;
$c_Lcats_effect_std_EnvCompanionPlatform$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return ((typeof x) === "string");
});
$c_Lcats_effect_std_EnvCompanionPlatform$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return (((typeof x) === "string") ? x : default$1.apply__O__O(x));
});
var $d_Lcats_effect_std_EnvCompanionPlatform$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_std_EnvCompanionPlatform$$anon$1, "cats.effect.std.EnvCompanionPlatform$$anon$1", ({
  Lcats_effect_std_EnvCompanionPlatform$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_effect_std_EnvCompanionPlatform$$anon$1 as $d_Lcats_effect_std_EnvCompanionPlatform$$anon$1 };
/** @constructor */
function $c_Lcats_effect_tracing_Tracing$$anon$1() {
}
export { $c_Lcats_effect_tracing_Tracing$$anon$1 as $c_Lcats_effect_tracing_Tracing$$anon$1 };
$c_Lcats_effect_tracing_Tracing$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$c_Lcats_effect_tracing_Tracing$$anon$1.prototype.constructor = $c_Lcats_effect_tracing_Tracing$$anon$1;
/** @constructor */
function $h_Lcats_effect_tracing_Tracing$$anon$1() {
}
export { $h_Lcats_effect_tracing_Tracing$$anon$1 as $h_Lcats_effect_tracing_Tracing$$anon$1 };
$h_Lcats_effect_tracing_Tracing$$anon$1.prototype = $c_Lcats_effect_tracing_Tracing$$anon$1.prototype;
$c_Lcats_effect_tracing_Tracing$$anon$1.prototype.isDefinedAt__Lcats_effect_tracing_TracingEvent__Z = (function(x) {
  return false;
});
$c_Lcats_effect_tracing_Tracing$$anon$1.prototype.applyOrElse__Lcats_effect_tracing_TracingEvent__F1__O = (function(x, default$1) {
  return (false ? $m_Lcats_effect_tracing_Tracing$().cats$effect$tracing$Tracing$$$getOpAndCallSite__Ajl_StackTraceElement__jl_StackTraceElement(x.getStackTrace__Ajl_StackTraceElement()) : default$1.apply__O__O(x));
});
$c_Lcats_effect_tracing_Tracing$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lcats_effect_tracing_TracingEvent__Z(x);
});
$c_Lcats_effect_tracing_Tracing$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lcats_effect_tracing_TracingEvent__F1__O(x, default$1);
});
var $d_Lcats_effect_tracing_Tracing$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_tracing_Tracing$$anon$1, "cats.effect.tracing.Tracing$$anon$1", ({
  Lcats_effect_tracing_Tracing$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_effect_tracing_Tracing$$anon$1 as $d_Lcats_effect_tracing_Tracing$$anon$1 };
function $p_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred__resolved__F0($thiz) {
  if ((!$thiz.Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred__f_resolvedbitmap$1)) {
    $thiz.Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred__f_resolved$lzy1 = $p_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred__loop$1__F0__F0($thiz, $thiz.Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred__f_fa);
    $thiz.Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred__f_resolvedbitmap$1 = true;
  }
  return $thiz.Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred__f_resolved$lzy1;
}
export { $p_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred__resolved__F0 as $p_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred__resolved__F0 };
function $p_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred__loop$1__F0__F0($thiz, f) {
  var f$tailLocal1 = f;
  while (true) {
    var x5 = f$tailLocal1.apply__O();
    if (((x5 instanceof $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred) && (x5.Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred__f_$outer === $thiz.Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred__f_$outer))) {
      var x8 = x5.Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred__f_fa;
      f$tailLocal1 = x8;
      continue;
    }
    return x5;
  }
}
export { $p_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred__loop$1__F0__F0 as $p_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred__loop$1__F0__F0 };
/** @constructor */
function $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred(outer, fa) {
  this.Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred__f_fa = null;
  this.Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred__f_resolved$lzy1 = null;
  this.Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred__f_resolvedbitmap$1 = false;
  this.Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred__f_$outer = null;
  this.Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred__f_fa = fa;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred__f_$outer = outer;
}
export { $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred as $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred };
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred.prototype.constructor = $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred;
/** @constructor */
function $h_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred() {
}
export { $h_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred as $h_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred };
$h_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred.prototype = $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred.prototype;
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred) && (x$0.Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred__f_$outer === this.Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred__f_$outer))) {
    var x = this.Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred__f_fa;
    var x$2 = x$0.Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred__f_fa;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred.prototype.productPrefix__T = (function() {
  return "Deferred";
});
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred__f_fa;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "fa";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred.prototype.apply__O = (function() {
  return $p_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred__resolved__F0(this).apply__O();
});
function $isArrayOf_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred)));
}
export { $isArrayOf_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred as $isArrayOf_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred };
var $d_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred, "cats.instances.FunctionInstancesBinCompat0$$anon$1$Deferred", ({
  Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred: 1,
  F0: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred as $d_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred };
function $ct_Lcats_instances_FutureCoflatMap__s_concurrent_ExecutionContext__($thiz, ec) {
  return $thiz;
}
export { $ct_Lcats_instances_FutureCoflatMap__s_concurrent_ExecutionContext__ as $ct_Lcats_instances_FutureCoflatMap__s_concurrent_ExecutionContext__ };
/** @constructor */
function $c_Lcats_instances_FutureCoflatMap() {
}
export { $c_Lcats_instances_FutureCoflatMap as $c_Lcats_instances_FutureCoflatMap };
$c_Lcats_instances_FutureCoflatMap.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_FutureCoflatMap.prototype.constructor = $c_Lcats_instances_FutureCoflatMap;
/** @constructor */
function $h_Lcats_instances_FutureCoflatMap() {
}
export { $h_Lcats_instances_FutureCoflatMap as $h_Lcats_instances_FutureCoflatMap };
$h_Lcats_instances_FutureCoflatMap.prototype = $c_Lcats_instances_FutureCoflatMap.prototype;
$c_Lcats_instances_FutureCoflatMap.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return this.map__s_concurrent_Future__F1__s_concurrent_Future(fa, f);
});
$c_Lcats_instances_FutureCoflatMap.prototype.void__O__O = (function(fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_instances_FutureCoflatMap.prototype.as__O__O__O = (function(fa, b) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Functor__as__O__O__O(this, fa, b);
});
/** @constructor */
function $c_Lcats_instances_FutureInstances$$anon$2(f$4) {
  this.Lcats_instances_FutureInstances$$anon$2__f_f$1 = null;
  this.Lcats_instances_FutureInstances$$anon$2__f_f$1 = f$4;
}
export { $c_Lcats_instances_FutureInstances$$anon$2 as $c_Lcats_instances_FutureInstances$$anon$2 };
$c_Lcats_instances_FutureInstances$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$c_Lcats_instances_FutureInstances$$anon$2.prototype.constructor = $c_Lcats_instances_FutureInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_FutureInstances$$anon$2() {
}
export { $h_Lcats_instances_FutureInstances$$anon$2 as $h_Lcats_instances_FutureInstances$$anon$2 };
$h_Lcats_instances_FutureInstances$$anon$2.prototype = $c_Lcats_instances_FutureInstances$$anon$2.prototype;
$c_Lcats_instances_FutureInstances$$anon$2.prototype.isDefinedAt__jl_Throwable__Z = (function(x) {
  return true;
});
$c_Lcats_instances_FutureInstances$$anon$2.prototype.applyOrElse__jl_Throwable__F1__O = (function(x, default$1) {
  return this.Lcats_instances_FutureInstances$$anon$2__f_f$1.apply__O__O(x);
});
$c_Lcats_instances_FutureInstances$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z(x);
});
$c_Lcats_instances_FutureInstances$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__jl_Throwable__F1__O(x, default$1);
});
var $d_Lcats_instances_FutureInstances$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_FutureInstances$$anon$2, "cats.instances.FutureInstances$$anon$2", ({
  Lcats_instances_FutureInstances$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_instances_FutureInstances$$anon$2 as $d_Lcats_instances_FutureInstances$$anon$2 };
/** @constructor */
function $c_Lcats_instances_LazyListInstances$$anon$2() {
}
export { $c_Lcats_instances_LazyListInstances$$anon$2 as $c_Lcats_instances_LazyListInstances$$anon$2 };
$c_Lcats_instances_LazyListInstances$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$c_Lcats_instances_LazyListInstances$$anon$2.prototype.constructor = $c_Lcats_instances_LazyListInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_LazyListInstances$$anon$2() {
}
export { $h_Lcats_instances_LazyListInstances$$anon$2 as $h_Lcats_instances_LazyListInstances$$anon$2 };
$h_Lcats_instances_LazyListInstances$$anon$2.prototype = $c_Lcats_instances_LazyListInstances$$anon$2.prototype;
$c_Lcats_instances_LazyListInstances$$anon$2.prototype.isDefinedAt__s_Option__Z = (function(x) {
  return (x instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some);
});
$c_Lcats_instances_LazyListInstances$$anon$2.prototype.applyOrElse__s_Option__F1__O = (function(x, default$1) {
  if ((x instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
    var v = x.s_Some__f_value;
    return v;
  } else {
    return default$1.apply__O__O(x);
  }
});
$c_Lcats_instances_LazyListInstances$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__s_Option__Z(x);
});
$c_Lcats_instances_LazyListInstances$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__s_Option__F1__O(x, default$1);
});
var $d_Lcats_instances_LazyListInstances$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_LazyListInstances$$anon$2, "cats.instances.LazyListInstances$$anon$2", ({
  Lcats_instances_LazyListInstances$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_instances_LazyListInstances$$anon$2 as $d_Lcats_instances_LazyListInstances$$anon$2 };
/** @constructor */
function $c_Lcats_instances_OrderInstances$$anon$2(fa$6, fb$3, outer) {
  this.Lcats_instances_OrderInstances$$anon$2__f_fa$4 = null;
  this.Lcats_instances_OrderInstances$$anon$2__f_fb$2 = null;
  this.Lcats_instances_OrderInstances$$anon$2__f_fa$4 = fa$6;
  this.Lcats_instances_OrderInstances$$anon$2__f_fb$2 = fb$3;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lcats_instances_OrderInstances$$anon$2 as $c_Lcats_instances_OrderInstances$$anon$2 };
$c_Lcats_instances_OrderInstances$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_OrderInstances$$anon$2.prototype.constructor = $c_Lcats_instances_OrderInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_OrderInstances$$anon$2() {
}
export { $h_Lcats_instances_OrderInstances$$anon$2 as $h_Lcats_instances_OrderInstances$$anon$2 };
$h_Lcats_instances_OrderInstances$$anon$2.prototype = $c_Lcats_instances_OrderInstances$$anon$2.prototype;
$c_Lcats_instances_OrderInstances$$anon$2.prototype.partialCompare__O__O__D = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_instances_OrderInstances$$anon$2.prototype.eqv__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Order__eqv__O__O__Z(this, x, y);
});
$c_Lcats_instances_OrderInstances$$anon$2.prototype.neqv__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Order__neqv__O__O__Z(this, x, y);
});
$c_Lcats_instances_OrderInstances$$anon$2.prototype.lt__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Order__lt__O__O__Z(this, x, y);
});
$c_Lcats_instances_OrderInstances$$anon$2.prototype.gt__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Order__gt__O__O__Z(this, x, y);
});
$c_Lcats_instances_OrderInstances$$anon$2.prototype.toOrdering__s_math_Ordering = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_kernel_Order$$anon$1(this);
});
$c_Lcats_instances_OrderInstances$$anon$2.prototype.compare__T2__T2__I = (function(x, y) {
  var fa$1 = this.Lcats_instances_OrderInstances$$anon$2__f_fa$4;
  var fb$1 = this.Lcats_instances_OrderInstances$$anon$2__f_fb$2;
  var z = fa$1.compare__O__O__I(x._1__O(), y._1__O());
  return ((z === 0) ? fb$1.compare__O__O__I(x._2__O(), y._2__O()) : z);
});
$c_Lcats_instances_OrderInstances$$anon$2.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__T2__T2__I(x, y);
});
var $d_Lcats_instances_OrderInstances$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_OrderInstances$$anon$2, "cats.instances.OrderInstances$$anon$2", ({
  Lcats_instances_OrderInstances$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1
}));
export { $d_Lcats_instances_OrderInstances$$anon$2 as $d_Lcats_instances_OrderInstances$$anon$2 };
/** @constructor */
function $c_Lcats_instances_package$queue$() {
  this.Lcats_instances_package$queue$__f_catsStdInstancesForQueue = null;
  $n_Lcats_instances_package$queue$ = this;
  this.Lcats_instances_package$queue$__f_catsStdInstancesForQueue = new $c_Lcats_instances_QueueInstances$$anon$1();
}
export { $c_Lcats_instances_package$queue$ as $c_Lcats_instances_package$queue$ };
$c_Lcats_instances_package$queue$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_package$queue$.prototype.constructor = $c_Lcats_instances_package$queue$;
/** @constructor */
function $h_Lcats_instances_package$queue$() {
}
export { $h_Lcats_instances_package$queue$ as $h_Lcats_instances_package$queue$ };
$h_Lcats_instances_package$queue$.prototype = $c_Lcats_instances_package$queue$.prototype;
var $d_Lcats_instances_package$queue$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_package$queue$, "cats.instances.package$queue$", ({
  Lcats_instances_package$queue$: 1,
  Lcats_kernel_instances_QueueInstances2: 1,
  Lcats_kernel_instances_QueueInstances1: 1,
  Lcats_kernel_instances_QueueInstances: 1,
  Lcats_instances_QueueInstances: 1
}));
export { $d_Lcats_instances_package$queue$ as $d_Lcats_instances_package$queue$ };
var $n_Lcats_instances_package$queue$;
function $m_Lcats_instances_package$queue$() {
  if ((!$n_Lcats_instances_package$queue$)) {
    $n_Lcats_instances_package$queue$ = new $c_Lcats_instances_package$queue$();
  }
  return $n_Lcats_instances_package$queue$;
}
export { $m_Lcats_instances_package$queue$ as $m_Lcats_instances_package$queue$ };
/** @constructor */
function $c_Lcats_kernel_Order$$anon$2(ev$5, f$7) {
  this.Lcats_kernel_Order$$anon$2__f_ev$3 = null;
  this.Lcats_kernel_Order$$anon$2__f_f$4 = null;
  this.Lcats_kernel_Order$$anon$2__f_ev$3 = ev$5;
  this.Lcats_kernel_Order$$anon$2__f_f$4 = f$7;
}
export { $c_Lcats_kernel_Order$$anon$2 as $c_Lcats_kernel_Order$$anon$2 };
$c_Lcats_kernel_Order$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_kernel_Order$$anon$2.prototype.constructor = $c_Lcats_kernel_Order$$anon$2;
/** @constructor */
function $h_Lcats_kernel_Order$$anon$2() {
}
export { $h_Lcats_kernel_Order$$anon$2 as $h_Lcats_kernel_Order$$anon$2 };
$h_Lcats_kernel_Order$$anon$2.prototype = $c_Lcats_kernel_Order$$anon$2.prototype;
$c_Lcats_kernel_Order$$anon$2.prototype.partialCompare__O__O__D = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_Order$$anon$2.prototype.eqv__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Order__eqv__O__O__Z(this, x, y);
});
$c_Lcats_kernel_Order$$anon$2.prototype.neqv__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Order__neqv__O__O__Z(this, x, y);
});
$c_Lcats_kernel_Order$$anon$2.prototype.lt__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Order__lt__O__O__Z(this, x, y);
});
$c_Lcats_kernel_Order$$anon$2.prototype.gt__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Order__gt__O__O__Z(this, x, y);
});
$c_Lcats_kernel_Order$$anon$2.prototype.toOrdering__s_math_Ordering = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_kernel_Order$$anon$1(this);
});
$c_Lcats_kernel_Order$$anon$2.prototype.compare__O__O__I = (function(x, y) {
  var ev$1 = this.Lcats_kernel_Order$$anon$2__f_ev$3;
  var f$1 = this.Lcats_kernel_Order$$anon$2__f_f$4;
  return ev$1.compare__O__O__I(f$1.apply__O__O(x), f$1.apply__O__O(y));
});
var $d_Lcats_kernel_Order$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_kernel_Order$$anon$2, "cats.kernel.Order$$anon$2", ({
  Lcats_kernel_Order$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1
}));
export { $d_Lcats_kernel_Order$$anon$2 as $d_Lcats_kernel_Order$$anon$2 };
/** @constructor */
function $c_Lcats_kernel_instances_BitSetPartialOrder() {
}
export { $c_Lcats_kernel_instances_BitSetPartialOrder as $c_Lcats_kernel_instances_BitSetPartialOrder };
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.constructor = $c_Lcats_kernel_instances_BitSetPartialOrder;
/** @constructor */
function $h_Lcats_kernel_instances_BitSetPartialOrder() {
}
export { $h_Lcats_kernel_instances_BitSetPartialOrder as $h_Lcats_kernel_instances_BitSetPartialOrder };
$h_Lcats_kernel_instances_BitSetPartialOrder.prototype = $c_Lcats_kernel_instances_BitSetPartialOrder.prototype;
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Eq__neqv__O__O__Z(this, x, y);
});
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.lt__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_PartialOrder__lt__O__O__Z(this, x, y);
});
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.gt__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_PartialOrder__gt__O__O__Z(this, x, y);
});
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.partialCompare__sci_BitSet__sci_BitSet__D = (function(x, y) {
  return ((x === y) ? 0.0 : (($f_sc_BitSetOps__size__I(x) < $f_sc_BitSetOps__size__I(y)) ? ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__forall__F1__Z(x, y) ? (-1.0) : (NaN)) : (($f_sc_BitSetOps__size__I(y) < $f_sc_BitSetOps__size__I(x)) ? ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__forall__F1__Z(y, x) ? 1.0 : (NaN)) : (((x === null) ? (y === null) : $f_sc_SortedSet__equals__O__Z(x, y)) ? 0.0 : (NaN)))));
});
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.eqv__sci_BitSet__sci_BitSet__Z = (function(x, y) {
  return ((x === null) ? (y === null) : $f_sc_SortedSet__equals__O__Z(x, y));
});
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.hash__O__I = (function(x) {
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$1.unorderedHash__sc_IterableOnce__I__I(x, this$1.s_util_hashing_MurmurHash3$__f_setSeed);
});
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return this.partialCompare__sci_BitSet__sci_BitSet__D(x, y);
});
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__sci_BitSet__sci_BitSet__Z(x, y);
});
var $d_Lcats_kernel_instances_BitSetPartialOrder = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_kernel_instances_BitSetPartialOrder, "cats.kernel.instances.BitSetPartialOrder", ({
  Lcats_kernel_instances_BitSetPartialOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Hash: 1
}));
export { $d_Lcats_kernel_instances_BitSetPartialOrder as $d_Lcats_kernel_instances_BitSetPartialOrder };
/** @constructor */
function $c_Lcom_raquo_airstream_status_Pending(input) {
  this.Lcom_raquo_airstream_status_Pending__f_input = null;
  this.Lcom_raquo_airstream_status_Pending__f_input = input;
}
export { $c_Lcom_raquo_airstream_status_Pending as $c_Lcom_raquo_airstream_status_Pending };
$c_Lcom_raquo_airstream_status_Pending.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_status_Pending.prototype.constructor = $c_Lcom_raquo_airstream_status_Pending;
/** @constructor */
function $h_Lcom_raquo_airstream_status_Pending() {
}
export { $h_Lcom_raquo_airstream_status_Pending as $h_Lcom_raquo_airstream_status_Pending };
$h_Lcom_raquo_airstream_status_Pending.prototype = $c_Lcom_raquo_airstream_status_Pending.prototype;
$c_Lcom_raquo_airstream_status_Pending.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcom_raquo_airstream_status_Pending.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 222573613, true);
});
$c_Lcom_raquo_airstream_status_Pending.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_raquo_airstream_status_Pending)) {
    var x = this.Lcom_raquo_airstream_status_Pending__f_input;
    var y = x$0.Lcom_raquo_airstream_status_Pending__f_input;
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcom_raquo_airstream_status_Pending.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcom_raquo_airstream_status_Pending.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcom_raquo_airstream_status_Pending.prototype.productPrefix__T = (function() {
  return "Pending";
});
$c_Lcom_raquo_airstream_status_Pending.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcom_raquo_airstream_status_Pending__f_input;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcom_raquo_airstream_status_Pending.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "input";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcom_raquo_airstream_status_Pending.prototype.isResolved__Z = (function() {
  return false;
});
$c_Lcom_raquo_airstream_status_Pending.prototype.fold__F1__F1__O = (function(resolved, pending) {
  return pending.apply__O__O(this);
});
function $isArrayOf_Lcom_raquo_airstream_status_Pending(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_raquo_airstream_status_Pending)));
}
export { $isArrayOf_Lcom_raquo_airstream_status_Pending as $isArrayOf_Lcom_raquo_airstream_status_Pending };
var $d_Lcom_raquo_airstream_status_Pending = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_status_Pending, "com.raquo.airstream.status.Pending", ({
  Lcom_raquo_airstream_status_Pending: 1,
  Lcom_raquo_airstream_status_Status: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcom_raquo_airstream_status_Pending as $d_Lcom_raquo_airstream_status_Pending };
/** @constructor */
function $c_Lcom_raquo_airstream_status_Resolved(input, output, ix) {
  this.Lcom_raquo_airstream_status_Resolved__f_input = null;
  this.Lcom_raquo_airstream_status_Resolved__f_output = null;
  this.Lcom_raquo_airstream_status_Resolved__f_ix = 0;
  this.Lcom_raquo_airstream_status_Resolved__f_input = input;
  this.Lcom_raquo_airstream_status_Resolved__f_output = output;
  this.Lcom_raquo_airstream_status_Resolved__f_ix = ix;
}
export { $c_Lcom_raquo_airstream_status_Resolved as $c_Lcom_raquo_airstream_status_Resolved };
$c_Lcom_raquo_airstream_status_Resolved.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_status_Resolved.prototype.constructor = $c_Lcom_raquo_airstream_status_Resolved;
/** @constructor */
function $h_Lcom_raquo_airstream_status_Resolved() {
}
export { $h_Lcom_raquo_airstream_status_Resolved as $h_Lcom_raquo_airstream_status_Resolved };
$h_Lcom_raquo_airstream_status_Resolved.prototype = $c_Lcom_raquo_airstream_status_Resolved.prototype;
$c_Lcom_raquo_airstream_status_Resolved.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcom_raquo_airstream_status_Resolved.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, (-276684776));
  var hash$1 = acc;
  var x = this.Lcom_raquo_airstream_status_Resolved__f_input;
  var data = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data);
  var hash$2 = acc;
  var x$1 = this.Lcom_raquo_airstream_status_Resolved__f_output;
  var data$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$1);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$2, data$1);
  var hash$3 = acc;
  var data$2 = this.Lcom_raquo_airstream_status_Resolved__f_ix;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$3, data$2);
  var hash$4 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3);
});
$c_Lcom_raquo_airstream_status_Resolved.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_raquo_airstream_status_Resolved)) {
    if ((this.Lcom_raquo_airstream_status_Resolved__f_ix === x$0.Lcom_raquo_airstream_status_Resolved__f_ix)) {
      var x = this.Lcom_raquo_airstream_status_Resolved__f_input;
      var y = x$0.Lcom_raquo_airstream_status_Resolved__f_input;
      var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$1 = this.Lcom_raquo_airstream_status_Resolved__f_output;
      var y$1 = x$0.Lcom_raquo_airstream_status_Resolved__f_output;
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y$1);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcom_raquo_airstream_status_Resolved.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcom_raquo_airstream_status_Resolved.prototype.productArity__I = (function() {
  return 3;
});
$c_Lcom_raquo_airstream_status_Resolved.prototype.productPrefix__T = (function() {
  return "Resolved";
});
$c_Lcom_raquo_airstream_status_Resolved.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lcom_raquo_airstream_status_Resolved__f_input;
      break;
    }
    case 1: {
      return this.Lcom_raquo_airstream_status_Resolved__f_output;
      break;
    }
    case 2: {
      return this.Lcom_raquo_airstream_status_Resolved__f_ix;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lcom_raquo_airstream_status_Resolved.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "input";
      break;
    }
    case 1: {
      return "output";
      break;
    }
    case 2: {
      return "ix";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lcom_raquo_airstream_status_Resolved.prototype.isResolved__Z = (function() {
  return true;
});
$c_Lcom_raquo_airstream_status_Resolved.prototype.fold__F1__F1__O = (function(resolved, pending) {
  return resolved.apply__O__O(this);
});
function $isArrayOf_Lcom_raquo_airstream_status_Resolved(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_raquo_airstream_status_Resolved)));
}
export { $isArrayOf_Lcom_raquo_airstream_status_Resolved as $isArrayOf_Lcom_raquo_airstream_status_Resolved };
var $d_Lcom_raquo_airstream_status_Resolved = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_status_Resolved, "com.raquo.airstream.status.Resolved", ({
  Lcom_raquo_airstream_status_Resolved: 1,
  Lcom_raquo_airstream_status_Status: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcom_raquo_airstream_status_Resolved as $d_Lcom_raquo_airstream_status_Resolved };
/** @constructor */
function $c_Lcom_raquo_laminar_inserters_StaticChildInserter(child, hooks) {
  this.Lcom_raquo_laminar_inserters_StaticChildInserter__f_child = null;
  this.Lcom_raquo_laminar_inserters_StaticChildInserter__f_hooks = null;
  this.Lcom_raquo_laminar_inserters_StaticChildInserter__f_child = child;
  this.Lcom_raquo_laminar_inserters_StaticChildInserter__f_hooks = hooks;
}
export { $c_Lcom_raquo_laminar_inserters_StaticChildInserter as $c_Lcom_raquo_laminar_inserters_StaticChildInserter };
$c_Lcom_raquo_laminar_inserters_StaticChildInserter.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_laminar_inserters_StaticChildInserter.prototype.constructor = $c_Lcom_raquo_laminar_inserters_StaticChildInserter;
/** @constructor */
function $h_Lcom_raquo_laminar_inserters_StaticChildInserter() {
}
export { $h_Lcom_raquo_laminar_inserters_StaticChildInserter as $h_Lcom_raquo_laminar_inserters_StaticChildInserter };
$h_Lcom_raquo_laminar_inserters_StaticChildInserter.prototype = $c_Lcom_raquo_laminar_inserters_StaticChildInserter.prototype;
$c_Lcom_raquo_laminar_inserters_StaticChildInserter.prototype.apply__Lcom_raquo_laminar_nodes_ReactiveElement__V = (function(element) {
  var x = this.Lcom_raquo_laminar_inserters_StaticChildInserter__f_hooks;
  if ((x !== (void 0))) {
    x.onWillInsertNode__Lcom_raquo_laminar_nodes_ParentNode__Lcom_raquo_laminar_nodes_ChildNode__V(element, this.Lcom_raquo_laminar_inserters_StaticChildInserter__f_child);
  }
  var this$6 = this.Lcom_raquo_laminar_inserters_StaticChildInserter__f_child;
  var this$7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_domapi_DomApi$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_laminar_domapi_DomTree__appendChild__Lcom_raquo_laminar_nodes_ParentNode__Lcom_raquo_laminar_nodes_ChildNode__O__Z(this$7, element, this$6, (void 0));
});
$c_Lcom_raquo_laminar_inserters_StaticChildInserter.prototype.renderInContext__Lcom_raquo_laminar_inserters_InsertContext__V = (function(ctx) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_inserters_ChildInserter$().switchToChild__O__Lcom_raquo_laminar_nodes_ChildNode__Lcom_raquo_laminar_inserters_InsertContext__O__V((void 0), this.Lcom_raquo_laminar_inserters_StaticChildInserter__f_child, ctx, this.Lcom_raquo_laminar_inserters_StaticChildInserter__f_hooks);
});
var $d_Lcom_raquo_laminar_inserters_StaticChildInserter = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_laminar_inserters_StaticChildInserter, "com.raquo.laminar.inserters.StaticChildInserter", ({
  Lcom_raquo_laminar_inserters_StaticChildInserter: 1,
  Lcom_raquo_laminar_modifiers_Modifier: 1,
  Lcom_raquo_laminar_inserters_Inserter: 1,
  Lcom_raquo_laminar_inserters_StaticInserter: 1,
  Lcom_raquo_laminar_inserters_Hookable: 1
}));
export { $d_Lcom_raquo_laminar_inserters_StaticChildInserter as $d_Lcom_raquo_laminar_inserters_StaticChildInserter };
/** @constructor */
function $c_Lcom_raquo_waypoint_Route$Total$$anon$1(outer) {
  this.Lcom_raquo_waypoint_Route$Total$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lcom_raquo_waypoint_Route$Total$$anon$1__f_$outer = outer;
}
export { $c_Lcom_raquo_waypoint_Route$Total$$anon$1 as $c_Lcom_raquo_waypoint_Route$Total$$anon$1 };
$c_Lcom_raquo_waypoint_Route$Total$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$c_Lcom_raquo_waypoint_Route$Total$$anon$1.prototype.constructor = $c_Lcom_raquo_waypoint_Route$Total$$anon$1;
/** @constructor */
function $h_Lcom_raquo_waypoint_Route$Total$$anon$1() {
}
export { $h_Lcom_raquo_waypoint_Route$Total$$anon$1 as $h_Lcom_raquo_waypoint_Route$Total$$anon$1 };
$h_Lcom_raquo_waypoint_Route$Total$$anon$1.prototype = $c_Lcom_raquo_waypoint_Route$Total$$anon$1.prototype;
$c_Lcom_raquo_waypoint_Route$Total$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  if ((x !== null)) {
    var x2 = this.Lcom_raquo_waypoint_Route$Total$$anon$1__f_$outer.Lcom_raquo_waypoint_Route$Total__f_com$raquo$waypoint$Route$Total$$evidence$1.unapply__O__s_Option(x);
    if ((!x2.isEmpty__Z())) {
      x2.get__O();
      return true;
    }
  }
  return false;
});
$c_Lcom_raquo_waypoint_Route$Total$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  if ((x !== null)) {
    var x6 = this.Lcom_raquo_waypoint_Route$Total$$anon$1__f_$outer.Lcom_raquo_waypoint_Route$Total__f_com$raquo$waypoint$Route$Total$$evidence$1.unapply__O__s_Option(x);
    if ((!x6.isEmpty__Z())) {
      var x7 = x6.get__O();
      return this.Lcom_raquo_waypoint_Route$Total$$anon$1__f_$outer.Lcom_raquo_waypoint_Route$Total__f_com$raquo$waypoint$Route$Total$$encode.apply__O__O(x7);
    }
  }
  return default$1.apply__O__O(x);
});
var $d_Lcom_raquo_waypoint_Route$Total$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_waypoint_Route$Total$$anon$1, "com.raquo.waypoint.Route$Total$$anon$1", ({
  Lcom_raquo_waypoint_Route$Total$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcom_raquo_waypoint_Route$Total$$anon$1 as $d_Lcom_raquo_waypoint_Route$Total$$anon$1 };
/** @constructor */
function $c_Lcom_raquo_waypoint_Route$Total$$anon$2(outer) {
  this.Lcom_raquo_waypoint_Route$Total$$anon$2__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lcom_raquo_waypoint_Route$Total$$anon$2__f_$outer = outer;
}
export { $c_Lcom_raquo_waypoint_Route$Total$$anon$2 as $c_Lcom_raquo_waypoint_Route$Total$$anon$2 };
$c_Lcom_raquo_waypoint_Route$Total$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$c_Lcom_raquo_waypoint_Route$Total$$anon$2.prototype.constructor = $c_Lcom_raquo_waypoint_Route$Total$$anon$2;
/** @constructor */
function $h_Lcom_raquo_waypoint_Route$Total$$anon$2() {
}
export { $h_Lcom_raquo_waypoint_Route$Total$$anon$2 as $h_Lcom_raquo_waypoint_Route$Total$$anon$2 };
$h_Lcom_raquo_waypoint_Route$Total$$anon$2.prototype = $c_Lcom_raquo_waypoint_Route$Total$$anon$2.prototype;
$c_Lcom_raquo_waypoint_Route$Total$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return true;
});
$c_Lcom_raquo_waypoint_Route$Total$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.Lcom_raquo_waypoint_Route$Total$$anon$2__f_$outer.Lcom_raquo_waypoint_Route$Total__f_com$raquo$waypoint$Route$Total$$decode.apply__O__O(x);
});
var $d_Lcom_raquo_waypoint_Route$Total$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_waypoint_Route$Total$$anon$2, "com.raquo.waypoint.Route$Total$$anon$2", ({
  Lcom_raquo_waypoint_Route$Total$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcom_raquo_waypoint_Route$Total$$anon$2 as $d_Lcom_raquo_waypoint_Route$Total$$anon$2 };
/** @constructor */
function $c_Lcom_raquo_waypoint_package$() {
  this.Lcom_raquo_waypoint_Waypoint__f_root = null;
  this.Lcom_raquo_waypoint_Waypoint__f_endOfSegments$lzy1 = null;
  this.Lcom_raquo_waypoint_Waypoint__f_endOfSegmentsbitmap$1 = false;
  this.Lcom_raquo_waypoint_Waypoint__f_pathError = null;
  this.Lcom_raquo_waypoint_Waypoint__f_queryError = null;
  $ct_Lcom_raquo_waypoint_Waypoint__Lurldsl_errors_PathMatchingError__Lurldsl_errors_ParamMatchingError__Lurldsl_errors_FragmentMatchingError__(this, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lurldsl_errors_DummyError$().dummyErrorIsPathMatchingError__Lurldsl_errors_PathMatchingError(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lurldsl_errors_DummyError$().dummyErrorIsParamMatchingError__Lurldsl_errors_ParamMatchingError(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lurldsl_errors_DummyError$().dummyErrorIsFragmentMatchingError__Lurldsl_errors_FragmentMatchingError());
}
export { $c_Lcom_raquo_waypoint_package$ as $c_Lcom_raquo_waypoint_package$ };
$c_Lcom_raquo_waypoint_package$.prototype = new $h_Lcom_raquo_waypoint_Waypoint();
$c_Lcom_raquo_waypoint_package$.prototype.constructor = $c_Lcom_raquo_waypoint_package$;
/** @constructor */
function $h_Lcom_raquo_waypoint_package$() {
}
export { $h_Lcom_raquo_waypoint_package$ as $h_Lcom_raquo_waypoint_package$ };
$h_Lcom_raquo_waypoint_package$.prototype = $c_Lcom_raquo_waypoint_package$.prototype;
var $d_Lcom_raquo_waypoint_package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_waypoint_package$, "com.raquo.waypoint.package$", ({
  Lcom_raquo_waypoint_package$: 1,
  Lcom_raquo_waypoint_Waypoint: 1,
  Lurldsl_language_PathSegmentImpl: 1,
  Lurldsl_language_QueryParametersImpl: 1,
  Lurldsl_language_FragmentImpl: 1
}));
export { $d_Lcom_raquo_waypoint_package$ as $d_Lcom_raquo_waypoint_package$ };
var $n_Lcom_raquo_waypoint_package$;
function $m_Lcom_raquo_waypoint_package$() {
  if ((!$n_Lcom_raquo_waypoint_package$)) {
    $n_Lcom_raquo_waypoint_package$ = new $c_Lcom_raquo_waypoint_package$();
  }
  return $n_Lcom_raquo_waypoint_package$;
}
export { $m_Lcom_raquo_waypoint_package$ as $m_Lcom_raquo_waypoint_package$ };
/** @constructor */
function $c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent() {
}
export { $c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent as $c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent };
$c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent.prototype.constructor = $c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent;
/** @constructor */
function $h_Lframework_auth_SupabaseAuthClient$AuthChangeEvent() {
}
export { $h_Lframework_auth_SupabaseAuthClient$AuthChangeEvent as $h_Lframework_auth_SupabaseAuthClient$AuthChangeEvent };
$h_Lframework_auth_SupabaseAuthClient$AuthChangeEvent.prototype = $c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent.prototype;
$c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lframework_components_ToastType() {
}
export { $c_Lframework_components_ToastType as $c_Lframework_components_ToastType };
$c_Lframework_components_ToastType.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_components_ToastType.prototype.constructor = $c_Lframework_components_ToastType;
/** @constructor */
function $h_Lframework_components_ToastType() {
}
export { $h_Lframework_components_ToastType as $h_Lframework_components_ToastType };
$h_Lframework_components_ToastType.prototype = $c_Lframework_components_ToastType.prototype;
$c_Lframework_components_ToastType.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading(outer, maybeRedirectToAfterRegistration) {
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading__f_maybeRedirectToAfterRegistration = null;
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading__f_$outer = null;
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading__f_maybeRedirectToAfterRegistration = maybeRedirectToAfterRegistration;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading__f_$outer = outer;
}
export { $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading as $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading };
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading.prototype.constructor = $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading;
/** @constructor */
function $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading() {
}
export { $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading as $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading };
$h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading.prototype = $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading.prototype;
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading.prototype.toString__T = (function() {
  return $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__toString__T(this);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 254301308, true);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading) && (x$0.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading__f_$outer === this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading__f_$outer))) {
    var x = this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading__f_maybeRedirectToAfterRegistration;
    var x$2 = x$0.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading__f_maybeRedirectToAfterRegistration;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading.prototype.productArity__I = (function() {
  return 1;
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading.prototype.productPrefix__T = (function() {
  return "Loading";
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading__f_maybeRedirectToAfterRegistration;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "maybeRedirectToAfterRegistration";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading.prototype.maybeRedirectToAfterRegistration__s_Option = (function() {
  return this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading__f_maybeRedirectToAfterRegistration;
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading.prototype.copy__s_Option__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading = (function(maybeRedirectToAfterRegistration) {
  return new $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading(this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading__f_$outer, maybeRedirectToAfterRegistration);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading.prototype.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth = (function() {
  return this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading__f_$outer.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$__f_$outer;
});
function $isArrayOf_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading)));
}
export { $isArrayOf_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading as $isArrayOf_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading };
var $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading, "framework.data.AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading", ({
  Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading: 1,
  Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading as $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Loading };
/** @constructor */
function $c_Lframework_data_AuthToken() {
}
export { $c_Lframework_data_AuthToken as $c_Lframework_data_AuthToken };
$c_Lframework_data_AuthToken.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_AuthToken.prototype.constructor = $c_Lframework_data_AuthToken;
/** @constructor */
function $h_Lframework_data_AuthToken() {
}
export { $h_Lframework_data_AuthToken as $h_Lframework_data_AuthToken };
$h_Lframework_data_AuthToken.prototype = $c_Lframework_data_AuthToken.prototype;
$c_Lframework_data_AuthToken.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_data_AuthToken.prototype.asString__Lio_circe_Encoder__T = (function(x$1) {
  if ((this instanceof $c_Lframework_data_AuthToken$Jwt)) {
    var x7 = this.Lframework_data_AuthToken$Jwt__f_token;
    return x7;
  }
  if ((this instanceof $c_Lframework_data_AuthToken$Dev)) {
    var x4 = this.Lframework_data_AuthToken$Dev__f_token;
    return $m_Lframework_data_AuthToken$().encodeDevToken__O__Lio_circe_Encoder__T(x4, x$1);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this);
});
/** @constructor */
function $c_Lframework_data_Email$package$Email$Validated$RegexValidator(outer, regex) {
  this.Lframework_data_Email$package$Email$Validated$RegexValidator__f_regex = null;
  this.Lframework_data_Email$package$Email$Validated$RegexValidator__f_$outer = null;
  this.Lframework_data_Email$package$Email$Validated$RegexValidator__f_regex = regex;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lframework_data_Email$package$Email$Validated$RegexValidator__f_$outer = outer;
}
export { $c_Lframework_data_Email$package$Email$Validated$RegexValidator as $c_Lframework_data_Email$package$Email$Validated$RegexValidator };
$c_Lframework_data_Email$package$Email$Validated$RegexValidator.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_Email$package$Email$Validated$RegexValidator.prototype.constructor = $c_Lframework_data_Email$package$Email$Validated$RegexValidator;
/** @constructor */
function $h_Lframework_data_Email$package$Email$Validated$RegexValidator() {
}
export { $h_Lframework_data_Email$package$Email$Validated$RegexValidator as $h_Lframework_data_Email$package$Email$Validated$RegexValidator };
$h_Lframework_data_Email$package$Email$Validated$RegexValidator.prototype = $c_Lframework_data_Email$package$Email$Validated$RegexValidator.prototype;
$c_Lframework_data_Email$package$Email$Validated$RegexValidator.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_data_Email$package$Email$Validated$RegexValidator.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-2015078167), true);
});
$c_Lframework_data_Email$package$Email$Validated$RegexValidator.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Lframework_data_Email$package$Email$Validated$RegexValidator) && (x$0.Lframework_data_Email$package$Email$Validated$RegexValidator__f_$outer === this.Lframework_data_Email$package$Email$Validated$RegexValidator__f_$outer))) {
    var x = this.Lframework_data_Email$package$Email$Validated$RegexValidator__f_regex;
    var x$2 = x$0.Lframework_data_Email$package$Email$Validated$RegexValidator__f_regex;
    return (x === x$2);
  } else {
    return false;
  }
});
$c_Lframework_data_Email$package$Email$Validated$RegexValidator.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lframework_data_Email$package$Email$Validated$RegexValidator.prototype.productArity__I = (function() {
  return 1;
});
$c_Lframework_data_Email$package$Email$Validated$RegexValidator.prototype.productPrefix__T = (function() {
  return "RegexValidator";
});
$c_Lframework_data_Email$package$Email$Validated$RegexValidator.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_data_Email$package$Email$Validated$RegexValidator__f_regex;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_Email$package$Email$Validated$RegexValidator.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "regex";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_Email$package$Email$Validated$RegexValidator.prototype.validate__T__s_Option = (function(email) {
  if (this.Lframework_data_Email$package$Email$Validated$RegexValidator__f_regex.matches__jl_CharSequence__Z(($m_Lframework_data_Email$package$Email$(), email))) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var value = this.Lframework_data_Email$package$Email$Validated$RegexValidator__f_$outer.Lframework_data_Email$package$Email$Validated__f_ValidationError$lzy1.apply__T__sci_Vector__Lframework_data_Email$package$Email$Validated$ValidationError(email, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_NonEmptyVector$().one__O__sci_Vector(this.Lframework_data_Email$package$Email$Validated$RegexValidator__f_regex));
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
  }
});
$c_Lframework_data_Email$package$Email$Validated$RegexValidator.prototype.isValid__T__Z = (function(s) {
  return this.Lframework_data_Email$package$Email$Validated$RegexValidator__f_regex.matches__jl_CharSequence__Z(($m_Lframework_data_Email$package$Email$(), s));
});
$c_Lframework_data_Email$package$Email$Validated$RegexValidator.prototype.validate__O__s_Option = (function(input) {
  return this.validate__T__s_Option(input);
});
function $isArrayOf_Lframework_data_Email$package$Email$Validated$RegexValidator(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_data_Email$package$Email$Validated$RegexValidator)));
}
export { $isArrayOf_Lframework_data_Email$package$Email$Validated$RegexValidator as $isArrayOf_Lframework_data_Email$package$Email$Validated$RegexValidator };
var $d_Lframework_data_Email$package$Email$Validated$RegexValidator = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_Email$package$Email$Validated$RegexValidator, "framework.data.Email$package$Email$Validated$RegexValidator", ({
  Lframework_data_Email$package$Email$Validated$RegexValidator: 1,
  Lyantl_ValidatorRule: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_data_Email$package$Email$Validated$RegexValidator as $d_Lframework_data_Email$package$Email$Validated$RegexValidator };
/** @constructor */
function $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode() {
}
export { $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode as $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode };
$c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode.prototype.constructor = $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode;
/** @constructor */
function $h_Lframework_data_EndpointSSEWithWS$ClientConnectionMode() {
}
export { $h_Lframework_data_EndpointSSEWithWS$ClientConnectionMode as $h_Lframework_data_EndpointSSEWithWS$ClientConnectionMode };
$h_Lframework_data_EndpointSSEWithWS$ClientConnectionMode.prototype = $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode.prototype;
$c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lframework_data_IndicatorStates$ListIndicatorState(unreadItems, currentlyIn) {
  this.Lframework_data_IndicatorStates$ListIndicatorState__f_unreadItems = null;
  this.Lframework_data_IndicatorStates$ListIndicatorState__f_currentlyIn = null;
  this.Lframework_data_IndicatorStates$ListIndicatorState__f_unreadItems = unreadItems;
  this.Lframework_data_IndicatorStates$ListIndicatorState__f_currentlyIn = currentlyIn;
}
export { $c_Lframework_data_IndicatorStates$ListIndicatorState as $c_Lframework_data_IndicatorStates$ListIndicatorState };
$c_Lframework_data_IndicatorStates$ListIndicatorState.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_IndicatorStates$ListIndicatorState.prototype.constructor = $c_Lframework_data_IndicatorStates$ListIndicatorState;
/** @constructor */
function $h_Lframework_data_IndicatorStates$ListIndicatorState() {
}
export { $h_Lframework_data_IndicatorStates$ListIndicatorState as $h_Lframework_data_IndicatorStates$ListIndicatorState };
$h_Lframework_data_IndicatorStates$ListIndicatorState.prototype = $c_Lframework_data_IndicatorStates$ListIndicatorState.prototype;
$c_Lframework_data_IndicatorStates$ListIndicatorState.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_data_IndicatorStates$ListIndicatorState.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-582711664), true);
});
$c_Lframework_data_IndicatorStates$ListIndicatorState.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lframework_data_IndicatorStates$ListIndicatorState)) {
    var x = this.Lframework_data_IndicatorStates$ListIndicatorState__f_unreadItems;
    var x$2 = x$0.Lframework_data_IndicatorStates$ListIndicatorState__f_unreadItems;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lframework_data_IndicatorStates$ListIndicatorState__f_currentlyIn;
      var x$4 = x$0.Lframework_data_IndicatorStates$ListIndicatorState__f_currentlyIn;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lframework_data_IndicatorStates$ListIndicatorState.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lframework_data_IndicatorStates$ListIndicatorState.prototype.productArity__I = (function() {
  return 2;
});
$c_Lframework_data_IndicatorStates$ListIndicatorState.prototype.productPrefix__T = (function() {
  return "ListIndicatorState";
});
$c_Lframework_data_IndicatorStates$ListIndicatorState.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_data_IndicatorStates$ListIndicatorState__f_unreadItems;
  }
  if ((n === 1)) {
    return this.Lframework_data_IndicatorStates$ListIndicatorState__f_currentlyIn;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_IndicatorStates$ListIndicatorState.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "unreadItems";
  }
  if ((n === 1)) {
    return "currentlyIn";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_IndicatorStates$ListIndicatorState.prototype.reset__Lframework_data_IndicatorStates$ListIndicatorState = (function() {
  var unreadItems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Set$EmptySet$();
  var currentlyIn = this.Lframework_data_IndicatorStates$ListIndicatorState__f_currentlyIn;
  return new $c_Lframework_data_IndicatorStates$ListIndicatorState(unreadItems, currentlyIn);
});
$c_Lframework_data_IndicatorStates$ListIndicatorState.prototype.newDataReceived__sc_IterableOnce__Lframework_data_IndicatorStates$ListIndicatorState = (function(unreadItemIds) {
  var this$6 = $m_Lmonocle_syntax_AppliedPLens$();
  var this$2 = $m_Lmonocle_PIso$();
  new $c_Lmonocle_PIso$$anon$5(this$2);
  var get = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((from) => from.Lframework_data_IndicatorStates$ListIndicatorState__f_unreadItems));
  var replace = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((to) => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((to$2) => ((from$1) => {
    var currentlyIn = from$1.Lframework_data_IndicatorStates$ListIndicatorState__f_currentlyIn;
    return new $c_Lframework_data_IndicatorStates$ListIndicatorState(to$2, currentlyIn);
  }))(to))));
  var this$4 = $m_Lmonocle_PLens$();
  var other = new $c_Lmonocle_PLens$$anon$2(get, replace, this$4);
  var this$9 = new $c_Lmonocle_syntax_AppliedPLens$$anon$1(this, other, this$6);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((items) => {
    var x16 = this.Lframework_data_IndicatorStates$ListIndicatorState__f_currentlyIn;
    var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    if ((x === x16)) {
      return items.concat__sc_IterableOnce__sc_SetOps(unreadItemIds);
    }
    if ((x16 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var itemId = x16.s_Some__f_value;
      var this$8 = items.concat__sc_IterableOnce__sc_SetOps(unreadItemIds);
      return this$8.excl__O__sci_SetOps(itemId);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x16);
  }));
  return $f_Lmonocle_syntax_AppliedPSetter__modify__F1__O(this$9, f);
});
$c_Lframework_data_IndicatorStates$ListIndicatorState.prototype.itemEntered__O__Lframework_data_IndicatorStates$ListIndicatorState = (function(id) {
  var this$1 = this.Lframework_data_IndicatorStates$ListIndicatorState__f_unreadItems;
  var unreadItems = this$1.excl__O__sci_SetOps(id);
  var currentlyIn = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(id);
  return new $c_Lframework_data_IndicatorStates$ListIndicatorState(unreadItems, currentlyIn);
});
$c_Lframework_data_IndicatorStates$ListIndicatorState.prototype.itemLeft__Lframework_data_IndicatorStates$ListIndicatorState = (function() {
  var currentlyIn$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var unreadItems$6 = this.Lframework_data_IndicatorStates$ListIndicatorState__f_unreadItems;
  return new $c_Lframework_data_IndicatorStates$ListIndicatorState(unreadItems$6, currentlyIn$1);
});
$c_Lframework_data_IndicatorStates$ListIndicatorState.prototype.itemProcessed__O__Lframework_data_IndicatorStates$ListIndicatorState = (function(id) {
  var this$1 = this.Lframework_data_IndicatorStates$ListIndicatorState__f_unreadItems;
  var unreadItems = this$1.excl__O__sci_SetOps(id);
  var currentlyIn = this.Lframework_data_IndicatorStates$ListIndicatorState__f_currentlyIn;
  return new $c_Lframework_data_IndicatorStates$ListIndicatorState(unreadItems, currentlyIn);
});
function $isArrayOf_Lframework_data_IndicatorStates$ListIndicatorState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_data_IndicatorStates$ListIndicatorState)));
}
export { $isArrayOf_Lframework_data_IndicatorStates$ListIndicatorState as $isArrayOf_Lframework_data_IndicatorStates$ListIndicatorState };
var $d_Lframework_data_IndicatorStates$ListIndicatorState = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_IndicatorStates$ListIndicatorState, "framework.data.IndicatorStates$ListIndicatorState", ({
  Lframework_data_IndicatorStates$ListIndicatorState: 1,
  Lframework_data_IndicatorStates$State: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_data_IndicatorStates$ListIndicatorState as $d_Lframework_data_IndicatorStates$ListIndicatorState };
/** @constructor */
function $c_Lframework_data_IndicatorStates$SingleLevelItemsState(forPages, unreadItems) {
  this.Lframework_data_IndicatorStates$SingleLevelItemsState__f_forPages = null;
  this.Lframework_data_IndicatorStates$SingleLevelItemsState__f_unreadItems = null;
  this.Lframework_data_IndicatorStates$SingleLevelItemsState__f_forPages = forPages;
  this.Lframework_data_IndicatorStates$SingleLevelItemsState__f_unreadItems = unreadItems;
}
export { $c_Lframework_data_IndicatorStates$SingleLevelItemsState as $c_Lframework_data_IndicatorStates$SingleLevelItemsState };
$c_Lframework_data_IndicatorStates$SingleLevelItemsState.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_IndicatorStates$SingleLevelItemsState.prototype.constructor = $c_Lframework_data_IndicatorStates$SingleLevelItemsState;
/** @constructor */
function $h_Lframework_data_IndicatorStates$SingleLevelItemsState() {
}
export { $h_Lframework_data_IndicatorStates$SingleLevelItemsState as $h_Lframework_data_IndicatorStates$SingleLevelItemsState };
$h_Lframework_data_IndicatorStates$SingleLevelItemsState.prototype = $c_Lframework_data_IndicatorStates$SingleLevelItemsState.prototype;
$c_Lframework_data_IndicatorStates$SingleLevelItemsState.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_data_IndicatorStates$SingleLevelItemsState.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1005502864, true);
});
$c_Lframework_data_IndicatorStates$SingleLevelItemsState.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lframework_data_IndicatorStates$SingleLevelItemsState)) {
    var x = this.Lframework_data_IndicatorStates$SingleLevelItemsState__f_forPages;
    var x$2 = x$0.Lframework_data_IndicatorStates$SingleLevelItemsState__f_forPages;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lframework_data_IndicatorStates$SingleLevelItemsState__f_unreadItems;
      var x$4 = x$0.Lframework_data_IndicatorStates$SingleLevelItemsState__f_unreadItems;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lframework_data_IndicatorStates$SingleLevelItemsState.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lframework_data_IndicatorStates$SingleLevelItemsState.prototype.productArity__I = (function() {
  return 2;
});
$c_Lframework_data_IndicatorStates$SingleLevelItemsState.prototype.productPrefix__T = (function() {
  return "SingleLevelItemsState";
});
$c_Lframework_data_IndicatorStates$SingleLevelItemsState.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_data_IndicatorStates$SingleLevelItemsState__f_forPages;
  }
  if ((n === 1)) {
    return this.Lframework_data_IndicatorStates$SingleLevelItemsState__f_unreadItems;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_IndicatorStates$SingleLevelItemsState.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "forPages";
  }
  if ((n === 1)) {
    return "unreadItems";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_IndicatorStates$SingleLevelItemsState.prototype.reset__Lframework_data_IndicatorStates$SingleLevelItemsState = (function() {
  var unreadItems$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Set$EmptySet$();
  var forPages$1 = this.Lframework_data_IndicatorStates$SingleLevelItemsState__f_forPages;
  return new $c_Lframework_data_IndicatorStates$SingleLevelItemsState(forPages$1, unreadItems$1);
});
$c_Lframework_data_IndicatorStates$SingleLevelItemsState.prototype.newDataReceived__s_Option__sc_IterableOnce__Lframework_data_IndicatorStates$SingleLevelItemsState = (function(currentPage, itemIds) {
  if ((!currentPage.isEmpty__Z())) {
    var x0 = currentPage.get__O();
    var $x_1 = $m_Lframework_data_IndicatorStates$().matches__F1__O__Z(this.Lframework_data_IndicatorStates$SingleLevelItemsState__f_forPages, x0);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    return this;
  } else {
    var this$1 = this.Lframework_data_IndicatorStates$SingleLevelItemsState__f_unreadItems;
    var unreadItems$2 = this$1.concat__sc_IterableOnce__sc_SetOps(itemIds);
    var forPages$2 = this.Lframework_data_IndicatorStates$SingleLevelItemsState__f_forPages;
    return new $c_Lframework_data_IndicatorStates$SingleLevelItemsState(forPages$2, unreadItems$2);
  }
});
$c_Lframework_data_IndicatorStates$SingleLevelItemsState.prototype.itemProcessed__O__Lframework_data_IndicatorStates$SingleLevelItemsState = (function(itemId) {
  var this$1 = this.Lframework_data_IndicatorStates$SingleLevelItemsState__f_unreadItems;
  var unreadItems$3 = this$1.excl__O__sci_SetOps(itemId);
  var forPages$3 = this.Lframework_data_IndicatorStates$SingleLevelItemsState__f_forPages;
  return new $c_Lframework_data_IndicatorStates$SingleLevelItemsState(forPages$3, unreadItems$3);
});
$c_Lframework_data_IndicatorStates$SingleLevelItemsState.prototype.itemsProcessed__sc_IterableOnce__Lframework_data_IndicatorStates$SingleLevelItemsState = (function(itemIds) {
  var this$1 = this.Lframework_data_IndicatorStates$SingleLevelItemsState__f_unreadItems;
  var unreadItems$4 = this$1.removedAll__sc_IterableOnce__sci_SetOps(itemIds);
  var forPages$4 = this.Lframework_data_IndicatorStates$SingleLevelItemsState__f_forPages;
  return new $c_Lframework_data_IndicatorStates$SingleLevelItemsState(forPages$4, unreadItems$4);
});
$c_Lframework_data_IndicatorStates$SingleLevelItemsState.prototype.onPageSwitch__s_Option__Lframework_data_IndicatorStates$SingleLevelItemsState = (function(currentPage) {
  if ((!currentPage.isEmpty__Z())) {
    var x0 = currentPage.get__O();
    var $x_1 = $m_Lframework_data_IndicatorStates$().matches__F1__O__Z(this.Lframework_data_IndicatorStates$SingleLevelItemsState__f_forPages, x0);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var unreadItems$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Set$EmptySet$();
    var forPages$5 = this.Lframework_data_IndicatorStates$SingleLevelItemsState__f_forPages;
    return new $c_Lframework_data_IndicatorStates$SingleLevelItemsState(forPages$5, unreadItems$5);
  } else {
    return this;
  }
});
function $isArrayOf_Lframework_data_IndicatorStates$SingleLevelItemsState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_data_IndicatorStates$SingleLevelItemsState)));
}
export { $isArrayOf_Lframework_data_IndicatorStates$SingleLevelItemsState as $isArrayOf_Lframework_data_IndicatorStates$SingleLevelItemsState };
var $d_Lframework_data_IndicatorStates$SingleLevelItemsState = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_IndicatorStates$SingleLevelItemsState, "framework.data.IndicatorStates$SingleLevelItemsState", ({
  Lframework_data_IndicatorStates$SingleLevelItemsState: 1,
  Lframework_data_IndicatorStates$State: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_data_IndicatorStates$SingleLevelItemsState as $d_Lframework_data_IndicatorStates$SingleLevelItemsState };
/** @constructor */
function $c_Lframework_data_WebPushSubscription$$anon$10() {
}
export { $c_Lframework_data_WebPushSubscription$$anon$10 as $c_Lframework_data_WebPushSubscription$$anon$10 };
$c_Lframework_data_WebPushSubscription$$anon$10.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$c_Lframework_data_WebPushSubscription$$anon$10.prototype.constructor = $c_Lframework_data_WebPushSubscription$$anon$10;
/** @constructor */
function $h_Lframework_data_WebPushSubscription$$anon$10() {
}
export { $h_Lframework_data_WebPushSubscription$$anon$10 as $h_Lframework_data_WebPushSubscription$$anon$10 };
$h_Lframework_data_WebPushSubscription$$anon$10.prototype = $c_Lframework_data_WebPushSubscription$$anon$10.prototype;
$c_Lframework_data_WebPushSubscription$$anon$10.prototype.isDefinedAt__O__Z = (function(x) {
  return false;
});
$c_Lframework_data_WebPushSubscription$$anon$10.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return (false ? x.name__T() : default$1.apply__O__O(x));
});
var $d_Lframework_data_WebPushSubscription$$anon$10 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_WebPushSubscription$$anon$10, "framework.data.WebPushSubscription$$anon$10", ({
  Lframework_data_WebPushSubscription$$anon$10: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_data_WebPushSubscription$$anon$10 as $d_Lframework_data_WebPushSubscription$$anon$10 };
/** @constructor */
function $c_Lframework_data_WebPushSubscription$$anon$2() {
}
export { $c_Lframework_data_WebPushSubscription$$anon$2 as $c_Lframework_data_WebPushSubscription$$anon$2 };
$c_Lframework_data_WebPushSubscription$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$c_Lframework_data_WebPushSubscription$$anon$2.prototype.constructor = $c_Lframework_data_WebPushSubscription$$anon$2;
/** @constructor */
function $h_Lframework_data_WebPushSubscription$$anon$2() {
}
export { $h_Lframework_data_WebPushSubscription$$anon$2 as $h_Lframework_data_WebPushSubscription$$anon$2 };
$h_Lframework_data_WebPushSubscription$$anon$2.prototype = $c_Lframework_data_WebPushSubscription$$anon$2.prototype;
$c_Lframework_data_WebPushSubscription$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return false;
});
$c_Lframework_data_WebPushSubscription$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return (false ? x.name__T() : default$1.apply__O__O(x));
});
var $d_Lframework_data_WebPushSubscription$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_WebPushSubscription$$anon$2, "framework.data.WebPushSubscription$$anon$2", ({
  Lframework_data_WebPushSubscription$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_data_WebPushSubscription$$anon$2 as $d_Lframework_data_WebPushSubscription$$anon$2 };
/** @constructor */
function $c_Lframework_data_WebPushSubscription$$anon$3() {
}
export { $c_Lframework_data_WebPushSubscription$$anon$3 as $c_Lframework_data_WebPushSubscription$$anon$3 };
$c_Lframework_data_WebPushSubscription$$anon$3.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$c_Lframework_data_WebPushSubscription$$anon$3.prototype.constructor = $c_Lframework_data_WebPushSubscription$$anon$3;
/** @constructor */
function $h_Lframework_data_WebPushSubscription$$anon$3() {
}
export { $h_Lframework_data_WebPushSubscription$$anon$3 as $h_Lframework_data_WebPushSubscription$$anon$3 };
$h_Lframework_data_WebPushSubscription$$anon$3.prototype = $c_Lframework_data_WebPushSubscription$$anon$3.prototype;
$c_Lframework_data_WebPushSubscription$$anon$3.prototype.isDefinedAt__O__Z = (function(x) {
  return false;
});
$c_Lframework_data_WebPushSubscription$$anon$3.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return (false ? x.name__T() : default$1.apply__O__O(x));
});
var $d_Lframework_data_WebPushSubscription$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_WebPushSubscription$$anon$3, "framework.data.WebPushSubscription$$anon$3", ({
  Lframework_data_WebPushSubscription$$anon$3: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_data_WebPushSubscription$$anon$3 as $d_Lframework_data_WebPushSubscription$$anon$3 };
/** @constructor */
function $c_Lframework_data_WebPushSubscription$$anon$9() {
}
export { $c_Lframework_data_WebPushSubscription$$anon$9 as $c_Lframework_data_WebPushSubscription$$anon$9 };
$c_Lframework_data_WebPushSubscription$$anon$9.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$c_Lframework_data_WebPushSubscription$$anon$9.prototype.constructor = $c_Lframework_data_WebPushSubscription$$anon$9;
/** @constructor */
function $h_Lframework_data_WebPushSubscription$$anon$9() {
}
export { $h_Lframework_data_WebPushSubscription$$anon$9 as $h_Lframework_data_WebPushSubscription$$anon$9 };
$h_Lframework_data_WebPushSubscription$$anon$9.prototype = $c_Lframework_data_WebPushSubscription$$anon$9.prototype;
$c_Lframework_data_WebPushSubscription$$anon$9.prototype.isDefinedAt__O__Z = (function(x) {
  return false;
});
$c_Lframework_data_WebPushSubscription$$anon$9.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return (false ? x.name__T() : default$1.apply__O__O(x));
});
var $d_Lframework_data_WebPushSubscription$$anon$9 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_WebPushSubscription$$anon$9, "framework.data.WebPushSubscription$$anon$9", ({
  Lframework_data_WebPushSubscription$$anon$9: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_data_WebPushSubscription$$anon$9 as $d_Lframework_data_WebPushSubscription$$anon$9 };
/** @constructor */
function $c_Lframework_exts_EventStreamBooleanExts$$anon$1() {
}
export { $c_Lframework_exts_EventStreamBooleanExts$$anon$1 as $c_Lframework_exts_EventStreamBooleanExts$$anon$1 };
$c_Lframework_exts_EventStreamBooleanExts$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$c_Lframework_exts_EventStreamBooleanExts$$anon$1.prototype.constructor = $c_Lframework_exts_EventStreamBooleanExts$$anon$1;
/** @constructor */
function $h_Lframework_exts_EventStreamBooleanExts$$anon$1() {
}
export { $h_Lframework_exts_EventStreamBooleanExts$$anon$1 as $h_Lframework_exts_EventStreamBooleanExts$$anon$1 };
$h_Lframework_exts_EventStreamBooleanExts$$anon$1.prototype = $c_Lframework_exts_EventStreamBooleanExts$$anon$1.prototype;
$c_Lframework_exts_EventStreamBooleanExts$$anon$1.prototype.isDefinedAt__Z__Z = (function(x) {
  return (x === true);
});
$c_Lframework_exts_EventStreamBooleanExts$$anon$1.prototype.applyOrElse__Z__F1__O = (function(x, default$1) {
  return ((x === true) ? (void 0) : default$1.apply__O__O(x));
});
$c_Lframework_exts_EventStreamBooleanExts$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Z__Z((!(!x)));
});
$c_Lframework_exts_EventStreamBooleanExts$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Z__F1__O((!(!x)), default$1);
});
var $d_Lframework_exts_EventStreamBooleanExts$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_EventStreamBooleanExts$$anon$1, "framework.exts.EventStreamBooleanExts$$anon$1", ({
  Lframework_exts_EventStreamBooleanExts$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_exts_EventStreamBooleanExts$$anon$1 as $d_Lframework_exts_EventStreamBooleanExts$$anon$1 };
/** @constructor */
function $c_Lframework_exts_IterableOnceExts$$anon$1() {
}
export { $c_Lframework_exts_IterableOnceExts$$anon$1 as $c_Lframework_exts_IterableOnceExts$$anon$1 };
$c_Lframework_exts_IterableOnceExts$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$c_Lframework_exts_IterableOnceExts$$anon$1.prototype.constructor = $c_Lframework_exts_IterableOnceExts$$anon$1;
/** @constructor */
function $h_Lframework_exts_IterableOnceExts$$anon$1() {
}
export { $h_Lframework_exts_IterableOnceExts$$anon$1 as $h_Lframework_exts_IterableOnceExts$$anon$1 };
$h_Lframework_exts_IterableOnceExts$$anon$1.prototype = $c_Lframework_exts_IterableOnceExts$$anon$1.prototype;
$c_Lframework_exts_IterableOnceExts$$anon$1.prototype.isDefinedAt__s_Option__Z = (function(x) {
  return (x instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some);
});
$c_Lframework_exts_IterableOnceExts$$anon$1.prototype.applyOrElse__s_Option__F1__O = (function(x, default$1) {
  if ((x instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
    var b = x.s_Some__f_value;
    return b;
  } else {
    return default$1.apply__O__O(x);
  }
});
$c_Lframework_exts_IterableOnceExts$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__s_Option__Z(x);
});
$c_Lframework_exts_IterableOnceExts$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__s_Option__F1__O(x, default$1);
});
var $d_Lframework_exts_IterableOnceExts$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_IterableOnceExts$$anon$1, "framework.exts.IterableOnceExts$$anon$1", ({
  Lframework_exts_IterableOnceExts$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_exts_IterableOnceExts$$anon$1 as $d_Lframework_exts_IterableOnceExts$$anon$1 };
/** @constructor */
function $c_Lframework_exts_OnSSEStreamError$OnErrorAction() {
}
export { $c_Lframework_exts_OnSSEStreamError$OnErrorAction as $c_Lframework_exts_OnSSEStreamError$OnErrorAction };
$c_Lframework_exts_OnSSEStreamError$OnErrorAction.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_OnSSEStreamError$OnErrorAction.prototype.constructor = $c_Lframework_exts_OnSSEStreamError$OnErrorAction;
/** @constructor */
function $h_Lframework_exts_OnSSEStreamError$OnErrorAction() {
}
export { $h_Lframework_exts_OnSSEStreamError$OnErrorAction as $h_Lframework_exts_OnSSEStreamError$OnErrorAction };
$h_Lframework_exts_OnSSEStreamError$OnErrorAction.prototype = $c_Lframework_exts_OnSSEStreamError$OnErrorAction.prototype;
$c_Lframework_exts_OnSSEStreamError$OnErrorAction.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lframework_exts_RequestExts$package$$anon$1(reqLog$5, x$2$5) {
  this.Lframework_exts_RequestExts$package$$anon$1__f_reqLog$3 = null;
  this.Lframework_exts_RequestExts$package$$anon$1__f_x$2$3 = null;
  this.Lframework_exts_RequestExts$package$$anon$1__f_reqLog$3 = reqLog$5;
  this.Lframework_exts_RequestExts$package$$anon$1__f_x$2$3 = x$2$5;
}
export { $c_Lframework_exts_RequestExts$package$$anon$1 as $c_Lframework_exts_RequestExts$package$$anon$1 };
$c_Lframework_exts_RequestExts$package$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$c_Lframework_exts_RequestExts$package$$anon$1.prototype.constructor = $c_Lframework_exts_RequestExts$package$$anon$1;
/** @constructor */
function $h_Lframework_exts_RequestExts$package$$anon$1() {
}
export { $h_Lframework_exts_RequestExts$package$$anon$1 as $h_Lframework_exts_RequestExts$package$$anon$1 };
$h_Lframework_exts_RequestExts$package$$anon$1.prototype = $c_Lframework_exts_RequestExts$package$$anon$1.prototype;
$c_Lframework_exts_RequestExts$package$$anon$1.prototype.isDefinedAt__jl_Throwable__Z = (function(x) {
  return (x instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException);
});
$c_Lframework_exts_RequestExts$package$$anon$1.prototype.applyOrElse__jl_Throwable__F1__O = (function(x, default$1) {
  if ((x instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException)) {
    var x34 = x.sjs_js_JavaScriptException__f_exception;
    if ((x34 !== null)) {
      var x35 = $m_Lframework_facades_AbortError$().unapply__O__s_Option(x34);
      if ((!x35.isEmpty__Z())) {
        x35.get__O();
        var info$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(["Request aborted"]));
        var this$3 = this.Lframework_exts_RequestExts$package$$anon$1__f_reqLog$3;
        var definedAt = this.Lframework_exts_RequestExts$package$$anon$1__f_x$2$3;
        var this$2 = $m_Lframework_prelude_client\uff3flogging$package$JSAppName$();
        var appName = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Newtype$WithoutValidation__apply__O__O(this$2, "app");
        var level = $s_Lframework_utils_LogLevel$__Info__Lframework_utils_LogLevel();
        this$3.atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V(level, this$3.scope__s_Option(), info$1, definedAt, appName);
        var value = $s_Lframework_utils_AuthenticatedNetworkRequestFailure$__Aborted__Lframework_utils_AuthenticatedNetworkRequestFailure();
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value);
      }
    }
    var err$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([("Error while sending request: " + x)]));
    var this$7 = this.Lframework_exts_RequestExts$package$$anon$1__f_reqLog$3;
    var definedAt$1 = this.Lframework_exts_RequestExts$package$$anon$1__f_x$2$3;
    var this$6 = $m_Lframework_prelude_client\uff3flogging$package$JSAppName$();
    var appName$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Newtype$WithoutValidation__apply__O__O(this$6, "app");
    var level$1 = $s_Lframework_utils_LogLevel$__Error__Lframework_utils_LogLevel();
    this$7.atScope__Lframework_utils_LogLevel__s_Option__sci_Seq__Lframework_sourcecode_DefinedAt__T__V(level$1, this$7.scope__s_Option(), err$1, definedAt$1, appName$1);
    var error = new $c_Lframework_utils_NetworkError$JsError(x);
    var err = new $c_Lframework_utils_NetworkOrEndpointError$NetworkError(error);
    var value$1 = new $c_Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError(err);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value$1);
  } else {
    return default$1.apply__O__O(x);
  }
});
$c_Lframework_exts_RequestExts$package$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z(x);
});
$c_Lframework_exts_RequestExts$package$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__jl_Throwable__F1__O(x, default$1);
});
var $d_Lframework_exts_RequestExts$package$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_RequestExts$package$$anon$1, "framework.exts.RequestExts$package$$anon$1", ({
  Lframework_exts_RequestExts$package$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_exts_RequestExts$package$$anon$1 as $d_Lframework_exts_RequestExts$package$$anon$1 };
/** @constructor */
function $c_Lframework_exts_SignalExts$Running$1(outer, queue) {
  this.Lframework_exts_SignalExts$Running$1__f_queue = null;
  this.Lframework_exts_SignalExts$Running$1__f_$outer = null;
  this.Lframework_exts_SignalExts$Running$1__f_queue = queue;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lframework_exts_SignalExts$Running$1__f_$outer = outer;
}
export { $c_Lframework_exts_SignalExts$Running$1 as $c_Lframework_exts_SignalExts$Running$1 };
$c_Lframework_exts_SignalExts$Running$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_SignalExts$Running$1.prototype.constructor = $c_Lframework_exts_SignalExts$Running$1;
/** @constructor */
function $h_Lframework_exts_SignalExts$Running$1() {
}
export { $h_Lframework_exts_SignalExts$Running$1 as $h_Lframework_exts_SignalExts$Running$1 };
$h_Lframework_exts_SignalExts$Running$1.prototype = $c_Lframework_exts_SignalExts$Running$1.prototype;
$c_Lframework_exts_SignalExts$Running$1.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_exts_SignalExts$Running$1.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1481549143, true);
});
$c_Lframework_exts_SignalExts$Running$1.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lframework_exts_SignalExts$Running$1)) {
    var x = this.Lframework_exts_SignalExts$Running$1__f_queue;
    var x$2 = x$0.Lframework_exts_SignalExts$Running$1__f_queue;
    return ((x === null) ? (x$2 === null) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_Seq__equals__O__Z(x, x$2));
  } else {
    return false;
  }
});
$c_Lframework_exts_SignalExts$Running$1.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lframework_exts_SignalExts$Running$1.prototype.productArity__I = (function() {
  return 1;
});
$c_Lframework_exts_SignalExts$Running$1.prototype.productPrefix__T = (function() {
  return "Running";
});
$c_Lframework_exts_SignalExts$Running$1.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_exts_SignalExts$Running$1__f_queue;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_exts_SignalExts$Running$1.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "queue";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_exts_SignalExts$Running$1.prototype.enqueue__O__Lframework_exts_SignalExts$Running$1 = (function(a) {
  return this.copy__sci_Queue__Lframework_exts_SignalExts$Running$1(this.Lframework_exts_SignalExts$Running$1__f_queue.enqueue__O__sci_Queue(a));
});
$c_Lframework_exts_SignalExts$Running$1.prototype.tryDequeue__s_Option = (function() {
  if (this.Lframework_exts_SignalExts$Running$1__f_queue.isEmpty__Z()) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var _1 = this.Lframework_exts_SignalExts$Running$1__f_queue.head__O();
    var _2 = this.copy__sci_Queue__Lframework_exts_SignalExts$Running$1(this.Lframework_exts_SignalExts$Running$1__f_queue.tail__sci_Queue());
    var value = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, _2);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
  }
});
$c_Lframework_exts_SignalExts$Running$1.prototype.copy__sci_Queue__Lframework_exts_SignalExts$Running$1 = (function(queue) {
  return new $c_Lframework_exts_SignalExts$Running$1(this.Lframework_exts_SignalExts$Running$1__f_$outer, queue);
});
function $isArrayOf_Lframework_exts_SignalExts$Running$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_exts_SignalExts$Running$1)));
}
export { $isArrayOf_Lframework_exts_SignalExts$Running$1 as $isArrayOf_Lframework_exts_SignalExts$Running$1 };
var $d_Lframework_exts_SignalExts$Running$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_SignalExts$Running$1, "framework.exts.SignalExts$Running$1", ({
  Lframework_exts_SignalExts$Running$1: 1,
  Lframework_exts_SignalExts$State$1: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_exts_SignalExts$Running$1 as $d_Lframework_exts_SignalExts$Running$1 };
/** @constructor */
function $c_Lframework_utils_AuthenticatedNetworkRequestFailure() {
}
export { $c_Lframework_utils_AuthenticatedNetworkRequestFailure as $c_Lframework_utils_AuthenticatedNetworkRequestFailure };
$c_Lframework_utils_AuthenticatedNetworkRequestFailure.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_AuthenticatedNetworkRequestFailure.prototype.constructor = $c_Lframework_utils_AuthenticatedNetworkRequestFailure;
/** @constructor */
function $h_Lframework_utils_AuthenticatedNetworkRequestFailure() {
}
export { $h_Lframework_utils_AuthenticatedNetworkRequestFailure as $h_Lframework_utils_AuthenticatedNetworkRequestFailure };
$h_Lframework_utils_AuthenticatedNetworkRequestFailure.prototype = $c_Lframework_utils_AuthenticatedNetworkRequestFailure.prototype;
$c_Lframework_utils_AuthenticatedNetworkRequestFailure.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lframework_utils_BrowserDetection() {
}
export { $c_Lframework_utils_BrowserDetection as $c_Lframework_utils_BrowserDetection };
$c_Lframework_utils_BrowserDetection.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_BrowserDetection.prototype.constructor = $c_Lframework_utils_BrowserDetection;
/** @constructor */
function $h_Lframework_utils_BrowserDetection() {
}
export { $h_Lframework_utils_BrowserDetection as $h_Lframework_utils_BrowserDetection };
$h_Lframework_utils_BrowserDetection.prototype = $c_Lframework_utils_BrowserDetection.prototype;
$c_Lframework_utils_BrowserDetection.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lframework_utils_LogLevel() {
}
export { $c_Lframework_utils_LogLevel as $c_Lframework_utils_LogLevel };
$c_Lframework_utils_LogLevel.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_LogLevel.prototype.constructor = $c_Lframework_utils_LogLevel;
/** @constructor */
function $h_Lframework_utils_LogLevel() {
}
export { $h_Lframework_utils_LogLevel as $h_Lframework_utils_LogLevel };
$h_Lframework_utils_LogLevel.prototype = $c_Lframework_utils_LogLevel.prototype;
$c_Lframework_utils_LogLevel.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lframework_utils_NetworkError() {
}
export { $c_Lframework_utils_NetworkError as $c_Lframework_utils_NetworkError };
$c_Lframework_utils_NetworkError.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_NetworkError.prototype.constructor = $c_Lframework_utils_NetworkError;
/** @constructor */
function $h_Lframework_utils_NetworkError() {
}
export { $h_Lframework_utils_NetworkError as $h_Lframework_utils_NetworkError };
$h_Lframework_utils_NetworkError.prototype = $c_Lframework_utils_NetworkError.prototype;
$c_Lframework_utils_NetworkError.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_utils_NetworkError.prototype.toString__T = (function() {
  if ((this instanceof $c_Lframework_utils_NetworkError$DecodeError)) {
    var x17 = this.Lframework_utils_NetworkError$DecodeError__f_failure;
    if ((x17 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_DecodeResult$Error)) {
      var x20 = x17.Lsttp_tapir_DecodeResult$Error__f_original;
      var x21 = x17.Lsttp_tapir_DecodeResult$Error__f_error;
      var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
      var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["|NetworkError.DecodeError(DecodeResult.Error(\n             |  original: '", "'\n             |  error(s):\n             |", "\n             |))"]));
      var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
      var x = $x_1.show$extension__s_StringContext__sci_Seq__T(sc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(x20, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString)), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__indent__I__T($m_Lframework_exts_ThrowableExts$package$().errorWithCausesAndStacktracesString__jl_Throwable__T(x21), 4), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))])));
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_StringOps$().stripMargin$extension__T__C__T(x, 124);
    }
    return (("NetworkError.DecodeError(" + x17) + ")");
  }
  if ((this instanceof $c_Lframework_utils_NetworkError$JsError)) {
    var x11 = this.Lframework_utils_NetworkError$JsError__f_jsError;
    return (("NetworkError.JsError(" + x11) + ")");
  }
  if ((this instanceof $c_Lframework_utils_NetworkError$RateLimited)) {
    var x8 = this.Lframework_utils_NetworkError$RateLimited__f_error;
    var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
    var parts$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["NetworkError.RateLimited(", ")"]));
    var sc$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts$1);
    return $x_2.show$extension__s_StringContext__sci_Seq__T(sc$1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(x8.toString__T(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))])));
  }
  if ((this instanceof $c_Lframework_utils_NetworkError$UnexpectedResponse)) {
    var x4 = this.Lframework_utils_NetworkError$UnexpectedResponse__f_statusCode;
    var x5 = this.Lframework_utils_NetworkError$UnexpectedResponse__f_error;
    var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
    var parts$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["NetworkError.UnexpectedResponse(statusCode: ", ", error: ", ")"]));
    var sc$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts$2);
    return $x_3.show$extension__s_StringContext__sci_Seq__T(sc$2, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(new $c_Lsttp_model_StatusCode(x4), $m_Lframework_prelude_sttp$package$().given_Show_StatusCode__Lcats_Show())), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(x5.toString__T(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))])));
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this);
});
/** @constructor */
function $c_Lframework_utils_NetworkOrEndpointError() {
}
export { $c_Lframework_utils_NetworkOrEndpointError as $c_Lframework_utils_NetworkOrEndpointError };
$c_Lframework_utils_NetworkOrEndpointError.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_NetworkOrEndpointError.prototype.constructor = $c_Lframework_utils_NetworkOrEndpointError;
/** @constructor */
function $h_Lframework_utils_NetworkOrEndpointError() {
}
export { $h_Lframework_utils_NetworkOrEndpointError as $h_Lframework_utils_NetworkOrEndpointError };
$h_Lframework_utils_NetworkOrEndpointError.prototype = $c_Lframework_utils_NetworkOrEndpointError.prototype;
$c_Lframework_utils_NetworkOrEndpointError.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
function $f_Lframework_utils_NewtypeNonEmptyString__$init$__V($thiz) {
  $thiz.Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$__f_validate = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lyantl_Validator$().fromRules__ALyantl_ValidatorRule__Lyantl_Validator($m_Lframework_utils_NewtypeNonEmptyString$().Lframework_utils_NewtypeNonEmptyString$__f_validators);
}
export { $f_Lframework_utils_NewtypeNonEmptyString__$init$__V as $f_Lframework_utils_NewtypeNonEmptyString__$init$__V };
/** @constructor */
function $c_Lframework_utils_PageTitleResult() {
}
export { $c_Lframework_utils_PageTitleResult as $c_Lframework_utils_PageTitleResult };
$c_Lframework_utils_PageTitleResult.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_PageTitleResult.prototype.constructor = $c_Lframework_utils_PageTitleResult;
/** @constructor */
function $h_Lframework_utils_PageTitleResult() {
}
export { $h_Lframework_utils_PageTitleResult as $h_Lframework_utils_PageTitleResult };
$h_Lframework_utils_PageTitleResult.prototype = $c_Lframework_utils_PageTitleResult.prototype;
$c_Lframework_utils_PageTitleResult.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lframework_utils_PushNotifications$State$Granted(pushManager, options, subscription, sink) {
  this.Lframework_utils_PushNotifications$State$Granted__f_pushManager = null;
  this.Lframework_utils_PushNotifications$State$Granted__f_options = null;
  this.Lframework_utils_PushNotifications$State$Granted__f_subscription = null;
  this.Lframework_utils_PushNotifications$State$Granted__f_sink = null;
  this.Lframework_utils_PushNotifications$State$Granted__f_pushManager = pushManager;
  this.Lframework_utils_PushNotifications$State$Granted__f_options = options;
  this.Lframework_utils_PushNotifications$State$Granted__f_subscription = subscription;
  this.Lframework_utils_PushNotifications$State$Granted__f_sink = sink;
}
export { $c_Lframework_utils_PushNotifications$State$Granted as $c_Lframework_utils_PushNotifications$State$Granted };
$c_Lframework_utils_PushNotifications$State$Granted.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_PushNotifications$State$Granted.prototype.constructor = $c_Lframework_utils_PushNotifications$State$Granted;
/** @constructor */
function $h_Lframework_utils_PushNotifications$State$Granted() {
}
export { $h_Lframework_utils_PushNotifications$State$Granted as $h_Lframework_utils_PushNotifications$State$Granted };
$h_Lframework_utils_PushNotifications$State$Granted.prototype = $c_Lframework_utils_PushNotifications$State$Granted.prototype;
$c_Lframework_utils_PushNotifications$State$Granted.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_utils_PushNotifications$State$Granted.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 904003105, true);
});
$c_Lframework_utils_PushNotifications$State$Granted.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lframework_utils_PushNotifications$State$Granted)) {
    var x = this.Lframework_utils_PushNotifications$State$Granted__f_pushManager;
    var y = x$0.Lframework_utils_PushNotifications$State$Granted__f_pushManager;
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Lframework_utils_PushNotifications$State$Granted__f_options;
      var y$1 = x$0.Lframework_utils_PushNotifications$State$Granted__f_options;
      var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y$1);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$2 = this.Lframework_utils_PushNotifications$State$Granted__f_subscription;
      var x$2$1 = x$0.Lframework_utils_PushNotifications$State$Granted__f_subscription;
      var $x_1 = ((x$2 === null) ? (x$2$1 === null) : x$2.equals__O__Z(x$2$1));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.Lframework_utils_PushNotifications$State$Granted__f_sink;
      var x$4 = x$0.Lframework_utils_PushNotifications$State$Granted__f_sink;
      return (x$3 === x$4);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lframework_utils_PushNotifications$State$Granted.prototype.productArity__I = (function() {
  return 4;
});
$c_Lframework_utils_PushNotifications$State$Granted.prototype.productPrefix__T = (function() {
  return "Granted";
});
$c_Lframework_utils_PushNotifications$State$Granted.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lframework_utils_PushNotifications$State$Granted__f_pushManager;
      break;
    }
    case 1: {
      return this.Lframework_utils_PushNotifications$State$Granted__f_options;
      break;
    }
    case 2: {
      return this.Lframework_utils_PushNotifications$State$Granted__f_subscription;
      break;
    }
    case 3: {
      return this.Lframework_utils_PushNotifications$State$Granted__f_sink;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lframework_utils_PushNotifications$State$Granted.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "pushManager";
      break;
    }
    case 1: {
      return "options";
      break;
    }
    case 2: {
      return "subscription";
      break;
    }
    case 3: {
      return "sink";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lframework_utils_PushNotifications$State$Granted.prototype.subscription__s_Option = (function() {
  return this.Lframework_utils_PushNotifications$State$Granted__f_subscription;
});
$c_Lframework_utils_PushNotifications$State$Granted.prototype.toString__T = (function() {
  var this$1 = this.Lframework_utils_PushNotifications$State$Granted__f_subscription;
  if (this$1.isEmpty__Z()) {
    var subStr = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0 = this$1.get__O();
    var subStr = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(JSON.stringify(x0.toJSON()));
  }
  var $x_4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
  var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["Granted(", ", subscription=", ")"]));
  var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
  var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
  var $x_2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T($m_Lframework_exts_PushSubscriptionOptions$package$().asString__Lorg_scalajs_dom_PushSubscriptionOptions__T(this.Lframework_utils_PushNotifications$State$Granted__f_options), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString));
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$();
  var evidence$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString;
  var this$9 = $m_Lcats_instances_package$option$();
  return $x_4.show$extension__s_StringContext__sci_Seq__T(sc, $x_3.genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([$x_2, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($x_1.mat__O__Lcats_Show$ContravariantShow__T(subStr, new $c_Lcats_instances_OptionInstances$$anon$2(evidence$1, this$9)))])));
});
function $isArrayOf_Lframework_utils_PushNotifications$State$Granted(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_utils_PushNotifications$State$Granted)));
}
export { $isArrayOf_Lframework_utils_PushNotifications$State$Granted as $isArrayOf_Lframework_utils_PushNotifications$State$Granted };
var $d_Lframework_utils_PushNotifications$State$Granted = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_PushNotifications$State$Granted, "framework.utils.PushNotifications$State$Granted", ({
  Lframework_utils_PushNotifications$State$Granted: 1,
  Lframework_utils_PushNotifications$State: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_utils_PushNotifications$State$Granted as $d_Lframework_utils_PushNotifications$State$Granted };
/** @constructor */
function $c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode() {
}
export { $c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode as $c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode };
$c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode.prototype.constructor = $c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode;
/** @constructor */
function $h_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode() {
}
export { $h_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode as $h_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode };
$h_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode.prototype = $c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode.prototype;
$c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lfs2_Chunk() {
}
export { $c_Lfs2_Chunk as $c_Lfs2_Chunk };
$c_Lfs2_Chunk.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_Chunk.prototype.constructor = $c_Lfs2_Chunk;
/** @constructor */
function $h_Lfs2_Chunk() {
}
export { $h_Lfs2_Chunk as $h_Lfs2_Chunk };
$h_Lfs2_Chunk.prototype = $c_Lfs2_Chunk.prototype;
$c_Lfs2_Chunk.prototype.collect__s_PartialFunction__Lfs2_Chunk = (function(pf) {
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  this.size__I();
  var i = 0;
  while ((i < this.size__I())) {
    var r = pf.applyOrElse__O__F1__O(this.apply__I__O(i), $m_Lfs2_Chunk$().Lfs2_Chunk$__f_fs2$Chunk$$$NotApplied);
    if ((r !== $m_Lfs2_Chunk$().Lfs2_Chunk$__f_fs2$Chunk$$$NotApplied)) {
      var unboxedElem = ((r === null) ? null : r);
      jsElems.push(unboxedElem);
    }
    i = ((1 + i) | 0);
  }
  var this$4 = $m_Lfs2_Chunk$();
  var values = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(jsElems);
  var evidence$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_reflect_ManifestFactory$AnyManifest$();
  var length = values.u.length;
  if ((length === 0)) {
    return this$4.Lfs2_Chunk$__f_empty_;
  } else if ((length === 1)) {
    var o = values.u[0];
    return new $c_Lfs2_Chunk$Singleton(o);
  } else {
    return new $c_Lfs2_Chunk$ArraySlice(values, 0, length, evidence$1);
  }
});
$c_Lfs2_Chunk.prototype.foreach__F1__V = (function(f) {
  var i = 0;
  while ((i < this.size__I())) {
    f.apply__O__O(this.apply__I__O(i));
    i = ((1 + i) | 0);
  }
});
$c_Lfs2_Chunk.prototype.foreachWithIndex__F2__V = (function(f) {
  var i = 0;
  while ((i < this.size__I())) {
    f.apply__O__O__O(this.apply__I__O(i), i);
    i = ((1 + i) | 0);
  }
});
$c_Lfs2_Chunk.prototype.isEmpty__Z = (function() {
  return (this.size__I() === 0);
});
$c_Lfs2_Chunk.prototype.iterator__sc_Iterator = (function() {
  return new $c_Lfs2_Chunk$$anon$1(this);
});
$c_Lfs2_Chunk.prototype.map__F1__Lfs2_Chunk = (function(f) {
  var arr = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(this.size__I());
  this.foreachWithIndex__F2__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((v1, v2) => {
    var i = (v2 | 0);
    arr.u[i] = f.apply__O__O(v1);
  })));
  var this$1 = $m_Lfs2_Chunk$();
  var evidence$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_reflect_ManifestFactory$AnyManifest$();
  var length = arr.u.length;
  if ((length === 0)) {
    return this$1.Lfs2_Chunk$__f_empty_;
  } else if ((length === 1)) {
    var o = arr.u[0];
    return new $c_Lfs2_Chunk$Singleton(o);
  } else {
    return new $c_Lfs2_Chunk$ArraySlice(arr, 0, length, evidence$1);
  }
});
$c_Lfs2_Chunk.prototype.splitAt__I__T2 = (function(n) {
  if ((n <= 0)) {
    var _1 = $m_Lfs2_Chunk$().Lfs2_Chunk$__f_empty_;
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, this);
  } else if ((n >= this.size__I())) {
    var _2 = $m_Lfs2_Chunk$().Lfs2_Chunk$__f_empty_;
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), this, _2);
  } else {
    return this.splitAtChunk___I__T2(n);
  }
});
$c_Lfs2_Chunk.prototype.take__I__Lfs2_Chunk = (function(n) {
  return this.splitAt__I__T2(n)._1__O();
});
$c_Lfs2_Chunk.prototype.hashCode__I = (function() {
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  var elem = this$1.stringHash__T__I__I("Chunk", (-137723950));
  var h = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_IntRef(elem);
  this.foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((o) => {
    h.sr_IntRef__f_elem = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().mix__I__I__I(h.sr_IntRef__f_elem, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(o));
  })));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h.sr_IntRef__f_elem, this.size__I());
});
$c_Lfs2_Chunk.prototype.equals__O__Z = (function(a) {
  return ((a instanceof $c_Lfs2_Chunk) && ((this.size__I() === a.size__I()) && $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_Iterator__sameElements__sc_IterableOnce__Z(this.iterator__sc_Iterator(), a.iterator__sc_Iterator())));
});
$c_Lfs2_Chunk.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__mkString__T__T__T__T(this.iterator__sc_Iterator(), "Chunk(", ", ", ")");
});
function $isArrayOf_Lfs2_Chunk(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Chunk)));
}
export { $isArrayOf_Lfs2_Chunk as $isArrayOf_Lfs2_Chunk };
/** @constructor */
function $c_Lfs2_Chunk$() {
  this.Lfs2_Chunk$__f_fs2$Chunk$$$NotApplied = null;
  this.Lfs2_Chunk$__f_empty_ = null;
  this.Lfs2_Chunk$__f_unit = null;
  $n_Lfs2_Chunk$ = this;
  this.Lfs2_Chunk$__f_fs2$Chunk$$$NotApplied = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$15) => $m_Lfs2_Chunk$().Lfs2_Chunk$__f_fs2$Chunk$$$NotApplied));
  this.Lfs2_Chunk$__f_empty_ = new $c_Lfs2_Chunk$EmptyChunk();
  this.Lfs2_Chunk$__f_unit = new $c_Lfs2_Chunk$Singleton((void 0));
}
export { $c_Lfs2_Chunk$ as $c_Lfs2_Chunk$ };
$c_Lfs2_Chunk$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_Chunk$.prototype.constructor = $c_Lfs2_Chunk$;
/** @constructor */
function $h_Lfs2_Chunk$() {
}
export { $h_Lfs2_Chunk$ as $h_Lfs2_Chunk$ };
$h_Lfs2_Chunk$.prototype = $c_Lfs2_Chunk$.prototype;
var $d_Lfs2_Chunk$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Chunk$, "fs2.Chunk$", ({
  Lfs2_Chunk$: 1,
  Lfs2_CollectorK: 1,
  Lfs2_ChunkCompanion213And3Compat: 1,
  Lfs2_ChunkCompanionPlatform: 1,
  Lfs2_ChunkCompanionRuntimePlatform: 1
}));
export { $d_Lfs2_Chunk$ as $d_Lfs2_Chunk$ };
var $n_Lfs2_Chunk$;
function $m_Lfs2_Chunk$() {
  if ((!$n_Lfs2_Chunk$)) {
    $n_Lfs2_Chunk$ = new $c_Lfs2_Chunk$();
  }
  return $n_Lfs2_Chunk$;
}
export { $m_Lfs2_Chunk$ as $m_Lfs2_Chunk$ };
/** @constructor */
function $c_Lfs2_Compiler$() {
  $n_Lfs2_Compiler$ = this;
  new $c_Lfs2_CompilerLowPriority0$$anon$3();
  new $c_Lfs2_CompilerLowPriority$$anon$4();
  new $c_Lfs2_Compiler$$anon$5();
}
export { $c_Lfs2_Compiler$ as $c_Lfs2_Compiler$ };
$c_Lfs2_Compiler$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_Compiler$.prototype.constructor = $c_Lfs2_Compiler$;
/** @constructor */
function $h_Lfs2_Compiler$() {
}
export { $h_Lfs2_Compiler$ as $h_Lfs2_Compiler$ };
$h_Lfs2_Compiler$.prototype = $c_Lfs2_Compiler$.prototype;
var $d_Lfs2_Compiler$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Compiler$, "fs2.Compiler$", ({
  Lfs2_Compiler$: 1,
  Lfs2_CompilerLowPriority2: 1,
  Lfs2_CompilerLowPriority1: 1,
  Lfs2_CompilerLowPriority0: 1,
  Lfs2_CompilerLowPriority: 1
}));
export { $d_Lfs2_Compiler$ as $d_Lfs2_Compiler$ };
var $n_Lfs2_Compiler$;
function $m_Lfs2_Compiler$() {
  if ((!$n_Lfs2_Compiler$)) {
    $n_Lfs2_Compiler$ = new $c_Lfs2_Compiler$();
  }
  return $n_Lfs2_Compiler$;
}
export { $m_Lfs2_Compiler$ as $m_Lfs2_Compiler$ };
class $c_Lfs2_CompositeFailure extends $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable {
  constructor(head, tail) {
    super();
    this.Lfs2_CompositeFailure__f_head = null;
    this.Lfs2_CompositeFailure__f_tail = null;
    this.Lfs2_CompositeFailure__f_head = head;
    this.Lfs2_CompositeFailure__f_tail = tail;
    var message = ((((("Multiple exceptions were thrown (" + ((1 + tail.size__I()) | 0)) + "), first ") + $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$objectClassName(head)) + ": ") + head.getMessage__T());
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, head, true, true);
  }
  productIterator__sc_Iterator() {
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
  }
  hashCode__I() {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1221187150, true);
  }
  equals__O__Z(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lfs2_CompositeFailure)) {
      var x = this.Lfs2_CompositeFailure__f_head;
      var x$2 = x$0.Lfs2_CompositeFailure__f_head;
      if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
        var x$3 = this.Lfs2_CompositeFailure__f_tail;
        var x$4 = x$0.Lfs2_CompositeFailure__f_tail;
        return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  productArity__I() {
    return 2;
  }
  productPrefix__T() {
    return "CompositeFailure";
  }
  productElement__I__O(n) {
    if ((n === 0)) {
      return this.Lfs2_CompositeFailure__f_head;
    }
    if ((n === 1)) {
      return this.Lfs2_CompositeFailure__f_tail;
    }
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  productElementName__I__T(n) {
    if ((n === 0)) {
      return "head";
    }
    if ((n === 1)) {
      return "tail";
    }
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
  }
}
export { $c_Lfs2_CompositeFailure as $c_Lfs2_CompositeFailure };
function $isArrayOf_Lfs2_CompositeFailure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_CompositeFailure)));
}
export { $isArrayOf_Lfs2_CompositeFailure as $isArrayOf_Lfs2_CompositeFailure };
var $d_Lfs2_CompositeFailure = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_CompositeFailure, "fs2.CompositeFailure", ({
  Lfs2_CompositeFailure: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lfs2_CompositeFailure as $d_Lfs2_CompositeFailure };
/** @constructor */
function $c_Lfs2_Pull$$anon$1(f$14, outer) {
  this.Lfs2_Pull$Bind__f_step = null;
  this.Lfs2_Pull$$anon$1__f_f$1 = null;
  this.Lfs2_Pull$$anon$1__f_f$1 = f$14;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  $ct_Lfs2_Pull$Bind__Lfs2_Pull__(this, outer);
}
export { $c_Lfs2_Pull$$anon$1 as $c_Lfs2_Pull$$anon$1 };
$c_Lfs2_Pull$$anon$1.prototype = new $h_Lfs2_Pull$Bind();
$c_Lfs2_Pull$$anon$1.prototype.constructor = $c_Lfs2_Pull$$anon$1;
/** @constructor */
function $h_Lfs2_Pull$$anon$1() {
}
export { $h_Lfs2_Pull$$anon$1 as $h_Lfs2_Pull$$anon$1 };
$h_Lfs2_Pull$$anon$1.prototype = $c_Lfs2_Pull$$anon$1.prototype;
$c_Lfs2_Pull$$anon$1.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(e) {
  if ((e instanceof $c_Lfs2_Pull$Succeeded)) {
    var x15 = e.Lfs2_Pull$Succeeded__f_r;
    try {
      return this.Lfs2_Pull$$anon$1__f_f$1.apply__O__O(x15);
    } catch (e$2) {
      var e$3 = ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e$2 : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e$2));
      var x2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$3);
      if ((!x2.isEmpty__Z())) {
        var x3 = x2.get__O();
        return new $c_Lfs2_Pull$Fail(x3);
      }
      throw ((e$3 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$3.sjs_js_JavaScriptException__f_exception : e$3);
    }
  }
  if ((e instanceof $c_Lfs2_Pull$Interrupted)) {
    return e;
  }
  if ((e instanceof $c_Lfs2_Pull$Fail)) {
    return e;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(e);
});
var $d_Lfs2_Pull$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$$anon$1, "fs2.Pull$$anon$1", ({
  Lfs2_Pull$$anon$1: 1,
  Lfs2_Pull$Bind: 1,
  Lfs2_Pull: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
}));
export { $d_Lfs2_Pull$$anon$1 as $d_Lfs2_Pull$$anon$1 };
/** @constructor */
function $c_Lfs2_Pull$$anon$2(post$3, outer) {
  this.Lfs2_Pull$Bind__f_step = null;
  this.Lfs2_Pull$$anon$2__f_post$1 = null;
  this.Lfs2_Pull$$anon$2__f_post$1 = post$3;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  $ct_Lfs2_Pull$Bind__Lfs2_Pull__(this, outer);
}
export { $c_Lfs2_Pull$$anon$2 as $c_Lfs2_Pull$$anon$2 };
$c_Lfs2_Pull$$anon$2.prototype = new $h_Lfs2_Pull$Bind();
$c_Lfs2_Pull$$anon$2.prototype.constructor = $c_Lfs2_Pull$$anon$2;
/** @constructor */
function $h_Lfs2_Pull$$anon$2() {
}
export { $h_Lfs2_Pull$$anon$2 as $h_Lfs2_Pull$$anon$2 };
$h_Lfs2_Pull$$anon$2.prototype = $c_Lfs2_Pull$$anon$2.prototype;
$c_Lfs2_Pull$$anon$2.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(r) {
  if ((r instanceof $c_Lfs2_Pull$Succeeded)) {
    return this.Lfs2_Pull$$anon$2__f_post$1.apply__O();
  }
  if ((r instanceof $c_Lfs2_Pull$Interrupted)) {
    return r;
  }
  if ((r instanceof $c_Lfs2_Pull$Fail)) {
    return r;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(r);
});
var $d_Lfs2_Pull$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$$anon$2, "fs2.Pull$$anon$2", ({
  Lfs2_Pull$$anon$2: 1,
  Lfs2_Pull$Bind: 1,
  Lfs2_Pull: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
}));
export { $d_Lfs2_Pull$$anon$2 as $d_Lfs2_Pull$$anon$2 };
/** @constructor */
function $c_Lfs2_Pull$$anon$3(handler$2, outer) {
  this.Lfs2_Pull$Bind__f_step = null;
  this.Lfs2_Pull$$anon$3__f_handler$1 = null;
  this.Lfs2_Pull$$anon$3__f_handler$1 = handler$2;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  $ct_Lfs2_Pull$Bind__Lfs2_Pull__(this, outer);
}
export { $c_Lfs2_Pull$$anon$3 as $c_Lfs2_Pull$$anon$3 };
$c_Lfs2_Pull$$anon$3.prototype = new $h_Lfs2_Pull$Bind();
$c_Lfs2_Pull$$anon$3.prototype.constructor = $c_Lfs2_Pull$$anon$3;
/** @constructor */
function $h_Lfs2_Pull$$anon$3() {
}
export { $h_Lfs2_Pull$$anon$3 as $h_Lfs2_Pull$$anon$3 };
$h_Lfs2_Pull$$anon$3.prototype = $c_Lfs2_Pull$$anon$3.prototype;
$c_Lfs2_Pull$$anon$3.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(term) {
  if ((term instanceof $c_Lfs2_Pull$Fail)) {
    var x27 = term.Lfs2_Pull$Fail__f_error;
    try {
      return this.Lfs2_Pull$$anon$3__f_handler$1.apply__O__O(x27);
    } catch (e$2) {
      var e$3 = ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e$2 : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e$2));
      var x21 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$3);
      if ((!x21.isEmpty__Z())) {
        var x22 = x21.get__O();
        return new $c_Lfs2_Pull$Fail(x22);
      }
      throw ((e$3 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$3.sjs_js_JavaScriptException__f_exception : e$3);
    }
  } else {
    return term;
  }
});
var $d_Lfs2_Pull$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$$anon$3, "fs2.Pull$$anon$3", ({
  Lfs2_Pull$$anon$3: 1,
  Lfs2_Pull$Bind: 1,
  Lfs2_Pull: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
}));
export { $d_Lfs2_Pull$$anon$3 as $d_Lfs2_Pull$$anon$3 };
/** @constructor */
function $c_Lfs2_Pull$$anon$4(f$15, outer) {
  this.Lfs2_Pull$Bind__f_step = null;
  this.Lfs2_Pull$$anon$4__f_f$3 = null;
  this.Lfs2_Pull$$anon$4__f_f$3 = f$15;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  $ct_Lfs2_Pull$Bind__Lfs2_Pull__(this, outer);
}
export { $c_Lfs2_Pull$$anon$4 as $c_Lfs2_Pull$$anon$4 };
$c_Lfs2_Pull$$anon$4.prototype = new $h_Lfs2_Pull$Bind();
$c_Lfs2_Pull$$anon$4.prototype.constructor = $c_Lfs2_Pull$$anon$4;
/** @constructor */
function $h_Lfs2_Pull$$anon$4() {
}
export { $h_Lfs2_Pull$$anon$4 as $h_Lfs2_Pull$$anon$4 };
$h_Lfs2_Pull$$anon$4.prototype = $c_Lfs2_Pull$$anon$4.prototype;
$c_Lfs2_Pull$$anon$4.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(r) {
  return r.map__F1__Lfs2_Pull(this.Lfs2_Pull$$anon$4__f_f$3);
});
var $d_Lfs2_Pull$$anon$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$$anon$4, "fs2.Pull$$anon$4", ({
  Lfs2_Pull$$anon$4: 1,
  Lfs2_Pull$Bind: 1,
  Lfs2_Pull: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
}));
export { $d_Lfs2_Pull$$anon$4 as $d_Lfs2_Pull$$anon$4 };
/** @constructor */
function $c_Lfs2_Pull$$anon$7(fmoc$1, view$1) {
  this.Lfs2_Pull$Bind__f_step = null;
  this.Lfs2_Pull$$anon$7__f_view$2 = null;
  this.Lfs2_Pull$$anon$7__f_view$2 = view$1;
  $ct_Lfs2_Pull$Bind__Lfs2_Pull__(this, fmoc$1);
}
export { $c_Lfs2_Pull$$anon$7 as $c_Lfs2_Pull$$anon$7 };
$c_Lfs2_Pull$$anon$7.prototype = new $h_Lfs2_Pull$Bind();
$c_Lfs2_Pull$$anon$7.prototype.constructor = $c_Lfs2_Pull$$anon$7;
/** @constructor */
function $h_Lfs2_Pull$$anon$7() {
}
export { $h_Lfs2_Pull$$anon$7 as $h_Lfs2_Pull$$anon$7 };
$h_Lfs2_Pull$$anon$7.prototype = $c_Lfs2_Pull$$anon$7.prototype;
$c_Lfs2_Pull$$anon$7.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(r) {
  return this.Lfs2_Pull$$anon$7__f_view$2.apply__O__O(r);
});
var $d_Lfs2_Pull$$anon$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$$anon$7, "fs2.Pull$$anon$7", ({
  Lfs2_Pull$$anon$7: 1,
  Lfs2_Pull$Bind: 1,
  Lfs2_Pull: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
}));
export { $d_Lfs2_Pull$$anon$7 as $d_Lfs2_Pull$$anon$7 };
/** @constructor */
function $c_Lfs2_Pull$$anon$8(stream$3, childScope$1) {
  this.Lfs2_Pull$Bind__f_step = null;
  this.Lfs2_Pull$$anon$8__f_childScope$2 = null;
  this.Lfs2_Pull$$anon$8__f_childScope$2 = childScope$1;
  $ct_Lfs2_Pull$Bind__Lfs2_Pull__(this, stream$3);
}
export { $c_Lfs2_Pull$$anon$8 as $c_Lfs2_Pull$$anon$8 };
$c_Lfs2_Pull$$anon$8.prototype = new $h_Lfs2_Pull$Bind();
$c_Lfs2_Pull$$anon$8.prototype.constructor = $c_Lfs2_Pull$$anon$8;
/** @constructor */
function $h_Lfs2_Pull$$anon$8() {
}
export { $h_Lfs2_Pull$$anon$8 as $h_Lfs2_Pull$$anon$8 };
$h_Lfs2_Pull$$anon$8.prototype = $c_Lfs2_Pull$$anon$8.prototype;
$c_Lfs2_Pull$$anon$8.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(r) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$endScope$1__Lcats_effect_kernel_Unique$Token__Lfs2_Pull$Terminal__Lfs2_Pull(this.Lfs2_Pull$$anon$8__f_childScope$2.Lfs2_internal_Scope__f_id, r);
});
var $d_Lfs2_Pull$$anon$8 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$$anon$8, "fs2.Pull$$anon$8", ({
  Lfs2_Pull$$anon$8: 1,
  Lfs2_Pull$Bind: 1,
  Lfs2_Pull: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
}));
export { $d_Lfs2_Pull$$anon$8 as $d_Lfs2_Pull$$anon$8 };
/** @constructor */
function $c_Lfs2_Pull$$anon$9(p$2, f$11) {
  this.Lfs2_Pull$Bind__f_step = null;
  this.Lfs2_Pull$$anon$9__f_f$12 = null;
  this.Lfs2_Pull$$anon$9__f_f$12 = f$11;
  $ct_Lfs2_Pull$Bind__Lfs2_Pull__(this, p$2);
}
export { $c_Lfs2_Pull$$anon$9 as $c_Lfs2_Pull$$anon$9 };
$c_Lfs2_Pull$$anon$9.prototype = new $h_Lfs2_Pull$Bind();
$c_Lfs2_Pull$$anon$9.prototype.constructor = $c_Lfs2_Pull$$anon$9;
/** @constructor */
function $h_Lfs2_Pull$$anon$9() {
}
export { $h_Lfs2_Pull$$anon$9 as $h_Lfs2_Pull$$anon$9 };
$h_Lfs2_Pull$$anon$9.prototype = $c_Lfs2_Pull$$anon$9.prototype;
$c_Lfs2_Pull$$anon$9.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(r) {
  try {
    return this.Lfs2_Pull$$anon$9__f_f$12.apply__O__O(r);
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
    var x340 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
    if ((!x340.isEmpty__Z())) {
      var x341 = x340.get__O();
      return new $c_Lfs2_Pull$Fail(x341);
    }
    throw ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
  }
});
var $d_Lfs2_Pull$$anon$9 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$$anon$9, "fs2.Pull$$anon$9", ({
  Lfs2_Pull$$anon$9: 1,
  Lfs2_Pull$Bind: 1,
  Lfs2_Pull: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
}));
export { $d_Lfs2_Pull$$anon$9 as $d_Lfs2_Pull$$anon$9 };
/** @constructor */
function $c_Lfs2_Pull$BindBind(step, bb, del) {
  this.Lfs2_Pull$Bind__f_step = null;
  this.Lfs2_Pull$BindBind__f_bb = null;
  this.Lfs2_Pull$BindBind__f_del = null;
  this.Lfs2_Pull$BindBind__f_bb = bb;
  this.Lfs2_Pull$BindBind__f_del = del;
  $ct_Lfs2_Pull$Bind__Lfs2_Pull__(this, step);
}
export { $c_Lfs2_Pull$BindBind as $c_Lfs2_Pull$BindBind };
$c_Lfs2_Pull$BindBind.prototype = new $h_Lfs2_Pull$Bind();
$c_Lfs2_Pull$BindBind.prototype.constructor = $c_Lfs2_Pull$BindBind;
/** @constructor */
function $h_Lfs2_Pull$BindBind() {
}
export { $h_Lfs2_Pull$BindBind as $h_Lfs2_Pull$BindBind };
$h_Lfs2_Pull$BindBind.prototype = $c_Lfs2_Pull$BindBind.prototype;
$c_Lfs2_Pull$BindBind.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(tx) {
  try {
    return $m_Lfs2_Pull$().fs2$Pull$$$bindBindAux__Lfs2_Pull__Lfs2_Pull$Bind__Lfs2_Pull(this.Lfs2_Pull$BindBind__f_bb.cont__Lfs2_Pull$Terminal__Lfs2_Pull(tx), this.Lfs2_Pull$BindBind__f_del);
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
    var x103 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
    if ((!x103.isEmpty__Z())) {
      var x104 = x103.get__O();
      return new $c_Lfs2_Pull$Fail(x104);
    }
    throw ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
  }
});
function $isArrayOf_Lfs2_Pull$BindBind(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$BindBind)));
}
export { $isArrayOf_Lfs2_Pull$BindBind as $isArrayOf_Lfs2_Pull$BindBind };
var $d_Lfs2_Pull$BindBind = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$BindBind, "fs2.Pull$BindBind", ({
  Lfs2_Pull$BindBind: 1,
  Lfs2_Pull$Bind: 1,
  Lfs2_Pull: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
}));
export { $d_Lfs2_Pull$BindBind as $d_Lfs2_Pull$BindBind };
/** @constructor */
function $c_Lfs2_Pull$CloseScope() {
}
export { $c_Lfs2_Pull$CloseScope as $c_Lfs2_Pull$CloseScope };
$c_Lfs2_Pull$CloseScope.prototype = new $h_Lfs2_Pull$AlgEffect();
$c_Lfs2_Pull$CloseScope.prototype.constructor = $c_Lfs2_Pull$CloseScope;
/** @constructor */
function $h_Lfs2_Pull$CloseScope() {
}
export { $h_Lfs2_Pull$CloseScope as $h_Lfs2_Pull$CloseScope };
$h_Lfs2_Pull$CloseScope.prototype = $c_Lfs2_Pull$CloseScope.prototype;
function $isArrayOf_Lfs2_Pull$CloseScope(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$CloseScope)));
}
export { $isArrayOf_Lfs2_Pull$CloseScope as $isArrayOf_Lfs2_Pull$CloseScope };
/** @constructor */
function $c_Lfs2_Pull$DelegateBind(step, delegate) {
  this.Lfs2_Pull$Bind__f_step = null;
  this.Lfs2_Pull$DelegateBind__f_delegate = null;
  this.Lfs2_Pull$DelegateBind__f_delegate = delegate;
  $ct_Lfs2_Pull$Bind__Lfs2_Pull__(this, step);
}
export { $c_Lfs2_Pull$DelegateBind as $c_Lfs2_Pull$DelegateBind };
$c_Lfs2_Pull$DelegateBind.prototype = new $h_Lfs2_Pull$Bind();
$c_Lfs2_Pull$DelegateBind.prototype.constructor = $c_Lfs2_Pull$DelegateBind;
/** @constructor */
function $h_Lfs2_Pull$DelegateBind() {
}
export { $h_Lfs2_Pull$DelegateBind as $h_Lfs2_Pull$DelegateBind };
$h_Lfs2_Pull$DelegateBind.prototype = $c_Lfs2_Pull$DelegateBind.prototype;
$c_Lfs2_Pull$DelegateBind.prototype.delegate__Lfs2_Pull$Bind = (function() {
  return this.Lfs2_Pull$DelegateBind__f_delegate;
});
$c_Lfs2_Pull$DelegateBind.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(yr) {
  return this.Lfs2_Pull$DelegateBind__f_delegate.cont__Lfs2_Pull$Terminal__Lfs2_Pull(yr);
});
var $d_Lfs2_Pull$DelegateBind = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$DelegateBind, "fs2.Pull$DelegateBind", ({
  Lfs2_Pull$DelegateBind: 1,
  Lfs2_Pull$Bind: 1,
  Lfs2_Pull: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
}));
export { $d_Lfs2_Pull$DelegateBind as $d_Lfs2_Pull$DelegateBind };
/** @constructor */
function $c_Lfs2_Stream$$anon$2() {
}
export { $c_Lfs2_Stream$$anon$2 as $c_Lfs2_Stream$$anon$2 };
$c_Lfs2_Stream$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$c_Lfs2_Stream$$anon$2.prototype.constructor = $c_Lfs2_Stream$$anon$2;
/** @constructor */
function $h_Lfs2_Stream$$anon$2() {
}
export { $h_Lfs2_Stream$$anon$2 as $h_Lfs2_Stream$$anon$2 };
$h_Lfs2_Stream$$anon$2.prototype = $c_Lfs2_Stream$$anon$2.prototype;
$c_Lfs2_Stream$$anon$2.prototype.isDefinedAt__T2__Z = (function(x) {
  if ((x !== null)) {
    var x259 = x._1__O();
    var x260 = x._2__O();
    if ((x259 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      if ((x260 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
        return true;
      }
    }
  }
  return false;
});
$c_Lfs2_Stream$$anon$2.prototype.applyOrElse__T2__F1__O = (function(x, default$1) {
  if ((x !== null)) {
    var x266 = x._1__O();
    var x267 = x._2__O();
    if ((x266 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var r1 = x266.s_Some__f_value;
      if ((x267 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
        var r2 = x267.s_Some__f_value;
        return $m_Lfs2_CompositeFailure$().fromResults__s_util_Either__s_util_Either__s_util_Either(r1, r2);
      }
    }
  }
  return default$1.apply__O__O(x);
});
$c_Lfs2_Stream$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T2__Z(x);
});
$c_Lfs2_Stream$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T2__F1__O(x, default$1);
});
var $d_Lfs2_Stream$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Stream$$anon$2, "fs2.Stream$$anon$2", ({
  Lfs2_Stream$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lfs2_Stream$$anon$2 as $d_Lfs2_Stream$$anon$2 };
/** @constructor */
function $c_Lfs2_internal_Scope$$anon$1() {
}
export { $c_Lfs2_internal_Scope$$anon$1 as $c_Lfs2_internal_Scope$$anon$1 };
$c_Lfs2_internal_Scope$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$c_Lfs2_internal_Scope$$anon$1.prototype.constructor = $c_Lfs2_internal_Scope$$anon$1;
/** @constructor */
function $h_Lfs2_internal_Scope$$anon$1() {
}
export { $h_Lfs2_internal_Scope$$anon$1 as $h_Lfs2_internal_Scope$$anon$1 };
$h_Lfs2_internal_Scope$$anon$1.prototype = $c_Lfs2_internal_Scope$$anon$1.prototype;
$c_Lfs2_internal_Scope$$anon$1.prototype.isDefinedAt__s_util_Either__Z = (function(x) {
  return (x instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left);
});
$c_Lfs2_internal_Scope$$anon$1.prototype.applyOrElse__s_util_Either__F1__O = (function(x, default$1) {
  if ((x instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
    var err = x.s_util_Left__f_value;
    return err;
  } else {
    return default$1.apply__O__O(x);
  }
});
$c_Lfs2_internal_Scope$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__s_util_Either__Z(x);
});
$c_Lfs2_internal_Scope$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__s_util_Either__F1__O(x, default$1);
});
var $d_Lfs2_internal_Scope$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_internal_Scope$$anon$1, "fs2.internal.Scope$$anon$1", ({
  Lfs2_internal_Scope$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lfs2_internal_Scope$$anon$1 as $d_Lfs2_internal_Scope$$anon$1 };
/** @constructor */
function $c_Lfs2_internal_Scope$State$Closed() {
}
export { $c_Lfs2_internal_Scope$State$Closed as $c_Lfs2_internal_Scope$State$Closed };
$c_Lfs2_internal_Scope$State$Closed.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_internal_Scope$State$Closed.prototype.constructor = $c_Lfs2_internal_Scope$State$Closed;
/** @constructor */
function $h_Lfs2_internal_Scope$State$Closed() {
}
export { $h_Lfs2_internal_Scope$State$Closed as $h_Lfs2_internal_Scope$State$Closed };
$h_Lfs2_internal_Scope$State$Closed.prototype = $c_Lfs2_internal_Scope$State$Closed.prototype;
$c_Lfs2_internal_Scope$State$Closed.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lfs2_internal_Scope$State$Closed.prototype.hashCode__I = (function() {
  return 2021313932;
});
$c_Lfs2_internal_Scope$State$Closed.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || (x$0 instanceof $c_Lfs2_internal_Scope$State$Closed));
});
$c_Lfs2_internal_Scope$State$Closed.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_internal_Scope$State$Closed.prototype.productArity__I = (function() {
  return 0;
});
$c_Lfs2_internal_Scope$State$Closed.prototype.productPrefix__T = (function() {
  return "Closed";
});
$c_Lfs2_internal_Scope$State$Closed.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lfs2_internal_Scope$State$Closed.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lfs2_internal_Scope$State$Closed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_internal_Scope$State$Closed)));
}
export { $isArrayOf_Lfs2_internal_Scope$State$Closed as $isArrayOf_Lfs2_internal_Scope$State$Closed };
var $d_Lfs2_internal_Scope$State$Closed = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_internal_Scope$State$Closed, "fs2.internal.Scope$State$Closed", ({
  Lfs2_internal_Scope$State$Closed: 1,
  Lfs2_internal_Scope$State: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lfs2_internal_Scope$State$Closed as $d_Lfs2_internal_Scope$State$Closed };
/** @constructor */
function $c_Lfs2_internal_Scope$State$Open(resources, children) {
  this.Lfs2_internal_Scope$State$Open__f_resources = null;
  this.Lfs2_internal_Scope$State$Open__f_children = null;
  this.Lfs2_internal_Scope$State$Open__f_resources = resources;
  this.Lfs2_internal_Scope$State$Open__f_children = children;
}
export { $c_Lfs2_internal_Scope$State$Open as $c_Lfs2_internal_Scope$State$Open };
$c_Lfs2_internal_Scope$State$Open.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_internal_Scope$State$Open.prototype.constructor = $c_Lfs2_internal_Scope$State$Open;
/** @constructor */
function $h_Lfs2_internal_Scope$State$Open() {
}
export { $h_Lfs2_internal_Scope$State$Open as $h_Lfs2_internal_Scope$State$Open };
$h_Lfs2_internal_Scope$State$Open.prototype = $c_Lfs2_internal_Scope$State$Open.prototype;
$c_Lfs2_internal_Scope$State$Open.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lfs2_internal_Scope$State$Open.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 161497921, true);
});
$c_Lfs2_internal_Scope$State$Open.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_internal_Scope$State$Open)) {
    var x = this.Lfs2_internal_Scope$State$Open__f_resources;
    var x$2 = x$0.Lfs2_internal_Scope$State$Open__f_resources;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lfs2_internal_Scope$State$Open__f_children;
      var x$4 = x$0.Lfs2_internal_Scope$State$Open__f_children;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lfs2_internal_Scope$State$Open.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_internal_Scope$State$Open.prototype.productArity__I = (function() {
  return 2;
});
$c_Lfs2_internal_Scope$State$Open.prototype.productPrefix__T = (function() {
  return "Open";
});
$c_Lfs2_internal_Scope$State$Open.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_internal_Scope$State$Open__f_resources;
  }
  if ((n === 1)) {
    return this.Lfs2_internal_Scope$State$Open__f_children;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lfs2_internal_Scope$State$Open.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "resources";
  }
  if ((n === 1)) {
    return "children";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lfs2_internal_Scope$State$Open.prototype.unregisterChild__Lcats_effect_kernel_Unique$Token__Lfs2_internal_Scope$State = (function(id) {
  var this$1 = this.Lfs2_internal_Scope$State$Open__f_children;
  var acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil;
  var x116;
  var acc$tailLocal2 = acc;
  var rem$tailLocal2 = this$1;
  while (true) {
    var x154 = rem$tailLocal2.uncons__s_Option();
    if ((x154 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var x156 = x154.s_Some__f_value;
      if ((x156 !== null)) {
        var a = x156._1__O();
        var tail = x156._2__O();
        var x = a.Lfs2_internal_Scope__f_id;
        if ((!(x === id))) {
          var this$2 = acc$tailLocal2;
          var acc$tailLocal2$tmp1 = this$2.append__O__Lcats_data_Chain(a);
          rem$tailLocal2 = tail;
          acc$tailLocal2 = acc$tailLocal2$tmp1;
          continue;
        }
        var this$3 = acc$tailLocal2;
        var _2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(this$3, tail);
        var value = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), a, _2);
        var x116 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
        break;
      }
    }
    var x$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    if ((x$1 === x154)) {
      var x116 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      break;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x154);
  }
  if ((x116 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
    var x118 = x116.s_Some__f_value;
    if ((x118 !== null)) {
      var newChildren = x118._2__O();
      var resources = this.Lfs2_internal_Scope$State$Open__f_resources;
      return new $c_Lfs2_internal_Scope$State$Open(resources, newChildren);
    }
  }
  var x$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  if ((x$2 === x116)) {
    return this;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x116);
});
function $isArrayOf_Lfs2_internal_Scope$State$Open(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_internal_Scope$State$Open)));
}
export { $isArrayOf_Lfs2_internal_Scope$State$Open as $isArrayOf_Lfs2_internal_Scope$State$Open };
var $d_Lfs2_internal_Scope$State$Open = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_internal_Scope$State$Open, "fs2.internal.Scope$State$Open", ({
  Lfs2_internal_Scope$State$Open: 1,
  Lfs2_internal_Scope$State: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lfs2_internal_Scope$State$Open as $d_Lfs2_internal_Scope$State$Open };
/** @constructor */
function $c_Lio_circe_Encoder$$anon$34(encodeA$17) {
  this.Lio_circe_Encoder$$anon$34__f_encodeA$9 = null;
  this.Lio_circe_Encoder$$anon$34__f_encodeA$9 = encodeA$17;
}
export { $c_Lio_circe_Encoder$$anon$34 as $c_Lio_circe_Encoder$$anon$34 };
$c_Lio_circe_Encoder$$anon$34.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_circe_Encoder$$anon$34.prototype.constructor = $c_Lio_circe_Encoder$$anon$34;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$34() {
}
export { $h_Lio_circe_Encoder$$anon$34 as $h_Lio_circe_Encoder$$anon$34 };
$h_Lio_circe_Encoder$$anon$34.prototype = $c_Lio_circe_Encoder$$anon$34.prototype;
$c_Lio_circe_Encoder$$anon$34.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this, a);
});
$c_Lio_circe_Encoder$$anon$34.prototype.encodeArray__O__sci_Vector = (function(a) {
  var this$2 = new $c_Lcats_data_NonEmptySetOps(a);
  var s = this$2.Lcats_data_NonEmptySetOps__f_value;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$().from__sc_IterableOnce__sci_Vector(s).map__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$14) => this.Lio_circe_Encoder$$anon$34__f_encodeA$9.apply__O__Lio_circe_Json(_$14))));
});
var $d_Lio_circe_Encoder$$anon$34 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_circe_Encoder$$anon$34, "io.circe.Encoder$$anon$34", ({
  Lio_circe_Encoder$$anon$34: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder$AsArray: 1
}));
export { $d_Lio_circe_Encoder$$anon$34 as $d_Lio_circe_Encoder$$anon$34 };
function $p_Lio_circe_derivation_ConfiguredDecoder$$anon$3__fp__F1($thiz) {
  if ((!$thiz.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_fpbitmap$1)) {
    $thiz.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_fp$lzy1 = $thiz.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_fromProduct$4.apply__O();
    $thiz.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_fpbitmap$1 = true;
  }
  return $thiz.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_fp$lzy1;
}
export { $p_Lio_circe_derivation_ConfiguredDecoder$$anon$3__fp__F1 as $p_Lio_circe_derivation_ConfiguredDecoder$$anon$3__fp__F1 };
/** @constructor */
function $c_Lio_circe_derivation_ConfiguredDecoder$$anon$3(conf$3, nme$3, fromProduct$3, decoders$5, labels$5, defaults$5) {
  this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_fromProduct$4 = null;
  this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_decoders$6 = null;
  this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_labels$6 = null;
  this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_defaults$6 = null;
  this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_io$circe$derivation$ConfiguredDecoder$$conf = null;
  this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_constructorNames$lzy3 = null;
  this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_constructorNamesbitmap$3 = false;
  this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_io$circe$derivation$ConfiguredDecoder$$decodersDict$lzy3 = null;
  this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_io$circe$derivation$ConfiguredDecoder$$decodersDictbitmap$3 = false;
  this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_fp$lzy1 = null;
  this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_fpbitmap$1 = false;
  this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_name = null;
  this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_elemDecoders$lzy3 = null;
  this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_elemDecodersbitmap$3 = false;
  this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_elemLabels$lzy3 = null;
  this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_elemLabelsbitmap$3 = false;
  this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_elemDefaults$lzy3 = null;
  this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_elemDefaultsbitmap$3 = false;
  this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_fromProduct$4 = fromProduct$3;
  this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_decoders$6 = decoders$5;
  this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_labels$6 = labels$5;
  this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_defaults$6 = defaults$5;
  this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_io$circe$derivation$ConfiguredDecoder$$conf = conf$3;
  this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_name = nme$3;
}
export { $c_Lio_circe_derivation_ConfiguredDecoder$$anon$3 as $c_Lio_circe_derivation_ConfiguredDecoder$$anon$3 };
$c_Lio_circe_derivation_ConfiguredDecoder$$anon$3.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_circe_derivation_ConfiguredDecoder$$anon$3.prototype.constructor = $c_Lio_circe_derivation_ConfiguredDecoder$$anon$3;
/** @constructor */
function $h_Lio_circe_derivation_ConfiguredDecoder$$anon$3() {
}
export { $h_Lio_circe_derivation_ConfiguredDecoder$$anon$3 as $h_Lio_circe_derivation_ConfiguredDecoder$$anon$3 };
$h_Lio_circe_derivation_ConfiguredDecoder$$anon$3.prototype = $c_Lio_circe_derivation_ConfiguredDecoder$$anon$3.prototype;
$c_Lio_circe_derivation_ConfiguredDecoder$$anon$3.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$c_Lio_circe_derivation_ConfiguredDecoder$$anon$3.prototype.tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated = (function(c) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lio_circe_Decoder__tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated(this, c);
});
$c_Lio_circe_derivation_ConfiguredDecoder$$anon$3.prototype.io$circe$derivation$ConfiguredDecoder$$conf__Lio_circe_derivation_Configuration = (function() {
  return this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_io$circe$derivation$ConfiguredDecoder$$conf;
});
$c_Lio_circe_derivation_ConfiguredDecoder$$anon$3.prototype.constructorNames__sci_List = (function() {
  if ((!this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_constructorNamesbitmap$3)) {
    this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_constructorNames$lzy3 = $f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_constructorNamesbitmap$3 = true;
  }
  return this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_constructorNames$lzy3;
});
$c_Lio_circe_derivation_ConfiguredDecoder$$anon$3.prototype.io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map = (function() {
  if ((!this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_io$circe$derivation$ConfiguredDecoder$$decodersDictbitmap$3)) {
    this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_io$circe$derivation$ConfiguredDecoder$$decodersDict$lzy3 = $f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_io$circe$derivation$ConfiguredDecoder$$decodersDictbitmap$3 = true;
  }
  return this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_io$circe$derivation$ConfiguredDecoder$$decodersDict$lzy3;
});
$c_Lio_circe_derivation_ConfiguredDecoder$$anon$3.prototype.name__T = (function() {
  return this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_name;
});
$c_Lio_circe_derivation_ConfiguredDecoder$$anon$3.prototype.elemDecoders__sci_List = (function() {
  if ((!this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_elemDecodersbitmap$3)) {
    this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_elemDecoders$lzy3 = this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_decoders$6.apply__O();
    this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_elemDecodersbitmap$3 = true;
  }
  return this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_elemDecoders$lzy3;
});
$c_Lio_circe_derivation_ConfiguredDecoder$$anon$3.prototype.elemLabels__sci_List = (function() {
  if ((!this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_elemLabelsbitmap$3)) {
    this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_elemLabels$lzy3 = this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_labels$6;
    this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_elemLabelsbitmap$3 = true;
  }
  return this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_elemLabels$lzy3;
});
$c_Lio_circe_derivation_ConfiguredDecoder$$anon$3.prototype.elemDefaults__Lio_circe_derivation_Default = (function() {
  if ((!this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_elemDefaultsbitmap$3)) {
    this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_elemDefaults$lzy3 = this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_defaults$6;
    this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_elemDefaultsbitmap$3 = true;
  }
  return this.Lio_circe_derivation_ConfiguredDecoder$$anon$3__f_elemDefaults$lzy3;
});
$c_Lio_circe_derivation_ConfiguredDecoder$$anon$3.prototype.isSum__Z = (function() {
  return false;
});
$c_Lio_circe_derivation_ConfiguredDecoder$$anon$3.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var fromProduct = $p_Lio_circe_derivation_ConfiguredDecoder$$anon$3__fp__F1(this);
  return $f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, fromProduct);
});
$c_Lio_circe_derivation_ConfiguredDecoder$$anon$3.prototype.decodeAccumulating__Lio_circe_HCursor__Lcats_data_Validated = (function(c) {
  var fromProduct = $p_Lio_circe_derivation_ConfiguredDecoder$$anon$3__fp__F1(this);
  return $f_Lio_circe_derivation_ConfiguredDecoder__decodeProductAccumulating__Lio_circe_HCursor__F1__Lcats_data_Validated(this, c, fromProduct);
});
var $d_Lio_circe_derivation_ConfiguredDecoder$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_circe_derivation_ConfiguredDecoder$$anon$3, "io.circe.derivation.ConfiguredDecoder$$anon$3", ({
  Lio_circe_derivation_ConfiguredDecoder$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1,
  Lio_circe_derivation_ConfiguredDecoder: 1,
  Lio_circe_derivation_SumOrProduct: 1
}));
export { $d_Lio_circe_derivation_ConfiguredDecoder$$anon$3 as $d_Lio_circe_derivation_ConfiguredDecoder$$anon$3 };
function $f_Lio_circe_derivation_ConfiguredEncoder__encodeElemAt__I__O__F1__T2($thiz, index, elem, transformName) {
  var this$1 = $thiz.elemLabels__sci_List();
  var _1 = transformName.apply__O__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_LinearSeqOps__apply__I__O(this$1, index));
  var this$2 = $thiz.elemEncoders__sci_List();
  var _2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_LinearSeqOps__apply__I__O(this$2, index).apply__O__Lio_circe_Json(elem);
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, _2);
}
export { $f_Lio_circe_derivation_ConfiguredEncoder__encodeElemAt__I__O__F1__T2 as $f_Lio_circe_derivation_ConfiguredEncoder__encodeElemAt__I__O__F1__T2 };
function $f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject($thiz, a) {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterable$();
  var n = a.productArity__I();
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((product$2) => ((index) => {
    var index$1 = (index | 0);
    return $f_Lio_circe_derivation_ConfiguredEncoder__encodeElemAt__I__O__F1__T2($thiz, index$1, product$2.productElement__I__O(index$1), $thiz.io$circe$derivation$ConfiguredEncoder$$conf__Lio_circe_derivation_Configuration().Lio_circe_derivation_Configuration__f_transformMemberNames);
  }))(a));
  var iterable = $f_sc_IterableFactory__tabulate__I__F1__O(this$2, n, f);
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_JsonObject$().fromIterable__sc_Iterable__Lio_circe_JsonObject(iterable);
}
export { $f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject as $f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject };
function $f_Lio_circe_derivation_ConfiguredEncoder__encodeSum__I__O__Lio_circe_JsonObject($thiz, index, a) {
  matchResult1: {
    var \u03b41$___1;
    var \u03b41$___2;
    var x1 = $f_Lio_circe_derivation_ConfiguredEncoder__encodeElemAt__I__O__F1__T2($thiz, index, a, $thiz.io$circe$derivation$ConfiguredEncoder$$conf__Lio_circe_derivation_Configuration().Lio_circe_derivation_Configuration__f_transformConstructorNames);
    if ((x1 !== null)) {
      var constructorName = x1._1__O();
      var json = x1._2__O();
      var \u03b41$___1 = constructorName;
      var \u03b41$___2 = json;
      break matchResult1;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1);
  }
  var constructorName$2 = \u03b41$___1;
  var json$2 = \u03b41$___2;
  var this$2 = json$2.asObject__s_Option();
  var jo = (this$2.isEmpty__Z() ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_JsonObject$().Lio_circe_JsonObject$__f_empty : this$2.get__O());
  matchResult2: {
    var elemIsSum;
    var this$3 = $thiz.elemEncoders__sci_List();
    var x4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_LinearSeqOps__apply__I__O(this$3, index);
    if (($is_Lio_circe_derivation_ConfiguredEncoder(x4) && $is_Lio_circe_derivation_SumOrProduct(x4))) {
      var elemIsSum = x4.isSum__Z();
      break matchResult2;
    }
    var this$4 = $thiz.io$circe$derivation$ConfiguredEncoder$$conf__Lio_circe_derivation_Configuration().Lio_circe_derivation_Configuration__f_discriminator;
    if ((!this$4.isEmpty__Z())) {
      var x0 = this$4.get__O();
      var elemIsSum = jo.contains__T__Z(x0);
    } else {
      var elemIsSum = false;
    }
  }
  if (elemIsSum) {
    return jo;
  } else {
    var x6 = $thiz.io$circe$derivation$ConfiguredEncoder$$conf__Lio_circe_derivation_Configuration().Lio_circe_derivation_Configuration__f_discriminator;
    if ((x6 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var discriminator = x6.s_Some__f_value;
      return jo.add__T__Lio_circe_Json__Lio_circe_JsonObject(discriminator, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_Json$().fromString__T__Lio_circe_Json(constructorName$2));
    }
    var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    if ((x === x6)) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lio_circe_JsonObject$().singleton__T__Lio_circe_Json__Lio_circe_JsonObject(constructorName$2, json$2);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x6);
  }
}
export { $f_Lio_circe_derivation_ConfiguredEncoder__encodeSum__I__O__Lio_circe_JsonObject as $f_Lio_circe_derivation_ConfiguredEncoder__encodeSum__I__O__Lio_circe_JsonObject };
function $is_Lio_circe_derivation_ConfiguredEncoder(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lio_circe_derivation_ConfiguredEncoder)));
}
export { $is_Lio_circe_derivation_ConfiguredEncoder as $is_Lio_circe_derivation_ConfiguredEncoder };
function $isArrayOf_Lio_circe_derivation_ConfiguredEncoder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_derivation_ConfiguredEncoder)));
}
export { $isArrayOf_Lio_circe_derivation_ConfiguredEncoder as $isArrayOf_Lio_circe_derivation_ConfiguredEncoder };
/** @constructor */
function $c_Lio_scalaland_chimney_partial_ErrorMessage$StringMessage(message) {
  this.Lio_scalaland_chimney_partial_ErrorMessage$StringMessage__f_message = null;
  this.Lio_scalaland_chimney_partial_ErrorMessage$StringMessage__f_message = message;
}
export { $c_Lio_scalaland_chimney_partial_ErrorMessage$StringMessage as $c_Lio_scalaland_chimney_partial_ErrorMessage$StringMessage };
$c_Lio_scalaland_chimney_partial_ErrorMessage$StringMessage.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_scalaland_chimney_partial_ErrorMessage$StringMessage.prototype.constructor = $c_Lio_scalaland_chimney_partial_ErrorMessage$StringMessage;
/** @constructor */
function $h_Lio_scalaland_chimney_partial_ErrorMessage$StringMessage() {
}
export { $h_Lio_scalaland_chimney_partial_ErrorMessage$StringMessage as $h_Lio_scalaland_chimney_partial_ErrorMessage$StringMessage };
$h_Lio_scalaland_chimney_partial_ErrorMessage$StringMessage.prototype = $c_Lio_scalaland_chimney_partial_ErrorMessage$StringMessage.prototype;
$c_Lio_scalaland_chimney_partial_ErrorMessage$StringMessage.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lio_scalaland_chimney_partial_ErrorMessage$StringMessage.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lio_scalaland_chimney_partial_ErrorMessage$StringMessage.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_scalaland_chimney_partial_ErrorMessage$StringMessage) && (this.Lio_scalaland_chimney_partial_ErrorMessage$StringMessage__f_message === x$0.Lio_scalaland_chimney_partial_ErrorMessage$StringMessage__f_message)));
});
$c_Lio_scalaland_chimney_partial_ErrorMessage$StringMessage.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lio_scalaland_chimney_partial_ErrorMessage$StringMessage.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_scalaland_chimney_partial_ErrorMessage$StringMessage.prototype.productPrefix__T = (function() {
  return "StringMessage";
});
$c_Lio_scalaland_chimney_partial_ErrorMessage$StringMessage.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_scalaland_chimney_partial_ErrorMessage$StringMessage__f_message;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_scalaland_chimney_partial_ErrorMessage$StringMessage.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "message";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_scalaland_chimney_partial_ErrorMessage$StringMessage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_scalaland_chimney_partial_ErrorMessage$StringMessage)));
}
export { $isArrayOf_Lio_scalaland_chimney_partial_ErrorMessage$StringMessage as $isArrayOf_Lio_scalaland_chimney_partial_ErrorMessage$StringMessage };
var $d_Lio_scalaland_chimney_partial_ErrorMessage$StringMessage = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_scalaland_chimney_partial_ErrorMessage$StringMessage, "io.scalaland.chimney.partial.ErrorMessage$StringMessage", ({
  Lio_scalaland_chimney_partial_ErrorMessage$StringMessage: 1,
  Lio_scalaland_chimney_partial_ErrorMessage: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_scalaland_chimney_partial_ErrorMessage$StringMessage as $d_Lio_scalaland_chimney_partial_ErrorMessage$StringMessage };
/** @constructor */
function $c_Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage(throwable) {
  this.Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage__f_throwable = null;
  this.Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage__f_throwable = throwable;
}
export { $c_Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage as $c_Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage };
$c_Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage.prototype.constructor = $c_Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage;
/** @constructor */
function $h_Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage() {
}
export { $h_Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage as $h_Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage };
$h_Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage.prototype = $c_Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage.prototype;
$c_Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage)) {
    var x = this.Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage__f_throwable;
    var x$2 = x$0.Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage__f_throwable;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage.prototype.productPrefix__T = (function() {
  return "ThrowableMessage";
});
$c_Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage__f_throwable;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "throwable";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage)));
}
export { $isArrayOf_Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage as $isArrayOf_Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage };
var $d_Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage, "io.scalaland.chimney.partial.ErrorMessage$ThrowableMessage", ({
  Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage: 1,
  Lio_scalaland_chimney_partial_ErrorMessage: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage as $d_Lio_scalaland_chimney_partial_ErrorMessage$ThrowableMessage };
/** @constructor */
function $c_Lio_scalaland_chimney_partial_PathElement$Accessor(name) {
  this.Lio_scalaland_chimney_partial_PathElement$Accessor__f_name = null;
  this.Lio_scalaland_chimney_partial_PathElement$Accessor__f_name = name;
}
export { $c_Lio_scalaland_chimney_partial_PathElement$Accessor as $c_Lio_scalaland_chimney_partial_PathElement$Accessor };
$c_Lio_scalaland_chimney_partial_PathElement$Accessor.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_scalaland_chimney_partial_PathElement$Accessor.prototype.constructor = $c_Lio_scalaland_chimney_partial_PathElement$Accessor;
/** @constructor */
function $h_Lio_scalaland_chimney_partial_PathElement$Accessor() {
}
export { $h_Lio_scalaland_chimney_partial_PathElement$Accessor as $h_Lio_scalaland_chimney_partial_PathElement$Accessor };
$h_Lio_scalaland_chimney_partial_PathElement$Accessor.prototype = $c_Lio_scalaland_chimney_partial_PathElement$Accessor.prototype;
$c_Lio_scalaland_chimney_partial_PathElement$Accessor.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lio_scalaland_chimney_partial_PathElement$Accessor.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lio_scalaland_chimney_partial_PathElement$Accessor.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_scalaland_chimney_partial_PathElement$Accessor) && (this.Lio_scalaland_chimney_partial_PathElement$Accessor__f_name === x$0.Lio_scalaland_chimney_partial_PathElement$Accessor__f_name)));
});
$c_Lio_scalaland_chimney_partial_PathElement$Accessor.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lio_scalaland_chimney_partial_PathElement$Accessor.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_scalaland_chimney_partial_PathElement$Accessor.prototype.productPrefix__T = (function() {
  return "Accessor";
});
$c_Lio_scalaland_chimney_partial_PathElement$Accessor.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_scalaland_chimney_partial_PathElement$Accessor__f_name;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_scalaland_chimney_partial_PathElement$Accessor.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "name";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_scalaland_chimney_partial_PathElement$Accessor.prototype.asString__T = (function() {
  return this.Lio_scalaland_chimney_partial_PathElement$Accessor__f_name;
});
function $isArrayOf_Lio_scalaland_chimney_partial_PathElement$Accessor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_scalaland_chimney_partial_PathElement$Accessor)));
}
export { $isArrayOf_Lio_scalaland_chimney_partial_PathElement$Accessor as $isArrayOf_Lio_scalaland_chimney_partial_PathElement$Accessor };
var $d_Lio_scalaland_chimney_partial_PathElement$Accessor = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_scalaland_chimney_partial_PathElement$Accessor, "io.scalaland.chimney.partial.PathElement$Accessor", ({
  Lio_scalaland_chimney_partial_PathElement$Accessor: 1,
  Lio_scalaland_chimney_partial_PathElement: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_scalaland_chimney_partial_PathElement$Accessor as $d_Lio_scalaland_chimney_partial_PathElement$Accessor };
function $isArrayOf_Lio_scalaland_chimney_partial_PathElement$Computed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_scalaland_chimney_partial_PathElement$Computed)));
}
export { $isArrayOf_Lio_scalaland_chimney_partial_PathElement$Computed as $isArrayOf_Lio_scalaland_chimney_partial_PathElement$Computed };
function $isArrayOf_Lio_scalaland_chimney_partial_PathElement$Const(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_scalaland_chimney_partial_PathElement$Const)));
}
export { $isArrayOf_Lio_scalaland_chimney_partial_PathElement$Const as $isArrayOf_Lio_scalaland_chimney_partial_PathElement$Const };
/** @constructor */
function $c_Lio_scalaland_chimney_partial_PathElement$Index(index) {
  this.Lio_scalaland_chimney_partial_PathElement$Index__f_index = 0;
  this.Lio_scalaland_chimney_partial_PathElement$Index__f_index = index;
}
export { $c_Lio_scalaland_chimney_partial_PathElement$Index as $c_Lio_scalaland_chimney_partial_PathElement$Index };
$c_Lio_scalaland_chimney_partial_PathElement$Index.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_scalaland_chimney_partial_PathElement$Index.prototype.constructor = $c_Lio_scalaland_chimney_partial_PathElement$Index;
/** @constructor */
function $h_Lio_scalaland_chimney_partial_PathElement$Index() {
}
export { $h_Lio_scalaland_chimney_partial_PathElement$Index as $h_Lio_scalaland_chimney_partial_PathElement$Index };
$h_Lio_scalaland_chimney_partial_PathElement$Index.prototype = $c_Lio_scalaland_chimney_partial_PathElement$Index.prototype;
$c_Lio_scalaland_chimney_partial_PathElement$Index.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lio_scalaland_chimney_partial_PathElement$Index.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I("Index");
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lio_scalaland_chimney_partial_PathElement$Index__f_index;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1);
});
$c_Lio_scalaland_chimney_partial_PathElement$Index.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_scalaland_chimney_partial_PathElement$Index) && (this.Lio_scalaland_chimney_partial_PathElement$Index__f_index === x$0.Lio_scalaland_chimney_partial_PathElement$Index__f_index)));
});
$c_Lio_scalaland_chimney_partial_PathElement$Index.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lio_scalaland_chimney_partial_PathElement$Index.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_scalaland_chimney_partial_PathElement$Index.prototype.productPrefix__T = (function() {
  return "Index";
});
$c_Lio_scalaland_chimney_partial_PathElement$Index.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_scalaland_chimney_partial_PathElement$Index__f_index;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_scalaland_chimney_partial_PathElement$Index.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "index";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_scalaland_chimney_partial_PathElement$Index.prototype.asString__T = (function() {
  return (("(" + this.Lio_scalaland_chimney_partial_PathElement$Index__f_index) + ")");
});
function $isArrayOf_Lio_scalaland_chimney_partial_PathElement$Index(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_scalaland_chimney_partial_PathElement$Index)));
}
export { $isArrayOf_Lio_scalaland_chimney_partial_PathElement$Index as $isArrayOf_Lio_scalaland_chimney_partial_PathElement$Index };
var $d_Lio_scalaland_chimney_partial_PathElement$Index = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_scalaland_chimney_partial_PathElement$Index, "io.scalaland.chimney.partial.PathElement$Index", ({
  Lio_scalaland_chimney_partial_PathElement$Index: 1,
  Lio_scalaland_chimney_partial_PathElement: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_scalaland_chimney_partial_PathElement$Index as $d_Lio_scalaland_chimney_partial_PathElement$Index };
function $isArrayOf_Lio_scalaland_chimney_partial_PathElement$MapKey(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_scalaland_chimney_partial_PathElement$MapKey)));
}
export { $isArrayOf_Lio_scalaland_chimney_partial_PathElement$MapKey as $isArrayOf_Lio_scalaland_chimney_partial_PathElement$MapKey };
function $isArrayOf_Lio_scalaland_chimney_partial_PathElement$MapValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_scalaland_chimney_partial_PathElement$MapValue)));
}
export { $isArrayOf_Lio_scalaland_chimney_partial_PathElement$MapValue as $isArrayOf_Lio_scalaland_chimney_partial_PathElement$MapValue };
/** @constructor */
function $c_Lio_scalaland_chimney_partial_Result$Errors(errors) {
  this.Lio_scalaland_chimney_partial_Result$Errors__f_errors = null;
  this.Lio_scalaland_chimney_partial_Result$Errors__f_errors = errors;
}
export { $c_Lio_scalaland_chimney_partial_Result$Errors as $c_Lio_scalaland_chimney_partial_Result$Errors };
$c_Lio_scalaland_chimney_partial_Result$Errors.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_scalaland_chimney_partial_Result$Errors.prototype.constructor = $c_Lio_scalaland_chimney_partial_Result$Errors;
/** @constructor */
function $h_Lio_scalaland_chimney_partial_Result$Errors() {
}
export { $h_Lio_scalaland_chimney_partial_Result$Errors as $h_Lio_scalaland_chimney_partial_Result$Errors };
$h_Lio_scalaland_chimney_partial_Result$Errors.prototype = $c_Lio_scalaland_chimney_partial_Result$Errors.prototype;
$c_Lio_scalaland_chimney_partial_Result$Errors.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lio_scalaland_chimney_partial_Result$Errors.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lio_scalaland_chimney_partial_Result$Errors.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_scalaland_chimney_partial_Result$Errors)) {
    var x = this.Lio_scalaland_chimney_partial_Result$Errors__f_errors;
    var x$2 = x$0.Lio_scalaland_chimney_partial_Result$Errors__f_errors;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lio_scalaland_chimney_partial_Result$Errors.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lio_scalaland_chimney_partial_Result$Errors.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_scalaland_chimney_partial_Result$Errors.prototype.productPrefix__T = (function() {
  return "Errors";
});
$c_Lio_scalaland_chimney_partial_Result$Errors.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_scalaland_chimney_partial_Result$Errors__f_errors;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_scalaland_chimney_partial_Result$Errors.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "errors";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_scalaland_chimney_partial_Result$Errors.prototype.prependPath__Lio_scalaland_chimney_partial_PathElement__Lio_scalaland_chimney_partial_Result$Errors = (function(pathElement) {
  var this$1 = this.Lio_scalaland_chimney_partial_Result$Errors__f_errors;
  var errors = new $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath(this$1, pathElement);
  return new $c_Lio_scalaland_chimney_partial_Result$Errors(errors);
});
$c_Lio_scalaland_chimney_partial_Result$Errors.prototype.unsealPath__Lio_scalaland_chimney_partial_Result$Errors = (function() {
  var errors = this.Lio_scalaland_chimney_partial_Result$Errors__f_errors.unsealPath__Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain();
  return new $c_Lio_scalaland_chimney_partial_Result$Errors(errors);
});
$c_Lio_scalaland_chimney_partial_Result$Errors.prototype.asErrorPathMessages__sc_Iterable = (function() {
  var this$1 = this.Lio_scalaland_chimney_partial_Result$Errors__f_errors;
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => _$1.asErrorPathMessage__T2()));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOps__map__F1__O(this$1, f);
});
function $isArrayOf_Lio_scalaland_chimney_partial_Result$Errors(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_scalaland_chimney_partial_Result$Errors)));
}
export { $isArrayOf_Lio_scalaland_chimney_partial_Result$Errors as $isArrayOf_Lio_scalaland_chimney_partial_Result$Errors };
var $d_Lio_scalaland_chimney_partial_Result$Errors = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_scalaland_chimney_partial_Result$Errors, "io.scalaland.chimney.partial.Result$Errors", ({
  Lio_scalaland_chimney_partial_Result$Errors: 1,
  Lio_scalaland_chimney_partial_Result: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_scalaland_chimney_partial_Result$Errors as $d_Lio_scalaland_chimney_partial_Result$Errors };
/** @constructor */
function $c_Lio_scalaland_chimney_partial_Result$Value(value) {
  this.Lio_scalaland_chimney_partial_Result$Value__f_value = null;
  this.Lio_scalaland_chimney_partial_Result$Value__f_value = value;
}
export { $c_Lio_scalaland_chimney_partial_Result$Value as $c_Lio_scalaland_chimney_partial_Result$Value };
$c_Lio_scalaland_chimney_partial_Result$Value.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_scalaland_chimney_partial_Result$Value.prototype.constructor = $c_Lio_scalaland_chimney_partial_Result$Value;
/** @constructor */
function $h_Lio_scalaland_chimney_partial_Result$Value() {
}
export { $h_Lio_scalaland_chimney_partial_Result$Value as $h_Lio_scalaland_chimney_partial_Result$Value };
$h_Lio_scalaland_chimney_partial_Result$Value.prototype = $c_Lio_scalaland_chimney_partial_Result$Value.prototype;
$c_Lio_scalaland_chimney_partial_Result$Value.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lio_scalaland_chimney_partial_Result$Value.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lio_scalaland_chimney_partial_Result$Value.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_scalaland_chimney_partial_Result$Value)) {
    var x = this.Lio_scalaland_chimney_partial_Result$Value__f_value;
    var y = x$0.Lio_scalaland_chimney_partial_Result$Value__f_value;
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lio_scalaland_chimney_partial_Result$Value.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lio_scalaland_chimney_partial_Result$Value.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_scalaland_chimney_partial_Result$Value.prototype.productPrefix__T = (function() {
  return "Value";
});
$c_Lio_scalaland_chimney_partial_Result$Value.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_scalaland_chimney_partial_Result$Value__f_value;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_scalaland_chimney_partial_Result$Value.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_scalaland_chimney_partial_Result$Value(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_scalaland_chimney_partial_Result$Value)));
}
export { $isArrayOf_Lio_scalaland_chimney_partial_Result$Value as $isArrayOf_Lio_scalaland_chimney_partial_Result$Value };
var $d_Lio_scalaland_chimney_partial_Result$Value = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_scalaland_chimney_partial_Result$Value, "io.scalaland.chimney.partial.Result$Value", ({
  Lio_scalaland_chimney_partial_Result$Value: 1,
  Lio_scalaland_chimney_partial_Result: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_scalaland_chimney_partial_Result$Value as $d_Lio_scalaland_chimney_partial_Result$Value };
function $p_Ljava_io_ByteArrayOutputStream__growBuf__I__V($thiz, minIncrement) {
  var a = (($thiz.Ljava_io_ByteArrayOutputStream__f_count + minIncrement) | 0);
  var b = ($thiz.Ljava_io_ByteArrayOutputStream__f_buf.u.length << 1);
  var newSize = ((a > b) ? a : b);
  var newBuf = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_B(newSize);
  var x0 = $thiz.Ljava_io_ByteArrayOutputStream__f_buf;
  var x4 = $thiz.Ljava_io_ByteArrayOutputStream__f_count;
  x0.copyTo(0, newBuf, 0, x4);
  $thiz.Ljava_io_ByteArrayOutputStream__f_buf = newBuf;
}
export { $p_Ljava_io_ByteArrayOutputStream__growBuf__I__V as $p_Ljava_io_ByteArrayOutputStream__growBuf__I__V };
function $ct_Ljava_io_ByteArrayOutputStream__I__($thiz, initBufSize) {
  $thiz.Ljava_io_ByteArrayOutputStream__f_buf = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_B(initBufSize);
  $thiz.Ljava_io_ByteArrayOutputStream__f_count = 0;
  return $thiz;
}
export { $ct_Ljava_io_ByteArrayOutputStream__I__ as $ct_Ljava_io_ByteArrayOutputStream__I__ };
function $ct_Ljava_io_ByteArrayOutputStream__($thiz) {
  $ct_Ljava_io_ByteArrayOutputStream__I__($thiz, 32);
  return $thiz;
}
export { $ct_Ljava_io_ByteArrayOutputStream__ as $ct_Ljava_io_ByteArrayOutputStream__ };
/** @constructor */
function $c_Ljava_io_ByteArrayOutputStream() {
  this.Ljava_io_ByteArrayOutputStream__f_buf = null;
  this.Ljava_io_ByteArrayOutputStream__f_count = 0;
}
export { $c_Ljava_io_ByteArrayOutputStream as $c_Ljava_io_ByteArrayOutputStream };
$c_Ljava_io_ByteArrayOutputStream.prototype = new $h_Ljava_io_OutputStream();
$c_Ljava_io_ByteArrayOutputStream.prototype.constructor = $c_Ljava_io_ByteArrayOutputStream;
/** @constructor */
function $h_Ljava_io_ByteArrayOutputStream() {
}
export { $h_Ljava_io_ByteArrayOutputStream as $h_Ljava_io_ByteArrayOutputStream };
$h_Ljava_io_ByteArrayOutputStream.prototype = $c_Ljava_io_ByteArrayOutputStream.prototype;
$c_Ljava_io_ByteArrayOutputStream.prototype.write__I__V = (function(b) {
  if ((this.Ljava_io_ByteArrayOutputStream__f_count >= this.Ljava_io_ByteArrayOutputStream__f_buf.u.length)) {
    $p_Ljava_io_ByteArrayOutputStream__growBuf__I__V(this, 1);
  }
  this.Ljava_io_ByteArrayOutputStream__f_buf.u[this.Ljava_io_ByteArrayOutputStream__f_count] = ((b << 24) >> 24);
  this.Ljava_io_ByteArrayOutputStream__f_count = ((1 + this.Ljava_io_ByteArrayOutputStream__f_count) | 0);
});
$c_Ljava_io_ByteArrayOutputStream.prototype.write__AB__I__I__V = (function(b, off, len) {
  if ((((off < 0) || (len < 0)) || (len > ((b.u.length - off) | 0)))) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException());
  }
  if ((((this.Ljava_io_ByteArrayOutputStream__f_count + len) | 0) > this.Ljava_io_ByteArrayOutputStream__f_buf.u.length)) {
    $p_Ljava_io_ByteArrayOutputStream__growBuf__I__V(this, len);
  }
  var x2 = this.Ljava_io_ByteArrayOutputStream__f_buf;
  var x3 = this.Ljava_io_ByteArrayOutputStream__f_count;
  b.copyTo(off, x2, x3, len);
  this.Ljava_io_ByteArrayOutputStream__f_count = ((this.Ljava_io_ByteArrayOutputStream__f_count + len) | 0);
});
$c_Ljava_io_ByteArrayOutputStream.prototype.toByteArray__AB = (function() {
  var res = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_B(this.Ljava_io_ByteArrayOutputStream__f_count);
  var x0 = this.Ljava_io_ByteArrayOutputStream__f_buf;
  var x4 = this.Ljava_io_ByteArrayOutputStream__f_count;
  x0.copyTo(0, res, 0, x4);
  return res;
});
$c_Ljava_io_ByteArrayOutputStream.prototype.toString__T = (function() {
  var bytes = this.Ljava_io_ByteArrayOutputStream__f_buf;
  var length = this.Ljava_io_ByteArrayOutputStream__f_count;
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_String$();
  return this$1.new__AB__I__I__Ljava_nio_charset_Charset__T(bytes, 0, length, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_nio_charset_UTF\uff3f8$());
});
var $d_Ljava_io_ByteArrayOutputStream = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Ljava_io_ByteArrayOutputStream, "java.io.ByteArrayOutputStream", ({
  Ljava_io_ByteArrayOutputStream: 1,
  Ljava_io_OutputStream: 1,
  Ljava_io_Closeable: 1,
  jl_AutoCloseable: 1,
  Ljava_io_Flushable: 1
}));
export { $d_Ljava_io_ByteArrayOutputStream as $d_Ljava_io_ByteArrayOutputStream };
function $ct_Ljava_io_FilterOutputStream__Ljava_io_OutputStream__($thiz, out) {
  return $thiz;
}
export { $ct_Ljava_io_FilterOutputStream__Ljava_io_OutputStream__ as $ct_Ljava_io_FilterOutputStream__Ljava_io_OutputStream__ };
/** @constructor */
function $c_Ljava_io_FilterOutputStream() {
}
export { $c_Ljava_io_FilterOutputStream as $c_Ljava_io_FilterOutputStream };
$c_Ljava_io_FilterOutputStream.prototype = new $h_Ljava_io_OutputStream();
$c_Ljava_io_FilterOutputStream.prototype.constructor = $c_Ljava_io_FilterOutputStream;
/** @constructor */
function $h_Ljava_io_FilterOutputStream() {
}
export { $h_Ljava_io_FilterOutputStream as $h_Ljava_io_FilterOutputStream };
$h_Ljava_io_FilterOutputStream.prototype = $c_Ljava_io_FilterOutputStream.prototype;
/** @constructor */
function $c_jl_JSConsoleBasedPrintStream$DummyOutputStream() {
}
export { $c_jl_JSConsoleBasedPrintStream$DummyOutputStream as $c_jl_JSConsoleBasedPrintStream$DummyOutputStream };
$c_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype = new $h_Ljava_io_OutputStream();
$c_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype.constructor = $c_jl_JSConsoleBasedPrintStream$DummyOutputStream;
/** @constructor */
function $h_jl_JSConsoleBasedPrintStream$DummyOutputStream() {
}
export { $h_jl_JSConsoleBasedPrintStream$DummyOutputStream as $h_jl_JSConsoleBasedPrintStream$DummyOutputStream };
$h_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype = $c_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype;
$c_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype.write__I__V = (function(c) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_AssertionError__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_AssertionError(), "Should not get in JSConsoleBasedPrintStream.DummyOutputStream");
});
var $d_jl_JSConsoleBasedPrintStream$DummyOutputStream = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_jl_JSConsoleBasedPrintStream$DummyOutputStream, "java.lang.JSConsoleBasedPrintStream$DummyOutputStream", ({
  jl_JSConsoleBasedPrintStream$DummyOutputStream: 1,
  Ljava_io_OutputStream: 1,
  Ljava_io_Closeable: 1,
  jl_AutoCloseable: 1,
  Ljava_io_Flushable: 1
}));
export { $d_jl_JSConsoleBasedPrintStream$DummyOutputStream as $d_jl_JSConsoleBasedPrintStream$DummyOutputStream };
class $c_jl_StackOverflowError extends $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_VirtualMachineError {
  constructor(s) {
    super();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true);
  }
}
export { $c_jl_StackOverflowError as $c_jl_StackOverflowError };
var $d_jl_StackOverflowError = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_jl_StackOverflowError, "java.lang.StackOverflowError", ({
  jl_StackOverflowError: 1,
  jl_VirtualMachineError: 1,
  jl_Error: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_jl_StackOverflowError as $d_jl_StackOverflowError };
function $isArrayOf_Ljava_net_MalformedURLException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_net_MalformedURLException)));
}
export { $isArrayOf_Ljava_net_MalformedURLException as $isArrayOf_Ljava_net_MalformedURLException };
function $isArrayOf_ju_concurrent_RejectedExecutionException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_concurrent_RejectedExecutionException)));
}
export { $isArrayOf_ju_concurrent_RejectedExecutionException as $isArrayOf_ju_concurrent_RejectedExecutionException };
/** @constructor */
function $c_Lmonocle_syntax_AppliedPOptional$$anon$1(_value$1, _optic$1, outer) {
  this.Lmonocle_syntax_AppliedPOptional$$anon$1__f_value = null;
  this.Lmonocle_syntax_AppliedPOptional$$anon$1__f_optic = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lmonocle_syntax_AppliedPOptional$$anon$1__f_value = _value$1;
  this.Lmonocle_syntax_AppliedPOptional$$anon$1__f_optic = _optic$1;
}
export { $c_Lmonocle_syntax_AppliedPOptional$$anon$1 as $c_Lmonocle_syntax_AppliedPOptional$$anon$1 };
$c_Lmonocle_syntax_AppliedPOptional$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lmonocle_syntax_AppliedPOptional$$anon$1.prototype.constructor = $c_Lmonocle_syntax_AppliedPOptional$$anon$1;
/** @constructor */
function $h_Lmonocle_syntax_AppliedPOptional$$anon$1() {
}
export { $h_Lmonocle_syntax_AppliedPOptional$$anon$1 as $h_Lmonocle_syntax_AppliedPOptional$$anon$1 };
$h_Lmonocle_syntax_AppliedPOptional$$anon$1.prototype = $c_Lmonocle_syntax_AppliedPOptional$$anon$1.prototype;
$c_Lmonocle_syntax_AppliedPOptional$$anon$1.prototype.value__O = (function() {
  return this.Lmonocle_syntax_AppliedPOptional$$anon$1__f_value;
});
$c_Lmonocle_syntax_AppliedPOptional$$anon$1.prototype.optic__Lmonocle_PSetter = (function() {
  return this.Lmonocle_syntax_AppliedPOptional$$anon$1__f_optic;
});
var $d_Lmonocle_syntax_AppliedPOptional$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lmonocle_syntax_AppliedPOptional$$anon$1, "monocle.syntax.AppliedPOptional$$anon$1", ({
  Lmonocle_syntax_AppliedPOptional$$anon$1: 1,
  Lmonocle_syntax_AppliedPSetter: 1,
  Lmonocle_syntax_AppliedFold: 1,
  Lmonocle_syntax_AppliedPTraversal: 1,
  Lmonocle_syntax_AppliedPOptional: 1
}));
export { $d_Lmonocle_syntax_AppliedPOptional$$anon$1 as $d_Lmonocle_syntax_AppliedPOptional$$anon$1 };
function $ct_Lpprint_PPrinter__I__I__I__Z__Z__Lfansi_Attrs__Lfansi_Attrs__s_PartialFunction__($thiz, defaultWidth, defaultHeight, defaultIndent, defaultEscapeUnicode, defaultShowFieldNames, colorLiteral, colorApplyPrefix, additionalHandlers) {
  $thiz.Lpprint_PPrinter__f_defaultWidth = defaultWidth;
  $thiz.Lpprint_PPrinter__f_defaultHeight = defaultHeight;
  $thiz.Lpprint_PPrinter__f_defaultIndent = defaultIndent;
  $thiz.Lpprint_PPrinter__f_defaultEscapeUnicode = defaultEscapeUnicode;
  $thiz.Lpprint_PPrinter__f_defaultShowFieldNames = defaultShowFieldNames;
  $thiz.Lpprint_PPrinter__f_colorLiteral = colorLiteral;
  $thiz.Lpprint_PPrinter__f_colorApplyPrefix = colorApplyPrefix;
  $thiz.Lpprint_PPrinter__f_additionalHandlers = additionalHandlers;
  $ct_Lpprint_Walker__($thiz);
  return $thiz;
}
export { $ct_Lpprint_PPrinter__I__I__I__Z__Z__Lfansi_Attrs__Lfansi_Attrs__s_PartialFunction__ as $ct_Lpprint_PPrinter__I__I__I__Z__Z__Lfansi_Attrs__Lfansi_Attrs__s_PartialFunction__ };
/** @constructor */
function $c_Lpprint_PPrinter() {
  this.Lpprint_Walker__f_tuplePrefix = null;
  this.Lpprint_PPrinter__f_defaultWidth = 0;
  this.Lpprint_PPrinter__f_defaultHeight = 0;
  this.Lpprint_PPrinter__f_defaultIndent = 0;
  this.Lpprint_PPrinter__f_defaultEscapeUnicode = false;
  this.Lpprint_PPrinter__f_defaultShowFieldNames = false;
  this.Lpprint_PPrinter__f_colorLiteral = null;
  this.Lpprint_PPrinter__f_colorApplyPrefix = null;
  this.Lpprint_PPrinter__f_additionalHandlers = null;
}
export { $c_Lpprint_PPrinter as $c_Lpprint_PPrinter };
$c_Lpprint_PPrinter.prototype = new $h_Lpprint_Walker();
$c_Lpprint_PPrinter.prototype.constructor = $c_Lpprint_PPrinter;
/** @constructor */
function $h_Lpprint_PPrinter() {
}
export { $h_Lpprint_PPrinter as $h_Lpprint_PPrinter };
$h_Lpprint_PPrinter.prototype = $c_Lpprint_PPrinter.prototype;
$c_Lpprint_PPrinter.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lpprint_PPrinter.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I("PPrinter");
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lpprint_PPrinter__f_defaultWidth;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Lpprint_PPrinter__f_defaultHeight;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = this.Lpprint_PPrinter__f_defaultIndent;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var data$4 = (this.Lpprint_PPrinter__f_defaultEscapeUnicode ? 1231 : 1237);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var data$5 = (this.Lpprint_PPrinter__f_defaultShowFieldNames ? 1231 : 1237);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var x = this.Lpprint_PPrinter__f_colorLiteral;
  var data$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var x$1 = this.Lpprint_PPrinter__f_colorApplyPrefix;
  var data$7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$1);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  var x$2 = this.Lpprint_PPrinter__f_additionalHandlers;
  var data$8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$2);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$8, data$8);
  var hash$9 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$9, 8);
});
$c_Lpprint_PPrinter.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpprint_PPrinter)) {
    if ((((((this.Lpprint_PPrinter__f_defaultWidth === x$0.Lpprint_PPrinter__f_defaultWidth) && (this.Lpprint_PPrinter__f_defaultHeight === x$0.Lpprint_PPrinter__f_defaultHeight)) && (this.Lpprint_PPrinter__f_defaultIndent === x$0.Lpprint_PPrinter__f_defaultIndent)) && (this.Lpprint_PPrinter__f_defaultEscapeUnicode === x$0.Lpprint_PPrinter__f_defaultEscapeUnicode)) && (this.Lpprint_PPrinter__f_defaultShowFieldNames === x$0.Lpprint_PPrinter__f_defaultShowFieldNames))) {
      var x = this.Lpprint_PPrinter__f_colorLiteral;
      var x$2 = x$0.Lpprint_PPrinter__f_colorLiteral;
      var $x_2 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Lpprint_PPrinter__f_colorApplyPrefix;
      var x$4 = x$0.Lpprint_PPrinter__f_colorApplyPrefix;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Lpprint_PPrinter__f_additionalHandlers;
      var x$6 = x$0.Lpprint_PPrinter__f_additionalHandlers;
      return ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lpprint_PPrinter.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lpprint_PPrinter.prototype.productArity__I = (function() {
  return 8;
});
$c_Lpprint_PPrinter.prototype.productPrefix__T = (function() {
  return "PPrinter";
});
$c_Lpprint_PPrinter.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lpprint_PPrinter__f_defaultWidth;
      break;
    }
    case 1: {
      return this.Lpprint_PPrinter__f_defaultHeight;
      break;
    }
    case 2: {
      return this.Lpprint_PPrinter__f_defaultIndent;
      break;
    }
    case 3: {
      return this.Lpprint_PPrinter__f_defaultEscapeUnicode;
      break;
    }
    case 4: {
      return this.Lpprint_PPrinter__f_defaultShowFieldNames;
      break;
    }
    case 5: {
      return this.Lpprint_PPrinter__f_colorLiteral;
      break;
    }
    case 6: {
      return this.Lpprint_PPrinter__f_colorApplyPrefix;
      break;
    }
    case 7: {
      return this.Lpprint_PPrinter__f_additionalHandlers;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lpprint_PPrinter.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "defaultWidth";
      break;
    }
    case 1: {
      return "defaultHeight";
      break;
    }
    case 2: {
      return "defaultIndent";
      break;
    }
    case 3: {
      return "defaultEscapeUnicode";
      break;
    }
    case 4: {
      return "defaultShowFieldNames";
      break;
    }
    case 5: {
      return "colorLiteral";
      break;
    }
    case 6: {
      return "colorApplyPrefix";
      break;
    }
    case 7: {
      return "additionalHandlers";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lpprint_PPrinter.prototype.apply__O__I__I__I__I__Z__Z__Lfansi_Str = (function(x, width, height, indent, initialOffset, escapeUnicode, showFieldNames) {
  var $x_1 = $m_Lfansi_Str$();
  var this$1 = this.tokenize__O__I__I__I__I__Z__Z__sc_Iterator(x, width, height, indent, initialOffset, escapeUnicode, showFieldNames);
  return $x_1.join__sc_Iterable__Lfansi_Str__Lfansi_Str($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$1), ($m_Lfansi_Str$(), $m_Lfansi_Str$().apply__jl_CharSequence__Lfansi_ErrorMode__Lfansi_Str("", ($m_Lfansi_Str$(), $m_Lfansi_ErrorMode$Sanitize$()))));
});
$c_Lpprint_PPrinter.prototype.tokenize__O__I__I__I__I__Z__Z__sc_Iterator = (function(x, width, height, indent, initialOffset, escapeUnicode, showFieldNames) {
  var tree = this.treeify__O__Z__Z__Lpprint_Tree(x, escapeUnicode, showFieldNames);
  var renderer = new $c_Lpprint_Renderer(width, this.Lpprint_PPrinter__f_colorApplyPrefix, this.Lpprint_PPrinter__f_colorLiteral, indent);
  var rendered = renderer.rec__Lpprint_Tree__I__I__Lpprint_Result(tree, initialOffset, 0).Lpprint_Result__f_iter;
  var truncated = new $c_Lpprint_Truncated(rendered, width, height, "...");
  return truncated;
});
function $isArrayOf_Lpprint_PPrinter(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lpprint_PPrinter)));
}
export { $isArrayOf_Lpprint_PPrinter as $isArrayOf_Lpprint_PPrinter };
/** @constructor */
function $c_Lpprint_Tree$Apply(prefix, body) {
  this.Lpprint_Tree$Apply__f_prefix = null;
  this.Lpprint_Tree$Apply__f_body = null;
  this.Lpprint_Tree$Apply__f_prefix = prefix;
  this.Lpprint_Tree$Apply__f_body = body;
}
export { $c_Lpprint_Tree$Apply as $c_Lpprint_Tree$Apply };
$c_Lpprint_Tree$Apply.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lpprint_Tree$Apply.prototype.constructor = $c_Lpprint_Tree$Apply;
/** @constructor */
function $h_Lpprint_Tree$Apply() {
}
export { $h_Lpprint_Tree$Apply as $h_Lpprint_Tree$Apply };
$h_Lpprint_Tree$Apply.prototype = $c_Lpprint_Tree$Apply.prototype;
$c_Lpprint_Tree$Apply.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lpprint_Tree$Apply.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lpprint_Tree$Apply.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpprint_Tree$Apply)) {
    if ((this.Lpprint_Tree$Apply__f_prefix === x$0.Lpprint_Tree$Apply__f_prefix)) {
      var x = this.Lpprint_Tree$Apply__f_body;
      var x$2 = x$0.Lpprint_Tree$Apply__f_body;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lpprint_Tree$Apply.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lpprint_Tree$Apply.prototype.productArity__I = (function() {
  return 2;
});
$c_Lpprint_Tree$Apply.prototype.productPrefix__T = (function() {
  return "Apply";
});
$c_Lpprint_Tree$Apply.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lpprint_Tree$Apply__f_prefix;
  }
  if ((n === 1)) {
    return this.Lpprint_Tree$Apply__f_body;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lpprint_Tree$Apply.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "prefix";
  }
  if ((n === 1)) {
    return "body";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpprint_Tree$Apply(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lpprint_Tree$Apply)));
}
export { $isArrayOf_Lpprint_Tree$Apply as $isArrayOf_Lpprint_Tree$Apply };
var $d_Lpprint_Tree$Apply = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lpprint_Tree$Apply, "pprint.Tree$Apply", ({
  Lpprint_Tree$Apply: 1,
  Lpprint_Tree: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lpprint_Tree$Apply as $d_Lpprint_Tree$Apply };
/** @constructor */
function $c_Lpprint_Tree$Infix(lhs, op, rhs) {
  this.Lpprint_Tree$Infix__f_lhs = null;
  this.Lpprint_Tree$Infix__f_op = null;
  this.Lpprint_Tree$Infix__f_rhs = null;
  this.Lpprint_Tree$Infix__f_lhs = lhs;
  this.Lpprint_Tree$Infix__f_op = op;
  this.Lpprint_Tree$Infix__f_rhs = rhs;
}
export { $c_Lpprint_Tree$Infix as $c_Lpprint_Tree$Infix };
$c_Lpprint_Tree$Infix.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lpprint_Tree$Infix.prototype.constructor = $c_Lpprint_Tree$Infix;
/** @constructor */
function $h_Lpprint_Tree$Infix() {
}
export { $h_Lpprint_Tree$Infix as $h_Lpprint_Tree$Infix };
$h_Lpprint_Tree$Infix.prototype = $c_Lpprint_Tree$Infix.prototype;
$c_Lpprint_Tree$Infix.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lpprint_Tree$Infix.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lpprint_Tree$Infix.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpprint_Tree$Infix)) {
    var x = this.Lpprint_Tree$Infix__f_lhs;
    var x$2 = x$0.Lpprint_Tree$Infix__f_lhs;
    if ((((x === null) ? (x$2 === null) : x.equals__O__Z(x$2)) && (this.Lpprint_Tree$Infix__f_op === x$0.Lpprint_Tree$Infix__f_op))) {
      var x$3 = this.Lpprint_Tree$Infix__f_rhs;
      var x$4 = x$0.Lpprint_Tree$Infix__f_rhs;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lpprint_Tree$Infix.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lpprint_Tree$Infix.prototype.productArity__I = (function() {
  return 3;
});
$c_Lpprint_Tree$Infix.prototype.productPrefix__T = (function() {
  return "Infix";
});
$c_Lpprint_Tree$Infix.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lpprint_Tree$Infix__f_lhs;
      break;
    }
    case 1: {
      return this.Lpprint_Tree$Infix__f_op;
      break;
    }
    case 2: {
      return this.Lpprint_Tree$Infix__f_rhs;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lpprint_Tree$Infix.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "lhs";
      break;
    }
    case 1: {
      return "op";
      break;
    }
    case 2: {
      return "rhs";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpprint_Tree$Infix(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lpprint_Tree$Infix)));
}
export { $isArrayOf_Lpprint_Tree$Infix as $isArrayOf_Lpprint_Tree$Infix };
var $d_Lpprint_Tree$Infix = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lpprint_Tree$Infix, "pprint.Tree$Infix", ({
  Lpprint_Tree$Infix: 1,
  Lpprint_Tree: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lpprint_Tree$Infix as $d_Lpprint_Tree$Infix };
/** @constructor */
function $c_Lpprint_Tree$KeyValue(key, value) {
  this.Lpprint_Tree$KeyValue__f_key = null;
  this.Lpprint_Tree$KeyValue__f_value = null;
  this.Lpprint_Tree$KeyValue__f_key = key;
  this.Lpprint_Tree$KeyValue__f_value = value;
}
export { $c_Lpprint_Tree$KeyValue as $c_Lpprint_Tree$KeyValue };
$c_Lpprint_Tree$KeyValue.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lpprint_Tree$KeyValue.prototype.constructor = $c_Lpprint_Tree$KeyValue;
/** @constructor */
function $h_Lpprint_Tree$KeyValue() {
}
export { $h_Lpprint_Tree$KeyValue as $h_Lpprint_Tree$KeyValue };
$h_Lpprint_Tree$KeyValue.prototype = $c_Lpprint_Tree$KeyValue.prototype;
$c_Lpprint_Tree$KeyValue.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lpprint_Tree$KeyValue.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lpprint_Tree$KeyValue.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpprint_Tree$KeyValue)) {
    if ((this.Lpprint_Tree$KeyValue__f_key === x$0.Lpprint_Tree$KeyValue__f_key)) {
      var x = this.Lpprint_Tree$KeyValue__f_value;
      var x$2 = x$0.Lpprint_Tree$KeyValue__f_value;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lpprint_Tree$KeyValue.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lpprint_Tree$KeyValue.prototype.productArity__I = (function() {
  return 2;
});
$c_Lpprint_Tree$KeyValue.prototype.productPrefix__T = (function() {
  return "KeyValue";
});
$c_Lpprint_Tree$KeyValue.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lpprint_Tree$KeyValue__f_key;
  }
  if ((n === 1)) {
    return this.Lpprint_Tree$KeyValue__f_value;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lpprint_Tree$KeyValue.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "key";
  }
  if ((n === 1)) {
    return "value";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpprint_Tree$KeyValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lpprint_Tree$KeyValue)));
}
export { $isArrayOf_Lpprint_Tree$KeyValue as $isArrayOf_Lpprint_Tree$KeyValue };
var $d_Lpprint_Tree$KeyValue = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lpprint_Tree$KeyValue, "pprint.Tree$KeyValue", ({
  Lpprint_Tree$KeyValue: 1,
  Lpprint_Tree: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lpprint_Tree$KeyValue as $d_Lpprint_Tree$KeyValue };
/** @constructor */
function $c_Lpprint_Tree$Lazy(body0) {
  this.Lpprint_Tree$Lazy__f_body0 = null;
  this.Lpprint_Tree$Lazy__f_body0 = body0;
}
export { $c_Lpprint_Tree$Lazy as $c_Lpprint_Tree$Lazy };
$c_Lpprint_Tree$Lazy.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lpprint_Tree$Lazy.prototype.constructor = $c_Lpprint_Tree$Lazy;
/** @constructor */
function $h_Lpprint_Tree$Lazy() {
}
export { $h_Lpprint_Tree$Lazy as $h_Lpprint_Tree$Lazy };
$h_Lpprint_Tree$Lazy.prototype = $c_Lpprint_Tree$Lazy.prototype;
$c_Lpprint_Tree$Lazy.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lpprint_Tree$Lazy.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lpprint_Tree$Lazy.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpprint_Tree$Lazy)) {
    var x = this.Lpprint_Tree$Lazy__f_body0;
    var x$2 = x$0.Lpprint_Tree$Lazy__f_body0;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lpprint_Tree$Lazy.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lpprint_Tree$Lazy.prototype.productArity__I = (function() {
  return 1;
});
$c_Lpprint_Tree$Lazy.prototype.productPrefix__T = (function() {
  return "Lazy";
});
$c_Lpprint_Tree$Lazy.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lpprint_Tree$Lazy__f_body0;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lpprint_Tree$Lazy.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "body0";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpprint_Tree$Lazy(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lpprint_Tree$Lazy)));
}
export { $isArrayOf_Lpprint_Tree$Lazy as $isArrayOf_Lpprint_Tree$Lazy };
var $d_Lpprint_Tree$Lazy = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lpprint_Tree$Lazy, "pprint.Tree$Lazy", ({
  Lpprint_Tree$Lazy: 1,
  Lpprint_Tree: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lpprint_Tree$Lazy as $d_Lpprint_Tree$Lazy };
/** @constructor */
function $c_Lpprint_Tree$Literal(body) {
  this.Lpprint_Tree$Literal__f_body = null;
  this.Lpprint_Tree$Literal__f_body = body;
  _return: {
    var len = body.length;
    var i = 0;
    while ((i < len)) {
      var index = i;
      var x0 = body.charCodeAt(index);
      if (((x0 === 10) || (x0 === 13))) {
        break _return;
      }
      i = ((1 + i) | 0);
    }
  }
}
export { $c_Lpprint_Tree$Literal as $c_Lpprint_Tree$Literal };
$c_Lpprint_Tree$Literal.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lpprint_Tree$Literal.prototype.constructor = $c_Lpprint_Tree$Literal;
/** @constructor */
function $h_Lpprint_Tree$Literal() {
}
export { $h_Lpprint_Tree$Literal as $h_Lpprint_Tree$Literal };
$h_Lpprint_Tree$Literal.prototype = $c_Lpprint_Tree$Literal.prototype;
$c_Lpprint_Tree$Literal.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lpprint_Tree$Literal.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lpprint_Tree$Literal.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpprint_Tree$Literal) && (this.Lpprint_Tree$Literal__f_body === x$0.Lpprint_Tree$Literal__f_body)));
});
$c_Lpprint_Tree$Literal.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lpprint_Tree$Literal.prototype.productArity__I = (function() {
  return 1;
});
$c_Lpprint_Tree$Literal.prototype.productPrefix__T = (function() {
  return "Literal";
});
$c_Lpprint_Tree$Literal.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lpprint_Tree$Literal__f_body;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lpprint_Tree$Literal.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "body";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpprint_Tree$Literal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lpprint_Tree$Literal)));
}
export { $isArrayOf_Lpprint_Tree$Literal as $isArrayOf_Lpprint_Tree$Literal };
var $d_Lpprint_Tree$Literal = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lpprint_Tree$Literal, "pprint.Tree$Literal", ({
  Lpprint_Tree$Literal: 1,
  Lpprint_Tree: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lpprint_Tree$Literal as $d_Lpprint_Tree$Literal };
/** @constructor */
function $c_Lretry_HandlerDecision() {
}
export { $c_Lretry_HandlerDecision as $c_Lretry_HandlerDecision };
$c_Lretry_HandlerDecision.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lretry_HandlerDecision.prototype.constructor = $c_Lretry_HandlerDecision;
/** @constructor */
function $h_Lretry_HandlerDecision() {
}
export { $h_Lretry_HandlerDecision as $h_Lretry_HandlerDecision };
$h_Lretry_HandlerDecision.prototype = $c_Lretry_HandlerDecision.prototype;
$c_Lretry_HandlerDecision.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lretry_NextStep$RetryAfterDelay(delay, updatedStatus) {
  this.Lretry_NextStep$RetryAfterDelay__f_delay = null;
  this.Lretry_NextStep$RetryAfterDelay__f_updatedStatus = null;
  this.Lretry_NextStep$RetryAfterDelay__f_delay = delay;
  this.Lretry_NextStep$RetryAfterDelay__f_updatedStatus = updatedStatus;
}
export { $c_Lretry_NextStep$RetryAfterDelay as $c_Lretry_NextStep$RetryAfterDelay };
$c_Lretry_NextStep$RetryAfterDelay.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lretry_NextStep$RetryAfterDelay.prototype.constructor = $c_Lretry_NextStep$RetryAfterDelay;
/** @constructor */
function $h_Lretry_NextStep$RetryAfterDelay() {
}
export { $h_Lretry_NextStep$RetryAfterDelay as $h_Lretry_NextStep$RetryAfterDelay };
$h_Lretry_NextStep$RetryAfterDelay.prototype = $c_Lretry_NextStep$RetryAfterDelay.prototype;
$c_Lretry_NextStep$RetryAfterDelay.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lretry_NextStep$RetryAfterDelay.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lretry_NextStep$RetryAfterDelay.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lretry_NextStep$RetryAfterDelay)) {
    var x = this.Lretry_NextStep$RetryAfterDelay__f_delay;
    var x$2 = x$0.Lretry_NextStep$RetryAfterDelay__f_delay;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lretry_NextStep$RetryAfterDelay__f_updatedStatus;
      var x$4 = x$0.Lretry_NextStep$RetryAfterDelay__f_updatedStatus;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lretry_NextStep$RetryAfterDelay.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lretry_NextStep$RetryAfterDelay.prototype.productArity__I = (function() {
  return 2;
});
$c_Lretry_NextStep$RetryAfterDelay.prototype.productPrefix__T = (function() {
  return "RetryAfterDelay";
});
$c_Lretry_NextStep$RetryAfterDelay.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lretry_NextStep$RetryAfterDelay__f_delay;
  }
  if ((n === 1)) {
    return this.Lretry_NextStep$RetryAfterDelay__f_updatedStatus;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lretry_NextStep$RetryAfterDelay.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "delay";
  }
  if ((n === 1)) {
    return "updatedStatus";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lretry_NextStep$RetryAfterDelay(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lretry_NextStep$RetryAfterDelay)));
}
export { $isArrayOf_Lretry_NextStep$RetryAfterDelay as $isArrayOf_Lretry_NextStep$RetryAfterDelay };
var $d_Lretry_NextStep$RetryAfterDelay = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lretry_NextStep$RetryAfterDelay, "retry.NextStep$RetryAfterDelay", ({
  Lretry_NextStep$RetryAfterDelay: 1,
  Lretry_NextStep: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lretry_NextStep$RetryAfterDelay as $d_Lretry_NextStep$RetryAfterDelay };
/** @constructor */
function $c_Lretry_PolicyDecision() {
}
export { $c_Lretry_PolicyDecision as $c_Lretry_PolicyDecision };
$c_Lretry_PolicyDecision.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lretry_PolicyDecision.prototype.constructor = $c_Lretry_PolicyDecision;
/** @constructor */
function $h_Lretry_PolicyDecision() {
}
export { $h_Lretry_PolicyDecision as $h_Lretry_PolicyDecision };
$h_Lretry_PolicyDecision.prototype = $c_Lretry_PolicyDecision.prototype;
$c_Lretry_PolicyDecision.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lretry_RetryDetails$NextStep() {
}
export { $c_Lretry_RetryDetails$NextStep as $c_Lretry_RetryDetails$NextStep };
$c_Lretry_RetryDetails$NextStep.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lretry_RetryDetails$NextStep.prototype.constructor = $c_Lretry_RetryDetails$NextStep;
/** @constructor */
function $h_Lretry_RetryDetails$NextStep() {
}
export { $h_Lretry_RetryDetails$NextStep as $h_Lretry_RetryDetails$NextStep };
$h_Lretry_RetryDetails$NextStep.prototype = $c_Lretry_RetryDetails$NextStep.prototype;
$c_Lretry_RetryDetails$NextStep.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lretry_RetryPolicy$$anon$1(decideNextRetry$1, pretty$1) {
  this.Lretry_RetryPolicy__f_decideNextRetry = null;
  this.Lretry_RetryPolicy$$anon$1__f_pretty$2 = null;
  this.Lretry_RetryPolicy$$anon$1__f_pretty$2 = pretty$1;
  $ct_Lretry_RetryPolicy__F2__(this, decideNextRetry$1);
}
export { $c_Lretry_RetryPolicy$$anon$1 as $c_Lretry_RetryPolicy$$anon$1 };
$c_Lretry_RetryPolicy$$anon$1.prototype = new $h_Lretry_RetryPolicy();
$c_Lretry_RetryPolicy$$anon$1.prototype.constructor = $c_Lretry_RetryPolicy$$anon$1;
/** @constructor */
function $h_Lretry_RetryPolicy$$anon$1() {
}
export { $h_Lretry_RetryPolicy$$anon$1 as $h_Lretry_RetryPolicy$$anon$1 };
$h_Lretry_RetryPolicy$$anon$1.prototype = $c_Lretry_RetryPolicy$$anon$1.prototype;
$c_Lretry_RetryPolicy$$anon$1.prototype.show__T = (function() {
  return this.Lretry_RetryPolicy$$anon$1__f_pretty$2.apply__O();
});
$c_Lretry_RetryPolicy$$anon$1.prototype.toString__T = (function() {
  return this.Lretry_RetryPolicy$$anon$1__f_pretty$2.apply__O();
});
var $d_Lretry_RetryPolicy$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lretry_RetryPolicy$$anon$1, "retry.RetryPolicy$$anon$1", ({
  Lretry_RetryPolicy$$anon$1: 1,
  Lretry_RetryPolicy: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lretry_RetryPolicy$$anon$1 as $d_Lretry_RetryPolicy$$anon$1 };
/** @constructor */
function $c_s_Product$$anon$2(outer) {
  this.s_Product$$anon$2__f_c = 0;
  this.s_Product$$anon$2__f_cmax = 0;
  this.s_Product$$anon$2__f_$outer = null;
  this.s_Product$$anon$2__f_$outer = outer;
  this.s_Product$$anon$2__f_c = 0;
  this.s_Product$$anon$2__f_cmax = outer.productArity__I();
}
export { $c_s_Product$$anon$2 as $c_s_Product$$anon$2 };
$c_s_Product$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sc_AbstractIterator();
$c_s_Product$$anon$2.prototype.constructor = $c_s_Product$$anon$2;
/** @constructor */
function $h_s_Product$$anon$2() {
}
export { $h_s_Product$$anon$2 as $h_s_Product$$anon$2 };
$h_s_Product$$anon$2.prototype = $c_s_Product$$anon$2.prototype;
$c_s_Product$$anon$2.prototype.hasNext__Z = (function() {
  return (this.s_Product$$anon$2__f_c < this.s_Product$$anon$2__f_cmax);
});
$c_s_Product$$anon$2.prototype.next__T = (function() {
  var result = this.s_Product$$anon$2__f_$outer.productElementName__I__T(this.s_Product$$anon$2__f_c);
  this.s_Product$$anon$2__f_c = ((1 + this.s_Product$$anon$2__f_c) | 0);
  return result;
});
$c_s_Product$$anon$2.prototype.next__O = (function() {
  return this.next__T();
});
var $d_s_Product$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_s_Product$$anon$2, "scala.Product$$anon$2", ({
  s_Product$$anon$2: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_s_Product$$anon$2 as $d_s_Product$$anon$2 };
/** @constructor */
function $c_sc_BitSetOps$$anon$1(outer, start$1) {
  this.sc_BitSetOps$$anon$1__f_currentPos = 0;
  this.sc_BitSetOps$$anon$1__f_currentWord = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0;
  this.sc_BitSetOps$$anon$1__f_$outer = null;
  this.sc_BitSetOps$$anon$1__f_$outer = outer;
  this.sc_BitSetOps$$anon$1__f_currentPos = ((start$1 > 0) ? (start$1 >> 6) : 0);
  if ((start$1 > 0)) {
    var a = outer.word__I__J(this.sc_BitSetOps$$anon$1__f_currentPos);
    var n = (63 & start$1);
    var lo = (((32 & n) === 0) ? ((-1) << n) : 0);
    var hi = (((32 & n) === 0) ? (((2147483647 >>> ((31 - n) | 0)) | 0) | ((-1) << n)) : ((-1) << n));
    var lo$1 = (a.RTLong__f_lo & lo);
    var hi$1 = (a.RTLong__f_hi & hi);
    var x__lo = lo$1;
    var x__hi = hi$1;
    var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(x__lo, x__hi);
  } else {
    var $x_1 = outer.word__I__J(0);
  }
  this.sc_BitSetOps$$anon$1__f_currentWord = $x_1;
}
export { $c_sc_BitSetOps$$anon$1 as $c_sc_BitSetOps$$anon$1 };
$c_sc_BitSetOps$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sc_AbstractIterator();
$c_sc_BitSetOps$$anon$1.prototype.constructor = $c_sc_BitSetOps$$anon$1;
/** @constructor */
function $h_sc_BitSetOps$$anon$1() {
}
export { $h_sc_BitSetOps$$anon$1 as $h_sc_BitSetOps$$anon$1 };
$h_sc_BitSetOps$$anon$1.prototype = $c_sc_BitSetOps$$anon$1.prototype;
$c_sc_BitSetOps$$anon$1.prototype.hasNext__Z = (function() {
  while (true) {
    var a = this.sc_BitSetOps$$anon$1__f_currentWord;
    if (((a.RTLong__f_lo === 0) && (a.RTLong__f_hi === 0))) {
      if ((((1 + this.sc_BitSetOps$$anon$1__f_currentPos) | 0) >= this.sc_BitSetOps$$anon$1__f_$outer.nwords__I())) {
        return false;
      }
      this.sc_BitSetOps$$anon$1__f_currentPos = ((1 + this.sc_BitSetOps$$anon$1__f_currentPos) | 0);
      this.sc_BitSetOps$$anon$1__f_currentWord = this.sc_BitSetOps$$anon$1__f_$outer.word__I__J(this.sc_BitSetOps$$anon$1__f_currentPos);
    } else {
      break;
    }
  }
  return true;
});
$c_sc_BitSetOps$$anon$1.prototype.next__I = (function() {
  if (this.hasNext__Z()) {
    var t = this.sc_BitSetOps$$anon$1__f_currentWord;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    if ((lo !== 0)) {
      var i = ((~lo) & (((-1) + lo) | 0));
      var bitPos = ((32 - Math.clz32(i)) | 0);
    } else {
      var i$1 = ((~hi) & (((-1) + hi) | 0));
      var bitPos = ((64 - Math.clz32(i$1)) | 0);
    }
    var a = this.sc_BitSetOps$$anon$1__f_currentWord;
    var b = this.sc_BitSetOps$$anon$1__f_currentWord;
    var blo = b.RTLong__f_lo;
    var lo$1 = (((-1) + blo) | 0);
    var hi$1 = (((((-1) + b.RTLong__f_hi) | 0) + (((blo | (~lo$1)) >>> 31) | 0)) | 0);
    var lo$2 = (a.RTLong__f_lo & lo$1);
    var hi$2 = (a.RTLong__f_hi & hi$1);
    this.sc_BitSetOps$$anon$1__f_currentWord = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$2, hi$2);
    return (((this.sc_BitSetOps$$anon$1__f_currentPos << 6) + bitPos) | 0);
  } else {
    return ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O() | 0);
  }
});
$c_sc_BitSetOps$$anon$1.prototype.next__O = (function() {
  return this.next__I();
});
var $d_sc_BitSetOps$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sc_BitSetOps$$anon$1, "scala.collection.BitSetOps$$anon$1", ({
  sc_BitSetOps$$anon$1: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sc_BitSetOps$$anon$1 as $d_sc_BitSetOps$$anon$1 };
/** @constructor */
function $c_sc_Iterator$$anon$23(end$1, f$5) {
  this.sc_Iterator$$anon$23__f_i = 0;
  this.sc_Iterator$$anon$23__f_end$1 = 0;
  this.sc_Iterator$$anon$23__f_f$5 = null;
  this.sc_Iterator$$anon$23__f_end$1 = end$1;
  this.sc_Iterator$$anon$23__f_f$5 = f$5;
  this.sc_Iterator$$anon$23__f_i = 0;
}
export { $c_sc_Iterator$$anon$23 as $c_sc_Iterator$$anon$23 };
$c_sc_Iterator$$anon$23.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sc_AbstractIterator();
$c_sc_Iterator$$anon$23.prototype.constructor = $c_sc_Iterator$$anon$23;
/** @constructor */
function $h_sc_Iterator$$anon$23() {
}
export { $h_sc_Iterator$$anon$23 as $h_sc_Iterator$$anon$23 };
$h_sc_Iterator$$anon$23.prototype = $c_sc_Iterator$$anon$23.prototype;
$c_sc_Iterator$$anon$23.prototype.knownSize__I = (function() {
  var x = ((this.sc_Iterator$$anon$23__f_end$1 - this.sc_Iterator$$anon$23__f_i) | 0);
  return ((x > 0) ? x : 0);
});
$c_sc_Iterator$$anon$23.prototype.hasNext__Z = (function() {
  return (this.sc_Iterator$$anon$23__f_i < this.sc_Iterator$$anon$23__f_end$1);
});
$c_sc_Iterator$$anon$23.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    var result = this.sc_Iterator$$anon$23__f_f$5.apply__O__O(this.sc_Iterator$$anon$23__f_i);
    this.sc_Iterator$$anon$23__f_i = ((1 + this.sc_Iterator$$anon$23__f_i) | 0);
    return result;
  } else {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  }
});
var $d_sc_Iterator$$anon$23 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sc_Iterator$$anon$23, "scala.collection.Iterator$$anon$23", ({
  sc_Iterator$$anon$23: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sc_Iterator$$anon$23 as $d_sc_Iterator$$anon$23 };
/** @constructor */
function $c_sc_Iterator$UnfoldIterator(init, f) {
  this.sc_Iterator$UnfoldIterator__f_f = null;
  this.sc_Iterator$UnfoldIterator__f_state = null;
  this.sc_Iterator$UnfoldIterator__f_nextResult = null;
  this.sc_Iterator$UnfoldIterator__f_f = f;
  this.sc_Iterator$UnfoldIterator__f_state = init;
  this.sc_Iterator$UnfoldIterator__f_nextResult = null;
}
export { $c_sc_Iterator$UnfoldIterator as $c_sc_Iterator$UnfoldIterator };
$c_sc_Iterator$UnfoldIterator.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sc_AbstractIterator();
$c_sc_Iterator$UnfoldIterator.prototype.constructor = $c_sc_Iterator$UnfoldIterator;
/** @constructor */
function $h_sc_Iterator$UnfoldIterator() {
}
export { $h_sc_Iterator$UnfoldIterator as $h_sc_Iterator$UnfoldIterator };
$h_sc_Iterator$UnfoldIterator.prototype = $c_sc_Iterator$UnfoldIterator.prototype;
$c_sc_Iterator$UnfoldIterator.prototype.hasNext__Z = (function() {
  if ((this.sc_Iterator$UnfoldIterator__f_nextResult === null)) {
    var res = this.sc_Iterator$UnfoldIterator__f_f.apply__O__O(this.sc_Iterator$UnfoldIterator__f_state);
    if ((res === null)) {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException(), "null during unfold");
    }
    this.sc_Iterator$UnfoldIterator__f_nextResult = res;
    this.sc_Iterator$UnfoldIterator__f_state = null;
  }
  var this$1 = this.sc_Iterator$UnfoldIterator__f_nextResult;
  return (!this$1.isEmpty__Z());
});
$c_sc_Iterator$UnfoldIterator.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    var x1 = this.sc_Iterator$UnfoldIterator__f_nextResult.get__O();
    if ((x1 === null)) {
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1);
    }
    var value = x1._1__O();
    var newState = x1._2__O();
    this.sc_Iterator$UnfoldIterator__f_state = newState;
    this.sc_Iterator$UnfoldIterator__f_nextResult = null;
    return value;
  } else {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  }
});
var $d_sc_Iterator$UnfoldIterator = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sc_Iterator$UnfoldIterator, "scala.collection.Iterator$UnfoldIterator", ({
  sc_Iterator$UnfoldIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sc_Iterator$UnfoldIterator as $d_sc_Iterator$UnfoldIterator };
/** @constructor */
function $c_sc_SortedIterableFactory$Delegate() {
  this.sc_EvidenceIterableFactory$Delegate__f_delegate = null;
}
export { $c_sc_SortedIterableFactory$Delegate as $c_sc_SortedIterableFactory$Delegate };
$c_sc_SortedIterableFactory$Delegate.prototype = new $h_sc_EvidenceIterableFactory$Delegate();
$c_sc_SortedIterableFactory$Delegate.prototype.constructor = $c_sc_SortedIterableFactory$Delegate;
/** @constructor */
function $h_sc_SortedIterableFactory$Delegate() {
}
export { $h_sc_SortedIterableFactory$Delegate as $h_sc_SortedIterableFactory$Delegate };
$h_sc_SortedIterableFactory$Delegate.prototype = $c_sc_SortedIterableFactory$Delegate.prototype;
function $ct_sci_LongMapIterator__sci_LongMap__($thiz, it) {
  $thiz.sci_LongMapIterator__f_index = 0;
  $thiz.sci_LongMapIterator__f_buffer = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(65);
  $thiz.push__sci_LongMap__V(it);
  return $thiz;
}
export { $ct_sci_LongMapIterator__sci_LongMap__ as $ct_sci_LongMapIterator__sci_LongMap__ };
/** @constructor */
function $c_sci_LongMapIterator() {
  this.sci_LongMapIterator__f_index = 0;
  this.sci_LongMapIterator__f_buffer = null;
}
export { $c_sci_LongMapIterator as $c_sci_LongMapIterator };
$c_sci_LongMapIterator.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sc_AbstractIterator();
$c_sci_LongMapIterator.prototype.constructor = $c_sci_LongMapIterator;
/** @constructor */
function $h_sci_LongMapIterator() {
}
export { $h_sci_LongMapIterator as $h_sci_LongMapIterator };
$h_sci_LongMapIterator.prototype = $c_sci_LongMapIterator.prototype;
$c_sci_LongMapIterator.prototype.pop__sci_LongMap = (function() {
  this.sci_LongMapIterator__f_index = (((-1) + this.sci_LongMapIterator__f_index) | 0);
  return this.sci_LongMapIterator__f_buffer.u[this.sci_LongMapIterator__f_index];
});
$c_sci_LongMapIterator.prototype.push__sci_LongMap__V = (function(x) {
  this.sci_LongMapIterator__f_buffer.u[this.sci_LongMapIterator__f_index] = x;
  this.sci_LongMapIterator__f_index = ((1 + this.sci_LongMapIterator__f_index) | 0);
});
$c_sci_LongMapIterator.prototype.hasNext__Z = (function() {
  return (this.sci_LongMapIterator__f_index !== 0);
});
$c_sci_LongMapIterator.prototype.next__O = (function() {
  while (true) {
    var rc16 = false;
    var x2 = null;
    var x1 = this.pop__sci_LongMap();
    if ((x1 instanceof $c_sci_LongMap$Bin)) {
      rc16 = true;
      x2 = x1;
      var t = x2.sci_LongMap$Bin__f_left;
      var right = x2.sci_LongMap$Bin__f_right;
      if ((t instanceof $c_sci_LongMap$Tip)) {
        this.push__sci_LongMap__V(right);
        return this.valueOf__sci_LongMap$Tip__O(t);
      }
    }
    if (rc16) {
      var left = x2.sci_LongMap$Bin__f_left;
      var right$2 = x2.sci_LongMap$Bin__f_right;
      this.push__sci_LongMap__V(right$2);
      this.push__sci_LongMap__V(left);
      continue;
    }
    if ((x1 instanceof $c_sci_LongMap$Tip)) {
      return this.valueOf__sci_LongMap$Tip__O(x1);
    }
    var x = $m_sci_LongMap$Nil$();
    if (x.equals__O__Z(x1)) {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalStateException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalStateException(), "Empty maps not allowed as subtrees");
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1);
  }
});
/** @constructor */
function $c_sci_Queue$() {
}
export { $c_sci_Queue$ as $c_sci_Queue$ };
$c_sci_Queue$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_sci_Queue$.prototype.constructor = $c_sci_Queue$;
/** @constructor */
function $h_sci_Queue$() {
}
export { $h_sci_Queue$ as $h_sci_Queue$ };
$h_sci_Queue$.prototype = $c_sci_Queue$.prototype;
$c_sci_Queue$.prototype.newBuilder__scm_Builder = (function() {
  var this$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_ListBuffer();
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$2$2) => $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$(), x$2$2)));
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_Builder$$anon$1(this$1, f);
});
$c_sci_Queue$.prototype.from__sc_IterableOnce__sci_Queue = (function(source) {
  if ((source instanceof $c_sci_Queue)) {
    return source;
  } else {
    var list = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(source);
    return (list.isEmpty__Z() ? $m_sci_Queue$EmptyQueue$() : $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$(), list));
  }
});
$c_sci_Queue$.prototype.apply__sci_Seq__O = (function(elems) {
  return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$(), elems.toList__sci_List());
});
$c_sci_Queue$.prototype.empty__O = (function() {
  return $m_sci_Queue$EmptyQueue$();
});
$c_sci_Queue$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_Queue(source);
});
var $d_sci_Queue$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sci_Queue$, "scala.collection.immutable.Queue$", ({
  sci_Queue$: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Queue$ as $d_sci_Queue$ };
var $n_sci_Queue$;
function $m_sci_Queue$() {
  if ((!$n_sci_Queue$)) {
    $n_sci_Queue$ = new $c_sci_Queue$();
  }
  return $n_sci_Queue$;
}
export { $m_sci_Queue$ as $m_sci_Queue$ };
function $p_sci_RedBlackTree$TreeIterator__startFrom__O__sci_RedBlackTree$Tree($thiz, key) {
  return (($thiz.sci_RedBlackTree$TreeIterator__f_root === null) ? null : $p_sci_RedBlackTree$TreeIterator__find$1__sci_RedBlackTree$Tree__O__sci_RedBlackTree$Tree($thiz, $thiz.sci_RedBlackTree$TreeIterator__f_root, key));
}
export { $p_sci_RedBlackTree$TreeIterator__startFrom__O__sci_RedBlackTree$Tree as $p_sci_RedBlackTree$TreeIterator__startFrom__O__sci_RedBlackTree$Tree };
function $p_sci_RedBlackTree$TreeIterator__find$1__sci_RedBlackTree$Tree__O__sci_RedBlackTree$Tree($thiz, tree, key$1) {
  while (true) {
    if ((tree === null)) {
      if (($thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index === 0)) {
        return null;
      } else {
        $thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = (((-1) + $thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index) | 0);
        return $thiz.sci_RedBlackTree$TreeIterator__f_stackOfNexts.u[$thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index];
      }
    } else {
      var $x_1 = $thiz.sci_RedBlackTree$TreeIterator__f_ordering;
      var this$1 = tree;
      if ($x_1.lteq__O__O__Z(key$1, this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key)) {
        var tree$1 = tree;
        $thiz.sci_RedBlackTree$TreeIterator__f_stackOfNexts.u[$thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index] = tree$1;
        $thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = ((1 + $thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index) | 0);
        tree = tree$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      } else {
        var tree$2 = tree;
        tree = tree$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      }
    }
  }
}
export { $p_sci_RedBlackTree$TreeIterator__find$1__sci_RedBlackTree$Tree__O__sci_RedBlackTree$Tree as $p_sci_RedBlackTree$TreeIterator__find$1__sci_RedBlackTree$Tree__O__sci_RedBlackTree$Tree };
function $ct_sci_RedBlackTree$TreeIterator__sci_RedBlackTree$Tree__s_Option__s_math_Ordering__($thiz, root, start, ordering) {
  $thiz.sci_RedBlackTree$TreeIterator__f_root = root;
  $thiz.sci_RedBlackTree$TreeIterator__f_ordering = ordering;
  if ((root === null)) {
    var $x_1 = null;
  } else {
    var i = ((1 + (2147483647 & root.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) | 0);
    var maximumHeight = (((-2) + (((32 - Math.clz32(i)) | 0) << 1)) | 0);
    var $x_1 = new ($d_sci_RedBlackTree$Tree.getArrayOf().constr)(maximumHeight);
  }
  $thiz.sci_RedBlackTree$TreeIterator__f_stackOfNexts = $x_1;
  $thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = 0;
  $thiz.sci_RedBlackTree$TreeIterator__f_lookahead = ((!start.isEmpty__Z()) ? $p_sci_RedBlackTree$TreeIterator__startFrom__O__sci_RedBlackTree$Tree($thiz, start.get__O()) : $thiz.findLeftMostOrPopOnEmpty__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(root));
  return $thiz;
}
export { $ct_sci_RedBlackTree$TreeIterator__sci_RedBlackTree$Tree__s_Option__s_math_Ordering__ as $ct_sci_RedBlackTree$TreeIterator__sci_RedBlackTree$Tree__s_Option__s_math_Ordering__ };
/** @constructor */
function $c_sci_RedBlackTree$TreeIterator() {
  this.sci_RedBlackTree$TreeIterator__f_root = null;
  this.sci_RedBlackTree$TreeIterator__f_ordering = null;
  this.sci_RedBlackTree$TreeIterator__f_stackOfNexts = null;
  this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = 0;
  this.sci_RedBlackTree$TreeIterator__f_lookahead = null;
}
export { $c_sci_RedBlackTree$TreeIterator as $c_sci_RedBlackTree$TreeIterator };
$c_sci_RedBlackTree$TreeIterator.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sc_AbstractIterator();
$c_sci_RedBlackTree$TreeIterator.prototype.constructor = $c_sci_RedBlackTree$TreeIterator;
/** @constructor */
function $h_sci_RedBlackTree$TreeIterator() {
}
export { $h_sci_RedBlackTree$TreeIterator as $h_sci_RedBlackTree$TreeIterator };
$h_sci_RedBlackTree$TreeIterator.prototype = $c_sci_RedBlackTree$TreeIterator.prototype;
$c_sci_RedBlackTree$TreeIterator.prototype.hasNext__Z = (function() {
  return (this.sci_RedBlackTree$TreeIterator__f_lookahead !== null);
});
$c_sci_RedBlackTree$TreeIterator.prototype.next__O = (function() {
  var tree = this.sci_RedBlackTree$TreeIterator__f_lookahead;
  if ((tree !== null)) {
    this.sci_RedBlackTree$TreeIterator__f_lookahead = this.findLeftMostOrPopOnEmpty__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
    return this.nextResult__sci_RedBlackTree$Tree__O(tree);
  } else {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  }
});
$c_sci_RedBlackTree$TreeIterator.prototype.findLeftMostOrPopOnEmpty__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tree) {
  while (true) {
    if ((tree === null)) {
      if ((this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index === 0)) {
        return null;
      } else {
        this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = (((-1) + this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index) | 0);
        return this.sci_RedBlackTree$TreeIterator__f_stackOfNexts.u[this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index];
      }
    } else {
      var this$1 = tree;
      if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left === null)) {
        return tree;
      } else {
        var tree$1 = tree;
        this.sci_RedBlackTree$TreeIterator__f_stackOfNexts.u[this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index] = tree$1;
        this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = ((1 + this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index) | 0);
        tree = tree$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      }
    }
  }
});
/** @constructor */
function $c_s_concurrent_ExecutionContext$parasitic$() {
  this.s_concurrent_ExecutionContext$parasitic$__f_scala$concurrent$BatchingExecutor$$_tasksLocal = null;
  $n_s_concurrent_ExecutionContext$parasitic$ = this;
  this.s_concurrent_ExecutionContext$parasitic$__f_scala$concurrent$BatchingExecutor$$_tasksLocal = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_ThreadLocal__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_ThreadLocal());
}
export { $c_s_concurrent_ExecutionContext$parasitic$ as $c_s_concurrent_ExecutionContext$parasitic$ };
$c_s_concurrent_ExecutionContext$parasitic$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_s_concurrent_ExecutionContext$parasitic$.prototype.constructor = $c_s_concurrent_ExecutionContext$parasitic$;
/** @constructor */
function $h_s_concurrent_ExecutionContext$parasitic$() {
}
export { $h_s_concurrent_ExecutionContext$parasitic$ as $h_s_concurrent_ExecutionContext$parasitic$ };
$h_s_concurrent_ExecutionContext$parasitic$.prototype = $c_s_concurrent_ExecutionContext$parasitic$.prototype;
$c_s_concurrent_ExecutionContext$parasitic$.prototype.execute__jl_Runnable__V = (function(runnable) {
  $f_s_concurrent_BatchingExecutor__submitSyncBatched__jl_Runnable__V(this, runnable);
});
$c_s_concurrent_ExecutionContext$parasitic$.prototype.reportFailure__jl_Throwable__V = (function(t) {
  $m_s_concurrent_ExecutionContext$().s_concurrent_ExecutionContext$__f_defaultReporter.apply__O__O(t);
});
var $d_s_concurrent_ExecutionContext$parasitic$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_s_concurrent_ExecutionContext$parasitic$, "scala.concurrent.ExecutionContext$parasitic$", ({
  s_concurrent_ExecutionContext$parasitic$: 1,
  s_concurrent_ExecutionContextExecutor: 1,
  s_concurrent_ExecutionContext: 1,
  ju_concurrent_Executor: 1,
  s_concurrent_BatchingExecutor: 1
}));
export { $d_s_concurrent_ExecutionContext$parasitic$ as $d_s_concurrent_ExecutionContext$parasitic$ };
var $n_s_concurrent_ExecutionContext$parasitic$;
function $m_s_concurrent_ExecutionContext$parasitic$() {
  if ((!$n_s_concurrent_ExecutionContext$parasitic$)) {
    $n_s_concurrent_ExecutionContext$parasitic$ = new $c_s_concurrent_ExecutionContext$parasitic$();
  }
  return $n_s_concurrent_ExecutionContext$parasitic$;
}
export { $m_s_concurrent_ExecutionContext$parasitic$ as $m_s_concurrent_ExecutionContext$parasitic$ };
/** @constructor */
function $c_Lsourcecode_Enclosing(value) {
  this.Lsourcecode_Enclosing__f_value = null;
  this.Lsourcecode_Enclosing__f_value = value;
}
export { $c_Lsourcecode_Enclosing as $c_Lsourcecode_Enclosing };
$c_Lsourcecode_Enclosing.prototype = new $h_Lsourcecode_SourceValue();
$c_Lsourcecode_Enclosing.prototype.constructor = $c_Lsourcecode_Enclosing;
/** @constructor */
function $h_Lsourcecode_Enclosing() {
}
export { $h_Lsourcecode_Enclosing as $h_Lsourcecode_Enclosing };
$h_Lsourcecode_Enclosing.prototype = $c_Lsourcecode_Enclosing.prototype;
$c_Lsourcecode_Enclosing.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsourcecode_Enclosing.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lsourcecode_Enclosing.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lsourcecode_Enclosing) && (this.Lsourcecode_Enclosing__f_value === x$0.Lsourcecode_Enclosing__f_value)));
});
$c_Lsourcecode_Enclosing.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsourcecode_Enclosing.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsourcecode_Enclosing.prototype.productPrefix__T = (function() {
  return "Enclosing";
});
$c_Lsourcecode_Enclosing.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsourcecode_Enclosing__f_value;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsourcecode_Enclosing.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsourcecode_Enclosing(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsourcecode_Enclosing)));
}
export { $isArrayOf_Lsourcecode_Enclosing as $isArrayOf_Lsourcecode_Enclosing };
var $d_Lsourcecode_Enclosing = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsourcecode_Enclosing, "sourcecode.Enclosing", ({
  Lsourcecode_Enclosing: 1,
  Lsourcecode_SourceValue: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsourcecode_Enclosing as $d_Lsourcecode_Enclosing };
/** @constructor */
function $c_Lsourcecode_File(value) {
  this.Lsourcecode_File__f_value = null;
  this.Lsourcecode_File__f_value = value;
}
export { $c_Lsourcecode_File as $c_Lsourcecode_File };
$c_Lsourcecode_File.prototype = new $h_Lsourcecode_SourceValue();
$c_Lsourcecode_File.prototype.constructor = $c_Lsourcecode_File;
/** @constructor */
function $h_Lsourcecode_File() {
}
export { $h_Lsourcecode_File as $h_Lsourcecode_File };
$h_Lsourcecode_File.prototype = $c_Lsourcecode_File.prototype;
$c_Lsourcecode_File.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsourcecode_File.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lsourcecode_File.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lsourcecode_File) && (this.Lsourcecode_File__f_value === x$0.Lsourcecode_File__f_value)));
});
$c_Lsourcecode_File.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsourcecode_File.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsourcecode_File.prototype.productPrefix__T = (function() {
  return "File";
});
$c_Lsourcecode_File.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsourcecode_File__f_value;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsourcecode_File.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsourcecode_File(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsourcecode_File)));
}
export { $isArrayOf_Lsourcecode_File as $isArrayOf_Lsourcecode_File };
var $d_Lsourcecode_File = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsourcecode_File, "sourcecode.File", ({
  Lsourcecode_File: 1,
  Lsourcecode_SourceValue: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsourcecode_File as $d_Lsourcecode_File };
/** @constructor */
function $c_Lsourcecode_FullName(value) {
  this.Lsourcecode_FullName__f_value = null;
  this.Lsourcecode_FullName__f_value = value;
}
export { $c_Lsourcecode_FullName as $c_Lsourcecode_FullName };
$c_Lsourcecode_FullName.prototype = new $h_Lsourcecode_SourceValue();
$c_Lsourcecode_FullName.prototype.constructor = $c_Lsourcecode_FullName;
/** @constructor */
function $h_Lsourcecode_FullName() {
}
export { $h_Lsourcecode_FullName as $h_Lsourcecode_FullName };
$h_Lsourcecode_FullName.prototype = $c_Lsourcecode_FullName.prototype;
$c_Lsourcecode_FullName.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsourcecode_FullName.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lsourcecode_FullName.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lsourcecode_FullName) && (this.Lsourcecode_FullName__f_value === x$0.Lsourcecode_FullName__f_value)));
});
$c_Lsourcecode_FullName.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsourcecode_FullName.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsourcecode_FullName.prototype.productPrefix__T = (function() {
  return "FullName";
});
$c_Lsourcecode_FullName.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsourcecode_FullName__f_value;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsourcecode_FullName.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsourcecode_FullName(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsourcecode_FullName)));
}
export { $isArrayOf_Lsourcecode_FullName as $isArrayOf_Lsourcecode_FullName };
var $d_Lsourcecode_FullName = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsourcecode_FullName, "sourcecode.FullName", ({
  Lsourcecode_FullName: 1,
  Lsourcecode_SourceValue: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsourcecode_FullName as $d_Lsourcecode_FullName };
/** @constructor */
function $c_Lsourcecode_Line(value) {
  this.Lsourcecode_Line__f_value = 0;
  this.Lsourcecode_Line__f_value = value;
}
export { $c_Lsourcecode_Line as $c_Lsourcecode_Line };
$c_Lsourcecode_Line.prototype = new $h_Lsourcecode_SourceValue();
$c_Lsourcecode_Line.prototype.constructor = $c_Lsourcecode_Line;
/** @constructor */
function $h_Lsourcecode_Line() {
}
export { $h_Lsourcecode_Line as $h_Lsourcecode_Line };
$h_Lsourcecode_Line.prototype = $c_Lsourcecode_Line.prototype;
$c_Lsourcecode_Line.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsourcecode_Line.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I("Line");
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lsourcecode_Line__f_value;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1);
});
$c_Lsourcecode_Line.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lsourcecode_Line) && (this.Lsourcecode_Line__f_value === x$0.Lsourcecode_Line__f_value)));
});
$c_Lsourcecode_Line.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsourcecode_Line.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsourcecode_Line.prototype.productPrefix__T = (function() {
  return "Line";
});
$c_Lsourcecode_Line.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsourcecode_Line__f_value;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsourcecode_Line.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsourcecode_Line(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsourcecode_Line)));
}
export { $isArrayOf_Lsourcecode_Line as $isArrayOf_Lsourcecode_Line };
var $d_Lsourcecode_Line = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsourcecode_Line, "sourcecode.Line", ({
  Lsourcecode_Line: 1,
  Lsourcecode_SourceValue: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsourcecode_Line as $d_Lsourcecode_Line };
/** @constructor */
function $c_Lsourcecode_Name(value) {
  this.Lsourcecode_Name__f_value = null;
  this.Lsourcecode_Name__f_value = value;
}
export { $c_Lsourcecode_Name as $c_Lsourcecode_Name };
$c_Lsourcecode_Name.prototype = new $h_Lsourcecode_SourceValue();
$c_Lsourcecode_Name.prototype.constructor = $c_Lsourcecode_Name;
/** @constructor */
function $h_Lsourcecode_Name() {
}
export { $h_Lsourcecode_Name as $h_Lsourcecode_Name };
$h_Lsourcecode_Name.prototype = $c_Lsourcecode_Name.prototype;
$c_Lsourcecode_Name.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsourcecode_Name.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lsourcecode_Name.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lsourcecode_Name) && (this.Lsourcecode_Name__f_value === x$0.Lsourcecode_Name__f_value)));
});
$c_Lsourcecode_Name.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsourcecode_Name.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsourcecode_Name.prototype.productPrefix__T = (function() {
  return "Name";
});
$c_Lsourcecode_Name.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsourcecode_Name__f_value;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsourcecode_Name.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsourcecode_Name(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsourcecode_Name)));
}
export { $isArrayOf_Lsourcecode_Name as $isArrayOf_Lsourcecode_Name };
var $d_Lsourcecode_Name = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsourcecode_Name, "sourcecode.Name", ({
  Lsourcecode_Name: 1,
  Lsourcecode_SourceValue: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsourcecode_Name as $d_Lsourcecode_Name };
function $ps_Lsourcecode_Name$__Name$$superArg$1__F1() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => new $c_Lsourcecode_Name(_$1)));
}
export { $ps_Lsourcecode_Name$__Name$$superArg$1__F1 as $ps_Lsourcecode_Name$__Name$$superArg$1__F1 };
/** @constructor */
function $c_Lsourcecode_Name$() {
  this.Lsourcecode_SourceCompanion__f_build = null;
  $ct_Lsourcecode_SourceCompanion__F1__(this, $ps_Lsourcecode_Name$__Name$$superArg$1__F1());
}
export { $c_Lsourcecode_Name$ as $c_Lsourcecode_Name$ };
$c_Lsourcecode_Name$.prototype = new $h_Lsourcecode_SourceCompanion();
$c_Lsourcecode_Name$.prototype.constructor = $c_Lsourcecode_Name$;
/** @constructor */
function $h_Lsourcecode_Name$() {
}
export { $h_Lsourcecode_Name$ as $h_Lsourcecode_Name$ };
$h_Lsourcecode_Name$.prototype = $c_Lsourcecode_Name$.prototype;
$c_Lsourcecode_Name$.prototype.fromProduct__s_Product__Lsourcecode_Name = (function(x$0) {
  return new $c_Lsourcecode_Name(x$0.productElement__I__O(0));
});
$c_Lsourcecode_Name$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lsourcecode_Name(p);
});
var $d_Lsourcecode_Name$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsourcecode_Name$, "sourcecode.Name$", ({
  Lsourcecode_Name$: 1,
  Lsourcecode_SourceCompanion: 1,
  Lsourcecode_NameMacros: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lsourcecode_Name$ as $d_Lsourcecode_Name$ };
var $n_Lsourcecode_Name$;
function $m_Lsourcecode_Name$() {
  if ((!$n_Lsourcecode_Name$)) {
    $n_Lsourcecode_Name$ = new $c_Lsourcecode_Name$();
  }
  return $n_Lsourcecode_Name$;
}
export { $m_Lsourcecode_Name$ as $m_Lsourcecode_Name$ };
/** @constructor */
function $c_Lsttp_client3_MappedResponseAs(raw, g, showAs) {
  this.Lsttp_client3_MappedResponseAs__f_raw = null;
  this.Lsttp_client3_MappedResponseAs__f_g = null;
  this.Lsttp_client3_MappedResponseAs__f_showAs = null;
  this.Lsttp_client3_MappedResponseAs__f_raw = raw;
  this.Lsttp_client3_MappedResponseAs__f_g = g;
  this.Lsttp_client3_MappedResponseAs__f_showAs = showAs;
}
export { $c_Lsttp_client3_MappedResponseAs as $c_Lsttp_client3_MappedResponseAs };
$c_Lsttp_client3_MappedResponseAs.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_MappedResponseAs.prototype.constructor = $c_Lsttp_client3_MappedResponseAs;
/** @constructor */
function $h_Lsttp_client3_MappedResponseAs() {
}
export { $h_Lsttp_client3_MappedResponseAs as $h_Lsttp_client3_MappedResponseAs };
$h_Lsttp_client3_MappedResponseAs.prototype = $c_Lsttp_client3_MappedResponseAs.prototype;
$c_Lsttp_client3_MappedResponseAs.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_client3_MappedResponseAs.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lsttp_client3_MappedResponseAs.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_client3_MappedResponseAs)) {
    var x = this.Lsttp_client3_MappedResponseAs__f_raw;
    var x$2 = x$0.Lsttp_client3_MappedResponseAs__f_raw;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lsttp_client3_MappedResponseAs__f_g;
      var x$4 = x$0.Lsttp_client3_MappedResponseAs__f_g;
      var $x_1 = (x$3 === x$4);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Lsttp_client3_MappedResponseAs__f_showAs;
      var x$6 = x$0.Lsttp_client3_MappedResponseAs__f_showAs;
      return ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_client3_MappedResponseAs.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_client3_MappedResponseAs.prototype.productArity__I = (function() {
  return 3;
});
$c_Lsttp_client3_MappedResponseAs.prototype.productPrefix__T = (function() {
  return "MappedResponseAs";
});
$c_Lsttp_client3_MappedResponseAs.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsttp_client3_MappedResponseAs__f_raw;
      break;
    }
    case 1: {
      return this.Lsttp_client3_MappedResponseAs__f_g;
      break;
    }
    case 2: {
      return this.Lsttp_client3_MappedResponseAs__f_showAs;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_client3_MappedResponseAs.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "raw";
      break;
    }
    case 1: {
      return "g";
      break;
    }
    case 2: {
      return "showAs";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_client3_MappedResponseAs.prototype.mapWithMetadata__F2__Lsttp_client3_ResponseAs = (function(f) {
  var raw = this.Lsttp_client3_MappedResponseAs__f_raw;
  var g = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((t, h) => f.apply__O__O__O(this.Lsttp_client3_MappedResponseAs__f_g.apply__O__O__O(t, h), h)));
  var this$2 = this.Lsttp_client3_MappedResponseAs__f_showAs;
  if (this$2.isEmpty__Z()) {
    var showAs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0 = this$2.get__O();
    var showAs = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some((("mapped(" + x0) + ")"));
  }
  return new $c_Lsttp_client3_MappedResponseAs(raw, g, showAs);
});
$c_Lsttp_client3_MappedResponseAs.prototype.showAs__T__Lsttp_client3_ResponseAs = (function(s) {
  var showAs$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(s);
  var raw$1 = this.Lsttp_client3_MappedResponseAs__f_raw;
  var g$1 = this.Lsttp_client3_MappedResponseAs__f_g;
  return new $c_Lsttp_client3_MappedResponseAs(raw$1, g$1, showAs$1);
});
function $isArrayOf_Lsttp_client3_MappedResponseAs(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_client3_MappedResponseAs)));
}
export { $isArrayOf_Lsttp_client3_MappedResponseAs as $isArrayOf_Lsttp_client3_MappedResponseAs };
var $d_Lsttp_client3_MappedResponseAs = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_MappedResponseAs, "sttp.client3.MappedResponseAs", ({
  Lsttp_client3_MappedResponseAs: 1,
  Lsttp_client3_ResponseAs: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_client3_MappedResponseAs as $d_Lsttp_client3_MappedResponseAs };
/** @constructor */
function $c_Lsttp_client3_MultipartBody(parts) {
  this.Lsttp_client3_MultipartBody__f_parts = null;
  this.Lsttp_client3_MultipartBody__f_parts = parts;
}
export { $c_Lsttp_client3_MultipartBody as $c_Lsttp_client3_MultipartBody };
$c_Lsttp_client3_MultipartBody.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_MultipartBody.prototype.constructor = $c_Lsttp_client3_MultipartBody;
/** @constructor */
function $h_Lsttp_client3_MultipartBody() {
}
export { $h_Lsttp_client3_MultipartBody as $h_Lsttp_client3_MultipartBody };
$h_Lsttp_client3_MultipartBody.prototype = $c_Lsttp_client3_MultipartBody.prototype;
$c_Lsttp_client3_MultipartBody.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_client3_MultipartBody.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lsttp_client3_MultipartBody.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_client3_MultipartBody)) {
    var x = this.Lsttp_client3_MultipartBody__f_parts;
    var x$2 = x$0.Lsttp_client3_MultipartBody__f_parts;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lsttp_client3_MultipartBody.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_client3_MultipartBody.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_client3_MultipartBody.prototype.productPrefix__T = (function() {
  return "MultipartBody";
});
$c_Lsttp_client3_MultipartBody.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_client3_MultipartBody__f_parts;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_client3_MultipartBody.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "parts";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_client3_MultipartBody.prototype.defaultContentType__Lsttp_model_MediaType = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_MediaType$().Lsttp_model_MediaType$__f_MultipartFormData;
});
function $isArrayOf_Lsttp_client3_MultipartBody(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_client3_MultipartBody)));
}
export { $isArrayOf_Lsttp_client3_MultipartBody as $isArrayOf_Lsttp_client3_MultipartBody };
var $d_Lsttp_client3_MultipartBody = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_MultipartBody, "sttp.client3.MultipartBody", ({
  Lsttp_client3_MultipartBody: 1,
  Lsttp_client3_RequestBody: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_client3_MultipartBody as $d_Lsttp_client3_MultipartBody };
function $isArrayOf_Lsttp_client3_ResponseAsBoth(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_client3_ResponseAsBoth)));
}
export { $isArrayOf_Lsttp_client3_ResponseAsBoth as $isArrayOf_Lsttp_client3_ResponseAsBoth };
/** @constructor */
function $c_Lsttp_client3_ResponseAsFile(output) {
  this.Lsttp_client3_ResponseAsFile__f_output = null;
  this.Lsttp_client3_ResponseAsFile__f_output = output;
}
export { $c_Lsttp_client3_ResponseAsFile as $c_Lsttp_client3_ResponseAsFile };
$c_Lsttp_client3_ResponseAsFile.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_ResponseAsFile.prototype.constructor = $c_Lsttp_client3_ResponseAsFile;
/** @constructor */
function $h_Lsttp_client3_ResponseAsFile() {
}
export { $h_Lsttp_client3_ResponseAsFile as $h_Lsttp_client3_ResponseAsFile };
$h_Lsttp_client3_ResponseAsFile.prototype = $c_Lsttp_client3_ResponseAsFile.prototype;
$c_Lsttp_client3_ResponseAsFile.prototype.mapWithMetadata__F2__Lsttp_client3_ResponseAs = (function(f) {
  var showAs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  return new $c_Lsttp_client3_MappedResponseAs(this, f, showAs);
});
$c_Lsttp_client3_ResponseAsFile.prototype.showAs__T__Lsttp_client3_ResponseAs = (function(s) {
  return $f_Lsttp_client3_ResponseAs__showAs__T__Lsttp_client3_ResponseAs(this, s);
});
$c_Lsttp_client3_ResponseAsFile.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_client3_ResponseAsFile.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lsttp_client3_ResponseAsFile.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_client3_ResponseAsFile)) {
    var x = this.Lsttp_client3_ResponseAsFile__f_output;
    var x$2 = x$0.Lsttp_client3_ResponseAsFile__f_output;
    return (x === x$2);
  } else {
    return false;
  }
});
$c_Lsttp_client3_ResponseAsFile.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_client3_ResponseAsFile.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_client3_ResponseAsFile.prototype.productPrefix__T = (function() {
  return "ResponseAsFile";
});
$c_Lsttp_client3_ResponseAsFile.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_client3_ResponseAsFile__f_output;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_client3_ResponseAsFile.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "output";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_client3_ResponseAsFile(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_client3_ResponseAsFile)));
}
export { $isArrayOf_Lsttp_client3_ResponseAsFile as $isArrayOf_Lsttp_client3_ResponseAsFile };
var $d_Lsttp_client3_ResponseAsFile = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_ResponseAsFile, "sttp.client3.ResponseAsFile", ({
  Lsttp_client3_ResponseAsFile: 1,
  Lsttp_client3_ResponseAs: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_client3_ResponseAsFile as $d_Lsttp_client3_ResponseAsFile };
/** @constructor */
function $c_Lsttp_client3_ResponseAsFromMetadata(conditions, default$1) {
  this.Lsttp_client3_ResponseAsFromMetadata__f_conditions = null;
  this.Lsttp_client3_ResponseAsFromMetadata__f_default = null;
  this.Lsttp_client3_ResponseAsFromMetadata__f_conditions = conditions;
  this.Lsttp_client3_ResponseAsFromMetadata__f_default = default$1;
}
export { $c_Lsttp_client3_ResponseAsFromMetadata as $c_Lsttp_client3_ResponseAsFromMetadata };
$c_Lsttp_client3_ResponseAsFromMetadata.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_ResponseAsFromMetadata.prototype.constructor = $c_Lsttp_client3_ResponseAsFromMetadata;
/** @constructor */
function $h_Lsttp_client3_ResponseAsFromMetadata() {
}
export { $h_Lsttp_client3_ResponseAsFromMetadata as $h_Lsttp_client3_ResponseAsFromMetadata };
$h_Lsttp_client3_ResponseAsFromMetadata.prototype = $c_Lsttp_client3_ResponseAsFromMetadata.prototype;
$c_Lsttp_client3_ResponseAsFromMetadata.prototype.mapWithMetadata__F2__Lsttp_client3_ResponseAs = (function(f) {
  var showAs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  return new $c_Lsttp_client3_MappedResponseAs(this, f, showAs);
});
$c_Lsttp_client3_ResponseAsFromMetadata.prototype.showAs__T__Lsttp_client3_ResponseAs = (function(s) {
  return $f_Lsttp_client3_ResponseAs__showAs__T__Lsttp_client3_ResponseAs(this, s);
});
$c_Lsttp_client3_ResponseAsFromMetadata.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_client3_ResponseAsFromMetadata.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lsttp_client3_ResponseAsFromMetadata.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_client3_ResponseAsFromMetadata)) {
    var x = this.Lsttp_client3_ResponseAsFromMetadata__f_conditions;
    var x$2 = x$0.Lsttp_client3_ResponseAsFromMetadata__f_conditions;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lsttp_client3_ResponseAsFromMetadata__f_default;
      var x$4 = x$0.Lsttp_client3_ResponseAsFromMetadata__f_default;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_client3_ResponseAsFromMetadata.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_client3_ResponseAsFromMetadata.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsttp_client3_ResponseAsFromMetadata.prototype.productPrefix__T = (function() {
  return "ResponseAsFromMetadata";
});
$c_Lsttp_client3_ResponseAsFromMetadata.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_client3_ResponseAsFromMetadata__f_conditions;
  }
  if ((n === 1)) {
    return this.Lsttp_client3_ResponseAsFromMetadata__f_default;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_client3_ResponseAsFromMetadata.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "conditions";
  }
  if ((n === 1)) {
    return "default";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_client3_ResponseAsFromMetadata.prototype.apply__Lsttp_model_ResponseMetadata__Lsttp_client3_ResponseAs = (function(meta) {
  var this$1 = this.Lsttp_client3_ResponseAsFromMetadata__f_conditions;
  _return: {
    var these = this$1;
    while ((!these.isEmpty__Z())) {
      var x0 = these.head__O();
      if ((!(!x0.Lsttp_client3_ConditionalResponseAs__f_condition.apply__O__O(meta)))) {
        var this$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(these.head__O());
        break _return;
      }
      these = these.tail__O();
    }
    var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
  if (this$2.isEmpty__Z()) {
    var this$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0$1 = this$2.get__O();
    var this$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(x0$1.Lsttp_client3_ConditionalResponseAs__f_responseAs);
  }
  return (this$3.isEmpty__Z() ? this.Lsttp_client3_ResponseAsFromMetadata__f_default : this$3.get__O());
});
function $isArrayOf_Lsttp_client3_ResponseAsFromMetadata(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_client3_ResponseAsFromMetadata)));
}
export { $isArrayOf_Lsttp_client3_ResponseAsFromMetadata as $isArrayOf_Lsttp_client3_ResponseAsFromMetadata };
var $d_Lsttp_client3_ResponseAsFromMetadata = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_ResponseAsFromMetadata, "sttp.client3.ResponseAsFromMetadata", ({
  Lsttp_client3_ResponseAsFromMetadata: 1,
  Lsttp_client3_ResponseAs: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_client3_ResponseAsFromMetadata as $d_Lsttp_client3_ResponseAsFromMetadata };
function $isArrayOf_Lsttp_client3_ResponseAsStream(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_client3_ResponseAsStream)));
}
export { $isArrayOf_Lsttp_client3_ResponseAsStream as $isArrayOf_Lsttp_client3_ResponseAsStream };
/** @constructor */
function $c_Lsttp_client3_ResponseAsStreamUnsafe(s) {
  this.Lsttp_client3_ResponseAsStreamUnsafe__f_s = null;
  this.Lsttp_client3_ResponseAsStreamUnsafe__f_s = s;
}
export { $c_Lsttp_client3_ResponseAsStreamUnsafe as $c_Lsttp_client3_ResponseAsStreamUnsafe };
$c_Lsttp_client3_ResponseAsStreamUnsafe.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_ResponseAsStreamUnsafe.prototype.constructor = $c_Lsttp_client3_ResponseAsStreamUnsafe;
/** @constructor */
function $h_Lsttp_client3_ResponseAsStreamUnsafe() {
}
export { $h_Lsttp_client3_ResponseAsStreamUnsafe as $h_Lsttp_client3_ResponseAsStreamUnsafe };
$h_Lsttp_client3_ResponseAsStreamUnsafe.prototype = $c_Lsttp_client3_ResponseAsStreamUnsafe.prototype;
$c_Lsttp_client3_ResponseAsStreamUnsafe.prototype.mapWithMetadata__F2__Lsttp_client3_ResponseAs = (function(f) {
  var showAs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  return new $c_Lsttp_client3_MappedResponseAs(this, f, showAs);
});
$c_Lsttp_client3_ResponseAsStreamUnsafe.prototype.showAs__T__Lsttp_client3_ResponseAs = (function(s) {
  return $f_Lsttp_client3_ResponseAs__showAs__T__Lsttp_client3_ResponseAs(this, s);
});
$c_Lsttp_client3_ResponseAsStreamUnsafe.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_client3_ResponseAsStreamUnsafe.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lsttp_client3_ResponseAsStreamUnsafe.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_client3_ResponseAsStreamUnsafe)) {
    var x = this.Lsttp_client3_ResponseAsStreamUnsafe__f_s;
    var x$2 = x$0.Lsttp_client3_ResponseAsStreamUnsafe__f_s;
    return (x === x$2);
  } else {
    return false;
  }
});
$c_Lsttp_client3_ResponseAsStreamUnsafe.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_client3_ResponseAsStreamUnsafe.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_client3_ResponseAsStreamUnsafe.prototype.productPrefix__T = (function() {
  return "ResponseAsStreamUnsafe";
});
$c_Lsttp_client3_ResponseAsStreamUnsafe.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_client3_ResponseAsStreamUnsafe__f_s;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_client3_ResponseAsStreamUnsafe.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "s";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_client3_ResponseAsStreamUnsafe(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_client3_ResponseAsStreamUnsafe)));
}
export { $isArrayOf_Lsttp_client3_ResponseAsStreamUnsafe as $isArrayOf_Lsttp_client3_ResponseAsStreamUnsafe };
var $d_Lsttp_client3_ResponseAsStreamUnsafe = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_ResponseAsStreamUnsafe, "sttp.client3.ResponseAsStreamUnsafe", ({
  Lsttp_client3_ResponseAsStreamUnsafe: 1,
  Lsttp_client3_ResponseAs: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_client3_ResponseAsStreamUnsafe as $d_Lsttp_client3_ResponseAsStreamUnsafe };
/** @constructor */
function $c_Lsttp_client3_StreamBody(b) {
  this.Lsttp_client3_StreamBody__f_b = null;
  this.Lsttp_client3_StreamBody__f_b = b;
}
export { $c_Lsttp_client3_StreamBody as $c_Lsttp_client3_StreamBody };
$c_Lsttp_client3_StreamBody.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_StreamBody.prototype.constructor = $c_Lsttp_client3_StreamBody;
/** @constructor */
function $h_Lsttp_client3_StreamBody() {
}
export { $h_Lsttp_client3_StreamBody as $h_Lsttp_client3_StreamBody };
$h_Lsttp_client3_StreamBody.prototype = $c_Lsttp_client3_StreamBody.prototype;
$c_Lsttp_client3_StreamBody.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_client3_StreamBody.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lsttp_client3_StreamBody.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_client3_StreamBody)) {
    var x = this.Lsttp_client3_StreamBody__f_b;
    var y = x$0.Lsttp_client3_StreamBody__f_b;
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lsttp_client3_StreamBody.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_client3_StreamBody.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_client3_StreamBody.prototype.productPrefix__T = (function() {
  return "StreamBody";
});
$c_Lsttp_client3_StreamBody.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_client3_StreamBody__f_b;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_client3_StreamBody.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "b";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_client3_StreamBody.prototype.defaultContentType__Lsttp_model_MediaType = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_MediaType$().Lsttp_model_MediaType$__f_ApplicationOctetStream;
});
function $isArrayOf_Lsttp_client3_StreamBody(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_client3_StreamBody)));
}
export { $isArrayOf_Lsttp_client3_StreamBody as $isArrayOf_Lsttp_client3_StreamBody };
var $d_Lsttp_client3_StreamBody = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_StreamBody, "sttp.client3.StreamBody", ({
  Lsttp_client3_StreamBody: 1,
  Lsttp_client3_RequestBody: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_client3_StreamBody as $d_Lsttp_client3_StreamBody };
/** @constructor */
function $c_Lsttp_client3_SttpClientException$$anon$1(monadError$2, usingFn$2, outer) {
  this.Lsttp_client3_SttpClientException$$anon$1__f_monadError$1 = null;
  this.Lsttp_client3_SttpClientException$$anon$1__f_usingFn$1 = null;
  this.Lsttp_client3_SttpClientException$$anon$1__f_monadError$1 = monadError$2;
  this.Lsttp_client3_SttpClientException$$anon$1__f_usingFn$1 = usingFn$2;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lsttp_client3_SttpClientException$$anon$1 as $c_Lsttp_client3_SttpClientException$$anon$1 };
$c_Lsttp_client3_SttpClientException$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$c_Lsttp_client3_SttpClientException$$anon$1.prototype.constructor = $c_Lsttp_client3_SttpClientException$$anon$1;
/** @constructor */
function $h_Lsttp_client3_SttpClientException$$anon$1() {
}
export { $h_Lsttp_client3_SttpClientException$$anon$1 as $h_Lsttp_client3_SttpClientException$$anon$1 };
$h_Lsttp_client3_SttpClientException$$anon$1.prototype = $c_Lsttp_client3_SttpClientException$$anon$1.prototype;
$c_Lsttp_client3_SttpClientException$$anon$1.prototype.isDefinedAt__jl_Throwable__Z = (function(x) {
  return (x instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Exception);
});
$c_Lsttp_client3_SttpClientException$$anon$1.prototype.applyOrElse__jl_Throwable__F1__O = (function(x, default$1) {
  if ((x instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Exception)) {
    var $x_1 = this.Lsttp_client3_SttpClientException$$anon$1__f_monadError$1;
    var this$1 = this.Lsttp_client3_SttpClientException$$anon$1__f_usingFn$1.apply__O__O(x);
    return $x_1.error__jl_Throwable__O((this$1.isEmpty__Z() ? x : this$1.get__O()));
  } else {
    return default$1.apply__O__O(x);
  }
});
$c_Lsttp_client3_SttpClientException$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z(x);
});
$c_Lsttp_client3_SttpClientException$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__jl_Throwable__F1__O(x, default$1);
});
var $d_Lsttp_client3_SttpClientException$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_SttpClientException$$anon$1, "sttp.client3.SttpClientException$$anon$1", ({
  Lsttp_client3_SttpClientException$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_client3_SttpClientException$$anon$1 as $d_Lsttp_client3_SttpClientException$$anon$1 };
class $c_Lsttp_client3_SttpClientException$ConnectException extends $c_Lsttp_client3_SttpClientException {
  constructor(request, cause) {
    super();
    $ct_Lsttp_client3_SttpClientException__Lsttp_client3_RequestT__jl_Exception__(this, request, cause);
  }
}
export { $c_Lsttp_client3_SttpClientException$ConnectException as $c_Lsttp_client3_SttpClientException$ConnectException };
var $d_Lsttp_client3_SttpClientException$ConnectException = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_SttpClientException$ConnectException, "sttp.client3.SttpClientException$ConnectException", ({
  Lsttp_client3_SttpClientException$ConnectException: 1,
  Lsttp_client3_SttpClientException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_client3_SttpClientException$ConnectException as $d_Lsttp_client3_SttpClientException$ConnectException };
function $ct_Lsttp_client3_SttpClientException$ReadException__Lsttp_client3_RequestT__jl_Exception__($thiz, request, cause) {
  $ct_Lsttp_client3_SttpClientException__Lsttp_client3_RequestT__jl_Exception__($thiz, request, cause);
  return $thiz;
}
export { $ct_Lsttp_client3_SttpClientException$ReadException__Lsttp_client3_RequestT__jl_Exception__ as $ct_Lsttp_client3_SttpClientException$ReadException__Lsttp_client3_RequestT__jl_Exception__ };
class $c_Lsttp_client3_SttpClientException$ReadException extends $c_Lsttp_client3_SttpClientException {
}
export { $c_Lsttp_client3_SttpClientException$ReadException as $c_Lsttp_client3_SttpClientException$ReadException };
var $d_Lsttp_client3_SttpClientException$ReadException = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_SttpClientException$ReadException, "sttp.client3.SttpClientException$ReadException", ({
  Lsttp_client3_SttpClientException$ReadException: 1,
  Lsttp_client3_SttpClientException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_client3_SttpClientException$ReadException as $d_Lsttp_client3_SttpClientException$ReadException };
/** @constructor */
function $c_Lsttp_client3_internal_package$$anon$1(outer) {
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lsttp_client3_internal_package$$anon$1 as $c_Lsttp_client3_internal_package$$anon$1 };
$c_Lsttp_client3_internal_package$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$c_Lsttp_client3_internal_package$$anon$1.prototype.constructor = $c_Lsttp_client3_internal_package$$anon$1;
/** @constructor */
function $h_Lsttp_client3_internal_package$$anon$1() {
}
export { $h_Lsttp_client3_internal_package$$anon$1 as $h_Lsttp_client3_internal_package$$anon$1 };
$h_Lsttp_client3_internal_package$$anon$1.prototype = $c_Lsttp_client3_internal_package$$anon$1.prototype;
$c_Lsttp_client3_internal_package$$anon$1.prototype.isDefinedAt__T__Z = (function(x) {
  return ((!(!x.startsWith("charset="))) && ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__trim__T(x.substring(8)) !== ""));
});
$c_Lsttp_client3_internal_package$$anon$1.prototype.applyOrElse__T__F1__O = (function(x, default$1) {
  return (((!(!x.startsWith("charset="))) && ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__trim__T(x.substring(8)) !== "")) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__trim__T(x.substring(8)) : default$1.apply__O__O(x));
});
$c_Lsttp_client3_internal_package$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T__Z(x);
});
$c_Lsttp_client3_internal_package$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T__F1__O(x, default$1);
});
var $d_Lsttp_client3_internal_package$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_internal_package$$anon$1, "sttp.client3.internal.package$$anon$1", ({
  Lsttp_client3_internal_package$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_client3_internal_package$$anon$1 as $d_Lsttp_client3_internal_package$$anon$1 };
/** @constructor */
function $c_Lsttp_client3_internal_ws_WebSocketEvent$Error(t) {
  this.Lsttp_client3_internal_ws_WebSocketEvent$Error__f_t = null;
  this.Lsttp_client3_internal_ws_WebSocketEvent$Error__f_t = t;
}
export { $c_Lsttp_client3_internal_ws_WebSocketEvent$Error as $c_Lsttp_client3_internal_ws_WebSocketEvent$Error };
$c_Lsttp_client3_internal_ws_WebSocketEvent$Error.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_internal_ws_WebSocketEvent$Error.prototype.constructor = $c_Lsttp_client3_internal_ws_WebSocketEvent$Error;
/** @constructor */
function $h_Lsttp_client3_internal_ws_WebSocketEvent$Error() {
}
export { $h_Lsttp_client3_internal_ws_WebSocketEvent$Error as $h_Lsttp_client3_internal_ws_WebSocketEvent$Error };
$h_Lsttp_client3_internal_ws_WebSocketEvent$Error.prototype = $c_Lsttp_client3_internal_ws_WebSocketEvent$Error.prototype;
$c_Lsttp_client3_internal_ws_WebSocketEvent$Error.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_client3_internal_ws_WebSocketEvent$Error.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lsttp_client3_internal_ws_WebSocketEvent$Error.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_client3_internal_ws_WebSocketEvent$Error)) {
    var x = this.Lsttp_client3_internal_ws_WebSocketEvent$Error__f_t;
    var x$2 = x$0.Lsttp_client3_internal_ws_WebSocketEvent$Error__f_t;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lsttp_client3_internal_ws_WebSocketEvent$Error.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_client3_internal_ws_WebSocketEvent$Error.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_client3_internal_ws_WebSocketEvent$Error.prototype.productPrefix__T = (function() {
  return "Error";
});
$c_Lsttp_client3_internal_ws_WebSocketEvent$Error.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_client3_internal_ws_WebSocketEvent$Error__f_t;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_client3_internal_ws_WebSocketEvent$Error.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "t";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_client3_internal_ws_WebSocketEvent$Error(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_client3_internal_ws_WebSocketEvent$Error)));
}
export { $isArrayOf_Lsttp_client3_internal_ws_WebSocketEvent$Error as $isArrayOf_Lsttp_client3_internal_ws_WebSocketEvent$Error };
var $d_Lsttp_client3_internal_ws_WebSocketEvent$Error = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_internal_ws_WebSocketEvent$Error, "sttp.client3.internal.ws.WebSocketEvent$Error", ({
  Lsttp_client3_internal_ws_WebSocketEvent$Error: 1,
  Lsttp_client3_internal_ws_WebSocketEvent: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_client3_internal_ws_WebSocketEvent$Error as $d_Lsttp_client3_internal_ws_WebSocketEvent$Error };
/** @constructor */
function $c_Lsttp_client3_internal_ws_WebSocketEvent$Frame(f) {
  this.Lsttp_client3_internal_ws_WebSocketEvent$Frame__f_f = null;
  this.Lsttp_client3_internal_ws_WebSocketEvent$Frame__f_f = f;
}
export { $c_Lsttp_client3_internal_ws_WebSocketEvent$Frame as $c_Lsttp_client3_internal_ws_WebSocketEvent$Frame };
$c_Lsttp_client3_internal_ws_WebSocketEvent$Frame.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_internal_ws_WebSocketEvent$Frame.prototype.constructor = $c_Lsttp_client3_internal_ws_WebSocketEvent$Frame;
/** @constructor */
function $h_Lsttp_client3_internal_ws_WebSocketEvent$Frame() {
}
export { $h_Lsttp_client3_internal_ws_WebSocketEvent$Frame as $h_Lsttp_client3_internal_ws_WebSocketEvent$Frame };
$h_Lsttp_client3_internal_ws_WebSocketEvent$Frame.prototype = $c_Lsttp_client3_internal_ws_WebSocketEvent$Frame.prototype;
$c_Lsttp_client3_internal_ws_WebSocketEvent$Frame.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_client3_internal_ws_WebSocketEvent$Frame.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lsttp_client3_internal_ws_WebSocketEvent$Frame.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_client3_internal_ws_WebSocketEvent$Frame)) {
    var x = this.Lsttp_client3_internal_ws_WebSocketEvent$Frame__f_f;
    var x$2 = x$0.Lsttp_client3_internal_ws_WebSocketEvent$Frame__f_f;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lsttp_client3_internal_ws_WebSocketEvent$Frame.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_client3_internal_ws_WebSocketEvent$Frame.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_client3_internal_ws_WebSocketEvent$Frame.prototype.productPrefix__T = (function() {
  return "Frame";
});
$c_Lsttp_client3_internal_ws_WebSocketEvent$Frame.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_client3_internal_ws_WebSocketEvent$Frame__f_f;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_client3_internal_ws_WebSocketEvent$Frame.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "f";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_client3_internal_ws_WebSocketEvent$Frame(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_client3_internal_ws_WebSocketEvent$Frame)));
}
export { $isArrayOf_Lsttp_client3_internal_ws_WebSocketEvent$Frame as $isArrayOf_Lsttp_client3_internal_ws_WebSocketEvent$Frame };
var $d_Lsttp_client3_internal_ws_WebSocketEvent$Frame = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_internal_ws_WebSocketEvent$Frame, "sttp.client3.internal.ws.WebSocketEvent$Frame", ({
  Lsttp_client3_internal_ws_WebSocketEvent$Frame: 1,
  Lsttp_client3_internal_ws_WebSocketEvent: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_client3_internal_ws_WebSocketEvent$Frame as $d_Lsttp_client3_internal_ws_WebSocketEvent$Frame };
/** @constructor */
function $c_Lsttp_client3_internal_ws_WebSocketEvent$Open() {
}
export { $c_Lsttp_client3_internal_ws_WebSocketEvent$Open as $c_Lsttp_client3_internal_ws_WebSocketEvent$Open };
$c_Lsttp_client3_internal_ws_WebSocketEvent$Open.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_internal_ws_WebSocketEvent$Open.prototype.constructor = $c_Lsttp_client3_internal_ws_WebSocketEvent$Open;
/** @constructor */
function $h_Lsttp_client3_internal_ws_WebSocketEvent$Open() {
}
export { $h_Lsttp_client3_internal_ws_WebSocketEvent$Open as $h_Lsttp_client3_internal_ws_WebSocketEvent$Open };
$h_Lsttp_client3_internal_ws_WebSocketEvent$Open.prototype = $c_Lsttp_client3_internal_ws_WebSocketEvent$Open.prototype;
$c_Lsttp_client3_internal_ws_WebSocketEvent$Open.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_client3_internal_ws_WebSocketEvent$Open.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lsttp_client3_internal_ws_WebSocketEvent$Open.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || (x$0 instanceof $c_Lsttp_client3_internal_ws_WebSocketEvent$Open));
});
$c_Lsttp_client3_internal_ws_WebSocketEvent$Open.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_client3_internal_ws_WebSocketEvent$Open.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_client3_internal_ws_WebSocketEvent$Open.prototype.productPrefix__T = (function() {
  return "Open";
});
$c_Lsttp_client3_internal_ws_WebSocketEvent$Open.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_client3_internal_ws_WebSocketEvent$Open.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_client3_internal_ws_WebSocketEvent$Open(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_client3_internal_ws_WebSocketEvent$Open)));
}
export { $isArrayOf_Lsttp_client3_internal_ws_WebSocketEvent$Open as $isArrayOf_Lsttp_client3_internal_ws_WebSocketEvent$Open };
var $d_Lsttp_client3_internal_ws_WebSocketEvent$Open = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_internal_ws_WebSocketEvent$Open, "sttp.client3.internal.ws.WebSocketEvent$Open", ({
  Lsttp_client3_internal_ws_WebSocketEvent$Open: 1,
  Lsttp_client3_internal_ws_WebSocketEvent: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_client3_internal_ws_WebSocketEvent$Open as $d_Lsttp_client3_internal_ws_WebSocketEvent$Open };
/** @constructor */
function $c_Lsttp_model_Headers(headers) {
  this.Lsttp_model_Headers__f_headers = null;
  this.Lsttp_model_Headers__f_headers = headers;
}
export { $c_Lsttp_model_Headers as $c_Lsttp_model_Headers };
$c_Lsttp_model_Headers.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_model_Headers.prototype.constructor = $c_Lsttp_model_Headers;
/** @constructor */
function $h_Lsttp_model_Headers() {
}
export { $h_Lsttp_model_Headers as $h_Lsttp_model_Headers };
$h_Lsttp_model_Headers.prototype = $c_Lsttp_model_Headers.prototype;
$c_Lsttp_model_Headers.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_model_Headers.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-712044112), true);
});
$c_Lsttp_model_Headers.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_model_Headers)) {
    var x = this.Lsttp_model_Headers__f_headers;
    var x$2 = x$0.Lsttp_model_Headers__f_headers;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lsttp_model_Headers.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_model_Headers.prototype.productPrefix__T = (function() {
  return "Headers";
});
$c_Lsttp_model_Headers.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_model_Headers__f_headers;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_Headers.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "headers";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_Headers.prototype.headers__sci_Seq = (function() {
  return this.Lsttp_model_Headers__f_headers;
});
$c_Lsttp_model_Headers.prototype.toString__T = (function() {
  return (("Headers(" + $m_Lsttp_model_Headers$().toStringSafe__sci_Seq__sci_Set__sci_Seq(this.Lsttp_model_Headers__f_headers, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_SensitiveHeaders)) + ")");
});
function $isArrayOf_Lsttp_model_Headers(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_model_Headers)));
}
export { $isArrayOf_Lsttp_model_Headers as $isArrayOf_Lsttp_model_Headers };
var $d_Lsttp_model_Headers = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_model_Headers, "sttp.model.Headers", ({
  Lsttp_model_Headers: 1,
  Lsttp_model_HasHeaders: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_model_Headers as $d_Lsttp_model_Headers };
/** @constructor */
function $c_Lsttp_tapir_CodecFormat$Json() {
  this.Lsttp_tapir_CodecFormat$Json__f_mediaType = null;
  this.Lsttp_tapir_CodecFormat$Json__f_mediaType = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_MediaType$().Lsttp_model_MediaType$__f_ApplicationJson;
}
export { $c_Lsttp_tapir_CodecFormat$Json as $c_Lsttp_tapir_CodecFormat$Json };
$c_Lsttp_tapir_CodecFormat$Json.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_CodecFormat$Json.prototype.constructor = $c_Lsttp_tapir_CodecFormat$Json;
/** @constructor */
function $h_Lsttp_tapir_CodecFormat$Json() {
}
export { $h_Lsttp_tapir_CodecFormat$Json as $h_Lsttp_tapir_CodecFormat$Json };
$h_Lsttp_tapir_CodecFormat$Json.prototype = $c_Lsttp_tapir_CodecFormat$Json.prototype;
$c_Lsttp_tapir_CodecFormat$Json.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_CodecFormat$Json.prototype.hashCode__I = (function() {
  return 2318600;
});
$c_Lsttp_tapir_CodecFormat$Json.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || (x$0 instanceof $c_Lsttp_tapir_CodecFormat$Json));
});
$c_Lsttp_tapir_CodecFormat$Json.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_CodecFormat$Json.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_tapir_CodecFormat$Json.prototype.productPrefix__T = (function() {
  return "Json";
});
$c_Lsttp_tapir_CodecFormat$Json.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_CodecFormat$Json.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_CodecFormat$Json.prototype.mediaType__Lsttp_model_MediaType = (function() {
  return this.Lsttp_tapir_CodecFormat$Json__f_mediaType;
});
function $isArrayOf_Lsttp_tapir_CodecFormat$Json(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_CodecFormat$Json)));
}
export { $isArrayOf_Lsttp_tapir_CodecFormat$Json as $isArrayOf_Lsttp_tapir_CodecFormat$Json };
var $d_Lsttp_tapir_CodecFormat$Json = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_CodecFormat$Json, "sttp.tapir.CodecFormat$Json", ({
  Lsttp_tapir_CodecFormat$Json: 1,
  Lsttp_tapir_CodecFormat: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_CodecFormat$Json as $d_Lsttp_tapir_CodecFormat$Json };
/** @constructor */
function $c_Lsttp_tapir_CodecFormat$TextHtml() {
  this.Lsttp_tapir_CodecFormat$TextHtml__f_mediaType = null;
  this.Lsttp_tapir_CodecFormat$TextHtml__f_mediaType = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_MediaType$().Lsttp_model_MediaType$__f_TextHtml;
}
export { $c_Lsttp_tapir_CodecFormat$TextHtml as $c_Lsttp_tapir_CodecFormat$TextHtml };
$c_Lsttp_tapir_CodecFormat$TextHtml.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_CodecFormat$TextHtml.prototype.constructor = $c_Lsttp_tapir_CodecFormat$TextHtml;
/** @constructor */
function $h_Lsttp_tapir_CodecFormat$TextHtml() {
}
export { $h_Lsttp_tapir_CodecFormat$TextHtml as $h_Lsttp_tapir_CodecFormat$TextHtml };
$h_Lsttp_tapir_CodecFormat$TextHtml.prototype = $c_Lsttp_tapir_CodecFormat$TextHtml.prototype;
$c_Lsttp_tapir_CodecFormat$TextHtml.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_CodecFormat$TextHtml.prototype.hashCode__I = (function() {
  return (-939342184);
});
$c_Lsttp_tapir_CodecFormat$TextHtml.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || (x$0 instanceof $c_Lsttp_tapir_CodecFormat$TextHtml));
});
$c_Lsttp_tapir_CodecFormat$TextHtml.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_CodecFormat$TextHtml.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_tapir_CodecFormat$TextHtml.prototype.productPrefix__T = (function() {
  return "TextHtml";
});
$c_Lsttp_tapir_CodecFormat$TextHtml.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_CodecFormat$TextHtml.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_CodecFormat$TextHtml.prototype.mediaType__Lsttp_model_MediaType = (function() {
  return this.Lsttp_tapir_CodecFormat$TextHtml__f_mediaType;
});
function $isArrayOf_Lsttp_tapir_CodecFormat$TextHtml(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_CodecFormat$TextHtml)));
}
export { $isArrayOf_Lsttp_tapir_CodecFormat$TextHtml as $isArrayOf_Lsttp_tapir_CodecFormat$TextHtml };
var $d_Lsttp_tapir_CodecFormat$TextHtml = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_CodecFormat$TextHtml, "sttp.tapir.CodecFormat$TextHtml", ({
  Lsttp_tapir_CodecFormat$TextHtml: 1,
  Lsttp_tapir_CodecFormat: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_CodecFormat$TextHtml as $d_Lsttp_tapir_CodecFormat$TextHtml };
/** @constructor */
function $c_Lsttp_tapir_EndpointIO$Info$$anon$2() {
}
export { $c_Lsttp_tapir_EndpointIO$Info$$anon$2 as $c_Lsttp_tapir_EndpointIO$Info$$anon$2 };
$c_Lsttp_tapir_EndpointIO$Info$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$c_Lsttp_tapir_EndpointIO$Info$$anon$2.prototype.constructor = $c_Lsttp_tapir_EndpointIO$Info$$anon$2;
/** @constructor */
function $h_Lsttp_tapir_EndpointIO$Info$$anon$2() {
}
export { $h_Lsttp_tapir_EndpointIO$Info$$anon$2 as $h_Lsttp_tapir_EndpointIO$Info$$anon$2 };
$h_Lsttp_tapir_EndpointIO$Info$$anon$2.prototype = $c_Lsttp_tapir_EndpointIO$Info$$anon$2.prototype;
$c_Lsttp_tapir_EndpointIO$Info$$anon$2.prototype.isDefinedAt__Lsttp_tapir_EndpointIO$Example__Z = (function(x) {
  if ((x !== null)) {
    var x204 = x.Lsttp_tapir_EndpointIO$Example__f_value;
    if ((x204 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_DecodeResult$Value)) {
      return true;
    }
  }
  return false;
});
$c_Lsttp_tapir_EndpointIO$Info$$anon$2.prototype.applyOrElse__Lsttp_tapir_EndpointIO$Example__F1__O = (function(x, default$1) {
  if ((x !== null)) {
    var x213 = x.Lsttp_tapir_EndpointIO$Example__f_value;
    var x214 = x.Lsttp_tapir_EndpointIO$Example__f_name;
    var x215 = x.Lsttp_tapir_EndpointIO$Example__f_summary;
    var x216 = x.Lsttp_tapir_EndpointIO$Example__f_description;
    if ((x213 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_DecodeResult$Value)) {
      var x219 = x213.Lsttp_tapir_DecodeResult$Value__f_v;
      return new $c_Lsttp_tapir_EndpointIO$Example(x219, x214, x215, x216);
    }
  }
  return default$1.apply__O__O(x);
});
$c_Lsttp_tapir_EndpointIO$Info$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lsttp_tapir_EndpointIO$Example__Z(x);
});
$c_Lsttp_tapir_EndpointIO$Info$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lsttp_tapir_EndpointIO$Example__F1__O(x, default$1);
});
var $d_Lsttp_tapir_EndpointIO$Info$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_EndpointIO$Info$$anon$2, "sttp.tapir.EndpointIO$Info$$anon$2", ({
  Lsttp_tapir_EndpointIO$Info$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_EndpointIO$Info$$anon$2 as $d_Lsttp_tapir_EndpointIO$Info$$anon$2 };
/** @constructor */
function $c_Lsttp_tapir_EndpointInput$AuthType$ApiKey() {
}
export { $c_Lsttp_tapir_EndpointInput$AuthType$ApiKey as $c_Lsttp_tapir_EndpointInput$AuthType$ApiKey };
$c_Lsttp_tapir_EndpointInput$AuthType$ApiKey.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_EndpointInput$AuthType$ApiKey.prototype.constructor = $c_Lsttp_tapir_EndpointInput$AuthType$ApiKey;
/** @constructor */
function $h_Lsttp_tapir_EndpointInput$AuthType$ApiKey() {
}
export { $h_Lsttp_tapir_EndpointInput$AuthType$ApiKey as $h_Lsttp_tapir_EndpointInput$AuthType$ApiKey };
$h_Lsttp_tapir_EndpointInput$AuthType$ApiKey.prototype = $c_Lsttp_tapir_EndpointInput$AuthType$ApiKey.prototype;
$c_Lsttp_tapir_EndpointInput$AuthType$ApiKey.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_EndpointInput$AuthType$ApiKey.prototype.hashCode__I = (function() {
  return 1967532549;
});
$c_Lsttp_tapir_EndpointInput$AuthType$ApiKey.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || (x$0 instanceof $c_Lsttp_tapir_EndpointInput$AuthType$ApiKey));
});
$c_Lsttp_tapir_EndpointInput$AuthType$ApiKey.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_EndpointInput$AuthType$ApiKey.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_tapir_EndpointInput$AuthType$ApiKey.prototype.productPrefix__T = (function() {
  return "ApiKey";
});
$c_Lsttp_tapir_EndpointInput$AuthType$ApiKey.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_EndpointInput$AuthType$ApiKey.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_tapir_EndpointInput$AuthType$ApiKey(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointInput$AuthType$ApiKey)));
}
export { $isArrayOf_Lsttp_tapir_EndpointInput$AuthType$ApiKey as $isArrayOf_Lsttp_tapir_EndpointInput$AuthType$ApiKey };
var $d_Lsttp_tapir_EndpointInput$AuthType$ApiKey = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_EndpointInput$AuthType$ApiKey, "sttp.tapir.EndpointInput$AuthType$ApiKey", ({
  Lsttp_tapir_EndpointInput$AuthType$ApiKey: 1,
  Lsttp_tapir_EndpointInput$AuthType: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_EndpointInput$AuthType$ApiKey as $d_Lsttp_tapir_EndpointInput$AuthType$ApiKey };
/** @constructor */
function $c_Lsttp_tapir_EndpointInput$AuthType$Http(scheme) {
  this.Lsttp_tapir_EndpointInput$AuthType$Http__f_scheme = null;
  this.Lsttp_tapir_EndpointInput$AuthType$Http__f_scheme = scheme;
}
export { $c_Lsttp_tapir_EndpointInput$AuthType$Http as $c_Lsttp_tapir_EndpointInput$AuthType$Http };
$c_Lsttp_tapir_EndpointInput$AuthType$Http.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_EndpointInput$AuthType$Http.prototype.constructor = $c_Lsttp_tapir_EndpointInput$AuthType$Http;
/** @constructor */
function $h_Lsttp_tapir_EndpointInput$AuthType$Http() {
}
export { $h_Lsttp_tapir_EndpointInput$AuthType$Http as $h_Lsttp_tapir_EndpointInput$AuthType$Http };
$h_Lsttp_tapir_EndpointInput$AuthType$Http.prototype = $c_Lsttp_tapir_EndpointInput$AuthType$Http.prototype;
$c_Lsttp_tapir_EndpointInput$AuthType$Http.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_EndpointInput$AuthType$Http.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1858646754, true);
});
$c_Lsttp_tapir_EndpointInput$AuthType$Http.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lsttp_tapir_EndpointInput$AuthType$Http) && (this.Lsttp_tapir_EndpointInput$AuthType$Http__f_scheme === x$0.Lsttp_tapir_EndpointInput$AuthType$Http__f_scheme)));
});
$c_Lsttp_tapir_EndpointInput$AuthType$Http.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_EndpointInput$AuthType$Http.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_tapir_EndpointInput$AuthType$Http.prototype.productPrefix__T = (function() {
  return "Http";
});
$c_Lsttp_tapir_EndpointInput$AuthType$Http.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_EndpointInput$AuthType$Http__f_scheme;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_EndpointInput$AuthType$Http.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "scheme";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_tapir_EndpointInput$AuthType$Http(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointInput$AuthType$Http)));
}
export { $isArrayOf_Lsttp_tapir_EndpointInput$AuthType$Http as $isArrayOf_Lsttp_tapir_EndpointInput$AuthType$Http };
var $d_Lsttp_tapir_EndpointInput$AuthType$Http = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_EndpointInput$AuthType$Http, "sttp.tapir.EndpointInput$AuthType$Http", ({
  Lsttp_tapir_EndpointInput$AuthType$Http: 1,
  Lsttp_tapir_EndpointInput$AuthType: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_EndpointInput$AuthType$Http as $d_Lsttp_tapir_EndpointInput$AuthType$Http };
/** @constructor */
function $c_Lsttp_tapir_EndpointInput$Query$$anon$1() {
}
export { $c_Lsttp_tapir_EndpointInput$Query$$anon$1 as $c_Lsttp_tapir_EndpointInput$Query$$anon$1 };
$c_Lsttp_tapir_EndpointInput$Query$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$c_Lsttp_tapir_EndpointInput$Query$$anon$1.prototype.constructor = $c_Lsttp_tapir_EndpointInput$Query$$anon$1;
/** @constructor */
function $h_Lsttp_tapir_EndpointInput$Query$$anon$1() {
}
export { $h_Lsttp_tapir_EndpointInput$Query$$anon$1 as $h_Lsttp_tapir_EndpointInput$Query$$anon$1 };
$h_Lsttp_tapir_EndpointInput$Query$$anon$1.prototype = $c_Lsttp_tapir_EndpointInput$Query$$anon$1.prototype;
$c_Lsttp_tapir_EndpointInput$Query$$anon$1.prototype.isDefinedAt__Lsttp_tapir_DecodeResult__Z = (function(x) {
  return (x instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_DecodeResult$Value);
});
$c_Lsttp_tapir_EndpointInput$Query$$anon$1.prototype.applyOrElse__Lsttp_tapir_DecodeResult__F1__O = (function(x, default$1) {
  if ((x instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_DecodeResult$Value)) {
    var x36 = x.Lsttp_tapir_DecodeResult$Value__f_v;
    return x36;
  } else {
    return default$1.apply__O__O(x);
  }
});
$c_Lsttp_tapir_EndpointInput$Query$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lsttp_tapir_DecodeResult__Z(x);
});
$c_Lsttp_tapir_EndpointInput$Query$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lsttp_tapir_DecodeResult__F1__O(x, default$1);
});
var $d_Lsttp_tapir_EndpointInput$Query$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_EndpointInput$Query$$anon$1, "sttp.tapir.EndpointInput$Query$$anon$1", ({
  Lsttp_tapir_EndpointInput$Query$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_EndpointInput$Query$$anon$1 as $d_Lsttp_tapir_EndpointInput$Query$$anon$1 };
/** @constructor */
function $c_Lsttp_tapir_client_ClientOutputParams$$anon$1(content$2) {
  this.Lsttp_tapir_client_ClientOutputParams$$anon$1__f_content$1 = null;
  this.Lsttp_tapir_client_ClientOutputParams$$anon$1__f_content$1 = content$2;
}
export { $c_Lsttp_tapir_client_ClientOutputParams$$anon$1 as $c_Lsttp_tapir_client_ClientOutputParams$$anon$1 };
$c_Lsttp_tapir_client_ClientOutputParams$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$c_Lsttp_tapir_client_ClientOutputParams$$anon$1.prototype.constructor = $c_Lsttp_tapir_client_ClientOutputParams$$anon$1;
/** @constructor */
function $h_Lsttp_tapir_client_ClientOutputParams$$anon$1() {
}
export { $h_Lsttp_tapir_client_ClientOutputParams$$anon$1 as $h_Lsttp_tapir_client_ClientOutputParams$$anon$1 };
$h_Lsttp_tapir_client_ClientOutputParams$$anon$1.prototype = $c_Lsttp_tapir_client_ClientOutputParams$$anon$1.prototype;
$c_Lsttp_tapir_client_ClientOutputParams$$anon$1.prototype.isDefinedAt__Lsttp_tapir_EndpointOutput$OneOfVariant__Z = (function(x) {
  var output = x.output__Lsttp_tapir_EndpointOutput();
  return new $c_Lsttp_tapir_internal_package$RichEndpointOutput(output).hasOptionalBodyMatchingContent__Lsttp_model_MediaType__Z(this.Lsttp_tapir_client_ClientOutputParams$$anon$1__f_content$1);
});
$c_Lsttp_tapir_client_ClientOutputParams$$anon$1.prototype.applyOrElse__Lsttp_tapir_EndpointOutput$OneOfVariant__F1__O = (function(x, default$1) {
  var output = x.output__Lsttp_tapir_EndpointOutput();
  if (new $c_Lsttp_tapir_internal_package$RichEndpointOutput(output).hasOptionalBodyMatchingContent__Lsttp_model_MediaType__Z(this.Lsttp_tapir_client_ClientOutputParams$$anon$1__f_content$1)) {
    return x;
  } else {
    return default$1.apply__O__O(x);
  }
});
$c_Lsttp_tapir_client_ClientOutputParams$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lsttp_tapir_EndpointOutput$OneOfVariant__Z(x);
});
$c_Lsttp_tapir_client_ClientOutputParams$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lsttp_tapir_EndpointOutput$OneOfVariant__F1__O(x, default$1);
});
var $d_Lsttp_tapir_client_ClientOutputParams$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_client_ClientOutputParams$$anon$1, "sttp.tapir.client.ClientOutputParams$$anon$1", ({
  Lsttp_tapir_client_ClientOutputParams$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_client_ClientOutputParams$$anon$1 as $d_Lsttp_tapir_client_ClientOutputParams$$anon$1 };
/** @constructor */
function $c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$2() {
}
export { $c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$2 as $c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$2 };
$c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$2.prototype.constructor = $c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$2;
/** @constructor */
function $h_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$2() {
}
export { $h_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$2 as $h_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$2 };
$h_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$2.prototype = $c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$2.prototype;
$c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$2.prototype.isDefinedAt__Lsttp_tapir_EndpointOutput__Z = (function(x) {
  if (false) {
    var x211 = x.Lsttp_tapir_EndpointIO$StreamBodyWrapper__f_wrapped;
    if ((x211 !== null)) {
      return true;
    }
  }
  if (false) {
    return true;
  }
  return false;
});
$c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$2.prototype.applyOrElse__Lsttp_tapir_EndpointOutput__F1__O = (function(x, default$1) {
  if (false) {
    var x226 = x.Lsttp_tapir_EndpointIO$StreamBodyWrapper__f_wrapped;
    if ((x226 !== null)) {
      var x229 = x226.Lsttp_tapir_StreamBodyIO__f_streams;
      var this$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
      var elems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lsttp_capabilities_package$Streams.getArrayOf().constr)([x229]));
      return this$3.from__sc_IterableOnce__sci_Vector(elems);
    }
  }
  if (false) {
    var x222 = x.Lsttp_tapir_EndpointIO$OneOfBody__f_variants;
    var rest = x222;
    var h = null;
    var t = null;
    while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
      var x0 = rest.head__O();
      var it = x0.Lsttp_tapir_EndpointIO$OneOfBodyVariant__f_body.toOption__s_Option().iterator__sc_Iterator();
      while (it.hasNext__Z()) {
        var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(it.next__O(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
        if ((t === null)) {
          h = nx;
        } else {
          t.sci_$colon$colon__f_next = nx;
        }
        t = nx;
      }
      rest = rest.tail__O();
    }
    var this$5 = ((h === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$() : h);
    var f = ((_$4) => _$4.Lsttp_tapir_EndpointIO$StreamBodyWrapper__f_wrapped.Lsttp_tapir_StreamBodyIO__f_streams);
    if ((this$5 === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
      var this$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    } else {
      var x0$1 = this$5.head__O();
      var h$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0$1), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      var t$1 = h$1;
      var rest$1 = this$5.tail__O();
      while ((rest$1 !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
        var x0$2 = rest$1.head__O();
        var nx$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0$2), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
        t$1.sci_$colon$colon__f_next = nx$1;
        t$1 = nx$1;
        rest$1 = rest$1.tail__O();
      }
      var this$6 = h$1;
    }
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$6);
  }
  return default$1.apply__O__O(x);
});
$c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lsttp_tapir_EndpointOutput__Z(x);
});
$c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lsttp_tapir_EndpointOutput__F1__O(x, default$1);
});
var $d_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$2, "sttp.tapir.client.sttp.EndpointToSttpClient$$anon$2", ({
  Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$2 as $d_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$2 };
/** @constructor */
function $c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$3() {
}
export { $c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$3 as $c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$3 };
$c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$3.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$3.prototype.constructor = $c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$3;
/** @constructor */
function $h_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$3() {
}
export { $h_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$3 as $h_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$3 };
$h_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$3.prototype = $c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$3.prototype;
$c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$3.prototype.isDefinedAt__Lsttp_tapir_EndpointOutput__Z = (function(x) {
  return (x instanceof $c_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper);
});
$c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$3.prototype.applyOrElse__Lsttp_tapir_EndpointOutput__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper)) {
    var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
    var elems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapUnitArray__Ajl_Void__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_jl_Void.getArrayOf().constr)([(void 0)]));
    return this$2.from__sc_IterableOnce__sci_Vector(elems);
  } else {
    return default$1.apply__O__O(x);
  }
});
$c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$3.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lsttp_tapir_EndpointOutput__Z(x);
});
$c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$3.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lsttp_tapir_EndpointOutput__F1__O(x, default$1);
});
var $d_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$3, "sttp.tapir.client.sttp.EndpointToSttpClient$$anon$3", ({
  Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$3: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$3 as $d_Lsttp_tapir_client_sttp_EndpointToSttpClient$$anon$3 };
/** @constructor */
function $c_Lsttp_tapir_internal_package$RichEndpointInput$$anon$2(includeAuth$2) {
  this.Lsttp_tapir_internal_package$RichEndpointInput$$anon$2__f_includeAuth$1 = false;
  this.Lsttp_tapir_internal_package$RichEndpointInput$$anon$2__f_includeAuth$1 = includeAuth$2;
}
export { $c_Lsttp_tapir_internal_package$RichEndpointInput$$anon$2 as $c_Lsttp_tapir_internal_package$RichEndpointInput$$anon$2 };
$c_Lsttp_tapir_internal_package$RichEndpointInput$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$c_Lsttp_tapir_internal_package$RichEndpointInput$$anon$2.prototype.constructor = $c_Lsttp_tapir_internal_package$RichEndpointInput$$anon$2;
/** @constructor */
function $h_Lsttp_tapir_internal_package$RichEndpointInput$$anon$2() {
}
export { $h_Lsttp_tapir_internal_package$RichEndpointInput$$anon$2 as $h_Lsttp_tapir_internal_package$RichEndpointInput$$anon$2 };
$h_Lsttp_tapir_internal_package$RichEndpointInput$$anon$2.prototype = $c_Lsttp_tapir_internal_package$RichEndpointInput$$anon$2.prototype;
$c_Lsttp_tapir_internal_package$RichEndpointInput$$anon$2.prototype.isDefinedAt__Lsttp_tapir_EndpointInput__Z = (function(x) {
  return ($is_Lsttp_tapir_EndpointInput$Basic(x) || (x instanceof $c_Lsttp_tapir_EndpointInput$Auth));
});
$c_Lsttp_tapir_internal_package$RichEndpointInput$$anon$2.prototype.applyOrElse__Lsttp_tapir_EndpointInput__F1__O = (function(x, default$1) {
  if ($is_Lsttp_tapir_EndpointInput$Basic(x)) {
    var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
    var elems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lsttp_tapir_EndpointInput$Basic.getArrayOf().constr)([x]));
    return this$1.from__sc_IterableOnce__sci_Vector(elems);
  } else if ((x instanceof $c_Lsttp_tapir_EndpointInput$Auth)) {
    if (this.Lsttp_tapir_internal_package$RichEndpointInput$$anon$2__f_includeAuth$1) {
      var input = x.Lsttp_tapir_EndpointInput$Auth__f_input;
      return new $c_Lsttp_tapir_internal_package$RichEndpointInput(input).asVectorOfBasicInputs__Z__sci_Vector(this.Lsttp_tapir_internal_package$RichEndpointInput$$anon$2__f_includeAuth$1);
    } else {
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector0$();
    }
  } else {
    return default$1.apply__O__O(x);
  }
});
$c_Lsttp_tapir_internal_package$RichEndpointInput$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lsttp_tapir_EndpointInput__Z(x);
});
$c_Lsttp_tapir_internal_package$RichEndpointInput$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lsttp_tapir_EndpointInput__F1__O(x, default$1);
});
var $d_Lsttp_tapir_internal_package$RichEndpointInput$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_internal_package$RichEndpointInput$$anon$2, "sttp.tapir.internal.package$RichEndpointInput$$anon$2", ({
  Lsttp_tapir_internal_package$RichEndpointInput$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_internal_package$RichEndpointInput$$anon$2 as $d_Lsttp_tapir_internal_package$RichEndpointInput$$anon$2 };
/** @constructor */
function $c_Lsttp_tapir_internal_package$RichEndpointInput$$anon$3() {
}
export { $c_Lsttp_tapir_internal_package$RichEndpointInput$$anon$3 as $c_Lsttp_tapir_internal_package$RichEndpointInput$$anon$3 };
$c_Lsttp_tapir_internal_package$RichEndpointInput$$anon$3.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$c_Lsttp_tapir_internal_package$RichEndpointInput$$anon$3.prototype.constructor = $c_Lsttp_tapir_internal_package$RichEndpointInput$$anon$3;
/** @constructor */
function $h_Lsttp_tapir_internal_package$RichEndpointInput$$anon$3() {
}
export { $h_Lsttp_tapir_internal_package$RichEndpointInput$$anon$3 as $h_Lsttp_tapir_internal_package$RichEndpointInput$$anon$3 };
$h_Lsttp_tapir_internal_package$RichEndpointInput$$anon$3.prototype = $c_Lsttp_tapir_internal_package$RichEndpointInput$$anon$3.prototype;
$c_Lsttp_tapir_internal_package$RichEndpointInput$$anon$3.prototype.isDefinedAt__Lsttp_tapir_EndpointInput__Z = (function(x) {
  return (x instanceof $c_Lsttp_tapir_EndpointInput$FixedMethod);
});
$c_Lsttp_tapir_internal_package$RichEndpointInput$$anon$3.prototype.applyOrElse__Lsttp_tapir_EndpointInput__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Lsttp_tapir_EndpointInput$FixedMethod)) {
    var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
    var elems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_Lsttp_model_Method.getArrayOf().constr)([new $c_Lsttp_model_Method(x.Lsttp_tapir_EndpointInput$FixedMethod__f_m)]));
    return this$1.from__sc_IterableOnce__sci_Vector(elems);
  } else {
    return default$1.apply__O__O(x);
  }
});
$c_Lsttp_tapir_internal_package$RichEndpointInput$$anon$3.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lsttp_tapir_EndpointInput__Z(x);
});
$c_Lsttp_tapir_internal_package$RichEndpointInput$$anon$3.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lsttp_tapir_EndpointInput__F1__O(x, default$1);
});
var $d_Lsttp_tapir_internal_package$RichEndpointInput$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_internal_package$RichEndpointInput$$anon$3, "sttp.tapir.internal.package$RichEndpointInput$$anon$3", ({
  Lsttp_tapir_internal_package$RichEndpointInput$$anon$3: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_internal_package$RichEndpointInput$$anon$3 as $d_Lsttp_tapir_internal_package$RichEndpointInput$$anon$3 };
/** @constructor */
function $c_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$4() {
}
export { $c_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$4 as $c_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$4 };
$c_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$4.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$c_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$4.prototype.constructor = $c_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$4;
/** @constructor */
function $h_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$4() {
}
export { $h_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$4 as $h_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$4 };
$h_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$4.prototype = $c_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$4.prototype;
$c_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$4.prototype.isDefinedAt__Lsttp_tapir_EndpointOutput__Z = (function(x) {
  return ((x instanceof $c_Lsttp_tapir_EndpointIO$Body) || false);
});
$c_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$4.prototype.applyOrElse__Lsttp_tapir_EndpointOutput__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Lsttp_tapir_EndpointIO$Body)) {
    var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
    var elems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lsttp_tapir_RawBodyType.getArrayOf().constr)([x.Lsttp_tapir_EndpointIO$Body__f_bodyType]));
    return this$1.from__sc_IterableOnce__sci_Vector(elems);
  } else if (false) {
    var x175 = x.Lsttp_tapir_EndpointIO$OneOfBody__f_variants;
    var rest = x175;
    var h = null;
    var t = null;
    while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
      var x0 = rest.head__O();
      var this$3 = x0.Lsttp_tapir_EndpointIO$OneOfBodyVariant__f_body;
      if ((this$3 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
        var b = this$3.s_util_Right__f_value;
        var $x_1 = new $c_Lsttp_tapir_internal_package$RichEndpointOutput(b).bodyType__s_Option();
      } else {
        if ((!(this$3 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left))) {
          throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this$3);
        }
        var a = this$3.s_util_Left__f_value;
        var value = a.Lsttp_tapir_EndpointIO$Body__f_bodyType;
        var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
      }
      var it = $x_1.iterator__sc_Iterator();
      while (it.hasNext__Z()) {
        var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(it.next__O(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
        if ((t === null)) {
          h = nx;
        } else {
          t.sci_$colon$colon__f_next = nx;
        }
        t = nx;
      }
      rest = rest.tail__O();
    }
    var this$6 = ((h === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$() : h);
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$6);
  } else {
    return default$1.apply__O__O(x);
  }
});
$c_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$4.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lsttp_tapir_EndpointOutput__Z(x);
});
$c_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$4.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lsttp_tapir_EndpointOutput__F1__O(x, default$1);
});
var $d_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$4, "sttp.tapir.internal.package$RichEndpointOutput$$anon$4", ({
  Lsttp_tapir_internal_package$RichEndpointOutput$$anon$4: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$4 as $d_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$4 };
/** @constructor */
function $c_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$5() {
}
export { $c_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$5 as $c_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$5 };
$c_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$5.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$c_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$5.prototype.constructor = $c_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$5;
/** @constructor */
function $h_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$5() {
}
export { $h_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$5 as $h_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$5 };
$h_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$5.prototype = $c_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$5.prototype;
$c_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$5.prototype.isDefinedAt__Lsttp_tapir_EndpointOutput__Z = (function(x) {
  if ((x instanceof $c_Lsttp_tapir_EndpointIO$Body)) {
    return true;
  }
  if (false) {
    return true;
  }
  if (false) {
    return true;
  }
  if (false) {
    var x181 = x.Lsttp_tapir_EndpointIO$FixedHeader__f_h;
    var this$3 = x181.Lsttp_model_Header__f_name;
    var anotherString = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_ContentType;
    _return: {
      var len = this$3.length;
      if ((!((anotherString === null) || (anotherString.length !== len)))) {
        var i = 0;
        while ((i !== len)) {
          var index = i;
          var c = this$3.charCodeAt(index);
          var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toLowerCase__C__C($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toUpperCase__C__C(c));
          var index$1 = i;
          var c$1 = anotherString.charCodeAt(index$1);
          if (($x_2 !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toLowerCase__C__C($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toUpperCase__C__C(c$1)))) {
            var $x_1 = false;
            break _return;
          }
          i = ((1 + i) | 0);
        }
        var $x_1 = true;
      } else {
        var $x_1 = false;
      }
    }
    if ($x_1) {
      return true;
    }
  }
  return false;
});
$c_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$5.prototype.applyOrElse__Lsttp_tapir_EndpointOutput__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Lsttp_tapir_EndpointIO$Body)) {
    var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
    var elems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lsttp_model_MediaType.getArrayOf().constr)([new $c_Lsttp_tapir_internal_package$RichBody(x).mediaTypeWithCharset__Lsttp_model_MediaType()]));
    return this$2.from__sc_IterableOnce__sci_Vector(elems);
  }
  if (false) {
    var x199 = x.Lsttp_tapir_EndpointIO$OneOfBody__f_variants;
    var f = ((_$10) => _$10.mediaTypeWithCharset__Lsttp_model_MediaType());
    if ((x199 === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
      var this$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    } else {
      var x0 = x199.head__O();
      var h = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      var t = h;
      var rest = x199.tail__O();
      while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
        var x0$1 = rest.head__O();
        var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0$1), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
        t.sci_$colon$colon__f_next = nx;
        t = nx;
        rest = rest.tail__O();
      }
      var this$4 = h;
    }
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$4);
  }
  if (false) {
    var this$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
    var elems$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lsttp_model_MediaType.getArrayOf().constr)([new $c_Lsttp_tapir_internal_package$RichStreamBody(x).mediaTypeWithCharset__Lsttp_model_MediaType()]));
    return this$6.from__sc_IterableOnce__sci_Vector(elems$1);
  }
  if (false) {
    var x193 = x.Lsttp_tapir_EndpointIO$FixedHeader__f_h;
    var this$8 = x193.Lsttp_model_Header__f_name;
    var anotherString = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_ContentType;
    _return: {
      var len = this$8.length;
      if ((!((anotherString === null) || (anotherString.length !== len)))) {
        var i = 0;
        while ((i !== len)) {
          var index = i;
          var c = this$8.charCodeAt(index);
          var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toLowerCase__C__C($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toUpperCase__C__C(c));
          var index$1 = i;
          var c$1 = anotherString.charCodeAt(index$1);
          if (($x_2 !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toLowerCase__C__C($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toUpperCase__C__C(c$1)))) {
            var $x_1 = false;
            break _return;
          }
          i = ((1 + i) | 0);
        }
        var $x_1 = true;
      } else {
        var $x_1 = false;
      }
    }
    if ($x_1) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Option$().option2Iterable__s_Option__sc_Iterable($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_MediaType$().parse__T__s_util_Either(x193.Lsttp_model_Header__f_value).toOption__s_Option()).toVector__sci_Vector();
    }
  }
  return default$1.apply__O__O(x);
});
$c_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$5.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lsttp_tapir_EndpointOutput__Z(x);
});
$c_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$5.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lsttp_tapir_EndpointOutput__F1__O(x, default$1);
});
var $d_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$5, "sttp.tapir.internal.package$RichEndpointOutput$$anon$5", ({
  Lsttp_tapir_internal_package$RichEndpointOutput$$anon$5: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$5 as $d_Lsttp_tapir_internal_package$RichEndpointOutput$$anon$5 };
/** @constructor */
function $c_Lurldsl_vocabulary_Param$$anon$1(outer) {
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lurldsl_vocabulary_Param$$anon$1 as $c_Lurldsl_vocabulary_Param$$anon$1 };
$c_Lurldsl_vocabulary_Param$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$c_Lurldsl_vocabulary_Param$$anon$1.prototype.constructor = $c_Lurldsl_vocabulary_Param$$anon$1;
/** @constructor */
function $h_Lurldsl_vocabulary_Param$$anon$1() {
}
export { $h_Lurldsl_vocabulary_Param$$anon$1 as $h_Lurldsl_vocabulary_Param$$anon$1 };
$h_Lurldsl_vocabulary_Param$$anon$1.prototype = $c_Lurldsl_vocabulary_Param$$anon$1.prototype;
$c_Lurldsl_vocabulary_Param$$anon$1.prototype.isDefinedAt__sci_List__Z = (function(x) {
  if ((x instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon)) {
    var x13 = x.sci_$colon$colon__f_head;
    var x14 = x.sci_$colon$colon__f_next;
    var x$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    if ((x$2.equals__O__Z(x14) && (x13 !== ""))) {
      return true;
    }
    if ((x14 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon)) {
      var x11 = x14.sci_$colon$colon__f_next;
      var x$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      if ((x$4.equals__O__Z(x11) && (x13 !== ""))) {
        return true;
      }
    }
  }
  return false;
});
$c_Lurldsl_vocabulary_Param$$anon$1.prototype.applyOrElse__sci_List__F1__O = (function(x, default$1) {
  if ((x instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon)) {
    var x23 = x.sci_$colon$colon__f_head;
    var x24 = x.sci_$colon$colon__f_next;
    var x$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    if ((x$2.equals__O__Z(x24) && (x23 !== ""))) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), x23, "");
    }
    if ((x24 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon)) {
      var x21 = x24.sci_$colon$colon__f_next;
      var second = x24.sci_$colon$colon__f_head;
      var x$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      if ((x$4.equals__O__Z(x21) && (x23 !== ""))) {
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), x23, second);
      }
    }
  }
  return default$1.apply__O__O(x);
});
$c_Lurldsl_vocabulary_Param$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__sci_List__Z(x);
});
$c_Lurldsl_vocabulary_Param$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__sci_List__F1__O(x, default$1);
});
var $d_Lurldsl_vocabulary_Param$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lurldsl_vocabulary_Param$$anon$1, "urldsl.vocabulary.Param$$anon$1", ({
  Lurldsl_vocabulary_Param$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lurldsl_vocabulary_Param$$anon$1 as $d_Lurldsl_vocabulary_Param$$anon$1 };
function $f_Lcats_arrow_Arrow__id__O($thiz) {
  return $thiz.lift__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x) => x)));
}
export { $f_Lcats_arrow_Arrow__id__O as $f_Lcats_arrow_Arrow__id__O };
/** @constructor */
function $c_Lcats_data_AndThen$Concat(left, right) {
  this.Lcats_data_AndThen$Concat__f_left = null;
  this.Lcats_data_AndThen$Concat__f_right = null;
  this.Lcats_data_AndThen$Concat__f_left = left;
  this.Lcats_data_AndThen$Concat__f_right = right;
}
export { $c_Lcats_data_AndThen$Concat as $c_Lcats_data_AndThen$Concat };
$c_Lcats_data_AndThen$Concat.prototype = new $h_Lcats_data_AndThen();
$c_Lcats_data_AndThen$Concat.prototype.constructor = $c_Lcats_data_AndThen$Concat;
/** @constructor */
function $h_Lcats_data_AndThen$Concat() {
}
export { $h_Lcats_data_AndThen$Concat as $h_Lcats_data_AndThen$Concat };
$h_Lcats_data_AndThen$Concat.prototype = $c_Lcats_data_AndThen$Concat.prototype;
$c_Lcats_data_AndThen$Concat.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_data_AndThen$Concat.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_data_AndThen$Concat)) {
    var x = this.Lcats_data_AndThen$Concat__f_left;
    var x$2 = x$0.Lcats_data_AndThen$Concat__f_left;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lcats_data_AndThen$Concat__f_right;
      var x$4 = x$0.Lcats_data_AndThen$Concat__f_right;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_data_AndThen$Concat.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_data_AndThen$Concat.prototype.productPrefix__T = (function() {
  return "Concat";
});
$c_Lcats_data_AndThen$Concat.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_AndThen$Concat__f_left;
  }
  if ((n === 1)) {
    return this.Lcats_data_AndThen$Concat__f_right;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_data_AndThen$Concat.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "left";
  }
  if ((n === 1)) {
    return "right";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcats_data_AndThen$Concat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_AndThen$Concat)));
}
export { $isArrayOf_Lcats_data_AndThen$Concat as $isArrayOf_Lcats_data_AndThen$Concat };
var $d_Lcats_data_AndThen$Concat = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_data_AndThen$Concat, "cats.data.AndThen$Concat", ({
  Lcats_data_AndThen$Concat: 1,
  Lcats_data_AndThen: 1,
  F1: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_data_AndThen$Concat as $d_Lcats_data_AndThen$Concat };
/** @constructor */
function $c_Lcats_data_AndThen$Single(f, index) {
  this.Lcats_data_AndThen$Single__f_f = null;
  this.Lcats_data_AndThen$Single__f_index = 0;
  this.Lcats_data_AndThen$Single__f_f = f;
  this.Lcats_data_AndThen$Single__f_index = index;
}
export { $c_Lcats_data_AndThen$Single as $c_Lcats_data_AndThen$Single };
$c_Lcats_data_AndThen$Single.prototype = new $h_Lcats_data_AndThen();
$c_Lcats_data_AndThen$Single.prototype.constructor = $c_Lcats_data_AndThen$Single;
/** @constructor */
function $h_Lcats_data_AndThen$Single() {
}
export { $h_Lcats_data_AndThen$Single as $h_Lcats_data_AndThen$Single };
$h_Lcats_data_AndThen$Single.prototype = $c_Lcats_data_AndThen$Single.prototype;
$c_Lcats_data_AndThen$Single.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I("Single");
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lcats_data_AndThen$Single__f_f;
  var data$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Lcats_data_AndThen$Single__f_index;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2);
});
$c_Lcats_data_AndThen$Single.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_data_AndThen$Single)) {
    if ((this.Lcats_data_AndThen$Single__f_index === x$0.Lcats_data_AndThen$Single__f_index)) {
      var x = this.Lcats_data_AndThen$Single__f_f;
      var x$2 = x$0.Lcats_data_AndThen$Single__f_f;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_data_AndThen$Single.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_data_AndThen$Single.prototype.productPrefix__T = (function() {
  return "Single";
});
$c_Lcats_data_AndThen$Single.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_AndThen$Single__f_f;
  }
  if ((n === 1)) {
    return this.Lcats_data_AndThen$Single__f_index;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_data_AndThen$Single.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "f";
  }
  if ((n === 1)) {
    return "index";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcats_data_AndThen$Single(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_AndThen$Single)));
}
export { $isArrayOf_Lcats_data_AndThen$Single as $isArrayOf_Lcats_data_AndThen$Single };
var $d_Lcats_data_AndThen$Single = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_data_AndThen$Single, "cats.data.AndThen$Single", ({
  Lcats_data_AndThen$Single: 1,
  Lcats_data_AndThen: 1,
  F1: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_data_AndThen$Single as $d_Lcats_data_AndThen$Single };
/** @constructor */
function $c_Lcats_data_KleisliInstances4() {
}
export { $c_Lcats_data_KleisliInstances4 as $c_Lcats_data_KleisliInstances4 };
$c_Lcats_data_KleisliInstances4.prototype = new $h_Lcats_data_KleisliInstances5();
$c_Lcats_data_KleisliInstances4.prototype.constructor = $c_Lcats_data_KleisliInstances4;
/** @constructor */
function $h_Lcats_data_KleisliInstances4() {
}
export { $h_Lcats_data_KleisliInstances4 as $h_Lcats_data_KleisliInstances4 };
$h_Lcats_data_KleisliInstances4.prototype = $c_Lcats_data_KleisliInstances4.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptyChainImpl$() {
  $ct_Lcats_data_NonEmptyChainInstances__(this);
}
export { $c_Lcats_data_NonEmptyChainImpl$ as $c_Lcats_data_NonEmptyChainImpl$ };
$c_Lcats_data_NonEmptyChainImpl$.prototype = new $h_Lcats_data_NonEmptyChainInstances();
$c_Lcats_data_NonEmptyChainImpl$.prototype.constructor = $c_Lcats_data_NonEmptyChainImpl$;
/** @constructor */
function $h_Lcats_data_NonEmptyChainImpl$() {
}
export { $h_Lcats_data_NonEmptyChainImpl$ as $h_Lcats_data_NonEmptyChainImpl$ };
$h_Lcats_data_NonEmptyChainImpl$.prototype = $c_Lcats_data_NonEmptyChainImpl$.prototype;
var $d_Lcats_data_NonEmptyChainImpl$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_data_NonEmptyChainImpl$, "cats.data.NonEmptyChainImpl$", ({
  Lcats_data_NonEmptyChainImpl$: 1,
  Lcats_data_NonEmptyChainInstances: 1,
  Lcats_data_NonEmptyChainInstances1: 1,
  Lcats_data_NonEmptyChainInstances2: 1,
  Lcats_data_NonEmptyChainInstances3: 1,
  Lcats_data_ScalaVersionSpecificNonEmptyChainImpl: 1
}));
export { $d_Lcats_data_NonEmptyChainImpl$ as $d_Lcats_data_NonEmptyChainImpl$ };
var $n_Lcats_data_NonEmptyChainImpl$;
function $m_Lcats_data_NonEmptyChainImpl$() {
  if ((!$n_Lcats_data_NonEmptyChainImpl$)) {
    $n_Lcats_data_NonEmptyChainImpl$ = new $c_Lcats_data_NonEmptyChainImpl$();
  }
  return $n_Lcats_data_NonEmptyChainImpl$;
}
export { $m_Lcats_data_NonEmptyChainImpl$ as $m_Lcats_data_NonEmptyChainImpl$ };
/** @constructor */
function $c_Lcats_derived_DerivedOrder$package$DerivedOrder$$anon$1(given_CoproductInstances_Order_A$lzy1$3, inst$3) {
  this.Lcats_derived_DerivedOrder$package$DerivedOrder$$anon$1__f_cats$derived$DerivedOrder$package$DerivedOrder$Coproduct$$inst = null;
  this.Lcats_derived_DerivedOrder$package$DerivedOrder$$anon$1__f_cats$derived$DerivedOrder$package$DerivedOrder$Coproduct$$inst = $m_Lcats_derived_DerivedOrder$package$DerivedOrder$().cats$derived$DerivedOrder$package$DerivedOrder$$$_$given_CoproductInstances_Order_A$1__sr_LazyRef__F0__Lshapeless3_deriving_internals_ErasedCoproductInstances(given_CoproductInstances_Order_A$lzy1$3, inst$3);
}
export { $c_Lcats_derived_DerivedOrder$package$DerivedOrder$$anon$1 as $c_Lcats_derived_DerivedOrder$package$DerivedOrder$$anon$1 };
$c_Lcats_derived_DerivedOrder$package$DerivedOrder$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_derived_DerivedOrder$package$DerivedOrder$$anon$1.prototype.constructor = $c_Lcats_derived_DerivedOrder$package$DerivedOrder$$anon$1;
/** @constructor */
function $h_Lcats_derived_DerivedOrder$package$DerivedOrder$$anon$1() {
}
export { $h_Lcats_derived_DerivedOrder$package$DerivedOrder$$anon$1 as $h_Lcats_derived_DerivedOrder$package$DerivedOrder$$anon$1 };
$h_Lcats_derived_DerivedOrder$package$DerivedOrder$$anon$1.prototype = $c_Lcats_derived_DerivedOrder$package$DerivedOrder$$anon$1.prototype;
$c_Lcats_derived_DerivedOrder$package$DerivedOrder$$anon$1.prototype.partialCompare__O__O__D = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_derived_DerivedOrder$package$DerivedOrder$$anon$1.prototype.eqv__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Order__eqv__O__O__Z(this, x, y);
});
$c_Lcats_derived_DerivedOrder$package$DerivedOrder$$anon$1.prototype.neqv__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Order__neqv__O__O__Z(this, x, y);
});
$c_Lcats_derived_DerivedOrder$package$DerivedOrder$$anon$1.prototype.lt__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Order__lt__O__O__Z(this, x, y);
});
$c_Lcats_derived_DerivedOrder$package$DerivedOrder$$anon$1.prototype.gt__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Order__gt__O__O__Z(this, x, y);
});
$c_Lcats_derived_DerivedOrder$package$DerivedOrder$$anon$1.prototype.toOrdering__s_math_Ordering = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_kernel_Order$$anon$1(this);
});
$c_Lcats_derived_DerivedOrder$package$DerivedOrder$$anon$1.prototype.compare__O__O__I = (function(x, y) {
  return $f_Lcats_derived_DerivedOrder$package$DerivedOrder$Coproduct__compare__O__O__I(this, x, y);
});
var $d_Lcats_derived_DerivedOrder$package$DerivedOrder$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_derived_DerivedOrder$package$DerivedOrder$$anon$1, "cats.derived.DerivedOrder$package$DerivedOrder$$anon$1", ({
  Lcats_derived_DerivedOrder$package$DerivedOrder$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_derived_DerivedOrder$package$DerivedOrder$Coproduct: 1
}));
export { $d_Lcats_derived_DerivedOrder$package$DerivedOrder$$anon$1 as $d_Lcats_derived_DerivedOrder$package$DerivedOrder$$anon$1 };
/** @constructor */
function $c_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$$anon$4(evidence$1$1) {
  this.Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$$anon$4__f_cats$derived$DerivedOrder$package$DerivedOrder$Product$$inst = null;
  this.Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$$anon$4__f_cats$derived$DerivedOrder$package$DerivedOrder$Product$$inst = evidence$1$1;
}
export { $c_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$$anon$4 as $c_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$$anon$4 };
$c_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$$anon$4.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$$anon$4.prototype.constructor = $c_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$$anon$4;
/** @constructor */
function $h_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$$anon$4() {
}
export { $h_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$$anon$4 as $h_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$$anon$4 };
$h_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$$anon$4.prototype = $c_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$$anon$4.prototype;
$c_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$$anon$4.prototype.partialCompare__O__O__D = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$$anon$4.prototype.eqv__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Order__eqv__O__O__Z(this, x, y);
});
$c_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$$anon$4.prototype.neqv__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Order__neqv__O__O__Z(this, x, y);
});
$c_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$$anon$4.prototype.lt__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Order__lt__O__O__Z(this, x, y);
});
$c_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$$anon$4.prototype.gt__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Order__gt__O__O__Z(this, x, y);
});
$c_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$$anon$4.prototype.toOrdering__s_math_Ordering = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_kernel_Order$$anon$1(this);
});
$c_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$$anon$4.prototype.compare__O__O__I = (function(x, y) {
  return $f_Lcats_derived_DerivedOrder$package$DerivedOrder$Product__compare__O__O__I(this, x, y);
});
var $d_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$$anon$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$$anon$4, "cats.derived.DerivedOrder$package$DerivedOrder$Strict$$anon$4", ({
  Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$$anon$4: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_derived_DerivedOrder$package$DerivedOrder$Product: 1
}));
export { $d_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$$anon$4 as $d_Lcats_derived_DerivedOrder$package$DerivedOrder$Strict$$anon$4 };
/** @constructor */
function $c_Lcats_effect_IO$() {
  this.Lcats_effect_IO$__f__asyncForIO = null;
  this.Lcats_effect_IO$__f__unit = null;
  this.Lcats_effect_IO$__f__parallelForIO = null;
  this.Lcats_effect_IO$__f__never = null;
  $n_Lcats_effect_IO$ = this;
  this.Lcats_effect_IO$__f__asyncForIO = new $c_Lcats_effect_IO$IOAsync();
  this.Lcats_effect_IO$__f__unit = new $c_Lcats_effect_IO$Pure((void 0));
  var this$2 = $m_Lcats_effect_instances_package$spawn$();
  var M = this.Lcats_effect_IO$__f__asyncForIO;
  this.Lcats_effect_IO$__f__parallelForIO = new $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1(M, this$2);
  $m_Lcats_effect_std_Console$().make__Lcats_effect_kernel_Async__Lcats_effect_std_Console(this.Lcats_effect_IO$__f__asyncForIO);
  var this$3 = $m_Lcats_effect_std_Env$();
  var F = this.Lcats_effect_IO$__f__asyncForIO;
  new $c_Lcats_effect_std_EnvCompanionPlatform$SyncEnv(this$3, F);
  var this$5 = this.Lcats_effect_IO$__f__asyncForIO;
  this.Lcats_effect_IO$__f__never = $f_Lcats_effect_kernel_Async__never__O(this$5);
}
export { $c_Lcats_effect_IO$ as $c_Lcats_effect_IO$ };
$c_Lcats_effect_IO$.prototype = new $h_Lcats_effect_IOCompanionPlatform();
$c_Lcats_effect_IO$.prototype.constructor = $c_Lcats_effect_IO$;
/** @constructor */
function $h_Lcats_effect_IO$() {
}
export { $h_Lcats_effect_IO$ as $h_Lcats_effect_IO$ };
$h_Lcats_effect_IO$.prototype = $c_Lcats_effect_IO$.prototype;
$c_Lcats_effect_IO$.prototype.delay__F0__Lcats_effect_IO = (function(thunk) {
  var event = $m_Lcats_effect_tracing_Tracing$().calculateTracingEvent__F0__Lcats_effect_tracing_TracingEvent(thunk);
  return new $c_Lcats_effect_IO$Delay(thunk, event);
});
$c_Lcats_effect_IO$.prototype.defer__F0__Lcats_effect_IO = (function(thunk) {
  var this$2 = this.delay__F0__Lcats_effect_IO(thunk);
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_$less$colon$less$();
  var ev = this$1.s_$less$colon$less$__f_singleton;
  return this$2.flatMap__F1__Lcats_effect_IO(ev);
});
$c_Lcats_effect_IO$.prototype.asyncCheckAttempt__F1__Lcats_effect_IO = (function(k) {
  var body = new $c_Lcats_effect_IO$$anon$4(k);
  var event = $m_Lcats_effect_tracing_Tracing$().calculateTracingEvent__F1__Lcats_effect_tracing_TracingEvent(k);
  return new $c_Lcats_effect_IO$IOCont(body, event);
});
$c_Lcats_effect_IO$.prototype.async__F1__Lcats_effect_IO = (function(k) {
  var body = new $c_Lcats_effect_IO$$anon$5(k);
  var event = $m_Lcats_effect_tracing_Tracing$().calculateTracingEvent__F1__Lcats_effect_tracing_TracingEvent(k);
  return new $c_Lcats_effect_IO$IOCont(body, event);
});
$c_Lcats_effect_IO$.prototype.async___F1__Lcats_effect_IO = (function(k) {
  var body = new $c_Lcats_effect_IO$$anon$6(k);
  var event = $m_Lcats_effect_tracing_Tracing$().calculateTracingEvent__F1__Lcats_effect_tracing_TracingEvent(k);
  return new $c_Lcats_effect_IO$IOCont(body, event);
});
$c_Lcats_effect_IO$.prototype.sleep__s_concurrent_duration_Duration__Lcats_effect_IO = (function(delay) {
  matchResult13: {
    var $x_1;
    if ((delay instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_FiniteDuration)) {
      var $x_1 = new $c_Lcats_effect_IO$Sleep(delay);
      break matchResult13;
    }
    var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Inf;
    if (((x === null) ? (delay === null) : x.equals__O__Z(delay))) {
      var $x_1 = $m_Lcats_effect_IO$().Lcats_effect_IO$__f__never;
      break matchResult13;
    }
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), ("Duration must be either a `FiniteDuration` or `Duration.Inf`, but got: " + delay));
  }
  return $x_1;
});
$c_Lcats_effect_IO$.prototype.uncancelable__F1__Lcats_effect_IO = (function(body) {
  var event = $m_Lcats_effect_tracing_Tracing$().calculateTracingEvent__F1__Lcats_effect_tracing_TracingEvent(body);
  return new $c_Lcats_effect_IO$Uncancelable(body, event);
});
$c_Lcats_effect_IO$.prototype.ref__O__Lcats_effect_IO = (function(a) {
  var this$2 = $m_Lcats_effect_IO$();
  var thunk = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    var F = $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO;
    return new $c_Lcats_effect_kernel_SyncRef(a, F);
  }));
  return this$2.delay__F0__Lcats_effect_IO(thunk);
});
$c_Lcats_effect_IO$.prototype.deferred__Lcats_effect_IO = (function() {
  var this$1 = $m_Lcats_effect_IO$();
  var thunk = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => new $c_Lcats_effect_IODeferred()));
  return this$1.delay__F0__Lcats_effect_IO(thunk);
});
$c_Lcats_effect_IO$.prototype.bracketFull__F1__F1__F2__Lcats_effect_IO = (function(acquire, use, release) {
  return $m_Lcats_effect_IO$().uncancelable__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((poll) => acquire.apply__O__O(poll).flatMap__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((poll$2) => ((a) => $m_Lcats_effect_IO$().defer__F0__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => poll$2.apply__O__O(use.apply__O__O(a))))).guaranteeCase__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$54) => release.apply__O__O__O(a, _$54))))))(poll))))));
});
$c_Lcats_effect_IO$.prototype.ordinal__Lcats_effect_IO__I = (function(x$0) {
  if ((x$0 instanceof $c_Lcats_effect_IO$Pure)) {
    return 0;
  }
  if ((x$0 instanceof $c_Lcats_effect_IO$Error)) {
    return 1;
  }
  if ((x$0 instanceof $c_Lcats_effect_IO$Delay)) {
    return 2;
  }
  if ((x$0 === $m_Lcats_effect_IO$RealTime$())) {
    return 3;
  }
  if ((x$0 === $m_Lcats_effect_IO$Monotonic$())) {
    return 4;
  }
  if ((x$0 === $m_Lcats_effect_IO$ReadEC$())) {
    return 5;
  }
  if ((x$0 instanceof $c_Lcats_effect_IO$Map)) {
    return 6;
  }
  if ((x$0 instanceof $c_Lcats_effect_IO$FlatMap)) {
    return 7;
  }
  if ((x$0 instanceof $c_Lcats_effect_IO$Attempt)) {
    return 8;
  }
  if ((x$0 instanceof $c_Lcats_effect_IO$HandleErrorWith)) {
    return 9;
  }
  if ((x$0 === $m_Lcats_effect_IO$Canceled$())) {
    return 10;
  }
  if ((x$0 instanceof $c_Lcats_effect_IO$OnCancel)) {
    return 11;
  }
  if ((x$0 instanceof $c_Lcats_effect_IO$Uncancelable)) {
    return 12;
  }
  if ((x$0 instanceof $c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop)) {
    return 13;
  }
  if ((x$0 instanceof $c_Lcats_effect_IO$IOCont)) {
    return 14;
  }
  if ((x$0 instanceof $c_Lcats_effect_IO$IOCont$Get)) {
    return 15;
  }
  if ((x$0 === $m_Lcats_effect_IO$Cede$())) {
    return 16;
  }
  if ((x$0 instanceof $c_Lcats_effect_IO$Start)) {
    return 17;
  }
  if ((x$0 instanceof $c_Lcats_effect_IO$RacePair)) {
    return 18;
  }
  if ((x$0 instanceof $c_Lcats_effect_IO$Sleep)) {
    return 19;
  }
  if ((x$0 instanceof $c_Lcats_effect_IO$EvalOn)) {
    return 20;
  }
  if (false) {
    return 21;
  }
  if (false) {
    return 22;
  }
  if ((x$0 === $m_Lcats_effect_IO$IOTrace$())) {
    return 23;
  }
  if ((x$0 === $m_Lcats_effect_IO$ReadRT$())) {
    return 24;
  }
  if ((x$0 === $m_Lcats_effect_IO$EndFiber$())) {
    return 25;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$0);
});
$c_Lcats_effect_IO$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Lcats_effect_IO__I(x);
});
var $d_Lcats_effect_IO$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IO$, "cats.effect.IO$", ({
  Lcats_effect_IO$: 1,
  Lcats_effect_IOCompanionPlatform: 1,
  Lcats_effect_IOLowPriorityImplicits: 1,
  Lcats_syntax_TupleParallelSyntax: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lcats_effect_IO$ as $d_Lcats_effect_IO$ };
var $n_Lcats_effect_IO$;
function $m_Lcats_effect_IO$() {
  if ((!$n_Lcats_effect_IO$)) {
    $n_Lcats_effect_IO$ = new $c_Lcats_effect_IO$();
  }
  return $n_Lcats_effect_IO$;
}
export { $m_Lcats_effect_IO$ as $m_Lcats_effect_IO$ };
/** @constructor */
function $c_Lcats_effect_IO$Attempt(ioa) {
  this.Lcats_effect_IO$Attempt__f_ioa = null;
  this.Lcats_effect_IO$Attempt__f_ioa = ioa;
}
export { $c_Lcats_effect_IO$Attempt as $c_Lcats_effect_IO$Attempt };
$c_Lcats_effect_IO$Attempt.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Attempt.prototype.constructor = $c_Lcats_effect_IO$Attempt;
/** @constructor */
function $h_Lcats_effect_IO$Attempt() {
}
export { $h_Lcats_effect_IO$Attempt as $h_Lcats_effect_IO$Attempt };
$h_Lcats_effect_IO$Attempt.prototype = $c_Lcats_effect_IO$Attempt.prototype;
$c_Lcats_effect_IO$Attempt.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Attempt.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_IO$Attempt.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Attempt)) {
    var x = this.Lcats_effect_IO$Attempt__f_ioa;
    var x$2 = x$0.Lcats_effect_IO$Attempt__f_ioa;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$Attempt.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_IO$Attempt.prototype.productPrefix__T = (function() {
  return "Attempt";
});
$c_Lcats_effect_IO$Attempt.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$Attempt__f_ioa;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Attempt.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "ioa";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Attempt.prototype.tag__B = (function() {
  return 8;
});
function $isArrayOf_Lcats_effect_IO$Attempt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Attempt)));
}
export { $isArrayOf_Lcats_effect_IO$Attempt as $isArrayOf_Lcats_effect_IO$Attempt };
var $d_Lcats_effect_IO$Attempt = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IO$Attempt, "cats.effect.IO$Attempt", ({
  Lcats_effect_IO$Attempt: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_effect_IO$Attempt as $d_Lcats_effect_IO$Attempt };
function $isArrayOf_Lcats_effect_IO$Blocking(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Blocking)));
}
export { $isArrayOf_Lcats_effect_IO$Blocking as $isArrayOf_Lcats_effect_IO$Blocking };
/** @constructor */
function $c_Lcats_effect_IO$Delay(thunk, event) {
  this.Lcats_effect_IO$Delay__f_thunk = null;
  this.Lcats_effect_IO$Delay__f_event = null;
  this.Lcats_effect_IO$Delay__f_thunk = thunk;
  this.Lcats_effect_IO$Delay__f_event = event;
}
export { $c_Lcats_effect_IO$Delay as $c_Lcats_effect_IO$Delay };
$c_Lcats_effect_IO$Delay.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Delay.prototype.constructor = $c_Lcats_effect_IO$Delay;
/** @constructor */
function $h_Lcats_effect_IO$Delay() {
}
export { $h_Lcats_effect_IO$Delay as $h_Lcats_effect_IO$Delay };
$h_Lcats_effect_IO$Delay.prototype = $c_Lcats_effect_IO$Delay.prototype;
$c_Lcats_effect_IO$Delay.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Delay.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_IO$Delay.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Delay)) {
    var x = this.Lcats_effect_IO$Delay__f_thunk;
    var x$2 = x$0.Lcats_effect_IO$Delay__f_thunk;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_IO$Delay__f_event;
      var x$4 = x$0.Lcats_effect_IO$Delay__f_event;
      return (x$3 === x$4);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$Delay.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_IO$Delay.prototype.productPrefix__T = (function() {
  return "Delay";
});
$c_Lcats_effect_IO$Delay.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$Delay__f_thunk;
  }
  if ((n === 1)) {
    return this.Lcats_effect_IO$Delay__f_event;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Delay.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "thunk";
  }
  if ((n === 1)) {
    return "event";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Delay.prototype.tag__B = (function() {
  return 2;
});
function $isArrayOf_Lcats_effect_IO$Delay(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Delay)));
}
export { $isArrayOf_Lcats_effect_IO$Delay as $isArrayOf_Lcats_effect_IO$Delay };
var $d_Lcats_effect_IO$Delay = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IO$Delay, "cats.effect.IO$Delay", ({
  Lcats_effect_IO$Delay: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_effect_IO$Delay as $d_Lcats_effect_IO$Delay };
/** @constructor */
function $c_Lcats_effect_IO$Error(t) {
  this.Lcats_effect_IO$Error__f_t = null;
  this.Lcats_effect_IO$Error__f_t = t;
}
export { $c_Lcats_effect_IO$Error as $c_Lcats_effect_IO$Error };
$c_Lcats_effect_IO$Error.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Error.prototype.constructor = $c_Lcats_effect_IO$Error;
/** @constructor */
function $h_Lcats_effect_IO$Error() {
}
export { $h_Lcats_effect_IO$Error as $h_Lcats_effect_IO$Error };
$h_Lcats_effect_IO$Error.prototype = $c_Lcats_effect_IO$Error.prototype;
$c_Lcats_effect_IO$Error.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Error.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_IO$Error.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Error)) {
    var x = this.Lcats_effect_IO$Error__f_t;
    var x$2 = x$0.Lcats_effect_IO$Error__f_t;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$Error.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_IO$Error.prototype.productPrefix__T = (function() {
  return "Error";
});
$c_Lcats_effect_IO$Error.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$Error__f_t;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Error.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "t";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Error.prototype.tag__B = (function() {
  return 1;
});
function $isArrayOf_Lcats_effect_IO$Error(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Error)));
}
export { $isArrayOf_Lcats_effect_IO$Error as $isArrayOf_Lcats_effect_IO$Error };
var $d_Lcats_effect_IO$Error = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IO$Error, "cats.effect.IO$Error", ({
  Lcats_effect_IO$Error: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_effect_IO$Error as $d_Lcats_effect_IO$Error };
/** @constructor */
function $c_Lcats_effect_IO$EvalOn(ioa, ec) {
  this.Lcats_effect_IO$EvalOn__f_ioa = null;
  this.Lcats_effect_IO$EvalOn__f_ec = null;
  this.Lcats_effect_IO$EvalOn__f_ioa = ioa;
  this.Lcats_effect_IO$EvalOn__f_ec = ec;
}
export { $c_Lcats_effect_IO$EvalOn as $c_Lcats_effect_IO$EvalOn };
$c_Lcats_effect_IO$EvalOn.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$EvalOn.prototype.constructor = $c_Lcats_effect_IO$EvalOn;
/** @constructor */
function $h_Lcats_effect_IO$EvalOn() {
}
export { $h_Lcats_effect_IO$EvalOn as $h_Lcats_effect_IO$EvalOn };
$h_Lcats_effect_IO$EvalOn.prototype = $c_Lcats_effect_IO$EvalOn.prototype;
$c_Lcats_effect_IO$EvalOn.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$EvalOn.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_IO$EvalOn.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$EvalOn)) {
    var x = this.Lcats_effect_IO$EvalOn__f_ioa;
    var x$2 = x$0.Lcats_effect_IO$EvalOn__f_ioa;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_IO$EvalOn__f_ec;
      var x$4 = x$0.Lcats_effect_IO$EvalOn__f_ec;
      return (x$3 === x$4);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$EvalOn.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_IO$EvalOn.prototype.productPrefix__T = (function() {
  return "EvalOn";
});
$c_Lcats_effect_IO$EvalOn.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$EvalOn__f_ioa;
  }
  if ((n === 1)) {
    return this.Lcats_effect_IO$EvalOn__f_ec;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$EvalOn.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "ioa";
  }
  if ((n === 1)) {
    return "ec";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$EvalOn.prototype.tag__B = (function() {
  return 20;
});
function $isArrayOf_Lcats_effect_IO$EvalOn(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$EvalOn)));
}
export { $isArrayOf_Lcats_effect_IO$EvalOn as $isArrayOf_Lcats_effect_IO$EvalOn };
var $d_Lcats_effect_IO$EvalOn = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IO$EvalOn, "cats.effect.IO$EvalOn", ({
  Lcats_effect_IO$EvalOn: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_effect_IO$EvalOn as $d_Lcats_effect_IO$EvalOn };
/** @constructor */
function $c_Lcats_effect_IO$FlatMap(ioe, f, event) {
  this.Lcats_effect_IO$FlatMap__f_ioe = null;
  this.Lcats_effect_IO$FlatMap__f_f = null;
  this.Lcats_effect_IO$FlatMap__f_event = null;
  this.Lcats_effect_IO$FlatMap__f_ioe = ioe;
  this.Lcats_effect_IO$FlatMap__f_f = f;
  this.Lcats_effect_IO$FlatMap__f_event = event;
}
export { $c_Lcats_effect_IO$FlatMap as $c_Lcats_effect_IO$FlatMap };
$c_Lcats_effect_IO$FlatMap.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$FlatMap.prototype.constructor = $c_Lcats_effect_IO$FlatMap;
/** @constructor */
function $h_Lcats_effect_IO$FlatMap() {
}
export { $h_Lcats_effect_IO$FlatMap as $h_Lcats_effect_IO$FlatMap };
$h_Lcats_effect_IO$FlatMap.prototype = $c_Lcats_effect_IO$FlatMap.prototype;
$c_Lcats_effect_IO$FlatMap.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$FlatMap.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_IO$FlatMap.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$FlatMap)) {
    var x = this.Lcats_effect_IO$FlatMap__f_ioe;
    var x$2 = x$0.Lcats_effect_IO$FlatMap__f_ioe;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_IO$FlatMap__f_f;
      var x$4 = x$0.Lcats_effect_IO$FlatMap__f_f;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Lcats_effect_IO$FlatMap__f_event;
      var x$6 = x$0.Lcats_effect_IO$FlatMap__f_event;
      return (x$5 === x$6);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$FlatMap.prototype.productArity__I = (function() {
  return 3;
});
$c_Lcats_effect_IO$FlatMap.prototype.productPrefix__T = (function() {
  return "FlatMap";
});
$c_Lcats_effect_IO$FlatMap.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lcats_effect_IO$FlatMap__f_ioe;
      break;
    }
    case 1: {
      return this.Lcats_effect_IO$FlatMap__f_f;
      break;
    }
    case 2: {
      return this.Lcats_effect_IO$FlatMap__f_event;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lcats_effect_IO$FlatMap.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "ioe";
      break;
    }
    case 1: {
      return "f";
      break;
    }
    case 2: {
      return "event";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lcats_effect_IO$FlatMap.prototype.tag__B = (function() {
  return 7;
});
function $isArrayOf_Lcats_effect_IO$FlatMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$FlatMap)));
}
export { $isArrayOf_Lcats_effect_IO$FlatMap as $isArrayOf_Lcats_effect_IO$FlatMap };
var $d_Lcats_effect_IO$FlatMap = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IO$FlatMap, "cats.effect.IO$FlatMap", ({
  Lcats_effect_IO$FlatMap: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_effect_IO$FlatMap as $d_Lcats_effect_IO$FlatMap };
/** @constructor */
function $c_Lcats_effect_IO$HandleErrorWith(ioa, f, event) {
  this.Lcats_effect_IO$HandleErrorWith__f_ioa = null;
  this.Lcats_effect_IO$HandleErrorWith__f_f = null;
  this.Lcats_effect_IO$HandleErrorWith__f_event = null;
  this.Lcats_effect_IO$HandleErrorWith__f_ioa = ioa;
  this.Lcats_effect_IO$HandleErrorWith__f_f = f;
  this.Lcats_effect_IO$HandleErrorWith__f_event = event;
}
export { $c_Lcats_effect_IO$HandleErrorWith as $c_Lcats_effect_IO$HandleErrorWith };
$c_Lcats_effect_IO$HandleErrorWith.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$HandleErrorWith.prototype.constructor = $c_Lcats_effect_IO$HandleErrorWith;
/** @constructor */
function $h_Lcats_effect_IO$HandleErrorWith() {
}
export { $h_Lcats_effect_IO$HandleErrorWith as $h_Lcats_effect_IO$HandleErrorWith };
$h_Lcats_effect_IO$HandleErrorWith.prototype = $c_Lcats_effect_IO$HandleErrorWith.prototype;
$c_Lcats_effect_IO$HandleErrorWith.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$HandleErrorWith.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_IO$HandleErrorWith.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$HandleErrorWith)) {
    var x = this.Lcats_effect_IO$HandleErrorWith__f_ioa;
    var x$2 = x$0.Lcats_effect_IO$HandleErrorWith__f_ioa;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_IO$HandleErrorWith__f_f;
      var x$4 = x$0.Lcats_effect_IO$HandleErrorWith__f_f;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Lcats_effect_IO$HandleErrorWith__f_event;
      var x$6 = x$0.Lcats_effect_IO$HandleErrorWith__f_event;
      return (x$5 === x$6);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$HandleErrorWith.prototype.productArity__I = (function() {
  return 3;
});
$c_Lcats_effect_IO$HandleErrorWith.prototype.productPrefix__T = (function() {
  return "HandleErrorWith";
});
$c_Lcats_effect_IO$HandleErrorWith.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lcats_effect_IO$HandleErrorWith__f_ioa;
      break;
    }
    case 1: {
      return this.Lcats_effect_IO$HandleErrorWith__f_f;
      break;
    }
    case 2: {
      return this.Lcats_effect_IO$HandleErrorWith__f_event;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lcats_effect_IO$HandleErrorWith.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "ioa";
      break;
    }
    case 1: {
      return "f";
      break;
    }
    case 2: {
      return "event";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lcats_effect_IO$HandleErrorWith.prototype.tag__B = (function() {
  return 9;
});
function $isArrayOf_Lcats_effect_IO$HandleErrorWith(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$HandleErrorWith)));
}
export { $isArrayOf_Lcats_effect_IO$HandleErrorWith as $isArrayOf_Lcats_effect_IO$HandleErrorWith };
var $d_Lcats_effect_IO$HandleErrorWith = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IO$HandleErrorWith, "cats.effect.IO$HandleErrorWith", ({
  Lcats_effect_IO$HandleErrorWith: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_effect_IO$HandleErrorWith as $d_Lcats_effect_IO$HandleErrorWith };
/** @constructor */
function $c_Lcats_effect_IO$IOCont(body, event) {
  this.Lcats_effect_IO$IOCont__f_body = null;
  this.Lcats_effect_IO$IOCont__f_event = null;
  this.Lcats_effect_IO$IOCont__f_body = body;
  this.Lcats_effect_IO$IOCont__f_event = event;
}
export { $c_Lcats_effect_IO$IOCont as $c_Lcats_effect_IO$IOCont };
$c_Lcats_effect_IO$IOCont.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$IOCont.prototype.constructor = $c_Lcats_effect_IO$IOCont;
/** @constructor */
function $h_Lcats_effect_IO$IOCont() {
}
export { $h_Lcats_effect_IO$IOCont as $h_Lcats_effect_IO$IOCont };
$h_Lcats_effect_IO$IOCont.prototype = $c_Lcats_effect_IO$IOCont.prototype;
$c_Lcats_effect_IO$IOCont.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$IOCont.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_IO$IOCont.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$IOCont)) {
    var x = this.Lcats_effect_IO$IOCont__f_body;
    var x$2 = x$0.Lcats_effect_IO$IOCont__f_body;
    if ((x === x$2)) {
      var x$3 = this.Lcats_effect_IO$IOCont__f_event;
      var x$4 = x$0.Lcats_effect_IO$IOCont__f_event;
      return (x$3 === x$4);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$IOCont.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_IO$IOCont.prototype.productPrefix__T = (function() {
  return "IOCont";
});
$c_Lcats_effect_IO$IOCont.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$IOCont__f_body;
  }
  if ((n === 1)) {
    return this.Lcats_effect_IO$IOCont__f_event;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$IOCont.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "body";
  }
  if ((n === 1)) {
    return "event";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$IOCont.prototype.tag__B = (function() {
  return 14;
});
function $isArrayOf_Lcats_effect_IO$IOCont(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$IOCont)));
}
export { $isArrayOf_Lcats_effect_IO$IOCont as $isArrayOf_Lcats_effect_IO$IOCont };
var $d_Lcats_effect_IO$IOCont = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IO$IOCont, "cats.effect.IO$IOCont", ({
  Lcats_effect_IO$IOCont: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_effect_IO$IOCont as $d_Lcats_effect_IO$IOCont };
/** @constructor */
function $c_Lcats_effect_IO$IOCont$Get(state) {
  this.Lcats_effect_IO$IOCont$Get__f_state = null;
  this.Lcats_effect_IO$IOCont$Get__f_state = state;
}
export { $c_Lcats_effect_IO$IOCont$Get as $c_Lcats_effect_IO$IOCont$Get };
$c_Lcats_effect_IO$IOCont$Get.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$IOCont$Get.prototype.constructor = $c_Lcats_effect_IO$IOCont$Get;
/** @constructor */
function $h_Lcats_effect_IO$IOCont$Get() {
}
export { $h_Lcats_effect_IO$IOCont$Get as $h_Lcats_effect_IO$IOCont$Get };
$h_Lcats_effect_IO$IOCont$Get.prototype = $c_Lcats_effect_IO$IOCont$Get.prototype;
$c_Lcats_effect_IO$IOCont$Get.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$IOCont$Get.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_IO$IOCont$Get.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$IOCont$Get)) {
    var x = this.Lcats_effect_IO$IOCont$Get__f_state;
    var x$2 = x$0.Lcats_effect_IO$IOCont$Get__f_state;
    return (x === x$2);
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$IOCont$Get.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_IO$IOCont$Get.prototype.productPrefix__T = (function() {
  return "Get";
});
$c_Lcats_effect_IO$IOCont$Get.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$IOCont$Get__f_state;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$IOCont$Get.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "state";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$IOCont$Get.prototype.tag__B = (function() {
  return 15;
});
function $isArrayOf_Lcats_effect_IO$IOCont$Get(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$IOCont$Get)));
}
export { $isArrayOf_Lcats_effect_IO$IOCont$Get as $isArrayOf_Lcats_effect_IO$IOCont$Get };
var $d_Lcats_effect_IO$IOCont$Get = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IO$IOCont$Get, "cats.effect.IO$IOCont$Get", ({
  Lcats_effect_IO$IOCont$Get: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_effect_IO$IOCont$Get as $d_Lcats_effect_IO$IOCont$Get };
function $isArrayOf_Lcats_effect_IO$Local(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Local)));
}
export { $isArrayOf_Lcats_effect_IO$Local as $isArrayOf_Lcats_effect_IO$Local };
/** @constructor */
function $c_Lcats_effect_IO$Map(ioe, f, event) {
  this.Lcats_effect_IO$Map__f_ioe = null;
  this.Lcats_effect_IO$Map__f_f = null;
  this.Lcats_effect_IO$Map__f_event = null;
  this.Lcats_effect_IO$Map__f_ioe = ioe;
  this.Lcats_effect_IO$Map__f_f = f;
  this.Lcats_effect_IO$Map__f_event = event;
}
export { $c_Lcats_effect_IO$Map as $c_Lcats_effect_IO$Map };
$c_Lcats_effect_IO$Map.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Map.prototype.constructor = $c_Lcats_effect_IO$Map;
/** @constructor */
function $h_Lcats_effect_IO$Map() {
}
export { $h_Lcats_effect_IO$Map as $h_Lcats_effect_IO$Map };
$h_Lcats_effect_IO$Map.prototype = $c_Lcats_effect_IO$Map.prototype;
$c_Lcats_effect_IO$Map.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Map.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_IO$Map.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Map)) {
    var x = this.Lcats_effect_IO$Map__f_ioe;
    var x$2 = x$0.Lcats_effect_IO$Map__f_ioe;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_IO$Map__f_f;
      var x$4 = x$0.Lcats_effect_IO$Map__f_f;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Lcats_effect_IO$Map__f_event;
      var x$6 = x$0.Lcats_effect_IO$Map__f_event;
      return (x$5 === x$6);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$Map.prototype.productArity__I = (function() {
  return 3;
});
$c_Lcats_effect_IO$Map.prototype.productPrefix__T = (function() {
  return "Map";
});
$c_Lcats_effect_IO$Map.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lcats_effect_IO$Map__f_ioe;
      break;
    }
    case 1: {
      return this.Lcats_effect_IO$Map__f_f;
      break;
    }
    case 2: {
      return this.Lcats_effect_IO$Map__f_event;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lcats_effect_IO$Map.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "ioe";
      break;
    }
    case 1: {
      return "f";
      break;
    }
    case 2: {
      return "event";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lcats_effect_IO$Map.prototype.tag__B = (function() {
  return 6;
});
function $isArrayOf_Lcats_effect_IO$Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Map)));
}
export { $isArrayOf_Lcats_effect_IO$Map as $isArrayOf_Lcats_effect_IO$Map };
var $d_Lcats_effect_IO$Map = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IO$Map, "cats.effect.IO$Map", ({
  Lcats_effect_IO$Map: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_effect_IO$Map as $d_Lcats_effect_IO$Map };
/** @constructor */
function $c_Lcats_effect_IO$OnCancel(ioa, fin) {
  this.Lcats_effect_IO$OnCancel__f_ioa = null;
  this.Lcats_effect_IO$OnCancel__f_fin = null;
  this.Lcats_effect_IO$OnCancel__f_ioa = ioa;
  this.Lcats_effect_IO$OnCancel__f_fin = fin;
}
export { $c_Lcats_effect_IO$OnCancel as $c_Lcats_effect_IO$OnCancel };
$c_Lcats_effect_IO$OnCancel.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$OnCancel.prototype.constructor = $c_Lcats_effect_IO$OnCancel;
/** @constructor */
function $h_Lcats_effect_IO$OnCancel() {
}
export { $h_Lcats_effect_IO$OnCancel as $h_Lcats_effect_IO$OnCancel };
$h_Lcats_effect_IO$OnCancel.prototype = $c_Lcats_effect_IO$OnCancel.prototype;
$c_Lcats_effect_IO$OnCancel.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$OnCancel.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_IO$OnCancel.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$OnCancel)) {
    var x = this.Lcats_effect_IO$OnCancel__f_ioa;
    var x$2 = x$0.Lcats_effect_IO$OnCancel__f_ioa;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_IO$OnCancel__f_fin;
      var x$4 = x$0.Lcats_effect_IO$OnCancel__f_fin;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$OnCancel.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_IO$OnCancel.prototype.productPrefix__T = (function() {
  return "OnCancel";
});
$c_Lcats_effect_IO$OnCancel.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$OnCancel__f_ioa;
  }
  if ((n === 1)) {
    return this.Lcats_effect_IO$OnCancel__f_fin;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$OnCancel.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "ioa";
  }
  if ((n === 1)) {
    return "fin";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$OnCancel.prototype.tag__B = (function() {
  return 11;
});
function $isArrayOf_Lcats_effect_IO$OnCancel(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$OnCancel)));
}
export { $isArrayOf_Lcats_effect_IO$OnCancel as $isArrayOf_Lcats_effect_IO$OnCancel };
var $d_Lcats_effect_IO$OnCancel = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IO$OnCancel, "cats.effect.IO$OnCancel", ({
  Lcats_effect_IO$OnCancel: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_effect_IO$OnCancel as $d_Lcats_effect_IO$OnCancel };
/** @constructor */
function $c_Lcats_effect_IO$Pure(value) {
  this.Lcats_effect_IO$Pure__f_value = null;
  this.Lcats_effect_IO$Pure__f_value = value;
}
export { $c_Lcats_effect_IO$Pure as $c_Lcats_effect_IO$Pure };
$c_Lcats_effect_IO$Pure.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Pure.prototype.constructor = $c_Lcats_effect_IO$Pure;
/** @constructor */
function $h_Lcats_effect_IO$Pure() {
}
export { $h_Lcats_effect_IO$Pure as $h_Lcats_effect_IO$Pure };
$h_Lcats_effect_IO$Pure.prototype = $c_Lcats_effect_IO$Pure.prototype;
$c_Lcats_effect_IO$Pure.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Pure.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_IO$Pure.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Pure)) {
    var x = this.Lcats_effect_IO$Pure__f_value;
    var y = x$0.Lcats_effect_IO$Pure__f_value;
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$Pure.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_IO$Pure.prototype.productPrefix__T = (function() {
  return "Pure";
});
$c_Lcats_effect_IO$Pure.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$Pure__f_value;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Pure.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Pure.prototype.tag__B = (function() {
  return 0;
});
$c_Lcats_effect_IO$Pure.prototype.toString__T = (function() {
  return (("IO(" + this.Lcats_effect_IO$Pure__f_value) + ")");
});
function $isArrayOf_Lcats_effect_IO$Pure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Pure)));
}
export { $isArrayOf_Lcats_effect_IO$Pure as $isArrayOf_Lcats_effect_IO$Pure };
var $d_Lcats_effect_IO$Pure = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IO$Pure, "cats.effect.IO$Pure", ({
  Lcats_effect_IO$Pure: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_effect_IO$Pure as $d_Lcats_effect_IO$Pure };
/** @constructor */
function $c_Lcats_effect_IO$RacePair(ioa, iob) {
  this.Lcats_effect_IO$RacePair__f_ioa = null;
  this.Lcats_effect_IO$RacePair__f_iob = null;
  this.Lcats_effect_IO$RacePair__f_ioa = ioa;
  this.Lcats_effect_IO$RacePair__f_iob = iob;
}
export { $c_Lcats_effect_IO$RacePair as $c_Lcats_effect_IO$RacePair };
$c_Lcats_effect_IO$RacePair.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$RacePair.prototype.constructor = $c_Lcats_effect_IO$RacePair;
/** @constructor */
function $h_Lcats_effect_IO$RacePair() {
}
export { $h_Lcats_effect_IO$RacePair as $h_Lcats_effect_IO$RacePair };
$h_Lcats_effect_IO$RacePair.prototype = $c_Lcats_effect_IO$RacePair.prototype;
$c_Lcats_effect_IO$RacePair.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$RacePair.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_IO$RacePair.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$RacePair)) {
    var x = this.Lcats_effect_IO$RacePair__f_ioa;
    var x$2 = x$0.Lcats_effect_IO$RacePair__f_ioa;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_IO$RacePair__f_iob;
      var x$4 = x$0.Lcats_effect_IO$RacePair__f_iob;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$RacePair.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_IO$RacePair.prototype.productPrefix__T = (function() {
  return "RacePair";
});
$c_Lcats_effect_IO$RacePair.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$RacePair__f_ioa;
  }
  if ((n === 1)) {
    return this.Lcats_effect_IO$RacePair__f_iob;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$RacePair.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "ioa";
  }
  if ((n === 1)) {
    return "iob";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$RacePair.prototype.tag__B = (function() {
  return 18;
});
function $isArrayOf_Lcats_effect_IO$RacePair(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$RacePair)));
}
export { $isArrayOf_Lcats_effect_IO$RacePair as $isArrayOf_Lcats_effect_IO$RacePair };
var $d_Lcats_effect_IO$RacePair = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IO$RacePair, "cats.effect.IO$RacePair", ({
  Lcats_effect_IO$RacePair: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_effect_IO$RacePair as $d_Lcats_effect_IO$RacePair };
/** @constructor */
function $c_Lcats_effect_IO$Sleep(delay) {
  this.Lcats_effect_IO$Sleep__f_delay = null;
  this.Lcats_effect_IO$Sleep__f_delay = delay;
}
export { $c_Lcats_effect_IO$Sleep as $c_Lcats_effect_IO$Sleep };
$c_Lcats_effect_IO$Sleep.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Sleep.prototype.constructor = $c_Lcats_effect_IO$Sleep;
/** @constructor */
function $h_Lcats_effect_IO$Sleep() {
}
export { $h_Lcats_effect_IO$Sleep as $h_Lcats_effect_IO$Sleep };
$h_Lcats_effect_IO$Sleep.prototype = $c_Lcats_effect_IO$Sleep.prototype;
$c_Lcats_effect_IO$Sleep.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Sleep.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_IO$Sleep.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Sleep)) {
    var x = this.Lcats_effect_IO$Sleep__f_delay;
    var x$2 = x$0.Lcats_effect_IO$Sleep__f_delay;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$Sleep.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_IO$Sleep.prototype.productPrefix__T = (function() {
  return "Sleep";
});
$c_Lcats_effect_IO$Sleep.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$Sleep__f_delay;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Sleep.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "delay";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Sleep.prototype.tag__B = (function() {
  return 19;
});
function $isArrayOf_Lcats_effect_IO$Sleep(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Sleep)));
}
export { $isArrayOf_Lcats_effect_IO$Sleep as $isArrayOf_Lcats_effect_IO$Sleep };
var $d_Lcats_effect_IO$Sleep = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IO$Sleep, "cats.effect.IO$Sleep", ({
  Lcats_effect_IO$Sleep: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_effect_IO$Sleep as $d_Lcats_effect_IO$Sleep };
/** @constructor */
function $c_Lcats_effect_IO$Start(ioa) {
  this.Lcats_effect_IO$Start__f_ioa = null;
  this.Lcats_effect_IO$Start__f_ioa = ioa;
}
export { $c_Lcats_effect_IO$Start as $c_Lcats_effect_IO$Start };
$c_Lcats_effect_IO$Start.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Start.prototype.constructor = $c_Lcats_effect_IO$Start;
/** @constructor */
function $h_Lcats_effect_IO$Start() {
}
export { $h_Lcats_effect_IO$Start as $h_Lcats_effect_IO$Start };
$h_Lcats_effect_IO$Start.prototype = $c_Lcats_effect_IO$Start.prototype;
$c_Lcats_effect_IO$Start.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Start.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_IO$Start.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Start)) {
    var x = this.Lcats_effect_IO$Start__f_ioa;
    var x$2 = x$0.Lcats_effect_IO$Start__f_ioa;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$Start.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_IO$Start.prototype.productPrefix__T = (function() {
  return "Start";
});
$c_Lcats_effect_IO$Start.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$Start__f_ioa;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Start.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "ioa";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Start.prototype.tag__B = (function() {
  return 17;
});
function $isArrayOf_Lcats_effect_IO$Start(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Start)));
}
export { $isArrayOf_Lcats_effect_IO$Start as $isArrayOf_Lcats_effect_IO$Start };
var $d_Lcats_effect_IO$Start = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IO$Start, "cats.effect.IO$Start", ({
  Lcats_effect_IO$Start: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_effect_IO$Start as $d_Lcats_effect_IO$Start };
/** @constructor */
function $c_Lcats_effect_IO$Uncancelable(body, event) {
  this.Lcats_effect_IO$Uncancelable__f_body = null;
  this.Lcats_effect_IO$Uncancelable__f_event = null;
  this.Lcats_effect_IO$Uncancelable__f_body = body;
  this.Lcats_effect_IO$Uncancelable__f_event = event;
}
export { $c_Lcats_effect_IO$Uncancelable as $c_Lcats_effect_IO$Uncancelable };
$c_Lcats_effect_IO$Uncancelable.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Uncancelable.prototype.constructor = $c_Lcats_effect_IO$Uncancelable;
/** @constructor */
function $h_Lcats_effect_IO$Uncancelable() {
}
export { $h_Lcats_effect_IO$Uncancelable as $h_Lcats_effect_IO$Uncancelable };
$h_Lcats_effect_IO$Uncancelable.prototype = $c_Lcats_effect_IO$Uncancelable.prototype;
$c_Lcats_effect_IO$Uncancelable.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Uncancelable.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_IO$Uncancelable.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Uncancelable)) {
    var x = this.Lcats_effect_IO$Uncancelable__f_body;
    var x$2 = x$0.Lcats_effect_IO$Uncancelable__f_body;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_IO$Uncancelable__f_event;
      var x$4 = x$0.Lcats_effect_IO$Uncancelable__f_event;
      return (x$3 === x$4);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$Uncancelable.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_IO$Uncancelable.prototype.productPrefix__T = (function() {
  return "Uncancelable";
});
$c_Lcats_effect_IO$Uncancelable.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$Uncancelable__f_body;
  }
  if ((n === 1)) {
    return this.Lcats_effect_IO$Uncancelable__f_event;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Uncancelable.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "body";
  }
  if ((n === 1)) {
    return "event";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Uncancelable.prototype.tag__B = (function() {
  return 12;
});
function $isArrayOf_Lcats_effect_IO$Uncancelable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Uncancelable)));
}
export { $isArrayOf_Lcats_effect_IO$Uncancelable as $isArrayOf_Lcats_effect_IO$Uncancelable };
var $d_Lcats_effect_IO$Uncancelable = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IO$Uncancelable, "cats.effect.IO$Uncancelable", ({
  Lcats_effect_IO$Uncancelable: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_effect_IO$Uncancelable as $d_Lcats_effect_IO$Uncancelable };
/** @constructor */
function $c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop(ioa, id, self) {
  this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_ioa = null;
  this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_id = 0;
  this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_self = null;
  this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_ioa = ioa;
  this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_id = id;
  this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_self = self;
}
export { $c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop as $c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop };
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype.constructor = $c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop;
/** @constructor */
function $h_Lcats_effect_IO$Uncancelable$UnmaskRunLoop() {
}
export { $h_Lcats_effect_IO$Uncancelable$UnmaskRunLoop as $h_Lcats_effect_IO$Uncancelable$UnmaskRunLoop };
$h_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype = $c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype;
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I("UnmaskRunLoop");
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_ioa;
  var data$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_id;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_self;
  var data$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$1);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3);
});
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop)) {
    if ((this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_id === x$0.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_id)) {
      var x = this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_ioa;
      var x$2 = x$0.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_ioa;
      var $x_1 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_self;
      var x$4 = x$0.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_self;
      return (x$3 === x$4);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype.productArity__I = (function() {
  return 3;
});
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype.productPrefix__T = (function() {
  return "UnmaskRunLoop";
});
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_ioa;
      break;
    }
    case 1: {
      return this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_id;
      break;
    }
    case 2: {
      return this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_self;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "ioa";
      break;
    }
    case 1: {
      return "id";
      break;
    }
    case 2: {
      return "self";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype.tag__B = (function() {
  return 13;
});
function $isArrayOf_Lcats_effect_IO$Uncancelable$UnmaskRunLoop(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Uncancelable$UnmaskRunLoop)));
}
export { $isArrayOf_Lcats_effect_IO$Uncancelable$UnmaskRunLoop as $isArrayOf_Lcats_effect_IO$Uncancelable$UnmaskRunLoop };
var $d_Lcats_effect_IO$Uncancelable$UnmaskRunLoop = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop, "cats.effect.IO$Uncancelable$UnmaskRunLoop", ({
  Lcats_effect_IO$Uncancelable$UnmaskRunLoop: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_effect_IO$Uncancelable$UnmaskRunLoop as $d_Lcats_effect_IO$Uncancelable$UnmaskRunLoop };
function $p_Lcats_effect_IOFiber__runLoop__Lcats_effect_IO__I__I__V($thiz, _cur0, cancelationIterations, autoCedeIterations) {
  var autoCedeIterations$tailLocal1 = autoCedeIterations;
  var cancelationIterations$tailLocal1 = cancelationIterations;
  var _cur0$tailLocal1 = _cur0;
  while (true) {
    if ((_cur0$tailLocal1 === $m_Lcats_effect_IO$EndFiber$())) {
      return (void 0);
    }
    var nextCancelation = (((-1) + cancelationIterations$tailLocal1) | 0);
    var nextAutoCede = autoCedeIterations$tailLocal1;
    if ((nextCancelation <= 0)) {
      nextCancelation = $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold;
      nextAutoCede = ((nextAutoCede - nextCancelation) | 0);
      if ((nextAutoCede <= 0)) {
        $thiz.Lcats_effect_IOFiber__f_resumeTag = 7;
        $thiz.Lcats_effect_IOFiber__f_resumeIO = _cur0$tailLocal1;
        var ec = $thiz.Lcats_effect_IOFiber__f_currentCtx;
        $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, $thiz);
        return (void 0);
      }
    }
    if ($p_Lcats_effect_IOFiber__shouldFinalize__Z($thiz)) {
      var fin = $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO($thiz, null);
      var cancelationIterations$tailLocal1$tmp1 = nextCancelation;
      var autoCedeIterations$tailLocal1$tmp1 = nextAutoCede;
      _cur0$tailLocal1 = fin;
      cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp1;
      autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp1;
    } else {
      if ((_cur0$tailLocal1 === null)) {
        var t = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
        var cur0 = new $c_Lcats_effect_IO$Error(t);
      } else {
        var cur0 = _cur0$tailLocal1;
      }
      var x40 = cur0.tag__B();
      switch (x40) {
        case 0: {
          var _cur0$tailLocal1$tmp2 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, cur0.Lcats_effect_IO$Pure__f_value, 0);
          var cancelationIterations$tailLocal1$tmp2 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp2 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp2;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp2;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp2;
          break;
        }
        case 1: {
          var ex = cur0.Lcats_effect_IO$Error__f_t;
          if ((!$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(ex))) {
            $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(ex);
          }
          var _cur0$tailLocal1$tmp3 = $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, ex, 0);
          var cancelationIterations$tailLocal1$tmp3 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp3 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp3;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp3;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp3;
          break;
        }
        case 2: {
          if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
            $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V($thiz, cur0.Lcats_effect_IO$Delay__f_event);
          }
          var error = null;
          try {
            var r = cur0.Lcats_effect_IO$Delay__f_thunk.apply__O();
          } catch (e) {
            var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
            matchResult2: {
              if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$2)) {
                error = e$2;
                break matchResult2;
              }
              $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(e$2);
            }
            var r = (void 0);
          }
          var next = ((error === null) ? $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, r, 0) : $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, error, 0));
          var cancelationIterations$tailLocal1$tmp4 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp4 = nextAutoCede;
          _cur0$tailLocal1 = next;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp4;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp4;
          break;
        }
        case 3: {
          var t$1 = $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_scheduler.nowMicros__J();
          var lo = t$1.RTLong__f_lo;
          var hi = t$1.RTLong__f_hi;
          var this$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_package$DurationLong(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi));
          var unit = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
          var t$2 = this$3.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
          var lo$1 = t$2.RTLong__f_lo;
          var hi$1 = t$2.RTLong__f_hi;
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$();
          var _cur0$tailLocal1$tmp5 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_FiniteDuration(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$1, hi$1), unit), 0);
          var cancelationIterations$tailLocal1$tmp5 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp5 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp5;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp5;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp5;
          break;
        }
        case 4: {
          var value = (1000000.0 * (+$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_System$NanoTime$().jl_System$NanoTime$__f_highPrecisionTimer.now()));
          var this$8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_RTLong$();
          var lo$2 = this$8.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
          var hi$2 = this$8.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          var this$10 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_package$DurationLong(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$2, hi$2));
          var unit$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
          var t$3 = this$10.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
          var lo$3 = t$3.RTLong__f_lo;
          var hi$3 = t$3.RTLong__f_hi;
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$();
          var _cur0$tailLocal1$tmp6 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_FiniteDuration(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$3, hi$3), unit$1), 0);
          var cancelationIterations$tailLocal1$tmp6 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp6 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp6;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp6;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp6;
          break;
        }
        case 5: {
          var _cur0$tailLocal1$tmp7 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, $thiz.Lcats_effect_IOFiber__f_currentCtx, 0);
          var cancelationIterations$tailLocal1$tmp7 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp7 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp7;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp7;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp7;
          break;
        }
        case 6: {
          if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
            $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V($thiz, cur0.Lcats_effect_IO$Map__f_event);
          }
          var ioe = cur0.Lcats_effect_IO$Map__f_ioe;
          var f = cur0.Lcats_effect_IO$Map__f_f;
          var x8 = ioe.tag__B();
          switch (x8) {
            case 0: {
              var _cur0$tailLocal1$tmp8 = $p_Lcats_effect_IOFiber__next$1__F1__O__Lcats_effect_IO($thiz, f, ioe.Lcats_effect_IO$Pure__f_value);
              var cancelationIterations$tailLocal1$tmp8 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp8 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp8;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp8;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp8;
              break;
            }
            case 1: {
              var ex$2 = ioe.Lcats_effect_IO$Error__f_t;
              if ((!$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(ex$2))) {
                $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(ex$2);
              }
              var _cur0$tailLocal1$tmp9 = $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, ex$2, 0);
              var cancelationIterations$tailLocal1$tmp9 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp9 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp9;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp9;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp9;
              break;
            }
            case 2: {
              if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
                $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V($thiz, ioe.Lcats_effect_IO$Delay__f_event);
              }
              var error$3 = null;
              try {
                var result = f.apply__O__O(ioe.Lcats_effect_IO$Delay__f_thunk.apply__O());
              } catch (e$3) {
                var e$4 = ((e$3 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e$3 : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e$3));
                matchResult4: {
                  if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$4)) {
                    error$3 = e$4;
                    break matchResult4;
                  }
                  $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(e$4);
                }
                var result = (void 0);
              }
              var nextIO = ((error$3 === null) ? $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, result, 0) : $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, error$3, 0));
              var cancelationIterations$tailLocal1$tmp10 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp10 = nextAutoCede;
              _cur0$tailLocal1 = nextIO;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp10;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp10;
              break;
            }
            case 3: {
              var t$4 = $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_scheduler.nowMicros__J();
              var lo$4 = t$4.RTLong__f_lo;
              var hi$4 = t$4.RTLong__f_hi;
              var this$14 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_package$DurationLong(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$4, hi$4));
              var unit$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
              var t$5 = this$14.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
              var lo$5 = t$5.RTLong__f_lo;
              var hi$5 = t$5.RTLong__f_hi;
              $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$();
              var realTime = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_FiniteDuration(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$5, hi$5), unit$2);
              var _cur0$tailLocal1$tmp11 = $p_Lcats_effect_IOFiber__next$1__F1__O__Lcats_effect_IO($thiz, f, realTime);
              var cancelationIterations$tailLocal1$tmp11 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp11 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp11;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp11;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp11;
              break;
            }
            case 4: {
              var value$1 = (1000000.0 * (+$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_System$NanoTime$().jl_System$NanoTime$__f_highPrecisionTimer.now()));
              var this$19 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_RTLong$();
              var lo$6 = this$19.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value$1);
              var hi$6 = this$19.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
              var this$21 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_package$DurationLong(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$6, hi$6));
              var unit$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
              var t$6 = this$21.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
              var lo$7 = t$6.RTLong__f_lo;
              var hi$7 = t$6.RTLong__f_hi;
              $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$();
              var monotonic = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_FiniteDuration(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$7, hi$7), unit$3);
              var _cur0$tailLocal1$tmp12 = $p_Lcats_effect_IOFiber__next$1__F1__O__Lcats_effect_IO($thiz, f, monotonic);
              var cancelationIterations$tailLocal1$tmp12 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp12 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp12;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp12;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp12;
              break;
            }
            case 5: {
              var ec$2 = $thiz.Lcats_effect_IOFiber__f_currentCtx;
              var _cur0$tailLocal1$tmp13 = $p_Lcats_effect_IOFiber__next$1__F1__O__Lcats_effect_IO($thiz, f, ec$2);
              var cancelationIterations$tailLocal1$tmp13 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp13 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp13;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp13;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp13;
              break;
            }
            default: {
              var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
              this$.push(f);
              var stack = $thiz.Lcats_effect_IOFiber__f_conts;
              var c = (stack[0] | 0);
              var use = ((((1 + (((1 + c) | 0) >> 3)) | 0) < (stack.length | 0)) ? stack : (stack.push(0), stack));
              var s = ((1 + (c >> 3)) | 0);
              var shift = ((7 & c) << 2);
              use[s] = ((use[s] | 0) & (~((-1) << shift)));
              use[0] = ((1 + (use[0] | 0)) | 0);
              $thiz.Lcats_effect_IOFiber__f_conts = use;
              var cancelationIterations$tailLocal1$tmp14 = nextCancelation;
              var autoCedeIterations$tailLocal1$tmp14 = nextAutoCede;
              _cur0$tailLocal1 = ioe;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp14;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp14;
            }
          }
          break;
        }
        case 7: {
          if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
            $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V($thiz, cur0.Lcats_effect_IO$FlatMap__f_event);
          }
          var ioe$2 = cur0.Lcats_effect_IO$FlatMap__f_ioe;
          var f$2 = cur0.Lcats_effect_IO$FlatMap__f_f;
          var x13 = ioe$2.tag__B();
          switch (x13) {
            case 0: {
              var _cur0$tailLocal1$tmp15 = $p_Lcats_effect_IOFiber__next$2__F1__O__Lcats_effect_IO($thiz, f$2, ioe$2.Lcats_effect_IO$Pure__f_value);
              var cancelationIterations$tailLocal1$tmp15 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp15 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp15;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp15;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp15;
              break;
            }
            case 1: {
              var ex$3 = ioe$2.Lcats_effect_IO$Error__f_t;
              if ((!$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(ex$3))) {
                $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(ex$3);
              }
              var _cur0$tailLocal1$tmp16 = $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, ex$3, 0);
              var cancelationIterations$tailLocal1$tmp16 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp16 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp16;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp16;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp16;
              break;
            }
            case 2: {
              if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
                $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V($thiz, ioe$2.Lcats_effect_IO$Delay__f_event);
              }
              try {
                var result$2 = f$2.apply__O__O(ioe$2.Lcats_effect_IO$Delay__f_thunk.apply__O());
              } catch (e$5) {
                var e$6 = ((e$5 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e$5 : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e$5));
                matchResult7: {
                  var result$2;
                  if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$6)) {
                    var result$2 = $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, e$6, 0);
                    break matchResult7;
                  }
                  $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(e$6);
                }
              }
              var cancelationIterations$tailLocal1$tmp17 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp17 = nextAutoCede;
              _cur0$tailLocal1 = result$2;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp17;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp17;
              break;
            }
            case 3: {
              var t$7 = $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_scheduler.nowMicros__J();
              var lo$8 = t$7.RTLong__f_lo;
              var hi$8 = t$7.RTLong__f_hi;
              var this$27 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_package$DurationLong(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$8, hi$8));
              var unit$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
              var t$8 = this$27.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
              var lo$9 = t$8.RTLong__f_lo;
              var hi$9 = t$8.RTLong__f_hi;
              $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$();
              var realTime$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_FiniteDuration(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$9, hi$9), unit$4);
              var _cur0$tailLocal1$tmp18 = $p_Lcats_effect_IOFiber__next$2__F1__O__Lcats_effect_IO($thiz, f$2, realTime$2);
              var cancelationIterations$tailLocal1$tmp18 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp18 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp18;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp18;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp18;
              break;
            }
            case 4: {
              var value$2 = (1000000.0 * (+$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_System$NanoTime$().jl_System$NanoTime$__f_highPrecisionTimer.now()));
              var this$32 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_RTLong$();
              var lo$10 = this$32.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value$2);
              var hi$10 = this$32.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
              var this$34 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_package$DurationLong(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$10, hi$10));
              var unit$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
              var t$9 = this$34.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
              var lo$11 = t$9.RTLong__f_lo;
              var hi$11 = t$9.RTLong__f_hi;
              $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$();
              var monotonic$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_FiniteDuration(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$11, hi$11), unit$5);
              var _cur0$tailLocal1$tmp19 = $p_Lcats_effect_IOFiber__next$2__F1__O__Lcats_effect_IO($thiz, f$2, monotonic$2);
              var cancelationIterations$tailLocal1$tmp19 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp19 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp19;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp19;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp19;
              break;
            }
            case 5: {
              var ec$3 = $thiz.Lcats_effect_IOFiber__f_currentCtx;
              var _cur0$tailLocal1$tmp20 = $p_Lcats_effect_IOFiber__next$2__F1__O__Lcats_effect_IO($thiz, f$2, ec$3);
              var cancelationIterations$tailLocal1$tmp20 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp20 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp20;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp20;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp20;
              break;
            }
            default: {
              var this$$1 = $thiz.Lcats_effect_IOFiber__f_objectState;
              this$$1.push(f$2);
              var stack$1 = $thiz.Lcats_effect_IOFiber__f_conts;
              var c$1 = (stack$1[0] | 0);
              var use$1 = ((((1 + (((1 + c$1) | 0) >> 3)) | 0) < (stack$1.length | 0)) ? stack$1 : (stack$1.push(0), stack$1));
              var s$1 = ((1 + (c$1 >> 3)) | 0);
              var shift$1 = ((7 & c$1) << 2);
              use$1[s$1] = (((use$1[s$1] | 0) & (~((-1) << shift$1))) | (1 << shift$1));
              use$1[0] = ((1 + (use$1[0] | 0)) | 0);
              $thiz.Lcats_effect_IOFiber__f_conts = use$1;
              var cancelationIterations$tailLocal1$tmp21 = nextCancelation;
              var autoCedeIterations$tailLocal1$tmp21 = nextAutoCede;
              _cur0$tailLocal1 = ioe$2;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp21;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp21;
            }
          }
          break;
        }
        case 8: {
          var ioa = cur0.Lcats_effect_IO$Attempt__f_ioa;
          var x16 = ioa.tag__B();
          switch (x16) {
            case 0: {
              var value$3 = ioa.Lcats_effect_IO$Pure__f_value;
              var _cur0$tailLocal1$tmp22 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value$3), 0);
              var cancelationIterations$tailLocal1$tmp22 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp22 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp22;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp22;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp22;
              break;
            }
            case 1: {
              var t$7$1 = ioa.Lcats_effect_IO$Error__f_t;
              if ((!$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(t$7$1))) {
                $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(t$7$1);
              }
              $m_Lcats_effect_tracing_Tracing$().augmentThrowable__Z__jl_Throwable__Lcats_effect_tracing_RingBuffer__V($thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_enhancedExceptions, t$7$1, $thiz.Lcats_effect_IOFiber__f_tracingEvents);
              var _cur0$tailLocal1$tmp23 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(t$7$1), 0);
              var cancelationIterations$tailLocal1$tmp23 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp23 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp23;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp23;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp23;
              break;
            }
            case 2: {
              if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
                $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V($thiz, ioa.Lcats_effect_IO$Delay__f_event);
              }
              var error$6 = null;
              try {
                var result$3 = ioa.Lcats_effect_IO$Delay__f_thunk.apply__O();
              } catch (e$7) {
                var e$8 = ((e$7 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e$7 : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e$7));
                matchResult9: {
                  if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$8)) {
                    $m_Lcats_effect_tracing_Tracing$().augmentThrowable__Z__jl_Throwable__Lcats_effect_tracing_RingBuffer__V($thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_enhancedExceptions, e$8, $thiz.Lcats_effect_IOFiber__f_tracingEvents);
                    error$6 = e$8;
                    break matchResult9;
                  }
                  $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(e$8);
                }
                var result$3 = (void 0);
              }
              if ((error$6 === null)) {
                var next$2 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(result$3), 0);
              } else {
                var value$4 = error$6;
                var next$2 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value$4), 0);
              }
              var cancelationIterations$tailLocal1$tmp24 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp24 = nextAutoCede;
              _cur0$tailLocal1 = next$2;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp24;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp24;
              break;
            }
            case 3: {
              var t$10 = $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_scheduler.nowMicros__J();
              var lo$12 = t$10.RTLong__f_lo;
              var hi$12 = t$10.RTLong__f_hi;
              var this$44 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_package$DurationLong(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$12, hi$12));
              var unit$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
              var t$11 = this$44.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
              var lo$13 = t$11.RTLong__f_lo;
              var hi$13 = t$11.RTLong__f_hi;
              $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$();
              var realTime$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_FiniteDuration(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$13, hi$13), unit$6);
              var _cur0$tailLocal1$tmp25 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(realTime$3), 0);
              var cancelationIterations$tailLocal1$tmp25 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp25 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp25;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp25;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp25;
              break;
            }
            case 4: {
              var value$5 = (1000000.0 * (+$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_System$NanoTime$().jl_System$NanoTime$__f_highPrecisionTimer.now()));
              var this$50 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_RTLong$();
              var lo$14 = this$50.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value$5);
              var hi$14 = this$50.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
              var this$52 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_package$DurationLong(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$14, hi$14));
              var unit$7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
              var t$12 = this$52.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
              var lo$15 = t$12.RTLong__f_lo;
              var hi$15 = t$12.RTLong__f_hi;
              $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$();
              var monotonic$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_FiniteDuration(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$15, hi$15), unit$7);
              var _cur0$tailLocal1$tmp26 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(monotonic$3), 0);
              var cancelationIterations$tailLocal1$tmp26 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp26 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp26;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp26;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp26;
              break;
            }
            case 5: {
              var ec$4 = $thiz.Lcats_effect_IOFiber__f_currentCtx;
              var _cur0$tailLocal1$tmp27 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(ec$4), 0);
              var cancelationIterations$tailLocal1$tmp27 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp27 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp27;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp27;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp27;
              break;
            }
            default: {
              var stack$2 = $thiz.Lcats_effect_IOFiber__f_conts;
              var c$2 = (stack$2[0] | 0);
              var use$2 = ((((1 + (((1 + c$2) | 0) >> 3)) | 0) < (stack$2.length | 0)) ? stack$2 : (stack$2.push(0), stack$2));
              var s$2 = ((1 + (c$2 >> 3)) | 0);
              var shift$2 = ((7 & c$2) << 2);
              use$2[s$2] = (((use$2[s$2] | 0) & (~((-1) << shift$2))) | (9 << shift$2));
              use$2[0] = ((1 + (use$2[0] | 0)) | 0);
              $thiz.Lcats_effect_IOFiber__f_conts = use$2;
              var cancelationIterations$tailLocal1$tmp28 = nextCancelation;
              var autoCedeIterations$tailLocal1$tmp28 = nextAutoCede;
              _cur0$tailLocal1 = ioa;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp28;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp28;
            }
          }
          break;
        }
        case 9: {
          if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
            $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V($thiz, cur0.Lcats_effect_IO$HandleErrorWith__f_event);
          }
          var this$$2 = $thiz.Lcats_effect_IOFiber__f_objectState;
          var a = cur0.Lcats_effect_IO$HandleErrorWith__f_f;
          this$$2.push(a);
          var stack$3 = $thiz.Lcats_effect_IOFiber__f_conts;
          var c$3 = (stack$3[0] | 0);
          var use$3 = ((((1 + (((1 + c$3) | 0) >> 3)) | 0) < (stack$3.length | 0)) ? stack$3 : (stack$3.push(0), stack$3));
          var s$3 = ((1 + (c$3 >> 3)) | 0);
          var shift$3 = ((7 & c$3) << 2);
          use$3[s$3] = (((use$3[s$3] | 0) & (~((-1) << shift$3))) | (5 << shift$3));
          use$3[0] = ((1 + (use$3[0] | 0)) | 0);
          $thiz.Lcats_effect_IOFiber__f_conts = use$3;
          var _cur0$tailLocal1$tmp29 = cur0.Lcats_effect_IO$HandleErrorWith__f_ioa;
          var cancelationIterations$tailLocal1$tmp29 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp29 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp29;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp29;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp29;
          break;
        }
        case 10: {
          $thiz.Lcats_effect_IOFiber__f_canceled = true;
          if ($p_Lcats_effect_IOFiber__isUnmasked__Z($thiz)) {
            var fin$2 = $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO($thiz, null);
            var cancelationIterations$tailLocal1$tmp30 = nextCancelation;
            var autoCedeIterations$tailLocal1$tmp30 = nextAutoCede;
            _cur0$tailLocal1 = fin$2;
            cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp30;
            autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp30;
          } else {
            var _cur0$tailLocal1$tmp31 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, (void 0), 0);
            var cancelationIterations$tailLocal1$tmp31 = nextCancelation;
            var autoCedeIterations$tailLocal1$tmp31 = nextAutoCede;
            _cur0$tailLocal1 = _cur0$tailLocal1$tmp31;
            cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp31;
            autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp31;
          }
          break;
        }
        case 11: {
          var this$$3 = $thiz.Lcats_effect_IOFiber__f_finalizers;
          var ioa$1 = cur0.Lcats_effect_IO$OnCancel__f_fin;
          var ec$1 = $thiz.Lcats_effect_IOFiber__f_currentCtx;
          var a$1 = new $c_Lcats_effect_IO$EvalOn(ioa$1, ec$1);
          this$$3.push(a$1);
          var stack$4 = $thiz.Lcats_effect_IOFiber__f_conts;
          var c$4 = (stack$4[0] | 0);
          var use$4 = ((((1 + (((1 + c$4) | 0) >> 3)) | 0) < (stack$4.length | 0)) ? stack$4 : (stack$4.push(0), stack$4));
          var s$4 = ((1 + (c$4 >> 3)) | 0);
          var shift$4 = ((7 & c$4) << 2);
          use$4[s$4] = (((use$4[s$4] | 0) & (~((-1) << shift$4))) | (6 << shift$4));
          use$4[0] = ((1 + (use$4[0] | 0)) | 0);
          $thiz.Lcats_effect_IOFiber__f_conts = use$4;
          var _cur0$tailLocal1$tmp32 = cur0.Lcats_effect_IO$OnCancel__f_ioa;
          var cancelationIterations$tailLocal1$tmp32 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp32 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp32;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp32;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp32;
          break;
        }
        case 12: {
          if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
            $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V($thiz, cur0.Lcats_effect_IO$Uncancelable__f_event);
          }
          $thiz.Lcats_effect_IOFiber__f_masks = ((1 + $thiz.Lcats_effect_IOFiber__f_masks) | 0);
          var id = $thiz.Lcats_effect_IOFiber__f_masks;
          var poll = new $c_Lcats_effect_IOFiber$$anon$1(id, $thiz);
          try {
            var next$3 = cur0.Lcats_effect_IO$Uncancelable__f_body.apply__O__O(poll);
          } catch (e$9) {
            var e$10 = ((e$9 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e$9 : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e$9));
            matchResult11: {
              var next$3;
              if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$10)) {
                $m_Lcats_effect_IO$();
                var next$3 = new $c_Lcats_effect_IO$Error(e$10);
                break matchResult11;
              }
              $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(e$10);
            }
          }
          var stack$5 = $thiz.Lcats_effect_IOFiber__f_conts;
          var c$5 = (stack$5[0] | 0);
          var use$5 = ((((1 + (((1 + c$5) | 0) >> 3)) | 0) < (stack$5.length | 0)) ? stack$5 : (stack$5.push(0), stack$5));
          var s$5 = ((1 + (c$5 >> 3)) | 0);
          var shift$5 = ((7 & c$5) << 2);
          use$5[s$5] = (((use$5[s$5] | 0) & (~((-1) << shift$5))) | (7 << shift$5));
          use$5[0] = ((1 + (use$5[0] | 0)) | 0);
          $thiz.Lcats_effect_IOFiber__f_conts = use$5;
          var cancelationIterations$tailLocal1$tmp33 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp33 = nextAutoCede;
          _cur0$tailLocal1 = next$3;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp33;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp33;
          break;
        }
        case 13: {
          if ((($thiz.Lcats_effect_IOFiber__f_masks === cur0.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_id) && ($thiz === cur0.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_self))) {
            $thiz.Lcats_effect_IOFiber__f_masks = (((-1) + $thiz.Lcats_effect_IOFiber__f_masks) | 0);
            var stack$6 = $thiz.Lcats_effect_IOFiber__f_conts;
            var c$6 = (stack$6[0] | 0);
            var use$6 = ((((1 + (((1 + c$6) | 0) >> 3)) | 0) < (stack$6.length | 0)) ? stack$6 : (stack$6.push(0), stack$6));
            var s$6 = ((1 + (c$6 >> 3)) | 0);
            var shift$6 = ((7 & c$6) << 2);
            use$6[s$6] = (((use$6[s$6] | 0) & (~((-1) << shift$6))) | (8 << shift$6));
            use$6[0] = ((1 + (use$6[0] | 0)) | 0);
            $thiz.Lcats_effect_IOFiber__f_conts = use$6;
          }
          var _cur0$tailLocal1$tmp34 = cur0.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_ioa;
          var cancelationIterations$tailLocal1$tmp34 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp34 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp34;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp34;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp34;
          break;
        }
        case 14: {
          var body = cur0.Lcats_effect_IO$IOCont__f_body;
          if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
            $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V($thiz, cur0.Lcats_effect_IO$IOCont__f_event);
          }
          var state = new $c_Lcats_effect_ContState($thiz.Lcats_effect_IOFiber__f_finalizing);
          var cb = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((state) => ((e$11) => {
            if ((e$11 === null)) {
              var value$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
              var result$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value$6);
            } else {
              var result$1 = e$11;
            }
            var waiting = state.Lcats_effect_ContState__f_waiting;
            $p_Lcats_effect_IOFiber__stateLoop$1__Lcats_effect_ContState__s_util_Either__s_util_Either__V($thiz, state, waiting, result$1);
          }))(state));
          var get = new $c_Lcats_effect_IO$IOCont$Get(state);
          try {
            var next$4 = body.apply__Lcats_effect_kernel_MonadCancel__F3($m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO).apply__O__O__O__O(cb, get, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_arrow_FunctionK$$anon$4());
          } catch (e$12) {
            var e$13 = ((e$12 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e$12 : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e$12));
            matchResult13: {
              var next$4;
              if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$13)) {
                $m_Lcats_effect_IO$();
                var next$4 = new $c_Lcats_effect_IO$Error(e$13);
                break matchResult13;
              }
              $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(e$13);
            }
          }
          var cancelationIterations$tailLocal1$tmp35 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp35 = nextAutoCede;
          _cur0$tailLocal1 = next$4;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp35;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp35;
          break;
        }
        case 15: {
          var state$3 = cur0.Lcats_effect_IO$IOCont$Get__f_state;
          var this$73 = $m_Lcats_effect_IO$();
          var thunk = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((state$3) => (() => {
            state$3.compareAndSet__O__O__Z(state$3.Lcats_effect_ContState__f_waiting, null);
          }))(state$3));
          var fin$3 = this$73.delay__F0__Lcats_effect_IO(thunk);
          var this$$4 = $thiz.Lcats_effect_IOFiber__f_finalizers;
          this$$4.push(fin$3);
          var stack$7 = $thiz.Lcats_effect_IOFiber__f_conts;
          var c$7 = (stack$7[0] | 0);
          var use$7 = ((((1 + (((1 + c$7) | 0) >> 3)) | 0) < (stack$7.length | 0)) ? stack$7 : (stack$7.push(0), stack$7));
          var s$7 = ((1 + (c$7 >> 3)) | 0);
          var shift$7 = ((7 & c$7) << 2);
          use$7[s$7] = (((use$7[s$7] | 0) & (~((-1) << shift$7))) | (6 << shift$7));
          use$7[0] = ((1 + (use$7[0] | 0)) | 0);
          $thiz.Lcats_effect_IOFiber__f_conts = use$7;
          if (state$3.compareAndSet__O__O__Z(null, state$3.Lcats_effect_ContState__f_waiting)) {
            state$3.Lcats_effect_ContState__f_wasFinalizing = $thiz.Lcats_effect_IOFiber__f_finalizing;
            if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
              state$3.Lcats_effect_ContState__f_handle = $p_Lcats_effect_IOFiber__monitor__Lcats_effect_unsafe_WeakBag$Handle($thiz);
              var this$$5 = $thiz.Lcats_effect_IOFiber__f_finalizers;
              var this$76 = $m_Lcats_effect_IO$();
              var thunk$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((state$3) => (() => {
                state$3.Lcats_effect_ContState__f_handle.deregister__V();
              }))(state$3));
              var a$2 = this$76.delay__F0__Lcats_effect_IO(thunk$1);
              this$$5.push(a$2);
              var stack$8 = $thiz.Lcats_effect_IOFiber__f_conts;
              var c$8 = (stack$8[0] | 0);
              var use$8 = ((((1 + (((1 + c$8) | 0) >> 3)) | 0) < (stack$8.length | 0)) ? stack$8 : (stack$8.push(0), stack$8));
              var s$8 = ((1 + (c$8 >> 3)) | 0);
              var shift$8 = ((7 & c$8) << 2);
              use$8[s$8] = (((use$8[s$8] | 0) & (~((-1) << shift$8))) | (6 << shift$8));
              use$8[0] = ((1 + (use$8[0] | 0)) | 0);
              $thiz.Lcats_effect_IOFiber__f_conts = use$8;
            }
            $thiz.getAndSet__Z__Z(true);
            if ($p_Lcats_effect_IOFiber__shouldFinalize__Z($thiz)) {
              if ($thiz.getAndSet__Z__Z(false)) {
                if ($p_Lcats_effect_IOFiber__shouldFinalize__Z($thiz)) {
                  var fin$4 = $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO($thiz, null);
                  var cancelationIterations$tailLocal1$tmp36 = nextCancelation;
                  var autoCedeIterations$tailLocal1$tmp36 = nextAutoCede;
                  _cur0$tailLocal1 = fin$4;
                  cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp36;
                  autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp36;
                } else {
                  $thiz.ju_concurrent_atomic_AtomicBoolean__f_value = true;
                  return (void 0);
                }
              } else {
                return (void 0);
              }
            } else {
              return (void 0);
            }
          } else {
            var result$4 = state$3.ju_concurrent_atomic_AtomicReference__f_value;
            if ((!$p_Lcats_effect_IOFiber__shouldFinalize__Z($thiz))) {
              matchResult14: {
                var next$5;
                if ((result$4 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
                  var t$14 = result$4.s_util_Left__f_value;
                  var next$5 = $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, t$14, 0);
                  break matchResult14;
                }
                if ((result$4 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
                  var a$3 = result$4.s_util_Right__f_value;
                  var next$5 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, a$3, 0);
                  break matchResult14;
                }
                throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(result$4);
              }
              var cancelationIterations$tailLocal1$tmp37 = nextCancelation;
              var autoCedeIterations$tailLocal1$tmp37 = nextAutoCede;
              _cur0$tailLocal1 = next$5;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp37;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp37;
            } else if (($thiz.Lcats_effect_IOFiber__f_outcome === null)) {
              var fin$5 = $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO($thiz, null);
              var cancelationIterations$tailLocal1$tmp38 = nextCancelation;
              var autoCedeIterations$tailLocal1$tmp38 = nextAutoCede;
              _cur0$tailLocal1 = fin$5;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp38;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp38;
            } else {
              return (void 0);
            }
          }
          break;
        }
        case 16: {
          $thiz.Lcats_effect_IOFiber__f_resumeTag = 6;
          var ec$5 = $thiz.Lcats_effect_IOFiber__f_currentCtx;
          $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec$5, $thiz);
          return (void 0);
          break;
        }
        case 17: {
          var ec$5$1 = $thiz.Lcats_effect_IOFiber__f_currentCtx;
          var fiber = new $c_Lcats_effect_IOFiber($thiz.Lcats_effect_IOFiber__f_localState, null, cur0.Lcats_effect_IO$Start__f_ioa, ec$5$1, $thiz.Lcats_effect_IOFiber__f_runtime);
          $p_Lcats_effect_IOFiber__scheduleFiber__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec$5$1, fiber);
          var _cur0$tailLocal1$tmp39 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, fiber, 0);
          var cancelationIterations$tailLocal1$tmp39 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp39 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp39;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp39;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp39;
          break;
        }
        case 18: {
          var next$6 = $m_Lcats_effect_IO$().async__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((cur$15) => ((cb$2) => {
            var this$90 = $m_Lcats_effect_IO$();
            var thunk$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((cb$2$1) => (() => {
              var ec$6 = $thiz.Lcats_effect_IOFiber__f_currentCtx;
              var rt = $thiz.Lcats_effect_IOFiber__f_runtime;
              var fiberA = new $c_Lcats_effect_IOFiber($thiz.Lcats_effect_IOFiber__f_localState, null, cur$15.Lcats_effect_IO$RacePair__f_ioa, ec$6, rt);
              var fiberB = new $c_Lcats_effect_IOFiber($thiz.Lcats_effect_IOFiber__f_localState, null, cur$15.Lcats_effect_IO$RacePair__f_iob, ec$6, rt);
              $p_Lcats_effect_IOFiber__setCallback__F1__V(fiberA, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((oc) => {
                var value$7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), oc, fiberB);
                var value$8 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value$7);
                cb$2$1.apply__O__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value$8));
              })));
              $p_Lcats_effect_IOFiber__setCallback__F1__V(fiberB, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((oc$2) => {
                var value$9 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), fiberA, oc$2);
                var value$10 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value$9);
                cb$2$1.apply__O__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value$10));
              })));
              $p_Lcats_effect_IOFiber__scheduleFiber__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec$6, fiberA);
              $p_Lcats_effect_IOFiber__scheduleFiber__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec$6, fiberB);
              var this$85 = fiberA.cancel__Lcats_effect_IO();
              var cancel = new $c_Lcats_effect_IO$Start(this$85).flatMap__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((cancelA) => {
                var this$87 = fiberB.cancel__Lcats_effect_IO();
                return new $c_Lcats_effect_IO$Start(this$87).flatMap__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((cancelA$2) => ((cancelB) => cancelA$2.join__O().flatMap__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((cancelB$2) => ((x$1) => cancelB$2.join__O().map__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1$2) => (void 0))))))(cancelB)))))(cancelA)));
              })));
              return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(cancel);
            }))(cb$2));
            return this$90.delay__F0__Lcats_effect_IO(thunk$2);
          }))(cur0)));
          var cancelationIterations$tailLocal1$tmp40 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp40 = nextAutoCede;
          _cur0$tailLocal1 = next$6;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp40;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp40;
          break;
        }
        case 19: {
          var delay$4 = cur0.Lcats_effect_IO$Sleep__f_delay;
          var a$4 = delay$4.s_concurrent_duration_FiniteDuration__f_length;
          var ahi = a$4.RTLong__f_hi;
          if (((ahi === 0) ? (a$4.RTLong__f_lo !== 0) : (ahi > 0))) {
            var next$7 = $m_Lcats_effect_IO$().async__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((delay$4) => ((cb$3) => {
              var this$95 = $m_Lcats_effect_IO$();
              var thunk$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((cb$2$2) => (() => {
                var scheduler = $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_scheduler;
                if (false) {
                  var cancel$1 = scheduler.sleepInternal__s_concurrent_duration_FiniteDuration__F1__jl_Runnable(delay$4, cb$2$2);
                  var cancelIO = new $c_Lcats_effect_IO$Delay(cancel$1, null);
                } else {
                  var cancel$2 = scheduler.sleep__s_concurrent_duration_FiniteDuration__jl_Runnable__jl_Runnable(delay$4, new $c_Lcats_effect_IOFiber$$anon$2(cb$2$2, $thiz));
                  var this$93 = $m_Lcats_effect_IO$();
                  var thunk$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
                    cancel$2.run__V();
                  }));
                  var cancelIO = this$93.delay__F0__Lcats_effect_IO(thunk$3);
                }
                return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(cancelIO);
              }))(cb$3));
              return this$95.delay__F0__Lcats_effect_IO(thunk$4);
            }))(delay$4)));
          } else {
            $m_Lcats_effect_IO$();
            var next$7 = $m_Lcats_effect_IO$Cede$();
          }
          var cancelationIterations$tailLocal1$tmp41 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp41 = nextAutoCede;
          _cur0$tailLocal1 = next$7;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp41;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp41;
          break;
        }
        case 20: {
          if ((cur0.Lcats_effect_IO$EvalOn__f_ec === $thiz.Lcats_effect_IOFiber__f_currentCtx)) {
            var _cur0$tailLocal1$tmp42 = cur0.Lcats_effect_IO$EvalOn__f_ioa;
            var cancelationIterations$tailLocal1$tmp42 = nextCancelation;
            var autoCedeIterations$tailLocal1$tmp42 = nextAutoCede;
            _cur0$tailLocal1 = _cur0$tailLocal1$tmp42;
            cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp42;
            autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp42;
          } else {
            var ec$6$1 = cur0.Lcats_effect_IO$EvalOn__f_ec;
            var this$$6 = $thiz.Lcats_effect_IOFiber__f_objectState;
            var a$5 = $thiz.Lcats_effect_IOFiber__f_currentCtx;
            this$$6.push(a$5);
            $thiz.Lcats_effect_IOFiber__f_currentCtx = ec$6$1;
            var stack$9 = $thiz.Lcats_effect_IOFiber__f_conts;
            var c$9 = (stack$9[0] | 0);
            var use$9 = ((((1 + (((1 + c$9) | 0) >> 3)) | 0) < (stack$9.length | 0)) ? stack$9 : (stack$9.push(0), stack$9));
            var s$9 = ((1 + (c$9 >> 3)) | 0);
            var shift$9 = ((7 & c$9) << 2);
            use$9[s$9] = (((use$9[s$9] | 0) & (~((-1) << shift$9))) | (4 << shift$9));
            use$9[0] = ((1 + (use$9[0] | 0)) | 0);
            $thiz.Lcats_effect_IOFiber__f_conts = use$9;
            $thiz.Lcats_effect_IOFiber__f_resumeTag = 7;
            $thiz.Lcats_effect_IOFiber__f_resumeIO = cur0.Lcats_effect_IO$EvalOn__f_ioa;
            if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
              var handle = $p_Lcats_effect_IOFiber__monitor__Lcats_effect_unsafe_WeakBag$Handle($thiz);
              var this$$7 = $thiz.Lcats_effect_IOFiber__f_objectState;
              this$$7.push(handle);
            }
            $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec$6$1, $thiz);
            return (void 0);
          }
          break;
        }
        case 21: {
          if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
            $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V($thiz, cur0.event__Lcats_effect_tracing_TracingEvent());
          }
          if ((cur0.hint__Lcats_effect_kernel_Sync$Type() === $m_Lcats_effect_IOFiber$().Lcats_effect_IOFiber$__f_TypeBlocking)) {
            var ec$7 = $thiz.Lcats_effect_IOFiber__f_currentCtx;
            if (false) {
              if (ec$7.canExecuteBlockingCode__Z()) {
                ec$7.prepareForBlocking__V();
                var error$7 = null;
                try {
                  var r$2 = cur0.thunk__F0().apply__O();
                } catch (e$14) {
                  var e$15 = ((e$14 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e$14 : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e$14));
                  matchResult17: {
                    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$15)) {
                      error$7 = e$15;
                      break matchResult17;
                    }
                    $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(e$15);
                  }
                  var r$2 = (void 0);
                }
                var next$8 = ((error$7 === null) ? $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, r$2, 0) : $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, error$7, 0));
                var cancelationIterations$tailLocal1$tmp43 = nextCancelation;
                var autoCedeIterations$tailLocal1$tmp43 = $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold;
                _cur0$tailLocal1 = next$8;
                cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp43;
                autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp43;
              } else {
                $p_Lcats_effect_IOFiber__blockingFallback__Lcats_effect_IO$Blocking__V($thiz, cur0);
                return (void 0);
              }
            } else {
              $p_Lcats_effect_IOFiber__blockingFallback__Lcats_effect_IO$Blocking__V($thiz, cur0);
              return (void 0);
            }
          } else {
            var _cur0$tailLocal1$tmp45 = $thiz.interruptibleImpl__Lcats_effect_IO$Blocking__Lcats_effect_IO(cur0);
            var cancelationIterations$tailLocal1$tmp45 = nextCancelation;
            var autoCedeIterations$tailLocal1$tmp45 = nextAutoCede;
            _cur0$tailLocal1 = _cur0$tailLocal1$tmp45;
            cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp45;
            autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp45;
          }
          break;
        }
        case 22: {
          matchResult19: {
            var \u03b41$___1;
            var \u03b41$___2;
            var x37 = cur0.f__F1().apply__O__O($thiz.Lcats_effect_IOFiber__f_localState);
            if ((x37 !== null)) {
              var nextLocalState = x37._1__O();
              var value$11 = x37._2__O();
              var \u03b41$___1 = nextLocalState;
              var \u03b41$___2 = value$11;
              break matchResult19;
            }
            throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x37);
          }
          var nextLocalState$2 = \u03b41$___1;
          var value$2$1 = \u03b41$___2;
          $thiz.Lcats_effect_IOFiber__f_localState = nextLocalState$2;
          var _cur0$tailLocal1$tmp46 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, value$2$1, 0);
          var cancelationIterations$tailLocal1$tmp46 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp46 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp46;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp46;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp46;
          break;
        }
        case 23: {
          var _cur0$tailLocal1$tmp47 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, $m_Lcats_effect_Trace$().apply__Lcats_effect_tracing_RingBuffer__Lcats_effect_Trace($thiz.Lcats_effect_IOFiber__f_tracingEvents), 0);
          var cancelationIterations$tailLocal1$tmp47 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp47 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp47;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp47;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp47;
          break;
        }
        case 24: {
          var _cur0$tailLocal1$tmp48 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, $thiz.Lcats_effect_IOFiber__f_runtime, 0);
          var cancelationIterations$tailLocal1$tmp48 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp48 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp48;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp48;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp48;
          break;
        }
        default: {
          throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x40);
        }
      }
    }
  }
}
export { $p_Lcats_effect_IOFiber__runLoop__Lcats_effect_IO__I__I__V as $p_Lcats_effect_IOFiber__runLoop__Lcats_effect_IO__I__I__V };
function $p_Lcats_effect_IOFiber__blockingFallback__Lcats_effect_IO$Blocking__V($thiz, cur) {
  $thiz.Lcats_effect_IOFiber__f_resumeTag = 5;
  $thiz.Lcats_effect_IOFiber__f_resumeIO = cur;
  if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
    var handle = $p_Lcats_effect_IOFiber__monitor__Lcats_effect_unsafe_WeakBag$Handle($thiz);
    var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
    this$.push(handle);
  }
  var ec = $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_blocking;
  $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, $thiz);
}
export { $p_Lcats_effect_IOFiber__blockingFallback__Lcats_effect_IO$Blocking__V as $p_Lcats_effect_IOFiber__blockingFallback__Lcats_effect_IO$Blocking__V };
function $p_Lcats_effect_IOFiber__done__Lcats_effect_kernel_Outcome__V($thiz, oc) {
  $thiz.Lcats_effect_IOFiber__f__join = ($m_Lcats_effect_IO$(), new $c_Lcats_effect_IO$Pure(oc));
  $thiz.Lcats_effect_IOFiber__f__cancel = $m_Lcats_effect_IO$().Lcats_effect_IO$__f__unit;
  $thiz.Lcats_effect_IOFiber__f_outcome = oc;
  var stack = $thiz.Lcats_effect_IOFiber__f_callbacks;
  if (((!(!(!stack.reduceRight($m_sjs_js_Any$().fromFunction2__F2__sjs_js_Function2(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((acc, cb) => {
    var acc$1 = (!(!acc));
    return ((cb !== null) ? (cb.apply__O__O(oc), true) : acc$1);
  }))), false)))) && $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_config.Lcats_effect_unsafe_IORuntimeConfig__f_reportUnhandledFiberErrors)) {
    if ((oc instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Errored)) {
      var x44 = oc.Lcats_effect_kernel_Outcome$Errored__f_e;
      $thiz.Lcats_effect_IOFiber__f_currentCtx.reportFailure__jl_Throwable__V(x44);
    }
  }
  $thiz.Lcats_effect_IOFiber__f_masks = 0;
  $thiz.Lcats_effect_IOFiber__f_resumeTag = 8;
  $thiz.Lcats_effect_IOFiber__f_resumeIO = null;
  $thiz.ju_concurrent_atomic_AtomicBoolean__f_value = false;
  $thiz.Lcats_effect_IOFiber__f_conts = null;
  var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
  this$.length = 0;
  var this$$1 = $thiz.Lcats_effect_IOFiber__f_finalizers;
  this$$1.length = 0;
  $thiz.Lcats_effect_IOFiber__f_currentCtx = null;
  if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
    $thiz.Lcats_effect_IOFiber__f_tracingEvents.invalidate__V();
  }
}
export { $p_Lcats_effect_IOFiber__done__Lcats_effect_kernel_Outcome__V as $p_Lcats_effect_IOFiber__done__Lcats_effect_kernel_Outcome__V };
function $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO($thiz, cb) {
  var this$ = $thiz.Lcats_effect_IOFiber__f_finalizers;
  if ((!((this$.length | 0) === 0))) {
    if ((!$thiz.Lcats_effect_IOFiber__f_finalizing)) {
      $thiz.Lcats_effect_IOFiber__f_finalizing = true;
      $thiz.Lcats_effect_IOFiber__f_conts = [0];
      var stack = $thiz.Lcats_effect_IOFiber__f_conts;
      var c = (stack[0] | 0);
      var use = ((((1 + (((1 + c) | 0) >> 3)) | 0) < (stack.length | 0)) ? stack : (stack.push(0), stack));
      var s = ((1 + (c >> 3)) | 0);
      var shift = ((7 & c) << 2);
      use[s] = (((use[s] | 0) & (~((-1) << shift))) | (2 << shift));
      use[0] = ((1 + (use[0] | 0)) | 0);
      $thiz.Lcats_effect_IOFiber__f_conts = use;
      var this$$2 = $thiz.Lcats_effect_IOFiber__f_objectState;
      this$$2.push(cb);
      $thiz.Lcats_effect_IOFiber__f_masks = ((1 + $thiz.Lcats_effect_IOFiber__f_masks) | 0);
    }
    var this$$3 = $thiz.Lcats_effect_IOFiber__f_finalizers;
    return this$$3.pop();
  } else {
    if ((cb !== null)) {
      cb.apply__O__O($m_Lcats_effect_IOFiber$().Lcats_effect_IOFiber$__f_RightUnit);
    }
    $p_Lcats_effect_IOFiber__done__Lcats_effect_kernel_Outcome__V($thiz, $m_Lcats_effect_IOFiber$().Lcats_effect_IOFiber$__f_OutcomeCanceled);
    return $m_Lcats_effect_IO$EndFiber$();
  }
}
export { $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO as $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO };
function $p_Lcats_effect_IOFiber__shouldFinalize__Z($thiz) {
  return ($thiz.Lcats_effect_IOFiber__f_canceled && $p_Lcats_effect_IOFiber__isUnmasked__Z($thiz));
}
export { $p_Lcats_effect_IOFiber__shouldFinalize__Z as $p_Lcats_effect_IOFiber__shouldFinalize__Z };
function $p_Lcats_effect_IOFiber__isUnmasked__Z($thiz) {
  return ($thiz.Lcats_effect_IOFiber__f_masks === 0);
}
export { $p_Lcats_effect_IOFiber__isUnmasked__Z as $p_Lcats_effect_IOFiber__isUnmasked__Z };
function $p_Lcats_effect_IOFiber__monitor__Lcats_effect_unsafe_WeakBag$Handle($thiz) {
  return $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_fiberMonitor.monitorSuspended__Lcats_effect_IOFiber__Lcats_effect_unsafe_WeakBag$Handle($thiz);
}
export { $p_Lcats_effect_IOFiber__monitor__Lcats_effect_unsafe_WeakBag$Handle as $p_Lcats_effect_IOFiber__monitor__Lcats_effect_unsafe_WeakBag$Handle };
function $p_Lcats_effect_IOFiber__setCallback__F1__V($thiz, cb) {
  var stack = $thiz.Lcats_effect_IOFiber__f_callbacks;
  stack[(((-1) + (stack.length | 0)) | 0)] = cb;
}
export { $p_Lcats_effect_IOFiber__setCallback__F1__V as $p_Lcats_effect_IOFiber__setCallback__F1__V };
function $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, result, depth) {
  var depth$tailLocal1 = depth;
  var result$tailLocal1 = result;
  while (true) {
    var stack = $thiz.Lcats_effect_IOFiber__f_conts;
    var c = (((-1) + (stack[0] | 0)) | 0);
    if ((c < 0)) {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_ArrayIndexOutOfBoundsException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_ArrayIndexOutOfBoundsException());
    }
    var op = (((15 & (((stack[((1 + (c >> 3)) | 0)] | 0) >>> ((7 & c) << 2)) | 0)) << 24) >> 24);
    stack[0] = (((-1) + (stack[0] | 0)) | 0);
    switch (op) {
      case 0: {
        var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
        var f = this$.pop();
        var error = null;
        try {
          var transformed = f.apply__O__O(result$tailLocal1);
        } catch (e) {
          var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
          matchResult22: {
            if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$2)) {
              error = e$2;
              break matchResult22;
            }
            $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(e$2);
          }
          var transformed = (void 0);
        }
        if ((depth$tailLocal1 > 512)) {
          if ((error === null)) {
            var $x_1 = new $c_Lcats_effect_IO$Pure(transformed);
          } else {
            var t = error;
            var $x_1 = new $c_Lcats_effect_IO$Error(t);
          }
          return $x_1;
        } else if ((error === null)) {
          var depth$tailLocal1$tmp1 = ((1 + depth$tailLocal1) | 0);
          result$tailLocal1 = transformed;
          depth$tailLocal1 = depth$tailLocal1$tmp1;
        } else {
          return $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, error, ((1 + depth$tailLocal1) | 0));
        }
        break;
      }
      case 1: {
        var this$$1 = $thiz.Lcats_effect_IOFiber__f_objectState;
        var f$2 = this$$1.pop();
        try {
          return f$2.apply__O__O(result$tailLocal1);
        } catch (e$3) {
          var e$4 = ((e$3 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e$3 : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e$3));
          if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$4)) {
            return $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, e$4, ((1 + depth$tailLocal1) | 0));
          }
          $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(e$4);
        }
        break;
      }
      case 2: {
        return $p_Lcats_effect_IOFiber__cancelationLoopSuccessK__Lcats_effect_IO($thiz);
        break;
      }
      case 3: {
        return $p_Lcats_effect_IOFiber__runTerminusSuccessK__O__Lcats_effect_IO($thiz, result$tailLocal1);
        break;
      }
      case 4: {
        return $p_Lcats_effect_IOFiber__evalOnSuccessK__O__Lcats_effect_IO($thiz, result$tailLocal1);
        break;
      }
      case 5: {
        var this$$2 = $thiz.Lcats_effect_IOFiber__f_objectState;
        this$$2.pop();
        break;
      }
      case 6: {
        var this$$3 = $thiz.Lcats_effect_IOFiber__f_finalizers;
        this$$3.pop();
        depth$tailLocal1 = ((1 + depth$tailLocal1) | 0);
        break;
      }
      case 7: {
        $thiz.Lcats_effect_IOFiber__f_masks = (((-1) + $thiz.Lcats_effect_IOFiber__f_masks) | 0);
        depth$tailLocal1 = ((1 + depth$tailLocal1) | 0);
        break;
      }
      case 8: {
        $thiz.Lcats_effect_IOFiber__f_masks = ((1 + $thiz.Lcats_effect_IOFiber__f_masks) | 0);
        depth$tailLocal1 = ((1 + depth$tailLocal1) | 0);
        break;
      }
      case 9: {
        var value = result$tailLocal1;
        result$tailLocal1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value);
        break;
      }
      default: {
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(op);
      }
    }
  }
}
export { $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO as $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO };
function $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, error, depth) {
  var depth$tailLocal2 = depth;
  var error$tailLocal1 = error;
  while (true) {
    $m_Lcats_effect_tracing_Tracing$().augmentThrowable__Z__jl_Throwable__Lcats_effect_tracing_RingBuffer__V($thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_enhancedExceptions, error$tailLocal1, $thiz.Lcats_effect_IOFiber__f_tracingEvents);
    var stack = $thiz.Lcats_effect_IOFiber__f_conts;
    var c = (((-1) + (stack[0] | 0)) | 0);
    if ((c < 0)) {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_ArrayIndexOutOfBoundsException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_ArrayIndexOutOfBoundsException());
    }
    var op = (((15 & (((stack[((1 + (c >> 3)) | 0)] | 0) >>> ((7 & c) << 2)) | 0)) << 24) >> 24);
    stack[0] = (((-1) + (stack[0] | 0)) | 0);
    switch (op) {
      case 0:
      case 1: {
        var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
        this$.pop();
        break;
      }
      case 2: {
        return $p_Lcats_effect_IOFiber__cancelationLoopFailureK__jl_Throwable__Lcats_effect_IO($thiz, error$tailLocal1);
        break;
      }
      case 3: {
        return $p_Lcats_effect_IOFiber__runTerminusFailureK__jl_Throwable__Lcats_effect_IO($thiz, error$tailLocal1);
        break;
      }
      case 4: {
        return $p_Lcats_effect_IOFiber__evalOnFailureK__jl_Throwable__Lcats_effect_IO($thiz, error$tailLocal1);
        break;
      }
      case 5: {
        var this$$1 = $thiz.Lcats_effect_IOFiber__f_objectState;
        var f = this$$1.pop();
        try {
          return f.apply__O__O(error$tailLocal1);
        } catch (e) {
          var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
          if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$2)) {
            var depth$tailLocal2$tmp1 = ((1 + depth$tailLocal2) | 0);
            error$tailLocal1 = e$2;
            depth$tailLocal2 = depth$tailLocal2$tmp1;
            break;
          }
          $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(e$2);
        }
        break;
      }
      case 6: {
        var this$$2 = $thiz.Lcats_effect_IOFiber__f_finalizers;
        this$$2.pop();
        depth$tailLocal2 = ((1 + depth$tailLocal2) | 0);
        break;
      }
      case 7: {
        $thiz.Lcats_effect_IOFiber__f_masks = (((-1) + $thiz.Lcats_effect_IOFiber__f_masks) | 0);
        depth$tailLocal2 = ((1 + depth$tailLocal2) | 0);
        break;
      }
      case 8: {
        $thiz.Lcats_effect_IOFiber__f_masks = ((1 + $thiz.Lcats_effect_IOFiber__f_masks) | 0);
        depth$tailLocal2 = ((1 + depth$tailLocal2) | 0);
        break;
      }
      case 9: {
        var value = error$tailLocal1;
        return $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value), depth$tailLocal2);
        break;
      }
      default: {
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(op);
      }
    }
  }
}
export { $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO as $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO };
function $p_Lcats_effect_IOFiber__scheduleFiber__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, fiber) {
  if ((ec instanceof $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor)) {
    ec.schedule__Lcats_effect_IOFiber__V(fiber);
  } else {
    $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, fiber);
  }
}
export { $p_Lcats_effect_IOFiber__scheduleFiber__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V as $p_Lcats_effect_IOFiber__scheduleFiber__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V };
function $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, fiber) {
  try {
    ec.execute__jl_Runnable__V(fiber);
  } catch (e) {
    if ((!false)) {
      throw e;
    }
  }
}
export { $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V as $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V };
function $p_Lcats_effect_IOFiber__execR__V($thiz) {
  if ($thiz.Lcats_effect_IOFiber__f_canceled) {
    $p_Lcats_effect_IOFiber__done__Lcats_effect_kernel_Outcome__V($thiz, $m_Lcats_effect_IOFiber$().Lcats_effect_IOFiber$__f_OutcomeCanceled);
  } else {
    $thiz.Lcats_effect_IOFiber__f_conts = [0];
    var stack = $thiz.Lcats_effect_IOFiber__f_conts;
    var c = (stack[0] | 0);
    var use = ((((1 + (((1 + c) | 0) >> 3)) | 0) < (stack.length | 0)) ? stack : (stack.push(0), stack));
    var s = ((1 + (c >> 3)) | 0);
    var shift = ((7 & c) << 2);
    use[s] = (((use[s] | 0) & (~((-1) << shift))) | (3 << shift));
    use[0] = ((1 + (use[0] | 0)) | 0);
    $thiz.Lcats_effect_IOFiber__f_conts = use;
    var io = $thiz.Lcats_effect_IOFiber__f_resumeIO;
    $thiz.Lcats_effect_IOFiber__f_resumeIO = null;
    $p_Lcats_effect_IOFiber__runLoop__Lcats_effect_IO__I__I__V($thiz, io, $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold, $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold);
  }
}
export { $p_Lcats_effect_IOFiber__execR__V as $p_Lcats_effect_IOFiber__execR__V };
function $p_Lcats_effect_IOFiber__asyncContinueSuccessfulR__V($thiz) {
  var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
  var a = this$.pop();
  $p_Lcats_effect_IOFiber__runLoop__Lcats_effect_IO__I__I__V($thiz, $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, a, 0), $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold, $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold);
}
export { $p_Lcats_effect_IOFiber__asyncContinueSuccessfulR__V as $p_Lcats_effect_IOFiber__asyncContinueSuccessfulR__V };
function $p_Lcats_effect_IOFiber__asyncContinueFailedR__V($thiz) {
  var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
  var t = this$.pop();
  $p_Lcats_effect_IOFiber__runLoop__Lcats_effect_IO__I__I__V($thiz, $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, t, 0), $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold, $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold);
}
export { $p_Lcats_effect_IOFiber__asyncContinueFailedR__V as $p_Lcats_effect_IOFiber__asyncContinueFailedR__V };
function $p_Lcats_effect_IOFiber__asyncContinueCanceledR__V($thiz) {
  var fin = $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO($thiz, null);
  $p_Lcats_effect_IOFiber__runLoop__Lcats_effect_IO__I__I__V($thiz, fin, $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold, $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold);
}
export { $p_Lcats_effect_IOFiber__asyncContinueCanceledR__V as $p_Lcats_effect_IOFiber__asyncContinueCanceledR__V };
function $p_Lcats_effect_IOFiber__asyncContinueCanceledWithFinalizerR__V($thiz) {
  var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
  var cb = this$.pop();
  var fin = $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO($thiz, cb);
  $p_Lcats_effect_IOFiber__runLoop__Lcats_effect_IO__I__I__V($thiz, fin, $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold, $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold);
}
export { $p_Lcats_effect_IOFiber__asyncContinueCanceledWithFinalizerR__V as $p_Lcats_effect_IOFiber__asyncContinueCanceledWithFinalizerR__V };
function $p_Lcats_effect_IOFiber__blockingR__V($thiz) {
  var error = null;
  var cur = $thiz.Lcats_effect_IOFiber__f_resumeIO;
  $thiz.Lcats_effect_IOFiber__f_resumeIO = null;
  try {
    var r = cur.thunk__F0().apply__O();
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
    matchResult27: {
      if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$2)) {
        error = e$2;
        break matchResult27;
      }
      $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(e$2);
    }
    var r = (void 0);
  }
  if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
    var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
    this$.pop().deregister__V();
  }
  if ((error === null)) {
    $thiz.Lcats_effect_IOFiber__f_resumeTag = 1;
    var this$$1 = $thiz.Lcats_effect_IOFiber__f_objectState;
    this$$1.push(r);
  } else {
    $thiz.Lcats_effect_IOFiber__f_resumeTag = 2;
    var this$$2 = $thiz.Lcats_effect_IOFiber__f_objectState;
    var a = error;
    this$$2.push(a);
  }
  var ec = $thiz.Lcats_effect_IOFiber__f_currentCtx;
  $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, $thiz);
}
export { $p_Lcats_effect_IOFiber__blockingR__V as $p_Lcats_effect_IOFiber__blockingR__V };
function $p_Lcats_effect_IOFiber__cedeR__V($thiz) {
  $p_Lcats_effect_IOFiber__runLoop__Lcats_effect_IO__I__I__V($thiz, $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, (void 0), 0), $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold, $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold);
}
export { $p_Lcats_effect_IOFiber__cedeR__V as $p_Lcats_effect_IOFiber__cedeR__V };
function $p_Lcats_effect_IOFiber__autoCedeR__V($thiz) {
  var io = $thiz.Lcats_effect_IOFiber__f_resumeIO;
  $thiz.Lcats_effect_IOFiber__f_resumeIO = null;
  $p_Lcats_effect_IOFiber__runLoop__Lcats_effect_IO__I__I__V($thiz, io, $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold, $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold);
}
export { $p_Lcats_effect_IOFiber__autoCedeR__V as $p_Lcats_effect_IOFiber__autoCedeR__V };
function $p_Lcats_effect_IOFiber__cancelationLoopSuccessK__Lcats_effect_IO($thiz) {
  var this$ = $thiz.Lcats_effect_IOFiber__f_finalizers;
  if ((!((this$.length | 0) === 0))) {
    var stack = $thiz.Lcats_effect_IOFiber__f_conts;
    var c = (stack[0] | 0);
    var use = ((((1 + (((1 + c) | 0) >> 3)) | 0) < (stack.length | 0)) ? stack : (stack.push(0), stack));
    var s = ((1 + (c >> 3)) | 0);
    var shift = ((7 & c) << 2);
    use[s] = (((use[s] | 0) & (~((-1) << shift))) | (2 << shift));
    use[0] = ((1 + (use[0] | 0)) | 0);
    $thiz.Lcats_effect_IOFiber__f_conts = use;
    var this$$1 = $thiz.Lcats_effect_IOFiber__f_finalizers;
    return this$$1.pop();
  } else {
    var this$$2 = $thiz.Lcats_effect_IOFiber__f_objectState;
    var cb = this$$2.pop();
    if ((cb !== null)) {
      cb.apply__O__O($m_Lcats_effect_IOFiber$().Lcats_effect_IOFiber$__f_RightUnit);
    }
    $p_Lcats_effect_IOFiber__done__Lcats_effect_kernel_Outcome__V($thiz, $m_Lcats_effect_IOFiber$().Lcats_effect_IOFiber$__f_OutcomeCanceled);
    return $m_Lcats_effect_IO$EndFiber$();
  }
}
export { $p_Lcats_effect_IOFiber__cancelationLoopSuccessK__Lcats_effect_IO as $p_Lcats_effect_IOFiber__cancelationLoopSuccessK__Lcats_effect_IO };
function $p_Lcats_effect_IOFiber__cancelationLoopFailureK__jl_Throwable__Lcats_effect_IO($thiz, t) {
  $thiz.Lcats_effect_IOFiber__f_currentCtx.reportFailure__jl_Throwable__V(t);
  return $p_Lcats_effect_IOFiber__cancelationLoopSuccessK__Lcats_effect_IO($thiz);
}
export { $p_Lcats_effect_IOFiber__cancelationLoopFailureK__jl_Throwable__Lcats_effect_IO as $p_Lcats_effect_IOFiber__cancelationLoopFailureK__jl_Throwable__Lcats_effect_IO };
function $p_Lcats_effect_IOFiber__runTerminusSuccessK__O__Lcats_effect_IO($thiz, result) {
  $m_Lcats_effect_IO$();
  var fa = new $c_Lcats_effect_IO$Pure(result);
  $p_Lcats_effect_IOFiber__done__Lcats_effect_kernel_Outcome__V($thiz, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Succeeded(fa));
  return $m_Lcats_effect_IO$EndFiber$();
}
export { $p_Lcats_effect_IOFiber__runTerminusSuccessK__O__Lcats_effect_IO as $p_Lcats_effect_IOFiber__runTerminusSuccessK__O__Lcats_effect_IO };
function $p_Lcats_effect_IOFiber__runTerminusFailureK__jl_Throwable__Lcats_effect_IO($thiz, t) {
  $p_Lcats_effect_IOFiber__done__Lcats_effect_kernel_Outcome__V($thiz, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Errored(t));
  return $m_Lcats_effect_IO$EndFiber$();
}
export { $p_Lcats_effect_IOFiber__runTerminusFailureK__jl_Throwable__Lcats_effect_IO as $p_Lcats_effect_IOFiber__runTerminusFailureK__jl_Throwable__Lcats_effect_IO };
function $p_Lcats_effect_IOFiber__evalOnSuccessK__O__Lcats_effect_IO($thiz, result) {
  if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
    var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
    this$.pop().deregister__V();
  }
  var this$$1 = $thiz.Lcats_effect_IOFiber__f_objectState;
  var ec = this$$1.pop();
  $thiz.Lcats_effect_IOFiber__f_currentCtx = ec;
  if ((!$p_Lcats_effect_IOFiber__shouldFinalize__Z($thiz))) {
    $thiz.Lcats_effect_IOFiber__f_resumeTag = 1;
    var this$$2 = $thiz.Lcats_effect_IOFiber__f_objectState;
    this$$2.push(result);
    $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, $thiz);
    return $m_Lcats_effect_IO$EndFiber$();
  } else {
    return $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO($thiz, null);
  }
}
export { $p_Lcats_effect_IOFiber__evalOnSuccessK__O__Lcats_effect_IO as $p_Lcats_effect_IOFiber__evalOnSuccessK__O__Lcats_effect_IO };
function $p_Lcats_effect_IOFiber__evalOnFailureK__jl_Throwable__Lcats_effect_IO($thiz, t) {
  if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
    var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
    this$.pop().deregister__V();
  }
  var this$$1 = $thiz.Lcats_effect_IOFiber__f_objectState;
  var ec = this$$1.pop();
  $thiz.Lcats_effect_IOFiber__f_currentCtx = ec;
  if ((!$p_Lcats_effect_IOFiber__shouldFinalize__Z($thiz))) {
    $thiz.Lcats_effect_IOFiber__f_resumeTag = 2;
    var this$$2 = $thiz.Lcats_effect_IOFiber__f_objectState;
    this$$2.push(t);
    $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, $thiz);
    return $m_Lcats_effect_IO$EndFiber$();
  } else {
    return $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO($thiz, null);
  }
}
export { $p_Lcats_effect_IOFiber__evalOnFailureK__jl_Throwable__Lcats_effect_IO as $p_Lcats_effect_IOFiber__evalOnFailureK__jl_Throwable__Lcats_effect_IO };
function $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V($thiz, te) {
  if ((te !== null)) {
    $thiz.Lcats_effect_IOFiber__f_tracingEvents.push__Lcats_effect_tracing_TracingEvent__V(te);
  }
}
export { $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V as $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V };
function $p_Lcats_effect_IOFiber__next$1__F1__O__Lcats_effect_IO($thiz, f$1, v) {
  var error = null;
  try {
    var result = f$1.apply__O__O(v);
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
    matchResult3: {
      if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$2)) {
        error = e$2;
        break matchResult3;
      }
      $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(e$2);
    }
    var result = (void 0);
  }
  return ((error === null) ? $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, result, 0) : $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, error, 0));
}
export { $p_Lcats_effect_IOFiber__next$1__F1__O__Lcats_effect_IO as $p_Lcats_effect_IOFiber__next$1__F1__O__Lcats_effect_IO };
function $p_Lcats_effect_IOFiber__next$2__F1__O__Lcats_effect_IO($thiz, f$2, v) {
  try {
    return f$2.apply__O__O(v);
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$2)) {
      return $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, e$2, 0);
    }
    $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(e$2);
  }
}
export { $p_Lcats_effect_IOFiber__next$2__F1__O__Lcats_effect_IO as $p_Lcats_effect_IOFiber__next$2__F1__O__Lcats_effect_IO };
function $p_Lcats_effect_IOFiber__loop$1__Lcats_effect_ContState__s_util_Either__V($thiz, state$2, result$1) {
  while (true) {
    if ($thiz.getAndSet__Z__Z(false)) {
      if (($thiz.Lcats_effect_IOFiber__f_finalizing === state$2.Lcats_effect_ContState__f_wasFinalizing)) {
        if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
          state$2.Lcats_effect_ContState__f_handle.deregister__V();
        }
        var ec = $thiz.Lcats_effect_IOFiber__f_currentCtx;
        if ((!$p_Lcats_effect_IOFiber__shouldFinalize__Z($thiz))) {
          matchResult12: {
            if ((result$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
              var t = result$1.s_util_Left__f_value;
              $thiz.Lcats_effect_IOFiber__f_resumeTag = 2;
              var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
              this$.push(t);
              break matchResult12;
            }
            if ((result$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
              var a = result$1.s_util_Right__f_value;
              $thiz.Lcats_effect_IOFiber__f_resumeTag = 1;
              var this$$1 = $thiz.Lcats_effect_IOFiber__f_objectState;
              this$$1.push(a);
              break matchResult12;
            }
            throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(result$1);
          }
        } else {
          $thiz.Lcats_effect_IOFiber__f_resumeTag = 3;
        }
        $p_Lcats_effect_IOFiber__scheduleFiber__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, $thiz);
        return (void 0);
      } else {
        $thiz.ju_concurrent_atomic_AtomicBoolean__f_value = true;
        return (void 0);
      }
    } else if (((($thiz.Lcats_effect_IOFiber__f_finalizing === state$2.Lcats_effect_ContState__f_wasFinalizing) && (!$p_Lcats_effect_IOFiber__shouldFinalize__Z($thiz))) && ($thiz.Lcats_effect_IOFiber__f_outcome === null))) {
    } else {
      return (void 0);
    }
  }
}
export { $p_Lcats_effect_IOFiber__loop$1__Lcats_effect_ContState__s_util_Either__V as $p_Lcats_effect_IOFiber__loop$1__Lcats_effect_ContState__s_util_Either__V };
function $p_Lcats_effect_IOFiber__stateLoop$1__Lcats_effect_ContState__s_util_Either__s_util_Either__V($thiz, state$3, waiting$1, result$2) {
  while (true) {
    var tag = state$3.ju_concurrent_atomic_AtomicReference__f_value;
    if (((tag === null) || (tag === waiting$1))) {
      if ((!state$3.compareAndSet__O__O__Z(tag, result$2))) {
      } else if ((tag === waiting$1)) {
        $p_Lcats_effect_IOFiber__loop$1__Lcats_effect_ContState__s_util_Either__V($thiz, state$3, result$2);
        return (void 0);
      } else {
        return (void 0);
      }
    } else {
      return (void 0);
    }
  }
}
export { $p_Lcats_effect_IOFiber__stateLoop$1__Lcats_effect_ContState__s_util_Either__s_util_Either__V as $p_Lcats_effect_IOFiber__stateLoop$1__Lcats_effect_ContState__s_util_Either__s_util_Either__V };
/** @constructor */
function $c_Lcats_effect_IOFiber(initState, cb, startIO, startEC, rt) {
  this.ju_concurrent_atomic_AtomicBoolean__f_value = false;
  this.Lcats_effect_IOFiber__f_localState = null;
  this.Lcats_effect_IOFiber__f_currentCtx = null;
  this.Lcats_effect_IOFiber__f_objectState = null;
  this.Lcats_effect_IOFiber__f_finalizers = null;
  this.Lcats_effect_IOFiber__f_callbacks = null;
  this.Lcats_effect_IOFiber__f_resumeTag = 0;
  this.Lcats_effect_IOFiber__f_resumeIO = null;
  this.Lcats_effect_IOFiber__f_runtime = null;
  this.Lcats_effect_IOFiber__f_tracingEvents = null;
  this.Lcats_effect_IOFiber__f_conts = null;
  this.Lcats_effect_IOFiber__f_canceled = false;
  this.Lcats_effect_IOFiber__f_masks = 0;
  this.Lcats_effect_IOFiber__f_finalizing = false;
  this.Lcats_effect_IOFiber__f_outcome = null;
  this.Lcats_effect_IOFiber__f__cancel = null;
  this.Lcats_effect_IOFiber__f__join = null;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_ju_concurrent_atomic_AtomicBoolean__Z__(this, false);
  this.Lcats_effect_IOFiber__f_localState = initState;
  this.Lcats_effect_IOFiber__f_currentCtx = startEC;
  this.Lcats_effect_IOFiber__f_objectState = [];
  this.Lcats_effect_IOFiber__f_finalizers = [];
  this.Lcats_effect_IOFiber__f_callbacks = [cb];
  this.Lcats_effect_IOFiber__f_resumeTag = 0;
  this.Lcats_effect_IOFiber__f_resumeIO = startIO;
  this.Lcats_effect_IOFiber__f_runtime = rt;
  if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
    var logSize = this.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_traceBufferLogSize;
    var $x_1 = new $c_Lcats_effect_tracing_RingBuffer(logSize);
  } else {
    var $x_1 = null;
  }
  this.Lcats_effect_IOFiber__f_tracingEvents = $x_1;
  this.Lcats_effect_IOFiber__f_canceled = false;
  this.Lcats_effect_IOFiber__f_masks = 0;
  this.Lcats_effect_IOFiber__f_finalizing = false;
  this.Lcats_effect_IOFiber__f__cancel = $m_Lcats_effect_IO$().uncancelable__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$3) => {
    this.Lcats_effect_IOFiber__f_canceled = true;
    if (this.getAndSet__Z__Z(false)) {
      if ($p_Lcats_effect_IOFiber__isUnmasked__Z(this)) {
        return $m_Lcats_effect_IO$().async___F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((fin) => {
          var ec = this.Lcats_effect_IOFiber__f_currentCtx;
          this.Lcats_effect_IOFiber__f_resumeTag = 4;
          var this$ = this.Lcats_effect_IOFiber__f_objectState;
          this$.push(fin);
          $p_Lcats_effect_IOFiber__scheduleFiber__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V(this, ec, this);
        })));
      } else {
        this.ju_concurrent_atomic_AtomicBoolean__f_value = true;
        return this.join__Lcats_effect_IO().void__Lcats_effect_IO();
      }
    } else {
      return this.join__Lcats_effect_IO().void__Lcats_effect_IO();
    }
  })));
  this.Lcats_effect_IOFiber__f__join = $m_Lcats_effect_IO$().asyncCheckAttempt__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((cb$2) => {
    var this$19 = $m_Lcats_effect_IO$();
    var thunk$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((cb$2$1) => (() => {
      if ((this.Lcats_effect_IOFiber__f_outcome === null)) {
        var stack = this.Lcats_effect_IOFiber__f_callbacks;
        var next = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((oc) => {
          cb$2$1.apply__O__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(oc));
        }));
        stack.push(next);
        var handle = (((-1) + (stack.length | 0)) | 0);
        if ((this.Lcats_effect_IOFiber__f_outcome !== null)) {
          var stack$1 = this.Lcats_effect_IOFiber__f_callbacks;
          delete stack$1[handle];
          var value = this.Lcats_effect_IOFiber__f_outcome;
          return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value);
        } else {
          var this$15 = $m_Lcats_effect_IO$();
          var thunk = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
            var stack$2 = this.Lcats_effect_IOFiber__f_callbacks;
            delete stack$2[handle];
          }));
          var value$1 = this$15.delay__F0__Lcats_effect_IO(thunk);
          var value$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value$1);
          return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value$2);
        }
      } else {
        var value$3 = this.Lcats_effect_IOFiber__f_outcome;
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value$3);
      }
    }))(cb$2));
    return this$19.delay__F0__Lcats_effect_IO(thunk$1);
  })));
}
export { $c_Lcats_effect_IOFiber as $c_Lcats_effect_IOFiber };
$c_Lcats_effect_IOFiber.prototype = new $h_Lcats_effect_IOFiberPlatform();
$c_Lcats_effect_IOFiber.prototype.constructor = $c_Lcats_effect_IOFiber;
/** @constructor */
function $h_Lcats_effect_IOFiber() {
}
export { $h_Lcats_effect_IOFiber as $h_Lcats_effect_IOFiber };
$h_Lcats_effect_IOFiber.prototype = $c_Lcats_effect_IOFiber.prototype;
$c_Lcats_effect_IOFiber.prototype.run__V = (function() {
  var x1 = this.Lcats_effect_IOFiber__f_resumeTag;
  switch (x1) {
    case 0: {
      $p_Lcats_effect_IOFiber__execR__V(this);
      return (void 0);
      break;
    }
    case 1: {
      $p_Lcats_effect_IOFiber__asyncContinueSuccessfulR__V(this);
      return (void 0);
      break;
    }
    case 2: {
      $p_Lcats_effect_IOFiber__asyncContinueFailedR__V(this);
      return (void 0);
      break;
    }
    case 3: {
      $p_Lcats_effect_IOFiber__asyncContinueCanceledR__V(this);
      return (void 0);
      break;
    }
    case 4: {
      $p_Lcats_effect_IOFiber__asyncContinueCanceledWithFinalizerR__V(this);
      return (void 0);
      break;
    }
    case 5: {
      $p_Lcats_effect_IOFiber__blockingR__V(this);
      return (void 0);
      break;
    }
    case 6: {
      $p_Lcats_effect_IOFiber__cedeR__V(this);
      return (void 0);
      break;
    }
    case 7: {
      $p_Lcats_effect_IOFiber__autoCedeR__V(this);
      return (void 0);
      break;
    }
    case 8: {
      return (void 0);
      break;
    }
    default: {
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1);
    }
  }
});
$c_Lcats_effect_IOFiber.prototype.cancel__Lcats_effect_IO = (function() {
  return this.Lcats_effect_IOFiber__f__cancel;
});
$c_Lcats_effect_IOFiber.prototype.join__Lcats_effect_IO = (function() {
  return this.Lcats_effect_IOFiber__f__join;
});
$c_Lcats_effect_IOFiber.prototype.toString__T = (function() {
  var state = (this.ju_concurrent_atomic_AtomicBoolean__f_value ? "SUSPENDED" : (this.isDone__Z() ? "COMPLETED" : "RUNNING"));
  var tracingEvents = this.Lcats_effect_IOFiber__f_tracingEvents;
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Option$().apply__O__s_Option(tracingEvents);
  if (this$1.isEmpty__Z()) {
    var this$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0 = this$1.get__O();
    var this$2 = $m_Lcats_effect_tracing_Tracing$().getFrames__Lcats_effect_tracing_RingBuffer__sci_List(x0).headOption__s_Option();
    if (this$2.isEmpty__Z()) {
      var this$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    } else {
      var x0$1 = this$2.get__O();
      var this$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some((": " + x0$1));
    }
  }
  var opAndCallSite = (this$3.isEmpty__Z() ? "" : this$3.get__O());
  var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$systemIdentityHashCode(this);
  return (((("cats.effect.IOFiber@" + (x >>> 0.0).toString(16)) + " ") + state) + opAndCallSite);
});
$c_Lcats_effect_IOFiber.prototype.isDone__Z = (function() {
  return (this.Lcats_effect_IOFiber__f_outcome !== null);
});
$c_Lcats_effect_IOFiber.prototype.cancel__O = (function() {
  return this.cancel__Lcats_effect_IO();
});
$c_Lcats_effect_IOFiber.prototype.join__O = (function() {
  return this.join__Lcats_effect_IO();
});
var $d_Lcats_effect_IOFiber = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IOFiber, "cats.effect.IOFiber", ({
  Lcats_effect_IOFiber: 1,
  Lcats_effect_IOFiberPlatform: 1,
  ju_concurrent_atomic_AtomicBoolean: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Fiber: 1,
  jl_Runnable: 1
}));
export { $d_Lcats_effect_IOFiber as $d_Lcats_effect_IOFiber };
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$1() {
}
export { $c_Lcats_instances_InvariantMonoidalInstances$$anon$1 as $c_Lcats_instances_InvariantMonoidalInstances$$anon$1 };
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$1() {
}
export { $h_Lcats_instances_InvariantMonoidalInstances$$anon$1 as $h_Lcats_instances_InvariantMonoidalInstances$$anon$1 };
$h_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype;
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return new $c_Lcats_instances_InvariantMonoidalInstances$$anon$2(fa, fb, this);
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return new $c_Lcats_instances_InvariantMonoidalInstances$$anon$3(f, fa, g, this);
});
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_InvariantMonoidalInstances$$anon$1, "cats.instances.InvariantMonoidalInstances$$anon$1", ({
  Lcats_instances_InvariantMonoidalInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1
}));
export { $d_Lcats_instances_InvariantMonoidalInstances$$anon$1 as $d_Lcats_instances_InvariantMonoidalInstances$$anon$1 };
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$4() {
}
export { $c_Lcats_instances_InvariantMonoidalInstances$$anon$4 as $c_Lcats_instances_InvariantMonoidalInstances$$anon$4 };
$c_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$4;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$4() {
}
export { $h_Lcats_instances_InvariantMonoidalInstances$$anon$4 as $h_Lcats_instances_InvariantMonoidalInstances$$anon$4 };
$h_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype;
$c_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype.product__O__O__O = (function(fa, fb) {
  return new $c_Lcats_instances_InvariantMonoidalInstances$$anon$5(fa, fb, this);
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return new $c_Lcats_instances_InvariantMonoidalInstances$$anon$6(f, fa, g, this);
});
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_InvariantMonoidalInstances$$anon$4, "cats.instances.InvariantMonoidalInstances$$anon$4", ({
  Lcats_instances_InvariantMonoidalInstances$$anon$4: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1
}));
export { $d_Lcats_instances_InvariantMonoidalInstances$$anon$4 as $d_Lcats_instances_InvariantMonoidalInstances$$anon$4 };
/** @constructor */
function $c_Lcats_instances_OrderingInstances$$anon$2(fa$4, fb$2) {
  this.Lcats_instances_OrderingInstances$$anon$2__f_fa$1 = null;
  this.Lcats_instances_OrderingInstances$$anon$2__f_fb$1 = null;
  this.Lcats_instances_OrderingInstances$$anon$2__f_fa$1 = fa$4;
  this.Lcats_instances_OrderingInstances$$anon$2__f_fb$1 = fb$2;
}
export { $c_Lcats_instances_OrderingInstances$$anon$2 as $c_Lcats_instances_OrderingInstances$$anon$2 };
$c_Lcats_instances_OrderingInstances$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.constructor = $c_Lcats_instances_OrderingInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_OrderingInstances$$anon$2() {
}
export { $h_Lcats_instances_OrderingInstances$$anon$2 as $h_Lcats_instances_OrderingInstances$$anon$2 };
$h_Lcats_instances_OrderingInstances$$anon$2.prototype = $c_Lcats_instances_OrderingInstances$$anon$2.prototype;
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.lteq__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.gteq__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.gt__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.equiv__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.max__O__O__O = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.min__O__O__O = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.compare__T2__T2__I = (function(x, y) {
  var z = this.Lcats_instances_OrderingInstances$$anon$2__f_fa$1.compare__O__O__I(x._1__O(), y._1__O());
  return ((z === 0) ? this.Lcats_instances_OrderingInstances$$anon$2__f_fb$1.compare__O__O__I(x._2__O(), y._2__O()) : z);
});
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__T2__T2__I(x, y);
});
var $d_Lcats_instances_OrderingInstances$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_OrderingInstances$$anon$2, "cats.instances.OrderingInstances$$anon$2", ({
  Lcats_instances_OrderingInstances$$anon$2: 1,
  ju_Comparator: 1,
  Ljava_io_Serializable: 1,
  s_math_Equiv: 1,
  s_math_PartialOrdering: 1,
  s_math_Ordering: 1
}));
export { $d_Lcats_instances_OrderingInstances$$anon$2 as $d_Lcats_instances_OrderingInstances$$anon$2 };
/** @constructor */
function $c_Lcats_instances_package$stream$() {
  this.Lcats_instances_package$stream$__f_catsStdInstancesForStream = null;
  $n_Lcats_instances_package$stream$ = this;
  this.Lcats_instances_package$stream$__f_catsStdInstancesForStream = new $c_Lcats_instances_StreamInstances$$anon$1();
  new $c_Lcats_instances_StreamInstancesBinCompat0$$anon$7();
}
export { $c_Lcats_instances_package$stream$ as $c_Lcats_instances_package$stream$ };
$c_Lcats_instances_package$stream$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_package$stream$.prototype.constructor = $c_Lcats_instances_package$stream$;
/** @constructor */
function $h_Lcats_instances_package$stream$() {
}
export { $h_Lcats_instances_package$stream$ as $h_Lcats_instances_package$stream$ };
$h_Lcats_instances_package$stream$.prototype = $c_Lcats_instances_package$stream$.prototype;
var $d_Lcats_instances_package$stream$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_package$stream$, "cats.instances.package$stream$", ({
  Lcats_instances_package$stream$: 1,
  Lcats_kernel_instances_StreamInstances2: 1,
  Lcats_kernel_instances_StreamInstances1: 1,
  Lcats_kernel_instances_StreamInstances: 1,
  Lcats_instances_StreamInstances: 1,
  Lcats_instances_StreamInstancesBinCompat0: 1
}));
export { $d_Lcats_instances_package$stream$ as $d_Lcats_instances_package$stream$ };
var $n_Lcats_instances_package$stream$;
function $m_Lcats_instances_package$stream$() {
  if ((!$n_Lcats_instances_package$stream$)) {
    $n_Lcats_instances_package$stream$ = new $c_Lcats_instances_package$stream$();
  }
  return $n_Lcats_instances_package$stream$;
}
export { $m_Lcats_instances_package$stream$ as $m_Lcats_instances_package$stream$ };
/** @constructor */
function $c_Lcats_kernel_instances_BigDecimalOrder() {
}
export { $c_Lcats_kernel_instances_BigDecimalOrder as $c_Lcats_kernel_instances_BigDecimalOrder };
$c_Lcats_kernel_instances_BigDecimalOrder.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.constructor = $c_Lcats_kernel_instances_BigDecimalOrder;
/** @constructor */
function $h_Lcats_kernel_instances_BigDecimalOrder() {
}
export { $h_Lcats_kernel_instances_BigDecimalOrder as $h_Lcats_kernel_instances_BigDecimalOrder };
$h_Lcats_kernel_instances_BigDecimalOrder.prototype = $c_Lcats_kernel_instances_BigDecimalOrder.prototype;
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.toOrdering__s_math_Ordering = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_kernel_Order$$anon$1(this);
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.neqv__s_math_BigDecimal__s_math_BigDecimal__Z = (function(x, y) {
  return (!$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(x, y));
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.hash__O__I = (function(x) {
  return x.hashCode__I();
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.compare__O__O__I = (function(x, y) {
  return x.s_math_BigDecimal__f_bigDecimal.compareTo__Ljava_math_BigDecimal__I(y.s_math_BigDecimal__f_bigDecimal);
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(x, y);
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__s_math_BigDecimal__s_math_BigDecimal__Z(x, y);
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.gt__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_math_Ordered__$greater__O__Z(x, y);
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.lt__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_math_Ordered__$less__O__Z(x, y);
});
var $d_Lcats_kernel_instances_BigDecimalOrder = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_kernel_instances_BigDecimalOrder, "cats.kernel.instances.BigDecimalOrder", ({
  Lcats_kernel_instances_BigDecimalOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1
}));
export { $d_Lcats_kernel_instances_BigDecimalOrder as $d_Lcats_kernel_instances_BigDecimalOrder };
/** @constructor */
function $c_Lcats_kernel_instances_DoubleOrder() {
}
export { $c_Lcats_kernel_instances_DoubleOrder as $c_Lcats_kernel_instances_DoubleOrder };
$c_Lcats_kernel_instances_DoubleOrder.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_kernel_instances_DoubleOrder.prototype.constructor = $c_Lcats_kernel_instances_DoubleOrder;
/** @constructor */
function $h_Lcats_kernel_instances_DoubleOrder() {
}
export { $h_Lcats_kernel_instances_DoubleOrder as $h_Lcats_kernel_instances_DoubleOrder };
$h_Lcats_kernel_instances_DoubleOrder.prototype = $c_Lcats_kernel_instances_DoubleOrder.prototype;
$c_Lcats_kernel_instances_DoubleOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.toOrdering__s_math_Ordering = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_kernel_Order$$anon$1(this);
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.eqv__D__D__Z = (function(x, y) {
  return (x === y);
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.neqv__D__D__Z = (function(x, y) {
  return (x !== y);
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.gt__D__D__Z = (function(x, y) {
  return (x > y);
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.lt__D__D__Z = (function(x, y) {
  return (x < y);
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.hash__O__I = (function(x) {
  var x$1 = (+x);
  var valueInt = (x$1 | 0);
  if (((valueInt === x$1) && ((1.0 / x$1) !== (-Infinity)))) {
    return valueInt;
  } else if ((x$1 !== x$1)) {
    return 2146959360;
  } else {
    var fpBitsDataView = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$fpBitsDataView;
    fpBitsDataView.setFloat64(0, x$1, true);
    var lo = (fpBitsDataView.getInt32(0, true) | 0);
    var hi = (fpBitsDataView.getInt32(4, true) | 0);
    return (lo ^ hi);
  }
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = (+x);
  var y$1 = (+y);
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Double$().compare__D__D__I(x$1, y$1);
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__D__D__Z((+x), (+y));
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__D__D__Z((+x), (+y));
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.gt__O__O__Z = (function(x, y) {
  return this.gt__D__D__Z((+x), (+y));
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.lt__O__O__Z = (function(x, y) {
  return this.lt__D__D__Z((+x), (+y));
});
var $d_Lcats_kernel_instances_DoubleOrder = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_kernel_instances_DoubleOrder, "cats.kernel.instances.DoubleOrder", ({
  Lcats_kernel_instances_DoubleOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1
}));
export { $d_Lcats_kernel_instances_DoubleOrder as $d_Lcats_kernel_instances_DoubleOrder };
/** @constructor */
function $c_Lcats_kernel_instances_FloatOrder() {
}
export { $c_Lcats_kernel_instances_FloatOrder as $c_Lcats_kernel_instances_FloatOrder };
$c_Lcats_kernel_instances_FloatOrder.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_kernel_instances_FloatOrder.prototype.constructor = $c_Lcats_kernel_instances_FloatOrder;
/** @constructor */
function $h_Lcats_kernel_instances_FloatOrder() {
}
export { $h_Lcats_kernel_instances_FloatOrder as $h_Lcats_kernel_instances_FloatOrder };
$h_Lcats_kernel_instances_FloatOrder.prototype = $c_Lcats_kernel_instances_FloatOrder.prototype;
$c_Lcats_kernel_instances_FloatOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_FloatOrder.prototype.toOrdering__s_math_Ordering = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_kernel_Order$$anon$1(this);
});
$c_Lcats_kernel_instances_FloatOrder.prototype.eqv__F__F__Z = (function(x, y) {
  return (x === y);
});
$c_Lcats_kernel_instances_FloatOrder.prototype.neqv__F__F__Z = (function(x, y) {
  return (x !== y);
});
$c_Lcats_kernel_instances_FloatOrder.prototype.gt__F__F__Z = (function(x, y) {
  return (x > y);
});
$c_Lcats_kernel_instances_FloatOrder.prototype.lt__F__F__Z = (function(x, y) {
  return (x < y);
});
$c_Lcats_kernel_instances_FloatOrder.prototype.hash__O__I = (function(x) {
  var x$1 = Math.fround(x);
  var value = x$1;
  var valueInt = (value | 0);
  if (((valueInt === value) && ((1.0 / value) !== (-Infinity)))) {
    return valueInt;
  } else if ((value !== value)) {
    return 2146959360;
  } else {
    var fpBitsDataView = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$fpBitsDataView;
    fpBitsDataView.setFloat64(0, value, true);
    var lo = (fpBitsDataView.getInt32(0, true) | 0);
    var hi = (fpBitsDataView.getInt32(4, true) | 0);
    return (lo ^ hi);
  }
});
$c_Lcats_kernel_instances_FloatOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = Math.fround(x);
  var y$1 = Math.fround(y);
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Double$().compare__D__D__I(x$1, y$1);
});
$c_Lcats_kernel_instances_FloatOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__F__F__Z(Math.fround(x), Math.fround(y));
});
$c_Lcats_kernel_instances_FloatOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__F__F__Z(Math.fround(x), Math.fround(y));
});
$c_Lcats_kernel_instances_FloatOrder.prototype.gt__O__O__Z = (function(x, y) {
  return this.gt__F__F__Z(Math.fround(x), Math.fround(y));
});
$c_Lcats_kernel_instances_FloatOrder.prototype.lt__O__O__Z = (function(x, y) {
  return this.lt__F__F__Z(Math.fround(x), Math.fround(y));
});
var $d_Lcats_kernel_instances_FloatOrder = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_kernel_instances_FloatOrder, "cats.kernel.instances.FloatOrder", ({
  Lcats_kernel_instances_FloatOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1
}));
export { $d_Lcats_kernel_instances_FloatOrder as $d_Lcats_kernel_instances_FloatOrder };
function $f_Lcom_raquo_airstream_combine_CombineObservable__onInputsReady__Lcom_raquo_airstream_core_Transaction__V($thiz, transaction) {
  if ((!transaction.containsPendingObservable__Lcom_raquo_airstream_core_SyncObservable__Z($thiz))) {
    transaction.enqueuePendingObservable__Lcom_raquo_airstream_core_SyncObservable__V($thiz);
  }
}
export { $f_Lcom_raquo_airstream_combine_CombineObservable__onInputsReady__Lcom_raquo_airstream_core_Transaction__V as $f_Lcom_raquo_airstream_combine_CombineObservable__onInputsReady__Lcom_raquo_airstream_core_Transaction__V };
function $f_Lcom_raquo_airstream_combine_CombineObservable__syncFire__Lcom_raquo_airstream_core_Transaction__V($thiz, transaction) {
  if ($thiz.inputsReady__Z()) {
    $thiz.fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V($thiz.combinedValue__s_util_Try(), transaction);
  } else {
    console.warn("CombineObservable: inputs not ready when syncFire");
  }
}
export { $f_Lcom_raquo_airstream_combine_CombineObservable__syncFire__Lcom_raquo_airstream_core_Transaction__V as $f_Lcom_raquo_airstream_combine_CombineObservable__syncFire__Lcom_raquo_airstream_core_Transaction__V };
function $f_Lcom_raquo_airstream_combine_CombineObservable__onStart__V($thiz) {
  var arr = $thiz.parentObservers__Lcom_raquo_ew_JsArray();
  var i = 0;
  var len = (arr.length | 0);
  while ((i < len)) {
    var _$1 = arr[i];
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(_$1.Lcom_raquo_airstream_common_InternalParentObserver$$anon$2__f_parent, _$1, false);
    i = ((1 + i) | 0);
  }
  $thiz.com$raquo$airstream$combine$CombineObservable$$super$onStart__V();
}
export { $f_Lcom_raquo_airstream_combine_CombineObservable__onStart__V as $f_Lcom_raquo_airstream_combine_CombineObservable__onStart__V };
function $f_Lcom_raquo_airstream_combine_CombineObservable__onStop__V($thiz) {
  var arr = $thiz.parentObservers__Lcom_raquo_ew_JsArray();
  var i = 0;
  var len = (arr.length | 0);
  while ((i < len)) {
    var _$2 = arr[i];
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V(_$2.Lcom_raquo_airstream_common_InternalParentObserver$$anon$2__f_parent, _$2);
    i = ((1 + i) | 0);
  }
}
export { $f_Lcom_raquo_airstream_combine_CombineObservable__onStop__V as $f_Lcom_raquo_airstream_combine_CombineObservable__onStop__V };
/** @constructor */
function $c_Lfansi_EscapeAttr(escape, resetMask, applyMask, sourceName) {
  this.Lfansi_EscapeAttr__f_escape = null;
  this.Lfansi_EscapeAttr__f_resetMask = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0;
  this.Lfansi_EscapeAttr__f_applyMask = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0;
  this.Lfansi_EscapeAttr__f_escapeOpt = null;
  this.Lfansi_EscapeAttr__f_name = null;
  this.Lfansi_EscapeAttr__f_escape = escape;
  this.Lfansi_EscapeAttr__f_resetMask = resetMask;
  this.Lfansi_EscapeAttr__f_applyMask = applyMask;
  this.Lfansi_EscapeAttr__f_escapeOpt = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(escape);
  this.Lfansi_EscapeAttr__f_name = sourceName.Lsourcecode_Name__f_value;
}
export { $c_Lfansi_EscapeAttr as $c_Lfansi_EscapeAttr };
$c_Lfansi_EscapeAttr.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfansi_EscapeAttr.prototype.constructor = $c_Lfansi_EscapeAttr;
/** @constructor */
function $h_Lfansi_EscapeAttr() {
}
export { $h_Lfansi_EscapeAttr as $h_Lfansi_EscapeAttr };
$h_Lfansi_EscapeAttr.prototype = $c_Lfansi_EscapeAttr.prototype;
$c_Lfansi_EscapeAttr.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lfansi_EscapeAttr.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I("EscapeAttr");
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lfansi_EscapeAttr__f_escape;
  var data$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var t = this.Lfansi_EscapeAttr__f_resetMask;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var data$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().longHash__J__I(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var t$1 = this.Lfansi_EscapeAttr__f_applyMask;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var data$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().longHash__J__I(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$1, hi$1));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3);
});
$c_Lfansi_EscapeAttr.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfansi_EscapeAttr)) {
    var a = this.Lfansi_EscapeAttr__f_resetMask;
    var b = x$0.Lfansi_EscapeAttr__f_resetMask;
    if (((a.RTLong__f_lo === b.RTLong__f_lo) && (a.RTLong__f_hi === b.RTLong__f_hi))) {
      var a$1 = this.Lfansi_EscapeAttr__f_applyMask;
      var b$1 = x$0.Lfansi_EscapeAttr__f_applyMask;
      var $x_1 = ((a$1.RTLong__f_lo === b$1.RTLong__f_lo) && (a$1.RTLong__f_hi === b$1.RTLong__f_hi));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return (this.Lfansi_EscapeAttr__f_escape === x$0.Lfansi_EscapeAttr__f_escape);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lfansi_EscapeAttr.prototype.productArity__I = (function() {
  return 3;
});
$c_Lfansi_EscapeAttr.prototype.productPrefix__T = (function() {
  return "EscapeAttr";
});
$c_Lfansi_EscapeAttr.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lfansi_EscapeAttr__f_escape;
      break;
    }
    case 1: {
      return this.Lfansi_EscapeAttr__f_resetMask;
      break;
    }
    case 2: {
      return this.Lfansi_EscapeAttr__f_applyMask;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lfansi_EscapeAttr.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "escape";
      break;
    }
    case 1: {
      return "resetMask";
      break;
    }
    case 2: {
      return "applyMask";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lfansi_EscapeAttr.prototype.resetMask__J = (function() {
  return this.Lfansi_EscapeAttr__f_resetMask;
});
$c_Lfansi_EscapeAttr.prototype.applyMask__J = (function() {
  return this.Lfansi_EscapeAttr__f_applyMask;
});
$c_Lfansi_EscapeAttr.prototype.escapeOpt__s_Option = (function() {
  return this.Lfansi_EscapeAttr__f_escapeOpt;
});
$c_Lfansi_EscapeAttr.prototype.toString__T = (function() {
  return ((("" + this.Lfansi_EscapeAttr__f_escape) + this.Lfansi_EscapeAttr__f_name) + "\u001b[0m");
});
function $isArrayOf_Lfansi_EscapeAttr(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfansi_EscapeAttr)));
}
export { $isArrayOf_Lfansi_EscapeAttr as $isArrayOf_Lfansi_EscapeAttr };
var $d_Lfansi_EscapeAttr = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfansi_EscapeAttr, "fansi.EscapeAttr", ({
  Lfansi_EscapeAttr: 1,
  Lfansi_Attrs: 1,
  Lfansi_Attr: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lfansi_EscapeAttr as $d_Lfansi_EscapeAttr };
/** @constructor */
function $c_Lfansi_ResetAttr(resetMask, applyMask, sourceName) {
  this.Lfansi_ResetAttr__f_resetMask = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0;
  this.Lfansi_ResetAttr__f_applyMask = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0;
  this.Lfansi_ResetAttr__f_escapeOpt = null;
  this.Lfansi_ResetAttr__f_name = null;
  this.Lfansi_ResetAttr__f_resetMask = resetMask;
  this.Lfansi_ResetAttr__f_applyMask = applyMask;
  this.Lfansi_ResetAttr__f_escapeOpt = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  this.Lfansi_ResetAttr__f_name = sourceName.Lsourcecode_Name__f_value;
}
export { $c_Lfansi_ResetAttr as $c_Lfansi_ResetAttr };
$c_Lfansi_ResetAttr.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfansi_ResetAttr.prototype.constructor = $c_Lfansi_ResetAttr;
/** @constructor */
function $h_Lfansi_ResetAttr() {
}
export { $h_Lfansi_ResetAttr as $h_Lfansi_ResetAttr };
$h_Lfansi_ResetAttr.prototype = $c_Lfansi_ResetAttr.prototype;
$c_Lfansi_ResetAttr.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lfansi_ResetAttr.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I("ResetAttr");
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var t = this.Lfansi_ResetAttr__f_resetMask;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var data$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().longHash__J__I(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var t$1 = this.Lfansi_ResetAttr__f_applyMask;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var data$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().longHash__J__I(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$1, hi$1));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2);
});
$c_Lfansi_ResetAttr.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfansi_ResetAttr)) {
    var a = this.Lfansi_ResetAttr__f_resetMask;
    var b = x$0.Lfansi_ResetAttr__f_resetMask;
    if (((a.RTLong__f_lo === b.RTLong__f_lo) && (a.RTLong__f_hi === b.RTLong__f_hi))) {
      var a$1 = this.Lfansi_ResetAttr__f_applyMask;
      var b$1 = x$0.Lfansi_ResetAttr__f_applyMask;
      return ((a$1.RTLong__f_lo === b$1.RTLong__f_lo) && (a$1.RTLong__f_hi === b$1.RTLong__f_hi));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lfansi_ResetAttr.prototype.productArity__I = (function() {
  return 2;
});
$c_Lfansi_ResetAttr.prototype.productPrefix__T = (function() {
  return "ResetAttr";
});
$c_Lfansi_ResetAttr.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfansi_ResetAttr__f_resetMask;
  }
  if ((n === 1)) {
    return this.Lfansi_ResetAttr__f_applyMask;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lfansi_ResetAttr.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "resetMask";
  }
  if ((n === 1)) {
    return "applyMask";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lfansi_ResetAttr.prototype.resetMask__J = (function() {
  return this.Lfansi_ResetAttr__f_resetMask;
});
$c_Lfansi_ResetAttr.prototype.applyMask__J = (function() {
  return this.Lfansi_ResetAttr__f_applyMask;
});
$c_Lfansi_ResetAttr.prototype.escapeOpt__s_Option = (function() {
  return this.Lfansi_ResetAttr__f_escapeOpt;
});
$c_Lfansi_ResetAttr.prototype.toString__T = (function() {
  return this.Lfansi_ResetAttr__f_name;
});
function $isArrayOf_Lfansi_ResetAttr(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfansi_ResetAttr)));
}
export { $isArrayOf_Lfansi_ResetAttr as $isArrayOf_Lfansi_ResetAttr };
var $d_Lfansi_ResetAttr = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfansi_ResetAttr, "fansi.ResetAttr", ({
  Lfansi_ResetAttr: 1,
  Lfansi_Attrs: 1,
  Lfansi_Attr: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lfansi_ResetAttr as $d_Lfansi_ResetAttr };
/** @constructor */
function $c_Lframework_components_AppToasts$package$ToastId$() {
  this.Lframework_components_AppToasts$package$ToastId$__f_defaultMake$lzy1 = null;
  this.Lframework_components_AppToasts$package$ToastId$__f_defaultMakebitmap$1 = false;
  this.Lframework_components_AppToasts$package$ToastId$__f_make$lzy1 = null;
  this.Lframework_components_AppToasts$package$ToastId$__f_makebitmap$1 = false;
  this.Lframework_components_AppToasts$package$ToastId$__f_given_Ordering_Type$lzy1 = null;
  this.Lframework_components_AppToasts$package$ToastId$__f_given_Ordering_Typebitmap$1 = false;
}
export { $c_Lframework_components_AppToasts$package$ToastId$ as $c_Lframework_components_AppToasts$package$ToastId$ };
$c_Lframework_components_AppToasts$package$ToastId$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_components_AppToasts$package$ToastId$.prototype.constructor = $c_Lframework_components_AppToasts$package$ToastId$;
/** @constructor */
function $h_Lframework_components_AppToasts$package$ToastId$() {
}
export { $h_Lframework_components_AppToasts$package$ToastId$ as $h_Lframework_components_AppToasts$package$ToastId$ };
$h_Lframework_components_AppToasts$package$ToastId$.prototype = $c_Lframework_components_AppToasts$package$ToastId$.prototype;
$c_Lframework_components_AppToasts$package$ToastId$.prototype.defaultMake__Lyantl_INewtype$defaultMake$ = (function() {
  if ((!this.Lframework_components_AppToasts$package$ToastId$__f_defaultMakebitmap$1)) {
    this.Lframework_components_AppToasts$package$ToastId$__f_defaultMake$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$defaultMake$(this);
    this.Lframework_components_AppToasts$package$ToastId$__f_defaultMakebitmap$1 = true;
  }
  return this.Lframework_components_AppToasts$package$ToastId$__f_defaultMake$lzy1;
});
$c_Lframework_components_AppToasts$package$ToastId$.prototype.make__Lyantl_INewtype$make$ = (function() {
  if ((!this.Lframework_components_AppToasts$package$ToastId$__f_makebitmap$1)) {
    this.Lframework_components_AppToasts$package$ToastId$__f_make$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$make$(this);
    this.Lframework_components_AppToasts$package$ToastId$__f_makebitmap$1 = true;
  }
  return this.Lframework_components_AppToasts$package$ToastId$__f_make$lzy1;
});
$c_Lframework_components_AppToasts$package$ToastId$.prototype.resolveMake__Lyantl_Make = (function() {
  return this.defaultMake__Lyantl_INewtype$defaultMake$();
});
$c_Lframework_components_AppToasts$package$ToastId$.prototype.protected_unwrap__O__O = (function(wrapped) {
  return wrapped;
});
$c_Lframework_components_AppToasts$package$ToastId$.prototype.wrap__O__O = (function(underlying) {
  return underlying;
});
$c_Lframework_components_AppToasts$package$ToastId$.prototype.given_Ordering_Type__s_math_Ordering = (function() {
  if ((!this.Lframework_components_AppToasts$package$ToastId$__f_given_Ordering_Typebitmap$1)) {
    this.Lframework_components_AppToasts$package$ToastId$__f_given_Ordering_Type$lzy1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lframework_utils_NewtypeInt__given_Ordering_Type__s_math_Ordering(this);
    this.Lframework_components_AppToasts$package$ToastId$__f_given_Ordering_Typebitmap$1 = true;
  }
  return this.Lframework_components_AppToasts$package$ToastId$__f_given_Ordering_Type$lzy1;
});
$c_Lframework_components_AppToasts$package$ToastId$.prototype.validate__Lyantl_Validate = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lyantl_Validate$().Lyantl_Validate$__f_noOp;
});
var $d_Lframework_components_AppToasts$package$ToastId$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_components_AppToasts$package$ToastId$, "framework.components.AppToasts$package$ToastId$", ({
  Lframework_components_AppToasts$package$ToastId$: 1,
  Lyantl_INewtype: 1,
  Lyantl_Newtype: 1,
  Lyantl_Newtype$Of: 1,
  Lframework_utils_NewtypeInt: 1,
  Lyantl_Newtype$WithoutValidation: 1
}));
export { $d_Lframework_components_AppToasts$package$ToastId$ as $d_Lframework_components_AppToasts$package$ToastId$ };
var $n_Lframework_components_AppToasts$package$ToastId$;
function $m_Lframework_components_AppToasts$package$ToastId$() {
  if ((!$n_Lframework_components_AppToasts$package$ToastId$)) {
    $n_Lframework_components_AppToasts$package$ToastId$ = new $c_Lframework_components_AppToasts$package$ToastId$();
  }
  return $n_Lframework_components_AppToasts$package$ToastId$;
}
export { $m_Lframework_components_AppToasts$package$ToastId$ as $m_Lframework_components_AppToasts$package$ToastId$ };
/** @constructor */
function $c_Lframework_data_AuthLoadingStatus$Loaded(value) {
  this.Lframework_data_AuthLoadingStatus$Loaded__f_value = null;
  this.Lframework_data_AuthLoadingStatus$Loaded__f_value = value;
}
export { $c_Lframework_data_AuthLoadingStatus$Loaded as $c_Lframework_data_AuthLoadingStatus$Loaded };
$c_Lframework_data_AuthLoadingStatus$Loaded.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_AuthLoadingStatus$Loaded.prototype.constructor = $c_Lframework_data_AuthLoadingStatus$Loaded;
/** @constructor */
function $h_Lframework_data_AuthLoadingStatus$Loaded() {
}
export { $h_Lframework_data_AuthLoadingStatus$Loaded as $h_Lframework_data_AuthLoadingStatus$Loaded };
$h_Lframework_data_AuthLoadingStatus$Loaded.prototype = $c_Lframework_data_AuthLoadingStatus$Loaded.prototype;
$c_Lframework_data_AuthLoadingStatus$Loaded.prototype.isLoading__Z = (function() {
  return $f_Lframework_data_AuthLoadingStatus__isLoading__Z(this);
});
$c_Lframework_data_AuthLoadingStatus$Loaded.prototype.toLoadedOption__s_Option = (function() {
  return $f_Lframework_data_AuthLoadingStatus__toLoadedOption__s_Option(this);
});
$c_Lframework_data_AuthLoadingStatus$Loaded.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_data_AuthLoadingStatus$Loaded.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1109440233), true);
});
$c_Lframework_data_AuthLoadingStatus$Loaded.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lframework_data_AuthLoadingStatus$Loaded)) {
    var x = this.Lframework_data_AuthLoadingStatus$Loaded__f_value;
    var y = x$0.Lframework_data_AuthLoadingStatus$Loaded__f_value;
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lframework_data_AuthLoadingStatus$Loaded.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lframework_data_AuthLoadingStatus$Loaded.prototype.productArity__I = (function() {
  return 1;
});
$c_Lframework_data_AuthLoadingStatus$Loaded.prototype.productPrefix__T = (function() {
  return "Loaded";
});
$c_Lframework_data_AuthLoadingStatus$Loaded.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_data_AuthLoadingStatus$Loaded__f_value;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_AuthLoadingStatus$Loaded.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lframework_data_AuthLoadingStatus$Loaded(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_data_AuthLoadingStatus$Loaded)));
}
export { $isArrayOf_Lframework_data_AuthLoadingStatus$Loaded as $isArrayOf_Lframework_data_AuthLoadingStatus$Loaded };
var $d_Lframework_data_AuthLoadingStatus$Loaded = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_AuthLoadingStatus$Loaded, "framework.data.AuthLoadingStatus$Loaded", ({
  Lframework_data_AuthLoadingStatus$Loaded: 1,
  Lframework_data_LoadingStatus: 1,
  Lframework_data_AuthLoadingStatus: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_data_AuthLoadingStatus$Loaded as $d_Lframework_data_AuthLoadingStatus$Loaded };
/** @constructor */
function $c_Lframework_data_AuthToken$Dev(token) {
  this.Lframework_data_AuthToken$Dev__f_token = null;
  this.Lframework_data_AuthToken$Dev__f_token = token;
}
export { $c_Lframework_data_AuthToken$Dev as $c_Lframework_data_AuthToken$Dev };
$c_Lframework_data_AuthToken$Dev.prototype = new $h_Lframework_data_AuthToken();
$c_Lframework_data_AuthToken$Dev.prototype.constructor = $c_Lframework_data_AuthToken$Dev;
/** @constructor */
function $h_Lframework_data_AuthToken$Dev() {
}
export { $h_Lframework_data_AuthToken$Dev as $h_Lframework_data_AuthToken$Dev };
$h_Lframework_data_AuthToken$Dev.prototype = $c_Lframework_data_AuthToken$Dev.prototype;
$c_Lframework_data_AuthToken$Dev.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-681738051), true);
});
$c_Lframework_data_AuthToken$Dev.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lframework_data_AuthToken$Dev)) {
    var x = this.Lframework_data_AuthToken$Dev__f_token;
    var y = x$0.Lframework_data_AuthToken$Dev__f_token;
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lframework_data_AuthToken$Dev.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lframework_data_AuthToken$Dev.prototype.productArity__I = (function() {
  return 1;
});
$c_Lframework_data_AuthToken$Dev.prototype.productPrefix__T = (function() {
  return "Dev";
});
$c_Lframework_data_AuthToken$Dev.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_data_AuthToken$Dev__f_token;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_AuthToken$Dev.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "token";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_AuthToken$Dev.prototype.ordinal__I = (function() {
  return 1;
});
function $isArrayOf_Lframework_data_AuthToken$Dev(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_data_AuthToken$Dev)));
}
export { $isArrayOf_Lframework_data_AuthToken$Dev as $isArrayOf_Lframework_data_AuthToken$Dev };
var $d_Lframework_data_AuthToken$Dev = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_AuthToken$Dev, "framework.data.AuthToken$Dev", ({
  Lframework_data_AuthToken$Dev: 1,
  Lframework_data_AuthToken: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lframework_data_AuthToken$Dev as $d_Lframework_data_AuthToken$Dev };
/** @constructor */
function $c_Lframework_data_AuthToken$Jwt(token) {
  this.Lframework_data_AuthToken$Jwt__f_token = null;
  this.Lframework_data_AuthToken$Jwt__f_token = token;
}
export { $c_Lframework_data_AuthToken$Jwt as $c_Lframework_data_AuthToken$Jwt };
$c_Lframework_data_AuthToken$Jwt.prototype = new $h_Lframework_data_AuthToken();
$c_Lframework_data_AuthToken$Jwt.prototype.constructor = $c_Lframework_data_AuthToken$Jwt;
/** @constructor */
function $h_Lframework_data_AuthToken$Jwt() {
}
export { $h_Lframework_data_AuthToken$Jwt as $h_Lframework_data_AuthToken$Jwt };
$h_Lframework_data_AuthToken$Jwt.prototype = $c_Lframework_data_AuthToken$Jwt.prototype;
$c_Lframework_data_AuthToken$Jwt.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1375125502, true);
});
$c_Lframework_data_AuthToken$Jwt.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lframework_data_AuthToken$Jwt) && (this.Lframework_data_AuthToken$Jwt__f_token === x$0.Lframework_data_AuthToken$Jwt__f_token)));
});
$c_Lframework_data_AuthToken$Jwt.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lframework_data_AuthToken$Jwt.prototype.productArity__I = (function() {
  return 1;
});
$c_Lframework_data_AuthToken$Jwt.prototype.productPrefix__T = (function() {
  return "Jwt";
});
$c_Lframework_data_AuthToken$Jwt.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_data_AuthToken$Jwt__f_token;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_AuthToken$Jwt.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "token";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_AuthToken$Jwt.prototype.ordinal__I = (function() {
  return 0;
});
function $isArrayOf_Lframework_data_AuthToken$Jwt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_data_AuthToken$Jwt)));
}
export { $isArrayOf_Lframework_data_AuthToken$Jwt as $isArrayOf_Lframework_data_AuthToken$Jwt };
var $d_Lframework_data_AuthToken$Jwt = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_AuthToken$Jwt, "framework.data.AuthToken$Jwt", ({
  Lframework_data_AuthToken$Jwt: 1,
  Lframework_data_AuthToken: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lframework_data_AuthToken$Jwt as $d_Lframework_data_AuthToken$Jwt };
/** @constructor */
function $c_Lframework_data_Email$package$Email$() {
  this.Lframework_data_Email$package$Email$__f_defaultMake$lzy2 = null;
  this.Lframework_data_Email$package$Email$__f_defaultMakebitmap$2 = false;
  this.Lframework_data_Email$package$Email$__f_make$lzy2 = null;
  this.Lframework_data_Email$package$Email$__f_makebitmap$2 = false;
  this.Lframework_data_Email$package$Email$__f_given_Show_Type$lzy2 = null;
  this.Lframework_data_Email$package$Email$__f_given_Show_Typebitmap$2 = false;
  this.Lframework_data_Email$package$Email$__f_given_CanEqual_Type_Type$lzy1 = null;
  this.Lframework_data_Email$package$Email$__f_given_CanEqual_Type_Typebitmap$1 = false;
  this.Lframework_data_Email$package$Email$__f_validator = null;
  this.Lframework_data_Email$package$Email$__f_resolveMake = null;
  $n_Lframework_data_Email$package$Email$ = this;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lyantl_Validator$();
  var x = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lyantl_ValidatorRule.getArrayOf().constr)([($m_Lframework_data_Email$package$Email$(), new $c_Lframework_data_Email$package$Email$$anon$1())]);
  this.Lframework_data_Email$package$Email$__f_validator = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lyantl_Validator$().fromRules__ALyantl_ValidatorRule__Lyantl_Validator(x);
  var this$5 = this.defaultMake__Lyantl_INewtype$defaultMake$();
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((email) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__toLowerCase__ju_Locale__T(email, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_Locale$().ROOT__ju_Locale())));
  this.Lframework_data_Email$package$Email$__f_resolveMake = new $c_Lyantl_Make$$anon$1(f, this$5);
}
export { $c_Lframework_data_Email$package$Email$ as $c_Lframework_data_Email$package$Email$ };
$c_Lframework_data_Email$package$Email$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_Email$package$Email$.prototype.constructor = $c_Lframework_data_Email$package$Email$;
/** @constructor */
function $h_Lframework_data_Email$package$Email$() {
}
export { $h_Lframework_data_Email$package$Email$ as $h_Lframework_data_Email$package$Email$ };
$h_Lframework_data_Email$package$Email$.prototype = $c_Lframework_data_Email$package$Email$.prototype;
$c_Lframework_data_Email$package$Email$.prototype.defaultMake__Lyantl_INewtype$defaultMake$ = (function() {
  if ((!this.Lframework_data_Email$package$Email$__f_defaultMakebitmap$2)) {
    this.Lframework_data_Email$package$Email$__f_defaultMake$lzy2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$defaultMake$(this);
    this.Lframework_data_Email$package$Email$__f_defaultMakebitmap$2 = true;
  }
  return this.Lframework_data_Email$package$Email$__f_defaultMake$lzy2;
});
$c_Lframework_data_Email$package$Email$.prototype.make__Lyantl_INewtype$make$ = (function() {
  if ((!this.Lframework_data_Email$package$Email$__f_makebitmap$2)) {
    this.Lframework_data_Email$package$Email$__f_make$lzy2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$make$(this);
    this.Lframework_data_Email$package$Email$__f_makebitmap$2 = true;
  }
  return this.Lframework_data_Email$package$Email$__f_make$lzy2;
});
$c_Lframework_data_Email$package$Email$.prototype.protected_unwrap__O__O = (function(wrapped) {
  return wrapped;
});
$c_Lframework_data_Email$package$Email$.prototype.wrap__O__O = (function(underlying) {
  return underlying;
});
$c_Lframework_data_Email$package$Email$.prototype.given_Show_Type__Lcats_Show = (function() {
  if ((!this.Lframework_data_Email$package$Email$__f_given_Show_Typebitmap$2)) {
    this.Lframework_data_Email$package$Email$__f_given_Show_Type$lzy2 = new $c_Lframework_utils_NewtypeString$$anon$1(this);
    this.Lframework_data_Email$package$Email$__f_given_Show_Typebitmap$2 = true;
  }
  return this.Lframework_data_Email$package$Email$__f_given_Show_Type$lzy2;
});
$c_Lframework_data_Email$package$Email$.prototype.given_CanEqual_Type_Type__s_CanEqual = (function() {
  if ((!this.Lframework_data_Email$package$Email$__f_given_CanEqual_Type_Typebitmap$1)) {
    this.Lframework_data_Email$package$Email$__f_given_CanEqual_Type_Type$lzy1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_CanEqual$derived$();
    this.Lframework_data_Email$package$Email$__f_given_CanEqual_Type_Typebitmap$1 = true;
  }
  return this.Lframework_data_Email$package$Email$__f_given_CanEqual_Type_Type$lzy1;
});
$c_Lframework_data_Email$package$Email$.prototype.validate__Lyantl_Validate = (function() {
  return this.Lframework_data_Email$package$Email$__f_validator;
});
$c_Lframework_data_Email$package$Email$.prototype.resolveMake__Lyantl_Make = (function() {
  return this.Lframework_data_Email$package$Email$__f_resolveMake;
});
var $d_Lframework_data_Email$package$Email$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_Email$package$Email$, "framework.data.Email$package$Email$", ({
  Lframework_data_Email$package$Email$: 1,
  Lyantl_INewtype: 1,
  Lyantl_Newtype: 1,
  Lyantl_Newtype$Of: 1,
  Lframework_utils_NewtypeString: 1,
  Lyantl_Newtype$ValidatedOf: 1
}));
export { $d_Lframework_data_Email$package$Email$ as $d_Lframework_data_Email$package$Email$ };
var $n_Lframework_data_Email$package$Email$;
function $m_Lframework_data_Email$package$Email$() {
  if ((!$n_Lframework_data_Email$package$Email$)) {
    $n_Lframework_data_Email$package$Email$ = new $c_Lframework_data_Email$package$Email$();
  }
  return $n_Lframework_data_Email$package$Email$;
}
export { $m_Lframework_data_Email$package$Email$ as $m_Lframework_data_Email$package$Email$ };
/** @constructor */
function $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback(trySSEAgainAt) {
  this.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback__f_trySSEAgainAt = null;
  this.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback__f_trySSEAgainAt = trySSEAgainAt;
}
export { $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback as $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback };
$c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback.prototype = new $h_Lframework_data_EndpointSSEWithWS$ClientConnectionMode();
$c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback.prototype.constructor = $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback;
/** @constructor */
function $h_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback() {
}
export { $h_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback as $h_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback };
$h_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback.prototype = $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback.prototype;
$c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-881783466), true);
});
$c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback)) {
    var x = this.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback__f_trySSEAgainAt;
    var x$2 = x$0.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback__f_trySSEAgainAt;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback.prototype.productArity__I = (function() {
  return 1;
});
$c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback.prototype.productPrefix__T = (function() {
  return "SSEWithWebSocketFallback";
});
$c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback__f_trySSEAgainAt;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "trySSEAgainAt";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback.prototype.ordinal__I = (function() {
  return 2;
});
function $isArrayOf_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback)));
}
export { $isArrayOf_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback as $isArrayOf_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback };
var $d_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback, "framework.data.EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback", ({
  Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback: 1,
  Lframework_data_EndpointSSEWithWS$ClientConnectionMode: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback as $d_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$SSEWithWebSocketFallback };
/** @constructor */
function $c_Lframework_data_FrameworkDate(ld) {
  this.Lframework_data_FrameworkDate__f_ld = null;
  this.Lframework_data_FrameworkDate__f_ld = ld;
}
export { $c_Lframework_data_FrameworkDate as $c_Lframework_data_FrameworkDate };
$c_Lframework_data_FrameworkDate.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_FrameworkDate.prototype.constructor = $c_Lframework_data_FrameworkDate;
/** @constructor */
function $h_Lframework_data_FrameworkDate() {
}
export { $h_Lframework_data_FrameworkDate as $h_Lframework_data_FrameworkDate };
$h_Lframework_data_FrameworkDate.prototype = $c_Lframework_data_FrameworkDate.prototype;
$c_Lframework_data_FrameworkDate.prototype.compareTo__O__I = (function(that) {
  return this.compare__O__I(that);
});
$c_Lframework_data_FrameworkDate.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_data_FrameworkDate.prototype.hashCode__I = (function() {
  $m_Lframework_data_FrameworkDate$();
  var this$ = this.Lframework_data_FrameworkDate__f_ld;
  return this$.hashCode__I();
});
$c_Lframework_data_FrameworkDate.prototype.equals__O__Z = (function(x$0) {
  return $m_Lframework_data_FrameworkDate$().equals$extension__Ljava_time_LocalDate__O__Z(this.Lframework_data_FrameworkDate__f_ld, x$0);
});
$c_Lframework_data_FrameworkDate.prototype.toString__T = (function() {
  return $m_Lframework_data_FrameworkDate$().toString$extension__Ljava_time_LocalDate__T(this.Lframework_data_FrameworkDate__f_ld);
});
$c_Lframework_data_FrameworkDate.prototype.productArity__I = (function() {
  $m_Lframework_data_FrameworkDate$();
  return 1;
});
$c_Lframework_data_FrameworkDate.prototype.productPrefix__T = (function() {
  $m_Lframework_data_FrameworkDate$();
  return "FrameworkDate";
});
$c_Lframework_data_FrameworkDate.prototype.productElement__I__O = (function(n) {
  return $m_Lframework_data_FrameworkDate$().productElement$extension__Ljava_time_LocalDate__I__O(this.Lframework_data_FrameworkDate__f_ld, n);
});
$c_Lframework_data_FrameworkDate.prototype.productElementName__I__T = (function(n) {
  return $m_Lframework_data_FrameworkDate$().productElementName$extension__Ljava_time_LocalDate__I__T(this.Lframework_data_FrameworkDate__f_ld, n);
});
$c_Lframework_data_FrameworkDate.prototype.compare__O__I = (function(that) {
  var that$1 = ((that === null) ? null : that.Lframework_data_FrameworkDate__f_ld);
  $m_Lframework_data_FrameworkDate$();
  var this$ = this.Lframework_data_FrameworkDate__f_ld;
  return this$.compareTo__Ljava_time_chrono_ChronoLocalDate__I(that$1);
});
function $isArrayOf_Lframework_data_FrameworkDate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_data_FrameworkDate)));
}
export { $isArrayOf_Lframework_data_FrameworkDate as $isArrayOf_Lframework_data_FrameworkDate };
var $d_Lframework_data_FrameworkDate = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_FrameworkDate, "framework.data.FrameworkDate", ({
  Lframework_data_FrameworkDate: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_data_FrameworkDate as $d_Lframework_data_FrameworkDate };
/** @constructor */
function $c_Lframework_data_LocalLoadingStatus$Loaded(value) {
  this.Lframework_data_LocalLoadingStatus$Loaded__f_value = null;
  this.Lframework_data_LocalLoadingStatus$Loaded__f_value = value;
}
export { $c_Lframework_data_LocalLoadingStatus$Loaded as $c_Lframework_data_LocalLoadingStatus$Loaded };
$c_Lframework_data_LocalLoadingStatus$Loaded.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_LocalLoadingStatus$Loaded.prototype.constructor = $c_Lframework_data_LocalLoadingStatus$Loaded;
/** @constructor */
function $h_Lframework_data_LocalLoadingStatus$Loaded() {
}
export { $h_Lframework_data_LocalLoadingStatus$Loaded as $h_Lframework_data_LocalLoadingStatus$Loaded };
$h_Lframework_data_LocalLoadingStatus$Loaded.prototype = $c_Lframework_data_LocalLoadingStatus$Loaded.prototype;
$c_Lframework_data_LocalLoadingStatus$Loaded.prototype.isLoading__Z = (function() {
  return $f_Lframework_data_LocalLoadingStatus__isLoading__Z(this);
});
$c_Lframework_data_LocalLoadingStatus$Loaded.prototype.toLoadedOption__s_Option = (function() {
  return $f_Lframework_data_LocalLoadingStatus__toLoadedOption__s_Option(this);
});
$c_Lframework_data_LocalLoadingStatus$Loaded.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_data_LocalLoadingStatus$Loaded.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1109440233), true);
});
$c_Lframework_data_LocalLoadingStatus$Loaded.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lframework_data_LocalLoadingStatus$Loaded)) {
    var x = this.Lframework_data_LocalLoadingStatus$Loaded__f_value;
    var y = x$0.Lframework_data_LocalLoadingStatus$Loaded__f_value;
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lframework_data_LocalLoadingStatus$Loaded.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lframework_data_LocalLoadingStatus$Loaded.prototype.productArity__I = (function() {
  return 1;
});
$c_Lframework_data_LocalLoadingStatus$Loaded.prototype.productPrefix__T = (function() {
  return "Loaded";
});
$c_Lframework_data_LocalLoadingStatus$Loaded.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_data_LocalLoadingStatus$Loaded__f_value;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_LocalLoadingStatus$Loaded.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lframework_data_LocalLoadingStatus$Loaded(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_data_LocalLoadingStatus$Loaded)));
}
export { $isArrayOf_Lframework_data_LocalLoadingStatus$Loaded as $isArrayOf_Lframework_data_LocalLoadingStatus$Loaded };
var $d_Lframework_data_LocalLoadingStatus$Loaded = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_LocalLoadingStatus$Loaded, "framework.data.LocalLoadingStatus$Loaded", ({
  Lframework_data_LocalLoadingStatus$Loaded: 1,
  Lframework_data_LoadingStatus: 1,
  Lframework_data_LocalLoadingStatus: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_data_LocalLoadingStatus$Loaded as $d_Lframework_data_LocalLoadingStatus$Loaded };
/** @constructor */
function $c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter(securityInput, input, after) {
  this.Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter__f_securityInput = null;
  this.Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter__f_input = null;
  this.Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter__f_after = null;
  this.Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter__f_securityInput = securityInput;
  this.Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter__f_input = input;
  this.Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter__f_after = after;
}
export { $c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter as $c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter };
$c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter.prototype = new $h_Lframework_exts_OnSSEStreamError$OnErrorAction();
$c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter.prototype.constructor = $c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter;
/** @constructor */
function $h_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter() {
}
export { $h_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter as $h_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter };
$h_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter.prototype = $c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter.prototype;
$c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 892131414, true);
});
$c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter)) {
    var x = this.Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter__f_securityInput;
    var y = x$0.Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter__f_securityInput;
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter__f_input;
      var y$1 = x$0.Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter__f_input;
      var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y$1);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$2 = this.Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter__f_after;
      var x$2$1 = x$0.Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter__f_after;
      return ((x$2 === null) ? (x$2$1 === null) : x$2.equals__O__Z(x$2$1));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter.prototype.productArity__I = (function() {
  return 3;
});
$c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter.prototype.productPrefix__T = (function() {
  return "ReconnectAfter";
});
$c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter__f_securityInput;
      break;
    }
    case 1: {
      return this.Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter__f_input;
      break;
    }
    case 2: {
      return this.Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter__f_after;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "securityInput";
      break;
    }
    case 1: {
      return "input";
      break;
    }
    case 2: {
      return "after";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter.prototype.ordinal__I = (function() {
  return 0;
});
function $isArrayOf_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter)));
}
export { $isArrayOf_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter as $isArrayOf_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter };
var $d_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter, "framework.exts.OnSSEStreamError$OnErrorAction$ReconnectAfter", ({
  Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter: 1,
  Lframework_exts_OnSSEStreamError$OnErrorAction: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter as $d_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectAfter };
/** @constructor */
function $c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith(stream) {
  this.Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith__f_stream = null;
  this.Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith__f_stream = stream;
}
export { $c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith as $c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith };
$c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith.prototype = new $h_Lframework_exts_OnSSEStreamError$OnErrorAction();
$c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith.prototype.constructor = $c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith;
/** @constructor */
function $h_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith() {
}
export { $h_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith as $h_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith };
$h_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith.prototype = $c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith.prototype;
$c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1386166339, true);
});
$c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith)) {
    var x = this.Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith__f_stream;
    var x$2 = x$0.Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith__f_stream;
    return (x === x$2);
  } else {
    return false;
  }
});
$c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith.prototype.productArity__I = (function() {
  return 1;
});
$c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith.prototype.productPrefix__T = (function() {
  return "ReconnectWith";
});
$c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith__f_stream;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "stream";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith.prototype.ordinal__I = (function() {
  return 1;
});
function $isArrayOf_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith)));
}
export { $isArrayOf_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith as $isArrayOf_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith };
var $d_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith, "framework.exts.OnSSEStreamError$OnErrorAction$ReconnectWith", ({
  Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith: 1,
  Lframework_exts_OnSSEStreamError$OnErrorAction: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith as $d_Lframework_exts_OnSSEStreamError$OnErrorAction$ReconnectWith };
/** @constructor */
function $c_Lframework_prelude_client\uff3flogging$package$JSAppName$() {
  this.Lframework_prelude_client\uff3flogging$package$JSAppName$__f_defaultMake$lzy1 = null;
  this.Lframework_prelude_client\uff3flogging$package$JSAppName$__f_defaultMakebitmap$1 = false;
  this.Lframework_prelude_client\uff3flogging$package$JSAppName$__f_make$lzy1 = null;
  this.Lframework_prelude_client\uff3flogging$package$JSAppName$__f_makebitmap$1 = false;
  this.Lframework_prelude_client\uff3flogging$package$JSAppName$__f_given_Show_Type$lzy1 = null;
  this.Lframework_prelude_client\uff3flogging$package$JSAppName$__f_given_Show_Typebitmap$1 = false;
}
export { $c_Lframework_prelude_client\uff3flogging$package$JSAppName$ as $c_Lframework_prelude_client\uff3flogging$package$JSAppName$ };
$c_Lframework_prelude_client\uff3flogging$package$JSAppName$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_prelude_client\uff3flogging$package$JSAppName$.prototype.constructor = $c_Lframework_prelude_client\uff3flogging$package$JSAppName$;
/** @constructor */
function $h_Lframework_prelude_client\uff3flogging$package$JSAppName$() {
}
export { $h_Lframework_prelude_client\uff3flogging$package$JSAppName$ as $h_Lframework_prelude_client\uff3flogging$package$JSAppName$ };
$h_Lframework_prelude_client\uff3flogging$package$JSAppName$.prototype = $c_Lframework_prelude_client\uff3flogging$package$JSAppName$.prototype;
$c_Lframework_prelude_client\uff3flogging$package$JSAppName$.prototype.defaultMake__Lyantl_INewtype$defaultMake$ = (function() {
  if ((!this.Lframework_prelude_client\uff3flogging$package$JSAppName$__f_defaultMakebitmap$1)) {
    this.Lframework_prelude_client\uff3flogging$package$JSAppName$__f_defaultMake$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$defaultMake$(this);
    this.Lframework_prelude_client\uff3flogging$package$JSAppName$__f_defaultMakebitmap$1 = true;
  }
  return this.Lframework_prelude_client\uff3flogging$package$JSAppName$__f_defaultMake$lzy1;
});
$c_Lframework_prelude_client\uff3flogging$package$JSAppName$.prototype.make__Lyantl_INewtype$make$ = (function() {
  if ((!this.Lframework_prelude_client\uff3flogging$package$JSAppName$__f_makebitmap$1)) {
    this.Lframework_prelude_client\uff3flogging$package$JSAppName$__f_make$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$make$(this);
    this.Lframework_prelude_client\uff3flogging$package$JSAppName$__f_makebitmap$1 = true;
  }
  return this.Lframework_prelude_client\uff3flogging$package$JSAppName$__f_make$lzy1;
});
$c_Lframework_prelude_client\uff3flogging$package$JSAppName$.prototype.resolveMake__Lyantl_Make = (function() {
  return this.defaultMake__Lyantl_INewtype$defaultMake$();
});
$c_Lframework_prelude_client\uff3flogging$package$JSAppName$.prototype.protected_unwrap__O__O = (function(wrapped) {
  return wrapped;
});
$c_Lframework_prelude_client\uff3flogging$package$JSAppName$.prototype.wrap__O__O = (function(underlying) {
  return underlying;
});
$c_Lframework_prelude_client\uff3flogging$package$JSAppName$.prototype.given_Show_Type__Lcats_Show = (function() {
  if ((!this.Lframework_prelude_client\uff3flogging$package$JSAppName$__f_given_Show_Typebitmap$1)) {
    this.Lframework_prelude_client\uff3flogging$package$JSAppName$__f_given_Show_Type$lzy1 = new $c_Lframework_utils_NewtypeString$$anon$1(this);
    this.Lframework_prelude_client\uff3flogging$package$JSAppName$__f_given_Show_Typebitmap$1 = true;
  }
  return this.Lframework_prelude_client\uff3flogging$package$JSAppName$__f_given_Show_Type$lzy1;
});
$c_Lframework_prelude_client\uff3flogging$package$JSAppName$.prototype.validate__Lyantl_Validate = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lyantl_Validate$().Lyantl_Validate$__f_noOp;
});
var $d_Lframework_prelude_client\uff3flogging$package$JSAppName$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_prelude_client\uff3flogging$package$JSAppName$, "framework.prelude.client_logging$package$JSAppName$", ({
  Lframework_prelude_client\uff3flogging$package$JSAppName$: 1,
  Lyantl_INewtype: 1,
  Lyantl_Newtype: 1,
  Lyantl_Newtype$Of: 1,
  Lframework_utils_NewtypeString: 1,
  Lyantl_Newtype$WithoutValidation: 1
}));
export { $d_Lframework_prelude_client\uff3flogging$package$JSAppName$ as $d_Lframework_prelude_client\uff3flogging$package$JSAppName$ };
var $n_Lframework_prelude_client\uff3flogging$package$JSAppName$;
function $m_Lframework_prelude_client\uff3flogging$package$JSAppName$() {
  if ((!$n_Lframework_prelude_client\uff3flogging$package$JSAppName$)) {
    $n_Lframework_prelude_client\uff3flogging$package$JSAppName$ = new $c_Lframework_prelude_client\uff3flogging$package$JSAppName$();
  }
  return $n_Lframework_prelude_client\uff3flogging$package$JSAppName$;
}
export { $m_Lframework_prelude_client\uff3flogging$package$JSAppName$ as $m_Lframework_prelude_client\uff3flogging$package$JSAppName$ };
/** @constructor */
function $c_Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError(err) {
  this.Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError__f_err = null;
  this.Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError__f_err = err;
}
export { $c_Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError as $c_Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError };
$c_Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError.prototype = new $h_Lframework_utils_AuthenticatedNetworkRequestFailure();
$c_Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError.prototype.constructor = $c_Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError;
/** @constructor */
function $h_Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError() {
}
export { $h_Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError as $h_Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError };
$h_Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError.prototype = $c_Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError.prototype;
$c_Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 8672841, true);
});
$c_Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError)) {
    var x = this.Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError__f_err;
    var x$2 = x$0.Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError__f_err;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError.prototype.productArity__I = (function() {
  return 1;
});
$c_Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError.prototype.productPrefix__T = (function() {
  return "NetworkOrEndpointError";
});
$c_Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError__f_err;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "err";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError.prototype.ordinal__I = (function() {
  return 0;
});
function $isArrayOf_Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError)));
}
export { $isArrayOf_Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError as $isArrayOf_Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError };
var $d_Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError, "framework.utils.AuthenticatedNetworkRequestFailure$NetworkOrEndpointError", ({
  Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError: 1,
  Lframework_utils_AuthenticatedNetworkRequestFailure: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError as $d_Lframework_utils_AuthenticatedNetworkRequestFailure$NetworkOrEndpointError };
/** @constructor */
function $c_Lframework_utils_BrowserDetection$Other(userAgent, userAgentData) {
  this.Lframework_utils_BrowserDetection$Other__f_userAgent = null;
  this.Lframework_utils_BrowserDetection$Other__f_userAgentData = null;
  this.Lframework_utils_BrowserDetection$Other__f_userAgent = userAgent;
  this.Lframework_utils_BrowserDetection$Other__f_userAgentData = userAgentData;
}
export { $c_Lframework_utils_BrowserDetection$Other as $c_Lframework_utils_BrowserDetection$Other };
$c_Lframework_utils_BrowserDetection$Other.prototype = new $h_Lframework_utils_BrowserDetection();
$c_Lframework_utils_BrowserDetection$Other.prototype.constructor = $c_Lframework_utils_BrowserDetection$Other;
/** @constructor */
function $h_Lframework_utils_BrowserDetection$Other() {
}
export { $h_Lframework_utils_BrowserDetection$Other as $h_Lframework_utils_BrowserDetection$Other };
$h_Lframework_utils_BrowserDetection$Other.prototype = $c_Lframework_utils_BrowserDetection$Other.prototype;
$c_Lframework_utils_BrowserDetection$Other.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1829651457, true);
});
$c_Lframework_utils_BrowserDetection$Other.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lframework_utils_BrowserDetection$Other)) {
    if ((this.Lframework_utils_BrowserDetection$Other__f_userAgent === x$0.Lframework_utils_BrowserDetection$Other__f_userAgent)) {
      var x = this.Lframework_utils_BrowserDetection$Other__f_userAgentData;
      var x$2 = x$0.Lframework_utils_BrowserDetection$Other__f_userAgentData;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lframework_utils_BrowserDetection$Other.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lframework_utils_BrowserDetection$Other.prototype.productArity__I = (function() {
  return 2;
});
$c_Lframework_utils_BrowserDetection$Other.prototype.productPrefix__T = (function() {
  return "Other";
});
$c_Lframework_utils_BrowserDetection$Other.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_utils_BrowserDetection$Other__f_userAgent;
  }
  if ((n === 1)) {
    return this.Lframework_utils_BrowserDetection$Other__f_userAgentData;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_utils_BrowserDetection$Other.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "userAgent";
  }
  if ((n === 1)) {
    return "userAgentData";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_utils_BrowserDetection$Other.prototype.ordinal__I = (function() {
  return 1;
});
function $isArrayOf_Lframework_utils_BrowserDetection$Other(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_utils_BrowserDetection$Other)));
}
export { $isArrayOf_Lframework_utils_BrowserDetection$Other as $isArrayOf_Lframework_utils_BrowserDetection$Other };
var $d_Lframework_utils_BrowserDetection$Other = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_BrowserDetection$Other, "framework.utils.BrowserDetection$Other", ({
  Lframework_utils_BrowserDetection$Other: 1,
  Lframework_utils_BrowserDetection: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lframework_utils_BrowserDetection$Other as $d_Lframework_utils_BrowserDetection$Other };
/** @constructor */
function $c_Lframework_utils_NetworkError$DecodeError(failure) {
  this.Lframework_utils_NetworkError$DecodeError__f_failure = null;
  this.Lframework_utils_NetworkError$DecodeError__f_failure = failure;
}
export { $c_Lframework_utils_NetworkError$DecodeError as $c_Lframework_utils_NetworkError$DecodeError };
$c_Lframework_utils_NetworkError$DecodeError.prototype = new $h_Lframework_utils_NetworkError();
$c_Lframework_utils_NetworkError$DecodeError.prototype.constructor = $c_Lframework_utils_NetworkError$DecodeError;
/** @constructor */
function $h_Lframework_utils_NetworkError$DecodeError() {
}
export { $h_Lframework_utils_NetworkError$DecodeError as $h_Lframework_utils_NetworkError$DecodeError };
$h_Lframework_utils_NetworkError$DecodeError.prototype = $c_Lframework_utils_NetworkError$DecodeError.prototype;
$c_Lframework_utils_NetworkError$DecodeError.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 301118149, true);
});
$c_Lframework_utils_NetworkError$DecodeError.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lframework_utils_NetworkError$DecodeError)) {
    var x = this.Lframework_utils_NetworkError$DecodeError__f_failure;
    var x$2 = x$0.Lframework_utils_NetworkError$DecodeError__f_failure;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lframework_utils_NetworkError$DecodeError.prototype.productArity__I = (function() {
  return 1;
});
$c_Lframework_utils_NetworkError$DecodeError.prototype.productPrefix__T = (function() {
  return "DecodeError";
});
$c_Lframework_utils_NetworkError$DecodeError.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_utils_NetworkError$DecodeError__f_failure;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_utils_NetworkError$DecodeError.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "failure";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lframework_utils_NetworkError$DecodeError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_utils_NetworkError$DecodeError)));
}
export { $isArrayOf_Lframework_utils_NetworkError$DecodeError as $isArrayOf_Lframework_utils_NetworkError$DecodeError };
var $d_Lframework_utils_NetworkError$DecodeError = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_NetworkError$DecodeError, "framework.utils.NetworkError$DecodeError", ({
  Lframework_utils_NetworkError$DecodeError: 1,
  Lframework_utils_NetworkError: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lframework_utils_NetworkError$DecodeError as $d_Lframework_utils_NetworkError$DecodeError };
/** @constructor */
function $c_Lframework_utils_NetworkError$JsError(jsError) {
  this.Lframework_utils_NetworkError$JsError__f_jsError = null;
  this.Lframework_utils_NetworkError$JsError__f_jsError = jsError;
}
export { $c_Lframework_utils_NetworkError$JsError as $c_Lframework_utils_NetworkError$JsError };
$c_Lframework_utils_NetworkError$JsError.prototype = new $h_Lframework_utils_NetworkError();
$c_Lframework_utils_NetworkError$JsError.prototype.constructor = $c_Lframework_utils_NetworkError$JsError;
/** @constructor */
function $h_Lframework_utils_NetworkError$JsError() {
}
export { $h_Lframework_utils_NetworkError$JsError as $h_Lframework_utils_NetworkError$JsError };
$h_Lframework_utils_NetworkError$JsError.prototype = $c_Lframework_utils_NetworkError$JsError.prototype;
$c_Lframework_utils_NetworkError$JsError.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 737952787, true);
});
$c_Lframework_utils_NetworkError$JsError.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lframework_utils_NetworkError$JsError)) {
    var x = this.Lframework_utils_NetworkError$JsError__f_jsError;
    var x$2 = x$0.Lframework_utils_NetworkError$JsError__f_jsError;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lframework_utils_NetworkError$JsError.prototype.productArity__I = (function() {
  return 1;
});
$c_Lframework_utils_NetworkError$JsError.prototype.productPrefix__T = (function() {
  return "JsError";
});
$c_Lframework_utils_NetworkError$JsError.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_utils_NetworkError$JsError__f_jsError;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_utils_NetworkError$JsError.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "jsError";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lframework_utils_NetworkError$JsError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_utils_NetworkError$JsError)));
}
export { $isArrayOf_Lframework_utils_NetworkError$JsError as $isArrayOf_Lframework_utils_NetworkError$JsError };
var $d_Lframework_utils_NetworkError$JsError = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_NetworkError$JsError, "framework.utils.NetworkError$JsError", ({
  Lframework_utils_NetworkError$JsError: 1,
  Lframework_utils_NetworkError: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lframework_utils_NetworkError$JsError as $d_Lframework_utils_NetworkError$JsError };
/** @constructor */
function $c_Lframework_utils_NetworkError$RateLimited(error) {
  this.Lframework_utils_NetworkError$RateLimited__f_error = null;
  this.Lframework_utils_NetworkError$RateLimited__f_error = error;
}
export { $c_Lframework_utils_NetworkError$RateLimited as $c_Lframework_utils_NetworkError$RateLimited };
$c_Lframework_utils_NetworkError$RateLimited.prototype = new $h_Lframework_utils_NetworkError();
$c_Lframework_utils_NetworkError$RateLimited.prototype.constructor = $c_Lframework_utils_NetworkError$RateLimited;
/** @constructor */
function $h_Lframework_utils_NetworkError$RateLimited() {
}
export { $h_Lframework_utils_NetworkError$RateLimited as $h_Lframework_utils_NetworkError$RateLimited };
$h_Lframework_utils_NetworkError$RateLimited.prototype = $c_Lframework_utils_NetworkError$RateLimited.prototype;
$c_Lframework_utils_NetworkError$RateLimited.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 2099832808, true);
});
$c_Lframework_utils_NetworkError$RateLimited.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lframework_utils_NetworkError$RateLimited)) {
    var x = this.Lframework_utils_NetworkError$RateLimited__f_error;
    var x$2 = x$0.Lframework_utils_NetworkError$RateLimited__f_error;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lframework_utils_NetworkError$RateLimited.prototype.productArity__I = (function() {
  return 1;
});
$c_Lframework_utils_NetworkError$RateLimited.prototype.productPrefix__T = (function() {
  return "RateLimited";
});
$c_Lframework_utils_NetworkError$RateLimited.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_utils_NetworkError$RateLimited__f_error;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_utils_NetworkError$RateLimited.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "error";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lframework_utils_NetworkError$RateLimited(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_utils_NetworkError$RateLimited)));
}
export { $isArrayOf_Lframework_utils_NetworkError$RateLimited as $isArrayOf_Lframework_utils_NetworkError$RateLimited };
var $d_Lframework_utils_NetworkError$RateLimited = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_NetworkError$RateLimited, "framework.utils.NetworkError$RateLimited", ({
  Lframework_utils_NetworkError$RateLimited: 1,
  Lframework_utils_NetworkError: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lframework_utils_NetworkError$RateLimited as $d_Lframework_utils_NetworkError$RateLimited };
/** @constructor */
function $c_Lframework_utils_NetworkError$UnexpectedResponse(statusCode, error) {
  this.Lframework_utils_NetworkError$UnexpectedResponse__f_statusCode = 0;
  this.Lframework_utils_NetworkError$UnexpectedResponse__f_error = null;
  this.Lframework_utils_NetworkError$UnexpectedResponse__f_statusCode = statusCode;
  this.Lframework_utils_NetworkError$UnexpectedResponse__f_error = error;
}
export { $c_Lframework_utils_NetworkError$UnexpectedResponse as $c_Lframework_utils_NetworkError$UnexpectedResponse };
$c_Lframework_utils_NetworkError$UnexpectedResponse.prototype = new $h_Lframework_utils_NetworkError();
$c_Lframework_utils_NetworkError$UnexpectedResponse.prototype.constructor = $c_Lframework_utils_NetworkError$UnexpectedResponse;
/** @constructor */
function $h_Lframework_utils_NetworkError$UnexpectedResponse() {
}
export { $h_Lframework_utils_NetworkError$UnexpectedResponse as $h_Lframework_utils_NetworkError$UnexpectedResponse };
$h_Lframework_utils_NetworkError$UnexpectedResponse.prototype = $c_Lframework_utils_NetworkError$UnexpectedResponse.prototype;
$c_Lframework_utils_NetworkError$UnexpectedResponse.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1843103363), true);
});
$c_Lframework_utils_NetworkError$UnexpectedResponse.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lframework_utils_NetworkError$UnexpectedResponse)) {
    if ((this.Lframework_utils_NetworkError$UnexpectedResponse__f_statusCode === x$0.Lframework_utils_NetworkError$UnexpectedResponse__f_statusCode)) {
      var x = this.Lframework_utils_NetworkError$UnexpectedResponse__f_error;
      var x$2 = x$0.Lframework_utils_NetworkError$UnexpectedResponse__f_error;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lframework_utils_NetworkError$UnexpectedResponse.prototype.productArity__I = (function() {
  return 2;
});
$c_Lframework_utils_NetworkError$UnexpectedResponse.prototype.productPrefix__T = (function() {
  return "UnexpectedResponse";
});
$c_Lframework_utils_NetworkError$UnexpectedResponse.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return new $c_Lsttp_model_StatusCode(this.Lframework_utils_NetworkError$UnexpectedResponse__f_statusCode);
  }
  if ((n === 1)) {
    return this.Lframework_utils_NetworkError$UnexpectedResponse__f_error;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_utils_NetworkError$UnexpectedResponse.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "statusCode";
  }
  if ((n === 1)) {
    return "error";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lframework_utils_NetworkError$UnexpectedResponse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_utils_NetworkError$UnexpectedResponse)));
}
export { $isArrayOf_Lframework_utils_NetworkError$UnexpectedResponse as $isArrayOf_Lframework_utils_NetworkError$UnexpectedResponse };
var $d_Lframework_utils_NetworkError$UnexpectedResponse = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_NetworkError$UnexpectedResponse, "framework.utils.NetworkError$UnexpectedResponse", ({
  Lframework_utils_NetworkError$UnexpectedResponse: 1,
  Lframework_utils_NetworkError: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lframework_utils_NetworkError$UnexpectedResponse as $d_Lframework_utils_NetworkError$UnexpectedResponse };
/** @constructor */
function $c_Lframework_utils_NetworkOrEndpointError$EndpointError(error) {
  this.Lframework_utils_NetworkOrEndpointError$EndpointError__f_error = null;
  this.Lframework_utils_NetworkOrEndpointError$EndpointError__f_error = error;
}
export { $c_Lframework_utils_NetworkOrEndpointError$EndpointError as $c_Lframework_utils_NetworkOrEndpointError$EndpointError };
$c_Lframework_utils_NetworkOrEndpointError$EndpointError.prototype = new $h_Lframework_utils_NetworkOrEndpointError();
$c_Lframework_utils_NetworkOrEndpointError$EndpointError.prototype.constructor = $c_Lframework_utils_NetworkOrEndpointError$EndpointError;
/** @constructor */
function $h_Lframework_utils_NetworkOrEndpointError$EndpointError() {
}
export { $h_Lframework_utils_NetworkOrEndpointError$EndpointError as $h_Lframework_utils_NetworkOrEndpointError$EndpointError };
$h_Lframework_utils_NetworkOrEndpointError$EndpointError.prototype = $c_Lframework_utils_NetworkOrEndpointError$EndpointError.prototype;
$c_Lframework_utils_NetworkOrEndpointError$EndpointError.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1768065541, true);
});
$c_Lframework_utils_NetworkOrEndpointError$EndpointError.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lframework_utils_NetworkOrEndpointError$EndpointError)) {
    var x = this.Lframework_utils_NetworkOrEndpointError$EndpointError__f_error;
    var y = x$0.Lframework_utils_NetworkOrEndpointError$EndpointError__f_error;
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lframework_utils_NetworkOrEndpointError$EndpointError.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lframework_utils_NetworkOrEndpointError$EndpointError.prototype.productArity__I = (function() {
  return 1;
});
$c_Lframework_utils_NetworkOrEndpointError$EndpointError.prototype.productPrefix__T = (function() {
  return "EndpointError";
});
$c_Lframework_utils_NetworkOrEndpointError$EndpointError.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_utils_NetworkOrEndpointError$EndpointError__f_error;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_utils_NetworkOrEndpointError$EndpointError.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "error";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lframework_utils_NetworkOrEndpointError$EndpointError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_utils_NetworkOrEndpointError$EndpointError)));
}
export { $isArrayOf_Lframework_utils_NetworkOrEndpointError$EndpointError as $isArrayOf_Lframework_utils_NetworkOrEndpointError$EndpointError };
var $d_Lframework_utils_NetworkOrEndpointError$EndpointError = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_NetworkOrEndpointError$EndpointError, "framework.utils.NetworkOrEndpointError$EndpointError", ({
  Lframework_utils_NetworkOrEndpointError$EndpointError: 1,
  Lframework_utils_NetworkOrEndpointError: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lframework_utils_NetworkOrEndpointError$EndpointError as $d_Lframework_utils_NetworkOrEndpointError$EndpointError };
/** @constructor */
function $c_Lframework_utils_NetworkOrEndpointError$NetworkError(error) {
  this.Lframework_utils_NetworkOrEndpointError$NetworkError__f_error = null;
  this.Lframework_utils_NetworkOrEndpointError$NetworkError__f_error = error;
}
export { $c_Lframework_utils_NetworkOrEndpointError$NetworkError as $c_Lframework_utils_NetworkOrEndpointError$NetworkError };
$c_Lframework_utils_NetworkOrEndpointError$NetworkError.prototype = new $h_Lframework_utils_NetworkOrEndpointError();
$c_Lframework_utils_NetworkOrEndpointError$NetworkError.prototype.constructor = $c_Lframework_utils_NetworkOrEndpointError$NetworkError;
/** @constructor */
function $h_Lframework_utils_NetworkOrEndpointError$NetworkError() {
}
export { $h_Lframework_utils_NetworkOrEndpointError$NetworkError as $h_Lframework_utils_NetworkOrEndpointError$NetworkError };
$h_Lframework_utils_NetworkOrEndpointError$NetworkError.prototype = $c_Lframework_utils_NetworkOrEndpointError$NetworkError.prototype;
$c_Lframework_utils_NetworkOrEndpointError$NetworkError.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1696685833), true);
});
$c_Lframework_utils_NetworkOrEndpointError$NetworkError.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lframework_utils_NetworkOrEndpointError$NetworkError)) {
    var x = this.Lframework_utils_NetworkOrEndpointError$NetworkError__f_error;
    var x$2 = x$0.Lframework_utils_NetworkOrEndpointError$NetworkError__f_error;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lframework_utils_NetworkOrEndpointError$NetworkError.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lframework_utils_NetworkOrEndpointError$NetworkError.prototype.productArity__I = (function() {
  return 1;
});
$c_Lframework_utils_NetworkOrEndpointError$NetworkError.prototype.productPrefix__T = (function() {
  return "NetworkError";
});
$c_Lframework_utils_NetworkOrEndpointError$NetworkError.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_utils_NetworkOrEndpointError$NetworkError__f_error;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_utils_NetworkOrEndpointError$NetworkError.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "error";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lframework_utils_NetworkOrEndpointError$NetworkError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_utils_NetworkOrEndpointError$NetworkError)));
}
export { $isArrayOf_Lframework_utils_NetworkOrEndpointError$NetworkError as $isArrayOf_Lframework_utils_NetworkOrEndpointError$NetworkError };
var $d_Lframework_utils_NetworkOrEndpointError$NetworkError = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_NetworkOrEndpointError$NetworkError, "framework.utils.NetworkOrEndpointError$NetworkError", ({
  Lframework_utils_NetworkOrEndpointError$NetworkError: 1,
  Lframework_utils_NetworkOrEndpointError: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lframework_utils_NetworkOrEndpointError$NetworkError as $d_Lframework_utils_NetworkOrEndpointError$NetworkError };
function $f_Lframework_utils_NewtypeUUID__fromBytes__AB__s_util_Either($thiz, bytes) {
  if ((bytes.u.length !== 16)) {
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
    var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["Failed to create UUID from bytes: expected 16 bytes, got ", ""]));
    var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
    var value = $x_1.show$extension__s_StringContext__sci_Seq__T(sc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(bytes.u.length, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$int$().Lcats_instances_package$int$__f_catsStdShowForInt))])));
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value);
  } else {
    try {
      var array = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().wrapByteIArray__AB__sci_ArraySeq$ofByte(bytes).sci_ArraySeq$ofByte__f_unsafeArray;
      var length = array.u.length;
      var bb = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_nio_HeapByteBuffer$().wrap__AB__I__I__I__I__Z__Ljava_nio_ByteBuffer(array, 0, array.u.length, 0, length, false);
      var r1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Newtype$WithoutValidation__apply__O__O($thiz, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_ju_UUID(bb.getLong__J(), bb.getLong__J()));
      var $x_2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(r1);
    } catch (e) {
      var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
      matchEnd8: {
        var $x_2;
        if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
          var $x_2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(e$2);
          break matchEnd8;
        }
        throw ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
      }
    }
    var this$11 = $x_2.toEither__s_util_Either();
    var this$12 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Either$LeftProjection(this$11);
    var x1 = this$12.s_util_Either$LeftProjection__f_e;
    if ((x1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
      var a = x1.s_util_Left__f_value;
      var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
      var parts$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["Failed to create UUID from bytes: ", ""]));
      var sc$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts$1);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left($x_3.show$extension__s_StringContext__sci_Seq__T(sc$1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(a.getMessage__T(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))]))));
    } else {
      return this$12.s_util_Either$LeftProjection__f_e;
    }
  }
}
export { $f_Lframework_utils_NewtypeUUID__fromBytes__AB__s_util_Either as $f_Lframework_utils_NewtypeUUID__fromBytes__AB__s_util_Either };
function $f_Lframework_utils_NewtypeUUID__fromString__T__s_util_Either($thiz, str) {
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_data_Base64Id$().fromBase64__T__s_Option(str);
  if (this$1.isEmpty__Z()) {
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
    var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["Failed to decode base64: \\\"", "\\\""]));
    var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
    var this$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left($x_1.show$extension__s_StringContext__sci_Seq__T(sc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(str, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))]))));
  } else {
    var this$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(this$1.get__O());
  }
  if ((this$7 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
    var b = this$7.s_util_Right__f_value;
    return $f_Lframework_utils_NewtypeUUID__fromBytes__AB__s_util_Either($thiz, b.Lframework_data_Base64Id__f_bytes);
  } else {
    return this$7;
  }
}
export { $f_Lframework_utils_NewtypeUUID__fromString__T__s_util_Either as $f_Lframework_utils_NewtypeUUID__fromString__T__s_util_Either };
function $f_Lframework_utils_NewtypeUUID__toBinary__ju_UUID__AB($thiz, value) {
  var bb = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_nio_ByteBuffer$().allocate__I__Ljava_nio_ByteBuffer(16);
  bb.putLong__J__Ljava_nio_ByteBuffer(value.ju_UUID__f_java$util$UUID$$mostSigBits);
  bb.putLong__J__Ljava_nio_ByteBuffer(value.ju_UUID__f_java$util$UUID$$leastSigBits);
  var a = bb.Ljava_nio_ByteBuffer__f__array;
  if ((a === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_UnsupportedOperationException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_UnsupportedOperationException());
  }
  if (bb.Ljava_nio_HeapByteBuffer__f__readOnly) {
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Ljava_nio_ReadOnlyBufferException();
  }
  return a;
}
export { $f_Lframework_utils_NewtypeUUID__toBinary__ju_UUID__AB as $f_Lframework_utils_NewtypeUUID__toBinary__ju_UUID__AB };
function $f_Lframework_utils_NewtypeUUID__toBase64__ju_UUID__Lframework_data_Base64Id($thiz, value) {
  var bytes = $f_Lframework_utils_NewtypeUUID__toBinary__ju_UUID__AB($thiz, value);
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lframework_data_Base64Id(bytes);
}
export { $f_Lframework_utils_NewtypeUUID__toBase64__ju_UUID__Lframework_data_Base64Id as $f_Lframework_utils_NewtypeUUID__toBase64__ju_UUID__Lframework_data_Base64Id };
/** @constructor */
function $c_Lframework_utils_PageTitleResult$Custom(title, renderInDocument) {
  this.Lframework_utils_PageTitleResult$Custom__f_title = null;
  this.Lframework_utils_PageTitleResult$Custom__f_renderInDocument = false;
  this.Lframework_utils_PageTitleResult$Custom__f_title = title;
  this.Lframework_utils_PageTitleResult$Custom__f_renderInDocument = renderInDocument;
}
export { $c_Lframework_utils_PageTitleResult$Custom as $c_Lframework_utils_PageTitleResult$Custom };
$c_Lframework_utils_PageTitleResult$Custom.prototype = new $h_Lframework_utils_PageTitleResult();
$c_Lframework_utils_PageTitleResult$Custom.prototype.constructor = $c_Lframework_utils_PageTitleResult$Custom;
/** @constructor */
function $h_Lframework_utils_PageTitleResult$Custom() {
}
export { $h_Lframework_utils_PageTitleResult$Custom as $h_Lframework_utils_PageTitleResult$Custom };
$h_Lframework_utils_PageTitleResult$Custom.prototype = $c_Lframework_utils_PageTitleResult$Custom.prototype;
$c_Lframework_utils_PageTitleResult$Custom.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, 2029746065);
  var hash$1 = acc;
  var x = this.Lframework_utils_PageTitleResult$Custom__f_title;
  var data = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data);
  var hash$2 = acc;
  var data$1 = (this.Lframework_utils_PageTitleResult$Custom__f_renderInDocument ? 1231 : 1237);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$2, data$1);
  var hash$3 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2);
});
$c_Lframework_utils_PageTitleResult$Custom.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lframework_utils_PageTitleResult$Custom)) {
    if ((this.Lframework_utils_PageTitleResult$Custom__f_renderInDocument === x$0.Lframework_utils_PageTitleResult$Custom__f_renderInDocument)) {
      var x = this.Lframework_utils_PageTitleResult$Custom__f_title;
      var y = x$0.Lframework_utils_PageTitleResult$Custom__f_title;
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lframework_utils_PageTitleResult$Custom.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lframework_utils_PageTitleResult$Custom.prototype.productArity__I = (function() {
  return 2;
});
$c_Lframework_utils_PageTitleResult$Custom.prototype.productPrefix__T = (function() {
  return "Custom";
});
$c_Lframework_utils_PageTitleResult$Custom.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_utils_PageTitleResult$Custom__f_title;
  }
  if ((n === 1)) {
    return this.Lframework_utils_PageTitleResult$Custom__f_renderInDocument;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_utils_PageTitleResult$Custom.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "title";
  }
  if ((n === 1)) {
    return "renderInDocument";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_utils_PageTitleResult$Custom.prototype.ordinal__I = (function() {
  return 1;
});
function $isArrayOf_Lframework_utils_PageTitleResult$Custom(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_utils_PageTitleResult$Custom)));
}
export { $isArrayOf_Lframework_utils_PageTitleResult$Custom as $isArrayOf_Lframework_utils_PageTitleResult$Custom };
var $d_Lframework_utils_PageTitleResult$Custom = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_PageTitleResult$Custom, "framework.utils.PageTitleResult$Custom", ({
  Lframework_utils_PageTitleResult$Custom: 1,
  Lframework_utils_PageTitleResult: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lframework_utils_PageTitleResult$Custom as $d_Lframework_utils_PageTitleResult$Custom };
/** @constructor */
function $c_Lframework_utils_PageTitleResult$Default(renderInDocument) {
  this.Lframework_utils_PageTitleResult$Default__f_renderInDocument = false;
  this.Lframework_utils_PageTitleResult$Default__f_renderInDocument = renderInDocument;
}
export { $c_Lframework_utils_PageTitleResult$Default as $c_Lframework_utils_PageTitleResult$Default };
$c_Lframework_utils_PageTitleResult$Default.prototype = new $h_Lframework_utils_PageTitleResult();
$c_Lframework_utils_PageTitleResult$Default.prototype.constructor = $c_Lframework_utils_PageTitleResult$Default;
/** @constructor */
function $h_Lframework_utils_PageTitleResult$Default() {
}
export { $h_Lframework_utils_PageTitleResult$Default as $h_Lframework_utils_PageTitleResult$Default };
$h_Lframework_utils_PageTitleResult$Default.prototype = $c_Lframework_utils_PageTitleResult$Default.prototype;
$c_Lframework_utils_PageTitleResult$Default.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, (-1085510111));
  var hash$1 = acc;
  var data = (this.Lframework_utils_PageTitleResult$Default__f_renderInDocument ? 1231 : 1237);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data);
  var hash$2 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1);
});
$c_Lframework_utils_PageTitleResult$Default.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lframework_utils_PageTitleResult$Default) && (this.Lframework_utils_PageTitleResult$Default__f_renderInDocument === x$0.Lframework_utils_PageTitleResult$Default__f_renderInDocument)));
});
$c_Lframework_utils_PageTitleResult$Default.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lframework_utils_PageTitleResult$Default.prototype.productArity__I = (function() {
  return 1;
});
$c_Lframework_utils_PageTitleResult$Default.prototype.productPrefix__T = (function() {
  return "Default";
});
$c_Lframework_utils_PageTitleResult$Default.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_utils_PageTitleResult$Default__f_renderInDocument;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_utils_PageTitleResult$Default.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "renderInDocument";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_utils_PageTitleResult$Default.prototype.ordinal__I = (function() {
  return 0;
});
function $isArrayOf_Lframework_utils_PageTitleResult$Default(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_utils_PageTitleResult$Default)));
}
export { $isArrayOf_Lframework_utils_PageTitleResult$Default as $isArrayOf_Lframework_utils_PageTitleResult$Default };
var $d_Lframework_utils_PageTitleResult$Default = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_PageTitleResult$Default, "framework.utils.PageTitleResult$Default", ({
  Lframework_utils_PageTitleResult$Default: 1,
  Lframework_utils_PageTitleResult: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lframework_utils_PageTitleResult$Default as $d_Lframework_utils_PageTitleResult$Default };
/** @constructor */
function $c_Lframework_utils_PushNotifications$State$Prompt(pushManager, options, sink) {
  this.Lframework_utils_PushNotifications$State$Prompt__f_pushManager = null;
  this.Lframework_utils_PushNotifications$State$Prompt__f_options = null;
  this.Lframework_utils_PushNotifications$State$Prompt__f_sink = null;
  this.Lframework_utils_PushNotifications$State$Prompt__f_pushManager = pushManager;
  this.Lframework_utils_PushNotifications$State$Prompt__f_options = options;
  this.Lframework_utils_PushNotifications$State$Prompt__f_sink = sink;
}
export { $c_Lframework_utils_PushNotifications$State$Prompt as $c_Lframework_utils_PushNotifications$State$Prompt };
$c_Lframework_utils_PushNotifications$State$Prompt.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_PushNotifications$State$Prompt.prototype.constructor = $c_Lframework_utils_PushNotifications$State$Prompt;
/** @constructor */
function $h_Lframework_utils_PushNotifications$State$Prompt() {
}
export { $h_Lframework_utils_PushNotifications$State$Prompt as $h_Lframework_utils_PushNotifications$State$Prompt };
$h_Lframework_utils_PushNotifications$State$Prompt.prototype = $c_Lframework_utils_PushNotifications$State$Prompt.prototype;
$c_Lframework_utils_PushNotifications$State$Prompt.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_utils_PushNotifications$State$Prompt.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1361412480, true);
});
$c_Lframework_utils_PushNotifications$State$Prompt.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lframework_utils_PushNotifications$State$Prompt)) {
    var x = this.Lframework_utils_PushNotifications$State$Prompt__f_pushManager;
    var y = x$0.Lframework_utils_PushNotifications$State$Prompt__f_pushManager;
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Lframework_utils_PushNotifications$State$Prompt__f_options;
      var y$1 = x$0.Lframework_utils_PushNotifications$State$Prompt__f_options;
      var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y$1);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$2 = this.Lframework_utils_PushNotifications$State$Prompt__f_sink;
      var x$2$1 = x$0.Lframework_utils_PushNotifications$State$Prompt__f_sink;
      return (x$2 === x$2$1);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lframework_utils_PushNotifications$State$Prompt.prototype.productArity__I = (function() {
  return 3;
});
$c_Lframework_utils_PushNotifications$State$Prompt.prototype.productPrefix__T = (function() {
  return "Prompt";
});
$c_Lframework_utils_PushNotifications$State$Prompt.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lframework_utils_PushNotifications$State$Prompt__f_pushManager;
      break;
    }
    case 1: {
      return this.Lframework_utils_PushNotifications$State$Prompt__f_options;
      break;
    }
    case 2: {
      return this.Lframework_utils_PushNotifications$State$Prompt__f_sink;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lframework_utils_PushNotifications$State$Prompt.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "pushManager";
      break;
    }
    case 1: {
      return "options";
      break;
    }
    case 2: {
      return "sink";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lframework_utils_PushNotifications$State$Prompt.prototype.subscription__s_Option = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
});
$c_Lframework_utils_PushNotifications$State$Prompt.prototype.toString__T = (function() {
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
  var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["Prompt(", ")"]));
  var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
  return $x_1.show$extension__s_StringContext__sci_Seq__T(sc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T($m_Lframework_exts_PushSubscriptionOptions$package$().asString__Lorg_scalajs_dom_PushSubscriptionOptions__T(this.Lframework_utils_PushNotifications$State$Prompt__f_options), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))])));
});
function $isArrayOf_Lframework_utils_PushNotifications$State$Prompt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_utils_PushNotifications$State$Prompt)));
}
export { $isArrayOf_Lframework_utils_PushNotifications$State$Prompt as $isArrayOf_Lframework_utils_PushNotifications$State$Prompt };
var $d_Lframework_utils_PushNotifications$State$Prompt = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_PushNotifications$State$Prompt, "framework.utils.PushNotifications$State$Prompt", ({
  Lframework_utils_PushNotifications$State$Prompt: 1,
  Lframework_utils_PushNotifications$State: 1,
  Lframework_utils_PushNotifications$State$Askable: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_utils_PushNotifications$State$Prompt as $d_Lframework_utils_PushNotifications$State$Prompt };
/** @constructor */
function $c_Lfs2_Chunk$EmptyChunk() {
}
export { $c_Lfs2_Chunk$EmptyChunk as $c_Lfs2_Chunk$EmptyChunk };
$c_Lfs2_Chunk$EmptyChunk.prototype = new $h_Lfs2_Chunk();
$c_Lfs2_Chunk$EmptyChunk.prototype.constructor = $c_Lfs2_Chunk$EmptyChunk;
/** @constructor */
function $h_Lfs2_Chunk$EmptyChunk() {
}
export { $h_Lfs2_Chunk$EmptyChunk as $h_Lfs2_Chunk$EmptyChunk };
$h_Lfs2_Chunk$EmptyChunk.prototype = $c_Lfs2_Chunk$EmptyChunk.prototype;
$c_Lfs2_Chunk$EmptyChunk.prototype.size__I = (function() {
  return 0;
});
$c_Lfs2_Chunk$EmptyChunk.prototype.apply__I__E = (function(i) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_sys_package$().error__T__E((("Chunk.empty.apply(" + i) + ")"));
});
$c_Lfs2_Chunk$EmptyChunk.prototype.splitAtChunk___I__T2 = (function(n) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_sys_package$().error__T__E("impossible");
});
$c_Lfs2_Chunk$EmptyChunk.prototype.map__F1__Lfs2_Chunk = (function(f) {
  return this;
});
$c_Lfs2_Chunk$EmptyChunk.prototype.apply__I__O = (function(i) {
  this.apply__I__E(i);
});
var $d_Lfs2_Chunk$EmptyChunk = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Chunk$EmptyChunk, "fs2.Chunk$EmptyChunk", ({
  Lfs2_Chunk$EmptyChunk: 1,
  Lfs2_Chunk: 1,
  Ljava_io_Serializable: 1,
  Lfs2_Chunk213And3Compat: 1,
  Lfs2_ChunkPlatform: 1,
  Lfs2_ChunkRuntimePlatform: 1
}));
export { $d_Lfs2_Chunk$EmptyChunk as $d_Lfs2_Chunk$EmptyChunk };
/** @constructor */
function $c_Lfs2_Chunk$Singleton(value) {
  this.Lfs2_Chunk$Singleton__f_value = null;
  this.Lfs2_Chunk$Singleton__f_value = value;
}
export { $c_Lfs2_Chunk$Singleton as $c_Lfs2_Chunk$Singleton };
$c_Lfs2_Chunk$Singleton.prototype = new $h_Lfs2_Chunk();
$c_Lfs2_Chunk$Singleton.prototype.constructor = $c_Lfs2_Chunk$Singleton;
/** @constructor */
function $h_Lfs2_Chunk$Singleton() {
}
export { $h_Lfs2_Chunk$Singleton as $h_Lfs2_Chunk$Singleton };
$h_Lfs2_Chunk$Singleton.prototype = $c_Lfs2_Chunk$Singleton.prototype;
$c_Lfs2_Chunk$Singleton.prototype.size__I = (function() {
  return 1;
});
$c_Lfs2_Chunk$Singleton.prototype.apply__I__O = (function(i) {
  if ((i === 0)) {
    return this.Lfs2_Chunk$Singleton__f_value;
  } else {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException());
  }
});
$c_Lfs2_Chunk$Singleton.prototype.splitAtChunk___I__T2 = (function(n) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_sys_package$().error__T__E("impossible");
});
$c_Lfs2_Chunk$Singleton.prototype.map__F1__Lfs2_Chunk = (function(f) {
  $m_Lfs2_Chunk$();
  var o = f.apply__O__O(this.Lfs2_Chunk$Singleton__f_value);
  return new $c_Lfs2_Chunk$Singleton(o);
});
var $d_Lfs2_Chunk$Singleton = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Chunk$Singleton, "fs2.Chunk$Singleton", ({
  Lfs2_Chunk$Singleton: 1,
  Lfs2_Chunk: 1,
  Ljava_io_Serializable: 1,
  Lfs2_Chunk213And3Compat: 1,
  Lfs2_ChunkPlatform: 1,
  Lfs2_ChunkRuntimePlatform: 1
}));
export { $d_Lfs2_Chunk$Singleton as $d_Lfs2_Chunk$Singleton };
/** @constructor */
function $c_Lfs2_concurrent_SignallingRef() {
}
export { $c_Lfs2_concurrent_SignallingRef as $c_Lfs2_concurrent_SignallingRef };
$c_Lfs2_concurrent_SignallingRef.prototype = new $h_Lcats_effect_kernel_Ref();
$c_Lfs2_concurrent_SignallingRef.prototype.constructor = $c_Lfs2_concurrent_SignallingRef;
/** @constructor */
function $h_Lfs2_concurrent_SignallingRef() {
}
export { $h_Lfs2_concurrent_SignallingRef as $h_Lfs2_concurrent_SignallingRef };
$h_Lfs2_concurrent_SignallingRef.prototype = $c_Lfs2_concurrent_SignallingRef.prototype;
class $c_Lio_circe_Errors extends $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Exception {
  constructor(errors) {
    super();
    this.Lio_circe_Errors__f_errors = null;
    this.Lio_circe_Errors__f_errors = errors;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  productIterator__sc_Iterator() {
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
  }
  hashCode__I() {
    var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
    return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
  }
  equals__O__Z(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lio_circe_Errors)) {
      var x = this.Lio_circe_Errors__f_errors;
      var x$2 = x$0.Lio_circe_Errors__f_errors;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      return false;
    }
  }
  productArity__I() {
    return 1;
  }
  productPrefix__T() {
    return "Errors";
  }
  productElement__I__O(n) {
    if ((n === 0)) {
      return this.Lio_circe_Errors__f_errors;
    }
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  productElementName__I__T(n) {
    if ((n === 0)) {
      return "errors";
    }
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  fillInStackTrace__jl_Throwable() {
    return this;
  }
}
export { $c_Lio_circe_Errors as $c_Lio_circe_Errors };
function $isArrayOf_Lio_circe_Errors(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Errors)));
}
export { $isArrayOf_Lio_circe_Errors as $isArrayOf_Lio_circe_Errors };
var $d_Lio_circe_Errors = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_circe_Errors, "io.circe.Errors", ({
  Lio_circe_Errors: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lio_circe_Errors as $d_Lio_circe_Errors };
/** @constructor */
function $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain() {
}
export { $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain as $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain };
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.constructor = $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain;
/** @constructor */
function $h_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain() {
}
export { $h_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain as $h_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain };
$h_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype = $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype;
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.knownSize__I = (function() {
  return (-1);
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.foreach__F1__V = (function(f) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.forall__F1__Z = (function(p) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.exists__F1__Z = (function(p) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__exists__F1__Z(this, p);
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.find__F1__s_Option = (function(p) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.reduceLeft__F2__O = (function(op) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.toList__sci_List = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.toVector__sci_Vector = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this);
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.toSeq__sci_Seq = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this);
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.reversed__sc_Iterable = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__reversed__sc_Iterable(this);
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.head__O = (function() {
  return this.iterator__sc_Iterator().next__O();
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.headOption__s_Option = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOps__headOption__s_Option(this);
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.last__O = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOps__last__O(this);
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.filter__F1__O = (function(pred) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOps__filter__F1__O(this, pred);
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.take__I__O = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOps__take__I__O(this, n);
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.drop__I__O = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOps__drop__I__O(this, n);
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.dropRight__I__O = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOps__dropRight__I__O(this, n);
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.tail__O = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOps__tail__O(this);
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.map__F1__O = (function(f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOps__map__F1__O(this, f);
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.flatMap__F1__O = (function(f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOps__flatMap__F1__O(this, f);
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterable$();
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.className__T = (function() {
  return "NonEmptyErrorsChain";
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_Iterable__toString__T(this);
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.unsealPath__Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain = (function() {
  return ((this instanceof $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$UnsealPath) ? this : new $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$UnsealPath(this));
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.isEmpty__Z = (function() {
  return false;
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.iterator__sc_Iterator = (function() {
  if ((this instanceof $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single)) {
    var x18 = this.Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single__f_error;
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$20(x18);
  }
  if ((this instanceof $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Wrap)) {
    var x15 = this.Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Wrap__f_errors;
    return x15.iterator__sc_Iterator();
  }
  if ((this instanceof $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge)) {
    var x11 = this.Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge__f_errors1;
    var x12 = this.Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge__f_errors2;
    var this$5 = x11.iterator__sc_Iterator();
    var xs = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => x12.iterator__sc_Iterator()));
    return this$5.concat__F0__sc_Iterator(xs);
  }
  if ((this instanceof $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath)) {
    var x7 = this.Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath__f_errors;
    var x8 = this.Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath__f_pathElement;
    var this$7 = x7.iterator__sc_Iterator();
    var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => _$1.prependErrorPath__Lio_scalaland_chimney_partial_PathElement__Lio_scalaland_chimney_partial_Error(x8)));
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(this$7, f);
  }
  if ((this instanceof $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$UnsealPath)) {
    var x4 = this.Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$UnsealPath__f_errors;
    var this$9 = x4.iterator__sc_Iterator();
    var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => _$2.unsealErrorPath__Lio_scalaland_chimney_partial_Error()));
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(this$9, f$1);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this);
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.equals__O__Z = (function(obj) {
  return ((obj instanceof $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain) && $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_Iterator__sameElements__sc_IterableOnce__Z(obj.iterator__sc_Iterator(), this.iterator__sc_Iterator()));
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.hashCode__I = (function() {
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  var xs = this.iterator__sc_Iterator();
  return this$1.orderedHash__sc_IterableOnce__I__I(xs, (-1248659538));
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterable$().from__sc_IterableOnce__O(coll);
});
function $isArrayOf_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain)));
}
export { $isArrayOf_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain as $isArrayOf_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain };
class $c_ju_concurrent_CancellationException extends $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalStateException {
  constructor(message) {
    super();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, null, true, true);
  }
}
export { $c_ju_concurrent_CancellationException as $c_ju_concurrent_CancellationException };
var $d_ju_concurrent_CancellationException = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_ju_concurrent_CancellationException, "java.util.concurrent.CancellationException", ({
  ju_concurrent_CancellationException: 1,
  jl_IllegalStateException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_concurrent_CancellationException as $d_ju_concurrent_CancellationException };
/** @constructor */
function $c_Lmonocle_Optional$$anon$3(_getOption$2, _set$4, outer) {
  this.Lmonocle_Optional$$anon$3__f__getOption$1 = null;
  this.Lmonocle_Optional$$anon$3__f__set$2 = null;
  this.Lmonocle_Optional$$anon$3__f__getOption$1 = _getOption$2;
  this.Lmonocle_Optional$$anon$3__f__set$2 = _set$4;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lmonocle_Optional$$anon$3 as $c_Lmonocle_Optional$$anon$3 };
$c_Lmonocle_Optional$$anon$3.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lmonocle_Optional$$anon$3.prototype.constructor = $c_Lmonocle_Optional$$anon$3;
/** @constructor */
function $h_Lmonocle_Optional$$anon$3() {
}
export { $h_Lmonocle_Optional$$anon$3 as $h_Lmonocle_Optional$$anon$3 };
$h_Lmonocle_Optional$$anon$3.prototype = $c_Lmonocle_Optional$$anon$3.prototype;
$c_Lmonocle_Optional$$anon$3.prototype.replace__O__F1 = (function(a) {
  return this.Lmonocle_Optional$$anon$3__f__set$2.apply__O__O(a);
});
$c_Lmonocle_Optional$$anon$3.prototype.modify__F1__F1 = (function(f) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s) => {
    var this$2 = this.Lmonocle_Optional$$anon$3__f__getOption$1.apply__O__O(s);
    if (this$2.isEmpty__Z()) {
      return s;
    } else {
      var x0 = this$2.get__O();
      return this.Lmonocle_Optional$$anon$3__f__set$2.apply__O__O(f.apply__O__O(x0)).apply__O__O(s);
    }
  }));
});
var $d_Lmonocle_Optional$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lmonocle_Optional$$anon$3, "monocle.Optional$$anon$3", ({
  Lmonocle_Optional$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lmonocle_PSetter: 1,
  Lmonocle_Fold: 1,
  Lmonocle_PTraversal: 1,
  Lmonocle_POptional: 1
}));
export { $d_Lmonocle_Optional$$anon$3 as $d_Lmonocle_Optional$$anon$3 };
/** @constructor */
function $c_Lmonocle_POptional$$anon$1(other$7, outer) {
  this.Lmonocle_POptional$$anon$1__f_other$6 = null;
  this.Lmonocle_POptional$$anon$1__f_$outer = null;
  this.Lmonocle_POptional$$anon$1__f_other$6 = other$7;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lmonocle_POptional$$anon$1__f_$outer = outer;
}
export { $c_Lmonocle_POptional$$anon$1 as $c_Lmonocle_POptional$$anon$1 };
$c_Lmonocle_POptional$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lmonocle_POptional$$anon$1.prototype.constructor = $c_Lmonocle_POptional$$anon$1;
/** @constructor */
function $h_Lmonocle_POptional$$anon$1() {
}
export { $h_Lmonocle_POptional$$anon$1 as $h_Lmonocle_POptional$$anon$1 };
$h_Lmonocle_POptional$$anon$1.prototype = $c_Lmonocle_POptional$$anon$1.prototype;
$c_Lmonocle_POptional$$anon$1.prototype.replace__O__F1 = (function(d) {
  return this.Lmonocle_POptional$$anon$1__f_$outer.modify__F1__F1(this.Lmonocle_POptional$$anon$1__f_other$6.replace__O__F1(d));
});
$c_Lmonocle_POptional$$anon$1.prototype.modify__F1__F1 = (function(f) {
  return this.Lmonocle_POptional$$anon$1__f_$outer.modify__F1__F1(this.Lmonocle_POptional$$anon$1__f_other$6.modify__F1__F1(f));
});
var $d_Lmonocle_POptional$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lmonocle_POptional$$anon$1, "monocle.POptional$$anon$1", ({
  Lmonocle_POptional$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lmonocle_PSetter: 1,
  Lmonocle_Fold: 1,
  Lmonocle_PTraversal: 1,
  Lmonocle_POptional: 1
}));
export { $d_Lmonocle_POptional$$anon$1 as $d_Lmonocle_POptional$$anon$1 };
function $f_Lmonocle_PPrism__modify__F1__F1($thiz, f) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => {
    var this$2 = $thiz.getOrModify__O__s_util_Either(_$2);
    if ((this$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
      var b = this$2.s_util_Right__f_value;
      return $thiz.reverseGet__O__O(f.apply__O__O(b));
    } else if ((this$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
      var a = this$2.s_util_Left__f_value;
      return a;
    } else {
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this$2);
    }
  }));
}
export { $f_Lmonocle_PPrism__modify__F1__F1 as $f_Lmonocle_PPrism__modify__F1__F1 };
function $f_Lmonocle_PPrism__replace__O__F1($thiz, b) {
  return $thiz.modify__F1__F1(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$3) => b)));
}
export { $f_Lmonocle_PPrism__replace__O__F1 as $f_Lmonocle_PPrism__replace__O__F1 };
/** @constructor */
function $c_Lpprint_package$() {
  this.Lpprint_Walker__f_tuplePrefix = null;
  this.Lpprint_PPrinter__f_defaultWidth = 0;
  this.Lpprint_PPrinter__f_defaultHeight = 0;
  this.Lpprint_PPrinter__f_defaultIndent = 0;
  this.Lpprint_PPrinter__f_defaultEscapeUnicode = false;
  this.Lpprint_PPrinter__f_defaultShowFieldNames = false;
  this.Lpprint_PPrinter__f_colorLiteral = null;
  this.Lpprint_PPrinter__f_colorApplyPrefix = null;
  this.Lpprint_PPrinter__f_additionalHandlers = null;
  $ct_Lpprint_PPrinter__I__I__I__Z__Z__Lfansi_Attrs__Lfansi_Attrs__s_PartialFunction__(this, 100, 500, 2, false, true, $m_Lfansi_Color$().Lfansi_Color$__f_Green, $m_Lfansi_Color$().Lfansi_Color$__f_Yellow, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_PartialFunction$().s_PartialFunction$__f_empty_pf);
}
export { $c_Lpprint_package$ as $c_Lpprint_package$ };
$c_Lpprint_package$.prototype = new $h_Lpprint_PPrinter();
$c_Lpprint_package$.prototype.constructor = $c_Lpprint_package$;
/** @constructor */
function $h_Lpprint_package$() {
}
export { $h_Lpprint_package$ as $h_Lpprint_package$ };
$h_Lpprint_package$.prototype = $c_Lpprint_package$.prototype;
var $d_Lpprint_package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lpprint_package$, "pprint.package$", ({
  Lpprint_package$: 1,
  Lpprint_PPrinter: 1,
  Lpprint_Walker: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lpprint_package$ as $d_Lpprint_package$ };
var $n_Lpprint_package$;
function $m_Lpprint_package$() {
  if ((!$n_Lpprint_package$)) {
    $n_Lpprint_package$ = new $c_Lpprint_package$();
  }
  return $n_Lpprint_package$;
}
export { $m_Lpprint_package$ as $m_Lpprint_package$ };
/** @constructor */
function $c_Lretry_HandlerDecision$Adapt(newAction) {
  this.Lretry_HandlerDecision$Adapt__f_newAction = null;
  this.Lretry_HandlerDecision$Adapt__f_newAction = newAction;
}
export { $c_Lretry_HandlerDecision$Adapt as $c_Lretry_HandlerDecision$Adapt };
$c_Lretry_HandlerDecision$Adapt.prototype = new $h_Lretry_HandlerDecision();
$c_Lretry_HandlerDecision$Adapt.prototype.constructor = $c_Lretry_HandlerDecision$Adapt;
/** @constructor */
function $h_Lretry_HandlerDecision$Adapt() {
}
export { $h_Lretry_HandlerDecision$Adapt as $h_Lretry_HandlerDecision$Adapt };
$h_Lretry_HandlerDecision$Adapt.prototype = $c_Lretry_HandlerDecision$Adapt.prototype;
$c_Lretry_HandlerDecision$Adapt.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lretry_HandlerDecision$Adapt.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lretry_HandlerDecision$Adapt)) {
    var x = this.Lretry_HandlerDecision$Adapt__f_newAction;
    var y = x$0.Lretry_HandlerDecision$Adapt__f_newAction;
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lretry_HandlerDecision$Adapt.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lretry_HandlerDecision$Adapt.prototype.productArity__I = (function() {
  return 1;
});
$c_Lretry_HandlerDecision$Adapt.prototype.productPrefix__T = (function() {
  return "Adapt";
});
$c_Lretry_HandlerDecision$Adapt.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lretry_HandlerDecision$Adapt__f_newAction;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lretry_HandlerDecision$Adapt.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "newAction";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lretry_HandlerDecision$Adapt.prototype.ordinal__I = (function() {
  return 2;
});
function $isArrayOf_Lretry_HandlerDecision$Adapt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lretry_HandlerDecision$Adapt)));
}
export { $isArrayOf_Lretry_HandlerDecision$Adapt as $isArrayOf_Lretry_HandlerDecision$Adapt };
var $d_Lretry_HandlerDecision$Adapt = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lretry_HandlerDecision$Adapt, "retry.HandlerDecision$Adapt", ({
  Lretry_HandlerDecision$Adapt: 1,
  Lretry_HandlerDecision: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lretry_HandlerDecision$Adapt as $d_Lretry_HandlerDecision$Adapt };
/** @constructor */
function $c_Lretry_PolicyDecision$DelayAndRetry(delay) {
  this.Lretry_PolicyDecision$DelayAndRetry__f_delay = null;
  this.Lretry_PolicyDecision$DelayAndRetry__f_delay = delay;
}
export { $c_Lretry_PolicyDecision$DelayAndRetry as $c_Lretry_PolicyDecision$DelayAndRetry };
$c_Lretry_PolicyDecision$DelayAndRetry.prototype = new $h_Lretry_PolicyDecision();
$c_Lretry_PolicyDecision$DelayAndRetry.prototype.constructor = $c_Lretry_PolicyDecision$DelayAndRetry;
/** @constructor */
function $h_Lretry_PolicyDecision$DelayAndRetry() {
}
export { $h_Lretry_PolicyDecision$DelayAndRetry as $h_Lretry_PolicyDecision$DelayAndRetry };
$h_Lretry_PolicyDecision$DelayAndRetry.prototype = $c_Lretry_PolicyDecision$DelayAndRetry.prototype;
$c_Lretry_PolicyDecision$DelayAndRetry.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lretry_PolicyDecision$DelayAndRetry.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lretry_PolicyDecision$DelayAndRetry)) {
    var x = this.Lretry_PolicyDecision$DelayAndRetry__f_delay;
    var x$2 = x$0.Lretry_PolicyDecision$DelayAndRetry__f_delay;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lretry_PolicyDecision$DelayAndRetry.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lretry_PolicyDecision$DelayAndRetry.prototype.productArity__I = (function() {
  return 1;
});
$c_Lretry_PolicyDecision$DelayAndRetry.prototype.productPrefix__T = (function() {
  return "DelayAndRetry";
});
$c_Lretry_PolicyDecision$DelayAndRetry.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lretry_PolicyDecision$DelayAndRetry__f_delay;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lretry_PolicyDecision$DelayAndRetry.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "delay";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lretry_PolicyDecision$DelayAndRetry.prototype.ordinal__I = (function() {
  return 1;
});
function $isArrayOf_Lretry_PolicyDecision$DelayAndRetry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lretry_PolicyDecision$DelayAndRetry)));
}
export { $isArrayOf_Lretry_PolicyDecision$DelayAndRetry as $isArrayOf_Lretry_PolicyDecision$DelayAndRetry };
var $d_Lretry_PolicyDecision$DelayAndRetry = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lretry_PolicyDecision$DelayAndRetry, "retry.PolicyDecision$DelayAndRetry", ({
  Lretry_PolicyDecision$DelayAndRetry: 1,
  Lretry_PolicyDecision: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lretry_PolicyDecision$DelayAndRetry as $d_Lretry_PolicyDecision$DelayAndRetry };
/** @constructor */
function $c_Lretry_RetryDetails$NextStep$DelayAndRetry(nextDelay) {
  this.Lretry_RetryDetails$NextStep$DelayAndRetry__f_nextDelay = null;
  this.Lretry_RetryDetails$NextStep$DelayAndRetry__f_nextDelay = nextDelay;
}
export { $c_Lretry_RetryDetails$NextStep$DelayAndRetry as $c_Lretry_RetryDetails$NextStep$DelayAndRetry };
$c_Lretry_RetryDetails$NextStep$DelayAndRetry.prototype = new $h_Lretry_RetryDetails$NextStep();
$c_Lretry_RetryDetails$NextStep$DelayAndRetry.prototype.constructor = $c_Lretry_RetryDetails$NextStep$DelayAndRetry;
/** @constructor */
function $h_Lretry_RetryDetails$NextStep$DelayAndRetry() {
}
export { $h_Lretry_RetryDetails$NextStep$DelayAndRetry as $h_Lretry_RetryDetails$NextStep$DelayAndRetry };
$h_Lretry_RetryDetails$NextStep$DelayAndRetry.prototype = $c_Lretry_RetryDetails$NextStep$DelayAndRetry.prototype;
$c_Lretry_RetryDetails$NextStep$DelayAndRetry.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lretry_RetryDetails$NextStep$DelayAndRetry.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lretry_RetryDetails$NextStep$DelayAndRetry)) {
    var x = this.Lretry_RetryDetails$NextStep$DelayAndRetry__f_nextDelay;
    var x$2 = x$0.Lretry_RetryDetails$NextStep$DelayAndRetry__f_nextDelay;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lretry_RetryDetails$NextStep$DelayAndRetry.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lretry_RetryDetails$NextStep$DelayAndRetry.prototype.productArity__I = (function() {
  return 1;
});
$c_Lretry_RetryDetails$NextStep$DelayAndRetry.prototype.productPrefix__T = (function() {
  return "DelayAndRetry";
});
$c_Lretry_RetryDetails$NextStep$DelayAndRetry.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lretry_RetryDetails$NextStep$DelayAndRetry__f_nextDelay;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lretry_RetryDetails$NextStep$DelayAndRetry.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "nextDelay";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lretry_RetryDetails$NextStep$DelayAndRetry.prototype.ordinal__I = (function() {
  return 1;
});
function $isArrayOf_Lretry_RetryDetails$NextStep$DelayAndRetry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lretry_RetryDetails$NextStep$DelayAndRetry)));
}
export { $isArrayOf_Lretry_RetryDetails$NextStep$DelayAndRetry as $isArrayOf_Lretry_RetryDetails$NextStep$DelayAndRetry };
var $d_Lretry_RetryDetails$NextStep$DelayAndRetry = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lretry_RetryDetails$NextStep$DelayAndRetry, "retry.RetryDetails$NextStep$DelayAndRetry", ({
  Lretry_RetryDetails$NextStep$DelayAndRetry: 1,
  Lretry_RetryDetails$NextStep: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lretry_RetryDetails$NextStep$DelayAndRetry as $d_Lretry_RetryDetails$NextStep$DelayAndRetry };
/** @constructor */
function $c_sci_LongMap$$anon$2(outer) {
  this.scm_ImmutableBuilder__f_elems = null;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_scm_ImmutableBuilder__sc_IterableOnce__(this, $m_sci_LongMap$Nil$());
}
export { $c_sci_LongMap$$anon$2 as $c_sci_LongMap$$anon$2 };
$c_sci_LongMap$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_scm_ImmutableBuilder();
$c_sci_LongMap$$anon$2.prototype.constructor = $c_sci_LongMap$$anon$2;
/** @constructor */
function $h_sci_LongMap$$anon$2() {
}
export { $h_sci_LongMap$$anon$2 as $h_sci_LongMap$$anon$2 };
$h_sci_LongMap$$anon$2.prototype = $c_sci_LongMap$$anon$2.prototype;
$c_sci_LongMap$$anon$2.prototype.addOne__T2__sci_LongMap$$anon$2 = (function(elem) {
  var this$1 = this.scm_ImmutableBuilder__f_elems;
  this.scm_ImmutableBuilder__f_elems = this$1.updated__J__O__sci_LongMap($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(elem._1__O()), elem._2__O());
  return this;
});
$c_sci_LongMap$$anon$2.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__sci_LongMap$$anon$2(elem);
});
var $d_sci_LongMap$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sci_LongMap$$anon$2, "scala.collection.immutable.LongMap$$anon$2", ({
  sci_LongMap$$anon$2: 1,
  scm_ImmutableBuilder: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
export { $d_sci_LongMap$$anon$2 as $d_sci_LongMap$$anon$2 };
/** @constructor */
function $c_sci_LongMapEntryIterator(it) {
  this.sci_LongMapIterator__f_index = 0;
  this.sci_LongMapIterator__f_buffer = null;
  $ct_sci_LongMapIterator__sci_LongMap__(this, it);
}
export { $c_sci_LongMapEntryIterator as $c_sci_LongMapEntryIterator };
$c_sci_LongMapEntryIterator.prototype = new $h_sci_LongMapIterator();
$c_sci_LongMapEntryIterator.prototype.constructor = $c_sci_LongMapEntryIterator;
/** @constructor */
function $h_sci_LongMapEntryIterator() {
}
export { $h_sci_LongMapEntryIterator as $h_sci_LongMapEntryIterator };
$h_sci_LongMapEntryIterator.prototype = $c_sci_LongMapEntryIterator.prototype;
$c_sci_LongMapEntryIterator.prototype.valueOf__sci_LongMap$Tip__O = (function(tip) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), tip.sci_LongMap$Tip__f_key, tip.sci_LongMap$Tip__f_value);
});
var $d_sci_LongMapEntryIterator = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sci_LongMapEntryIterator, "scala.collection.immutable.LongMapEntryIterator", ({
  sci_LongMapEntryIterator: 1,
  sci_LongMapIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sci_LongMapEntryIterator as $d_sci_LongMapEntryIterator };
/** @constructor */
function $c_sci_LongMapKeyIterator(it) {
  this.sci_LongMapIterator__f_index = 0;
  this.sci_LongMapIterator__f_buffer = null;
  $ct_sci_LongMapIterator__sci_LongMap__(this, it);
}
export { $c_sci_LongMapKeyIterator as $c_sci_LongMapKeyIterator };
$c_sci_LongMapKeyIterator.prototype = new $h_sci_LongMapIterator();
$c_sci_LongMapKeyIterator.prototype.constructor = $c_sci_LongMapKeyIterator;
/** @constructor */
function $h_sci_LongMapKeyIterator() {
}
export { $h_sci_LongMapKeyIterator as $h_sci_LongMapKeyIterator };
$h_sci_LongMapKeyIterator.prototype = $c_sci_LongMapKeyIterator.prototype;
$c_sci_LongMapKeyIterator.prototype.valueOf__sci_LongMap$Tip__O = (function(tip) {
  return tip.sci_LongMap$Tip__f_key;
});
var $d_sci_LongMapKeyIterator = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sci_LongMapKeyIterator, "scala.collection.immutable.LongMapKeyIterator", ({
  sci_LongMapKeyIterator: 1,
  sci_LongMapIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sci_LongMapKeyIterator as $d_sci_LongMapKeyIterator };
/** @constructor */
function $c_sci_LongMapValueIterator(it) {
  this.sci_LongMapIterator__f_index = 0;
  this.sci_LongMapIterator__f_buffer = null;
  $ct_sci_LongMapIterator__sci_LongMap__(this, it);
}
export { $c_sci_LongMapValueIterator as $c_sci_LongMapValueIterator };
$c_sci_LongMapValueIterator.prototype = new $h_sci_LongMapIterator();
$c_sci_LongMapValueIterator.prototype.constructor = $c_sci_LongMapValueIterator;
/** @constructor */
function $h_sci_LongMapValueIterator() {
}
export { $h_sci_LongMapValueIterator as $h_sci_LongMapValueIterator };
$h_sci_LongMapValueIterator.prototype = $c_sci_LongMapValueIterator.prototype;
$c_sci_LongMapValueIterator.prototype.valueOf__sci_LongMap$Tip__O = (function(tip) {
  return tip.sci_LongMap$Tip__f_value;
});
var $d_sci_LongMapValueIterator = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sci_LongMapValueIterator, "scala.collection.immutable.LongMapValueIterator", ({
  sci_LongMapValueIterator: 1,
  sci_LongMapIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sci_LongMapValueIterator as $d_sci_LongMapValueIterator };
/** @constructor */
function $c_sci_RedBlackTree$EntriesIterator(tree, focus, evidence$20) {
  this.sci_RedBlackTree$TreeIterator__f_root = null;
  this.sci_RedBlackTree$TreeIterator__f_ordering = null;
  this.sci_RedBlackTree$TreeIterator__f_stackOfNexts = null;
  this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = 0;
  this.sci_RedBlackTree$TreeIterator__f_lookahead = null;
  $ct_sci_RedBlackTree$TreeIterator__sci_RedBlackTree$Tree__s_Option__s_math_Ordering__(this, tree, focus, evidence$20);
}
export { $c_sci_RedBlackTree$EntriesIterator as $c_sci_RedBlackTree$EntriesIterator };
$c_sci_RedBlackTree$EntriesIterator.prototype = new $h_sci_RedBlackTree$TreeIterator();
$c_sci_RedBlackTree$EntriesIterator.prototype.constructor = $c_sci_RedBlackTree$EntriesIterator;
/** @constructor */
function $h_sci_RedBlackTree$EntriesIterator() {
}
export { $h_sci_RedBlackTree$EntriesIterator as $h_sci_RedBlackTree$EntriesIterator };
$h_sci_RedBlackTree$EntriesIterator.prototype = $c_sci_RedBlackTree$EntriesIterator.prototype;
$c_sci_RedBlackTree$EntriesIterator.prototype.nextResult__sci_RedBlackTree$Tree__O = (function(tree) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value);
});
var $d_sci_RedBlackTree$EntriesIterator = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sci_RedBlackTree$EntriesIterator, "scala.collection.immutable.RedBlackTree$EntriesIterator", ({
  sci_RedBlackTree$EntriesIterator: 1,
  sci_RedBlackTree$TreeIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sci_RedBlackTree$EntriesIterator as $d_sci_RedBlackTree$EntriesIterator };
/** @constructor */
function $c_sci_RedBlackTree$EqualsIterator(tree, evidence$19) {
  this.sci_RedBlackTree$TreeIterator__f_root = null;
  this.sci_RedBlackTree$TreeIterator__f_ordering = null;
  this.sci_RedBlackTree$TreeIterator__f_stackOfNexts = null;
  this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = 0;
  this.sci_RedBlackTree$TreeIterator__f_lookahead = null;
  $ct_sci_RedBlackTree$TreeIterator__sci_RedBlackTree$Tree__s_Option__s_math_Ordering__(this, tree, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$(), evidence$19);
}
export { $c_sci_RedBlackTree$EqualsIterator as $c_sci_RedBlackTree$EqualsIterator };
$c_sci_RedBlackTree$EqualsIterator.prototype = new $h_sci_RedBlackTree$TreeIterator();
$c_sci_RedBlackTree$EqualsIterator.prototype.constructor = $c_sci_RedBlackTree$EqualsIterator;
/** @constructor */
function $h_sci_RedBlackTree$EqualsIterator() {
}
export { $h_sci_RedBlackTree$EqualsIterator as $h_sci_RedBlackTree$EqualsIterator };
$h_sci_RedBlackTree$EqualsIterator.prototype = $c_sci_RedBlackTree$EqualsIterator.prototype;
$c_sci_RedBlackTree$EqualsIterator.prototype.sameKeys__sci_RedBlackTree$EqualsIterator__Z = (function(that) {
  var equal = true;
  while (((equal && (this.sci_RedBlackTree$TreeIterator__f_lookahead !== null)) && (that.sci_RedBlackTree$TreeIterator__f_lookahead !== null))) {
    if ((this.sci_RedBlackTree$TreeIterator__f_lookahead === that.sci_RedBlackTree$TreeIterator__f_lookahead)) {
      if ((this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index === 0)) {
        var $x_1 = null;
      } else {
        this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = (((-1) + this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index) | 0);
        var $x_1 = this.sci_RedBlackTree$TreeIterator__f_stackOfNexts.u[this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index];
      }
      this.sci_RedBlackTree$TreeIterator__f_lookahead = $x_1;
      if ((that.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index === 0)) {
        var $x_2 = null;
      } else {
        that.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = (((-1) + that.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index) | 0);
        var $x_2 = that.sci_RedBlackTree$TreeIterator__f_stackOfNexts.u[that.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index];
      }
      that.sci_RedBlackTree$TreeIterator__f_lookahead = $x_2;
    } else {
      var this$1 = this.sci_RedBlackTree$TreeIterator__f_lookahead;
      var $x_3 = this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
      var this$2 = that.sci_RedBlackTree$TreeIterator__f_lookahead;
      if (Object.is($x_3, this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key)) {
        equal = true;
      } else {
        var $x_5 = this.sci_RedBlackTree$TreeIterator__f_ordering;
        var this$3 = this.sci_RedBlackTree$TreeIterator__f_lookahead;
        var $x_4 = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
        var this$4 = that.sci_RedBlackTree$TreeIterator__f_lookahead;
        equal = $x_5.equiv__O__O__Z($x_4, this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
      }
      var tree = this.sci_RedBlackTree$TreeIterator__f_lookahead;
      this.sci_RedBlackTree$TreeIterator__f_lookahead = this.findLeftMostOrPopOnEmpty__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
      var tree$1 = that.sci_RedBlackTree$TreeIterator__f_lookahead;
      that.sci_RedBlackTree$TreeIterator__f_lookahead = that.findLeftMostOrPopOnEmpty__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tree$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
    }
  }
  return ((equal && (this.sci_RedBlackTree$TreeIterator__f_lookahead === null)) && (that.sci_RedBlackTree$TreeIterator__f_lookahead === null));
});
$c_sci_RedBlackTree$EqualsIterator.prototype.sameEntries__sci_RedBlackTree$EqualsIterator__Z = (function(that) {
  var equal = true;
  while (((equal && (this.sci_RedBlackTree$TreeIterator__f_lookahead !== null)) && (that.sci_RedBlackTree$TreeIterator__f_lookahead !== null))) {
    if ((this.sci_RedBlackTree$TreeIterator__f_lookahead === that.sci_RedBlackTree$TreeIterator__f_lookahead)) {
      if ((this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index === 0)) {
        var $x_1 = null;
      } else {
        this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = (((-1) + this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index) | 0);
        var $x_1 = this.sci_RedBlackTree$TreeIterator__f_stackOfNexts.u[this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index];
      }
      this.sci_RedBlackTree$TreeIterator__f_lookahead = $x_1;
      if ((that.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index === 0)) {
        var $x_2 = null;
      } else {
        that.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = (((-1) + that.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index) | 0);
        var $x_2 = that.sci_RedBlackTree$TreeIterator__f_stackOfNexts.u[that.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index];
      }
      that.sci_RedBlackTree$TreeIterator__f_lookahead = $x_2;
    } else {
      var this$1 = this.sci_RedBlackTree$TreeIterator__f_lookahead;
      var $x_4 = this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
      var this$2 = that.sci_RedBlackTree$TreeIterator__f_lookahead;
      if (Object.is($x_4, this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key)) {
        var $x_3 = true;
      } else {
        var $x_6 = this.sci_RedBlackTree$TreeIterator__f_ordering;
        var this$3 = this.sci_RedBlackTree$TreeIterator__f_lookahead;
        var $x_5 = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
        var this$4 = that.sci_RedBlackTree$TreeIterator__f_lookahead;
        var $x_3 = $x_6.equiv__O__O__Z($x_5, this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
      }
      if ($x_3) {
        var $x_8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$();
        var this$5 = this.sci_RedBlackTree$TreeIterator__f_lookahead;
        var $x_7 = this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value;
        var this$6 = that.sci_RedBlackTree$TreeIterator__f_lookahead;
        equal = $x_8.equals__O__O__Z($x_7, this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value);
      } else {
        equal = false;
      }
      var tree = this.sci_RedBlackTree$TreeIterator__f_lookahead;
      this.sci_RedBlackTree$TreeIterator__f_lookahead = this.findLeftMostOrPopOnEmpty__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
      var tree$1 = that.sci_RedBlackTree$TreeIterator__f_lookahead;
      that.sci_RedBlackTree$TreeIterator__f_lookahead = that.findLeftMostOrPopOnEmpty__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tree$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
    }
  }
  return ((equal && (this.sci_RedBlackTree$TreeIterator__f_lookahead === null)) && (that.sci_RedBlackTree$TreeIterator__f_lookahead === null));
});
$c_sci_RedBlackTree$EqualsIterator.prototype.nextResult__sci_RedBlackTree$Tree__O = (function(tree) {
  throw new $c_s_NotImplementedError();
});
var $d_sci_RedBlackTree$EqualsIterator = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sci_RedBlackTree$EqualsIterator, "scala.collection.immutable.RedBlackTree$EqualsIterator", ({
  sci_RedBlackTree$EqualsIterator: 1,
  sci_RedBlackTree$TreeIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sci_RedBlackTree$EqualsIterator as $d_sci_RedBlackTree$EqualsIterator };
/** @constructor */
function $c_sci_RedBlackTree$KeysIterator(tree, focus, evidence$21) {
  this.sci_RedBlackTree$TreeIterator__f_root = null;
  this.sci_RedBlackTree$TreeIterator__f_ordering = null;
  this.sci_RedBlackTree$TreeIterator__f_stackOfNexts = null;
  this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = 0;
  this.sci_RedBlackTree$TreeIterator__f_lookahead = null;
  $ct_sci_RedBlackTree$TreeIterator__sci_RedBlackTree$Tree__s_Option__s_math_Ordering__(this, tree, focus, evidence$21);
}
export { $c_sci_RedBlackTree$KeysIterator as $c_sci_RedBlackTree$KeysIterator };
$c_sci_RedBlackTree$KeysIterator.prototype = new $h_sci_RedBlackTree$TreeIterator();
$c_sci_RedBlackTree$KeysIterator.prototype.constructor = $c_sci_RedBlackTree$KeysIterator;
/** @constructor */
function $h_sci_RedBlackTree$KeysIterator() {
}
export { $h_sci_RedBlackTree$KeysIterator as $h_sci_RedBlackTree$KeysIterator };
$h_sci_RedBlackTree$KeysIterator.prototype = $c_sci_RedBlackTree$KeysIterator.prototype;
$c_sci_RedBlackTree$KeysIterator.prototype.nextResult__sci_RedBlackTree$Tree__O = (function(tree) {
  return tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
});
var $d_sci_RedBlackTree$KeysIterator = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sci_RedBlackTree$KeysIterator, "scala.collection.immutable.RedBlackTree$KeysIterator", ({
  sci_RedBlackTree$KeysIterator: 1,
  sci_RedBlackTree$TreeIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sci_RedBlackTree$KeysIterator as $d_sci_RedBlackTree$KeysIterator };
/** @constructor */
function $c_sci_SortedSet$() {
  this.sc_EvidenceIterableFactory$Delegate__f_delegate = null;
  var delegate = $m_sci_TreeSet$();
  $ct_sc_EvidenceIterableFactory$Delegate__sc_EvidenceIterableFactory__(this, delegate);
}
export { $c_sci_SortedSet$ as $c_sci_SortedSet$ };
$c_sci_SortedSet$.prototype = new $h_sc_SortedIterableFactory$Delegate();
$c_sci_SortedSet$.prototype.constructor = $c_sci_SortedSet$;
/** @constructor */
function $h_sci_SortedSet$() {
}
export { $h_sci_SortedSet$ as $h_sci_SortedSet$ };
$h_sci_SortedSet$.prototype = $c_sci_SortedSet$.prototype;
$c_sci_SortedSet$.prototype.from__sc_IterableOnce__s_math_Ordering__sci_SortedSet = (function(it, evidence$1) {
  if ($is_sci_SortedSet(it)) {
    var x$2 = it.ordering__s_math_Ordering();
    if (((evidence$1 === null) ? (x$2 === null) : evidence$1.equals__O__Z(x$2))) {
      return it;
    }
  }
  return $c_sc_EvidenceIterableFactory$Delegate.prototype.from__sc_IterableOnce__O__O.call(this, it, evidence$1);
});
$c_sci_SortedSet$.prototype.from__sc_IterableOnce__O__O = (function(it, evidence$20) {
  return this.from__sc_IterableOnce__s_math_Ordering__sci_SortedSet(it, evidence$20);
});
var $d_sci_SortedSet$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sci_SortedSet$, "scala.collection.immutable.SortedSet$", ({
  sci_SortedSet$: 1,
  sc_SortedIterableFactory$Delegate: 1,
  sc_EvidenceIterableFactory$Delegate: 1,
  sc_EvidenceIterableFactory: 1,
  Ljava_io_Serializable: 1,
  sc_SortedIterableFactory: 1
}));
export { $d_sci_SortedSet$ as $d_sci_SortedSet$ };
var $n_sci_SortedSet$;
function $m_sci_SortedSet$() {
  if ((!$n_sci_SortedSet$)) {
    $n_sci_SortedSet$ = new $c_sci_SortedSet$();
  }
  return $n_sci_SortedSet$;
}
export { $m_sci_SortedSet$ as $m_sci_SortedSet$ };
function $f_s_math_Numeric__sign__O__O($thiz, x) {
  return ($thiz.lt__O__O__Z(x, $thiz.fromInt__I__O(0)) ? $thiz.negate__O__O($thiz.fromInt__I__O(1)) : ($thiz.gt__O__O__Z(x, $thiz.fromInt__I__O(0)) ? $thiz.fromInt__I__O(1) : $thiz.fromInt__I__O(0)));
}
export { $f_s_math_Numeric__sign__O__O as $f_s_math_Numeric__sign__O__O };
/** @constructor */
function $c_Lsttp_client3_ByteArrayBody(b, defaultContentType) {
  this.Lsttp_client3_ByteArrayBody__f_b = null;
  this.Lsttp_client3_ByteArrayBody__f_defaultContentType = null;
  this.Lsttp_client3_ByteArrayBody__f_b = b;
  this.Lsttp_client3_ByteArrayBody__f_defaultContentType = defaultContentType;
}
export { $c_Lsttp_client3_ByteArrayBody as $c_Lsttp_client3_ByteArrayBody };
$c_Lsttp_client3_ByteArrayBody.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_ByteArrayBody.prototype.constructor = $c_Lsttp_client3_ByteArrayBody;
/** @constructor */
function $h_Lsttp_client3_ByteArrayBody() {
}
export { $h_Lsttp_client3_ByteArrayBody as $h_Lsttp_client3_ByteArrayBody };
$h_Lsttp_client3_ByteArrayBody.prototype = $c_Lsttp_client3_ByteArrayBody.prototype;
$c_Lsttp_client3_ByteArrayBody.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_client3_ByteArrayBody.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lsttp_client3_ByteArrayBody.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_client3_ByteArrayBody)) {
    var x = this.Lsttp_client3_ByteArrayBody__f_b;
    var x$2 = x$0.Lsttp_client3_ByteArrayBody__f_b;
    if ((x === x$2)) {
      var x$3 = this.Lsttp_client3_ByteArrayBody__f_defaultContentType;
      var x$4 = x$0.Lsttp_client3_ByteArrayBody__f_defaultContentType;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_client3_ByteArrayBody.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_client3_ByteArrayBody.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsttp_client3_ByteArrayBody.prototype.productPrefix__T = (function() {
  return "ByteArrayBody";
});
$c_Lsttp_client3_ByteArrayBody.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_client3_ByteArrayBody__f_b;
  }
  if ((n === 1)) {
    return this.Lsttp_client3_ByteArrayBody__f_defaultContentType;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_client3_ByteArrayBody.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "b";
  }
  if ((n === 1)) {
    return "defaultContentType";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_client3_ByteArrayBody.prototype.defaultContentType__Lsttp_model_MediaType = (function() {
  return this.Lsttp_client3_ByteArrayBody__f_defaultContentType;
});
function $isArrayOf_Lsttp_client3_ByteArrayBody(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_client3_ByteArrayBody)));
}
export { $isArrayOf_Lsttp_client3_ByteArrayBody as $isArrayOf_Lsttp_client3_ByteArrayBody };
var $d_Lsttp_client3_ByteArrayBody = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_ByteArrayBody, "sttp.client3.ByteArrayBody", ({
  Lsttp_client3_ByteArrayBody: 1,
  Lsttp_client3_RequestBody: 1,
  Lsttp_client3_BasicRequestBody: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_client3_ByteArrayBody as $d_Lsttp_client3_ByteArrayBody };
/** @constructor */
function $c_Lsttp_client3_ByteBufferBody(b, defaultContentType) {
  this.Lsttp_client3_ByteBufferBody__f_b = null;
  this.Lsttp_client3_ByteBufferBody__f_defaultContentType = null;
  this.Lsttp_client3_ByteBufferBody__f_b = b;
  this.Lsttp_client3_ByteBufferBody__f_defaultContentType = defaultContentType;
}
export { $c_Lsttp_client3_ByteBufferBody as $c_Lsttp_client3_ByteBufferBody };
$c_Lsttp_client3_ByteBufferBody.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_ByteBufferBody.prototype.constructor = $c_Lsttp_client3_ByteBufferBody;
/** @constructor */
function $h_Lsttp_client3_ByteBufferBody() {
}
export { $h_Lsttp_client3_ByteBufferBody as $h_Lsttp_client3_ByteBufferBody };
$h_Lsttp_client3_ByteBufferBody.prototype = $c_Lsttp_client3_ByteBufferBody.prototype;
$c_Lsttp_client3_ByteBufferBody.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_client3_ByteBufferBody.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lsttp_client3_ByteBufferBody.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_client3_ByteBufferBody)) {
    var x = this.Lsttp_client3_ByteBufferBody__f_b;
    var x$2 = x$0.Lsttp_client3_ByteBufferBody__f_b;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lsttp_client3_ByteBufferBody__f_defaultContentType;
      var x$4 = x$0.Lsttp_client3_ByteBufferBody__f_defaultContentType;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_client3_ByteBufferBody.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_client3_ByteBufferBody.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsttp_client3_ByteBufferBody.prototype.productPrefix__T = (function() {
  return "ByteBufferBody";
});
$c_Lsttp_client3_ByteBufferBody.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_client3_ByteBufferBody__f_b;
  }
  if ((n === 1)) {
    return this.Lsttp_client3_ByteBufferBody__f_defaultContentType;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_client3_ByteBufferBody.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "b";
  }
  if ((n === 1)) {
    return "defaultContentType";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_client3_ByteBufferBody.prototype.defaultContentType__Lsttp_model_MediaType = (function() {
  return this.Lsttp_client3_ByteBufferBody__f_defaultContentType;
});
function $isArrayOf_Lsttp_client3_ByteBufferBody(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_client3_ByteBufferBody)));
}
export { $isArrayOf_Lsttp_client3_ByteBufferBody as $isArrayOf_Lsttp_client3_ByteBufferBody };
var $d_Lsttp_client3_ByteBufferBody = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_ByteBufferBody, "sttp.client3.ByteBufferBody", ({
  Lsttp_client3_ByteBufferBody: 1,
  Lsttp_client3_RequestBody: 1,
  Lsttp_client3_BasicRequestBody: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_client3_ByteBufferBody as $d_Lsttp_client3_ByteBufferBody };
/** @constructor */
function $c_Lsttp_client3_FileBody(f, defaultContentType) {
  this.Lsttp_client3_FileBody__f_f = null;
  this.Lsttp_client3_FileBody__f_defaultContentType = null;
  this.Lsttp_client3_FileBody__f_f = f;
  this.Lsttp_client3_FileBody__f_defaultContentType = defaultContentType;
}
export { $c_Lsttp_client3_FileBody as $c_Lsttp_client3_FileBody };
$c_Lsttp_client3_FileBody.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_FileBody.prototype.constructor = $c_Lsttp_client3_FileBody;
/** @constructor */
function $h_Lsttp_client3_FileBody() {
}
export { $h_Lsttp_client3_FileBody as $h_Lsttp_client3_FileBody };
$h_Lsttp_client3_FileBody.prototype = $c_Lsttp_client3_FileBody.prototype;
$c_Lsttp_client3_FileBody.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_client3_FileBody.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lsttp_client3_FileBody.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_client3_FileBody)) {
    var x = this.Lsttp_client3_FileBody__f_f;
    var x$2 = x$0.Lsttp_client3_FileBody__f_f;
    if ((x === x$2)) {
      var x$3 = this.Lsttp_client3_FileBody__f_defaultContentType;
      var x$4 = x$0.Lsttp_client3_FileBody__f_defaultContentType;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_client3_FileBody.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_client3_FileBody.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsttp_client3_FileBody.prototype.productPrefix__T = (function() {
  return "FileBody";
});
$c_Lsttp_client3_FileBody.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_client3_FileBody__f_f;
  }
  if ((n === 1)) {
    return this.Lsttp_client3_FileBody__f_defaultContentType;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_client3_FileBody.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "f";
  }
  if ((n === 1)) {
    return "defaultContentType";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_client3_FileBody.prototype.defaultContentType__Lsttp_model_MediaType = (function() {
  return this.Lsttp_client3_FileBody__f_defaultContentType;
});
function $isArrayOf_Lsttp_client3_FileBody(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_client3_FileBody)));
}
export { $isArrayOf_Lsttp_client3_FileBody as $isArrayOf_Lsttp_client3_FileBody };
var $d_Lsttp_client3_FileBody = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_FileBody, "sttp.client3.FileBody", ({
  Lsttp_client3_FileBody: 1,
  Lsttp_client3_RequestBody: 1,
  Lsttp_client3_BasicRequestBody: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_client3_FileBody as $d_Lsttp_client3_FileBody };
/** @constructor */
function $c_Lsttp_client3_InputStreamBody(b, defaultContentType) {
  this.Lsttp_client3_InputStreamBody__f_b = null;
  this.Lsttp_client3_InputStreamBody__f_defaultContentType = null;
  this.Lsttp_client3_InputStreamBody__f_b = b;
  this.Lsttp_client3_InputStreamBody__f_defaultContentType = defaultContentType;
}
export { $c_Lsttp_client3_InputStreamBody as $c_Lsttp_client3_InputStreamBody };
$c_Lsttp_client3_InputStreamBody.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_InputStreamBody.prototype.constructor = $c_Lsttp_client3_InputStreamBody;
/** @constructor */
function $h_Lsttp_client3_InputStreamBody() {
}
export { $h_Lsttp_client3_InputStreamBody as $h_Lsttp_client3_InputStreamBody };
$h_Lsttp_client3_InputStreamBody.prototype = $c_Lsttp_client3_InputStreamBody.prototype;
$c_Lsttp_client3_InputStreamBody.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_client3_InputStreamBody.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lsttp_client3_InputStreamBody.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_client3_InputStreamBody)) {
    var x = this.Lsttp_client3_InputStreamBody__f_b;
    var x$2 = x$0.Lsttp_client3_InputStreamBody__f_b;
    if ((x === x$2)) {
      var x$3 = this.Lsttp_client3_InputStreamBody__f_defaultContentType;
      var x$4 = x$0.Lsttp_client3_InputStreamBody__f_defaultContentType;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_client3_InputStreamBody.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_client3_InputStreamBody.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsttp_client3_InputStreamBody.prototype.productPrefix__T = (function() {
  return "InputStreamBody";
});
$c_Lsttp_client3_InputStreamBody.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_client3_InputStreamBody__f_b;
  }
  if ((n === 1)) {
    return this.Lsttp_client3_InputStreamBody__f_defaultContentType;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_client3_InputStreamBody.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "b";
  }
  if ((n === 1)) {
    return "defaultContentType";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_client3_InputStreamBody.prototype.defaultContentType__Lsttp_model_MediaType = (function() {
  return this.Lsttp_client3_InputStreamBody__f_defaultContentType;
});
function $isArrayOf_Lsttp_client3_InputStreamBody(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_client3_InputStreamBody)));
}
export { $isArrayOf_Lsttp_client3_InputStreamBody as $isArrayOf_Lsttp_client3_InputStreamBody };
var $d_Lsttp_client3_InputStreamBody = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_InputStreamBody, "sttp.client3.InputStreamBody", ({
  Lsttp_client3_InputStreamBody: 1,
  Lsttp_client3_RequestBody: 1,
  Lsttp_client3_BasicRequestBody: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_client3_InputStreamBody as $d_Lsttp_client3_InputStreamBody };
function $p_Lsttp_client3_RequestT__hasContentType__Z($thiz) {
  return $thiz.Lsttp_client3_RequestT__f_headers.exists__F1__Z(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$10) => {
    var otherName = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_ContentType;
    var this$1 = _$10.Lsttp_model_Header__f_name;
    var len = this$1.length;
    if ((!((otherName === null) || (otherName.length !== len)))) {
      var i = 0;
      while ((i !== len)) {
        var index = i;
        var c = this$1.charCodeAt(index);
        var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toLowerCase__C__C($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toUpperCase__C__C(c));
        var index$1 = i;
        var c$1 = otherName.charCodeAt(index$1);
        if (($x_1 !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toLowerCase__C__C($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toUpperCase__C__C(c$1)))) {
          return false;
        }
        i = ((1 + i) | 0);
      }
      return true;
    } else {
      return false;
    }
  })));
}
export { $p_Lsttp_client3_RequestT__hasContentType__Z as $p_Lsttp_client3_RequestT__hasContentType__Z };
function $p_Lsttp_client3_RequestT__setContentTypeIfMissing__Lsttp_model_MediaType__Lsttp_client3_RequestT($thiz, mt) {
  return ($p_Lsttp_client3_RequestT__hasContentType__Z($thiz) ? $thiz : $thiz.header__T__T__Z__Lsttp_client3_RequestT($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_ContentType, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$p_Lsttp_model_MediaType__toStringCache__T(mt), true));
}
export { $p_Lsttp_client3_RequestT__setContentTypeIfMissing__Lsttp_model_MediaType__Lsttp_client3_RequestT as $p_Lsttp_client3_RequestT__setContentTypeIfMissing__Lsttp_model_MediaType__Lsttp_client3_RequestT };
function $p_Lsttp_client3_RequestT__hasContentLength__Z($thiz) {
  return $thiz.Lsttp_client3_RequestT__f_headers.exists__F1__Z(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$11) => {
    var otherName = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_ContentLength;
    var this$1 = _$11.Lsttp_model_Header__f_name;
    var len = this$1.length;
    if ((!((otherName === null) || (otherName.length !== len)))) {
      var i = 0;
      while ((i !== len)) {
        var index = i;
        var c = this$1.charCodeAt(index);
        var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toLowerCase__C__C($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toUpperCase__C__C(c));
        var index$1 = i;
        var c$1 = otherName.charCodeAt(index$1);
        if (($x_1 !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toLowerCase__C__C($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toUpperCase__C__C(c$1)))) {
          return false;
        }
        i = ((1 + i) | 0);
      }
      return true;
    } else {
      return false;
    }
  })));
}
export { $p_Lsttp_client3_RequestT__hasContentLength__Z as $p_Lsttp_client3_RequestT__hasContentLength__Z };
/** @constructor */
function $c_Lsttp_client3_RequestT(method, uri, body, headers, response, options, tags) {
  this.Lsttp_client3_RequestT__f_method = null;
  this.Lsttp_client3_RequestT__f_uri = null;
  this.Lsttp_client3_RequestT__f_body = null;
  this.Lsttp_client3_RequestT__f_headers = null;
  this.Lsttp_client3_RequestT__f_response = null;
  this.Lsttp_client3_RequestT__f_options = null;
  this.Lsttp_client3_RequestT__f_tags = null;
  this.Lsttp_client3_RequestT__f_method = method;
  this.Lsttp_client3_RequestT__f_uri = uri;
  this.Lsttp_client3_RequestT__f_body = body;
  this.Lsttp_client3_RequestT__f_headers = headers;
  this.Lsttp_client3_RequestT__f_response = response;
  this.Lsttp_client3_RequestT__f_options = options;
  this.Lsttp_client3_RequestT__f_tags = tags;
}
export { $c_Lsttp_client3_RequestT as $c_Lsttp_client3_RequestT };
$c_Lsttp_client3_RequestT.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_RequestT.prototype.constructor = $c_Lsttp_client3_RequestT;
/** @constructor */
function $h_Lsttp_client3_RequestT() {
}
export { $h_Lsttp_client3_RequestT as $h_Lsttp_client3_RequestT };
$h_Lsttp_client3_RequestT.prototype = $c_Lsttp_client3_RequestT.prototype;
$c_Lsttp_client3_RequestT.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_client3_RequestT.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lsttp_client3_RequestT.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_client3_RequestT)) {
    var x = this.Lsttp_client3_RequestT__f_method;
    var y = x$0.Lsttp_client3_RequestT__f_method;
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Lsttp_client3_RequestT__f_uri;
      var y$1 = x$0.Lsttp_client3_RequestT__f_uri;
      var $x_5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y$1);
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$2 = this.Lsttp_client3_RequestT__f_body;
      var x$2$1 = x$0.Lsttp_client3_RequestT__f_body;
      var $x_4 = ((x$2 === null) ? (x$2$1 === null) : x$2.equals__O__Z(x$2$1));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$3 = this.Lsttp_client3_RequestT__f_headers;
      var x$4 = x$0.Lsttp_client3_RequestT__f_headers;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.Lsttp_client3_RequestT__f_response;
      var x$6 = x$0.Lsttp_client3_RequestT__f_response;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.Lsttp_client3_RequestT__f_options;
      var x$8 = x$0.Lsttp_client3_RequestT__f_options;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : x$7.equals__O__Z(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$9 = this.Lsttp_client3_RequestT__f_tags;
      var x$10 = x$0.Lsttp_client3_RequestT__f_tags;
      return ((x$9 === null) ? (x$10 === null) : x$9.equals__O__Z(x$10));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_client3_RequestT.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_client3_RequestT.prototype.productArity__I = (function() {
  return 7;
});
$c_Lsttp_client3_RequestT.prototype.productPrefix__T = (function() {
  return "RequestT";
});
$c_Lsttp_client3_RequestT.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsttp_client3_RequestT__f_method;
      break;
    }
    case 1: {
      return this.Lsttp_client3_RequestT__f_uri;
      break;
    }
    case 2: {
      return this.Lsttp_client3_RequestT__f_body;
      break;
    }
    case 3: {
      return this.Lsttp_client3_RequestT__f_headers;
      break;
    }
    case 4: {
      return this.Lsttp_client3_RequestT__f_response;
      break;
    }
    case 5: {
      return this.Lsttp_client3_RequestT__f_options;
      break;
    }
    case 6: {
      return this.Lsttp_client3_RequestT__f_tags;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_client3_RequestT.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "method";
      break;
    }
    case 1: {
      return "uri";
      break;
    }
    case 2: {
      return "body";
      break;
    }
    case 3: {
      return "headers";
      break;
    }
    case 4: {
      return "response";
      break;
    }
    case 5: {
      return "options";
      break;
    }
    case 6: {
      return "tags";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_client3_RequestT.prototype.headers__sci_Seq = (function() {
  return this.Lsttp_client3_RequestT__f_headers;
});
$c_Lsttp_client3_RequestT.prototype.header__Lsttp_model_Header__Z__Lsttp_client3_RequestT = (function(h, replaceExisting) {
  var current = (replaceExisting ? this.Lsttp_client3_RequestT__f_headers.filterNot__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => {
    var otherName = h.Lsttp_model_Header__f_name;
    var this$1 = _$2.Lsttp_model_Header__f_name;
    var len = this$1.length;
    if ((!((otherName === null) || (otherName.length !== len)))) {
      var i = 0;
      while ((i !== len)) {
        var index = i;
        var c = this$1.charCodeAt(index);
        var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toLowerCase__C__C($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toUpperCase__C__C(c));
        var index$1 = i;
        var c$1 = otherName.charCodeAt(index$1);
        if (($x_1 !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toLowerCase__C__C($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toUpperCase__C__C(c$1)))) {
          return false;
        }
        i = ((1 + i) | 0);
      }
      return true;
    } else {
      return false;
    }
  }))) : this.Lsttp_client3_RequestT__f_headers);
  var headers$8 = current.appended__O__O(h);
  var method$8 = this.Lsttp_client3_RequestT__f_method;
  var uri$1 = this.Lsttp_client3_RequestT__f_uri;
  var body$8 = this.Lsttp_client3_RequestT__f_body;
  var response$8 = this.Lsttp_client3_RequestT__f_response;
  var options$8 = this.Lsttp_client3_RequestT__f_options;
  var tags$8 = this.Lsttp_client3_RequestT__f_tags;
  return new $c_Lsttp_client3_RequestT(method$8, uri$1, body$8, headers$8, response$8, options$8, tags$8);
});
$c_Lsttp_client3_RequestT.prototype.header__T__T__Z__Lsttp_client3_RequestT = (function(k, v, replaceExisting) {
  return this.header__Lsttp_model_Header__Z__Lsttp_client3_RequestT(($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_Header$(), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_model_Header(k, v)), replaceExisting);
});
$c_Lsttp_client3_RequestT.prototype.header__T__T__Lsttp_client3_RequestT = (function(k, v) {
  return this.header__Lsttp_model_Header__Z__Lsttp_client3_RequestT(($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_Header$(), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_model_Header(k, v)), false);
});
$c_Lsttp_client3_RequestT.prototype.cookie__T__T__Lsttp_client3_RequestT = (function(n, v) {
  return this.cookies__sci_Seq__Lsttp_client3_RequestT($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T2.getArrayOf().constr)([$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), n, v)])));
});
$c_Lsttp_client3_RequestT.prototype.cookies__sci_Seq__Lsttp_client3_RequestT = (function(nvs) {
  var $x_4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_Cookie;
  var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Option$();
  var this$2 = this.Lsttp_client3_RequestT__f_headers.find__F1__s_Option(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$4) => {
    var otherName = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_Cookie;
    var this$1 = _$4.Lsttp_model_Header__f_name;
    var len = this$1.length;
    if ((!((otherName === null) || (otherName.length !== len)))) {
      var i = 0;
      while ((i !== len)) {
        var index = i;
        var c = this$1.charCodeAt(index);
        var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toLowerCase__C__C($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toUpperCase__C__C(c));
        var index$1 = i;
        var c$1 = otherName.charCodeAt(index$1);
        if (($x_1 !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toLowerCase__C__C($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Character$().toUpperCase__C__C(c$1)))) {
          return false;
        }
        i = ((1 + i) | 0);
      }
      return true;
    } else {
      return false;
    }
  })));
  if (this$2.isEmpty__Z()) {
    var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0 = this$2.get__O();
    var $x_2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(x0.Lsttp_model_Header__f_value);
  }
  var this$3 = $x_3.option2Iterable__s_Option__sc_Iterable($x_2).toSeq__sci_Seq();
  var suffix = nvs.map__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((p) => ((p._1__O() + "=") + p._2__O()))));
  var this$4 = this$3.appendedAll__sc_IterableOnce__O(suffix);
  return this.header__T__T__Z__Lsttp_client3_RequestT($x_4, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__mkString__T__T__T__T(this$4, "", "; ", ""), true);
});
$c_Lsttp_client3_RequestT.prototype.body__T__T__Lsttp_client3_RequestT = (function(b, encoding) {
  var defaultContentType = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_MediaType$().Lsttp_model_MediaType$__f_TextPlain;
  var this$3 = this.withBody__Lsttp_client3_RequestBody__Lsttp_client3_RequestT(new $c_Lsttp_client3_StringBody(b, encoding, defaultContentType));
  if ($p_Lsttp_client3_RequestT__hasContentLength__Z(this$3)) {
    return this$3;
  } else {
    var value = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__getBytes__T__AB(b, encoding).u.length;
    var hi = (value >> 31);
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_ContentLength;
    var this$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_RTLong$();
    return this$3.header__T__T__Z__Lsttp_client3_RequestT($x_1, this$5.org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(value, hi), true);
  }
});
$c_Lsttp_client3_RequestT.prototype.body__AB__Lsttp_client3_RequestT = (function(b) {
  var defaultContentType = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_MediaType$().Lsttp_model_MediaType$__f_ApplicationOctetStream;
  var this$3 = this.withBody__Lsttp_client3_RequestBody__Lsttp_client3_RequestT(new $c_Lsttp_client3_ByteArrayBody(b, defaultContentType));
  if ($p_Lsttp_client3_RequestT__hasContentLength__Z(this$3)) {
    return this$3;
  } else {
    var value = b.u.length;
    var hi = (value >> 31);
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_ContentLength;
    var this$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_RTLong$();
    return this$3.header__T__T__Z__Lsttp_client3_RequestT($x_1, this$5.org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(value, hi), true);
  }
});
$c_Lsttp_client3_RequestT.prototype.body__Ljava_nio_ByteBuffer__Lsttp_client3_RequestT = (function(b) {
  var defaultContentType = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_MediaType$().Lsttp_model_MediaType$__f_ApplicationOctetStream;
  return this.withBody__Lsttp_client3_RequestBody__Lsttp_client3_RequestT(new $c_Lsttp_client3_ByteBufferBody(b, defaultContentType));
});
$c_Lsttp_client3_RequestT.prototype.body__Ljava_io_InputStream__Lsttp_client3_RequestT = (function(b) {
  var defaultContentType = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_MediaType$().Lsttp_model_MediaType$__f_ApplicationOctetStream;
  return this.withBody__Lsttp_client3_RequestBody__Lsttp_client3_RequestT(new $c_Lsttp_client3_InputStreamBody(b, defaultContentType));
});
$c_Lsttp_client3_RequestT.prototype.body__Lsttp_client3_internal_SttpFile__Lsttp_client3_RequestT = (function(f) {
  var defaultContentType = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_MediaType$().Lsttp_model_MediaType$__f_ApplicationOctetStream;
  var this$3 = this.withBody__Lsttp_client3_RequestBody__Lsttp_client3_RequestT(new $c_Lsttp_client3_FileBody(f, defaultContentType));
  if ($p_Lsttp_client3_RequestT__hasContentLength__Z(this$3)) {
    return this$3;
  } else {
    var t = f.Lsttp_client3_internal_SttpFileCompanionExtensions$$anon$1__f_size;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_ContentLength;
    var this$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_RTLong$();
    return this$3.header__T__T__Z__Lsttp_client3_RequestT($x_1, this$4.org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(lo, hi), true);
  }
});
$c_Lsttp_client3_RequestT.prototype.multipartBody__sci_Seq__Lsttp_client3_RequestT = (function(ps) {
  var body$10 = new $c_Lsttp_client3_MultipartBody(ps);
  var method$10 = this.Lsttp_client3_RequestT__f_method;
  var uri$3 = this.Lsttp_client3_RequestT__f_uri;
  var headers$10 = this.Lsttp_client3_RequestT__f_headers;
  var response$10 = this.Lsttp_client3_RequestT__f_response;
  var options$10 = this.Lsttp_client3_RequestT__f_options;
  var tags$10 = this.Lsttp_client3_RequestT__f_tags;
  return new $c_Lsttp_client3_RequestT(method$10, uri$3, body$10, headers$10, response$10, options$10, tags$10);
});
$c_Lsttp_client3_RequestT.prototype.streamBody__Lsttp_capabilities_package$Streams__O__Lsttp_client3_RequestT = (function(s, b) {
  return this.withBody__Lsttp_client3_RequestBody__Lsttp_client3_RequestT(new $c_Lsttp_client3_StreamBody(b));
});
$c_Lsttp_client3_RequestT.prototype.mapResponse__F1__Lsttp_client3_RequestT = (function(f) {
  var response$13 = $f_Lsttp_client3_ResponseAs__map__F1__Lsttp_client3_ResponseAs(this.Lsttp_client3_RequestT__f_response, f);
  var method$13 = this.Lsttp_client3_RequestT__f_method;
  var uri$6 = this.Lsttp_client3_RequestT__f_uri;
  var body$13 = this.Lsttp_client3_RequestT__f_body;
  var headers$13 = this.Lsttp_client3_RequestT__f_headers;
  var options$13 = this.Lsttp_client3_RequestT__f_options;
  var tags$13 = this.Lsttp_client3_RequestT__f_tags;
  return new $c_Lsttp_client3_RequestT(method$13, uri$6, body$13, headers$13, response$13, options$13, tags$13);
});
$c_Lsttp_client3_RequestT.prototype.withBody__Lsttp_client3_RequestBody__Lsttp_client3_RequestT = (function(body) {
  if ((body instanceof $c_Lsttp_client3_StringBody)) {
    var x25 = body.Lsttp_client3_StringBody__f_encoding;
    var x26 = body.Lsttp_client3_StringBody__f_defaultContentType;
    var charset$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(x25);
    var mainType$1 = x26.Lsttp_model_MediaType__f_mainType;
    var subType$1 = x26.Lsttp_model_MediaType__f_subType;
    var otherParameters$1 = x26.Lsttp_model_MediaType__f_otherParameters;
    var defaultCt = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_model_MediaType(mainType$1, subType$1, charset$1, otherParameters$1);
  } else {
    var defaultCt = body.defaultContentType__Lsttp_model_MediaType();
  }
  var \u03b41$ = $p_Lsttp_client3_RequestT__setContentTypeIfMissing__Lsttp_model_MediaType__Lsttp_client3_RequestT(this, defaultCt);
  var method = \u03b41$.Lsttp_client3_RequestT__f_method;
  var uri = \u03b41$.Lsttp_client3_RequestT__f_uri;
  var headers = \u03b41$.Lsttp_client3_RequestT__f_headers;
  var response = \u03b41$.Lsttp_client3_RequestT__f_response;
  var options = \u03b41$.Lsttp_client3_RequestT__f_options;
  var tags = \u03b41$.Lsttp_client3_RequestT__f_tags;
  return new $c_Lsttp_client3_RequestT(method, uri, body, headers, response, options, tags);
});
$c_Lsttp_client3_RequestT.prototype.onlyMetadata__s_$eq$colon$eq__Lsttp_model_RequestMetadata = (function(isIdInRequest) {
  var m = ((this.Lsttp_client3_RequestT__f_method === null) ? null : this.Lsttp_client3_RequestT__f_method.Lsttp_model_Method__f_method);
  var u = this.Lsttp_client3_RequestT__f_uri;
  var h = this.Lsttp_client3_RequestT__f_headers;
  return new $c_Lsttp_client3_RequestT$$anon$2(m, u, h);
});
function $isArrayOf_Lsttp_client3_RequestT(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_client3_RequestT)));
}
export { $isArrayOf_Lsttp_client3_RequestT as $isArrayOf_Lsttp_client3_RequestT };
var $d_Lsttp_client3_RequestT = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_RequestT, "sttp.client3.RequestT", ({
  Lsttp_client3_RequestT: 1,
  Lsttp_model_HasHeaders: 1,
  Lsttp_client3_RequestTExtensions: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_client3_RequestT as $d_Lsttp_client3_RequestT };
/** @constructor */
function $c_Lsttp_client3_Response(body, code, statusText, headers, history, request) {
  this.Lsttp_client3_Response__f_body = null;
  this.Lsttp_client3_Response__f_code = 0;
  this.Lsttp_client3_Response__f_statusText = null;
  this.Lsttp_client3_Response__f_headers = null;
  this.Lsttp_client3_Response__f_history = null;
  this.Lsttp_client3_Response__f_request = null;
  this.Lsttp_client3_Response__f_body = body;
  this.Lsttp_client3_Response__f_code = code;
  this.Lsttp_client3_Response__f_statusText = statusText;
  this.Lsttp_client3_Response__f_headers = headers;
  this.Lsttp_client3_Response__f_history = history;
  this.Lsttp_client3_Response__f_request = request;
}
export { $c_Lsttp_client3_Response as $c_Lsttp_client3_Response };
$c_Lsttp_client3_Response.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_Response.prototype.constructor = $c_Lsttp_client3_Response;
/** @constructor */
function $h_Lsttp_client3_Response() {
}
export { $h_Lsttp_client3_Response as $h_Lsttp_client3_Response };
$h_Lsttp_client3_Response.prototype = $c_Lsttp_client3_Response.prototype;
$c_Lsttp_client3_Response.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_client3_Response.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lsttp_client3_Response.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_client3_Response)) {
    var x = this.Lsttp_client3_Response__f_body;
    var y = x$0.Lsttp_client3_Response__f_body;
    if ((($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y) && (this.Lsttp_client3_Response__f_code === x$0.Lsttp_client3_Response__f_code)) && (this.Lsttp_client3_Response__f_statusText === x$0.Lsttp_client3_Response__f_statusText))) {
      var x$1 = this.Lsttp_client3_Response__f_headers;
      var x$2 = x$0.Lsttp_client3_Response__f_headers;
      var $x_2 = ((x$1 === null) ? (x$2 === null) : x$1.equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Lsttp_client3_Response__f_history;
      var x$4 = x$0.Lsttp_client3_Response__f_history;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Lsttp_client3_Response__f_request;
      var x$6 = x$0.Lsttp_client3_Response__f_request;
      return (x$5 === x$6);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_client3_Response.prototype.productArity__I = (function() {
  return 6;
});
$c_Lsttp_client3_Response.prototype.productPrefix__T = (function() {
  return "Response";
});
$c_Lsttp_client3_Response.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsttp_client3_Response__f_body;
      break;
    }
    case 1: {
      return new $c_Lsttp_model_StatusCode(this.Lsttp_client3_Response__f_code);
      break;
    }
    case 2: {
      return this.Lsttp_client3_Response__f_statusText;
      break;
    }
    case 3: {
      return this.Lsttp_client3_Response__f_headers;
      break;
    }
    case 4: {
      return this.Lsttp_client3_Response__f_history;
      break;
    }
    case 5: {
      return this.Lsttp_client3_Response__f_request;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_client3_Response.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "body";
      break;
    }
    case 1: {
      return "code";
      break;
    }
    case 2: {
      return "statusText";
      break;
    }
    case 3: {
      return "headers";
      break;
    }
    case 4: {
      return "history";
      break;
    }
    case 5: {
      return "request";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_client3_Response.prototype.code__I = (function() {
  return this.Lsttp_client3_Response__f_code;
});
$c_Lsttp_client3_Response.prototype.statusText__T = (function() {
  return this.Lsttp_client3_Response__f_statusText;
});
$c_Lsttp_client3_Response.prototype.headers__sci_Seq = (function() {
  return this.Lsttp_client3_Response__f_headers;
});
$c_Lsttp_client3_Response.prototype.toString__T = (function() {
  return (((((((((((("Response(" + this.Lsttp_client3_Response__f_body) + ",") + new $c_Lsttp_model_StatusCode(this.Lsttp_client3_Response__f_code)) + ",") + this.Lsttp_client3_Response__f_statusText) + ",") + $m_Lsttp_model_Headers$().toStringSafe__sci_Seq__sci_Set__sci_Seq(this.Lsttp_client3_Response__f_headers, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_SensitiveHeaders)) + ",") + this.Lsttp_client3_Response__f_history) + ",") + this.Lsttp_client3_Response__f_request) + ")");
});
function $isArrayOf_Lsttp_client3_Response(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_client3_Response)));
}
export { $isArrayOf_Lsttp_client3_Response as $isArrayOf_Lsttp_client3_Response };
var $d_Lsttp_client3_Response = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_Response, "sttp.client3.Response", ({
  Lsttp_client3_Response: 1,
  Lsttp_model_HasHeaders: 1,
  Lsttp_model_ResponseMetadata: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_client3_Response as $d_Lsttp_client3_Response };
function $isArrayOf_Lsttp_client3_ResponseAsWebSocket(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_client3_ResponseAsWebSocket)));
}
export { $isArrayOf_Lsttp_client3_ResponseAsWebSocket as $isArrayOf_Lsttp_client3_ResponseAsWebSocket };
function $isArrayOf_Lsttp_client3_ResponseAsWebSocketStream(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_client3_ResponseAsWebSocketStream)));
}
export { $isArrayOf_Lsttp_client3_ResponseAsWebSocketStream as $isArrayOf_Lsttp_client3_ResponseAsWebSocketStream };
/** @constructor */
function $c_Lsttp_client3_ResponseAsWebSocketUnsafe() {
}
export { $c_Lsttp_client3_ResponseAsWebSocketUnsafe as $c_Lsttp_client3_ResponseAsWebSocketUnsafe };
$c_Lsttp_client3_ResponseAsWebSocketUnsafe.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_ResponseAsWebSocketUnsafe.prototype.constructor = $c_Lsttp_client3_ResponseAsWebSocketUnsafe;
/** @constructor */
function $h_Lsttp_client3_ResponseAsWebSocketUnsafe() {
}
export { $h_Lsttp_client3_ResponseAsWebSocketUnsafe as $h_Lsttp_client3_ResponseAsWebSocketUnsafe };
$h_Lsttp_client3_ResponseAsWebSocketUnsafe.prototype = $c_Lsttp_client3_ResponseAsWebSocketUnsafe.prototype;
$c_Lsttp_client3_ResponseAsWebSocketUnsafe.prototype.mapWithMetadata__F2__Lsttp_client3_ResponseAs = (function(f) {
  var showAs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  return new $c_Lsttp_client3_MappedResponseAs(this, f, showAs);
});
$c_Lsttp_client3_ResponseAsWebSocketUnsafe.prototype.showAs__T__Lsttp_client3_ResponseAs = (function(s) {
  return $f_Lsttp_client3_ResponseAs__showAs__T__Lsttp_client3_ResponseAs(this, s);
});
$c_Lsttp_client3_ResponseAsWebSocketUnsafe.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_client3_ResponseAsWebSocketUnsafe.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lsttp_client3_ResponseAsWebSocketUnsafe.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || (x$0 instanceof $c_Lsttp_client3_ResponseAsWebSocketUnsafe));
});
$c_Lsttp_client3_ResponseAsWebSocketUnsafe.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_client3_ResponseAsWebSocketUnsafe.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_client3_ResponseAsWebSocketUnsafe.prototype.productPrefix__T = (function() {
  return "ResponseAsWebSocketUnsafe";
});
$c_Lsttp_client3_ResponseAsWebSocketUnsafe.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_client3_ResponseAsWebSocketUnsafe.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_client3_ResponseAsWebSocketUnsafe(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_client3_ResponseAsWebSocketUnsafe)));
}
export { $isArrayOf_Lsttp_client3_ResponseAsWebSocketUnsafe as $isArrayOf_Lsttp_client3_ResponseAsWebSocketUnsafe };
var $d_Lsttp_client3_ResponseAsWebSocketUnsafe = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_ResponseAsWebSocketUnsafe, "sttp.client3.ResponseAsWebSocketUnsafe", ({
  Lsttp_client3_ResponseAsWebSocketUnsafe: 1,
  Lsttp_client3_ResponseAs: 1,
  Lsttp_client3_WebSocketResponseAs: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_client3_ResponseAsWebSocketUnsafe as $d_Lsttp_client3_ResponseAsWebSocketUnsafe };
/** @constructor */
function $c_Lsttp_client3_StringBody(s, encoding, defaultContentType) {
  this.Lsttp_client3_StringBody__f_s = null;
  this.Lsttp_client3_StringBody__f_encoding = null;
  this.Lsttp_client3_StringBody__f_defaultContentType = null;
  this.Lsttp_client3_StringBody__f_s = s;
  this.Lsttp_client3_StringBody__f_encoding = encoding;
  this.Lsttp_client3_StringBody__f_defaultContentType = defaultContentType;
}
export { $c_Lsttp_client3_StringBody as $c_Lsttp_client3_StringBody };
$c_Lsttp_client3_StringBody.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_StringBody.prototype.constructor = $c_Lsttp_client3_StringBody;
/** @constructor */
function $h_Lsttp_client3_StringBody() {
}
export { $h_Lsttp_client3_StringBody as $h_Lsttp_client3_StringBody };
$h_Lsttp_client3_StringBody.prototype = $c_Lsttp_client3_StringBody.prototype;
$c_Lsttp_client3_StringBody.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_client3_StringBody.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lsttp_client3_StringBody.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_client3_StringBody)) {
    if (((this.Lsttp_client3_StringBody__f_s === x$0.Lsttp_client3_StringBody__f_s) && (this.Lsttp_client3_StringBody__f_encoding === x$0.Lsttp_client3_StringBody__f_encoding))) {
      var x = this.Lsttp_client3_StringBody__f_defaultContentType;
      var x$2 = x$0.Lsttp_client3_StringBody__f_defaultContentType;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_client3_StringBody.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_client3_StringBody.prototype.productArity__I = (function() {
  return 3;
});
$c_Lsttp_client3_StringBody.prototype.productPrefix__T = (function() {
  return "StringBody";
});
$c_Lsttp_client3_StringBody.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsttp_client3_StringBody__f_s;
      break;
    }
    case 1: {
      return this.Lsttp_client3_StringBody__f_encoding;
      break;
    }
    case 2: {
      return this.Lsttp_client3_StringBody__f_defaultContentType;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_client3_StringBody.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "s";
      break;
    }
    case 1: {
      return "encoding";
      break;
    }
    case 2: {
      return "defaultContentType";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_client3_StringBody.prototype.defaultContentType__Lsttp_model_MediaType = (function() {
  return this.Lsttp_client3_StringBody__f_defaultContentType;
});
function $isArrayOf_Lsttp_client3_StringBody(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_client3_StringBody)));
}
export { $isArrayOf_Lsttp_client3_StringBody as $isArrayOf_Lsttp_client3_StringBody };
var $d_Lsttp_client3_StringBody = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_StringBody, "sttp.client3.StringBody", ({
  Lsttp_client3_StringBody: 1,
  Lsttp_client3_RequestBody: 1,
  Lsttp_client3_BasicRequestBody: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_client3_StringBody as $d_Lsttp_client3_StringBody };
class $c_Lsttp_client3_SttpClientException$TimeoutException extends $c_Lsttp_client3_SttpClientException$ReadException {
  constructor(request, cause) {
    super();
    $ct_Lsttp_client3_SttpClientException__Lsttp_client3_RequestT__jl_Exception__(this, request, cause);
  }
}
export { $c_Lsttp_client3_SttpClientException$TimeoutException as $c_Lsttp_client3_SttpClientException$TimeoutException };
var $d_Lsttp_client3_SttpClientException$TimeoutException = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_SttpClientException$TimeoutException, "sttp.client3.SttpClientException$TimeoutException", ({
  Lsttp_client3_SttpClientException$TimeoutException: 1,
  Lsttp_client3_SttpClientException$ReadException: 1,
  Lsttp_client3_SttpClientException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_client3_SttpClientException$TimeoutException as $d_Lsttp_client3_SttpClientException$TimeoutException };
class $c_Lsttp_tapir_DecodeResult$Error$JsonDecodeException extends $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Exception {
  constructor(errors, underlying) {
    super();
    this.Lsttp_tapir_DecodeResult$Error$JsonDecodeException__f_errors = null;
    this.Lsttp_tapir_DecodeResult$Error$JsonDecodeException__f_underlying = null;
    this.Lsttp_tapir_DecodeResult$Error$JsonDecodeException__f_errors = errors;
    this.Lsttp_tapir_DecodeResult$Error$JsonDecodeException__f_underlying = underlying;
    var s = underlying.getMessage__T();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, underlying, true, false);
  }
  productIterator__sc_Iterator() {
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
  }
  hashCode__I() {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1930333197, true);
  }
  equals__O__Z(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lsttp_tapir_DecodeResult$Error$JsonDecodeException)) {
      var x = this.Lsttp_tapir_DecodeResult$Error$JsonDecodeException__f_errors;
      var x$2 = x$0.Lsttp_tapir_DecodeResult$Error$JsonDecodeException__f_errors;
      if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
        var x$3 = this.Lsttp_tapir_DecodeResult$Error$JsonDecodeException__f_underlying;
        var x$4 = x$0.Lsttp_tapir_DecodeResult$Error$JsonDecodeException__f_underlying;
        return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  productArity__I() {
    return 2;
  }
  productPrefix__T() {
    return "JsonDecodeException";
  }
  productElement__I__O(n) {
    if ((n === 0)) {
      return this.Lsttp_tapir_DecodeResult$Error$JsonDecodeException__f_errors;
    }
    if ((n === 1)) {
      return this.Lsttp_tapir_DecodeResult$Error$JsonDecodeException__f_underlying;
    }
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  productElementName__I__T(n) {
    if ((n === 0)) {
      return "errors";
    }
    if ((n === 1)) {
      return "underlying";
    }
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  toString__T() {
    return (((("JsonDecodeException(" + this.Lsttp_tapir_DecodeResult$Error$JsonDecodeException__f_errors) + ",") + this.Lsttp_tapir_DecodeResult$Error$JsonDecodeException__f_underlying) + ")");
  }
}
export { $c_Lsttp_tapir_DecodeResult$Error$JsonDecodeException as $c_Lsttp_tapir_DecodeResult$Error$JsonDecodeException };
function $isArrayOf_Lsttp_tapir_DecodeResult$Error$JsonDecodeException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_DecodeResult$Error$JsonDecodeException)));
}
export { $isArrayOf_Lsttp_tapir_DecodeResult$Error$JsonDecodeException as $isArrayOf_Lsttp_tapir_DecodeResult$Error$JsonDecodeException };
var $d_Lsttp_tapir_DecodeResult$Error$JsonDecodeException = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_DecodeResult$Error$JsonDecodeException, "sttp.tapir.DecodeResult$Error$JsonDecodeException", ({
  Lsttp_tapir_DecodeResult$Error$JsonDecodeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lsttp_tapir_DecodeResult$Error$JsonDecodeException as $d_Lsttp_tapir_DecodeResult$Error$JsonDecodeException };
/** @constructor */
function $c_Lsttp_tapir_DecodeResult$Mismatch(expected, actual) {
  this.Lsttp_tapir_DecodeResult$Mismatch__f_expected = null;
  this.Lsttp_tapir_DecodeResult$Mismatch__f_actual = null;
  this.Lsttp_tapir_DecodeResult$Mismatch__f_expected = expected;
  this.Lsttp_tapir_DecodeResult$Mismatch__f_actual = actual;
}
export { $c_Lsttp_tapir_DecodeResult$Mismatch as $c_Lsttp_tapir_DecodeResult$Mismatch };
$c_Lsttp_tapir_DecodeResult$Mismatch.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_DecodeResult$Mismatch.prototype.constructor = $c_Lsttp_tapir_DecodeResult$Mismatch;
/** @constructor */
function $h_Lsttp_tapir_DecodeResult$Mismatch() {
}
export { $h_Lsttp_tapir_DecodeResult$Mismatch as $h_Lsttp_tapir_DecodeResult$Mismatch };
$h_Lsttp_tapir_DecodeResult$Mismatch.prototype = $c_Lsttp_tapir_DecodeResult$Mismatch.prototype;
$c_Lsttp_tapir_DecodeResult$Mismatch.prototype.map__F1__Lsttp_tapir_DecodeResult = (function(f) {
  return this;
});
$c_Lsttp_tapir_DecodeResult$Mismatch.prototype.flatMap__F1__Lsttp_tapir_DecodeResult = (function(f) {
  return this;
});
$c_Lsttp_tapir_DecodeResult$Mismatch.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_DecodeResult$Mismatch.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 13069829, true);
});
$c_Lsttp_tapir_DecodeResult$Mismatch.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lsttp_tapir_DecodeResult$Mismatch) && ((this.Lsttp_tapir_DecodeResult$Mismatch__f_expected === x$0.Lsttp_tapir_DecodeResult$Mismatch__f_expected) && (this.Lsttp_tapir_DecodeResult$Mismatch__f_actual === x$0.Lsttp_tapir_DecodeResult$Mismatch__f_actual))));
});
$c_Lsttp_tapir_DecodeResult$Mismatch.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_DecodeResult$Mismatch.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsttp_tapir_DecodeResult$Mismatch.prototype.productPrefix__T = (function() {
  return "Mismatch";
});
$c_Lsttp_tapir_DecodeResult$Mismatch.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_DecodeResult$Mismatch__f_expected;
  }
  if ((n === 1)) {
    return this.Lsttp_tapir_DecodeResult$Mismatch__f_actual;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_DecodeResult$Mismatch.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "expected";
  }
  if ((n === 1)) {
    return "actual";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_tapir_DecodeResult$Mismatch(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_DecodeResult$Mismatch)));
}
export { $isArrayOf_Lsttp_tapir_DecodeResult$Mismatch as $isArrayOf_Lsttp_tapir_DecodeResult$Mismatch };
var $d_Lsttp_tapir_DecodeResult$Mismatch = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_DecodeResult$Mismatch, "sttp.tapir.DecodeResult$Mismatch", ({
  Lsttp_tapir_DecodeResult$Mismatch: 1,
  Lsttp_tapir_DecodeResult: 1,
  Lsttp_tapir_DecodeResult$Failure: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_DecodeResult$Mismatch as $d_Lsttp_tapir_DecodeResult$Mismatch };
function $is_Lsttp_tapir_EndpointInput$Basic(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsttp_tapir_EndpointInput$Basic)));
}
export { $is_Lsttp_tapir_EndpointInput$Basic as $is_Lsttp_tapir_EndpointInput$Basic };
function $isArrayOf_Lsttp_tapir_EndpointInput$Basic(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointInput$Basic)));
}
export { $isArrayOf_Lsttp_tapir_EndpointInput$Basic as $isArrayOf_Lsttp_tapir_EndpointInput$Basic };
var $d_Lsttp_tapir_EndpointInput$Basic = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass(1, "sttp.tapir.EndpointInput$Basic", ({
  Lsttp_tapir_EndpointInput$Basic: 1,
  Lsttp_tapir_macros_EndpointTransputMacros: 1,
  Lsttp_tapir_EndpointTransput: 1,
  Lsttp_tapir_EndpointInput: 1,
  Lsttp_tapir_EndpointInput$Single: 1,
  Lsttp_tapir_EndpointTransput$Basic: 1
}));
export { $d_Lsttp_tapir_EndpointInput$Basic as $d_Lsttp_tapir_EndpointInput$Basic };
function $f_Lsttp_tapir_Tapir__$init$__V($thiz) {
  var charset = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_nio_charset_UTF\uff3f8$();
  var bodyType = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_RawBodyType$StringBody(charset);
  var this$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Codec$().Lsttp_tapir_Codec$__f_string;
  var f = new $c_Lsttp_tapir_CodecFormat$TextHtml();
  var codec = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Codec$$anon$3(f, this$4);
  var description = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var examples = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var attributes = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  var info = new $c_Lsttp_tapir_EndpointIO$Info(description, examples, false, attributes);
  $thiz.sttp$tapir$Tapir$_setter_$htmlBodyUtf8_$eq__Lsttp_tapir_EndpointIO$Body__V(new $c_Lsttp_tapir_EndpointIO$Body(bodyType, codec, info));
  var multipartCodec = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_MultipartCodec$().Lsttp_tapir_MultipartCodec$__f_Default;
  var bodyType$1 = multipartCodec.Lsttp_tapir_MultipartCodec__f_rawBodyType;
  var codec$1 = multipartCodec.Lsttp_tapir_MultipartCodec__f_codec;
  var description$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var examples$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var attributes$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  var info$1 = new $c_Lsttp_tapir_EndpointIO$Info(description$1, examples$1, false, attributes$1);
  $thiz.sttp$tapir$Tapir$_setter_$multipartBody_$eq__Lsttp_tapir_EndpointIO$Body__V(new $c_Lsttp_tapir_EndpointIO$Body(bodyType$1, codec$1, info$1));
  var this$29 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$();
  var elems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T2.getArrayOf().constr)([$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_B.getClassOf(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_jl_Byte.getClassOf()), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_S.getClassOf(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_jl_Short.getClassOf()), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_C.getClassOf(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_jl_Character.getClassOf()), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_I.getClassOf(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_jl_Integer.getClassOf()), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_J.getClassOf(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_jl_Long.getClassOf()), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_F.getClassOf(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_jl_Float.getClassOf()), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_D.getClassOf(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_jl_Double.getClassOf()), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Z.getClassOf(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_jl_Boolean.getClassOf()), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_V.getClassOf(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_jl_Void.getClassOf())]));
  $thiz.sttp$tapir$Tapir$_setter_$sttp$tapir$Tapir$$primitiveToBoxedClasses_$eq__sci_Map__V(this$29.from__sc_IterableOnce__sci_Map(elems));
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Codec$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Codec$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var schemaType = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_SchemaType$SString();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var name = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var isOptional = false;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var description$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var default$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var format = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var encodedExample = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var deprecated = false;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var hidden = false;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var validator = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var attributes$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  var s = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema(schemaType, name, isOptional, description$2, default$1, format, encodedExample, deprecated, hidden, validator, attributes$2);
  var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_CodecFormat$TextPlain();
  var codec$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Codec$$anon$4(s, f$1);
  var description$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var examples$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var attributes$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  var info$2 = new $c_Lsttp_tapir_EndpointIO$Info(description$3, examples$2, false, attributes$3);
  $thiz.sttp$tapir$Tapir$_setter_$sttp$tapir$Tapir$$emptyIO_$eq__Lsttp_tapir_EndpointIO$Empty__V(new $c_Lsttp_tapir_EndpointIO$Empty(codec$2, info$2));
  $thiz.sttp$tapir$Tapir$_setter_$emptyOutput_$eq__Lsttp_tapir_EndpointOutput$Atom__V($thiz.sttp$tapir$Tapir$$emptyIO__Lsttp_tapir_EndpointIO$Empty());
  $thiz.sttp$tapir$Tapir$_setter_$emptyInput_$eq__Lsttp_tapir_EndpointInput__V($thiz.sttp$tapir$Tapir$$emptyIO__Lsttp_tapir_EndpointIO$Empty());
  var input = $thiz.sttp$tapir$Tapir$$emptyIO__Lsttp_tapir_EndpointIO$Empty();
  $m_Lsttp_model_headers_WWWAuthenticateChallenge$();
  $m_Lsttp_model_headers_WWWAuthenticateChallenge$();
  var params = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_ListMap$EmptyListMap$();
  var challenge = new $c_Lsttp_model_headers_WWWAuthenticateChallenge("", params);
  var authType = new $c_Lsttp_tapir_EndpointInput$AuthType$ApiKey();
  var info$3 = $m_Lsttp_tapir_EndpointInput$AuthInfo$().Lsttp_tapir_EndpointInput$AuthInfo$__f_Empty;
  $thiz.sttp$tapir$Tapir$_setter_$emptyAuth_$eq__Lsttp_tapir_EndpointInput$Auth__V(new $c_Lsttp_tapir_EndpointInput$Auth(input, challenge, authType, info$3));
  var securityInput = $thiz.emptyInput__Lsttp_tapir_EndpointInput();
  var input$1 = $thiz.emptyInput__Lsttp_tapir_EndpointInput();
  var errorOutput = new $c_Lsttp_tapir_EndpointOutput$Void();
  var output = $thiz.emptyOutput__Lsttp_tapir_EndpointOutput$Atom();
  var name$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var summary = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var description$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
  var tags = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector0$();
  var attributes$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  var info$4 = new $c_Lsttp_tapir_EndpointInfo(name$1, summary, description$4, tags, false, attributes$4);
  $thiz.sttp$tapir$Tapir$_setter_$infallibleEndpoint_$eq__Lsttp_tapir_Endpoint__V(new $c_Lsttp_tapir_Endpoint(securityInput, input$1, errorOutput, output, info$4));
  $thiz.infallibleEndpoint__Lsttp_tapir_Endpoint();
  var this$54 = $thiz.infallibleEndpoint__Lsttp_tapir_Endpoint();
  var securityInput$1 = this$54.Lsttp_tapir_Endpoint__f_securityInput;
  var this$55 = $thiz.infallibleEndpoint__Lsttp_tapir_Endpoint();
  var input$2 = this$55.Lsttp_tapir_Endpoint__f_input;
  var errorOutput$1 = $thiz.emptyOutput__Lsttp_tapir_EndpointOutput$Atom();
  var this$56 = $thiz.infallibleEndpoint__Lsttp_tapir_Endpoint();
  var output$1 = this$56.Lsttp_tapir_Endpoint__f_output;
  var this$57 = $thiz.infallibleEndpoint__Lsttp_tapir_Endpoint();
  var info$5 = this$57.Lsttp_tapir_Endpoint__f_info;
  $thiz.sttp$tapir$Tapir$_setter_$endpoint_$eq__Lsttp_tapir_Endpoint__V(new $c_Lsttp_tapir_Endpoint(securityInput$1, input$2, errorOutput$1, output$1, info$5));
}
export { $f_Lsttp_tapir_Tapir__$init$__V as $f_Lsttp_tapir_Tapir__$init$__V };
function $f_Lsttp_tapir_Tapir__stringToPath__T__Lsttp_tapir_EndpointInput$FixedPath($thiz, s) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Codec$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Codec$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var schemaType = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_SchemaType$SString();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var name = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var isOptional = false;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var description = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var default$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var format = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var encodedExample = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var deprecated = false;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var hidden = false;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var validator = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var attributes = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  var s$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema(schemaType, name, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_CodecFormat$TextPlain();
  var codec = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Codec$$anon$4(s$1, f);
  var description$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var examples = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var attributes$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  var info = new $c_Lsttp_tapir_EndpointIO$Info(description$1, examples, false, attributes$1);
  return new $c_Lsttp_tapir_EndpointInput$FixedPath(s, codec, info);
}
export { $f_Lsttp_tapir_Tapir__stringToPath__T__Lsttp_tapir_EndpointInput$FixedPath as $f_Lsttp_tapir_Tapir__stringToPath__T__Lsttp_tapir_EndpointInput$FixedPath };
function $f_Lsttp_tapir_Tapir__path__Lsttp_tapir_Codec__Lsttp_tapir_EndpointInput$PathCapture($thiz, evidence$1) {
  var name = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var description = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var examples = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var attributes = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  var info = new $c_Lsttp_tapir_EndpointIO$Info(description, examples, false, attributes);
  return new $c_Lsttp_tapir_EndpointInput$PathCapture(name, evidence$1, info);
}
export { $f_Lsttp_tapir_Tapir__path__Lsttp_tapir_Codec__Lsttp_tapir_EndpointInput$PathCapture as $f_Lsttp_tapir_Tapir__path__Lsttp_tapir_Codec__Lsttp_tapir_EndpointInput$PathCapture };
function $f_Lsttp_tapir_Tapir__query__T__Lsttp_tapir_Codec__Lsttp_tapir_EndpointInput$Query($thiz, name, evidence$1) {
  var flagValue = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var description = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var examples = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var attributes = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  var info = new $c_Lsttp_tapir_EndpointIO$Info(description, examples, false, attributes);
  return new $c_Lsttp_tapir_EndpointInput$Query(name, flagValue, evidence$1, info);
}
export { $f_Lsttp_tapir_Tapir__query__T__Lsttp_tapir_Codec__Lsttp_tapir_EndpointInput$Query as $f_Lsttp_tapir_Tapir__query__T__Lsttp_tapir_Codec__Lsttp_tapir_EndpointInput$Query };
function $f_Lsttp_tapir_Tapir__header__T__Lsttp_tapir_Codec__Lsttp_tapir_EndpointIO$Header($thiz, name, evidence$1) {
  var description = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var examples = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var attributes = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  var info = new $c_Lsttp_tapir_EndpointIO$Info(description, examples, false, attributes);
  return new $c_Lsttp_tapir_EndpointIO$Header(name, evidence$1, info);
}
export { $f_Lsttp_tapir_Tapir__header__T__Lsttp_tapir_Codec__Lsttp_tapir_EndpointIO$Header as $f_Lsttp_tapir_Tapir__header__T__Lsttp_tapir_Codec__Lsttp_tapir_EndpointIO$Header };
function $f_Lsttp_tapir_Tapir__cookie__T__Lsttp_tapir_Codec__Lsttp_tapir_EndpointInput$Cookie($thiz, name, evidence$1) {
  var description = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var examples = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var attributes = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  var info = new $c_Lsttp_tapir_EndpointIO$Info(description, examples, false, attributes);
  return new $c_Lsttp_tapir_EndpointInput$Cookie(name, evidence$1, info);
}
export { $f_Lsttp_tapir_Tapir__cookie__T__Lsttp_tapir_Codec__Lsttp_tapir_EndpointInput$Cookie as $f_Lsttp_tapir_Tapir__cookie__T__Lsttp_tapir_Codec__Lsttp_tapir_EndpointInput$Cookie };
function $f_Lsttp_tapir_Tapir__stringBodyAnyFormat__Lsttp_tapir_Codec__Ljava_nio_charset_Charset__Lsttp_tapir_EndpointIO$Body($thiz, codec, charset) {
  var bodyType = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_RawBodyType$StringBody(charset);
  var description = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var examples = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var attributes = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  var info = new $c_Lsttp_tapir_EndpointIO$Info(description, examples, false, attributes);
  return new $c_Lsttp_tapir_EndpointIO$Body(bodyType, codec, info);
}
export { $f_Lsttp_tapir_Tapir__stringBodyAnyFormat__Lsttp_tapir_Codec__Ljava_nio_charset_Charset__Lsttp_tapir_EndpointIO$Body as $f_Lsttp_tapir_Tapir__stringBodyAnyFormat__Lsttp_tapir_Codec__Ljava_nio_charset_Charset__Lsttp_tapir_EndpointIO$Body };
function $f_Lsttp_tapir_Tapir__extractFromRequest__F1__Lsttp_tapir_EndpointInput$ExtractFromRequest($thiz, f) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Codec$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Codec$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var schemaType = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_SchemaType$SString();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var name = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var isOptional = false;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var description = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var default$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var format = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var encodedExample = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var deprecated = false;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var hidden = false;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var validator = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var attributes = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  var s = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema(schemaType, name, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes);
  var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_CodecFormat$TextPlain();
  var this$13 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Codec$$anon$4(s, f$1);
  var g = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$15) => null));
  var codec = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lsttp_tapir_Codec__map__F1__F1__Lsttp_tapir_Codec(this$13, f, g);
  var description$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var examples = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var attributes$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  var info = new $c_Lsttp_tapir_EndpointIO$Info(description$1, examples, false, attributes$1);
  return new $c_Lsttp_tapir_EndpointInput$ExtractFromRequest(codec, info);
}
export { $f_Lsttp_tapir_Tapir__extractFromRequest__F1__Lsttp_tapir_EndpointInput$ExtractFromRequest as $f_Lsttp_tapir_Tapir__extractFromRequest__F1__Lsttp_tapir_EndpointInput$ExtractFromRequest };
function $f_Lsttp_tapir_Tapir__statusCode__I__Lsttp_tapir_EndpointOutput$FixedStatusCode($thiz, statusCode) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Codec$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Codec$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var schemaType = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_SchemaType$SString();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var name = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var isOptional = false;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var description = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var default$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var format = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var encodedExample = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var deprecated = false;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var hidden = false;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var validator = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
  var attributes = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  var s = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema(schemaType, name, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_CodecFormat$TextPlain();
  var codec = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Codec$$anon$4(s, f);
  var description$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var examples = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var attributes$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  var info = new $c_Lsttp_tapir_EndpointIO$Info(description$1, examples, false, attributes$1);
  return new $c_Lsttp_tapir_EndpointOutput$FixedStatusCode(statusCode, codec, info);
}
export { $f_Lsttp_tapir_Tapir__statusCode__I__Lsttp_tapir_EndpointOutput$FixedStatusCode as $f_Lsttp_tapir_Tapir__statusCode__I__Lsttp_tapir_EndpointOutput$FixedStatusCode };
/** @constructor */
function $c_Lsttp_ws_WebSocketFrame$Binary(payload, finalFragment, rsv) {
  this.Lsttp_ws_WebSocketFrame$Binary__f_payload = null;
  this.Lsttp_ws_WebSocketFrame$Binary__f_finalFragment = false;
  this.Lsttp_ws_WebSocketFrame$Binary__f_rsv = null;
  this.Lsttp_ws_WebSocketFrame$Binary__f_payload = payload;
  this.Lsttp_ws_WebSocketFrame$Binary__f_finalFragment = finalFragment;
  this.Lsttp_ws_WebSocketFrame$Binary__f_rsv = rsv;
}
export { $c_Lsttp_ws_WebSocketFrame$Binary as $c_Lsttp_ws_WebSocketFrame$Binary };
$c_Lsttp_ws_WebSocketFrame$Binary.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_ws_WebSocketFrame$Binary.prototype.constructor = $c_Lsttp_ws_WebSocketFrame$Binary;
/** @constructor */
function $h_Lsttp_ws_WebSocketFrame$Binary() {
}
export { $h_Lsttp_ws_WebSocketFrame$Binary as $h_Lsttp_ws_WebSocketFrame$Binary };
$h_Lsttp_ws_WebSocketFrame$Binary.prototype = $c_Lsttp_ws_WebSocketFrame$Binary.prototype;
$c_Lsttp_ws_WebSocketFrame$Binary.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_ws_WebSocketFrame$Binary.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I("Binary");
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lsttp_ws_WebSocketFrame$Binary__f_payload;
  var data$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Lsttp_ws_WebSocketFrame$Binary__f_finalFragment ? 1231 : 1237);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lsttp_ws_WebSocketFrame$Binary__f_rsv;
  var data$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$1);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3);
});
$c_Lsttp_ws_WebSocketFrame$Binary.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_ws_WebSocketFrame$Binary)) {
    if ((this.Lsttp_ws_WebSocketFrame$Binary__f_finalFragment === x$0.Lsttp_ws_WebSocketFrame$Binary__f_finalFragment)) {
      var x = this.Lsttp_ws_WebSocketFrame$Binary__f_payload;
      var x$2 = x$0.Lsttp_ws_WebSocketFrame$Binary__f_payload;
      var $x_1 = (x === x$2);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.Lsttp_ws_WebSocketFrame$Binary__f_rsv;
      var x$4 = x$0.Lsttp_ws_WebSocketFrame$Binary__f_rsv;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_ws_WebSocketFrame$Binary.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_ws_WebSocketFrame$Binary.prototype.productArity__I = (function() {
  return 3;
});
$c_Lsttp_ws_WebSocketFrame$Binary.prototype.productPrefix__T = (function() {
  return "Binary";
});
$c_Lsttp_ws_WebSocketFrame$Binary.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsttp_ws_WebSocketFrame$Binary__f_payload;
      break;
    }
    case 1: {
      return this.Lsttp_ws_WebSocketFrame$Binary__f_finalFragment;
      break;
    }
    case 2: {
      return this.Lsttp_ws_WebSocketFrame$Binary__f_rsv;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_ws_WebSocketFrame$Binary.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "payload";
      break;
    }
    case 1: {
      return "finalFragment";
      break;
    }
    case 2: {
      return "rsv";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lsttp_ws_WebSocketFrame$Binary(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_ws_WebSocketFrame$Binary)));
}
export { $isArrayOf_Lsttp_ws_WebSocketFrame$Binary as $isArrayOf_Lsttp_ws_WebSocketFrame$Binary };
var $d_Lsttp_ws_WebSocketFrame$Binary = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_ws_WebSocketFrame$Binary, "sttp.ws.WebSocketFrame$Binary", ({
  Lsttp_ws_WebSocketFrame$Binary: 1,
  Lsttp_ws_WebSocketFrame: 1,
  Lsttp_ws_WebSocketFrame$Data: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_ws_WebSocketFrame$Binary as $d_Lsttp_ws_WebSocketFrame$Binary };
/** @constructor */
function $c_Lsttp_ws_WebSocketFrame$Close(statusCode, reasonText) {
  this.Lsttp_ws_WebSocketFrame$Close__f_statusCode = 0;
  this.Lsttp_ws_WebSocketFrame$Close__f_reasonText = null;
  this.Lsttp_ws_WebSocketFrame$Close__f_statusCode = statusCode;
  this.Lsttp_ws_WebSocketFrame$Close__f_reasonText = reasonText;
}
export { $c_Lsttp_ws_WebSocketFrame$Close as $c_Lsttp_ws_WebSocketFrame$Close };
$c_Lsttp_ws_WebSocketFrame$Close.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_ws_WebSocketFrame$Close.prototype.constructor = $c_Lsttp_ws_WebSocketFrame$Close;
/** @constructor */
function $h_Lsttp_ws_WebSocketFrame$Close() {
}
export { $h_Lsttp_ws_WebSocketFrame$Close as $h_Lsttp_ws_WebSocketFrame$Close };
$h_Lsttp_ws_WebSocketFrame$Close.prototype = $c_Lsttp_ws_WebSocketFrame$Close.prototype;
$c_Lsttp_ws_WebSocketFrame$Close.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_ws_WebSocketFrame$Close.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I("Close");
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lsttp_ws_WebSocketFrame$Close__f_statusCode;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lsttp_ws_WebSocketFrame$Close__f_reasonText;
  var data$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2);
});
$c_Lsttp_ws_WebSocketFrame$Close.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lsttp_ws_WebSocketFrame$Close) && ((this.Lsttp_ws_WebSocketFrame$Close__f_statusCode === x$0.Lsttp_ws_WebSocketFrame$Close__f_statusCode) && (this.Lsttp_ws_WebSocketFrame$Close__f_reasonText === x$0.Lsttp_ws_WebSocketFrame$Close__f_reasonText))));
});
$c_Lsttp_ws_WebSocketFrame$Close.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_ws_WebSocketFrame$Close.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsttp_ws_WebSocketFrame$Close.prototype.productPrefix__T = (function() {
  return "Close";
});
$c_Lsttp_ws_WebSocketFrame$Close.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_ws_WebSocketFrame$Close__f_statusCode;
  }
  if ((n === 1)) {
    return this.Lsttp_ws_WebSocketFrame$Close__f_reasonText;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_ws_WebSocketFrame$Close.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "statusCode";
  }
  if ((n === 1)) {
    return "reasonText";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_ws_WebSocketFrame$Close(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_ws_WebSocketFrame$Close)));
}
export { $isArrayOf_Lsttp_ws_WebSocketFrame$Close as $isArrayOf_Lsttp_ws_WebSocketFrame$Close };
var $d_Lsttp_ws_WebSocketFrame$Close = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_ws_WebSocketFrame$Close, "sttp.ws.WebSocketFrame$Close", ({
  Lsttp_ws_WebSocketFrame$Close: 1,
  Lsttp_ws_WebSocketFrame: 1,
  Lsttp_ws_WebSocketFrame$Control: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_ws_WebSocketFrame$Close as $d_Lsttp_ws_WebSocketFrame$Close };
/** @constructor */
function $c_Lsttp_ws_WebSocketFrame$Ping(payload) {
  this.Lsttp_ws_WebSocketFrame$Ping__f_payload = null;
  this.Lsttp_ws_WebSocketFrame$Ping__f_payload = payload;
}
export { $c_Lsttp_ws_WebSocketFrame$Ping as $c_Lsttp_ws_WebSocketFrame$Ping };
$c_Lsttp_ws_WebSocketFrame$Ping.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_ws_WebSocketFrame$Ping.prototype.constructor = $c_Lsttp_ws_WebSocketFrame$Ping;
/** @constructor */
function $h_Lsttp_ws_WebSocketFrame$Ping() {
}
export { $h_Lsttp_ws_WebSocketFrame$Ping as $h_Lsttp_ws_WebSocketFrame$Ping };
$h_Lsttp_ws_WebSocketFrame$Ping.prototype = $c_Lsttp_ws_WebSocketFrame$Ping.prototype;
$c_Lsttp_ws_WebSocketFrame$Ping.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_ws_WebSocketFrame$Ping.prototype.hashCode__I = (function() {
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lsttp_ws_WebSocketFrame$Ping.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_ws_WebSocketFrame$Ping)) {
    var x = this.Lsttp_ws_WebSocketFrame$Ping__f_payload;
    var x$2 = x$0.Lsttp_ws_WebSocketFrame$Ping__f_payload;
    return (x === x$2);
  } else {
    return false;
  }
});
$c_Lsttp_ws_WebSocketFrame$Ping.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_ws_WebSocketFrame$Ping.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_ws_WebSocketFrame$Ping.prototype.productPrefix__T = (function() {
  return "Ping";
});
$c_Lsttp_ws_WebSocketFrame$Ping.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_ws_WebSocketFrame$Ping__f_payload;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_ws_WebSocketFrame$Ping.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "payload";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_ws_WebSocketFrame$Ping(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_ws_WebSocketFrame$Ping)));
}
export { $isArrayOf_Lsttp_ws_WebSocketFrame$Ping as $isArrayOf_Lsttp_ws_WebSocketFrame$Ping };
var $d_Lsttp_ws_WebSocketFrame$Ping = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_ws_WebSocketFrame$Ping, "sttp.ws.WebSocketFrame$Ping", ({
  Lsttp_ws_WebSocketFrame$Ping: 1,
  Lsttp_ws_WebSocketFrame: 1,
  Lsttp_ws_WebSocketFrame$Control: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_ws_WebSocketFrame$Ping as $d_Lsttp_ws_WebSocketFrame$Ping };
function $isArrayOf_Lsttp_ws_WebSocketFrame$Pong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_ws_WebSocketFrame$Pong)));
}
export { $isArrayOf_Lsttp_ws_WebSocketFrame$Pong as $isArrayOf_Lsttp_ws_WebSocketFrame$Pong };
/** @constructor */
function $c_Lcats_data_EitherT$() {
}
export { $c_Lcats_data_EitherT$ as $c_Lcats_data_EitherT$ };
$c_Lcats_data_EitherT$.prototype = new $h_Lcats_data_EitherTInstances();
$c_Lcats_data_EitherT$.prototype.constructor = $c_Lcats_data_EitherT$;
/** @constructor */
function $h_Lcats_data_EitherT$() {
}
export { $h_Lcats_data_EitherT$ as $h_Lcats_data_EitherT$ };
$h_Lcats_data_EitherT$.prototype = $c_Lcats_data_EitherT$.prototype;
$c_Lcats_data_EitherT$.prototype.liftF__O__Lcats_Functor__Lcats_data_EitherT = (function(fb, F) {
  return $m_Lcats_data_EitherT$RightPartiallyApplied$().apply$extension__Z__O__Lcats_Functor__Lcats_data_EitherT(true, fb, F);
});
$c_Lcats_data_EitherT$.prototype.fromProduct__s_Product__Lcats_data_EitherT = (function(x$0) {
  return new $c_Lcats_data_EitherT(x$0.productElement__I__O(0));
});
$c_Lcats_data_EitherT$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lcats_data_EitherT(p);
});
var $d_Lcats_data_EitherT$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_data_EitherT$, "cats.data.EitherT$", ({
  Lcats_data_EitherT$: 1,
  Lcats_data_EitherTInstances: 1,
  Lcats_data_EitherTInstances1: 1,
  Lcats_data_EitherTInstances2: 1,
  Lcats_data_EitherTInstances3: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lcats_data_EitherT$ as $d_Lcats_data_EitherT$ };
var $n_Lcats_data_EitherT$;
function $m_Lcats_data_EitherT$() {
  if ((!$n_Lcats_data_EitherT$)) {
    $n_Lcats_data_EitherT$ = new $c_Lcats_data_EitherT$();
  }
  return $n_Lcats_data_EitherT$;
}
export { $m_Lcats_data_EitherT$ as $m_Lcats_data_EitherT$ };
function $ct_Lcats_data_KleisliInstances3__($thiz) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_package$();
  return $thiz;
}
export { $ct_Lcats_data_KleisliInstances3__ as $ct_Lcats_data_KleisliInstances3__ };
/** @constructor */
function $c_Lcats_data_KleisliInstances3() {
}
export { $c_Lcats_data_KleisliInstances3 as $c_Lcats_data_KleisliInstances3 };
$c_Lcats_data_KleisliInstances3.prototype = new $h_Lcats_data_KleisliInstances4();
$c_Lcats_data_KleisliInstances3.prototype.constructor = $c_Lcats_data_KleisliInstances3;
/** @constructor */
function $h_Lcats_data_KleisliInstances3() {
}
export { $h_Lcats_data_KleisliInstances3 as $h_Lcats_data_KleisliInstances3 };
$h_Lcats_data_KleisliInstances3.prototype = $c_Lcats_data_KleisliInstances3.prototype;
function $ct_Lcats_instances_ScalaVersionSpecificNumeric__s_math_Numeric__F1__F1__($thiz, fa, f, g) {
  $thiz.Lcats_instances_ScalaVersionSpecificNumeric__f_fa = fa;
  $thiz.Lcats_instances_ScalaVersionSpecificNumeric__f_f = f;
  $thiz.Lcats_instances_ScalaVersionSpecificNumeric__f_g = g;
  return $thiz;
}
export { $ct_Lcats_instances_ScalaVersionSpecificNumeric__s_math_Numeric__F1__F1__ as $ct_Lcats_instances_ScalaVersionSpecificNumeric__s_math_Numeric__F1__F1__ };
/** @constructor */
function $c_Lcats_instances_ScalaVersionSpecificNumeric() {
  this.Lcats_instances_ScalaVersionSpecificNumeric__f_fa = null;
  this.Lcats_instances_ScalaVersionSpecificNumeric__f_f = null;
  this.Lcats_instances_ScalaVersionSpecificNumeric__f_g = null;
}
export { $c_Lcats_instances_ScalaVersionSpecificNumeric as $c_Lcats_instances_ScalaVersionSpecificNumeric };
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.constructor = $c_Lcats_instances_ScalaVersionSpecificNumeric;
/** @constructor */
function $h_Lcats_instances_ScalaVersionSpecificNumeric() {
}
export { $h_Lcats_instances_ScalaVersionSpecificNumeric as $h_Lcats_instances_ScalaVersionSpecificNumeric };
$h_Lcats_instances_ScalaVersionSpecificNumeric.prototype = $c_Lcats_instances_ScalaVersionSpecificNumeric.prototype;
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.lteq__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.gteq__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.lt__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.gt__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.equiv__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.max__O__O__O = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.min__O__O__O = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.sign__O__O = (function(x) {
  return $f_s_math_Numeric__sign__O__O(this, x);
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.compare__O__O__I = (function(x, y) {
  return this.Lcats_instances_ScalaVersionSpecificNumeric__f_fa.compare__O__O__I(this.Lcats_instances_ScalaVersionSpecificNumeric__f_g.apply__O__O(x), this.Lcats_instances_ScalaVersionSpecificNumeric__f_g.apply__O__O(y));
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.plus__O__O__O = (function(x, y) {
  return this.Lcats_instances_ScalaVersionSpecificNumeric__f_f.apply__O__O(this.Lcats_instances_ScalaVersionSpecificNumeric__f_fa.plus__O__O__O(this.Lcats_instances_ScalaVersionSpecificNumeric__f_g.apply__O__O(x), this.Lcats_instances_ScalaVersionSpecificNumeric__f_g.apply__O__O(y)));
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.minus__O__O__O = (function(x, y) {
  return this.Lcats_instances_ScalaVersionSpecificNumeric__f_f.apply__O__O(this.Lcats_instances_ScalaVersionSpecificNumeric__f_fa.minus__O__O__O(this.Lcats_instances_ScalaVersionSpecificNumeric__f_g.apply__O__O(x), this.Lcats_instances_ScalaVersionSpecificNumeric__f_g.apply__O__O(y)));
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.times__O__O__O = (function(x, y) {
  return this.Lcats_instances_ScalaVersionSpecificNumeric__f_f.apply__O__O(this.Lcats_instances_ScalaVersionSpecificNumeric__f_fa.times__O__O__O(this.Lcats_instances_ScalaVersionSpecificNumeric__f_g.apply__O__O(x), this.Lcats_instances_ScalaVersionSpecificNumeric__f_g.apply__O__O(y)));
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.negate__O__O = (function(x) {
  return this.Lcats_instances_ScalaVersionSpecificNumeric__f_f.apply__O__O(this.Lcats_instances_ScalaVersionSpecificNumeric__f_fa.negate__O__O(this.Lcats_instances_ScalaVersionSpecificNumeric__f_g.apply__O__O(x)));
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.fromInt__I__O = (function(x) {
  return this.Lcats_instances_ScalaVersionSpecificNumeric__f_f.apply__O__O(this.Lcats_instances_ScalaVersionSpecificNumeric__f_fa.fromInt__I__O(x));
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.toInt__O__I = (function(x) {
  return this.Lcats_instances_ScalaVersionSpecificNumeric__f_fa.toInt__O__I(this.Lcats_instances_ScalaVersionSpecificNumeric__f_g.apply__O__O(x));
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.toDouble__O__D = (function(x) {
  return this.Lcats_instances_ScalaVersionSpecificNumeric__f_fa.toDouble__O__D(this.Lcats_instances_ScalaVersionSpecificNumeric__f_g.apply__O__O(x));
});
/** @constructor */
function $c_Lcats_instances_package$option$() {
  this.Lcats_instances_package$option$__f_catsStdInstancesForOption = null;
  $n_Lcats_instances_package$option$ = this;
  this.Lcats_instances_package$option$__f_catsStdInstancesForOption = new $c_Lcats_instances_OptionInstances$$anon$1();
  new $c_Lcats_instances_OptionInstancesBinCompat0$$anon$3();
}
export { $c_Lcats_instances_package$option$ as $c_Lcats_instances_package$option$ };
$c_Lcats_instances_package$option$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_package$option$.prototype.constructor = $c_Lcats_instances_package$option$;
/** @constructor */
function $h_Lcats_instances_package$option$() {
}
export { $h_Lcats_instances_package$option$ as $h_Lcats_instances_package$option$ };
$h_Lcats_instances_package$option$.prototype = $c_Lcats_instances_package$option$.prototype;
var $d_Lcats_instances_package$option$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_package$option$, "cats.instances.package$option$", ({
  Lcats_instances_package$option$: 1,
  Lcats_kernel_instances_OptionInstances2: 1,
  Lcats_kernel_instances_OptionInstances1: 1,
  Lcats_kernel_instances_OptionInstances0: 1,
  Lcats_kernel_instances_OptionInstances: 1,
  Lcats_instances_OptionInstances: 1,
  Lcats_instances_OptionInstancesBinCompat0: 1
}));
export { $d_Lcats_instances_package$option$ as $d_Lcats_instances_package$option$ };
var $n_Lcats_instances_package$option$;
function $m_Lcats_instances_package$option$() {
  if ((!$n_Lcats_instances_package$option$)) {
    $n_Lcats_instances_package$option$ = new $c_Lcats_instances_package$option$();
  }
  return $n_Lcats_instances_package$option$;
}
export { $m_Lcats_instances_package$option$ as $m_Lcats_instances_package$option$ };
/** @constructor */
function $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide(outer, clientData, maybeRedirectToAfterRegistration) {
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_clientData = null;
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_maybeRedirectToAfterRegistration = null;
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_$outer = null;
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_clientData = clientData;
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_maybeRedirectToAfterRegistration = maybeRedirectToAfterRegistration;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_$outer = outer;
}
export { $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide as $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide };
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide.prototype.constructor = $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide;
/** @constructor */
function $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide() {
}
export { $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide as $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide };
$h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide.prototype = $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide.prototype;
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide.prototype.toString__T = (function() {
  return $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__toString__T(this);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-894792943), true);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide) && (x$0.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_$outer === this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_$outer))) {
    var x = this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_clientData;
    var y = x$0.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_clientData;
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_maybeRedirectToAfterRegistration;
      var x$2 = x$0.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_maybeRedirectToAfterRegistration;
      return ((x$1 === null) ? (x$2 === null) : x$1.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide.prototype.productArity__I = (function() {
  return 2;
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide.prototype.productPrefix__T = (function() {
  return "AuthenticatedInClientSide";
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_clientData;
  }
  if ((n === 1)) {
    return this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_maybeRedirectToAfterRegistration;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "clientData";
  }
  if ((n === 1)) {
    return "maybeRedirectToAfterRegistration";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide.prototype.clientData__O = (function() {
  return this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_clientData;
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide.prototype.maybeRedirectToAfterRegistration__s_Option = (function() {
  return this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_maybeRedirectToAfterRegistration;
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide.prototype.copy__O__s_Option__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide = (function(clientData, maybeRedirectToAfterRegistration) {
  return new $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide(this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_$outer, clientData, maybeRedirectToAfterRegistration);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide.prototype.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth = (function() {
  return this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_$outer.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$__f_$outer;
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide.prototype.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasRespondedState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth = (function() {
  return this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_$outer.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$__f_$outer;
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide.prototype.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasSucceededState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth = (function() {
  return this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide__f_$outer.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$__f_$outer;
});
function $isArrayOf_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide)));
}
export { $isArrayOf_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide as $isArrayOf_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide };
var $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide, "framework.data.AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide", ({
  Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide: 1,
  Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState: 1,
  Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasRespondedState: 1,
  Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasSucceededState: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide as $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSide };
/** @constructor */
function $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated(outer, failure, maybeRedirectToAfterRegistration) {
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated__f_failure = null;
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated__f_maybeRedirectToAfterRegistration = null;
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated__f_$outer = null;
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated__f_failure = failure;
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated__f_maybeRedirectToAfterRegistration = maybeRedirectToAfterRegistration;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated__f_$outer = outer;
}
export { $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated as $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated };
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated.prototype.constructor = $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated;
/** @constructor */
function $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated() {
}
export { $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated as $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated };
$h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated.prototype = $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated.prototype;
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated.prototype.toString__T = (function() {
  return $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__toString__T(this);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 434218946, true);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated) && (x$0.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated__f_$outer === this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated__f_$outer))) {
    var x = this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated__f_failure;
    var x$2 = x$0.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated__f_failure;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated__f_maybeRedirectToAfterRegistration;
      var x$4 = x$0.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated__f_maybeRedirectToAfterRegistration;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated.prototype.productArity__I = (function() {
  return 2;
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated.prototype.productPrefix__T = (function() {
  return "NotAuthenticated";
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated__f_failure;
  }
  if ((n === 1)) {
    return this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated__f_maybeRedirectToAfterRegistration;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "failure";
  }
  if ((n === 1)) {
    return "maybeRedirectToAfterRegistration";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated.prototype.maybeRedirectToAfterRegistration__s_Option = (function() {
  return this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated__f_maybeRedirectToAfterRegistration;
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated.prototype.copy__s_Option__s_Option__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated = (function(failure, maybeRedirectToAfterRegistration) {
  return new $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated(this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated__f_$outer, failure, maybeRedirectToAfterRegistration);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated.prototype.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth = (function() {
  return this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated__f_$outer.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$__f_$outer;
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated.prototype.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasRespondedState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth = (function() {
  return this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated__f_$outer.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$__f_$outer;
});
function $isArrayOf_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated)));
}
export { $isArrayOf_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated as $isArrayOf_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated };
var $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated, "framework.data.AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated", ({
  Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated: 1,
  Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState: 1,
  Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasRespondedState: 1,
  Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthHasFailedState: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated as $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$NotAuthenticated };
/** @constructor */
function $c_Lframework_data_IsProductionMode$package$IsProductionMode$() {
  this.Lframework_data_IsProductionMode$package$IsProductionMode$__f_defaultMake$lzy1 = null;
  this.Lframework_data_IsProductionMode$package$IsProductionMode$__f_defaultMakebitmap$1 = false;
  this.Lframework_data_IsProductionMode$package$IsProductionMode$__f_make$lzy1 = null;
  this.Lframework_data_IsProductionMode$package$IsProductionMode$__f_makebitmap$1 = false;
  this.Lframework_data_IsProductionMode$package$IsProductionMode$__f_given_Conversion_Type_Boolean$lzy1 = null;
  this.Lframework_data_IsProductionMode$package$IsProductionMode$__f_given_Conversion_Type_Booleanbitmap$1 = false;
}
export { $c_Lframework_data_IsProductionMode$package$IsProductionMode$ as $c_Lframework_data_IsProductionMode$package$IsProductionMode$ };
$c_Lframework_data_IsProductionMode$package$IsProductionMode$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_IsProductionMode$package$IsProductionMode$.prototype.constructor = $c_Lframework_data_IsProductionMode$package$IsProductionMode$;
/** @constructor */
function $h_Lframework_data_IsProductionMode$package$IsProductionMode$() {
}
export { $h_Lframework_data_IsProductionMode$package$IsProductionMode$ as $h_Lframework_data_IsProductionMode$package$IsProductionMode$ };
$h_Lframework_data_IsProductionMode$package$IsProductionMode$.prototype = $c_Lframework_data_IsProductionMode$package$IsProductionMode$.prototype;
$c_Lframework_data_IsProductionMode$package$IsProductionMode$.prototype.defaultMake__Lyantl_INewtype$defaultMake$ = (function() {
  if ((!this.Lframework_data_IsProductionMode$package$IsProductionMode$__f_defaultMakebitmap$1)) {
    this.Lframework_data_IsProductionMode$package$IsProductionMode$__f_defaultMake$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$defaultMake$(this);
    this.Lframework_data_IsProductionMode$package$IsProductionMode$__f_defaultMakebitmap$1 = true;
  }
  return this.Lframework_data_IsProductionMode$package$IsProductionMode$__f_defaultMake$lzy1;
});
$c_Lframework_data_IsProductionMode$package$IsProductionMode$.prototype.make__Lyantl_INewtype$make$ = (function() {
  if ((!this.Lframework_data_IsProductionMode$package$IsProductionMode$__f_makebitmap$1)) {
    this.Lframework_data_IsProductionMode$package$IsProductionMode$__f_make$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$make$(this);
    this.Lframework_data_IsProductionMode$package$IsProductionMode$__f_makebitmap$1 = true;
  }
  return this.Lframework_data_IsProductionMode$package$IsProductionMode$__f_make$lzy1;
});
$c_Lframework_data_IsProductionMode$package$IsProductionMode$.prototype.resolveMake__Lyantl_Make = (function() {
  return this.defaultMake__Lyantl_INewtype$defaultMake$();
});
$c_Lframework_data_IsProductionMode$package$IsProductionMode$.prototype.protected_unwrap__O__O = (function(wrapped) {
  return wrapped;
});
$c_Lframework_data_IsProductionMode$package$IsProductionMode$.prototype.wrap__O__O = (function(underlying) {
  return underlying;
});
$c_Lframework_data_IsProductionMode$package$IsProductionMode$.prototype.validate__Lyantl_Validate = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lyantl_Validate$().Lyantl_Validate$__f_noOp;
});
$c_Lframework_data_IsProductionMode$package$IsProductionMode$.prototype.given_Conversion_Type_Boolean__s_Conversion = (function() {
  if ((!this.Lframework_data_IsProductionMode$package$IsProductionMode$__f_given_Conversion_Type_Booleanbitmap$1)) {
    this.Lframework_data_IsProductionMode$package$IsProductionMode$__f_given_Conversion_Type_Boolean$lzy1 = new $c_Lframework_utils_NewtypeBoolean$$anon$2(this);
    this.Lframework_data_IsProductionMode$package$IsProductionMode$__f_given_Conversion_Type_Booleanbitmap$1 = true;
  }
  return this.Lframework_data_IsProductionMode$package$IsProductionMode$__f_given_Conversion_Type_Boolean$lzy1;
});
var $d_Lframework_data_IsProductionMode$package$IsProductionMode$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_IsProductionMode$package$IsProductionMode$, "framework.data.IsProductionMode$package$IsProductionMode$", ({
  Lframework_data_IsProductionMode$package$IsProductionMode$: 1,
  Lyantl_INewtype: 1,
  Lyantl_Newtype: 1,
  Lyantl_Newtype$Of: 1,
  Lyantl_Newtype$WithoutValidation: 1,
  Lyantl_Newtype$WithoutValidationOf: 1,
  Lframework_utils_NewtypeBoolean: 1
}));
export { $d_Lframework_data_IsProductionMode$package$IsProductionMode$ as $d_Lframework_data_IsProductionMode$package$IsProductionMode$ };
var $n_Lframework_data_IsProductionMode$package$IsProductionMode$;
function $m_Lframework_data_IsProductionMode$package$IsProductionMode$() {
  if ((!$n_Lframework_data_IsProductionMode$package$IsProductionMode$)) {
    $n_Lframework_data_IsProductionMode$package$IsProductionMode$ = new $c_Lframework_data_IsProductionMode$package$IsProductionMode$();
  }
  return $n_Lframework_data_IsProductionMode$package$IsProductionMode$;
}
export { $m_Lframework_data_IsProductionMode$package$IsProductionMode$ as $m_Lframework_data_IsProductionMode$package$IsProductionMode$ };
/** @constructor */
function $c_Lframework_facades_AbortError$() {
}
export { $c_Lframework_facades_AbortError$ as $c_Lframework_facades_AbortError$ };
$c_Lframework_facades_AbortError$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_facades_AbortError$.prototype.constructor = $c_Lframework_facades_AbortError$;
/** @constructor */
function $h_Lframework_facades_AbortError$() {
}
export { $h_Lframework_facades_AbortError$ as $h_Lframework_facades_AbortError$ };
$h_Lframework_facades_AbortError$.prototype = $c_Lframework_facades_AbortError$.prototype;
$c_Lframework_facades_AbortError$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_facades_AbortError$.prototype.hashCode__I = (function() {
  return 737482968;
});
$c_Lframework_facades_AbortError$.prototype.toString__T = (function() {
  return "AbortError";
});
$c_Lframework_facades_AbortError$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lframework_facades_AbortError$.prototype.productPrefix__T = (function() {
  return "AbortError";
});
$c_Lframework_facades_AbortError$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_facades_AbortError$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_facades_AbortError$.prototype.is__O__Z = (function(any) {
  if ((!(!(any instanceof Object)))) {
    var x = any.name;
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, "AbortError");
  } else {
    return false;
  }
});
$c_Lframework_facades_AbortError$.prototype.unapply__O__s_Option = (function(any) {
  if (this.is__O__Z(any)) {
    var value = $m_Lframework_facades_AbortError$();
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
  } else {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
});
$c_Lframework_facades_AbortError$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lframework_facades_AbortError$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_facades_AbortError$, "framework.facades.AbortError$", ({
  Lframework_facades_AbortError$: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lframework_facades_AbortError$ as $d_Lframework_facades_AbortError$ };
var $n_Lframework_facades_AbortError$;
function $m_Lframework_facades_AbortError$() {
  if ((!$n_Lframework_facades_AbortError$)) {
    $n_Lframework_facades_AbortError$ = new $c_Lframework_facades_AbortError$();
  }
  return $n_Lframework_facades_AbortError$;
}
export { $m_Lframework_facades_AbortError$ as $m_Lframework_facades_AbortError$ };
/** @constructor */
function $c_Lfs2_Pull$Fail(error) {
  this.Lfs2_Pull$Fail__f_error = null;
  this.Lfs2_Pull$Fail__f_error = error;
}
export { $c_Lfs2_Pull$Fail as $c_Lfs2_Pull$Fail };
$c_Lfs2_Pull$Fail.prototype = new $h_Lfs2_Pull$Terminal();
$c_Lfs2_Pull$Fail.prototype.constructor = $c_Lfs2_Pull$Fail;
/** @constructor */
function $h_Lfs2_Pull$Fail() {
}
export { $h_Lfs2_Pull$Fail as $h_Lfs2_Pull$Fail };
$h_Lfs2_Pull$Fail.prototype = $c_Lfs2_Pull$Fail.prototype;
$c_Lfs2_Pull$Fail.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$Fail.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-781652260), true);
});
$c_Lfs2_Pull$Fail.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$Fail)) {
    var x = this.Lfs2_Pull$Fail__f_error;
    var x$2 = x$0.Lfs2_Pull$Fail__f_error;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lfs2_Pull$Fail.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$Fail.prototype.productArity__I = (function() {
  return 1;
});
$c_Lfs2_Pull$Fail.prototype.productPrefix__T = (function() {
  return "Fail";
});
$c_Lfs2_Pull$Fail.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$Fail__f_error;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lfs2_Pull$Fail.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "error";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lfs2_Pull$Fail.prototype.map__F1__Lfs2_Pull = (function(f) {
  return this;
});
function $isArrayOf_Lfs2_Pull$Fail(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Fail)));
}
export { $isArrayOf_Lfs2_Pull$Fail as $isArrayOf_Lfs2_Pull$Fail };
var $d_Lfs2_Pull$Fail = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$Fail, "fs2.Pull$Fail", ({
  Lfs2_Pull$Fail: 1,
  Lfs2_Pull$Terminal: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lfs2_Pull$Fail as $d_Lfs2_Pull$Fail };
/** @constructor */
function $c_Lfs2_Pull$FlatMapOutput(stream, fun) {
  this.Lfs2_Pull$FlatMapOutput__f_stream = null;
  this.Lfs2_Pull$FlatMapOutput__f_fun = null;
  this.Lfs2_Pull$FlatMapOutput__f_stream = stream;
  this.Lfs2_Pull$FlatMapOutput__f_fun = fun;
}
export { $c_Lfs2_Pull$FlatMapOutput as $c_Lfs2_Pull$FlatMapOutput };
$c_Lfs2_Pull$FlatMapOutput.prototype = new $h_Lfs2_Pull$Action();
$c_Lfs2_Pull$FlatMapOutput.prototype.constructor = $c_Lfs2_Pull$FlatMapOutput;
/** @constructor */
function $h_Lfs2_Pull$FlatMapOutput() {
}
export { $h_Lfs2_Pull$FlatMapOutput as $h_Lfs2_Pull$FlatMapOutput };
$h_Lfs2_Pull$FlatMapOutput.prototype = $c_Lfs2_Pull$FlatMapOutput.prototype;
$c_Lfs2_Pull$FlatMapOutput.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$FlatMapOutput.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1428439897, true);
});
$c_Lfs2_Pull$FlatMapOutput.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$FlatMapOutput)) {
    var x = this.Lfs2_Pull$FlatMapOutput__f_stream;
    var x$2 = x$0.Lfs2_Pull$FlatMapOutput__f_stream;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lfs2_Pull$FlatMapOutput__f_fun;
      var x$4 = x$0.Lfs2_Pull$FlatMapOutput__f_fun;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lfs2_Pull$FlatMapOutput.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$FlatMapOutput.prototype.productArity__I = (function() {
  return 2;
});
$c_Lfs2_Pull$FlatMapOutput.prototype.productPrefix__T = (function() {
  return "FlatMapOutput";
});
$c_Lfs2_Pull$FlatMapOutput.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$FlatMapOutput__f_stream;
  }
  if ((n === 1)) {
    return this.Lfs2_Pull$FlatMapOutput__f_fun;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lfs2_Pull$FlatMapOutput.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "stream";
  }
  if ((n === 1)) {
    return "fun";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lfs2_Pull$FlatMapOutput(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$FlatMapOutput)));
}
export { $isArrayOf_Lfs2_Pull$FlatMapOutput as $isArrayOf_Lfs2_Pull$FlatMapOutput };
var $d_Lfs2_Pull$FlatMapOutput = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$FlatMapOutput, "fs2.Pull$FlatMapOutput", ({
  Lfs2_Pull$FlatMapOutput: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lfs2_Pull$FlatMapOutput as $d_Lfs2_Pull$FlatMapOutput };
/** @constructor */
function $c_Lfs2_Pull$InScope(stream, useInterruption) {
  this.Lfs2_Pull$InScope__f_stream = null;
  this.Lfs2_Pull$InScope__f_useInterruption = false;
  this.Lfs2_Pull$InScope__f_stream = stream;
  this.Lfs2_Pull$InScope__f_useInterruption = useInterruption;
}
export { $c_Lfs2_Pull$InScope as $c_Lfs2_Pull$InScope };
$c_Lfs2_Pull$InScope.prototype = new $h_Lfs2_Pull$Action();
$c_Lfs2_Pull$InScope.prototype.constructor = $c_Lfs2_Pull$InScope;
/** @constructor */
function $h_Lfs2_Pull$InScope() {
}
export { $h_Lfs2_Pull$InScope as $h_Lfs2_Pull$InScope };
$h_Lfs2_Pull$InScope.prototype = $c_Lfs2_Pull$InScope.prototype;
$c_Lfs2_Pull$InScope.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$InScope.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, (-702789617));
  var hash$1 = acc;
  var x = this.Lfs2_Pull$InScope__f_stream;
  var data = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data);
  var hash$2 = acc;
  var data$1 = (this.Lfs2_Pull$InScope__f_useInterruption ? 1231 : 1237);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$2, data$1);
  var hash$3 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2);
});
$c_Lfs2_Pull$InScope.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$InScope)) {
    if ((this.Lfs2_Pull$InScope__f_useInterruption === x$0.Lfs2_Pull$InScope__f_useInterruption)) {
      var x = this.Lfs2_Pull$InScope__f_stream;
      var x$2 = x$0.Lfs2_Pull$InScope__f_stream;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lfs2_Pull$InScope.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$InScope.prototype.productArity__I = (function() {
  return 2;
});
$c_Lfs2_Pull$InScope.prototype.productPrefix__T = (function() {
  return "InScope";
});
$c_Lfs2_Pull$InScope.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$InScope__f_stream;
  }
  if ((n === 1)) {
    return this.Lfs2_Pull$InScope__f_useInterruption;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lfs2_Pull$InScope.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "stream";
  }
  if ((n === 1)) {
    return "useInterruption";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lfs2_Pull$InScope(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$InScope)));
}
export { $isArrayOf_Lfs2_Pull$InScope as $isArrayOf_Lfs2_Pull$InScope };
var $d_Lfs2_Pull$InScope = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$InScope, "fs2.Pull$InScope", ({
  Lfs2_Pull$InScope: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lfs2_Pull$InScope as $d_Lfs2_Pull$InScope };
/** @constructor */
function $c_Lfs2_Pull$Interrupted(context, deferredError) {
  this.Lfs2_Pull$Interrupted__f_context = null;
  this.Lfs2_Pull$Interrupted__f_deferredError = null;
  this.Lfs2_Pull$Interrupted__f_context = context;
  this.Lfs2_Pull$Interrupted__f_deferredError = deferredError;
}
export { $c_Lfs2_Pull$Interrupted as $c_Lfs2_Pull$Interrupted };
$c_Lfs2_Pull$Interrupted.prototype = new $h_Lfs2_Pull$Terminal();
$c_Lfs2_Pull$Interrupted.prototype.constructor = $c_Lfs2_Pull$Interrupted;
/** @constructor */
function $h_Lfs2_Pull$Interrupted() {
}
export { $h_Lfs2_Pull$Interrupted as $h_Lfs2_Pull$Interrupted };
$h_Lfs2_Pull$Interrupted.prototype = $c_Lfs2_Pull$Interrupted.prototype;
$c_Lfs2_Pull$Interrupted.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$Interrupted.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1033946063, true);
});
$c_Lfs2_Pull$Interrupted.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$Interrupted)) {
    var x = this.Lfs2_Pull$Interrupted__f_context;
    var x$2 = x$0.Lfs2_Pull$Interrupted__f_context;
    if ((x === x$2)) {
      var x$3 = this.Lfs2_Pull$Interrupted__f_deferredError;
      var x$4 = x$0.Lfs2_Pull$Interrupted__f_deferredError;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lfs2_Pull$Interrupted.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$Interrupted.prototype.productArity__I = (function() {
  return 2;
});
$c_Lfs2_Pull$Interrupted.prototype.productPrefix__T = (function() {
  return "Interrupted";
});
$c_Lfs2_Pull$Interrupted.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$Interrupted__f_context;
  }
  if ((n === 1)) {
    return this.Lfs2_Pull$Interrupted__f_deferredError;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lfs2_Pull$Interrupted.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "context";
  }
  if ((n === 1)) {
    return "deferredError";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lfs2_Pull$Interrupted.prototype.map__F1__Lfs2_Pull = (function(f) {
  return this;
});
function $isArrayOf_Lfs2_Pull$Interrupted(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Interrupted)));
}
export { $isArrayOf_Lfs2_Pull$Interrupted as $isArrayOf_Lfs2_Pull$Interrupted };
var $d_Lfs2_Pull$Interrupted = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$Interrupted, "fs2.Pull$Interrupted", ({
  Lfs2_Pull$Interrupted: 1,
  Lfs2_Pull$Terminal: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lfs2_Pull$Interrupted as $d_Lfs2_Pull$Interrupted };
/** @constructor */
function $c_Lfs2_Pull$Output(values) {
  this.Lfs2_Pull$Output__f_values = null;
  this.Lfs2_Pull$Output__f_values = values;
}
export { $c_Lfs2_Pull$Output as $c_Lfs2_Pull$Output };
$c_Lfs2_Pull$Output.prototype = new $h_Lfs2_Pull$Action();
$c_Lfs2_Pull$Output.prototype.constructor = $c_Lfs2_Pull$Output;
/** @constructor */
function $h_Lfs2_Pull$Output() {
}
export { $h_Lfs2_Pull$Output as $h_Lfs2_Pull$Output };
$h_Lfs2_Pull$Output.prototype = $c_Lfs2_Pull$Output.prototype;
$c_Lfs2_Pull$Output.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$Output.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 2068668084, true);
});
$c_Lfs2_Pull$Output.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$Output)) {
    var x = this.Lfs2_Pull$Output__f_values;
    var x$2 = x$0.Lfs2_Pull$Output__f_values;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lfs2_Pull$Output.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$Output.prototype.productArity__I = (function() {
  return 1;
});
$c_Lfs2_Pull$Output.prototype.productPrefix__T = (function() {
  return "Output";
});
$c_Lfs2_Pull$Output.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$Output__f_values;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lfs2_Pull$Output.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "values";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lfs2_Pull$Output(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Output)));
}
export { $isArrayOf_Lfs2_Pull$Output as $isArrayOf_Lfs2_Pull$Output };
var $d_Lfs2_Pull$Output = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$Output, "fs2.Pull$Output", ({
  Lfs2_Pull$Output: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lfs2_Pull$Output as $d_Lfs2_Pull$Output };
function $isArrayOf_Lfs2_Pull$StepLeg(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$StepLeg)));
}
export { $isArrayOf_Lfs2_Pull$StepLeg as $isArrayOf_Lfs2_Pull$StepLeg };
/** @constructor */
function $c_Lfs2_Pull$Succeeded(r) {
  this.Lfs2_Pull$Succeeded__f_r = null;
  this.Lfs2_Pull$Succeeded__f_r = r;
}
export { $c_Lfs2_Pull$Succeeded as $c_Lfs2_Pull$Succeeded };
$c_Lfs2_Pull$Succeeded.prototype = new $h_Lfs2_Pull$Terminal();
$c_Lfs2_Pull$Succeeded.prototype.constructor = $c_Lfs2_Pull$Succeeded;
/** @constructor */
function $h_Lfs2_Pull$Succeeded() {
}
export { $h_Lfs2_Pull$Succeeded as $h_Lfs2_Pull$Succeeded };
$h_Lfs2_Pull$Succeeded.prototype = $c_Lfs2_Pull$Succeeded.prototype;
$c_Lfs2_Pull$Succeeded.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$Succeeded.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1822422107), true);
});
$c_Lfs2_Pull$Succeeded.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$Succeeded)) {
    var x = this.Lfs2_Pull$Succeeded__f_r;
    var y = x$0.Lfs2_Pull$Succeeded__f_r;
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lfs2_Pull$Succeeded.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$Succeeded.prototype.productArity__I = (function() {
  return 1;
});
$c_Lfs2_Pull$Succeeded.prototype.productPrefix__T = (function() {
  return "Succeeded";
});
$c_Lfs2_Pull$Succeeded.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$Succeeded__f_r;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lfs2_Pull$Succeeded.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "r";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lfs2_Pull$Succeeded.prototype.map__F1__Lfs2_Pull$Terminal = (function(f) {
  try {
    var r = f.apply__O__O(this.Lfs2_Pull$Succeeded__f_r);
    var $x_1 = new $c_Lfs2_Pull$Succeeded(r);
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
    matchResult19: {
      var $x_1;
      var x83 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
      if ((!x83.isEmpty__Z())) {
        var x84 = x83.get__O();
        var $x_1 = new $c_Lfs2_Pull$Fail(x84);
        break matchResult19;
      }
      throw ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  }
  return $x_1;
});
$c_Lfs2_Pull$Succeeded.prototype.map__F1__Lfs2_Pull = (function(f) {
  return this.map__F1__Lfs2_Pull$Terminal(f);
});
function $isArrayOf_Lfs2_Pull$Succeeded(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Succeeded)));
}
export { $isArrayOf_Lfs2_Pull$Succeeded as $isArrayOf_Lfs2_Pull$Succeeded };
var $d_Lfs2_Pull$Succeeded = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$Succeeded, "fs2.Pull$Succeeded", ({
  Lfs2_Pull$Succeeded: 1,
  Lfs2_Pull$Terminal: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lfs2_Pull$Succeeded as $d_Lfs2_Pull$Succeeded };
/** @constructor */
function $c_Lfs2_Pull$Translate(stream, fk) {
  this.Lfs2_Pull$Translate__f_stream = null;
  this.Lfs2_Pull$Translate__f_fk = null;
  this.Lfs2_Pull$Translate__f_stream = stream;
  this.Lfs2_Pull$Translate__f_fk = fk;
}
export { $c_Lfs2_Pull$Translate as $c_Lfs2_Pull$Translate };
$c_Lfs2_Pull$Translate.prototype = new $h_Lfs2_Pull$Action();
$c_Lfs2_Pull$Translate.prototype.constructor = $c_Lfs2_Pull$Translate;
/** @constructor */
function $h_Lfs2_Pull$Translate() {
}
export { $h_Lfs2_Pull$Translate as $h_Lfs2_Pull$Translate };
$h_Lfs2_Pull$Translate.prototype = $c_Lfs2_Pull$Translate.prototype;
$c_Lfs2_Pull$Translate.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$Translate.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 2007277961, true);
});
$c_Lfs2_Pull$Translate.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$Translate)) {
    var x = this.Lfs2_Pull$Translate__f_stream;
    var x$2 = x$0.Lfs2_Pull$Translate__f_stream;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lfs2_Pull$Translate__f_fk;
      var x$4 = x$0.Lfs2_Pull$Translate__f_fk;
      return (x$3 === x$4);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lfs2_Pull$Translate.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$Translate.prototype.productArity__I = (function() {
  return 2;
});
$c_Lfs2_Pull$Translate.prototype.productPrefix__T = (function() {
  return "Translate";
});
$c_Lfs2_Pull$Translate.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$Translate__f_stream;
  }
  if ((n === 1)) {
    return this.Lfs2_Pull$Translate__f_fk;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lfs2_Pull$Translate.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "stream";
  }
  if ((n === 1)) {
    return "fk";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lfs2_Pull$Translate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Translate)));
}
export { $isArrayOf_Lfs2_Pull$Translate as $isArrayOf_Lfs2_Pull$Translate };
var $d_Lfs2_Pull$Translate = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$Translate, "fs2.Pull$Translate", ({
  Lfs2_Pull$Translate: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lfs2_Pull$Translate as $d_Lfs2_Pull$Translate };
/** @constructor */
function $c_Lfs2_Pull$Uncons(stream) {
  this.Lfs2_Pull$Uncons__f_stream = null;
  this.Lfs2_Pull$Uncons__f_stream = stream;
}
export { $c_Lfs2_Pull$Uncons as $c_Lfs2_Pull$Uncons };
$c_Lfs2_Pull$Uncons.prototype = new $h_Lfs2_Pull$Action();
$c_Lfs2_Pull$Uncons.prototype.constructor = $c_Lfs2_Pull$Uncons;
/** @constructor */
function $h_Lfs2_Pull$Uncons() {
}
export { $h_Lfs2_Pull$Uncons as $h_Lfs2_Pull$Uncons };
$h_Lfs2_Pull$Uncons.prototype = $c_Lfs2_Pull$Uncons.prototype;
$c_Lfs2_Pull$Uncons.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$Uncons.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-2142214375), true);
});
$c_Lfs2_Pull$Uncons.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$Uncons)) {
    var x = this.Lfs2_Pull$Uncons__f_stream;
    var x$2 = x$0.Lfs2_Pull$Uncons__f_stream;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lfs2_Pull$Uncons.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$Uncons.prototype.productArity__I = (function() {
  return 1;
});
$c_Lfs2_Pull$Uncons.prototype.productPrefix__T = (function() {
  return "Uncons";
});
$c_Lfs2_Pull$Uncons.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$Uncons__f_stream;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lfs2_Pull$Uncons.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "stream";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lfs2_Pull$Uncons(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Uncons)));
}
export { $isArrayOf_Lfs2_Pull$Uncons as $isArrayOf_Lfs2_Pull$Uncons };
var $d_Lfs2_Pull$Uncons = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$Uncons, "fs2.Pull$Uncons", ({
  Lfs2_Pull$Uncons: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lfs2_Pull$Uncons as $d_Lfs2_Pull$Uncons };
function $p_Lfs2_concurrent_SignallingRef$$anon$4__getAndDiscreteUpdatesImpl__Lcats_effect_kernel_Resource($thiz) {
  var target = $thiz.Lfs2_concurrent_SignallingRef$$anon$4__f_state$1.get__O();
  var tc = $thiz.Lfs2_concurrent_SignallingRef$$anon$4__f_F$5;
  var this$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s) => {
    var _1 = s.Lfs2_concurrent_SignallingRef$State$1__f_value;
    var _2 = $m_Lfs2_Stream$().bracket__O__F1__Lfs2_Stream($m_Lfs2_concurrent_SignallingRef$().fs2$concurrent$SignallingRef$$$_$newId$1__Lcats_effect_kernel_Ref__O($thiz.Lfs2_concurrent_SignallingRef$$anon$4__f_ids$2), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((id) => {
      var t = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(id);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      return $p_Lfs2_concurrent_SignallingRef$$anon$4__cleanup$1__J__O($thiz, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi));
    }))).flatMap__F1__s_util_NotGiven__Lfs2_Stream(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s$2) => ((_$19) => {
      var t$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(_$19);
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      return $p_Lfs2_concurrent_SignallingRef$$anon$4__go$1__J__J__Lfs2_Stream($thiz, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$1, hi$1), s$2.Lfs2_concurrent_SignallingRef$State$1__f_lastUpdate);
    }))(s)), $m_s_util_NotGiven$().s_util_NotGiven$__f_cachedValue);
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, _2);
  }));
  var fa = this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  return new $c_Lcats_effect_kernel_Resource$Eval(fa);
}
export { $p_Lfs2_concurrent_SignallingRef$$anon$4__getAndDiscreteUpdatesImpl__Lcats_effect_kernel_Resource as $p_Lfs2_concurrent_SignallingRef$$anon$4__getAndDiscreteUpdatesImpl__Lcats_effect_kernel_Resource };
function $p_Lfs2_concurrent_SignallingRef$$anon$4__getNext$1__J__J__O($thiz, lastSeen$1, id$1) {
  var target = $m_Lcats_effect_IO$().deferred__Lcats_effect_IO();
  var tc = $thiz.Lfs2_concurrent_SignallingRef$$anon$4__f_F$5;
  var this$18 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((wait) => $thiz.Lfs2_concurrent_SignallingRef$$anon$4__f_state$1.modify__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((wait$2) => ((x$1) => {
    if ((x$1 !== null)) {
      $m_Lfs2_concurrent_SignallingRef$().fs2$concurrent$SignallingRef$$$_$State$2__sr_LazyRef__Lfs2_concurrent_SignallingRef$State$3$($thiz.Lfs2_concurrent_SignallingRef$$anon$4__f_State$lzy1$5);
      var x25 = x$1.Lfs2_concurrent_SignallingRef$State$1__f_value;
      var t = x$1.Lfs2_concurrent_SignallingRef$State$1__f_lastUpdate;
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var x27 = x$1.Lfs2_concurrent_SignallingRef$State$1__f_listeners;
      if ((!((lo === lastSeen$1.RTLong__f_lo) && (hi === lastSeen$1.RTLong__f_hi)))) {
        var a = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), x25, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi));
        $m_Lcats_effect_IO$();
        var y = new $c_Lcats_effect_IO$Pure(a);
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), x$1, y);
      } else {
        var listeners$1 = x27.updated__J__O__sci_LongMap(id$1, wait$2);
        var value$1 = x$1.Lfs2_concurrent_SignallingRef$State$1__f_value;
        var t$1 = x$1.Lfs2_concurrent_SignallingRef$State$1__f_lastUpdate;
        var lo$1 = t$1.RTLong__f_lo;
        var hi$1 = t$1.RTLong__f_hi;
        var self = new $c_Lfs2_concurrent_SignallingRef$State$1(value$1, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$1, hi$1), listeners$1);
        var y$1 = wait$2.get__Lcats_effect_IO();
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self, y$1);
      }
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  }))(wait)))));
  var ffa = this$18.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$18.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  var F$1 = $thiz.Lfs2_concurrent_SignallingRef$$anon$4__f_F$5;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__flatten__O__O(F$1, ffa);
}
export { $p_Lfs2_concurrent_SignallingRef$$anon$4__getNext$1__J__J__O as $p_Lfs2_concurrent_SignallingRef$$anon$4__getNext$1__J__J__O };
function $p_Lfs2_concurrent_SignallingRef$$anon$4__go$1__J__J__Lfs2_Stream($thiz, id, lastSeen) {
  return $m_Lfs2_Stream$().eval__O__Lfs2_Stream($p_Lfs2_concurrent_SignallingRef$$anon$4__getNext$1__J__J__O($thiz, lastSeen, id)).flatMap__F1__s_util_NotGiven__Lfs2_Stream(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 !== null)) {
      var a = x$1._1__O();
      var t = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(x$1._2__O());
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      return $m_Lfs2_Stream$().emit__O__Lfs2_Stream(a).$plus$plus__F0__Lfs2_Stream(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((lastUpdate$2) => (() => $p_Lfs2_concurrent_SignallingRef$$anon$4__go$1__J__J__Lfs2_Stream($thiz, id, lastUpdate$2)))(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi))));
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  })), $m_s_util_NotGiven$().s_util_NotGiven$__f_cachedValue);
}
export { $p_Lfs2_concurrent_SignallingRef$$anon$4__go$1__J__J__Lfs2_Stream as $p_Lfs2_concurrent_SignallingRef$$anon$4__go$1__J__J__Lfs2_Stream };
function $p_Lfs2_concurrent_SignallingRef$$anon$4__cleanup$1__J__O($thiz, id) {
  return $thiz.Lfs2_concurrent_SignallingRef$$anon$4__f_state$1.update__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s) => {
    var this$1 = s.Lfs2_concurrent_SignallingRef$State$1__f_listeners;
    var listeners$2 = this$1.removed__J__sci_LongMap(id);
    var value$2 = s.Lfs2_concurrent_SignallingRef$State$1__f_value;
    var t = s.Lfs2_concurrent_SignallingRef$State$1__f_lastUpdate;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    return new $c_Lfs2_concurrent_SignallingRef$State$1(value$2, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi), listeners$2);
  })));
}
export { $p_Lfs2_concurrent_SignallingRef$$anon$4__cleanup$1__J__O as $p_Lfs2_concurrent_SignallingRef$$anon$4__cleanup$1__J__O };
/** @constructor */
function $c_Lfs2_concurrent_SignallingRef$$anon$4(state$9, F$14, State$lzy1$6, ids$6) {
  this.Lfs2_concurrent_SignallingRef$$anon$4__f_state$1 = null;
  this.Lfs2_concurrent_SignallingRef$$anon$4__f_F$5 = null;
  this.Lfs2_concurrent_SignallingRef$$anon$4__f_State$lzy1$5 = null;
  this.Lfs2_concurrent_SignallingRef$$anon$4__f_ids$2 = null;
  this.Lfs2_concurrent_SignallingRef$$anon$4__f_state$1 = state$9;
  this.Lfs2_concurrent_SignallingRef$$anon$4__f_F$5 = F$14;
  this.Lfs2_concurrent_SignallingRef$$anon$4__f_State$lzy1$5 = State$lzy1$6;
  this.Lfs2_concurrent_SignallingRef$$anon$4__f_ids$2 = ids$6;
}
export { $c_Lfs2_concurrent_SignallingRef$$anon$4 as $c_Lfs2_concurrent_SignallingRef$$anon$4 };
$c_Lfs2_concurrent_SignallingRef$$anon$4.prototype = new $h_Lfs2_concurrent_SignallingRef();
$c_Lfs2_concurrent_SignallingRef$$anon$4.prototype.constructor = $c_Lfs2_concurrent_SignallingRef$$anon$4;
/** @constructor */
function $h_Lfs2_concurrent_SignallingRef$$anon$4() {
}
export { $h_Lfs2_concurrent_SignallingRef$$anon$4 as $h_Lfs2_concurrent_SignallingRef$$anon$4 };
$h_Lfs2_concurrent_SignallingRef$$anon$4.prototype = $c_Lfs2_concurrent_SignallingRef$$anon$4.prototype;
$c_Lfs2_concurrent_SignallingRef$$anon$4.prototype.get__O = (function() {
  var target = this.Lfs2_concurrent_SignallingRef$$anon$4__f_state$1.get__O();
  var tc = this.Lfs2_concurrent_SignallingRef$$anon$4__f_F$5;
  var this$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$18) => _$18.Lfs2_concurrent_SignallingRef$State$1__f_value));
  return this$2.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.map__O__F1__O(this$2.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
});
$c_Lfs2_concurrent_SignallingRef$$anon$4.prototype.discrete__Lfs2_Stream = (function() {
  return $m_Lfs2_Stream$().resource__Lcats_effect_kernel_Resource__Lcats_effect_kernel_MonadCancel__Lfs2_Stream($p_Lfs2_concurrent_SignallingRef$$anon$4__getAndDiscreteUpdatesImpl__Lcats_effect_kernel_Resource(this), this.Lfs2_concurrent_SignallingRef$$anon$4__f_F$5).flatMap__F1__s_util_NotGiven__Lfs2_Stream(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 !== null)) {
      var a = x$1._1__O();
      var updates = x$1._2__O();
      return $m_Lfs2_Stream$().emit__O__Lfs2_Stream(a).$plus$plus__F0__Lfs2_Stream(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => updates)));
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  })), $m_s_util_NotGiven$().s_util_NotGiven$__f_cachedValue);
});
$c_Lfs2_concurrent_SignallingRef$$anon$4.prototype.update__F1__O = (function(f) {
  return this.modify__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((a) => {
    var _1 = f.apply__O__O(a);
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, (void 0));
  })));
});
$c_Lfs2_concurrent_SignallingRef$$anon$4.prototype.modify__F1__O = (function(f) {
  return this.Lfs2_concurrent_SignallingRef$$anon$4__f_state$1.flatModify__F1__Lcats_effect_kernel_MonadCancel__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$21) => $m_Lfs2_concurrent_SignallingRef$().fs2$concurrent$SignallingRef$$$_$updateAndNotify$1__Lcats_effect_kernel_GenConcurrent__sr_LazyRef__Lfs2_concurrent_SignallingRef$State$1__F1__T2(this.Lfs2_concurrent_SignallingRef$$anon$4__f_F$5, this.Lfs2_concurrent_SignallingRef$$anon$4__f_State$lzy1$5, _$21, f))), this.Lfs2_concurrent_SignallingRef$$anon$4__f_F$5);
});
var $d_Lfs2_concurrent_SignallingRef$$anon$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_concurrent_SignallingRef$$anon$4, "fs2.concurrent.SignallingRef$$anon$4", ({
  Lfs2_concurrent_SignallingRef$$anon$4: 1,
  Lfs2_concurrent_SignallingRef: 1,
  Lcats_effect_kernel_Ref: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_RefSource: 1,
  Lcats_effect_kernel_RefSink: 1,
  Lfs2_concurrent_Signal: 1
}));
export { $d_Lfs2_concurrent_SignallingRef$$anon$4 as $d_Lfs2_concurrent_SignallingRef$$anon$4 };
class $c_Lio_circe_ParsingFailure extends $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lio_circe_Error {
  constructor(message, underlying) {
    super();
    this.Lio_circe_ParsingFailure__f_message = null;
    this.Lio_circe_ParsingFailure__f_underlying = null;
    this.Lio_circe_ParsingFailure__f_message = message;
    this.Lio_circe_ParsingFailure__f_underlying = underlying;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  productIterator__sc_Iterator() {
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
  }
  hashCode__I() {
    var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$();
    return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
  }
  equals__O__Z(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lio_circe_ParsingFailure)) {
      if ((this.Lio_circe_ParsingFailure__f_message === x$0.Lio_circe_ParsingFailure__f_message)) {
        var x = this.Lio_circe_ParsingFailure__f_underlying;
        var x$2 = x$0.Lio_circe_ParsingFailure__f_underlying;
        return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  productArity__I() {
    return 2;
  }
  productPrefix__T() {
    return "ParsingFailure";
  }
  productElement__I__O(n) {
    if ((n === 0)) {
      return this.Lio_circe_ParsingFailure__f_message;
    }
    if ((n === 1)) {
      return this.Lio_circe_ParsingFailure__f_underlying;
    }
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  productElementName__I__T(n) {
    if ((n === 0)) {
      return "message";
    }
    if ((n === 1)) {
      return "underlying";
    }
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  getMessage__T() {
    return this.Lio_circe_ParsingFailure__f_message;
  }
  toString__T() {
    return ("ParsingFailure: " + this.Lio_circe_ParsingFailure__f_message);
  }
}
export { $c_Lio_circe_ParsingFailure as $c_Lio_circe_ParsingFailure };
function $isArrayOf_Lio_circe_ParsingFailure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_ParsingFailure)));
}
export { $isArrayOf_Lio_circe_ParsingFailure as $isArrayOf_Lio_circe_ParsingFailure };
var $d_Lio_circe_ParsingFailure = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_circe_ParsingFailure, "io.circe.ParsingFailure", ({
  Lio_circe_ParsingFailure: 1,
  Lio_circe_Error: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lio_circe_ParsingFailure as $d_Lio_circe_ParsingFailure };
/** @constructor */
function $c_Lio_circe_derivation_ConfiguredEncoder$$anon$3(conf$3, encoders$5, labels$5) {
  this.Lio_circe_derivation_ConfiguredEncoder$$anon$3__f_encoders$6 = null;
  this.Lio_circe_derivation_ConfiguredEncoder$$anon$3__f_labels$6 = null;
  this.Lio_circe_derivation_ConfiguredEncoder$$anon$3__f_io$circe$derivation$ConfiguredEncoder$$conf = null;
  this.Lio_circe_derivation_ConfiguredEncoder$$anon$3__f_elemEncoders$lzy3 = null;
  this.Lio_circe_derivation_ConfiguredEncoder$$anon$3__f_elemEncodersbitmap$3 = false;
  this.Lio_circe_derivation_ConfiguredEncoder$$anon$3__f_elemLabels$lzy3 = null;
  this.Lio_circe_derivation_ConfiguredEncoder$$anon$3__f_elemLabelsbitmap$3 = false;
  this.Lio_circe_derivation_ConfiguredEncoder$$anon$3__f_encoders$6 = encoders$5;
  this.Lio_circe_derivation_ConfiguredEncoder$$anon$3__f_labels$6 = labels$5;
  this.Lio_circe_derivation_ConfiguredEncoder$$anon$3__f_io$circe$derivation$ConfiguredEncoder$$conf = conf$3;
}
export { $c_Lio_circe_derivation_ConfiguredEncoder$$anon$3 as $c_Lio_circe_derivation_ConfiguredEncoder$$anon$3 };
$c_Lio_circe_derivation_ConfiguredEncoder$$anon$3.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_circe_derivation_ConfiguredEncoder$$anon$3.prototype.constructor = $c_Lio_circe_derivation_ConfiguredEncoder$$anon$3;
/** @constructor */
function $h_Lio_circe_derivation_ConfiguredEncoder$$anon$3() {
}
export { $h_Lio_circe_derivation_ConfiguredEncoder$$anon$3 as $h_Lio_circe_derivation_ConfiguredEncoder$$anon$3 };
$h_Lio_circe_derivation_ConfiguredEncoder$$anon$3.prototype = $c_Lio_circe_derivation_ConfiguredEncoder$$anon$3.prototype;
$c_Lio_circe_derivation_ConfiguredEncoder$$anon$3.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$c_Lio_circe_derivation_ConfiguredEncoder$$anon$3.prototype.io$circe$derivation$ConfiguredEncoder$$conf__Lio_circe_derivation_Configuration = (function() {
  return this.Lio_circe_derivation_ConfiguredEncoder$$anon$3__f_io$circe$derivation$ConfiguredEncoder$$conf;
});
$c_Lio_circe_derivation_ConfiguredEncoder$$anon$3.prototype.elemEncoders__sci_List = (function() {
  if ((!this.Lio_circe_derivation_ConfiguredEncoder$$anon$3__f_elemEncodersbitmap$3)) {
    this.Lio_circe_derivation_ConfiguredEncoder$$anon$3__f_elemEncoders$lzy3 = this.Lio_circe_derivation_ConfiguredEncoder$$anon$3__f_encoders$6.apply__O();
    this.Lio_circe_derivation_ConfiguredEncoder$$anon$3__f_elemEncodersbitmap$3 = true;
  }
  return this.Lio_circe_derivation_ConfiguredEncoder$$anon$3__f_elemEncoders$lzy3;
});
$c_Lio_circe_derivation_ConfiguredEncoder$$anon$3.prototype.elemLabels__sci_List = (function() {
  if ((!this.Lio_circe_derivation_ConfiguredEncoder$$anon$3__f_elemLabelsbitmap$3)) {
    this.Lio_circe_derivation_ConfiguredEncoder$$anon$3__f_elemLabels$lzy3 = this.Lio_circe_derivation_ConfiguredEncoder$$anon$3__f_labels$6;
    this.Lio_circe_derivation_ConfiguredEncoder$$anon$3__f_elemLabelsbitmap$3 = true;
  }
  return this.Lio_circe_derivation_ConfiguredEncoder$$anon$3__f_elemLabels$lzy3;
});
$c_Lio_circe_derivation_ConfiguredEncoder$$anon$3.prototype.isSum__Z = (function() {
  return false;
});
$c_Lio_circe_derivation_ConfiguredEncoder$$anon$3.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lio_circe_derivation_ConfiguredEncoder$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_circe_derivation_ConfiguredEncoder$$anon$3, "io.circe.derivation.ConfiguredEncoder$$anon$3", ({
  Lio_circe_derivation_ConfiguredEncoder$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_derivation_ConfiguredEncoder: 1,
  Lio_circe_derivation_SumOrProduct: 1
}));
export { $d_Lio_circe_derivation_ConfiguredEncoder$$anon$3 as $d_Lio_circe_derivation_ConfiguredEncoder$$anon$3 };
function $ct_Ljava_io_PrintStream__Ljava_io_OutputStream__Z__Ljava_nio_charset_Charset__($thiz, _out, autoFlush, charset) {
  $ct_Ljava_io_FilterOutputStream__Ljava_io_OutputStream__($thiz, _out);
  return $thiz;
}
export { $ct_Ljava_io_PrintStream__Ljava_io_OutputStream__Z__Ljava_nio_charset_Charset__ as $ct_Ljava_io_PrintStream__Ljava_io_OutputStream__Z__Ljava_nio_charset_Charset__ };
/** @constructor */
function $c_Ljava_io_PrintStream() {
}
export { $c_Ljava_io_PrintStream as $c_Ljava_io_PrintStream };
$c_Ljava_io_PrintStream.prototype = new $h_Ljava_io_FilterOutputStream();
$c_Ljava_io_PrintStream.prototype.constructor = $c_Ljava_io_PrintStream;
/** @constructor */
function $h_Ljava_io_PrintStream() {
}
export { $h_Ljava_io_PrintStream as $h_Ljava_io_PrintStream };
$h_Ljava_io_PrintStream.prototype = $c_Ljava_io_PrintStream.prototype;
$c_Ljava_io_PrintStream.prototype.println__T__V = (function(s) {
  this.print__T__V(s);
  this.java$lang$JSConsoleBasedPrintStream$$printString__T__V("\n");
});
$c_Ljava_io_PrintStream.prototype.append__jl_CharSequence__Ljava_io_PrintStream = (function(csq) {
  this.print__T__V(((csq === null) ? "null" : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$dp_toString__T(csq)));
  return this;
});
$c_Ljava_io_PrintStream.prototype.append__jl_CharSequence__I__I__Ljava_io_PrintStream = (function(csq, start, end) {
  var csq1 = ((csq === null) ? "null" : csq);
  this.print__T__V($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$dp_toString__T($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$dp_subSequence__I__I__jl_CharSequence(csq1, start, end)));
  return this;
});
$c_Ljava_io_PrintStream.prototype.append__C__Ljava_io_PrintStream = (function(c) {
  this.print__C__V(c);
  return this;
});
$c_Ljava_io_PrintStream.prototype.append__C__jl_Appendable = (function(c) {
  return this.append__C__Ljava_io_PrintStream(c);
});
$c_Ljava_io_PrintStream.prototype.append__jl_CharSequence__I__I__jl_Appendable = (function(csq, start, end) {
  return this.append__jl_CharSequence__I__I__Ljava_io_PrintStream(csq, start, end);
});
$c_Ljava_io_PrintStream.prototype.append__jl_CharSequence__jl_Appendable = (function(csq) {
  return this.append__jl_CharSequence__Ljava_io_PrintStream(csq);
});
function $f_Lmonocle_PLens__getOrModify__O__s_util_Either($thiz, s) {
  var value = $thiz.get__O__O(s);
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value);
}
export { $f_Lmonocle_PLens__getOrModify__O__s_util_Either as $f_Lmonocle_PLens__getOrModify__O__s_util_Either };
/** @constructor */
function $c_Lmonocle_PPrism$$anon$1(other$2, outer) {
  this.Lmonocle_PPrism$$anon$1__f_other$1 = null;
  this.Lmonocle_PPrism$$anon$1__f_$outer = null;
  this.Lmonocle_PPrism$$anon$1__f_other$1 = other$2;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lmonocle_PPrism$$anon$1__f_$outer = outer;
}
export { $c_Lmonocle_PPrism$$anon$1 as $c_Lmonocle_PPrism$$anon$1 };
$c_Lmonocle_PPrism$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lmonocle_PPrism$$anon$1.prototype.constructor = $c_Lmonocle_PPrism$$anon$1;
/** @constructor */
function $h_Lmonocle_PPrism$$anon$1() {
}
export { $h_Lmonocle_PPrism$$anon$1 as $h_Lmonocle_PPrism$$anon$1 };
$h_Lmonocle_PPrism$$anon$1.prototype = $c_Lmonocle_PPrism$$anon$1.prototype;
$c_Lmonocle_PPrism$$anon$1.prototype.modify__F1__F1 = (function(f) {
  return $f_Lmonocle_PPrism__modify__F1__F1(this, f);
});
$c_Lmonocle_PPrism$$anon$1.prototype.replace__O__F1 = (function(b) {
  return $f_Lmonocle_PPrism__replace__O__F1(this, b);
});
$c_Lmonocle_PPrism$$anon$1.prototype.andThen__Lmonocle_PPrism__Lmonocle_PPrism = (function(other) {
  return new $c_Lmonocle_PPrism$$anon$1(other, this);
});
$c_Lmonocle_PPrism$$anon$1.prototype.getOrModify__O__s_util_Either = (function(s) {
  var this$1 = this.Lmonocle_PPrism$$anon$1__f_$outer.getOrModify__O__s_util_Either(s);
  if ((this$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
    var b = this$1.s_util_Right__f_value;
    var eab = this.Lmonocle_PPrism$$anon$1__f_other$1.getOrModify__O__s_util_Either(b);
    if ((eab instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
      var a = eab.s_util_Left__f_value;
      var value = this.Lmonocle_PPrism$$anon$1__f_$outer.replace__O__F1(a).apply__O__O(s);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value);
    }
    if ((eab instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
      var b$1 = eab.s_util_Right__f_value;
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(b$1);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(eab);
  } else {
    return this$1;
  }
});
$c_Lmonocle_PPrism$$anon$1.prototype.reverseGet__O__O = (function(d) {
  return this.Lmonocle_PPrism$$anon$1__f_$outer.reverseGet__O__O(this.Lmonocle_PPrism$$anon$1__f_other$1.reverseGet__O__O(d));
});
var $d_Lmonocle_PPrism$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lmonocle_PPrism$$anon$1, "monocle.PPrism$$anon$1", ({
  Lmonocle_PPrism$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lmonocle_PSetter: 1,
  Lmonocle_Fold: 1,
  Lmonocle_PTraversal: 1,
  Lmonocle_POptional: 1,
  Lmonocle_PPrism: 1
}));
export { $d_Lmonocle_PPrism$$anon$1 as $d_Lmonocle_PPrism$$anon$1 };
/** @constructor */
function $c_Lmonocle_PPrism$$anon$2(_getOrModify$2, _reverseGet$3, outer) {
  this.Lmonocle_PPrism$$anon$2__f__getOrModify$1 = null;
  this.Lmonocle_PPrism$$anon$2__f__reverseGet$1 = null;
  this.Lmonocle_PPrism$$anon$2__f__getOrModify$1 = _getOrModify$2;
  this.Lmonocle_PPrism$$anon$2__f__reverseGet$1 = _reverseGet$3;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lmonocle_PPrism$$anon$2 as $c_Lmonocle_PPrism$$anon$2 };
$c_Lmonocle_PPrism$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lmonocle_PPrism$$anon$2.prototype.constructor = $c_Lmonocle_PPrism$$anon$2;
/** @constructor */
function $h_Lmonocle_PPrism$$anon$2() {
}
export { $h_Lmonocle_PPrism$$anon$2 as $h_Lmonocle_PPrism$$anon$2 };
$h_Lmonocle_PPrism$$anon$2.prototype = $c_Lmonocle_PPrism$$anon$2.prototype;
$c_Lmonocle_PPrism$$anon$2.prototype.modify__F1__F1 = (function(f) {
  return $f_Lmonocle_PPrism__modify__F1__F1(this, f);
});
$c_Lmonocle_PPrism$$anon$2.prototype.replace__O__F1 = (function(b) {
  return $f_Lmonocle_PPrism__replace__O__F1(this, b);
});
$c_Lmonocle_PPrism$$anon$2.prototype.andThen__Lmonocle_PPrism__Lmonocle_PPrism = (function(other) {
  return new $c_Lmonocle_PPrism$$anon$1(other, this);
});
$c_Lmonocle_PPrism$$anon$2.prototype.getOrModify__O__s_util_Either = (function(s) {
  return this.Lmonocle_PPrism$$anon$2__f__getOrModify$1.apply__O__O(s);
});
$c_Lmonocle_PPrism$$anon$2.prototype.reverseGet__O__O = (function(b) {
  return this.Lmonocle_PPrism$$anon$2__f__reverseGet$1.apply__O__O(b);
});
var $d_Lmonocle_PPrism$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lmonocle_PPrism$$anon$2, "monocle.PPrism$$anon$2", ({
  Lmonocle_PPrism$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lmonocle_PSetter: 1,
  Lmonocle_Fold: 1,
  Lmonocle_PTraversal: 1,
  Lmonocle_POptional: 1,
  Lmonocle_PPrism: 1
}));
export { $d_Lmonocle_PPrism$$anon$2 as $d_Lmonocle_PPrism$$anon$2 };
/** @constructor */
function $c_Lmonocle_Prism$$anon$3(_getOption$2, _reverseGet$4, outer) {
  this.Lmonocle_Prism$$anon$3__f__getOption$1 = null;
  this.Lmonocle_Prism$$anon$3__f__reverseGet$2 = null;
  this.Lmonocle_Prism$$anon$3__f__getOption$1 = _getOption$2;
  this.Lmonocle_Prism$$anon$3__f__reverseGet$2 = _reverseGet$4;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lmonocle_Prism$$anon$3 as $c_Lmonocle_Prism$$anon$3 };
$c_Lmonocle_Prism$$anon$3.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lmonocle_Prism$$anon$3.prototype.constructor = $c_Lmonocle_Prism$$anon$3;
/** @constructor */
function $h_Lmonocle_Prism$$anon$3() {
}
export { $h_Lmonocle_Prism$$anon$3 as $h_Lmonocle_Prism$$anon$3 };
$h_Lmonocle_Prism$$anon$3.prototype = $c_Lmonocle_Prism$$anon$3.prototype;
$c_Lmonocle_Prism$$anon$3.prototype.modify__F1__F1 = (function(f) {
  return $f_Lmonocle_PPrism__modify__F1__F1(this, f);
});
$c_Lmonocle_Prism$$anon$3.prototype.replace__O__F1 = (function(b) {
  return $f_Lmonocle_PPrism__replace__O__F1(this, b);
});
$c_Lmonocle_Prism$$anon$3.prototype.andThen__Lmonocle_PPrism__Lmonocle_PPrism = (function(other) {
  return new $c_Lmonocle_PPrism$$anon$1(other, this);
});
$c_Lmonocle_Prism$$anon$3.prototype.getOrModify__O__s_util_Either = (function(s) {
  var this$2 = this.Lmonocle_Prism$$anon$3__f__getOption$1.apply__O__O(s);
  if (this$2.isEmpty__Z()) {
    var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(s);
  } else {
    var x0 = this$2.get__O();
    var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(x0);
  }
  return $x_1;
});
$c_Lmonocle_Prism$$anon$3.prototype.reverseGet__O__O = (function(b) {
  return this.Lmonocle_Prism$$anon$3__f__reverseGet$2.apply__O__O(b);
});
var $d_Lmonocle_Prism$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lmonocle_Prism$$anon$3, "monocle.Prism$$anon$3", ({
  Lmonocle_Prism$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lmonocle_PSetter: 1,
  Lmonocle_Fold: 1,
  Lmonocle_PTraversal: 1,
  Lmonocle_POptional: 1,
  Lmonocle_PPrism: 1
}));
export { $d_Lmonocle_Prism$$anon$3 as $d_Lmonocle_Prism$$anon$3 };
/** @constructor */
function $c_Lmonocle_syntax_AppliedPLens$$anon$1(_value$1, _optic$1, outer) {
  this.Lmonocle_syntax_AppliedPLens$$anon$1__f_value = null;
  this.Lmonocle_syntax_AppliedPLens$$anon$1__f_optic = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lmonocle_syntax_AppliedPLens$$anon$1__f_value = _value$1;
  this.Lmonocle_syntax_AppliedPLens$$anon$1__f_optic = _optic$1;
}
export { $c_Lmonocle_syntax_AppliedPLens$$anon$1 as $c_Lmonocle_syntax_AppliedPLens$$anon$1 };
$c_Lmonocle_syntax_AppliedPLens$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lmonocle_syntax_AppliedPLens$$anon$1.prototype.constructor = $c_Lmonocle_syntax_AppliedPLens$$anon$1;
/** @constructor */
function $h_Lmonocle_syntax_AppliedPLens$$anon$1() {
}
export { $h_Lmonocle_syntax_AppliedPLens$$anon$1 as $h_Lmonocle_syntax_AppliedPLens$$anon$1 };
$h_Lmonocle_syntax_AppliedPLens$$anon$1.prototype = $c_Lmonocle_syntax_AppliedPLens$$anon$1.prototype;
$c_Lmonocle_syntax_AppliedPLens$$anon$1.prototype.value__O = (function() {
  return this.Lmonocle_syntax_AppliedPLens$$anon$1__f_value;
});
$c_Lmonocle_syntax_AppliedPLens$$anon$1.prototype.optic__Lmonocle_PSetter = (function() {
  return this.Lmonocle_syntax_AppliedPLens$$anon$1__f_optic;
});
var $d_Lmonocle_syntax_AppliedPLens$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lmonocle_syntax_AppliedPLens$$anon$1, "monocle.syntax.AppliedPLens$$anon$1", ({
  Lmonocle_syntax_AppliedPLens$$anon$1: 1,
  Lmonocle_syntax_AppliedPSetter: 1,
  Lmonocle_syntax_AppliedFold: 1,
  Lmonocle_syntax_AppliedPTraversal: 1,
  Lmonocle_syntax_AppliedPOptional: 1,
  Lmonocle_syntax_AppliedGetter: 1,
  Lmonocle_syntax_AppliedPLens: 1
}));
export { $d_Lmonocle_syntax_AppliedPLens$$anon$1 as $d_Lmonocle_syntax_AppliedPLens$$anon$1 };
function $f_sc_SortedSetOps__max__s_math_Ordering__O($thiz, ord) {
  if ($thiz.isEmpty__Z()) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_UnsupportedOperationException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_UnsupportedOperationException(), "empty.max");
  } else {
    var x$2 = $thiz.ordering__s_math_Ordering();
    if (((ord === null) ? (x$2 === null) : ord.equals__O__Z(x$2))) {
      return $thiz.last__O();
    } else {
      return (ord.isReverseOf__s_math_Ordering__Z($thiz.ordering__s_math_Ordering()) ? $thiz.head__O() : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__max__s_math_Ordering__O($thiz, ord));
    }
  }
}
export { $f_sc_SortedSetOps__max__s_math_Ordering__O as $f_sc_SortedSetOps__max__s_math_Ordering__O };
function $p_sci_TreeMap$TreeMapBuilder__adder__sci_TreeMap$TreeMapBuilder$adder$($thiz) {
  if (($thiz.sci_TreeMap$TreeMapBuilder__f_adder$module === null)) {
    $p_sci_TreeMap$TreeMapBuilder__adder$lzycompute$1__V($thiz);
  }
  return $thiz.sci_TreeMap$TreeMapBuilder__f_adder$module;
}
export { $p_sci_TreeMap$TreeMapBuilder__adder__sci_TreeMap$TreeMapBuilder$adder$ as $p_sci_TreeMap$TreeMapBuilder__adder__sci_TreeMap$TreeMapBuilder$adder$ };
function $p_sci_TreeMap$TreeMapBuilder__adder$lzycompute$1__V($thiz) {
  if (($thiz.sci_TreeMap$TreeMapBuilder__f_adder$module === null)) {
    $thiz.sci_TreeMap$TreeMapBuilder__f_adder$module = new $c_sci_TreeMap$TreeMapBuilder$adder$($thiz);
  }
}
export { $p_sci_TreeMap$TreeMapBuilder__adder$lzycompute$1__V as $p_sci_TreeMap$TreeMapBuilder__adder$lzycompute$1__V };
/** @constructor */
function $c_sci_TreeMap$TreeMapBuilder(ordering) {
  this.sci_RedBlackTree$Helper__f_ordering = null;
  this.sci_TreeMap$TreeMapBuilder__f_adder$module = null;
  this.sci_TreeMap$TreeMapBuilder__f_scala$collection$immutable$TreeMap$TreeMapBuilder$$tree = null;
  $ct_sci_RedBlackTree$Helper__s_math_Ordering__(this, ordering);
  this.sci_TreeMap$TreeMapBuilder__f_scala$collection$immutable$TreeMap$TreeMapBuilder$$tree = null;
}
export { $c_sci_TreeMap$TreeMapBuilder as $c_sci_TreeMap$TreeMapBuilder };
$c_sci_TreeMap$TreeMapBuilder.prototype = new $h_sci_RedBlackTree$MapHelper();
$c_sci_TreeMap$TreeMapBuilder.prototype.constructor = $c_sci_TreeMap$TreeMapBuilder;
/** @constructor */
function $h_sci_TreeMap$TreeMapBuilder() {
}
export { $h_sci_TreeMap$TreeMapBuilder as $h_sci_TreeMap$TreeMapBuilder };
$h_sci_TreeMap$TreeMapBuilder.prototype = $c_sci_TreeMap$TreeMapBuilder.prototype;
$c_sci_TreeMap$TreeMapBuilder.prototype.sizeHint__I__V = (function(size) {
});
$c_sci_TreeMap$TreeMapBuilder.prototype.addOne__T2__sci_TreeMap$TreeMapBuilder = (function(elem) {
  this.sci_TreeMap$TreeMapBuilder__f_scala$collection$immutable$TreeMap$TreeMapBuilder$$tree = this.mutableUpd__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree(this.sci_TreeMap$TreeMapBuilder__f_scala$collection$immutable$TreeMap$TreeMapBuilder$$tree, elem._1__O(), elem._2__O());
  return this;
});
$c_sci_TreeMap$TreeMapBuilder.prototype.addAll__sc_IterableOnce__sci_TreeMap$TreeMapBuilder = (function(xs) {
  matchEnd5: {
    if ((xs instanceof $c_sci_TreeMap)) {
      var x = xs.sci_TreeMap__f_ordering;
      var x$2 = this.sci_RedBlackTree$Helper__f_ordering;
      if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
        if ((this.sci_TreeMap$TreeMapBuilder__f_scala$collection$immutable$TreeMap$TreeMapBuilder$$tree === null)) {
          this.sci_TreeMap$TreeMapBuilder__f_scala$collection$immutable$TreeMap$TreeMapBuilder$$tree = xs.sci_TreeMap__f_tree;
          break matchEnd5;
        } else {
          this.sci_TreeMap$TreeMapBuilder__f_scala$collection$immutable$TreeMap$TreeMapBuilder$$tree = $m_sci_RedBlackTree$().union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree(this.beforePublish__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeMap$TreeMapBuilder__f_scala$collection$immutable$TreeMap$TreeMapBuilder$$tree), xs.sci_TreeMap__f_tree, this.sci_RedBlackTree$Helper__f_ordering);
          break matchEnd5;
        }
      }
    }
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$is_sc_Map(xs)) {
      $p_sci_TreeMap$TreeMapBuilder__adder__sci_TreeMap$TreeMapBuilder$adder$(this).addForEach__sc_Map__V(xs);
      break matchEnd5;
    }
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs);
  }
  return this;
});
$c_sci_TreeMap$TreeMapBuilder.prototype.result__sci_TreeMap = (function() {
  return $ct_sci_TreeMap__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeMap(), this.beforePublish__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeMap$TreeMapBuilder__f_scala$collection$immutable$TreeMap$TreeMapBuilder$$tree), this.sci_RedBlackTree$Helper__f_ordering);
});
$c_sci_TreeMap$TreeMapBuilder.prototype.result__O = (function() {
  return this.result__sci_TreeMap();
});
$c_sci_TreeMap$TreeMapBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__sci_TreeMap$TreeMapBuilder(elems);
});
$c_sci_TreeMap$TreeMapBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__sci_TreeMap$TreeMapBuilder(elem);
});
var $d_sci_TreeMap$TreeMapBuilder = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sci_TreeMap$TreeMapBuilder, "scala.collection.immutable.TreeMap$TreeMapBuilder", ({
  sci_TreeMap$TreeMapBuilder: 1,
  sci_RedBlackTree$MapHelper: 1,
  sci_RedBlackTree$Helper: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
export { $d_sci_TreeMap$TreeMapBuilder as $d_sci_TreeMap$TreeMapBuilder };
/** @constructor */
function $c_sci_TreeSet$TreeSetBuilder(ordering) {
  this.sci_RedBlackTree$Helper__f_ordering = null;
  this.sci_TreeSet$TreeSetBuilder__f_tree = null;
  $ct_sci_RedBlackTree$Helper__s_math_Ordering__(this, ordering);
  this.sci_TreeSet$TreeSetBuilder__f_tree = null;
}
export { $c_sci_TreeSet$TreeSetBuilder as $c_sci_TreeSet$TreeSetBuilder };
$c_sci_TreeSet$TreeSetBuilder.prototype = new $h_sci_RedBlackTree$SetHelper();
$c_sci_TreeSet$TreeSetBuilder.prototype.constructor = $c_sci_TreeSet$TreeSetBuilder;
/** @constructor */
function $h_sci_TreeSet$TreeSetBuilder() {
}
export { $h_sci_TreeSet$TreeSetBuilder as $h_sci_TreeSet$TreeSetBuilder };
$h_sci_TreeSet$TreeSetBuilder.prototype = $c_sci_TreeSet$TreeSetBuilder.prototype;
$c_sci_TreeSet$TreeSetBuilder.prototype.sizeHint__I__V = (function(size) {
});
$c_sci_TreeSet$TreeSetBuilder.prototype.addOne__O__sci_TreeSet$TreeSetBuilder = (function(elem) {
  this.sci_TreeSet$TreeSetBuilder__f_tree = this.mutableUpd__sci_RedBlackTree$Tree__O__sci_RedBlackTree$Tree(this.sci_TreeSet$TreeSetBuilder__f_tree, elem);
  return this;
});
$c_sci_TreeSet$TreeSetBuilder.prototype.addAll__sc_IterableOnce__sci_TreeSet$TreeSetBuilder = (function(xs) {
  matchEnd5: {
    if ((xs instanceof $c_sci_TreeSet)) {
      var x = xs.sci_TreeSet__f_ordering;
      var x$2 = this.sci_RedBlackTree$Helper__f_ordering;
      if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
        if ((this.sci_TreeSet$TreeSetBuilder__f_tree === null)) {
          this.sci_TreeSet$TreeSetBuilder__f_tree = xs.sci_TreeSet__f_tree;
          break matchEnd5;
        } else {
          this.sci_TreeSet$TreeSetBuilder__f_tree = $m_sci_RedBlackTree$().union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree(this.beforePublish__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeSet$TreeSetBuilder__f_tree), xs.sci_TreeSet__f_tree, this.sci_RedBlackTree$Helper__f_ordering);
          break matchEnd5;
        }
      }
    }
    if ((xs instanceof $c_sci_TreeMap)) {
      var x$3 = xs.sci_TreeMap__f_ordering;
      var x$4 = this.sci_RedBlackTree$Helper__f_ordering;
      if (((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))) {
        if ((this.sci_TreeSet$TreeSetBuilder__f_tree === null)) {
          this.sci_TreeSet$TreeSetBuilder__f_tree = xs.sci_TreeMap__f_tree;
          break matchEnd5;
        } else {
          this.sci_TreeSet$TreeSetBuilder__f_tree = $m_sci_RedBlackTree$().union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree(this.beforePublish__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeSet$TreeSetBuilder__f_tree), xs.sci_TreeMap__f_tree, this.sci_RedBlackTree$Helper__f_ordering);
          break matchEnd5;
        }
      }
    }
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs);
  }
  return this;
});
$c_sci_TreeSet$TreeSetBuilder.prototype.result__sci_TreeSet = (function() {
  return $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), this.beforePublish__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeSet$TreeSetBuilder__f_tree), this.sci_RedBlackTree$Helper__f_ordering);
});
$c_sci_TreeSet$TreeSetBuilder.prototype.result__O = (function() {
  return this.result__sci_TreeSet();
});
$c_sci_TreeSet$TreeSetBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__sci_TreeSet$TreeSetBuilder(elems);
});
$c_sci_TreeSet$TreeSetBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sci_TreeSet$TreeSetBuilder(elem);
});
var $d_sci_TreeSet$TreeSetBuilder = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sci_TreeSet$TreeSetBuilder, "scala.collection.immutable.TreeSet$TreeSetBuilder", ({
  sci_TreeSet$TreeSetBuilder: 1,
  sci_RedBlackTree$SetHelper: 1,
  sci_RedBlackTree$Helper: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
export { $d_sci_TreeSet$TreeSetBuilder as $d_sci_TreeSet$TreeSetBuilder };
class $c_s_concurrent_Future$$anon$1 extends $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_ju_NoSuchElementException {
  constructor(t$2) {
    super();
    var s = ("Future.collect partial function is not defined at: " + t$2);
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true);
  }
  fillInStackTrace__jl_Throwable() {
    return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this);
  }
}
export { $c_s_concurrent_Future$$anon$1 as $c_s_concurrent_Future$$anon$1 };
var $d_s_concurrent_Future$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_s_concurrent_Future$$anon$1, "scala.concurrent.Future$$anon$1", ({
  s_concurrent_Future$$anon$1: 1,
  ju_NoSuchElementException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_util_control_NoStackTrace: 1
}));
export { $d_s_concurrent_Future$$anon$1 as $d_s_concurrent_Future$$anon$1 };
class $c_s_concurrent_Future$$anon$2 extends $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_ju_NoSuchElementException {
  constructor() {
    super();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, "Future.filter predicate is not satisfied", null, true, true);
  }
  fillInStackTrace__jl_Throwable() {
    return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this);
  }
}
export { $c_s_concurrent_Future$$anon$2 as $c_s_concurrent_Future$$anon$2 };
var $d_s_concurrent_Future$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_s_concurrent_Future$$anon$2, "scala.concurrent.Future$$anon$2", ({
  s_concurrent_Future$$anon$2: 1,
  ju_NoSuchElementException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_util_control_NoStackTrace: 1
}));
export { $d_s_concurrent_Future$$anon$2 as $d_s_concurrent_Future$$anon$2 };
class $c_s_concurrent_Future$$anon$3 extends $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_ju_NoSuchElementException {
  constructor() {
    super();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, "Future.failed not completed with a throwable.", null, true, true);
  }
  fillInStackTrace__jl_Throwable() {
    return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this);
  }
}
export { $c_s_concurrent_Future$$anon$3 as $c_s_concurrent_Future$$anon$3 };
var $d_s_concurrent_Future$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_s_concurrent_Future$$anon$3, "scala.concurrent.Future$$anon$3", ({
  s_concurrent_Future$$anon$3: 1,
  ju_NoSuchElementException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_util_control_NoStackTrace: 1
}));
export { $d_s_concurrent_Future$$anon$3 as $d_s_concurrent_Future$$anon$3 };
function $p_s_concurrent_impl_Promise$DefaultPromise__value0__s_util_Try($thiz) {
  var _$this = $thiz;
  while (true) {
    var state = _$this.ju_concurrent_atomic_AtomicReference__f_value;
    if ((state instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Try)) {
      return state;
    } else if ((state instanceof $c_s_concurrent_impl_Promise$Link)) {
      _$this = state.promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this);
    } else {
      return null;
    }
  }
}
export { $p_s_concurrent_impl_Promise$DefaultPromise__value0__s_util_Try as $p_s_concurrent_impl_Promise$DefaultPromise__value0__s_util_Try };
function $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks($thiz, state, callbacks) {
  var _$this = $thiz;
  while (true) {
    if ((state instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Try)) {
      $p_s_concurrent_impl_Promise$DefaultPromise__submitWithValue__s_concurrent_impl_Promise$Callbacks__s_util_Try__V(_$this, callbacks, state);
      return callbacks;
    } else if ($is_s_concurrent_impl_Promise$Callbacks(state)) {
      if (_$this.compareAndSet__O__O__Z(state, ((state !== $m_s_concurrent_impl_Promise$().s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop) ? $p_s_concurrent_impl_Promise$DefaultPromise__concatCallbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(_$this, callbacks, state) : callbacks))) {
        return callbacks;
      } else {
        state = _$this.ju_concurrent_atomic_AtomicReference__f_value;
      }
    } else {
      var p = state.promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this);
      var temp$state$2 = p.ju_concurrent_atomic_AtomicReference__f_value;
      _$this = p;
      state = temp$state$2;
    }
  }
}
export { $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks as $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks };
function $p_s_concurrent_impl_Promise$DefaultPromise__concatCallbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks($thiz, left, right) {
  while (true) {
    if ((left instanceof $c_s_concurrent_impl_Promise$Transformation)) {
      return new $c_s_concurrent_impl_Promise$ManyCallbacks(left, right);
    } else {
      var m = left;
      var temp$left = m.s_concurrent_impl_Promise$ManyCallbacks__f_rest;
      var temp$right = new $c_s_concurrent_impl_Promise$ManyCallbacks(m.s_concurrent_impl_Promise$ManyCallbacks__f_first, right);
      left = temp$left;
      right = temp$right;
    }
  }
}
export { $p_s_concurrent_impl_Promise$DefaultPromise__concatCallbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks as $p_s_concurrent_impl_Promise$DefaultPromise__concatCallbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks };
function $p_s_concurrent_impl_Promise$DefaultPromise__submitWithValue__s_concurrent_impl_Promise$Callbacks__s_util_Try__V($thiz, callbacks, resolved) {
  while (true) {
    if ((callbacks instanceof $c_s_concurrent_impl_Promise$ManyCallbacks)) {
      var m = callbacks;
      m.s_concurrent_impl_Promise$ManyCallbacks__f_first.submitWithValue__s_util_Try__s_concurrent_impl_Promise$Transformation(resolved);
      callbacks = m.s_concurrent_impl_Promise$ManyCallbacks__f_rest;
      continue;
    } else {
      callbacks.submitWithValue__s_util_Try__s_concurrent_impl_Promise$Transformation(resolved);
    }
    return (void 0);
  }
}
export { $p_s_concurrent_impl_Promise$DefaultPromise__submitWithValue__s_concurrent_impl_Promise$Callbacks__s_util_Try__V as $p_s_concurrent_impl_Promise$DefaultPromise__submitWithValue__s_concurrent_impl_Promise$Callbacks__s_util_Try__V };
function $ps_s_concurrent_impl_Promise$DefaultPromise__liftedTree1$1__F2__s_util_Success__s_util_Success__s_util_Try(f$1, x2$1, right$1) {
  try {
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(f$1.apply__O__O__O(x2$1.s_util_Success__f_value, right$1.s_util_Success__f_value));
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  }
}
export { $ps_s_concurrent_impl_Promise$DefaultPromise__liftedTree1$1__F2__s_util_Success__s_util_Success__s_util_Try as $ps_s_concurrent_impl_Promise$DefaultPromise__liftedTree1$1__F2__s_util_Success__s_util_Success__s_util_Try };
function $ps_s_concurrent_impl_Promise$DefaultPromise__liftedTree2$1__F2__s_util_Success__s_util_Success__s_util_Try(f$1, left$1, x2$2) {
  try {
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(f$1.apply__O__O__O(left$1.s_util_Success__f_value, x2$2.s_util_Success__f_value));
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  }
}
export { $ps_s_concurrent_impl_Promise$DefaultPromise__liftedTree2$1__F2__s_util_Success__s_util_Success__s_util_Try as $ps_s_concurrent_impl_Promise$DefaultPromise__liftedTree2$1__F2__s_util_Success__s_util_Success__s_util_Try };
function $ct_s_concurrent_impl_Promise$DefaultPromise__O__($thiz, initial) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_ju_concurrent_atomic_AtomicReference__O__($thiz, initial);
  return $thiz;
}
export { $ct_s_concurrent_impl_Promise$DefaultPromise__O__ as $ct_s_concurrent_impl_Promise$DefaultPromise__O__ };
function $ct_s_concurrent_impl_Promise$DefaultPromise__s_util_Try__($thiz, result) {
  $ct_s_concurrent_impl_Promise$DefaultPromise__O__($thiz, $m_s_concurrent_impl_Promise$().scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try(result));
  return $thiz;
}
export { $ct_s_concurrent_impl_Promise$DefaultPromise__s_util_Try__ as $ct_s_concurrent_impl_Promise$DefaultPromise__s_util_Try__ };
function $ct_s_concurrent_impl_Promise$DefaultPromise__($thiz) {
  $ct_s_concurrent_impl_Promise$DefaultPromise__O__($thiz, $m_s_concurrent_impl_Promise$().s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop);
  return $thiz;
}
export { $ct_s_concurrent_impl_Promise$DefaultPromise__ as $ct_s_concurrent_impl_Promise$DefaultPromise__ };
/** @constructor */
function $c_s_concurrent_impl_Promise$DefaultPromise() {
  this.ju_concurrent_atomic_AtomicReference__f_value = null;
}
export { $c_s_concurrent_impl_Promise$DefaultPromise as $c_s_concurrent_impl_Promise$DefaultPromise };
$c_s_concurrent_impl_Promise$DefaultPromise.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_ju_concurrent_atomic_AtomicReference();
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.constructor = $c_s_concurrent_impl_Promise$DefaultPromise;
/** @constructor */
function $h_s_concurrent_impl_Promise$DefaultPromise() {
}
export { $h_s_concurrent_impl_Promise$DefaultPromise as $h_s_concurrent_impl_Promise$DefaultPromise };
$h_s_concurrent_impl_Promise$DefaultPromise.prototype = $c_s_concurrent_impl_Promise$DefaultPromise.prototype;
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return (this.tryComplete0__O__s_util_Try__Z(this.ju_concurrent_atomic_AtomicReference__f_value, v1), (void 0));
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.compose__F1__F1 = (function(g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_F1__compose__F1__F1(this, g);
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.andThen__F1__F1 = (function(g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_F1__andThen__F1__F1(this, g);
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.transformWith__F1__s_concurrent_ExecutionContext__s_concurrent_Future = (function(f, executor) {
  return $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, this.ju_concurrent_atomic_AtomicReference__f_value, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 4, f, executor));
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.zipWith__s_concurrent_Future__F2__s_concurrent_ExecutionContext__s_concurrent_Future = (function(that, f, executor) {
  var state = this.ju_concurrent_atomic_AtomicReference__f_value;
  if ((state instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Try)) {
    if (state.isFailure__Z()) {
      return this;
    } else {
      var l = state.s_util_Success__f_value;
      return that.map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((r$2$2) => f.apply__O__O__O(l, r$2$2))), executor);
    }
  } else {
    var buffer = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_ju_concurrent_atomic_AtomicReference__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_ju_concurrent_atomic_AtomicReference());
    var zipped = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
    var thisF = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x0$1$2$2) => {
      if ((x0$1$2$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success)) {
        var right = buffer.getAndSet__O__O(x0$1$2$2);
        if ((right !== null)) {
          zipped.tryComplete__s_util_Try__Z($ps_s_concurrent_impl_Promise$DefaultPromise__liftedTree1$1__F2__s_util_Success__s_util_Success__s_util_Try(f, x0$1$2$2, right));
        }
      } else {
        zipped.tryComplete__s_util_Try__Z(x0$1$2$2);
      }
    }));
    var thatF = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x0$2$2$2) => {
      if ((x0$2$2$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success)) {
        var left = buffer.getAndSet__O__O(x0$2$2$2);
        if ((left !== null)) {
          zipped.tryComplete__s_util_Try__Z($ps_s_concurrent_impl_Promise$DefaultPromise__liftedTree2$1__F2__s_util_Success__s_util_Success__s_util_Try(f, left, x0$2$2$2));
        }
      } else {
        zipped.tryComplete__s_util_Try__Z(x0$2$2$2);
      }
    }));
    $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, state, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 6, thisF, executor));
    that.onComplete__F1__s_concurrent_ExecutionContext__V(thatF, executor);
    return zipped;
  }
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.foreach__F1__s_concurrent_ExecutionContext__V = (function(f, executor) {
  var state = this.ju_concurrent_atomic_AtomicReference__f_value;
  if ((!(state instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure))) {
    $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, state, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 5, f, executor));
  }
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.flatMap__F1__s_concurrent_ExecutionContext__s_concurrent_Future = (function(f, executor) {
  var state = this.ju_concurrent_atomic_AtomicReference__f_value;
  return ((!(state instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure)) ? $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, state, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 2, f, executor)) : this);
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.map__F1__s_concurrent_ExecutionContext__s_concurrent_Future = (function(f, executor) {
  var state = this.ju_concurrent_atomic_AtomicReference__f_value;
  return ((!(state instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure)) ? $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, state, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 1, f, executor)) : this);
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.recoverWith__s_PartialFunction__s_concurrent_ExecutionContext__s_concurrent_Future = (function(pf, executor) {
  var state = this.ju_concurrent_atomic_AtomicReference__f_value;
  return ((!(state instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success)) ? $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, state, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 8, pf, executor)) : this);
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.onComplete__F1__s_concurrent_ExecutionContext__V = (function(func, executor) {
  $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, this.ju_concurrent_atomic_AtomicReference__f_value, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 6, func, executor));
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.toString__T = (function() {
  var _$this = this;
  while (true) {
    var state = _$this.ju_concurrent_atomic_AtomicReference__f_value;
    if ((state instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Try)) {
      return (("Future(" + state) + ")");
    } else if ((state instanceof $c_s_concurrent_impl_Promise$Link)) {
      _$this = state.promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this);
    } else {
      return "Future(<not completed>)";
    }
  }
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.isCompleted__Z = (function() {
  return ($p_s_concurrent_impl_Promise$DefaultPromise__value0__s_util_Try(this) !== null);
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.value__s_Option = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Option$().apply__O__s_Option($p_s_concurrent_impl_Promise$DefaultPromise__value0__s_util_Try(this));
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.tryComplete__s_util_Try__Z = (function(value) {
  var state = this.ju_concurrent_atomic_AtomicReference__f_value;
  return ((!(state instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Try)) && this.tryComplete0__O__s_util_Try__Z(state, $m_s_concurrent_impl_Promise$().scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try(value)));
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.tryComplete0__O__s_util_Try__Z = (function(state, resolved) {
  var _$this = this;
  while (true) {
    if ($is_s_concurrent_impl_Promise$Callbacks(state)) {
      if (_$this.compareAndSet__O__O__Z(state, resolved)) {
        if ((state !== $m_s_concurrent_impl_Promise$().s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop)) {
          $p_s_concurrent_impl_Promise$DefaultPromise__submitWithValue__s_concurrent_impl_Promise$Callbacks__s_util_Try__V(_$this, state, resolved);
        }
        return true;
      } else {
        state = _$this.ju_concurrent_atomic_AtomicReference__f_value;
      }
    } else if ((state instanceof $c_s_concurrent_impl_Promise$Link)) {
      var p = state.promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this);
      if ((p !== _$this)) {
        var temp$state$2 = p.ju_concurrent_atomic_AtomicReference__f_value;
        _$this = p;
        state = temp$state$2;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.completeWith__s_concurrent_Future__s_concurrent_impl_Promise$DefaultPromise = (function(other) {
  if ((other !== this)) {
    var state = this.ju_concurrent_atomic_AtomicReference__f_value;
    if ((!(state instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Try))) {
      if ((other instanceof $c_s_concurrent_impl_Promise$DefaultPromise)) {
        var resolved = $p_s_concurrent_impl_Promise$DefaultPromise__value0__s_util_Try(other);
      } else {
        var this$2 = other.value__s_Option();
        var resolved = (this$2.isEmpty__Z() ? null : this$2.get__O());
      }
      if ((resolved !== null)) {
        this.tryComplete0__O__s_util_Try__Z(state, resolved);
      } else {
        other.onComplete__F1__s_concurrent_ExecutionContext__V(this, $m_s_concurrent_ExecutionContext$parasitic$());
      }
    }
  }
  return this;
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.linkRootOf__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$Link__V = (function(target, link) {
  var _$this = this;
  while (true) {
    if ((_$this !== target)) {
      var state = _$this.ju_concurrent_atomic_AtomicReference__f_value;
      if ((state instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Try)) {
        if ((!target.tryComplete0__O__s_util_Try__Z(target.ju_concurrent_atomic_AtomicReference__f_value, state))) {
          throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalStateException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalStateException(), "Cannot link completed promises together");
        }
      } else if ($is_s_concurrent_impl_Promise$Callbacks(state)) {
        var l = ((link !== null) ? link : new $c_s_concurrent_impl_Promise$Link(target));
        var p = l.promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this);
        if (((_$this !== p) && _$this.compareAndSet__O__O__Z(state, l))) {
          if ((state !== $m_s_concurrent_impl_Promise$().s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop)) {
            $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(p, p.ju_concurrent_atomic_AtomicReference__f_value, state);
          }
        } else {
          target = p;
          link = l;
          continue;
        }
      } else {
        _$this = state.promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this);
        continue;
      }
    }
    break;
  }
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.unlink__s_util_Try__V = (function(resolved) {
  var _$this = this;
  while (true) {
    var state = _$this.ju_concurrent_atomic_AtomicReference__f_value;
    if ((state instanceof $c_s_concurrent_impl_Promise$Link)) {
      var next = (_$this.compareAndSet__O__O__Z(state, resolved) ? state.ju_concurrent_atomic_AtomicReference__f_value : _$this);
      _$this = next;
      continue;
    } else {
      _$this.tryComplete0__O__s_util_Try__Z(state, resolved);
    }
    break;
  }
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.apply__O__O = (function(v1) {
  this.tryComplete0__O__s_util_Try__Z(this.ju_concurrent_atomic_AtomicReference__f_value, v1);
});
function $isArrayOf_s_concurrent_impl_Promise$DefaultPromise(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_impl_Promise$DefaultPromise)));
}
export { $isArrayOf_s_concurrent_impl_Promise$DefaultPromise as $isArrayOf_s_concurrent_impl_Promise$DefaultPromise };
var $d_s_concurrent_impl_Promise$DefaultPromise = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_s_concurrent_impl_Promise$DefaultPromise, "scala.concurrent.impl.Promise$DefaultPromise", ({
  s_concurrent_impl_Promise$DefaultPromise: 1,
  ju_concurrent_atomic_AtomicReference: 1,
  Ljava_io_Serializable: 1,
  s_concurrent_Promise: 1,
  s_concurrent_Future: 1,
  s_concurrent_Awaitable: 1,
  F1: 1
}));
export { $d_s_concurrent_impl_Promise$DefaultPromise as $d_s_concurrent_impl_Promise$DefaultPromise };
/** @constructor */
function $c_sjs_js_IterableOps(self) {
  this.sjs_js_IterableOps__f_scala$scalajs$js$IterableOps$$self = null;
  this.sjs_js_IterableOps__f_scala$scalajs$js$IterableOps$$self = self;
}
export { $c_sjs_js_IterableOps as $c_sjs_js_IterableOps };
$c_sjs_js_IterableOps.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sc_AbstractIterable();
$c_sjs_js_IterableOps.prototype.constructor = $c_sjs_js_IterableOps;
/** @constructor */
function $h_sjs_js_IterableOps() {
}
export { $h_sjs_js_IterableOps as $h_sjs_js_IterableOps };
$h_sjs_js_IterableOps.prototype = $c_sjs_js_IterableOps.prototype;
$c_sjs_js_IterableOps.prototype.iterator__sc_Iterator = (function() {
  var self = this.sjs_js_IterableOps__f_scala$scalajs$js$IterableOps$$self[Symbol.iterator]();
  return new $c_sjs_js_Iterator$WrappedIterator(self);
});
var $d_sjs_js_IterableOps = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sjs_js_IterableOps, "scala.scalajs.js.IterableOps", ({
  sjs_js_IterableOps: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1
}));
export { $d_sjs_js_IterableOps as $d_sjs_js_IterableOps };
/** @constructor */
function $c_Lsttp_tapir_EndpointOutput$Void() {
}
export { $c_Lsttp_tapir_EndpointOutput$Void as $c_Lsttp_tapir_EndpointOutput$Void };
$c_Lsttp_tapir_EndpointOutput$Void.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_EndpointOutput$Void.prototype.constructor = $c_Lsttp_tapir_EndpointOutput$Void;
/** @constructor */
function $h_Lsttp_tapir_EndpointOutput$Void() {
}
export { $h_Lsttp_tapir_EndpointOutput$Void as $h_Lsttp_tapir_EndpointOutput$Void };
$h_Lsttp_tapir_EndpointOutput$Void.prototype = $c_Lsttp_tapir_EndpointOutput$Void.prototype;
$c_Lsttp_tapir_EndpointOutput$Void.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_EndpointOutput$Void.prototype.hashCode__I = (function() {
  return 2672052;
});
$c_Lsttp_tapir_EndpointOutput$Void.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || (x$0 instanceof $c_Lsttp_tapir_EndpointOutput$Void));
});
$c_Lsttp_tapir_EndpointOutput$Void.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_EndpointOutput$Void.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_tapir_EndpointOutput$Void.prototype.productPrefix__T = (function() {
  return "Void";
});
$c_Lsttp_tapir_EndpointOutput$Void.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_EndpointOutput$Void.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_EndpointOutput$Void.prototype.and__Lsttp_tapir_EndpointOutput__Lsttp_tapir_typelevel_ParamConcat__Lsttp_tapir_EndpointOutput = (function(other, concat) {
  return other;
});
$c_Lsttp_tapir_EndpointOutput$Void.prototype.map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput = (function(mapping) {
  return new $c_Lsttp_tapir_EndpointOutput$Void();
});
function $isArrayOf_Lsttp_tapir_EndpointOutput$Void(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointOutput$Void)));
}
export { $isArrayOf_Lsttp_tapir_EndpointOutput$Void as $isArrayOf_Lsttp_tapir_EndpointOutput$Void };
var $d_Lsttp_tapir_EndpointOutput$Void = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_EndpointOutput$Void, "sttp.tapir.EndpointOutput$Void", ({
  Lsttp_tapir_EndpointOutput$Void: 1,
  Lsttp_tapir_macros_EndpointTransputMacros: 1,
  Lsttp_tapir_EndpointTransput: 1,
  Lsttp_tapir_EndpointOutput: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_EndpointOutput$Void as $d_Lsttp_tapir_EndpointOutput$Void };
/** @constructor */
function $c_Lsttp_tapir_package$() {
  this.Lsttp_tapir_package$__f_NoTrailingSlash$lzy1 = null;
  this.Lsttp_tapir_package$__f_NoTrailingSlashbitmap$1 = false;
  this.Lsttp_tapir_package$__f_sttp$tapir$Tapir$$emptyIO = null;
  this.Lsttp_tapir_package$__f_emptyOutput = null;
  this.Lsttp_tapir_package$__f_emptyInput = null;
  this.Lsttp_tapir_package$__f_infallibleEndpoint = null;
  this.Lsttp_tapir_package$__f_endpoint = null;
  $n_Lsttp_tapir_package$ = this;
  $f_Lsttp_tapir_TapirComputedInputs__$init$__V(this);
  $f_Lsttp_tapir_Tapir__$init$__V(this);
}
export { $c_Lsttp_tapir_package$ as $c_Lsttp_tapir_package$ };
$c_Lsttp_tapir_package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_package$.prototype.constructor = $c_Lsttp_tapir_package$;
/** @constructor */
function $h_Lsttp_tapir_package$() {
}
export { $h_Lsttp_tapir_package$ as $h_Lsttp_tapir_package$ };
$h_Lsttp_tapir_package$.prototype = $c_Lsttp_tapir_package$.prototype;
$c_Lsttp_tapir_package$.prototype.NoTrailingSlash__Lsttp_tapir_TapirComputedInputs$NoTrailingSlash$ = (function() {
  if ((!this.Lsttp_tapir_package$__f_NoTrailingSlashbitmap$1)) {
    this.Lsttp_tapir_package$__f_NoTrailingSlash$lzy1 = new $c_Lsttp_tapir_TapirComputedInputs$NoTrailingSlash$(this);
    this.Lsttp_tapir_package$__f_NoTrailingSlashbitmap$1 = true;
  }
  return this.Lsttp_tapir_package$__f_NoTrailingSlash$lzy1;
});
$c_Lsttp_tapir_package$.prototype.sttp$tapir$TapirComputedInputs$_setter_$noTrailingSlash_$eq__Lsttp_tapir_EndpointInput__V = (function(x$0) {
});
$c_Lsttp_tapir_package$.prototype.sttp$tapir$Tapir$$emptyIO__Lsttp_tapir_EndpointIO$Empty = (function() {
  return this.Lsttp_tapir_package$__f_sttp$tapir$Tapir$$emptyIO;
});
$c_Lsttp_tapir_package$.prototype.emptyOutput__Lsttp_tapir_EndpointOutput$Atom = (function() {
  return this.Lsttp_tapir_package$__f_emptyOutput;
});
$c_Lsttp_tapir_package$.prototype.emptyInput__Lsttp_tapir_EndpointInput = (function() {
  return this.Lsttp_tapir_package$__f_emptyInput;
});
$c_Lsttp_tapir_package$.prototype.infallibleEndpoint__Lsttp_tapir_Endpoint = (function() {
  return this.Lsttp_tapir_package$__f_infallibleEndpoint;
});
$c_Lsttp_tapir_package$.prototype.sttp$tapir$Tapir$_setter_$htmlBodyUtf8_$eq__Lsttp_tapir_EndpointIO$Body__V = (function(x$0) {
});
$c_Lsttp_tapir_package$.prototype.sttp$tapir$Tapir$_setter_$multipartBody_$eq__Lsttp_tapir_EndpointIO$Body__V = (function(x$0) {
});
$c_Lsttp_tapir_package$.prototype.sttp$tapir$Tapir$_setter_$sttp$tapir$Tapir$$primitiveToBoxedClasses_$eq__sci_Map__V = (function(x$0) {
});
$c_Lsttp_tapir_package$.prototype.sttp$tapir$Tapir$_setter_$sttp$tapir$Tapir$$emptyIO_$eq__Lsttp_tapir_EndpointIO$Empty__V = (function(x$0) {
  this.Lsttp_tapir_package$__f_sttp$tapir$Tapir$$emptyIO = x$0;
});
$c_Lsttp_tapir_package$.prototype.sttp$tapir$Tapir$_setter_$emptyOutput_$eq__Lsttp_tapir_EndpointOutput$Atom__V = (function(x$0) {
  this.Lsttp_tapir_package$__f_emptyOutput = x$0;
});
$c_Lsttp_tapir_package$.prototype.sttp$tapir$Tapir$_setter_$emptyInput_$eq__Lsttp_tapir_EndpointInput__V = (function(x$0) {
  this.Lsttp_tapir_package$__f_emptyInput = x$0;
});
$c_Lsttp_tapir_package$.prototype.sttp$tapir$Tapir$_setter_$emptyAuth_$eq__Lsttp_tapir_EndpointInput$Auth__V = (function(x$0) {
});
$c_Lsttp_tapir_package$.prototype.sttp$tapir$Tapir$_setter_$infallibleEndpoint_$eq__Lsttp_tapir_Endpoint__V = (function(x$0) {
  this.Lsttp_tapir_package$__f_infallibleEndpoint = x$0;
});
$c_Lsttp_tapir_package$.prototype.sttp$tapir$Tapir$_setter_$endpoint_$eq__Lsttp_tapir_Endpoint__V = (function(x$0) {
  this.Lsttp_tapir_package$__f_endpoint = x$0;
});
var $d_Lsttp_tapir_package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_package$, "sttp.tapir.package$", ({
  Lsttp_tapir_package$: 1,
  Lsttp_tapir_TapirExtensions: 1,
  Lsttp_tapir_TapirComputedInputs: 1,
  Lsttp_tapir_static_TapirStaticContentEndpoints: 1,
  Lsttp_tapir_macros_ModifyMacroFunctorSupport: 1,
  Lsttp_tapir_macros_ModifyMacroSupport: 1,
  Lsttp_tapir_Tapir: 1
}));
export { $d_Lsttp_tapir_package$ as $d_Lsttp_tapir_package$ };
var $n_Lsttp_tapir_package$;
function $m_Lsttp_tapir_package$() {
  if ((!$n_Lsttp_tapir_package$)) {
    $n_Lsttp_tapir_package$ = new $c_Lsttp_tapir_package$();
  }
  return $n_Lsttp_tapir_package$;
}
export { $m_Lsttp_tapir_package$ as $m_Lsttp_tapir_package$ };
function $f_Lcats_Traverse__sequence__O__Lcats_Applicative__O($thiz, fga, evidence$1) {
  return $thiz.traverse__O__F1__Lcats_Applicative__O(fga, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((ga) => ga)), evidence$1);
}
export { $f_Lcats_Traverse__sequence__O__Lcats_Applicative__O as $f_Lcats_Traverse__sequence__O__Lcats_Applicative__O };
function $f_Lcats_Traverse__flatSequence__O__Lcats_Applicative__Lcats_FlatMap__O($thiz, fgfa, G, F) {
  return G.map__O__F1__O($f_Lcats_Traverse__sequence__O__Lcats_Applicative__O($thiz, fgfa, G), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((ffa) => F.flatten__O__O(ffa))));
}
export { $f_Lcats_Traverse__flatSequence__O__Lcats_Applicative__Lcats_FlatMap__O as $f_Lcats_Traverse__flatSequence__O__Lcats_Applicative__Lcats_FlatMap__O };
function $f_Lcats_Traverse__traverseWithIndexM__O__F2__Lcats_Monad__O($thiz, fa, f, G) {
  return $thiz.traverse__O__F1__Lcats_Applicative__O(fa, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((a) => {
    var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s) => {
      var s$1 = (s | 0);
      return G.map__O__F1__O(f.apply__O__O__O(a, s$1), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((b) => {
        var _1 = ((1 + s$1) | 0);
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, b);
      })));
    }));
    return $m_Lcats_data_IndexedStateT$().apply__F1__Lcats_Applicative__Lcats_data_IndexedStateT(f$1, G);
  })), new $c_Lcats_data_IndexedStateTInstances2$$anon$7(G)).runA__O__Lcats_FlatMap__O(0, G);
}
export { $f_Lcats_Traverse__traverseWithIndexM__O__F2__Lcats_Monad__O as $f_Lcats_Traverse__traverseWithIndexM__O__F2__Lcats_Monad__O };
/** @constructor */
function $c_Lcats_data_IndexedStateT$() {
}
export { $c_Lcats_data_IndexedStateT$ as $c_Lcats_data_IndexedStateT$ };
$c_Lcats_data_IndexedStateT$.prototype = new $h_Lcats_data_IndexedStateTInstances();
$c_Lcats_data_IndexedStateT$.prototype.constructor = $c_Lcats_data_IndexedStateT$;
/** @constructor */
function $h_Lcats_data_IndexedStateT$() {
}
export { $h_Lcats_data_IndexedStateT$ as $h_Lcats_data_IndexedStateT$ };
$h_Lcats_data_IndexedStateT$.prototype = $c_Lcats_data_IndexedStateT$.prototype;
$c_Lcats_data_IndexedStateT$.prototype.apply__F1__Lcats_Applicative__Lcats_data_IndexedStateT = (function(f, F) {
  return new $c_Lcats_data_IndexedStateT(F.pure__O__O(f));
});
var $d_Lcats_data_IndexedStateT$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_data_IndexedStateT$, "cats.data.IndexedStateT$", ({
  Lcats_data_IndexedStateT$: 1,
  Lcats_data_IndexedStateTInstances: 1,
  Lcats_data_IndexedStateTInstances1: 1,
  Lcats_data_IndexedStateTInstances2: 1,
  Lcats_data_IndexedStateTInstances3: 1,
  Lcats_data_IndexedStateTInstances4: 1,
  Lcats_data_CommonStateTConstructors: 1,
  Lcats_data_CommonStateTConstructors0: 1
}));
export { $d_Lcats_data_IndexedStateT$ as $d_Lcats_data_IndexedStateT$ };
var $n_Lcats_data_IndexedStateT$;
function $m_Lcats_data_IndexedStateT$() {
  if ((!$n_Lcats_data_IndexedStateT$)) {
    $n_Lcats_data_IndexedStateT$ = new $c_Lcats_data_IndexedStateT$();
  }
  return $n_Lcats_data_IndexedStateT$;
}
export { $m_Lcats_data_IndexedStateT$ as $m_Lcats_data_IndexedStateT$ };
/** @constructor */
function $c_Lcats_data_KleisliInstances2() {
}
export { $c_Lcats_data_KleisliInstances2 as $c_Lcats_data_KleisliInstances2 };
$c_Lcats_data_KleisliInstances2.prototype = new $h_Lcats_data_KleisliInstances3();
$c_Lcats_data_KleisliInstances2.prototype.constructor = $c_Lcats_data_KleisliInstances2;
/** @constructor */
function $h_Lcats_data_KleisliInstances2() {
}
export { $h_Lcats_data_KleisliInstances2 as $h_Lcats_data_KleisliInstances2 };
$h_Lcats_data_KleisliInstances2.prototype = $c_Lcats_data_KleisliInstances2.prototype;
/** @constructor */
function $c_Lcats_data_OptionT$() {
}
export { $c_Lcats_data_OptionT$ as $c_Lcats_data_OptionT$ };
$c_Lcats_data_OptionT$.prototype = new $h_Lcats_data_OptionTInstances();
$c_Lcats_data_OptionT$.prototype.constructor = $c_Lcats_data_OptionT$;
/** @constructor */
function $h_Lcats_data_OptionT$() {
}
export { $h_Lcats_data_OptionT$ as $h_Lcats_data_OptionT$ };
$h_Lcats_data_OptionT$.prototype = $c_Lcats_data_OptionT$.prototype;
$c_Lcats_data_OptionT$.prototype.liftF__O__Lcats_Functor__Lcats_data_OptionT = (function(fa, F) {
  var value = F.map__O__F1__O(fa, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$33) => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(_$33))));
  return new $c_Lcats_data_OptionT(value);
});
$c_Lcats_data_OptionT$.prototype.fromProduct__s_Product__Lcats_data_OptionT = (function(x$0) {
  return new $c_Lcats_data_OptionT(x$0.productElement__I__O(0));
});
$c_Lcats_data_OptionT$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lcats_data_OptionT(p);
});
var $d_Lcats_data_OptionT$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_data_OptionT$, "cats.data.OptionT$", ({
  Lcats_data_OptionT$: 1,
  Lcats_data_OptionTInstances: 1,
  Lcats_data_OptionTInstances0: 1,
  Lcats_data_OptionTInstances1: 1,
  Lcats_data_OptionTInstances2: 1,
  Lcats_data_OptionTInstances3: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lcats_data_OptionT$ as $d_Lcats_data_OptionT$ };
var $n_Lcats_data_OptionT$;
function $m_Lcats_data_OptionT$() {
  if ((!$n_Lcats_data_OptionT$)) {
    $n_Lcats_data_OptionT$ = new $c_Lcats_data_OptionT$();
  }
  return $n_Lcats_data_OptionT$;
}
export { $m_Lcats_data_OptionT$ as $m_Lcats_data_OptionT$ };
/** @constructor */
function $c_Lcats_effect_kernel_Resource$ExitCase$Canceled$() {
}
export { $c_Lcats_effect_kernel_Resource$ExitCase$Canceled$ as $c_Lcats_effect_kernel_Resource$ExitCase$Canceled$ };
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype.constructor = $c_Lcats_effect_kernel_Resource$ExitCase$Canceled$;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$ExitCase$Canceled$() {
}
export { $h_Lcats_effect_kernel_Resource$ExitCase$Canceled$ as $h_Lcats_effect_kernel_Resource$ExitCase$Canceled$ };
$h_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype = $c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype;
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype.hashCode__I = (function() {
  return (-58529607);
});
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype.toString__T = (function() {
  return "Canceled";
});
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype.productPrefix__T = (function() {
  return "Canceled";
});
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lcats_effect_kernel_Resource$ExitCase$Canceled$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_kernel_Resource$ExitCase$Canceled$, "cats.effect.kernel.Resource$ExitCase$Canceled$", ({
  Lcats_effect_kernel_Resource$ExitCase$Canceled$: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Resource$ExitCase: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lcats_effect_kernel_Resource$ExitCase$Canceled$ as $d_Lcats_effect_kernel_Resource$ExitCase$Canceled$ };
var $n_Lcats_effect_kernel_Resource$ExitCase$Canceled$;
function $m_Lcats_effect_kernel_Resource$ExitCase$Canceled$() {
  if ((!$n_Lcats_effect_kernel_Resource$ExitCase$Canceled$)) {
    $n_Lcats_effect_kernel_Resource$ExitCase$Canceled$ = new $c_Lcats_effect_kernel_Resource$ExitCase$Canceled$();
  }
  return $n_Lcats_effect_kernel_Resource$ExitCase$Canceled$;
}
export { $m_Lcats_effect_kernel_Resource$ExitCase$Canceled$ as $m_Lcats_effect_kernel_Resource$ExitCase$Canceled$ };
/** @constructor */
function $c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$() {
}
export { $c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$ as $c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$ };
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype.constructor = $c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$ExitCase$Succeeded$() {
}
export { $h_Lcats_effect_kernel_Resource$ExitCase$Succeeded$ as $h_Lcats_effect_kernel_Resource$ExitCase$Succeeded$ };
$h_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype = $c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype;
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype.hashCode__I = (function() {
  return (-1345265087);
});
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype.toString__T = (function() {
  return "Succeeded";
});
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype.productPrefix__T = (function() {
  return "Succeeded";
});
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lcats_effect_kernel_Resource$ExitCase$Succeeded$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$, "cats.effect.kernel.Resource$ExitCase$Succeeded$", ({
  Lcats_effect_kernel_Resource$ExitCase$Succeeded$: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Resource$ExitCase: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lcats_effect_kernel_Resource$ExitCase$Succeeded$ as $d_Lcats_effect_kernel_Resource$ExitCase$Succeeded$ };
var $n_Lcats_effect_kernel_Resource$ExitCase$Succeeded$;
function $m_Lcats_effect_kernel_Resource$ExitCase$Succeeded$() {
  if ((!$n_Lcats_effect_kernel_Resource$ExitCase$Succeeded$)) {
    $n_Lcats_effect_kernel_Resource$ExitCase$Succeeded$ = new $c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$();
  }
  return $n_Lcats_effect_kernel_Resource$ExitCase$Succeeded$;
}
export { $m_Lcats_effect_kernel_Resource$ExitCase$Succeeded$ as $m_Lcats_effect_kernel_Resource$ExitCase$Succeeded$ };
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Nil$2$() {
}
export { $c_Lcats_effect_kernel_Resource$Nil$2$ as $c_Lcats_effect_kernel_Resource$Nil$2$ };
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype.constructor = $c_Lcats_effect_kernel_Resource$Nil$2$;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Nil$2$() {
}
export { $h_Lcats_effect_kernel_Resource$Nil$2$ as $h_Lcats_effect_kernel_Resource$Nil$2$ };
$h_Lcats_effect_kernel_Resource$Nil$2$.prototype = $c_Lcats_effect_kernel_Resource$Nil$2$.prototype;
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype.hashCode__I = (function() {
  return 78321;
});
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype.toString__T = (function() {
  return "Nil";
});
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype.productPrefix__T = (function() {
  return "Nil";
});
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lcats_effect_kernel_Resource$Nil$2$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_kernel_Resource$Nil$2$, "cats.effect.kernel.Resource$Nil$2$", ({
  Lcats_effect_kernel_Resource$Nil$2$: 1,
  Lcats_effect_kernel_Resource$Stack$1: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lcats_effect_kernel_Resource$Nil$2$ as $d_Lcats_effect_kernel_Resource$Nil$2$ };
/** @constructor */
function $c_Lcats_effect_std_Semaphore$impl$Done$() {
}
export { $c_Lcats_effect_std_Semaphore$impl$Done$ as $c_Lcats_effect_std_Semaphore$impl$Done$ };
$c_Lcats_effect_std_Semaphore$impl$Done$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_std_Semaphore$impl$Done$.prototype.constructor = $c_Lcats_effect_std_Semaphore$impl$Done$;
/** @constructor */
function $h_Lcats_effect_std_Semaphore$impl$Done$() {
}
export { $h_Lcats_effect_std_Semaphore$impl$Done$ as $h_Lcats_effect_std_Semaphore$impl$Done$ };
$h_Lcats_effect_std_Semaphore$impl$Done$.prototype = $c_Lcats_effect_std_Semaphore$impl$Done$.prototype;
$c_Lcats_effect_std_Semaphore$impl$Done$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_std_Semaphore$impl$Done$.prototype.hashCode__I = (function() {
  return 2135970;
});
$c_Lcats_effect_std_Semaphore$impl$Done$.prototype.toString__T = (function() {
  return "Done";
});
$c_Lcats_effect_std_Semaphore$impl$Done$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_std_Semaphore$impl$Done$.prototype.productPrefix__T = (function() {
  return "Done";
});
$c_Lcats_effect_std_Semaphore$impl$Done$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_std_Semaphore$impl$Done$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_std_Semaphore$impl$Done$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lcats_effect_std_Semaphore$impl$Done$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_std_Semaphore$impl$Done$, "cats.effect.std.Semaphore$impl$Done$", ({
  Lcats_effect_std_Semaphore$impl$Done$: 1,
  Lcats_effect_std_Semaphore$impl$Action: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lcats_effect_std_Semaphore$impl$Done$ as $d_Lcats_effect_std_Semaphore$impl$Done$ };
/** @constructor */
function $c_Lcats_effect_std_Semaphore$impl$Wait$() {
}
export { $c_Lcats_effect_std_Semaphore$impl$Wait$ as $c_Lcats_effect_std_Semaphore$impl$Wait$ };
$c_Lcats_effect_std_Semaphore$impl$Wait$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_std_Semaphore$impl$Wait$.prototype.constructor = $c_Lcats_effect_std_Semaphore$impl$Wait$;
/** @constructor */
function $h_Lcats_effect_std_Semaphore$impl$Wait$() {
}
export { $h_Lcats_effect_std_Semaphore$impl$Wait$ as $h_Lcats_effect_std_Semaphore$impl$Wait$ };
$h_Lcats_effect_std_Semaphore$impl$Wait$.prototype = $c_Lcats_effect_std_Semaphore$impl$Wait$.prototype;
$c_Lcats_effect_std_Semaphore$impl$Wait$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_std_Semaphore$impl$Wait$.prototype.hashCode__I = (function() {
  return 2688405;
});
$c_Lcats_effect_std_Semaphore$impl$Wait$.prototype.toString__T = (function() {
  return "Wait";
});
$c_Lcats_effect_std_Semaphore$impl$Wait$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_std_Semaphore$impl$Wait$.prototype.productPrefix__T = (function() {
  return "Wait";
});
$c_Lcats_effect_std_Semaphore$impl$Wait$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_std_Semaphore$impl$Wait$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_std_Semaphore$impl$Wait$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lcats_effect_std_Semaphore$impl$Wait$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_std_Semaphore$impl$Wait$, "cats.effect.std.Semaphore$impl$Wait$", ({
  Lcats_effect_std_Semaphore$impl$Wait$: 1,
  Lcats_effect_std_Semaphore$impl$Action: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lcats_effect_std_Semaphore$impl$Wait$ as $d_Lcats_effect_std_Semaphore$impl$Wait$ };
/** @constructor */
function $c_Lcats_instances_InvariantInstances$$anon$11(fa$8, f$4, g$4) {
  this.Lcats_instances_ScalaVersionSpecificNumeric__f_fa = null;
  this.Lcats_instances_ScalaVersionSpecificNumeric__f_f = null;
  this.Lcats_instances_ScalaVersionSpecificNumeric__f_g = null;
  $ct_Lcats_instances_ScalaVersionSpecificNumeric__s_math_Numeric__F1__F1__(this, fa$8, f$4, g$4);
}
export { $c_Lcats_instances_InvariantInstances$$anon$11 as $c_Lcats_instances_InvariantInstances$$anon$11 };
$c_Lcats_instances_InvariantInstances$$anon$11.prototype = new $h_Lcats_instances_ScalaVersionSpecificNumeric();
$c_Lcats_instances_InvariantInstances$$anon$11.prototype.constructor = $c_Lcats_instances_InvariantInstances$$anon$11;
/** @constructor */
function $h_Lcats_instances_InvariantInstances$$anon$11() {
}
export { $h_Lcats_instances_InvariantInstances$$anon$11 as $h_Lcats_instances_InvariantInstances$$anon$11 };
$h_Lcats_instances_InvariantInstances$$anon$11.prototype = $c_Lcats_instances_InvariantInstances$$anon$11.prototype;
var $d_Lcats_instances_InvariantInstances$$anon$11 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_InvariantInstances$$anon$11, "cats.instances.InvariantInstances$$anon$11", ({
  Lcats_instances_InvariantInstances$$anon$11: 1,
  Lcats_instances_ScalaVersionSpecificNumeric: 1,
  ju_Comparator: 1,
  Ljava_io_Serializable: 1,
  s_math_Equiv: 1,
  s_math_PartialOrdering: 1,
  s_math_Ordering: 1,
  s_math_Numeric: 1
}));
export { $d_Lcats_instances_InvariantInstances$$anon$11 as $d_Lcats_instances_InvariantInstances$$anon$11 };
/** @constructor */
function $c_Lcats_kernel_instances_BigDecimalGroup() {
  this.Lcats_kernel_instances_BigDecimalGroup__f_empty = null;
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_package$().BigDecimal__s_math_BigDecimal$();
  this.Lcats_kernel_instances_BigDecimalGroup__f_empty = this$1.apply__I__Ljava_math_MathContext__s_math_BigDecimal(0, this$1.s_math_BigDecimal$__f_defaultMathContext);
}
export { $c_Lcats_kernel_instances_BigDecimalGroup as $c_Lcats_kernel_instances_BigDecimalGroup };
$c_Lcats_kernel_instances_BigDecimalGroup.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_kernel_instances_BigDecimalGroup.prototype.constructor = $c_Lcats_kernel_instances_BigDecimalGroup;
/** @constructor */
function $h_Lcats_kernel_instances_BigDecimalGroup() {
}
export { $h_Lcats_kernel_instances_BigDecimalGroup as $h_Lcats_kernel_instances_BigDecimalGroup };
$h_Lcats_kernel_instances_BigDecimalGroup.prototype = $c_Lcats_kernel_instances_BigDecimalGroup.prototype;
$c_Lcats_kernel_instances_BigDecimalGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_BigDecimalGroup.prototype.combine__s_math_BigDecimal__s_math_BigDecimal__s_math_BigDecimal = (function(x, y) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_math_BigDecimal(x.s_math_BigDecimal__f_bigDecimal.add__Ljava_math_BigDecimal__Ljava_math_BigDecimal(y.s_math_BigDecimal__f_bigDecimal), x.s_math_BigDecimal__f_mc);
});
$c_Lcats_kernel_instances_BigDecimalGroup.prototype.empty__O = (function() {
  return this.Lcats_kernel_instances_BigDecimalGroup__f_empty;
});
$c_Lcats_kernel_instances_BigDecimalGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__s_math_BigDecimal__s_math_BigDecimal__s_math_BigDecimal(x, y);
});
var $d_Lcats_kernel_instances_BigDecimalGroup = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_kernel_instances_BigDecimalGroup, "cats.kernel.instances.BigDecimalGroup", ({
  Lcats_kernel_instances_BigDecimalGroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
}));
export { $d_Lcats_kernel_instances_BigDecimalGroup as $d_Lcats_kernel_instances_BigDecimalGroup };
/** @constructor */
function $c_Lcats_kernel_instances_BigIntGroup() {
  this.Lcats_kernel_instances_BigIntGroup__f_empty = null;
  this.Lcats_kernel_instances_BigIntGroup__f_empty = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_package$().BigInt__s_math_BigInt$().apply__I__s_math_BigInt(0);
}
export { $c_Lcats_kernel_instances_BigIntGroup as $c_Lcats_kernel_instances_BigIntGroup };
$c_Lcats_kernel_instances_BigIntGroup.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_kernel_instances_BigIntGroup.prototype.constructor = $c_Lcats_kernel_instances_BigIntGroup;
/** @constructor */
function $h_Lcats_kernel_instances_BigIntGroup() {
}
export { $h_Lcats_kernel_instances_BigIntGroup as $h_Lcats_kernel_instances_BigIntGroup };
$h_Lcats_kernel_instances_BigIntGroup.prototype = $c_Lcats_kernel_instances_BigIntGroup.prototype;
$c_Lcats_kernel_instances_BigIntGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_BigIntGroup.prototype.empty__O = (function() {
  return this.Lcats_kernel_instances_BigIntGroup__f_empty;
});
$c_Lcats_kernel_instances_BigIntGroup.prototype.combine__O__O__O = (function(x, y) {
  return x.$plus__s_math_BigInt__s_math_BigInt(y);
});
var $d_Lcats_kernel_instances_BigIntGroup = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_kernel_instances_BigIntGroup, "cats.kernel.instances.BigIntGroup", ({
  Lcats_kernel_instances_BigIntGroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
}));
export { $d_Lcats_kernel_instances_BigIntGroup as $d_Lcats_kernel_instances_BigIntGroup };
/** @constructor */
function $c_Lcats_kernel_instances_ByteGroup() {
}
export { $c_Lcats_kernel_instances_ByteGroup as $c_Lcats_kernel_instances_ByteGroup };
$c_Lcats_kernel_instances_ByteGroup.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_kernel_instances_ByteGroup.prototype.constructor = $c_Lcats_kernel_instances_ByteGroup;
/** @constructor */
function $h_Lcats_kernel_instances_ByteGroup() {
}
export { $h_Lcats_kernel_instances_ByteGroup as $h_Lcats_kernel_instances_ByteGroup };
$h_Lcats_kernel_instances_ByteGroup.prototype = $c_Lcats_kernel_instances_ByteGroup.prototype;
$c_Lcats_kernel_instances_ByteGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_ByteGroup.prototype.combine__B__B__B = (function(x, y) {
  return ((((x + y) | 0) << 24) >> 24);
});
$c_Lcats_kernel_instances_ByteGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__B__B__B((x | 0), (y | 0));
});
$c_Lcats_kernel_instances_ByteGroup.prototype.empty__O = (function() {
  return 0;
});
var $d_Lcats_kernel_instances_ByteGroup = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_kernel_instances_ByteGroup, "cats.kernel.instances.ByteGroup", ({
  Lcats_kernel_instances_ByteGroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
}));
export { $d_Lcats_kernel_instances_ByteGroup as $d_Lcats_kernel_instances_ByteGroup };
/** @constructor */
function $c_Lcats_kernel_instances_DoubleGroup() {
}
export { $c_Lcats_kernel_instances_DoubleGroup as $c_Lcats_kernel_instances_DoubleGroup };
$c_Lcats_kernel_instances_DoubleGroup.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_kernel_instances_DoubleGroup.prototype.constructor = $c_Lcats_kernel_instances_DoubleGroup;
/** @constructor */
function $h_Lcats_kernel_instances_DoubleGroup() {
}
export { $h_Lcats_kernel_instances_DoubleGroup as $h_Lcats_kernel_instances_DoubleGroup };
$h_Lcats_kernel_instances_DoubleGroup.prototype = $c_Lcats_kernel_instances_DoubleGroup.prototype;
$c_Lcats_kernel_instances_DoubleGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_DoubleGroup.prototype.combine__D__D__D = (function(x, y) {
  return (x + y);
});
$c_Lcats_kernel_instances_DoubleGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__D__D__D((+x), (+y));
});
$c_Lcats_kernel_instances_DoubleGroup.prototype.empty__O = (function() {
  return 0.0;
});
var $d_Lcats_kernel_instances_DoubleGroup = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_kernel_instances_DoubleGroup, "cats.kernel.instances.DoubleGroup", ({
  Lcats_kernel_instances_DoubleGroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
}));
export { $d_Lcats_kernel_instances_DoubleGroup as $d_Lcats_kernel_instances_DoubleGroup };
/** @constructor */
function $c_Lcats_kernel_instances_DurationGroup() {
}
export { $c_Lcats_kernel_instances_DurationGroup as $c_Lcats_kernel_instances_DurationGroup };
$c_Lcats_kernel_instances_DurationGroup.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_kernel_instances_DurationGroup.prototype.constructor = $c_Lcats_kernel_instances_DurationGroup;
/** @constructor */
function $h_Lcats_kernel_instances_DurationGroup() {
}
export { $h_Lcats_kernel_instances_DurationGroup as $h_Lcats_kernel_instances_DurationGroup };
$h_Lcats_kernel_instances_DurationGroup.prototype = $c_Lcats_kernel_instances_DurationGroup.prototype;
$c_Lcats_kernel_instances_DurationGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_DurationGroup.prototype.empty__O = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Zero;
});
$c_Lcats_kernel_instances_DurationGroup.prototype.combine__O__O__O = (function(x, y) {
  return x.$plus__s_concurrent_duration_Duration__s_concurrent_duration_Duration(y);
});
var $d_Lcats_kernel_instances_DurationGroup = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_kernel_instances_DurationGroup, "cats.kernel.instances.DurationGroup", ({
  Lcats_kernel_instances_DurationGroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
}));
export { $d_Lcats_kernel_instances_DurationGroup as $d_Lcats_kernel_instances_DurationGroup };
/** @constructor */
function $c_Lcats_kernel_instances_FiniteDurationGroup() {
}
export { $c_Lcats_kernel_instances_FiniteDurationGroup as $c_Lcats_kernel_instances_FiniteDurationGroup };
$c_Lcats_kernel_instances_FiniteDurationGroup.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_kernel_instances_FiniteDurationGroup.prototype.constructor = $c_Lcats_kernel_instances_FiniteDurationGroup;
/** @constructor */
function $h_Lcats_kernel_instances_FiniteDurationGroup() {
}
export { $h_Lcats_kernel_instances_FiniteDurationGroup as $h_Lcats_kernel_instances_FiniteDurationGroup };
$h_Lcats_kernel_instances_FiniteDurationGroup.prototype = $c_Lcats_kernel_instances_FiniteDurationGroup.prototype;
$c_Lcats_kernel_instances_FiniteDurationGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_FiniteDurationGroup.prototype.empty__O = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Zero;
});
$c_Lcats_kernel_instances_FiniteDurationGroup.prototype.combine__O__O__O = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$p_s_concurrent_duration_FiniteDuration__add__J__ju_concurrent_TimeUnit__s_concurrent_duration_FiniteDuration(x, y.s_concurrent_duration_FiniteDuration__f_length, y.s_concurrent_duration_FiniteDuration__f_unit);
});
var $d_Lcats_kernel_instances_FiniteDurationGroup = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_kernel_instances_FiniteDurationGroup, "cats.kernel.instances.FiniteDurationGroup", ({
  Lcats_kernel_instances_FiniteDurationGroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
}));
export { $d_Lcats_kernel_instances_FiniteDurationGroup as $d_Lcats_kernel_instances_FiniteDurationGroup };
/** @constructor */
function $c_Lcats_kernel_instances_FloatGroup() {
}
export { $c_Lcats_kernel_instances_FloatGroup as $c_Lcats_kernel_instances_FloatGroup };
$c_Lcats_kernel_instances_FloatGroup.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_kernel_instances_FloatGroup.prototype.constructor = $c_Lcats_kernel_instances_FloatGroup;
/** @constructor */
function $h_Lcats_kernel_instances_FloatGroup() {
}
export { $h_Lcats_kernel_instances_FloatGroup as $h_Lcats_kernel_instances_FloatGroup };
$h_Lcats_kernel_instances_FloatGroup.prototype = $c_Lcats_kernel_instances_FloatGroup.prototype;
$c_Lcats_kernel_instances_FloatGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_FloatGroup.prototype.combine__F__F__F = (function(x, y) {
  return Math.fround((x + y));
});
$c_Lcats_kernel_instances_FloatGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__F__F__F(Math.fround(x), Math.fround(y));
});
$c_Lcats_kernel_instances_FloatGroup.prototype.empty__O = (function() {
  return 0.0;
});
var $d_Lcats_kernel_instances_FloatGroup = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_kernel_instances_FloatGroup, "cats.kernel.instances.FloatGroup", ({
  Lcats_kernel_instances_FloatGroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
}));
export { $d_Lcats_kernel_instances_FloatGroup as $d_Lcats_kernel_instances_FloatGroup };
/** @constructor */
function $c_Lcats_kernel_instances_ShortGroup() {
}
export { $c_Lcats_kernel_instances_ShortGroup as $c_Lcats_kernel_instances_ShortGroup };
$c_Lcats_kernel_instances_ShortGroup.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_kernel_instances_ShortGroup.prototype.constructor = $c_Lcats_kernel_instances_ShortGroup;
/** @constructor */
function $h_Lcats_kernel_instances_ShortGroup() {
}
export { $h_Lcats_kernel_instances_ShortGroup as $h_Lcats_kernel_instances_ShortGroup };
$h_Lcats_kernel_instances_ShortGroup.prototype = $c_Lcats_kernel_instances_ShortGroup.prototype;
$c_Lcats_kernel_instances_ShortGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_ShortGroup.prototype.combine__S__S__S = (function(x, y) {
  return ((((x + y) | 0) << 16) >> 16);
});
$c_Lcats_kernel_instances_ShortGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__S__S__S((x | 0), (y | 0));
});
$c_Lcats_kernel_instances_ShortGroup.prototype.empty__O = (function() {
  return 0;
});
var $d_Lcats_kernel_instances_ShortGroup = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_kernel_instances_ShortGroup, "cats.kernel.instances.ShortGroup", ({
  Lcats_kernel_instances_ShortGroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
}));
export { $d_Lcats_kernel_instances_ShortGroup as $d_Lcats_kernel_instances_ShortGroup };
/** @constructor */
function $c_Lfansi_ErrorMode$Sanitize$() {
}
export { $c_Lfansi_ErrorMode$Sanitize$ as $c_Lfansi_ErrorMode$Sanitize$ };
$c_Lfansi_ErrorMode$Sanitize$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfansi_ErrorMode$Sanitize$.prototype.constructor = $c_Lfansi_ErrorMode$Sanitize$;
/** @constructor */
function $h_Lfansi_ErrorMode$Sanitize$() {
}
export { $h_Lfansi_ErrorMode$Sanitize$ as $h_Lfansi_ErrorMode$Sanitize$ };
$h_Lfansi_ErrorMode$Sanitize$.prototype = $c_Lfansi_ErrorMode$Sanitize$.prototype;
$c_Lfansi_ErrorMode$Sanitize$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lfansi_ErrorMode$Sanitize$.prototype.hashCode__I = (function() {
  return 2062617737;
});
$c_Lfansi_ErrorMode$Sanitize$.prototype.toString__T = (function() {
  return "Sanitize";
});
$c_Lfansi_ErrorMode$Sanitize$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lfansi_ErrorMode$Sanitize$.prototype.productPrefix__T = (function() {
  return "Sanitize";
});
$c_Lfansi_ErrorMode$Sanitize$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lfansi_ErrorMode$Sanitize$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lfansi_ErrorMode$Sanitize$.prototype.handle__I__jl_CharSequence__I = (function(sourceIndex, raw) {
  return ((1 + sourceIndex) | 0);
});
$c_Lfansi_ErrorMode$Sanitize$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lfansi_ErrorMode$Sanitize$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfansi_ErrorMode$Sanitize$, "fansi.ErrorMode$Sanitize$", ({
  Lfansi_ErrorMode$Sanitize$: 1,
  Lfansi_ErrorMode: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lfansi_ErrorMode$Sanitize$ as $d_Lfansi_ErrorMode$Sanitize$ };
var $n_Lfansi_ErrorMode$Sanitize$;
function $m_Lfansi_ErrorMode$Sanitize$() {
  if ((!$n_Lfansi_ErrorMode$Sanitize$)) {
    $n_Lfansi_ErrorMode$Sanitize$ = new $c_Lfansi_ErrorMode$Sanitize$();
  }
  return $n_Lfansi_ErrorMode$Sanitize$;
}
export { $m_Lfansi_ErrorMode$Sanitize$ as $m_Lfansi_ErrorMode$Sanitize$ };
/** @constructor */
function $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated(outer, clientData, serverData, maybeRedirectToAfterRegistration) {
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_clientData = null;
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_serverData = null;
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_maybeRedirectToAfterRegistration = null;
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_$outer = null;
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_clientData = clientData;
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_serverData = serverData;
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_maybeRedirectToAfterRegistration = maybeRedirectToAfterRegistration;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_$outer = outer;
}
export { $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated as $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated };
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated.prototype.constructor = $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated;
/** @constructor */
function $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated() {
}
export { $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated as $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated };
$h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated.prototype = $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated.prototype;
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated.prototype.toString__T = (function() {
  return $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__toString__T(this);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-349491939), true);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated) && (x$0.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_$outer === this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_$outer))) {
    var x = this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_clientData;
    var y = x$0.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_clientData;
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_serverData;
      var y$1 = x$0.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_serverData;
      var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y$1);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$2 = this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_maybeRedirectToAfterRegistration;
      var x$2$1 = x$0.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_maybeRedirectToAfterRegistration;
      return ((x$2 === null) ? (x$2$1 === null) : x$2.equals__O__Z(x$2$1));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated.prototype.productArity__I = (function() {
  return 3;
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated.prototype.productPrefix__T = (function() {
  return "Authenticated";
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_clientData;
      break;
    }
    case 1: {
      return this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_serverData;
      break;
    }
    case 2: {
      return this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_maybeRedirectToAfterRegistration;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "clientData";
      break;
    }
    case 1: {
      return "serverData";
      break;
    }
    case 2: {
      return "maybeRedirectToAfterRegistration";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated.prototype.clientData__O = (function() {
  return this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_clientData;
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated.prototype.maybeRedirectToAfterRegistration__s_Option = (function() {
  return this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_maybeRedirectToAfterRegistration;
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated.prototype.copy__O__O__s_Option__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated = (function(clientData, serverData, maybeRedirectToAfterRegistration) {
  return new $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated(this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_$outer, clientData, serverData, maybeRedirectToAfterRegistration);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated.prototype.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth = (function() {
  return this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_$outer.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$__f_$outer;
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated.prototype.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasRespondedState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth = (function() {
  return this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_$outer.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$__f_$outer;
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated.prototype.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasSucceededState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth = (function() {
  return this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_$outer.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$__f_$outer;
});
function $isArrayOf_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated)));
}
export { $isArrayOf_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated as $isArrayOf_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated };
var $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated, "framework.data.AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated", ({
  Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated: 1,
  Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState: 1,
  Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasRespondedState: 1,
  Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasSucceededState: 1,
  Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthServerSideHasRespondedState: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated as $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated };
/** @constructor */
function $c_Lframework_exts_SignalExts$Idle$2$() {
}
export { $c_Lframework_exts_SignalExts$Idle$2$ as $c_Lframework_exts_SignalExts$Idle$2$ };
$c_Lframework_exts_SignalExts$Idle$2$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_exts_SignalExts$Idle$2$.prototype.constructor = $c_Lframework_exts_SignalExts$Idle$2$;
/** @constructor */
function $h_Lframework_exts_SignalExts$Idle$2$() {
}
export { $h_Lframework_exts_SignalExts$Idle$2$ as $h_Lframework_exts_SignalExts$Idle$2$ };
$h_Lframework_exts_SignalExts$Idle$2$.prototype = $c_Lframework_exts_SignalExts$Idle$2$.prototype;
$c_Lframework_exts_SignalExts$Idle$2$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_exts_SignalExts$Idle$2$.prototype.hashCode__I = (function() {
  return 2274292;
});
$c_Lframework_exts_SignalExts$Idle$2$.prototype.toString__T = (function() {
  return "Idle";
});
$c_Lframework_exts_SignalExts$Idle$2$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lframework_exts_SignalExts$Idle$2$.prototype.productPrefix__T = (function() {
  return "Idle";
});
$c_Lframework_exts_SignalExts$Idle$2$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_exts_SignalExts$Idle$2$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_exts_SignalExts$Idle$2$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lframework_exts_SignalExts$Idle$2$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_SignalExts$Idle$2$, "framework.exts.SignalExts$Idle$2$", ({
  Lframework_exts_SignalExts$Idle$2$: 1,
  Lframework_exts_SignalExts$State$1: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lframework_exts_SignalExts$Idle$2$ as $d_Lframework_exts_SignalExts$Idle$2$ };
/** @constructor */
function $c_Lframework_utils_PushNotifications$State$Denied$() {
}
export { $c_Lframework_utils_PushNotifications$State$Denied$ as $c_Lframework_utils_PushNotifications$State$Denied$ };
$c_Lframework_utils_PushNotifications$State$Denied$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_utils_PushNotifications$State$Denied$.prototype.constructor = $c_Lframework_utils_PushNotifications$State$Denied$;
/** @constructor */
function $h_Lframework_utils_PushNotifications$State$Denied$() {
}
export { $h_Lframework_utils_PushNotifications$State$Denied$ as $h_Lframework_utils_PushNotifications$State$Denied$ };
$h_Lframework_utils_PushNotifications$State$Denied$.prototype = $c_Lframework_utils_PushNotifications$State$Denied$.prototype;
$c_Lframework_utils_PushNotifications$State$Denied$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_utils_PushNotifications$State$Denied$.prototype.hashCode__I = (function() {
  return 2043439035;
});
$c_Lframework_utils_PushNotifications$State$Denied$.prototype.toString__T = (function() {
  return "Denied";
});
$c_Lframework_utils_PushNotifications$State$Denied$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lframework_utils_PushNotifications$State$Denied$.prototype.productPrefix__T = (function() {
  return "Denied";
});
$c_Lframework_utils_PushNotifications$State$Denied$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_utils_PushNotifications$State$Denied$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_utils_PushNotifications$State$Denied$.prototype.subscription__s_Option = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
});
$c_Lframework_utils_PushNotifications$State$Denied$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lframework_utils_PushNotifications$State$Denied$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_PushNotifications$State$Denied$, "framework.utils.PushNotifications$State$Denied$", ({
  Lframework_utils_PushNotifications$State$Denied$: 1,
  Lframework_utils_PushNotifications$State: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lframework_utils_PushNotifications$State$Denied$ as $d_Lframework_utils_PushNotifications$State$Denied$ };
var $n_Lframework_utils_PushNotifications$State$Denied$;
function $m_Lframework_utils_PushNotifications$State$Denied$() {
  if ((!$n_Lframework_utils_PushNotifications$State$Denied$)) {
    $n_Lframework_utils_PushNotifications$State$Denied$ = new $c_Lframework_utils_PushNotifications$State$Denied$();
  }
  return $n_Lframework_utils_PushNotifications$State$Denied$;
}
export { $m_Lframework_utils_PushNotifications$State$Denied$ as $m_Lframework_utils_PushNotifications$State$Denied$ };
/** @constructor */
function $c_Lfs2_Chunk$ArraySlice(values, offset, length, ct) {
  this.Lfs2_Chunk$ArraySlice__f_values = null;
  this.Lfs2_Chunk$ArraySlice__f_offset = 0;
  this.Lfs2_Chunk$ArraySlice__f_length = 0;
  this.Lfs2_Chunk$ArraySlice__f_ct = null;
  this.Lfs2_Chunk$ArraySlice__f_values = values;
  this.Lfs2_Chunk$ArraySlice__f_offset = offset;
  this.Lfs2_Chunk$ArraySlice__f_length = length;
  this.Lfs2_Chunk$ArraySlice__f_ct = ct;
  var requirement = (((((offset >= 0) && (offset <= $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_reflect_Array$().getLength__O__I(values))) && (length >= 0)) && (length <= $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_reflect_Array$().getLength__O__I(values))) && (((offset + length) | 0) <= $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_reflect_Array$().getLength__O__I(values)));
  if ((!requirement)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), "requirement failed: ArraySlice out of bounds");
  }
}
export { $c_Lfs2_Chunk$ArraySlice as $c_Lfs2_Chunk$ArraySlice };
$c_Lfs2_Chunk$ArraySlice.prototype = new $h_Lfs2_Chunk();
$c_Lfs2_Chunk$ArraySlice.prototype.constructor = $c_Lfs2_Chunk$ArraySlice;
/** @constructor */
function $h_Lfs2_Chunk$ArraySlice() {
}
export { $h_Lfs2_Chunk$ArraySlice as $h_Lfs2_Chunk$ArraySlice };
$h_Lfs2_Chunk$ArraySlice.prototype = $c_Lfs2_Chunk$ArraySlice.prototype;
$c_Lfs2_Chunk$ArraySlice.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lfs2_Chunk$ArraySlice.prototype.productArity__I = (function() {
  return 3;
});
$c_Lfs2_Chunk$ArraySlice.prototype.productPrefix__T = (function() {
  return "ArraySlice";
});
$c_Lfs2_Chunk$ArraySlice.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lfs2_Chunk$ArraySlice__f_values;
      break;
    }
    case 1: {
      return this.Lfs2_Chunk$ArraySlice__f_offset;
      break;
    }
    case 2: {
      return this.Lfs2_Chunk$ArraySlice__f_length;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lfs2_Chunk$ArraySlice.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "values";
      break;
    }
    case 1: {
      return "offset";
      break;
    }
    case 2: {
      return "length";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lfs2_Chunk$ArraySlice.prototype.size__I = (function() {
  return this.Lfs2_Chunk$ArraySlice__f_length;
});
$c_Lfs2_Chunk$ArraySlice.prototype.apply__I__O = (function(i) {
  if (((i < 0) || (i >= this.Lfs2_Chunk$ArraySlice__f_length))) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException());
  } else {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().array_apply__O__I__O(this.Lfs2_Chunk$ArraySlice__f_values, ((this.Lfs2_Chunk$ArraySlice__f_offset + i) | 0));
  }
});
$c_Lfs2_Chunk$ArraySlice.prototype.splitAtChunk___I__T2 = (function(n) {
  var values = this.Lfs2_Chunk$ArraySlice__f_values;
  var offset = this.Lfs2_Chunk$ArraySlice__f_offset;
  var ct = this.Lfs2_Chunk$ArraySlice__f_ct;
  var self = new $c_Lfs2_Chunk$ArraySlice(values, offset, n, ct);
  var values$1 = this.Lfs2_Chunk$ArraySlice__f_values;
  var offset$1 = ((this.Lfs2_Chunk$ArraySlice__f_offset + n) | 0);
  var length = ((this.Lfs2_Chunk$ArraySlice__f_length - n) | 0);
  var ct$1 = this.Lfs2_Chunk$ArraySlice__f_ct;
  var y = new $c_Lfs2_Chunk$ArraySlice(values$1, offset$1, length, ct$1);
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self, y);
});
$c_Lfs2_Chunk$ArraySlice.prototype.take__I__Lfs2_Chunk = (function(n) {
  if ((n <= 0)) {
    return $m_Lfs2_Chunk$().Lfs2_Chunk$__f_empty_;
  } else if ((n >= this.Lfs2_Chunk$ArraySlice__f_length)) {
    return this;
  } else {
    var values = this.Lfs2_Chunk$ArraySlice__f_values;
    var offset = this.Lfs2_Chunk$ArraySlice__f_offset;
    var ct = this.Lfs2_Chunk$ArraySlice__f_ct;
    return new $c_Lfs2_Chunk$ArraySlice(values, offset, n, ct);
  }
});
var $d_Lfs2_Chunk$ArraySlice = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Chunk$ArraySlice, "fs2.Chunk$ArraySlice", ({
  Lfs2_Chunk$ArraySlice: 1,
  Lfs2_Chunk: 1,
  Ljava_io_Serializable: 1,
  Lfs2_Chunk213And3Compat: 1,
  Lfs2_ChunkPlatform: 1,
  Lfs2_ChunkRuntimePlatform: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lfs2_Chunk$ArraySlice as $d_Lfs2_Chunk$ArraySlice };
/** @constructor */
function $c_Lfs2_Pull$Acquire(resource, release, cancelable) {
  this.Lfs2_Pull$Acquire__f_resource = null;
  this.Lfs2_Pull$Acquire__f_release = null;
  this.Lfs2_Pull$Acquire__f_cancelable = false;
  this.Lfs2_Pull$Acquire__f_resource = resource;
  this.Lfs2_Pull$Acquire__f_release = release;
  this.Lfs2_Pull$Acquire__f_cancelable = cancelable;
}
export { $c_Lfs2_Pull$Acquire as $c_Lfs2_Pull$Acquire };
$c_Lfs2_Pull$Acquire.prototype = new $h_Lfs2_Pull$AlgEffect();
$c_Lfs2_Pull$Acquire.prototype.constructor = $c_Lfs2_Pull$Acquire;
/** @constructor */
function $h_Lfs2_Pull$Acquire() {
}
export { $h_Lfs2_Pull$Acquire as $h_Lfs2_Pull$Acquire };
$h_Lfs2_Pull$Acquire.prototype = $c_Lfs2_Pull$Acquire.prototype;
$c_Lfs2_Pull$Acquire.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$Acquire.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, 500431030);
  var hash$1 = acc;
  var x = this.Lfs2_Pull$Acquire__f_resource;
  var data = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data);
  var hash$2 = acc;
  var x$1 = this.Lfs2_Pull$Acquire__f_release;
  var data$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$1);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$2, data$1);
  var hash$3 = acc;
  var data$2 = (this.Lfs2_Pull$Acquire__f_cancelable ? 1231 : 1237);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$3, data$2);
  var hash$4 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3);
});
$c_Lfs2_Pull$Acquire.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$Acquire)) {
    if ((this.Lfs2_Pull$Acquire__f_cancelable === x$0.Lfs2_Pull$Acquire__f_cancelable)) {
      var x = this.Lfs2_Pull$Acquire__f_resource;
      var y = x$0.Lfs2_Pull$Acquire__f_resource;
      var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$1 = this.Lfs2_Pull$Acquire__f_release;
      var x$2 = x$0.Lfs2_Pull$Acquire__f_release;
      return (x$1 === x$2);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lfs2_Pull$Acquire.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$Acquire.prototype.productArity__I = (function() {
  return 3;
});
$c_Lfs2_Pull$Acquire.prototype.productPrefix__T = (function() {
  return "Acquire";
});
$c_Lfs2_Pull$Acquire.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lfs2_Pull$Acquire__f_resource;
      break;
    }
    case 1: {
      return this.Lfs2_Pull$Acquire__f_release;
      break;
    }
    case 2: {
      return this.Lfs2_Pull$Acquire__f_cancelable;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lfs2_Pull$Acquire.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "resource";
      break;
    }
    case 1: {
      return "release";
      break;
    }
    case 2: {
      return "cancelable";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lfs2_Pull$Acquire(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Acquire)));
}
export { $isArrayOf_Lfs2_Pull$Acquire as $isArrayOf_Lfs2_Pull$Acquire };
var $d_Lfs2_Pull$Acquire = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$Acquire, "fs2.Pull$Acquire", ({
  Lfs2_Pull$Acquire: 1,
  Lfs2_Pull$AlgEffect: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lfs2_Pull$Acquire as $d_Lfs2_Pull$Acquire };
/** @constructor */
function $c_Lfs2_Pull$Eval(value) {
  this.Lfs2_Pull$Eval__f_value = null;
  this.Lfs2_Pull$Eval__f_value = value;
}
export { $c_Lfs2_Pull$Eval as $c_Lfs2_Pull$Eval };
$c_Lfs2_Pull$Eval.prototype = new $h_Lfs2_Pull$AlgEffect();
$c_Lfs2_Pull$Eval.prototype.constructor = $c_Lfs2_Pull$Eval;
/** @constructor */
function $h_Lfs2_Pull$Eval() {
}
export { $h_Lfs2_Pull$Eval as $h_Lfs2_Pull$Eval };
$h_Lfs2_Pull$Eval.prototype = $c_Lfs2_Pull$Eval.prototype;
$c_Lfs2_Pull$Eval.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$Eval.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 446370046, true);
});
$c_Lfs2_Pull$Eval.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$Eval)) {
    var x = this.Lfs2_Pull$Eval__f_value;
    var y = x$0.Lfs2_Pull$Eval__f_value;
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lfs2_Pull$Eval.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$Eval.prototype.productArity__I = (function() {
  return 1;
});
$c_Lfs2_Pull$Eval.prototype.productPrefix__T = (function() {
  return "Eval";
});
$c_Lfs2_Pull$Eval.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$Eval__f_value;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lfs2_Pull$Eval.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lfs2_Pull$Eval(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Eval)));
}
export { $isArrayOf_Lfs2_Pull$Eval as $isArrayOf_Lfs2_Pull$Eval };
var $d_Lfs2_Pull$Eval = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$Eval, "fs2.Pull$Eval", ({
  Lfs2_Pull$Eval: 1,
  Lfs2_Pull$AlgEffect: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lfs2_Pull$Eval as $d_Lfs2_Pull$Eval };
function $isArrayOf_Lfs2_Pull$GetScope(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$GetScope)));
}
export { $isArrayOf_Lfs2_Pull$GetScope as $isArrayOf_Lfs2_Pull$GetScope };
/** @constructor */
function $c_Lfs2_Pull$InterruptWhen(haltOnSignal) {
  this.Lfs2_Pull$InterruptWhen__f_haltOnSignal = null;
  this.Lfs2_Pull$InterruptWhen__f_haltOnSignal = haltOnSignal;
}
export { $c_Lfs2_Pull$InterruptWhen as $c_Lfs2_Pull$InterruptWhen };
$c_Lfs2_Pull$InterruptWhen.prototype = new $h_Lfs2_Pull$AlgEffect();
$c_Lfs2_Pull$InterruptWhen.prototype.constructor = $c_Lfs2_Pull$InterruptWhen;
/** @constructor */
function $h_Lfs2_Pull$InterruptWhen() {
}
export { $h_Lfs2_Pull$InterruptWhen as $h_Lfs2_Pull$InterruptWhen };
$h_Lfs2_Pull$InterruptWhen.prototype = $c_Lfs2_Pull$InterruptWhen.prototype;
$c_Lfs2_Pull$InterruptWhen.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$InterruptWhen.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-2079369075), true);
});
$c_Lfs2_Pull$InterruptWhen.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$InterruptWhen)) {
    var x = this.Lfs2_Pull$InterruptWhen__f_haltOnSignal;
    var y = x$0.Lfs2_Pull$InterruptWhen__f_haltOnSignal;
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lfs2_Pull$InterruptWhen.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$InterruptWhen.prototype.productArity__I = (function() {
  return 1;
});
$c_Lfs2_Pull$InterruptWhen.prototype.productPrefix__T = (function() {
  return "InterruptWhen";
});
$c_Lfs2_Pull$InterruptWhen.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$InterruptWhen__f_haltOnSignal;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lfs2_Pull$InterruptWhen.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "haltOnSignal";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lfs2_Pull$InterruptWhen(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$InterruptWhen)));
}
export { $isArrayOf_Lfs2_Pull$InterruptWhen as $isArrayOf_Lfs2_Pull$InterruptWhen };
var $d_Lfs2_Pull$InterruptWhen = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$InterruptWhen, "fs2.Pull$InterruptWhen", ({
  Lfs2_Pull$InterruptWhen: 1,
  Lfs2_Pull$AlgEffect: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lfs2_Pull$InterruptWhen as $d_Lfs2_Pull$InterruptWhen };
class $c_Lfs2_internal_AcquireAfterScopeClosed$ extends $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable {
  constructor() {
    super();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  productIterator__sc_Iterator() {
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
  }
  hashCode__I() {
    return (-998855110);
  }
  productArity__I() {
    return 0;
  }
  productPrefix__T() {
    return "AcquireAfterScopeClosed";
  }
  productElement__I__O(n) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  productElementName__I__T(n) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  fillInStackTrace__jl_Throwable() {
    return this;
  }
  fromProduct__s_Product__O(p) {
    return this;
  }
}
export { $c_Lfs2_internal_AcquireAfterScopeClosed$ as $c_Lfs2_internal_AcquireAfterScopeClosed$ };
var $d_Lfs2_internal_AcquireAfterScopeClosed$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_internal_AcquireAfterScopeClosed$, "fs2.internal.AcquireAfterScopeClosed$", ({
  Lfs2_internal_AcquireAfterScopeClosed$: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lfs2_internal_AcquireAfterScopeClosed$ as $d_Lfs2_internal_AcquireAfterScopeClosed$ };
var $n_Lfs2_internal_AcquireAfterScopeClosed$;
function $m_Lfs2_internal_AcquireAfterScopeClosed$() {
  if ((!$n_Lfs2_internal_AcquireAfterScopeClosed$)) {
    $n_Lfs2_internal_AcquireAfterScopeClosed$ = new $c_Lfs2_internal_AcquireAfterScopeClosed$();
  }
  return $n_Lfs2_internal_AcquireAfterScopeClosed$;
}
export { $m_Lfs2_internal_AcquireAfterScopeClosed$ as $m_Lfs2_internal_AcquireAfterScopeClosed$ };
function $p_jl_JSConsoleBasedPrintStream__doWriteLine__T__V($thiz, line) {
  if (((typeof console) !== "undefined")) {
    if (($thiz.jl_JSConsoleBasedPrintStream__f_isErr && (!(!(!(!console.error)))))) {
      console.error(line);
    } else {
      console.log(line);
    }
  }
}
export { $p_jl_JSConsoleBasedPrintStream__doWriteLine__T__V as $p_jl_JSConsoleBasedPrintStream__doWriteLine__T__V };
/** @constructor */
function $c_jl_JSConsoleBasedPrintStream(isErr) {
  this.jl_JSConsoleBasedPrintStream__f_isErr = false;
  this.jl_JSConsoleBasedPrintStream__f_buffer = null;
  this.jl_JSConsoleBasedPrintStream__f_isErr = isErr;
  var out = new $c_jl_JSConsoleBasedPrintStream$DummyOutputStream();
  $ct_Ljava_io_PrintStream__Ljava_io_OutputStream__Z__Ljava_nio_charset_Charset__(this, out, false, null);
  this.jl_JSConsoleBasedPrintStream__f_buffer = "";
}
export { $c_jl_JSConsoleBasedPrintStream as $c_jl_JSConsoleBasedPrintStream };
$c_jl_JSConsoleBasedPrintStream.prototype = new $h_Ljava_io_PrintStream();
$c_jl_JSConsoleBasedPrintStream.prototype.constructor = $c_jl_JSConsoleBasedPrintStream;
/** @constructor */
function $h_jl_JSConsoleBasedPrintStream() {
}
export { $h_jl_JSConsoleBasedPrintStream as $h_jl_JSConsoleBasedPrintStream };
$h_jl_JSConsoleBasedPrintStream.prototype = $c_jl_JSConsoleBasedPrintStream.prototype;
$c_jl_JSConsoleBasedPrintStream.prototype.write__I__V = (function(b) {
  this.write__AB__I__I__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_B(new Int8Array([((b << 24) >> 24)])), 0, 1);
});
$c_jl_JSConsoleBasedPrintStream.prototype.write__AB__I__I__V = (function(buf, off, len) {
  if ((((off < 0) || (len < 0)) || (len > ((buf.u.length - off) | 0)))) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException());
  }
  var i = 0;
  while ((i < len)) {
    this.print__C__V((65535 & (255 & buf.u[((i + off) | 0)])));
    i = ((1 + i) | 0);
  }
});
$c_jl_JSConsoleBasedPrintStream.prototype.print__C__V = (function(c) {
  this.java$lang$JSConsoleBasedPrintStream$$printString__T__V(("" + $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$cToS(c)));
});
$c_jl_JSConsoleBasedPrintStream.prototype.print__T__V = (function(s) {
  this.java$lang$JSConsoleBasedPrintStream$$printString__T__V(((s === null) ? "null" : s));
});
$c_jl_JSConsoleBasedPrintStream.prototype.java$lang$JSConsoleBasedPrintStream$$printString__T__V = (function(s) {
  var rest = s;
  while ((rest !== "")) {
    var this$1 = rest;
    var nlPos = (this$1.indexOf("\n") | 0);
    if ((nlPos < 0)) {
      this.jl_JSConsoleBasedPrintStream__f_buffer = (("" + this.jl_JSConsoleBasedPrintStream__f_buffer) + rest);
      rest = "";
    } else {
      var $x_1 = this.jl_JSConsoleBasedPrintStream__f_buffer;
      var this$2 = rest;
      $p_jl_JSConsoleBasedPrintStream__doWriteLine__T__V(this, (("" + $x_1) + this$2.substring(0, nlPos)));
      this.jl_JSConsoleBasedPrintStream__f_buffer = "";
      var this$3 = rest;
      var beginIndex = ((1 + nlPos) | 0);
      rest = this$3.substring(beginIndex);
    }
  }
});
var $d_jl_JSConsoleBasedPrintStream = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_jl_JSConsoleBasedPrintStream, "java.lang.JSConsoleBasedPrintStream", ({
  jl_JSConsoleBasedPrintStream: 1,
  Ljava_io_PrintStream: 1,
  Ljava_io_FilterOutputStream: 1,
  Ljava_io_OutputStream: 1,
  Ljava_io_Closeable: 1,
  jl_AutoCloseable: 1,
  Ljava_io_Flushable: 1,
  jl_Appendable: 1
}));
export { $d_jl_JSConsoleBasedPrintStream as $d_jl_JSConsoleBasedPrintStream };
/** @constructor */
function $c_Lmonocle_PLens$$anon$1(other$5, outer) {
  this.Lmonocle_PLens$$anon$1__f_other$4 = null;
  this.Lmonocle_PLens$$anon$1__f_$outer = null;
  this.Lmonocle_PLens$$anon$1__f_other$4 = other$5;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lmonocle_PLens$$anon$1__f_$outer = outer;
}
export { $c_Lmonocle_PLens$$anon$1 as $c_Lmonocle_PLens$$anon$1 };
$c_Lmonocle_PLens$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lmonocle_PLens$$anon$1.prototype.constructor = $c_Lmonocle_PLens$$anon$1;
/** @constructor */
function $h_Lmonocle_PLens$$anon$1() {
}
export { $h_Lmonocle_PLens$$anon$1 as $h_Lmonocle_PLens$$anon$1 };
$h_Lmonocle_PLens$$anon$1.prototype = $c_Lmonocle_PLens$$anon$1.prototype;
$c_Lmonocle_PLens$$anon$1.prototype.andThen__Lmonocle_POptional__Lmonocle_POptional = (function(other) {
  return new $c_Lmonocle_POptional$$anon$1(other, this);
});
$c_Lmonocle_PLens$$anon$1.prototype.get__O__O = (function(s) {
  return this.Lmonocle_PLens$$anon$1__f_other$4.get__O__O(this.Lmonocle_PLens$$anon$1__f_$outer.get__O__O(s));
});
$c_Lmonocle_PLens$$anon$1.prototype.replace__O__F1 = (function(d) {
  return this.Lmonocle_PLens$$anon$1__f_$outer.modify__F1__F1(this.Lmonocle_PLens$$anon$1__f_other$4.replace__O__F1(d));
});
$c_Lmonocle_PLens$$anon$1.prototype.modify__F1__F1 = (function(f) {
  return this.Lmonocle_PLens$$anon$1__f_$outer.modify__F1__F1(this.Lmonocle_PLens$$anon$1__f_other$4.modify__F1__F1(f));
});
var $d_Lmonocle_PLens$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lmonocle_PLens$$anon$1, "monocle.PLens$$anon$1", ({
  Lmonocle_PLens$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lmonocle_PSetter: 1,
  Lmonocle_Fold: 1,
  Lmonocle_PTraversal: 1,
  Lmonocle_POptional: 1,
  Lmonocle_Getter: 1,
  Lmonocle_PLens: 1
}));
export { $d_Lmonocle_PLens$$anon$1 as $d_Lmonocle_PLens$$anon$1 };
/** @constructor */
function $c_Lmonocle_PLens$$anon$2(_get$2, _set$2, outer) {
  this.Lmonocle_PLens$$anon$2__f__get$1 = null;
  this.Lmonocle_PLens$$anon$2__f__set$1 = null;
  this.Lmonocle_PLens$$anon$2__f__get$1 = _get$2;
  this.Lmonocle_PLens$$anon$2__f__set$1 = _set$2;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lmonocle_PLens$$anon$2 as $c_Lmonocle_PLens$$anon$2 };
$c_Lmonocle_PLens$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lmonocle_PLens$$anon$2.prototype.constructor = $c_Lmonocle_PLens$$anon$2;
/** @constructor */
function $h_Lmonocle_PLens$$anon$2() {
}
export { $h_Lmonocle_PLens$$anon$2 as $h_Lmonocle_PLens$$anon$2 };
$h_Lmonocle_PLens$$anon$2.prototype = $c_Lmonocle_PLens$$anon$2.prototype;
$c_Lmonocle_PLens$$anon$2.prototype.andThen__Lmonocle_POptional__Lmonocle_POptional = (function(other) {
  return new $c_Lmonocle_POptional$$anon$1(other, this);
});
$c_Lmonocle_PLens$$anon$2.prototype.get__O__O = (function(s) {
  return this.Lmonocle_PLens$$anon$2__f__get$1.apply__O__O(s);
});
$c_Lmonocle_PLens$$anon$2.prototype.replace__O__F1 = (function(b) {
  return this.Lmonocle_PLens$$anon$2__f__set$1.apply__O__O(b);
});
$c_Lmonocle_PLens$$anon$2.prototype.modify__F1__F1 = (function(f) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s) => this.Lmonocle_PLens$$anon$2__f__set$1.apply__O__O(f.apply__O__O(this.Lmonocle_PLens$$anon$2__f__get$1.apply__O__O(s))).apply__O__O(s)));
});
var $d_Lmonocle_PLens$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lmonocle_PLens$$anon$2, "monocle.PLens$$anon$2", ({
  Lmonocle_PLens$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lmonocle_PSetter: 1,
  Lmonocle_Fold: 1,
  Lmonocle_PTraversal: 1,
  Lmonocle_POptional: 1,
  Lmonocle_Getter: 1,
  Lmonocle_PLens: 1
}));
export { $d_Lmonocle_PLens$$anon$2 as $d_Lmonocle_PLens$$anon$2 };
/** @constructor */
function $c_Lretry_NextStep$GiveUp$() {
}
export { $c_Lretry_NextStep$GiveUp$ as $c_Lretry_NextStep$GiveUp$ };
$c_Lretry_NextStep$GiveUp$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lretry_NextStep$GiveUp$.prototype.constructor = $c_Lretry_NextStep$GiveUp$;
/** @constructor */
function $h_Lretry_NextStep$GiveUp$() {
}
export { $h_Lretry_NextStep$GiveUp$ as $h_Lretry_NextStep$GiveUp$ };
$h_Lretry_NextStep$GiveUp$.prototype = $c_Lretry_NextStep$GiveUp$.prototype;
$c_Lretry_NextStep$GiveUp$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lretry_NextStep$GiveUp$.prototype.hashCode__I = (function() {
  return 2133254572;
});
$c_Lretry_NextStep$GiveUp$.prototype.toString__T = (function() {
  return "GiveUp";
});
$c_Lretry_NextStep$GiveUp$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lretry_NextStep$GiveUp$.prototype.productPrefix__T = (function() {
  return "GiveUp";
});
$c_Lretry_NextStep$GiveUp$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lretry_NextStep$GiveUp$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lretry_NextStep$GiveUp$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lretry_NextStep$GiveUp$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lretry_NextStep$GiveUp$, "retry.NextStep$GiveUp$", ({
  Lretry_NextStep$GiveUp$: 1,
  Lretry_NextStep: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lretry_NextStep$GiveUp$ as $d_Lretry_NextStep$GiveUp$ };
var $n_Lretry_NextStep$GiveUp$;
function $m_Lretry_NextStep$GiveUp$() {
  if ((!$n_Lretry_NextStep$GiveUp$)) {
    $n_Lretry_NextStep$GiveUp$ = new $c_Lretry_NextStep$GiveUp$();
  }
  return $n_Lretry_NextStep$GiveUp$;
}
export { $m_Lretry_NextStep$GiveUp$ as $m_Lretry_NextStep$GiveUp$ };
function $f_sc_BitSetOps__contains__I__Z($thiz, elem) {
  if ((elem >= 0)) {
    var a = $thiz.word__I__J((elem >> 6));
    var lo = (((32 & elem) === 0) ? (1 << elem) : 0);
    var hi = (((32 & elem) === 0) ? 0 : (1 << elem));
    var lo$1 = (a.RTLong__f_lo & lo);
    var hi$1 = (a.RTLong__f_hi & hi);
    return (!((lo$1 === 0) && (hi$1 === 0)));
  } else {
    return false;
  }
}
export { $f_sc_BitSetOps__contains__I__Z as $f_sc_BitSetOps__contains__I__Z };
function $f_sc_BitSetOps__size__I($thiz) {
  var s = 0;
  var i = $thiz.nwords__I();
  while ((i > 0)) {
    i = (((-1) + i) | 0);
    var $x_1 = s;
    var t = $thiz.word__I__J(i);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    s = (($x_1 + (($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Integer$().bitCount__I__I(lo) + $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_jl_Integer$().bitCount__I__I(hi)) | 0)) | 0);
  }
  return s;
}
export { $f_sc_BitSetOps__size__I as $f_sc_BitSetOps__size__I };
function $f_sc_BitSetOps__isEmpty__Z($thiz) {
  var end = $thiz.nwords__I();
  var isEmpty = (end <= 0);
  var scala$collection$immutable$Range$$lastElement = (((-1) + end) | 0);
  var res = true;
  var it = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
  while ((res && it.sci_RangeIterator__f__hasNext)) {
    var x0 = it.next__I();
    var a = $thiz.word__I__J(x0);
    res = ((a.RTLong__f_lo === 0) && (a.RTLong__f_hi === 0));
  }
  return res;
}
export { $f_sc_BitSetOps__isEmpty__Z as $f_sc_BitSetOps__isEmpty__Z };
function $f_sc_BitSetOps__max__s_math_Ordering__I($thiz, ord) {
  if (($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_math_Ordering$Int$() === ord)) {
    var i = (((-1) + $thiz.nwords__I()) | 0);
    while ((i >= 0)) {
      var t = $thiz.word__I__J(i);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      if ((!((lo === 0) && (hi === 0)))) {
        return (((-1) + (((((1 + i) | 0) << 6) - ((hi !== 0) ? Math.clz32(hi) : ((32 + Math.clz32(lo)) | 0))) | 0)) | 0);
      }
      i = (((-1) + i) | 0);
    }
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_UnsupportedOperationException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_UnsupportedOperationException(), "empty.largestInt");
  } else {
    var this$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_math_Ordering$Int$();
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z(this$6, ord)) {
      var thisnwords = $thiz.nwords__I();
      var i$1 = 0;
      while ((i$1 < thisnwords)) {
        var t$1 = $thiz.word__I__J(i$1);
        var lo$1 = t$1.RTLong__f_lo;
        var hi$1 = t$1.RTLong__f_hi;
        if ((!((lo$1 === 0) && (hi$1 === 0)))) {
          if ((lo$1 !== 0)) {
            var i$2 = ((~lo$1) & (((-1) + lo$1) | 0));
            var $x_1 = ((32 - Math.clz32(i$2)) | 0);
          } else {
            var i$3 = ((~hi$1) & (((-1) + hi$1) | 0));
            var $x_1 = ((64 - Math.clz32(i$3)) | 0);
          }
          return (($x_1 + (i$1 << 6)) | 0);
        }
        i$1 = ((1 + i$1) | 0);
      }
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_UnsupportedOperationException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_UnsupportedOperationException(), "empty.smallestInt");
    } else {
      return $thiz.scala$collection$BitSetOps$$super$max__s_math_Ordering__I(ord);
    }
  }
}
export { $f_sc_BitSetOps__max__s_math_Ordering__I as $f_sc_BitSetOps__max__s_math_Ordering__I };
function $f_sc_BitSetOps__foreach__F1__V($thiz, f) {
  var i = 0;
  while ((i < $thiz.nwords__I())) {
    var t = $thiz.word__I__J(i);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var w__lo = lo;
    var w__hi = hi;
    var j = (i << 6);
    while (true) {
      var a__lo = w__lo;
      var a__hi = w__hi;
      if ((!((a__lo === 0) && (a__hi === 0)))) {
        var b__lo = w__lo;
        var b__hi = w__hi;
        var lo$1 = (1 & b__lo);
        if ((lo$1 === 1)) {
          f.apply__O__O(j);
        }
        var a$1__lo = w__lo;
        var a$1__hi = w__hi;
        var hi$1 = a$1__hi;
        var lo$2 = (((a$1__lo >>> 1) | 0) | (hi$1 << 31));
        var hi$2 = ((hi$1 >>> 1) | 0);
        var $x_1__lo = lo$2;
        var $x_1__hi = hi$2;
        w__lo = $x_1__lo;
        w__hi = $x_1__hi;
        j = ((1 + j) | 0);
      } else {
        break;
      }
    }
    i = ((1 + i) | 0);
  }
}
export { $f_sc_BitSetOps__foreach__F1__V as $f_sc_BitSetOps__foreach__F1__V };
function $f_sc_BitSetOps__concat__sc_IterableOnce__sc_BitSet($thiz, other) {
  if ($is_sc_BitSet(other)) {
    var x = $thiz.nwords__I();
    var that = other.nwords__I();
    var len = ((x > that) ? x : that);
    var words = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_J(len);
    var isEmpty = (len <= 0);
    var scala$collection$immutable$Range$$lastElement = (((-1) + len) | 0);
    if ((!isEmpty)) {
      var i = 0;
      while (true) {
        var v1 = i;
        var a = $thiz.word__I__J(v1);
        var b = other.word__I__J(v1);
        var lo = (a.RTLong__f_lo | b.RTLong__f_lo);
        var hi = (a.RTLong__f_hi | b.RTLong__f_hi);
        words.u[v1] = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi);
        if ((i === scala$collection$immutable$Range$$lastElement)) {
          break;
        }
        i = ((1 + i) | 0);
      }
    }
    return $thiz.fromBitMaskNoCopy__AJ__sc_BitSet(words);
  } else {
    return $thiz.scala$collection$BitSetOps$$super$concat__sc_IterableOnce__sc_BitSet(other);
  }
}
export { $f_sc_BitSetOps__concat__sc_IterableOnce__sc_BitSet as $f_sc_BitSetOps__concat__sc_IterableOnce__sc_BitSet };
/** @constructor */
function $c_Lsttp_client3_IgnoreResponse$() {
}
export { $c_Lsttp_client3_IgnoreResponse$ as $c_Lsttp_client3_IgnoreResponse$ };
$c_Lsttp_client3_IgnoreResponse$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_IgnoreResponse$.prototype.constructor = $c_Lsttp_client3_IgnoreResponse$;
/** @constructor */
function $h_Lsttp_client3_IgnoreResponse$() {
}
export { $h_Lsttp_client3_IgnoreResponse$ as $h_Lsttp_client3_IgnoreResponse$ };
$h_Lsttp_client3_IgnoreResponse$.prototype = $c_Lsttp_client3_IgnoreResponse$.prototype;
$c_Lsttp_client3_IgnoreResponse$.prototype.mapWithMetadata__F2__Lsttp_client3_ResponseAs = (function(f) {
  var showAs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  return new $c_Lsttp_client3_MappedResponseAs(this, f, showAs);
});
$c_Lsttp_client3_IgnoreResponse$.prototype.showAs__T__Lsttp_client3_ResponseAs = (function(s) {
  return $f_Lsttp_client3_ResponseAs__showAs__T__Lsttp_client3_ResponseAs(this, s);
});
$c_Lsttp_client3_IgnoreResponse$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_client3_IgnoreResponse$.prototype.hashCode__I = (function() {
  return 1941590099;
});
$c_Lsttp_client3_IgnoreResponse$.prototype.toString__T = (function() {
  return "IgnoreResponse";
});
$c_Lsttp_client3_IgnoreResponse$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_client3_IgnoreResponse$.prototype.productPrefix__T = (function() {
  return "IgnoreResponse";
});
$c_Lsttp_client3_IgnoreResponse$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_client3_IgnoreResponse$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_client3_IgnoreResponse$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_client3_IgnoreResponse$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_IgnoreResponse$, "sttp.client3.IgnoreResponse$", ({
  Lsttp_client3_IgnoreResponse$: 1,
  Lsttp_client3_ResponseAs: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_client3_IgnoreResponse$ as $d_Lsttp_client3_IgnoreResponse$ };
var $n_Lsttp_client3_IgnoreResponse$;
function $m_Lsttp_client3_IgnoreResponse$() {
  if ((!$n_Lsttp_client3_IgnoreResponse$)) {
    $n_Lsttp_client3_IgnoreResponse$ = new $c_Lsttp_client3_IgnoreResponse$();
  }
  return $n_Lsttp_client3_IgnoreResponse$;
}
export { $m_Lsttp_client3_IgnoreResponse$ as $m_Lsttp_client3_IgnoreResponse$ };
/** @constructor */
function $c_Lsttp_client3_NoBody$() {
}
export { $c_Lsttp_client3_NoBody$ as $c_Lsttp_client3_NoBody$ };
$c_Lsttp_client3_NoBody$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_NoBody$.prototype.constructor = $c_Lsttp_client3_NoBody$;
/** @constructor */
function $h_Lsttp_client3_NoBody$() {
}
export { $h_Lsttp_client3_NoBody$ as $h_Lsttp_client3_NoBody$ };
$h_Lsttp_client3_NoBody$.prototype = $c_Lsttp_client3_NoBody$.prototype;
$c_Lsttp_client3_NoBody$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_client3_NoBody$.prototype.hashCode__I = (function() {
  return (-1957306589);
});
$c_Lsttp_client3_NoBody$.prototype.toString__T = (function() {
  return "NoBody";
});
$c_Lsttp_client3_NoBody$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_client3_NoBody$.prototype.productPrefix__T = (function() {
  return "NoBody";
});
$c_Lsttp_client3_NoBody$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_client3_NoBody$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_client3_NoBody$.prototype.defaultContentType__Lsttp_model_MediaType = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_model_MediaType$().Lsttp_model_MediaType$__f_ApplicationOctetStream;
});
$c_Lsttp_client3_NoBody$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_client3_NoBody$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_NoBody$, "sttp.client3.NoBody$", ({
  Lsttp_client3_NoBody$: 1,
  Lsttp_client3_RequestBody: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_client3_NoBody$ as $d_Lsttp_client3_NoBody$ };
var $n_Lsttp_client3_NoBody$;
function $m_Lsttp_client3_NoBody$() {
  if ((!$n_Lsttp_client3_NoBody$)) {
    $n_Lsttp_client3_NoBody$ = new $c_Lsttp_client3_NoBody$();
  }
  return $n_Lsttp_client3_NoBody$;
}
export { $m_Lsttp_client3_NoBody$ as $m_Lsttp_client3_NoBody$ };
/** @constructor */
function $c_Lsttp_client3_ResponseAsByteArray$() {
}
export { $c_Lsttp_client3_ResponseAsByteArray$ as $c_Lsttp_client3_ResponseAsByteArray$ };
$c_Lsttp_client3_ResponseAsByteArray$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_client3_ResponseAsByteArray$.prototype.constructor = $c_Lsttp_client3_ResponseAsByteArray$;
/** @constructor */
function $h_Lsttp_client3_ResponseAsByteArray$() {
}
export { $h_Lsttp_client3_ResponseAsByteArray$ as $h_Lsttp_client3_ResponseAsByteArray$ };
$h_Lsttp_client3_ResponseAsByteArray$.prototype = $c_Lsttp_client3_ResponseAsByteArray$.prototype;
$c_Lsttp_client3_ResponseAsByteArray$.prototype.mapWithMetadata__F2__Lsttp_client3_ResponseAs = (function(f) {
  var showAs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  return new $c_Lsttp_client3_MappedResponseAs(this, f, showAs);
});
$c_Lsttp_client3_ResponseAsByteArray$.prototype.showAs__T__Lsttp_client3_ResponseAs = (function(s) {
  return $f_Lsttp_client3_ResponseAs__showAs__T__Lsttp_client3_ResponseAs(this, s);
});
$c_Lsttp_client3_ResponseAsByteArray$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_client3_ResponseAsByteArray$.prototype.hashCode__I = (function() {
  return 305859326;
});
$c_Lsttp_client3_ResponseAsByteArray$.prototype.toString__T = (function() {
  return "ResponseAsByteArray";
});
$c_Lsttp_client3_ResponseAsByteArray$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_client3_ResponseAsByteArray$.prototype.productPrefix__T = (function() {
  return "ResponseAsByteArray";
});
$c_Lsttp_client3_ResponseAsByteArray$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_client3_ResponseAsByteArray$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_client3_ResponseAsByteArray$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_client3_ResponseAsByteArray$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_client3_ResponseAsByteArray$, "sttp.client3.ResponseAsByteArray$", ({
  Lsttp_client3_ResponseAsByteArray$: 1,
  Lsttp_client3_ResponseAs: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_client3_ResponseAsByteArray$ as $d_Lsttp_client3_ResponseAsByteArray$ };
var $n_Lsttp_client3_ResponseAsByteArray$;
function $m_Lsttp_client3_ResponseAsByteArray$() {
  if ((!$n_Lsttp_client3_ResponseAsByteArray$)) {
    $n_Lsttp_client3_ResponseAsByteArray$ = new $c_Lsttp_client3_ResponseAsByteArray$();
  }
  return $n_Lsttp_client3_ResponseAsByteArray$;
}
export { $m_Lsttp_client3_ResponseAsByteArray$ as $m_Lsttp_client3_ResponseAsByteArray$ };
/** @constructor */
function $c_Lsttp_tapir_EndpointInput$Auth(input, challenge, authType, info) {
  this.Lsttp_tapir_EndpointInput$Auth__f_input = null;
  this.Lsttp_tapir_EndpointInput$Auth__f_challenge = null;
  this.Lsttp_tapir_EndpointInput$Auth__f_authType = null;
  this.Lsttp_tapir_EndpointInput$Auth__f_info = null;
  this.Lsttp_tapir_EndpointInput$Auth__f_input = input;
  this.Lsttp_tapir_EndpointInput$Auth__f_challenge = challenge;
  this.Lsttp_tapir_EndpointInput$Auth__f_authType = authType;
  this.Lsttp_tapir_EndpointInput$Auth__f_info = info;
}
export { $c_Lsttp_tapir_EndpointInput$Auth as $c_Lsttp_tapir_EndpointInput$Auth };
$c_Lsttp_tapir_EndpointInput$Auth.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_EndpointInput$Auth.prototype.constructor = $c_Lsttp_tapir_EndpointInput$Auth;
/** @constructor */
function $h_Lsttp_tapir_EndpointInput$Auth() {
}
export { $h_Lsttp_tapir_EndpointInput$Auth as $h_Lsttp_tapir_EndpointInput$Auth };
$h_Lsttp_tapir_EndpointInput$Auth.prototype = $c_Lsttp_tapir_EndpointInput$Auth.prototype;
$c_Lsttp_tapir_EndpointInput$Auth.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_EndpointInput$Auth.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1981214316, true);
});
$c_Lsttp_tapir_EndpointInput$Auth.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_EndpointInput$Auth)) {
    var x = this.Lsttp_tapir_EndpointInput$Auth__f_input;
    var x$2 = x$0.Lsttp_tapir_EndpointInput$Auth__f_input;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lsttp_tapir_EndpointInput$Auth__f_challenge;
      var x$4 = x$0.Lsttp_tapir_EndpointInput$Auth__f_challenge;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Lsttp_tapir_EndpointInput$Auth__f_authType;
      var x$6 = x$0.Lsttp_tapir_EndpointInput$Auth__f_authType;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.Lsttp_tapir_EndpointInput$Auth__f_info;
      var x$8 = x$0.Lsttp_tapir_EndpointInput$Auth__f_info;
      return ((x$7 === null) ? (x$8 === null) : x$7.equals__O__Z(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_EndpointInput$Auth.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_EndpointInput$Auth.prototype.productArity__I = (function() {
  return 4;
});
$c_Lsttp_tapir_EndpointInput$Auth.prototype.productPrefix__T = (function() {
  return "Auth";
});
$c_Lsttp_tapir_EndpointInput$Auth.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsttp_tapir_EndpointInput$Auth__f_input;
      break;
    }
    case 1: {
      return this.Lsttp_tapir_EndpointInput$Auth__f_challenge;
      break;
    }
    case 2: {
      return this.Lsttp_tapir_EndpointInput$Auth__f_authType;
      break;
    }
    case 3: {
      return this.Lsttp_tapir_EndpointInput$Auth__f_info;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_EndpointInput$Auth.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "input";
      break;
    }
    case 1: {
      return "challenge";
      break;
    }
    case 2: {
      return "authType";
      break;
    }
    case 3: {
      return "info";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_EndpointInput$Auth.prototype.map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointInput$Auth = (function(mapping) {
  var input = this.Lsttp_tapir_EndpointInput$Auth__f_input.map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput(mapping);
  var challenge = this.Lsttp_tapir_EndpointInput$Auth__f_challenge;
  var authType = this.Lsttp_tapir_EndpointInput$Auth__f_authType;
  var info = this.Lsttp_tapir_EndpointInput$Auth__f_info;
  return new $c_Lsttp_tapir_EndpointInput$Auth(input, challenge, authType, info);
});
$c_Lsttp_tapir_EndpointInput$Auth.prototype.map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput = (function(mapping) {
  return this.map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointInput$Auth(mapping);
});
function $isArrayOf_Lsttp_tapir_EndpointInput$Auth(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointInput$Auth)));
}
export { $isArrayOf_Lsttp_tapir_EndpointInput$Auth as $isArrayOf_Lsttp_tapir_EndpointInput$Auth };
var $d_Lsttp_tapir_EndpointInput$Auth = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_EndpointInput$Auth, "sttp.tapir.EndpointInput$Auth", ({
  Lsttp_tapir_EndpointInput$Auth: 1,
  Lsttp_tapir_macros_EndpointTransputMacros: 1,
  Lsttp_tapir_EndpointTransput: 1,
  Lsttp_tapir_EndpointInput: 1,
  Lsttp_tapir_EndpointInput$Single: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_EndpointInput$Auth as $d_Lsttp_tapir_EndpointInput$Auth };
/** @constructor */
function $c_Lsttp_tapir_EndpointInput$MappedPair(input, mapping) {
  this.Lsttp_tapir_EndpointInput$MappedPair__f_input = null;
  this.Lsttp_tapir_EndpointInput$MappedPair__f_mapping = null;
  this.Lsttp_tapir_EndpointInput$MappedPair__f_input = input;
  this.Lsttp_tapir_EndpointInput$MappedPair__f_mapping = mapping;
}
export { $c_Lsttp_tapir_EndpointInput$MappedPair as $c_Lsttp_tapir_EndpointInput$MappedPair };
$c_Lsttp_tapir_EndpointInput$MappedPair.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_EndpointInput$MappedPair.prototype.constructor = $c_Lsttp_tapir_EndpointInput$MappedPair;
/** @constructor */
function $h_Lsttp_tapir_EndpointInput$MappedPair() {
}
export { $h_Lsttp_tapir_EndpointInput$MappedPair as $h_Lsttp_tapir_EndpointInput$MappedPair };
$h_Lsttp_tapir_EndpointInput$MappedPair.prototype = $c_Lsttp_tapir_EndpointInput$MappedPair.prototype;
$c_Lsttp_tapir_EndpointInput$MappedPair.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_EndpointInput$MappedPair.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 2043052985, true);
});
$c_Lsttp_tapir_EndpointInput$MappedPair.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_EndpointInput$MappedPair)) {
    var x = this.Lsttp_tapir_EndpointInput$MappedPair__f_input;
    var x$2 = x$0.Lsttp_tapir_EndpointInput$MappedPair__f_input;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lsttp_tapir_EndpointInput$MappedPair__f_mapping;
      var x$4 = x$0.Lsttp_tapir_EndpointInput$MappedPair__f_mapping;
      return (x$3 === x$4);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_EndpointInput$MappedPair.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_EndpointInput$MappedPair.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsttp_tapir_EndpointInput$MappedPair.prototype.productPrefix__T = (function() {
  return "MappedPair";
});
$c_Lsttp_tapir_EndpointInput$MappedPair.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_EndpointInput$MappedPair__f_input;
  }
  if ((n === 1)) {
    return this.Lsttp_tapir_EndpointInput$MappedPair__f_mapping;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_EndpointInput$MappedPair.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "input";
  }
  if ((n === 1)) {
    return "mapping";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_EndpointInput$MappedPair.prototype.map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointInput$MappedPair = (function(m) {
  var input = this.Lsttp_tapir_EndpointInput$MappedPair__f_input;
  var this$1 = this.Lsttp_tapir_EndpointInput$MappedPair__f_mapping;
  var mapping = new $c_Lsttp_tapir_Mapping$$anon$1(m, this$1);
  return new $c_Lsttp_tapir_EndpointInput$MappedPair(input, mapping);
});
$c_Lsttp_tapir_EndpointInput$MappedPair.prototype.map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput = (function(mapping) {
  return this.map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointInput$MappedPair(mapping);
});
function $isArrayOf_Lsttp_tapir_EndpointInput$MappedPair(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointInput$MappedPair)));
}
export { $isArrayOf_Lsttp_tapir_EndpointInput$MappedPair as $isArrayOf_Lsttp_tapir_EndpointInput$MappedPair };
var $d_Lsttp_tapir_EndpointInput$MappedPair = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_EndpointInput$MappedPair, "sttp.tapir.EndpointInput$MappedPair", ({
  Lsttp_tapir_EndpointInput$MappedPair: 1,
  Lsttp_tapir_macros_EndpointTransputMacros: 1,
  Lsttp_tapir_EndpointTransput: 1,
  Lsttp_tapir_EndpointInput: 1,
  Lsttp_tapir_EndpointInput$Single: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_EndpointInput$MappedPair as $d_Lsttp_tapir_EndpointInput$MappedPair };
/** @constructor */
function $c_Lsttp_tapir_EndpointInput$Pair(left, right, combine, split) {
  this.Lsttp_tapir_EndpointInput$Pair__f_left = null;
  this.Lsttp_tapir_EndpointInput$Pair__f_right = null;
  this.Lsttp_tapir_EndpointInput$Pair__f_combine = null;
  this.Lsttp_tapir_EndpointInput$Pair__f_split = null;
  this.Lsttp_tapir_EndpointInput$Pair__f_left = left;
  this.Lsttp_tapir_EndpointInput$Pair__f_right = right;
  this.Lsttp_tapir_EndpointInput$Pair__f_combine = combine;
  this.Lsttp_tapir_EndpointInput$Pair__f_split = split;
}
export { $c_Lsttp_tapir_EndpointInput$Pair as $c_Lsttp_tapir_EndpointInput$Pair };
$c_Lsttp_tapir_EndpointInput$Pair.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_EndpointInput$Pair.prototype.constructor = $c_Lsttp_tapir_EndpointInput$Pair;
/** @constructor */
function $h_Lsttp_tapir_EndpointInput$Pair() {
}
export { $h_Lsttp_tapir_EndpointInput$Pair as $h_Lsttp_tapir_EndpointInput$Pair };
$h_Lsttp_tapir_EndpointInput$Pair.prototype = $c_Lsttp_tapir_EndpointInput$Pair.prototype;
$c_Lsttp_tapir_EndpointInput$Pair.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_EndpointInput$Pair.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1094274182, true);
});
$c_Lsttp_tapir_EndpointInput$Pair.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_EndpointInput$Pair)) {
    var x = this.Lsttp_tapir_EndpointInput$Pair__f_left;
    var x$2 = x$0.Lsttp_tapir_EndpointInput$Pair__f_left;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lsttp_tapir_EndpointInput$Pair__f_right;
      var x$4 = x$0.Lsttp_tapir_EndpointInput$Pair__f_right;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Lsttp_tapir_EndpointInput$Pair__f_combine;
      var x$6 = x$0.Lsttp_tapir_EndpointInput$Pair__f_combine;
      var $x_1 = (x$5 === x$6);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.Lsttp_tapir_EndpointInput$Pair__f_split;
      var x$8 = x$0.Lsttp_tapir_EndpointInput$Pair__f_split;
      return ((x$7 === null) ? (x$8 === null) : x$7.equals__O__Z(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_EndpointInput$Pair.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_EndpointInput$Pair.prototype.productArity__I = (function() {
  return 4;
});
$c_Lsttp_tapir_EndpointInput$Pair.prototype.productPrefix__T = (function() {
  return "Pair";
});
$c_Lsttp_tapir_EndpointInput$Pair.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsttp_tapir_EndpointInput$Pair__f_left;
      break;
    }
    case 1: {
      return this.Lsttp_tapir_EndpointInput$Pair__f_right;
      break;
    }
    case 2: {
      return this.Lsttp_tapir_EndpointInput$Pair__f_combine;
      break;
    }
    case 3: {
      return this.Lsttp_tapir_EndpointInput$Pair__f_split;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_EndpointInput$Pair.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "left";
      break;
    }
    case 1: {
      return "right";
      break;
    }
    case 2: {
      return "combine";
      break;
    }
    case 3: {
      return "split";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_EndpointInput$Pair.prototype.map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput = (function(mapping) {
  return new $c_Lsttp_tapir_EndpointInput$MappedPair(this, mapping);
});
function $isArrayOf_Lsttp_tapir_EndpointInput$Pair(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointInput$Pair)));
}
export { $isArrayOf_Lsttp_tapir_EndpointInput$Pair as $isArrayOf_Lsttp_tapir_EndpointInput$Pair };
var $d_Lsttp_tapir_EndpointInput$Pair = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_EndpointInput$Pair, "sttp.tapir.EndpointInput$Pair", ({
  Lsttp_tapir_EndpointInput$Pair: 1,
  Lsttp_tapir_macros_EndpointTransputMacros: 1,
  Lsttp_tapir_EndpointTransput: 1,
  Lsttp_tapir_EndpointInput: 1,
  Lsttp_tapir_EndpointTransput$Pair: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_EndpointInput$Pair as $d_Lsttp_tapir_EndpointInput$Pair };
/** @constructor */
function $c_Lsttp_tapir_EndpointOutput$MappedPair(output, mapping) {
  this.Lsttp_tapir_EndpointOutput$MappedPair__f_output = null;
  this.Lsttp_tapir_EndpointOutput$MappedPair__f_mapping = null;
  this.Lsttp_tapir_EndpointOutput$MappedPair__f_output = output;
  this.Lsttp_tapir_EndpointOutput$MappedPair__f_mapping = mapping;
}
export { $c_Lsttp_tapir_EndpointOutput$MappedPair as $c_Lsttp_tapir_EndpointOutput$MappedPair };
$c_Lsttp_tapir_EndpointOutput$MappedPair.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_EndpointOutput$MappedPair.prototype.constructor = $c_Lsttp_tapir_EndpointOutput$MappedPair;
/** @constructor */
function $h_Lsttp_tapir_EndpointOutput$MappedPair() {
}
export { $h_Lsttp_tapir_EndpointOutput$MappedPair as $h_Lsttp_tapir_EndpointOutput$MappedPair };
$h_Lsttp_tapir_EndpointOutput$MappedPair.prototype = $c_Lsttp_tapir_EndpointOutput$MappedPair.prototype;
$c_Lsttp_tapir_EndpointOutput$MappedPair.prototype.and__Lsttp_tapir_EndpointOutput__Lsttp_tapir_typelevel_ParamConcat__Lsttp_tapir_EndpointOutput = (function(other, concat) {
  return $f_Lsttp_tapir_EndpointOutput__and__Lsttp_tapir_EndpointOutput__Lsttp_tapir_typelevel_ParamConcat__Lsttp_tapir_EndpointOutput(this, other, concat);
});
$c_Lsttp_tapir_EndpointOutput$MappedPair.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_EndpointOutput$MappedPair.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 2043052985, true);
});
$c_Lsttp_tapir_EndpointOutput$MappedPair.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_EndpointOutput$MappedPair)) {
    var x = this.Lsttp_tapir_EndpointOutput$MappedPair__f_output;
    var x$2 = x$0.Lsttp_tapir_EndpointOutput$MappedPair__f_output;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lsttp_tapir_EndpointOutput$MappedPair__f_mapping;
      var x$4 = x$0.Lsttp_tapir_EndpointOutput$MappedPair__f_mapping;
      return (x$3 === x$4);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_EndpointOutput$MappedPair.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_EndpointOutput$MappedPair.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsttp_tapir_EndpointOutput$MappedPair.prototype.productPrefix__T = (function() {
  return "MappedPair";
});
$c_Lsttp_tapir_EndpointOutput$MappedPair.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_EndpointOutput$MappedPair__f_output;
  }
  if ((n === 1)) {
    return this.Lsttp_tapir_EndpointOutput$MappedPair__f_mapping;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_EndpointOutput$MappedPair.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "output";
  }
  if ((n === 1)) {
    return "mapping";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_EndpointOutput$MappedPair.prototype.map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointOutput$MappedPair = (function(m) {
  var output = this.Lsttp_tapir_EndpointOutput$MappedPair__f_output;
  var this$1 = this.Lsttp_tapir_EndpointOutput$MappedPair__f_mapping;
  var mapping = new $c_Lsttp_tapir_Mapping$$anon$1(m, this$1);
  return new $c_Lsttp_tapir_EndpointOutput$MappedPair(output, mapping);
});
$c_Lsttp_tapir_EndpointOutput$MappedPair.prototype.map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput = (function(mapping) {
  return this.map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointOutput$MappedPair(mapping);
});
function $isArrayOf_Lsttp_tapir_EndpointOutput$MappedPair(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointOutput$MappedPair)));
}
export { $isArrayOf_Lsttp_tapir_EndpointOutput$MappedPair as $isArrayOf_Lsttp_tapir_EndpointOutput$MappedPair };
var $d_Lsttp_tapir_EndpointOutput$MappedPair = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_EndpointOutput$MappedPair, "sttp.tapir.EndpointOutput$MappedPair", ({
  Lsttp_tapir_EndpointOutput$MappedPair: 1,
  Lsttp_tapir_macros_EndpointTransputMacros: 1,
  Lsttp_tapir_EndpointTransput: 1,
  Lsttp_tapir_EndpointOutput: 1,
  Lsttp_tapir_EndpointOutput$Single: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_EndpointOutput$MappedPair as $d_Lsttp_tapir_EndpointOutput$MappedPair };
function $isArrayOf_Lsttp_tapir_EndpointOutput$OneOf(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointOutput$OneOf)));
}
export { $isArrayOf_Lsttp_tapir_EndpointOutput$OneOf as $isArrayOf_Lsttp_tapir_EndpointOutput$OneOf };
/** @constructor */
function $c_Lsttp_tapir_EndpointOutput$Pair(left, right, combine, split) {
  this.Lsttp_tapir_EndpointOutput$Pair__f_left = null;
  this.Lsttp_tapir_EndpointOutput$Pair__f_right = null;
  this.Lsttp_tapir_EndpointOutput$Pair__f_combine = null;
  this.Lsttp_tapir_EndpointOutput$Pair__f_split = null;
  this.Lsttp_tapir_EndpointOutput$Pair__f_left = left;
  this.Lsttp_tapir_EndpointOutput$Pair__f_right = right;
  this.Lsttp_tapir_EndpointOutput$Pair__f_combine = combine;
  this.Lsttp_tapir_EndpointOutput$Pair__f_split = split;
}
export { $c_Lsttp_tapir_EndpointOutput$Pair as $c_Lsttp_tapir_EndpointOutput$Pair };
$c_Lsttp_tapir_EndpointOutput$Pair.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_EndpointOutput$Pair.prototype.constructor = $c_Lsttp_tapir_EndpointOutput$Pair;
/** @constructor */
function $h_Lsttp_tapir_EndpointOutput$Pair() {
}
export { $h_Lsttp_tapir_EndpointOutput$Pair as $h_Lsttp_tapir_EndpointOutput$Pair };
$h_Lsttp_tapir_EndpointOutput$Pair.prototype = $c_Lsttp_tapir_EndpointOutput$Pair.prototype;
$c_Lsttp_tapir_EndpointOutput$Pair.prototype.and__Lsttp_tapir_EndpointOutput__Lsttp_tapir_typelevel_ParamConcat__Lsttp_tapir_EndpointOutput = (function(other, concat) {
  return $f_Lsttp_tapir_EndpointOutput__and__Lsttp_tapir_EndpointOutput__Lsttp_tapir_typelevel_ParamConcat__Lsttp_tapir_EndpointOutput(this, other, concat);
});
$c_Lsttp_tapir_EndpointOutput$Pair.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_EndpointOutput$Pair.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1094274182, true);
});
$c_Lsttp_tapir_EndpointOutput$Pair.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_EndpointOutput$Pair)) {
    var x = this.Lsttp_tapir_EndpointOutput$Pair__f_left;
    var x$2 = x$0.Lsttp_tapir_EndpointOutput$Pair__f_left;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lsttp_tapir_EndpointOutput$Pair__f_right;
      var x$4 = x$0.Lsttp_tapir_EndpointOutput$Pair__f_right;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Lsttp_tapir_EndpointOutput$Pair__f_combine;
      var x$6 = x$0.Lsttp_tapir_EndpointOutput$Pair__f_combine;
      var $x_1 = (x$5 === x$6);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.Lsttp_tapir_EndpointOutput$Pair__f_split;
      var x$8 = x$0.Lsttp_tapir_EndpointOutput$Pair__f_split;
      return ((x$7 === null) ? (x$8 === null) : x$7.equals__O__Z(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_EndpointOutput$Pair.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_EndpointOutput$Pair.prototype.productArity__I = (function() {
  return 4;
});
$c_Lsttp_tapir_EndpointOutput$Pair.prototype.productPrefix__T = (function() {
  return "Pair";
});
$c_Lsttp_tapir_EndpointOutput$Pair.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsttp_tapir_EndpointOutput$Pair__f_left;
      break;
    }
    case 1: {
      return this.Lsttp_tapir_EndpointOutput$Pair__f_right;
      break;
    }
    case 2: {
      return this.Lsttp_tapir_EndpointOutput$Pair__f_combine;
      break;
    }
    case 3: {
      return this.Lsttp_tapir_EndpointOutput$Pair__f_split;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_EndpointOutput$Pair.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "left";
      break;
    }
    case 1: {
      return "right";
      break;
    }
    case 2: {
      return "combine";
      break;
    }
    case 3: {
      return "split";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_EndpointOutput$Pair.prototype.map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput = (function(mapping) {
  return new $c_Lsttp_tapir_EndpointOutput$MappedPair(this, mapping);
});
function $isArrayOf_Lsttp_tapir_EndpointOutput$Pair(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointOutput$Pair)));
}
export { $isArrayOf_Lsttp_tapir_EndpointOutput$Pair as $isArrayOf_Lsttp_tapir_EndpointOutput$Pair };
var $d_Lsttp_tapir_EndpointOutput$Pair = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_EndpointOutput$Pair, "sttp.tapir.EndpointOutput$Pair", ({
  Lsttp_tapir_EndpointOutput$Pair: 1,
  Lsttp_tapir_macros_EndpointTransputMacros: 1,
  Lsttp_tapir_EndpointTransput: 1,
  Lsttp_tapir_EndpointOutput: 1,
  Lsttp_tapir_EndpointTransput$Pair: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_EndpointOutput$Pair as $d_Lsttp_tapir_EndpointOutput$Pair };
/** @constructor */
function $c_Lsttp_tapir_WebSocketBodyOutput(streams, requests, responses, codec, info, requestsInfo, responsesInfo, concatenateFragmentedFrames, ignorePong, autoPongOnPing, decodeCloseRequests, decodeCloseResponses, autoPing) {
  this.Lsttp_tapir_WebSocketBodyOutput__f_streams = null;
  this.Lsttp_tapir_WebSocketBodyOutput__f_requests = null;
  this.Lsttp_tapir_WebSocketBodyOutput__f_responses = null;
  this.Lsttp_tapir_WebSocketBodyOutput__f_codec = null;
  this.Lsttp_tapir_WebSocketBodyOutput__f_info = null;
  this.Lsttp_tapir_WebSocketBodyOutput__f_requestsInfo = null;
  this.Lsttp_tapir_WebSocketBodyOutput__f_responsesInfo = null;
  this.Lsttp_tapir_WebSocketBodyOutput__f_concatenateFragmentedFrames = false;
  this.Lsttp_tapir_WebSocketBodyOutput__f_ignorePong = false;
  this.Lsttp_tapir_WebSocketBodyOutput__f_autoPongOnPing = false;
  this.Lsttp_tapir_WebSocketBodyOutput__f_decodeCloseRequests = false;
  this.Lsttp_tapir_WebSocketBodyOutput__f_decodeCloseResponses = false;
  this.Lsttp_tapir_WebSocketBodyOutput__f_autoPing = null;
  this.Lsttp_tapir_WebSocketBodyOutput__f_streams = streams;
  this.Lsttp_tapir_WebSocketBodyOutput__f_requests = requests;
  this.Lsttp_tapir_WebSocketBodyOutput__f_responses = responses;
  this.Lsttp_tapir_WebSocketBodyOutput__f_codec = codec;
  this.Lsttp_tapir_WebSocketBodyOutput__f_info = info;
  this.Lsttp_tapir_WebSocketBodyOutput__f_requestsInfo = requestsInfo;
  this.Lsttp_tapir_WebSocketBodyOutput__f_responsesInfo = responsesInfo;
  this.Lsttp_tapir_WebSocketBodyOutput__f_concatenateFragmentedFrames = concatenateFragmentedFrames;
  this.Lsttp_tapir_WebSocketBodyOutput__f_ignorePong = ignorePong;
  this.Lsttp_tapir_WebSocketBodyOutput__f_autoPongOnPing = autoPongOnPing;
  this.Lsttp_tapir_WebSocketBodyOutput__f_decodeCloseRequests = decodeCloseRequests;
  this.Lsttp_tapir_WebSocketBodyOutput__f_decodeCloseResponses = decodeCloseResponses;
  this.Lsttp_tapir_WebSocketBodyOutput__f_autoPing = autoPing;
}
export { $c_Lsttp_tapir_WebSocketBodyOutput as $c_Lsttp_tapir_WebSocketBodyOutput };
$c_Lsttp_tapir_WebSocketBodyOutput.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_WebSocketBodyOutput.prototype.constructor = $c_Lsttp_tapir_WebSocketBodyOutput;
/** @constructor */
function $h_Lsttp_tapir_WebSocketBodyOutput() {
}
export { $h_Lsttp_tapir_WebSocketBodyOutput as $h_Lsttp_tapir_WebSocketBodyOutput };
$h_Lsttp_tapir_WebSocketBodyOutput.prototype = $c_Lsttp_tapir_WebSocketBodyOutput.prototype;
$c_Lsttp_tapir_WebSocketBodyOutput.prototype.map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput = (function(mapping) {
  return $f_Lsttp_tapir_EndpointTransput$Atom__map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput(this, mapping);
});
$c_Lsttp_tapir_WebSocketBodyOutput.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_WebSocketBodyOutput.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, 1560491114);
  var hash$1 = acc;
  var x = this.Lsttp_tapir_WebSocketBodyOutput__f_streams;
  var data = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data);
  var hash$2 = acc;
  var x$1 = this.Lsttp_tapir_WebSocketBodyOutput__f_requests;
  var data$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$1);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$2, data$1);
  var hash$3 = acc;
  var x$2 = this.Lsttp_tapir_WebSocketBodyOutput__f_responses;
  var data$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$2);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$3, data$2);
  var hash$4 = acc;
  var x$3 = this.Lsttp_tapir_WebSocketBodyOutput__f_codec;
  var data$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$3);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$4, data$3);
  var hash$5 = acc;
  var x$4 = this.Lsttp_tapir_WebSocketBodyOutput__f_info;
  var data$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$4);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$5, data$4);
  var hash$6 = acc;
  var x$5 = this.Lsttp_tapir_WebSocketBodyOutput__f_requestsInfo;
  var data$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$5);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$6, data$5);
  var hash$7 = acc;
  var x$6 = this.Lsttp_tapir_WebSocketBodyOutput__f_responsesInfo;
  var data$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$6);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$7, data$6);
  var hash$8 = acc;
  var data$7 = (this.Lsttp_tapir_WebSocketBodyOutput__f_concatenateFragmentedFrames ? 1231 : 1237);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$8, data$7);
  var hash$9 = acc;
  var data$8 = (this.Lsttp_tapir_WebSocketBodyOutput__f_ignorePong ? 1231 : 1237);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$9, data$8);
  var hash$10 = acc;
  var data$9 = (this.Lsttp_tapir_WebSocketBodyOutput__f_autoPongOnPing ? 1231 : 1237);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$10, data$9);
  var hash$11 = acc;
  var data$10 = (this.Lsttp_tapir_WebSocketBodyOutput__f_decodeCloseRequests ? 1231 : 1237);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$11, data$10);
  var hash$12 = acc;
  var data$11 = (this.Lsttp_tapir_WebSocketBodyOutput__f_decodeCloseResponses ? 1231 : 1237);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$12, data$11);
  var hash$13 = acc;
  var x$7 = this.Lsttp_tapir_WebSocketBodyOutput__f_autoPing;
  var data$12 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().anyHash__O__I(x$7);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$13, data$12);
  var hash$14 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$14, 13);
});
$c_Lsttp_tapir_WebSocketBodyOutput.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_WebSocketBodyOutput)) {
    if ((((((this.Lsttp_tapir_WebSocketBodyOutput__f_concatenateFragmentedFrames === x$0.Lsttp_tapir_WebSocketBodyOutput__f_concatenateFragmentedFrames) && (this.Lsttp_tapir_WebSocketBodyOutput__f_ignorePong === x$0.Lsttp_tapir_WebSocketBodyOutput__f_ignorePong)) && (this.Lsttp_tapir_WebSocketBodyOutput__f_autoPongOnPing === x$0.Lsttp_tapir_WebSocketBodyOutput__f_autoPongOnPing)) && (this.Lsttp_tapir_WebSocketBodyOutput__f_decodeCloseRequests === x$0.Lsttp_tapir_WebSocketBodyOutput__f_decodeCloseRequests)) && (this.Lsttp_tapir_WebSocketBodyOutput__f_decodeCloseResponses === x$0.Lsttp_tapir_WebSocketBodyOutput__f_decodeCloseResponses))) {
      var x = this.Lsttp_tapir_WebSocketBodyOutput__f_streams;
      var x$2 = x$0.Lsttp_tapir_WebSocketBodyOutput__f_streams;
      var $x_7 = (x === x$2);
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$3 = this.Lsttp_tapir_WebSocketBodyOutput__f_requests;
      var x$4 = x$0.Lsttp_tapir_WebSocketBodyOutput__f_requests;
      var $x_6 = (x$3 === x$4);
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$5 = this.Lsttp_tapir_WebSocketBodyOutput__f_responses;
      var x$6 = x$0.Lsttp_tapir_WebSocketBodyOutput__f_responses;
      var $x_5 = (x$5 === x$6);
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$7 = this.Lsttp_tapir_WebSocketBodyOutput__f_codec;
      var x$8 = x$0.Lsttp_tapir_WebSocketBodyOutput__f_codec;
      var $x_4 = (x$7 === x$8);
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$9 = this.Lsttp_tapir_WebSocketBodyOutput__f_info;
      var x$10 = x$0.Lsttp_tapir_WebSocketBodyOutput__f_info;
      var $x_3 = ((x$9 === null) ? (x$10 === null) : x$9.equals__O__Z(x$10));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$11 = this.Lsttp_tapir_WebSocketBodyOutput__f_requestsInfo;
      var x$12 = x$0.Lsttp_tapir_WebSocketBodyOutput__f_requestsInfo;
      var $x_2 = ((x$11 === null) ? (x$12 === null) : x$11.equals__O__Z(x$12));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$13 = this.Lsttp_tapir_WebSocketBodyOutput__f_responsesInfo;
      var x$14 = x$0.Lsttp_tapir_WebSocketBodyOutput__f_responsesInfo;
      var $x_1 = ((x$13 === null) ? (x$14 === null) : x$13.equals__O__Z(x$14));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$15 = this.Lsttp_tapir_WebSocketBodyOutput__f_autoPing;
      var x$16 = x$0.Lsttp_tapir_WebSocketBodyOutput__f_autoPing;
      return ((x$15 === null) ? (x$16 === null) : x$15.equals__O__Z(x$16));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_WebSocketBodyOutput.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_WebSocketBodyOutput.prototype.productArity__I = (function() {
  return 13;
});
$c_Lsttp_tapir_WebSocketBodyOutput.prototype.productPrefix__T = (function() {
  return "WebSocketBodyOutput";
});
$c_Lsttp_tapir_WebSocketBodyOutput.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsttp_tapir_WebSocketBodyOutput__f_streams;
      break;
    }
    case 1: {
      return this.Lsttp_tapir_WebSocketBodyOutput__f_requests;
      break;
    }
    case 2: {
      return this.Lsttp_tapir_WebSocketBodyOutput__f_responses;
      break;
    }
    case 3: {
      return this.Lsttp_tapir_WebSocketBodyOutput__f_codec;
      break;
    }
    case 4: {
      return this.Lsttp_tapir_WebSocketBodyOutput__f_info;
      break;
    }
    case 5: {
      return this.Lsttp_tapir_WebSocketBodyOutput__f_requestsInfo;
      break;
    }
    case 6: {
      return this.Lsttp_tapir_WebSocketBodyOutput__f_responsesInfo;
      break;
    }
    case 7: {
      return this.Lsttp_tapir_WebSocketBodyOutput__f_concatenateFragmentedFrames;
      break;
    }
    case 8: {
      return this.Lsttp_tapir_WebSocketBodyOutput__f_ignorePong;
      break;
    }
    case 9: {
      return this.Lsttp_tapir_WebSocketBodyOutput__f_autoPongOnPing;
      break;
    }
    case 10: {
      return this.Lsttp_tapir_WebSocketBodyOutput__f_decodeCloseRequests;
      break;
    }
    case 11: {
      return this.Lsttp_tapir_WebSocketBodyOutput__f_decodeCloseResponses;
      break;
    }
    case 12: {
      return this.Lsttp_tapir_WebSocketBodyOutput__f_autoPing;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_WebSocketBodyOutput.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "streams";
      break;
    }
    case 1: {
      return "requests";
      break;
    }
    case 2: {
      return "responses";
      break;
    }
    case 3: {
      return "codec";
      break;
    }
    case 4: {
      return "info";
      break;
    }
    case 5: {
      return "requestsInfo";
      break;
    }
    case 6: {
      return "responsesInfo";
      break;
    }
    case 7: {
      return "concatenateFragmentedFrames";
      break;
    }
    case 8: {
      return "ignorePong";
      break;
    }
    case 9: {
      return "autoPongOnPing";
      break;
    }
    case 10: {
      return "decodeCloseRequests";
      break;
    }
    case 11: {
      return "decodeCloseResponses";
      break;
    }
    case 12: {
      return "autoPing";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_WebSocketBodyOutput.prototype.codec__Lsttp_tapir_Codec = (function() {
  return this.Lsttp_tapir_WebSocketBodyOutput__f_codec;
});
$c_Lsttp_tapir_WebSocketBodyOutput.prototype.info__Lsttp_tapir_EndpointIO$Info = (function() {
  return this.Lsttp_tapir_WebSocketBodyOutput__f_info;
});
$c_Lsttp_tapir_WebSocketBodyOutput.prototype.copyWith__Lsttp_tapir_Codec__Lsttp_tapir_EndpointIO$Info__Lsttp_tapir_EndpointTransput = (function(c, i) {
  var streams = this.Lsttp_tapir_WebSocketBodyOutput__f_streams;
  var requests = this.Lsttp_tapir_WebSocketBodyOutput__f_requests;
  var responses = this.Lsttp_tapir_WebSocketBodyOutput__f_responses;
  var requestsInfo = this.Lsttp_tapir_WebSocketBodyOutput__f_requestsInfo;
  var responsesInfo = this.Lsttp_tapir_WebSocketBodyOutput__f_responsesInfo;
  var concatenateFragmentedFrames = this.Lsttp_tapir_WebSocketBodyOutput__f_concatenateFragmentedFrames;
  var ignorePong = this.Lsttp_tapir_WebSocketBodyOutput__f_ignorePong;
  var autoPongOnPing = this.Lsttp_tapir_WebSocketBodyOutput__f_autoPongOnPing;
  var decodeCloseRequests = this.Lsttp_tapir_WebSocketBodyOutput__f_decodeCloseRequests;
  var decodeCloseResponses = this.Lsttp_tapir_WebSocketBodyOutput__f_decodeCloseResponses;
  var autoPing = this.Lsttp_tapir_WebSocketBodyOutput__f_autoPing;
  return new $c_Lsttp_tapir_WebSocketBodyOutput(streams, requests, responses, c, i, requestsInfo, responsesInfo, concatenateFragmentedFrames, ignorePong, autoPongOnPing, decodeCloseRequests, decodeCloseResponses, autoPing);
});
function $isArrayOf_Lsttp_tapir_WebSocketBodyOutput(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_WebSocketBodyOutput)));
}
export { $isArrayOf_Lsttp_tapir_WebSocketBodyOutput as $isArrayOf_Lsttp_tapir_WebSocketBodyOutput };
var $d_Lsttp_tapir_WebSocketBodyOutput = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_WebSocketBodyOutput, "sttp.tapir.WebSocketBodyOutput", ({
  Lsttp_tapir_WebSocketBodyOutput: 1,
  Lsttp_tapir_macros_EndpointTransputMacros: 1,
  Lsttp_tapir_EndpointTransput: 1,
  Lsttp_tapir_EndpointTransput$Basic: 1,
  Lsttp_tapir_EndpointTransput$Atom: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_WebSocketBodyOutput as $d_Lsttp_tapir_WebSocketBodyOutput };
function $f_Lcats_Applicative__map__O__F1__O($thiz, fa, f) {
  return $thiz.ap__O__O__O($thiz.pure__O__O(f), fa);
}
export { $f_Lcats_Applicative__map__O__F1__O as $f_Lcats_Applicative__map__O__F1__O };
/** @constructor */
function $c_Lcats_data_KleisliInstances1() {
}
export { $c_Lcats_data_KleisliInstances1 as $c_Lcats_data_KleisliInstances1 };
$c_Lcats_data_KleisliInstances1.prototype = new $h_Lcats_data_KleisliInstances2();
$c_Lcats_data_KleisliInstances1.prototype.constructor = $c_Lcats_data_KleisliInstances1;
/** @constructor */
function $h_Lcats_data_KleisliInstances1() {
}
export { $h_Lcats_data_KleisliInstances1 as $h_Lcats_data_KleisliInstances1 };
$h_Lcats_data_KleisliInstances1.prototype = $c_Lcats_data_KleisliInstances1.prototype;
/** @constructor */
function $c_Lcats_effect_IO$Canceled$() {
}
export { $c_Lcats_effect_IO$Canceled$ as $c_Lcats_effect_IO$Canceled$ };
$c_Lcats_effect_IO$Canceled$.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Canceled$.prototype.constructor = $c_Lcats_effect_IO$Canceled$;
/** @constructor */
function $h_Lcats_effect_IO$Canceled$() {
}
export { $h_Lcats_effect_IO$Canceled$ as $h_Lcats_effect_IO$Canceled$ };
$h_Lcats_effect_IO$Canceled$.prototype = $c_Lcats_effect_IO$Canceled$.prototype;
$c_Lcats_effect_IO$Canceled$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Canceled$.prototype.hashCode__I = (function() {
  return (-58529607);
});
$c_Lcats_effect_IO$Canceled$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_IO$Canceled$.prototype.productPrefix__T = (function() {
  return "Canceled";
});
$c_Lcats_effect_IO$Canceled$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Canceled$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Canceled$.prototype.tag__B = (function() {
  return 10;
});
$c_Lcats_effect_IO$Canceled$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lcats_effect_IO$Canceled$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IO$Canceled$, "cats.effect.IO$Canceled$", ({
  Lcats_effect_IO$Canceled$: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lcats_effect_IO$Canceled$ as $d_Lcats_effect_IO$Canceled$ };
var $n_Lcats_effect_IO$Canceled$;
function $m_Lcats_effect_IO$Canceled$() {
  if ((!$n_Lcats_effect_IO$Canceled$)) {
    $n_Lcats_effect_IO$Canceled$ = new $c_Lcats_effect_IO$Canceled$();
  }
  return $n_Lcats_effect_IO$Canceled$;
}
export { $m_Lcats_effect_IO$Canceled$ as $m_Lcats_effect_IO$Canceled$ };
/** @constructor */
function $c_Lcats_effect_IO$Cede$() {
}
export { $c_Lcats_effect_IO$Cede$ as $c_Lcats_effect_IO$Cede$ };
$c_Lcats_effect_IO$Cede$.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Cede$.prototype.constructor = $c_Lcats_effect_IO$Cede$;
/** @constructor */
function $h_Lcats_effect_IO$Cede$() {
}
export { $h_Lcats_effect_IO$Cede$ as $h_Lcats_effect_IO$Cede$ };
$h_Lcats_effect_IO$Cede$.prototype = $c_Lcats_effect_IO$Cede$.prototype;
$c_Lcats_effect_IO$Cede$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Cede$.prototype.hashCode__I = (function() {
  return 2096259;
});
$c_Lcats_effect_IO$Cede$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_IO$Cede$.prototype.productPrefix__T = (function() {
  return "Cede";
});
$c_Lcats_effect_IO$Cede$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Cede$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Cede$.prototype.tag__B = (function() {
  return 16;
});
$c_Lcats_effect_IO$Cede$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lcats_effect_IO$Cede$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IO$Cede$, "cats.effect.IO$Cede$", ({
  Lcats_effect_IO$Cede$: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lcats_effect_IO$Cede$ as $d_Lcats_effect_IO$Cede$ };
var $n_Lcats_effect_IO$Cede$;
function $m_Lcats_effect_IO$Cede$() {
  if ((!$n_Lcats_effect_IO$Cede$)) {
    $n_Lcats_effect_IO$Cede$ = new $c_Lcats_effect_IO$Cede$();
  }
  return $n_Lcats_effect_IO$Cede$;
}
export { $m_Lcats_effect_IO$Cede$ as $m_Lcats_effect_IO$Cede$ };
/** @constructor */
function $c_Lcats_effect_IO$EndFiber$() {
}
export { $c_Lcats_effect_IO$EndFiber$ as $c_Lcats_effect_IO$EndFiber$ };
$c_Lcats_effect_IO$EndFiber$.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$EndFiber$.prototype.constructor = $c_Lcats_effect_IO$EndFiber$;
/** @constructor */
function $h_Lcats_effect_IO$EndFiber$() {
}
export { $h_Lcats_effect_IO$EndFiber$ as $h_Lcats_effect_IO$EndFiber$ };
$h_Lcats_effect_IO$EndFiber$.prototype = $c_Lcats_effect_IO$EndFiber$.prototype;
$c_Lcats_effect_IO$EndFiber$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$EndFiber$.prototype.hashCode__I = (function() {
  return 1766772977;
});
$c_Lcats_effect_IO$EndFiber$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_IO$EndFiber$.prototype.productPrefix__T = (function() {
  return "EndFiber";
});
$c_Lcats_effect_IO$EndFiber$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$EndFiber$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$EndFiber$.prototype.tag__B = (function() {
  return (-1);
});
$c_Lcats_effect_IO$EndFiber$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lcats_effect_IO$EndFiber$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IO$EndFiber$, "cats.effect.IO$EndFiber$", ({
  Lcats_effect_IO$EndFiber$: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lcats_effect_IO$EndFiber$ as $d_Lcats_effect_IO$EndFiber$ };
var $n_Lcats_effect_IO$EndFiber$;
function $m_Lcats_effect_IO$EndFiber$() {
  if ((!$n_Lcats_effect_IO$EndFiber$)) {
    $n_Lcats_effect_IO$EndFiber$ = new $c_Lcats_effect_IO$EndFiber$();
  }
  return $n_Lcats_effect_IO$EndFiber$;
}
export { $m_Lcats_effect_IO$EndFiber$ as $m_Lcats_effect_IO$EndFiber$ };
/** @constructor */
function $c_Lcats_effect_IO$IOTrace$() {
}
export { $c_Lcats_effect_IO$IOTrace$ as $c_Lcats_effect_IO$IOTrace$ };
$c_Lcats_effect_IO$IOTrace$.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$IOTrace$.prototype.constructor = $c_Lcats_effect_IO$IOTrace$;
/** @constructor */
function $h_Lcats_effect_IO$IOTrace$() {
}
export { $h_Lcats_effect_IO$IOTrace$ as $h_Lcats_effect_IO$IOTrace$ };
$h_Lcats_effect_IO$IOTrace$.prototype = $c_Lcats_effect_IO$IOTrace$.prototype;
$c_Lcats_effect_IO$IOTrace$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$IOTrace$.prototype.hashCode__I = (function() {
  return (-1588936769);
});
$c_Lcats_effect_IO$IOTrace$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_IO$IOTrace$.prototype.productPrefix__T = (function() {
  return "IOTrace";
});
$c_Lcats_effect_IO$IOTrace$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$IOTrace$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$IOTrace$.prototype.tag__B = (function() {
  return 23;
});
$c_Lcats_effect_IO$IOTrace$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lcats_effect_IO$IOTrace$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IO$IOTrace$, "cats.effect.IO$IOTrace$", ({
  Lcats_effect_IO$IOTrace$: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lcats_effect_IO$IOTrace$ as $d_Lcats_effect_IO$IOTrace$ };
var $n_Lcats_effect_IO$IOTrace$;
function $m_Lcats_effect_IO$IOTrace$() {
  if ((!$n_Lcats_effect_IO$IOTrace$)) {
    $n_Lcats_effect_IO$IOTrace$ = new $c_Lcats_effect_IO$IOTrace$();
  }
  return $n_Lcats_effect_IO$IOTrace$;
}
export { $m_Lcats_effect_IO$IOTrace$ as $m_Lcats_effect_IO$IOTrace$ };
/** @constructor */
function $c_Lcats_effect_IO$Monotonic$() {
}
export { $c_Lcats_effect_IO$Monotonic$ as $c_Lcats_effect_IO$Monotonic$ };
$c_Lcats_effect_IO$Monotonic$.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Monotonic$.prototype.constructor = $c_Lcats_effect_IO$Monotonic$;
/** @constructor */
function $h_Lcats_effect_IO$Monotonic$() {
}
export { $h_Lcats_effect_IO$Monotonic$ as $h_Lcats_effect_IO$Monotonic$ };
$h_Lcats_effect_IO$Monotonic$.prototype = $c_Lcats_effect_IO$Monotonic$.prototype;
$c_Lcats_effect_IO$Monotonic$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Monotonic$.prototype.hashCode__I = (function() {
  return 572915850;
});
$c_Lcats_effect_IO$Monotonic$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_IO$Monotonic$.prototype.productPrefix__T = (function() {
  return "Monotonic";
});
$c_Lcats_effect_IO$Monotonic$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Monotonic$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Monotonic$.prototype.tag__B = (function() {
  return 4;
});
$c_Lcats_effect_IO$Monotonic$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lcats_effect_IO$Monotonic$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IO$Monotonic$, "cats.effect.IO$Monotonic$", ({
  Lcats_effect_IO$Monotonic$: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lcats_effect_IO$Monotonic$ as $d_Lcats_effect_IO$Monotonic$ };
var $n_Lcats_effect_IO$Monotonic$;
function $m_Lcats_effect_IO$Monotonic$() {
  if ((!$n_Lcats_effect_IO$Monotonic$)) {
    $n_Lcats_effect_IO$Monotonic$ = new $c_Lcats_effect_IO$Monotonic$();
  }
  return $n_Lcats_effect_IO$Monotonic$;
}
export { $m_Lcats_effect_IO$Monotonic$ as $m_Lcats_effect_IO$Monotonic$ };
/** @constructor */
function $c_Lcats_effect_IO$ReadEC$() {
}
export { $c_Lcats_effect_IO$ReadEC$ as $c_Lcats_effect_IO$ReadEC$ };
$c_Lcats_effect_IO$ReadEC$.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$ReadEC$.prototype.constructor = $c_Lcats_effect_IO$ReadEC$;
/** @constructor */
function $h_Lcats_effect_IO$ReadEC$() {
}
export { $h_Lcats_effect_IO$ReadEC$ as $h_Lcats_effect_IO$ReadEC$ };
$h_Lcats_effect_IO$ReadEC$.prototype = $c_Lcats_effect_IO$ReadEC$.prototype;
$c_Lcats_effect_IO$ReadEC$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$ReadEC$.prototype.hashCode__I = (function() {
  return (-1851113260);
});
$c_Lcats_effect_IO$ReadEC$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_IO$ReadEC$.prototype.productPrefix__T = (function() {
  return "ReadEC";
});
$c_Lcats_effect_IO$ReadEC$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$ReadEC$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$ReadEC$.prototype.tag__B = (function() {
  return 5;
});
$c_Lcats_effect_IO$ReadEC$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lcats_effect_IO$ReadEC$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IO$ReadEC$, "cats.effect.IO$ReadEC$", ({
  Lcats_effect_IO$ReadEC$: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lcats_effect_IO$ReadEC$ as $d_Lcats_effect_IO$ReadEC$ };
var $n_Lcats_effect_IO$ReadEC$;
function $m_Lcats_effect_IO$ReadEC$() {
  if ((!$n_Lcats_effect_IO$ReadEC$)) {
    $n_Lcats_effect_IO$ReadEC$ = new $c_Lcats_effect_IO$ReadEC$();
  }
  return $n_Lcats_effect_IO$ReadEC$;
}
export { $m_Lcats_effect_IO$ReadEC$ as $m_Lcats_effect_IO$ReadEC$ };
/** @constructor */
function $c_Lcats_effect_IO$ReadRT$() {
}
export { $c_Lcats_effect_IO$ReadRT$ as $c_Lcats_effect_IO$ReadRT$ };
$c_Lcats_effect_IO$ReadRT$.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$ReadRT$.prototype.constructor = $c_Lcats_effect_IO$ReadRT$;
/** @constructor */
function $h_Lcats_effect_IO$ReadRT$() {
}
export { $h_Lcats_effect_IO$ReadRT$ as $h_Lcats_effect_IO$ReadRT$ };
$h_Lcats_effect_IO$ReadRT$.prototype = $c_Lcats_effect_IO$ReadRT$.prototype;
$c_Lcats_effect_IO$ReadRT$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$ReadRT$.prototype.hashCode__I = (function() {
  return (-1851112840);
});
$c_Lcats_effect_IO$ReadRT$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_IO$ReadRT$.prototype.productPrefix__T = (function() {
  return "ReadRT";
});
$c_Lcats_effect_IO$ReadRT$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$ReadRT$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$ReadRT$.prototype.tag__B = (function() {
  return 24;
});
$c_Lcats_effect_IO$ReadRT$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lcats_effect_IO$ReadRT$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IO$ReadRT$, "cats.effect.IO$ReadRT$", ({
  Lcats_effect_IO$ReadRT$: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lcats_effect_IO$ReadRT$ as $d_Lcats_effect_IO$ReadRT$ };
var $n_Lcats_effect_IO$ReadRT$;
function $m_Lcats_effect_IO$ReadRT$() {
  if ((!$n_Lcats_effect_IO$ReadRT$)) {
    $n_Lcats_effect_IO$ReadRT$ = new $c_Lcats_effect_IO$ReadRT$();
  }
  return $n_Lcats_effect_IO$ReadRT$;
}
export { $m_Lcats_effect_IO$ReadRT$ as $m_Lcats_effect_IO$ReadRT$ };
/** @constructor */
function $c_Lcats_effect_IO$RealTime$() {
}
export { $c_Lcats_effect_IO$RealTime$ as $c_Lcats_effect_IO$RealTime$ };
$c_Lcats_effect_IO$RealTime$.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$RealTime$.prototype.constructor = $c_Lcats_effect_IO$RealTime$;
/** @constructor */
function $h_Lcats_effect_IO$RealTime$() {
}
export { $h_Lcats_effect_IO$RealTime$ as $h_Lcats_effect_IO$RealTime$ };
$h_Lcats_effect_IO$RealTime$.prototype = $c_Lcats_effect_IO$RealTime$.prototype;
$c_Lcats_effect_IO$RealTime$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$RealTime$.prototype.hashCode__I = (function() {
  return (-795507285);
});
$c_Lcats_effect_IO$RealTime$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_IO$RealTime$.prototype.productPrefix__T = (function() {
  return "RealTime";
});
$c_Lcats_effect_IO$RealTime$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$RealTime$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$RealTime$.prototype.tag__B = (function() {
  return 3;
});
$c_Lcats_effect_IO$RealTime$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lcats_effect_IO$RealTime$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IO$RealTime$, "cats.effect.IO$RealTime$", ({
  Lcats_effect_IO$RealTime$: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lcats_effect_IO$RealTime$ as $d_Lcats_effect_IO$RealTime$ };
var $n_Lcats_effect_IO$RealTime$;
function $m_Lcats_effect_IO$RealTime$() {
  if ((!$n_Lcats_effect_IO$RealTime$)) {
    $n_Lcats_effect_IO$RealTime$ = new $c_Lcats_effect_IO$RealTime$();
  }
  return $n_Lcats_effect_IO$RealTime$;
}
export { $m_Lcats_effect_IO$RealTime$ as $m_Lcats_effect_IO$RealTime$ };
/** @constructor */
function $c_Lcats_instances_EqInstances$$anon$1() {
}
export { $c_Lcats_instances_EqInstances$$anon$1 as $c_Lcats_instances_EqInstances$$anon$1 };
$c_Lcats_instances_EqInstances$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_EqInstances$$anon$1.prototype.constructor = $c_Lcats_instances_EqInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_EqInstances$$anon$1() {
}
export { $h_Lcats_instances_EqInstances$$anon$1 as $h_Lcats_instances_EqInstances$$anon$1 };
$h_Lcats_instances_EqInstances$$anon$1.prototype = $c_Lcats_instances_EqInstances$$anon$1.prototype;
$c_Lcats_instances_EqInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, fi) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_package$();
  return new $c_Lcats_kernel_Eq$$anon$2(fa, fi);
});
$c_Lcats_instances_EqInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return new $c_Lcats_instances_EqInstances$$anon$2(fa, fb, this);
});
var $d_Lcats_instances_EqInstances$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_EqInstances$$anon$1, "cats.instances.EqInstances$$anon$1", ({
  Lcats_instances_EqInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Contravariant: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_ContravariantMonoidal: 1
}));
export { $d_Lcats_instances_EqInstances$$anon$1 as $d_Lcats_instances_EqInstances$$anon$1 };
/** @constructor */
function $c_Lcats_instances_EquivInstances$$anon$1() {
}
export { $c_Lcats_instances_EquivInstances$$anon$1 as $c_Lcats_instances_EquivInstances$$anon$1 };
$c_Lcats_instances_EquivInstances$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_EquivInstances$$anon$1.prototype.constructor = $c_Lcats_instances_EquivInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_EquivInstances$$anon$1() {
}
export { $h_Lcats_instances_EquivInstances$$anon$1 as $h_Lcats_instances_EquivInstances$$anon$1 };
$h_Lcats_instances_EquivInstances$$anon$1.prototype = $c_Lcats_instances_EquivInstances$$anon$1.prototype;
$c_Lcats_instances_EquivInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, fi) {
  return new $c_Lcats_instances_EquivInstances$$anon$3(fa, fi);
});
$c_Lcats_instances_EquivInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return new $c_Lcats_instances_EquivInstances$$anon$4(fa, fb);
});
var $d_Lcats_instances_EquivInstances$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_EquivInstances$$anon$1, "cats.instances.EquivInstances$$anon$1", ({
  Lcats_instances_EquivInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Contravariant: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_ContravariantMonoidal: 1
}));
export { $d_Lcats_instances_EquivInstances$$anon$1 as $d_Lcats_instances_EquivInstances$$anon$1 };
/** @constructor */
function $c_Lcats_instances_InvariantInstances$$anon$13(fa$9, f$5, g$5) {
  this.Lcats_instances_ScalaVersionSpecificNumeric__f_fa = null;
  this.Lcats_instances_ScalaVersionSpecificNumeric__f_f = null;
  this.Lcats_instances_ScalaVersionSpecificNumeric__f_g = null;
  this.Lcats_instances_InvariantInstances$$anon$13__f_f$6 = null;
  this.Lcats_instances_InvariantInstances$$anon$13__f_fa$10 = null;
  this.Lcats_instances_InvariantInstances$$anon$13__f_g$6 = null;
  this.Lcats_instances_InvariantInstances$$anon$13__f_f$6 = f$5;
  this.Lcats_instances_InvariantInstances$$anon$13__f_fa$10 = fa$9;
  this.Lcats_instances_InvariantInstances$$anon$13__f_g$6 = g$5;
  $ct_Lcats_instances_ScalaVersionSpecificNumeric__s_math_Numeric__F1__F1__(this, fa$9, f$5, g$5);
}
export { $c_Lcats_instances_InvariantInstances$$anon$13 as $c_Lcats_instances_InvariantInstances$$anon$13 };
$c_Lcats_instances_InvariantInstances$$anon$13.prototype = new $h_Lcats_instances_ScalaVersionSpecificNumeric();
$c_Lcats_instances_InvariantInstances$$anon$13.prototype.constructor = $c_Lcats_instances_InvariantInstances$$anon$13;
/** @constructor */
function $h_Lcats_instances_InvariantInstances$$anon$13() {
}
export { $h_Lcats_instances_InvariantInstances$$anon$13 as $h_Lcats_instances_InvariantInstances$$anon$13 };
$h_Lcats_instances_InvariantInstances$$anon$13.prototype = $c_Lcats_instances_InvariantInstances$$anon$13.prototype;
$c_Lcats_instances_InvariantInstances$$anon$13.prototype.quot__O__O__O = (function(x, y) {
  return this.Lcats_instances_InvariantInstances$$anon$13__f_f$6.apply__O__O(this.Lcats_instances_InvariantInstances$$anon$13__f_fa$10.quot__O__O__O(this.Lcats_instances_InvariantInstances$$anon$13__f_g$6.apply__O__O(x), this.Lcats_instances_InvariantInstances$$anon$13__f_g$6.apply__O__O(y)));
});
$c_Lcats_instances_InvariantInstances$$anon$13.prototype.rem__O__O__O = (function(x, y) {
  return this.Lcats_instances_InvariantInstances$$anon$13__f_f$6.apply__O__O(this.Lcats_instances_InvariantInstances$$anon$13__f_fa$10.rem__O__O__O(this.Lcats_instances_InvariantInstances$$anon$13__f_g$6.apply__O__O(x), this.Lcats_instances_InvariantInstances$$anon$13__f_g$6.apply__O__O(y)));
});
var $d_Lcats_instances_InvariantInstances$$anon$13 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_InvariantInstances$$anon$13, "cats.instances.InvariantInstances$$anon$13", ({
  Lcats_instances_InvariantInstances$$anon$13: 1,
  Lcats_instances_ScalaVersionSpecificNumeric: 1,
  ju_Comparator: 1,
  Ljava_io_Serializable: 1,
  s_math_Equiv: 1,
  s_math_PartialOrdering: 1,
  s_math_Ordering: 1,
  s_math_Numeric: 1,
  s_math_Integral: 1
}));
export { $d_Lcats_instances_InvariantInstances$$anon$13 as $d_Lcats_instances_InvariantInstances$$anon$13 };
/** @constructor */
function $c_Lcats_instances_OrderInstances$$anon$1() {
}
export { $c_Lcats_instances_OrderInstances$$anon$1 as $c_Lcats_instances_OrderInstances$$anon$1 };
$c_Lcats_instances_OrderInstances$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_OrderInstances$$anon$1.prototype.constructor = $c_Lcats_instances_OrderInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_OrderInstances$$anon$1() {
}
export { $h_Lcats_instances_OrderInstances$$anon$1 as $h_Lcats_instances_OrderInstances$$anon$1 };
$h_Lcats_instances_OrderInstances$$anon$1.prototype = $c_Lcats_instances_OrderInstances$$anon$1.prototype;
$c_Lcats_instances_OrderInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, fi) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_package$();
  return new $c_Lcats_kernel_Order$$anon$2(fa, fi);
});
$c_Lcats_instances_OrderInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return new $c_Lcats_instances_OrderInstances$$anon$2(fa, fb, this);
});
var $d_Lcats_instances_OrderInstances$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_OrderInstances$$anon$1, "cats.instances.OrderInstances$$anon$1", ({
  Lcats_instances_OrderInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Contravariant: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_ContravariantMonoidal: 1
}));
export { $d_Lcats_instances_OrderInstances$$anon$1 as $d_Lcats_instances_OrderInstances$$anon$1 };
/** @constructor */
function $c_Lcats_instances_OrderingInstances$$anon$1() {
}
export { $c_Lcats_instances_OrderingInstances$$anon$1 as $c_Lcats_instances_OrderingInstances$$anon$1 };
$c_Lcats_instances_OrderingInstances$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_OrderingInstances$$anon$1.prototype.constructor = $c_Lcats_instances_OrderingInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_OrderingInstances$$anon$1() {
}
export { $h_Lcats_instances_OrderingInstances$$anon$1 as $h_Lcats_instances_OrderingInstances$$anon$1 };
$h_Lcats_instances_OrderingInstances$$anon$1.prototype = $c_Lcats_instances_OrderingInstances$$anon$1.prototype;
$c_Lcats_instances_OrderingInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, fi) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_math_Ordering$$anon$1(fa, fi);
});
$c_Lcats_instances_OrderingInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return new $c_Lcats_instances_OrderingInstances$$anon$2(fa, fb);
});
var $d_Lcats_instances_OrderingInstances$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_OrderingInstances$$anon$1, "cats.instances.OrderingInstances$$anon$1", ({
  Lcats_instances_OrderingInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Contravariant: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_ContravariantMonoidal: 1
}));
export { $d_Lcats_instances_OrderingInstances$$anon$1 as $d_Lcats_instances_OrderingInstances$$anon$1 };
/** @constructor */
function $c_Lcats_instances_PartialOrderInstances$$anon$1() {
}
export { $c_Lcats_instances_PartialOrderInstances$$anon$1 as $c_Lcats_instances_PartialOrderInstances$$anon$1 };
$c_Lcats_instances_PartialOrderInstances$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_PartialOrderInstances$$anon$1.prototype.constructor = $c_Lcats_instances_PartialOrderInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_PartialOrderInstances$$anon$1() {
}
export { $h_Lcats_instances_PartialOrderInstances$$anon$1 as $h_Lcats_instances_PartialOrderInstances$$anon$1 };
$h_Lcats_instances_PartialOrderInstances$$anon$1.prototype = $c_Lcats_instances_PartialOrderInstances$$anon$1.prototype;
$c_Lcats_instances_PartialOrderInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, fi) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_package$();
  return new $c_Lcats_kernel_PartialOrder$$anon$1(fa, fi);
});
$c_Lcats_instances_PartialOrderInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return new $c_Lcats_instances_PartialOrderInstances$$anon$2(fa, fb, this);
});
var $d_Lcats_instances_PartialOrderInstances$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_PartialOrderInstances$$anon$1, "cats.instances.PartialOrderInstances$$anon$1", ({
  Lcats_instances_PartialOrderInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Contravariant: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_ContravariantMonoidal: 1
}));
export { $d_Lcats_instances_PartialOrderInstances$$anon$1 as $d_Lcats_instances_PartialOrderInstances$$anon$1 };
/** @constructor */
function $c_Lcats_instances_PartialOrderingInstances$$anon$1() {
}
export { $c_Lcats_instances_PartialOrderingInstances$$anon$1 as $c_Lcats_instances_PartialOrderingInstances$$anon$1 };
$c_Lcats_instances_PartialOrderingInstances$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_PartialOrderingInstances$$anon$1.prototype.constructor = $c_Lcats_instances_PartialOrderingInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_PartialOrderingInstances$$anon$1() {
}
export { $h_Lcats_instances_PartialOrderingInstances$$anon$1 as $h_Lcats_instances_PartialOrderingInstances$$anon$1 };
$h_Lcats_instances_PartialOrderingInstances$$anon$1.prototype = $c_Lcats_instances_PartialOrderingInstances$$anon$1.prototype;
$c_Lcats_instances_PartialOrderingInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, fi) {
  return new $c_Lcats_instances_PartialOrderingInstances$$anon$2(fa, fi);
});
$c_Lcats_instances_PartialOrderingInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return new $c_Lcats_instances_PartialOrderingInstances$$anon$3(fa, fb);
});
var $d_Lcats_instances_PartialOrderingInstances$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_PartialOrderingInstances$$anon$1, "cats.instances.PartialOrderingInstances$$anon$1", ({
  Lcats_instances_PartialOrderingInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Contravariant: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_ContravariantMonoidal: 1
}));
export { $d_Lcats_instances_PartialOrderingInstances$$anon$1 as $d_Lcats_instances_PartialOrderingInstances$$anon$1 };
/** @constructor */
function $c_Lcats_kernel_instances_BitSetSemilattice() {
}
export { $c_Lcats_kernel_instances_BitSetSemilattice as $c_Lcats_kernel_instances_BitSetSemilattice };
$c_Lcats_kernel_instances_BitSetSemilattice.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_kernel_instances_BitSetSemilattice.prototype.constructor = $c_Lcats_kernel_instances_BitSetSemilattice;
/** @constructor */
function $h_Lcats_kernel_instances_BitSetSemilattice() {
}
export { $h_Lcats_kernel_instances_BitSetSemilattice as $h_Lcats_kernel_instances_BitSetSemilattice };
$h_Lcats_kernel_instances_BitSetSemilattice.prototype = $c_Lcats_kernel_instances_BitSetSemilattice.prototype;
$c_Lcats_kernel_instances_BitSetSemilattice.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_BitSetSemilattice.prototype.empty__O = (function() {
  return $m_sci_BitSet$().sci_BitSet$__f_empty;
});
$c_Lcats_kernel_instances_BitSetSemilattice.prototype.combine__O__O__O = (function(x, y) {
  return $f_sc_BitSetOps__concat__sc_IterableOnce__sc_BitSet(x, y);
});
var $d_Lcats_kernel_instances_BitSetSemilattice = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_kernel_instances_BitSetSemilattice, "cats.kernel.instances.BitSetSemilattice", ({
  Lcats_kernel_instances_BitSetSemilattice: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Band: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_Semilattice: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_BoundedSemilattice: 1
}));
export { $d_Lcats_kernel_instances_BitSetSemilattice as $d_Lcats_kernel_instances_BitSetSemilattice };
/** @constructor */
function $c_Lcats_kernel_instances_DurationOrder() {
}
export { $c_Lcats_kernel_instances_DurationOrder as $c_Lcats_kernel_instances_DurationOrder };
$c_Lcats_kernel_instances_DurationOrder.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_kernel_instances_DurationOrder.prototype.constructor = $c_Lcats_kernel_instances_DurationOrder;
/** @constructor */
function $h_Lcats_kernel_instances_DurationOrder() {
}
export { $h_Lcats_kernel_instances_DurationOrder as $h_Lcats_kernel_instances_DurationOrder };
$h_Lcats_kernel_instances_DurationOrder.prototype = $c_Lcats_kernel_instances_DurationOrder.prototype;
$c_Lcats_kernel_instances_DurationOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_DurationOrder.prototype.toOrdering__s_math_Ordering = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_kernel_Order$$anon$1(this);
});
$c_Lcats_kernel_instances_DurationOrder.prototype.eqv__s_concurrent_duration_Duration__s_concurrent_duration_Duration__Z = (function(x, y) {
  return ((x === null) ? (y === null) : x.equals__O__Z(y));
});
$c_Lcats_kernel_instances_DurationOrder.prototype.neqv__s_concurrent_duration_Duration__s_concurrent_duration_Duration__Z = (function(x, y) {
  return (!((x === null) ? (y === null) : x.equals__O__Z(y)));
});
$c_Lcats_kernel_instances_DurationOrder.prototype.hash__O__I = (function(x) {
  return x.hashCode__I();
});
$c_Lcats_kernel_instances_DurationOrder.prototype.compare__O__O__I = (function(x, y) {
  return x.compare__s_concurrent_duration_Duration__I(y);
});
$c_Lcats_kernel_instances_DurationOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__s_concurrent_duration_Duration__s_concurrent_duration_Duration__Z(x, y);
});
$c_Lcats_kernel_instances_DurationOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__s_concurrent_duration_Duration__s_concurrent_duration_Duration__Z(x, y);
});
$c_Lcats_kernel_instances_DurationOrder.prototype.gt__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_math_Ordered__$greater__O__Z(x, y);
});
$c_Lcats_kernel_instances_DurationOrder.prototype.lt__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_math_Ordered__$less__O__Z(x, y);
});
var $d_Lcats_kernel_instances_DurationOrder = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_kernel_instances_DurationOrder, "cats.kernel.instances.DurationOrder", ({
  Lcats_kernel_instances_DurationOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_DurationBounded: 1
}));
export { $d_Lcats_kernel_instances_DurationOrder as $d_Lcats_kernel_instances_DurationOrder };
/** @constructor */
function $c_Lcats_kernel_instances_FiniteDurationOrder() {
}
export { $c_Lcats_kernel_instances_FiniteDurationOrder as $c_Lcats_kernel_instances_FiniteDurationOrder };
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.constructor = $c_Lcats_kernel_instances_FiniteDurationOrder;
/** @constructor */
function $h_Lcats_kernel_instances_FiniteDurationOrder() {
}
export { $h_Lcats_kernel_instances_FiniteDurationOrder as $h_Lcats_kernel_instances_FiniteDurationOrder };
$h_Lcats_kernel_instances_FiniteDurationOrder.prototype = $c_Lcats_kernel_instances_FiniteDurationOrder.prototype;
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.toOrdering__s_math_Ordering = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_kernel_Order$$anon$1(this);
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.eqv__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration__Z = (function(x, y) {
  return ((x === null) ? (y === null) : x.equals__O__Z(y));
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.neqv__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration__Z = (function(x, y) {
  return (!((x === null) ? (y === null) : x.equals__O__Z(y)));
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.hash__O__I = (function(x) {
  var a = x.s_concurrent_duration_FiniteDuration__f_unit.toNanos__J__J(x.s_concurrent_duration_FiniteDuration__f_length);
  return a.RTLong__f_lo;
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.compare__O__O__I = (function(x, y) {
  return x.compare__s_concurrent_duration_Duration__I(y);
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration__Z(x, y);
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration__Z(x, y);
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.gt__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_math_Ordered__$greater__O__Z(x, y);
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.lt__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_math_Ordered__$less__O__Z(x, y);
});
var $d_Lcats_kernel_instances_FiniteDurationOrder = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_kernel_instances_FiniteDurationOrder, "cats.kernel.instances.FiniteDurationOrder", ({
  Lcats_kernel_instances_FiniteDurationOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_FiniteDurationBounded: 1
}));
export { $d_Lcats_kernel_instances_FiniteDurationOrder as $d_Lcats_kernel_instances_FiniteDurationOrder };
/** @constructor */
function $c_Lframework_data_AuthLoadingStatus$Loading$() {
}
export { $c_Lframework_data_AuthLoadingStatus$Loading$ as $c_Lframework_data_AuthLoadingStatus$Loading$ };
$c_Lframework_data_AuthLoadingStatus$Loading$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_AuthLoadingStatus$Loading$.prototype.constructor = $c_Lframework_data_AuthLoadingStatus$Loading$;
/** @constructor */
function $h_Lframework_data_AuthLoadingStatus$Loading$() {
}
export { $h_Lframework_data_AuthLoadingStatus$Loading$ as $h_Lframework_data_AuthLoadingStatus$Loading$ };
$h_Lframework_data_AuthLoadingStatus$Loading$.prototype = $c_Lframework_data_AuthLoadingStatus$Loading$.prototype;
$c_Lframework_data_AuthLoadingStatus$Loading$.prototype.isLoading__Z = (function() {
  return $f_Lframework_data_AuthLoadingStatus__isLoading__Z(this);
});
$c_Lframework_data_AuthLoadingStatus$Loading$.prototype.toLoadedOption__s_Option = (function() {
  return $f_Lframework_data_AuthLoadingStatus__toLoadedOption__s_Option(this);
});
$c_Lframework_data_AuthLoadingStatus$Loading$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_data_AuthLoadingStatus$Loading$.prototype.hashCode__I = (function() {
  return 2001303836;
});
$c_Lframework_data_AuthLoadingStatus$Loading$.prototype.toString__T = (function() {
  return "Loading";
});
$c_Lframework_data_AuthLoadingStatus$Loading$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lframework_data_AuthLoadingStatus$Loading$.prototype.productPrefix__T = (function() {
  return "Loading";
});
$c_Lframework_data_AuthLoadingStatus$Loading$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_AuthLoadingStatus$Loading$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_AuthLoadingStatus$Loading$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lframework_data_AuthLoadingStatus$Loading$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_AuthLoadingStatus$Loading$, "framework.data.AuthLoadingStatus$Loading$", ({
  Lframework_data_AuthLoadingStatus$Loading$: 1,
  Lframework_data_LoadingStatus: 1,
  Lframework_data_AuthLoadingStatus: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lframework_data_AuthLoadingStatus$Loading$ as $d_Lframework_data_AuthLoadingStatus$Loading$ };
var $n_Lframework_data_AuthLoadingStatus$Loading$;
function $m_Lframework_data_AuthLoadingStatus$Loading$() {
  if ((!$n_Lframework_data_AuthLoadingStatus$Loading$)) {
    $n_Lframework_data_AuthLoadingStatus$Loading$ = new $c_Lframework_data_AuthLoadingStatus$Loading$();
  }
  return $n_Lframework_data_AuthLoadingStatus$Loading$;
}
export { $m_Lframework_data_AuthLoadingStatus$Loading$ as $m_Lframework_data_AuthLoadingStatus$Loading$ };
/** @constructor */
function $c_Lframework_data_AuthLoadingStatus$NetworkError$() {
}
export { $c_Lframework_data_AuthLoadingStatus$NetworkError$ as $c_Lframework_data_AuthLoadingStatus$NetworkError$ };
$c_Lframework_data_AuthLoadingStatus$NetworkError$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_AuthLoadingStatus$NetworkError$.prototype.constructor = $c_Lframework_data_AuthLoadingStatus$NetworkError$;
/** @constructor */
function $h_Lframework_data_AuthLoadingStatus$NetworkError$() {
}
export { $h_Lframework_data_AuthLoadingStatus$NetworkError$ as $h_Lframework_data_AuthLoadingStatus$NetworkError$ };
$h_Lframework_data_AuthLoadingStatus$NetworkError$.prototype = $c_Lframework_data_AuthLoadingStatus$NetworkError$.prototype;
$c_Lframework_data_AuthLoadingStatus$NetworkError$.prototype.isLoading__Z = (function() {
  return $f_Lframework_data_AuthLoadingStatus__isLoading__Z(this);
});
$c_Lframework_data_AuthLoadingStatus$NetworkError$.prototype.toLoadedOption__s_Option = (function() {
  return $f_Lframework_data_AuthLoadingStatus__toLoadedOption__s_Option(this);
});
$c_Lframework_data_AuthLoadingStatus$NetworkError$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_data_AuthLoadingStatus$NetworkError$.prototype.hashCode__I = (function() {
  return 120785050;
});
$c_Lframework_data_AuthLoadingStatus$NetworkError$.prototype.toString__T = (function() {
  return "NetworkError";
});
$c_Lframework_data_AuthLoadingStatus$NetworkError$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lframework_data_AuthLoadingStatus$NetworkError$.prototype.productPrefix__T = (function() {
  return "NetworkError";
});
$c_Lframework_data_AuthLoadingStatus$NetworkError$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_AuthLoadingStatus$NetworkError$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_AuthLoadingStatus$NetworkError$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lframework_data_AuthLoadingStatus$NetworkError$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_AuthLoadingStatus$NetworkError$, "framework.data.AuthLoadingStatus$NetworkError$", ({
  Lframework_data_AuthLoadingStatus$NetworkError$: 1,
  Lframework_data_LoadingStatus: 1,
  Lframework_data_AuthLoadingStatus: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lframework_data_AuthLoadingStatus$NetworkError$ as $d_Lframework_data_AuthLoadingStatus$NetworkError$ };
var $n_Lframework_data_AuthLoadingStatus$NetworkError$;
function $m_Lframework_data_AuthLoadingStatus$NetworkError$() {
  if ((!$n_Lframework_data_AuthLoadingStatus$NetworkError$)) {
    $n_Lframework_data_AuthLoadingStatus$NetworkError$ = new $c_Lframework_data_AuthLoadingStatus$NetworkError$();
  }
  return $n_Lframework_data_AuthLoadingStatus$NetworkError$;
}
export { $m_Lframework_data_AuthLoadingStatus$NetworkError$ as $m_Lframework_data_AuthLoadingStatus$NetworkError$ };
/** @constructor */
function $c_Lframework_data_AuthLoadingStatus$NotFound$() {
}
export { $c_Lframework_data_AuthLoadingStatus$NotFound$ as $c_Lframework_data_AuthLoadingStatus$NotFound$ };
$c_Lframework_data_AuthLoadingStatus$NotFound$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_AuthLoadingStatus$NotFound$.prototype.constructor = $c_Lframework_data_AuthLoadingStatus$NotFound$;
/** @constructor */
function $h_Lframework_data_AuthLoadingStatus$NotFound$() {
}
export { $h_Lframework_data_AuthLoadingStatus$NotFound$ as $h_Lframework_data_AuthLoadingStatus$NotFound$ };
$h_Lframework_data_AuthLoadingStatus$NotFound$.prototype = $c_Lframework_data_AuthLoadingStatus$NotFound$.prototype;
$c_Lframework_data_AuthLoadingStatus$NotFound$.prototype.isLoading__Z = (function() {
  return $f_Lframework_data_AuthLoadingStatus__isLoading__Z(this);
});
$c_Lframework_data_AuthLoadingStatus$NotFound$.prototype.toLoadedOption__s_Option = (function() {
  return $f_Lframework_data_AuthLoadingStatus__toLoadedOption__s_Option(this);
});
$c_Lframework_data_AuthLoadingStatus$NotFound$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_data_AuthLoadingStatus$NotFound$.prototype.hashCode__I = (function() {
  return 1617964175;
});
$c_Lframework_data_AuthLoadingStatus$NotFound$.prototype.toString__T = (function() {
  return "NotFound";
});
$c_Lframework_data_AuthLoadingStatus$NotFound$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lframework_data_AuthLoadingStatus$NotFound$.prototype.productPrefix__T = (function() {
  return "NotFound";
});
$c_Lframework_data_AuthLoadingStatus$NotFound$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_AuthLoadingStatus$NotFound$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_AuthLoadingStatus$NotFound$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lframework_data_AuthLoadingStatus$NotFound$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_AuthLoadingStatus$NotFound$, "framework.data.AuthLoadingStatus$NotFound$", ({
  Lframework_data_AuthLoadingStatus$NotFound$: 1,
  Lframework_data_LoadingStatus: 1,
  Lframework_data_AuthLoadingStatus: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lframework_data_AuthLoadingStatus$NotFound$ as $d_Lframework_data_AuthLoadingStatus$NotFound$ };
var $n_Lframework_data_AuthLoadingStatus$NotFound$;
function $m_Lframework_data_AuthLoadingStatus$NotFound$() {
  if ((!$n_Lframework_data_AuthLoadingStatus$NotFound$)) {
    $n_Lframework_data_AuthLoadingStatus$NotFound$ = new $c_Lframework_data_AuthLoadingStatus$NotFound$();
  }
  return $n_Lframework_data_AuthLoadingStatus$NotFound$;
}
export { $m_Lframework_data_AuthLoadingStatus$NotFound$ as $m_Lframework_data_AuthLoadingStatus$NotFound$ };
/** @constructor */
function $c_Lframework_data_AuthLoadingStatus$Unauthenticated$() {
}
export { $c_Lframework_data_AuthLoadingStatus$Unauthenticated$ as $c_Lframework_data_AuthLoadingStatus$Unauthenticated$ };
$c_Lframework_data_AuthLoadingStatus$Unauthenticated$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_AuthLoadingStatus$Unauthenticated$.prototype.constructor = $c_Lframework_data_AuthLoadingStatus$Unauthenticated$;
/** @constructor */
function $h_Lframework_data_AuthLoadingStatus$Unauthenticated$() {
}
export { $h_Lframework_data_AuthLoadingStatus$Unauthenticated$ as $h_Lframework_data_AuthLoadingStatus$Unauthenticated$ };
$h_Lframework_data_AuthLoadingStatus$Unauthenticated$.prototype = $c_Lframework_data_AuthLoadingStatus$Unauthenticated$.prototype;
$c_Lframework_data_AuthLoadingStatus$Unauthenticated$.prototype.isLoading__Z = (function() {
  return $f_Lframework_data_AuthLoadingStatus__isLoading__Z(this);
});
$c_Lframework_data_AuthLoadingStatus$Unauthenticated$.prototype.toLoadedOption__s_Option = (function() {
  return $f_Lframework_data_AuthLoadingStatus__toLoadedOption__s_Option(this);
});
$c_Lframework_data_AuthLoadingStatus$Unauthenticated$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_data_AuthLoadingStatus$Unauthenticated$.prototype.hashCode__I = (function() {
  return 1331011094;
});
$c_Lframework_data_AuthLoadingStatus$Unauthenticated$.prototype.toString__T = (function() {
  return "Unauthenticated";
});
$c_Lframework_data_AuthLoadingStatus$Unauthenticated$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lframework_data_AuthLoadingStatus$Unauthenticated$.prototype.productPrefix__T = (function() {
  return "Unauthenticated";
});
$c_Lframework_data_AuthLoadingStatus$Unauthenticated$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_AuthLoadingStatus$Unauthenticated$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_AuthLoadingStatus$Unauthenticated$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lframework_data_AuthLoadingStatus$Unauthenticated$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_AuthLoadingStatus$Unauthenticated$, "framework.data.AuthLoadingStatus$Unauthenticated$", ({
  Lframework_data_AuthLoadingStatus$Unauthenticated$: 1,
  Lframework_data_LoadingStatus: 1,
  Lframework_data_AuthLoadingStatus: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lframework_data_AuthLoadingStatus$Unauthenticated$ as $d_Lframework_data_AuthLoadingStatus$Unauthenticated$ };
var $n_Lframework_data_AuthLoadingStatus$Unauthenticated$;
function $m_Lframework_data_AuthLoadingStatus$Unauthenticated$() {
  if ((!$n_Lframework_data_AuthLoadingStatus$Unauthenticated$)) {
    $n_Lframework_data_AuthLoadingStatus$Unauthenticated$ = new $c_Lframework_data_AuthLoadingStatus$Unauthenticated$();
  }
  return $n_Lframework_data_AuthLoadingStatus$Unauthenticated$;
}
export { $m_Lframework_data_AuthLoadingStatus$Unauthenticated$ as $m_Lframework_data_AuthLoadingStatus$Unauthenticated$ };
/** @constructor */
function $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide(outer, clientData, serverData, maybeRedirectToAfterRegistration) {
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_clientData = null;
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_serverData = null;
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_maybeRedirectToAfterRegistration = null;
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_$outer = null;
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_clientData = clientData;
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_serverData = serverData;
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_maybeRedirectToAfterRegistration = maybeRedirectToAfterRegistration;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_$outer = outer;
}
export { $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide as $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide };
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide.prototype.constructor = $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide;
/** @constructor */
function $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide() {
}
export { $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide as $h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide };
$h_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide.prototype = $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide.prototype;
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide.prototype.toString__T = (function() {
  return $f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__toString__T(this);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-548945910), true);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide) && (x$0.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_$outer === this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_$outer))) {
    var x = this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_clientData;
    var y = x$0.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_clientData;
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_serverData;
      var y$1 = x$0.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_serverData;
      var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y$1);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$2 = this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_maybeRedirectToAfterRegistration;
      var x$2$1 = x$0.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_maybeRedirectToAfterRegistration;
      return ((x$2 === null) ? (x$2$1 === null) : x$2.equals__O__Z(x$2$1));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide.prototype.productArity__I = (function() {
  return 3;
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide.prototype.productPrefix__T = (function() {
  return "AuthenticatedInClientSideButNotServerSide";
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_clientData;
      break;
    }
    case 1: {
      return this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_serverData;
      break;
    }
    case 2: {
      return this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_maybeRedirectToAfterRegistration;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "clientData";
      break;
    }
    case 1: {
      return "serverData";
      break;
    }
    case 2: {
      return "maybeRedirectToAfterRegistration";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide.prototype.clientData__O = (function() {
  return this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_clientData;
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide.prototype.maybeRedirectToAfterRegistration__s_Option = (function() {
  return this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_maybeRedirectToAfterRegistration;
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide.prototype.copy__O__O__s_Option__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide = (function(clientData, serverData, maybeRedirectToAfterRegistration) {
  return new $c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide(this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_$outer, clientData, serverData, maybeRedirectToAfterRegistration);
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide.prototype.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth = (function() {
  return this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_$outer.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$__f_$outer;
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide.prototype.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasRespondedState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth = (function() {
  return this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_$outer.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$__f_$outer;
});
$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide.prototype.framework$data$AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasSucceededState$$$outer__Lframework_data_AuthPlatformForClientAndServerSideAuth = (function() {
  return this.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide__f_$outer.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$__f_$outer;
});
function $isArrayOf_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide)));
}
export { $isArrayOf_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide as $isArrayOf_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide };
var $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide, "framework.data.AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide", ({
  Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide: 1,
  Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState: 1,
  Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasRespondedState: 1,
  Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasSucceededState: 1,
  Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthServerSideHasRespondedState: 1,
  Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthHasFailedState: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide as $d_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$AuthenticatedInClientSideButNotServerSide };
/** @constructor */
function $c_Lframework_data_LocalLoadingStatus$Loading$() {
}
export { $c_Lframework_data_LocalLoadingStatus$Loading$ as $c_Lframework_data_LocalLoadingStatus$Loading$ };
$c_Lframework_data_LocalLoadingStatus$Loading$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_data_LocalLoadingStatus$Loading$.prototype.constructor = $c_Lframework_data_LocalLoadingStatus$Loading$;
/** @constructor */
function $h_Lframework_data_LocalLoadingStatus$Loading$() {
}
export { $h_Lframework_data_LocalLoadingStatus$Loading$ as $h_Lframework_data_LocalLoadingStatus$Loading$ };
$h_Lframework_data_LocalLoadingStatus$Loading$.prototype = $c_Lframework_data_LocalLoadingStatus$Loading$.prototype;
$c_Lframework_data_LocalLoadingStatus$Loading$.prototype.isLoading__Z = (function() {
  return $f_Lframework_data_LocalLoadingStatus__isLoading__Z(this);
});
$c_Lframework_data_LocalLoadingStatus$Loading$.prototype.toLoadedOption__s_Option = (function() {
  return $f_Lframework_data_LocalLoadingStatus__toLoadedOption__s_Option(this);
});
$c_Lframework_data_LocalLoadingStatus$Loading$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lframework_data_LocalLoadingStatus$Loading$.prototype.hashCode__I = (function() {
  return 2001303836;
});
$c_Lframework_data_LocalLoadingStatus$Loading$.prototype.toString__T = (function() {
  return "Loading";
});
$c_Lframework_data_LocalLoadingStatus$Loading$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lframework_data_LocalLoadingStatus$Loading$.prototype.productPrefix__T = (function() {
  return "Loading";
});
$c_Lframework_data_LocalLoadingStatus$Loading$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_LocalLoadingStatus$Loading$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_LocalLoadingStatus$Loading$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lframework_data_LocalLoadingStatus$Loading$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_LocalLoadingStatus$Loading$, "framework.data.LocalLoadingStatus$Loading$", ({
  Lframework_data_LocalLoadingStatus$Loading$: 1,
  Lframework_data_LoadingStatus: 1,
  Lframework_data_LocalLoadingStatus: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lframework_data_LocalLoadingStatus$Loading$ as $d_Lframework_data_LocalLoadingStatus$Loading$ };
var $n_Lframework_data_LocalLoadingStatus$Loading$;
function $m_Lframework_data_LocalLoadingStatus$Loading$() {
  if ((!$n_Lframework_data_LocalLoadingStatus$Loading$)) {
    $n_Lframework_data_LocalLoadingStatus$Loading$ = new $c_Lframework_data_LocalLoadingStatus$Loading$();
  }
  return $n_Lframework_data_LocalLoadingStatus$Loading$;
}
export { $m_Lframework_data_LocalLoadingStatus$Loading$ as $m_Lframework_data_LocalLoadingStatus$Loading$ };
/** @constructor */
function $c_Lfs2_Pull$CanceledScope(scopeId, inter) {
  this.Lfs2_Pull$CanceledScope__f_scopeId = null;
  this.Lfs2_Pull$CanceledScope__f_inter = null;
  this.Lfs2_Pull$CanceledScope__f_scopeId = scopeId;
  this.Lfs2_Pull$CanceledScope__f_inter = inter;
}
export { $c_Lfs2_Pull$CanceledScope as $c_Lfs2_Pull$CanceledScope };
$c_Lfs2_Pull$CanceledScope.prototype = new $h_Lfs2_Pull$CloseScope();
$c_Lfs2_Pull$CanceledScope.prototype.constructor = $c_Lfs2_Pull$CanceledScope;
/** @constructor */
function $h_Lfs2_Pull$CanceledScope() {
}
export { $h_Lfs2_Pull$CanceledScope as $h_Lfs2_Pull$CanceledScope };
$h_Lfs2_Pull$CanceledScope.prototype = $c_Lfs2_Pull$CanceledScope.prototype;
$c_Lfs2_Pull$CanceledScope.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$CanceledScope.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1271109854), true);
});
$c_Lfs2_Pull$CanceledScope.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$CanceledScope)) {
    var x = this.Lfs2_Pull$CanceledScope__f_scopeId;
    var x$2 = x$0.Lfs2_Pull$CanceledScope__f_scopeId;
    if ((x === x$2)) {
      var x$3 = this.Lfs2_Pull$CanceledScope__f_inter;
      var x$4 = x$0.Lfs2_Pull$CanceledScope__f_inter;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lfs2_Pull$CanceledScope.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$CanceledScope.prototype.productArity__I = (function() {
  return 2;
});
$c_Lfs2_Pull$CanceledScope.prototype.productPrefix__T = (function() {
  return "CanceledScope";
});
$c_Lfs2_Pull$CanceledScope.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$CanceledScope__f_scopeId;
  }
  if ((n === 1)) {
    return this.Lfs2_Pull$CanceledScope__f_inter;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lfs2_Pull$CanceledScope.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "scopeId";
  }
  if ((n === 1)) {
    return "inter";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lfs2_Pull$CanceledScope.prototype.scopeId__Lcats_effect_kernel_Unique$Token = (function() {
  return this.Lfs2_Pull$CanceledScope__f_scopeId;
});
$c_Lfs2_Pull$CanceledScope.prototype.exitCase__Lcats_effect_kernel_Resource$ExitCase = (function() {
  return $m_Lcats_effect_kernel_Resource$ExitCase$Canceled$();
});
$c_Lfs2_Pull$CanceledScope.prototype.interruption__s_Option = (function() {
  var value = this.Lfs2_Pull$CanceledScope__f_inter;
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
});
function $isArrayOf_Lfs2_Pull$CanceledScope(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$CanceledScope)));
}
export { $isArrayOf_Lfs2_Pull$CanceledScope as $isArrayOf_Lfs2_Pull$CanceledScope };
var $d_Lfs2_Pull$CanceledScope = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$CanceledScope, "fs2.Pull$CanceledScope", ({
  Lfs2_Pull$CanceledScope: 1,
  Lfs2_Pull$CloseScope: 1,
  Lfs2_Pull$AlgEffect: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lfs2_Pull$CanceledScope as $d_Lfs2_Pull$CanceledScope };
/** @constructor */
function $c_Lfs2_Pull$FailedScope(scopeId, err) {
  this.Lfs2_Pull$FailedScope__f_scopeId = null;
  this.Lfs2_Pull$FailedScope__f_err = null;
  this.Lfs2_Pull$FailedScope__f_scopeId = scopeId;
  this.Lfs2_Pull$FailedScope__f_err = err;
}
export { $c_Lfs2_Pull$FailedScope as $c_Lfs2_Pull$FailedScope };
$c_Lfs2_Pull$FailedScope.prototype = new $h_Lfs2_Pull$CloseScope();
$c_Lfs2_Pull$FailedScope.prototype.constructor = $c_Lfs2_Pull$FailedScope;
/** @constructor */
function $h_Lfs2_Pull$FailedScope() {
}
export { $h_Lfs2_Pull$FailedScope as $h_Lfs2_Pull$FailedScope };
$h_Lfs2_Pull$FailedScope.prototype = $c_Lfs2_Pull$FailedScope.prototype;
$c_Lfs2_Pull$FailedScope.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$FailedScope.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1732783656), true);
});
$c_Lfs2_Pull$FailedScope.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$FailedScope)) {
    var x = this.Lfs2_Pull$FailedScope__f_scopeId;
    var x$2 = x$0.Lfs2_Pull$FailedScope__f_scopeId;
    if ((x === x$2)) {
      var x$3 = this.Lfs2_Pull$FailedScope__f_err;
      var x$4 = x$0.Lfs2_Pull$FailedScope__f_err;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lfs2_Pull$FailedScope.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$FailedScope.prototype.productArity__I = (function() {
  return 2;
});
$c_Lfs2_Pull$FailedScope.prototype.productPrefix__T = (function() {
  return "FailedScope";
});
$c_Lfs2_Pull$FailedScope.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$FailedScope__f_scopeId;
  }
  if ((n === 1)) {
    return this.Lfs2_Pull$FailedScope__f_err;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lfs2_Pull$FailedScope.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "scopeId";
  }
  if ((n === 1)) {
    return "err";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lfs2_Pull$FailedScope.prototype.scopeId__Lcats_effect_kernel_Unique$Token = (function() {
  return this.Lfs2_Pull$FailedScope__f_scopeId;
});
$c_Lfs2_Pull$FailedScope.prototype.exitCase__Lcats_effect_kernel_Resource$ExitCase = (function() {
  var e = this.Lfs2_Pull$FailedScope__f_err;
  return new $c_Lcats_effect_kernel_Resource$ExitCase$Errored(e);
});
$c_Lfs2_Pull$FailedScope.prototype.interruption__s_Option = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
});
function $isArrayOf_Lfs2_Pull$FailedScope(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$FailedScope)));
}
export { $isArrayOf_Lfs2_Pull$FailedScope as $isArrayOf_Lfs2_Pull$FailedScope };
var $d_Lfs2_Pull$FailedScope = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$FailedScope, "fs2.Pull$FailedScope", ({
  Lfs2_Pull$FailedScope: 1,
  Lfs2_Pull$CloseScope: 1,
  Lfs2_Pull$AlgEffect: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lfs2_Pull$FailedScope as $d_Lfs2_Pull$FailedScope };
/** @constructor */
function $c_Lfs2_Pull$SucceedScope(scopeId) {
  this.Lfs2_Pull$SucceedScope__f_scopeId = null;
  this.Lfs2_Pull$SucceedScope__f_scopeId = scopeId;
}
export { $c_Lfs2_Pull$SucceedScope as $c_Lfs2_Pull$SucceedScope };
$c_Lfs2_Pull$SucceedScope.prototype = new $h_Lfs2_Pull$CloseScope();
$c_Lfs2_Pull$SucceedScope.prototype.constructor = $c_Lfs2_Pull$SucceedScope;
/** @constructor */
function $h_Lfs2_Pull$SucceedScope() {
}
export { $h_Lfs2_Pull$SucceedScope as $h_Lfs2_Pull$SucceedScope };
$h_Lfs2_Pull$SucceedScope.prototype = $c_Lfs2_Pull$SucceedScope.prototype;
$c_Lfs2_Pull$SucceedScope.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$SucceedScope.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1718393090, true);
});
$c_Lfs2_Pull$SucceedScope.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$SucceedScope)) {
    var x = this.Lfs2_Pull$SucceedScope__f_scopeId;
    var x$2 = x$0.Lfs2_Pull$SucceedScope__f_scopeId;
    return (x === x$2);
  } else {
    return false;
  }
});
$c_Lfs2_Pull$SucceedScope.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$SucceedScope.prototype.productArity__I = (function() {
  return 1;
});
$c_Lfs2_Pull$SucceedScope.prototype.productPrefix__T = (function() {
  return "SucceedScope";
});
$c_Lfs2_Pull$SucceedScope.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$SucceedScope__f_scopeId;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lfs2_Pull$SucceedScope.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "scopeId";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lfs2_Pull$SucceedScope.prototype.scopeId__Lcats_effect_kernel_Unique$Token = (function() {
  return this.Lfs2_Pull$SucceedScope__f_scopeId;
});
$c_Lfs2_Pull$SucceedScope.prototype.exitCase__Lcats_effect_kernel_Resource$ExitCase = (function() {
  return $m_Lcats_effect_kernel_Resource$ExitCase$Succeeded$();
});
$c_Lfs2_Pull$SucceedScope.prototype.interruption__s_Option = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
});
function $isArrayOf_Lfs2_Pull$SucceedScope(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$SucceedScope)));
}
export { $isArrayOf_Lfs2_Pull$SucceedScope as $isArrayOf_Lfs2_Pull$SucceedScope };
var $d_Lfs2_Pull$SucceedScope = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Pull$SucceedScope, "fs2.Pull$SucceedScope", ({
  Lfs2_Pull$SucceedScope: 1,
  Lfs2_Pull$CloseScope: 1,
  Lfs2_Pull$AlgEffect: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lfs2_Pull$SucceedScope as $d_Lfs2_Pull$SucceedScope };
function $f_Lmonocle_PIso__modify__F1__F1($thiz, f) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s) => $thiz.reverseGet__O__O(f.apply__O__O($thiz.get__O__O(s)))));
}
export { $f_Lmonocle_PIso__modify__F1__F1 as $f_Lmonocle_PIso__modify__F1__F1 };
function $f_Lmonocle_PIso__replace__O__F1($thiz, b) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$4) => $thiz.reverseGet__O__O(b)));
}
export { $f_Lmonocle_PIso__replace__O__F1 as $f_Lmonocle_PIso__replace__O__F1 };
function $f_sci_StrictOptimizedSetOps__concat__sc_IterableOnce__sci_SetOps($thiz, that) {
  var result = $thiz;
  var it = that.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var this$1 = result;
    var elem = it.next__O();
    result = this$1.incl__O__sci_SetOps(elem);
  }
  return result;
}
export { $f_sci_StrictOptimizedSetOps__concat__sc_IterableOnce__sci_SetOps as $f_sci_StrictOptimizedSetOps__concat__sc_IterableOnce__sci_SetOps };
/** @constructor */
function $c_Lsttp_tapir_RawBodyType$ByteBufferBody$() {
}
export { $c_Lsttp_tapir_RawBodyType$ByteBufferBody$ as $c_Lsttp_tapir_RawBodyType$ByteBufferBody$ };
$c_Lsttp_tapir_RawBodyType$ByteBufferBody$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_RawBodyType$ByteBufferBody$.prototype.constructor = $c_Lsttp_tapir_RawBodyType$ByteBufferBody$;
/** @constructor */
function $h_Lsttp_tapir_RawBodyType$ByteBufferBody$() {
}
export { $h_Lsttp_tapir_RawBodyType$ByteBufferBody$ as $h_Lsttp_tapir_RawBodyType$ByteBufferBody$ };
$h_Lsttp_tapir_RawBodyType$ByteBufferBody$.prototype = $c_Lsttp_tapir_RawBodyType$ByteBufferBody$.prototype;
$c_Lsttp_tapir_RawBodyType$ByteBufferBody$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_RawBodyType$ByteBufferBody$.prototype.hashCode__I = (function() {
  return 440303946;
});
$c_Lsttp_tapir_RawBodyType$ByteBufferBody$.prototype.toString__T = (function() {
  return "ByteBufferBody";
});
$c_Lsttp_tapir_RawBodyType$ByteBufferBody$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_tapir_RawBodyType$ByteBufferBody$.prototype.productPrefix__T = (function() {
  return "ByteBufferBody";
});
$c_Lsttp_tapir_RawBodyType$ByteBufferBody$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_RawBodyType$ByteBufferBody$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_RawBodyType$ByteBufferBody$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_tapir_RawBodyType$ByteBufferBody$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_RawBodyType$ByteBufferBody$, "sttp.tapir.RawBodyType$ByteBufferBody$", ({
  Lsttp_tapir_RawBodyType$ByteBufferBody$: 1,
  Lsttp_tapir_RawBodyType: 1,
  Lsttp_tapir_RawBodyType$Binary: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_tapir_RawBodyType$ByteBufferBody$ as $d_Lsttp_tapir_RawBodyType$ByteBufferBody$ };
var $n_Lsttp_tapir_RawBodyType$ByteBufferBody$;
function $m_Lsttp_tapir_RawBodyType$ByteBufferBody$() {
  if ((!$n_Lsttp_tapir_RawBodyType$ByteBufferBody$)) {
    $n_Lsttp_tapir_RawBodyType$ByteBufferBody$ = new $c_Lsttp_tapir_RawBodyType$ByteBufferBody$();
  }
  return $n_Lsttp_tapir_RawBodyType$ByteBufferBody$;
}
export { $m_Lsttp_tapir_RawBodyType$ByteBufferBody$ as $m_Lsttp_tapir_RawBodyType$ByteBufferBody$ };
/** @constructor */
function $c_Lsttp_tapir_RawBodyType$FileBody$() {
}
export { $c_Lsttp_tapir_RawBodyType$FileBody$ as $c_Lsttp_tapir_RawBodyType$FileBody$ };
$c_Lsttp_tapir_RawBodyType$FileBody$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_RawBodyType$FileBody$.prototype.constructor = $c_Lsttp_tapir_RawBodyType$FileBody$;
/** @constructor */
function $h_Lsttp_tapir_RawBodyType$FileBody$() {
}
export { $h_Lsttp_tapir_RawBodyType$FileBody$ as $h_Lsttp_tapir_RawBodyType$FileBody$ };
$h_Lsttp_tapir_RawBodyType$FileBody$.prototype = $c_Lsttp_tapir_RawBodyType$FileBody$.prototype;
$c_Lsttp_tapir_RawBodyType$FileBody$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_RawBodyType$FileBody$.prototype.hashCode__I = (function() {
  return (-671422114);
});
$c_Lsttp_tapir_RawBodyType$FileBody$.prototype.toString__T = (function() {
  return "FileBody";
});
$c_Lsttp_tapir_RawBodyType$FileBody$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_tapir_RawBodyType$FileBody$.prototype.productPrefix__T = (function() {
  return "FileBody";
});
$c_Lsttp_tapir_RawBodyType$FileBody$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_RawBodyType$FileBody$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_RawBodyType$FileBody$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_tapir_RawBodyType$FileBody$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_RawBodyType$FileBody$, "sttp.tapir.RawBodyType$FileBody$", ({
  Lsttp_tapir_RawBodyType$FileBody$: 1,
  Lsttp_tapir_RawBodyType: 1,
  Lsttp_tapir_RawBodyType$Binary: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_tapir_RawBodyType$FileBody$ as $d_Lsttp_tapir_RawBodyType$FileBody$ };
var $n_Lsttp_tapir_RawBodyType$FileBody$;
function $m_Lsttp_tapir_RawBodyType$FileBody$() {
  if ((!$n_Lsttp_tapir_RawBodyType$FileBody$)) {
    $n_Lsttp_tapir_RawBodyType$FileBody$ = new $c_Lsttp_tapir_RawBodyType$FileBody$();
  }
  return $n_Lsttp_tapir_RawBodyType$FileBody$;
}
export { $m_Lsttp_tapir_RawBodyType$FileBody$ as $m_Lsttp_tapir_RawBodyType$FileBody$ };
/** @constructor */
function $c_Lsttp_tapir_RawBodyType$InputStreamBody$() {
}
export { $c_Lsttp_tapir_RawBodyType$InputStreamBody$ as $c_Lsttp_tapir_RawBodyType$InputStreamBody$ };
$c_Lsttp_tapir_RawBodyType$InputStreamBody$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_RawBodyType$InputStreamBody$.prototype.constructor = $c_Lsttp_tapir_RawBodyType$InputStreamBody$;
/** @constructor */
function $h_Lsttp_tapir_RawBodyType$InputStreamBody$() {
}
export { $h_Lsttp_tapir_RawBodyType$InputStreamBody$ as $h_Lsttp_tapir_RawBodyType$InputStreamBody$ };
$h_Lsttp_tapir_RawBodyType$InputStreamBody$.prototype = $c_Lsttp_tapir_RawBodyType$InputStreamBody$.prototype;
$c_Lsttp_tapir_RawBodyType$InputStreamBody$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_RawBodyType$InputStreamBody$.prototype.hashCode__I = (function() {
  return 831878284;
});
$c_Lsttp_tapir_RawBodyType$InputStreamBody$.prototype.toString__T = (function() {
  return "InputStreamBody";
});
$c_Lsttp_tapir_RawBodyType$InputStreamBody$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_tapir_RawBodyType$InputStreamBody$.prototype.productPrefix__T = (function() {
  return "InputStreamBody";
});
$c_Lsttp_tapir_RawBodyType$InputStreamBody$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_RawBodyType$InputStreamBody$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_RawBodyType$InputStreamBody$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_tapir_RawBodyType$InputStreamBody$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_RawBodyType$InputStreamBody$, "sttp.tapir.RawBodyType$InputStreamBody$", ({
  Lsttp_tapir_RawBodyType$InputStreamBody$: 1,
  Lsttp_tapir_RawBodyType: 1,
  Lsttp_tapir_RawBodyType$Binary: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_tapir_RawBodyType$InputStreamBody$ as $d_Lsttp_tapir_RawBodyType$InputStreamBody$ };
var $n_Lsttp_tapir_RawBodyType$InputStreamBody$;
function $m_Lsttp_tapir_RawBodyType$InputStreamBody$() {
  if ((!$n_Lsttp_tapir_RawBodyType$InputStreamBody$)) {
    $n_Lsttp_tapir_RawBodyType$InputStreamBody$ = new $c_Lsttp_tapir_RawBodyType$InputStreamBody$();
  }
  return $n_Lsttp_tapir_RawBodyType$InputStreamBody$;
}
export { $m_Lsttp_tapir_RawBodyType$InputStreamBody$ as $m_Lsttp_tapir_RawBodyType$InputStreamBody$ };
/** @constructor */
function $c_Lsttp_tapir_RawBodyType$InputStreamRangeBody$() {
}
export { $c_Lsttp_tapir_RawBodyType$InputStreamRangeBody$ as $c_Lsttp_tapir_RawBodyType$InputStreamRangeBody$ };
$c_Lsttp_tapir_RawBodyType$InputStreamRangeBody$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_RawBodyType$InputStreamRangeBody$.prototype.constructor = $c_Lsttp_tapir_RawBodyType$InputStreamRangeBody$;
/** @constructor */
function $h_Lsttp_tapir_RawBodyType$InputStreamRangeBody$() {
}
export { $h_Lsttp_tapir_RawBodyType$InputStreamRangeBody$ as $h_Lsttp_tapir_RawBodyType$InputStreamRangeBody$ };
$h_Lsttp_tapir_RawBodyType$InputStreamRangeBody$.prototype = $c_Lsttp_tapir_RawBodyType$InputStreamRangeBody$.prototype;
$c_Lsttp_tapir_RawBodyType$InputStreamRangeBody$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_RawBodyType$InputStreamRangeBody$.prototype.hashCode__I = (function() {
  return (-226097195);
});
$c_Lsttp_tapir_RawBodyType$InputStreamRangeBody$.prototype.toString__T = (function() {
  return "InputStreamRangeBody";
});
$c_Lsttp_tapir_RawBodyType$InputStreamRangeBody$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_tapir_RawBodyType$InputStreamRangeBody$.prototype.productPrefix__T = (function() {
  return "InputStreamRangeBody";
});
$c_Lsttp_tapir_RawBodyType$InputStreamRangeBody$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_RawBodyType$InputStreamRangeBody$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_RawBodyType$InputStreamRangeBody$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_tapir_RawBodyType$InputStreamRangeBody$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_RawBodyType$InputStreamRangeBody$, "sttp.tapir.RawBodyType$InputStreamRangeBody$", ({
  Lsttp_tapir_RawBodyType$InputStreamRangeBody$: 1,
  Lsttp_tapir_RawBodyType: 1,
  Lsttp_tapir_RawBodyType$Binary: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_tapir_RawBodyType$InputStreamRangeBody$ as $d_Lsttp_tapir_RawBodyType$InputStreamRangeBody$ };
var $n_Lsttp_tapir_RawBodyType$InputStreamRangeBody$;
function $m_Lsttp_tapir_RawBodyType$InputStreamRangeBody$() {
  if ((!$n_Lsttp_tapir_RawBodyType$InputStreamRangeBody$)) {
    $n_Lsttp_tapir_RawBodyType$InputStreamRangeBody$ = new $c_Lsttp_tapir_RawBodyType$InputStreamRangeBody$();
  }
  return $n_Lsttp_tapir_RawBodyType$InputStreamRangeBody$;
}
export { $m_Lsttp_tapir_RawBodyType$InputStreamRangeBody$ as $m_Lsttp_tapir_RawBodyType$InputStreamRangeBody$ };
/** @constructor */
function $c_Lcats_data_AndThenInstances0$$anon$1() {
  $m_Lcats_instances_package$all$();
}
export { $c_Lcats_data_AndThenInstances0$$anon$1 as $c_Lcats_data_AndThenInstances0$$anon$1 };
$c_Lcats_data_AndThenInstances0$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_data_AndThenInstances0$$anon$1.prototype.constructor = $c_Lcats_data_AndThenInstances0$$anon$1;
/** @constructor */
function $h_Lcats_data_AndThenInstances0$$anon$1() {
}
export { $h_Lcats_data_AndThenInstances0$$anon$1 as $h_Lcats_data_AndThenInstances0$$anon$1 };
$h_Lcats_data_AndThenInstances0$$anon$1.prototype = $c_Lcats_data_AndThenInstances0$$anon$1.prototype;
$c_Lcats_data_AndThenInstances0$$anon$1.prototype.id__O = (function() {
  return $f_Lcats_arrow_Arrow__id__O(this);
});
$c_Lcats_data_AndThenInstances0$$anon$1.prototype.lift__F1__O = (function(f) {
  return $m_Lcats_data_AndThen$().apply__F1__Lcats_data_AndThen(f);
});
$c_Lcats_data_AndThenInstances0$$anon$1.prototype.compose__O__O__O = (function(f, g) {
  return $m_Lcats_data_AndThen$().andThen__Lcats_data_AndThen__Lcats_data_AndThen__Lcats_data_AndThen(g, f);
});
var $d_Lcats_data_AndThenInstances0$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_data_AndThenInstances0$$anon$1, "cats.data.AndThenInstances0$$anon$1", ({
  Lcats_data_AndThenInstances0$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_Compose: 1,
  Lcats_arrow_Category: 1,
  Lcats_arrow_Profunctor: 1,
  Lcats_arrow_Strong: 1,
  Lcats_arrow_Arrow: 1,
  Lcats_arrow_Choice: 1,
  Lcats_arrow_ArrowChoice: 1,
  Lcats_arrow_CommutativeArrow: 1
}));
export { $d_Lcats_data_AndThenInstances0$$anon$1 as $d_Lcats_data_AndThenInstances0$$anon$1 };
/** @constructor */
function $c_Lcats_data_KleisliInstances0\uff3f5() {
}
export { $c_Lcats_data_KleisliInstances0\uff3f5 as $c_Lcats_data_KleisliInstances0\uff3f5 };
$c_Lcats_data_KleisliInstances0\uff3f5.prototype = new $h_Lcats_data_KleisliInstances1();
$c_Lcats_data_KleisliInstances0\uff3f5.prototype.constructor = $c_Lcats_data_KleisliInstances0\uff3f5;
/** @constructor */
function $h_Lcats_data_KleisliInstances0\uff3f5() {
}
export { $h_Lcats_data_KleisliInstances0\uff3f5 as $h_Lcats_data_KleisliInstances0\uff3f5 };
$h_Lcats_data_KleisliInstances0\uff3f5.prototype = $c_Lcats_data_KleisliInstances0\uff3f5.prototype;
/** @constructor */
function $c_Lcats_instances_Function1Instances$$anon$6() {
}
export { $c_Lcats_instances_Function1Instances$$anon$6 as $c_Lcats_instances_Function1Instances$$anon$6 };
$c_Lcats_instances_Function1Instances$$anon$6.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_Function1Instances$$anon$6.prototype.constructor = $c_Lcats_instances_Function1Instances$$anon$6;
/** @constructor */
function $h_Lcats_instances_Function1Instances$$anon$6() {
}
export { $h_Lcats_instances_Function1Instances$$anon$6 as $h_Lcats_instances_Function1Instances$$anon$6 };
$h_Lcats_instances_Function1Instances$$anon$6.prototype = $c_Lcats_instances_Function1Instances$$anon$6.prototype;
$c_Lcats_instances_Function1Instances$$anon$6.prototype.id__O = (function() {
  return $f_Lcats_arrow_Arrow__id__O(this);
});
$c_Lcats_instances_Function1Instances$$anon$6.prototype.lift__F1__O = (function(f) {
  return f;
});
$c_Lcats_instances_Function1Instances$$anon$6.prototype.compose__O__O__O = (function(f, g) {
  return f.compose__F1__F1(g);
});
var $d_Lcats_instances_Function1Instances$$anon$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_Function1Instances$$anon$6, "cats.instances.Function1Instances$$anon$6", ({
  Lcats_instances_Function1Instances$$anon$6: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_Compose: 1,
  Lcats_arrow_Category: 1,
  Lcats_arrow_Profunctor: 1,
  Lcats_arrow_Strong: 1,
  Lcats_arrow_Arrow: 1,
  Lcats_arrow_Choice: 1,
  Lcats_arrow_ArrowChoice: 1,
  Lcats_arrow_CommutativeArrow: 1
}));
export { $d_Lcats_instances_Function1Instances$$anon$6 as $d_Lcats_instances_Function1Instances$$anon$6 };
function $f_Lcom_raquo_airstream_common_MultiParentSignal___parentLastUpdateIds__Lcom_raquo_ew_JsArray($thiz) {
  return $thiz.Lcom_raquo_airstream_combine_CombineSignalN__f_parents.map(((_$1) => _$1._lastUpdateId__I()));
}
export { $f_Lcom_raquo_airstream_common_MultiParentSignal___parentLastUpdateIds__Lcom_raquo_ew_JsArray as $f_Lcom_raquo_airstream_common_MultiParentSignal___parentLastUpdateIds__Lcom_raquo_ew_JsArray };
function $f_Lcom_raquo_airstream_common_MultiParentSignal__onWillStart__V($thiz) {
  var arr = $thiz.Lcom_raquo_airstream_combine_CombineSignalN__f_parents;
  var i = 0;
  var len = (arr.length | 0);
  while ((i < len)) {
    var _$2 = arr[i];
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(_$2);
    i = ((1 + i) | 0);
  }
  var shouldPullFromParent = $f_Lcom_raquo_airstream_common_MultiParentSignal__updateParentLastUpdateIds__Z($thiz);
  if (shouldPullFromParent) {
    $f_Lcom_raquo_airstream_common_MultiParentSignal__updateCurrentValueFromParent__V($thiz);
  }
}
export { $f_Lcom_raquo_airstream_common_MultiParentSignal__onWillStart__V as $f_Lcom_raquo_airstream_common_MultiParentSignal__onWillStart__V };
function $f_Lcom_raquo_airstream_common_MultiParentSignal__updateParentLastUpdateIds__Z($thiz) {
  var elem = false;
  elem = false;
  var arr = $thiz.Lcom_raquo_airstream_combine_CombineSignalN__f_parents;
  var i = 0;
  var len = (arr.length | 0);
  while ((i < len)) {
    var parent = arr[i];
    var ix = i;
    var newLastUpdateId = parent._lastUpdateId__I();
    var lastSeenParentUpdateId = ($thiz._parentLastUpdateIds__Lcom_raquo_ew_JsArray()[ix] | 0);
    if ((newLastUpdateId !== lastSeenParentUpdateId)) {
      $thiz._parentLastUpdateIds__Lcom_raquo_ew_JsArray()[ix] = newLastUpdateId;
      elem = true;
    }
    i = ((1 + i) | 0);
  }
  return elem;
}
export { $f_Lcom_raquo_airstream_common_MultiParentSignal__updateParentLastUpdateIds__Z as $f_Lcom_raquo_airstream_common_MultiParentSignal__updateParentLastUpdateIds__Z };
function $f_Lcom_raquo_airstream_common_MultiParentSignal__updateCurrentValueFromParent__V($thiz) {
  var nextValue = $thiz.combinedValue__s_util_Try();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableSignal__setCurrentValue__s_util_Try__V($thiz, nextValue);
}
export { $f_Lcom_raquo_airstream_common_MultiParentSignal__updateCurrentValueFromParent__V as $f_Lcom_raquo_airstream_common_MultiParentSignal__updateCurrentValueFromParent__V };
/** @constructor */
function $c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1__f_$name$1 = null;
  this.Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1__f__$ordinal$1 = 0;
  this.Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1__f_$name$1 = \u03b4name$2;
  this.Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1__f__$ordinal$1 = _$ordinal$2;
}
export { $c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1 as $c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1 };
$c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1.prototype = new $h_Lframework_auth_SupabaseAuthClient$AuthChangeEvent();
$c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1.prototype.constructor = $c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1;
/** @constructor */
function $h_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1() {
}
export { $h_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1 as $h_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1 };
$h_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1.prototype = $c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1.prototype;
$c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1.prototype.productArity__I = (function() {
  return 0;
});
$c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1.prototype.productElement__I__O = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1.prototype.productElementName__I__T = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1.prototype.productPrefix__T = (function() {
  return this.Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1__f_$name$1;
});
$c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1.prototype.toString__T = (function() {
  return this.Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1__f_$name$1;
});
$c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I(this.Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1__f_$name$1);
});
$c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1, "framework.auth.SupabaseAuthClient$AuthChangeEvent$$anon$1", ({
  Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1: 1,
  Lframework_auth_SupabaseAuthClient$AuthChangeEvent: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1 as $d_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$$anon$1 };
/** @constructor */
function $c_Lframework_components_ToastType$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.Lframework_components_ToastType$$anon$1__f_$name$1 = null;
  this.Lframework_components_ToastType$$anon$1__f__$ordinal$1 = 0;
  this.Lframework_components_ToastType$$anon$1__f_$name$1 = \u03b4name$2;
  this.Lframework_components_ToastType$$anon$1__f__$ordinal$1 = _$ordinal$2;
}
export { $c_Lframework_components_ToastType$$anon$1 as $c_Lframework_components_ToastType$$anon$1 };
$c_Lframework_components_ToastType$$anon$1.prototype = new $h_Lframework_components_ToastType();
$c_Lframework_components_ToastType$$anon$1.prototype.constructor = $c_Lframework_components_ToastType$$anon$1;
/** @constructor */
function $h_Lframework_components_ToastType$$anon$1() {
}
export { $h_Lframework_components_ToastType$$anon$1 as $h_Lframework_components_ToastType$$anon$1 };
$h_Lframework_components_ToastType$$anon$1.prototype = $c_Lframework_components_ToastType$$anon$1.prototype;
$c_Lframework_components_ToastType$$anon$1.prototype.productArity__I = (function() {
  return 0;
});
$c_Lframework_components_ToastType$$anon$1.prototype.productElement__I__O = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Lframework_components_ToastType$$anon$1.prototype.productElementName__I__T = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Lframework_components_ToastType$$anon$1.prototype.productPrefix__T = (function() {
  return this.Lframework_components_ToastType$$anon$1__f_$name$1;
});
$c_Lframework_components_ToastType$$anon$1.prototype.toString__T = (function() {
  return this.Lframework_components_ToastType$$anon$1__f_$name$1;
});
$c_Lframework_components_ToastType$$anon$1.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I(this.Lframework_components_ToastType$$anon$1__f_$name$1);
});
$c_Lframework_components_ToastType$$anon$1.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lframework_components_ToastType$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_components_ToastType$$anon$1, "framework.components.ToastType$$anon$1", ({
  Lframework_components_ToastType$$anon$1: 1,
  Lframework_components_ToastType: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lframework_components_ToastType$$anon$1 as $d_Lframework_components_ToastType$$anon$1 };
/** @constructor */
function $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$$anon$1(\u03b4name$3, _$ordinal$3) {
  this.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$$anon$1__f_$name$1 = null;
  this.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$$anon$1__f__$ordinal$1 = 0;
  this.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$$anon$1__f_$name$1 = \u03b4name$3;
  this.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$$anon$1__f__$ordinal$1 = _$ordinal$3;
}
export { $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$$anon$1 as $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$$anon$1 };
$c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$$anon$1.prototype = new $h_Lframework_data_EndpointSSEWithWS$ClientConnectionMode();
$c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$$anon$1.prototype.constructor = $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$$anon$1;
/** @constructor */
function $h_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$$anon$1() {
}
export { $h_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$$anon$1 as $h_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$$anon$1 };
$h_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$$anon$1.prototype = $c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$$anon$1.prototype;
$c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$$anon$1.prototype.productArity__I = (function() {
  return 0;
});
$c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$$anon$1.prototype.productElement__I__O = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$$anon$1.prototype.productElementName__I__T = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$$anon$1.prototype.productPrefix__T = (function() {
  return this.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$$anon$1__f_$name$1;
});
$c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$$anon$1.prototype.toString__T = (function() {
  return this.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$$anon$1__f_$name$1;
});
$c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$$anon$1.prototype.ordinal__I = (function() {
  return this.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$$anon$1__f__$ordinal$1;
});
$c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$$anon$1.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I(this.Lframework_data_EndpointSSEWithWS$ClientConnectionMode$$anon$1__f_$name$1);
});
$c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$$anon$1.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$$anon$1, "framework.data.EndpointSSEWithWS$ClientConnectionMode$$anon$1", ({
  Lframework_data_EndpointSSEWithWS$ClientConnectionMode$$anon$1: 1,
  Lframework_data_EndpointSSEWithWS$ClientConnectionMode: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$$anon$1 as $d_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$$anon$1 };
/** @constructor */
function $c_Lframework_exts_OnSSEStreamError$OnErrorAction$$anon$2() {
}
export { $c_Lframework_exts_OnSSEStreamError$OnErrorAction$$anon$2 as $c_Lframework_exts_OnSSEStreamError$OnErrorAction$$anon$2 };
$c_Lframework_exts_OnSSEStreamError$OnErrorAction$$anon$2.prototype = new $h_Lframework_exts_OnSSEStreamError$OnErrorAction();
$c_Lframework_exts_OnSSEStreamError$OnErrorAction$$anon$2.prototype.constructor = $c_Lframework_exts_OnSSEStreamError$OnErrorAction$$anon$2;
/** @constructor */
function $h_Lframework_exts_OnSSEStreamError$OnErrorAction$$anon$2() {
}
export { $h_Lframework_exts_OnSSEStreamError$OnErrorAction$$anon$2 as $h_Lframework_exts_OnSSEStreamError$OnErrorAction$$anon$2 };
$h_Lframework_exts_OnSSEStreamError$OnErrorAction$$anon$2.prototype = $c_Lframework_exts_OnSSEStreamError$OnErrorAction$$anon$2.prototype;
$c_Lframework_exts_OnSSEStreamError$OnErrorAction$$anon$2.prototype.productArity__I = (function() {
  return 0;
});
$c_Lframework_exts_OnSSEStreamError$OnErrorAction$$anon$2.prototype.productElement__I__O = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Lframework_exts_OnSSEStreamError$OnErrorAction$$anon$2.prototype.productElementName__I__T = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Lframework_exts_OnSSEStreamError$OnErrorAction$$anon$2.prototype.productPrefix__T = (function() {
  return "Stop";
});
$c_Lframework_exts_OnSSEStreamError$OnErrorAction$$anon$2.prototype.toString__T = (function() {
  return "Stop";
});
$c_Lframework_exts_OnSSEStreamError$OnErrorAction$$anon$2.prototype.ordinal__I = (function() {
  return 2;
});
$c_Lframework_exts_OnSSEStreamError$OnErrorAction$$anon$2.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I("Stop");
});
$c_Lframework_exts_OnSSEStreamError$OnErrorAction$$anon$2.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lframework_exts_OnSSEStreamError$OnErrorAction$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_exts_OnSSEStreamError$OnErrorAction$$anon$2, "framework.exts.OnSSEStreamError$OnErrorAction$$anon$2", ({
  Lframework_exts_OnSSEStreamError$OnErrorAction$$anon$2: 1,
  Lframework_exts_OnSSEStreamError$OnErrorAction: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lframework_exts_OnSSEStreamError$OnErrorAction$$anon$2 as $d_Lframework_exts_OnSSEStreamError$OnErrorAction$$anon$2 };
/** @constructor */
function $c_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$() {
}
export { $c_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$ as $c_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$ };
$c_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$.prototype.constructor = $c_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$;
/** @constructor */
function $h_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$() {
}
export { $h_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$ as $h_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$ };
$h_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$.prototype = $c_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$.prototype;
$c_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return $f_Lcats_Applicative__map__O__F1__O(this, fa, f);
});
$c_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$.prototype.void__O__O = (function(fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$.prototype.as__O__O__O = (function(fa, b) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$.prototype.productL__O__O__O = (function(fa, fb) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Apply__productL__O__O__O(this, fa, fb);
});
$c_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$.prototype.product__O__O__O = (function(fa, fb) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Apply__product__O__O__O(this, fa, fb);
});
$c_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Apply__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Apply__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$.prototype.unit__O = (function() {
  return $m_Lcom_raquo_airstream_state_Val$().apply__O__Lcom_raquo_airstream_state_Val((void 0));
});
$c_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$.prototype.map__O__F1__O = (function(fa, f) {
  return $f_Lcats_Applicative__map__O__F1__O(this, fa, f);
});
$c_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$.prototype.compose__Lcats_Applicative__Lcats_Applicative = (function(evidence$1) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Applicative$$anon$1(evidence$1, this);
});
$c_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$.prototype.ap__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_core_Signal = (function(ff, fa) {
  var combinator = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((x$1, x$2) => x$2.apply__O__O(x$1)));
  return $m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().combineWithFn__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_Source$SignalSource__F2__Lcom_raquo_airstream_core_Signal(fa, ff, combinator);
});
$c_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$.prototype.pure__O__O = (function(x) {
  return $m_Lcom_raquo_airstream_state_Val$().apply__O__Lcom_raquo_airstream_state_Val(x);
});
$c_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$.prototype.ap__O__O__O = (function(ff, fa) {
  return this.ap__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_core_Signal(ff, fa);
});
var $d_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$, "framework.prelude.SignalInstances$package$given_Applicative_Signal$", ({
  Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1
}));
export { $d_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$ as $d_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$ };
var $n_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$;
function $m_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$() {
  if ((!$n_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$)) {
    $n_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$ = new $c_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$();
  }
  return $n_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$;
}
export { $m_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$ as $m_Lframework_prelude_SignalInstances$package$given\uff3fApplicative\uff3fSignal$ };
/** @constructor */
function $c_Lframework_utils_AuthenticatedNetworkRequestFailure$$anon$1() {
}
export { $c_Lframework_utils_AuthenticatedNetworkRequestFailure$$anon$1 as $c_Lframework_utils_AuthenticatedNetworkRequestFailure$$anon$1 };
$c_Lframework_utils_AuthenticatedNetworkRequestFailure$$anon$1.prototype = new $h_Lframework_utils_AuthenticatedNetworkRequestFailure();
$c_Lframework_utils_AuthenticatedNetworkRequestFailure$$anon$1.prototype.constructor = $c_Lframework_utils_AuthenticatedNetworkRequestFailure$$anon$1;
/** @constructor */
function $h_Lframework_utils_AuthenticatedNetworkRequestFailure$$anon$1() {
}
export { $h_Lframework_utils_AuthenticatedNetworkRequestFailure$$anon$1 as $h_Lframework_utils_AuthenticatedNetworkRequestFailure$$anon$1 };
$h_Lframework_utils_AuthenticatedNetworkRequestFailure$$anon$1.prototype = $c_Lframework_utils_AuthenticatedNetworkRequestFailure$$anon$1.prototype;
$c_Lframework_utils_AuthenticatedNetworkRequestFailure$$anon$1.prototype.productArity__I = (function() {
  return 0;
});
$c_Lframework_utils_AuthenticatedNetworkRequestFailure$$anon$1.prototype.productElement__I__O = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Lframework_utils_AuthenticatedNetworkRequestFailure$$anon$1.prototype.productElementName__I__T = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Lframework_utils_AuthenticatedNetworkRequestFailure$$anon$1.prototype.productPrefix__T = (function() {
  return "Aborted";
});
$c_Lframework_utils_AuthenticatedNetworkRequestFailure$$anon$1.prototype.toString__T = (function() {
  return "Aborted";
});
$c_Lframework_utils_AuthenticatedNetworkRequestFailure$$anon$1.prototype.ordinal__I = (function() {
  return 1;
});
$c_Lframework_utils_AuthenticatedNetworkRequestFailure$$anon$1.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I("Aborted");
});
$c_Lframework_utils_AuthenticatedNetworkRequestFailure$$anon$1.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lframework_utils_AuthenticatedNetworkRequestFailure$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_AuthenticatedNetworkRequestFailure$$anon$1, "framework.utils.AuthenticatedNetworkRequestFailure$$anon$1", ({
  Lframework_utils_AuthenticatedNetworkRequestFailure$$anon$1: 1,
  Lframework_utils_AuthenticatedNetworkRequestFailure: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lframework_utils_AuthenticatedNetworkRequestFailure$$anon$1 as $d_Lframework_utils_AuthenticatedNetworkRequestFailure$$anon$1 };
/** @constructor */
function $c_Lframework_utils_BrowserDetection$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.Lframework_utils_BrowserDetection$$anon$1__f_$name$1 = null;
  this.Lframework_utils_BrowserDetection$$anon$1__f__$ordinal$1 = 0;
  this.Lframework_utils_BrowserDetection$$anon$1__f_$name$1 = \u03b4name$2;
  this.Lframework_utils_BrowserDetection$$anon$1__f__$ordinal$1 = _$ordinal$2;
}
export { $c_Lframework_utils_BrowserDetection$$anon$1 as $c_Lframework_utils_BrowserDetection$$anon$1 };
$c_Lframework_utils_BrowserDetection$$anon$1.prototype = new $h_Lframework_utils_BrowserDetection();
$c_Lframework_utils_BrowserDetection$$anon$1.prototype.constructor = $c_Lframework_utils_BrowserDetection$$anon$1;
/** @constructor */
function $h_Lframework_utils_BrowserDetection$$anon$1() {
}
export { $h_Lframework_utils_BrowserDetection$$anon$1 as $h_Lframework_utils_BrowserDetection$$anon$1 };
$h_Lframework_utils_BrowserDetection$$anon$1.prototype = $c_Lframework_utils_BrowserDetection$$anon$1.prototype;
$c_Lframework_utils_BrowserDetection$$anon$1.prototype.productArity__I = (function() {
  return 0;
});
$c_Lframework_utils_BrowserDetection$$anon$1.prototype.productElement__I__O = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Lframework_utils_BrowserDetection$$anon$1.prototype.productElementName__I__T = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Lframework_utils_BrowserDetection$$anon$1.prototype.productPrefix__T = (function() {
  return this.Lframework_utils_BrowserDetection$$anon$1__f_$name$1;
});
$c_Lframework_utils_BrowserDetection$$anon$1.prototype.toString__T = (function() {
  return this.Lframework_utils_BrowserDetection$$anon$1__f_$name$1;
});
$c_Lframework_utils_BrowserDetection$$anon$1.prototype.ordinal__I = (function() {
  return this.Lframework_utils_BrowserDetection$$anon$1__f__$ordinal$1;
});
$c_Lframework_utils_BrowserDetection$$anon$1.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I(this.Lframework_utils_BrowserDetection$$anon$1__f_$name$1);
});
$c_Lframework_utils_BrowserDetection$$anon$1.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lframework_utils_BrowserDetection$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_BrowserDetection$$anon$1, "framework.utils.BrowserDetection$$anon$1", ({
  Lframework_utils_BrowserDetection$$anon$1: 1,
  Lframework_utils_BrowserDetection: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lframework_utils_BrowserDetection$$anon$1 as $d_Lframework_utils_BrowserDetection$$anon$1 };
/** @constructor */
function $c_Lframework_utils_LogLevel$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.Lframework_utils_LogLevel$$anon$1__f_$name$1 = null;
  this.Lframework_utils_LogLevel$$anon$1__f__$ordinal$1 = 0;
  this.Lframework_utils_LogLevel$$anon$1__f_$name$1 = \u03b4name$2;
  this.Lframework_utils_LogLevel$$anon$1__f__$ordinal$1 = _$ordinal$2;
}
export { $c_Lframework_utils_LogLevel$$anon$1 as $c_Lframework_utils_LogLevel$$anon$1 };
$c_Lframework_utils_LogLevel$$anon$1.prototype = new $h_Lframework_utils_LogLevel();
$c_Lframework_utils_LogLevel$$anon$1.prototype.constructor = $c_Lframework_utils_LogLevel$$anon$1;
/** @constructor */
function $h_Lframework_utils_LogLevel$$anon$1() {
}
export { $h_Lframework_utils_LogLevel$$anon$1 as $h_Lframework_utils_LogLevel$$anon$1 };
$h_Lframework_utils_LogLevel$$anon$1.prototype = $c_Lframework_utils_LogLevel$$anon$1.prototype;
$c_Lframework_utils_LogLevel$$anon$1.prototype.productArity__I = (function() {
  return 0;
});
$c_Lframework_utils_LogLevel$$anon$1.prototype.productElement__I__O = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Lframework_utils_LogLevel$$anon$1.prototype.productElementName__I__T = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Lframework_utils_LogLevel$$anon$1.prototype.productPrefix__T = (function() {
  return this.Lframework_utils_LogLevel$$anon$1__f_$name$1;
});
$c_Lframework_utils_LogLevel$$anon$1.prototype.toString__T = (function() {
  return this.Lframework_utils_LogLevel$$anon$1__f_$name$1;
});
$c_Lframework_utils_LogLevel$$anon$1.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I(this.Lframework_utils_LogLevel$$anon$1__f_$name$1);
});
$c_Lframework_utils_LogLevel$$anon$1.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lframework_utils_LogLevel$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_LogLevel$$anon$1, "framework.utils.LogLevel$$anon$1", ({
  Lframework_utils_LogLevel$$anon$1: 1,
  Lframework_utils_LogLevel: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lframework_utils_LogLevel$$anon$1 as $d_Lframework_utils_LogLevel$$anon$1 };
/** @constructor */
function $c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$$anon$3(\u03b4name$2, _$ordinal$2) {
  this.Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$$anon$3__f_$name$1 = null;
  this.Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$$anon$3__f__$ordinal$1 = 0;
  this.Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$$anon$3__f_$name$1 = \u03b4name$2;
  this.Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$$anon$3__f__$ordinal$1 = _$ordinal$2;
}
export { $c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$$anon$3 as $c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$$anon$3 };
$c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$$anon$3.prototype = new $h_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode();
$c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$$anon$3.prototype.constructor = $c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$$anon$3;
/** @constructor */
function $h_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$$anon$3() {
}
export { $h_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$$anon$3 as $h_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$$anon$3 };
$h_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$$anon$3.prototype = $c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$$anon$3.prototype;
$c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$$anon$3.prototype.productArity__I = (function() {
  return 0;
});
$c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$$anon$3.prototype.productElement__I__O = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$$anon$3.prototype.productElementName__I__T = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$$anon$3.prototype.productPrefix__T = (function() {
  return this.Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$$anon$3__f_$name$1;
});
$c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$$anon$3.prototype.toString__T = (function() {
  return this.Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$$anon$3__f_$name$1;
});
$c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$$anon$3.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I(this.Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$$anon$3__f_$name$1);
});
$c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$$anon$3.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$$anon$3, "framework.utils.ToSSEStreamBuilder$PreferredConnectionMode$$anon$3", ({
  Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$$anon$3: 1,
  Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$$anon$3 as $d_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$$anon$3 };
/** @constructor */
function $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge(errors1, errors2) {
  this.Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge__f_errors1 = null;
  this.Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge__f_errors2 = null;
  this.Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge__f_errors1 = errors1;
  this.Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge__f_errors2 = errors2;
}
export { $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge as $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge };
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge.prototype = new $h_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain();
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge.prototype.constructor = $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge;
/** @constructor */
function $h_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge() {
}
export { $h_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge as $h_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge };
$h_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge.prototype = $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge.prototype;
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge.prototype.productArity__I = (function() {
  return 2;
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge.prototype.productPrefix__T = (function() {
  return "Merge";
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge__f_errors1;
  }
  if ((n === 1)) {
    return this.Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge__f_errors2;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "errors1";
  }
  if ((n === 1)) {
    return "errors2";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge)));
}
export { $isArrayOf_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge as $isArrayOf_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge };
var $d_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge, "io.scalaland.chimney.internal.runtime.NonEmptyErrorsChain$Merge", ({
  Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge: 1,
  Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_IterableOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Iterable: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge as $d_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge };
/** @constructor */
function $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single(error) {
  this.Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single__f_error = null;
  this.Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single__f_error = error;
}
export { $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single as $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single };
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single.prototype = new $h_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain();
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single.prototype.constructor = $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single;
/** @constructor */
function $h_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single() {
}
export { $h_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single as $h_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single };
$h_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single.prototype = $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single.prototype;
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single.prototype.productPrefix__T = (function() {
  return "Single";
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single__f_error;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "error";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single)));
}
export { $isArrayOf_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single as $isArrayOf_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single };
var $d_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single, "io.scalaland.chimney.internal.runtime.NonEmptyErrorsChain$Single", ({
  Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single: 1,
  Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_IterableOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Iterable: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single as $d_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Single };
/** @constructor */
function $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$UnsealPath(errors) {
  this.Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$UnsealPath__f_errors = null;
  this.Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$UnsealPath__f_errors = errors;
}
export { $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$UnsealPath as $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$UnsealPath };
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$UnsealPath.prototype = new $h_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain();
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$UnsealPath.prototype.constructor = $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$UnsealPath;
/** @constructor */
function $h_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$UnsealPath() {
}
export { $h_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$UnsealPath as $h_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$UnsealPath };
$h_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$UnsealPath.prototype = $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$UnsealPath.prototype;
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$UnsealPath.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$UnsealPath.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$UnsealPath.prototype.productPrefix__T = (function() {
  return "UnsealPath";
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$UnsealPath.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$UnsealPath__f_errors;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$UnsealPath.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "errors";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$UnsealPath(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$UnsealPath)));
}
export { $isArrayOf_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$UnsealPath as $isArrayOf_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$UnsealPath };
var $d_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$UnsealPath = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$UnsealPath, "io.scalaland.chimney.internal.runtime.NonEmptyErrorsChain$UnsealPath", ({
  Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$UnsealPath: 1,
  Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_IterableOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Iterable: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$UnsealPath as $d_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$UnsealPath };
/** @constructor */
function $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Wrap(errors) {
  this.Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Wrap__f_errors = null;
  this.Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Wrap__f_errors = errors;
}
export { $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Wrap as $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Wrap };
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Wrap.prototype = new $h_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain();
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Wrap.prototype.constructor = $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Wrap;
/** @constructor */
function $h_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Wrap() {
}
export { $h_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Wrap as $h_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Wrap };
$h_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Wrap.prototype = $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Wrap.prototype;
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Wrap.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Wrap.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Wrap.prototype.productPrefix__T = (function() {
  return "Wrap";
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Wrap.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Wrap__f_errors;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Wrap.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "errors";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Wrap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Wrap)));
}
export { $isArrayOf_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Wrap as $isArrayOf_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Wrap };
var $d_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Wrap = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Wrap, "io.scalaland.chimney.internal.runtime.NonEmptyErrorsChain$Wrap", ({
  Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Wrap: 1,
  Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_IterableOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Iterable: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Wrap as $d_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Wrap };
/** @constructor */
function $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath(errors, pathElement) {
  this.Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath__f_errors = null;
  this.Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath__f_pathElement = null;
  this.Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath__f_errors = errors;
  this.Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath__f_pathElement = pathElement;
}
export { $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath as $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath };
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath.prototype = new $h_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain();
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath.prototype.constructor = $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath;
/** @constructor */
function $h_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath() {
}
export { $h_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath as $h_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath };
$h_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath.prototype = $c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath.prototype;
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath.prototype.productArity__I = (function() {
  return 2;
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath.prototype.productPrefix__T = (function() {
  return "WrapPath";
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath__f_errors;
  }
  if ((n === 1)) {
    return this.Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath__f_pathElement;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "errors";
  }
  if ((n === 1)) {
    return "pathElement";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath)));
}
export { $isArrayOf_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath as $isArrayOf_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath };
var $d_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath, "io.scalaland.chimney.internal.runtime.NonEmptyErrorsChain$WrapPath", ({
  Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath: 1,
  Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_IterableOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Iterable: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath as $d_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$WrapPath };
/** @constructor */
function $c_Lmonocle_PIso$$anon$3(_get$2, _reverseGet$2, outer) {
  this.Lmonocle_PIso$$anon$3__f_monocle$PIso$$anon$3$$_get$1 = null;
  this.Lmonocle_PIso$$anon$3__f_monocle$PIso$$anon$3$$_reverseGet$1 = null;
  this.Lmonocle_PIso$$anon$3__f_monocle$PIso$$anon$3$$_get$1 = _get$2;
  this.Lmonocle_PIso$$anon$3__f_monocle$PIso$$anon$3$$_reverseGet$1 = _reverseGet$2;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lmonocle_PIso$$anon$3 as $c_Lmonocle_PIso$$anon$3 };
$c_Lmonocle_PIso$$anon$3.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lmonocle_PIso$$anon$3.prototype.constructor = $c_Lmonocle_PIso$$anon$3;
/** @constructor */
function $h_Lmonocle_PIso$$anon$3() {
}
export { $h_Lmonocle_PIso$$anon$3 as $h_Lmonocle_PIso$$anon$3 };
$h_Lmonocle_PIso$$anon$3.prototype = $c_Lmonocle_PIso$$anon$3.prototype;
$c_Lmonocle_PIso$$anon$3.prototype.andThen__Lmonocle_POptional__Lmonocle_POptional = (function(other) {
  return new $c_Lmonocle_POptional$$anon$1(other, this);
});
$c_Lmonocle_PIso$$anon$3.prototype.getOrModify__O__s_util_Either = (function(s) {
  return $f_Lmonocle_PLens__getOrModify__O__s_util_Either(this, s);
});
$c_Lmonocle_PIso$$anon$3.prototype.andThen__Lmonocle_PPrism__Lmonocle_PPrism = (function(other) {
  return new $c_Lmonocle_PPrism$$anon$1(other, this);
});
$c_Lmonocle_PIso$$anon$3.prototype.modify__F1__F1 = (function(f) {
  return $f_Lmonocle_PIso__modify__F1__F1(this, f);
});
$c_Lmonocle_PIso$$anon$3.prototype.replace__O__F1 = (function(b) {
  return $f_Lmonocle_PIso__replace__O__F1(this, b);
});
$c_Lmonocle_PIso$$anon$3.prototype.get__O__O = (function(s) {
  return this.Lmonocle_PIso$$anon$3__f_monocle$PIso$$anon$3$$_get$1.apply__O__O(s);
});
$c_Lmonocle_PIso$$anon$3.prototype.reverseGet__O__O = (function(b) {
  return this.Lmonocle_PIso$$anon$3__f_monocle$PIso$$anon$3$$_reverseGet$1.apply__O__O(b);
});
var $d_Lmonocle_PIso$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lmonocle_PIso$$anon$3, "monocle.PIso$$anon$3", ({
  Lmonocle_PIso$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lmonocle_PSetter: 1,
  Lmonocle_Fold: 1,
  Lmonocle_PTraversal: 1,
  Lmonocle_POptional: 1,
  Lmonocle_Getter: 1,
  Lmonocle_PLens: 1,
  Lmonocle_PPrism: 1,
  Lmonocle_PIso: 1
}));
export { $d_Lmonocle_PIso$$anon$3 as $d_Lmonocle_PIso$$anon$3 };
/** @constructor */
function $c_Lmonocle_PIso$$anon$5(outer) {
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
}
export { $c_Lmonocle_PIso$$anon$5 as $c_Lmonocle_PIso$$anon$5 };
$c_Lmonocle_PIso$$anon$5.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lmonocle_PIso$$anon$5.prototype.constructor = $c_Lmonocle_PIso$$anon$5;
/** @constructor */
function $h_Lmonocle_PIso$$anon$5() {
}
export { $h_Lmonocle_PIso$$anon$5 as $h_Lmonocle_PIso$$anon$5 };
$h_Lmonocle_PIso$$anon$5.prototype = $c_Lmonocle_PIso$$anon$5.prototype;
$c_Lmonocle_PIso$$anon$5.prototype.getOrModify__O__s_util_Either = (function(s) {
  return $f_Lmonocle_PLens__getOrModify__O__s_util_Either(this, s);
});
$c_Lmonocle_PIso$$anon$5.prototype.modify__F1__F1 = (function(f) {
  return $f_Lmonocle_PIso__modify__F1__F1(this, f);
});
$c_Lmonocle_PIso$$anon$5.prototype.replace__O__F1 = (function(b) {
  return $f_Lmonocle_PIso__replace__O__F1(this, b);
});
$c_Lmonocle_PIso$$anon$5.prototype.get__O__O = (function(s) {
  return s;
});
$c_Lmonocle_PIso$$anon$5.prototype.reverseGet__O__O = (function(t) {
  return t;
});
$c_Lmonocle_PIso$$anon$5.prototype.andThen__Lmonocle_PPrism__Lmonocle_PPrism = (function(other) {
  return other;
});
$c_Lmonocle_PIso$$anon$5.prototype.andThen__Lmonocle_POptional__Lmonocle_POptional = (function(other) {
  return other;
});
var $d_Lmonocle_PIso$$anon$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lmonocle_PIso$$anon$5, "monocle.PIso$$anon$5", ({
  Lmonocle_PIso$$anon$5: 1,
  Ljava_io_Serializable: 1,
  Lmonocle_PSetter: 1,
  Lmonocle_Fold: 1,
  Lmonocle_PTraversal: 1,
  Lmonocle_POptional: 1,
  Lmonocle_Getter: 1,
  Lmonocle_PLens: 1,
  Lmonocle_PPrism: 1,
  Lmonocle_PIso: 1
}));
export { $d_Lmonocle_PIso$$anon$5 as $d_Lmonocle_PIso$$anon$5 };
/** @constructor */
function $c_Lretry_HandlerDecision$$anon$1() {
}
export { $c_Lretry_HandlerDecision$$anon$1 as $c_Lretry_HandlerDecision$$anon$1 };
$c_Lretry_HandlerDecision$$anon$1.prototype = new $h_Lretry_HandlerDecision();
$c_Lretry_HandlerDecision$$anon$1.prototype.constructor = $c_Lretry_HandlerDecision$$anon$1;
/** @constructor */
function $h_Lretry_HandlerDecision$$anon$1() {
}
export { $h_Lretry_HandlerDecision$$anon$1 as $h_Lretry_HandlerDecision$$anon$1 };
$h_Lretry_HandlerDecision$$anon$1.prototype = $c_Lretry_HandlerDecision$$anon$1.prototype;
$c_Lretry_HandlerDecision$$anon$1.prototype.productArity__I = (function() {
  return 0;
});
$c_Lretry_HandlerDecision$$anon$1.prototype.productElement__I__O = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Lretry_HandlerDecision$$anon$1.prototype.productElementName__I__T = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Lretry_HandlerDecision$$anon$1.prototype.productPrefix__T = (function() {
  return "Stop";
});
$c_Lretry_HandlerDecision$$anon$1.prototype.toString__T = (function() {
  return "Stop";
});
$c_Lretry_HandlerDecision$$anon$1.prototype.ordinal__I = (function() {
  return 0;
});
$c_Lretry_HandlerDecision$$anon$1.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lretry_HandlerDecision$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lretry_HandlerDecision$$anon$1, "retry.HandlerDecision$$anon$1", ({
  Lretry_HandlerDecision$$anon$1: 1,
  Lretry_HandlerDecision: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lretry_HandlerDecision$$anon$1 as $d_Lretry_HandlerDecision$$anon$1 };
/** @constructor */
function $c_Lretry_HandlerDecision$$anon$2() {
}
export { $c_Lretry_HandlerDecision$$anon$2 as $c_Lretry_HandlerDecision$$anon$2 };
$c_Lretry_HandlerDecision$$anon$2.prototype = new $h_Lretry_HandlerDecision();
$c_Lretry_HandlerDecision$$anon$2.prototype.constructor = $c_Lretry_HandlerDecision$$anon$2;
/** @constructor */
function $h_Lretry_HandlerDecision$$anon$2() {
}
export { $h_Lretry_HandlerDecision$$anon$2 as $h_Lretry_HandlerDecision$$anon$2 };
$h_Lretry_HandlerDecision$$anon$2.prototype = $c_Lretry_HandlerDecision$$anon$2.prototype;
$c_Lretry_HandlerDecision$$anon$2.prototype.productArity__I = (function() {
  return 0;
});
$c_Lretry_HandlerDecision$$anon$2.prototype.productElement__I__O = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Lretry_HandlerDecision$$anon$2.prototype.productElementName__I__T = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Lretry_HandlerDecision$$anon$2.prototype.productPrefix__T = (function() {
  return "Continue";
});
$c_Lretry_HandlerDecision$$anon$2.prototype.toString__T = (function() {
  return "Continue";
});
$c_Lretry_HandlerDecision$$anon$2.prototype.ordinal__I = (function() {
  return 1;
});
$c_Lretry_HandlerDecision$$anon$2.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lretry_HandlerDecision$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lretry_HandlerDecision$$anon$2, "retry.HandlerDecision$$anon$2", ({
  Lretry_HandlerDecision$$anon$2: 1,
  Lretry_HandlerDecision: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lretry_HandlerDecision$$anon$2 as $d_Lretry_HandlerDecision$$anon$2 };
/** @constructor */
function $c_Lretry_PolicyDecision$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.Lretry_PolicyDecision$$anon$1__f_$name$1 = null;
  this.Lretry_PolicyDecision$$anon$1__f__$ordinal$1 = 0;
  this.Lretry_PolicyDecision$$anon$1__f_$name$1 = \u03b4name$2;
  this.Lretry_PolicyDecision$$anon$1__f__$ordinal$1 = _$ordinal$2;
}
export { $c_Lretry_PolicyDecision$$anon$1 as $c_Lretry_PolicyDecision$$anon$1 };
$c_Lretry_PolicyDecision$$anon$1.prototype = new $h_Lretry_PolicyDecision();
$c_Lretry_PolicyDecision$$anon$1.prototype.constructor = $c_Lretry_PolicyDecision$$anon$1;
/** @constructor */
function $h_Lretry_PolicyDecision$$anon$1() {
}
export { $h_Lretry_PolicyDecision$$anon$1 as $h_Lretry_PolicyDecision$$anon$1 };
$h_Lretry_PolicyDecision$$anon$1.prototype = $c_Lretry_PolicyDecision$$anon$1.prototype;
$c_Lretry_PolicyDecision$$anon$1.prototype.productArity__I = (function() {
  return 0;
});
$c_Lretry_PolicyDecision$$anon$1.prototype.productElement__I__O = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Lretry_PolicyDecision$$anon$1.prototype.productElementName__I__T = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Lretry_PolicyDecision$$anon$1.prototype.productPrefix__T = (function() {
  return this.Lretry_PolicyDecision$$anon$1__f_$name$1;
});
$c_Lretry_PolicyDecision$$anon$1.prototype.toString__T = (function() {
  return this.Lretry_PolicyDecision$$anon$1__f_$name$1;
});
$c_Lretry_PolicyDecision$$anon$1.prototype.ordinal__I = (function() {
  return this.Lretry_PolicyDecision$$anon$1__f__$ordinal$1;
});
$c_Lretry_PolicyDecision$$anon$1.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lretry_PolicyDecision$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lretry_PolicyDecision$$anon$1, "retry.PolicyDecision$$anon$1", ({
  Lretry_PolicyDecision$$anon$1: 1,
  Lretry_PolicyDecision: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lretry_PolicyDecision$$anon$1 as $d_Lretry_PolicyDecision$$anon$1 };
/** @constructor */
function $c_Lretry_RetryDetails$NextStep$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.Lretry_RetryDetails$NextStep$$anon$1__f_$name$1 = null;
  this.Lretry_RetryDetails$NextStep$$anon$1__f__$ordinal$1 = 0;
  this.Lretry_RetryDetails$NextStep$$anon$1__f_$name$1 = \u03b4name$2;
  this.Lretry_RetryDetails$NextStep$$anon$1__f__$ordinal$1 = _$ordinal$2;
}
export { $c_Lretry_RetryDetails$NextStep$$anon$1 as $c_Lretry_RetryDetails$NextStep$$anon$1 };
$c_Lretry_RetryDetails$NextStep$$anon$1.prototype = new $h_Lretry_RetryDetails$NextStep();
$c_Lretry_RetryDetails$NextStep$$anon$1.prototype.constructor = $c_Lretry_RetryDetails$NextStep$$anon$1;
/** @constructor */
function $h_Lretry_RetryDetails$NextStep$$anon$1() {
}
export { $h_Lretry_RetryDetails$NextStep$$anon$1 as $h_Lretry_RetryDetails$NextStep$$anon$1 };
$h_Lretry_RetryDetails$NextStep$$anon$1.prototype = $c_Lretry_RetryDetails$NextStep$$anon$1.prototype;
$c_Lretry_RetryDetails$NextStep$$anon$1.prototype.productArity__I = (function() {
  return 0;
});
$c_Lretry_RetryDetails$NextStep$$anon$1.prototype.productElement__I__O = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Lretry_RetryDetails$NextStep$$anon$1.prototype.productElementName__I__T = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Lretry_RetryDetails$NextStep$$anon$1.prototype.productPrefix__T = (function() {
  return this.Lretry_RetryDetails$NextStep$$anon$1__f_$name$1;
});
$c_Lretry_RetryDetails$NextStep$$anon$1.prototype.toString__T = (function() {
  return this.Lretry_RetryDetails$NextStep$$anon$1__f_$name$1;
});
$c_Lretry_RetryDetails$NextStep$$anon$1.prototype.ordinal__I = (function() {
  return this.Lretry_RetryDetails$NextStep$$anon$1__f__$ordinal$1;
});
$c_Lretry_RetryDetails$NextStep$$anon$1.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lretry_RetryDetails$NextStep$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lretry_RetryDetails$NextStep$$anon$1, "retry.RetryDetails$NextStep$$anon$1", ({
  Lretry_RetryDetails$NextStep$$anon$1: 1,
  Lretry_RetryDetails$NextStep: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lretry_RetryDetails$NextStep$$anon$1 as $d_Lretry_RetryDetails$NextStep$$anon$1 };
/** @constructor */
function $c_sc_View$Tabulate(n, f) {
  this.sc_View$Tabulate__f_n = 0;
  this.sc_View$Tabulate__f_f = null;
  this.sc_View$Tabulate__f_n = n;
  this.sc_View$Tabulate__f_f = f;
}
export { $c_sc_View$Tabulate as $c_sc_View$Tabulate };
$c_sc_View$Tabulate.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sc_AbstractView();
$c_sc_View$Tabulate.prototype.constructor = $c_sc_View$Tabulate;
/** @constructor */
function $h_sc_View$Tabulate() {
}
export { $h_sc_View$Tabulate as $h_sc_View$Tabulate };
$h_sc_View$Tabulate.prototype = $c_sc_View$Tabulate.prototype;
$c_sc_View$Tabulate.prototype.iterator__sc_Iterator = (function() {
  var end = this.sc_View$Tabulate__f_n;
  var f = this.sc_View$Tabulate__f_f;
  return new $c_sc_Iterator$$anon$23(end, f);
});
$c_sc_View$Tabulate.prototype.knownSize__I = (function() {
  var that = this.sc_View$Tabulate__f_n;
  return ((that < 0) ? 0 : that);
});
$c_sc_View$Tabulate.prototype.isEmpty__Z = (function() {
  return (this.sc_View$Tabulate__f_n <= 0);
});
var $d_sc_View$Tabulate = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sc_View$Tabulate, "scala.collection.View$Tabulate", ({
  sc_View$Tabulate: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_View$Tabulate as $d_sc_View$Tabulate };
function $isArrayOf_Lsttp_tapir_EndpointIO$Pair(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointIO$Pair)));
}
export { $isArrayOf_Lsttp_tapir_EndpointIO$Pair as $isArrayOf_Lsttp_tapir_EndpointIO$Pair };
/** @constructor */
function $c_Lcats_data_KleisliInstances0() {
}
export { $c_Lcats_data_KleisliInstances0 as $c_Lcats_data_KleisliInstances0 };
$c_Lcats_data_KleisliInstances0.prototype = new $h_Lcats_data_KleisliInstances0\uff3f5();
$c_Lcats_data_KleisliInstances0.prototype.constructor = $c_Lcats_data_KleisliInstances0;
/** @constructor */
function $h_Lcats_data_KleisliInstances0() {
}
export { $h_Lcats_data_KleisliInstances0 as $h_Lcats_data_KleisliInstances0 };
$h_Lcats_data_KleisliInstances0.prototype = $c_Lcats_data_KleisliInstances0.prototype;
/** @constructor */
function $c_Lcats_effect_kernel_implicits$() {
}
export { $c_Lcats_effect_kernel_implicits$ as $c_Lcats_effect_kernel_implicits$ };
$c_Lcats_effect_kernel_implicits$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_kernel_implicits$.prototype.constructor = $c_Lcats_effect_kernel_implicits$;
/** @constructor */
function $h_Lcats_effect_kernel_implicits$() {
}
export { $h_Lcats_effect_kernel_implicits$ as $h_Lcats_effect_kernel_implicits$ };
$h_Lcats_effect_kernel_implicits$.prototype = $c_Lcats_effect_kernel_implicits$.prototype;
var $d_Lcats_effect_kernel_implicits$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_kernel_implicits$, "cats.effect.kernel.implicits$", ({
  Lcats_effect_kernel_implicits$: 1,
  Lcats_effect_kernel_syntax_MonadCancelSyntax: 1,
  Lcats_effect_kernel_syntax_GenSpawnSyntax: 1,
  Lcats_effect_kernel_syntax_GenTemporalSyntax: 1,
  Lcats_effect_kernel_syntax_GenConcurrentSyntax: 1,
  Lcats_effect_kernel_syntax_AsyncSyntax: 1,
  Lcats_effect_kernel_syntax_ResourceSyntax: 1,
  Lcats_effect_kernel_syntax_ClockSyntax: 1,
  Lcats_effect_kernel_syntax_AllSyntax: 1,
  Lcats_effect_kernel_instances_GenSpawnInstances: 1,
  Lcats_effect_kernel_instances_AllInstances: 1
}));
export { $d_Lcats_effect_kernel_implicits$ as $d_Lcats_effect_kernel_implicits$ };
var $n_Lcats_effect_kernel_implicits$;
function $m_Lcats_effect_kernel_implicits$() {
  if ((!$n_Lcats_effect_kernel_implicits$)) {
    $n_Lcats_effect_kernel_implicits$ = new $c_Lcats_effect_kernel_implicits$();
  }
  return $n_Lcats_effect_kernel_implicits$;
}
export { $m_Lcats_effect_kernel_implicits$ as $m_Lcats_effect_kernel_implicits$ };
/** @constructor */
function $c_Lcats_kernel_instances_UnitAlgebra() {
}
export { $c_Lcats_kernel_instances_UnitAlgebra as $c_Lcats_kernel_instances_UnitAlgebra };
$c_Lcats_kernel_instances_UnitAlgebra.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_kernel_instances_UnitAlgebra.prototype.constructor = $c_Lcats_kernel_instances_UnitAlgebra;
/** @constructor */
function $h_Lcats_kernel_instances_UnitAlgebra() {
}
export { $h_Lcats_kernel_instances_UnitAlgebra as $h_Lcats_kernel_instances_UnitAlgebra };
$h_Lcats_kernel_instances_UnitAlgebra.prototype = $c_Lcats_kernel_instances_UnitAlgebra.prototype;
$c_Lcats_kernel_instances_UnitAlgebra.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_UnitAlgebra.prototype.empty__O = (function() {
  return (void 0);
});
$c_Lcats_kernel_instances_UnitAlgebra.prototype.combine__O__O__O = (function(x, y) {
  return (void 0);
});
var $d_Lcats_kernel_instances_UnitAlgebra = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_kernel_instances_UnitAlgebra, "cats.kernel.instances.UnitAlgebra", ({
  Lcats_kernel_instances_UnitAlgebra: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Band: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_Semilattice: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_BoundedSemilattice: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeGroup: 1
}));
export { $d_Lcats_kernel_instances_UnitAlgebra as $d_Lcats_kernel_instances_UnitAlgebra };
/** @constructor */
function $c_Lcom_raquo_airstream_state_Val(constantValue) {
  this.Lcom_raquo_airstream_state_Val__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_state_Val__f_isSafeToRemoveObserver = false;
  this.Lcom_raquo_airstream_state_Val__f_maybePendingObserverRemovals = null;
  this.Lcom_raquo_airstream_state_Val__f__lastUpdateId = 0;
  this.Lcom_raquo_airstream_state_Val__f_externalObservers = null;
  this.Lcom_raquo_airstream_state_Val__f_internalObservers = null;
  this.Lcom_raquo_airstream_state_Val__f_willStartDone = false;
  this.Lcom_raquo_airstream_state_Val__f_maybeLastSeenCurrentValue = null;
  this.Lcom_raquo_airstream_state_Val__f_constantValue = null;
  this.Lcom_raquo_airstream_state_Val__f_topoRank = 0;
  this.Lcom_raquo_airstream_state_Val__f_constantValue = constantValue;
  this.Lcom_raquo_airstream_state_Val__f_maybeDisplayName = (void 0);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  this.Lcom_raquo_airstream_state_Val__f__lastUpdateId = 0;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.Lcom_raquo_airstream_state_Val__f_maybeLastSeenCurrentValue = (void 0);
  this.Lcom_raquo_airstream_state_Val__f_topoRank = 1;
}
export { $c_Lcom_raquo_airstream_state_Val as $c_Lcom_raquo_airstream_state_Val };
$c_Lcom_raquo_airstream_state_Val.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_state_Val.prototype.constructor = $c_Lcom_raquo_airstream_state_Val;
/** @constructor */
function $h_Lcom_raquo_airstream_state_Val() {
}
export { $h_Lcom_raquo_airstream_state_Val as $h_Lcom_raquo_airstream_state_Val };
$h_Lcom_raquo_airstream_state_Val.prototype = $c_Lcom_raquo_airstream_state_Val.prototype;
$c_Lcom_raquo_airstream_state_Val.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_state_Val__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_state_Val.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_state_Val__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_state_Val.prototype.defaultDisplayName__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_airstream_state_Val.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_state_Val.prototype.isSafeToRemoveObserver__Z = (function() {
  return this.Lcom_raquo_airstream_state_Val__f_isSafeToRemoveObserver;
});
$c_Lcom_raquo_airstream_state_Val.prototype.maybePendingObserverRemovals__O = (function() {
  return this.Lcom_raquo_airstream_state_Val__f_maybePendingObserverRemovals;
});
$c_Lcom_raquo_airstream_state_Val.prototype.isSafeToRemoveObserver_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_state_Val__f_isSafeToRemoveObserver = x$1;
});
$c_Lcom_raquo_airstream_state_Val.prototype.maybePendingObserverRemovals_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_state_Val__f_maybePendingObserverRemovals = x$1;
});
$c_Lcom_raquo_airstream_state_Val.prototype.onStop__V = (function() {
});
$c_Lcom_raquo_airstream_state_Val.prototype.equals__O__Z = (function(obj) {
  return (this === obj);
});
$c_Lcom_raquo_airstream_state_Val.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$systemIdentityHashCode(this);
});
$c_Lcom_raquo_airstream_state_Val.prototype._lastUpdateId__I = (function() {
  return this.Lcom_raquo_airstream_state_Val__f__lastUpdateId;
});
$c_Lcom_raquo_airstream_state_Val.prototype._lastUpdateId_$eq__I__V = (function(x$1) {
  this.Lcom_raquo_airstream_state_Val__f__lastUpdateId = x$1;
});
$c_Lcom_raquo_airstream_state_Val.prototype.toObservable__Lcom_raquo_airstream_core_Signal = (function() {
  return this;
});
$c_Lcom_raquo_airstream_state_Val.prototype.onStart__V = (function() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_Signal__onStart__V(this);
});
$c_Lcom_raquo_airstream_state_Val.prototype.onAddedExternalObserver__Lcom_raquo_airstream_core_Observer__V = (function(observer) {
  observer.onTry__s_util_Try__V(this.Lcom_raquo_airstream_state_Val__f_constantValue);
});
$c_Lcom_raquo_airstream_state_Val.prototype.externalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_state_Val__f_externalObservers;
});
$c_Lcom_raquo_airstream_state_Val.prototype.internalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_state_Val__f_internalObservers;
});
$c_Lcom_raquo_airstream_state_Val.prototype.willStartDone__Z = (function() {
  return this.Lcom_raquo_airstream_state_Val__f_willStartDone;
});
$c_Lcom_raquo_airstream_state_Val.prototype.willStartDone_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_state_Val__f_willStartDone = x$1;
});
$c_Lcom_raquo_airstream_state_Val.prototype.com$raquo$airstream$core$WritableObservable$_setter_$externalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_state_Val__f_externalObservers = x$0;
});
$c_Lcom_raquo_airstream_state_Val.prototype.com$raquo$airstream$core$WritableObservable$_setter_$internalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_state_Val__f_internalObservers = x$0;
});
$c_Lcom_raquo_airstream_state_Val.prototype.maybeLastSeenCurrentValue__O = (function() {
  return this.Lcom_raquo_airstream_state_Val__f_maybeLastSeenCurrentValue;
});
$c_Lcom_raquo_airstream_state_Val.prototype.maybeLastSeenCurrentValue_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_state_Val__f_maybeLastSeenCurrentValue = x$1;
});
$c_Lcom_raquo_airstream_state_Val.prototype.fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_state_Val.prototype.topoRank__I = (function() {
  return this.Lcom_raquo_airstream_state_Val__f_topoRank;
});
$c_Lcom_raquo_airstream_state_Val.prototype.tryNow__s_util_Try = (function() {
  return this.Lcom_raquo_airstream_state_Val__f_constantValue;
});
$c_Lcom_raquo_airstream_state_Val.prototype.currentValueFromParent__s_util_Try = (function() {
  return this.Lcom_raquo_airstream_state_Val__f_constantValue;
});
$c_Lcom_raquo_airstream_state_Val.prototype.onWillStart__V = (function() {
});
$c_Lcom_raquo_airstream_state_Val.prototype.map__F1__Lcom_raquo_airstream_core_Observable = (function(project) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), this, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lcom_raquo_airstream_state_Val.prototype.distinctTry__F2__Lcom_raquo_airstream_core_Observable = (function(isSame) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_distinct_DistinctSignal(this, isSame, false);
});
$c_Lcom_raquo_airstream_state_Val.prototype.toObservable__Lcom_raquo_airstream_core_Observable = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_state_Val = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_state_Val, "com.raquo.airstream.state.Val", ({
  Lcom_raquo_airstream_state_Val: 1,
  Lcom_raquo_airstream_core_Source: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_BaseObservable: 1,
  Lcom_raquo_airstream_core_Observable: 1,
  Lcom_raquo_airstream_core_Source$SignalSource: 1,
  Lcom_raquo_airstream_dynamicImport_SignalDynamicImportOps: 1,
  Lcom_raquo_airstream_core_Signal: 1,
  Lcom_raquo_airstream_core_WritableObservable: 1,
  Lcom_raquo_airstream_core_WritableSignal: 1,
  Lcom_raquo_airstream_state_StrictSignal: 1
}));
export { $d_Lcom_raquo_airstream_state_Val as $d_Lcom_raquo_airstream_state_Val };
function $p_s_concurrent_impl_Promise$Transformation__handleFailure__jl_Throwable__s_concurrent_ExecutionContext__V($thiz, t, e) {
  var wasInterrupted = false;
  if ((wasInterrupted || $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().apply__jl_Throwable__Z(t))) {
    var completed = $thiz.tryComplete0__O__s_util_Try__Z($thiz.ju_concurrent_atomic_AtomicReference__f_value, $m_s_concurrent_impl_Promise$().scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(t)));
    if ((completed && wasInterrupted)) {
      var this$1 = $m_jl_Thread$().jl_Thread$__f_SingleThread;
      this$1.jl_Thread__f_java$lang$Thread$$interruptedState = true;
    }
    if (((($thiz.s_concurrent_impl_Promise$Transformation__f__xform === 5) || ($thiz.s_concurrent_impl_Promise$Transformation__f__xform === 6)) || (!completed))) {
      e.reportFailure__jl_Throwable__V(t);
    }
  } else {
    var $x_1 = t;
    throw (($x_1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? $x_1.sjs_js_JavaScriptException__f_exception : $x_1);
  }
}
export { $p_s_concurrent_impl_Promise$Transformation__handleFailure__jl_Throwable__s_concurrent_ExecutionContext__V as $p_s_concurrent_impl_Promise$Transformation__handleFailure__jl_Throwable__s_concurrent_ExecutionContext__V };
function $ct_s_concurrent_impl_Promise$Transformation__F1__s_concurrent_ExecutionContext__s_util_Try__I__($thiz, _fun, _ec, _arg, _xform) {
  $thiz.s_concurrent_impl_Promise$Transformation__f__fun = _fun;
  $thiz.s_concurrent_impl_Promise$Transformation__f__ec = _ec;
  $thiz.s_concurrent_impl_Promise$Transformation__f__arg = _arg;
  $thiz.s_concurrent_impl_Promise$Transformation__f__xform = _xform;
  $ct_s_concurrent_impl_Promise$DefaultPromise__($thiz);
  return $thiz;
}
export { $ct_s_concurrent_impl_Promise$Transformation__F1__s_concurrent_ExecutionContext__s_util_Try__I__ as $ct_s_concurrent_impl_Promise$Transformation__F1__s_concurrent_ExecutionContext__s_util_Try__I__ };
function $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__($thiz, xform, f, ec) {
  $ct_s_concurrent_impl_Promise$Transformation__F1__s_concurrent_ExecutionContext__s_util_Try__I__($thiz, f, ec, null, xform);
  return $thiz;
}
export { $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__ as $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__ };
/** @constructor */
function $c_s_concurrent_impl_Promise$Transformation() {
  this.ju_concurrent_atomic_AtomicReference__f_value = null;
  this.s_concurrent_impl_Promise$Transformation__f__fun = null;
  this.s_concurrent_impl_Promise$Transformation__f__ec = null;
  this.s_concurrent_impl_Promise$Transformation__f__arg = null;
  this.s_concurrent_impl_Promise$Transformation__f__xform = 0;
}
export { $c_s_concurrent_impl_Promise$Transformation as $c_s_concurrent_impl_Promise$Transformation };
$c_s_concurrent_impl_Promise$Transformation.prototype = new $h_s_concurrent_impl_Promise$DefaultPromise();
$c_s_concurrent_impl_Promise$Transformation.prototype.constructor = $c_s_concurrent_impl_Promise$Transformation;
/** @constructor */
function $h_s_concurrent_impl_Promise$Transformation() {
}
export { $h_s_concurrent_impl_Promise$Transformation as $h_s_concurrent_impl_Promise$Transformation };
$h_s_concurrent_impl_Promise$Transformation.prototype = $c_s_concurrent_impl_Promise$Transformation.prototype;
$c_s_concurrent_impl_Promise$Transformation.prototype.submitWithValue__s_util_Try__s_concurrent_impl_Promise$Transformation = (function(resolved) {
  this.s_concurrent_impl_Promise$Transformation__f__arg = resolved;
  var e = this.s_concurrent_impl_Promise$Transformation__f__ec;
  try {
    e.execute__jl_Runnable__V(this);
  } catch (e$2) {
    var e$3 = ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e$2 : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e$2));
    this.s_concurrent_impl_Promise$Transformation__f__fun = null;
    this.s_concurrent_impl_Promise$Transformation__f__arg = null;
    this.s_concurrent_impl_Promise$Transformation__f__ec = null;
    $p_s_concurrent_impl_Promise$Transformation__handleFailure__jl_Throwable__s_concurrent_ExecutionContext__V(this, e$3, e);
  }
  return this;
});
$c_s_concurrent_impl_Promise$Transformation.prototype.run__V = (function() {
  var v = this.s_concurrent_impl_Promise$Transformation__f__arg;
  var fun = this.s_concurrent_impl_Promise$Transformation__f__fun;
  var ec = this.s_concurrent_impl_Promise$Transformation__f__ec;
  this.s_concurrent_impl_Promise$Transformation__f__fun = null;
  this.s_concurrent_impl_Promise$Transformation__f__arg = null;
  this.s_concurrent_impl_Promise$Transformation__f__ec = null;
  try {
    var x1 = this.s_concurrent_impl_Promise$Transformation__f__xform;
    switch (x1) {
      case 0: {
        var resolvedResult = null;
        break;
      }
      case 1: {
        var resolvedResult = ((v instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(fun.apply__O__O(v.get__O())) : v);
        break;
      }
      case 2: {
        if ((v instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success)) {
          var f = fun.apply__O__O(v.get__O());
          if ((f instanceof $c_s_concurrent_impl_Promise$DefaultPromise)) {
            f.linkRootOf__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$Link__V(this, null);
          } else {
            this.completeWith__s_concurrent_Future__s_concurrent_impl_Promise$DefaultPromise(f);
          }
          var resolvedResult = null;
        } else {
          var resolvedResult = v;
        }
        break;
      }
      case 3: {
        var resolvedResult = $m_s_concurrent_impl_Promise$().scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try(fun.apply__O__O(v));
        break;
      }
      case 4: {
        var f$2 = fun.apply__O__O(v);
        if ((f$2 instanceof $c_s_concurrent_impl_Promise$DefaultPromise)) {
          f$2.linkRootOf__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$Link__V(this, null);
        } else {
          this.completeWith__s_concurrent_Future__s_concurrent_impl_Promise$DefaultPromise(f$2);
        }
        var resolvedResult = null;
        break;
      }
      case 5: {
        v.foreach__F1__V(fun);
        var resolvedResult = null;
        break;
      }
      case 6: {
        fun.apply__O__O(v);
        var resolvedResult = null;
        break;
      }
      case 7: {
        var resolvedResult = ((v instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure) ? $m_s_concurrent_impl_Promise$().scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try(v.recover__s_PartialFunction__s_util_Try(fun)) : v);
        break;
      }
      case 8: {
        if ((v instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure)) {
          var f$3 = fun.applyOrElse__O__F1__O(v.s_util_Failure__f_exception, $m_s_concurrent_Future$().s_concurrent_Future$__f_recoverWithFailed);
          var resolvedResult = ((f$3 !== $m_s_concurrent_Future$().s_concurrent_Future$__f_recoverWithFailedMarker) ? (((f$3 instanceof $c_s_concurrent_impl_Promise$DefaultPromise) ? f$3.linkRootOf__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$Link__V(this, null) : this.completeWith__s_concurrent_Future__s_concurrent_impl_Promise$DefaultPromise(f$3)), null) : v);
        } else {
          var resolvedResult = v;
        }
        break;
      }
      case 9: {
        var resolvedResult = (((v instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure) || (!(!fun.apply__O__O(v.get__O())))) ? v : $m_s_concurrent_Future$().s_concurrent_Future$__f_filterFailure);
        break;
      }
      case 10: {
        var resolvedResult = ((v instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(fun.applyOrElse__O__F1__O(v.get__O(), $m_s_concurrent_Future$().s_concurrent_Future$__f_collectFailed)) : v);
        break;
      }
      default: {
        var resolvedResult = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalStateException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalStateException(), ("BUG: encountered transformation promise with illegal type: " + this.s_concurrent_impl_Promise$Transformation__f__xform)));
      }
    }
    if ((resolvedResult !== null)) {
      this.tryComplete0__O__s_util_Try__Z(this.ju_concurrent_atomic_AtomicReference__f_value, resolvedResult);
    }
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
    $p_s_concurrent_impl_Promise$Transformation__handleFailure__jl_Throwable__s_concurrent_ExecutionContext__V(this, e$2, ec);
  }
});
function $isArrayOf_s_concurrent_impl_Promise$Transformation(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_impl_Promise$Transformation)));
}
export { $isArrayOf_s_concurrent_impl_Promise$Transformation as $isArrayOf_s_concurrent_impl_Promise$Transformation };
var $d_s_concurrent_impl_Promise$Transformation = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_s_concurrent_impl_Promise$Transformation, "scala.concurrent.impl.Promise$Transformation", ({
  s_concurrent_impl_Promise$Transformation: 1,
  s_concurrent_impl_Promise$DefaultPromise: 1,
  ju_concurrent_atomic_AtomicReference: 1,
  Ljava_io_Serializable: 1,
  s_concurrent_Promise: 1,
  s_concurrent_Future: 1,
  s_concurrent_Awaitable: 1,
  F1: 1,
  s_concurrent_impl_Promise$Callbacks: 1,
  jl_Runnable: 1,
  s_concurrent_Batchable: 1
}));
export { $d_s_concurrent_impl_Promise$Transformation as $d_s_concurrent_impl_Promise$Transformation };
function $ct_Lcats_data_KleisliInstances__($thiz) {
  $ct_Lcats_data_KleisliInstances3__($thiz);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_package$();
  return $thiz;
}
export { $ct_Lcats_data_KleisliInstances__ as $ct_Lcats_data_KleisliInstances__ };
/** @constructor */
function $c_Lcats_data_KleisliInstances() {
}
export { $c_Lcats_data_KleisliInstances as $c_Lcats_data_KleisliInstances };
$c_Lcats_data_KleisliInstances.prototype = new $h_Lcats_data_KleisliInstances0();
$c_Lcats_data_KleisliInstances.prototype.constructor = $c_Lcats_data_KleisliInstances;
/** @constructor */
function $h_Lcats_data_KleisliInstances() {
}
export { $h_Lcats_data_KleisliInstances as $h_Lcats_data_KleisliInstances };
$h_Lcats_data_KleisliInstances.prototype = $c_Lcats_data_KleisliInstances.prototype;
/** @constructor */
function $c_Lcats_effect_kernel_Resource$() {
}
export { $c_Lcats_effect_kernel_Resource$ as $c_Lcats_effect_kernel_Resource$ };
$c_Lcats_effect_kernel_Resource$.prototype = new $h_Lcats_effect_kernel_ResourceFOInstances0();
$c_Lcats_effect_kernel_Resource$.prototype.constructor = $c_Lcats_effect_kernel_Resource$;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$() {
}
export { $h_Lcats_effect_kernel_Resource$ as $h_Lcats_effect_kernel_Resource$ };
$h_Lcats_effect_kernel_Resource$.prototype = $c_Lcats_effect_kernel_Resource$.prototype;
$c_Lcats_effect_kernel_Resource$.prototype.applyCase__O__Lcats_effect_kernel_Resource = (function(resource) {
  var resource$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$59) => resource));
  return new $c_Lcats_effect_kernel_Resource$Allocate(resource$1);
});
$c_Lcats_effect_kernel_Resource$.prototype.makeCase__O__F2__Lcats_Functor__Lcats_effect_kernel_Resource = (function(acquire, release, F) {
  var this$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(acquire, F);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((a) => {
    var _2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((e) => release.apply__O__O__O(a, e)));
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), a, _2);
  }));
  return this.applyCase__O__Lcats_effect_kernel_Resource(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.map__O__F1__O(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f));
});
$c_Lcats_effect_kernel_Resource$.prototype.ordinal__Lcats_effect_kernel_Resource__I = (function(x$0) {
  if ((x$0 instanceof $c_Lcats_effect_kernel_Resource$Allocate)) {
    return 0;
  }
  if (false) {
    return 1;
  }
  if ((x$0 instanceof $c_Lcats_effect_kernel_Resource$Pure)) {
    return 2;
  }
  if ((x$0 instanceof $c_Lcats_effect_kernel_Resource$Eval)) {
    return 3;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$0);
});
$c_Lcats_effect_kernel_Resource$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Lcats_effect_kernel_Resource__I(x);
});
var $d_Lcats_effect_kernel_Resource$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_kernel_Resource$, "cats.effect.kernel.Resource$", ({
  Lcats_effect_kernel_Resource$: 1,
  Lcats_effect_kernel_ResourceFOInstances0: 1,
  Lcats_effect_kernel_ResourceFOInstances1: 1,
  Lcats_effect_kernel_ResourceHOInstances5: 1,
  Lcats_effect_kernel_ResourceHOInstances4: 1,
  Lcats_effect_kernel_ResourceHOInstances3: 1,
  Lcats_effect_kernel_ResourceHOInstances2: 1,
  Lcats_effect_kernel_ResourceHOInstances1: 1,
  Lcats_effect_kernel_ResourceHOInstances0: 1,
  Lcats_effect_kernel_ResourcePlatform: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lcats_effect_kernel_Resource$ as $d_Lcats_effect_kernel_Resource$ };
var $n_Lcats_effect_kernel_Resource$;
function $m_Lcats_effect_kernel_Resource$() {
  if ((!$n_Lcats_effect_kernel_Resource$)) {
    $n_Lcats_effect_kernel_Resource$ = new $c_Lcats_effect_kernel_Resource$();
  }
  return $n_Lcats_effect_kernel_Resource$;
}
export { $m_Lcats_effect_kernel_Resource$ as $m_Lcats_effect_kernel_Resource$ };
/** @constructor */
function $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4(F$3) {
  this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4__f_F$1 = null;
  this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4__f_F$1 = F$3;
}
export { $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4 as $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4 };
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.constructor = $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4;
/** @constructor */
function $h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4() {
}
export { $h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4 as $h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4 };
$h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype = $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype;
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return this.map__O__F1__O(fa, f);
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.void__O__O = (function(fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.as__O__O__O = (function(fa, b) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.productL__O__O__O = (function(fa, fb) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Apply__productL__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Apply__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.compose__Lcats_Applicative__Lcats_Applicative = (function(evidence$1) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Applicative$$anon$1(evidence$1, this);
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.pure__O__O = (function(a) {
  $m_Lcats_effect_IO$();
  var fa = new $c_Lcats_effect_IO$Pure(a);
  return fa;
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  $m_Lcats_implicits$();
  var this$5 = this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4__f_F$1;
  var target = $f_Lcats_effect_kernel_GenSpawn__both__O__O__O(this$5, fa, fb);
  var tc = this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4__f_F$1;
  var this$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
  var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 !== null)) {
      var a = x$1._1__O();
      var b = x$1._2__O();
      return f.apply__O__O__O(a, b);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  }));
  var fa$1 = this$7.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.map__O__F1__O(this$7.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$1);
  return fa$1;
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.ap__O__O__O = (function(ff, fa) {
  return this.map2__O__O__F2__O(ff, fa, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((_$6, _$7) => _$6.apply__O__O(_$7))));
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.product__O__O__O = (function(fa, fb) {
  return this.map2__O__O__F2__O(fa, fb, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((_$8, _$9) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _$8, _$9))));
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.map__O__F1__O = (function(fa, f) {
  $m_Lcats_implicits$();
  var tc = this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4__f_F$1;
  var this$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(fa, tc);
  var fa$1 = this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  return fa$1;
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.unit__O = (function() {
  var fa = $m_Lcats_effect_IO$().Lcats_effect_IO$__f__unit;
  return fa;
});
var $d_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4, "cats.effect.kernel.instances.GenSpawnInstances$$anon$4", ({
  Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_CommutativeApply: 1,
  Lcats_CommutativeApplicative: 1
}));
export { $d_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4 as $d_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4 };
/** @constructor */
function $c_Lcats_kernel_instances_BigIntOrder() {
}
export { $c_Lcats_kernel_instances_BigIntOrder as $c_Lcats_kernel_instances_BigIntOrder };
$c_Lcats_kernel_instances_BigIntOrder.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_kernel_instances_BigIntOrder.prototype.constructor = $c_Lcats_kernel_instances_BigIntOrder;
/** @constructor */
function $h_Lcats_kernel_instances_BigIntOrder() {
}
export { $h_Lcats_kernel_instances_BigIntOrder as $h_Lcats_kernel_instances_BigIntOrder };
$h_Lcats_kernel_instances_BigIntOrder.prototype = $c_Lcats_kernel_instances_BigIntOrder.prototype;
$c_Lcats_kernel_instances_BigIntOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.toOrdering__s_math_Ordering = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_kernel_Order$$anon$1(this);
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.neqv__s_math_BigInt__s_math_BigInt__Z = (function(x, y) {
  return (!$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(x, y));
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.hash__O__I = (function(x) {
  return x.hashCode__I();
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.compare__O__O__I = (function(x, y) {
  return x.compare__s_math_BigInt__I(y);
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(x, y);
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__s_math_BigInt__s_math_BigInt__Z(x, y);
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.gt__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_math_Ordered__$greater__O__Z(x, y);
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.lt__O__O__Z = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_math_Ordered__$less__O__Z(x, y);
});
var $d_Lcats_kernel_instances_BigIntOrder = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_kernel_instances_BigIntOrder, "cats.kernel.instances.BigIntOrder", ({
  Lcats_kernel_instances_BigIntOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_Next: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_Previous: 1,
  Lcats_kernel_UnboundedEnumerable: 1,
  Lcats_kernel_instances_BigIntUnboundedEnum: 1
}));
export { $d_Lcats_kernel_instances_BigIntOrder as $d_Lcats_kernel_instances_BigIntOrder };
function $p_Lcom_raquo_airstream_flatten_SwitchSignal__currentSignalTry__s_util_Try($thiz) {
  var x = $thiz.Lcom_raquo_airstream_flatten_SwitchSignal__f_maybeCurrentSignalTry;
  if ((x === (void 0))) {
    var initialSignal = $thiz.Lcom_raquo_airstream_flatten_SwitchSignal__f_parent.tryNow__s_util_Try();
    $thiz.Lcom_raquo_airstream_flatten_SwitchSignal__f_maybeCurrentSignalTry = initialSignal;
    var $x_1 = initialSignal;
  } else {
    var $x_1 = x;
  }
  return $x_1;
}
export { $p_Lcom_raquo_airstream_flatten_SwitchSignal__currentSignalTry__s_util_Try as $p_Lcom_raquo_airstream_flatten_SwitchSignal__currentSignalTry__s_util_Try };
function $p_Lcom_raquo_airstream_flatten_SwitchSignal__isSameSignal__s_util_Try__s_util_Try__Z($thiz, signalTry1, signalTry2) {
  if ((signalTry1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success)) {
    var signal1 = signalTry1.s_util_Success__f_value;
    if ((signalTry2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success)) {
      var signal2 = signalTry2.s_util_Success__f_value;
      return (signal1 === signal2);
    }
  }
  return false;
}
export { $p_Lcom_raquo_airstream_flatten_SwitchSignal__isSameSignal__s_util_Try__s_util_Try__Z as $p_Lcom_raquo_airstream_flatten_SwitchSignal__isSameSignal__s_util_Try__s_util_Try__Z };
/** @constructor */
function $c_Lcom_raquo_airstream_flatten_SwitchSignal(parent) {
  this.Lcom_raquo_airstream_flatten_SwitchSignal__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_flatten_SwitchSignal__f_isSafeToRemoveObserver = false;
  this.Lcom_raquo_airstream_flatten_SwitchSignal__f_maybePendingObserverRemovals = null;
  this.Lcom_raquo_airstream_flatten_SwitchSignal__f__lastUpdateId = 0;
  this.Lcom_raquo_airstream_flatten_SwitchSignal__f_externalObservers = null;
  this.Lcom_raquo_airstream_flatten_SwitchSignal__f_internalObservers = null;
  this.Lcom_raquo_airstream_flatten_SwitchSignal__f_willStartDone = false;
  this.Lcom_raquo_airstream_flatten_SwitchSignal__f_maybeLastSeenCurrentValue = null;
  this.Lcom_raquo_airstream_flatten_SwitchSignal__f_parent = null;
  this.Lcom_raquo_airstream_flatten_SwitchSignal__f_topoRank = 0;
  this.Lcom_raquo_airstream_flatten_SwitchSignal__f_maybeCurrentSignalTry = null;
  this.Lcom_raquo_airstream_flatten_SwitchSignal__f_innerSignalLastSeenUpdateId = 0;
  this.Lcom_raquo_airstream_flatten_SwitchSignal__f_internalEventObserver = null;
  this.Lcom_raquo_airstream_flatten_SwitchSignal__f_parent = parent;
  this.Lcom_raquo_airstream_flatten_SwitchSignal__f_maybeDisplayName = (void 0);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  this.Lcom_raquo_airstream_flatten_SwitchSignal__f__lastUpdateId = 0;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.Lcom_raquo_airstream_flatten_SwitchSignal__f_maybeLastSeenCurrentValue = (void 0);
  this.Lcom_raquo_airstream_flatten_SwitchSignal__f_topoRank = 1;
  this.Lcom_raquo_airstream_flatten_SwitchSignal__f_maybeCurrentSignalTry = (void 0);
  this.Lcom_raquo_airstream_flatten_SwitchSignal__f_innerSignalLastSeenUpdateId = 0;
  this.Lcom_raquo_airstream_flatten_SwitchSignal__f_internalEventObserver = $m_Lcom_raquo_airstream_core_InternalObserver$().fromTry__F2__Lcom_raquo_airstream_core_InternalObserver(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((nextTry, _$1) => {
    var signal = $p_Lcom_raquo_airstream_flatten_SwitchSignal__currentSignalTry__s_util_Try(this).get__O();
    this.Lcom_raquo_airstream_flatten_SwitchSignal__f_innerSignalLastSeenUpdateId = signal._lastUpdateId__I();
    var code = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((nextTry$2) => ((_$2) => {
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextTry$2, _$2);
    }))(nextTry));
    new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_core_Transaction(code);
  })));
}
export { $c_Lcom_raquo_airstream_flatten_SwitchSignal as $c_Lcom_raquo_airstream_flatten_SwitchSignal };
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.constructor = $c_Lcom_raquo_airstream_flatten_SwitchSignal;
/** @constructor */
function $h_Lcom_raquo_airstream_flatten_SwitchSignal() {
}
export { $h_Lcom_raquo_airstream_flatten_SwitchSignal as $h_Lcom_raquo_airstream_flatten_SwitchSignal };
$h_Lcom_raquo_airstream_flatten_SwitchSignal.prototype = $c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype;
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_flatten_SwitchSignal__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_flatten_SwitchSignal__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.defaultDisplayName__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.isSafeToRemoveObserver__Z = (function() {
  return this.Lcom_raquo_airstream_flatten_SwitchSignal__f_isSafeToRemoveObserver;
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.maybePendingObserverRemovals__O = (function() {
  return this.Lcom_raquo_airstream_flatten_SwitchSignal__f_maybePendingObserverRemovals;
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.isSafeToRemoveObserver_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_flatten_SwitchSignal__f_isSafeToRemoveObserver = x$1;
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.maybePendingObserverRemovals_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_flatten_SwitchSignal__f_maybePendingObserverRemovals = x$1;
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.equals__O__Z = (function(obj) {
  return (this === obj);
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$systemIdentityHashCode(this);
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype._lastUpdateId__I = (function() {
  return this.Lcom_raquo_airstream_flatten_SwitchSignal__f__lastUpdateId;
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype._lastUpdateId_$eq__I__V = (function(x$1) {
  this.Lcom_raquo_airstream_flatten_SwitchSignal__f__lastUpdateId = x$1;
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.toObservable__Lcom_raquo_airstream_core_Signal = (function() {
  return this;
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.onAddedExternalObserver__Lcom_raquo_airstream_core_Observer__V = (function(observer) {
  observer.onTry__s_util_Try__V($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this));
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.externalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_flatten_SwitchSignal__f_externalObservers;
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.internalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_flatten_SwitchSignal__f_internalObservers;
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.willStartDone__Z = (function() {
  return this.Lcom_raquo_airstream_flatten_SwitchSignal__f_willStartDone;
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.willStartDone_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_flatten_SwitchSignal__f_willStartDone = x$1;
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.com$raquo$airstream$core$WritableObservable$_setter_$externalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_flatten_SwitchSignal__f_externalObservers = x$0;
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.com$raquo$airstream$core$WritableObservable$_setter_$internalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_flatten_SwitchSignal__f_internalObservers = x$0;
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.maybeLastSeenCurrentValue__O = (function() {
  return this.Lcom_raquo_airstream_flatten_SwitchSignal__f_maybeLastSeenCurrentValue;
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.maybeLastSeenCurrentValue_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_flatten_SwitchSignal__f_maybeLastSeenCurrentValue = x$1;
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.tryNow__s_util_Try = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.onNext__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.topoRank__I = (function() {
  return this.Lcom_raquo_airstream_flatten_SwitchSignal__f_topoRank;
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.currentValueFromParent__s_util_Try = (function() {
  return this.Lcom_raquo_airstream_flatten_SwitchSignal__f_parent.tryNow__s_util_Try().flatMap__F1__s_util_Try(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$3) => _$3.tryNow__s_util_Try())));
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextParentValue, transaction) {
  this.switchToSignalOnline__s_util_Try__V(nextParentValue);
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.onWillStart__V = (function() {
  var observable = this.Lcom_raquo_airstream_flatten_SwitchSignal__f_parent;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(observable);
  var nextSignalTry = this.Lcom_raquo_airstream_flatten_SwitchSignal__f_parent.tryNow__s_util_Try();
  if ($p_Lcom_raquo_airstream_flatten_SwitchSignal__isSameSignal__s_util_Try__s_util_Try__Z(this, nextSignalTry, $p_Lcom_raquo_airstream_flatten_SwitchSignal__currentSignalTry__s_util_Try(this))) {
    $p_Lcom_raquo_airstream_flatten_SwitchSignal__currentSignalTry__s_util_Try(this).foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((observable$1) => {
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(observable$1);
    })));
    var nextSignal = nextSignalTry.get__O();
    var nextSignalLastUpdateId = nextSignal._lastUpdateId__I();
    if ((nextSignalLastUpdateId !== this.Lcom_raquo_airstream_flatten_SwitchSignal__f_innerSignalLastSeenUpdateId)) {
      var newValue = nextSignal.tryNow__s_util_Try();
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableSignal__setCurrentValue__s_util_Try__V(this, newValue);
      this.Lcom_raquo_airstream_flatten_SwitchSignal__f_innerSignalLastSeenUpdateId = nextSignalLastUpdateId;
    }
  } else {
    $p_Lcom_raquo_airstream_flatten_SwitchSignal__currentSignalTry__s_util_Try(this).foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$4) => {
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V(_$4, this.Lcom_raquo_airstream_flatten_SwitchSignal__f_internalEventObserver);
    })));
    this.Lcom_raquo_airstream_flatten_SwitchSignal__f_maybeCurrentSignalTry = nextSignalTry;
    nextSignalTry.foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((observable$2) => {
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(observable$2);
    })));
    var newValue$1 = nextSignalTry.flatMap__F1__s_util_Try(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$5) => _$5.tryNow__s_util_Try())));
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableSignal__setCurrentValue__s_util_Try__V(this, newValue$1);
    this.Lcom_raquo_airstream_flatten_SwitchSignal__f_innerSignalLastSeenUpdateId = (nextSignalTry.map__F1__s_util_Try(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((signal) => signal._lastUpdateId__I()))).getOrElse__F0__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => 0))) | 0);
    nextSignalTry.foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$6) => {
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(_$6, this.Lcom_raquo_airstream_flatten_SwitchSignal__f_internalEventObserver, false);
    })));
  }
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.switchToSignalOnline__s_util_Try__V = (function(nextSignalTry) {
  if ((!$p_Lcom_raquo_airstream_flatten_SwitchSignal__isSameSignal__s_util_Try__s_util_Try__Z(this, nextSignalTry, $p_Lcom_raquo_airstream_flatten_SwitchSignal__currentSignalTry__s_util_Try(this)))) {
    var prevSignalTry = $p_Lcom_raquo_airstream_flatten_SwitchSignal__currentSignalTry__s_util_Try(this);
    prevSignalTry.foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$7) => {
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(_$7, $m_Lcom_raquo_airstream_core_InternalObserver$().Lcom_raquo_airstream_core_InternalObserver$__f_empty, false);
    })));
    prevSignalTry.foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$8) => {
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V(_$8, this.Lcom_raquo_airstream_flatten_SwitchSignal__f_internalEventObserver);
    })));
    this.Lcom_raquo_airstream_flatten_SwitchSignal__f_maybeCurrentSignalTry = nextSignalTry;
    this.Lcom_raquo_airstream_flatten_SwitchSignal__f_innerSignalLastSeenUpdateId = 0;
    var code = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((trx) => {
      if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z(this)) {
        nextSignalTry.foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((observable) => {
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(observable);
        })));
        var nextValue = nextSignalTry.flatMap__F1__s_util_Try(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$9) => _$9.tryNow__s_util_Try())));
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, trx);
        this.Lcom_raquo_airstream_flatten_SwitchSignal__f_innerSignalLastSeenUpdateId = (nextSignalTry.map__F1__s_util_Try(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((signal) => signal._lastUpdateId__I()))).getOrElse__F0__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => 0))) | 0);
        nextSignalTry.foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$10) => {
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(_$10, this.Lcom_raquo_airstream_flatten_SwitchSignal__f_internalEventObserver, false);
        })));
        prevSignalTry.foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$11) => {
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V(_$11, $m_Lcom_raquo_airstream_core_InternalObserver$().Lcom_raquo_airstream_core_InternalObserver$__f_empty);
        })));
      }
    }));
    new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_core_Transaction(code);
  }
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.onStart__V = (function() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(this.Lcom_raquo_airstream_flatten_SwitchSignal__f_parent, this, false);
  $p_Lcom_raquo_airstream_flatten_SwitchSignal__currentSignalTry__s_util_Try(this).foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$12) => {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(_$12, this.Lcom_raquo_airstream_flatten_SwitchSignal__f_internalEventObserver, false);
  })));
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_Signal__onStart__V(this);
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.onStop__V = (function() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V(this.Lcom_raquo_airstream_flatten_SwitchSignal__f_parent, this);
  $p_Lcom_raquo_airstream_flatten_SwitchSignal__currentSignalTry__s_util_Try(this).foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$13) => {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V(_$13, this.Lcom_raquo_airstream_flatten_SwitchSignal__f_internalEventObserver);
  })));
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.map__F1__Lcom_raquo_airstream_core_Observable = (function(project) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), this, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.distinctTry__F2__Lcom_raquo_airstream_core_Observable = (function(isSame) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_distinct_DistinctSignal(this, isSame, false);
});
$c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype.toObservable__Lcom_raquo_airstream_core_Observable = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_flatten_SwitchSignal = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_flatten_SwitchSignal, "com.raquo.airstream.flatten.SwitchSignal", ({
  Lcom_raquo_airstream_flatten_SwitchSignal: 1,
  Lcom_raquo_airstream_core_Source: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_BaseObservable: 1,
  Lcom_raquo_airstream_core_Observable: 1,
  Lcom_raquo_airstream_core_Source$SignalSource: 1,
  Lcom_raquo_airstream_dynamicImport_SignalDynamicImportOps: 1,
  Lcom_raquo_airstream_core_Signal: 1,
  Lcom_raquo_airstream_core_WritableObservable: 1,
  Lcom_raquo_airstream_core_WritableSignal: 1,
  Lcom_raquo_airstream_core_InternalObserver: 1,
  Lcom_raquo_airstream_common_InternalTryObserver: 1
}));
export { $d_Lcom_raquo_airstream_flatten_SwitchSignal as $d_Lcom_raquo_airstream_flatten_SwitchSignal };
function $p_Lcom_raquo_airstream_flatten_SwitchSignalStream__switchToSignal__s_util_Try__V($thiz, nextSignalTry) {
  var x = $thiz.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_maybeCurrentSignalTry;
  if ((x !== (void 0))) {
    matchResult1: {
      var isSameSignal;
      if ((nextSignalTry instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success)) {
        var nextSignal = nextSignalTry.s_util_Success__f_value;
        if ((x instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success)) {
          var currentSignal = x.s_util_Success__f_value;
          var isSameSignal = (nextSignal === currentSignal);
          break matchResult1;
        }
      }
      var isSameSignal = false;
    }
  } else {
    var isSameSignal = false;
  }
  if ((!isSameSignal)) {
    $p_Lcom_raquo_airstream_flatten_SwitchSignalStream__removeInternalObserverFromCurrentSignal__V($thiz);
    $thiz.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_maybeCurrentSignalTry = nextSignalTry;
    $thiz.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_lastSeenSignalUpdateId = (-1);
    var code = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((trx) => {
      if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z($thiz)) {
        nextSignalTry.foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((observable) => {
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(observable);
        })));
        var nextValue = nextSignalTry.flatMap__F1__s_util_Try(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$4) => _$4.tryNow__s_util_Try())));
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V($thiz, nextValue, trx);
        nextSignalTry.foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((nextSignal$1) => {
          $thiz.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_lastSeenSignalUpdateId = nextSignal$1._lastUpdateId__I();
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(nextSignal$1, $thiz.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_internalEventObserver, false);
        })));
      }
    }));
    new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_core_Transaction(code);
  }
}
export { $p_Lcom_raquo_airstream_flatten_SwitchSignalStream__switchToSignal__s_util_Try__V as $p_Lcom_raquo_airstream_flatten_SwitchSignalStream__switchToSignal__s_util_Try__V };
function $p_Lcom_raquo_airstream_flatten_SwitchSignalStream__removeInternalObserverFromCurrentSignal__V($thiz) {
  var x = $thiz.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_maybeCurrentSignalTry;
  if ((x !== (void 0))) {
    x.foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((currentSignal) => {
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V(currentSignal, $thiz.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_internalEventObserver);
    })));
  }
}
export { $p_Lcom_raquo_airstream_flatten_SwitchSignalStream__removeInternalObserverFromCurrentSignal__V as $p_Lcom_raquo_airstream_flatten_SwitchSignalStream__removeInternalObserverFromCurrentSignal__V };
/** @constructor */
function $c_Lcom_raquo_airstream_flatten_SwitchSignalStream(parent) {
  this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_isSafeToRemoveObserver = false;
  this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_maybePendingObserverRemovals = null;
  this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_externalObservers = null;
  this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_internalObservers = null;
  this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_willStartDone = false;
  this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_parent = null;
  this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_topoRank = 0;
  this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_maybeCurrentSignalTry = null;
  this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_lastSeenSignalUpdateId = 0;
  this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_internalEventObserver = null;
  this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_parent = parent;
  this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_maybeDisplayName = (void 0);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_topoRank = 1;
  this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_maybeCurrentSignalTry = (void 0);
  this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_lastSeenSignalUpdateId = 0;
  this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_internalEventObserver = $m_Lcom_raquo_airstream_core_InternalObserver$().fromTry__F2__Lcom_raquo_airstream_core_InternalObserver(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((nextTry, _$1) => {
    var code = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((nextTry$2) => ((trx) => {
      if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z(this)) {
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextTry$2, trx);
        var x = this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_maybeCurrentSignalTry;
        if ((x !== (void 0))) {
          x.foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((currentSignal) => {
            this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_lastSeenSignalUpdateId = currentSignal._lastUpdateId__I();
          })));
        }
      }
    }))(nextTry));
    new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_core_Transaction(code);
  })));
}
export { $c_Lcom_raquo_airstream_flatten_SwitchSignalStream as $c_Lcom_raquo_airstream_flatten_SwitchSignalStream };
$c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype.constructor = $c_Lcom_raquo_airstream_flatten_SwitchSignalStream;
/** @constructor */
function $h_Lcom_raquo_airstream_flatten_SwitchSignalStream() {
}
export { $h_Lcom_raquo_airstream_flatten_SwitchSignalStream as $h_Lcom_raquo_airstream_flatten_SwitchSignalStream };
$h_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype = $c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype;
$c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype.defaultDisplayName__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype.isSafeToRemoveObserver__Z = (function() {
  return this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_isSafeToRemoveObserver;
});
$c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype.maybePendingObserverRemovals__O = (function() {
  return this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_maybePendingObserverRemovals;
});
$c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype.isSafeToRemoveObserver_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_isSafeToRemoveObserver = x$1;
});
$c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype.maybePendingObserverRemovals_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_maybePendingObserverRemovals = x$1;
});
$c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype.equals__O__Z = (function(obj) {
  return (this === obj);
});
$c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$systemIdentityHashCode(this);
});
$c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype.onAddedExternalObserver__Lcom_raquo_airstream_core_Observer__V = (function(observer) {
});
$c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype.toObservable__Lcom_raquo_airstream_core_EventStream = (function() {
  return this;
});
$c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype.externalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_externalObservers;
});
$c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype.internalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_internalObservers;
});
$c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype.willStartDone__Z = (function() {
  return this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_willStartDone;
});
$c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype.willStartDone_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_willStartDone = x$1;
});
$c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype.com$raquo$airstream$core$WritableObservable$_setter_$externalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_externalObservers = x$0;
});
$c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype.com$raquo$airstream$core$WritableObservable$_setter_$internalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_internalObservers = x$0;
});
$c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype.fireValue__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype.fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype.fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype.onNext__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype.onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype.topoRank__I = (function() {
  return this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_topoRank;
});
$c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype.onWillStart__V = (function() {
  var observable = this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_parent;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(observable);
  var x = this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_maybeCurrentSignalTry;
  if ((x !== (void 0))) {
    x.foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((currentSignal) => {
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(currentSignal);
    })));
  }
});
$c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype.onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextSignalTry, transaction) {
  $p_Lcom_raquo_airstream_flatten_SwitchSignalStream__switchToSignal__s_util_Try__V(this, nextSignalTry);
});
$c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype.onStart__V = (function() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_parent, this, false);
  var x = this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_maybeCurrentSignalTry;
  if ((x !== (void 0))) {
    x.foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((currentSignal) => {
      var newSignalLastUpdateId = currentSignal._lastUpdateId__I();
      if ((newSignalLastUpdateId !== this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_lastSeenSignalUpdateId)) {
        var code = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((currentSignal$2) => ((trx) => {
          if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z(this)) {
            var nextValue = currentSignal$2.tryNow__s_util_Try();
            $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, trx);
            this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_lastSeenSignalUpdateId = newSignalLastUpdateId;
          }
        }))(currentSignal));
        new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_core_Transaction(code);
      }
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(currentSignal, this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_internalEventObserver, false);
    })));
  }
});
$c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype.onStop__V = (function() {
  $p_Lcom_raquo_airstream_flatten_SwitchSignalStream__removeInternalObserverFromCurrentSignal__V(this);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V(this.Lcom_raquo_airstream_flatten_SwitchSignalStream__f_parent, this);
});
$c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype.map__F1__Lcom_raquo_airstream_core_Observable = (function(project) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapStream(this, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype.distinctTry__F2__Lcom_raquo_airstream_core_Observable = (function(isSame) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype.toObservable__Lcom_raquo_airstream_core_Observable = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_flatten_SwitchSignalStream = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_flatten_SwitchSignalStream, "com.raquo.airstream.flatten.SwitchSignalStream", ({
  Lcom_raquo_airstream_flatten_SwitchSignalStream: 1,
  Lcom_raquo_airstream_core_Source: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_BaseObservable: 1,
  Lcom_raquo_airstream_core_Observable: 1,
  Lcom_raquo_airstream_core_Source$EventSource: 1,
  Lcom_raquo_airstream_dynamicImport_StreamDynamicImportOps: 1,
  Lcom_raquo_airstream_core_EventStream: 1,
  Lcom_raquo_airstream_core_WritableObservable: 1,
  Lcom_raquo_airstream_core_WritableStream: 1,
  Lcom_raquo_airstream_core_InternalObserver: 1,
  Lcom_raquo_airstream_common_InternalTryObserver: 1
}));
export { $d_Lcom_raquo_airstream_flatten_SwitchSignalStream as $d_Lcom_raquo_airstream_flatten_SwitchSignalStream };
function $p_Lcom_raquo_airstream_flatten_SwitchStream__switchToNextStream__Lcom_raquo_airstream_core_EventStream__Z__V($thiz, nextStream, isStarting) {
  var x = $thiz.Lcom_raquo_airstream_flatten_SwitchStream__f_maybeCurrentEventStreamTry;
  var isSameStream = ((x !== (void 0)) && (x.isSuccess__Z() && (x.get__O() === nextStream)));
  var maybePrevEventStreamTry = $thiz.Lcom_raquo_airstream_flatten_SwitchStream__f_maybeCurrentEventStreamTry;
  if ((!isSameStream)) {
    if ((maybePrevEventStreamTry !== (void 0))) {
      maybePrevEventStreamTry.foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((prevStream) => {
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(prevStream, $m_Lcom_raquo_airstream_core_InternalObserver$().Lcom_raquo_airstream_core_InternalObserver$__f_empty, false);
      })));
    }
    $p_Lcom_raquo_airstream_flatten_SwitchStream__removeInternalObserverFromCurrentEventStream__V($thiz);
    $thiz.Lcom_raquo_airstream_flatten_SwitchStream__f_maybeCurrentEventStreamTry = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(nextStream);
  }
  if (((!isSameStream) || isStarting)) {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(nextStream, $thiz.Lcom_raquo_airstream_flatten_SwitchStream__f_internalEventObserver, (!isStarting));
    if ((!isSameStream)) {
      if ((maybePrevEventStreamTry !== (void 0))) {
        maybePrevEventStreamTry.foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((prevStream$1) => {
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V(prevStream$1, $m_Lcom_raquo_airstream_core_InternalObserver$().Lcom_raquo_airstream_core_InternalObserver$__f_empty);
        })));
      }
    }
  }
}
export { $p_Lcom_raquo_airstream_flatten_SwitchStream__switchToNextStream__Lcom_raquo_airstream_core_EventStream__Z__V as $p_Lcom_raquo_airstream_flatten_SwitchStream__switchToNextStream__Lcom_raquo_airstream_core_EventStream__Z__V };
function $p_Lcom_raquo_airstream_flatten_SwitchStream__switchToNextError__jl_Throwable__s_Option__V($thiz, nextError, transaction) {
  $p_Lcom_raquo_airstream_flatten_SwitchStream__removeInternalObserverFromCurrentEventStream__V($thiz);
  $thiz.Lcom_raquo_airstream_flatten_SwitchStream__f_maybeCurrentEventStreamTry = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(nextError);
  if (transaction.isEmpty__Z()) {
    var code = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$9) => {
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V($thiz, nextError, _$9);
    }));
    new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_core_Transaction(code);
  } else {
    var x0 = transaction.get__O();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V($thiz, nextError, x0);
  }
}
export { $p_Lcom_raquo_airstream_flatten_SwitchStream__switchToNextError__jl_Throwable__s_Option__V as $p_Lcom_raquo_airstream_flatten_SwitchStream__switchToNextError__jl_Throwable__s_Option__V };
function $p_Lcom_raquo_airstream_flatten_SwitchStream__removeInternalObserverFromCurrentEventStream__V($thiz) {
  var x = $thiz.Lcom_raquo_airstream_flatten_SwitchStream__f_maybeCurrentEventStreamTry;
  if ((x !== (void 0))) {
    x.foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((currentStream) => {
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V(currentStream, $thiz.Lcom_raquo_airstream_flatten_SwitchStream__f_internalEventObserver);
    })));
  }
}
export { $p_Lcom_raquo_airstream_flatten_SwitchStream__removeInternalObserverFromCurrentEventStream__V as $p_Lcom_raquo_airstream_flatten_SwitchStream__removeInternalObserverFromCurrentEventStream__V };
/** @constructor */
function $c_Lcom_raquo_airstream_flatten_SwitchStream(parent, makeStream) {
  this.Lcom_raquo_airstream_flatten_SwitchStream__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_flatten_SwitchStream__f_isSafeToRemoveObserver = false;
  this.Lcom_raquo_airstream_flatten_SwitchStream__f_maybePendingObserverRemovals = null;
  this.Lcom_raquo_airstream_flatten_SwitchStream__f_externalObservers = null;
  this.Lcom_raquo_airstream_flatten_SwitchStream__f_internalObservers = null;
  this.Lcom_raquo_airstream_flatten_SwitchStream__f_willStartDone = false;
  this.Lcom_raquo_airstream_flatten_SwitchStream__f_parent = null;
  this.Lcom_raquo_airstream_flatten_SwitchStream__f_makeStream = null;
  this.Lcom_raquo_airstream_flatten_SwitchStream__f_topoRank = 0;
  this.Lcom_raquo_airstream_flatten_SwitchStream__f_parentIsSignal = false;
  this.Lcom_raquo_airstream_flatten_SwitchStream__f_maybeCurrentEventStreamTry = null;
  this.Lcom_raquo_airstream_flatten_SwitchStream__f_maybeNextEventStreamTry = null;
  this.Lcom_raquo_airstream_flatten_SwitchStream__f_internalEventObserver = null;
  this.Lcom_raquo_airstream_flatten_SwitchStream__f_parent = parent;
  this.Lcom_raquo_airstream_flatten_SwitchStream__f_makeStream = makeStream;
  this.Lcom_raquo_airstream_flatten_SwitchStream__f_maybeDisplayName = (void 0);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.Lcom_raquo_airstream_flatten_SwitchStream__f_topoRank = 1;
  this.Lcom_raquo_airstream_flatten_SwitchStream__f_parentIsSignal = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$is_Lcom_raquo_airstream_core_Signal(parent);
  this.Lcom_raquo_airstream_flatten_SwitchStream__f_maybeCurrentEventStreamTry = (void 0);
  this.Lcom_raquo_airstream_flatten_SwitchStream__f_maybeNextEventStreamTry = (void 0);
  this.Lcom_raquo_airstream_flatten_SwitchStream__f_internalEventObserver = $m_Lcom_raquo_airstream_core_InternalObserver$().apply__F2__F2__Lcom_raquo_airstream_core_InternalObserver(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((nextEvent, _$1) => {
    var code = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => {
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, nextEvent, _$2);
    }));
    new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_core_Transaction(code);
  })), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((nextError, _$3) => {
    var code$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((nextError$2) => ((_$4) => {
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError$2, _$4);
    }))(nextError));
    new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_core_Transaction(code$1);
  })));
}
export { $c_Lcom_raquo_airstream_flatten_SwitchStream as $c_Lcom_raquo_airstream_flatten_SwitchStream };
$c_Lcom_raquo_airstream_flatten_SwitchStream.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_flatten_SwitchStream.prototype.constructor = $c_Lcom_raquo_airstream_flatten_SwitchStream;
/** @constructor */
function $h_Lcom_raquo_airstream_flatten_SwitchStream() {
}
export { $h_Lcom_raquo_airstream_flatten_SwitchStream as $h_Lcom_raquo_airstream_flatten_SwitchStream };
$h_Lcom_raquo_airstream_flatten_SwitchStream.prototype = $c_Lcom_raquo_airstream_flatten_SwitchStream.prototype;
$c_Lcom_raquo_airstream_flatten_SwitchStream.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_flatten_SwitchStream__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_flatten_SwitchStream.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_flatten_SwitchStream__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_flatten_SwitchStream.prototype.defaultDisplayName__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_airstream_flatten_SwitchStream.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_flatten_SwitchStream.prototype.isSafeToRemoveObserver__Z = (function() {
  return this.Lcom_raquo_airstream_flatten_SwitchStream__f_isSafeToRemoveObserver;
});
$c_Lcom_raquo_airstream_flatten_SwitchStream.prototype.maybePendingObserverRemovals__O = (function() {
  return this.Lcom_raquo_airstream_flatten_SwitchStream__f_maybePendingObserverRemovals;
});
$c_Lcom_raquo_airstream_flatten_SwitchStream.prototype.isSafeToRemoveObserver_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_flatten_SwitchStream__f_isSafeToRemoveObserver = x$1;
});
$c_Lcom_raquo_airstream_flatten_SwitchStream.prototype.maybePendingObserverRemovals_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_flatten_SwitchStream__f_maybePendingObserverRemovals = x$1;
});
$c_Lcom_raquo_airstream_flatten_SwitchStream.prototype.equals__O__Z = (function(obj) {
  return (this === obj);
});
$c_Lcom_raquo_airstream_flatten_SwitchStream.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$systemIdentityHashCode(this);
});
$c_Lcom_raquo_airstream_flatten_SwitchStream.prototype.onAddedExternalObserver__Lcom_raquo_airstream_core_Observer__V = (function(observer) {
});
$c_Lcom_raquo_airstream_flatten_SwitchStream.prototype.toObservable__Lcom_raquo_airstream_core_EventStream = (function() {
  return this;
});
$c_Lcom_raquo_airstream_flatten_SwitchStream.prototype.externalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_flatten_SwitchStream__f_externalObservers;
});
$c_Lcom_raquo_airstream_flatten_SwitchStream.prototype.internalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_flatten_SwitchStream__f_internalObservers;
});
$c_Lcom_raquo_airstream_flatten_SwitchStream.prototype.willStartDone__Z = (function() {
  return this.Lcom_raquo_airstream_flatten_SwitchStream__f_willStartDone;
});
$c_Lcom_raquo_airstream_flatten_SwitchStream.prototype.willStartDone_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_flatten_SwitchStream__f_willStartDone = x$1;
});
$c_Lcom_raquo_airstream_flatten_SwitchStream.prototype.com$raquo$airstream$core$WritableObservable$_setter_$externalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_flatten_SwitchStream__f_externalObservers = x$0;
});
$c_Lcom_raquo_airstream_flatten_SwitchStream.prototype.com$raquo$airstream$core$WritableObservable$_setter_$internalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_flatten_SwitchStream__f_internalObservers = x$0;
});
$c_Lcom_raquo_airstream_flatten_SwitchStream.prototype.fireValue__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_flatten_SwitchStream.prototype.fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$c_Lcom_raquo_airstream_flatten_SwitchStream.prototype.fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_flatten_SwitchStream.prototype.onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_InternalNextErrorObserver__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_flatten_SwitchStream.prototype.topoRank__I = (function() {
  return this.Lcom_raquo_airstream_flatten_SwitchStream__f_topoRank;
});
$c_Lcom_raquo_airstream_flatten_SwitchStream.prototype.onNext__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $p_Lcom_raquo_airstream_flatten_SwitchStream__switchToNextStream__Lcom_raquo_airstream_core_EventStream__Z__V(this, this.Lcom_raquo_airstream_flatten_SwitchStream__f_makeStream.apply__O__O(nextValue), false);
});
$c_Lcom_raquo_airstream_flatten_SwitchStream.prototype.onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  $p_Lcom_raquo_airstream_flatten_SwitchStream__switchToNextError__jl_Throwable__s_Option__V(this, nextError, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(transaction));
});
$c_Lcom_raquo_airstream_flatten_SwitchStream.prototype.onWillStart__V = (function() {
  var observable = this.Lcom_raquo_airstream_flatten_SwitchStream__f_parent;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(observable);
  if (this.Lcom_raquo_airstream_flatten_SwitchStream__f_parentIsSignal) {
    var parentSignal = this.Lcom_raquo_airstream_flatten_SwitchStream__f_parent;
    var newStreamTry = parentSignal.tryNow__s_util_Try().map__F1__s_util_Try(this.Lcom_raquo_airstream_flatten_SwitchStream__f_makeStream);
    newStreamTry.foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((observable$1) => {
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(observable$1);
    })));
    this.Lcom_raquo_airstream_flatten_SwitchStream__f_maybeNextEventStreamTry = newStreamTry;
  } else {
    var x = this.Lcom_raquo_airstream_flatten_SwitchStream__f_maybeCurrentEventStreamTry;
    if ((x !== (void 0))) {
      x.foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((observable$2) => {
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(observable$2);
      })));
    }
  }
});
$c_Lcom_raquo_airstream_flatten_SwitchStream.prototype.onStart__V = (function() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(this.Lcom_raquo_airstream_flatten_SwitchStream__f_parent, this, false);
  if (this.Lcom_raquo_airstream_flatten_SwitchStream__f_parentIsSignal) {
    var x = this.Lcom_raquo_airstream_flatten_SwitchStream__f_maybeNextEventStreamTry;
    if ((x !== (void 0))) {
      matchResult1: {
        if ((x instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success)) {
          var nextStream = x.s_util_Success__f_value;
          $p_Lcom_raquo_airstream_flatten_SwitchStream__switchToNextStream__Lcom_raquo_airstream_core_EventStream__Z__V(this, nextStream, true);
          break matchResult1;
        }
        if ((x instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure)) {
          var nextError = x.s_util_Failure__f_exception;
          $p_Lcom_raquo_airstream_flatten_SwitchStream__switchToNextError__jl_Throwable__s_Option__V(this, nextError, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
          break matchResult1;
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x);
      }
    }
    this.Lcom_raquo_airstream_flatten_SwitchStream__f_maybeNextEventStreamTry = (void 0);
  } else {
    var x$1 = this.Lcom_raquo_airstream_flatten_SwitchStream__f_maybeCurrentEventStreamTry;
    if ((x$1 !== (void 0))) {
      x$1.foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((currentStream) => {
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(currentStream, this.Lcom_raquo_airstream_flatten_SwitchStream__f_internalEventObserver, false);
      })));
    }
  }
});
$c_Lcom_raquo_airstream_flatten_SwitchStream.prototype.onStop__V = (function() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V(this.Lcom_raquo_airstream_flatten_SwitchStream__f_parent, this);
  $p_Lcom_raquo_airstream_flatten_SwitchStream__removeInternalObserverFromCurrentEventStream__V(this);
});
$c_Lcom_raquo_airstream_flatten_SwitchStream.prototype.map__F1__Lcom_raquo_airstream_core_Observable = (function(project) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapStream(this, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lcom_raquo_airstream_flatten_SwitchStream.prototype.distinctTry__F2__Lcom_raquo_airstream_core_Observable = (function(isSame) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$c_Lcom_raquo_airstream_flatten_SwitchStream.prototype.toObservable__Lcom_raquo_airstream_core_Observable = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_flatten_SwitchStream = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_flatten_SwitchStream, "com.raquo.airstream.flatten.SwitchStream", ({
  Lcom_raquo_airstream_flatten_SwitchStream: 1,
  Lcom_raquo_airstream_core_Source: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_BaseObservable: 1,
  Lcom_raquo_airstream_core_Observable: 1,
  Lcom_raquo_airstream_core_Source$EventSource: 1,
  Lcom_raquo_airstream_dynamicImport_StreamDynamicImportOps: 1,
  Lcom_raquo_airstream_core_EventStream: 1,
  Lcom_raquo_airstream_core_WritableObservable: 1,
  Lcom_raquo_airstream_core_WritableStream: 1,
  Lcom_raquo_airstream_core_InternalObserver: 1,
  Lcom_raquo_airstream_common_InternalNextErrorObserver: 1
}));
export { $d_Lcom_raquo_airstream_flatten_SwitchStream as $d_Lcom_raquo_airstream_flatten_SwitchStream };
function $is_sci_Set(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_Set)));
}
export { $is_sci_Set as $is_sci_Set };
function $isArrayOf_sci_Set(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Set)));
}
export { $isArrayOf_sci_Set as $isArrayOf_sci_Set };
function $isArrayOf_Lsttp_tapir_EndpointIO$MappedPair(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointIO$MappedPair)));
}
export { $isArrayOf_Lsttp_tapir_EndpointIO$MappedPair as $isArrayOf_Lsttp_tapir_EndpointIO$MappedPair };
/** @constructor */
function $c_Lsttp_tapir_EndpointInput$Cookie(name, codec, info) {
  this.Lsttp_tapir_EndpointInput$Cookie__f_name = null;
  this.Lsttp_tapir_EndpointInput$Cookie__f_codec = null;
  this.Lsttp_tapir_EndpointInput$Cookie__f_info = null;
  this.Lsttp_tapir_EndpointInput$Cookie__f_name = name;
  this.Lsttp_tapir_EndpointInput$Cookie__f_codec = codec;
  this.Lsttp_tapir_EndpointInput$Cookie__f_info = info;
}
export { $c_Lsttp_tapir_EndpointInput$Cookie as $c_Lsttp_tapir_EndpointInput$Cookie };
$c_Lsttp_tapir_EndpointInput$Cookie.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_EndpointInput$Cookie.prototype.constructor = $c_Lsttp_tapir_EndpointInput$Cookie;
/** @constructor */
function $h_Lsttp_tapir_EndpointInput$Cookie() {
}
export { $h_Lsttp_tapir_EndpointInput$Cookie as $h_Lsttp_tapir_EndpointInput$Cookie };
$h_Lsttp_tapir_EndpointInput$Cookie.prototype = $c_Lsttp_tapir_EndpointInput$Cookie.prototype;
$c_Lsttp_tapir_EndpointInput$Cookie.prototype.map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput = (function(mapping) {
  return $f_Lsttp_tapir_EndpointTransput$Atom__map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput(this, mapping);
});
$c_Lsttp_tapir_EndpointInput$Cookie.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_EndpointInput$Cookie.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 2015920540, true);
});
$c_Lsttp_tapir_EndpointInput$Cookie.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_EndpointInput$Cookie)) {
    if ((this.Lsttp_tapir_EndpointInput$Cookie__f_name === x$0.Lsttp_tapir_EndpointInput$Cookie__f_name)) {
      var x = this.Lsttp_tapir_EndpointInput$Cookie__f_codec;
      var x$2 = x$0.Lsttp_tapir_EndpointInput$Cookie__f_codec;
      var $x_1 = (x === x$2);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.Lsttp_tapir_EndpointInput$Cookie__f_info;
      var x$4 = x$0.Lsttp_tapir_EndpointInput$Cookie__f_info;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_EndpointInput$Cookie.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_EndpointInput$Cookie.prototype.productArity__I = (function() {
  return 3;
});
$c_Lsttp_tapir_EndpointInput$Cookie.prototype.productPrefix__T = (function() {
  return "Cookie";
});
$c_Lsttp_tapir_EndpointInput$Cookie.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsttp_tapir_EndpointInput$Cookie__f_name;
      break;
    }
    case 1: {
      return this.Lsttp_tapir_EndpointInput$Cookie__f_codec;
      break;
    }
    case 2: {
      return this.Lsttp_tapir_EndpointInput$Cookie__f_info;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_EndpointInput$Cookie.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "name";
      break;
    }
    case 1: {
      return "codec";
      break;
    }
    case 2: {
      return "info";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_EndpointInput$Cookie.prototype.codec__Lsttp_tapir_Codec = (function() {
  return this.Lsttp_tapir_EndpointInput$Cookie__f_codec;
});
$c_Lsttp_tapir_EndpointInput$Cookie.prototype.info__Lsttp_tapir_EndpointIO$Info = (function() {
  return this.Lsttp_tapir_EndpointInput$Cookie__f_info;
});
$c_Lsttp_tapir_EndpointInput$Cookie.prototype.copyWith__Lsttp_tapir_Codec__Lsttp_tapir_EndpointIO$Info__Lsttp_tapir_EndpointTransput = (function(c, i) {
  var name = this.Lsttp_tapir_EndpointInput$Cookie__f_name;
  return new $c_Lsttp_tapir_EndpointInput$Cookie(name, c, i);
});
function $isArrayOf_Lsttp_tapir_EndpointInput$Cookie(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointInput$Cookie)));
}
export { $isArrayOf_Lsttp_tapir_EndpointInput$Cookie as $isArrayOf_Lsttp_tapir_EndpointInput$Cookie };
var $d_Lsttp_tapir_EndpointInput$Cookie = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_EndpointInput$Cookie, "sttp.tapir.EndpointInput$Cookie", ({
  Lsttp_tapir_EndpointInput$Cookie: 1,
  Lsttp_tapir_macros_EndpointTransputMacros: 1,
  Lsttp_tapir_EndpointTransput: 1,
  Lsttp_tapir_EndpointInput: 1,
  Lsttp_tapir_EndpointInput$Single: 1,
  Lsttp_tapir_EndpointTransput$Basic: 1,
  Lsttp_tapir_EndpointInput$Basic: 1,
  Lsttp_tapir_EndpointTransput$Atom: 1,
  Lsttp_tapir_EndpointInput$Atom: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_EndpointInput$Cookie as $d_Lsttp_tapir_EndpointInput$Cookie };
/** @constructor */
function $c_Lsttp_tapir_EndpointInput$ExtractFromRequest(codec, info) {
  this.Lsttp_tapir_EndpointInput$ExtractFromRequest__f_codec = null;
  this.Lsttp_tapir_EndpointInput$ExtractFromRequest__f_info = null;
  this.Lsttp_tapir_EndpointInput$ExtractFromRequest__f_codec = codec;
  this.Lsttp_tapir_EndpointInput$ExtractFromRequest__f_info = info;
}
export { $c_Lsttp_tapir_EndpointInput$ExtractFromRequest as $c_Lsttp_tapir_EndpointInput$ExtractFromRequest };
$c_Lsttp_tapir_EndpointInput$ExtractFromRequest.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_EndpointInput$ExtractFromRequest.prototype.constructor = $c_Lsttp_tapir_EndpointInput$ExtractFromRequest;
/** @constructor */
function $h_Lsttp_tapir_EndpointInput$ExtractFromRequest() {
}
export { $h_Lsttp_tapir_EndpointInput$ExtractFromRequest as $h_Lsttp_tapir_EndpointInput$ExtractFromRequest };
$h_Lsttp_tapir_EndpointInput$ExtractFromRequest.prototype = $c_Lsttp_tapir_EndpointInput$ExtractFromRequest.prototype;
$c_Lsttp_tapir_EndpointInput$ExtractFromRequest.prototype.map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput = (function(mapping) {
  return $f_Lsttp_tapir_EndpointTransput$Atom__map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput(this, mapping);
});
$c_Lsttp_tapir_EndpointInput$ExtractFromRequest.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_EndpointInput$ExtractFromRequest.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 557612145, true);
});
$c_Lsttp_tapir_EndpointInput$ExtractFromRequest.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_EndpointInput$ExtractFromRequest)) {
    var x = this.Lsttp_tapir_EndpointInput$ExtractFromRequest__f_codec;
    var x$2 = x$0.Lsttp_tapir_EndpointInput$ExtractFromRequest__f_codec;
    if ((x === x$2)) {
      var x$3 = this.Lsttp_tapir_EndpointInput$ExtractFromRequest__f_info;
      var x$4 = x$0.Lsttp_tapir_EndpointInput$ExtractFromRequest__f_info;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_EndpointInput$ExtractFromRequest.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_EndpointInput$ExtractFromRequest.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsttp_tapir_EndpointInput$ExtractFromRequest.prototype.productPrefix__T = (function() {
  return "ExtractFromRequest";
});
$c_Lsttp_tapir_EndpointInput$ExtractFromRequest.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_EndpointInput$ExtractFromRequest__f_codec;
  }
  if ((n === 1)) {
    return this.Lsttp_tapir_EndpointInput$ExtractFromRequest__f_info;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_EndpointInput$ExtractFromRequest.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "codec";
  }
  if ((n === 1)) {
    return "info";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_EndpointInput$ExtractFromRequest.prototype.codec__Lsttp_tapir_Codec = (function() {
  return this.Lsttp_tapir_EndpointInput$ExtractFromRequest__f_codec;
});
$c_Lsttp_tapir_EndpointInput$ExtractFromRequest.prototype.info__Lsttp_tapir_EndpointIO$Info = (function() {
  return this.Lsttp_tapir_EndpointInput$ExtractFromRequest__f_info;
});
$c_Lsttp_tapir_EndpointInput$ExtractFromRequest.prototype.copyWith__Lsttp_tapir_Codec__Lsttp_tapir_EndpointIO$Info__Lsttp_tapir_EndpointTransput = (function(c, i) {
  return new $c_Lsttp_tapir_EndpointInput$ExtractFromRequest(c, i);
});
function $isArrayOf_Lsttp_tapir_EndpointInput$ExtractFromRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointInput$ExtractFromRequest)));
}
export { $isArrayOf_Lsttp_tapir_EndpointInput$ExtractFromRequest as $isArrayOf_Lsttp_tapir_EndpointInput$ExtractFromRequest };
var $d_Lsttp_tapir_EndpointInput$ExtractFromRequest = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_EndpointInput$ExtractFromRequest, "sttp.tapir.EndpointInput$ExtractFromRequest", ({
  Lsttp_tapir_EndpointInput$ExtractFromRequest: 1,
  Lsttp_tapir_macros_EndpointTransputMacros: 1,
  Lsttp_tapir_EndpointTransput: 1,
  Lsttp_tapir_EndpointInput: 1,
  Lsttp_tapir_EndpointInput$Single: 1,
  Lsttp_tapir_EndpointTransput$Basic: 1,
  Lsttp_tapir_EndpointInput$Basic: 1,
  Lsttp_tapir_EndpointTransput$Atom: 1,
  Lsttp_tapir_EndpointInput$Atom: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_EndpointInput$ExtractFromRequest as $d_Lsttp_tapir_EndpointInput$ExtractFromRequest };
/** @constructor */
function $c_Lsttp_tapir_EndpointInput$FixedMethod(m, codec, info) {
  this.Lsttp_tapir_EndpointInput$FixedMethod__f_m = null;
  this.Lsttp_tapir_EndpointInput$FixedMethod__f_codec = null;
  this.Lsttp_tapir_EndpointInput$FixedMethod__f_info = null;
  this.Lsttp_tapir_EndpointInput$FixedMethod__f_m = m;
  this.Lsttp_tapir_EndpointInput$FixedMethod__f_codec = codec;
  this.Lsttp_tapir_EndpointInput$FixedMethod__f_info = info;
}
export { $c_Lsttp_tapir_EndpointInput$FixedMethod as $c_Lsttp_tapir_EndpointInput$FixedMethod };
$c_Lsttp_tapir_EndpointInput$FixedMethod.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_EndpointInput$FixedMethod.prototype.constructor = $c_Lsttp_tapir_EndpointInput$FixedMethod;
/** @constructor */
function $h_Lsttp_tapir_EndpointInput$FixedMethod() {
}
export { $h_Lsttp_tapir_EndpointInput$FixedMethod as $h_Lsttp_tapir_EndpointInput$FixedMethod };
$h_Lsttp_tapir_EndpointInput$FixedMethod.prototype = $c_Lsttp_tapir_EndpointInput$FixedMethod.prototype;
$c_Lsttp_tapir_EndpointInput$FixedMethod.prototype.map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput = (function(mapping) {
  return $f_Lsttp_tapir_EndpointTransput$Atom__map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput(this, mapping);
});
$c_Lsttp_tapir_EndpointInput$FixedMethod.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_EndpointInput$FixedMethod.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 721984922, true);
});
$c_Lsttp_tapir_EndpointInput$FixedMethod.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_EndpointInput$FixedMethod)) {
    if ((this.Lsttp_tapir_EndpointInput$FixedMethod__f_m === x$0.Lsttp_tapir_EndpointInput$FixedMethod__f_m)) {
      var x = this.Lsttp_tapir_EndpointInput$FixedMethod__f_codec;
      var x$2 = x$0.Lsttp_tapir_EndpointInput$FixedMethod__f_codec;
      var $x_1 = (x === x$2);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.Lsttp_tapir_EndpointInput$FixedMethod__f_info;
      var x$4 = x$0.Lsttp_tapir_EndpointInput$FixedMethod__f_info;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_EndpointInput$FixedMethod.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_EndpointInput$FixedMethod.prototype.productArity__I = (function() {
  return 3;
});
$c_Lsttp_tapir_EndpointInput$FixedMethod.prototype.productPrefix__T = (function() {
  return "FixedMethod";
});
$c_Lsttp_tapir_EndpointInput$FixedMethod.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return new $c_Lsttp_model_Method(this.Lsttp_tapir_EndpointInput$FixedMethod__f_m);
      break;
    }
    case 1: {
      return this.Lsttp_tapir_EndpointInput$FixedMethod__f_codec;
      break;
    }
    case 2: {
      return this.Lsttp_tapir_EndpointInput$FixedMethod__f_info;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_EndpointInput$FixedMethod.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "m";
      break;
    }
    case 1: {
      return "codec";
      break;
    }
    case 2: {
      return "info";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_EndpointInput$FixedMethod.prototype.codec__Lsttp_tapir_Codec = (function() {
  return this.Lsttp_tapir_EndpointInput$FixedMethod__f_codec;
});
$c_Lsttp_tapir_EndpointInput$FixedMethod.prototype.info__Lsttp_tapir_EndpointIO$Info = (function() {
  return this.Lsttp_tapir_EndpointInput$FixedMethod__f_info;
});
$c_Lsttp_tapir_EndpointInput$FixedMethod.prototype.copyWith__Lsttp_tapir_Codec__Lsttp_tapir_EndpointIO$Info__Lsttp_tapir_EndpointTransput = (function(c, i) {
  var m = this.Lsttp_tapir_EndpointInput$FixedMethod__f_m;
  return new $c_Lsttp_tapir_EndpointInput$FixedMethod(m, c, i);
});
function $isArrayOf_Lsttp_tapir_EndpointInput$FixedMethod(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointInput$FixedMethod)));
}
export { $isArrayOf_Lsttp_tapir_EndpointInput$FixedMethod as $isArrayOf_Lsttp_tapir_EndpointInput$FixedMethod };
var $d_Lsttp_tapir_EndpointInput$FixedMethod = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_EndpointInput$FixedMethod, "sttp.tapir.EndpointInput$FixedMethod", ({
  Lsttp_tapir_EndpointInput$FixedMethod: 1,
  Lsttp_tapir_macros_EndpointTransputMacros: 1,
  Lsttp_tapir_EndpointTransput: 1,
  Lsttp_tapir_EndpointInput: 1,
  Lsttp_tapir_EndpointInput$Single: 1,
  Lsttp_tapir_EndpointTransput$Basic: 1,
  Lsttp_tapir_EndpointInput$Basic: 1,
  Lsttp_tapir_EndpointTransput$Atom: 1,
  Lsttp_tapir_EndpointInput$Atom: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_EndpointInput$FixedMethod as $d_Lsttp_tapir_EndpointInput$FixedMethod };
/** @constructor */
function $c_Lsttp_tapir_EndpointInput$FixedPath(s, codec, info) {
  this.Lsttp_tapir_EndpointInput$FixedPath__f_s = null;
  this.Lsttp_tapir_EndpointInput$FixedPath__f_codec = null;
  this.Lsttp_tapir_EndpointInput$FixedPath__f_info = null;
  this.Lsttp_tapir_EndpointInput$FixedPath__f_s = s;
  this.Lsttp_tapir_EndpointInput$FixedPath__f_codec = codec;
  this.Lsttp_tapir_EndpointInput$FixedPath__f_info = info;
}
export { $c_Lsttp_tapir_EndpointInput$FixedPath as $c_Lsttp_tapir_EndpointInput$FixedPath };
$c_Lsttp_tapir_EndpointInput$FixedPath.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_EndpointInput$FixedPath.prototype.constructor = $c_Lsttp_tapir_EndpointInput$FixedPath;
/** @constructor */
function $h_Lsttp_tapir_EndpointInput$FixedPath() {
}
export { $h_Lsttp_tapir_EndpointInput$FixedPath as $h_Lsttp_tapir_EndpointInput$FixedPath };
$h_Lsttp_tapir_EndpointInput$FixedPath.prototype = $c_Lsttp_tapir_EndpointInput$FixedPath.prototype;
$c_Lsttp_tapir_EndpointInput$FixedPath.prototype.map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput = (function(mapping) {
  return $f_Lsttp_tapir_EndpointTransput$Atom__map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput(this, mapping);
});
$c_Lsttp_tapir_EndpointInput$FixedPath.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_EndpointInput$FixedPath.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 2123894153, true);
});
$c_Lsttp_tapir_EndpointInput$FixedPath.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_EndpointInput$FixedPath)) {
    if ((this.Lsttp_tapir_EndpointInput$FixedPath__f_s === x$0.Lsttp_tapir_EndpointInput$FixedPath__f_s)) {
      var x = this.Lsttp_tapir_EndpointInput$FixedPath__f_codec;
      var x$2 = x$0.Lsttp_tapir_EndpointInput$FixedPath__f_codec;
      var $x_1 = (x === x$2);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.Lsttp_tapir_EndpointInput$FixedPath__f_info;
      var x$4 = x$0.Lsttp_tapir_EndpointInput$FixedPath__f_info;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_EndpointInput$FixedPath.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_EndpointInput$FixedPath.prototype.productArity__I = (function() {
  return 3;
});
$c_Lsttp_tapir_EndpointInput$FixedPath.prototype.productPrefix__T = (function() {
  return "FixedPath";
});
$c_Lsttp_tapir_EndpointInput$FixedPath.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsttp_tapir_EndpointInput$FixedPath__f_s;
      break;
    }
    case 1: {
      return this.Lsttp_tapir_EndpointInput$FixedPath__f_codec;
      break;
    }
    case 2: {
      return this.Lsttp_tapir_EndpointInput$FixedPath__f_info;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_EndpointInput$FixedPath.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "s";
      break;
    }
    case 1: {
      return "codec";
      break;
    }
    case 2: {
      return "info";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_EndpointInput$FixedPath.prototype.codec__Lsttp_tapir_Codec = (function() {
  return this.Lsttp_tapir_EndpointInput$FixedPath__f_codec;
});
$c_Lsttp_tapir_EndpointInput$FixedPath.prototype.info__Lsttp_tapir_EndpointIO$Info = (function() {
  return this.Lsttp_tapir_EndpointInput$FixedPath__f_info;
});
$c_Lsttp_tapir_EndpointInput$FixedPath.prototype.copyWith__Lsttp_tapir_Codec__Lsttp_tapir_EndpointIO$Info__Lsttp_tapir_EndpointTransput = (function(c, i) {
  var s = this.Lsttp_tapir_EndpointInput$FixedPath__f_s;
  return new $c_Lsttp_tapir_EndpointInput$FixedPath(s, c, i);
});
function $isArrayOf_Lsttp_tapir_EndpointInput$FixedPath(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointInput$FixedPath)));
}
export { $isArrayOf_Lsttp_tapir_EndpointInput$FixedPath as $isArrayOf_Lsttp_tapir_EndpointInput$FixedPath };
var $d_Lsttp_tapir_EndpointInput$FixedPath = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_EndpointInput$FixedPath, "sttp.tapir.EndpointInput$FixedPath", ({
  Lsttp_tapir_EndpointInput$FixedPath: 1,
  Lsttp_tapir_macros_EndpointTransputMacros: 1,
  Lsttp_tapir_EndpointTransput: 1,
  Lsttp_tapir_EndpointInput: 1,
  Lsttp_tapir_EndpointInput$Single: 1,
  Lsttp_tapir_EndpointTransput$Basic: 1,
  Lsttp_tapir_EndpointInput$Basic: 1,
  Lsttp_tapir_EndpointTransput$Atom: 1,
  Lsttp_tapir_EndpointInput$Atom: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_EndpointInput$FixedPath as $d_Lsttp_tapir_EndpointInput$FixedPath };
/** @constructor */
function $c_Lsttp_tapir_EndpointInput$PathCapture(name, codec, info) {
  this.Lsttp_tapir_EndpointInput$PathCapture__f_name = null;
  this.Lsttp_tapir_EndpointInput$PathCapture__f_codec = null;
  this.Lsttp_tapir_EndpointInput$PathCapture__f_info = null;
  this.Lsttp_tapir_EndpointInput$PathCapture__f_name = name;
  this.Lsttp_tapir_EndpointInput$PathCapture__f_codec = codec;
  this.Lsttp_tapir_EndpointInput$PathCapture__f_info = info;
}
export { $c_Lsttp_tapir_EndpointInput$PathCapture as $c_Lsttp_tapir_EndpointInput$PathCapture };
$c_Lsttp_tapir_EndpointInput$PathCapture.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_EndpointInput$PathCapture.prototype.constructor = $c_Lsttp_tapir_EndpointInput$PathCapture;
/** @constructor */
function $h_Lsttp_tapir_EndpointInput$PathCapture() {
}
export { $h_Lsttp_tapir_EndpointInput$PathCapture as $h_Lsttp_tapir_EndpointInput$PathCapture };
$h_Lsttp_tapir_EndpointInput$PathCapture.prototype = $c_Lsttp_tapir_EndpointInput$PathCapture.prototype;
$c_Lsttp_tapir_EndpointInput$PathCapture.prototype.map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput = (function(mapping) {
  return $f_Lsttp_tapir_EndpointTransput$Atom__map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput(this, mapping);
});
$c_Lsttp_tapir_EndpointInput$PathCapture.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_EndpointInput$PathCapture.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-984842683), true);
});
$c_Lsttp_tapir_EndpointInput$PathCapture.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_EndpointInput$PathCapture)) {
    var x = this.Lsttp_tapir_EndpointInput$PathCapture__f_name;
    var x$2 = x$0.Lsttp_tapir_EndpointInput$PathCapture__f_name;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lsttp_tapir_EndpointInput$PathCapture__f_codec;
      var x$4 = x$0.Lsttp_tapir_EndpointInput$PathCapture__f_codec;
      var $x_1 = (x$3 === x$4);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Lsttp_tapir_EndpointInput$PathCapture__f_info;
      var x$6 = x$0.Lsttp_tapir_EndpointInput$PathCapture__f_info;
      return ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_EndpointInput$PathCapture.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_EndpointInput$PathCapture.prototype.productArity__I = (function() {
  return 3;
});
$c_Lsttp_tapir_EndpointInput$PathCapture.prototype.productPrefix__T = (function() {
  return "PathCapture";
});
$c_Lsttp_tapir_EndpointInput$PathCapture.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsttp_tapir_EndpointInput$PathCapture__f_name;
      break;
    }
    case 1: {
      return this.Lsttp_tapir_EndpointInput$PathCapture__f_codec;
      break;
    }
    case 2: {
      return this.Lsttp_tapir_EndpointInput$PathCapture__f_info;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_EndpointInput$PathCapture.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "name";
      break;
    }
    case 1: {
      return "codec";
      break;
    }
    case 2: {
      return "info";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_EndpointInput$PathCapture.prototype.codec__Lsttp_tapir_Codec = (function() {
  return this.Lsttp_tapir_EndpointInput$PathCapture__f_codec;
});
$c_Lsttp_tapir_EndpointInput$PathCapture.prototype.info__Lsttp_tapir_EndpointIO$Info = (function() {
  return this.Lsttp_tapir_EndpointInput$PathCapture__f_info;
});
$c_Lsttp_tapir_EndpointInput$PathCapture.prototype.name__T__Lsttp_tapir_EndpointInput$PathCapture = (function(n) {
  var name = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(n);
  var codec = this.Lsttp_tapir_EndpointInput$PathCapture__f_codec;
  var info = this.Lsttp_tapir_EndpointInput$PathCapture__f_info;
  return new $c_Lsttp_tapir_EndpointInput$PathCapture(name, codec, info);
});
$c_Lsttp_tapir_EndpointInput$PathCapture.prototype.copyWith__Lsttp_tapir_Codec__Lsttp_tapir_EndpointIO$Info__Lsttp_tapir_EndpointTransput = (function(c, i) {
  var name = this.Lsttp_tapir_EndpointInput$PathCapture__f_name;
  return new $c_Lsttp_tapir_EndpointInput$PathCapture(name, c, i);
});
function $isArrayOf_Lsttp_tapir_EndpointInput$PathCapture(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointInput$PathCapture)));
}
export { $isArrayOf_Lsttp_tapir_EndpointInput$PathCapture as $isArrayOf_Lsttp_tapir_EndpointInput$PathCapture };
var $d_Lsttp_tapir_EndpointInput$PathCapture = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_EndpointInput$PathCapture, "sttp.tapir.EndpointInput$PathCapture", ({
  Lsttp_tapir_EndpointInput$PathCapture: 1,
  Lsttp_tapir_macros_EndpointTransputMacros: 1,
  Lsttp_tapir_EndpointTransput: 1,
  Lsttp_tapir_EndpointInput: 1,
  Lsttp_tapir_EndpointInput$Single: 1,
  Lsttp_tapir_EndpointTransput$Basic: 1,
  Lsttp_tapir_EndpointInput$Basic: 1,
  Lsttp_tapir_EndpointTransput$Atom: 1,
  Lsttp_tapir_EndpointInput$Atom: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_EndpointInput$PathCapture as $d_Lsttp_tapir_EndpointInput$PathCapture };
function $isArrayOf_Lsttp_tapir_EndpointInput$PathsCapture(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointInput$PathsCapture)));
}
export { $isArrayOf_Lsttp_tapir_EndpointInput$PathsCapture as $isArrayOf_Lsttp_tapir_EndpointInput$PathsCapture };
/** @constructor */
function $c_Lsttp_tapir_EndpointInput$Query(name, flagValue, codec, info) {
  this.Lsttp_tapir_EndpointInput$Query__f_name = null;
  this.Lsttp_tapir_EndpointInput$Query__f_flagValue = null;
  this.Lsttp_tapir_EndpointInput$Query__f_codec = null;
  this.Lsttp_tapir_EndpointInput$Query__f_info = null;
  this.Lsttp_tapir_EndpointInput$Query__f_name = name;
  this.Lsttp_tapir_EndpointInput$Query__f_flagValue = flagValue;
  this.Lsttp_tapir_EndpointInput$Query__f_codec = codec;
  this.Lsttp_tapir_EndpointInput$Query__f_info = info;
}
export { $c_Lsttp_tapir_EndpointInput$Query as $c_Lsttp_tapir_EndpointInput$Query };
$c_Lsttp_tapir_EndpointInput$Query.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_EndpointInput$Query.prototype.constructor = $c_Lsttp_tapir_EndpointInput$Query;
/** @constructor */
function $h_Lsttp_tapir_EndpointInput$Query() {
}
export { $h_Lsttp_tapir_EndpointInput$Query as $h_Lsttp_tapir_EndpointInput$Query };
$h_Lsttp_tapir_EndpointInput$Query.prototype = $c_Lsttp_tapir_EndpointInput$Query.prototype;
$c_Lsttp_tapir_EndpointInput$Query.prototype.map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput = (function(mapping) {
  return $f_Lsttp_tapir_EndpointTransput$Atom__map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput(this, mapping);
});
$c_Lsttp_tapir_EndpointInput$Query.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_EndpointInput$Query.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-691151777), true);
});
$c_Lsttp_tapir_EndpointInput$Query.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_EndpointInput$Query)) {
    if ((this.Lsttp_tapir_EndpointInput$Query__f_name === x$0.Lsttp_tapir_EndpointInput$Query__f_name)) {
      var x = this.Lsttp_tapir_EndpointInput$Query__f_flagValue;
      var x$2 = x$0.Lsttp_tapir_EndpointInput$Query__f_flagValue;
      var $x_2 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Lsttp_tapir_EndpointInput$Query__f_codec;
      var x$4 = x$0.Lsttp_tapir_EndpointInput$Query__f_codec;
      var $x_1 = (x$3 === x$4);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Lsttp_tapir_EndpointInput$Query__f_info;
      var x$6 = x$0.Lsttp_tapir_EndpointInput$Query__f_info;
      return ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_EndpointInput$Query.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_EndpointInput$Query.prototype.productArity__I = (function() {
  return 4;
});
$c_Lsttp_tapir_EndpointInput$Query.prototype.productPrefix__T = (function() {
  return "Query";
});
$c_Lsttp_tapir_EndpointInput$Query.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsttp_tapir_EndpointInput$Query__f_name;
      break;
    }
    case 1: {
      return this.Lsttp_tapir_EndpointInput$Query__f_flagValue;
      break;
    }
    case 2: {
      return this.Lsttp_tapir_EndpointInput$Query__f_codec;
      break;
    }
    case 3: {
      return this.Lsttp_tapir_EndpointInput$Query__f_info;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_EndpointInput$Query.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "name";
      break;
    }
    case 1: {
      return "flagValue";
      break;
    }
    case 2: {
      return "codec";
      break;
    }
    case 3: {
      return "info";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_EndpointInput$Query.prototype.codec__Lsttp_tapir_Codec = (function() {
  return this.Lsttp_tapir_EndpointInput$Query__f_codec;
});
$c_Lsttp_tapir_EndpointInput$Query.prototype.info__Lsttp_tapir_EndpointIO$Info = (function() {
  return this.Lsttp_tapir_EndpointInput$Query__f_info;
});
$c_Lsttp_tapir_EndpointInput$Query.prototype.copyWith__Lsttp_tapir_Codec__Lsttp_tapir_EndpointIO$Info__Lsttp_tapir_EndpointInput$Query = (function(c, i) {
  var this$1 = this.Lsttp_tapir_EndpointInput$Query__f_flagValue;
  if (this$1.isEmpty__Z()) {
    var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0 = this$1.get__O();
    var this$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lsttp_tapir_Codec__decode__O__Lsttp_tapir_DecodeResult(c, this.Lsttp_tapir_EndpointInput$Query__f_codec.encode__O__O(x0)));
  }
  var pf = new $c_Lsttp_tapir_EndpointInput$Query$$anon$1();
  if ((!this$2.isEmpty__Z())) {
    var this$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_PartialFunction$Lifted(pf);
    var v1 = this$2.get__O();
    var flagValue$1 = this$3.apply__O__s_Option(v1);
  } else {
    var flagValue$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
  var name$1 = this.Lsttp_tapir_EndpointInput$Query__f_name;
  return new $c_Lsttp_tapir_EndpointInput$Query(name$1, flagValue$1, c, i);
});
$c_Lsttp_tapir_EndpointInput$Query.prototype.copyWith__Lsttp_tapir_Codec__Lsttp_tapir_EndpointIO$Info__Lsttp_tapir_EndpointTransput = (function(c, i) {
  return this.copyWith__Lsttp_tapir_Codec__Lsttp_tapir_EndpointIO$Info__Lsttp_tapir_EndpointInput$Query(c, i);
});
function $isArrayOf_Lsttp_tapir_EndpointInput$Query(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointInput$Query)));
}
export { $isArrayOf_Lsttp_tapir_EndpointInput$Query as $isArrayOf_Lsttp_tapir_EndpointInput$Query };
var $d_Lsttp_tapir_EndpointInput$Query = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_EndpointInput$Query, "sttp.tapir.EndpointInput$Query", ({
  Lsttp_tapir_EndpointInput$Query: 1,
  Lsttp_tapir_macros_EndpointTransputMacros: 1,
  Lsttp_tapir_EndpointTransput: 1,
  Lsttp_tapir_EndpointInput: 1,
  Lsttp_tapir_EndpointInput$Single: 1,
  Lsttp_tapir_EndpointTransput$Basic: 1,
  Lsttp_tapir_EndpointInput$Basic: 1,
  Lsttp_tapir_EndpointTransput$Atom: 1,
  Lsttp_tapir_EndpointInput$Atom: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_EndpointInput$Query as $d_Lsttp_tapir_EndpointInput$Query };
function $isArrayOf_Lsttp_tapir_EndpointInput$QueryParams(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointInput$QueryParams)));
}
export { $isArrayOf_Lsttp_tapir_EndpointInput$QueryParams as $isArrayOf_Lsttp_tapir_EndpointInput$QueryParams };
/** @constructor */
function $c_Lsttp_tapir_EndpointOutput$FixedStatusCode(statusCode, codec, info) {
  this.Lsttp_tapir_EndpointOutput$FixedStatusCode__f_statusCode = 0;
  this.Lsttp_tapir_EndpointOutput$FixedStatusCode__f_codec = null;
  this.Lsttp_tapir_EndpointOutput$FixedStatusCode__f_info = null;
  this.Lsttp_tapir_EndpointOutput$FixedStatusCode__f_statusCode = statusCode;
  this.Lsttp_tapir_EndpointOutput$FixedStatusCode__f_codec = codec;
  this.Lsttp_tapir_EndpointOutput$FixedStatusCode__f_info = info;
}
export { $c_Lsttp_tapir_EndpointOutput$FixedStatusCode as $c_Lsttp_tapir_EndpointOutput$FixedStatusCode };
$c_Lsttp_tapir_EndpointOutput$FixedStatusCode.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_EndpointOutput$FixedStatusCode.prototype.constructor = $c_Lsttp_tapir_EndpointOutput$FixedStatusCode;
/** @constructor */
function $h_Lsttp_tapir_EndpointOutput$FixedStatusCode() {
}
export { $h_Lsttp_tapir_EndpointOutput$FixedStatusCode as $h_Lsttp_tapir_EndpointOutput$FixedStatusCode };
$h_Lsttp_tapir_EndpointOutput$FixedStatusCode.prototype = $c_Lsttp_tapir_EndpointOutput$FixedStatusCode.prototype;
$c_Lsttp_tapir_EndpointOutput$FixedStatusCode.prototype.and__Lsttp_tapir_EndpointOutput__Lsttp_tapir_typelevel_ParamConcat__Lsttp_tapir_EndpointOutput = (function(other, concat) {
  return $f_Lsttp_tapir_EndpointOutput__and__Lsttp_tapir_EndpointOutput__Lsttp_tapir_typelevel_ParamConcat__Lsttp_tapir_EndpointOutput(this, other, concat);
});
$c_Lsttp_tapir_EndpointOutput$FixedStatusCode.prototype.map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput = (function(mapping) {
  return $f_Lsttp_tapir_EndpointTransput$Atom__map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput(this, mapping);
});
$c_Lsttp_tapir_EndpointOutput$FixedStatusCode.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_EndpointOutput$FixedStatusCode.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 485683897, true);
});
$c_Lsttp_tapir_EndpointOutput$FixedStatusCode.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_EndpointOutput$FixedStatusCode)) {
    if ((this.Lsttp_tapir_EndpointOutput$FixedStatusCode__f_statusCode === x$0.Lsttp_tapir_EndpointOutput$FixedStatusCode__f_statusCode)) {
      var x = this.Lsttp_tapir_EndpointOutput$FixedStatusCode__f_codec;
      var x$2 = x$0.Lsttp_tapir_EndpointOutput$FixedStatusCode__f_codec;
      var $x_1 = (x === x$2);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.Lsttp_tapir_EndpointOutput$FixedStatusCode__f_info;
      var x$4 = x$0.Lsttp_tapir_EndpointOutput$FixedStatusCode__f_info;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_EndpointOutput$FixedStatusCode.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_EndpointOutput$FixedStatusCode.prototype.productArity__I = (function() {
  return 3;
});
$c_Lsttp_tapir_EndpointOutput$FixedStatusCode.prototype.productPrefix__T = (function() {
  return "FixedStatusCode";
});
$c_Lsttp_tapir_EndpointOutput$FixedStatusCode.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return new $c_Lsttp_model_StatusCode(this.Lsttp_tapir_EndpointOutput$FixedStatusCode__f_statusCode);
      break;
    }
    case 1: {
      return this.Lsttp_tapir_EndpointOutput$FixedStatusCode__f_codec;
      break;
    }
    case 2: {
      return this.Lsttp_tapir_EndpointOutput$FixedStatusCode__f_info;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_EndpointOutput$FixedStatusCode.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "statusCode";
      break;
    }
    case 1: {
      return "codec";
      break;
    }
    case 2: {
      return "info";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_EndpointOutput$FixedStatusCode.prototype.codec__Lsttp_tapir_Codec = (function() {
  return this.Lsttp_tapir_EndpointOutput$FixedStatusCode__f_codec;
});
$c_Lsttp_tapir_EndpointOutput$FixedStatusCode.prototype.info__Lsttp_tapir_EndpointIO$Info = (function() {
  return this.Lsttp_tapir_EndpointOutput$FixedStatusCode__f_info;
});
$c_Lsttp_tapir_EndpointOutput$FixedStatusCode.prototype.copyWith__Lsttp_tapir_Codec__Lsttp_tapir_EndpointIO$Info__Lsttp_tapir_EndpointTransput = (function(c, i) {
  var statusCode = this.Lsttp_tapir_EndpointOutput$FixedStatusCode__f_statusCode;
  return new $c_Lsttp_tapir_EndpointOutput$FixedStatusCode(statusCode, c, i);
});
function $isArrayOf_Lsttp_tapir_EndpointOutput$FixedStatusCode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointOutput$FixedStatusCode)));
}
export { $isArrayOf_Lsttp_tapir_EndpointOutput$FixedStatusCode as $isArrayOf_Lsttp_tapir_EndpointOutput$FixedStatusCode };
var $d_Lsttp_tapir_EndpointOutput$FixedStatusCode = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_EndpointOutput$FixedStatusCode, "sttp.tapir.EndpointOutput$FixedStatusCode", ({
  Lsttp_tapir_EndpointOutput$FixedStatusCode: 1,
  Lsttp_tapir_macros_EndpointTransputMacros: 1,
  Lsttp_tapir_EndpointTransput: 1,
  Lsttp_tapir_EndpointOutput: 1,
  Lsttp_tapir_EndpointOutput$Single: 1,
  Lsttp_tapir_EndpointTransput$Basic: 1,
  Lsttp_tapir_EndpointOutput$Basic: 1,
  Lsttp_tapir_EndpointTransput$Atom: 1,
  Lsttp_tapir_EndpointOutput$Atom: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_EndpointOutput$FixedStatusCode as $d_Lsttp_tapir_EndpointOutput$FixedStatusCode };
function $isArrayOf_Lsttp_tapir_EndpointOutput$StatusCode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointOutput$StatusCode)));
}
export { $isArrayOf_Lsttp_tapir_EndpointOutput$StatusCode as $isArrayOf_Lsttp_tapir_EndpointOutput$StatusCode };
/** @constructor */
function $c_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper(wrapped) {
  this.Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper__f_wrapped = null;
  this.Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper__f_wrapped = wrapped;
}
export { $c_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper as $c_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper };
$c_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper.prototype.constructor = $c_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper;
/** @constructor */
function $h_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper() {
}
export { $h_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper as $h_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper };
$h_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper.prototype = $c_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper.prototype;
$c_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper.prototype.and__Lsttp_tapir_EndpointOutput__Lsttp_tapir_typelevel_ParamConcat__Lsttp_tapir_EndpointOutput = (function(other, concat) {
  return $f_Lsttp_tapir_EndpointOutput__and__Lsttp_tapir_EndpointOutput__Lsttp_tapir_typelevel_ParamConcat__Lsttp_tapir_EndpointOutput(this, other, concat);
});
$c_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper.prototype.map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput = (function(mapping) {
  return $f_Lsttp_tapir_EndpointTransput$Atom__map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput(this, mapping);
});
$c_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-132773080), true);
});
$c_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper)) {
    var x = this.Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper__f_wrapped;
    var x$2 = x$0.Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper__f_wrapped;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper.prototype.productPrefix__T = (function() {
  return "WebSocketBodyWrapper";
});
$c_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper__f_wrapped;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "wrapped";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper.prototype.copyWith__Lsttp_tapir_Codec__Lsttp_tapir_EndpointIO$Info__Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper = (function(c, i) {
  var this$1 = this.Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper__f_wrapped;
  var streams = this$1.Lsttp_tapir_WebSocketBodyOutput__f_streams;
  var requests = this$1.Lsttp_tapir_WebSocketBodyOutput__f_requests;
  var responses = this$1.Lsttp_tapir_WebSocketBodyOutput__f_responses;
  var requestsInfo = this$1.Lsttp_tapir_WebSocketBodyOutput__f_requestsInfo;
  var responsesInfo = this$1.Lsttp_tapir_WebSocketBodyOutput__f_responsesInfo;
  var concatenateFragmentedFrames = this$1.Lsttp_tapir_WebSocketBodyOutput__f_concatenateFragmentedFrames;
  var ignorePong = this$1.Lsttp_tapir_WebSocketBodyOutput__f_ignorePong;
  var autoPongOnPing = this$1.Lsttp_tapir_WebSocketBodyOutput__f_autoPongOnPing;
  var decodeCloseRequests = this$1.Lsttp_tapir_WebSocketBodyOutput__f_decodeCloseRequests;
  var decodeCloseResponses = this$1.Lsttp_tapir_WebSocketBodyOutput__f_decodeCloseResponses;
  var autoPing = this$1.Lsttp_tapir_WebSocketBodyOutput__f_autoPing;
  var wrapped = new $c_Lsttp_tapir_WebSocketBodyOutput(streams, requests, responses, c, i, requestsInfo, responsesInfo, concatenateFragmentedFrames, ignorePong, autoPongOnPing, decodeCloseRequests, decodeCloseResponses, autoPing);
  return new $c_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper(wrapped);
});
$c_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper.prototype.codec__Lsttp_tapir_Codec = (function() {
  return this.Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper__f_wrapped.Lsttp_tapir_WebSocketBodyOutput__f_codec;
});
$c_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper.prototype.info__Lsttp_tapir_EndpointIO$Info = (function() {
  return this.Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper__f_wrapped.Lsttp_tapir_WebSocketBodyOutput__f_info;
});
$c_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper.prototype.copyWith__Lsttp_tapir_Codec__Lsttp_tapir_EndpointIO$Info__Lsttp_tapir_EndpointTransput = (function(c, i) {
  return this.copyWith__Lsttp_tapir_Codec__Lsttp_tapir_EndpointIO$Info__Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper(c, i);
});
function $isArrayOf_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper)));
}
export { $isArrayOf_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper as $isArrayOf_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper };
var $d_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper, "sttp.tapir.EndpointOutput$WebSocketBodyWrapper", ({
  Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper: 1,
  Lsttp_tapir_macros_EndpointTransputMacros: 1,
  Lsttp_tapir_EndpointTransput: 1,
  Lsttp_tapir_EndpointOutput: 1,
  Lsttp_tapir_EndpointOutput$Single: 1,
  Lsttp_tapir_EndpointTransput$Basic: 1,
  Lsttp_tapir_EndpointOutput$Basic: 1,
  Lsttp_tapir_EndpointTransput$Atom: 1,
  Lsttp_tapir_EndpointOutput$Atom: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper as $d_Lsttp_tapir_EndpointOutput$WebSocketBodyWrapper };
/** @constructor */
function $c_Lcats_data_NonEmptyMapInstances$$anon$1() {
}
export { $c_Lcats_data_NonEmptyMapInstances$$anon$1 as $c_Lcats_data_NonEmptyMapInstances$$anon$1 };
$c_Lcats_data_NonEmptyMapInstances$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_data_NonEmptyMapInstances$$anon$1.prototype.constructor = $c_Lcats_data_NonEmptyMapInstances$$anon$1;
/** @constructor */
function $h_Lcats_data_NonEmptyMapInstances$$anon$1() {
}
export { $h_Lcats_data_NonEmptyMapInstances$$anon$1 as $h_Lcats_data_NonEmptyMapInstances$$anon$1 };
$h_Lcats_data_NonEmptyMapInstances$$anon$1.prototype = $c_Lcats_data_NonEmptyMapInstances$$anon$1.prototype;
$c_Lcats_data_NonEmptyMapInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_SemigroupK$$anon$1(this);
});
$c_Lcats_data_NonEmptyMapInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return this.map__O__F1__O(fa, f);
});
$c_Lcats_data_NonEmptyMapInstances$$anon$1.prototype.void__O__O = (function(fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_data_NonEmptyMapInstances$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_data_NonEmptyMapInstances$$anon$1.prototype.toIterable__O__sc_Iterable = (function(fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_compat_FoldableCompat$().toIterable__O__Lcats_Foldable__sc_Iterable(fa, this);
});
$c_Lcats_data_NonEmptyMapInstances$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Foldable__foldM__O__O__F2__Lcats_Monad__O(this, fa, z, f, G);
});
$c_Lcats_data_NonEmptyMapInstances$$anon$1.prototype.traverseVoid__O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Foldable__traverseVoid__O__F1__Lcats_Applicative__O(this, fa, f, G);
});
$c_Lcats_data_NonEmptyMapInstances$$anon$1.prototype.toList__O__sci_List = (function(fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Foldable__toList__O__sci_List(this, fa);
});
$c_Lcats_data_NonEmptyMapInstances$$anon$1.prototype.unorderedFoldMap__O__F1__Lcats_kernel_CommutativeMonoid__O = (function(fa, f, evidence$1) {
  return this.foldMap__O__F1__Lcats_kernel_Monoid__O(fa, f, evidence$1);
});
$c_Lcats_data_NonEmptyMapInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.nonEmptyTraverse__O__F1__Lcats_Apply__O(fa, f, evidence$1);
});
$c_Lcats_data_NonEmptyMapInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  return new $c_Lcats_data_NonEmptyMapOps(fa).map__F1__O(f);
});
$c_Lcats_data_NonEmptyMapInstances$$anon$1.prototype.combineK__O__O__O = (function(a, b) {
  var this$2 = new $c_Lcats_data_NonEmptyMapOps(a);
  return this$2.concat__O__O(b);
});
$c_Lcats_data_NonEmptyMapInstances$$anon$1.prototype.size__O__J = (function(fa) {
  var this$2 = new $c_Lcats_data_NonEmptyMapOps(fa);
  var m = this$2.Lcats_data_NonEmptyMapOps__f_value;
  var value = $m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(m.sci_TreeMap__f_tree);
  var hi = (value >> 31);
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(value, hi);
});
$c_Lcats_data_NonEmptyMapInstances$$anon$1.prototype.nonEmptyTraverse__O__F1__Lcats_Apply__O = (function(fa, f, G) {
  return new $c_Lcats_data_NonEmptyMapOps(fa).nonEmptyTraverse__F1__Lcats_Apply__O(f, G);
});
$c_Lcats_data_NonEmptyMapInstances$$anon$1.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  return new $c_Lcats_data_NonEmptyMapOps(fa).foldLeft__O__F2__O(b, f);
});
$c_Lcats_data_NonEmptyMapInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return new $c_Lcats_data_NonEmptyMapOps(fa).foldRight__Lcats_Eval__F2__Lcats_Eval(lb, f);
});
$c_Lcats_data_NonEmptyMapInstances$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return new $c_Lcats_data_NonEmptyMapOps(fa).foldLeft__O__F2__O(B.empty__O(), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((b, a) => B.combine__O__O__O(b, f.apply__O__O(a)))));
});
$c_Lcats_data_NonEmptyMapInstances$$anon$1.prototype.exists__O__F1__Z = (function(fa, p) {
  return new $c_Lcats_data_NonEmptyMapOps(fa).exists__F1__Z(p);
});
var $d_Lcats_data_NonEmptyMapInstances$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_data_NonEmptyMapInstances$$anon$1, "cats.data.NonEmptyMapInstances$$anon$1", ({
  Lcats_data_NonEmptyMapInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_SemigroupK: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Reducible: 1,
  Lcats_NonEmptyTraverse: 1,
  Lcats_Align: 1
}));
export { $d_Lcats_data_NonEmptyMapInstances$$anon$1 as $d_Lcats_data_NonEmptyMapInstances$$anon$1 };
/** @constructor */
function $c_Lcom_raquo_airstream_combine_CombineSignalN(parents, combinator) {
  this.Lcom_raquo_airstream_combine_CombineSignalN__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_combine_CombineSignalN__f_isSafeToRemoveObserver = false;
  this.Lcom_raquo_airstream_combine_CombineSignalN__f_maybePendingObserverRemovals = null;
  this.Lcom_raquo_airstream_combine_CombineSignalN__f__lastUpdateId = 0;
  this.Lcom_raquo_airstream_combine_CombineSignalN__f_externalObservers = null;
  this.Lcom_raquo_airstream_combine_CombineSignalN__f_internalObservers = null;
  this.Lcom_raquo_airstream_combine_CombineSignalN__f_willStartDone = false;
  this.Lcom_raquo_airstream_combine_CombineSignalN__f_maybeLastSeenCurrentValue = null;
  this.Lcom_raquo_airstream_combine_CombineSignalN__f__parentLastUpdateIds$lzy1 = null;
  this.Lcom_raquo_airstream_combine_CombineSignalN__f__parentLastUpdateIdsbitmap$1 = false;
  this.Lcom_raquo_airstream_combine_CombineSignalN__f_parents = null;
  this.Lcom_raquo_airstream_combine_CombineSignalN__f_combinator = null;
  this.Lcom_raquo_airstream_combine_CombineSignalN__f_topoRank = 0;
  this.Lcom_raquo_airstream_combine_CombineSignalN__f_parentObservers = null;
  this.Lcom_raquo_airstream_combine_CombineSignalN__f_parents = parents;
  this.Lcom_raquo_airstream_combine_CombineSignalN__f_combinator = combinator;
  this.Lcom_raquo_airstream_combine_CombineSignalN__f_maybeDisplayName = (void 0);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  this.Lcom_raquo_airstream_combine_CombineSignalN__f__lastUpdateId = 0;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.Lcom_raquo_airstream_combine_CombineSignalN__f_maybeLastSeenCurrentValue = (void 0);
  this.Lcom_raquo_airstream_combine_CombineSignalN__f_topoRank = ((1 + $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_Protected$().maxTopoRank__I__Lcom_raquo_ew_JsArray__I(0, parents)) | 0);
  this.Lcom_raquo_airstream_combine_CombineSignalN__f_parentObservers = parents.map(((parent) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_common_InternalParentObserver$().fromTry__Lcom_raquo_airstream_core_Observable__F2__Lcom_raquo_airstream_common_InternalParentObserver(parent, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((_$1, trx) => {
    $f_Lcom_raquo_airstream_combine_CombineObservable__onInputsReady__Lcom_raquo_airstream_core_Transaction__V(this, trx);
  })))));
}
export { $c_Lcom_raquo_airstream_combine_CombineSignalN as $c_Lcom_raquo_airstream_combine_CombineSignalN };
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.constructor = $c_Lcom_raquo_airstream_combine_CombineSignalN;
/** @constructor */
function $h_Lcom_raquo_airstream_combine_CombineSignalN() {
}
export { $h_Lcom_raquo_airstream_combine_CombineSignalN as $h_Lcom_raquo_airstream_combine_CombineSignalN };
$h_Lcom_raquo_airstream_combine_CombineSignalN.prototype = $c_Lcom_raquo_airstream_combine_CombineSignalN.prototype;
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_combine_CombineSignalN__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_combine_CombineSignalN__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.defaultDisplayName__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.isSafeToRemoveObserver__Z = (function() {
  return this.Lcom_raquo_airstream_combine_CombineSignalN__f_isSafeToRemoveObserver;
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.maybePendingObserverRemovals__O = (function() {
  return this.Lcom_raquo_airstream_combine_CombineSignalN__f_maybePendingObserverRemovals;
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.isSafeToRemoveObserver_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_combine_CombineSignalN__f_isSafeToRemoveObserver = x$1;
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.maybePendingObserverRemovals_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_combine_CombineSignalN__f_maybePendingObserverRemovals = x$1;
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.equals__O__Z = (function(obj) {
  return (this === obj);
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$systemIdentityHashCode(this);
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype._lastUpdateId__I = (function() {
  return this.Lcom_raquo_airstream_combine_CombineSignalN__f__lastUpdateId;
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype._lastUpdateId_$eq__I__V = (function(x$1) {
  this.Lcom_raquo_airstream_combine_CombineSignalN__f__lastUpdateId = x$1;
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.toObservable__Lcom_raquo_airstream_core_Signal = (function() {
  return this;
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.onAddedExternalObserver__Lcom_raquo_airstream_core_Observer__V = (function(observer) {
  observer.onTry__s_util_Try__V($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this));
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.externalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_combine_CombineSignalN__f_externalObservers;
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.internalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_combine_CombineSignalN__f_internalObservers;
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.willStartDone__Z = (function() {
  return this.Lcom_raquo_airstream_combine_CombineSignalN__f_willStartDone;
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.willStartDone_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_combine_CombineSignalN__f_willStartDone = x$1;
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.com$raquo$airstream$core$WritableObservable$_setter_$externalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_combine_CombineSignalN__f_externalObservers = x$0;
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.com$raquo$airstream$core$WritableObservable$_setter_$internalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_combine_CombineSignalN__f_internalObservers = x$0;
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.maybeLastSeenCurrentValue__O = (function() {
  return this.Lcom_raquo_airstream_combine_CombineSignalN__f_maybeLastSeenCurrentValue;
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.maybeLastSeenCurrentValue_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_combine_CombineSignalN__f_maybeLastSeenCurrentValue = x$1;
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.tryNow__s_util_Try = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype._parentLastUpdateIds__Lcom_raquo_ew_JsArray = (function() {
  if ((!this.Lcom_raquo_airstream_combine_CombineSignalN__f__parentLastUpdateIdsbitmap$1)) {
    this.Lcom_raquo_airstream_combine_CombineSignalN__f__parentLastUpdateIds$lzy1 = $f_Lcom_raquo_airstream_common_MultiParentSignal___parentLastUpdateIds__Lcom_raquo_ew_JsArray(this);
    this.Lcom_raquo_airstream_combine_CombineSignalN__f__parentLastUpdateIdsbitmap$1 = true;
  }
  return this.Lcom_raquo_airstream_combine_CombineSignalN__f__parentLastUpdateIds$lzy1;
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.onWillStart__V = (function() {
  $f_Lcom_raquo_airstream_common_MultiParentSignal__onWillStart__V(this);
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.syncFire__Lcom_raquo_airstream_core_Transaction__V = (function(transaction) {
  $f_Lcom_raquo_airstream_combine_CombineObservable__syncFire__Lcom_raquo_airstream_core_Transaction__V(this, transaction);
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.onStart__V = (function() {
  $f_Lcom_raquo_airstream_combine_CombineObservable__onStart__V(this);
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.onStop__V = (function() {
  $f_Lcom_raquo_airstream_combine_CombineObservable__onStop__V(this);
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.com$raquo$airstream$combine$CombineObservable$$super$onStart__V = (function() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_Signal__onStart__V(this);
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.topoRank__I = (function() {
  return this.Lcom_raquo_airstream_combine_CombineSignalN__f_topoRank;
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.parentObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_combine_CombineSignalN__f_parentObservers;
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.inputsReady__Z = (function() {
  return true;
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.combinedValue__s_util_Try = (function() {
  return $m_Lcom_raquo_airstream_combine_CombineObservable$().jsArrayCombinator__Lcom_raquo_ew_JsArray__F1__s_util_Try(this.Lcom_raquo_airstream_combine_CombineSignalN__f_parents.map(((_$2) => _$2.tryNow__s_util_Try())), this.Lcom_raquo_airstream_combine_CombineSignalN__f_combinator);
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.currentValueFromParent__s_util_Try = (function() {
  return this.combinedValue__s_util_Try();
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.map__F1__Lcom_raquo_airstream_core_Observable = (function(project) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), this, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.distinctTry__F2__Lcom_raquo_airstream_core_Observable = (function(isSame) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_distinct_DistinctSignal(this, isSame, false);
});
$c_Lcom_raquo_airstream_combine_CombineSignalN.prototype.toObservable__Lcom_raquo_airstream_core_Observable = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_combine_CombineSignalN = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_combine_CombineSignalN, "com.raquo.airstream.combine.CombineSignalN", ({
  Lcom_raquo_airstream_combine_CombineSignalN: 1,
  Lcom_raquo_airstream_core_Source: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_BaseObservable: 1,
  Lcom_raquo_airstream_core_Observable: 1,
  Lcom_raquo_airstream_core_Source$SignalSource: 1,
  Lcom_raquo_airstream_dynamicImport_SignalDynamicImportOps: 1,
  Lcom_raquo_airstream_core_Signal: 1,
  Lcom_raquo_airstream_core_WritableObservable: 1,
  Lcom_raquo_airstream_core_WritableSignal: 1,
  Lcom_raquo_airstream_common_MultiParentSignal: 1,
  Lcom_raquo_airstream_core_SyncObservable: 1,
  Lcom_raquo_airstream_combine_CombineObservable: 1
}));
export { $d_Lcom_raquo_airstream_combine_CombineSignalN as $d_Lcom_raquo_airstream_combine_CombineSignalN };
/** @constructor */
function $c_Lcom_raquo_airstream_combine_SampleCombineStreamN(samplingStream, sampledSignals, combinator) {
  this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_isSafeToRemoveObserver = false;
  this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_maybePendingObserverRemovals = null;
  this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_externalObservers = null;
  this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_internalObservers = null;
  this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_willStartDone = false;
  this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_sampledSignals = null;
  this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_combinator = null;
  this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_topoRank = 0;
  this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_maybeLastSamplingValue = null;
  this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_parents = null;
  this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_parentObservers = null;
  this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_sampledSignals = sampledSignals;
  this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_combinator = combinator;
  this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_maybeDisplayName = (void 0);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_topoRank = ((1 + $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_Protected$().maxTopoRank__Lcom_raquo_airstream_core_Observable__Lcom_raquo_ew_JsArray__I(samplingStream, sampledSignals)) | 0);
  this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_maybeLastSamplingValue = (void 0);
  var arr = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_airstream_core_Observable.getArrayOf().constr)([samplingStream])));
  var i = 0;
  var len = (sampledSignals.length | 0);
  while ((i < len)) {
    var sampledSignal = sampledSignals[i];
    (arr.push(sampledSignal) | 0);
    i = ((1 + i) | 0);
  }
  this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_parents = arr;
  var arr$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcom_raquo_airstream_common_InternalParentObserver.getArrayOf().constr)([$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_common_InternalParentObserver$().fromTry__Lcom_raquo_airstream_core_Observable__F2__Lcom_raquo_airstream_common_InternalParentObserver(samplingStream, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((nextSamplingValue, trx) => {
    this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_maybeLastSamplingValue = nextSamplingValue;
    $f_Lcom_raquo_airstream_combine_CombineObservable__onInputsReady__Lcom_raquo_airstream_core_Transaction__V(this, trx);
  })))])));
  var i$1 = 0;
  var len$1 = (sampledSignals.length | 0);
  while ((i$1 < len$1)) {
    var sampledSignal$2 = sampledSignals[i$1];
    (arr$3.push($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_common_InternalParentObserver$().fromTry__Lcom_raquo_airstream_core_Observable__F2__Lcom_raquo_airstream_common_InternalParentObserver(sampledSignal$2, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((_$1, _$2) => (void 0))))) | 0);
    i$1 = ((1 + i$1) | 0);
  }
  this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_parentObservers = arr$3;
}
export { $c_Lcom_raquo_airstream_combine_SampleCombineStreamN as $c_Lcom_raquo_airstream_combine_SampleCombineStreamN };
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.constructor = $c_Lcom_raquo_airstream_combine_SampleCombineStreamN;
/** @constructor */
function $h_Lcom_raquo_airstream_combine_SampleCombineStreamN() {
}
export { $h_Lcom_raquo_airstream_combine_SampleCombineStreamN as $h_Lcom_raquo_airstream_combine_SampleCombineStreamN };
$h_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype = $c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype;
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.defaultDisplayName__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.isSafeToRemoveObserver__Z = (function() {
  return this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_isSafeToRemoveObserver;
});
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.maybePendingObserverRemovals__O = (function() {
  return this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_maybePendingObserverRemovals;
});
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.isSafeToRemoveObserver_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_isSafeToRemoveObserver = x$1;
});
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.maybePendingObserverRemovals_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_maybePendingObserverRemovals = x$1;
});
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.equals__O__Z = (function(obj) {
  return (this === obj);
});
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$systemIdentityHashCode(this);
});
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.onAddedExternalObserver__Lcom_raquo_airstream_core_Observer__V = (function(observer) {
});
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.toObservable__Lcom_raquo_airstream_core_EventStream = (function() {
  return this;
});
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.externalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_externalObservers;
});
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.internalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_internalObservers;
});
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.willStartDone__Z = (function() {
  return this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_willStartDone;
});
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.willStartDone_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_willStartDone = x$1;
});
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.com$raquo$airstream$core$WritableObservable$_setter_$externalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_externalObservers = x$0;
});
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.com$raquo$airstream$core$WritableObservable$_setter_$internalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_internalObservers = x$0;
});
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.fireValue__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.onWillStart__V = (function() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_MultiParentStream__onWillStart__V(this);
});
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.onStart__V = (function() {
  $f_Lcom_raquo_airstream_combine_CombineObservable__onStart__V(this);
});
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.onStop__V = (function() {
  $f_Lcom_raquo_airstream_combine_CombineObservable__onStop__V(this);
});
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.com$raquo$airstream$combine$CombineObservable$$super$onStart__V = (function() {
});
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.topoRank__I = (function() {
  return this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_topoRank;
});
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.inputsReady__Z = (function() {
  var x = this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_maybeLastSamplingValue;
  return (x !== (void 0));
});
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.parents__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_parents;
});
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.parentObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_parentObservers;
});
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.combinedValue__s_util_Try = (function() {
  var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_ew_JsArray$();
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
  var x = this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_maybeLastSamplingValue;
  if ((x === (void 0))) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_ju_NoSuchElementException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_ju_NoSuchElementException(), "undefined.get");
  }
  var values = $x_2.apply__sci_Seq__Lcom_raquo_ew_JsArray($x_1.wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_s_util_Try.getArrayOf().constr)([x])));
  var arr = this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_sampledSignals;
  var i = 0;
  var len = (arr.length | 0);
  while ((i < len)) {
    var sampledSignal = arr[i];
    (values.push(sampledSignal.tryNow__s_util_Try()) | 0);
    i = ((1 + i) | 0);
  }
  return $m_Lcom_raquo_airstream_combine_CombineObservable$().jsArrayCombinator__Lcom_raquo_ew_JsArray__F1__s_util_Try(values, this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_combinator);
});
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.syncFire__Lcom_raquo_airstream_core_Transaction__V = (function(transaction) {
  $f_Lcom_raquo_airstream_combine_CombineObservable__syncFire__Lcom_raquo_airstream_core_Transaction__V(this, transaction);
  this.Lcom_raquo_airstream_combine_SampleCombineStreamN__f_maybeLastSamplingValue = (void 0);
});
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.map__F1__Lcom_raquo_airstream_core_Observable = (function(project) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapStream(this, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.distinctTry__F2__Lcom_raquo_airstream_core_Observable = (function(isSame) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype.toObservable__Lcom_raquo_airstream_core_Observable = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_combine_SampleCombineStreamN = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_combine_SampleCombineStreamN, "com.raquo.airstream.combine.SampleCombineStreamN", ({
  Lcom_raquo_airstream_combine_SampleCombineStreamN: 1,
  Lcom_raquo_airstream_core_Source: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_BaseObservable: 1,
  Lcom_raquo_airstream_core_Observable: 1,
  Lcom_raquo_airstream_core_Source$EventSource: 1,
  Lcom_raquo_airstream_dynamicImport_StreamDynamicImportOps: 1,
  Lcom_raquo_airstream_core_EventStream: 1,
  Lcom_raquo_airstream_core_WritableObservable: 1,
  Lcom_raquo_airstream_core_WritableStream: 1,
  Lcom_raquo_airstream_common_MultiParentStream: 1,
  Lcom_raquo_airstream_core_SyncObservable: 1,
  Lcom_raquo_airstream_combine_CombineObservable: 1
}));
export { $d_Lcom_raquo_airstream_combine_SampleCombineStreamN as $d_Lcom_raquo_airstream_combine_SampleCombineStreamN };
/** @constructor */
function $c_Lcom_raquo_airstream_misc_CollectStream(parent, fn) {
  this.Lcom_raquo_airstream_misc_CollectStream__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_misc_CollectStream__f_isSafeToRemoveObserver = false;
  this.Lcom_raquo_airstream_misc_CollectStream__f_maybePendingObserverRemovals = null;
  this.Lcom_raquo_airstream_misc_CollectStream__f_externalObservers = null;
  this.Lcom_raquo_airstream_misc_CollectStream__f_internalObservers = null;
  this.Lcom_raquo_airstream_misc_CollectStream__f_willStartDone = false;
  this.Lcom_raquo_airstream_misc_CollectStream__f_parent = null;
  this.Lcom_raquo_airstream_misc_CollectStream__f_fn = null;
  this.Lcom_raquo_airstream_misc_CollectStream__f_topoRank = 0;
  this.Lcom_raquo_airstream_misc_CollectStream__f_parent = parent;
  this.Lcom_raquo_airstream_misc_CollectStream__f_fn = fn;
  this.Lcom_raquo_airstream_misc_CollectStream__f_maybeDisplayName = (void 0);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.Lcom_raquo_airstream_misc_CollectStream__f_topoRank = ((1 + parent.topoRank__I()) | 0);
}
export { $c_Lcom_raquo_airstream_misc_CollectStream as $c_Lcom_raquo_airstream_misc_CollectStream };
$c_Lcom_raquo_airstream_misc_CollectStream.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_misc_CollectStream.prototype.constructor = $c_Lcom_raquo_airstream_misc_CollectStream;
/** @constructor */
function $h_Lcom_raquo_airstream_misc_CollectStream() {
}
export { $h_Lcom_raquo_airstream_misc_CollectStream as $h_Lcom_raquo_airstream_misc_CollectStream };
$h_Lcom_raquo_airstream_misc_CollectStream.prototype = $c_Lcom_raquo_airstream_misc_CollectStream.prototype;
$c_Lcom_raquo_airstream_misc_CollectStream.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_misc_CollectStream__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_misc_CollectStream.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_misc_CollectStream__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_misc_CollectStream.prototype.defaultDisplayName__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_airstream_misc_CollectStream.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_misc_CollectStream.prototype.isSafeToRemoveObserver__Z = (function() {
  return this.Lcom_raquo_airstream_misc_CollectStream__f_isSafeToRemoveObserver;
});
$c_Lcom_raquo_airstream_misc_CollectStream.prototype.maybePendingObserverRemovals__O = (function() {
  return this.Lcom_raquo_airstream_misc_CollectStream__f_maybePendingObserverRemovals;
});
$c_Lcom_raquo_airstream_misc_CollectStream.prototype.isSafeToRemoveObserver_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_misc_CollectStream__f_isSafeToRemoveObserver = x$1;
});
$c_Lcom_raquo_airstream_misc_CollectStream.prototype.maybePendingObserverRemovals_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_misc_CollectStream__f_maybePendingObserverRemovals = x$1;
});
$c_Lcom_raquo_airstream_misc_CollectStream.prototype.equals__O__Z = (function(obj) {
  return (this === obj);
});
$c_Lcom_raquo_airstream_misc_CollectStream.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$systemIdentityHashCode(this);
});
$c_Lcom_raquo_airstream_misc_CollectStream.prototype.onAddedExternalObserver__Lcom_raquo_airstream_core_Observer__V = (function(observer) {
});
$c_Lcom_raquo_airstream_misc_CollectStream.prototype.toObservable__Lcom_raquo_airstream_core_EventStream = (function() {
  return this;
});
$c_Lcom_raquo_airstream_misc_CollectStream.prototype.externalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_misc_CollectStream__f_externalObservers;
});
$c_Lcom_raquo_airstream_misc_CollectStream.prototype.internalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_misc_CollectStream__f_internalObservers;
});
$c_Lcom_raquo_airstream_misc_CollectStream.prototype.willStartDone__Z = (function() {
  return this.Lcom_raquo_airstream_misc_CollectStream__f_willStartDone;
});
$c_Lcom_raquo_airstream_misc_CollectStream.prototype.willStartDone_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_misc_CollectStream__f_willStartDone = x$1;
});
$c_Lcom_raquo_airstream_misc_CollectStream.prototype.com$raquo$airstream$core$WritableObservable$_setter_$externalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_misc_CollectStream__f_externalObservers = x$0;
});
$c_Lcom_raquo_airstream_misc_CollectStream.prototype.com$raquo$airstream$core$WritableObservable$_setter_$internalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_misc_CollectStream__f_internalObservers = x$0;
});
$c_Lcom_raquo_airstream_misc_CollectStream.prototype.fireValue__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_misc_CollectStream.prototype.fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$c_Lcom_raquo_airstream_misc_CollectStream.prototype.fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_misc_CollectStream.prototype.onWillStart__V = (function() {
  var observable = this.Lcom_raquo_airstream_misc_CollectStream__f_parent;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(observable);
});
$c_Lcom_raquo_airstream_misc_CollectStream.prototype.onStart__V = (function() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_SingleParentStream__onStart__V(this);
});
$c_Lcom_raquo_airstream_misc_CollectStream.prototype.onStop__V = (function() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_SingleParentStream__onStop__V(this);
});
$c_Lcom_raquo_airstream_misc_CollectStream.prototype.onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_InternalNextErrorObserver__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_misc_CollectStream.prototype.topoRank__I = (function() {
  return this.Lcom_raquo_airstream_misc_CollectStream__f_topoRank;
});
$c_Lcom_raquo_airstream_misc_CollectStream.prototype.onNext__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextParentValue, transaction) {
  try {
    var r1 = this.Lcom_raquo_airstream_misc_CollectStream__f_fn.apply__O__O(nextParentValue);
    var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(r1);
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Throwable) ? e : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException(e));
    matchEnd8: {
      var $x_1;
      if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure(e$2);
        break matchEnd8;
      }
      throw ((e$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  }
  $x_1.fold__F1__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, _$1, transaction);
  })), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((nextValue) => {
    if ((!nextValue.isEmpty__Z())) {
      var x0 = nextValue.get__O();
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, x0, transaction);
    }
  })));
});
$c_Lcom_raquo_airstream_misc_CollectStream.prototype.onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$c_Lcom_raquo_airstream_misc_CollectStream.prototype.parent__Lcom_raquo_airstream_core_Observable = (function() {
  return this.Lcom_raquo_airstream_misc_CollectStream__f_parent;
});
$c_Lcom_raquo_airstream_misc_CollectStream.prototype.map__F1__Lcom_raquo_airstream_core_Observable = (function(project) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapStream(this, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lcom_raquo_airstream_misc_CollectStream.prototype.distinctTry__F2__Lcom_raquo_airstream_core_Observable = (function(isSame) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$c_Lcom_raquo_airstream_misc_CollectStream.prototype.toObservable__Lcom_raquo_airstream_core_Observable = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_misc_CollectStream = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_misc_CollectStream, "com.raquo.airstream.misc.CollectStream", ({
  Lcom_raquo_airstream_misc_CollectStream: 1,
  Lcom_raquo_airstream_core_Source: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_BaseObservable: 1,
  Lcom_raquo_airstream_core_Observable: 1,
  Lcom_raquo_airstream_core_Source$EventSource: 1,
  Lcom_raquo_airstream_dynamicImport_StreamDynamicImportOps: 1,
  Lcom_raquo_airstream_core_EventStream: 1,
  Lcom_raquo_airstream_core_WritableObservable: 1,
  Lcom_raquo_airstream_core_WritableStream: 1,
  Lcom_raquo_airstream_core_InternalObserver: 1,
  Lcom_raquo_airstream_common_SingleParentStream: 1,
  Lcom_raquo_airstream_common_InternalNextErrorObserver: 1
}));
export { $d_Lcom_raquo_airstream_misc_CollectStream as $d_Lcom_raquo_airstream_misc_CollectStream };
/** @constructor */
function $c_Lcom_raquo_airstream_misc_StreamFromSignal(parent, changesOnly) {
  this.Lcom_raquo_airstream_misc_StreamFromSignal__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_misc_StreamFromSignal__f_isSafeToRemoveObserver = false;
  this.Lcom_raquo_airstream_misc_StreamFromSignal__f_maybePendingObserverRemovals = null;
  this.Lcom_raquo_airstream_misc_StreamFromSignal__f_externalObservers = null;
  this.Lcom_raquo_airstream_misc_StreamFromSignal__f_internalObservers = null;
  this.Lcom_raquo_airstream_misc_StreamFromSignal__f_willStartDone = false;
  this.Lcom_raquo_airstream_misc_StreamFromSignal__f_parent = null;
  this.Lcom_raquo_airstream_misc_StreamFromSignal__f_changesOnly = false;
  this.Lcom_raquo_airstream_misc_StreamFromSignal__f_topoRank = 0;
  this.Lcom_raquo_airstream_misc_StreamFromSignal__f_lastSeenParentUpdateId = 0;
  this.Lcom_raquo_airstream_misc_StreamFromSignal__f_isFirstPull = false;
  this.Lcom_raquo_airstream_misc_StreamFromSignal__f_parent = parent;
  this.Lcom_raquo_airstream_misc_StreamFromSignal__f_changesOnly = changesOnly;
  this.Lcom_raquo_airstream_misc_StreamFromSignal__f_maybeDisplayName = (void 0);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.Lcom_raquo_airstream_misc_StreamFromSignal__f_topoRank = ((1 + parent.topoRank__I()) | 0);
  this.Lcom_raquo_airstream_misc_StreamFromSignal__f_lastSeenParentUpdateId = 0;
  this.Lcom_raquo_airstream_misc_StreamFromSignal__f_isFirstPull = true;
}
export { $c_Lcom_raquo_airstream_misc_StreamFromSignal as $c_Lcom_raquo_airstream_misc_StreamFromSignal };
$c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype.constructor = $c_Lcom_raquo_airstream_misc_StreamFromSignal;
/** @constructor */
function $h_Lcom_raquo_airstream_misc_StreamFromSignal() {
}
export { $h_Lcom_raquo_airstream_misc_StreamFromSignal as $h_Lcom_raquo_airstream_misc_StreamFromSignal };
$h_Lcom_raquo_airstream_misc_StreamFromSignal.prototype = $c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype;
$c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_misc_StreamFromSignal__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_misc_StreamFromSignal__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype.defaultDisplayName__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype.isSafeToRemoveObserver__Z = (function() {
  return this.Lcom_raquo_airstream_misc_StreamFromSignal__f_isSafeToRemoveObserver;
});
$c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype.maybePendingObserverRemovals__O = (function() {
  return this.Lcom_raquo_airstream_misc_StreamFromSignal__f_maybePendingObserverRemovals;
});
$c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype.isSafeToRemoveObserver_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_misc_StreamFromSignal__f_isSafeToRemoveObserver = x$1;
});
$c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype.maybePendingObserverRemovals_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_misc_StreamFromSignal__f_maybePendingObserverRemovals = x$1;
});
$c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype.equals__O__Z = (function(obj) {
  return (this === obj);
});
$c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$systemIdentityHashCode(this);
});
$c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype.onAddedExternalObserver__Lcom_raquo_airstream_core_Observer__V = (function(observer) {
});
$c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype.toObservable__Lcom_raquo_airstream_core_EventStream = (function() {
  return this;
});
$c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype.externalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_misc_StreamFromSignal__f_externalObservers;
});
$c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype.internalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_misc_StreamFromSignal__f_internalObservers;
});
$c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype.willStartDone__Z = (function() {
  return this.Lcom_raquo_airstream_misc_StreamFromSignal__f_willStartDone;
});
$c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype.willStartDone_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_misc_StreamFromSignal__f_willStartDone = x$1;
});
$c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype.com$raquo$airstream$core$WritableObservable$_setter_$externalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_misc_StreamFromSignal__f_externalObservers = x$0;
});
$c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype.com$raquo$airstream$core$WritableObservable$_setter_$internalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_misc_StreamFromSignal__f_internalObservers = x$0;
});
$c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype.fireValue__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype.fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype.fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype.onWillStart__V = (function() {
  var observable = this.Lcom_raquo_airstream_misc_StreamFromSignal__f_parent;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(observable);
});
$c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype.onStop__V = (function() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_SingleParentStream__onStop__V(this);
});
$c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype.onNext__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype.onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype.topoRank__I = (function() {
  return this.Lcom_raquo_airstream_misc_StreamFromSignal__f_topoRank;
});
$c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype.onStart__V = (function() {
  var signal = this.Lcom_raquo_airstream_misc_StreamFromSignal__f_parent;
  var newParentLastUpdateId = signal._lastUpdateId__I();
  if ((this.Lcom_raquo_airstream_misc_StreamFromSignal__f_isFirstPull && this.Lcom_raquo_airstream_misc_StreamFromSignal__f_changesOnly)) {
    this.Lcom_raquo_airstream_misc_StreamFromSignal__f_lastSeenParentUpdateId = newParentLastUpdateId;
  } else if ((newParentLastUpdateId !== this.Lcom_raquo_airstream_misc_StreamFromSignal__f_lastSeenParentUpdateId)) {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_Transaction$onStart$().add__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((trx) => {
      if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z(this)) {
        var nextValue = this.Lcom_raquo_airstream_misc_StreamFromSignal__f_parent.tryNow__s_util_Try();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, trx);
        var signal$1 = this.Lcom_raquo_airstream_misc_StreamFromSignal__f_parent;
        this.Lcom_raquo_airstream_misc_StreamFromSignal__f_lastSeenParentUpdateId = signal$1._lastUpdateId__I();
      }
    })));
  }
  this.Lcom_raquo_airstream_misc_StreamFromSignal__f_isFirstPull = false;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_SingleParentStream__onStart__V(this);
});
$c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype.onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
  var signal = this.Lcom_raquo_airstream_misc_StreamFromSignal__f_parent;
  this.Lcom_raquo_airstream_misc_StreamFromSignal__f_lastSeenParentUpdateId = signal._lastUpdateId__I();
  this.Lcom_raquo_airstream_misc_StreamFromSignal__f_isFirstPull = false;
});
$c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype.parent__Lcom_raquo_airstream_core_Observable = (function() {
  return this.Lcom_raquo_airstream_misc_StreamFromSignal__f_parent;
});
$c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype.map__F1__Lcom_raquo_airstream_core_Observable = (function(project) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapStream(this, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype.distinctTry__F2__Lcom_raquo_airstream_core_Observable = (function(isSame) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype.toObservable__Lcom_raquo_airstream_core_Observable = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_misc_StreamFromSignal = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_misc_StreamFromSignal, "com.raquo.airstream.misc.StreamFromSignal", ({
  Lcom_raquo_airstream_misc_StreamFromSignal: 1,
  Lcom_raquo_airstream_core_Source: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_BaseObservable: 1,
  Lcom_raquo_airstream_core_Observable: 1,
  Lcom_raquo_airstream_core_Source$EventSource: 1,
  Lcom_raquo_airstream_dynamicImport_StreamDynamicImportOps: 1,
  Lcom_raquo_airstream_core_EventStream: 1,
  Lcom_raquo_airstream_core_WritableObservable: 1,
  Lcom_raquo_airstream_core_WritableStream: 1,
  Lcom_raquo_airstream_core_InternalObserver: 1,
  Lcom_raquo_airstream_common_SingleParentStream: 1,
  Lcom_raquo_airstream_common_InternalTryObserver: 1
}));
export { $d_Lcom_raquo_airstream_misc_StreamFromSignal as $d_Lcom_raquo_airstream_misc_StreamFromSignal };
function $p_Lcom_raquo_airstream_split_SplitChildSignal__pullValueFromParent__s_Option($thiz) {
  var this$1 = $thiz.Lcom_raquo_airstream_split_SplitChildSignal__f_getMemoizedValue.apply__O();
  return (this$1.isEmpty__Z() ? $thiz.Lcom_raquo_airstream_split_SplitChildSignal__f_initialValue : this$1);
}
export { $p_Lcom_raquo_airstream_split_SplitChildSignal__pullValueFromParent__s_Option as $p_Lcom_raquo_airstream_split_SplitChildSignal__pullValueFromParent__s_Option };
/** @constructor */
function $c_Lcom_raquo_airstream_split_SplitChildSignal(parent, initialValue, getMemoizedValue) {
  this.Lcom_raquo_airstream_split_SplitChildSignal__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_split_SplitChildSignal__f_isSafeToRemoveObserver = false;
  this.Lcom_raquo_airstream_split_SplitChildSignal__f_maybePendingObserverRemovals = null;
  this.Lcom_raquo_airstream_split_SplitChildSignal__f__lastUpdateId = 0;
  this.Lcom_raquo_airstream_split_SplitChildSignal__f_externalObservers = null;
  this.Lcom_raquo_airstream_split_SplitChildSignal__f_internalObservers = null;
  this.Lcom_raquo_airstream_split_SplitChildSignal__f_willStartDone = false;
  this.Lcom_raquo_airstream_split_SplitChildSignal__f_maybeLastSeenCurrentValue = null;
  this.Lcom_raquo_airstream_split_SplitChildSignal__f_parentIsSignal = false;
  this.Lcom_raquo_airstream_split_SplitChildSignal__f__parentLastUpdateId = 0;
  this.Lcom_raquo_airstream_split_SplitChildSignal__f_parent = null;
  this.Lcom_raquo_airstream_split_SplitChildSignal__f_initialValue = null;
  this.Lcom_raquo_airstream_split_SplitChildSignal__f_getMemoizedValue = null;
  this.Lcom_raquo_airstream_split_SplitChildSignal__f_maybeInitialTransaction = null;
  this.Lcom_raquo_airstream_split_SplitChildSignal__f_droppedDuplicateEvent = false;
  this.Lcom_raquo_airstream_split_SplitChildSignal__f_topoRank = 0;
  this.Lcom_raquo_airstream_split_SplitChildSignal__f_parent = parent;
  this.Lcom_raquo_airstream_split_SplitChildSignal__f_initialValue = initialValue;
  this.Lcom_raquo_airstream_split_SplitChildSignal__f_getMemoizedValue = getMemoizedValue;
  this.Lcom_raquo_airstream_split_SplitChildSignal__f_maybeDisplayName = (void 0);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  this.Lcom_raquo_airstream_split_SplitChildSignal__f__lastUpdateId = 0;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.Lcom_raquo_airstream_split_SplitChildSignal__f_maybeLastSeenCurrentValue = (void 0);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_SingleParentSignal__$init$__V(this);
  this.Lcom_raquo_airstream_split_SplitChildSignal__f_maybeInitialTransaction = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_Transaction$pendingTransactions$().peekStack__O();
  this.Lcom_raquo_airstream_split_SplitChildSignal__f_droppedDuplicateEvent = false;
  this.Lcom_raquo_airstream_split_SplitChildSignal__f_topoRank = ((1 + parent.Lcom_raquo_airstream_timing_SyncDelayStream__f_topoRank) | 0);
}
export { $c_Lcom_raquo_airstream_split_SplitChildSignal as $c_Lcom_raquo_airstream_split_SplitChildSignal };
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.constructor = $c_Lcom_raquo_airstream_split_SplitChildSignal;
/** @constructor */
function $h_Lcom_raquo_airstream_split_SplitChildSignal() {
}
export { $h_Lcom_raquo_airstream_split_SplitChildSignal as $h_Lcom_raquo_airstream_split_SplitChildSignal };
$h_Lcom_raquo_airstream_split_SplitChildSignal.prototype = $c_Lcom_raquo_airstream_split_SplitChildSignal.prototype;
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_split_SplitChildSignal__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_split_SplitChildSignal__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.defaultDisplayName__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.isSafeToRemoveObserver__Z = (function() {
  return this.Lcom_raquo_airstream_split_SplitChildSignal__f_isSafeToRemoveObserver;
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.maybePendingObserverRemovals__O = (function() {
  return this.Lcom_raquo_airstream_split_SplitChildSignal__f_maybePendingObserverRemovals;
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.isSafeToRemoveObserver_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_split_SplitChildSignal__f_isSafeToRemoveObserver = x$1;
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.maybePendingObserverRemovals_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_split_SplitChildSignal__f_maybePendingObserverRemovals = x$1;
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.equals__O__Z = (function(obj) {
  return (this === obj);
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$systemIdentityHashCode(this);
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype._lastUpdateId__I = (function() {
  return this.Lcom_raquo_airstream_split_SplitChildSignal__f__lastUpdateId;
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype._lastUpdateId_$eq__I__V = (function(x$1) {
  this.Lcom_raquo_airstream_split_SplitChildSignal__f__lastUpdateId = x$1;
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.toObservable__Lcom_raquo_airstream_core_Signal = (function() {
  return this;
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.onAddedExternalObserver__Lcom_raquo_airstream_core_Observer__V = (function(observer) {
  observer.onTry__s_util_Try__V($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this));
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.externalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_split_SplitChildSignal__f_externalObservers;
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.internalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_split_SplitChildSignal__f_internalObservers;
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.willStartDone__Z = (function() {
  return this.Lcom_raquo_airstream_split_SplitChildSignal__f_willStartDone;
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.willStartDone_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_split_SplitChildSignal__f_willStartDone = x$1;
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.com$raquo$airstream$core$WritableObservable$_setter_$externalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_split_SplitChildSignal__f_externalObservers = x$0;
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.com$raquo$airstream$core$WritableObservable$_setter_$internalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_split_SplitChildSignal__f_internalObservers = x$0;
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.maybeLastSeenCurrentValue__O = (function() {
  return this.Lcom_raquo_airstream_split_SplitChildSignal__f_maybeLastSeenCurrentValue;
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.maybeLastSeenCurrentValue_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_split_SplitChildSignal__f_maybeLastSeenCurrentValue = x$1;
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.tryNow__s_util_Try = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.onNext__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.parentIsSignal__Z = (function() {
  return this.Lcom_raquo_airstream_split_SplitChildSignal__f_parentIsSignal;
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype._parentLastUpdateId__I = (function() {
  return this.Lcom_raquo_airstream_split_SplitChildSignal__f__parentLastUpdateId;
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype._parentLastUpdateId_$eq__I__V = (function(x$1) {
  this.Lcom_raquo_airstream_split_SplitChildSignal__f__parentLastUpdateId = x$1;
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.com$raquo$airstream$common$SingleParentSignal$_setter_$parentIsSignal_$eq__Z__V = (function(x$0) {
  this.Lcom_raquo_airstream_split_SplitChildSignal__f_parentIsSignal = x$0;
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.onStart__V = (function() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_SingleParentSignal__onStart__V(this);
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.onStop__V = (function() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_SingleParentSignal__onStop__V(this);
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.topoRank__I = (function() {
  return this.Lcom_raquo_airstream_split_SplitChildSignal__f_topoRank;
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.onWillStart__V = (function() {
  var observable = this.Lcom_raquo_airstream_split_SplitChildSignal__f_parent;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(observable);
  var maybeInitialValue = $p_Lcom_raquo_airstream_split_SplitChildSignal__pullValueFromParent__s_Option(this);
  if ((!maybeInitialValue.isEmpty__Z())) {
    var x0 = maybeInitialValue.get__O();
    matchResult1: {
      if ((x0 !== null)) {
        var nextValue = x0._1__O();
        var nextParentLastUpdateId = (x0._2__O() | 0);
        if ((nextParentLastUpdateId !== this.Lcom_raquo_airstream_split_SplitChildSignal__f__parentLastUpdateId)) {
          this.updateCurrentValueFromParent__s_util_Try__I__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(nextValue), nextParentLastUpdateId);
          break matchResult1;
        } else {
          break matchResult1;
        }
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x0);
    }
  }
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.updateCurrentValueFromParent__s_util_Try__I__V = (function(nextValue, nextParentLastUpdateId) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_SingleParentSignal__updateCurrentValueFromParent__s_util_Try__I__V(this, nextValue, nextParentLastUpdateId);
  this.Lcom_raquo_airstream_split_SplitChildSignal__f_initialValue = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.currentValueFromParent__s_util_Try = (function() {
  var this$1 = $p_Lcom_raquo_airstream_split_SplitChildSignal__pullValueFromParent__s_Option(this);
  if (this$1.isEmpty__Z()) {
    var this$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0 = this$1.get__O();
    var value = x0._1__O();
    var this$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(value));
  }
  return (this$3.isEmpty__Z() ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this) : this$3.get__O());
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextParentValue, transaction) {
  var this$1 = this.Lcom_raquo_airstream_split_SplitChildSignal__f_getMemoizedValue.apply__O();
  if ((!this$1.isEmpty__Z())) {
    var x0 = this$1.get__O();
    matchResult2: {
      if ((x0 !== null)) {
        var freshMemoizedInput = x0._1__O();
        var lastParentUpdateId = (x0._2__O() | 0);
        this.Lcom_raquo_airstream_split_SplitChildSignal__f__parentLastUpdateId = lastParentUpdateId;
        if ((!this.Lcom_raquo_airstream_split_SplitChildSignal__f_droppedDuplicateEvent)) {
          var x = this.Lcom_raquo_airstream_split_SplitChildSignal__f_maybeInitialTransaction;
          var y = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_Transaction$pendingTransactions$().peekStack__O();
          var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
        } else {
          var $x_1 = false;
        }
        if ($x_1) {
          this.Lcom_raquo_airstream_split_SplitChildSignal__f_maybeInitialTransaction = (void 0);
          this.Lcom_raquo_airstream_split_SplitChildSignal__f_droppedDuplicateEvent = true;
          break matchResult2;
        } else {
          var nextValue = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success(freshMemoizedInput);
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
          break matchResult2;
        }
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x0);
    }
  }
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.parent__Lcom_raquo_airstream_core_Observable = (function() {
  return this.Lcom_raquo_airstream_split_SplitChildSignal__f_parent;
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.map__F1__Lcom_raquo_airstream_core_Observable = (function(project) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), this, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.distinctTry__F2__Lcom_raquo_airstream_core_Observable = (function(isSame) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_distinct_DistinctSignal(this, isSame, false);
});
$c_Lcom_raquo_airstream_split_SplitChildSignal.prototype.toObservable__Lcom_raquo_airstream_core_Observable = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_split_SplitChildSignal = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_split_SplitChildSignal, "com.raquo.airstream.split.SplitChildSignal", ({
  Lcom_raquo_airstream_split_SplitChildSignal: 1,
  Lcom_raquo_airstream_core_Source: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_BaseObservable: 1,
  Lcom_raquo_airstream_core_Observable: 1,
  Lcom_raquo_airstream_core_Source$SignalSource: 1,
  Lcom_raquo_airstream_dynamicImport_SignalDynamicImportOps: 1,
  Lcom_raquo_airstream_core_Signal: 1,
  Lcom_raquo_airstream_core_WritableObservable: 1,
  Lcom_raquo_airstream_core_WritableSignal: 1,
  Lcom_raquo_airstream_core_InternalObserver: 1,
  Lcom_raquo_airstream_common_InternalTryObserver: 1,
  Lcom_raquo_airstream_common_SingleParentSignal: 1
}));
export { $d_Lcom_raquo_airstream_split_SplitChildSignal as $d_Lcom_raquo_airstream_split_SplitChildSignal };
function $p_Lcom_raquo_airstream_split_SplitSignal__memoizedProject__O__O($thiz, nextInputs) {
  var nextKeys = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_scm_HashSet__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_HashSet());
  var this$2 = $thiz.Lcom_raquo_airstream_split_SplitSignal__f_duplicateKeysConfig;
  if (this$2.Lcom_raquo_airstream_split_DuplicateKeysConfig__f__shouldWarn) {
    var duplicateKeys = [];
  } else {
    var duplicateKeys = null;
  }
  var nextOutputs = $thiz.Lcom_raquo_airstream_split_SplitSignal__f_splittable.map__O__F1__O(nextInputs, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((nextInput) => {
    var memoizedKey = $thiz.Lcom_raquo_airstream_split_SplitSignal__f_key.apply__O__O(nextInput);
    var this$4 = $thiz.Lcom_raquo_airstream_split_SplitSignal__f_duplicateKeysConfig;
    if ((this$4.Lcom_raquo_airstream_split_DuplicateKeysConfig__f__shouldWarn && nextKeys.contains__O__Z(memoizedKey))) {
      if ((!$m_sjs_js_ArrayOps$().contains$extension__sjs_js_Array__O__Z(duplicateKeys, memoizedKey))) {
        duplicateKeys.push(memoizedKey);
      }
    }
    nextKeys.add__O__Z(memoizedKey);
    var this$6 = $thiz.Lcom_raquo_airstream_split_SplitSignal__f_memoized.get__O__s_Option(memoizedKey);
    if (this$6.isEmpty__Z()) {
      var cachedSignalAndOutput = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    } else {
      var x0 = this$6.get__O();
      var _1 = x0.T4__f__2;
      var _2 = x0.T4__f__3;
      var cachedSignalAndOutput = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, _2));
    }
    if (cachedSignalAndOutput.isEmpty__Z()) {
      var $x_3 = $thiz.Lcom_raquo_airstream_split_SplitSignal__f_distinctCompose;
      var $x_2 = $thiz.Lcom_raquo_airstream_split_SplitSignal__f_sharedDelayedParent;
      var signal = $thiz.Lcom_raquo_airstream_split_SplitSignal__f_parent;
      var _2$1 = signal._lastUpdateId__I();
      var value = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), nextInput, _2$1);
      var inputSignal = $x_3.apply__O__O(new $c_Lcom_raquo_airstream_split_SplitChildSignal($x_2, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
        var maybeMemoizedValue = $thiz.Lcom_raquo_airstream_split_SplitSignal__f_memoized.get__O__s_Option(memoizedKey);
        if ((maybeMemoizedValue instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
          var memoizedValue = maybeMemoizedValue.s_Some__f_value;
          var memoizedParentLastUpdateId = (memoizedValue.T4__f__4 | 0);
          var signal$1 = $thiz.Lcom_raquo_airstream_split_SplitSignal__f_parent;
          if ((signal$1._lastUpdateId__I() > memoizedParentLastUpdateId)) {
            $thiz.currentValueFromParent__s_util_Try();
            var $x_4 = $thiz.Lcom_raquo_airstream_split_SplitSignal__f_memoized.get__O__s_Option(memoizedKey);
          } else {
            var $x_4 = maybeMemoizedValue;
          }
        } else {
          var $x_4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        }
        var this$12 = $x_4;
        if (this$12.isEmpty__Z()) {
          return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        } else {
          var x0$1 = this$12.get__O();
          var _1$1 = x0$1.T4__f__1;
          var _2$2 = x0$1.T4__f__4;
          return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1$1, _2$2));
        }
      }))));
      if (($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z($thiz) && $thiz.Lcom_raquo_airstream_split_SplitSignal__f_strict)) {
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(inputSignal, $thiz.Lcom_raquo_airstream_split_SplitSignal__f_emptyObserver, true);
      }
      var newOutput = $thiz.Lcom_raquo_airstream_split_SplitSignal__f_project.apply__O__O__O__O(memoizedKey, nextInput, inputSignal);
      var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), inputSignal, newOutput);
    } else {
      var $x_1 = cachedSignalAndOutput.get__O();
    }
    var nextSignalAndOutput = $x_1;
    var inputSignal$1 = nextSignalAndOutput._1__O();
    var nextOutput = nextSignalAndOutput._2__O();
    var $x_5 = $thiz.Lcom_raquo_airstream_split_SplitSignal__f_memoized;
    var signal$2 = $thiz.Lcom_raquo_airstream_split_SplitSignal__f_parent;
    var _4 = signal$2._lastUpdateId__I();
    $x_5.update__O__O__V(memoizedKey, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T4(nextInput, inputSignal$1, nextOutput, _4));
    return nextOutput;
  })));
  $thiz.Lcom_raquo_airstream_split_SplitSignal__f_memoized.keys__sc_Iterable().foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((memoizedKey$1) => {
    if ((!nextKeys.contains__O__Z(memoizedKey$1))) {
      if ($thiz.Lcom_raquo_airstream_split_SplitSignal__f_strict) {
        var inputSignal$2 = $thiz.Lcom_raquo_airstream_split_SplitSignal__f_memoized.apply__O__O(memoizedKey$1).T4__f__2;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V(inputSignal$2, $thiz.Lcom_raquo_airstream_split_SplitSignal__f_emptyObserver);
      }
      $thiz.Lcom_raquo_airstream_split_SplitSignal__f_memoized.remove__O__s_Option(memoizedKey$1);
    }
  })));
  var this$17 = $thiz.Lcom_raquo_airstream_split_SplitSignal__f_duplicateKeysConfig;
  if ((this$17.Lcom_raquo_airstream_split_DuplicateKeysConfig__f__shouldWarn && ((duplicateKeys.length | 0) !== 0))) {
    var $x_7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_core_AirstreamError$();
    var $x_6 = $thiz.Lcom_raquo_airstream_split_SplitSignal__f_parent;
    var this$21 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_sjs_js_WrappedArray__sjs_js_Array__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_WrappedArray(), duplicateKeys);
    $x_7.sendUnhandledError__jl_Throwable__V($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Exception__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Exception(), (((("Duplicate keys detected in {" + $x_6) + "}.split(): `") + $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__mkString__T__T__T__T(this$21, "", "`, `", "")) + "`. This is a bug in your code. See comment in Airstream's DuplicateKeysConfig.scala.")));
  }
  return nextOutputs;
}
export { $p_Lcom_raquo_airstream_split_SplitSignal__memoizedProject__O__O as $p_Lcom_raquo_airstream_split_SplitSignal__memoizedProject__O__O };
/** @constructor */
function $c_Lcom_raquo_airstream_split_SplitSignal(parent, key, distinctCompose, project, splittable, duplicateKeysConfig, strict) {
  this.Lcom_raquo_airstream_split_SplitSignal__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_split_SplitSignal__f_isSafeToRemoveObserver = false;
  this.Lcom_raquo_airstream_split_SplitSignal__f_maybePendingObserverRemovals = null;
  this.Lcom_raquo_airstream_split_SplitSignal__f__lastUpdateId = 0;
  this.Lcom_raquo_airstream_split_SplitSignal__f_externalObservers = null;
  this.Lcom_raquo_airstream_split_SplitSignal__f_internalObservers = null;
  this.Lcom_raquo_airstream_split_SplitSignal__f_willStartDone = false;
  this.Lcom_raquo_airstream_split_SplitSignal__f_maybeLastSeenCurrentValue = null;
  this.Lcom_raquo_airstream_split_SplitSignal__f_parentIsSignal = false;
  this.Lcom_raquo_airstream_split_SplitSignal__f__parentLastUpdateId = 0;
  this.Lcom_raquo_airstream_split_SplitSignal__f_parent = null;
  this.Lcom_raquo_airstream_split_SplitSignal__f_key = null;
  this.Lcom_raquo_airstream_split_SplitSignal__f_distinctCompose = null;
  this.Lcom_raquo_airstream_split_SplitSignal__f_project = null;
  this.Lcom_raquo_airstream_split_SplitSignal__f_splittable = null;
  this.Lcom_raquo_airstream_split_SplitSignal__f_duplicateKeysConfig = null;
  this.Lcom_raquo_airstream_split_SplitSignal__f_strict = false;
  this.Lcom_raquo_airstream_split_SplitSignal__f_topoRank = 0;
  this.Lcom_raquo_airstream_split_SplitSignal__f_memoized = null;
  this.Lcom_raquo_airstream_split_SplitSignal__f_sharedDelayedParent = null;
  this.Lcom_raquo_airstream_split_SplitSignal__f_emptyObserver = null;
  this.Lcom_raquo_airstream_split_SplitSignal__f_parent = parent;
  this.Lcom_raquo_airstream_split_SplitSignal__f_key = key;
  this.Lcom_raquo_airstream_split_SplitSignal__f_distinctCompose = distinctCompose;
  this.Lcom_raquo_airstream_split_SplitSignal__f_project = project;
  this.Lcom_raquo_airstream_split_SplitSignal__f_splittable = splittable;
  this.Lcom_raquo_airstream_split_SplitSignal__f_duplicateKeysConfig = duplicateKeysConfig;
  this.Lcom_raquo_airstream_split_SplitSignal__f_strict = strict;
  this.Lcom_raquo_airstream_split_SplitSignal__f_maybeDisplayName = (void 0);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  this.Lcom_raquo_airstream_split_SplitSignal__f__lastUpdateId = 0;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.Lcom_raquo_airstream_split_SplitSignal__f_maybeLastSeenCurrentValue = (void 0);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_SingleParentSignal__$init$__V(this);
  this.Lcom_raquo_airstream_split_SplitSignal__f_topoRank = ((1 + parent.topoRank__I()) | 0);
  this.Lcom_raquo_airstream_split_SplitSignal__f_memoized = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_scm_Map$().empty__O();
  this.Lcom_raquo_airstream_split_SplitSignal__f_sharedDelayedParent = new $c_Lcom_raquo_airstream_timing_SyncDelayStream(parent, this);
  this.Lcom_raquo_airstream_split_SplitSignal__f_emptyObserver = new $c_Lcom_raquo_airstream_split_SplitSignal$$anon$1();
}
export { $c_Lcom_raquo_airstream_split_SplitSignal as $c_Lcom_raquo_airstream_split_SplitSignal };
$c_Lcom_raquo_airstream_split_SplitSignal.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.constructor = $c_Lcom_raquo_airstream_split_SplitSignal;
/** @constructor */
function $h_Lcom_raquo_airstream_split_SplitSignal() {
}
export { $h_Lcom_raquo_airstream_split_SplitSignal as $h_Lcom_raquo_airstream_split_SplitSignal };
$h_Lcom_raquo_airstream_split_SplitSignal.prototype = $c_Lcom_raquo_airstream_split_SplitSignal.prototype;
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_split_SplitSignal__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_split_SplitSignal__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.defaultDisplayName__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.isSafeToRemoveObserver__Z = (function() {
  return this.Lcom_raquo_airstream_split_SplitSignal__f_isSafeToRemoveObserver;
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.maybePendingObserverRemovals__O = (function() {
  return this.Lcom_raquo_airstream_split_SplitSignal__f_maybePendingObserverRemovals;
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.isSafeToRemoveObserver_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_split_SplitSignal__f_isSafeToRemoveObserver = x$1;
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.maybePendingObserverRemovals_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_split_SplitSignal__f_maybePendingObserverRemovals = x$1;
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.equals__O__Z = (function(obj) {
  return (this === obj);
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$systemIdentityHashCode(this);
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype._lastUpdateId__I = (function() {
  return this.Lcom_raquo_airstream_split_SplitSignal__f__lastUpdateId;
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype._lastUpdateId_$eq__I__V = (function(x$1) {
  this.Lcom_raquo_airstream_split_SplitSignal__f__lastUpdateId = x$1;
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.toObservable__Lcom_raquo_airstream_core_Signal = (function() {
  return this;
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.onAddedExternalObserver__Lcom_raquo_airstream_core_Observer__V = (function(observer) {
  observer.onTry__s_util_Try__V($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this));
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.externalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_split_SplitSignal__f_externalObservers;
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.internalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_split_SplitSignal__f_internalObservers;
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.willStartDone__Z = (function() {
  return this.Lcom_raquo_airstream_split_SplitSignal__f_willStartDone;
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.willStartDone_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_split_SplitSignal__f_willStartDone = x$1;
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.com$raquo$airstream$core$WritableObservable$_setter_$externalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_split_SplitSignal__f_externalObservers = x$0;
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.com$raquo$airstream$core$WritableObservable$_setter_$internalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_split_SplitSignal__f_internalObservers = x$0;
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.maybeLastSeenCurrentValue__O = (function() {
  return this.Lcom_raquo_airstream_split_SplitSignal__f_maybeLastSeenCurrentValue;
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.maybeLastSeenCurrentValue_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_split_SplitSignal__f_maybeLastSeenCurrentValue = x$1;
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.tryNow__s_util_Try = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.onNext__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.parentIsSignal__Z = (function() {
  return this.Lcom_raquo_airstream_split_SplitSignal__f_parentIsSignal;
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype._parentLastUpdateId__I = (function() {
  return this.Lcom_raquo_airstream_split_SplitSignal__f__parentLastUpdateId;
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype._parentLastUpdateId_$eq__I__V = (function(x$1) {
  this.Lcom_raquo_airstream_split_SplitSignal__f__parentLastUpdateId = x$1;
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.com$raquo$airstream$common$SingleParentSignal$_setter_$parentIsSignal_$eq__Z__V = (function(x$0) {
  this.Lcom_raquo_airstream_split_SplitSignal__f_parentIsSignal = x$0;
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.onWillStart__V = (function() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_SingleParentSignal__onWillStart__V(this);
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.updateCurrentValueFromParent__s_util_Try__I__V = (function(nextValue, nextParentLastUpdateId) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_SingleParentSignal__updateCurrentValueFromParent__s_util_Try__I__V(this, nextValue, nextParentLastUpdateId);
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.topoRank__I = (function() {
  return this.Lcom_raquo_airstream_split_SplitSignal__f_topoRank;
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.currentValueFromParent__s_util_Try = (function() {
  return this.Lcom_raquo_airstream_split_SplitSignal__f_parent.tryNow__s_util_Try().map__F1__s_util_Try(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((nextInputs) => $p_Lcom_raquo_airstream_split_SplitSignal__memoizedProject__O__O(this, nextInputs))));
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextParentValue, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_SingleParentSignal__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextParentValue, transaction);
  nextParentValue.fold__F1__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((nextError) => {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableSignal__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
  })), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((nextEvent) => {
    var nextValue = $p_Lcom_raquo_airstream_split_SplitSignal__memoizedProject__O__O(this, nextEvent);
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableSignal__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
  })));
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.onStart__V = (function() {
  if (this.Lcom_raquo_airstream_split_SplitSignal__f_strict) {
    this.Lcom_raquo_airstream_split_SplitSignal__f_parent.tryNow__s_util_Try().foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((inputs) => {
      this.Lcom_raquo_airstream_split_SplitSignal__f_splittable.foreach__O__F1__V(inputs, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((input) => {
        var memoizedKey = this.Lcom_raquo_airstream_split_SplitSignal__f_key.apply__O__O(input);
        var this$2 = this.Lcom_raquo_airstream_split_SplitSignal__f_memoized.get__O__s_Option(memoizedKey);
        if (this$2.isEmpty__Z()) {
          var maybeInputSignal = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        } else {
          var x0 = this$2.get__O();
          var maybeInputSignal = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(x0.T4__f__2);
        }
        if ((!maybeInputSignal.isEmpty__Z())) {
          var x0$1 = maybeInputSignal.get__O();
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(x0$1, this.Lcom_raquo_airstream_split_SplitSignal__f_emptyObserver, true);
        }
      })));
    })));
  }
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_SingleParentSignal__onStart__V(this);
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.onStop__V = (function() {
  if (this.Lcom_raquo_airstream_split_SplitSignal__f_strict) {
    this.Lcom_raquo_airstream_split_SplitSignal__f_memoized.keys__sc_Iterable().foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((memoizedKey) => {
      var inputSignal = this.Lcom_raquo_airstream_split_SplitSignal__f_memoized.apply__O__O(memoizedKey).T4__f__2;
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V(inputSignal, this.Lcom_raquo_airstream_split_SplitSignal__f_emptyObserver);
    })));
  }
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_SingleParentSignal__onStop__V(this);
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.parent__Lcom_raquo_airstream_core_Observable = (function() {
  return this.Lcom_raquo_airstream_split_SplitSignal__f_parent;
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.map__F1__Lcom_raquo_airstream_core_Observable = (function(project) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), this, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.distinctTry__F2__Lcom_raquo_airstream_core_Observable = (function(isSame) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_distinct_DistinctSignal(this, isSame, false);
});
$c_Lcom_raquo_airstream_split_SplitSignal.prototype.toObservable__Lcom_raquo_airstream_core_Observable = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_split_SplitSignal = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_split_SplitSignal, "com.raquo.airstream.split.SplitSignal", ({
  Lcom_raquo_airstream_split_SplitSignal: 1,
  Lcom_raquo_airstream_core_Source: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_BaseObservable: 1,
  Lcom_raquo_airstream_core_Observable: 1,
  Lcom_raquo_airstream_core_Source$SignalSource: 1,
  Lcom_raquo_airstream_dynamicImport_SignalDynamicImportOps: 1,
  Lcom_raquo_airstream_core_Signal: 1,
  Lcom_raquo_airstream_core_WritableObservable: 1,
  Lcom_raquo_airstream_core_WritableSignal: 1,
  Lcom_raquo_airstream_core_InternalObserver: 1,
  Lcom_raquo_airstream_common_InternalTryObserver: 1,
  Lcom_raquo_airstream_common_SingleParentSignal: 1
}));
export { $d_Lcom_raquo_airstream_split_SplitSignal as $d_Lcom_raquo_airstream_split_SplitSignal };
/** @constructor */
function $c_Lcom_raquo_airstream_timing_DebounceStream(parent, intervalMs) {
  this.Lcom_raquo_airstream_timing_DebounceStream__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_timing_DebounceStream__f_isSafeToRemoveObserver = false;
  this.Lcom_raquo_airstream_timing_DebounceStream__f_maybePendingObserverRemovals = null;
  this.Lcom_raquo_airstream_timing_DebounceStream__f_externalObservers = null;
  this.Lcom_raquo_airstream_timing_DebounceStream__f_internalObservers = null;
  this.Lcom_raquo_airstream_timing_DebounceStream__f_willStartDone = false;
  this.Lcom_raquo_airstream_timing_DebounceStream__f_parent = null;
  this.Lcom_raquo_airstream_timing_DebounceStream__f_intervalMs = 0;
  this.Lcom_raquo_airstream_timing_DebounceStream__f_maybeLastTimeoutHandle = null;
  this.Lcom_raquo_airstream_timing_DebounceStream__f_topoRank = 0;
  this.Lcom_raquo_airstream_timing_DebounceStream__f_parent = parent;
  this.Lcom_raquo_airstream_timing_DebounceStream__f_intervalMs = intervalMs;
  this.Lcom_raquo_airstream_timing_DebounceStream__f_maybeDisplayName = (void 0);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.Lcom_raquo_airstream_timing_DebounceStream__f_maybeLastTimeoutHandle = (void 0);
  this.Lcom_raquo_airstream_timing_DebounceStream__f_topoRank = 1;
}
export { $c_Lcom_raquo_airstream_timing_DebounceStream as $c_Lcom_raquo_airstream_timing_DebounceStream };
$c_Lcom_raquo_airstream_timing_DebounceStream.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_timing_DebounceStream.prototype.constructor = $c_Lcom_raquo_airstream_timing_DebounceStream;
/** @constructor */
function $h_Lcom_raquo_airstream_timing_DebounceStream() {
}
export { $h_Lcom_raquo_airstream_timing_DebounceStream as $h_Lcom_raquo_airstream_timing_DebounceStream };
$h_Lcom_raquo_airstream_timing_DebounceStream.prototype = $c_Lcom_raquo_airstream_timing_DebounceStream.prototype;
$c_Lcom_raquo_airstream_timing_DebounceStream.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_timing_DebounceStream__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_timing_DebounceStream.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_timing_DebounceStream__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_timing_DebounceStream.prototype.defaultDisplayName__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_airstream_timing_DebounceStream.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_timing_DebounceStream.prototype.isSafeToRemoveObserver__Z = (function() {
  return this.Lcom_raquo_airstream_timing_DebounceStream__f_isSafeToRemoveObserver;
});
$c_Lcom_raquo_airstream_timing_DebounceStream.prototype.maybePendingObserverRemovals__O = (function() {
  return this.Lcom_raquo_airstream_timing_DebounceStream__f_maybePendingObserverRemovals;
});
$c_Lcom_raquo_airstream_timing_DebounceStream.prototype.isSafeToRemoveObserver_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_timing_DebounceStream__f_isSafeToRemoveObserver = x$1;
});
$c_Lcom_raquo_airstream_timing_DebounceStream.prototype.maybePendingObserverRemovals_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_timing_DebounceStream__f_maybePendingObserverRemovals = x$1;
});
$c_Lcom_raquo_airstream_timing_DebounceStream.prototype.equals__O__Z = (function(obj) {
  return (this === obj);
});
$c_Lcom_raquo_airstream_timing_DebounceStream.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$systemIdentityHashCode(this);
});
$c_Lcom_raquo_airstream_timing_DebounceStream.prototype.onAddedExternalObserver__Lcom_raquo_airstream_core_Observer__V = (function(observer) {
});
$c_Lcom_raquo_airstream_timing_DebounceStream.prototype.toObservable__Lcom_raquo_airstream_core_EventStream = (function() {
  return this;
});
$c_Lcom_raquo_airstream_timing_DebounceStream.prototype.externalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_timing_DebounceStream__f_externalObservers;
});
$c_Lcom_raquo_airstream_timing_DebounceStream.prototype.internalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_timing_DebounceStream__f_internalObservers;
});
$c_Lcom_raquo_airstream_timing_DebounceStream.prototype.willStartDone__Z = (function() {
  return this.Lcom_raquo_airstream_timing_DebounceStream__f_willStartDone;
});
$c_Lcom_raquo_airstream_timing_DebounceStream.prototype.willStartDone_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_timing_DebounceStream__f_willStartDone = x$1;
});
$c_Lcom_raquo_airstream_timing_DebounceStream.prototype.com$raquo$airstream$core$WritableObservable$_setter_$externalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_timing_DebounceStream__f_externalObservers = x$0;
});
$c_Lcom_raquo_airstream_timing_DebounceStream.prototype.com$raquo$airstream$core$WritableObservable$_setter_$internalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_timing_DebounceStream__f_internalObservers = x$0;
});
$c_Lcom_raquo_airstream_timing_DebounceStream.prototype.fireValue__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_timing_DebounceStream.prototype.fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$c_Lcom_raquo_airstream_timing_DebounceStream.prototype.fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_timing_DebounceStream.prototype.onWillStart__V = (function() {
  var observable = this.Lcom_raquo_airstream_timing_DebounceStream__f_parent;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(observable);
});
$c_Lcom_raquo_airstream_timing_DebounceStream.prototype.onStart__V = (function() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_SingleParentStream__onStart__V(this);
});
$c_Lcom_raquo_airstream_timing_DebounceStream.prototype.onNext__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_timing_DebounceStream.prototype.onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$c_Lcom_raquo_airstream_timing_DebounceStream.prototype.topoRank__I = (function() {
  return this.Lcom_raquo_airstream_timing_DebounceStream__f_topoRank;
});
$c_Lcom_raquo_airstream_timing_DebounceStream.prototype.onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  var x = this.Lcom_raquo_airstream_timing_DebounceStream__f_maybeLastTimeoutHandle;
  if ((x !== (void 0))) {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sjs_js_timers_package$().clearTimeout__sjs_js_timers_SetTimeoutHandle__V(x);
  }
  this.Lcom_raquo_airstream_timing_DebounceStream__f_maybeLastTimeoutHandle = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sjs_js_timers_package$().setTimeout__D__F0__sjs_js_timers_SetTimeoutHandle(this.Lcom_raquo_airstream_timing_DebounceStream__f_intervalMs, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    var code = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => {
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, _$1);
    }));
    new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_core_Transaction(code);
  })));
});
$c_Lcom_raquo_airstream_timing_DebounceStream.prototype.onStop__V = (function() {
  var x = this.Lcom_raquo_airstream_timing_DebounceStream__f_maybeLastTimeoutHandle;
  if ((x !== (void 0))) {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sjs_js_timers_package$().clearTimeout__sjs_js_timers_SetTimeoutHandle__V(x);
  }
  this.Lcom_raquo_airstream_timing_DebounceStream__f_maybeLastTimeoutHandle = (void 0);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_SingleParentStream__onStop__V(this);
});
$c_Lcom_raquo_airstream_timing_DebounceStream.prototype.parent__Lcom_raquo_airstream_core_Observable = (function() {
  return this.Lcom_raquo_airstream_timing_DebounceStream__f_parent;
});
$c_Lcom_raquo_airstream_timing_DebounceStream.prototype.map__F1__Lcom_raquo_airstream_core_Observable = (function(project) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapStream(this, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lcom_raquo_airstream_timing_DebounceStream.prototype.distinctTry__F2__Lcom_raquo_airstream_core_Observable = (function(isSame) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$c_Lcom_raquo_airstream_timing_DebounceStream.prototype.toObservable__Lcom_raquo_airstream_core_Observable = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_timing_DebounceStream = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_timing_DebounceStream, "com.raquo.airstream.timing.DebounceStream", ({
  Lcom_raquo_airstream_timing_DebounceStream: 1,
  Lcom_raquo_airstream_core_Source: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_BaseObservable: 1,
  Lcom_raquo_airstream_core_Observable: 1,
  Lcom_raquo_airstream_core_Source$EventSource: 1,
  Lcom_raquo_airstream_dynamicImport_StreamDynamicImportOps: 1,
  Lcom_raquo_airstream_core_EventStream: 1,
  Lcom_raquo_airstream_core_WritableObservable: 1,
  Lcom_raquo_airstream_core_WritableStream: 1,
  Lcom_raquo_airstream_core_InternalObserver: 1,
  Lcom_raquo_airstream_common_SingleParentStream: 1,
  Lcom_raquo_airstream_common_InternalTryObserver: 1
}));
export { $d_Lcom_raquo_airstream_timing_DebounceStream as $d_Lcom_raquo_airstream_timing_DebounceStream };
/** @constructor */
function $c_Lframework_tapir_FrameworkTapir$() {
  this.Lframework_tapir_FrameworkTapir$__f_NoTrailingSlash$lzy1 = null;
  this.Lframework_tapir_FrameworkTapir$__f_NoTrailingSlashbitmap$1 = false;
  this.Lframework_tapir_FrameworkTapir$__f_sttp$tapir$Tapir$$emptyIO = null;
  this.Lframework_tapir_FrameworkTapir$__f_emptyOutput = null;
  this.Lframework_tapir_FrameworkTapir$__f_emptyInput = null;
  this.Lframework_tapir_FrameworkTapir$__f_infallibleEndpoint = null;
  this.Lframework_tapir_FrameworkTapir$__f_endpoint = null;
  $n_Lframework_tapir_FrameworkTapir$ = this;
  $f_Lsttp_tapir_TapirComputedInputs__$init$__V(this);
  $f_Lsttp_tapir_Tapir__$init$__V(this);
  $f_Lsttp_tapir_json_circe_TapirJsonCirce__$init$__V(this);
}
export { $c_Lframework_tapir_FrameworkTapir$ as $c_Lframework_tapir_FrameworkTapir$ };
$c_Lframework_tapir_FrameworkTapir$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lframework_tapir_FrameworkTapir$.prototype.constructor = $c_Lframework_tapir_FrameworkTapir$;
/** @constructor */
function $h_Lframework_tapir_FrameworkTapir$() {
}
export { $h_Lframework_tapir_FrameworkTapir$ as $h_Lframework_tapir_FrameworkTapir$ };
$h_Lframework_tapir_FrameworkTapir$.prototype = $c_Lframework_tapir_FrameworkTapir$.prototype;
$c_Lframework_tapir_FrameworkTapir$.prototype.NoTrailingSlash__Lsttp_tapir_TapirComputedInputs$NoTrailingSlash$ = (function() {
  if ((!this.Lframework_tapir_FrameworkTapir$__f_NoTrailingSlashbitmap$1)) {
    this.Lframework_tapir_FrameworkTapir$__f_NoTrailingSlash$lzy1 = new $c_Lsttp_tapir_TapirComputedInputs$NoTrailingSlash$(this);
    this.Lframework_tapir_FrameworkTapir$__f_NoTrailingSlashbitmap$1 = true;
  }
  return this.Lframework_tapir_FrameworkTapir$__f_NoTrailingSlash$lzy1;
});
$c_Lframework_tapir_FrameworkTapir$.prototype.sttp$tapir$TapirComputedInputs$_setter_$noTrailingSlash_$eq__Lsttp_tapir_EndpointInput__V = (function(x$0) {
});
$c_Lframework_tapir_FrameworkTapir$.prototype.sttp$tapir$Tapir$$emptyIO__Lsttp_tapir_EndpointIO$Empty = (function() {
  return this.Lframework_tapir_FrameworkTapir$__f_sttp$tapir$Tapir$$emptyIO;
});
$c_Lframework_tapir_FrameworkTapir$.prototype.emptyOutput__Lsttp_tapir_EndpointOutput$Atom = (function() {
  return this.Lframework_tapir_FrameworkTapir$__f_emptyOutput;
});
$c_Lframework_tapir_FrameworkTapir$.prototype.emptyInput__Lsttp_tapir_EndpointInput = (function() {
  return this.Lframework_tapir_FrameworkTapir$__f_emptyInput;
});
$c_Lframework_tapir_FrameworkTapir$.prototype.infallibleEndpoint__Lsttp_tapir_Endpoint = (function() {
  return this.Lframework_tapir_FrameworkTapir$__f_infallibleEndpoint;
});
$c_Lframework_tapir_FrameworkTapir$.prototype.sttp$tapir$Tapir$_setter_$htmlBodyUtf8_$eq__Lsttp_tapir_EndpointIO$Body__V = (function(x$0) {
});
$c_Lframework_tapir_FrameworkTapir$.prototype.sttp$tapir$Tapir$_setter_$multipartBody_$eq__Lsttp_tapir_EndpointIO$Body__V = (function(x$0) {
});
$c_Lframework_tapir_FrameworkTapir$.prototype.sttp$tapir$Tapir$_setter_$sttp$tapir$Tapir$$primitiveToBoxedClasses_$eq__sci_Map__V = (function(x$0) {
});
$c_Lframework_tapir_FrameworkTapir$.prototype.sttp$tapir$Tapir$_setter_$sttp$tapir$Tapir$$emptyIO_$eq__Lsttp_tapir_EndpointIO$Empty__V = (function(x$0) {
  this.Lframework_tapir_FrameworkTapir$__f_sttp$tapir$Tapir$$emptyIO = x$0;
});
$c_Lframework_tapir_FrameworkTapir$.prototype.sttp$tapir$Tapir$_setter_$emptyOutput_$eq__Lsttp_tapir_EndpointOutput$Atom__V = (function(x$0) {
  this.Lframework_tapir_FrameworkTapir$__f_emptyOutput = x$0;
});
$c_Lframework_tapir_FrameworkTapir$.prototype.sttp$tapir$Tapir$_setter_$emptyInput_$eq__Lsttp_tapir_EndpointInput__V = (function(x$0) {
  this.Lframework_tapir_FrameworkTapir$__f_emptyInput = x$0;
});
$c_Lframework_tapir_FrameworkTapir$.prototype.sttp$tapir$Tapir$_setter_$emptyAuth_$eq__Lsttp_tapir_EndpointInput$Auth__V = (function(x$0) {
});
$c_Lframework_tapir_FrameworkTapir$.prototype.sttp$tapir$Tapir$_setter_$infallibleEndpoint_$eq__Lsttp_tapir_Endpoint__V = (function(x$0) {
  this.Lframework_tapir_FrameworkTapir$__f_infallibleEndpoint = x$0;
});
$c_Lframework_tapir_FrameworkTapir$.prototype.sttp$tapir$Tapir$_setter_$endpoint_$eq__Lsttp_tapir_Endpoint__V = (function(x$0) {
  this.Lframework_tapir_FrameworkTapir$__f_endpoint = x$0;
});
var $d_Lframework_tapir_FrameworkTapir$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lframework_tapir_FrameworkTapir$, "framework.tapir.FrameworkTapir$", ({
  Lframework_tapir_FrameworkTapir$: 1,
  Lsttp_tapir_TapirExtensions: 1,
  Lsttp_tapir_TapirComputedInputs: 1,
  Lsttp_tapir_static_TapirStaticContentEndpoints: 1,
  Lsttp_tapir_macros_ModifyMacroFunctorSupport: 1,
  Lsttp_tapir_macros_ModifyMacroSupport: 1,
  Lsttp_tapir_Tapir: 1,
  Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation: 1,
  Lsttp_tapir_generic_auto_SchemaDerivation: 1,
  Lsttp_tapir_integ_cats_TapirCodecCats: 1,
  Lsttp_tapir_json_circe_TapirJsonCirce: 1,
  Lsttp_tapir_integ_cats_ServerEndpointSyntax: 1,
  Lsttp_tapir_integ_cats_MonadErrorSyntax: 1
}));
export { $d_Lframework_tapir_FrameworkTapir$ as $d_Lframework_tapir_FrameworkTapir$ };
var $n_Lframework_tapir_FrameworkTapir$;
function $m_Lframework_tapir_FrameworkTapir$() {
  if ((!$n_Lframework_tapir_FrameworkTapir$)) {
    $n_Lframework_tapir_FrameworkTapir$ = new $c_Lframework_tapir_FrameworkTapir$();
  }
  return $n_Lframework_tapir_FrameworkTapir$;
}
export { $m_Lframework_tapir_FrameworkTapir$ as $m_Lframework_tapir_FrameworkTapir$ };
function $p_Lio_circe_derivation_ConfiguredCodec$$anon$3__fp__F1($thiz) {
  if ((!$thiz.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_fpbitmap$1)) {
    $thiz.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_fp$lzy1 = $thiz.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_fromProduct$2.apply__O();
    $thiz.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_fpbitmap$1 = true;
  }
  return $thiz.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_fp$lzy1;
}
export { $p_Lio_circe_derivation_ConfiguredCodec$$anon$3__fp__F1 as $p_Lio_circe_derivation_ConfiguredCodec$$anon$3__fp__F1 };
/** @constructor */
function $c_Lio_circe_derivation_ConfiguredCodec$$anon$3(conf$3, nme$3, fromProduct$1, decoders$5, encoders$5, labels$5, defaults$5) {
  this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_fromProduct$2 = null;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_decoders$6 = null;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_encoders$6 = null;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_labels$6 = null;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_defaults$6 = null;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_io$circe$derivation$ConfiguredDecoder$$conf = null;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_constructorNames$lzy3 = null;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_constructorNamesbitmap$3 = false;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_io$circe$derivation$ConfiguredDecoder$$decodersDict$lzy3 = null;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_io$circe$derivation$ConfiguredDecoder$$decodersDictbitmap$3 = false;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_io$circe$derivation$ConfiguredEncoder$$conf = null;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_fp$lzy1 = null;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_fpbitmap$1 = false;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_name = null;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_elemDecoders$lzy3 = null;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_elemDecodersbitmap$3 = false;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_elemEncoders$lzy3 = null;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_elemEncodersbitmap$3 = false;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_elemLabels$lzy3 = null;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_elemLabelsbitmap$3 = false;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_elemDefaults$lzy3 = null;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_elemDefaultsbitmap$3 = false;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_fromProduct$2 = fromProduct$1;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_decoders$6 = decoders$5;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_encoders$6 = encoders$5;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_labels$6 = labels$5;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_defaults$6 = defaults$5;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_io$circe$derivation$ConfiguredDecoder$$conf = conf$3;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_io$circe$derivation$ConfiguredEncoder$$conf = conf$3;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_name = nme$3;
}
export { $c_Lio_circe_derivation_ConfiguredCodec$$anon$3 as $c_Lio_circe_derivation_ConfiguredCodec$$anon$3 };
$c_Lio_circe_derivation_ConfiguredCodec$$anon$3.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_circe_derivation_ConfiguredCodec$$anon$3.prototype.constructor = $c_Lio_circe_derivation_ConfiguredCodec$$anon$3;
/** @constructor */
function $h_Lio_circe_derivation_ConfiguredCodec$$anon$3() {
}
export { $h_Lio_circe_derivation_ConfiguredCodec$$anon$3 as $h_Lio_circe_derivation_ConfiguredCodec$$anon$3 };
$h_Lio_circe_derivation_ConfiguredCodec$$anon$3.prototype = $c_Lio_circe_derivation_ConfiguredCodec$$anon$3.prototype;
$c_Lio_circe_derivation_ConfiguredCodec$$anon$3.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$c_Lio_circe_derivation_ConfiguredCodec$$anon$3.prototype.tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated = (function(c) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lio_circe_Decoder__tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated(this, c);
});
$c_Lio_circe_derivation_ConfiguredCodec$$anon$3.prototype.io$circe$derivation$ConfiguredDecoder$$conf__Lio_circe_derivation_Configuration = (function() {
  return this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_io$circe$derivation$ConfiguredDecoder$$conf;
});
$c_Lio_circe_derivation_ConfiguredCodec$$anon$3.prototype.constructorNames__sci_List = (function() {
  if ((!this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_constructorNamesbitmap$3)) {
    this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_constructorNames$lzy3 = $f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_constructorNamesbitmap$3 = true;
  }
  return this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_constructorNames$lzy3;
});
$c_Lio_circe_derivation_ConfiguredCodec$$anon$3.prototype.io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map = (function() {
  if ((!this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_io$circe$derivation$ConfiguredDecoder$$decodersDictbitmap$3)) {
    this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_io$circe$derivation$ConfiguredDecoder$$decodersDict$lzy3 = $f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_io$circe$derivation$ConfiguredDecoder$$decodersDictbitmap$3 = true;
  }
  return this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_io$circe$derivation$ConfiguredDecoder$$decodersDict$lzy3;
});
$c_Lio_circe_derivation_ConfiguredCodec$$anon$3.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$c_Lio_circe_derivation_ConfiguredCodec$$anon$3.prototype.io$circe$derivation$ConfiguredEncoder$$conf__Lio_circe_derivation_Configuration = (function() {
  return this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_io$circe$derivation$ConfiguredEncoder$$conf;
});
$c_Lio_circe_derivation_ConfiguredCodec$$anon$3.prototype.name__T = (function() {
  return this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_name;
});
$c_Lio_circe_derivation_ConfiguredCodec$$anon$3.prototype.elemDecoders__sci_List = (function() {
  if ((!this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_elemDecodersbitmap$3)) {
    this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_elemDecoders$lzy3 = this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_decoders$6.apply__O();
    this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_elemDecodersbitmap$3 = true;
  }
  return this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_elemDecoders$lzy3;
});
$c_Lio_circe_derivation_ConfiguredCodec$$anon$3.prototype.elemEncoders__sci_List = (function() {
  if ((!this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_elemEncodersbitmap$3)) {
    this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_elemEncoders$lzy3 = this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_encoders$6.apply__O();
    this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_elemEncodersbitmap$3 = true;
  }
  return this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_elemEncoders$lzy3;
});
$c_Lio_circe_derivation_ConfiguredCodec$$anon$3.prototype.elemLabels__sci_List = (function() {
  if ((!this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_elemLabelsbitmap$3)) {
    this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_elemLabels$lzy3 = this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_labels$6;
    this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_elemLabelsbitmap$3 = true;
  }
  return this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_elemLabels$lzy3;
});
$c_Lio_circe_derivation_ConfiguredCodec$$anon$3.prototype.elemDefaults__Lio_circe_derivation_Default = (function() {
  if ((!this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_elemDefaultsbitmap$3)) {
    this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_elemDefaults$lzy3 = this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_defaults$6;
    this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_elemDefaultsbitmap$3 = true;
  }
  return this.Lio_circe_derivation_ConfiguredCodec$$anon$3__f_elemDefaults$lzy3;
});
$c_Lio_circe_derivation_ConfiguredCodec$$anon$3.prototype.isSum__Z = (function() {
  return false;
});
$c_Lio_circe_derivation_ConfiguredCodec$$anon$3.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var fromProduct = $p_Lio_circe_derivation_ConfiguredCodec$$anon$3__fp__F1(this);
  return $f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, fromProduct);
});
$c_Lio_circe_derivation_ConfiguredCodec$$anon$3.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
$c_Lio_circe_derivation_ConfiguredCodec$$anon$3.prototype.decodeAccumulating__Lio_circe_HCursor__Lcats_data_Validated = (function(c) {
  var fromProduct = $p_Lio_circe_derivation_ConfiguredCodec$$anon$3__fp__F1(this);
  return $f_Lio_circe_derivation_ConfiguredDecoder__decodeProductAccumulating__Lio_circe_HCursor__F1__Lcats_data_Validated(this, c, fromProduct);
});
var $d_Lio_circe_derivation_ConfiguredCodec$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_circe_derivation_ConfiguredCodec$$anon$3, "io.circe.derivation.ConfiguredCodec$$anon$3", ({
  Lio_circe_derivation_ConfiguredCodec$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1,
  Lio_circe_derivation_ConfiguredDecoder: 1,
  Lio_circe_Encoder: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_derivation_ConfiguredEncoder: 1,
  Lio_circe_Codec: 1,
  Lio_circe_Codec$AsRoot: 1,
  Lio_circe_Codec$AsObject: 1,
  Lio_circe_derivation_ConfiguredCodec: 1,
  Lio_circe_derivation_SumOrProduct: 1
}));
export { $d_Lio_circe_derivation_ConfiguredCodec$$anon$3 as $d_Lio_circe_derivation_ConfiguredCodec$$anon$3 };
function $p_Lio_circe_derivation_ConfiguredCodec$$anon$4__o__F1($thiz) {
  if ((!$thiz.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_obitmap$1)) {
    $thiz.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_o$lzy1 = $thiz.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_ordinal$2.apply__O();
    $thiz.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_obitmap$1 = true;
  }
  return $thiz.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_o$lzy1;
}
export { $p_Lio_circe_derivation_ConfiguredCodec$$anon$4__o__F1 as $p_Lio_circe_derivation_ConfiguredCodec$$anon$4__o__F1 };
/** @constructor */
function $c_Lio_circe_derivation_ConfiguredCodec$$anon$4(conf$4, nme$4, ordinal$1, decoders$7, encoders$7, labels$7, defaults$7) {
  this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_ordinal$2 = null;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_decoders$8 = null;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_encoders$8 = null;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_labels$8 = null;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_defaults$8 = null;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_io$circe$derivation$ConfiguredDecoder$$conf = null;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_constructorNames$lzy4 = null;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_constructorNamesbitmap$4 = false;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_io$circe$derivation$ConfiguredDecoder$$decodersDict$lzy4 = null;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_io$circe$derivation$ConfiguredDecoder$$decodersDictbitmap$4 = false;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_io$circe$derivation$ConfiguredEncoder$$conf = null;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_o$lzy1 = null;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_obitmap$1 = false;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_name = null;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_elemDecoders$lzy4 = null;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_elemDecodersbitmap$4 = false;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_elemEncoders$lzy4 = null;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_elemEncodersbitmap$4 = false;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_elemLabels$lzy4 = null;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_elemLabelsbitmap$4 = false;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_elemDefaults$lzy4 = null;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_elemDefaultsbitmap$4 = false;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_ordinal$2 = ordinal$1;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_decoders$8 = decoders$7;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_encoders$8 = encoders$7;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_labels$8 = labels$7;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_defaults$8 = defaults$7;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_io$circe$derivation$ConfiguredDecoder$$conf = conf$4;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_io$circe$derivation$ConfiguredEncoder$$conf = conf$4;
  this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_name = nme$4;
}
export { $c_Lio_circe_derivation_ConfiguredCodec$$anon$4 as $c_Lio_circe_derivation_ConfiguredCodec$$anon$4 };
$c_Lio_circe_derivation_ConfiguredCodec$$anon$4.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lio_circe_derivation_ConfiguredCodec$$anon$4.prototype.constructor = $c_Lio_circe_derivation_ConfiguredCodec$$anon$4;
/** @constructor */
function $h_Lio_circe_derivation_ConfiguredCodec$$anon$4() {
}
export { $h_Lio_circe_derivation_ConfiguredCodec$$anon$4 as $h_Lio_circe_derivation_ConfiguredCodec$$anon$4 };
$h_Lio_circe_derivation_ConfiguredCodec$$anon$4.prototype = $c_Lio_circe_derivation_ConfiguredCodec$$anon$4.prototype;
$c_Lio_circe_derivation_ConfiguredCodec$$anon$4.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$c_Lio_circe_derivation_ConfiguredCodec$$anon$4.prototype.tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated = (function(c) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lio_circe_Decoder__tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated(this, c);
});
$c_Lio_circe_derivation_ConfiguredCodec$$anon$4.prototype.io$circe$derivation$ConfiguredDecoder$$conf__Lio_circe_derivation_Configuration = (function() {
  return this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_io$circe$derivation$ConfiguredDecoder$$conf;
});
$c_Lio_circe_derivation_ConfiguredCodec$$anon$4.prototype.constructorNames__sci_List = (function() {
  if ((!this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_constructorNamesbitmap$4)) {
    this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_constructorNames$lzy4 = $f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_constructorNamesbitmap$4 = true;
  }
  return this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_constructorNames$lzy4;
});
$c_Lio_circe_derivation_ConfiguredCodec$$anon$4.prototype.io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map = (function() {
  if ((!this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_io$circe$derivation$ConfiguredDecoder$$decodersDictbitmap$4)) {
    this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_io$circe$derivation$ConfiguredDecoder$$decodersDict$lzy4 = $f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_io$circe$derivation$ConfiguredDecoder$$decodersDictbitmap$4 = true;
  }
  return this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_io$circe$derivation$ConfiguredDecoder$$decodersDict$lzy4;
});
$c_Lio_circe_derivation_ConfiguredCodec$$anon$4.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$c_Lio_circe_derivation_ConfiguredCodec$$anon$4.prototype.io$circe$derivation$ConfiguredEncoder$$conf__Lio_circe_derivation_Configuration = (function() {
  return this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_io$circe$derivation$ConfiguredEncoder$$conf;
});
$c_Lio_circe_derivation_ConfiguredCodec$$anon$4.prototype.name__T = (function() {
  return this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_name;
});
$c_Lio_circe_derivation_ConfiguredCodec$$anon$4.prototype.elemDecoders__sci_List = (function() {
  if ((!this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_elemDecodersbitmap$4)) {
    this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_elemDecoders$lzy4 = this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_decoders$8.apply__O();
    this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_elemDecodersbitmap$4 = true;
  }
  return this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_elemDecoders$lzy4;
});
$c_Lio_circe_derivation_ConfiguredCodec$$anon$4.prototype.elemEncoders__sci_List = (function() {
  if ((!this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_elemEncodersbitmap$4)) {
    this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_elemEncoders$lzy4 = this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_encoders$8.apply__O();
    this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_elemEncodersbitmap$4 = true;
  }
  return this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_elemEncoders$lzy4;
});
$c_Lio_circe_derivation_ConfiguredCodec$$anon$4.prototype.elemLabels__sci_List = (function() {
  if ((!this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_elemLabelsbitmap$4)) {
    this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_elemLabels$lzy4 = this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_labels$8;
    this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_elemLabelsbitmap$4 = true;
  }
  return this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_elemLabels$lzy4;
});
$c_Lio_circe_derivation_ConfiguredCodec$$anon$4.prototype.elemDefaults__Lio_circe_derivation_Default = (function() {
  if ((!this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_elemDefaultsbitmap$4)) {
    this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_elemDefaults$lzy4 = this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_defaults$8;
    this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_elemDefaultsbitmap$4 = true;
  }
  return this.Lio_circe_derivation_ConfiguredCodec$$anon$4__f_elemDefaults$lzy4;
});
$c_Lio_circe_derivation_ConfiguredCodec$$anon$4.prototype.isSum__Z = (function() {
  return true;
});
$c_Lio_circe_derivation_ConfiguredCodec$$anon$4.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  return $f_Lio_circe_derivation_ConfiguredDecoder__decodeSum__Lio_circe_HCursor__s_util_Either(this, c);
});
$c_Lio_circe_derivation_ConfiguredCodec$$anon$4.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  var index = ($p_Lio_circe_derivation_ConfiguredCodec$$anon$4__o__F1(this).apply__O__O(a) | 0);
  return $f_Lio_circe_derivation_ConfiguredEncoder__encodeSum__I__O__Lio_circe_JsonObject(this, index, a);
});
$c_Lio_circe_derivation_ConfiguredCodec$$anon$4.prototype.decodeAccumulating__Lio_circe_HCursor__Lcats_data_Validated = (function(c) {
  return $f_Lio_circe_derivation_ConfiguredDecoder__decodeSumAccumulating__Lio_circe_HCursor__Lcats_data_Validated(this, c);
});
var $d_Lio_circe_derivation_ConfiguredCodec$$anon$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lio_circe_derivation_ConfiguredCodec$$anon$4, "io.circe.derivation.ConfiguredCodec$$anon$4", ({
  Lio_circe_derivation_ConfiguredCodec$$anon$4: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1,
  Lio_circe_derivation_ConfiguredDecoder: 1,
  Lio_circe_Encoder: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_derivation_ConfiguredEncoder: 1,
  Lio_circe_Codec: 1,
  Lio_circe_Codec$AsRoot: 1,
  Lio_circe_Codec$AsObject: 1,
  Lio_circe_derivation_ConfiguredCodec: 1,
  Lio_circe_derivation_SumOrProduct: 1
}));
export { $d_Lio_circe_derivation_ConfiguredCodec$$anon$4 as $d_Lio_circe_derivation_ConfiguredCodec$$anon$4 };
function $f_sc_SortedSet__equals__O__Z($thiz, that) {
  if (($thiz === that)) {
    return true;
  }
  if ($is_sc_SortedSet(that)) {
    var x = that.ordering__s_math_Ordering();
    var x$2 = $thiz.ordering__s_math_Ordering();
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      if (($thiz.size__I() === that.size__I())) {
        var i1 = $thiz.iterator__sc_Iterator();
        var i2 = that.iterator__sc_Iterator();
        var allEqual = true;
        while ((allEqual && i1.hasNext__Z())) {
          allEqual = $thiz.ordering__s_math_Ordering().equiv__O__O__Z(i1.next__O(), i2.next__O());
        }
        return allEqual;
      } else {
        return false;
      }
    }
  }
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_Set__equals__O__Z($thiz, that);
}
export { $f_sc_SortedSet__equals__O__Z as $f_sc_SortedSet__equals__O__Z };
function $is_sc_SortedSet(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_SortedSet)));
}
export { $is_sc_SortedSet as $is_sc_SortedSet };
function $isArrayOf_sc_SortedSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_SortedSet)));
}
export { $isArrayOf_sc_SortedSet as $isArrayOf_sc_SortedSet };
function $f_Lcats_MonadError__redeemWith__O__F1__F1__O($thiz, fa, recover, bind) {
  return $thiz.flatMap__O__F1__O($thiz.attempt__O__O(fa), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$3) => _$3.fold__F1__F1__O(recover, bind))));
}
export { $f_Lcats_MonadError__redeemWith__O__F1__F1__O as $f_Lcats_MonadError__redeemWith__O__F1__F1__O };
/** @constructor */
function $c_Lcats_data_IndexedStateTMonad() {
}
export { $c_Lcats_data_IndexedStateTMonad as $c_Lcats_data_IndexedStateTMonad };
$c_Lcats_data_IndexedStateTMonad.prototype = new $h_Lcats_data_IndexedStateTFunctor();
$c_Lcats_data_IndexedStateTMonad.prototype.constructor = $c_Lcats_data_IndexedStateTMonad;
/** @constructor */
function $h_Lcats_data_IndexedStateTMonad() {
}
export { $h_Lcats_data_IndexedStateTMonad as $h_Lcats_data_IndexedStateTMonad };
$h_Lcats_data_IndexedStateTMonad.prototype = $c_Lcats_data_IndexedStateTMonad.prototype;
$c_Lcats_data_IndexedStateTMonad.prototype.flatten__O__O = (function(ffa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_data_IndexedStateTMonad.prototype.ap__O__O__O = (function(ff, fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_data_IndexedStateTMonad.prototype.product__O__O__O = (function(fa, fb) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_data_IndexedStateTMonad.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_data_IndexedStateTMonad.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lcats_data_IndexedStateTMonad.prototype.productL__O__O__O = (function(fa, fb) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_data_IndexedStateTMonad.prototype.unit__O = (function() {
  var this$1 = $m_Lcats_data_IndexedStateT$();
  var F = this.Lcats_data_IndexedStateTInstances2$$anon$7__f_F0$3;
  return $f_Lcats_data_CommonStateTConstructors__pure__O__Lcats_Applicative__Lcats_data_IndexedStateT(this$1, (void 0), F);
});
$c_Lcats_data_IndexedStateTMonad.prototype.compose__Lcats_Applicative__Lcats_Applicative = (function(evidence$1) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Applicative$$anon$1(evidence$1, this);
});
$c_Lcats_data_IndexedStateTMonad.prototype.map__O__F1__O = (function(fa, f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_data_IndexedStateTMonad.prototype.tailRecM__O__F1__Lcats_data_IndexedStateT = (function(a, f) {
  return $m_Lcats_data_IndexedStateT$().apply__F1__Lcats_Applicative__Lcats_data_IndexedStateT(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s) => this.Lcats_data_IndexedStateTInstances2$$anon$7__f_F0$3.tailRecM__O__F1__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), s, a), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 !== null)) {
      var s$1 = x$1._1__O();
      var a$1 = x$1._2__O();
      return this.Lcats_data_IndexedStateTInstances2$$anon$7__f_F0$3.map__O__F1__O(f.apply__O__O(a$1).run__O__Lcats_FlatMap__O(s$1, this.Lcats_data_IndexedStateTInstances2$$anon$7__f_F0$3), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1$2) => {
        if ((x$1$2 !== null)) {
          var s$2 = x$1$2._1__O();
          var ab = x$1$2._2__O();
          if ((ab instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
            var b = ab.s_util_Right__f_value;
            var value = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), s$2, b);
            return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(value);
          }
          if ((ab instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
            var a$2 = ab.s_util_Left__f_value;
            var value$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), s$2, a$2);
            return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(value$1);
          }
          throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(ab);
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1$2);
      })));
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  }))))), this.Lcats_data_IndexedStateTInstances2$$anon$7__f_F0$3);
});
$c_Lcats_data_IndexedStateTMonad.prototype.pure__O__O = (function(x) {
  var this$1 = $m_Lcats_data_IndexedStateT$();
  var F = this.Lcats_data_IndexedStateTInstances2$$anon$7__f_F0$3;
  return $f_Lcats_data_CommonStateTConstructors__pure__O__Lcats_Applicative__Lcats_data_IndexedStateT(this$1, x, F);
});
$c_Lcats_data_IndexedStateTMonad.prototype.flatMap__O__F1__O = (function(fa, f) {
  return fa.flatMap__F1__Lcats_FlatMap__Lcats_data_IndexedStateT(f, this.Lcats_data_IndexedStateTInstances2$$anon$7__f_F0$3);
});
$c_Lcats_data_IndexedStateTMonad.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__Lcats_data_IndexedStateT(a, f);
});
/** @constructor */
function $c_Lcom_raquo_airstream_timing_SyncDelayStream(parent, after) {
  this.Lcom_raquo_airstream_timing_SyncDelayStream__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_timing_SyncDelayStream__f_isSafeToRemoveObserver = false;
  this.Lcom_raquo_airstream_timing_SyncDelayStream__f_maybePendingObserverRemovals = null;
  this.Lcom_raquo_airstream_timing_SyncDelayStream__f_externalObservers = null;
  this.Lcom_raquo_airstream_timing_SyncDelayStream__f_internalObservers = null;
  this.Lcom_raquo_airstream_timing_SyncDelayStream__f_willStartDone = false;
  this.Lcom_raquo_airstream_timing_SyncDelayStream__f_parent = null;
  this.Lcom_raquo_airstream_timing_SyncDelayStream__f_maybePendingValue = null;
  this.Lcom_raquo_airstream_timing_SyncDelayStream__f_topoRank = 0;
  this.Lcom_raquo_airstream_timing_SyncDelayStream__f_parent = parent;
  this.Lcom_raquo_airstream_timing_SyncDelayStream__f_maybeDisplayName = (void 0);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.Lcom_raquo_airstream_timing_SyncDelayStream__f_maybePendingValue = (void 0);
  var x = parent.topoRank__I();
  var that = after.topoRank__I();
  this.Lcom_raquo_airstream_timing_SyncDelayStream__f_topoRank = ((1 + ((x > that) ? x : that)) | 0);
}
export { $c_Lcom_raquo_airstream_timing_SyncDelayStream as $c_Lcom_raquo_airstream_timing_SyncDelayStream };
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype.constructor = $c_Lcom_raquo_airstream_timing_SyncDelayStream;
/** @constructor */
function $h_Lcom_raquo_airstream_timing_SyncDelayStream() {
}
export { $h_Lcom_raquo_airstream_timing_SyncDelayStream as $h_Lcom_raquo_airstream_timing_SyncDelayStream };
$h_Lcom_raquo_airstream_timing_SyncDelayStream.prototype = $c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype;
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_timing_SyncDelayStream__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_timing_SyncDelayStream__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype.defaultDisplayName__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype.isSafeToRemoveObserver__Z = (function() {
  return this.Lcom_raquo_airstream_timing_SyncDelayStream__f_isSafeToRemoveObserver;
});
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype.maybePendingObserverRemovals__O = (function() {
  return this.Lcom_raquo_airstream_timing_SyncDelayStream__f_maybePendingObserverRemovals;
});
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype.isSafeToRemoveObserver_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_timing_SyncDelayStream__f_isSafeToRemoveObserver = x$1;
});
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype.maybePendingObserverRemovals_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_timing_SyncDelayStream__f_maybePendingObserverRemovals = x$1;
});
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype.equals__O__Z = (function(obj) {
  return (this === obj);
});
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$systemIdentityHashCode(this);
});
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype.onAddedExternalObserver__Lcom_raquo_airstream_core_Observer__V = (function(observer) {
});
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype.toObservable__Lcom_raquo_airstream_core_EventStream = (function() {
  return this;
});
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype.externalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_timing_SyncDelayStream__f_externalObservers;
});
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype.internalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_timing_SyncDelayStream__f_internalObservers;
});
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype.willStartDone__Z = (function() {
  return this.Lcom_raquo_airstream_timing_SyncDelayStream__f_willStartDone;
});
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype.willStartDone_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_timing_SyncDelayStream__f_willStartDone = x$1;
});
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype.com$raquo$airstream$core$WritableObservable$_setter_$externalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_timing_SyncDelayStream__f_externalObservers = x$0;
});
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype.com$raquo$airstream$core$WritableObservable$_setter_$internalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_timing_SyncDelayStream__f_internalObservers = x$0;
});
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype.fireValue__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype.fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype.fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype.onWillStart__V = (function() {
  var observable = this.Lcom_raquo_airstream_timing_SyncDelayStream__f_parent;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(observable);
});
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype.onStart__V = (function() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_SingleParentStream__onStart__V(this);
});
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype.onStop__V = (function() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_SingleParentStream__onStop__V(this);
});
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype.onNext__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype.onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype.parent__Lcom_raquo_airstream_core_Observable = (function() {
  return this.Lcom_raquo_airstream_timing_SyncDelayStream__f_parent;
});
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype.topoRank__I = (function() {
  return this.Lcom_raquo_airstream_timing_SyncDelayStream__f_topoRank;
});
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype.onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  if ((!transaction.containsPendingObservable__Lcom_raquo_airstream_core_SyncObservable__Z(this))) {
    transaction.enqueuePendingObservable__Lcom_raquo_airstream_core_SyncObservable__V(this);
  }
  this.Lcom_raquo_airstream_timing_SyncDelayStream__f_maybePendingValue = nextValue;
});
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype.syncFire__Lcom_raquo_airstream_core_Transaction__V = (function(transaction) {
  var x = this.Lcom_raquo_airstream_timing_SyncDelayStream__f_maybePendingValue;
  if ((x !== (void 0))) {
    this.Lcom_raquo_airstream_timing_SyncDelayStream__f_maybePendingValue = (void 0);
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, x, transaction);
  }
});
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype.map__F1__Lcom_raquo_airstream_core_Observable = (function(project) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapStream(this, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype.distinctTry__F2__Lcom_raquo_airstream_core_Observable = (function(isSame) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype.toObservable__Lcom_raquo_airstream_core_Observable = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_timing_SyncDelayStream = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_timing_SyncDelayStream, "com.raquo.airstream.timing.SyncDelayStream", ({
  Lcom_raquo_airstream_timing_SyncDelayStream: 1,
  Lcom_raquo_airstream_core_Source: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_BaseObservable: 1,
  Lcom_raquo_airstream_core_Observable: 1,
  Lcom_raquo_airstream_core_Source$EventSource: 1,
  Lcom_raquo_airstream_dynamicImport_StreamDynamicImportOps: 1,
  Lcom_raquo_airstream_core_EventStream: 1,
  Lcom_raquo_airstream_core_WritableObservable: 1,
  Lcom_raquo_airstream_core_WritableStream: 1,
  Lcom_raquo_airstream_core_InternalObserver: 1,
  Lcom_raquo_airstream_common_SingleParentStream: 1,
  Lcom_raquo_airstream_common_InternalTryObserver: 1,
  Lcom_raquo_airstream_core_SyncObservable: 1
}));
export { $d_Lcom_raquo_airstream_timing_SyncDelayStream as $d_Lcom_raquo_airstream_timing_SyncDelayStream };
/** @constructor */
function $c_Lcats_data_IndexedStateTInstances2$$anon$7(F0$11) {
  this.Lcats_data_IndexedStateTInstances2$$anon$7__f_F0$3 = null;
  this.Lcats_data_IndexedStateTInstances2$$anon$7__f_F0$3 = F0$11;
}
export { $c_Lcats_data_IndexedStateTInstances2$$anon$7 as $c_Lcats_data_IndexedStateTInstances2$$anon$7 };
$c_Lcats_data_IndexedStateTInstances2$$anon$7.prototype = new $h_Lcats_data_IndexedStateTMonad();
$c_Lcats_data_IndexedStateTInstances2$$anon$7.prototype.constructor = $c_Lcats_data_IndexedStateTInstances2$$anon$7;
/** @constructor */
function $h_Lcats_data_IndexedStateTInstances2$$anon$7() {
}
export { $h_Lcats_data_IndexedStateTInstances2$$anon$7 as $h_Lcats_data_IndexedStateTInstances2$$anon$7 };
$h_Lcats_data_IndexedStateTInstances2$$anon$7.prototype = $c_Lcats_data_IndexedStateTInstances2$$anon$7.prototype;
var $d_Lcats_data_IndexedStateTInstances2$$anon$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_data_IndexedStateTInstances2$$anon$7, "cats.data.IndexedStateTInstances2$$anon$7", ({
  Lcats_data_IndexedStateTInstances2$$anon$7: 1,
  Lcats_data_IndexedStateTMonad: 1,
  Lcats_data_IndexedStateTFunctor: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_Monad: 1
}));
export { $d_Lcats_data_IndexedStateTInstances2$$anon$7 as $d_Lcats_data_IndexedStateTInstances2$$anon$7 };
/** @constructor */
function $c_Lcats_kernel_instances_ByteOrder() {
}
export { $c_Lcats_kernel_instances_ByteOrder as $c_Lcats_kernel_instances_ByteOrder };
$c_Lcats_kernel_instances_ByteOrder.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_kernel_instances_ByteOrder.prototype.constructor = $c_Lcats_kernel_instances_ByteOrder;
/** @constructor */
function $h_Lcats_kernel_instances_ByteOrder() {
}
export { $h_Lcats_kernel_instances_ByteOrder as $h_Lcats_kernel_instances_ByteOrder };
$h_Lcats_kernel_instances_ByteOrder.prototype = $c_Lcats_kernel_instances_ByteOrder.prototype;
$c_Lcats_kernel_instances_ByteOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_ByteOrder.prototype.toOrdering__s_math_Ordering = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_kernel_Order$$anon$1(this);
});
$c_Lcats_kernel_instances_ByteOrder.prototype.compare__B__B__I = (function(x, y) {
  return ((x < y) ? (-1) : ((x > y) ? 1 : 0));
});
$c_Lcats_kernel_instances_ByteOrder.prototype.eqv__B__B__Z = (function(x, y) {
  return (x === y);
});
$c_Lcats_kernel_instances_ByteOrder.prototype.neqv__B__B__Z = (function(x, y) {
  return (x !== y);
});
$c_Lcats_kernel_instances_ByteOrder.prototype.gt__B__B__Z = (function(x, y) {
  return (x > y);
});
$c_Lcats_kernel_instances_ByteOrder.prototype.lt__B__B__Z = (function(x, y) {
  return (x < y);
});
$c_Lcats_kernel_instances_ByteOrder.prototype.hash__O__I = (function(x) {
  var x$1 = (x | 0);
  return x$1;
});
$c_Lcats_kernel_instances_ByteOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__B__B__I((x | 0), (y | 0));
});
$c_Lcats_kernel_instances_ByteOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__B__B__Z((x | 0), (y | 0));
});
$c_Lcats_kernel_instances_ByteOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__B__B__Z((x | 0), (y | 0));
});
$c_Lcats_kernel_instances_ByteOrder.prototype.gt__O__O__Z = (function(x, y) {
  return this.gt__B__B__Z((x | 0), (y | 0));
});
$c_Lcats_kernel_instances_ByteOrder.prototype.lt__O__O__Z = (function(x, y) {
  return this.lt__B__B__Z((x | 0), (y | 0));
});
var $d_Lcats_kernel_instances_ByteOrder = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_kernel_instances_ByteOrder, "cats.kernel.instances.ByteOrder", ({
  Lcats_kernel_instances_ByteOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_ByteBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_instances_ByteEnumerable: 1
}));
export { $d_Lcats_kernel_instances_ByteOrder as $d_Lcats_kernel_instances_ByteOrder };
/** @constructor */
function $c_Lcats_kernel_instances_ShortOrder() {
}
export { $c_Lcats_kernel_instances_ShortOrder as $c_Lcats_kernel_instances_ShortOrder };
$c_Lcats_kernel_instances_ShortOrder.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_kernel_instances_ShortOrder.prototype.constructor = $c_Lcats_kernel_instances_ShortOrder;
/** @constructor */
function $h_Lcats_kernel_instances_ShortOrder() {
}
export { $h_Lcats_kernel_instances_ShortOrder as $h_Lcats_kernel_instances_ShortOrder };
$h_Lcats_kernel_instances_ShortOrder.prototype = $c_Lcats_kernel_instances_ShortOrder.prototype;
$c_Lcats_kernel_instances_ShortOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_ShortOrder.prototype.toOrdering__s_math_Ordering = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_kernel_Order$$anon$1(this);
});
$c_Lcats_kernel_instances_ShortOrder.prototype.compare__S__S__I = (function(x, y) {
  return ((x < y) ? (-1) : ((x > y) ? 1 : 0));
});
$c_Lcats_kernel_instances_ShortOrder.prototype.eqv__S__S__Z = (function(x, y) {
  return (x === y);
});
$c_Lcats_kernel_instances_ShortOrder.prototype.neqv__S__S__Z = (function(x, y) {
  return (x !== y);
});
$c_Lcats_kernel_instances_ShortOrder.prototype.gt__S__S__Z = (function(x, y) {
  return (x > y);
});
$c_Lcats_kernel_instances_ShortOrder.prototype.lt__S__S__Z = (function(x, y) {
  return (x < y);
});
$c_Lcats_kernel_instances_ShortOrder.prototype.hash__O__I = (function(x) {
  var x$1 = (x | 0);
  return x$1;
});
$c_Lcats_kernel_instances_ShortOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__S__S__I((x | 0), (y | 0));
});
$c_Lcats_kernel_instances_ShortOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__S__S__Z((x | 0), (y | 0));
});
$c_Lcats_kernel_instances_ShortOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__S__S__Z((x | 0), (y | 0));
});
$c_Lcats_kernel_instances_ShortOrder.prototype.gt__O__O__Z = (function(x, y) {
  return this.gt__S__S__Z((x | 0), (y | 0));
});
$c_Lcats_kernel_instances_ShortOrder.prototype.lt__O__O__Z = (function(x, y) {
  return this.lt__S__S__Z((x | 0), (y | 0));
});
var $d_Lcats_kernel_instances_ShortOrder = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_kernel_instances_ShortOrder, "cats.kernel.instances.ShortOrder", ({
  Lcats_kernel_instances_ShortOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_ShortBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_instances_ShortEnumerable: 1
}));
export { $d_Lcats_kernel_instances_ShortOrder as $d_Lcats_kernel_instances_ShortOrder };
/** @constructor */
function $c_Lcats_kernel_instances_UnitOrder() {
}
export { $c_Lcats_kernel_instances_UnitOrder as $c_Lcats_kernel_instances_UnitOrder };
$c_Lcats_kernel_instances_UnitOrder.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_kernel_instances_UnitOrder.prototype.constructor = $c_Lcats_kernel_instances_UnitOrder;
/** @constructor */
function $h_Lcats_kernel_instances_UnitOrder() {
}
export { $h_Lcats_kernel_instances_UnitOrder as $h_Lcats_kernel_instances_UnitOrder };
$h_Lcats_kernel_instances_UnitOrder.prototype = $c_Lcats_kernel_instances_UnitOrder.prototype;
$c_Lcats_kernel_instances_UnitOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_UnitOrder.prototype.toOrdering__s_math_Ordering = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_kernel_Order$$anon$1(this);
});
$c_Lcats_kernel_instances_UnitOrder.prototype.compare__O__O__I = (function(x, y) {
  return 0;
});
$c_Lcats_kernel_instances_UnitOrder.prototype.hash__O__I = (function(x) {
  return 0;
});
$c_Lcats_kernel_instances_UnitOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return true;
});
$c_Lcats_kernel_instances_UnitOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return false;
});
$c_Lcats_kernel_instances_UnitOrder.prototype.gt__O__O__Z = (function(x, y) {
  return false;
});
$c_Lcats_kernel_instances_UnitOrder.prototype.lt__O__O__Z = (function(x, y) {
  return false;
});
var $d_Lcats_kernel_instances_UnitOrder = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_kernel_instances_UnitOrder, "cats.kernel.instances.UnitOrder", ({
  Lcats_kernel_instances_UnitOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_UnitBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_instances_UnitEnumerable: 1
}));
export { $d_Lcats_kernel_instances_UnitOrder as $d_Lcats_kernel_instances_UnitOrder };
/** @constructor */
function $c_Lfs2_PullMonadErrorInstance() {
}
export { $c_Lfs2_PullMonadErrorInstance as $c_Lfs2_PullMonadErrorInstance };
$c_Lfs2_PullMonadErrorInstance.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_PullMonadErrorInstance.prototype.constructor = $c_Lfs2_PullMonadErrorInstance;
/** @constructor */
function $h_Lfs2_PullMonadErrorInstance() {
}
export { $h_Lfs2_PullMonadErrorInstance as $h_Lfs2_PullMonadErrorInstance };
$h_Lfs2_PullMonadErrorInstance.prototype = $c_Lfs2_PullMonadErrorInstance.prototype;
$c_Lfs2_PullMonadErrorInstance.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lfs2_PullMonadErrorInstance.prototype.void__O__O = (function(fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lfs2_PullMonadErrorInstance.prototype.as__O__O__O = (function(fa, b) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lfs2_PullMonadErrorInstance.prototype.compose__Lcats_Applicative__Lcats_Applicative = (function(evidence$1) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Applicative$$anon$1(evidence$1, this);
});
$c_Lfs2_PullMonadErrorInstance.prototype.attempt__O__O = (function(fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_ApplicativeError__attempt__O__O(this, fa);
});
$c_Lfs2_PullMonadErrorInstance.prototype.flatten__O__O = (function(ffa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lfs2_PullMonadErrorInstance.prototype.ap__O__O__O = (function(ff, fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lfs2_PullMonadErrorInstance.prototype.product__O__O__O = (function(fa, fb) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lfs2_PullMonadErrorInstance.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lfs2_PullMonadErrorInstance.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lfs2_PullMonadErrorInstance.prototype.productR__O__O__O = (function(fa, fb) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lfs2_PullMonadErrorInstance.prototype.productL__O__O__O = (function(fa, fb) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lfs2_PullMonadErrorInstance.prototype.map__O__F1__O = (function(fa, f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lfs2_PullMonadErrorInstance.prototype.tailRecM__O__F1__Lfs2_Pull = (function(a, f) {
  var this$4 = f.apply__O__O(a);
  var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
      var a$1 = x$1.s_util_Left__f_value;
      return this.tailRecM__O__F1__Lfs2_Pull(a$1, f);
    }
    if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
      var b = x$1.s_util_Right__f_value;
      $m_Lfs2_Pull$();
      return new $c_Lfs2_Pull$Succeeded(b);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  }));
  return new $c_Lfs2_Pull$$anon$1(f$1, this$4);
});
$c_Lfs2_PullMonadErrorInstance.prototype.pure__O__O = (function(x) {
  $m_Lfs2_Pull$();
  return new $c_Lfs2_Pull$Succeeded(x);
});
$c_Lfs2_PullMonadErrorInstance.prototype.flatMap__O__F1__O = (function(fa, f) {
  return new $c_Lfs2_Pull$$anon$1(f, fa);
});
$c_Lfs2_PullMonadErrorInstance.prototype.unit__O = (function() {
  return $m_Lfs2_Pull$().Lfs2_Pull$__f_done;
});
$c_Lfs2_PullMonadErrorInstance.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__Lfs2_Pull(a, f);
});
$c_Lfs2_PullMonadErrorInstance.prototype.raiseError__O__O = (function(e) {
  $m_Lfs2_Pull$();
  return new $c_Lfs2_Pull$Fail(e);
});
$c_Lfs2_PullMonadErrorInstance.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  return new $c_Lfs2_Pull$$anon$3(f, fa);
});
var $d_Lfs2_PullMonadErrorInstance = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_PullMonadErrorInstance, "fs2.PullMonadErrorInstance", ({
  Lfs2_PullMonadErrorInstance: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1
}));
export { $d_Lfs2_PullMonadErrorInstance as $d_Lfs2_PullMonadErrorInstance };
function $is_sc_BitSet(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_BitSet)));
}
export { $is_sc_BitSet as $is_sc_BitSet };
function $isArrayOf_sc_BitSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_BitSet)));
}
export { $isArrayOf_sc_BitSet as $isArrayOf_sc_BitSet };
function $f_sc_SortedMap__equals__O__Z($thiz, that) {
  if (($thiz === that)) {
    return true;
  }
  if ($is_sc_SortedMap(that)) {
    var x = that.sci_TreeMap__f_ordering;
    var x$2 = $thiz.sci_TreeMap__f_ordering;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      if (($m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I($thiz.sci_TreeMap__f_tree) === $m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(that.sci_TreeMap__f_tree))) {
        var tree = $thiz.sci_TreeMap__f_tree;
        var start = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        var evidence$16 = $thiz.sci_TreeMap__f_ordering;
        var i1 = new $c_sci_RedBlackTree$EntriesIterator(tree, start, evidence$16);
        var tree$1 = that.sci_TreeMap__f_tree;
        var start$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        var evidence$16$1 = that.sci_TreeMap__f_ordering;
        var i2 = new $c_sci_RedBlackTree$EntriesIterator(tree$1, start$1, evidence$16$1);
        var allEqual = true;
        while ((allEqual && i1.hasNext__Z())) {
          var kv1 = i1.next__O();
          var kv2 = i2.next__O();
          allEqual = ($thiz.sci_TreeMap__f_ordering.equiv__O__O__Z(kv1._1__O(), kv2._1__O()) && $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(kv1._2__O(), kv2._2__O()));
        }
        return allEqual;
      } else {
        return false;
      }
    }
  }
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_Map__equals__O__Z($thiz, that);
}
export { $f_sc_SortedMap__equals__O__Z as $f_sc_SortedMap__equals__O__Z };
function $is_sc_SortedMap(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_SortedMap)));
}
export { $is_sc_SortedMap as $is_sc_SortedMap };
function $isArrayOf_sc_SortedMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_SortedMap)));
}
export { $isArrayOf_sc_SortedMap as $isArrayOf_sc_SortedMap };
/** @constructor */
function $c_Lcats_instances_SortedMapInstances$$anon$2() {
}
export { $c_Lcats_instances_SortedMapInstances$$anon$2 as $c_Lcats_instances_SortedMapInstances$$anon$2 };
$c_Lcats_instances_SortedMapInstances$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_SortedMapInstances$$anon$2.prototype.constructor = $c_Lcats_instances_SortedMapInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_SortedMapInstances$$anon$2() {
}
export { $h_Lcats_instances_SortedMapInstances$$anon$2 as $h_Lcats_instances_SortedMapInstances$$anon$2 };
$h_Lcats_instances_SortedMapInstances$$anon$2.prototype = $c_Lcats_instances_SortedMapInstances$$anon$2.prototype;
$c_Lcats_instances_SortedMapInstances$$anon$2.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return this.map__sci_SortedMap__F1__sci_SortedMap(fa, f);
});
$c_Lcats_instances_SortedMapInstances$$anon$2.prototype.void__O__O = (function(fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_instances_SortedMapInstances$$anon$2.prototype.as__O__O__O = (function(fa, b) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_instances_SortedMapInstances$$anon$2.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Foldable__foldMap__O__F1__Lcats_kernel_Monoid__O(this, fa, f, B);
});
$c_Lcats_instances_SortedMapInstances$$anon$2.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Foldable__foldM__O__O__F2__Lcats_Monad__O(this, fa, z, f, G);
});
$c_Lcats_instances_SortedMapInstances$$anon$2.prototype.traverseVoid__O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Foldable__traverseVoid__O__F1__Lcats_Applicative__O(this, fa, f, G);
});
$c_Lcats_instances_SortedMapInstances$$anon$2.prototype.exists__O__F1__Z = (function(fa, p) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Foldable__exists__O__F1__Z(this, fa, p);
});
$c_Lcats_instances_SortedMapInstances$$anon$2.prototype.unorderedFoldMap__O__F1__Lcats_kernel_CommutativeMonoid__O = (function(fa, f, evidence$1) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Foldable__foldMap__O__F1__Lcats_kernel_Monoid__O(this, fa, f, evidence$1);
});
$c_Lcats_instances_SortedMapInstances$$anon$2.prototype.flatten__O__O = (function(ffa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_instances_SortedMapInstances$$anon$2.prototype.ap__O__O__O = (function(ff, fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_instances_SortedMapInstances$$anon$2.prototype.product__O__O__O = (function(fa, fb) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_instances_SortedMapInstances$$anon$2.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_instances_SortedMapInstances$$anon$2.prototype.traverse__sci_SortedMap__F1__Lcats_Applicative__O = (function(fa, f, G) {
  var ordering = fa.sci_TreeMap__f_ordering;
  if (fa.isEmpty__Z()) {
    return G.pure__O__O($m_sci_SortedMap$().empty__s_math_Ordering__O(ordering));
  } else {
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_Chain$();
    var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_scm_ArrayBuffer$();
    var elems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T2.getArrayOf().constr)([]));
    var as = this$1.from__sc_IterableOnce__scm_ArrayBuffer(elems);
    as.addAll__sc_IterableOnce__scm_ArrayBuffer(fa);
    return G.map__O__F1__O($x_1.traverseViaChain__sci_IndexedSeq__F1__Lcats_Applicative__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq(as), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
      if ((x$1 !== null)) {
        var k = x$1._1__O();
        var a = x$1._2__O();
        return G.map__O__F1__O(f.apply__O__O(a), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$9) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), k, _$9))));
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), G), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((chain) => {
      var z = $m_sci_SortedMap$().empty__s_math_Ordering__O(ordering);
      var result = z;
      var iter = chain.iterator__sc_Iterator();
      while (iter.hasNext__Z()) {
        var x0 = result;
        var x1 = iter.next__O();
        matchResult3: {
          var x7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), x0, x1);
          var x9 = x7.T2__f__2;
          var m = x7.T2__f__1;
          if ((x9 !== null)) {
            var k$1 = x9._1__O();
            var b = x9._2__O();
            result = m.updated__O__O__sci_TreeMap(k$1, b);
            break matchResult3;
          }
          throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x7);
        }
      }
      return result;
    })));
  }
});
$c_Lcats_instances_SortedMapInstances$$anon$2.prototype.flatMap__sci_SortedMap__F1__sci_SortedMap = (function(fa, f) {
  var ordering = fa.sci_TreeMap__f_ordering;
  var b = new $c_sci_TreeMap$TreeMapBuilder(ordering);
  var tree = fa.sci_TreeMap__f_tree;
  var start = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var evidence$16 = fa.sci_TreeMap__f_ordering;
  var it = new $c_sci_RedBlackTree$EntriesIterator(tree, start, evidence$16);
  while (it.hasNext__Z()) {
    var x0 = it.next__O();
    matchResult4: {
      var elems;
      if ((x0 !== null)) {
        var k = x0._1__O();
        var a = x0._2__O();
        var this$4 = f.apply__O__O(a).get__O__s_Option(k);
        if (this$4.isEmpty__Z()) {
          var elems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
          break matchResult4;
        } else {
          var x0$1 = this$4.get__O();
          var elems = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), k, x0$1));
          break matchResult4;
        }
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x0);
    }
    b.addAll__sc_IterableOnce__sci_TreeMap$TreeMapBuilder(elems);
  }
  return b.result__sci_TreeMap();
});
$c_Lcats_instances_SortedMapInstances$$anon$2.prototype.map__sci_SortedMap__F1__sci_SortedMap = (function(fa, f) {
  var ordering = fa.sci_TreeMap__f_ordering;
  var b = new $c_sci_TreeMap$TreeMapBuilder(ordering);
  var tree = fa.sci_TreeMap__f_tree;
  var start = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var evidence$16 = fa.sci_TreeMap__f_ordering;
  var it = new $c_sci_RedBlackTree$EntriesIterator(tree, start, evidence$16);
  while (it.hasNext__Z()) {
    var x0 = it.next__O();
    matchResult5: {
      var elem___1;
      var elem___2;
      if ((x0 !== null)) {
        var k = x0._1__O();
        var a = x0._2__O();
        var _2 = f.apply__O__O(a);
        var elem___1 = k;
        var elem___2 = _2;
        break matchResult5;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x0);
    }
    b.sci_TreeMap$TreeMapBuilder__f_scala$collection$immutable$TreeMap$TreeMapBuilder$$tree = b.mutableUpd__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree(b.sci_TreeMap$TreeMapBuilder__f_scala$collection$immutable$TreeMap$TreeMapBuilder$$tree, elem___1, elem___2);
  }
  return b.result__sci_TreeMap();
});
$c_Lcats_instances_SortedMapInstances$$anon$2.prototype.map2Eval__sci_SortedMap__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  if (fa.isEmpty__Z()) {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Eval$();
    var a = $m_sci_SortedMap$().empty__s_math_Ordering__O(fa.sci_TreeMap__f_ordering);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Now(a);
  } else {
    return fb.map__F1__Lcats_Eval(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((fb$2) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb$2, f))));
  }
});
$c_Lcats_instances_SortedMapInstances$$anon$2.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__sci_SortedMap__F1__Lcats_Applicative__O(fa, f, evidence$1);
});
$c_Lcats_instances_SortedMapInstances$$anon$2.prototype.flatMap__O__F1__O = (function(fa, f) {
  return this.flatMap__sci_SortedMap__F1__sci_SortedMap(fa, f);
});
$c_Lcats_instances_SortedMapInstances$$anon$2.prototype.map__O__F1__O = (function(fa, f) {
  return this.map__sci_SortedMap__F1__sci_SortedMap(fa, f);
});
$c_Lcats_instances_SortedMapInstances$$anon$2.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__sci_SortedMap__Lcats_Eval__F2__Lcats_Eval(fa, fb, f);
});
$c_Lcats_instances_SortedMapInstances$$anon$2.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  var this$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapOps$$anon$3(fa);
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__foldLeft__O__F2__O(this$1, b, f);
});
$c_Lcats_instances_SortedMapInstances$$anon$2.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Foldable$().iterateRight__sc_Iterable__Lcats_Eval__F2__Lcats_Eval(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapOps$$anon$1(fa), lb, f);
});
$c_Lcats_instances_SortedMapInstances$$anon$2.prototype.size__O__J = (function(fa) {
  var value = $m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(fa.sci_TreeMap__f_tree);
  var hi = (value >> 31);
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(value, hi);
});
$c_Lcats_instances_SortedMapInstances$$anon$2.prototype.toList__O__sci_List = (function(fa) {
  var this$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapOps$$anon$1(fa);
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$1);
});
$c_Lcats_instances_SortedMapInstances$$anon$2.prototype.toIterable__O__sc_Iterable = (function(fa) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapOps$$anon$1(fa);
});
var $d_Lcats_instances_SortedMapInstances$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_SortedMapInstances$$anon$2, "cats.instances.SortedMapInstances$$anon$2", ({
  Lcats_instances_SortedMapInstances$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Align: 1
}));
export { $d_Lcats_instances_SortedMapInstances$$anon$2 as $d_Lcats_instances_SortedMapInstances$$anon$2 };
function $ps_Lcom_raquo_airstream_state_ObservedSignal__ObservedSignal$superArg$1__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_core_Observer__Lcom_raquo_airstream_ownership_Owner__F1(parent, observer, owner) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x) => x));
}
export { $ps_Lcom_raquo_airstream_state_ObservedSignal__ObservedSignal$superArg$1__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_core_Observer__Lcom_raquo_airstream_ownership_Owner__F1 as $ps_Lcom_raquo_airstream_state_ObservedSignal__ObservedSignal$superArg$1__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_core_Observer__Lcom_raquo_airstream_ownership_Owner__F1 };
/** @constructor */
function $c_Lcom_raquo_airstream_state_ObservedSignal(parent, observer, owner) {
  this.Lcom_raquo_airstream_misc_MapSignal__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_misc_MapSignal__f_isSafeToRemoveObserver = false;
  this.Lcom_raquo_airstream_misc_MapSignal__f_maybePendingObserverRemovals = null;
  this.Lcom_raquo_airstream_misc_MapSignal__f__lastUpdateId = 0;
  this.Lcom_raquo_airstream_misc_MapSignal__f_externalObservers = null;
  this.Lcom_raquo_airstream_misc_MapSignal__f_internalObservers = null;
  this.Lcom_raquo_airstream_misc_MapSignal__f_willStartDone = false;
  this.Lcom_raquo_airstream_misc_MapSignal__f_maybeLastSeenCurrentValue = null;
  this.Lcom_raquo_airstream_misc_MapSignal__f_parentIsSignal = false;
  this.Lcom_raquo_airstream_misc_MapSignal__f__parentLastUpdateId = 0;
  this.Lcom_raquo_airstream_misc_MapSignal__f_parent = null;
  this.Lcom_raquo_airstream_misc_MapSignal__f_project = null;
  this.Lcom_raquo_airstream_misc_MapSignal__f_recover = null;
  this.Lcom_raquo_airstream_misc_MapSignal__f_topoRank = 0;
  this.Lcom_raquo_airstream_state_ObservedSignal__f_parent = null;
  this.Lcom_raquo_airstream_state_ObservedSignal__f_parent = parent;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(this, parent, $ps_Lcom_raquo_airstream_state_ObservedSignal__ObservedSignal$superArg$1__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_core_Observer__Lcom_raquo_airstream_ownership_Owner__F1(parent, observer, owner), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableObservable__addObserver__Lcom_raquo_airstream_core_Observer__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(this, observer, owner);
}
export { $c_Lcom_raquo_airstream_state_ObservedSignal as $c_Lcom_raquo_airstream_state_ObservedSignal };
$c_Lcom_raquo_airstream_state_ObservedSignal.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_Lcom_raquo_airstream_misc_MapSignal();
$c_Lcom_raquo_airstream_state_ObservedSignal.prototype.constructor = $c_Lcom_raquo_airstream_state_ObservedSignal;
/** @constructor */
function $h_Lcom_raquo_airstream_state_ObservedSignal() {
}
export { $h_Lcom_raquo_airstream_state_ObservedSignal as $h_Lcom_raquo_airstream_state_ObservedSignal };
$h_Lcom_raquo_airstream_state_ObservedSignal.prototype = $c_Lcom_raquo_airstream_state_ObservedSignal.prototype;
$c_Lcom_raquo_airstream_state_ObservedSignal.prototype.tryNow__s_util_Try = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
});
$c_Lcom_raquo_airstream_state_ObservedSignal.prototype.parent__Lcom_raquo_airstream_core_Signal = (function() {
  return this.Lcom_raquo_airstream_state_ObservedSignal__f_parent;
});
$c_Lcom_raquo_airstream_state_ObservedSignal.prototype.defaultDisplayName__T = (function() {
  return (($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_Named__displayName__T(this.Lcom_raquo_airstream_state_ObservedSignal__f_parent) + ".observe@") + $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$systemIdentityHashCode(this));
});
$c_Lcom_raquo_airstream_state_ObservedSignal.prototype.parent__Lcom_raquo_airstream_core_Observable = (function() {
  return this.Lcom_raquo_airstream_state_ObservedSignal__f_parent;
});
var $d_Lcom_raquo_airstream_state_ObservedSignal = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcom_raquo_airstream_state_ObservedSignal, "com.raquo.airstream.state.ObservedSignal", ({
  Lcom_raquo_airstream_state_ObservedSignal: 1,
  Lcom_raquo_airstream_misc_MapSignal: 1,
  Lcom_raquo_airstream_core_Source: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_BaseObservable: 1,
  Lcom_raquo_airstream_core_Observable: 1,
  Lcom_raquo_airstream_core_Source$SignalSource: 1,
  Lcom_raquo_airstream_dynamicImport_SignalDynamicImportOps: 1,
  Lcom_raquo_airstream_core_Signal: 1,
  Lcom_raquo_airstream_core_WritableObservable: 1,
  Lcom_raquo_airstream_core_WritableSignal: 1,
  Lcom_raquo_airstream_core_InternalObserver: 1,
  Lcom_raquo_airstream_common_InternalTryObserver: 1,
  Lcom_raquo_airstream_common_SingleParentSignal: 1,
  Lcom_raquo_airstream_state_StrictSignal: 1,
  Lcom_raquo_airstream_state_OwnedSignal: 1
}));
export { $d_Lcom_raquo_airstream_state_ObservedSignal as $d_Lcom_raquo_airstream_state_ObservedSignal };
function $f_Lfs2_Compiler$Target__compile__Lfs2_Pull__O__F2__O($thiz, p, init, foldChunk) {
  return $m_Lcats_effect_kernel_Resource$().makeCase__O__F2__Lcats_Functor__Lcats_effect_kernel_Resource($m_Lfs2_internal_Scope$().newRoot__Lfs2_Compiler$Target__O($thiz), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((scope, ec) => {
    var fea = scope.close__Lcats_effect_kernel_Resource$ExitCase__O(ec);
    $thiz.F__Lcats_effect_kernel_MonadCancel();
    return $m_Lcats_syntax_MonadErrorRethrowOps$().rethrow$extension__O__Lcats_MonadError__O(fea, $thiz.F__Lcats_effect_kernel_MonadCancel());
  })), $thiz.F__Lcats_effect_kernel_MonadCancel()).use__F1__Lcats_effect_kernel_MonadCancel__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((scope$2) => $m_Lfs2_Pull$().compile__Lfs2_Pull__Lfs2_internal_Scope__Z__O__F2__Lcats_MonadError__O(p, scope$2, false, init, foldChunk, $thiz.F__Lcats_effect_kernel_MonadCancel()))), $thiz.F__Lcats_effect_kernel_MonadCancel());
}
export { $f_Lfs2_Compiler$Target__compile__Lfs2_Pull__O__F2__O as $f_Lfs2_Compiler$Target__compile__Lfs2_Pull__O__F2__O };
/** @constructor */
function $c_Lsttp_tapir_Endpoint(securityInput, input, errorOutput, output, info) {
  this.Lsttp_tapir_Endpoint__f_showShort$lzy1 = null;
  this.Lsttp_tapir_Endpoint__f_showShortbitmap$1 = false;
  this.Lsttp_tapir_Endpoint__f_method$lzy1 = null;
  this.Lsttp_tapir_Endpoint__f_methodbitmap$1 = false;
  this.Lsttp_tapir_Endpoint__f_securityInput = null;
  this.Lsttp_tapir_Endpoint__f_input = null;
  this.Lsttp_tapir_Endpoint__f_errorOutput = null;
  this.Lsttp_tapir_Endpoint__f_output = null;
  this.Lsttp_tapir_Endpoint__f_info = null;
  this.Lsttp_tapir_Endpoint__f_securityInput = securityInput;
  this.Lsttp_tapir_Endpoint__f_input = input;
  this.Lsttp_tapir_Endpoint__f_errorOutput = errorOutput;
  this.Lsttp_tapir_Endpoint__f_output = output;
  this.Lsttp_tapir_Endpoint__f_info = info;
}
export { $c_Lsttp_tapir_Endpoint as $c_Lsttp_tapir_Endpoint };
$c_Lsttp_tapir_Endpoint.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_Endpoint.prototype.constructor = $c_Lsttp_tapir_Endpoint;
/** @constructor */
function $h_Lsttp_tapir_Endpoint() {
}
export { $h_Lsttp_tapir_Endpoint as $h_Lsttp_tapir_Endpoint };
$h_Lsttp_tapir_Endpoint.prototype = $c_Lsttp_tapir_Endpoint.prototype;
$c_Lsttp_tapir_Endpoint.prototype.showShort__T = (function() {
  if ((!this.Lsttp_tapir_Endpoint__f_showShortbitmap$1)) {
    this.Lsttp_tapir_Endpoint__f_showShort$lzy1 = $f_Lsttp_tapir_EndpointMetaOps__showShort__T(this);
    this.Lsttp_tapir_Endpoint__f_showShortbitmap$1 = true;
  }
  return this.Lsttp_tapir_Endpoint__f_showShort$lzy1;
});
$c_Lsttp_tapir_Endpoint.prototype.method__s_Option = (function() {
  if ((!this.Lsttp_tapir_Endpoint__f_methodbitmap$1)) {
    this.Lsttp_tapir_Endpoint__f_method$lzy1 = $f_Lsttp_tapir_EndpointMetaOps__method__s_Option(this);
    this.Lsttp_tapir_Endpoint__f_methodbitmap$1 = true;
  }
  return this.Lsttp_tapir_Endpoint__f_method$lzy1;
});
$c_Lsttp_tapir_Endpoint.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_Endpoint.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 2056079477, true);
});
$c_Lsttp_tapir_Endpoint.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_Endpoint)) {
    var x = this.Lsttp_tapir_Endpoint__f_securityInput;
    var x$2 = x$0.Lsttp_tapir_Endpoint__f_securityInput;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lsttp_tapir_Endpoint__f_input;
      var x$4 = x$0.Lsttp_tapir_Endpoint__f_input;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.Lsttp_tapir_Endpoint__f_errorOutput;
      var x$6 = x$0.Lsttp_tapir_Endpoint__f_errorOutput;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.Lsttp_tapir_Endpoint__f_output;
      var x$8 = x$0.Lsttp_tapir_Endpoint__f_output;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : x$7.equals__O__Z(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$9 = this.Lsttp_tapir_Endpoint__f_info;
      var x$10 = x$0.Lsttp_tapir_Endpoint__f_info;
      return ((x$9 === null) ? (x$10 === null) : x$9.equals__O__Z(x$10));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_Endpoint.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_Endpoint.prototype.productArity__I = (function() {
  return 5;
});
$c_Lsttp_tapir_Endpoint.prototype.productPrefix__T = (function() {
  return "Endpoint";
});
$c_Lsttp_tapir_Endpoint.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsttp_tapir_Endpoint__f_securityInput;
      break;
    }
    case 1: {
      return this.Lsttp_tapir_Endpoint__f_input;
      break;
    }
    case 2: {
      return this.Lsttp_tapir_Endpoint__f_errorOutput;
      break;
    }
    case 3: {
      return this.Lsttp_tapir_Endpoint__f_output;
      break;
    }
    case 4: {
      return this.Lsttp_tapir_Endpoint__f_info;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_Endpoint.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "securityInput";
      break;
    }
    case 1: {
      return "input";
      break;
    }
    case 2: {
      return "errorOutput";
      break;
    }
    case 3: {
      return "output";
      break;
    }
    case 4: {
      return "info";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lsttp_tapir_Endpoint(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_Endpoint)));
}
export { $isArrayOf_Lsttp_tapir_Endpoint as $isArrayOf_Lsttp_tapir_Endpoint };
var $d_Lsttp_tapir_Endpoint = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_Endpoint, "sttp.tapir.Endpoint", ({
  Lsttp_tapir_Endpoint: 1,
  Lsttp_tapir_macros_EndpointSecurityInputsMacros: 1,
  Lsttp_tapir_EndpointSecurityInputsOps: 1,
  Lsttp_tapir_macros_EndpointInputsMacros: 1,
  Lsttp_tapir_EndpointInputsOps: 1,
  Lsttp_tapir_macros_EndpointErrorOutputsMacros: 1,
  Lsttp_tapir_EndpointErrorOutputsOps: 1,
  Lsttp_tapir_EndpointErrorOutputVariantsOps: 1,
  Lsttp_tapir_macros_EndpointOutputsMacros: 1,
  Lsttp_tapir_EndpointOutputsOps: 1,
  Lsttp_tapir_EndpointInfoOps: 1,
  Lsttp_tapir_EndpointMetaOps: 1,
  Lsttp_tapir_EndpointServerLogicOps: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_Endpoint as $d_Lsttp_tapir_Endpoint };
function $isArrayOf_Lsttp_tapir_EndpointIO$OneOfBody(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointIO$OneOfBody)));
}
export { $isArrayOf_Lsttp_tapir_EndpointIO$OneOfBody as $isArrayOf_Lsttp_tapir_EndpointIO$OneOfBody };
function $f_Lcats_effect_kernel_GenSpawn__raceOutcome__O__O__O($thiz, fa, fb) {
  var body = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((poll) => {
    var target = poll.apply__O__O(($m_Lcats_effect_IO$(), new $c_Lcats_effect_IO$RacePair(fa, fb)));
    var this$11 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, $thiz);
    var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
      if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
        var x7 = x$1.s_util_Left__f_value;
        if ((x7 !== null)) {
          var oc = x7._1__O();
          var f = x7._2__O();
          var target$1 = f.cancel__O();
          var this$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, $thiz);
          var b = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(oc);
          return this$7.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.as__O__O__O(this$7.Lcats_Functor$ToFunctorOps$$anon$5__f_self, b);
        }
      }
      if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
        var x3 = x$1.s_util_Right__f_value;
        if ((x3 !== null)) {
          var f$2 = x3._1__O();
          var oc$2 = x3._2__O();
          var target$2 = f$2.cancel__O();
          var this$10 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, $thiz);
          var b$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(oc$2);
          return this$10.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.as__O__O__O(this$10.Lcats_Functor$ToFunctorOps$$anon$5__f_self, b$1);
        }
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    }));
    return this$11.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$11.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
  }));
  return $m_Lcats_effect_IO$().uncancelable__F1__Lcats_effect_IO(body);
}
export { $f_Lcats_effect_kernel_GenSpawn__raceOutcome__O__O__O as $f_Lcats_effect_kernel_GenSpawn__raceOutcome__O__O__O };
function $f_Lcats_effect_kernel_GenSpawn__both__O__O__O($thiz, fa, fb) {
  var body = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((poll) => {
    var target = poll.apply__O__O(($m_Lcats_effect_IO$(), new $c_Lcats_effect_IO$RacePair(fa, fb)));
    var this$55 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, $thiz);
    var f$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((poll$2) => ((x$1) => {
      if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
        var x98 = x$1.s_util_Left__f_value;
        if ((x98 !== null)) {
          var oc = x98._1__O();
          var f = x98._2__O();
          if ((oc instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Succeeded)) {
            var x75 = oc.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
            var wrapped = poll$2.apply__O__O(f.join__O());
            var fin = f.cancel__O();
            var target$1 = new $c_Lcats_effect_IO$OnCancel(wrapped, fin);
            var this$19 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, $thiz);
            var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1$2) => {
              if ((x$1$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Succeeded)) {
                var x67 = x$1$2.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
                return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__product__O__O__O($thiz, x75, x67);
              }
              if ((x$1$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Errored)) {
                var x64 = x$1$2.Lcats_effect_kernel_Outcome$Errored__f_e;
                $m_Lcats_effect_IO$();
                return new $c_Lcats_effect_IO$Error(x64);
              }
              if ((x$1$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Canceled)) {
                var fa$1 = poll$2.apply__O__O(($m_Lcats_effect_IO$(), $m_Lcats_effect_IO$Canceled$()));
                var fb$1 = $f_Lcats_effect_kernel_Async__never__O($thiz);
                return fa$1.productR__Lcats_effect_IO__Lcats_effect_IO(fb$1);
              }
              throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1$2);
            }));
            return this$19.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$19.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
          }
          if ((oc instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Errored)) {
            var x72 = oc.Lcats_effect_kernel_Outcome$Errored__f_e;
            var fa$2 = f.cancel__O();
            $m_Lcats_effect_IO$();
            var fb$2 = new $c_Lcats_effect_IO$Error(x72);
            return fa$2.productR__Lcats_effect_IO__Lcats_effect_IO(fb$2);
          }
          if ((oc instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Canceled)) {
            var fa$3 = f.cancel__O();
            var fb$3 = poll$2.apply__O__O(($m_Lcats_effect_IO$(), $m_Lcats_effect_IO$Canceled$()));
            var fa$4 = fa$3.productR__Lcats_effect_IO__Lcats_effect_IO(fb$3);
            var fb$4 = $f_Lcats_effect_kernel_Async__never__O($thiz);
            return fa$4.productR__Lcats_effect_IO__Lcats_effect_IO(fb$4);
          }
          throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(oc);
        }
      }
      if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
        var x94 = x$1.s_util_Right__f_value;
        if ((x94 !== null)) {
          var f$2 = x94._1__O();
          var oc$2 = x94._2__O();
          if ((oc$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Succeeded)) {
            var x91 = oc$2.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
            var wrapped$1 = poll$2.apply__O__O(f$2.join__O());
            var fin$1 = f$2.cancel__O();
            var target$2 = new $c_Lcats_effect_IO$OnCancel(wrapped$1, fin$1);
            var this$44 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, $thiz);
            var f$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1$3) => {
              if ((x$1$3 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Succeeded)) {
                var x83 = x$1$3.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
                return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__product__O__O__O($thiz, x83, x91);
              }
              if ((x$1$3 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Errored)) {
                var x80 = x$1$3.Lcats_effect_kernel_Outcome$Errored__f_e;
                $m_Lcats_effect_IO$();
                return new $c_Lcats_effect_IO$Error(x80);
              }
              if ((x$1$3 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Canceled)) {
                var fa$5 = poll$2.apply__O__O(($m_Lcats_effect_IO$(), $m_Lcats_effect_IO$Canceled$()));
                var fb$5 = $f_Lcats_effect_kernel_Async__never__O($thiz);
                return fa$5.productR__Lcats_effect_IO__Lcats_effect_IO(fb$5);
              }
              throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1$3);
            }));
            return this$44.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$44.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
          }
          if ((oc$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Errored)) {
            var x88 = oc$2.Lcats_effect_kernel_Outcome$Errored__f_e;
            var fa$6 = f$2.cancel__O();
            $m_Lcats_effect_IO$();
            var fb$6 = new $c_Lcats_effect_IO$Error(x88);
            return fa$6.productR__Lcats_effect_IO__Lcats_effect_IO(fb$6);
          }
          if ((oc$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_effect_kernel_Outcome$Canceled)) {
            var fa$7 = f$2.cancel__O();
            var fb$7 = poll$2.apply__O__O(($m_Lcats_effect_IO$(), $m_Lcats_effect_IO$Canceled$()));
            var fa$8 = fa$7.productR__Lcats_effect_IO__Lcats_effect_IO(fb$7);
            var fb$8 = $f_Lcats_effect_kernel_Async__never__O($thiz);
            return fa$8.productR__Lcats_effect_IO__Lcats_effect_IO(fb$8);
          }
          throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(oc$2);
        }
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    }))(poll));
    return this$55.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$55.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$4);
  }));
  return $m_Lcats_effect_IO$().uncancelable__F1__Lcats_effect_IO(body);
}
export { $f_Lcats_effect_kernel_GenSpawn__both__O__O__O as $f_Lcats_effect_kernel_GenSpawn__both__O__O__O };
/** @constructor */
function $c_Lfs2_Compiler$Target$ConcurrentTarget(F0) {
  this.Lfs2_Compiler$Target$ConcurrentTarget__f_F0 = null;
  this.Lfs2_Compiler$Target$ConcurrentTarget__f_F = null;
  this.Lfs2_Compiler$Target$ConcurrentTarget__f_F0 = F0;
  this.Lfs2_Compiler$Target$ConcurrentTarget__f_F = F0;
}
export { $c_Lfs2_Compiler$Target$ConcurrentTarget as $c_Lfs2_Compiler$Target$ConcurrentTarget };
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.constructor = $c_Lfs2_Compiler$Target$ConcurrentTarget;
/** @constructor */
function $h_Lfs2_Compiler$Target$ConcurrentTarget() {
}
export { $h_Lfs2_Compiler$Target$ConcurrentTarget as $h_Lfs2_Compiler$Target$ConcurrentTarget };
$h_Lfs2_Compiler$Target$ConcurrentTarget.prototype = $c_Lfs2_Compiler$Target$ConcurrentTarget.prototype;
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.void__O__O = (function(fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.as__O__O__O = (function(fa, b) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.unit__O = (function() {
  return this.Lfs2_Compiler$Target$ConcurrentTarget__f_F.pure__O__O((void 0));
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.compose__Lcats_Applicative__Lcats_Applicative = (function(evidence$1) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Applicative$$anon$1(evidence$1, this);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.handleError__O__F1__O = (function(fa, f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.attempt__O__O = (function(fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_ApplicativeError__attempt__O__O(this, fa);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.onError__O__s_PartialFunction__O = (function(fa, pf) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_ApplicativeError__onError__O__s_PartialFunction__O(this, fa, pf);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.flatten__O__O = (function(ffa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.ap__O__O__O = (function(ff, fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.product__O__O__O = (function(fa, fb) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.productR__O__O__O = (function(fa, fb) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.productL__O__O__O = (function(fa, fb) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.map__O__F1__O = (function(fa, f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.guaranteeCase__O__F1__O = (function(fa, fin) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_effect_kernel_MonadCancel__guaranteeCase__O__F1__O(this, fa, fin);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.bracketFull__F1__F1__F2__O = (function(acquire, use, release) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_effect_kernel_MonadCancel__bracketFull__F1__F1__F2__O(this, acquire, use, release);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.pure__O__O = (function(a) {
  return this.Lfs2_Compiler$Target$ConcurrentTarget__f_F.pure__O__O(a);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  return this.Lfs2_Compiler$Target$ConcurrentTarget__f_F.handleErrorWith__O__F1__O(fa, f);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.flatMap__O__F1__O = (function(fa, f) {
  return this.Lfs2_Compiler$Target$ConcurrentTarget__f_F.flatMap__O__F1__O(fa, f);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.Lfs2_Compiler$Target$ConcurrentTarget__f_F.tailRecM__O__F1__O(a, f);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.uncancelable__F1__O = (function(f) {
  return this.Lfs2_Compiler$Target$ConcurrentTarget__f_F.uncancelable__F1__O(f);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.onCancel__O__O__O = (function(fa, fin) {
  return this.Lfs2_Compiler$Target$ConcurrentTarget__f_F.onCancel__O__O__O(fa, fin);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.F__Lcats_effect_kernel_MonadCancel = (function() {
  return this.Lfs2_Compiler$Target$ConcurrentTarget__f_F;
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.unique__O = (function() {
  var F = this.Lfs2_Compiler$Target$ConcurrentTarget__f_F0;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_effect_kernel_Sync__unique__O(F);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.ref__O__O = (function(a) {
  return $m_Lcats_effect_IO$().ref__O__Lcats_effect_IO(a);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.interruptContext__Lcats_effect_kernel_Unique$Token__s_Option = (function(root) {
  var value = $m_Lfs2_internal_InterruptContext$().apply__Lcats_effect_kernel_Unique$Token__O__Lcats_effect_kernel_GenConcurrent__O(root, this.Lfs2_Compiler$Target$ConcurrentTarget__f_F.unit__O(), this.Lfs2_Compiler$Target$ConcurrentTarget__f_F0);
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.raiseError__O__O = (function(e) {
  return this.Lfs2_Compiler$Target$ConcurrentTarget__f_F.raiseError__O__O(e);
});
var $d_Lfs2_Compiler$Target$ConcurrentTarget = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Compiler$Target$ConcurrentTarget, "fs2.Compiler$Target$ConcurrentTarget", ({
  Lfs2_Compiler$Target$ConcurrentTarget: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1,
  Lfs2_Compiler$Target: 1
}));
export { $d_Lfs2_Compiler$Target$ConcurrentTarget as $d_Lfs2_Compiler$Target$ConcurrentTarget };
/** @constructor */
function $c_Lfs2_Compiler$TargetLowPriority$SyncTarget(F0) {
  this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F0 = null;
  this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F = null;
  this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F0 = F0;
  this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F = F0;
}
export { $c_Lfs2_Compiler$TargetLowPriority$SyncTarget as $c_Lfs2_Compiler$TargetLowPriority$SyncTarget };
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.constructor = $c_Lfs2_Compiler$TargetLowPriority$SyncTarget;
/** @constructor */
function $h_Lfs2_Compiler$TargetLowPriority$SyncTarget() {
}
export { $h_Lfs2_Compiler$TargetLowPriority$SyncTarget as $h_Lfs2_Compiler$TargetLowPriority$SyncTarget };
$h_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype = $c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype;
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.void__O__O = (function(fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.as__O__O__O = (function(fa, b) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.unit__O = (function() {
  return this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F.pure__O__O((void 0));
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.compose__Lcats_Applicative__Lcats_Applicative = (function(evidence$1) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Applicative$$anon$1(evidence$1, this);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.handleError__O__F1__O = (function(fa, f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.attempt__O__O = (function(fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_ApplicativeError__attempt__O__O(this, fa);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.onError__O__s_PartialFunction__O = (function(fa, pf) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_ApplicativeError__onError__O__s_PartialFunction__O(this, fa, pf);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.flatten__O__O = (function(ffa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.ap__O__O__O = (function(ff, fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.product__O__O__O = (function(fa, fb) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.productR__O__O__O = (function(fa, fb) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.productL__O__O__O = (function(fa, fb) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.map__O__F1__O = (function(fa, f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.guaranteeCase__O__F1__O = (function(fa, fin) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_effect_kernel_MonadCancel__guaranteeCase__O__F1__O(this, fa, fin);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.bracketFull__F1__F1__F2__O = (function(acquire, use, release) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_effect_kernel_MonadCancel__bracketFull__F1__F1__F2__O(this, acquire, use, release);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.pure__O__O = (function(a) {
  return this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F.pure__O__O(a);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  return this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F.handleErrorWith__O__F1__O(fa, f);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.flatMap__O__F1__O = (function(fa, f) {
  return this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F.flatMap__O__F1__O(fa, f);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F.tailRecM__O__F1__O(a, f);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.uncancelable__F1__O = (function(f) {
  return this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F.uncancelable__F1__O(f);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.onCancel__O__O__O = (function(fa, fin) {
  return this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F.onCancel__O__O__O(fa, fin);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.F__Lcats_effect_kernel_MonadCancel = (function() {
  return this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F;
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.unique__O = (function() {
  var F = this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F0;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_effect_kernel_Sync__unique__O(F);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.ref__O__O = (function(a) {
  var F = this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F0;
  var mk = new $c_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2(F);
  return mk.refOf__O__O(a);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.interruptContext__Lcats_effect_kernel_Unique$Token__s_Option = (function(root) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.raiseError__O__O = (function(e) {
  return this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F.raiseError__O__O(e);
});
var $d_Lfs2_Compiler$TargetLowPriority$SyncTarget = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lfs2_Compiler$TargetLowPriority$SyncTarget, "fs2.Compiler$TargetLowPriority$SyncTarget", ({
  Lfs2_Compiler$TargetLowPriority$SyncTarget: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1,
  Lfs2_Compiler$Target: 1
}));
export { $d_Lfs2_Compiler$TargetLowPriority$SyncTarget as $d_Lfs2_Compiler$TargetLowPriority$SyncTarget };
function $is_sci_LinearSeq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_LinearSeq)));
}
export { $is_sci_LinearSeq as $is_sci_LinearSeq };
function $isArrayOf_sci_LinearSeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_LinearSeq)));
}
export { $isArrayOf_sci_LinearSeq as $isArrayOf_sci_LinearSeq };
/** @constructor */
function $c_Lcats_data_Kleisli$() {
  $ct_Lcats_data_KleisliInstances__(this);
}
export { $c_Lcats_data_Kleisli$ as $c_Lcats_data_Kleisli$ };
$c_Lcats_data_Kleisli$.prototype = new $h_Lcats_data_KleisliInstances();
$c_Lcats_data_Kleisli$.prototype.constructor = $c_Lcats_data_Kleisli$;
/** @constructor */
function $h_Lcats_data_Kleisli$() {
}
export { $h_Lcats_data_Kleisli$ as $h_Lcats_data_Kleisli$ };
$h_Lcats_data_Kleisli$.prototype = $c_Lcats_data_Kleisli$.prototype;
$c_Lcats_data_Kleisli$.prototype.fromProduct__s_Product__Lcats_data_Kleisli = (function(x$0) {
  return new $c_Lcats_data_Kleisli(x$0.productElement__I__O(0));
});
$c_Lcats_data_Kleisli$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lcats_data_Kleisli(p);
});
var $d_Lcats_data_Kleisli$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_data_Kleisli$, "cats.data.Kleisli$", ({
  Lcats_data_Kleisli$: 1,
  Lcats_data_KleisliInstances: 1,
  Lcats_data_KleisliInstances0: 1,
  Lcats_data_KleisliInstances0\uff3f5: 1,
  Lcats_data_KleisliInstances1: 1,
  Lcats_data_KleisliInstances2: 1,
  Lcats_data_KleisliInstances3: 1,
  Lcats_data_KleisliInstances4: 1,
  Lcats_data_KleisliInstances5: 1,
  Lcats_data_KleisliInstances6: 1,
  Lcats_data_KleisliInstances7: 1,
  Lcats_data_KleisliInstances8: 1,
  Lcats_data_KleisliInstances9: 1,
  Lcats_data_KleisliFunctions: 1,
  Lcats_data_KleisliFunctionsBinCompat: 1,
  Lcats_data_KleisliExplicitInstances: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lcats_data_Kleisli$ as $d_Lcats_data_Kleisli$ };
var $n_Lcats_data_Kleisli$;
function $m_Lcats_data_Kleisli$() {
  if ((!$n_Lcats_data_Kleisli$)) {
    $n_Lcats_data_Kleisli$ = new $c_Lcats_data_Kleisli$();
  }
  return $n_Lcats_data_Kleisli$;
}
export { $m_Lcats_data_Kleisli$ as $m_Lcats_data_Kleisli$ };
/** @constructor */
function $c_Lcats_instances_FutureInstances$$anon$1(ec$1) {
  this.Lcats_instances_FutureInstances$$anon$1__f_ec$2 = null;
  this.Lcats_instances_FutureInstances$$anon$1__f_ec$2 = ec$1;
  $ct_Lcats_instances_FutureCoflatMap__s_concurrent_ExecutionContext__(this, ec$1);
}
export { $c_Lcats_instances_FutureInstances$$anon$1 as $c_Lcats_instances_FutureInstances$$anon$1 };
$c_Lcats_instances_FutureInstances$$anon$1.prototype = new $h_Lcats_instances_FutureCoflatMap();
$c_Lcats_instances_FutureInstances$$anon$1.prototype.constructor = $c_Lcats_instances_FutureInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_FutureInstances$$anon$1() {
}
export { $h_Lcats_instances_FutureInstances$$anon$1 as $h_Lcats_instances_FutureInstances$$anon$1 };
$h_Lcats_instances_FutureInstances$$anon$1.prototype = $c_Lcats_instances_FutureInstances$$anon$1.prototype;
$c_Lcats_instances_FutureInstances$$anon$1.prototype.unit__O = (function() {
  return $m_s_concurrent_Future$().successful__O__s_concurrent_Future((void 0));
});
$c_Lcats_instances_FutureInstances$$anon$1.prototype.compose__Lcats_Applicative__Lcats_Applicative = (function(evidence$1) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Applicative$$anon$1(evidence$1, this);
});
$c_Lcats_instances_FutureInstances$$anon$1.prototype.flatten__O__O = (function(ffa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_instances_FutureInstances$$anon$1.prototype.ap__O__O__O = (function(ff, fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_instances_FutureInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_instances_FutureInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_instances_FutureInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lcats_instances_FutureInstances$$anon$1.prototype.productR__O__O__O = (function(fa, fb) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_instances_FutureInstances$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_instances_FutureInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_StackSafeMonad__tailRecM__O__F1__O(this, a, f);
});
$c_Lcats_instances_FutureInstances$$anon$1.prototype.flatMap__s_concurrent_Future__F1__s_concurrent_Future = (function(fa, f) {
  return fa.flatMap__F1__s_concurrent_ExecutionContext__s_concurrent_Future(f, this.Lcats_instances_FutureInstances$$anon$1__f_ec$2);
});
$c_Lcats_instances_FutureInstances$$anon$1.prototype.handleErrorWith__s_concurrent_Future__F1__s_concurrent_Future = (function(fea, f) {
  return fea.recoverWith__s_PartialFunction__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_Lcats_instances_FutureInstances$$anon$2(f), this.Lcats_instances_FutureInstances$$anon$1__f_ec$2);
});
$c_Lcats_instances_FutureInstances$$anon$1.prototype.attempt__s_concurrent_Future__s_concurrent_Future = (function(fa) {
  return fa.transformWith__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((r) => {
    var $x_2 = $m_s_concurrent_Future$();
    matchResult5: {
      var $x_1;
      if ((r instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Success)) {
        var a = r.s_util_Success__f_value;
        var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(a);
        break matchResult5;
      }
      if ((r instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Failure)) {
        var e = r.s_util_Failure__f_exception;
        var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(e);
        break matchResult5;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(r);
    }
    return $x_2.successful__O__s_concurrent_Future($x_1);
  })), this.Lcats_instances_FutureInstances$$anon$1__f_ec$2);
});
$c_Lcats_instances_FutureInstances$$anon$1.prototype.map__s_concurrent_Future__F1__s_concurrent_Future = (function(fa, f) {
  return fa.map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(f, this.Lcats_instances_FutureInstances$$anon$1__f_ec$2);
});
$c_Lcats_instances_FutureInstances$$anon$1.prototype.pure__O__O = (function(x) {
  return $m_s_concurrent_Future$().successful__O__s_concurrent_Future(x);
});
$c_Lcats_instances_FutureInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  return this.flatMap__s_concurrent_Future__F1__s_concurrent_Future(fa, f);
});
$c_Lcats_instances_FutureInstances$$anon$1.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  return this.handleErrorWith__s_concurrent_Future__F1__s_concurrent_Future(fa, f);
});
$c_Lcats_instances_FutureInstances$$anon$1.prototype.raiseError__O__O = (function(e) {
  return $m_s_concurrent_Future$().failed__jl_Throwable__s_concurrent_Future(e);
});
$c_Lcats_instances_FutureInstances$$anon$1.prototype.attempt__O__O = (function(fa) {
  return this.attempt__s_concurrent_Future__s_concurrent_Future(fa);
});
$c_Lcats_instances_FutureInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  return this.map__s_concurrent_Future__F1__s_concurrent_Future(fa, f);
});
var $d_Lcats_instances_FutureInstances$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_FutureInstances$$anon$1, "cats.instances.FutureInstances$$anon$1", ({
  Lcats_instances_FutureInstances$$anon$1: 1,
  Lcats_instances_FutureCoflatMap: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_CoflatMap: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_StackSafeMonad: 1
}));
export { $d_Lcats_instances_FutureInstances$$anon$1 as $d_Lcats_instances_FutureInstances$$anon$1 };
function $is_sci_SortedSet(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_SortedSet)));
}
export { $is_sci_SortedSet as $is_sci_SortedSet };
function $isArrayOf_sci_SortedSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SortedSet)));
}
export { $isArrayOf_sci_SortedSet as $isArrayOf_sci_SortedSet };
function $is_sci_SortedMap(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_SortedMap)));
}
export { $is_sci_SortedMap as $is_sci_SortedMap };
function $isArrayOf_sci_SortedMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SortedMap)));
}
export { $isArrayOf_sci_SortedMap as $isArrayOf_sci_SortedMap };
/** @constructor */
function $c_Lsttp_tapir_EndpointIO$Body(bodyType, codec, info) {
  this.Lsttp_tapir_EndpointIO$Body__f_bodyType = null;
  this.Lsttp_tapir_EndpointIO$Body__f_codec = null;
  this.Lsttp_tapir_EndpointIO$Body__f_info = null;
  this.Lsttp_tapir_EndpointIO$Body__f_bodyType = bodyType;
  this.Lsttp_tapir_EndpointIO$Body__f_codec = codec;
  this.Lsttp_tapir_EndpointIO$Body__f_info = info;
}
export { $c_Lsttp_tapir_EndpointIO$Body as $c_Lsttp_tapir_EndpointIO$Body };
$c_Lsttp_tapir_EndpointIO$Body.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_EndpointIO$Body.prototype.constructor = $c_Lsttp_tapir_EndpointIO$Body;
/** @constructor */
function $h_Lsttp_tapir_EndpointIO$Body() {
}
export { $h_Lsttp_tapir_EndpointIO$Body as $h_Lsttp_tapir_EndpointIO$Body };
$h_Lsttp_tapir_EndpointIO$Body.prototype = $c_Lsttp_tapir_EndpointIO$Body.prototype;
$c_Lsttp_tapir_EndpointIO$Body.prototype.and__Lsttp_tapir_EndpointOutput__Lsttp_tapir_typelevel_ParamConcat__Lsttp_tapir_EndpointOutput = (function(other, concat) {
  return $f_Lsttp_tapir_EndpointOutput__and__Lsttp_tapir_EndpointOutput__Lsttp_tapir_typelevel_ParamConcat__Lsttp_tapir_EndpointOutput(this, other, concat);
});
$c_Lsttp_tapir_EndpointIO$Body.prototype.map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput = (function(mapping) {
  return $f_Lsttp_tapir_EndpointTransput$Atom__map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput(this, mapping);
});
$c_Lsttp_tapir_EndpointIO$Body.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_EndpointIO$Body.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1035467921), true);
});
$c_Lsttp_tapir_EndpointIO$Body.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_EndpointIO$Body)) {
    var x = this.Lsttp_tapir_EndpointIO$Body__f_bodyType;
    var x$2 = x$0.Lsttp_tapir_EndpointIO$Body__f_bodyType;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lsttp_tapir_EndpointIO$Body__f_codec;
      var x$4 = x$0.Lsttp_tapir_EndpointIO$Body__f_codec;
      var $x_1 = (x$3 === x$4);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Lsttp_tapir_EndpointIO$Body__f_info;
      var x$6 = x$0.Lsttp_tapir_EndpointIO$Body__f_info;
      return ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_EndpointIO$Body.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_EndpointIO$Body.prototype.productArity__I = (function() {
  return 3;
});
$c_Lsttp_tapir_EndpointIO$Body.prototype.productPrefix__T = (function() {
  return "Body";
});
$c_Lsttp_tapir_EndpointIO$Body.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsttp_tapir_EndpointIO$Body__f_bodyType;
      break;
    }
    case 1: {
      return this.Lsttp_tapir_EndpointIO$Body__f_codec;
      break;
    }
    case 2: {
      return this.Lsttp_tapir_EndpointIO$Body__f_info;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_EndpointIO$Body.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "bodyType";
      break;
    }
    case 1: {
      return "codec";
      break;
    }
    case 2: {
      return "info";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_EndpointIO$Body.prototype.codec__Lsttp_tapir_Codec = (function() {
  return this.Lsttp_tapir_EndpointIO$Body__f_codec;
});
$c_Lsttp_tapir_EndpointIO$Body.prototype.info__Lsttp_tapir_EndpointIO$Info = (function() {
  return this.Lsttp_tapir_EndpointIO$Body__f_info;
});
$c_Lsttp_tapir_EndpointIO$Body.prototype.copyWith__Lsttp_tapir_Codec__Lsttp_tapir_EndpointIO$Info__Lsttp_tapir_EndpointTransput = (function(c, i) {
  var bodyType = this.Lsttp_tapir_EndpointIO$Body__f_bodyType;
  return new $c_Lsttp_tapir_EndpointIO$Body(bodyType, c, i);
});
function $isArrayOf_Lsttp_tapir_EndpointIO$Body(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointIO$Body)));
}
export { $isArrayOf_Lsttp_tapir_EndpointIO$Body as $isArrayOf_Lsttp_tapir_EndpointIO$Body };
var $d_Lsttp_tapir_EndpointIO$Body = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_EndpointIO$Body, "sttp.tapir.EndpointIO$Body", ({
  Lsttp_tapir_EndpointIO$Body: 1,
  Lsttp_tapir_macros_EndpointTransputMacros: 1,
  Lsttp_tapir_EndpointTransput: 1,
  Lsttp_tapir_EndpointInput: 1,
  Lsttp_tapir_EndpointOutput: 1,
  Lsttp_tapir_EndpointIO: 1,
  Lsttp_tapir_EndpointInput$Single: 1,
  Lsttp_tapir_EndpointOutput$Single: 1,
  Lsttp_tapir_EndpointIO$Single: 1,
  Lsttp_tapir_EndpointTransput$Basic: 1,
  Lsttp_tapir_EndpointInput$Basic: 1,
  Lsttp_tapir_EndpointOutput$Basic: 1,
  Lsttp_tapir_EndpointIO$Basic: 1,
  Lsttp_tapir_EndpointTransput$Atom: 1,
  Lsttp_tapir_EndpointInput$Atom: 1,
  Lsttp_tapir_EndpointOutput$Atom: 1,
  Lsttp_tapir_EndpointIO$Atom: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_EndpointIO$Body as $d_Lsttp_tapir_EndpointIO$Body };
/** @constructor */
function $c_Lsttp_tapir_EndpointIO$Empty(codec, info) {
  this.Lsttp_tapir_EndpointIO$Empty__f_codec = null;
  this.Lsttp_tapir_EndpointIO$Empty__f_info = null;
  this.Lsttp_tapir_EndpointIO$Empty__f_codec = codec;
  this.Lsttp_tapir_EndpointIO$Empty__f_info = info;
}
export { $c_Lsttp_tapir_EndpointIO$Empty as $c_Lsttp_tapir_EndpointIO$Empty };
$c_Lsttp_tapir_EndpointIO$Empty.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_EndpointIO$Empty.prototype.constructor = $c_Lsttp_tapir_EndpointIO$Empty;
/** @constructor */
function $h_Lsttp_tapir_EndpointIO$Empty() {
}
export { $h_Lsttp_tapir_EndpointIO$Empty as $h_Lsttp_tapir_EndpointIO$Empty };
$h_Lsttp_tapir_EndpointIO$Empty.prototype = $c_Lsttp_tapir_EndpointIO$Empty.prototype;
$c_Lsttp_tapir_EndpointIO$Empty.prototype.and__Lsttp_tapir_EndpointOutput__Lsttp_tapir_typelevel_ParamConcat__Lsttp_tapir_EndpointOutput = (function(other, concat) {
  return $f_Lsttp_tapir_EndpointOutput__and__Lsttp_tapir_EndpointOutput__Lsttp_tapir_typelevel_ParamConcat__Lsttp_tapir_EndpointOutput(this, other, concat);
});
$c_Lsttp_tapir_EndpointIO$Empty.prototype.map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput = (function(mapping) {
  return $f_Lsttp_tapir_EndpointTransput$Atom__map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput(this, mapping);
});
$c_Lsttp_tapir_EndpointIO$Empty.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_EndpointIO$Empty.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 95517591, true);
});
$c_Lsttp_tapir_EndpointIO$Empty.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_EndpointIO$Empty)) {
    var x = this.Lsttp_tapir_EndpointIO$Empty__f_codec;
    var x$2 = x$0.Lsttp_tapir_EndpointIO$Empty__f_codec;
    if ((x === x$2)) {
      var x$3 = this.Lsttp_tapir_EndpointIO$Empty__f_info;
      var x$4 = x$0.Lsttp_tapir_EndpointIO$Empty__f_info;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_EndpointIO$Empty.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_EndpointIO$Empty.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsttp_tapir_EndpointIO$Empty.prototype.productPrefix__T = (function() {
  return "Empty";
});
$c_Lsttp_tapir_EndpointIO$Empty.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_EndpointIO$Empty__f_codec;
  }
  if ((n === 1)) {
    return this.Lsttp_tapir_EndpointIO$Empty__f_info;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_EndpointIO$Empty.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "codec";
  }
  if ((n === 1)) {
    return "info";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_EndpointIO$Empty.prototype.codec__Lsttp_tapir_Codec = (function() {
  return this.Lsttp_tapir_EndpointIO$Empty__f_codec;
});
$c_Lsttp_tapir_EndpointIO$Empty.prototype.info__Lsttp_tapir_EndpointIO$Info = (function() {
  return this.Lsttp_tapir_EndpointIO$Empty__f_info;
});
$c_Lsttp_tapir_EndpointIO$Empty.prototype.copyWith__Lsttp_tapir_Codec__Lsttp_tapir_EndpointIO$Info__Lsttp_tapir_EndpointTransput = (function(c, i) {
  return new $c_Lsttp_tapir_EndpointIO$Empty(c, i);
});
function $isArrayOf_Lsttp_tapir_EndpointIO$Empty(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointIO$Empty)));
}
export { $isArrayOf_Lsttp_tapir_EndpointIO$Empty as $isArrayOf_Lsttp_tapir_EndpointIO$Empty };
var $d_Lsttp_tapir_EndpointIO$Empty = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_EndpointIO$Empty, "sttp.tapir.EndpointIO$Empty", ({
  Lsttp_tapir_EndpointIO$Empty: 1,
  Lsttp_tapir_macros_EndpointTransputMacros: 1,
  Lsttp_tapir_EndpointTransput: 1,
  Lsttp_tapir_EndpointInput: 1,
  Lsttp_tapir_EndpointOutput: 1,
  Lsttp_tapir_EndpointIO: 1,
  Lsttp_tapir_EndpointInput$Single: 1,
  Lsttp_tapir_EndpointOutput$Single: 1,
  Lsttp_tapir_EndpointIO$Single: 1,
  Lsttp_tapir_EndpointTransput$Basic: 1,
  Lsttp_tapir_EndpointInput$Basic: 1,
  Lsttp_tapir_EndpointOutput$Basic: 1,
  Lsttp_tapir_EndpointIO$Basic: 1,
  Lsttp_tapir_EndpointTransput$Atom: 1,
  Lsttp_tapir_EndpointInput$Atom: 1,
  Lsttp_tapir_EndpointOutput$Atom: 1,
  Lsttp_tapir_EndpointIO$Atom: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_EndpointIO$Empty as $d_Lsttp_tapir_EndpointIO$Empty };
function $isArrayOf_Lsttp_tapir_EndpointIO$FixedHeader(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointIO$FixedHeader)));
}
export { $isArrayOf_Lsttp_tapir_EndpointIO$FixedHeader as $isArrayOf_Lsttp_tapir_EndpointIO$FixedHeader };
/** @constructor */
function $c_Lsttp_tapir_EndpointIO$Header(name, codec, info) {
  this.Lsttp_tapir_EndpointIO$Header__f_name = null;
  this.Lsttp_tapir_EndpointIO$Header__f_codec = null;
  this.Lsttp_tapir_EndpointIO$Header__f_info = null;
  this.Lsttp_tapir_EndpointIO$Header__f_name = name;
  this.Lsttp_tapir_EndpointIO$Header__f_codec = codec;
  this.Lsttp_tapir_EndpointIO$Header__f_info = info;
}
export { $c_Lsttp_tapir_EndpointIO$Header as $c_Lsttp_tapir_EndpointIO$Header };
$c_Lsttp_tapir_EndpointIO$Header.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lsttp_tapir_EndpointIO$Header.prototype.constructor = $c_Lsttp_tapir_EndpointIO$Header;
/** @constructor */
function $h_Lsttp_tapir_EndpointIO$Header() {
}
export { $h_Lsttp_tapir_EndpointIO$Header as $h_Lsttp_tapir_EndpointIO$Header };
$h_Lsttp_tapir_EndpointIO$Header.prototype = $c_Lsttp_tapir_EndpointIO$Header.prototype;
$c_Lsttp_tapir_EndpointIO$Header.prototype.and__Lsttp_tapir_EndpointOutput__Lsttp_tapir_typelevel_ParamConcat__Lsttp_tapir_EndpointOutput = (function(other, concat) {
  return $f_Lsttp_tapir_EndpointOutput__and__Lsttp_tapir_EndpointOutput__Lsttp_tapir_typelevel_ParamConcat__Lsttp_tapir_EndpointOutput(this, other, concat);
});
$c_Lsttp_tapir_EndpointIO$Header.prototype.map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput = (function(mapping) {
  return $f_Lsttp_tapir_EndpointTransput$Atom__map__Lsttp_tapir_Mapping__Lsttp_tapir_EndpointTransput(this, mapping);
});
$c_Lsttp_tapir_EndpointIO$Header.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_EndpointIO$Header.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-198202398), true);
});
$c_Lsttp_tapir_EndpointIO$Header.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_EndpointIO$Header)) {
    if ((this.Lsttp_tapir_EndpointIO$Header__f_name === x$0.Lsttp_tapir_EndpointIO$Header__f_name)) {
      var x = this.Lsttp_tapir_EndpointIO$Header__f_codec;
      var x$2 = x$0.Lsttp_tapir_EndpointIO$Header__f_codec;
      var $x_1 = (x === x$2);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.Lsttp_tapir_EndpointIO$Header__f_info;
      var x$4 = x$0.Lsttp_tapir_EndpointIO$Header__f_info;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_EndpointIO$Header.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_EndpointIO$Header.prototype.productArity__I = (function() {
  return 3;
});
$c_Lsttp_tapir_EndpointIO$Header.prototype.productPrefix__T = (function() {
  return "Header";
});
$c_Lsttp_tapir_EndpointIO$Header.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsttp_tapir_EndpointIO$Header__f_name;
      break;
    }
    case 1: {
      return this.Lsttp_tapir_EndpointIO$Header__f_codec;
      break;
    }
    case 2: {
      return this.Lsttp_tapir_EndpointIO$Header__f_info;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_EndpointIO$Header.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "name";
      break;
    }
    case 1: {
      return "codec";
      break;
    }
    case 2: {
      return "info";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_EndpointIO$Header.prototype.codec__Lsttp_tapir_Codec = (function() {
  return this.Lsttp_tapir_EndpointIO$Header__f_codec;
});
$c_Lsttp_tapir_EndpointIO$Header.prototype.info__Lsttp_tapir_EndpointIO$Info = (function() {
  return this.Lsttp_tapir_EndpointIO$Header__f_info;
});
$c_Lsttp_tapir_EndpointIO$Header.prototype.copyWith__Lsttp_tapir_Codec__Lsttp_tapir_EndpointIO$Info__Lsttp_tapir_EndpointTransput = (function(c, i) {
  var name = this.Lsttp_tapir_EndpointIO$Header__f_name;
  return new $c_Lsttp_tapir_EndpointIO$Header(name, c, i);
});
function $isArrayOf_Lsttp_tapir_EndpointIO$Header(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointIO$Header)));
}
export { $isArrayOf_Lsttp_tapir_EndpointIO$Header as $isArrayOf_Lsttp_tapir_EndpointIO$Header };
var $d_Lsttp_tapir_EndpointIO$Header = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lsttp_tapir_EndpointIO$Header, "sttp.tapir.EndpointIO$Header", ({
  Lsttp_tapir_EndpointIO$Header: 1,
  Lsttp_tapir_macros_EndpointTransputMacros: 1,
  Lsttp_tapir_EndpointTransput: 1,
  Lsttp_tapir_EndpointInput: 1,
  Lsttp_tapir_EndpointOutput: 1,
  Lsttp_tapir_EndpointIO: 1,
  Lsttp_tapir_EndpointInput$Single: 1,
  Lsttp_tapir_EndpointOutput$Single: 1,
  Lsttp_tapir_EndpointIO$Single: 1,
  Lsttp_tapir_EndpointTransput$Basic: 1,
  Lsttp_tapir_EndpointInput$Basic: 1,
  Lsttp_tapir_EndpointOutput$Basic: 1,
  Lsttp_tapir_EndpointIO$Basic: 1,
  Lsttp_tapir_EndpointTransput$Atom: 1,
  Lsttp_tapir_EndpointInput$Atom: 1,
  Lsttp_tapir_EndpointOutput$Atom: 1,
  Lsttp_tapir_EndpointIO$Atom: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_EndpointIO$Header as $d_Lsttp_tapir_EndpointIO$Header };
function $isArrayOf_Lsttp_tapir_EndpointIO$Headers(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointIO$Headers)));
}
export { $isArrayOf_Lsttp_tapir_EndpointIO$Headers as $isArrayOf_Lsttp_tapir_EndpointIO$Headers };
function $isArrayOf_Lsttp_tapir_EndpointIO$StreamBodyWrapper(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_EndpointIO$StreamBodyWrapper)));
}
export { $isArrayOf_Lsttp_tapir_EndpointIO$StreamBodyWrapper as $isArrayOf_Lsttp_tapir_EndpointIO$StreamBodyWrapper };
function $f_Lcats_effect_kernel_GenTemporal__sleep__s_concurrent_duration_Duration__O($thiz, time) {
  if ((time instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_concurrent_duration_FiniteDuration)) {
    var this$2 = $m_Lcats_effect_IO$();
    return this$2.sleep__s_concurrent_duration_Duration__Lcats_effect_IO(time);
  }
  var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Inf;
  if (((x === null) ? (time === null) : x.equals__O__Z(time))) {
    return $f_Lcats_effect_kernel_Async__never__O($thiz);
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), ("Duration must be either a `FiniteDuration` or `Duration.Inf`, but got: " + time));
}
export { $f_Lcats_effect_kernel_GenTemporal__sleep__s_concurrent_duration_Duration__O as $f_Lcats_effect_kernel_GenTemporal__sleep__s_concurrent_duration_Duration__O };
/** @constructor */
function $c_sci_LongMap() {
}
export { $c_sci_LongMap as $c_sci_LongMap };
$c_sci_LongMap.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sci_AbstractMap();
$c_sci_LongMap.prototype.constructor = $c_sci_LongMap;
/** @constructor */
function $h_sci_LongMap() {
}
export { $h_sci_LongMap as $h_sci_LongMap };
$h_sci_LongMap.prototype = $c_sci_LongMap.prototype;
$c_sci_LongMap.prototype.map__F1__sc_IterableOps = (function(f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedMapOps__map__F1__sc_IterableOps(this, f);
});
$c_sci_LongMap.prototype.collect__s_PartialFunction__sc_IterableOps = (function(pf) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedMapOps__collect__s_PartialFunction__sc_IterableOps(this, pf);
});
$c_sci_LongMap.prototype.map__F1__O = (function(f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_LongMap.prototype.flatMap__F1__O = (function(f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_LongMap.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sci_LongMap.prototype.dropRight__I__O = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_LongMap.prototype.fromSpecific__sc_IterableOnce__sci_LongMap = (function(coll) {
  var b = new $c_sci_LongMap$$anon$2(this);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_scm_Builder__sizeHint__sc_IterableOnce__I__V(b, coll, 0);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(b, coll);
  return b.scm_ImmutableBuilder__f_elems;
});
$c_sci_LongMap.prototype.newSpecificBuilder__scm_Builder = (function() {
  return new $c_sci_LongMap$$anon$2(this);
});
$c_sci_LongMap.prototype.toList__sci_List = (function() {
  var buffer = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_ListBuffer();
  this.foreach__F1__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1$2$2) => buffer.addOne__O__scm_ListBuffer(x$1$2$2))));
  return buffer.toList__sci_List();
});
$c_sci_LongMap.prototype.iterator__sc_Iterator = (function() {
  var x = $m_sci_LongMap$Nil$();
  if (x.equals__O__Z(this)) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  } else {
    return new $c_sci_LongMapEntryIterator(this);
  }
});
$c_sci_LongMap.prototype.foreach__F1__V = (function(f) {
  var _$this = this;
  while (true) {
    var x1 = _$this;
    if ((x1 instanceof $c_sci_LongMap$Bin)) {
      var left = x1.sci_LongMap$Bin__f_left;
      var right = x1.sci_LongMap$Bin__f_right;
      left.foreach__F1__V(f);
      _$this = right;
      continue;
    } else if ((x1 instanceof $c_sci_LongMap$Tip)) {
      var t = x1.sci_LongMap$Tip__f_key;
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var value = x1.sci_LongMap$Tip__f_value;
      f.apply__O__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi), value));
    } else {
      var x = $m_sci_LongMap$Nil$();
      if ((!x.equals__O__Z(x1))) {
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1);
      }
    }
    break;
  }
});
$c_sci_LongMap.prototype.foreachEntry__F2__V = (function(f) {
  var _$this = this;
  while (true) {
    var x1 = _$this;
    if ((x1 instanceof $c_sci_LongMap$Bin)) {
      var left = x1.sci_LongMap$Bin__f_left;
      var right = x1.sci_LongMap$Bin__f_right;
      left.foreachEntry__F2__V(f);
      _$this = right;
      continue;
    } else if ((x1 instanceof $c_sci_LongMap$Tip)) {
      var t = x1.sci_LongMap$Tip__f_key;
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var value = x1.sci_LongMap$Tip__f_value;
      f.apply__O__O__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi), value);
    } else {
      var x = $m_sci_LongMap$Nil$();
      if ((!x.equals__O__Z(x1))) {
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1);
      }
    }
    break;
  }
});
$c_sci_LongMap.prototype.keysIterator__sc_Iterator = (function() {
  var x = $m_sci_LongMap$Nil$();
  if (x.equals__O__Z(this)) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  } else {
    return new $c_sci_LongMapKeyIterator(this);
  }
});
$c_sci_LongMap.prototype.valuesIterator__sc_Iterator = (function() {
  var x = $m_sci_LongMap$Nil$();
  if (x.equals__O__Z(this)) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  } else {
    return new $c_sci_LongMapValueIterator(this);
  }
});
$c_sci_LongMap.prototype.className__T = (function() {
  return "LongMap";
});
$c_sci_LongMap.prototype.isEmpty__Z = (function() {
  return (this === $m_sci_LongMap$Nil$());
});
$c_sci_LongMap.prototype.knownSize__I = (function() {
  return (this.isEmpty__Z() ? 0 : (-1));
});
$c_sci_LongMap.prototype.filter__F1__sci_LongMap = (function(f) {
  if ((this instanceof $c_sci_LongMap$Bin)) {
    var t = this.sci_LongMap$Bin__f_prefix;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var t$1 = this.sci_LongMap$Bin__f_mask;
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    var left = this.sci_LongMap$Bin__f_left;
    var right = this.sci_LongMap$Bin__f_right;
    var _1 = left.filter__F1__sci_LongMap(f);
    var _2 = right.filter__F1__sci_LongMap(f);
    return (((left === _1) && (right === _2)) ? this : $m_sci_LongMapUtils$().bin__J__J__sci_LongMap__sci_LongMap__sci_LongMap(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$1, hi$1), _1, _2));
  } else if ((this instanceof $c_sci_LongMap$Tip)) {
    var t$2 = this.sci_LongMap$Tip__f_key;
    var lo$2 = t$2.RTLong__f_lo;
    var hi$2 = t$2.RTLong__f_hi;
    var value = this.sci_LongMap$Tip__f_value;
    return ((!(!f.apply__O__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$2, hi$2), value)))) ? this : $m_sci_LongMap$Nil$());
  } else {
    var x = $m_sci_LongMap$Nil$();
    if (x.equals__O__Z(this)) {
      return $m_sci_LongMap$Nil$();
    } else {
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this);
    }
  }
});
$c_sci_LongMap.prototype.size__I = (function() {
  var x = $m_sci_LongMap$Nil$();
  if (x.equals__O__Z(this)) {
    return 0;
  } else if ((this instanceof $c_sci_LongMap$Tip)) {
    return 1;
  } else if ((this instanceof $c_sci_LongMap$Bin)) {
    var left = this.sci_LongMap$Bin__f_left;
    var right = this.sci_LongMap$Bin__f_right;
    return ((left.size__I() + right.size__I()) | 0);
  } else {
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this);
  }
});
$c_sci_LongMap.prototype.get__J__s_Option = (function(key) {
  var _$this = this;
  while (true) {
    var x1 = _$this;
    if ((x1 instanceof $c_sci_LongMap$Bin)) {
      var t = x1.sci_LongMap$Bin__f_mask;
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var left = x1.sci_LongMap$Bin__f_left;
      var right = x1.sci_LongMap$Bin__f_right;
      var this$1 = $m_sci_LongMapUtils$();
      if ($f_scg_BitOperations$Long__zero__J__J__Z(this$1, key, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi))) {
        _$this = left;
      } else {
        _$this = right;
      }
    } else if ((x1 instanceof $c_sci_LongMap$Tip)) {
      var t$1 = x1.sci_LongMap$Tip__f_key;
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      var value = x1.sci_LongMap$Tip__f_value;
      return (((key.RTLong__f_lo === lo$1) && (key.RTLong__f_hi === hi$1)) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
    } else {
      var x = $m_sci_LongMap$Nil$();
      if (x.equals__O__Z(x1)) {
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      } else {
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1);
      }
    }
  }
});
$c_sci_LongMap.prototype.getOrElse__J__F0__O = (function(key, default$1) {
  var _$this = this;
  while (true) {
    var x1 = _$this;
    var x = $m_sci_LongMap$Nil$();
    if (x.equals__O__Z(x1)) {
      return default$1.apply__O();
    } else if ((x1 instanceof $c_sci_LongMap$Tip)) {
      var t = x1.sci_LongMap$Tip__f_key;
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var value = x1.sci_LongMap$Tip__f_value;
      return (((key.RTLong__f_lo === lo) && (key.RTLong__f_hi === hi)) ? value : default$1.apply__O());
    } else if ((x1 instanceof $c_sci_LongMap$Bin)) {
      var t$1 = x1.sci_LongMap$Bin__f_mask;
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      var left = x1.sci_LongMap$Bin__f_left;
      var right = x1.sci_LongMap$Bin__f_right;
      var this$2 = $m_sci_LongMapUtils$();
      if ($f_scg_BitOperations$Long__zero__J__J__Z(this$2, key, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$1, hi$1))) {
        _$this = left;
      } else {
        _$this = right;
      }
    } else {
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1);
    }
  }
});
$c_sci_LongMap.prototype.apply__J__O = (function(key) {
  var _$this = this;
  while (true) {
    var x1 = _$this;
    if ((x1 instanceof $c_sci_LongMap$Bin)) {
      var t = x1.sci_LongMap$Bin__f_mask;
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var left = x1.sci_LongMap$Bin__f_left;
      var right = x1.sci_LongMap$Bin__f_right;
      var this$1 = $m_sci_LongMapUtils$();
      if ($f_scg_BitOperations$Long__zero__J__J__Z(this$1, key, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi))) {
        _$this = left;
      } else {
        _$this = right;
      }
    } else if ((x1 instanceof $c_sci_LongMap$Tip)) {
      var t$1 = x1.sci_LongMap$Tip__f_key;
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      var value = x1.sci_LongMap$Tip__f_value;
      if (((key.RTLong__f_lo === lo$1) && (key.RTLong__f_hi === hi$1))) {
        return value;
      } else {
        throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), "Key not found");
      }
    } else {
      var x = $m_sci_LongMap$Nil$();
      if (x.equals__O__Z(x1)) {
        throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), "key not found");
      } else {
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1);
      }
    }
  }
});
$c_sci_LongMap.prototype.updated__J__O__sci_LongMap = (function(key, value) {
  if ((this instanceof $c_sci_LongMap$Bin)) {
    var t = this.sci_LongMap$Bin__f_prefix;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var t$1 = this.sci_LongMap$Bin__f_mask;
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    var left = this.sci_LongMap$Bin__f_left;
    var right = this.sci_LongMap$Bin__f_right;
    var this$1 = $m_sci_LongMapUtils$();
    if ((!$f_scg_BitOperations$Long__hasMatch__J__J__J__Z(this$1, key, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$1, hi$1)))) {
      return $m_sci_LongMapUtils$().join__J__sci_LongMap__J__sci_LongMap__sci_LongMap(key, new $c_sci_LongMap$Tip(key, value), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi), this);
    } else {
      var this$2 = $m_sci_LongMapUtils$();
      if ($f_scg_BitOperations$Long__zero__J__J__Z(this$2, key, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$1, hi$1))) {
        return new $c_sci_LongMap$Bin(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$1, hi$1), left.updated__J__O__sci_LongMap(key, value), right);
      } else {
        return new $c_sci_LongMap$Bin(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$1, hi$1), left, right.updated__J__O__sci_LongMap(key, value));
      }
    }
  } else if ((this instanceof $c_sci_LongMap$Tip)) {
    var t$2 = this.sci_LongMap$Tip__f_key;
    var lo$2 = t$2.RTLong__f_lo;
    var hi$2 = t$2.RTLong__f_hi;
    return (((key.RTLong__f_lo === lo$2) && (key.RTLong__f_hi === hi$2)) ? new $c_sci_LongMap$Tip(key, value) : $m_sci_LongMapUtils$().join__J__sci_LongMap__J__sci_LongMap__sci_LongMap(key, new $c_sci_LongMap$Tip(key, value), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$2, hi$2), this));
  } else {
    var x = $m_sci_LongMap$Nil$();
    if (x.equals__O__Z(this)) {
      return new $c_sci_LongMap$Tip(key, value);
    } else {
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this);
    }
  }
});
$c_sci_LongMap.prototype.removed__J__sci_LongMap = (function(key) {
  if ((this instanceof $c_sci_LongMap$Bin)) {
    var t = this.sci_LongMap$Bin__f_prefix;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var t$1 = this.sci_LongMap$Bin__f_mask;
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    var left = this.sci_LongMap$Bin__f_left;
    var right = this.sci_LongMap$Bin__f_right;
    var this$1 = $m_sci_LongMapUtils$();
    if ((!$f_scg_BitOperations$Long__hasMatch__J__J__J__Z(this$1, key, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$1, hi$1)))) {
      return this;
    } else {
      var this$2 = $m_sci_LongMapUtils$();
      if ($f_scg_BitOperations$Long__zero__J__J__Z(this$2, key, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$1, hi$1))) {
        return $m_sci_LongMapUtils$().bin__J__J__sci_LongMap__sci_LongMap__sci_LongMap(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$1, hi$1), left.removed__J__sci_LongMap(key), right);
      } else {
        return $m_sci_LongMapUtils$().bin__J__J__sci_LongMap__sci_LongMap__sci_LongMap(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$1, hi$1), left, right.removed__J__sci_LongMap(key));
      }
    }
  } else if ((this instanceof $c_sci_LongMap$Tip)) {
    var t$2 = this.sci_LongMap$Tip__f_key;
    var lo$2 = t$2.RTLong__f_lo;
    var hi$2 = t$2.RTLong__f_hi;
    return (((key.RTLong__f_lo === lo$2) && (key.RTLong__f_hi === hi$2)) ? $m_sci_LongMap$Nil$() : this);
  } else {
    var x = $m_sci_LongMap$Nil$();
    if (x.equals__O__Z(this)) {
      return $m_sci_LongMap$Nil$();
    } else {
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this);
    }
  }
});
$c_sci_LongMap.prototype.$plus$plus__sc_IterableOnce__sc_IterableOps = (function(xs) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sci_StrictOptimizedMapOps__concat__sc_IterableOnce__sci_MapOps(this, xs);
});
$c_sci_LongMap.prototype.concat__sc_IterableOnce__sc_IterableOps = (function(suffix) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sci_StrictOptimizedMapOps__concat__sc_IterableOnce__sci_MapOps(this, suffix);
});
$c_sci_LongMap.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__J__sci_LongMap($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(key));
});
$c_sci_LongMap.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__J__O__sci_LongMap($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(key), value);
});
$c_sci_LongMap.prototype.$plus__T2__sci_MapOps = (function(kv) {
  return this.updated__J__O__sci_LongMap($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(kv._1__O()), kv._2__O());
});
$c_sci_LongMap.prototype.apply__O__O = (function(key) {
  return this.apply__J__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(key));
});
$c_sci_LongMap.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return this.getOrElse__J__F0__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(key), default$1);
});
$c_sci_LongMap.prototype.get__O__s_Option = (function(key) {
  return this.get__J__s_Option($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(key));
});
$c_sci_LongMap.prototype.filter__F1__O = (function(pred) {
  return this.filter__F1__sci_LongMap(pred);
});
$c_sci_LongMap.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sci_LongMap(coll);
});
$c_sci_LongMap.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sci_LongMap(coll);
});
function $isArrayOf_sci_LongMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_LongMap)));
}
export { $isArrayOf_sci_LongMap as $isArrayOf_sci_LongMap };
/** @constructor */
function $c_Lcats_instances_QueueInstances$$anon$1() {
}
export { $c_Lcats_instances_QueueInstances$$anon$1 as $c_Lcats_instances_QueueInstances$$anon$1 };
$c_Lcats_instances_QueueInstances$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_QueueInstances$$anon$1.prototype.constructor = $c_Lcats_instances_QueueInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_QueueInstances$$anon$1() {
}
export { $h_Lcats_instances_QueueInstances$$anon$1 as $h_Lcats_instances_QueueInstances$$anon$1 };
$h_Lcats_instances_QueueInstances$$anon$1.prototype = $c_Lcats_instances_QueueInstances$$anon$1.prototype;
$c_Lcats_instances_QueueInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedIterableOps__map__F1__O(fa, f);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.void__O__O = (function(fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.size__O__J = (function(fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_UnorderedFoldable__size__O__J(this, fa);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.unorderedFoldMap__O__F1__Lcats_kernel_CommutativeMonoid__O = (function(fa, f, evidence$1) {
  return this.foldMap__sci_Queue__F1__Lcats_kernel_Monoid__O(fa, f, evidence$1);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.unit__O = (function() {
  return this.pure__O__sci_Queue((void 0));
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.flatten__O__O = (function(ffa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.ap__O__O__O = (function(ff, fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.fromIterableOnce__sc_IterableOnce__sci_Queue = (function(as) {
  var builder = $m_sci_Queue$().newBuilder__scm_Builder();
  builder.addAll__sc_IterableOnce__scm_Growable(as);
  return builder.result__O();
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.pure__O__sci_Queue = (function(x) {
  var xs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([x]));
  return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(xs));
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.map2__sci_Queue__sci_Queue__F2__sci_Queue = (function(fa, fb, f) {
  if (fb.isEmpty__Z()) {
    return $m_sci_Queue$EmptyQueue$();
  } else {
    var b = $m_sci_Queue$().newBuilder__scm_Builder();
    var it = fa.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var x0 = it.next__O();
      var b$1 = $m_sci_Queue$().newBuilder__scm_Builder();
      var it$1 = fb.iterator__sc_Iterator();
      while (it$1.hasNext__Z()) {
        var x0$1 = it$1.next__O();
        var elem = f.apply__O__O__O(x0, x0$1);
        b$1.addOne__O__scm_Growable(elem);
      }
      var elems = b$1.result__O();
      b.addAll__sc_IterableOnce__scm_Growable(elems);
    }
    return b.result__O();
  }
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.map2Eval__sci_Queue__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  if (fa.isEmpty__Z()) {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Eval$();
    var a = $m_sci_Queue$EmptyQueue$();
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Now(a);
  } else {
    return fb.map__F1__Lcats_Eval(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((fb$2) => this.map2__sci_Queue__sci_Queue__F2__sci_Queue(fa, fb$2, f))));
  }
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.tailRecM__O__F1__sci_Queue = (function(a, f) {
  var bldr = $m_sci_Queue$().newBuilder__scm_Builder();
  var elem$2 = f.apply__O__O(a);
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  return $s_Lcats_instances_QueueInstances__cats$instances$QueueInstances$$anon$1$$_$go$1__scm_Builder__F1__sci_List__sci_Queue(bldr, f, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem$2, this$1));
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.foldRight__sci_Queue__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Eval$();
  var a = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $ps_Lcats_instances_QueueInstances__loop$2__Lcats_Eval__F2__sci_Queue__Lcats_Eval(lb, f, fa)));
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Eval$$anon$5(a);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.foldMap__sci_Queue__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var this$1 = fa.iterator__sc_Iterator();
  return B.combineAll__sc_IterableOnce__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(this$1, f));
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.traverse__sci_Queue__F1__Lcats_Applicative__O = (function(fa, f, G) {
  if (fa.isEmpty__Z()) {
    return G.pure__O__O($m_sci_Queue$EmptyQueue$());
  } else if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$is_Lcats_StackSafeMonad(G)) {
    return G.map__O__F1__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Traverse$().traverseDirectly__sc_IterableOnce__F1__Lcats_StackSafeMonad__O(fa, f, G), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((c) => this.fromIterableOnce__sc_IterableOnce__sci_Queue(c.iterator__sc_Iterator()))));
  } else {
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_Chain$();
    var this$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_scm_ArrayBuffer$();
    var elems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([]));
    var as = this$3.from__sc_IterableOnce__scm_ArrayBuffer(elems);
    as.addAll__sc_IterableOnce__scm_ArrayBuffer(fa);
    return G.map__O__F1__O($x_1.traverseViaChain__sci_IndexedSeq__F1__Lcats_Applicative__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq(as), f, G), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((chain) => {
      var z = $m_sci_Queue$EmptyQueue$();
      var result = z;
      var iter = chain.iterator__sc_Iterator();
      while (iter.hasNext__Z()) {
        var x0 = result;
        var x1 = iter.next__O();
        result = x0.enqueue__O__sci_Queue(x1);
      }
      return result;
    })));
  }
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.traverseVoid__sci_Queue__F1__Lcats_Applicative__O = (function(fa, f, G) {
  if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$is_Lcats_StackSafeMonad(G)) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Traverse$().traverseVoidDirectly__sc_IterableOnce__F1__Lcats_StackSafeMonad__O(fa, f, G);
  } else {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Eval$();
    var a = G.unit__O();
    return this.foldRight__sci_Queue__Lcats_Eval__F2__Lcats_Eval(fa, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Now(a), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((a$1, acc) => G.map2Eval__O__Lcats_Eval__F2__Lcats_Eval(f.apply__O__O(a$1), acc, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((_$5, _$6) => (void 0))))))).value__O();
  }
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.foldM__sci_Queue__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return G.tailRecM__O__F1__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), fa, z), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((in$1) => $ps_Lcats_instances_QueueInstances__step$1__Lcats_Monad__F2__T2__O(G, f, in$1))));
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.empty__O = (function() {
  return $m_sci_Queue$EmptyQueue$();
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  return x.appendedAll__sc_IterableOnce__sci_Queue(y);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.pure__O__O = (function(x) {
  return this.pure__O__sci_Queue(x);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedIterableOps__map__F1__O(fa, f);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedIterableOps__flatMap__F1__O(fa, f);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__sci_Queue__sci_Queue__F2__sci_Queue(fa, fb, f);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__sci_Queue__Lcats_Eval__F2__Lcats_Eval(fa, fb, f);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__sci_Queue(a, f);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_LinearSeqOps__foldLeft__O__F2__O(fa, b, f);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__sci_Queue__Lcats_Eval__F2__Lcats_Eval(fa, lb, f);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__sci_Queue__F1__Lcats_kernel_Monoid__O(fa, f, B);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__sci_Queue__F1__Lcats_Applicative__O(fa, f, evidence$1);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.traverseVoid__O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return this.traverseVoid__sci_Queue__F1__Lcats_Applicative__O(fa, f, G);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.exists__O__F1__Z = (function(fa, p) {
  return fa.exists__F1__Z(p);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return this.foldM__sci_Queue__O__F2__Lcats_Monad__O(fa, z, f, G);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.toList__O__sci_List = (function(fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(fa);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.toIterable__O__sc_Iterable = (function(fa) {
  return fa;
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return $m_Lcats_kernel_instances_QueueMonoid$().Lcats_kernel_instances_QueueMonoid$__f_singleton;
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.compose__Lcats_Applicative__Lcats_Applicative = (function(evidence$1) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Alternative$$anon$1(evidence$1, this);
});
var $d_Lcats_instances_QueueInstances$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_QueueInstances$$anon$1, "cats.instances.QueueInstances$$anon$1", ({
  Lcats_instances_QueueInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1
}));
export { $d_Lcats_instances_QueueInstances$$anon$1 as $d_Lcats_instances_QueueInstances$$anon$1 };
/** @constructor */
function $c_Lcats_instances_LazyListInstances$$anon$1() {
}
export { $c_Lcats_instances_LazyListInstances$$anon$1 as $c_Lcats_instances_LazyListInstances$$anon$1 };
$c_Lcats_instances_LazyListInstances$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.constructor = $c_Lcats_instances_LazyListInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_LazyListInstances$$anon$1() {
}
export { $h_Lcats_instances_LazyListInstances$$anon$1 as $h_Lcats_instances_LazyListInstances$$anon$1 };
$h_Lcats_instances_LazyListInstances$$anon$1.prototype = $c_Lcats_instances_LazyListInstances$$anon$1.prototype;
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return fa.map__F1__sci_LazyList(f);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.void__O__O = (function(fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.size__O__J = (function(fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_UnorderedFoldable__size__O__J(this, fa);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.traverseVoid__O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Foldable__traverseVoid__O__F1__Lcats_Applicative__O(this, fa, f, G);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.unorderedFoldMap__O__F1__Lcats_kernel_CommutativeMonoid__O = (function(fa, f, evidence$1) {
  return this.foldMap__sci_LazyList__F1__Lcats_kernel_Monoid__O(fa, f, evidence$1);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.unit__O = (function() {
  return this.pure__O__sci_LazyList((void 0));
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.flatten__O__O = (function(ffa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.ap__O__O__O = (function(ff, fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.combineK__sci_LazyList__sci_LazyList__sci_LazyList = (function(x, y) {
  return x.lazyAppendedAll__F0__sci_LazyList(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => y)));
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.pure__O__sci_LazyList = (function(x) {
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_LazyList$();
  var elems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([x]));
  return this$1.from__sc_IterableOnce__sci_LazyList(elems);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.map2__sci_LazyList__sci_LazyList__F2__sci_LazyList = (function(fa, fb, f) {
  if ((fb.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) {
    var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_LazyList$();
    return this$1.sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty;
  } else {
    return fa.flatMap__F1__sci_LazyList(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((a) => fb.map__F1__sci_LazyList(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((b) => f.apply__O__O__O(a, b)))))));
  }
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.map2Eval__sci_LazyList__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  if ((fa.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Eval$();
    var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_LazyList$();
    var a = this$1.sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty;
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Now(a);
  } else {
    return fb.map__F1__Lcats_Eval(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((fb$2) => this.map2__sci_LazyList__sci_LazyList__F2__sci_LazyList(fa, fb$2, f))));
  }
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.foldRight__sci_LazyList__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Now(fa).flatMap__F1__Lcats_Eval(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s) => {
    if ((s.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) {
      return lb;
    } else {
      var $x_1 = s.head__O();
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Eval$();
      var a = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((s$2) => (() => this.foldRight__sci_LazyList__Lcats_Eval__F2__Lcats_Eval(s$2.tail__sci_LazyList(), lb, f)))(s));
      return f.apply__O__O__O($x_1, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Eval$$anon$5(a));
    }
  })));
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.foldMap__sci_LazyList__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var this$1 = fa.iterator__sc_Iterator();
  return B.combineAll__sc_IterableOnce__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(this$1, f));
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.traverse__sci_LazyList__F1__Lcats_Applicative__O = (function(fa, f, G) {
  var a = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_LazyList$();
    return G.pure__O__O(this$1.sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty);
  }));
  return this.foldRight__sci_LazyList__Lcats_Eval__F2__Lcats_Eval(fa, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Always(a), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((a$1, lgsb) => G.map2Eval__O__Lcats_Eval__F2__Lcats_Eval(f.apply__O__O(a$1), lgsb, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((_$3, _$4) => {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_LazyList$();
    var l = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((_$4$2) => (() => _$4$2))(_$4));
    return $m_sci_LazyList$Deferrer$().$hash$colon$colon$extension__F0__F0__sci_LazyList(l, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => _$3)));
  })))))).value__O();
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.tailRecM__O__F1__sci_LazyList = (function(a, fn) {
  var xs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_s_util_Left.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(a)]));
  var init = xs.iterator__sc_Iterator();
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((it) => {
    if ((!it.hasNext__Z())) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    } else {
      var x1 = it.next__O();
      if ((x1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
        var a$1 = x1.s_util_Left__f_value;
        var _1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        var this$3 = fn.apply__O__O(a$1).iterator__sc_Iterator();
        var xs$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((it$2) => (() => it$2))(it));
        var _2 = this$3.concat__F0__sc_Iterator(xs$1);
        var value = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, _2);
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
      }
      if ((x1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
        var b = x1.s_util_Right__f_value;
        var _1$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(b);
        var value$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1$1, it);
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value$1);
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1);
    }
  }));
  var kernel = new $c_sc_Iterator$UnfoldIterator(init, f);
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_LazyList$();
  var pf = new $c_Lcats_instances_LazyListInstances$$anon$2();
  return $x_1.from__sc_IterableOnce__sci_LazyList(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$7(kernel, pf));
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.foldM__sci_LazyList__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return G.tailRecM__O__F1__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), fa, z), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((in$1) => $ps_Lcats_instances_LazyListInstances__step$1__Lcats_Monad__F2__T2__O(G, f, in$1))));
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.empty__O = (function() {
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_LazyList$();
  return this$1.sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty;
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  return this.combineK__sci_LazyList__sci_LazyList__sci_LazyList(x, y);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.pure__O__O = (function(x) {
  return this.pure__O__sci_LazyList(x);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  return fa.map__F1__sci_LazyList(f);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  return fa.flatMap__F1__sci_LazyList(f);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__sci_LazyList__sci_LazyList__F2__sci_LazyList(fa, fb, f);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__sci_LazyList__Lcats_Eval__F2__Lcats_Eval(fa, fb, f);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  return fa.foldLeft__O__F2__O(b, f);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__sci_LazyList__Lcats_Eval__F2__Lcats_Eval(fa, lb, f);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__sci_LazyList__F1__Lcats_kernel_Monoid__O(fa, f, B);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__sci_LazyList__F1__Lcats_Applicative__O(fa, f, evidence$1);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__sci_LazyList(a, f);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.exists__O__F1__Z = (function(fa, p) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_LinearSeqOps__exists__F1__Z(fa, p);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return this.foldM__sci_LazyList__O__F2__Lcats_Monad__O(fa, z, f, G);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.toList__O__sci_List = (function(fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(fa);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.toIterable__O__sc_Iterable = (function(fa) {
  return fa;
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return $m_Lcats_kernel_instances_LazyListMonoid$().Lcats_kernel_instances_LazyListMonoid$__f_singleton;
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.compose__Lcats_Applicative__Lcats_Applicative = (function(evidence$1) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Alternative$$anon$1(evidence$1, this);
});
var $d_Lcats_instances_LazyListInstances$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_LazyListInstances$$anon$1, "cats.instances.LazyListInstances$$anon$1", ({
  Lcats_instances_LazyListInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
}));
export { $d_Lcats_instances_LazyListInstances$$anon$1 as $d_Lcats_instances_LazyListInstances$$anon$1 };
/** @constructor */
function $c_Lcats_instances_StreamInstances$$anon$1() {
}
export { $c_Lcats_instances_StreamInstances$$anon$1 as $c_Lcats_instances_StreamInstances$$anon$1 };
$c_Lcats_instances_StreamInstances$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_StreamInstances$$anon$1.prototype.constructor = $c_Lcats_instances_StreamInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_StreamInstances$$anon$1() {
}
export { $h_Lcats_instances_StreamInstances$$anon$1 as $h_Lcats_instances_StreamInstances$$anon$1 };
$h_Lcats_instances_StreamInstances$$anon$1.prototype = $c_Lcats_instances_StreamInstances$$anon$1.prototype;
$c_Lcats_instances_StreamInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return fa.map__F1__sci_Stream(f);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.void__O__O = (function(fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.size__O__J = (function(fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_UnorderedFoldable__size__O__J(this, fa);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.traverseVoid__O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Foldable__traverseVoid__O__F1__Lcats_Applicative__O(this, fa, f, G);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.unorderedFoldMap__O__F1__Lcats_kernel_CommutativeMonoid__O = (function(fa, f, evidence$1) {
  return this.foldMap__sci_Stream__F1__Lcats_kernel_Monoid__O(fa, f, evidence$1);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.unit__O = (function() {
  return this.pure__O__sci_Stream((void 0));
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.flatten__O__O = (function(ffa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.ap__O__O__O = (function(ff, fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.empty__sci_Stream = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Stream$Empty$();
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.combineK__sci_Stream__sci_Stream__sci_Stream = (function(x, y) {
  var l = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => y));
  return x.lazyAppendedAll__F0__sci_Stream(l);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.pure__O__sci_Stream = (function(x) {
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Stream$();
  var elems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([x]));
  return this$1.from__sc_IterableOnce__sci_Stream(elems);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.map2__sci_Stream__sci_Stream__F2__sci_Stream = (function(fa, fb, f) {
  return (fb.isEmpty__Z() ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Stream$Empty$() : fa.flatMap__F1__sci_Stream(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((a) => fb.map__F1__sci_Stream(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((b) => f.apply__O__O__O(a, b))))))));
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.map2Eval__sci_Stream__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  if (fa.isEmpty__Z()) {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Eval$();
    var a = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Stream$Empty$();
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Now(a);
  } else {
    return fb.map__F1__Lcats_Eval(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((fb$2) => this.map2__sci_Stream__sci_Stream__F2__sci_Stream(fa, fb$2, f))));
  }
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.foldRight__sci_Stream__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Now(fa).flatMap__F1__Lcats_Eval(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s) => {
    if (s.isEmpty__Z()) {
      return lb;
    } else {
      var $x_1 = s.head__O();
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Eval$();
      var a = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((s$2) => (() => this.foldRight__sci_Stream__Lcats_Eval__F2__Lcats_Eval(s$2.tail__sci_Stream(), lb, f)))(s));
      return f.apply__O__O__O($x_1, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Eval$$anon$5(a));
    }
  })));
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.foldMap__sci_Stream__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_LinearSeqOps__iterator__sc_Iterator(fa);
  return B.combineAll__sc_IterableOnce__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(this$1, f));
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.traverse__sci_Stream__F1__Lcats_Applicative__O = (function(fa, f, G) {
  var a = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => G.pure__O__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Stream$Empty$())));
  return this.foldRight__sci_Stream__Lcats_Eval__F2__Lcats_Eval(fa, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Always(a), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((a$1, lgsb) => G.map2Eval__O__Lcats_Eval__F2__Lcats_Eval(f.apply__O__O(a$1), lgsb, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((_$2, _$3) => {
    var l = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((_$3$2) => (() => _$3$2))(_$3));
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_Stream$Cons(_$2, l);
  })))))).value__O();
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.tailRecM__O__F1__sci_Stream = (function(a, fn) {
  var it = new $c_Lcats_instances_StreamInstances$$anon$2(fn, a);
  var factory = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Stream$();
  var factory$1 = new $c_sc_IterableFactory$ToFactory(factory);
  return factory$1.fromSpecific__sc_IterableOnce__O(it);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.foldM__sci_Stream__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return G.tailRecM__O__F1__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), fa, z), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((in$1) => $ps_Lcats_instances_StreamInstances__step$1__Lcats_Monad__F2__T2__O(G, f, in$1))));
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.empty__O = (function() {
  return this.empty__sci_Stream();
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  return this.combineK__sci_Stream__sci_Stream__sci_Stream(x, y);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.pure__O__O = (function(x) {
  return this.pure__O__sci_Stream(x);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  return fa.map__F1__sci_Stream(f);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  return fa.flatMap__F1__sci_Stream(f);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__sci_Stream__sci_Stream__F2__sci_Stream(fa, fb, f);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__sci_Stream__Lcats_Eval__F2__Lcats_Eval(fa, fb, f);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  return fa.foldLeft__O__F2__O(b, f);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__sci_Stream__Lcats_Eval__F2__Lcats_Eval(fa, lb, f);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__sci_Stream__F1__Lcats_kernel_Monoid__O(fa, f, B);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__sci_Stream__F1__Lcats_Applicative__O(fa, f, evidence$1);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__sci_Stream(a, f);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.exists__O__F1__Z = (function(fa, p) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_LinearSeqOps__exists__F1__Z(fa, p);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return this.foldM__sci_Stream__O__F2__Lcats_Monad__O(fa, z, f, G);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.toList__O__sci_List = (function(fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(fa);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.toIterable__O__sc_Iterable = (function(fa) {
  return fa;
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_kernel_instances_StreamMonoid();
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.compose__Lcats_Applicative__Lcats_Applicative = (function(evidence$1) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Alternative$$anon$1(evidence$1, this);
});
var $d_Lcats_instances_StreamInstances$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_StreamInstances$$anon$1, "cats.instances.StreamInstances$$anon$1", ({
  Lcats_instances_StreamInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
}));
export { $d_Lcats_instances_StreamInstances$$anon$1 as $d_Lcats_instances_StreamInstances$$anon$1 };
/** @constructor */
function $c_sci_LongMap$Bin(prefix, mask, left, right) {
  this.sci_LongMap$Bin__f_prefix = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0;
  this.sci_LongMap$Bin__f_mask = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0;
  this.sci_LongMap$Bin__f_left = null;
  this.sci_LongMap$Bin__f_right = null;
  this.sci_LongMap$Bin__f_prefix = prefix;
  this.sci_LongMap$Bin__f_mask = mask;
  this.sci_LongMap$Bin__f_left = left;
  this.sci_LongMap$Bin__f_right = right;
}
export { $c_sci_LongMap$Bin as $c_sci_LongMap$Bin };
$c_sci_LongMap$Bin.prototype = new $h_sci_LongMap();
$c_sci_LongMap$Bin.prototype.constructor = $c_sci_LongMap$Bin;
/** @constructor */
function $h_sci_LongMap$Bin() {
}
export { $h_sci_LongMap$Bin as $h_sci_LongMap$Bin };
$h_sci_LongMap$Bin.prototype = $c_sci_LongMap$Bin.prototype;
$c_sci_LongMap$Bin.prototype.productPrefix__T = (function() {
  return "Bin";
});
$c_sci_LongMap$Bin.prototype.productArity__I = (function() {
  return 4;
});
$c_sci_LongMap$Bin.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.sci_LongMap$Bin__f_prefix;
      break;
    }
    case 1: {
      return this.sci_LongMap$Bin__f_mask;
      break;
    }
    case 2: {
      return this.sci_LongMap$Bin__f_left;
      break;
    }
    case 3: {
      return this.sci_LongMap$Bin__f_right;
      break;
    }
    default: {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ioobe__I__O(x$1);
    }
  }
});
$c_sci_LongMap$Bin.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_ScalaRunTime$$anon$1(this);
});
$c_sci_LongMap$Bin.prototype.productElementName__I__T = (function(x$1) {
  switch (x$1) {
    case 0: {
      return "prefix";
      break;
    }
    case 1: {
      return "mask";
      break;
    }
    case 2: {
      return "left";
      break;
    }
    case 3: {
      return "right";
      break;
    }
    default: {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ioobe__I__O(x$1);
    }
  }
});
function $isArrayOf_sci_LongMap$Bin(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_LongMap$Bin)));
}
export { $isArrayOf_sci_LongMap$Bin as $isArrayOf_sci_LongMap$Bin };
var $d_sci_LongMap$Bin = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sci_LongMap$Bin, "scala.collection.immutable.LongMap$Bin", ({
  sci_LongMap$Bin: 1,
  sci_LongMap: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sci_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1
}));
export { $d_sci_LongMap$Bin as $d_sci_LongMap$Bin };
/** @constructor */
function $c_sci_LongMap$Nil$() {
}
export { $c_sci_LongMap$Nil$ as $c_sci_LongMap$Nil$ };
$c_sci_LongMap$Nil$.prototype = new $h_sci_LongMap();
$c_sci_LongMap$Nil$.prototype.constructor = $c_sci_LongMap$Nil$;
/** @constructor */
function $h_sci_LongMap$Nil$() {
}
export { $h_sci_LongMap$Nil$ as $h_sci_LongMap$Nil$ };
$h_sci_LongMap$Nil$.prototype = $c_sci_LongMap$Nil$.prototype;
$c_sci_LongMap$Nil$.prototype.productElementName__I__T = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_Product__productElementName__I__T(this, n);
});
$c_sci_LongMap$Nil$.prototype.equals__O__Z = (function(that) {
  return ((that === this) || ((!(that instanceof $c_sci_LongMap)) && $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_Map__equals__O__Z(this, that)));
});
$c_sci_LongMap$Nil$.prototype.productPrefix__T = (function() {
  return "Nil";
});
$c_sci_LongMap$Nil$.prototype.productArity__I = (function() {
  return 0;
});
$c_sci_LongMap$Nil$.prototype.productElement__I__O = (function(x$1) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ioobe__I__O(x$1);
});
$c_sci_LongMap$Nil$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_ScalaRunTime$$anon$1(this);
});
var $d_sci_LongMap$Nil$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sci_LongMap$Nil$, "scala.collection.immutable.LongMap$Nil$", ({
  sci_LongMap$Nil$: 1,
  sci_LongMap: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sci_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1
}));
export { $d_sci_LongMap$Nil$ as $d_sci_LongMap$Nil$ };
var $n_sci_LongMap$Nil$;
function $m_sci_LongMap$Nil$() {
  if ((!$n_sci_LongMap$Nil$)) {
    $n_sci_LongMap$Nil$ = new $c_sci_LongMap$Nil$();
  }
  return $n_sci_LongMap$Nil$;
}
export { $m_sci_LongMap$Nil$ as $m_sci_LongMap$Nil$ };
/** @constructor */
function $c_sci_LongMap$Tip(key, value) {
  this.sci_LongMap$Tip__f_key = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0;
  this.sci_LongMap$Tip__f_value = null;
  this.sci_LongMap$Tip__f_key = key;
  this.sci_LongMap$Tip__f_value = value;
}
export { $c_sci_LongMap$Tip as $c_sci_LongMap$Tip };
$c_sci_LongMap$Tip.prototype = new $h_sci_LongMap();
$c_sci_LongMap$Tip.prototype.constructor = $c_sci_LongMap$Tip;
/** @constructor */
function $h_sci_LongMap$Tip() {
}
export { $h_sci_LongMap$Tip as $h_sci_LongMap$Tip };
$h_sci_LongMap$Tip.prototype = $c_sci_LongMap$Tip.prototype;
$c_sci_LongMap$Tip.prototype.productPrefix__T = (function() {
  return "Tip";
});
$c_sci_LongMap$Tip.prototype.productArity__I = (function() {
  return 2;
});
$c_sci_LongMap$Tip.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.sci_LongMap$Tip__f_key;
      break;
    }
    case 1: {
      return this.sci_LongMap$Tip__f_value;
      break;
    }
    default: {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ioobe__I__O(x$1);
    }
  }
});
$c_sci_LongMap$Tip.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_ScalaRunTime$$anon$1(this);
});
$c_sci_LongMap$Tip.prototype.productElementName__I__T = (function(x$1) {
  switch (x$1) {
    case 0: {
      return "key";
      break;
    }
    case 1: {
      return "value";
      break;
    }
    default: {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ioobe__I__O(x$1);
    }
  }
});
function $isArrayOf_sci_LongMap$Tip(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_LongMap$Tip)));
}
export { $isArrayOf_sci_LongMap$Tip as $isArrayOf_sci_LongMap$Tip };
var $d_sci_LongMap$Tip = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sci_LongMap$Tip, "scala.collection.immutable.LongMap$Tip", ({
  sci_LongMap$Tip: 1,
  sci_LongMap: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sci_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1
}));
export { $d_sci_LongMap$Tip as $d_sci_LongMap$Tip };
/** @constructor */
function $c_sjs_js_WrappedDictionary(dict) {
  this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict = null;
  this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict = dict;
}
export { $c_sjs_js_WrappedDictionary as $c_sjs_js_WrappedDictionary };
$c_sjs_js_WrappedDictionary.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_scm_AbstractMap();
$c_sjs_js_WrappedDictionary.prototype.constructor = $c_sjs_js_WrappedDictionary;
/** @constructor */
function $h_sjs_js_WrappedDictionary() {
}
export { $h_sjs_js_WrappedDictionary as $h_sjs_js_WrappedDictionary };
$h_sjs_js_WrappedDictionary.prototype = $c_sjs_js_WrappedDictionary.prototype;
$c_sjs_js_WrappedDictionary.prototype.fromSpecific__sc_IterableOnce__sjs_js_WrappedDictionary = (function(coll) {
  var d = new $c_sjs_js_WrappedDictionary(({}));
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(d, coll);
  return d;
});
$c_sjs_js_WrappedDictionary.prototype.get__T__s_Option = (function(key) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  if ((!(!$m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key)))) {
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key]);
  } else {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
});
$c_sjs_js_WrappedDictionary.prototype.apply__T__O = (function(key) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  if ((!(!$m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key)))) {
    return this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key];
  } else {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_ju_NoSuchElementException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_ju_NoSuchElementException(), ("key not found: " + key));
  }
});
$c_sjs_js_WrappedDictionary.prototype.getOrElse__T__F0__O = (function(key, default$1) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  if ((!(!$m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key)))) {
    return this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key];
  } else {
    return default$1.apply__O();
  }
});
$c_sjs_js_WrappedDictionary.prototype.getOrElseUpdate__T__F0__O = (function(key, op) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  if ((!(!$m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key)))) {
    return this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key];
  } else {
    var v = op.apply__O();
    this.update__T__O__V(key, v);
    return v;
  }
});
$c_sjs_js_WrappedDictionary.prototype.subtractOne__T__sjs_js_WrappedDictionary = (function(key) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  if ((!(!$m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key)))) {
    delete this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key];
  }
  return this;
});
$c_sjs_js_WrappedDictionary.prototype.update__T__O__V = (function(key, value) {
  this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key] = value;
});
$c_sjs_js_WrappedDictionary.prototype.addOne__T2__sjs_js_WrappedDictionary = (function(kv) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  var key = kv._1__O();
  var value = kv._2__O();
  dict[key] = value;
  return this;
});
$c_sjs_js_WrappedDictionary.prototype.iterator__sc_Iterator = (function() {
  return new $c_sjs_js_WrappedDictionary$DictionaryIterator(this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict);
});
$c_sjs_js_WrappedDictionary.prototype.keys__sc_Iterable = (function() {
  var array = Object.keys(this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict);
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_sjs_js_WrappedArray__sjs_js_Array__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjs_js_WrappedArray(), array);
});
$c_sjs_js_WrappedDictionary.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__sjs_js_WrappedDictionary(elem);
});
$c_sjs_js_WrappedDictionary.prototype.update__O__O__V = (function(key, value) {
  this.update__T__O__V(key, value);
});
$c_sjs_js_WrappedDictionary.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__T__sjs_js_WrappedDictionary(elem);
});
$c_sjs_js_WrappedDictionary.prototype.contains__O__Z = (function(key) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  return (!(!$m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key)));
});
$c_sjs_js_WrappedDictionary.prototype.getOrElseUpdate__O__F0__O = (function(key, defaultValue) {
  return this.getOrElseUpdate__T__F0__O(key, defaultValue);
});
$c_sjs_js_WrappedDictionary.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return this.getOrElse__T__F0__O(key, default$1);
});
$c_sjs_js_WrappedDictionary.prototype.apply__O__O = (function(key) {
  return this.apply__T__O(key);
});
$c_sjs_js_WrappedDictionary.prototype.get__O__s_Option = (function(key) {
  return this.get__T__s_Option(key);
});
$c_sjs_js_WrappedDictionary.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sjs_js_WrappedDictionary(coll);
});
$c_sjs_js_WrappedDictionary.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sjs_js_WrappedDictionary(coll);
});
var $d_sjs_js_WrappedDictionary = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sjs_js_WrappedDictionary, "scala.scalajs.js.WrappedDictionary", ({
  sjs_js_WrappedDictionary: 1,
  scm_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  scm_Map: 1,
  scm_Iterable: 1,
  scm_MapOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1
}));
export { $d_sjs_js_WrappedDictionary as $d_sjs_js_WrappedDictionary };
function $ct_Lcats_data_AbstractNonEmptyInstances__Lcats_Monad__Lcats_CoflatMap__Lcats_Traverse__Lcats_Alternative__($thiz, MF, CF, TF, SF) {
  $thiz.Lcats_data_AbstractNonEmptyInstances__f_monadInstance = MF;
  $thiz.Lcats_data_AbstractNonEmptyInstances__f_traverseInstance = TF;
  $thiz.Lcats_data_AbstractNonEmptyInstances__f_alternativeInstance = SF;
  return $thiz;
}
export { $ct_Lcats_data_AbstractNonEmptyInstances__Lcats_Monad__Lcats_CoflatMap__Lcats_Traverse__Lcats_Alternative__ as $ct_Lcats_data_AbstractNonEmptyInstances__Lcats_Monad__Lcats_CoflatMap__Lcats_Traverse__Lcats_Alternative__ };
/** @constructor */
function $c_Lcats_data_AbstractNonEmptyInstances() {
  this.Lcats_data_AbstractNonEmptyInstances__f_monadInstance = null;
  this.Lcats_data_AbstractNonEmptyInstances__f_traverseInstance = null;
  this.Lcats_data_AbstractNonEmptyInstances__f_alternativeInstance = null;
}
export { $c_Lcats_data_AbstractNonEmptyInstances as $c_Lcats_data_AbstractNonEmptyInstances };
$c_Lcats_data_AbstractNonEmptyInstances.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_data_AbstractNonEmptyInstances.prototype.constructor = $c_Lcats_data_AbstractNonEmptyInstances;
/** @constructor */
function $h_Lcats_data_AbstractNonEmptyInstances() {
}
export { $h_Lcats_data_AbstractNonEmptyInstances as $h_Lcats_data_AbstractNonEmptyInstances };
$h_Lcats_data_AbstractNonEmptyInstances.prototype = $c_Lcats_data_AbstractNonEmptyInstances.prototype;
$c_Lcats_data_AbstractNonEmptyInstances.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return this.Lcats_data_AbstractNonEmptyInstances__f_monadInstance.map__O__F1__O(fa, f);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.void__O__O = (function(fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.as__O__O__O = (function(fa, b) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.flatten__O__O = (function(ffa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.ap__O__O__O = (function(ff, fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.product__O__O__O = (function(fa, fb) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.productL__O__O__O = (function(fa, fb) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.unit__O = (function() {
  return this.Lcats_data_AbstractNonEmptyInstances__f_monadInstance.pure__O__O((void 0));
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.toIterable__O__sc_Iterable = (function(fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_compat_FoldableCompat$().toIterable__O__Lcats_Foldable__sc_Iterable(fa, this);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.traverseVoid__O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Foldable__traverseVoid__O__F1__Lcats_Applicative__O(this, fa, f, G);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.unorderedFoldMap__O__F1__Lcats_kernel_CommutativeMonoid__O = (function(fa, f, evidence$1) {
  return this.Lcats_data_AbstractNonEmptyInstances__f_traverseInstance.foldMap__O__F1__Lcats_kernel_Monoid__O(fa, f, evidence$1);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_SemigroupK$$anon$1(this);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.combineK__O__O__O = (function(a, b) {
  return this.Lcats_data_AbstractNonEmptyInstances__f_alternativeInstance.combineK__O__O__O(a, b);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.pure__O__O = (function(x) {
  return this.Lcats_data_AbstractNonEmptyInstances__f_monadInstance.pure__O__O(x);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.map__O__F1__O = (function(fa, f) {
  return this.Lcats_data_AbstractNonEmptyInstances__f_monadInstance.map__O__F1__O(fa, f);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.flatMap__O__F1__O = (function(fa, f) {
  return this.Lcats_data_AbstractNonEmptyInstances__f_monadInstance.flatMap__O__F1__O(fa, f);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.Lcats_data_AbstractNonEmptyInstances__f_monadInstance.map2__O__O__F2__O(fa, fb, f);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.Lcats_data_AbstractNonEmptyInstances__f_monadInstance.map2Eval__O__Lcats_Eval__F2__Lcats_Eval(fa, fb, f);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.Lcats_data_AbstractNonEmptyInstances__f_monadInstance.tailRecM__O__F1__O(a, f);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  return this.Lcats_data_AbstractNonEmptyInstances__f_traverseInstance.foldLeft__O__O__F2__O(fa, b, f);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.Lcats_data_AbstractNonEmptyInstances__f_traverseInstance.foldRight__O__Lcats_Eval__F2__Lcats_Eval(fa, lb, f);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.Lcats_data_AbstractNonEmptyInstances__f_traverseInstance.foldMap__O__F1__Lcats_kernel_Monoid__O(fa, f, B);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return this.Lcats_data_AbstractNonEmptyInstances__f_traverseInstance.traverse__O__F1__Lcats_Applicative__O(fa, f, G);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.exists__O__F1__Z = (function(fa, p) {
  return this.Lcats_data_AbstractNonEmptyInstances__f_traverseInstance.exists__O__F1__Z(fa, p);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return this.Lcats_data_AbstractNonEmptyInstances__f_traverseInstance.foldM__O__O__F2__Lcats_Monad__O(fa, z, f, G);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.toList__O__sci_List = (function(fa) {
  return this.Lcats_data_AbstractNonEmptyInstances__f_traverseInstance.toList__O__sci_List(fa);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.compose__Lcats_Applicative__Lcats_Applicative = (function(evidence$1) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_NonEmptyAlternative$$anon$1(evidence$1, this);
});
function $f_Lcats_effect_kernel_Async__never__O($thiz) {
  var k = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$4) => {
    var value = $m_Lcats_effect_IO$().Lcats_effect_IO$__f__unit;
    var x = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
    $m_Lcats_effect_IO$();
    return new $c_Lcats_effect_IO$Pure(x);
  }));
  return $m_Lcats_effect_IO$().async__F1__Lcats_effect_IO(k);
}
export { $f_Lcats_effect_kernel_Async__never__O as $f_Lcats_effect_kernel_Async__never__O };
function $f_Lcats_effect_kernel_Async__fromFuture__O__O($thiz, fut) {
  var fa$1 = $thiz.Lcats_effect_IO$IOAsync__f_executionContext;
  var f$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((ec) => {
    var body = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((ec$2) => ((poll) => {
      var fa = poll.apply__O__O(fut);
      var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((f) => {
        var k = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((f$2) => ((cb) => {
          f$2.onComplete__F1__s_concurrent_ExecutionContext__V(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((cb$2) => ((t) => {
            cb$2.apply__O__O(t.toEither__s_util_Either());
          }))(cb)), ec$2);
        }))(f));
        return $m_Lcats_effect_IO$().async___F1__Lcats_effect_IO(k);
      }));
      return fa.flatMap__F1__Lcats_effect_IO(f$1);
    }))(ec));
    return $m_Lcats_effect_IO$().uncancelable__F1__Lcats_effect_IO(body);
  }));
  return fa$1.flatMap__F1__Lcats_effect_IO(f$3);
}
export { $f_Lcats_effect_kernel_Async__fromFuture__O__O as $f_Lcats_effect_kernel_Async__fromFuture__O__O };
function $is_Lcats_effect_kernel_Async(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_kernel_Async)));
}
export { $is_Lcats_effect_kernel_Async as $is_Lcats_effect_kernel_Async };
function $isArrayOf_Lcats_effect_kernel_Async(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Async)));
}
export { $isArrayOf_Lcats_effect_kernel_Async as $isArrayOf_Lcats_effect_kernel_Async };
/** @constructor */
function $c_Lcats_data_NonEmptyChainInstances$$anon$1() {
  this.Lcats_data_AbstractNonEmptyInstances__f_monadInstance = null;
  this.Lcats_data_AbstractNonEmptyInstances__f_traverseInstance = null;
  this.Lcats_data_AbstractNonEmptyInstances__f_alternativeInstance = null;
  $ct_Lcats_data_AbstractNonEmptyInstances__Lcats_Monad__Lcats_CoflatMap__Lcats_Traverse__Lcats_Alternative__(this, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_Chain$().Lcats_data_ChainInstances__f_catsDataInstancesForChain, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_Chain$().Lcats_data_ChainInstances__f_catsDataInstancesForChain, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_Chain$().Lcats_data_ChainInstances__f_catsDataInstancesForChain, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_Chain$().Lcats_data_ChainInstances__f_catsDataInstancesForChain);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_Chain$();
}
export { $c_Lcats_data_NonEmptyChainInstances$$anon$1 as $c_Lcats_data_NonEmptyChainInstances$$anon$1 };
$c_Lcats_data_NonEmptyChainInstances$$anon$1.prototype = new $h_Lcats_data_AbstractNonEmptyInstances();
$c_Lcats_data_NonEmptyChainInstances$$anon$1.prototype.constructor = $c_Lcats_data_NonEmptyChainInstances$$anon$1;
/** @constructor */
function $h_Lcats_data_NonEmptyChainInstances$$anon$1() {
}
export { $h_Lcats_data_NonEmptyChainInstances$$anon$1 as $h_Lcats_data_NonEmptyChainInstances$$anon$1 };
$h_Lcats_data_NonEmptyChainInstances$$anon$1.prototype = $c_Lcats_data_NonEmptyChainInstances$$anon$1.prototype;
$c_Lcats_data_NonEmptyChainInstances$$anon$1.prototype.size__O__J = (function(fa) {
  $m_Lcats_data_NonEmptyChainImpl$();
  return $m_Lcats_data_NonEmptyChainOps$().length$extension__O__J(fa);
});
var $d_Lcats_data_NonEmptyChainInstances$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_data_NonEmptyChainInstances$$anon$1, "cats.data.NonEmptyChainInstances$$anon$1", ({
  Lcats_data_NonEmptyChainInstances$$anon$1: 1,
  Lcats_data_AbstractNonEmptyInstances: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Comonad: 1,
  Lcats_Bimonad: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Reducible: 1,
  Lcats_NonEmptyTraverse: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_Align: 1
}));
export { $d_Lcats_data_NonEmptyChainInstances$$anon$1 as $d_Lcats_data_NonEmptyChainInstances$$anon$1 };
/** @constructor */
function $c_Lcats_effect_IO$IOAsync() {
  this.Lcats_effect_IO$IOAsync__f_cats$effect$kernel$Sync$$Delay = null;
  this.Lcats_effect_IO$IOAsync__f_executionContext = null;
  this.Lcats_effect_IO$IOAsync__f_monotonic = null;
  this.Lcats_effect_IO$IOAsync__f_realTime = null;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_effect_kernel_Sync__$init$__V(this);
  this.Lcats_effect_IO$IOAsync__f_executionContext = ($m_Lcats_effect_IO$(), $m_Lcats_effect_IO$ReadEC$());
  this.Lcats_effect_IO$IOAsync__f_monotonic = ($m_Lcats_effect_IO$(), $m_Lcats_effect_IO$Monotonic$());
  this.Lcats_effect_IO$IOAsync__f_realTime = ($m_Lcats_effect_IO$(), $m_Lcats_effect_IO$RealTime$());
}
export { $c_Lcats_effect_IO$IOAsync as $c_Lcats_effect_IO$IOAsync };
$c_Lcats_effect_IO$IOAsync.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_effect_IO$IOAsync.prototype.constructor = $c_Lcats_effect_IO$IOAsync;
/** @constructor */
function $h_Lcats_effect_IO$IOAsync() {
}
export { $h_Lcats_effect_IO$IOAsync as $h_Lcats_effect_IO$IOAsync };
$h_Lcats_effect_IO$IOAsync.prototype = $c_Lcats_effect_IO$IOAsync.prototype;
$c_Lcats_effect_IO$IOAsync.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return fa.map__F1__Lcats_effect_IO(f);
});
$c_Lcats_effect_IO$IOAsync.prototype.compose__Lcats_Applicative__Lcats_Applicative = (function(evidence$1) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Applicative$$anon$1(evidence$1, this);
});
$c_Lcats_effect_IO$IOAsync.prototype.flatten__O__O = (function(ffa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_effect_IO$IOAsync.prototype.ap__O__O__O = (function(ff, fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_effect_IO$IOAsync.prototype.product__O__O__O = (function(fa, fb) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_effect_IO$IOAsync.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_effect_IO$IOAsync.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Delay_$eq__Lcats_effect_kernel_Sync$Type$Delay$__V = (function(x$0) {
  this.Lcats_effect_IO$IOAsync__f_cats$effect$kernel$Sync$$Delay = x$0;
});
$c_Lcats_effect_IO$IOAsync.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Blocking_$eq__Lcats_effect_kernel_Sync$Type$Blocking$__V = (function(x$0) {
});
$c_Lcats_effect_IO$IOAsync.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleOnce_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleOnce$__V = (function(x$0) {
});
$c_Lcats_effect_IO$IOAsync.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleMany_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleMany$__V = (function(x$0) {
});
$c_Lcats_effect_IO$IOAsync.prototype.tailRecM__O__F1__O = (function(a, f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_StackSafeMonad__tailRecM__O__F1__O(this, a, f);
});
$c_Lcats_effect_IO$IOAsync.prototype.map2Eval__Lcats_effect_IO__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, fn) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Eval$();
  var a$1 = fa.flatMap__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((a) => fb.value__O().map__F1__Lcats_effect_IO(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((b) => fn.apply__O__O__O(a, b)))))));
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Now(a$1);
});
$c_Lcats_effect_IO$IOAsync.prototype.as__O__O__O = (function(fa, b) {
  return fa.as__O__Lcats_effect_IO(b);
});
$c_Lcats_effect_IO$IOAsync.prototype.attempt__O__O = (function(fa) {
  return new $c_Lcats_effect_IO$Attempt(fa);
});
$c_Lcats_effect_IO$IOAsync.prototype.pure__O__O = (function(x) {
  $m_Lcats_effect_IO$();
  return new $c_Lcats_effect_IO$Pure(x);
});
$c_Lcats_effect_IO$IOAsync.prototype.unit__O = (function() {
  return $m_Lcats_effect_IO$().Lcats_effect_IO$__f__unit;
});
$c_Lcats_effect_IO$IOAsync.prototype.guaranteeCase__O__F1__O = (function(fa, fin) {
  return fa.guaranteeCase__F1__Lcats_effect_IO(fin);
});
$c_Lcats_effect_IO$IOAsync.prototype.handleError__O__F1__O = (function(fa, f) {
  return fa.handleError__F1__Lcats_effect_IO(f);
});
$c_Lcats_effect_IO$IOAsync.prototype.onError__O__s_PartialFunction__O = (function(fa, pf) {
  return fa.onError__s_PartialFunction__Lcats_effect_IO(pf);
});
$c_Lcats_effect_IO$IOAsync.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  return fa.handleErrorWith__F1__Lcats_effect_IO(f);
});
$c_Lcats_effect_IO$IOAsync.prototype.raiseError__O__O = (function(e) {
  $m_Lcats_effect_IO$();
  return new $c_Lcats_effect_IO$Error(e);
});
$c_Lcats_effect_IO$IOAsync.prototype.onCancel__O__O__O = (function(fa, fin) {
  return new $c_Lcats_effect_IO$OnCancel(fa, fin);
});
$c_Lcats_effect_IO$IOAsync.prototype.bracketFull__F1__F1__F2__O = (function(acquire, use, release) {
  return $m_Lcats_effect_IO$().bracketFull__F1__F1__F2__Lcats_effect_IO(acquire, use, release);
});
$c_Lcats_effect_IO$IOAsync.prototype.monotonic__O = (function() {
  return this.Lcats_effect_IO$IOAsync__f_monotonic;
});
$c_Lcats_effect_IO$IOAsync.prototype.realTime__O = (function() {
  return this.Lcats_effect_IO$IOAsync__f_realTime;
});
$c_Lcats_effect_IO$IOAsync.prototype.productL__O__O__O = (function(fa, fb) {
  return fa.productL__Lcats_effect_IO__Lcats_effect_IO(fb);
});
$c_Lcats_effect_IO$IOAsync.prototype.productR__O__O__O = (function(fa, fb) {
  return fa.productR__Lcats_effect_IO__Lcats_effect_IO(fb);
});
$c_Lcats_effect_IO$IOAsync.prototype.uncancelable__F1__O = (function(body) {
  return $m_Lcats_effect_IO$().uncancelable__F1__Lcats_effect_IO(body);
});
$c_Lcats_effect_IO$IOAsync.prototype.map__O__F1__O = (function(fa, f) {
  return fa.map__F1__Lcats_effect_IO(f);
});
$c_Lcats_effect_IO$IOAsync.prototype.flatMap__O__F1__O = (function(fa, f) {
  return fa.flatMap__F1__Lcats_effect_IO(f);
});
$c_Lcats_effect_IO$IOAsync.prototype.delay__F0__O = (function(thunk) {
  var this$1 = $m_Lcats_effect_IO$();
  return this$1.delay__F0__Lcats_effect_IO(thunk);
});
$c_Lcats_effect_IO$IOAsync.prototype.suspend__Lcats_effect_kernel_Sync$Type__F0__O = (function(hint, thunk) {
  return $m_Lcats_effect_IO$().suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_effect_IO(hint, thunk);
});
$c_Lcats_effect_IO$IOAsync.prototype.void__O__O = (function(fa) {
  return fa.void__Lcats_effect_IO();
});
$c_Lcats_effect_IO$IOAsync.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__Lcats_effect_IO__Lcats_Eval__F2__Lcats_Eval(fa, fb, f);
});
var $d_Lcats_effect_IO$IOAsync = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_effect_IO$IOAsync, "cats.effect.IO$IOAsync", ({
  Lcats_effect_IO$IOAsync: 1,
  Lcats_effect_kernel_AsyncPlatform: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1,
  Lcats_effect_kernel_ClockPlatform: 1,
  Lcats_effect_kernel_Clock: 1,
  Lcats_effect_kernel_Unique: 1,
  Lcats_Defer: 1,
  Lcats_effect_kernel_Sync: 1,
  Lcats_effect_kernel_GenSpawn: 1,
  Lcats_effect_kernel_GenConcurrent: 1,
  Lcats_effect_kernel_GenTemporal: 1,
  Lcats_effect_kernel_Async: 1,
  Lcats_StackSafeMonad: 1
}));
export { $d_Lcats_effect_IO$IOAsync as $d_Lcats_effect_IO$IOAsync };
function $ps_sci_Queue__indexOutOfRange$1__I__E(n$1) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n$1));
}
export { $ps_sci_Queue__indexOutOfRange$1__I__E as $ps_sci_Queue__indexOutOfRange$1__I__E };
function $ct_sci_Queue__sci_List__sci_List__($thiz, in$1, out) {
  $thiz.sci_Queue__f_in = in$1;
  $thiz.sci_Queue__f_out = out;
  return $thiz;
}
export { $ct_sci_Queue__sci_List__sci_List__ as $ct_sci_Queue__sci_List__sci_List__ };
/** @constructor */
function $c_sci_Queue() {
  this.sci_Queue__f_in = null;
  this.sci_Queue__f_out = null;
}
export { $c_sci_Queue as $c_sci_Queue };
$c_sci_Queue.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sci_AbstractSeq();
$c_sci_Queue.prototype.constructor = $c_sci_Queue;
/** @constructor */
function $h_sci_Queue() {
}
export { $h_sci_Queue as $h_sci_Queue };
$h_sci_Queue.prototype = $c_sci_Queue.prototype;
$c_sci_Queue.prototype.distinctBy__F1__O = (function(f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sci_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$c_sci_Queue.prototype.updated__I__O__O = (function(index, elem) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sci_StrictOptimizedSeqOps__updated__I__O__O(this, index, elem);
});
$c_sci_Queue.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord);
});
$c_sci_Queue.prototype.diff__sc_Seq__O = (function(that) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedSeqOps__diff__sc_Seq__O(this, that);
});
$c_sci_Queue.prototype.partition__F1__T2 = (function(p) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$c_sci_Queue.prototype.map__F1__O = (function(f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_Queue.prototype.flatMap__F1__O = (function(f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_Queue.prototype.flatten__F1__O = (function(toIterableOnce) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$c_sci_Queue.prototype.filter__F1__O = (function(pred) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_sci_Queue.prototype.filterNot__F1__O = (function(pred) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$c_sci_Queue.prototype.dropRight__I__O = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_Queue.prototype.stringPrefix__T = (function() {
  return "LinearSeq";
});
$c_sci_Queue.prototype.headOption__s_Option = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_LinearSeqOps__headOption__s_Option(this);
});
$c_sci_Queue.prototype.lengthCompare__I__I = (function(len) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_LinearSeqOps__lengthCompare__I__I(this, len);
});
$c_sci_Queue.prototype.isDefinedAt__I__Z = (function(x) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x);
});
$c_sci_Queue.prototype.foreach__F1__V = (function(f) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_LinearSeqOps__foreach__F1__V(this, f);
});
$c_sci_Queue.prototype.find__F1__s_Option = (function(p) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_LinearSeqOps__find__F1__s_Option(this, p);
});
$c_sci_Queue.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_LinearSeqOps__foldLeft__O__F2__O(this, z, op);
});
$c_sci_Queue.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z(this, that);
});
$c_sci_Queue.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_LinearSeqOps__indexWhere__F1__I__I(this, p, from);
});
$c_sci_Queue.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sci_Queue$();
});
$c_sci_Queue.prototype.apply__I__O = (function(n) {
  var index = 0;
  var curr = this.sci_Queue__f_out;
  while (true) {
    if ((index < n)) {
      var this$1 = curr;
      var $x_1 = (!this$1.isEmpty__Z());
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      index = ((1 + index) | 0);
      curr = curr.tail__O();
    } else {
      break;
    }
  }
  if ((index === n)) {
    var this$2 = curr;
    if ((!this$2.isEmpty__Z())) {
      return curr.head__O();
    } else {
      var this$3 = this.sci_Queue__f_in;
      if ((!this$3.isEmpty__Z())) {
        return this.sci_Queue__f_in.last__O();
      } else {
        $ps_sci_Queue__indexOutOfRange$1__I__E(n);
      }
    }
  } else {
    var indexFromBack = ((n - index) | 0);
    var inLength = this.sci_Queue__f_in.length__I();
    if ((indexFromBack >= inLength)) {
      $ps_sci_Queue__indexOutOfRange$1__I__E(n);
    } else {
      var this$4 = this.sci_Queue__f_in;
      var n$1 = (((-1) + ((inLength - indexFromBack) | 0)) | 0);
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_LinearSeqOps__apply__I__O(this$4, n$1);
    }
  }
});
$c_sci_Queue.prototype.iterator__sc_Iterator = (function() {
  return this.sci_Queue__f_out.iterator__sc_Iterator().concat__F0__sc_Iterator(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => this.sci_Queue__f_in.reverse__sci_List())));
});
$c_sci_Queue.prototype.isEmpty__Z = (function() {
  return (this.sci_Queue__f_in.isEmpty__Z() && this.sci_Queue__f_out.isEmpty__Z());
});
$c_sci_Queue.prototype.head__O = (function() {
  var this$1 = this.sci_Queue__f_out;
  if ((!this$1.isEmpty__Z())) {
    return this.sci_Queue__f_out.head__O();
  } else {
    var this$2 = this.sci_Queue__f_in;
    if ((!this$2.isEmpty__Z())) {
      return this.sci_Queue__f_in.last__O();
    } else {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_ju_NoSuchElementException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_ju_NoSuchElementException(), "head on empty queue");
    }
  }
});
$c_sci_Queue.prototype.tail__sci_Queue = (function() {
  var this$1 = this.sci_Queue__f_out;
  if ((!this$1.isEmpty__Z())) {
    return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), this.sci_Queue__f_in, this.sci_Queue__f_out.tail__O());
  } else {
    var this$2 = this.sci_Queue__f_in;
    if ((!this$2.isEmpty__Z())) {
      return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$(), this.sci_Queue__f_in.reverse__sci_List().tail__O());
    } else {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_ju_NoSuchElementException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_ju_NoSuchElementException(), "tail on empty queue");
    }
  }
});
$c_sci_Queue.prototype.last__O = (function() {
  var this$1 = this.sci_Queue__f_in;
  if ((!this$1.isEmpty__Z())) {
    return this.sci_Queue__f_in.head__O();
  } else {
    var this$2 = this.sci_Queue__f_out;
    if ((!this$2.isEmpty__Z())) {
      return this.sci_Queue__f_out.last__O();
    } else {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_ju_NoSuchElementException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_ju_NoSuchElementException(), "last on empty queue");
    }
  }
});
$c_sci_Queue.prototype.forall__F1__Z = (function(p) {
  return (this.sci_Queue__f_in.forall__F1__Z(p) && this.sci_Queue__f_out.forall__F1__Z(p));
});
$c_sci_Queue.prototype.exists__F1__Z = (function(p) {
  return (this.sci_Queue__f_in.exists__F1__Z(p) || this.sci_Queue__f_out.exists__F1__Z(p));
});
$c_sci_Queue.prototype.className__T = (function() {
  return "Queue";
});
$c_sci_Queue.prototype.length__I = (function() {
  return ((this.sci_Queue__f_in.length__I() + this.sci_Queue__f_out.length__I()) | 0);
});
$c_sci_Queue.prototype.prepended__O__sci_Queue = (function(elem) {
  var $x_1 = this.sci_Queue__f_in;
  var this$1 = this.sci_Queue__f_out;
  return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $x_1, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem, this$1));
});
$c_sci_Queue.prototype.appendedAll__sc_IterableOnce__sci_Queue = (function(that) {
  if ((that instanceof $c_sci_Queue)) {
    var this$1 = that.sci_Queue__f_in;
    var rassoc$2 = that.sci_Queue__f_out;
    var suffix = this.sci_Queue__f_in.reverse_$colon$colon$colon__sci_List__sci_List(rassoc$2);
    var newIn = this$1.appendedAll__sc_IterableOnce__sci_List(suffix);
  } else if ((that instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_List)) {
    var newIn = this.sci_Queue__f_in.reverse_$colon$colon$colon__sci_List__sci_List(that);
  } else {
    var result = this.sci_Queue__f_in;
    var iter = that.iterator__sc_Iterator();
    while (iter.hasNext__Z()) {
      var rassoc$4 = iter.next__O();
      var this$2 = result;
      result = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(rassoc$4, this$2);
    }
    var newIn = result;
  }
  return ((newIn === this.sci_Queue__f_in) ? this : $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), newIn, this.sci_Queue__f_out));
});
$c_sci_Queue.prototype.enqueue__O__sci_Queue = (function(elem) {
  var this$1 = this.sci_Queue__f_in;
  return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem, this$1), this.sci_Queue__f_out);
});
$c_sci_Queue.prototype.dequeue__T2 = (function() {
  var x1 = this.sci_Queue__f_out;
  var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  if ((x.equals__O__Z(x1) && (!this.sci_Queue__f_in.isEmpty__Z()))) {
    var rev = this.sci_Queue__f_in.reverse__sci_List();
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), rev.head__O(), $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$(), rev.tail__O()));
  } else if ((x1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon)) {
    var x$3 = x1.sci_$colon$colon__f_head;
    var xs = x1.sci_$colon$colon__f_next;
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), x$3, $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), this.sci_Queue__f_in, xs));
  } else {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_ju_NoSuchElementException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_ju_NoSuchElementException(), "dequeue on empty queue");
  }
});
$c_sci_Queue.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__mkString__T__T__T__T(this, "Queue(", ", ", ")");
});
$c_sci_Queue.prototype.isDefinedAt__O__Z = (function(x) {
  var x$1 = (x | 0);
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x$1);
});
$c_sci_Queue.prototype.drop__I__O = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this, n, this);
});
$c_sci_Queue.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_Queue(suffix);
});
$c_sci_Queue.prototype.appended__O__O = (function(elem) {
  return this.enqueue__O__sci_Queue(elem);
});
$c_sci_Queue.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_Queue(elem);
});
$c_sci_Queue.prototype.tail__O = (function() {
  return this.tail__sci_Queue();
});
$c_sci_Queue.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O((v1 | 0));
});
$c_sci_Queue.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_Queue$();
});
function $isArrayOf_sci_Queue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Queue)));
}
export { $isArrayOf_sci_Queue as $isArrayOf_sci_Queue };
var $d_sci_Queue = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sci_Queue, "scala.collection.immutable.Queue", ({
  sci_Queue: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  sc_StrictOptimizedLinearSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Queue as $d_sci_Queue };
/** @constructor */
function $c_sci_Queue$EmptyQueue$() {
  this.sci_Queue__f_in = null;
  this.sci_Queue__f_out = null;
  $ct_sci_Queue__sci_List__sci_List__(this, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
}
export { $c_sci_Queue$EmptyQueue$ as $c_sci_Queue$EmptyQueue$ };
$c_sci_Queue$EmptyQueue$.prototype = new $h_sci_Queue();
$c_sci_Queue$EmptyQueue$.prototype.constructor = $c_sci_Queue$EmptyQueue$;
/** @constructor */
function $h_sci_Queue$EmptyQueue$() {
}
export { $h_sci_Queue$EmptyQueue$ as $h_sci_Queue$EmptyQueue$ };
$h_sci_Queue$EmptyQueue$.prototype = $c_sci_Queue$EmptyQueue$.prototype;
var $d_sci_Queue$EmptyQueue$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sci_Queue$EmptyQueue$, "scala.collection.immutable.Queue$EmptyQueue$", ({
  sci_Queue$EmptyQueue$: 1,
  sci_Queue: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  sc_StrictOptimizedLinearSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Queue$EmptyQueue$ as $d_sci_Queue$EmptyQueue$ };
var $n_sci_Queue$EmptyQueue$;
function $m_sci_Queue$EmptyQueue$() {
  if ((!$n_sci_Queue$EmptyQueue$)) {
    $n_sci_Queue$EmptyQueue$ = new $c_sci_Queue$EmptyQueue$();
  }
  return $n_sci_Queue$EmptyQueue$;
}
export { $m_sci_Queue$EmptyQueue$ as $m_sci_Queue$EmptyQueue$ };
function $p_sci_TreeSet__newSetOrSelf__sci_RedBlackTree$Tree__sci_TreeSet($thiz, t) {
  return ((t === $thiz.sci_TreeSet__f_tree) ? $thiz : $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), t, $thiz.sci_TreeSet__f_ordering));
}
export { $p_sci_TreeSet__newSetOrSelf__sci_RedBlackTree$Tree__sci_TreeSet as $p_sci_TreeSet__newSetOrSelf__sci_RedBlackTree$Tree__sci_TreeSet };
function $p_sci_TreeSet__sub$lzycompute$1__sr_LazyRef__sci_TreeSet$sub$1$($thiz, sub$module$1) {
  return (sub$module$1.sr_LazyRef__f__initialized ? sub$module$1.sr_LazyRef__f__value : sub$module$1.initialize__O__O(new $c_sci_TreeSet$sub$1$($thiz)));
}
export { $p_sci_TreeSet__sub$lzycompute$1__sr_LazyRef__sci_TreeSet$sub$1$ as $p_sci_TreeSet__sub$lzycompute$1__sr_LazyRef__sci_TreeSet$sub$1$ };
function $p_sci_TreeSet__sub$2__sr_LazyRef__sci_TreeSet$sub$1$($thiz, sub$module$1) {
  return (sub$module$1.sr_LazyRef__f__initialized ? sub$module$1.sr_LazyRef__f__value : $p_sci_TreeSet__sub$lzycompute$1__sr_LazyRef__sci_TreeSet$sub$1$($thiz, sub$module$1));
}
export { $p_sci_TreeSet__sub$2__sr_LazyRef__sci_TreeSet$sub$1$ as $p_sci_TreeSet__sub$2__sr_LazyRef__sci_TreeSet$sub$1$ };
function $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__($thiz, tree, ordering) {
  $thiz.sci_TreeSet__f_tree = tree;
  $thiz.sci_TreeSet__f_ordering = ordering;
  if ((ordering === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException(), "ordering must not be null");
  }
  return $thiz;
}
export { $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__ as $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__ };
function $ct_sci_TreeSet__s_math_Ordering__($thiz, ordering) {
  $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__($thiz, null, ordering);
  return $thiz;
}
export { $ct_sci_TreeSet__s_math_Ordering__ as $ct_sci_TreeSet__s_math_Ordering__ };
/** @constructor */
function $c_sci_TreeSet() {
  this.sci_TreeSet__f_tree = null;
  this.sci_TreeSet__f_ordering = null;
}
export { $c_sci_TreeSet as $c_sci_TreeSet };
$c_sci_TreeSet.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sci_AbstractSet();
$c_sci_TreeSet.prototype.constructor = $c_sci_TreeSet;
/** @constructor */
function $h_sci_TreeSet() {
}
export { $h_sci_TreeSet as $h_sci_TreeSet };
$h_sci_TreeSet.prototype = $c_sci_TreeSet.prototype;
$c_sci_TreeSet.prototype.map__F1__O = (function(f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_TreeSet.prototype.flatMap__F1__O = (function(f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_TreeSet.prototype.stringPrefix__T = (function() {
  return "SortedSet";
});
$c_sci_TreeSet.prototype.newSpecificBuilder__scm_Builder = (function() {
  var evidence$12 = this.sci_TreeSet__f_ordering;
  return new $c_sci_TreeSet$TreeSetBuilder(evidence$12);
});
$c_sci_TreeSet.prototype.ordering__s_math_Ordering = (function() {
  return this.sci_TreeSet__f_ordering;
});
$c_sci_TreeSet.prototype.size__I = (function() {
  return $m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(this.sci_TreeSet__f_tree);
});
$c_sci_TreeSet.prototype.isEmpty__Z = (function() {
  return ($m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(this.sci_TreeSet__f_tree) === 0);
});
$c_sci_TreeSet.prototype.head__O = (function() {
  var this$1 = $m_sci_RedBlackTree$().smallest__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree);
  return this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
});
$c_sci_TreeSet.prototype.last__O = (function() {
  var this$1 = $m_sci_RedBlackTree$().greatest__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree);
  return this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
});
$c_sci_TreeSet.prototype.tail__sci_TreeSet = (function() {
  return $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), $m_sci_RedBlackTree$().tail__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree), this.sci_TreeSet__f_ordering);
});
$c_sci_TreeSet.prototype.max__s_math_Ordering__O = (function(ord) {
  return (((ord === this.sci_TreeSet__f_ordering) && (!this.isEmpty__Z())) ? this.last__O() : $f_sc_SortedSetOps__max__s_math_Ordering__O(this, ord));
});
$c_sci_TreeSet.prototype.drop__I__sci_TreeSet = (function(n) {
  if ((n <= 0)) {
    return this;
  } else if ((n >= $m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(this.sci_TreeSet__f_tree))) {
    var evidence$6 = this.sci_TreeSet__f_ordering;
    return $ct_sci_TreeSet__s_math_Ordering__(new $c_sci_TreeSet(), evidence$6);
  } else {
    return $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), $m_sci_RedBlackTree$().drop__sci_RedBlackTree$Tree__I__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree, n, this.sci_TreeSet__f_ordering), this.sci_TreeSet__f_ordering);
  }
});
$c_sci_TreeSet.prototype.take__I__sci_TreeSet = (function(n) {
  if ((n <= 0)) {
    var evidence$6 = this.sci_TreeSet__f_ordering;
    return $ct_sci_TreeSet__s_math_Ordering__(new $c_sci_TreeSet(), evidence$6);
  } else {
    return ((n >= $m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(this.sci_TreeSet__f_tree)) ? this : $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), $m_sci_RedBlackTree$().take__sci_RedBlackTree$Tree__I__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree, n, this.sci_TreeSet__f_ordering), this.sci_TreeSet__f_ordering));
  }
});
$c_sci_TreeSet.prototype.dropRight__I__sci_TreeSet = (function(n) {
  return this.take__I__sci_TreeSet((($m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(this.sci_TreeSet__f_tree) - ((n > 0) ? n : 0)) | 0));
});
$c_sci_TreeSet.prototype.foreach__F1__V = (function(f) {
  $m_sci_RedBlackTree$().foreachKey__sci_RedBlackTree$Tree__F1__V(this.sci_TreeSet__f_tree, f);
});
$c_sci_TreeSet.prototype.iterator__sc_Iterator = (function() {
  var tree = this.sci_TreeSet__f_tree;
  var start = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var evidence$17 = this.sci_TreeSet__f_ordering;
  return new $c_sci_RedBlackTree$KeysIterator(tree, start, evidence$17);
});
$c_sci_TreeSet.prototype.contains__O__Z = (function(elem) {
  return $m_sci_RedBlackTree$().contains__sci_RedBlackTree$Tree__O__s_math_Ordering__Z(this.sci_TreeSet__f_tree, elem, this.sci_TreeSet__f_ordering);
});
$c_sci_TreeSet.prototype.incl__O__sci_TreeSet = (function(elem) {
  return $p_sci_TreeSet__newSetOrSelf__sci_RedBlackTree$Tree__sci_TreeSet(this, $m_sci_RedBlackTree$().update__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree, elem, null, false, this.sci_TreeSet__f_ordering));
});
$c_sci_TreeSet.prototype.excl__O__sci_TreeSet = (function(elem) {
  return $p_sci_TreeSet__newSetOrSelf__sci_RedBlackTree$Tree__sci_TreeSet(this, $m_sci_RedBlackTree$().delete__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree, elem, this.sci_TreeSet__f_ordering));
});
$c_sci_TreeSet.prototype.concat__sc_IterableOnce__sci_TreeSet = (function(that) {
  matchEnd4: {
    var t$2;
    if ((that instanceof $c_sci_TreeSet)) {
      var x = this.sci_TreeSet__f_ordering;
      var x$2 = that.sci_TreeSet__f_ordering;
      if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
        var t$2 = $m_sci_RedBlackTree$().union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree, that.sci_TreeSet__f_tree, this.sci_TreeSet__f_ordering);
        break matchEnd4;
      }
    }
    var it = that.iterator__sc_Iterator();
    var t = this.sci_TreeSet__f_tree;
    while (it.hasNext__Z()) {
      t = $m_sci_RedBlackTree$().update__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree(t, it.next__O(), null, false, this.sci_TreeSet__f_ordering);
    }
    var t$2 = t;
  }
  return $p_sci_TreeSet__newSetOrSelf__sci_RedBlackTree$Tree__sci_TreeSet(this, t$2);
});
$c_sci_TreeSet.prototype.removedAll__sc_IterableOnce__sci_TreeSet = (function(that) {
  if ((that instanceof $c_sci_TreeSet)) {
    var x = this.sci_TreeSet__f_ordering;
    var x$2 = that.sci_TreeSet__f_ordering;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      return $p_sci_TreeSet__newSetOrSelf__sci_RedBlackTree$Tree__sci_TreeSet(this, $m_sci_RedBlackTree$().difference__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree, that.sci_TreeSet__f_tree, this.sci_TreeSet__f_ordering));
    }
  }
  var sub$module = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_LazyRef();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__foreach__F1__V(that.iterator__sc_Iterator(), $p_sci_TreeSet__sub$2__sr_LazyRef__sci_TreeSet$sub$1$(this, sub$module));
  return $p_sci_TreeSet__newSetOrSelf__sci_RedBlackTree$Tree__sci_TreeSet(this, $p_sci_TreeSet__sub$2__sr_LazyRef__sci_TreeSet$sub$1$(this, sub$module).sci_TreeSet$sub$1$__f_currentTree);
});
$c_sci_TreeSet.prototype.filter__F1__sci_TreeSet = (function(f) {
  return $p_sci_TreeSet__newSetOrSelf__sci_RedBlackTree$Tree__sci_TreeSet(this, $m_sci_RedBlackTree$().filterEntries__sci_RedBlackTree$Tree__F2__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((k$2$2, x$13$2$2) => (!(!f.apply__O__O(k$2$2)))))));
});
$c_sci_TreeSet.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_sci_TreeSet)) {
    var x = this.sci_TreeSet__f_ordering;
    var x$2 = obj.sci_TreeSet__f_ordering;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      return $m_sci_RedBlackTree$().keysEqual__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__Z(this.sci_TreeSet__f_tree, obj.sci_TreeSet__f_tree, this.sci_TreeSet__f_ordering);
    }
  }
  return $f_sc_SortedSet__equals__O__Z(this, obj);
});
$c_sci_TreeSet.prototype.className__T = (function() {
  return "TreeSet";
});
$c_sci_TreeSet.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sci_TreeSet$();
  var evidence$5 = this.sci_TreeSet__f_ordering;
  return this$1.from__sc_IterableOnce__s_math_Ordering__sci_TreeSet(coll, evidence$5);
});
$c_sci_TreeSet.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  var this$1 = $m_sci_TreeSet$();
  var evidence$5 = this.sci_TreeSet__f_ordering;
  return this$1.from__sc_IterableOnce__s_math_Ordering__sci_TreeSet(coll, evidence$5);
});
$c_sci_TreeSet.prototype.filter__F1__O = (function(pred) {
  return this.filter__F1__sci_TreeSet(pred);
});
$c_sci_TreeSet.prototype.removedAll__sc_IterableOnce__sci_SetOps = (function(that) {
  return this.removedAll__sc_IterableOnce__sci_TreeSet(that);
});
$c_sci_TreeSet.prototype.concat__sc_IterableOnce__sc_SetOps = (function(that) {
  return this.concat__sc_IterableOnce__sci_TreeSet(that);
});
$c_sci_TreeSet.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_TreeSet(elem);
});
$c_sci_TreeSet.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_TreeSet(elem);
});
$c_sci_TreeSet.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sci_TreeSet(n);
});
$c_sci_TreeSet.prototype.take__I__O = (function(n) {
  return this.take__I__sci_TreeSet(n);
});
$c_sci_TreeSet.prototype.drop__I__O = (function(n) {
  return this.drop__I__sci_TreeSet(n);
});
$c_sci_TreeSet.prototype.tail__O = (function() {
  return this.tail__sci_TreeSet();
});
function $isArrayOf_sci_TreeSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_TreeSet)));
}
export { $isArrayOf_sci_TreeSet as $isArrayOf_sci_TreeSet };
var $d_sci_TreeSet = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sci_TreeSet, "scala.collection.immutable.TreeSet", ({
  sci_TreeSet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sci_SortedSet: 1,
  sc_SortedSet: 1,
  sc_SortedSetOps: 1,
  sc_SortedOps: 1,
  sc_SortedSetFactoryDefaults: 1,
  sci_SortedSetOps: 1,
  sci_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSetOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_TreeSet as $d_sci_TreeSet };
/** @constructor */
function $c_Lcats_instances_OptionInstances$$anon$1() {
  this.Lcats_instances_OptionInstances$$anon$1__f_someUnit = null;
  this.Lcats_instances_OptionInstances$$anon$1__f_someUnit = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some((void 0));
}
export { $c_Lcats_instances_OptionInstances$$anon$1 as $c_Lcats_instances_OptionInstances$$anon$1 };
$c_Lcats_instances_OptionInstances$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_OptionInstances$$anon$1.prototype.constructor = $c_Lcats_instances_OptionInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_OptionInstances$$anon$1() {
}
export { $h_Lcats_instances_OptionInstances$$anon$1 as $h_Lcats_instances_OptionInstances$$anon$1 };
$h_Lcats_instances_OptionInstances$$anon$1.prototype = $c_Lcats_instances_OptionInstances$$anon$1.prototype;
$c_Lcats_instances_OptionInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return (fa.isEmpty__Z() ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$() : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(f.apply__O__O(fa.get__O())));
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.toIterable__O__sc_Iterable = (function(fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_compat_FoldableCompat$().toIterable__O__Lcats_Foldable__sc_Iterable(fa, this);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Foldable__foldM__O__O__F2__Lcats_Monad__O(this, fa, z, f, G);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.traverseVoid__O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_Foldable__traverseVoid__O__F1__Lcats_Applicative__O(this, fa, f, G);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.unorderedFoldMap__O__F1__Lcats_kernel_CommutativeMonoid__O = (function(fa, f, evidence$1) {
  return this.foldMap__s_Option__F1__Lcats_kernel_Monoid__O(fa, f, evidence$1);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.attempt__O__O = (function(fa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_ApplicativeError__attempt__O__O(this, fa);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.flatten__O__O = (function(ffa) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.combineK__s_Option__s_Option__s_Option = (function(x, y) {
  return ((!x.isEmpty__Z()) ? x : y);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.tailRecM__O__F1__s_Option = (function(a, f) {
  var a$tailLocal1 = a;
  while (true) {
    var x4 = f.apply__O__O(a$tailLocal1);
    var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    if ((x === x4)) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    }
    if ((x4 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var x10 = x4.s_Some__f_value;
      if ((x10 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
        var a1 = x10.s_util_Left__f_value;
        a$tailLocal1 = a1;
        continue;
      }
      if ((x10 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
        var b = x10.s_util_Right__f_value;
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(b);
      }
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x4);
  }
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.map2__s_Option__s_Option__F2__s_Option = (function(fa, fb, f) {
  if (((!fa.isEmpty__Z()) && (!fb.isEmpty__Z()))) {
    var value = f.apply__O__O__O(fa.get__O(), fb.get__O());
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
  } else {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.product__s_Option__s_Option__s_Option = (function(fa, fb) {
  if (((!fa.isEmpty__Z()) && (!fb.isEmpty__Z()))) {
    var _1 = fa.get__O();
    var _2 = fb.get__O();
    var value = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, _2);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
  } else {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.productR__s_Option__s_Option__s_Option = (function(fa, fb) {
  return ((!fa.isEmpty__Z()) ? fb : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.productL__s_Option__s_Option__s_Option = (function(fa, fb) {
  return ((!fb.isEmpty__Z()) ? fa : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.ap__s_Option__s_Option__s_Option = (function(f, fa) {
  if (((!f.isEmpty__Z()) && (!fa.isEmpty__Z()))) {
    var value = f.get__O().apply__O__O(fa.get__O());
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
  } else {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.map2Eval__s_Option__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  if ((x === fa)) {
    var value = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Now(value);
  }
  if ((fa instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
    var a = fa.s_Some__f_value;
    return fb.map__F1__Lcats_Eval(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
      if ((x$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
        var b = x$1.s_Some__f_value;
        var value$1 = f.apply__O__O__O(a, b);
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value$1);
      }
      var x$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      if ((x$2 === x$1)) {
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })));
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(fa);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.foldLeft__s_Option__O__F2__O = (function(fa, b, f) {
  var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  if ((x === fa)) {
    return b;
  }
  if ((fa instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
    var a = fa.s_Some__f_value;
    return f.apply__O__O__O(b, a);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(fa);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.foldRight__s_Option__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  if ((x === fa)) {
    return lb;
  }
  if ((fa instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
    var a = fa.s_Some__f_value;
    return f.apply__O__O__O(a, lb);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(fa);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.handleErrorWith__s_Option__F1__s_Option = (function(fa, f) {
  return (fa.isEmpty__Z() ? f.apply__O__O((void 0)) : fa);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.traverse__s_Option__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  if ((x === fa)) {
    return evidence$1.pure__O__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  }
  if ((fa instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
    var a = fa.s_Some__f_value;
    return evidence$1.map__O__F1__O(f.apply__O__O(a), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(_$2))));
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(fa);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.size__s_Option__J = (function(fa) {
  return (fa.isEmpty__Z() ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0 : (fa.get__O(), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(1, 0)));
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.foldMap__s_Option__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return (fa.isEmpty__Z() ? B.empty__O() : f.apply__O__O(fa.get__O()));
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.void__s_Option__s_Option = (function(oa) {
  return ((!oa.isEmpty__Z()) ? this.Lcats_instances_OptionInstances$$anon$1__f_someUnit : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.empty__O = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  return this.combineK__s_Option__s_Option__s_Option(x, y);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.pure__O__O = (function(x) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(x);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  return (fa.isEmpty__Z() ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$() : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(f.apply__O__O(fa.get__O())));
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  return (fa.isEmpty__Z() ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$() : f.apply__O__O(fa.get__O()));
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__s_Option(a, f);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__s_Option__s_Option__F2__s_Option(fa, fb, f);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return this.product__s_Option__s_Option__s_Option(fa, fb);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.productR__O__O__O = (function(fa, fb) {
  return this.productR__s_Option__s_Option__s_Option(fa, fb);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return this.productL__s_Option__s_Option__s_Option(fa, fb);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.ap__O__O__O = (function(ff, fa) {
  return this.ap__s_Option__s_Option__s_Option(ff, fa);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__s_Option__Lcats_Eval__F2__Lcats_Eval(fa, fb, f);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  return this.foldLeft__s_Option__O__F2__O(fa, b, f);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__s_Option__Lcats_Eval__F2__Lcats_Eval(fa, lb, f);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.raiseError__O__O = (function(e) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  return this.handleErrorWith__s_Option__F1__s_Option(fa, f);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__s_Option__F1__Lcats_Applicative__O(fa, f, evidence$1);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.size__O__J = (function(fa) {
  return this.size__s_Option__J(fa);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__s_Option__F1__Lcats_kernel_Monoid__O(fa, f, B);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.exists__O__F1__Z = (function(fa, p) {
  return ((!fa.isEmpty__Z()) && (!(!p.apply__O__O(fa.get__O()))));
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.toList__O__sci_List = (function(fa) {
  return fa.toList__sci_List();
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.unit__O = (function() {
  return this.Lcats_instances_OptionInstances$$anon$1__f_someUnit;
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.void__O__O = (function(fa) {
  return this.void__s_Option__s_Option(fa);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.compose__Lcats_Applicative__Lcats_Applicative = (function(evidence$1) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Alternative$$anon$1(evidence$1, this);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_MonoidK$$anon$1(this);
});
var $d_Lcats_instances_OptionInstances$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_OptionInstances$$anon$1, "cats.instances.OptionInstances$$anon$1", ({
  Lcats_instances_OptionInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_CommutativeApply: 1,
  Lcats_CommutativeFlatMap: 1,
  Lcats_CommutativeApplicative: 1,
  Lcats_CommutativeMonad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
}));
export { $d_Lcats_instances_OptionInstances$$anon$1 as $d_Lcats_instances_OptionInstances$$anon$1 };
/** @constructor */
function $c_sci_BitSet() {
}
export { $c_sci_BitSet as $c_sci_BitSet };
$c_sci_BitSet.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sci_AbstractSet();
$c_sci_BitSet.prototype.constructor = $c_sci_BitSet;
/** @constructor */
function $h_sci_BitSet() {
}
export { $h_sci_BitSet as $h_sci_BitSet };
$h_sci_BitSet.prototype = $c_sci_BitSet.prototype;
$c_sci_BitSet.prototype.stringPrefix__T = (function() {
  return "BitSet";
});
$c_sci_BitSet.prototype.scala$collection$BitSetOps$$super$max__s_math_Ordering__I = (function(ord) {
  return ($f_sc_SortedSetOps__max__s_math_Ordering__O(this, ord) | 0);
});
$c_sci_BitSet.prototype.scala$collection$BitSetOps$$super$concat__sc_IterableOnce__sc_BitSet = (function(that) {
  return $f_sci_StrictOptimizedSetOps__concat__sc_IterableOnce__sci_SetOps(this, that);
});
$c_sci_BitSet.prototype.ordering__s_math_Ordering = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_math_Ordering$Int$();
});
$c_sci_BitSet.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_BitSetOps$$anon$1(this, 0);
});
$c_sci_BitSet.prototype.size__I = (function() {
  return $f_sc_BitSetOps__size__I(this);
});
$c_sci_BitSet.prototype.isEmpty__Z = (function() {
  return $f_sc_BitSetOps__isEmpty__Z(this);
});
$c_sci_BitSet.prototype.foreach__F1__V = (function(f) {
  $f_sc_BitSetOps__foreach__F1__V(this, f);
});
$c_sci_BitSet.prototype.map__F1__O = (function(f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_BitSet.prototype.flatMap__F1__O = (function(f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_BitSet.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_BitSet(pred, false);
});
$c_sci_BitSet.prototype.dropRight__I__O = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_BitSet.prototype.equals__O__Z = (function(that) {
  return $f_sc_SortedSet__equals__O__Z(this, that);
});
$c_sci_BitSet.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sci_BitSet$().newBuilder__scm_Builder();
});
$c_sci_BitSet.prototype.incl__I__sci_BitSet = (function(elem) {
  var requirement = (elem >= 0);
  if ((!requirement)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), "requirement failed: bitset element must be >= 0");
  }
  if ($f_sc_BitSetOps__contains__I__Z(this, elem)) {
    return this;
  } else {
    var idx = (elem >> 6);
    var a = this.word__I__J(idx);
    var lo = (((32 & elem) === 0) ? (1 << elem) : 0);
    var hi = (((32 & elem) === 0) ? 0 : (1 << elem));
    var lo$1 = (a.RTLong__f_lo | lo);
    var hi$1 = (a.RTLong__f_hi | hi);
    return this.updateWord__I__J__sci_BitSet(idx, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$1, hi$1));
  }
});
$c_sci_BitSet.prototype.excl__I__sci_BitSet = (function(elem) {
  var requirement = (elem >= 0);
  if ((!requirement)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), "requirement failed: bitset element must be >= 0");
  }
  if ($f_sc_BitSetOps__contains__I__Z(this, elem)) {
    var idx = (elem >> 6);
    var a = this.word__I__J(idx);
    var lo = (((32 & elem) === 0) ? (1 << elem) : 0);
    var hi = (((32 & elem) === 0) ? 0 : (1 << elem));
    var lo$1 = (~lo);
    var hi$1 = (~hi);
    var lo$2 = (a.RTLong__f_lo & lo$1);
    var hi$2 = (a.RTLong__f_hi & hi$1);
    return this.updateWord__I__J__sci_BitSet(idx, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$2, hi$2));
  } else {
    return this;
  }
});
$c_sci_BitSet.prototype.concat__sc_IterableOnce__sc_SetOps = (function(that) {
  return $f_sc_BitSetOps__concat__sc_IterableOnce__sc_BitSet(this, that);
});
$c_sci_BitSet.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_BitSetOps__max__s_math_Ordering__I(this, ord);
});
$c_sci_BitSet.prototype.contains__O__Z = (function(elem) {
  var elem$1 = (elem | 0);
  return $f_sc_BitSetOps__contains__I__Z(this, elem$1);
});
$c_sci_BitSet.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__I__sci_BitSet((elem | 0));
});
$c_sci_BitSet.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__I__sci_BitSet((elem | 0));
});
$c_sci_BitSet.prototype.fromBitMaskNoCopy__AJ__sc_BitSet = (function(elems) {
  return $m_sci_BitSet$().fromBitMaskNoCopy__AJ__sci_BitSet(elems);
});
$c_sci_BitSet.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return $m_sci_BitSet$().fromSpecific__sc_IterableOnce__sci_BitSet(coll);
});
$c_sci_BitSet.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return $m_sci_BitSet$().fromSpecific__sc_IterableOnce__sci_BitSet(coll);
});
function $isArrayOf_sci_BitSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_BitSet)));
}
export { $isArrayOf_sci_BitSet as $isArrayOf_sci_BitSet };
/** @constructor */
function $c_sci_BitSet$BitSet1(elems) {
  this.sci_BitSet$BitSet1__f_elems = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0;
  this.sci_BitSet$BitSet1__f_elems = elems;
}
export { $c_sci_BitSet$BitSet1 as $c_sci_BitSet$BitSet1 };
$c_sci_BitSet$BitSet1.prototype = new $h_sci_BitSet();
$c_sci_BitSet$BitSet1.prototype.constructor = $c_sci_BitSet$BitSet1;
/** @constructor */
function $h_sci_BitSet$BitSet1() {
}
export { $h_sci_BitSet$BitSet1 as $h_sci_BitSet$BitSet1 };
$h_sci_BitSet$BitSet1.prototype = $c_sci_BitSet$BitSet1.prototype;
$c_sci_BitSet$BitSet1.prototype.nwords__I = (function() {
  return 1;
});
$c_sci_BitSet$BitSet1.prototype.word__I__J = (function(idx) {
  return ((idx === 0) ? this.sci_BitSet$BitSet1__f_elems : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0);
});
$c_sci_BitSet$BitSet1.prototype.updateWord__I__J__sci_BitSet = (function(idx, w) {
  if ((idx === 0)) {
    return new $c_sci_BitSet$BitSet1(w);
  } else if ((idx === 1)) {
    return $m_sci_BitSet$().scala$collection$immutable$BitSet$$createSmall__J__J__sci_BitSet(this.sci_BitSet$BitSet1__f_elems, w);
  } else {
    var elems = $m_sc_BitSetOps$().updateArray__AJ__I__J__AJ(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_J([this.sci_BitSet$BitSet1__f_elems]), idx, w);
    return $m_sci_BitSet$().fromBitMaskNoCopy__AJ__sci_BitSet(elems);
  }
});
$c_sci_BitSet$BitSet1.prototype.filterImpl__F1__Z__sci_BitSet = (function(pred, isFlipped) {
  var t = $m_sc_BitSetOps$().computeWordForFilter__F1__Z__J__I__J(pred, isFlipped, this.sci_BitSet$BitSet1__f_elems, 0);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return (((lo === 0) && (hi === 0)) ? $m_sci_BitSet$().sci_BitSet$__f_empty : new $c_sci_BitSet$BitSet1(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi)));
});
var $d_sci_BitSet$BitSet1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sci_BitSet$BitSet1, "scala.collection.immutable.BitSet$BitSet1", ({
  sci_BitSet$BitSet1: 1,
  sci_BitSet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sci_SortedSet: 1,
  sc_SortedSet: 1,
  sc_SortedSetOps: 1,
  sc_SortedOps: 1,
  sc_SortedSetFactoryDefaults: 1,
  sci_SortedSetOps: 1,
  sci_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSetOps: 1,
  sc_BitSet: 1,
  sc_BitSetOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_BitSet$BitSet1 as $d_sci_BitSet$BitSet1 };
/** @constructor */
function $c_sci_BitSet$BitSet2(elems0, elems1) {
  this.sci_BitSet$BitSet2__f_elems0 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0;
  this.sci_BitSet$BitSet2__f_elems1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0;
  this.sci_BitSet$BitSet2__f_elems0 = elems0;
  this.sci_BitSet$BitSet2__f_elems1 = elems1;
}
export { $c_sci_BitSet$BitSet2 as $c_sci_BitSet$BitSet2 };
$c_sci_BitSet$BitSet2.prototype = new $h_sci_BitSet();
$c_sci_BitSet$BitSet2.prototype.constructor = $c_sci_BitSet$BitSet2;
/** @constructor */
function $h_sci_BitSet$BitSet2() {
}
export { $h_sci_BitSet$BitSet2 as $h_sci_BitSet$BitSet2 };
$h_sci_BitSet$BitSet2.prototype = $c_sci_BitSet$BitSet2.prototype;
$c_sci_BitSet$BitSet2.prototype.nwords__I = (function() {
  return 2;
});
$c_sci_BitSet$BitSet2.prototype.word__I__J = (function(idx) {
  return ((idx === 0) ? this.sci_BitSet$BitSet2__f_elems0 : ((idx === 1) ? this.sci_BitSet$BitSet2__f_elems1 : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0));
});
$c_sci_BitSet$BitSet2.prototype.updateWord__I__J__sci_BitSet = (function(idx, w) {
  if ((idx === 0)) {
    return new $c_sci_BitSet$BitSet2(w, this.sci_BitSet$BitSet2__f_elems1);
  } else if ((idx === 1)) {
    return $m_sci_BitSet$().scala$collection$immutable$BitSet$$createSmall__J__J__sci_BitSet(this.sci_BitSet$BitSet2__f_elems0, w);
  } else {
    var elems = $m_sc_BitSetOps$().updateArray__AJ__I__J__AJ(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_J([this.sci_BitSet$BitSet2__f_elems0, this.sci_BitSet$BitSet2__f_elems1]), idx, w);
    return $m_sci_BitSet$().fromBitMaskNoCopy__AJ__sci_BitSet(elems);
  }
});
$c_sci_BitSet$BitSet2.prototype.filterImpl__F1__Z__sci_BitSet = (function(pred, isFlipped) {
  var t = $m_sc_BitSetOps$().computeWordForFilter__F1__Z__J__I__J(pred, isFlipped, this.sci_BitSet$BitSet2__f_elems0, 0);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $m_sc_BitSetOps$().computeWordForFilter__F1__Z__J__I__J(pred, isFlipped, this.sci_BitSet$BitSet2__f_elems1, 1);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return (((lo$1 === 0) && (hi$1 === 0)) ? (((lo === 0) && (hi === 0)) ? $m_sci_BitSet$().sci_BitSet$__f_empty : new $c_sci_BitSet$BitSet1(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi))) : new $c_sci_BitSet$BitSet2(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$1, hi$1)));
});
var $d_sci_BitSet$BitSet2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sci_BitSet$BitSet2, "scala.collection.immutable.BitSet$BitSet2", ({
  sci_BitSet$BitSet2: 1,
  sci_BitSet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sci_SortedSet: 1,
  sc_SortedSet: 1,
  sc_SortedSetOps: 1,
  sc_SortedOps: 1,
  sc_SortedSetFactoryDefaults: 1,
  sci_SortedSetOps: 1,
  sci_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSetOps: 1,
  sc_BitSet: 1,
  sc_BitSetOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_BitSet$BitSet2 as $d_sci_BitSet$BitSet2 };
/** @constructor */
function $c_sci_BitSet$BitSetN(elems) {
  this.sci_BitSet$BitSetN__f_elems = null;
  this.sci_BitSet$BitSetN__f_elems = elems;
}
export { $c_sci_BitSet$BitSetN as $c_sci_BitSet$BitSetN };
$c_sci_BitSet$BitSetN.prototype = new $h_sci_BitSet();
$c_sci_BitSet$BitSetN.prototype.constructor = $c_sci_BitSet$BitSetN;
/** @constructor */
function $h_sci_BitSet$BitSetN() {
}
export { $h_sci_BitSet$BitSetN as $h_sci_BitSet$BitSetN };
$h_sci_BitSet$BitSetN.prototype = $c_sci_BitSet$BitSetN.prototype;
$c_sci_BitSet$BitSetN.prototype.nwords__I = (function() {
  return this.sci_BitSet$BitSetN__f_elems.u.length;
});
$c_sci_BitSet$BitSetN.prototype.word__I__J = (function(idx) {
  return ((idx < this.sci_BitSet$BitSetN__f_elems.u.length) ? this.sci_BitSet$BitSetN__f_elems.u[idx] : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0);
});
$c_sci_BitSet$BitSetN.prototype.updateWord__I__J__sci_BitSet = (function(idx, w) {
  var elems = $m_sc_BitSetOps$().updateArray__AJ__I__J__AJ(this.sci_BitSet$BitSetN__f_elems, idx, w);
  return $m_sci_BitSet$().fromBitMaskNoCopy__AJ__sci_BitSet(elems);
});
$c_sci_BitSet$BitSetN.prototype.filterImpl__F1__Z__sci_BitSet = (function(pred, isFlipped) {
  var i = (((-1) + this.sci_BitSet$BitSetN__f_elems.u.length) | 0);
  var currentWord__lo = 0;
  var currentWord__hi = 0;
  var anyChanges = false;
  while (true) {
    if ((i >= 0)) {
      var a__lo = currentWord__lo;
      var a__hi = currentWord__hi;
      var $x_2 = ((a__lo === 0) && (a__hi === 0));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var t = this.word__I__J(i);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var t$1 = $m_sc_BitSetOps$().computeWordForFilter__F1__Z__J__I__J(pred, isFlipped, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi), i);
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      var $x_1__lo = lo$1;
      var $x_1__hi = hi$1;
      currentWord__lo = $x_1__lo;
      currentWord__hi = $x_1__hi;
      if (anyChanges) {
        anyChanges = true;
      } else {
        var a$1__lo = currentWord__lo;
        var a$1__hi = currentWord__hi;
        anyChanges = (!((a$1__lo === lo) && (a$1__hi === hi)));
      }
      i = (((-1) + i) | 0);
    } else {
      break;
    }
  }
  var x1 = i;
  switch (x1) {
    case (-1): {
      if (anyChanges) {
        var a$2__lo = currentWord__lo;
        var a$2__hi = currentWord__hi;
        if (((a$2__lo === 0) && (a$2__hi === 0))) {
          return $m_sci_BitSet$().sci_BitSet$__f_empty;
        } else {
          return new $c_sci_BitSet$BitSet1(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(currentWord__lo, currentWord__hi));
        }
      } else {
        return this;
      }
      break;
    }
    case 0: {
      var t$2 = this.word__I__J(0);
      var lo$2 = t$2.RTLong__f_lo;
      var hi$2 = t$2.RTLong__f_hi;
      var t$3 = $m_sc_BitSetOps$().computeWordForFilter__F1__Z__J__I__J(pred, isFlipped, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$2, hi$2), 0);
      var lo$3 = t$3.RTLong__f_lo;
      var hi$3 = t$3.RTLong__f_hi;
      anyChanges = (anyChanges || (!((lo$3 === lo$2) && (hi$3 === hi$2))));
      return (anyChanges ? new $c_sci_BitSet$BitSet2(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$3, hi$3), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(currentWord__lo, currentWord__hi)) : this);
      break;
    }
    default: {
      var minimumNonZeroIndex = ((1 + i) | 0);
      while (((!anyChanges) && (i >= 0))) {
        var t$4 = this.word__I__J(i);
        var lo$4 = t$4.RTLong__f_lo;
        var hi$4 = t$4.RTLong__f_hi;
        var t$5 = $m_sc_BitSetOps$().computeWordForFilter__F1__Z__J__I__J(pred, isFlipped, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$4, hi$4), i);
        var lo$5 = t$5.RTLong__f_lo;
        var hi$5 = t$5.RTLong__f_hi;
        var $x_3__lo = lo$5;
        var $x_3__hi = hi$5;
        currentWord__lo = $x_3__lo;
        currentWord__hi = $x_3__hi;
        if (anyChanges) {
          anyChanges = true;
        } else {
          var a$3__lo = currentWord__lo;
          var a$3__hi = currentWord__hi;
          anyChanges = (!((a$3__lo === lo$4) && (a$3__hi === hi$4)));
        }
        i = (((-1) + i) | 0);
      }
      if (anyChanges) {
        var xs = this.sci_BitSet$BitSetN__f_elems;
        var n = ((1 + minimumNonZeroIndex) | 0);
        var newArray = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_ArrayOps$().slice$extension__O__I__I__O(xs, 0, n);
        newArray.u[((1 + i) | 0)] = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(currentWord__lo, currentWord__hi);
        while ((i >= 0)) {
          newArray.u[i] = $m_sc_BitSetOps$().computeWordForFilter__F1__Z__J__I__J(pred, isFlipped, this.word__I__J(i), i);
          i = (((-1) + i) | 0);
        }
        return new $c_sci_BitSet$BitSetN(newArray);
      } else {
        return this;
      }
    }
  }
});
var $d_sci_BitSet$BitSetN = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sci_BitSet$BitSetN, "scala.collection.immutable.BitSet$BitSetN", ({
  sci_BitSet$BitSetN: 1,
  sci_BitSet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sci_SortedSet: 1,
  sc_SortedSet: 1,
  sc_SortedSetOps: 1,
  sc_SortedOps: 1,
  sc_SortedSetFactoryDefaults: 1,
  sci_SortedSetOps: 1,
  sci_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSetOps: 1,
  sc_BitSet: 1,
  sc_BitSetOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_BitSet$BitSetN as $d_sci_BitSet$BitSetN };
function $p_sci_TreeMap__newMapOrSelf__sci_RedBlackTree$Tree__sci_TreeMap($thiz, t) {
  return ((t === $thiz.sci_TreeMap__f_tree) ? $thiz : $ct_sci_TreeMap__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeMap(), t, $thiz.sci_TreeMap__f_ordering));
}
export { $p_sci_TreeMap__newMapOrSelf__sci_RedBlackTree$Tree__sci_TreeMap as $p_sci_TreeMap__newMapOrSelf__sci_RedBlackTree$Tree__sci_TreeMap };
function $ct_sci_TreeMap__sci_RedBlackTree$Tree__s_math_Ordering__($thiz, tree, ordering) {
  $thiz.sci_TreeMap__f_tree = tree;
  $thiz.sci_TreeMap__f_ordering = ordering;
  return $thiz;
}
export { $ct_sci_TreeMap__sci_RedBlackTree$Tree__s_math_Ordering__ as $ct_sci_TreeMap__sci_RedBlackTree$Tree__s_math_Ordering__ };
function $ct_sci_TreeMap__s_math_Ordering__($thiz, ordering) {
  $ct_sci_TreeMap__sci_RedBlackTree$Tree__s_math_Ordering__($thiz, null, ordering);
  return $thiz;
}
export { $ct_sci_TreeMap__s_math_Ordering__ as $ct_sci_TreeMap__s_math_Ordering__ };
/** @constructor */
function $c_sci_TreeMap() {
  this.sci_TreeMap__f_tree = null;
  this.sci_TreeMap__f_ordering = null;
}
export { $c_sci_TreeMap as $c_sci_TreeMap };
$c_sci_TreeMap.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sci_AbstractMap();
$c_sci_TreeMap.prototype.constructor = $c_sci_TreeMap;
/** @constructor */
function $h_sci_TreeMap() {
}
export { $h_sci_TreeMap as $h_sci_TreeMap };
$h_sci_TreeMap.prototype = $c_sci_TreeMap.prototype;
$c_sci_TreeMap.prototype.map__F1__sc_IterableOps = (function(f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedMapOps__map__F1__sc_IterableOps(this, f);
});
$c_sci_TreeMap.prototype.collect__s_PartialFunction__sc_IterableOps = (function(pf) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedMapOps__collect__s_PartialFunction__sc_IterableOps(this, pf);
});
$c_sci_TreeMap.prototype.map__F1__O = (function(f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_TreeMap.prototype.flatMap__F1__O = (function(f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_TreeMap.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sci_TreeMap.prototype.stringPrefix__T = (function() {
  return "SortedMap";
});
$c_sci_TreeMap.prototype.newSpecificBuilder__scm_Builder = (function() {
  var evidence$39 = this.sci_TreeMap__f_ordering;
  return new $c_sci_TreeMap$TreeMapBuilder(evidence$39);
});
$c_sci_TreeMap.prototype.iterator__sc_Iterator = (function() {
  var tree = this.sci_TreeMap__f_tree;
  var start = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var evidence$16 = this.sci_TreeMap__f_ordering;
  return new $c_sci_RedBlackTree$EntriesIterator(tree, start, evidence$16);
});
$c_sci_TreeMap.prototype.get__O__s_Option = (function(key) {
  return $m_sci_RedBlackTree$().get__sci_RedBlackTree$Tree__O__s_math_Ordering__s_Option(this.sci_TreeMap__f_tree, key, this.sci_TreeMap__f_ordering);
});
$c_sci_TreeMap.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  var resultOrNull = $m_sci_RedBlackTree$().lookup__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeMap__f_tree, key, this.sci_TreeMap__f_ordering);
  return ((resultOrNull === null) ? default$1.apply__O() : resultOrNull.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value);
});
$c_sci_TreeMap.prototype.apply__O__O = (function(key) {
  var resultOrNull = $m_sci_RedBlackTree$().lookup__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeMap__f_tree, key, this.sci_TreeMap__f_ordering);
  return ((resultOrNull === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_MapOps__default__O__O(this, key) : resultOrNull.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value);
});
$c_sci_TreeMap.prototype.contains__O__Z = (function(key) {
  return $m_sci_RedBlackTree$().contains__sci_RedBlackTree$Tree__O__s_math_Ordering__Z(this.sci_TreeMap__f_tree, key, this.sci_TreeMap__f_ordering);
});
$c_sci_TreeMap.prototype.removed__O__sci_TreeMap = (function(key) {
  return $p_sci_TreeMap__newMapOrSelf__sci_RedBlackTree$Tree__sci_TreeMap(this, $m_sci_RedBlackTree$().delete__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeMap__f_tree, key, this.sci_TreeMap__f_ordering));
});
$c_sci_TreeMap.prototype.updated__O__O__sci_TreeMap = (function(key, value) {
  return $p_sci_TreeMap__newMapOrSelf__sci_RedBlackTree$Tree__sci_TreeMap(this, $m_sci_RedBlackTree$().update__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeMap__f_tree, key, value, true, this.sci_TreeMap__f_ordering));
});
$c_sci_TreeMap.prototype.concat__sc_IterableOnce__sci_TreeMap = (function(that) {
  matchEnd5: {
    var $x_1;
    if ((that instanceof $c_sci_TreeMap)) {
      var x = this.sci_TreeMap__f_ordering;
      var x$2 = that.sci_TreeMap__f_ordering;
      if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
        var $x_1 = $m_sci_RedBlackTree$().union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeMap__f_tree, that.sci_TreeMap__f_tree, this.sci_TreeMap__f_ordering);
        break matchEnd5;
      }
    }
    if ($is_sci_LinearSeq(that)) {
      if (that.isEmpty__Z()) {
        var $x_1 = this.sci_TreeMap__f_tree;
        break matchEnd5;
      } else {
        var adder = new $c_sci_TreeMap$Adder(this);
        adder.addAll__sci_LinearSeq__V(that);
        var $x_1 = adder.beforePublish__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(adder.sci_TreeMap$Adder__f_currentMutableTree);
        break matchEnd5;
      }
    }
    var adder$2 = new $c_sci_TreeMap$Adder(this);
    var it = that.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      adder$2.apply__T2__V(it.next__O());
    }
    var $x_1 = adder$2.beforePublish__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(adder$2.sci_TreeMap$Adder__f_currentMutableTree);
  }
  return $p_sci_TreeMap__newMapOrSelf__sci_RedBlackTree$Tree__sci_TreeMap(this, $x_1);
});
$c_sci_TreeMap.prototype.removedAll__sc_IterableOnce__sci_TreeMap = (function(keys) {
  if ((keys instanceof $c_sci_TreeSet)) {
    var x = this.sci_TreeMap__f_ordering;
    var x$2 = keys.sci_TreeSet__f_ordering;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      return $p_sci_TreeMap__newMapOrSelf__sci_RedBlackTree$Tree__sci_TreeMap(this, $m_sci_RedBlackTree$().difference__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeMap__f_tree, keys.sci_TreeSet__f_tree, this.sci_TreeMap__f_ordering));
    }
  }
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sci_MapOps__removedAll__sc_IterableOnce__sci_MapOps(this, keys);
});
$c_sci_TreeMap.prototype.foreach__F1__V = (function(f) {
  $m_sci_RedBlackTree$().foreach__sci_RedBlackTree$Tree__F1__V(this.sci_TreeMap__f_tree, f);
});
$c_sci_TreeMap.prototype.foreachEntry__F2__V = (function(f) {
  $m_sci_RedBlackTree$().foreachEntry__sci_RedBlackTree$Tree__F2__V(this.sci_TreeMap__f_tree, f);
});
$c_sci_TreeMap.prototype.size__I = (function() {
  return $m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(this.sci_TreeMap__f_tree);
});
$c_sci_TreeMap.prototype.knownSize__I = (function() {
  return $m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(this.sci_TreeMap__f_tree);
});
$c_sci_TreeMap.prototype.isEmpty__Z = (function() {
  return ($m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(this.sci_TreeMap__f_tree) === 0);
});
$c_sci_TreeMap.prototype.head__T2 = (function() {
  var smallest = $m_sci_RedBlackTree$().smallest__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeMap__f_tree);
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), smallest.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, smallest.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value);
});
$c_sci_TreeMap.prototype.last__T2 = (function() {
  var greatest = $m_sci_RedBlackTree$().greatest__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeMap__f_tree);
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), greatest.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, greatest.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value);
});
$c_sci_TreeMap.prototype.tail__sci_TreeMap = (function() {
  return $ct_sci_TreeMap__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeMap(), $m_sci_RedBlackTree$().tail__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeMap__f_tree), this.sci_TreeMap__f_ordering);
});
$c_sci_TreeMap.prototype.drop__I__sci_TreeMap = (function(n) {
  if ((n <= 0)) {
    return this;
  } else if ((n >= $m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(this.sci_TreeMap__f_tree))) {
    var evidence$36 = this.sci_TreeMap__f_ordering;
    return $ct_sci_TreeMap__s_math_Ordering__(new $c_sci_TreeMap(), evidence$36);
  } else {
    return $ct_sci_TreeMap__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeMap(), $m_sci_RedBlackTree$().drop__sci_RedBlackTree$Tree__I__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeMap__f_tree, n, this.sci_TreeMap__f_ordering), this.sci_TreeMap__f_ordering);
  }
});
$c_sci_TreeMap.prototype.take__I__sci_TreeMap = (function(n) {
  if ((n <= 0)) {
    var evidence$36 = this.sci_TreeMap__f_ordering;
    return $ct_sci_TreeMap__s_math_Ordering__(new $c_sci_TreeMap(), evidence$36);
  } else {
    return ((n >= $m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(this.sci_TreeMap__f_tree)) ? this : $ct_sci_TreeMap__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeMap(), $m_sci_RedBlackTree$().take__sci_RedBlackTree$Tree__I__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeMap__f_tree, n, this.sci_TreeMap__f_ordering), this.sci_TreeMap__f_ordering));
  }
});
$c_sci_TreeMap.prototype.dropRight__I__sci_TreeMap = (function(n) {
  return this.take__I__sci_TreeMap((($m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(this.sci_TreeMap__f_tree) - ((n > 0) ? n : 0)) | 0));
});
$c_sci_TreeMap.prototype.filter__F1__sci_TreeMap = (function(f) {
  return $p_sci_TreeMap__newMapOrSelf__sci_RedBlackTree$Tree__sci_TreeMap(this, $m_sci_RedBlackTree$().filterEntries__sci_RedBlackTree$Tree__F2__sci_RedBlackTree$Tree(this.sci_TreeMap__f_tree, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((k$2$2, v$2$2) => (!(!f.apply__O__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), k$2$2, v$2$2))))))));
});
$c_sci_TreeMap.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_sci_TreeMap)) {
    var x = this.sci_TreeMap__f_ordering;
    var x$2 = obj.sci_TreeMap__f_ordering;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      return $m_sci_RedBlackTree$().entriesEqual__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__Z(this.sci_TreeMap__f_tree, obj.sci_TreeMap__f_tree, this.sci_TreeMap__f_ordering);
    }
  }
  return $f_sc_SortedMap__equals__O__Z(this, obj);
});
$c_sci_TreeMap.prototype.className__T = (function() {
  return "TreeMap";
});
$c_sci_TreeMap.prototype.$plus$plus__sc_IterableOnce__sc_IterableOps = (function(xs) {
  return this.concat__sc_IterableOnce__sci_TreeMap(xs);
});
$c_sci_TreeMap.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sci_TreeMap$();
  var evidence$37 = this.sci_TreeMap__f_ordering;
  return this$1.from__sc_IterableOnce__s_math_Ordering__sci_TreeMap(coll, evidence$37);
});
$c_sci_TreeMap.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  var this$1 = $m_sci_TreeMap$();
  var evidence$37 = this.sci_TreeMap__f_ordering;
  return this$1.from__sc_IterableOnce__s_math_Ordering__sci_TreeMap(coll, evidence$37);
});
$c_sci_TreeMap.prototype.$plus__T2__sci_MapOps = (function(kv) {
  var key = kv._1__O();
  var value = kv._2__O();
  return this.updated__O__O__sci_TreeMap(key, value);
});
$c_sci_TreeMap.prototype.filter__F1__O = (function(pred) {
  return this.filter__F1__sci_TreeMap(pred);
});
$c_sci_TreeMap.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sci_TreeMap(n);
});
$c_sci_TreeMap.prototype.take__I__O = (function(n) {
  return this.take__I__sci_TreeMap(n);
});
$c_sci_TreeMap.prototype.drop__I__O = (function(n) {
  return this.drop__I__sci_TreeMap(n);
});
$c_sci_TreeMap.prototype.tail__O = (function() {
  return this.tail__sci_TreeMap();
});
$c_sci_TreeMap.prototype.last__O = (function() {
  return this.last__T2();
});
$c_sci_TreeMap.prototype.head__O = (function() {
  return this.head__T2();
});
$c_sci_TreeMap.prototype.removedAll__sc_IterableOnce__sci_MapOps = (function(keys) {
  return this.removedAll__sc_IterableOnce__sci_TreeMap(keys);
});
$c_sci_TreeMap.prototype.concat__sc_IterableOnce__sc_IterableOps = (function(suffix) {
  return this.concat__sc_IterableOnce__sci_TreeMap(suffix);
});
$c_sci_TreeMap.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_TreeMap(key, value);
});
$c_sci_TreeMap.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_TreeMap(key);
});
$c_sci_TreeMap.prototype.keySet__sc_Set = (function() {
  return $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), this.sci_TreeMap__f_tree, this.sci_TreeMap__f_ordering);
});
$c_sci_TreeMap.prototype.keySet__sci_Set = (function() {
  return $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), this.sci_TreeMap__f_tree, this.sci_TreeMap__f_ordering);
});
function $isArrayOf_sci_TreeMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_TreeMap)));
}
export { $isArrayOf_sci_TreeMap as $isArrayOf_sci_TreeMap };
var $d_sci_TreeMap = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_sci_TreeMap, "scala.collection.immutable.TreeMap", ({
  sci_TreeMap: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sci_SortedMap: 1,
  sc_SortedMap: 1,
  sc_SortedMapOps: 1,
  sc_SortedOps: 1,
  sc_SortedMapFactoryDefaults: 1,
  sci_SortedMapOps: 1,
  sci_StrictOptimizedSortedMapOps: 1,
  sc_StrictOptimizedSortedMapOps: 1,
  sc_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedMapOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_TreeMap as $d_sci_TreeMap };
function $ct_scm_BitSet__AJ__($thiz, elems) {
  $thiz.scm_BitSet__f_elems = elems;
  return $thiz;
}
export { $ct_scm_BitSet__AJ__ as $ct_scm_BitSet__AJ__ };
function $ct_scm_BitSet__I__($thiz, initSize) {
  var x = (((63 + initSize) | 0) >> 6);
  $ct_scm_BitSet__AJ__($thiz, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_J(((x > 1) ? x : 1)));
  return $thiz;
}
export { $ct_scm_BitSet__I__ as $ct_scm_BitSet__I__ };
function $ct_scm_BitSet__($thiz) {
  $ct_scm_BitSet__I__($thiz, 0);
  return $thiz;
}
export { $ct_scm_BitSet__ as $ct_scm_BitSet__ };
/** @constructor */
function $c_scm_BitSet() {
  this.scm_BitSet__f_elems = null;
}
export { $c_scm_BitSet as $c_scm_BitSet };
$c_scm_BitSet.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_scm_AbstractSet();
$c_scm_BitSet.prototype.constructor = $c_scm_BitSet;
/** @constructor */
function $h_scm_BitSet() {
}
export { $h_scm_BitSet as $h_scm_BitSet };
$h_scm_BitSet.prototype = $c_scm_BitSet.prototype;
$c_scm_BitSet.prototype.stringPrefix__T = (function() {
  return "BitSet";
});
$c_scm_BitSet.prototype.scala$collection$BitSetOps$$super$max__s_math_Ordering__I = (function(ord) {
  return ($f_sc_SortedSetOps__max__s_math_Ordering__O(this, ord) | 0);
});
$c_scm_BitSet.prototype.scala$collection$BitSetOps$$super$concat__sc_IterableOnce__sc_BitSet = (function(that) {
  var b = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_scm_GrowableBuilder__scm_Growable__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_GrowableBuilder(), $ct_scm_BitSet__(new $c_scm_BitSet()));
  b.addAll__sc_IterableOnce__scm_GrowableBuilder(this);
  b.addAll__sc_IterableOnce__scm_GrowableBuilder(that);
  return b.scm_GrowableBuilder__f_elems;
});
$c_scm_BitSet.prototype.ordering__s_math_Ordering = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_math_Ordering$Int$();
});
$c_scm_BitSet.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_BitSetOps$$anon$1(this, 0);
});
$c_scm_BitSet.prototype.size__I = (function() {
  return $f_sc_BitSetOps__size__I(this);
});
$c_scm_BitSet.prototype.isEmpty__Z = (function() {
  return $f_sc_BitSetOps__isEmpty__Z(this);
});
$c_scm_BitSet.prototype.foreach__F1__V = (function(f) {
  $f_sc_BitSetOps__foreach__F1__V(this, f);
});
$c_scm_BitSet.prototype.map__F1__O = (function(f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_scm_BitSet.prototype.flatMap__F1__O = (function(f) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_scm_BitSet.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__scm_BitSet(pred, false);
});
$c_scm_BitSet.prototype.dropRight__I__O = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_scm_BitSet.prototype.equals__O__Z = (function(that) {
  return $f_sc_SortedSet__equals__O__Z(this, that);
});
$c_scm_BitSet.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_scm_GrowableBuilder__scm_Growable__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_GrowableBuilder(), $ct_scm_BitSet__(new $c_scm_BitSet()));
});
$c_scm_BitSet.prototype.nwords__I = (function() {
  return this.scm_BitSet__f_elems.u.length;
});
$c_scm_BitSet.prototype.word__I__J = (function(idx) {
  return ((idx < this.scm_BitSet__f_elems.u.length) ? this.scm_BitSet__f_elems.u[idx] : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0);
});
$c_scm_BitSet.prototype.fromBitMaskNoCopy__AJ__scm_BitSet = (function(elems) {
  return ((elems.u.length === 0) ? $ct_scm_BitSet__(new $c_scm_BitSet()) : $ct_scm_BitSet__AJ__(new $c_scm_BitSet(), elems));
});
$c_scm_BitSet.prototype.addOne__I__scm_BitSet = (function(elem) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Predef$().require__Z__V((elem >= 0));
  if ((!$f_sc_BitSetOps__contains__I__Z(this, elem))) {
    var idx = (elem >> 6);
    var a = this.word__I__J(idx);
    var lo = (((32 & elem) === 0) ? (1 << elem) : 0);
    var hi = (((32 & elem) === 0) ? 0 : (1 << elem));
    var lo$1 = (a.RTLong__f_lo | lo);
    var hi$1 = (a.RTLong__f_hi | hi);
    this.updateWord__I__J__V(idx, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$1, hi$1));
  }
  return this;
});
$c_scm_BitSet.prototype.subtractOne__I__scm_BitSet = (function(elem) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Predef$().require__Z__V((elem >= 0));
  if ($f_sc_BitSetOps__contains__I__Z(this, elem)) {
    var idx = (elem >> 6);
    var a = this.word__I__J(idx);
    var lo = (((32 & elem) === 0) ? (1 << elem) : 0);
    var hi = (((32 & elem) === 0) ? 0 : (1 << elem));
    var lo$1 = (~lo);
    var hi$1 = (~hi);
    var lo$2 = (a.RTLong__f_lo & lo$1);
    var hi$2 = (a.RTLong__f_hi & hi$1);
    this.updateWord__I__J__V(idx, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$2, hi$2));
  }
  return this;
});
$c_scm_BitSet.prototype.updateWord__I__J__V = (function(idx, w) {
  this.ensureCapacity__I__V(idx);
  this.scm_BitSet__f_elems.u[idx] = w;
});
$c_scm_BitSet.prototype.ensureCapacity__I__V = (function(idx) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Predef$().require__Z__V((idx < 33554432));
  if ((idx >= this.scm_BitSet__f_elems.u.length)) {
    var newlen = this.scm_BitSet__f_elems.u.length;
    while ((idx >= newlen)) {
      var x = (newlen << 1);
      newlen = ((x < 33554432) ? x : 33554432);
    }
    var elems1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_J(newlen);
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Array$().copy__O__I__O__I__I__V(this.scm_BitSet__f_elems, 0, elems1, 0, this.scm_BitSet__f_elems.u.length);
    this.scm_BitSet__f_elems = elems1;
  }
});
$c_scm_BitSet.prototype.$bar$eq__sc_BitSet__scm_BitSet = (function(other) {
  this.ensureCapacity__I__V((((-1) + other.nwords__I()) | 0));
  var i = 0;
  var othernwords = other.nwords__I();
  while ((i < othernwords)) {
    var $x_2 = this.scm_BitSet__f_elems;
    var $x_1 = i;
    var a = this.scm_BitSet__f_elems.u[i];
    var b = other.word__I__J(i);
    var lo = (a.RTLong__f_lo | b.RTLong__f_lo);
    var hi = (a.RTLong__f_hi | b.RTLong__f_hi);
    $x_2.u[$x_1] = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi);
    i = ((1 + i) | 0);
  }
  return this;
});
$c_scm_BitSet.prototype.addAll__sc_IterableOnce__scm_BitSet = (function(xs) {
  if ($is_sc_BitSet(xs)) {
    return this.$bar$eq__sc_BitSet__scm_BitSet(xs);
  } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_Range)) {
    if ((!xs.sci_Range__f_isEmpty)) {
      var start = xs.min__s_math_Ordering__I($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_math_Ordering$Int$());
      if ((start >= 0)) {
        var end = xs.max__s_math_Ordering__I($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_math_Ordering$Int$());
        var endIdx = (end >> 6);
        this.ensureCapacity__I__V(endIdx);
        if (((xs.sci_Range__f_step === 1) || (xs.sci_Range__f_step === (-1)))) {
          var startIdx = (start >> 6);
          var wordStart = (startIdx << 6);
          var n = ((start - wordStart) | 0);
          var lo = (((32 & n) === 0) ? ((-1) << n) : 0);
          var hi = (((32 & n) === 0) ? (((2147483647 >>> ((31 - n) | 0)) | 0) | ((-1) << n)) : ((-1) << n));
          if ((endIdx > startIdx)) {
            var ev$1 = this.scm_BitSet__f_elems;
            var a = ev$1.u[startIdx];
            var lo$1 = (a.RTLong__f_lo | lo);
            var hi$1 = (a.RTLong__f_hi | hi);
            ev$1.u[startIdx] = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$1, hi$1);
            var a$1 = this.scm_BitSet__f_elems;
            var fromIndex = ((1 + startIdx) | 0);
            $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_Arrays$().fill__AJ__I__I__J__V(a$1, fromIndex, endIdx, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong((-1), (-1)));
            var ev$2 = this.scm_BitSet__f_elems;
            var a$2 = ev$2.u[endIdx];
            var n$1 = ((63 - ((end - (endIdx << 6)) | 0)) | 0);
            var lo$2 = (((32 & n$1) === 0) ? ((((-1) >>> n$1) | 0) | ((-2) << ((31 - n$1) | 0))) : (((-1) >>> n$1) | 0));
            var hi$2 = (((32 & n$1) === 0) ? (((-1) >>> n$1) | 0) : 0);
            var lo$3 = (a$2.RTLong__f_lo | lo$2);
            var hi$3 = (a$2.RTLong__f_hi | hi$2);
            ev$2.u[endIdx] = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$3, hi$3);
          } else {
            var ev$3 = this.scm_BitSet__f_elems;
            var a$3 = ev$3.u[endIdx];
            var n$2 = ((63 - ((end - wordStart) | 0)) | 0);
            var lo$4 = (((32 & n$2) === 0) ? ((((-1) >>> n$2) | 0) | ((-2) << ((31 - n$2) | 0))) : (((-1) >>> n$2) | 0));
            var hi$4 = (((32 & n$2) === 0) ? (((-1) >>> n$2) | 0) : 0);
            var lo$5 = (lo & lo$4);
            var hi$5 = (hi & hi$4);
            var lo$6 = (a$3.RTLong__f_lo | lo$5);
            var hi$6 = (a$3.RTLong__f_hi | hi$5);
            ev$3.u[endIdx] = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$6, hi$6);
          }
        } else {
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs);
        }
      } else {
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs);
      }
    }
    return this;
  } else if ($is_sc_SortedSet(xs)) {
    if ((!xs.isEmpty__Z())) {
      var ord = xs.ordering__s_math_Ordering();
      if ((ord === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_math_Ordering$Int$())) {
        this.ensureCapacity__I__V(((xs.last__O() | 0) >> 6));
      } else {
        var this$8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_math_Ordering$Int$();
        if ((ord === this$8.s_math_Ordering$Int$__f_scala$math$Ordering$CachedReverse$$_reverse)) {
          this.ensureCapacity__I__V(((xs.head__O() | 0) >> 6));
        }
      }
      var iter = xs.iterator__sc_Iterator();
      while (iter.hasNext__Z()) {
        this.addOne__I__scm_BitSet((iter.next__O() | 0));
      }
    }
    return this;
  } else {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs);
  }
});
$c_scm_BitSet.prototype.subsetOf__sc_Set__Z = (function(that) {
  if ($is_sc_BitSet(that)) {
    var thisnwords = this.scm_BitSet__f_elems.u.length;
    var bsnwords = that.nwords__I();
    var minWords = ((thisnwords < bsnwords) ? thisnwords : bsnwords);
    var i = bsnwords;
    while ((i < thisnwords)) {
      var a = this.word__I__J(i);
      if ((!((a.RTLong__f_lo === 0) && (a.RTLong__f_hi === 0)))) {
        return false;
      }
      i = ((1 + i) | 0);
    }
    var j = 0;
    while ((j < minWords)) {
      var a$1 = this.word__I__J(j);
      var b = that.word__I__J(j);
      var lo = (~b.RTLong__f_lo);
      var hi = (~b.RTLong__f_hi);
      var lo$1 = (a$1.RTLong__f_lo & lo);
      var hi$1 = (a$1.RTLong__f_hi & hi);
      if ((!((lo$1 === 0) && (hi$1 === 0)))) {
        return false;
      }
      j = ((1 + j) | 0);
    }
    return true;
  } else {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__forall__F1__Z(this, that);
  }
});
$c_scm_BitSet.prototype.filterImpl__F1__Z__scm_BitSet = (function(pred, isFlipped) {
  var i = (((-1) + this.scm_BitSet__f_elems.u.length) | 0);
  var newArray = null;
  while ((i >= 0)) {
    var t = $m_sc_BitSetOps$().computeWordForFilter__F1__Z__J__I__J(pred, isFlipped, this.word__I__J(i), i);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    if ((!((lo === 0) && (hi === 0)))) {
      if ((newArray === null)) {
        newArray = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_J(((1 + i) | 0));
      }
      newArray.u[i] = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi);
    }
    i = (((-1) + i) | 0);
  }
  return ((newArray === null) ? $ct_scm_BitSet__(new $c_scm_BitSet()) : this.fromBitMaskNoCopy__AJ__scm_BitSet(newArray));
});
$c_scm_BitSet.prototype.concat__sc_IterableOnce__sc_SetOps = (function(that) {
  return $f_sc_BitSetOps__concat__sc_IterableOnce__sc_BitSet(this, that);
});
$c_scm_BitSet.prototype.contains__O__Z = (function(elem) {
  var elem$1 = (elem | 0);
  return $f_sc_BitSetOps__contains__I__Z(this, elem$1);
});
$c_scm_BitSet.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__scm_BitSet(elems);
});
$c_scm_BitSet.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__I__scm_BitSet((elem | 0));
});
$c_scm_BitSet.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__I__scm_BitSet((elem | 0));
});
$c_scm_BitSet.prototype.fromBitMaskNoCopy__AJ__sc_BitSet = (function(elems) {
  return this.fromBitMaskNoCopy__AJ__scm_BitSet(elems);
});
$c_scm_BitSet.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var empty = $ct_scm_BitSet__(new $c_scm_BitSet());
  return empty.addAll__sc_IterableOnce__scm_BitSet(coll);
});
$c_scm_BitSet.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  var empty = $ct_scm_BitSet__(new $c_scm_BitSet());
  return empty.addAll__sc_IterableOnce__scm_BitSet(coll);
});
var $d_scm_BitSet = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_scm_BitSet, "scala.collection.mutable.BitSet", ({
  scm_BitSet: 1,
  scm_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  scm_Set: 1,
  scm_Iterable: 1,
  scm_SetOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  scm_SortedSet: 1,
  sc_SortedSet: 1,
  sc_SortedSetOps: 1,
  sc_SortedOps: 1,
  sc_SortedSetFactoryDefaults: 1,
  scm_SortedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_BitSet: 1,
  sc_BitSetOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_BitSet as $d_scm_BitSet };
function $ct_Lcats_instances_AllInstancesBinCompat__($thiz) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_instances_IntInstances__$init$__V($thiz);
  $f_Lcats_kernel_instances_ByteInstances__$init$__V($thiz);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_instances_LongInstances__$init$__V($thiz);
  $f_Lcats_kernel_instances_ShortInstances__$init$__V($thiz);
  $f_Lcats_kernel_instances_FloatInstances__$init$__V($thiz);
  $f_Lcats_kernel_instances_DoubleInstances__$init$__V($thiz);
  $f_Lcats_kernel_instances_UnitInstances__$init$__V($thiz);
  $f_Lcats_kernel_instances_BigIntInstances__$init$__V($thiz);
  $f_Lcats_kernel_instances_BigDecimalInstances__$init$__V($thiz);
  $f_Lcats_kernel_instances_BitSetInstances__$init$__V($thiz);
  $f_Lcats_instances_Function1Instances__$init$__V($thiz);
  $f_Lcats_instances_InvariantMonoidalInstances__$init$__V($thiz);
  $f_Lcats_instances_LazyListInstances__$init$__V($thiz);
  new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_instances_ListInstances$$anon$1();
  new $c_Lcats_instances_OptionInstances$$anon$1();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_instances_StringInstances__$init$__V($thiz);
  new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_instances_VectorInstances$$anon$1();
  new $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1();
  new $c_Lcats_instances_OptionInstancesBinCompat0$$anon$3();
  new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_instances_ListInstancesBinCompat0$$anon$6();
  new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_instances_VectorInstancesBinCompat0$$anon$6();
  new $c_Lcats_instances_StreamInstancesBinCompat0$$anon$7();
  $f_Lcats_kernel_instances_DurationInstances__$init$__V($thiz);
  $f_Lcats_kernel_instances_FiniteDurationInstances__$init$__V($thiz);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_instances_SeqInstances__$init$__V($thiz);
  $f_Lcats_instances_InvariantInstances__$init$__V($thiz);
  return $thiz;
}
export { $ct_Lcats_instances_AllInstancesBinCompat__ as $ct_Lcats_instances_AllInstancesBinCompat__ };
/** @constructor */
function $c_Lcats_instances_AllInstancesBinCompat() {
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForFunction1 = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForLazyList = null;
}
export { $c_Lcats_instances_AllInstancesBinCompat as $c_Lcats_instances_AllInstancesBinCompat };
$c_Lcats_instances_AllInstancesBinCompat.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_instances_AllInstancesBinCompat.prototype.constructor = $c_Lcats_instances_AllInstancesBinCompat;
/** @constructor */
function $h_Lcats_instances_AllInstancesBinCompat() {
}
export { $h_Lcats_instances_AllInstancesBinCompat as $h_Lcats_instances_AllInstancesBinCompat };
$h_Lcats_instances_AllInstancesBinCompat.prototype = $c_Lcats_instances_AllInstancesBinCompat.prototype;
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$IntInstances$_setter_$catsKernelStdOrderForInt_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$IntInstances$_setter_$catsKernelStdGroupForInt_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$ByteInstances$_setter_$catsKernelStdOrderForByte_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$ByteInstances$_setter_$catsKernelStdGroupForByte_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$LongInstances$_setter_$catsKernelStdOrderForLong_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$LongInstances$_setter_$catsKernelStdGroupForLong_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$ShortInstances$_setter_$catsKernelStdOrderForShort_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$ShortInstances$_setter_$catsKernelStdGroupForShort_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$FloatInstances$_setter_$catsKernelStdOrderForFloat_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$FloatInstances$_setter_$catsKernelStdGroupForFloat_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$DoubleInstances$_setter_$catsKernelStdOrderForDouble_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$DoubleInstances$_setter_$catsKernelStdGroupForDouble_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$UnitInstances$_setter_$catsKernelStdOrderForUnit_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$UnitInstances$_setter_$catsKernelStdAlgebraForUnit_$eq__Lcats_kernel_BoundedSemilattice__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$BigIntInstances$_setter_$catsKernelStdOrderForBigInt_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$BigIntInstances$_setter_$catsKernelStdGroupForBigInt_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$BigDecimalInstances$_setter_$catsKernelStdOrderForBigDecimal_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$BigDecimalInstances$_setter_$catsKernelStdGroupForBigDecimal_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$BitSetInstances$_setter_$catsKernelStdOrderForBitSet_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$BitSetInstances$_setter_$catsKernelStdSemilatticeForBitSet_$eq__Lcats_kernel_BoundedSemilattice__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.catsStdInstancesForFunction1__Lcats_arrow_ArrowChoice = (function() {
  return this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForFunction1;
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$Function1Instances$_setter_$catsStdInstancesForFunction1_$eq__Lcats_arrow_ArrowChoice__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForFunction1 = x$0;
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$Function1Instances$_setter_$catsStdMonoidKForFunction1_$eq__Lcats_MonoidK__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalSemigroup_$eq__Lcats_InvariantMonoidal__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalCommutativeSemigroup_$eq__Lcats_InvariantMonoidal__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.catsStdInstancesForLazyList__Lcats_Align = (function() {
  return this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForLazyList;
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$LazyListInstances$_setter_$catsStdInstancesForLazyList_$eq__Lcats_Align__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForLazyList = x$0;
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$LazyListInstances$_setter_$catsStdTraverseFilterForLazyList_$eq__Lcats_TraverseFilter__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$StringInstances$_setter_$catsKernelStdOrderForString_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$StringInstances$_setter_$catsKernelStdMonoidForString_$eq__Lcats_kernel_Monoid__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$DurationInstances$_setter_$catsKernelStdOrderForDuration_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$DurationInstances$_setter_$catsKernelStdGroupForDuration_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$FiniteDurationInstances$_setter_$catsKernelStdOrderForFiniteDuration_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$FiniteDurationInstances$_setter_$catsKernelStdGroupForFiniteDuration_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$SeqInstances$_setter_$catsStdInstancesForSeq_$eq__Lcats_Align__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$SeqInstances$_setter_$catsStdTraverseFilterForSeq_$eq__Lcats_TraverseFilter__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$InvariantInstances$_setter_$catsInvariantForNumeric_$eq__Lcats_Invariant__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$InvariantInstances$_setter_$catsInvariantForIntegral_$eq__Lcats_Invariant__V = (function(x$0) {
});
/** @constructor */
function $c_Lcats_instances_package$all$() {
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForFunction1 = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForLazyList = null;
  $ct_Lcats_instances_AllInstancesBinCompat__(this);
}
export { $c_Lcats_instances_package$all$ as $c_Lcats_instances_package$all$ };
$c_Lcats_instances_package$all$.prototype = new $h_Lcats_instances_AllInstancesBinCompat();
$c_Lcats_instances_package$all$.prototype.constructor = $c_Lcats_instances_package$all$;
/** @constructor */
function $h_Lcats_instances_package$all$() {
}
export { $h_Lcats_instances_package$all$ as $h_Lcats_instances_package$all$ };
$h_Lcats_instances_package$all$.prototype = $c_Lcats_instances_package$all$.prototype;
var $d_Lcats_instances_package$all$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_instances_package$all$, "cats.instances.package$all$", ({
  Lcats_instances_package$all$: 1,
  Lcats_instances_AllInstancesBinCompat: 1,
  Lcats_kernel_instances_IntInstances: 1,
  Lcats_instances_IntInstances: 1,
  Lcats_kernel_instances_ByteInstances: 1,
  Lcats_instances_ByteInstances: 1,
  Lcats_kernel_instances_CharInstances: 1,
  Lcats_instances_CharInstances: 1,
  Lcats_kernel_instances_LongInstances: 1,
  Lcats_instances_LongInstances: 1,
  Lcats_kernel_instances_ShortInstances: 1,
  Lcats_instances_ShortInstances: 1,
  Lcats_kernel_instances_FloatInstances: 1,
  Lcats_instances_FloatInstances: 1,
  Lcats_kernel_instances_DoubleInstances: 1,
  Lcats_instances_DoubleInstances: 1,
  Lcats_kernel_instances_BooleanInstances: 1,
  Lcats_instances_BooleanInstances: 1,
  Lcats_kernel_instances_UnitInstances: 1,
  Lcats_instances_UnitInstances: 1,
  Lcats_instances_Tuple2Instances4: 1,
  Lcats_instances_Tuple2Instances3: 1,
  Lcats_instances_Tuple2Instances2: 1,
  Lcats_instances_Tuple2Instances1: 1,
  Lcats_instances_Tuple2Instances: 1,
  Lcats_kernel_instances_TupleInstances3: 1,
  Lcats_kernel_instances_TupleInstances2: 1,
  Lcats_kernel_instances_TupleInstances1: 1,
  Lcats_kernel_instances_TupleInstances: 1,
  Lcats_instances_TupleInstances: 1,
  Lcats_instances_AnyValInstances: 1,
  Lcats_kernel_instances_ArraySeqInstances$ArraySeqInstances2: 1,
  Lcats_kernel_instances_ArraySeqInstances$ArraySeqInstances1: 1,
  Lcats_kernel_instances_ArraySeqInstances: 1,
  Lcats_instances_ArraySeqInstances: 1,
  Lcats_kernel_instances_BigIntInstances: 1,
  Lcats_instances_BigIntInstances: 1,
  Lcats_kernel_instances_BigDecimalInstances: 1,
  Lcats_instances_BigDecimalInstances: 1,
  Lcats_kernel_instances_BitSetInstances: 1,
  Lcats_instances_BitSetInstances: 1,
  Lcats_kernel_instances_EitherInstances1: 1,
  Lcats_kernel_instances_EitherInstances0: 1,
  Lcats_kernel_instances_EitherInstances: 1,
  Lcats_instances_EitherInstances: 1,
  Lcats_kernel_EqToEquivConversion: 1,
  Lcats_kernel_instances_EqInstances: 1,
  Lcats_instances_EqInstances: 1,
  Lcats_instances_EquivInstances: 1,
  Lcats_kernel_instances_FunctionInstances4: 1,
  Lcats_kernel_instances_FunctionInstances3: 1,
  Lcats_kernel_instances_FunctionInstances2: 1,
  Lcats_kernel_instances_FunctionInstances1: 1,
  Lcats_kernel_instances_FunctionInstances0: 1,
  Lcats_kernel_instances_FunctionInstances: 1,
  Lcats_instances_Function0Instances0: 1,
  Lcats_instances_Function0Instances: 1,
  Lcats_instances_Function1Instances0: 1,
  Lcats_instances_Function1Instances: 1,
  Lcats_instances_FunctionInstances: 1,
  Lcats_instances_FutureInstances2: 1,
  Lcats_instances_FutureInstances1: 1,
  Lcats_instances_FutureInstances: 1,
  Lcats_kernel_HashToHashingConversion: 1,
  Lcats_kernel_instances_HashInstances: 1,
  Lcats_instances_HashInstances: 1,
  Lcats_instances_InvariantMonoidalInstances: 1,
  Lcats_kernel_instances_LazyListInstances2: 1,
  Lcats_kernel_instances_LazyListInstances1: 1,
  Lcats_kernel_instances_LazyListInstances: 1,
  Lcats_instances_LazyListInstances: 1,
  Lcats_kernel_instances_ListInstances2: 1,
  Lcats_kernel_instances_ListInstances1: 1,
  Lcats_kernel_instances_ListInstances: 1,
  Lcats_instances_ListInstances: 1,
  Lcats_kernel_instances_MapInstances1: 1,
  Lcats_kernel_instances_MapInstances: 1,
  Lcats_instances_MapInstances: 1,
  Lcats_kernel_instances_OptionInstances2: 1,
  Lcats_kernel_instances_OptionInstances1: 1,
  Lcats_kernel_instances_OptionInstances0: 1,
  Lcats_kernel_instances_OptionInstances: 1,
  Lcats_instances_OptionInstances: 1,
  Lcats_kernel_OrderToOrderingConversion: 1,
  Lcats_kernel_instances_OrderInstances: 1,
  Lcats_instances_OrderInstances: 1,
  Lcats_instances_OrderingInstances: 1,
  Lcats_instances_ParallelInstances1: 1,
  Lcats_instances_ParallelInstances: 1,
  Lcats_kernel_PartialOrderToPartialOrderingConversion: 1,
  Lcats_kernel_instances_PartialOrderInstances: 1,
  Lcats_instances_PartialOrderInstances: 1,
  Lcats_instances_PartialOrderingInstances: 1,
  Lcats_kernel_instances_QueueInstances2: 1,
  Lcats_kernel_instances_QueueInstances1: 1,
  Lcats_kernel_instances_QueueInstances: 1,
  Lcats_instances_QueueInstances: 1,
  Lcats_kernel_instances_SetInstances1: 1,
  Lcats_kernel_instances_SetInstances: 1,
  Lcats_instances_SetInstances: 1,
  Lcats_instances_SortedMapInstances1: 1,
  Lcats_instances_SortedMapInstances2: 1,
  Lcats_instances_SortedMapInstances: 1,
  Lcats_instances_SortedSetInstances1: 1,
  Lcats_instances_SortedSetInstances: 1,
  Lcats_instances_ShowInstances: 1,
  Lcats_kernel_instances_StreamInstances2: 1,
  Lcats_kernel_instances_StreamInstances1: 1,
  Lcats_kernel_instances_StreamInstances: 1,
  Lcats_instances_StreamInstances: 1,
  Lcats_kernel_instances_StringInstances: 1,
  Lcats_instances_StringInstances: 1,
  Lcats_kernel_instances_SymbolInstances: 1,
  Lcats_instances_SymbolInstances: 1,
  Lcats_instances_TailRecInstances: 1,
  Lcats_instances_TryInstances2: 1,
  Lcats_instances_TryInstances1: 1,
  Lcats_instances_TryInstances: 1,
  Lcats_kernel_instances_UUIDInstances: 1,
  Lcats_instances_UUIDInstances: 1,
  Lcats_kernel_instances_VectorInstances2: 1,
  Lcats_kernel_instances_VectorInstances1: 1,
  Lcats_kernel_instances_VectorInstances: 1,
  Lcats_instances_VectorInstances: 1,
  Lcats_instances_PartialFunctionInstances: 1,
  Lcats_instances_AllInstances: 1,
  Lcats_instances_FunctionInstancesBinCompat0: 1,
  Lcats_instances_Tuple2InstancesBinCompat0: 1,
  Lcats_instances_AllInstancesBinCompat0: 1,
  Lcats_instances_OptionInstancesBinCompat0: 1,
  Lcats_instances_ListInstancesBinCompat0: 1,
  Lcats_instances_VectorInstancesBinCompat0: 1,
  Lcats_instances_StreamInstancesBinCompat0: 1,
  Lcats_instances_MapInstancesBinCompat0: 1,
  Lcats_instances_SortedMapInstancesBinCompat0: 1,
  Lcats_instances_AllInstancesBinCompat1: 1,
  Lcats_kernel_instances_DurationInstances: 1,
  Lcats_instances_DurationInstances: 1,
  Lcats_kernel_instances_FiniteDurationInstances: 1,
  Lcats_instances_FiniteDurationInstances: 1,
  Lcats_instances_AllInstancesBinCompat2: 1,
  Lcats_instances_CoreDurationInstances: 1,
  Lcats_instances_CoreFiniteDurationInstances: 1,
  Lcats_instances_AllCoreDurationInstances: 1,
  Lcats_instances_AllInstancesBinCompat3: 1,
  Lcats_instances_SortedMapInstancesBinCompat1: 1,
  Lcats_instances_MapInstancesBinCompat1: 1,
  Lcats_instances_AllInstancesBinCompat4: 1,
  Lcats_instances_SortedSetInstancesBinCompat0: 1,
  Lcats_instances_AllInstancesBinCompat5: 1,
  Lcats_kernel_instances_SortedSetInstances1: 1,
  Lcats_kernel_instances_SortedSetInstances: 1,
  Lcats_instances_LowPrioritySortedSetInstancesBinCompat1: 1,
  Lcats_instances_SortedSetInstancesBinCompat1: 1,
  Lcats_kernel_instances_SortedMapInstances1: 1,
  Lcats_kernel_instances_SortedMapInstances2: 1,
  Lcats_kernel_instances_SortedMapInstances3: 1,
  Lcats_kernel_instances_SortedMapInstances: 1,
  Lcats_instances_SortedMapInstancesBinCompat2: 1,
  Lcats_instances_AllInstancesBinCompat6: 1,
  Lcats_kernel_instances_SeqInstances2: 1,
  Lcats_kernel_instances_SeqInstances1: 1,
  Lcats_kernel_instances_SeqInstances: 1,
  Lcats_instances_SeqInstances: 1,
  Lcats_instances_AllInstancesBinCompat7: 1,
  Lcats_instances_InvariantInstances: 1,
  Lcats_instances_AllInstancesBinCompat8: 1,
  Lcats_kernel_instances_DeadlineInstances: 1,
  Lcats_instances_DeadlineInstances: 1,
  Lcats_instances_AllInstancesBinCompat9: 1
}));
export { $d_Lcats_instances_package$all$ as $d_Lcats_instances_package$all$ };
var $n_Lcats_instances_package$all$;
function $m_Lcats_instances_package$all$() {
  if ((!$n_Lcats_instances_package$all$)) {
    $n_Lcats_instances_package$all$ = new $c_Lcats_instances_package$all$();
  }
  return $n_Lcats_instances_package$all$;
}
export { $m_Lcats_instances_package$all$ as $m_Lcats_instances_package$all$ };
/** @constructor */
function $c_Lcats_implicits$() {
  this.Lcats_implicits$__f_catsStdInstancesForFunction1 = null;
  this.Lcats_implicits$__f_catsStdInstancesForLazyList = null;
  this.Lcats_implicits$__f_catsStdShowForString = null;
  $n_Lcats_implicits$ = this;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_instances_IntInstances__$init$__V(this);
  $f_Lcats_kernel_instances_ByteInstances__$init$__V(this);
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_instances_LongInstances__$init$__V(this);
  $f_Lcats_kernel_instances_ShortInstances__$init$__V(this);
  $f_Lcats_kernel_instances_FloatInstances__$init$__V(this);
  $f_Lcats_kernel_instances_DoubleInstances__$init$__V(this);
  $f_Lcats_kernel_instances_UnitInstances__$init$__V(this);
  $f_Lcats_kernel_instances_BigIntInstances__$init$__V(this);
  $f_Lcats_kernel_instances_BigDecimalInstances__$init$__V(this);
  $f_Lcats_kernel_instances_BitSetInstances__$init$__V(this);
  $f_Lcats_instances_Function1Instances__$init$__V(this);
  $f_Lcats_instances_InvariantMonoidalInstances__$init$__V(this);
  $f_Lcats_instances_LazyListInstances__$init$__V(this);
  new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_instances_ListInstances$$anon$1();
  new $c_Lcats_instances_OptionInstances$$anon$1();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcats_kernel_instances_StringInstances__$init$__V(this);
  this.Lcats_implicits$__f_catsStdShowForString = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$$anon$5();
  new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_instances_VectorInstances$$anon$1();
  new $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1();
  new $c_Lcats_instances_OptionInstancesBinCompat0$$anon$3();
  new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_instances_ListInstancesBinCompat0$$anon$6();
  new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_instances_VectorInstancesBinCompat0$$anon$6();
  new $c_Lcats_instances_StreamInstancesBinCompat0$$anon$7();
  $f_Lcats_kernel_instances_DurationInstances__$init$__V(this);
  $f_Lcats_kernel_instances_FiniteDurationInstances__$init$__V(this);
}
export { $c_Lcats_implicits$ as $c_Lcats_implicits$ };
$c_Lcats_implicits$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lcats_implicits$.prototype.constructor = $c_Lcats_implicits$;
/** @constructor */
function $h_Lcats_implicits$() {
}
export { $h_Lcats_implicits$ as $h_Lcats_implicits$ };
$h_Lcats_implicits$.prototype = $c_Lcats_implicits$.prototype;
$c_Lcats_implicits$.prototype.cats$kernel$instances$IntInstances$_setter_$catsKernelStdOrderForInt_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$IntInstances$_setter_$catsKernelStdGroupForInt_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$ByteInstances$_setter_$catsKernelStdOrderForByte_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$ByteInstances$_setter_$catsKernelStdGroupForByte_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$LongInstances$_setter_$catsKernelStdOrderForLong_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$LongInstances$_setter_$catsKernelStdGroupForLong_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$ShortInstances$_setter_$catsKernelStdOrderForShort_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$ShortInstances$_setter_$catsKernelStdGroupForShort_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$FloatInstances$_setter_$catsKernelStdOrderForFloat_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$FloatInstances$_setter_$catsKernelStdGroupForFloat_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$DoubleInstances$_setter_$catsKernelStdOrderForDouble_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$DoubleInstances$_setter_$catsKernelStdGroupForDouble_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$UnitInstances$_setter_$catsKernelStdOrderForUnit_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$UnitInstances$_setter_$catsKernelStdAlgebraForUnit_$eq__Lcats_kernel_BoundedSemilattice__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$BigIntInstances$_setter_$catsKernelStdOrderForBigInt_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$BigIntInstances$_setter_$catsKernelStdGroupForBigInt_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$BigDecimalInstances$_setter_$catsKernelStdOrderForBigDecimal_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$BigDecimalInstances$_setter_$catsKernelStdGroupForBigDecimal_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$BitSetInstances$_setter_$catsKernelStdOrderForBitSet_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$BitSetInstances$_setter_$catsKernelStdSemilatticeForBitSet_$eq__Lcats_kernel_BoundedSemilattice__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.catsStdInstancesForFunction1__Lcats_arrow_ArrowChoice = (function() {
  return this.Lcats_implicits$__f_catsStdInstancesForFunction1;
});
$c_Lcats_implicits$.prototype.cats$instances$Function1Instances$_setter_$catsStdInstancesForFunction1_$eq__Lcats_arrow_ArrowChoice__V = (function(x$0) {
  this.Lcats_implicits$__f_catsStdInstancesForFunction1 = x$0;
});
$c_Lcats_implicits$.prototype.cats$instances$Function1Instances$_setter_$catsStdMonoidKForFunction1_$eq__Lcats_MonoidK__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalSemigroup_$eq__Lcats_InvariantMonoidal__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalCommutativeSemigroup_$eq__Lcats_InvariantMonoidal__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.catsStdInstancesForLazyList__Lcats_Align = (function() {
  return this.Lcats_implicits$__f_catsStdInstancesForLazyList;
});
$c_Lcats_implicits$.prototype.cats$instances$LazyListInstances$_setter_$catsStdInstancesForLazyList_$eq__Lcats_Align__V = (function(x$0) {
  this.Lcats_implicits$__f_catsStdInstancesForLazyList = x$0;
});
$c_Lcats_implicits$.prototype.cats$instances$LazyListInstances$_setter_$catsStdTraverseFilterForLazyList_$eq__Lcats_TraverseFilter__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$StringInstances$_setter_$catsKernelStdOrderForString_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$StringInstances$_setter_$catsKernelStdMonoidForString_$eq__Lcats_kernel_Monoid__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$DurationInstances$_setter_$catsKernelStdOrderForDuration_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$DurationInstances$_setter_$catsKernelStdGroupForDuration_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$FiniteDurationInstances$_setter_$catsKernelStdOrderForFiniteDuration_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$FiniteDurationInstances$_setter_$catsKernelStdGroupForFiniteDuration_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
var $d_Lcats_implicits$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lcats_implicits$, "cats.implicits$", ({
  Lcats_implicits$: 1,
  Lcats_syntax_AlternativeSyntax: 1,
  Lcats_syntax_NonEmptyAlternativeSyntax: 1,
  Ljava_io_Serializable: 1,
  Lcats_Align$ToAlignOps: 1,
  Lcats_syntax_AlignSyntax: 1,
  Lcats_syntax_ApplicativeSyntax: 1,
  Lcats_syntax_ApplicativeErrorSyntax: 1,
  Lcats_syntax_TupleSemigroupalSyntax: 1,
  Lcats_syntax_FunctionApplySyntax: 1,
  Lcats_syntax_ApplySyntax: 1,
  Lcats_arrow_Arrow$ToArrowOps: 1,
  Lcats_syntax_ArrowSyntax: 1,
  Lcats_arrow_ArrowChoice$ToArrowChoiceOps: 1,
  Lcats_syntax_ArrowChoiceSyntax: 1,
  Lcats_Bifunctor$ToBifunctorOps: 1,
  Lcats_syntax_BifunctorSyntax: 1,
  Lcats_Bifoldable$ToBifoldableOps: 1,
  Lcats_syntax_BifoldableSyntax: 1,
  Lcats_syntax_BitraverseSyntax1: 1,
  Lcats_syntax_BitraverseSyntax: 1,
  Lcats_syntax_SemigroupalSyntax: 1,
  Lcats_CoflatMap$ToCoflatMapOps: 1,
  Lcats_syntax_CoflatMapSyntax: 1,
  Lcats_Comonad$ToComonadOps: 1,
  Lcats_syntax_ComonadSyntax: 1,
  Lcats_arrow_Compose$ToComposeOps: 1,
  Lcats_syntax_ComposeSyntax: 1,
  Lcats_Contravariant$ToContravariantOps: 1,
  Lcats_syntax_ContravariantSyntax: 1,
  Lcats_Distributive$ToDistributiveOps: 1,
  Lcats_syntax_DistributiveSyntax: 1,
  Lcats_syntax_ContravariantMonoidalSyntax: 1,
  Lcats_syntax_ContravariantSemigroupalSyntax: 1,
  Lcats_syntax_EitherKSyntax: 1,
  Lcats_syntax_EitherSyntax: 1,
  Lcats_syntax_EqSyntax: 1,
  Lcats_FlatMap$ToFlatMapOps: 1,
  Lcats_syntax_FlatMapSyntax: 1,
  Lcats_Foldable$ToFoldableOps: 1,
  Lcats_UnorderedFoldable$ToUnorderedFoldableOps: 1,
  Lcats_syntax_FoldableSyntax: 1,
  Lcats_Functor$ToFunctorOps: 1,
  Lcats_syntax_FunctorSyntax: 1,
  Lcats_syntax_SemigroupSyntax: 1,
  Lcats_syntax_GroupSyntax: 1,
  Lcats_syntax_HashSyntax: 1,
  Lcats_Invariant$ToInvariantOps: 1,
  Lcats_syntax_InvariantSyntax: 1,
  Lcats_syntax_IorSyntax: 1,
  Lcats_syntax_ListSyntax: 1,
  Lcats_syntax_MonadErrorSyntax: 1,
  Lcats_syntax_MonadSyntax: 1,
  Lcats_syntax_MonoidSyntax: 1,
  Lcats_syntax_OptionSyntax: 1,
  Lcats_syntax_PartialOrderSyntax: 1,
  Lcats_syntax_OrderSyntax: 1,
  Lcats_syntax_TupleParallelSyntax: 1,
  Lcats_syntax_ParallelSyntax: 1,
  Lcats_arrow_Profunctor$ToProfunctorOps: 1,
  Lcats_syntax_ProfunctorSyntax: 1,
  Lcats_Reducible$ToReducibleOps: 1,
  Lcats_syntax_ReducibleSyntax: 1,
  Lcats_SemigroupK$ToSemigroupKOps: 1,
  Lcats_syntax_SemigroupKSyntax: 1,
  Lcats_Show$ToShowOps: 1,
  Lcats_syntax_ShowSyntax: 1,
  Lcats_arrow_Strong$ToStrongOps: 1,
  Lcats_syntax_StrongSyntax: 1,
  Lcats_Traverse$ToTraverseOps: 1,
  Lcats_syntax_TraverseSyntax: 1,
  Lcats_NonEmptyTraverse$ToNonEmptyTraverseOps: 1,
  Lcats_syntax_NonEmptyTraverseSyntax: 1,
  Lcats_syntax_ValidatedSyntax: 1,
  Lcats_syntax_VectorSyntax: 1,
  Lcats_syntax_WriterSyntax: 1,
  Lcats_syntax_ParallelFoldMapASyntax: 1,
  Lcats_syntax_ParallelTraverseFilterSyntax: 1,
  Lcats_syntax_ParallelReduceMapASyntax: 1,
  Lcats_syntax_AllSyntax: 1,
  Lcats_UnorderedTraverse$ToUnorderedTraverseOps: 1,
  Lcats_syntax_UnorderedTraverseSyntax: 1,
  Lcats_syntax_ApplicativeErrorExtension: 1,
  Lcats_syntax_TrySyntax: 1,
  Lcats_syntax_AllSyntaxBinCompat0: 1,
  Lcats_syntax_FlatMapOptionSyntax: 1,
  Lcats_arrow_Choice$ToChoiceOps: 1,
  Lcats_syntax_ChoiceSyntax: 1,
  Lcats_syntax_NestedSyntax: 1,
  Lcats_syntax_BinestedSyntax: 1,
  Lcats_syntax_ParallelFlatSyntax: 1,
  Lcats_syntax_SetSyntax: 1,
  Lcats_syntax_ValidatedExtensionSyntax: 1,
  Lcats_syntax_RepresentableSyntax: 1,
  Lcats_syntax_AllSyntaxBinCompat1: 1,
  Lcats_syntax_ParallelTraverseSyntax: 1,
  Lcats_TraverseFilter$ToTraverseFilterOps: 1,
  Lcats_syntax_TraverseFilterSyntax: 1,
  Lcats_FunctorFilter$ToFunctorFilterOps: 1,
  Lcats_syntax_FunctorFilterSyntax: 1,
  Lcats_syntax_EitherSyntaxBinCompat0: 1,
  Lcats_syntax_ListSyntaxBinCompat0: 1,
  Lcats_syntax_ValidatedSyntaxBincompat0: 1,
  Lcats_syntax_AllSyntaxBinCompat2: 1,
  Lcats_syntax_UnorderedFoldableSyntax: 1,
  Lcats_syntax_Function1Syntax: 1,
  Lcats_syntax_AllSyntaxBinCompat3: 1,
  Lcats_syntax_TraverseFilterSyntaxBinCompat0: 1,
  Lcats_syntax_ApplySyntaxBinCompat0: 1,
  Lcats_syntax_ParallelApplySyntax: 1,
  Lcats_syntax_FoldableSyntaxBinCompat0: 1,
  Lcats_syntax_ReducibleSyntaxBinCompat0: 1,
  Lcats_syntax_FoldableSyntaxBinCompat1: 1,
  Lcats_syntax_BitraverseSyntaxBinCompat0: 1,
  Lcats_syntax_AllSyntaxBinCompat4: 1,
  Lcats_syntax_ParallelBitraverseSyntax: 1,
  Lcats_syntax_AllSyntaxBinCompat5: 1,
  Lcats_syntax_ParallelUnorderedTraverseSyntax: 1,
  Lcats_syntax_AllSyntaxBinCompat6: 1,
  Lcats_kernel_instances_IntInstances: 1,
  Lcats_instances_IntInstances: 1,
  Lcats_kernel_instances_ByteInstances: 1,
  Lcats_instances_ByteInstances: 1,
  Lcats_kernel_instances_CharInstances: 1,
  Lcats_instances_CharInstances: 1,
  Lcats_kernel_instances_LongInstances: 1,
  Lcats_instances_LongInstances: 1,
  Lcats_kernel_instances_ShortInstances: 1,
  Lcats_instances_ShortInstances: 1,
  Lcats_kernel_instances_FloatInstances: 1,
  Lcats_instances_FloatInstances: 1,
  Lcats_kernel_instances_DoubleInstances: 1,
  Lcats_instances_DoubleInstances: 1,
  Lcats_kernel_instances_BooleanInstances: 1,
  Lcats_instances_BooleanInstances: 1,
  Lcats_kernel_instances_UnitInstances: 1,
  Lcats_instances_UnitInstances: 1,
  Lcats_instances_Tuple2Instances4: 1,
  Lcats_instances_Tuple2Instances3: 1,
  Lcats_instances_Tuple2Instances2: 1,
  Lcats_instances_Tuple2Instances1: 1,
  Lcats_instances_Tuple2Instances: 1,
  Lcats_kernel_instances_TupleInstances3: 1,
  Lcats_kernel_instances_TupleInstances2: 1,
  Lcats_kernel_instances_TupleInstances1: 1,
  Lcats_kernel_instances_TupleInstances: 1,
  Lcats_instances_TupleInstances: 1,
  Lcats_instances_AnyValInstances: 1,
  Lcats_kernel_instances_ArraySeqInstances$ArraySeqInstances2: 1,
  Lcats_kernel_instances_ArraySeqInstances$ArraySeqInstances1: 1,
  Lcats_kernel_instances_ArraySeqInstances: 1,
  Lcats_instances_ArraySeqInstances: 1,
  Lcats_kernel_instances_BigIntInstances: 1,
  Lcats_instances_BigIntInstances: 1,
  Lcats_kernel_instances_BigDecimalInstances: 1,
  Lcats_instances_BigDecimalInstances: 1,
  Lcats_kernel_instances_BitSetInstances: 1,
  Lcats_instances_BitSetInstances: 1,
  Lcats_kernel_instances_EitherInstances1: 1,
  Lcats_kernel_instances_EitherInstances0: 1,
  Lcats_kernel_instances_EitherInstances: 1,
  Lcats_instances_EitherInstances: 1,
  Lcats_kernel_EqToEquivConversion: 1,
  Lcats_kernel_instances_EqInstances: 1,
  Lcats_instances_EqInstances: 1,
  Lcats_instances_EquivInstances: 1,
  Lcats_kernel_instances_FunctionInstances4: 1,
  Lcats_kernel_instances_FunctionInstances3: 1,
  Lcats_kernel_instances_FunctionInstances2: 1,
  Lcats_kernel_instances_FunctionInstances1: 1,
  Lcats_kernel_instances_FunctionInstances0: 1,
  Lcats_kernel_instances_FunctionInstances: 1,
  Lcats_instances_Function0Instances0: 1,
  Lcats_instances_Function0Instances: 1,
  Lcats_instances_Function1Instances0: 1,
  Lcats_instances_Function1Instances: 1,
  Lcats_instances_FunctionInstances: 1,
  Lcats_instances_FutureInstances2: 1,
  Lcats_instances_FutureInstances1: 1,
  Lcats_instances_FutureInstances: 1,
  Lcats_kernel_HashToHashingConversion: 1,
  Lcats_kernel_instances_HashInstances: 1,
  Lcats_instances_HashInstances: 1,
  Lcats_instances_InvariantMonoidalInstances: 1,
  Lcats_kernel_instances_LazyListInstances2: 1,
  Lcats_kernel_instances_LazyListInstances1: 1,
  Lcats_kernel_instances_LazyListInstances: 1,
  Lcats_instances_LazyListInstances: 1,
  Lcats_kernel_instances_ListInstances2: 1,
  Lcats_kernel_instances_ListInstances1: 1,
  Lcats_kernel_instances_ListInstances: 1,
  Lcats_instances_ListInstances: 1,
  Lcats_kernel_instances_MapInstances1: 1,
  Lcats_kernel_instances_MapInstances: 1,
  Lcats_instances_MapInstances: 1,
  Lcats_kernel_instances_OptionInstances2: 1,
  Lcats_kernel_instances_OptionInstances1: 1,
  Lcats_kernel_instances_OptionInstances0: 1,
  Lcats_kernel_instances_OptionInstances: 1,
  Lcats_instances_OptionInstances: 1,
  Lcats_kernel_OrderToOrderingConversion: 1,
  Lcats_kernel_instances_OrderInstances: 1,
  Lcats_instances_OrderInstances: 1,
  Lcats_instances_OrderingInstances: 1,
  Lcats_instances_ParallelInstances1: 1,
  Lcats_instances_ParallelInstances: 1,
  Lcats_kernel_PartialOrderToPartialOrderingConversion: 1,
  Lcats_kernel_instances_PartialOrderInstances: 1,
  Lcats_instances_PartialOrderInstances: 1,
  Lcats_instances_PartialOrderingInstances: 1,
  Lcats_kernel_instances_QueueInstances2: 1,
  Lcats_kernel_instances_QueueInstances1: 1,
  Lcats_kernel_instances_QueueInstances: 1,
  Lcats_instances_QueueInstances: 1,
  Lcats_kernel_instances_SetInstances1: 1,
  Lcats_kernel_instances_SetInstances: 1,
  Lcats_instances_SetInstances: 1,
  Lcats_instances_SortedMapInstances1: 1,
  Lcats_instances_SortedMapInstances2: 1,
  Lcats_instances_SortedMapInstances: 1,
  Lcats_instances_SortedSetInstances1: 1,
  Lcats_instances_SortedSetInstances: 1,
  Lcats_instances_ShowInstances: 1,
  Lcats_kernel_instances_StreamInstances2: 1,
  Lcats_kernel_instances_StreamInstances1: 1,
  Lcats_kernel_instances_StreamInstances: 1,
  Lcats_instances_StreamInstances: 1,
  Lcats_kernel_instances_StringInstances: 1,
  Lcats_instances_StringInstances: 1,
  Lcats_kernel_instances_SymbolInstances: 1,
  Lcats_instances_SymbolInstances: 1,
  Lcats_instances_TailRecInstances: 1,
  Lcats_instances_TryInstances2: 1,
  Lcats_instances_TryInstances1: 1,
  Lcats_instances_TryInstances: 1,
  Lcats_kernel_instances_UUIDInstances: 1,
  Lcats_instances_UUIDInstances: 1,
  Lcats_kernel_instances_VectorInstances2: 1,
  Lcats_kernel_instances_VectorInstances1: 1,
  Lcats_kernel_instances_VectorInstances: 1,
  Lcats_instances_VectorInstances: 1,
  Lcats_instances_PartialFunctionInstances: 1,
  Lcats_instances_AllInstances: 1,
  Lcats_instances_FunctionInstancesBinCompat0: 1,
  Lcats_instances_Tuple2InstancesBinCompat0: 1,
  Lcats_instances_AllInstancesBinCompat0: 1,
  Lcats_instances_OptionInstancesBinCompat0: 1,
  Lcats_instances_ListInstancesBinCompat0: 1,
  Lcats_instances_VectorInstancesBinCompat0: 1,
  Lcats_instances_StreamInstancesBinCompat0: 1,
  Lcats_instances_MapInstancesBinCompat0: 1,
  Lcats_instances_SortedMapInstancesBinCompat0: 1,
  Lcats_instances_AllInstancesBinCompat1: 1,
  Lcats_kernel_instances_DurationInstances: 1,
  Lcats_instances_DurationInstances: 1,
  Lcats_kernel_instances_FiniteDurationInstances: 1,
  Lcats_instances_FiniteDurationInstances: 1,
  Lcats_instances_AllInstancesBinCompat2: 1,
  Lcats_instances_CoreDurationInstances: 1,
  Lcats_instances_CoreFiniteDurationInstances: 1,
  Lcats_instances_AllCoreDurationInstances: 1,
  Lcats_instances_AllInstancesBinCompat3: 1,
  Lcats_instances_SortedMapInstancesBinCompat1: 1,
  Lcats_instances_MapInstancesBinCompat1: 1,
  Lcats_instances_AllInstancesBinCompat4: 1,
  Lcats_instances_SortedSetInstancesBinCompat0: 1,
  Lcats_instances_AllInstancesBinCompat5: 1,
  Lcats_kernel_instances_SortedSetInstances1: 1,
  Lcats_kernel_instances_SortedSetInstances: 1,
  Lcats_instances_LowPrioritySortedSetInstancesBinCompat1: 1,
  Lcats_instances_SortedSetInstancesBinCompat1: 1,
  Lcats_kernel_instances_SortedMapInstances1: 1,
  Lcats_kernel_instances_SortedMapInstances2: 1,
  Lcats_kernel_instances_SortedMapInstances3: 1,
  Lcats_kernel_instances_SortedMapInstances: 1,
  Lcats_instances_SortedMapInstancesBinCompat2: 1,
  Lcats_instances_AllInstancesBinCompat6: 1
}));
export { $d_Lcats_implicits$ as $d_Lcats_implicits$ };
var $n_Lcats_implicits$;
function $m_Lcats_implicits$() {
  if ((!$n_Lcats_implicits$)) {
    $n_Lcats_implicits$ = new $c_Lcats_implicits$();
  }
  return $n_Lcats_implicits$;
}
export { $m_Lcats_implicits$ as $m_Lcats_implicits$ };
var $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__INITIAL_SESSION = null;
function $u_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__INITIAL_SESSION(x) {
  $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__INITIAL_SESSION = x;
}
export { $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__INITIAL_SESSION as $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__INITIAL_SESSION, $u_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__INITIAL_SESSION as $u_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__INITIAL_SESSION };
var $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__PASSWORD_RECOVERY = null;
function $u_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__PASSWORD_RECOVERY(x) {
  $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__PASSWORD_RECOVERY = x;
}
export { $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__PASSWORD_RECOVERY as $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__PASSWORD_RECOVERY, $u_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__PASSWORD_RECOVERY as $u_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__PASSWORD_RECOVERY };
var $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__SIGNED_IN = null;
function $u_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__SIGNED_IN(x) {
  $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__SIGNED_IN = x;
}
export { $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__SIGNED_IN as $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__SIGNED_IN, $u_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__SIGNED_IN as $u_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__SIGNED_IN };
var $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__SIGNED_OUT = null;
function $u_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__SIGNED_OUT(x) {
  $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__SIGNED_OUT = x;
}
export { $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__SIGNED_OUT as $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__SIGNED_OUT, $u_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__SIGNED_OUT as $u_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__SIGNED_OUT };
var $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__TOKEN_REFRESHED = null;
function $u_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__TOKEN_REFRESHED(x) {
  $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__TOKEN_REFRESHED = x;
}
export { $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__TOKEN_REFRESHED as $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__TOKEN_REFRESHED, $u_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__TOKEN_REFRESHED as $u_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__TOKEN_REFRESHED };
var $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__USER_UPDATED = null;
function $u_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__USER_UPDATED(x) {
  $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__USER_UPDATED = x;
}
export { $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__USER_UPDATED as $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__USER_UPDATED, $u_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__USER_UPDATED as $u_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__USER_UPDATED };
var $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__AuthChangeEventMFA = null;
function $u_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__AuthChangeEventMFA(x) {
  $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__AuthChangeEventMFA = x;
}
export { $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__AuthChangeEventMFA as $t_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__AuthChangeEventMFA, $u_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__AuthChangeEventMFA as $u_Lframework_auth_SupabaseAuthClient$AuthChangeEvent$__AuthChangeEventMFA };
var $t_Lframework_components_ToastType$__Info = null;
function $u_Lframework_components_ToastType$__Info(x) {
  $t_Lframework_components_ToastType$__Info = x;
}
export { $t_Lframework_components_ToastType$__Info as $t_Lframework_components_ToastType$__Info, $u_Lframework_components_ToastType$__Info as $u_Lframework_components_ToastType$__Info };
var $t_Lframework_components_ToastType$__Success = null;
function $u_Lframework_components_ToastType$__Success(x) {
  $t_Lframework_components_ToastType$__Success = x;
}
export { $t_Lframework_components_ToastType$__Success as $t_Lframework_components_ToastType$__Success, $u_Lframework_components_ToastType$__Success as $u_Lframework_components_ToastType$__Success };
var $t_Lframework_components_ToastType$__Warning = null;
function $u_Lframework_components_ToastType$__Warning(x) {
  $t_Lframework_components_ToastType$__Warning = x;
}
export { $t_Lframework_components_ToastType$__Warning as $t_Lframework_components_ToastType$__Warning, $u_Lframework_components_ToastType$__Warning as $u_Lframework_components_ToastType$__Warning };
var $t_Lframework_components_ToastType$__Error = null;
function $u_Lframework_components_ToastType$__Error(x) {
  $t_Lframework_components_ToastType$__Error = x;
}
export { $t_Lframework_components_ToastType$__Error as $t_Lframework_components_ToastType$__Error, $u_Lframework_components_ToastType$__Error as $u_Lframework_components_ToastType$__Error };
var $t_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__ServerSentEvents = null;
function $u_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__ServerSentEvents(x) {
  $t_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__ServerSentEvents = x;
}
export { $t_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__ServerSentEvents as $t_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__ServerSentEvents, $u_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__ServerSentEvents as $u_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__ServerSentEvents };
var $t_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__WebSocket = null;
function $u_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__WebSocket(x) {
  $t_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__WebSocket = x;
}
export { $t_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__WebSocket as $t_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__WebSocket, $u_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__WebSocket as $u_Lframework_data_EndpointSSEWithWS$ClientConnectionMode$__WebSocket };
var $t_Lframework_exts_OnSSEStreamError$OnErrorAction$__Stop = null;
function $u_Lframework_exts_OnSSEStreamError$OnErrorAction$__Stop(x) {
  $t_Lframework_exts_OnSSEStreamError$OnErrorAction$__Stop = x;
}
export { $t_Lframework_exts_OnSSEStreamError$OnErrorAction$__Stop as $t_Lframework_exts_OnSSEStreamError$OnErrorAction$__Stop, $u_Lframework_exts_OnSSEStreamError$OnErrorAction$__Stop as $u_Lframework_exts_OnSSEStreamError$OnErrorAction$__Stop };
var $t_Lframework_utils_AuthenticatedNetworkRequestFailure$__Aborted = null;
function $u_Lframework_utils_AuthenticatedNetworkRequestFailure$__Aborted(x) {
  $t_Lframework_utils_AuthenticatedNetworkRequestFailure$__Aborted = x;
}
export { $t_Lframework_utils_AuthenticatedNetworkRequestFailure$__Aborted as $t_Lframework_utils_AuthenticatedNetworkRequestFailure$__Aborted, $u_Lframework_utils_AuthenticatedNetworkRequestFailure$__Aborted as $u_Lframework_utils_AuthenticatedNetworkRequestFailure$__Aborted };
var $t_Lframework_utils_BrowserDetection$__MicrosoftEdge = null;
function $u_Lframework_utils_BrowserDetection$__MicrosoftEdge(x) {
  $t_Lframework_utils_BrowserDetection$__MicrosoftEdge = x;
}
export { $t_Lframework_utils_BrowserDetection$__MicrosoftEdge as $t_Lframework_utils_BrowserDetection$__MicrosoftEdge, $u_Lframework_utils_BrowserDetection$__MicrosoftEdge as $u_Lframework_utils_BrowserDetection$__MicrosoftEdge };
var $t_Lframework_utils_LogLevel$__Default = null;
function $u_Lframework_utils_LogLevel$__Default(x) {
  $t_Lframework_utils_LogLevel$__Default = x;
}
export { $t_Lframework_utils_LogLevel$__Default as $t_Lframework_utils_LogLevel$__Default, $u_Lframework_utils_LogLevel$__Default as $u_Lframework_utils_LogLevel$__Default };
var $t_Lframework_utils_LogLevel$__Debug = null;
function $u_Lframework_utils_LogLevel$__Debug(x) {
  $t_Lframework_utils_LogLevel$__Debug = x;
}
export { $t_Lframework_utils_LogLevel$__Debug as $t_Lframework_utils_LogLevel$__Debug, $u_Lframework_utils_LogLevel$__Debug as $u_Lframework_utils_LogLevel$__Debug };
var $t_Lframework_utils_LogLevel$__Info = null;
function $u_Lframework_utils_LogLevel$__Info(x) {
  $t_Lframework_utils_LogLevel$__Info = x;
}
export { $t_Lframework_utils_LogLevel$__Info as $t_Lframework_utils_LogLevel$__Info, $u_Lframework_utils_LogLevel$__Info as $u_Lframework_utils_LogLevel$__Info };
var $t_Lframework_utils_LogLevel$__Warning = null;
function $u_Lframework_utils_LogLevel$__Warning(x) {
  $t_Lframework_utils_LogLevel$__Warning = x;
}
export { $t_Lframework_utils_LogLevel$__Warning as $t_Lframework_utils_LogLevel$__Warning, $u_Lframework_utils_LogLevel$__Warning as $u_Lframework_utils_LogLevel$__Warning };
var $t_Lframework_utils_LogLevel$__Error = null;
function $u_Lframework_utils_LogLevel$__Error(x) {
  $t_Lframework_utils_LogLevel$__Error = x;
}
export { $t_Lframework_utils_LogLevel$__Error as $t_Lframework_utils_LogLevel$__Error, $u_Lframework_utils_LogLevel$__Error as $u_Lframework_utils_LogLevel$__Error };
var $t_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__ServerSentEvents = null;
function $u_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__ServerSentEvents(x) {
  $t_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__ServerSentEvents = x;
}
export { $t_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__ServerSentEvents as $t_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__ServerSentEvents, $u_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__ServerSentEvents as $u_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__ServerSentEvents };
var $t_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__WebSocket = null;
function $u_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__WebSocket(x) {
  $t_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__WebSocket = x;
}
export { $t_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__WebSocket as $t_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__WebSocket, $u_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__WebSocket as $u_Lframework_utils_ToSSEStreamBuilder$PreferredConnectionMode$__WebSocket };
var $t_Lretry_HandlerDecision$__Stop = null;
function $u_Lretry_HandlerDecision$__Stop(x) {
  $t_Lretry_HandlerDecision$__Stop = x;
}
export { $t_Lretry_HandlerDecision$__Stop as $t_Lretry_HandlerDecision$__Stop, $u_Lretry_HandlerDecision$__Stop as $u_Lretry_HandlerDecision$__Stop };
var $t_Lretry_HandlerDecision$__Continue = null;
function $u_Lretry_HandlerDecision$__Continue(x) {
  $t_Lretry_HandlerDecision$__Continue = x;
}
export { $t_Lretry_HandlerDecision$__Continue as $t_Lretry_HandlerDecision$__Continue, $u_Lretry_HandlerDecision$__Continue as $u_Lretry_HandlerDecision$__Continue };
var $t_Lretry_PolicyDecision$__GiveUp = null;
function $u_Lretry_PolicyDecision$__GiveUp(x) {
  $t_Lretry_PolicyDecision$__GiveUp = x;
}
export { $t_Lretry_PolicyDecision$__GiveUp as $t_Lretry_PolicyDecision$__GiveUp, $u_Lretry_PolicyDecision$__GiveUp as $u_Lretry_PolicyDecision$__GiveUp };
var $t_Lretry_RetryDetails$NextStep$__GiveUp = null;
function $u_Lretry_RetryDetails$NextStep$__GiveUp(x) {
  $t_Lretry_RetryDetails$NextStep$__GiveUp = x;
}
export { $t_Lretry_RetryDetails$NextStep$__GiveUp as $t_Lretry_RetryDetails$NextStep$__GiveUp, $u_Lretry_RetryDetails$NextStep$__GiveUp as $u_Lretry_RetryDetails$NextStep$__GiveUp };
//# sourceMappingURL=internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js.map
